var Ny = Object.defineProperty;
var p1 = (e) => {
  throw TypeError(e);
};
var Ly = (e, n, r) => n in e ? Ny(e, n, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[n] = r;
var ni = (e, n, r) => Ly(e, typeof n != "symbol" ? n + "" : n, r), fu = (e, n, r) => n.has(e) || p1("Cannot " + r);
var Un = (e, n, r) => (fu(e, n, "read from private field"), r ? r.call(e) : n.get(e)), zn = (e, n, r) => n.has(e) ? p1("Cannot add the same private member more than once") : n instanceof WeakSet ? n.add(e) : n.set(e, r), Mc = (e, n, r, a) => (fu(e, n, "write to private field"), a ? a.call(e, r) : n.set(e, r), r), Nt = (e, n, r) => (fu(e, n, "access private method"), r);
import * as Ue from "react";
import Nn, { useCallback as Oe, useState as Ee, useRef as ut, useEffect as ot, useMemo as Tt, createContext as Jr, useContext as xs, createElement as By, useLayoutEffect as Pa, Children as $y, isValidElement as al, cloneElement as ol, lazy as Uy, Suspense as zy, useId as dc } from "react";
import { validateFieldsNatively as Hy, toNestErrors as Wy } from "@hookform/resolvers";
import { appendErrors as qy, useForm as mr, useController as Vr, useFormContext as Rr, useFieldArray as Hh, useWatch as Vy, FormProvider as Hm } from "react-hook-form";
import * as Jn from "yup";
import { styled as Fn, Box as vn, Typography as wi, CircularProgress as Wh, keyframes as Wm, TextField as qs, Button as Ei, IconButton as Si, useTheme as l0, useMediaQuery as Xy, InputAdornment as kl, Dialog as qm, DialogTitle as Vm, DialogContent as Xm, DialogActions as Gm, Chip as Ai, Badge as Km, Skeleton as Vs, AppBar as Gy, Toolbar as Ky, List as qh, ListItem as Vh, ListItemButton as Xh, FormControlLabel as gr, FormHelperText as Gh, Tooltip as Kh, ListItemText as Yy, Drawer as Zy, InputLabel as Qy, OutlinedInput as Jy, FormLabel as e5, Stack as No, Select as g1, MenuItem as Rn, Checkbox as Hi, Radio as Vo, Collapse as m1, Fade as t5, svgIconClasses as n5, typographyClasses as i5, Avatar as Ym, createFilterOptions as r5, inputBaseClasses as s5, Divider as x1, ClickAwayListener as a5, Popper as o5, FormControl as c5, Menu as Ji, Table as l5, TableHead as u5, TableRow as b1, TableCell as zi, TableSortLabel as Dc, TableBody as d5 } from "@mui/material";
import { Icon as it, styled as tt, Box as Me, useTheme as Mr, Typography as Te, ConfirmationDialog as Yh, Stack as Pe, ScreenWrapper as Xr, BodyWrapper as Ya, Loading as u0, Dialog as oi, Button as lt, DragAndDrop as Xo, FileAttachmentItem as d0, Divider as wn, Accordion as yd, FieldWrapper as Zm, GlobalLoader as mi, IconButton as Gn, TopLoader as h5, UserInfo as f5, TextField as vi, Chip as fr, ListItemText as Mn, Avatar as Xs, FooterWrapper as Zh, TagList as p5, ListItemButton as Qm, useViewportSize as ri, ListItem as bs, OverflowTypography as g5, slidingViewsState as m5, MenuItem as vd, List as Gs, Switch as x5, ListItemIcon as Jm, TableCell as In, TableContainer as ex, Table as b5, TableHead as y5, TableRow as Nc, TableBody as v5, Tag as w5, ProgressBarWithLabel as Qh, CircularProgress as Jh, Link as Ii, SwipeableDrawer as tx, DragAndDropBox as S5, Card as hc, Alert as Za, AlertTitle as ef, Tooltip as ja, ThemedLogo as tf, ProgressBar as nf, Drawer as _5, ResponsiveView as C5, SuccessCheckAnimation as A5, Skeleton as nx, CloudSaveIcon as k5, Breadcrumbs as E5, VerticalLayout as I5, ErrorDialog as El, FileTypeIcon as T5, MobileConfirmationDrawer as pu, Container as ix, UnreadIndicator as O5, AutocompleteField as h0, TextWithLines as F5, CheckmarkAnimation as P5, GroupedRecipientChips as j5, Paper as R5, Grid as gu, Checkbox as M5, ListItemAvatar as D5, InputLabel as N5, UserChip as L5, CenteredLayout as rx, ErrorAlert as B5, liscioLogoSplash as $5, PrintContainer as U5, FileIcon as z5, InputAdornment as vr, InteractiveTableRow as H5, Inline as W5, GuidedFileRenameDialog as q5, GuidedFileRenameGhost as V5, FileNamingPatternDialog as X5 } from "@liscio/ui";
import G5, { usePostApiV5AiMessagesGenerate as K5, usePostApiV5AiMessagesGenerateReply as Y5, getApiV5FirmsAdminCpaSettingsKey as sx, patchApiV5FirmsAdminCpaSettingsKey as Z5, getApiErrorHttpStatus as rf, MAX_FILE_SIZE_IN_BYTES as Q5, makeFileId as mu, getApiV5Profile as J5, UserProfileRole as Lc, UploadFormType as on, UploadType as cs, patchApiV5AuthMagicLinksId as e8, AuthErrorMessageTypes as Ra, usePostApiV5AuthSignIn as t8, usePostApiV5AuthPasskeysAuthenticationOptions as n8, usePostApiV5AuthPasskeysSignIn as i8, usePostApiV5AuthMagicLinks as ax, usePostApiV5AuthSignUpSso as r8, usePostApiV5AuthSignInSso as s8, usePostApiV5AuthPasswordResetTokens as a8, useDeleteApiV5AuthSignOut as o8, parseApiErrorType as sf, UNAUTHORIZED_ERROR_MESSAGE as af, MessageStatus as cl, deleteApiV5MessagesMessageIdDocumentsDocumentId as c8, Role as Il, BaseRequestItemsSchemaItemType as ns, RequestSchemaStatus as ox, usePatchApiV5FirmsRequestsRequestIdSectionsSectionIdItemsItemIdResponse as l8, useGetApiV5FirmsRequestsId as f0, workflowRequestsQueryDocument as cx, updateResponseItemDocUploadDocument as u8, updateResponseItemBoolDocument as d8, updateResponseItemTextDocument as h8, workflowRequestsCountQueryDocument as f8, workflowRequestDocument as lx, updateWorkflowRequestMutationDocument as p8, usePutApiV5FirmsRequestsId as g8, usePutApiV5RequestsRequestIdTaxReturnFormId as m8, parseApiErrorMessage as p0, usePostApiV5DocumentsSignedUrls as x8, GetApiV5FirmsRequestsType as b8, usePatchApiV5FirmsSignersId as y8, getGetApiV5FirmsRequestsIdQueryKey as v8, usePostApiV5ClientsRfiDirectUploads as w8, usePostApiV5ClientsRfiRequestsRequestUuidAttachments as ux, usePostApiV5FirmsRfiDirectUploads as S8, usePostApiV5FirmsRfiRequestsRequestUuidAttachments as dx, useDeleteApiV5ClientsRfiAttachmentsId as _8, useDeleteApiV5FirmsRfiAttachmentsId as C8, getApiV5FirmsRfiAttachmentsId as A8, getApiV5ClientsRfiAttachmentsId as k8, useGetApiV5IntercomSettings as hx, PostApiV5DocumentsSignedUrlsBodyDisposition as fx, useGetApiV5FirmsFilesSharepointImportsUnreviewedCount as E8, getApiV5FirmsContactsIdAccounts as I8, useGetApiV5FirmsAccounts as T8, usePostApiV5AuthPasswordResets as O8, usePostApiV5AuthPasskeysRegistrationOptions as F8, usePostApiV5AuthPasskeys as P8, getGetApiV5AuthPasskeysQueryKey as px, useGetApiV5AuthPasskeys as gx, usePatchApiV5AuthPasskeysId as j8, useDeleteApiV5AuthPasskeysId as R8, UploaderType as Lo, getApiV5FirmsContactsSearch as y1, getApiV5FirmsContactsAccounts as M8, getApiV5FirmsContactsForAccounts as D8, TaskType as N8, getApiV5FirmsDocumentsLiscioVault as L8, useGetApiV5FilesIdNamingSuggestions as B8, useGetApiV5FilesNamingConfig as $8, useGetApiV5FirmsFileNamingTemplates as U8, usePutApiV5FirmsFileNamingTemplatesId as z8, getApiV5FilesIdNamingSuggestions as H8, getGetApiV5FirmsFileNamingTemplatesQueryKey as W8, MAX_FILE_SIZE_IN_MB as q8 } from "@liscio/api";
import { useQuery as Sn, useQueryClient as qn, useMutation as Ln, useInfiniteQuery as g0, useQueries as mx, QueryClient as V8, QueryClientProvider as X8 } from "@tanstack/react-query";
import { useLDClient as of, useFlags as Dr } from "launchdarkly-react-client-sdk";
import { isCancel as G8, isAxiosError as K8 } from "axios";
import { Capacitor as On, registerPlugin as xx } from "@capacitor/core";
import { debounce as wd, first as xu, uniqBy as Y8 } from "lodash";
import * as Z8 from "react-dom";
import { createPortal as bx } from "react-dom";
import { useDropzone as fc } from "react-dropzone";
import rn, { toast as Tl } from "react-hot-toast";
import { defaultErrorParser as Q8, formatUnsupportedFileMessage as yx, readableBytes as cf, scrollToElement as vx, formatStringDate as nr, pluralLabel as wx, containsErrorOfType as Sx, errorHandledByMutation as _x, parseCentsToDollars as js, parseAmount as J8, wholePercent as e7, formatPercent as Cx, useTimeout as Ax, useTimeoutValue as t7, getScrollValue as n7, convertQueryStringToObject as i7, preventBubbling as r7, useBeforeUnload as s7, getFirstUrlElementFromLink as a7, parseFileName as o7 } from "@liscio/utils";
import { create as Qa, createStore as c7, useStore as lf } from "zustand";
import Gr from "js-cookie";
import { v4 as l7 } from "uuid";
import { App as Go } from "@capacitor/app";
import { Browser as kx } from "@capacitor/browser";
import { useNavigate as Ki, Link as Ex, useMatch as u7, useParams as m0, useLocation as x0, useSearchParams as Ix, matchPath as v1, Outlet as d7 } from "react-router-dom";
import * as w1 from "@capacitor/live-updates";
import { Preferences as Sa } from "@capacitor/preferences";
import { PushNotifications as Rs } from "@capacitor/push-notifications";
import { Directory as h7, Filesystem as f7 } from "@capacitor/filesystem";
import { format as uf, parseISO as p7 } from "date-fns";
import { BiometryType as g7, NativeBiometric as ia } from "@capgo/capacitor-native-biometric";
import { stripHtml as b0 } from "string-strip-html";
import { produce as Sd } from "immer";
import { Document as m7, pdfjs as S1, Page as x7 } from "react-pdf";
import { fileTagLabel as gs, matchesFileTagSearch as df } from "./file-tag-label.js";
import { jsPDF as b7 } from "jspdf";
import { motion as y7, AnimatePresence as v7 } from "framer-motion";
import _1 from "cordova-plugin-scanbot-sdk";
import { Helmet as Tx } from "react-helmet-async";
import { Interweave as w7 } from "interweave";
import S7 from "@emotion/styled";
import { CacheProvider as _7, Global as C7, ThemeContext as A7, css as k7, keyframes as y0 } from "@emotion/react";
import { useReactToPrint as E7 } from "react-to-print";
import "./workflow-field-display.js";
function I7(e, n) {
  for (var r = 0; r < n.length; r++) {
    const a = n[r];
    if (typeof a != "string" && !Array.isArray(a)) {
      for (const o in a)
        if (o !== "default" && !(o in e)) {
          const l = Object.getOwnPropertyDescriptor(a, o);
          l && Object.defineProperty(e, o, l.get ? l : {
            enumerable: !0,
            get: () => a[o]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
}
var Mi = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ys(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function vs(e) {
  if (e.__esModule) return e;
  var n = e.default;
  if (typeof n == "function") {
    var r = function a() {
      return this instanceof a ? Reflect.construct(n, arguments, this.constructor) : n.apply(this, arguments);
    };
    r.prototype = n.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(a) {
    var o = Object.getOwnPropertyDescriptor(e, a);
    Object.defineProperty(r, a, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[a];
      }
    });
  }), r;
}
var _d = { exports: {} }, lo = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var C1;
function T7() {
  if (C1) return lo;
  C1 = 1;
  var e = Nn, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, l = { key: !0, ref: !0, __self: !0, __source: !0 };
  function d(c, f, s) {
    var h, g = {}, t = null, i = null;
    s !== void 0 && (t = "" + s), f.key !== void 0 && (t = "" + f.key), f.ref !== void 0 && (i = f.ref);
    for (h in f) a.call(f, h) && !l.hasOwnProperty(h) && (g[h] = f[h]);
    if (c && c.defaultProps) for (h in f = c.defaultProps, f) g[h] === void 0 && (g[h] = f[h]);
    return { $$typeof: n, type: c, key: t, ref: i, props: g, _owner: o.current };
  }
  return lo.Fragment = r, lo.jsx = d, lo.jsxs = d, lo;
}
var uo = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var A1;
function O7() {
  return A1 || (A1 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Nn, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), l = Symbol.for("react.profiler"), d = Symbol.for("react.provider"), c = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), s = Symbol.for("react.suspense"), h = Symbol.for("react.suspense_list"), g = Symbol.for("react.memo"), t = Symbol.for("react.lazy"), i = Symbol.for("react.offscreen"), m = Symbol.iterator, v = "@@iterator";
    function E(_e) {
      if (_e === null || typeof _e != "object")
        return null;
      var Qe = m && _e[m] || _e[v];
      return typeof Qe == "function" ? Qe : null;
    }
    var S = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(_e) {
      {
        for (var Qe = arguments.length, qe = new Array(Qe > 1 ? Qe - 1 : 0), Je = 1; Je < Qe; Je++)
          qe[Je - 1] = arguments[Je];
        x("error", _e, qe);
      }
    }
    function x(_e, Qe, qe) {
      {
        var Je = S.ReactDebugCurrentFrame, nt = Je.getStackAddendum();
        nt !== "" && (Qe += "%s", qe = qe.concat([nt]));
        var At = qe.map(function(Rt) {
          return String(Rt);
        });
        At.unshift("Warning: " + Qe), Function.prototype.apply.call(console[_e], console, At);
      }
    }
    var b = !1, u = !1, I = !1, O = !1, D = !1, $;
    $ = Symbol.for("react.module.reference");
    function K(_e) {
      return !!(typeof _e == "string" || typeof _e == "function" || _e === a || _e === l || D || _e === o || _e === s || _e === h || O || _e === i || b || u || I || typeof _e == "object" && _e !== null && (_e.$$typeof === t || _e.$$typeof === g || _e.$$typeof === d || _e.$$typeof === c || _e.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      _e.$$typeof === $ || _e.getModuleId !== void 0));
    }
    function H(_e, Qe, qe) {
      var Je = _e.displayName;
      if (Je)
        return Je;
      var nt = Qe.displayName || Qe.name || "";
      return nt !== "" ? qe + "(" + nt + ")" : qe;
    }
    function B(_e) {
      return _e.displayName || "Context";
    }
    function R(_e) {
      if (_e == null)
        return null;
      if (typeof _e.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof _e == "function")
        return _e.displayName || _e.name || null;
      if (typeof _e == "string")
        return _e;
      switch (_e) {
        case a:
          return "Fragment";
        case r:
          return "Portal";
        case l:
          return "Profiler";
        case o:
          return "StrictMode";
        case s:
          return "Suspense";
        case h:
          return "SuspenseList";
      }
      if (typeof _e == "object")
        switch (_e.$$typeof) {
          case c:
            var Qe = _e;
            return B(Qe) + ".Consumer";
          case d:
            var qe = _e;
            return B(qe._context) + ".Provider";
          case f:
            return H(_e, _e.render, "ForwardRef");
          case g:
            var Je = _e.displayName || null;
            return Je !== null ? Je : R(_e.type) || "Memo";
          case t: {
            var nt = _e, At = nt._payload, Rt = nt._init;
            try {
              return R(Rt(At));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var _ = Object.assign, A = 0, k, z, T, w, F, j, P;
    function V() {
    }
    V.__reactDisabledLog = !0;
    function J() {
      {
        if (A === 0) {
          k = console.log, z = console.info, T = console.warn, w = console.error, F = console.group, j = console.groupCollapsed, P = console.groupEnd;
          var _e = {
            configurable: !0,
            enumerable: !0,
            value: V,
            writable: !0
          };
          Object.defineProperties(console, {
            info: _e,
            log: _e,
            warn: _e,
            error: _e,
            group: _e,
            groupCollapsed: _e,
            groupEnd: _e
          });
        }
        A++;
      }
    }
    function ne() {
      {
        if (A--, A === 0) {
          var _e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: _({}, _e, {
              value: k
            }),
            info: _({}, _e, {
              value: z
            }),
            warn: _({}, _e, {
              value: T
            }),
            error: _({}, _e, {
              value: w
            }),
            group: _({}, _e, {
              value: F
            }),
            groupCollapsed: _({}, _e, {
              value: j
            }),
            groupEnd: _({}, _e, {
              value: P
            })
          });
        }
        A < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Z = S.ReactCurrentDispatcher, te;
    function G(_e, Qe, qe) {
      {
        if (te === void 0)
          try {
            throw Error();
          } catch (nt) {
            var Je = nt.stack.trim().match(/\n( *(at )?)/);
            te = Je && Je[1] || "";
          }
        return `
` + te + _e;
      }
    }
    var N = !1, q;
    {
      var ie = typeof WeakMap == "function" ? WeakMap : Map;
      q = new ie();
    }
    function oe(_e, Qe) {
      if (!_e || N)
        return "";
      {
        var qe = q.get(_e);
        if (qe !== void 0)
          return qe;
      }
      var Je;
      N = !0;
      var nt = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var At;
      At = Z.current, Z.current = null, J();
      try {
        if (Qe) {
          var Rt = function() {
            throw Error();
          };
          if (Object.defineProperty(Rt.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Rt, []);
            } catch (Ke) {
              Je = Ke;
            }
            Reflect.construct(_e, [], Rt);
          } else {
            try {
              Rt.call();
            } catch (Ke) {
              Je = Ke;
            }
            _e.call(Rt.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ke) {
            Je = Ke;
          }
          _e();
        }
      } catch (Ke) {
        if (Ke && Je && typeof Ke.stack == "string") {
          for (var St = Ke.stack.split(`
`), _t = Je.stack.split(`
`), Zt = St.length - 1, an = _t.length - 1; Zt >= 1 && an >= 0 && St[Zt] !== _t[an]; )
            an--;
          for (; Zt >= 1 && an >= 0; Zt--, an--)
            if (St[Zt] !== _t[an]) {
              if (Zt !== 1 || an !== 1)
                do
                  if (Zt--, an--, an < 0 || St[Zt] !== _t[an]) {
                    var ze = `
` + St[Zt].replace(" at new ", " at ");
                    return _e.displayName && ze.includes("<anonymous>") && (ze = ze.replace("<anonymous>", _e.displayName)), typeof _e == "function" && q.set(_e, ze), ze;
                  }
                while (Zt >= 1 && an >= 0);
              break;
            }
        }
      } finally {
        N = !1, Z.current = At, ne(), Error.prepareStackTrace = nt;
      }
      var $e = _e ? _e.displayName || _e.name : "", Ve = $e ? G($e) : "";
      return typeof _e == "function" && q.set(_e, Ve), Ve;
    }
    function fe(_e, Qe, qe) {
      return oe(_e, !1);
    }
    function Y(_e) {
      var Qe = _e.prototype;
      return !!(Qe && Qe.isReactComponent);
    }
    function ae(_e, Qe, qe) {
      if (_e == null)
        return "";
      if (typeof _e == "function")
        return oe(_e, Y(_e));
      if (typeof _e == "string")
        return G(_e);
      switch (_e) {
        case s:
          return G("Suspense");
        case h:
          return G("SuspenseList");
      }
      if (typeof _e == "object")
        switch (_e.$$typeof) {
          case f:
            return fe(_e.render);
          case g:
            return ae(_e.type, Qe, qe);
          case t: {
            var Je = _e, nt = Je._payload, At = Je._init;
            try {
              return ae(At(nt), Qe, qe);
            } catch {
            }
          }
        }
      return "";
    }
    var se = Object.prototype.hasOwnProperty, L = {}, W = S.ReactDebugCurrentFrame;
    function M(_e) {
      if (_e) {
        var Qe = _e._owner, qe = ae(_e.type, _e._source, Qe ? Qe.type : null);
        W.setExtraStackFrame(qe);
      } else
        W.setExtraStackFrame(null);
    }
    function X(_e, Qe, qe, Je, nt) {
      {
        var At = Function.call.bind(se);
        for (var Rt in _e)
          if (At(_e, Rt)) {
            var St = void 0;
            try {
              if (typeof _e[Rt] != "function") {
                var _t = Error((Je || "React class") + ": " + qe + " type `" + Rt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof _e[Rt] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw _t.name = "Invariant Violation", _t;
              }
              St = _e[Rt](Qe, Rt, Je, qe, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Zt) {
              St = Zt;
            }
            St && !(St instanceof Error) && (M(nt), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Je || "React class", qe, Rt, typeof St), M(null)), St instanceof Error && !(St.message in L) && (L[St.message] = !0, M(nt), y("Failed %s type: %s", qe, St.message), M(null));
          }
      }
    }
    var U = Array.isArray;
    function Q(_e) {
      return U(_e);
    }
    function re(_e) {
      {
        var Qe = typeof Symbol == "function" && Symbol.toStringTag, qe = Qe && _e[Symbol.toStringTag] || _e.constructor.name || "Object";
        return qe;
      }
    }
    function le(_e) {
      try {
        return ce(_e), !1;
      } catch {
        return !0;
      }
    }
    function ce(_e) {
      return "" + _e;
    }
    function ee(_e) {
      if (le(_e))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", re(_e)), ce(_e);
    }
    var he = S.ReactCurrentOwner, pe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, de, ge, me;
    me = {};
    function xe(_e) {
      if (se.call(_e, "ref")) {
        var Qe = Object.getOwnPropertyDescriptor(_e, "ref").get;
        if (Qe && Qe.isReactWarning)
          return !1;
      }
      return _e.ref !== void 0;
    }
    function ye(_e) {
      if (se.call(_e, "key")) {
        var Qe = Object.getOwnPropertyDescriptor(_e, "key").get;
        if (Qe && Qe.isReactWarning)
          return !1;
      }
      return _e.key !== void 0;
    }
    function ve(_e, Qe) {
      if (typeof _e.ref == "string" && he.current && Qe && he.current.stateNode !== Qe) {
        var qe = R(he.current.type);
        me[qe] || (y('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', R(he.current.type), _e.ref), me[qe] = !0);
      }
    }
    function Ce(_e, Qe) {
      {
        var qe = function() {
          de || (de = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Qe));
        };
        qe.isReactWarning = !0, Object.defineProperty(_e, "key", {
          get: qe,
          configurable: !0
        });
      }
    }
    function Ie(_e, Qe) {
      {
        var qe = function() {
          ge || (ge = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Qe));
        };
        qe.isReactWarning = !0, Object.defineProperty(_e, "ref", {
          get: qe,
          configurable: !0
        });
      }
    }
    var Ae = function(_e, Qe, qe, Je, nt, At, Rt) {
      var St = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: _e,
        key: Qe,
        ref: qe,
        props: Rt,
        // Record the component responsible for creating this element.
        _owner: At
      };
      return St._store = {}, Object.defineProperty(St._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(St, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Je
      }), Object.defineProperty(St, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: nt
      }), Object.freeze && (Object.freeze(St.props), Object.freeze(St)), St;
    };
    function Se(_e, Qe, qe, Je, nt) {
      {
        var At, Rt = {}, St = null, _t = null;
        qe !== void 0 && (ee(qe), St = "" + qe), ye(Qe) && (ee(Qe.key), St = "" + Qe.key), xe(Qe) && (_t = Qe.ref, ve(Qe, nt));
        for (At in Qe)
          se.call(Qe, At) && !pe.hasOwnProperty(At) && (Rt[At] = Qe[At]);
        if (_e && _e.defaultProps) {
          var Zt = _e.defaultProps;
          for (At in Zt)
            Rt[At] === void 0 && (Rt[At] = Zt[At]);
        }
        if (St || _t) {
          var an = typeof _e == "function" ? _e.displayName || _e.name || "Unknown" : _e;
          St && Ce(Rt, an), _t && Ie(Rt, an);
        }
        return Ae(_e, St, _t, nt, Je, he.current, Rt);
      }
    }
    var De = S.ReactCurrentOwner, Be = S.ReactDebugCurrentFrame;
    function ke(_e) {
      if (_e) {
        var Qe = _e._owner, qe = ae(_e.type, _e._source, Qe ? Qe.type : null);
        Be.setExtraStackFrame(qe);
      } else
        Be.setExtraStackFrame(null);
    }
    var be;
    be = !1;
    function we(_e) {
      return typeof _e == "object" && _e !== null && _e.$$typeof === n;
    }
    function Le() {
      {
        if (De.current) {
          var _e = R(De.current.type);
          if (_e)
            return `

Check the render method of \`` + _e + "`.";
        }
        return "";
      }
    }
    function Re(_e) {
      return "";
    }
    var ct = {};
    function ft(_e) {
      {
        var Qe = Le();
        if (!Qe) {
          var qe = typeof _e == "string" ? _e : _e.displayName || _e.name;
          qe && (Qe = `

Check the top-level render call using <` + qe + ">.");
        }
        return Qe;
      }
    }
    function kt(_e, Qe) {
      {
        if (!_e._store || _e._store.validated || _e.key != null)
          return;
        _e._store.validated = !0;
        var qe = ft(Qe);
        if (ct[qe])
          return;
        ct[qe] = !0;
        var Je = "";
        _e && _e._owner && _e._owner !== De.current && (Je = " It was passed a child from " + R(_e._owner.type) + "."), ke(_e), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', qe, Je), ke(null);
      }
    }
    function We(_e, Qe) {
      {
        if (typeof _e != "object")
          return;
        if (Q(_e))
          for (var qe = 0; qe < _e.length; qe++) {
            var Je = _e[qe];
            we(Je) && kt(Je, Qe);
          }
        else if (we(_e))
          _e._store && (_e._store.validated = !0);
        else if (_e) {
          var nt = E(_e);
          if (typeof nt == "function" && nt !== _e.entries)
            for (var At = nt.call(_e), Rt; !(Rt = At.next()).done; )
              we(Rt.value) && kt(Rt.value, Qe);
        }
      }
    }
    function jt(_e) {
      {
        var Qe = _e.type;
        if (Qe == null || typeof Qe == "string")
          return;
        var qe;
        if (typeof Qe == "function")
          qe = Qe.propTypes;
        else if (typeof Qe == "object" && (Qe.$$typeof === f || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Qe.$$typeof === g))
          qe = Qe.propTypes;
        else
          return;
        if (qe) {
          var Je = R(Qe);
          X(qe, _e.props, "prop", Je, _e);
        } else if (Qe.PropTypes !== void 0 && !be) {
          be = !0;
          var nt = R(Qe);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", nt || "Unknown");
        }
        typeof Qe.getDefaultProps == "function" && !Qe.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function yt(_e) {
      {
        for (var Qe = Object.keys(_e.props), qe = 0; qe < Qe.length; qe++) {
          var Je = Qe[qe];
          if (Je !== "children" && Je !== "key") {
            ke(_e), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Je), ke(null);
            break;
          }
        }
        _e.ref !== null && (ke(_e), y("Invalid attribute `ref` supplied to `React.Fragment`."), ke(null));
      }
    }
    var Ye = {};
    function mt(_e, Qe, qe, Je, nt, At) {
      {
        var Rt = K(_e);
        if (!Rt) {
          var St = "";
          (_e === void 0 || typeof _e == "object" && _e !== null && Object.keys(_e).length === 0) && (St += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var _t = Re();
          _t ? St += _t : St += Le();
          var Zt;
          _e === null ? Zt = "null" : Q(_e) ? Zt = "array" : _e !== void 0 && _e.$$typeof === n ? (Zt = "<" + (R(_e.type) || "Unknown") + " />", St = " Did you accidentally export a JSX literal instead of a component?") : Zt = typeof _e, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Zt, St);
        }
        var an = Se(_e, Qe, qe, nt, At);
        if (an == null)
          return an;
        if (Rt) {
          var ze = Qe.children;
          if (ze !== void 0)
            if (Je)
              if (Q(ze)) {
                for (var $e = 0; $e < ze.length; $e++)
                  We(ze[$e], _e);
                Object.freeze && Object.freeze(ze);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              We(ze, _e);
        }
        if (se.call(Qe, "key")) {
          var Ve = R(_e), Ke = Object.keys(Qe).filter(function(st) {
            return st !== "key";
          }), at = Ke.length > 0 ? "{key: someKey, " + Ke.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Ye[Ve + at]) {
            var It = Ke.length > 0 ? "{" + Ke.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, at, Ve, It, Ve), Ye[Ve + at] = !0;
          }
        }
        return _e === a ? yt(an) : jt(an), an;
      }
    }
    function Pt(_e, Qe, qe) {
      return mt(_e, Qe, qe, !0);
    }
    function et(_e, Qe, qe) {
      return mt(_e, Qe, qe, !1);
    }
    var tn = et, Xt = Pt;
    uo.Fragment = a, uo.jsx = tn, uo.jsxs = Xt;
  }()), uo;
}
process.env.NODE_ENV === "production" ? _d.exports = T7() : _d.exports = O7();
var p = _d.exports;
function ws(e, n, r) {
  return n === void 0 && (n = {}), r === void 0 && (r = {}), function(a, o, l) {
    try {
      return Promise.resolve(function(d, c) {
        try {
          var f = (n.context && process.env.NODE_ENV === "development" && console.warn("You should not used the yup options context. Please, use the 'useForm' context object instead"), Promise.resolve(e[r.mode === "sync" ? "validateSync" : "validate"](a, Object.assign({ abortEarly: !1 }, n, { context: o }))).then(function(s) {
            return l.shouldUseNativeValidation && Hy({}, l), { values: r.raw ? a : s, errors: {} };
          }));
        } catch (s) {
          return c(s);
        }
        return f && f.then ? f.then(void 0, c) : f;
      }(0, function(d) {
        if (!d.inner) throw d;
        return { values: {}, errors: Wy((c = d, f = !l.shouldUseNativeValidation && l.criteriaMode === "all", (c.inner || []).reduce(function(s, h) {
          if (s[h.path] || (s[h.path] = { message: h.message, type: h.type }), f) {
            var g = s[h.path].types, t = g && g[h.type];
            s[h.path] = qy(h.path, f, s, h.type, t ? [].concat(t, h.message) : h.message);
          }
          return s;
        }, {})), l) };
        var c, f;
      }));
    } catch (d) {
      return Promise.reject(d);
    }
  };
}
const F7 = Fn(vn)(({ theme: e }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: e.spacing(2),
  gap: e.spacing(1.5)
})), P7 = Fn(wi)(({ theme: e }) => ({
  color: e.palette.text.secondary,
  fontSize: "0.875rem",
  fontWeight: 500
})), Ox = ({
  message: e = "AI is generating content..."
}) => /* @__PURE__ */ p.jsxs(F7, { children: [
  /* @__PURE__ */ p.jsx(Wh, { size: 16, thickness: 4 }),
  /* @__PURE__ */ p.jsx(P7, { children: e })
] }), j7 = Fn(vn, {
  shouldForwardProp: (e) => e !== "variant"
})(({ theme: e, variant: n }) => ({
  // Variant-specific styles
  ...n === "compose" && {
    backgroundColor: e.palette.grey[50],
    border: `1px solid ${e.palette.grey[200]}`,
    borderRadius: e.shape.borderRadius,
    padding: e.spacing(2),
    [e.breakpoints.up("md")]: {
      padding: e.spacing(2)
    }
  },
  ...n === "reply" && {
    backgroundColor: "transparent",
    border: "none",
    padding: 0,
    marginBottom: 0,
    [e.breakpoints.up("md")]: {
      marginBottom: 0
    }
  },
  ...n === "suggestions" && {
    backgroundColor: "transparent",
    border: "none",
    padding: 0,
    marginBottom: e.spacing(1)
  }
})), R7 = Fn(vn)({
  display: "flex",
  flexDirection: "column"
}), Fx = ({
  children: e,
  variant: n = "compose"
}) => /* @__PURE__ */ p.jsx(j7, { variant: n, children: /* @__PURE__ */ p.jsx(R7, { children: e }) }), Ol = Wm`
  0% {
    box-shadow: 0 0 0 0 rgba(0, 175, 204, 0.4);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(236, 42, 171, 0);
  }
`, Px = Wm`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`, Fl = "linear-gradient(135deg, rgb(0, 175, 204), rgb(236, 42, 171))", M7 = "linear-gradient(90deg, rgb(0, 175, 204), rgb(236, 42, 171))", Pl = "#00afcc", jx = "#ec2aab", D7 = "all ease-in-out 350ms", N7 = Fn(vn)(
  ({ theme: e, variant: n = "compose" }) => ({
    display: "flex",
    alignItems: "center",
    ...n === "compose" && {
      marginBottom: e.spacing(1),
      [e.breakpoints.up("md")]: {
        marginBottom: e.spacing(2)
      }
    },
    ...n === "reply" && {
      marginBottom: e.spacing(0.75)
    }
  })
), L7 = Fn(wi, {
  shouldForwardProp: (e) => e !== "gradientVariant"
})(({ gradientVariant: e = "compose" }) => ({
  ...e === "compose" && {
    backgroundImage: M7,
    backgroundClip: "text",
    color: "transparent",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent"
  },
  fontWeight: 600
})), B7 = ({
  title: e,
  isMobile: n = !1,
  variant: r = "compose"
}) => /* @__PURE__ */ p.jsxs(N7, { variant: r, children: [
  /* @__PURE__ */ p.jsx(
    it,
    {
      icon: "sparkles",
      color: "secondary",
      fontSize: "inherit",
      sx: { mr: 1 }
    }
  ),
  /* @__PURE__ */ p.jsx(
    L7,
    {
      variant: n ? "body2" : "body1",
      gradientVariant: r,
      children: e
    }
  )
] }), $7 = Fn(qs)(({ theme: e }) => ({
  backgroundColor: e.palette.common.white,
  "& .MuiOutlinedInput-root": {
    // Reduce padding on mobile for more compact appearance
    [e.breakpoints.down("sm")]: {
      fontSize: "0.875rem",
      "& .MuiOutlinedInput-input": {
        paddingTop: e.spacing(1),
        paddingBottom: e.spacing(1)
      }
    }
  }
})), Rx = ({
  register: e,
  placeholder: n,
  disabled: r = !1,
  error: a,
  isMobile: o = !1,
  multiline: l = !1,
  // Default to false for mobile single line
  minRows: d = 1,
  maxRows: c = 1,
  // Single line by default
  endAdornment: f
}) => /* @__PURE__ */ p.jsx(
  $7,
  {
    ...e,
    size: "small",
    fullWidth: !0,
    variant: "outlined",
    placeholder: n,
    disabled: r,
    error: !!a,
    helperText: a == null ? void 0 : a.message,
    multiline: o ? !1 : l,
    minRows: o ? 1 : d,
    maxRows: o ? 1 : c,
    InputProps: {
      endAdornment: f
    }
  }
), U7 = Fn(Ei)(({ theme: e, variant: n }) => ({
  position: "relative",
  transition: D7,
  minHeight: e.spacing(4),
  width: "auto",
  whiteSpace: "nowrap",
  // Make button larger on desktop to better match input field
  [e.breakpoints.up("sm")]: {
    minHeight: e.spacing(5.5),
    paddingLeft: e.spacing(2.5),
    paddingRight: e.spacing(2.5)
  },
  ...n === "contained" && {
    border: "0",
    background: Fl,
    color: e.palette.common.white,
    "&:hover": {
      color: e.palette.common.white,
      animation: `${Ol} 2s 1`,
      boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.1)"
    }
  },
  ...n === "outlined" && {
    position: "relative",
    borderRadius: "20px",
    background: "white",
    color: Pl,
    border: "2px solid transparent",
    backgroundImage: `linear-gradient(white, white), ${Fl}`,
    backgroundOrigin: "border-box",
    backgroundClip: "padding-box, border-box",
    transition: "all 0.3s ease-in-out",
    "&:hover": {
      background: "white",
      // Keep WHITE background on hover
      backgroundImage: "linear-gradient(white, white), linear-gradient(270deg, #00afcc, #ec2aab, #00afcc, #ec2aab)",
      backgroundSize: "auto, 400% 400%",
      border: "2px solid transparent",
      backgroundOrigin: "border-box",
      backgroundClip: "padding-box, border-box",
      animationName: Px,
      animationDuration: "3s",
      animationIterationCount: "infinite",
      animationTimingFunction: "ease-in-out"
    }
  },
  // Text variant
  ...n === "text" && {
    color: Pl,
    background: "transparent",
    "&:hover": {
      color: jx,
      animation: `${Ol} 2s 1`
    }
  },
  "&:disabled": {
    background: e.palette.action.disabledBackground,
    color: e.palette.action.disabled,
    borderColor: e.palette.action.disabled,
    backgroundImage: "none"
  }
})), z7 = Fn(Si)(({ theme: e, variant: n }) => ({
  minHeight: e.spacing(4.5),
  width: e.spacing(4.5),
  height: e.spacing(4.5),
  transition: "all 0.3s ease",
  borderRadius: "50%",
  // Circular for icon button
  // Match the variant styles for consistency
  ...n === "contained" && {
    background: Fl,
    color: "white",
    border: "none",
    "&:hover": {
      animation: `${Ol} 2s 1`,
      boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.1)"
    }
  },
  // Outlined variant for icon button - WHITE background with GRADIENT BORDER
  ...n === "outlined" && {
    background: "white",
    // WHITE background
    color: Pl,
    border: "2px solid transparent",
    // This creates the gradient border effect with white background
    backgroundImage: `linear-gradient(white, white), ${Fl}`,
    backgroundOrigin: "border-box",
    backgroundClip: "padding-box, border-box",
    "&:hover": {
      background: "white",
      // Keep WHITE background on hover
      backgroundImage: "linear-gradient(white, white), linear-gradient(270deg, #00afcc, #ec2aab, #00afcc, #ec2aab)",
      backgroundSize: "auto, 400% 400%",
      border: "2px solid transparent",
      backgroundOrigin: "border-box",
      backgroundClip: "padding-box, border-box",
      animationName: Px,
      animationDuration: "3s",
      animationIterationCount: "infinite",
      animationTimingFunction: "ease-in-out"
    }
  },
  ...n === "text" && {
    background: "transparent",
    color: Pl,
    border: "none",
    "&:hover": {
      color: jx,
      animation: `${Ol} 2s 1`
    }
  },
  "&:disabled": {
    background: e.palette.action.disabledBackground,
    color: e.palette.action.disabled,
    borderColor: e.palette.action.disabled,
    backgroundImage: "none"
  }
})), Mx = ({
  onClick: e,
  disabled: n = !1,
  isLoading: r = !1,
  text: a = "Generate",
  loadingText: o = "Generating...",
  variant: l = "outlined",
  // Default to outlined to match the image
  size: d = "small",
  fullWidth: c
}) => {
  const f = l0(), s = Xy(f.breakpoints.down("sm")), h = r ? o : a, g = n || r;
  return s && !c ? /* @__PURE__ */ p.jsx(
    z7,
    {
      variant: l,
      onClick: e,
      disabled: g,
      size: d,
      title: h,
      children: /* @__PURE__ */ p.jsx(it, { icon: "wandSparkles", sx: { fontSize: "16px" } })
    }
  ) : /* @__PURE__ */ p.jsx(
    U7,
    {
      variant: l,
      onClick: e,
      disabled: g,
      size: d,
      startIcon: /* @__PURE__ */ p.jsx(it, { icon: "wandSparkles", sx: { fontSize: "16px" } }),
      sx: {
        width: c ? "100%" : "auto",
        // Additional desktop styling for better match with input field
        ...c && {
          minHeight: { xs: "auto", sm: "48px" }
        }
      },
      children: h
    }
  );
}, H7 = Fn("div")(({ theme: e }) => ({
  display: "flex",
  flexDirection: "row",
  // Always row layout, even on mobile
  gap: e.spacing(0.75),
  marginBottom: 0,
  alignItems: "flex-end",
  [e.breakpoints.up("sm")]: {
    gap: e.spacing(1.5),
    marginBottom: 0
  }
})), W7 = Fn("div")({
  flexGrow: 1
}), q7 = Fn("div")(({ theme: e }) => ({
  display: "flex",
  alignSelf: "flex-start",
  // Keep button aligned to top when error text appears
  width: "auto",
  // Always auto width, no full width on mobile
  flexShrink: 0,
  // Prevent button from shrinking
  // On desktop, keep aligned to top to prevent dropping when errors appear
  [e.breakpoints.up("sm")]: {
    alignSelf: "flex-start"
  }
})), Dx = ({
  children: e
}) => {
  const n = Nn.Children.toArray(e), r = n[0], a = n[1];
  return /* @__PURE__ */ p.jsxs(H7, { children: [
    /* @__PURE__ */ p.jsx(W7, { children: r }),
    a && /* @__PURE__ */ p.jsx(q7, { children: a })
  ] });
}, V7 = Fn(Si, {
  shouldForwardProp: (e) => e !== "isListening" && e !== "isProcessingVoice"
})(
  ({ theme: e, isListening: n, isProcessingVoice: r }) => ({
    color: n || r ? e.palette.primary.main : e.palette.grey[500],
    backgroundColor: "transparent",
    borderRadius: "50%",
    transition: "all 0.3s ease",
    transform: n || r ? "scale(1.1)" : "scale(1)",
    opacity: r ? 0.7 : 1,
    padding: e.spacing(0.5)
  })
), X7 = Fn(it)`
  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1);
    }
  }

  &.listening {
    animation: pulse 0.8s infinite;
  }
`, G7 = Fn(it)`
  @keyframes recording {
    0% {
      opacity: 1;
      transform: scale(1);
    }
    50% {
      opacity: 0.6;
      transform: scale(1.1);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }

  animation: recording 1.5s ease-in-out infinite;
`, K7 = Fn(it)({
  "@keyframes pulse": {
    "0%": { transform: "scale(1)" },
    "50%": { transform: "scale(1.1)" },
    "100%": { transform: "scale(1)" }
  },
  animation: "pulse 0.8s infinite"
}), Nx = ({
  isListening: e,
  isProcessingVoice: n,
  isSupported: r,
  disabled: a = !1,
  onVoiceInput: o
}) => {
  if (!r)
    return null;
  const l = () => n ? "Processing voice input..." : e ? "Click to stop recording" : "Start voice recording", d = () => n ? /* @__PURE__ */ p.jsx(K7, { icon: "sparkles", sx: { fontSize: "16px" } }) : e ? /* @__PURE__ */ p.jsx(G7, { icon: "pause", sx: { fontSize: "16px" } }) : /* @__PURE__ */ p.jsx(
    X7,
    {
      icon: "microphone",
      sx: { fontSize: "16px" },
      className: e ? "listening" : ""
    }
  );
  return /* @__PURE__ */ p.jsx(kl, { position: "end", children: /* @__PURE__ */ p.jsx(
    V7,
    {
      edge: "end",
      size: "small",
      disabled: a || n,
      onClick: o,
      title: l(),
      isListening: e,
      isProcessingVoice: n,
      children: d()
    }
  ) });
}, Y7 = ({
  open: e,
  onClose: n,
  onConfirm: r,
  title: a,
  content: o,
  generatedContent: l,
  confirmText: d = "Replace",
  cancelText: c = "Cancel",
  isMobile: f = !1
}) => /* @__PURE__ */ p.jsxs(
  qm,
  {
    open: e,
    onClose: n,
    maxWidth: "sm",
    fullWidth: !0,
    PaperProps: {
      sx: { margin: f ? 1 : 3 }
    },
    children: [
      /* @__PURE__ */ p.jsx(Vm, { children: a }),
      /* @__PURE__ */ p.jsxs(Xm, { children: [
        /* @__PURE__ */ p.jsx(wi, { variant: "body2", sx: { mb: 2 }, children: o }),
        /* @__PURE__ */ p.jsxs(
          vn,
          {
            sx: {
              border: 1,
              borderColor: "grey.300",
              borderRadius: 1,
              p: 2,
              bgcolor: "grey.50",
              maxHeight: 200,
              overflow: "auto"
            },
            children: [
              /* @__PURE__ */ p.jsx(wi, { variant: "subtitle2", sx: { fontWeight: "bold", mb: 1 }, children: "AI Generated Content:" }),
              /* @__PURE__ */ p.jsx(wi, { variant: "body2", sx: { whiteSpace: "pre-wrap" }, children: l })
            ]
          }
        )
      ] }),
      /* @__PURE__ */ p.jsxs(Gm, { children: [
        /* @__PURE__ */ p.jsx(Ei, { onClick: n, children: c }),
        /* @__PURE__ */ p.jsx(Ei, { onClick: r, variant: "contained", children: d })
      ] })
    ]
  }
);
Fn(Ai)(({ theme: e }) => ({
  justifyContent: "flex-start",
  textAlign: "left",
  height: "auto",
  minHeight: e.spacing(3),
  padding: e.spacing(0.5, 1),
  fontSize: "0.75rem",
  border: "none",
  backgroundColor: e.palette.common.neutrals[100],
  width: "auto",
  // Auto-width based on content
  flexShrink: 0,
  // Don't shrink in horizontal scroll
  "& .MuiChip-label": {
    whiteSpace: "nowrap",
    // Single line for mobile
    padding: e.spacing(0.5),
    lineHeight: 1.4,
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "200px",
    // Prevent extremely long chips
    fontWeight: 500
  },
  "&:hover": {
    backgroundColor: e.palette.action.hover
  }
}));
Fn(Ai)(({ theme: e }) => ({
  justifyContent: "flex-start",
  textAlign: "left",
  height: "auto",
  minHeight: e.spacing(4),
  padding: e.spacing(0.5, 1),
  fontSize: "0.875rem",
  border: "none",
  backgroundColor: e.palette.common.neutrals[100],
  "& .MuiChip-label": {
    whiteSpace: "normal",
    // Allow wrap on desktop
    padding: e.spacing(0.5),
    lineHeight: 1.4,
    fontWeight: 500
  },
  "&:hover": {
    backgroundColor: e.palette.action.hover
  },
  [e.breakpoints.up("sm")]: {
    maxWidth: "calc(50% - 8px)"
  },
  [e.breakpoints.up("md")]: {
    maxWidth: "calc(33.333% - 12px)"
  }
}));
Fn(vn)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between"
}));
Fn(vn)(({ theme: e }) => ({
  display: "flex",
  gap: e.spacing(1),
  overflowX: "auto",
  scrollBehavior: "smooth",
  paddingBottom: e.spacing(1),
  // Hide scrollbar completely
  scrollbarWidth: "none",
  // Firefox
  "&::-webkit-scrollbar": {
    display: "none"
    // Chrome, Safari, Opera
  },
  "-ms-overflow-style": "none"
  // Internet Explorer 10+
}));
Fn(vn)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  gap: e.spacing(2),
  alignItems: "flex-start"
}));
Fn(vn)(({ theme: e }) => ({
  display: "flex",
  gap: e.spacing(1),
  overflowX: "auto",
  // Hide scrollbar completely
  scrollbarWidth: "none",
  // Firefox
  "&::-webkit-scrollbar": {
    display: "none"
    // Chrome, Safari, Opera
  },
  "-ms-overflow-style": "none"
  // Internet Explorer 10+
}));
const VL = (e = !1) => {
  const n = K5(), r = Y5(), a = Oe(
    (l) => new Promise((d, c) => {
      const f = { prompt: l };
      n.mutate(
        { data: f },
        {
          onSuccess: (s) => {
            if (s.success && s.draft)
              d({
                content: s.draft,
                subject: s.subject_line,
                ai_message_draft_uuid: s.ai_message_draft_uuid
              });
            else {
              const h = "No content was generated. Please try again.";
              c(new Error(h));
            }
          },
          onError: (s) => {
            if ((s == null ? void 0 : s.error) === "guardrail_triggered") {
              const g = (s == null ? void 0 : s.error_explanation) || "AI content generation blocked due to security concerns.";
              c(new Error(g));
              return;
            }
            const h = (s == null ? void 0 : s.error_explanation) || "An error occurred while generating content.";
            c(new Error(h));
          }
        }
      );
    }),
    [n]
  ), o = Oe(
    (l) => new Promise((d, c) => {
      const f = {
        thread_id: l.thread_id,
        message: l.message,
        skip_guardrail: l.skip_guardrail
      };
      r.mutate(
        { data: f },
        {
          onSuccess: (s) => {
            if (s.success && s.draft)
              d({
                content: s.draft,
                ai_message_draft_uuid: s.ai_message_draft_uuid
              });
            else {
              const h = "No reply was generated. Please try again.";
              c(new Error(h));
            }
          },
          onError: (s) => {
            if ((s == null ? void 0 : s.error) === "guardrail_triggered") {
              const g = (s == null ? void 0 : s.error_explanation) || "AI content generation blocked due to security concerns.";
              c(new Error(g));
              return;
            }
            const h = (s == null ? void 0 : s.error_explanation) || "An error occurred while generating reply.";
            c(new Error(h));
          }
        }
      );
    }),
    [r]
  );
  return {
    generateAiMessageContent: e ? a : void 0,
    generateAiReply: e ? o : void 0
  };
};
function Z7(e, n) {
  const r = of(), [a, o] = Ee(!1), [l, d] = Ee(null), c = ut(n);
  return ot(() => {
    let f = !0;
    if (r)
      return r.waitForInitialization().then(async () => {
        if (f)
          try {
            const s = await r.variation(e, n);
            c.current = s, o(!0);
          } catch (s) {
            d(
              s instanceof Error ? s : new Error("Failed to evaluate flag")
            ), o(!0);
          }
      }).catch((s) => {
        f && (d(
          s instanceof Error ? s : new Error("LaunchDarkly initialization failed")
        ), o(!0));
      }), () => {
        f = !1;
      };
  }, [r, e, n]), {
    flagValue: c.current,
    isLoading: !a,
    error: l
  };
}
const Lx = "ai_features_enabled";
function Q7(e = !1) {
  return Sn({
    queryKey: ["ai-firm-setting"],
    queryFn: async () => {
      try {
        const n = await sx(
          Lx
        );
        if (n && n.data !== void 0) {
          const r = n.data;
          return typeof r == "boolean" ? r : r === "true";
        }
        return !1;
      } catch (n) {
        return console.warn("AI firm setting not found, defaulting to false:", n), !1;
      }
    },
    staleTime: 1e3 * 60 * 60,
    // 1 hour - very long cache time
    cacheTime: 1e3 * 60 * 60 * 2,
    // 2 hours - keep in cache longer
    enabled: e
    // Controlled by the parameter
  });
}
function XL() {
  const e = qn();
  return Ln({
    mutationFn: async (n) => {
      const r = await Z5(
        Lx,
        {
          type: "boolean",
          value: [n.toString()]
          // API expects string array
        }
      );
      if (r && r.value !== void 0) {
        const a = r.value;
        return typeof a == "boolean" ? a : Array.isArray(a) ? a[0] === "true" : a === "true";
      }
      return n;
    },
    onSuccess: (n) => {
      n != null && e.setQueryData(["ai-firm-setting"], n);
    },
    onError: (n) => {
      console.error("Failed to update AI setting:", n.message || n);
    }
  });
}
function GL(e = "client") {
  const {
    flagValue: n,
    isLoading: r,
    error: a
  } = Z7("enableAiClient", !1), o = e === "firm", l = Q7(o), d = o && l.isLoading || r, c = o && l.error || a, f = o ? l.data : !0, s = Tt(
    () => n && f === !0,
    [n, f]
  );
  return Tt(
    () => ({
      isAiEnabled: s,
      isLoading: d,
      error: c,
      firmSetting: o ? f : void 0,
      featureFlag: n
    }),
    [
      s,
      d,
      c,
      o,
      f,
      n
    ]
  );
}
const J7 = "file_intelligence_enabled", Cd = [
  "file-intelligence-setting"
], k1 = 1e3 * 60 * 60, e6 = (e) => typeof e == "boolean" ? e : String(e) === "true";
async function t6(e) {
  try {
    const n = await sx(
      J7,
      e
    );
    return e6(n.data);
  } catch (n) {
    if (rf(n) === 404) return !0;
    throw n;
  }
}
const E1 = /* @__PURE__ */ new WeakMap();
function n6({
  enabled: e = !0,
  onError: n,
  staleTime: r = k1
} = {}) {
  const a = qn();
  return Sn({
    queryKey: Cd,
    queryFn: ({ signal: o }) => t6(o),
    staleTime: r,
    cacheTime: k1 * 2,
    // Each caller decides when to read (`enabled`); a focus or reconnect must
    // not re-read behind its back.
    refetchOnWindowFocus: !1,
    refetchOnReconnect: !1,
    enabled: e,
    onError: (o) => {
      var d;
      if (G8(o)) return;
      const l = (d = a.getQueryState(
        Cd
      )) == null ? void 0 : d.errorUpdatedAt;
      if (l !== void 0) {
        if (E1.get(a) === l) return;
        E1.set(a, l);
      }
      n == null || n(o);
    }
  });
}
function KL({
  enabled: e = !0,
  onError: n
} = {}) {
  const r = qn(), { data: a, isFetching: o, isError: l, error: d } = n6({
    enabled: e,
    onError: n,
    staleTime: 0
  }), c = e && o;
  return ot(() => {
    if (e)
      return () => {
        r.cancelQueries({
          queryKey: Cd
        });
      };
  }, [e, r]), {
    // After a failed refetch React Query keeps the previous `data`, so the
    // current read must also have succeeded.
    isFileIntelligenceEnabled: !c && !l && a === !0,
    /** True while the setting is being read. */
    isLoading: c,
    /** The latest read failed, whatever an earlier read returned. */
    isUnknown: !c && l,
    error: d
  };
}
const i6 = (e = {}, n = {}) => {
  const [r, a] = Ee(!1), [o, l] = Ee(null), d = ut(null), c = typeof window < "u" && ("SpeechRecognition" in window || "webkitSpeechRecognition" in window), f = Oe(() => {
    l(null);
  }, []), s = Oe(() => {
    d.current && (d.current.abort(), d.current = null), a(!1), l(null);
  }, []), h = Oe(() => {
    if (!c) return null;
    const i = window.SpeechRecognition || window.webkitSpeechRecognition, m = new i();
    return m.continuous = e.continuous ?? !0, m.interimResults = e.interimResults ?? !0, m.lang = e.lang ?? "en-US", m.maxAlternatives = e.maxAlternatives ?? 1, m.onstart = () => {
      var v;
      a(!0), l(null), (v = n.onStart) == null || v.call(n);
    }, m.onend = () => {
      var v;
      a(!1), (v = n.onEnd) == null || v.call(n);
    }, m.onresult = (v) => {
      var y, x;
      let E = "", S = "";
      for (let b = v.resultIndex; b < v.results.length; b++) {
        const u = v.results[b][0].transcript;
        v.results[b].isFinal ? E += u : S += u;
      }
      E ? (y = n.onResult) == null || y.call(n, E, !0) : S && ((x = n.onResult) == null || x.call(n, S, !1));
    }, m.onerror = (v) => {
      var x;
      const S = {
        "no-speech": "No speech was detected. Please try again.",
        "audio-capture": "Audio capture failed. Please check your microphone.",
        "not-allowed": "Microphone access was denied. Please allow microphone access.",
        network: "Network error occurred. Please check your connection.",
        "service-not-allowed": "Speech recognition service is not allowed.",
        "bad-grammar": "Recognition grammar error.",
        "language-not-supported": "The selected language is not supported."
      }[v.error] || `Speech recognition error: ${v.error}`, y = {
        code: v.error,
        message: S
      };
      l(y), a(!1), (x = n.onError) == null || x.call(n, y);
    }, m;
  }, [e, n, c]), g = Oe(() => {
    var i, m, v;
    if (!c) {
      const E = {
        code: "not-supported",
        message: "Speech recognition is not supported in this browser"
      };
      l(E), (i = n.onError) == null || i.call(n, E);
      return;
    }
    if (!r) {
      f();
      try {
        d.current || (d.current = h()), (m = d.current) == null || m.start();
      } catch (E) {
        const S = {
          code: "start-failed",
          message: `Failed to start speech recognition: ${E instanceof Error ? E.message : "Unknown error"}`
        };
        l(S), (v = n.onError) == null || v.call(n, S);
      }
    }
  }, [c, r, f, h, n]), t = Oe(() => {
    d.current && r && d.current.stop();
  }, [r]);
  return ot(() => () => {
    d.current && d.current.abort();
  }, []), {
    isListening: r,
    isSupported: c,
    startListening: g,
    stopListening: t,
    clearError: f,
    resetRecognition: s,
    error: o
  };
}, Bx = ({
  currentValue: e,
  setValue: n,
  setError: r,
  fieldName: a
}) => {
  const [o, l] = Ee(!1), [d, c] = Ee(""), f = ut(null), s = ut(""), h = ut(""), g = Oe(() => Date.now().toString() + Math.random().toString(36).substr(2, 9), []);
  ot(
    () => () => {
      f.current && clearTimeout(f.current);
    },
    []
  );
  const t = {
    continuous: !0,
    interimResults: !1,
    lang: "en-US"
  }, i = Oe(
    (I, O) => {
      !I.trim() || O !== s.current || (c((D) => D ? `${D} ${I.trim()}` : I.trim()), h.current = h.current ? `${h.current} ${I.trim()}` : I.trim());
    },
    []
  ), {
    isListening: m,
    isSupported: v,
    startListening: E,
    stopListening: S,
    clearError: y,
    resetRecognition: x
  } = i6(t, {
    onResult: (I, O) => {
      O && i(I, s.current);
    },
    onError: (I) => {
      r(a, {
        type: "manual",
        message: I.message
      }), l(!1);
    },
    onEnd: () => {
      let I = d.trim();
      if (I || (I = h.current.trim()), I) {
        const O = e ? `${e.trim()} ${I}` : I;
        n(a, O);
      }
      l(!1), setTimeout(() => {
        s.current = "", c(""), h.current = "";
      }, 1e3);
    }
  }), b = () => {
    if (!v) {
      r(a, {
        type: "manual",
        message: "Speech recognition is not supported in this browser"
      });
      return;
    }
    if (m) {
      if (d.trim() || h.current.trim()) {
        const I = d.trim() || h.current.trim(), O = e ? `${e.trim()} ${I}` : I;
        n(a, O);
      }
      S();
    } else
      s.current = g(), f.current && (clearTimeout(f.current), f.current = null), y(), l(!1), c(""), h.current = "", x(), E();
  }, u = Oe(
    (I) => {
      if (!m) {
        I == null || I();
        return;
      }
      if (d.trim() || h.current.trim()) {
        const O = d.trim() || h.current.trim(), D = e ? `${e.trim()} ${O}` : O;
        n(a, D);
      }
      S(), I && setTimeout(I, 500);
    },
    [
      m,
      d,
      e,
      a,
      n,
      S
    ]
  );
  return {
    isListening: m,
    isProcessingVoice: o,
    isSupported: v,
    handleVoiceInput: b,
    stopRecordingAndCommit: u
  };
}, r6 = Jn.object().shape({
  prompt: Jn.string().trim().required("Please enter a prompt to generate content")
}), YL = ({
  generateAiContent: e,
  isAiEnabled: n,
  onContentGenerated: r,
  currentContent: a = "",
  disabled: o = !1,
  placeholder: l = "What would you like to write about?",
  isMobile: d = !1,
  onLoadingChange: c
}) => {
  const [f, s] = Ee(!1), [h, g] = Ee(!1), [t, i] = Ee(""), [m, v] = Ee(""), [E, S] = Ee(void 0), {
    register: y,
    handleSubmit: x,
    formState: { errors: b },
    setError: u,
    clearErrors: I,
    setValue: O,
    watch: D
  } = mr({
    resolver: ws(r6),
    defaultValues: { prompt: "" },
    mode: "onChange"
  }), $ = D("prompt"), {
    isListening: K,
    isProcessingVoice: H,
    isSupported: B,
    handleVoiceInput: R,
    stopRecordingAndCommit: _
  } = Bx({
    currentValue: $,
    setValue: O,
    setError: u,
    fieldName: "prompt"
  }), A = async (w) => {
    if (!e) {
      u("prompt", {
        type: "manual",
        message: "AI content generation is not available"
      });
      return;
    }
    s(!0), c == null || c(!0), I();
    try {
      const F = await e(w.prompt), { content: j, subject: P, ai_message_draft_uuid: V } = F;
      i(j), v(P), S(V), a && a.trim() ? g(!0) : r(j, P, V);
    } catch (F) {
      const j = F instanceof Error ? F.message : "Failed to generate content. Please try again.";
      u("prompt", {
        type: "manual",
        message: j
      });
    } finally {
      s(!1), c == null || c(!1);
    }
  }, k = () => {
    r(t, m, E), g(!1), i(""), v(""), S(void 0);
  }, z = () => {
    g(!1), i(""), v(""), S(void 0);
  }, T = () => {
    _(() => {
      x(A)();
    });
  };
  return n ? /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsxs(Fx, { variant: "compose", children: [
      /* @__PURE__ */ p.jsx(
        B7,
        {
          title: "AI Message Assistant",
          isMobile: d,
          variant: "compose"
        }
      ),
      /* @__PURE__ */ p.jsxs(Dx, { isMobile: d, children: [
        /* @__PURE__ */ p.jsx(
          Rx,
          {
            register: y("prompt"),
            placeholder: l,
            disabled: f || o,
            error: b.prompt,
            isMobile: d,
            endAdornment: /* @__PURE__ */ p.jsx(
              Nx,
              {
                isListening: K,
                isProcessingVoice: H,
                isSupported: B,
                disabled: f || o,
                onVoiceInput: R
              }
            )
          }
        ),
        /* @__PURE__ */ p.jsx(
          Mx,
          {
            onClick: T,
            disabled: f || o,
            isLoading: f,
            text: "Generate",
            loadingText: "Generating...",
            isMobile: d
          }
        )
      ] }),
      f && /* @__PURE__ */ p.jsx(Ox, { message: "Generating your message..." })
    ] }),
    /* @__PURE__ */ p.jsx(
      Y7,
      {
        open: h,
        onClose: z,
        onConfirm: k,
        title: "Replace Existing Content?",
        content: "You already have content in your message. Would you like to replace it with the AI-generated content?",
        generatedContent: t,
        isMobile: d
      }
    )
  ] }) : null;
}, s6 = Jn.object().shape({
  message: Jn.string().trim().optional().default("")
}), ZL = ({
  generateAiReply: e,
  isAiEnabled: n,
  threadId: r,
  onContentGenerated: a,
  disabled: o = !1,
  isMobile: l = !1,
  onLoadingChange: d
}) => {
  const [c, f] = Ee(!1), {
    register: s,
    handleSubmit: h,
    formState: { errors: g },
    reset: t,
    setError: i,
    clearErrors: m,
    setValue: v,
    watch: E
  } = mr({
    resolver: ws(s6),
    defaultValues: { message: "" },
    mode: "onChange"
  }), S = E("message"), {
    isListening: y,
    isProcessingVoice: x,
    isSupported: b,
    handleVoiceInput: u,
    stopRecordingAndCommit: I
  } = Bx({
    currentValue: S,
    setValue: v,
    setError: i,
    fieldName: "message"
  }), O = async ($) => {
    if (!r) {
      i("message", {
        type: "manual",
        message: "Thread ID is required to generate a reply"
      });
      return;
    }
    if (!e) {
      i("message", {
        type: "manual",
        message: "AI reply generation is not available"
      });
      return;
    }
    f(!0), d == null || d(!0), m();
    try {
      const K = {
        thread_id: r,
        message: $.message ? $.message.trim() : ""
      }, { content: H, ai_message_draft_uuid: B } = await e(K);
      a(H, B), t({ message: "" });
    } catch (K) {
      const H = K instanceof Error ? K.message : "Failed to generate reply. Please try again.";
      i("message", {
        type: "manual",
        message: H
      });
    } finally {
      f(!1), d == null || d(!1);
    }
  }, D = () => {
    I(() => {
      h(O)();
    });
  };
  return n ? /* @__PURE__ */ p.jsxs(Fx, { variant: "reply", children: [
    /* @__PURE__ */ p.jsxs(Dx, { isMobile: l, children: [
      /* @__PURE__ */ p.jsx(
        Rx,
        {
          register: s("message"),
          placeholder: "Tell AI what you want to say and we'll draft the message for you...",
          disabled: c || o,
          error: g.message,
          isMobile: l,
          endAdornment: /* @__PURE__ */ p.jsx(
            Nx,
            {
              isListening: y,
              isProcessingVoice: x,
              isSupported: b,
              disabled: c || o,
              onVoiceInput: u
            }
          )
        }
      ),
      /* @__PURE__ */ p.jsx(
        Mx,
        {
          onClick: D,
          disabled: c || o,
          isLoading: c,
          text: "Generate",
          loadingText: "Generating...",
          isMobile: l
        }
      )
    ] }),
    c && /* @__PURE__ */ p.jsx(Ox, { message: "Analyzing conversation and generating reply..." })
  ] }) : null;
}, Bi = tt(Me)(() => ({
  minWidth: "43px",
  minHeight: "43px",
  display: "flex",
  alignItems: "center"
})), Ks = tt(Me)(() => ({
  flexGrow: 1,
  overflow: "hidden",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
})), a6 = tt(Km)({
  "& .MuiBadge-badge": {
    top: "12px",
    right: "8px"
  }
}), o6 = ({
  title: e,
  numberOfNotifications: n = 0,
  onSecondaryActionClick: r,
  onNavigationClick: a,
  hideSecondaryActionButton: o
}) => {
  const l = Mr();
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsx(Bi, { children: /* @__PURE__ */ p.jsx(
      a6,
      {
        badgeContent: n,
        color: "primary",
        overlap: "circular",
        children: /* @__PURE__ */ p.jsx(
          Si,
          {
            "aria-label": "Navigation",
            size: "large",
            onClick: () => a && a("open:menu"),
            children: /* @__PURE__ */ p.jsx(
              it,
              {
                icon: "menu",
                style: { color: l.palette.common.blueGray[500] }
              }
            )
          }
        )
      }
    ) }),
    /* @__PURE__ */ p.jsx(Ks, { children: typeof e == "string" ? /* @__PURE__ */ p.jsx(Te, { variant: "h2", children: e }) : e }),
    /* @__PURE__ */ p.jsx(Bi, { children: !o && /* @__PURE__ */ p.jsx(
      Si,
      {
        "aria-label": "Search",
        size: "large",
        onClick: r,
        children: /* @__PURE__ */ p.jsx(it, { icon: "search" })
      }
    ) })
  ] });
}, c6 = tt(qs)(({ theme: e }) => ({
  backgroundColor: e.palette.common.white,
  "& .Mui-focused .MuiInputAdornment-positionStart svg path": {
    fill: e.palette.primary.main
  }
})), $x = ({
  value: e = "",
  onChange: n,
  onClearClick: r,
  autoFocus: a = !1,
  debounce: o = 500,
  placeholder: l = "Search..."
}) => {
  const [d, c] = Ee(e), f = Tt(
    () => wd(n, o),
    [n, o]
  );
  return ot(() => {
    f(d);
  }, [d, f]), ot(() => {
    c(e);
  }, [e]), /* @__PURE__ */ p.jsx(
    c6,
    {
      value: d,
      onChange: (s) => {
        var h;
        c(((h = s == null ? void 0 : s.target) == null ? void 0 : h.value) || "");
      },
      placeholder: l,
      size: "small",
      inputProps: {
        "aria-label": "search"
      },
      InputProps: {
        startAdornment: /* @__PURE__ */ p.jsx(kl, { position: "start", children: /* @__PURE__ */ p.jsx(it, { icon: "search" }) }),
        endAdornment: /* @__PURE__ */ p.jsx(kl, { position: "end", children: /* @__PURE__ */ p.jsx(
          Si,
          {
            "aria-label": "clear-search",
            onClick: r,
            edge: "end",
            size: "small",
            children: /* @__PURE__ */ p.jsx(it, { icon: "clear" })
          }
        ) })
      },
      fullWidth: !0,
      autoFocus: a
    }
  );
}, l6 = ({
  onSearchChange: e = () => {
  },
  onCloseClick: n
}) => /* @__PURE__ */ p.jsx(Me, { flexGrow: 1, minHeight: "44px", children: /* @__PURE__ */ p.jsx(
  $x,
  {
    onChange: e,
    onClearClick: n,
    autoFocus: !0
  }
) }), Ys = ({
  onNavigationClick: e,
  children: n,
  title: r,
  secondaryActionChildren: a = null,
  isLoading: o,
  mainSlotMinHeight: l
}) => /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
  /* @__PURE__ */ p.jsx(Bi, { children: /* @__PURE__ */ p.jsx(
    Si,
    {
      "aria-label": "Navigation",
      size: "large",
      onClick: () => e && e("go:back"),
      children: /* @__PURE__ */ p.jsx(it, { icon: "chevronLeft" })
    }
  ) }),
  /* @__PURE__ */ p.jsxs(Ks, { sx: { minHeight: l }, children: [
    n,
    !n && (typeof r == "string" ? /* @__PURE__ */ p.jsx(Te, { variant: "h2", children: r }) : r),
    o && /* @__PURE__ */ p.jsx(Vs, { width: 180, height: "1em" })
  ] }),
  /* @__PURE__ */ p.jsx(Bi, { sx: { flexShrink: 0 }, children: a })
] }), QL = ({
  onNavigationClick: e,
  children: n,
  title: r
}) => /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
  /* @__PURE__ */ p.jsx(Bi, {}),
  /* @__PURE__ */ p.jsxs(Ks, { children: [
    n,
    !n && /* @__PURE__ */ p.jsx(Te, { variant: "h2", children: r })
  ] }),
  /* @__PURE__ */ p.jsx(Bi, { children: /* @__PURE__ */ p.jsx(
    Si,
    {
      "aria-label": "Navigation",
      size: "large",
      onClick: () => e && e("go:back"),
      children: /* @__PURE__ */ p.jsx(it, { icon: "close" })
    }
  ) })
] }), JL = ({
  title: e,
  onNavigationClick: n,
  hideSecondaryActionButton: r
}) => /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
  /* @__PURE__ */ p.jsx(Bi, { children: /* @__PURE__ */ p.jsx(
    Si,
    {
      "aria-label": "Back",
      size: "large",
      onClick: () => n && n("go:back"),
      children: /* @__PURE__ */ p.jsx(it, { icon: "chevronLeft", fontSize: "small" })
    }
  ) }),
  /* @__PURE__ */ p.jsxs(Ks, { children: [
    e && /* @__PURE__ */ p.jsx(Te, { variant: "h2", children: e }),
    !e && /* @__PURE__ */ p.jsx(Vs, { width: 180 })
  ] }),
  /* @__PURE__ */ p.jsx(Bi, { children: !r && /* @__PURE__ */ p.jsx(
    Si,
    {
      "aria-label": "Add file",
      size: "large",
      onClick: () => n && n("upload"),
      children: /* @__PURE__ */ p.jsx(it, { icon: "attachFile", fontSize: "small" })
    }
  ) })
] }), eB = ({
  children: e,
  title: n,
  isLoading: r,
  mainSlotMinHeight: a,
  cancelLabel: o = "Cancel",
  onCancel: l,
  submitLabel: d = "Submit",
  onSubmit: c
}) => /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
  /* @__PURE__ */ p.jsx(Bi, { children: /* @__PURE__ */ p.jsx(Ei, { "aria-label": "Navigation", size: "large", onClick: l, children: o }) }),
  /* @__PURE__ */ p.jsxs(Ks, { sx: { minHeight: a }, children: [
    e,
    !e && /* @__PURE__ */ p.jsx(Te, { variant: "h2", children: n }),
    r && /* @__PURE__ */ p.jsx(Vs, { width: 180, height: "1em" })
  ] }),
  /* @__PURE__ */ p.jsx(Bi, { children: /* @__PURE__ */ p.jsx(
    Ei,
    {
      "aria-label": "Navigation",
      size: "large",
      type: "submit",
      onClick: c,
      children: d
    }
  ) })
] }), tB = ({
  children: e,
  title: n,
  isLoading: r,
  mainSlotMinHeight: a
}) => /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
  /* @__PURE__ */ p.jsx(Bi, {}),
  /* @__PURE__ */ p.jsxs(Ks, { sx: { minHeight: a }, children: [
    e,
    !e && /* @__PURE__ */ p.jsx(Te, { variant: "h2", children: n }),
    r && /* @__PURE__ */ p.jsx(Vs, { width: 180, height: "1em" })
  ] }),
  /* @__PURE__ */ p.jsx(Bi, {})
] });
var u6 = /* @__PURE__ */ ((e) => (e.DEFAULT = "default", e.SEARCH = "search", e))(u6 || {});
const d6 = tt(Gy)({
  paddingBottom: 0
}), h6 = tt(Ky)(({ theme: e }) => ({
  minHeight: "49px",
  [e.breakpoints.up("sm")]: {
    minHeight: "44px"
  }
})), f6 = tt(Me)(({ theme: e }) => ({
  backgroundColor: e.palette.common.neutrals[100]
})), Kr = ({
  title: e,
  numberOfNotifications: n,
  color: r,
  onSearchChange: a,
  onNavigationClick: o,
  hideSecondaryActionButton: l,
  onSecondaryActionClick: d,
  DefaultStateElement: c = o6,
  children: f,
  isLoading: s,
  position: h = "relative"
}) => {
  const [g, t] = Ee(
    "default"
    /* DEFAULT */
  ), i = On.getPlatform() === "ios" ? "52px" : "12px";
  return /* @__PURE__ */ p.jsxs(
    d6,
    {
      position: h,
      color: r,
      sx: { paddingTop: i, maxWidth: "100vw" },
      children: [
        /* @__PURE__ */ p.jsxs(h6, { children: [
          g === "default" && /* @__PURE__ */ p.jsx(
            c,
            {
              title: e,
              onSecondaryActionClick: d || (() => t(
                "search"
                /* SEARCH */
              )),
              numberOfNotifications: n,
              onNavigationClick: o,
              hideSecondaryActionButton: l,
              isLoading: s
            }
          ),
          g === "search" && /* @__PURE__ */ p.jsx(
            l6,
            {
              onSearchChange: a,
              onCloseClick: () => {
                a && a(""), t(
                  "default"
                  /* DEFAULT */
                );
              }
            }
          )
        ] }),
        f && /* @__PURE__ */ p.jsx(f6, { children: f })
      ]
    }
  );
};
function p6(e, n = Q5) {
  return !((e == null ? void 0 : e.size) > n);
}
function jl(e) {
  if (!e)
    return {
      totalPages: 0,
      currentPage: 0
    };
  const { off: n, offset: r, total_documents: a } = e;
  if (typeof n != "number" || typeof r != "number" || typeof a != "number" || Number.isNaN(n) || Number.isNaN(r) || Number.isNaN(a))
    return {
      totalPages: 0,
      currentPage: 0
    };
  const o = n - r + 1;
  return {
    totalPages: Math.ceil(a / o) || 0,
    currentPage: Math.ceil(n / o) || 0
  };
}
function Ux(e) {
  return e.filter(Boolean).map(({ value: n }) => n ? String(n) : "");
}
function g6({ recipient: e, account: n }) {
  return [e == null ? void 0 : e.value, (n == null ? void 0 : n.value) || "", "user"];
}
function m6(e) {
  return e == null ? void 0 : e.map(g6);
}
function Rl(e) {
  return `${e.name}-${e.lastModified}-${e.size}`;
}
const hf = Jr(void 0), x6 = ({
  children: e,
  apiClient: n,
  graphQLClient: r
}) => /* @__PURE__ */ p.jsx(hf.Provider, { value: { apiClient: n, graphQLClient: r }, children: e }), Jt = () => {
  var n;
  const e = (n = xs(hf)) == null ? void 0 : n.apiClient;
  if (!e)
    throw new Error("useApiClient must be used within an ApiClientProvider");
  return e;
};
function b6(e, n, r) {
  const a = Jt(), { getContactDocuments: o } = a.documents;
  return g0({
    queryKey: ["files", e, n],
    queryFn: async ({ pageParam: l = 1 }) => await o(e, {
      page: l,
      ...n
    }),
    enabled: (r == null ? void 0 : r.enabled) !== !1 && !!e,
    getNextPageParam: (l, d) => {
      if (!(l != null && l.response_hash)) return;
      const { currentPage: c, totalPages: f } = jl(
        l.response_hash
      );
      if (!(f === 0 || c >= f))
        return d.length + 1;
    },
    getPreviousPageParam: (l, d) => {
      const { currentPage: c } = jl(
        l.response_hash
      );
      if (c !== 1)
        return d.length - 1;
    }
  });
}
function zx(e, n) {
  const r = Jt(), { getLiscioVaultDocuments: a } = r.documents;
  return g0({
    queryKey: ["files", "liscio_vault", e],
    queryFn: async ({ pageParam: o = 1 }) => await a({
      page: o,
      ...e
    }),
    enabled: (n == null ? void 0 : n.enabled) !== !1,
    getNextPageParam: (o, l) => {
      if (!(o != null && o.response_hash)) return;
      const { currentPage: d, totalPages: c } = jl(
        o.response_hash
      );
      if (!(c === 0 || d >= c))
        return l.length + 1;
    },
    getPreviousPageParam: (o, l) => {
      if (!(o != null && o.response_hash)) return;
      const { currentPage: d } = jl(
        o.response_hash
      );
      if (d !== 1)
        return l.length - 1;
    }
  });
}
function Hx(e, n = !0) {
  const r = Jt(), { getDocumentDetails: a } = r.documents;
  return Sn({
    queryKey: ["fileDetails", e],
    queryFn: a,
    enabled: n && !!e
  });
}
function Wx(e) {
  const n = Jt(), { getDocumentDetails: r } = n.documents, a = Array.isArray(e) && (e != null && e.length) ? e.map((h) => ({
    queryKey: ["workflow-document-details", h],
    queryFn: r,
    enabled: !!h
  })) : [], o = mx({ queries: a }), l = o.reduce(
    (h, g) => (g.isFetched && h.documents.push(g.data || { data: { success: !1 } }), h),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    { documents: [] }
  ), d = o.some((h) => h.isLoading), c = o.some((h) => h.isError), f = d ? "loading" : "idle", s = o.every((h) => h.isFetched);
  return {
    data: l,
    isLoading: d,
    isError: c,
    isFetched: s,
    fetchStatus: f
  };
}
function y6(e) {
  const n = Jt(), { archiveDocuments: r } = n.documents, a = qn();
  return Ln({
    mutationFn: r,
    onSuccess: (o, l) => {
      a.invalidateQueries({ queryKey: ["files"] }), a.invalidateQueries([
        "fileDetails",
        String(l.documentId)
      ]), e != null && e.onSuccess && e.onSuccess(o);
    }
  });
}
function qx(e) {
  const n = qn(), r = Jt(), { deleteDocument: a } = r.documents;
  return Ln({
    mutationFn: a,
    onSuccess: (o, l) => {
      n.removeQueries({ queryKey: ["files"] }), n.removeQueries(["fileDetails", String(l.documentId)]);
    }
  });
}
function v6(e) {
  const n = Jt(), { updateDocument: r } = n.documents, a = qn();
  return Ln({
    mutationFn: r,
    onSuccess: (o) => {
      a.invalidateQueries(["files"]), a.invalidateQueries(["messageThread"]), a.invalidateQueries(["fileDetails", String(o.data.id)]);
    }
  });
}
function Vx(e) {
  const n = Jt(), { updateNewDocument: r } = n.documents, a = qn();
  return Ln({
    mutationFn: ({
      doc_ids: o,
      formValues: { tags: l, year: d, month: c }
    }) => r({
      doc_ids: o,
      tags: Ux(l),
      is_draft: (e == null ? void 0 : e.isDraft) !== void 0 ? e.isDraft : !0,
      year: d,
      month: c,
      task_id: e != null && e.taskId ? String(e == null ? void 0 : e.taskId) : ""
    }),
    onSuccess: () => {
      a.invalidateQueries(["taskDetails", String(e == null ? void 0 : e.taskId)]), e != null && e.onSuccess && e.onSuccess();
    }
  });
}
function w6(e) {
  const n = Jt(), { shareDocumentsByDocId: r } = n.documents, a = qn();
  return Ln({
    mutationFn: async ({
      doc_ids: o,
      formValues: { tags: l, message: d, participants: c },
      isMessageAltered: f
    }) => {
      const s = await r({
        doc_ids: o,
        tags: Ux(l),
        message: d,
        recipients: m6(c),
        is_msg_alter: f
      });
      if ((s == null ? void 0 : s.success) !== !0 || (s == null ? void 0 : s.status) !== 200)
        throw new Error((s == null ? void 0 : s.message) || "Document sharing failed");
      return s;
    },
    onSuccess: () => {
      a.invalidateQueries(["files"]);
    }
  });
}
function Xx(e) {
  const n = Jt(), { sendDocsToS3: r } = n.documents, a = qn();
  return Ln({
    mutationFn: (o) => r(o),
    onSuccess: () => {
      a.invalidateQueries(["files"]), e != null && e.onSuccess && e.onSuccess();
    }
  });
}
const S6 = ({ open: e, id: n, onSuccess: r, closeFunction: a, isFileArchived: o }) => {
  const l = o ? "Confirm unarchive this file" : "Confirm archive this file", d = o ? "Are you sure you want to unarchive this file?" : "Are you sure you want to archive this file?", c = o ? "Unarchive" : "Archive", { mutateAsync: f, isLoading: s } = y6({
    onSuccess: r
  }), h = async () => {
    await f({
      documentId: n,
      mode: o ? "UNARCHIVE" : "ARCHIVE"
    }), a();
  };
  return /* @__PURE__ */ p.jsx(p.Fragment, { children: /* @__PURE__ */ p.jsx(
    Yh,
    {
      open: e,
      onConfirm: h,
      onCancel: a,
      title: l,
      content: d,
      confirmLabel: c,
      isLoading: s
    }
  ) });
}, _6 = tt(Me)(({ theme: e }) => ({
  position: "fixed",
  top: 0,
  bottom: 0,
  "html.native-android &": {
    top: "var(--safe-area-inset-top, env(safe-area-inset-top, 0px))",
    bottom: "var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px))"
  },
  left: 0,
  right: 0,
  backgroundColor: e.palette.background.paper,
  zIndex: e.zIndex.modal,
  padding: 0,
  overscrollBehavior: "none",
  overflow: "auto"
})), C6 = tt(Pe)(() => ({
  height: "var(--liscio-app-viewport-height, 100vh)",
  "@supports (height: 100dvh)": {
    height: "var(--liscio-app-viewport-height, 100dvh)"
  }
})), ms = ({
  open: e,
  children: n,
  ...r
}) => {
  const a = ut(window.document.body.style.overflow);
  if (ot(() => {
    const l = a.current;
    return e ? window.document.body.style.overflow = "hidden" : window.document.body.style.overflow = l, () => {
      window.document.body.style.overflow = l;
    };
  }, [e, a]), !e)
    return null;
  const o = /* @__PURE__ */ p.jsx(_6, { ...r, children: /* @__PURE__ */ p.jsx(C6, { children: n }) });
  return bx(o, document.body);
}, A6 = Fn(vn)(({ theme: e }) => {
  var n, r;
  return {
    padding: "8px",
    borderBottom: `solid 1px ${((n = e.palette.common.blueGray) == null ? void 0 : n[200]) || ((r = e.palette.common.neutrals) == null ? void 0 : r[200])}`
  };
}), k6 = ({
  open: e = !1,
  isLoading: n = !1,
  title: r,
  closeFunction: a,
  data: o,
  keyExtractor: l,
  renderItem: d,
  onSelect: c = () => {
  },
  onSearchChange: f,
  searchString: s = "",
  searchDebounce: h = 500
}) => /* @__PURE__ */ p.jsx(ms, { open: e, children: /* @__PURE__ */ p.jsxs(
  Xr,
  {
    sx: { backgroundColor: (g) => g.palette.background.paper },
    children: [
      /* @__PURE__ */ p.jsx(
        Kr,
        {
          onNavigationClick: a,
          DefaultStateElement: Ys,
          title: r
        }
      ),
      f && /* @__PURE__ */ p.jsx(A6, { children: /* @__PURE__ */ p.jsx(
        $x,
        {
          onChange: f,
          onClearClick: () => f(""),
          value: s,
          debounce: h
        }
      ) }),
      /* @__PURE__ */ p.jsxs(Ya, { children: [
        n && /* @__PURE__ */ p.jsx(u0, {}),
        !n && /* @__PURE__ */ p.jsx(qh, { disablePadding: !0, children: o.map((g) => /* @__PURE__ */ p.jsx(Vh, { disablePadding: !0, children: /* @__PURE__ */ p.jsx(Xh, { onClick: () => c(g), children: d(g) }) }, l(g))) })
      ] })
    ]
  }
) }), ra = tt(Te)(({ theme: e }) => ({
  color: e.palette.grey[500],
  width: "40%",
  maxWidth: "150px"
})), ks = ({ children: e, sx: n }) => /* @__PURE__ */ p.jsx(Pe, { direction: "row", gap: "8px", alignItems: "center", sx: n, children: e });
function Ns(e) {
  let n = "https://mui.com/production-error/?code=" + e;
  for (let r = 1; r < arguments.length; r += 1)
    n += "&args[]=" + encodeURIComponent(arguments[r]);
  return "Minified MUI error #" + e + "; visit " + n + " for the full message.";
}
const E6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ns
}, Symbol.toStringTag, { value: "Module" })), I6 = "$$material";
function zt() {
  return zt = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var r = arguments[n];
      for (var a in r) ({}).hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, zt.apply(null, arguments);
}
function Ti(e, n) {
  if (e == null) return {};
  var r = {};
  for (var a in e) if ({}.hasOwnProperty.call(e, a)) {
    if (n.includes(a)) continue;
    r[a] = e[a];
  }
  return r;
}
var Ad = { exports: {} }, Bc = { exports: {} }, mn = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var I1;
function T6() {
  if (I1) return mn;
  I1 = 1;
  var e = typeof Symbol == "function" && Symbol.for, n = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, l = e ? Symbol.for("react.profiler") : 60114, d = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, f = e ? Symbol.for("react.async_mode") : 60111, s = e ? Symbol.for("react.concurrent_mode") : 60111, h = e ? Symbol.for("react.forward_ref") : 60112, g = e ? Symbol.for("react.suspense") : 60113, t = e ? Symbol.for("react.suspense_list") : 60120, i = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, E = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
  function x(u) {
    if (typeof u == "object" && u !== null) {
      var I = u.$$typeof;
      switch (I) {
        case n:
          switch (u = u.type, u) {
            case f:
            case s:
            case a:
            case l:
            case o:
            case g:
              return u;
            default:
              switch (u = u && u.$$typeof, u) {
                case c:
                case h:
                case m:
                case i:
                case d:
                  return u;
                default:
                  return I;
              }
          }
        case r:
          return I;
      }
    }
  }
  function b(u) {
    return x(u) === s;
  }
  return mn.AsyncMode = f, mn.ConcurrentMode = s, mn.ContextConsumer = c, mn.ContextProvider = d, mn.Element = n, mn.ForwardRef = h, mn.Fragment = a, mn.Lazy = m, mn.Memo = i, mn.Portal = r, mn.Profiler = l, mn.StrictMode = o, mn.Suspense = g, mn.isAsyncMode = function(u) {
    return b(u) || x(u) === f;
  }, mn.isConcurrentMode = b, mn.isContextConsumer = function(u) {
    return x(u) === c;
  }, mn.isContextProvider = function(u) {
    return x(u) === d;
  }, mn.isElement = function(u) {
    return typeof u == "object" && u !== null && u.$$typeof === n;
  }, mn.isForwardRef = function(u) {
    return x(u) === h;
  }, mn.isFragment = function(u) {
    return x(u) === a;
  }, mn.isLazy = function(u) {
    return x(u) === m;
  }, mn.isMemo = function(u) {
    return x(u) === i;
  }, mn.isPortal = function(u) {
    return x(u) === r;
  }, mn.isProfiler = function(u) {
    return x(u) === l;
  }, mn.isStrictMode = function(u) {
    return x(u) === o;
  }, mn.isSuspense = function(u) {
    return x(u) === g;
  }, mn.isValidElementType = function(u) {
    return typeof u == "string" || typeof u == "function" || u === a || u === s || u === l || u === o || u === g || u === t || typeof u == "object" && u !== null && (u.$$typeof === m || u.$$typeof === i || u.$$typeof === d || u.$$typeof === c || u.$$typeof === h || u.$$typeof === E || u.$$typeof === S || u.$$typeof === y || u.$$typeof === v);
  }, mn.typeOf = x, mn;
}
var xn = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var T1;
function O6() {
  return T1 || (T1 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, n = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, l = e ? Symbol.for("react.profiler") : 60114, d = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, f = e ? Symbol.for("react.async_mode") : 60111, s = e ? Symbol.for("react.concurrent_mode") : 60111, h = e ? Symbol.for("react.forward_ref") : 60112, g = e ? Symbol.for("react.suspense") : 60113, t = e ? Symbol.for("react.suspense_list") : 60120, i = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, E = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
    function x(oe) {
      return typeof oe == "string" || typeof oe == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      oe === a || oe === s || oe === l || oe === o || oe === g || oe === t || typeof oe == "object" && oe !== null && (oe.$$typeof === m || oe.$$typeof === i || oe.$$typeof === d || oe.$$typeof === c || oe.$$typeof === h || oe.$$typeof === E || oe.$$typeof === S || oe.$$typeof === y || oe.$$typeof === v);
    }
    function b(oe) {
      if (typeof oe == "object" && oe !== null) {
        var fe = oe.$$typeof;
        switch (fe) {
          case n:
            var Y = oe.type;
            switch (Y) {
              case f:
              case s:
              case a:
              case l:
              case o:
              case g:
                return Y;
              default:
                var ae = Y && Y.$$typeof;
                switch (ae) {
                  case c:
                  case h:
                  case m:
                  case i:
                  case d:
                    return ae;
                  default:
                    return fe;
                }
            }
          case r:
            return fe;
        }
      }
    }
    var u = f, I = s, O = c, D = d, $ = n, K = h, H = a, B = m, R = i, _ = r, A = l, k = o, z = g, T = !1;
    function w(oe) {
      return T || (T = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), F(oe) || b(oe) === f;
    }
    function F(oe) {
      return b(oe) === s;
    }
    function j(oe) {
      return b(oe) === c;
    }
    function P(oe) {
      return b(oe) === d;
    }
    function V(oe) {
      return typeof oe == "object" && oe !== null && oe.$$typeof === n;
    }
    function J(oe) {
      return b(oe) === h;
    }
    function ne(oe) {
      return b(oe) === a;
    }
    function Z(oe) {
      return b(oe) === m;
    }
    function te(oe) {
      return b(oe) === i;
    }
    function G(oe) {
      return b(oe) === r;
    }
    function N(oe) {
      return b(oe) === l;
    }
    function q(oe) {
      return b(oe) === o;
    }
    function ie(oe) {
      return b(oe) === g;
    }
    xn.AsyncMode = u, xn.ConcurrentMode = I, xn.ContextConsumer = O, xn.ContextProvider = D, xn.Element = $, xn.ForwardRef = K, xn.Fragment = H, xn.Lazy = B, xn.Memo = R, xn.Portal = _, xn.Profiler = A, xn.StrictMode = k, xn.Suspense = z, xn.isAsyncMode = w, xn.isConcurrentMode = F, xn.isContextConsumer = j, xn.isContextProvider = P, xn.isElement = V, xn.isForwardRef = J, xn.isFragment = ne, xn.isLazy = Z, xn.isMemo = te, xn.isPortal = G, xn.isProfiler = N, xn.isStrictMode = q, xn.isSuspense = ie, xn.isValidElementType = x, xn.typeOf = b;
  }()), xn;
}
var O1;
function Gx() {
  return O1 || (O1 = 1, process.env.NODE_ENV === "production" ? Bc.exports = T6() : Bc.exports = O6()), Bc.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var bu, F1;
function F6() {
  if (F1) return bu;
  F1 = 1;
  var e = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function a(l) {
    if (l == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(l);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var l = new String("abc");
      if (l[5] = "de", Object.getOwnPropertyNames(l)[0] === "5")
        return !1;
      for (var d = {}, c = 0; c < 10; c++)
        d["_" + String.fromCharCode(c)] = c;
      var f = Object.getOwnPropertyNames(d).map(function(h) {
        return d[h];
      });
      if (f.join("") !== "0123456789")
        return !1;
      var s = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(h) {
        s[h] = h;
      }), Object.keys(Object.assign({}, s)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return bu = o() ? Object.assign : function(l, d) {
    for (var c, f = a(l), s, h = 1; h < arguments.length; h++) {
      c = Object(arguments[h]);
      for (var g in c)
        n.call(c, g) && (f[g] = c[g]);
      if (e) {
        s = e(c);
        for (var t = 0; t < s.length; t++)
          r.call(c, s[t]) && (f[s[t]] = c[s[t]]);
      }
    }
    return f;
  }, bu;
}
var yu, P1;
function ff() {
  if (P1) return yu;
  P1 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return yu = e, yu;
}
var vu, j1;
function Kx() {
  return j1 || (j1 = 1, vu = Function.call.bind(Object.prototype.hasOwnProperty)), vu;
}
var wu, R1;
function P6() {
  if (R1) return wu;
  R1 = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var n = ff(), r = {}, a = Kx();
    e = function(l) {
      var d = "Warning: " + l;
      typeof console < "u" && console.error(d);
      try {
        throw new Error(d);
      } catch {
      }
    };
  }
  function o(l, d, c, f, s) {
    if (process.env.NODE_ENV !== "production") {
      for (var h in l)
        if (a(l, h)) {
          var g;
          try {
            if (typeof l[h] != "function") {
              var t = Error(
                (f || "React class") + ": " + c + " type `" + h + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof l[h] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw t.name = "Invariant Violation", t;
            }
            g = l[h](d, h, f, c, null, n);
          } catch (m) {
            g = m;
          }
          if (g && !(g instanceof Error) && e(
            (f || "React class") + ": type specification of " + c + " `" + h + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof g + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), g instanceof Error && !(g.message in r)) {
            r[g.message] = !0;
            var i = s ? s() : "";
            e(
              "Failed " + c + " type: " + g.message + (i ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, wu = o, wu;
}
var Su, M1;
function j6() {
  if (M1) return Su;
  M1 = 1;
  var e = Gx(), n = F6(), r = ff(), a = Kx(), o = P6(), l = function() {
  };
  process.env.NODE_ENV !== "production" && (l = function(c) {
    var f = "Warning: " + c;
    typeof console < "u" && console.error(f);
    try {
      throw new Error(f);
    } catch {
    }
  });
  function d() {
    return null;
  }
  return Su = function(c, f) {
    var s = typeof Symbol == "function" && Symbol.iterator, h = "@@iterator";
    function g(F) {
      var j = F && (s && F[s] || F[h]);
      if (typeof j == "function")
        return j;
    }
    var t = "<<anonymous>>", i = {
      array: S("array"),
      bigint: S("bigint"),
      bool: S("boolean"),
      func: S("function"),
      number: S("number"),
      object: S("object"),
      string: S("string"),
      symbol: S("symbol"),
      any: y(),
      arrayOf: x,
      element: b(),
      elementType: u(),
      instanceOf: I,
      node: K(),
      objectOf: D,
      oneOf: O,
      oneOfType: $,
      shape: B,
      exact: R
    };
    function m(F, j) {
      return F === j ? F !== 0 || 1 / F === 1 / j : F !== F && j !== j;
    }
    function v(F, j) {
      this.message = F, this.data = j && typeof j == "object" ? j : {}, this.stack = "";
    }
    v.prototype = Error.prototype;
    function E(F) {
      if (process.env.NODE_ENV !== "production")
        var j = {}, P = 0;
      function V(ne, Z, te, G, N, q, ie) {
        if (G = G || t, q = q || te, ie !== r) {
          if (f) {
            var oe = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw oe.name = "Invariant Violation", oe;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var fe = G + ":" + te;
            !j[fe] && // Avoid spamming the console because they are often not actionable except for lib authors
            P < 3 && (l(
              "You are manually calling a React.PropTypes validation function for the `" + q + "` prop on `" + G + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), j[fe] = !0, P++);
          }
        }
        return Z[te] == null ? ne ? Z[te] === null ? new v("The " + N + " `" + q + "` is marked as required " + ("in `" + G + "`, but its value is `null`.")) : new v("The " + N + " `" + q + "` is marked as required in " + ("`" + G + "`, but its value is `undefined`.")) : null : F(Z, te, G, N, q);
      }
      var J = V.bind(null, !1);
      return J.isRequired = V.bind(null, !0), J;
    }
    function S(F) {
      function j(P, V, J, ne, Z, te) {
        var G = P[V], N = k(G);
        if (N !== F) {
          var q = z(G);
          return new v(
            "Invalid " + ne + " `" + Z + "` of type " + ("`" + q + "` supplied to `" + J + "`, expected ") + ("`" + F + "`."),
            { expectedType: F }
          );
        }
        return null;
      }
      return E(j);
    }
    function y() {
      return E(d);
    }
    function x(F) {
      function j(P, V, J, ne, Z) {
        if (typeof F != "function")
          return new v("Property `" + Z + "` of component `" + J + "` has invalid PropType notation inside arrayOf.");
        var te = P[V];
        if (!Array.isArray(te)) {
          var G = k(te);
          return new v("Invalid " + ne + " `" + Z + "` of type " + ("`" + G + "` supplied to `" + J + "`, expected an array."));
        }
        for (var N = 0; N < te.length; N++) {
          var q = F(te, N, J, ne, Z + "[" + N + "]", r);
          if (q instanceof Error)
            return q;
        }
        return null;
      }
      return E(j);
    }
    function b() {
      function F(j, P, V, J, ne) {
        var Z = j[P];
        if (!c(Z)) {
          var te = k(Z);
          return new v("Invalid " + J + " `" + ne + "` of type " + ("`" + te + "` supplied to `" + V + "`, expected a single ReactElement."));
        }
        return null;
      }
      return E(F);
    }
    function u() {
      function F(j, P, V, J, ne) {
        var Z = j[P];
        if (!e.isValidElementType(Z)) {
          var te = k(Z);
          return new v("Invalid " + J + " `" + ne + "` of type " + ("`" + te + "` supplied to `" + V + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return E(F);
    }
    function I(F) {
      function j(P, V, J, ne, Z) {
        if (!(P[V] instanceof F)) {
          var te = F.name || t, G = w(P[V]);
          return new v("Invalid " + ne + " `" + Z + "` of type " + ("`" + G + "` supplied to `" + J + "`, expected ") + ("instance of `" + te + "`."));
        }
        return null;
      }
      return E(j);
    }
    function O(F) {
      if (!Array.isArray(F))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? l(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : l("Invalid argument supplied to oneOf, expected an array.")), d;
      function j(P, V, J, ne, Z) {
        for (var te = P[V], G = 0; G < F.length; G++)
          if (m(te, F[G]))
            return null;
        var N = JSON.stringify(F, function(ie, oe) {
          var fe = z(oe);
          return fe === "symbol" ? String(oe) : oe;
        });
        return new v("Invalid " + ne + " `" + Z + "` of value `" + String(te) + "` " + ("supplied to `" + J + "`, expected one of " + N + "."));
      }
      return E(j);
    }
    function D(F) {
      function j(P, V, J, ne, Z) {
        if (typeof F != "function")
          return new v("Property `" + Z + "` of component `" + J + "` has invalid PropType notation inside objectOf.");
        var te = P[V], G = k(te);
        if (G !== "object")
          return new v("Invalid " + ne + " `" + Z + "` of type " + ("`" + G + "` supplied to `" + J + "`, expected an object."));
        for (var N in te)
          if (a(te, N)) {
            var q = F(te, N, J, ne, Z + "." + N, r);
            if (q instanceof Error)
              return q;
          }
        return null;
      }
      return E(j);
    }
    function $(F) {
      if (!Array.isArray(F))
        return process.env.NODE_ENV !== "production" && l("Invalid argument supplied to oneOfType, expected an instance of array."), d;
      for (var j = 0; j < F.length; j++) {
        var P = F[j];
        if (typeof P != "function")
          return l(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + T(P) + " at index " + j + "."
          ), d;
      }
      function V(J, ne, Z, te, G) {
        for (var N = [], q = 0; q < F.length; q++) {
          var ie = F[q], oe = ie(J, ne, Z, te, G, r);
          if (oe == null)
            return null;
          oe.data && a(oe.data, "expectedType") && N.push(oe.data.expectedType);
        }
        var fe = N.length > 0 ? ", expected one of type [" + N.join(", ") + "]" : "";
        return new v("Invalid " + te + " `" + G + "` supplied to " + ("`" + Z + "`" + fe + "."));
      }
      return E(V);
    }
    function K() {
      function F(j, P, V, J, ne) {
        return _(j[P]) ? null : new v("Invalid " + J + " `" + ne + "` supplied to " + ("`" + V + "`, expected a ReactNode."));
      }
      return E(F);
    }
    function H(F, j, P, V, J) {
      return new v(
        (F || "React class") + ": " + j + " type `" + P + "." + V + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + J + "`."
      );
    }
    function B(F) {
      function j(P, V, J, ne, Z) {
        var te = P[V], G = k(te);
        if (G !== "object")
          return new v("Invalid " + ne + " `" + Z + "` of type `" + G + "` " + ("supplied to `" + J + "`, expected `object`."));
        for (var N in F) {
          var q = F[N];
          if (typeof q != "function")
            return H(J, ne, Z, N, z(q));
          var ie = q(te, N, J, ne, Z + "." + N, r);
          if (ie)
            return ie;
        }
        return null;
      }
      return E(j);
    }
    function R(F) {
      function j(P, V, J, ne, Z) {
        var te = P[V], G = k(te);
        if (G !== "object")
          return new v("Invalid " + ne + " `" + Z + "` of type `" + G + "` " + ("supplied to `" + J + "`, expected `object`."));
        var N = n({}, P[V], F);
        for (var q in N) {
          var ie = F[q];
          if (a(F, q) && typeof ie != "function")
            return H(J, ne, Z, q, z(ie));
          if (!ie)
            return new v(
              "Invalid " + ne + " `" + Z + "` key `" + q + "` supplied to `" + J + "`.\nBad object: " + JSON.stringify(P[V], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(F), null, "  ")
            );
          var oe = ie(te, q, J, ne, Z + "." + q, r);
          if (oe)
            return oe;
        }
        return null;
      }
      return E(j);
    }
    function _(F) {
      switch (typeof F) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !F;
        case "object":
          if (Array.isArray(F))
            return F.every(_);
          if (F === null || c(F))
            return !0;
          var j = g(F);
          if (j) {
            var P = j.call(F), V;
            if (j !== F.entries) {
              for (; !(V = P.next()).done; )
                if (!_(V.value))
                  return !1;
            } else
              for (; !(V = P.next()).done; ) {
                var J = V.value;
                if (J && !_(J[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function A(F, j) {
      return F === "symbol" ? !0 : j ? j["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && j instanceof Symbol : !1;
    }
    function k(F) {
      var j = typeof F;
      return Array.isArray(F) ? "array" : F instanceof RegExp ? "object" : A(j, F) ? "symbol" : j;
    }
    function z(F) {
      if (typeof F > "u" || F === null)
        return "" + F;
      var j = k(F);
      if (j === "object") {
        if (F instanceof Date)
          return "date";
        if (F instanceof RegExp)
          return "regexp";
      }
      return j;
    }
    function T(F) {
      var j = z(F);
      switch (j) {
        case "array":
        case "object":
          return "an " + j;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + j;
        default:
          return j;
      }
    }
    function w(F) {
      return !F.constructor || !F.constructor.name ? t : F.constructor.name;
    }
    return i.checkPropTypes = o, i.resetWarningCache = o.resetWarningCache, i.PropTypes = i, i;
  }, Su;
}
var _u, D1;
function R6() {
  if (D1) return _u;
  D1 = 1;
  var e = ff();
  function n() {
  }
  function r() {
  }
  return r.resetWarningCache = n, _u = function() {
    function a(d, c, f, s, h, g) {
      if (g !== e) {
        var t = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw t.name = "Invariant Violation", t;
      }
    }
    a.isRequired = a;
    function o() {
      return a;
    }
    var l = {
      array: a,
      bigint: a,
      bool: a,
      func: a,
      number: a,
      object: a,
      string: a,
      symbol: a,
      any: a,
      arrayOf: o,
      element: a,
      elementType: a,
      instanceOf: o,
      node: a,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: r,
      resetWarningCache: n
    };
    return l.PropTypes = l, l;
  }, _u;
}
if (process.env.NODE_ENV !== "production") {
  var M6 = Gx(), D6 = !0;
  Ad.exports = j6()(M6.isElement, D6);
} else
  Ad.exports = R6()();
var N6 = Ad.exports;
const Fe = /* @__PURE__ */ ys(N6);
var L6 = !1;
function B6(e) {
  if (e.sheet)
    return e.sheet;
  for (var n = 0; n < document.styleSheets.length; n++)
    if (document.styleSheets[n].ownerNode === e)
      return document.styleSheets[n];
}
function $6(e) {
  var n = document.createElement("style");
  return n.setAttribute("data-emotion", e.key), e.nonce !== void 0 && n.setAttribute("nonce", e.nonce), n.appendChild(document.createTextNode("")), n.setAttribute("data-s", ""), n;
}
var U6 = /* @__PURE__ */ function() {
  function e(r) {
    var a = this;
    this._insertTag = function(o) {
      var l;
      a.tags.length === 0 ? a.insertionPoint ? l = a.insertionPoint.nextSibling : a.prepend ? l = a.container.firstChild : l = a.before : l = a.tags[a.tags.length - 1].nextSibling, a.container.insertBefore(o, l), a.tags.push(o);
    }, this.isSpeedy = r.speedy === void 0 ? !L6 : r.speedy, this.tags = [], this.ctr = 0, this.nonce = r.nonce, this.key = r.key, this.container = r.container, this.prepend = r.prepend, this.insertionPoint = r.insertionPoint, this.before = null;
  }
  var n = e.prototype;
  return n.hydrate = function(a) {
    a.forEach(this._insertTag);
  }, n.insert = function(a) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag($6(this));
    var o = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var l = B6(o);
      try {
        l.insertRule(a, l.cssRules.length);
      } catch {
      }
    } else
      o.appendChild(document.createTextNode(a));
    this.ctr++;
  }, n.flush = function() {
    this.tags.forEach(function(a) {
      var o;
      return (o = a.parentNode) == null ? void 0 : o.removeChild(a);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), bi = "-ms-", Ml = "-moz-", fn = "-webkit-", Yx = "comm", pf = "rule", gf = "decl", z6 = "@import", Zx = "@keyframes", H6 = "@layer", W6 = Math.abs, v0 = String.fromCharCode, q6 = Object.assign;
function V6(e, n) {
  return fi(e, 0) ^ 45 ? (((n << 2 ^ fi(e, 0)) << 2 ^ fi(e, 1)) << 2 ^ fi(e, 2)) << 2 ^ fi(e, 3) : 0;
}
function Qx(e) {
  return e.trim();
}
function X6(e, n) {
  return (e = n.exec(e)) ? e[0] : e;
}
function pn(e, n, r) {
  return e.replace(n, r);
}
function kd(e, n) {
  return e.indexOf(n);
}
function fi(e, n) {
  return e.charCodeAt(n) | 0;
}
function Ko(e, n, r) {
  return e.slice(n, r);
}
function Sr(e) {
  return e.length;
}
function mf(e) {
  return e.length;
}
function $c(e, n) {
  return n.push(e), e;
}
function G6(e, n) {
  return e.map(n).join("");
}
var w0 = 1, Ma = 1, Jx = 0, $i = 0, ei = 0, Ja = "";
function S0(e, n, r, a, o, l, d) {
  return { value: e, root: n, parent: r, type: a, props: o, children: l, line: w0, column: Ma, length: d, return: "" };
}
function ho(e, n) {
  return q6(S0("", null, null, "", null, null, 0), e, { length: -e.length }, n);
}
function K6() {
  return ei;
}
function Y6() {
  return ei = $i > 0 ? fi(Ja, --$i) : 0, Ma--, ei === 10 && (Ma = 1, w0--), ei;
}
function Vi() {
  return ei = $i < Jx ? fi(Ja, $i++) : 0, Ma++, ei === 10 && (Ma = 1, w0++), ei;
}
function Ir() {
  return fi(Ja, $i);
}
function ll() {
  return $i;
}
function pc(e, n) {
  return Ko(Ja, e, n);
}
function Yo(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function e2(e) {
  return w0 = Ma = 1, Jx = Sr(Ja = e), $i = 0, [];
}
function t2(e) {
  return Ja = "", e;
}
function ul(e) {
  return Qx(pc($i - 1, Ed(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Z6(e) {
  for (; (ei = Ir()) && ei < 33; )
    Vi();
  return Yo(e) > 2 || Yo(ei) > 3 ? "" : " ";
}
function Q6(e, n) {
  for (; --n && Vi() && !(ei < 48 || ei > 102 || ei > 57 && ei < 65 || ei > 70 && ei < 97); )
    ;
  return pc(e, ll() + (n < 6 && Ir() == 32 && Vi() == 32));
}
function Ed(e) {
  for (; Vi(); )
    switch (ei) {
      case e:
        return $i;
      case 34:
      case 39:
        e !== 34 && e !== 39 && Ed(ei);
        break;
      case 40:
        e === 41 && Ed(e);
        break;
      case 92:
        Vi();
        break;
    }
  return $i;
}
function J6(e, n) {
  for (; Vi() && e + ei !== 57; )
    if (e + ei === 84 && Ir() === 47)
      break;
  return "/*" + pc(n, $i - 1) + "*" + v0(e === 47 ? e : Vi());
}
function ev(e) {
  for (; !Yo(Ir()); )
    Vi();
  return pc(e, $i);
}
function tv(e) {
  return t2(dl("", null, null, null, [""], e = e2(e), 0, [0], e));
}
function dl(e, n, r, a, o, l, d, c, f) {
  for (var s = 0, h = 0, g = d, t = 0, i = 0, m = 0, v = 1, E = 1, S = 1, y = 0, x = "", b = o, u = l, I = a, O = x; E; )
    switch (m = y, y = Vi()) {
      case 40:
        if (m != 108 && fi(O, g - 1) == 58) {
          kd(O += pn(ul(y), "&", "&\f"), "&\f") != -1 && (S = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        O += ul(y);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        O += Z6(m);
        break;
      case 92:
        O += Q6(ll() - 1, 7);
        continue;
      case 47:
        switch (Ir()) {
          case 42:
          case 47:
            $c(nv(J6(Vi(), ll()), n, r), f);
            break;
          default:
            O += "/";
        }
        break;
      case 123 * v:
        c[s++] = Sr(O) * S;
      case 125 * v:
      case 59:
      case 0:
        switch (y) {
          case 0:
          case 125:
            E = 0;
          case 59 + h:
            S == -1 && (O = pn(O, /\f/g, "")), i > 0 && Sr(O) - g && $c(i > 32 ? L1(O + ";", a, r, g - 1) : L1(pn(O, " ", "") + ";", a, r, g - 2), f);
            break;
          case 59:
            O += ";";
          default:
            if ($c(I = N1(O, n, r, s, h, o, c, x, b = [], u = [], g), l), y === 123)
              if (h === 0)
                dl(O, n, I, I, b, l, g, c, u);
              else
                switch (t === 99 && fi(O, 3) === 110 ? 100 : t) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    dl(e, I, I, a && $c(N1(e, I, I, 0, 0, o, c, x, o, b = [], g), u), o, u, g, c, a ? b : u);
                    break;
                  default:
                    dl(O, I, I, I, [""], u, 0, c, u);
                }
        }
        s = h = i = 0, v = S = 1, x = O = "", g = d;
        break;
      case 58:
        g = 1 + Sr(O), i = m;
      default:
        if (v < 1) {
          if (y == 123)
            --v;
          else if (y == 125 && v++ == 0 && Y6() == 125)
            continue;
        }
        switch (O += v0(y), y * v) {
          case 38:
            S = h > 0 ? 1 : (O += "\f", -1);
            break;
          case 44:
            c[s++] = (Sr(O) - 1) * S, S = 1;
            break;
          case 64:
            Ir() === 45 && (O += ul(Vi())), t = Ir(), h = g = Sr(x = O += ev(ll())), y++;
            break;
          case 45:
            m === 45 && Sr(O) == 2 && (v = 0);
        }
    }
  return l;
}
function N1(e, n, r, a, o, l, d, c, f, s, h) {
  for (var g = o - 1, t = o === 0 ? l : [""], i = mf(t), m = 0, v = 0, E = 0; m < a; ++m)
    for (var S = 0, y = Ko(e, g + 1, g = W6(v = d[m])), x = e; S < i; ++S)
      (x = Qx(v > 0 ? t[S] + " " + y : pn(y, /&\f/g, t[S]))) && (f[E++] = x);
  return S0(e, n, r, o === 0 ? pf : c, f, s, h);
}
function nv(e, n, r) {
  return S0(e, n, r, Yx, v0(K6()), Ko(e, 2, -2), 0);
}
function L1(e, n, r, a) {
  return S0(e, n, r, gf, Ko(e, 0, a), Ko(e, a + 1, -1), a);
}
function ka(e, n) {
  for (var r = "", a = mf(e), o = 0; o < a; o++)
    r += n(e[o], o, e, n) || "";
  return r;
}
function iv(e, n, r, a) {
  switch (e.type) {
    case H6:
      if (e.children.length) break;
    case z6:
    case gf:
      return e.return = e.return || e.value;
    case Yx:
      return "";
    case Zx:
      return e.return = e.value + "{" + ka(e.children, a) + "}";
    case pf:
      e.value = e.props.join(",");
  }
  return Sr(r = ka(e.children, a)) ? e.return = e.value + "{" + r + "}" : "";
}
function rv(e) {
  var n = mf(e);
  return function(r, a, o, l) {
    for (var d = "", c = 0; c < n; c++)
      d += e[c](r, a, o, l) || "";
    return d;
  };
}
function sv(e) {
  return function(n) {
    n.root || (n = n.return) && e(n);
  };
}
var av = function(n, r, a) {
  for (var o = 0, l = 0; o = l, l = Ir(), o === 38 && l === 12 && (r[a] = 1), !Yo(l); )
    Vi();
  return pc(n, $i);
}, ov = function(n, r) {
  var a = -1, o = 44;
  do
    switch (Yo(o)) {
      case 0:
        o === 38 && Ir() === 12 && (r[a] = 1), n[a] += av($i - 1, r, a);
        break;
      case 2:
        n[a] += ul(o);
        break;
      case 4:
        if (o === 44) {
          n[++a] = Ir() === 58 ? "&\f" : "", r[a] = n[a].length;
          break;
        }
      default:
        n[a] += v0(o);
    }
  while (o = Vi());
  return n;
}, cv = function(n, r) {
  return t2(ov(e2(n), r));
}, B1 = /* @__PURE__ */ new WeakMap(), lv = function(n) {
  if (!(n.type !== "rule" || !n.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  n.length < 1)) {
    for (var r = n.value, a = n.parent, o = n.column === a.column && n.line === a.line; a.type !== "rule"; )
      if (a = a.parent, !a) return;
    if (!(n.props.length === 1 && r.charCodeAt(0) !== 58 && !B1.get(a)) && !o) {
      B1.set(n, !0);
      for (var l = [], d = cv(r, l), c = a.props, f = 0, s = 0; f < d.length; f++)
        for (var h = 0; h < c.length; h++, s++)
          n.props[s] = l[f] ? d[f].replace(/&\f/g, c[h]) : c[h] + " " + d[f];
    }
  }
}, uv = function(n) {
  if (n.type === "decl") {
    var r = n.value;
    // charcode for l
    r.charCodeAt(0) === 108 && // charcode for b
    r.charCodeAt(2) === 98 && (n.return = "", n.value = "");
  }
};
function n2(e, n) {
  switch (V6(e, n)) {
    case 5103:
      return fn + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return fn + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return fn + e + Ml + e + bi + e + e;
    case 6828:
    case 4268:
      return fn + e + bi + e + e;
    case 6165:
      return fn + e + bi + "flex-" + e + e;
    case 5187:
      return fn + e + pn(e, /(\w+).+(:[^]+)/, fn + "box-$1$2" + bi + "flex-$1$2") + e;
    case 5443:
      return fn + e + bi + "flex-item-" + pn(e, /flex-|-self/, "") + e;
    case 4675:
      return fn + e + bi + "flex-line-pack" + pn(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return fn + e + bi + pn(e, "shrink", "negative") + e;
    case 5292:
      return fn + e + bi + pn(e, "basis", "preferred-size") + e;
    case 6060:
      return fn + "box-" + pn(e, "-grow", "") + fn + e + bi + pn(e, "grow", "positive") + e;
    case 4554:
      return fn + pn(e, /([^-])(transform)/g, "$1" + fn + "$2") + e;
    case 6187:
      return pn(pn(pn(e, /(zoom-|grab)/, fn + "$1"), /(image-set)/, fn + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return pn(e, /(image-set\([^]*)/, fn + "$1$`$1");
    case 4968:
      return pn(pn(e, /(.+:)(flex-)?(.*)/, fn + "box-pack:$3" + bi + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + fn + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return pn(e, /(.+)-inline(.+)/, fn + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Sr(e) - 1 - n > 6) switch (fi(e, n + 1)) {
        case 109:
          if (fi(e, n + 4) !== 45) break;
        case 102:
          return pn(e, /(.+:)(.+)-([^]+)/, "$1" + fn + "$2-$3$1" + Ml + (fi(e, n + 3) == 108 ? "$3" : "$2-$3")) + e;
        case 115:
          return ~kd(e, "stretch") ? n2(pn(e, "stretch", "fill-available"), n) + e : e;
      }
      break;
    case 4949:
      if (fi(e, n + 1) !== 115) break;
    case 6444:
      switch (fi(e, Sr(e) - 3 - (~kd(e, "!important") && 10))) {
        case 107:
          return pn(e, ":", ":" + fn) + e;
        case 101:
          return pn(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + fn + (fi(e, 14) === 45 ? "inline-" : "") + "box$3$1" + fn + "$2$3$1" + bi + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (fi(e, n + 11)) {
        case 114:
          return fn + e + bi + pn(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return fn + e + bi + pn(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return fn + e + bi + pn(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return fn + e + bi + e + e;
  }
  return e;
}
var dv = function(n, r, a, o) {
  if (n.length > -1 && !n.return) switch (n.type) {
    case gf:
      n.return = n2(n.value, n.length);
      break;
    case Zx:
      return ka([ho(n, {
        value: pn(n.value, "@", "@" + fn)
      })], o);
    case pf:
      if (n.length) return G6(n.props, function(l) {
        switch (X6(l, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return ka([ho(n, {
              props: [pn(l, /:(read-\w+)/, ":" + Ml + "$1")]
            })], o);
          case "::placeholder":
            return ka([ho(n, {
              props: [pn(l, /:(plac\w+)/, ":" + fn + "input-$1")]
            }), ho(n, {
              props: [pn(l, /:(plac\w+)/, ":" + Ml + "$1")]
            }), ho(n, {
              props: [pn(l, /:(plac\w+)/, bi + "input-$1")]
            })], o);
        }
        return "";
      });
  }
}, hv = [dv], fv = function(n) {
  var r = n.key;
  if (r === "css") {
    var a = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(a, function(v) {
      var E = v.getAttribute("data-emotion");
      E.indexOf(" ") !== -1 && (document.head.appendChild(v), v.setAttribute("data-s", ""));
    });
  }
  var o = n.stylisPlugins || hv, l = {}, d, c = [];
  d = n.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + r + ' "]'),
    function(v) {
      for (var E = v.getAttribute("data-emotion").split(" "), S = 1; S < E.length; S++)
        l[E[S]] = !0;
      c.push(v);
    }
  );
  var f, s = [lv, uv];
  {
    var h, g = [iv, sv(function(v) {
      h.insert(v);
    })], t = rv(s.concat(o, g)), i = function(E) {
      return ka(tv(E), t);
    };
    f = function(E, S, y, x) {
      h = y, i(E ? E + "{" + S.styles + "}" : S.styles), x && (m.inserted[S.name] = !0);
    };
  }
  var m = {
    key: r,
    sheet: new U6({
      key: r,
      container: d,
      nonce: n.nonce,
      speedy: n.speedy,
      prepend: n.prepend,
      insertionPoint: n.insertionPoint
    }),
    nonce: n.nonce,
    inserted: l,
    registered: {},
    insert: f
  };
  return m.sheet.hydrate(c), m;
};
let Id;
typeof document == "object" && (Id = fv({
  key: "css",
  prepend: !0
}));
function i2(e) {
  const {
    injectFirst: n,
    children: r
  } = e;
  return n && Id ? /* @__PURE__ */ p.jsx(_7, {
    value: Id,
    children: r
  }) : r;
}
process.env.NODE_ENV !== "production" && (i2.propTypes = {
  /**
   * Your component tree.
   */
  children: Fe.node,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: Fe.bool
});
function pv(e) {
  return e == null || Object.keys(e).length === 0;
}
function r2(e) {
  const {
    styles: n,
    defaultTheme: r = {}
  } = e, a = typeof n == "function" ? (o) => n(pv(o) ? r : o) : n;
  return /* @__PURE__ */ p.jsx(C7, {
    styles: a
  });
}
process.env.NODE_ENV !== "production" && (r2.propTypes = {
  defaultTheme: Fe.object,
  styles: Fe.oneOfType([Fe.array, Fe.string, Fe.object, Fe.func])
});
/**
 * @mui/styled-engine v5.16.6
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function gv(e, n) {
  const r = S7(e, n);
  return process.env.NODE_ENV !== "production" ? (...a) => {
    const o = typeof e == "string" ? `"${e}"` : "component";
    return a.length === 0 ? console.error([`MUI: Seems like you called \`styled(${o})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : a.some((l) => l === void 0) && console.error(`MUI: the styled(${o})(...args) API requires all its args to be defined.`), r(...a);
  } : r;
}
const mv = (e, n) => {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = n(e.__emotion_styles));
}, xv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GlobalStyles: r2,
  StyledEngineProvider: i2,
  ThemeContext: A7,
  css: k7,
  default: gv,
  internal_processStyles: mv,
  keyframes: y0
}, Symbol.toStringTag, { value: "Module" }));
function ls(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function s2(e) {
  if (!ls(e))
    return e;
  const n = {};
  return Object.keys(e).forEach((r) => {
    n[r] = s2(e[r]);
  }), n;
}
function Tr(e, n, r = {
  clone: !0
}) {
  const a = r.clone ? zt({}, e) : e;
  return ls(e) && ls(n) && Object.keys(n).forEach((o) => {
    ls(n[o]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, o) && ls(e[o]) ? a[o] = Tr(e[o], n[o], r) : r.clone ? a[o] = ls(n[o]) ? s2(n[o]) : n[o] : a[o] = n[o];
  }), a;
}
const bv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Tr,
  isPlainObject: ls
}, Symbol.toStringTag, { value: "Module" })), yv = ["values", "unit", "step"], vv = (e) => {
  const n = Object.keys(e).map((r) => ({
    key: r,
    val: e[r]
  })) || [];
  return n.sort((r, a) => r.val - a.val), n.reduce((r, a) => zt({}, r, {
    [a.key]: a.val
  }), {});
};
function a2(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: n = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: r = "px",
    step: a = 5
  } = e, o = Ti(e, yv), l = vv(n), d = Object.keys(l);
  function c(t) {
    return `@media (min-width:${typeof n[t] == "number" ? n[t] : t}${r})`;
  }
  function f(t) {
    return `@media (max-width:${(typeof n[t] == "number" ? n[t] : t) - a / 100}${r})`;
  }
  function s(t, i) {
    const m = d.indexOf(i);
    return `@media (min-width:${typeof n[t] == "number" ? n[t] : t}${r}) and (max-width:${(m !== -1 && typeof n[d[m]] == "number" ? n[d[m]] : i) - a / 100}${r})`;
  }
  function h(t) {
    return d.indexOf(t) + 1 < d.length ? s(t, d[d.indexOf(t) + 1]) : c(t);
  }
  function g(t) {
    const i = d.indexOf(t);
    return i === 0 ? c(d[1]) : i === d.length - 1 ? f(d[i]) : s(t, d[d.indexOf(t) + 1]).replace("@media", "@media not all and");
  }
  return zt({
    keys: d,
    values: l,
    up: c,
    down: f,
    between: s,
    only: h,
    not: g,
    unit: r
  }, o);
}
const wv = {
  borderRadius: 4
}, Ss = process.env.NODE_ENV !== "production" ? Fe.oneOfType([Fe.number, Fe.string, Fe.object, Fe.array]) : {};
function Bo(e, n) {
  return n ? Tr(e, n, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const xf = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, $1 = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${xf[e]}px)`
};
function Yr(e, n, r) {
  const a = e.theme || {};
  if (Array.isArray(n)) {
    const l = a.breakpoints || $1;
    return n.reduce((d, c, f) => (d[l.up(l.keys[f])] = r(n[f]), d), {});
  }
  if (typeof n == "object") {
    const l = a.breakpoints || $1;
    return Object.keys(n).reduce((d, c) => {
      if (Object.keys(l.values || xf).indexOf(c) !== -1) {
        const f = l.up(c);
        d[f] = r(n[c], c);
      } else {
        const f = c;
        d[f] = n[f];
      }
      return d;
    }, {});
  }
  return r(n);
}
function Sv(e = {}) {
  var n;
  return ((n = e.keys) == null ? void 0 : n.reduce((a, o) => {
    const l = e.up(o);
    return a[l] = {}, a;
  }, {})) || {};
}
function _v(e, n) {
  return e.reduce((r, a) => {
    const o = r[a];
    return (!o || Object.keys(o).length === 0) && delete r[a], r;
  }, n);
}
function Ri(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : Ns(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const Cv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ri
}, Symbol.toStringTag, { value: "Module" }));
function _0(e, n, r = !0) {
  if (!n || typeof n != "string")
    return null;
  if (e && e.vars && r) {
    const a = `vars.${n}`.split(".").reduce((o, l) => o && o[l] ? o[l] : null, e);
    if (a != null)
      return a;
  }
  return n.split(".").reduce((a, o) => a && a[o] != null ? a[o] : null, e);
}
function Dl(e, n, r, a = r) {
  let o;
  return typeof e == "function" ? o = e(r) : Array.isArray(e) ? o = e[r] || a : o = _0(e, r) || a, n && (o = n(o, a, e)), o;
}
function Kn(e) {
  const {
    prop: n,
    cssProperty: r = e.prop,
    themeKey: a,
    transform: o
  } = e, l = (d) => {
    if (d[n] == null)
      return null;
    const c = d[n], f = d.theme, s = _0(f, a) || {};
    return Yr(d, c, (g) => {
      let t = Dl(s, o, g);
      return g === t && typeof g == "string" && (t = Dl(s, o, `${n}${g === "default" ? "" : Ri(g)}`, g)), r === !1 ? t : {
        [r]: t
      };
    });
  };
  return l.propTypes = process.env.NODE_ENV !== "production" ? {
    [n]: Ss
  } : {}, l.filterProps = [n], l;
}
function Av(e) {
  const n = {};
  return (r) => (n[r] === void 0 && (n[r] = e(r)), n[r]);
}
const kv = {
  m: "margin",
  p: "padding"
}, Ev = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, U1 = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, Iv = Av((e) => {
  if (e.length > 2)
    if (U1[e])
      e = U1[e];
    else
      return [e];
  const [n, r] = e.split(""), a = kv[n], o = Ev[r] || "";
  return Array.isArray(o) ? o.map((l) => a + l) : [a + o];
}), C0 = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], A0 = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], Tv = [...C0, ...A0];
function gc(e, n, r, a) {
  var o;
  const l = (o = _0(e, n, !1)) != null ? o : r;
  return typeof l == "number" ? (d) => typeof d == "string" ? d : (process.env.NODE_ENV !== "production" && typeof d != "number" && console.error(`MUI: Expected ${a} argument to be a number or a string, got ${d}.`), l * d) : Array.isArray(l) ? (d) => typeof d == "string" ? d : (process.env.NODE_ENV !== "production" && (Number.isInteger(d) ? d > l.length - 1 && console.error([`MUI: The value provided (${d}) overflows.`, `The supported values are: ${JSON.stringify(l)}.`, `${d} > ${l.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${n}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${n}\` as a number.`].join(`
`))), l[d]) : typeof l == "function" ? l : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${n}\` value (${l}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function o2(e) {
  return gc(e, "spacing", 8, "spacing");
}
function mc(e, n) {
  if (typeof n == "string" || n == null)
    return n;
  const r = Math.abs(n), a = e(r);
  return n >= 0 ? a : typeof a == "number" ? -a : `-${a}`;
}
function Ov(e, n) {
  return (r) => e.reduce((a, o) => (a[o] = mc(n, r), a), {});
}
function Fv(e, n, r, a) {
  if (n.indexOf(r) === -1)
    return null;
  const o = Iv(r), l = Ov(o, a), d = e[r];
  return Yr(e, d, l);
}
function c2(e, n) {
  const r = o2(e.theme);
  return Object.keys(e).map((a) => Fv(e, n, a, r)).reduce(Bo, {});
}
function Hn(e) {
  return c2(e, C0);
}
Hn.propTypes = process.env.NODE_ENV !== "production" ? C0.reduce((e, n) => (e[n] = Ss, e), {}) : {};
Hn.filterProps = C0;
function Wn(e) {
  return c2(e, A0);
}
Wn.propTypes = process.env.NODE_ENV !== "production" ? A0.reduce((e, n) => (e[n] = Ss, e), {}) : {};
Wn.filterProps = A0;
process.env.NODE_ENV !== "production" && Tv.reduce((e, n) => (e[n] = Ss, e), {});
function Pv(e = 8) {
  if (e.mui)
    return e;
  const n = o2({
    spacing: e
  }), r = (...a) => (process.env.NODE_ENV !== "production" && (a.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${a.length}`)), (a.length === 0 ? [1] : a).map((l) => {
    const d = n(l);
    return typeof d == "number" ? `${d}px` : d;
  }).join(" "));
  return r.mui = !0, r;
}
function k0(...e) {
  const n = e.reduce((a, o) => (o.filterProps.forEach((l) => {
    a[l] = o;
  }), a), {}), r = (a) => Object.keys(a).reduce((o, l) => n[l] ? Bo(o, n[l](a)) : o, {});
  return r.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((a, o) => Object.assign(a, o.propTypes), {}) : {}, r.filterProps = e.reduce((a, o) => a.concat(o.filterProps), []), r;
}
function tr(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function ur(e, n) {
  return Kn({
    prop: e,
    themeKey: "borders",
    transform: n
  });
}
const jv = ur("border", tr), Rv = ur("borderTop", tr), Mv = ur("borderRight", tr), Dv = ur("borderBottom", tr), Nv = ur("borderLeft", tr), Lv = ur("borderColor"), Bv = ur("borderTopColor"), $v = ur("borderRightColor"), Uv = ur("borderBottomColor"), zv = ur("borderLeftColor"), Hv = ur("outline", tr), Wv = ur("outlineColor"), E0 = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const n = gc(e.theme, "shape.borderRadius", 4, "borderRadius"), r = (a) => ({
      borderRadius: mc(n, a)
    });
    return Yr(e, e.borderRadius, r);
  }
  return null;
};
E0.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: Ss
} : {};
E0.filterProps = ["borderRadius"];
k0(jv, Rv, Mv, Dv, Nv, Lv, Bv, $v, Uv, zv, E0, Hv, Wv);
const I0 = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const n = gc(e.theme, "spacing", 8, "gap"), r = (a) => ({
      gap: mc(n, a)
    });
    return Yr(e, e.gap, r);
  }
  return null;
};
I0.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: Ss
} : {};
I0.filterProps = ["gap"];
const T0 = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const n = gc(e.theme, "spacing", 8, "columnGap"), r = (a) => ({
      columnGap: mc(n, a)
    });
    return Yr(e, e.columnGap, r);
  }
  return null;
};
T0.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: Ss
} : {};
T0.filterProps = ["columnGap"];
const O0 = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const n = gc(e.theme, "spacing", 8, "rowGap"), r = (a) => ({
      rowGap: mc(n, a)
    });
    return Yr(e, e.rowGap, r);
  }
  return null;
};
O0.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: Ss
} : {};
O0.filterProps = ["rowGap"];
const qv = Kn({
  prop: "gridColumn"
}), Vv = Kn({
  prop: "gridRow"
}), Xv = Kn({
  prop: "gridAutoFlow"
}), Gv = Kn({
  prop: "gridAutoColumns"
}), Kv = Kn({
  prop: "gridAutoRows"
}), Yv = Kn({
  prop: "gridTemplateColumns"
}), Zv = Kn({
  prop: "gridTemplateRows"
}), Qv = Kn({
  prop: "gridTemplateAreas"
}), Jv = Kn({
  prop: "gridArea"
});
k0(I0, T0, O0, qv, Vv, Xv, Gv, Kv, Yv, Zv, Qv, Jv);
function Ea(e, n) {
  return n === "grey" ? n : e;
}
const e4 = Kn({
  prop: "color",
  themeKey: "palette",
  transform: Ea
}), t4 = Kn({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: Ea
}), n4 = Kn({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: Ea
});
k0(e4, t4, n4);
function Wi(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const i4 = Kn({
  prop: "width",
  transform: Wi
}), bf = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const n = (r) => {
      var a, o;
      const l = ((a = e.theme) == null || (a = a.breakpoints) == null || (a = a.values) == null ? void 0 : a[r]) || xf[r];
      return l ? ((o = e.theme) == null || (o = o.breakpoints) == null ? void 0 : o.unit) !== "px" ? {
        maxWidth: `${l}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: l
      } : {
        maxWidth: Wi(r)
      };
    };
    return Yr(e, e.maxWidth, n);
  }
  return null;
};
bf.filterProps = ["maxWidth"];
const r4 = Kn({
  prop: "minWidth",
  transform: Wi
}), s4 = Kn({
  prop: "height",
  transform: Wi
}), a4 = Kn({
  prop: "maxHeight",
  transform: Wi
}), o4 = Kn({
  prop: "minHeight",
  transform: Wi
});
Kn({
  prop: "size",
  cssProperty: "width",
  transform: Wi
});
Kn({
  prop: "size",
  cssProperty: "height",
  transform: Wi
});
const c4 = Kn({
  prop: "boxSizing"
});
k0(i4, bf, r4, s4, a4, o4, c4);
const l4 = {
  // borders
  border: {
    themeKey: "borders",
    transform: tr
  },
  borderTop: {
    themeKey: "borders",
    transform: tr
  },
  borderRight: {
    themeKey: "borders",
    transform: tr
  },
  borderBottom: {
    themeKey: "borders",
    transform: tr
  },
  borderLeft: {
    themeKey: "borders",
    transform: tr
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: tr
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: E0
  },
  // palette
  color: {
    themeKey: "palette",
    transform: Ea
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: Ea
  },
  backgroundColor: {
    themeKey: "palette",
    transform: Ea
  },
  // spacing
  p: {
    style: Wn
  },
  pt: {
    style: Wn
  },
  pr: {
    style: Wn
  },
  pb: {
    style: Wn
  },
  pl: {
    style: Wn
  },
  px: {
    style: Wn
  },
  py: {
    style: Wn
  },
  padding: {
    style: Wn
  },
  paddingTop: {
    style: Wn
  },
  paddingRight: {
    style: Wn
  },
  paddingBottom: {
    style: Wn
  },
  paddingLeft: {
    style: Wn
  },
  paddingX: {
    style: Wn
  },
  paddingY: {
    style: Wn
  },
  paddingInline: {
    style: Wn
  },
  paddingInlineStart: {
    style: Wn
  },
  paddingInlineEnd: {
    style: Wn
  },
  paddingBlock: {
    style: Wn
  },
  paddingBlockStart: {
    style: Wn
  },
  paddingBlockEnd: {
    style: Wn
  },
  m: {
    style: Hn
  },
  mt: {
    style: Hn
  },
  mr: {
    style: Hn
  },
  mb: {
    style: Hn
  },
  ml: {
    style: Hn
  },
  mx: {
    style: Hn
  },
  my: {
    style: Hn
  },
  margin: {
    style: Hn
  },
  marginTop: {
    style: Hn
  },
  marginRight: {
    style: Hn
  },
  marginBottom: {
    style: Hn
  },
  marginLeft: {
    style: Hn
  },
  marginX: {
    style: Hn
  },
  marginY: {
    style: Hn
  },
  marginInline: {
    style: Hn
  },
  marginInlineStart: {
    style: Hn
  },
  marginInlineEnd: {
    style: Hn
  },
  marginBlock: {
    style: Hn
  },
  marginBlockStart: {
    style: Hn
  },
  marginBlockEnd: {
    style: Hn
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: I0
  },
  rowGap: {
    style: O0
  },
  columnGap: {
    style: T0
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: Wi
  },
  maxWidth: {
    style: bf
  },
  minWidth: {
    transform: Wi
  },
  height: {
    transform: Wi
  },
  maxHeight: {
    transform: Wi
  },
  minHeight: {
    transform: Wi
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
}, xc = l4;
function u4(...e) {
  const n = e.reduce((a, o) => a.concat(Object.keys(o)), []), r = new Set(n);
  return e.every((a) => r.size === Object.keys(a).length);
}
function d4(e, n) {
  return typeof e == "function" ? e(n) : e;
}
function l2() {
  function e(r, a, o, l) {
    const d = {
      [r]: a,
      theme: o
    }, c = l[r];
    if (!c)
      return {
        [r]: a
      };
    const {
      cssProperty: f = r,
      themeKey: s,
      transform: h,
      style: g
    } = c;
    if (a == null)
      return null;
    if (s === "typography" && a === "inherit")
      return {
        [r]: a
      };
    const t = _0(o, s) || {};
    return g ? g(d) : Yr(d, a, (m) => {
      let v = Dl(t, h, m);
      return m === v && typeof m == "string" && (v = Dl(t, h, `${r}${m === "default" ? "" : Ri(m)}`, m)), f === !1 ? v : {
        [f]: v
      };
    });
  }
  function n(r) {
    var a;
    const {
      sx: o,
      theme: l = {}
    } = r || {};
    if (!o)
      return null;
    const d = (a = l.unstable_sxConfig) != null ? a : xc;
    function c(f) {
      let s = f;
      if (typeof f == "function")
        s = f(l);
      else if (typeof f != "object")
        return f;
      if (!s)
        return null;
      const h = Sv(l.breakpoints), g = Object.keys(h);
      let t = h;
      return Object.keys(s).forEach((i) => {
        const m = d4(s[i], l);
        if (m != null)
          if (typeof m == "object")
            if (d[i])
              t = Bo(t, e(i, m, l, d));
            else {
              const v = Yr({
                theme: l
              }, m, (E) => ({
                [i]: E
              }));
              u4(v, m) ? t[i] = n({
                sx: m,
                theme: l
              }) : t = Bo(t, v);
            }
          else
            t = Bo(t, e(i, m, l, d));
      }), _v(g, t);
    }
    return Array.isArray(o) ? o.map(c) : c(o);
  }
  return n;
}
const u2 = l2();
u2.filterProps = ["sx"];
const yf = u2;
function d2(e, n) {
  const r = this;
  return r.vars && typeof r.getColorSchemeSelector == "function" ? {
    [r.getColorSchemeSelector(e).replace(/(\[[^\]]+\])/, "*:where($1)")]: n
  } : r.palette.mode === e ? n : {};
}
const h4 = ["breakpoints", "palette", "spacing", "shape"];
function h2(e = {}, ...n) {
  const {
    breakpoints: r = {},
    palette: a = {},
    spacing: o,
    shape: l = {}
  } = e, d = Ti(e, h4), c = a2(r), f = Pv(o);
  let s = Tr({
    breakpoints: c,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: zt({
      mode: "light"
    }, a),
    spacing: f,
    shape: zt({}, wv, l)
  }, d);
  return s.applyStyles = d2, s = n.reduce((h, g) => Tr(h, g), s), s.unstable_sxConfig = zt({}, xc, d == null ? void 0 : d.unstable_sxConfig), s.unstable_sx = function(g) {
    return yf({
      sx: g,
      theme: this
    });
  }, s;
}
const f4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: h2,
  private_createBreakpoints: a2,
  unstable_applyStyles: d2
}, Symbol.toStringTag, { value: "Module" })), p4 = ["sx"], g4 = (e) => {
  var n, r;
  const a = {
    systemProps: {},
    otherProps: {}
  }, o = (n = e == null || (r = e.theme) == null ? void 0 : r.unstable_sxConfig) != null ? n : xc;
  return Object.keys(e).forEach((l) => {
    o[l] ? a.systemProps[l] = e[l] : a.otherProps[l] = e[l];
  }), a;
};
function m4(e) {
  const {
    sx: n
  } = e, r = Ti(e, p4), {
    systemProps: a,
    otherProps: o
  } = g4(r);
  let l;
  return Array.isArray(n) ? l = [a, ...n] : typeof n == "function" ? l = (...d) => {
    const c = n(...d);
    return ls(c) ? zt({}, a, c) : a;
  } : l = zt({}, a, n), zt({}, o, {
    sx: l
  });
}
const x4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: yf,
  extendSxProp: m4,
  unstable_createStyleFunctionSx: l2,
  unstable_defaultSxConfig: xc
}, Symbol.toStringTag, { value: "Module" })), z1 = (e) => e, b4 = () => {
  let e = z1;
  return {
    configure(n) {
      e = n;
    },
    generate(n) {
      return e(n);
    },
    reset() {
      e = z1;
    }
  };
}, y4 = b4();
function f2(e) {
  var n, r, a = "";
  if (typeof e == "string" || typeof e == "number") a += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (n = 0; n < o; n++) e[n] && (r = f2(e[n])) && (a && (a += " "), a += r);
  } else for (r in e) e[r] && (a && (a += " "), a += r);
  return a;
}
function ji() {
  for (var e, n, r = 0, a = "", o = arguments.length; r < o; r++) (e = arguments[r]) && (n = f2(e)) && (a && (a += " "), a += n);
  return a;
}
const v4 = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function bc(e, n, r = "Mui") {
  const a = v4[n];
  return a ? `${r}-${a}` : `${y4.generate(e)}-${n}`;
}
function F0(e, n, r = "Mui") {
  const a = {};
  return n.forEach((o) => {
    a[o] = bc(e, o, r);
  }), a;
}
var Td = { exports: {} }, bn = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var H1;
function w4() {
  if (H1) return bn;
  H1 = 1;
  var e = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), d = Symbol.for("react.context"), c = Symbol.for("react.server_context"), f = Symbol.for("react.forward_ref"), s = Symbol.for("react.suspense"), h = Symbol.for("react.suspense_list"), g = Symbol.for("react.memo"), t = Symbol.for("react.lazy"), i = Symbol.for("react.offscreen"), m;
  m = Symbol.for("react.module.reference");
  function v(E) {
    if (typeof E == "object" && E !== null) {
      var S = E.$$typeof;
      switch (S) {
        case e:
          switch (E = E.type, E) {
            case r:
            case o:
            case a:
            case s:
            case h:
              return E;
            default:
              switch (E = E && E.$$typeof, E) {
                case c:
                case d:
                case f:
                case t:
                case g:
                case l:
                  return E;
                default:
                  return S;
              }
          }
        case n:
          return S;
      }
    }
  }
  return bn.ContextConsumer = d, bn.ContextProvider = l, bn.Element = e, bn.ForwardRef = f, bn.Fragment = r, bn.Lazy = t, bn.Memo = g, bn.Portal = n, bn.Profiler = o, bn.StrictMode = a, bn.Suspense = s, bn.SuspenseList = h, bn.isAsyncMode = function() {
    return !1;
  }, bn.isConcurrentMode = function() {
    return !1;
  }, bn.isContextConsumer = function(E) {
    return v(E) === d;
  }, bn.isContextProvider = function(E) {
    return v(E) === l;
  }, bn.isElement = function(E) {
    return typeof E == "object" && E !== null && E.$$typeof === e;
  }, bn.isForwardRef = function(E) {
    return v(E) === f;
  }, bn.isFragment = function(E) {
    return v(E) === r;
  }, bn.isLazy = function(E) {
    return v(E) === t;
  }, bn.isMemo = function(E) {
    return v(E) === g;
  }, bn.isPortal = function(E) {
    return v(E) === n;
  }, bn.isProfiler = function(E) {
    return v(E) === o;
  }, bn.isStrictMode = function(E) {
    return v(E) === a;
  }, bn.isSuspense = function(E) {
    return v(E) === s;
  }, bn.isSuspenseList = function(E) {
    return v(E) === h;
  }, bn.isValidElementType = function(E) {
    return typeof E == "string" || typeof E == "function" || E === r || E === o || E === a || E === s || E === h || E === i || typeof E == "object" && E !== null && (E.$$typeof === t || E.$$typeof === g || E.$$typeof === l || E.$$typeof === d || E.$$typeof === f || E.$$typeof === m || E.getModuleId !== void 0);
  }, bn.typeOf = v, bn;
}
var yn = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var W1;
function S4() {
  return W1 || (W1 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), d = Symbol.for("react.context"), c = Symbol.for("react.server_context"), f = Symbol.for("react.forward_ref"), s = Symbol.for("react.suspense"), h = Symbol.for("react.suspense_list"), g = Symbol.for("react.memo"), t = Symbol.for("react.lazy"), i = Symbol.for("react.offscreen"), m = !1, v = !1, E = !1, S = !1, y = !1, x;
    x = Symbol.for("react.module.reference");
    function b(Y) {
      return !!(typeof Y == "string" || typeof Y == "function" || Y === r || Y === o || y || Y === a || Y === s || Y === h || S || Y === i || m || v || E || typeof Y == "object" && Y !== null && (Y.$$typeof === t || Y.$$typeof === g || Y.$$typeof === l || Y.$$typeof === d || Y.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Y.$$typeof === x || Y.getModuleId !== void 0));
    }
    function u(Y) {
      if (typeof Y == "object" && Y !== null) {
        var ae = Y.$$typeof;
        switch (ae) {
          case e:
            var se = Y.type;
            switch (se) {
              case r:
              case o:
              case a:
              case s:
              case h:
                return se;
              default:
                var L = se && se.$$typeof;
                switch (L) {
                  case c:
                  case d:
                  case f:
                  case t:
                  case g:
                  case l:
                    return L;
                  default:
                    return ae;
                }
            }
          case n:
            return ae;
        }
      }
    }
    var I = d, O = l, D = e, $ = f, K = r, H = t, B = g, R = n, _ = o, A = a, k = s, z = h, T = !1, w = !1;
    function F(Y) {
      return T || (T = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function j(Y) {
      return w || (w = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function P(Y) {
      return u(Y) === d;
    }
    function V(Y) {
      return u(Y) === l;
    }
    function J(Y) {
      return typeof Y == "object" && Y !== null && Y.$$typeof === e;
    }
    function ne(Y) {
      return u(Y) === f;
    }
    function Z(Y) {
      return u(Y) === r;
    }
    function te(Y) {
      return u(Y) === t;
    }
    function G(Y) {
      return u(Y) === g;
    }
    function N(Y) {
      return u(Y) === n;
    }
    function q(Y) {
      return u(Y) === o;
    }
    function ie(Y) {
      return u(Y) === a;
    }
    function oe(Y) {
      return u(Y) === s;
    }
    function fe(Y) {
      return u(Y) === h;
    }
    yn.ContextConsumer = I, yn.ContextProvider = O, yn.Element = D, yn.ForwardRef = $, yn.Fragment = K, yn.Lazy = H, yn.Memo = B, yn.Portal = R, yn.Profiler = _, yn.StrictMode = A, yn.Suspense = k, yn.SuspenseList = z, yn.isAsyncMode = F, yn.isConcurrentMode = j, yn.isContextConsumer = P, yn.isContextProvider = V, yn.isElement = J, yn.isForwardRef = ne, yn.isFragment = Z, yn.isLazy = te, yn.isMemo = G, yn.isPortal = N, yn.isProfiler = q, yn.isStrictMode = ie, yn.isSuspense = oe, yn.isSuspenseList = fe, yn.isValidElementType = b, yn.typeOf = u;
  }()), yn;
}
process.env.NODE_ENV === "production" ? Td.exports = w4() : Td.exports = S4();
var q1 = Td.exports;
const _4 = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function p2(e) {
  const n = `${e}`.match(_4);
  return n && n[1] || "";
}
function g2(e, n = "") {
  return e.displayName || e.name || p2(e) || n;
}
function V1(e, n, r) {
  const a = g2(n);
  return e.displayName || (a !== "" ? `${r}(${a})` : r);
}
function C4(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return g2(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case q1.ForwardRef:
          return V1(e, e.render, "ForwardRef");
        case q1.Memo:
          return V1(e, e.type, "memo");
        default:
          return;
      }
  }
}
const A4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: C4,
  getFunctionName: p2
}, Symbol.toStringTag, { value: "Module" }));
function Nl(e, n) {
  const r = zt({}, n);
  return Object.keys(e).forEach((a) => {
    if (a.toString().match(/^(components|slots)$/))
      r[a] = zt({}, e[a], r[a]);
    else if (a.toString().match(/^(componentsProps|slotProps)$/)) {
      const o = e[a] || {}, l = n[a];
      r[a] = {}, !l || !Object.keys(l) ? r[a] = o : !o || !Object.keys(o) ? r[a] = l : (r[a] = zt({}, l), Object.keys(o).forEach((d) => {
        r[a][d] = Nl(o[d], l[d]);
      }));
    } else r[a] === void 0 && (r[a] = e[a]);
  }), r;
}
const Zo = typeof window < "u" ? Ue.useLayoutEffect : Ue.useEffect;
function m2(e, n = Number.MIN_SAFE_INTEGER, r = Number.MAX_SAFE_INTEGER) {
  return Math.max(n, Math.min(e, r));
}
const k4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: m2
}, Symbol.toStringTag, { value: "Module" }));
function E4(e, n = 0, r = 1) {
  return process.env.NODE_ENV !== "production" && (e < n || e > r) && console.error(`MUI: The value provided ${e} is out of range [${n}, ${r}].`), m2(e, n, r);
}
function I4(e) {
  e = e.slice(1);
  const n = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let r = e.match(n);
  return r && r[0].length === 1 && (r = r.map((a) => a + a)), r ? `rgb${r.length === 4 ? "a" : ""}(${r.map((a, o) => o < 3 ? parseInt(a, 16) : Math.round(parseInt(a, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function x2(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return x2(I4(e));
  const n = e.indexOf("("), r = e.substring(0, n);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(r) === -1)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : Ns(9, e));
  let a = e.substring(n + 1, e.length - 1), o;
  if (r === "color") {
    if (a = a.split(" "), o = a.shift(), a.length === 4 && a[3].charAt(0) === "/" && (a[3] = a[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(o) === -1)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${o}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : Ns(10, o));
  } else
    a = a.split(",");
  return a = a.map((l) => parseFloat(l)), {
    type: r,
    values: a,
    colorSpace: o
  };
}
function T4(e) {
  const {
    type: n,
    colorSpace: r
  } = e;
  let {
    values: a
  } = e;
  return n.indexOf("rgb") !== -1 ? a = a.map((o, l) => l < 3 ? parseInt(o, 10) : o) : n.indexOf("hsl") !== -1 && (a[1] = `${a[1]}%`, a[2] = `${a[2]}%`), n.indexOf("color") !== -1 ? a = `${r} ${a.join(" ")}` : a = `${a.join(", ")}`, `${n}(${a})`;
}
function b2(e, n) {
  return e = x2(e), n = E4(n), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${n}` : e.values[3] = n, T4(e);
}
function y2(e, n) {
  return process.env.NODE_ENV === "production" ? () => null : function(...a) {
    return e(...a) || n(...a);
  };
}
function O4(e) {
  const {
    prototype: n = {}
  } = e;
  return !!n.isReactComponent;
}
function F4(e, n, r, a, o) {
  const l = e[n], d = o || n;
  if (l == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let c;
  return typeof l == "function" && !O4(l) && (c = "Did you accidentally provide a plain function component instead?"), c !== void 0 ? new Error(`Invalid ${a} \`${d}\` supplied to \`${r}\`. Expected an element type that can hold a ref. ${c} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const P4 = y2(Fe.elementType, F4), j4 = "exact-prop: ​";
function R4(e) {
  return process.env.NODE_ENV === "production" ? e : zt({}, e, {
    [j4]: (n) => {
      const r = Object.keys(n).filter((a) => !e.hasOwnProperty(a));
      return r.length > 0 ? new Error(`The following props are not supported: ${r.map((a) => `\`${a}\``).join(", ")}. Please remove them.`) : null;
    }
  });
}
function Qo(e, n, r, a, o) {
  if (process.env.NODE_ENV === "production")
    return null;
  const l = e[n], d = o || n;
  return l == null ? null : l && l.nodeType !== 1 ? new Error(`Invalid ${a} \`${d}\` supplied to \`${r}\`. Expected an HTMLElement.`) : null;
}
const vf = Fe.oneOfType([Fe.func, Fe.object]);
function M4(e, n = 166) {
  let r;
  function a(...o) {
    const l = () => {
      e.apply(this, o);
    };
    clearTimeout(r), r = setTimeout(l, n);
  }
  return a.clear = () => {
    clearTimeout(r);
  }, a;
}
function X1(e) {
  return e && e.ownerDocument || document;
}
function Od(e, n) {
  typeof e == "function" ? e(n) : e && (e.current = n);
}
function Uc(e) {
  const n = Ue.useRef(e);
  return Zo(() => {
    n.current = e;
  }), Ue.useRef((...r) => (
    // @ts-expect-error hide `this`
    (0, n.current)(...r)
  )).current;
}
function Da(...e) {
  return Ue.useMemo(() => e.every((n) => n == null) ? null : (n) => {
    e.forEach((r) => {
      Od(r, n);
    });
  }, e);
}
const G1 = {};
function D4(e, n) {
  const r = Ue.useRef(G1);
  return r.current === G1 && (r.current = e(n)), r;
}
const N4 = [];
function L4(e) {
  Ue.useEffect(e, N4);
}
class P0 {
  constructor() {
    this.currentId = null, this.clear = () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    }, this.disposeEffect = () => this.clear;
  }
  static create() {
    return new P0();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(n, r) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, r();
    }, n);
  }
}
function B4() {
  const e = D4(P0.create).current;
  return L4(e.disposeEffect), e;
}
let j0 = !0, Fd = !1;
const $4 = new P0(), U4 = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function z4(e) {
  const {
    type: n,
    tagName: r
  } = e;
  return !!(r === "INPUT" && U4[n] && !e.readOnly || r === "TEXTAREA" && !e.readOnly || e.isContentEditable);
}
function H4(e) {
  e.metaKey || e.altKey || e.ctrlKey || (j0 = !0);
}
function Cu() {
  j0 = !1;
}
function W4() {
  this.visibilityState === "hidden" && Fd && (j0 = !0);
}
function q4(e) {
  e.addEventListener("keydown", H4, !0), e.addEventListener("mousedown", Cu, !0), e.addEventListener("pointerdown", Cu, !0), e.addEventListener("touchstart", Cu, !0), e.addEventListener("visibilitychange", W4, !0);
}
function V4(e) {
  const {
    target: n
  } = e;
  try {
    return n.matches(":focus-visible");
  } catch {
  }
  return j0 || z4(n);
}
function X4() {
  const e = Ue.useCallback((o) => {
    o != null && q4(o.ownerDocument);
  }, []), n = Ue.useRef(!1);
  function r() {
    return n.current ? (Fd = !0, $4.start(100, () => {
      Fd = !1;
    }), n.current = !1, !0) : !1;
  }
  function a(o) {
    return V4(o) ? (n.current = !0, !0) : !1;
  }
  return {
    isFocusVisibleRef: n,
    onFocus: a,
    onBlur: r,
    ref: e
  };
}
function wf(e, n, r = void 0) {
  const a = {};
  return Object.keys(e).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (o) => {
      a[o] = e[o].reduce((l, d) => {
        if (d) {
          const c = n(d);
          c !== "" && l.push(c), r && r[d] && l.push(r[d]);
        }
        return l;
      }, []).join(" ");
    }
  ), a;
}
function G4(e) {
  return typeof e == "string";
}
function K4(e, n, r) {
  return e === void 0 || G4(e) ? n : zt({}, n, {
    ownerState: zt({}, n.ownerState, r)
  });
}
function Y4(e, n = []) {
  if (e === void 0)
    return {};
  const r = {};
  return Object.keys(e).filter((a) => a.match(/^on[A-Z]/) && typeof e[a] == "function" && !n.includes(a)).forEach((a) => {
    r[a] = e[a];
  }), r;
}
function K1(e) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((r) => !(r.match(/^on[A-Z]/) && typeof e[r] == "function")).forEach((r) => {
    n[r] = e[r];
  }), n;
}
function Z4(e) {
  const {
    getSlotProps: n,
    additionalProps: r,
    externalSlotProps: a,
    externalForwardedProps: o,
    className: l
  } = e;
  if (!n) {
    const i = ji(r == null ? void 0 : r.className, l, o == null ? void 0 : o.className, a == null ? void 0 : a.className), m = zt({}, r == null ? void 0 : r.style, o == null ? void 0 : o.style, a == null ? void 0 : a.style), v = zt({}, r, o, a);
    return i.length > 0 && (v.className = i), Object.keys(m).length > 0 && (v.style = m), {
      props: v,
      internalRef: void 0
    };
  }
  const d = Y4(zt({}, o, a)), c = K1(a), f = K1(o), s = n(d), h = ji(s == null ? void 0 : s.className, r == null ? void 0 : r.className, l, o == null ? void 0 : o.className, a == null ? void 0 : a.className), g = zt({}, s == null ? void 0 : s.style, r == null ? void 0 : r.style, o == null ? void 0 : o.style, a == null ? void 0 : a.style), t = zt({}, s, r, f, c);
  return h.length > 0 && (t.className = h), Object.keys(g).length > 0 && (t.style = g), {
    props: t,
    internalRef: s.ref
  };
}
function Q4(e, n, r) {
  return typeof e == "function" ? e(n, r) : e;
}
const J4 = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function ew(e) {
  var n;
  const {
    elementType: r,
    externalSlotProps: a,
    ownerState: o,
    skipResolvingSlotProps: l = !1
  } = e, d = Ti(e, J4), c = l ? {} : Q4(a, o), {
    props: f,
    internalRef: s
  } = Z4(zt({}, d, {
    externalSlotProps: c
  })), h = Da(s, c == null ? void 0 : c.ref, (n = e.additionalProps) == null ? void 0 : n.ref);
  return K4(r, zt({}, f, {
    ref: h
  }), o);
}
const tw = /* @__PURE__ */ Ue.createContext(void 0);
process.env.NODE_ENV !== "production" && (Fe.node, Fe.object);
function nw(e) {
  const {
    theme: n,
    name: r,
    props: a
  } = e;
  if (!n || !n.components || !n.components[r])
    return a;
  const o = n.components[r];
  return o.defaultProps ? Nl(o.defaultProps, a) : !o.styleOverrides && !o.variants ? Nl(o, a) : a;
}
function iw({
  props: e,
  name: n
}) {
  const r = Ue.useContext(tw);
  return nw({
    props: e,
    name: n,
    theme: {
      components: r
    }
  });
}
function rw(e, n) {
  return zt({
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    }
  }, n);
}
var Yn = {}, v2 = { exports: {} };
(function(e) {
  function n(r) {
    return r && r.__esModule ? r : {
      default: r
    };
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(v2);
var w2 = v2.exports;
const sw = /* @__PURE__ */ vs(E6), aw = /* @__PURE__ */ vs(k4);
var S2 = w2;
Object.defineProperty(Yn, "__esModule", {
  value: !0
});
var zc = Yn.alpha = k2;
Yn.blend = bw;
Yn.colorChannel = void 0;
var ow = Yn.darken = _f;
Yn.decomposeColor = or;
Yn.emphasize = E2;
var Y1 = Yn.getContrastRatio = fw;
Yn.getLuminance = Ll;
Yn.hexToRgb = _2;
Yn.hslToRgb = A2;
var cw = Yn.lighten = Cf;
Yn.private_safeAlpha = pw;
Yn.private_safeColorChannel = void 0;
Yn.private_safeDarken = gw;
Yn.private_safeEmphasize = xw;
Yn.private_safeLighten = mw;
Yn.recomposeColor = eo;
Yn.rgbToHex = hw;
var Z1 = S2(sw), lw = S2(aw);
function Sf(e, n = 0, r = 1) {
  return process.env.NODE_ENV !== "production" && (e < n || e > r) && console.error(`MUI: The value provided ${e} is out of range [${n}, ${r}].`), (0, lw.default)(e, n, r);
}
function _2(e) {
  e = e.slice(1);
  const n = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let r = e.match(n);
  return r && r[0].length === 1 && (r = r.map((a) => a + a)), r ? `rgb${r.length === 4 ? "a" : ""}(${r.map((a, o) => o < 3 ? parseInt(a, 16) : Math.round(parseInt(a, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function uw(e) {
  const n = e.toString(16);
  return n.length === 1 ? `0${n}` : n;
}
function or(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return or(_2(e));
  const n = e.indexOf("("), r = e.substring(0, n);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(r) === -1)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : (0, Z1.default)(9, e));
  let a = e.substring(n + 1, e.length - 1), o;
  if (r === "color") {
    if (a = a.split(" "), o = a.shift(), a.length === 4 && a[3].charAt(0) === "/" && (a[3] = a[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(o) === -1)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${o}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : (0, Z1.default)(10, o));
  } else
    a = a.split(",");
  return a = a.map((l) => parseFloat(l)), {
    type: r,
    values: a,
    colorSpace: o
  };
}
const C2 = (e) => {
  const n = or(e);
  return n.values.slice(0, 3).map((r, a) => n.type.indexOf("hsl") !== -1 && a !== 0 ? `${r}%` : r).join(" ");
};
Yn.colorChannel = C2;
const dw = (e, n) => {
  try {
    return C2(e);
  } catch {
    return n && process.env.NODE_ENV !== "production" && console.warn(n), e;
  }
};
Yn.private_safeColorChannel = dw;
function eo(e) {
  const {
    type: n,
    colorSpace: r
  } = e;
  let {
    values: a
  } = e;
  return n.indexOf("rgb") !== -1 ? a = a.map((o, l) => l < 3 ? parseInt(o, 10) : o) : n.indexOf("hsl") !== -1 && (a[1] = `${a[1]}%`, a[2] = `${a[2]}%`), n.indexOf("color") !== -1 ? a = `${r} ${a.join(" ")}` : a = `${a.join(", ")}`, `${n}(${a})`;
}
function hw(e) {
  if (e.indexOf("#") === 0)
    return e;
  const {
    values: n
  } = or(e);
  return `#${n.map((r, a) => uw(a === 3 ? Math.round(255 * r) : r)).join("")}`;
}
function A2(e) {
  e = or(e);
  const {
    values: n
  } = e, r = n[0], a = n[1] / 100, o = n[2] / 100, l = a * Math.min(o, 1 - o), d = (s, h = (s + r / 30) % 12) => o - l * Math.max(Math.min(h - 3, 9 - h, 1), -1);
  let c = "rgb";
  const f = [Math.round(d(0) * 255), Math.round(d(8) * 255), Math.round(d(4) * 255)];
  return e.type === "hsla" && (c += "a", f.push(n[3])), eo({
    type: c,
    values: f
  });
}
function Ll(e) {
  e = or(e);
  let n = e.type === "hsl" || e.type === "hsla" ? or(A2(e)).values : e.values;
  return n = n.map((r) => (e.type !== "color" && (r /= 255), r <= 0.03928 ? r / 12.92 : ((r + 0.055) / 1.055) ** 2.4)), Number((0.2126 * n[0] + 0.7152 * n[1] + 0.0722 * n[2]).toFixed(3));
}
function fw(e, n) {
  const r = Ll(e), a = Ll(n);
  return (Math.max(r, a) + 0.05) / (Math.min(r, a) + 0.05);
}
function k2(e, n) {
  return e = or(e), n = Sf(n), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${n}` : e.values[3] = n, eo(e);
}
function pw(e, n, r) {
  try {
    return k2(e, n);
  } catch {
    return r && process.env.NODE_ENV !== "production" && console.warn(r), e;
  }
}
function _f(e, n) {
  if (e = or(e), n = Sf(n), e.type.indexOf("hsl") !== -1)
    e.values[2] *= 1 - n;
  else if (e.type.indexOf("rgb") !== -1 || e.type.indexOf("color") !== -1)
    for (let r = 0; r < 3; r += 1)
      e.values[r] *= 1 - n;
  return eo(e);
}
function gw(e, n, r) {
  try {
    return _f(e, n);
  } catch {
    return r && process.env.NODE_ENV !== "production" && console.warn(r), e;
  }
}
function Cf(e, n) {
  if (e = or(e), n = Sf(n), e.type.indexOf("hsl") !== -1)
    e.values[2] += (100 - e.values[2]) * n;
  else if (e.type.indexOf("rgb") !== -1)
    for (let r = 0; r < 3; r += 1)
      e.values[r] += (255 - e.values[r]) * n;
  else if (e.type.indexOf("color") !== -1)
    for (let r = 0; r < 3; r += 1)
      e.values[r] += (1 - e.values[r]) * n;
  return eo(e);
}
function mw(e, n, r) {
  try {
    return Cf(e, n);
  } catch {
    return r && process.env.NODE_ENV !== "production" && console.warn(r), e;
  }
}
function E2(e, n = 0.15) {
  return Ll(e) > 0.5 ? _f(e, n) : Cf(e, n);
}
function xw(e, n, r) {
  try {
    return E2(e, n);
  } catch {
    return r && process.env.NODE_ENV !== "production" && console.warn(r), e;
  }
}
function bw(e, n, r, a = 1) {
  const o = (f, s) => Math.round((f ** (1 / a) * (1 - r) + s ** (1 / a) * r) ** a), l = or(e), d = or(n), c = [o(l.values[0], d.values[0]), o(l.values[1], d.values[1]), o(l.values[2], d.values[2])];
  return eo({
    type: "rgb",
    values: c
  });
}
const Jo = {
  black: "#000",
  white: "#fff"
}, yw = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, sa = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, aa = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, fo = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, oa = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, ca = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, la = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
}, vw = ["mode", "contrastThreshold", "tonalOffset"], Q1 = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.6)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: Jo.white,
    default: Jo.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, Au = {
  text: {
    primary: Jo.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: Jo.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function J1(e, n, r, a) {
  const o = a.light || a, l = a.dark || a * 1.5;
  e[n] || (e.hasOwnProperty(r) ? e[n] = e[r] : n === "light" ? e.light = cw(e.main, o) : n === "dark" && (e.dark = ow(e.main, l)));
}
function ww(e = "light") {
  return e === "dark" ? {
    main: oa[200],
    light: oa[50],
    dark: oa[400]
  } : {
    main: oa[700],
    light: oa[400],
    dark: oa[800]
  };
}
function Sw(e = "light") {
  return e === "dark" ? {
    main: sa[200],
    light: sa[50],
    dark: sa[400]
  } : {
    main: sa[500],
    light: sa[300],
    dark: sa[700]
  };
}
function _w(e = "light") {
  return e === "dark" ? {
    main: aa[500],
    light: aa[300],
    dark: aa[700]
  } : {
    main: aa[700],
    light: aa[400],
    dark: aa[800]
  };
}
function Cw(e = "light") {
  return e === "dark" ? {
    main: ca[400],
    light: ca[300],
    dark: ca[700]
  } : {
    main: ca[700],
    light: ca[500],
    dark: ca[900]
  };
}
function Aw(e = "light") {
  return e === "dark" ? {
    main: la[400],
    light: la[300],
    dark: la[700]
  } : {
    main: la[800],
    light: la[500],
    dark: la[900]
  };
}
function kw(e = "light") {
  return e === "dark" ? {
    main: fo[400],
    light: fo[300],
    dark: fo[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: fo[500],
    dark: fo[900]
  };
}
function Ew(e) {
  const {
    mode: n = "light",
    contrastThreshold: r = 3,
    tonalOffset: a = 0.2
  } = e, o = Ti(e, vw), l = e.primary || ww(n), d = e.secondary || Sw(n), c = e.error || _w(n), f = e.info || Cw(n), s = e.success || Aw(n), h = e.warning || kw(n);
  function g(v) {
    const E = Y1(v, Au.text.primary) >= r ? Au.text.primary : Q1.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const S = Y1(v, E);
      S < 3 && console.error([`MUI: The contrast ratio of ${S}:1 for ${E} on ${v}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return E;
  }
  const t = ({
    color: v,
    name: E,
    mainShade: S = 500,
    lightShade: y = 300,
    darkShade: x = 700
  }) => {
    if (v = zt({}, v), !v.main && v[S] && (v.main = v[S]), !v.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${E ? ` (${E})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${S}\` property.` : Ns(11, E ? ` (${E})` : "", S));
    if (typeof v.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${E ? ` (${E})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(v.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : Ns(12, E ? ` (${E})` : "", JSON.stringify(v.main)));
    return J1(v, "light", y, a), J1(v, "dark", x, a), v.contrastText || (v.contrastText = g(v.main)), v;
  }, i = {
    dark: Au,
    light: Q1
  };
  return process.env.NODE_ENV !== "production" && (i[n] || console.error(`MUI: The palette mode \`${n}\` is not supported.`)), Tr(zt({
    // A collection of common colors.
    common: zt({}, Jo),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: n,
    // The colors used to represent primary interface elements for a user.
    primary: t({
      color: l,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: t({
      color: d,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: t({
      color: c,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: t({
      color: h,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: t({
      color: f,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: t({
      color: s,
      name: "success"
    }),
    // The grey colors.
    grey: yw,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: r,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: g,
    // Generate a rich color object.
    augmentColor: t,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: a
  }, i[n]), o);
}
const Iw = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function Tw(e) {
  return Math.round(e * 1e5) / 1e5;
}
const ep = {
  textTransform: "uppercase"
}, tp = '"Roboto", "Helvetica", "Arial", sans-serif';
function Ow(e, n) {
  const r = typeof n == "function" ? n(e) : n, {
    fontFamily: a = tp,
    // The default font size of the Material Specification.
    fontSize: o = 14,
    // px
    fontWeightLight: l = 300,
    fontWeightRegular: d = 400,
    fontWeightMedium: c = 500,
    fontWeightBold: f = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: s = 16,
    // Apply the CSS properties to all the variants.
    allVariants: h,
    pxToRem: g
  } = r, t = Ti(r, Iw);
  process.env.NODE_ENV !== "production" && (typeof o != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof s != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const i = o / 14, m = g || ((S) => `${S / s * i}rem`), v = (S, y, x, b, u) => zt({
    fontFamily: a,
    fontWeight: S,
    fontSize: m(y),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: x
  }, a === tp ? {
    letterSpacing: `${Tw(b / y)}em`
  } : {}, u, h), E = {
    h1: v(l, 96, 1.167, -1.5),
    h2: v(l, 60, 1.2, -0.5),
    h3: v(d, 48, 1.167, 0),
    h4: v(d, 34, 1.235, 0.25),
    h5: v(d, 24, 1.334, 0),
    h6: v(c, 20, 1.6, 0.15),
    subtitle1: v(d, 16, 1.75, 0.15),
    subtitle2: v(c, 14, 1.57, 0.1),
    body1: v(d, 16, 1.5, 0.15),
    body2: v(d, 14, 1.43, 0.15),
    button: v(c, 14, 1.75, 0.4, ep),
    caption: v(d, 12, 1.66, 0.4),
    overline: v(d, 12, 2.66, 1, ep),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return Tr(zt({
    htmlFontSize: s,
    pxToRem: m,
    fontFamily: a,
    fontSize: o,
    fontWeightLight: l,
    fontWeightRegular: d,
    fontWeightMedium: c,
    fontWeightBold: f
  }, E), t, {
    clone: !1
    // No need to clone deep
  });
}
const Fw = 0.2, Pw = 0.14, jw = 0.12;
function jn(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${Fw})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${Pw})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${jw})`].join(",");
}
const Rw = ["none", jn(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), jn(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), jn(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), jn(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), jn(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), jn(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), jn(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), jn(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), jn(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), jn(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), jn(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), jn(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), jn(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), jn(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), jn(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), jn(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), jn(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), jn(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), jn(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), jn(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), jn(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), jn(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), jn(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), jn(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], Mw = ["duration", "easing", "delay"], Dw = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, Nw = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function np(e) {
  return `${Math.round(e)}ms`;
}
function Lw(e) {
  if (!e)
    return 0;
  const n = e / 36;
  return Math.round((4 + 15 * n ** 0.25 + n / 5) * 10);
}
function Bw(e) {
  const n = zt({}, Dw, e.easing), r = zt({}, Nw, e.duration);
  return zt({
    getAutoHeightDuration: Lw,
    create: (o = ["all"], l = {}) => {
      const {
        duration: d = r.standard,
        easing: c = n.easeInOut,
        delay: f = 0
      } = l, s = Ti(l, Mw);
      if (process.env.NODE_ENV !== "production") {
        const h = (t) => typeof t == "string", g = (t) => !isNaN(parseFloat(t));
        !h(o) && !Array.isArray(o) && console.error('MUI: Argument "props" must be a string or Array.'), !g(d) && !h(d) && console.error(`MUI: Argument "duration" must be a number or a string but found ${d}.`), h(c) || console.error('MUI: Argument "easing" must be a string.'), !g(f) && !h(f) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof l != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(s).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(s).join(",")}].`);
      }
      return (Array.isArray(o) ? o : [o]).map((h) => `${h} ${typeof d == "string" ? d : np(d)} ${c} ${typeof f == "string" ? f : np(f)}`).join(",");
    }
  }, e, {
    easing: n,
    duration: r
  });
}
const $w = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
}, Uw = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function zw(e = {}, ...n) {
  const {
    mixins: r = {},
    palette: a = {},
    transitions: o = {},
    typography: l = {}
  } = e, d = Ti(e, Uw);
  if (e.vars)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name." : Ns(18));
  const c = Ew(a), f = h2(e);
  let s = Tr(f, {
    mixins: rw(f.breakpoints, r),
    palette: c,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: Rw.slice(),
    typography: Ow(c, l),
    transitions: Bw(o),
    zIndex: zt({}, $w)
  });
  if (s = Tr(s, d), s = n.reduce((h, g) => Tr(h, g), s), process.env.NODE_ENV !== "production") {
    const h = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], g = (t, i) => {
      let m;
      for (m in t) {
        const v = t[m];
        if (h.indexOf(m) !== -1 && Object.keys(v).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const E = bc("", m);
            console.error([`MUI: The \`${i}\` component increases the CSS specificity of the \`${m}\` internal state.`, "You can not override it like this: ", JSON.stringify(t, null, 2), "", `Instead, you need to use the '&.${E}' syntax:`, JSON.stringify({
              root: {
                [`&.${E}`]: v
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          t[m] = {};
        }
      }
    };
    Object.keys(s.components).forEach((t) => {
      const i = s.components[t].styleOverrides;
      i && t.indexOf("Mui") === 0 && g(i, t);
    });
  }
  return s.unstable_sxConfig = zt({}, xc, d == null ? void 0 : d.unstable_sxConfig), s.unstable_sx = function(g) {
    return yf({
      sx: g,
      theme: this
    });
  }, s;
}
const Hw = zw();
var yc = {}, ku = { exports: {} }, ip;
function Ww() {
  return ip || (ip = 1, function(e) {
    function n() {
      return e.exports = n = Object.assign ? Object.assign.bind() : function(r) {
        for (var a = 1; a < arguments.length; a++) {
          var o = arguments[a];
          for (var l in o) ({}).hasOwnProperty.call(o, l) && (r[l] = o[l]);
        }
        return r;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, n.apply(null, arguments);
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(ku)), ku.exports;
}
var Eu = { exports: {} }, rp;
function qw() {
  return rp || (rp = 1, function(e) {
    function n(r, a) {
      if (r == null) return {};
      var o = {};
      for (var l in r) if ({}.hasOwnProperty.call(r, l)) {
        if (a.includes(l)) continue;
        o[l] = r[l];
      }
      return o;
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Eu)), Eu.exports;
}
const I2 = /* @__PURE__ */ vs(xv), Vw = /* @__PURE__ */ vs(bv), Xw = /* @__PURE__ */ vs(Cv), Gw = /* @__PURE__ */ vs(A4), Kw = /* @__PURE__ */ vs(f4), Yw = /* @__PURE__ */ vs(x4);
var to = w2;
Object.defineProperty(yc, "__esModule", {
  value: !0
});
var Zw = yc.default = dS;
yc.shouldForwardProp = hl;
yc.systemDefaultTheme = void 0;
var Qi = to(Ww()), Pd = to(qw()), sp = aS(I2), Qw = Vw, Jw = to(Xw), eS = to(Gw), tS = to(Kw), nS = to(Yw);
const iS = ["ownerState"], rS = ["variants"], sS = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function T2(e) {
  if (typeof WeakMap != "function") return null;
  var n = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (T2 = function(a) {
    return a ? r : n;
  })(e);
}
function aS(e, n) {
  if (e && e.__esModule) return e;
  if (e === null || typeof e != "object" && typeof e != "function") return { default: e };
  var r = T2(n);
  if (r && r.has(e)) return r.get(e);
  var a = { __proto__: null }, o = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var l in e) if (l !== "default" && Object.prototype.hasOwnProperty.call(e, l)) {
    var d = o ? Object.getOwnPropertyDescriptor(e, l) : null;
    d && (d.get || d.set) ? Object.defineProperty(a, l, d) : a[l] = e[l];
  }
  return a.default = e, r && r.set(e, a), a;
}
function oS(e) {
  return Object.keys(e).length === 0;
}
function cS(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function hl(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const lS = yc.systemDefaultTheme = (0, tS.default)(), ap = (e) => e && e.charAt(0).toLowerCase() + e.slice(1);
function Hc({
  defaultTheme: e,
  theme: n,
  themeId: r
}) {
  return oS(n) ? e : n[r] || n;
}
function uS(e) {
  return e ? (n, r) => r[e] : null;
}
function fl(e, n) {
  let {
    ownerState: r
  } = n, a = (0, Pd.default)(n, iS);
  const o = typeof e == "function" ? e((0, Qi.default)({
    ownerState: r
  }, a)) : e;
  if (Array.isArray(o))
    return o.flatMap((l) => fl(l, (0, Qi.default)({
      ownerState: r
    }, a)));
  if (o && typeof o == "object" && Array.isArray(o.variants)) {
    const {
      variants: l = []
    } = o;
    let c = (0, Pd.default)(o, rS);
    return l.forEach((f) => {
      let s = !0;
      typeof f.props == "function" ? s = f.props((0, Qi.default)({
        ownerState: r
      }, a, r)) : Object.keys(f.props).forEach((h) => {
        (r == null ? void 0 : r[h]) !== f.props[h] && a[h] !== f.props[h] && (s = !1);
      }), s && (Array.isArray(c) || (c = [c]), c.push(typeof f.style == "function" ? f.style((0, Qi.default)({
        ownerState: r
      }, a, r)) : f.style));
    }), c;
  }
  return o;
}
function dS(e = {}) {
  const {
    themeId: n,
    defaultTheme: r = lS,
    rootShouldForwardProp: a = hl,
    slotShouldForwardProp: o = hl
  } = e, l = (d) => (0, nS.default)((0, Qi.default)({}, d, {
    theme: Hc((0, Qi.default)({}, d, {
      defaultTheme: r,
      themeId: n
    }))
  }));
  return l.__mui_systemSx = !0, (d, c = {}) => {
    (0, sp.internal_processStyles)(d, (u) => u.filter((I) => !(I != null && I.__mui_systemSx)));
    const {
      name: f,
      slot: s,
      skipVariantsResolver: h,
      skipSx: g,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: t = uS(ap(s))
    } = c, i = (0, Pd.default)(c, sS), m = h !== void 0 ? h : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      s && s !== "Root" && s !== "root" || !1
    ), v = g || !1;
    let E;
    process.env.NODE_ENV !== "production" && f && (E = `${f}-${ap(s || "Root")}`);
    let S = hl;
    s === "Root" || s === "root" ? S = a : s ? S = o : cS(d) && (S = void 0);
    const y = (0, sp.default)(d, (0, Qi.default)({
      shouldForwardProp: S,
      label: E
    }, i)), x = (u) => typeof u == "function" && u.__emotion_real !== u || (0, Qw.isPlainObject)(u) ? (I) => fl(u, (0, Qi.default)({}, I, {
      theme: Hc({
        theme: I.theme,
        defaultTheme: r,
        themeId: n
      })
    })) : u, b = (u, ...I) => {
      let O = x(u);
      const D = I ? I.map(x) : [];
      f && t && D.push((H) => {
        const B = Hc((0, Qi.default)({}, H, {
          defaultTheme: r,
          themeId: n
        }));
        if (!B.components || !B.components[f] || !B.components[f].styleOverrides)
          return null;
        const R = B.components[f].styleOverrides, _ = {};
        return Object.entries(R).forEach(([A, k]) => {
          _[A] = fl(k, (0, Qi.default)({}, H, {
            theme: B
          }));
        }), t(H, _);
      }), f && !m && D.push((H) => {
        var B;
        const R = Hc((0, Qi.default)({}, H, {
          defaultTheme: r,
          themeId: n
        })), _ = R == null || (B = R.components) == null || (B = B[f]) == null ? void 0 : B.variants;
        return fl({
          variants: _
        }, (0, Qi.default)({}, H, {
          theme: R
        }));
      }), v || D.push(l);
      const $ = D.length - I.length;
      if (Array.isArray(u) && $ > 0) {
        const H = new Array($).fill("");
        O = [...u, ...H], O.raw = [...u.raw, ...H];
      }
      const K = y(O, ...D);
      if (process.env.NODE_ENV !== "production") {
        let H;
        f && (H = `${f}${(0, Jw.default)(s || "")}`), H === void 0 && (H = `Styled(${(0, eS.default)(d)})`), K.displayName = H;
      }
      return d.muiName && (K.muiName = d.muiName), K;
    };
    return y.withConfig && (b.withConfig = y.withConfig), b;
  };
}
function hS(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const O2 = (e) => hS(e) && e !== "classes", Zs = Zw({
  themeId: I6,
  defaultTheme: Hw,
  rootShouldForwardProp: O2
});
function F2(e, n) {
  return e ? e.reduce(
    (a, o, l) => {
      const d = o == null ? void 0 : o.data;
      return (d == null ? void 0 : d.status) === "unprocessable_entity" ? (d != null && d.message ? rn.error(d == null ? void 0 : d.message) : rn.error(`Could not upload ${n[l].name}.`), [...a, l]) : a;
    },
    []
  ) : [];
}
const op = ({
  value: e,
  onChange: n = () => {
  },
  ...r
}) => {
  const [a, o] = Ee({
    year: "",
    month: "",
    tags: []
  }), l = e || a, d = Oe(
    (h) => {
      o(h), n(h);
    },
    [n]
  ), c = Oe(
    (h, g) => {
      d({ ...e || a, year: g || "" });
    },
    [e, a, d]
  ), f = Oe(
    (h, g) => {
      d({ ...e || a, month: g || "" });
    },
    [e, a, d]
  ), s = Oe(
    (h, g) => {
      d({ ...e || a, tags: g || [] });
    },
    [e, a, d]
  );
  return /* @__PURE__ */ p.jsxs(Pe, { ...r, children: [
    /* @__PURE__ */ p.jsxs(Me, { display: "flex", gap: 2, children: [
      /* @__PURE__ */ p.jsx(Me, { flex: 1, children: /* @__PURE__ */ p.jsx(iy, { value: l.year || null, onChange: c }) }),
      /* @__PURE__ */ p.jsx(Me, { flex: 1, children: /* @__PURE__ */ p.jsx(ry, { value: l.month || null, onChange: f }) })
    ] }),
    /* @__PURE__ */ p.jsx(Me, { children: /* @__PURE__ */ p.jsx(sy, { value: l.tags || null, onChange: s }) })
  ] });
}, vc = {
  "image/jpeg": [".jpg", ".jpeg"],
  "image/png": [".png"],
  "image/gif": [".gif"],
  "image/tiff": [".tif", ".tiff"],
  "application/postscript": [".ps", ".eps", ".postscript", ".ai"],
  "application/pdf": [".pdf"],
  "text/plain": [
    ".txt",
    ".text",
    ".qbb",
    ".qbm",
    ".qbw",
    ".qbx",
    ".qby",
    ".qba",
    ".ptb",
    ".cab",
    ".qbo"
  ],
  "application/octect-stream": [".quickenbackup"],
  "application/msword": [".doc", ".dot"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx"
  ],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template": [
    ".dotx"
  ],
  "application/vnd.ms-word.document.macroEnabled.12": [".docm"],
  "application/vnd.ms-word.template.macroEnabled.12": [".dotm"],
  "application/vnd.ms-excel.sheet.macroEnabled.12": [".xlsm"],
  "application/vnd.ms-excel": [".xls", ".xlt", ".xla"],
  "application/vnd.ms-excel.template.macroenabled.12": [".xltm"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
    ".xlsx"
  ],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template": [
    ".xltx"
  ],
  "application/vnd.ms-excel.sheet.binary.macroenabled.12": [".xlsb"],
  "application/vnd.ms-excel.addin.macroenabled.12": [".xlam"],
  "text/csv": [".csv"],
  "text/tab-separated-values": [".tsv"],
  "application/x-zip": [".zip"],
  "audio/mpeg": [".mp3"],
  "application/vnd.intu.qfx": [".qfx"],
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": [
    ".pptx"
  ],
  "application/vnd.ms-powerpoint": [".pot", ".ppa", ".pps", ".ppt", ".pwz"],
  "application/vnd.openxmlformats-officedocument.presentationml.template": [
    ".potx"
  ],
  "application/vnd.openxmlformats-officedocument.presentationml.slideshow": [
    ".ppsx"
  ],
  "application/vnd.ms-powerpoint.presentation.macroenabled.12": [".pptm"],
  "application/vnd.ms-powerpoint.template.macroenabled.12": [".potm"],
  "application/vnd.ms-powerpoint.slideshow.macroenabled.12": [".ppsm"],
  "application/vnd.ms-powerpoint.addin.macroenabled.12": [".ppam"]
}, fS = ["bytes", "KB", "MB", "GB", "TB", "PB"], pS = (e) => cf(e || 0, { sizeTerms: fS }), gS = ({
  open: e = !1,
  onClose: n = () => {
  },
  files: r = [],
  uploadType: a,
  onUpload: o = () => {
  },
  defaultFileDetailsExpanded: l,
  hideFileDetails: d,
  isMessageAltered: c,
  linkedTaskId: f,
  isDraft: s,
  uploadDialogVariant: h = "default"
}) => {
  const g = h === "message", [t, i] = Ee({ year: "", month: "", tags: [] }), [m, v] = Ee(!1), [E, S] = Ee([]), y = Oe(
    (N) => S((q) => [...q.slice(0, N), ...q.slice(N + 1)]),
    []
  ), x = Oe(() => {
    S([]), i({ year: "", month: "", tags: [] });
  }, []), [b, u] = Ee(
    void 0
  );
  ot(() => {
    E.length === 0 && r.length > 0 && !m && (S(r.map((N) => ({ file: N }))), v(!0));
  }, [r, E, m]), ot(() => {
    e || (v(!1), x());
  }, [e, x]);
  const [I, O] = Ee(!1), D = Oe(() => O(!1), []), $ = Oe(() => {
    O(!1), n();
  }, [n]), K = Oe(() => {
    E.length ? O(!0) : n();
  }, [n, E, O]), { mutateAsync: H } = Vx({
    taskId: f,
    isDraft: s
  }), { mutateAsync: B } = Xx({
    taskId: f
  }), { mutate: R, isLoading: _ } = Ln({
    mutationFn: async () => {
      try {
        const N = await B({
          documents: E.map((oe) => oe.file),
          taskId: f,
          uploadType: a,
          onUploadProgress: (oe) => {
            S(
              (fe) => fe.map((Y) => ({
                ...Y,
                uploadProgress: oe[mu(Y.file)]
              }))
            );
          },
          // Map AbortController for files
          setCancelController: (oe) => {
            S(
              (fe) => fe.map((Y) => ({
                ...Y,
                abortController: oe[mu(Y.file)]
              }))
            );
          }
        });
        F2(
          N,
          E.map((oe) => oe.file)
        );
        const q = (N == null ? void 0 : N.map(
          ({ data: oe }) => ({
            ...oe.data,
            attachment_origin: "direct_upload"
          })
        )) || [], ie = (q == null ? void 0 : q.map(
          (oe) => oe == null ? void 0 : oe.id
        )) || [];
        await H({
          doc_ids: ie,
          formValues: {
            year: t.year,
            month: t.month,
            // This is why we keep our request and response contracts separate from each other:
            // These RichOptions will just  be "munged" back into a string[] prior to request dispatch...
            tags: t.tags.map((oe) => ({ label: "", value: oe })),
            files: [],
            file_name: "",
            message: ""
          },
          isMessageAltered: c
        }), await o(q || []);
      } catch (N) {
        const q = Q8(
          N,
          "Something went wrong with this file upload."
        );
        rn.error(String(q));
      }
      n();
    }
  }), A = Oe(
    (N, q) => {
      if (!_ && N.uploadProgress === void 0)
        return () => y(q);
      if (N.uploadProgress !== void 0 && N.uploadProgress < 100)
        return () => {
          var ie, oe;
          return (oe = (ie = N.abortController) == null ? void 0 : ie.abort) == null ? void 0 : oe.call(ie);
        };
    },
    [_, y]
  ), k = Tt(
    () => E.map((N, q) => {
      var ie;
      return {
        key: mu(N.file),
        filename: N.file.name,
        mimeType: N.file.type,
        size: N.file.size,
        onCancel: A(N, q),
        onClick: () => u(q),
        progress: _ ? N.uploadProgress || 0 : void 0,
        uploadCancelled: (ie = N.abortController) == null ? void 0 : ie.signal.aborted
      };
    }),
    [E, _, A]
  ), {
    getRootProps: z,
    getInputProps: T,
    open: w
  } = fc({
    noClick: !0,
    onDrop: (N, q) => {
      q.forEach(
        (ie) => rn.error(yx(ie.file))
      ), S([...E, ...N.map((ie) => ({ file: ie }))]);
    },
    noDragEventsBubbling: !0,
    disabled: _,
    accept: vc
  }), [F, j] = Ee(!1), [P, V] = Ee([]), {
    data: J,
    fetchNextPage: ne,
    isFetchingNextPage: Z
  } = zx(
    {
      sortBy: "created_at",
      sortOrder: "desc",
      tags: [],
      showArchived: !1
    },
    { enabled: !g }
  ), te = ((J == null ? void 0 : J.pages) || []).flatMap((N) => (N == null ? void 0 : N.documents) || []).filter(Boolean), G = (N) => {
    V(
      (q) => q.includes(N) ? q.filter((ie) => ie !== N) : [...q, N]
    );
  };
  return /* @__PURE__ */ p.jsxs(
    oi,
    {
      open: e,
      onClose: K,
      title: g ? /* @__PURE__ */ p.jsx(
        Me,
        {
          component: "span",
          "data-testid": "upload-dialog-accessible-title",
          sx: {
            position: "absolute",
            width: "1px",
            height: "1px",
            p: 0,
            m: "-1px",
            overflow: "hidden",
            clip: "rect(0 0 0 0)",
            whiteSpace: "nowrap",
            border: 0
          },
          children: "Upload File(s)"
        }
      ) : "Upload File(s)",
      onSubmit: g ? void 0 : R,
      submitLabel: g ? void 0 : "Upload",
      submitBtnProps: g ? void 0 : { disabled: _ || !E.length },
      onCancel: g ? void 0 : K,
      cancelBtnProps: g ? void 0 : { disabled: _ },
      actions: g ? /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
        /* @__PURE__ */ p.jsx(
          lt,
          {
            variant: "outlined",
            color: "primary",
            disabled: _,
            onClick: K,
            sx: { width: { xs: "100%", sm: 160 } },
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ p.jsx(
          lt,
          {
            variant: "contained",
            color: "primary",
            disabled: _ || !E.length,
            onClick: () => R(),
            sx: { width: { xs: "100%", sm: 164 } },
            children: "Upload"
          }
        )
      ] }) : void 0,
      actionsProps: g ? {
        sx: {
          borderTop: 1,
          borderColor: "divider",
          gap: 2,
          mx: 1,
          pt: 2,
          flexWrap: "wrap",
          "& > :not(style) ~ :not(style)": { ml: 0 }
        }
      } : void 0,
      contentProps: g ? { sx: { p: { xs: 1, sm: 3 }, pb: { xs: 2, sm: 3 } } } : void 0,
      iconClose: !1,
      BackdropProps: g ? {
        sx: {
          backgroundColor: (N) => b2(N.palette.common.black, 0.12)
        }
      } : void 0,
      TransitionProps: { onExited: x },
      ...g ? {
        fullWidth: !0,
        maxWidth: "md"
      } : {},
      children: [
        g ? /* @__PURE__ */ p.jsxs(Pe, { sx: { gap: 2 }, "data-testid": "message-upload-dialog-content", children: [
          /* @__PURE__ */ p.jsx(
            Xo,
            {
              ...z(),
              "data-testid": "message-upload-dropzone",
              onBrowse: w,
              hideFilesList: !0,
              children: /* @__PURE__ */ p.jsx(
                "input",
                {
                  "data-testid": "upload-documents-dialog-input",
                  ...T()
                }
              )
            }
          ),
          k.length > 0 && /* @__PURE__ */ p.jsx(Pe, { sx: { gap: 1 }, "data-testid": "dnd-attachments", children: k.map(({ key: N, filename: q, ...ie }) => /* @__PURE__ */ By(
            d0,
            {
              ...ie,
              key: N,
              "data-testid": "message-upload-file-row",
              filename: q,
              sizeFormat: pS,
              filenameProps: {
                title: typeof q == "string" ? q : void 0,
                "aria-label": typeof q == "string" ? `File name: ${q}` : void 0
              },
              cancelBtnProps: {
                "aria-label": typeof q == "string" ? `Remove ${q}` : "Remove file",
                title: typeof q == "string" ? `Remove ${q}` : "Remove file"
              },
              sx: { borderRadius: 0 }
            }
          )) }),
          !d && /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
            /* @__PURE__ */ p.jsx(wn, {}),
            /* @__PURE__ */ p.jsx(
              yd,
              {
                summary: "File Details",
                detailsProps: { sx: { px: 0 } },
                defaultExpanded: l,
                summaryProps: { sx: { px: 0 } },
                sx: { "&:before": { display: "none" } },
                children: /* @__PURE__ */ p.jsx(
                  op,
                  {
                    value: t,
                    onChange: i
                  }
                )
              }
            )
          ] })
        ] }) : /* @__PURE__ */ p.jsxs(Me, { children: [
          /* @__PURE__ */ p.jsxs(
            Pe,
            {
              direction: "row",
              sx: { justifyContent: "space-between", mb: 2 },
              children: [
                /* @__PURE__ */ p.jsx("div", {}),
                /* @__PURE__ */ p.jsx(
                  lt,
                  {
                    variant: "text",
                    onClick: () => j((N) => !N),
                    children: F ? "Close Liscio Vault" : "Attach from Liscio Vault"
                  }
                )
              ]
            }
          ),
          F && /* @__PURE__ */ p.jsxs(Me, { sx: { maxHeight: 300, overflow: "auto", mb: 2 }, children: [
            te.map((N) => /* @__PURE__ */ p.jsxs(
              Pe,
              {
                direction: "row",
                sx: {
                  justifyContent: "space-between",
                  alignItems: "center",
                  py: 0.5
                },
                children: [
                  /* @__PURE__ */ p.jsx("span", { children: N.doc_name }),
                  /* @__PURE__ */ p.jsx(
                    "input",
                    {
                      type: "checkbox",
                      checked: P.includes(N.id),
                      onChange: () => G(N.id)
                    }
                  )
                ]
              },
              N.id
            )),
            /* @__PURE__ */ p.jsx(
              lt,
              {
                variant: "text",
                disabled: Z,
                onClick: () => ne(),
                children: "Load more"
              }
            ),
            /* @__PURE__ */ p.jsx(
              lt,
              {
                sx: { mt: 1 },
                variant: "contained",
                onClick: () => {
                  const N = te.filter(
                    (q) => P.includes(q.id)
                  ).map((q) => ({
                    ...q,
                    attachment_origin: "liscio_vault"
                  }));
                  o(N), j(!1);
                },
                children: "Attach selected"
              }
            )
          ] }),
          !d && /* @__PURE__ */ p.jsx(
            yd,
            {
              summary: "File Details",
              detailsProps: { sx: { px: 0 } },
              sx: { mb: 2 },
              defaultExpanded: l,
              children: /* @__PURE__ */ p.jsx(
                op,
                {
                  value: t,
                  onChange: i
                }
              )
            }
          ),
          /* @__PURE__ */ p.jsx(Me, { children: /* @__PURE__ */ p.jsx(
            Xo,
            {
              ...z(),
              onBrowse: w,
              attachments: k,
              children: /* @__PURE__ */ p.jsx(
                "input",
                {
                  "data-testid": "upload-documents-dialog-input",
                  ...T()
                }
              )
            }
          ) })
        ] }),
        /* @__PURE__ */ p.jsx(
          oi,
          {
            open: e && I,
            title: "Are you sure you want to cancel?",
            onClose: D,
            onCancel: D,
            cancelLabel: "No",
            submitLabel: "Yes",
            onSubmit: $,
            fullWidth: !1,
            children: "This action cannot be undone. Proceed?"
          }
        ),
        /* @__PURE__ */ p.jsx(
          oi,
          {
            maxWidth: !1,
            open: b !== void 0,
            onClose: () => u(void 0),
            title: b !== void 0 && E[b].file.name,
            children: b !== void 0 && /* @__PURE__ */ p.jsx(Z3, { file: E[b].file })
          }
        )
      ]
    }
  );
}, P2 = (e) => {
  const n = On.getPlatform();
  let r = "";
  return n === "ios" ? r = 'You can find your file in the  "Files" app. Either search for it by name or open the Liscio folder in the "On my iPhone" section.' : n === "android" && (r = 'You can find your file in the  "My Files" app in the "Recent Downloads" section.'), {
    onSuccess: () => rn.success(`${e} downloaded. ${r}`),
    onError: () => rn.error(`There was a problem downloading ${e}.`)
  };
};
function j2(e) {
  rn.error(yx(e));
}
const R2 = ({
  name: e,
  label: n,
  error: r,
  uploadType: a,
  onChange: o = () => {
  },
  value: l,
  defaultFileDetailsExpanded: d = !1,
  hideFileDetails: c,
  linkedTaskId: f,
  hideFilesList: s,
  disabled: h = !1,
  isMessageAltered: g,
  isDraft: t,
  onVaultClick: i,
  showLabeledActions: m = !1,
  renderPreview: v,
  canPreviewAttachment: E,
  onDeletePersistedAttachment: S,
  uploadDialogVariant: y
}) => {
  var N;
  const [x, b] = Ee(l || []), u = l || x, I = Oe(
    (q) => {
      b(q), o(q);
    },
    [o]
  ), [O, D] = Ee([]), [$, K] = Ee(), H = Tt(
    () => $ !== void 0 && u[$],
    [$, u]
  ), [B, R] = Ee(!1), _ = Oe(
    () => R(!0),
    []
  ), A = Oe(() => {
    R(!1), D([]);
  }, []), k = Oe(
    (q, ie) => {
      ie.forEach(
        (oe) => j2(oe.file)
      ), D(q), _();
    },
    [_]
  ), {
    getInputProps: z,
    getRootProps: T,
    open: w
  } = fc({
    onDrop: k,
    noClick: !0,
    noDragEventsBubbling: !0,
    accept: vc,
    disabled: h
  }), [F, j] = Ee(), P = Oe(() => j(void 0), []), { mutateAsync: V, isLoading: J } = qx(), [ne, Z] = Ee(!1), te = Oe(async () => {
    if (F !== void 0) {
      const q = u[F];
      if (q) {
        if (!q.id) {
          rn.error(
            "Unable to delete this attachment. Please refresh and try again."
          );
          return;
        }
        try {
          S ? (Z(!0), await S(q)) : await V({
            messageId: "",
            documentId: q.id,
            docType: "Request"
          }), I([
            ...u.slice(0, F),
            ...u.slice(F + 1)
          ]), j(void 0);
        } catch (ie) {
          console.error("Failed to delete attachment:", ie), rn.error("Unable to delete this attachment. Please try again.");
        } finally {
          Z(!1);
        }
      }
    }
  }, [
    F,
    V,
    u,
    I,
    S
  ]), G = u.map((q, ie) => ({ attachment: q, index: ie })).filter(({ attachment: q }) => !!q);
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsx(
      Zm,
      {
        name: e,
        label: n,
        error: r,
        onClick: (q) => q.preventDefault(),
        disabled: h,
        children: /* @__PURE__ */ p.jsx(
          Xo,
          {
            ...T(),
            onBrowse: w,
            onVaultClick: i,
            vaultDisabled: h,
            attachments: G.map(({ attachment: q, index: ie }) => ({
              filename: q.name || q.doc_name || "",
              size: q.file_size || 0,
              ...m ? {
                onDelete: h ? void 0 : () => j(ie),
                onPreview: !h && q.id && q.is_active !== !1 && ((E == null ? void 0 : E(q)) ?? !0) ? () => K(ie) : void 0
              } : {
                onCancel: h ? void 0 : () => j(ie),
                onClick: !h && q.id ? () => K(ie) : void 0
              }
            })),
            hideFilesList: s,
            children: /* @__PURE__ */ p.jsx(
              "input",
              {
                "data-testid": "file-attachments-field-input",
                ...z()
              }
            )
          }
        )
      }
    ),
    /* @__PURE__ */ p.jsx(
      gS,
      {
        open: B,
        onClose: A,
        files: O,
        uploadType: a,
        onUpload: (q) => I([...u, ...q]),
        defaultFileDetailsExpanded: d,
        hideFileDetails: c,
        linkedTaskId: f,
        isMessageAltered: g,
        isDraft: t,
        uploadDialogVariant: y
      }
    ),
    /* @__PURE__ */ p.jsx(
      oi,
      {
        open: F !== void 0,
        onClose: P,
        title: "Delete Attachment",
        submitLabel: "Yes",
        onSubmit: te,
        cancelLabel: "No",
        onCancel: P,
        children: /* @__PURE__ */ p.jsxs(Te, { children: [
          "You are about to delete the attached file",
          " ",
          /* @__PURE__ */ p.jsx("b", { children: (N = u[F]) == null ? void 0 : N.doc_name }),
          ". This action cannot be undone. Proceed?"
        ] })
      }
    ),
    /* @__PURE__ */ p.jsx(mi, { open: J || ne }),
    /* @__PURE__ */ p.jsx(
      oi,
      {
        maxWidth: !1,
        layout: v ? "documentPreview" : void 0,
        open: !!H,
        onClose: () => K(void 0),
        title: v ? "Preview" : H && H.doc_name,
        contentProps: v ? void 0 : { sx: { p: 0 } },
        children: H && H.id && (v ? v(H) : /* @__PURE__ */ p.jsx(Y3, { documentId: H.id }))
      }
    )
  ] });
}, nB = ({
  name: e,
  isMessageAltered: n,
  ...r
}) => {
  var l;
  const { field: a, fieldState: o } = Vr({ name: e });
  return /* @__PURE__ */ p.jsx(
    R2,
    {
      error: (l = o.error) == null ? void 0 : l.message,
      ...r,
      name: a.name,
      onChange: a.onChange,
      value: a.value,
      isMessageAltered: n
    }
  );
}, cp = ({
  onNavigationClick: e,
  onSecondaryActionClick: n,
  children: r,
  title: a
}) => {
  const o = /* @__PURE__ */ p.jsx(
    Gn,
    {
      "aria-label": "Navigation",
      size: "large",
      onClick: n,
      children: /* @__PURE__ */ p.jsx(it, { icon: "ellipsis" })
    }
  );
  return /* @__PURE__ */ p.jsx(
    Ys,
    {
      onNavigationClick: e,
      title: a,
      children: r,
      secondaryActionChildren: o
    }
  );
}, mS = ({
  onNavigationClick: e,
  onSecondaryActionClick: n,
  hideSecondaryActionButton: r,
  children: a,
  title: o
}) => {
  const l = r ? null : /* @__PURE__ */ p.jsx(
    lt,
    {
      variant: "outlined",
      color: "inherit",
      "aria-haspopup": "dialog",
      endIcon: /* @__PURE__ */ p.jsx(it, { icon: "chevronDown", fontSize: "small" }),
      onClick: n,
      sx: {
        height: 44,
        px: 2,
        flexShrink: 0,
        whiteSpace: "nowrap",
        textTransform: "none",
        color: "text.primary",
        borderColor: "divider",
        "&:hover": { borderColor: "divider", bgcolor: "action.hover" },
        "&.Mui-focusVisible": {
          outline: 2,
          outlineColor: "primary.main",
          outlineOffset: 2
        }
      },
      children: "Actions"
    }
  );
  return /* @__PURE__ */ p.jsx(
    Ys,
    {
      onNavigationClick: e,
      title: o,
      children: a,
      secondaryActionChildren: l
    }
  );
};
var M2 = { exports: {} };
(function(e, n) {
  (function(a, o) {
    e.exports = a.pdfjsWorker = o();
  })(globalThis, () => (
    /******/
    (() => {
      var r = [
        ,
        /* 1 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.WorkerTask = c.WorkerMessageHandler = void 0;
          var s = f(2), h = f(3), g = f(4), t = f(6), i = f(10), m = f(68), v = f(73), E = f(104), S = f(105), y = f(72);
          class x {
            constructor(O) {
              this.name = O, this.terminated = !1, this._capability = new s.PromiseCapability();
            }
            get finished() {
              return this._capability.promise;
            }
            finish() {
              this._capability.resolve();
            }
            terminate() {
              this.terminated = !0;
            }
            ensureNotTerminated() {
              if (this.terminated)
                throw new Error("Worker task was terminated");
            }
          }
          c.WorkerTask = x;
          class b {
            static setup(O, D) {
              let $ = !1;
              O.on("test", function(K) {
                $ || ($ = !0, O.send("test", K instanceof Uint8Array));
              }), O.on("configure", function(K) {
                (0, s.setVerbosityLevel)(K.verbosity);
              }), O.on("GetDocRequest", function(K) {
                return b.createDocumentHandler(K, D);
              });
            }
            static createDocumentHandler(O, D) {
              let $, K = !1, H = null;
              const B = /* @__PURE__ */ new Set(), R = (0, s.getVerbosityLevel)(), {
                docId: _,
                apiVersion: A
              } = O, k = "3.11.174";
              if (A !== k)
                throw new Error(`The API version "${A}" does not match the Worker version "${k}".`);
              const z = [];
              for (const Z in [])
                z.push(Z);
              if (z.length)
                throw new Error("The `Array.prototype` contains unexpected enumerable properties: " + z.join(", ") + "; thus breaking e.g. `for...in` iteration of `Array`s.");
              const T = _ + "_worker";
              let w = new E.MessageHandler(T, _, D);
              function F() {
                if (K)
                  throw new Error("Worker was terminated");
              }
              function j(Z) {
                B.add(Z);
              }
              function P(Z) {
                Z.finish(), B.delete(Z);
              }
              async function V(Z) {
                await $.ensureDoc("checkHeader"), await $.ensureDoc("parseStartXRef"), await $.ensureDoc("parse", [Z]), await $.ensureDoc("checkFirstPage", [Z]), await $.ensureDoc("checkLastPage", [Z]);
                const te = await $.ensureDoc("isPureXfa");
                if (te) {
                  const ie = new x("loadXfaFonts");
                  j(ie), await Promise.all([$.loadXfaFonts(w, ie).catch((oe) => {
                  }).then(() => P(ie)), $.loadXfaImages()]);
                }
                const [G, N] = await Promise.all([$.ensureDoc("numPages"), $.ensureDoc("fingerprints")]), q = te ? await $.ensureDoc("htmlForXfa") : null;
                return {
                  numPages: G,
                  fingerprints: N,
                  htmlForXfa: q
                };
              }
              function J({
                data: Z,
                password: te,
                disableAutoFetch: G,
                rangeChunkSize: N,
                length: q,
                docBaseUrl: ie,
                enableXfa: oe,
                evaluatorOptions: fe
              }) {
                const Y = {
                  source: null,
                  disableAutoFetch: G,
                  docBaseUrl: ie,
                  docId: _,
                  enableXfa: oe,
                  evaluatorOptions: fe,
                  handler: w,
                  length: q,
                  password: te,
                  rangeChunkSize: N
                }, ae = new s.PromiseCapability();
                let se;
                if (Z) {
                  try {
                    Y.source = Z, se = new t.LocalPdfManager(Y), ae.resolve(se);
                  } catch (Q) {
                    ae.reject(Q);
                  }
                  return ae.promise;
                }
                let L, W = [];
                try {
                  L = new S.PDFWorkerStream(w);
                } catch (Q) {
                  return ae.reject(Q), ae.promise;
                }
                const M = L.getFullReader();
                M.headersReady.then(function() {
                  if (M.isRangeSupported) {
                    Y.source = L, Y.length = M.contentLength, Y.disableAutoFetch || (Y.disableAutoFetch = M.isStreamingSupported), se = new t.NetworkPdfManager(Y);
                    for (const Q of W)
                      se.sendProgressiveData(Q);
                    W = [], ae.resolve(se), H = null;
                  }
                }).catch(function(Q) {
                  ae.reject(Q), H = null;
                });
                let X = 0;
                const U = function() {
                  const Q = (0, h.arrayBuffersToBytes)(W);
                  q && Q.length !== q && (0, s.warn)("reported HTTP length is different from actual");
                  try {
                    Y.source = Q, se = new t.LocalPdfManager(Y), ae.resolve(se);
                  } catch (re) {
                    ae.reject(re);
                  }
                  W = [];
                };
                return new Promise(function(Q, re) {
                  const le = function({
                    value: ce,
                    done: ee
                  }) {
                    try {
                      if (F(), ee) {
                        se || U(), H = null;
                        return;
                      }
                      X += ce.byteLength, M.isStreamingSupported || w.send("DocProgress", {
                        loaded: X,
                        total: Math.max(X, M.contentLength || 0)
                      }), se ? se.sendProgressiveData(ce) : W.push(ce), M.read().then(le, re);
                    } catch (he) {
                      re(he);
                    }
                  };
                  M.read().then(le, re);
                }).catch(function(Q) {
                  ae.reject(Q), H = null;
                }), H = function(Q) {
                  L.cancelAllRequests(Q);
                }, ae.promise;
              }
              function ne(Z) {
                function te(q) {
                  F(), w.send("GetDoc", {
                    pdfInfo: q
                  });
                }
                function G(q) {
                  if (F(), q instanceof s.PasswordException) {
                    const ie = new x(`PasswordException: response ${q.code}`);
                    j(ie), w.sendWithPromise("PasswordRequest", q).then(function({
                      password: oe
                    }) {
                      P(ie), $.updatePassword(oe), N();
                    }).catch(function() {
                      P(ie), w.send("DocException", q);
                    });
                  } else q instanceof s.InvalidPDFException || q instanceof s.MissingPDFException || q instanceof s.UnexpectedResponseException || q instanceof s.UnknownErrorException ? w.send("DocException", q) : w.send("DocException", new s.UnknownErrorException(q.message, q.toString()));
                }
                function N() {
                  F(), V(!1).then(te, function(q) {
                    if (F(), !(q instanceof h.XRefParseException)) {
                      G(q);
                      return;
                    }
                    $.requestLoadedStream().then(function() {
                      F(), V(!0).then(te, G);
                    });
                  });
                }
                F(), J(Z).then(function(q) {
                  if (K)
                    throw q.terminate(new s.AbortException("Worker was terminated.")), new Error("Worker was terminated");
                  $ = q, $.requestLoadedStream(!0).then((ie) => {
                    w.send("DataLoaded", {
                      length: ie.bytes.byteLength
                    });
                  });
                }).then(N, G);
              }
              return w.on("GetPage", function(Z) {
                return $.getPage(Z.pageIndex).then(function(te) {
                  return Promise.all([$.ensure(te, "rotate"), $.ensure(te, "ref"), $.ensure(te, "userUnit"), $.ensure(te, "view")]).then(function([G, N, q, ie]) {
                    return {
                      rotate: G,
                      ref: N,
                      userUnit: q,
                      view: ie
                    };
                  });
                });
              }), w.on("GetPageIndex", function(Z) {
                const te = g.Ref.get(Z.num, Z.gen);
                return $.ensureCatalog("getPageIndex", [te]);
              }), w.on("GetDestinations", function(Z) {
                return $.ensureCatalog("destinations");
              }), w.on("GetDestination", function(Z) {
                return $.ensureCatalog("getDestination", [Z.id]);
              }), w.on("GetPageLabels", function(Z) {
                return $.ensureCatalog("pageLabels");
              }), w.on("GetPageLayout", function(Z) {
                return $.ensureCatalog("pageLayout");
              }), w.on("GetPageMode", function(Z) {
                return $.ensureCatalog("pageMode");
              }), w.on("GetViewerPreferences", function(Z) {
                return $.ensureCatalog("viewerPreferences");
              }), w.on("GetOpenAction", function(Z) {
                return $.ensureCatalog("openAction");
              }), w.on("GetAttachments", function(Z) {
                return $.ensureCatalog("attachments");
              }), w.on("GetDocJSActions", function(Z) {
                return $.ensureCatalog("jsActions");
              }), w.on("GetPageJSActions", function({
                pageIndex: Z
              }) {
                return $.getPage(Z).then(function(te) {
                  return $.ensure(te, "jsActions");
                });
              }), w.on("GetOutline", function(Z) {
                return $.ensureCatalog("documentOutline");
              }), w.on("GetOptionalContentConfig", function(Z) {
                return $.ensureCatalog("optionalContentConfig");
              }), w.on("GetPermissions", function(Z) {
                return $.ensureCatalog("permissions");
              }), w.on("GetMetadata", function(Z) {
                return Promise.all([$.ensureDoc("documentInfo"), $.ensureCatalog("metadata")]);
              }), w.on("GetMarkInfo", function(Z) {
                return $.ensureCatalog("markInfo");
              }), w.on("GetData", function(Z) {
                return $.requestLoadedStream().then(function(te) {
                  return te.bytes;
                });
              }), w.on("GetAnnotations", function({
                pageIndex: Z,
                intent: te
              }) {
                return $.getPage(Z).then(function(G) {
                  const N = new x(`GetAnnotations: page ${Z}`);
                  return j(N), G.getAnnotationsData(w, N, te).then((q) => (P(N), q), (q) => {
                    throw P(N), q;
                  });
                });
              }), w.on("GetFieldObjects", function(Z) {
                return $.ensureDoc("fieldObjects");
              }), w.on("HasJSActions", function(Z) {
                return $.ensureDoc("hasJSActions");
              }), w.on("GetCalculationOrderIds", function(Z) {
                return $.ensureDoc("calculationOrderIds");
              }), w.on("SaveDocument", async function({
                isPureXfa: Z,
                numPages: te,
                annotationStorage: G,
                filename: N
              }) {
                const q = [$.requestLoadedStream(), $.ensureCatalog("acroForm"), $.ensureCatalog("acroFormRef"), $.ensureDoc("startXRef"), $.ensureDoc("xref"), $.ensureDoc("linearization"), $.ensureCatalog("structTreeRoot")], ie = [], oe = Z ? null : (0, h.getNewAnnotationsMap)(G), [fe, Y, ae, se, L, W, M] = await Promise.all(q), X = L.trailer.getRaw("Root") || null;
                let U;
                if (oe) {
                  M ? await M.canUpdateStructTree({
                    pdfManager: $,
                    newAnnotationsByPage: oe
                  }) && (U = M) : await y.StructTreeRoot.canCreateStructureTree({
                    catalogRef: X,
                    pdfManager: $,
                    newAnnotationsByPage: oe
                  }) && (U = null);
                  const ge = i.AnnotationFactory.generateImages(G.values(), L, $.evaluatorOptions.isOffscreenCanvasSupported), me = U === void 0 ? ie : [];
                  for (const [xe, ye] of oe)
                    me.push($.getPage(xe).then((ve) => {
                      const Ce = new x(`Save (editor): page ${xe}`);
                      return ve.saveNewAnnotations(w, Ce, ye, ge).finally(function() {
                        P(Ce);
                      });
                    }));
                  U === null ? ie.push(Promise.all(me).then(async (xe) => (await y.StructTreeRoot.createStructureTree({
                    newAnnotationsByPage: oe,
                    xref: L,
                    catalogRef: X,
                    pdfManager: $,
                    newRefs: xe
                  }), xe))) : U && ie.push(Promise.all(me).then(async (xe) => (await U.updateStructureTree({
                    newAnnotationsByPage: oe,
                    pdfManager: $,
                    newRefs: xe
                  }), xe)));
                }
                if (Z)
                  ie.push($.serializeXfaData(G));
                else
                  for (let ge = 0; ge < te; ge++)
                    ie.push($.getPage(ge).then(function(me) {
                      const xe = new x(`Save: page ${ge}`);
                      return me.save(w, xe, G).finally(function() {
                        P(xe);
                      });
                    }));
                const Q = await Promise.all(ie);
                let re = [], le = null;
                if (Z) {
                  if (le = Q[0], !le)
                    return fe.bytes;
                } else if (re = Q.flat(2), re.length === 0)
                  return fe.bytes;
                const ce = ae && Y instanceof g.Dict && re.some((ge) => ge.needAppearances), ee = Y instanceof g.Dict && Y.get("XFA") || null;
                let he = null, pe = !1;
                if (Array.isArray(ee)) {
                  for (let ge = 0, me = ee.length; ge < me; ge += 2)
                    ee[ge] === "datasets" && (he = ee[ge + 1], pe = !0);
                  he === null && (he = L.getNewTemporaryRef());
                } else ee && (0, s.warn)("Unsupported XFA type.");
                let de = /* @__PURE__ */ Object.create(null);
                if (L.trailer) {
                  const ge = /* @__PURE__ */ Object.create(null), me = L.trailer.get("Info") || null;
                  me instanceof g.Dict && me.forEach((xe, ye) => {
                    typeof ye == "string" && (ge[xe] = (0, s.stringToPDFString)(ye));
                  }), de = {
                    rootRef: X,
                    encryptRef: L.trailer.getRaw("Encrypt") || null,
                    newRef: L.getNewTemporaryRef(),
                    infoRef: L.trailer.getRaw("Info") || null,
                    info: ge,
                    fileIds: L.trailer.get("ID") || null,
                    startXRef: W ? se : L.lastXRefStreamPos ?? se,
                    filename: N
                  };
                }
                return (0, v.incrementalUpdate)({
                  originalData: fe.bytes,
                  xrefInfo: de,
                  newRefs: re,
                  xref: L,
                  hasXfa: !!ee,
                  xfaDatasetsRef: he,
                  hasXfaDatasetsEntry: pe,
                  needAppearances: ce,
                  acroFormRef: ae,
                  acroForm: Y,
                  xfaData: le
                }).finally(() => {
                  L.resetNewTemporaryRef();
                });
              }), w.on("GetOperatorList", function(Z, te) {
                const G = Z.pageIndex;
                $.getPage(G).then(function(N) {
                  const q = new x(`GetOperatorList: page ${G}`);
                  j(q);
                  const ie = R >= s.VerbosityLevel.INFOS ? Date.now() : 0;
                  N.getOperatorList({
                    handler: w,
                    sink: te,
                    task: q,
                    intent: Z.intent,
                    cacheKey: Z.cacheKey,
                    annotationStorage: Z.annotationStorage
                  }).then(function(oe) {
                    P(q), ie && (0, s.info)(`page=${G + 1} - getOperatorList: time=${Date.now() - ie}ms, len=${oe.length}`), te.close();
                  }, function(oe) {
                    P(q), !q.terminated && te.error(oe);
                  });
                });
              }), w.on("GetTextContent", function(Z, te) {
                const {
                  pageIndex: G,
                  includeMarkedContent: N,
                  disableNormalization: q
                } = Z;
                $.getPage(G).then(function(ie) {
                  const oe = new x("GetTextContent: page " + G);
                  j(oe);
                  const fe = R >= s.VerbosityLevel.INFOS ? Date.now() : 0;
                  ie.extractTextContent({
                    handler: w,
                    task: oe,
                    sink: te,
                    includeMarkedContent: N,
                    disableNormalization: q
                  }).then(function() {
                    P(oe), fe && (0, s.info)(`page=${G + 1} - getTextContent: time=${Date.now() - fe}ms`), te.close();
                  }, function(Y) {
                    P(oe), !oe.terminated && te.error(Y);
                  });
                });
              }), w.on("GetStructTree", function(Z) {
                return $.getPage(Z.pageIndex).then(function(te) {
                  return $.ensure(te, "getStructTree");
                });
              }), w.on("FontFallback", function(Z) {
                return $.fontFallback(Z.id, w);
              }), w.on("Cleanup", function(Z) {
                return $.cleanup(!0);
              }), w.on("Terminate", function(Z) {
                K = !0;
                const te = [];
                if ($) {
                  $.terminate(new s.AbortException("Worker was terminated."));
                  const G = $.cleanup();
                  te.push(G), $ = null;
                } else
                  (0, m.clearGlobalCaches)();
                H && H(new s.AbortException("Worker was terminated."));
                for (const G of B)
                  te.push(G.finished), G.terminate();
                return Promise.all(te).then(function() {
                  w.destroy(), w = null;
                });
              }), w.on("Ready", function(Z) {
                ne(O), O = null;
              }), T;
            }
            static initializeFromPort(O) {
              const D = new E.MessageHandler("worker", "main", O);
              b.setup(D, O), D.send("ready", null);
            }
          }
          c.WorkerMessageHandler = b;
          function u(I) {
            return typeof I.postMessage == "function" && "onmessage" in I;
          }
          typeof window > "u" && !s.isNodeJS && typeof self < "u" && u(self) && b.initializeFromPort(self);
        },
        /* 2 */
        /***/
        (d, c) => {
          var Be;
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.VerbosityLevel = c.Util = c.UnknownErrorException = c.UnexpectedResponseException = c.TextRenderingMode = c.RenderingIntentFlag = c.PromiseCapability = c.PermissionFlag = c.PasswordResponses = c.PasswordException = c.PageActionEventType = c.OPS = c.MissingPDFException = c.MAX_IMAGE_SIZE_TO_CACHE = c.LINE_FACTOR = c.LINE_DESCENT_FACTOR = c.InvalidPDFException = c.ImageKind = c.IDENTITY_MATRIX = c.FormatError = c.FeatureTest = c.FONT_IDENTITY_MATRIX = c.DocumentActionEventType = c.CMapCompressionType = c.BaseException = c.BASELINE_FACTOR = c.AnnotationType = c.AnnotationReplyType = c.AnnotationPrefix = c.AnnotationMode = c.AnnotationFlag = c.AnnotationFieldFlag = c.AnnotationEditorType = c.AnnotationEditorPrefix = c.AnnotationEditorParamsType = c.AnnotationBorderStyleType = c.AnnotationActionEventType = c.AbortException = void 0, c.assert = ne, c.bytesToString = L, c.createValidAbsoluteUrl = te, c.getModificationDate = ye, c.getUuid = Se, c.getVerbosityLevel = j, c.info = P, c.isArrayBuffer = me, c.isArrayEqual = xe, c.isNodeJS = void 0, c.normalizeUnicode = Ae, c.objectFromMap = U, c.objectSize = X, c.setVerbosityLevel = F, c.shadow = G, c.string32 = M, c.stringToBytes = W, c.stringToPDFString = pe, c.stringToUTF8String = de, c.unreachable = J, c.utf8StringToString = ge, c.warn = V;
          const f = typeof process == "object" && process + "" == "[object process]" && !process.versions.nw && !(process.versions.electron && process.type && process.type !== "browser");
          c.isNodeJS = f;
          const s = [1, 0, 0, 1, 0, 0];
          c.IDENTITY_MATRIX = s;
          const h = [1e-3, 0, 0, 1e-3, 0, 0];
          c.FONT_IDENTITY_MATRIX = h;
          const g = 1e7;
          c.MAX_IMAGE_SIZE_TO_CACHE = g;
          const t = 1.35;
          c.LINE_FACTOR = t;
          const i = 0.35;
          c.LINE_DESCENT_FACTOR = i;
          const m = i / t;
          c.BASELINE_FACTOR = m;
          const v = {
            ANY: 1,
            DISPLAY: 2,
            PRINT: 4,
            SAVE: 8,
            ANNOTATIONS_FORMS: 16,
            ANNOTATIONS_STORAGE: 32,
            ANNOTATIONS_DISABLE: 64,
            OPLIST: 256
          };
          c.RenderingIntentFlag = v;
          const E = {
            DISABLE: 0,
            ENABLE: 1,
            ENABLE_FORMS: 2,
            ENABLE_STORAGE: 3
          };
          c.AnnotationMode = E;
          const S = "pdfjs_internal_editor_";
          c.AnnotationEditorPrefix = S;
          const y = {
            DISABLE: -1,
            NONE: 0,
            FREETEXT: 3,
            STAMP: 13,
            INK: 15
          };
          c.AnnotationEditorType = y;
          const x = {
            RESIZE: 1,
            CREATE: 2,
            FREETEXT_SIZE: 11,
            FREETEXT_COLOR: 12,
            FREETEXT_OPACITY: 13,
            INK_COLOR: 21,
            INK_THICKNESS: 22,
            INK_OPACITY: 23
          };
          c.AnnotationEditorParamsType = x;
          const b = {
            PRINT: 4,
            MODIFY_CONTENTS: 8,
            COPY: 16,
            MODIFY_ANNOTATIONS: 32,
            FILL_INTERACTIVE_FORMS: 256,
            COPY_FOR_ACCESSIBILITY: 512,
            ASSEMBLE: 1024,
            PRINT_HIGH_QUALITY: 2048
          };
          c.PermissionFlag = b;
          const u = {
            FILL: 0,
            STROKE: 1,
            FILL_STROKE: 2,
            INVISIBLE: 3,
            FILL_ADD_TO_PATH: 4,
            STROKE_ADD_TO_PATH: 5,
            FILL_STROKE_ADD_TO_PATH: 6,
            ADD_TO_PATH: 7,
            FILL_STROKE_MASK: 3,
            ADD_TO_PATH_FLAG: 4
          };
          c.TextRenderingMode = u;
          const I = {
            GRAYSCALE_1BPP: 1,
            RGB_24BPP: 2,
            RGBA_32BPP: 3
          };
          c.ImageKind = I;
          const O = {
            TEXT: 1,
            LINK: 2,
            FREETEXT: 3,
            LINE: 4,
            SQUARE: 5,
            CIRCLE: 6,
            POLYGON: 7,
            POLYLINE: 8,
            HIGHLIGHT: 9,
            UNDERLINE: 10,
            SQUIGGLY: 11,
            STRIKEOUT: 12,
            STAMP: 13,
            CARET: 14,
            INK: 15,
            POPUP: 16,
            FILEATTACHMENT: 17,
            SOUND: 18,
            MOVIE: 19,
            WIDGET: 20,
            SCREEN: 21,
            PRINTERMARK: 22,
            TRAPNET: 23,
            WATERMARK: 24,
            THREED: 25,
            REDACT: 26
          };
          c.AnnotationType = O;
          const D = {
            GROUP: "Group",
            REPLY: "R"
          };
          c.AnnotationReplyType = D;
          const $ = {
            INVISIBLE: 1,
            HIDDEN: 2,
            PRINT: 4,
            NOZOOM: 8,
            NOROTATE: 16,
            NOVIEW: 32,
            READONLY: 64,
            LOCKED: 128,
            TOGGLENOVIEW: 256,
            LOCKEDCONTENTS: 512
          };
          c.AnnotationFlag = $;
          const K = {
            READONLY: 1,
            REQUIRED: 2,
            NOEXPORT: 4,
            MULTILINE: 4096,
            PASSWORD: 8192,
            NOTOGGLETOOFF: 16384,
            RADIO: 32768,
            PUSHBUTTON: 65536,
            COMBO: 131072,
            EDIT: 262144,
            SORT: 524288,
            FILESELECT: 1048576,
            MULTISELECT: 2097152,
            DONOTSPELLCHECK: 4194304,
            DONOTSCROLL: 8388608,
            COMB: 16777216,
            RICHTEXT: 33554432,
            RADIOSINUNISON: 33554432,
            COMMITONSELCHANGE: 67108864
          };
          c.AnnotationFieldFlag = K;
          const H = {
            SOLID: 1,
            DASHED: 2,
            BEVELED: 3,
            INSET: 4,
            UNDERLINE: 5
          };
          c.AnnotationBorderStyleType = H;
          const B = {
            E: "Mouse Enter",
            X: "Mouse Exit",
            D: "Mouse Down",
            U: "Mouse Up",
            Fo: "Focus",
            Bl: "Blur",
            PO: "PageOpen",
            PC: "PageClose",
            PV: "PageVisible",
            PI: "PageInvisible",
            K: "Keystroke",
            F: "Format",
            V: "Validate",
            C: "Calculate"
          };
          c.AnnotationActionEventType = B;
          const R = {
            WC: "WillClose",
            WS: "WillSave",
            DS: "DidSave",
            WP: "WillPrint",
            DP: "DidPrint"
          };
          c.DocumentActionEventType = R;
          const _ = {
            O: "PageOpen",
            C: "PageClose"
          };
          c.PageActionEventType = _;
          const A = {
            ERRORS: 0,
            WARNINGS: 1,
            INFOS: 5
          };
          c.VerbosityLevel = A;
          const k = {
            NONE: 0,
            BINARY: 1
          };
          c.CMapCompressionType = k;
          const z = {
            dependency: 1,
            setLineWidth: 2,
            setLineCap: 3,
            setLineJoin: 4,
            setMiterLimit: 5,
            setDash: 6,
            setRenderingIntent: 7,
            setFlatness: 8,
            setGState: 9,
            save: 10,
            restore: 11,
            transform: 12,
            moveTo: 13,
            lineTo: 14,
            curveTo: 15,
            curveTo2: 16,
            curveTo3: 17,
            closePath: 18,
            rectangle: 19,
            stroke: 20,
            closeStroke: 21,
            fill: 22,
            eoFill: 23,
            fillStroke: 24,
            eoFillStroke: 25,
            closeFillStroke: 26,
            closeEOFillStroke: 27,
            endPath: 28,
            clip: 29,
            eoClip: 30,
            beginText: 31,
            endText: 32,
            setCharSpacing: 33,
            setWordSpacing: 34,
            setHScale: 35,
            setLeading: 36,
            setFont: 37,
            setTextRenderingMode: 38,
            setTextRise: 39,
            moveText: 40,
            setLeadingMoveText: 41,
            setTextMatrix: 42,
            nextLine: 43,
            showText: 44,
            showSpacedText: 45,
            nextLineShowText: 46,
            nextLineSetSpacingShowText: 47,
            setCharWidth: 48,
            setCharWidthAndBounds: 49,
            setStrokeColorSpace: 50,
            setFillColorSpace: 51,
            setStrokeColor: 52,
            setStrokeColorN: 53,
            setFillColor: 54,
            setFillColorN: 55,
            setStrokeGray: 56,
            setFillGray: 57,
            setStrokeRGBColor: 58,
            setFillRGBColor: 59,
            setStrokeCMYKColor: 60,
            setFillCMYKColor: 61,
            shadingFill: 62,
            beginInlineImage: 63,
            beginImageData: 64,
            endInlineImage: 65,
            paintXObject: 66,
            markPoint: 67,
            markPointProps: 68,
            beginMarkedContent: 69,
            beginMarkedContentProps: 70,
            endMarkedContent: 71,
            beginCompat: 72,
            endCompat: 73,
            paintFormXObjectBegin: 74,
            paintFormXObjectEnd: 75,
            beginGroup: 76,
            endGroup: 77,
            beginAnnotation: 80,
            endAnnotation: 81,
            paintImageMaskXObject: 83,
            paintImageMaskXObjectGroup: 84,
            paintImageXObject: 85,
            paintInlineImageXObject: 86,
            paintInlineImageXObjectGroup: 87,
            paintImageXObjectRepeat: 88,
            paintImageMaskXObjectRepeat: 89,
            paintSolidColorImageMask: 90,
            constructPath: 91
          };
          c.OPS = z;
          const T = {
            NEED_PASSWORD: 1,
            INCORRECT_PASSWORD: 2
          };
          c.PasswordResponses = T;
          let w = A.WARNINGS;
          function F(ke) {
            Number.isInteger(ke) && (w = ke);
          }
          function j() {
            return w;
          }
          function P(ke) {
            w >= A.INFOS && console.log(`Info: ${ke}`);
          }
          function V(ke) {
            w >= A.WARNINGS && console.log(`Warning: ${ke}`);
          }
          function J(ke) {
            throw new Error(ke);
          }
          function ne(ke, be) {
            ke || J(be);
          }
          function Z(ke) {
            switch (ke == null ? void 0 : ke.protocol) {
              case "http:":
              case "https:":
              case "ftp:":
              case "mailto:":
              case "tel:":
                return !0;
              default:
                return !1;
            }
          }
          function te(ke, be = null, we = null) {
            if (!ke)
              return null;
            try {
              if (we && typeof ke == "string") {
                if (we.addDefaultProtocol && ke.startsWith("www.")) {
                  const Re = ke.match(/\./g);
                  (Re == null ? void 0 : Re.length) >= 2 && (ke = `http://${ke}`);
                }
                if (we.tryConvertEncoding)
                  try {
                    ke = de(ke);
                  } catch {
                  }
              }
              const Le = be ? new URL(ke, be) : new URL(ke);
              if (Z(Le))
                return Le;
            } catch {
            }
            return null;
          }
          function G(ke, be, we, Le = !1) {
            return Object.defineProperty(ke, be, {
              value: we,
              enumerable: !Le,
              configurable: !0,
              writable: !1
            }), we;
          }
          const N = function() {
            function be(we, Le) {
              this.constructor === be && J("Cannot initialize BaseException."), this.message = we, this.name = Le;
            }
            return be.prototype = new Error(), be.constructor = be, be;
          }();
          c.BaseException = N;
          class q extends N {
            constructor(be, we) {
              super(be, "PasswordException"), this.code = we;
            }
          }
          c.PasswordException = q;
          class ie extends N {
            constructor(be, we) {
              super(be, "UnknownErrorException"), this.details = we;
            }
          }
          c.UnknownErrorException = ie;
          class oe extends N {
            constructor(be) {
              super(be, "InvalidPDFException");
            }
          }
          c.InvalidPDFException = oe;
          class fe extends N {
            constructor(be) {
              super(be, "MissingPDFException");
            }
          }
          c.MissingPDFException = fe;
          class Y extends N {
            constructor(be, we) {
              super(be, "UnexpectedResponseException"), this.status = we;
            }
          }
          c.UnexpectedResponseException = Y;
          class ae extends N {
            constructor(be) {
              super(be, "FormatError");
            }
          }
          c.FormatError = ae;
          class se extends N {
            constructor(be) {
              super(be, "AbortException");
            }
          }
          c.AbortException = se;
          function L(ke) {
            (typeof ke != "object" || (ke == null ? void 0 : ke.length) === void 0) && J("Invalid argument for bytesToString");
            const be = ke.length, we = 8192;
            if (be < we)
              return String.fromCharCode.apply(null, ke);
            const Le = [];
            for (let Re = 0; Re < be; Re += we) {
              const ct = Math.min(Re + we, be), ft = ke.subarray(Re, ct);
              Le.push(String.fromCharCode.apply(null, ft));
            }
            return Le.join("");
          }
          function W(ke) {
            typeof ke != "string" && J("Invalid argument for stringToBytes");
            const be = ke.length, we = new Uint8Array(be);
            for (let Le = 0; Le < be; ++Le)
              we[Le] = ke.charCodeAt(Le) & 255;
            return we;
          }
          function M(ke) {
            return String.fromCharCode(ke >> 24 & 255, ke >> 16 & 255, ke >> 8 & 255, ke & 255);
          }
          function X(ke) {
            return Object.keys(ke).length;
          }
          function U(ke) {
            const be = /* @__PURE__ */ Object.create(null);
            for (const [we, Le] of ke)
              be[we] = Le;
            return be;
          }
          function Q() {
            const ke = new Uint8Array(4);
            return ke[0] = 1, new Uint32Array(ke.buffer, 0, 1)[0] === 1;
          }
          function re() {
            try {
              return new Function(""), !0;
            } catch {
              return !1;
            }
          }
          class le {
            static get isLittleEndian() {
              return G(this, "isLittleEndian", Q());
            }
            static get isEvalSupported() {
              return G(this, "isEvalSupported", re());
            }
            static get isOffscreenCanvasSupported() {
              return G(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas < "u");
            }
            static get platform() {
              return typeof navigator > "u" ? G(this, "platform", {
                isWin: !1,
                isMac: !1
              }) : G(this, "platform", {
                isWin: navigator.platform.includes("Win"),
                isMac: navigator.platform.includes("Mac")
              });
            }
            static get isCSSRoundSupported() {
              var be, we;
              return G(this, "isCSSRoundSupported", (we = (be = globalThis.CSS) == null ? void 0 : be.supports) == null ? void 0 : we.call(be, "width: round(1.5px, 1px)"));
            }
          }
          c.FeatureTest = le;
          const ce = [...Array(256).keys()].map((ke) => ke.toString(16).padStart(2, "0"));
          class ee {
            static makeHexColor(be, we, Le) {
              return `#${ce[be]}${ce[we]}${ce[Le]}`;
            }
            static scaleMinMax(be, we) {
              let Le;
              be[0] ? (be[0] < 0 && (Le = we[0], we[0] = we[1], we[1] = Le), we[0] *= be[0], we[1] *= be[0], be[3] < 0 && (Le = we[2], we[2] = we[3], we[3] = Le), we[2] *= be[3], we[3] *= be[3]) : (Le = we[0], we[0] = we[2], we[2] = Le, Le = we[1], we[1] = we[3], we[3] = Le, be[1] < 0 && (Le = we[2], we[2] = we[3], we[3] = Le), we[2] *= be[1], we[3] *= be[1], be[2] < 0 && (Le = we[0], we[0] = we[1], we[1] = Le), we[0] *= be[2], we[1] *= be[2]), we[0] += be[4], we[1] += be[4], we[2] += be[5], we[3] += be[5];
            }
            static transform(be, we) {
              return [be[0] * we[0] + be[2] * we[1], be[1] * we[0] + be[3] * we[1], be[0] * we[2] + be[2] * we[3], be[1] * we[2] + be[3] * we[3], be[0] * we[4] + be[2] * we[5] + be[4], be[1] * we[4] + be[3] * we[5] + be[5]];
            }
            static applyTransform(be, we) {
              const Le = be[0] * we[0] + be[1] * we[2] + we[4], Re = be[0] * we[1] + be[1] * we[3] + we[5];
              return [Le, Re];
            }
            static applyInverseTransform(be, we) {
              const Le = we[0] * we[3] - we[1] * we[2], Re = (be[0] * we[3] - be[1] * we[2] + we[2] * we[5] - we[4] * we[3]) / Le, ct = (-be[0] * we[1] + be[1] * we[0] + we[4] * we[1] - we[5] * we[0]) / Le;
              return [Re, ct];
            }
            static getAxialAlignedBoundingBox(be, we) {
              const Le = this.applyTransform(be, we), Re = this.applyTransform(be.slice(2, 4), we), ct = this.applyTransform([be[0], be[3]], we), ft = this.applyTransform([be[2], be[1]], we);
              return [Math.min(Le[0], Re[0], ct[0], ft[0]), Math.min(Le[1], Re[1], ct[1], ft[1]), Math.max(Le[0], Re[0], ct[0], ft[0]), Math.max(Le[1], Re[1], ct[1], ft[1])];
            }
            static inverseTransform(be) {
              const we = be[0] * be[3] - be[1] * be[2];
              return [be[3] / we, -be[1] / we, -be[2] / we, be[0] / we, (be[2] * be[5] - be[4] * be[3]) / we, (be[4] * be[1] - be[5] * be[0]) / we];
            }
            static singularValueDecompose2dScale(be) {
              const we = [be[0], be[2], be[1], be[3]], Le = be[0] * we[0] + be[1] * we[2], Re = be[0] * we[1] + be[1] * we[3], ct = be[2] * we[0] + be[3] * we[2], ft = be[2] * we[1] + be[3] * we[3], kt = (Le + ft) / 2, We = Math.sqrt((Le + ft) ** 2 - 4 * (Le * ft - ct * Re)) / 2, jt = kt + We || 1, yt = kt - We || 1;
              return [Math.sqrt(jt), Math.sqrt(yt)];
            }
            static normalizeRect(be) {
              const we = be.slice(0);
              return be[0] > be[2] && (we[0] = be[2], we[2] = be[0]), be[1] > be[3] && (we[1] = be[3], we[3] = be[1]), we;
            }
            static intersect(be, we) {
              const Le = Math.max(Math.min(be[0], be[2]), Math.min(we[0], we[2])), Re = Math.min(Math.max(be[0], be[2]), Math.max(we[0], we[2]));
              if (Le > Re)
                return null;
              const ct = Math.max(Math.min(be[1], be[3]), Math.min(we[1], we[3])), ft = Math.min(Math.max(be[1], be[3]), Math.max(we[1], we[3]));
              return ct > ft ? null : [Le, ct, Re, ft];
            }
            static bezierBoundingBox(be, we, Le, Re, ct, ft, kt, We) {
              const jt = [], yt = [[], []];
              let Ye, mt, Pt, et, tn, Xt, _e, Qe;
              for (let At = 0; At < 2; ++At) {
                if (At === 0 ? (mt = 6 * be - 12 * Le + 6 * ct, Ye = -3 * be + 9 * Le - 9 * ct + 3 * kt, Pt = 3 * Le - 3 * be) : (mt = 6 * we - 12 * Re + 6 * ft, Ye = -3 * we + 9 * Re - 9 * ft + 3 * We, Pt = 3 * Re - 3 * we), Math.abs(Ye) < 1e-12) {
                  if (Math.abs(mt) < 1e-12)
                    continue;
                  et = -Pt / mt, 0 < et && et < 1 && jt.push(et);
                  continue;
                }
                _e = mt * mt - 4 * Pt * Ye, Qe = Math.sqrt(_e), !(_e < 0) && (tn = (-mt + Qe) / (2 * Ye), 0 < tn && tn < 1 && jt.push(tn), Xt = (-mt - Qe) / (2 * Ye), 0 < Xt && Xt < 1 && jt.push(Xt));
              }
              let qe = jt.length, Je;
              const nt = qe;
              for (; qe--; )
                et = jt[qe], Je = 1 - et, yt[0][qe] = Je * Je * Je * be + 3 * Je * Je * et * Le + 3 * Je * et * et * ct + et * et * et * kt, yt[1][qe] = Je * Je * Je * we + 3 * Je * Je * et * Re + 3 * Je * et * et * ft + et * et * et * We;
              return yt[0][nt] = be, yt[1][nt] = we, yt[0][nt + 1] = kt, yt[1][nt + 1] = We, yt[0].length = yt[1].length = nt + 2, [Math.min(...yt[0]), Math.min(...yt[1]), Math.max(...yt[0]), Math.max(...yt[1])];
            }
          }
          c.Util = ee;
          const he = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 728, 711, 710, 729, 733, 731, 730, 732, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8226, 8224, 8225, 8230, 8212, 8211, 402, 8260, 8249, 8250, 8722, 8240, 8222, 8220, 8221, 8216, 8217, 8218, 8482, 64257, 64258, 321, 338, 352, 376, 381, 305, 322, 339, 353, 382, 0, 8364];
          function pe(ke) {
            if (ke[0] >= "ï") {
              let we;
              if (ke[0] === "þ" && ke[1] === "ÿ" ? we = "utf-16be" : ke[0] === "ÿ" && ke[1] === "þ" ? we = "utf-16le" : ke[0] === "ï" && ke[1] === "»" && ke[2] === "¿" && (we = "utf-8"), we)
                try {
                  const Le = new TextDecoder(we, {
                    fatal: !0
                  }), Re = W(ke);
                  return Le.decode(Re);
                } catch (Le) {
                  V(`stringToPDFString: "${Le}".`);
                }
            }
            const be = [];
            for (let we = 0, Le = ke.length; we < Le; we++) {
              const Re = he[ke.charCodeAt(we)];
              be.push(Re ? String.fromCharCode(Re) : ke.charAt(we));
            }
            return be.join("");
          }
          function de(ke) {
            return decodeURIComponent(escape(ke));
          }
          function ge(ke) {
            return unescape(encodeURIComponent(ke));
          }
          function me(ke) {
            return typeof ke == "object" && (ke == null ? void 0 : ke.byteLength) !== void 0;
          }
          function xe(ke, be) {
            if (ke.length !== be.length)
              return !1;
            for (let we = 0, Le = ke.length; we < Le; we++)
              if (ke[we] !== be[we])
                return !1;
            return !0;
          }
          function ye(ke = /* @__PURE__ */ new Date()) {
            return [ke.getUTCFullYear().toString(), (ke.getUTCMonth() + 1).toString().padStart(2, "0"), ke.getUTCDate().toString().padStart(2, "0"), ke.getUTCHours().toString().padStart(2, "0"), ke.getUTCMinutes().toString().padStart(2, "0"), ke.getUTCSeconds().toString().padStart(2, "0")].join("");
          }
          class ve {
            constructor() {
              zn(this, Be, !1);
              this.promise = new Promise((be, we) => {
                this.resolve = (Le) => {
                  Mc(this, Be, !0), be(Le);
                }, this.reject = (Le) => {
                  Mc(this, Be, !0), we(Le);
                };
              });
            }
            get settled() {
              return Un(this, Be);
            }
          }
          Be = new WeakMap(), c.PromiseCapability = ve;
          let Ce = null, Ie = null;
          function Ae(ke) {
            return Ce || (Ce = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu, Ie = /* @__PURE__ */ new Map([["ﬅ", "ſt"]])), ke.replaceAll(Ce, (be, we, Le) => we ? we.normalize("NFKC") : Ie.get(Le));
          }
          function Se() {
            if (typeof crypto < "u" && typeof (crypto == null ? void 0 : crypto.randomUUID) == "function")
              return crypto.randomUUID();
            const ke = new Uint8Array(32);
            if (typeof crypto < "u" && typeof (crypto == null ? void 0 : crypto.getRandomValues) == "function")
              crypto.getRandomValues(ke);
            else
              for (let be = 0; be < 32; be++)
                ke[be] = Math.floor(Math.random() * 255);
            return L(ke);
          }
          const De = "pdfjs_internal_id_";
          c.AnnotationPrefix = De;
        },
        /* 3 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.XRefParseException = c.XRefEntryException = c.ParserEOFException = c.PDF_VERSION_REGEXP = c.MissingDataException = void 0, c.arrayBuffersToBytes = y, c.collectActions = A, c.encodeToXmlString = z, c.escapePDFName = B, c.escapeString = R, c.getInheritableProperty = x, c.getLookupTableFactory = i, c.getNewAnnotationsMap = P, c.getRotationMatrix = Z, c.isAscii = V, c.isWhiteSpace = K, c.log2 = I, c.numberToString = j, c.parseXFAPath = H, c.readInt8 = O, c.readUint16 = D, c.readUint32 = $, c.recoverJsURL = F, c.stringToUTF16HexString = J, c.stringToUTF16String = ne, c.toRomanNumerals = u, c.validateCSSFont = w, c.validateFontName = T;
          var s = f(2), h = f(4), g = f(5);
          const t = /^[1-9]\.\d$/;
          c.PDF_VERSION_REGEXP = t;
          function i(te) {
            let G;
            return function() {
              return te && (G = /* @__PURE__ */ Object.create(null), te(G), te = null), G;
            };
          }
          class m extends s.BaseException {
            constructor(G, N) {
              super(`Missing data [${G}, ${N})`, "MissingDataException"), this.begin = G, this.end = N;
            }
          }
          c.MissingDataException = m;
          class v extends s.BaseException {
            constructor(G) {
              super(G, "ParserEOFException");
            }
          }
          c.ParserEOFException = v;
          class E extends s.BaseException {
            constructor(G) {
              super(G, "XRefEntryException");
            }
          }
          c.XRefEntryException = E;
          class S extends s.BaseException {
            constructor(G) {
              super(G, "XRefParseException");
            }
          }
          c.XRefParseException = S;
          function y(te) {
            const G = te.length;
            if (G === 0)
              return new Uint8Array(0);
            if (G === 1)
              return new Uint8Array(te[0]);
            let N = 0;
            for (let oe = 0; oe < G; oe++)
              N += te[oe].byteLength;
            const q = new Uint8Array(N);
            let ie = 0;
            for (let oe = 0; oe < G; oe++) {
              const fe = new Uint8Array(te[oe]);
              q.set(fe, ie), ie += fe.byteLength;
            }
            return q;
          }
          function x({
            dict: te,
            key: G,
            getArray: N = !1,
            stopWhenFound: q = !0
          }) {
            let ie;
            const oe = new h.RefSet();
            for (; te instanceof h.Dict && !(te.objId && oe.has(te.objId)); ) {
              te.objId && oe.put(te.objId);
              const fe = N ? te.getArray(G) : te.get(G);
              if (fe !== void 0) {
                if (q)
                  return fe;
                (ie || (ie = [])).push(fe);
              }
              te = te.get("Parent");
            }
            return ie;
          }
          const b = ["", "C", "CC", "CCC", "CD", "D", "DC", "DCC", "DCCC", "CM", "", "X", "XX", "XXX", "XL", "L", "LX", "LXX", "LXXX", "XC", "", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX"];
          function u(te, G = !1) {
            (0, s.assert)(Number.isInteger(te) && te > 0, "The number should be a positive integer.");
            const N = [];
            let q;
            for (; te >= 1e3; )
              te -= 1e3, N.push("M");
            q = te / 100 | 0, te %= 100, N.push(b[q]), q = te / 10 | 0, te %= 10, N.push(b[10 + q]), N.push(b[20 + te]);
            const ie = N.join("");
            return G ? ie.toLowerCase() : ie;
          }
          function I(te) {
            return te <= 0 ? 0 : Math.ceil(Math.log2(te));
          }
          function O(te, G) {
            return te[G] << 24 >> 24;
          }
          function D(te, G) {
            return te[G] << 8 | te[G + 1];
          }
          function $(te, G) {
            return (te[G] << 24 | te[G + 1] << 16 | te[G + 2] << 8 | te[G + 3]) >>> 0;
          }
          function K(te) {
            return te === 32 || te === 9 || te === 13 || te === 10;
          }
          function H(te) {
            const G = /(.+)\[(\d+)\]$/;
            return te.split(".").map((N) => {
              const q = N.match(G);
              return q ? {
                name: q[1],
                pos: parseInt(q[2], 10)
              } : {
                name: N,
                pos: 0
              };
            });
          }
          function B(te) {
            const G = [];
            let N = 0;
            for (let q = 0, ie = te.length; q < ie; q++) {
              const oe = te.charCodeAt(q);
              (oe < 33 || oe > 126 || oe === 35 || oe === 40 || oe === 41 || oe === 60 || oe === 62 || oe === 91 || oe === 93 || oe === 123 || oe === 125 || oe === 47 || oe === 37) && (N < q && G.push(te.substring(N, q)), G.push(`#${oe.toString(16)}`), N = q + 1);
            }
            return G.length === 0 ? te : (N < te.length && G.push(te.substring(N, te.length)), G.join(""));
          }
          function R(te) {
            return te.replaceAll(/([()\\\n\r])/g, (G) => G === `
` ? "\\n" : G === "\r" ? "\\r" : `\\${G}`);
          }
          function _(te, G, N, q) {
            if (!te)
              return;
            let ie = null;
            if (te instanceof h.Ref) {
              if (q.has(te))
                return;
              ie = te, q.put(ie), te = G.fetch(te);
            }
            if (Array.isArray(te))
              for (const oe of te)
                _(oe, G, N, q);
            else if (te instanceof h.Dict) {
              if ((0, h.isName)(te.get("S"), "JavaScript")) {
                const oe = te.get("JS");
                let fe;
                oe instanceof g.BaseStream ? fe = oe.getString() : typeof oe == "string" && (fe = oe), fe && (fe = (0, s.stringToPDFString)(fe).replaceAll("\0", "")), fe && N.push(fe);
              }
              _(te.getRaw("Next"), G, N, q);
            }
            ie && q.remove(ie);
          }
          function A(te, G, N) {
            const q = /* @__PURE__ */ Object.create(null), ie = x({
              dict: G,
              key: "AA",
              stopWhenFound: !1
            });
            if (ie)
              for (let oe = ie.length - 1; oe >= 0; oe--) {
                const fe = ie[oe];
                if (fe instanceof h.Dict)
                  for (const Y of fe.getKeys()) {
                    const ae = N[Y];
                    if (!ae)
                      continue;
                    const se = fe.getRaw(Y), L = new h.RefSet(), W = [];
                    _(se, te, W, L), W.length > 0 && (q[ae] = W);
                  }
              }
            if (G.has("A")) {
              const oe = G.get("A"), fe = new h.RefSet(), Y = [];
              _(oe, te, Y, fe), Y.length > 0 && (q.Action = Y);
            }
            return (0, s.objectSize)(q) > 0 ? q : null;
          }
          const k = {
            60: "&lt;",
            62: "&gt;",
            38: "&amp;",
            34: "&quot;",
            39: "&apos;"
          };
          function z(te) {
            const G = [];
            let N = 0;
            for (let q = 0, ie = te.length; q < ie; q++) {
              const oe = te.codePointAt(q);
              if (32 <= oe && oe <= 126) {
                const fe = k[oe];
                fe && (N < q && G.push(te.substring(N, q)), G.push(fe), N = q + 1);
              } else
                N < q && G.push(te.substring(N, q)), G.push(`&#x${oe.toString(16).toUpperCase()};`), oe > 55295 && (oe < 57344 || oe > 65533) && q++, N = q + 1;
            }
            return G.length === 0 ? te : (N < te.length && G.push(te.substring(N, te.length)), G.join(""));
          }
          function T(te, G = !1) {
            const N = /^("|').*("|')$/.exec(te);
            if (N && N[1] === N[2]) {
              if (new RegExp(`[^\\\\]${N[1]}`).test(te.slice(1, -1)))
                return G && (0, s.warn)(`FontFamily contains unescaped ${N[1]}: ${te}.`), !1;
            } else
              for (const q of te.split(/[ \t]+/))
                if (/^(\d|(-(\d|-)))/.test(q) || !/^[\w-\\]+$/.test(q))
                  return G && (0, s.warn)(`FontFamily contains invalid <custom-ident>: ${te}.`), !1;
            return !0;
          }
          function w(te) {
            const G = "14", N = "400", q = /* @__PURE__ */ new Set(["100", "200", "300", "400", "500", "600", "700", "800", "900", "1000", "normal", "bold", "bolder", "lighter"]), {
              fontFamily: ie,
              fontWeight: oe,
              italicAngle: fe
            } = te;
            if (!T(ie, !0))
              return !1;
            const Y = oe ? oe.toString() : "";
            te.fontWeight = q.has(Y) ? Y : N;
            const ae = parseFloat(fe);
            return te.italicAngle = isNaN(ae) || ae < -90 || ae > 90 ? G : fe.toString(), !0;
          }
          function F(te) {
            const G = ["app.launchURL", "window.open", "xfa.host.gotoURL"], q = new RegExp("^\\s*(" + G.join("|").replaceAll(".", "\\.") + `)\\((?:'|")([^'"]*)(?:'|")(?:,\\s*(\\w+)\\)|\\))`, "i").exec(te);
            if (q != null && q[2]) {
              const ie = q[2];
              let oe = !1;
              return q[3] === "true" && q[1] === "app.launchURL" && (oe = !0), {
                url: ie,
                newWindow: oe
              };
            }
            return null;
          }
          function j(te) {
            if (Number.isInteger(te))
              return te.toString();
            const G = Math.round(te * 100);
            return G % 100 === 0 ? (G / 100).toString() : G % 10 === 0 ? te.toFixed(1) : te.toFixed(2);
          }
          function P(te) {
            if (!te)
              return null;
            const G = /* @__PURE__ */ new Map();
            for (const [N, q] of te) {
              if (!N.startsWith(s.AnnotationEditorPrefix))
                continue;
              let ie = G.get(q.pageIndex);
              ie || (ie = [], G.set(q.pageIndex, ie)), ie.push(q);
            }
            return G.size > 0 ? G : null;
          }
          function V(te) {
            return /^[\x00-\x7F]*$/.test(te);
          }
          function J(te) {
            const G = [];
            for (let N = 0, q = te.length; N < q; N++) {
              const ie = te.charCodeAt(N);
              G.push((ie >> 8 & 255).toString(16).padStart(2, "0"), (ie & 255).toString(16).padStart(2, "0"));
            }
            return G.join("");
          }
          function ne(te, G = !1) {
            const N = [];
            G && N.push("þÿ");
            for (let q = 0, ie = te.length; q < ie; q++) {
              const oe = te.charCodeAt(q);
              N.push(String.fromCharCode(oe >> 8 & 255), String.fromCharCode(oe & 255));
            }
            return N.join("");
          }
          function Z(te, G, N) {
            switch (te) {
              case 90:
                return [0, 1, -1, 0, G, 0];
              case 180:
                return [-1, 0, 0, -1, G, N];
              case 270:
                return [0, -1, 1, 0, 0, N];
              default:
                throw new Error("Invalid rotation");
            }
          }
        },
        /* 4 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.RefSetCache = c.RefSet = c.Ref = c.Name = c.EOF = c.Dict = c.Cmd = c.CIRCULAR_REF = void 0, c.clearPrimitiveCaches = v, c.isCmd = D, c.isDict = $, c.isName = O, c.isRefsEqual = K;
          var s = f(2);
          const h = Symbol("CIRCULAR_REF");
          c.CIRCULAR_REF = h;
          const g = Symbol("EOF");
          c.EOF = g;
          let t = /* @__PURE__ */ Object.create(null), i = /* @__PURE__ */ Object.create(null), m = /* @__PURE__ */ Object.create(null);
          function v() {
            t = /* @__PURE__ */ Object.create(null), i = /* @__PURE__ */ Object.create(null), m = /* @__PURE__ */ Object.create(null);
          }
          class E {
            constructor(B) {
              this.name = B;
            }
            static get(B) {
              return i[B] || (i[B] = new E(B));
            }
          }
          c.Name = E;
          class S {
            constructor(B) {
              this.cmd = B;
            }
            static get(B) {
              return t[B] || (t[B] = new S(B));
            }
          }
          c.Cmd = S;
          const y = function() {
            return y;
          };
          class x {
            constructor(B = null) {
              this._map = /* @__PURE__ */ Object.create(null), this.xref = B, this.objId = null, this.suppressEncryption = !1, this.__nonSerializable__ = y;
            }
            assignXref(B) {
              this.xref = B;
            }
            get size() {
              return Object.keys(this._map).length;
            }
            get(B, R, _) {
              let A = this._map[B];
              return A === void 0 && R !== void 0 && (A = this._map[R], A === void 0 && _ !== void 0 && (A = this._map[_])), A instanceof b && this.xref ? this.xref.fetch(A, this.suppressEncryption) : A;
            }
            async getAsync(B, R, _) {
              let A = this._map[B];
              return A === void 0 && R !== void 0 && (A = this._map[R], A === void 0 && _ !== void 0 && (A = this._map[_])), A instanceof b && this.xref ? this.xref.fetchAsync(A, this.suppressEncryption) : A;
            }
            getArray(B, R, _) {
              let A = this._map[B];
              if (A === void 0 && R !== void 0 && (A = this._map[R], A === void 0 && _ !== void 0 && (A = this._map[_])), A instanceof b && this.xref && (A = this.xref.fetch(A, this.suppressEncryption)), Array.isArray(A)) {
                A = A.slice();
                for (let k = 0, z = A.length; k < z; k++)
                  A[k] instanceof b && this.xref && (A[k] = this.xref.fetch(A[k], this.suppressEncryption));
              }
              return A;
            }
            getRaw(B) {
              return this._map[B];
            }
            getKeys() {
              return Object.keys(this._map);
            }
            getRawValues() {
              return Object.values(this._map);
            }
            set(B, R) {
              this._map[B] = R;
            }
            has(B) {
              return this._map[B] !== void 0;
            }
            forEach(B) {
              for (const R in this._map)
                B(R, this.get(R));
            }
            static get empty() {
              const B = new x(null);
              return B.set = (R, _) => {
                (0, s.unreachable)("Should not call `set` on the empty dictionary.");
              }, (0, s.shadow)(this, "empty", B);
            }
            static merge({
              xref: B,
              dictArray: R,
              mergeSubDicts: _ = !1
            }) {
              const A = new x(B), k = /* @__PURE__ */ new Map();
              for (const z of R)
                if (z instanceof x)
                  for (const [T, w] of Object.entries(z._map)) {
                    let F = k.get(T);
                    if (F === void 0)
                      F = [], k.set(T, F);
                    else if (!_ || !(w instanceof x))
                      continue;
                    F.push(w);
                  }
              for (const [z, T] of k) {
                if (T.length === 1 || !(T[0] instanceof x)) {
                  A._map[z] = T[0];
                  continue;
                }
                const w = new x(B);
                for (const F of T)
                  for (const [j, P] of Object.entries(F._map))
                    w._map[j] === void 0 && (w._map[j] = P);
                w.size > 0 && (A._map[z] = w);
              }
              return k.clear(), A.size > 0 ? A : x.empty;
            }
            clone() {
              const B = new x(this.xref);
              for (const R of this.getKeys())
                B.set(R, this.getRaw(R));
              return B;
            }
          }
          c.Dict = x;
          class b {
            constructor(B, R) {
              this.num = B, this.gen = R;
            }
            toString() {
              return this.gen === 0 ? `${this.num}R` : `${this.num}R${this.gen}`;
            }
            static fromString(B) {
              const R = m[B];
              if (R)
                return R;
              const _ = /^(\d+)R(\d*)$/.exec(B);
              return !_ || _[1] === "0" ? null : m[B] = new b(parseInt(_[1]), _[2] ? parseInt(_[2]) : 0);
            }
            static get(B, R) {
              const _ = R === 0 ? `${B}R` : `${B}R${R}`;
              return m[_] || (m[_] = new b(B, R));
            }
          }
          c.Ref = b;
          class u {
            constructor(B = null) {
              this._set = new Set(B == null ? void 0 : B._set);
            }
            has(B) {
              return this._set.has(B.toString());
            }
            put(B) {
              this._set.add(B.toString());
            }
            remove(B) {
              this._set.delete(B.toString());
            }
            [Symbol.iterator]() {
              return this._set.values();
            }
            clear() {
              this._set.clear();
            }
          }
          c.RefSet = u;
          class I {
            constructor() {
              this._map = /* @__PURE__ */ new Map();
            }
            get size() {
              return this._map.size;
            }
            get(B) {
              return this._map.get(B.toString());
            }
            has(B) {
              return this._map.has(B.toString());
            }
            put(B, R) {
              this._map.set(B.toString(), R);
            }
            putAlias(B, R) {
              this._map.set(B.toString(), this.get(R));
            }
            [Symbol.iterator]() {
              return this._map.values();
            }
            clear() {
              this._map.clear();
            }
          }
          c.RefSetCache = I;
          function O(H, B) {
            return H instanceof E && (B === void 0 || H.name === B);
          }
          function D(H, B) {
            return H instanceof S && (B === void 0 || H.cmd === B);
          }
          function $(H, B) {
            return H instanceof x && (B === void 0 || O(H.get("Type"), B));
          }
          function K(H, B) {
            return H.num === B.num && H.gen === B.gen;
          }
        },
        /* 5 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.BaseStream = void 0;
          var s = f(2);
          class h {
            constructor() {
              this.constructor === h && (0, s.unreachable)("Cannot initialize BaseStream.");
            }
            get length() {
              (0, s.unreachable)("Abstract getter `length` accessed");
            }
            get isEmpty() {
              (0, s.unreachable)("Abstract getter `isEmpty` accessed");
            }
            get isDataLoaded() {
              return (0, s.shadow)(this, "isDataLoaded", !0);
            }
            getByte() {
              (0, s.unreachable)("Abstract method `getByte` called");
            }
            getBytes(t) {
              (0, s.unreachable)("Abstract method `getBytes` called");
            }
            peekByte() {
              const t = this.getByte();
              return t !== -1 && this.pos--, t;
            }
            peekBytes(t) {
              const i = this.getBytes(t);
              return this.pos -= i.length, i;
            }
            getUint16() {
              const t = this.getByte(), i = this.getByte();
              return t === -1 || i === -1 ? -1 : (t << 8) + i;
            }
            getInt32() {
              const t = this.getByte(), i = this.getByte(), m = this.getByte(), v = this.getByte();
              return (t << 24) + (i << 16) + (m << 8) + v;
            }
            getByteRange(t, i) {
              (0, s.unreachable)("Abstract method `getByteRange` called");
            }
            getString(t) {
              return (0, s.bytesToString)(this.getBytes(t));
            }
            skip(t) {
              this.pos += t || 1;
            }
            reset() {
              (0, s.unreachable)("Abstract method `reset` called");
            }
            moveStart() {
              (0, s.unreachable)("Abstract method `moveStart` called");
            }
            makeSubStream(t, i, m = null) {
              (0, s.unreachable)("Abstract method `makeSubStream` called");
            }
            getBaseStreams() {
              return null;
            }
          }
          c.BaseStream = h;
        },
        /* 6 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.NetworkPdfManager = c.LocalPdfManager = void 0;
          var s = f(2), h = f(7), g = f(3), t = f(9), i = f(8);
          function m(y) {
            if (y) {
              const x = (0, s.createValidAbsoluteUrl)(y);
              if (x)
                return x.href;
              (0, s.warn)(`Invalid absolute docBaseUrl: "${y}".`);
            }
            return null;
          }
          class v {
            constructor(x) {
              var b;
              this.constructor === v && (0, s.unreachable)("Cannot initialize BasePdfManager."), this._docBaseUrl = m(x.docBaseUrl), this._docId = x.docId, this._password = x.password, this.enableXfa = x.enableXfa, (b = x.evaluatorOptions).isOffscreenCanvasSupported && (b.isOffscreenCanvasSupported = s.FeatureTest.isOffscreenCanvasSupported), this.evaluatorOptions = x.evaluatorOptions;
            }
            get docId() {
              return this._docId;
            }
            get password() {
              return this._password;
            }
            get docBaseUrl() {
              return this._docBaseUrl;
            }
            get catalog() {
              return this.pdfDocument.catalog;
            }
            ensureDoc(x, b) {
              return this.ensure(this.pdfDocument, x, b);
            }
            ensureXRef(x, b) {
              return this.ensure(this.pdfDocument.xref, x, b);
            }
            ensureCatalog(x, b) {
              return this.ensure(this.pdfDocument.catalog, x, b);
            }
            getPage(x) {
              return this.pdfDocument.getPage(x);
            }
            fontFallback(x, b) {
              return this.pdfDocument.fontFallback(x, b);
            }
            loadXfaFonts(x, b) {
              return this.pdfDocument.loadXfaFonts(x, b);
            }
            loadXfaImages() {
              return this.pdfDocument.loadXfaImages();
            }
            serializeXfaData(x) {
              return this.pdfDocument.serializeXfaData(x);
            }
            cleanup(x = !1) {
              return this.pdfDocument.cleanup(x);
            }
            async ensure(x, b, u) {
              (0, s.unreachable)("Abstract method `ensure` called");
            }
            requestRange(x, b) {
              (0, s.unreachable)("Abstract method `requestRange` called");
            }
            requestLoadedStream(x = !1) {
              (0, s.unreachable)("Abstract method `requestLoadedStream` called");
            }
            sendProgressiveData(x) {
              (0, s.unreachable)("Abstract method `sendProgressiveData` called");
            }
            updatePassword(x) {
              this._password = x;
            }
            terminate(x) {
              (0, s.unreachable)("Abstract method `terminate` called");
            }
          }
          class E extends v {
            constructor(x) {
              super(x);
              const b = new i.Stream(x.source);
              this.pdfDocument = new t.PDFDocument(this, b), this._loadedStreamPromise = Promise.resolve(b);
            }
            async ensure(x, b, u) {
              const I = x[b];
              return typeof I == "function" ? I.apply(x, u) : I;
            }
            requestRange(x, b) {
              return Promise.resolve();
            }
            requestLoadedStream(x = !1) {
              return this._loadedStreamPromise;
            }
            terminate(x) {
            }
          }
          c.LocalPdfManager = E;
          class S extends v {
            constructor(x) {
              super(x), this.streamManager = new h.ChunkedStreamManager(x.source, {
                msgHandler: x.handler,
                length: x.length,
                disableAutoFetch: x.disableAutoFetch,
                rangeChunkSize: x.rangeChunkSize
              }), this.pdfDocument = new t.PDFDocument(this, this.streamManager.getStream());
            }
            async ensure(x, b, u) {
              try {
                const I = x[b];
                return typeof I == "function" ? I.apply(x, u) : I;
              } catch (I) {
                if (!(I instanceof g.MissingDataException))
                  throw I;
                return await this.requestRange(I.begin, I.end), this.ensure(x, b, u);
              }
            }
            requestRange(x, b) {
              return this.streamManager.requestRange(x, b);
            }
            requestLoadedStream(x = !1) {
              return this.streamManager.requestAllChunks(x);
            }
            sendProgressiveData(x) {
              this.streamManager.onReceiveData({
                chunk: x
              });
            }
            terminate(x) {
              this.streamManager.abort(x);
            }
          }
          c.NetworkPdfManager = S;
        },
        /* 7 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.ChunkedStreamManager = c.ChunkedStream = void 0;
          var s = f(3), h = f(2), g = f(8);
          class t extends g.Stream {
            constructor(v, E, S) {
              super(new Uint8Array(v), 0, v, null), this.chunkSize = E, this._loadedChunks = /* @__PURE__ */ new Set(), this.numChunks = Math.ceil(v / E), this.manager = S, this.progressiveDataLength = 0, this.lastSuccessfulEnsureByteChunk = -1;
            }
            getMissingChunks() {
              const v = [];
              for (let E = 0, S = this.numChunks; E < S; ++E)
                this._loadedChunks.has(E) || v.push(E);
              return v;
            }
            get numChunksLoaded() {
              return this._loadedChunks.size;
            }
            get isDataLoaded() {
              return this.numChunksLoaded === this.numChunks;
            }
            onReceiveData(v, E) {
              const S = this.chunkSize;
              if (v % S !== 0)
                throw new Error(`Bad begin offset: ${v}`);
              const y = v + E.byteLength;
              if (y % S !== 0 && y !== this.bytes.length)
                throw new Error(`Bad end offset: ${y}`);
              this.bytes.set(new Uint8Array(E), v);
              const x = Math.floor(v / S), b = Math.floor((y - 1) / S) + 1;
              for (let u = x; u < b; ++u)
                this._loadedChunks.add(u);
            }
            onReceiveProgressiveData(v) {
              let E = this.progressiveDataLength;
              const S = Math.floor(E / this.chunkSize);
              this.bytes.set(new Uint8Array(v), E), E += v.byteLength, this.progressiveDataLength = E;
              const y = E >= this.end ? this.numChunks : Math.floor(E / this.chunkSize);
              for (let x = S; x < y; ++x)
                this._loadedChunks.add(x);
            }
            ensureByte(v) {
              if (v < this.progressiveDataLength)
                return;
              const E = Math.floor(v / this.chunkSize);
              if (!(E > this.numChunks) && E !== this.lastSuccessfulEnsureByteChunk) {
                if (!this._loadedChunks.has(E))
                  throw new s.MissingDataException(v, v + 1);
                this.lastSuccessfulEnsureByteChunk = E;
              }
            }
            ensureRange(v, E) {
              if (v >= E || E <= this.progressiveDataLength)
                return;
              const S = Math.floor(v / this.chunkSize);
              if (S > this.numChunks)
                return;
              const y = Math.min(Math.floor((E - 1) / this.chunkSize) + 1, this.numChunks);
              for (let x = S; x < y; ++x)
                if (!this._loadedChunks.has(x))
                  throw new s.MissingDataException(v, E);
            }
            nextEmptyChunk(v) {
              const E = this.numChunks;
              for (let S = 0; S < E; ++S) {
                const y = (v + S) % E;
                if (!this._loadedChunks.has(y))
                  return y;
              }
              return null;
            }
            hasChunk(v) {
              return this._loadedChunks.has(v);
            }
            getByte() {
              const v = this.pos;
              return v >= this.end ? -1 : (v >= this.progressiveDataLength && this.ensureByte(v), this.bytes[this.pos++]);
            }
            getBytes(v) {
              const E = this.bytes, S = this.pos, y = this.end;
              if (!v)
                return y > this.progressiveDataLength && this.ensureRange(S, y), E.subarray(S, y);
              let x = S + v;
              return x > y && (x = y), x > this.progressiveDataLength && this.ensureRange(S, x), this.pos = x, E.subarray(S, x);
            }
            getByteRange(v, E) {
              return v < 0 && (v = 0), E > this.end && (E = this.end), E > this.progressiveDataLength && this.ensureRange(v, E), this.bytes.subarray(v, E);
            }
            makeSubStream(v, E, S = null) {
              E ? v + E > this.progressiveDataLength && this.ensureRange(v, v + E) : v >= this.progressiveDataLength && this.ensureByte(v);
              function y() {
              }
              y.prototype = Object.create(this), y.prototype.getMissingChunks = function() {
                const b = this.chunkSize, u = Math.floor(this.start / b), I = Math.floor((this.end - 1) / b) + 1, O = [];
                for (let D = u; D < I; ++D)
                  this._loadedChunks.has(D) || O.push(D);
                return O;
              }, Object.defineProperty(y.prototype, "isDataLoaded", {
                get() {
                  return this.numChunksLoaded === this.numChunks ? !0 : this.getMissingChunks().length === 0;
                },
                configurable: !0
              });
              const x = new y();
              return x.pos = x.start = v, x.end = v + E || this.end, x.dict = S, x;
            }
            getBaseStreams() {
              return [this];
            }
          }
          c.ChunkedStream = t;
          class i {
            constructor(v, E) {
              this.length = E.length, this.chunkSize = E.rangeChunkSize, this.stream = new t(this.length, this.chunkSize, this), this.pdfNetworkStream = v, this.disableAutoFetch = E.disableAutoFetch, this.msgHandler = E.msgHandler, this.currRequestId = 0, this._chunksNeededByRequest = /* @__PURE__ */ new Map(), this._requestsByChunk = /* @__PURE__ */ new Map(), this._promisesByRequest = /* @__PURE__ */ new Map(), this.progressiveDataLength = 0, this.aborted = !1, this._loadedStreamCapability = new h.PromiseCapability();
            }
            sendRequest(v, E) {
              const S = this.pdfNetworkStream.getRangeReader(v, E);
              S.isStreamingSupported || (S.onProgress = this.onProgress.bind(this));
              let y = [], x = 0;
              return new Promise((b, u) => {
                const I = ({
                  value: O,
                  done: D
                }) => {
                  try {
                    if (D) {
                      const $ = (0, s.arrayBuffersToBytes)(y);
                      y = null, b($);
                      return;
                    }
                    x += O.byteLength, S.isStreamingSupported && this.onProgress({
                      loaded: x
                    }), y.push(O), S.read().then(I, u);
                  } catch ($) {
                    u($);
                  }
                };
                S.read().then(I, u);
              }).then((b) => {
                this.aborted || this.onReceiveData({
                  chunk: b,
                  begin: v
                });
              });
            }
            requestAllChunks(v = !1) {
              if (!v) {
                const E = this.stream.getMissingChunks();
                this._requestChunks(E);
              }
              return this._loadedStreamCapability.promise;
            }
            _requestChunks(v) {
              const E = this.currRequestId++, S = /* @__PURE__ */ new Set();
              this._chunksNeededByRequest.set(E, S);
              for (const b of v)
                this.stream.hasChunk(b) || S.add(b);
              if (S.size === 0)
                return Promise.resolve();
              const y = new h.PromiseCapability();
              this._promisesByRequest.set(E, y);
              const x = [];
              for (const b of S) {
                let u = this._requestsByChunk.get(b);
                u || (u = [], this._requestsByChunk.set(b, u), x.push(b)), u.push(E);
              }
              if (x.length > 0) {
                const b = this.groupChunks(x);
                for (const u of b) {
                  const I = u.beginChunk * this.chunkSize, O = Math.min(u.endChunk * this.chunkSize, this.length);
                  this.sendRequest(I, O).catch(y.reject);
                }
              }
              return y.promise.catch((b) => {
                if (!this.aborted)
                  throw b;
              });
            }
            getStream() {
              return this.stream;
            }
            requestRange(v, E) {
              E = Math.min(E, this.length);
              const S = this.getBeginChunk(v), y = this.getEndChunk(E), x = [];
              for (let b = S; b < y; ++b)
                x.push(b);
              return this._requestChunks(x);
            }
            requestRanges(v = []) {
              const E = [];
              for (const S of v) {
                const y = this.getBeginChunk(S.begin), x = this.getEndChunk(S.end);
                for (let b = y; b < x; ++b)
                  E.includes(b) || E.push(b);
              }
              return E.sort(function(S, y) {
                return S - y;
              }), this._requestChunks(E);
            }
            groupChunks(v) {
              const E = [];
              let S = -1, y = -1;
              for (let x = 0, b = v.length; x < b; ++x) {
                const u = v[x];
                S < 0 && (S = u), y >= 0 && y + 1 !== u && (E.push({
                  beginChunk: S,
                  endChunk: y + 1
                }), S = u), x + 1 === v.length && E.push({
                  beginChunk: S,
                  endChunk: u + 1
                }), y = u;
              }
              return E;
            }
            onProgress(v) {
              this.msgHandler.send("DocProgress", {
                loaded: this.stream.numChunksLoaded * this.chunkSize + v.loaded,
                total: this.length
              });
            }
            onReceiveData(v) {
              const E = v.chunk, S = v.begin === void 0, y = S ? this.progressiveDataLength : v.begin, x = y + E.byteLength, b = Math.floor(y / this.chunkSize), u = x < this.length ? Math.floor(x / this.chunkSize) : Math.ceil(x / this.chunkSize);
              S ? (this.stream.onReceiveProgressiveData(E), this.progressiveDataLength = x) : this.stream.onReceiveData(y, E), this.stream.isDataLoaded && this._loadedStreamCapability.resolve(this.stream);
              const I = [];
              for (let O = b; O < u; ++O) {
                const D = this._requestsByChunk.get(O);
                if (D) {
                  this._requestsByChunk.delete(O);
                  for (const $ of D) {
                    const K = this._chunksNeededByRequest.get($);
                    K.has(O) && K.delete(O), !(K.size > 0) && I.push($);
                  }
                }
              }
              if (!this.disableAutoFetch && this._requestsByChunk.size === 0) {
                let O;
                if (this.stream.numChunksLoaded === 1) {
                  const D = this.stream.numChunks - 1;
                  this.stream.hasChunk(D) || (O = D);
                } else
                  O = this.stream.nextEmptyChunk(u);
                Number.isInteger(O) && this._requestChunks([O]);
              }
              for (const O of I) {
                const D = this._promisesByRequest.get(O);
                this._promisesByRequest.delete(O), D.resolve();
              }
              this.msgHandler.send("DocProgress", {
                loaded: this.stream.numChunksLoaded * this.chunkSize,
                total: this.length
              });
            }
            onError(v) {
              this._loadedStreamCapability.reject(v);
            }
            getBeginChunk(v) {
              return Math.floor(v / this.chunkSize);
            }
            getEndChunk(v) {
              return Math.floor((v - 1) / this.chunkSize) + 1;
            }
            abort(v) {
              var E;
              this.aborted = !0, (E = this.pdfNetworkStream) == null || E.cancelAllRequests(v);
              for (const S of this._promisesByRequest.values())
                S.reject(v);
            }
          }
          c.ChunkedStreamManager = i;
        },
        /* 8 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.StringStream = c.Stream = c.NullStream = void 0;
          var s = f(5), h = f(2);
          class g extends s.BaseStream {
            constructor(v, E, S, y) {
              super(), this.bytes = v instanceof Uint8Array ? v : new Uint8Array(v), this.start = E || 0, this.pos = this.start, this.end = E + S || this.bytes.length, this.dict = y;
            }
            get length() {
              return this.end - this.start;
            }
            get isEmpty() {
              return this.length === 0;
            }
            getByte() {
              return this.pos >= this.end ? -1 : this.bytes[this.pos++];
            }
            getBytes(v) {
              const E = this.bytes, S = this.pos, y = this.end;
              if (!v)
                return E.subarray(S, y);
              let x = S + v;
              return x > y && (x = y), this.pos = x, E.subarray(S, x);
            }
            getByteRange(v, E) {
              return v < 0 && (v = 0), E > this.end && (E = this.end), this.bytes.subarray(v, E);
            }
            reset() {
              this.pos = this.start;
            }
            moveStart() {
              this.start = this.pos;
            }
            makeSubStream(v, E, S = null) {
              return new g(this.bytes.buffer, v, E, S);
            }
          }
          c.Stream = g;
          class t extends g {
            constructor(v) {
              super((0, h.stringToBytes)(v));
            }
          }
          c.StringStream = t;
          class i extends g {
            constructor() {
              super(new Uint8Array(0));
            }
          }
          c.NullStream = i;
        },
        /* 9 */
        /***/
        (d, c, f) => {
          var V, jd, ne, Rd;
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.Page = c.PDFDocument = void 0;
          var s = f(2), h = f(10), g = f(3), t = f(4), i = f(51), m = f(5), v = f(74), E = f(66), S = f(68), y = f(102), x = f(16), b = f(8), u = f(76), I = f(64), O = f(13), D = f(18), $ = f(72), K = f(73), H = f(77), B = f(103);
          const R = 1, _ = [0, 0, 612, 792];
          class A {
            constructor({
              pdfManager: G,
              xref: N,
              pageIndex: q,
              pageDict: ie,
              ref: oe,
              globalIdFactory: fe,
              fontCache: Y,
              builtInCMapCache: ae,
              standardFontDataCache: se,
              globalImageCache: L,
              systemFontCache: W,
              nonBlendModesSet: M,
              xfaFactory: X
            }) {
              zn(this, V);
              this.pdfManager = G, this.pageIndex = q, this.pageDict = ie, this.xref = N, this.ref = oe, this.fontCache = Y, this.builtInCMapCache = ae, this.standardFontDataCache = se, this.globalImageCache = L, this.systemFontCache = W, this.nonBlendModesSet = M, this.evaluatorOptions = G.evaluatorOptions, this.resourcesPromise = null, this.xfaFactory = X;
              const U = {
                obj: 0
              };
              this._localIdFactory = class extends fe {
                static createObjId() {
                  return `p${q}_${++U.obj}`;
                }
                static getPageObjId() {
                  return `p${oe.toString()}`;
                }
              };
            }
            _getInheritableProperty(G, N = !1) {
              const q = (0, g.getInheritableProperty)({
                dict: this.pageDict,
                key: G,
                getArray: N,
                stopWhenFound: !1
              });
              return Array.isArray(q) ? q.length === 1 || !(q[0] instanceof t.Dict) ? q[0] : t.Dict.merge({
                xref: this.xref,
                dictArray: q
              }) : q;
            }
            get content() {
              return this.pageDict.getArray("Contents");
            }
            get resources() {
              const G = this._getInheritableProperty("Resources");
              return (0, s.shadow)(this, "resources", G instanceof t.Dict ? G : t.Dict.empty);
            }
            _getBoundingBox(G) {
              if (this.xfaData)
                return this.xfaData.bbox;
              let N = this._getInheritableProperty(G, !0);
              if (Array.isArray(N) && N.length === 4) {
                if (N = s.Util.normalizeRect(N), N[2] - N[0] > 0 && N[3] - N[1] > 0)
                  return N;
                (0, s.warn)(`Empty, or invalid, /${G} entry.`);
              }
              return null;
            }
            get mediaBox() {
              return (0, s.shadow)(this, "mediaBox", this._getBoundingBox("MediaBox") || _);
            }
            get cropBox() {
              return (0, s.shadow)(this, "cropBox", this._getBoundingBox("CropBox") || this.mediaBox);
            }
            get userUnit() {
              let G = this.pageDict.get("UserUnit");
              return (typeof G != "number" || G <= 0) && (G = R), (0, s.shadow)(this, "userUnit", G);
            }
            get view() {
              const {
                cropBox: G,
                mediaBox: N
              } = this;
              if (G !== N && !(0, s.isArrayEqual)(G, N)) {
                const q = s.Util.intersect(G, N);
                if (q && q[2] - q[0] > 0 && q[3] - q[1] > 0)
                  return (0, s.shadow)(this, "view", q);
                (0, s.warn)("Empty /CropBox and /MediaBox intersection.");
              }
              return (0, s.shadow)(this, "view", N);
            }
            get rotate() {
              let G = this._getInheritableProperty("Rotate") || 0;
              return G % 90 !== 0 ? G = 0 : G >= 360 ? G %= 360 : G < 0 && (G = (G % 360 + 360) % 360), (0, s.shadow)(this, "rotate", G);
            }
            _onSubStreamError(G, N) {
              if (this.evaluatorOptions.ignoreErrors) {
                (0, s.warn)(`getContentStream - ignoring sub-stream (${N}): "${G}".`);
                return;
              }
              throw G;
            }
            getContentStream() {
              return this.pdfManager.ensure(this, "content").then((G) => G instanceof m.BaseStream ? G : Array.isArray(G) ? new D.StreamsSequenceStream(G, this._onSubStreamError.bind(this)) : new b.NullStream());
            }
            get xfaData() {
              return (0, s.shadow)(this, "xfaData", this.xfaFactory ? {
                bbox: this.xfaFactory.getBoundingBox(this.pageIndex)
              } : null);
            }
            async saveNewAnnotations(G, N, q, ie) {
              if (this.xfaFactory)
                throw new Error("XFA: Cannot save new annotations.");
              const oe = new O.PartialEvaluator({
                xref: this.xref,
                handler: G,
                pageIndex: this.pageIndex,
                idFactory: this._localIdFactory,
                fontCache: this.fontCache,
                builtInCMapCache: this.builtInCMapCache,
                standardFontDataCache: this.standardFontDataCache,
                globalImageCache: this.globalImageCache,
                systemFontCache: this.systemFontCache,
                options: this.evaluatorOptions
              }), fe = new t.RefSet(), Y = new t.RefSet();
              Nt(this, V, jd).call(this, q, fe, Y);
              const ae = this.pageDict, se = this.annotations.filter((U) => !(U instanceof t.Ref && fe.has(U))), L = await h.AnnotationFactory.saveNewAnnotations(oe, N, q, ie);
              for (const {
                ref: U
              } of L.annotations)
                U instanceof t.Ref && !Y.has(U) && se.push(U);
              const W = ae.get("Annots");
              ae.set("Annots", se);
              const M = [];
              await (0, K.writeObject)(this.ref, ae, M, this.xref), W && ae.set("Annots", W);
              const X = L.dependencies;
              return X.push({
                ref: this.ref,
                data: M.join("")
              }, ...L.annotations), X;
            }
            save(G, N, q) {
              const ie = new O.PartialEvaluator({
                xref: this.xref,
                handler: G,
                pageIndex: this.pageIndex,
                idFactory: this._localIdFactory,
                fontCache: this.fontCache,
                builtInCMapCache: this.builtInCMapCache,
                standardFontDataCache: this.standardFontDataCache,
                globalImageCache: this.globalImageCache,
                systemFontCache: this.systemFontCache,
                options: this.evaluatorOptions
              });
              return this._parsedAnnotations.then(function(oe) {
                const fe = [];
                for (const Y of oe)
                  Y.mustBePrinted(q) && fe.push(Y.save(ie, N, q).catch(function(ae) {
                    return (0, s.warn)(`save - ignoring annotation data during "${N.name}" task: "${ae}".`), null;
                  }));
                return Promise.all(fe).then(function(Y) {
                  return Y.filter((ae) => !!ae);
                });
              });
            }
            loadResources(G) {
              return this.resourcesPromise || (this.resourcesPromise = this.pdfManager.ensure(this, "resources")), this.resourcesPromise.then(() => new u.ObjectLoader(this.resources, G, this.xref).load());
            }
            getOperatorList({
              handler: G,
              sink: N,
              task: q,
              intent: ie,
              cacheKey: oe,
              annotationStorage: fe = null
            }) {
              const Y = this.getContentStream(), ae = this.loadResources(["ColorSpace", "ExtGState", "Font", "Pattern", "Properties", "Shading", "XObject"]), se = new O.PartialEvaluator({
                xref: this.xref,
                handler: G,
                pageIndex: this.pageIndex,
                idFactory: this._localIdFactory,
                fontCache: this.fontCache,
                builtInCMapCache: this.builtInCMapCache,
                standardFontDataCache: this.standardFontDataCache,
                globalImageCache: this.globalImageCache,
                systemFontCache: this.systemFontCache,
                options: this.evaluatorOptions
              }), L = this.xfaFactory ? null : (0, g.getNewAnnotationsMap)(fe);
              let W = null, M = Promise.resolve(null);
              if (L) {
                const Q = L.get(this.pageIndex);
                if (Q) {
                  const re = this.pdfManager.ensureDoc("annotationGlobals");
                  let le;
                  const ce = /* @__PURE__ */ new Set();
                  for (const {
                    bitmapId: he,
                    bitmap: pe
                  } of Q)
                    he && !pe && !ce.has(he) && ce.add(he);
                  const {
                    isOffscreenCanvasSupported: ee
                  } = this.evaluatorOptions;
                  if (ce.size > 0) {
                    const he = Q.slice();
                    for (const [pe, de] of fe)
                      pe.startsWith(s.AnnotationEditorPrefix) && de.bitmap && ce.has(de.bitmapId) && he.push(de);
                    le = h.AnnotationFactory.generateImages(he, this.xref, ee);
                  } else
                    le = h.AnnotationFactory.generateImages(Q, this.xref, ee);
                  W = new t.RefSet(), Nt(this, V, jd).call(this, Q, W, null), M = re.then((he) => he ? h.AnnotationFactory.printNewAnnotations(he, se, q, Q, le) : null);
                }
              }
              const U = Promise.all([Y, ae]).then(([Q]) => {
                const re = new I.OperatorList(ie, N);
                return G.send("StartRenderPage", {
                  transparency: se.hasBlendModes(this.resources, this.nonBlendModesSet),
                  pageIndex: this.pageIndex,
                  cacheKey: oe
                }), se.getOperatorList({
                  stream: Q,
                  task: q,
                  resources: this.resources,
                  operatorList: re
                }).then(function() {
                  return re;
                });
              });
              return Promise.all([U, this._parsedAnnotations, M]).then(function([Q, re, le]) {
                if (le) {
                  re = re.filter((ge) => !(ge.ref && W.has(ge.ref)));
                  for (let ge = 0, me = le.length; ge < me; ge++) {
                    const xe = le[ge];
                    if (xe.refToReplace) {
                      const ye = re.findIndex((ve) => ve.ref && (0, t.isRefsEqual)(ve.ref, xe.refToReplace));
                      ye >= 0 && (re.splice(ye, 1, xe), le.splice(ge--, 1), me--);
                    }
                  }
                  re = re.concat(le);
                }
                if (re.length === 0 || ie & s.RenderingIntentFlag.ANNOTATIONS_DISABLE)
                  return Q.flush(!0), {
                    length: Q.totalLength
                  };
                const ce = !!(ie & s.RenderingIntentFlag.ANNOTATIONS_FORMS), ee = !!(ie & s.RenderingIntentFlag.ANY), he = !!(ie & s.RenderingIntentFlag.DISPLAY), pe = !!(ie & s.RenderingIntentFlag.PRINT), de = [];
                for (const ge of re)
                  (ee || he && ge.mustBeViewed(fe, ce) || pe && ge.mustBePrinted(fe)) && de.push(ge.getOperatorList(se, q, ie, ce, fe).catch(function(me) {
                    return (0, s.warn)(`getOperatorList - ignoring annotation data during "${q.name}" task: "${me}".`), {
                      opList: null,
                      separateForm: !1,
                      separateCanvas: !1
                    };
                  }));
                return Promise.all(de).then(function(ge) {
                  let me = !1, xe = !1;
                  for (const {
                    opList: ye,
                    separateForm: ve,
                    separateCanvas: Ce
                  } of ge)
                    Q.addOpList(ye), me || (me = ve), xe || (xe = Ce);
                  return Q.flush(!0, {
                    form: me,
                    canvas: xe
                  }), {
                    length: Q.totalLength
                  };
                });
              });
            }
            extractTextContent({
              handler: G,
              task: N,
              includeMarkedContent: q,
              disableNormalization: ie,
              sink: oe
            }) {
              const fe = this.getContentStream(), Y = this.loadResources(["ExtGState", "Font", "Properties", "XObject"]);
              return Promise.all([fe, Y]).then(([se]) => new O.PartialEvaluator({
                xref: this.xref,
                handler: G,
                pageIndex: this.pageIndex,
                idFactory: this._localIdFactory,
                fontCache: this.fontCache,
                builtInCMapCache: this.builtInCMapCache,
                standardFontDataCache: this.standardFontDataCache,
                globalImageCache: this.globalImageCache,
                systemFontCache: this.systemFontCache,
                options: this.evaluatorOptions
              }).getTextContent({
                stream: se,
                task: N,
                resources: this.resources,
                includeMarkedContent: q,
                disableNormalization: ie,
                sink: oe,
                viewBox: this.view
              }));
            }
            async getStructTree() {
              const G = await this.pdfManager.ensureCatalog("structTreeRoot");
              return G ? (await this._parsedAnnotations, (await this.pdfManager.ensure(this, "_parseStructTree", [G])).serializable) : null;
            }
            _parseStructTree(G) {
              const N = new $.StructTreePage(G, this.pageDict);
              return N.parse(this.ref), N;
            }
            async getAnnotationsData(G, N, q) {
              const ie = await this._parsedAnnotations;
              if (ie.length === 0)
                return ie;
              const oe = [], fe = [];
              let Y;
              const ae = !!(q & s.RenderingIntentFlag.ANY), se = !!(q & s.RenderingIntentFlag.DISPLAY), L = !!(q & s.RenderingIntentFlag.PRINT);
              for (const W of ie) {
                const M = ae || se && W.viewable;
                (M || L && W.printable) && oe.push(W.data), W.hasTextContent && M && (Y || (Y = new O.PartialEvaluator({
                  xref: this.xref,
                  handler: G,
                  pageIndex: this.pageIndex,
                  idFactory: this._localIdFactory,
                  fontCache: this.fontCache,
                  builtInCMapCache: this.builtInCMapCache,
                  standardFontDataCache: this.standardFontDataCache,
                  globalImageCache: this.globalImageCache,
                  systemFontCache: this.systemFontCache,
                  options: this.evaluatorOptions
                })), fe.push(W.extractTextContent(Y, N, [-1 / 0, -1 / 0, 1 / 0, 1 / 0]).catch(function(X) {
                  (0, s.warn)(`getAnnotationsData - ignoring textContent during "${N.name}" task: "${X}".`);
                })));
              }
              return await Promise.all(fe), oe;
            }
            get annotations() {
              const G = this._getInheritableProperty("Annots");
              return (0, s.shadow)(this, "annotations", Array.isArray(G) ? G : []);
            }
            get _parsedAnnotations() {
              const G = this.pdfManager.ensure(this, "annotations").then(async (N) => {
                if (N.length === 0)
                  return N;
                const q = await this.pdfManager.ensureDoc("annotationGlobals");
                if (!q)
                  return [];
                const ie = [];
                for (const Y of N)
                  ie.push(h.AnnotationFactory.create(this.xref, Y, q, this._localIdFactory, !1, this.ref).catch(function(ae) {
                    return (0, s.warn)(`_parsedAnnotations: "${ae}".`), null;
                  }));
                const oe = [];
                let fe;
                for (const Y of await Promise.all(ie))
                  if (Y) {
                    if (Y instanceof h.PopupAnnotation) {
                      (fe || (fe = [])).push(Y);
                      continue;
                    }
                    oe.push(Y);
                  }
                return fe && oe.push(...fe), oe;
              });
              return (0, s.shadow)(this, "_parsedAnnotations", G);
            }
            get jsActions() {
              const G = (0, g.collectActions)(this.xref, this.pageDict, s.PageActionEventType);
              return (0, s.shadow)(this, "jsActions", G);
            }
          }
          V = new WeakSet(), jd = function(G, N, q) {
            for (const ie of G)
              if (ie.id) {
                const oe = t.Ref.fromString(ie.id);
                if (!oe) {
                  (0, s.warn)(`A non-linked annotation cannot be modified: ${ie.id}`);
                  continue;
                }
                if (ie.deleted) {
                  N.put(oe);
                  continue;
                }
                q == null || q.put(oe), ie.ref = oe, delete ie.id;
              }
          }, c.Page = A;
          const k = new Uint8Array([37, 80, 68, 70, 45]), z = new Uint8Array([115, 116, 97, 114, 116, 120, 114, 101, 102]), T = new Uint8Array([101, 110, 100, 111, 98, 106]), w = 1024, F = "\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0";
          function j(te, G, N = 1024, q = !1) {
            const ie = G.length, oe = te.peekBytes(N), fe = oe.length - ie;
            if (fe <= 0)
              return !1;
            if (q) {
              const Y = ie - 1;
              let ae = oe.length - 1;
              for (; ae >= Y; ) {
                let se = 0;
                for (; se < ie && oe[ae - se] === G[Y - se]; )
                  se++;
                if (se >= ie)
                  return te.pos += ae - Y, !0;
                ae--;
              }
            } else {
              let Y = 0;
              for (; Y <= fe; ) {
                let ae = 0;
                for (; ae < ie && oe[Y + ae] === G[ae]; )
                  ae++;
                if (ae >= ie)
                  return te.pos += Y, !0;
                Y++;
              }
            }
            return !1;
          }
          class P {
            constructor(G, N) {
              zn(this, ne);
              if (N.length <= 0)
                throw new s.InvalidPDFException("The PDF file is empty, i.e. its size is zero bytes.");
              this.pdfManager = G, this.stream = N, this.xref = new B.XRef(N, G), this._pagePromises = /* @__PURE__ */ new Map(), this._version = null;
              const q = {
                font: 0
              };
              this._globalIdFactory = class {
                static getDocId() {
                  return `g_${G.docId}`;
                }
                static createFontId() {
                  return `f${++q.font}`;
                }
                static createObjId() {
                  (0, s.unreachable)("Abstract method `createObjId` called.");
                }
                static getPageObjId() {
                  (0, s.unreachable)("Abstract method `getPageObjId` called.");
                }
              };
            }
            parse(G) {
              this.xref.parse(G), this.catalog = new E.Catalog(this.pdfManager, this.xref);
            }
            get linearization() {
              let G = null;
              try {
                G = x.Linearization.create(this.stream);
              } catch (N) {
                if (N instanceof g.MissingDataException)
                  throw N;
                (0, s.info)(N);
              }
              return (0, s.shadow)(this, "linearization", G);
            }
            get startXRef() {
              const G = this.stream;
              let N = 0;
              if (this.linearization)
                G.reset(), j(G, T) && (N = G.pos + 6 - G.start);
              else {
                const ie = z.length;
                let oe = !1, fe = G.end;
                for (; !oe && fe > 0; )
                  fe -= 1024 - ie, fe < 0 && (fe = 0), G.pos = fe, oe = j(G, z, 1024, !0);
                if (oe) {
                  G.skip(9);
                  let Y;
                  do
                    Y = G.getByte();
                  while ((0, g.isWhiteSpace)(Y));
                  let ae = "";
                  for (; Y >= 32 && Y <= 57; )
                    ae += String.fromCharCode(Y), Y = G.getByte();
                  N = parseInt(ae, 10), isNaN(N) && (N = 0);
                }
              }
              return (0, s.shadow)(this, "startXRef", N);
            }
            checkHeader() {
              const G = this.stream;
              if (G.reset(), !j(G, k))
                return;
              G.moveStart(), G.skip(k.length);
              let N = "", q;
              for (; (q = G.getByte()) > 32 && N.length < 7; )
                N += String.fromCharCode(q);
              g.PDF_VERSION_REGEXP.test(N) ? this._version = N : (0, s.warn)(`Invalid PDF header version: ${N}`);
            }
            parseStartXRef() {
              this.xref.setStartXRef(this.startXRef);
            }
            get numPages() {
              let G = 0;
              return this.catalog.hasActualNumPages ? G = this.catalog.numPages : this.xfaFactory ? G = this.xfaFactory.getNumPages() : this.linearization ? G = this.linearization.numPages : G = this.catalog.numPages, (0, s.shadow)(this, "numPages", G);
            }
            _hasOnlyDocumentSignatures(G, N = 0) {
              return Array.isArray(G) ? G.every((ie) => {
                if (ie = this.xref.fetchIfRef(ie), !(ie instanceof t.Dict))
                  return !1;
                if (ie.has("Kids"))
                  return ++N > 10 ? ((0, s.warn)("_hasOnlyDocumentSignatures: maximum recursion depth reached"), !1) : this._hasOnlyDocumentSignatures(ie.get("Kids"), N);
                const oe = (0, t.isName)(ie.get("FT"), "Sig"), fe = ie.get("Rect"), Y = Array.isArray(fe) && fe.every((ae) => ae === 0);
                return oe && Y;
              }) : !1;
            }
            get _xfaStreams() {
              const G = this.catalog.acroForm;
              if (!G)
                return null;
              const N = G.get("XFA"), q = {
                "xdp:xdp": "",
                template: "",
                datasets: "",
                config: "",
                connectionSet: "",
                localeSet: "",
                stylesheet: "",
                "/xdp:xdp": ""
              };
              if (N instanceof m.BaseStream && !N.isEmpty)
                return q["xdp:xdp"] = N, q;
              if (!Array.isArray(N) || N.length === 0)
                return null;
              for (let ie = 0, oe = N.length; ie < oe; ie += 2) {
                let fe;
                if (ie === 0 ? fe = "xdp:xdp" : ie === oe - 2 ? fe = "/xdp:xdp" : fe = N[ie], !q.hasOwnProperty(fe))
                  continue;
                const Y = this.xref.fetchIfRef(N[ie + 1]);
                !(Y instanceof m.BaseStream) || Y.isEmpty || (q[fe] = Y);
              }
              return q;
            }
            get xfaDatasets() {
              const G = this._xfaStreams;
              if (!G)
                return (0, s.shadow)(this, "xfaDatasets", null);
              for (const N of ["datasets", "xdp:xdp"]) {
                const q = G[N];
                if (q)
                  try {
                    const ie = (0, s.stringToUTF8String)(q.getString()), oe = {
                      [N]: ie
                    };
                    return (0, s.shadow)(this, "xfaDatasets", new y.DatasetReader(oe));
                  } catch {
                    (0, s.warn)("XFA - Invalid utf-8 string.");
                    break;
                  }
              }
              return (0, s.shadow)(this, "xfaDatasets", null);
            }
            get xfaData() {
              const G = this._xfaStreams;
              if (!G)
                return null;
              const N = /* @__PURE__ */ Object.create(null);
              for (const [q, ie] of Object.entries(G))
                if (ie)
                  try {
                    N[q] = (0, s.stringToUTF8String)(ie.getString());
                  } catch {
                    return (0, s.warn)("XFA - Invalid utf-8 string."), null;
                  }
              return N;
            }
            get xfaFactory() {
              let G;
              return this.pdfManager.enableXfa && this.catalog.needsRendering && this.formInfo.hasXfa && !this.formInfo.hasAcroForm && (G = this.xfaData), (0, s.shadow)(this, "xfaFactory", G ? new H.XFAFactory(G) : null);
            }
            get isPureXfa() {
              return this.xfaFactory ? this.xfaFactory.isValid() : !1;
            }
            get htmlForXfa() {
              return this.xfaFactory ? this.xfaFactory.getPages() : null;
            }
            async loadXfaImages() {
              const G = await this.pdfManager.ensureCatalog("xfaImages");
              if (!G)
                return;
              const N = G.getKeys();
              await new u.ObjectLoader(G, N, this.xref).load();
              const ie = /* @__PURE__ */ new Map();
              for (const oe of N) {
                const fe = G.get(oe);
                fe instanceof m.BaseStream && ie.set(oe, fe.getBytes());
              }
              this.xfaFactory.setImages(ie);
            }
            async loadXfaFonts(G, N) {
              const q = await this.pdfManager.ensureCatalog("acroForm");
              if (!q)
                return;
              const ie = await q.getAsync("DR");
              if (!(ie instanceof t.Dict))
                return;
              await new u.ObjectLoader(ie, ["Font"], this.xref).load();
              const fe = ie.get("Font");
              if (!(fe instanceof t.Dict))
                return;
              const Y = Object.assign(/* @__PURE__ */ Object.create(null), this.pdfManager.evaluatorOptions);
              Y.useSystemFonts = !1;
              const ae = new O.PartialEvaluator({
                xref: this.xref,
                handler: G,
                pageIndex: -1,
                idFactory: this._globalIdFactory,
                fontCache: this.catalog.fontCache,
                builtInCMapCache: this.catalog.builtInCMapCache,
                standardFontDataCache: this.catalog.standardFontDataCache,
                options: Y
              }), se = new I.OperatorList(), L = [], W = {
                get font() {
                  return L.at(-1);
                },
                set font(re) {
                  L.push(re);
                },
                clone() {
                  return this;
                }
              }, M = /* @__PURE__ */ new Map();
              fe.forEach((re, le) => {
                M.set(re, le);
              });
              const X = [];
              for (const [re, le] of M) {
                const ce = le.get("FontDescriptor");
                if (!(ce instanceof t.Dict))
                  continue;
                let ee = ce.get("FontFamily");
                ee = ee.replaceAll(/[ ]+(\d)/g, "$1");
                const he = ce.get("FontWeight"), pe = -ce.get("ItalicAngle"), de = {
                  fontFamily: ee,
                  fontWeight: he,
                  italicAngle: pe
                };
                (0, g.validateCSSFont)(de) && X.push(ae.handleSetFont(ie, [t.Name.get(re), 1], null, se, N, W, null, de).catch(function(ge) {
                  return (0, s.warn)(`loadXfaFonts: "${ge}".`), null;
                }));
              }
              await Promise.all(X);
              const U = this.xfaFactory.setFonts(L);
              if (!U)
                return;
              Y.ignoreErrors = !0, X.length = 0, L.length = 0;
              const Q = /* @__PURE__ */ new Set();
              for (const re of U)
                (0, i.getXfaFontName)(`${re}-Regular`) || Q.add(re);
              Q.size && U.push("PdfJS-Fallback");
              for (const re of U)
                if (!Q.has(re))
                  for (const le of [{
                    name: "Regular",
                    fontWeight: 400,
                    italicAngle: 0
                  }, {
                    name: "Bold",
                    fontWeight: 700,
                    italicAngle: 0
                  }, {
                    name: "Italic",
                    fontWeight: 400,
                    italicAngle: 12
                  }, {
                    name: "BoldItalic",
                    fontWeight: 700,
                    italicAngle: 12
                  }]) {
                    const ce = `${re}-${le.name}`, ee = (0, i.getXfaFontDict)(ce);
                    X.push(ae.handleSetFont(ie, [t.Name.get(ce), 1], null, se, N, W, ee, {
                      fontFamily: re,
                      fontWeight: le.fontWeight,
                      italicAngle: le.italicAngle
                    }).catch(function(he) {
                      return (0, s.warn)(`loadXfaFonts: "${he}".`), null;
                    }));
                  }
              await Promise.all(X), this.xfaFactory.appendFonts(L, Q);
            }
            async serializeXfaData(G) {
              return this.xfaFactory ? this.xfaFactory.serializeData(G) : null;
            }
            get version() {
              return this.catalog.version || this._version;
            }
            get formInfo() {
              const G = {
                hasFields: !1,
                hasAcroForm: !1,
                hasXfa: !1,
                hasSignatures: !1
              }, N = this.catalog.acroForm;
              if (!N)
                return (0, s.shadow)(this, "formInfo", G);
              try {
                const q = N.get("Fields"), ie = Array.isArray(q) && q.length > 0;
                G.hasFields = ie;
                const oe = N.get("XFA");
                G.hasXfa = Array.isArray(oe) && oe.length > 0 || oe instanceof m.BaseStream && !oe.isEmpty;
                const Y = !!(N.get("SigFlags") & 1), ae = Y && this._hasOnlyDocumentSignatures(q);
                G.hasAcroForm = ie && !ae, G.hasSignatures = Y;
              } catch (q) {
                if (q instanceof g.MissingDataException)
                  throw q;
                (0, s.warn)(`Cannot fetch form information: "${q}".`);
              }
              return (0, s.shadow)(this, "formInfo", G);
            }
            get documentInfo() {
              const G = {
                PDFFormatVersion: this.version,
                Language: this.catalog.lang,
                EncryptFilterName: this.xref.encrypt ? this.xref.encrypt.filterName : null,
                IsLinearized: !!this.linearization,
                IsAcroFormPresent: this.formInfo.hasAcroForm,
                IsXFAPresent: this.formInfo.hasXfa,
                IsCollectionPresent: !!this.catalog.collection,
                IsSignaturesPresent: this.formInfo.hasSignatures
              };
              let N;
              try {
                N = this.xref.trailer.get("Info");
              } catch (q) {
                if (q instanceof g.MissingDataException)
                  throw q;
                (0, s.info)("The document information dictionary is invalid.");
              }
              if (!(N instanceof t.Dict))
                return (0, s.shadow)(this, "documentInfo", G);
              for (const q of N.getKeys()) {
                const ie = N.get(q);
                switch (q) {
                  case "Title":
                  case "Author":
                  case "Subject":
                  case "Keywords":
                  case "Creator":
                  case "Producer":
                  case "CreationDate":
                  case "ModDate":
                    if (typeof ie == "string") {
                      G[q] = (0, s.stringToPDFString)(ie);
                      continue;
                    }
                    break;
                  case "Trapped":
                    if (ie instanceof t.Name) {
                      G[q] = ie;
                      continue;
                    }
                    break;
                  default:
                    let oe;
                    switch (typeof ie) {
                      case "string":
                        oe = (0, s.stringToPDFString)(ie);
                        break;
                      case "number":
                      case "boolean":
                        oe = ie;
                        break;
                      default:
                        ie instanceof t.Name && (oe = ie);
                        break;
                    }
                    if (oe === void 0) {
                      (0, s.warn)(`Bad value, for custom key "${q}", in Info: ${ie}.`);
                      continue;
                    }
                    G.Custom || (G.Custom = /* @__PURE__ */ Object.create(null)), G.Custom[q] = oe;
                    continue;
                }
                (0, s.warn)(`Bad value, for key "${q}", in Info: ${ie}.`);
              }
              return (0, s.shadow)(this, "documentInfo", G);
            }
            get fingerprints() {
              function G(fe) {
                return typeof fe == "string" && fe.length > 0 && fe !== F;
              }
              function N(fe) {
                const Y = [];
                for (const ae of fe) {
                  const se = ae.toString(16);
                  Y.push(se.padStart(2, "0"));
                }
                return Y.join("");
              }
              const q = this.xref.trailer.get("ID");
              let ie, oe;
              return Array.isArray(q) && G(q[0]) ? (ie = (0, s.stringToBytes)(q[0]), q[1] !== q[0] && G(q[1]) && (oe = (0, s.stringToBytes)(q[1]))) : ie = (0, v.calculateMD5)(this.stream.getByteRange(0, w), 0, w), (0, s.shadow)(this, "fingerprints", [N(ie), oe ? N(oe) : null]);
            }
            async _getLinearizationPage(G) {
              const {
                catalog: N,
                linearization: q,
                xref: ie
              } = this, oe = t.Ref.get(q.objectNumberFirst, 0);
              try {
                const fe = await ie.fetchAsync(oe);
                if (fe instanceof t.Dict) {
                  let Y = fe.getRaw("Type");
                  if (Y instanceof t.Ref && (Y = await ie.fetchAsync(Y)), (0, t.isName)(Y, "Page") || !fe.has("Type") && !fe.has("Kids"))
                    return N.pageKidsCountCache.has(oe) || N.pageKidsCountCache.put(oe, 1), N.pageIndexCache.has(oe) || N.pageIndexCache.put(oe, 0), [fe, oe];
                }
                throw new s.FormatError("The Linearization dictionary doesn't point to a valid Page dictionary.");
              } catch (fe) {
                return (0, s.warn)(`_getLinearizationPage: "${fe.message}".`), N.getPageDict(G);
              }
            }
            getPage(G) {
              const N = this._pagePromises.get(G);
              if (N)
                return N;
              const {
                catalog: q,
                linearization: ie,
                xfaFactory: oe
              } = this;
              let fe;
              return oe ? fe = Promise.resolve([t.Dict.empty, null]) : (ie == null ? void 0 : ie.pageFirst) === G ? fe = this._getLinearizationPage(G) : fe = q.getPageDict(G), fe = fe.then(([Y, ae]) => new A({
                pdfManager: this.pdfManager,
                xref: this.xref,
                pageIndex: G,
                pageDict: Y,
                ref: ae,
                globalIdFactory: this._globalIdFactory,
                fontCache: q.fontCache,
                builtInCMapCache: q.builtInCMapCache,
                standardFontDataCache: q.standardFontDataCache,
                globalImageCache: q.globalImageCache,
                systemFontCache: q.systemFontCache,
                nonBlendModesSet: q.nonBlendModesSet,
                xfaFactory: oe
              })), this._pagePromises.set(G, fe), fe;
            }
            async checkFirstPage(G = !1) {
              if (!G)
                try {
                  await this.getPage(0);
                } catch (N) {
                  if (N instanceof g.XRefEntryException)
                    throw this._pagePromises.delete(0), await this.cleanup(), new g.XRefParseException();
                }
            }
            async checkLastPage(G = !1) {
              const {
                catalog: N,
                pdfManager: q
              } = this;
              N.setActualNumPages();
              let ie;
              try {
                if (await Promise.all([q.ensureDoc("xfaFactory"), q.ensureDoc("linearization"), q.ensureCatalog("numPages")]), this.xfaFactory)
                  return;
                if (this.linearization ? ie = this.linearization.numPages : ie = N.numPages, Number.isInteger(ie)) {
                  if (ie <= 1)
                    return;
                } else throw new s.FormatError("Page count is not an integer.");
                await this.getPage(ie - 1);
              } catch (oe) {
                if (this._pagePromises.delete(ie - 1), await this.cleanup(), oe instanceof g.XRefEntryException && !G)
                  throw new g.XRefParseException();
                (0, s.warn)(`checkLastPage - invalid /Pages tree /Count: ${ie}.`);
                let fe;
                try {
                  fe = await N.getAllPageDicts(G);
                } catch (Y) {
                  if (Y instanceof g.XRefEntryException && !G)
                    throw new g.XRefParseException();
                  N.setActualNumPages(1);
                  return;
                }
                for (const [Y, [ae, se]] of fe) {
                  let L;
                  ae instanceof Error ? (L = Promise.reject(ae), L.catch(() => {
                  })) : L = Promise.resolve(new A({
                    pdfManager: q,
                    xref: this.xref,
                    pageIndex: Y,
                    pageDict: ae,
                    ref: se,
                    globalIdFactory: this._globalIdFactory,
                    fontCache: N.fontCache,
                    builtInCMapCache: N.builtInCMapCache,
                    standardFontDataCache: N.standardFontDataCache,
                    globalImageCache: N.globalImageCache,
                    systemFontCache: N.systemFontCache,
                    nonBlendModesSet: N.nonBlendModesSet,
                    xfaFactory: null
                  })), this._pagePromises.set(Y, L);
                }
                N.setActualNumPages(fe.size);
              }
            }
            fontFallback(G, N) {
              return this.catalog.fontFallback(G, N);
            }
            async cleanup(G = !1) {
              return this.catalog ? this.catalog.cleanup(G) : (0, S.clearGlobalCaches)();
            }
            get fieldObjects() {
              if (!this.formInfo.hasFields)
                return (0, s.shadow)(this, "fieldObjects", Promise.resolve(null));
              const G = this.pdfManager.ensureDoc("annotationGlobals").then(async (N) => {
                if (!N)
                  return null;
                const q = /* @__PURE__ */ Object.create(null), ie = /* @__PURE__ */ new Map();
                for (const fe of this.catalog.acroForm.get("Fields"))
                  Nt(this, ne, Rd).call(this, "", fe, ie, N);
                const oe = [];
                for (const [fe, Y] of ie)
                  oe.push(Promise.all(Y).then((ae) => {
                    ae = ae.filter((se) => !!se), ae.length > 0 && (q[fe] = ae);
                  }));
                return await Promise.all(oe), q;
              });
              return (0, s.shadow)(this, "fieldObjects", G);
            }
            get hasJSActions() {
              const G = this.pdfManager.ensureDoc("_parseHasJSActions");
              return (0, s.shadow)(this, "hasJSActions", G);
            }
            async _parseHasJSActions() {
              const [G, N] = await Promise.all([this.pdfManager.ensureCatalog("jsActions"), this.pdfManager.ensureDoc("fieldObjects")]);
              return G ? !0 : N ? Object.values(N).some((q) => q.some((ie) => ie.actions !== null)) : !1;
            }
            get calculationOrderIds() {
              const G = this.catalog.acroForm;
              if (!(G != null && G.has("CO")))
                return (0, s.shadow)(this, "calculationOrderIds", null);
              const N = G.get("CO");
              if (!Array.isArray(N) || N.length === 0)
                return (0, s.shadow)(this, "calculationOrderIds", null);
              const q = [];
              for (const ie of N)
                ie instanceof t.Ref && q.push(ie.toString());
              return q.length === 0 ? (0, s.shadow)(this, "calculationOrderIds", null) : (0, s.shadow)(this, "calculationOrderIds", q);
            }
            get annotationGlobals() {
              return (0, s.shadow)(this, "annotationGlobals", h.AnnotationFactory.createGlobals(this.pdfManager));
            }
          }
          ne = new WeakSet(), Rd = function(G, N, q, ie) {
            const oe = this.xref.fetchIfRef(N);
            if (oe.has("T")) {
              const fe = (0, s.stringToPDFString)(oe.get("T"));
              G = G === "" ? fe : `${G}.${fe}`;
            }
            if (q.has(G) || q.set(G, []), q.get(G).push(h.AnnotationFactory.create(this.xref, N, ie, this._localIdFactory, !0, null).then((fe) => fe == null ? void 0 : fe.getFieldObject()).catch(function(fe) {
              return (0, s.warn)(`#collectFieldObjects: "${fe}".`), null;
            })), oe.has("Kids"))
              for (const fe of oe.get("Kids"))
                Nt(this, ne, Rd).call(this, G, fe, q, ie);
          }, c.PDFDocument = P;
        },
        /* 10 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.PopupAnnotation = c.MarkupAnnotation = c.AnnotationFactory = c.AnnotationBorderStyle = c.Annotation = void 0, c.getQuadPoints = H;
          var s = f(2), h = f(3), g = f(11), t = f(4), i = f(8), m = f(5), v = f(60), E = f(66), S = f(12), y = f(69), x = f(26), b = f(76), u = f(64), I = f(73), O = f(77);
          class D {
            static createGlobals(M) {
              return Promise.all([M.ensureCatalog("acroForm"), M.ensureDoc("xfaDatasets"), M.ensureCatalog("structTreeRoot"), M.ensureCatalog("baseUrl"), M.ensureCatalog("attachments")]).then(([X, U, Q, re, le]) => ({
                pdfManager: M,
                acroForm: X instanceof t.Dict ? X : t.Dict.empty,
                xfaDatasets: U,
                structTreeRoot: Q,
                baseUrl: re,
                attachments: le
              }), (X) => ((0, s.warn)(`createGlobals: "${X}".`), null));
            }
            static async create(M, X, U, Q, re, le) {
              const ce = re ? await this._getPageIndex(M, X, U.pdfManager) : null;
              return U.pdfManager.ensure(this, "_create", [M, X, U, Q, re, ce, le]);
            }
            static _create(M, X, U, Q, re = !1, le = null, ce = null) {
              const ee = M.fetchIfRef(X);
              if (!(ee instanceof t.Dict))
                return;
              const {
                acroForm: he,
                pdfManager: pe
              } = U, de = X instanceof t.Ref ? X.toString() : `annot_${Q.createObjId()}`;
              let ge = ee.get("Subtype");
              ge = ge instanceof t.Name ? ge.name : null;
              const me = {
                xref: M,
                ref: X,
                dict: ee,
                subtype: ge,
                id: de,
                annotationGlobals: U,
                collectFields: re,
                needAppearances: !re && he.get("NeedAppearances") === !0,
                pageIndex: le,
                evaluatorOptions: pe.evaluatorOptions,
                pageRef: ce
              };
              switch (ge) {
                case "Link":
                  return new P(me);
                case "Text":
                  return new j(me);
                case "Widget":
                  let xe = (0, h.getInheritableProperty)({
                    dict: ee,
                    key: "FT"
                  });
                  switch (xe = xe instanceof t.Name ? xe.name : null, xe) {
                    case "Tx":
                      return new z(me);
                    case "Btn":
                      return new T(me);
                    case "Ch":
                      return new w(me);
                    case "Sig":
                      return new F(me);
                  }
                  return (0, s.warn)(`Unimplemented widget field type "${xe}", falling back to base field type.`), new k(me);
                case "Popup":
                  return new V(me);
                case "FreeText":
                  return new J(me);
                case "Line":
                  return new ne(me);
                case "Square":
                  return new Z(me);
                case "Circle":
                  return new te(me);
                case "PolyLine":
                  return new G(me);
                case "Polygon":
                  return new N(me);
                case "Caret":
                  return new q(me);
                case "Ink":
                  return new ie(me);
                case "Highlight":
                  return new oe(me);
                case "Underline":
                  return new fe(me);
                case "Squiggly":
                  return new Y(me);
                case "StrikeOut":
                  return new ae(me);
                case "Stamp":
                  return new se(me);
                case "FileAttachment":
                  return new L(me);
                default:
                  return re || (ge ? (0, s.warn)(`Unimplemented annotation type "${ge}", falling back to base annotation.`) : (0, s.warn)("Annotation is missing the required /Subtype.")), new R(me);
              }
            }
            static async _getPageIndex(M, X, U) {
              try {
                const Q = await M.fetchIfRefAsync(X);
                if (!(Q instanceof t.Dict))
                  return -1;
                const re = Q.getRaw("P");
                if (re instanceof t.Ref)
                  try {
                    return await U.ensureCatalog("getPageIndex", [re]);
                  } catch (ce) {
                    (0, s.info)(`_getPageIndex -- not a valid page reference: "${ce}".`);
                  }
                if (Q.has("Kids"))
                  return -1;
                const le = await U.ensureDoc("numPages");
                for (let ce = 0; ce < le; ce++) {
                  const ee = await U.getPage(ce), he = await U.ensure(ee, "annotations");
                  for (const pe of he)
                    if (pe instanceof t.Ref && (0, t.isRefsEqual)(pe, X))
                      return ce;
                }
              } catch (Q) {
                (0, s.warn)(`_getPageIndex: "${Q}".`);
              }
              return -1;
            }
            static generateImages(M, X, U) {
              if (!U)
                return (0, s.warn)("generateImages: OffscreenCanvas is not supported, cannot save or print some annotations with images."), null;
              let Q;
              for (const {
                bitmapId: re,
                bitmap: le
              } of M)
                le && (Q || (Q = /* @__PURE__ */ new Map()), Q.set(re, se.createImage(le, X)));
              return Q;
            }
            static async saveNewAnnotations(M, X, U, Q) {
              const re = M.xref;
              let le;
              const ce = [], ee = [], {
                isOffscreenCanvasSupported: he
              } = M.options;
              for (const pe of U)
                if (!pe.deleted)
                  switch (pe.annotationType) {
                    case s.AnnotationEditorType.FREETEXT:
                      if (!le) {
                        const ge = new t.Dict(re);
                        ge.set("BaseFont", t.Name.get("Helvetica")), ge.set("Type", t.Name.get("Font")), ge.set("Subtype", t.Name.get("Type1")), ge.set("Encoding", t.Name.get("WinAnsiEncoding"));
                        const me = [];
                        le = re.getNewTemporaryRef(), await (0, I.writeObject)(le, ge, me, re), ce.push({
                          ref: le,
                          data: me.join("")
                        });
                      }
                      ee.push(J.createNewAnnotation(re, pe, ce, {
                        evaluator: M,
                        task: X,
                        baseFontRef: le
                      }));
                      break;
                    case s.AnnotationEditorType.INK:
                      ee.push(ie.createNewAnnotation(re, pe, ce));
                      break;
                    case s.AnnotationEditorType.STAMP:
                      if (!he)
                        break;
                      const de = await Q.get(pe.bitmapId);
                      if (de.imageStream) {
                        const {
                          imageStream: ge,
                          smaskStream: me
                        } = de, xe = [];
                        if (me) {
                          const ve = re.getNewTemporaryRef();
                          await (0, I.writeObject)(ve, me, xe, re), ce.push({
                            ref: ve,
                            data: xe.join("")
                          }), ge.dict.set("SMask", ve), xe.length = 0;
                        }
                        const ye = de.imageRef = re.getNewTemporaryRef();
                        await (0, I.writeObject)(ye, ge, xe, re), ce.push({
                          ref: ye,
                          data: xe.join("")
                        }), de.imageStream = de.smaskStream = null;
                      }
                      ee.push(se.createNewAnnotation(re, pe, ce, {
                        image: de
                      }));
                      break;
                  }
              return {
                annotations: await Promise.all(ee),
                dependencies: ce
              };
            }
            static async printNewAnnotations(M, X, U, Q, re) {
              if (!Q)
                return null;
              const {
                options: le,
                xref: ce
              } = X, ee = [];
              for (const he of Q)
                if (!he.deleted)
                  switch (he.annotationType) {
                    case s.AnnotationEditorType.FREETEXT:
                      ee.push(J.createNewPrintAnnotation(M, ce, he, {
                        evaluator: X,
                        task: U,
                        evaluatorOptions: le
                      }));
                      break;
                    case s.AnnotationEditorType.INK:
                      ee.push(ie.createNewPrintAnnotation(M, ce, he, {
                        evaluatorOptions: le
                      }));
                      break;
                    case s.AnnotationEditorType.STAMP:
                      if (!le.isOffscreenCanvasSupported)
                        break;
                      const pe = await re.get(he.bitmapId);
                      if (pe.imageStream) {
                        const {
                          imageStream: de,
                          smaskStream: ge
                        } = pe;
                        ge && de.dict.set("SMask", ge), pe.imageRef = new x.JpegStream(de, de.length), pe.imageStream = pe.smaskStream = null;
                      }
                      ee.push(se.createNewPrintAnnotation(M, ce, he, {
                        image: pe,
                        evaluatorOptions: le
                      }));
                      break;
                  }
              return Promise.all(ee);
            }
          }
          c.AnnotationFactory = D;
          function $(W, M = new Uint8ClampedArray(3)) {
            if (!Array.isArray(W))
              return M;
            const X = M || new Uint8ClampedArray(3);
            switch (W.length) {
              case 0:
                return null;
              case 1:
                return S.ColorSpace.singletons.gray.getRgbItem(W, 0, X, 0), X;
              case 3:
                return S.ColorSpace.singletons.rgb.getRgbItem(W, 0, X, 0), X;
              case 4:
                return S.ColorSpace.singletons.cmyk.getRgbItem(W, 0, X, 0), X;
              default:
                return M;
            }
          }
          function K(W) {
            return Array.from(W, (M) => M / 255);
          }
          function H(W, M) {
            const X = W.getArray("QuadPoints");
            if (!Array.isArray(X) || X.length === 0 || X.length % 8 > 0)
              return null;
            const U = [];
            for (let Q = 0, re = X.length / 8; Q < re; Q++) {
              let le = 1 / 0, ce = -1 / 0, ee = 1 / 0, he = -1 / 0;
              for (let pe = Q * 8, de = Q * 8 + 8; pe < de; pe += 2) {
                const ge = X[pe], me = X[pe + 1];
                le = Math.min(ge, le), ce = Math.max(ge, ce), ee = Math.min(me, ee), he = Math.max(me, he);
              }
              if (M !== null && (le < M[0] || ce > M[2] || ee < M[1] || he > M[3]))
                return null;
              U.push([{
                x: le,
                y: he
              }, {
                x: ce,
                y: he
              }, {
                x: le,
                y: ee
              }, {
                x: ce,
                y: ee
              }]);
            }
            return U;
          }
          function B(W, M, X) {
            const [U, Q, re, le] = s.Util.getAxialAlignedBoundingBox(M, X);
            if (U === re || Q === le)
              return [1, 0, 0, 1, W[0], W[1]];
            const ce = (W[2] - W[0]) / (re - U), ee = (W[3] - W[1]) / (le - Q);
            return [ce, 0, 0, ee, W[0] - U * ce, W[1] - Q * ee];
          }
          class R {
            constructor(M) {
              const {
                dict: X,
                xref: U,
                annotationGlobals: Q
              } = M;
              this.setTitle(X.get("T")), this.setContents(X.get("Contents")), this.setModificationDate(X.get("M")), this.setFlags(X.get("F")), this.setRectangle(X.getArray("Rect")), this.setColor(X.getArray("C")), this.setBorderStyle(X), this.setAppearance(X), this.setOptionalContent(X);
              const re = X.get("MK");
              this.setBorderAndBackgroundColors(re), this.setRotation(re, X), this.ref = M.ref instanceof t.Ref ? M.ref : null, this._streams = [], this.appearance && this._streams.push(this.appearance);
              const le = !!(this.flags & s.AnnotationFlag.LOCKED), ce = !!(this.flags & s.AnnotationFlag.LOCKEDCONTENTS);
              if (Q.structTreeRoot) {
                let ee = X.get("StructParent");
                ee = Number.isInteger(ee) && ee >= 0 ? ee : -1, Q.structTreeRoot.addAnnotationIdToPage(M.pageRef, ee);
              }
              if (this.data = {
                annotationFlags: this.flags,
                borderStyle: this.borderStyle,
                color: this.color,
                backgroundColor: this.backgroundColor,
                borderColor: this.borderColor,
                rotation: this.rotation,
                contentsObj: this._contents,
                hasAppearance: !!this.appearance,
                id: M.id,
                modificationDate: this.modificationDate,
                rect: this.rectangle,
                subtype: M.subtype,
                hasOwnCanvas: !1,
                noRotate: !!(this.flags & s.AnnotationFlag.NOROTATE),
                noHTML: le && ce
              }, M.collectFields) {
                const ee = X.get("Kids");
                if (Array.isArray(ee)) {
                  const he = [];
                  for (const pe of ee)
                    pe instanceof t.Ref && he.push(pe.toString());
                  he.length !== 0 && (this.data.kidIds = he);
                }
                this.data.actions = (0, h.collectActions)(U, X, s.AnnotationActionEventType), this.data.fieldName = this._constructFieldName(X), this.data.pageIndex = M.pageIndex;
              }
              this._isOffscreenCanvasSupported = M.evaluatorOptions.isOffscreenCanvasSupported, this._fallbackFontDict = null, this._needAppearances = !1;
            }
            _hasFlag(M, X) {
              return !!(M & X);
            }
            _isViewable(M) {
              return !this._hasFlag(M, s.AnnotationFlag.INVISIBLE) && !this._hasFlag(M, s.AnnotationFlag.NOVIEW);
            }
            _isPrintable(M) {
              return this._hasFlag(M, s.AnnotationFlag.PRINT) && !this._hasFlag(M, s.AnnotationFlag.HIDDEN) && !this._hasFlag(M, s.AnnotationFlag.INVISIBLE);
            }
            mustBeViewed(M, X) {
              var Q;
              const U = (Q = M == null ? void 0 : M.get(this.data.id)) == null ? void 0 : Q.noView;
              return U !== void 0 ? !U : this.viewable && !this._hasFlag(this.flags, s.AnnotationFlag.HIDDEN);
            }
            mustBePrinted(M) {
              var U;
              const X = (U = M == null ? void 0 : M.get(this.data.id)) == null ? void 0 : U.noPrint;
              return X !== void 0 ? !X : this.printable;
            }
            get viewable() {
              return this.data.quadPoints === null ? !1 : this.flags === 0 ? !0 : this._isViewable(this.flags);
            }
            get printable() {
              return this.data.quadPoints === null || this.flags === 0 ? !1 : this._isPrintable(this.flags);
            }
            _parseStringHelper(M) {
              const X = typeof M == "string" ? (0, s.stringToPDFString)(M) : "", U = X && (0, v.bidi)(X).dir === "rtl" ? "rtl" : "ltr";
              return {
                str: X,
                dir: U
              };
            }
            setDefaultAppearance(M) {
              const {
                dict: X,
                annotationGlobals: U
              } = M, Q = (0, h.getInheritableProperty)({
                dict: X,
                key: "DA"
              }) || U.acroForm.get("DA");
              this._defaultAppearance = typeof Q == "string" ? Q : "", this.data.defaultAppearanceData = (0, g.parseDefaultAppearance)(this._defaultAppearance);
            }
            setTitle(M) {
              this._title = this._parseStringHelper(M);
            }
            setContents(M) {
              this._contents = this._parseStringHelper(M);
            }
            setModificationDate(M) {
              this.modificationDate = typeof M == "string" ? M : null;
            }
            setFlags(M) {
              this.flags = Number.isInteger(M) && M > 0 ? M : 0;
            }
            hasFlag(M) {
              return this._hasFlag(this.flags, M);
            }
            setRectangle(M) {
              this.rectangle = Array.isArray(M) && M.length === 4 ? s.Util.normalizeRect(M) : [0, 0, 0, 0];
            }
            setColor(M) {
              this.color = $(M);
            }
            setLineEndings(M) {
              if (this.lineEndings = ["None", "None"], Array.isArray(M) && M.length === 2)
                for (let X = 0; X < 2; X++) {
                  const U = M[X];
                  if (U instanceof t.Name)
                    switch (U.name) {
                      case "None":
                        continue;
                      case "Square":
                      case "Circle":
                      case "Diamond":
                      case "OpenArrow":
                      case "ClosedArrow":
                      case "Butt":
                      case "ROpenArrow":
                      case "RClosedArrow":
                      case "Slash":
                        this.lineEndings[X] = U.name;
                        continue;
                    }
                  (0, s.warn)(`Ignoring invalid lineEnding: ${U}`);
                }
            }
            setRotation(M, X) {
              this.rotation = 0;
              let U = M instanceof t.Dict ? M.get("R") || 0 : X.get("Rotate") || 0;
              Number.isInteger(U) && U !== 0 && (U %= 360, U < 0 && (U += 360), U % 90 === 0 && (this.rotation = U));
            }
            setBorderAndBackgroundColors(M) {
              M instanceof t.Dict ? (this.borderColor = $(M.getArray("BC"), null), this.backgroundColor = $(M.getArray("BG"), null)) : this.borderColor = this.backgroundColor = null;
            }
            setBorderStyle(M) {
              if (this.borderStyle = new _(), M instanceof t.Dict)
                if (M.has("BS")) {
                  const X = M.get("BS"), U = X.get("Type");
                  (!U || (0, t.isName)(U, "Border")) && (this.borderStyle.setWidth(X.get("W"), this.rectangle), this.borderStyle.setStyle(X.get("S")), this.borderStyle.setDashArray(X.getArray("D")));
                } else if (M.has("Border")) {
                  const X = M.getArray("Border");
                  Array.isArray(X) && X.length >= 3 && (this.borderStyle.setHorizontalCornerRadius(X[0]), this.borderStyle.setVerticalCornerRadius(X[1]), this.borderStyle.setWidth(X[2], this.rectangle), X.length === 4 && this.borderStyle.setDashArray(X[3], !0));
                } else
                  this.borderStyle.setWidth(0);
            }
            setAppearance(M) {
              this.appearance = null;
              const X = M.get("AP");
              if (!(X instanceof t.Dict))
                return;
              const U = X.get("N");
              if (U instanceof m.BaseStream) {
                this.appearance = U;
                return;
              }
              if (!(U instanceof t.Dict))
                return;
              const Q = M.get("AS");
              if (!(Q instanceof t.Name) || !U.has(Q.name))
                return;
              const re = U.get(Q.name);
              re instanceof m.BaseStream && (this.appearance = re);
            }
            setOptionalContent(M) {
              this.oc = null;
              const X = M.get("OC");
              X instanceof t.Name ? (0, s.warn)("setOptionalContent: Support for /Name-entry is not implemented.") : X instanceof t.Dict && (this.oc = X);
            }
            loadResources(M, X) {
              return X.dict.getAsync("Resources").then((U) => U ? new b.ObjectLoader(U, M, U.xref).load().then(function() {
                return U;
              }) : void 0);
            }
            async getOperatorList(M, X, U, Q, re) {
              const le = this.data;
              let ce = this.appearance;
              const ee = !!(this.data.hasOwnCanvas && U & s.RenderingIntentFlag.DISPLAY);
              if (!ce) {
                if (!ee)
                  return {
                    opList: new u.OperatorList(),
                    separateForm: !1,
                    separateCanvas: !1
                  };
                ce = new i.StringStream(""), ce.dict = new t.Dict();
              }
              const he = ce.dict, pe = await this.loadResources(["ExtGState", "ColorSpace", "Pattern", "Shading", "XObject", "Font"], ce), de = he.getArray("BBox") || [0, 0, 1, 1], ge = he.getArray("Matrix") || [1, 0, 0, 1, 0, 0], me = B(le.rect, de, ge), xe = new u.OperatorList();
              let ye;
              return this.oc && (ye = await M.parseMarkedContentProps(this.oc, null)), ye !== void 0 && xe.addOp(s.OPS.beginMarkedContentProps, ["OC", ye]), xe.addOp(s.OPS.beginAnnotation, [le.id, le.rect, me, ge, ee]), await M.getOperatorList({
                stream: ce,
                task: X,
                resources: pe,
                operatorList: xe,
                fallbackFontDict: this._fallbackFontDict
              }), xe.addOp(s.OPS.endAnnotation, []), ye !== void 0 && xe.addOp(s.OPS.endMarkedContent, []), this.reset(), {
                opList: xe,
                separateForm: !1,
                separateCanvas: ee
              };
            }
            async save(M, X, U) {
              return null;
            }
            get hasTextContent() {
              return !1;
            }
            async extractTextContent(M, X, U) {
              if (!this.appearance)
                return;
              const Q = await this.loadResources(["ExtGState", "Font", "Properties", "XObject"], this.appearance), re = [], le = [];
              let ce = null;
              const ee = {
                desiredSize: Math.Infinity,
                ready: !0,
                enqueue(he, pe) {
                  for (const de of he.items)
                    de.str !== void 0 && (ce || (ce = de.transform.slice(-2)), le.push(de.str), de.hasEOL && (re.push(le.join("")), le.length = 0));
                }
              };
              if (await M.getTextContent({
                stream: this.appearance,
                task: X,
                resources: Q,
                includeMarkedContent: !0,
                sink: ee,
                viewBox: U
              }), this.reset(), le.length && re.push(le.join("")), re.length > 1 || re[0]) {
                const he = this.appearance.dict, pe = he.getArray("BBox") || [0, 0, 1, 1], de = he.getArray("Matrix") || [1, 0, 0, 1, 0, 0], ge = this.data.rect, me = B(ge, pe, de);
                me[4] -= ge[0], me[5] -= ge[1], ce = s.Util.applyTransform(ce, me), ce = s.Util.applyTransform(ce, de), this.data.textPosition = ce, this.data.textContent = re;
              }
            }
            getFieldObject() {
              return this.data.kidIds ? {
                id: this.data.id,
                actions: this.data.actions,
                name: this.data.fieldName,
                strokeColor: this.data.borderColor,
                fillColor: this.data.backgroundColor,
                type: "",
                kidIds: this.data.kidIds,
                page: this.data.pageIndex,
                rotation: this.rotation
              } : null;
            }
            reset() {
              for (const M of this._streams)
                M.reset();
            }
            _constructFieldName(M) {
              if (!M.has("T") && !M.has("Parent"))
                return (0, s.warn)("Unknown field name, falling back to empty field name."), "";
              if (!M.has("Parent"))
                return (0, s.stringToPDFString)(M.get("T"));
              const X = [];
              M.has("T") && X.unshift((0, s.stringToPDFString)(M.get("T")));
              let U = M;
              const Q = new t.RefSet();
              for (M.objId && Q.put(M.objId); U.has("Parent") && (U = U.get("Parent"), !(!(U instanceof t.Dict) || U.objId && Q.has(U.objId))); )
                U.objId && Q.put(U.objId), U.has("T") && X.unshift((0, s.stringToPDFString)(U.get("T")));
              return X.join(".");
            }
          }
          c.Annotation = R;
          class _ {
            constructor() {
              this.width = 1, this.style = s.AnnotationBorderStyleType.SOLID, this.dashArray = [3], this.horizontalCornerRadius = 0, this.verticalCornerRadius = 0;
            }
            setWidth(M, X = [0, 0, 0, 0]) {
              if (M instanceof t.Name) {
                this.width = 0;
                return;
              }
              if (typeof M == "number") {
                if (M > 0) {
                  const U = (X[2] - X[0]) / 2, Q = (X[3] - X[1]) / 2;
                  U > 0 && Q > 0 && (M > U || M > Q) && ((0, s.warn)(`AnnotationBorderStyle.setWidth - ignoring width: ${M}`), M = 1);
                }
                this.width = M;
              }
            }
            setStyle(M) {
              if (M instanceof t.Name)
                switch (M.name) {
                  case "S":
                    this.style = s.AnnotationBorderStyleType.SOLID;
                    break;
                  case "D":
                    this.style = s.AnnotationBorderStyleType.DASHED;
                    break;
                  case "B":
                    this.style = s.AnnotationBorderStyleType.BEVELED;
                    break;
                  case "I":
                    this.style = s.AnnotationBorderStyleType.INSET;
                    break;
                  case "U":
                    this.style = s.AnnotationBorderStyleType.UNDERLINE;
                    break;
                }
            }
            setDashArray(M, X = !1) {
              if (Array.isArray(M) && M.length > 0) {
                let U = !0, Q = !0;
                for (const re of M)
                  if (+re >= 0)
                    re > 0 && (Q = !1);
                  else {
                    U = !1;
                    break;
                  }
                U && !Q ? (this.dashArray = M, X && this.setStyle(t.Name.get("D"))) : this.width = 0;
              } else M && (this.width = 0);
            }
            setHorizontalCornerRadius(M) {
              Number.isInteger(M) && (this.horizontalCornerRadius = M);
            }
            setVerticalCornerRadius(M) {
              Number.isInteger(M) && (this.verticalCornerRadius = M);
            }
          }
          c.AnnotationBorderStyle = _;
          class A extends R {
            constructor(M) {
              super(M);
              const {
                dict: X
              } = M;
              if (X.has("IRT")) {
                const Q = X.getRaw("IRT");
                this.data.inReplyTo = Q instanceof t.Ref ? Q.toString() : null;
                const re = X.get("RT");
                this.data.replyType = re instanceof t.Name ? re.name : s.AnnotationReplyType.REPLY;
              }
              let U = null;
              if (this.data.replyType === s.AnnotationReplyType.GROUP) {
                const Q = X.get("IRT");
                this.setTitle(Q.get("T")), this.data.titleObj = this._title, this.setContents(Q.get("Contents")), this.data.contentsObj = this._contents, Q.has("CreationDate") ? (this.setCreationDate(Q.get("CreationDate")), this.data.creationDate = this.creationDate) : this.data.creationDate = null, Q.has("M") ? (this.setModificationDate(Q.get("M")), this.data.modificationDate = this.modificationDate) : this.data.modificationDate = null, U = Q.getRaw("Popup"), Q.has("C") ? (this.setColor(Q.getArray("C")), this.data.color = this.color) : this.data.color = null;
              } else
                this.data.titleObj = this._title, this.setCreationDate(X.get("CreationDate")), this.data.creationDate = this.creationDate, U = X.getRaw("Popup"), X.has("C") || (this.data.color = null);
              this.data.popupRef = U instanceof t.Ref ? U.toString() : null, X.has("RC") && (this.data.richText = O.XFAFactory.getRichTextAsHtml(X.get("RC")));
            }
            setCreationDate(M) {
              this.creationDate = typeof M == "string" ? M : null;
            }
            _setDefaultAppearance({
              xref: M,
              extra: X,
              strokeColor: U,
              fillColor: Q,
              blendMode: re,
              strokeAlpha: le,
              fillAlpha: ce,
              pointsCallback: ee
            }) {
              let he = Number.MAX_VALUE, pe = Number.MAX_VALUE, de = Number.MIN_VALUE, ge = Number.MIN_VALUE;
              const me = ["q"];
              X && me.push(X), U && me.push(`${U[0]} ${U[1]} ${U[2]} RG`), Q && me.push(`${Q[0]} ${Q[1]} ${Q[2]} rg`);
              let xe = this.data.quadPoints;
              xe || (xe = [[{
                x: this.rectangle[0],
                y: this.rectangle[3]
              }, {
                x: this.rectangle[2],
                y: this.rectangle[3]
              }, {
                x: this.rectangle[0],
                y: this.rectangle[1]
              }, {
                x: this.rectangle[2],
                y: this.rectangle[1]
              }]]);
              for (const ke of xe) {
                const [be, we, Le, Re] = ee(me, ke);
                he = Math.min(he, be), de = Math.max(de, we), pe = Math.min(pe, Le), ge = Math.max(ge, Re);
              }
              me.push("Q");
              const ye = new t.Dict(M), ve = new t.Dict(M);
              ve.set("Subtype", t.Name.get("Form"));
              const Ce = new i.StringStream(me.join(" "));
              Ce.dict = ve, ye.set("Fm0", Ce);
              const Ie = new t.Dict(M);
              re && Ie.set("BM", t.Name.get(re)), typeof le == "number" && Ie.set("CA", le), typeof ce == "number" && Ie.set("ca", ce);
              const Ae = new t.Dict(M);
              Ae.set("GS0", Ie);
              const Se = new t.Dict(M);
              Se.set("ExtGState", Ae), Se.set("XObject", ye);
              const De = new t.Dict(M);
              De.set("Resources", Se);
              const Be = this.data.rect = [he, pe, de, ge];
              De.set("BBox", Be), this.appearance = new i.StringStream("/GS0 gs /Fm0 Do"), this.appearance.dict = De, this._streams.push(this.appearance, Ce);
            }
            static async createNewAnnotation(M, X, U, Q) {
              const re = X.ref || (X.ref = M.getNewTemporaryRef()), le = await this.createNewAppearanceStream(X, M, Q), ce = [];
              let ee;
              if (le) {
                const he = M.getNewTemporaryRef();
                ee = this.createNewDict(X, M, {
                  apRef: he
                }), await (0, I.writeObject)(he, le, ce, M), U.push({
                  ref: he,
                  data: ce.join("")
                });
              } else
                ee = this.createNewDict(X, M, {});
              return Number.isInteger(X.parentTreeId) && ee.set("StructParent", X.parentTreeId), ce.length = 0, await (0, I.writeObject)(re, ee, ce, M), {
                ref: re,
                data: ce.join("")
              };
            }
            static async createNewPrintAnnotation(M, X, U, Q) {
              const re = await this.createNewAppearanceStream(U, X, Q), le = this.createNewDict(U, X, {
                ap: re
              }), ce = new this.prototype.constructor({
                dict: le,
                xref: X,
                annotationGlobals: M,
                evaluatorOptions: Q.evaluatorOptions
              });
              return U.ref && (ce.ref = ce.refToReplace = U.ref), ce;
            }
          }
          c.MarkupAnnotation = A;
          class k extends R {
            constructor(M) {
              var ge;
              super(M);
              const {
                dict: X,
                xref: U,
                annotationGlobals: Q
              } = M, re = this.data;
              this._needAppearances = M.needAppearances, re.annotationType = s.AnnotationType.WIDGET, re.fieldName === void 0 && (re.fieldName = this._constructFieldName(X)), re.actions === void 0 && (re.actions = (0, h.collectActions)(U, X, s.AnnotationActionEventType));
              let le = (0, h.getInheritableProperty)({
                dict: X,
                key: "V",
                getArray: !0
              });
              re.fieldValue = this._decodeFormValue(le);
              const ce = (0, h.getInheritableProperty)({
                dict: X,
                key: "DV",
                getArray: !0
              });
              if (re.defaultFieldValue = this._decodeFormValue(ce), le === void 0 && Q.xfaDatasets) {
                const me = this._title.str;
                me && (this._hasValueFromXFA = !0, re.fieldValue = le = Q.xfaDatasets.getValue(me));
              }
              le === void 0 && re.defaultFieldValue !== null && (re.fieldValue = re.defaultFieldValue), re.alternativeText = (0, s.stringToPDFString)(X.get("TU") || ""), this.setDefaultAppearance(M), re.hasAppearance || (re.hasAppearance = this._needAppearances && re.fieldValue !== void 0 && re.fieldValue !== null);
              const ee = (0, h.getInheritableProperty)({
                dict: X,
                key: "FT"
              });
              re.fieldType = ee instanceof t.Name ? ee.name : null;
              const he = (0, h.getInheritableProperty)({
                dict: X,
                key: "DR"
              }), pe = Q.acroForm.get("DR"), de = (ge = this.appearance) == null ? void 0 : ge.dict.get("Resources");
              this._fieldResources = {
                localResources: he,
                acroFormResources: pe,
                appearanceResources: de,
                mergedResources: t.Dict.merge({
                  xref: U,
                  dictArray: [he, de, pe],
                  mergeSubDicts: !0
                })
              }, re.fieldFlags = (0, h.getInheritableProperty)({
                dict: X,
                key: "Ff"
              }), (!Number.isInteger(re.fieldFlags) || re.fieldFlags < 0) && (re.fieldFlags = 0), re.readOnly = this.hasFieldFlag(s.AnnotationFieldFlag.READONLY), re.required = this.hasFieldFlag(s.AnnotationFieldFlag.REQUIRED), re.hidden = this._hasFlag(re.annotationFlags, s.AnnotationFlag.HIDDEN) || this._hasFlag(re.annotationFlags, s.AnnotationFlag.NOVIEW);
            }
            _decodeFormValue(M) {
              return Array.isArray(M) ? M.filter((X) => typeof X == "string").map((X) => (0, s.stringToPDFString)(X)) : M instanceof t.Name ? (0, s.stringToPDFString)(M.name) : typeof M == "string" ? (0, s.stringToPDFString)(M) : null;
            }
            hasFieldFlag(M) {
              return !!(this.data.fieldFlags & M);
            }
            _isViewable(M) {
              return !this._hasFlag(M, s.AnnotationFlag.INVISIBLE);
            }
            mustBeViewed(M, X) {
              return X ? this.viewable : super.mustBeViewed(M, X) && !this._hasFlag(this.flags, s.AnnotationFlag.NOVIEW);
            }
            getRotationMatrix(M) {
              var re;
              let X = (re = M == null ? void 0 : M.get(this.data.id)) == null ? void 0 : re.rotation;
              if (X === void 0 && (X = this.rotation), X === 0)
                return s.IDENTITY_MATRIX;
              const U = this.data.rect[2] - this.data.rect[0], Q = this.data.rect[3] - this.data.rect[1];
              return (0, h.getRotationMatrix)(X, U, Q);
            }
            getBorderAndBackgroundAppearances(M) {
              var ce;
              let X = (ce = M == null ? void 0 : M.get(this.data.id)) == null ? void 0 : ce.rotation;
              if (X === void 0 && (X = this.rotation), !this.backgroundColor && !this.borderColor)
                return "";
              const U = this.data.rect[2] - this.data.rect[0], Q = this.data.rect[3] - this.data.rect[1], re = X === 0 || X === 180 ? `0 0 ${U} ${Q} re` : `0 0 ${Q} ${U} re`;
              let le = "";
              if (this.backgroundColor && (le = `${(0, g.getPdfColor)(this.backgroundColor, !0)} ${re} f `), this.borderColor) {
                const ee = this.borderStyle.width || 1;
                le += `${ee} w ${(0, g.getPdfColor)(this.borderColor, !1)} ${re} S `;
              }
              return le;
            }
            async getOperatorList(M, X, U, Q, re) {
              if (Q && !(this instanceof F) && !this.data.noHTML && !this.data.hasOwnCanvas)
                return {
                  opList: new u.OperatorList(),
                  separateForm: !0,
                  separateCanvas: !1
                };
              if (!this._hasText)
                return super.getOperatorList(M, X, U, Q, re);
              const le = await this._getAppearance(M, X, U, re);
              if (this.appearance && le === null)
                return super.getOperatorList(M, X, U, Q, re);
              const ce = new u.OperatorList();
              if (!this._defaultAppearance || le === null)
                return {
                  opList: ce,
                  separateForm: !1,
                  separateCanvas: !1
                };
              const ee = !!(this.data.hasOwnCanvas && U & s.RenderingIntentFlag.DISPLAY), he = [1, 0, 0, 1, 0, 0], pe = [0, 0, this.data.rect[2] - this.data.rect[0], this.data.rect[3] - this.data.rect[1]], de = B(this.data.rect, pe, he);
              let ge;
              this.oc && (ge = await M.parseMarkedContentProps(this.oc, null)), ge !== void 0 && ce.addOp(s.OPS.beginMarkedContentProps, ["OC", ge]), ce.addOp(s.OPS.beginAnnotation, [this.data.id, this.data.rect, de, this.getRotationMatrix(re), ee]);
              const me = new i.StringStream(le);
              return await M.getOperatorList({
                stream: me,
                task: X,
                resources: this._fieldResources.mergedResources,
                operatorList: ce
              }), ce.addOp(s.OPS.endAnnotation, []), ge !== void 0 && ce.addOp(s.OPS.endMarkedContent, []), {
                opList: ce,
                separateForm: !1,
                separateCanvas: ee
              };
            }
            _getMKDict(M) {
              const X = new t.Dict(null);
              return M && X.set("R", M), this.borderColor && X.set("BC", K(this.borderColor)), this.backgroundColor && X.set("BG", K(this.backgroundColor)), X.size > 0 ? X : null;
            }
            amendSavedDict(M, X) {
            }
            async save(M, X, U) {
              const Q = U == null ? void 0 : U.get(this.data.id);
              let re = Q == null ? void 0 : Q.value, le = Q == null ? void 0 : Q.rotation;
              if (re === this.data.fieldValue || re === void 0) {
                if (!this._hasValueFromXFA && le === void 0)
                  return null;
                re || (re = this.data.fieldValue);
              }
              if (le === void 0 && !this._hasValueFromXFA && Array.isArray(re) && Array.isArray(this.data.fieldValue) && re.length === this.data.fieldValue.length && re.every((Ce, Ie) => Ce === this.data.fieldValue[Ie]))
                return null;
              le === void 0 && (le = this.rotation);
              let ce = null;
              if (!this._needAppearances && (ce = await this._getAppearance(M, X, s.RenderingIntentFlag.SAVE, U), ce === null))
                return null;
              let ee = !1;
              ce != null && ce.needAppearances && (ee = !0, ce = null);
              const {
                xref: he
              } = M, pe = he.fetchIfRef(this.ref);
              if (!(pe instanceof t.Dict))
                return null;
              const de = new t.Dict(he);
              for (const Ce of pe.getKeys())
                Ce !== "AP" && de.set(Ce, pe.getRaw(Ce));
              const ge = {
                path: this.data.fieldName,
                value: re
              }, me = (Ce) => (0, h.isAscii)(Ce) ? Ce : (0, h.stringToUTF16String)(Ce, !0);
              de.set("V", Array.isArray(re) ? re.map(me) : me(re)), this.amendSavedDict(U, de);
              const xe = this._getMKDict(le);
              xe && de.set("MK", xe);
              const ye = [], ve = [{
                ref: this.ref,
                data: "",
                xfa: ge,
                needAppearances: ee
              }];
              if (ce !== null) {
                const Ce = he.getNewTemporaryRef(), Ie = new t.Dict(he);
                de.set("AP", Ie), Ie.set("N", Ce);
                const Ae = this._getSaveFieldResources(he), Se = new i.StringStream(ce), De = Se.dict = new t.Dict(he);
                De.set("Subtype", t.Name.get("Form")), De.set("Resources", Ae), De.set("BBox", [0, 0, this.data.rect[2] - this.data.rect[0], this.data.rect[3] - this.data.rect[1]]);
                const Be = this.getRotationMatrix(U);
                Be !== s.IDENTITY_MATRIX && De.set("Matrix", Be), await (0, I.writeObject)(Ce, Se, ye, he), ve.push({
                  ref: Ce,
                  data: ye.join(""),
                  xfa: null,
                  needAppearances: !1
                }), ye.length = 0;
              }
              return de.set("M", `D:${(0, s.getModificationDate)()}`), await (0, I.writeObject)(this.ref, de, ye, he), ve[0].data = ye.join(""), ve;
            }
            async _getAppearance(M, X, U, Q) {
              if (this.hasFieldFlag(s.AnnotationFieldFlag.PASSWORD))
                return null;
              const le = Q == null ? void 0 : Q.get(this.data.id);
              let ce, ee;
              if (le && (ce = le.formattedValue || le.value, ee = le.rotation), ee === void 0 && ce === void 0 && !this._needAppearances && (!this._hasValueFromXFA || this.appearance))
                return null;
              const he = this.getBorderAndBackgroundAppearances(Q);
              if (ce === void 0 && (ce = this.data.fieldValue, !ce))
                return `/Tx BMC q ${he}Q EMC`;
              if (Array.isArray(ce) && ce.length === 1 && (ce = ce[0]), (0, s.assert)(typeof ce == "string", "Expected `value` to be a string."), ce = ce.trim(), this.data.combo) {
                const ct = this.data.options.find(({
                  exportValue: ft
                }) => ce === ft);
                ce = (ct == null ? void 0 : ct.displayValue) || ce;
              }
              if (ce === "")
                return `/Tx BMC q ${he}Q EMC`;
              ee === void 0 && (ee = this.rotation);
              let pe = -1, de;
              this.data.multiLine ? (de = ce.split(/\r\n?|\n/).map((ct) => ct.normalize("NFC")), pe = de.length) : de = [ce.replace(/\r\n?|\n/, "").normalize("NFC")];
              const ge = 1, me = 2;
              let xe = this.data.rect[3] - this.data.rect[1], ye = this.data.rect[2] - this.data.rect[0];
              (ee === 90 || ee === 270) && ([ye, xe] = [xe, ye]), this._defaultAppearance || (this.data.defaultAppearanceData = (0, g.parseDefaultAppearance)(this._defaultAppearance = "/Helvetica 0 Tf 0 g"));
              let ve = await k._getFontData(M, X, this.data.defaultAppearanceData, this._fieldResources.mergedResources), Ce, Ie, Ae;
              const Se = [];
              let De = !1;
              for (const ct of de) {
                const ft = ve.encodeString(ct);
                ft.length > 1 && (De = !0), Se.push(ft.join(""));
              }
              if (De && U & s.RenderingIntentFlag.SAVE)
                return {
                  needAppearances: !0
                };
              if (De && this._isOffscreenCanvasSupported) {
                const ct = this.data.comb ? "monospace" : "sans-serif", ft = new g.FakeUnicodeFont(M.xref, ct), kt = ft.createFontResources(de.join("")), We = kt.getRaw("Font");
                if (this._fieldResources.mergedResources.has("Font")) {
                  const Ye = this._fieldResources.mergedResources.get("Font");
                  for (const mt of We.getKeys())
                    Ye.set(mt, We.getRaw(mt));
                } else
                  this._fieldResources.mergedResources.set("Font", We);
                const jt = ft.fontName.name;
                ve = await k._getFontData(M, X, {
                  fontName: jt,
                  fontSize: 0
                }, kt);
                for (let Ye = 0, mt = Se.length; Ye < mt; Ye++)
                  Se[Ye] = (0, h.stringToUTF16String)(de[Ye]);
                const yt = Object.assign(/* @__PURE__ */ Object.create(null), this.data.defaultAppearanceData);
                this.data.defaultAppearanceData.fontSize = 0, this.data.defaultAppearanceData.fontName = jt, [Ce, Ie, Ae] = this._computeFontSize(xe - 2 * ge, ye - 2 * me, ce, ve, pe), this.data.defaultAppearanceData = yt;
              } else
                this._isOffscreenCanvasSupported || (0, s.warn)("_getAppearance: OffscreenCanvas is not supported, annotation may not render correctly."), [Ce, Ie, Ae] = this._computeFontSize(xe - 2 * ge, ye - 2 * me, ce, ve, pe);
              let Be = ve.descent;
              isNaN(Be) ? Be = s.BASELINE_FACTOR * Ae : Be = Math.max(s.BASELINE_FACTOR * Ae, Math.abs(Be) * Ie);
              const ke = Math.min(Math.floor((xe - Ie) / 2), ge), be = this.data.textAlignment;
              if (this.data.multiLine)
                return this._getMultilineAppearance(Ce, Se, ve, Ie, ye, xe, be, me, ke, Be, Ae, Q);
              if (this.data.comb)
                return this._getCombAppearance(Ce, ve, Se[0], Ie, ye, xe, me, ke, Be, Ae, Q);
              const we = ke + Be;
              if (be === 0 || be > 2)
                return `/Tx BMC q ${he}BT ` + Ce + ` 1 0 0 1 ${(0, h.numberToString)(me)} ${(0, h.numberToString)(we)} Tm (${(0, h.escapeString)(Se[0])}) Tj ET Q EMC`;
              const Le = {
                shift: 0
              }, Re = this._renderText(Se[0], ve, Ie, ye, be, Le, me, we);
              return `/Tx BMC q ${he}BT ` + Ce + ` 1 0 0 1 0 0 Tm ${Re} ET Q EMC`;
            }
            static async _getFontData(M, X, U, Q) {
              const re = new u.OperatorList(), le = {
                font: null,
                clone() {
                  return this;
                }
              }, {
                fontName: ce,
                fontSize: ee
              } = U;
              return await M.handleSetFont(Q, [ce && t.Name.get(ce), ee], null, re, X, le, null), le.font;
            }
            _getTextWidth(M, X) {
              return X.charsToGlyphs(M).reduce((U, Q) => U + Q.width, 0) / 1e3;
            }
            _computeFontSize(M, X, U, Q, re) {
              let {
                fontSize: le
              } = this.data.defaultAppearanceData, ce = (le || 12) * s.LINE_FACTOR, ee = Math.round(M / ce);
              if (!le) {
                const he = (ge) => Math.floor(ge * 100) / 100;
                if (re === -1) {
                  const ge = this._getTextWidth(U, Q);
                  le = he(Math.min(M / s.LINE_FACTOR, ge > X ? X / ge : 1 / 0)), ee = 1;
                } else {
                  const ge = U.split(/\r\n?|\n/), me = [];
                  for (const ye of ge) {
                    const ve = Q.encodeString(ye).join(""), Ce = Q.charsToGlyphs(ve), Ie = Q.getCharPositions(ve);
                    me.push({
                      line: ve,
                      glyphs: Ce,
                      positions: Ie
                    });
                  }
                  const xe = (ye) => {
                    let ve = 0;
                    for (const Ce of me) {
                      const Ie = this._splitLine(null, Q, ye, X, Ce);
                      if (ve += Ie.length * ye, ve > M)
                        return !0;
                    }
                    return !1;
                  };
                  for (ee = Math.max(ee, re); ; ) {
                    if (ce = M / ee, le = he(ce / s.LINE_FACTOR), xe(le)) {
                      ee++;
                      continue;
                    }
                    break;
                  }
                }
                const {
                  fontName: pe,
                  fontColor: de
                } = this.data.defaultAppearanceData;
                this._defaultAppearance = (0, g.createDefaultAppearance)({
                  fontSize: le,
                  fontName: pe,
                  fontColor: de
                });
              }
              return [this._defaultAppearance, le, M / ee];
            }
            _renderText(M, X, U, Q, re, le, ce, ee) {
              let he;
              if (re === 1) {
                const de = this._getTextWidth(M, X) * U;
                he = (Q - de) / 2;
              } else if (re === 2) {
                const de = this._getTextWidth(M, X) * U;
                he = Q - de - ce;
              } else
                he = ce;
              const pe = (0, h.numberToString)(he - le.shift);
              return le.shift = he, ee = (0, h.numberToString)(ee), `${pe} ${ee} Td (${(0, h.escapeString)(M)}) Tj`;
            }
            _getSaveFieldResources(M) {
              var le;
              const {
                localResources: X,
                appearanceResources: U,
                acroFormResources: Q
              } = this._fieldResources, re = (le = this.data.defaultAppearanceData) == null ? void 0 : le.fontName;
              if (!re)
                return X || t.Dict.empty;
              for (const ce of [X, U])
                if (ce instanceof t.Dict) {
                  const ee = ce.get("Font");
                  if (ee instanceof t.Dict && ee.has(re))
                    return ce;
                }
              if (Q instanceof t.Dict) {
                const ce = Q.get("Font");
                if (ce instanceof t.Dict && ce.has(re)) {
                  const ee = new t.Dict(M);
                  ee.set(re, ce.getRaw(re));
                  const he = new t.Dict(M);
                  return he.set("Font", ee), t.Dict.merge({
                    xref: M,
                    dictArray: [he, X],
                    mergeSubDicts: !0
                  });
                }
              }
              return X || t.Dict.empty;
            }
            getFieldObject() {
              return null;
            }
          }
          class z extends k {
            constructor(M) {
              super(M), this.data.hasOwnCanvas = this.data.readOnly && !this.data.noHTML, this._hasText = !0;
              const X = M.dict;
              typeof this.data.fieldValue != "string" && (this.data.fieldValue = "");
              let U = (0, h.getInheritableProperty)({
                dict: X,
                key: "Q"
              });
              (!Number.isInteger(U) || U < 0 || U > 2) && (U = null), this.data.textAlignment = U;
              let Q = (0, h.getInheritableProperty)({
                dict: X,
                key: "MaxLen"
              });
              (!Number.isInteger(Q) || Q < 0) && (Q = 0), this.data.maxLen = Q, this.data.multiLine = this.hasFieldFlag(s.AnnotationFieldFlag.MULTILINE), this.data.comb = this.hasFieldFlag(s.AnnotationFieldFlag.COMB) && !this.hasFieldFlag(s.AnnotationFieldFlag.MULTILINE) && !this.hasFieldFlag(s.AnnotationFieldFlag.PASSWORD) && !this.hasFieldFlag(s.AnnotationFieldFlag.FILESELECT) && this.data.maxLen !== 0, this.data.doNotScroll = this.hasFieldFlag(s.AnnotationFieldFlag.DONOTSCROLL);
            }
            get hasTextContent() {
              return !!this.appearance && !this._needAppearances;
            }
            _getCombAppearance(M, X, U, Q, re, le, ce, ee, he, pe, de) {
              const ge = re / this.data.maxLen, me = this.getBorderAndBackgroundAppearances(de), xe = [], ye = X.getCharPositions(U);
              for (const [Ce, Ie] of ye)
                xe.push(`(${(0, h.escapeString)(U.substring(Ce, Ie))}) Tj`);
              const ve = xe.join(` ${(0, h.numberToString)(ge)} 0 Td `);
              return `/Tx BMC q ${me}BT ` + M + ` 1 0 0 1 ${(0, h.numberToString)(ce)} ${(0, h.numberToString)(ee + he)} Tm ${ve} ET Q EMC`;
            }
            _getMultilineAppearance(M, X, U, Q, re, le, ce, ee, he, pe, de, ge) {
              const me = [], xe = re - 2 * ee, ye = {
                shift: 0
              };
              for (let Ie = 0, Ae = X.length; Ie < Ae; Ie++) {
                const Se = X[Ie], De = this._splitLine(Se, U, Q, xe);
                for (let Be = 0, ke = De.length; Be < ke; Be++) {
                  const be = De[Be], we = Ie === 0 && Be === 0 ? -he - (de - pe) : -de;
                  me.push(this._renderText(be, U, Q, re, ce, ye, ee, we));
                }
              }
              const ve = this.getBorderAndBackgroundAppearances(ge), Ce = me.join(`
`);
              return `/Tx BMC q ${ve}BT ` + M + ` 1 0 0 1 0 ${(0, h.numberToString)(le)} Tm ${Ce} ET Q EMC`;
            }
            _splitLine(M, X, U, Q, re = {}) {
              M = re.line || M;
              const le = re.glyphs || X.charsToGlyphs(M);
              if (le.length <= 1)
                return [M];
              const ce = re.positions || X.getCharPositions(M), ee = U / 1e3, he = [];
              let pe = -1, de = -1, ge = -1, me = 0, xe = 0;
              for (let ye = 0, ve = le.length; ye < ve; ye++) {
                const [Ce, Ie] = ce[ye], Ae = le[ye], Se = Ae.width * ee;
                Ae.unicode === " " ? xe + Se > Q ? (he.push(M.substring(me, Ce)), me = Ce, xe = Se, pe = -1, ge = -1) : (xe += Se, pe = Ce, de = Ie, ge = ye) : xe + Se > Q ? pe !== -1 ? (he.push(M.substring(me, de)), me = de, ye = ge + 1, pe = -1, xe = 0) : (he.push(M.substring(me, Ce)), me = Ce, xe = Se) : xe += Se;
              }
              return me < M.length && he.push(M.substring(me, M.length)), he;
            }
            getFieldObject() {
              return {
                id: this.data.id,
                value: this.data.fieldValue,
                defaultValue: this.data.defaultFieldValue || "",
                multiline: this.data.multiLine,
                password: this.hasFieldFlag(s.AnnotationFieldFlag.PASSWORD),
                charLimit: this.data.maxLen,
                comb: this.data.comb,
                editable: !this.data.readOnly,
                hidden: this.data.hidden,
                name: this.data.fieldName,
                rect: this.data.rect,
                actions: this.data.actions,
                page: this.data.pageIndex,
                strokeColor: this.data.borderColor,
                fillColor: this.data.backgroundColor,
                rotation: this.rotation,
                type: "text"
              };
            }
          }
          class T extends k {
            constructor(M) {
              super(M), this.checkedAppearance = null, this.uncheckedAppearance = null, this.data.checkBox = !this.hasFieldFlag(s.AnnotationFieldFlag.RADIO) && !this.hasFieldFlag(s.AnnotationFieldFlag.PUSHBUTTON), this.data.radioButton = this.hasFieldFlag(s.AnnotationFieldFlag.RADIO) && !this.hasFieldFlag(s.AnnotationFieldFlag.PUSHBUTTON), this.data.pushButton = this.hasFieldFlag(s.AnnotationFieldFlag.PUSHBUTTON), this.data.isTooltipOnly = !1, this.data.checkBox ? this._processCheckBox(M) : this.data.radioButton ? this._processRadioButton(M) : this.data.pushButton ? (this.data.hasOwnCanvas = !0, this._processPushButton(M)) : (0, s.warn)("Invalid field flags for button widget annotation");
            }
            async getOperatorList(M, X, U, Q, re) {
              if (this.data.pushButton)
                return super.getOperatorList(M, X, U, !1, re);
              let le = null, ce = null;
              if (re) {
                const he = re.get(this.data.id);
                le = he ? he.value : null, ce = he ? he.rotation : null;
              }
              if (le === null && this.appearance)
                return super.getOperatorList(M, X, U, Q, re);
              le == null && (le = this.data.checkBox ? this.data.fieldValue === this.data.exportValue : this.data.fieldValue === this.data.buttonValue);
              const ee = le ? this.checkedAppearance : this.uncheckedAppearance;
              if (ee) {
                const he = this.appearance, pe = ee.dict.getArray("Matrix") || s.IDENTITY_MATRIX;
                ce && ee.dict.set("Matrix", this.getRotationMatrix(re)), this.appearance = ee;
                const de = super.getOperatorList(M, X, U, Q, re);
                return this.appearance = he, ee.dict.set("Matrix", pe), de;
              }
              return {
                opList: new u.OperatorList(),
                separateForm: !1,
                separateCanvas: !1
              };
            }
            async save(M, X, U) {
              return this.data.checkBox ? this._saveCheckbox(M, X, U) : this.data.radioButton ? this._saveRadioButton(M, X, U) : null;
            }
            async _saveCheckbox(M, X, U) {
              if (!U)
                return null;
              const Q = U.get(this.data.id);
              let re = Q == null ? void 0 : Q.rotation, le = Q == null ? void 0 : Q.value;
              if (re === void 0 && (le === void 0 || this.data.fieldValue === this.data.exportValue === le))
                return null;
              const ce = M.xref.fetchIfRef(this.ref);
              if (!(ce instanceof t.Dict))
                return null;
              re === void 0 && (re = this.rotation), le === void 0 && (le = this.data.fieldValue === this.data.exportValue);
              const ee = {
                path: this.data.fieldName,
                value: le ? this.data.exportValue : ""
              }, he = t.Name.get(le ? this.data.exportValue : "Off");
              ce.set("V", he), ce.set("AS", he), ce.set("M", `D:${(0, s.getModificationDate)()}`);
              const pe = this._getMKDict(re);
              pe && ce.set("MK", pe);
              const de = [];
              return await (0, I.writeObject)(this.ref, ce, de, M.xref), [{
                ref: this.ref,
                data: de.join(""),
                xfa: ee
              }];
            }
            async _saveRadioButton(M, X, U) {
              if (!U)
                return null;
              const Q = U.get(this.data.id);
              let re = Q == null ? void 0 : Q.rotation, le = Q == null ? void 0 : Q.value;
              if (re === void 0 && (le === void 0 || this.data.fieldValue === this.data.buttonValue === le))
                return null;
              const ce = M.xref.fetchIfRef(this.ref);
              if (!(ce instanceof t.Dict))
                return null;
              le === void 0 && (le = this.data.fieldValue === this.data.buttonValue), re === void 0 && (re = this.rotation);
              const ee = {
                path: this.data.fieldName,
                value: le ? this.data.buttonValue : ""
              }, he = t.Name.get(le ? this.data.buttonValue : "Off"), pe = [];
              let de = null;
              if (le)
                if (this.parent instanceof t.Ref) {
                  const xe = M.xref.fetch(this.parent);
                  xe.set("V", he), await (0, I.writeObject)(this.parent, xe, pe, M.xref), de = pe.join(""), pe.length = 0;
                } else this.parent instanceof t.Dict && this.parent.set("V", he);
              ce.set("AS", he), ce.set("M", `D:${(0, s.getModificationDate)()}`);
              const ge = this._getMKDict(re);
              ge && ce.set("MK", ge), await (0, I.writeObject)(this.ref, ce, pe, M.xref);
              const me = [{
                ref: this.ref,
                data: pe.join(""),
                xfa: ee
              }];
              return de && me.push({
                ref: this.parent,
                data: de,
                xfa: null
              }), me;
            }
            _getDefaultCheckedAppearance(M, X) {
              const U = this.data.rect[2] - this.data.rect[0], Q = this.data.rect[3] - this.data.rect[1], re = [0, 0, U, Q], ce = Math.min(U, Q) * 0.8;
              let ee, he;
              X === "check" ? (ee = {
                width: 0.755 * ce,
                height: 0.705 * ce
              }, he = "3") : X === "disc" ? (ee = {
                width: 0.791 * ce,
                height: 0.705 * ce
              }, he = "l") : (0, s.unreachable)(`_getDefaultCheckedAppearance - unsupported type: ${X}`);
              const pe = (0, h.numberToString)((U - ee.width) / 2), de = (0, h.numberToString)((Q - ee.height) / 2), ge = `q BT /PdfJsZaDb ${ce} Tf 0 g ${pe} ${de} Td (${he}) Tj ET Q`, me = new t.Dict(M.xref);
              me.set("FormType", 1), me.set("Subtype", t.Name.get("Form")), me.set("Type", t.Name.get("XObject")), me.set("BBox", re), me.set("Matrix", [1, 0, 0, 1, 0, 0]), me.set("Length", ge.length);
              const xe = new t.Dict(M.xref), ye = new t.Dict(M.xref);
              ye.set("PdfJsZaDb", this.fallbackFontDict), xe.set("Font", ye), me.set("Resources", xe), this.checkedAppearance = new i.StringStream(ge), this.checkedAppearance.dict = me, this._streams.push(this.checkedAppearance);
            }
            _processCheckBox(M) {
              const X = M.dict.get("AP");
              if (!(X instanceof t.Dict))
                return;
              const U = X.get("N");
              if (!(U instanceof t.Dict))
                return;
              const Q = this._decodeFormValue(M.dict.get("AS"));
              typeof Q == "string" && (this.data.fieldValue = Q);
              const re = this.data.fieldValue !== null && this.data.fieldValue !== "Off" ? this.data.fieldValue : "Yes", le = U.getKeys();
              if (le.length === 0)
                le.push("Off", re);
              else if (le.length === 1)
                le[0] === "Off" ? le.push(re) : le.unshift("Off");
              else if (le.includes(re))
                le.length = 0, le.push("Off", re);
              else {
                const he = le.find((pe) => pe !== "Off");
                le.length = 0, le.push("Off", he);
              }
              le.includes(this.data.fieldValue) || (this.data.fieldValue = "Off"), this.data.exportValue = le[1];
              const ce = U.get(this.data.exportValue);
              this.checkedAppearance = ce instanceof m.BaseStream ? ce : null;
              const ee = U.get("Off");
              this.uncheckedAppearance = ee instanceof m.BaseStream ? ee : null, this.checkedAppearance ? this._streams.push(this.checkedAppearance) : this._getDefaultCheckedAppearance(M, "check"), this.uncheckedAppearance && this._streams.push(this.uncheckedAppearance), this._fallbackFontDict = this.fallbackFontDict, this.data.defaultFieldValue === null && (this.data.defaultFieldValue = "Off");
            }
            _processRadioButton(M) {
              this.data.fieldValue = this.data.buttonValue = null;
              const X = M.dict.get("Parent");
              if (X instanceof t.Dict) {
                this.parent = M.dict.getRaw("Parent");
                const ce = X.get("V");
                ce instanceof t.Name && (this.data.fieldValue = this._decodeFormValue(ce));
              }
              const U = M.dict.get("AP");
              if (!(U instanceof t.Dict))
                return;
              const Q = U.get("N");
              if (!(Q instanceof t.Dict))
                return;
              for (const ce of Q.getKeys())
                if (ce !== "Off") {
                  this.data.buttonValue = this._decodeFormValue(ce);
                  break;
                }
              const re = Q.get(this.data.buttonValue);
              this.checkedAppearance = re instanceof m.BaseStream ? re : null;
              const le = Q.get("Off");
              this.uncheckedAppearance = le instanceof m.BaseStream ? le : null, this.checkedAppearance ? this._streams.push(this.checkedAppearance) : this._getDefaultCheckedAppearance(M, "disc"), this.uncheckedAppearance && this._streams.push(this.uncheckedAppearance), this._fallbackFontDict = this.fallbackFontDict, this.data.defaultFieldValue === null && (this.data.defaultFieldValue = "Off");
            }
            _processPushButton(M) {
              const {
                dict: X,
                annotationGlobals: U
              } = M;
              if (!X.has("A") && !X.has("AA") && !this.data.alternativeText) {
                (0, s.warn)("Push buttons without action dictionaries are not supported");
                return;
              }
              this.data.isTooltipOnly = !X.has("A") && !X.has("AA"), E.Catalog.parseDestDictionary({
                destDict: X,
                resultObj: this.data,
                docBaseUrl: U.baseUrl,
                docAttachments: U.attachments
              });
            }
            getFieldObject() {
              let M = "button", X;
              return this.data.checkBox ? (M = "checkbox", X = this.data.exportValue) : this.data.radioButton && (M = "radiobutton", X = this.data.buttonValue), {
                id: this.data.id,
                value: this.data.fieldValue || "Off",
                defaultValue: this.data.defaultFieldValue,
                exportValues: X,
                editable: !this.data.readOnly,
                name: this.data.fieldName,
                rect: this.data.rect,
                hidden: this.data.hidden,
                actions: this.data.actions,
                page: this.data.pageIndex,
                strokeColor: this.data.borderColor,
                fillColor: this.data.backgroundColor,
                rotation: this.rotation,
                type: M
              };
            }
            get fallbackFontDict() {
              const M = new t.Dict();
              return M.set("BaseFont", t.Name.get("ZapfDingbats")), M.set("Type", t.Name.get("FallbackType")), M.set("Subtype", t.Name.get("FallbackType")), M.set("Encoding", t.Name.get("ZapfDingbatsEncoding")), (0, s.shadow)(this, "fallbackFontDict", M);
            }
          }
          class w extends k {
            constructor(M) {
              super(M);
              const {
                dict: X,
                xref: U
              } = M;
              this.indices = X.getArray("I"), this.hasIndices = Array.isArray(this.indices) && this.indices.length > 0, this.data.options = [];
              const Q = (0, h.getInheritableProperty)({
                dict: X,
                key: "Opt"
              });
              if (Array.isArray(Q))
                for (let re = 0, le = Q.length; re < le; re++) {
                  const ce = U.fetchIfRef(Q[re]), ee = Array.isArray(ce);
                  this.data.options[re] = {
                    exportValue: this._decodeFormValue(ee ? U.fetchIfRef(ce[0]) : ce),
                    displayValue: this._decodeFormValue(ee ? U.fetchIfRef(ce[1]) : ce)
                  };
                }
              if (!this.hasIndices)
                typeof this.data.fieldValue == "string" ? this.data.fieldValue = [this.data.fieldValue] : this.data.fieldValue || (this.data.fieldValue = []);
              else {
                this.data.fieldValue = [];
                const re = this.data.options.length;
                for (const le of this.indices)
                  Number.isInteger(le) && le >= 0 && le < re && this.data.fieldValue.push(this.data.options[le].exportValue);
              }
              this.data.combo = this.hasFieldFlag(s.AnnotationFieldFlag.COMBO), this.data.multiSelect = this.hasFieldFlag(s.AnnotationFieldFlag.MULTISELECT), this._hasText = !0;
            }
            getFieldObject() {
              const M = this.data.combo ? "combobox" : "listbox", X = this.data.fieldValue.length > 0 ? this.data.fieldValue[0] : null;
              return {
                id: this.data.id,
                value: X,
                defaultValue: this.data.defaultFieldValue,
                editable: !this.data.readOnly,
                name: this.data.fieldName,
                rect: this.data.rect,
                numItems: this.data.fieldValue.length,
                multipleSelection: this.data.multiSelect,
                hidden: this.data.hidden,
                actions: this.data.actions,
                items: this.data.options,
                page: this.data.pageIndex,
                strokeColor: this.data.borderColor,
                fillColor: this.data.backgroundColor,
                rotation: this.rotation,
                type: M
              };
            }
            amendSavedDict(M, X) {
              var le;
              if (!this.hasIndices)
                return;
              let U = (le = M == null ? void 0 : M.get(this.data.id)) == null ? void 0 : le.value;
              Array.isArray(U) || (U = [U]);
              const Q = [], {
                options: re
              } = this.data;
              for (let ce = 0, ee = 0, he = re.length; ce < he; ce++)
                re[ce].exportValue === U[ee] && (Q.push(ce), ee += 1);
              X.set("I", Q);
            }
            async _getAppearance(M, X, U, Q) {
              if (this.data.combo)
                return super._getAppearance(M, X, U, Q);
              let re, le;
              const ce = Q == null ? void 0 : Q.get(this.data.id);
              if (ce && (le = ce.rotation, re = ce.value), le === void 0 && re === void 0 && !this._needAppearances)
                return null;
              re === void 0 ? re = this.data.fieldValue : Array.isArray(re) || (re = [re]);
              const ee = 1, he = 2;
              let pe = this.data.rect[3] - this.data.rect[1], de = this.data.rect[2] - this.data.rect[0];
              (le === 90 || le === 270) && ([de, pe] = [pe, de]);
              const ge = this.data.options.length, me = [];
              for (let be = 0; be < ge; be++) {
                const {
                  exportValue: we
                } = this.data.options[be];
                re.includes(we) && me.push(be);
              }
              this._defaultAppearance || (this.data.defaultAppearanceData = (0, g.parseDefaultAppearance)(this._defaultAppearance = "/Helvetica 0 Tf 0 g"));
              const xe = await k._getFontData(M, X, this.data.defaultAppearanceData, this._fieldResources.mergedResources);
              let ye, {
                fontSize: ve
              } = this.data.defaultAppearanceData;
              if (ve)
                ye = this._defaultAppearance;
              else {
                const be = (pe - ee) / ge;
                let we = -1, Le;
                for (const {
                  displayValue: Re
                } of this.data.options) {
                  const ct = this._getTextWidth(Re, xe);
                  ct > we && (we = ct, Le = Re);
                }
                [ye, ve] = this._computeFontSize(be, de - 2 * he, Le, xe, -1);
              }
              const Ce = ve * s.LINE_FACTOR, Ie = (Ce - ve) / 2, Ae = Math.floor(pe / Ce);
              let Se = 0;
              if (me.length > 0) {
                const be = Math.min(...me), we = Math.max(...me);
                Se = Math.max(0, we - Ae + 1), Se > be && (Se = be);
              }
              const De = Math.min(Se + Ae + 1, ge), Be = ["/Tx BMC q", `1 1 ${de} ${pe} re W n`];
              if (me.length) {
                Be.push("0.600006 0.756866 0.854904 rg");
                for (const be of me)
                  Se <= be && be < De && Be.push(`1 ${pe - (be - Se + 1) * Ce} ${de} ${Ce} re f`);
              }
              Be.push("BT", ye, `1 0 0 1 0 ${pe} Tm`);
              const ke = {
                shift: 0
              };
              for (let be = Se; be < De; be++) {
                const {
                  displayValue: we
                } = this.data.options[be], Le = be === Se ? Ie : 0;
                Be.push(this._renderText(we, xe, ve, de, 0, ke, he, -Ce + Le));
              }
              return Be.push("ET Q EMC"), Be.join(`
`);
            }
          }
          class F extends k {
            constructor(M) {
              super(M), this.data.fieldValue = null, this.data.hasOwnCanvas = this.data.noRotate;
            }
            getFieldObject() {
              return {
                id: this.data.id,
                value: null,
                page: this.data.pageIndex,
                type: "signature"
              };
            }
          }
          class j extends A {
            constructor(M) {
              super(M), this.data.noRotate = !0, this.data.hasOwnCanvas = this.data.noRotate;
              const {
                dict: U
              } = M;
              this.data.annotationType = s.AnnotationType.TEXT, this.data.hasAppearance ? this.data.name = "NoIcon" : (this.data.rect[1] = this.data.rect[3] - 22, this.data.rect[2] = this.data.rect[0] + 22, this.data.name = U.has("Name") ? U.get("Name").name : "Note"), U.has("State") ? (this.data.state = U.get("State") || null, this.data.stateModel = U.get("StateModel") || null) : (this.data.state = null, this.data.stateModel = null);
            }
          }
          class P extends R {
            constructor(M) {
              var re;
              super(M);
              const {
                dict: X,
                annotationGlobals: U
              } = M;
              this.data.annotationType = s.AnnotationType.LINK;
              const Q = H(X, this.rectangle);
              Q && (this.data.quadPoints = Q), (re = this.data).borderColor || (re.borderColor = this.data.color), E.Catalog.parseDestDictionary({
                destDict: X,
                resultObj: this.data,
                docBaseUrl: U.baseUrl,
                docAttachments: U.attachments
              });
            }
          }
          class V extends R {
            constructor(M) {
              super(M);
              const {
                dict: X
              } = M;
              this.data.annotationType = s.AnnotationType.POPUP, (this.data.rect[0] === this.data.rect[2] || this.data.rect[1] === this.data.rect[3]) && (this.data.rect = null);
              let U = X.get("Parent");
              if (!U) {
                (0, s.warn)("Popup annotation has a missing or invalid parent annotation.");
                return;
              }
              const Q = U.getArray("Rect");
              this.data.parentRect = Array.isArray(Q) && Q.length === 4 ? s.Util.normalizeRect(Q) : null;
              const re = U.get("RT");
              if ((0, t.isName)(re, s.AnnotationReplyType.GROUP) && (U = U.get("IRT")), U.has("M") ? (this.setModificationDate(U.get("M")), this.data.modificationDate = this.modificationDate) : this.data.modificationDate = null, U.has("C") ? (this.setColor(U.getArray("C")), this.data.color = this.color) : this.data.color = null, !this.viewable) {
                const le = U.get("F");
                this._isViewable(le) && this.setFlags(le);
              }
              this.setTitle(U.get("T")), this.data.titleObj = this._title, this.setContents(U.get("Contents")), this.data.contentsObj = this._contents, U.has("RC") && (this.data.richText = O.XFAFactory.getRichTextAsHtml(U.get("RC"))), this.data.open = !!X.get("Open");
            }
          }
          c.PopupAnnotation = V;
          class J extends A {
            constructor(M) {
              var Q;
              super(M), this.data.hasOwnCanvas = !0;
              const {
                evaluatorOptions: X,
                xref: U
              } = M;
              if (this.data.annotationType = s.AnnotationType.FREETEXT, this.setDefaultAppearance(M), this.appearance) {
                const {
                  fontColor: re,
                  fontSize: le
                } = (0, g.parseAppearanceStream)(this.appearance, X, U);
                this.data.defaultAppearanceData.fontColor = re, this.data.defaultAppearanceData.fontSize = le || 10;
              } else if (this._isOffscreenCanvasSupported) {
                const re = M.dict.get("CA"), le = new g.FakeUnicodeFont(U, "sans-serif");
                (Q = this.data.defaultAppearanceData).fontSize || (Q.fontSize = 10);
                const {
                  fontColor: ce,
                  fontSize: ee
                } = this.data.defaultAppearanceData;
                this.appearance = le.createAppearance(this._contents.str, this.rectangle, this.rotation, ee, ce, re), this._streams.push(this.appearance, g.FakeUnicodeFont.toUnicodeStream);
              } else
                (0, s.warn)("FreeTextAnnotation: OffscreenCanvas is not supported, annotation may not render correctly.");
            }
            get hasTextContent() {
              return !!this.appearance;
            }
            static createNewDict(M, X, {
              apRef: U,
              ap: Q
            }) {
              const {
                color: re,
                fontSize: le,
                rect: ce,
                rotation: ee,
                user: he,
                value: pe
              } = M, de = new t.Dict(X);
              de.set("Type", t.Name.get("Annot")), de.set("Subtype", t.Name.get("FreeText")), de.set("CreationDate", `D:${(0, s.getModificationDate)()}`), de.set("Rect", ce);
              const ge = `/Helv ${le} Tf ${(0, g.getPdfColor)(re, !0)}`;
              if (de.set("DA", ge), de.set("Contents", (0, h.isAscii)(pe) ? pe : (0, h.stringToUTF16String)(pe, !0)), de.set("F", 4), de.set("Border", [0, 0, 0]), de.set("Rotate", ee), he && de.set("T", (0, h.isAscii)(he) ? he : (0, h.stringToUTF16String)(he, !0)), U || Q) {
                const me = new t.Dict(X);
                de.set("AP", me), U ? me.set("N", U) : me.set("N", Q);
              }
              return de;
            }
            static async createNewAppearanceStream(M, X, U) {
              const {
                baseFontRef: Q,
                evaluator: re,
                task: le
              } = U, {
                color: ce,
                fontSize: ee,
                rect: he,
                rotation: pe,
                value: de
              } = M, ge = new t.Dict(X), me = new t.Dict(X);
              if (Q)
                me.set("Helv", Q);
              else {
                const _e = new t.Dict(X);
                _e.set("BaseFont", t.Name.get("Helvetica")), _e.set("Type", t.Name.get("Font")), _e.set("Subtype", t.Name.get("Type1")), _e.set("Encoding", t.Name.get("WinAnsiEncoding")), me.set("Helv", _e);
              }
              ge.set("Font", me);
              const xe = await k._getFontData(re, le, {
                fontName: "Helv",
                fontSize: ee
              }, ge), [ye, ve, Ce, Ie] = he;
              let Ae = Ce - ye, Se = Ie - ve;
              pe % 180 !== 0 && ([Ae, Se] = [Se, Ae]);
              const De = de.split(`
`), Be = ee / 1e3;
              let ke = -1 / 0;
              const be = [];
              for (let _e of De) {
                const Qe = xe.encodeString(_e);
                if (Qe.length > 1)
                  return null;
                _e = Qe.join(""), be.push(_e);
                let qe = 0;
                const Je = xe.charsToGlyphs(_e);
                for (const nt of Je)
                  qe += nt.width * Be;
                ke = Math.max(ke, qe);
              }
              let we = 1;
              ke > Ae && (we = Ae / ke);
              let Le = 1;
              const Re = s.LINE_FACTOR * ee, ct = (s.LINE_FACTOR - s.LINE_DESCENT_FACTOR) * ee, ft = Re * De.length;
              ft > Se && (Le = Se / ft);
              const kt = Math.min(we, Le), We = ee * kt;
              let jt, yt, Ye;
              switch (pe) {
                case 0:
                  Ye = [1, 0, 0, 1], yt = [he[0], he[1], Ae, Se], jt = [he[0], he[3] - ct];
                  break;
                case 90:
                  Ye = [0, 1, -1, 0], yt = [he[1], -he[2], Ae, Se], jt = [he[1], -he[0] - ct];
                  break;
                case 180:
                  Ye = [-1, 0, 0, -1], yt = [-he[2], -he[3], Ae, Se], jt = [-he[2], -he[1] - ct];
                  break;
                case 270:
                  Ye = [0, -1, 1, 0], yt = [-he[3], he[0], Ae, Se], jt = [-he[3], he[2] - ct];
                  break;
              }
              const mt = ["q", `${Ye.join(" ")} 0 0 cm`, `${yt.join(" ")} re W n`, "BT", `${(0, g.getPdfColor)(ce, !0)}`, `0 Tc /Helv ${(0, h.numberToString)(We)} Tf`];
              mt.push(`${jt.join(" ")} Td (${(0, h.escapeString)(be[0])}) Tj`);
              const Pt = (0, h.numberToString)(Re);
              for (let _e = 1, Qe = be.length; _e < Qe; _e++) {
                const qe = be[_e];
                mt.push(`0 -${Pt} Td (${(0, h.escapeString)(qe)}) Tj`);
              }
              mt.push("ET", "Q");
              const et = mt.join(`
`), tn = new t.Dict(X);
              tn.set("FormType", 1), tn.set("Subtype", t.Name.get("Form")), tn.set("Type", t.Name.get("XObject")), tn.set("BBox", he), tn.set("Resources", ge), tn.set("Matrix", [1, 0, 0, 1, -he[0], -he[1]]);
              const Xt = new i.StringStream(et);
              return Xt.dict = tn, Xt;
            }
          }
          class ne extends A {
            constructor(M) {
              super(M);
              const {
                dict: X,
                xref: U
              } = M;
              this.data.annotationType = s.AnnotationType.LINE, this.data.hasOwnCanvas = this.data.noRotate;
              const Q = X.getArray("L");
              if (this.data.lineCoordinates = s.Util.normalizeRect(Q), this.setLineEndings(X.getArray("LE")), this.data.lineEndings = this.lineEndings, !this.appearance) {
                const re = this.color ? K(this.color) : [0, 0, 0], le = X.get("CA"), ce = $(X.getArray("IC"), null), ee = ce ? K(ce) : null, he = ee ? le : null, pe = this.borderStyle.width || 1, de = 2 * pe, ge = [this.data.lineCoordinates[0] - de, this.data.lineCoordinates[1] - de, this.data.lineCoordinates[2] + de, this.data.lineCoordinates[3] + de];
                s.Util.intersect(this.rectangle, ge) || (this.rectangle = ge), this._setDefaultAppearance({
                  xref: U,
                  extra: `${pe} w`,
                  strokeColor: re,
                  fillColor: ee,
                  strokeAlpha: le,
                  fillAlpha: he,
                  pointsCallback: (me, xe) => (me.push(`${Q[0]} ${Q[1]} m`, `${Q[2]} ${Q[3]} l`, "S"), [xe[0].x - pe, xe[1].x + pe, xe[3].y - pe, xe[1].y + pe])
                });
              }
            }
          }
          class Z extends A {
            constructor(M) {
              super(M);
              const {
                dict: X,
                xref: U
              } = M;
              if (this.data.annotationType = s.AnnotationType.SQUARE, this.data.hasOwnCanvas = this.data.noRotate, !this.appearance) {
                const Q = this.color ? K(this.color) : [0, 0, 0], re = X.get("CA"), le = $(X.getArray("IC"), null), ce = le ? K(le) : null, ee = ce ? re : null;
                if (this.borderStyle.width === 0 && !ce)
                  return;
                this._setDefaultAppearance({
                  xref: U,
                  extra: `${this.borderStyle.width} w`,
                  strokeColor: Q,
                  fillColor: ce,
                  strokeAlpha: re,
                  fillAlpha: ee,
                  pointsCallback: (he, pe) => {
                    const de = pe[2].x + this.borderStyle.width / 2, ge = pe[2].y + this.borderStyle.width / 2, me = pe[3].x - pe[2].x - this.borderStyle.width, xe = pe[1].y - pe[3].y - this.borderStyle.width;
                    return he.push(`${de} ${ge} ${me} ${xe} re`), ce ? he.push("B") : he.push("S"), [pe[0].x, pe[1].x, pe[3].y, pe[1].y];
                  }
                });
              }
            }
          }
          class te extends A {
            constructor(M) {
              super(M);
              const {
                dict: X,
                xref: U
              } = M;
              if (this.data.annotationType = s.AnnotationType.CIRCLE, !this.appearance) {
                const Q = this.color ? K(this.color) : [0, 0, 0], re = X.get("CA"), le = $(X.getArray("IC"), null), ce = le ? K(le) : null, ee = ce ? re : null;
                if (this.borderStyle.width === 0 && !ce)
                  return;
                const he = 4 / 3 * Math.tan(Math.PI / (2 * 4));
                this._setDefaultAppearance({
                  xref: U,
                  extra: `${this.borderStyle.width} w`,
                  strokeColor: Q,
                  fillColor: ce,
                  strokeAlpha: re,
                  fillAlpha: ee,
                  pointsCallback: (pe, de) => {
                    const ge = de[0].x + this.borderStyle.width / 2, me = de[0].y - this.borderStyle.width / 2, xe = de[3].x - this.borderStyle.width / 2, ye = de[3].y + this.borderStyle.width / 2, ve = ge + (xe - ge) / 2, Ce = me + (ye - me) / 2, Ie = (xe - ge) / 2 * he, Ae = (ye - me) / 2 * he;
                    return pe.push(`${ve} ${ye} m`, `${ve + Ie} ${ye} ${xe} ${Ce + Ae} ${xe} ${Ce} c`, `${xe} ${Ce - Ae} ${ve + Ie} ${me} ${ve} ${me} c`, `${ve - Ie} ${me} ${ge} ${Ce - Ae} ${ge} ${Ce} c`, `${ge} ${Ce + Ae} ${ve - Ie} ${ye} ${ve} ${ye} c`, "h"), ce ? pe.push("B") : pe.push("S"), [de[0].x, de[1].x, de[3].y, de[1].y];
                  }
                });
              }
            }
          }
          class G extends A {
            constructor(M) {
              super(M);
              const {
                dict: X,
                xref: U
              } = M;
              this.data.annotationType = s.AnnotationType.POLYLINE, this.data.hasOwnCanvas = this.data.noRotate, this.data.vertices = [], this instanceof N || (this.setLineEndings(X.getArray("LE")), this.data.lineEndings = this.lineEndings);
              const Q = X.getArray("Vertices");
              if (Array.isArray(Q)) {
                for (let re = 0, le = Q.length; re < le; re += 2)
                  this.data.vertices.push({
                    x: Q[re],
                    y: Q[re + 1]
                  });
                if (!this.appearance) {
                  const re = this.color ? K(this.color) : [0, 0, 0], le = X.get("CA"), ce = this.borderStyle.width || 1, ee = 2 * ce, he = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
                  for (const pe of this.data.vertices)
                    he[0] = Math.min(he[0], pe.x - ee), he[1] = Math.min(he[1], pe.y - ee), he[2] = Math.max(he[2], pe.x + ee), he[3] = Math.max(he[3], pe.y + ee);
                  s.Util.intersect(this.rectangle, he) || (this.rectangle = he), this._setDefaultAppearance({
                    xref: U,
                    extra: `${ce} w`,
                    strokeColor: re,
                    strokeAlpha: le,
                    pointsCallback: (pe, de) => {
                      const ge = this.data.vertices;
                      for (let me = 0, xe = ge.length; me < xe; me++)
                        pe.push(`${ge[me].x} ${ge[me].y} ${me === 0 ? "m" : "l"}`);
                      return pe.push("S"), [de[0].x, de[1].x, de[3].y, de[1].y];
                    }
                  });
                }
              }
            }
          }
          class N extends G {
            constructor(M) {
              super(M), this.data.annotationType = s.AnnotationType.POLYGON;
            }
          }
          class q extends A {
            constructor(M) {
              super(M), this.data.annotationType = s.AnnotationType.CARET;
            }
          }
          class ie extends A {
            constructor(M) {
              super(M), this.data.hasOwnCanvas = this.data.noRotate;
              const {
                dict: X,
                xref: U
              } = M;
              this.data.annotationType = s.AnnotationType.INK, this.data.inkLists = [];
              const Q = X.getArray("InkList");
              if (Array.isArray(Q)) {
                for (let re = 0, le = Q.length; re < le; ++re) {
                  this.data.inkLists.push([]);
                  for (let ce = 0, ee = Q[re].length; ce < ee; ce += 2)
                    this.data.inkLists[re].push({
                      x: U.fetchIfRef(Q[re][ce]),
                      y: U.fetchIfRef(Q[re][ce + 1])
                    });
                }
                if (!this.appearance) {
                  const re = this.color ? K(this.color) : [0, 0, 0], le = X.get("CA"), ce = this.borderStyle.width || 1, ee = 2 * ce, he = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
                  for (const pe of this.data.inkLists)
                    for (const de of pe)
                      he[0] = Math.min(he[0], de.x - ee), he[1] = Math.min(he[1], de.y - ee), he[2] = Math.max(he[2], de.x + ee), he[3] = Math.max(he[3], de.y + ee);
                  s.Util.intersect(this.rectangle, he) || (this.rectangle = he), this._setDefaultAppearance({
                    xref: U,
                    extra: `${ce} w`,
                    strokeColor: re,
                    strokeAlpha: le,
                    pointsCallback: (pe, de) => {
                      for (const ge of this.data.inkLists) {
                        for (let me = 0, xe = ge.length; me < xe; me++)
                          pe.push(`${ge[me].x} ${ge[me].y} ${me === 0 ? "m" : "l"}`);
                        pe.push("S");
                      }
                      return [de[0].x, de[1].x, de[3].y, de[1].y];
                    }
                  });
                }
              }
            }
            static createNewDict(M, X, {
              apRef: U,
              ap: Q
            }) {
              const {
                color: re,
                opacity: le,
                paths: ce,
                rect: ee,
                rotation: he,
                thickness: pe
              } = M, de = new t.Dict(X);
              de.set("Type", t.Name.get("Annot")), de.set("Subtype", t.Name.get("Ink")), de.set("CreationDate", `D:${(0, s.getModificationDate)()}`), de.set("Rect", ee), de.set("InkList", ce.map((xe) => xe.points)), de.set("F", 4), de.set("Rotate", he);
              const ge = new t.Dict(X);
              de.set("BS", ge), ge.set("W", pe), de.set("C", Array.from(re, (xe) => xe / 255)), de.set("CA", le);
              const me = new t.Dict(X);
              return de.set("AP", me), U ? me.set("N", U) : me.set("N", Q), de;
            }
            static async createNewAppearanceStream(M, X, U) {
              const {
                color: Q,
                rect: re,
                paths: le,
                thickness: ce,
                opacity: ee
              } = M, he = [`${ce} w 1 J 1 j`, `${(0, g.getPdfColor)(Q, !1)}`];
              ee !== 1 && he.push("/R0 gs");
              const pe = [];
              for (const {
                bezier: xe
              } of le) {
                pe.length = 0, pe.push(`${(0, h.numberToString)(xe[0])} ${(0, h.numberToString)(xe[1])} m`);
                for (let ye = 2, ve = xe.length; ye < ve; ye += 6) {
                  const Ce = xe.slice(ye, ye + 6).map(h.numberToString).join(" ");
                  pe.push(`${Ce} c`);
                }
                pe.push("S"), he.push(pe.join(`
`));
              }
              const de = he.join(`
`), ge = new t.Dict(X);
              if (ge.set("FormType", 1), ge.set("Subtype", t.Name.get("Form")), ge.set("Type", t.Name.get("XObject")), ge.set("BBox", re), ge.set("Length", de.length), ee !== 1) {
                const xe = new t.Dict(X), ye = new t.Dict(X), ve = new t.Dict(X);
                ve.set("CA", ee), ve.set("Type", t.Name.get("ExtGState")), ye.set("R0", ve), xe.set("ExtGState", ye), ge.set("Resources", xe);
              }
              const me = new i.StringStream(de);
              return me.dict = ge, me;
            }
          }
          class oe extends A {
            constructor(M) {
              var re;
              super(M);
              const {
                dict: X,
                xref: U
              } = M;
              if (this.data.annotationType = s.AnnotationType.HIGHLIGHT, this.data.quadPoints = H(X, null)) {
                const le = (re = this.appearance) == null ? void 0 : re.dict.get("Resources");
                if (!this.appearance || !(le != null && le.has("ExtGState"))) {
                  this.appearance && (0, s.warn)("HighlightAnnotation - ignoring built-in appearance stream.");
                  const ce = this.color ? K(this.color) : [1, 1, 0], ee = X.get("CA");
                  this._setDefaultAppearance({
                    xref: U,
                    fillColor: ce,
                    blendMode: "Multiply",
                    fillAlpha: ee,
                    pointsCallback: (he, pe) => (he.push(`${pe[0].x} ${pe[0].y} m`, `${pe[1].x} ${pe[1].y} l`, `${pe[3].x} ${pe[3].y} l`, `${pe[2].x} ${pe[2].y} l`, "f"), [pe[0].x, pe[1].x, pe[3].y, pe[1].y])
                  });
                }
              } else
                this.data.popupRef = null;
            }
          }
          class fe extends A {
            constructor(M) {
              super(M);
              const {
                dict: X,
                xref: U
              } = M;
              if (this.data.annotationType = s.AnnotationType.UNDERLINE, this.data.quadPoints = H(X, null)) {
                if (!this.appearance) {
                  const re = this.color ? K(this.color) : [0, 0, 0], le = X.get("CA");
                  this._setDefaultAppearance({
                    xref: U,
                    extra: "[] 0 d 0.571 w",
                    strokeColor: re,
                    strokeAlpha: le,
                    pointsCallback: (ce, ee) => (ce.push(`${ee[2].x} ${ee[2].y + 1.3} m`, `${ee[3].x} ${ee[3].y + 1.3} l`, "S"), [ee[0].x, ee[1].x, ee[3].y, ee[1].y])
                  });
                }
              } else
                this.data.popupRef = null;
            }
          }
          class Y extends A {
            constructor(M) {
              super(M);
              const {
                dict: X,
                xref: U
              } = M;
              if (this.data.annotationType = s.AnnotationType.SQUIGGLY, this.data.quadPoints = H(X, null)) {
                if (!this.appearance) {
                  const re = this.color ? K(this.color) : [0, 0, 0], le = X.get("CA");
                  this._setDefaultAppearance({
                    xref: U,
                    extra: "[] 0 d 1 w",
                    strokeColor: re,
                    strokeAlpha: le,
                    pointsCallback: (ce, ee) => {
                      const he = (ee[0].y - ee[2].y) / 6;
                      let pe = he, de = ee[2].x;
                      const ge = ee[2].y, me = ee[3].x;
                      ce.push(`${de} ${ge + pe} m`);
                      do
                        de += 2, pe = pe === 0 ? he : 0, ce.push(`${de} ${ge + pe} l`);
                      while (de < me);
                      return ce.push("S"), [ee[2].x, me, ge - 2 * he, ge + 2 * he];
                    }
                  });
                }
              } else
                this.data.popupRef = null;
            }
          }
          class ae extends A {
            constructor(M) {
              super(M);
              const {
                dict: X,
                xref: U
              } = M;
              if (this.data.annotationType = s.AnnotationType.STRIKEOUT, this.data.quadPoints = H(X, null)) {
                if (!this.appearance) {
                  const re = this.color ? K(this.color) : [0, 0, 0], le = X.get("CA");
                  this._setDefaultAppearance({
                    xref: U,
                    extra: "[] 0 d 1 w",
                    strokeColor: re,
                    strokeAlpha: le,
                    pointsCallback: (ce, ee) => (ce.push(`${(ee[0].x + ee[2].x) / 2} ${(ee[0].y + ee[2].y) / 2} m`, `${(ee[1].x + ee[3].x) / 2} ${(ee[1].y + ee[3].y) / 2} l`, "S"), [ee[0].x, ee[1].x, ee[3].y, ee[1].y])
                  });
                }
              } else
                this.data.popupRef = null;
            }
          }
          class se extends A {
            constructor(M) {
              super(M), this.data.annotationType = s.AnnotationType.STAMP, this.data.hasOwnCanvas = this.data.noRotate;
            }
            static async createImage(M, X) {
              const {
                width: U,
                height: Q
              } = M, re = new OffscreenCanvas(U, Q), le = re.getContext("2d", {
                alpha: !0
              });
              le.drawImage(M, 0, 0);
              const ce = le.getImageData(0, 0, U, Q).data, ee = new Uint32Array(ce.buffer), he = ee.some(s.FeatureTest.isLittleEndian ? (ve) => ve >>> 24 !== 255 : (ve) => (ve & 255) !== 255);
              he && (le.fillStyle = "white", le.fillRect(0, 0, U, Q), le.drawImage(M, 0, 0));
              const pe = re.convertToBlob({
                type: "image/jpeg",
                quality: 1
              }).then((ve) => ve.arrayBuffer()), de = t.Name.get("XObject"), ge = t.Name.get("Image"), me = new t.Dict(X);
              me.set("Type", de), me.set("Subtype", ge), me.set("BitsPerComponent", 8), me.set("ColorSpace", t.Name.get("DeviceRGB")), me.set("Filter", t.Name.get("DCTDecode")), me.set("BBox", [0, 0, U, Q]), me.set("Width", U), me.set("Height", Q);
              let xe = null;
              if (he) {
                const ve = new Uint8Array(ee.length);
                if (s.FeatureTest.isLittleEndian)
                  for (let Ie = 0, Ae = ee.length; Ie < Ae; Ie++)
                    ve[Ie] = ee[Ie] >>> 24;
                else
                  for (let Ie = 0, Ae = ee.length; Ie < Ae; Ie++)
                    ve[Ie] = ee[Ie] & 255;
                const Ce = new t.Dict(X);
                Ce.set("Type", de), Ce.set("Subtype", ge), Ce.set("BitsPerComponent", 8), Ce.set("ColorSpace", t.Name.get("DeviceGray")), Ce.set("Width", U), Ce.set("Height", Q), xe = new i.Stream(ve, 0, 0, Ce);
              }
              return {
                imageStream: new i.Stream(await pe, 0, 0, me),
                smaskStream: xe,
                width: U,
                height: Q
              };
            }
            static createNewDict(M, X, {
              apRef: U,
              ap: Q
            }) {
              const {
                rect: re,
                rotation: le,
                user: ce
              } = M, ee = new t.Dict(X);
              if (ee.set("Type", t.Name.get("Annot")), ee.set("Subtype", t.Name.get("Stamp")), ee.set("CreationDate", `D:${(0, s.getModificationDate)()}`), ee.set("Rect", re), ee.set("F", 4), ee.set("Border", [0, 0, 0]), ee.set("Rotate", le), ce && ee.set("T", (0, h.isAscii)(ce) ? ce : (0, h.stringToUTF16String)(ce, !0)), U || Q) {
                const he = new t.Dict(X);
                ee.set("AP", he), U ? he.set("N", U) : he.set("N", Q);
              }
              return ee;
            }
            static async createNewAppearanceStream(M, X, U) {
              const {
                rotation: Q
              } = M, {
                imageRef: re,
                width: le,
                height: ce
              } = U.image, ee = new t.Dict(X), he = new t.Dict(X);
              ee.set("XObject", he), he.set("Im0", re);
              const pe = `q ${le} 0 0 ${ce} 0 0 cm /Im0 Do Q`, de = new t.Dict(X);
              if (de.set("FormType", 1), de.set("Subtype", t.Name.get("Form")), de.set("Type", t.Name.get("XObject")), de.set("BBox", [0, 0, le, ce]), de.set("Resources", ee), Q) {
                const me = (0, h.getRotationMatrix)(Q, le, ce);
                de.set("Matrix", me);
              }
              const ge = new i.StringStream(pe);
              return ge.dict = de, ge;
            }
          }
          class L extends A {
            constructor(M) {
              super(M);
              const {
                dict: X,
                xref: U
              } = M, Q = new y.FileSpec(X.get("FS"), U);
              this.data.annotationType = s.AnnotationType.FILEATTACHMENT, this.data.hasOwnCanvas = this.data.noRotate, this.data.file = Q.serializable;
              const re = X.get("Name");
              this.data.name = re instanceof t.Name ? (0, s.stringToPDFString)(re.name) : "PushPin";
              const le = X.get("ca");
              this.data.fillAlpha = typeof le == "number" && le >= 0 && le <= 1 ? le : null;
            }
          }
        },
        /* 11 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.FakeUnicodeFont = void 0, c.createDefaultAppearance = I, c.getPdfColor = u, c.parseAppearanceStream = b, c.parseDefaultAppearance = y;
          var s = f(4), h = f(3), g = f(2), t = f(12), i = f(13), m = f(59), v = f(57), E = f(8);
          class S extends i.EvaluatorPreprocessor {
            constructor($) {
              super(new E.StringStream($));
            }
            parse() {
              const $ = {
                fn: 0,
                args: []
              }, K = {
                fontSize: 0,
                fontName: "",
                fontColor: new Uint8ClampedArray(3)
              };
              try {
                for (; $.args.length = 0, !!this.read($); ) {
                  if (this.savedStatesDepth !== 0)
                    continue;
                  const {
                    fn: H,
                    args: B
                  } = $;
                  switch (H | 0) {
                    case g.OPS.setFont:
                      const [R, _] = B;
                      R instanceof s.Name && (K.fontName = R.name), typeof _ == "number" && _ > 0 && (K.fontSize = _);
                      break;
                    case g.OPS.setFillRGBColor:
                      t.ColorSpace.singletons.rgb.getRgbItem(B, 0, K.fontColor, 0);
                      break;
                    case g.OPS.setFillGray:
                      t.ColorSpace.singletons.gray.getRgbItem(B, 0, K.fontColor, 0);
                      break;
                    case g.OPS.setFillCMYKColor:
                      t.ColorSpace.singletons.cmyk.getRgbItem(B, 0, K.fontColor, 0);
                      break;
                  }
                }
              } catch (H) {
                (0, g.warn)(`parseDefaultAppearance - ignoring errors: "${H}".`);
              }
              return K;
            }
          }
          function y(D) {
            return new S(D).parse();
          }
          class x extends i.EvaluatorPreprocessor {
            constructor($, K, H) {
              var B;
              super($), this.stream = $, this.evaluatorOptions = K, this.xref = H, this.resources = (B = $.dict) == null ? void 0 : B.get("Resources");
            }
            parse() {
              const $ = {
                fn: 0,
                args: []
              };
              let K = {
                scaleFactor: 1,
                fontSize: 0,
                fontName: "",
                fontColor: new Uint8ClampedArray(3),
                fillColorSpace: t.ColorSpace.singletons.gray
              }, H = !1;
              const B = [];
              try {
                for (; $.args.length = 0, !(H || !this.read($)); ) {
                  const {
                    fn: R,
                    args: _
                  } = $;
                  switch (R | 0) {
                    case g.OPS.save:
                      B.push({
                        scaleFactor: K.scaleFactor,
                        fontSize: K.fontSize,
                        fontName: K.fontName,
                        fontColor: K.fontColor.slice(),
                        fillColorSpace: K.fillColorSpace
                      });
                      break;
                    case g.OPS.restore:
                      K = B.pop() || K;
                      break;
                    case g.OPS.setTextMatrix:
                      K.scaleFactor *= Math.hypot(_[0], _[1]);
                      break;
                    case g.OPS.setFont:
                      const [A, k] = _;
                      A instanceof s.Name && (K.fontName = A.name), typeof k == "number" && k > 0 && (K.fontSize = k * K.scaleFactor);
                      break;
                    case g.OPS.setFillColorSpace:
                      K.fillColorSpace = t.ColorSpace.parse({
                        cs: _[0],
                        xref: this.xref,
                        resources: this.resources,
                        pdfFunctionFactory: this._pdfFunctionFactory,
                        localColorSpaceCache: this._localColorSpaceCache
                      });
                      break;
                    case g.OPS.setFillColor:
                      K.fillColorSpace.getRgbItem(_, 0, K.fontColor, 0);
                      break;
                    case g.OPS.setFillRGBColor:
                      t.ColorSpace.singletons.rgb.getRgbItem(_, 0, K.fontColor, 0);
                      break;
                    case g.OPS.setFillGray:
                      t.ColorSpace.singletons.gray.getRgbItem(_, 0, K.fontColor, 0);
                      break;
                    case g.OPS.setFillCMYKColor:
                      t.ColorSpace.singletons.cmyk.getRgbItem(_, 0, K.fontColor, 0);
                      break;
                    case g.OPS.showText:
                    case g.OPS.showSpacedText:
                    case g.OPS.nextLineShowText:
                    case g.OPS.nextLineSetSpacingShowText:
                      H = !0;
                      break;
                  }
                }
              } catch (R) {
                (0, g.warn)(`parseAppearanceStream - ignoring errors: "${R}".`);
              }
              return this.stream.reset(), delete K.scaleFactor, delete K.fillColorSpace, K;
            }
            get _localColorSpaceCache() {
              return (0, g.shadow)(this, "_localColorSpaceCache", new m.LocalColorSpaceCache());
            }
            get _pdfFunctionFactory() {
              const $ = new v.PDFFunctionFactory({
                xref: this.xref,
                isEvalSupported: this.evaluatorOptions.isEvalSupported
              });
              return (0, g.shadow)(this, "_pdfFunctionFactory", $);
            }
          }
          function b(D, $, K) {
            return new x(D, $, K).parse();
          }
          function u(D, $) {
            if (D[0] === D[1] && D[1] === D[2]) {
              const K = D[0] / 255;
              return `${(0, h.numberToString)(K)} ${$ ? "g" : "G"}`;
            }
            return Array.from(D, (K) => (0, h.numberToString)(K / 255)).join(" ") + ` ${$ ? "rg" : "RG"}`;
          }
          function I({
            fontSize: D,
            fontName: $,
            fontColor: K
          }) {
            return `/${(0, h.escapePDFName)($)} ${D} Tf ${u(K, !0)}`;
          }
          class O {
            constructor($, K) {
              this.xref = $, this.widths = null, this.firstChar = 1 / 0, this.lastChar = -1 / 0, this.fontFamily = K;
              const H = new OffscreenCanvas(1, 1);
              this.ctxMeasure = H.getContext("2d"), O._fontNameId || (O._fontNameId = 1), this.fontName = s.Name.get(`InvalidPDFjsFont_${K}_${O._fontNameId++}`);
            }
            get toUnicodeRef() {
              if (!O._toUnicodeRef) {
                const $ = `/CIDInit /ProcSet findresource begin
12 dict begin
begincmap
/CIDSystemInfo
<< /Registry (Adobe)
/Ordering (UCS) /Supplement 0 >> def
/CMapName /Adobe-Identity-UCS def
/CMapType 2 def
1 begincodespacerange
<0000> <FFFF>
endcodespacerange
1 beginbfrange
<0000> <FFFF> <0000>
endbfrange
endcmap CMapName currentdict /CMap defineresource pop end end`, K = O.toUnicodeStream = new E.StringStream($), H = new s.Dict(this.xref);
                K.dict = H, H.set("Length", $.length), O._toUnicodeRef = this.xref.getNewPersistentRef(K);
              }
              return O._toUnicodeRef;
            }
            get fontDescriptorRef() {
              if (!O._fontDescriptorRef) {
                const $ = new s.Dict(this.xref);
                $.set("Type", s.Name.get("FontDescriptor")), $.set("FontName", this.fontName), $.set("FontFamily", "MyriadPro Regular"), $.set("FontBBox", [0, 0, 0, 0]), $.set("FontStretch", s.Name.get("Normal")), $.set("FontWeight", 400), $.set("ItalicAngle", 0), O._fontDescriptorRef = this.xref.getNewPersistentRef($);
              }
              return O._fontDescriptorRef;
            }
            get descendantFontRef() {
              const $ = new s.Dict(this.xref);
              $.set("BaseFont", this.fontName), $.set("Type", s.Name.get("Font")), $.set("Subtype", s.Name.get("CIDFontType0")), $.set("CIDToGIDMap", s.Name.get("Identity")), $.set("FirstChar", this.firstChar), $.set("LastChar", this.lastChar), $.set("FontDescriptor", this.fontDescriptorRef), $.set("DW", 1e3);
              const K = [], H = [...this.widths.entries()].sort();
              let B = null, R = null;
              for (const [A, k] of H) {
                if (!B) {
                  B = A, R = [k];
                  continue;
                }
                A === B + R.length ? R.push(k) : (K.push(B, R), B = A, R = [k]);
              }
              B && K.push(B, R), $.set("W", K);
              const _ = new s.Dict(this.xref);
              return _.set("Ordering", "Identity"), _.set("Registry", "Adobe"), _.set("Supplement", 0), $.set("CIDSystemInfo", _), this.xref.getNewPersistentRef($);
            }
            get baseFontRef() {
              const $ = new s.Dict(this.xref);
              return $.set("BaseFont", this.fontName), $.set("Type", s.Name.get("Font")), $.set("Subtype", s.Name.get("Type0")), $.set("Encoding", s.Name.get("Identity-H")), $.set("DescendantFonts", [this.descendantFontRef]), $.set("ToUnicode", this.toUnicodeRef), this.xref.getNewPersistentRef($);
            }
            get resources() {
              const $ = new s.Dict(this.xref), K = new s.Dict(this.xref);
              return K.set(this.fontName.name, this.baseFontRef), $.set("Font", K), $;
            }
            _createContext() {
              return this.widths = /* @__PURE__ */ new Map(), this.ctxMeasure.font = `1000px ${this.fontFamily}`, this.ctxMeasure;
            }
            createFontResources($) {
              const K = this._createContext();
              for (const H of $.split(/\r\n?|\n/))
                for (const B of H.split("")) {
                  const R = B.charCodeAt(0);
                  if (this.widths.has(R))
                    continue;
                  const _ = K.measureText(B), A = Math.ceil(_.width);
                  this.widths.set(R, A), this.firstChar = Math.min(R, this.firstChar), this.lastChar = Math.max(R, this.lastChar);
                }
              return this.resources;
            }
            createAppearance($, K, H, B, R, _) {
              const A = this._createContext(), k = [];
              let z = -1 / 0;
              for (const L of $.split(/\r\n?|\n/)) {
                k.push(L);
                const W = A.measureText(L).width;
                z = Math.max(z, W);
                for (const M of L.split("")) {
                  const X = M.charCodeAt(0);
                  let U = this.widths.get(X);
                  if (U === void 0) {
                    const Q = A.measureText(M);
                    U = Math.ceil(Q.width), this.widths.set(X, U), this.firstChar = Math.min(X, this.firstChar), this.lastChar = Math.max(X, this.lastChar);
                  }
                }
              }
              z *= B / 1e3;
              const [T, w, F, j] = K;
              let P = F - T, V = j - w;
              H % 180 !== 0 && ([P, V] = [V, P]);
              let J = 1;
              z > P && (J = P / z);
              let ne = 1;
              const Z = g.LINE_FACTOR * B, te = g.LINE_DESCENT_FACTOR * B, G = Z * k.length;
              G > V && (ne = V / G);
              const N = Math.min(J, ne), q = B * N, ie = ["q", `0 0 ${(0, h.numberToString)(P)} ${(0, h.numberToString)(V)} re W n`, "BT", `1 0 0 1 0 ${(0, h.numberToString)(V + te)} Tm 0 Tc ${u(R, !0)}`, `/${this.fontName.name} ${(0, h.numberToString)(q)} Tf`], {
                resources: oe
              } = this;
              if (_ = typeof _ == "number" && _ >= 0 && _ <= 1 ? _ : 1, _ !== 1) {
                ie.push("/R0 gs");
                const L = new s.Dict(this.xref), W = new s.Dict(this.xref);
                W.set("ca", _), W.set("CA", _), W.set("Type", s.Name.get("ExtGState")), L.set("R0", W), oe.set("ExtGState", L);
              }
              const fe = (0, h.numberToString)(Z);
              for (const L of k)
                ie.push(`0 -${fe} Td <${(0, h.stringToUTF16HexString)(L)}> Tj`);
              ie.push("ET", "Q");
              const Y = ie.join(`
`), ae = new s.Dict(this.xref);
              if (ae.set("Subtype", s.Name.get("Form")), ae.set("Type", s.Name.get("XObject")), ae.set("BBox", [0, 0, P, V]), ae.set("Length", Y.length), ae.set("Resources", oe), H) {
                const L = (0, h.getRotationMatrix)(H, P, V);
                ae.set("Matrix", L);
              }
              const se = new E.StringStream(Y);
              return se.dict = ae, se;
            }
          }
          c.FakeUnicodeFont = O;
        },
        /* 12 */
        /***/
        (d, c, f) => {
          var D, Md, K, Dd, B, R, _, A, k, z, T, w, F, xa, D2, N2, pl, ba, ya, L2, B2, $2, Nd, oe, gl, ml, Ld;
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.ColorSpace = void 0;
          var s = f(2), h = f(4), g = f(5), t = f(3);
          function i(se, L, W, M, X, U, Q) {
            Q = Q !== 1 ? 0 : Q;
            const le = W / X, ce = M / U;
            let ee = 0, he;
            const pe = new Uint16Array(X), de = W * 3;
            for (let ge = 0; ge < X; ge++)
              pe[ge] = Math.floor(ge * le) * 3;
            for (let ge = 0; ge < U; ge++) {
              const me = Math.floor(ge * ce) * de;
              for (let xe = 0; xe < X; xe++)
                he = me + pe[xe], L[ee++] = se[he++], L[ee++] = se[he++], L[ee++] = se[he++], ee += Q;
            }
          }
          class m {
            constructor(L, W) {
              this.constructor === m && (0, s.unreachable)("Cannot initialize ColorSpace."), this.name = L, this.numComps = W;
            }
            getRgb(L, W) {
              const M = new Uint8ClampedArray(3);
              return this.getRgbItem(L, W, M, 0), M;
            }
            getRgbItem(L, W, M, X) {
              (0, s.unreachable)("Should not call ColorSpace.getRgbItem");
            }
            getRgbBuffer(L, W, M, X, U, Q, re) {
              (0, s.unreachable)("Should not call ColorSpace.getRgbBuffer");
            }
            getOutputLength(L, W) {
              (0, s.unreachable)("Should not call ColorSpace.getOutputLength");
            }
            isPassthrough(L) {
              return !1;
            }
            isDefaultDecode(L, W) {
              return m.isDefaultDecode(L, this.numComps);
            }
            fillRgb(L, W, M, X, U, Q, re, le, ce) {
              const ee = W * M;
              let he = null;
              const pe = 1 << re, de = M !== U || W !== X;
              if (this.isPassthrough(re))
                he = le;
              else if (this.numComps === 1 && ee > pe && this.name !== "DeviceGray" && this.name !== "DeviceRGB") {
                const ge = re <= 8 ? new Uint8Array(pe) : new Uint16Array(pe);
                for (let xe = 0; xe < pe; xe++)
                  ge[xe] = xe;
                const me = new Uint8ClampedArray(pe * 3);
                if (this.getRgbBuffer(ge, 0, pe, me, 0, re, 0), de) {
                  he = new Uint8Array(ee * 3);
                  let xe = 0;
                  for (let ye = 0; ye < ee; ++ye) {
                    const ve = le[ye] * 3;
                    he[xe++] = me[ve], he[xe++] = me[ve + 1], he[xe++] = me[ve + 2];
                  }
                } else {
                  let xe = 0;
                  for (let ye = 0; ye < ee; ++ye) {
                    const ve = le[ye] * 3;
                    L[xe++] = me[ve], L[xe++] = me[ve + 1], L[xe++] = me[ve + 2], xe += ce;
                  }
                }
              } else de ? (he = new Uint8ClampedArray(ee * 3), this.getRgbBuffer(le, 0, ee, he, 0, re, 0)) : this.getRgbBuffer(le, 0, X * Q, L, 0, re, ce);
              if (he)
                if (de)
                  i(he, L, W, M, X, U, ce);
                else {
                  let ge = 0, me = 0;
                  for (let xe = 0, ye = X * Q; xe < ye; xe++)
                    L[ge++] = he[me++], L[ge++] = he[me++], L[ge++] = he[me++], ge += ce;
                }
            }
            get usesZeroToOneRange() {
              return (0, s.shadow)(this, "usesZeroToOneRange", !0);
            }
            static _cache(L, W, M, X) {
              if (!M)
                throw new Error('ColorSpace._cache - expected "localColorSpaceCache" argument.');
              if (!X)
                throw new Error('ColorSpace._cache - expected "parsedColorSpace" argument.');
              let U, Q;
              L instanceof h.Ref && (Q = L, L = W.fetch(L)), L instanceof h.Name && (U = L.name), (U || Q) && M.set(U, Q, X);
            }
            static getCached(L, W, M) {
              if (!M)
                throw new Error('ColorSpace.getCached - expected "localColorSpaceCache" argument.');
              if (L instanceof h.Ref) {
                const X = M.getByRef(L);
                if (X)
                  return X;
                try {
                  L = W.fetch(L);
                } catch (U) {
                  if (U instanceof t.MissingDataException)
                    throw U;
                }
              }
              if (L instanceof h.Name) {
                const X = M.getByName(L.name);
                if (X)
                  return X;
              }
              return null;
            }
            static async parseAsync({
              cs: L,
              xref: W,
              resources: M = null,
              pdfFunctionFactory: X,
              localColorSpaceCache: U
            }) {
              const Q = this._parse(L, W, M, X);
              return this._cache(L, W, U, Q), Q;
            }
            static parse({
              cs: L,
              xref: W,
              resources: M = null,
              pdfFunctionFactory: X,
              localColorSpaceCache: U
            }) {
              const Q = this.getCached(L, W, U);
              if (Q)
                return Q;
              const re = this._parse(L, W, M, X);
              return this._cache(L, W, U, re), re;
            }
            static _parse(L, W, M = null, X) {
              if (L = W.fetchIfRef(L), L instanceof h.Name)
                switch (L.name) {
                  case "G":
                  case "DeviceGray":
                    return this.singletons.gray;
                  case "RGB":
                  case "DeviceRGB":
                    return this.singletons.rgb;
                  case "CMYK":
                  case "DeviceCMYK":
                    return this.singletons.cmyk;
                  case "Pattern":
                    return new E(null);
                  default:
                    if (M instanceof h.Dict) {
                      const U = M.get("ColorSpace");
                      if (U instanceof h.Dict) {
                        const Q = U.get(L.name);
                        if (Q) {
                          if (Q instanceof h.Name)
                            return this._parse(Q, W, M, X);
                          L = Q;
                          break;
                        }
                      }
                    }
                    throw new s.FormatError(`Unrecognized ColorSpace: ${L.name}`);
                }
              if (Array.isArray(L)) {
                const U = W.fetchIfRef(L[0]).name;
                let Q, re, le, ce, ee, he;
                switch (U) {
                  case "G":
                  case "DeviceGray":
                    return this.singletons.gray;
                  case "RGB":
                  case "DeviceRGB":
                    return this.singletons.rgb;
                  case "CMYK":
                  case "DeviceCMYK":
                    return this.singletons.cmyk;
                  case "CalGray":
                    return Q = W.fetchIfRef(L[1]), ce = Q.getArray("WhitePoint"), ee = Q.getArray("BlackPoint"), he = Q.get("Gamma"), new u(ce, ee, he);
                  case "CalRGB":
                    Q = W.fetchIfRef(L[1]), ce = Q.getArray("WhitePoint"), ee = Q.getArray("BlackPoint"), he = Q.getArray("Gamma");
                    const pe = Q.getArray("Matrix");
                    return new I(ce, ee, he, pe);
                  case "ICCBased":
                    const ge = W.fetchIfRef(L[1]).dict;
                    re = ge.get("N");
                    const me = ge.get("Alternate");
                    if (me) {
                      const Ae = this._parse(me, W, M, X);
                      if (Ae.numComps === re)
                        return Ae;
                      (0, s.warn)("ICCBased color space: Ignoring incorrect /Alternate entry.");
                    }
                    if (re === 1)
                      return this.singletons.gray;
                    if (re === 3)
                      return this.singletons.rgb;
                    if (re === 4)
                      return this.singletons.cmyk;
                    break;
                  case "Pattern":
                    return le = L[1] || null, le && (le = this._parse(le, W, M, X)), new E(le);
                  case "I":
                  case "Indexed":
                    le = this._parse(L[1], W, M, X);
                    const xe = W.fetchIfRef(L[2]) + 1, ye = W.fetchIfRef(L[3]);
                    return new S(le, xe, ye);
                  case "Separation":
                  case "DeviceN":
                    const ve = W.fetchIfRef(L[1]);
                    re = Array.isArray(ve) ? ve.length : 1, le = this._parse(L[2], W, M, X);
                    const Ce = X.create(L[3]);
                    return new v(re, le, Ce);
                  case "Lab":
                    Q = W.fetchIfRef(L[1]), ce = Q.getArray("WhitePoint"), ee = Q.getArray("BlackPoint");
                    const Ie = Q.getArray("Range");
                    return new O(ce, ee, Ie);
                  default:
                    throw new s.FormatError(`Unimplemented ColorSpace object: ${U}`);
                }
              }
              throw new s.FormatError(`Unrecognized ColorSpace object: ${L}`);
            }
            static isDefaultDecode(L, W) {
              if (!Array.isArray(L))
                return !0;
              if (W * 2 !== L.length)
                return (0, s.warn)("The decode map is not the correct length"), !0;
              for (let M = 0, X = L.length; M < X; M += 2)
                if (L[M] !== 0 || L[M + 1] !== 1)
                  return !1;
              return !0;
            }
            static get singletons() {
              return (0, s.shadow)(this, "singletons", {
                get gray() {
                  return (0, s.shadow)(this, "gray", new y());
                },
                get rgb() {
                  return (0, s.shadow)(this, "rgb", new x());
                },
                get cmyk() {
                  return (0, s.shadow)(this, "cmyk", new b());
                }
              });
            }
          }
          c.ColorSpace = m;
          class v extends m {
            constructor(L, W, M) {
              super("Alternate", L), this.base = W, this.tintFn = M, this.tmpBuf = new Float32Array(W.numComps);
            }
            getRgbItem(L, W, M, X) {
              const U = this.tmpBuf;
              this.tintFn(L, W, U, 0), this.base.getRgbItem(U, 0, M, X);
            }
            getRgbBuffer(L, W, M, X, U, Q, re) {
              const le = this.tintFn, ce = this.base, ee = 1 / ((1 << Q) - 1), he = ce.numComps, pe = ce.usesZeroToOneRange, de = (ce.isPassthrough(8) || !pe) && re === 0;
              let ge = de ? U : 0;
              const me = de ? X : new Uint8ClampedArray(he * M), xe = this.numComps, ye = new Float32Array(xe), ve = new Float32Array(he);
              let Ce, Ie;
              for (Ce = 0; Ce < M; Ce++) {
                for (Ie = 0; Ie < xe; Ie++)
                  ye[Ie] = L[W++] * ee;
                if (le(ye, 0, ve, 0), pe)
                  for (Ie = 0; Ie < he; Ie++)
                    me[ge++] = ve[Ie] * 255;
                else
                  ce.getRgbItem(ve, 0, me, ge), ge += he;
              }
              de || ce.getRgbBuffer(me, 0, M, X, U, 8, re);
            }
            getOutputLength(L, W) {
              return this.base.getOutputLength(L * this.base.numComps / this.numComps, W);
            }
          }
          class E extends m {
            constructor(L) {
              super("Pattern", null), this.base = L;
            }
            isDefaultDecode(L, W) {
              (0, s.unreachable)("Should not call PatternCS.isDefaultDecode");
            }
          }
          class S extends m {
            constructor(L, W, M) {
              super("Indexed", 1), this.base = L, this.highVal = W;
              const X = L.numComps * W;
              if (this.lookup = new Uint8Array(X), M instanceof g.BaseStream) {
                const U = M.getBytes(X);
                this.lookup.set(U);
              } else if (typeof M == "string")
                for (let U = 0; U < X; ++U)
                  this.lookup[U] = M.charCodeAt(U) & 255;
              else
                throw new s.FormatError(`IndexedCS - unrecognized lookup table: ${M}`);
            }
            getRgbItem(L, W, M, X) {
              const U = this.base.numComps, Q = L[W] * U;
              this.base.getRgbBuffer(this.lookup, Q, 1, M, X, 8, 0);
            }
            getRgbBuffer(L, W, M, X, U, Q, re) {
              const le = this.base, ce = le.numComps, ee = le.getOutputLength(ce, re), he = this.lookup;
              for (let pe = 0; pe < M; ++pe) {
                const de = L[W++] * ce;
                le.getRgbBuffer(he, de, 1, X, U, 8, re), U += ee;
              }
            }
            getOutputLength(L, W) {
              return this.base.getOutputLength(L * this.base.numComps, W);
            }
            isDefaultDecode(L, W) {
              return Array.isArray(L) ? L.length !== 2 ? ((0, s.warn)("Decode map length is not correct"), !0) : !Number.isInteger(W) || W < 1 ? ((0, s.warn)("Bits per component is not correct"), !0) : L[0] === 0 && L[1] === (1 << W) - 1 : !0;
            }
          }
          class y extends m {
            constructor() {
              super("DeviceGray", 1);
            }
            getRgbItem(L, W, M, X) {
              const U = L[W] * 255;
              M[X] = M[X + 1] = M[X + 2] = U;
            }
            getRgbBuffer(L, W, M, X, U, Q, re) {
              const le = 255 / ((1 << Q) - 1);
              let ce = W, ee = U;
              for (let he = 0; he < M; ++he) {
                const pe = le * L[ce++];
                X[ee++] = pe, X[ee++] = pe, X[ee++] = pe, ee += re;
              }
            }
            getOutputLength(L, W) {
              return L * (3 + W);
            }
          }
          class x extends m {
            constructor() {
              super("DeviceRGB", 3);
            }
            getRgbItem(L, W, M, X) {
              M[X] = L[W] * 255, M[X + 1] = L[W + 1] * 255, M[X + 2] = L[W + 2] * 255;
            }
            getRgbBuffer(L, W, M, X, U, Q, re) {
              if (Q === 8 && re === 0) {
                X.set(L.subarray(W, W + M * 3), U);
                return;
              }
              const le = 255 / ((1 << Q) - 1);
              let ce = W, ee = U;
              for (let he = 0; he < M; ++he)
                X[ee++] = le * L[ce++], X[ee++] = le * L[ce++], X[ee++] = le * L[ce++], ee += re;
            }
            getOutputLength(L, W) {
              return L * (3 + W) / 3 | 0;
            }
            isPassthrough(L) {
              return L === 8;
            }
          }
          class b extends m {
            constructor() {
              super("DeviceCMYK", 4);
              zn(this, D);
            }
            getRgbItem(W, M, X, U) {
              Nt(this, D, Md).call(this, W, M, 1, X, U);
            }
            getRgbBuffer(W, M, X, U, Q, re, le) {
              const ce = 1 / ((1 << re) - 1);
              for (let ee = 0; ee < X; ee++)
                Nt(this, D, Md).call(this, W, M, ce, U, Q), M += 4, Q += 3 + le;
            }
            getOutputLength(W, M) {
              return W / 4 * (3 + M) | 0;
            }
          }
          D = new WeakSet(), Md = function(W, M, X, U, Q) {
            const re = W[M] * X, le = W[M + 1] * X, ce = W[M + 2] * X, ee = W[M + 3] * X;
            U[Q] = 255 + re * (-4.387332384609988 * re + 54.48615194189176 * le + 18.82290502165302 * ce + 212.25662451639585 * ee + -285.2331026137004) + le * (1.7149763477362134 * le - 5.6096736904047315 * ce + -17.873870861415444 * ee - 5.497006427196366) + ce * (-2.5217340131683033 * ce - 21.248923337353073 * ee + 17.5119270841813) + ee * (-21.86122147463605 * ee - 189.48180835922747), U[Q + 1] = 255 + re * (8.841041422036149 * re + 60.118027045597366 * le + 6.871425592049007 * ce + 31.159100130055922 * ee + -79.2970844816548) + le * (-15.310361306967817 * le + 17.575251261109482 * ce + 131.35250912493976 * ee - 190.9453302588951) + ce * (4.444339102852739 * ce + 9.8632861493405 * ee - 24.86741582555878) + ee * (-20.737325471181034 * ee - 187.80453709719578), U[Q + 2] = 255 + re * (0.8842522430003296 * re + 8.078677503112928 * le + 30.89978309703729 * ce - 0.23883238689178934 * ee + -14.183576799673286) + le * (10.49593273432072 * le + 63.02378494754052 * ce + 50.606957656360734 * ee - 112.23884253719248) + ce * (0.03296041114873217 * ce + 115.60384449646641 * ee + -193.58209356861505) + ee * (-22.33816807309886 * ee - 180.12613974708367);
          };
          class u extends m {
            constructor(W, M, X) {
              super("CalGray", 1);
              zn(this, K);
              if (!W)
                throw new s.FormatError("WhitePoint missing - required for color space CalGray");
              if ([this.XW, this.YW, this.ZW] = W, [this.XB, this.YB, this.ZB] = M || [0, 0, 0], this.G = X || 1, this.XW < 0 || this.ZW < 0 || this.YW !== 1)
                throw new s.FormatError(`Invalid WhitePoint components for ${this.name}, no fallback available`);
              (this.XB < 0 || this.YB < 0 || this.ZB < 0) && ((0, s.info)(`Invalid BlackPoint for ${this.name}, falling back to default.`), this.XB = this.YB = this.ZB = 0), (this.XB !== 0 || this.YB !== 0 || this.ZB !== 0) && (0, s.warn)(`${this.name}, BlackPoint: XB: ${this.XB}, YB: ${this.YB}, ZB: ${this.ZB}, only default values are supported.`), this.G < 1 && ((0, s.info)(`Invalid Gamma: ${this.G} for ${this.name}, falling back to default.`), this.G = 1);
            }
            getRgbItem(W, M, X, U) {
              Nt(this, K, Dd).call(this, W, M, X, U, 1);
            }
            getRgbBuffer(W, M, X, U, Q, re, le) {
              const ce = 1 / ((1 << re) - 1);
              for (let ee = 0; ee < X; ++ee)
                Nt(this, K, Dd).call(this, W, M, U, Q, ce), M += 1, Q += 3 + le;
            }
            getOutputLength(W, M) {
              return W * (3 + M);
            }
          }
          K = new WeakSet(), Dd = function(W, M, X, U, Q) {
            const le = (W[M] * Q) ** this.G, ce = this.YW * le, ee = Math.max(295.8 * ce ** 0.3333333333333333 - 40.8, 0);
            X[U] = ee, X[U + 1] = ee, X[U + 2] = ee;
          };
          const ie = class ie extends m {
            constructor(W, M, X, U) {
              super("CalRGB", 3);
              zn(this, F);
              if (!W)
                throw new s.FormatError("WhitePoint missing - required for color space CalRGB");
              const [Q, re, le] = this.whitePoint = W, [ce, ee, he] = this.blackPoint = M || new Float32Array(3);
              if ([this.GR, this.GG, this.GB] = X || new Float32Array([1, 1, 1]), [this.MXA, this.MYA, this.MZA, this.MXB, this.MYB, this.MZB, this.MXC, this.MYC, this.MZC] = U || new Float32Array([1, 0, 0, 0, 1, 0, 0, 0, 1]), Q < 0 || le < 0 || re !== 1)
                throw new s.FormatError(`Invalid WhitePoint components for ${this.name}, no fallback available`);
              (ce < 0 || ee < 0 || he < 0) && ((0, s.info)(`Invalid BlackPoint for ${this.name} [${ce}, ${ee}, ${he}], falling back to default.`), this.blackPoint = new Float32Array(3)), (this.GR < 0 || this.GG < 0 || this.GB < 0) && ((0, s.info)(`Invalid Gamma [${this.GR}, ${this.GG}, ${this.GB}] for ${this.name}, falling back to default.`), this.GR = this.GG = this.GB = 1);
            }
            getRgbItem(W, M, X, U) {
              Nt(this, F, Nd).call(this, W, M, X, U, 1);
            }
            getRgbBuffer(W, M, X, U, Q, re, le) {
              const ce = 1 / ((1 << re) - 1);
              for (let ee = 0; ee < X; ++ee)
                Nt(this, F, Nd).call(this, W, M, U, Q, ce), M += 3, Q += 3 + le;
            }
            getOutputLength(W, M) {
              return W * (3 + M) / 3 | 0;
            }
          };
          B = new WeakMap(), R = new WeakMap(), _ = new WeakMap(), A = new WeakMap(), k = new WeakMap(), z = new WeakMap(), T = new WeakMap(), w = new WeakMap(), F = new WeakSet(), xa = function(W, M, X) {
            X[0] = W[0] * M[0] + W[1] * M[1] + W[2] * M[2], X[1] = W[3] * M[0] + W[4] * M[1] + W[5] * M[2], X[2] = W[6] * M[0] + W[7] * M[1] + W[8] * M[2];
          }, D2 = function(W, M, X) {
            X[0] = M[0] * 1 / W[0], X[1] = M[1] * 1 / W[1], X[2] = M[2] * 1 / W[2];
          }, N2 = function(W, M, X) {
            X[0] = M[0] * 0.95047 / W[0], X[1] = M[1] * 1 / W[1], X[2] = M[2] * 1.08883 / W[2];
          }, pl = function(W) {
            return W <= 31308e-7 ? Nt(this, F, ba).call(this, 0, 1, 12.92 * W) : W >= 0.99554525 ? 1 : Nt(this, F, ba).call(this, 0, 1, 1.055 * W ** 0.4166666666666667 - 0.055);
          }, ba = function(W, M, X) {
            return Math.max(W, Math.min(M, X));
          }, ya = function(W) {
            return W < 0 ? -Nt(this, F, ya).call(this, -W) : W > 8 ? ((W + 16) / 116) ** 3 : W * Un(ie, w);
          }, L2 = function(W, M, X) {
            if (W[0] === 0 && W[1] === 0 && W[2] === 0) {
              X[0] = M[0], X[1] = M[1], X[2] = M[2];
              return;
            }
            const U = Nt(this, F, ya).call(this, 0), Q = U, re = Nt(this, F, ya).call(this, W[0]), le = U, ce = Nt(this, F, ya).call(this, W[1]), ee = U, he = Nt(this, F, ya).call(this, W[2]), pe = (1 - Q) / (1 - re), de = 1 - pe, ge = (1 - le) / (1 - ce), me = 1 - ge, xe = (1 - ee) / (1 - he), ye = 1 - xe;
            X[0] = M[0] * pe + de, X[1] = M[1] * ge + me, X[2] = M[2] * xe + ye;
          }, B2 = function(W, M, X) {
            if (W[0] === 1 && W[2] === 1) {
              X[0] = M[0], X[1] = M[1], X[2] = M[2];
              return;
            }
            const U = X;
            Nt(this, F, xa).call(this, Un(ie, B), M, U);
            const Q = Un(ie, k);
            Nt(this, F, D2).call(this, W, U, Q), Nt(this, F, xa).call(this, Un(ie, R), Q, X);
          }, $2 = function(W, M, X) {
            const U = X;
            Nt(this, F, xa).call(this, Un(ie, B), M, U);
            const Q = Un(ie, k);
            Nt(this, F, N2).call(this, W, U, Q), Nt(this, F, xa).call(this, Un(ie, R), Q, X);
          }, Nd = function(W, M, X, U, Q) {
            const re = Nt(this, F, ba).call(this, 0, 1, W[M] * Q), le = Nt(this, F, ba).call(this, 0, 1, W[M + 1] * Q), ce = Nt(this, F, ba).call(this, 0, 1, W[M + 2] * Q), ee = re === 1 ? 1 : re ** this.GR, he = le === 1 ? 1 : le ** this.GG, pe = ce === 1 ? 1 : ce ** this.GB, de = this.MXA * ee + this.MXB * he + this.MXC * pe, ge = this.MYA * ee + this.MYB * he + this.MYC * pe, me = this.MZA * ee + this.MZB * he + this.MZC * pe, xe = Un(ie, z);
            xe[0] = de, xe[1] = ge, xe[2] = me;
            const ye = Un(ie, T);
            Nt(this, F, B2).call(this, this.whitePoint, xe, ye);
            const ve = Un(ie, z);
            Nt(this, F, L2).call(this, this.blackPoint, ye, ve);
            const Ce = Un(ie, T);
            Nt(this, F, $2).call(this, Un(ie, A), ve, Ce);
            const Ie = Un(ie, z);
            Nt(this, F, xa).call(this, Un(ie, _), Ce, Ie), X[U] = Nt(this, F, pl).call(this, Ie[0]) * 255, X[U + 1] = Nt(this, F, pl).call(this, Ie[1]) * 255, X[U + 2] = Nt(this, F, pl).call(this, Ie[2]) * 255;
          }, zn(ie, B, new Float32Array([0.8951, 0.2664, -0.1614, -0.7502, 1.7135, 0.0367, 0.0389, -0.0685, 1.0296])), zn(ie, R, new Float32Array([0.9869929, -0.1470543, 0.1599627, 0.4323053, 0.5183603, 0.0492912, -85287e-7, 0.0400428, 0.9684867])), zn(ie, _, new Float32Array([3.2404542, -1.5371385, -0.4985314, -0.969266, 1.8760108, 0.041556, 0.0556434, -0.2040259, 1.0572252])), zn(ie, A, new Float32Array([1, 1, 1])), zn(ie, k, new Float32Array(3)), zn(ie, z, new Float32Array(3)), zn(ie, T, new Float32Array(3)), zn(ie, w, 0.0011070564598794539);
          let I = ie;
          class O extends m {
            constructor(W, M, X) {
              super("Lab", 3);
              zn(this, oe);
              if (!W)
                throw new s.FormatError("WhitePoint missing - required for color space Lab");
              if ([this.XW, this.YW, this.ZW] = W, [this.amin, this.amax, this.bmin, this.bmax] = X || [-100, 100, -100, 100], [this.XB, this.YB, this.ZB] = M || [0, 0, 0], this.XW < 0 || this.ZW < 0 || this.YW !== 1)
                throw new s.FormatError("Invalid WhitePoint components, no fallback available");
              (this.XB < 0 || this.YB < 0 || this.ZB < 0) && ((0, s.info)("Invalid BlackPoint, falling back to default"), this.XB = this.YB = this.ZB = 0), (this.amin > this.amax || this.bmin > this.bmax) && ((0, s.info)("Invalid Range, falling back to defaults"), this.amin = -100, this.amax = 100, this.bmin = -100, this.bmax = 100);
            }
            getRgbItem(W, M, X, U) {
              Nt(this, oe, Ld).call(this, W, M, !1, X, U);
            }
            getRgbBuffer(W, M, X, U, Q, re, le) {
              const ce = (1 << re) - 1;
              for (let ee = 0; ee < X; ee++)
                Nt(this, oe, Ld).call(this, W, M, ce, U, Q), M += 3, Q += 3 + le;
            }
            getOutputLength(W, M) {
              return W * (3 + M) / 3 | 0;
            }
            isDefaultDecode(W, M) {
              return !0;
            }
            get usesZeroToOneRange() {
              return (0, s.shadow)(this, "usesZeroToOneRange", !1);
            }
          }
          oe = new WeakSet(), gl = function(W) {
            return W >= 0.20689655172413793 ? W ** 3 : 0.12841854934601665 * (W - 0.13793103448275862);
          }, ml = function(W, M, X, U) {
            return X + W * (U - X) / M;
          }, Ld = function(W, M, X, U, Q) {
            let re = W[M], le = W[M + 1], ce = W[M + 2];
            X !== !1 && (re = Nt(this, oe, ml).call(this, re, X, 0, 100), le = Nt(this, oe, ml).call(this, le, X, this.amin, this.amax), ce = Nt(this, oe, ml).call(this, ce, X, this.bmin, this.bmax)), le > this.amax ? le = this.amax : le < this.amin && (le = this.amin), ce > this.bmax ? ce = this.bmax : ce < this.bmin && (ce = this.bmin);
            const ee = (re + 16) / 116, he = ee + le / 500, pe = ee - ce / 200, de = this.XW * Nt(this, oe, gl).call(this, he), ge = this.YW * Nt(this, oe, gl).call(this, ee), me = this.ZW * Nt(this, oe, gl).call(this, pe);
            let xe, ye, ve;
            this.ZW < 1 ? (xe = de * 3.1339 + ge * -1.617 + me * -0.4906, ye = de * -0.9785 + ge * 1.916 + me * 0.0333, ve = de * 0.072 + ge * -0.229 + me * 1.4057) : (xe = de * 3.2406 + ge * -1.5372 + me * -0.4986, ye = de * -0.9689 + ge * 1.8758 + me * 0.0415, ve = de * 0.0557 + ge * -0.204 + me * 1.057), U[Q] = Math.sqrt(xe) * 255, U[Q + 1] = Math.sqrt(ye) * 255, U[Q + 2] = Math.sqrt(ve) * 255;
          };
        },
        /* 13 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.PartialEvaluator = c.EvaluatorPreprocessor = void 0;
          var s = f(2), h = f(14), g = f(4), t = f(34), i = f(37), m = f(41), v = f(50), E = f(51), S = f(42), y = f(57), x = f(16), b = f(59), u = f(8), I = f(5), O = f(60), D = f(12), $ = f(18), K = f(38), H = f(61), B = f(39), R = f(45), _ = f(40), A = f(62), k = f(63), z = f(64), T = f(65);
          const w = Object.freeze({
            maxImageSize: -1,
            disableFontFace: !1,
            ignoreErrors: !1,
            isEvalSupported: !0,
            isOffscreenCanvasSupported: !1,
            canvasMaxAreaInBytes: -1,
            fontExtraProperties: !1,
            useSystemFonts: !0,
            cMapUrl: null,
            standardFontDataUrl: null
          }), F = {
            TILING: 1,
            SHADING: 2
          }, j = 10, P = Promise.resolve();
          function V(Y, ae = !1) {
            if (Array.isArray(Y)) {
              for (const se of Y) {
                const L = V(se, !0);
                if (L)
                  return L;
              }
              return (0, s.warn)(`Unsupported blend mode Array: ${Y}`), "source-over";
            }
            if (!(Y instanceof g.Name))
              return ae ? null : "source-over";
            switch (Y.name) {
              case "Normal":
              case "Compatible":
                return "source-over";
              case "Multiply":
                return "multiply";
              case "Screen":
                return "screen";
              case "Overlay":
                return "overlay";
              case "Darken":
                return "darken";
              case "Lighten":
                return "lighten";
              case "ColorDodge":
                return "color-dodge";
              case "ColorBurn":
                return "color-burn";
              case "HardLight":
                return "hard-light";
              case "SoftLight":
                return "soft-light";
              case "Difference":
                return "difference";
              case "Exclusion":
                return "exclusion";
              case "Hue":
                return "hue";
              case "Saturation":
                return "saturation";
              case "Color":
                return "color";
              case "Luminosity":
                return "luminosity";
            }
            return ae ? null : ((0, s.warn)(`Unsupported blend mode: ${Y.name}`), "source-over");
          }
          function J(Y) {
            var ae;
            Y.fn === s.OPS.paintImageMaskXObject && ((ae = Y.args[0]) == null ? void 0 : ae.count) > 0 && Y.args[0].count++;
          }
          const oe = class oe {
            constructor() {
              this.reset();
            }
            check() {
              return ++this.checked < oe.CHECK_TIME_EVERY ? !1 : (this.checked = 0, this.endTime <= Date.now());
            }
            reset() {
              this.endTime = Date.now() + oe.TIME_SLOT_DURATION_MS, this.checked = 0;
            }
          };
          ni(oe, "TIME_SLOT_DURATION_MS", 20), ni(oe, "CHECK_TIME_EVERY", 100);
          let ne = oe;
          class Z {
            constructor({
              xref: ae,
              handler: se,
              pageIndex: L,
              idFactory: W,
              fontCache: M,
              builtInCMapCache: X,
              standardFontDataCache: U,
              globalImageCache: Q,
              systemFontCache: re,
              options: le = null
            }) {
              this.xref = ae, this.handler = se, this.pageIndex = L, this.idFactory = W, this.fontCache = M, this.builtInCMapCache = X, this.standardFontDataCache = U, this.globalImageCache = Q, this.systemFontCache = re, this.options = le || w, this.parsingType3Font = !1, this._regionalImageCache = new b.RegionalImageCache(), this._fetchBuiltInCMapBound = this.fetchBuiltInCMap.bind(this), A.ImageResizer.setMaxArea(this.options.canvasMaxAreaInBytes);
            }
            get _pdfFunctionFactory() {
              const ae = new y.PDFFunctionFactory({
                xref: this.xref,
                isEvalSupported: this.options.isEvalSupported
              });
              return (0, s.shadow)(this, "_pdfFunctionFactory", ae);
            }
            clone(ae = null) {
              const se = Object.create(this);
              return se.options = Object.assign(/* @__PURE__ */ Object.create(null), this.options, ae), se;
            }
            hasBlendModes(ae, se) {
              if (!(ae instanceof g.Dict) || ae.objId && se.has(ae.objId))
                return !1;
              const L = new g.RefSet(se);
              ae.objId && L.put(ae.objId);
              const W = [ae], M = this.xref;
              for (; W.length; ) {
                const X = W.shift(), U = X.get("ExtGState");
                if (U instanceof g.Dict)
                  for (let re of U.getRawValues()) {
                    if (re instanceof g.Ref) {
                      if (L.has(re))
                        continue;
                      try {
                        re = M.fetch(re);
                      } catch (ce) {
                        L.put(re), (0, s.info)(`hasBlendModes - ignoring ExtGState: "${ce}".`);
                        continue;
                      }
                    }
                    if (!(re instanceof g.Dict))
                      continue;
                    re.objId && L.put(re.objId);
                    const le = re.get("BM");
                    if (le instanceof g.Name) {
                      if (le.name !== "Normal")
                        return !0;
                      continue;
                    }
                    if (le !== void 0 && Array.isArray(le)) {
                      for (const ce of le)
                        if (ce instanceof g.Name && ce.name !== "Normal")
                          return !0;
                    }
                  }
                const Q = X.get("XObject");
                if (Q instanceof g.Dict)
                  for (let re of Q.getRawValues()) {
                    if (re instanceof g.Ref) {
                      if (L.has(re))
                        continue;
                      try {
                        re = M.fetch(re);
                      } catch (ce) {
                        L.put(re), (0, s.info)(`hasBlendModes - ignoring XObject: "${ce}".`);
                        continue;
                      }
                    }
                    if (!(re instanceof I.BaseStream))
                      continue;
                    re.dict.objId && L.put(re.dict.objId);
                    const le = re.dict.get("Resources");
                    le instanceof g.Dict && (le.objId && L.has(le.objId) || (W.push(le), le.objId && L.put(le.objId)));
                  }
              }
              for (const X of L)
                se.put(X);
              return !1;
            }
            async fetchBuiltInCMap(ae) {
              const se = this.builtInCMapCache.get(ae);
              if (se)
                return se;
              let L;
              if (this.options.cMapUrl !== null) {
                const W = `${this.options.cMapUrl}${ae}.bcmap`, M = await fetch(W);
                if (!M.ok)
                  throw new Error(`fetchBuiltInCMap: failed to fetch file "${W}" with "${M.statusText}".`);
                L = {
                  cMapData: new Uint8Array(await M.arrayBuffer()),
                  compressionType: s.CMapCompressionType.BINARY
                };
              } else
                L = await this.handler.sendWithPromise("FetchBuiltInCMap", {
                  name: ae
                });
              return L.compressionType !== s.CMapCompressionType.NONE && this.builtInCMapCache.set(ae, L), L;
            }
            async fetchStandardFontData(ae) {
              const se = this.standardFontDataCache.get(ae);
              if (se)
                return new u.Stream(se);
              if (this.options.useSystemFonts && ae !== "Symbol" && ae !== "ZapfDingbats")
                return null;
              const L = (0, m.getFontNameToFileMap)(), W = L[ae];
              let M;
              if (this.options.standardFontDataUrl !== null) {
                const X = `${this.options.standardFontDataUrl}${W}`, U = await fetch(X);
                U.ok ? M = await U.arrayBuffer() : (0, s.warn)(`fetchStandardFontData: failed to fetch file "${X}" with "${U.statusText}".`);
              } else
                try {
                  M = await this.handler.sendWithPromise("FetchStandardFontData", {
                    filename: W
                  });
                } catch (X) {
                  (0, s.warn)(`fetchStandardFontData: failed to fetch file "${W}" with "${X}".`);
                }
              return M ? (this.standardFontDataCache.set(ae, M), new u.Stream(M)) : null;
            }
            async buildFormXObject(ae, se, L, W, M, X, U) {
              const Q = se.dict, re = Q.getArray("Matrix");
              let le = Q.getArray("BBox");
              le = Array.isArray(le) && le.length === 4 ? s.Util.normalizeRect(le) : null;
              let ce, ee;
              Q.has("OC") && (ce = await this.parseMarkedContentProps(Q.get("OC"), ae)), ce !== void 0 && W.addOp(s.OPS.beginMarkedContentProps, ["OC", ce]);
              const he = Q.get("Group");
              if (he) {
                ee = {
                  matrix: re,
                  bbox: le,
                  smask: L,
                  isolated: !1,
                  knockout: !1
                };
                const de = he.get("S");
                let ge = null;
                if ((0, g.isName)(de, "Transparency") && (ee.isolated = he.get("I") || !1, ee.knockout = he.get("K") || !1, he.has("CS"))) {
                  const me = he.getRaw("CS"), xe = D.ColorSpace.getCached(me, this.xref, U);
                  xe ? ge = xe : ge = await this.parseColorSpace({
                    cs: me,
                    resources: ae,
                    localColorSpaceCache: U
                  });
                }
                L != null && L.backdrop && (ge || (ge = D.ColorSpace.singletons.rgb), L.backdrop = ge.getRgb(L.backdrop, 0)), W.addOp(s.OPS.beginGroup, [ee]);
              }
              const pe = he ? [re, null] : [re, le];
              return W.addOp(s.OPS.paintFormXObjectBegin, pe), this.getOperatorList({
                stream: se,
                task: M,
                resources: Q.get("Resources") || ae,
                operatorList: W,
                initialState: X
              }).then(function() {
                W.addOp(s.OPS.paintFormXObjectEnd, []), he && W.addOp(s.OPS.endGroup, [ee]), ce !== void 0 && W.addOp(s.OPS.endMarkedContent, []);
              });
            }
            _sendImgData(ae, se, L = !1) {
              const W = se ? [se.bitmap || se.data.buffer] : null;
              return this.parsingType3Font || L ? this.handler.send("commonobj", [ae, "Image", se], W) : this.handler.send("obj", [ae, this.pageIndex, "Image", se], W);
            }
            async buildPaintImageXObject({
              resources: ae,
              image: se,
              isInline: L = !1,
              operatorList: W,
              cacheKey: M,
              localImageCache: X,
              localColorSpaceCache: U
            }) {
              const Q = se.dict, re = Q.objId, le = Q.get("W", "Width"), ce = Q.get("H", "Height");
              if (!(le && typeof le == "number") || !(ce && typeof ce == "number")) {
                (0, s.warn)("Image dimensions are missing, or not numbers.");
                return;
              }
              const ee = this.options.maxImageSize;
              if (ee !== -1 && le * ce > ee) {
                const ve = "Image exceeded maximum allowed size and was removed.";
                if (this.options.ignoreErrors) {
                  (0, s.warn)(ve);
                  return;
                }
                throw new Error(ve);
              }
              let he;
              Q.has("OC") && (he = await this.parseMarkedContentProps(Q.get("OC"), ae));
              const pe = Q.get("IM", "ImageMask") || !1;
              let de, ge;
              if (pe) {
                const ve = Q.get("I", "Interpolate"), Ce = le + 7 >> 3, Ie = se.getBytes(Ce * ce), Ae = Q.getArray("D", "Decode");
                if (this.parsingType3Font) {
                  if (de = T.PDFImage.createRawMask({
                    imgArray: Ie,
                    width: le,
                    height: ce,
                    imageIsFromDecodeStream: se instanceof $.DecodeStream,
                    inverseDecode: (Ae == null ? void 0 : Ae[0]) > 0,
                    interpolate: ve
                  }), de.cached = !!M, ge = [de], W.addImageOps(s.OPS.paintImageMaskXObject, ge, he), M) {
                    const De = {
                      fn: s.OPS.paintImageMaskXObject,
                      args: ge,
                      optionalContent: he
                    };
                    X.set(M, re, De), re && this._regionalImageCache.set(null, re, De);
                  }
                  return;
                }
                if (de = await T.PDFImage.createMask({
                  imgArray: Ie,
                  width: le,
                  height: ce,
                  imageIsFromDecodeStream: se instanceof $.DecodeStream,
                  inverseDecode: (Ae == null ? void 0 : Ae[0]) > 0,
                  interpolate: ve,
                  isOffscreenCanvasSupported: this.options.isOffscreenCanvasSupported
                }), de.isSingleOpaquePixel) {
                  if (W.addImageOps(s.OPS.paintSolidColorImageMask, [], he), M) {
                    const De = {
                      fn: s.OPS.paintSolidColorImageMask,
                      args: [],
                      optionalContent: he
                    };
                    X.set(M, re, De), re && this._regionalImageCache.set(null, re, De);
                  }
                  return;
                }
                const Se = `mask_${this.idFactory.createObjId()}`;
                if (W.addDependency(Se), this._sendImgData(Se, de), ge = [{
                  data: Se,
                  width: de.width,
                  height: de.height,
                  interpolate: de.interpolate,
                  count: 1
                }], W.addImageOps(s.OPS.paintImageMaskXObject, ge, he), M) {
                  const De = {
                    fn: s.OPS.paintImageMaskXObject,
                    args: ge,
                    optionalContent: he
                  };
                  X.set(M, re, De), re && this._regionalImageCache.set(null, re, De);
                }
                return;
              }
              if (L && !Q.has("SMask") && !Q.has("Mask") && le + ce < 200) {
                de = await new T.PDFImage({
                  xref: this.xref,
                  res: ae,
                  image: se,
                  isInline: L,
                  pdfFunctionFactory: this._pdfFunctionFactory,
                  localColorSpaceCache: U
                }).createImageData(!0, !1), W.isOffscreenCanvasSupported = this.options.isOffscreenCanvasSupported, W.addImageOps(s.OPS.paintInlineImageXObject, [de], he);
                return;
              }
              let xe = `img_${this.idFactory.createObjId()}`, ye = !1;
              if (this.parsingType3Font ? xe = `${this.idFactory.getDocId()}_type3_${xe}` : re && (ye = this.globalImageCache.shouldCache(re, this.pageIndex), ye && (xe = `${this.idFactory.getDocId()}_${xe}`)), W.addDependency(xe), ge = [xe, le, ce], T.PDFImage.buildImage({
                xref: this.xref,
                res: ae,
                image: se,
                isInline: L,
                pdfFunctionFactory: this._pdfFunctionFactory,
                localColorSpaceCache: U
              }).then(async (ve) => {
                if (de = await ve.createImageData(!1, this.options.isOffscreenCanvasSupported), M && re && ye) {
                  const Ce = de.bitmap ? de.width * de.height * 4 : de.data.length;
                  this.globalImageCache.addByteSize(re, Ce);
                }
                return this._sendImgData(xe, de, ye);
              }).catch((ve) => ((0, s.warn)(`Unable to decode image "${xe}": "${ve}".`), this._sendImgData(xe, null, ye))), W.addImageOps(s.OPS.paintImageXObject, ge, he), M) {
                const ve = {
                  fn: s.OPS.paintImageXObject,
                  args: ge,
                  optionalContent: he
                };
                X.set(M, re, ve), re && (this._regionalImageCache.set(null, re, ve), ye && ((0, s.assert)(!L, "Cannot cache an inline image globally."), this.globalImageCache.setData(re, {
                  objId: xe,
                  fn: s.OPS.paintImageXObject,
                  args: ge,
                  optionalContent: he,
                  byteSize: 0
                })));
              }
            }
            handleSMask(ae, se, L, W, M, X) {
              const U = ae.get("G"), Q = {
                subtype: ae.get("S").name,
                backdrop: ae.get("BC")
              }, re = ae.get("TR");
              if ((0, y.isPDFFunction)(re)) {
                const le = this._pdfFunctionFactory.create(re), ce = new Uint8Array(256), ee = new Float32Array(1);
                for (let he = 0; he < 256; he++)
                  ee[0] = he / 255, le(ee, 0, ee, 0), ce[he] = ee[0] * 255 | 0;
                Q.transferMap = ce;
              }
              return this.buildFormXObject(se, U, Q, L, W, M.state.clone(), X);
            }
            handleTransferFunction(ae) {
              let se;
              if (Array.isArray(ae))
                se = ae;
              else if ((0, y.isPDFFunction)(ae))
                se = [ae];
              else
                return null;
              const L = [];
              let W = 0, M = 0;
              for (const X of se) {
                const U = this.xref.fetchIfRef(X);
                if (W++, (0, g.isName)(U, "Identity")) {
                  L.push(null);
                  continue;
                } else if (!(0, y.isPDFFunction)(U))
                  return null;
                const Q = this._pdfFunctionFactory.create(U), re = new Uint8Array(256), le = new Float32Array(1);
                for (let ce = 0; ce < 256; ce++)
                  le[0] = ce / 255, Q(le, 0, le, 0), re[ce] = le[0] * 255 | 0;
                L.push(re), M++;
              }
              return !(W === 1 || W === 4) || M === 0 ? null : L;
            }
            handleTilingType(ae, se, L, W, M, X, U, Q) {
              const re = new z.OperatorList(), le = g.Dict.merge({
                xref: this.xref,
                dictArray: [M.get("Resources"), L]
              });
              return this.getOperatorList({
                stream: W,
                task: U,
                resources: le,
                operatorList: re
              }).then(function() {
                const ce = re.getIR(), ee = (0, v.getTilingPatternIR)(ce, M, se);
                X.addDependencies(re.dependencies), X.addOp(ae, ee), M.objId && Q.set(null, M.objId, {
                  operatorListIR: ce,
                  dict: M
                });
              }).catch((ce) => {
                if (!(ce instanceof s.AbortException)) {
                  if (this.options.ignoreErrors) {
                    (0, s.warn)(`handleTilingType - ignoring pattern: "${ce}".`);
                    return;
                  }
                  throw ce;
                }
              });
            }
            handleSetFont(ae, se, L, W, M, X, U = null, Q = null) {
              const re = (se == null ? void 0 : se[0]) instanceof g.Name ? se[0].name : null;
              return this.loadFont(re, L, ae, U, Q).then((le) => le.font.isType3Font ? le.loadType3Data(this, ae, M).then(function() {
                return W.addDependencies(le.type3Dependencies), le;
              }).catch((ce) => new te({
                loadedName: "g_font_error",
                font: new t.ErrorFont(`Type3 font load error: ${ce}`),
                dict: le.font,
                evaluatorOptions: this.options
              })) : le).then((le) => (X.font = le.font, le.send(this.handler), le.loadedName));
            }
            handleText(ae, se) {
              const L = se.font, W = L.charsToGlyphs(ae);
              return L.data && (se.textRenderingMode & s.TextRenderingMode.ADD_TO_PATH_FLAG || se.fillColorSpace.name === "Pattern" || L.disableFontFace || this.options.disableFontFace) && Z.buildFontPaths(L, W, this.handler, this.options), W;
            }
            ensureStateFont(ae) {
              if (ae.font)
                return;
              const se = new s.FormatError("Missing setFont (Tf) operator before text rendering operator.");
              if (this.options.ignoreErrors) {
                (0, s.warn)(`ensureStateFont: "${se}".`);
                return;
              }
              throw se;
            }
            async setGState({
              resources: ae,
              gState: se,
              operatorList: L,
              cacheKey: W,
              task: M,
              stateManager: X,
              localGStateCache: U,
              localColorSpaceCache: Q
            }) {
              const re = se.objId;
              let le = !0;
              const ce = [];
              let ee = Promise.resolve();
              for (const he of se.getKeys()) {
                const pe = se.get(he);
                switch (he) {
                  case "Type":
                    break;
                  case "LW":
                  case "LC":
                  case "LJ":
                  case "ML":
                  case "D":
                  case "RI":
                  case "FL":
                  case "CA":
                  case "ca":
                    ce.push([he, pe]);
                    break;
                  case "Font":
                    le = !1, ee = ee.then(() => this.handleSetFont(ae, null, pe[0], L, M, X.state).then(function(ge) {
                      L.addDependency(ge), ce.push([he, [ge, pe[1]]]);
                    }));
                    break;
                  case "BM":
                    ce.push([he, V(pe)]);
                    break;
                  case "SMask":
                    if ((0, g.isName)(pe, "None")) {
                      ce.push([he, !1]);
                      break;
                    }
                    pe instanceof g.Dict ? (le = !1, ee = ee.then(() => this.handleSMask(pe, ae, L, M, X, Q)), ce.push([he, !0])) : (0, s.warn)("Unsupported SMask type");
                    break;
                  case "TR":
                    const de = this.handleTransferFunction(pe);
                    ce.push([he, de]);
                    break;
                  case "OP":
                  case "op":
                  case "OPM":
                  case "BG":
                  case "BG2":
                  case "UCR":
                  case "UCR2":
                  case "TR2":
                  case "HT":
                  case "SM":
                  case "SA":
                  case "AIS":
                  case "TK":
                    (0, s.info)("graphic state operator " + he);
                    break;
                  default:
                    (0, s.info)("Unknown graphic state operator " + he);
                    break;
                }
              }
              return ee.then(function() {
                ce.length > 0 && L.addOp(s.OPS.setGState, [ce]), le && U.set(W, re, ce);
              });
            }
            loadFont(ae, se, L, W = null, M = null) {
              const X = async () => new te({
                loadedName: "g_font_error",
                font: new t.ErrorFont(`Font "${ae}" is not available.`),
                dict: se,
                evaluatorOptions: this.options
              });
              let U;
              if (se)
                se instanceof g.Ref && (U = se);
              else {
                const pe = L.get("Font");
                pe && (U = pe.getRaw(ae));
              }
              if (U) {
                if (this.parsingType3Font && this.type3FontRefs.has(U))
                  return X();
                if (this.fontCache.has(U))
                  return this.fontCache.get(U);
                se = this.xref.fetchIfRef(U);
              }
              if (!(se instanceof g.Dict)) {
                if (!this.options.ignoreErrors && !this.parsingType3Font)
                  return (0, s.warn)(`Font "${ae}" is not available.`), X();
                (0, s.warn)(`Font "${ae}" is not available -- attempting to fallback to a default font.`), se = W || Z.fallbackFontDict;
              }
              if (se.cacheKey && this.fontCache.has(se.cacheKey))
                return this.fontCache.get(se.cacheKey);
              const Q = new s.PromiseCapability();
              let re;
              try {
                re = this.preEvaluateFont(se), re.cssFontInfo = M;
              } catch (pe) {
                return (0, s.warn)(`loadFont - preEvaluateFont failed: "${pe}".`), X();
              }
              const {
                descriptor: le,
                hash: ce
              } = re, ee = U instanceof g.Ref;
              let he;
              if (ce && le instanceof g.Dict) {
                const pe = le.fontAliases || (le.fontAliases = /* @__PURE__ */ Object.create(null));
                if (pe[ce]) {
                  const de = pe[ce].aliasRef;
                  if (ee && de && this.fontCache.has(de))
                    return this.fontCache.putAlias(U, de), this.fontCache.get(U);
                } else
                  pe[ce] = {
                    fontID: this.idFactory.createFontId()
                  };
                ee && (pe[ce].aliasRef = U), he = pe[ce].fontID;
              } else
                he = this.idFactory.createFontId();
              return (0, s.assert)(he == null ? void 0 : he.startsWith("f"), 'The "fontID" must be (correctly) defined.'), ee ? this.fontCache.put(U, Q.promise) : (se.cacheKey = `cacheKey_${he}`, this.fontCache.put(se.cacheKey, Q.promise)), se.loadedName = `${this.idFactory.getDocId()}_${he}`, this.translateFont(re).then((pe) => {
                Q.resolve(new te({
                  loadedName: se.loadedName,
                  font: pe,
                  dict: se,
                  evaluatorOptions: this.options
                }));
              }).catch((pe) => {
                (0, s.warn)(`loadFont - translateFont failed: "${pe}".`), Q.resolve(new te({
                  loadedName: se.loadedName,
                  font: new t.ErrorFont(pe instanceof Error ? pe.message : pe),
                  dict: se,
                  evaluatorOptions: this.options
                }));
              }), Q.promise;
            }
            buildPath(ae, se, L, W = !1) {
              const M = ae.length - 1;
              if (L || (L = []), M < 0 || ae.fnArray[M] !== s.OPS.constructPath) {
                W && ((0, s.warn)(`Encountered path operator "${se}" inside of a text object.`), ae.addOp(s.OPS.save, null));
                let X;
                switch (se) {
                  case s.OPS.rectangle:
                    const U = L[0] + L[2], Q = L[1] + L[3];
                    X = [Math.min(L[0], U), Math.max(L[0], U), Math.min(L[1], Q), Math.max(L[1], Q)];
                    break;
                  case s.OPS.moveTo:
                  case s.OPS.lineTo:
                    X = [L[0], L[0], L[1], L[1]];
                    break;
                  default:
                    X = [1 / 0, -1 / 0, 1 / 0, -1 / 0];
                    break;
                }
                ae.addOp(s.OPS.constructPath, [[se], L, X]), W && ae.addOp(s.OPS.restore, null);
              } else {
                const X = ae.argsArray[M];
                X[0].push(se), X[1].push(...L);
                const U = X[2];
                switch (se) {
                  case s.OPS.rectangle:
                    const Q = L[0] + L[2], re = L[1] + L[3];
                    U[0] = Math.min(U[0], L[0], Q), U[1] = Math.max(U[1], L[0], Q), U[2] = Math.min(U[2], L[1], re), U[3] = Math.max(U[3], L[1], re);
                    break;
                  case s.OPS.moveTo:
                  case s.OPS.lineTo:
                    U[0] = Math.min(U[0], L[0]), U[1] = Math.max(U[1], L[0]), U[2] = Math.min(U[2], L[1]), U[3] = Math.max(U[3], L[1]);
                    break;
                }
              }
            }
            parseColorSpace({
              cs: ae,
              resources: se,
              localColorSpaceCache: L
            }) {
              return D.ColorSpace.parseAsync({
                cs: ae,
                xref: this.xref,
                resources: se,
                pdfFunctionFactory: this._pdfFunctionFactory,
                localColorSpaceCache: L
              }).catch((W) => {
                if (W instanceof s.AbortException)
                  return null;
                if (this.options.ignoreErrors)
                  return (0, s.warn)(`parseColorSpace - ignoring ColorSpace: "${W}".`), null;
                throw W;
              });
            }
            parseShading({
              shading: ae,
              resources: se,
              localColorSpaceCache: L,
              localShadingPatternCache: W
            }) {
              let M = W.get(ae);
              if (!M) {
                var X = v.Pattern.parseShading(ae, this.xref, se, this._pdfFunctionFactory, L);
                const U = X.getIR();
                M = `pattern_${this.idFactory.createObjId()}`, this.parsingType3Font && (M = `${this.idFactory.getDocId()}_type3_${M}`), W.set(ae, M), this.parsingType3Font ? this.handler.send("commonobj", [M, "Pattern", U]) : this.handler.send("obj", [M, this.pageIndex, "Pattern", U]);
              }
              return M;
            }
            handleColorN(ae, se, L, W, M, X, U, Q, re, le) {
              const ce = L.pop();
              if (ce instanceof g.Name) {
                const ee = M.getRaw(ce.name), he = ee instanceof g.Ref && re.getByRef(ee);
                if (he)
                  try {
                    const de = W.base ? W.base.getRgb(L, 0) : null, ge = (0, v.getTilingPatternIR)(he.operatorListIR, he.dict, de);
                    ae.addOp(se, ge);
                    return;
                  } catch {
                  }
                const pe = this.xref.fetchIfRef(ee);
                if (pe) {
                  const de = pe instanceof I.BaseStream ? pe.dict : pe, ge = de.get("PatternType");
                  if (ge === F.TILING) {
                    const me = W.base ? W.base.getRgb(L, 0) : null;
                    return this.handleTilingType(se, me, X, pe, de, ae, U, re);
                  } else if (ge === F.SHADING) {
                    const me = de.get("Shading"), xe = de.getArray("Matrix"), ye = this.parseShading({
                      shading: me,
                      resources: X,
                      localColorSpaceCache: Q,
                      localShadingPatternCache: le
                    });
                    ae.addOp(se, ["Shading", ye, xe]);
                    return;
                  }
                  throw new s.FormatError(`Unknown PatternType: ${ge}`);
                }
              }
              throw new s.FormatError(`Unknown PatternName: ${ce}`);
            }
            _parseVisibilityExpression(ae, se, L) {
              if (++se > 10) {
                (0, s.warn)("Visibility expression is too deeply nested");
                return;
              }
              const M = ae.length, X = this.xref.fetchIfRef(ae[0]);
              if (M < 2 || !(X instanceof g.Name)) {
                (0, s.warn)("Invalid visibility expression");
                return;
              }
              switch (X.name) {
                case "And":
                case "Or":
                case "Not":
                  L.push(X.name);
                  break;
                default:
                  (0, s.warn)(`Invalid operator ${X.name} in visibility expression`);
                  return;
              }
              for (let U = 1; U < M; U++) {
                const Q = ae[U], re = this.xref.fetchIfRef(Q);
                if (Array.isArray(re)) {
                  const le = [];
                  L.push(le), this._parseVisibilityExpression(re, se, le);
                } else Q instanceof g.Ref && L.push(Q.toString());
              }
            }
            async parseMarkedContentProps(ae, se) {
              var M;
              let L;
              if (ae instanceof g.Name)
                L = se.get("Properties").get(ae.name);
              else if (ae instanceof g.Dict)
                L = ae;
              else
                throw new s.FormatError("Optional content properties malformed.");
              const W = (M = L.get("Type")) == null ? void 0 : M.name;
              if (W === "OCG")
                return {
                  type: W,
                  id: L.objId
                };
              if (W === "OCMD") {
                const X = L.get("VE");
                if (Array.isArray(X)) {
                  const Q = [];
                  if (this._parseVisibilityExpression(X, 0, Q), Q.length > 0)
                    return {
                      type: "OCMD",
                      expression: Q
                    };
                }
                const U = L.get("OCGs");
                if (Array.isArray(U) || U instanceof g.Dict) {
                  const Q = [];
                  if (Array.isArray(U))
                    for (const re of U)
                      Q.push(re.toString());
                  else
                    Q.push(U.objId);
                  return {
                    type: W,
                    ids: Q,
                    policy: L.get("P") instanceof g.Name ? L.get("P").name : null,
                    expression: null
                  };
                } else if (U instanceof g.Ref)
                  return {
                    type: W,
                    id: U.toString()
                  };
              }
              return null;
            }
            getOperatorList({
              stream: ae,
              task: se,
              resources: L,
              operatorList: W,
              initialState: M = null,
              fallbackFontDict: X = null
            }) {
              if (L || (L = g.Dict.empty), M || (M = new q()), !W)
                throw new Error('getOperatorList: missing "operatorList" parameter');
              const U = this, Q = this.xref;
              let re = !1;
              const le = new b.LocalImageCache(), ce = new b.LocalColorSpaceCache(), ee = new b.LocalGStateCache(), he = new b.LocalTilingPatternCache(), pe = /* @__PURE__ */ new Map(), de = L.get("XObject") || g.Dict.empty, ge = L.get("Pattern") || g.Dict.empty, me = new G(M), xe = new ie(ae, Q, me), ye = new ne();
              function ve(Ce) {
                for (let Ie = 0, Ae = xe.savedStatesDepth; Ie < Ae; Ie++)
                  W.addOp(s.OPS.restore, []);
              }
              return new Promise(function Ce(Ie, Ae) {
                const Se = function(Ye) {
                  Promise.all([Ye, W.ready]).then(function() {
                    try {
                      Ce(Ie, Ae);
                    } catch (mt) {
                      Ae(mt);
                    }
                  }, Ae);
                };
                se.ensureNotTerminated(), ye.reset();
                const De = {};
                let Be, ke, be, we, Le, Re;
                for (; !(Be = ye.check()) && (De.args = null, !!xe.read(De)); ) {
                  let Ye = De.args, mt = De.fn;
                  switch (mt | 0) {
                    case s.OPS.paintXObject:
                      if (Re = Ye[0] instanceof g.Name, Le = Ye[0].name, Re) {
                        const et = le.getByName(Le);
                        if (et) {
                          W.addImageOps(et.fn, et.args, et.optionalContent), J(et), Ye = null;
                          continue;
                        }
                      }
                      Se(new Promise(function(et, tn) {
                        if (!Re)
                          throw new s.FormatError("XObject must be referred to by name.");
                        let Xt = de.getRaw(Le);
                        if (Xt instanceof g.Ref) {
                          const Qe = le.getByRef(Xt) || U._regionalImageCache.getByRef(Xt);
                          if (Qe) {
                            W.addImageOps(Qe.fn, Qe.args, Qe.optionalContent), J(Qe), et();
                            return;
                          }
                          const qe = U.globalImageCache.getData(Xt, U.pageIndex);
                          if (qe) {
                            W.addDependency(qe.objId), W.addImageOps(qe.fn, qe.args, qe.optionalContent), et();
                            return;
                          }
                          Xt = Q.fetch(Xt);
                        }
                        if (!(Xt instanceof I.BaseStream))
                          throw new s.FormatError("XObject should be a stream");
                        const _e = Xt.dict.get("Subtype");
                        if (!(_e instanceof g.Name))
                          throw new s.FormatError("XObject should have a Name subtype");
                        if (_e.name === "Form") {
                          me.save(), U.buildFormXObject(L, Xt, null, W, se, me.state.clone(), ce).then(function() {
                            me.restore(), et();
                          }, tn);
                          return;
                        } else if (_e.name === "Image") {
                          U.buildPaintImageXObject({
                            resources: L,
                            image: Xt,
                            operatorList: W,
                            cacheKey: Le,
                            localImageCache: le,
                            localColorSpaceCache: ce
                          }).then(et, tn);
                          return;
                        } else if (_e.name === "PS")
                          (0, s.info)("Ignored XObject subtype PS");
                        else
                          throw new s.FormatError(`Unhandled XObject subtype ${_e.name}`);
                        et();
                      }).catch(function(et) {
                        if (!(et instanceof s.AbortException)) {
                          if (U.options.ignoreErrors) {
                            (0, s.warn)(`getOperatorList - ignoring XObject: "${et}".`);
                            return;
                          }
                          throw et;
                        }
                      }));
                      return;
                    case s.OPS.setFont:
                      var ct = Ye[1];
                      Se(U.handleSetFont(L, Ye, null, W, se, me.state, X).then(function(et) {
                        W.addDependency(et), W.addOp(s.OPS.setFont, [et, ct]);
                      }));
                      return;
                    case s.OPS.beginText:
                      re = !0;
                      break;
                    case s.OPS.endText:
                      re = !1;
                      break;
                    case s.OPS.endInlineImage:
                      var ft = Ye[0].cacheKey;
                      if (ft) {
                        const et = le.getByName(ft);
                        if (et) {
                          W.addImageOps(et.fn, et.args, et.optionalContent), J(et), Ye = null;
                          continue;
                        }
                      }
                      Se(U.buildPaintImageXObject({
                        resources: L,
                        image: Ye[0],
                        isInline: !0,
                        operatorList: W,
                        cacheKey: ft,
                        localImageCache: le,
                        localColorSpaceCache: ce
                      }));
                      return;
                    case s.OPS.showText:
                      if (!me.state.font) {
                        U.ensureStateFont(me.state);
                        continue;
                      }
                      Ye[0] = U.handleText(Ye[0], me.state);
                      break;
                    case s.OPS.showSpacedText:
                      if (!me.state.font) {
                        U.ensureStateFont(me.state);
                        continue;
                      }
                      var kt = [], We = me.state;
                      for (const et of Ye[0])
                        typeof et == "string" ? kt.push(...U.handleText(et, We)) : typeof et == "number" && kt.push(et);
                      Ye[0] = kt, mt = s.OPS.showText;
                      break;
                    case s.OPS.nextLineShowText:
                      if (!me.state.font) {
                        U.ensureStateFont(me.state);
                        continue;
                      }
                      W.addOp(s.OPS.nextLine), Ye[0] = U.handleText(Ye[0], me.state), mt = s.OPS.showText;
                      break;
                    case s.OPS.nextLineSetSpacingShowText:
                      if (!me.state.font) {
                        U.ensureStateFont(me.state);
                        continue;
                      }
                      W.addOp(s.OPS.nextLine), W.addOp(s.OPS.setWordSpacing, [Ye.shift()]), W.addOp(s.OPS.setCharSpacing, [Ye.shift()]), Ye[0] = U.handleText(Ye[0], me.state), mt = s.OPS.showText;
                      break;
                    case s.OPS.setTextRenderingMode:
                      me.state.textRenderingMode = Ye[0];
                      break;
                    case s.OPS.setFillColorSpace: {
                      const et = D.ColorSpace.getCached(Ye[0], Q, ce);
                      if (et) {
                        me.state.fillColorSpace = et;
                        continue;
                      }
                      Se(U.parseColorSpace({
                        cs: Ye[0],
                        resources: L,
                        localColorSpaceCache: ce
                      }).then(function(tn) {
                        tn && (me.state.fillColorSpace = tn);
                      }));
                      return;
                    }
                    case s.OPS.setStrokeColorSpace: {
                      const et = D.ColorSpace.getCached(Ye[0], Q, ce);
                      if (et) {
                        me.state.strokeColorSpace = et;
                        continue;
                      }
                      Se(U.parseColorSpace({
                        cs: Ye[0],
                        resources: L,
                        localColorSpaceCache: ce
                      }).then(function(tn) {
                        tn && (me.state.strokeColorSpace = tn);
                      }));
                      return;
                    }
                    case s.OPS.setFillColor:
                      we = me.state.fillColorSpace, Ye = we.getRgb(Ye, 0), mt = s.OPS.setFillRGBColor;
                      break;
                    case s.OPS.setStrokeColor:
                      we = me.state.strokeColorSpace, Ye = we.getRgb(Ye, 0), mt = s.OPS.setStrokeRGBColor;
                      break;
                    case s.OPS.setFillGray:
                      me.state.fillColorSpace = D.ColorSpace.singletons.gray, Ye = D.ColorSpace.singletons.gray.getRgb(Ye, 0), mt = s.OPS.setFillRGBColor;
                      break;
                    case s.OPS.setStrokeGray:
                      me.state.strokeColorSpace = D.ColorSpace.singletons.gray, Ye = D.ColorSpace.singletons.gray.getRgb(Ye, 0), mt = s.OPS.setStrokeRGBColor;
                      break;
                    case s.OPS.setFillCMYKColor:
                      me.state.fillColorSpace = D.ColorSpace.singletons.cmyk, Ye = D.ColorSpace.singletons.cmyk.getRgb(Ye, 0), mt = s.OPS.setFillRGBColor;
                      break;
                    case s.OPS.setStrokeCMYKColor:
                      me.state.strokeColorSpace = D.ColorSpace.singletons.cmyk, Ye = D.ColorSpace.singletons.cmyk.getRgb(Ye, 0), mt = s.OPS.setStrokeRGBColor;
                      break;
                    case s.OPS.setFillRGBColor:
                      me.state.fillColorSpace = D.ColorSpace.singletons.rgb, Ye = D.ColorSpace.singletons.rgb.getRgb(Ye, 0);
                      break;
                    case s.OPS.setStrokeRGBColor:
                      me.state.strokeColorSpace = D.ColorSpace.singletons.rgb, Ye = D.ColorSpace.singletons.rgb.getRgb(Ye, 0);
                      break;
                    case s.OPS.setFillColorN:
                      if (we = me.state.fillColorSpace, we.name === "Pattern") {
                        Se(U.handleColorN(W, s.OPS.setFillColorN, Ye, we, ge, L, se, ce, he, pe));
                        return;
                      }
                      Ye = we.getRgb(Ye, 0), mt = s.OPS.setFillRGBColor;
                      break;
                    case s.OPS.setStrokeColorN:
                      if (we = me.state.strokeColorSpace, we.name === "Pattern") {
                        Se(U.handleColorN(W, s.OPS.setStrokeColorN, Ye, we, ge, L, se, ce, he, pe));
                        return;
                      }
                      Ye = we.getRgb(Ye, 0), mt = s.OPS.setStrokeRGBColor;
                      break;
                    case s.OPS.shadingFill:
                      var jt = L.get("Shading");
                      if (!jt)
                        throw new s.FormatError("No shading resource found");
                      var yt = jt.get(Ye[0].name);
                      if (!yt)
                        throw new s.FormatError("No shading object found");
                      Ye = [U.parseShading({
                        shading: yt,
                        resources: L,
                        localColorSpaceCache: ce,
                        localShadingPatternCache: pe
                      })], mt = s.OPS.shadingFill;
                      break;
                    case s.OPS.setGState:
                      if (Re = Ye[0] instanceof g.Name, Le = Ye[0].name, Re) {
                        const et = ee.getByName(Le);
                        if (et) {
                          et.length > 0 && W.addOp(s.OPS.setGState, [et]), Ye = null;
                          continue;
                        }
                      }
                      Se(new Promise(function(et, tn) {
                        if (!Re)
                          throw new s.FormatError("GState must be referred to by name.");
                        const Xt = L.get("ExtGState");
                        if (!(Xt instanceof g.Dict))
                          throw new s.FormatError("ExtGState should be a dictionary.");
                        const _e = Xt.get(Le);
                        if (!(_e instanceof g.Dict))
                          throw new s.FormatError("GState should be a dictionary.");
                        U.setGState({
                          resources: L,
                          gState: _e,
                          operatorList: W,
                          cacheKey: Le,
                          task: se,
                          stateManager: me,
                          localGStateCache: ee,
                          localColorSpaceCache: ce
                        }).then(et, tn);
                      }).catch(function(et) {
                        if (!(et instanceof s.AbortException)) {
                          if (U.options.ignoreErrors) {
                            (0, s.warn)(`getOperatorList - ignoring ExtGState: "${et}".`);
                            return;
                          }
                          throw et;
                        }
                      }));
                      return;
                    case s.OPS.moveTo:
                    case s.OPS.lineTo:
                    case s.OPS.curveTo:
                    case s.OPS.curveTo2:
                    case s.OPS.curveTo3:
                    case s.OPS.closePath:
                    case s.OPS.rectangle:
                      U.buildPath(W, mt, Ye, re);
                      continue;
                    case s.OPS.markPoint:
                    case s.OPS.markPointProps:
                    case s.OPS.beginCompat:
                    case s.OPS.endCompat:
                      continue;
                    case s.OPS.beginMarkedContentProps:
                      if (!(Ye[0] instanceof g.Name)) {
                        (0, s.warn)(`Expected name for beginMarkedContentProps arg0=${Ye[0]}`);
                        continue;
                      }
                      if (Ye[0].name === "OC") {
                        Se(U.parseMarkedContentProps(Ye[1], L).then((et) => {
                          W.addOp(s.OPS.beginMarkedContentProps, ["OC", et]);
                        }).catch((et) => {
                          if (!(et instanceof s.AbortException)) {
                            if (U.options.ignoreErrors) {
                              (0, s.warn)(`getOperatorList - ignoring beginMarkedContentProps: "${et}".`);
                              return;
                            }
                            throw et;
                          }
                        }));
                        return;
                      }
                      Ye = [Ye[0].name, Ye[1] instanceof g.Dict ? Ye[1].get("MCID") : null];
                      break;
                    case s.OPS.beginMarkedContent:
                    case s.OPS.endMarkedContent:
                    default:
                      if (Ye !== null) {
                        for (ke = 0, be = Ye.length; ke < be && !(Ye[ke] instanceof g.Dict); ke++)
                          ;
                        if (ke < be) {
                          (0, s.warn)("getOperatorList - ignoring operator: " + mt);
                          continue;
                        }
                      }
                  }
                  W.addOp(mt, Ye);
                }
                if (Be) {
                  Se(P);
                  return;
                }
                ve(), Ie();
              }).catch((Ce) => {
                if (!(Ce instanceof s.AbortException)) {
                  if (this.options.ignoreErrors) {
                    (0, s.warn)(`getOperatorList - ignoring errors during "${se.name}" task: "${Ce}".`), ve();
                    return;
                  }
                  throw Ce;
                }
              });
            }
            getTextContent({
              stream: ae,
              task: se,
              resources: L,
              stateManager: W = null,
              includeMarkedContent: M = !1,
              sink: X,
              seenStyles: U = /* @__PURE__ */ new Set(),
              viewBox: Q,
              markedContentData: re = null,
              disableNormalization: le = !1
            }) {
              L || (L = g.Dict.empty), W || (W = new G(new N())), M && (re || (re = {
                level: 0
              }));
              const ce = {
                items: [],
                styles: /* @__PURE__ */ Object.create(null)
              }, ee = {
                initialized: !1,
                str: [],
                totalWidth: 0,
                totalHeight: 0,
                width: 0,
                height: 0,
                vertical: !1,
                prevTransform: null,
                textAdvanceScale: 0,
                spaceInFlowMin: 0,
                spaceInFlowMax: 0,
                trackingSpaceMin: 1 / 0,
                negativeSpaceMax: -1 / 0,
                notASpace: -1 / 0,
                transform: null,
                fontName: null,
                hasEOL: !1
              }, he = [" ", " "];
              let pe = 0;
              function de(qe) {
                const Je = (pe + 1) % 2, nt = he[pe] !== " " && he[Je] === " ";
                return he[pe] = qe, pe = Je, nt;
              }
              function ge() {
                return he[pe] !== " " && he[(pe + 1) % 2] === " ";
              }
              function me() {
                he[0] = he[1] = " ", pe = 0;
              }
              const xe = 0.102, ye = 0.03, ve = -0.2, Ce = 0.102, Ie = 0.6, Ae = 0.25, Se = this, De = this.xref, Be = [];
              let ke = null;
              const be = new b.LocalImageCache(), we = new b.LocalGStateCache(), Le = new ie(ae, De, W);
              let Re;
              function ct({
                width: qe = 0,
                height: Je = 0,
                transform: nt = ee.prevTransform,
                fontName: At = ee.fontName
              }) {
                ce.items.push({
                  str: " ",
                  dir: "ltr",
                  width: qe,
                  height: Je,
                  transform: nt,
                  fontName: At,
                  hasEOL: !1
                });
              }
              function ft() {
                const qe = Re.font, Je = [Re.fontSize * Re.textHScale, 0, 0, Re.fontSize, 0, Re.textRise];
                if (qe.isType3Font && (Re.fontSize <= 1 || qe.isCharBBox) && !(0, s.isArrayEqual)(Re.fontMatrix, s.FONT_IDENTITY_MATRIX)) {
                  const nt = qe.bbox[3] - qe.bbox[1];
                  nt > 0 && (Je[3] *= nt * Re.fontMatrix[3]);
                }
                return s.Util.transform(Re.ctm, s.Util.transform(Re.textMatrix, Je));
              }
              function kt() {
                if (ee.initialized)
                  return ee;
                const {
                  font: qe,
                  loadedName: Je
                } = Re;
                U.has(Je) || (U.add(Je), ce.styles[Je] = {
                  fontFamily: qe.fallbackName,
                  ascent: qe.ascent,
                  descent: qe.descent,
                  vertical: qe.vertical
                }), ee.fontName = Je;
                const nt = ee.transform = ft();
                qe.vertical ? (ee.width = ee.totalWidth = Math.hypot(nt[0], nt[1]), ee.height = ee.totalHeight = 0, ee.vertical = !0) : (ee.width = ee.totalWidth = 0, ee.height = ee.totalHeight = Math.hypot(nt[2], nt[3]), ee.vertical = !1);
                const At = Math.hypot(Re.textLineMatrix[0], Re.textLineMatrix[1]), Rt = Math.hypot(Re.ctm[0], Re.ctm[1]);
                ee.textAdvanceScale = Rt * At;
                const {
                  fontSize: St
                } = Re;
                return ee.trackingSpaceMin = St * xe, ee.notASpace = St * ye, ee.negativeSpaceMax = St * ve, ee.spaceInFlowMin = St * Ce, ee.spaceInFlowMax = St * Ie, ee.hasEOL = !1, ee.initialized = !0, ee;
              }
              function We() {
                if (!ee.initialized)
                  return;
                const qe = Math.hypot(Re.textLineMatrix[0], Re.textLineMatrix[1]), nt = Math.hypot(Re.ctm[0], Re.ctm[1]) * qe;
                nt !== ee.textAdvanceScale && (ee.vertical ? (ee.totalHeight += ee.height * ee.textAdvanceScale, ee.height = 0) : (ee.totalWidth += ee.width * ee.textAdvanceScale, ee.width = 0), ee.textAdvanceScale = nt);
              }
              function jt(qe) {
                let Je = qe.str.join("");
                le || (Je = (0, s.normalizeUnicode)(Je));
                const nt = (0, O.bidi)(Je, -1, qe.vertical);
                return {
                  str: nt.str,
                  dir: nt.dir,
                  width: Math.abs(qe.totalWidth),
                  height: Math.abs(qe.totalHeight),
                  transform: qe.transform,
                  fontName: qe.fontName,
                  hasEOL: qe.hasEOL
                };
              }
              function yt(qe, Je) {
                return Se.loadFont(qe, Je, L).then(function(nt) {
                  return nt.font.isType3Font ? nt.loadType3Data(Se, L, se).catch(function() {
                  }).then(function() {
                    return nt;
                  }) : nt;
                }).then(function(nt) {
                  Re.loadedName = nt.loadedName, Re.font = nt.font, Re.fontMatrix = nt.font.fontMatrix || s.FONT_IDENTITY_MATRIX;
                });
              }
              function Ye(qe, Je, nt) {
                const At = Math.hypot(nt[0], nt[1]);
                return [(nt[0] * qe + nt[1] * Je) / At, (nt[2] * qe + nt[3] * Je) / At];
              }
              function mt(qe) {
                var $e;
                const Je = ft();
                let nt = Je[4], At = Je[5];
                if (($e = Re.font) != null && $e.vertical) {
                  if (nt < Q[0] || nt > Q[2] || At + qe < Q[1] || At > Q[3])
                    return !1;
                } else if (nt + qe < Q[0] || nt > Q[2] || At < Q[1] || At > Q[3])
                  return !1;
                if (!Re.font || !ee.prevTransform)
                  return !0;
                let Rt = ee.prevTransform[4], St = ee.prevTransform[5];
                if (Rt === nt && St === At)
                  return !0;
                let _t = -1;
                switch (Je[0] && Je[1] === 0 && Je[2] === 0 ? _t = Je[0] > 0 ? 0 : 180 : Je[1] && Je[0] === 0 && Je[3] === 0 && (_t = Je[1] > 0 ? 90 : 270), _t) {
                  case 0:
                    break;
                  case 90:
                    [nt, At] = [At, nt], [Rt, St] = [St, Rt];
                    break;
                  case 180:
                    [nt, At, Rt, St] = [-nt, -At, -Rt, -St];
                    break;
                  case 270:
                    [nt, At] = [-At, -nt], [Rt, St] = [-St, -Rt];
                    break;
                  default:
                    [nt, At] = Ye(nt, At, Je), [Rt, St] = Ye(Rt, St, ee.prevTransform);
                }
                if (Re.font.vertical) {
                  const Ve = (St - At) / ee.textAdvanceScale, Ke = nt - Rt, at = Math.sign(ee.height);
                  return Ve < at * ee.negativeSpaceMax ? Math.abs(Ke) > 0.5 * ee.width ? (et(), !0) : (me(), Xt(), !0) : Math.abs(Ke) > ee.width ? (et(), !0) : (Ve <= at * ee.notASpace && me(), Ve <= at * ee.trackingSpaceMin ? ge() ? (me(), Xt(), ct({
                    height: Math.abs(Ve)
                  })) : ee.height += Ve : tn(Ve, ee.prevTransform, at) || (ee.str.length === 0 ? (me(), ct({
                    height: Math.abs(Ve)
                  })) : ee.height += Ve), Math.abs(Ke) > ee.width * Ae && Xt(), !0);
                }
                const Zt = (nt - Rt) / ee.textAdvanceScale, an = At - St, ze = Math.sign(ee.width);
                return Zt < ze * ee.negativeSpaceMax ? Math.abs(an) > 0.5 * ee.height ? (et(), !0) : (me(), Xt(), !0) : Math.abs(an) > ee.height ? (et(), !0) : (Zt <= ze * ee.notASpace && me(), Zt <= ze * ee.trackingSpaceMin ? ge() ? (me(), Xt(), ct({
                  width: Math.abs(Zt)
                })) : ee.width += Zt : tn(Zt, ee.prevTransform, ze) || (ee.str.length === 0 ? (me(), ct({
                  width: Math.abs(Zt)
                })) : ee.width += Zt), Math.abs(an) > ee.height * Ae && Xt(), !0);
              }
              function Pt({
                chars: qe,
                extraSpacing: Je
              }) {
                const nt = Re.font;
                if (!qe) {
                  const St = Re.charSpacing + Je;
                  St && (nt.vertical ? Re.translateTextMatrix(0, -St) : Re.translateTextMatrix(St * Re.textHScale, 0));
                  return;
                }
                const At = nt.charsToGlyphs(qe), Rt = Re.fontMatrix[0] * Re.fontSize;
                for (let St = 0, _t = At.length; St < _t; St++) {
                  const Zt = At[St], {
                    category: an
                  } = Zt;
                  if (an.isInvisibleFormatMark)
                    continue;
                  let ze = Re.charSpacing + (St + 1 === _t ? Je : 0), $e = Zt.width;
                  nt.vertical && ($e = Zt.vmetric ? Zt.vmetric[0] : -$e);
                  let Ve = $e * Rt;
                  if (an.isWhitespace) {
                    nt.vertical ? (ze += -Ve + Re.wordSpacing, Re.translateTextMatrix(0, -ze)) : (ze += Ve + Re.wordSpacing, Re.translateTextMatrix(ze * Re.textHScale, 0)), de(" ");
                    continue;
                  }
                  if (!an.isZeroWidthDiacritic && !mt(Ve)) {
                    nt.vertical ? Re.translateTextMatrix(0, Ve) : Re.translateTextMatrix(Ve * Re.textHScale, 0);
                    continue;
                  }
                  const Ke = kt();
                  an.isZeroWidthDiacritic && (Ve = 0), nt.vertical ? (Re.translateTextMatrix(0, Ve), Ve = Math.abs(Ve), Ke.height += Ve) : (Ve *= Re.textHScale, Re.translateTextMatrix(Ve, 0), Ke.width += Ve), Ve && (Ke.prevTransform = ft());
                  const at = Zt.unicode;
                  de(at) && Ke.str.push(" "), Ke.str.push(at), ze && (nt.vertical ? Re.translateTextMatrix(0, -ze) : Re.translateTextMatrix(ze * Re.textHScale, 0));
                }
              }
              function et() {
                me(), ee.initialized ? (ee.hasEOL = !0, Xt()) : ce.items.push({
                  str: "",
                  dir: "ltr",
                  width: 0,
                  height: 0,
                  transform: ft(),
                  fontName: Re.loadedName,
                  hasEOL: !0
                });
              }
              function tn(qe, Je, nt) {
                if (nt * ee.spaceInFlowMin <= qe && qe <= nt * ee.spaceInFlowMax)
                  return ee.initialized && (me(), ee.str.push(" ")), !1;
                const At = ee.fontName;
                let Rt = 0;
                return ee.vertical && (Rt = qe, qe = 0), Xt(), me(), ct({
                  width: Math.abs(qe),
                  height: Math.abs(Rt),
                  transform: Je || ft(),
                  fontName: At
                }), !0;
              }
              function Xt() {
                !ee.initialized || !ee.str || (ee.vertical ? ee.totalHeight += ee.height * ee.textAdvanceScale : ee.totalWidth += ee.width * ee.textAdvanceScale, ce.items.push(jt(ee)), ee.initialized = !1, ee.str.length = 0);
              }
              function _e(qe = !1) {
                const Je = ce.items.length;
                Je !== 0 && (qe && Je < j || (X.enqueue(ce, Je), ce.items = [], ce.styles = /* @__PURE__ */ Object.create(null)));
              }
              const Qe = new ne();
              return new Promise(function qe(Je, nt) {
                const At = function(Ve) {
                  _e(!0), Promise.all([Ve, X.ready]).then(function() {
                    try {
                      qe(Je, nt);
                    } catch (Ke) {
                      nt(Ke);
                    }
                  }, nt);
                };
                se.ensureNotTerminated(), Qe.reset();
                const Rt = {};
                let St, _t = [];
                for (; !(St = Qe.check()) && (_t.length = 0, Rt.args = _t, !!Le.read(Rt)); ) {
                  const Ve = Re;
                  Re = W.state;
                  const Ke = Rt.fn;
                  switch (_t = Rt.args, Ke | 0) {
                    case s.OPS.setFont:
                      var Zt = _t[0].name, an = _t[1];
                      if (Re.font && Zt === Re.fontName && an === Re.fontSize)
                        break;
                      Xt(), Re.fontName = Zt, Re.fontSize = an, At(yt(Zt, null));
                      return;
                    case s.OPS.setTextRise:
                      Re.textRise = _t[0];
                      break;
                    case s.OPS.setHScale:
                      Re.textHScale = _t[0] / 100;
                      break;
                    case s.OPS.setLeading:
                      Re.leading = _t[0];
                      break;
                    case s.OPS.moveText:
                      Re.translateTextLineMatrix(_t[0], _t[1]), Re.textMatrix = Re.textLineMatrix.slice();
                      break;
                    case s.OPS.setLeadingMoveText:
                      Re.leading = -_t[1], Re.translateTextLineMatrix(_t[0], _t[1]), Re.textMatrix = Re.textLineMatrix.slice();
                      break;
                    case s.OPS.nextLine:
                      Re.carriageReturn();
                      break;
                    case s.OPS.setTextMatrix:
                      Re.setTextMatrix(_t[0], _t[1], _t[2], _t[3], _t[4], _t[5]), Re.setTextLineMatrix(_t[0], _t[1], _t[2], _t[3], _t[4], _t[5]), We();
                      break;
                    case s.OPS.setCharSpacing:
                      Re.charSpacing = _t[0];
                      break;
                    case s.OPS.setWordSpacing:
                      Re.wordSpacing = _t[0];
                      break;
                    case s.OPS.beginText:
                      Re.textMatrix = s.IDENTITY_MATRIX.slice(), Re.textLineMatrix = s.IDENTITY_MATRIX.slice();
                      break;
                    case s.OPS.showSpacedText:
                      if (!W.state.font) {
                        Se.ensureStateFont(W.state);
                        continue;
                      }
                      const at = (Re.font.vertical ? 1 : -1) * Re.fontSize / 1e3, It = _t[0];
                      for (let st = 0, Ze = It.length; st < Ze; st++) {
                        const gt = It[st];
                        if (typeof gt == "string")
                          Be.push(gt);
                        else if (typeof gt == "number" && gt !== 0) {
                          const Lt = Be.join("");
                          Be.length = 0, Pt({
                            chars: Lt,
                            extraSpacing: gt * at
                          });
                        }
                      }
                      if (Be.length > 0) {
                        const st = Be.join("");
                        Be.length = 0, Pt({
                          chars: st,
                          extraSpacing: 0
                        });
                      }
                      break;
                    case s.OPS.showText:
                      if (!W.state.font) {
                        Se.ensureStateFont(W.state);
                        continue;
                      }
                      Pt({
                        chars: _t[0],
                        extraSpacing: 0
                      });
                      break;
                    case s.OPS.nextLineShowText:
                      if (!W.state.font) {
                        Se.ensureStateFont(W.state);
                        continue;
                      }
                      Re.carriageReturn(), Pt({
                        chars: _t[0],
                        extraSpacing: 0
                      });
                      break;
                    case s.OPS.nextLineSetSpacingShowText:
                      if (!W.state.font) {
                        Se.ensureStateFont(W.state);
                        continue;
                      }
                      Re.wordSpacing = _t[0], Re.charSpacing = _t[1], Re.carriageReturn(), Pt({
                        chars: _t[2],
                        extraSpacing: 0
                      });
                      break;
                    case s.OPS.paintXObject:
                      Xt(), ke || (ke = L.get("XObject") || g.Dict.empty);
                      var ze = _t[0] instanceof g.Name, $e = _t[0].name;
                      if (ze && be.getByName($e))
                        break;
                      At(new Promise(function(st, Ze) {
                        if (!ze)
                          throw new s.FormatError("XObject must be referred to by name.");
                        let gt = ke.getRaw($e);
                        if (gt instanceof g.Ref) {
                          if (be.getByRef(gt)) {
                            st();
                            return;
                          }
                          if (Se.globalImageCache.getData(gt, Se.pageIndex)) {
                            st();
                            return;
                          }
                          gt = De.fetch(gt);
                        }
                        if (!(gt instanceof I.BaseStream))
                          throw new s.FormatError("XObject should be a stream");
                        const Lt = gt.dict.get("Subtype");
                        if (!(Lt instanceof g.Name))
                          throw new s.FormatError("XObject should have a Name subtype");
                        if (Lt.name !== "Form") {
                          be.set($e, gt.dict.objId, !0), st();
                          return;
                        }
                        const Yt = W.state.clone(), Ft = new G(Yt), Dt = gt.dict.getArray("Matrix");
                        Array.isArray(Dt) && Dt.length === 6 && Ft.transform(Dt), _e();
                        const Wt = {
                          enqueueInvoked: !1,
                          enqueue(xt, Bt) {
                            this.enqueueInvoked = !0, X.enqueue(xt, Bt);
                          },
                          get desiredSize() {
                            return X.desiredSize;
                          },
                          get ready() {
                            return X.ready;
                          }
                        };
                        Se.getTextContent({
                          stream: gt,
                          task: se,
                          resources: gt.dict.get("Resources") || L,
                          stateManager: Ft,
                          includeMarkedContent: M,
                          sink: Wt,
                          seenStyles: U,
                          viewBox: Q,
                          markedContentData: re,
                          disableNormalization: le
                        }).then(function() {
                          Wt.enqueueInvoked || be.set($e, gt.dict.objId, !0), st();
                        }, Ze);
                      }).catch(function(st) {
                        if (!(st instanceof s.AbortException)) {
                          if (Se.options.ignoreErrors) {
                            (0, s.warn)(`getTextContent - ignoring XObject: "${st}".`);
                            return;
                          }
                          throw st;
                        }
                      }));
                      return;
                    case s.OPS.setGState:
                      if (ze = _t[0] instanceof g.Name, $e = _t[0].name, ze && we.getByName($e))
                        break;
                      At(new Promise(function(st, Ze) {
                        if (!ze)
                          throw new s.FormatError("GState must be referred to by name.");
                        const gt = L.get("ExtGState");
                        if (!(gt instanceof g.Dict))
                          throw new s.FormatError("ExtGState should be a dictionary.");
                        const Lt = gt.get($e);
                        if (!(Lt instanceof g.Dict))
                          throw new s.FormatError("GState should be a dictionary.");
                        const Yt = Lt.get("Font");
                        if (!Yt) {
                          we.set($e, Lt.objId, !0), st();
                          return;
                        }
                        Xt(), Re.fontName = null, Re.fontSize = Yt[1], yt(null, Yt[0]).then(st, Ze);
                      }).catch(function(st) {
                        if (!(st instanceof s.AbortException)) {
                          if (Se.options.ignoreErrors) {
                            (0, s.warn)(`getTextContent - ignoring ExtGState: "${st}".`);
                            return;
                          }
                          throw st;
                        }
                      }));
                      return;
                    case s.OPS.beginMarkedContent:
                      Xt(), M && (re.level++, ce.items.push({
                        type: "beginMarkedContent",
                        tag: _t[0] instanceof g.Name ? _t[0].name : null
                      }));
                      break;
                    case s.OPS.beginMarkedContentProps:
                      if (Xt(), M) {
                        re.level++;
                        let st = null;
                        _t[1] instanceof g.Dict && (st = _t[1].get("MCID")), ce.items.push({
                          type: "beginMarkedContentProps",
                          id: Number.isInteger(st) ? `${Se.idFactory.getPageObjId()}_mc${st}` : null,
                          tag: _t[0] instanceof g.Name ? _t[0].name : null
                        });
                      }
                      break;
                    case s.OPS.endMarkedContent:
                      if (Xt(), M) {
                        if (re.level === 0)
                          break;
                        re.level--, ce.items.push({
                          type: "endMarkedContent"
                        });
                      }
                      break;
                    case s.OPS.restore:
                      Ve && (Ve.font !== Re.font || Ve.fontSize !== Re.fontSize || Ve.fontName !== Re.fontName) && Xt();
                      break;
                  }
                  if (ce.items.length >= X.desiredSize) {
                    St = !0;
                    break;
                  }
                }
                if (St) {
                  At(P);
                  return;
                }
                Xt(), _e(), Je();
              }).catch((qe) => {
                if (!(qe instanceof s.AbortException)) {
                  if (this.options.ignoreErrors) {
                    (0, s.warn)(`getTextContent - ignoring errors during "${se.name}" task: "${qe}".`), Xt(), _e();
                    return;
                  }
                  throw qe;
                }
              });
            }
            extractDataStructures(ae, se, L) {
              const W = this.xref;
              let M;
              const X = this.readToUnicode(L.toUnicode || ae.get("ToUnicode") || se.get("ToUnicode"));
              if (L.composite) {
                const ee = ae.get("CIDSystemInfo");
                ee instanceof g.Dict && (L.cidSystemInfo = {
                  registry: (0, s.stringToPDFString)(ee.get("Registry")),
                  ordering: (0, s.stringToPDFString)(ee.get("Ordering")),
                  supplement: ee.get("Supplement")
                });
                try {
                  const he = ae.get("CIDToGIDMap");
                  he instanceof I.BaseStream && (M = he.getBytes());
                } catch (he) {
                  if (!this.options.ignoreErrors)
                    throw he;
                  (0, s.warn)(`extractDataStructures - ignoring CIDToGIDMap data: "${he}".`);
                }
              }
              const U = [];
              let Q = null, re;
              if (ae.has("Encoding")) {
                if (re = ae.get("Encoding"), re instanceof g.Dict) {
                  if (Q = re.get("BaseEncoding"), Q = Q instanceof g.Name ? Q.name : null, re.has("Differences")) {
                    const ee = re.get("Differences");
                    let he = 0;
                    for (const pe of ee) {
                      const de = W.fetchIfRef(pe);
                      if (typeof de == "number")
                        he = de;
                      else if (de instanceof g.Name)
                        U[he++] = de.name;
                      else
                        throw new s.FormatError(`Invalid entry in 'Differences' array: ${de}`);
                    }
                  }
                } else if (re instanceof g.Name)
                  Q = re.name;
                else {
                  const ee = "Encoding is not a Name nor a Dict";
                  if (!this.options.ignoreErrors)
                    throw new s.FormatError(ee);
                  (0, s.warn)(ee);
                }
                Q !== "MacRomanEncoding" && Q !== "MacExpertEncoding" && Q !== "WinAnsiEncoding" && (Q = null);
              }
              const le = !L.file || L.isInternalFont, ce = (0, m.getSymbolsFonts)()[L.name];
              if (Q && le && ce && (Q = null), Q)
                L.defaultEncoding = (0, i.getEncoding)(Q);
              else {
                const ee = !!(L.flags & K.FontFlags.Symbolic), he = !!(L.flags & K.FontFlags.Nonsymbolic);
                re = i.StandardEncoding, L.type === "TrueType" && !he && (re = i.WinAnsiEncoding), (ee || ce) && (re = i.MacRomanEncoding, le && (/Symbol/i.test(L.name) ? re = i.SymbolSetEncoding : /Dingbats/i.test(L.name) ? re = i.ZapfDingbatsEncoding : /Wingdings/i.test(L.name) && (re = i.WinAnsiEncoding))), L.defaultEncoding = re;
              }
              return L.differences = U, L.baseEncodingName = Q, L.hasEncoding = !!Q || U.length > 0, L.dict = ae, X.then((ee) => (L.toUnicode = ee, this.buildToUnicode(L))).then((ee) => (L.toUnicode = ee, M && (L.cidToGidMap = this.readCidToGidMap(M, ee)), L));
            }
            _simpleFontToUnicode(ae, se = !1) {
              (0, s.assert)(!ae.composite, "Must be a simple font.");
              const L = [], W = ae.defaultEncoding.slice(), M = ae.baseEncodingName, X = ae.differences;
              for (const Q in X) {
                const re = X[Q];
                re !== ".notdef" && (W[Q] = re);
              }
              const U = (0, B.getGlyphsUnicode)();
              for (const Q in W) {
                let re = W[Q];
                if (re === "")
                  continue;
                let le = U[re];
                if (le !== void 0) {
                  L[Q] = String.fromCharCode(le);
                  continue;
                }
                let ce = 0;
                switch (re[0]) {
                  case "G":
                    re.length === 3 && (ce = parseInt(re.substring(1), 16));
                    break;
                  case "g":
                    re.length === 5 && (ce = parseInt(re.substring(1), 16));
                    break;
                  case "C":
                  case "c":
                    if (re.length >= 3 && re.length <= 4) {
                      const ee = re.substring(1);
                      if (se) {
                        ce = parseInt(ee, 16);
                        break;
                      }
                      if (ce = +ee, Number.isNaN(ce) && Number.isInteger(parseInt(ee, 16)))
                        return this._simpleFontToUnicode(ae, !0);
                    }
                    break;
                  case "u":
                    le = (0, _.getUnicodeForGlyph)(re, U), le !== -1 && (ce = le);
                    break;
                  default:
                    switch (re) {
                      case "f_h":
                      case "f_t":
                      case "T_h":
                        L[Q] = re.replaceAll("_", "");
                        continue;
                    }
                    break;
                }
                if (ce > 0 && ce <= 1114111 && Number.isInteger(ce)) {
                  if (M && ce === +Q) {
                    const ee = (0, i.getEncoding)(M);
                    if (ee && (re = ee[Q])) {
                      L[Q] = String.fromCharCode(U[re]);
                      continue;
                    }
                  }
                  L[Q] = String.fromCodePoint(ce);
                }
              }
              return L;
            }
            async buildToUnicode(ae) {
              var se;
              if (ae.hasIncludedToUnicodeMap = ((se = ae.toUnicode) == null ? void 0 : se.length) > 0, ae.hasIncludedToUnicodeMap)
                return !ae.composite && ae.hasEncoding && (ae.fallbackToUnicode = this._simpleFontToUnicode(ae)), ae.toUnicode;
              if (!ae.composite)
                return new S.ToUnicodeMap(this._simpleFontToUnicode(ae));
              if (ae.composite && (ae.cMap.builtInCMap && !(ae.cMap instanceof h.IdentityCMap) || ae.cidSystemInfo.registry === "Adobe" && (ae.cidSystemInfo.ordering === "GB1" || ae.cidSystemInfo.ordering === "CNS1" || ae.cidSystemInfo.ordering === "Japan1" || ae.cidSystemInfo.ordering === "Korea1"))) {
                const {
                  registry: L,
                  ordering: W
                } = ae.cidSystemInfo, M = g.Name.get(`${L}-${W}-UCS2`), X = await h.CMapFactory.create({
                  encoding: M,
                  fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                  useCMap: null
                }), U = [], Q = [];
                return ae.cMap.forEach(function(re, le) {
                  if (le > 65535)
                    throw new s.FormatError("Max size of CID is 65,535");
                  const ce = X.lookup(le);
                  if (ce) {
                    Q.length = 0;
                    for (let ee = 0, he = ce.length; ee < he; ee += 2)
                      Q.push((ce.charCodeAt(ee) << 8) + ce.charCodeAt(ee + 1));
                    U[re] = String.fromCharCode(...Q);
                  }
                }), new S.ToUnicodeMap(U);
              }
              return new S.IdentityToUnicodeMap(ae.firstChar, ae.lastChar);
            }
            readToUnicode(ae) {
              return ae ? ae instanceof g.Name ? h.CMapFactory.create({
                encoding: ae,
                fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                useCMap: null
              }).then(function(se) {
                return se instanceof h.IdentityCMap ? new S.IdentityToUnicodeMap(0, 65535) : new S.ToUnicodeMap(se.getMap());
              }) : ae instanceof I.BaseStream ? h.CMapFactory.create({
                encoding: ae,
                fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                useCMap: null
              }).then(function(se) {
                if (se instanceof h.IdentityCMap)
                  return new S.IdentityToUnicodeMap(0, 65535);
                const L = new Array(se.length);
                return se.forEach(function(W, M) {
                  if (typeof M == "number") {
                    L[W] = String.fromCodePoint(M);
                    return;
                  }
                  const X = [];
                  for (let U = 0; U < M.length; U += 2) {
                    const Q = M.charCodeAt(U) << 8 | M.charCodeAt(U + 1);
                    if ((Q & 63488) !== 55296) {
                      X.push(Q);
                      continue;
                    }
                    U += 2;
                    const re = M.charCodeAt(U) << 8 | M.charCodeAt(U + 1);
                    X.push(((Q & 1023) << 10) + (re & 1023) + 65536);
                  }
                  L[W] = String.fromCodePoint(...X);
                }), new S.ToUnicodeMap(L);
              }, (se) => {
                if (se instanceof s.AbortException)
                  return null;
                if (this.options.ignoreErrors)
                  return (0, s.warn)(`readToUnicode - ignoring ToUnicode data: "${se}".`), null;
                throw se;
              }) : Promise.resolve(null) : Promise.resolve(null);
            }
            readCidToGidMap(ae, se) {
              const L = [];
              for (let W = 0, M = ae.length; W < M; W++) {
                const X = ae[W++] << 8 | ae[W], U = W >> 1;
                X === 0 && !se.has(U) || (L[U] = X);
              }
              return L;
            }
            extractWidths(ae, se, L) {
              const W = this.xref;
              let M = [], X = 0;
              const U = [];
              let Q, re, le, ce, ee, he, pe, de;
              if (L.composite) {
                if (X = ae.has("DW") ? ae.get("DW") : 1e3, de = ae.get("W"), de)
                  for (re = 0, le = de.length; re < le; re++)
                    if (he = W.fetchIfRef(de[re++]), pe = W.fetchIfRef(de[re]), Array.isArray(pe))
                      for (ce = 0, ee = pe.length; ce < ee; ce++)
                        M[he++] = W.fetchIfRef(pe[ce]);
                    else {
                      const xe = W.fetchIfRef(de[++re]);
                      for (ce = he; ce <= pe; ce++)
                        M[ce] = xe;
                    }
                if (L.vertical) {
                  let xe = ae.getArray("DW2") || [880, -1e3];
                  if (Q = [xe[1], X * 0.5, xe[0]], xe = ae.get("W2"), xe)
                    for (re = 0, le = xe.length; re < le; re++)
                      if (he = W.fetchIfRef(xe[re++]), pe = W.fetchIfRef(xe[re]), Array.isArray(pe))
                        for (ce = 0, ee = pe.length; ce < ee; ce++)
                          U[he++] = [W.fetchIfRef(pe[ce++]), W.fetchIfRef(pe[ce++]), W.fetchIfRef(pe[ce])];
                      else {
                        const ye = [W.fetchIfRef(xe[++re]), W.fetchIfRef(xe[++re]), W.fetchIfRef(xe[++re])];
                        for (ce = he; ce <= pe; ce++)
                          U[ce] = ye;
                      }
                }
              } else {
                const xe = L.firstChar;
                if (de = ae.get("Widths"), de) {
                  for (ce = xe, re = 0, le = de.length; re < le; re++)
                    M[ce++] = W.fetchIfRef(de[re]);
                  X = parseFloat(se.get("MissingWidth")) || 0;
                } else {
                  const ye = ae.get("BaseFont");
                  if (ye instanceof g.Name) {
                    const ve = this.getBaseFontMetrics(ye.name);
                    M = this.buildCharCodeToWidth(ve.widths, L), X = ve.defaultWidth;
                  }
                }
              }
              let ge = !0, me = X;
              for (const xe in M) {
                const ye = M[xe];
                if (ye) {
                  if (!me) {
                    me = ye;
                    continue;
                  }
                  if (me !== ye) {
                    ge = !1;
                    break;
                  }
                }
              }
              ge ? L.flags |= K.FontFlags.FixedPitch : L.flags &= ~K.FontFlags.FixedPitch, L.defaultWidth = X, L.widths = M, L.defaultVMetrics = Q, L.vmetrics = U;
            }
            isSerifFont(ae) {
              const se = ae.split("-")[0];
              return se in (0, m.getSerifFonts)() || /serif/gi.test(se);
            }
            getBaseFontMetrics(ae) {
              let se = 0, L = /* @__PURE__ */ Object.create(null), W = !1, X = (0, m.getStdFontMap)()[ae] || ae;
              const U = (0, R.getMetrics)();
              X in U || (X = this.isSerifFont(ae) ? "Times-Roman" : "Helvetica");
              const Q = U[X];
              return typeof Q == "number" ? (se = Q, W = !0) : L = Q(), {
                defaultWidth: se,
                monospace: W,
                widths: L
              };
            }
            buildCharCodeToWidth(ae, se) {
              const L = /* @__PURE__ */ Object.create(null), W = se.differences, M = se.defaultEncoding;
              for (let X = 0; X < 256; X++) {
                if (X in W && ae[W[X]]) {
                  L[X] = ae[W[X]];
                  continue;
                }
                if (X in M && ae[M[X]]) {
                  L[X] = ae[M[X]];
                  continue;
                }
              }
              return L;
            }
            preEvaluateFont(ae) {
              const se = ae;
              let L = ae.get("Subtype");
              if (!(L instanceof g.Name))
                throw new s.FormatError("invalid font Subtype");
              let W = !1, M, X;
              if (L.name === "Type0") {
                const le = ae.get("DescendantFonts");
                if (!le)
                  throw new s.FormatError("Descendant fonts are not specified");
                if (ae = Array.isArray(le) ? this.xref.fetchIfRef(le[0]) : le, !(ae instanceof g.Dict))
                  throw new s.FormatError("Descendant font is not a dictionary.");
                if (L = ae.get("Subtype"), !(L instanceof g.Name))
                  throw new s.FormatError("invalid font Subtype");
                W = !0;
              }
              const U = ae.get("FirstChar") || 0, Q = ae.get("LastChar") || (W ? 65535 : 255), re = ae.get("FontDescriptor");
              if (re) {
                M = new k.MurmurHash3_64();
                const le = se.getRaw("Encoding");
                if (le instanceof g.Name)
                  M.update(le.name);
                else if (le instanceof g.Ref)
                  M.update(le.toString());
                else if (le instanceof g.Dict) {
                  for (const ee of le.getRawValues())
                    if (ee instanceof g.Name)
                      M.update(ee.name);
                    else if (ee instanceof g.Ref)
                      M.update(ee.toString());
                    else if (Array.isArray(ee)) {
                      const he = ee.length, pe = new Array(he);
                      for (let de = 0; de < he; de++) {
                        const ge = ee[de];
                        ge instanceof g.Name ? pe[de] = ge.name : (typeof ge == "number" || ge instanceof g.Ref) && (pe[de] = ge.toString());
                      }
                      M.update(pe.join());
                    }
                }
                if (M.update(`${U}-${Q}`), X = ae.get("ToUnicode") || se.get("ToUnicode"), X instanceof I.BaseStream) {
                  const ee = X.str || X, he = ee.buffer ? new Uint8Array(ee.buffer.buffer, 0, ee.bufferLength) : new Uint8Array(ee.bytes.buffer, ee.start, ee.end - ee.start);
                  M.update(he);
                } else X instanceof g.Name && M.update(X.name);
                const ce = ae.get("Widths") || se.get("Widths");
                if (Array.isArray(ce)) {
                  const ee = [];
                  for (const he of ce)
                    (typeof he == "number" || he instanceof g.Ref) && ee.push(he.toString());
                  M.update(ee.join());
                }
                if (W) {
                  M.update("compositeFont");
                  const ee = ae.get("W") || se.get("W");
                  if (Array.isArray(ee)) {
                    const pe = [];
                    for (const de of ee)
                      if (typeof de == "number" || de instanceof g.Ref)
                        pe.push(de.toString());
                      else if (Array.isArray(de)) {
                        const ge = [];
                        for (const me of de)
                          (typeof me == "number" || me instanceof g.Ref) && ge.push(me.toString());
                        pe.push(`[${ge.join()}]`);
                      }
                    M.update(pe.join());
                  }
                  const he = ae.getRaw("CIDToGIDMap") || se.getRaw("CIDToGIDMap");
                  he instanceof g.Name ? M.update(he.name) : he instanceof g.Ref ? M.update(he.toString()) : he instanceof I.BaseStream && M.update(he.peekBytes());
                }
              }
              return {
                descriptor: re,
                dict: ae,
                baseDict: se,
                composite: W,
                type: L.name,
                firstChar: U,
                lastChar: Q,
                toUnicode: X,
                hash: M ? M.hexdigest() : ""
              };
            }
            async translateFont({
              descriptor: ae,
              dict: se,
              baseDict: L,
              composite: W,
              type: M,
              firstChar: X,
              lastChar: U,
              toUnicode: Q,
              cssFontInfo: re
            }) {
              const le = M === "Type3";
              let ce;
              if (!ae)
                if (le)
                  ae = new g.Dict(null), ae.set("FontName", g.Name.get(M)), ae.set("FontBBox", se.getArray("FontBBox") || [0, 0, 0, 0]);
                else {
                  let Se = se.get("BaseFont");
                  if (!(Se instanceof g.Name))
                    throw new s.FormatError("Base font is not specified");
                  Se = Se.name.replaceAll(/[,_]/g, "-");
                  const De = this.getBaseFontMetrics(Se), Be = Se.split("-")[0], ke = (this.isSerifFont(Be) ? K.FontFlags.Serif : 0) | (De.monospace ? K.FontFlags.FixedPitch : 0) | ((0, m.getSymbolsFonts)()[Be] ? K.FontFlags.Symbolic : K.FontFlags.Nonsymbolic);
                  ce = {
                    type: M,
                    name: Se,
                    loadedName: L.loadedName,
                    systemFontInfo: null,
                    widths: De.widths,
                    defaultWidth: De.defaultWidth,
                    isSimulatedFlags: !0,
                    flags: ke,
                    firstChar: X,
                    lastChar: U,
                    toUnicode: Q,
                    xHeight: 0,
                    capHeight: 0,
                    italicAngle: 0,
                    isType3Font: le
                  };
                  const be = se.get("Widths"), we = (0, m.getStandardFontName)(Se);
                  let Le = null;
                  return we && (Le = await this.fetchStandardFontData(we), ce.isInternalFont = !!Le), !ce.isInternalFont && this.options.useSystemFonts && (ce.systemFontInfo = (0, H.getFontSubstitution)(this.systemFontCache, this.idFactory, this.options.standardFontDataUrl, Se, we)), this.extractDataStructures(se, se, ce).then((Re) => {
                    if (be) {
                      const ct = [];
                      let ft = X;
                      for (const kt of be)
                        ct[ft++] = this.xref.fetchIfRef(kt);
                      Re.widths = ct;
                    } else
                      Re.widths = this.buildCharCodeToWidth(De.widths, Re);
                    return new t.Font(Se, Le, Re);
                  });
                }
              let ee = ae.get("FontName"), he = se.get("BaseFont");
              typeof ee == "string" && (ee = g.Name.get(ee)), typeof he == "string" && (he = g.Name.get(he));
              const pe = ee == null ? void 0 : ee.name, de = he == null ? void 0 : he.name;
              if (!le && pe !== de && ((0, s.info)(`The FontDescriptor's FontName is "${pe}" but should be the same as the Font's BaseFont "${de}".`), pe && de && (de.startsWith(pe) || !(0, m.isKnownFontName)(pe) && (0, m.isKnownFontName)(de)) && (ee = null)), ee || (ee = he), !(ee instanceof g.Name))
                throw new s.FormatError("invalid font name");
              let ge, me, xe, ye, ve;
              try {
                ge = ae.get("FontFile", "FontFile2", "FontFile3");
              } catch (Se) {
                if (!this.options.ignoreErrors)
                  throw Se;
                (0, s.warn)(`translateFont - fetching "${ee.name}" font file: "${Se}".`), ge = new u.NullStream();
              }
              let Ce = !1, Ie = null, Ae = null;
              if (ge) {
                if (ge.dict) {
                  const Se = ge.dict.get("Subtype");
                  Se instanceof g.Name && (me = Se.name), xe = ge.dict.get("Length1"), ye = ge.dict.get("Length2"), ve = ge.dict.get("Length3");
                }
              } else if (re) {
                const Se = (0, E.getXfaFontName)(ee.name);
                Se && (re.fontFamily = `${re.fontFamily}-PdfJS-XFA`, re.metrics = Se.metrics || null, Ie = Se.factors || null, ge = await this.fetchStandardFontData(Se.name), Ce = !!ge, L = se = (0, E.getXfaFontDict)(ee.name), W = !0);
              } else if (!le) {
                const Se = (0, m.getStandardFontName)(ee.name);
                Se && (ge = await this.fetchStandardFontData(Se), Ce = !!ge), !Ce && this.options.useSystemFonts && (Ae = (0, H.getFontSubstitution)(this.systemFontCache, this.idFactory, this.options.standardFontDataUrl, ee.name, Se));
              }
              if (ce = {
                type: M,
                name: ee.name,
                subtype: me,
                file: ge,
                length1: xe,
                length2: ye,
                length3: ve,
                isInternalFont: Ce,
                loadedName: L.loadedName,
                composite: W,
                fixedPitch: !1,
                fontMatrix: se.getArray("FontMatrix") || s.FONT_IDENTITY_MATRIX,
                firstChar: X,
                lastChar: U,
                toUnicode: Q,
                bbox: ae.getArray("FontBBox") || se.getArray("FontBBox"),
                ascent: ae.get("Ascent"),
                descent: ae.get("Descent"),
                xHeight: ae.get("XHeight") || 0,
                capHeight: ae.get("CapHeight") || 0,
                flags: ae.get("Flags"),
                italicAngle: ae.get("ItalicAngle") || 0,
                isType3Font: le,
                cssFontInfo: re,
                scaleFactors: Ie,
                systemFontInfo: Ae
              }, W) {
                const Se = L.get("Encoding");
                Se instanceof g.Name && (ce.cidEncoding = Se.name);
                const De = await h.CMapFactory.create({
                  encoding: Se,
                  fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                  useCMap: null
                });
                ce.cMap = De, ce.vertical = ce.cMap.vertical;
              }
              return this.extractDataStructures(se, L, ce).then((Se) => (this.extractWidths(se, ae, Se), new t.Font(ee.name, ge, Se)));
            }
            static buildFontPaths(ae, se, L, W) {
              function M(X) {
                const U = `${ae.loadedName}_path_${X}`;
                try {
                  if (ae.renderer.hasBuiltPath(X))
                    return;
                  L.send("commonobj", [U, "FontPath", ae.renderer.getPathJs(X)]);
                } catch (Q) {
                  if (W.ignoreErrors) {
                    (0, s.warn)(`buildFontPaths - ignoring ${U} glyph: "${Q}".`);
                    return;
                  }
                  throw Q;
                }
              }
              for (const X of se) {
                M(X.fontChar);
                const U = X.accent;
                U != null && U.fontChar && M(U.fontChar);
              }
            }
            static get fallbackFontDict() {
              const ae = new g.Dict();
              return ae.set("BaseFont", g.Name.get("Helvetica")), ae.set("Type", g.Name.get("FallbackType")), ae.set("Subtype", g.Name.get("FallbackType")), ae.set("Encoding", g.Name.get("WinAnsiEncoding")), (0, s.shadow)(this, "fallbackFontDict", ae);
            }
          }
          c.PartialEvaluator = Z;
          class te {
            constructor({
              loadedName: ae,
              font: se,
              dict: L,
              evaluatorOptions: W
            }) {
              this.loadedName = ae, this.font = se, this.dict = L, this._evaluatorOptions = W || w, this.type3Loaded = null, this.type3Dependencies = se.isType3Font ? /* @__PURE__ */ new Set() : null, this.sent = !1;
            }
            send(ae) {
              this.sent || (this.sent = !0, ae.send("commonobj", [this.loadedName, "Font", this.font.exportData(this._evaluatorOptions.fontExtraProperties)]));
            }
            fallback(ae) {
              this.font.data && (this.font.disableFontFace = !0, Z.buildFontPaths(this.font, this.font.glyphCacheValues, ae, this._evaluatorOptions));
            }
            loadType3Data(ae, se, L) {
              if (this.type3Loaded)
                return this.type3Loaded;
              if (!this.font.isType3Font)
                throw new Error("Must be a Type3 font.");
              const W = ae.clone({
                ignoreErrors: !1
              });
              W.parsingType3Font = !0;
              const M = new g.RefSet(ae.type3FontRefs);
              this.dict.objId && !M.has(this.dict.objId) && M.put(this.dict.objId), W.type3FontRefs = M;
              const X = this.font, U = this.type3Dependencies;
              let Q = Promise.resolve();
              const re = this.dict.get("CharProcs"), le = this.dict.get("Resources") || se, ce = /* @__PURE__ */ Object.create(null), ee = s.Util.normalizeRect(X.bbox || [0, 0, 0, 0]), he = ee[2] - ee[0], pe = ee[3] - ee[1], de = Math.hypot(he, pe);
              for (const ge of re.getKeys())
                Q = Q.then(() => {
                  const me = re.get(ge), xe = new z.OperatorList();
                  return W.getOperatorList({
                    stream: me,
                    task: L,
                    resources: le,
                    operatorList: xe
                  }).then(() => {
                    xe.fnArray[0] === s.OPS.setCharWidthAndBounds && this._removeType3ColorOperators(xe, de), ce[ge] = xe.getIR();
                    for (const ye of xe.dependencies)
                      U.add(ye);
                  }).catch(function(ye) {
                    (0, s.warn)(`Type3 font resource "${ge}" is not available.`);
                    const ve = new z.OperatorList();
                    ce[ge] = ve.getIR();
                  });
                });
              return this.type3Loaded = Q.then(() => {
                X.charProcOperatorList = ce, this._bbox && (X.isCharBBox = !0, X.bbox = this._bbox);
              }), this.type3Loaded;
            }
            _removeType3ColorOperators(ae, se = NaN) {
              const L = s.Util.normalizeRect(ae.argsArray[0].slice(2)), W = L[2] - L[0], M = L[3] - L[1], X = Math.hypot(W, M);
              W === 0 || M === 0 ? (ae.fnArray.splice(0, 1), ae.argsArray.splice(0, 1)) : (se === 0 || Math.round(X / se) >= 10) && (this._bbox || (this._bbox = [1 / 0, 1 / 0, -1 / 0, -1 / 0]), this._bbox[0] = Math.min(this._bbox[0], L[0]), this._bbox[1] = Math.min(this._bbox[1], L[1]), this._bbox[2] = Math.max(this._bbox[2], L[2]), this._bbox[3] = Math.max(this._bbox[3], L[3]));
              let U = 0, Q = ae.length;
              for (; U < Q; ) {
                switch (ae.fnArray[U]) {
                  case s.OPS.setCharWidthAndBounds:
                    break;
                  case s.OPS.setStrokeColorSpace:
                  case s.OPS.setFillColorSpace:
                  case s.OPS.setStrokeColor:
                  case s.OPS.setStrokeColorN:
                  case s.OPS.setFillColor:
                  case s.OPS.setFillColorN:
                  case s.OPS.setStrokeGray:
                  case s.OPS.setFillGray:
                  case s.OPS.setStrokeRGBColor:
                  case s.OPS.setFillRGBColor:
                  case s.OPS.setStrokeCMYKColor:
                  case s.OPS.setFillCMYKColor:
                  case s.OPS.shadingFill:
                  case s.OPS.setRenderingIntent:
                    ae.fnArray.splice(U, 1), ae.argsArray.splice(U, 1), Q--;
                    continue;
                  case s.OPS.setGState:
                    const [re] = ae.argsArray[U];
                    let le = 0, ce = re.length;
                    for (; le < ce; ) {
                      const [ee] = re[le];
                      switch (ee) {
                        case "TR":
                        case "TR2":
                        case "HT":
                        case "BG":
                        case "BG2":
                        case "UCR":
                        case "UCR2":
                          re.splice(le, 1), ce--;
                          continue;
                      }
                      le++;
                    }
                    break;
                }
                U++;
              }
            }
          }
          class G {
            constructor(ae = new q()) {
              this.state = ae, this.stateStack = [];
            }
            save() {
              const ae = this.state;
              this.stateStack.push(this.state), this.state = ae.clone();
            }
            restore() {
              const ae = this.stateStack.pop();
              ae && (this.state = ae);
            }
            transform(ae) {
              this.state.ctm = s.Util.transform(this.state.ctm, ae);
            }
          }
          class N {
            constructor() {
              this.ctm = new Float32Array(s.IDENTITY_MATRIX), this.fontName = null, this.fontSize = 0, this.loadedName = null, this.font = null, this.fontMatrix = s.FONT_IDENTITY_MATRIX, this.textMatrix = s.IDENTITY_MATRIX.slice(), this.textLineMatrix = s.IDENTITY_MATRIX.slice(), this.charSpacing = 0, this.wordSpacing = 0, this.leading = 0, this.textHScale = 1, this.textRise = 0;
            }
            setTextMatrix(ae, se, L, W, M, X) {
              const U = this.textMatrix;
              U[0] = ae, U[1] = se, U[2] = L, U[3] = W, U[4] = M, U[5] = X;
            }
            setTextLineMatrix(ae, se, L, W, M, X) {
              const U = this.textLineMatrix;
              U[0] = ae, U[1] = se, U[2] = L, U[3] = W, U[4] = M, U[5] = X;
            }
            translateTextMatrix(ae, se) {
              const L = this.textMatrix;
              L[4] = L[0] * ae + L[2] * se + L[4], L[5] = L[1] * ae + L[3] * se + L[5];
            }
            translateTextLineMatrix(ae, se) {
              const L = this.textLineMatrix;
              L[4] = L[0] * ae + L[2] * se + L[4], L[5] = L[1] * ae + L[3] * se + L[5];
            }
            carriageReturn() {
              this.translateTextLineMatrix(0, -this.leading), this.textMatrix = this.textLineMatrix.slice();
            }
            clone() {
              const ae = Object.create(this);
              return ae.textMatrix = this.textMatrix.slice(), ae.textLineMatrix = this.textLineMatrix.slice(), ae.fontMatrix = this.fontMatrix.slice(), ae;
            }
          }
          class q {
            constructor() {
              this.ctm = new Float32Array(s.IDENTITY_MATRIX), this.font = null, this.textRenderingMode = s.TextRenderingMode.FILL, this.fillColorSpace = D.ColorSpace.singletons.gray, this.strokeColorSpace = D.ColorSpace.singletons.gray;
            }
            clone() {
              return Object.create(this);
            }
          }
          const fe = class fe {
            static get opMap() {
              return (0, s.shadow)(this, "opMap", {
                w: {
                  id: s.OPS.setLineWidth,
                  numArgs: 1,
                  variableArgs: !1
                },
                J: {
                  id: s.OPS.setLineCap,
                  numArgs: 1,
                  variableArgs: !1
                },
                j: {
                  id: s.OPS.setLineJoin,
                  numArgs: 1,
                  variableArgs: !1
                },
                M: {
                  id: s.OPS.setMiterLimit,
                  numArgs: 1,
                  variableArgs: !1
                },
                d: {
                  id: s.OPS.setDash,
                  numArgs: 2,
                  variableArgs: !1
                },
                ri: {
                  id: s.OPS.setRenderingIntent,
                  numArgs: 1,
                  variableArgs: !1
                },
                i: {
                  id: s.OPS.setFlatness,
                  numArgs: 1,
                  variableArgs: !1
                },
                gs: {
                  id: s.OPS.setGState,
                  numArgs: 1,
                  variableArgs: !1
                },
                q: {
                  id: s.OPS.save,
                  numArgs: 0,
                  variableArgs: !1
                },
                Q: {
                  id: s.OPS.restore,
                  numArgs: 0,
                  variableArgs: !1
                },
                cm: {
                  id: s.OPS.transform,
                  numArgs: 6,
                  variableArgs: !1
                },
                m: {
                  id: s.OPS.moveTo,
                  numArgs: 2,
                  variableArgs: !1
                },
                l: {
                  id: s.OPS.lineTo,
                  numArgs: 2,
                  variableArgs: !1
                },
                c: {
                  id: s.OPS.curveTo,
                  numArgs: 6,
                  variableArgs: !1
                },
                v: {
                  id: s.OPS.curveTo2,
                  numArgs: 4,
                  variableArgs: !1
                },
                y: {
                  id: s.OPS.curveTo3,
                  numArgs: 4,
                  variableArgs: !1
                },
                h: {
                  id: s.OPS.closePath,
                  numArgs: 0,
                  variableArgs: !1
                },
                re: {
                  id: s.OPS.rectangle,
                  numArgs: 4,
                  variableArgs: !1
                },
                S: {
                  id: s.OPS.stroke,
                  numArgs: 0,
                  variableArgs: !1
                },
                s: {
                  id: s.OPS.closeStroke,
                  numArgs: 0,
                  variableArgs: !1
                },
                f: {
                  id: s.OPS.fill,
                  numArgs: 0,
                  variableArgs: !1
                },
                F: {
                  id: s.OPS.fill,
                  numArgs: 0,
                  variableArgs: !1
                },
                "f*": {
                  id: s.OPS.eoFill,
                  numArgs: 0,
                  variableArgs: !1
                },
                B: {
                  id: s.OPS.fillStroke,
                  numArgs: 0,
                  variableArgs: !1
                },
                "B*": {
                  id: s.OPS.eoFillStroke,
                  numArgs: 0,
                  variableArgs: !1
                },
                b: {
                  id: s.OPS.closeFillStroke,
                  numArgs: 0,
                  variableArgs: !1
                },
                "b*": {
                  id: s.OPS.closeEOFillStroke,
                  numArgs: 0,
                  variableArgs: !1
                },
                n: {
                  id: s.OPS.endPath,
                  numArgs: 0,
                  variableArgs: !1
                },
                W: {
                  id: s.OPS.clip,
                  numArgs: 0,
                  variableArgs: !1
                },
                "W*": {
                  id: s.OPS.eoClip,
                  numArgs: 0,
                  variableArgs: !1
                },
                BT: {
                  id: s.OPS.beginText,
                  numArgs: 0,
                  variableArgs: !1
                },
                ET: {
                  id: s.OPS.endText,
                  numArgs: 0,
                  variableArgs: !1
                },
                Tc: {
                  id: s.OPS.setCharSpacing,
                  numArgs: 1,
                  variableArgs: !1
                },
                Tw: {
                  id: s.OPS.setWordSpacing,
                  numArgs: 1,
                  variableArgs: !1
                },
                Tz: {
                  id: s.OPS.setHScale,
                  numArgs: 1,
                  variableArgs: !1
                },
                TL: {
                  id: s.OPS.setLeading,
                  numArgs: 1,
                  variableArgs: !1
                },
                Tf: {
                  id: s.OPS.setFont,
                  numArgs: 2,
                  variableArgs: !1
                },
                Tr: {
                  id: s.OPS.setTextRenderingMode,
                  numArgs: 1,
                  variableArgs: !1
                },
                Ts: {
                  id: s.OPS.setTextRise,
                  numArgs: 1,
                  variableArgs: !1
                },
                Td: {
                  id: s.OPS.moveText,
                  numArgs: 2,
                  variableArgs: !1
                },
                TD: {
                  id: s.OPS.setLeadingMoveText,
                  numArgs: 2,
                  variableArgs: !1
                },
                Tm: {
                  id: s.OPS.setTextMatrix,
                  numArgs: 6,
                  variableArgs: !1
                },
                "T*": {
                  id: s.OPS.nextLine,
                  numArgs: 0,
                  variableArgs: !1
                },
                Tj: {
                  id: s.OPS.showText,
                  numArgs: 1,
                  variableArgs: !1
                },
                TJ: {
                  id: s.OPS.showSpacedText,
                  numArgs: 1,
                  variableArgs: !1
                },
                "'": {
                  id: s.OPS.nextLineShowText,
                  numArgs: 1,
                  variableArgs: !1
                },
                '"': {
                  id: s.OPS.nextLineSetSpacingShowText,
                  numArgs: 3,
                  variableArgs: !1
                },
                d0: {
                  id: s.OPS.setCharWidth,
                  numArgs: 2,
                  variableArgs: !1
                },
                d1: {
                  id: s.OPS.setCharWidthAndBounds,
                  numArgs: 6,
                  variableArgs: !1
                },
                CS: {
                  id: s.OPS.setStrokeColorSpace,
                  numArgs: 1,
                  variableArgs: !1
                },
                cs: {
                  id: s.OPS.setFillColorSpace,
                  numArgs: 1,
                  variableArgs: !1
                },
                SC: {
                  id: s.OPS.setStrokeColor,
                  numArgs: 4,
                  variableArgs: !0
                },
                SCN: {
                  id: s.OPS.setStrokeColorN,
                  numArgs: 33,
                  variableArgs: !0
                },
                sc: {
                  id: s.OPS.setFillColor,
                  numArgs: 4,
                  variableArgs: !0
                },
                scn: {
                  id: s.OPS.setFillColorN,
                  numArgs: 33,
                  variableArgs: !0
                },
                G: {
                  id: s.OPS.setStrokeGray,
                  numArgs: 1,
                  variableArgs: !1
                },
                g: {
                  id: s.OPS.setFillGray,
                  numArgs: 1,
                  variableArgs: !1
                },
                RG: {
                  id: s.OPS.setStrokeRGBColor,
                  numArgs: 3,
                  variableArgs: !1
                },
                rg: {
                  id: s.OPS.setFillRGBColor,
                  numArgs: 3,
                  variableArgs: !1
                },
                K: {
                  id: s.OPS.setStrokeCMYKColor,
                  numArgs: 4,
                  variableArgs: !1
                },
                k: {
                  id: s.OPS.setFillCMYKColor,
                  numArgs: 4,
                  variableArgs: !1
                },
                sh: {
                  id: s.OPS.shadingFill,
                  numArgs: 1,
                  variableArgs: !1
                },
                BI: {
                  id: s.OPS.beginInlineImage,
                  numArgs: 0,
                  variableArgs: !1
                },
                ID: {
                  id: s.OPS.beginImageData,
                  numArgs: 0,
                  variableArgs: !1
                },
                EI: {
                  id: s.OPS.endInlineImage,
                  numArgs: 1,
                  variableArgs: !1
                },
                Do: {
                  id: s.OPS.paintXObject,
                  numArgs: 1,
                  variableArgs: !1
                },
                MP: {
                  id: s.OPS.markPoint,
                  numArgs: 1,
                  variableArgs: !1
                },
                DP: {
                  id: s.OPS.markPointProps,
                  numArgs: 2,
                  variableArgs: !1
                },
                BMC: {
                  id: s.OPS.beginMarkedContent,
                  numArgs: 1,
                  variableArgs: !1
                },
                BDC: {
                  id: s.OPS.beginMarkedContentProps,
                  numArgs: 2,
                  variableArgs: !1
                },
                EMC: {
                  id: s.OPS.endMarkedContent,
                  numArgs: 0,
                  variableArgs: !1
                },
                BX: {
                  id: s.OPS.beginCompat,
                  numArgs: 0,
                  variableArgs: !1
                },
                EX: {
                  id: s.OPS.endCompat,
                  numArgs: 0,
                  variableArgs: !1
                },
                BM: null,
                BD: null,
                true: null,
                fa: null,
                fal: null,
                fals: null,
                false: null,
                nu: null,
                nul: null,
                null: null
              });
            }
            constructor(ae, se, L = new G()) {
              this.parser = new x.Parser({
                lexer: new x.Lexer(ae, fe.opMap),
                xref: se
              }), this.stateManager = L, this.nonProcessedArgs = [], this._isPathOp = !1, this._numInvalidPathOPS = 0;
            }
            get savedStatesDepth() {
              return this.stateManager.stateStack.length;
            }
            read(ae) {
              let se = ae.args;
              for (; ; ) {
                const L = this.parser.getObj();
                if (L instanceof g.Cmd) {
                  const W = L.cmd, M = fe.opMap[W];
                  if (!M) {
                    (0, s.warn)(`Unknown command "${W}".`);
                    continue;
                  }
                  const X = M.id, U = M.numArgs;
                  let Q = se !== null ? se.length : 0;
                  if (this._isPathOp || (this._numInvalidPathOPS = 0), this._isPathOp = X >= s.OPS.moveTo && X <= s.OPS.endPath, M.variableArgs)
                    Q > U && (0, s.info)(`Command ${W}: expected [0, ${U}] args, but received ${Q} args.`);
                  else {
                    if (Q !== U) {
                      const re = this.nonProcessedArgs;
                      for (; Q > U; )
                        re.push(se.shift()), Q--;
                      for (; Q < U && re.length !== 0; )
                        se === null && (se = []), se.unshift(re.pop()), Q++;
                    }
                    if (Q < U) {
                      const re = `command ${W}: expected ${U} args, but received ${Q} args.`;
                      if (this._isPathOp && ++this._numInvalidPathOPS > fe.MAX_INVALID_PATH_OPS)
                        throw new s.FormatError(`Invalid ${re}`);
                      (0, s.warn)(`Skipping ${re}`), se !== null && (se.length = 0);
                      continue;
                    }
                  }
                  return this.preprocessCommand(X, se), ae.fn = X, ae.args = se, !0;
                }
                if (L === g.EOF)
                  return !1;
                if (L !== null && (se === null && (se = []), se.push(L), se.length > 33))
                  throw new s.FormatError("Too many arguments");
              }
            }
            preprocessCommand(ae, se) {
              switch (ae | 0) {
                case s.OPS.save:
                  this.stateManager.save();
                  break;
                case s.OPS.restore:
                  this.stateManager.restore();
                  break;
                case s.OPS.transform:
                  this.stateManager.transform(se);
                  break;
              }
            }
          };
          ni(fe, "MAX_INVALID_PATH_OPS", 10);
          let ie = fe;
          c.EvaluatorPreprocessor = ie;
        },
        /* 14 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.IdentityCMap = c.CMapFactory = c.CMap = void 0;
          var s = f(2), h = f(4), g = f(5), t = f(15), i = f(16), m = f(3), v = f(8);
          const E = ["Adobe-GB1-UCS2", "Adobe-CNS1-UCS2", "Adobe-Japan1-UCS2", "Adobe-Korea1-UCS2", "78-EUC-H", "78-EUC-V", "78-H", "78-RKSJ-H", "78-RKSJ-V", "78-V", "78ms-RKSJ-H", "78ms-RKSJ-V", "83pv-RKSJ-H", "90ms-RKSJ-H", "90ms-RKSJ-V", "90msp-RKSJ-H", "90msp-RKSJ-V", "90pv-RKSJ-H", "90pv-RKSJ-V", "Add-H", "Add-RKSJ-H", "Add-RKSJ-V", "Add-V", "Adobe-CNS1-0", "Adobe-CNS1-1", "Adobe-CNS1-2", "Adobe-CNS1-3", "Adobe-CNS1-4", "Adobe-CNS1-5", "Adobe-CNS1-6", "Adobe-GB1-0", "Adobe-GB1-1", "Adobe-GB1-2", "Adobe-GB1-3", "Adobe-GB1-4", "Adobe-GB1-5", "Adobe-Japan1-0", "Adobe-Japan1-1", "Adobe-Japan1-2", "Adobe-Japan1-3", "Adobe-Japan1-4", "Adobe-Japan1-5", "Adobe-Japan1-6", "Adobe-Korea1-0", "Adobe-Korea1-1", "Adobe-Korea1-2", "B5-H", "B5-V", "B5pc-H", "B5pc-V", "CNS-EUC-H", "CNS-EUC-V", "CNS1-H", "CNS1-V", "CNS2-H", "CNS2-V", "ETHK-B5-H", "ETHK-B5-V", "ETen-B5-H", "ETen-B5-V", "ETenms-B5-H", "ETenms-B5-V", "EUC-H", "EUC-V", "Ext-H", "Ext-RKSJ-H", "Ext-RKSJ-V", "Ext-V", "GB-EUC-H", "GB-EUC-V", "GB-H", "GB-V", "GBK-EUC-H", "GBK-EUC-V", "GBK2K-H", "GBK2K-V", "GBKp-EUC-H", "GBKp-EUC-V", "GBT-EUC-H", "GBT-EUC-V", "GBT-H", "GBT-V", "GBTpc-EUC-H", "GBTpc-EUC-V", "GBpc-EUC-H", "GBpc-EUC-V", "H", "HKdla-B5-H", "HKdla-B5-V", "HKdlb-B5-H", "HKdlb-B5-V", "HKgccs-B5-H", "HKgccs-B5-V", "HKm314-B5-H", "HKm314-B5-V", "HKm471-B5-H", "HKm471-B5-V", "HKscs-B5-H", "HKscs-B5-V", "Hankaku", "Hiragana", "KSC-EUC-H", "KSC-EUC-V", "KSC-H", "KSC-Johab-H", "KSC-Johab-V", "KSC-V", "KSCms-UHC-H", "KSCms-UHC-HW-H", "KSCms-UHC-HW-V", "KSCms-UHC-V", "KSCpc-EUC-H", "KSCpc-EUC-V", "Katakana", "NWP-H", "NWP-V", "RKSJ-H", "RKSJ-V", "Roman", "UniCNS-UCS2-H", "UniCNS-UCS2-V", "UniCNS-UTF16-H", "UniCNS-UTF16-V", "UniCNS-UTF32-H", "UniCNS-UTF32-V", "UniCNS-UTF8-H", "UniCNS-UTF8-V", "UniGB-UCS2-H", "UniGB-UCS2-V", "UniGB-UTF16-H", "UniGB-UTF16-V", "UniGB-UTF32-H", "UniGB-UTF32-V", "UniGB-UTF8-H", "UniGB-UTF8-V", "UniJIS-UCS2-H", "UniJIS-UCS2-HW-H", "UniJIS-UCS2-HW-V", "UniJIS-UCS2-V", "UniJIS-UTF16-H", "UniJIS-UTF16-V", "UniJIS-UTF32-H", "UniJIS-UTF32-V", "UniJIS-UTF8-H", "UniJIS-UTF8-V", "UniJIS2004-UTF16-H", "UniJIS2004-UTF16-V", "UniJIS2004-UTF32-H", "UniJIS2004-UTF32-V", "UniJIS2004-UTF8-H", "UniJIS2004-UTF8-V", "UniJISPro-UCS2-HW-V", "UniJISPro-UCS2-V", "UniJISPro-UTF8-V", "UniJISX0213-UTF32-H", "UniJISX0213-UTF32-V", "UniJISX02132004-UTF32-H", "UniJISX02132004-UTF32-V", "UniKS-UCS2-H", "UniKS-UCS2-V", "UniKS-UTF16-H", "UniKS-UTF16-V", "UniKS-UTF32-H", "UniKS-UTF32-V", "UniKS-UTF8-H", "UniKS-UTF8-V", "V", "WP-Symbol"], S = 2 ** 24 - 1;
          class y {
            constructor(w = !1) {
              this.codespaceRanges = [[], [], [], []], this.numCodespaceRanges = 0, this._map = [], this.name = "", this.vertical = !1, this.useCMap = null, this.builtInCMap = w;
            }
            addCodespaceRange(w, F, j) {
              this.codespaceRanges[w - 1].push(F, j), this.numCodespaceRanges++;
            }
            mapCidRange(w, F, j) {
              if (F - w > S)
                throw new Error("mapCidRange - ignoring data above MAX_MAP_RANGE.");
              for (; w <= F; )
                this._map[w++] = j++;
            }
            mapBfRange(w, F, j) {
              if (F - w > S)
                throw new Error("mapBfRange - ignoring data above MAX_MAP_RANGE.");
              const P = j.length - 1;
              for (; w <= F; ) {
                this._map[w++] = j;
                const V = j.charCodeAt(P) + 1;
                if (V > 255) {
                  j = j.substring(0, P - 1) + String.fromCharCode(j.charCodeAt(P - 1) + 1) + "\0";
                  continue;
                }
                j = j.substring(0, P) + String.fromCharCode(V);
              }
            }
            mapBfRangeToArray(w, F, j) {
              if (F - w > S)
                throw new Error("mapBfRangeToArray - ignoring data above MAX_MAP_RANGE.");
              const P = j.length;
              let V = 0;
              for (; w <= F && V < P; )
                this._map[w] = j[V++], ++w;
            }
            mapOne(w, F) {
              this._map[w] = F;
            }
            lookup(w) {
              return this._map[w];
            }
            contains(w) {
              return this._map[w] !== void 0;
            }
            forEach(w) {
              const F = this._map, j = F.length;
              if (j <= 65536)
                for (let P = 0; P < j; P++)
                  F[P] !== void 0 && w(P, F[P]);
              else
                for (const P in F)
                  w(P, F[P]);
            }
            charCodeOf(w) {
              const F = this._map;
              if (F.length <= 65536)
                return F.indexOf(w);
              for (const j in F)
                if (F[j] === w)
                  return j | 0;
              return -1;
            }
            getMap() {
              return this._map;
            }
            readCharCode(w, F, j) {
              let P = 0;
              const V = this.codespaceRanges;
              for (let J = 0, ne = V.length; J < ne; J++) {
                P = (P << 8 | w.charCodeAt(F + J)) >>> 0;
                const Z = V[J];
                for (let te = 0, G = Z.length; te < G; ) {
                  const N = Z[te++], q = Z[te++];
                  if (P >= N && P <= q) {
                    j.charcode = P, j.length = J + 1;
                    return;
                  }
                }
              }
              j.charcode = 0, j.length = 1;
            }
            getCharCodeLength(w) {
              const F = this.codespaceRanges;
              for (let j = 0, P = F.length; j < P; j++) {
                const V = F[j];
                for (let J = 0, ne = V.length; J < ne; ) {
                  const Z = V[J++], te = V[J++];
                  if (w >= Z && w <= te)
                    return j + 1;
                }
              }
              return 1;
            }
            get length() {
              return this._map.length;
            }
            get isIdentityCMap() {
              if (!(this.name === "Identity-H" || this.name === "Identity-V") || this._map.length !== 65536)
                return !1;
              for (let w = 0; w < 65536; w++)
                if (this._map[w] !== w)
                  return !1;
              return !0;
            }
          }
          c.CMap = y;
          class x extends y {
            constructor(w, F) {
              super(), this.vertical = w, this.addCodespaceRange(F, 0, 65535);
            }
            mapCidRange(w, F, j) {
              (0, s.unreachable)("should not call mapCidRange");
            }
            mapBfRange(w, F, j) {
              (0, s.unreachable)("should not call mapBfRange");
            }
            mapBfRangeToArray(w, F, j) {
              (0, s.unreachable)("should not call mapBfRangeToArray");
            }
            mapOne(w, F) {
              (0, s.unreachable)("should not call mapCidOne");
            }
            lookup(w) {
              return Number.isInteger(w) && w <= 65535 ? w : void 0;
            }
            contains(w) {
              return Number.isInteger(w) && w <= 65535;
            }
            forEach(w) {
              for (let F = 0; F <= 65535; F++)
                w(F, F);
            }
            charCodeOf(w) {
              return Number.isInteger(w) && w <= 65535 ? w : -1;
            }
            getMap() {
              const w = new Array(65536);
              for (let F = 0; F <= 65535; F++)
                w[F] = F;
              return w;
            }
            get length() {
              return 65536;
            }
            get isIdentityCMap() {
              (0, s.unreachable)("should not access .isIdentityCMap");
            }
          }
          c.IdentityCMap = x;
          function b(T) {
            let w = 0;
            for (let F = 0; F < T.length; F++)
              w = w << 8 | T.charCodeAt(F);
            return w >>> 0;
          }
          function u(T) {
            if (typeof T != "string")
              throw new s.FormatError("Malformed CMap: expected string.");
          }
          function I(T) {
            if (!Number.isInteger(T))
              throw new s.FormatError("Malformed CMap: expected int.");
          }
          function O(T, w) {
            for (; ; ) {
              let F = w.getObj();
              if (F === h.EOF)
                break;
              if ((0, h.isCmd)(F, "endbfchar"))
                return;
              u(F);
              const j = b(F);
              F = w.getObj(), u(F);
              const P = F;
              T.mapOne(j, P);
            }
          }
          function D(T, w) {
            for (; ; ) {
              let F = w.getObj();
              if (F === h.EOF)
                break;
              if ((0, h.isCmd)(F, "endbfrange"))
                return;
              u(F);
              const j = b(F);
              F = w.getObj(), u(F);
              const P = b(F);
              if (F = w.getObj(), Number.isInteger(F) || typeof F == "string") {
                const V = Number.isInteger(F) ? String.fromCharCode(F) : F;
                T.mapBfRange(j, P, V);
              } else if ((0, h.isCmd)(F, "[")) {
                F = w.getObj();
                const V = [];
                for (; !(0, h.isCmd)(F, "]") && F !== h.EOF; )
                  V.push(F), F = w.getObj();
                T.mapBfRangeToArray(j, P, V);
              } else
                break;
            }
            throw new s.FormatError("Invalid bf range.");
          }
          function $(T, w) {
            for (; ; ) {
              let F = w.getObj();
              if (F === h.EOF)
                break;
              if ((0, h.isCmd)(F, "endcidchar"))
                return;
              u(F);
              const j = b(F);
              F = w.getObj(), I(F);
              const P = F;
              T.mapOne(j, P);
            }
          }
          function K(T, w) {
            for (; ; ) {
              let F = w.getObj();
              if (F === h.EOF)
                break;
              if ((0, h.isCmd)(F, "endcidrange"))
                return;
              u(F);
              const j = b(F);
              F = w.getObj(), u(F);
              const P = b(F);
              F = w.getObj(), I(F);
              const V = F;
              T.mapCidRange(j, P, V);
            }
          }
          function H(T, w) {
            for (; ; ) {
              let F = w.getObj();
              if (F === h.EOF)
                break;
              if ((0, h.isCmd)(F, "endcodespacerange"))
                return;
              if (typeof F != "string")
                break;
              const j = b(F);
              if (F = w.getObj(), typeof F != "string")
                break;
              const P = b(F);
              T.addCodespaceRange(F.length, j, P);
            }
            throw new s.FormatError("Invalid codespace range.");
          }
          function B(T, w) {
            const F = w.getObj();
            Number.isInteger(F) && (T.vertical = !!F);
          }
          function R(T, w) {
            const F = w.getObj();
            F instanceof h.Name && (T.name = F.name);
          }
          async function _(T, w, F, j) {
            let P, V;
            e: for (; ; )
              try {
                const J = w.getObj();
                if (J === h.EOF)
                  break;
                if (J instanceof h.Name)
                  J.name === "WMode" ? B(T, w) : J.name === "CMapName" && R(T, w), P = J;
                else if (J instanceof h.Cmd)
                  switch (J.cmd) {
                    case "endcmap":
                      break e;
                    case "usecmap":
                      P instanceof h.Name && (V = P.name);
                      break;
                    case "begincodespacerange":
                      H(T, w);
                      break;
                    case "beginbfchar":
                      O(T, w);
                      break;
                    case "begincidchar":
                      $(T, w);
                      break;
                    case "beginbfrange":
                      D(T, w);
                      break;
                    case "begincidrange":
                      K(T, w);
                      break;
                  }
              } catch (J) {
                if (J instanceof m.MissingDataException)
                  throw J;
                (0, s.warn)("Invalid cMap data: " + J);
                continue;
              }
            return !j && V && (j = V), j ? A(T, F, j) : T;
          }
          async function A(T, w, F) {
            if (T.useCMap = await k(F, w), T.numCodespaceRanges === 0) {
              const j = T.useCMap.codespaceRanges;
              for (let P = 0; P < j.length; P++)
                T.codespaceRanges[P] = j[P].slice();
              T.numCodespaceRanges = T.useCMap.numCodespaceRanges;
            }
            return T.useCMap.forEach(function(j, P) {
              T.contains(j) || T.mapOne(j, T.useCMap.lookup(j));
            }), T;
          }
          async function k(T, w) {
            if (T === "Identity-H")
              return new x(!1, 2);
            if (T === "Identity-V")
              return new x(!0, 2);
            if (!E.includes(T))
              throw new Error("Unknown CMap name: " + T);
            if (!w)
              throw new Error("Built-in CMap parameters are not provided.");
            const {
              cMapData: F,
              compressionType: j
            } = await w(T), P = new y(!0);
            if (j === s.CMapCompressionType.BINARY)
              return new t.BinaryCMapReader().process(F, P, (V) => A(P, w, V));
            if (j === s.CMapCompressionType.NONE) {
              const V = new i.Lexer(new v.Stream(F));
              return _(P, V, w, null);
            }
            throw new Error(`Invalid CMap "compressionType" value: ${j}`);
          }
          class z {
            static async create({
              encoding: w,
              fetchBuiltInCMap: F,
              useCMap: j
            }) {
              if (w instanceof h.Name)
                return k(w.name, F);
              if (w instanceof g.BaseStream) {
                const P = await _(new y(), new i.Lexer(w), F, j);
                return P.isIdentityCMap ? k(P.name, F) : P;
              }
              throw new Error("Encoding required.");
            }
          }
          c.CMapFactory = z;
        },
        /* 15 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.BinaryCMapReader = void 0;
          var s = f(2);
          function h(y, x) {
            let b = 0;
            for (let u = 0; u <= x; u++)
              b = b << 8 | y[u];
            return b >>> 0;
          }
          function g(y, x) {
            return x === 1 ? String.fromCharCode(y[0], y[1]) : x === 3 ? String.fromCharCode(y[0], y[1], y[2], y[3]) : String.fromCharCode(...y.subarray(0, x + 1));
          }
          function t(y, x, b) {
            let u = 0;
            for (let I = b; I >= 0; I--)
              u += y[I] + x[I], y[I] = u & 255, u >>= 8;
          }
          function i(y, x) {
            let b = 1;
            for (let u = x; u >= 0 && b > 0; u--)
              b += y[u], y[u] = b & 255, b >>= 8;
          }
          const m = 16, v = 19;
          class E {
            constructor(x) {
              this.buffer = x, this.pos = 0, this.end = x.length, this.tmpBuf = new Uint8Array(v);
            }
            readByte() {
              return this.pos >= this.end ? -1 : this.buffer[this.pos++];
            }
            readNumber() {
              let x = 0, b;
              do {
                const u = this.readByte();
                if (u < 0)
                  throw new s.FormatError("unexpected EOF in bcmap");
                b = !(u & 128), x = x << 7 | u & 127;
              } while (!b);
              return x;
            }
            readSigned() {
              const x = this.readNumber();
              return x & 1 ? ~(x >>> 1) : x >>> 1;
            }
            readHex(x, b) {
              x.set(this.buffer.subarray(this.pos, this.pos + b + 1)), this.pos += b + 1;
            }
            readHexNumber(x, b) {
              let u;
              const I = this.tmpBuf;
              let O = 0;
              do {
                const H = this.readByte();
                if (H < 0)
                  throw new s.FormatError("unexpected EOF in bcmap");
                u = !(H & 128), I[O++] = H & 127;
              } while (!u);
              let D = b, $ = 0, K = 0;
              for (; D >= 0; ) {
                for (; K < 8 && I.length > 0; )
                  $ |= I[--O] << K, K += 7;
                x[D] = $ & 255, D--, $ >>= 8, K -= 8;
              }
            }
            readHexSigned(x, b) {
              this.readHexNumber(x, b);
              const u = x[b] & 1 ? 255 : 0;
              let I = 0;
              for (let O = 0; O <= b; O++)
                I = (I & 1) << 8 | x[O], x[O] = I >> 1 ^ u;
            }
            readString() {
              const x = this.readNumber(), b = new Array(x);
              for (let u = 0; u < x; u++)
                b[u] = this.readNumber();
              return String.fromCharCode(...b);
            }
          }
          class S {
            async process(x, b, u) {
              const I = new E(x), O = I.readByte();
              b.vertical = !!(O & 1);
              let D = null;
              const $ = new Uint8Array(m), K = new Uint8Array(m), H = new Uint8Array(m), B = new Uint8Array(m), R = new Uint8Array(m);
              let _, A;
              for (; (A = I.readByte()) >= 0; ) {
                const k = A >> 5;
                if (k === 7) {
                  switch (A & 31) {
                    case 0:
                      I.readString();
                      break;
                    case 1:
                      D = I.readString();
                      break;
                  }
                  continue;
                }
                const z = !!(A & 16), T = A & 15;
                if (T + 1 > m)
                  throw new Error("BinaryCMapReader.process: Invalid dataSize.");
                const w = 1, F = I.readNumber();
                switch (k) {
                  case 0:
                    I.readHex($, T), I.readHexNumber(K, T), t(K, $, T), b.addCodespaceRange(T + 1, h($, T), h(K, T));
                    for (let j = 1; j < F; j++)
                      i(K, T), I.readHexNumber($, T), t($, K, T), I.readHexNumber(K, T), t(K, $, T), b.addCodespaceRange(T + 1, h($, T), h(K, T));
                    break;
                  case 1:
                    I.readHex($, T), I.readHexNumber(K, T), t(K, $, T), I.readNumber();
                    for (let j = 1; j < F; j++)
                      i(K, T), I.readHexNumber($, T), t($, K, T), I.readHexNumber(K, T), t(K, $, T), I.readNumber();
                    break;
                  case 2:
                    I.readHex(H, T), _ = I.readNumber(), b.mapOne(h(H, T), _);
                    for (let j = 1; j < F; j++)
                      i(H, T), z || (I.readHexNumber(R, T), t(H, R, T)), _ = I.readSigned() + (_ + 1), b.mapOne(h(H, T), _);
                    break;
                  case 3:
                    I.readHex($, T), I.readHexNumber(K, T), t(K, $, T), _ = I.readNumber(), b.mapCidRange(h($, T), h(K, T), _);
                    for (let j = 1; j < F; j++)
                      i(K, T), z ? $.set(K) : (I.readHexNumber($, T), t($, K, T)), I.readHexNumber(K, T), t(K, $, T), _ = I.readNumber(), b.mapCidRange(h($, T), h(K, T), _);
                    break;
                  case 4:
                    I.readHex(H, w), I.readHex(B, T), b.mapOne(h(H, w), g(B, T));
                    for (let j = 1; j < F; j++)
                      i(H, w), z || (I.readHexNumber(R, w), t(H, R, w)), i(B, T), I.readHexSigned(R, T), t(B, R, T), b.mapOne(h(H, w), g(B, T));
                    break;
                  case 5:
                    I.readHex($, w), I.readHexNumber(K, w), t(K, $, w), I.readHex(B, T), b.mapBfRange(h($, w), h(K, w), g(B, T));
                    for (let j = 1; j < F; j++)
                      i(K, w), z ? $.set(K) : (I.readHexNumber($, w), t($, K, w)), I.readHexNumber(K, w), t(K, $, w), I.readHex(B, T), b.mapBfRange(h($, w), h(K, w), g(B, T));
                    break;
                  default:
                    throw new Error(`BinaryCMapReader.process - unknown type: ${k}`);
                }
              }
              return D ? u(D) : b;
            }
          }
          c.BinaryCMapReader = S;
        },
        /* 16 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.Parser = c.Linearization = c.Lexer = void 0;
          var s = f(2), h = f(4), g = f(3), t = f(8), i = f(17), m = f(19), v = f(20), E = f(22), S = f(23), y = f(26), x = f(29), b = f(31), u = f(32), I = f(33);
          const O = 1e3;
          function D(_) {
            const A = [], k = _.length;
            let z = 0;
            for (; z < k - 1; )
              A.push(_[z++] << 8 | _[z++]);
            return z < k && A.push(_[z]), k + "_" + String.fromCharCode.apply(null, A);
          }
          class $ {
            constructor({
              lexer: A,
              xref: k,
              allowStreams: z = !1,
              recoveryMode: T = !1
            }) {
              this.lexer = A, this.xref = k, this.allowStreams = z, this.recoveryMode = T, this.imageCache = /* @__PURE__ */ Object.create(null), this._imageId = 0, this.refill();
            }
            refill() {
              this.buf1 = this.lexer.getObj(), this.buf2 = this.lexer.getObj();
            }
            shift() {
              this.buf2 instanceof h.Cmd && this.buf2.cmd === "ID" ? (this.buf1 = this.buf2, this.buf2 = null) : (this.buf1 = this.buf2, this.buf2 = this.lexer.getObj());
            }
            tryShift() {
              try {
                return this.shift(), !0;
              } catch (A) {
                if (A instanceof g.MissingDataException)
                  throw A;
                return !1;
              }
            }
            getObj(A = null) {
              const k = this.buf1;
              if (this.shift(), k instanceof h.Cmd)
                switch (k.cmd) {
                  case "BI":
                    return this.makeInlineImage(A);
                  case "[":
                    const z = [];
                    for (; !(0, h.isCmd)(this.buf1, "]") && this.buf1 !== h.EOF; )
                      z.push(this.getObj(A));
                    if (this.buf1 === h.EOF) {
                      if (this.recoveryMode)
                        return z;
                      throw new g.ParserEOFException("End of file inside array.");
                    }
                    return this.shift(), z;
                  case "<<":
                    const T = new h.Dict(this.xref);
                    for (; !(0, h.isCmd)(this.buf1, ">>") && this.buf1 !== h.EOF; ) {
                      if (!(this.buf1 instanceof h.Name)) {
                        (0, s.info)("Malformed dictionary: key must be a name object"), this.shift();
                        continue;
                      }
                      const w = this.buf1.name;
                      if (this.shift(), this.buf1 === h.EOF)
                        break;
                      T.set(w, this.getObj(A));
                    }
                    if (this.buf1 === h.EOF) {
                      if (this.recoveryMode)
                        return T;
                      throw new g.ParserEOFException("End of file inside dictionary.");
                    }
                    return (0, h.isCmd)(this.buf2, "stream") ? this.allowStreams ? this.makeStream(T, A) : T : (this.shift(), T);
                  default:
                    return k;
                }
              if (Number.isInteger(k)) {
                if (Number.isInteger(this.buf1) && (0, h.isCmd)(this.buf2, "R")) {
                  const z = h.Ref.get(k, this.buf1);
                  return this.shift(), this.shift(), z;
                }
                return k;
              }
              return typeof k == "string" && A ? A.decryptString(k) : k;
            }
            findDefaultInlineStreamEnd(A) {
              const {
                knownCommands: P
              } = this.lexer, V = A.pos, J = 15;
              let ne = 0, Z, te;
              for (; (Z = A.getByte()) !== -1; )
                if (ne === 0)
                  ne = Z === 69 ? 1 : 0;
                else if (ne === 1)
                  ne = Z === 73 ? 2 : 0;
                else if (Z === 32 || Z === 10 || Z === 13) {
                  te = A.pos;
                  const N = A.peekBytes(J), q = N.length;
                  if (q === 0)
                    break;
                  for (let fe = 0; fe < q; fe++)
                    if (Z = N[fe], !(Z === 0 && N[fe + 1] !== 0) && Z !== 10 && Z !== 13 && (Z < 32 || Z > 127)) {
                      ne = 0;
                      break;
                    }
                  if (ne !== 2)
                    continue;
                  if (!P) {
                    (0, s.warn)("findDefaultInlineStreamEnd - `lexer.knownCommands` is undefined.");
                    continue;
                  }
                  const ie = new B(new t.Stream(N.slice()), P);
                  ie._hexStringWarn = () => {
                  };
                  let oe = 0;
                  for (; ; ) {
                    const fe = ie.getObj();
                    if (fe === h.EOF) {
                      ne = 0;
                      break;
                    }
                    if (fe instanceof h.Cmd) {
                      const Y = P[fe.cmd];
                      if (Y) {
                        if (Y.variableArgs ? oe <= Y.numArgs : oe === Y.numArgs)
                          break;
                      } else {
                        ne = 0;
                        break;
                      }
                      oe = 0;
                      continue;
                    }
                    oe++;
                  }
                  if (ne === 2)
                    break;
                } else
                  ne = 0;
              Z === -1 && ((0, s.warn)("findDefaultInlineStreamEnd: Reached the end of the stream without finding a valid EI marker"), te && ((0, s.warn)('... trying to recover by using the last "EI" occurrence.'), A.skip(-(A.pos - te))));
              let G = 4;
              return A.skip(-G), Z = A.peekByte(), A.skip(G), (0, g.isWhiteSpace)(Z) || G--, A.pos - G - V;
            }
            findDCTDecodeInlineStreamEnd(A) {
              const k = A.pos;
              let z = !1, T, w;
              for (; (T = A.getByte()) !== -1; )
                if (T === 255) {
                  switch (A.getByte()) {
                    case 0:
                      break;
                    case 255:
                      A.skip(-1);
                      break;
                    case 217:
                      z = !0;
                      break;
                    case 192:
                    case 193:
                    case 194:
                    case 195:
                    case 197:
                    case 198:
                    case 199:
                    case 201:
                    case 202:
                    case 203:
                    case 205:
                    case 206:
                    case 207:
                    case 196:
                    case 204:
                    case 218:
                    case 219:
                    case 220:
                    case 221:
                    case 222:
                    case 223:
                    case 224:
                    case 225:
                    case 226:
                    case 227:
                    case 228:
                    case 229:
                    case 230:
                    case 231:
                    case 232:
                    case 233:
                    case 234:
                    case 235:
                    case 236:
                    case 237:
                    case 238:
                    case 239:
                    case 254:
                      w = A.getUint16(), w > 2 ? A.skip(w - 2) : A.skip(-2);
                      break;
                  }
                  if (z)
                    break;
                }
              const F = A.pos - k;
              return T === -1 ? ((0, s.warn)("Inline DCTDecode image stream: EOI marker not found, searching for /EI/ instead."), A.skip(-F), this.findDefaultInlineStreamEnd(A)) : (this.inlineStreamSkipEI(A), F);
            }
            findASCII85DecodeInlineStreamEnd(A) {
              const T = A.pos;
              let w;
              for (; (w = A.getByte()) !== -1; )
                if (w === 126) {
                  const j = A.pos;
                  for (w = A.peekByte(); (0, g.isWhiteSpace)(w); )
                    A.skip(), w = A.peekByte();
                  if (w === 62) {
                    A.skip();
                    break;
                  }
                  if (A.pos > j) {
                    const P = A.peekBytes(2);
                    if (P[0] === 69 && P[1] === 73)
                      break;
                  }
                }
              const F = A.pos - T;
              return w === -1 ? ((0, s.warn)("Inline ASCII85Decode image stream: EOD marker not found, searching for /EI/ instead."), A.skip(-F), this.findDefaultInlineStreamEnd(A)) : (this.inlineStreamSkipEI(A), F);
            }
            findASCIIHexDecodeInlineStreamEnd(A) {
              const z = A.pos;
              let T;
              for (; (T = A.getByte()) !== -1 && T !== 62; )
                ;
              const w = A.pos - z;
              return T === -1 ? ((0, s.warn)("Inline ASCIIHexDecode image stream: EOD marker not found, searching for /EI/ instead."), A.skip(-w), this.findDefaultInlineStreamEnd(A)) : (this.inlineStreamSkipEI(A), w);
            }
            inlineStreamSkipEI(A) {
              let T = 0, w;
              for (; (w = A.getByte()) !== -1; )
                if (T === 0)
                  T = w === 69 ? 1 : 0;
                else if (T === 1)
                  T = w === 73 ? 2 : 0;
                else if (T === 2)
                  break;
            }
            makeInlineImage(A) {
              const k = this.lexer, z = k.stream, T = /* @__PURE__ */ Object.create(null);
              let w;
              for (; !(0, h.isCmd)(this.buf1, "ID") && this.buf1 !== h.EOF; ) {
                if (!(this.buf1 instanceof h.Name))
                  throw new s.FormatError("Dictionary key must be a name object");
                const te = this.buf1.name;
                if (this.shift(), this.buf1 === h.EOF)
                  break;
                T[te] = this.getObj(A);
              }
              k.beginInlineImagePos !== -1 && (w = z.pos - k.beginInlineImagePos);
              const F = this.xref.fetchIfRef(T.F || T.Filter);
              let j;
              if (F instanceof h.Name)
                j = F.name;
              else if (Array.isArray(F)) {
                const te = this.xref.fetchIfRef(F[0]);
                te instanceof h.Name && (j = te.name);
              }
              const P = z.pos;
              let V;
              switch (j) {
                case "DCT":
                case "DCTDecode":
                  V = this.findDCTDecodeInlineStreamEnd(z);
                  break;
                case "A85":
                case "ASCII85Decode":
                  V = this.findASCII85DecodeInlineStreamEnd(z);
                  break;
                case "AHx":
                case "ASCIIHexDecode":
                  V = this.findASCIIHexDecodeInlineStreamEnd(z);
                  break;
                default:
                  V = this.findDefaultInlineStreamEnd(z);
              }
              let J;
              if (V < O && w > 0) {
                const te = z.pos;
                z.pos = k.beginInlineImagePos, J = D(z.getBytes(w + V)), z.pos = te;
                const G = this.imageCache[J];
                if (G !== void 0)
                  return this.buf2 = h.Cmd.get("EI"), this.shift(), G.reset(), G;
              }
              const ne = new h.Dict(this.xref);
              for (const te in T)
                ne.set(te, T[te]);
              let Z = z.makeSubStream(P, V, ne);
              return A && (Z = A.createStream(Z, V)), Z = this.filter(Z, ne, V), Z.dict = ne, J !== void 0 && (Z.cacheKey = `inline_img_${++this._imageId}`, this.imageCache[J] = Z), this.buf2 = h.Cmd.get("EI"), this.shift(), Z;
            }
            _findStreamLength(A, k) {
              const {
                stream: z
              } = this.lexer;
              z.pos = A;
              const T = 2048, w = k.length;
              for (; z.pos < z.end; ) {
                const F = z.peekBytes(T), j = F.length - w;
                if (j <= 0)
                  break;
                let P = 0;
                for (; P < j; ) {
                  let V = 0;
                  for (; V < w && F[P + V] === k[V]; )
                    V++;
                  if (V >= w)
                    return z.pos += P, z.pos - A;
                  P++;
                }
                z.pos += j;
              }
              return -1;
            }
            makeStream(A, k) {
              const z = this.lexer;
              let T = z.stream;
              z.skipToNextLine();
              const w = T.pos - 1;
              let F = A.get("Length");
              if (Number.isInteger(F) || ((0, s.info)(`Bad length "${F && F.toString()}" in stream.`), F = 0), T.pos = w + F, z.nextChar(), this.tryShift() && (0, h.isCmd)(this.buf2, "endstream"))
                this.shift();
              else {
                const j = new Uint8Array([101, 110, 100, 115, 116, 114, 101, 97, 109]);
                let P = this._findStreamLength(w, j);
                if (P < 0) {
                  for (let J = 1; J <= 1; J++) {
                    const ne = j.length - J, Z = j.slice(0, ne), te = this._findStreamLength(w, Z);
                    if (te >= 0) {
                      const G = T.peekBytes(ne + 1)[ne];
                      if (!(0, g.isWhiteSpace)(G))
                        break;
                      (0, s.info)(`Found "${(0, s.bytesToString)(Z)}" when searching for endstream command.`), P = te;
                      break;
                    }
                  }
                  if (P < 0)
                    throw new s.FormatError("Missing endstream command.");
                }
                F = P, z.nextChar(), this.shift(), this.shift();
              }
              return this.shift(), T = T.makeSubStream(w, F, A), k && (T = k.createStream(T, F)), T = this.filter(T, A, F), T.dict = A, T;
            }
            filter(A, k, z) {
              let T = k.get("F", "Filter"), w = k.get("DP", "DecodeParms");
              if (T instanceof h.Name)
                return Array.isArray(w) && (0, s.warn)("/DecodeParms should not be an Array, when /Filter is a Name."), this.makeFilter(A, T.name, z, w);
              let F = z;
              if (Array.isArray(T)) {
                const j = T, P = w;
                for (let V = 0, J = j.length; V < J; ++V) {
                  if (T = this.xref.fetchIfRef(j[V]), !(T instanceof h.Name))
                    throw new s.FormatError(`Bad filter name "${T}"`);
                  w = null, Array.isArray(P) && V in P && (w = this.xref.fetchIfRef(P[V])), A = this.makeFilter(A, T.name, F, w), F = null;
                }
              }
              return A;
            }
            makeFilter(A, k, z, T) {
              if (z === 0)
                return (0, s.warn)(`Empty "${k}" stream.`), new t.NullStream();
              try {
                switch (k) {
                  case "Fl":
                  case "FlateDecode":
                    return T ? new u.PredictorStream(new E.FlateStream(A, z), z, T) : new E.FlateStream(A, z);
                  case "LZW":
                  case "LZWDecode":
                    let w = 1;
                    return T ? (T.has("EarlyChange") && (w = T.get("EarlyChange")), new u.PredictorStream(new b.LZWStream(A, z, w), z, T)) : new b.LZWStream(A, z, w);
                  case "DCT":
                  case "DCTDecode":
                    return new y.JpegStream(A, z, T);
                  case "JPX":
                  case "JPXDecode":
                    return new x.JpxStream(A, z, T);
                  case "A85":
                  case "ASCII85Decode":
                    return new i.Ascii85Stream(A, z);
                  case "AHx":
                  case "ASCIIHexDecode":
                    return new m.AsciiHexStream(A, z);
                  case "CCF":
                  case "CCITTFaxDecode":
                    return new v.CCITTFaxStream(A, z, T);
                  case "RL":
                  case "RunLengthDecode":
                    return new I.RunLengthStream(A, z);
                  case "JBIG2Decode":
                    return new S.Jbig2Stream(A, z, T);
                }
                return (0, s.warn)(`Filter "${k}" is not supported.`), A;
              } catch (w) {
                if (w instanceof g.MissingDataException)
                  throw w;
                return (0, s.warn)(`Invalid stream: "${w}"`), new t.NullStream();
              }
            }
          }
          c.Parser = $;
          const K = [1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 2, 0, 0, 2, 2, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
          function H(_) {
            return _ >= 48 && _ <= 57 ? _ & 15 : _ >= 65 && _ <= 70 || _ >= 97 && _ <= 102 ? (_ & 15) + 9 : -1;
          }
          class B {
            constructor(A, k = null) {
              this.stream = A, this.nextChar(), this.strBuf = [], this.knownCommands = k, this._hexStringNumWarn = 0, this.beginInlineImagePos = -1;
            }
            nextChar() {
              return this.currentChar = this.stream.getByte();
            }
            peekChar() {
              return this.stream.peekByte();
            }
            getNumber() {
              let A = this.currentChar, k = !1, z = 0, T = 1;
              if (A === 45 ? (T = -1, A = this.nextChar(), A === 45 && (A = this.nextChar())) : A === 43 && (A = this.nextChar()), A === 10 || A === 13)
                do
                  A = this.nextChar();
                while (A === 10 || A === 13);
              if (A === 46 && (z = 10, A = this.nextChar()), A < 48 || A > 57) {
                const P = `Invalid number: ${String.fromCharCode(A)} (charCode ${A})`;
                if ((0, g.isWhiteSpace)(A) || A === -1)
                  return (0, s.info)(`Lexer.getNumber - "${P}".`), 0;
                throw new s.FormatError(P);
              }
              let w = A - 48, F = 0, j = 1;
              for (; (A = this.nextChar()) >= 0; )
                if (A >= 48 && A <= 57) {
                  const P = A - 48;
                  k ? F = F * 10 + P : (z !== 0 && (z *= 10), w = w * 10 + P);
                } else if (A === 46)
                  if (z === 0)
                    z = 1;
                  else
                    break;
                else if (A === 45)
                  (0, s.warn)("Badly formatted number: minus sign in the middle");
                else if (A === 69 || A === 101) {
                  if (A = this.peekChar(), A === 43 || A === 45)
                    j = A === 45 ? -1 : 1, this.nextChar();
                  else if (A < 48 || A > 57)
                    break;
                  k = !0;
                } else
                  break;
              return z !== 0 && (w /= z), k && (w *= 10 ** (j * F)), T * w;
            }
            getString() {
              let A = 1, k = !1;
              const z = this.strBuf;
              z.length = 0;
              let T = this.nextChar();
              for (; ; ) {
                let w = !1;
                switch (T | 0) {
                  case -1:
                    (0, s.warn)("Unterminated string"), k = !0;
                    break;
                  case 40:
                    ++A, z.push("(");
                    break;
                  case 41:
                    --A === 0 ? (this.nextChar(), k = !0) : z.push(")");
                    break;
                  case 92:
                    switch (T = this.nextChar(), T) {
                      case -1:
                        (0, s.warn)("Unterminated string"), k = !0;
                        break;
                      case 110:
                        z.push(`
`);
                        break;
                      case 114:
                        z.push("\r");
                        break;
                      case 116:
                        z.push("	");
                        break;
                      case 98:
                        z.push("\b");
                        break;
                      case 102:
                        z.push("\f");
                        break;
                      case 92:
                      case 40:
                      case 41:
                        z.push(String.fromCharCode(T));
                        break;
                      case 48:
                      case 49:
                      case 50:
                      case 51:
                      case 52:
                      case 53:
                      case 54:
                      case 55:
                        let F = T & 15;
                        T = this.nextChar(), w = !0, T >= 48 && T <= 55 && (F = (F << 3) + (T & 15), T = this.nextChar(), T >= 48 && T <= 55 && (w = !1, F = (F << 3) + (T & 15))), z.push(String.fromCharCode(F));
                        break;
                      case 13:
                        this.peekChar() === 10 && this.nextChar();
                        break;
                      case 10:
                        break;
                      default:
                        z.push(String.fromCharCode(T));
                        break;
                    }
                    break;
                  default:
                    z.push(String.fromCharCode(T));
                    break;
                }
                if (k)
                  break;
                w || (T = this.nextChar());
              }
              return z.join("");
            }
            getName() {
              let A, k;
              const z = this.strBuf;
              for (z.length = 0; (A = this.nextChar()) >= 0 && !K[A]; )
                if (A === 35) {
                  if (A = this.nextChar(), K[A]) {
                    (0, s.warn)("Lexer_getName: NUMBER SIGN (#) should be followed by a hexadecimal number."), z.push("#");
                    break;
                  }
                  const T = H(A);
                  if (T !== -1) {
                    k = A, A = this.nextChar();
                    const w = H(A);
                    if (w === -1) {
                      if ((0, s.warn)(`Lexer_getName: Illegal digit (${String.fromCharCode(A)}) in hexadecimal number.`), z.push("#", String.fromCharCode(k)), K[A])
                        break;
                      z.push(String.fromCharCode(A));
                      continue;
                    }
                    z.push(String.fromCharCode(T << 4 | w));
                  } else
                    z.push("#", String.fromCharCode(A));
                } else
                  z.push(String.fromCharCode(A));
              return z.length > 127 && (0, s.warn)(`Name token is longer than allowed by the spec: ${z.length}`), h.Name.get(z.join(""));
            }
            _hexStringWarn(A) {
              if (this._hexStringNumWarn++ === 5) {
                (0, s.warn)("getHexString - ignoring additional invalid characters.");
                return;
              }
              this._hexStringNumWarn > 5 || (0, s.warn)(`getHexString - ignoring invalid character: ${A}`);
            }
            getHexString() {
              const A = this.strBuf;
              A.length = 0;
              let k = this.currentChar, z = !0, T, w;
              for (this._hexStringNumWarn = 0; ; )
                if (k < 0) {
                  (0, s.warn)("Unterminated hex string");
                  break;
                } else if (k === 62) {
                  this.nextChar();
                  break;
                } else if (K[k] === 1) {
                  k = this.nextChar();
                  continue;
                } else {
                  if (z) {
                    if (T = H(k), T === -1) {
                      this._hexStringWarn(k), k = this.nextChar();
                      continue;
                    }
                  } else {
                    if (w = H(k), w === -1) {
                      this._hexStringWarn(k), k = this.nextChar();
                      continue;
                    }
                    A.push(String.fromCharCode(T << 4 | w));
                  }
                  z = !z, k = this.nextChar();
                }
              return A.join("");
            }
            getObj() {
              let A = !1, k = this.currentChar;
              for (; ; ) {
                if (k < 0)
                  return h.EOF;
                if (A)
                  (k === 10 || k === 13) && (A = !1);
                else if (k === 37)
                  A = !0;
                else if (K[k] !== 1)
                  break;
                k = this.nextChar();
              }
              switch (k | 0) {
                case 48:
                case 49:
                case 50:
                case 51:
                case 52:
                case 53:
                case 54:
                case 55:
                case 56:
                case 57:
                case 43:
                case 45:
                case 46:
                  return this.getNumber();
                case 40:
                  return this.getString();
                case 47:
                  return this.getName();
                case 91:
                  return this.nextChar(), h.Cmd.get("[");
                case 93:
                  return this.nextChar(), h.Cmd.get("]");
                case 60:
                  return k = this.nextChar(), k === 60 ? (this.nextChar(), h.Cmd.get("<<")) : this.getHexString();
                case 62:
                  return k = this.nextChar(), k === 62 ? (this.nextChar(), h.Cmd.get(">>")) : h.Cmd.get(">");
                case 123:
                  return this.nextChar(), h.Cmd.get("{");
                case 125:
                  return this.nextChar(), h.Cmd.get("}");
                case 41:
                  throw this.nextChar(), new s.FormatError(`Illegal character: ${k}`);
              }
              let z = String.fromCharCode(k);
              if (k < 32 || k > 127) {
                const F = this.peekChar();
                if (F >= 32 && F <= 127)
                  return this.nextChar(), h.Cmd.get(z);
              }
              const T = this.knownCommands;
              let w = (T == null ? void 0 : T[z]) !== void 0;
              for (; (k = this.nextChar()) >= 0 && !K[k]; ) {
                const F = z + String.fromCharCode(k);
                if (w && T[F] === void 0)
                  break;
                if (z.length === 128)
                  throw new s.FormatError(`Command token too long: ${z.length}`);
                z = F, w = (T == null ? void 0 : T[z]) !== void 0;
              }
              return z === "true" ? !0 : z === "false" ? !1 : z === "null" ? null : (z === "BI" && (this.beginInlineImagePos = this.stream.pos), h.Cmd.get(z));
            }
            skipToNextLine() {
              let A = this.currentChar;
              for (; A >= 0; ) {
                if (A === 13) {
                  A = this.nextChar(), A === 10 && this.nextChar();
                  break;
                } else if (A === 10) {
                  this.nextChar();
                  break;
                }
                A = this.nextChar();
              }
            }
          }
          c.Lexer = B;
          class R {
            static create(A) {
              function k(ne, Z, te = !1) {
                const G = ne.get(Z);
                if (Number.isInteger(G) && (te ? G >= 0 : G > 0))
                  return G;
                throw new Error(`The "${Z}" parameter in the linearization dictionary is invalid.`);
              }
              function z(ne) {
                const Z = ne.get("H");
                let te;
                if (Array.isArray(Z) && ((te = Z.length) === 2 || te === 4)) {
                  for (let G = 0; G < te; G++) {
                    const N = Z[G];
                    if (!(Number.isInteger(N) && N > 0))
                      throw new Error(`Hint (${G}) in the linearization dictionary is invalid.`);
                  }
                  return Z;
                }
                throw new Error("Hint array in the linearization dictionary is invalid.");
              }
              const T = new $({
                lexer: new B(A),
                xref: null
              }), w = T.getObj(), F = T.getObj(), j = T.getObj(), P = T.getObj();
              let V, J;
              if (Number.isInteger(w) && Number.isInteger(F) && (0, h.isCmd)(j, "obj") && P instanceof h.Dict && typeof (V = P.get("Linearized")) == "number" && V > 0) {
                if ((J = k(P, "L")) !== A.length)
                  throw new Error('The "L" parameter in the linearization dictionary does not equal the stream length.');
              } else return null;
              return {
                length: J,
                hints: z(P),
                objectNumberFirst: k(P, "O"),
                endFirst: k(P, "E"),
                numPages: k(P, "N"),
                mainXRefEntriesOffset: k(P, "T"),
                pageFirst: P.has("P") ? k(P, "P", !0) : 0
              };
            }
          }
          c.Linearization = R;
        },
        /* 17 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.Ascii85Stream = void 0;
          var s = f(18), h = f(3);
          class g extends s.DecodeStream {
            constructor(i, m) {
              m && (m *= 0.8), super(m), this.str = i, this.dict = i.dict, this.input = new Uint8Array(5);
            }
            readBlock() {
              const E = this.str;
              let S = E.getByte();
              for (; (0, h.isWhiteSpace)(S); )
                S = E.getByte();
              if (S === -1 || S === 126) {
                this.eof = !0;
                return;
              }
              const y = this.bufferLength;
              let x, b;
              if (S === 122) {
                for (x = this.ensureBuffer(y + 4), b = 0; b < 4; ++b)
                  x[y + b] = 0;
                this.bufferLength += 4;
              } else {
                const u = this.input;
                for (u[0] = S, b = 1; b < 5; ++b) {
                  for (S = E.getByte(); (0, h.isWhiteSpace)(S); )
                    S = E.getByte();
                  if (u[b] = S, S === -1 || S === 126)
                    break;
                }
                if (x = this.ensureBuffer(y + b - 1), this.bufferLength += b - 1, b < 5) {
                  for (; b < 5; ++b)
                    u[b] = 117;
                  this.eof = !0;
                }
                let I = 0;
                for (b = 0; b < 5; ++b)
                  I = I * 85 + (u[b] - 33);
                for (b = 3; b >= 0; --b)
                  x[y + b] = I & 255, I >>= 8;
              }
            }
          }
          c.Ascii85Stream = g;
        },
        /* 18 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.StreamsSequenceStream = c.DecodeStream = void 0;
          var s = f(5), h = f(8);
          const g = new Uint8Array(0);
          class t extends s.BaseStream {
            constructor(v) {
              if (super(), this._rawMinBufferLength = v || 0, this.pos = 0, this.bufferLength = 0, this.eof = !1, this.buffer = g, this.minBufferLength = 512, v)
                for (; this.minBufferLength < v; )
                  this.minBufferLength *= 2;
            }
            get isEmpty() {
              for (; !this.eof && this.bufferLength === 0; )
                this.readBlock();
              return this.bufferLength === 0;
            }
            ensureBuffer(v) {
              const E = this.buffer;
              if (v <= E.byteLength)
                return E;
              let S = this.minBufferLength;
              for (; S < v; )
                S *= 2;
              const y = new Uint8Array(S);
              return y.set(E), this.buffer = y;
            }
            getByte() {
              const v = this.pos;
              for (; this.bufferLength <= v; ) {
                if (this.eof)
                  return -1;
                this.readBlock();
              }
              return this.buffer[this.pos++];
            }
            getBytes(v) {
              const E = this.pos;
              let S;
              if (v) {
                for (this.ensureBuffer(E + v), S = E + v; !this.eof && this.bufferLength < S; )
                  this.readBlock();
                const y = this.bufferLength;
                S > y && (S = y);
              } else {
                for (; !this.eof; )
                  this.readBlock();
                S = this.bufferLength;
              }
              return this.pos = S, this.buffer.subarray(E, S);
            }
            reset() {
              this.pos = 0;
            }
            makeSubStream(v, E, S = null) {
              if (E === void 0)
                for (; !this.eof; )
                  this.readBlock();
              else {
                const y = v + E;
                for (; this.bufferLength <= y && !this.eof; )
                  this.readBlock();
              }
              return new h.Stream(this.buffer, v, E, S);
            }
            getBaseStreams() {
              return this.str ? this.str.getBaseStreams() : null;
            }
          }
          c.DecodeStream = t;
          class i extends t {
            constructor(v, E = null) {
              let S = 0;
              for (const y of v)
                S += y instanceof t ? y._rawMinBufferLength : y.length;
              super(S), this.streams = v, this._onError = E;
            }
            readBlock() {
              var u;
              const v = this.streams;
              if (v.length === 0) {
                this.eof = !0;
                return;
              }
              const E = v.shift();
              let S;
              try {
                S = E.getBytes();
              } catch (I) {
                if (this._onError) {
                  this._onError(I, (u = E.dict) == null ? void 0 : u.objId);
                  return;
                }
                throw I;
              }
              const y = this.bufferLength, x = y + S.length;
              this.ensureBuffer(x).set(S, y), this.bufferLength = x;
            }
            getBaseStreams() {
              const v = [];
              for (const E of this.streams) {
                const S = E.getBaseStreams();
                S && v.push(...S);
              }
              return v.length > 0 ? v : null;
            }
          }
          c.StreamsSequenceStream = i;
        },
        /* 19 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.AsciiHexStream = void 0;
          var s = f(18);
          class h extends s.DecodeStream {
            constructor(t, i) {
              i && (i *= 0.5), super(i), this.str = t, this.dict = t.dict, this.firstDigit = -1;
            }
            readBlock() {
              const i = this.str.getBytes(8e3);
              if (!i.length) {
                this.eof = !0;
                return;
              }
              const m = i.length + 1 >> 1, v = this.ensureBuffer(this.bufferLength + m);
              let E = this.bufferLength, S = this.firstDigit;
              for (const y of i) {
                let x;
                if (y >= 48 && y <= 57)
                  x = y & 15;
                else if (y >= 65 && y <= 70 || y >= 97 && y <= 102)
                  x = (y & 15) + 9;
                else if (y === 62) {
                  this.eof = !0;
                  break;
                } else
                  continue;
                S < 0 ? S = x : (v[E++] = S << 4 | x, S = -1);
              }
              S >= 0 && this.eof && (v[E++] = S << 4, S = -1), this.firstDigit = S, this.bufferLength = E;
            }
          }
          c.AsciiHexStream = h;
        },
        /* 20 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.CCITTFaxStream = void 0;
          var s = f(21), h = f(18), g = f(4);
          class t extends h.DecodeStream {
            constructor(m, v, E) {
              super(v), this.str = m, this.dict = m.dict, E instanceof g.Dict || (E = g.Dict.empty);
              const S = {
                next() {
                  return m.getByte();
                }
              };
              this.ccittFaxDecoder = new s.CCITTFaxDecoder(S, {
                K: E.get("K"),
                EndOfLine: E.get("EndOfLine"),
                EncodedByteAlign: E.get("EncodedByteAlign"),
                Columns: E.get("Columns"),
                Rows: E.get("Rows"),
                EndOfBlock: E.get("EndOfBlock"),
                BlackIs1: E.get("BlackIs1")
              });
            }
            readBlock() {
              for (; !this.eof; ) {
                const m = this.ccittFaxDecoder.readNextChar();
                if (m === -1) {
                  this.eof = !0;
                  return;
                }
                this.ensureBuffer(this.bufferLength + 1), this.buffer[this.bufferLength++] = m;
              }
            }
          }
          c.CCITTFaxStream = t;
        },
        /* 21 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.CCITTFaxDecoder = void 0;
          var s = f(2);
          const h = -2, g = -1, t = 0, i = 1, m = 2, v = 3, E = 4, S = 5, y = 6, x = 7, b = 8, u = [[-1, -1], [-1, -1], [7, b], [7, x], [6, y], [6, y], [6, S], [6, S], [4, t], [4, t], [4, t], [4, t], [4, t], [4, t], [4, t], [4, t], [3, i], [3, i], [3, i], [3, i], [3, i], [3, i], [3, i], [3, i], [3, i], [3, i], [3, i], [3, i], [3, i], [3, i], [3, i], [3, i], [3, E], [3, E], [3, E], [3, E], [3, E], [3, E], [3, E], [3, E], [3, E], [3, E], [3, E], [3, E], [3, E], [3, E], [3, E], [3, E], [3, v], [3, v], [3, v], [3, v], [3, v], [3, v], [3, v], [3, v], [3, v], [3, v], [3, v], [3, v], [3, v], [3, v], [3, v], [3, v], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m], [1, m]], I = [[-1, -1], [12, h], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [11, 1792], [11, 1792], [12, 1984], [12, 2048], [12, 2112], [12, 2176], [12, 2240], [12, 2304], [11, 1856], [11, 1856], [11, 1920], [11, 1920], [12, 2368], [12, 2432], [12, 2496], [12, 2560]], O = [[-1, -1], [-1, -1], [-1, -1], [-1, -1], [8, 29], [8, 29], [8, 30], [8, 30], [8, 45], [8, 45], [8, 46], [8, 46], [7, 22], [7, 22], [7, 22], [7, 22], [7, 23], [7, 23], [7, 23], [7, 23], [8, 47], [8, 47], [8, 48], [8, 48], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [7, 20], [7, 20], [7, 20], [7, 20], [8, 33], [8, 33], [8, 34], [8, 34], [8, 35], [8, 35], [8, 36], [8, 36], [8, 37], [8, 37], [8, 38], [8, 38], [7, 19], [7, 19], [7, 19], [7, 19], [8, 31], [8, 31], [8, 32], [8, 32], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [8, 53], [8, 53], [8, 54], [8, 54], [7, 26], [7, 26], [7, 26], [7, 26], [8, 39], [8, 39], [8, 40], [8, 40], [8, 41], [8, 41], [8, 42], [8, 42], [8, 43], [8, 43], [8, 44], [8, 44], [7, 21], [7, 21], [7, 21], [7, 21], [7, 28], [7, 28], [7, 28], [7, 28], [8, 61], [8, 61], [8, 62], [8, 62], [8, 63], [8, 63], [8, 0], [8, 0], [8, 320], [8, 320], [8, 384], [8, 384], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [7, 27], [7, 27], [7, 27], [7, 27], [8, 59], [8, 59], [8, 60], [8, 60], [9, 1472], [9, 1536], [9, 1600], [9, 1728], [7, 18], [7, 18], [7, 18], [7, 18], [7, 24], [7, 24], [7, 24], [7, 24], [8, 49], [8, 49], [8, 50], [8, 50], [8, 51], [8, 51], [8, 52], [8, 52], [7, 25], [7, 25], [7, 25], [7, 25], [8, 55], [8, 55], [8, 56], [8, 56], [8, 57], [8, 57], [8, 58], [8, 58], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [8, 448], [8, 448], [8, 512], [8, 512], [9, 704], [9, 768], [8, 640], [8, 640], [8, 576], [8, 576], [9, 832], [9, 896], [9, 960], [9, 1024], [9, 1088], [9, 1152], [9, 1216], [9, 1280], [9, 1344], [9, 1408], [7, 256], [7, 256], [7, 256], [7, 256], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7]], D = [[-1, -1], [-1, -1], [12, h], [12, h], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [11, 1792], [11, 1792], [11, 1792], [11, 1792], [12, 1984], [12, 1984], [12, 2048], [12, 2048], [12, 2112], [12, 2112], [12, 2176], [12, 2176], [12, 2240], [12, 2240], [12, 2304], [12, 2304], [11, 1856], [11, 1856], [11, 1856], [11, 1856], [11, 1920], [11, 1920], [11, 1920], [11, 1920], [12, 2368], [12, 2368], [12, 2432], [12, 2432], [12, 2496], [12, 2496], [12, 2560], [12, 2560], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [12, 52], [12, 52], [13, 640], [13, 704], [13, 768], [13, 832], [12, 55], [12, 55], [12, 56], [12, 56], [13, 1280], [13, 1344], [13, 1408], [13, 1472], [12, 59], [12, 59], [12, 60], [12, 60], [13, 1536], [13, 1600], [11, 24], [11, 24], [11, 24], [11, 24], [11, 25], [11, 25], [11, 25], [11, 25], [13, 1664], [13, 1728], [12, 320], [12, 320], [12, 384], [12, 384], [12, 448], [12, 448], [13, 512], [13, 576], [12, 53], [12, 53], [12, 54], [12, 54], [13, 896], [13, 960], [13, 1024], [13, 1088], [13, 1152], [13, 1216], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64]], $ = [[8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [11, 23], [11, 23], [12, 50], [12, 51], [12, 44], [12, 45], [12, 46], [12, 47], [12, 57], [12, 58], [12, 61], [12, 256], [10, 16], [10, 16], [10, 16], [10, 16], [10, 17], [10, 17], [10, 17], [10, 17], [12, 48], [12, 49], [12, 62], [12, 63], [12, 30], [12, 31], [12, 32], [12, 33], [12, 40], [12, 41], [11, 22], [11, 22], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [12, 128], [12, 192], [12, 26], [12, 27], [12, 28], [12, 29], [11, 19], [11, 19], [11, 20], [11, 20], [12, 34], [12, 35], [12, 36], [12, 37], [12, 38], [12, 39], [11, 21], [11, 21], [12, 42], [12, 43], [10, 0], [10, 0], [10, 0], [10, 0], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12]], K = [[-1, -1], [-1, -1], [-1, -1], [-1, -1], [6, 9], [6, 8], [5, 7], [5, 7], [4, 6], [4, 6], [4, 6], [4, 6], [4, 5], [4, 5], [4, 5], [4, 5], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2]];
          class H {
            constructor(R, _ = {}) {
              if (!R || typeof R.next != "function")
                throw new Error('CCITTFaxDecoder - invalid "source" parameter.');
              this.source = R, this.eof = !1, this.encoding = _.K || 0, this.eoline = _.EndOfLine || !1, this.byteAlign = _.EncodedByteAlign || !1, this.columns = _.Columns || 1728, this.rows = _.Rows || 0, this.eoblock = _.EndOfBlock ?? !0, this.black = _.BlackIs1 || !1, this.codingLine = new Uint32Array(this.columns + 1), this.refLine = new Uint32Array(this.columns + 2), this.codingLine[0] = this.columns, this.codingPos = 0, this.row = 0, this.nextLine2D = this.encoding < 0, this.inputBits = 0, this.inputBuf = 0, this.outputBits = 0, this.rowsDone = !1;
              let A;
              for (; (A = this._lookBits(12)) === 0; )
                this._eatBits(1);
              A === 1 && this._eatBits(12), this.encoding > 0 && (this.nextLine2D = !this._lookBits(1), this._eatBits(1));
            }
            readNextChar() {
              if (this.eof)
                return -1;
              const R = this.refLine, _ = this.codingLine, A = this.columns;
              let k, z, T, w;
              if (this.outputBits === 0) {
                if (this.rowsDone && (this.eof = !0), this.eof)
                  return -1;
                this.err = !1;
                let j, P, V;
                if (this.nextLine2D) {
                  for (w = 0; _[w] < A; ++w)
                    R[w] = _[w];
                  for (R[w++] = A, R[w] = A, _[0] = 0, this.codingPos = 0, k = 0, z = 0; _[this.codingPos] < A; )
                    switch (j = this._getTwoDimCode(), j) {
                      case t:
                        this._addPixels(R[k + 1], z), R[k + 1] < A && (k += 2);
                        break;
                      case i:
                        if (j = P = 0, z) {
                          do
                            j += V = this._getBlackCode();
                          while (V >= 64);
                          do
                            P += V = this._getWhiteCode();
                          while (V >= 64);
                        } else {
                          do
                            j += V = this._getWhiteCode();
                          while (V >= 64);
                          do
                            P += V = this._getBlackCode();
                          while (V >= 64);
                        }
                        for (this._addPixels(_[this.codingPos] + j, z), _[this.codingPos] < A && this._addPixels(_[this.codingPos] + P, z ^ 1); R[k] <= _[this.codingPos] && R[k] < A; )
                          k += 2;
                        break;
                      case x:
                        if (this._addPixels(R[k] + 3, z), z ^= 1, _[this.codingPos] < A)
                          for (++k; R[k] <= _[this.codingPos] && R[k] < A; )
                            k += 2;
                        break;
                      case S:
                        if (this._addPixels(R[k] + 2, z), z ^= 1, _[this.codingPos] < A)
                          for (++k; R[k] <= _[this.codingPos] && R[k] < A; )
                            k += 2;
                        break;
                      case v:
                        if (this._addPixels(R[k] + 1, z), z ^= 1, _[this.codingPos] < A)
                          for (++k; R[k] <= _[this.codingPos] && R[k] < A; )
                            k += 2;
                        break;
                      case m:
                        if (this._addPixels(R[k], z), z ^= 1, _[this.codingPos] < A)
                          for (++k; R[k] <= _[this.codingPos] && R[k] < A; )
                            k += 2;
                        break;
                      case b:
                        if (this._addPixelsNeg(R[k] - 3, z), z ^= 1, _[this.codingPos] < A)
                          for (k > 0 ? --k : ++k; R[k] <= _[this.codingPos] && R[k] < A; )
                            k += 2;
                        break;
                      case y:
                        if (this._addPixelsNeg(R[k] - 2, z), z ^= 1, _[this.codingPos] < A)
                          for (k > 0 ? --k : ++k; R[k] <= _[this.codingPos] && R[k] < A; )
                            k += 2;
                        break;
                      case E:
                        if (this._addPixelsNeg(R[k] - 1, z), z ^= 1, _[this.codingPos] < A)
                          for (k > 0 ? --k : ++k; R[k] <= _[this.codingPos] && R[k] < A; )
                            k += 2;
                        break;
                      case g:
                        this._addPixels(A, 0), this.eof = !0;
                        break;
                      default:
                        (0, s.info)("bad 2d code"), this._addPixels(A, 0), this.err = !0;
                    }
                } else
                  for (_[0] = 0, this.codingPos = 0, z = 0; _[this.codingPos] < A; ) {
                    if (j = 0, z)
                      do
                        j += V = this._getBlackCode();
                      while (V >= 64);
                    else
                      do
                        j += V = this._getWhiteCode();
                      while (V >= 64);
                    this._addPixels(_[this.codingPos] + j, z), z ^= 1;
                  }
                let J = !1;
                if (this.byteAlign && (this.inputBits &= -8), !this.eoblock && this.row === this.rows - 1)
                  this.rowsDone = !0;
                else {
                  if (j = this._lookBits(12), this.eoline)
                    for (; j !== g && j !== 1; )
                      this._eatBits(1), j = this._lookBits(12);
                  else
                    for (; j === 0; )
                      this._eatBits(1), j = this._lookBits(12);
                  j === 1 ? (this._eatBits(12), J = !0) : j === g && (this.eof = !0);
                }
                if (!this.eof && this.encoding > 0 && !this.rowsDone && (this.nextLine2D = !this._lookBits(1), this._eatBits(1)), this.eoblock && J && this.byteAlign) {
                  if (j = this._lookBits(12), j === 1) {
                    if (this._eatBits(12), this.encoding > 0 && (this._lookBits(1), this._eatBits(1)), this.encoding >= 0)
                      for (w = 0; w < 4; ++w)
                        j = this._lookBits(12), j !== 1 && (0, s.info)("bad rtc code: " + j), this._eatBits(12), this.encoding > 0 && (this._lookBits(1), this._eatBits(1));
                    this.eof = !0;
                  }
                } else if (this.err && this.eoline) {
                  for (; ; ) {
                    if (j = this._lookBits(13), j === g)
                      return this.eof = !0, -1;
                    if (j >> 1 === 1)
                      break;
                    this._eatBits(1);
                  }
                  this._eatBits(12), this.encoding > 0 && (this._eatBits(1), this.nextLine2D = !(j & 1));
                }
                this.outputBits = _[0] > 0 ? _[this.codingPos = 0] : _[this.codingPos = 1], this.row++;
              }
              let F;
              if (this.outputBits >= 8)
                F = this.codingPos & 1 ? 0 : 255, this.outputBits -= 8, this.outputBits === 0 && _[this.codingPos] < A && (this.codingPos++, this.outputBits = _[this.codingPos] - _[this.codingPos - 1]);
              else {
                T = 8, F = 0;
                do {
                  if (typeof this.outputBits != "number")
                    throw new s.FormatError('Invalid /CCITTFaxDecode data, "outputBits" must be a number.');
                  this.outputBits > T ? (F <<= T, this.codingPos & 1 || (F |= 255 >> 8 - T), this.outputBits -= T, T = 0) : (F <<= this.outputBits, this.codingPos & 1 || (F |= 255 >> 8 - this.outputBits), T -= this.outputBits, this.outputBits = 0, _[this.codingPos] < A ? (this.codingPos++, this.outputBits = _[this.codingPos] - _[this.codingPos - 1]) : T > 0 && (F <<= T, T = 0));
                } while (T);
              }
              return this.black && (F ^= 255), F;
            }
            _addPixels(R, _) {
              const A = this.codingLine;
              let k = this.codingPos;
              R > A[k] && (R > this.columns && ((0, s.info)("row is wrong length"), this.err = !0, R = this.columns), k & 1 ^ _ && ++k, A[k] = R), this.codingPos = k;
            }
            _addPixelsNeg(R, _) {
              const A = this.codingLine;
              let k = this.codingPos;
              if (R > A[k])
                R > this.columns && ((0, s.info)("row is wrong length"), this.err = !0, R = this.columns), k & 1 ^ _ && ++k, A[k] = R;
              else if (R < A[k]) {
                for (R < 0 && ((0, s.info)("invalid code"), this.err = !0, R = 0); k > 0 && R < A[k - 1]; )
                  --k;
                A[k] = R;
              }
              this.codingPos = k;
            }
            _findTableCode(R, _, A, k) {
              const z = k || 0;
              for (let T = R; T <= _; ++T) {
                let w = this._lookBits(T);
                if (w === g)
                  return [!0, 1, !1];
                if (T < _ && (w <<= _ - T), !z || w >= z) {
                  const F = A[w - z];
                  if (F[0] === T)
                    return this._eatBits(T), [!0, F[1], !0];
                }
              }
              return [!1, 0, !1];
            }
            _getTwoDimCode() {
              let R = 0, _;
              if (this.eoblock) {
                if (R = this._lookBits(7), _ = u[R], (_ == null ? void 0 : _[0]) > 0)
                  return this._eatBits(_[0]), _[1];
              } else {
                const A = this._findTableCode(1, 7, u);
                if (A[0] && A[2])
                  return A[1];
              }
              return (0, s.info)("Bad two dim code"), g;
            }
            _getWhiteCode() {
              let R = 0, _;
              if (this.eoblock) {
                if (R = this._lookBits(12), R === g)
                  return 1;
                if (_ = R >> 5 ? O[R >> 3] : I[R], _[0] > 0)
                  return this._eatBits(_[0]), _[1];
              } else {
                let A = this._findTableCode(1, 9, O);
                if (A[0] || (A = this._findTableCode(11, 12, I), A[0]))
                  return A[1];
              }
              return (0, s.info)("bad white code"), this._eatBits(1), 1;
            }
            _getBlackCode() {
              let R, _;
              if (this.eoblock) {
                if (R = this._lookBits(13), R === g)
                  return 1;
                if (R >> 7 ? !(R >> 9) && R >> 7 ? _ = $[(R >> 1) - 64] : _ = K[R >> 7] : _ = D[R], _[0] > 0)
                  return this._eatBits(_[0]), _[1];
              } else {
                let A = this._findTableCode(2, 6, K);
                if (A[0] || (A = this._findTableCode(7, 12, $, 64), A[0]) || (A = this._findTableCode(10, 13, D), A[0]))
                  return A[1];
              }
              return (0, s.info)("bad black code"), this._eatBits(1), 1;
            }
            _lookBits(R) {
              let _;
              for (; this.inputBits < R; ) {
                if ((_ = this.source.next()) === -1)
                  return this.inputBits === 0 ? g : this.inputBuf << R - this.inputBits & 65535 >> 16 - R;
                this.inputBuf = this.inputBuf << 8 | _, this.inputBits += 8;
              }
              return this.inputBuf >> this.inputBits - R & 65535 >> 16 - R;
            }
            _eatBits(R) {
              (this.inputBits -= R) < 0 && (this.inputBits = 0);
            }
          }
          c.CCITTFaxDecoder = H;
        },
        /* 22 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.FlateStream = void 0;
          var s = f(18), h = f(2);
          const g = new Int32Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), t = new Int32Array([3, 4, 5, 6, 7, 8, 9, 10, 65547, 65549, 65551, 65553, 131091, 131095, 131099, 131103, 196643, 196651, 196659, 196667, 262211, 262227, 262243, 262259, 327811, 327843, 327875, 327907, 258, 258, 258]), i = new Int32Array([1, 2, 3, 4, 65541, 65543, 131081, 131085, 196625, 196633, 262177, 262193, 327745, 327777, 393345, 393409, 459009, 459137, 524801, 525057, 590849, 591361, 657409, 658433, 724993, 727041, 794625, 798721, 868353, 876545]), m = [new Int32Array([459008, 524368, 524304, 524568, 459024, 524400, 524336, 590016, 459016, 524384, 524320, 589984, 524288, 524416, 524352, 590048, 459012, 524376, 524312, 589968, 459028, 524408, 524344, 590032, 459020, 524392, 524328, 59e4, 524296, 524424, 524360, 590064, 459010, 524372, 524308, 524572, 459026, 524404, 524340, 590024, 459018, 524388, 524324, 589992, 524292, 524420, 524356, 590056, 459014, 524380, 524316, 589976, 459030, 524412, 524348, 590040, 459022, 524396, 524332, 590008, 524300, 524428, 524364, 590072, 459009, 524370, 524306, 524570, 459025, 524402, 524338, 590020, 459017, 524386, 524322, 589988, 524290, 524418, 524354, 590052, 459013, 524378, 524314, 589972, 459029, 524410, 524346, 590036, 459021, 524394, 524330, 590004, 524298, 524426, 524362, 590068, 459011, 524374, 524310, 524574, 459027, 524406, 524342, 590028, 459019, 524390, 524326, 589996, 524294, 524422, 524358, 590060, 459015, 524382, 524318, 589980, 459031, 524414, 524350, 590044, 459023, 524398, 524334, 590012, 524302, 524430, 524366, 590076, 459008, 524369, 524305, 524569, 459024, 524401, 524337, 590018, 459016, 524385, 524321, 589986, 524289, 524417, 524353, 590050, 459012, 524377, 524313, 589970, 459028, 524409, 524345, 590034, 459020, 524393, 524329, 590002, 524297, 524425, 524361, 590066, 459010, 524373, 524309, 524573, 459026, 524405, 524341, 590026, 459018, 524389, 524325, 589994, 524293, 524421, 524357, 590058, 459014, 524381, 524317, 589978, 459030, 524413, 524349, 590042, 459022, 524397, 524333, 590010, 524301, 524429, 524365, 590074, 459009, 524371, 524307, 524571, 459025, 524403, 524339, 590022, 459017, 524387, 524323, 589990, 524291, 524419, 524355, 590054, 459013, 524379, 524315, 589974, 459029, 524411, 524347, 590038, 459021, 524395, 524331, 590006, 524299, 524427, 524363, 590070, 459011, 524375, 524311, 524575, 459027, 524407, 524343, 590030, 459019, 524391, 524327, 589998, 524295, 524423, 524359, 590062, 459015, 524383, 524319, 589982, 459031, 524415, 524351, 590046, 459023, 524399, 524335, 590014, 524303, 524431, 524367, 590078, 459008, 524368, 524304, 524568, 459024, 524400, 524336, 590017, 459016, 524384, 524320, 589985, 524288, 524416, 524352, 590049, 459012, 524376, 524312, 589969, 459028, 524408, 524344, 590033, 459020, 524392, 524328, 590001, 524296, 524424, 524360, 590065, 459010, 524372, 524308, 524572, 459026, 524404, 524340, 590025, 459018, 524388, 524324, 589993, 524292, 524420, 524356, 590057, 459014, 524380, 524316, 589977, 459030, 524412, 524348, 590041, 459022, 524396, 524332, 590009, 524300, 524428, 524364, 590073, 459009, 524370, 524306, 524570, 459025, 524402, 524338, 590021, 459017, 524386, 524322, 589989, 524290, 524418, 524354, 590053, 459013, 524378, 524314, 589973, 459029, 524410, 524346, 590037, 459021, 524394, 524330, 590005, 524298, 524426, 524362, 590069, 459011, 524374, 524310, 524574, 459027, 524406, 524342, 590029, 459019, 524390, 524326, 589997, 524294, 524422, 524358, 590061, 459015, 524382, 524318, 589981, 459031, 524414, 524350, 590045, 459023, 524398, 524334, 590013, 524302, 524430, 524366, 590077, 459008, 524369, 524305, 524569, 459024, 524401, 524337, 590019, 459016, 524385, 524321, 589987, 524289, 524417, 524353, 590051, 459012, 524377, 524313, 589971, 459028, 524409, 524345, 590035, 459020, 524393, 524329, 590003, 524297, 524425, 524361, 590067, 459010, 524373, 524309, 524573, 459026, 524405, 524341, 590027, 459018, 524389, 524325, 589995, 524293, 524421, 524357, 590059, 459014, 524381, 524317, 589979, 459030, 524413, 524349, 590043, 459022, 524397, 524333, 590011, 524301, 524429, 524365, 590075, 459009, 524371, 524307, 524571, 459025, 524403, 524339, 590023, 459017, 524387, 524323, 589991, 524291, 524419, 524355, 590055, 459013, 524379, 524315, 589975, 459029, 524411, 524347, 590039, 459021, 524395, 524331, 590007, 524299, 524427, 524363, 590071, 459011, 524375, 524311, 524575, 459027, 524407, 524343, 590031, 459019, 524391, 524327, 589999, 524295, 524423, 524359, 590063, 459015, 524383, 524319, 589983, 459031, 524415, 524351, 590047, 459023, 524399, 524335, 590015, 524303, 524431, 524367, 590079]), 9], v = [new Int32Array([327680, 327696, 327688, 327704, 327684, 327700, 327692, 327708, 327682, 327698, 327690, 327706, 327686, 327702, 327694, 0, 327681, 327697, 327689, 327705, 327685, 327701, 327693, 327709, 327683, 327699, 327691, 327707, 327687, 327703, 327695, 0]), 5];
          class E extends s.DecodeStream {
            constructor(y, x) {
              super(x), this.str = y, this.dict = y.dict;
              const b = y.getByte(), u = y.getByte();
              if (b === -1 || u === -1)
                throw new h.FormatError(`Invalid header in flate stream: ${b}, ${u}`);
              if ((b & 15) !== 8)
                throw new h.FormatError(`Unknown compression method in flate stream: ${b}, ${u}`);
              if (((b << 8) + u) % 31 !== 0)
                throw new h.FormatError(`Bad FCHECK in flate stream: ${b}, ${u}`);
              if (u & 32)
                throw new h.FormatError(`FDICT bit set in flate stream: ${b}, ${u}`);
              this.codeSize = 0, this.codeBuf = 0;
            }
            getBits(y) {
              const x = this.str;
              let b = this.codeSize, u = this.codeBuf, I;
              for (; b < y; ) {
                if ((I = x.getByte()) === -1)
                  throw new h.FormatError("Bad encoding in flate stream");
                u |= I << b, b += 8;
              }
              return I = u & (1 << y) - 1, this.codeBuf = u >> y, this.codeSize = b -= y, I;
            }
            getCode(y) {
              const x = this.str, b = y[0], u = y[1];
              let I = this.codeSize, O = this.codeBuf, D;
              for (; I < u && (D = x.getByte()) !== -1; )
                O |= D << I, I += 8;
              const $ = b[O & (1 << u) - 1], K = $ >> 16, H = $ & 65535;
              if (K < 1 || I < K)
                throw new h.FormatError("Bad encoding in flate stream");
              return this.codeBuf = O >> K, this.codeSize = I - K, H;
            }
            generateHuffmanTable(y) {
              const x = y.length;
              let b = 0, u;
              for (u = 0; u < x; ++u)
                y[u] > b && (b = y[u]);
              const I = 1 << b, O = new Int32Array(I);
              for (let D = 1, $ = 0, K = 2; D <= b; ++D, $ <<= 1, K <<= 1)
                for (let H = 0; H < x; ++H)
                  if (y[H] === D) {
                    let B = 0, R = $;
                    for (u = 0; u < D; ++u)
                      B = B << 1 | R & 1, R >>= 1;
                    for (u = B; u < I; u += K)
                      O[u] = D << 16 | H;
                    ++$;
                  }
              return [O, b];
            }
            readBlock() {
              let y, x;
              const b = this.str;
              let u = this.getBits(3);
              if (u & 1 && (this.eof = !0), u >>= 1, u === 0) {
                let K;
                if ((K = b.getByte()) === -1)
                  throw new h.FormatError("Bad block header in flate stream");
                let H = K;
                if ((K = b.getByte()) === -1)
                  throw new h.FormatError("Bad block header in flate stream");
                if (H |= K << 8, (K = b.getByte()) === -1)
                  throw new h.FormatError("Bad block header in flate stream");
                let B = K;
                if ((K = b.getByte()) === -1)
                  throw new h.FormatError("Bad block header in flate stream");
                if (B |= K << 8, B !== (~H & 65535) && (H !== 0 || B !== 0))
                  throw new h.FormatError("Bad uncompressed block length in flate stream");
                this.codeBuf = 0, this.codeSize = 0;
                const R = this.bufferLength, _ = R + H;
                if (y = this.ensureBuffer(_), this.bufferLength = _, H === 0)
                  b.peekByte() === -1 && (this.eof = !0);
                else {
                  const A = b.getBytes(H);
                  y.set(A, R), A.length < H && (this.eof = !0);
                }
                return;
              }
              let I, O;
              if (u === 1)
                I = m, O = v;
              else if (u === 2) {
                const K = this.getBits(5) + 257, H = this.getBits(5) + 1, B = this.getBits(4) + 4, R = new Uint8Array(g.length);
                let _;
                for (_ = 0; _ < B; ++_)
                  R[g[_]] = this.getBits(3);
                const A = this.generateHuffmanTable(R);
                x = 0, _ = 0;
                const k = K + H, z = new Uint8Array(k);
                let T, w, F;
                for (; _ < k; ) {
                  const j = this.getCode(A);
                  if (j === 16)
                    T = 2, w = 3, F = x;
                  else if (j === 17)
                    T = 3, w = 3, F = x = 0;
                  else if (j === 18)
                    T = 7, w = 11, F = x = 0;
                  else {
                    z[_++] = x = j;
                    continue;
                  }
                  let P = this.getBits(T) + w;
                  for (; P-- > 0; )
                    z[_++] = F;
                }
                I = this.generateHuffmanTable(z.subarray(0, K)), O = this.generateHuffmanTable(z.subarray(K, k));
              } else
                throw new h.FormatError("Unknown block type in flate stream");
              y = this.buffer;
              let D = y ? y.length : 0, $ = this.bufferLength;
              for (; ; ) {
                let K = this.getCode(I);
                if (K < 256) {
                  $ + 1 >= D && (y = this.ensureBuffer($ + 1), D = y.length), y[$++] = K;
                  continue;
                }
                if (K === 256) {
                  this.bufferLength = $;
                  return;
                }
                K -= 257, K = t[K];
                let H = K >> 16;
                H > 0 && (H = this.getBits(H)), x = (K & 65535) + H, K = this.getCode(O), K = i[K], H = K >> 16, H > 0 && (H = this.getBits(H));
                const B = (K & 65535) + H;
                $ + x >= D && (y = this.ensureBuffer($ + x), D = y.length);
                for (let R = 0; R < x; ++R, ++$)
                  y[$] = y[$ - B];
              }
            }
          }
          c.FlateStream = E;
        },
        /* 23 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.Jbig2Stream = void 0;
          var s = f(5), h = f(18), g = f(4), t = f(24), i = f(2);
          class m extends h.DecodeStream {
            constructor(E, S, y) {
              super(S), this.stream = E, this.dict = E.dict, this.maybeLength = S, this.params = y;
            }
            get bytes() {
              return (0, i.shadow)(this, "bytes", this.stream.getBytes(this.maybeLength));
            }
            ensureBuffer(E) {
            }
            readBlock() {
              if (this.eof)
                return;
              const E = new t.Jbig2Image(), S = [];
              if (this.params instanceof g.Dict) {
                const b = this.params.get("JBIG2Globals");
                if (b instanceof s.BaseStream) {
                  const u = b.getBytes();
                  S.push({
                    data: u,
                    start: 0,
                    end: u.length
                  });
                }
              }
              S.push({
                data: this.bytes,
                start: 0,
                end: this.bytes.length
              });
              const y = E.parseChunks(S), x = y.length;
              for (let b = 0; b < x; b++)
                y[b] ^= 255;
              this.buffer = y, this.bufferLength = x, this.eof = !0;
            }
          }
          c.Jbig2Stream = m;
        },
        /* 24 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.Jbig2Image = void 0;
          var s = f(2), h = f(3), g = f(25), t = f(21);
          class i extends s.BaseException {
            constructor(L) {
              super(`JBIG2 error: ${L}`, "Jbig2Error");
            }
          }
          class m {
            getContexts(L) {
              return L in this ? this[L] : this[L] = new Int8Array(65536);
            }
          }
          class v {
            constructor(L, W, M) {
              this.data = L, this.start = W, this.end = M;
            }
            get decoder() {
              const L = new g.ArithmeticDecoder(this.data, this.start, this.end);
              return (0, s.shadow)(this, "decoder", L);
            }
            get contextCache() {
              const L = new m();
              return (0, s.shadow)(this, "contextCache", L);
            }
          }
          const E = 2 ** 31 - 1, S = -(2 ** 31);
          function y(se, L, W) {
            const M = se.getContexts(L);
            let X = 1;
            function U(ce) {
              let ee = 0;
              for (let he = 0; he < ce; he++) {
                const pe = W.readBit(M, X);
                X = X < 256 ? X << 1 | pe : (X << 1 | pe) & 511 | 256, ee = ee << 1 | pe;
              }
              return ee >>> 0;
            }
            const Q = U(1), re = U(1) ? U(1) ? U(1) ? U(1) ? U(1) ? U(32) + 4436 : U(12) + 340 : U(8) + 84 : U(6) + 20 : U(4) + 4 : U(2);
            let le;
            return Q === 0 ? le = re : re > 0 && (le = -re), le >= S && le <= E ? le : null;
          }
          function x(se, L, W) {
            const M = se.getContexts("IAID");
            let X = 1;
            for (let U = 0; U < W; U++) {
              const Q = L.readBit(M, X);
              X = X << 1 | Q;
            }
            return W < 31 ? X & (1 << W) - 1 : X & 2147483647;
          }
          const b = ["SymbolDictionary", null, null, null, "IntermediateTextRegion", null, "ImmediateTextRegion", "ImmediateLosslessTextRegion", null, null, null, null, null, null, null, null, "PatternDictionary", null, null, null, "IntermediateHalftoneRegion", null, "ImmediateHalftoneRegion", "ImmediateLosslessHalftoneRegion", null, null, null, null, null, null, null, null, null, null, null, null, "IntermediateGenericRegion", null, "ImmediateGenericRegion", "ImmediateLosslessGenericRegion", "IntermediateGenericRefinementRegion", null, "ImmediateGenericRefinementRegion", "ImmediateLosslessGenericRefinementRegion", null, null, null, null, "PageInformation", "EndOfPage", "EndOfStripe", "EndOfFile", "Profiles", "Tables", null, null, null, null, null, null, null, null, "Extension"], u = [[{
            x: -1,
            y: -2
          }, {
            x: 0,
            y: -2
          }, {
            x: 1,
            y: -2
          }, {
            x: -2,
            y: -1
          }, {
            x: -1,
            y: -1
          }, {
            x: 0,
            y: -1
          }, {
            x: 1,
            y: -1
          }, {
            x: 2,
            y: -1
          }, {
            x: -4,
            y: 0
          }, {
            x: -3,
            y: 0
          }, {
            x: -2,
            y: 0
          }, {
            x: -1,
            y: 0
          }], [{
            x: -1,
            y: -2
          }, {
            x: 0,
            y: -2
          }, {
            x: 1,
            y: -2
          }, {
            x: 2,
            y: -2
          }, {
            x: -2,
            y: -1
          }, {
            x: -1,
            y: -1
          }, {
            x: 0,
            y: -1
          }, {
            x: 1,
            y: -1
          }, {
            x: 2,
            y: -1
          }, {
            x: -3,
            y: 0
          }, {
            x: -2,
            y: 0
          }, {
            x: -1,
            y: 0
          }], [{
            x: -1,
            y: -2
          }, {
            x: 0,
            y: -2
          }, {
            x: 1,
            y: -2
          }, {
            x: -2,
            y: -1
          }, {
            x: -1,
            y: -1
          }, {
            x: 0,
            y: -1
          }, {
            x: 1,
            y: -1
          }, {
            x: -2,
            y: 0
          }, {
            x: -1,
            y: 0
          }], [{
            x: -3,
            y: -1
          }, {
            x: -2,
            y: -1
          }, {
            x: -1,
            y: -1
          }, {
            x: 0,
            y: -1
          }, {
            x: 1,
            y: -1
          }, {
            x: -4,
            y: 0
          }, {
            x: -3,
            y: 0
          }, {
            x: -2,
            y: 0
          }, {
            x: -1,
            y: 0
          }]], I = [{
            coding: [{
              x: 0,
              y: -1
            }, {
              x: 1,
              y: -1
            }, {
              x: -1,
              y: 0
            }],
            reference: [{
              x: 0,
              y: -1
            }, {
              x: 1,
              y: -1
            }, {
              x: -1,
              y: 0
            }, {
              x: 0,
              y: 0
            }, {
              x: 1,
              y: 0
            }, {
              x: -1,
              y: 1
            }, {
              x: 0,
              y: 1
            }, {
              x: 1,
              y: 1
            }]
          }, {
            coding: [{
              x: -1,
              y: -1
            }, {
              x: 0,
              y: -1
            }, {
              x: 1,
              y: -1
            }, {
              x: -1,
              y: 0
            }],
            reference: [{
              x: 0,
              y: -1
            }, {
              x: -1,
              y: 0
            }, {
              x: 0,
              y: 0
            }, {
              x: 1,
              y: 0
            }, {
              x: 0,
              y: 1
            }, {
              x: 1,
              y: 1
            }]
          }], O = [39717, 1941, 229, 405];
          function D(se, L, W) {
            const M = W.decoder, X = W.contextCache.getContexts("GB"), U = [];
            let Q, re, le, ce, ee, he, pe;
            const de = 31735;
            for (re = 0; re < L; re++)
              for (ee = U[re] = new Uint8Array(se), he = re < 1 ? ee : U[re - 1], pe = re < 2 ? ee : U[re - 2], Q = pe[0] << 13 | pe[1] << 12 | pe[2] << 11 | he[0] << 7 | he[1] << 6 | he[2] << 5 | he[3] << 4, le = 0; le < se; le++)
                ee[le] = ce = M.readBit(X, Q), Q = (Q & de) << 1 | (le + 3 < se ? pe[le + 3] << 11 : 0) | (le + 4 < se ? he[le + 4] << 4 : 0) | ce;
            return U;
          }
          function $(se, L, W, M, X, U, Q, re) {
            if (se) {
              const Pt = new N(re.data, re.start, re.end);
              return Y(Pt, L, W, !1);
            }
            if (M === 0 && !U && !X && Q.length === 4 && Q[0].x === 3 && Q[0].y === -1 && Q[1].x === -3 && Q[1].y === -1 && Q[2].x === 2 && Q[2].y === -2 && Q[3].x === -2 && Q[3].y === -2)
              return D(L, W, re);
            const le = u[M].concat(Q);
            le.sort(function(Pt, et) {
              return Pt.y - et.y || Pt.x - et.x;
            });
            const ce = le.length, ee = new Int8Array(ce), he = new Int8Array(ce), pe = [];
            let de = 0, ge = 0, me = 0, xe = 0, ye, ve;
            for (ve = 0; ve < ce; ve++)
              ee[ve] = le[ve].x, he[ve] = le[ve].y, ge = Math.min(ge, le[ve].x), me = Math.max(me, le[ve].x), xe = Math.min(xe, le[ve].y), ve < ce - 1 && le[ve].y === le[ve + 1].y && le[ve].x === le[ve + 1].x - 1 ? de |= 1 << ce - 1 - ve : pe.push(ve);
            const Ce = pe.length, Ie = new Int8Array(Ce), Ae = new Int8Array(Ce), Se = new Uint16Array(Ce);
            for (ye = 0; ye < Ce; ye++)
              ve = pe[ye], Ie[ye] = le[ve].x, Ae[ye] = le[ve].y, Se[ye] = 1 << ce - 1 - ve;
            const De = -ge, Be = -xe, ke = L - me, be = O[M];
            let we = new Uint8Array(L);
            const Le = [], Re = re.decoder, ct = re.contextCache.getContexts("GB");
            let ft = 0, kt, We, jt, yt = 0, Ye, mt;
            for (let Pt = 0; Pt < W; Pt++) {
              if (X) {
                const et = Re.readBit(ct, be);
                if (ft ^= et, ft) {
                  Le.push(we);
                  continue;
                }
              }
              for (we = new Uint8Array(we), Le.push(we), kt = 0; kt < L; kt++) {
                if (kt >= De && kt < ke && Pt >= Be)
                  for (yt = yt << 1 & de, ve = 0; ve < Ce; ve++)
                    We = Pt + Ae[ve], jt = kt + Ie[ve], Ye = Le[We][jt], Ye && (Ye = Se[ve], yt |= Ye);
                else
                  for (yt = 0, mt = ce - 1, ve = 0; ve < ce; ve++, mt--)
                    jt = kt + ee[ve], jt >= 0 && jt < L && (We = Pt + he[ve], We >= 0 && (Ye = Le[We][jt], Ye && (yt |= Ye << mt)));
                const et = Re.readBit(ct, yt);
                we[kt] = et;
              }
            }
            return Le;
          }
          function K(se, L, W, M, X, U, Q, re, le) {
            let ce = I[W].coding;
            W === 0 && (ce = ce.concat([re[0]]));
            const ee = ce.length, he = new Int32Array(ee), pe = new Int32Array(ee);
            let de;
            for (de = 0; de < ee; de++)
              he[de] = ce[de].x, pe[de] = ce[de].y;
            let ge = I[W].reference;
            W === 0 && (ge = ge.concat([re[1]]));
            const me = ge.length, xe = new Int32Array(me), ye = new Int32Array(me);
            for (de = 0; de < me; de++)
              xe[de] = ge[de].x, ye[de] = ge[de].y;
            const ve = M[0].length, Ce = M.length, Ie = [], Ae = le.decoder, Se = le.contextCache.getContexts("GR");
            for (let De = 0; De < L; De++) {
              const Be = new Uint8Array(se);
              Ie.push(Be);
              for (let ke = 0; ke < se; ke++) {
                let be, we, Le = 0;
                for (de = 0; de < ee; de++)
                  be = De + pe[de], we = ke + he[de], be < 0 || we < 0 || we >= se ? Le <<= 1 : Le = Le << 1 | Ie[be][we];
                for (de = 0; de < me; de++)
                  be = De + ye[de] - U, we = ke + xe[de] - X, be < 0 || be >= Ce || we < 0 || we >= ve ? Le <<= 1 : Le = Le << 1 | M[be][we];
                const Re = Ae.readBit(Se, Le);
                Be[ke] = Re;
              }
            }
            return Ie;
          }
          function H(se, L, W, M, X, U, Q, re, le, ce, ee, he) {
            if (se && L)
              throw new i("symbol refinement with Huffman is not supported");
            const pe = [];
            let de = 0, ge = (0, h.log2)(W.length + M);
            const me = ee.decoder, xe = ee.contextCache;
            let ye, ve;
            for (se && (ye = G(1), ve = [], ge = Math.max(ge, 1)); pe.length < M; ) {
              const ke = se ? U.tableDeltaHeight.decode(he) : y(xe, "IADH", me);
              de += ke;
              let be = 0, we = 0;
              const Le = se ? ve.length : 0;
              for (; ; ) {
                const Re = se ? U.tableDeltaWidth.decode(he) : y(xe, "IADW", me);
                if (Re === null)
                  break;
                be += Re, we += be;
                let ct;
                if (L) {
                  const ft = y(xe, "IAAI", me);
                  if (ft > 1)
                    ct = B(se, L, be, de, 0, ft, 1, W.concat(pe), ge, 0, 0, 1, 0, U, le, ce, ee, 0, he);
                  else {
                    const kt = x(xe, me, ge), We = y(xe, "IARDX", me), jt = y(xe, "IARDY", me), yt = kt < W.length ? W[kt] : pe[kt - W.length];
                    ct = K(be, de, le, yt, We, jt, !1, ce, ee);
                  }
                  pe.push(ct);
                } else se ? ve.push(be) : (ct = $(!1, be, de, Q, !1, null, re, ee), pe.push(ct));
              }
              if (se && !L) {
                const Re = U.tableBitmapSize.decode(he);
                he.byteAlign();
                let ct;
                if (Re === 0)
                  ct = fe(he, we, de);
                else {
                  const kt = he.end, We = he.position + Re;
                  he.end = We, ct = Y(he, we, de, !1), he.end = kt, he.position = We;
                }
                const ft = ve.length;
                if (Le === ft - 1)
                  pe.push(ct);
                else {
                  let kt, We, jt = 0, yt, Ye, mt;
                  for (kt = Le; kt < ft; kt++) {
                    for (Ye = ve[kt], yt = jt + Ye, mt = [], We = 0; We < de; We++)
                      mt.push(ct[We].subarray(jt, yt));
                    pe.push(mt), jt = yt;
                  }
                }
              }
            }
            const Ce = [], Ie = [];
            let Ae = !1, Se, De;
            const Be = W.length + M;
            for (; Ie.length < Be; ) {
              let ke = se ? ye.decode(he) : y(xe, "IAEX", me);
              for (; ke--; )
                Ie.push(Ae);
              Ae = !Ae;
            }
            for (Se = 0, De = W.length; Se < De; Se++)
              Ie[Se] && Ce.push(W[Se]);
            for (let ke = 0; ke < M; Se++, ke++)
              Ie[Se] && Ce.push(pe[ke]);
            return Ce;
          }
          function B(se, L, W, M, X, U, Q, re, le, ce, ee, he, pe, de, ge, me, xe, ye, ve) {
            if (se && L)
              throw new i("refinement with Huffman is not supported");
            const Ce = [];
            let Ie, Ae;
            for (Ie = 0; Ie < M; Ie++) {
              if (Ae = new Uint8Array(W), X)
                for (let be = 0; be < W; be++)
                  Ae[be] = X;
              Ce.push(Ae);
            }
            const Se = xe.decoder, De = xe.contextCache;
            let Be = se ? -de.tableDeltaT.decode(ve) : -y(De, "IADT", Se), ke = 0;
            for (Ie = 0; Ie < U; ) {
              const be = se ? de.tableDeltaT.decode(ve) : y(De, "IADT", Se);
              Be += be;
              const we = se ? de.tableFirstS.decode(ve) : y(De, "IAFS", Se);
              ke += we;
              let Le = ke;
              do {
                let Re = 0;
                Q > 1 && (Re = se ? ve.readBits(ye) : y(De, "IAIT", Se));
                const ct = Q * Be + Re, ft = se ? de.symbolIDTable.decode(ve) : x(De, Se, le), kt = L && (se ? ve.readBit() : y(De, "IARI", Se));
                let We = re[ft], jt = We[0].length, yt = We.length;
                if (kt) {
                  const _e = y(De, "IARDW", Se), Qe = y(De, "IARDH", Se), qe = y(De, "IARDX", Se), Je = y(De, "IARDY", Se);
                  jt += _e, yt += Qe, We = K(jt, yt, ge, We, (_e >> 1) + qe, (Qe >> 1) + Je, !1, me, xe);
                }
                const Ye = ct - (he & 1 ? 0 : yt - 1), mt = Le - (he & 2 ? jt - 1 : 0);
                let Pt, et, tn;
                if (ce) {
                  for (Pt = 0; Pt < yt; Pt++) {
                    if (Ae = Ce[mt + Pt], !Ae)
                      continue;
                    tn = We[Pt];
                    const _e = Math.min(W - Ye, jt);
                    switch (pe) {
                      case 0:
                        for (et = 0; et < _e; et++)
                          Ae[Ye + et] |= tn[et];
                        break;
                      case 2:
                        for (et = 0; et < _e; et++)
                          Ae[Ye + et] ^= tn[et];
                        break;
                      default:
                        throw new i(`operator ${pe} is not supported`);
                    }
                  }
                  Le += yt - 1;
                } else {
                  for (et = 0; et < yt; et++)
                    if (Ae = Ce[Ye + et], !!Ae)
                      switch (tn = We[et], pe) {
                        case 0:
                          for (Pt = 0; Pt < jt; Pt++)
                            Ae[mt + Pt] |= tn[Pt];
                          break;
                        case 2:
                          for (Pt = 0; Pt < jt; Pt++)
                            Ae[mt + Pt] ^= tn[Pt];
                          break;
                        default:
                          throw new i(`operator ${pe} is not supported`);
                      }
                  Le += jt - 1;
                }
                Ie++;
                const Xt = se ? de.tableDeltaS.decode(ve) : y(De, "IADS", Se);
                if (Xt === null)
                  break;
                Le += Xt + ee;
              } while (!0);
            }
            return Ce;
          }
          function R(se, L, W, M, X, U) {
            const Q = [];
            se || (Q.push({
              x: -L,
              y: 0
            }), X === 0 && Q.push({
              x: -3,
              y: -1
            }, {
              x: 2,
              y: -2
            }, {
              x: -2,
              y: -2
            }));
            const re = (M + 1) * L, le = $(se, re, W, X, !1, null, Q, U), ce = [];
            for (let ee = 0; ee <= M; ee++) {
              const he = [], pe = L * ee, de = pe + L;
              for (let ge = 0; ge < W; ge++)
                he.push(le[ge].subarray(pe, de));
              ce.push(he);
            }
            return ce;
          }
          function _(se, L, W, M, X, U, Q, re, le, ce, ee, he, pe, de, ge) {
            if (Q)
              throw new i("skip is not supported");
            if (re !== 0)
              throw new i(`operator "${re}" is not supported in halftone region`);
            const xe = [];
            let ye, ve, Ce;
            for (ye = 0; ye < X; ye++) {
              if (Ce = new Uint8Array(M), U)
                for (ve = 0; ve < M; ve++)
                  Ce[ve] = U;
              xe.push(Ce);
            }
            const Ie = L.length, Ae = L[0], Se = Ae[0].length, De = Ae.length, Be = (0, h.log2)(Ie), ke = [];
            se || (ke.push({
              x: W <= 1 ? 3 : 2,
              y: -1
            }), W === 0 && ke.push({
              x: -3,
              y: -1
            }, {
              x: 2,
              y: -2
            }, {
              x: -2,
              y: -2
            }));
            const be = [];
            let we, Le;
            for (se && (we = new N(ge.data, ge.start, ge.end)), ye = Be - 1; ye >= 0; ye--)
              se ? Le = Y(we, le, ce, !0) : Le = $(!1, le, ce, W, !1, null, ke, ge), be[ye] = Le;
            let Re, ct, ft, kt, We, jt, yt, Ye, mt;
            for (Re = 0; Re < ce; Re++)
              for (ct = 0; ct < le; ct++) {
                for (ft = 0, kt = 0, ve = Be - 1; ve >= 0; ve--)
                  ft ^= be[ve][Re][ct], kt |= ft << ve;
                if (We = L[kt], jt = ee + Re * de + ct * pe >> 8, yt = he + Re * pe - ct * de >> 8, jt >= 0 && jt + Se <= M && yt >= 0 && yt + De <= X)
                  for (ye = 0; ye < De; ye++)
                    for (mt = xe[yt + ye], Ye = We[ye], ve = 0; ve < Se; ve++)
                      mt[jt + ve] |= Ye[ve];
                else {
                  let Pt, et;
                  for (ye = 0; ye < De; ye++)
                    if (et = yt + ye, !(et < 0 || et >= X))
                      for (mt = xe[et], Ye = We[ye], ve = 0; ve < Se; ve++)
                        Pt = jt + ve, Pt >= 0 && Pt < M && (mt[Pt] |= Ye[ve]);
                }
              }
            return xe;
          }
          function A(se, L) {
            const W = {};
            W.number = (0, h.readUint32)(se, L);
            const M = se[L + 4], X = M & 63;
            if (!b[X])
              throw new i("invalid segment type: " + X);
            W.type = X, W.typeName = b[X], W.deferredNonRetain = !!(M & 128);
            const U = !!(M & 64), Q = se[L + 5];
            let re = Q >> 5 & 7;
            const le = [Q & 31];
            let ce = L + 6;
            if (Q === 7) {
              re = (0, h.readUint32)(se, ce - 1) & 536870911, ce += 3;
              let ge = re + 7 >> 3;
              for (le[0] = se[ce++]; --ge > 0; )
                le.push(se[ce++]);
            } else if (Q === 5 || Q === 6)
              throw new i("invalid referred-to flags");
            W.retainBits = le;
            let ee = 4;
            W.number <= 256 ? ee = 1 : W.number <= 65536 && (ee = 2);
            const he = [];
            let pe, de;
            for (pe = 0; pe < re; pe++) {
              let ge;
              ee === 1 ? ge = se[ce] : ee === 2 ? ge = (0, h.readUint16)(se, ce) : ge = (0, h.readUint32)(se, ce), he.push(ge), ce += ee;
            }
            if (W.referredTo = he, U ? (W.pageAssociation = (0, h.readUint32)(se, ce), ce += 4) : W.pageAssociation = se[ce++], W.length = (0, h.readUint32)(se, ce), ce += 4, W.length === 4294967295)
              if (X === 38) {
                const ge = z(se, ce), xe = !!(se[ce + T] & 1), ye = 6, ve = new Uint8Array(ye);
                for (xe || (ve[0] = 255, ve[1] = 172), ve[2] = ge.height >>> 24 & 255, ve[3] = ge.height >> 16 & 255, ve[4] = ge.height >> 8 & 255, ve[5] = ge.height & 255, pe = ce, de = se.length; pe < de; pe++) {
                  let Ce = 0;
                  for (; Ce < ye && ve[Ce] === se[pe + Ce]; )
                    Ce++;
                  if (Ce === ye) {
                    W.length = pe + ye;
                    break;
                  }
                }
                if (W.length === 4294967295)
                  throw new i("segment end was not found");
              } else
                throw new i("invalid unknown segment length");
            return W.headerEnd = ce, W;
          }
          function k(se, L, W, M) {
            const X = [];
            let U = W;
            for (; U < M; ) {
              const Q = A(L, U);
              U = Q.headerEnd;
              const re = {
                header: Q,
                data: L
              };
              if (se.randomAccess || (re.start = U, U += Q.length, re.end = U), X.push(re), Q.type === 51)
                break;
            }
            if (se.randomAccess)
              for (let Q = 0, re = X.length; Q < re; Q++)
                X[Q].start = U, U += X[Q].header.length, X[Q].end = U;
            return X;
          }
          function z(se, L) {
            return {
              width: (0, h.readUint32)(se, L),
              height: (0, h.readUint32)(se, L + 4),
              x: (0, h.readUint32)(se, L + 8),
              y: (0, h.readUint32)(se, L + 12),
              combinationOperator: se[L + 16] & 7
            };
          }
          const T = 17;
          function w(se, L) {
            const W = se.header, M = se.data, X = se.end;
            let U = se.start, Q, re, le, ce;
            switch (W.type) {
              case 0:
                const he = {}, pe = (0, h.readUint16)(M, U);
                if (he.huffman = !!(pe & 1), he.refinement = !!(pe & 2), he.huffmanDHSelector = pe >> 2 & 3, he.huffmanDWSelector = pe >> 4 & 3, he.bitmapSizeSelector = pe >> 6 & 1, he.aggregationInstancesSelector = pe >> 7 & 1, he.bitmapCodingContextUsed = !!(pe & 256), he.bitmapCodingContextRetained = !!(pe & 512), he.template = pe >> 10 & 3, he.refinementTemplate = pe >> 12 & 1, U += 2, !he.huffman) {
                  for (ce = he.template === 0 ? 4 : 1, re = [], le = 0; le < ce; le++)
                    re.push({
                      x: (0, h.readInt8)(M, U),
                      y: (0, h.readInt8)(M, U + 1)
                    }), U += 2;
                  he.at = re;
                }
                if (he.refinement && !he.refinementTemplate) {
                  for (re = [], le = 0; le < 2; le++)
                    re.push({
                      x: (0, h.readInt8)(M, U),
                      y: (0, h.readInt8)(M, U + 1)
                    }), U += 2;
                  he.refinementAt = re;
                }
                he.numberOfExportedSymbols = (0, h.readUint32)(M, U), U += 4, he.numberOfNewSymbols = (0, h.readUint32)(M, U), U += 4, Q = [he, W.number, W.referredTo, M, U, X];
                break;
              case 6:
              case 7:
                const de = {};
                de.info = z(M, U), U += T;
                const ge = (0, h.readUint16)(M, U);
                if (U += 2, de.huffman = !!(ge & 1), de.refinement = !!(ge & 2), de.logStripSize = ge >> 2 & 3, de.stripSize = 1 << de.logStripSize, de.referenceCorner = ge >> 4 & 3, de.transposed = !!(ge & 64), de.combinationOperator = ge >> 7 & 3, de.defaultPixelValue = ge >> 9 & 1, de.dsOffset = ge << 17 >> 27, de.refinementTemplate = ge >> 15 & 1, de.huffman) {
                  const De = (0, h.readUint16)(M, U);
                  U += 2, de.huffmanFS = De & 3, de.huffmanDS = De >> 2 & 3, de.huffmanDT = De >> 4 & 3, de.huffmanRefinementDW = De >> 6 & 3, de.huffmanRefinementDH = De >> 8 & 3, de.huffmanRefinementDX = De >> 10 & 3, de.huffmanRefinementDY = De >> 12 & 3, de.huffmanRefinementSizeSelector = !!(De & 16384);
                }
                if (de.refinement && !de.refinementTemplate) {
                  for (re = [], le = 0; le < 2; le++)
                    re.push({
                      x: (0, h.readInt8)(M, U),
                      y: (0, h.readInt8)(M, U + 1)
                    }), U += 2;
                  de.refinementAt = re;
                }
                de.numberOfSymbolInstances = (0, h.readUint32)(M, U), U += 4, Q = [de, W.referredTo, M, U, X];
                break;
              case 16:
                const me = {}, xe = M[U++];
                me.mmr = !!(xe & 1), me.template = xe >> 1 & 3, me.patternWidth = M[U++], me.patternHeight = M[U++], me.maxPatternIndex = (0, h.readUint32)(M, U), U += 4, Q = [me, W.number, M, U, X];
                break;
              case 22:
              case 23:
                const ye = {};
                ye.info = z(M, U), U += T;
                const ve = M[U++];
                ye.mmr = !!(ve & 1), ye.template = ve >> 1 & 3, ye.enableSkip = !!(ve & 8), ye.combinationOperator = ve >> 4 & 7, ye.defaultPixelValue = ve >> 7 & 1, ye.gridWidth = (0, h.readUint32)(M, U), U += 4, ye.gridHeight = (0, h.readUint32)(M, U), U += 4, ye.gridOffsetX = (0, h.readUint32)(M, U) & 4294967295, U += 4, ye.gridOffsetY = (0, h.readUint32)(M, U) & 4294967295, U += 4, ye.gridVectorX = (0, h.readUint16)(M, U), U += 2, ye.gridVectorY = (0, h.readUint16)(M, U), U += 2, Q = [ye, W.referredTo, M, U, X];
                break;
              case 38:
              case 39:
                const Ce = {};
                Ce.info = z(M, U), U += T;
                const Ie = M[U++];
                if (Ce.mmr = !!(Ie & 1), Ce.template = Ie >> 1 & 3, Ce.prediction = !!(Ie & 8), !Ce.mmr) {
                  for (ce = Ce.template === 0 ? 4 : 1, re = [], le = 0; le < ce; le++)
                    re.push({
                      x: (0, h.readInt8)(M, U),
                      y: (0, h.readInt8)(M, U + 1)
                    }), U += 2;
                  Ce.at = re;
                }
                Q = [Ce, M, U, X];
                break;
              case 48:
                const Ae = {
                  width: (0, h.readUint32)(M, U),
                  height: (0, h.readUint32)(M, U + 4),
                  resolutionX: (0, h.readUint32)(M, U + 8),
                  resolutionY: (0, h.readUint32)(M, U + 12)
                };
                Ae.height === 4294967295 && delete Ae.height;
                const Se = M[U + 16];
                (0, h.readUint16)(M, U + 17), Ae.lossless = !!(Se & 1), Ae.refinement = !!(Se & 2), Ae.defaultPixelValue = Se >> 2 & 1, Ae.combinationOperator = Se >> 3 & 3, Ae.requiresBuffer = !!(Se & 32), Ae.combinationOperatorOverride = !!(Se & 64), Q = [Ae];
                break;
              case 49:
                break;
              case 50:
                break;
              case 51:
                break;
              case 53:
                Q = [W.number, M, U, X];
                break;
              case 62:
                break;
              default:
                throw new i(`segment type ${W.typeName}(${W.type}) is not implemented`);
            }
            const ee = "on" + W.typeName;
            ee in L && L[ee].apply(L, Q);
          }
          function F(se, L) {
            for (let W = 0, M = se.length; W < M; W++)
              w(se[W], L);
          }
          function j(se) {
            const L = new P();
            for (let W = 0, M = se.length; W < M; W++) {
              const X = se[W], U = k({}, X.data, X.start, X.end);
              F(U, L);
            }
            return L.buffer;
          }
          class P {
            onPageInformation(L) {
              this.currentPageInfo = L;
              const W = L.width + 7 >> 3, M = new Uint8ClampedArray(W * L.height);
              L.defaultPixelValue && M.fill(255), this.buffer = M;
            }
            drawBitmap(L, W) {
              const M = this.currentPageInfo, X = L.width, U = L.height, Q = M.width + 7 >> 3, re = M.combinationOperatorOverride ? L.combinationOperator : M.combinationOperator, le = this.buffer, ce = 128 >> (L.x & 7);
              let ee = L.y * Q + (L.x >> 3), he, pe, de, ge;
              switch (re) {
                case 0:
                  for (he = 0; he < U; he++) {
                    for (de = ce, ge = ee, pe = 0; pe < X; pe++)
                      W[he][pe] && (le[ge] |= de), de >>= 1, de || (de = 128, ge++);
                    ee += Q;
                  }
                  break;
                case 2:
                  for (he = 0; he < U; he++) {
                    for (de = ce, ge = ee, pe = 0; pe < X; pe++)
                      W[he][pe] && (le[ge] ^= de), de >>= 1, de || (de = 128, ge++);
                    ee += Q;
                  }
                  break;
                default:
                  throw new i(`operator ${re} is not supported`);
              }
            }
            onImmediateGenericRegion(L, W, M, X) {
              const U = L.info, Q = new v(W, M, X), re = $(L.mmr, U.width, U.height, L.template, L.prediction, null, L.at, Q);
              this.drawBitmap(U, re);
            }
            onImmediateLosslessGenericRegion() {
              this.onImmediateGenericRegion(...arguments);
            }
            onSymbolDictionary(L, W, M, X, U, Q) {
              let re, le;
              L.huffman && (re = oe(L, M, this.customTables), le = new N(X, U, Q));
              let ce = this.symbols;
              ce || (this.symbols = ce = {});
              const ee = [];
              for (const pe of M) {
                const de = ce[pe];
                de && ee.push(...de);
              }
              const he = new v(X, U, Q);
              ce[W] = H(L.huffman, L.refinement, ee, L.numberOfNewSymbols, L.numberOfExportedSymbols, re, L.template, L.at, L.refinementTemplate, L.refinementAt, he, le);
            }
            onImmediateTextRegion(L, W, M, X, U) {
              const Q = L.info;
              let re, le;
              const ce = this.symbols, ee = [];
              for (const ge of W) {
                const me = ce[ge];
                me && ee.push(...me);
              }
              const he = (0, h.log2)(ee.length);
              L.huffman && (le = new N(M, X, U), re = ie(L, W, this.customTables, ee.length, le));
              const pe = new v(M, X, U), de = B(L.huffman, L.refinement, Q.width, Q.height, L.defaultPixelValue, L.numberOfSymbolInstances, L.stripSize, ee, he, L.transposed, L.dsOffset, L.referenceCorner, L.combinationOperator, re, L.refinementTemplate, L.refinementAt, pe, L.logStripSize, le);
              this.drawBitmap(Q, de);
            }
            onImmediateLosslessTextRegion() {
              this.onImmediateTextRegion(...arguments);
            }
            onPatternDictionary(L, W, M, X, U) {
              let Q = this.patterns;
              Q || (this.patterns = Q = {});
              const re = new v(M, X, U);
              Q[W] = R(L.mmr, L.patternWidth, L.patternHeight, L.maxPatternIndex, L.template, re);
            }
            onImmediateHalftoneRegion(L, W, M, X, U) {
              const Q = this.patterns[W[0]], re = L.info, le = new v(M, X, U), ce = _(L.mmr, Q, L.template, re.width, re.height, L.defaultPixelValue, L.enableSkip, L.combinationOperator, L.gridWidth, L.gridHeight, L.gridOffsetX, L.gridOffsetY, L.gridVectorX, L.gridVectorY, le);
              this.drawBitmap(re, ce);
            }
            onImmediateLosslessHalftoneRegion() {
              this.onImmediateHalftoneRegion(...arguments);
            }
            onTables(L, W, M, X) {
              let U = this.customTables;
              U || (this.customTables = U = {}), U[L] = Z(W, M, X);
            }
          }
          class V {
            constructor(L) {
              L.length === 2 ? (this.isOOB = !0, this.rangeLow = 0, this.prefixLength = L[0], this.rangeLength = 0, this.prefixCode = L[1], this.isLowerRange = !1) : (this.isOOB = !1, this.rangeLow = L[0], this.prefixLength = L[1], this.rangeLength = L[2], this.prefixCode = L[3], this.isLowerRange = L[4] === "lower");
            }
          }
          class J {
            constructor(L) {
              this.children = [], L ? (this.isLeaf = !0, this.rangeLength = L.rangeLength, this.rangeLow = L.rangeLow, this.isLowerRange = L.isLowerRange, this.isOOB = L.isOOB) : this.isLeaf = !1;
            }
            buildTree(L, W) {
              const M = L.prefixCode >> W & 1;
              if (W <= 0)
                this.children[M] = new J(L);
              else {
                let X = this.children[M];
                X || (this.children[M] = X = new J(null)), X.buildTree(L, W - 1);
              }
            }
            decodeNode(L) {
              if (this.isLeaf) {
                if (this.isOOB)
                  return null;
                const M = L.readBits(this.rangeLength);
                return this.rangeLow + (this.isLowerRange ? -M : M);
              }
              const W = this.children[L.readBit()];
              if (!W)
                throw new i("invalid Huffman data");
              return W.decodeNode(L);
            }
          }
          class ne {
            constructor(L, W) {
              W || this.assignPrefixCodes(L), this.rootNode = new J(null);
              for (let M = 0, X = L.length; M < X; M++) {
                const U = L[M];
                U.prefixLength > 0 && this.rootNode.buildTree(U, U.prefixLength - 1);
              }
            }
            decode(L) {
              return this.rootNode.decodeNode(L);
            }
            assignPrefixCodes(L) {
              const W = L.length;
              let M = 0;
              for (let ee = 0; ee < W; ee++)
                M = Math.max(M, L[ee].prefixLength);
              const X = new Uint32Array(M + 1);
              for (let ee = 0; ee < W; ee++)
                X[L[ee].prefixLength]++;
              let U = 1, Q = 0, re, le, ce;
              for (X[0] = 0; U <= M; ) {
                for (Q = Q + X[U - 1] << 1, re = Q, le = 0; le < W; )
                  ce = L[le], ce.prefixLength === U && (ce.prefixCode = re, re++), le++;
                U++;
              }
            }
          }
          function Z(se, L, W) {
            const M = se[L], X = (0, h.readUint32)(se, L + 1) & 4294967295, U = (0, h.readUint32)(se, L + 5) & 4294967295, Q = new N(se, L + 9, W), re = (M >> 1 & 7) + 1, le = (M >> 4 & 7) + 1, ce = [];
            let ee, he, pe = X;
            do
              ee = Q.readBits(re), he = Q.readBits(le), ce.push(new V([pe, ee, he, 0])), pe += 1 << he;
            while (pe < U);
            return ee = Q.readBits(re), ce.push(new V([X - 1, ee, 32, 0, "lower"])), ee = Q.readBits(re), ce.push(new V([U, ee, 32, 0])), M & 1 && (ee = Q.readBits(re), ce.push(new V([ee, 0]))), new ne(ce, !1);
          }
          const te = {};
          function G(se) {
            let L = te[se];
            if (L)
              return L;
            let W;
            switch (se) {
              case 1:
                W = [[0, 1, 4, 0], [16, 2, 8, 2], [272, 3, 16, 6], [65808, 3, 32, 7]];
                break;
              case 2:
                W = [[0, 1, 0, 0], [1, 2, 0, 2], [2, 3, 0, 6], [3, 4, 3, 14], [11, 5, 6, 30], [75, 6, 32, 62], [6, 63]];
                break;
              case 3:
                W = [[-256, 8, 8, 254], [0, 1, 0, 0], [1, 2, 0, 2], [2, 3, 0, 6], [3, 4, 3, 14], [11, 5, 6, 30], [-257, 8, 32, 255, "lower"], [75, 7, 32, 126], [6, 62]];
                break;
              case 4:
                W = [[1, 1, 0, 0], [2, 2, 0, 2], [3, 3, 0, 6], [4, 4, 3, 14], [12, 5, 6, 30], [76, 5, 32, 31]];
                break;
              case 5:
                W = [[-255, 7, 8, 126], [1, 1, 0, 0], [2, 2, 0, 2], [3, 3, 0, 6], [4, 4, 3, 14], [12, 5, 6, 30], [-256, 7, 32, 127, "lower"], [76, 6, 32, 62]];
                break;
              case 6:
                W = [[-2048, 5, 10, 28], [-1024, 4, 9, 8], [-512, 4, 8, 9], [-256, 4, 7, 10], [-128, 5, 6, 29], [-64, 5, 5, 30], [-32, 4, 5, 11], [0, 2, 7, 0], [128, 3, 7, 2], [256, 3, 8, 3], [512, 4, 9, 12], [1024, 4, 10, 13], [-2049, 6, 32, 62, "lower"], [2048, 6, 32, 63]];
                break;
              case 7:
                W = [[-1024, 4, 9, 8], [-512, 3, 8, 0], [-256, 4, 7, 9], [-128, 5, 6, 26], [-64, 5, 5, 27], [-32, 4, 5, 10], [0, 4, 5, 11], [32, 5, 5, 28], [64, 5, 6, 29], [128, 4, 7, 12], [256, 3, 8, 1], [512, 3, 9, 2], [1024, 3, 10, 3], [-1025, 5, 32, 30, "lower"], [2048, 5, 32, 31]];
                break;
              case 8:
                W = [[-15, 8, 3, 252], [-7, 9, 1, 508], [-5, 8, 1, 253], [-3, 9, 0, 509], [-2, 7, 0, 124], [-1, 4, 0, 10], [0, 2, 1, 0], [2, 5, 0, 26], [3, 6, 0, 58], [4, 3, 4, 4], [20, 6, 1, 59], [22, 4, 4, 11], [38, 4, 5, 12], [70, 5, 6, 27], [134, 5, 7, 28], [262, 6, 7, 60], [390, 7, 8, 125], [646, 6, 10, 61], [-16, 9, 32, 510, "lower"], [1670, 9, 32, 511], [2, 1]];
                break;
              case 9:
                W = [[-31, 8, 4, 252], [-15, 9, 2, 508], [-11, 8, 2, 253], [-7, 9, 1, 509], [-5, 7, 1, 124], [-3, 4, 1, 10], [-1, 3, 1, 2], [1, 3, 1, 3], [3, 5, 1, 26], [5, 6, 1, 58], [7, 3, 5, 4], [39, 6, 2, 59], [43, 4, 5, 11], [75, 4, 6, 12], [139, 5, 7, 27], [267, 5, 8, 28], [523, 6, 8, 60], [779, 7, 9, 125], [1291, 6, 11, 61], [-32, 9, 32, 510, "lower"], [3339, 9, 32, 511], [2, 0]];
                break;
              case 10:
                W = [[-21, 7, 4, 122], [-5, 8, 0, 252], [-4, 7, 0, 123], [-3, 5, 0, 24], [-2, 2, 2, 0], [2, 5, 0, 25], [3, 6, 0, 54], [4, 7, 0, 124], [5, 8, 0, 253], [6, 2, 6, 1], [70, 5, 5, 26], [102, 6, 5, 55], [134, 6, 6, 56], [198, 6, 7, 57], [326, 6, 8, 58], [582, 6, 9, 59], [1094, 6, 10, 60], [2118, 7, 11, 125], [-22, 8, 32, 254, "lower"], [4166, 8, 32, 255], [2, 2]];
                break;
              case 11:
                W = [[1, 1, 0, 0], [2, 2, 1, 2], [4, 4, 0, 12], [5, 4, 1, 13], [7, 5, 1, 28], [9, 5, 2, 29], [13, 6, 2, 60], [17, 7, 2, 122], [21, 7, 3, 123], [29, 7, 4, 124], [45, 7, 5, 125], [77, 7, 6, 126], [141, 7, 32, 127]];
                break;
              case 12:
                W = [[1, 1, 0, 0], [2, 2, 0, 2], [3, 3, 1, 6], [5, 5, 0, 28], [6, 5, 1, 29], [8, 6, 1, 60], [10, 7, 0, 122], [11, 7, 1, 123], [13, 7, 2, 124], [17, 7, 3, 125], [25, 7, 4, 126], [41, 8, 5, 254], [73, 8, 32, 255]];
                break;
              case 13:
                W = [[1, 1, 0, 0], [2, 3, 0, 4], [3, 4, 0, 12], [4, 5, 0, 28], [5, 4, 1, 13], [7, 3, 3, 5], [15, 6, 1, 58], [17, 6, 2, 59], [21, 6, 3, 60], [29, 6, 4, 61], [45, 6, 5, 62], [77, 7, 6, 126], [141, 7, 32, 127]];
                break;
              case 14:
                W = [[-2, 3, 0, 4], [-1, 3, 0, 5], [0, 1, 0, 0], [1, 3, 0, 6], [2, 3, 0, 7]];
                break;
              case 15:
                W = [[-24, 7, 4, 124], [-8, 6, 2, 60], [-4, 5, 1, 28], [-2, 4, 0, 12], [-1, 3, 0, 4], [0, 1, 0, 0], [1, 3, 0, 5], [2, 4, 0, 13], [3, 5, 1, 29], [5, 6, 2, 61], [9, 7, 4, 125], [-25, 7, 32, 126, "lower"], [25, 7, 32, 127]];
                break;
              default:
                throw new i(`standard table B.${se} does not exist`);
            }
            for (let M = 0, X = W.length; M < X; M++)
              W[M] = new V(W[M]);
            return L = new ne(W, !0), te[se] = L, L;
          }
          class N {
            constructor(L, W, M) {
              this.data = L, this.start = W, this.end = M, this.position = W, this.shift = -1, this.currentByte = 0;
            }
            readBit() {
              if (this.shift < 0) {
                if (this.position >= this.end)
                  throw new i("end of data while reading bit");
                this.currentByte = this.data[this.position++], this.shift = 7;
              }
              const L = this.currentByte >> this.shift & 1;
              return this.shift--, L;
            }
            readBits(L) {
              let W = 0, M;
              for (M = L - 1; M >= 0; M--)
                W |= this.readBit() << M;
              return W;
            }
            byteAlign() {
              this.shift = -1;
            }
            next() {
              return this.position >= this.end ? -1 : this.data[this.position++];
            }
          }
          function q(se, L, W) {
            let M = 0;
            for (let X = 0, U = L.length; X < U; X++) {
              const Q = W[L[X]];
              if (Q) {
                if (se === M)
                  return Q;
                M++;
              }
            }
            throw new i("can't find custom Huffman table");
          }
          function ie(se, L, W, M, X) {
            const U = [];
            for (let pe = 0; pe <= 34; pe++) {
              const de = X.readBits(4);
              U.push(new V([pe, de, 0, 0]));
            }
            const Q = new ne(U, !1);
            U.length = 0;
            for (let pe = 0; pe < M; ) {
              const de = Q.decode(X);
              if (de >= 32) {
                let ge, me, xe;
                switch (de) {
                  case 32:
                    if (pe === 0)
                      throw new i("no previous value in symbol ID table");
                    me = X.readBits(2) + 3, ge = U[pe - 1].prefixLength;
                    break;
                  case 33:
                    me = X.readBits(3) + 3, ge = 0;
                    break;
                  case 34:
                    me = X.readBits(7) + 11, ge = 0;
                    break;
                  default:
                    throw new i("invalid code length in symbol ID table");
                }
                for (xe = 0; xe < me; xe++)
                  U.push(new V([pe, ge, 0, 0])), pe++;
              } else
                U.push(new V([pe, de, 0, 0])), pe++;
            }
            X.byteAlign();
            const re = new ne(U, !1);
            let le = 0, ce, ee, he;
            switch (se.huffmanFS) {
              case 0:
              case 1:
                ce = G(se.huffmanFS + 6);
                break;
              case 3:
                ce = q(le, L, W), le++;
                break;
              default:
                throw new i("invalid Huffman FS selector");
            }
            switch (se.huffmanDS) {
              case 0:
              case 1:
              case 2:
                ee = G(se.huffmanDS + 8);
                break;
              case 3:
                ee = q(le, L, W), le++;
                break;
              default:
                throw new i("invalid Huffman DS selector");
            }
            switch (se.huffmanDT) {
              case 0:
              case 1:
              case 2:
                he = G(se.huffmanDT + 11);
                break;
              case 3:
                he = q(le, L, W), le++;
                break;
              default:
                throw new i("invalid Huffman DT selector");
            }
            if (se.refinement)
              throw new i("refinement with Huffman is not supported");
            return {
              symbolIDTable: re,
              tableFirstS: ce,
              tableDeltaS: ee,
              tableDeltaT: he
            };
          }
          function oe(se, L, W) {
            let M = 0, X, U;
            switch (se.huffmanDHSelector) {
              case 0:
              case 1:
                X = G(se.huffmanDHSelector + 4);
                break;
              case 3:
                X = q(M, L, W), M++;
                break;
              default:
                throw new i("invalid Huffman DH selector");
            }
            switch (se.huffmanDWSelector) {
              case 0:
              case 1:
                U = G(se.huffmanDWSelector + 2);
                break;
              case 3:
                U = q(M, L, W), M++;
                break;
              default:
                throw new i("invalid Huffman DW selector");
            }
            let Q, re;
            return se.bitmapSizeSelector ? (Q = q(M, L, W), M++) : Q = G(1), se.aggregationInstancesSelector ? re = q(M, L, W) : re = G(1), {
              tableDeltaHeight: X,
              tableDeltaWidth: U,
              tableBitmapSize: Q,
              tableAggregateInstances: re
            };
          }
          function fe(se, L, W) {
            const M = [];
            for (let X = 0; X < W; X++) {
              const U = new Uint8Array(L);
              M.push(U);
              for (let Q = 0; Q < L; Q++)
                U[Q] = se.readBit();
              se.byteAlign();
            }
            return M;
          }
          function Y(se, L, W, M) {
            const X = {
              K: -1,
              Columns: L,
              Rows: W,
              BlackIs1: !0,
              EndOfBlock: M
            }, U = new t.CCITTFaxDecoder(se, X), Q = [];
            let re, le = !1;
            for (let ce = 0; ce < W; ce++) {
              const ee = new Uint8Array(L);
              Q.push(ee);
              let he = -1;
              for (let pe = 0; pe < L; pe++)
                he < 0 && (re = U.readNextChar(), re === -1 && (re = 0, le = !0), he = 7), ee[pe] = re >> he & 1, he--;
            }
            if (M && !le)
              for (let ee = 0; ee < 5 && U.readNextChar() !== -1; ee++)
                ;
            return Q;
          }
          class ae {
            parseChunks(L) {
              return j(L);
            }
            parse(L) {
              throw new Error("Not implemented: Jbig2Image.parse");
            }
          }
          c.Jbig2Image = ae;
        },
        /* 25 */
        /***/
        (d, c) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.ArithmeticDecoder = void 0;
          const f = [{
            qe: 22017,
            nmps: 1,
            nlps: 1,
            switchFlag: 1
          }, {
            qe: 13313,
            nmps: 2,
            nlps: 6,
            switchFlag: 0
          }, {
            qe: 6145,
            nmps: 3,
            nlps: 9,
            switchFlag: 0
          }, {
            qe: 2753,
            nmps: 4,
            nlps: 12,
            switchFlag: 0
          }, {
            qe: 1313,
            nmps: 5,
            nlps: 29,
            switchFlag: 0
          }, {
            qe: 545,
            nmps: 38,
            nlps: 33,
            switchFlag: 0
          }, {
            qe: 22017,
            nmps: 7,
            nlps: 6,
            switchFlag: 1
          }, {
            qe: 21505,
            nmps: 8,
            nlps: 14,
            switchFlag: 0
          }, {
            qe: 18433,
            nmps: 9,
            nlps: 14,
            switchFlag: 0
          }, {
            qe: 14337,
            nmps: 10,
            nlps: 14,
            switchFlag: 0
          }, {
            qe: 12289,
            nmps: 11,
            nlps: 17,
            switchFlag: 0
          }, {
            qe: 9217,
            nmps: 12,
            nlps: 18,
            switchFlag: 0
          }, {
            qe: 7169,
            nmps: 13,
            nlps: 20,
            switchFlag: 0
          }, {
            qe: 5633,
            nmps: 29,
            nlps: 21,
            switchFlag: 0
          }, {
            qe: 22017,
            nmps: 15,
            nlps: 14,
            switchFlag: 1
          }, {
            qe: 21505,
            nmps: 16,
            nlps: 14,
            switchFlag: 0
          }, {
            qe: 20737,
            nmps: 17,
            nlps: 15,
            switchFlag: 0
          }, {
            qe: 18433,
            nmps: 18,
            nlps: 16,
            switchFlag: 0
          }, {
            qe: 14337,
            nmps: 19,
            nlps: 17,
            switchFlag: 0
          }, {
            qe: 13313,
            nmps: 20,
            nlps: 18,
            switchFlag: 0
          }, {
            qe: 12289,
            nmps: 21,
            nlps: 19,
            switchFlag: 0
          }, {
            qe: 10241,
            nmps: 22,
            nlps: 19,
            switchFlag: 0
          }, {
            qe: 9217,
            nmps: 23,
            nlps: 20,
            switchFlag: 0
          }, {
            qe: 8705,
            nmps: 24,
            nlps: 21,
            switchFlag: 0
          }, {
            qe: 7169,
            nmps: 25,
            nlps: 22,
            switchFlag: 0
          }, {
            qe: 6145,
            nmps: 26,
            nlps: 23,
            switchFlag: 0
          }, {
            qe: 5633,
            nmps: 27,
            nlps: 24,
            switchFlag: 0
          }, {
            qe: 5121,
            nmps: 28,
            nlps: 25,
            switchFlag: 0
          }, {
            qe: 4609,
            nmps: 29,
            nlps: 26,
            switchFlag: 0
          }, {
            qe: 4353,
            nmps: 30,
            nlps: 27,
            switchFlag: 0
          }, {
            qe: 2753,
            nmps: 31,
            nlps: 28,
            switchFlag: 0
          }, {
            qe: 2497,
            nmps: 32,
            nlps: 29,
            switchFlag: 0
          }, {
            qe: 2209,
            nmps: 33,
            nlps: 30,
            switchFlag: 0
          }, {
            qe: 1313,
            nmps: 34,
            nlps: 31,
            switchFlag: 0
          }, {
            qe: 1089,
            nmps: 35,
            nlps: 32,
            switchFlag: 0
          }, {
            qe: 673,
            nmps: 36,
            nlps: 33,
            switchFlag: 0
          }, {
            qe: 545,
            nmps: 37,
            nlps: 34,
            switchFlag: 0
          }, {
            qe: 321,
            nmps: 38,
            nlps: 35,
            switchFlag: 0
          }, {
            qe: 273,
            nmps: 39,
            nlps: 36,
            switchFlag: 0
          }, {
            qe: 133,
            nmps: 40,
            nlps: 37,
            switchFlag: 0
          }, {
            qe: 73,
            nmps: 41,
            nlps: 38,
            switchFlag: 0
          }, {
            qe: 37,
            nmps: 42,
            nlps: 39,
            switchFlag: 0
          }, {
            qe: 21,
            nmps: 43,
            nlps: 40,
            switchFlag: 0
          }, {
            qe: 9,
            nmps: 44,
            nlps: 41,
            switchFlag: 0
          }, {
            qe: 5,
            nmps: 45,
            nlps: 42,
            switchFlag: 0
          }, {
            qe: 1,
            nmps: 45,
            nlps: 43,
            switchFlag: 0
          }, {
            qe: 22017,
            nmps: 46,
            nlps: 46,
            switchFlag: 0
          }];
          class s {
            constructor(g, t, i) {
              this.data = g, this.bp = t, this.dataEnd = i, this.chigh = g[t], this.clow = 0, this.byteIn(), this.chigh = this.chigh << 7 & 65535 | this.clow >> 9 & 127, this.clow = this.clow << 7 & 65535, this.ct -= 7, this.a = 32768;
            }
            byteIn() {
              const g = this.data;
              let t = this.bp;
              g[t] === 255 ? g[t + 1] > 143 ? (this.clow += 65280, this.ct = 8) : (t++, this.clow += g[t] << 9, this.ct = 7, this.bp = t) : (t++, this.clow += t < this.dataEnd ? g[t] << 8 : 65280, this.ct = 8, this.bp = t), this.clow > 65535 && (this.chigh += this.clow >> 16, this.clow &= 65535);
            }
            readBit(g, t) {
              let i = g[t] >> 1, m = g[t] & 1;
              const v = f[i], E = v.qe;
              let S, y = this.a - E;
              if (this.chigh < E)
                y < E ? (y = E, S = m, i = v.nmps) : (y = E, S = 1 ^ m, v.switchFlag === 1 && (m = S), i = v.nlps);
              else {
                if (this.chigh -= E, y & 32768)
                  return this.a = y, m;
                y < E ? (S = 1 ^ m, v.switchFlag === 1 && (m = S), i = v.nlps) : (S = m, i = v.nmps);
              }
              do
                this.ct === 0 && this.byteIn(), y <<= 1, this.chigh = this.chigh << 1 & 65535 | this.clow >> 15 & 1, this.clow = this.clow << 1 & 65535, this.ct--;
              while (!(y & 32768));
              return this.a = y, g[t] = i << 1 | m, S;
            }
          }
          c.ArithmeticDecoder = s;
        },
        /* 26 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.JpegStream = void 0;
          var s = f(18), h = f(4), g = f(27), t = f(2);
          class i extends s.DecodeStream {
            constructor(v, E, S) {
              let y;
              for (; (y = v.getByte()) !== -1; )
                if (y === 255) {
                  v.skip(-1);
                  break;
                }
              super(E), this.stream = v, this.dict = v.dict, this.maybeLength = E, this.params = S;
            }
            get bytes() {
              return (0, t.shadow)(this, "bytes", this.stream.getBytes(this.maybeLength));
            }
            ensureBuffer(v) {
            }
            readBlock() {
              if (this.eof)
                return;
              const v = {
                decodeTransform: void 0,
                colorTransform: void 0
              }, E = this.dict.getArray("D", "Decode");
              if ((this.forceRGBA || this.forceRGB) && Array.isArray(E)) {
                const x = this.dict.get("BPC", "BitsPerComponent") || 8, b = E.length, u = new Int32Array(b);
                let I = !1;
                const O = (1 << x) - 1;
                for (let D = 0; D < b; D += 2)
                  u[D] = (E[D + 1] - E[D]) * 256 | 0, u[D + 1] = E[D] * O | 0, (u[D] !== 256 || u[D + 1] !== 0) && (I = !0);
                I && (v.decodeTransform = u);
              }
              if (this.params instanceof h.Dict) {
                const x = this.params.get("ColorTransform");
                Number.isInteger(x) && (v.colorTransform = x);
              }
              const S = new g.JpegImage(v);
              S.parse(this.bytes);
              const y = S.getData({
                width: this.drawWidth,
                height: this.drawHeight,
                forceRGBA: this.forceRGBA,
                forceRGB: this.forceRGB,
                isSourcePDF: !0
              });
              this.buffer = y, this.bufferLength = y.length, this.eof = !0;
            }
          }
          c.JpegStream = i;
        },
        /* 27 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.JpegImage = void 0;
          var s = f(2), h = f(28), g = f(3);
          class t extends s.BaseException {
            constructor(k) {
              super(`JPEG error: ${k}`, "JpegError");
            }
          }
          class i extends s.BaseException {
            constructor(k, z) {
              super(k, "DNLMarkerError"), this.scanLines = z;
            }
          }
          class m extends s.BaseException {
            constructor(k) {
              super(k, "EOIMarkerError");
            }
          }
          const v = new Uint8Array([0, 1, 8, 16, 9, 2, 3, 10, 17, 24, 32, 25, 18, 11, 4, 5, 12, 19, 26, 33, 40, 48, 41, 34, 27, 20, 13, 6, 7, 14, 21, 28, 35, 42, 49, 56, 57, 50, 43, 36, 29, 22, 15, 23, 30, 37, 44, 51, 58, 59, 52, 45, 38, 31, 39, 46, 53, 60, 61, 54, 47, 55, 62, 63]), E = 4017, S = 799, y = 3406, x = 2276, b = 1567, u = 3784, I = 5793, O = 2896;
          function D(A, k) {
            let z = 0, T, w, F = 16;
            for (; F > 0 && !A[F - 1]; )
              F--;
            const j = [{
              children: [],
              index: 0
            }];
            let P = j[0], V;
            for (T = 0; T < F; T++) {
              for (w = 0; w < A[T]; w++) {
                for (P = j.pop(), P.children[P.index] = k[z]; P.index > 0; )
                  P = j.pop();
                for (P.index++, j.push(P); j.length <= T; )
                  j.push(V = {
                    children: [],
                    index: 0
                  }), P.children[P.index] = V.children, P = V;
                z++;
              }
              T + 1 < F && (j.push(V = {
                children: [],
                index: 0
              }), P.children[P.index] = V.children, P = V);
            }
            return j[0].children;
          }
          function $(A, k, z) {
            return 64 * ((A.blocksPerLine + 1) * k + z);
          }
          function K(A, k, z, T, w, F, j, P, V, J = !1) {
            const ne = z.mcusPerLine, Z = z.progressive, te = k;
            let G = 0, N = 0;
            function q() {
              if (N > 0)
                return N--, G >> N & 1;
              if (G = A[k++], G === 255) {
                const Ae = A[k++];
                if (Ae) {
                  if (Ae === 220 && J) {
                    k += 2;
                    const Se = (0, g.readUint16)(A, k);
                    if (k += 2, Se > 0 && Se !== z.scanLines)
                      throw new i("Found DNL marker (0xFFDC) while parsing scan data", Se);
                  } else if (Ae === 217) {
                    if (J) {
                      const Se = Q * (z.precision === 8 ? 8 : 0);
                      if (Se > 0 && Math.round(z.scanLines / Se) >= 5)
                        throw new i("Found EOI marker (0xFFD9) while parsing scan data, possibly caused by incorrect `scanLines` parameter", Se);
                    }
                    throw new m("Found EOI marker (0xFFD9) while parsing scan data");
                  }
                  throw new t(`unexpected marker ${(G << 8 | Ae).toString(16)}`);
                }
              }
              return N = 7, G >>> 7;
            }
            function ie(Ae) {
              let Se = Ae;
              for (; ; ) {
                switch (Se = Se[q()], typeof Se) {
                  case "number":
                    return Se;
                  case "object":
                    continue;
                }
                throw new t("invalid huffman sequence");
              }
            }
            function oe(Ae) {
              let Se = 0;
              for (; Ae > 0; )
                Se = Se << 1 | q(), Ae--;
              return Se;
            }
            function fe(Ae) {
              if (Ae === 1)
                return q() === 1 ? 1 : -1;
              const Se = oe(Ae);
              return Se >= 1 << Ae - 1 ? Se : Se + (-1 << Ae) + 1;
            }
            function Y(Ae, Se) {
              const De = ie(Ae.huffmanTableDC), Be = De === 0 ? 0 : fe(De);
              Ae.blockData[Se] = Ae.pred += Be;
              let ke = 1;
              for (; ke < 64; ) {
                const be = ie(Ae.huffmanTableAC), we = be & 15, Le = be >> 4;
                if (we === 0) {
                  if (Le < 15)
                    break;
                  ke += 16;
                  continue;
                }
                ke += Le;
                const Re = v[ke];
                Ae.blockData[Se + Re] = fe(we), ke++;
              }
            }
            function ae(Ae, Se) {
              const De = ie(Ae.huffmanTableDC), Be = De === 0 ? 0 : fe(De) << V;
              Ae.blockData[Se] = Ae.pred += Be;
            }
            function se(Ae, Se) {
              Ae.blockData[Se] |= q() << V;
            }
            let L = 0;
            function W(Ae, Se) {
              if (L > 0) {
                L--;
                return;
              }
              let De = F;
              const Be = j;
              for (; De <= Be; ) {
                const ke = ie(Ae.huffmanTableAC), be = ke & 15, we = ke >> 4;
                if (be === 0) {
                  if (we < 15) {
                    L = oe(we) + (1 << we) - 1;
                    break;
                  }
                  De += 16;
                  continue;
                }
                De += we;
                const Le = v[De];
                Ae.blockData[Se + Le] = fe(be) * (1 << V), De++;
              }
            }
            let M = 0, X;
            function U(Ae, Se) {
              let De = F;
              const Be = j;
              let ke = 0, be, we;
              for (; De <= Be; ) {
                const Le = Se + v[De], Re = Ae.blockData[Le] < 0 ? -1 : 1;
                switch (M) {
                  case 0:
                    if (we = ie(Ae.huffmanTableAC), be = we & 15, ke = we >> 4, be === 0)
                      ke < 15 ? (L = oe(ke) + (1 << ke), M = 4) : (ke = 16, M = 1);
                    else {
                      if (be !== 1)
                        throw new t("invalid ACn encoding");
                      X = fe(be), M = ke ? 2 : 3;
                    }
                    continue;
                  case 1:
                  case 2:
                    Ae.blockData[Le] ? Ae.blockData[Le] += Re * (q() << V) : (ke--, ke === 0 && (M = M === 2 ? 3 : 0));
                    break;
                  case 3:
                    Ae.blockData[Le] ? Ae.blockData[Le] += Re * (q() << V) : (Ae.blockData[Le] = X << V, M = 0);
                    break;
                  case 4:
                    Ae.blockData[Le] && (Ae.blockData[Le] += Re * (q() << V));
                    break;
                }
                De++;
              }
              M === 4 && (L--, L === 0 && (M = 0));
            }
            let Q = 0;
            function re(Ae, Se, De, Be, ke) {
              const be = De / ne | 0, we = De % ne;
              Q = be * Ae.v + Be;
              const Le = we * Ae.h + ke, Re = $(Ae, Q, Le);
              Se(Ae, Re);
            }
            function le(Ae, Se, De) {
              Q = De / Ae.blocksPerLine | 0;
              const Be = De % Ae.blocksPerLine, ke = $(Ae, Q, Be);
              Se(Ae, ke);
            }
            const ce = T.length;
            let ee, he, pe, de, ge, me;
            Z ? F === 0 ? me = P === 0 ? ae : se : me = P === 0 ? W : U : me = Y;
            let xe = 0, ye;
            const ve = ce === 1 ? T[0].blocksPerLine * T[0].blocksPerColumn : ne * z.mcusPerColumn;
            let Ce, Ie;
            for (; xe <= ve; ) {
              const Ae = w ? Math.min(ve - xe, w) : ve;
              if (Ae > 0) {
                for (he = 0; he < ce; he++)
                  T[he].pred = 0;
                if (L = 0, ce === 1)
                  for (ee = T[0], ge = 0; ge < Ae; ge++)
                    le(ee, me, xe), xe++;
                else
                  for (ge = 0; ge < Ae; ge++) {
                    for (he = 0; he < ce; he++)
                      for (ee = T[he], Ce = ee.h, Ie = ee.v, pe = 0; pe < Ie; pe++)
                        for (de = 0; de < Ce; de++)
                          re(ee, me, xe, pe, de);
                    xe++;
                  }
              }
              if (N = 0, ye = R(A, k), !ye)
                break;
              if (ye.invalid) {
                const Se = Ae > 0 ? "unexpected" : "excessive";
                (0, s.warn)(`decodeScan - ${Se} MCU data, current marker is: ${ye.invalid}`), k = ye.offset;
              }
              if (ye.marker >= 65488 && ye.marker <= 65495)
                k += 2;
              else
                break;
            }
            return k - te;
          }
          function H(A, k, z) {
            const T = A.quantizationTable, w = A.blockData;
            let F, j, P, V, J, ne, Z, te, G, N, q, ie, oe, fe, Y, ae, se;
            if (!T)
              throw new t("missing required Quantization Table.");
            for (let L = 0; L < 64; L += 8) {
              if (G = w[k + L], N = w[k + L + 1], q = w[k + L + 2], ie = w[k + L + 3], oe = w[k + L + 4], fe = w[k + L + 5], Y = w[k + L + 6], ae = w[k + L + 7], G *= T[L], !(N | q | ie | oe | fe | Y | ae)) {
                se = I * G + 512 >> 10, z[L] = se, z[L + 1] = se, z[L + 2] = se, z[L + 3] = se, z[L + 4] = se, z[L + 5] = se, z[L + 6] = se, z[L + 7] = se;
                continue;
              }
              N *= T[L + 1], q *= T[L + 2], ie *= T[L + 3], oe *= T[L + 4], fe *= T[L + 5], Y *= T[L + 6], ae *= T[L + 7], F = I * G + 128 >> 8, j = I * oe + 128 >> 8, P = q, V = Y, J = O * (N - ae) + 128 >> 8, te = O * (N + ae) + 128 >> 8, ne = ie << 4, Z = fe << 4, F = F + j + 1 >> 1, j = F - j, se = P * u + V * b + 128 >> 8, P = P * b - V * u + 128 >> 8, V = se, J = J + Z + 1 >> 1, Z = J - Z, te = te + ne + 1 >> 1, ne = te - ne, F = F + V + 1 >> 1, V = F - V, j = j + P + 1 >> 1, P = j - P, se = J * x + te * y + 2048 >> 12, J = J * y - te * x + 2048 >> 12, te = se, se = ne * S + Z * E + 2048 >> 12, ne = ne * E - Z * S + 2048 >> 12, Z = se, z[L] = F + te, z[L + 7] = F - te, z[L + 1] = j + Z, z[L + 6] = j - Z, z[L + 2] = P + ne, z[L + 5] = P - ne, z[L + 3] = V + J, z[L + 4] = V - J;
            }
            for (let L = 0; L < 8; ++L) {
              if (G = z[L], N = z[L + 8], q = z[L + 16], ie = z[L + 24], oe = z[L + 32], fe = z[L + 40], Y = z[L + 48], ae = z[L + 56], !(N | q | ie | oe | fe | Y | ae)) {
                se = I * G + 8192 >> 14, se < -2040 ? se = 0 : se >= 2024 ? se = 255 : se = se + 2056 >> 4, w[k + L] = se, w[k + L + 8] = se, w[k + L + 16] = se, w[k + L + 24] = se, w[k + L + 32] = se, w[k + L + 40] = se, w[k + L + 48] = se, w[k + L + 56] = se;
                continue;
              }
              F = I * G + 2048 >> 12, j = I * oe + 2048 >> 12, P = q, V = Y, J = O * (N - ae) + 2048 >> 12, te = O * (N + ae) + 2048 >> 12, ne = ie, Z = fe, F = (F + j + 1 >> 1) + 4112, j = F - j, se = P * u + V * b + 2048 >> 12, P = P * b - V * u + 2048 >> 12, V = se, J = J + Z + 1 >> 1, Z = J - Z, te = te + ne + 1 >> 1, ne = te - ne, F = F + V + 1 >> 1, V = F - V, j = j + P + 1 >> 1, P = j - P, se = J * x + te * y + 2048 >> 12, J = J * y - te * x + 2048 >> 12, te = se, se = ne * S + Z * E + 2048 >> 12, ne = ne * E - Z * S + 2048 >> 12, Z = se, G = F + te, ae = F - te, N = j + Z, Y = j - Z, q = P + ne, fe = P - ne, ie = V + J, oe = V - J, G < 16 ? G = 0 : G >= 4080 ? G = 255 : G >>= 4, N < 16 ? N = 0 : N >= 4080 ? N = 255 : N >>= 4, q < 16 ? q = 0 : q >= 4080 ? q = 255 : q >>= 4, ie < 16 ? ie = 0 : ie >= 4080 ? ie = 255 : ie >>= 4, oe < 16 ? oe = 0 : oe >= 4080 ? oe = 255 : oe >>= 4, fe < 16 ? fe = 0 : fe >= 4080 ? fe = 255 : fe >>= 4, Y < 16 ? Y = 0 : Y >= 4080 ? Y = 255 : Y >>= 4, ae < 16 ? ae = 0 : ae >= 4080 ? ae = 255 : ae >>= 4, w[k + L] = G, w[k + L + 8] = N, w[k + L + 16] = q, w[k + L + 24] = ie, w[k + L + 32] = oe, w[k + L + 40] = fe, w[k + L + 48] = Y, w[k + L + 56] = ae;
            }
          }
          function B(A, k) {
            const z = k.blocksPerLine, T = k.blocksPerColumn, w = new Int16Array(64);
            for (let F = 0; F < T; F++)
              for (let j = 0; j < z; j++) {
                const P = $(k, F, j);
                H(k, P, w);
              }
            return k.blockData;
          }
          function R(A, k, z = k) {
            const T = A.length - 1;
            let w = z < k ? z : k;
            if (k >= T)
              return null;
            const F = (0, g.readUint16)(A, k);
            if (F >= 65472 && F <= 65534)
              return {
                invalid: null,
                marker: F,
                offset: k
              };
            let j = (0, g.readUint16)(A, w);
            for (; !(j >= 65472 && j <= 65534); ) {
              if (++w >= T)
                return null;
              j = (0, g.readUint16)(A, w);
            }
            return {
              invalid: F.toString(16),
              marker: j,
              offset: w
            };
          }
          class _ {
            constructor({
              decodeTransform: k = null,
              colorTransform: z = -1
            } = {}) {
              this._decodeTransform = k, this._colorTransform = z;
            }
            parse(k, {
              dnlScanLines: z = null
            } = {}) {
              function T() {
                const q = (0, g.readUint16)(k, F);
                F += 2;
                let ie = F + q - 2;
                const oe = R(k, ie, F);
                oe != null && oe.invalid && ((0, s.warn)("readDataBlock - incorrect length, current marker is: " + oe.invalid), ie = oe.offset);
                const fe = k.subarray(F, ie);
                return F += fe.length, fe;
              }
              function w(q) {
                const ie = Math.ceil(q.samplesPerLine / 8 / q.maxH), oe = Math.ceil(q.scanLines / 8 / q.maxV);
                for (const fe of q.components) {
                  const Y = Math.ceil(Math.ceil(q.samplesPerLine / 8) * fe.h / q.maxH), ae = Math.ceil(Math.ceil(q.scanLines / 8) * fe.v / q.maxV), se = ie * fe.h, W = 64 * (oe * fe.v) * (se + 1);
                  fe.blockData = new Int16Array(W), fe.blocksPerLine = Y, fe.blocksPerColumn = ae;
                }
                q.mcusPerLine = ie, q.mcusPerColumn = oe;
              }
              let F = 0, j = null, P = null, V, J, ne = 0;
              const Z = [], te = [], G = [];
              let N = (0, g.readUint16)(k, F);
              if (F += 2, N !== 65496)
                throw new t("SOI not found");
              N = (0, g.readUint16)(k, F), F += 2;
              e: for (; N !== 65497; ) {
                let q, ie, oe;
                switch (N) {
                  case 65504:
                  case 65505:
                  case 65506:
                  case 65507:
                  case 65508:
                  case 65509:
                  case 65510:
                  case 65511:
                  case 65512:
                  case 65513:
                  case 65514:
                  case 65515:
                  case 65516:
                  case 65517:
                  case 65518:
                  case 65519:
                  case 65534:
                    const fe = T();
                    N === 65504 && fe[0] === 74 && fe[1] === 70 && fe[2] === 73 && fe[3] === 70 && fe[4] === 0 && (j = {
                      version: {
                        major: fe[5],
                        minor: fe[6]
                      },
                      densityUnits: fe[7],
                      xDensity: fe[8] << 8 | fe[9],
                      yDensity: fe[10] << 8 | fe[11],
                      thumbWidth: fe[12],
                      thumbHeight: fe[13],
                      thumbData: fe.subarray(14, 14 + 3 * fe[12] * fe[13])
                    }), N === 65518 && fe[0] === 65 && fe[1] === 100 && fe[2] === 111 && fe[3] === 98 && fe[4] === 101 && (P = {
                      version: fe[5] << 8 | fe[6],
                      flags0: fe[7] << 8 | fe[8],
                      flags1: fe[9] << 8 | fe[10],
                      transformCode: fe[11]
                    });
                    break;
                  case 65499:
                    const Y = (0, g.readUint16)(k, F);
                    F += 2;
                    const ae = Y + F - 2;
                    let se;
                    for (; F < ae; ) {
                      const de = k[F++], ge = new Uint16Array(64);
                      if (de >> 4)
                        if (de >> 4 === 1)
                          for (ie = 0; ie < 64; ie++)
                            se = v[ie], ge[se] = (0, g.readUint16)(k, F), F += 2;
                        else
                          throw new t("DQT - invalid table spec");
                      else for (ie = 0; ie < 64; ie++)
                        se = v[ie], ge[se] = k[F++];
                      Z[de & 15] = ge;
                    }
                    break;
                  case 65472:
                  case 65473:
                  case 65474:
                    if (V)
                      throw new t("Only single frame JPEGs supported");
                    F += 2, V = {}, V.extended = N === 65473, V.progressive = N === 65474, V.precision = k[F++];
                    const L = (0, g.readUint16)(k, F);
                    F += 2, V.scanLines = z || L, V.samplesPerLine = (0, g.readUint16)(k, F), F += 2, V.components = [], V.componentIds = {};
                    const W = k[F++];
                    let M = 0, X = 0;
                    for (q = 0; q < W; q++) {
                      const de = k[F], ge = k[F + 1] >> 4, me = k[F + 1] & 15;
                      M < ge && (M = ge), X < me && (X = me);
                      const xe = k[F + 2];
                      oe = V.components.push({
                        h: ge,
                        v: me,
                        quantizationId: xe,
                        quantizationTable: null
                      }), V.componentIds[de] = oe - 1, F += 3;
                    }
                    V.maxH = M, V.maxV = X, w(V);
                    break;
                  case 65476:
                    const U = (0, g.readUint16)(k, F);
                    for (F += 2, q = 2; q < U; ) {
                      const de = k[F++], ge = new Uint8Array(16);
                      let me = 0;
                      for (ie = 0; ie < 16; ie++, F++)
                        me += ge[ie] = k[F];
                      const xe = new Uint8Array(me);
                      for (ie = 0; ie < me; ie++, F++)
                        xe[ie] = k[F];
                      q += 17 + me, (de >> 4 ? te : G)[de & 15] = D(ge, xe);
                    }
                    break;
                  case 65501:
                    F += 2, J = (0, g.readUint16)(k, F), F += 2;
                    break;
                  case 65498:
                    const Q = ++ne === 1 && !z;
                    F += 2;
                    const re = k[F++], le = [];
                    for (q = 0; q < re; q++) {
                      const de = k[F++], ge = V.componentIds[de], me = V.components[ge];
                      me.index = de;
                      const xe = k[F++];
                      me.huffmanTableDC = G[xe >> 4], me.huffmanTableAC = te[xe & 15], le.push(me);
                    }
                    const ce = k[F++], ee = k[F++], he = k[F++];
                    try {
                      const de = K(k, F, V, le, J, ce, ee, he >> 4, he & 15, Q);
                      F += de;
                    } catch (de) {
                      if (de instanceof i)
                        return (0, s.warn)(`${de.message} -- attempting to re-parse the JPEG image.`), this.parse(k, {
                          dnlScanLines: de.scanLines
                        });
                      if (de instanceof m) {
                        (0, s.warn)(`${de.message} -- ignoring the rest of the image data.`);
                        break e;
                      }
                      throw de;
                    }
                    break;
                  case 65500:
                    F += 4;
                    break;
                  case 65535:
                    k[F] !== 255 && F--;
                    break;
                  default:
                    const pe = R(k, F - 2, F - 3);
                    if (pe != null && pe.invalid) {
                      (0, s.warn)("JpegImage.parse - unexpected data, current marker is: " + pe.invalid), F = pe.offset;
                      break;
                    }
                    if (!pe || F >= k.length - 1) {
                      (0, s.warn)("JpegImage.parse - reached the end of the image data without finding an EOI marker (0xFFD9).");
                      break e;
                    }
                    throw new t("JpegImage.parse - unknown marker: " + N.toString(16));
                }
                N = (0, g.readUint16)(k, F), F += 2;
              }
              this.width = V.samplesPerLine, this.height = V.scanLines, this.jfif = j, this.adobe = P, this.components = [];
              for (const q of V.components) {
                const ie = Z[q.quantizationId];
                ie && (q.quantizationTable = ie), this.components.push({
                  index: q.index,
                  output: B(V, q),
                  scaleX: q.h / V.maxH,
                  scaleY: q.v / V.maxV,
                  blocksPerLine: q.blocksPerLine,
                  blocksPerColumn: q.blocksPerColumn
                });
              }
              this.numComponents = this.components.length;
            }
            _getLinearizedBlockData(k, z, T = !1) {
              const w = this.width / k, F = this.height / z;
              let j, P, V, J, ne, Z, te, G, N, q, ie = 0, oe;
              const fe = this.components.length, Y = k * z * fe, ae = new Uint8ClampedArray(Y), se = new Uint32Array(k), L = 4294967288;
              let W;
              for (te = 0; te < fe; te++) {
                if (j = this.components[te], P = j.scaleX * w, V = j.scaleY * F, ie = te, oe = j.output, J = j.blocksPerLine + 1 << 3, P !== W) {
                  for (ne = 0; ne < k; ne++)
                    G = 0 | ne * P, se[ne] = (G & L) << 3 | G & 7;
                  W = P;
                }
                for (Z = 0; Z < z; Z++)
                  for (G = 0 | Z * V, q = J * (G & L) | (G & 7) << 3, ne = 0; ne < k; ne++)
                    ae[ie] = oe[q + se[ne]], ie += fe;
              }
              let M = this._decodeTransform;
              if (!T && fe === 4 && !M && (M = new Int32Array([-256, 255, -256, 255, -256, 255, -256, 255])), M)
                for (te = 0; te < Y; )
                  for (G = 0, N = 0; G < fe; G++, te++, N += 2)
                    ae[te] = (ae[te] * M[N] >> 8) + M[N + 1];
              return ae;
            }
            get _isColorConversionNeeded() {
              return this.adobe ? !!this.adobe.transformCode : this.numComponents === 3 ? this._colorTransform === 0 ? !1 : !(this.components[0].index === 82 && this.components[1].index === 71 && this.components[2].index === 66) : this._colorTransform === 1;
            }
            _convertYccToRgb(k) {
              let z, T, w;
              for (let F = 0, j = k.length; F < j; F += 3)
                z = k[F], T = k[F + 1], w = k[F + 2], k[F] = z - 179.456 + 1.402 * w, k[F + 1] = z + 135.459 - 0.344 * T - 0.714 * w, k[F + 2] = z - 226.816 + 1.772 * T;
              return k;
            }
            _convertYccToRgba(k, z) {
              for (let T = 0, w = 0, F = k.length; T < F; T += 3, w += 4) {
                const j = k[T], P = k[T + 1], V = k[T + 2];
                z[w] = j - 179.456 + 1.402 * V, z[w + 1] = j + 135.459 - 0.344 * P - 0.714 * V, z[w + 2] = j - 226.816 + 1.772 * P, z[w + 3] = 255;
              }
              return z;
            }
            _convertYcckToRgb(k) {
              let z, T, w, F, j = 0;
              for (let P = 0, V = k.length; P < V; P += 4)
                z = k[P], T = k[P + 1], w = k[P + 2], F = k[P + 3], k[j++] = -122.67195406894 + T * (-660635669420364e-19 * T + 437130475926232e-18 * w - 54080610064599e-18 * z + 48449797120281e-17 * F - 0.154362151871126) + w * (-957964378445773e-18 * w + 817076911346625e-18 * z - 0.00477271405408747 * F + 1.53380253221734) + z * (961250184130688e-18 * z - 0.00266257332283933 * F + 0.48357088451265) + F * (-336197177618394e-18 * F + 0.484791561490776), k[j++] = 107.268039397724 + T * (219927104525741e-19 * T - 640992018297945e-18 * w + 659397001245577e-18 * z + 426105652938837e-18 * F - 0.176491792462875) + w * (-778269941513683e-18 * w + 0.00130872261408275 * z + 770482631801132e-18 * F - 0.151051492775562) + z * (0.00126935368114843 * z - 0.00265090189010898 * F + 0.25802910206845) + F * (-318913117588328e-18 * F - 0.213742400323665), k[j++] = -20.810012546947 + T * (-570115196973677e-18 * T - 263409051004589e-19 * w + 0.0020741088115012 * z - 0.00288260236853442 * F + 0.814272968359295) + w * (-153496057440975e-19 * w - 132689043961446e-18 * z + 560833691242812e-18 * F - 0.195152027534049) + z * (0.00174418132927582 * z - 0.00255243321439347 * F + 0.116935020465145) + F * (-343531996510555e-18 * F + 0.24165260232407);
              return k.subarray(0, j);
            }
            _convertYcckToRgba(k) {
              for (let z = 0, T = k.length; z < T; z += 4) {
                const w = k[z], F = k[z + 1], j = k[z + 2], P = k[z + 3];
                k[z] = -122.67195406894 + F * (-660635669420364e-19 * F + 437130475926232e-18 * j - 54080610064599e-18 * w + 48449797120281e-17 * P - 0.154362151871126) + j * (-957964378445773e-18 * j + 817076911346625e-18 * w - 0.00477271405408747 * P + 1.53380253221734) + w * (961250184130688e-18 * w - 0.00266257332283933 * P + 0.48357088451265) + P * (-336197177618394e-18 * P + 0.484791561490776), k[z + 1] = 107.268039397724 + F * (219927104525741e-19 * F - 640992018297945e-18 * j + 659397001245577e-18 * w + 426105652938837e-18 * P - 0.176491792462875) + j * (-778269941513683e-18 * j + 0.00130872261408275 * w + 770482631801132e-18 * P - 0.151051492775562) + w * (0.00126935368114843 * w - 0.00265090189010898 * P + 0.25802910206845) + P * (-318913117588328e-18 * P - 0.213742400323665), k[z + 2] = -20.810012546947 + F * (-570115196973677e-18 * F - 263409051004589e-19 * j + 0.0020741088115012 * w - 0.00288260236853442 * P + 0.814272968359295) + j * (-153496057440975e-19 * j - 132689043961446e-18 * w + 560833691242812e-18 * P - 0.195152027534049) + w * (0.00174418132927582 * w - 0.00255243321439347 * P + 0.116935020465145) + P * (-343531996510555e-18 * P + 0.24165260232407), k[z + 3] = 255;
              }
              return k;
            }
            _convertYcckToCmyk(k) {
              let z, T, w;
              for (let F = 0, j = k.length; F < j; F += 4)
                z = k[F], T = k[F + 1], w = k[F + 2], k[F] = 434.456 - z - 1.402 * w, k[F + 1] = 119.541 - z + 0.344 * T + 0.714 * w, k[F + 2] = 481.816 - z - 1.772 * T;
              return k;
            }
            _convertCmykToRgb(k) {
              let z, T, w, F, j = 0;
              for (let P = 0, V = k.length; P < V; P += 4)
                z = k[P], T = k[P + 1], w = k[P + 2], F = k[P + 3], k[j++] = 255 + z * (-6747147073602441e-20 * z + 8379262121013727e-19 * T + 2894718188643294e-19 * w + 0.003264231057537806 * F - 1.1185611867203937) + T * (26374107616089405e-21 * T - 8626949158638572e-20 * w - 2748769067499491e-19 * F - 0.02155688794978967) + w * (-3878099212869363e-20 * w - 3267808279485286e-19 * F + 0.0686742238595345) - F * (3361971776183937e-19 * F + 0.7430659151342254), k[j++] = 255 + z * (13596372813588848e-20 * z + 924537132573585e-18 * T + 10567359618683593e-20 * w + 4791864687436512e-19 * F - 0.3109689587515875) + T * (-23545346108370344e-20 * T + 2702845253534714e-19 * w + 0.0020200308977307156 * F - 0.7488052167015494) + w * (6834815998235662e-20 * w + 15168452363460973e-20 * F - 0.09751927774728933) - F * (3189131175883281e-19 * F + 0.7364883807733168), k[j++] = 255 + z * (13598650411385307e-21 * z + 12423956175490851e-20 * T + 4751985097583589e-19 * w - 36729317476630422e-22 * F - 0.05562186980264034) + T * (16141380598724676e-20 * T + 9692239130725186e-19 * w + 7782692450036253e-19 * F - 0.44015232367526463) + w * (5068882914068769e-22 * w + 0.0017778369011375071 * F - 0.7591454649749609) - F * (3435319965105553e-19 * F + 0.7063770186160144);
              return k.subarray(0, j);
            }
            _convertCmykToRgba(k) {
              for (let z = 0, T = k.length; z < T; z += 4) {
                const w = k[z], F = k[z + 1], j = k[z + 2], P = k[z + 3];
                k[z] = 255 + w * (-6747147073602441e-20 * w + 8379262121013727e-19 * F + 2894718188643294e-19 * j + 0.003264231057537806 * P - 1.1185611867203937) + F * (26374107616089405e-21 * F - 8626949158638572e-20 * j - 2748769067499491e-19 * P - 0.02155688794978967) + j * (-3878099212869363e-20 * j - 3267808279485286e-19 * P + 0.0686742238595345) - P * (3361971776183937e-19 * P + 0.7430659151342254), k[z + 1] = 255 + w * (13596372813588848e-20 * w + 924537132573585e-18 * F + 10567359618683593e-20 * j + 4791864687436512e-19 * P - 0.3109689587515875) + F * (-23545346108370344e-20 * F + 2702845253534714e-19 * j + 0.0020200308977307156 * P - 0.7488052167015494) + j * (6834815998235662e-20 * j + 15168452363460973e-20 * P - 0.09751927774728933) - P * (3189131175883281e-19 * P + 0.7364883807733168), k[z + 2] = 255 + w * (13598650411385307e-21 * w + 12423956175490851e-20 * F + 4751985097583589e-19 * j - 36729317476630422e-22 * P - 0.05562186980264034) + F * (16141380598724676e-20 * F + 9692239130725186e-19 * j + 7782692450036253e-19 * P - 0.44015232367526463) + j * (5068882914068769e-22 * j + 0.0017778369011375071 * P - 0.7591454649749609) - P * (3435319965105553e-19 * P + 0.7063770186160144), k[z + 3] = 255;
              }
              return k;
            }
            getData({
              width: k,
              height: z,
              forceRGBA: T = !1,
              forceRGB: w = !1,
              isSourcePDF: F = !1
            }) {
              if (this.numComponents > 4)
                throw new t("Unsupported color mode");
              const j = this._getLinearizedBlockData(k, z, F);
              if (this.numComponents === 1 && (T || w)) {
                const P = j.length * (T ? 4 : 3), V = new Uint8ClampedArray(P);
                let J = 0;
                if (T)
                  (0, h.grayToRGBA)(j, new Uint32Array(V.buffer));
                else
                  for (const ne of j)
                    V[J++] = ne, V[J++] = ne, V[J++] = ne;
                return V;
              } else if (this.numComponents === 3 && this._isColorConversionNeeded) {
                if (T) {
                  const P = new Uint8ClampedArray(j.length / 3 * 4);
                  return this._convertYccToRgba(j, P);
                }
                return this._convertYccToRgb(j);
              } else if (this.numComponents === 4) {
                if (this._isColorConversionNeeded)
                  return T ? this._convertYcckToRgba(j) : w ? this._convertYcckToRgb(j) : this._convertYcckToCmyk(j);
                if (T)
                  return this._convertCmykToRgba(j);
                if (w)
                  return this._convertCmykToRgb(j);
              }
              return j;
            }
          }
          c.JpegImage = _;
        },
        /* 28 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.convertBlackAndWhiteToRGBA = g, c.convertToRGBA = h, c.grayToRGBA = i;
          var s = f(2);
          function h(m) {
            switch (m.kind) {
              case s.ImageKind.GRAYSCALE_1BPP:
                return g(m);
              case s.ImageKind.RGB_24BPP:
                return t(m);
            }
            return null;
          }
          function g({
            src: m,
            srcPos: v = 0,
            dest: E,
            width: S,
            height: y,
            nonBlackColor: x = 4294967295,
            inverseDecode: b = !1
          }) {
            const u = s.FeatureTest.isLittleEndian ? 4278190080 : 255, [I, O] = b ? [x, u] : [u, x], D = S >> 3, $ = S & 7, K = m.length;
            E = new Uint32Array(E.buffer);
            let H = 0;
            for (let B = 0; B < y; B++) {
              for (const _ = v + D; v < _; v++) {
                const A = v < K ? m[v] : 255;
                E[H++] = A & 128 ? O : I, E[H++] = A & 64 ? O : I, E[H++] = A & 32 ? O : I, E[H++] = A & 16 ? O : I, E[H++] = A & 8 ? O : I, E[H++] = A & 4 ? O : I, E[H++] = A & 2 ? O : I, E[H++] = A & 1 ? O : I;
              }
              if ($ === 0)
                continue;
              const R = v < K ? m[v++] : 255;
              for (let _ = 0; _ < $; _++)
                E[H++] = R & 1 << 7 - _ ? O : I;
            }
            return {
              srcPos: v,
              destPos: H
            };
          }
          function t({
            src: m,
            srcPos: v = 0,
            dest: E,
            destPos: S = 0,
            width: y,
            height: x
          }) {
            let b = 0;
            const u = m.length >> 2, I = new Uint32Array(m.buffer, v, u);
            if (s.FeatureTest.isLittleEndian) {
              for (; b < u - 2; b += 3, S += 4) {
                const O = I[b], D = I[b + 1], $ = I[b + 2];
                E[S] = O | 4278190080, E[S + 1] = O >>> 24 | D << 8 | 4278190080, E[S + 2] = D >>> 16 | $ << 16 | 4278190080, E[S + 3] = $ >>> 8 | 4278190080;
              }
              for (let O = b * 4, D = m.length; O < D; O += 3)
                E[S++] = m[O] | m[O + 1] << 8 | m[O + 2] << 16 | 4278190080;
            } else {
              for (; b < u - 2; b += 3, S += 4) {
                const O = I[b], D = I[b + 1], $ = I[b + 2];
                E[S] = O | 255, E[S + 1] = O << 24 | D >>> 8 | 255, E[S + 2] = D << 16 | $ >>> 16 | 255, E[S + 3] = $ << 8 | 255;
              }
              for (let O = b * 4, D = m.length; O < D; O += 3)
                E[S++] = m[O] << 24 | m[O + 1] << 16 | m[O + 2] << 8 | 255;
            }
            return {
              srcPos: v,
              destPos: S
            };
          }
          function i(m, v) {
            if (s.FeatureTest.isLittleEndian)
              for (let E = 0, S = m.length; E < S; E++)
                v[E] = m[E] * 65793 | 4278190080;
            else
              for (let E = 0, S = m.length; E < S; E++)
                v[E] = m[E] * 16843008 | 255;
          }
        },
        /* 29 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.JpxStream = void 0;
          var s = f(18), h = f(30), g = f(2);
          class t extends s.DecodeStream {
            constructor(m, v, E) {
              super(v), this.stream = m, this.dict = m.dict, this.maybeLength = v, this.params = E;
            }
            get bytes() {
              return (0, g.shadow)(this, "bytes", this.stream.getBytes(this.maybeLength));
            }
            ensureBuffer(m) {
            }
            readBlock() {
              if (this.eof)
                return;
              const m = new h.JpxImage();
              m.parse(this.bytes);
              const v = m.width, E = m.height, S = m.componentsCount, y = m.tiles.length;
              if (y === 1)
                this.buffer = m.tiles[0].items;
              else {
                const x = new Uint8ClampedArray(v * E * S);
                for (let b = 0; b < y; b++) {
                  const u = m.tiles[b], I = u.width, O = u.height, D = u.left, $ = u.top, K = u.items;
                  let H = 0, B = (v * $ + D) * S;
                  const R = v * S, _ = I * S;
                  for (let A = 0; A < O; A++) {
                    const k = K.subarray(H, H + _);
                    x.set(k, B), H += _, B += R;
                  }
                }
                this.buffer = x;
              }
              this.bufferLength = this.buffer.length, this.eof = !0;
            }
          }
          c.JpxStream = t;
        },
        /* 30 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.JpxImage = void 0;
          var s = f(2), h = f(3), g = f(25);
          class t extends s.BaseException {
            constructor(Z) {
              super(`JPX error: ${Z}`, "JpxError");
            }
          }
          const i = {
            LL: 0,
            LH: 1,
            HL: 1,
            HH: 2
          };
          class m {
            constructor() {
              this.failOnCorruptedImage = !1;
            }
            parse(Z) {
              if ((0, h.readUint16)(Z, 0) === 65359) {
                this.parseCodestream(Z, 0, Z.length);
                return;
              }
              const G = Z.length;
              let N = 0;
              for (; N < G; ) {
                let q = 8, ie = (0, h.readUint32)(Z, N);
                const oe = (0, h.readUint32)(Z, N + 4);
                if (N += q, ie === 1 && (ie = (0, h.readUint32)(Z, N) * 4294967296 + (0, h.readUint32)(Z, N + 4), N += 8, q += 8), ie === 0 && (ie = G - N + q), ie < q)
                  throw new t("Invalid box field size");
                const fe = ie - q;
                let Y = !0;
                switch (oe) {
                  case 1785737832:
                    Y = !1;
                    break;
                  case 1668246642:
                    const ae = Z[N];
                    if (ae === 1) {
                      const L = (0, h.readUint32)(Z, N + 3);
                      switch (L) {
                        case 16:
                        case 17:
                        case 18:
                          break;
                        default:
                          (0, s.warn)("Unknown colorspace " + L);
                          break;
                      }
                    } else ae === 2 && (0, s.info)("ICC profile not supported");
                    break;
                  case 1785737827:
                    this.parseCodestream(Z, N, N + fe);
                    break;
                  case 1783636e3:
                    (0, h.readUint32)(Z, N) !== 218793738 && (0, s.warn)("Invalid JP2 signature");
                    break;
                  case 1783634458:
                  case 1718909296:
                  case 1920099697:
                  case 1919251232:
                  case 1768449138:
                    break;
                  default:
                    const se = String.fromCharCode(oe >> 24 & 255, oe >> 16 & 255, oe >> 8 & 255, oe & 255);
                    (0, s.warn)(`Unsupported header type ${oe} (${se}).`);
                    break;
                }
                Y && (N += fe);
              }
            }
            parseImageProperties(Z) {
              let te = Z.getByte();
              for (; te >= 0; ) {
                const G = te;
                if (te = Z.getByte(), (G << 8 | te) === 65361) {
                  Z.skip(4);
                  const q = Z.getInt32() >>> 0, ie = Z.getInt32() >>> 0, oe = Z.getInt32() >>> 0, fe = Z.getInt32() >>> 0;
                  Z.skip(16);
                  const Y = Z.getUint16();
                  this.width = q - oe, this.height = ie - fe, this.componentsCount = Y, this.bitsPerComponent = 8;
                  return;
                }
              }
              throw new t("No size marker found in JPX stream");
            }
            parseCodestream(Z, te, G) {
              const N = {};
              let q = !1;
              try {
                let ie = te;
                for (; ie + 1 < G; ) {
                  const oe = (0, h.readUint16)(Z, ie);
                  ie += 2;
                  let fe = 0, Y, ae, se, L, W, M;
                  switch (oe) {
                    case 65359:
                      N.mainHeader = !0;
                      break;
                    case 65497:
                      break;
                    case 65361:
                      fe = (0, h.readUint16)(Z, ie);
                      const X = {};
                      X.Xsiz = (0, h.readUint32)(Z, ie + 4), X.Ysiz = (0, h.readUint32)(Z, ie + 8), X.XOsiz = (0, h.readUint32)(Z, ie + 12), X.YOsiz = (0, h.readUint32)(Z, ie + 16), X.XTsiz = (0, h.readUint32)(Z, ie + 20), X.YTsiz = (0, h.readUint32)(Z, ie + 24), X.XTOsiz = (0, h.readUint32)(Z, ie + 28), X.YTOsiz = (0, h.readUint32)(Z, ie + 32);
                      const U = (0, h.readUint16)(Z, ie + 36);
                      X.Csiz = U;
                      const Q = [];
                      Y = ie + 38;
                      for (let ge = 0; ge < U; ge++) {
                        const me = {
                          precision: (Z[Y] & 127) + 1,
                          isSigned: !!(Z[Y] & 128),
                          XRsiz: Z[Y + 1],
                          YRsiz: Z[Y + 2]
                        };
                        Y += 3, v(me, X), Q.push(me);
                      }
                      N.SIZ = X, N.components = Q, E(N, Q), N.QCC = [], N.COC = [];
                      break;
                    case 65372:
                      fe = (0, h.readUint16)(Z, ie);
                      const re = {};
                      switch (Y = ie + 2, ae = Z[Y++], ae & 31) {
                        case 0:
                          L = 8, W = !0;
                          break;
                        case 1:
                          L = 16, W = !1;
                          break;
                        case 2:
                          L = 16, W = !0;
                          break;
                        default:
                          throw new Error("Invalid SQcd value " + ae);
                      }
                      for (re.noQuantization = L === 8, re.scalarExpounded = W, re.guardBits = ae >> 5, se = []; Y < fe + ie; ) {
                        const ge = {};
                        L === 8 ? (ge.epsilon = Z[Y++] >> 3, ge.mu = 0) : (ge.epsilon = Z[Y] >> 3, ge.mu = (Z[Y] & 7) << 8 | Z[Y + 1], Y += 2), se.push(ge);
                      }
                      re.SPqcds = se, N.mainHeader ? N.QCD = re : (N.currentTile.QCD = re, N.currentTile.QCC = []);
                      break;
                    case 65373:
                      fe = (0, h.readUint16)(Z, ie);
                      const le = {};
                      Y = ie + 2;
                      let ce;
                      switch (N.SIZ.Csiz < 257 ? ce = Z[Y++] : (ce = (0, h.readUint16)(Z, Y), Y += 2), ae = Z[Y++], ae & 31) {
                        case 0:
                          L = 8, W = !0;
                          break;
                        case 1:
                          L = 16, W = !1;
                          break;
                        case 2:
                          L = 16, W = !0;
                          break;
                        default:
                          throw new Error("Invalid SQcd value " + ae);
                      }
                      for (le.noQuantization = L === 8, le.scalarExpounded = W, le.guardBits = ae >> 5, se = []; Y < fe + ie; ) {
                        const ge = {};
                        L === 8 ? (ge.epsilon = Z[Y++] >> 3, ge.mu = 0) : (ge.epsilon = Z[Y] >> 3, ge.mu = (Z[Y] & 7) << 8 | Z[Y + 1], Y += 2), se.push(ge);
                      }
                      le.SPqcds = se, N.mainHeader ? N.QCC[ce] = le : N.currentTile.QCC[ce] = le;
                      break;
                    case 65362:
                      fe = (0, h.readUint16)(Z, ie);
                      const ee = {};
                      Y = ie + 2;
                      const he = Z[Y++];
                      ee.entropyCoderWithCustomPrecincts = !!(he & 1), ee.sopMarkerUsed = !!(he & 2), ee.ephMarkerUsed = !!(he & 4), ee.progressionOrder = Z[Y++], ee.layersCount = (0, h.readUint16)(Z, Y), Y += 2, ee.multipleComponentTransform = Z[Y++], ee.decompositionLevelsCount = Z[Y++], ee.xcb = (Z[Y++] & 15) + 2, ee.ycb = (Z[Y++] & 15) + 2;
                      const pe = Z[Y++];
                      if (ee.selectiveArithmeticCodingBypass = !!(pe & 1), ee.resetContextProbabilities = !!(pe & 2), ee.terminationOnEachCodingPass = !!(pe & 4), ee.verticallyStripe = !!(pe & 8), ee.predictableTermination = !!(pe & 16), ee.segmentationSymbolUsed = !!(pe & 32), ee.reversibleTransformation = Z[Y++], ee.entropyCoderWithCustomPrecincts) {
                        const ge = [];
                        for (; Y < fe + ie; ) {
                          const me = Z[Y++];
                          ge.push({
                            PPx: me & 15,
                            PPy: me >> 4
                          });
                        }
                        ee.precinctsSizes = ge;
                      }
                      const de = [];
                      ee.selectiveArithmeticCodingBypass && de.push("selectiveArithmeticCodingBypass"), ee.terminationOnEachCodingPass && de.push("terminationOnEachCodingPass"), ee.verticallyStripe && de.push("verticallyStripe"), ee.predictableTermination && de.push("predictableTermination"), de.length > 0 && (q = !0, (0, s.warn)(`JPX: Unsupported COD options (${de.join(", ")}).`)), N.mainHeader ? N.COD = ee : (N.currentTile.COD = ee, N.currentTile.COC = []);
                      break;
                    case 65424:
                      fe = (0, h.readUint16)(Z, ie), M = {}, M.index = (0, h.readUint16)(Z, ie + 2), M.length = (0, h.readUint32)(Z, ie + 4), M.dataEnd = M.length + ie - 2, M.partIndex = Z[ie + 8], M.partsCount = Z[ie + 9], N.mainHeader = !1, M.partIndex === 0 && (M.COD = N.COD, M.COC = N.COC.slice(0), M.QCD = N.QCD, M.QCC = N.QCC.slice(0)), N.currentTile = M;
                      break;
                    case 65427:
                      M = N.currentTile, M.partIndex === 0 && (z(N, M.index), B(N)), fe = M.dataEnd - ie, R(N, Z, ie, fe);
                      break;
                    case 65363:
                      (0, s.warn)("JPX: Codestream code 0xFF53 (COC) is not implemented.");
                    case 65365:
                    case 65367:
                    case 65368:
                    case 65380:
                      fe = (0, h.readUint16)(Z, ie);
                      break;
                    default:
                      throw new Error("Unknown codestream code: " + oe.toString(16));
                  }
                  ie += fe;
                }
              } catch (ie) {
                if (q || this.failOnCorruptedImage)
                  throw new t(ie.message);
                (0, s.warn)(`JPX: Trying to recover from: "${ie.message}".`);
              }
              this.tiles = k(N), this.width = N.SIZ.Xsiz - N.SIZ.XOsiz, this.height = N.SIZ.Ysiz - N.SIZ.YOsiz, this.componentsCount = N.SIZ.Csiz;
            }
          }
          c.JpxImage = m;
          function v(ne, Z) {
            ne.x0 = Math.ceil(Z.XOsiz / ne.XRsiz), ne.x1 = Math.ceil(Z.Xsiz / ne.XRsiz), ne.y0 = Math.ceil(Z.YOsiz / ne.YRsiz), ne.y1 = Math.ceil(Z.Ysiz / ne.YRsiz), ne.width = ne.x1 - ne.x0, ne.height = ne.y1 - ne.y0;
          }
          function E(ne, Z) {
            const te = ne.SIZ, G = [];
            let N;
            const q = Math.ceil((te.Xsiz - te.XTOsiz) / te.XTsiz), ie = Math.ceil((te.Ysiz - te.YTOsiz) / te.YTsiz);
            for (let fe = 0; fe < ie; fe++)
              for (let Y = 0; Y < q; Y++)
                N = {}, N.tx0 = Math.max(te.XTOsiz + Y * te.XTsiz, te.XOsiz), N.ty0 = Math.max(te.YTOsiz + fe * te.YTsiz, te.YOsiz), N.tx1 = Math.min(te.XTOsiz + (Y + 1) * te.XTsiz, te.Xsiz), N.ty1 = Math.min(te.YTOsiz + (fe + 1) * te.YTsiz, te.Ysiz), N.width = N.tx1 - N.tx0, N.height = N.ty1 - N.ty0, N.components = [], G.push(N);
            ne.tiles = G;
            const oe = te.Csiz;
            for (let fe = 0, Y = oe; fe < Y; fe++) {
              const ae = Z[fe];
              for (let se = 0, L = G.length; se < L; se++) {
                const W = {};
                N = G[se], W.tcx0 = Math.ceil(N.tx0 / ae.XRsiz), W.tcy0 = Math.ceil(N.ty0 / ae.YRsiz), W.tcx1 = Math.ceil(N.tx1 / ae.XRsiz), W.tcy1 = Math.ceil(N.ty1 / ae.YRsiz), W.width = W.tcx1 - W.tcx0, W.height = W.tcy1 - W.tcy0, N.components[fe] = W;
              }
            }
          }
          function S(ne, Z, te) {
            const G = Z.codingStyleParameters, N = {};
            return G.entropyCoderWithCustomPrecincts ? (N.PPx = G.precinctsSizes[te].PPx, N.PPy = G.precinctsSizes[te].PPy) : (N.PPx = 15, N.PPy = 15), N.xcb_ = te > 0 ? Math.min(G.xcb, N.PPx - 1) : Math.min(G.xcb, N.PPx), N.ycb_ = te > 0 ? Math.min(G.ycb, N.PPy - 1) : Math.min(G.ycb, N.PPy), N;
          }
          function y(ne, Z, te) {
            const G = 1 << te.PPx, N = 1 << te.PPy, q = Z.resLevel === 0, ie = 1 << te.PPx + (q ? 0 : -1), oe = 1 << te.PPy + (q ? 0 : -1), fe = Z.trx1 > Z.trx0 ? Math.ceil(Z.trx1 / G) - Math.floor(Z.trx0 / G) : 0, Y = Z.try1 > Z.try0 ? Math.ceil(Z.try1 / N) - Math.floor(Z.try0 / N) : 0, ae = fe * Y;
            Z.precinctParameters = {
              precinctWidth: G,
              precinctHeight: N,
              numprecinctswide: fe,
              numprecinctshigh: Y,
              numprecincts: ae,
              precinctWidthInSubband: ie,
              precinctHeightInSubband: oe
            };
          }
          function x(ne, Z, te) {
            const G = te.xcb_, N = te.ycb_, q = 1 << G, ie = 1 << N, oe = Z.tbx0 >> G, fe = Z.tby0 >> N, Y = Z.tbx1 + q - 1 >> G, ae = Z.tby1 + ie - 1 >> N, se = Z.resolution.precinctParameters, L = [], W = [];
            let M, X, U, Q;
            for (X = fe; X < ae; X++)
              for (M = oe; M < Y; M++) {
                U = {
                  cbx: M,
                  cby: X,
                  tbx0: q * M,
                  tby0: ie * X,
                  tbx1: q * (M + 1),
                  tby1: ie * (X + 1)
                }, U.tbx0_ = Math.max(Z.tbx0, U.tbx0), U.tby0_ = Math.max(Z.tby0, U.tby0), U.tbx1_ = Math.min(Z.tbx1, U.tbx1), U.tby1_ = Math.min(Z.tby1, U.tby1);
                const re = Math.floor((U.tbx0_ - Z.tbx0) / se.precinctWidthInSubband), le = Math.floor((U.tby0_ - Z.tby0) / se.precinctHeightInSubband);
                if (Q = re + le * se.numprecinctswide, U.precinctNumber = Q, U.subbandType = Z.type, U.Lblock = 3, U.tbx1_ <= U.tbx0_ || U.tby1_ <= U.tby0_)
                  continue;
                L.push(U);
                let ce = W[Q];
                ce !== void 0 ? (M < ce.cbxMin ? ce.cbxMin = M : M > ce.cbxMax && (ce.cbxMax = M), X < ce.cbyMin ? ce.cbxMin = X : X > ce.cbyMax && (ce.cbyMax = X)) : W[Q] = ce = {
                  cbxMin: M,
                  cbyMin: X,
                  cbxMax: M,
                  cbyMax: X
                }, U.precinct = ce;
              }
            Z.codeblockParameters = {
              codeblockWidth: G,
              codeblockHeight: N,
              numcodeblockwide: Y - oe + 1,
              numcodeblockhigh: ae - fe + 1
            }, Z.codeblocks = L, Z.precincts = W;
          }
          function b(ne, Z, te) {
            const G = [], N = ne.subbands;
            for (let q = 0, ie = N.length; q < ie; q++) {
              const fe = N[q].codeblocks;
              for (let Y = 0, ae = fe.length; Y < ae; Y++) {
                const se = fe[Y];
                se.precinctNumber === Z && G.push(se);
              }
            }
            return {
              layerNumber: te,
              codeblocks: G
            };
          }
          function u(ne) {
            const Z = ne.SIZ, te = ne.currentTile.index, G = ne.tiles[te], N = G.codingStyleDefaultParameters.layersCount, q = Z.Csiz;
            let ie = 0;
            for (let se = 0; se < q; se++)
              ie = Math.max(ie, G.components[se].codingStyleParameters.decompositionLevelsCount);
            let oe = 0, fe = 0, Y = 0, ae = 0;
            this.nextPacket = function() {
              for (; oe < N; oe++) {
                for (; fe <= ie; fe++) {
                  for (; Y < q; Y++) {
                    const L = G.components[Y];
                    if (fe > L.codingStyleParameters.decompositionLevelsCount)
                      continue;
                    const W = L.resolutions[fe], M = W.precinctParameters.numprecincts;
                    for (; ae < M; ) {
                      const X = b(W, ae, oe);
                      return ae++, X;
                    }
                    ae = 0;
                  }
                  Y = 0;
                }
                fe = 0;
              }
              throw new t("Out of packets");
            };
          }
          function I(ne) {
            const Z = ne.SIZ, te = ne.currentTile.index, G = ne.tiles[te], N = G.codingStyleDefaultParameters.layersCount, q = Z.Csiz;
            let ie = 0;
            for (let se = 0; se < q; se++)
              ie = Math.max(ie, G.components[se].codingStyleParameters.decompositionLevelsCount);
            let oe = 0, fe = 0, Y = 0, ae = 0;
            this.nextPacket = function() {
              for (; oe <= ie; oe++) {
                for (; fe < N; fe++) {
                  for (; Y < q; Y++) {
                    const L = G.components[Y];
                    if (oe > L.codingStyleParameters.decompositionLevelsCount)
                      continue;
                    const W = L.resolutions[oe], M = W.precinctParameters.numprecincts;
                    for (; ae < M; ) {
                      const X = b(W, ae, fe);
                      return ae++, X;
                    }
                    ae = 0;
                  }
                  Y = 0;
                }
                fe = 0;
              }
              throw new t("Out of packets");
            };
          }
          function O(ne) {
            const Z = ne.SIZ, te = ne.currentTile.index, G = ne.tiles[te], N = G.codingStyleDefaultParameters.layersCount, q = Z.Csiz;
            let ie, oe, fe, Y, ae = 0;
            for (fe = 0; fe < q; fe++) {
              const L = G.components[fe];
              ae = Math.max(ae, L.codingStyleParameters.decompositionLevelsCount);
            }
            const se = new Int32Array(ae + 1);
            for (oe = 0; oe <= ae; ++oe) {
              let L = 0;
              for (fe = 0; fe < q; ++fe) {
                const W = G.components[fe].resolutions;
                oe < W.length && (L = Math.max(L, W[oe].precinctParameters.numprecincts));
              }
              se[oe] = L;
            }
            ie = 0, oe = 0, fe = 0, Y = 0, this.nextPacket = function() {
              for (; oe <= ae; oe++) {
                for (; Y < se[oe]; Y++) {
                  for (; fe < q; fe++) {
                    const W = G.components[fe];
                    if (oe > W.codingStyleParameters.decompositionLevelsCount)
                      continue;
                    const M = W.resolutions[oe], X = M.precinctParameters.numprecincts;
                    if (!(Y >= X)) {
                      for (; ie < N; ) {
                        const U = b(M, Y, ie);
                        return ie++, U;
                      }
                      ie = 0;
                    }
                  }
                  fe = 0;
                }
                Y = 0;
              }
              throw new t("Out of packets");
            };
          }
          function D(ne) {
            const Z = ne.SIZ, te = ne.currentTile.index, G = ne.tiles[te], N = G.codingStyleDefaultParameters.layersCount, q = Z.Csiz, ie = H(G), oe = ie;
            let fe = 0, Y = 0, ae = 0, se = 0, L = 0;
            this.nextPacket = function() {
              for (; L < oe.maxNumHigh; L++) {
                for (; se < oe.maxNumWide; se++) {
                  for (; ae < q; ae++) {
                    const M = G.components[ae], X = M.codingStyleParameters.decompositionLevelsCount;
                    for (; Y <= X; Y++) {
                      const U = M.resolutions[Y], Q = ie.components[ae].resolutions[Y], re = K(se, L, Q, oe, U);
                      if (re !== null) {
                        for (; fe < N; ) {
                          const le = b(U, re, fe);
                          return fe++, le;
                        }
                        fe = 0;
                      }
                    }
                    Y = 0;
                  }
                  ae = 0;
                }
                se = 0;
              }
              throw new t("Out of packets");
            };
          }
          function $(ne) {
            const Z = ne.SIZ, te = ne.currentTile.index, G = ne.tiles[te], N = G.codingStyleDefaultParameters.layersCount, q = Z.Csiz, ie = H(G);
            let oe = 0, fe = 0, Y = 0, ae = 0, se = 0;
            this.nextPacket = function() {
              for (; Y < q; ++Y) {
                const W = G.components[Y], M = ie.components[Y], X = W.codingStyleParameters.decompositionLevelsCount;
                for (; se < M.maxNumHigh; se++) {
                  for (; ae < M.maxNumWide; ae++) {
                    for (; fe <= X; fe++) {
                      const U = W.resolutions[fe], Q = M.resolutions[fe], re = K(ae, se, Q, M, U);
                      if (re !== null) {
                        for (; oe < N; ) {
                          const le = b(U, re, oe);
                          return oe++, le;
                        }
                        oe = 0;
                      }
                    }
                    fe = 0;
                  }
                  ae = 0;
                }
                se = 0;
              }
              throw new t("Out of packets");
            };
          }
          function K(ne, Z, te, G, N) {
            const q = ne * G.minWidth, ie = Z * G.minHeight;
            if (q % te.width !== 0 || ie % te.height !== 0)
              return null;
            const oe = ie / te.width * N.precinctParameters.numprecinctswide;
            return q / te.height + oe;
          }
          function H(ne) {
            const Z = ne.components.length;
            let te = Number.MAX_VALUE, G = Number.MAX_VALUE, N = 0, q = 0;
            const ie = new Array(Z);
            for (let oe = 0; oe < Z; oe++) {
              const fe = ne.components[oe], Y = fe.codingStyleParameters.decompositionLevelsCount, ae = new Array(Y + 1);
              let se = Number.MAX_VALUE, L = Number.MAX_VALUE, W = 0, M = 0, X = 1;
              for (let U = Y; U >= 0; --U) {
                const Q = fe.resolutions[U], re = X * Q.precinctParameters.precinctWidth, le = X * Q.precinctParameters.precinctHeight;
                se = Math.min(se, re), L = Math.min(L, le), W = Math.max(W, Q.precinctParameters.numprecinctswide), M = Math.max(M, Q.precinctParameters.numprecinctshigh), ae[U] = {
                  width: re,
                  height: le
                }, X <<= 1;
              }
              te = Math.min(te, se), G = Math.min(G, L), N = Math.max(N, W), q = Math.max(q, M), ie[oe] = {
                resolutions: ae,
                minWidth: se,
                minHeight: L,
                maxNumWide: W,
                maxNumHigh: M
              };
            }
            return {
              components: ie,
              minWidth: te,
              minHeight: G,
              maxNumWide: N,
              maxNumHigh: q
            };
          }
          function B(ne) {
            const Z = ne.SIZ, te = ne.currentTile.index, G = ne.tiles[te], N = Z.Csiz;
            for (let ie = 0; ie < N; ie++) {
              const oe = G.components[ie], fe = oe.codingStyleParameters.decompositionLevelsCount, Y = [], ae = [];
              for (let se = 0; se <= fe; se++) {
                const L = S(ne, oe, se), W = {}, M = 1 << fe - se;
                W.trx0 = Math.ceil(oe.tcx0 / M), W.try0 = Math.ceil(oe.tcy0 / M), W.trx1 = Math.ceil(oe.tcx1 / M), W.try1 = Math.ceil(oe.tcy1 / M), W.resLevel = se, y(ne, W, L), Y.push(W);
                let X;
                if (se === 0)
                  X = {}, X.type = "LL", X.tbx0 = Math.ceil(oe.tcx0 / M), X.tby0 = Math.ceil(oe.tcy0 / M), X.tbx1 = Math.ceil(oe.tcx1 / M), X.tby1 = Math.ceil(oe.tcy1 / M), X.resolution = W, x(ne, X, L), ae.push(X), W.subbands = [X];
                else {
                  const U = 1 << fe - se + 1, Q = [];
                  X = {}, X.type = "HL", X.tbx0 = Math.ceil(oe.tcx0 / U - 0.5), X.tby0 = Math.ceil(oe.tcy0 / U), X.tbx1 = Math.ceil(oe.tcx1 / U - 0.5), X.tby1 = Math.ceil(oe.tcy1 / U), X.resolution = W, x(ne, X, L), ae.push(X), Q.push(X), X = {}, X.type = "LH", X.tbx0 = Math.ceil(oe.tcx0 / U), X.tby0 = Math.ceil(oe.tcy0 / U - 0.5), X.tbx1 = Math.ceil(oe.tcx1 / U), X.tby1 = Math.ceil(oe.tcy1 / U - 0.5), X.resolution = W, x(ne, X, L), ae.push(X), Q.push(X), X = {}, X.type = "HH", X.tbx0 = Math.ceil(oe.tcx0 / U - 0.5), X.tby0 = Math.ceil(oe.tcy0 / U - 0.5), X.tbx1 = Math.ceil(oe.tcx1 / U - 0.5), X.tby1 = Math.ceil(oe.tcy1 / U - 0.5), X.resolution = W, x(ne, X, L), ae.push(X), Q.push(X), W.subbands = Q;
                }
              }
              oe.resolutions = Y, oe.subbands = ae;
            }
            const q = G.codingStyleDefaultParameters.progressionOrder;
            switch (q) {
              case 0:
                G.packetsIterator = new u(ne);
                break;
              case 1:
                G.packetsIterator = new I(ne);
                break;
              case 2:
                G.packetsIterator = new O(ne);
                break;
              case 3:
                G.packetsIterator = new D(ne);
                break;
              case 4:
                G.packetsIterator = new $(ne);
                break;
              default:
                throw new t(`Unsupported progression order ${q}`);
            }
          }
          function R(ne, Z, te, G) {
            let N = 0, q, ie = 0, oe = !1;
            function fe(re) {
              for (; ie < re; ) {
                const le = Z[te + N];
                N++, oe ? (q = q << 7 | le, ie += 7, oe = !1) : (q = q << 8 | le, ie += 8), le === 255 && (oe = !0);
              }
              return ie -= re, q >>> ie & (1 << re) - 1;
            }
            function Y(re) {
              return Z[te + N - 1] === 255 && Z[te + N] === re ? (ae(1), !0) : Z[te + N] === 255 && Z[te + N + 1] === re ? (ae(2), !0) : !1;
            }
            function ae(re) {
              N += re;
            }
            function se() {
              ie = 0, oe && (N++, oe = !1);
            }
            function L() {
              if (fe(1) === 0)
                return 1;
              if (fe(1) === 0)
                return 2;
              let re = fe(2);
              return re < 3 ? re + 3 : (re = fe(5), re < 31 ? re + 6 : (re = fe(7), re + 37));
            }
            const W = ne.currentTile.index, M = ne.tiles[W], X = ne.COD.sopMarkerUsed, U = ne.COD.ephMarkerUsed, Q = M.packetsIterator;
            for (; N < G; ) {
              se(), X && Y(145) && ae(4);
              const re = Q.nextPacket();
              if (!fe(1))
                continue;
              const le = re.layerNumber, ce = [];
              let ee;
              for (let he = 0, pe = re.codeblocks.length; he < pe; he++) {
                ee = re.codeblocks[he];
                let de = ee.precinct;
                const ge = ee.cbx - de.cbxMin, me = ee.cby - de.cbyMin;
                let xe = !1, ye = !1, ve, Ce;
                if (ee.included !== void 0)
                  xe = !!fe(1);
                else {
                  de = ee.precinct;
                  let Be;
                  if (de.inclusionTree !== void 0)
                    Be = de.inclusionTree;
                  else {
                    const ke = de.cbxMax - de.cbxMin + 1, be = de.cbyMax - de.cbyMin + 1;
                    Be = new w(ke, be, le), Ce = new T(ke, be), de.inclusionTree = Be, de.zeroBitPlanesTree = Ce;
                    for (let we = 0; we < le; we++)
                      if (fe(1) !== 0)
                        throw new t("Invalid tag tree");
                  }
                  if (Be.reset(ge, me, le))
                    for (; ; )
                      if (fe(1)) {
                        if (ve = !Be.nextLevel(), ve) {
                          ee.included = !0, xe = ye = !0;
                          break;
                        }
                      } else {
                        Be.incrementValue(le);
                        break;
                      }
                }
                if (!xe)
                  continue;
                if (ye) {
                  for (Ce = de.zeroBitPlanesTree, Ce.reset(ge, me); ; )
                    if (fe(1)) {
                      if (ve = !Ce.nextLevel(), ve)
                        break;
                    } else
                      Ce.incrementValue();
                  ee.zeroBitPlanes = Ce.value;
                }
                const Ie = L();
                for (; fe(1); )
                  ee.Lblock++;
                const Ae = (0, h.log2)(Ie), Se = (Ie < 1 << Ae ? Ae - 1 : Ae) + ee.Lblock, De = fe(Se);
                ce.push({
                  codeblock: ee,
                  codingpasses: Ie,
                  dataLength: De
                });
              }
              for (se(), U && Y(146); ce.length > 0; ) {
                const he = ce.shift();
                ee = he.codeblock, ee.data === void 0 && (ee.data = []), ee.data.push({
                  data: Z,
                  start: te + N,
                  end: te + N + he.dataLength,
                  codingpasses: he.codingpasses
                }), N += he.dataLength;
              }
            }
            return N;
          }
          function _(ne, Z, te, G, N, q, ie, oe, fe) {
            const Y = G.tbx0, ae = G.tby0, se = G.tbx1 - G.tbx0, L = G.codeblocks, W = G.type.charAt(0) === "H" ? 1 : 0, M = G.type.charAt(1) === "H" ? Z : 0;
            for (let X = 0, U = L.length; X < U; ++X) {
              const Q = L[X], re = Q.tbx1_ - Q.tbx0_, le = Q.tby1_ - Q.tby0_;
              if (re === 0 || le === 0 || Q.data === void 0)
                continue;
              const ce = new F(re, le, Q.subbandType, Q.zeroBitPlanes, q);
              let ee = 2;
              const he = Q.data;
              let pe = 0, de = 0, ge, me, xe;
              for (ge = 0, me = he.length; ge < me; ge++)
                xe = he[ge], pe += xe.end - xe.start, de += xe.codingpasses;
              const ye = new Uint8Array(pe);
              let ve = 0;
              for (ge = 0, me = he.length; ge < me; ge++) {
                xe = he[ge];
                const Re = xe.data.subarray(xe.start, xe.end);
                ye.set(Re, ve), ve += Re.length;
              }
              const Ce = new g.ArithmeticDecoder(ye, 0, pe);
              for (ce.setDecoder(Ce), ge = 0; ge < de; ge++) {
                switch (ee) {
                  case 0:
                    ce.runSignificancePropagationPass();
                    break;
                  case 1:
                    ce.runMagnitudeRefinementPass();
                    break;
                  case 2:
                    ce.runCleanupPass(), oe && ce.checkSegmentationSymbol();
                    break;
                }
                fe && ce.reset(), ee = (ee + 1) % 3;
              }
              let Ie = Q.tbx0_ - Y + (Q.tby0_ - ae) * se;
              const Ae = ce.coefficentsSign, Se = ce.coefficentsMagnitude, De = ce.bitsDecoded, Be = ie ? 0 : 0.5;
              let ke, be, we;
              ve = 0;
              const Le = G.type !== "LL";
              for (ge = 0; ge < le; ge++) {
                const ct = 2 * (Ie / se | 0) * (Z - se) + W + M;
                for (ke = 0; ke < re; ke++) {
                  if (be = Se[ve], be !== 0) {
                    be = (be + Be) * N, Ae[ve] !== 0 && (be = -be), we = De[ve];
                    const ft = Le ? ct + (Ie << 1) : Ie;
                    ne[ft] = ie && we >= q ? be : be * (1 << q - we);
                  }
                  Ie++, ve++;
                }
                Ie += se - re;
              }
            }
          }
          function A(ne, Z, te) {
            const G = Z.components[te], N = G.codingStyleParameters, q = G.quantizationParameters, ie = N.decompositionLevelsCount, oe = q.SPqcds, fe = q.scalarExpounded, Y = q.guardBits, ae = N.segmentationSymbolUsed, se = N.resetContextProbabilities, L = ne.components[te].precision, W = N.reversibleTransformation, M = W ? new V() : new P(), X = [];
            let U = 0;
            for (let re = 0; re <= ie; re++) {
              const le = G.resolutions[re], ce = le.trx1 - le.trx0, ee = le.try1 - le.try0, he = new Float32Array(ce * ee);
              for (let pe = 0, de = le.subbands.length; pe < de; pe++) {
                let ge, me;
                fe ? (ge = oe[U].mu, me = oe[U].epsilon, U++) : (ge = oe[0].mu, me = oe[0].epsilon + (re > 0 ? 1 - re : 0));
                const xe = le.subbands[pe], ye = i[xe.type], ve = W ? 1 : 2 ** (L + ye - me) * (1 + ge / 2048), Ce = Y + me - 1;
                _(he, ce, ee, xe, ve, Ce, W, ae, se);
              }
              X.push({
                width: ce,
                height: ee,
                items: he
              });
            }
            const Q = M.calculate(X, G.tcx0, G.tcy0);
            return {
              left: G.tcx0,
              top: G.tcy0,
              width: Q.width,
              height: Q.height,
              items: Q.items
            };
          }
          function k(ne) {
            const Z = ne.SIZ, te = ne.components, G = Z.Csiz, N = [];
            for (let q = 0, ie = ne.tiles.length; q < ie; q++) {
              const oe = ne.tiles[q], fe = [];
              for (let ce = 0; ce < G; ce++)
                fe[ce] = A(ne, oe, ce);
              const Y = fe[0], ae = new Uint8ClampedArray(Y.items.length * G), se = {
                left: Y.left,
                top: Y.top,
                width: Y.width,
                height: Y.height,
                items: ae
              };
              let L, W, M = 0, X, U, Q, re, le;
              if (oe.codingStyleDefaultParameters.multipleComponentTransform) {
                const ce = G === 4, ee = fe[0].items, he = fe[1].items, pe = fe[2].items, de = ce ? fe[3].items : null;
                L = te[0].precision - 8, W = (128 << L) + 0.5;
                const ge = oe.components[0], me = G - 3;
                if (U = ee.length, ge.codingStyleParameters.reversibleTransformation)
                  for (X = 0; X < U; X++, M += me) {
                    Q = ee[X] + W, re = he[X], le = pe[X];
                    const xe = Q - (le + re >> 2);
                    ae[M++] = xe + le >> L, ae[M++] = xe >> L, ae[M++] = xe + re >> L;
                  }
                else
                  for (X = 0; X < U; X++, M += me)
                    Q = ee[X] + W, re = he[X], le = pe[X], ae[M++] = Q + 1.402 * le >> L, ae[M++] = Q - 0.34413 * re - 0.71414 * le >> L, ae[M++] = Q + 1.772 * re >> L;
                if (ce)
                  for (X = 0, M = 3; X < U; X++, M += 4)
                    ae[M] = de[X] + W >> L;
              } else
                for (let ce = 0; ce < G; ce++) {
                  const ee = fe[ce].items;
                  for (L = te[ce].precision - 8, W = (128 << L) + 0.5, M = ce, X = 0, U = ee.length; X < U; X++)
                    ae[M] = ee[X] + W >> L, M += G;
                }
              N.push(se);
            }
            return N;
          }
          function z(ne, Z) {
            const G = ne.SIZ.Csiz, N = ne.tiles[Z];
            for (let q = 0; q < G; q++) {
              const ie = N.components[q], oe = ne.currentTile.QCC[q] !== void 0 ? ne.currentTile.QCC[q] : ne.currentTile.QCD;
              ie.quantizationParameters = oe;
              const fe = ne.currentTile.COC[q] !== void 0 ? ne.currentTile.COC[q] : ne.currentTile.COD;
              ie.codingStyleParameters = fe;
            }
            N.codingStyleDefaultParameters = ne.currentTile.COD;
          }
          class T {
            constructor(Z, te) {
              const G = (0, h.log2)(Math.max(Z, te)) + 1;
              this.levels = [];
              for (let N = 0; N < G; N++) {
                const q = {
                  width: Z,
                  height: te,
                  items: []
                };
                this.levels.push(q), Z = Math.ceil(Z / 2), te = Math.ceil(te / 2);
              }
            }
            reset(Z, te) {
              let G = 0, N = 0, q;
              for (; G < this.levels.length; ) {
                q = this.levels[G];
                const ie = Z + te * q.width;
                if (q.items[ie] !== void 0) {
                  N = q.items[ie];
                  break;
                }
                q.index = ie, Z >>= 1, te >>= 1, G++;
              }
              G--, q = this.levels[G], q.items[q.index] = N, this.currentLevel = G, delete this.value;
            }
            incrementValue() {
              const Z = this.levels[this.currentLevel];
              Z.items[Z.index]++;
            }
            nextLevel() {
              let Z = this.currentLevel, te = this.levels[Z];
              const G = te.items[te.index];
              return Z--, Z < 0 ? (this.value = G, !1) : (this.currentLevel = Z, te = this.levels[Z], te.items[te.index] = G, !0);
            }
          }
          class w {
            constructor(Z, te, G) {
              const N = (0, h.log2)(Math.max(Z, te)) + 1;
              this.levels = [];
              for (let q = 0; q < N; q++) {
                const ie = new Uint8Array(Z * te);
                for (let fe = 0, Y = ie.length; fe < Y; fe++)
                  ie[fe] = G;
                const oe = {
                  width: Z,
                  height: te,
                  items: ie
                };
                this.levels.push(oe), Z = Math.ceil(Z / 2), te = Math.ceil(te / 2);
              }
            }
            reset(Z, te, G) {
              let N = 0;
              for (; N < this.levels.length; ) {
                const q = this.levels[N], ie = Z + te * q.width;
                q.index = ie;
                const oe = q.items[ie];
                if (oe === 255)
                  break;
                if (oe > G)
                  return this.currentLevel = N, this.propagateValues(), !1;
                Z >>= 1, te >>= 1, N++;
              }
              return this.currentLevel = N - 1, !0;
            }
            incrementValue(Z) {
              const te = this.levels[this.currentLevel];
              te.items[te.index] = Z + 1, this.propagateValues();
            }
            propagateValues() {
              let Z = this.currentLevel, te = this.levels[Z];
              const G = te.items[te.index];
              for (; --Z >= 0; )
                te = this.levels[Z], te.items[te.index] = G;
            }
            nextLevel() {
              let Z = this.currentLevel, te = this.levels[Z];
              const G = te.items[te.index];
              return te.items[te.index] = 255, Z--, Z < 0 ? !1 : (this.currentLevel = Z, te = this.levels[Z], te.items[te.index] = G, !0);
            }
          }
          const J = class J {
            constructor(Z, te, G, N, q) {
              this.width = Z, this.height = te;
              let ie;
              G === "HH" ? ie = J.HHContextLabel : G === "HL" ? ie = J.HLContextLabel : ie = J.LLAndLHContextsLabel, this.contextLabelTable = ie;
              const oe = Z * te;
              this.neighborsSignificance = new Uint8Array(oe), this.coefficentsSign = new Uint8Array(oe);
              let fe;
              q > 14 ? fe = new Uint32Array(oe) : q > 6 ? fe = new Uint16Array(oe) : fe = new Uint8Array(oe), this.coefficentsMagnitude = fe, this.processingFlags = new Uint8Array(oe);
              const Y = new Uint8Array(oe);
              if (N !== 0)
                for (let ae = 0; ae < oe; ae++)
                  Y[ae] = N;
              this.bitsDecoded = Y, this.reset();
            }
            setDecoder(Z) {
              this.decoder = Z;
            }
            reset() {
              this.contexts = new Int8Array(19), this.contexts[0] = 8, this.contexts[J.UNIFORM_CONTEXT] = 92, this.contexts[J.RUNLENGTH_CONTEXT] = 6;
            }
            setNeighborsSignificance(Z, te, G) {
              const N = this.neighborsSignificance, q = this.width, ie = this.height, oe = te > 0, fe = te + 1 < q;
              let Y;
              Z > 0 && (Y = G - q, oe && (N[Y - 1] += 16), fe && (N[Y + 1] += 16), N[Y] += 4), Z + 1 < ie && (Y = G + q, oe && (N[Y - 1] += 16), fe && (N[Y + 1] += 16), N[Y] += 4), oe && (N[G - 1] += 1), fe && (N[G + 1] += 1), N[G] |= 128;
            }
            runSignificancePropagationPass() {
              const Z = this.decoder, te = this.width, G = this.height, N = this.coefficentsMagnitude, q = this.coefficentsSign, ie = this.neighborsSignificance, oe = this.processingFlags, fe = this.contexts, Y = this.contextLabelTable, ae = this.bitsDecoded, se = -2, L = 1, W = 2;
              for (let M = 0; M < G; M += 4)
                for (let X = 0; X < te; X++) {
                  let U = M * te + X;
                  for (let Q = 0; Q < 4; Q++, U += te) {
                    const re = M + Q;
                    if (re >= G)
                      break;
                    if (oe[U] &= se, N[U] || !ie[U])
                      continue;
                    const le = Y[ie[U]];
                    if (Z.readBit(fe, le)) {
                      const ee = this.decodeSignBit(re, X, U);
                      q[U] = ee, N[U] = 1, this.setNeighborsSignificance(re, X, U), oe[U] |= W;
                    }
                    ae[U]++, oe[U] |= L;
                  }
                }
            }
            decodeSignBit(Z, te, G) {
              const N = this.width, q = this.height, ie = this.coefficentsMagnitude, oe = this.coefficentsSign;
              let fe, Y, ae, se, L, W;
              se = te > 0 && ie[G - 1] !== 0, te + 1 < N && ie[G + 1] !== 0 ? (ae = oe[G + 1], se ? (Y = oe[G - 1], fe = 1 - ae - Y) : fe = 1 - ae - ae) : se ? (Y = oe[G - 1], fe = 1 - Y - Y) : fe = 0;
              const M = 3 * fe;
              return se = Z > 0 && ie[G - N] !== 0, Z + 1 < q && ie[G + N] !== 0 ? (ae = oe[G + N], se ? (Y = oe[G - N], fe = 1 - ae - Y + M) : fe = 1 - ae - ae + M) : se ? (Y = oe[G - N], fe = 1 - Y - Y + M) : fe = M, fe >= 0 ? (L = 9 + fe, W = this.decoder.readBit(this.contexts, L)) : (L = 9 - fe, W = this.decoder.readBit(this.contexts, L) ^ 1), W;
            }
            runMagnitudeRefinementPass() {
              const Z = this.decoder, te = this.width, G = this.height, N = this.coefficentsMagnitude, q = this.neighborsSignificance, ie = this.contexts, oe = this.bitsDecoded, fe = this.processingFlags, Y = 1, ae = 2, se = te * G, L = te * 4;
              for (let W = 0, M; W < se; W = M) {
                M = Math.min(se, W + L);
                for (let X = 0; X < te; X++)
                  for (let U = W + X; U < M; U += te) {
                    if (!N[U] || fe[U] & Y)
                      continue;
                    let Q = 16;
                    fe[U] & ae && (fe[U] ^= ae, Q = (q[U] & 127) === 0 ? 15 : 14);
                    const re = Z.readBit(ie, Q);
                    N[U] = N[U] << 1 | re, oe[U]++, fe[U] |= Y;
                  }
              }
            }
            runCleanupPass() {
              const Z = this.decoder, te = this.width, G = this.height, N = this.neighborsSignificance, q = this.coefficentsMagnitude, ie = this.coefficentsSign, oe = this.contexts, fe = this.contextLabelTable, Y = this.bitsDecoded, ae = this.processingFlags, se = 1, L = 2, W = te, M = te * 2, X = te * 3;
              let U;
              for (let Q = 0; Q < G; Q = U) {
                U = Math.min(Q + 4, G);
                const re = Q * te, le = Q + 3 < G;
                for (let ce = 0; ce < te; ce++) {
                  const ee = re + ce, he = le && ae[ee] === 0 && ae[ee + W] === 0 && ae[ee + M] === 0 && ae[ee + X] === 0 && N[ee] === 0 && N[ee + W] === 0 && N[ee + M] === 0 && N[ee + X] === 0;
                  let pe = 0, de = ee, ge = Q, me;
                  if (he) {
                    if (!Z.readBit(oe, J.RUNLENGTH_CONTEXT)) {
                      Y[ee]++, Y[ee + W]++, Y[ee + M]++, Y[ee + X]++;
                      continue;
                    }
                    pe = Z.readBit(oe, J.UNIFORM_CONTEXT) << 1 | Z.readBit(oe, J.UNIFORM_CONTEXT), pe !== 0 && (ge = Q + pe, de += pe * te), me = this.decodeSignBit(ge, ce, de), ie[de] = me, q[de] = 1, this.setNeighborsSignificance(ge, ce, de), ae[de] |= L, de = ee;
                    for (let ye = Q; ye <= ge; ye++, de += te)
                      Y[de]++;
                    pe++;
                  }
                  for (ge = Q + pe; ge < U; ge++, de += te) {
                    if (q[de] || ae[de] & se)
                      continue;
                    const xe = fe[N[de]];
                    Z.readBit(oe, xe) === 1 && (me = this.decodeSignBit(ge, ce, de), ie[de] = me, q[de] = 1, this.setNeighborsSignificance(ge, ce, de), ae[de] |= L), Y[de]++;
                  }
                }
              }
            }
            checkSegmentationSymbol() {
              const Z = this.decoder, te = this.contexts;
              if ((Z.readBit(te, J.UNIFORM_CONTEXT) << 3 | Z.readBit(te, J.UNIFORM_CONTEXT) << 2 | Z.readBit(te, J.UNIFORM_CONTEXT) << 1 | Z.readBit(te, J.UNIFORM_CONTEXT)) !== 10)
                throw new t("Invalid segmentation symbol");
            }
          };
          ni(J, "UNIFORM_CONTEXT", 17), ni(J, "RUNLENGTH_CONTEXT", 18), ni(J, "LLAndLHContextsLabel", new Uint8Array([0, 5, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 1, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8])), ni(J, "HLContextLabel", new Uint8Array([0, 3, 4, 0, 5, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 1, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8])), ni(J, "HHContextLabel", new Uint8Array([0, 1, 2, 0, 1, 2, 2, 0, 2, 2, 2, 0, 0, 0, 0, 0, 3, 4, 5, 0, 4, 5, 5, 0, 5, 5, 5, 0, 0, 0, 0, 0, 6, 7, 7, 0, 7, 7, 7, 0, 7, 7, 7, 0, 0, 0, 0, 0, 8, 8, 8, 0, 8, 8, 8, 0, 8, 8, 8, 0, 0, 0, 0, 0, 8, 8, 8, 0, 8, 8, 8, 0, 8, 8, 8]));
          let F = J;
          class j {
            constructor() {
              this.constructor === j && (0, s.unreachable)("Cannot initialize Transform.");
            }
            calculate(Z, te, G) {
              let N = Z[0];
              for (let q = 1, ie = Z.length; q < ie; q++)
                N = this.iterate(N, Z[q], te, G);
              return N;
            }
            extend(Z, te, G) {
              let N = te - 1, q = te + 1, ie = te + G - 2, oe = te + G;
              Z[N--] = Z[q++], Z[oe++] = Z[ie--], Z[N--] = Z[q++], Z[oe++] = Z[ie--], Z[N--] = Z[q++], Z[oe++] = Z[ie--], Z[N] = Z[q], Z[oe] = Z[ie];
            }
            filter(Z, te, G) {
              (0, s.unreachable)("Abstract method `filter` called");
            }
            iterate(Z, te, G, N) {
              const q = Z.width, ie = Z.height;
              let oe = Z.items;
              const fe = te.width, Y = te.height, ae = te.items;
              let se, L, W, M, X, U;
              for (W = 0, se = 0; se < ie; se++)
                for (M = se * 2 * fe, L = 0; L < q; L++, W++, M += 2)
                  ae[M] = oe[W];
              oe = Z.items = null;
              const Q = 4, re = new Float32Array(fe + 2 * Q);
              if (fe === 1) {
                if (G & 1)
                  for (U = 0, W = 0; U < Y; U++, W += fe)
                    ae[W] *= 0.5;
              } else
                for (U = 0, W = 0; U < Y; U++, W += fe)
                  re.set(ae.subarray(W, W + fe), Q), this.extend(re, Q, fe), this.filter(re, Q, fe), ae.set(re.subarray(Q, Q + fe), W);
              let le = 16;
              const ce = [];
              for (se = 0; se < le; se++)
                ce.push(new Float32Array(Y + 2 * Q));
              let ee, he = 0;
              if (Z = Q + Y, Y === 1) {
                if (N & 1)
                  for (X = 0; X < fe; X++)
                    ae[X] *= 0.5;
              } else
                for (X = 0; X < fe; X++) {
                  if (he === 0) {
                    for (le = Math.min(fe - X, le), W = X, M = Q; M < Z; W += fe, M++)
                      for (ee = 0; ee < le; ee++)
                        ce[ee][M] = ae[W + ee];
                    he = le;
                  }
                  he--;
                  const pe = ce[he];
                  if (this.extend(pe, Q, Y), this.filter(pe, Q, Y), he === 0)
                    for (W = X - le + 1, M = Q; M < Z; W += fe, M++)
                      for (ee = 0; ee < le; ee++)
                        ae[W + ee] = ce[ee][M];
                }
              return {
                width: fe,
                height: Y,
                items: ae
              };
            }
          }
          class P extends j {
            filter(Z, te, G) {
              const N = G >> 1;
              te |= 0;
              let q, ie, oe, fe;
              const Y = -1.586134342059924, ae = -0.052980118572961, se = 0.882911075530934, L = 0.443506852043971, W = 1.230174104914001, M = 1 / W;
              for (q = te - 3, ie = N + 4; ie--; q += 2)
                Z[q] *= M;
              for (q = te - 2, oe = L * Z[q - 1], ie = N + 3; ie-- && (fe = L * Z[q + 1], Z[q] = W * Z[q] - oe - fe, ie--); q += 2)
                q += 2, oe = L * Z[q + 1], Z[q] = W * Z[q] - oe - fe;
              for (q = te - 1, oe = se * Z[q - 1], ie = N + 2; ie-- && (fe = se * Z[q + 1], Z[q] -= oe + fe, ie--); q += 2)
                q += 2, oe = se * Z[q + 1], Z[q] -= oe + fe;
              for (q = te, oe = ae * Z[q - 1], ie = N + 1; ie-- && (fe = ae * Z[q + 1], Z[q] -= oe + fe, ie--); q += 2)
                q += 2, oe = ae * Z[q + 1], Z[q] -= oe + fe;
              if (N !== 0)
                for (q = te + 1, oe = Y * Z[q - 1], ie = N; ie-- && (fe = Y * Z[q + 1], Z[q] -= oe + fe, ie--); q += 2)
                  q += 2, oe = Y * Z[q + 1], Z[q] -= oe + fe;
            }
          }
          class V extends j {
            filter(Z, te, G) {
              const N = G >> 1;
              te |= 0;
              let q, ie;
              for (q = te, ie = N + 1; ie--; q += 2)
                Z[q] -= Z[q - 1] + Z[q + 1] + 2 >> 2;
              for (q = te + 1, ie = N; ie--; q += 2)
                Z[q] += Z[q - 1] + Z[q + 1] >> 1;
            }
          }
        },
        /* 31 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.LZWStream = void 0;
          var s = f(18);
          class h extends s.DecodeStream {
            constructor(t, i, m) {
              super(i), this.str = t, this.dict = t.dict, this.cachedData = 0, this.bitsCached = 0;
              const v = 4096, E = {
                earlyChange: m,
                codeLength: 9,
                nextCode: 258,
                dictionaryValues: new Uint8Array(v),
                dictionaryLengths: new Uint16Array(v),
                dictionaryPrevCodes: new Uint16Array(v),
                currentSequence: new Uint8Array(v),
                currentSequenceLength: 0
              };
              for (let S = 0; S < 256; ++S)
                E.dictionaryValues[S] = S, E.dictionaryLengths[S] = 1;
              this.lzwState = E;
            }
            readBits(t) {
              let i = this.bitsCached, m = this.cachedData;
              for (; i < t; ) {
                const v = this.str.getByte();
                if (v === -1)
                  return this.eof = !0, null;
                m = m << 8 | v, i += 8;
              }
              return this.bitsCached = i -= t, this.cachedData = m, this.lastCode = null, m >>> i & (1 << t) - 1;
            }
            readBlock() {
              let m = 1024, v, E, S;
              const y = this.lzwState;
              if (!y)
                return;
              const x = y.earlyChange;
              let b = y.nextCode;
              const u = y.dictionaryValues, I = y.dictionaryLengths, O = y.dictionaryPrevCodes;
              let D = y.codeLength, $ = y.prevCode;
              const K = y.currentSequence;
              let H = y.currentSequenceLength, B = 0, R = this.bufferLength, _ = this.ensureBuffer(this.bufferLength + m);
              for (v = 0; v < 512; v++) {
                const A = this.readBits(D), k = H > 0;
                if (A < 256)
                  K[0] = A, H = 1;
                else if (A >= 258)
                  if (A < b)
                    for (H = I[A], E = H - 1, S = A; E >= 0; E--)
                      K[E] = u[S], S = O[S];
                  else
                    K[H++] = K[0];
                else if (A === 256) {
                  D = 9, b = 258, H = 0;
                  continue;
                } else {
                  this.eof = !0, delete this.lzwState;
                  break;
                }
                if (k && (O[b] = $, I[b] = I[$] + 1, u[b] = K[0], b++, D = b + x & b + x - 1 ? D : Math.min(Math.log(b + x) / 0.6931471805599453 + 1, 12) | 0), $ = A, B += H, m < B) {
                  do
                    m += 512;
                  while (m < B);
                  _ = this.ensureBuffer(this.bufferLength + m);
                }
                for (E = 0; E < H; E++)
                  _[R++] = K[E];
              }
              y.nextCode = b, y.codeLength = D, y.prevCode = $, y.currentSequenceLength = H, this.bufferLength = R;
            }
          }
          c.LZWStream = h;
        },
        /* 32 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.PredictorStream = void 0;
          var s = f(18), h = f(4), g = f(2);
          class t extends s.DecodeStream {
            constructor(m, v, E) {
              if (super(v), !(E instanceof h.Dict))
                return m;
              const S = this.predictor = E.get("Predictor") || 1;
              if (S <= 1)
                return m;
              if (S !== 2 && (S < 10 || S > 15))
                throw new g.FormatError(`Unsupported predictor: ${S}`);
              this.readBlock = S === 2 ? this.readBlockTiff : this.readBlockPng, this.str = m, this.dict = m.dict;
              const y = this.colors = E.get("Colors") || 1, x = this.bits = E.get("BPC", "BitsPerComponent") || 8, b = this.columns = E.get("Columns") || 1;
              return this.pixBytes = y * x + 7 >> 3, this.rowBytes = b * y * x + 7 >> 3, this;
            }
            readBlockTiff() {
              const m = this.rowBytes, v = this.bufferLength, E = this.ensureBuffer(v + m), S = this.bits, y = this.colors, x = this.str.getBytes(m);
              if (this.eof = !x.length, this.eof)
                return;
              let b = 0, u = 0, I = 0, O = 0, D = v, $;
              if (S === 1 && y === 1)
                for ($ = 0; $ < m; ++$) {
                  let K = x[$] ^ b;
                  K ^= K >> 1, K ^= K >> 2, K ^= K >> 4, b = (K & 1) << 7, E[D++] = K;
                }
              else if (S === 8) {
                for ($ = 0; $ < y; ++$)
                  E[D++] = x[$];
                for (; $ < m; ++$)
                  E[D] = E[D - y] + x[$], D++;
              } else if (S === 16) {
                const K = y * 2;
                for ($ = 0; $ < K; ++$)
                  E[D++] = x[$];
                for (; $ < m; $ += 2) {
                  const H = ((x[$] & 255) << 8) + (x[$ + 1] & 255) + ((E[D - K] & 255) << 8) + (E[D - K + 1] & 255);
                  E[D++] = H >> 8 & 255, E[D++] = H & 255;
                }
              } else {
                const K = new Uint8Array(y + 1), H = (1 << S) - 1;
                let B = 0, R = v;
                const _ = this.columns;
                for ($ = 0; $ < _; ++$)
                  for (let A = 0; A < y; ++A)
                    I < S && (b = b << 8 | x[B++] & 255, I += 8), K[A] = K[A] + (b >> I - S) & H, I -= S, u = u << S | K[A], O += S, O >= 8 && (E[R++] = u >> O - 8 & 255, O -= 8);
                O > 0 && (E[R++] = (u << 8 - O) + (b & (1 << 8 - O) - 1));
              }
              this.bufferLength += m;
            }
            readBlockPng() {
              const m = this.rowBytes, v = this.pixBytes, E = this.str.getByte(), S = this.str.getBytes(m);
              if (this.eof = !S.length, this.eof)
                return;
              const y = this.bufferLength, x = this.ensureBuffer(y + m);
              let b = x.subarray(y - m, y);
              b.length === 0 && (b = new Uint8Array(m));
              let u, I = y, O, D;
              switch (E) {
                case 0:
                  for (u = 0; u < m; ++u)
                    x[I++] = S[u];
                  break;
                case 1:
                  for (u = 0; u < v; ++u)
                    x[I++] = S[u];
                  for (; u < m; ++u)
                    x[I] = x[I - v] + S[u] & 255, I++;
                  break;
                case 2:
                  for (u = 0; u < m; ++u)
                    x[I++] = b[u] + S[u] & 255;
                  break;
                case 3:
                  for (u = 0; u < v; ++u)
                    x[I++] = (b[u] >> 1) + S[u];
                  for (; u < m; ++u)
                    x[I] = (b[u] + x[I - v] >> 1) + S[u] & 255, I++;
                  break;
                case 4:
                  for (u = 0; u < v; ++u)
                    O = b[u], D = S[u], x[I++] = O + D;
                  for (; u < m; ++u) {
                    O = b[u];
                    const $ = b[u - v], K = x[I - v], H = K + O - $;
                    let B = H - K;
                    B < 0 && (B = -B);
                    let R = H - O;
                    R < 0 && (R = -R);
                    let _ = H - $;
                    _ < 0 && (_ = -_), D = S[u], B <= R && B <= _ ? x[I++] = K + D : R <= _ ? x[I++] = O + D : x[I++] = $ + D;
                  }
                  break;
                default:
                  throw new g.FormatError(`Unsupported predictor: ${E}`);
              }
              this.bufferLength += m;
            }
          }
          c.PredictorStream = t;
        },
        /* 33 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.RunLengthStream = void 0;
          var s = f(18);
          class h extends s.DecodeStream {
            constructor(t, i) {
              super(i), this.str = t, this.dict = t.dict;
            }
            readBlock() {
              const t = this.str.getBytes(2);
              if (!t || t.length < 2 || t[0] === 128) {
                this.eof = !0;
                return;
              }
              let i, m = this.bufferLength, v = t[0];
              if (v < 128) {
                if (i = this.ensureBuffer(m + v + 1), i[m++] = t[1], v > 0) {
                  const E = this.str.getBytes(v);
                  i.set(E, m), m += v;
                }
              } else {
                v = 257 - v;
                const E = t[1];
                i = this.ensureBuffer(m + v + 1);
                for (let S = 0; S < v; S++)
                  i[m++] = E;
              }
              this.bufferLength = m;
            }
          }
          c.RunLengthStream = h;
        },
        /* 34 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.Font = c.ErrorFont = void 0;
          var s = f(2), h = f(35), g = f(38), t = f(40), i = f(39), m = f(37), v = f(41), E = f(42), S = f(43), y = f(44), x = f(45), b = f(46), u = f(14), I = f(47), O = f(3), D = f(8), $ = f(48);
          const K = [[57344, 63743], [1048576, 1114109]], H = 1e3, B = ["ascent", "bbox", "black", "bold", "charProcOperatorList", "composite", "cssFontInfo", "data", "defaultVMetrics", "defaultWidth", "descent", "fallbackName", "fontMatrix", "isInvalidPDFjsFont", "isType3Font", "italic", "loadedName", "mimetype", "missingFile", "name", "remeasure", "subtype", "systemFontInfo", "type", "vertical"], R = ["cMap", "defaultEncoding", "differences", "isMonospace", "isSerifFont", "isSymbolicFont", "seacMap", "toFontChar", "toUnicode", "vmetrics", "widths"];
          function _(ee) {
            if (!ee.fontMatrix || ee.fontMatrix[0] === s.FONT_IDENTITY_MATRIX[0])
              return;
            const he = 1e-3 / ee.fontMatrix[0], pe = ee.widths;
            for (const de in pe)
              pe[de] *= he;
            ee.defaultWidth *= he;
          }
          function A(ee, he, pe) {
            if (ee.isInternalFont || ee.hasIncludedToUnicodeMap || ee.hasEncoding || ee.toUnicode instanceof E.IdentityToUnicodeMap || !he || pe.length === 0 || ee.defaultEncoding === m.WinAnsiEncoding)
              return;
            for (const xe of pe)
              if (!Y(xe))
                return;
            const de = m.WinAnsiEncoding, ge = [], me = (0, i.getGlyphsUnicode)();
            for (const xe in de) {
              const ye = de[xe];
              if (ye === "")
                continue;
              const ve = me[ye];
              ve !== void 0 && (ge[xe] = String.fromCharCode(ve));
            }
            ge.length > 0 && ee.toUnicode.amend(ge);
          }
          function k(ee, he) {
            if (ee.isInternalFont || ee.hasIncludedToUnicodeMap || he === ee.defaultEncoding || ee.toUnicode instanceof E.IdentityToUnicodeMap)
              return;
            const pe = [], de = (0, i.getGlyphsUnicode)();
            for (const ge in he) {
              if (ee.hasEncoding && (ee.baseEncodingName || ee.differences[ge] !== void 0))
                continue;
              const me = he[ge], xe = (0, t.getUnicodeForGlyph)(me, de);
              xe !== -1 && (pe[ge] = String.fromCharCode(xe));
            }
            pe.length > 0 && ee.toUnicode.amend(pe);
          }
          function z(ee) {
            if (!ee.fallbackToUnicode || ee.toUnicode instanceof E.IdentityToUnicodeMap)
              return;
            const he = [];
            for (const pe in ee.fallbackToUnicode)
              ee.toUnicode.has(pe) || (he[pe] = ee.fallbackToUnicode[pe]);
            he.length > 0 && ee.toUnicode.amend(he);
          }
          class T {
            constructor(he, pe, de, ge, me, xe, ye, ve, Ce) {
              this.originalCharCode = he, this.fontChar = pe, this.unicode = de, this.accent = ge, this.width = me, this.vmetric = xe, this.operatorListId = ye, this.isSpace = ve, this.isInFont = Ce;
            }
            get category() {
              return (0, s.shadow)(this, "category", (0, t.getCharUnicodeCategory)(this.unicode), !0);
            }
          }
          function w(ee, he) {
            return (ee << 8) + he;
          }
          function F(ee, he, pe) {
            ee[he + 1] = pe, ee[he] = pe >>> 8;
          }
          function j(ee, he) {
            const pe = (ee << 8) + he;
            return pe & 32768 ? pe - 65536 : pe;
          }
          function P(ee, he, pe, de) {
            return (ee << 24) + (he << 16) + (pe << 8) + de;
          }
          function V(ee) {
            return String.fromCharCode(ee >> 8 & 255, ee & 255);
          }
          function J(ee) {
            return ee > 32767 ? ee = 32767 : ee < -32768 && (ee = -32768), String.fromCharCode(ee >> 8 & 255, ee & 255);
          }
          function ne(ee) {
            const he = ee.peekBytes(4);
            return (0, O.readUint32)(he, 0) === 65536 || (0, s.bytesToString)(he) === "true";
          }
          function Z(ee) {
            const he = ee.peekBytes(4);
            return (0, s.bytesToString)(he) === "ttcf";
          }
          function te(ee) {
            const he = ee.peekBytes(4);
            return (0, s.bytesToString)(he) === "OTTO";
          }
          function G(ee) {
            const he = ee.peekBytes(2);
            return he[0] === 37 && he[1] === 33 || he[0] === 128 && he[1] === 1;
          }
          function N(ee) {
            const he = ee.peekBytes(4);
            return he[0] >= 1 && he[3] >= 1 && he[3] <= 4;
          }
          function q(ee, {
            type: he,
            subtype: pe,
            composite: de
          }) {
            let ge, me;
            return ne(ee) || Z(ee) ? ge = de ? "CIDFontType2" : "TrueType" : te(ee) ? ge = de ? "CIDFontType2" : "OpenType" : G(ee) ? de ? ge = "CIDFontType0" : ge = he === "MMType1" ? "MMType1" : "Type1" : N(ee) ? de ? (ge = "CIDFontType0", me = "CIDFontType0C") : (ge = he === "MMType1" ? "MMType1" : "Type1", me = "Type1C") : ((0, s.warn)("getFontFileType: Unable to detect correct font file Type/Subtype."), ge = he, me = pe), [ge, me];
          }
          function ie(ee, he) {
            for (const pe in he)
              ee[+pe] = he[pe];
          }
          function oe(ee, he, pe) {
            const de = [];
            let ge;
            for (let me = 0, xe = ee.length; me < xe; me++)
              ge = (0, t.getUnicodeForGlyph)(ee[me], he), ge !== -1 && (de[me] = ge);
            for (const me in pe)
              ge = (0, t.getUnicodeForGlyph)(pe[me], he), ge !== -1 && (de[+me] = ge);
            return de;
          }
          function fe(ee) {
            return ee.platform === 1 && ee.encoding === 0 && ee.language === 0;
          }
          function Y(ee) {
            return ee.platform === 3 && ee.encoding === 1 && ee.language === 1033;
          }
          function ae(ee, he, pe = !1) {
            switch (he.length) {
              case 1:
                return he.charCodeAt(0);
              case 2:
                return he.charCodeAt(0) << 8 | he.charCodeAt(1);
            }
            const de = `Unsupported CID string (charCode ${ee}): "${he}".`;
            if (pe)
              throw new s.FormatError(de);
            return (0, s.warn)(de), he;
          }
          function se(ee, he, pe, de) {
            const ge = /* @__PURE__ */ Object.create(null), me = /* @__PURE__ */ new Map(), xe = [], ye = /* @__PURE__ */ new Set();
            let ve = 0, Ie = K[ve][0], Ae = K[ve][1];
            const Se = (De) => K[0][0] <= De && De <= K[0][1] || K[1][0] <= De && De <= K[1][1];
            for (let De in ee) {
              De |= 0;
              let Be = ee[De];
              if (!he(Be))
                continue;
              if (Ie > Ae) {
                if (ve++, ve >= K.length) {
                  (0, s.warn)("Ran out of space in font private use area.");
                  break;
                }
                Ie = K[ve][0], Ae = K[ve][1];
              }
              const ke = Ie++;
              Be === 0 && (Be = pe);
              let be = de.get(De);
              typeof be == "string" && (be = be.codePointAt(0)), be && !Se(be) && !ye.has(Be) && (me.set(be, Be), ye.add(Be)), ge[ke] = Be, xe[De] = ke;
            }
            return {
              toFontChar: xe,
              charCodeToGlyphId: ge,
              toUnicodeExtraMap: me,
              nextAvailableFontCharCode: Ie
            };
          }
          function L(ee, he, pe) {
            const de = [];
            for (const xe in ee)
              ee[xe] >= pe || de.push({
                fontCharCode: xe | 0,
                glyphId: ee[xe]
              });
            if (he)
              for (const [xe, ye] of he)
                ye >= pe || de.push({
                  fontCharCode: xe,
                  glyphId: ye
                });
            de.length === 0 && de.push({
              fontCharCode: 0,
              glyphId: 0
            }), de.sort(function(ye, ve) {
              return ye.fontCharCode - ve.fontCharCode;
            });
            const ge = [], me = de.length;
            for (let xe = 0; xe < me; ) {
              const ye = de[xe].fontCharCode, ve = [de[xe].glyphId];
              ++xe;
              let Ce = ye;
              for (; xe < me && Ce + 1 === de[xe].fontCharCode && (ve.push(de[xe].glyphId), ++Ce, ++xe, Ce !== 65535); )
                ;
              ge.push([ye, Ce, ve]);
            }
            return ge;
          }
          function W(ee, he, pe) {
            const de = L(ee, he, pe), ge = de.at(-1)[1] > 65535 ? 2 : 1;
            let me = "\0\0" + V(ge) + "\0\0" + (0, s.string32)(4 + ge * 8), xe, ye, ve, Ce;
            for (xe = de.length - 1; xe >= 0 && !(de[xe][0] <= 65535); --xe)
              ;
            const Ie = xe + 1;
            de[xe][0] < 65535 && de[xe][1] === 65535 && (de[xe][1] = 65534);
            const Ae = de[xe][1] < 65535 ? 1 : 0, Se = Ie + Ae, De = I.OpenTypeFileBuilder.getSearchParams(Se, 2);
            let Be = "", ke = "", be = "", we = "", Le = "", Re = 0, ct, ft, kt, We;
            for (xe = 0, ye = Ie; xe < ye; xe++) {
              ct = de[xe], ft = ct[0], kt = ct[1], Be += V(ft), ke += V(kt), We = ct[2];
              let mt = !0;
              for (ve = 1, Ce = We.length; ve < Ce; ++ve)
                if (We[ve] !== We[ve - 1] + 1) {
                  mt = !1;
                  break;
                }
              if (mt) {
                const Pt = We[0];
                be += V(Pt - ft & 65535), we += V(0);
              } else {
                const Pt = (Se - xe) * 2 + Re * 2;
                for (Re += kt - ft + 1, be += V(0), we += V(Pt), ve = 0, Ce = We.length; ve < Ce; ++ve)
                  Le += V(We[ve]);
              }
            }
            Ae > 0 && (ke += "ÿÿ", Be += "ÿÿ", be += "\0", we += "\0\0");
            const jt = "\0\0" + V(2 * Se) + V(De.range) + V(De.entry) + V(De.rangeShift) + ke + "\0\0" + Be + be + we + Le;
            let yt = "", Ye = "";
            if (ge > 1) {
              for (me += `\0\0
` + (0, s.string32)(4 + ge * 8 + 4 + jt.length), yt = "", xe = 0, ye = de.length; xe < ye; xe++) {
                ct = de[xe], ft = ct[0], We = ct[2];
                let mt = We[0];
                for (ve = 1, Ce = We.length; ve < Ce; ++ve)
                  We[ve] !== We[ve - 1] + 1 && (kt = ct[0] + ve - 1, yt += (0, s.string32)(ft) + (0, s.string32)(kt) + (0, s.string32)(mt), ft = kt + 1, mt = We[ve]);
                yt += (0, s.string32)(ft) + (0, s.string32)(ct[1]) + (0, s.string32)(mt);
              }
              Ye = "\0\f\0\0" + (0, s.string32)(yt.length + 16) + "\0\0\0\0" + (0, s.string32)(yt.length / 12);
            }
            return me + "\0" + V(jt.length + 4) + jt + Ye + yt;
          }
          function M(ee, he) {
            he.pos = (he.start || 0) + ee.offset;
            const pe = he.getUint16();
            he.skip(60);
            const de = he.getUint16();
            if (pe < 4 && de & 768)
              return !1;
            const ge = he.getUint16(), me = he.getUint16();
            return ge > me || (he.skip(6), he.getUint16() === 0) ? !1 : (ee.data[8] = ee.data[9] = 0, !0);
          }
          function X(ee, he, pe) {
            pe || (pe = {
              unitsPerEm: 0,
              yMax: 0,
              yMin: 0,
              ascent: 0,
              descent: 0
            });
            let de = 0, ge = 0, me = 0, xe = 0, ye = null, ve = 0, Ce = -1;
            if (he) {
              for (let we in he)
                if (we |= 0, (ye > we || !ye) && (ye = we), ve < we && (ve = we), Ce = (0, t.getUnicodeRangeFor)(we, Ce), Ce < 32)
                  de |= 1 << Ce;
                else if (Ce < 64)
                  ge |= 1 << Ce - 32;
                else if (Ce < 96)
                  me |= 1 << Ce - 64;
                else if (Ce < 123)
                  xe |= 1 << Ce - 96;
                else
                  throw new s.FormatError("Unicode ranges Bits > 123 are reserved for internal usage");
              ve > 65535 && (ve = 65535);
            } else
              ye = 0, ve = 255;
            const Ie = ee.bbox || [0, 0, 0, 0], Ae = pe.unitsPerEm || 1 / (ee.fontMatrix || s.FONT_IDENTITY_MATRIX)[0], Se = ee.ascentScaled ? 1 : Ae / H, De = pe.ascent || Math.round(Se * (ee.ascent || Ie[3]));
            let Be = pe.descent || Math.round(Se * (ee.descent || Ie[1]));
            Be > 0 && ee.descent > 0 && Ie[1] < 0 && (Be = -Be);
            const ke = pe.yMax || De, be = -pe.yMin || -Be;
            return "\0$ô\0\0\0»\0\0\0»\0\0ß\x001\0\0\0\0" + String.fromCharCode(ee.fixedPitch ? 9 : 0) + "\0\0\0\0\0\0" + (0, s.string32)(de) + (0, s.string32)(ge) + (0, s.string32)(me) + (0, s.string32)(xe) + "*21*" + V(ee.italicAngle ? 1 : 0) + V(ye || ee.firstChar) + V(ve || ee.lastChar) + V(De) + V(Be) + "\0d" + V(ke) + V(be) + "\0\0\0\0\0\0\0\0" + V(ee.xHeight) + V(ee.capHeight) + V(0) + V(ye || ee.firstChar) + "\0";
          }
          function U(ee) {
            const he = Math.floor(ee.italicAngle * 65536);
            return "\0\0\0" + (0, s.string32)(he) + "\0\0\0\0" + (0, s.string32)(ee.fixedPitch ? 1 : 0) + "\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0";
          }
          function Q(ee) {
            return ee.replaceAll(/[^\x21-\x7E]|[[\](){}<>/%]/g, "").slice(0, 63);
          }
          function re(ee, he) {
            he || (he = [[], []]);
            const pe = [he[0][0] || "Original licence", he[0][1] || ee, he[0][2] || "Unknown", he[0][3] || "uniqueID", he[0][4] || ee, he[0][5] || "Version 0.11", he[0][6] || Q(ee), he[0][7] || "Unknown", he[0][8] || "Unknown", he[0][9] || "Unknown"], de = [];
            let ge, me, xe, ye, ve;
            for (ge = 0, me = pe.length; ge < me; ge++) {
              ve = he[1][ge] || pe[ge];
              const be = [];
              for (xe = 0, ye = ve.length; xe < ye; xe++)
                be.push(V(ve.charCodeAt(xe)));
              de.push(be.join(""));
            }
            const Ce = [pe, de], Ie = ["\0", "\0"], Ae = ["\0\0", "\0"], Se = ["\0\0", "	"], De = pe.length * Ie.length;
            let Be = "\0\0" + V(De) + V(De * 12 + 6), ke = 0;
            for (ge = 0, me = Ie.length; ge < me; ge++) {
              const be = Ce[ge];
              for (xe = 0, ye = be.length; xe < ye; xe++) {
                ve = be[xe];
                const we = Ie[ge] + Ae[ge] + Se[ge] + V(xe) + V(ve.length) + V(ke);
                Be += we, ke += ve.length;
              }
            }
            return Be += pe.join("") + de.join(""), Be;
          }
          class le {
            constructor(he, pe, de) {
              var Ce;
              this.name = he, this.psName = null, this.mimetype = null, this.disableFontFace = !1, this.loadedName = de.loadedName, this.isType3Font = de.isType3Font, this.missingFile = !1, this.cssFontInfo = de.cssFontInfo, this._charsCache = /* @__PURE__ */ Object.create(null), this._glyphCache = /* @__PURE__ */ Object.create(null);
              let ge = !!(de.flags & g.FontFlags.Serif);
              if (!ge && !de.isSimulatedFlags) {
                const Ie = he.replaceAll(/[,_]/g, "-").split("-")[0], Ae = (0, v.getSerifFonts)();
                for (const Se of Ie.split("+"))
                  if (Ae[Se]) {
                    ge = !0;
                    break;
                  }
              }
              this.isSerifFont = ge, this.isSymbolicFont = !!(de.flags & g.FontFlags.Symbolic), this.isMonospace = !!(de.flags & g.FontFlags.FixedPitch);
              let {
                type: me,
                subtype: xe
              } = de;
              this.type = me, this.subtype = xe, this.systemFontInfo = de.systemFontInfo;
              const ye = he.match(/^InvalidPDFjsFont_(.*)_\d+$/);
              if (this.isInvalidPDFjsFont = !!ye, this.isInvalidPDFjsFont ? this.fallbackName = ye[1] : this.isMonospace ? this.fallbackName = "monospace" : this.isSerifFont ? this.fallbackName = "serif" : this.fallbackName = "sans-serif", (Ce = this.systemFontInfo) != null && Ce.guessFallback && (this.systemFontInfo.guessFallback = !1, this.systemFontInfo.css += `,${this.fallbackName}`), this.differences = de.differences, this.widths = de.widths, this.defaultWidth = de.defaultWidth, this.composite = de.composite, this.cMap = de.cMap, this.capHeight = de.capHeight / H, this.ascent = de.ascent / H, this.descent = de.descent / H, this.lineHeight = this.ascent - this.descent, this.fontMatrix = de.fontMatrix, this.bbox = de.bbox, this.defaultEncoding = de.defaultEncoding, this.toUnicode = de.toUnicode, this.toFontChar = [], de.type === "Type3") {
                for (let Ie = 0; Ie < 256; Ie++)
                  this.toFontChar[Ie] = this.differences[Ie] || de.defaultEncoding[Ie];
                return;
              }
              if (this.cidEncoding = de.cidEncoding || "", this.vertical = !!de.vertical, this.vertical && (this.vmetrics = de.vmetrics, this.defaultVMetrics = de.defaultVMetrics), !pe || pe.isEmpty) {
                pe && (0, s.warn)('Font file is empty in "' + he + '" (' + this.loadedName + ")"), this.fallbackToSystemFont(de);
                return;
              }
              [me, xe] = q(pe, de), (me !== this.type || xe !== this.subtype) && (0, s.info)(`Inconsistent font file Type/SubType, expected: ${this.type}/${this.subtype} but found: ${me}/${xe}.`);
              let ve;
              try {
                switch (me) {
                  case "MMType1":
                    (0, s.info)("MMType1 font (" + he + "), falling back to Type1.");
                  case "Type1":
                  case "CIDFontType0":
                    this.mimetype = "font/opentype";
                    const Ie = xe === "Type1C" || xe === "CIDFontType0C" ? new S.CFFFont(pe, de) : new $.Type1Font(he, pe, de);
                    _(de), ve = this.convert(he, Ie, de);
                    break;
                  case "OpenType":
                  case "TrueType":
                  case "CIDFontType2":
                    this.mimetype = "font/opentype", ve = this.checkAndRepair(he, pe, de), this.isOpenType && (_(de), me = "OpenType");
                    break;
                  default:
                    throw new s.FormatError(`Font ${me} is not supported`);
                }
              } catch (Ie) {
                (0, s.warn)(Ie), this.fallbackToSystemFont(de);
                return;
              }
              z(de), this.data = ve, this.type = me, this.subtype = xe, this.fontMatrix = de.fontMatrix, this.widths = de.widths, this.defaultWidth = de.defaultWidth, this.toUnicode = de.toUnicode, this.seacMap = de.seacMap;
            }
            get renderer() {
              const he = y.FontRendererFactory.create(this, g.SEAC_ANALYSIS_ENABLED);
              return (0, s.shadow)(this, "renderer", he);
            }
            exportData(he = !1) {
              const pe = he ? [...B, ...R] : B, de = /* @__PURE__ */ Object.create(null);
              let ge, me;
              for (ge of pe)
                me = this[ge], me !== void 0 && (de[ge] = me);
              return de;
            }
            fallbackToSystemFont(he) {
              this.missingFile = !0;
              const {
                name: pe,
                type: de
              } = this;
              let ge = (0, g.normalizeFontName)(pe);
              const me = (0, v.getStdFontMap)(), xe = (0, v.getNonStdFontMap)(), ye = !!me[ge], ve = !!(xe[ge] && me[xe[ge]]);
              ge = me[ge] || xe[ge] || ge;
              const Ie = (0, x.getFontBasicMetrics)()[ge];
              Ie && (isNaN(this.ascent) && (this.ascent = Ie.ascent / H), isNaN(this.descent) && (this.descent = Ie.descent / H), isNaN(this.capHeight) && (this.capHeight = Ie.capHeight / H)), this.bold = /bold/gi.test(ge), this.italic = /oblique|italic/gi.test(ge), this.black = /Black/g.test(pe);
              const Ae = /Narrow/g.test(pe);
              if (this.remeasure = (!ye || Ae) && Object.keys(this.widths).length > 0, (ye || ve) && de === "CIDFontType2" && this.cidEncoding.startsWith("Identity-")) {
                const Se = he.cidToGidMap, De = [];
                if (ie(De, (0, v.getGlyphMapForStandardFonts)()), /Arial-?Black/i.test(pe) ? ie(De, (0, v.getSupplementalGlyphMapForArialBlack)()) : /Calibri/i.test(pe) && ie(De, (0, v.getSupplementalGlyphMapForCalibri)()), Se) {
                  for (const Be in De) {
                    const ke = De[Be];
                    Se[ke] !== void 0 && (De[+Be] = Se[ke]);
                  }
                  Se.length !== this.toUnicode.length && he.hasIncludedToUnicodeMap && this.toUnicode instanceof E.IdentityToUnicodeMap && this.toUnicode.forEach(function(Be, ke) {
                    const be = De[Be];
                    Se[be] === void 0 && (De[+Be] = ke);
                  });
                }
                this.toUnicode instanceof E.IdentityToUnicodeMap || this.toUnicode.forEach(function(Be, ke) {
                  De[+Be] = ke;
                }), this.toFontChar = De, this.toUnicode = new E.ToUnicodeMap(De);
              } else if (/Symbol/i.test(ge))
                this.toFontChar = oe(m.SymbolSetEncoding, (0, i.getGlyphsUnicode)(), this.differences);
              else if (/Dingbats/i.test(ge))
                this.toFontChar = oe(m.ZapfDingbatsEncoding, (0, i.getDingbatsGlyphsUnicode)(), this.differences);
              else if (ye) {
                const Se = oe(this.defaultEncoding, (0, i.getGlyphsUnicode)(), this.differences);
                de === "CIDFontType2" && !this.cidEncoding.startsWith("Identity-") && !(this.toUnicode instanceof E.IdentityToUnicodeMap) && this.toUnicode.forEach(function(De, Be) {
                  Se[+De] = Be;
                }), this.toFontChar = Se;
              } else {
                const Se = (0, i.getGlyphsUnicode)(), De = [];
                this.toUnicode.forEach((Be, ke) => {
                  if (!this.composite) {
                    const be = this.differences[Be] || this.defaultEncoding[Be], we = (0, t.getUnicodeForGlyph)(be, Se);
                    we !== -1 && (ke = we);
                  }
                  De[+Be] = ke;
                }), this.composite && this.toUnicode instanceof E.IdentityToUnicodeMap && /Tahoma|Verdana/i.test(pe) && ie(De, (0, v.getGlyphMapForStandardFonts)()), this.toFontChar = De;
              }
              z(he), this.loadedName = ge.split("-")[0];
            }
            checkAndRepair(he, pe, de) {
              var _t, Zt, an;
              const ge = ["OS/2", "cmap", "head", "hhea", "hmtx", "maxp", "name", "post", "loca", "glyf", "fpgm", "prep", "cvt ", "CFF "];
              function me(ze, $e) {
                const Ve = /* @__PURE__ */ Object.create(null);
                Ve["OS/2"] = null, Ve.cmap = null, Ve.head = null, Ve.hhea = null, Ve.hmtx = null, Ve.maxp = null, Ve.name = null, Ve.post = null;
                for (let Ke = 0; Ke < $e; Ke++) {
                  const at = xe(ze);
                  ge.includes(at.tag) && at.length !== 0 && (Ve[at.tag] = at);
                }
                return Ve;
              }
              function xe(ze) {
                const $e = ze.getString(4), Ve = ze.getInt32() >>> 0, Ke = ze.getInt32() >>> 0, at = ze.getInt32() >>> 0, It = ze.pos;
                ze.pos = ze.start || 0, ze.skip(Ke);
                const st = ze.getBytes(at);
                return ze.pos = It, $e === "head" && (st[8] = st[9] = st[10] = st[11] = 0, st[17] |= 32), {
                  tag: $e,
                  checksum: Ve,
                  length: at,
                  offset: Ke,
                  data: st
                };
              }
              function ye(ze) {
                return {
                  version: ze.getString(4),
                  numTables: ze.getUint16(),
                  searchRange: ze.getUint16(),
                  entrySelector: ze.getUint16(),
                  rangeShift: ze.getUint16()
                };
              }
              function ve(ze) {
                const $e = ze.getString(4);
                (0, s.assert)($e === "ttcf", "Must be a TrueType Collection font.");
                const Ve = ze.getUint16(), Ke = ze.getUint16(), at = ze.getInt32() >>> 0, It = [];
                for (let Ze = 0; Ze < at; Ze++)
                  It.push(ze.getInt32() >>> 0);
                const st = {
                  ttcTag: $e,
                  majorVersion: Ve,
                  minorVersion: Ke,
                  numFonts: at,
                  offsetTable: It
                };
                switch (Ve) {
                  case 1:
                    return st;
                  case 2:
                    return st.dsigTag = ze.getInt32() >>> 0, st.dsigLength = ze.getInt32() >>> 0, st.dsigOffset = ze.getInt32() >>> 0, st;
                }
                throw new s.FormatError(`Invalid TrueType Collection majorVersion: ${Ve}.`);
              }
              function Ce(ze, $e) {
                var st;
                const {
                  numFonts: Ve,
                  offsetTable: Ke
                } = ve(ze), at = $e.split("+");
                let It;
                for (let Ze = 0; Ze < Ve; Ze++) {
                  ze.pos = (ze.start || 0) + Ke[Ze];
                  const gt = ye(ze), Lt = me(ze, gt.numTables);
                  if (!Lt.name)
                    throw new s.FormatError('TrueType Collection font must contain a "name" table.');
                  const [Yt] = be(Lt.name);
                  for (let Ft = 0, Dt = Yt.length; Ft < Dt; Ft++)
                    for (let Wt = 0, xt = Yt[Ft].length; Wt < xt; Wt++) {
                      const Bt = (st = Yt[Ft][Wt]) == null ? void 0 : st.replaceAll(/\s/g, "");
                      if (Bt) {
                        if (Bt === $e)
                          return {
                            header: gt,
                            tables: Lt
                          };
                        if (!(at.length < 2))
                          for (const ht of at)
                            Bt === ht && (It = {
                              name: ht,
                              header: gt,
                              tables: Lt
                            });
                      }
                    }
                }
                if (It)
                  return (0, s.warn)(`TrueType Collection does not contain "${$e}" font, falling back to "${It.name}" font instead.`), {
                    header: It.header,
                    tables: It.tables
                  };
                throw new s.FormatError(`TrueType Collection does not contain "${$e}" font.`);
              }
              function Ie(ze, $e, Ve, Ke) {
                if (!ze)
                  return (0, s.warn)("No cmap table available."), {
                    platformId: -1,
                    encodingId: -1,
                    mappings: [],
                    hasShortCmap: !1
                  };
                let at, It = ($e.start || 0) + ze.offset;
                $e.pos = It, $e.skip(2);
                const st = $e.getUint16();
                let Ze, gt = !1;
                for (let xt = 0; xt < st; xt++) {
                  const Bt = $e.getUint16(), ht = $e.getUint16(), Ht = $e.getInt32() >>> 0;
                  let Qt = !1;
                  if (!((Ze == null ? void 0 : Ze.platformId) === Bt && (Ze == null ? void 0 : Ze.encodingId) === ht)) {
                    if (Bt === 0 && (ht === 0 || ht === 1 || ht === 3))
                      Qt = !0;
                    else if (Bt === 1 && ht === 0)
                      Qt = !0;
                    else if (Bt === 3 && ht === 1 && (Ke || !Ze))
                      Qt = !0, Ve || (gt = !0);
                    else if (Ve && Bt === 3 && ht === 0) {
                      Qt = !0;
                      let Vn = !0;
                      if (xt < st - 1) {
                        const $t = $e.peekBytes(2);
                        w($t[0], $t[1]) < Bt && (Vn = !1);
                      }
                      Vn && (gt = !0);
                    }
                    if (Qt && (Ze = {
                      platformId: Bt,
                      encodingId: ht,
                      offset: Ht
                    }), gt)
                      break;
                  }
                }
                if (Ze && ($e.pos = It + Ze.offset), !Ze || $e.peekByte() === -1)
                  return (0, s.warn)("Could not find a preferred cmap table."), {
                    platformId: -1,
                    encodingId: -1,
                    mappings: [],
                    hasShortCmap: !1
                  };
                const Lt = $e.getUint16();
                let Yt = !1;
                const Ft = [];
                let Dt, Wt;
                if (Lt === 0) {
                  for ($e.skip(4), Dt = 0; Dt < 256; Dt++) {
                    const xt = $e.getByte();
                    xt && Ft.push({
                      charCode: Dt,
                      glyphId: xt
                    });
                  }
                  Yt = !0;
                } else if (Lt === 2) {
                  $e.skip(4);
                  const xt = [];
                  let Bt = 0;
                  for (let Ht = 0; Ht < 256; Ht++) {
                    const Qt = $e.getUint16() >> 3;
                    xt.push(Qt), Bt = Math.max(Qt, Bt);
                  }
                  const ht = [];
                  for (let Ht = 0; Ht <= Bt; Ht++)
                    ht.push({
                      firstCode: $e.getUint16(),
                      entryCount: $e.getUint16(),
                      idDelta: j($e.getByte(), $e.getByte()),
                      idRangePos: $e.pos + $e.getUint16()
                    });
                  for (let Ht = 0; Ht < 256; Ht++)
                    if (xt[Ht] === 0)
                      $e.pos = ht[0].idRangePos + 2 * Ht, Wt = $e.getUint16(), Ft.push({
                        charCode: Ht,
                        glyphId: Wt
                      });
                    else {
                      const Qt = ht[xt[Ht]];
                      for (Dt = 0; Dt < Qt.entryCount; Dt++) {
                        const Vn = (Ht << 8) + Dt + Qt.firstCode;
                        $e.pos = Qt.idRangePos + 2 * Dt, Wt = $e.getUint16(), Wt !== 0 && (Wt = (Wt + Qt.idDelta) % 65536), Ft.push({
                          charCode: Vn,
                          glyphId: Wt
                        });
                      }
                    }
                } else if (Lt === 4) {
                  $e.skip(4);
                  const xt = $e.getUint16() >> 1;
                  $e.skip(6);
                  const Bt = [];
                  let ht;
                  for (ht = 0; ht < xt; ht++)
                    Bt.push({
                      end: $e.getUint16()
                    });
                  for ($e.skip(2), ht = 0; ht < xt; ht++)
                    Bt[ht].start = $e.getUint16();
                  for (ht = 0; ht < xt; ht++)
                    Bt[ht].delta = $e.getUint16();
                  let Ht = 0, Qt;
                  for (ht = 0; ht < xt; ht++) {
                    at = Bt[ht];
                    const $t = $e.getUint16();
                    if (!$t) {
                      at.offsetIndex = -1;
                      continue;
                    }
                    Qt = ($t >> 1) - (xt - ht), at.offsetIndex = Qt, Ht = Math.max(Ht, Qt + at.end - at.start + 1);
                  }
                  const Vn = [];
                  for (Dt = 0; Dt < Ht; Dt++)
                    Vn.push($e.getUint16());
                  for (ht = 0; ht < xt; ht++) {
                    at = Bt[ht], It = at.start;
                    const $t = at.end, Ut = at.delta;
                    for (Qt = at.offsetIndex, Dt = It; Dt <= $t; Dt++)
                      Dt !== 65535 && (Wt = Qt < 0 ? Dt : Vn[Qt + Dt - It], Wt = Wt + Ut & 65535, Ft.push({
                        charCode: Dt,
                        glyphId: Wt
                      }));
                  }
                } else if (Lt === 6) {
                  $e.skip(4);
                  const xt = $e.getUint16(), Bt = $e.getUint16();
                  for (Dt = 0; Dt < Bt; Dt++) {
                    Wt = $e.getUint16();
                    const ht = xt + Dt;
                    Ft.push({
                      charCode: ht,
                      glyphId: Wt
                    });
                  }
                } else if (Lt === 12) {
                  $e.skip(10);
                  const xt = $e.getInt32() >>> 0;
                  for (Dt = 0; Dt < xt; Dt++) {
                    const Bt = $e.getInt32() >>> 0, ht = $e.getInt32() >>> 0;
                    let Ht = $e.getInt32() >>> 0;
                    for (let Qt = Bt; Qt <= ht; Qt++)
                      Ft.push({
                        charCode: Qt,
                        glyphId: Ht++
                      });
                  }
                } else
                  return (0, s.warn)("cmap table has unsupported format: " + Lt), {
                    platformId: -1,
                    encodingId: -1,
                    mappings: [],
                    hasShortCmap: !1
                  };
                Ft.sort(function(xt, Bt) {
                  return xt.charCode - Bt.charCode;
                });
                for (let xt = 1; xt < Ft.length; xt++)
                  Ft[xt - 1].charCode === Ft[xt].charCode && (Ft.splice(xt, 1), xt--);
                return {
                  platformId: Ze.platformId,
                  encodingId: Ze.encodingId,
                  mappings: Ft,
                  hasShortCmap: Yt
                };
              }
              function Ae(ze, $e, Ve, Ke, at, It) {
                if (!$e) {
                  Ve && (Ve.data = null);
                  return;
                }
                ze.pos = (ze.start || 0) + $e.offset, ze.pos += 4, ze.pos += 2, ze.pos += 2, ze.pos += 2, ze.pos += 2, ze.pos += 2, ze.pos += 2, ze.pos += 2, ze.pos += 2, ze.pos += 2;
                const st = ze.getUint16();
                ze.pos += 8, ze.pos += 2;
                let Ze = ze.getUint16();
                st !== 0 && (w(Ke.data[44], Ke.data[45]) & 2 || ($e.data[22] = 0, $e.data[23] = 0)), Ze > at && ((0, s.info)(`The numOfMetrics (${Ze}) should not be greater than the numGlyphs (${at}).`), Ze = at, $e.data[34] = (Ze & 65280) >> 8, $e.data[35] = Ze & 255);
                const Lt = at - Ze - (Ve.length - Ze * 4 >> 1);
                if (Lt > 0) {
                  const Yt = new Uint8Array(Ve.length + Lt * 2);
                  Yt.set(Ve.data), It && (Yt[Ve.length] = Ve.data[2], Yt[Ve.length + 1] = Ve.data[3]), Ve.data = Yt;
                }
              }
              function Se(ze, $e, Ve, Ke, at, It) {
                const st = {
                  length: 0,
                  sizeOfInstructions: 0
                };
                if ($e < 0 || $e >= ze.length || Ve > ze.length || Ve - $e <= 12)
                  return st;
                const Ze = ze.subarray($e, Ve), gt = j(Ze[2], Ze[3]), Lt = j(Ze[4], Ze[5]), Yt = j(Ze[6], Ze[7]), Ft = j(Ze[8], Ze[9]);
                gt > Yt && (F(Ze, 2, Yt), F(Ze, 6, gt)), Lt > Ft && (F(Ze, 4, Ft), F(Ze, 8, Lt));
                const Dt = j(Ze[0], Ze[1]);
                if (Dt < 0)
                  return Dt < -1 || (Ke.set(Ze, at), st.length = Ze.length), st;
                let Wt, xt = 10, Bt = 0;
                for (Wt = 0; Wt < Dt; Wt++)
                  Bt = (Ze[xt] << 8 | Ze[xt + 1]) + 1, xt += 2;
                const ht = xt, Ht = Ze[xt] << 8 | Ze[xt + 1];
                st.sizeOfInstructions = Ht, xt += 2 + Ht;
                const Qt = xt;
                let Vn = 0;
                for (Wt = 0; Wt < Bt; Wt++) {
                  const Ut = Ze[xt++];
                  Ut & 192 && (Ze[xt - 1] = Ut & 63);
                  let dn = 2;
                  Ut & 2 ? dn = 1 : Ut & 16 && (dn = 0);
                  let kn = 2;
                  Ut & 4 ? kn = 1 : Ut & 32 && (kn = 0);
                  const _i = dn + kn;
                  if (Vn += _i, Ut & 8) {
                    const As = Ze[xt++];
                    As === 0 && (Ze[xt - 1] ^= 8), Wt += As, Vn += As * _i;
                  }
                }
                if (Vn === 0)
                  return st;
                let $t = xt + Vn;
                return $t > Ze.length ? st : !It && Ht > 0 ? (Ke.set(Ze.subarray(0, ht), at), Ke.set([0, 0], at + ht), Ke.set(Ze.subarray(Qt, $t), at + ht + 2), $t -= Ht, Ze.length - $t > 3 && ($t = $t + 3 & -4), st.length = $t, st) : Ze.length - $t > 3 ? ($t = $t + 3 & -4, Ke.set(Ze.subarray(0, $t), at), st.length = $t, st) : (Ke.set(Ze, at), st.length = Ze.length, st);
              }
              function De(ze, $e, Ve) {
                const Ke = ze.data, at = P(Ke[0], Ke[1], Ke[2], Ke[3]);
                at >> 16 !== 1 && ((0, s.info)("Attempting to fix invalid version in head table: " + at), Ke[0] = 0, Ke[1] = 1, Ke[2] = 0, Ke[3] = 0);
                const It = w(Ke[50], Ke[51]);
                if (It < 0 || It > 1) {
                  (0, s.info)("Attempting to fix invalid indexToLocFormat in head table: " + It);
                  const st = $e + 1;
                  if (Ve === st << 1)
                    Ke[50] = 0, Ke[51] = 0;
                  else if (Ve === st << 2)
                    Ke[50] = 0, Ke[51] = 1;
                  else
                    throw new s.FormatError("Could not fix indexToLocFormat: " + It);
                }
              }
              function Be(ze, $e, Ve, Ke, at, It, st) {
                let Ze, gt, Lt;
                Ke ? (Ze = 4, gt = function(dn, kn) {
                  return dn[kn] << 24 | dn[kn + 1] << 16 | dn[kn + 2] << 8 | dn[kn + 3];
                }, Lt = function(dn, kn, _i) {
                  dn[kn] = _i >>> 24 & 255, dn[kn + 1] = _i >> 16 & 255, dn[kn + 2] = _i >> 8 & 255, dn[kn + 3] = _i & 255;
                }) : (Ze = 2, gt = function(dn, kn) {
                  return dn[kn] << 9 | dn[kn + 1] << 1;
                }, Lt = function(dn, kn, _i) {
                  dn[kn] = _i >> 9 & 255, dn[kn + 1] = _i >> 1 & 255;
                });
                const Yt = It ? Ve + 1 : Ve, Ft = Ze * (1 + Yt), Dt = new Uint8Array(Ft);
                Dt.set(ze.data.subarray(0, Ft)), ze.data = Dt;
                const Wt = $e.data, xt = Wt.length, Bt = new Uint8Array(xt);
                let ht, Ht;
                const Qt = [];
                for (ht = 0, Ht = 0; ht < Ve + 1; ht++, Ht += Ze) {
                  let Ut = gt(Dt, Ht);
                  Ut > xt && (Ut = xt), Qt.push({
                    index: ht,
                    offset: Ut,
                    endOffset: 0
                  });
                }
                for (Qt.sort((Ut, dn) => Ut.offset - dn.offset), ht = 0; ht < Ve; ht++)
                  Qt[ht].endOffset = Qt[ht + 1].offset;
                for (Qt.sort((Ut, dn) => Ut.index - dn.index), ht = 0; ht < Ve; ht++) {
                  const {
                    offset: Ut,
                    endOffset: dn
                  } = Qt[ht];
                  if (Ut !== 0 || dn !== 0)
                    break;
                  const kn = Qt[ht + 1].offset;
                  if (kn !== 0) {
                    Qt[ht].endOffset = kn;
                    break;
                  }
                }
                const Vn = /* @__PURE__ */ Object.create(null);
                let $t = 0;
                for (Lt(Dt, 0, $t), ht = 0, Ht = Ze; ht < Ve; ht++, Ht += Ze) {
                  const Ut = Se(Wt, Qt[ht].offset, Qt[ht].endOffset, Bt, $t, at), dn = Ut.length;
                  dn === 0 && (Vn[ht] = !0), Ut.sizeOfInstructions > st && (st = Ut.sizeOfInstructions), $t += dn, Lt(Dt, Ht, $t);
                }
                if ($t === 0) {
                  const Ut = new Uint8Array([0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 49, 0]);
                  for (ht = 0, Ht = Ze; ht < Yt; ht++, Ht += Ze)
                    Lt(Dt, Ht, Ut.length);
                  $e.data = Ut;
                } else if (It) {
                  const Ut = gt(Dt, Ze);
                  Bt.length > Ut + $t ? $e.data = Bt.subarray(0, Ut + $t) : ($e.data = new Uint8Array(Ut + $t), $e.data.set(Bt.subarray(0, $t))), $e.data.set(Bt.subarray(0, Ut), $t), Lt(ze.data, Dt.length - Ze, $t + Ut);
                } else
                  $e.data = Bt.subarray(0, $t);
                return {
                  missingGlyphs: Vn,
                  maxSizeOfInstructions: st
                };
              }
              function ke(ze, $e, Ve) {
                const Ke = (pe.start || 0) + ze.offset;
                pe.pos = Ke;
                const at = ze.length, It = Ke + at, st = pe.getInt32();
                pe.skip(28);
                let Ze, gt = !0, Lt;
                switch (st) {
                  case 65536:
                    Ze = g.MacStandardGlyphOrdering;
                    break;
                  case 131072:
                    const Yt = pe.getUint16();
                    if (Yt !== Ve) {
                      gt = !1;
                      break;
                    }
                    const Ft = [];
                    for (Lt = 0; Lt < Yt; ++Lt) {
                      const xt = pe.getUint16();
                      if (xt >= 32768) {
                        gt = !1;
                        break;
                      }
                      Ft.push(xt);
                    }
                    if (!gt)
                      break;
                    const Dt = [], Wt = [];
                    for (; pe.pos < It; ) {
                      const xt = pe.getByte();
                      for (Wt.length = xt, Lt = 0; Lt < xt; ++Lt)
                        Wt[Lt] = String.fromCharCode(pe.getByte());
                      Dt.push(Wt.join(""));
                    }
                    for (Ze = [], Lt = 0; Lt < Yt; ++Lt) {
                      const xt = Ft[Lt];
                      if (xt < 258) {
                        Ze.push(g.MacStandardGlyphOrdering[xt]);
                        continue;
                      }
                      Ze.push(Dt[xt - 258]);
                    }
                    break;
                  case 196608:
                    break;
                  default:
                    (0, s.warn)("Unknown/unsupported post table version " + st), gt = !1, $e.defaultEncoding && (Ze = $e.defaultEncoding);
                    break;
                }
                return $e.glyphNames = Ze, gt;
              }
              function be(ze) {
                const $e = (pe.start || 0) + ze.offset;
                pe.pos = $e;
                const Ve = [[], []], Ke = [], at = ze.length, It = $e + at;
                if (pe.getUint16() !== 0 || at < 6)
                  return [Ve, Ke];
                const gt = pe.getUint16(), Lt = pe.getUint16(), Yt = 12;
                let Ft, Dt;
                for (Ft = 0; Ft < gt && pe.pos + Yt <= It; Ft++) {
                  const Wt = {
                    platform: pe.getUint16(),
                    encoding: pe.getUint16(),
                    language: pe.getUint16(),
                    name: pe.getUint16(),
                    length: pe.getUint16(),
                    offset: pe.getUint16()
                  };
                  (fe(Wt) || Y(Wt)) && Ke.push(Wt);
                }
                for (Ft = 0, Dt = Ke.length; Ft < Dt; Ft++) {
                  const Wt = Ke[Ft];
                  if (Wt.length <= 0)
                    continue;
                  const xt = $e + Lt + Wt.offset;
                  if (xt + Wt.length > It)
                    continue;
                  pe.pos = xt;
                  const Bt = Wt.name;
                  if (Wt.encoding) {
                    let ht = "";
                    for (let Ht = 0, Qt = Wt.length; Ht < Qt; Ht += 2)
                      ht += String.fromCharCode(pe.getUint16());
                    Ve[1][Bt] = ht;
                  } else
                    Ve[0][Bt] = pe.getString(Wt.length);
                }
                return [Ve, Ke];
              }
              const we = [0, 0, 0, 0, 0, 0, 0, 0, -2, -2, -2, -2, 0, 0, -2, -5, -1, -1, -1, -1, -1, -1, -1, -1, 0, 0, -1, 0, -1, -1, -1, -1, 1, -1, -999, 0, 1, 0, -1, -2, 0, -1, -2, -1, -1, 0, -1, -1, 0, 0, -999, -999, -1, -1, -1, -1, -2, -999, -2, -2, -999, 0, -2, -2, 0, 0, -2, 0, -2, 0, 0, 0, -2, -1, -1, 1, 1, 0, 0, -1, -1, -1, -1, -1, -1, -1, 0, 0, -1, 0, -1, -1, 0, -999, -1, -1, -1, -1, -1, -1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, -2, -999, -999, -999, -999, -999, -1, -1, -2, -2, 0, 0, 0, 0, -1, -1, -999, -2, -2, 0, 0, -1, -2, -2, 0, 0, 0, -1, -1, -1, -2];
              function Le(ze, $e) {
                let Ve = ze.data, Ke = 0, at, It, st, Ze, gt, Lt = 0, Yt = 0;
                const Ft = [], Dt = [], Wt = [];
                let xt = $e.tooComplexToFollowFunctions, Bt = !1, ht = 0, Ht = 0;
                for (let Vn = Ve.length; Ke < Vn; ) {
                  const $t = Ve[Ke++];
                  if ($t === 64)
                    if (It = Ve[Ke++], Bt || Ht)
                      Ke += It;
                    else
                      for (at = 0; at < It; at++)
                        Ft.push(Ve[Ke++]);
                  else if ($t === 65)
                    if (It = Ve[Ke++], Bt || Ht)
                      Ke += It * 2;
                    else
                      for (at = 0; at < It; at++)
                        st = Ve[Ke++], Ft.push(st << 8 | Ve[Ke++]);
                  else if (($t & 248) === 176)
                    if (It = $t - 176 + 1, Bt || Ht)
                      Ke += It;
                    else
                      for (at = 0; at < It; at++)
                        Ft.push(Ve[Ke++]);
                  else if (($t & 248) === 184)
                    if (It = $t - 184 + 1, Bt || Ht)
                      Ke += It * 2;
                    else
                      for (at = 0; at < It; at++)
                        st = Ve[Ke++], Ft.push(st << 8 | Ve[Ke++]);
                  else if ($t === 43 && !xt) {
                    if (!Bt && !Ht) {
                      if (Ze = Ft.at(-1), isNaN(Ze))
                        (0, s.info)("TT: CALL empty stack (or invalid entry).");
                      else if ($e.functionsUsed[Ze] = !0, Ze in $e.functionsStackDeltas) {
                        const Ut = Ft.length + $e.functionsStackDeltas[Ze];
                        if (Ut < 0) {
                          (0, s.warn)("TT: CALL invalid functions stack delta."), $e.hintsValid = !1;
                          return;
                        }
                        Ft.length = Ut;
                      } else if (Ze in $e.functionsDefined && !Wt.includes(Ze)) {
                        if (Dt.push({
                          data: Ve,
                          i: Ke,
                          stackTop: Ft.length - 1
                        }), Wt.push(Ze), gt = $e.functionsDefined[Ze], !gt) {
                          (0, s.warn)("TT: CALL non-existent function"), $e.hintsValid = !1;
                          return;
                        }
                        Ve = gt.data, Ke = gt.i;
                      }
                    }
                  } else if ($t === 44 && !xt)
                    (Bt || Ht) && ((0, s.warn)("TT: nested FDEFs not allowed"), xt = !0), Bt = !0, Yt = Ke, Ze = Ft.pop(), $e.functionsDefined[Ze] = {
                      data: Ve,
                      i: Ke
                    };
                  else if ($t === 45)
                    if (Bt)
                      Bt = !1, Lt = Ke;
                    else {
                      if (gt = Dt.pop(), !gt) {
                        (0, s.warn)("TT: ENDF bad stack"), $e.hintsValid = !1;
                        return;
                      }
                      Ze = Wt.pop(), Ve = gt.data, Ke = gt.i, $e.functionsStackDeltas[Ze] = Ft.length - gt.stackTop;
                    }
                  else if ($t === 137)
                    (Bt || Ht) && ((0, s.warn)("TT: nested IDEFs not allowed"), xt = !0), Bt = !0, Yt = Ke;
                  else if ($t === 88)
                    ++ht;
                  else if ($t === 27)
                    Ht = ht;
                  else if ($t === 89)
                    Ht === ht && (Ht = 0), --ht;
                  else if ($t === 28 && !Bt && !Ht) {
                    const Ut = Ft.at(-1);
                    Ut > 0 && (Ke += Ut - 1);
                  }
                  if (!Bt && !Ht) {
                    let Ut = 0;
                    for ($t <= 142 ? Ut = we[$t] : $t >= 192 && $t <= 223 ? Ut = -1 : $t >= 224 && (Ut = -2), $t >= 113 && $t <= 117 && (It = Ft.pop(), isNaN(It) || (Ut = -It * 2)); Ut < 0 && Ft.length > 0; )
                      Ft.pop(), Ut++;
                    for (; Ut > 0; )
                      Ft.push(NaN), Ut--;
                  }
                }
                $e.tooComplexToFollowFunctions = xt;
                const Qt = [Ve];
                Ke > Ve.length && Qt.push(new Uint8Array(Ke - Ve.length)), Yt > Lt && ((0, s.warn)("TT: complementing a missing function tail"), Qt.push(new Uint8Array([34, 45]))), ct(ze, Qt);
              }
              function Re(ze, $e) {
                if (!ze.tooComplexToFollowFunctions) {
                  if (ze.functionsDefined.length > $e) {
                    (0, s.warn)("TT: more functions defined than expected"), ze.hintsValid = !1;
                    return;
                  }
                  for (let Ve = 0, Ke = ze.functionsUsed.length; Ve < Ke; Ve++) {
                    if (Ve > $e) {
                      (0, s.warn)("TT: invalid function id: " + Ve), ze.hintsValid = !1;
                      return;
                    }
                    if (ze.functionsUsed[Ve] && !ze.functionsDefined[Ve]) {
                      (0, s.warn)("TT: undefined function: " + Ve), ze.hintsValid = !1;
                      return;
                    }
                  }
                }
              }
              function ct(ze, $e) {
                if ($e.length > 1) {
                  let Ve = 0, Ke, at;
                  for (Ke = 0, at = $e.length; Ke < at; Ke++)
                    Ve += $e[Ke].length;
                  Ve = Ve + 3 & -4;
                  const It = new Uint8Array(Ve);
                  let st = 0;
                  for (Ke = 0, at = $e.length; Ke < at; Ke++)
                    It.set($e[Ke], st), st += $e[Ke].length;
                  ze.data = It, ze.length = Ve;
                }
              }
              function ft(ze, $e, Ve, Ke) {
                const at = {
                  functionsDefined: [],
                  functionsUsed: [],
                  functionsStackDeltas: [],
                  tooComplexToFollowFunctions: !1,
                  hintsValid: !0
                };
                if (ze && Le(ze, at), $e && Le($e, at), ze && Re(at, Ke), Ve && Ve.length & 1) {
                  const It = new Uint8Array(Ve.length + 1);
                  It.set(Ve.data), Ve.data = It;
                }
                return at.hintsValid;
              }
              pe = new D.Stream(new Uint8Array(pe.getBytes()));
              let kt, We;
              if (Z(pe)) {
                const ze = Ce(pe, this.name);
                kt = ze.header, We = ze.tables;
              } else
                kt = ye(pe), We = me(pe, kt.numTables);
              let jt, yt;
              const Ye = !We["CFF "];
              if (Ye) {
                if (!We.loca)
                  throw new s.FormatError('Required "loca" table is not found');
                We.glyf || ((0, s.warn)('Required "glyf" table is not found -- trying to recover.'), We.glyf = {
                  tag: "glyf",
                  data: new Uint8Array(0)
                }), this.isOpenType = !1;
              } else {
                const ze = de.composite && (((_t = de.cidToGidMap) == null ? void 0 : _t.length) > 0 || !(de.cMap instanceof u.IdentityCMap));
                if (kt.version === "OTTO" && !ze || !We.head || !We.hhea || !We.maxp || !We.post)
                  return yt = new D.Stream(We["CFF "].data), jt = new S.CFFFont(yt, de), _(de), this.convert(he, jt, de);
                delete We.glyf, delete We.loca, delete We.fpgm, delete We.prep, delete We["cvt "], this.isOpenType = !0;
              }
              if (!We.maxp)
                throw new s.FormatError('Required "maxp" table is not found');
              pe.pos = (pe.start || 0) + We.maxp.offset;
              const mt = pe.getInt32(), Pt = pe.getUint16();
              if (((Zt = de.scaleFactors) == null ? void 0 : Zt.length) === Pt && Ye) {
                const {
                  scaleFactors: ze
                } = de, $e = w(We.head.data[50], We.head.data[51]), Ve = new b.GlyfTable({
                  glyfTable: We.glyf.data,
                  isGlyphLocationsLong: $e,
                  locaTable: We.loca.data,
                  numGlyphs: Pt
                });
                Ve.scale(ze);
                const {
                  glyf: Ke,
                  loca: at,
                  isLocationLong: It
                } = Ve.write();
                We.glyf.data = Ke, We.loca.data = at, It !== !!$e && (We.head.data[50] = 0, We.head.data[51] = It ? 1 : 0);
                const st = We.hmtx.data;
                for (let Ze = 0; Ze < Pt; Ze++) {
                  const gt = 4 * Ze, Lt = Math.round(ze[Ze] * w(st[gt], st[gt + 1]));
                  st[gt] = Lt >> 8 & 255, st[gt + 1] = Lt & 255;
                  const Yt = Math.round(ze[Ze] * j(st[gt + 2], st[gt + 3]));
                  F(st, gt + 2, Yt);
                }
              }
              let et = Pt + 1, tn = !0;
              et > 65535 && (tn = !1, et = Pt, (0, s.warn)("Not enough space in glyfs to duplicate first glyph."));
              let Xt = 0, _e = 0;
              mt >= 65536 && We.maxp.length >= 22 && (pe.pos += 8, pe.getUint16() > 2 && (We.maxp.data[14] = 0, We.maxp.data[15] = 2), pe.pos += 4, Xt = pe.getUint16(), pe.pos += 4, _e = pe.getUint16()), We.maxp.data[4] = et >> 8, We.maxp.data[5] = et & 255;
              const Qe = ft(We.fpgm, We.prep, We["cvt "], Xt);
              if (Qe || (delete We.fpgm, delete We.prep, delete We["cvt "]), Ae(pe, We.hhea, We.hmtx, We.head, et, tn), !We.head)
                throw new s.FormatError('Required "head" table is not found');
              De(We.head, Pt, Ye ? We.loca.length : 0);
              let qe = /* @__PURE__ */ Object.create(null);
              if (Ye) {
                const ze = w(We.head.data[50], We.head.data[51]), $e = Be(We.loca, We.glyf, Pt, ze, Qe, tn, _e);
                qe = $e.missingGlyphs, mt >= 65536 && We.maxp.length >= 22 && (We.maxp.data[26] = $e.maxSizeOfInstructions >> 8, We.maxp.data[27] = $e.maxSizeOfInstructions & 255);
              }
              if (!We.hhea)
                throw new s.FormatError('Required "hhea" table is not found');
              We.hhea.data[10] === 0 && We.hhea.data[11] === 0 && (We.hhea.data[10] = 255, We.hhea.data[11] = 255);
              const Je = {
                unitsPerEm: w(We.head.data[18], We.head.data[19]),
                yMax: j(We.head.data[42], We.head.data[43]),
                yMin: j(We.head.data[38], We.head.data[39]),
                ascent: j(We.hhea.data[4], We.hhea.data[5]),
                descent: j(We.hhea.data[6], We.hhea.data[7]),
                lineGap: j(We.hhea.data[8], We.hhea.data[9])
              };
              this.ascent = Je.ascent / Je.unitsPerEm, this.descent = Je.descent / Je.unitsPerEm, this.lineGap = Je.lineGap / Je.unitsPerEm, (an = this.cssFontInfo) != null && an.lineHeight ? (this.lineHeight = this.cssFontInfo.metrics.lineHeight, this.lineGap = this.cssFontInfo.metrics.lineGap) : this.lineHeight = this.ascent - this.descent + this.lineGap, We.post && ke(We.post, de, Pt), We.post = {
                tag: "post",
                data: U(de)
              };
              const nt = [];
              function At(ze) {
                return !qe[ze];
              }
              if (de.composite) {
                const ze = de.cidToGidMap || [], $e = ze.length === 0;
                de.cMap.forEach(function(Ve, Ke) {
                  if (typeof Ke == "string" && (Ke = ae(Ve, Ke, !0)), Ke > 65535)
                    throw new s.FormatError("Max size of CID is 65,535");
                  let at = -1;
                  $e ? at = Ke : ze[Ke] !== void 0 && (at = ze[Ke]), at >= 0 && at < Pt && At(at) && (nt[Ve] = at);
                });
              } else {
                const ze = Ie(We.cmap, pe, this.isSymbolicFont, de.hasEncoding), $e = ze.platformId, Ve = ze.encodingId, Ke = ze.mappings;
                let at = [], It = !1;
                if (de.hasEncoding && (de.baseEncodingName === "MacRomanEncoding" || de.baseEncodingName === "WinAnsiEncoding") && (at = (0, m.getEncoding)(de.baseEncodingName)), de.hasEncoding && !this.isSymbolicFont && ($e === 3 && Ve === 1 || $e === 1 && Ve === 0)) {
                  const st = (0, i.getGlyphsUnicode)();
                  for (let Ze = 0; Ze < 256; Ze++) {
                    let gt;
                    if (this.differences[Ze] !== void 0 ? gt = this.differences[Ze] : at.length && at[Ze] !== "" ? gt = at[Ze] : gt = m.StandardEncoding[Ze], !gt)
                      continue;
                    const Lt = (0, g.recoverGlyphName)(gt, st);
                    let Yt;
                    if ($e === 3 && Ve === 1 ? Yt = st[Lt] : $e === 1 && Ve === 0 && (Yt = m.MacRomanEncoding.indexOf(Lt)), Yt === void 0) {
                      if (!de.glyphNames && de.hasIncludedToUnicodeMap && !(this.toUnicode instanceof E.IdentityToUnicodeMap)) {
                        const Ft = this.toUnicode.get(Ze);
                        Ft && (Yt = Ft.codePointAt(0));
                      }
                      if (Yt === void 0)
                        continue;
                    }
                    for (const Ft of Ke)
                      if (Ft.charCode === Yt) {
                        nt[Ze] = Ft.glyphId;
                        break;
                      }
                  }
                } else if ($e === 0) {
                  for (const st of Ke)
                    nt[st.charCode] = st.glyphId;
                  It = !0;
                } else
                  for (const st of Ke) {
                    let Ze = st.charCode;
                    $e === 3 && Ze >= 61440 && Ze <= 61695 && (Ze &= 255), nt[Ze] = st.glyphId;
                  }
                if (de.glyphNames && (at.length || this.differences.length))
                  for (let st = 0; st < 256; ++st) {
                    if (!It && nt[st] !== void 0)
                      continue;
                    const Ze = this.differences[st] || at[st];
                    if (!Ze)
                      continue;
                    const gt = de.glyphNames.indexOf(Ze);
                    gt > 0 && At(gt) && (nt[st] = gt);
                  }
              }
              nt.length === 0 && (nt[0] = 0);
              let Rt = et - 1;
              if (tn || (Rt = 0), !de.cssFontInfo) {
                const ze = se(nt, At, Rt, this.toUnicode);
                this.toFontChar = ze.toFontChar, We.cmap = {
                  tag: "cmap",
                  data: W(ze.charCodeToGlyphId, ze.toUnicodeExtraMap, et)
                }, (!We["OS/2"] || !M(We["OS/2"], pe)) && (We["OS/2"] = {
                  tag: "OS/2",
                  data: X(de, ze.charCodeToGlyphId, Je)
                });
              }
              if (!Ye)
                try {
                  yt = new D.Stream(We["CFF "].data), jt = new h.CFFParser(yt, de, g.SEAC_ANALYSIS_ENABLED).parse(), jt.duplicateFirstGlyph();
                  const $e = new h.CFFCompiler(jt);
                  We["CFF "].data = $e.compile();
                } catch {
                  (0, s.warn)("Failed to compile font " + de.loadedName);
                }
              if (!We.name)
                We.name = {
                  tag: "name",
                  data: re(this.name)
                };
              else {
                const [ze, $e] = be(We.name);
                We.name.data = re(he, ze), this.psName = ze[0][6] || null, de.composite || A(de, this.isSymbolicFont, $e);
              }
              const St = new I.OpenTypeFileBuilder(kt.version);
              for (const ze in We)
                St.addTable(ze, We[ze].data);
              return St.toArray();
            }
            convert(he, pe, de) {
              de.fixedPitch = !1, de.builtInEncoding && k(de, de.builtInEncoding);
              let ge = 1;
              pe instanceof S.CFFFont && (ge = pe.numGlyphs - 1);
              const me = pe.getGlyphMapping(de);
              let xe = null, ye = me, ve = null;
              de.cssFontInfo || (xe = se(me, pe.hasGlyphId.bind(pe), ge, this.toUnicode), this.toFontChar = xe.toFontChar, ye = xe.charCodeToGlyphId, ve = xe.toUnicodeExtraMap);
              const Ce = pe.numGlyphs;
              function Ie(ke, be) {
                let we = null;
                for (const Le in ke)
                  be === ke[Le] && (we || (we = [])).push(Le | 0);
                return we;
              }
              function Ae(ke, be) {
                for (const we in ke)
                  if (be === ke[we])
                    return we | 0;
                return xe.charCodeToGlyphId[xe.nextAvailableFontCharCode] = be, xe.nextAvailableFontCharCode++;
              }
              const Se = pe.seacs;
              if (xe && g.SEAC_ANALYSIS_ENABLED && (Se != null && Se.length)) {
                const ke = de.fontMatrix || s.FONT_IDENTITY_MATRIX, be = pe.getCharset(), we = /* @__PURE__ */ Object.create(null);
                for (let Le in Se) {
                  Le |= 0;
                  const Re = Se[Le], ct = m.StandardEncoding[Re[2]], ft = m.StandardEncoding[Re[3]], kt = be.indexOf(ct), We = be.indexOf(ft);
                  if (kt < 0 || We < 0)
                    continue;
                  const jt = {
                    x: Re[0] * ke[0] + Re[1] * ke[2] + ke[4],
                    y: Re[0] * ke[1] + Re[1] * ke[3] + ke[5]
                  }, yt = Ie(me, Le);
                  if (yt)
                    for (const Ye of yt) {
                      const mt = xe.charCodeToGlyphId, Pt = Ae(mt, kt), et = Ae(mt, We);
                      we[Ye] = {
                        baseFontCharCode: Pt,
                        accentFontCharCode: et,
                        accentOffset: jt
                      };
                    }
                }
                de.seacMap = we;
              }
              const De = 1 / (de.fontMatrix || s.FONT_IDENTITY_MATRIX)[0], Be = new I.OpenTypeFileBuilder("OTTO");
              return Be.addTable("CFF ", pe.data), Be.addTable("OS/2", X(de, ye)), Be.addTable("cmap", W(ye, ve, Ce)), Be.addTable("head", "\0\0\0\0\0\0\0\0\0\0_<õ\0\0" + J(De) + "\0\0\0\0\v~'\0\0\0\0\v~'\0\0" + J(de.descent) + "ÿ" + J(de.ascent) + V(de.italicAngle ? 2 : 0) + "\0\0\0\0\0\0\0"), Be.addTable("hhea", "\0\0\0" + J(de.ascent) + J(de.descent) + "\0\0ÿÿ\0\0\0\0\0\0" + J(de.capHeight) + J(Math.tan(de.italicAngle) * de.xHeight) + "\0\0\0\0\0\0\0\0\0\0\0\0" + V(Ce)), Be.addTable("hmtx", function() {
                const be = pe.charstrings, we = pe.cff ? pe.cff.widths : null;
                let Le = "\0\0\0\0";
                for (let Re = 1, ct = Ce; Re < ct; Re++) {
                  let ft = 0;
                  if (be) {
                    const kt = be[Re - 1];
                    ft = "width" in kt ? kt.width : 0;
                  } else we && (ft = Math.ceil(we[Re] || 0));
                  Le += V(ft) + V(0);
                }
                return Le;
              }()), Be.addTable("maxp", "\0\0P\0" + V(Ce)), Be.addTable("name", re(he)), Be.addTable("post", U(de)), Be.toArray();
            }
            get spaceWidth() {
              const he = ["space", "minus", "one", "i", "I"];
              let pe;
              for (const de of he) {
                if (de in this.widths) {
                  pe = this.widths[de];
                  break;
                }
                const me = (0, i.getGlyphsUnicode)()[de];
                let xe = 0;
                if (this.composite && this.cMap.contains(me) && (xe = this.cMap.lookup(me), typeof xe == "string" && (xe = ae(me, xe))), !xe && this.toUnicode && (xe = this.toUnicode.charCodeOf(me)), xe <= 0 && (xe = me), pe = this.widths[xe], pe)
                  break;
              }
              return (0, s.shadow)(this, "spaceWidth", pe || this.defaultWidth);
            }
            _charToGlyph(he, pe = !1) {
              var De, Be, ke;
              let de = this._glyphCache[he];
              if ((de == null ? void 0 : de.isSpace) === pe)
                return de;
              let ge, me, xe, ye = he;
              (De = this.cMap) != null && De.contains(he) && (ye = this.cMap.lookup(he), typeof ye == "string" && (ye = ae(he, ye))), me = this.widths[ye], typeof me != "number" && (me = this.defaultWidth);
              const ve = (Be = this.vmetrics) == null ? void 0 : Be[ye];
              let Ce = this.toUnicode.get(he) || he;
              typeof Ce == "number" && (Ce = String.fromCharCode(Ce));
              let Ie = this.toFontChar[he] !== void 0;
              if (ge = this.toFontChar[he] || he, this.missingFile) {
                const be = this.differences[he] || this.defaultEncoding[he];
                (be === ".notdef" || be === "") && this.type === "Type1" && (ge = 32), ge = (0, t.mapSpecialUnicodeValues)(ge);
              }
              this.isType3Font && (xe = ge);
              let Ae = null;
              if ((ke = this.seacMap) != null && ke[he]) {
                Ie = !0;
                const be = this.seacMap[he];
                ge = be.baseFontCharCode, Ae = {
                  fontChar: String.fromCodePoint(be.accentFontCharCode),
                  offset: be.accentOffset
                };
              }
              let Se = "";
              return typeof ge == "number" && (ge <= 1114111 ? Se = String.fromCodePoint(ge) : (0, s.warn)(`charToGlyph - invalid fontCharCode: ${ge}`)), de = new T(he, Se, Ce, Ae, me, ve, xe, pe, Ie), this._glyphCache[he] = de;
            }
            charsToGlyphs(he) {
              let pe = this._charsCache[he];
              if (pe)
                return pe;
              if (pe = [], this.cMap) {
                const de = /* @__PURE__ */ Object.create(null), ge = he.length;
                let me = 0;
                for (; me < ge; ) {
                  this.cMap.readCharCode(he, me, de);
                  const {
                    charcode: xe,
                    length: ye
                  } = de;
                  me += ye;
                  const ve = this._charToGlyph(xe, ye === 1 && he.charCodeAt(me - 1) === 32);
                  pe.push(ve);
                }
              } else
                for (let de = 0, ge = he.length; de < ge; ++de) {
                  const me = he.charCodeAt(de), xe = this._charToGlyph(me, me === 32);
                  pe.push(xe);
                }
              return this._charsCache[he] = pe;
            }
            getCharPositions(he) {
              const pe = [];
              if (this.cMap) {
                const de = /* @__PURE__ */ Object.create(null);
                let ge = 0;
                for (; ge < he.length; ) {
                  this.cMap.readCharCode(he, ge, de);
                  const me = de.length;
                  pe.push([ge, ge + me]), ge += me;
                }
              } else
                for (let de = 0, ge = he.length; de < ge; ++de)
                  pe.push([de, de + 1]);
              return pe;
            }
            get glyphCacheValues() {
              return Object.values(this._glyphCache);
            }
            encodeString(he) {
              const pe = [], de = [], ge = () => pe.length % 2 === 1, me = this.toUnicode instanceof E.IdentityToUnicodeMap ? (xe) => this.toUnicode.charCodeOf(xe) : (xe) => this.toUnicode.charCodeOf(String.fromCodePoint(xe));
              for (let xe = 0, ye = he.length; xe < ye; xe++) {
                const ve = he.codePointAt(xe);
                if (ve > 55295 && (ve < 57344 || ve > 65533) && xe++, this.toUnicode) {
                  const Ce = me(ve);
                  if (Ce !== -1) {
                    ge() && (pe.push(de.join("")), de.length = 0);
                    const Ie = this.cMap ? this.cMap.getCharCodeLength(Ce) : 1;
                    for (let Ae = Ie - 1; Ae >= 0; Ae--)
                      de.push(String.fromCharCode(Ce >> 8 * Ae & 255));
                    continue;
                  }
                }
                ge() || (pe.push(de.join("")), de.length = 0), de.push(String.fromCodePoint(ve));
              }
              return pe.push(de.join("")), pe;
            }
          }
          c.Font = le;
          class ce {
            constructor(he) {
              this.error = he, this.loadedName = "g_font_error", this.missingFile = !0;
            }
            charsToGlyphs() {
              return [];
            }
            encodeString(he) {
              return [he];
            }
            exportData(he = !1) {
              return {
                error: this.error
              };
            }
          }
          c.ErrorFont = ce;
        },
        /* 35 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.CFFTopDict = c.CFFStrings = c.CFFStandardStrings = c.CFFPrivateDict = c.CFFParser = c.CFFIndex = c.CFFHeader = c.CFFFDSelect = c.CFFCompiler = c.CFFCharset = c.CFF = void 0;
          var s = f(2), h = f(36), g = f(37);
          const t = 10, i = [".notdef", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quoteright", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "quoteleft", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "exclamdown", "cent", "sterling", "fraction", "yen", "florin", "section", "currency", "quotesingle", "quotedblleft", "guillemotleft", "guilsinglleft", "guilsinglright", "fi", "fl", "endash", "dagger", "daggerdbl", "periodcentered", "paragraph", "bullet", "quotesinglbase", "quotedblbase", "quotedblright", "guillemotright", "ellipsis", "perthousand", "questiondown", "grave", "acute", "circumflex", "tilde", "macron", "breve", "dotaccent", "dieresis", "ring", "cedilla", "hungarumlaut", "ogonek", "caron", "emdash", "AE", "ordfeminine", "Lslash", "Oslash", "OE", "ordmasculine", "ae", "dotlessi", "lslash", "oslash", "oe", "germandbls", "onesuperior", "logicalnot", "mu", "trademark", "Eth", "onehalf", "plusminus", "Thorn", "onequarter", "divide", "brokenbar", "degree", "thorn", "threequarters", "twosuperior", "registered", "minus", "eth", "multiply", "threesuperior", "copyright", "Aacute", "Acircumflex", "Adieresis", "Agrave", "Aring", "Atilde", "Ccedilla", "Eacute", "Ecircumflex", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Ntilde", "Oacute", "Ocircumflex", "Odieresis", "Ograve", "Otilde", "Scaron", "Uacute", "Ucircumflex", "Udieresis", "Ugrave", "Yacute", "Ydieresis", "Zcaron", "aacute", "acircumflex", "adieresis", "agrave", "aring", "atilde", "ccedilla", "eacute", "ecircumflex", "edieresis", "egrave", "iacute", "icircumflex", "idieresis", "igrave", "ntilde", "oacute", "ocircumflex", "odieresis", "ograve", "otilde", "scaron", "uacute", "ucircumflex", "udieresis", "ugrave", "yacute", "ydieresis", "zcaron", "exclamsmall", "Hungarumlautsmall", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "commasuperior", "threequartersemdash", "periodsuperior", "questionsmall", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "isuperior", "lsuperior", "msuperior", "nsuperior", "osuperior", "rsuperior", "ssuperior", "tsuperior", "ff", "ffi", "ffl", "parenleftinferior", "parenrightinferior", "Circumflexsmall", "hyphensuperior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "exclamdownsmall", "centoldstyle", "Lslashsmall", "Scaronsmall", "Zcaronsmall", "Dieresissmall", "Brevesmall", "Caronsmall", "Dotaccentsmall", "Macronsmall", "figuredash", "hypheninferior", "Ogoneksmall", "Ringsmall", "Cedillasmall", "questiondownsmall", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "zerosuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior", "Agravesmall", "Aacutesmall", "Acircumflexsmall", "Atildesmall", "Adieresissmall", "Aringsmall", "AEsmall", "Ccedillasmall", "Egravesmall", "Eacutesmall", "Ecircumflexsmall", "Edieresissmall", "Igravesmall", "Iacutesmall", "Icircumflexsmall", "Idieresissmall", "Ethsmall", "Ntildesmall", "Ogravesmall", "Oacutesmall", "Ocircumflexsmall", "Otildesmall", "Odieresissmall", "OEsmall", "Oslashsmall", "Ugravesmall", "Uacutesmall", "Ucircumflexsmall", "Udieresissmall", "Yacutesmall", "Thornsmall", "Ydieresissmall", "001.000", "001.001", "001.002", "001.003", "Black", "Bold", "Book", "Light", "Medium", "Regular", "Roman", "Semibold"];
          c.CFFStandardStrings = i;
          const m = 391, v = [null, {
            id: "hstem",
            min: 2,
            stackClearing: !0,
            stem: !0
          }, null, {
            id: "vstem",
            min: 2,
            stackClearing: !0,
            stem: !0
          }, {
            id: "vmoveto",
            min: 1,
            stackClearing: !0
          }, {
            id: "rlineto",
            min: 2,
            resetStack: !0
          }, {
            id: "hlineto",
            min: 1,
            resetStack: !0
          }, {
            id: "vlineto",
            min: 1,
            resetStack: !0
          }, {
            id: "rrcurveto",
            min: 6,
            resetStack: !0
          }, null, {
            id: "callsubr",
            min: 1,
            undefStack: !0
          }, {
            id: "return",
            min: 0,
            undefStack: !0
          }, null, null, {
            id: "endchar",
            min: 0,
            stackClearing: !0
          }, null, null, null, {
            id: "hstemhm",
            min: 2,
            stackClearing: !0,
            stem: !0
          }, {
            id: "hintmask",
            min: 0,
            stackClearing: !0
          }, {
            id: "cntrmask",
            min: 0,
            stackClearing: !0
          }, {
            id: "rmoveto",
            min: 2,
            stackClearing: !0
          }, {
            id: "hmoveto",
            min: 1,
            stackClearing: !0
          }, {
            id: "vstemhm",
            min: 2,
            stackClearing: !0,
            stem: !0
          }, {
            id: "rcurveline",
            min: 8,
            resetStack: !0
          }, {
            id: "rlinecurve",
            min: 8,
            resetStack: !0
          }, {
            id: "vvcurveto",
            min: 4,
            resetStack: !0
          }, {
            id: "hhcurveto",
            min: 4,
            resetStack: !0
          }, null, {
            id: "callgsubr",
            min: 1,
            undefStack: !0
          }, {
            id: "vhcurveto",
            min: 4,
            resetStack: !0
          }, {
            id: "hvcurveto",
            min: 4,
            resetStack: !0
          }], E = [null, null, null, {
            id: "and",
            min: 2,
            stackDelta: -1
          }, {
            id: "or",
            min: 2,
            stackDelta: -1
          }, {
            id: "not",
            min: 1,
            stackDelta: 0
          }, null, null, null, {
            id: "abs",
            min: 1,
            stackDelta: 0
          }, {
            id: "add",
            min: 2,
            stackDelta: -1,
            stackFn(z, T) {
              z[T - 2] = z[T - 2] + z[T - 1];
            }
          }, {
            id: "sub",
            min: 2,
            stackDelta: -1,
            stackFn(z, T) {
              z[T - 2] = z[T - 2] - z[T - 1];
            }
          }, {
            id: "div",
            min: 2,
            stackDelta: -1,
            stackFn(z, T) {
              z[T - 2] = z[T - 2] / z[T - 1];
            }
          }, null, {
            id: "neg",
            min: 1,
            stackDelta: 0,
            stackFn(z, T) {
              z[T - 1] = -z[T - 1];
            }
          }, {
            id: "eq",
            min: 2,
            stackDelta: -1
          }, null, null, {
            id: "drop",
            min: 1,
            stackDelta: -1
          }, null, {
            id: "put",
            min: 2,
            stackDelta: -2
          }, {
            id: "get",
            min: 1,
            stackDelta: 0
          }, {
            id: "ifelse",
            min: 4,
            stackDelta: -3
          }, {
            id: "random",
            min: 0,
            stackDelta: 1
          }, {
            id: "mul",
            min: 2,
            stackDelta: -1,
            stackFn(z, T) {
              z[T - 2] = z[T - 2] * z[T - 1];
            }
          }, null, {
            id: "sqrt",
            min: 1,
            stackDelta: 0
          }, {
            id: "dup",
            min: 1,
            stackDelta: 1
          }, {
            id: "exch",
            min: 2,
            stackDelta: 0
          }, {
            id: "index",
            min: 2,
            stackDelta: 0
          }, {
            id: "roll",
            min: 3,
            stackDelta: -2
          }, null, null, null, {
            id: "hflex",
            min: 7,
            resetStack: !0
          }, {
            id: "flex",
            min: 13,
            resetStack: !0
          }, {
            id: "hflex1",
            min: 9,
            resetStack: !0
          }, {
            id: "flex1",
            min: 11,
            resetStack: !0
          }];
          class S {
            constructor(T, w, F) {
              this.bytes = T.getBytes(), this.properties = w, this.seacAnalysisEnabled = !!F;
            }
            parse() {
              const T = this.properties, w = new y();
              this.cff = w;
              const F = this.parseHeader(), j = this.parseIndex(F.endPos), P = this.parseIndex(j.endPos), V = this.parseIndex(P.endPos), J = this.parseIndex(V.endPos), ne = this.parseDict(P.obj.get(0)), Z = this.createDict(D, ne, w.strings);
              w.header = F.obj, w.names = this.parseNameIndex(j.obj), w.strings = this.parseStringIndex(V.obj), w.topDict = Z, w.globalSubrIndex = J.obj, this.parsePrivateDict(w.topDict), w.isCIDFont = Z.hasName("ROS");
              const te = Z.getByName("CharStrings"), G = this.parseIndex(te).obj, N = Z.getByName("FontMatrix");
              N && (T.fontMatrix = N);
              const q = Z.getByName("FontBBox");
              q && (T.ascent = Math.max(q[3], q[1]), T.descent = Math.min(q[1], q[3]), T.ascentScaled = !0);
              let ie, oe;
              if (w.isCIDFont) {
                const Y = this.parseIndex(Z.getByName("FDArray")).obj;
                for (let ae = 0, se = Y.count; ae < se; ++ae) {
                  const L = Y.get(ae), W = this.createDict(D, this.parseDict(L), w.strings);
                  this.parsePrivateDict(W), w.fdArray.push(W);
                }
                oe = null, ie = this.parseCharsets(Z.getByName("charset"), G.count, w.strings, !0), w.fdSelect = this.parseFDSelect(Z.getByName("FDSelect"), G.count);
              } else
                ie = this.parseCharsets(Z.getByName("charset"), G.count, w.strings, !1), oe = this.parseEncoding(Z.getByName("Encoding"), T, w.strings, ie.charset);
              w.charset = ie, w.encoding = oe;
              const fe = this.parseCharStrings({
                charStrings: G,
                localSubrIndex: Z.privateDict.subrsIndex,
                globalSubrIndex: J.obj,
                fdSelect: w.fdSelect,
                fdArray: w.fdArray,
                privateDict: Z.privateDict
              });
              return w.charStrings = fe.charStrings, w.seacs = fe.seacs, w.widths = fe.widths, w;
            }
            parseHeader() {
              let T = this.bytes;
              const w = T.length;
              let F = 0;
              for (; F < w && T[F] !== 1; )
                ++F;
              if (F >= w)
                throw new s.FormatError("Invalid CFF header");
              F !== 0 && ((0, s.info)("cff data is shifted"), T = T.subarray(F), this.bytes = T);
              const j = T[0], P = T[1], V = T[2], J = T[3];
              return {
                obj: new x(j, P, V, J),
                endPos: V
              };
            }
            parseDict(T) {
              let w = 0;
              function F() {
                let ne = T[w++];
                return ne === 30 ? j() : ne === 28 ? (ne = T[w++], ne = (ne << 24 | T[w++] << 16) >> 16, ne) : ne === 29 ? (ne = T[w++], ne = ne << 8 | T[w++], ne = ne << 8 | T[w++], ne = ne << 8 | T[w++], ne) : ne >= 32 && ne <= 246 ? ne - 139 : ne >= 247 && ne <= 250 ? (ne - 247) * 256 + T[w++] + 108 : ne >= 251 && ne <= 254 ? -((ne - 251) * 256) - T[w++] - 108 : ((0, s.warn)('CFFParser_parseDict: "' + ne + '" is a reserved command.'), NaN);
              }
              function j() {
                let ne = "";
                const te = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "E", "E-", null, "-"], G = T.length;
                for (; w < G; ) {
                  const N = T[w++], q = N >> 4, ie = N & 15;
                  if (q === 15 || (ne += te[q], ie === 15))
                    break;
                  ne += te[ie];
                }
                return parseFloat(ne);
              }
              let P = [];
              const V = [];
              w = 0;
              const J = T.length;
              for (; w < J; ) {
                let ne = T[w];
                ne <= 21 ? (ne === 12 && (ne = ne << 8 | T[++w]), V.push([ne, P]), P = [], ++w) : P.push(F());
              }
              return V;
            }
            parseIndex(T) {
              const w = new u(), F = this.bytes, j = F[T++] << 8 | F[T++], P = [];
              let V = T, J, ne;
              if (j !== 0) {
                const Z = F[T++], te = T + (j + 1) * Z - 1;
                for (J = 0, ne = j + 1; J < ne; ++J) {
                  let G = 0;
                  for (let N = 0; N < Z; ++N)
                    G <<= 8, G += F[T++];
                  P.push(te + G);
                }
                V = P[j];
              }
              for (J = 0, ne = P.length - 1; J < ne; ++J) {
                const Z = P[J], te = P[J + 1];
                w.add(F.subarray(Z, te));
              }
              return {
                obj: w,
                endPos: V
              };
            }
            parseNameIndex(T) {
              const w = [];
              for (let F = 0, j = T.count; F < j; ++F) {
                const P = T.get(F);
                w.push((0, s.bytesToString)(P));
              }
              return w;
            }
            parseStringIndex(T) {
              const w = new b();
              for (let F = 0, j = T.count; F < j; ++F) {
                const P = T.get(F);
                w.add((0, s.bytesToString)(P));
              }
              return w;
            }
            createDict(T, w, F) {
              const j = new T(F);
              for (const [P, V] of w)
                j.setByKey(P, V);
              return j;
            }
            parseCharString(T, w, F, j) {
              if (!w || T.callDepth > t)
                return !1;
              let P = T.stackSize;
              const V = T.stack;
              let J = w.length;
              for (let ne = 0; ne < J; ) {
                const Z = w[ne++];
                let te = null;
                if (Z === 12) {
                  const G = w[ne++];
                  G === 0 ? (w[ne - 2] = 139, w[ne - 1] = 22, P = 0) : te = E[G];
                } else if (Z === 28)
                  V[P] = (w[ne] << 24 | w[ne + 1] << 16) >> 16, ne += 2, P++;
                else if (Z === 14) {
                  if (P >= 4 && (P -= 4, this.seacAnalysisEnabled))
                    return T.seac = V.slice(P, P + 4), !1;
                  te = v[Z];
                } else if (Z >= 32 && Z <= 246)
                  V[P] = Z - 139, P++;
                else if (Z >= 247 && Z <= 254)
                  V[P] = Z < 251 ? (Z - 247 << 8) + w[ne] + 108 : -(Z - 251 << 8) - w[ne] - 108, ne++, P++;
                else if (Z === 255)
                  V[P] = (w[ne] << 24 | w[ne + 1] << 16 | w[ne + 2] << 8 | w[ne + 3]) / 65536, ne += 4, P++;
                else if (Z === 19 || Z === 20) {
                  if (T.hints += P >> 1, T.hints === 0) {
                    w.copyWithin(ne - 1, ne, -1), ne -= 1, J -= 1;
                    continue;
                  }
                  ne += T.hints + 7 >> 3, P %= 2, te = v[Z];
                } else if (Z === 10 || Z === 29) {
                  const G = Z === 10 ? F : j;
                  if (!G)
                    return te = v[Z], (0, s.warn)("Missing subrsIndex for " + te.id), !1;
                  let N = 32768;
                  G.count < 1240 ? N = 107 : G.count < 33900 && (N = 1131);
                  const q = V[--P] + N;
                  if (q < 0 || q >= G.count || isNaN(q))
                    return te = v[Z], (0, s.warn)("Out of bounds subrIndex for " + te.id), !1;
                  if (T.stackSize = P, T.callDepth++, !this.parseCharString(T, G.get(q), F, j))
                    return !1;
                  T.callDepth--, P = T.stackSize;
                  continue;
                } else {
                  if (Z === 11)
                    return T.stackSize = P, !0;
                  if (Z === 0 && ne === w.length)
                    w[ne - 1] = 14, te = v[14];
                  else if (Z === 9) {
                    w.copyWithin(ne - 1, ne, -1), ne -= 1, J -= 1;
                    continue;
                  } else
                    te = v[Z];
                }
                if (te) {
                  if (te.stem && (T.hints += P >> 1, Z === 3 || Z === 23 ? T.hasVStems = !0 : T.hasVStems && (Z === 1 || Z === 18) && ((0, s.warn)("CFF stem hints are in wrong order"), w[ne - 1] = Z === 1 ? 3 : 23)), "min" in te && !T.undefStack && P < te.min)
                    return (0, s.warn)("Not enough parameters for " + te.id + "; actual: " + P + ", expected: " + te.min), P === 0 ? (w[ne - 1] = 14, !0) : !1;
                  T.firstStackClearing && te.stackClearing && (T.firstStackClearing = !1, P -= te.min, P >= 2 && te.stem ? P %= 2 : P > 1 && (0, s.warn)("Found too many parameters for stack-clearing command"), P > 0 && (T.width = V[P - 1])), "stackDelta" in te ? ("stackFn" in te && te.stackFn(V, P), P += te.stackDelta) : te.stackClearing ? P = 0 : te.resetStack ? (P = 0, T.undefStack = !1) : te.undefStack && (P = 0, T.undefStack = !0, T.firstStackClearing = !1);
                }
              }
              return J < w.length && w.fill(14, J), T.stackSize = P, !0;
            }
            parseCharStrings({
              charStrings: T,
              localSubrIndex: w,
              globalSubrIndex: F,
              fdSelect: j,
              fdArray: P,
              privateDict: V
            }) {
              const J = [], ne = [], Z = T.count;
              for (let te = 0; te < Z; te++) {
                const G = T.get(te), N = {
                  callDepth: 0,
                  stackSize: 0,
                  stack: [],
                  undefStack: !0,
                  hints: 0,
                  firstStackClearing: !0,
                  seac: null,
                  width: null,
                  hasVStems: !1
                };
                let q = !0, ie = null, oe = V;
                if (j && P.length) {
                  const fe = j.getFDIndex(te);
                  fe === -1 && ((0, s.warn)("Glyph index is not in fd select."), q = !1), fe >= P.length && ((0, s.warn)("Invalid fd index for glyph index."), q = !1), q && (oe = P[fe].privateDict, ie = oe.subrsIndex);
                } else w && (ie = w);
                if (q && (q = this.parseCharString(N, G, ie, F)), N.width !== null) {
                  const fe = oe.getByName("nominalWidthX");
                  ne[te] = fe + N.width;
                } else {
                  const fe = oe.getByName("defaultWidthX");
                  ne[te] = fe;
                }
                N.seac !== null && (J[te] = N.seac), q || T.set(te, new Uint8Array([14]));
              }
              return {
                charStrings: T,
                seacs: J,
                widths: ne
              };
            }
            emptyPrivateDictionary(T) {
              const w = this.createDict(K, [], T.strings);
              T.setByKey(18, [0, 0]), T.privateDict = w;
            }
            parsePrivateDict(T) {
              if (!T.hasName("Private")) {
                this.emptyPrivateDictionary(T);
                return;
              }
              const w = T.getByName("Private");
              if (!Array.isArray(w) || w.length !== 2) {
                T.removeByName("Private");
                return;
              }
              const F = w[0], j = w[1];
              if (F === 0 || j >= this.bytes.length) {
                this.emptyPrivateDictionary(T);
                return;
              }
              const P = j + F, V = this.bytes.subarray(j, P), J = this.parseDict(V), ne = this.createDict(K, J, T.strings);
              if (T.privateDict = ne, ne.getByName("ExpansionFactor") === 0 && ne.setByName("ExpansionFactor", 0.06), !ne.getByName("Subrs"))
                return;
              const Z = ne.getByName("Subrs"), te = j + Z;
              if (Z === 0 || te >= this.bytes.length) {
                this.emptyPrivateDictionary(T);
                return;
              }
              const G = this.parseIndex(te);
              ne.subrsIndex = G.obj;
            }
            parseCharsets(T, w, F, j) {
              if (T === 0)
                return new B(!0, H.ISO_ADOBE, h.ISOAdobeCharset);
              if (T === 1)
                return new B(!0, H.EXPERT, h.ExpertCharset);
              if (T === 2)
                return new B(!0, H.EXPERT_SUBSET, h.ExpertSubsetCharset);
              const P = this.bytes, V = T, J = P[T++], ne = [j ? 0 : ".notdef"];
              let Z, te, G;
              switch (w -= 1, J) {
                case 0:
                  for (G = 0; G < w; G++)
                    Z = P[T++] << 8 | P[T++], ne.push(j ? Z : F.get(Z));
                  break;
                case 1:
                  for (; ne.length <= w; )
                    for (Z = P[T++] << 8 | P[T++], te = P[T++], G = 0; G <= te; G++)
                      ne.push(j ? Z++ : F.get(Z++));
                  break;
                case 2:
                  for (; ne.length <= w; )
                    for (Z = P[T++] << 8 | P[T++], te = P[T++] << 8 | P[T++], G = 0; G <= te; G++)
                      ne.push(j ? Z++ : F.get(Z++));
                  break;
                default:
                  throw new s.FormatError("Unknown charset format");
              }
              const N = T, q = P.subarray(V, N);
              return new B(!1, J, ne, q);
            }
            parseEncoding(T, w, F, j) {
              const P = /* @__PURE__ */ Object.create(null), V = this.bytes;
              let J = !1, ne, Z, te, G = null;
              function N() {
                const q = V[T++];
                for (Z = 0; Z < q; Z++) {
                  const ie = V[T++], oe = (V[T++] << 8) + (V[T++] & 255);
                  P[ie] = j.indexOf(F.get(oe));
                }
              }
              if (T === 0 || T === 1) {
                J = !0, ne = T;
                const q = T ? g.ExpertEncoding : g.StandardEncoding;
                for (Z = 0, te = j.length; Z < te; Z++) {
                  const ie = q.indexOf(j[Z]);
                  ie !== -1 && (P[ie] = Z);
                }
              } else {
                const q = T;
                switch (ne = V[T++], ne & 127) {
                  case 0:
                    const oe = V[T++];
                    for (Z = 1; Z <= oe; Z++)
                      P[V[T++]] = Z;
                    break;
                  case 1:
                    const fe = V[T++];
                    let Y = 1;
                    for (Z = 0; Z < fe; Z++) {
                      const ae = V[T++], se = V[T++];
                      for (let L = ae; L <= ae + se; L++)
                        P[L] = Y++;
                    }
                    break;
                  default:
                    throw new s.FormatError(`Unknown encoding format: ${ne} in CFF`);
                }
                const ie = T;
                ne & 128 && (V[q] &= 127, N()), G = V.subarray(q, ie);
              }
              return ne &= 127, new R(J, ne, P, G);
            }
            parseFDSelect(T, w) {
              const F = this.bytes, j = F[T++], P = [];
              let V;
              switch (j) {
                case 0:
                  for (V = 0; V < w; ++V) {
                    const ne = F[T++];
                    P.push(ne);
                  }
                  break;
                case 3:
                  const J = F[T++] << 8 | F[T++];
                  for (V = 0; V < J; ++V) {
                    let ne = F[T++] << 8 | F[T++];
                    V === 0 && ne !== 0 && ((0, s.warn)("parseFDSelect: The first range must have a first GID of 0 -- trying to recover."), ne = 0);
                    const Z = F[T++], te = F[T] << 8 | F[T + 1];
                    for (let G = ne; G < te; ++G)
                      P.push(Z);
                  }
                  T += 2;
                  break;
                default:
                  throw new s.FormatError(`parseFDSelect: Unknown format "${j}".`);
              }
              if (P.length !== w)
                throw new s.FormatError("parseFDSelect: Invalid font data.");
              return new _(j, P);
            }
          }
          c.CFFParser = S;
          class y {
            constructor() {
              this.header = null, this.names = [], this.topDict = null, this.strings = new b(), this.globalSubrIndex = null, this.encoding = null, this.charset = null, this.charStrings = null, this.fdArray = [], this.fdSelect = null, this.isCIDFont = !1;
            }
            duplicateFirstGlyph() {
              if (this.charStrings.count >= 65535) {
                (0, s.warn)("Not enough space in charstrings to duplicate first glyph.");
                return;
              }
              const T = this.charStrings.get(0);
              this.charStrings.add(T), this.isCIDFont && this.fdSelect.fdSelect.push(this.fdSelect.fdSelect[0]);
            }
            hasGlyphId(T) {
              return T < 0 || T >= this.charStrings.count ? !1 : this.charStrings.get(T).length > 0;
            }
          }
          c.CFF = y;
          class x {
            constructor(T, w, F, j) {
              this.major = T, this.minor = w, this.hdrSize = F, this.offSize = j;
            }
          }
          c.CFFHeader = x;
          class b {
            constructor() {
              this.strings = [];
            }
            get(T) {
              return T >= 0 && T <= m - 1 ? i[T] : T - m <= this.strings.length ? this.strings[T - m] : i[0];
            }
            getSID(T) {
              let w = i.indexOf(T);
              return w !== -1 ? w : (w = this.strings.indexOf(T), w !== -1 ? w + m : -1);
            }
            add(T) {
              this.strings.push(T);
            }
            get count() {
              return this.strings.length;
            }
          }
          c.CFFStrings = b;
          class u {
            constructor() {
              this.objects = [], this.length = 0;
            }
            add(T) {
              this.length += T.length, this.objects.push(T);
            }
            set(T, w) {
              this.length += w.length - this.objects[T].length, this.objects[T] = w;
            }
            get(T) {
              return this.objects[T];
            }
            get count() {
              return this.objects.length;
            }
          }
          c.CFFIndex = u;
          class I {
            constructor(T, w) {
              this.keyToNameMap = T.keyToNameMap, this.nameToKeyMap = T.nameToKeyMap, this.defaults = T.defaults, this.types = T.types, this.opcodes = T.opcodes, this.order = T.order, this.strings = w, this.values = /* @__PURE__ */ Object.create(null);
            }
            setByKey(T, w) {
              if (!(T in this.keyToNameMap))
                return !1;
              if (w.length === 0)
                return !0;
              for (const j of w)
                if (isNaN(j))
                  return (0, s.warn)(`Invalid CFFDict value: "${w}" for key "${T}".`), !0;
              const F = this.types[T];
              return (F === "num" || F === "sid" || F === "offset") && (w = w[0]), this.values[T] = w, !0;
            }
            setByName(T, w) {
              if (!(T in this.nameToKeyMap))
                throw new s.FormatError(`Invalid dictionary name "${T}"`);
              this.values[this.nameToKeyMap[T]] = w;
            }
            hasName(T) {
              return this.nameToKeyMap[T] in this.values;
            }
            getByName(T) {
              if (!(T in this.nameToKeyMap))
                throw new s.FormatError(`Invalid dictionary name ${T}"`);
              const w = this.nameToKeyMap[T];
              return w in this.values ? this.values[w] : this.defaults[w];
            }
            removeByName(T) {
              delete this.values[this.nameToKeyMap[T]];
            }
            static createTables(T) {
              const w = {
                keyToNameMap: {},
                nameToKeyMap: {},
                defaults: {},
                types: {},
                opcodes: {},
                order: []
              };
              for (const F of T) {
                const j = Array.isArray(F[0]) ? (F[0][0] << 8) + F[0][1] : F[0];
                w.keyToNameMap[j] = F[1], w.nameToKeyMap[F[1]] = j, w.types[j] = F[2], w.defaults[j] = F[3], w.opcodes[j] = Array.isArray(F[0]) ? F[0] : [F[0]], w.order.push(j);
              }
              return w;
            }
          }
          const O = [[[12, 30], "ROS", ["sid", "sid", "num"], null], [[12, 20], "SyntheticBase", "num", null], [0, "version", "sid", null], [1, "Notice", "sid", null], [[12, 0], "Copyright", "sid", null], [2, "FullName", "sid", null], [3, "FamilyName", "sid", null], [4, "Weight", "sid", null], [[12, 1], "isFixedPitch", "num", 0], [[12, 2], "ItalicAngle", "num", 0], [[12, 3], "UnderlinePosition", "num", -100], [[12, 4], "UnderlineThickness", "num", 50], [[12, 5], "PaintType", "num", 0], [[12, 6], "CharstringType", "num", 2], [[12, 7], "FontMatrix", ["num", "num", "num", "num", "num", "num"], [1e-3, 0, 0, 1e-3, 0, 0]], [13, "UniqueID", "num", null], [5, "FontBBox", ["num", "num", "num", "num"], [0, 0, 0, 0]], [[12, 8], "StrokeWidth", "num", 0], [14, "XUID", "array", null], [15, "charset", "offset", 0], [16, "Encoding", "offset", 0], [17, "CharStrings", "offset", 0], [18, "Private", ["offset", "offset"], null], [[12, 21], "PostScript", "sid", null], [[12, 22], "BaseFontName", "sid", null], [[12, 23], "BaseFontBlend", "delta", null], [[12, 31], "CIDFontVersion", "num", 0], [[12, 32], "CIDFontRevision", "num", 0], [[12, 33], "CIDFontType", "num", 0], [[12, 34], "CIDCount", "num", 8720], [[12, 35], "UIDBase", "num", null], [[12, 37], "FDSelect", "offset", null], [[12, 36], "FDArray", "offset", null], [[12, 38], "FontName", "sid", null]];
          class D extends I {
            static get tables() {
              return (0, s.shadow)(this, "tables", this.createTables(O));
            }
            constructor(T) {
              super(D.tables, T), this.privateDict = null;
            }
          }
          c.CFFTopDict = D;
          const $ = [[6, "BlueValues", "delta", null], [7, "OtherBlues", "delta", null], [8, "FamilyBlues", "delta", null], [9, "FamilyOtherBlues", "delta", null], [[12, 9], "BlueScale", "num", 0.039625], [[12, 10], "BlueShift", "num", 7], [[12, 11], "BlueFuzz", "num", 1], [10, "StdHW", "num", null], [11, "StdVW", "num", null], [[12, 12], "StemSnapH", "delta", null], [[12, 13], "StemSnapV", "delta", null], [[12, 14], "ForceBold", "num", 0], [[12, 17], "LanguageGroup", "num", 0], [[12, 18], "ExpansionFactor", "num", 0.06], [[12, 19], "initialRandomSeed", "num", 0], [20, "defaultWidthX", "num", 0], [21, "nominalWidthX", "num", 0], [19, "Subrs", "offset", null]];
          class K extends I {
            static get tables() {
              return (0, s.shadow)(this, "tables", this.createTables($));
            }
            constructor(T) {
              super(K.tables, T), this.subrsIndex = null;
            }
          }
          c.CFFPrivateDict = K;
          const H = {
            ISO_ADOBE: 0,
            EXPERT: 1,
            EXPERT_SUBSET: 2
          };
          class B {
            constructor(T, w, F, j) {
              this.predefined = T, this.format = w, this.charset = F, this.raw = j;
            }
          }
          c.CFFCharset = B;
          class R {
            constructor(T, w, F, j) {
              this.predefined = T, this.format = w, this.encoding = F, this.raw = j;
            }
          }
          class _ {
            constructor(T, w) {
              this.format = T, this.fdSelect = w;
            }
            getFDIndex(T) {
              return T < 0 || T >= this.fdSelect.length ? -1 : this.fdSelect[T];
            }
          }
          c.CFFFDSelect = _;
          class A {
            constructor() {
              this.offsets = /* @__PURE__ */ Object.create(null);
            }
            isTracking(T) {
              return T in this.offsets;
            }
            track(T, w) {
              if (T in this.offsets)
                throw new s.FormatError(`Already tracking location of ${T}`);
              this.offsets[T] = w;
            }
            offset(T) {
              for (const w in this.offsets)
                this.offsets[w] += T;
            }
            setEntryLocation(T, w, F) {
              if (!(T in this.offsets))
                throw new s.FormatError(`Not tracking location of ${T}`);
              const j = F.data, P = this.offsets[T], V = 5;
              for (let J = 0, ne = w.length; J < ne; ++J) {
                const Z = J * V + P, te = Z + 1, G = Z + 2, N = Z + 3, q = Z + 4;
                if (j[Z] !== 29 || j[te] !== 0 || j[G] !== 0 || j[N] !== 0 || j[q] !== 0)
                  throw new s.FormatError("writing to an offset that is not empty");
                const ie = w[J];
                j[Z] = 29, j[te] = ie >> 24 & 255, j[G] = ie >> 16 & 255, j[N] = ie >> 8 & 255, j[q] = ie & 255;
              }
            }
          }
          class k {
            constructor(T) {
              this.cff = T;
            }
            compile() {
              const T = this.cff, w = {
                data: [],
                length: 0,
                add(N) {
                  try {
                    this.data.push(...N);
                  } catch {
                    this.data = this.data.concat(N);
                  }
                  this.length = this.data.length;
                }
              }, F = this.compileHeader(T.header);
              w.add(F);
              const j = this.compileNameIndex(T.names);
              if (w.add(j), T.isCIDFont && T.topDict.hasName("FontMatrix")) {
                const N = T.topDict.getByName("FontMatrix");
                T.topDict.removeByName("FontMatrix");
                for (const q of T.fdArray) {
                  let ie = N.slice(0);
                  q.hasName("FontMatrix") && (ie = s.Util.transform(ie, q.getByName("FontMatrix"))), q.setByName("FontMatrix", ie);
                }
              }
              const P = T.topDict.getByName("XUID");
              (P == null ? void 0 : P.length) > 16 && T.topDict.removeByName("XUID"), T.topDict.setByName("charset", 0);
              let V = this.compileTopDicts([T.topDict], w.length, T.isCIDFont);
              w.add(V.output);
              const J = V.trackers[0], ne = this.compileStringIndex(T.strings.strings);
              w.add(ne);
              const Z = this.compileIndex(T.globalSubrIndex);
              if (w.add(Z), T.encoding && T.topDict.hasName("Encoding"))
                if (T.encoding.predefined)
                  J.setEntryLocation("Encoding", [T.encoding.format], w);
                else {
                  const N = this.compileEncoding(T.encoding);
                  J.setEntryLocation("Encoding", [w.length], w), w.add(N);
                }
              const te = this.compileCharset(T.charset, T.charStrings.count, T.strings, T.isCIDFont);
              J.setEntryLocation("charset", [w.length], w), w.add(te);
              const G = this.compileCharStrings(T.charStrings);
              if (J.setEntryLocation("CharStrings", [w.length], w), w.add(G), T.isCIDFont) {
                J.setEntryLocation("FDSelect", [w.length], w);
                const N = this.compileFDSelect(T.fdSelect);
                w.add(N), V = this.compileTopDicts(T.fdArray, w.length, !0), J.setEntryLocation("FDArray", [w.length], w), w.add(V.output);
                const q = V.trackers;
                this.compilePrivateDicts(T.fdArray, q, w);
              }
              return this.compilePrivateDicts([T.topDict], [J], w), w.add([0]), w.data;
            }
            encodeNumber(T) {
              return Number.isInteger(T) ? this.encodeInteger(T) : this.encodeFloat(T);
            }
            static get EncodeFloatRegExp() {
              return (0, s.shadow)(this, "EncodeFloatRegExp", /\.(\d*?)(?:9{5,20}|0{5,20})\d{0,2}(?:e(.+)|$)/);
            }
            encodeFloat(T) {
              let w = T.toString();
              const F = k.EncodeFloatRegExp.exec(w);
              if (F) {
                const ne = parseFloat("1e" + ((F[2] ? +F[2] : 0) + F[1].length));
                w = (Math.round(T * ne) / ne).toString();
              }
              let j = "", P, V;
              for (P = 0, V = w.length; P < V; ++P) {
                const ne = w[P];
                ne === "e" ? j += w[++P] === "-" ? "c" : "b" : ne === "." ? j += "a" : ne === "-" ? j += "e" : j += ne;
              }
              j += j.length & 1 ? "f" : "ff";
              const J = [30];
              for (P = 0, V = j.length; P < V; P += 2)
                J.push(parseInt(j.substring(P, P + 2), 16));
              return J;
            }
            encodeInteger(T) {
              let w;
              return T >= -107 && T <= 107 ? w = [T + 139] : T >= 108 && T <= 1131 ? (T -= 108, w = [(T >> 8) + 247, T & 255]) : T >= -1131 && T <= -108 ? (T = -T - 108, w = [(T >> 8) + 251, T & 255]) : T >= -32768 && T <= 32767 ? w = [28, T >> 8 & 255, T & 255] : w = [29, T >> 24 & 255, T >> 16 & 255, T >> 8 & 255, T & 255], w;
            }
            compileHeader(T) {
              return [T.major, T.minor, 4, T.offSize];
            }
            compileNameIndex(T) {
              const w = new u();
              for (const F of T) {
                const j = Math.min(F.length, 127);
                let P = new Array(j);
                for (let V = 0; V < j; V++) {
                  let J = F[V];
                  (J < "!" || J > "~" || J === "[" || J === "]" || J === "(" || J === ")" || J === "{" || J === "}" || J === "<" || J === ">" || J === "/" || J === "%") && (J = "_"), P[V] = J;
                }
                P = P.join(""), P === "" && (P = "Bad_Font_Name"), w.add((0, s.stringToBytes)(P));
              }
              return this.compileIndex(w);
            }
            compileTopDicts(T, w, F) {
              const j = [];
              let P = new u();
              for (const V of T) {
                F && (V.removeByName("CIDFontVersion"), V.removeByName("CIDFontRevision"), V.removeByName("CIDFontType"), V.removeByName("CIDCount"), V.removeByName("UIDBase"));
                const J = new A(), ne = this.compileDict(V, J);
                j.push(J), P.add(ne), J.offset(w);
              }
              return P = this.compileIndex(P, j), {
                trackers: j,
                output: P
              };
            }
            compilePrivateDicts(T, w, F) {
              for (let j = 0, P = T.length; j < P; ++j) {
                const V = T[j], J = V.privateDict;
                if (!J || !V.hasName("Private"))
                  throw new s.FormatError("There must be a private dictionary.");
                const ne = new A(), Z = this.compileDict(J, ne);
                let te = F.length;
                if (ne.offset(te), Z.length || (te = 0), w[j].setEntryLocation("Private", [Z.length, te], F), F.add(Z), J.subrsIndex && J.hasName("Subrs")) {
                  const G = this.compileIndex(J.subrsIndex);
                  ne.setEntryLocation("Subrs", [Z.length], F), F.add(G);
                }
              }
            }
            compileDict(T, w) {
              const F = [];
              for (const j of T.order) {
                if (!(j in T.values))
                  continue;
                let P = T.values[j], V = T.types[j];
                if (Array.isArray(V) || (V = [V]), Array.isArray(P) || (P = [P]), P.length !== 0) {
                  for (let J = 0, ne = V.length; J < ne; ++J) {
                    const Z = V[J], te = P[J];
                    switch (Z) {
                      case "num":
                      case "sid":
                        F.push(...this.encodeNumber(te));
                        break;
                      case "offset":
                        const G = T.keyToNameMap[j];
                        w.isTracking(G) || w.track(G, F.length), F.push(29, 0, 0, 0, 0);
                        break;
                      case "array":
                      case "delta":
                        F.push(...this.encodeNumber(te));
                        for (let N = 1, q = P.length; N < q; ++N)
                          F.push(...this.encodeNumber(P[N]));
                        break;
                      default:
                        throw new s.FormatError(`Unknown data type of ${Z}`);
                    }
                  }
                  F.push(...T.opcodes[j]);
                }
              }
              return F;
            }
            compileStringIndex(T) {
              const w = new u();
              for (const F of T)
                w.add((0, s.stringToBytes)(F));
              return this.compileIndex(w);
            }
            compileCharStrings(T) {
              const w = new u();
              for (let F = 0; F < T.count; F++) {
                const j = T.get(F);
                if (j.length === 0) {
                  w.add(new Uint8Array([139, 14]));
                  continue;
                }
                w.add(j);
              }
              return this.compileIndex(w);
            }
            compileCharset(T, w, F, j) {
              let P;
              const V = w - 1;
              if (j)
                P = new Uint8Array([2, 0, 0, V >> 8 & 255, V & 255]);
              else {
                const J = 1 + V * 2;
                P = new Uint8Array(J), P[0] = 0;
                let ne = 0;
                const Z = T.charset.length;
                let te = !1;
                for (let G = 1; G < P.length; G += 2) {
                  let N = 0;
                  if (ne < Z) {
                    const q = T.charset[ne++];
                    N = F.getSID(q), N === -1 && (N = 0, te || (te = !0, (0, s.warn)(`Couldn't find ${q} in CFF strings`)));
                  }
                  P[G] = N >> 8 & 255, P[G + 1] = N & 255;
                }
              }
              return this.compileTypedArray(P);
            }
            compileEncoding(T) {
              return this.compileTypedArray(T.raw);
            }
            compileFDSelect(T) {
              const w = T.format;
              let F, j;
              switch (w) {
                case 0:
                  for (F = new Uint8Array(1 + T.fdSelect.length), F[0] = w, j = 0; j < T.fdSelect.length; j++)
                    F[j + 1] = T.fdSelect[j];
                  break;
                case 3:
                  const P = 0;
                  let V = T.fdSelect[0];
                  const J = [w, 0, 0, P >> 8 & 255, P & 255, V];
                  for (j = 1; j < T.fdSelect.length; j++) {
                    const Z = T.fdSelect[j];
                    Z !== V && (J.push(j >> 8 & 255, j & 255, Z), V = Z);
                  }
                  const ne = (J.length - 3) / 3;
                  J[1] = ne >> 8 & 255, J[2] = ne & 255, J.push(j >> 8 & 255, j & 255), F = new Uint8Array(J);
                  break;
              }
              return this.compileTypedArray(F);
            }
            compileTypedArray(T) {
              return Array.from(T);
            }
            compileIndex(T, w = []) {
              const F = T.objects, j = F.length;
              if (j === 0)
                return [0, 0];
              const P = [j >> 8 & 255, j & 255];
              let V = 1, J;
              for (J = 0; J < j; ++J)
                V += F[J].length;
              let ne;
              V < 256 ? ne = 1 : V < 65536 ? ne = 2 : V < 16777216 ? ne = 3 : ne = 4, P.push(ne);
              let Z = 1;
              for (J = 0; J < j + 1; J++)
                ne === 1 ? P.push(Z & 255) : ne === 2 ? P.push(Z >> 8 & 255, Z & 255) : ne === 3 ? P.push(Z >> 16 & 255, Z >> 8 & 255, Z & 255) : P.push(Z >>> 24 & 255, Z >> 16 & 255, Z >> 8 & 255, Z & 255), F[J] && (Z += F[J].length);
              for (J = 0; J < j; J++)
                w[J] && w[J].offset(P.length), P.push(...F[J]);
              return P;
            }
          }
          c.CFFCompiler = k;
        },
        /* 36 */
        /***/
        (d, c) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.ISOAdobeCharset = c.ExpertSubsetCharset = c.ExpertCharset = void 0;
          const f = [".notdef", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quoteright", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "quoteleft", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "exclamdown", "cent", "sterling", "fraction", "yen", "florin", "section", "currency", "quotesingle", "quotedblleft", "guillemotleft", "guilsinglleft", "guilsinglright", "fi", "fl", "endash", "dagger", "daggerdbl", "periodcentered", "paragraph", "bullet", "quotesinglbase", "quotedblbase", "quotedblright", "guillemotright", "ellipsis", "perthousand", "questiondown", "grave", "acute", "circumflex", "tilde", "macron", "breve", "dotaccent", "dieresis", "ring", "cedilla", "hungarumlaut", "ogonek", "caron", "emdash", "AE", "ordfeminine", "Lslash", "Oslash", "OE", "ordmasculine", "ae", "dotlessi", "lslash", "oslash", "oe", "germandbls", "onesuperior", "logicalnot", "mu", "trademark", "Eth", "onehalf", "plusminus", "Thorn", "onequarter", "divide", "brokenbar", "degree", "thorn", "threequarters", "twosuperior", "registered", "minus", "eth", "multiply", "threesuperior", "copyright", "Aacute", "Acircumflex", "Adieresis", "Agrave", "Aring", "Atilde", "Ccedilla", "Eacute", "Ecircumflex", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Ntilde", "Oacute", "Ocircumflex", "Odieresis", "Ograve", "Otilde", "Scaron", "Uacute", "Ucircumflex", "Udieresis", "Ugrave", "Yacute", "Ydieresis", "Zcaron", "aacute", "acircumflex", "adieresis", "agrave", "aring", "atilde", "ccedilla", "eacute", "ecircumflex", "edieresis", "egrave", "iacute", "icircumflex", "idieresis", "igrave", "ntilde", "oacute", "ocircumflex", "odieresis", "ograve", "otilde", "scaron", "uacute", "ucircumflex", "udieresis", "ugrave", "yacute", "ydieresis", "zcaron"];
          c.ISOAdobeCharset = f;
          const s = [".notdef", "space", "exclamsmall", "Hungarumlautsmall", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "commasuperior", "threequartersemdash", "periodsuperior", "questionsmall", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "isuperior", "lsuperior", "msuperior", "nsuperior", "osuperior", "rsuperior", "ssuperior", "tsuperior", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "parenrightinferior", "Circumflexsmall", "hyphensuperior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "exclamdownsmall", "centoldstyle", "Lslashsmall", "Scaronsmall", "Zcaronsmall", "Dieresissmall", "Brevesmall", "Caronsmall", "Dotaccentsmall", "Macronsmall", "figuredash", "hypheninferior", "Ogoneksmall", "Ringsmall", "Cedillasmall", "onequarter", "onehalf", "threequarters", "questiondownsmall", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "zerosuperior", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior", "Agravesmall", "Aacutesmall", "Acircumflexsmall", "Atildesmall", "Adieresissmall", "Aringsmall", "AEsmall", "Ccedillasmall", "Egravesmall", "Eacutesmall", "Ecircumflexsmall", "Edieresissmall", "Igravesmall", "Iacutesmall", "Icircumflexsmall", "Idieresissmall", "Ethsmall", "Ntildesmall", "Ogravesmall", "Oacutesmall", "Ocircumflexsmall", "Otildesmall", "Odieresissmall", "OEsmall", "Oslashsmall", "Ugravesmall", "Uacutesmall", "Ucircumflexsmall", "Udieresissmall", "Yacutesmall", "Thornsmall", "Ydieresissmall"];
          c.ExpertCharset = s;
          const h = [".notdef", "space", "dollaroldstyle", "dollarsuperior", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "commasuperior", "threequartersemdash", "periodsuperior", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "isuperior", "lsuperior", "msuperior", "nsuperior", "osuperior", "rsuperior", "ssuperior", "tsuperior", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "parenrightinferior", "hyphensuperior", "colonmonetary", "onefitted", "rupiah", "centoldstyle", "figuredash", "hypheninferior", "onequarter", "onehalf", "threequarters", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "zerosuperior", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior"];
          c.ExpertSubsetCharset = h;
        },
        /* 37 */
        /***/
        (d, c) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.ZapfDingbatsEncoding = c.WinAnsiEncoding = c.SymbolSetEncoding = c.StandardEncoding = c.MacRomanEncoding = c.ExpertEncoding = void 0, c.getEncoding = v;
          const f = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclamsmall", "Hungarumlautsmall", "", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "commasuperior", "threequartersemdash", "periodsuperior", "questionsmall", "", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "", "", "", "isuperior", "", "", "lsuperior", "msuperior", "nsuperior", "osuperior", "", "", "rsuperior", "ssuperior", "tsuperior", "", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "", "parenrightinferior", "Circumflexsmall", "hyphensuperior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "exclamdownsmall", "centoldstyle", "Lslashsmall", "", "", "Scaronsmall", "Zcaronsmall", "Dieresissmall", "Brevesmall", "Caronsmall", "", "Dotaccentsmall", "", "", "Macronsmall", "", "", "figuredash", "hypheninferior", "", "", "Ogoneksmall", "Ringsmall", "Cedillasmall", "", "", "", "onequarter", "onehalf", "threequarters", "questiondownsmall", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "", "", "zerosuperior", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior", "Agravesmall", "Aacutesmall", "Acircumflexsmall", "Atildesmall", "Adieresissmall", "Aringsmall", "AEsmall", "Ccedillasmall", "Egravesmall", "Eacutesmall", "Ecircumflexsmall", "Edieresissmall", "Igravesmall", "Iacutesmall", "Icircumflexsmall", "Idieresissmall", "Ethsmall", "Ntildesmall", "Ogravesmall", "Oacutesmall", "Ocircumflexsmall", "Otildesmall", "Odieresissmall", "OEsmall", "Oslashsmall", "Ugravesmall", "Uacutesmall", "Ucircumflexsmall", "Udieresissmall", "Yacutesmall", "Thornsmall", "Ydieresissmall"];
          c.ExpertEncoding = f;
          const s = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclamsmall", "Hungarumlautsmall", "centoldstyle", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "", "threequartersemdash", "", "questionsmall", "", "", "", "", "Ethsmall", "", "", "onequarter", "onehalf", "threequarters", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "", "", "", "", "", "", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "", "parenrightinferior", "Circumflexsmall", "hypheninferior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "", "", "asuperior", "centsuperior", "", "", "", "", "Aacutesmall", "Agravesmall", "Acircumflexsmall", "Adieresissmall", "Atildesmall", "Aringsmall", "Ccedillasmall", "Eacutesmall", "Egravesmall", "Ecircumflexsmall", "Edieresissmall", "Iacutesmall", "Igravesmall", "Icircumflexsmall", "Idieresissmall", "Ntildesmall", "Oacutesmall", "Ogravesmall", "Ocircumflexsmall", "Odieresissmall", "Otildesmall", "Uacutesmall", "Ugravesmall", "Ucircumflexsmall", "Udieresissmall", "", "eightsuperior", "fourinferior", "threeinferior", "sixinferior", "eightinferior", "seveninferior", "Scaronsmall", "", "centinferior", "twoinferior", "", "Dieresissmall", "", "Caronsmall", "osuperior", "fiveinferior", "", "commainferior", "periodinferior", "Yacutesmall", "", "dollarinferior", "", "", "Thornsmall", "", "nineinferior", "zeroinferior", "Zcaronsmall", "AEsmall", "Oslashsmall", "questiondownsmall", "oneinferior", "Lslashsmall", "", "", "", "", "", "", "Cedillasmall", "", "", "", "", "", "OEsmall", "figuredash", "hyphensuperior", "", "", "", "", "exclamdownsmall", "", "Ydieresissmall", "", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "ninesuperior", "zerosuperior", "", "esuperior", "rsuperior", "tsuperior", "", "", "isuperior", "ssuperior", "dsuperior", "", "", "", "", "", "lsuperior", "Ogoneksmall", "Brevesmall", "Macronsmall", "bsuperior", "nsuperior", "msuperior", "commasuperior", "periodsuperior", "Dotaccentsmall", "Ringsmall", "", "", "", ""], h = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quotesingle", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "grave", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "", "Adieresis", "Aring", "Ccedilla", "Eacute", "Ntilde", "Odieresis", "Udieresis", "aacute", "agrave", "acircumflex", "adieresis", "atilde", "aring", "ccedilla", "eacute", "egrave", "ecircumflex", "edieresis", "iacute", "igrave", "icircumflex", "idieresis", "ntilde", "oacute", "ograve", "ocircumflex", "odieresis", "otilde", "uacute", "ugrave", "ucircumflex", "udieresis", "dagger", "degree", "cent", "sterling", "section", "bullet", "paragraph", "germandbls", "registered", "copyright", "trademark", "acute", "dieresis", "notequal", "AE", "Oslash", "infinity", "plusminus", "lessequal", "greaterequal", "yen", "mu", "partialdiff", "summation", "product", "pi", "integral", "ordfeminine", "ordmasculine", "Omega", "ae", "oslash", "questiondown", "exclamdown", "logicalnot", "radical", "florin", "approxequal", "Delta", "guillemotleft", "guillemotright", "ellipsis", "space", "Agrave", "Atilde", "Otilde", "OE", "oe", "endash", "emdash", "quotedblleft", "quotedblright", "quoteleft", "quoteright", "divide", "lozenge", "ydieresis", "Ydieresis", "fraction", "currency", "guilsinglleft", "guilsinglright", "fi", "fl", "daggerdbl", "periodcentered", "quotesinglbase", "quotedblbase", "perthousand", "Acircumflex", "Ecircumflex", "Aacute", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Oacute", "Ocircumflex", "apple", "Ograve", "Uacute", "Ucircumflex", "Ugrave", "dotlessi", "circumflex", "tilde", "macron", "breve", "dotaccent", "ring", "cedilla", "hungarumlaut", "ogonek", "caron"];
          c.MacRomanEncoding = h;
          const g = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quoteright", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "quoteleft", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "exclamdown", "cent", "sterling", "fraction", "yen", "florin", "section", "currency", "quotesingle", "quotedblleft", "guillemotleft", "guilsinglleft", "guilsinglright", "fi", "fl", "", "endash", "dagger", "daggerdbl", "periodcentered", "", "paragraph", "bullet", "quotesinglbase", "quotedblbase", "quotedblright", "guillemotright", "ellipsis", "perthousand", "", "questiondown", "", "grave", "acute", "circumflex", "tilde", "macron", "breve", "dotaccent", "dieresis", "", "ring", "cedilla", "", "hungarumlaut", "ogonek", "caron", "emdash", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "AE", "", "ordfeminine", "", "", "", "", "Lslash", "Oslash", "OE", "ordmasculine", "", "", "", "", "", "ae", "", "", "", "dotlessi", "", "", "lslash", "oslash", "oe", "germandbls", "", "", "", ""];
          c.StandardEncoding = g;
          const t = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quotesingle", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "grave", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "bullet", "Euro", "bullet", "quotesinglbase", "florin", "quotedblbase", "ellipsis", "dagger", "daggerdbl", "circumflex", "perthousand", "Scaron", "guilsinglleft", "OE", "bullet", "Zcaron", "bullet", "bullet", "quoteleft", "quoteright", "quotedblleft", "quotedblright", "bullet", "endash", "emdash", "tilde", "trademark", "scaron", "guilsinglright", "oe", "bullet", "zcaron", "Ydieresis", "space", "exclamdown", "cent", "sterling", "currency", "yen", "brokenbar", "section", "dieresis", "copyright", "ordfeminine", "guillemotleft", "logicalnot", "hyphen", "registered", "macron", "degree", "plusminus", "twosuperior", "threesuperior", "acute", "mu", "paragraph", "periodcentered", "cedilla", "onesuperior", "ordmasculine", "guillemotright", "onequarter", "onehalf", "threequarters", "questiondown", "Agrave", "Aacute", "Acircumflex", "Atilde", "Adieresis", "Aring", "AE", "Ccedilla", "Egrave", "Eacute", "Ecircumflex", "Edieresis", "Igrave", "Iacute", "Icircumflex", "Idieresis", "Eth", "Ntilde", "Ograve", "Oacute", "Ocircumflex", "Otilde", "Odieresis", "multiply", "Oslash", "Ugrave", "Uacute", "Ucircumflex", "Udieresis", "Yacute", "Thorn", "germandbls", "agrave", "aacute", "acircumflex", "atilde", "adieresis", "aring", "ae", "ccedilla", "egrave", "eacute", "ecircumflex", "edieresis", "igrave", "iacute", "icircumflex", "idieresis", "eth", "ntilde", "ograve", "oacute", "ocircumflex", "otilde", "odieresis", "divide", "oslash", "ugrave", "uacute", "ucircumflex", "udieresis", "yacute", "thorn", "ydieresis"];
          c.WinAnsiEncoding = t;
          const i = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "universal", "numbersign", "existential", "percent", "ampersand", "suchthat", "parenleft", "parenright", "asteriskmath", "plus", "comma", "minus", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "congruent", "Alpha", "Beta", "Chi", "Delta", "Epsilon", "Phi", "Gamma", "Eta", "Iota", "theta1", "Kappa", "Lambda", "Mu", "Nu", "Omicron", "Pi", "Theta", "Rho", "Sigma", "Tau", "Upsilon", "sigma1", "Omega", "Xi", "Psi", "Zeta", "bracketleft", "therefore", "bracketright", "perpendicular", "underscore", "radicalex", "alpha", "beta", "chi", "delta", "epsilon", "phi", "gamma", "eta", "iota", "phi1", "kappa", "lambda", "mu", "nu", "omicron", "pi", "theta", "rho", "sigma", "tau", "upsilon", "omega1", "omega", "xi", "psi", "zeta", "braceleft", "bar", "braceright", "similar", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "Euro", "Upsilon1", "minute", "lessequal", "fraction", "infinity", "florin", "club", "diamond", "heart", "spade", "arrowboth", "arrowleft", "arrowup", "arrowright", "arrowdown", "degree", "plusminus", "second", "greaterequal", "multiply", "proportional", "partialdiff", "bullet", "divide", "notequal", "equivalence", "approxequal", "ellipsis", "arrowvertex", "arrowhorizex", "carriagereturn", "aleph", "Ifraktur", "Rfraktur", "weierstrass", "circlemultiply", "circleplus", "emptyset", "intersection", "union", "propersuperset", "reflexsuperset", "notsubset", "propersubset", "reflexsubset", "element", "notelement", "angle", "gradient", "registerserif", "copyrightserif", "trademarkserif", "product", "radical", "dotmath", "logicalnot", "logicaland", "logicalor", "arrowdblboth", "arrowdblleft", "arrowdblup", "arrowdblright", "arrowdbldown", "lozenge", "angleleft", "registersans", "copyrightsans", "trademarksans", "summation", "parenlefttp", "parenleftex", "parenleftbt", "bracketlefttp", "bracketleftex", "bracketleftbt", "bracelefttp", "braceleftmid", "braceleftbt", "braceex", "", "angleright", "integral", "integraltp", "integralex", "integralbt", "parenrighttp", "parenrightex", "parenrightbt", "bracketrighttp", "bracketrightex", "bracketrightbt", "bracerighttp", "bracerightmid", "bracerightbt", ""];
          c.SymbolSetEncoding = i;
          const m = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "a1", "a2", "a202", "a3", "a4", "a5", "a119", "a118", "a117", "a11", "a12", "a13", "a14", "a15", "a16", "a105", "a17", "a18", "a19", "a20", "a21", "a22", "a23", "a24", "a25", "a26", "a27", "a28", "a6", "a7", "a8", "a9", "a10", "a29", "a30", "a31", "a32", "a33", "a34", "a35", "a36", "a37", "a38", "a39", "a40", "a41", "a42", "a43", "a44", "a45", "a46", "a47", "a48", "a49", "a50", "a51", "a52", "a53", "a54", "a55", "a56", "a57", "a58", "a59", "a60", "a61", "a62", "a63", "a64", "a65", "a66", "a67", "a68", "a69", "a70", "a71", "a72", "a73", "a74", "a203", "a75", "a204", "a76", "a77", "a78", "a79", "a81", "a82", "a83", "a84", "a97", "a98", "a99", "a100", "", "a89", "a90", "a93", "a94", "a91", "a92", "a205", "a85", "a206", "a86", "a87", "a88", "a95", "a96", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "a101", "a102", "a103", "a104", "a106", "a107", "a108", "a112", "a111", "a110", "a109", "a120", "a121", "a122", "a123", "a124", "a125", "a126", "a127", "a128", "a129", "a130", "a131", "a132", "a133", "a134", "a135", "a136", "a137", "a138", "a139", "a140", "a141", "a142", "a143", "a144", "a145", "a146", "a147", "a148", "a149", "a150", "a151", "a152", "a153", "a154", "a155", "a156", "a157", "a158", "a159", "a160", "a161", "a163", "a164", "a196", "a165", "a192", "a166", "a167", "a168", "a169", "a170", "a171", "a172", "a173", "a162", "a174", "a175", "a176", "a177", "a178", "a179", "a193", "a180", "a199", "a181", "a200", "a182", "", "a201", "a183", "a184", "a197", "a185", "a194", "a198", "a186", "a195", "a187", "a188", "a189", "a190", "a191", ""];
          c.ZapfDingbatsEncoding = m;
          function v(E) {
            switch (E) {
              case "WinAnsiEncoding":
                return t;
              case "StandardEncoding":
                return g;
              case "MacRomanEncoding":
                return h;
              case "SymbolSetEncoding":
                return i;
              case "ZapfDingbatsEncoding":
                return m;
              case "ExpertEncoding":
                return f;
              case "MacExpertEncoding":
                return s;
              default:
                return null;
            }
          }
        },
        /* 38 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.SEAC_ANALYSIS_ENABLED = c.MacStandardGlyphOrdering = c.FontFlags = void 0, c.normalizeFontName = y, c.recoverGlyphName = E, c.type1FontGlyphMapping = S;
          var s = f(37), h = f(39), g = f(40), t = f(2);
          const i = !0;
          c.SEAC_ANALYSIS_ENABLED = i;
          const m = {
            FixedPitch: 1,
            Serif: 2,
            Symbolic: 4,
            Script: 8,
            Nonsymbolic: 32,
            Italic: 64,
            AllCap: 65536,
            SmallCap: 131072,
            ForceBold: 262144
          };
          c.FontFlags = m;
          const v = [".notdef", ".null", "nonmarkingreturn", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quotesingle", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "grave", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "Adieresis", "Aring", "Ccedilla", "Eacute", "Ntilde", "Odieresis", "Udieresis", "aacute", "agrave", "acircumflex", "adieresis", "atilde", "aring", "ccedilla", "eacute", "egrave", "ecircumflex", "edieresis", "iacute", "igrave", "icircumflex", "idieresis", "ntilde", "oacute", "ograve", "ocircumflex", "odieresis", "otilde", "uacute", "ugrave", "ucircumflex", "udieresis", "dagger", "degree", "cent", "sterling", "section", "bullet", "paragraph", "germandbls", "registered", "copyright", "trademark", "acute", "dieresis", "notequal", "AE", "Oslash", "infinity", "plusminus", "lessequal", "greaterequal", "yen", "mu", "partialdiff", "summation", "product", "pi", "integral", "ordfeminine", "ordmasculine", "Omega", "ae", "oslash", "questiondown", "exclamdown", "logicalnot", "radical", "florin", "approxequal", "Delta", "guillemotleft", "guillemotright", "ellipsis", "nonbreakingspace", "Agrave", "Atilde", "Otilde", "OE", "oe", "endash", "emdash", "quotedblleft", "quotedblright", "quoteleft", "quoteright", "divide", "lozenge", "ydieresis", "Ydieresis", "fraction", "currency", "guilsinglleft", "guilsinglright", "fi", "fl", "daggerdbl", "periodcentered", "quotesinglbase", "quotedblbase", "perthousand", "Acircumflex", "Ecircumflex", "Aacute", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Oacute", "Ocircumflex", "apple", "Ograve", "Uacute", "Ucircumflex", "Ugrave", "dotlessi", "circumflex", "tilde", "macron", "breve", "dotaccent", "ring", "cedilla", "hungarumlaut", "ogonek", "caron", "Lslash", "lslash", "Scaron", "scaron", "Zcaron", "zcaron", "brokenbar", "Eth", "eth", "Yacute", "yacute", "Thorn", "thorn", "minus", "multiply", "onesuperior", "twosuperior", "threesuperior", "onehalf", "onequarter", "threequarters", "franc", "Gbreve", "gbreve", "Idotaccent", "Scedilla", "scedilla", "Cacute", "cacute", "Ccaron", "ccaron", "dcroat"];
          c.MacStandardGlyphOrdering = v;
          function E(x, b) {
            if (b[x] !== void 0)
              return x;
            const u = (0, g.getUnicodeForGlyph)(x, b);
            if (u !== -1) {
              for (const I in b)
                if (b[I] === u)
                  return I;
            }
            return (0, t.info)("Unable to recover a standard glyph name for: " + x), x;
          }
          function S(x, b, u) {
            const I = /* @__PURE__ */ Object.create(null);
            let O, D, $;
            const K = !!(x.flags & m.Symbolic);
            if (x.isInternalFont)
              for ($ = b, D = 0; D < $.length; D++)
                O = u.indexOf($[D]), I[D] = O >= 0 ? O : 0;
            else if (x.baseEncodingName)
              for ($ = (0, s.getEncoding)(x.baseEncodingName), D = 0; D < $.length; D++)
                O = u.indexOf($[D]), I[D] = O >= 0 ? O : 0;
            else if (K)
              for (D in b)
                I[D] = b[D];
            else
              for ($ = s.StandardEncoding, D = 0; D < $.length; D++)
                O = u.indexOf($[D]), I[D] = O >= 0 ? O : 0;
            const H = x.differences;
            let B;
            if (H)
              for (D in H) {
                const R = H[D];
                if (O = u.indexOf(R), O === -1) {
                  B || (B = (0, h.getGlyphsUnicode)());
                  const _ = E(R, B);
                  _ !== R && (O = u.indexOf(_));
                }
                I[D] = O >= 0 ? O : 0;
              }
            return I;
          }
          function y(x) {
            return x.replaceAll(/[,_]/g, "-").replaceAll(/\s/g, "");
          }
        },
        /* 39 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.getGlyphsUnicode = c.getDingbatsGlyphsUnicode = void 0;
          var s = f(3);
          const h = (0, s.getLookupTableFactory)(function(t) {
            t.A = 65, t.AE = 198, t.AEacute = 508, t.AEmacron = 482, t.AEsmall = 63462, t.Aacute = 193, t.Aacutesmall = 63457, t.Abreve = 258, t.Abreveacute = 7854, t.Abrevecyrillic = 1232, t.Abrevedotbelow = 7862, t.Abrevegrave = 7856, t.Abrevehookabove = 7858, t.Abrevetilde = 7860, t.Acaron = 461, t.Acircle = 9398, t.Acircumflex = 194, t.Acircumflexacute = 7844, t.Acircumflexdotbelow = 7852, t.Acircumflexgrave = 7846, t.Acircumflexhookabove = 7848, t.Acircumflexsmall = 63458, t.Acircumflextilde = 7850, t.Acute = 63177, t.Acutesmall = 63412, t.Acyrillic = 1040, t.Adblgrave = 512, t.Adieresis = 196, t.Adieresiscyrillic = 1234, t.Adieresismacron = 478, t.Adieresissmall = 63460, t.Adotbelow = 7840, t.Adotmacron = 480, t.Agrave = 192, t.Agravesmall = 63456, t.Ahookabove = 7842, t.Aiecyrillic = 1236, t.Ainvertedbreve = 514, t.Alpha = 913, t.Alphatonos = 902, t.Amacron = 256, t.Amonospace = 65313, t.Aogonek = 260, t.Aring = 197, t.Aringacute = 506, t.Aringbelow = 7680, t.Aringsmall = 63461, t.Asmall = 63329, t.Atilde = 195, t.Atildesmall = 63459, t.Aybarmenian = 1329, t.B = 66, t.Bcircle = 9399, t.Bdotaccent = 7682, t.Bdotbelow = 7684, t.Becyrillic = 1041, t.Benarmenian = 1330, t.Beta = 914, t.Bhook = 385, t.Blinebelow = 7686, t.Bmonospace = 65314, t.Brevesmall = 63220, t.Bsmall = 63330, t.Btopbar = 386, t.C = 67, t.Caarmenian = 1342, t.Cacute = 262, t.Caron = 63178, t.Caronsmall = 63221, t.Ccaron = 268, t.Ccedilla = 199, t.Ccedillaacute = 7688, t.Ccedillasmall = 63463, t.Ccircle = 9400, t.Ccircumflex = 264, t.Cdot = 266, t.Cdotaccent = 266, t.Cedillasmall = 63416, t.Chaarmenian = 1353, t.Cheabkhasiancyrillic = 1212, t.Checyrillic = 1063, t.Chedescenderabkhasiancyrillic = 1214, t.Chedescendercyrillic = 1206, t.Chedieresiscyrillic = 1268, t.Cheharmenian = 1347, t.Chekhakassiancyrillic = 1227, t.Cheverticalstrokecyrillic = 1208, t.Chi = 935, t.Chook = 391, t.Circumflexsmall = 63222, t.Cmonospace = 65315, t.Coarmenian = 1361, t.Csmall = 63331, t.D = 68, t.DZ = 497, t.DZcaron = 452, t.Daarmenian = 1332, t.Dafrican = 393, t.Dcaron = 270, t.Dcedilla = 7696, t.Dcircle = 9401, t.Dcircumflexbelow = 7698, t.Dcroat = 272, t.Ddotaccent = 7690, t.Ddotbelow = 7692, t.Decyrillic = 1044, t.Deicoptic = 1006, t.Delta = 8710, t.Deltagreek = 916, t.Dhook = 394, t.Dieresis = 63179, t.DieresisAcute = 63180, t.DieresisGrave = 63181, t.Dieresissmall = 63400, t.Digammagreek = 988, t.Djecyrillic = 1026, t.Dlinebelow = 7694, t.Dmonospace = 65316, t.Dotaccentsmall = 63223, t.Dslash = 272, t.Dsmall = 63332, t.Dtopbar = 395, t.Dz = 498, t.Dzcaron = 453, t.Dzeabkhasiancyrillic = 1248, t.Dzecyrillic = 1029, t.Dzhecyrillic = 1039, t.E = 69, t.Eacute = 201, t.Eacutesmall = 63465, t.Ebreve = 276, t.Ecaron = 282, t.Ecedillabreve = 7708, t.Echarmenian = 1333, t.Ecircle = 9402, t.Ecircumflex = 202, t.Ecircumflexacute = 7870, t.Ecircumflexbelow = 7704, t.Ecircumflexdotbelow = 7878, t.Ecircumflexgrave = 7872, t.Ecircumflexhookabove = 7874, t.Ecircumflexsmall = 63466, t.Ecircumflextilde = 7876, t.Ecyrillic = 1028, t.Edblgrave = 516, t.Edieresis = 203, t.Edieresissmall = 63467, t.Edot = 278, t.Edotaccent = 278, t.Edotbelow = 7864, t.Efcyrillic = 1060, t.Egrave = 200, t.Egravesmall = 63464, t.Eharmenian = 1335, t.Ehookabove = 7866, t.Eightroman = 8551, t.Einvertedbreve = 518, t.Eiotifiedcyrillic = 1124, t.Elcyrillic = 1051, t.Elevenroman = 8554, t.Emacron = 274, t.Emacronacute = 7702, t.Emacrongrave = 7700, t.Emcyrillic = 1052, t.Emonospace = 65317, t.Encyrillic = 1053, t.Endescendercyrillic = 1186, t.Eng = 330, t.Enghecyrillic = 1188, t.Enhookcyrillic = 1223, t.Eogonek = 280, t.Eopen = 400, t.Epsilon = 917, t.Epsilontonos = 904, t.Ercyrillic = 1056, t.Ereversed = 398, t.Ereversedcyrillic = 1069, t.Escyrillic = 1057, t.Esdescendercyrillic = 1194, t.Esh = 425, t.Esmall = 63333, t.Eta = 919, t.Etarmenian = 1336, t.Etatonos = 905, t.Eth = 208, t.Ethsmall = 63472, t.Etilde = 7868, t.Etildebelow = 7706, t.Euro = 8364, t.Ezh = 439, t.Ezhcaron = 494, t.Ezhreversed = 440, t.F = 70, t.Fcircle = 9403, t.Fdotaccent = 7710, t.Feharmenian = 1366, t.Feicoptic = 996, t.Fhook = 401, t.Fitacyrillic = 1138, t.Fiveroman = 8548, t.Fmonospace = 65318, t.Fourroman = 8547, t.Fsmall = 63334, t.G = 71, t.GBsquare = 13191, t.Gacute = 500, t.Gamma = 915, t.Gammaafrican = 404, t.Gangiacoptic = 1002, t.Gbreve = 286, t.Gcaron = 486, t.Gcedilla = 290, t.Gcircle = 9404, t.Gcircumflex = 284, t.Gcommaaccent = 290, t.Gdot = 288, t.Gdotaccent = 288, t.Gecyrillic = 1043, t.Ghadarmenian = 1346, t.Ghemiddlehookcyrillic = 1172, t.Ghestrokecyrillic = 1170, t.Gheupturncyrillic = 1168, t.Ghook = 403, t.Gimarmenian = 1331, t.Gjecyrillic = 1027, t.Gmacron = 7712, t.Gmonospace = 65319, t.Grave = 63182, t.Gravesmall = 63328, t.Gsmall = 63335, t.Gsmallhook = 667, t.Gstroke = 484, t.H = 72, t.H18533 = 9679, t.H18543 = 9642, t.H18551 = 9643, t.H22073 = 9633, t.HPsquare = 13259, t.Haabkhasiancyrillic = 1192, t.Hadescendercyrillic = 1202, t.Hardsigncyrillic = 1066, t.Hbar = 294, t.Hbrevebelow = 7722, t.Hcedilla = 7720, t.Hcircle = 9405, t.Hcircumflex = 292, t.Hdieresis = 7718, t.Hdotaccent = 7714, t.Hdotbelow = 7716, t.Hmonospace = 65320, t.Hoarmenian = 1344, t.Horicoptic = 1e3, t.Hsmall = 63336, t.Hungarumlaut = 63183, t.Hungarumlautsmall = 63224, t.Hzsquare = 13200, t.I = 73, t.IAcyrillic = 1071, t.IJ = 306, t.IUcyrillic = 1070, t.Iacute = 205, t.Iacutesmall = 63469, t.Ibreve = 300, t.Icaron = 463, t.Icircle = 9406, t.Icircumflex = 206, t.Icircumflexsmall = 63470, t.Icyrillic = 1030, t.Idblgrave = 520, t.Idieresis = 207, t.Idieresisacute = 7726, t.Idieresiscyrillic = 1252, t.Idieresissmall = 63471, t.Idot = 304, t.Idotaccent = 304, t.Idotbelow = 7882, t.Iebrevecyrillic = 1238, t.Iecyrillic = 1045, t.Ifraktur = 8465, t.Igrave = 204, t.Igravesmall = 63468, t.Ihookabove = 7880, t.Iicyrillic = 1048, t.Iinvertedbreve = 522, t.Iishortcyrillic = 1049, t.Imacron = 298, t.Imacroncyrillic = 1250, t.Imonospace = 65321, t.Iniarmenian = 1339, t.Iocyrillic = 1025, t.Iogonek = 302, t.Iota = 921, t.Iotaafrican = 406, t.Iotadieresis = 938, t.Iotatonos = 906, t.Ismall = 63337, t.Istroke = 407, t.Itilde = 296, t.Itildebelow = 7724, t.Izhitsacyrillic = 1140, t.Izhitsadblgravecyrillic = 1142, t.J = 74, t.Jaarmenian = 1345, t.Jcircle = 9407, t.Jcircumflex = 308, t.Jecyrillic = 1032, t.Jheharmenian = 1355, t.Jmonospace = 65322, t.Jsmall = 63338, t.K = 75, t.KBsquare = 13189, t.KKsquare = 13261, t.Kabashkircyrillic = 1184, t.Kacute = 7728, t.Kacyrillic = 1050, t.Kadescendercyrillic = 1178, t.Kahookcyrillic = 1219, t.Kappa = 922, t.Kastrokecyrillic = 1182, t.Kaverticalstrokecyrillic = 1180, t.Kcaron = 488, t.Kcedilla = 310, t.Kcircle = 9408, t.Kcommaaccent = 310, t.Kdotbelow = 7730, t.Keharmenian = 1364, t.Kenarmenian = 1343, t.Khacyrillic = 1061, t.Kheicoptic = 998, t.Khook = 408, t.Kjecyrillic = 1036, t.Klinebelow = 7732, t.Kmonospace = 65323, t.Koppacyrillic = 1152, t.Koppagreek = 990, t.Ksicyrillic = 1134, t.Ksmall = 63339, t.L = 76, t.LJ = 455, t.LL = 63167, t.Lacute = 313, t.Lambda = 923, t.Lcaron = 317, t.Lcedilla = 315, t.Lcircle = 9409, t.Lcircumflexbelow = 7740, t.Lcommaaccent = 315, t.Ldot = 319, t.Ldotaccent = 319, t.Ldotbelow = 7734, t.Ldotbelowmacron = 7736, t.Liwnarmenian = 1340, t.Lj = 456, t.Ljecyrillic = 1033, t.Llinebelow = 7738, t.Lmonospace = 65324, t.Lslash = 321, t.Lslashsmall = 63225, t.Lsmall = 63340, t.M = 77, t.MBsquare = 13190, t.Macron = 63184, t.Macronsmall = 63407, t.Macute = 7742, t.Mcircle = 9410, t.Mdotaccent = 7744, t.Mdotbelow = 7746, t.Menarmenian = 1348, t.Mmonospace = 65325, t.Msmall = 63341, t.Mturned = 412, t.Mu = 924, t.N = 78, t.NJ = 458, t.Nacute = 323, t.Ncaron = 327, t.Ncedilla = 325, t.Ncircle = 9411, t.Ncircumflexbelow = 7754, t.Ncommaaccent = 325, t.Ndotaccent = 7748, t.Ndotbelow = 7750, t.Nhookleft = 413, t.Nineroman = 8552, t.Nj = 459, t.Njecyrillic = 1034, t.Nlinebelow = 7752, t.Nmonospace = 65326, t.Nowarmenian = 1350, t.Nsmall = 63342, t.Ntilde = 209, t.Ntildesmall = 63473, t.Nu = 925, t.O = 79, t.OE = 338, t.OEsmall = 63226, t.Oacute = 211, t.Oacutesmall = 63475, t.Obarredcyrillic = 1256, t.Obarreddieresiscyrillic = 1258, t.Obreve = 334, t.Ocaron = 465, t.Ocenteredtilde = 415, t.Ocircle = 9412, t.Ocircumflex = 212, t.Ocircumflexacute = 7888, t.Ocircumflexdotbelow = 7896, t.Ocircumflexgrave = 7890, t.Ocircumflexhookabove = 7892, t.Ocircumflexsmall = 63476, t.Ocircumflextilde = 7894, t.Ocyrillic = 1054, t.Odblacute = 336, t.Odblgrave = 524, t.Odieresis = 214, t.Odieresiscyrillic = 1254, t.Odieresissmall = 63478, t.Odotbelow = 7884, t.Ogoneksmall = 63227, t.Ograve = 210, t.Ogravesmall = 63474, t.Oharmenian = 1365, t.Ohm = 8486, t.Ohookabove = 7886, t.Ohorn = 416, t.Ohornacute = 7898, t.Ohorndotbelow = 7906, t.Ohorngrave = 7900, t.Ohornhookabove = 7902, t.Ohorntilde = 7904, t.Ohungarumlaut = 336, t.Oi = 418, t.Oinvertedbreve = 526, t.Omacron = 332, t.Omacronacute = 7762, t.Omacrongrave = 7760, t.Omega = 8486, t.Omegacyrillic = 1120, t.Omegagreek = 937, t.Omegaroundcyrillic = 1146, t.Omegatitlocyrillic = 1148, t.Omegatonos = 911, t.Omicron = 927, t.Omicrontonos = 908, t.Omonospace = 65327, t.Oneroman = 8544, t.Oogonek = 490, t.Oogonekmacron = 492, t.Oopen = 390, t.Oslash = 216, t.Oslashacute = 510, t.Oslashsmall = 63480, t.Osmall = 63343, t.Ostrokeacute = 510, t.Otcyrillic = 1150, t.Otilde = 213, t.Otildeacute = 7756, t.Otildedieresis = 7758, t.Otildesmall = 63477, t.P = 80, t.Pacute = 7764, t.Pcircle = 9413, t.Pdotaccent = 7766, t.Pecyrillic = 1055, t.Peharmenian = 1354, t.Pemiddlehookcyrillic = 1190, t.Phi = 934, t.Phook = 420, t.Pi = 928, t.Piwrarmenian = 1363, t.Pmonospace = 65328, t.Psi = 936, t.Psicyrillic = 1136, t.Psmall = 63344, t.Q = 81, t.Qcircle = 9414, t.Qmonospace = 65329, t.Qsmall = 63345, t.R = 82, t.Raarmenian = 1356, t.Racute = 340, t.Rcaron = 344, t.Rcedilla = 342, t.Rcircle = 9415, t.Rcommaaccent = 342, t.Rdblgrave = 528, t.Rdotaccent = 7768, t.Rdotbelow = 7770, t.Rdotbelowmacron = 7772, t.Reharmenian = 1360, t.Rfraktur = 8476, t.Rho = 929, t.Ringsmall = 63228, t.Rinvertedbreve = 530, t.Rlinebelow = 7774, t.Rmonospace = 65330, t.Rsmall = 63346, t.Rsmallinverted = 641, t.Rsmallinvertedsuperior = 694, t.S = 83, t.SF010000 = 9484, t.SF020000 = 9492, t.SF030000 = 9488, t.SF040000 = 9496, t.SF050000 = 9532, t.SF060000 = 9516, t.SF070000 = 9524, t.SF080000 = 9500, t.SF090000 = 9508, t.SF100000 = 9472, t.SF110000 = 9474, t.SF190000 = 9569, t.SF200000 = 9570, t.SF210000 = 9558, t.SF220000 = 9557, t.SF230000 = 9571, t.SF240000 = 9553, t.SF250000 = 9559, t.SF260000 = 9565, t.SF270000 = 9564, t.SF280000 = 9563, t.SF360000 = 9566, t.SF370000 = 9567, t.SF380000 = 9562, t.SF390000 = 9556, t.SF400000 = 9577, t.SF410000 = 9574, t.SF420000 = 9568, t.SF430000 = 9552, t.SF440000 = 9580, t.SF450000 = 9575, t.SF460000 = 9576, t.SF470000 = 9572, t.SF480000 = 9573, t.SF490000 = 9561, t.SF500000 = 9560, t.SF510000 = 9554, t.SF520000 = 9555, t.SF530000 = 9579, t.SF540000 = 9578, t.Sacute = 346, t.Sacutedotaccent = 7780, t.Sampigreek = 992, t.Scaron = 352, t.Scarondotaccent = 7782, t.Scaronsmall = 63229, t.Scedilla = 350, t.Schwa = 399, t.Schwacyrillic = 1240, t.Schwadieresiscyrillic = 1242, t.Scircle = 9416, t.Scircumflex = 348, t.Scommaaccent = 536, t.Sdotaccent = 7776, t.Sdotbelow = 7778, t.Sdotbelowdotaccent = 7784, t.Seharmenian = 1357, t.Sevenroman = 8550, t.Shaarmenian = 1351, t.Shacyrillic = 1064, t.Shchacyrillic = 1065, t.Sheicoptic = 994, t.Shhacyrillic = 1210, t.Shimacoptic = 1004, t.Sigma = 931, t.Sixroman = 8549, t.Smonospace = 65331, t.Softsigncyrillic = 1068, t.Ssmall = 63347, t.Stigmagreek = 986, t.T = 84, t.Tau = 932, t.Tbar = 358, t.Tcaron = 356, t.Tcedilla = 354, t.Tcircle = 9417, t.Tcircumflexbelow = 7792, t.Tcommaaccent = 354, t.Tdotaccent = 7786, t.Tdotbelow = 7788, t.Tecyrillic = 1058, t.Tedescendercyrillic = 1196, t.Tenroman = 8553, t.Tetsecyrillic = 1204, t.Theta = 920, t.Thook = 428, t.Thorn = 222, t.Thornsmall = 63486, t.Threeroman = 8546, t.Tildesmall = 63230, t.Tiwnarmenian = 1359, t.Tlinebelow = 7790, t.Tmonospace = 65332, t.Toarmenian = 1337, t.Tonefive = 444, t.Tonesix = 388, t.Tonetwo = 423, t.Tretroflexhook = 430, t.Tsecyrillic = 1062, t.Tshecyrillic = 1035, t.Tsmall = 63348, t.Twelveroman = 8555, t.Tworoman = 8545, t.U = 85, t.Uacute = 218, t.Uacutesmall = 63482, t.Ubreve = 364, t.Ucaron = 467, t.Ucircle = 9418, t.Ucircumflex = 219, t.Ucircumflexbelow = 7798, t.Ucircumflexsmall = 63483, t.Ucyrillic = 1059, t.Udblacute = 368, t.Udblgrave = 532, t.Udieresis = 220, t.Udieresisacute = 471, t.Udieresisbelow = 7794, t.Udieresiscaron = 473, t.Udieresiscyrillic = 1264, t.Udieresisgrave = 475, t.Udieresismacron = 469, t.Udieresissmall = 63484, t.Udotbelow = 7908, t.Ugrave = 217, t.Ugravesmall = 63481, t.Uhookabove = 7910, t.Uhorn = 431, t.Uhornacute = 7912, t.Uhorndotbelow = 7920, t.Uhorngrave = 7914, t.Uhornhookabove = 7916, t.Uhorntilde = 7918, t.Uhungarumlaut = 368, t.Uhungarumlautcyrillic = 1266, t.Uinvertedbreve = 534, t.Ukcyrillic = 1144, t.Umacron = 362, t.Umacroncyrillic = 1262, t.Umacrondieresis = 7802, t.Umonospace = 65333, t.Uogonek = 370, t.Upsilon = 933, t.Upsilon1 = 978, t.Upsilonacutehooksymbolgreek = 979, t.Upsilonafrican = 433, t.Upsilondieresis = 939, t.Upsilondieresishooksymbolgreek = 980, t.Upsilonhooksymbol = 978, t.Upsilontonos = 910, t.Uring = 366, t.Ushortcyrillic = 1038, t.Usmall = 63349, t.Ustraightcyrillic = 1198, t.Ustraightstrokecyrillic = 1200, t.Utilde = 360, t.Utildeacute = 7800, t.Utildebelow = 7796, t.V = 86, t.Vcircle = 9419, t.Vdotbelow = 7806, t.Vecyrillic = 1042, t.Vewarmenian = 1358, t.Vhook = 434, t.Vmonospace = 65334, t.Voarmenian = 1352, t.Vsmall = 63350, t.Vtilde = 7804, t.W = 87, t.Wacute = 7810, t.Wcircle = 9420, t.Wcircumflex = 372, t.Wdieresis = 7812, t.Wdotaccent = 7814, t.Wdotbelow = 7816, t.Wgrave = 7808, t.Wmonospace = 65335, t.Wsmall = 63351, t.X = 88, t.Xcircle = 9421, t.Xdieresis = 7820, t.Xdotaccent = 7818, t.Xeharmenian = 1341, t.Xi = 926, t.Xmonospace = 65336, t.Xsmall = 63352, t.Y = 89, t.Yacute = 221, t.Yacutesmall = 63485, t.Yatcyrillic = 1122, t.Ycircle = 9422, t.Ycircumflex = 374, t.Ydieresis = 376, t.Ydieresissmall = 63487, t.Ydotaccent = 7822, t.Ydotbelow = 7924, t.Yericyrillic = 1067, t.Yerudieresiscyrillic = 1272, t.Ygrave = 7922, t.Yhook = 435, t.Yhookabove = 7926, t.Yiarmenian = 1349, t.Yicyrillic = 1031, t.Yiwnarmenian = 1362, t.Ymonospace = 65337, t.Ysmall = 63353, t.Ytilde = 7928, t.Yusbigcyrillic = 1130, t.Yusbigiotifiedcyrillic = 1132, t.Yuslittlecyrillic = 1126, t.Yuslittleiotifiedcyrillic = 1128, t.Z = 90, t.Zaarmenian = 1334, t.Zacute = 377, t.Zcaron = 381, t.Zcaronsmall = 63231, t.Zcircle = 9423, t.Zcircumflex = 7824, t.Zdot = 379, t.Zdotaccent = 379, t.Zdotbelow = 7826, t.Zecyrillic = 1047, t.Zedescendercyrillic = 1176, t.Zedieresiscyrillic = 1246, t.Zeta = 918, t.Zhearmenian = 1338, t.Zhebrevecyrillic = 1217, t.Zhecyrillic = 1046, t.Zhedescendercyrillic = 1174, t.Zhedieresiscyrillic = 1244, t.Zlinebelow = 7828, t.Zmonospace = 65338, t.Zsmall = 63354, t.Zstroke = 437, t.a = 97, t.aabengali = 2438, t.aacute = 225, t.aadeva = 2310, t.aagujarati = 2694, t.aagurmukhi = 2566, t.aamatragurmukhi = 2622, t.aarusquare = 13059, t.aavowelsignbengali = 2494, t.aavowelsigndeva = 2366, t.aavowelsigngujarati = 2750, t.abbreviationmarkarmenian = 1375, t.abbreviationsigndeva = 2416, t.abengali = 2437, t.abopomofo = 12570, t.abreve = 259, t.abreveacute = 7855, t.abrevecyrillic = 1233, t.abrevedotbelow = 7863, t.abrevegrave = 7857, t.abrevehookabove = 7859, t.abrevetilde = 7861, t.acaron = 462, t.acircle = 9424, t.acircumflex = 226, t.acircumflexacute = 7845, t.acircumflexdotbelow = 7853, t.acircumflexgrave = 7847, t.acircumflexhookabove = 7849, t.acircumflextilde = 7851, t.acute = 180, t.acutebelowcmb = 791, t.acutecmb = 769, t.acutecomb = 769, t.acutedeva = 2388, t.acutelowmod = 719, t.acutetonecmb = 833, t.acyrillic = 1072, t.adblgrave = 513, t.addakgurmukhi = 2673, t.adeva = 2309, t.adieresis = 228, t.adieresiscyrillic = 1235, t.adieresismacron = 479, t.adotbelow = 7841, t.adotmacron = 481, t.ae = 230, t.aeacute = 509, t.aekorean = 12624, t.aemacron = 483, t.afii00208 = 8213, t.afii08941 = 8356, t.afii10017 = 1040, t.afii10018 = 1041, t.afii10019 = 1042, t.afii10020 = 1043, t.afii10021 = 1044, t.afii10022 = 1045, t.afii10023 = 1025, t.afii10024 = 1046, t.afii10025 = 1047, t.afii10026 = 1048, t.afii10027 = 1049, t.afii10028 = 1050, t.afii10029 = 1051, t.afii10030 = 1052, t.afii10031 = 1053, t.afii10032 = 1054, t.afii10033 = 1055, t.afii10034 = 1056, t.afii10035 = 1057, t.afii10036 = 1058, t.afii10037 = 1059, t.afii10038 = 1060, t.afii10039 = 1061, t.afii10040 = 1062, t.afii10041 = 1063, t.afii10042 = 1064, t.afii10043 = 1065, t.afii10044 = 1066, t.afii10045 = 1067, t.afii10046 = 1068, t.afii10047 = 1069, t.afii10048 = 1070, t.afii10049 = 1071, t.afii10050 = 1168, t.afii10051 = 1026, t.afii10052 = 1027, t.afii10053 = 1028, t.afii10054 = 1029, t.afii10055 = 1030, t.afii10056 = 1031, t.afii10057 = 1032, t.afii10058 = 1033, t.afii10059 = 1034, t.afii10060 = 1035, t.afii10061 = 1036, t.afii10062 = 1038, t.afii10063 = 63172, t.afii10064 = 63173, t.afii10065 = 1072, t.afii10066 = 1073, t.afii10067 = 1074, t.afii10068 = 1075, t.afii10069 = 1076, t.afii10070 = 1077, t.afii10071 = 1105, t.afii10072 = 1078, t.afii10073 = 1079, t.afii10074 = 1080, t.afii10075 = 1081, t.afii10076 = 1082, t.afii10077 = 1083, t.afii10078 = 1084, t.afii10079 = 1085, t.afii10080 = 1086, t.afii10081 = 1087, t.afii10082 = 1088, t.afii10083 = 1089, t.afii10084 = 1090, t.afii10085 = 1091, t.afii10086 = 1092, t.afii10087 = 1093, t.afii10088 = 1094, t.afii10089 = 1095, t.afii10090 = 1096, t.afii10091 = 1097, t.afii10092 = 1098, t.afii10093 = 1099, t.afii10094 = 1100, t.afii10095 = 1101, t.afii10096 = 1102, t.afii10097 = 1103, t.afii10098 = 1169, t.afii10099 = 1106, t.afii10100 = 1107, t.afii10101 = 1108, t.afii10102 = 1109, t.afii10103 = 1110, t.afii10104 = 1111, t.afii10105 = 1112, t.afii10106 = 1113, t.afii10107 = 1114, t.afii10108 = 1115, t.afii10109 = 1116, t.afii10110 = 1118, t.afii10145 = 1039, t.afii10146 = 1122, t.afii10147 = 1138, t.afii10148 = 1140, t.afii10192 = 63174, t.afii10193 = 1119, t.afii10194 = 1123, t.afii10195 = 1139, t.afii10196 = 1141, t.afii10831 = 63175, t.afii10832 = 63176, t.afii10846 = 1241, t.afii299 = 8206, t.afii300 = 8207, t.afii301 = 8205, t.afii57381 = 1642, t.afii57388 = 1548, t.afii57392 = 1632, t.afii57393 = 1633, t.afii57394 = 1634, t.afii57395 = 1635, t.afii57396 = 1636, t.afii57397 = 1637, t.afii57398 = 1638, t.afii57399 = 1639, t.afii57400 = 1640, t.afii57401 = 1641, t.afii57403 = 1563, t.afii57407 = 1567, t.afii57409 = 1569, t.afii57410 = 1570, t.afii57411 = 1571, t.afii57412 = 1572, t.afii57413 = 1573, t.afii57414 = 1574, t.afii57415 = 1575, t.afii57416 = 1576, t.afii57417 = 1577, t.afii57418 = 1578, t.afii57419 = 1579, t.afii57420 = 1580, t.afii57421 = 1581, t.afii57422 = 1582, t.afii57423 = 1583, t.afii57424 = 1584, t.afii57425 = 1585, t.afii57426 = 1586, t.afii57427 = 1587, t.afii57428 = 1588, t.afii57429 = 1589, t.afii57430 = 1590, t.afii57431 = 1591, t.afii57432 = 1592, t.afii57433 = 1593, t.afii57434 = 1594, t.afii57440 = 1600, t.afii57441 = 1601, t.afii57442 = 1602, t.afii57443 = 1603, t.afii57444 = 1604, t.afii57445 = 1605, t.afii57446 = 1606, t.afii57448 = 1608, t.afii57449 = 1609, t.afii57450 = 1610, t.afii57451 = 1611, t.afii57452 = 1612, t.afii57453 = 1613, t.afii57454 = 1614, t.afii57455 = 1615, t.afii57456 = 1616, t.afii57457 = 1617, t.afii57458 = 1618, t.afii57470 = 1607, t.afii57505 = 1700, t.afii57506 = 1662, t.afii57507 = 1670, t.afii57508 = 1688, t.afii57509 = 1711, t.afii57511 = 1657, t.afii57512 = 1672, t.afii57513 = 1681, t.afii57514 = 1722, t.afii57519 = 1746, t.afii57534 = 1749, t.afii57636 = 8362, t.afii57645 = 1470, t.afii57658 = 1475, t.afii57664 = 1488, t.afii57665 = 1489, t.afii57666 = 1490, t.afii57667 = 1491, t.afii57668 = 1492, t.afii57669 = 1493, t.afii57670 = 1494, t.afii57671 = 1495, t.afii57672 = 1496, t.afii57673 = 1497, t.afii57674 = 1498, t.afii57675 = 1499, t.afii57676 = 1500, t.afii57677 = 1501, t.afii57678 = 1502, t.afii57679 = 1503, t.afii57680 = 1504, t.afii57681 = 1505, t.afii57682 = 1506, t.afii57683 = 1507, t.afii57684 = 1508, t.afii57685 = 1509, t.afii57686 = 1510, t.afii57687 = 1511, t.afii57688 = 1512, t.afii57689 = 1513, t.afii57690 = 1514, t.afii57694 = 64298, t.afii57695 = 64299, t.afii57700 = 64331, t.afii57705 = 64287, t.afii57716 = 1520, t.afii57717 = 1521, t.afii57718 = 1522, t.afii57723 = 64309, t.afii57793 = 1460, t.afii57794 = 1461, t.afii57795 = 1462, t.afii57796 = 1467, t.afii57797 = 1464, t.afii57798 = 1463, t.afii57799 = 1456, t.afii57800 = 1458, t.afii57801 = 1457, t.afii57802 = 1459, t.afii57803 = 1474, t.afii57804 = 1473, t.afii57806 = 1465, t.afii57807 = 1468, t.afii57839 = 1469, t.afii57841 = 1471, t.afii57842 = 1472, t.afii57929 = 700, t.afii61248 = 8453, t.afii61289 = 8467, t.afii61352 = 8470, t.afii61573 = 8236, t.afii61574 = 8237, t.afii61575 = 8238, t.afii61664 = 8204, t.afii63167 = 1645, t.afii64937 = 701, t.agrave = 224, t.agujarati = 2693, t.agurmukhi = 2565, t.ahiragana = 12354, t.ahookabove = 7843, t.aibengali = 2448, t.aibopomofo = 12574, t.aideva = 2320, t.aiecyrillic = 1237, t.aigujarati = 2704, t.aigurmukhi = 2576, t.aimatragurmukhi = 2632, t.ainarabic = 1593, t.ainfinalarabic = 65226, t.aininitialarabic = 65227, t.ainmedialarabic = 65228, t.ainvertedbreve = 515, t.aivowelsignbengali = 2504, t.aivowelsigndeva = 2376, t.aivowelsigngujarati = 2760, t.akatakana = 12450, t.akatakanahalfwidth = 65393, t.akorean = 12623, t.alef = 1488, t.alefarabic = 1575, t.alefdageshhebrew = 64304, t.aleffinalarabic = 65166, t.alefhamzaabovearabic = 1571, t.alefhamzaabovefinalarabic = 65156, t.alefhamzabelowarabic = 1573, t.alefhamzabelowfinalarabic = 65160, t.alefhebrew = 1488, t.aleflamedhebrew = 64335, t.alefmaddaabovearabic = 1570, t.alefmaddaabovefinalarabic = 65154, t.alefmaksuraarabic = 1609, t.alefmaksurafinalarabic = 65264, t.alefmaksurainitialarabic = 65267, t.alefmaksuramedialarabic = 65268, t.alefpatahhebrew = 64302, t.alefqamatshebrew = 64303, t.aleph = 8501, t.allequal = 8780, t.alpha = 945, t.alphatonos = 940, t.amacron = 257, t.amonospace = 65345, t.ampersand = 38, t.ampersandmonospace = 65286, t.ampersandsmall = 63270, t.amsquare = 13250, t.anbopomofo = 12578, t.angbopomofo = 12580, t.angbracketleft = 12296, t.angbracketright = 12297, t.angkhankhuthai = 3674, t.angle = 8736, t.anglebracketleft = 12296, t.anglebracketleftvertical = 65087, t.anglebracketright = 12297, t.anglebracketrightvertical = 65088, t.angleleft = 9001, t.angleright = 9002, t.angstrom = 8491, t.anoteleia = 903, t.anudattadeva = 2386, t.anusvarabengali = 2434, t.anusvaradeva = 2306, t.anusvaragujarati = 2690, t.aogonek = 261, t.apaatosquare = 13056, t.aparen = 9372, t.apostrophearmenian = 1370, t.apostrophemod = 700, t.apple = 63743, t.approaches = 8784, t.approxequal = 8776, t.approxequalorimage = 8786, t.approximatelyequal = 8773, t.araeaekorean = 12686, t.araeakorean = 12685, t.arc = 8978, t.arighthalfring = 7834, t.aring = 229, t.aringacute = 507, t.aringbelow = 7681, t.arrowboth = 8596, t.arrowdashdown = 8675, t.arrowdashleft = 8672, t.arrowdashright = 8674, t.arrowdashup = 8673, t.arrowdblboth = 8660, t.arrowdbldown = 8659, t.arrowdblleft = 8656, t.arrowdblright = 8658, t.arrowdblup = 8657, t.arrowdown = 8595, t.arrowdownleft = 8601, t.arrowdownright = 8600, t.arrowdownwhite = 8681, t.arrowheaddownmod = 709, t.arrowheadleftmod = 706, t.arrowheadrightmod = 707, t.arrowheadupmod = 708, t.arrowhorizex = 63719, t.arrowleft = 8592, t.arrowleftdbl = 8656, t.arrowleftdblstroke = 8653, t.arrowleftoverright = 8646, t.arrowleftwhite = 8678, t.arrowright = 8594, t.arrowrightdblstroke = 8655, t.arrowrightheavy = 10142, t.arrowrightoverleft = 8644, t.arrowrightwhite = 8680, t.arrowtableft = 8676, t.arrowtabright = 8677, t.arrowup = 8593, t.arrowupdn = 8597, t.arrowupdnbse = 8616, t.arrowupdownbase = 8616, t.arrowupleft = 8598, t.arrowupleftofdown = 8645, t.arrowupright = 8599, t.arrowupwhite = 8679, t.arrowvertex = 63718, t.asciicircum = 94, t.asciicircummonospace = 65342, t.asciitilde = 126, t.asciitildemonospace = 65374, t.ascript = 593, t.ascriptturned = 594, t.asmallhiragana = 12353, t.asmallkatakana = 12449, t.asmallkatakanahalfwidth = 65383, t.asterisk = 42, t.asteriskaltonearabic = 1645, t.asteriskarabic = 1645, t.asteriskmath = 8727, t.asteriskmonospace = 65290, t.asterisksmall = 65121, t.asterism = 8258, t.asuperior = 63209, t.asymptoticallyequal = 8771, t.at = 64, t.atilde = 227, t.atmonospace = 65312, t.atsmall = 65131, t.aturned = 592, t.aubengali = 2452, t.aubopomofo = 12576, t.audeva = 2324, t.augujarati = 2708, t.augurmukhi = 2580, t.aulengthmarkbengali = 2519, t.aumatragurmukhi = 2636, t.auvowelsignbengali = 2508, t.auvowelsigndeva = 2380, t.auvowelsigngujarati = 2764, t.avagrahadeva = 2365, t.aybarmenian = 1377, t.ayin = 1506, t.ayinaltonehebrew = 64288, t.ayinhebrew = 1506, t.b = 98, t.babengali = 2476, t.backslash = 92, t.backslashmonospace = 65340, t.badeva = 2348, t.bagujarati = 2732, t.bagurmukhi = 2604, t.bahiragana = 12400, t.bahtthai = 3647, t.bakatakana = 12496, t.bar = 124, t.barmonospace = 65372, t.bbopomofo = 12549, t.bcircle = 9425, t.bdotaccent = 7683, t.bdotbelow = 7685, t.beamedsixteenthnotes = 9836, t.because = 8757, t.becyrillic = 1073, t.beharabic = 1576, t.behfinalarabic = 65168, t.behinitialarabic = 65169, t.behiragana = 12409, t.behmedialarabic = 65170, t.behmeeminitialarabic = 64671, t.behmeemisolatedarabic = 64520, t.behnoonfinalarabic = 64621, t.bekatakana = 12505, t.benarmenian = 1378, t.bet = 1489, t.beta = 946, t.betasymbolgreek = 976, t.betdagesh = 64305, t.betdageshhebrew = 64305, t.bethebrew = 1489, t.betrafehebrew = 64332, t.bhabengali = 2477, t.bhadeva = 2349, t.bhagujarati = 2733, t.bhagurmukhi = 2605, t.bhook = 595, t.bihiragana = 12403, t.bikatakana = 12499, t.bilabialclick = 664, t.bindigurmukhi = 2562, t.birusquare = 13105, t.blackcircle = 9679, t.blackdiamond = 9670, t.blackdownpointingtriangle = 9660, t.blackleftpointingpointer = 9668, t.blackleftpointingtriangle = 9664, t.blacklenticularbracketleft = 12304, t.blacklenticularbracketleftvertical = 65083, t.blacklenticularbracketright = 12305, t.blacklenticularbracketrightvertical = 65084, t.blacklowerlefttriangle = 9699, t.blacklowerrighttriangle = 9698, t.blackrectangle = 9644, t.blackrightpointingpointer = 9658, t.blackrightpointingtriangle = 9654, t.blacksmallsquare = 9642, t.blacksmilingface = 9787, t.blacksquare = 9632, t.blackstar = 9733, t.blackupperlefttriangle = 9700, t.blackupperrighttriangle = 9701, t.blackuppointingsmalltriangle = 9652, t.blackuppointingtriangle = 9650, t.blank = 9251, t.blinebelow = 7687, t.block = 9608, t.bmonospace = 65346, t.bobaimaithai = 3610, t.bohiragana = 12412, t.bokatakana = 12508, t.bparen = 9373, t.bqsquare = 13251, t.braceex = 63732, t.braceleft = 123, t.braceleftbt = 63731, t.braceleftmid = 63730, t.braceleftmonospace = 65371, t.braceleftsmall = 65115, t.bracelefttp = 63729, t.braceleftvertical = 65079, t.braceright = 125, t.bracerightbt = 63742, t.bracerightmid = 63741, t.bracerightmonospace = 65373, t.bracerightsmall = 65116, t.bracerighttp = 63740, t.bracerightvertical = 65080, t.bracketleft = 91, t.bracketleftbt = 63728, t.bracketleftex = 63727, t.bracketleftmonospace = 65339, t.bracketlefttp = 63726, t.bracketright = 93, t.bracketrightbt = 63739, t.bracketrightex = 63738, t.bracketrightmonospace = 65341, t.bracketrighttp = 63737, t.breve = 728, t.brevebelowcmb = 814, t.brevecmb = 774, t.breveinvertedbelowcmb = 815, t.breveinvertedcmb = 785, t.breveinverteddoublecmb = 865, t.bridgebelowcmb = 810, t.bridgeinvertedbelowcmb = 826, t.brokenbar = 166, t.bstroke = 384, t.bsuperior = 63210, t.btopbar = 387, t.buhiragana = 12406, t.bukatakana = 12502, t.bullet = 8226, t.bulletinverse = 9688, t.bulletoperator = 8729, t.bullseye = 9678, t.c = 99, t.caarmenian = 1390, t.cabengali = 2458, t.cacute = 263, t.cadeva = 2330, t.cagujarati = 2714, t.cagurmukhi = 2586, t.calsquare = 13192, t.candrabindubengali = 2433, t.candrabinducmb = 784, t.candrabindudeva = 2305, t.candrabindugujarati = 2689, t.capslock = 8682, t.careof = 8453, t.caron = 711, t.caronbelowcmb = 812, t.caroncmb = 780, t.carriagereturn = 8629, t.cbopomofo = 12568, t.ccaron = 269, t.ccedilla = 231, t.ccedillaacute = 7689, t.ccircle = 9426, t.ccircumflex = 265, t.ccurl = 597, t.cdot = 267, t.cdotaccent = 267, t.cdsquare = 13253, t.cedilla = 184, t.cedillacmb = 807, t.cent = 162, t.centigrade = 8451, t.centinferior = 63199, t.centmonospace = 65504, t.centoldstyle = 63394, t.centsuperior = 63200, t.chaarmenian = 1401, t.chabengali = 2459, t.chadeva = 2331, t.chagujarati = 2715, t.chagurmukhi = 2587, t.chbopomofo = 12564, t.cheabkhasiancyrillic = 1213, t.checkmark = 10003, t.checyrillic = 1095, t.chedescenderabkhasiancyrillic = 1215, t.chedescendercyrillic = 1207, t.chedieresiscyrillic = 1269, t.cheharmenian = 1395, t.chekhakassiancyrillic = 1228, t.cheverticalstrokecyrillic = 1209, t.chi = 967, t.chieuchacirclekorean = 12919, t.chieuchaparenkorean = 12823, t.chieuchcirclekorean = 12905, t.chieuchkorean = 12618, t.chieuchparenkorean = 12809, t.chochangthai = 3594, t.chochanthai = 3592, t.chochingthai = 3593, t.chochoethai = 3596, t.chook = 392, t.cieucacirclekorean = 12918, t.cieucaparenkorean = 12822, t.cieuccirclekorean = 12904, t.cieuckorean = 12616, t.cieucparenkorean = 12808, t.cieucuparenkorean = 12828, t.circle = 9675, t.circlecopyrt = 169, t.circlemultiply = 8855, t.circleot = 8857, t.circleplus = 8853, t.circlepostalmark = 12342, t.circlewithlefthalfblack = 9680, t.circlewithrighthalfblack = 9681, t.circumflex = 710, t.circumflexbelowcmb = 813, t.circumflexcmb = 770, t.clear = 8999, t.clickalveolar = 450, t.clickdental = 448, t.clicklateral = 449, t.clickretroflex = 451, t.club = 9827, t.clubsuitblack = 9827, t.clubsuitwhite = 9831, t.cmcubedsquare = 13220, t.cmonospace = 65347, t.cmsquaredsquare = 13216, t.coarmenian = 1409, t.colon = 58, t.colonmonetary = 8353, t.colonmonospace = 65306, t.colonsign = 8353, t.colonsmall = 65109, t.colontriangularhalfmod = 721, t.colontriangularmod = 720, t.comma = 44, t.commaabovecmb = 787, t.commaaboverightcmb = 789, t.commaaccent = 63171, t.commaarabic = 1548, t.commaarmenian = 1373, t.commainferior = 63201, t.commamonospace = 65292, t.commareversedabovecmb = 788, t.commareversedmod = 701, t.commasmall = 65104, t.commasuperior = 63202, t.commaturnedabovecmb = 786, t.commaturnedmod = 699, t.compass = 9788, t.congruent = 8773, t.contourintegral = 8750, t.control = 8963, t.controlACK = 6, t.controlBEL = 7, t.controlBS = 8, t.controlCAN = 24, t.controlCR = 13, t.controlDC1 = 17, t.controlDC2 = 18, t.controlDC3 = 19, t.controlDC4 = 20, t.controlDEL = 127, t.controlDLE = 16, t.controlEM = 25, t.controlENQ = 5, t.controlEOT = 4, t.controlESC = 27, t.controlETB = 23, t.controlETX = 3, t.controlFF = 12, t.controlFS = 28, t.controlGS = 29, t.controlHT = 9, t.controlLF = 10, t.controlNAK = 21, t.controlNULL = 0, t.controlRS = 30, t.controlSI = 15, t.controlSO = 14, t.controlSOT = 2, t.controlSTX = 1, t.controlSUB = 26, t.controlSYN = 22, t.controlUS = 31, t.controlVT = 11, t.copyright = 169, t.copyrightsans = 63721, t.copyrightserif = 63193, t.cornerbracketleft = 12300, t.cornerbracketlefthalfwidth = 65378, t.cornerbracketleftvertical = 65089, t.cornerbracketright = 12301, t.cornerbracketrighthalfwidth = 65379, t.cornerbracketrightvertical = 65090, t.corporationsquare = 13183, t.cosquare = 13255, t.coverkgsquare = 13254, t.cparen = 9374, t.cruzeiro = 8354, t.cstretched = 663, t.curlyand = 8911, t.curlyor = 8910, t.currency = 164, t.cyrBreve = 63185, t.cyrFlex = 63186, t.cyrbreve = 63188, t.cyrflex = 63189, t.d = 100, t.daarmenian = 1380, t.dabengali = 2470, t.dadarabic = 1590, t.dadeva = 2342, t.dadfinalarabic = 65214, t.dadinitialarabic = 65215, t.dadmedialarabic = 65216, t.dagesh = 1468, t.dageshhebrew = 1468, t.dagger = 8224, t.daggerdbl = 8225, t.dagujarati = 2726, t.dagurmukhi = 2598, t.dahiragana = 12384, t.dakatakana = 12480, t.dalarabic = 1583, t.dalet = 1491, t.daletdagesh = 64307, t.daletdageshhebrew = 64307, t.dalethebrew = 1491, t.dalfinalarabic = 65194, t.dammaarabic = 1615, t.dammalowarabic = 1615, t.dammatanaltonearabic = 1612, t.dammatanarabic = 1612, t.danda = 2404, t.dargahebrew = 1447, t.dargalefthebrew = 1447, t.dasiapneumatacyrilliccmb = 1157, t.dblGrave = 63187, t.dblanglebracketleft = 12298, t.dblanglebracketleftvertical = 65085, t.dblanglebracketright = 12299, t.dblanglebracketrightvertical = 65086, t.dblarchinvertedbelowcmb = 811, t.dblarrowleft = 8660, t.dblarrowright = 8658, t.dbldanda = 2405, t.dblgrave = 63190, t.dblgravecmb = 783, t.dblintegral = 8748, t.dbllowline = 8215, t.dbllowlinecmb = 819, t.dbloverlinecmb = 831, t.dblprimemod = 698, t.dblverticalbar = 8214, t.dblverticallineabovecmb = 782, t.dbopomofo = 12553, t.dbsquare = 13256, t.dcaron = 271, t.dcedilla = 7697, t.dcircle = 9427, t.dcircumflexbelow = 7699, t.dcroat = 273, t.ddabengali = 2465, t.ddadeva = 2337, t.ddagujarati = 2721, t.ddagurmukhi = 2593, t.ddalarabic = 1672, t.ddalfinalarabic = 64393, t.dddhadeva = 2396, t.ddhabengali = 2466, t.ddhadeva = 2338, t.ddhagujarati = 2722, t.ddhagurmukhi = 2594, t.ddotaccent = 7691, t.ddotbelow = 7693, t.decimalseparatorarabic = 1643, t.decimalseparatorpersian = 1643, t.decyrillic = 1076, t.degree = 176, t.dehihebrew = 1453, t.dehiragana = 12391, t.deicoptic = 1007, t.dekatakana = 12487, t.deleteleft = 9003, t.deleteright = 8998, t.delta = 948, t.deltaturned = 397, t.denominatorminusonenumeratorbengali = 2552, t.dezh = 676, t.dhabengali = 2471, t.dhadeva = 2343, t.dhagujarati = 2727, t.dhagurmukhi = 2599, t.dhook = 599, t.dialytikatonos = 901, t.dialytikatonoscmb = 836, t.diamond = 9830, t.diamondsuitwhite = 9826, t.dieresis = 168, t.dieresisacute = 63191, t.dieresisbelowcmb = 804, t.dieresiscmb = 776, t.dieresisgrave = 63192, t.dieresistonos = 901, t.dihiragana = 12386, t.dikatakana = 12482, t.dittomark = 12291, t.divide = 247, t.divides = 8739, t.divisionslash = 8725, t.djecyrillic = 1106, t.dkshade = 9619, t.dlinebelow = 7695, t.dlsquare = 13207, t.dmacron = 273, t.dmonospace = 65348, t.dnblock = 9604, t.dochadathai = 3598, t.dodekthai = 3604, t.dohiragana = 12393, t.dokatakana = 12489, t.dollar = 36, t.dollarinferior = 63203, t.dollarmonospace = 65284, t.dollaroldstyle = 63268, t.dollarsmall = 65129, t.dollarsuperior = 63204, t.dong = 8363, t.dorusquare = 13094, t.dotaccent = 729, t.dotaccentcmb = 775, t.dotbelowcmb = 803, t.dotbelowcomb = 803, t.dotkatakana = 12539, t.dotlessi = 305, t.dotlessj = 63166, t.dotlessjstrokehook = 644, t.dotmath = 8901, t.dottedcircle = 9676, t.doubleyodpatah = 64287, t.doubleyodpatahhebrew = 64287, t.downtackbelowcmb = 798, t.downtackmod = 725, t.dparen = 9375, t.dsuperior = 63211, t.dtail = 598, t.dtopbar = 396, t.duhiragana = 12389, t.dukatakana = 12485, t.dz = 499, t.dzaltone = 675, t.dzcaron = 454, t.dzcurl = 677, t.dzeabkhasiancyrillic = 1249, t.dzecyrillic = 1109, t.dzhecyrillic = 1119, t.e = 101, t.eacute = 233, t.earth = 9793, t.ebengali = 2447, t.ebopomofo = 12572, t.ebreve = 277, t.ecandradeva = 2317, t.ecandragujarati = 2701, t.ecandravowelsigndeva = 2373, t.ecandravowelsigngujarati = 2757, t.ecaron = 283, t.ecedillabreve = 7709, t.echarmenian = 1381, t.echyiwnarmenian = 1415, t.ecircle = 9428, t.ecircumflex = 234, t.ecircumflexacute = 7871, t.ecircumflexbelow = 7705, t.ecircumflexdotbelow = 7879, t.ecircumflexgrave = 7873, t.ecircumflexhookabove = 7875, t.ecircumflextilde = 7877, t.ecyrillic = 1108, t.edblgrave = 517, t.edeva = 2319, t.edieresis = 235, t.edot = 279, t.edotaccent = 279, t.edotbelow = 7865, t.eegurmukhi = 2575, t.eematragurmukhi = 2631, t.efcyrillic = 1092, t.egrave = 232, t.egujarati = 2703, t.eharmenian = 1383, t.ehbopomofo = 12573, t.ehiragana = 12360, t.ehookabove = 7867, t.eibopomofo = 12575, t.eight = 56, t.eightarabic = 1640, t.eightbengali = 2542, t.eightcircle = 9319, t.eightcircleinversesansserif = 10129, t.eightdeva = 2414, t.eighteencircle = 9329, t.eighteenparen = 9349, t.eighteenperiod = 9369, t.eightgujarati = 2798, t.eightgurmukhi = 2670, t.eighthackarabic = 1640, t.eighthangzhou = 12328, t.eighthnotebeamed = 9835, t.eightideographicparen = 12839, t.eightinferior = 8328, t.eightmonospace = 65304, t.eightoldstyle = 63288, t.eightparen = 9339, t.eightperiod = 9359, t.eightpersian = 1784, t.eightroman = 8567, t.eightsuperior = 8312, t.eightthai = 3672, t.einvertedbreve = 519, t.eiotifiedcyrillic = 1125, t.ekatakana = 12456, t.ekatakanahalfwidth = 65396, t.ekonkargurmukhi = 2676, t.ekorean = 12628, t.elcyrillic = 1083, t.element = 8712, t.elevencircle = 9322, t.elevenparen = 9342, t.elevenperiod = 9362, t.elevenroman = 8570, t.ellipsis = 8230, t.ellipsisvertical = 8942, t.emacron = 275, t.emacronacute = 7703, t.emacrongrave = 7701, t.emcyrillic = 1084, t.emdash = 8212, t.emdashvertical = 65073, t.emonospace = 65349, t.emphasismarkarmenian = 1371, t.emptyset = 8709, t.enbopomofo = 12579, t.encyrillic = 1085, t.endash = 8211, t.endashvertical = 65074, t.endescendercyrillic = 1187, t.eng = 331, t.engbopomofo = 12581, t.enghecyrillic = 1189, t.enhookcyrillic = 1224, t.enspace = 8194, t.eogonek = 281, t.eokorean = 12627, t.eopen = 603, t.eopenclosed = 666, t.eopenreversed = 604, t.eopenreversedclosed = 606, t.eopenreversedhook = 605, t.eparen = 9376, t.epsilon = 949, t.epsilontonos = 941, t.equal = 61, t.equalmonospace = 65309, t.equalsmall = 65126, t.equalsuperior = 8316, t.equivalence = 8801, t.erbopomofo = 12582, t.ercyrillic = 1088, t.ereversed = 600, t.ereversedcyrillic = 1101, t.escyrillic = 1089, t.esdescendercyrillic = 1195, t.esh = 643, t.eshcurl = 646, t.eshortdeva = 2318, t.eshortvowelsigndeva = 2374, t.eshreversedloop = 426, t.eshsquatreversed = 645, t.esmallhiragana = 12359, t.esmallkatakana = 12455, t.esmallkatakanahalfwidth = 65386, t.estimated = 8494, t.esuperior = 63212, t.eta = 951, t.etarmenian = 1384, t.etatonos = 942, t.eth = 240, t.etilde = 7869, t.etildebelow = 7707, t.etnahtafoukhhebrew = 1425, t.etnahtafoukhlefthebrew = 1425, t.etnahtahebrew = 1425, t.etnahtalefthebrew = 1425, t.eturned = 477, t.eukorean = 12641, t.euro = 8364, t.evowelsignbengali = 2503, t.evowelsigndeva = 2375, t.evowelsigngujarati = 2759, t.exclam = 33, t.exclamarmenian = 1372, t.exclamdbl = 8252, t.exclamdown = 161, t.exclamdownsmall = 63393, t.exclammonospace = 65281, t.exclamsmall = 63265, t.existential = 8707, t.ezh = 658, t.ezhcaron = 495, t.ezhcurl = 659, t.ezhreversed = 441, t.ezhtail = 442, t.f = 102, t.fadeva = 2398, t.fagurmukhi = 2654, t.fahrenheit = 8457, t.fathaarabic = 1614, t.fathalowarabic = 1614, t.fathatanarabic = 1611, t.fbopomofo = 12552, t.fcircle = 9429, t.fdotaccent = 7711, t.feharabic = 1601, t.feharmenian = 1414, t.fehfinalarabic = 65234, t.fehinitialarabic = 65235, t.fehmedialarabic = 65236, t.feicoptic = 997, t.female = 9792, t.ff = 64256, t.f_f = 64256, t.ffi = 64259, t.f_f_i = 64259, t.ffl = 64260, t.f_f_l = 64260, t.fi = 64257, t.f_i = 64257, t.fifteencircle = 9326, t.fifteenparen = 9346, t.fifteenperiod = 9366, t.figuredash = 8210, t.filledbox = 9632, t.filledrect = 9644, t.finalkaf = 1498, t.finalkafdagesh = 64314, t.finalkafdageshhebrew = 64314, t.finalkafhebrew = 1498, t.finalmem = 1501, t.finalmemhebrew = 1501, t.finalnun = 1503, t.finalnunhebrew = 1503, t.finalpe = 1507, t.finalpehebrew = 1507, t.finaltsadi = 1509, t.finaltsadihebrew = 1509, t.firsttonechinese = 713, t.fisheye = 9673, t.fitacyrillic = 1139, t.five = 53, t.fivearabic = 1637, t.fivebengali = 2539, t.fivecircle = 9316, t.fivecircleinversesansserif = 10126, t.fivedeva = 2411, t.fiveeighths = 8541, t.fivegujarati = 2795, t.fivegurmukhi = 2667, t.fivehackarabic = 1637, t.fivehangzhou = 12325, t.fiveideographicparen = 12836, t.fiveinferior = 8325, t.fivemonospace = 65301, t.fiveoldstyle = 63285, t.fiveparen = 9336, t.fiveperiod = 9356, t.fivepersian = 1781, t.fiveroman = 8564, t.fivesuperior = 8309, t.fivethai = 3669, t.fl = 64258, t.f_l = 64258, t.florin = 402, t.fmonospace = 65350, t.fmsquare = 13209, t.fofanthai = 3615, t.fofathai = 3613, t.fongmanthai = 3663, t.forall = 8704, t.four = 52, t.fourarabic = 1636, t.fourbengali = 2538, t.fourcircle = 9315, t.fourcircleinversesansserif = 10125, t.fourdeva = 2410, t.fourgujarati = 2794, t.fourgurmukhi = 2666, t.fourhackarabic = 1636, t.fourhangzhou = 12324, t.fourideographicparen = 12835, t.fourinferior = 8324, t.fourmonospace = 65300, t.fournumeratorbengali = 2551, t.fouroldstyle = 63284, t.fourparen = 9335, t.fourperiod = 9355, t.fourpersian = 1780, t.fourroman = 8563, t.foursuperior = 8308, t.fourteencircle = 9325, t.fourteenparen = 9345, t.fourteenperiod = 9365, t.fourthai = 3668, t.fourthtonechinese = 715, t.fparen = 9377, t.fraction = 8260, t.franc = 8355, t.g = 103, t.gabengali = 2455, t.gacute = 501, t.gadeva = 2327, t.gafarabic = 1711, t.gaffinalarabic = 64403, t.gafinitialarabic = 64404, t.gafmedialarabic = 64405, t.gagujarati = 2711, t.gagurmukhi = 2583, t.gahiragana = 12364, t.gakatakana = 12460, t.gamma = 947, t.gammalatinsmall = 611, t.gammasuperior = 736, t.gangiacoptic = 1003, t.gbopomofo = 12557, t.gbreve = 287, t.gcaron = 487, t.gcedilla = 291, t.gcircle = 9430, t.gcircumflex = 285, t.gcommaaccent = 291, t.gdot = 289, t.gdotaccent = 289, t.gecyrillic = 1075, t.gehiragana = 12370, t.gekatakana = 12466, t.geometricallyequal = 8785, t.gereshaccenthebrew = 1436, t.gereshhebrew = 1523, t.gereshmuqdamhebrew = 1437, t.germandbls = 223, t.gershayimaccenthebrew = 1438, t.gershayimhebrew = 1524, t.getamark = 12307, t.ghabengali = 2456, t.ghadarmenian = 1394, t.ghadeva = 2328, t.ghagujarati = 2712, t.ghagurmukhi = 2584, t.ghainarabic = 1594, t.ghainfinalarabic = 65230, t.ghaininitialarabic = 65231, t.ghainmedialarabic = 65232, t.ghemiddlehookcyrillic = 1173, t.ghestrokecyrillic = 1171, t.gheupturncyrillic = 1169, t.ghhadeva = 2394, t.ghhagurmukhi = 2650, t.ghook = 608, t.ghzsquare = 13203, t.gihiragana = 12366, t.gikatakana = 12462, t.gimarmenian = 1379, t.gimel = 1490, t.gimeldagesh = 64306, t.gimeldageshhebrew = 64306, t.gimelhebrew = 1490, t.gjecyrillic = 1107, t.glottalinvertedstroke = 446, t.glottalstop = 660, t.glottalstopinverted = 662, t.glottalstopmod = 704, t.glottalstopreversed = 661, t.glottalstopreversedmod = 705, t.glottalstopreversedsuperior = 740, t.glottalstopstroke = 673, t.glottalstopstrokereversed = 674, t.gmacron = 7713, t.gmonospace = 65351, t.gohiragana = 12372, t.gokatakana = 12468, t.gparen = 9378, t.gpasquare = 13228, t.gradient = 8711, t.grave = 96, t.gravebelowcmb = 790, t.gravecmb = 768, t.gravecomb = 768, t.gravedeva = 2387, t.gravelowmod = 718, t.gravemonospace = 65344, t.gravetonecmb = 832, t.greater = 62, t.greaterequal = 8805, t.greaterequalorless = 8923, t.greatermonospace = 65310, t.greaterorequivalent = 8819, t.greaterorless = 8823, t.greateroverequal = 8807, t.greatersmall = 65125, t.gscript = 609, t.gstroke = 485, t.guhiragana = 12368, t.guillemotleft = 171, t.guillemotright = 187, t.guilsinglleft = 8249, t.guilsinglright = 8250, t.gukatakana = 12464, t.guramusquare = 13080, t.gysquare = 13257, t.h = 104, t.haabkhasiancyrillic = 1193, t.haaltonearabic = 1729, t.habengali = 2489, t.hadescendercyrillic = 1203, t.hadeva = 2361, t.hagujarati = 2745, t.hagurmukhi = 2617, t.haharabic = 1581, t.hahfinalarabic = 65186, t.hahinitialarabic = 65187, t.hahiragana = 12399, t.hahmedialarabic = 65188, t.haitusquare = 13098, t.hakatakana = 12495, t.hakatakanahalfwidth = 65418, t.halantgurmukhi = 2637, t.hamzaarabic = 1569, t.hamzalowarabic = 1569, t.hangulfiller = 12644, t.hardsigncyrillic = 1098, t.harpoonleftbarbup = 8636, t.harpoonrightbarbup = 8640, t.hasquare = 13258, t.hatafpatah = 1458, t.hatafpatah16 = 1458, t.hatafpatah23 = 1458, t.hatafpatah2f = 1458, t.hatafpatahhebrew = 1458, t.hatafpatahnarrowhebrew = 1458, t.hatafpatahquarterhebrew = 1458, t.hatafpatahwidehebrew = 1458, t.hatafqamats = 1459, t.hatafqamats1b = 1459, t.hatafqamats28 = 1459, t.hatafqamats34 = 1459, t.hatafqamatshebrew = 1459, t.hatafqamatsnarrowhebrew = 1459, t.hatafqamatsquarterhebrew = 1459, t.hatafqamatswidehebrew = 1459, t.hatafsegol = 1457, t.hatafsegol17 = 1457, t.hatafsegol24 = 1457, t.hatafsegol30 = 1457, t.hatafsegolhebrew = 1457, t.hatafsegolnarrowhebrew = 1457, t.hatafsegolquarterhebrew = 1457, t.hatafsegolwidehebrew = 1457, t.hbar = 295, t.hbopomofo = 12559, t.hbrevebelow = 7723, t.hcedilla = 7721, t.hcircle = 9431, t.hcircumflex = 293, t.hdieresis = 7719, t.hdotaccent = 7715, t.hdotbelow = 7717, t.he = 1492, t.heart = 9829, t.heartsuitblack = 9829, t.heartsuitwhite = 9825, t.hedagesh = 64308, t.hedageshhebrew = 64308, t.hehaltonearabic = 1729, t.heharabic = 1607, t.hehebrew = 1492, t.hehfinalaltonearabic = 64423, t.hehfinalalttwoarabic = 65258, t.hehfinalarabic = 65258, t.hehhamzaabovefinalarabic = 64421, t.hehhamzaaboveisolatedarabic = 64420, t.hehinitialaltonearabic = 64424, t.hehinitialarabic = 65259, t.hehiragana = 12408, t.hehmedialaltonearabic = 64425, t.hehmedialarabic = 65260, t.heiseierasquare = 13179, t.hekatakana = 12504, t.hekatakanahalfwidth = 65421, t.hekutaarusquare = 13110, t.henghook = 615, t.herutusquare = 13113, t.het = 1495, t.hethebrew = 1495, t.hhook = 614, t.hhooksuperior = 689, t.hieuhacirclekorean = 12923, t.hieuhaparenkorean = 12827, t.hieuhcirclekorean = 12909, t.hieuhkorean = 12622, t.hieuhparenkorean = 12813, t.hihiragana = 12402, t.hikatakana = 12498, t.hikatakanahalfwidth = 65419, t.hiriq = 1460, t.hiriq14 = 1460, t.hiriq21 = 1460, t.hiriq2d = 1460, t.hiriqhebrew = 1460, t.hiriqnarrowhebrew = 1460, t.hiriqquarterhebrew = 1460, t.hiriqwidehebrew = 1460, t.hlinebelow = 7830, t.hmonospace = 65352, t.hoarmenian = 1392, t.hohipthai = 3627, t.hohiragana = 12411, t.hokatakana = 12507, t.hokatakanahalfwidth = 65422, t.holam = 1465, t.holam19 = 1465, t.holam26 = 1465, t.holam32 = 1465, t.holamhebrew = 1465, t.holamnarrowhebrew = 1465, t.holamquarterhebrew = 1465, t.holamwidehebrew = 1465, t.honokhukthai = 3630, t.hookabovecomb = 777, t.hookcmb = 777, t.hookpalatalizedbelowcmb = 801, t.hookretroflexbelowcmb = 802, t.hoonsquare = 13122, t.horicoptic = 1001, t.horizontalbar = 8213, t.horncmb = 795, t.hotsprings = 9832, t.house = 8962, t.hparen = 9379, t.hsuperior = 688, t.hturned = 613, t.huhiragana = 12405, t.huiitosquare = 13107, t.hukatakana = 12501, t.hukatakanahalfwidth = 65420, t.hungarumlaut = 733, t.hungarumlautcmb = 779, t.hv = 405, t.hyphen = 45, t.hypheninferior = 63205, t.hyphenmonospace = 65293, t.hyphensmall = 65123, t.hyphensuperior = 63206, t.hyphentwo = 8208, t.i = 105, t.iacute = 237, t.iacyrillic = 1103, t.ibengali = 2439, t.ibopomofo = 12583, t.ibreve = 301, t.icaron = 464, t.icircle = 9432, t.icircumflex = 238, t.icyrillic = 1110, t.idblgrave = 521, t.ideographearthcircle = 12943, t.ideographfirecircle = 12939, t.ideographicallianceparen = 12863, t.ideographiccallparen = 12858, t.ideographiccentrecircle = 12965, t.ideographicclose = 12294, t.ideographiccomma = 12289, t.ideographiccommaleft = 65380, t.ideographiccongratulationparen = 12855, t.ideographiccorrectcircle = 12963, t.ideographicearthparen = 12847, t.ideographicenterpriseparen = 12861, t.ideographicexcellentcircle = 12957, t.ideographicfestivalparen = 12864, t.ideographicfinancialcircle = 12950, t.ideographicfinancialparen = 12854, t.ideographicfireparen = 12843, t.ideographichaveparen = 12850, t.ideographichighcircle = 12964, t.ideographiciterationmark = 12293, t.ideographiclaborcircle = 12952, t.ideographiclaborparen = 12856, t.ideographicleftcircle = 12967, t.ideographiclowcircle = 12966, t.ideographicmedicinecircle = 12969, t.ideographicmetalparen = 12846, t.ideographicmoonparen = 12842, t.ideographicnameparen = 12852, t.ideographicperiod = 12290, t.ideographicprintcircle = 12958, t.ideographicreachparen = 12867, t.ideographicrepresentparen = 12857, t.ideographicresourceparen = 12862, t.ideographicrightcircle = 12968, t.ideographicsecretcircle = 12953, t.ideographicselfparen = 12866, t.ideographicsocietyparen = 12851, t.ideographicspace = 12288, t.ideographicspecialparen = 12853, t.ideographicstockparen = 12849, t.ideographicstudyparen = 12859, t.ideographicsunparen = 12848, t.ideographicsuperviseparen = 12860, t.ideographicwaterparen = 12844, t.ideographicwoodparen = 12845, t.ideographiczero = 12295, t.ideographmetalcircle = 12942, t.ideographmooncircle = 12938, t.ideographnamecircle = 12948, t.ideographsuncircle = 12944, t.ideographwatercircle = 12940, t.ideographwoodcircle = 12941, t.ideva = 2311, t.idieresis = 239, t.idieresisacute = 7727, t.idieresiscyrillic = 1253, t.idotbelow = 7883, t.iebrevecyrillic = 1239, t.iecyrillic = 1077, t.ieungacirclekorean = 12917, t.ieungaparenkorean = 12821, t.ieungcirclekorean = 12903, t.ieungkorean = 12615, t.ieungparenkorean = 12807, t.igrave = 236, t.igujarati = 2695, t.igurmukhi = 2567, t.ihiragana = 12356, t.ihookabove = 7881, t.iibengali = 2440, t.iicyrillic = 1080, t.iideva = 2312, t.iigujarati = 2696, t.iigurmukhi = 2568, t.iimatragurmukhi = 2624, t.iinvertedbreve = 523, t.iishortcyrillic = 1081, t.iivowelsignbengali = 2496, t.iivowelsigndeva = 2368, t.iivowelsigngujarati = 2752, t.ij = 307, t.ikatakana = 12452, t.ikatakanahalfwidth = 65394, t.ikorean = 12643, t.ilde = 732, t.iluyhebrew = 1452, t.imacron = 299, t.imacroncyrillic = 1251, t.imageorapproximatelyequal = 8787, t.imatragurmukhi = 2623, t.imonospace = 65353, t.increment = 8710, t.infinity = 8734, t.iniarmenian = 1387, t.integral = 8747, t.integralbottom = 8993, t.integralbt = 8993, t.integralex = 63733, t.integraltop = 8992, t.integraltp = 8992, t.intersection = 8745, t.intisquare = 13061, t.invbullet = 9688, t.invcircle = 9689, t.invsmileface = 9787, t.iocyrillic = 1105, t.iogonek = 303, t.iota = 953, t.iotadieresis = 970, t.iotadieresistonos = 912, t.iotalatin = 617, t.iotatonos = 943, t.iparen = 9380, t.irigurmukhi = 2674, t.ismallhiragana = 12355, t.ismallkatakana = 12451, t.ismallkatakanahalfwidth = 65384, t.issharbengali = 2554, t.istroke = 616, t.isuperior = 63213, t.iterationhiragana = 12445, t.iterationkatakana = 12541, t.itilde = 297, t.itildebelow = 7725, t.iubopomofo = 12585, t.iucyrillic = 1102, t.ivowelsignbengali = 2495, t.ivowelsigndeva = 2367, t.ivowelsigngujarati = 2751, t.izhitsacyrillic = 1141, t.izhitsadblgravecyrillic = 1143, t.j = 106, t.jaarmenian = 1393, t.jabengali = 2460, t.jadeva = 2332, t.jagujarati = 2716, t.jagurmukhi = 2588, t.jbopomofo = 12560, t.jcaron = 496, t.jcircle = 9433, t.jcircumflex = 309, t.jcrossedtail = 669, t.jdotlessstroke = 607, t.jecyrillic = 1112, t.jeemarabic = 1580, t.jeemfinalarabic = 65182, t.jeeminitialarabic = 65183, t.jeemmedialarabic = 65184, t.jeharabic = 1688, t.jehfinalarabic = 64395, t.jhabengali = 2461, t.jhadeva = 2333, t.jhagujarati = 2717, t.jhagurmukhi = 2589, t.jheharmenian = 1403, t.jis = 12292, t.jmonospace = 65354, t.jparen = 9381, t.jsuperior = 690, t.k = 107, t.kabashkircyrillic = 1185, t.kabengali = 2453, t.kacute = 7729, t.kacyrillic = 1082, t.kadescendercyrillic = 1179, t.kadeva = 2325, t.kaf = 1499, t.kafarabic = 1603, t.kafdagesh = 64315, t.kafdageshhebrew = 64315, t.kaffinalarabic = 65242, t.kafhebrew = 1499, t.kafinitialarabic = 65243, t.kafmedialarabic = 65244, t.kafrafehebrew = 64333, t.kagujarati = 2709, t.kagurmukhi = 2581, t.kahiragana = 12363, t.kahookcyrillic = 1220, t.kakatakana = 12459, t.kakatakanahalfwidth = 65398, t.kappa = 954, t.kappasymbolgreek = 1008, t.kapyeounmieumkorean = 12657, t.kapyeounphieuphkorean = 12676, t.kapyeounpieupkorean = 12664, t.kapyeounssangpieupkorean = 12665, t.karoriisquare = 13069, t.kashidaautoarabic = 1600, t.kashidaautonosidebearingarabic = 1600, t.kasmallkatakana = 12533, t.kasquare = 13188, t.kasraarabic = 1616, t.kasratanarabic = 1613, t.kastrokecyrillic = 1183, t.katahiraprolongmarkhalfwidth = 65392, t.kaverticalstrokecyrillic = 1181, t.kbopomofo = 12558, t.kcalsquare = 13193, t.kcaron = 489, t.kcedilla = 311, t.kcircle = 9434, t.kcommaaccent = 311, t.kdotbelow = 7731, t.keharmenian = 1412, t.kehiragana = 12369, t.kekatakana = 12465, t.kekatakanahalfwidth = 65401, t.kenarmenian = 1391, t.kesmallkatakana = 12534, t.kgreenlandic = 312, t.khabengali = 2454, t.khacyrillic = 1093, t.khadeva = 2326, t.khagujarati = 2710, t.khagurmukhi = 2582, t.khaharabic = 1582, t.khahfinalarabic = 65190, t.khahinitialarabic = 65191, t.khahmedialarabic = 65192, t.kheicoptic = 999, t.khhadeva = 2393, t.khhagurmukhi = 2649, t.khieukhacirclekorean = 12920, t.khieukhaparenkorean = 12824, t.khieukhcirclekorean = 12906, t.khieukhkorean = 12619, t.khieukhparenkorean = 12810, t.khokhaithai = 3586, t.khokhonthai = 3589, t.khokhuatthai = 3587, t.khokhwaithai = 3588, t.khomutthai = 3675, t.khook = 409, t.khorakhangthai = 3590, t.khzsquare = 13201, t.kihiragana = 12365, t.kikatakana = 12461, t.kikatakanahalfwidth = 65399, t.kiroguramusquare = 13077, t.kiromeetorusquare = 13078, t.kirosquare = 13076, t.kiyeokacirclekorean = 12910, t.kiyeokaparenkorean = 12814, t.kiyeokcirclekorean = 12896, t.kiyeokkorean = 12593, t.kiyeokparenkorean = 12800, t.kiyeoksioskorean = 12595, t.kjecyrillic = 1116, t.klinebelow = 7733, t.klsquare = 13208, t.kmcubedsquare = 13222, t.kmonospace = 65355, t.kmsquaredsquare = 13218, t.kohiragana = 12371, t.kohmsquare = 13248, t.kokaithai = 3585, t.kokatakana = 12467, t.kokatakanahalfwidth = 65402, t.kooposquare = 13086, t.koppacyrillic = 1153, t.koreanstandardsymbol = 12927, t.koroniscmb = 835, t.kparen = 9382, t.kpasquare = 13226, t.ksicyrillic = 1135, t.ktsquare = 13263, t.kturned = 670, t.kuhiragana = 12367, t.kukatakana = 12463, t.kukatakanahalfwidth = 65400, t.kvsquare = 13240, t.kwsquare = 13246, t.l = 108, t.labengali = 2482, t.lacute = 314, t.ladeva = 2354, t.lagujarati = 2738, t.lagurmukhi = 2610, t.lakkhangyaothai = 3653, t.lamaleffinalarabic = 65276, t.lamalefhamzaabovefinalarabic = 65272, t.lamalefhamzaaboveisolatedarabic = 65271, t.lamalefhamzabelowfinalarabic = 65274, t.lamalefhamzabelowisolatedarabic = 65273, t.lamalefisolatedarabic = 65275, t.lamalefmaddaabovefinalarabic = 65270, t.lamalefmaddaaboveisolatedarabic = 65269, t.lamarabic = 1604, t.lambda = 955, t.lambdastroke = 411, t.lamed = 1500, t.lameddagesh = 64316, t.lameddageshhebrew = 64316, t.lamedhebrew = 1500, t.lamfinalarabic = 65246, t.lamhahinitialarabic = 64714, t.laminitialarabic = 65247, t.lamjeeminitialarabic = 64713, t.lamkhahinitialarabic = 64715, t.lamlamhehisolatedarabic = 65010, t.lammedialarabic = 65248, t.lammeemhahinitialarabic = 64904, t.lammeeminitialarabic = 64716, t.largecircle = 9711, t.lbar = 410, t.lbelt = 620, t.lbopomofo = 12556, t.lcaron = 318, t.lcedilla = 316, t.lcircle = 9435, t.lcircumflexbelow = 7741, t.lcommaaccent = 316, t.ldot = 320, t.ldotaccent = 320, t.ldotbelow = 7735, t.ldotbelowmacron = 7737, t.leftangleabovecmb = 794, t.lefttackbelowcmb = 792, t.less = 60, t.lessequal = 8804, t.lessequalorgreater = 8922, t.lessmonospace = 65308, t.lessorequivalent = 8818, t.lessorgreater = 8822, t.lessoverequal = 8806, t.lesssmall = 65124, t.lezh = 622, t.lfblock = 9612, t.lhookretroflex = 621, t.lira = 8356, t.liwnarmenian = 1388, t.lj = 457, t.ljecyrillic = 1113, t.ll = 63168, t.lladeva = 2355, t.llagujarati = 2739, t.llinebelow = 7739, t.llladeva = 2356, t.llvocalicbengali = 2529, t.llvocalicdeva = 2401, t.llvocalicvowelsignbengali = 2531, t.llvocalicvowelsigndeva = 2403, t.lmiddletilde = 619, t.lmonospace = 65356, t.lmsquare = 13264, t.lochulathai = 3628, t.logicaland = 8743, t.logicalnot = 172, t.logicalnotreversed = 8976, t.logicalor = 8744, t.lolingthai = 3621, t.longs = 383, t.lowlinecenterline = 65102, t.lowlinecmb = 818, t.lowlinedashed = 65101, t.lozenge = 9674, t.lparen = 9383, t.lslash = 322, t.lsquare = 8467, t.lsuperior = 63214, t.ltshade = 9617, t.luthai = 3622, t.lvocalicbengali = 2444, t.lvocalicdeva = 2316, t.lvocalicvowelsignbengali = 2530, t.lvocalicvowelsigndeva = 2402, t.lxsquare = 13267, t.m = 109, t.mabengali = 2478, t.macron = 175, t.macronbelowcmb = 817, t.macroncmb = 772, t.macronlowmod = 717, t.macronmonospace = 65507, t.macute = 7743, t.madeva = 2350, t.magujarati = 2734, t.magurmukhi = 2606, t.mahapakhhebrew = 1444, t.mahapakhlefthebrew = 1444, t.mahiragana = 12414, t.maichattawalowleftthai = 63637, t.maichattawalowrightthai = 63636, t.maichattawathai = 3659, t.maichattawaupperleftthai = 63635, t.maieklowleftthai = 63628, t.maieklowrightthai = 63627, t.maiekthai = 3656, t.maiekupperleftthai = 63626, t.maihanakatleftthai = 63620, t.maihanakatthai = 3633, t.maitaikhuleftthai = 63625, t.maitaikhuthai = 3655, t.maitholowleftthai = 63631, t.maitholowrightthai = 63630, t.maithothai = 3657, t.maithoupperleftthai = 63629, t.maitrilowleftthai = 63634, t.maitrilowrightthai = 63633, t.maitrithai = 3658, t.maitriupperleftthai = 63632, t.maiyamokthai = 3654, t.makatakana = 12510, t.makatakanahalfwidth = 65423, t.male = 9794, t.mansyonsquare = 13127, t.maqafhebrew = 1470, t.mars = 9794, t.masoracirclehebrew = 1455, t.masquare = 13187, t.mbopomofo = 12551, t.mbsquare = 13268, t.mcircle = 9436, t.mcubedsquare = 13221, t.mdotaccent = 7745, t.mdotbelow = 7747, t.meemarabic = 1605, t.meemfinalarabic = 65250, t.meeminitialarabic = 65251, t.meemmedialarabic = 65252, t.meemmeeminitialarabic = 64721, t.meemmeemisolatedarabic = 64584, t.meetorusquare = 13133, t.mehiragana = 12417, t.meizierasquare = 13182, t.mekatakana = 12513, t.mekatakanahalfwidth = 65426, t.mem = 1502, t.memdagesh = 64318, t.memdageshhebrew = 64318, t.memhebrew = 1502, t.menarmenian = 1396, t.merkhahebrew = 1445, t.merkhakefulahebrew = 1446, t.merkhakefulalefthebrew = 1446, t.merkhalefthebrew = 1445, t.mhook = 625, t.mhzsquare = 13202, t.middledotkatakanahalfwidth = 65381, t.middot = 183, t.mieumacirclekorean = 12914, t.mieumaparenkorean = 12818, t.mieumcirclekorean = 12900, t.mieumkorean = 12609, t.mieumpansioskorean = 12656, t.mieumparenkorean = 12804, t.mieumpieupkorean = 12654, t.mieumsioskorean = 12655, t.mihiragana = 12415, t.mikatakana = 12511, t.mikatakanahalfwidth = 65424, t.minus = 8722, t.minusbelowcmb = 800, t.minuscircle = 8854, t.minusmod = 727, t.minusplus = 8723, t.minute = 8242, t.miribaarusquare = 13130, t.mirisquare = 13129, t.mlonglegturned = 624, t.mlsquare = 13206, t.mmcubedsquare = 13219, t.mmonospace = 65357, t.mmsquaredsquare = 13215, t.mohiragana = 12418, t.mohmsquare = 13249, t.mokatakana = 12514, t.mokatakanahalfwidth = 65427, t.molsquare = 13270, t.momathai = 3617, t.moverssquare = 13223, t.moverssquaredsquare = 13224, t.mparen = 9384, t.mpasquare = 13227, t.mssquare = 13235, t.msuperior = 63215, t.mturned = 623, t.mu = 181, t.mu1 = 181, t.muasquare = 13186, t.muchgreater = 8811, t.muchless = 8810, t.mufsquare = 13196, t.mugreek = 956, t.mugsquare = 13197, t.muhiragana = 12416, t.mukatakana = 12512, t.mukatakanahalfwidth = 65425, t.mulsquare = 13205, t.multiply = 215, t.mumsquare = 13211, t.munahhebrew = 1443, t.munahlefthebrew = 1443, t.musicalnote = 9834, t.musicalnotedbl = 9835, t.musicflatsign = 9837, t.musicsharpsign = 9839, t.mussquare = 13234, t.muvsquare = 13238, t.muwsquare = 13244, t.mvmegasquare = 13241, t.mvsquare = 13239, t.mwmegasquare = 13247, t.mwsquare = 13245, t.n = 110, t.nabengali = 2472, t.nabla = 8711, t.nacute = 324, t.nadeva = 2344, t.nagujarati = 2728, t.nagurmukhi = 2600, t.nahiragana = 12394, t.nakatakana = 12490, t.nakatakanahalfwidth = 65413, t.napostrophe = 329, t.nasquare = 13185, t.nbopomofo = 12555, t.nbspace = 160, t.ncaron = 328, t.ncedilla = 326, t.ncircle = 9437, t.ncircumflexbelow = 7755, t.ncommaaccent = 326, t.ndotaccent = 7749, t.ndotbelow = 7751, t.nehiragana = 12397, t.nekatakana = 12493, t.nekatakanahalfwidth = 65416, t.newsheqelsign = 8362, t.nfsquare = 13195, t.ngabengali = 2457, t.ngadeva = 2329, t.ngagujarati = 2713, t.ngagurmukhi = 2585, t.ngonguthai = 3591, t.nhiragana = 12435, t.nhookleft = 626, t.nhookretroflex = 627, t.nieunacirclekorean = 12911, t.nieunaparenkorean = 12815, t.nieuncieuckorean = 12597, t.nieuncirclekorean = 12897, t.nieunhieuhkorean = 12598, t.nieunkorean = 12596, t.nieunpansioskorean = 12648, t.nieunparenkorean = 12801, t.nieunsioskorean = 12647, t.nieuntikeutkorean = 12646, t.nihiragana = 12395, t.nikatakana = 12491, t.nikatakanahalfwidth = 65414, t.nikhahitleftthai = 63641, t.nikhahitthai = 3661, t.nine = 57, t.ninearabic = 1641, t.ninebengali = 2543, t.ninecircle = 9320, t.ninecircleinversesansserif = 10130, t.ninedeva = 2415, t.ninegujarati = 2799, t.ninegurmukhi = 2671, t.ninehackarabic = 1641, t.ninehangzhou = 12329, t.nineideographicparen = 12840, t.nineinferior = 8329, t.ninemonospace = 65305, t.nineoldstyle = 63289, t.nineparen = 9340, t.nineperiod = 9360, t.ninepersian = 1785, t.nineroman = 8568, t.ninesuperior = 8313, t.nineteencircle = 9330, t.nineteenparen = 9350, t.nineteenperiod = 9370, t.ninethai = 3673, t.nj = 460, t.njecyrillic = 1114, t.nkatakana = 12531, t.nkatakanahalfwidth = 65437, t.nlegrightlong = 414, t.nlinebelow = 7753, t.nmonospace = 65358, t.nmsquare = 13210, t.nnabengali = 2467, t.nnadeva = 2339, t.nnagujarati = 2723, t.nnagurmukhi = 2595, t.nnnadeva = 2345, t.nohiragana = 12398, t.nokatakana = 12494, t.nokatakanahalfwidth = 65417, t.nonbreakingspace = 160, t.nonenthai = 3603, t.nonuthai = 3609, t.noonarabic = 1606, t.noonfinalarabic = 65254, t.noonghunnaarabic = 1722, t.noonghunnafinalarabic = 64415, t.nooninitialarabic = 65255, t.noonjeeminitialarabic = 64722, t.noonjeemisolatedarabic = 64587, t.noonmedialarabic = 65256, t.noonmeeminitialarabic = 64725, t.noonmeemisolatedarabic = 64590, t.noonnoonfinalarabic = 64653, t.notcontains = 8716, t.notelement = 8713, t.notelementof = 8713, t.notequal = 8800, t.notgreater = 8815, t.notgreaternorequal = 8817, t.notgreaternorless = 8825, t.notidentical = 8802, t.notless = 8814, t.notlessnorequal = 8816, t.notparallel = 8742, t.notprecedes = 8832, t.notsubset = 8836, t.notsucceeds = 8833, t.notsuperset = 8837, t.nowarmenian = 1398, t.nparen = 9385, t.nssquare = 13233, t.nsuperior = 8319, t.ntilde = 241, t.nu = 957, t.nuhiragana = 12396, t.nukatakana = 12492, t.nukatakanahalfwidth = 65415, t.nuktabengali = 2492, t.nuktadeva = 2364, t.nuktagujarati = 2748, t.nuktagurmukhi = 2620, t.numbersign = 35, t.numbersignmonospace = 65283, t.numbersignsmall = 65119, t.numeralsigngreek = 884, t.numeralsignlowergreek = 885, t.numero = 8470, t.nun = 1504, t.nundagesh = 64320, t.nundageshhebrew = 64320, t.nunhebrew = 1504, t.nvsquare = 13237, t.nwsquare = 13243, t.nyabengali = 2462, t.nyadeva = 2334, t.nyagujarati = 2718, t.nyagurmukhi = 2590, t.o = 111, t.oacute = 243, t.oangthai = 3629, t.obarred = 629, t.obarredcyrillic = 1257, t.obarreddieresiscyrillic = 1259, t.obengali = 2451, t.obopomofo = 12571, t.obreve = 335, t.ocandradeva = 2321, t.ocandragujarati = 2705, t.ocandravowelsigndeva = 2377, t.ocandravowelsigngujarati = 2761, t.ocaron = 466, t.ocircle = 9438, t.ocircumflex = 244, t.ocircumflexacute = 7889, t.ocircumflexdotbelow = 7897, t.ocircumflexgrave = 7891, t.ocircumflexhookabove = 7893, t.ocircumflextilde = 7895, t.ocyrillic = 1086, t.odblacute = 337, t.odblgrave = 525, t.odeva = 2323, t.odieresis = 246, t.odieresiscyrillic = 1255, t.odotbelow = 7885, t.oe = 339, t.oekorean = 12634, t.ogonek = 731, t.ogonekcmb = 808, t.ograve = 242, t.ogujarati = 2707, t.oharmenian = 1413, t.ohiragana = 12362, t.ohookabove = 7887, t.ohorn = 417, t.ohornacute = 7899, t.ohorndotbelow = 7907, t.ohorngrave = 7901, t.ohornhookabove = 7903, t.ohorntilde = 7905, t.ohungarumlaut = 337, t.oi = 419, t.oinvertedbreve = 527, t.okatakana = 12458, t.okatakanahalfwidth = 65397, t.okorean = 12631, t.olehebrew = 1451, t.omacron = 333, t.omacronacute = 7763, t.omacrongrave = 7761, t.omdeva = 2384, t.omega = 969, t.omega1 = 982, t.omegacyrillic = 1121, t.omegalatinclosed = 631, t.omegaroundcyrillic = 1147, t.omegatitlocyrillic = 1149, t.omegatonos = 974, t.omgujarati = 2768, t.omicron = 959, t.omicrontonos = 972, t.omonospace = 65359, t.one = 49, t.onearabic = 1633, t.onebengali = 2535, t.onecircle = 9312, t.onecircleinversesansserif = 10122, t.onedeva = 2407, t.onedotenleader = 8228, t.oneeighth = 8539, t.onefitted = 63196, t.onegujarati = 2791, t.onegurmukhi = 2663, t.onehackarabic = 1633, t.onehalf = 189, t.onehangzhou = 12321, t.oneideographicparen = 12832, t.oneinferior = 8321, t.onemonospace = 65297, t.onenumeratorbengali = 2548, t.oneoldstyle = 63281, t.oneparen = 9332, t.oneperiod = 9352, t.onepersian = 1777, t.onequarter = 188, t.oneroman = 8560, t.onesuperior = 185, t.onethai = 3665, t.onethird = 8531, t.oogonek = 491, t.oogonekmacron = 493, t.oogurmukhi = 2579, t.oomatragurmukhi = 2635, t.oopen = 596, t.oparen = 9386, t.openbullet = 9702, t.option = 8997, t.ordfeminine = 170, t.ordmasculine = 186, t.orthogonal = 8735, t.oshortdeva = 2322, t.oshortvowelsigndeva = 2378, t.oslash = 248, t.oslashacute = 511, t.osmallhiragana = 12361, t.osmallkatakana = 12457, t.osmallkatakanahalfwidth = 65387, t.ostrokeacute = 511, t.osuperior = 63216, t.otcyrillic = 1151, t.otilde = 245, t.otildeacute = 7757, t.otildedieresis = 7759, t.oubopomofo = 12577, t.overline = 8254, t.overlinecenterline = 65098, t.overlinecmb = 773, t.overlinedashed = 65097, t.overlinedblwavy = 65100, t.overlinewavy = 65099, t.overscore = 175, t.ovowelsignbengali = 2507, t.ovowelsigndeva = 2379, t.ovowelsigngujarati = 2763, t.p = 112, t.paampssquare = 13184, t.paasentosquare = 13099, t.pabengali = 2474, t.pacute = 7765, t.padeva = 2346, t.pagedown = 8671, t.pageup = 8670, t.pagujarati = 2730, t.pagurmukhi = 2602, t.pahiragana = 12401, t.paiyannoithai = 3631, t.pakatakana = 12497, t.palatalizationcyrilliccmb = 1156, t.palochkacyrillic = 1216, t.pansioskorean = 12671, t.paragraph = 182, t.parallel = 8741, t.parenleft = 40, t.parenleftaltonearabic = 64830, t.parenleftbt = 63725, t.parenleftex = 63724, t.parenleftinferior = 8333, t.parenleftmonospace = 65288, t.parenleftsmall = 65113, t.parenleftsuperior = 8317, t.parenlefttp = 63723, t.parenleftvertical = 65077, t.parenright = 41, t.parenrightaltonearabic = 64831, t.parenrightbt = 63736, t.parenrightex = 63735, t.parenrightinferior = 8334, t.parenrightmonospace = 65289, t.parenrightsmall = 65114, t.parenrightsuperior = 8318, t.parenrighttp = 63734, t.parenrightvertical = 65078, t.partialdiff = 8706, t.paseqhebrew = 1472, t.pashtahebrew = 1433, t.pasquare = 13225, t.patah = 1463, t.patah11 = 1463, t.patah1d = 1463, t.patah2a = 1463, t.patahhebrew = 1463, t.patahnarrowhebrew = 1463, t.patahquarterhebrew = 1463, t.patahwidehebrew = 1463, t.pazerhebrew = 1441, t.pbopomofo = 12550, t.pcircle = 9439, t.pdotaccent = 7767, t.pe = 1508, t.pecyrillic = 1087, t.pedagesh = 64324, t.pedageshhebrew = 64324, t.peezisquare = 13115, t.pefinaldageshhebrew = 64323, t.peharabic = 1662, t.peharmenian = 1402, t.pehebrew = 1508, t.pehfinalarabic = 64343, t.pehinitialarabic = 64344, t.pehiragana = 12410, t.pehmedialarabic = 64345, t.pekatakana = 12506, t.pemiddlehookcyrillic = 1191, t.perafehebrew = 64334, t.percent = 37, t.percentarabic = 1642, t.percentmonospace = 65285, t.percentsmall = 65130, t.period = 46, t.periodarmenian = 1417, t.periodcentered = 183, t.periodhalfwidth = 65377, t.periodinferior = 63207, t.periodmonospace = 65294, t.periodsmall = 65106, t.periodsuperior = 63208, t.perispomenigreekcmb = 834, t.perpendicular = 8869, t.perthousand = 8240, t.peseta = 8359, t.pfsquare = 13194, t.phabengali = 2475, t.phadeva = 2347, t.phagujarati = 2731, t.phagurmukhi = 2603, t.phi = 966, t.phi1 = 981, t.phieuphacirclekorean = 12922, t.phieuphaparenkorean = 12826, t.phieuphcirclekorean = 12908, t.phieuphkorean = 12621, t.phieuphparenkorean = 12812, t.philatin = 632, t.phinthuthai = 3642, t.phisymbolgreek = 981, t.phook = 421, t.phophanthai = 3614, t.phophungthai = 3612, t.phosamphaothai = 3616, t.pi = 960, t.pieupacirclekorean = 12915, t.pieupaparenkorean = 12819, t.pieupcieuckorean = 12662, t.pieupcirclekorean = 12901, t.pieupkiyeokkorean = 12658, t.pieupkorean = 12610, t.pieupparenkorean = 12805, t.pieupsioskiyeokkorean = 12660, t.pieupsioskorean = 12612, t.pieupsiostikeutkorean = 12661, t.pieupthieuthkorean = 12663, t.pieuptikeutkorean = 12659, t.pihiragana = 12404, t.pikatakana = 12500, t.pisymbolgreek = 982, t.piwrarmenian = 1411, t.planckover2pi = 8463, t.planckover2pi1 = 8463, t.plus = 43, t.plusbelowcmb = 799, t.pluscircle = 8853, t.plusminus = 177, t.plusmod = 726, t.plusmonospace = 65291, t.plussmall = 65122, t.plussuperior = 8314, t.pmonospace = 65360, t.pmsquare = 13272, t.pohiragana = 12413, t.pointingindexdownwhite = 9759, t.pointingindexleftwhite = 9756, t.pointingindexrightwhite = 9758, t.pointingindexupwhite = 9757, t.pokatakana = 12509, t.poplathai = 3611, t.postalmark = 12306, t.postalmarkface = 12320, t.pparen = 9387, t.precedes = 8826, t.prescription = 8478, t.primemod = 697, t.primereversed = 8245, t.product = 8719, t.projective = 8965, t.prolongedkana = 12540, t.propellor = 8984, t.propersubset = 8834, t.propersuperset = 8835, t.proportion = 8759, t.proportional = 8733, t.psi = 968, t.psicyrillic = 1137, t.psilipneumatacyrilliccmb = 1158, t.pssquare = 13232, t.puhiragana = 12407, t.pukatakana = 12503, t.pvsquare = 13236, t.pwsquare = 13242, t.q = 113, t.qadeva = 2392, t.qadmahebrew = 1448, t.qafarabic = 1602, t.qaffinalarabic = 65238, t.qafinitialarabic = 65239, t.qafmedialarabic = 65240, t.qamats = 1464, t.qamats10 = 1464, t.qamats1a = 1464, t.qamats1c = 1464, t.qamats27 = 1464, t.qamats29 = 1464, t.qamats33 = 1464, t.qamatsde = 1464, t.qamatshebrew = 1464, t.qamatsnarrowhebrew = 1464, t.qamatsqatanhebrew = 1464, t.qamatsqatannarrowhebrew = 1464, t.qamatsqatanquarterhebrew = 1464, t.qamatsqatanwidehebrew = 1464, t.qamatsquarterhebrew = 1464, t.qamatswidehebrew = 1464, t.qarneyparahebrew = 1439, t.qbopomofo = 12561, t.qcircle = 9440, t.qhook = 672, t.qmonospace = 65361, t.qof = 1511, t.qofdagesh = 64327, t.qofdageshhebrew = 64327, t.qofhebrew = 1511, t.qparen = 9388, t.quarternote = 9833, t.qubuts = 1467, t.qubuts18 = 1467, t.qubuts25 = 1467, t.qubuts31 = 1467, t.qubutshebrew = 1467, t.qubutsnarrowhebrew = 1467, t.qubutsquarterhebrew = 1467, t.qubutswidehebrew = 1467, t.question = 63, t.questionarabic = 1567, t.questionarmenian = 1374, t.questiondown = 191, t.questiondownsmall = 63423, t.questiongreek = 894, t.questionmonospace = 65311, t.questionsmall = 63295, t.quotedbl = 34, t.quotedblbase = 8222, t.quotedblleft = 8220, t.quotedblmonospace = 65282, t.quotedblprime = 12318, t.quotedblprimereversed = 12317, t.quotedblright = 8221, t.quoteleft = 8216, t.quoteleftreversed = 8219, t.quotereversed = 8219, t.quoteright = 8217, t.quoterightn = 329, t.quotesinglbase = 8218, t.quotesingle = 39, t.quotesinglemonospace = 65287, t.r = 114, t.raarmenian = 1404, t.rabengali = 2480, t.racute = 341, t.radeva = 2352, t.radical = 8730, t.radicalex = 63717, t.radoverssquare = 13230, t.radoverssquaredsquare = 13231, t.radsquare = 13229, t.rafe = 1471, t.rafehebrew = 1471, t.ragujarati = 2736, t.ragurmukhi = 2608, t.rahiragana = 12425, t.rakatakana = 12521, t.rakatakanahalfwidth = 65431, t.ralowerdiagonalbengali = 2545, t.ramiddlediagonalbengali = 2544, t.ramshorn = 612, t.ratio = 8758, t.rbopomofo = 12566, t.rcaron = 345, t.rcedilla = 343, t.rcircle = 9441, t.rcommaaccent = 343, t.rdblgrave = 529, t.rdotaccent = 7769, t.rdotbelow = 7771, t.rdotbelowmacron = 7773, t.referencemark = 8251, t.reflexsubset = 8838, t.reflexsuperset = 8839, t.registered = 174, t.registersans = 63720, t.registerserif = 63194, t.reharabic = 1585, t.reharmenian = 1408, t.rehfinalarabic = 65198, t.rehiragana = 12428, t.rekatakana = 12524, t.rekatakanahalfwidth = 65434, t.resh = 1512, t.reshdageshhebrew = 64328, t.reshhebrew = 1512, t.reversedtilde = 8765, t.reviahebrew = 1431, t.reviamugrashhebrew = 1431, t.revlogicalnot = 8976, t.rfishhook = 638, t.rfishhookreversed = 639, t.rhabengali = 2525, t.rhadeva = 2397, t.rho = 961, t.rhook = 637, t.rhookturned = 635, t.rhookturnedsuperior = 693, t.rhosymbolgreek = 1009, t.rhotichookmod = 734, t.rieulacirclekorean = 12913, t.rieulaparenkorean = 12817, t.rieulcirclekorean = 12899, t.rieulhieuhkorean = 12608, t.rieulkiyeokkorean = 12602, t.rieulkiyeoksioskorean = 12649, t.rieulkorean = 12601, t.rieulmieumkorean = 12603, t.rieulpansioskorean = 12652, t.rieulparenkorean = 12803, t.rieulphieuphkorean = 12607, t.rieulpieupkorean = 12604, t.rieulpieupsioskorean = 12651, t.rieulsioskorean = 12605, t.rieulthieuthkorean = 12606, t.rieultikeutkorean = 12650, t.rieulyeorinhieuhkorean = 12653, t.rightangle = 8735, t.righttackbelowcmb = 793, t.righttriangle = 8895, t.rihiragana = 12426, t.rikatakana = 12522, t.rikatakanahalfwidth = 65432, t.ring = 730, t.ringbelowcmb = 805, t.ringcmb = 778, t.ringhalfleft = 703, t.ringhalfleftarmenian = 1369, t.ringhalfleftbelowcmb = 796, t.ringhalfleftcentered = 723, t.ringhalfright = 702, t.ringhalfrightbelowcmb = 825, t.ringhalfrightcentered = 722, t.rinvertedbreve = 531, t.rittorusquare = 13137, t.rlinebelow = 7775, t.rlongleg = 636, t.rlonglegturned = 634, t.rmonospace = 65362, t.rohiragana = 12429, t.rokatakana = 12525, t.rokatakanahalfwidth = 65435, t.roruathai = 3619, t.rparen = 9389, t.rrabengali = 2524, t.rradeva = 2353, t.rragurmukhi = 2652, t.rreharabic = 1681, t.rrehfinalarabic = 64397, t.rrvocalicbengali = 2528, t.rrvocalicdeva = 2400, t.rrvocalicgujarati = 2784, t.rrvocalicvowelsignbengali = 2500, t.rrvocalicvowelsigndeva = 2372, t.rrvocalicvowelsigngujarati = 2756, t.rsuperior = 63217, t.rtblock = 9616, t.rturned = 633, t.rturnedsuperior = 692, t.ruhiragana = 12427, t.rukatakana = 12523, t.rukatakanahalfwidth = 65433, t.rupeemarkbengali = 2546, t.rupeesignbengali = 2547, t.rupiah = 63197, t.ruthai = 3620, t.rvocalicbengali = 2443, t.rvocalicdeva = 2315, t.rvocalicgujarati = 2699, t.rvocalicvowelsignbengali = 2499, t.rvocalicvowelsigndeva = 2371, t.rvocalicvowelsigngujarati = 2755, t.s = 115, t.sabengali = 2488, t.sacute = 347, t.sacutedotaccent = 7781, t.sadarabic = 1589, t.sadeva = 2360, t.sadfinalarabic = 65210, t.sadinitialarabic = 65211, t.sadmedialarabic = 65212, t.sagujarati = 2744, t.sagurmukhi = 2616, t.sahiragana = 12373, t.sakatakana = 12469, t.sakatakanahalfwidth = 65403, t.sallallahoualayhewasallamarabic = 65018, t.samekh = 1505, t.samekhdagesh = 64321, t.samekhdageshhebrew = 64321, t.samekhhebrew = 1505, t.saraaathai = 3634, t.saraaethai = 3649, t.saraaimaimalaithai = 3652, t.saraaimaimuanthai = 3651, t.saraamthai = 3635, t.saraathai = 3632, t.saraethai = 3648, t.saraiileftthai = 63622, t.saraiithai = 3637, t.saraileftthai = 63621, t.saraithai = 3636, t.saraothai = 3650, t.saraueeleftthai = 63624, t.saraueethai = 3639, t.saraueleftthai = 63623, t.sarauethai = 3638, t.sarauthai = 3640, t.sarauuthai = 3641, t.sbopomofo = 12569, t.scaron = 353, t.scarondotaccent = 7783, t.scedilla = 351, t.schwa = 601, t.schwacyrillic = 1241, t.schwadieresiscyrillic = 1243, t.schwahook = 602, t.scircle = 9442, t.scircumflex = 349, t.scommaaccent = 537, t.sdotaccent = 7777, t.sdotbelow = 7779, t.sdotbelowdotaccent = 7785, t.seagullbelowcmb = 828, t.second = 8243, t.secondtonechinese = 714, t.section = 167, t.seenarabic = 1587, t.seenfinalarabic = 65202, t.seeninitialarabic = 65203, t.seenmedialarabic = 65204, t.segol = 1462, t.segol13 = 1462, t.segol1f = 1462, t.segol2c = 1462, t.segolhebrew = 1462, t.segolnarrowhebrew = 1462, t.segolquarterhebrew = 1462, t.segoltahebrew = 1426, t.segolwidehebrew = 1462, t.seharmenian = 1405, t.sehiragana = 12379, t.sekatakana = 12475, t.sekatakanahalfwidth = 65406, t.semicolon = 59, t.semicolonarabic = 1563, t.semicolonmonospace = 65307, t.semicolonsmall = 65108, t.semivoicedmarkkana = 12444, t.semivoicedmarkkanahalfwidth = 65439, t.sentisquare = 13090, t.sentosquare = 13091, t.seven = 55, t.sevenarabic = 1639, t.sevenbengali = 2541, t.sevencircle = 9318, t.sevencircleinversesansserif = 10128, t.sevendeva = 2413, t.seveneighths = 8542, t.sevengujarati = 2797, t.sevengurmukhi = 2669, t.sevenhackarabic = 1639, t.sevenhangzhou = 12327, t.sevenideographicparen = 12838, t.seveninferior = 8327, t.sevenmonospace = 65303, t.sevenoldstyle = 63287, t.sevenparen = 9338, t.sevenperiod = 9358, t.sevenpersian = 1783, t.sevenroman = 8566, t.sevensuperior = 8311, t.seventeencircle = 9328, t.seventeenparen = 9348, t.seventeenperiod = 9368, t.seventhai = 3671, t.sfthyphen = 173, t.shaarmenian = 1399, t.shabengali = 2486, t.shacyrillic = 1096, t.shaddaarabic = 1617, t.shaddadammaarabic = 64609, t.shaddadammatanarabic = 64606, t.shaddafathaarabic = 64608, t.shaddakasraarabic = 64610, t.shaddakasratanarabic = 64607, t.shade = 9618, t.shadedark = 9619, t.shadelight = 9617, t.shademedium = 9618, t.shadeva = 2358, t.shagujarati = 2742, t.shagurmukhi = 2614, t.shalshelethebrew = 1427, t.shbopomofo = 12565, t.shchacyrillic = 1097, t.sheenarabic = 1588, t.sheenfinalarabic = 65206, t.sheeninitialarabic = 65207, t.sheenmedialarabic = 65208, t.sheicoptic = 995, t.sheqel = 8362, t.sheqelhebrew = 8362, t.sheva = 1456, t.sheva115 = 1456, t.sheva15 = 1456, t.sheva22 = 1456, t.sheva2e = 1456, t.shevahebrew = 1456, t.shevanarrowhebrew = 1456, t.shevaquarterhebrew = 1456, t.shevawidehebrew = 1456, t.shhacyrillic = 1211, t.shimacoptic = 1005, t.shin = 1513, t.shindagesh = 64329, t.shindageshhebrew = 64329, t.shindageshshindot = 64300, t.shindageshshindothebrew = 64300, t.shindageshsindot = 64301, t.shindageshsindothebrew = 64301, t.shindothebrew = 1473, t.shinhebrew = 1513, t.shinshindot = 64298, t.shinshindothebrew = 64298, t.shinsindot = 64299, t.shinsindothebrew = 64299, t.shook = 642, t.sigma = 963, t.sigma1 = 962, t.sigmafinal = 962, t.sigmalunatesymbolgreek = 1010, t.sihiragana = 12375, t.sikatakana = 12471, t.sikatakanahalfwidth = 65404, t.siluqhebrew = 1469, t.siluqlefthebrew = 1469, t.similar = 8764, t.sindothebrew = 1474, t.siosacirclekorean = 12916, t.siosaparenkorean = 12820, t.sioscieuckorean = 12670, t.sioscirclekorean = 12902, t.sioskiyeokkorean = 12666, t.sioskorean = 12613, t.siosnieunkorean = 12667, t.siosparenkorean = 12806, t.siospieupkorean = 12669, t.siostikeutkorean = 12668, t.six = 54, t.sixarabic = 1638, t.sixbengali = 2540, t.sixcircle = 9317, t.sixcircleinversesansserif = 10127, t.sixdeva = 2412, t.sixgujarati = 2796, t.sixgurmukhi = 2668, t.sixhackarabic = 1638, t.sixhangzhou = 12326, t.sixideographicparen = 12837, t.sixinferior = 8326, t.sixmonospace = 65302, t.sixoldstyle = 63286, t.sixparen = 9337, t.sixperiod = 9357, t.sixpersian = 1782, t.sixroman = 8565, t.sixsuperior = 8310, t.sixteencircle = 9327, t.sixteencurrencydenominatorbengali = 2553, t.sixteenparen = 9347, t.sixteenperiod = 9367, t.sixthai = 3670, t.slash = 47, t.slashmonospace = 65295, t.slong = 383, t.slongdotaccent = 7835, t.smileface = 9786, t.smonospace = 65363, t.sofpasuqhebrew = 1475, t.softhyphen = 173, t.softsigncyrillic = 1100, t.sohiragana = 12381, t.sokatakana = 12477, t.sokatakanahalfwidth = 65407, t.soliduslongoverlaycmb = 824, t.solidusshortoverlaycmb = 823, t.sorusithai = 3625, t.sosalathai = 3624, t.sosothai = 3595, t.sosuathai = 3626, t.space = 32, t.spacehackarabic = 32, t.spade = 9824, t.spadesuitblack = 9824, t.spadesuitwhite = 9828, t.sparen = 9390, t.squarebelowcmb = 827, t.squarecc = 13252, t.squarecm = 13213, t.squarediagonalcrosshatchfill = 9641, t.squarehorizontalfill = 9636, t.squarekg = 13199, t.squarekm = 13214, t.squarekmcapital = 13262, t.squareln = 13265, t.squarelog = 13266, t.squaremg = 13198, t.squaremil = 13269, t.squaremm = 13212, t.squaremsquared = 13217, t.squareorthogonalcrosshatchfill = 9638, t.squareupperlefttolowerrightfill = 9639, t.squareupperrighttolowerleftfill = 9640, t.squareverticalfill = 9637, t.squarewhitewithsmallblack = 9635, t.srsquare = 13275, t.ssabengali = 2487, t.ssadeva = 2359, t.ssagujarati = 2743, t.ssangcieuckorean = 12617, t.ssanghieuhkorean = 12677, t.ssangieungkorean = 12672, t.ssangkiyeokkorean = 12594, t.ssangnieunkorean = 12645, t.ssangpieupkorean = 12611, t.ssangsioskorean = 12614, t.ssangtikeutkorean = 12600, t.ssuperior = 63218, t.sterling = 163, t.sterlingmonospace = 65505, t.strokelongoverlaycmb = 822, t.strokeshortoverlaycmb = 821, t.subset = 8834, t.subsetnotequal = 8842, t.subsetorequal = 8838, t.succeeds = 8827, t.suchthat = 8715, t.suhiragana = 12377, t.sukatakana = 12473, t.sukatakanahalfwidth = 65405, t.sukunarabic = 1618, t.summation = 8721, t.sun = 9788, t.superset = 8835, t.supersetnotequal = 8843, t.supersetorequal = 8839, t.svsquare = 13276, t.syouwaerasquare = 13180, t.t = 116, t.tabengali = 2468, t.tackdown = 8868, t.tackleft = 8867, t.tadeva = 2340, t.tagujarati = 2724, t.tagurmukhi = 2596, t.taharabic = 1591, t.tahfinalarabic = 65218, t.tahinitialarabic = 65219, t.tahiragana = 12383, t.tahmedialarabic = 65220, t.taisyouerasquare = 13181, t.takatakana = 12479, t.takatakanahalfwidth = 65408, t.tatweelarabic = 1600, t.tau = 964, t.tav = 1514, t.tavdages = 64330, t.tavdagesh = 64330, t.tavdageshhebrew = 64330, t.tavhebrew = 1514, t.tbar = 359, t.tbopomofo = 12554, t.tcaron = 357, t.tccurl = 680, t.tcedilla = 355, t.tcheharabic = 1670, t.tchehfinalarabic = 64379, t.tchehinitialarabic = 64380, t.tchehmedialarabic = 64381, t.tcircle = 9443, t.tcircumflexbelow = 7793, t.tcommaaccent = 355, t.tdieresis = 7831, t.tdotaccent = 7787, t.tdotbelow = 7789, t.tecyrillic = 1090, t.tedescendercyrillic = 1197, t.teharabic = 1578, t.tehfinalarabic = 65174, t.tehhahinitialarabic = 64674, t.tehhahisolatedarabic = 64524, t.tehinitialarabic = 65175, t.tehiragana = 12390, t.tehjeeminitialarabic = 64673, t.tehjeemisolatedarabic = 64523, t.tehmarbutaarabic = 1577, t.tehmarbutafinalarabic = 65172, t.tehmedialarabic = 65176, t.tehmeeminitialarabic = 64676, t.tehmeemisolatedarabic = 64526, t.tehnoonfinalarabic = 64627, t.tekatakana = 12486, t.tekatakanahalfwidth = 65411, t.telephone = 8481, t.telephoneblack = 9742, t.telishagedolahebrew = 1440, t.telishaqetanahebrew = 1449, t.tencircle = 9321, t.tenideographicparen = 12841, t.tenparen = 9341, t.tenperiod = 9361, t.tenroman = 8569, t.tesh = 679, t.tet = 1496, t.tetdagesh = 64312, t.tetdageshhebrew = 64312, t.tethebrew = 1496, t.tetsecyrillic = 1205, t.tevirhebrew = 1435, t.tevirlefthebrew = 1435, t.thabengali = 2469, t.thadeva = 2341, t.thagujarati = 2725, t.thagurmukhi = 2597, t.thalarabic = 1584, t.thalfinalarabic = 65196, t.thanthakhatlowleftthai = 63640, t.thanthakhatlowrightthai = 63639, t.thanthakhatthai = 3660, t.thanthakhatupperleftthai = 63638, t.theharabic = 1579, t.thehfinalarabic = 65178, t.thehinitialarabic = 65179, t.thehmedialarabic = 65180, t.thereexists = 8707, t.therefore = 8756, t.theta = 952, t.theta1 = 977, t.thetasymbolgreek = 977, t.thieuthacirclekorean = 12921, t.thieuthaparenkorean = 12825, t.thieuthcirclekorean = 12907, t.thieuthkorean = 12620, t.thieuthparenkorean = 12811, t.thirteencircle = 9324, t.thirteenparen = 9344, t.thirteenperiod = 9364, t.thonangmonthothai = 3601, t.thook = 429, t.thophuthaothai = 3602, t.thorn = 254, t.thothahanthai = 3607, t.thothanthai = 3600, t.thothongthai = 3608, t.thothungthai = 3606, t.thousandcyrillic = 1154, t.thousandsseparatorarabic = 1644, t.thousandsseparatorpersian = 1644, t.three = 51, t.threearabic = 1635, t.threebengali = 2537, t.threecircle = 9314, t.threecircleinversesansserif = 10124, t.threedeva = 2409, t.threeeighths = 8540, t.threegujarati = 2793, t.threegurmukhi = 2665, t.threehackarabic = 1635, t.threehangzhou = 12323, t.threeideographicparen = 12834, t.threeinferior = 8323, t.threemonospace = 65299, t.threenumeratorbengali = 2550, t.threeoldstyle = 63283, t.threeparen = 9334, t.threeperiod = 9354, t.threepersian = 1779, t.threequarters = 190, t.threequartersemdash = 63198, t.threeroman = 8562, t.threesuperior = 179, t.threethai = 3667, t.thzsquare = 13204, t.tihiragana = 12385, t.tikatakana = 12481, t.tikatakanahalfwidth = 65409, t.tikeutacirclekorean = 12912, t.tikeutaparenkorean = 12816, t.tikeutcirclekorean = 12898, t.tikeutkorean = 12599, t.tikeutparenkorean = 12802, t.tilde = 732, t.tildebelowcmb = 816, t.tildecmb = 771, t.tildecomb = 771, t.tildedoublecmb = 864, t.tildeoperator = 8764, t.tildeoverlaycmb = 820, t.tildeverticalcmb = 830, t.timescircle = 8855, t.tipehahebrew = 1430, t.tipehalefthebrew = 1430, t.tippigurmukhi = 2672, t.titlocyrilliccmb = 1155, t.tiwnarmenian = 1407, t.tlinebelow = 7791, t.tmonospace = 65364, t.toarmenian = 1385, t.tohiragana = 12392, t.tokatakana = 12488, t.tokatakanahalfwidth = 65412, t.tonebarextrahighmod = 741, t.tonebarextralowmod = 745, t.tonebarhighmod = 742, t.tonebarlowmod = 744, t.tonebarmidmod = 743, t.tonefive = 445, t.tonesix = 389, t.tonetwo = 424, t.tonos = 900, t.tonsquare = 13095, t.topatakthai = 3599, t.tortoiseshellbracketleft = 12308, t.tortoiseshellbracketleftsmall = 65117, t.tortoiseshellbracketleftvertical = 65081, t.tortoiseshellbracketright = 12309, t.tortoiseshellbracketrightsmall = 65118, t.tortoiseshellbracketrightvertical = 65082, t.totaothai = 3605, t.tpalatalhook = 427, t.tparen = 9391, t.trademark = 8482, t.trademarksans = 63722, t.trademarkserif = 63195, t.tretroflexhook = 648, t.triagdn = 9660, t.triaglf = 9668, t.triagrt = 9658, t.triagup = 9650, t.ts = 678, t.tsadi = 1510, t.tsadidagesh = 64326, t.tsadidageshhebrew = 64326, t.tsadihebrew = 1510, t.tsecyrillic = 1094, t.tsere = 1461, t.tsere12 = 1461, t.tsere1e = 1461, t.tsere2b = 1461, t.tserehebrew = 1461, t.tserenarrowhebrew = 1461, t.tserequarterhebrew = 1461, t.tserewidehebrew = 1461, t.tshecyrillic = 1115, t.tsuperior = 63219, t.ttabengali = 2463, t.ttadeva = 2335, t.ttagujarati = 2719, t.ttagurmukhi = 2591, t.tteharabic = 1657, t.ttehfinalarabic = 64359, t.ttehinitialarabic = 64360, t.ttehmedialarabic = 64361, t.tthabengali = 2464, t.tthadeva = 2336, t.tthagujarati = 2720, t.tthagurmukhi = 2592, t.tturned = 647, t.tuhiragana = 12388, t.tukatakana = 12484, t.tukatakanahalfwidth = 65410, t.tusmallhiragana = 12387, t.tusmallkatakana = 12483, t.tusmallkatakanahalfwidth = 65391, t.twelvecircle = 9323, t.twelveparen = 9343, t.twelveperiod = 9363, t.twelveroman = 8571, t.twentycircle = 9331, t.twentyhangzhou = 21316, t.twentyparen = 9351, t.twentyperiod = 9371, t.two = 50, t.twoarabic = 1634, t.twobengali = 2536, t.twocircle = 9313, t.twocircleinversesansserif = 10123, t.twodeva = 2408, t.twodotenleader = 8229, t.twodotleader = 8229, t.twodotleadervertical = 65072, t.twogujarati = 2792, t.twogurmukhi = 2664, t.twohackarabic = 1634, t.twohangzhou = 12322, t.twoideographicparen = 12833, t.twoinferior = 8322, t.twomonospace = 65298, t.twonumeratorbengali = 2549, t.twooldstyle = 63282, t.twoparen = 9333, t.twoperiod = 9353, t.twopersian = 1778, t.tworoman = 8561, t.twostroke = 443, t.twosuperior = 178, t.twothai = 3666, t.twothirds = 8532, t.u = 117, t.uacute = 250, t.ubar = 649, t.ubengali = 2441, t.ubopomofo = 12584, t.ubreve = 365, t.ucaron = 468, t.ucircle = 9444, t.ucircumflex = 251, t.ucircumflexbelow = 7799, t.ucyrillic = 1091, t.udattadeva = 2385, t.udblacute = 369, t.udblgrave = 533, t.udeva = 2313, t.udieresis = 252, t.udieresisacute = 472, t.udieresisbelow = 7795, t.udieresiscaron = 474, t.udieresiscyrillic = 1265, t.udieresisgrave = 476, t.udieresismacron = 470, t.udotbelow = 7909, t.ugrave = 249, t.ugujarati = 2697, t.ugurmukhi = 2569, t.uhiragana = 12358, t.uhookabove = 7911, t.uhorn = 432, t.uhornacute = 7913, t.uhorndotbelow = 7921, t.uhorngrave = 7915, t.uhornhookabove = 7917, t.uhorntilde = 7919, t.uhungarumlaut = 369, t.uhungarumlautcyrillic = 1267, t.uinvertedbreve = 535, t.ukatakana = 12454, t.ukatakanahalfwidth = 65395, t.ukcyrillic = 1145, t.ukorean = 12636, t.umacron = 363, t.umacroncyrillic = 1263, t.umacrondieresis = 7803, t.umatragurmukhi = 2625, t.umonospace = 65365, t.underscore = 95, t.underscoredbl = 8215, t.underscoremonospace = 65343, t.underscorevertical = 65075, t.underscorewavy = 65103, t.union = 8746, t.universal = 8704, t.uogonek = 371, t.uparen = 9392, t.upblock = 9600, t.upperdothebrew = 1476, t.upsilon = 965, t.upsilondieresis = 971, t.upsilondieresistonos = 944, t.upsilonlatin = 650, t.upsilontonos = 973, t.uptackbelowcmb = 797, t.uptackmod = 724, t.uragurmukhi = 2675, t.uring = 367, t.ushortcyrillic = 1118, t.usmallhiragana = 12357, t.usmallkatakana = 12453, t.usmallkatakanahalfwidth = 65385, t.ustraightcyrillic = 1199, t.ustraightstrokecyrillic = 1201, t.utilde = 361, t.utildeacute = 7801, t.utildebelow = 7797, t.uubengali = 2442, t.uudeva = 2314, t.uugujarati = 2698, t.uugurmukhi = 2570, t.uumatragurmukhi = 2626, t.uuvowelsignbengali = 2498, t.uuvowelsigndeva = 2370, t.uuvowelsigngujarati = 2754, t.uvowelsignbengali = 2497, t.uvowelsigndeva = 2369, t.uvowelsigngujarati = 2753, t.v = 118, t.vadeva = 2357, t.vagujarati = 2741, t.vagurmukhi = 2613, t.vakatakana = 12535, t.vav = 1493, t.vavdagesh = 64309, t.vavdagesh65 = 64309, t.vavdageshhebrew = 64309, t.vavhebrew = 1493, t.vavholam = 64331, t.vavholamhebrew = 64331, t.vavvavhebrew = 1520, t.vavyodhebrew = 1521, t.vcircle = 9445, t.vdotbelow = 7807, t.vecyrillic = 1074, t.veharabic = 1700, t.vehfinalarabic = 64363, t.vehinitialarabic = 64364, t.vehmedialarabic = 64365, t.vekatakana = 12537, t.venus = 9792, t.verticalbar = 124, t.verticallineabovecmb = 781, t.verticallinebelowcmb = 809, t.verticallinelowmod = 716, t.verticallinemod = 712, t.vewarmenian = 1406, t.vhook = 651, t.vikatakana = 12536, t.viramabengali = 2509, t.viramadeva = 2381, t.viramagujarati = 2765, t.visargabengali = 2435, t.visargadeva = 2307, t.visargagujarati = 2691, t.vmonospace = 65366, t.voarmenian = 1400, t.voicediterationhiragana = 12446, t.voicediterationkatakana = 12542, t.voicedmarkkana = 12443, t.voicedmarkkanahalfwidth = 65438, t.vokatakana = 12538, t.vparen = 9393, t.vtilde = 7805, t.vturned = 652, t.vuhiragana = 12436, t.vukatakana = 12532, t.w = 119, t.wacute = 7811, t.waekorean = 12633, t.wahiragana = 12431, t.wakatakana = 12527, t.wakatakanahalfwidth = 65436, t.wakorean = 12632, t.wasmallhiragana = 12430, t.wasmallkatakana = 12526, t.wattosquare = 13143, t.wavedash = 12316, t.wavyunderscorevertical = 65076, t.wawarabic = 1608, t.wawfinalarabic = 65262, t.wawhamzaabovearabic = 1572, t.wawhamzaabovefinalarabic = 65158, t.wbsquare = 13277, t.wcircle = 9446, t.wcircumflex = 373, t.wdieresis = 7813, t.wdotaccent = 7815, t.wdotbelow = 7817, t.wehiragana = 12433, t.weierstrass = 8472, t.wekatakana = 12529, t.wekorean = 12638, t.weokorean = 12637, t.wgrave = 7809, t.whitebullet = 9702, t.whitecircle = 9675, t.whitecircleinverse = 9689, t.whitecornerbracketleft = 12302, t.whitecornerbracketleftvertical = 65091, t.whitecornerbracketright = 12303, t.whitecornerbracketrightvertical = 65092, t.whitediamond = 9671, t.whitediamondcontainingblacksmalldiamond = 9672, t.whitedownpointingsmalltriangle = 9663, t.whitedownpointingtriangle = 9661, t.whiteleftpointingsmalltriangle = 9667, t.whiteleftpointingtriangle = 9665, t.whitelenticularbracketleft = 12310, t.whitelenticularbracketright = 12311, t.whiterightpointingsmalltriangle = 9657, t.whiterightpointingtriangle = 9655, t.whitesmallsquare = 9643, t.whitesmilingface = 9786, t.whitesquare = 9633, t.whitestar = 9734, t.whitetelephone = 9743, t.whitetortoiseshellbracketleft = 12312, t.whitetortoiseshellbracketright = 12313, t.whiteuppointingsmalltriangle = 9653, t.whiteuppointingtriangle = 9651, t.wihiragana = 12432, t.wikatakana = 12528, t.wikorean = 12639, t.wmonospace = 65367, t.wohiragana = 12434, t.wokatakana = 12530, t.wokatakanahalfwidth = 65382, t.won = 8361, t.wonmonospace = 65510, t.wowaenthai = 3623, t.wparen = 9394, t.wring = 7832, t.wsuperior = 695, t.wturned = 653, t.wynn = 447, t.x = 120, t.xabovecmb = 829, t.xbopomofo = 12562, t.xcircle = 9447, t.xdieresis = 7821, t.xdotaccent = 7819, t.xeharmenian = 1389, t.xi = 958, t.xmonospace = 65368, t.xparen = 9395, t.xsuperior = 739, t.y = 121, t.yaadosquare = 13134, t.yabengali = 2479, t.yacute = 253, t.yadeva = 2351, t.yaekorean = 12626, t.yagujarati = 2735, t.yagurmukhi = 2607, t.yahiragana = 12420, t.yakatakana = 12516, t.yakatakanahalfwidth = 65428, t.yakorean = 12625, t.yamakkanthai = 3662, t.yasmallhiragana = 12419, t.yasmallkatakana = 12515, t.yasmallkatakanahalfwidth = 65388, t.yatcyrillic = 1123, t.ycircle = 9448, t.ycircumflex = 375, t.ydieresis = 255, t.ydotaccent = 7823, t.ydotbelow = 7925, t.yeharabic = 1610, t.yehbarreearabic = 1746, t.yehbarreefinalarabic = 64431, t.yehfinalarabic = 65266, t.yehhamzaabovearabic = 1574, t.yehhamzaabovefinalarabic = 65162, t.yehhamzaaboveinitialarabic = 65163, t.yehhamzaabovemedialarabic = 65164, t.yehinitialarabic = 65267, t.yehmedialarabic = 65268, t.yehmeeminitialarabic = 64733, t.yehmeemisolatedarabic = 64600, t.yehnoonfinalarabic = 64660, t.yehthreedotsbelowarabic = 1745, t.yekorean = 12630, t.yen = 165, t.yenmonospace = 65509, t.yeokorean = 12629, t.yeorinhieuhkorean = 12678, t.yerahbenyomohebrew = 1450, t.yerahbenyomolefthebrew = 1450, t.yericyrillic = 1099, t.yerudieresiscyrillic = 1273, t.yesieungkorean = 12673, t.yesieungpansioskorean = 12675, t.yesieungsioskorean = 12674, t.yetivhebrew = 1434, t.ygrave = 7923, t.yhook = 436, t.yhookabove = 7927, t.yiarmenian = 1397, t.yicyrillic = 1111, t.yikorean = 12642, t.yinyang = 9775, t.yiwnarmenian = 1410, t.ymonospace = 65369, t.yod = 1497, t.yoddagesh = 64313, t.yoddageshhebrew = 64313, t.yodhebrew = 1497, t.yodyodhebrew = 1522, t.yodyodpatahhebrew = 64287, t.yohiragana = 12424, t.yoikorean = 12681, t.yokatakana = 12520, t.yokatakanahalfwidth = 65430, t.yokorean = 12635, t.yosmallhiragana = 12423, t.yosmallkatakana = 12519, t.yosmallkatakanahalfwidth = 65390, t.yotgreek = 1011, t.yoyaekorean = 12680, t.yoyakorean = 12679, t.yoyakthai = 3618, t.yoyingthai = 3597, t.yparen = 9396, t.ypogegrammeni = 890, t.ypogegrammenigreekcmb = 837, t.yr = 422, t.yring = 7833, t.ysuperior = 696, t.ytilde = 7929, t.yturned = 654, t.yuhiragana = 12422, t.yuikorean = 12684, t.yukatakana = 12518, t.yukatakanahalfwidth = 65429, t.yukorean = 12640, t.yusbigcyrillic = 1131, t.yusbigiotifiedcyrillic = 1133, t.yuslittlecyrillic = 1127, t.yuslittleiotifiedcyrillic = 1129, t.yusmallhiragana = 12421, t.yusmallkatakana = 12517, t.yusmallkatakanahalfwidth = 65389, t.yuyekorean = 12683, t.yuyeokorean = 12682, t.yyabengali = 2527, t.yyadeva = 2399, t.z = 122, t.zaarmenian = 1382, t.zacute = 378, t.zadeva = 2395, t.zagurmukhi = 2651, t.zaharabic = 1592, t.zahfinalarabic = 65222, t.zahinitialarabic = 65223, t.zahiragana = 12374, t.zahmedialarabic = 65224, t.zainarabic = 1586, t.zainfinalarabic = 65200, t.zakatakana = 12470, t.zaqefgadolhebrew = 1429, t.zaqefqatanhebrew = 1428, t.zarqahebrew = 1432, t.zayin = 1494, t.zayindagesh = 64310, t.zayindageshhebrew = 64310, t.zayinhebrew = 1494, t.zbopomofo = 12567, t.zcaron = 382, t.zcircle = 9449, t.zcircumflex = 7825, t.zcurl = 657, t.zdot = 380, t.zdotaccent = 380, t.zdotbelow = 7827, t.zecyrillic = 1079, t.zedescendercyrillic = 1177, t.zedieresiscyrillic = 1247, t.zehiragana = 12380, t.zekatakana = 12476, t.zero = 48, t.zeroarabic = 1632, t.zerobengali = 2534, t.zerodeva = 2406, t.zerogujarati = 2790, t.zerogurmukhi = 2662, t.zerohackarabic = 1632, t.zeroinferior = 8320, t.zeromonospace = 65296, t.zerooldstyle = 63280, t.zeropersian = 1776, t.zerosuperior = 8304, t.zerothai = 3664, t.zerowidthjoiner = 65279, t.zerowidthnonjoiner = 8204, t.zerowidthspace = 8203, t.zeta = 950, t.zhbopomofo = 12563, t.zhearmenian = 1386, t.zhebrevecyrillic = 1218, t.zhecyrillic = 1078, t.zhedescendercyrillic = 1175, t.zhedieresiscyrillic = 1245, t.zihiragana = 12376, t.zikatakana = 12472, t.zinorhebrew = 1454, t.zlinebelow = 7829, t.zmonospace = 65370, t.zohiragana = 12382, t.zokatakana = 12478, t.zparen = 9397, t.zretroflexhook = 656, t.zstroke = 438, t.zuhiragana = 12378, t.zukatakana = 12474, t[".notdef"] = 0, t.angbracketleftbig = 9001, t.angbracketleftBig = 9001, t.angbracketleftbigg = 9001, t.angbracketleftBigg = 9001, t.angbracketrightBig = 9002, t.angbracketrightbig = 9002, t.angbracketrightBigg = 9002, t.angbracketrightbigg = 9002, t.arrowhookleft = 8618, t.arrowhookright = 8617, t.arrowlefttophalf = 8636, t.arrowleftbothalf = 8637, t.arrownortheast = 8599, t.arrownorthwest = 8598, t.arrowrighttophalf = 8640, t.arrowrightbothalf = 8641, t.arrowsoutheast = 8600, t.arrowsouthwest = 8601, t.backslashbig = 8726, t.backslashBig = 8726, t.backslashBigg = 8726, t.backslashbigg = 8726, t.bardbl = 8214, t.bracehtipdownleft = 65079, t.bracehtipdownright = 65079, t.bracehtipupleft = 65080, t.bracehtipupright = 65080, t.braceleftBig = 123, t.braceleftbig = 123, t.braceleftbigg = 123, t.braceleftBigg = 123, t.bracerightBig = 125, t.bracerightbig = 125, t.bracerightbigg = 125, t.bracerightBigg = 125, t.bracketleftbig = 91, t.bracketleftBig = 91, t.bracketleftbigg = 91, t.bracketleftBigg = 91, t.bracketrightBig = 93, t.bracketrightbig = 93, t.bracketrightbigg = 93, t.bracketrightBigg = 93, t.ceilingleftbig = 8968, t.ceilingleftBig = 8968, t.ceilingleftBigg = 8968, t.ceilingleftbigg = 8968, t.ceilingrightbig = 8969, t.ceilingrightBig = 8969, t.ceilingrightbigg = 8969, t.ceilingrightBigg = 8969, t.circledotdisplay = 8857, t.circledottext = 8857, t.circlemultiplydisplay = 8855, t.circlemultiplytext = 8855, t.circleplusdisplay = 8853, t.circleplustext = 8853, t.contintegraldisplay = 8750, t.contintegraltext = 8750, t.coproductdisplay = 8720, t.coproducttext = 8720, t.floorleftBig = 8970, t.floorleftbig = 8970, t.floorleftbigg = 8970, t.floorleftBigg = 8970, t.floorrightbig = 8971, t.floorrightBig = 8971, t.floorrightBigg = 8971, t.floorrightbigg = 8971, t.hatwide = 770, t.hatwider = 770, t.hatwidest = 770, t.intercal = 7488, t.integraldisplay = 8747, t.integraltext = 8747, t.intersectiondisplay = 8898, t.intersectiontext = 8898, t.logicalanddisplay = 8743, t.logicalandtext = 8743, t.logicalordisplay = 8744, t.logicalortext = 8744, t.parenleftBig = 40, t.parenleftbig = 40, t.parenleftBigg = 40, t.parenleftbigg = 40, t.parenrightBig = 41, t.parenrightbig = 41, t.parenrightBigg = 41, t.parenrightbigg = 41, t.prime = 8242, t.productdisplay = 8719, t.producttext = 8719, t.radicalbig = 8730, t.radicalBig = 8730, t.radicalBigg = 8730, t.radicalbigg = 8730, t.radicalbt = 8730, t.radicaltp = 8730, t.radicalvertex = 8730, t.slashbig = 47, t.slashBig = 47, t.slashBigg = 47, t.slashbigg = 47, t.summationdisplay = 8721, t.summationtext = 8721, t.tildewide = 732, t.tildewider = 732, t.tildewidest = 732, t.uniondisplay = 8899, t.unionmultidisplay = 8846, t.unionmultitext = 8846, t.unionsqdisplay = 8852, t.unionsqtext = 8852, t.uniontext = 8899, t.vextenddouble = 8741, t.vextendsingle = 8739;
          });
          c.getGlyphsUnicode = h;
          const g = (0, s.getLookupTableFactory)(function(t) {
            t.space = 32, t.a1 = 9985, t.a2 = 9986, t.a202 = 9987, t.a3 = 9988, t.a4 = 9742, t.a5 = 9990, t.a119 = 9991, t.a118 = 9992, t.a117 = 9993, t.a11 = 9755, t.a12 = 9758, t.a13 = 9996, t.a14 = 9997, t.a15 = 9998, t.a16 = 9999, t.a105 = 1e4, t.a17 = 10001, t.a18 = 10002, t.a19 = 10003, t.a20 = 10004, t.a21 = 10005, t.a22 = 10006, t.a23 = 10007, t.a24 = 10008, t.a25 = 10009, t.a26 = 10010, t.a27 = 10011, t.a28 = 10012, t.a6 = 10013, t.a7 = 10014, t.a8 = 10015, t.a9 = 10016, t.a10 = 10017, t.a29 = 10018, t.a30 = 10019, t.a31 = 10020, t.a32 = 10021, t.a33 = 10022, t.a34 = 10023, t.a35 = 9733, t.a36 = 10025, t.a37 = 10026, t.a38 = 10027, t.a39 = 10028, t.a40 = 10029, t.a41 = 10030, t.a42 = 10031, t.a43 = 10032, t.a44 = 10033, t.a45 = 10034, t.a46 = 10035, t.a47 = 10036, t.a48 = 10037, t.a49 = 10038, t.a50 = 10039, t.a51 = 10040, t.a52 = 10041, t.a53 = 10042, t.a54 = 10043, t.a55 = 10044, t.a56 = 10045, t.a57 = 10046, t.a58 = 10047, t.a59 = 10048, t.a60 = 10049, t.a61 = 10050, t.a62 = 10051, t.a63 = 10052, t.a64 = 10053, t.a65 = 10054, t.a66 = 10055, t.a67 = 10056, t.a68 = 10057, t.a69 = 10058, t.a70 = 10059, t.a71 = 9679, t.a72 = 10061, t.a73 = 9632, t.a74 = 10063, t.a203 = 10064, t.a75 = 10065, t.a204 = 10066, t.a76 = 9650, t.a77 = 9660, t.a78 = 9670, t.a79 = 10070, t.a81 = 9687, t.a82 = 10072, t.a83 = 10073, t.a84 = 10074, t.a97 = 10075, t.a98 = 10076, t.a99 = 10077, t.a100 = 10078, t.a101 = 10081, t.a102 = 10082, t.a103 = 10083, t.a104 = 10084, t.a106 = 10085, t.a107 = 10086, t.a108 = 10087, t.a112 = 9827, t.a111 = 9830, t.a110 = 9829, t.a109 = 9824, t.a120 = 9312, t.a121 = 9313, t.a122 = 9314, t.a123 = 9315, t.a124 = 9316, t.a125 = 9317, t.a126 = 9318, t.a127 = 9319, t.a128 = 9320, t.a129 = 9321, t.a130 = 10102, t.a131 = 10103, t.a132 = 10104, t.a133 = 10105, t.a134 = 10106, t.a135 = 10107, t.a136 = 10108, t.a137 = 10109, t.a138 = 10110, t.a139 = 10111, t.a140 = 10112, t.a141 = 10113, t.a142 = 10114, t.a143 = 10115, t.a144 = 10116, t.a145 = 10117, t.a146 = 10118, t.a147 = 10119, t.a148 = 10120, t.a149 = 10121, t.a150 = 10122, t.a151 = 10123, t.a152 = 10124, t.a153 = 10125, t.a154 = 10126, t.a155 = 10127, t.a156 = 10128, t.a157 = 10129, t.a158 = 10130, t.a159 = 10131, t.a160 = 10132, t.a161 = 8594, t.a163 = 8596, t.a164 = 8597, t.a196 = 10136, t.a165 = 10137, t.a192 = 10138, t.a166 = 10139, t.a167 = 10140, t.a168 = 10141, t.a169 = 10142, t.a170 = 10143, t.a171 = 10144, t.a172 = 10145, t.a173 = 10146, t.a162 = 10147, t.a174 = 10148, t.a175 = 10149, t.a176 = 10150, t.a177 = 10151, t.a178 = 10152, t.a179 = 10153, t.a193 = 10154, t.a180 = 10155, t.a199 = 10156, t.a181 = 10157, t.a200 = 10158, t.a182 = 10159, t.a201 = 10161, t.a183 = 10162, t.a184 = 10163, t.a197 = 10164, t.a185 = 10165, t.a194 = 10166, t.a198 = 10167, t.a186 = 10168, t.a195 = 10169, t.a187 = 10170, t.a188 = 10171, t.a189 = 10172, t.a190 = 10173, t.a191 = 10174, t.a89 = 10088, t.a90 = 10089, t.a93 = 10090, t.a94 = 10091, t.a91 = 10092, t.a92 = 10093, t.a205 = 10094, t.a85 = 10095, t.a206 = 10096, t.a86 = 10097, t.a87 = 10098, t.a88 = 10099, t.a95 = 10100, t.a96 = 10101, t[".notdef"] = 0;
          });
          c.getDingbatsGlyphsUnicode = g;
        },
        /* 40 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.clearUnicodeCaches = y, c.getCharUnicodeCategory = S, c.getUnicodeForGlyph = t, c.getUnicodeRangeFor = m, c.mapSpecialUnicodeValues = g;
          var s = f(3);
          const h = (0, s.getLookupTableFactory)(function(x) {
            x[63721] = 169, x[63193] = 169, x[63720] = 174, x[63194] = 174, x[63722] = 8482, x[63195] = 8482, x[63729] = 9127, x[63730] = 9128, x[63731] = 9129, x[63740] = 9131, x[63741] = 9132, x[63742] = 9133, x[63726] = 9121, x[63727] = 9122, x[63728] = 9123, x[63737] = 9124, x[63738] = 9125, x[63739] = 9126, x[63723] = 9115, x[63724] = 9116, x[63725] = 9117, x[63734] = 9118, x[63735] = 9119, x[63736] = 9120;
          });
          function g(x) {
            return x >= 65520 && x <= 65535 ? 0 : x >= 62976 && x <= 63743 ? h()[x] || x : x === 173 ? 45 : x;
          }
          function t(x, b) {
            let u = b[x];
            if (u !== void 0)
              return u;
            if (!x)
              return -1;
            if (x[0] === "u") {
              const I = x.length;
              let O;
              if (I === 7 && x[1] === "n" && x[2] === "i")
                O = x.substring(3);
              else if (I >= 5 && I <= 7)
                O = x.substring(1);
              else
                return -1;
              if (O === O.toUpperCase() && (u = parseInt(O, 16), u >= 0))
                return u;
            }
            return -1;
          }
          const i = [[0, 127], [128, 255], [256, 383], [384, 591], [592, 687, 7424, 7551, 7552, 7615], [688, 767, 42752, 42783], [768, 879, 7616, 7679], [880, 1023], [11392, 11519], [1024, 1279, 1280, 1327, 11744, 11775, 42560, 42655], [1328, 1423], [1424, 1535], [42240, 42559], [1536, 1791, 1872, 1919], [1984, 2047], [2304, 2431], [2432, 2559], [2560, 2687], [2688, 2815], [2816, 2943], [2944, 3071], [3072, 3199], [3200, 3327], [3328, 3455], [3584, 3711], [3712, 3839], [4256, 4351, 11520, 11567], [6912, 7039], [4352, 4607], [7680, 7935, 11360, 11391, 42784, 43007], [7936, 8191], [8192, 8303, 11776, 11903], [8304, 8351], [8352, 8399], [8400, 8447], [8448, 8527], [8528, 8591], [8592, 8703, 10224, 10239, 10496, 10623, 11008, 11263], [8704, 8959, 10752, 11007, 10176, 10223, 10624, 10751], [8960, 9215], [9216, 9279], [9280, 9311], [9312, 9471], [9472, 9599], [9600, 9631], [9632, 9727], [9728, 9983], [9984, 10175], [12288, 12351], [12352, 12447], [12448, 12543, 12784, 12799], [12544, 12591, 12704, 12735], [12592, 12687], [43072, 43135], [12800, 13055], [13056, 13311], [44032, 55215], [55296, 57343], [67840, 67871], [19968, 40959, 11904, 12031, 12032, 12255, 12272, 12287, 13312, 19903, 131072, 173791, 12688, 12703], [57344, 63743], [12736, 12783, 63744, 64255, 194560, 195103], [64256, 64335], [64336, 65023], [65056, 65071], [65040, 65055], [65104, 65135], [65136, 65279], [65280, 65519], [65520, 65535], [3840, 4095], [1792, 1871], [1920, 1983], [3456, 3583], [4096, 4255], [4608, 4991, 4992, 5023, 11648, 11743], [5024, 5119], [5120, 5759], [5760, 5791], [5792, 5887], [6016, 6143], [6144, 6319], [10240, 10495], [40960, 42127], [5888, 5919, 5920, 5951, 5952, 5983, 5984, 6015], [66304, 66351], [66352, 66383], [66560, 66639], [118784, 119039, 119040, 119295, 119296, 119375], [119808, 120831], [1044480, 1048573], [65024, 65039, 917760, 917999], [917504, 917631], [6400, 6479], [6480, 6527], [6528, 6623], [6656, 6687], [11264, 11359], [11568, 11647], [19904, 19967], [43008, 43055], [65536, 65663, 65664, 65791, 65792, 65855], [65856, 65935], [66432, 66463], [66464, 66527], [66640, 66687], [66688, 66735], [67584, 67647], [68096, 68191], [119552, 119647], [73728, 74751, 74752, 74879], [119648, 119679], [7040, 7103], [7168, 7247], [7248, 7295], [43136, 43231], [43264, 43311], [43312, 43359], [43520, 43615], [65936, 65999], [66e3, 66047], [66208, 66271, 66176, 66207, 67872, 67903], [127024, 127135, 126976, 127023]];
          function m(x, b = -1) {
            if (b !== -1) {
              const u = i[b];
              for (let I = 0, O = u.length; I < O; I += 2)
                if (x >= u[I] && x <= u[I + 1])
                  return b;
            }
            for (let u = 0, I = i.length; u < I; u++) {
              const O = i[u];
              for (let D = 0, $ = O.length; D < $; D += 2)
                if (x >= O[D] && x <= O[D + 1])
                  return u;
            }
            return -1;
          }
          const v = new RegExp("^(\\s)|(\\p{Mn})|(\\p{Cf})$", "u"), E = /* @__PURE__ */ new Map();
          function S(x) {
            const b = E.get(x);
            if (b)
              return b;
            const u = x.match(v), I = {
              isWhitespace: !!(u != null && u[1]),
              isZeroWidthDiacritic: !!(u != null && u[2]),
              isInvisibleFormatMark: !!(u != null && u[3])
            };
            return E.set(x, I), I;
          }
          function y() {
            E.clear();
          }
        },
        /* 41 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.getSerifFonts = c.getNonStdFontMap = c.getGlyphMapForStandardFonts = c.getFontNameToFileMap = void 0, c.getStandardFontName = x, c.getSymbolsFonts = c.getSupplementalGlyphMapForCalibri = c.getSupplementalGlyphMapForArialBlack = c.getStdFontMap = void 0, c.isKnownFontName = b;
          var s = f(3), h = f(38);
          const g = (0, s.getLookupTableFactory)(function(u) {
            u["Times-Roman"] = "Times-Roman", u.Helvetica = "Helvetica", u.Courier = "Courier", u.Symbol = "Symbol", u["Times-Bold"] = "Times-Bold", u["Helvetica-Bold"] = "Helvetica-Bold", u["Courier-Bold"] = "Courier-Bold", u.ZapfDingbats = "ZapfDingbats", u["Times-Italic"] = "Times-Italic", u["Helvetica-Oblique"] = "Helvetica-Oblique", u["Courier-Oblique"] = "Courier-Oblique", u["Times-BoldItalic"] = "Times-BoldItalic", u["Helvetica-BoldOblique"] = "Helvetica-BoldOblique", u["Courier-BoldOblique"] = "Courier-BoldOblique", u.ArialNarrow = "Helvetica", u["ArialNarrow-Bold"] = "Helvetica-Bold", u["ArialNarrow-BoldItalic"] = "Helvetica-BoldOblique", u["ArialNarrow-Italic"] = "Helvetica-Oblique", u.ArialBlack = "Helvetica", u["ArialBlack-Bold"] = "Helvetica-Bold", u["ArialBlack-BoldItalic"] = "Helvetica-BoldOblique", u["ArialBlack-Italic"] = "Helvetica-Oblique", u["Arial-Black"] = "Helvetica", u["Arial-Black-Bold"] = "Helvetica-Bold", u["Arial-Black-BoldItalic"] = "Helvetica-BoldOblique", u["Arial-Black-Italic"] = "Helvetica-Oblique", u.Arial = "Helvetica", u["Arial-Bold"] = "Helvetica-Bold", u["Arial-BoldItalic"] = "Helvetica-BoldOblique", u["Arial-Italic"] = "Helvetica-Oblique", u.ArialMT = "Helvetica", u["Arial-BoldItalicMT"] = "Helvetica-BoldOblique", u["Arial-BoldMT"] = "Helvetica-Bold", u["Arial-ItalicMT"] = "Helvetica-Oblique", u["Arial-BoldItalicMT-BoldItalic"] = "Helvetica-BoldOblique", u["Arial-BoldMT-Bold"] = "Helvetica-Bold", u["Arial-ItalicMT-Italic"] = "Helvetica-Oblique", u.ArialUnicodeMS = "Helvetica", u["ArialUnicodeMS-Bold"] = "Helvetica-Bold", u["ArialUnicodeMS-BoldItalic"] = "Helvetica-BoldOblique", u["ArialUnicodeMS-Italic"] = "Helvetica-Oblique", u["Courier-BoldItalic"] = "Courier-BoldOblique", u["Courier-Italic"] = "Courier-Oblique", u.CourierNew = "Courier", u["CourierNew-Bold"] = "Courier-Bold", u["CourierNew-BoldItalic"] = "Courier-BoldOblique", u["CourierNew-Italic"] = "Courier-Oblique", u["CourierNewPS-BoldItalicMT"] = "Courier-BoldOblique", u["CourierNewPS-BoldMT"] = "Courier-Bold", u["CourierNewPS-ItalicMT"] = "Courier-Oblique", u.CourierNewPSMT = "Courier", u["Helvetica-BoldItalic"] = "Helvetica-BoldOblique", u["Helvetica-Italic"] = "Helvetica-Oblique", u["Symbol-Bold"] = "Symbol", u["Symbol-BoldItalic"] = "Symbol", u["Symbol-Italic"] = "Symbol", u.TimesNewRoman = "Times-Roman", u["TimesNewRoman-Bold"] = "Times-Bold", u["TimesNewRoman-BoldItalic"] = "Times-BoldItalic", u["TimesNewRoman-Italic"] = "Times-Italic", u.TimesNewRomanPS = "Times-Roman", u["TimesNewRomanPS-Bold"] = "Times-Bold", u["TimesNewRomanPS-BoldItalic"] = "Times-BoldItalic", u["TimesNewRomanPS-BoldItalicMT"] = "Times-BoldItalic", u["TimesNewRomanPS-BoldMT"] = "Times-Bold", u["TimesNewRomanPS-Italic"] = "Times-Italic", u["TimesNewRomanPS-ItalicMT"] = "Times-Italic", u.TimesNewRomanPSMT = "Times-Roman", u["TimesNewRomanPSMT-Bold"] = "Times-Bold", u["TimesNewRomanPSMT-BoldItalic"] = "Times-BoldItalic", u["TimesNewRomanPSMT-Italic"] = "Times-Italic";
          });
          c.getStdFontMap = g;
          const t = (0, s.getLookupTableFactory)(function(u) {
            u.Courier = "FoxitFixed.pfb", u["Courier-Bold"] = "FoxitFixedBold.pfb", u["Courier-BoldOblique"] = "FoxitFixedBoldItalic.pfb", u["Courier-Oblique"] = "FoxitFixedItalic.pfb", u.Helvetica = "LiberationSans-Regular.ttf", u["Helvetica-Bold"] = "LiberationSans-Bold.ttf", u["Helvetica-BoldOblique"] = "LiberationSans-BoldItalic.ttf", u["Helvetica-Oblique"] = "LiberationSans-Italic.ttf", u["Times-Roman"] = "FoxitSerif.pfb", u["Times-Bold"] = "FoxitSerifBold.pfb", u["Times-BoldItalic"] = "FoxitSerifBoldItalic.pfb", u["Times-Italic"] = "FoxitSerifItalic.pfb", u.Symbol = "FoxitSymbol.pfb", u.ZapfDingbats = "FoxitDingbats.pfb", u["LiberationSans-Regular"] = "LiberationSans-Regular.ttf", u["LiberationSans-Bold"] = "LiberationSans-Bold.ttf", u["LiberationSans-Italic"] = "LiberationSans-Italic.ttf", u["LiberationSans-BoldItalic"] = "LiberationSans-BoldItalic.ttf";
          });
          c.getFontNameToFileMap = t;
          const i = (0, s.getLookupTableFactory)(function(u) {
            u.Calibri = "Helvetica", u["Calibri-Bold"] = "Helvetica-Bold", u["Calibri-BoldItalic"] = "Helvetica-BoldOblique", u["Calibri-Italic"] = "Helvetica-Oblique", u.CenturyGothic = "Helvetica", u["CenturyGothic-Bold"] = "Helvetica-Bold", u["CenturyGothic-BoldItalic"] = "Helvetica-BoldOblique", u["CenturyGothic-Italic"] = "Helvetica-Oblique", u.ComicSansMS = "Comic Sans MS", u["ComicSansMS-Bold"] = "Comic Sans MS-Bold", u["ComicSansMS-BoldItalic"] = "Comic Sans MS-BoldItalic", u["ComicSansMS-Italic"] = "Comic Sans MS-Italic", u.Impact = "Helvetica", u["ItcSymbol-Bold"] = "Helvetica-Bold", u["ItcSymbol-BoldItalic"] = "Helvetica-BoldOblique", u["ItcSymbol-Book"] = "Helvetica", u["ItcSymbol-BookItalic"] = "Helvetica-Oblique", u["ItcSymbol-Medium"] = "Helvetica", u["ItcSymbol-MediumItalic"] = "Helvetica-Oblique", u.LucidaConsole = "Courier", u["LucidaConsole-Bold"] = "Courier-Bold", u["LucidaConsole-BoldItalic"] = "Courier-BoldOblique", u["LucidaConsole-Italic"] = "Courier-Oblique", u["LucidaSans-Demi"] = "Helvetica-Bold", u["MS-Gothic"] = "MS Gothic", u["MS-Gothic-Bold"] = "MS Gothic-Bold", u["MS-Gothic-BoldItalic"] = "MS Gothic-BoldItalic", u["MS-Gothic-Italic"] = "MS Gothic-Italic", u["MS-Mincho"] = "MS Mincho", u["MS-Mincho-Bold"] = "MS Mincho-Bold", u["MS-Mincho-BoldItalic"] = "MS Mincho-BoldItalic", u["MS-Mincho-Italic"] = "MS Mincho-Italic", u["MS-PGothic"] = "MS PGothic", u["MS-PGothic-Bold"] = "MS PGothic-Bold", u["MS-PGothic-BoldItalic"] = "MS PGothic-BoldItalic", u["MS-PGothic-Italic"] = "MS PGothic-Italic", u["MS-PMincho"] = "MS PMincho", u["MS-PMincho-Bold"] = "MS PMincho-Bold", u["MS-PMincho-BoldItalic"] = "MS PMincho-BoldItalic", u["MS-PMincho-Italic"] = "MS PMincho-Italic", u.NuptialScript = "Times-Italic", u.SegoeUISymbol = "Helvetica";
          });
          c.getNonStdFontMap = i;
          const m = (0, s.getLookupTableFactory)(function(u) {
            u["Adobe Jenson"] = !0, u["Adobe Text"] = !0, u.Albertus = !0, u.Aldus = !0, u.Alexandria = !0, u.Algerian = !0, u["American Typewriter"] = !0, u.Antiqua = !0, u.Apex = !0, u.Arno = !0, u.Aster = !0, u.Aurora = !0, u.Baskerville = !0, u.Bell = !0, u.Bembo = !0, u["Bembo Schoolbook"] = !0, u.Benguiat = !0, u["Berkeley Old Style"] = !0, u["Bernhard Modern"] = !0, u["Berthold City"] = !0, u.Bodoni = !0, u["Bauer Bodoni"] = !0, u["Book Antiqua"] = !0, u.Bookman = !0, u["Bordeaux Roman"] = !0, u["Californian FB"] = !0, u.Calisto = !0, u.Calvert = !0, u.Capitals = !0, u.Cambria = !0, u.Cartier = !0, u.Caslon = !0, u.Catull = !0, u.Centaur = !0, u["Century Old Style"] = !0, u["Century Schoolbook"] = !0, u.Chaparral = !0, u["Charis SIL"] = !0, u.Cheltenham = !0, u["Cholla Slab"] = !0, u.Clarendon = !0, u.Clearface = !0, u.Cochin = !0, u.Colonna = !0, u["Computer Modern"] = !0, u["Concrete Roman"] = !0, u.Constantia = !0, u["Cooper Black"] = !0, u.Corona = !0, u.Ecotype = !0, u.Egyptienne = !0, u.Elephant = !0, u.Excelsior = !0, u.Fairfield = !0, u["FF Scala"] = !0, u.Folkard = !0, u.Footlight = !0, u.FreeSerif = !0, u["Friz Quadrata"] = !0, u.Garamond = !0, u.Gentium = !0, u.Georgia = !0, u.Gloucester = !0, u["Goudy Old Style"] = !0, u["Goudy Schoolbook"] = !0, u["Goudy Pro Font"] = !0, u.Granjon = !0, u["Guardian Egyptian"] = !0, u.Heather = !0, u.Hercules = !0, u["High Tower Text"] = !0, u.Hiroshige = !0, u["Hoefler Text"] = !0, u["Humana Serif"] = !0, u.Imprint = !0, u["Ionic No. 5"] = !0, u.Janson = !0, u.Joanna = !0, u.Korinna = !0, u.Lexicon = !0, u.LiberationSerif = !0, u["Liberation Serif"] = !0, u["Linux Libertine"] = !0, u.Literaturnaya = !0, u.Lucida = !0, u["Lucida Bright"] = !0, u.Melior = !0, u.Memphis = !0, u.Miller = !0, u.Minion = !0, u.Modern = !0, u["Mona Lisa"] = !0, u["Mrs Eaves"] = !0, u["MS Serif"] = !0, u["Museo Slab"] = !0, u["New York"] = !0, u["Nimbus Roman"] = !0, u["NPS Rawlinson Roadway"] = !0, u.NuptialScript = !0, u.Palatino = !0, u.Perpetua = !0, u.Plantin = !0, u["Plantin Schoolbook"] = !0, u.Playbill = !0, u["Poor Richard"] = !0, u["Rawlinson Roadway"] = !0, u.Renault = !0, u.Requiem = !0, u.Rockwell = !0, u.Roman = !0, u["Rotis Serif"] = !0, u.Sabon = !0, u.Scala = !0, u.Seagull = !0, u.Sistina = !0, u.Souvenir = !0, u.STIX = !0, u["Stone Informal"] = !0, u["Stone Serif"] = !0, u.Sylfaen = !0, u.Times = !0, u.Trajan = !0, u.Trinité = !0, u["Trump Mediaeval"] = !0, u.Utopia = !0, u["Vale Type"] = !0, u["Bitstream Vera"] = !0, u["Vera Serif"] = !0, u.Versailles = !0, u.Wanted = !0, u.Weiss = !0, u["Wide Latin"] = !0, u.Windsor = !0, u.XITS = !0;
          });
          c.getSerifFonts = m;
          const v = (0, s.getLookupTableFactory)(function(u) {
            u.Dingbats = !0, u.Symbol = !0, u.ZapfDingbats = !0, u.Wingdings = !0, u["Wingdings-Bold"] = !0, u["Wingdings-Regular"] = !0;
          });
          c.getSymbolsFonts = v;
          const E = (0, s.getLookupTableFactory)(function(u) {
            u[2] = 10, u[3] = 32, u[4] = 33, u[5] = 34, u[6] = 35, u[7] = 36, u[8] = 37, u[9] = 38, u[10] = 39, u[11] = 40, u[12] = 41, u[13] = 42, u[14] = 43, u[15] = 44, u[16] = 45, u[17] = 46, u[18] = 47, u[19] = 48, u[20] = 49, u[21] = 50, u[22] = 51, u[23] = 52, u[24] = 53, u[25] = 54, u[26] = 55, u[27] = 56, u[28] = 57, u[29] = 58, u[30] = 894, u[31] = 60, u[32] = 61, u[33] = 62, u[34] = 63, u[35] = 64, u[36] = 65, u[37] = 66, u[38] = 67, u[39] = 68, u[40] = 69, u[41] = 70, u[42] = 71, u[43] = 72, u[44] = 73, u[45] = 74, u[46] = 75, u[47] = 76, u[48] = 77, u[49] = 78, u[50] = 79, u[51] = 80, u[52] = 81, u[53] = 82, u[54] = 83, u[55] = 84, u[56] = 85, u[57] = 86, u[58] = 87, u[59] = 88, u[60] = 89, u[61] = 90, u[62] = 91, u[63] = 92, u[64] = 93, u[65] = 94, u[66] = 95, u[67] = 96, u[68] = 97, u[69] = 98, u[70] = 99, u[71] = 100, u[72] = 101, u[73] = 102, u[74] = 103, u[75] = 104, u[76] = 105, u[77] = 106, u[78] = 107, u[79] = 108, u[80] = 109, u[81] = 110, u[82] = 111, u[83] = 112, u[84] = 113, u[85] = 114, u[86] = 115, u[87] = 116, u[88] = 117, u[89] = 118, u[90] = 119, u[91] = 120, u[92] = 121, u[93] = 122, u[94] = 123, u[95] = 124, u[96] = 125, u[97] = 126, u[98] = 196, u[99] = 197, u[100] = 199, u[101] = 201, u[102] = 209, u[103] = 214, u[104] = 220, u[105] = 225, u[106] = 224, u[107] = 226, u[108] = 228, u[109] = 227, u[110] = 229, u[111] = 231, u[112] = 233, u[113] = 232, u[114] = 234, u[115] = 235, u[116] = 237, u[117] = 236, u[118] = 238, u[119] = 239, u[120] = 241, u[121] = 243, u[122] = 242, u[123] = 244, u[124] = 246, u[125] = 245, u[126] = 250, u[127] = 249, u[128] = 251, u[129] = 252, u[130] = 8224, u[131] = 176, u[132] = 162, u[133] = 163, u[134] = 167, u[135] = 8226, u[136] = 182, u[137] = 223, u[138] = 174, u[139] = 169, u[140] = 8482, u[141] = 180, u[142] = 168, u[143] = 8800, u[144] = 198, u[145] = 216, u[146] = 8734, u[147] = 177, u[148] = 8804, u[149] = 8805, u[150] = 165, u[151] = 181, u[152] = 8706, u[153] = 8721, u[154] = 8719, u[156] = 8747, u[157] = 170, u[158] = 186, u[159] = 8486, u[160] = 230, u[161] = 248, u[162] = 191, u[163] = 161, u[164] = 172, u[165] = 8730, u[166] = 402, u[167] = 8776, u[168] = 8710, u[169] = 171, u[170] = 187, u[171] = 8230, u[179] = 8220, u[180] = 8221, u[181] = 8216, u[182] = 8217, u[200] = 193, u[203] = 205, u[207] = 211, u[210] = 218, u[223] = 711, u[224] = 321, u[225] = 322, u[226] = 352, u[227] = 353, u[228] = 381, u[229] = 382, u[233] = 221, u[234] = 253, u[252] = 263, u[253] = 268, u[254] = 269, u[258] = 258, u[260] = 260, u[261] = 261, u[265] = 280, u[266] = 281, u[267] = 282, u[268] = 283, u[269] = 313, u[275] = 323, u[276] = 324, u[278] = 328, u[283] = 344, u[284] = 345, u[285] = 346, u[286] = 347, u[292] = 367, u[295] = 377, u[296] = 378, u[298] = 380, u[305] = 963, u[306] = 964, u[307] = 966, u[308] = 8215, u[309] = 8252, u[310] = 8319, u[311] = 8359, u[312] = 8592, u[313] = 8593, u[337] = 9552, u[493] = 1039, u[494] = 1040, u[672] = 1488, u[673] = 1489, u[674] = 1490, u[675] = 1491, u[676] = 1492, u[677] = 1493, u[678] = 1494, u[679] = 1495, u[680] = 1496, u[681] = 1497, u[682] = 1498, u[683] = 1499, u[684] = 1500, u[685] = 1501, u[686] = 1502, u[687] = 1503, u[688] = 1504, u[689] = 1505, u[690] = 1506, u[691] = 1507, u[692] = 1508, u[693] = 1509, u[694] = 1510, u[695] = 1511, u[696] = 1512, u[697] = 1513, u[698] = 1514, u[705] = 1524, u[706] = 8362, u[710] = 64288, u[711] = 64298, u[759] = 1617, u[761] = 1776, u[763] = 1778, u[775] = 1652, u[777] = 1764, u[778] = 1780, u[779] = 1781, u[780] = 1782, u[782] = 771, u[783] = 64726, u[786] = 8363, u[788] = 8532, u[790] = 768, u[791] = 769, u[792] = 768, u[795] = 803, u[797] = 64336, u[798] = 64337, u[799] = 64342, u[800] = 64343, u[801] = 64344, u[802] = 64345, u[803] = 64362, u[804] = 64363, u[805] = 64364, u[2424] = 7821, u[2425] = 7822, u[2426] = 7823, u[2427] = 7824, u[2428] = 7825, u[2429] = 7826, u[2430] = 7827, u[2433] = 7682, u[2678] = 8045, u[2679] = 8046, u[2830] = 1552, u[2838] = 686, u[2840] = 751, u[2842] = 753, u[2843] = 754, u[2844] = 755, u[2846] = 757, u[2856] = 767, u[2857] = 848, u[2858] = 849, u[2862] = 853, u[2863] = 854, u[2864] = 855, u[2865] = 861, u[2866] = 862, u[2906] = 7460, u[2908] = 7462, u[2909] = 7463, u[2910] = 7464, u[2912] = 7466, u[2913] = 7467, u[2914] = 7468, u[2916] = 7470, u[2917] = 7471, u[2918] = 7472, u[2920] = 7474, u[2921] = 7475, u[2922] = 7476, u[2924] = 7478, u[2925] = 7479, u[2926] = 7480, u[2928] = 7482, u[2929] = 7483, u[2930] = 7484, u[2932] = 7486, u[2933] = 7487, u[2934] = 7488, u[2936] = 7490, u[2937] = 7491, u[2938] = 7492, u[2940] = 7494, u[2941] = 7495, u[2942] = 7496, u[2944] = 7498, u[2946] = 7500, u[2948] = 7502, u[2950] = 7504, u[2951] = 7505, u[2952] = 7506, u[2954] = 7508, u[2955] = 7509, u[2956] = 7510, u[2958] = 7512, u[2959] = 7513, u[2960] = 7514, u[2962] = 7516, u[2963] = 7517, u[2964] = 7518, u[2966] = 7520, u[2967] = 7521, u[2968] = 7522, u[2970] = 7524, u[2971] = 7525, u[2972] = 7526, u[2974] = 7528, u[2975] = 7529, u[2976] = 7530, u[2978] = 1537, u[2979] = 1538, u[2980] = 1539, u[2982] = 1549, u[2983] = 1551, u[2984] = 1552, u[2986] = 1554, u[2987] = 1555, u[2988] = 1556, u[2990] = 1623, u[2991] = 1624, u[2995] = 1775, u[2999] = 1791, u[3002] = 64290, u[3003] = 64291, u[3004] = 64292, u[3006] = 64294, u[3007] = 64295, u[3008] = 64296, u[3011] = 1900, u[3014] = 8223, u[3015] = 8244, u[3017] = 7532, u[3018] = 7533, u[3019] = 7534, u[3075] = 7590, u[3076] = 7591, u[3079] = 7594, u[3080] = 7595, u[3083] = 7598, u[3084] = 7599, u[3087] = 7602, u[3088] = 7603, u[3091] = 7606, u[3092] = 7607, u[3095] = 7610, u[3096] = 7611, u[3099] = 7614, u[3100] = 7615, u[3103] = 7618, u[3104] = 7619, u[3107] = 8337, u[3108] = 8338, u[3116] = 1884, u[3119] = 1885, u[3120] = 1885, u[3123] = 1886, u[3124] = 1886, u[3127] = 1887, u[3128] = 1887, u[3131] = 1888, u[3132] = 1888, u[3135] = 1889, u[3136] = 1889, u[3139] = 1890, u[3140] = 1890, u[3143] = 1891, u[3144] = 1891, u[3147] = 1892, u[3148] = 1892, u[3153] = 580, u[3154] = 581, u[3157] = 584, u[3158] = 585, u[3161] = 588, u[3162] = 589, u[3165] = 891, u[3166] = 892, u[3169] = 1274, u[3170] = 1275, u[3173] = 1278, u[3174] = 1279, u[3181] = 7622, u[3182] = 7623, u[3282] = 11799, u[3316] = 578, u[3379] = 42785, u[3393] = 1159, u[3416] = 8377;
          });
          c.getGlyphMapForStandardFonts = E;
          const S = (0, s.getLookupTableFactory)(function(u) {
            u[227] = 322, u[264] = 261, u[291] = 346;
          });
          c.getSupplementalGlyphMapForArialBlack = S;
          const y = (0, s.getLookupTableFactory)(function(u) {
            u[1] = 32, u[4] = 65, u[5] = 192, u[6] = 193, u[9] = 196, u[17] = 66, u[18] = 67, u[21] = 268, u[24] = 68, u[28] = 69, u[29] = 200, u[30] = 201, u[32] = 282, u[38] = 70, u[39] = 71, u[44] = 72, u[47] = 73, u[48] = 204, u[49] = 205, u[58] = 74, u[60] = 75, u[62] = 76, u[68] = 77, u[69] = 78, u[75] = 79, u[76] = 210, u[80] = 214, u[87] = 80, u[89] = 81, u[90] = 82, u[92] = 344, u[94] = 83, u[97] = 352, u[100] = 84, u[104] = 85, u[109] = 220, u[115] = 86, u[116] = 87, u[121] = 88, u[122] = 89, u[124] = 221, u[127] = 90, u[129] = 381, u[258] = 97, u[259] = 224, u[260] = 225, u[263] = 228, u[268] = 261, u[271] = 98, u[272] = 99, u[273] = 263, u[275] = 269, u[282] = 100, u[286] = 101, u[287] = 232, u[288] = 233, u[290] = 283, u[295] = 281, u[296] = 102, u[336] = 103, u[346] = 104, u[349] = 105, u[350] = 236, u[351] = 237, u[361] = 106, u[364] = 107, u[367] = 108, u[371] = 322, u[373] = 109, u[374] = 110, u[381] = 111, u[382] = 242, u[383] = 243, u[386] = 246, u[393] = 112, u[395] = 113, u[396] = 114, u[398] = 345, u[400] = 115, u[401] = 347, u[403] = 353, u[410] = 116, u[437] = 117, u[442] = 252, u[448] = 118, u[449] = 119, u[454] = 120, u[455] = 121, u[457] = 253, u[460] = 122, u[462] = 382, u[463] = 380, u[853] = 44, u[855] = 58, u[856] = 46, u[876] = 47, u[878] = 45, u[882] = 45, u[894] = 40, u[895] = 41, u[896] = 91, u[897] = 93, u[923] = 64, u[1004] = 48, u[1005] = 49, u[1006] = 50, u[1007] = 51, u[1008] = 52, u[1009] = 53, u[1010] = 54, u[1011] = 55, u[1012] = 56, u[1013] = 57, u[1081] = 37, u[1085] = 43, u[1086] = 45;
          });
          c.getSupplementalGlyphMapForCalibri = y;
          function x(u) {
            const I = (0, h.normalizeFontName)(u);
            return g()[I];
          }
          function b(u) {
            const I = (0, h.normalizeFontName)(u);
            return !!(g()[I] || i()[I] || m()[I] || v()[I]);
          }
        },
        /* 42 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.ToUnicodeMap = c.IdentityToUnicodeMap = void 0;
          var s = f(2);
          class h {
            constructor(i = []) {
              this._map = i;
            }
            get length() {
              return this._map.length;
            }
            forEach(i) {
              for (const m in this._map)
                i(m, this._map[m].charCodeAt(0));
            }
            has(i) {
              return this._map[i] !== void 0;
            }
            get(i) {
              return this._map[i];
            }
            charCodeOf(i) {
              const m = this._map;
              if (m.length <= 65536)
                return m.indexOf(i);
              for (const v in m)
                if (m[v] === i)
                  return v | 0;
              return -1;
            }
            amend(i) {
              for (const m in i)
                this._map[m] = i[m];
            }
          }
          c.ToUnicodeMap = h;
          class g {
            constructor(i, m) {
              this.firstChar = i, this.lastChar = m;
            }
            get length() {
              return this.lastChar + 1 - this.firstChar;
            }
            forEach(i) {
              for (let m = this.firstChar, v = this.lastChar; m <= v; m++)
                i(m, m);
            }
            has(i) {
              return this.firstChar <= i && i <= this.lastChar;
            }
            get(i) {
              if (this.firstChar <= i && i <= this.lastChar)
                return String.fromCharCode(i);
            }
            charCodeOf(i) {
              return Number.isInteger(i) && i >= this.firstChar && i <= this.lastChar ? i : -1;
            }
            amend(i) {
              (0, s.unreachable)("Should not call amend()");
            }
          }
          c.IdentityToUnicodeMap = g;
        },
        /* 43 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.CFFFont = void 0;
          var s = f(35), h = f(38), g = f(2);
          class t {
            constructor(m, v) {
              this.properties = v;
              const E = new s.CFFParser(m, v, h.SEAC_ANALYSIS_ENABLED);
              this.cff = E.parse(), this.cff.duplicateFirstGlyph();
              const S = new s.CFFCompiler(this.cff);
              this.seacs = this.cff.seacs;
              try {
                this.data = S.compile();
              } catch {
                (0, g.warn)("Failed to compile font " + v.loadedName), this.data = m;
              }
              this._createBuiltInEncoding();
            }
            get numGlyphs() {
              return this.cff.charStrings.count;
            }
            getCharset() {
              return this.cff.charset.charset;
            }
            getGlyphMapping() {
              const m = this.cff, v = this.properties, {
                cidToGidMap: E,
                cMap: S
              } = v, y = m.charset.charset;
              let x, b;
              if (v.composite) {
                let I;
                if ((E == null ? void 0 : E.length) > 0) {
                  I = /* @__PURE__ */ Object.create(null);
                  for (let D = 0, $ = E.length; D < $; D++) {
                    const K = E[D];
                    K !== void 0 && (I[K] = D);
                  }
                }
                x = /* @__PURE__ */ Object.create(null);
                let O;
                if (m.isCIDFont)
                  for (b = 0; b < y.length; b++) {
                    const D = y[b];
                    O = S.charCodeOf(D), (I == null ? void 0 : I[O]) !== void 0 && (O = I[O]), x[O] = b;
                  }
                else
                  for (b = 0; b < m.charStrings.count; b++)
                    O = S.charCodeOf(b), x[O] = b;
                return x;
              }
              let u = m.encoding ? m.encoding.encoding : null;
              return v.isInternalFont && (u = v.defaultEncoding), x = (0, h.type1FontGlyphMapping)(v, u, y), x;
            }
            hasGlyphId(m) {
              return this.cff.hasGlyphId(m);
            }
            _createBuiltInEncoding() {
              const {
                charset: m,
                encoding: v
              } = this.cff;
              if (!m || !v)
                return;
              const E = m.charset, S = v.encoding, y = [];
              for (const x in S) {
                const b = S[x];
                if (b >= 0) {
                  const u = E[b];
                  u && (y[x] = u);
                }
              }
              y.length > 0 && (this.properties.builtInEncoding = y);
            }
          }
          c.CFFFont = t;
        },
        /* 44 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.FontRendererFactory = void 0;
          var s = f(2), h = f(35), g = f(39), t = f(37), i = f(8);
          function m(A, k) {
            return (A[k] << 24 | A[k + 1] << 16 | A[k + 2] << 8 | A[k + 3]) >>> 0;
          }
          function v(A, k) {
            return A[k] << 8 | A[k + 1];
          }
          function E(A, k) {
            return (A[k] << 24 | A[k + 1] << 16) >> 16;
          }
          function S(A, k) {
            return A[k] << 24 >> 24;
          }
          function y(A, k) {
            return E(A, k) / 16384;
          }
          function x(A) {
            const k = A.length;
            let z = 32768;
            return k < 1240 ? z = 107 : k < 33900 && (z = 1131), z;
          }
          function b(A, k, z) {
            const T = v(A, k + 2) === 1 ? m(A, k + 8) : m(A, k + 16), w = v(A, k + T);
            let F, j, P;
            if (w === 4) {
              v(A, k + T + 2);
              const V = v(A, k + T + 6) >> 1;
              for (j = k + T + 14, F = [], P = 0; P < V; P++, j += 2)
                F[P] = {
                  end: v(A, j)
                };
              for (j += 2, P = 0; P < V; P++, j += 2)
                F[P].start = v(A, j);
              for (P = 0; P < V; P++, j += 2)
                F[P].idDelta = v(A, j);
              for (P = 0; P < V; P++, j += 2) {
                let J = v(A, j);
                if (J !== 0) {
                  F[P].ids = [];
                  for (let ne = 0, Z = F[P].end - F[P].start + 1; ne < Z; ne++)
                    F[P].ids[ne] = v(A, j + J), J += 2;
                }
              }
              return F;
            } else if (w === 12) {
              const V = m(A, k + T + 12);
              for (j = k + T + 16, F = [], P = 0; P < V; P++)
                k = m(A, j), F.push({
                  start: k,
                  end: m(A, j + 4),
                  idDelta: m(A, j + 8) - k
                }), j += 12;
              return F;
            }
            throw new s.FormatError(`unsupported cmap: ${w}`);
          }
          function u(A, k, z, T) {
            var P, V, J;
            const w = {}, j = new h.CFFParser(new i.Stream(A, k, z - k), w, T).parse();
            return {
              glyphs: j.charStrings.objects,
              subrs: (V = (P = j.topDict.privateDict) == null ? void 0 : P.subrsIndex) == null ? void 0 : V.objects,
              gsubrs: (J = j.globalSubrIndex) == null ? void 0 : J.objects,
              isCFFCIDFont: j.isCIDFont,
              fdSelect: j.fdSelect,
              fdArray: j.fdArray
            };
          }
          function I(A, k, z) {
            let T, w;
            z ? (T = 4, w = m) : (T = 2, w = (P, V) => 2 * v(P, V));
            const F = [];
            let j = w(k, 0);
            for (let P = T; P < k.length; P += T) {
              const V = w(k, P);
              F.push(A.subarray(j, V)), j = V;
            }
            return F;
          }
          function O(A, k) {
            const z = k.codePointAt(0);
            let T = 0, w = 0, F = A.length - 1;
            for (; w < F; ) {
              const j = w + F + 1 >> 1;
              z < A[j].start ? F = j - 1 : w = j;
            }
            return A[w].start <= z && z <= A[w].end && (T = A[w].idDelta + (A[w].ids ? A[w].ids[z - A[w].start] : z) & 65535), {
              charCode: z,
              glyphId: T
            };
          }
          function D(A, k, z) {
            function T(Z, te) {
              k.push({
                cmd: "moveTo",
                args: [Z, te]
              });
            }
            function w(Z, te) {
              k.push({
                cmd: "lineTo",
                args: [Z, te]
              });
            }
            function F(Z, te, G, N) {
              k.push({
                cmd: "quadraticCurveTo",
                args: [Z, te, G, N]
              });
            }
            let j = 0;
            const P = E(A, j);
            let V, J = 0, ne = 0;
            if (j += 10, P < 0)
              do {
                V = v(A, j);
                const Z = v(A, j + 2);
                j += 4;
                let te, G;
                V & 1 ? (V & 2 ? (te = E(A, j), G = E(A, j + 2)) : (te = v(A, j), G = v(A, j + 2)), j += 4) : V & 2 ? (te = S(A, j++), G = S(A, j++)) : (te = A[j++], G = A[j++]), V & 2 ? (J = te, ne = G) : (J = 0, ne = 0);
                let N = 1, q = 1, ie = 0, oe = 0;
                V & 8 ? (N = q = y(A, j), j += 2) : V & 64 ? (N = y(A, j), q = y(A, j + 2), j += 4) : V & 128 && (N = y(A, j), ie = y(A, j + 2), oe = y(A, j + 4), q = y(A, j + 6), j += 8);
                const fe = z.glyphs[Z];
                fe && (k.push({
                  cmd: "save"
                }, {
                  cmd: "transform",
                  args: [N, ie, oe, q, J, ne]
                }), D(fe, k, z), k.push({
                  cmd: "restore"
                }));
              } while (V & 32);
            else {
              const Z = [];
              let te, G;
              for (te = 0; te < P; te++)
                Z.push(v(A, j)), j += 2;
              const N = v(A, j);
              j += 2 + N;
              const q = Z.at(-1) + 1, ie = [];
              for (; ie.length < q; ) {
                V = A[j++];
                let fe = 1;
                for (V & 8 && (fe += A[j++]); fe-- > 0; )
                  ie.push({
                    flags: V
                  });
              }
              for (te = 0; te < q; te++) {
                switch (ie[te].flags & 18) {
                  case 0:
                    J += E(A, j), j += 2;
                    break;
                  case 2:
                    J -= A[j++];
                    break;
                  case 18:
                    J += A[j++];
                    break;
                }
                ie[te].x = J;
              }
              for (te = 0; te < q; te++) {
                switch (ie[te].flags & 36) {
                  case 0:
                    ne += E(A, j), j += 2;
                    break;
                  case 4:
                    ne -= A[j++];
                    break;
                  case 36:
                    ne += A[j++];
                    break;
                }
                ie[te].y = ne;
              }
              let oe = 0;
              for (j = 0; j < P; j++) {
                const fe = Z[j], Y = ie.slice(oe, fe + 1);
                if (Y[0].flags & 1)
                  Y.push(Y[0]);
                else if (Y.at(-1).flags & 1)
                  Y.unshift(Y.at(-1));
                else {
                  const ae = {
                    flags: 1,
                    x: (Y[0].x + Y.at(-1).x) / 2,
                    y: (Y[0].y + Y.at(-1).y) / 2
                  };
                  Y.unshift(ae), Y.push(ae);
                }
                for (T(Y[0].x, Y[0].y), te = 1, G = Y.length; te < G; te++)
                  Y[te].flags & 1 ? w(Y[te].x, Y[te].y) : Y[te + 1].flags & 1 ? (F(Y[te].x, Y[te].y, Y[te + 1].x, Y[te + 1].y), te++) : F(Y[te].x, Y[te].y, (Y[te].x + Y[te + 1].x) / 2, (Y[te].y + Y[te + 1].y) / 2);
                oe = fe + 1;
              }
            }
          }
          function $(A, k, z, T) {
            function w(te, G) {
              k.push({
                cmd: "moveTo",
                args: [te, G]
              });
            }
            function F(te, G) {
              k.push({
                cmd: "lineTo",
                args: [te, G]
              });
            }
            function j(te, G, N, q, ie, oe) {
              k.push({
                cmd: "bezierCurveTo",
                args: [te, G, N, q, ie, oe]
              });
            }
            const P = [];
            let V = 0, J = 0, ne = 0;
            function Z(te) {
              var N;
              let G = 0;
              for (; G < te.length; ) {
                let q = !1, ie = te[G++], oe, fe, Y, ae, se, L, W, M, X;
                switch (ie) {
                  case 1:
                    ne += P.length >> 1, q = !0;
                    break;
                  case 3:
                    ne += P.length >> 1, q = !0;
                    break;
                  case 4:
                    J += P.pop(), w(V, J), q = !0;
                    break;
                  case 5:
                    for (; P.length > 0; )
                      V += P.shift(), J += P.shift(), F(V, J);
                    break;
                  case 6:
                    for (; P.length > 0 && (V += P.shift(), F(V, J), P.length !== 0); )
                      J += P.shift(), F(V, J);
                    break;
                  case 7:
                    for (; P.length > 0 && (J += P.shift(), F(V, J), P.length !== 0); )
                      V += P.shift(), F(V, J);
                    break;
                  case 8:
                    for (; P.length > 0; )
                      oe = V + P.shift(), Y = J + P.shift(), fe = oe + P.shift(), ae = Y + P.shift(), V = fe + P.shift(), J = ae + P.shift(), j(oe, Y, fe, ae, V, J);
                    break;
                  case 10:
                    if (M = P.pop(), X = null, z.isCFFCIDFont) {
                      const U = z.fdSelect.getFDIndex(T);
                      if (U >= 0 && U < z.fdArray.length) {
                        const Q = z.fdArray[U];
                        let re;
                        (N = Q.privateDict) != null && N.subrsIndex && (re = Q.privateDict.subrsIndex.objects), re && (M += x(re), X = re[M]);
                      } else
                        (0, s.warn)("Invalid fd index for glyph index.");
                    } else
                      X = z.subrs[M + z.subrsBias];
                    X && Z(X);
                    break;
                  case 11:
                    return;
                  case 12:
                    switch (ie = te[G++], ie) {
                      case 34:
                        oe = V + P.shift(), fe = oe + P.shift(), se = J + P.shift(), V = fe + P.shift(), j(oe, J, fe, se, V, se), oe = V + P.shift(), fe = oe + P.shift(), V = fe + P.shift(), j(oe, se, fe, J, V, J);
                        break;
                      case 35:
                        oe = V + P.shift(), Y = J + P.shift(), fe = oe + P.shift(), ae = Y + P.shift(), V = fe + P.shift(), J = ae + P.shift(), j(oe, Y, fe, ae, V, J), oe = V + P.shift(), Y = J + P.shift(), fe = oe + P.shift(), ae = Y + P.shift(), V = fe + P.shift(), J = ae + P.shift(), j(oe, Y, fe, ae, V, J), P.pop();
                        break;
                      case 36:
                        oe = V + P.shift(), se = J + P.shift(), fe = oe + P.shift(), L = se + P.shift(), V = fe + P.shift(), j(oe, se, fe, L, V, L), oe = V + P.shift(), fe = oe + P.shift(), W = L + P.shift(), V = fe + P.shift(), j(oe, L, fe, W, V, J);
                        break;
                      case 37:
                        const U = V, Q = J;
                        oe = V + P.shift(), Y = J + P.shift(), fe = oe + P.shift(), ae = Y + P.shift(), V = fe + P.shift(), J = ae + P.shift(), j(oe, Y, fe, ae, V, J), oe = V + P.shift(), Y = J + P.shift(), fe = oe + P.shift(), ae = Y + P.shift(), V = fe, J = ae, Math.abs(V - U) > Math.abs(J - Q) ? V += P.shift() : J += P.shift(), j(oe, Y, fe, ae, V, J);
                        break;
                      default:
                        throw new s.FormatError(`unknown operator: 12 ${ie}`);
                    }
                    break;
                  case 14:
                    if (P.length >= 4) {
                      const U = P.pop(), Q = P.pop();
                      J = P.pop(), V = P.pop(), k.push({
                        cmd: "save"
                      }, {
                        cmd: "translate",
                        args: [V, J]
                      });
                      let re = O(z.cmap, String.fromCharCode(z.glyphNameMap[t.StandardEncoding[U]]));
                      $(z.glyphs[re.glyphId], k, z, re.glyphId), k.push({
                        cmd: "restore"
                      }), re = O(z.cmap, String.fromCharCode(z.glyphNameMap[t.StandardEncoding[Q]])), $(z.glyphs[re.glyphId], k, z, re.glyphId);
                    }
                    return;
                  case 18:
                    ne += P.length >> 1, q = !0;
                    break;
                  case 19:
                    ne += P.length >> 1, G += ne + 7 >> 3, q = !0;
                    break;
                  case 20:
                    ne += P.length >> 1, G += ne + 7 >> 3, q = !0;
                    break;
                  case 21:
                    J += P.pop(), V += P.pop(), w(V, J), q = !0;
                    break;
                  case 22:
                    V += P.pop(), w(V, J), q = !0;
                    break;
                  case 23:
                    ne += P.length >> 1, q = !0;
                    break;
                  case 24:
                    for (; P.length > 2; )
                      oe = V + P.shift(), Y = J + P.shift(), fe = oe + P.shift(), ae = Y + P.shift(), V = fe + P.shift(), J = ae + P.shift(), j(oe, Y, fe, ae, V, J);
                    V += P.shift(), J += P.shift(), F(V, J);
                    break;
                  case 25:
                    for (; P.length > 6; )
                      V += P.shift(), J += P.shift(), F(V, J);
                    oe = V + P.shift(), Y = J + P.shift(), fe = oe + P.shift(), ae = Y + P.shift(), V = fe + P.shift(), J = ae + P.shift(), j(oe, Y, fe, ae, V, J);
                    break;
                  case 26:
                    for (P.length % 2 && (V += P.shift()); P.length > 0; )
                      oe = V, Y = J + P.shift(), fe = oe + P.shift(), ae = Y + P.shift(), V = fe, J = ae + P.shift(), j(oe, Y, fe, ae, V, J);
                    break;
                  case 27:
                    for (P.length % 2 && (J += P.shift()); P.length > 0; )
                      oe = V + P.shift(), Y = J, fe = oe + P.shift(), ae = Y + P.shift(), V = fe + P.shift(), J = ae, j(oe, Y, fe, ae, V, J);
                    break;
                  case 28:
                    P.push((te[G] << 24 | te[G + 1] << 16) >> 16), G += 2;
                    break;
                  case 29:
                    M = P.pop() + z.gsubrsBias, X = z.gsubrs[M], X && Z(X);
                    break;
                  case 30:
                    for (; P.length > 0 && (oe = V, Y = J + P.shift(), fe = oe + P.shift(), ae = Y + P.shift(), V = fe + P.shift(), J = ae + (P.length === 1 ? P.shift() : 0), j(oe, Y, fe, ae, V, J), P.length !== 0); )
                      oe = V + P.shift(), Y = J, fe = oe + P.shift(), ae = Y + P.shift(), J = ae + P.shift(), V = fe + (P.length === 1 ? P.shift() : 0), j(oe, Y, fe, ae, V, J);
                    break;
                  case 31:
                    for (; P.length > 0 && (oe = V + P.shift(), Y = J, fe = oe + P.shift(), ae = Y + P.shift(), J = ae + P.shift(), V = fe + (P.length === 1 ? P.shift() : 0), j(oe, Y, fe, ae, V, J), P.length !== 0); )
                      oe = V, Y = J + P.shift(), fe = oe + P.shift(), ae = Y + P.shift(), V = fe + P.shift(), J = ae + (P.length === 1 ? P.shift() : 0), j(oe, Y, fe, ae, V, J);
                    break;
                  default:
                    if (ie < 32)
                      throw new s.FormatError(`unknown operator: ${ie}`);
                    ie < 247 ? P.push(ie - 139) : ie < 251 ? P.push((ie - 247) * 256 + te[G++] + 108) : ie < 255 ? P.push(-(ie - 251) * 256 - te[G++] - 108) : (P.push((te[G] << 24 | te[G + 1] << 16 | te[G + 2] << 8 | te[G + 3]) / 65536), G += 4);
                    break;
                }
                q && (P.length = 0);
              }
            }
            Z(A);
          }
          const K = [];
          class H {
            constructor(k) {
              this.constructor === H && (0, s.unreachable)("Cannot initialize CompiledFont."), this.fontMatrix = k, this.compiledGlyphs = /* @__PURE__ */ Object.create(null), this.compiledCharCodeToGlyphId = /* @__PURE__ */ Object.create(null);
            }
            getPathJs(k) {
              const {
                charCode: z,
                glyphId: T
              } = O(this.cmap, k);
              let w = this.compiledGlyphs[T];
              if (!w)
                try {
                  w = this.compileGlyph(this.glyphs[T], T), this.compiledGlyphs[T] = w;
                } catch (F) {
                  throw this.compiledGlyphs[T] = K, this.compiledCharCodeToGlyphId[z] === void 0 && (this.compiledCharCodeToGlyphId[z] = T), F;
                }
              return this.compiledCharCodeToGlyphId[z] === void 0 && (this.compiledCharCodeToGlyphId[z] = T), w;
            }
            compileGlyph(k, z) {
              if (!k || k.length === 0 || k[0] === 14)
                return K;
              let T = this.fontMatrix;
              if (this.isCFFCIDFont) {
                const F = this.fdSelect.getFDIndex(z);
                F >= 0 && F < this.fdArray.length ? T = this.fdArray[F].getByName("FontMatrix") || s.FONT_IDENTITY_MATRIX : (0, s.warn)("Invalid fd index for glyph index.");
              }
              const w = [{
                cmd: "save"
              }, {
                cmd: "transform",
                args: T.slice()
              }, {
                cmd: "scale",
                args: ["size", "-size"]
              }];
              return this.compileGlyphImpl(k, w, z), w.push({
                cmd: "restore"
              }), w;
            }
            compileGlyphImpl() {
              (0, s.unreachable)("Children classes should implement this.");
            }
            hasBuiltPath(k) {
              const {
                charCode: z,
                glyphId: T
              } = O(this.cmap, k);
              return this.compiledGlyphs[T] !== void 0 && this.compiledCharCodeToGlyphId[z] !== void 0;
            }
          }
          class B extends H {
            constructor(k, z, T) {
              super(T || [488e-6, 0, 0, 488e-6, 0, 0]), this.glyphs = k, this.cmap = z;
            }
            compileGlyphImpl(k, z) {
              D(k, z, this);
            }
          }
          class R extends H {
            constructor(k, z, T, w) {
              super(T || [1e-3, 0, 0, 1e-3, 0, 0]), this.glyphs = k.glyphs, this.gsubrs = k.gsubrs || [], this.subrs = k.subrs || [], this.cmap = z, this.glyphNameMap = w || (0, g.getGlyphsUnicode)(), this.gsubrsBias = x(this.gsubrs), this.subrsBias = x(this.subrs), this.isCFFCIDFont = k.isCFFCIDFont, this.fdSelect = k.fdSelect, this.fdArray = k.fdArray;
            }
            compileGlyphImpl(k, z, T) {
              $(k, z, this, T);
            }
          }
          class _ {
            static create(k, z) {
              const T = new Uint8Array(k.data);
              let w, F, j, P, V, J;
              const ne = v(T, 4);
              for (let Z = 0, te = 12; Z < ne; Z++, te += 16) {
                const G = (0, s.bytesToString)(T.subarray(te, te + 4)), N = m(T, te + 8), q = m(T, te + 12);
                switch (G) {
                  case "cmap":
                    w = b(T, N);
                    break;
                  case "glyf":
                    F = T.subarray(N, N + q);
                    break;
                  case "loca":
                    j = T.subarray(N, N + q);
                    break;
                  case "head":
                    J = v(T, N + 18), V = v(T, N + 50);
                    break;
                  case "CFF ":
                    P = u(T, N, N + q, z);
                    break;
                }
              }
              if (F) {
                const Z = J ? [1 / J, 0, 0, 1 / J, 0, 0] : k.fontMatrix;
                return new B(I(F, j, V), w, Z);
              }
              return new R(P, w, k.fontMatrix, k.glyphNameMap);
            }
          }
          c.FontRendererFactory = _;
        },
        /* 45 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.getMetrics = c.getFontBasicMetrics = void 0;
          var s = f(3);
          const h = (0, s.getLookupTableFactory)(function(t) {
            t.Courier = 600, t["Courier-Bold"] = 600, t["Courier-BoldOblique"] = 600, t["Courier-Oblique"] = 600, t.Helvetica = (0, s.getLookupTableFactory)(function(i) {
              i.space = 278, i.exclam = 278, i.quotedbl = 355, i.numbersign = 556, i.dollar = 556, i.percent = 889, i.ampersand = 667, i.quoteright = 222, i.parenleft = 333, i.parenright = 333, i.asterisk = 389, i.plus = 584, i.comma = 278, i.hyphen = 333, i.period = 278, i.slash = 278, i.zero = 556, i.one = 556, i.two = 556, i.three = 556, i.four = 556, i.five = 556, i.six = 556, i.seven = 556, i.eight = 556, i.nine = 556, i.colon = 278, i.semicolon = 278, i.less = 584, i.equal = 584, i.greater = 584, i.question = 556, i.at = 1015, i.A = 667, i.B = 667, i.C = 722, i.D = 722, i.E = 667, i.F = 611, i.G = 778, i.H = 722, i.I = 278, i.J = 500, i.K = 667, i.L = 556, i.M = 833, i.N = 722, i.O = 778, i.P = 667, i.Q = 778, i.R = 722, i.S = 667, i.T = 611, i.U = 722, i.V = 667, i.W = 944, i.X = 667, i.Y = 667, i.Z = 611, i.bracketleft = 278, i.backslash = 278, i.bracketright = 278, i.asciicircum = 469, i.underscore = 556, i.quoteleft = 222, i.a = 556, i.b = 556, i.c = 500, i.d = 556, i.e = 556, i.f = 278, i.g = 556, i.h = 556, i.i = 222, i.j = 222, i.k = 500, i.l = 222, i.m = 833, i.n = 556, i.o = 556, i.p = 556, i.q = 556, i.r = 333, i.s = 500, i.t = 278, i.u = 556, i.v = 500, i.w = 722, i.x = 500, i.y = 500, i.z = 500, i.braceleft = 334, i.bar = 260, i.braceright = 334, i.asciitilde = 584, i.exclamdown = 333, i.cent = 556, i.sterling = 556, i.fraction = 167, i.yen = 556, i.florin = 556, i.section = 556, i.currency = 556, i.quotesingle = 191, i.quotedblleft = 333, i.guillemotleft = 556, i.guilsinglleft = 333, i.guilsinglright = 333, i.fi = 500, i.fl = 500, i.endash = 556, i.dagger = 556, i.daggerdbl = 556, i.periodcentered = 278, i.paragraph = 537, i.bullet = 350, i.quotesinglbase = 222, i.quotedblbase = 333, i.quotedblright = 333, i.guillemotright = 556, i.ellipsis = 1e3, i.perthousand = 1e3, i.questiondown = 611, i.grave = 333, i.acute = 333, i.circumflex = 333, i.tilde = 333, i.macron = 333, i.breve = 333, i.dotaccent = 333, i.dieresis = 333, i.ring = 333, i.cedilla = 333, i.hungarumlaut = 333, i.ogonek = 333, i.caron = 333, i.emdash = 1e3, i.AE = 1e3, i.ordfeminine = 370, i.Lslash = 556, i.Oslash = 778, i.OE = 1e3, i.ordmasculine = 365, i.ae = 889, i.dotlessi = 278, i.lslash = 222, i.oslash = 611, i.oe = 944, i.germandbls = 611, i.Idieresis = 278, i.eacute = 556, i.abreve = 556, i.uhungarumlaut = 556, i.ecaron = 556, i.Ydieresis = 667, i.divide = 584, i.Yacute = 667, i.Acircumflex = 667, i.aacute = 556, i.Ucircumflex = 722, i.yacute = 500, i.scommaaccent = 500, i.ecircumflex = 556, i.Uring = 722, i.Udieresis = 722, i.aogonek = 556, i.Uacute = 722, i.uogonek = 556, i.Edieresis = 667, i.Dcroat = 722, i.commaaccent = 250, i.copyright = 737, i.Emacron = 667, i.ccaron = 500, i.aring = 556, i.Ncommaaccent = 722, i.lacute = 222, i.agrave = 556, i.Tcommaaccent = 611, i.Cacute = 722, i.atilde = 556, i.Edotaccent = 667, i.scaron = 500, i.scedilla = 500, i.iacute = 278, i.lozenge = 471, i.Rcaron = 722, i.Gcommaaccent = 778, i.ucircumflex = 556, i.acircumflex = 556, i.Amacron = 667, i.rcaron = 333, i.ccedilla = 500, i.Zdotaccent = 611, i.Thorn = 667, i.Omacron = 778, i.Racute = 722, i.Sacute = 667, i.dcaron = 643, i.Umacron = 722, i.uring = 556, i.threesuperior = 333, i.Ograve = 778, i.Agrave = 667, i.Abreve = 667, i.multiply = 584, i.uacute = 556, i.Tcaron = 611, i.partialdiff = 476, i.ydieresis = 500, i.Nacute = 722, i.icircumflex = 278, i.Ecircumflex = 667, i.adieresis = 556, i.edieresis = 556, i.cacute = 500, i.nacute = 556, i.umacron = 556, i.Ncaron = 722, i.Iacute = 278, i.plusminus = 584, i.brokenbar = 260, i.registered = 737, i.Gbreve = 778, i.Idotaccent = 278, i.summation = 600, i.Egrave = 667, i.racute = 333, i.omacron = 556, i.Zacute = 611, i.Zcaron = 611, i.greaterequal = 549, i.Eth = 722, i.Ccedilla = 722, i.lcommaaccent = 222, i.tcaron = 317, i.eogonek = 556, i.Uogonek = 722, i.Aacute = 667, i.Adieresis = 667, i.egrave = 556, i.zacute = 500, i.iogonek = 222, i.Oacute = 778, i.oacute = 556, i.amacron = 556, i.sacute = 500, i.idieresis = 278, i.Ocircumflex = 778, i.Ugrave = 722, i.Delta = 612, i.thorn = 556, i.twosuperior = 333, i.Odieresis = 778, i.mu = 556, i.igrave = 278, i.ohungarumlaut = 556, i.Eogonek = 667, i.dcroat = 556, i.threequarters = 834, i.Scedilla = 667, i.lcaron = 299, i.Kcommaaccent = 667, i.Lacute = 556, i.trademark = 1e3, i.edotaccent = 556, i.Igrave = 278, i.Imacron = 278, i.Lcaron = 556, i.onehalf = 834, i.lessequal = 549, i.ocircumflex = 556, i.ntilde = 556, i.Uhungarumlaut = 722, i.Eacute = 667, i.emacron = 556, i.gbreve = 556, i.onequarter = 834, i.Scaron = 667, i.Scommaaccent = 667, i.Ohungarumlaut = 778, i.degree = 400, i.ograve = 556, i.Ccaron = 722, i.ugrave = 556, i.radical = 453, i.Dcaron = 722, i.rcommaaccent = 333, i.Ntilde = 722, i.otilde = 556, i.Rcommaaccent = 722, i.Lcommaaccent = 556, i.Atilde = 667, i.Aogonek = 667, i.Aring = 667, i.Otilde = 778, i.zdotaccent = 500, i.Ecaron = 667, i.Iogonek = 278, i.kcommaaccent = 500, i.minus = 584, i.Icircumflex = 278, i.ncaron = 556, i.tcommaaccent = 278, i.logicalnot = 584, i.odieresis = 556, i.udieresis = 556, i.notequal = 549, i.gcommaaccent = 556, i.eth = 556, i.zcaron = 500, i.ncommaaccent = 556, i.onesuperior = 333, i.imacron = 278, i.Euro = 556;
            }), t["Helvetica-Bold"] = (0, s.getLookupTableFactory)(function(i) {
              i.space = 278, i.exclam = 333, i.quotedbl = 474, i.numbersign = 556, i.dollar = 556, i.percent = 889, i.ampersand = 722, i.quoteright = 278, i.parenleft = 333, i.parenright = 333, i.asterisk = 389, i.plus = 584, i.comma = 278, i.hyphen = 333, i.period = 278, i.slash = 278, i.zero = 556, i.one = 556, i.two = 556, i.three = 556, i.four = 556, i.five = 556, i.six = 556, i.seven = 556, i.eight = 556, i.nine = 556, i.colon = 333, i.semicolon = 333, i.less = 584, i.equal = 584, i.greater = 584, i.question = 611, i.at = 975, i.A = 722, i.B = 722, i.C = 722, i.D = 722, i.E = 667, i.F = 611, i.G = 778, i.H = 722, i.I = 278, i.J = 556, i.K = 722, i.L = 611, i.M = 833, i.N = 722, i.O = 778, i.P = 667, i.Q = 778, i.R = 722, i.S = 667, i.T = 611, i.U = 722, i.V = 667, i.W = 944, i.X = 667, i.Y = 667, i.Z = 611, i.bracketleft = 333, i.backslash = 278, i.bracketright = 333, i.asciicircum = 584, i.underscore = 556, i.quoteleft = 278, i.a = 556, i.b = 611, i.c = 556, i.d = 611, i.e = 556, i.f = 333, i.g = 611, i.h = 611, i.i = 278, i.j = 278, i.k = 556, i.l = 278, i.m = 889, i.n = 611, i.o = 611, i.p = 611, i.q = 611, i.r = 389, i.s = 556, i.t = 333, i.u = 611, i.v = 556, i.w = 778, i.x = 556, i.y = 556, i.z = 500, i.braceleft = 389, i.bar = 280, i.braceright = 389, i.asciitilde = 584, i.exclamdown = 333, i.cent = 556, i.sterling = 556, i.fraction = 167, i.yen = 556, i.florin = 556, i.section = 556, i.currency = 556, i.quotesingle = 238, i.quotedblleft = 500, i.guillemotleft = 556, i.guilsinglleft = 333, i.guilsinglright = 333, i.fi = 611, i.fl = 611, i.endash = 556, i.dagger = 556, i.daggerdbl = 556, i.periodcentered = 278, i.paragraph = 556, i.bullet = 350, i.quotesinglbase = 278, i.quotedblbase = 500, i.quotedblright = 500, i.guillemotright = 556, i.ellipsis = 1e3, i.perthousand = 1e3, i.questiondown = 611, i.grave = 333, i.acute = 333, i.circumflex = 333, i.tilde = 333, i.macron = 333, i.breve = 333, i.dotaccent = 333, i.dieresis = 333, i.ring = 333, i.cedilla = 333, i.hungarumlaut = 333, i.ogonek = 333, i.caron = 333, i.emdash = 1e3, i.AE = 1e3, i.ordfeminine = 370, i.Lslash = 611, i.Oslash = 778, i.OE = 1e3, i.ordmasculine = 365, i.ae = 889, i.dotlessi = 278, i.lslash = 278, i.oslash = 611, i.oe = 944, i.germandbls = 611, i.Idieresis = 278, i.eacute = 556, i.abreve = 556, i.uhungarumlaut = 611, i.ecaron = 556, i.Ydieresis = 667, i.divide = 584, i.Yacute = 667, i.Acircumflex = 722, i.aacute = 556, i.Ucircumflex = 722, i.yacute = 556, i.scommaaccent = 556, i.ecircumflex = 556, i.Uring = 722, i.Udieresis = 722, i.aogonek = 556, i.Uacute = 722, i.uogonek = 611, i.Edieresis = 667, i.Dcroat = 722, i.commaaccent = 250, i.copyright = 737, i.Emacron = 667, i.ccaron = 556, i.aring = 556, i.Ncommaaccent = 722, i.lacute = 278, i.agrave = 556, i.Tcommaaccent = 611, i.Cacute = 722, i.atilde = 556, i.Edotaccent = 667, i.scaron = 556, i.scedilla = 556, i.iacute = 278, i.lozenge = 494, i.Rcaron = 722, i.Gcommaaccent = 778, i.ucircumflex = 611, i.acircumflex = 556, i.Amacron = 722, i.rcaron = 389, i.ccedilla = 556, i.Zdotaccent = 611, i.Thorn = 667, i.Omacron = 778, i.Racute = 722, i.Sacute = 667, i.dcaron = 743, i.Umacron = 722, i.uring = 611, i.threesuperior = 333, i.Ograve = 778, i.Agrave = 722, i.Abreve = 722, i.multiply = 584, i.uacute = 611, i.Tcaron = 611, i.partialdiff = 494, i.ydieresis = 556, i.Nacute = 722, i.icircumflex = 278, i.Ecircumflex = 667, i.adieresis = 556, i.edieresis = 556, i.cacute = 556, i.nacute = 611, i.umacron = 611, i.Ncaron = 722, i.Iacute = 278, i.plusminus = 584, i.brokenbar = 280, i.registered = 737, i.Gbreve = 778, i.Idotaccent = 278, i.summation = 600, i.Egrave = 667, i.racute = 389, i.omacron = 611, i.Zacute = 611, i.Zcaron = 611, i.greaterequal = 549, i.Eth = 722, i.Ccedilla = 722, i.lcommaaccent = 278, i.tcaron = 389, i.eogonek = 556, i.Uogonek = 722, i.Aacute = 722, i.Adieresis = 722, i.egrave = 556, i.zacute = 500, i.iogonek = 278, i.Oacute = 778, i.oacute = 611, i.amacron = 556, i.sacute = 556, i.idieresis = 278, i.Ocircumflex = 778, i.Ugrave = 722, i.Delta = 612, i.thorn = 611, i.twosuperior = 333, i.Odieresis = 778, i.mu = 611, i.igrave = 278, i.ohungarumlaut = 611, i.Eogonek = 667, i.dcroat = 611, i.threequarters = 834, i.Scedilla = 667, i.lcaron = 400, i.Kcommaaccent = 722, i.Lacute = 611, i.trademark = 1e3, i.edotaccent = 556, i.Igrave = 278, i.Imacron = 278, i.Lcaron = 611, i.onehalf = 834, i.lessequal = 549, i.ocircumflex = 611, i.ntilde = 611, i.Uhungarumlaut = 722, i.Eacute = 667, i.emacron = 556, i.gbreve = 611, i.onequarter = 834, i.Scaron = 667, i.Scommaaccent = 667, i.Ohungarumlaut = 778, i.degree = 400, i.ograve = 611, i.Ccaron = 722, i.ugrave = 611, i.radical = 549, i.Dcaron = 722, i.rcommaaccent = 389, i.Ntilde = 722, i.otilde = 611, i.Rcommaaccent = 722, i.Lcommaaccent = 611, i.Atilde = 722, i.Aogonek = 722, i.Aring = 722, i.Otilde = 778, i.zdotaccent = 500, i.Ecaron = 667, i.Iogonek = 278, i.kcommaaccent = 556, i.minus = 584, i.Icircumflex = 278, i.ncaron = 611, i.tcommaaccent = 333, i.logicalnot = 584, i.odieresis = 611, i.udieresis = 611, i.notequal = 549, i.gcommaaccent = 611, i.eth = 611, i.zcaron = 500, i.ncommaaccent = 611, i.onesuperior = 333, i.imacron = 278, i.Euro = 556;
            }), t["Helvetica-BoldOblique"] = (0, s.getLookupTableFactory)(function(i) {
              i.space = 278, i.exclam = 333, i.quotedbl = 474, i.numbersign = 556, i.dollar = 556, i.percent = 889, i.ampersand = 722, i.quoteright = 278, i.parenleft = 333, i.parenright = 333, i.asterisk = 389, i.plus = 584, i.comma = 278, i.hyphen = 333, i.period = 278, i.slash = 278, i.zero = 556, i.one = 556, i.two = 556, i.three = 556, i.four = 556, i.five = 556, i.six = 556, i.seven = 556, i.eight = 556, i.nine = 556, i.colon = 333, i.semicolon = 333, i.less = 584, i.equal = 584, i.greater = 584, i.question = 611, i.at = 975, i.A = 722, i.B = 722, i.C = 722, i.D = 722, i.E = 667, i.F = 611, i.G = 778, i.H = 722, i.I = 278, i.J = 556, i.K = 722, i.L = 611, i.M = 833, i.N = 722, i.O = 778, i.P = 667, i.Q = 778, i.R = 722, i.S = 667, i.T = 611, i.U = 722, i.V = 667, i.W = 944, i.X = 667, i.Y = 667, i.Z = 611, i.bracketleft = 333, i.backslash = 278, i.bracketright = 333, i.asciicircum = 584, i.underscore = 556, i.quoteleft = 278, i.a = 556, i.b = 611, i.c = 556, i.d = 611, i.e = 556, i.f = 333, i.g = 611, i.h = 611, i.i = 278, i.j = 278, i.k = 556, i.l = 278, i.m = 889, i.n = 611, i.o = 611, i.p = 611, i.q = 611, i.r = 389, i.s = 556, i.t = 333, i.u = 611, i.v = 556, i.w = 778, i.x = 556, i.y = 556, i.z = 500, i.braceleft = 389, i.bar = 280, i.braceright = 389, i.asciitilde = 584, i.exclamdown = 333, i.cent = 556, i.sterling = 556, i.fraction = 167, i.yen = 556, i.florin = 556, i.section = 556, i.currency = 556, i.quotesingle = 238, i.quotedblleft = 500, i.guillemotleft = 556, i.guilsinglleft = 333, i.guilsinglright = 333, i.fi = 611, i.fl = 611, i.endash = 556, i.dagger = 556, i.daggerdbl = 556, i.periodcentered = 278, i.paragraph = 556, i.bullet = 350, i.quotesinglbase = 278, i.quotedblbase = 500, i.quotedblright = 500, i.guillemotright = 556, i.ellipsis = 1e3, i.perthousand = 1e3, i.questiondown = 611, i.grave = 333, i.acute = 333, i.circumflex = 333, i.tilde = 333, i.macron = 333, i.breve = 333, i.dotaccent = 333, i.dieresis = 333, i.ring = 333, i.cedilla = 333, i.hungarumlaut = 333, i.ogonek = 333, i.caron = 333, i.emdash = 1e3, i.AE = 1e3, i.ordfeminine = 370, i.Lslash = 611, i.Oslash = 778, i.OE = 1e3, i.ordmasculine = 365, i.ae = 889, i.dotlessi = 278, i.lslash = 278, i.oslash = 611, i.oe = 944, i.germandbls = 611, i.Idieresis = 278, i.eacute = 556, i.abreve = 556, i.uhungarumlaut = 611, i.ecaron = 556, i.Ydieresis = 667, i.divide = 584, i.Yacute = 667, i.Acircumflex = 722, i.aacute = 556, i.Ucircumflex = 722, i.yacute = 556, i.scommaaccent = 556, i.ecircumflex = 556, i.Uring = 722, i.Udieresis = 722, i.aogonek = 556, i.Uacute = 722, i.uogonek = 611, i.Edieresis = 667, i.Dcroat = 722, i.commaaccent = 250, i.copyright = 737, i.Emacron = 667, i.ccaron = 556, i.aring = 556, i.Ncommaaccent = 722, i.lacute = 278, i.agrave = 556, i.Tcommaaccent = 611, i.Cacute = 722, i.atilde = 556, i.Edotaccent = 667, i.scaron = 556, i.scedilla = 556, i.iacute = 278, i.lozenge = 494, i.Rcaron = 722, i.Gcommaaccent = 778, i.ucircumflex = 611, i.acircumflex = 556, i.Amacron = 722, i.rcaron = 389, i.ccedilla = 556, i.Zdotaccent = 611, i.Thorn = 667, i.Omacron = 778, i.Racute = 722, i.Sacute = 667, i.dcaron = 743, i.Umacron = 722, i.uring = 611, i.threesuperior = 333, i.Ograve = 778, i.Agrave = 722, i.Abreve = 722, i.multiply = 584, i.uacute = 611, i.Tcaron = 611, i.partialdiff = 494, i.ydieresis = 556, i.Nacute = 722, i.icircumflex = 278, i.Ecircumflex = 667, i.adieresis = 556, i.edieresis = 556, i.cacute = 556, i.nacute = 611, i.umacron = 611, i.Ncaron = 722, i.Iacute = 278, i.plusminus = 584, i.brokenbar = 280, i.registered = 737, i.Gbreve = 778, i.Idotaccent = 278, i.summation = 600, i.Egrave = 667, i.racute = 389, i.omacron = 611, i.Zacute = 611, i.Zcaron = 611, i.greaterequal = 549, i.Eth = 722, i.Ccedilla = 722, i.lcommaaccent = 278, i.tcaron = 389, i.eogonek = 556, i.Uogonek = 722, i.Aacute = 722, i.Adieresis = 722, i.egrave = 556, i.zacute = 500, i.iogonek = 278, i.Oacute = 778, i.oacute = 611, i.amacron = 556, i.sacute = 556, i.idieresis = 278, i.Ocircumflex = 778, i.Ugrave = 722, i.Delta = 612, i.thorn = 611, i.twosuperior = 333, i.Odieresis = 778, i.mu = 611, i.igrave = 278, i.ohungarumlaut = 611, i.Eogonek = 667, i.dcroat = 611, i.threequarters = 834, i.Scedilla = 667, i.lcaron = 400, i.Kcommaaccent = 722, i.Lacute = 611, i.trademark = 1e3, i.edotaccent = 556, i.Igrave = 278, i.Imacron = 278, i.Lcaron = 611, i.onehalf = 834, i.lessequal = 549, i.ocircumflex = 611, i.ntilde = 611, i.Uhungarumlaut = 722, i.Eacute = 667, i.emacron = 556, i.gbreve = 611, i.onequarter = 834, i.Scaron = 667, i.Scommaaccent = 667, i.Ohungarumlaut = 778, i.degree = 400, i.ograve = 611, i.Ccaron = 722, i.ugrave = 611, i.radical = 549, i.Dcaron = 722, i.rcommaaccent = 389, i.Ntilde = 722, i.otilde = 611, i.Rcommaaccent = 722, i.Lcommaaccent = 611, i.Atilde = 722, i.Aogonek = 722, i.Aring = 722, i.Otilde = 778, i.zdotaccent = 500, i.Ecaron = 667, i.Iogonek = 278, i.kcommaaccent = 556, i.minus = 584, i.Icircumflex = 278, i.ncaron = 611, i.tcommaaccent = 333, i.logicalnot = 584, i.odieresis = 611, i.udieresis = 611, i.notequal = 549, i.gcommaaccent = 611, i.eth = 611, i.zcaron = 500, i.ncommaaccent = 611, i.onesuperior = 333, i.imacron = 278, i.Euro = 556;
            }), t["Helvetica-Oblique"] = (0, s.getLookupTableFactory)(function(i) {
              i.space = 278, i.exclam = 278, i.quotedbl = 355, i.numbersign = 556, i.dollar = 556, i.percent = 889, i.ampersand = 667, i.quoteright = 222, i.parenleft = 333, i.parenright = 333, i.asterisk = 389, i.plus = 584, i.comma = 278, i.hyphen = 333, i.period = 278, i.slash = 278, i.zero = 556, i.one = 556, i.two = 556, i.three = 556, i.four = 556, i.five = 556, i.six = 556, i.seven = 556, i.eight = 556, i.nine = 556, i.colon = 278, i.semicolon = 278, i.less = 584, i.equal = 584, i.greater = 584, i.question = 556, i.at = 1015, i.A = 667, i.B = 667, i.C = 722, i.D = 722, i.E = 667, i.F = 611, i.G = 778, i.H = 722, i.I = 278, i.J = 500, i.K = 667, i.L = 556, i.M = 833, i.N = 722, i.O = 778, i.P = 667, i.Q = 778, i.R = 722, i.S = 667, i.T = 611, i.U = 722, i.V = 667, i.W = 944, i.X = 667, i.Y = 667, i.Z = 611, i.bracketleft = 278, i.backslash = 278, i.bracketright = 278, i.asciicircum = 469, i.underscore = 556, i.quoteleft = 222, i.a = 556, i.b = 556, i.c = 500, i.d = 556, i.e = 556, i.f = 278, i.g = 556, i.h = 556, i.i = 222, i.j = 222, i.k = 500, i.l = 222, i.m = 833, i.n = 556, i.o = 556, i.p = 556, i.q = 556, i.r = 333, i.s = 500, i.t = 278, i.u = 556, i.v = 500, i.w = 722, i.x = 500, i.y = 500, i.z = 500, i.braceleft = 334, i.bar = 260, i.braceright = 334, i.asciitilde = 584, i.exclamdown = 333, i.cent = 556, i.sterling = 556, i.fraction = 167, i.yen = 556, i.florin = 556, i.section = 556, i.currency = 556, i.quotesingle = 191, i.quotedblleft = 333, i.guillemotleft = 556, i.guilsinglleft = 333, i.guilsinglright = 333, i.fi = 500, i.fl = 500, i.endash = 556, i.dagger = 556, i.daggerdbl = 556, i.periodcentered = 278, i.paragraph = 537, i.bullet = 350, i.quotesinglbase = 222, i.quotedblbase = 333, i.quotedblright = 333, i.guillemotright = 556, i.ellipsis = 1e3, i.perthousand = 1e3, i.questiondown = 611, i.grave = 333, i.acute = 333, i.circumflex = 333, i.tilde = 333, i.macron = 333, i.breve = 333, i.dotaccent = 333, i.dieresis = 333, i.ring = 333, i.cedilla = 333, i.hungarumlaut = 333, i.ogonek = 333, i.caron = 333, i.emdash = 1e3, i.AE = 1e3, i.ordfeminine = 370, i.Lslash = 556, i.Oslash = 778, i.OE = 1e3, i.ordmasculine = 365, i.ae = 889, i.dotlessi = 278, i.lslash = 222, i.oslash = 611, i.oe = 944, i.germandbls = 611, i.Idieresis = 278, i.eacute = 556, i.abreve = 556, i.uhungarumlaut = 556, i.ecaron = 556, i.Ydieresis = 667, i.divide = 584, i.Yacute = 667, i.Acircumflex = 667, i.aacute = 556, i.Ucircumflex = 722, i.yacute = 500, i.scommaaccent = 500, i.ecircumflex = 556, i.Uring = 722, i.Udieresis = 722, i.aogonek = 556, i.Uacute = 722, i.uogonek = 556, i.Edieresis = 667, i.Dcroat = 722, i.commaaccent = 250, i.copyright = 737, i.Emacron = 667, i.ccaron = 500, i.aring = 556, i.Ncommaaccent = 722, i.lacute = 222, i.agrave = 556, i.Tcommaaccent = 611, i.Cacute = 722, i.atilde = 556, i.Edotaccent = 667, i.scaron = 500, i.scedilla = 500, i.iacute = 278, i.lozenge = 471, i.Rcaron = 722, i.Gcommaaccent = 778, i.ucircumflex = 556, i.acircumflex = 556, i.Amacron = 667, i.rcaron = 333, i.ccedilla = 500, i.Zdotaccent = 611, i.Thorn = 667, i.Omacron = 778, i.Racute = 722, i.Sacute = 667, i.dcaron = 643, i.Umacron = 722, i.uring = 556, i.threesuperior = 333, i.Ograve = 778, i.Agrave = 667, i.Abreve = 667, i.multiply = 584, i.uacute = 556, i.Tcaron = 611, i.partialdiff = 476, i.ydieresis = 500, i.Nacute = 722, i.icircumflex = 278, i.Ecircumflex = 667, i.adieresis = 556, i.edieresis = 556, i.cacute = 500, i.nacute = 556, i.umacron = 556, i.Ncaron = 722, i.Iacute = 278, i.plusminus = 584, i.brokenbar = 260, i.registered = 737, i.Gbreve = 778, i.Idotaccent = 278, i.summation = 600, i.Egrave = 667, i.racute = 333, i.omacron = 556, i.Zacute = 611, i.Zcaron = 611, i.greaterequal = 549, i.Eth = 722, i.Ccedilla = 722, i.lcommaaccent = 222, i.tcaron = 317, i.eogonek = 556, i.Uogonek = 722, i.Aacute = 667, i.Adieresis = 667, i.egrave = 556, i.zacute = 500, i.iogonek = 222, i.Oacute = 778, i.oacute = 556, i.amacron = 556, i.sacute = 500, i.idieresis = 278, i.Ocircumflex = 778, i.Ugrave = 722, i.Delta = 612, i.thorn = 556, i.twosuperior = 333, i.Odieresis = 778, i.mu = 556, i.igrave = 278, i.ohungarumlaut = 556, i.Eogonek = 667, i.dcroat = 556, i.threequarters = 834, i.Scedilla = 667, i.lcaron = 299, i.Kcommaaccent = 667, i.Lacute = 556, i.trademark = 1e3, i.edotaccent = 556, i.Igrave = 278, i.Imacron = 278, i.Lcaron = 556, i.onehalf = 834, i.lessequal = 549, i.ocircumflex = 556, i.ntilde = 556, i.Uhungarumlaut = 722, i.Eacute = 667, i.emacron = 556, i.gbreve = 556, i.onequarter = 834, i.Scaron = 667, i.Scommaaccent = 667, i.Ohungarumlaut = 778, i.degree = 400, i.ograve = 556, i.Ccaron = 722, i.ugrave = 556, i.radical = 453, i.Dcaron = 722, i.rcommaaccent = 333, i.Ntilde = 722, i.otilde = 556, i.Rcommaaccent = 722, i.Lcommaaccent = 556, i.Atilde = 667, i.Aogonek = 667, i.Aring = 667, i.Otilde = 778, i.zdotaccent = 500, i.Ecaron = 667, i.Iogonek = 278, i.kcommaaccent = 500, i.minus = 584, i.Icircumflex = 278, i.ncaron = 556, i.tcommaaccent = 278, i.logicalnot = 584, i.odieresis = 556, i.udieresis = 556, i.notequal = 549, i.gcommaaccent = 556, i.eth = 556, i.zcaron = 500, i.ncommaaccent = 556, i.onesuperior = 333, i.imacron = 278, i.Euro = 556;
            }), t.Symbol = (0, s.getLookupTableFactory)(function(i) {
              i.space = 250, i.exclam = 333, i.universal = 713, i.numbersign = 500, i.existential = 549, i.percent = 833, i.ampersand = 778, i.suchthat = 439, i.parenleft = 333, i.parenright = 333, i.asteriskmath = 500, i.plus = 549, i.comma = 250, i.minus = 549, i.period = 250, i.slash = 278, i.zero = 500, i.one = 500, i.two = 500, i.three = 500, i.four = 500, i.five = 500, i.six = 500, i.seven = 500, i.eight = 500, i.nine = 500, i.colon = 278, i.semicolon = 278, i.less = 549, i.equal = 549, i.greater = 549, i.question = 444, i.congruent = 549, i.Alpha = 722, i.Beta = 667, i.Chi = 722, i.Delta = 612, i.Epsilon = 611, i.Phi = 763, i.Gamma = 603, i.Eta = 722, i.Iota = 333, i.theta1 = 631, i.Kappa = 722, i.Lambda = 686, i.Mu = 889, i.Nu = 722, i.Omicron = 722, i.Pi = 768, i.Theta = 741, i.Rho = 556, i.Sigma = 592, i.Tau = 611, i.Upsilon = 690, i.sigma1 = 439, i.Omega = 768, i.Xi = 645, i.Psi = 795, i.Zeta = 611, i.bracketleft = 333, i.therefore = 863, i.bracketright = 333, i.perpendicular = 658, i.underscore = 500, i.radicalex = 500, i.alpha = 631, i.beta = 549, i.chi = 549, i.delta = 494, i.epsilon = 439, i.phi = 521, i.gamma = 411, i.eta = 603, i.iota = 329, i.phi1 = 603, i.kappa = 549, i.lambda = 549, i.mu = 576, i.nu = 521, i.omicron = 549, i.pi = 549, i.theta = 521, i.rho = 549, i.sigma = 603, i.tau = 439, i.upsilon = 576, i.omega1 = 713, i.omega = 686, i.xi = 493, i.psi = 686, i.zeta = 494, i.braceleft = 480, i.bar = 200, i.braceright = 480, i.similar = 549, i.Euro = 750, i.Upsilon1 = 620, i.minute = 247, i.lessequal = 549, i.fraction = 167, i.infinity = 713, i.florin = 500, i.club = 753, i.diamond = 753, i.heart = 753, i.spade = 753, i.arrowboth = 1042, i.arrowleft = 987, i.arrowup = 603, i.arrowright = 987, i.arrowdown = 603, i.degree = 400, i.plusminus = 549, i.second = 411, i.greaterequal = 549, i.multiply = 549, i.proportional = 713, i.partialdiff = 494, i.bullet = 460, i.divide = 549, i.notequal = 549, i.equivalence = 549, i.approxequal = 549, i.ellipsis = 1e3, i.arrowvertex = 603, i.arrowhorizex = 1e3, i.carriagereturn = 658, i.aleph = 823, i.Ifraktur = 686, i.Rfraktur = 795, i.weierstrass = 987, i.circlemultiply = 768, i.circleplus = 768, i.emptyset = 823, i.intersection = 768, i.union = 768, i.propersuperset = 713, i.reflexsuperset = 713, i.notsubset = 713, i.propersubset = 713, i.reflexsubset = 713, i.element = 713, i.notelement = 713, i.angle = 768, i.gradient = 713, i.registerserif = 790, i.copyrightserif = 790, i.trademarkserif = 890, i.product = 823, i.radical = 549, i.dotmath = 250, i.logicalnot = 713, i.logicaland = 603, i.logicalor = 603, i.arrowdblboth = 1042, i.arrowdblleft = 987, i.arrowdblup = 603, i.arrowdblright = 987, i.arrowdbldown = 603, i.lozenge = 494, i.angleleft = 329, i.registersans = 790, i.copyrightsans = 790, i.trademarksans = 786, i.summation = 713, i.parenlefttp = 384, i.parenleftex = 384, i.parenleftbt = 384, i.bracketlefttp = 384, i.bracketleftex = 384, i.bracketleftbt = 384, i.bracelefttp = 494, i.braceleftmid = 494, i.braceleftbt = 494, i.braceex = 494, i.angleright = 329, i.integral = 274, i.integraltp = 686, i.integralex = 686, i.integralbt = 686, i.parenrighttp = 384, i.parenrightex = 384, i.parenrightbt = 384, i.bracketrighttp = 384, i.bracketrightex = 384, i.bracketrightbt = 384, i.bracerighttp = 494, i.bracerightmid = 494, i.bracerightbt = 494, i.apple = 790;
            }), t["Times-Roman"] = (0, s.getLookupTableFactory)(function(i) {
              i.space = 250, i.exclam = 333, i.quotedbl = 408, i.numbersign = 500, i.dollar = 500, i.percent = 833, i.ampersand = 778, i.quoteright = 333, i.parenleft = 333, i.parenright = 333, i.asterisk = 500, i.plus = 564, i.comma = 250, i.hyphen = 333, i.period = 250, i.slash = 278, i.zero = 500, i.one = 500, i.two = 500, i.three = 500, i.four = 500, i.five = 500, i.six = 500, i.seven = 500, i.eight = 500, i.nine = 500, i.colon = 278, i.semicolon = 278, i.less = 564, i.equal = 564, i.greater = 564, i.question = 444, i.at = 921, i.A = 722, i.B = 667, i.C = 667, i.D = 722, i.E = 611, i.F = 556, i.G = 722, i.H = 722, i.I = 333, i.J = 389, i.K = 722, i.L = 611, i.M = 889, i.N = 722, i.O = 722, i.P = 556, i.Q = 722, i.R = 667, i.S = 556, i.T = 611, i.U = 722, i.V = 722, i.W = 944, i.X = 722, i.Y = 722, i.Z = 611, i.bracketleft = 333, i.backslash = 278, i.bracketright = 333, i.asciicircum = 469, i.underscore = 500, i.quoteleft = 333, i.a = 444, i.b = 500, i.c = 444, i.d = 500, i.e = 444, i.f = 333, i.g = 500, i.h = 500, i.i = 278, i.j = 278, i.k = 500, i.l = 278, i.m = 778, i.n = 500, i.o = 500, i.p = 500, i.q = 500, i.r = 333, i.s = 389, i.t = 278, i.u = 500, i.v = 500, i.w = 722, i.x = 500, i.y = 500, i.z = 444, i.braceleft = 480, i.bar = 200, i.braceright = 480, i.asciitilde = 541, i.exclamdown = 333, i.cent = 500, i.sterling = 500, i.fraction = 167, i.yen = 500, i.florin = 500, i.section = 500, i.currency = 500, i.quotesingle = 180, i.quotedblleft = 444, i.guillemotleft = 500, i.guilsinglleft = 333, i.guilsinglright = 333, i.fi = 556, i.fl = 556, i.endash = 500, i.dagger = 500, i.daggerdbl = 500, i.periodcentered = 250, i.paragraph = 453, i.bullet = 350, i.quotesinglbase = 333, i.quotedblbase = 444, i.quotedblright = 444, i.guillemotright = 500, i.ellipsis = 1e3, i.perthousand = 1e3, i.questiondown = 444, i.grave = 333, i.acute = 333, i.circumflex = 333, i.tilde = 333, i.macron = 333, i.breve = 333, i.dotaccent = 333, i.dieresis = 333, i.ring = 333, i.cedilla = 333, i.hungarumlaut = 333, i.ogonek = 333, i.caron = 333, i.emdash = 1e3, i.AE = 889, i.ordfeminine = 276, i.Lslash = 611, i.Oslash = 722, i.OE = 889, i.ordmasculine = 310, i.ae = 667, i.dotlessi = 278, i.lslash = 278, i.oslash = 500, i.oe = 722, i.germandbls = 500, i.Idieresis = 333, i.eacute = 444, i.abreve = 444, i.uhungarumlaut = 500, i.ecaron = 444, i.Ydieresis = 722, i.divide = 564, i.Yacute = 722, i.Acircumflex = 722, i.aacute = 444, i.Ucircumflex = 722, i.yacute = 500, i.scommaaccent = 389, i.ecircumflex = 444, i.Uring = 722, i.Udieresis = 722, i.aogonek = 444, i.Uacute = 722, i.uogonek = 500, i.Edieresis = 611, i.Dcroat = 722, i.commaaccent = 250, i.copyright = 760, i.Emacron = 611, i.ccaron = 444, i.aring = 444, i.Ncommaaccent = 722, i.lacute = 278, i.agrave = 444, i.Tcommaaccent = 611, i.Cacute = 667, i.atilde = 444, i.Edotaccent = 611, i.scaron = 389, i.scedilla = 389, i.iacute = 278, i.lozenge = 471, i.Rcaron = 667, i.Gcommaaccent = 722, i.ucircumflex = 500, i.acircumflex = 444, i.Amacron = 722, i.rcaron = 333, i.ccedilla = 444, i.Zdotaccent = 611, i.Thorn = 556, i.Omacron = 722, i.Racute = 667, i.Sacute = 556, i.dcaron = 588, i.Umacron = 722, i.uring = 500, i.threesuperior = 300, i.Ograve = 722, i.Agrave = 722, i.Abreve = 722, i.multiply = 564, i.uacute = 500, i.Tcaron = 611, i.partialdiff = 476, i.ydieresis = 500, i.Nacute = 722, i.icircumflex = 278, i.Ecircumflex = 611, i.adieresis = 444, i.edieresis = 444, i.cacute = 444, i.nacute = 500, i.umacron = 500, i.Ncaron = 722, i.Iacute = 333, i.plusminus = 564, i.brokenbar = 200, i.registered = 760, i.Gbreve = 722, i.Idotaccent = 333, i.summation = 600, i.Egrave = 611, i.racute = 333, i.omacron = 500, i.Zacute = 611, i.Zcaron = 611, i.greaterequal = 549, i.Eth = 722, i.Ccedilla = 667, i.lcommaaccent = 278, i.tcaron = 326, i.eogonek = 444, i.Uogonek = 722, i.Aacute = 722, i.Adieresis = 722, i.egrave = 444, i.zacute = 444, i.iogonek = 278, i.Oacute = 722, i.oacute = 500, i.amacron = 444, i.sacute = 389, i.idieresis = 278, i.Ocircumflex = 722, i.Ugrave = 722, i.Delta = 612, i.thorn = 500, i.twosuperior = 300, i.Odieresis = 722, i.mu = 500, i.igrave = 278, i.ohungarumlaut = 500, i.Eogonek = 611, i.dcroat = 500, i.threequarters = 750, i.Scedilla = 556, i.lcaron = 344, i.Kcommaaccent = 722, i.Lacute = 611, i.trademark = 980, i.edotaccent = 444, i.Igrave = 333, i.Imacron = 333, i.Lcaron = 611, i.onehalf = 750, i.lessequal = 549, i.ocircumflex = 500, i.ntilde = 500, i.Uhungarumlaut = 722, i.Eacute = 611, i.emacron = 444, i.gbreve = 500, i.onequarter = 750, i.Scaron = 556, i.Scommaaccent = 556, i.Ohungarumlaut = 722, i.degree = 400, i.ograve = 500, i.Ccaron = 667, i.ugrave = 500, i.radical = 453, i.Dcaron = 722, i.rcommaaccent = 333, i.Ntilde = 722, i.otilde = 500, i.Rcommaaccent = 667, i.Lcommaaccent = 611, i.Atilde = 722, i.Aogonek = 722, i.Aring = 722, i.Otilde = 722, i.zdotaccent = 444, i.Ecaron = 611, i.Iogonek = 333, i.kcommaaccent = 500, i.minus = 564, i.Icircumflex = 333, i.ncaron = 500, i.tcommaaccent = 278, i.logicalnot = 564, i.odieresis = 500, i.udieresis = 500, i.notequal = 549, i.gcommaaccent = 500, i.eth = 500, i.zcaron = 444, i.ncommaaccent = 500, i.onesuperior = 300, i.imacron = 278, i.Euro = 500;
            }), t["Times-Bold"] = (0, s.getLookupTableFactory)(function(i) {
              i.space = 250, i.exclam = 333, i.quotedbl = 555, i.numbersign = 500, i.dollar = 500, i.percent = 1e3, i.ampersand = 833, i.quoteright = 333, i.parenleft = 333, i.parenright = 333, i.asterisk = 500, i.plus = 570, i.comma = 250, i.hyphen = 333, i.period = 250, i.slash = 278, i.zero = 500, i.one = 500, i.two = 500, i.three = 500, i.four = 500, i.five = 500, i.six = 500, i.seven = 500, i.eight = 500, i.nine = 500, i.colon = 333, i.semicolon = 333, i.less = 570, i.equal = 570, i.greater = 570, i.question = 500, i.at = 930, i.A = 722, i.B = 667, i.C = 722, i.D = 722, i.E = 667, i.F = 611, i.G = 778, i.H = 778, i.I = 389, i.J = 500, i.K = 778, i.L = 667, i.M = 944, i.N = 722, i.O = 778, i.P = 611, i.Q = 778, i.R = 722, i.S = 556, i.T = 667, i.U = 722, i.V = 722, i.W = 1e3, i.X = 722, i.Y = 722, i.Z = 667, i.bracketleft = 333, i.backslash = 278, i.bracketright = 333, i.asciicircum = 581, i.underscore = 500, i.quoteleft = 333, i.a = 500, i.b = 556, i.c = 444, i.d = 556, i.e = 444, i.f = 333, i.g = 500, i.h = 556, i.i = 278, i.j = 333, i.k = 556, i.l = 278, i.m = 833, i.n = 556, i.o = 500, i.p = 556, i.q = 556, i.r = 444, i.s = 389, i.t = 333, i.u = 556, i.v = 500, i.w = 722, i.x = 500, i.y = 500, i.z = 444, i.braceleft = 394, i.bar = 220, i.braceright = 394, i.asciitilde = 520, i.exclamdown = 333, i.cent = 500, i.sterling = 500, i.fraction = 167, i.yen = 500, i.florin = 500, i.section = 500, i.currency = 500, i.quotesingle = 278, i.quotedblleft = 500, i.guillemotleft = 500, i.guilsinglleft = 333, i.guilsinglright = 333, i.fi = 556, i.fl = 556, i.endash = 500, i.dagger = 500, i.daggerdbl = 500, i.periodcentered = 250, i.paragraph = 540, i.bullet = 350, i.quotesinglbase = 333, i.quotedblbase = 500, i.quotedblright = 500, i.guillemotright = 500, i.ellipsis = 1e3, i.perthousand = 1e3, i.questiondown = 500, i.grave = 333, i.acute = 333, i.circumflex = 333, i.tilde = 333, i.macron = 333, i.breve = 333, i.dotaccent = 333, i.dieresis = 333, i.ring = 333, i.cedilla = 333, i.hungarumlaut = 333, i.ogonek = 333, i.caron = 333, i.emdash = 1e3, i.AE = 1e3, i.ordfeminine = 300, i.Lslash = 667, i.Oslash = 778, i.OE = 1e3, i.ordmasculine = 330, i.ae = 722, i.dotlessi = 278, i.lslash = 278, i.oslash = 500, i.oe = 722, i.germandbls = 556, i.Idieresis = 389, i.eacute = 444, i.abreve = 500, i.uhungarumlaut = 556, i.ecaron = 444, i.Ydieresis = 722, i.divide = 570, i.Yacute = 722, i.Acircumflex = 722, i.aacute = 500, i.Ucircumflex = 722, i.yacute = 500, i.scommaaccent = 389, i.ecircumflex = 444, i.Uring = 722, i.Udieresis = 722, i.aogonek = 500, i.Uacute = 722, i.uogonek = 556, i.Edieresis = 667, i.Dcroat = 722, i.commaaccent = 250, i.copyright = 747, i.Emacron = 667, i.ccaron = 444, i.aring = 500, i.Ncommaaccent = 722, i.lacute = 278, i.agrave = 500, i.Tcommaaccent = 667, i.Cacute = 722, i.atilde = 500, i.Edotaccent = 667, i.scaron = 389, i.scedilla = 389, i.iacute = 278, i.lozenge = 494, i.Rcaron = 722, i.Gcommaaccent = 778, i.ucircumflex = 556, i.acircumflex = 500, i.Amacron = 722, i.rcaron = 444, i.ccedilla = 444, i.Zdotaccent = 667, i.Thorn = 611, i.Omacron = 778, i.Racute = 722, i.Sacute = 556, i.dcaron = 672, i.Umacron = 722, i.uring = 556, i.threesuperior = 300, i.Ograve = 778, i.Agrave = 722, i.Abreve = 722, i.multiply = 570, i.uacute = 556, i.Tcaron = 667, i.partialdiff = 494, i.ydieresis = 500, i.Nacute = 722, i.icircumflex = 278, i.Ecircumflex = 667, i.adieresis = 500, i.edieresis = 444, i.cacute = 444, i.nacute = 556, i.umacron = 556, i.Ncaron = 722, i.Iacute = 389, i.plusminus = 570, i.brokenbar = 220, i.registered = 747, i.Gbreve = 778, i.Idotaccent = 389, i.summation = 600, i.Egrave = 667, i.racute = 444, i.omacron = 500, i.Zacute = 667, i.Zcaron = 667, i.greaterequal = 549, i.Eth = 722, i.Ccedilla = 722, i.lcommaaccent = 278, i.tcaron = 416, i.eogonek = 444, i.Uogonek = 722, i.Aacute = 722, i.Adieresis = 722, i.egrave = 444, i.zacute = 444, i.iogonek = 278, i.Oacute = 778, i.oacute = 500, i.amacron = 500, i.sacute = 389, i.idieresis = 278, i.Ocircumflex = 778, i.Ugrave = 722, i.Delta = 612, i.thorn = 556, i.twosuperior = 300, i.Odieresis = 778, i.mu = 556, i.igrave = 278, i.ohungarumlaut = 500, i.Eogonek = 667, i.dcroat = 556, i.threequarters = 750, i.Scedilla = 556, i.lcaron = 394, i.Kcommaaccent = 778, i.Lacute = 667, i.trademark = 1e3, i.edotaccent = 444, i.Igrave = 389, i.Imacron = 389, i.Lcaron = 667, i.onehalf = 750, i.lessequal = 549, i.ocircumflex = 500, i.ntilde = 556, i.Uhungarumlaut = 722, i.Eacute = 667, i.emacron = 444, i.gbreve = 500, i.onequarter = 750, i.Scaron = 556, i.Scommaaccent = 556, i.Ohungarumlaut = 778, i.degree = 400, i.ograve = 500, i.Ccaron = 722, i.ugrave = 556, i.radical = 549, i.Dcaron = 722, i.rcommaaccent = 444, i.Ntilde = 722, i.otilde = 500, i.Rcommaaccent = 722, i.Lcommaaccent = 667, i.Atilde = 722, i.Aogonek = 722, i.Aring = 722, i.Otilde = 778, i.zdotaccent = 444, i.Ecaron = 667, i.Iogonek = 389, i.kcommaaccent = 556, i.minus = 570, i.Icircumflex = 389, i.ncaron = 556, i.tcommaaccent = 333, i.logicalnot = 570, i.odieresis = 500, i.udieresis = 556, i.notequal = 549, i.gcommaaccent = 500, i.eth = 500, i.zcaron = 444, i.ncommaaccent = 556, i.onesuperior = 300, i.imacron = 278, i.Euro = 500;
            }), t["Times-BoldItalic"] = (0, s.getLookupTableFactory)(function(i) {
              i.space = 250, i.exclam = 389, i.quotedbl = 555, i.numbersign = 500, i.dollar = 500, i.percent = 833, i.ampersand = 778, i.quoteright = 333, i.parenleft = 333, i.parenright = 333, i.asterisk = 500, i.plus = 570, i.comma = 250, i.hyphen = 333, i.period = 250, i.slash = 278, i.zero = 500, i.one = 500, i.two = 500, i.three = 500, i.four = 500, i.five = 500, i.six = 500, i.seven = 500, i.eight = 500, i.nine = 500, i.colon = 333, i.semicolon = 333, i.less = 570, i.equal = 570, i.greater = 570, i.question = 500, i.at = 832, i.A = 667, i.B = 667, i.C = 667, i.D = 722, i.E = 667, i.F = 667, i.G = 722, i.H = 778, i.I = 389, i.J = 500, i.K = 667, i.L = 611, i.M = 889, i.N = 722, i.O = 722, i.P = 611, i.Q = 722, i.R = 667, i.S = 556, i.T = 611, i.U = 722, i.V = 667, i.W = 889, i.X = 667, i.Y = 611, i.Z = 611, i.bracketleft = 333, i.backslash = 278, i.bracketright = 333, i.asciicircum = 570, i.underscore = 500, i.quoteleft = 333, i.a = 500, i.b = 500, i.c = 444, i.d = 500, i.e = 444, i.f = 333, i.g = 500, i.h = 556, i.i = 278, i.j = 278, i.k = 500, i.l = 278, i.m = 778, i.n = 556, i.o = 500, i.p = 500, i.q = 500, i.r = 389, i.s = 389, i.t = 278, i.u = 556, i.v = 444, i.w = 667, i.x = 500, i.y = 444, i.z = 389, i.braceleft = 348, i.bar = 220, i.braceright = 348, i.asciitilde = 570, i.exclamdown = 389, i.cent = 500, i.sterling = 500, i.fraction = 167, i.yen = 500, i.florin = 500, i.section = 500, i.currency = 500, i.quotesingle = 278, i.quotedblleft = 500, i.guillemotleft = 500, i.guilsinglleft = 333, i.guilsinglright = 333, i.fi = 556, i.fl = 556, i.endash = 500, i.dagger = 500, i.daggerdbl = 500, i.periodcentered = 250, i.paragraph = 500, i.bullet = 350, i.quotesinglbase = 333, i.quotedblbase = 500, i.quotedblright = 500, i.guillemotright = 500, i.ellipsis = 1e3, i.perthousand = 1e3, i.questiondown = 500, i.grave = 333, i.acute = 333, i.circumflex = 333, i.tilde = 333, i.macron = 333, i.breve = 333, i.dotaccent = 333, i.dieresis = 333, i.ring = 333, i.cedilla = 333, i.hungarumlaut = 333, i.ogonek = 333, i.caron = 333, i.emdash = 1e3, i.AE = 944, i.ordfeminine = 266, i.Lslash = 611, i.Oslash = 722, i.OE = 944, i.ordmasculine = 300, i.ae = 722, i.dotlessi = 278, i.lslash = 278, i.oslash = 500, i.oe = 722, i.germandbls = 500, i.Idieresis = 389, i.eacute = 444, i.abreve = 500, i.uhungarumlaut = 556, i.ecaron = 444, i.Ydieresis = 611, i.divide = 570, i.Yacute = 611, i.Acircumflex = 667, i.aacute = 500, i.Ucircumflex = 722, i.yacute = 444, i.scommaaccent = 389, i.ecircumflex = 444, i.Uring = 722, i.Udieresis = 722, i.aogonek = 500, i.Uacute = 722, i.uogonek = 556, i.Edieresis = 667, i.Dcroat = 722, i.commaaccent = 250, i.copyright = 747, i.Emacron = 667, i.ccaron = 444, i.aring = 500, i.Ncommaaccent = 722, i.lacute = 278, i.agrave = 500, i.Tcommaaccent = 611, i.Cacute = 667, i.atilde = 500, i.Edotaccent = 667, i.scaron = 389, i.scedilla = 389, i.iacute = 278, i.lozenge = 494, i.Rcaron = 667, i.Gcommaaccent = 722, i.ucircumflex = 556, i.acircumflex = 500, i.Amacron = 667, i.rcaron = 389, i.ccedilla = 444, i.Zdotaccent = 611, i.Thorn = 611, i.Omacron = 722, i.Racute = 667, i.Sacute = 556, i.dcaron = 608, i.Umacron = 722, i.uring = 556, i.threesuperior = 300, i.Ograve = 722, i.Agrave = 667, i.Abreve = 667, i.multiply = 570, i.uacute = 556, i.Tcaron = 611, i.partialdiff = 494, i.ydieresis = 444, i.Nacute = 722, i.icircumflex = 278, i.Ecircumflex = 667, i.adieresis = 500, i.edieresis = 444, i.cacute = 444, i.nacute = 556, i.umacron = 556, i.Ncaron = 722, i.Iacute = 389, i.plusminus = 570, i.brokenbar = 220, i.registered = 747, i.Gbreve = 722, i.Idotaccent = 389, i.summation = 600, i.Egrave = 667, i.racute = 389, i.omacron = 500, i.Zacute = 611, i.Zcaron = 611, i.greaterequal = 549, i.Eth = 722, i.Ccedilla = 667, i.lcommaaccent = 278, i.tcaron = 366, i.eogonek = 444, i.Uogonek = 722, i.Aacute = 667, i.Adieresis = 667, i.egrave = 444, i.zacute = 389, i.iogonek = 278, i.Oacute = 722, i.oacute = 500, i.amacron = 500, i.sacute = 389, i.idieresis = 278, i.Ocircumflex = 722, i.Ugrave = 722, i.Delta = 612, i.thorn = 500, i.twosuperior = 300, i.Odieresis = 722, i.mu = 576, i.igrave = 278, i.ohungarumlaut = 500, i.Eogonek = 667, i.dcroat = 500, i.threequarters = 750, i.Scedilla = 556, i.lcaron = 382, i.Kcommaaccent = 667, i.Lacute = 611, i.trademark = 1e3, i.edotaccent = 444, i.Igrave = 389, i.Imacron = 389, i.Lcaron = 611, i.onehalf = 750, i.lessequal = 549, i.ocircumflex = 500, i.ntilde = 556, i.Uhungarumlaut = 722, i.Eacute = 667, i.emacron = 444, i.gbreve = 500, i.onequarter = 750, i.Scaron = 556, i.Scommaaccent = 556, i.Ohungarumlaut = 722, i.degree = 400, i.ograve = 500, i.Ccaron = 667, i.ugrave = 556, i.radical = 549, i.Dcaron = 722, i.rcommaaccent = 389, i.Ntilde = 722, i.otilde = 500, i.Rcommaaccent = 667, i.Lcommaaccent = 611, i.Atilde = 667, i.Aogonek = 667, i.Aring = 667, i.Otilde = 722, i.zdotaccent = 389, i.Ecaron = 667, i.Iogonek = 389, i.kcommaaccent = 500, i.minus = 606, i.Icircumflex = 389, i.ncaron = 556, i.tcommaaccent = 278, i.logicalnot = 606, i.odieresis = 500, i.udieresis = 556, i.notequal = 549, i.gcommaaccent = 500, i.eth = 500, i.zcaron = 389, i.ncommaaccent = 556, i.onesuperior = 300, i.imacron = 278, i.Euro = 500;
            }), t["Times-Italic"] = (0, s.getLookupTableFactory)(function(i) {
              i.space = 250, i.exclam = 333, i.quotedbl = 420, i.numbersign = 500, i.dollar = 500, i.percent = 833, i.ampersand = 778, i.quoteright = 333, i.parenleft = 333, i.parenright = 333, i.asterisk = 500, i.plus = 675, i.comma = 250, i.hyphen = 333, i.period = 250, i.slash = 278, i.zero = 500, i.one = 500, i.two = 500, i.three = 500, i.four = 500, i.five = 500, i.six = 500, i.seven = 500, i.eight = 500, i.nine = 500, i.colon = 333, i.semicolon = 333, i.less = 675, i.equal = 675, i.greater = 675, i.question = 500, i.at = 920, i.A = 611, i.B = 611, i.C = 667, i.D = 722, i.E = 611, i.F = 611, i.G = 722, i.H = 722, i.I = 333, i.J = 444, i.K = 667, i.L = 556, i.M = 833, i.N = 667, i.O = 722, i.P = 611, i.Q = 722, i.R = 611, i.S = 500, i.T = 556, i.U = 722, i.V = 611, i.W = 833, i.X = 611, i.Y = 556, i.Z = 556, i.bracketleft = 389, i.backslash = 278, i.bracketright = 389, i.asciicircum = 422, i.underscore = 500, i.quoteleft = 333, i.a = 500, i.b = 500, i.c = 444, i.d = 500, i.e = 444, i.f = 278, i.g = 500, i.h = 500, i.i = 278, i.j = 278, i.k = 444, i.l = 278, i.m = 722, i.n = 500, i.o = 500, i.p = 500, i.q = 500, i.r = 389, i.s = 389, i.t = 278, i.u = 500, i.v = 444, i.w = 667, i.x = 444, i.y = 444, i.z = 389, i.braceleft = 400, i.bar = 275, i.braceright = 400, i.asciitilde = 541, i.exclamdown = 389, i.cent = 500, i.sterling = 500, i.fraction = 167, i.yen = 500, i.florin = 500, i.section = 500, i.currency = 500, i.quotesingle = 214, i.quotedblleft = 556, i.guillemotleft = 500, i.guilsinglleft = 333, i.guilsinglright = 333, i.fi = 500, i.fl = 500, i.endash = 500, i.dagger = 500, i.daggerdbl = 500, i.periodcentered = 250, i.paragraph = 523, i.bullet = 350, i.quotesinglbase = 333, i.quotedblbase = 556, i.quotedblright = 556, i.guillemotright = 500, i.ellipsis = 889, i.perthousand = 1e3, i.questiondown = 500, i.grave = 333, i.acute = 333, i.circumflex = 333, i.tilde = 333, i.macron = 333, i.breve = 333, i.dotaccent = 333, i.dieresis = 333, i.ring = 333, i.cedilla = 333, i.hungarumlaut = 333, i.ogonek = 333, i.caron = 333, i.emdash = 889, i.AE = 889, i.ordfeminine = 276, i.Lslash = 556, i.Oslash = 722, i.OE = 944, i.ordmasculine = 310, i.ae = 667, i.dotlessi = 278, i.lslash = 278, i.oslash = 500, i.oe = 667, i.germandbls = 500, i.Idieresis = 333, i.eacute = 444, i.abreve = 500, i.uhungarumlaut = 500, i.ecaron = 444, i.Ydieresis = 556, i.divide = 675, i.Yacute = 556, i.Acircumflex = 611, i.aacute = 500, i.Ucircumflex = 722, i.yacute = 444, i.scommaaccent = 389, i.ecircumflex = 444, i.Uring = 722, i.Udieresis = 722, i.aogonek = 500, i.Uacute = 722, i.uogonek = 500, i.Edieresis = 611, i.Dcroat = 722, i.commaaccent = 250, i.copyright = 760, i.Emacron = 611, i.ccaron = 444, i.aring = 500, i.Ncommaaccent = 667, i.lacute = 278, i.agrave = 500, i.Tcommaaccent = 556, i.Cacute = 667, i.atilde = 500, i.Edotaccent = 611, i.scaron = 389, i.scedilla = 389, i.iacute = 278, i.lozenge = 471, i.Rcaron = 611, i.Gcommaaccent = 722, i.ucircumflex = 500, i.acircumflex = 500, i.Amacron = 611, i.rcaron = 389, i.ccedilla = 444, i.Zdotaccent = 556, i.Thorn = 611, i.Omacron = 722, i.Racute = 611, i.Sacute = 500, i.dcaron = 544, i.Umacron = 722, i.uring = 500, i.threesuperior = 300, i.Ograve = 722, i.Agrave = 611, i.Abreve = 611, i.multiply = 675, i.uacute = 500, i.Tcaron = 556, i.partialdiff = 476, i.ydieresis = 444, i.Nacute = 667, i.icircumflex = 278, i.Ecircumflex = 611, i.adieresis = 500, i.edieresis = 444, i.cacute = 444, i.nacute = 500, i.umacron = 500, i.Ncaron = 667, i.Iacute = 333, i.plusminus = 675, i.brokenbar = 275, i.registered = 760, i.Gbreve = 722, i.Idotaccent = 333, i.summation = 600, i.Egrave = 611, i.racute = 389, i.omacron = 500, i.Zacute = 556, i.Zcaron = 556, i.greaterequal = 549, i.Eth = 722, i.Ccedilla = 667, i.lcommaaccent = 278, i.tcaron = 300, i.eogonek = 444, i.Uogonek = 722, i.Aacute = 611, i.Adieresis = 611, i.egrave = 444, i.zacute = 389, i.iogonek = 278, i.Oacute = 722, i.oacute = 500, i.amacron = 500, i.sacute = 389, i.idieresis = 278, i.Ocircumflex = 722, i.Ugrave = 722, i.Delta = 612, i.thorn = 500, i.twosuperior = 300, i.Odieresis = 722, i.mu = 500, i.igrave = 278, i.ohungarumlaut = 500, i.Eogonek = 611, i.dcroat = 500, i.threequarters = 750, i.Scedilla = 500, i.lcaron = 300, i.Kcommaaccent = 667, i.Lacute = 556, i.trademark = 980, i.edotaccent = 444, i.Igrave = 333, i.Imacron = 333, i.Lcaron = 611, i.onehalf = 750, i.lessequal = 549, i.ocircumflex = 500, i.ntilde = 500, i.Uhungarumlaut = 722, i.Eacute = 611, i.emacron = 444, i.gbreve = 500, i.onequarter = 750, i.Scaron = 500, i.Scommaaccent = 500, i.Ohungarumlaut = 722, i.degree = 400, i.ograve = 500, i.Ccaron = 667, i.ugrave = 500, i.radical = 453, i.Dcaron = 722, i.rcommaaccent = 389, i.Ntilde = 667, i.otilde = 500, i.Rcommaaccent = 611, i.Lcommaaccent = 556, i.Atilde = 611, i.Aogonek = 611, i.Aring = 611, i.Otilde = 722, i.zdotaccent = 389, i.Ecaron = 611, i.Iogonek = 333, i.kcommaaccent = 444, i.minus = 675, i.Icircumflex = 333, i.ncaron = 500, i.tcommaaccent = 278, i.logicalnot = 675, i.odieresis = 500, i.udieresis = 500, i.notequal = 549, i.gcommaaccent = 500, i.eth = 500, i.zcaron = 389, i.ncommaaccent = 500, i.onesuperior = 300, i.imacron = 278, i.Euro = 500;
            }), t.ZapfDingbats = (0, s.getLookupTableFactory)(function(i) {
              i.space = 278, i.a1 = 974, i.a2 = 961, i.a202 = 974, i.a3 = 980, i.a4 = 719, i.a5 = 789, i.a119 = 790, i.a118 = 791, i.a117 = 690, i.a11 = 960, i.a12 = 939, i.a13 = 549, i.a14 = 855, i.a15 = 911, i.a16 = 933, i.a105 = 911, i.a17 = 945, i.a18 = 974, i.a19 = 755, i.a20 = 846, i.a21 = 762, i.a22 = 761, i.a23 = 571, i.a24 = 677, i.a25 = 763, i.a26 = 760, i.a27 = 759, i.a28 = 754, i.a6 = 494, i.a7 = 552, i.a8 = 537, i.a9 = 577, i.a10 = 692, i.a29 = 786, i.a30 = 788, i.a31 = 788, i.a32 = 790, i.a33 = 793, i.a34 = 794, i.a35 = 816, i.a36 = 823, i.a37 = 789, i.a38 = 841, i.a39 = 823, i.a40 = 833, i.a41 = 816, i.a42 = 831, i.a43 = 923, i.a44 = 744, i.a45 = 723, i.a46 = 749, i.a47 = 790, i.a48 = 792, i.a49 = 695, i.a50 = 776, i.a51 = 768, i.a52 = 792, i.a53 = 759, i.a54 = 707, i.a55 = 708, i.a56 = 682, i.a57 = 701, i.a58 = 826, i.a59 = 815, i.a60 = 789, i.a61 = 789, i.a62 = 707, i.a63 = 687, i.a64 = 696, i.a65 = 689, i.a66 = 786, i.a67 = 787, i.a68 = 713, i.a69 = 791, i.a70 = 785, i.a71 = 791, i.a72 = 873, i.a73 = 761, i.a74 = 762, i.a203 = 762, i.a75 = 759, i.a204 = 759, i.a76 = 892, i.a77 = 892, i.a78 = 788, i.a79 = 784, i.a81 = 438, i.a82 = 138, i.a83 = 277, i.a84 = 415, i.a97 = 392, i.a98 = 392, i.a99 = 668, i.a100 = 668, i.a89 = 390, i.a90 = 390, i.a93 = 317, i.a94 = 317, i.a91 = 276, i.a92 = 276, i.a205 = 509, i.a85 = 509, i.a206 = 410, i.a86 = 410, i.a87 = 234, i.a88 = 234, i.a95 = 334, i.a96 = 334, i.a101 = 732, i.a102 = 544, i.a103 = 544, i.a104 = 910, i.a106 = 667, i.a107 = 760, i.a108 = 760, i.a112 = 776, i.a111 = 595, i.a110 = 694, i.a109 = 626, i.a120 = 788, i.a121 = 788, i.a122 = 788, i.a123 = 788, i.a124 = 788, i.a125 = 788, i.a126 = 788, i.a127 = 788, i.a128 = 788, i.a129 = 788, i.a130 = 788, i.a131 = 788, i.a132 = 788, i.a133 = 788, i.a134 = 788, i.a135 = 788, i.a136 = 788, i.a137 = 788, i.a138 = 788, i.a139 = 788, i.a140 = 788, i.a141 = 788, i.a142 = 788, i.a143 = 788, i.a144 = 788, i.a145 = 788, i.a146 = 788, i.a147 = 788, i.a148 = 788, i.a149 = 788, i.a150 = 788, i.a151 = 788, i.a152 = 788, i.a153 = 788, i.a154 = 788, i.a155 = 788, i.a156 = 788, i.a157 = 788, i.a158 = 788, i.a159 = 788, i.a160 = 894, i.a161 = 838, i.a163 = 1016, i.a164 = 458, i.a196 = 748, i.a165 = 924, i.a192 = 748, i.a166 = 918, i.a167 = 927, i.a168 = 928, i.a169 = 928, i.a170 = 834, i.a171 = 873, i.a172 = 828, i.a173 = 924, i.a162 = 924, i.a174 = 917, i.a175 = 930, i.a176 = 931, i.a177 = 463, i.a178 = 883, i.a179 = 836, i.a193 = 836, i.a180 = 867, i.a199 = 867, i.a181 = 696, i.a200 = 696, i.a182 = 874, i.a201 = 874, i.a183 = 760, i.a184 = 946, i.a197 = 771, i.a185 = 865, i.a194 = 771, i.a198 = 888, i.a186 = 967, i.a195 = 888, i.a187 = 831, i.a188 = 873, i.a189 = 927, i.a190 = 970, i.a191 = 918;
            });
          });
          c.getMetrics = h;
          const g = (0, s.getLookupTableFactory)(function(t) {
            t.Courier = {
              ascent: 629,
              descent: -157,
              capHeight: 562,
              xHeight: -426
            }, t["Courier-Bold"] = {
              ascent: 629,
              descent: -157,
              capHeight: 562,
              xHeight: 439
            }, t["Courier-Oblique"] = {
              ascent: 629,
              descent: -157,
              capHeight: 562,
              xHeight: 426
            }, t["Courier-BoldOblique"] = {
              ascent: 629,
              descent: -157,
              capHeight: 562,
              xHeight: 426
            }, t.Helvetica = {
              ascent: 718,
              descent: -207,
              capHeight: 718,
              xHeight: 523
            }, t["Helvetica-Bold"] = {
              ascent: 718,
              descent: -207,
              capHeight: 718,
              xHeight: 532
            }, t["Helvetica-Oblique"] = {
              ascent: 718,
              descent: -207,
              capHeight: 718,
              xHeight: 523
            }, t["Helvetica-BoldOblique"] = {
              ascent: 718,
              descent: -207,
              capHeight: 718,
              xHeight: 532
            }, t["Times-Roman"] = {
              ascent: 683,
              descent: -217,
              capHeight: 662,
              xHeight: 450
            }, t["Times-Bold"] = {
              ascent: 683,
              descent: -217,
              capHeight: 676,
              xHeight: 461
            }, t["Times-Italic"] = {
              ascent: 683,
              descent: -217,
              capHeight: 653,
              xHeight: 441
            }, t["Times-BoldItalic"] = {
              ascent: 683,
              descent: -217,
              capHeight: 669,
              xHeight: 462
            }, t.Symbol = {
              ascent: Math.NaN,
              descent: Math.NaN,
              capHeight: Math.NaN,
              xHeight: Math.NaN
            }, t.ZapfDingbats = {
              ascent: Math.NaN,
              descent: Math.NaN,
              capHeight: Math.NaN,
              xHeight: Math.NaN
            };
          });
          c.getFontBasicMetrics = g;
        },
        /* 46 */
        /***/
        (d, c) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.GlyfTable = void 0;
          const f = 1, s = 2, h = 4, g = 8, t = 16, i = 32, m = 64, v = 1, E = 2, S = 8, y = 32, x = 64, b = 128, u = 256;
          class I {
            constructor({
              glyfTable: R,
              isGlyphLocationsLong: _,
              locaTable: A,
              numGlyphs: k
            }) {
              this.glyphs = [];
              const z = new DataView(A.buffer, A.byteOffset, A.byteLength), T = new DataView(R.buffer, R.byteOffset, R.byteLength), w = _ ? 4 : 2;
              let F = _ ? z.getUint32(0) : 2 * z.getUint16(0), j = 0;
              for (let P = 0; P < k; P++) {
                j += w;
                const V = _ ? z.getUint32(j) : 2 * z.getUint16(j);
                if (V === F) {
                  this.glyphs.push(new O({}));
                  continue;
                }
                const J = O.parse(F, T);
                this.glyphs.push(J), F = V;
              }
            }
            getSize() {
              return this.glyphs.reduce((R, _) => {
                const A = _.getSize();
                return R + (A + 3 & -4);
              }, 0);
            }
            write() {
              const R = this.getSize(), _ = new DataView(new ArrayBuffer(R)), A = R > 131070, k = A ? 4 : 2, z = new DataView(new ArrayBuffer((this.glyphs.length + 1) * k));
              A ? z.setUint32(0, 0) : z.setUint16(0, 0);
              let T = 0, w = 0;
              for (const F of this.glyphs)
                T += F.write(T, _), T = T + 3 & -4, w += k, A ? z.setUint32(w, T) : z.setUint16(w, T >> 1);
              return {
                isLocationLong: A,
                loca: new Uint8Array(z.buffer),
                glyf: new Uint8Array(_.buffer)
              };
            }
            scale(R) {
              for (let _ = 0, A = this.glyphs.length; _ < A; _++)
                this.glyphs[_].scale(R[_]);
            }
          }
          c.GlyfTable = I;
          class O {
            constructor({
              header: R = null,
              simple: _ = null,
              composites: A = null
            }) {
              this.header = R, this.simple = _, this.composites = A;
            }
            static parse(R, _) {
              const [A, k] = D.parse(R, _);
              if (R += A, k.numberOfContours < 0) {
                const T = [];
                for (; ; ) {
                  const [w, F] = H.parse(R, _);
                  if (R += w, T.push(F), !(F.flags & y))
                    break;
                }
                return new O({
                  header: k,
                  composites: T
                });
              }
              const z = K.parse(R, _, k.numberOfContours);
              return new O({
                header: k,
                simple: z
              });
            }
            getSize() {
              if (!this.header)
                return 0;
              const R = this.simple ? this.simple.getSize() : this.composites.reduce((_, A) => _ + A.getSize(), 0);
              return this.header.getSize() + R;
            }
            write(R, _) {
              if (!this.header)
                return 0;
              const A = R;
              if (R += this.header.write(R, _), this.simple)
                R += this.simple.write(R, _);
              else
                for (const k of this.composites)
                  R += k.write(R, _);
              return R - A;
            }
            scale(R) {
              if (!this.header)
                return;
              const _ = (this.header.xMin + this.header.xMax) / 2;
              if (this.header.scale(_, R), this.simple)
                this.simple.scale(_, R);
              else
                for (const A of this.composites)
                  A.scale(_, R);
            }
          }
          class D {
            constructor({
              numberOfContours: R,
              xMin: _,
              yMin: A,
              xMax: k,
              yMax: z
            }) {
              this.numberOfContours = R, this.xMin = _, this.yMin = A, this.xMax = k, this.yMax = z;
            }
            static parse(R, _) {
              return [10, new D({
                numberOfContours: _.getInt16(R),
                xMin: _.getInt16(R + 2),
                yMin: _.getInt16(R + 4),
                xMax: _.getInt16(R + 6),
                yMax: _.getInt16(R + 8)
              })];
            }
            getSize() {
              return 10;
            }
            write(R, _) {
              return _.setInt16(R, this.numberOfContours), _.setInt16(R + 2, this.xMin), _.setInt16(R + 4, this.yMin), _.setInt16(R + 6, this.xMax), _.setInt16(R + 8, this.yMax), 10;
            }
            scale(R, _) {
              this.xMin = Math.round(R + (this.xMin - R) * _), this.xMax = Math.round(R + (this.xMax - R) * _);
            }
          }
          class $ {
            constructor({
              flags: R,
              xCoordinates: _,
              yCoordinates: A
            }) {
              this.xCoordinates = _, this.yCoordinates = A, this.flags = R;
            }
          }
          class K {
            constructor({
              contours: R,
              instructions: _
            }) {
              this.contours = R, this.instructions = _;
            }
            static parse(R, _, A) {
              const k = [];
              for (let G = 0; G < A; G++) {
                const N = _.getUint16(R);
                R += 2, k.push(N);
              }
              const z = k[A - 1] + 1, T = _.getUint16(R);
              R += 2;
              const w = new Uint8Array(_).slice(R, R + T);
              R += T;
              const F = [];
              for (let G = 0; G < z; R++, G++) {
                let N = _.getUint8(R);
                if (F.push(N), N & g) {
                  const q = _.getUint8(++R);
                  N ^= g;
                  for (let ie = 0; ie < q; ie++)
                    F.push(N);
                  G += q;
                }
              }
              const j = [];
              let P = [], V = [], J = [];
              const ne = [];
              let Z = 0, te = 0;
              for (let G = 0; G < z; G++) {
                const N = F[G];
                if (N & s) {
                  const q = _.getUint8(R++);
                  te += N & t ? q : -q, P.push(te);
                } else N & t || (te += _.getInt16(R), R += 2), P.push(te);
                k[Z] === G && (Z++, j.push(P), P = []);
              }
              te = 0, Z = 0;
              for (let G = 0; G < z; G++) {
                const N = F[G];
                if (N & h) {
                  const q = _.getUint8(R++);
                  te += N & i ? q : -q, V.push(te);
                } else N & i || (te += _.getInt16(R), R += 2), V.push(te);
                J.push(N & f | N & m), k[Z] === G && (P = j[Z], Z++, ne.push(new $({
                  flags: J,
                  xCoordinates: P,
                  yCoordinates: V
                })), V = [], J = []);
              }
              return new K({
                contours: ne,
                instructions: w
              });
            }
            getSize() {
              let R = this.contours.length * 2 + 2 + this.instructions.length, _ = 0, A = 0;
              for (const k of this.contours) {
                R += k.flags.length;
                for (let z = 0, T = k.xCoordinates.length; z < T; z++) {
                  const w = k.xCoordinates[z], F = k.yCoordinates[z];
                  let j = Math.abs(w - _);
                  j > 255 ? R += 2 : j > 0 && (R += 1), _ = w, j = Math.abs(F - A), j > 255 ? R += 2 : j > 0 && (R += 1), A = F;
                }
              }
              return R;
            }
            write(R, _) {
              const A = R, k = [], z = [], T = [];
              let w = 0, F = 0;
              for (const j of this.contours) {
                for (let P = 0, V = j.xCoordinates.length; P < V; P++) {
                  let J = j.flags[P];
                  const ne = j.xCoordinates[P];
                  let Z = ne - w;
                  if (Z === 0)
                    J |= t, k.push(0);
                  else {
                    const G = Math.abs(Z);
                    G <= 255 ? (J |= Z >= 0 ? s | t : s, k.push(G)) : k.push(Z);
                  }
                  w = ne;
                  const te = j.yCoordinates[P];
                  if (Z = te - F, Z === 0)
                    J |= i, z.push(0);
                  else {
                    const G = Math.abs(Z);
                    G <= 255 ? (J |= Z >= 0 ? h | i : h, z.push(G)) : z.push(Z);
                  }
                  F = te, T.push(J);
                }
                _.setUint16(R, k.length - 1), R += 2;
              }
              _.setUint16(R, this.instructions.length), R += 2, this.instructions.length && (new Uint8Array(_.buffer, 0, _.buffer.byteLength).set(this.instructions, R), R += this.instructions.length);
              for (const j of T)
                _.setUint8(R++, j);
              for (let j = 0, P = k.length; j < P; j++) {
                const V = k[j], J = T[j];
                J & s ? _.setUint8(R++, V) : J & t || (_.setInt16(R, V), R += 2);
              }
              for (let j = 0, P = z.length; j < P; j++) {
                const V = z[j], J = T[j];
                J & h ? _.setUint8(R++, V) : J & i || (_.setInt16(R, V), R += 2);
              }
              return R - A;
            }
            scale(R, _) {
              for (const A of this.contours)
                if (A.xCoordinates.length !== 0)
                  for (let k = 0, z = A.xCoordinates.length; k < z; k++)
                    A.xCoordinates[k] = Math.round(R + (A.xCoordinates[k] - R) * _);
            }
          }
          class H {
            constructor({
              flags: R,
              glyphIndex: _,
              argument1: A,
              argument2: k,
              transf: z,
              instructions: T
            }) {
              this.flags = R, this.glyphIndex = _, this.argument1 = A, this.argument2 = k, this.transf = z, this.instructions = T;
            }
            static parse(R, _) {
              const A = R, k = [];
              let z = _.getUint16(R);
              const T = _.getUint16(R + 2);
              R += 4;
              let w, F;
              z & v ? (z & E ? (w = _.getInt16(R), F = _.getInt16(R + 2)) : (w = _.getUint16(R), F = _.getUint16(R + 2)), R += 4, z ^= v) : (z & E ? (w = _.getInt8(R), F = _.getInt8(R + 1)) : (w = _.getUint8(R), F = _.getUint8(R + 1)), R += 2), z & S ? (k.push(_.getUint16(R)), R += 2) : z & x ? (k.push(_.getUint16(R), _.getUint16(R + 2)), R += 4) : z & b && (k.push(_.getUint16(R), _.getUint16(R + 2), _.getUint16(R + 4), _.getUint16(R + 6)), R += 8);
              let j = null;
              if (z & u) {
                const P = _.getUint16(R);
                R += 2, j = new Uint8Array(_).slice(R, R + P), R += P;
              }
              return [R - A, new H({
                flags: z,
                glyphIndex: T,
                argument1: w,
                argument2: F,
                transf: k,
                instructions: j
              })];
            }
            getSize() {
              let R = 4 + this.transf.length * 2;
              return this.flags & u && (R += 2 + this.instructions.length), R += 2, this.flags & 2 ? this.argument1 >= -128 && this.argument1 <= 127 && this.argument2 >= -128 && this.argument2 <= 127 || (R += 2) : this.argument1 >= 0 && this.argument1 <= 255 && this.argument2 >= 0 && this.argument2 <= 255 || (R += 2), R;
            }
            write(R, _) {
              const A = R;
              return this.flags & E ? this.argument1 >= -128 && this.argument1 <= 127 && this.argument2 >= -128 && this.argument2 <= 127 || (this.flags |= v) : this.argument1 >= 0 && this.argument1 <= 255 && this.argument2 >= 0 && this.argument2 <= 255 || (this.flags |= v), _.setUint16(R, this.flags), _.setUint16(R + 2, this.glyphIndex), R += 4, this.flags & v ? (this.flags & E ? (_.setInt16(R, this.argument1), _.setInt16(R + 2, this.argument2)) : (_.setUint16(R, this.argument1), _.setUint16(R + 2, this.argument2)), R += 4) : (_.setUint8(R, this.argument1), _.setUint8(R + 1, this.argument2), R += 2), this.flags & u && (_.setUint16(R, this.instructions.length), R += 2, this.instructions.length && (new Uint8Array(_.buffer, 0, _.buffer.byteLength).set(this.instructions, R), R += this.instructions.length)), R - A;
            }
            scale(R, _) {
            }
          }
        },
        /* 47 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.OpenTypeFileBuilder = void 0;
          var s = f(3), h = f(2);
          function g(S, y, x) {
            S[y] = x >> 8 & 255, S[y + 1] = x & 255;
          }
          function t(S, y, x) {
            S[y] = x >> 24 & 255, S[y + 1] = x >> 16 & 255, S[y + 2] = x >> 8 & 255, S[y + 3] = x & 255;
          }
          function i(S, y, x) {
            if (x instanceof Uint8Array)
              S.set(x, y);
            else if (typeof x == "string")
              for (let b = 0, u = x.length; b < u; b++)
                S[y++] = x.charCodeAt(b) & 255;
            else
              for (const b of x)
                S[y++] = b & 255;
          }
          const m = 12, v = 16;
          class E {
            constructor(y) {
              this.sfnt = y, this.tables = /* @__PURE__ */ Object.create(null);
            }
            static getSearchParams(y, x) {
              let b = 1, u = 0;
              for (; (b ^ y) > b; )
                b <<= 1, u++;
              const I = b * x;
              return {
                range: I,
                entry: u,
                rangeShift: x * y - I
              };
            }
            toArray() {
              let y = this.sfnt;
              const x = this.tables, b = Object.keys(x);
              b.sort();
              const u = b.length;
              let I, O, D, $, K, H = m + u * v;
              const B = [H];
              for (I = 0; I < u; I++) {
                $ = x[b[I]];
                const A = ($.length + 3 & -4) >>> 0;
                H += A, B.push(H);
              }
              const R = new Uint8Array(H);
              for (I = 0; I < u; I++)
                $ = x[b[I]], i(R, B[I], $);
              y === "true" && (y = (0, h.string32)(65536)), R[0] = y.charCodeAt(0) & 255, R[1] = y.charCodeAt(1) & 255, R[2] = y.charCodeAt(2) & 255, R[3] = y.charCodeAt(3) & 255, g(R, 4, u);
              const _ = E.getSearchParams(u, 16);
              for (g(R, 6, _.range), g(R, 8, _.entry), g(R, 10, _.rangeShift), H = m, I = 0; I < u; I++) {
                K = b[I], R[H] = K.charCodeAt(0) & 255, R[H + 1] = K.charCodeAt(1) & 255, R[H + 2] = K.charCodeAt(2) & 255, R[H + 3] = K.charCodeAt(3) & 255;
                let A = 0;
                for (O = B[I], D = B[I + 1]; O < D; O += 4) {
                  const k = (0, s.readUint32)(R, O);
                  A = A + k >>> 0;
                }
                t(R, H + 4, A), t(R, H + 8, B[I]), t(R, H + 12, x[K].length), H += v;
              }
              return R;
            }
            addTable(y, x) {
              if (y in this.tables)
                throw new Error("Table " + y + " already exists");
              this.tables[y] = x;
            }
          }
          c.OpenTypeFileBuilder = E;
        },
        /* 48 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.Type1Font = void 0;
          var s = f(35), h = f(2), g = f(38), t = f(3), i = f(8), m = f(49);
          function v(x, b, u) {
            const I = x.length, O = b.length, D = I - O;
            let $ = u, K = !1;
            for (; $ < D; ) {
              let H = 0;
              for (; H < O && x[$ + H] === b[H]; )
                H++;
              if (H >= O) {
                for ($ += H; $ < I && (0, t.isWhiteSpace)(x[$]); )
                  $++;
                K = !0;
                break;
              }
              $++;
            }
            return {
              found: K,
              length: $
            };
          }
          function E(x, b) {
            const u = [101, 101, 120, 101, 99], I = x.pos;
            let O, D, $;
            try {
              O = x.getBytes(b), D = O.length;
            } catch {
            }
            if (D === b && ($ = v(O, u, b - 2 * u.length), $.found && $.length === b))
              return {
                stream: new i.Stream(O),
                length: b
              };
            (0, h.warn)('Invalid "Length1" property in Type1 font -- trying to recover.'), x.pos = I;
            const K = 2048;
            let H;
            for (; ; ) {
              const B = x.peekBytes(K);
              if ($ = v(B, u, 0), $.length === 0)
                break;
              if (x.pos += $.length, $.found) {
                H = x.pos - I;
                break;
              }
            }
            return x.pos = I, H ? {
              stream: new i.Stream(x.getBytes(H)),
              length: H
            } : ((0, h.warn)('Unable to recover "Length1" property in Type1 font -- using as is.'), {
              stream: new i.Stream(x.getBytes(b)),
              length: b
            });
          }
          function S(x, b) {
            const u = x.getBytes();
            if (u.length === 0)
              throw new h.FormatError("getEexecBlock - no font program found.");
            return {
              stream: new i.Stream(u),
              length: u.length
            };
          }
          class y {
            constructor(b, u, I) {
              let D = I.length1;
              I.length2;
              let $ = u.peekBytes(6);
              const K = $[0] === 128 && $[1] === 1;
              K && (u.skip(6), D = $[5] << 24 | $[4] << 16 | $[3] << 8 | $[2]);
              const H = E(u, D);
              new m.Type1Parser(H.stream, !1, g.SEAC_ANALYSIS_ENABLED).extractFontHeader(I), K && ($ = u.getBytes(6), $[5] << 24 | $[4] << 16 | $[3] << 8 | $[2]);
              const R = S(u), A = new m.Type1Parser(R.stream, !0, g.SEAC_ANALYSIS_ENABLED).extractFontProgram(I);
              for (const w in A.properties)
                I[w] = A.properties[w];
              const k = A.charstrings, z = this.getType2Charstrings(k), T = this.getType2Subrs(A.subrs);
              this.charstrings = k, this.data = this.wrap(b, z, this.charstrings, T, I), this.seacs = this.getSeacs(A.charstrings);
            }
            get numGlyphs() {
              return this.charstrings.length + 1;
            }
            getCharset() {
              const b = [".notdef"];
              for (const {
                glyphName: u
              } of this.charstrings)
                b.push(u);
              return b;
            }
            getGlyphMapping(b) {
              const u = this.charstrings;
              if (b.composite) {
                const K = /* @__PURE__ */ Object.create(null);
                for (let H = 0, B = u.length; H < B; H++) {
                  const R = b.cMap.charCodeOf(H);
                  K[R] = H + 1;
                }
                return K;
              }
              const I = [".notdef"];
              let O, D;
              for (D = 0; D < u.length; D++)
                I.push(u[D].glyphName);
              const $ = b.builtInEncoding;
              if ($) {
                O = /* @__PURE__ */ Object.create(null);
                for (const K in $)
                  D = I.indexOf($[K]), D >= 0 && (O[K] = D);
              }
              return (0, g.type1FontGlyphMapping)(b, O, I);
            }
            hasGlyphId(b) {
              return b < 0 || b >= this.numGlyphs ? !1 : b === 0 ? !0 : this.charstrings[b - 1].charstring.length > 0;
            }
            getSeacs(b) {
              const u = [];
              for (let I = 0, O = b.length; I < O; I++) {
                const D = b[I];
                D.seac && (u[I + 1] = D.seac);
              }
              return u;
            }
            getType2Charstrings(b) {
              const u = [];
              for (const I of b)
                u.push(I.charstring);
              return u;
            }
            getType2Subrs(b) {
              let u = 0;
              const I = b.length;
              I < 1133 ? u = 107 : I < 33769 ? u = 1131 : u = 32768;
              const O = [];
              let D;
              for (D = 0; D < u; D++)
                O.push([11]);
              for (D = 0; D < I; D++)
                O.push(b[D]);
              return O;
            }
            wrap(b, u, I, O, D) {
              const $ = new s.CFF();
              $.header = new s.CFFHeader(1, 0, 4, 4), $.names = [b];
              const K = new s.CFFTopDict();
              K.setByName("version", 391), K.setByName("Notice", 392), K.setByName("FullName", 393), K.setByName("FamilyName", 394), K.setByName("Weight", 395), K.setByName("Encoding", null), K.setByName("FontMatrix", D.fontMatrix), K.setByName("FontBBox", D.bbox), K.setByName("charset", null), K.setByName("CharStrings", null), K.setByName("Private", null), $.topDict = K;
              const H = new s.CFFStrings();
              H.add("Version 0.11"), H.add("See original notice"), H.add(b), H.add(b), H.add("Medium"), $.strings = H, $.globalSubrIndex = new s.CFFIndex();
              const B = u.length, R = [".notdef"];
              let _, A;
              for (_ = 0; _ < B; _++) {
                const j = I[_].glyphName;
                s.CFFStandardStrings.indexOf(j) === -1 && H.add(j), R.push(j);
              }
              $.charset = new s.CFFCharset(!1, 0, R);
              const k = new s.CFFIndex();
              for (k.add([139, 14]), _ = 0; _ < B; _++)
                k.add(u[_]);
              $.charStrings = k;
              const z = new s.CFFPrivateDict();
              z.setByName("Subrs", null);
              const T = ["BlueValues", "OtherBlues", "FamilyBlues", "FamilyOtherBlues", "StemSnapH", "StemSnapV", "BlueShift", "BlueFuzz", "BlueScale", "LanguageGroup", "ExpansionFactor", "ForceBold", "StdHW", "StdVW"];
              for (_ = 0, A = T.length; _ < A; _++) {
                const j = T[_];
                if (!(j in D.privateData))
                  continue;
                const P = D.privateData[j];
                if (Array.isArray(P))
                  for (let V = P.length - 1; V > 0; V--)
                    P[V] -= P[V - 1];
                z.setByName(j, P);
              }
              $.topDict.privateDict = z;
              const w = new s.CFFIndex();
              for (_ = 0, A = O.length; _ < A; _++)
                w.add(O[_]);
              return z.subrsIndex = w, new s.CFFCompiler($).compile();
            }
          }
          c.Type1Font = y;
        },
        /* 49 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.Type1Parser = void 0;
          var s = f(37), h = f(3), g = f(8), t = f(2);
          const i = !1, m = {
            hstem: [1],
            vstem: [3],
            vmoveto: [4],
            rlineto: [5],
            hlineto: [6],
            vlineto: [7],
            rrcurveto: [8],
            callsubr: [10],
            flex: [12, 35],
            drop: [12, 18],
            endchar: [14],
            rmoveto: [21],
            hmoveto: [22],
            vhcurveto: [30],
            hvcurveto: [31]
          };
          class v {
            constructor() {
              this.width = 0, this.lsb = 0, this.flexing = !1, this.output = [], this.stack = [];
            }
            convert(D, $, K) {
              const H = D.length;
              let B = !1, R, _, A;
              for (let k = 0; k < H; k++) {
                let z = D[k];
                if (z < 32) {
                  switch (z === 12 && (z = (z << 8) + D[++k]), z) {
                    case 1: {
                      this.stack = [];
                      break;
                    }
                    case 3: {
                      this.stack = [];
                      break;
                    }
                    case 4:
                      if (this.flexing) {
                        if (this.stack.length < 1) {
                          B = !0;
                          break;
                        }
                        const P = this.stack.pop();
                        this.stack.push(0, P);
                        break;
                      }
                      B = this.executeCommand(1, m.vmoveto);
                      break;
                    case 5:
                      B = this.executeCommand(2, m.rlineto);
                      break;
                    case 6:
                      B = this.executeCommand(1, m.hlineto);
                      break;
                    case 7:
                      B = this.executeCommand(1, m.vlineto);
                      break;
                    case 8:
                      B = this.executeCommand(6, m.rrcurveto);
                      break;
                    case 9:
                      this.stack = [];
                      break;
                    case 10:
                      if (this.stack.length < 1) {
                        B = !0;
                        break;
                      }
                      if (A = this.stack.pop(), !$[A]) {
                        B = !0;
                        break;
                      }
                      B = this.convert($[A], $, K);
                      break;
                    case 11:
                      return B;
                    case 13:
                      if (this.stack.length < 2) {
                        B = !0;
                        break;
                      }
                      R = this.stack.pop(), _ = this.stack.pop(), this.lsb = _, this.width = R, this.stack.push(R, _), B = this.executeCommand(2, m.hmoveto);
                      break;
                    case 14:
                      this.output.push(m.endchar[0]);
                      break;
                    case 21:
                      if (this.flexing)
                        break;
                      B = this.executeCommand(2, m.rmoveto);
                      break;
                    case 22:
                      if (this.flexing) {
                        this.stack.push(0);
                        break;
                      }
                      B = this.executeCommand(1, m.hmoveto);
                      break;
                    case 30:
                      B = this.executeCommand(4, m.vhcurveto);
                      break;
                    case 31:
                      B = this.executeCommand(4, m.hvcurveto);
                      break;
                    case 3072:
                      this.stack = [];
                      break;
                    case 3073: {
                      this.stack = [];
                      break;
                    }
                    case 3074: {
                      this.stack = [];
                      break;
                    }
                    case 3078:
                      if (K) {
                        const P = this.stack.at(-5);
                        this.seac = this.stack.splice(-4, 4), this.seac[0] += this.lsb - P, B = this.executeCommand(0, m.endchar);
                      } else
                        B = this.executeCommand(4, m.endchar);
                      break;
                    case 3079:
                      if (this.stack.length < 4) {
                        B = !0;
                        break;
                      }
                      this.stack.pop(), R = this.stack.pop();
                      const T = this.stack.pop();
                      _ = this.stack.pop(), this.lsb = _, this.width = R, this.stack.push(R, _, T), B = this.executeCommand(3, m.rmoveto);
                      break;
                    case 3084:
                      if (this.stack.length < 2) {
                        B = !0;
                        break;
                      }
                      const w = this.stack.pop(), F = this.stack.pop();
                      this.stack.push(F / w);
                      break;
                    case 3088:
                      if (this.stack.length < 2) {
                        B = !0;
                        break;
                      }
                      A = this.stack.pop();
                      const j = this.stack.pop();
                      if (A === 0 && j === 3) {
                        const P = this.stack.splice(-17, 17);
                        this.stack.push(P[2] + P[0], P[3] + P[1], P[4], P[5], P[6], P[7], P[8], P[9], P[10], P[11], P[12], P[13], P[14]), B = this.executeCommand(13, m.flex, !0), this.flexing = !1, this.stack.push(P[15], P[16]);
                      } else A === 1 && j === 0 && (this.flexing = !0);
                      break;
                    case 3089:
                      break;
                    case 3105:
                      this.stack = [];
                      break;
                    default:
                      (0, t.warn)('Unknown type 1 charstring command of "' + z + '"');
                      break;
                  }
                  if (B)
                    break;
                  continue;
                } else z <= 246 ? z -= 139 : z <= 250 ? z = (z - 247) * 256 + D[++k] + 108 : z <= 254 ? z = -((z - 251) * 256) - D[++k] - 108 : z = (D[++k] & 255) << 24 | (D[++k] & 255) << 16 | (D[++k] & 255) << 8 | (D[++k] & 255) << 0;
                this.stack.push(z);
              }
              return B;
            }
            executeCommand(D, $, K) {
              const H = this.stack.length;
              if (D > H)
                return !0;
              const B = H - D;
              for (let R = B; R < H; R++) {
                let _ = this.stack[R];
                Number.isInteger(_) ? this.output.push(28, _ >> 8 & 255, _ & 255) : (_ = 65536 * _ | 0, this.output.push(255, _ >> 24 & 255, _ >> 16 & 255, _ >> 8 & 255, _ & 255));
              }
              return this.output.push(...$), K ? this.stack.splice(B, D) : this.stack.length = 0, !1;
            }
          }
          const E = 55665, S = 4330;
          function y(O) {
            return O >= 48 && O <= 57 || O >= 65 && O <= 70 || O >= 97 && O <= 102;
          }
          function x(O, D, $) {
            if ($ >= O.length)
              return new Uint8Array(0);
            const K = 52845, H = 22719;
            let B = D | 0, R, _;
            for (R = 0; R < $; R++)
              B = (O[R] + B) * K + H & 65535;
            const A = O.length - $, k = new Uint8Array(A);
            for (R = $, _ = 0; _ < A; R++, _++) {
              const z = O[R];
              k[_] = z ^ B >> 8, B = (z + B) * K + H & 65535;
            }
            return k;
          }
          function b(O, D, $) {
            let B = D | 0;
            const R = O.length, _ = R >>> 1, A = new Uint8Array(_);
            let k, z;
            for (k = 0, z = 0; k < R; k++) {
              const T = O[k];
              if (!y(T))
                continue;
              k++;
              let w;
              for (; k < R && !y(w = O[k]); )
                k++;
              if (k < R) {
                const F = parseInt(String.fromCharCode(T, w), 16);
                A[z++] = F ^ B >> 8, B = (F + B) * 52845 + 22719 & 65535;
              }
            }
            return A.slice($, z);
          }
          function u(O) {
            return O === 47 || O === 91 || O === 93 || O === 123 || O === 125 || O === 40 || O === 41;
          }
          class I {
            constructor(D, $, K) {
              if ($) {
                const H = D.getBytes(), B = !((y(H[0]) || (0, h.isWhiteSpace)(H[0])) && y(H[1]) && y(H[2]) && y(H[3]) && y(H[4]) && y(H[5]) && y(H[6]) && y(H[7]));
                D = new g.Stream(B ? x(H, E, 4) : b(H, E, 4));
              }
              this.seacAnalysisEnabled = !!K, this.stream = D, this.nextChar();
            }
            readNumberArray() {
              this.getToken();
              const D = [];
              for (; ; ) {
                const $ = this.getToken();
                if ($ === null || $ === "]" || $ === "}")
                  break;
                D.push(parseFloat($ || 0));
              }
              return D;
            }
            readNumber() {
              const D = this.getToken();
              return parseFloat(D || 0);
            }
            readInt() {
              const D = this.getToken();
              return parseInt(D || 0, 10) | 0;
            }
            readBoolean() {
              return this.getToken() === "true" ? 1 : 0;
            }
            nextChar() {
              return this.currentChar = this.stream.getByte();
            }
            prevChar() {
              return this.stream.skip(-2), this.currentChar = this.stream.getByte();
            }
            getToken() {
              let D = !1, $ = this.currentChar;
              for (; ; ) {
                if ($ === -1)
                  return null;
                if (D)
                  ($ === 10 || $ === 13) && (D = !1);
                else if ($ === 37)
                  D = !0;
                else if (!(0, h.isWhiteSpace)($))
                  break;
                $ = this.nextChar();
              }
              if (u($))
                return this.nextChar(), String.fromCharCode($);
              let K = "";
              do
                K += String.fromCharCode($), $ = this.nextChar();
              while ($ >= 0 && !(0, h.isWhiteSpace)($) && !u($));
              return K;
            }
            readCharStrings(D, $) {
              return $ === -1 ? D : x(D, S, $);
            }
            extractFontProgram(D) {
              const $ = this.stream, K = [], H = [], B = /* @__PURE__ */ Object.create(null);
              B.lenIV = 4;
              const R = {
                subrs: [],
                charstrings: [],
                properties: {
                  privateData: B
                }
              };
              let _, A, k, z;
              for (; (_ = this.getToken()) !== null; )
                if (_ === "/")
                  switch (_ = this.getToken(), _) {
                    case "CharStrings":
                      for (this.getToken(), this.getToken(), this.getToken(), this.getToken(); _ = this.getToken(), !(_ === null || _ === "end"); ) {
                        if (_ !== "/")
                          continue;
                        const w = this.getToken();
                        A = this.readInt(), this.getToken(), k = A > 0 ? $.getBytes(A) : new Uint8Array(0), z = R.properties.privateData.lenIV;
                        const F = this.readCharStrings(k, z);
                        this.nextChar(), _ = this.getToken(), _ === "noaccess" ? this.getToken() : _ === "/" && this.prevChar(), H.push({
                          glyph: w,
                          encoded: F
                        });
                      }
                      break;
                    case "Subrs":
                      for (this.readInt(), this.getToken(); this.getToken() === "dup"; ) {
                        const w = this.readInt();
                        A = this.readInt(), this.getToken(), k = A > 0 ? $.getBytes(A) : new Uint8Array(0), z = R.properties.privateData.lenIV;
                        const F = this.readCharStrings(k, z);
                        this.nextChar(), _ = this.getToken(), _ === "noaccess" && this.getToken(), K[w] = F;
                      }
                      break;
                    case "BlueValues":
                    case "OtherBlues":
                    case "FamilyBlues":
                    case "FamilyOtherBlues":
                      const T = this.readNumberArray();
                      T.length > 0 && T.length % 2 === 0 && i && (R.properties.privateData[_] = T);
                      break;
                    case "StemSnapH":
                    case "StemSnapV":
                      R.properties.privateData[_] = this.readNumberArray();
                      break;
                    case "StdHW":
                    case "StdVW":
                      R.properties.privateData[_] = this.readNumberArray()[0];
                      break;
                    case "BlueShift":
                    case "lenIV":
                    case "BlueFuzz":
                    case "BlueScale":
                    case "LanguageGroup":
                      R.properties.privateData[_] = this.readNumber();
                      break;
                    case "ExpansionFactor":
                      R.properties.privateData[_] = this.readNumber() || 0.06;
                      break;
                    case "ForceBold":
                      R.properties.privateData[_] = this.readBoolean();
                      break;
                  }
              for (const {
                encoded: T,
                glyph: w
              } of H) {
                const F = new v(), j = F.convert(T, K, this.seacAnalysisEnabled);
                let P = F.output;
                j && (P = [14]);
                const V = {
                  glyphName: w,
                  charstring: P,
                  width: F.width,
                  lsb: F.lsb,
                  seac: F.seac
                };
                if (w === ".notdef" ? R.charstrings.unshift(V) : R.charstrings.push(V), D.builtInEncoding) {
                  const J = D.builtInEncoding.indexOf(w);
                  J > -1 && D.widths[J] === void 0 && J >= D.firstChar && J <= D.lastChar && (D.widths[J] = F.width);
                }
              }
              return R;
            }
            extractFontHeader(D) {
              let $;
              for (; ($ = this.getToken()) !== null; )
                if ($ === "/")
                  switch ($ = this.getToken(), $) {
                    case "FontMatrix":
                      const K = this.readNumberArray();
                      D.fontMatrix = K;
                      break;
                    case "Encoding":
                      const H = this.getToken();
                      let B;
                      if (!/^\d+$/.test(H))
                        B = (0, s.getEncoding)(H);
                      else {
                        B = [];
                        const _ = parseInt(H, 10) | 0;
                        this.getToken();
                        for (let A = 0; A < _; A++) {
                          for ($ = this.getToken(); $ !== "dup" && $ !== "def"; )
                            if ($ = this.getToken(), $ === null)
                              return;
                          if ($ === "def")
                            break;
                          const k = this.readInt();
                          this.getToken();
                          const z = this.getToken();
                          B[k] = z, this.getToken();
                        }
                      }
                      D.builtInEncoding = B;
                      break;
                    case "FontBBox":
                      const R = this.readNumberArray();
                      D.ascent = Math.max(R[3], R[1]), D.descent = Math.min(R[1], R[3]), D.ascentScaled = !0;
                      break;
                  }
            }
          }
          c.Type1Parser = I;
        },
        /* 50 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.Pattern = void 0, c.clearPatternCaches = u, c.getTilingPatternIR = D;
          var s = f(2), h = f(5), g = f(12), t = f(3);
          const i = {
            FUNCTION_BASED: 1,
            AXIAL: 2,
            RADIAL: 3,
            FREE_FORM_MESH: 4,
            LATTICE_FORM_MESH: 5,
            COONS_PATCH_MESH: 6,
            TENSOR_PATCH_MESH: 7
          };
          class m {
            constructor() {
              (0, s.unreachable)("Cannot initialize Pattern.");
            }
            static parseShading(B, R, _, A, k) {
              const z = B instanceof h.BaseStream ? B.dict : B, T = z.get("ShadingType");
              try {
                switch (T) {
                  case i.AXIAL:
                  case i.RADIAL:
                    return new E(z, R, _, A, k);
                  case i.FREE_FORM_MESH:
                  case i.LATTICE_FORM_MESH:
                  case i.COONS_PATCH_MESH:
                  case i.TENSOR_PATCH_MESH:
                    return new I(B, R, _, A, k);
                  default:
                    throw new s.FormatError("Unsupported ShadingType: " + T);
                }
              } catch (w) {
                if (w instanceof t.MissingDataException)
                  throw w;
                return (0, s.warn)(w), new O();
              }
            }
          }
          c.Pattern = m;
          const $ = class $ {
            constructor() {
              this.constructor === $ && (0, s.unreachable)("Cannot initialize BaseShading.");
            }
            getIR() {
              (0, s.unreachable)("Abstract method `getIR` called.");
            }
          };
          ni($, "SMALL_NUMBER", 1e-6);
          let v = $;
          class E extends v {
            constructor(B, R, _, A, k) {
              super(), this.coordsArr = B.getArray("Coords"), this.shadingType = B.get("ShadingType");
              const z = g.ColorSpace.parse({
                cs: B.getRaw("CS") || B.getRaw("ColorSpace"),
                xref: R,
                resources: _,
                pdfFunctionFactory: A,
                localColorSpaceCache: k
              }), T = B.getArray("BBox");
              this.bbox = Array.isArray(T) && T.length === 4 ? s.Util.normalizeRect(T) : null;
              let w = 0, F = 1;
              if (B.has("Domain")) {
                const le = B.getArray("Domain");
                w = le[0], F = le[1];
              }
              let j = !1, P = !1;
              if (B.has("Extend")) {
                const le = B.getArray("Extend");
                j = le[0], P = le[1];
              }
              if (this.shadingType === i.RADIAL && (!j || !P)) {
                const [le, ce, ee, he, pe, de] = this.coordsArr, ge = Math.hypot(le - he, ce - pe);
                ee <= de + ge && de <= ee + ge && (0, s.warn)("Unsupported radial gradient.");
              }
              this.extendStart = j, this.extendEnd = P;
              const V = B.getRaw("Function"), J = A.createFromArray(V), ne = 840, Z = (F - w) / ne, te = this.colorStops = [];
              if (w >= F || Z <= 0) {
                (0, s.info)("Bad shading domain.");
                return;
              }
              const G = new Float32Array(z.numComps), N = new Float32Array(1);
              let q, ie = 0;
              N[0] = w, J(N, 0, G, 0);
              let oe = z.getRgb(G, 0);
              const fe = s.Util.makeHexColor(oe[0], oe[1], oe[2]);
              te.push([0, fe]);
              let Y = 1;
              N[0] = w + Z, J(N, 0, G, 0);
              let ae = z.getRgb(G, 0), se = ae[0] - oe[0] + 1, L = ae[1] - oe[1] + 1, W = ae[2] - oe[2] + 1, M = ae[0] - oe[0] - 1, X = ae[1] - oe[1] - 1, U = ae[2] - oe[2] - 1;
              for (let le = 2; le < ne; le++) {
                N[0] = w + le * Z, J(N, 0, G, 0), q = z.getRgb(G, 0);
                const ce = le - ie;
                if (se = Math.min(se, (q[0] - oe[0] + 1) / ce), L = Math.min(L, (q[1] - oe[1] + 1) / ce), W = Math.min(W, (q[2] - oe[2] + 1) / ce), M = Math.max(M, (q[0] - oe[0] - 1) / ce), X = Math.max(X, (q[1] - oe[1] - 1) / ce), U = Math.max(U, (q[2] - oe[2] - 1) / ce), !(M <= se && X <= L && U <= W)) {
                  const he = s.Util.makeHexColor(ae[0], ae[1], ae[2]);
                  te.push([Y / ne, he]), se = q[0] - ae[0] + 1, L = q[1] - ae[1] + 1, W = q[2] - ae[2] + 1, M = q[0] - ae[0] - 1, X = q[1] - ae[1] - 1, U = q[2] - ae[2] - 1, ie = Y, oe = ae;
                }
                Y = le, ae = q;
              }
              const Q = s.Util.makeHexColor(ae[0], ae[1], ae[2]);
              te.push([1, Q]);
              let re = "transparent";
              B.has("Background") && (q = z.getRgb(B.get("Background"), 0), re = s.Util.makeHexColor(q[0], q[1], q[2])), j || (te.unshift([0, re]), te[1][0] += v.SMALL_NUMBER), P || (te.at(-1)[0] -= v.SMALL_NUMBER, te.push([1, re])), this.colorStops = te;
            }
            getIR() {
              const B = this.coordsArr, R = this.shadingType;
              let _, A, k, z, T;
              return R === i.AXIAL ? (A = [B[0], B[1]], k = [B[2], B[3]], z = null, T = null, _ = "axial") : R === i.RADIAL ? (A = [B[0], B[1]], k = [B[3], B[4]], z = B[2], T = B[5], _ = "radial") : (0, s.unreachable)(`getPattern type unknown: ${R}`), ["RadialAxial", _, this.bbox, this.colorStops, A, k, z, T];
            }
          }
          class S {
            constructor(B, R) {
              this.stream = B, this.context = R, this.buffer = 0, this.bufferLength = 0;
              const _ = R.numComps;
              this.tmpCompsBuf = new Float32Array(_);
              const A = R.colorSpace.numComps;
              this.tmpCsCompsBuf = R.colorFn ? new Float32Array(A) : this.tmpCompsBuf;
            }
            get hasData() {
              if (this.stream.end)
                return this.stream.pos < this.stream.end;
              if (this.bufferLength > 0)
                return !0;
              const B = this.stream.getByte();
              return B < 0 ? !1 : (this.buffer = B, this.bufferLength = 8, !0);
            }
            readBits(B) {
              let R = this.buffer, _ = this.bufferLength;
              if (B === 32) {
                if (_ === 0)
                  return (this.stream.getByte() << 24 | this.stream.getByte() << 16 | this.stream.getByte() << 8 | this.stream.getByte()) >>> 0;
                R = R << 24 | this.stream.getByte() << 16 | this.stream.getByte() << 8 | this.stream.getByte();
                const A = this.stream.getByte();
                return this.buffer = A & (1 << _) - 1, (R << 8 - _ | (A & 255) >> _) >>> 0;
              }
              if (B === 8 && _ === 0)
                return this.stream.getByte();
              for (; _ < B; )
                R = R << 8 | this.stream.getByte(), _ += 8;
              return _ -= B, this.bufferLength = _, this.buffer = R & (1 << _) - 1, R >> _;
            }
            align() {
              this.buffer = 0, this.bufferLength = 0;
            }
            readFlag() {
              return this.readBits(this.context.bitsPerFlag);
            }
            readCoordinate() {
              const B = this.context.bitsPerCoordinate, R = this.readBits(B), _ = this.readBits(B), A = this.context.decode, k = B < 32 ? 1 / ((1 << B) - 1) : 23283064365386963e-26;
              return [R * k * (A[1] - A[0]) + A[0], _ * k * (A[3] - A[2]) + A[2]];
            }
            readComponents() {
              const B = this.context.numComps, R = this.context.bitsPerComponent, _ = R < 32 ? 1 / ((1 << R) - 1) : 23283064365386963e-26, A = this.context.decode, k = this.tmpCompsBuf;
              for (let T = 0, w = 4; T < B; T++, w += 2) {
                const F = this.readBits(R);
                k[T] = F * _ * (A[w + 1] - A[w]) + A[w];
              }
              const z = this.tmpCsCompsBuf;
              return this.context.colorFn && this.context.colorFn(k, 0, z, 0), this.context.colorSpace.getRgb(z, 0);
            }
          }
          let y = /* @__PURE__ */ Object.create(null);
          function x(H) {
            const B = [];
            for (let R = 0; R <= H; R++) {
              const _ = R / H, A = 1 - _;
              B.push(new Float32Array([A ** 3, 3 * _ * A ** 2, 3 * _ ** 2 * A, _ ** 3]));
            }
            return B;
          }
          function b(H) {
            return y[H] || (y[H] = x(H));
          }
          function u() {
            y = /* @__PURE__ */ Object.create(null);
          }
          const K = class K extends v {
            constructor(B, R, _, A, k) {
              if (super(), !(B instanceof h.BaseStream))
                throw new s.FormatError("Mesh data is not a stream");
              const z = B.dict;
              this.shadingType = z.get("ShadingType");
              const T = z.getArray("BBox");
              this.bbox = Array.isArray(T) && T.length === 4 ? s.Util.normalizeRect(T) : null;
              const w = g.ColorSpace.parse({
                cs: z.getRaw("CS") || z.getRaw("ColorSpace"),
                xref: R,
                resources: _,
                pdfFunctionFactory: A,
                localColorSpaceCache: k
              });
              this.background = z.has("Background") ? w.getRgb(z.get("Background"), 0) : null;
              const F = z.getRaw("Function"), j = F ? A.createFromArray(F) : null;
              this.coords = [], this.colors = [], this.figures = [];
              const P = {
                bitsPerCoordinate: z.get("BitsPerCoordinate"),
                bitsPerComponent: z.get("BitsPerComponent"),
                bitsPerFlag: z.get("BitsPerFlag"),
                decode: z.getArray("Decode"),
                colorFn: j,
                colorSpace: w,
                numComps: j ? 1 : w.numComps
              }, V = new S(B, P);
              let J = !1;
              switch (this.shadingType) {
                case i.FREE_FORM_MESH:
                  this._decodeType4Shading(V);
                  break;
                case i.LATTICE_FORM_MESH:
                  const ne = z.get("VerticesPerRow") | 0;
                  if (ne < 2)
                    throw new s.FormatError("Invalid VerticesPerRow");
                  this._decodeType5Shading(V, ne);
                  break;
                case i.COONS_PATCH_MESH:
                  this._decodeType6Shading(V), J = !0;
                  break;
                case i.TENSOR_PATCH_MESH:
                  this._decodeType7Shading(V), J = !0;
                  break;
                default:
                  (0, s.unreachable)("Unsupported mesh type.");
                  break;
              }
              if (J) {
                this._updateBounds();
                for (let ne = 0, Z = this.figures.length; ne < Z; ne++)
                  this._buildFigureFromPatch(ne);
              }
              this._updateBounds(), this._packData();
            }
            _decodeType4Shading(B) {
              const R = this.coords, _ = this.colors, A = [];
              let k = 0;
              for (; B.hasData; ) {
                const z = B.readFlag(), T = B.readCoordinate(), w = B.readComponents();
                if (k === 0) {
                  if (!(0 <= z && z <= 2))
                    throw new s.FormatError("Unknown type4 flag");
                  switch (z) {
                    case 0:
                      k = 3;
                      break;
                    case 1:
                      A.push(A.at(-2), A.at(-1)), k = 1;
                      break;
                    case 2:
                      A.push(A.at(-3), A.at(-1)), k = 1;
                      break;
                  }
                }
                A.push(R.length), R.push(T), _.push(w), k--, B.align();
              }
              this.figures.push({
                type: "triangles",
                coords: new Int32Array(A),
                colors: new Int32Array(A)
              });
            }
            _decodeType5Shading(B, R) {
              const _ = this.coords, A = this.colors, k = [];
              for (; B.hasData; ) {
                const z = B.readCoordinate(), T = B.readComponents();
                k.push(_.length), _.push(z), A.push(T);
              }
              this.figures.push({
                type: "lattice",
                coords: new Int32Array(k),
                colors: new Int32Array(k),
                verticesPerRow: R
              });
            }
            _decodeType6Shading(B) {
              const R = this.coords, _ = this.colors, A = new Int32Array(16), k = new Int32Array(4);
              for (; B.hasData; ) {
                const z = B.readFlag();
                if (!(0 <= z && z <= 3))
                  throw new s.FormatError("Unknown type6 flag");
                const T = R.length;
                for (let J = 0, ne = z !== 0 ? 8 : 12; J < ne; J++)
                  R.push(B.readCoordinate());
                const w = _.length;
                for (let J = 0, ne = z !== 0 ? 2 : 4; J < ne; J++)
                  _.push(B.readComponents());
                let F, j, P, V;
                switch (z) {
                  case 0:
                    A[12] = T + 3, A[13] = T + 4, A[14] = T + 5, A[15] = T + 6, A[8] = T + 2, A[11] = T + 7, A[4] = T + 1, A[7] = T + 8, A[0] = T, A[1] = T + 11, A[2] = T + 10, A[3] = T + 9, k[2] = w + 1, k[3] = w + 2, k[0] = w, k[1] = w + 3;
                    break;
                  case 1:
                    F = A[12], j = A[13], P = A[14], V = A[15], A[12] = V, A[13] = T + 0, A[14] = T + 1, A[15] = T + 2, A[8] = P, A[11] = T + 3, A[4] = j, A[7] = T + 4, A[0] = F, A[1] = T + 7, A[2] = T + 6, A[3] = T + 5, F = k[2], j = k[3], k[2] = j, k[3] = w, k[0] = F, k[1] = w + 1;
                    break;
                  case 2:
                    F = A[15], j = A[11], A[12] = A[3], A[13] = T + 0, A[14] = T + 1, A[15] = T + 2, A[8] = A[7], A[11] = T + 3, A[4] = j, A[7] = T + 4, A[0] = F, A[1] = T + 7, A[2] = T + 6, A[3] = T + 5, F = k[3], k[2] = k[1], k[3] = w, k[0] = F, k[1] = w + 1;
                    break;
                  case 3:
                    A[12] = A[0], A[13] = T + 0, A[14] = T + 1, A[15] = T + 2, A[8] = A[1], A[11] = T + 3, A[4] = A[2], A[7] = T + 4, A[0] = A[3], A[1] = T + 7, A[2] = T + 6, A[3] = T + 5, k[2] = k[0], k[3] = w, k[0] = k[1], k[1] = w + 1;
                    break;
                }
                A[5] = R.length, R.push([(-4 * R[A[0]][0] - R[A[15]][0] + 6 * (R[A[4]][0] + R[A[1]][0]) - 2 * (R[A[12]][0] + R[A[3]][0]) + 3 * (R[A[13]][0] + R[A[7]][0])) / 9, (-4 * R[A[0]][1] - R[A[15]][1] + 6 * (R[A[4]][1] + R[A[1]][1]) - 2 * (R[A[12]][1] + R[A[3]][1]) + 3 * (R[A[13]][1] + R[A[7]][1])) / 9]), A[6] = R.length, R.push([(-4 * R[A[3]][0] - R[A[12]][0] + 6 * (R[A[2]][0] + R[A[7]][0]) - 2 * (R[A[0]][0] + R[A[15]][0]) + 3 * (R[A[4]][0] + R[A[14]][0])) / 9, (-4 * R[A[3]][1] - R[A[12]][1] + 6 * (R[A[2]][1] + R[A[7]][1]) - 2 * (R[A[0]][1] + R[A[15]][1]) + 3 * (R[A[4]][1] + R[A[14]][1])) / 9]), A[9] = R.length, R.push([(-4 * R[A[12]][0] - R[A[3]][0] + 6 * (R[A[8]][0] + R[A[13]][0]) - 2 * (R[A[0]][0] + R[A[15]][0]) + 3 * (R[A[11]][0] + R[A[1]][0])) / 9, (-4 * R[A[12]][1] - R[A[3]][1] + 6 * (R[A[8]][1] + R[A[13]][1]) - 2 * (R[A[0]][1] + R[A[15]][1]) + 3 * (R[A[11]][1] + R[A[1]][1])) / 9]), A[10] = R.length, R.push([(-4 * R[A[15]][0] - R[A[0]][0] + 6 * (R[A[11]][0] + R[A[14]][0]) - 2 * (R[A[12]][0] + R[A[3]][0]) + 3 * (R[A[2]][0] + R[A[8]][0])) / 9, (-4 * R[A[15]][1] - R[A[0]][1] + 6 * (R[A[11]][1] + R[A[14]][1]) - 2 * (R[A[12]][1] + R[A[3]][1]) + 3 * (R[A[2]][1] + R[A[8]][1])) / 9]), this.figures.push({
                  type: "patch",
                  coords: new Int32Array(A),
                  colors: new Int32Array(k)
                });
              }
            }
            _decodeType7Shading(B) {
              const R = this.coords, _ = this.colors, A = new Int32Array(16), k = new Int32Array(4);
              for (; B.hasData; ) {
                const z = B.readFlag();
                if (!(0 <= z && z <= 3))
                  throw new s.FormatError("Unknown type7 flag");
                const T = R.length;
                for (let J = 0, ne = z !== 0 ? 12 : 16; J < ne; J++)
                  R.push(B.readCoordinate());
                const w = _.length;
                for (let J = 0, ne = z !== 0 ? 2 : 4; J < ne; J++)
                  _.push(B.readComponents());
                let F, j, P, V;
                switch (z) {
                  case 0:
                    A[12] = T + 3, A[13] = T + 4, A[14] = T + 5, A[15] = T + 6, A[8] = T + 2, A[9] = T + 13, A[10] = T + 14, A[11] = T + 7, A[4] = T + 1, A[5] = T + 12, A[6] = T + 15, A[7] = T + 8, A[0] = T, A[1] = T + 11, A[2] = T + 10, A[3] = T + 9, k[2] = w + 1, k[3] = w + 2, k[0] = w, k[1] = w + 3;
                    break;
                  case 1:
                    F = A[12], j = A[13], P = A[14], V = A[15], A[12] = V, A[13] = T + 0, A[14] = T + 1, A[15] = T + 2, A[8] = P, A[9] = T + 9, A[10] = T + 10, A[11] = T + 3, A[4] = j, A[5] = T + 8, A[6] = T + 11, A[7] = T + 4, A[0] = F, A[1] = T + 7, A[2] = T + 6, A[3] = T + 5, F = k[2], j = k[3], k[2] = j, k[3] = w, k[0] = F, k[1] = w + 1;
                    break;
                  case 2:
                    F = A[15], j = A[11], A[12] = A[3], A[13] = T + 0, A[14] = T + 1, A[15] = T + 2, A[8] = A[7], A[9] = T + 9, A[10] = T + 10, A[11] = T + 3, A[4] = j, A[5] = T + 8, A[6] = T + 11, A[7] = T + 4, A[0] = F, A[1] = T + 7, A[2] = T + 6, A[3] = T + 5, F = k[3], k[2] = k[1], k[3] = w, k[0] = F, k[1] = w + 1;
                    break;
                  case 3:
                    A[12] = A[0], A[13] = T + 0, A[14] = T + 1, A[15] = T + 2, A[8] = A[1], A[9] = T + 9, A[10] = T + 10, A[11] = T + 3, A[4] = A[2], A[5] = T + 8, A[6] = T + 11, A[7] = T + 4, A[0] = A[3], A[1] = T + 7, A[2] = T + 6, A[3] = T + 5, k[2] = k[0], k[3] = w, k[0] = k[1], k[1] = w + 1;
                    break;
                }
                this.figures.push({
                  type: "patch",
                  coords: new Int32Array(A),
                  colors: new Int32Array(k)
                });
              }
            }
            _buildFigureFromPatch(B) {
              const R = this.figures[B];
              (0, s.assert)(R.type === "patch", "Unexpected patch mesh figure");
              const _ = this.coords, A = this.colors, k = R.coords, z = R.colors, T = Math.min(_[k[0]][0], _[k[3]][0], _[k[12]][0], _[k[15]][0]), w = Math.min(_[k[0]][1], _[k[3]][1], _[k[12]][1], _[k[15]][1]), F = Math.max(_[k[0]][0], _[k[3]][0], _[k[12]][0], _[k[15]][0]), j = Math.max(_[k[0]][1], _[k[3]][1], _[k[12]][1], _[k[15]][1]);
              let P = Math.ceil((F - T) * K.TRIANGLE_DENSITY / (this.bounds[2] - this.bounds[0]));
              P = Math.max(K.MIN_SPLIT_PATCH_CHUNKS_AMOUNT, Math.min(K.MAX_SPLIT_PATCH_CHUNKS_AMOUNT, P));
              let V = Math.ceil((j - w) * K.TRIANGLE_DENSITY / (this.bounds[3] - this.bounds[1]));
              V = Math.max(K.MIN_SPLIT_PATCH_CHUNKS_AMOUNT, Math.min(K.MAX_SPLIT_PATCH_CHUNKS_AMOUNT, V));
              const J = P + 1, ne = new Int32Array((V + 1) * J), Z = new Int32Array((V + 1) * J);
              let te = 0;
              const G = new Uint8Array(3), N = new Uint8Array(3), q = A[z[0]], ie = A[z[1]], oe = A[z[2]], fe = A[z[3]], Y = b(V), ae = b(P);
              for (let se = 0; se <= V; se++) {
                G[0] = (q[0] * (V - se) + oe[0] * se) / V | 0, G[1] = (q[1] * (V - se) + oe[1] * se) / V | 0, G[2] = (q[2] * (V - se) + oe[2] * se) / V | 0, N[0] = (ie[0] * (V - se) + fe[0] * se) / V | 0, N[1] = (ie[1] * (V - se) + fe[1] * se) / V | 0, N[2] = (ie[2] * (V - se) + fe[2] * se) / V | 0;
                for (let L = 0; L <= P; L++, te++) {
                  if ((se === 0 || se === V) && (L === 0 || L === P))
                    continue;
                  let W = 0, M = 0, X = 0;
                  for (let Q = 0; Q <= 3; Q++)
                    for (let re = 0; re <= 3; re++, X++) {
                      const le = Y[se][Q] * ae[L][re];
                      W += _[k[X]][0] * le, M += _[k[X]][1] * le;
                    }
                  ne[te] = _.length, _.push([W, M]), Z[te] = A.length;
                  const U = new Uint8Array(3);
                  U[0] = (G[0] * (P - L) + N[0] * L) / P | 0, U[1] = (G[1] * (P - L) + N[1] * L) / P | 0, U[2] = (G[2] * (P - L) + N[2] * L) / P | 0, A.push(U);
                }
              }
              ne[0] = k[0], Z[0] = z[0], ne[P] = k[3], Z[P] = z[1], ne[J * V] = k[12], Z[J * V] = z[2], ne[J * V + P] = k[15], Z[J * V + P] = z[3], this.figures[B] = {
                type: "lattice",
                coords: ne,
                colors: Z,
                verticesPerRow: J
              };
            }
            _updateBounds() {
              let B = this.coords[0][0], R = this.coords[0][1], _ = B, A = R;
              for (let k = 1, z = this.coords.length; k < z; k++) {
                const T = this.coords[k][0], w = this.coords[k][1];
                B = B > T ? T : B, R = R > w ? w : R, _ = _ < T ? T : _, A = A < w ? w : A;
              }
              this.bounds = [B, R, _, A];
            }
            _packData() {
              let B, R, _, A;
              const k = this.coords, z = new Float32Array(k.length * 2);
              for (B = 0, _ = 0, R = k.length; B < R; B++) {
                const j = k[B];
                z[_++] = j[0], z[_++] = j[1];
              }
              this.coords = z;
              const T = this.colors, w = new Uint8Array(T.length * 3);
              for (B = 0, _ = 0, R = T.length; B < R; B++) {
                const j = T[B];
                w[_++] = j[0], w[_++] = j[1], w[_++] = j[2];
              }
              this.colors = w;
              const F = this.figures;
              for (B = 0, R = F.length; B < R; B++) {
                const j = F[B], P = j.coords, V = j.colors;
                for (_ = 0, A = P.length; _ < A; _++)
                  P[_] *= 2, V[_] *= 3;
              }
            }
            getIR() {
              return ["Mesh", this.shadingType, this.coords, this.colors, this.figures, this.bounds, this.bbox, this.background];
            }
          };
          ni(K, "MIN_SPLIT_PATCH_CHUNKS_AMOUNT", 3), ni(K, "MAX_SPLIT_PATCH_CHUNKS_AMOUNT", 20), ni(K, "TRIANGLE_DENSITY", 20);
          let I = K;
          class O extends v {
            getIR() {
              return ["Dummy"];
            }
          }
          function D(H, B, R) {
            const _ = B.getArray("Matrix"), A = s.Util.normalizeRect(B.getArray("BBox")), k = B.get("XStep"), z = B.get("YStep"), T = B.get("PaintType"), w = B.get("TilingType");
            if (A[2] - A[0] === 0 || A[3] - A[1] === 0)
              throw new s.FormatError(`Invalid getTilingPatternIR /BBox array: [${A}].`);
            return ["TilingPattern", R, H, _, A, k, z, T, w];
          }
        },
        /* 51 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.getXfaFontDict = b, c.getXfaFontName = y;
          var s = f(52), h = f(4), g = f(53), t = f(54), i = f(55), m = f(56), v = f(3), E = f(38);
          const S = (0, v.getLookupTableFactory)(function(u) {
            u["MyriadPro-Regular"] = u["PdfJS-Fallback-Regular"] = {
              name: "LiberationSans-Regular",
              factors: i.MyriadProRegularFactors,
              baseWidths: t.LiberationSansRegularWidths,
              baseMapping: t.LiberationSansRegularMapping,
              metrics: i.MyriadProRegularMetrics
            }, u["MyriadPro-Bold"] = u["PdfJS-Fallback-Bold"] = {
              name: "LiberationSans-Bold",
              factors: i.MyriadProBoldFactors,
              baseWidths: t.LiberationSansBoldWidths,
              baseMapping: t.LiberationSansBoldMapping,
              metrics: i.MyriadProBoldMetrics
            }, u["MyriadPro-It"] = u["MyriadPro-Italic"] = u["PdfJS-Fallback-Italic"] = {
              name: "LiberationSans-Italic",
              factors: i.MyriadProItalicFactors,
              baseWidths: t.LiberationSansItalicWidths,
              baseMapping: t.LiberationSansItalicMapping,
              metrics: i.MyriadProItalicMetrics
            }, u["MyriadPro-BoldIt"] = u["MyriadPro-BoldItalic"] = u["PdfJS-Fallback-BoldItalic"] = {
              name: "LiberationSans-BoldItalic",
              factors: i.MyriadProBoldItalicFactors,
              baseWidths: t.LiberationSansBoldItalicWidths,
              baseMapping: t.LiberationSansBoldItalicMapping,
              metrics: i.MyriadProBoldItalicMetrics
            }, u.ArialMT = u.Arial = u["Arial-Regular"] = {
              name: "LiberationSans-Regular",
              baseWidths: t.LiberationSansRegularWidths,
              baseMapping: t.LiberationSansRegularMapping
            }, u["Arial-BoldMT"] = u["Arial-Bold"] = {
              name: "LiberationSans-Bold",
              baseWidths: t.LiberationSansBoldWidths,
              baseMapping: t.LiberationSansBoldMapping
            }, u["Arial-ItalicMT"] = u["Arial-Italic"] = {
              name: "LiberationSans-Italic",
              baseWidths: t.LiberationSansItalicWidths,
              baseMapping: t.LiberationSansItalicMapping
            }, u["Arial-BoldItalicMT"] = u["Arial-BoldItalic"] = {
              name: "LiberationSans-BoldItalic",
              baseWidths: t.LiberationSansBoldItalicWidths,
              baseMapping: t.LiberationSansBoldItalicMapping
            }, u["Calibri-Regular"] = {
              name: "LiberationSans-Regular",
              factors: s.CalibriRegularFactors,
              baseWidths: t.LiberationSansRegularWidths,
              baseMapping: t.LiberationSansRegularMapping,
              metrics: s.CalibriRegularMetrics
            }, u["Calibri-Bold"] = {
              name: "LiberationSans-Bold",
              factors: s.CalibriBoldFactors,
              baseWidths: t.LiberationSansBoldWidths,
              baseMapping: t.LiberationSansBoldMapping,
              metrics: s.CalibriBoldMetrics
            }, u["Calibri-Italic"] = {
              name: "LiberationSans-Italic",
              factors: s.CalibriItalicFactors,
              baseWidths: t.LiberationSansItalicWidths,
              baseMapping: t.LiberationSansItalicMapping,
              metrics: s.CalibriItalicMetrics
            }, u["Calibri-BoldItalic"] = {
              name: "LiberationSans-BoldItalic",
              factors: s.CalibriBoldItalicFactors,
              baseWidths: t.LiberationSansBoldItalicWidths,
              baseMapping: t.LiberationSansBoldItalicMapping,
              metrics: s.CalibriBoldItalicMetrics
            }, u["Segoeui-Regular"] = {
              name: "LiberationSans-Regular",
              factors: m.SegoeuiRegularFactors,
              baseWidths: t.LiberationSansRegularWidths,
              baseMapping: t.LiberationSansRegularMapping,
              metrics: m.SegoeuiRegularMetrics
            }, u["Segoeui-Bold"] = {
              name: "LiberationSans-Bold",
              factors: m.SegoeuiBoldFactors,
              baseWidths: t.LiberationSansBoldWidths,
              baseMapping: t.LiberationSansBoldMapping,
              metrics: m.SegoeuiBoldMetrics
            }, u["Segoeui-Italic"] = {
              name: "LiberationSans-Italic",
              factors: m.SegoeuiItalicFactors,
              baseWidths: t.LiberationSansItalicWidths,
              baseMapping: t.LiberationSansItalicMapping,
              metrics: m.SegoeuiItalicMetrics
            }, u["Segoeui-BoldItalic"] = {
              name: "LiberationSans-BoldItalic",
              factors: m.SegoeuiBoldItalicFactors,
              baseWidths: t.LiberationSansBoldItalicWidths,
              baseMapping: t.LiberationSansBoldItalicMapping,
              metrics: m.SegoeuiBoldItalicMetrics
            }, u["Helvetica-Regular"] = u.Helvetica = {
              name: "LiberationSans-Regular",
              factors: g.HelveticaRegularFactors,
              baseWidths: t.LiberationSansRegularWidths,
              baseMapping: t.LiberationSansRegularMapping,
              metrics: g.HelveticaRegularMetrics
            }, u["Helvetica-Bold"] = {
              name: "LiberationSans-Bold",
              factors: g.HelveticaBoldFactors,
              baseWidths: t.LiberationSansBoldWidths,
              baseMapping: t.LiberationSansBoldMapping,
              metrics: g.HelveticaBoldMetrics
            }, u["Helvetica-Italic"] = {
              name: "LiberationSans-Italic",
              factors: g.HelveticaItalicFactors,
              baseWidths: t.LiberationSansItalicWidths,
              baseMapping: t.LiberationSansItalicMapping,
              metrics: g.HelveticaItalicMetrics
            }, u["Helvetica-BoldItalic"] = {
              name: "LiberationSans-BoldItalic",
              factors: g.HelveticaBoldItalicFactors,
              baseWidths: t.LiberationSansBoldItalicWidths,
              baseMapping: t.LiberationSansBoldItalicMapping,
              metrics: g.HelveticaBoldItalicMetrics
            };
          });
          function y(u) {
            const I = (0, E.normalizeFontName)(u);
            return S()[I];
          }
          function x(u) {
            const I = y(u);
            if (!I)
              return null;
            const {
              baseWidths: O,
              baseMapping: D,
              factors: $
            } = I, K = $ ? O.map((_, A) => _ * $[A]) : O;
            let H = -2, B;
            const R = [];
            for (const [_, A] of D.map((k, z) => [k, z]).sort(([k], [z]) => k - z))
              _ !== -1 && (_ === H + 1 ? (B.push(K[A]), H += 1) : (H = _, B = [K[A]], R.push(_, B)));
            return R;
          }
          function b(u) {
            const I = x(u), O = new h.Dict(null);
            O.set("BaseFont", h.Name.get(u)), O.set("Type", h.Name.get("Font")), O.set("Subtype", h.Name.get("CIDFontType2")), O.set("Encoding", h.Name.get("Identity-H")), O.set("CIDToGIDMap", h.Name.get("Identity")), O.set("W", I), O.set("FirstChar", I[0]), O.set("LastChar", I.at(-2) + I.at(-1).length - 1);
            const D = new h.Dict(null);
            O.set("FontDescriptor", D);
            const $ = new h.Dict(null);
            return $.set("Ordering", "Identity"), $.set("Registry", "Adobe"), $.set("Supplement", 0), O.set("CIDSystemInfo", $), O;
          }
        },
        /* 52 */
        /***/
        (d, c) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.CalibriRegularMetrics = c.CalibriRegularFactors = c.CalibriItalicMetrics = c.CalibriItalicFactors = c.CalibriBoldMetrics = c.CalibriBoldItalicMetrics = c.CalibriBoldItalicFactors = c.CalibriBoldFactors = void 0;
          const f = [1.3877, 1, 1, 1, 0.97801, 0.92482, 0.89552, 0.91133, 0.81988, 0.97566, 0.98152, 0.93548, 0.93548, 1.2798, 0.85284, 0.92794, 1, 0.96134, 1.54657, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.82845, 0.82845, 0.85284, 0.85284, 0.85284, 0.75859, 0.92138, 0.83908, 0.7762, 0.73293, 0.87289, 0.73133, 0.7514, 0.81921, 0.87356, 0.95958, 0.59526, 0.75727, 0.69225, 1.04924, 0.9121, 0.86943, 0.79795, 0.88198, 0.77958, 0.70864, 0.81055, 0.90399, 0.88653, 0.96017, 0.82577, 0.77892, 0.78257, 0.97507, 1.54657, 0.97507, 0.85284, 0.89552, 0.90176, 0.88762, 0.8785, 0.75241, 0.8785, 0.90518, 0.95015, 0.77618, 0.8785, 0.88401, 0.91916, 0.86304, 0.88401, 0.91488, 0.8785, 0.8801, 0.8785, 0.8785, 0.91343, 0.7173, 1.04106, 0.8785, 0.85075, 0.95794, 0.82616, 0.85162, 0.79492, 0.88331, 1.69808, 0.88331, 0.85284, 0.97801, 0.89552, 0.91133, 0.89552, 0.91133, 1.7801, 0.89552, 1.24487, 1.13254, 1.12401, 0.96839, 0.85284, 0.68787, 0.70645, 0.85592, 0.90747, 1.01466, 1.0088, 0.90323, 1, 1.07463, 1, 0.91056, 0.75806, 1.19118, 0.96839, 0.78864, 0.82845, 0.84133, 0.75859, 0.83908, 0.83908, 0.83908, 0.83908, 0.83908, 0.83908, 0.77539, 0.73293, 0.73133, 0.73133, 0.73133, 0.73133, 0.95958, 0.95958, 0.95958, 0.95958, 0.88506, 0.9121, 0.86943, 0.86943, 0.86943, 0.86943, 0.86943, 0.85284, 0.87508, 0.90399, 0.90399, 0.90399, 0.90399, 0.77892, 0.79795, 0.90807, 0.88762, 0.88762, 0.88762, 0.88762, 0.88762, 0.88762, 0.8715, 0.75241, 0.90518, 0.90518, 0.90518, 0.90518, 0.88401, 0.88401, 0.88401, 0.88401, 0.8785, 0.8785, 0.8801, 0.8801, 0.8801, 0.8801, 0.8801, 0.90747, 0.89049, 0.8785, 0.8785, 0.8785, 0.8785, 0.85162, 0.8785, 0.85162, 0.83908, 0.88762, 0.83908, 0.88762, 0.83908, 0.88762, 0.73293, 0.75241, 0.73293, 0.75241, 0.73293, 0.75241, 0.73293, 0.75241, 0.87289, 0.83016, 0.88506, 0.93125, 0.73133, 0.90518, 0.73133, 0.90518, 0.73133, 0.90518, 0.73133, 0.90518, 0.73133, 0.90518, 0.81921, 0.77618, 0.81921, 0.77618, 0.81921, 0.77618, 1, 1, 0.87356, 0.8785, 0.91075, 0.89608, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.76229, 0.90167, 0.59526, 0.91916, 1, 1, 0.86304, 0.69225, 0.88401, 1, 1, 0.70424, 0.79468, 0.91926, 0.88175, 0.70823, 0.94903, 0.9121, 0.8785, 1, 1, 0.9121, 0.8785, 0.87802, 0.88656, 0.8785, 0.86943, 0.8801, 0.86943, 0.8801, 0.86943, 0.8801, 0.87402, 0.89291, 0.77958, 0.91343, 1, 1, 0.77958, 0.91343, 0.70864, 0.7173, 0.70864, 0.7173, 0.70864, 0.7173, 0.70864, 0.7173, 1, 1, 0.81055, 0.75841, 0.81055, 1.06452, 0.90399, 0.8785, 0.90399, 0.8785, 0.90399, 0.8785, 0.90399, 0.8785, 0.90399, 0.8785, 0.90399, 0.8785, 0.96017, 0.95794, 0.77892, 0.85162, 0.77892, 0.78257, 0.79492, 0.78257, 0.79492, 0.78257, 0.79492, 0.9297, 0.56892, 0.83908, 0.88762, 0.77539, 0.8715, 0.87508, 0.89049, 1, 1, 0.81055, 1.04106, 1.20528, 1.20528, 1, 1.15543, 0.70674, 0.98387, 0.94721, 1.33431, 1.45894, 0.95161, 1.06303, 0.83908, 0.80352, 0.57184, 0.6965, 0.56289, 0.82001, 0.56029, 0.81235, 1.02988, 0.83908, 0.7762, 0.68156, 0.80367, 0.73133, 0.78257, 0.87356, 0.86943, 0.95958, 0.75727, 0.89019, 1.04924, 0.9121, 0.7648, 0.86943, 0.87356, 0.79795, 0.78275, 0.81055, 0.77892, 0.9762, 0.82577, 0.99819, 0.84896, 0.95958, 0.77892, 0.96108, 1.01407, 0.89049, 1.02988, 0.94211, 0.96108, 0.8936, 0.84021, 0.87842, 0.96399, 0.79109, 0.89049, 1.00813, 1.02988, 0.86077, 0.87445, 0.92099, 0.84723, 0.86513, 0.8801, 0.75638, 0.85714, 0.78216, 0.79586, 0.87965, 0.94211, 0.97747, 0.78287, 0.97926, 0.84971, 1.02988, 0.94211, 0.8801, 0.94211, 0.84971, 0.73133, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90264, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90518, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90548, 1, 1, 1, 1, 1, 1, 0.96017, 0.95794, 0.96017, 0.95794, 0.96017, 0.95794, 0.77892, 0.85162, 1, 1, 0.89552, 0.90527, 1, 0.90363, 0.92794, 0.92794, 0.92794, 0.92794, 0.87012, 0.87012, 0.87012, 0.89552, 0.89552, 1.42259, 0.71143, 1.06152, 1, 1, 1.03372, 1.03372, 0.97171, 1.4956, 2.2807, 0.93835, 0.83406, 0.91133, 0.84107, 0.91133, 1, 1, 1, 0.72021, 1, 1.23108, 0.83489, 0.88525, 0.88525, 0.81499, 0.90527, 1.81055, 0.90527, 1.81055, 1.31006, 1.53711, 0.94434, 1.08696, 1, 0.95018, 0.77192, 0.85284, 0.90747, 1.17534, 0.69825, 0.9716, 1.37077, 0.90747, 0.90747, 0.85356, 0.90747, 0.90747, 1.44947, 0.85284, 0.8941, 0.8941, 0.70572, 0.8, 0.70572, 0.70572, 0.70572, 0.70572, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.99862, 0.99862, 1, 1, 1, 1, 1, 1.08004, 0.91027, 1, 1, 1, 0.99862, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90727, 0.90727, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          c.CalibriBoldFactors = f;
          const s = {
            lineHeight: 1.2207,
            lineGap: 0.2207
          };
          c.CalibriBoldMetrics = s;
          const h = [1.3877, 1, 1, 1, 0.97801, 0.92482, 0.89552, 0.91133, 0.81988, 0.97566, 0.98152, 0.93548, 0.93548, 1.2798, 0.85284, 0.92794, 1, 0.96134, 1.56239, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.82845, 0.82845, 0.85284, 0.85284, 0.85284, 0.75859, 0.92138, 0.83908, 0.7762, 0.71805, 0.87289, 0.73133, 0.7514, 0.81921, 0.87356, 0.95958, 0.59526, 0.75727, 0.69225, 1.04924, 0.90872, 0.85938, 0.79795, 0.87068, 0.77958, 0.69766, 0.81055, 0.90399, 0.88653, 0.96068, 0.82577, 0.77892, 0.78257, 0.97507, 1.529, 0.97507, 0.85284, 0.89552, 0.90176, 0.94908, 0.86411, 0.74012, 0.86411, 0.88323, 0.95015, 0.86411, 0.86331, 0.88401, 0.91916, 0.86304, 0.88401, 0.9039, 0.86331, 0.86331, 0.86411, 0.86411, 0.90464, 0.70852, 1.04106, 0.86331, 0.84372, 0.95794, 0.82616, 0.84548, 0.79492, 0.88331, 1.69808, 0.88331, 0.85284, 0.97801, 0.89552, 0.91133, 0.89552, 0.91133, 1.7801, 0.89552, 1.24487, 1.13254, 1.19129, 0.96839, 0.85284, 0.68787, 0.70645, 0.85592, 0.90747, 1.01466, 1.0088, 0.90323, 1, 1.07463, 1, 0.91056, 0.75806, 1.19118, 0.96839, 0.78864, 0.82845, 0.84133, 0.75859, 0.83908, 0.83908, 0.83908, 0.83908, 0.83908, 0.83908, 0.77539, 0.71805, 0.73133, 0.73133, 0.73133, 0.73133, 0.95958, 0.95958, 0.95958, 0.95958, 0.88506, 0.90872, 0.85938, 0.85938, 0.85938, 0.85938, 0.85938, 0.85284, 0.87068, 0.90399, 0.90399, 0.90399, 0.90399, 0.77892, 0.79795, 0.90807, 0.94908, 0.94908, 0.94908, 0.94908, 0.94908, 0.94908, 0.85887, 0.74012, 0.88323, 0.88323, 0.88323, 0.88323, 0.88401, 0.88401, 0.88401, 0.88401, 0.8785, 0.86331, 0.86331, 0.86331, 0.86331, 0.86331, 0.86331, 0.90747, 0.89049, 0.86331, 0.86331, 0.86331, 0.86331, 0.84548, 0.86411, 0.84548, 0.83908, 0.94908, 0.83908, 0.94908, 0.83908, 0.94908, 0.71805, 0.74012, 0.71805, 0.74012, 0.71805, 0.74012, 0.71805, 0.74012, 0.87289, 0.79538, 0.88506, 0.92726, 0.73133, 0.88323, 0.73133, 0.88323, 0.73133, 0.88323, 0.73133, 0.88323, 0.73133, 0.88323, 0.81921, 0.86411, 0.81921, 0.86411, 0.81921, 0.86411, 1, 1, 0.87356, 0.86331, 0.91075, 0.8777, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.76467, 0.90167, 0.59526, 0.91916, 1, 1, 0.86304, 0.69225, 0.88401, 1, 1, 0.70424, 0.77312, 0.91926, 0.88175, 0.70823, 0.94903, 0.90872, 0.86331, 1, 1, 0.90872, 0.86331, 0.86906, 0.88116, 0.86331, 0.85938, 0.86331, 0.85938, 0.86331, 0.85938, 0.86331, 0.87402, 0.86549, 0.77958, 0.90464, 1, 1, 0.77958, 0.90464, 0.69766, 0.70852, 0.69766, 0.70852, 0.69766, 0.70852, 0.69766, 0.70852, 1, 1, 0.81055, 0.75841, 0.81055, 1.06452, 0.90399, 0.86331, 0.90399, 0.86331, 0.90399, 0.86331, 0.90399, 0.86331, 0.90399, 0.86331, 0.90399, 0.86331, 0.96068, 0.95794, 0.77892, 0.84548, 0.77892, 0.78257, 0.79492, 0.78257, 0.79492, 0.78257, 0.79492, 0.9297, 0.56892, 0.83908, 0.94908, 0.77539, 0.85887, 0.87068, 0.89049, 1, 1, 0.81055, 1.04106, 1.20528, 1.20528, 1, 1.15543, 0.70088, 0.98387, 0.94721, 1.33431, 1.45894, 0.95161, 1.48387, 0.83908, 0.80352, 0.57118, 0.6965, 0.56347, 0.79179, 0.55853, 0.80346, 1.02988, 0.83908, 0.7762, 0.67174, 0.86036, 0.73133, 0.78257, 0.87356, 0.86441, 0.95958, 0.75727, 0.89019, 1.04924, 0.90872, 0.74889, 0.85938, 0.87891, 0.79795, 0.7957, 0.81055, 0.77892, 0.97447, 0.82577, 0.97466, 0.87179, 0.95958, 0.77892, 0.94252, 0.95612, 0.8753, 1.02988, 0.92733, 0.94252, 0.87411, 0.84021, 0.8728, 0.95612, 0.74081, 0.8753, 1.02189, 1.02988, 0.84814, 0.87445, 0.91822, 0.84723, 0.85668, 0.86331, 0.81344, 0.87581, 0.76422, 0.82046, 0.96057, 0.92733, 0.99375, 0.78022, 0.95452, 0.86015, 1.02988, 0.92733, 0.86331, 0.92733, 0.86015, 0.73133, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90631, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.88323, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.85174, 1, 1, 1, 1, 1, 1, 0.96068, 0.95794, 0.96068, 0.95794, 0.96068, 0.95794, 0.77892, 0.84548, 1, 1, 0.89552, 0.90527, 1, 0.90363, 0.92794, 0.92794, 0.92794, 0.89807, 0.87012, 0.87012, 0.87012, 0.89552, 0.89552, 1.42259, 0.71094, 1.06152, 1, 1, 1.03372, 1.03372, 0.97171, 1.4956, 2.2807, 0.92972, 0.83406, 0.91133, 0.83326, 0.91133, 1, 1, 1, 0.72021, 1, 1.23108, 0.83489, 0.88525, 0.88525, 0.81499, 0.90616, 1.81055, 0.90527, 1.81055, 1.3107, 1.53711, 0.94434, 1.08696, 1, 0.95018, 0.77192, 0.85284, 0.90747, 1.17534, 0.69825, 0.9716, 1.37077, 0.90747, 0.90747, 0.85356, 0.90747, 0.90747, 1.44947, 0.85284, 0.8941, 0.8941, 0.70572, 0.8, 0.70572, 0.70572, 0.70572, 0.70572, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.99862, 0.99862, 1, 1, 1, 1, 1, 1.08004, 0.91027, 1, 1, 1, 0.99862, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90727, 0.90727, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          c.CalibriBoldItalicFactors = h;
          const g = {
            lineHeight: 1.2207,
            lineGap: 0.2207
          };
          c.CalibriBoldItalicMetrics = g;
          const t = [1.3877, 1, 1, 1, 1.17223, 1.1293, 0.89552, 0.91133, 0.80395, 1.02269, 1.15601, 0.91056, 0.91056, 1.2798, 0.85284, 0.89807, 1, 0.90861, 1.39543, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.96309, 0.96309, 0.85284, 0.85284, 0.85284, 0.83319, 0.88071, 0.8675, 0.81552, 0.72346, 0.85193, 0.73206, 0.7522, 0.81105, 0.86275, 0.90685, 0.6377, 0.77892, 0.75593, 1.02638, 0.89249, 0.84118, 0.77452, 0.85374, 0.75186, 0.67789, 0.79776, 0.88844, 0.85066, 0.94309, 0.77818, 0.7306, 0.76659, 1.10369, 1.38313, 1.10369, 1.06139, 0.89552, 0.8739, 0.9245, 0.9245, 0.83203, 0.9245, 0.85865, 1.09842, 0.9245, 0.9245, 1.03297, 1.07692, 0.90918, 1.03297, 0.94959, 0.9245, 0.92274, 0.9245, 0.9245, 1.02933, 0.77832, 1.20562, 0.9245, 0.8916, 0.98986, 0.86621, 0.89453, 0.79004, 0.94152, 1.77256, 0.94152, 0.85284, 0.97801, 0.89552, 0.91133, 0.89552, 0.91133, 1.91729, 0.89552, 1.17889, 1.13254, 1.16359, 0.92098, 0.85284, 0.68787, 0.71353, 0.84737, 0.90747, 1.0088, 1.0044, 0.87683, 1, 1.09091, 1, 0.92229, 0.739, 1.15642, 0.92098, 0.76288, 0.80504, 0.80972, 0.75859, 0.8675, 0.8675, 0.8675, 0.8675, 0.8675, 0.8675, 0.76318, 0.72346, 0.73206, 0.73206, 0.73206, 0.73206, 0.90685, 0.90685, 0.90685, 0.90685, 0.86477, 0.89249, 0.84118, 0.84118, 0.84118, 0.84118, 0.84118, 0.85284, 0.84557, 0.88844, 0.88844, 0.88844, 0.88844, 0.7306, 0.77452, 0.86331, 0.9245, 0.9245, 0.9245, 0.9245, 0.9245, 0.9245, 0.84843, 0.83203, 0.85865, 0.85865, 0.85865, 0.85865, 0.82601, 0.82601, 0.82601, 0.82601, 0.94469, 0.9245, 0.92274, 0.92274, 0.92274, 0.92274, 0.92274, 0.90747, 0.86651, 0.9245, 0.9245, 0.9245, 0.9245, 0.89453, 0.9245, 0.89453, 0.8675, 0.9245, 0.8675, 0.9245, 0.8675, 0.9245, 0.72346, 0.83203, 0.72346, 0.83203, 0.72346, 0.83203, 0.72346, 0.83203, 0.85193, 0.8875, 0.86477, 0.99034, 0.73206, 0.85865, 0.73206, 0.85865, 0.73206, 0.85865, 0.73206, 0.85865, 0.73206, 0.85865, 0.81105, 0.9245, 0.81105, 0.9245, 0.81105, 0.9245, 1, 1, 0.86275, 0.9245, 0.90872, 0.93591, 0.90685, 0.82601, 0.90685, 0.82601, 0.90685, 0.82601, 0.90685, 1.03297, 0.90685, 0.82601, 0.77896, 1.05611, 0.6377, 1.07692, 1, 1, 0.90918, 0.75593, 1.03297, 1, 1, 0.76032, 0.9375, 0.98156, 0.93407, 0.77261, 1.11429, 0.89249, 0.9245, 1, 1, 0.89249, 0.9245, 0.92534, 0.86698, 0.9245, 0.84118, 0.92274, 0.84118, 0.92274, 0.84118, 0.92274, 0.8667, 0.86291, 0.75186, 1.02933, 1, 1, 0.75186, 1.02933, 0.67789, 0.77832, 0.67789, 0.77832, 0.67789, 0.77832, 0.67789, 0.77832, 1, 1, 0.79776, 0.97655, 0.79776, 1.23023, 0.88844, 0.9245, 0.88844, 0.9245, 0.88844, 0.9245, 0.88844, 0.9245, 0.88844, 0.9245, 0.88844, 0.9245, 0.94309, 0.98986, 0.7306, 0.89453, 0.7306, 0.76659, 0.79004, 0.76659, 0.79004, 0.76659, 0.79004, 1.09231, 0.54873, 0.8675, 0.9245, 0.76318, 0.84843, 0.84557, 0.86651, 1, 1, 0.79776, 1.20562, 1.18622, 1.18622, 1, 1.1437, 0.67009, 0.96334, 0.93695, 1.35191, 1.40909, 0.95161, 1.48387, 0.8675, 0.90861, 0.6192, 0.7363, 0.64824, 0.82411, 0.56321, 0.85696, 1.23516, 0.8675, 0.81552, 0.7286, 0.84134, 0.73206, 0.76659, 0.86275, 0.84369, 0.90685, 0.77892, 0.85871, 1.02638, 0.89249, 0.75828, 0.84118, 0.85984, 0.77452, 0.76466, 0.79776, 0.7306, 0.90782, 0.77818, 0.903, 0.87291, 0.90685, 0.7306, 0.99058, 1.03667, 0.94635, 1.23516, 0.9849, 0.99058, 0.92393, 0.8916, 0.942, 1.03667, 0.75026, 0.94635, 1.0297, 1.23516, 0.90918, 0.94048, 0.98217, 0.89746, 0.84153, 0.92274, 0.82507, 0.88832, 0.84438, 0.88178, 1.03525, 0.9849, 1.00225, 0.78086, 0.97248, 0.89404, 1.23516, 0.9849, 0.92274, 0.9849, 0.89404, 0.73206, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.89693, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.85865, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90933, 1, 1, 1, 1, 1, 1, 0.94309, 0.98986, 0.94309, 0.98986, 0.94309, 0.98986, 0.7306, 0.89453, 1, 1, 0.89552, 0.90527, 1, 0.90186, 1.12308, 1.12308, 1.12308, 1.12308, 1.2566, 1.2566, 1.2566, 0.89552, 0.89552, 1.42259, 0.68994, 1.03809, 1, 1, 1.0176, 1.0176, 1.11523, 1.4956, 2.01462, 0.97858, 0.82616, 0.91133, 0.83437, 0.91133, 1, 1, 1, 0.70508, 1, 1.23108, 0.79801, 0.84426, 0.84426, 0.774, 0.90572, 1.81055, 0.90749, 1.81055, 1.28809, 1.55469, 0.94434, 1.07806, 1, 0.97094, 0.7589, 0.85284, 0.90747, 1.19658, 0.69825, 0.97622, 1.33512, 0.90747, 0.90747, 0.85284, 0.90747, 0.90747, 1.44947, 0.85284, 0.8941, 0.8941, 0.70572, 0.8, 0.70572, 0.70572, 0.70572, 0.70572, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.99862, 0.99862, 1, 1, 1, 1, 1, 1.0336, 0.91027, 1, 1, 1, 0.99862, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.05859, 1.05859, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          c.CalibriItalicFactors = t;
          const i = {
            lineHeight: 1.2207,
            lineGap: 0.2207
          };
          c.CalibriItalicMetrics = i;
          const m = [1.3877, 1, 1, 1, 1.17223, 1.1293, 0.89552, 0.91133, 0.80395, 1.02269, 1.15601, 0.91056, 0.91056, 1.2798, 0.85284, 0.89807, 1, 0.90861, 1.39016, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.96309, 0.96309, 0.85284, 0.85284, 0.85284, 0.83319, 0.88071, 0.8675, 0.81552, 0.73834, 0.85193, 0.73206, 0.7522, 0.81105, 0.86275, 0.90685, 0.6377, 0.77892, 0.75593, 1.02638, 0.89385, 0.85122, 0.77452, 0.86503, 0.75186, 0.68887, 0.79776, 0.88844, 0.85066, 0.94258, 0.77818, 0.7306, 0.76659, 1.10369, 1.39016, 1.10369, 1.06139, 0.89552, 0.8739, 0.86128, 0.94469, 0.8457, 0.94469, 0.89464, 1.09842, 0.84636, 0.94469, 1.03297, 1.07692, 0.90918, 1.03297, 0.95897, 0.94469, 0.9482, 0.94469, 0.94469, 1.04692, 0.78223, 1.20562, 0.94469, 0.90332, 0.98986, 0.86621, 0.90527, 0.79004, 0.94152, 1.77256, 0.94152, 0.85284, 0.97801, 0.89552, 0.91133, 0.89552, 0.91133, 1.91729, 0.89552, 1.17889, 1.13254, 1.08707, 0.92098, 0.85284, 0.68787, 0.71353, 0.84737, 0.90747, 1.0088, 1.0044, 0.87683, 1, 1.09091, 1, 0.92229, 0.739, 1.15642, 0.92098, 0.76288, 0.80504, 0.80972, 0.75859, 0.8675, 0.8675, 0.8675, 0.8675, 0.8675, 0.8675, 0.76318, 0.73834, 0.73206, 0.73206, 0.73206, 0.73206, 0.90685, 0.90685, 0.90685, 0.90685, 0.86477, 0.89385, 0.85122, 0.85122, 0.85122, 0.85122, 0.85122, 0.85284, 0.85311, 0.88844, 0.88844, 0.88844, 0.88844, 0.7306, 0.77452, 0.86331, 0.86128, 0.86128, 0.86128, 0.86128, 0.86128, 0.86128, 0.8693, 0.8457, 0.89464, 0.89464, 0.89464, 0.89464, 0.82601, 0.82601, 0.82601, 0.82601, 0.94469, 0.94469, 0.9482, 0.9482, 0.9482, 0.9482, 0.9482, 0.90747, 0.86651, 0.94469, 0.94469, 0.94469, 0.94469, 0.90527, 0.94469, 0.90527, 0.8675, 0.86128, 0.8675, 0.86128, 0.8675, 0.86128, 0.73834, 0.8457, 0.73834, 0.8457, 0.73834, 0.8457, 0.73834, 0.8457, 0.85193, 0.92454, 0.86477, 0.9921, 0.73206, 0.89464, 0.73206, 0.89464, 0.73206, 0.89464, 0.73206, 0.89464, 0.73206, 0.89464, 0.81105, 0.84636, 0.81105, 0.84636, 0.81105, 0.84636, 1, 1, 0.86275, 0.94469, 0.90872, 0.95786, 0.90685, 0.82601, 0.90685, 0.82601, 0.90685, 0.82601, 0.90685, 1.03297, 0.90685, 0.82601, 0.77741, 1.05611, 0.6377, 1.07692, 1, 1, 0.90918, 0.75593, 1.03297, 1, 1, 0.76032, 0.90452, 0.98156, 1.11842, 0.77261, 1.11429, 0.89385, 0.94469, 1, 1, 0.89385, 0.94469, 0.95877, 0.86901, 0.94469, 0.85122, 0.9482, 0.85122, 0.9482, 0.85122, 0.9482, 0.8667, 0.90016, 0.75186, 1.04692, 1, 1, 0.75186, 1.04692, 0.68887, 0.78223, 0.68887, 0.78223, 0.68887, 0.78223, 0.68887, 0.78223, 1, 1, 0.79776, 0.92188, 0.79776, 1.23023, 0.88844, 0.94469, 0.88844, 0.94469, 0.88844, 0.94469, 0.88844, 0.94469, 0.88844, 0.94469, 0.88844, 0.94469, 0.94258, 0.98986, 0.7306, 0.90527, 0.7306, 0.76659, 0.79004, 0.76659, 0.79004, 0.76659, 0.79004, 1.09231, 0.54873, 0.8675, 0.86128, 0.76318, 0.8693, 0.85311, 0.86651, 1, 1, 0.79776, 1.20562, 1.18622, 1.18622, 1, 1.1437, 0.67742, 0.96334, 0.93695, 1.35191, 1.40909, 0.95161, 1.48387, 0.86686, 0.90861, 0.62267, 0.74359, 0.65649, 0.85498, 0.56963, 0.88254, 1.23516, 0.8675, 0.81552, 0.75443, 0.84503, 0.73206, 0.76659, 0.86275, 0.85122, 0.90685, 0.77892, 0.85746, 1.02638, 0.89385, 0.75657, 0.85122, 0.86275, 0.77452, 0.74171, 0.79776, 0.7306, 0.95165, 0.77818, 0.89772, 0.88831, 0.90685, 0.7306, 0.98142, 1.02191, 0.96576, 1.23516, 0.99018, 0.98142, 0.9236, 0.89258, 0.94035, 1.02191, 0.78848, 0.96576, 0.9561, 1.23516, 0.90918, 0.92578, 0.95424, 0.89746, 0.83969, 0.9482, 0.80113, 0.89442, 0.85208, 0.86155, 0.98022, 0.99018, 1.00452, 0.81209, 0.99247, 0.89181, 1.23516, 0.99018, 0.9482, 0.99018, 0.89181, 0.73206, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.88844, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.89464, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.96766, 1, 1, 1, 1, 1, 1, 0.94258, 0.98986, 0.94258, 0.98986, 0.94258, 0.98986, 0.7306, 0.90527, 1, 1, 0.89552, 0.90527, 1, 0.90186, 1.12308, 1.12308, 1.12308, 1.12308, 1.2566, 1.2566, 1.2566, 0.89552, 0.89552, 1.42259, 0.69043, 1.03809, 1, 1, 1.0176, 1.0176, 1.11523, 1.4956, 2.01462, 0.99331, 0.82616, 0.91133, 0.84286, 0.91133, 1, 1, 1, 0.70508, 1, 1.23108, 0.79801, 0.84426, 0.84426, 0.774, 0.90527, 1.81055, 0.90527, 1.81055, 1.28809, 1.55469, 0.94434, 1.07806, 1, 0.97094, 0.7589, 0.85284, 0.90747, 1.19658, 0.69825, 0.97622, 1.33512, 0.90747, 0.90747, 0.85356, 0.90747, 0.90747, 1.44947, 0.85284, 0.8941, 0.8941, 0.70572, 0.8, 0.70572, 0.70572, 0.70572, 0.70572, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.99862, 0.99862, 1, 1, 1, 1, 1, 1.0336, 0.91027, 1, 1, 1, 0.99862, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.05859, 1.05859, 1, 1, 1, 1.07185, 0.99413, 0.96334, 1.08065, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          c.CalibriRegularFactors = m;
          const v = {
            lineHeight: 1.2207,
            lineGap: 0.2207
          };
          c.CalibriRegularMetrics = v;
        },
        /* 53 */
        /***/
        (d, c) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.HelveticaRegularMetrics = c.HelveticaRegularFactors = c.HelveticaItalicMetrics = c.HelveticaItalicFactors = c.HelveticaBoldMetrics = c.HelveticaBoldItalicMetrics = c.HelveticaBoldItalicFactors = c.HelveticaBoldFactors = void 0;
          const f = [0.76116, 1, 1, 1.0006, 0.99998, 0.99974, 0.99973, 0.99973, 0.99982, 0.99977, 1.00087, 0.99998, 0.99998, 0.99959, 1.00003, 1.0006, 0.99998, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99998, 1, 1.00003, 1.00003, 1.00003, 1.00026, 0.9999, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00026, 1.00022, 0.99977, 1.0006, 0.99973, 0.99977, 1.00026, 0.99999, 0.99977, 1.00022, 1.00001, 1.00022, 0.99977, 1.00001, 1.00026, 0.99977, 1.00001, 1.00016, 1.00001, 1.00001, 1.00026, 0.99998, 1.0006, 0.99998, 1.00003, 0.99973, 0.99998, 0.99973, 1.00026, 0.99973, 1.00026, 0.99973, 0.99998, 1.00026, 1.00026, 1.0006, 1.0006, 0.99973, 1.0006, 0.99982, 1.00026, 1.00026, 1.00026, 1.00026, 0.99959, 0.99973, 0.99998, 1.00026, 0.99973, 1.00022, 0.99973, 0.99973, 1, 0.99959, 1.00077, 0.99959, 1.00003, 0.99998, 0.99973, 0.99973, 0.99973, 0.99973, 1.00077, 0.99973, 0.99998, 1.00025, 0.99968, 0.99973, 1.00003, 1.00025, 0.60299, 1.00024, 1.06409, 1, 1, 0.99998, 1, 0.99973, 1.0006, 0.99998, 1, 0.99936, 0.99973, 1.00002, 1.00002, 1.00002, 1.00026, 0.99977, 0.99977, 0.99977, 0.99977, 0.99977, 0.99977, 1, 0.99977, 1.00001, 1.00001, 1.00001, 1.00001, 1.0006, 1.0006, 1.0006, 1.0006, 0.99977, 0.99977, 1.00022, 1.00022, 1.00022, 1.00022, 1.00022, 1.00003, 1.00022, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00001, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99982, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.06409, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 0.99973, 1.00026, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 1.03374, 0.99977, 1.00026, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.00042, 0.99973, 0.99973, 1.0006, 0.99977, 0.99973, 0.99973, 1.00026, 1.0006, 1.00026, 1.0006, 1.00026, 1.03828, 1.00026, 0.99999, 1.00026, 1.0006, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.9993, 0.9998, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1, 1.00016, 0.99977, 0.99959, 0.99977, 0.99959, 0.99977, 0.99959, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00026, 0.99998, 1.00026, 0.8121, 1.00026, 0.99998, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 1.00016, 1.00022, 1.00001, 0.99973, 1.00001, 1.00026, 1, 1.00026, 1, 1.00026, 1, 1.0006, 0.99973, 0.99977, 0.99973, 1, 0.99982, 1.00022, 1.00026, 1.00001, 0.99973, 1.00026, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 1.00034, 0.99977, 1, 0.99997, 1.00026, 1.00078, 1.00036, 0.99973, 1.00013, 1.0006, 0.99977, 0.99977, 0.99988, 0.85148, 1.00001, 1.00026, 0.99977, 1.00022, 1.0006, 0.99977, 1.00001, 0.99999, 0.99977, 1.00069, 1.00022, 0.99977, 1.00001, 0.99984, 1.00026, 1.00001, 1.00024, 1.00001, 0.9999, 1, 1.0006, 1.00001, 1.00041, 0.99962, 1.00026, 1.0006, 0.99995, 1.00041, 0.99942, 0.99973, 0.99927, 1.00082, 0.99902, 1.00026, 1.00087, 1.0006, 1.00069, 0.99973, 0.99867, 0.99973, 0.9993, 1.00026, 1.00049, 1.00056, 1, 0.99988, 0.99935, 0.99995, 0.99954, 1.00055, 0.99945, 1.00032, 1.0006, 0.99995, 1.00026, 0.99995, 1.00032, 1.00001, 1.00008, 0.99971, 1.00019, 0.9994, 1.00001, 1.0006, 1.00044, 0.99973, 1.00023, 1.00047, 1, 0.99942, 0.99561, 0.99989, 1.00035, 0.99977, 1.00035, 0.99977, 1.00019, 0.99944, 1.00001, 1.00021, 0.99926, 1.00035, 1.00035, 0.99942, 1.00048, 0.99999, 0.99977, 1.00022, 1.00035, 1.00001, 0.99977, 1.00026, 0.99989, 1.00057, 1.00001, 0.99936, 1.00052, 1.00012, 0.99996, 1.00043, 1, 1.00035, 0.9994, 0.99976, 1.00035, 0.99973, 1.00052, 1.00041, 1.00119, 1.00037, 0.99973, 1.00002, 0.99986, 1.00041, 1.00041, 0.99902, 0.9996, 1.00034, 0.99999, 1.00026, 0.99999, 1.00026, 0.99973, 1.00052, 0.99973, 1, 0.99973, 1.00041, 1.00075, 0.9994, 1.0003, 0.99999, 1, 1.00041, 0.99955, 1, 0.99915, 0.99973, 0.99973, 1.00026, 1.00119, 0.99955, 0.99973, 1.0006, 0.99911, 1.0006, 1.00026, 0.99972, 1.00026, 0.99902, 1.00041, 0.99973, 0.99999, 1, 1, 1.00038, 1.0005, 1.00016, 1.00022, 1.00016, 1.00022, 1.00016, 1.00022, 1.00001, 0.99973, 1, 1, 0.99973, 1, 1, 0.99955, 1.0006, 1.0006, 1.0006, 1.0006, 1, 1, 1, 0.99973, 0.99973, 0.99972, 1, 1, 1.00106, 0.99999, 0.99998, 0.99998, 0.99999, 0.99998, 1.66475, 1, 0.99973, 0.99973, 1.00023, 0.99973, 0.99971, 1.00047, 1.00023, 1, 0.99991, 0.99984, 1.00002, 1.00002, 1.00002, 1.00002, 1, 1, 1, 1, 1, 1, 1, 0.99972, 1, 1.20985, 1.39713, 1.00003, 1.00031, 1.00015, 1, 0.99561, 1.00027, 1.00031, 1.00031, 0.99915, 1.00031, 1.00031, 0.99999, 1.00003, 0.99999, 0.99999, 1.41144, 1.6, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.40579, 1.40579, 1.36625, 0.99999, 1, 0.99861, 0.99861, 1, 1.00026, 1.00026, 1.00026, 1.00026, 0.99972, 0.99999, 0.99999, 0.99999, 0.99999, 1.40483, 1, 0.99977, 1.00054, 1, 1, 0.99953, 0.99962, 1.00042, 0.9995, 1, 1, 1, 1, 1, 1, 1, 1, 0.99998, 0.99998, 0.99998, 0.99998, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          c.HelveticaBoldFactors = f;
          const s = {
            lineHeight: 1.2,
            lineGap: 0.2
          };
          c.HelveticaBoldMetrics = s;
          const h = [0.76116, 1, 1, 1.0006, 0.99998, 0.99974, 0.99973, 0.99973, 0.99982, 0.99977, 1.00087, 0.99998, 0.99998, 0.99959, 1.00003, 1.0006, 0.99998, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99998, 1, 1.00003, 1.00003, 1.00003, 1.00026, 0.9999, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00026, 1.00022, 0.99977, 1.0006, 0.99973, 0.99977, 1.00026, 0.99999, 0.99977, 1.00022, 1.00001, 1.00022, 0.99977, 1.00001, 1.00026, 0.99977, 1.00001, 1.00016, 1.00001, 1.00001, 1.00026, 0.99998, 1.0006, 0.99998, 1.00003, 0.99973, 0.99998, 0.99973, 1.00026, 0.99973, 1.00026, 0.99973, 0.99998, 1.00026, 1.00026, 1.0006, 1.0006, 0.99973, 1.0006, 0.99982, 1.00026, 1.00026, 1.00026, 1.00026, 0.99959, 0.99973, 0.99998, 1.00026, 0.99973, 1.00022, 0.99973, 0.99973, 1, 0.99959, 1.00077, 0.99959, 1.00003, 0.99998, 0.99973, 0.99973, 0.99973, 0.99973, 1.00077, 0.99973, 0.99998, 1.00025, 0.99968, 0.99973, 1.00003, 1.00025, 0.60299, 1.00024, 1.06409, 1, 1, 0.99998, 1, 0.99973, 1.0006, 0.99998, 1, 0.99936, 0.99973, 1.00002, 1.00002, 1.00002, 1.00026, 0.99977, 0.99977, 0.99977, 0.99977, 0.99977, 0.99977, 1, 0.99977, 1.00001, 1.00001, 1.00001, 1.00001, 1.0006, 1.0006, 1.0006, 1.0006, 0.99977, 0.99977, 1.00022, 1.00022, 1.00022, 1.00022, 1.00022, 1.00003, 1.00022, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00001, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99982, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.06409, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 0.99973, 1.00026, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 1.0044, 0.99977, 1.00026, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 0.99971, 0.99973, 0.99973, 1.0006, 0.99977, 0.99973, 0.99973, 1.00026, 1.0006, 1.00026, 1.0006, 1.00026, 1.01011, 1.00026, 0.99999, 1.00026, 1.0006, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.9993, 0.9998, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1, 1.00016, 0.99977, 0.99959, 0.99977, 0.99959, 0.99977, 0.99959, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00026, 0.99998, 1.00026, 0.8121, 1.00026, 0.99998, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 1.00016, 1.00022, 1.00001, 0.99973, 1.00001, 1.00026, 1, 1.00026, 1, 1.00026, 1, 1.0006, 0.99973, 0.99977, 0.99973, 1, 0.99982, 1.00022, 1.00026, 1.00001, 0.99973, 1.00026, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99977, 1, 1, 1.00026, 0.99969, 0.99972, 0.99981, 0.9998, 1.0006, 0.99977, 0.99977, 1.00022, 0.91155, 1.00001, 1.00026, 0.99977, 1.00022, 1.0006, 0.99977, 1.00001, 0.99999, 0.99977, 0.99966, 1.00022, 1.00032, 1.00001, 0.99944, 1.00026, 1.00001, 0.99968, 1.00001, 1.00047, 1, 1.0006, 1.00001, 0.99981, 1.00101, 1.00026, 1.0006, 0.99948, 0.99981, 1.00064, 0.99973, 0.99942, 1.00101, 1.00061, 1.00026, 1.00069, 1.0006, 1.00014, 0.99973, 1.01322, 0.99973, 1.00065, 1.00026, 1.00012, 0.99923, 1, 1.00064, 1.00076, 0.99948, 1.00055, 1.00063, 1.00007, 0.99943, 1.0006, 0.99948, 1.00026, 0.99948, 0.99943, 1.00001, 1.00001, 1.00029, 1.00038, 1.00035, 1.00001, 1.0006, 1.0006, 0.99973, 0.99978, 1.00001, 1.00057, 0.99989, 0.99967, 0.99964, 0.99967, 0.99977, 0.99999, 0.99977, 1.00038, 0.99977, 1.00001, 0.99973, 1.00066, 0.99967, 0.99967, 1.00041, 0.99998, 0.99999, 0.99977, 1.00022, 0.99967, 1.00001, 0.99977, 1.00026, 0.99964, 1.00031, 1.00001, 0.99999, 0.99999, 1, 1.00023, 1, 1, 0.99999, 1.00035, 1.00001, 0.99999, 0.99973, 0.99977, 0.99999, 1.00058, 0.99973, 0.99973, 0.99955, 0.9995, 1.00026, 1.00026, 1.00032, 0.99989, 1.00034, 0.99999, 1.00026, 1.00026, 1.00026, 0.99973, 0.45998, 0.99973, 1.00026, 0.99973, 1.00001, 0.99999, 0.99982, 0.99994, 0.99996, 1, 1.00042, 1.00044, 1.00029, 1.00023, 0.99973, 0.99973, 1.00026, 0.99949, 1.00002, 0.99973, 1.0006, 1.0006, 1.0006, 0.99975, 1.00026, 1.00026, 1.00032, 0.98685, 0.99973, 1.00026, 1, 1, 0.99966, 1.00044, 1.00016, 1.00022, 1.00016, 1.00022, 1.00016, 1.00022, 1.00001, 0.99973, 1, 1, 0.99973, 1, 1, 0.99955, 1.0006, 1.0006, 1.0006, 1.0006, 1, 1, 1, 0.99973, 0.99973, 0.99972, 1, 1, 1.00106, 0.99999, 0.99998, 0.99998, 0.99999, 0.99998, 1.66475, 1, 0.99973, 0.99973, 1, 0.99973, 0.99971, 0.99978, 1, 1, 0.99991, 0.99984, 1.00002, 1.00002, 1.00002, 1.00002, 1.00098, 1, 1, 1, 1.00049, 1, 1, 0.99972, 1, 1.20985, 1.39713, 1.00003, 1.00031, 1.00015, 1, 0.99561, 1.00027, 1.00031, 1.00031, 0.99915, 1.00031, 1.00031, 0.99999, 1.00003, 0.99999, 0.99999, 1.41144, 1.6, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.40579, 1.40579, 1.36625, 0.99999, 1, 0.99861, 0.99861, 1, 1.00026, 1.00026, 1.00026, 1.00026, 0.99972, 0.99999, 0.99999, 0.99999, 0.99999, 1.40483, 1, 0.99977, 1.00054, 1, 1, 0.99953, 0.99962, 1.00042, 0.9995, 1, 1, 1, 1, 1, 1, 1, 1, 0.99998, 0.99998, 0.99998, 0.99998, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          c.HelveticaBoldItalicFactors = h;
          const g = {
            lineHeight: 1.35,
            lineGap: 0.2
          };
          c.HelveticaBoldItalicMetrics = g;
          const t = [0.76116, 1, 1, 1.0006, 1.0006, 1.00006, 0.99973, 0.99973, 0.99982, 1.00001, 1.00043, 0.99998, 0.99998, 0.99959, 1.00003, 1.0006, 0.99998, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1, 1.00003, 1.00003, 1.00003, 0.99973, 0.99987, 1.00001, 1.00001, 0.99977, 0.99977, 1.00001, 1.00026, 1.00022, 0.99977, 1.0006, 1, 1.00001, 0.99973, 0.99999, 0.99977, 1.00022, 1.00001, 1.00022, 0.99977, 1.00001, 1.00026, 0.99977, 1.00001, 1.00016, 1.00001, 1.00001, 1.00026, 1.0006, 1.0006, 1.0006, 0.99949, 0.99973, 0.99998, 0.99973, 0.99973, 1, 0.99973, 0.99973, 1.0006, 0.99973, 0.99973, 0.99924, 0.99924, 1, 0.99924, 0.99999, 0.99973, 0.99973, 0.99973, 0.99973, 0.99998, 1, 1.0006, 0.99973, 1, 0.99977, 1, 1, 1, 1.00005, 1.0009, 1.00005, 1.00003, 0.99998, 0.99973, 0.99973, 0.99973, 0.99973, 1.0009, 0.99973, 0.99998, 1.00025, 0.99968, 0.99973, 1.00003, 1.00025, 0.60299, 1.00024, 1.06409, 1, 1, 0.99998, 1, 0.9998, 1.0006, 0.99998, 1, 0.99936, 0.99973, 1.00002, 1.00002, 1.00002, 1.00026, 1.00001, 1.00001, 1.00001, 1.00001, 1.00001, 1.00001, 1, 0.99977, 1.00001, 1.00001, 1.00001, 1.00001, 1.0006, 1.0006, 1.0006, 1.0006, 0.99977, 0.99977, 1.00022, 1.00022, 1.00022, 1.00022, 1.00022, 1.00003, 1.00022, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00001, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99982, 1, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.06409, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 1, 0.99973, 1, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 0.99977, 1, 0.99977, 1, 0.99977, 1, 0.99977, 1, 0.99977, 1.0288, 0.99977, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 0.99924, 1.0006, 1.0006, 0.99946, 1.00034, 1, 0.99924, 1.00001, 1, 1, 0.99973, 0.99924, 0.99973, 0.99924, 0.99973, 1.06311, 0.99973, 1.00024, 0.99973, 0.99924, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 1.00041, 0.9998, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1, 1.00016, 0.99977, 0.99998, 0.99977, 0.99998, 0.99977, 0.99998, 1.00001, 1, 1.00001, 1, 1.00001, 1, 1.00001, 1, 1.00026, 1.0006, 1.00026, 0.89547, 1.00026, 1.0006, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 1.00016, 0.99977, 1.00001, 1, 1.00001, 1.00026, 1, 1.00026, 1, 1.00026, 1, 0.99924, 0.99973, 1.00001, 0.99973, 1, 0.99982, 1.00022, 1.00026, 1.00001, 1, 1.00026, 1.0006, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 1.00001, 1, 1.00054, 0.99977, 1.00084, 1.00007, 0.99973, 1.00013, 0.99924, 1.00001, 1.00001, 0.99945, 0.91221, 1.00001, 1.00026, 0.99977, 1.00022, 1.0006, 1.00001, 1.00001, 0.99999, 0.99977, 0.99933, 1.00022, 1.00054, 1.00001, 1.00065, 1.00026, 1.00001, 1.0001, 1.00001, 1.00052, 1, 1.0006, 1.00001, 0.99945, 0.99897, 0.99968, 0.99924, 1.00036, 0.99945, 0.99949, 1, 1.0006, 0.99897, 0.99918, 0.99968, 0.99911, 0.99924, 1, 0.99962, 1.01487, 1, 1.0005, 0.99973, 1.00012, 1.00043, 1, 0.99995, 0.99994, 1.00036, 0.99947, 1.00019, 1.00063, 1.00025, 0.99924, 1.00036, 0.99973, 1.00036, 1.00025, 1.00001, 1.00001, 1.00027, 1.0001, 1.00068, 1.00001, 1.0006, 1.0006, 1, 1.00008, 0.99957, 0.99972, 0.9994, 0.99954, 0.99975, 1.00051, 1.00001, 1.00019, 1.00001, 1.0001, 0.99986, 1.00001, 1.00001, 1.00038, 0.99954, 0.99954, 0.9994, 1.00066, 0.99999, 0.99977, 1.00022, 1.00054, 1.00001, 0.99977, 1.00026, 0.99975, 1.0001, 1.00001, 0.99993, 0.9995, 0.99955, 1.00016, 0.99978, 0.99974, 1.00019, 1.00022, 0.99955, 1.00053, 0.99973, 1.00089, 1.00005, 0.99967, 1.00048, 0.99973, 1.00002, 1.00034, 0.99973, 0.99973, 0.99964, 1.00006, 1.00066, 0.99947, 0.99973, 0.98894, 0.99973, 1, 0.44898, 1, 0.99946, 1, 1.00039, 1.00082, 0.99991, 0.99991, 0.99985, 1.00022, 1.00023, 1.00061, 1.00006, 0.99966, 0.99973, 0.99973, 0.99973, 1.00019, 1.0008, 1, 0.99924, 0.99924, 0.99924, 0.99983, 1.00044, 0.99973, 0.99964, 0.98332, 1, 0.99973, 1, 1, 0.99962, 0.99895, 1.00016, 0.99977, 1.00016, 0.99977, 1.00016, 0.99977, 1.00001, 1, 1, 1, 0.99973, 1, 1, 0.99955, 0.99924, 0.99924, 0.99924, 0.99924, 0.99998, 0.99998, 0.99998, 0.99973, 0.99973, 0.99972, 1, 1, 1.00267, 0.99999, 0.99998, 0.99998, 1, 0.99998, 1.66475, 1, 0.99973, 0.99973, 1.00023, 0.99973, 1.00423, 0.99925, 0.99999, 1, 0.99991, 0.99984, 1.00002, 1.00002, 1.00002, 1.00002, 1.00049, 1, 1.00245, 1, 1, 1, 1, 0.96329, 1, 1.20985, 1.39713, 1.00003, 0.8254, 1.00015, 1, 1.00035, 1.00027, 1.00031, 1.00031, 1.00003, 1.00031, 1.00031, 0.99999, 1.00003, 0.99999, 0.99999, 1.41144, 1.6, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.40579, 1.40579, 1.36625, 0.99999, 1, 0.99861, 0.99861, 1, 1.00026, 1.00026, 1.00026, 1.00026, 0.95317, 0.99999, 0.99999, 0.99999, 0.99999, 1.40483, 1, 0.99977, 1.00054, 1, 1, 0.99953, 0.99962, 1.00042, 0.9995, 1, 1, 1, 1, 1, 1, 1, 1, 0.99998, 0.99998, 0.99998, 0.99998, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          c.HelveticaItalicFactors = t;
          const i = {
            lineHeight: 1.35,
            lineGap: 0.2
          };
          c.HelveticaItalicMetrics = i;
          const m = [0.76116, 1, 1, 1.0006, 1.0006, 1.00006, 0.99973, 0.99973, 0.99982, 1.00001, 1.00043, 0.99998, 0.99998, 0.99959, 1.00003, 1.0006, 0.99998, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1, 1.00003, 1.00003, 1.00003, 0.99973, 0.99987, 1.00001, 1.00001, 0.99977, 0.99977, 1.00001, 1.00026, 1.00022, 0.99977, 1.0006, 1, 1.00001, 0.99973, 0.99999, 0.99977, 1.00022, 1.00001, 1.00022, 0.99977, 1.00001, 1.00026, 0.99977, 1.00001, 1.00016, 1.00001, 1.00001, 1.00026, 1.0006, 1.0006, 1.0006, 0.99949, 0.99973, 0.99998, 0.99973, 0.99973, 1, 0.99973, 0.99973, 1.0006, 0.99973, 0.99973, 0.99924, 0.99924, 1, 0.99924, 0.99999, 0.99973, 0.99973, 0.99973, 0.99973, 0.99998, 1, 1.0006, 0.99973, 1, 0.99977, 1, 1, 1, 1.00005, 1.0009, 1.00005, 1.00003, 0.99998, 0.99973, 0.99973, 0.99973, 0.99973, 1.0009, 0.99973, 0.99998, 1.00025, 0.99968, 0.99973, 1.00003, 1.00025, 0.60299, 1.00024, 1.06409, 1, 1, 0.99998, 1, 0.9998, 1.0006, 0.99998, 1, 0.99936, 0.99973, 1.00002, 1.00002, 1.00002, 1.00026, 1.00001, 1.00001, 1.00001, 1.00001, 1.00001, 1.00001, 1, 0.99977, 1.00001, 1.00001, 1.00001, 1.00001, 1.0006, 1.0006, 1.0006, 1.0006, 0.99977, 0.99977, 1.00022, 1.00022, 1.00022, 1.00022, 1.00022, 1.00003, 1.00022, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00001, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99982, 1, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.06409, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 1, 0.99973, 1, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 0.99977, 1, 0.99977, 1, 0.99977, 1, 0.99977, 1, 0.99977, 1.04596, 0.99977, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 0.99924, 1.0006, 1.0006, 1.00019, 1.00034, 1, 0.99924, 1.00001, 1, 1, 0.99973, 0.99924, 0.99973, 0.99924, 0.99973, 1.02572, 0.99973, 1.00005, 0.99973, 0.99924, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99999, 0.9998, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1, 1.00016, 0.99977, 0.99998, 0.99977, 0.99998, 0.99977, 0.99998, 1.00001, 1, 1.00001, 1, 1.00001, 1, 1.00001, 1, 1.00026, 1.0006, 1.00026, 0.84533, 1.00026, 1.0006, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 1.00016, 0.99977, 1.00001, 1, 1.00001, 1.00026, 1, 1.00026, 1, 1.00026, 1, 0.99924, 0.99973, 1.00001, 0.99973, 1, 0.99982, 1.00022, 1.00026, 1.00001, 1, 1.00026, 1.0006, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99928, 1, 0.99977, 1.00013, 1.00055, 0.99947, 0.99945, 0.99941, 0.99924, 1.00001, 1.00001, 1.0004, 0.91621, 1.00001, 1.00026, 0.99977, 1.00022, 1.0006, 1.00001, 1.00005, 0.99999, 0.99977, 1.00015, 1.00022, 0.99977, 1.00001, 0.99973, 1.00026, 1.00001, 1.00019, 1.00001, 0.99946, 1, 1.0006, 1.00001, 0.99978, 1.00045, 0.99973, 0.99924, 1.00023, 0.99978, 0.99966, 1, 1.00065, 1.00045, 1.00019, 0.99973, 0.99973, 0.99924, 1, 1, 0.96499, 1, 1.00055, 0.99973, 1.00008, 1.00027, 1, 0.9997, 0.99995, 1.00023, 0.99933, 1.00019, 1.00015, 1.00031, 0.99924, 1.00023, 0.99973, 1.00023, 1.00031, 1.00001, 0.99928, 1.00029, 1.00092, 1.00035, 1.00001, 1.0006, 1.0006, 1, 0.99988, 0.99975, 1, 1.00082, 0.99561, 0.9996, 1.00035, 1.00001, 0.99962, 1.00001, 1.00092, 0.99964, 1.00001, 0.99963, 0.99999, 1.00035, 1.00035, 1.00082, 0.99962, 0.99999, 0.99977, 1.00022, 1.00035, 1.00001, 0.99977, 1.00026, 0.9996, 0.99967, 1.00001, 1.00034, 1.00074, 1.00054, 1.00053, 1.00063, 0.99971, 0.99962, 1.00035, 0.99975, 0.99977, 0.99973, 1.00043, 0.99953, 1.0007, 0.99915, 0.99973, 1.00008, 0.99892, 1.00073, 1.00073, 1.00114, 0.99915, 1.00073, 0.99955, 0.99973, 1.00092, 0.99973, 1, 0.99998, 1, 1.0003, 1, 1.00043, 1.00001, 0.99969, 1.0003, 1, 1.00035, 1.00001, 0.9995, 1, 1.00092, 0.99973, 0.99973, 0.99973, 1.0007, 0.9995, 1, 0.99924, 1.0006, 0.99924, 0.99972, 1.00062, 0.99973, 1.00114, 1.00073, 1, 0.99955, 1, 1, 1.00047, 0.99968, 1.00016, 0.99977, 1.00016, 0.99977, 1.00016, 0.99977, 1.00001, 1, 1, 1, 0.99973, 1, 1, 0.99955, 0.99924, 0.99924, 0.99924, 0.99924, 0.99998, 0.99998, 0.99998, 0.99973, 0.99973, 0.99972, 1, 1, 1.00267, 0.99999, 0.99998, 0.99998, 1, 0.99998, 1.66475, 1, 0.99973, 0.99973, 1.00023, 0.99973, 0.99971, 0.99925, 1.00023, 1, 0.99991, 0.99984, 1.00002, 1.00002, 1.00002, 1.00002, 1, 1, 1, 1, 1, 1, 1, 0.96329, 1, 1.20985, 1.39713, 1.00003, 0.8254, 1.00015, 1, 1.00035, 1.00027, 1.00031, 1.00031, 0.99915, 1.00031, 1.00031, 0.99999, 1.00003, 0.99999, 0.99999, 1.41144, 1.6, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.40579, 1.40579, 1.36625, 0.99999, 1, 0.99861, 0.99861, 1, 1.00026, 1.00026, 1.00026, 1.00026, 0.95317, 0.99999, 0.99999, 0.99999, 0.99999, 1.40483, 1, 0.99977, 1.00054, 1, 1, 0.99953, 0.99962, 1.00042, 0.9995, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          c.HelveticaRegularFactors = m;
          const v = {
            lineHeight: 1.2,
            lineGap: 0.2
          };
          c.HelveticaRegularMetrics = v;
        },
        /* 54 */
        /***/
        (d, c) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.LiberationSansRegularWidths = c.LiberationSansRegularMapping = c.LiberationSansItalicWidths = c.LiberationSansItalicMapping = c.LiberationSansBoldWidths = c.LiberationSansBoldMapping = c.LiberationSansBoldItalicWidths = c.LiberationSansBoldItalicMapping = void 0;
          const f = [365, 0, 333, 278, 333, 474, 556, 556, 889, 722, 238, 333, 333, 389, 584, 278, 333, 278, 278, 556, 556, 556, 556, 556, 556, 556, 556, 556, 556, 333, 333, 584, 584, 584, 611, 975, 722, 722, 722, 722, 667, 611, 778, 722, 278, 556, 722, 611, 833, 722, 778, 667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611, 333, 278, 333, 584, 556, 333, 556, 611, 556, 611, 556, 333, 611, 611, 278, 278, 556, 278, 889, 611, 611, 611, 611, 389, 556, 333, 611, 556, 778, 556, 556, 500, 389, 280, 389, 584, 333, 556, 556, 556, 556, 280, 556, 333, 737, 370, 556, 584, 737, 552, 400, 549, 333, 333, 333, 576, 556, 278, 333, 333, 365, 556, 834, 834, 834, 611, 722, 722, 722, 722, 722, 722, 1e3, 722, 667, 667, 667, 667, 278, 278, 278, 278, 722, 722, 778, 778, 778, 778, 778, 584, 778, 722, 722, 722, 722, 667, 667, 611, 556, 556, 556, 556, 556, 556, 889, 556, 556, 556, 556, 556, 278, 278, 278, 278, 611, 611, 611, 611, 611, 611, 611, 549, 611, 611, 611, 611, 611, 556, 611, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 719, 722, 611, 667, 556, 667, 556, 667, 556, 667, 556, 667, 556, 778, 611, 778, 611, 778, 611, 778, 611, 722, 611, 722, 611, 278, 278, 278, 278, 278, 278, 278, 278, 278, 278, 785, 556, 556, 278, 722, 556, 556, 611, 278, 611, 278, 611, 385, 611, 479, 611, 278, 722, 611, 722, 611, 722, 611, 708, 723, 611, 778, 611, 778, 611, 778, 611, 1e3, 944, 722, 389, 722, 389, 722, 389, 667, 556, 667, 556, 667, 556, 667, 556, 611, 333, 611, 479, 611, 333, 722, 611, 722, 611, 722, 611, 722, 611, 722, 611, 722, 611, 944, 778, 667, 556, 667, 611, 500, 611, 500, 611, 500, 278, 556, 722, 556, 1e3, 889, 778, 611, 667, 556, 611, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 465, 722, 333, 853, 906, 474, 825, 927, 838, 278, 722, 722, 601, 719, 667, 611, 722, 778, 278, 722, 667, 833, 722, 644, 778, 722, 667, 600, 611, 667, 821, 667, 809, 802, 278, 667, 615, 451, 611, 278, 582, 615, 610, 556, 606, 475, 460, 611, 541, 278, 558, 556, 612, 556, 445, 611, 766, 619, 520, 684, 446, 582, 715, 576, 753, 845, 278, 582, 611, 582, 845, 667, 669, 885, 567, 711, 667, 278, 276, 556, 1094, 1062, 875, 610, 722, 622, 719, 722, 719, 722, 567, 712, 667, 904, 626, 719, 719, 610, 702, 833, 722, 778, 719, 667, 722, 611, 622, 854, 667, 730, 703, 1005, 1019, 870, 979, 719, 711, 1031, 719, 556, 618, 615, 417, 635, 556, 709, 497, 615, 615, 500, 635, 740, 604, 611, 604, 611, 556, 490, 556, 875, 556, 615, 581, 833, 844, 729, 854, 615, 552, 854, 583, 556, 556, 611, 417, 552, 556, 278, 281, 278, 969, 906, 611, 500, 615, 556, 604, 778, 611, 487, 447, 944, 778, 944, 778, 944, 778, 667, 556, 333, 333, 556, 1e3, 1e3, 552, 278, 278, 278, 278, 500, 500, 500, 556, 556, 350, 1e3, 1e3, 240, 479, 333, 333, 604, 333, 167, 396, 556, 556, 1094, 556, 885, 489, 1115, 1e3, 768, 600, 834, 834, 834, 834, 1e3, 500, 1e3, 500, 1e3, 500, 500, 494, 612, 823, 713, 584, 549, 713, 979, 722, 274, 549, 549, 583, 549, 549, 604, 584, 604, 604, 708, 625, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 729, 604, 604, 354, 354, 1e3, 990, 990, 990, 990, 494, 604, 604, 604, 604, 354, 1021, 1052, 917, 750, 750, 531, 656, 594, 510, 500, 750, 750, 611, 611, 333, 333, 333, 333, 333, 333, 333, 333, 222, 222, 333, 333, 333, 333, 333, 333, 333, 333];
          c.LiberationSansBoldWidths = f;
          const s = [-1, -1, -1, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 402, 506, 507, 508, 509, 510, 511, 536, 537, 538, 539, 710, 711, 713, 728, 729, 730, 731, 732, 733, 900, 901, 902, 903, 904, 905, 906, 908, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 938, 939, 940, 941, 942, 943, 944, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 970, 971, 972, 973, 974, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1101, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1138, 1139, 1168, 1169, 7808, 7809, 7810, 7811, 7812, 7813, 7922, 7923, 8208, 8209, 8211, 8212, 8213, 8215, 8216, 8217, 8218, 8219, 8220, 8221, 8222, 8224, 8225, 8226, 8230, 8240, 8242, 8243, 8249, 8250, 8252, 8254, 8260, 8319, 8355, 8356, 8359, 8364, 8453, 8467, 8470, 8482, 8486, 8494, 8539, 8540, 8541, 8542, 8592, 8593, 8594, 8595, 8596, 8597, 8616, 8706, 8710, 8719, 8721, 8722, 8730, 8734, 8735, 8745, 8747, 8776, 8800, 8801, 8804, 8805, 8962, 8976, 8992, 8993, 9472, 9474, 9484, 9488, 9492, 9496, 9500, 9508, 9516, 9524, 9532, 9552, 9553, 9554, 9555, 9556, 9557, 9558, 9559, 9560, 9561, 9562, 9563, 9564, 9565, 9566, 9567, 9568, 9569, 9570, 9571, 9572, 9573, 9574, 9575, 9576, 9577, 9578, 9579, 9580, 9600, 9604, 9608, 9612, 9616, 9617, 9618, 9619, 9632, 9633, 9642, 9643, 9644, 9650, 9658, 9660, 9668, 9674, 9675, 9679, 9688, 9689, 9702, 9786, 9787, 9788, 9792, 9794, 9824, 9827, 9829, 9830, 9834, 9835, 9836, 61441, 61442, 61445, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1];
          c.LiberationSansBoldMapping = s;
          const h = [365, 0, 333, 278, 333, 474, 556, 556, 889, 722, 238, 333, 333, 389, 584, 278, 333, 278, 278, 556, 556, 556, 556, 556, 556, 556, 556, 556, 556, 333, 333, 584, 584, 584, 611, 975, 722, 722, 722, 722, 667, 611, 778, 722, 278, 556, 722, 611, 833, 722, 778, 667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611, 333, 278, 333, 584, 556, 333, 556, 611, 556, 611, 556, 333, 611, 611, 278, 278, 556, 278, 889, 611, 611, 611, 611, 389, 556, 333, 611, 556, 778, 556, 556, 500, 389, 280, 389, 584, 333, 556, 556, 556, 556, 280, 556, 333, 737, 370, 556, 584, 737, 552, 400, 549, 333, 333, 333, 576, 556, 278, 333, 333, 365, 556, 834, 834, 834, 611, 722, 722, 722, 722, 722, 722, 1e3, 722, 667, 667, 667, 667, 278, 278, 278, 278, 722, 722, 778, 778, 778, 778, 778, 584, 778, 722, 722, 722, 722, 667, 667, 611, 556, 556, 556, 556, 556, 556, 889, 556, 556, 556, 556, 556, 278, 278, 278, 278, 611, 611, 611, 611, 611, 611, 611, 549, 611, 611, 611, 611, 611, 556, 611, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 740, 722, 611, 667, 556, 667, 556, 667, 556, 667, 556, 667, 556, 778, 611, 778, 611, 778, 611, 778, 611, 722, 611, 722, 611, 278, 278, 278, 278, 278, 278, 278, 278, 278, 278, 782, 556, 556, 278, 722, 556, 556, 611, 278, 611, 278, 611, 396, 611, 479, 611, 278, 722, 611, 722, 611, 722, 611, 708, 723, 611, 778, 611, 778, 611, 778, 611, 1e3, 944, 722, 389, 722, 389, 722, 389, 667, 556, 667, 556, 667, 556, 667, 556, 611, 333, 611, 479, 611, 333, 722, 611, 722, 611, 722, 611, 722, 611, 722, 611, 722, 611, 944, 778, 667, 556, 667, 611, 500, 611, 500, 611, 500, 278, 556, 722, 556, 1e3, 889, 778, 611, 667, 556, 611, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 722, 333, 854, 906, 473, 844, 930, 847, 278, 722, 722, 610, 671, 667, 611, 722, 778, 278, 722, 667, 833, 722, 657, 778, 718, 667, 590, 611, 667, 822, 667, 829, 781, 278, 667, 620, 479, 611, 278, 591, 620, 621, 556, 610, 479, 492, 611, 558, 278, 566, 556, 603, 556, 450, 611, 712, 605, 532, 664, 409, 591, 704, 578, 773, 834, 278, 591, 611, 591, 834, 667, 667, 886, 614, 719, 667, 278, 278, 556, 1094, 1042, 854, 622, 719, 677, 719, 722, 708, 722, 614, 722, 667, 927, 643, 719, 719, 615, 687, 833, 722, 778, 719, 667, 722, 611, 677, 781, 667, 729, 708, 979, 989, 854, 1e3, 708, 719, 1042, 729, 556, 619, 604, 534, 618, 556, 736, 510, 611, 611, 507, 622, 740, 604, 611, 611, 611, 556, 889, 556, 885, 556, 646, 583, 889, 935, 707, 854, 594, 552, 865, 589, 556, 556, 611, 469, 563, 556, 278, 278, 278, 969, 906, 611, 507, 619, 556, 611, 778, 611, 575, 467, 944, 778, 944, 778, 944, 778, 667, 556, 333, 333, 556, 1e3, 1e3, 552, 278, 278, 278, 278, 500, 500, 500, 556, 556, 350, 1e3, 1e3, 240, 479, 333, 333, 604, 333, 167, 396, 556, 556, 1104, 556, 885, 516, 1146, 1e3, 768, 600, 834, 834, 834, 834, 999, 500, 1e3, 500, 1e3, 500, 500, 494, 612, 823, 713, 584, 549, 713, 979, 722, 274, 549, 549, 583, 549, 549, 604, 584, 604, 604, 708, 625, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 729, 604, 604, 354, 354, 1e3, 990, 990, 990, 990, 494, 604, 604, 604, 604, 354, 1021, 1052, 917, 750, 750, 531, 656, 594, 510, 500, 750, 750, 611, 611, 333, 333, 333, 333, 333, 333, 333, 333, 222, 222, 333, 333, 333, 333, 333, 333, 333, 333];
          c.LiberationSansBoldItalicWidths = h;
          const g = [-1, -1, -1, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 402, 506, 507, 508, 509, 510, 511, 536, 537, 538, 539, 710, 711, 713, 728, 729, 730, 731, 732, 733, 900, 901, 902, 903, 904, 905, 906, 908, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 938, 939, 940, 941, 942, 943, 944, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 970, 971, 972, 973, 974, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1101, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1138, 1139, 1168, 1169, 7808, 7809, 7810, 7811, 7812, 7813, 7922, 7923, 8208, 8209, 8211, 8212, 8213, 8215, 8216, 8217, 8218, 8219, 8220, 8221, 8222, 8224, 8225, 8226, 8230, 8240, 8242, 8243, 8249, 8250, 8252, 8254, 8260, 8319, 8355, 8356, 8359, 8364, 8453, 8467, 8470, 8482, 8486, 8494, 8539, 8540, 8541, 8542, 8592, 8593, 8594, 8595, 8596, 8597, 8616, 8706, 8710, 8719, 8721, 8722, 8730, 8734, 8735, 8745, 8747, 8776, 8800, 8801, 8804, 8805, 8962, 8976, 8992, 8993, 9472, 9474, 9484, 9488, 9492, 9496, 9500, 9508, 9516, 9524, 9532, 9552, 9553, 9554, 9555, 9556, 9557, 9558, 9559, 9560, 9561, 9562, 9563, 9564, 9565, 9566, 9567, 9568, 9569, 9570, 9571, 9572, 9573, 9574, 9575, 9576, 9577, 9578, 9579, 9580, 9600, 9604, 9608, 9612, 9616, 9617, 9618, 9619, 9632, 9633, 9642, 9643, 9644, 9650, 9658, 9660, 9668, 9674, 9675, 9679, 9688, 9689, 9702, 9786, 9787, 9788, 9792, 9794, 9824, 9827, 9829, 9830, 9834, 9835, 9836, 61441, 61442, 61445, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1];
          c.LiberationSansBoldItalicMapping = g;
          const t = [365, 0, 333, 278, 278, 355, 556, 556, 889, 667, 191, 333, 333, 389, 584, 278, 333, 278, 278, 556, 556, 556, 556, 556, 556, 556, 556, 556, 556, 278, 278, 584, 584, 584, 556, 1015, 667, 667, 722, 722, 667, 611, 778, 722, 278, 500, 667, 556, 833, 722, 778, 667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611, 278, 278, 278, 469, 556, 333, 556, 556, 500, 556, 556, 278, 556, 556, 222, 222, 500, 222, 833, 556, 556, 556, 556, 333, 500, 278, 556, 500, 722, 500, 500, 500, 334, 260, 334, 584, 333, 556, 556, 556, 556, 260, 556, 333, 737, 370, 556, 584, 737, 552, 400, 549, 333, 333, 333, 576, 537, 278, 333, 333, 365, 556, 834, 834, 834, 611, 667, 667, 667, 667, 667, 667, 1e3, 722, 667, 667, 667, 667, 278, 278, 278, 278, 722, 722, 778, 778, 778, 778, 778, 584, 778, 722, 722, 722, 722, 667, 667, 611, 556, 556, 556, 556, 556, 556, 889, 500, 556, 556, 556, 556, 278, 278, 278, 278, 556, 556, 556, 556, 556, 556, 556, 549, 611, 556, 556, 556, 556, 500, 556, 500, 667, 556, 667, 556, 667, 556, 722, 500, 722, 500, 722, 500, 722, 500, 722, 625, 722, 556, 667, 556, 667, 556, 667, 556, 667, 556, 667, 556, 778, 556, 778, 556, 778, 556, 778, 556, 722, 556, 722, 556, 278, 278, 278, 278, 278, 278, 278, 222, 278, 278, 733, 444, 500, 222, 667, 500, 500, 556, 222, 556, 222, 556, 281, 556, 400, 556, 222, 722, 556, 722, 556, 722, 556, 615, 723, 556, 778, 556, 778, 556, 778, 556, 1e3, 944, 722, 333, 722, 333, 722, 333, 667, 500, 667, 500, 667, 500, 667, 500, 611, 278, 611, 354, 611, 278, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 944, 722, 667, 500, 667, 611, 500, 611, 500, 611, 500, 222, 556, 667, 556, 1e3, 889, 778, 611, 667, 500, 611, 278, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 667, 278, 789, 846, 389, 794, 865, 775, 222, 667, 667, 570, 671, 667, 611, 722, 778, 278, 667, 667, 833, 722, 648, 778, 725, 667, 600, 611, 667, 837, 667, 831, 761, 278, 667, 570, 439, 555, 222, 550, 570, 571, 500, 556, 439, 463, 555, 542, 222, 500, 492, 548, 500, 447, 556, 670, 573, 486, 603, 374, 550, 652, 546, 728, 779, 222, 550, 556, 550, 779, 667, 667, 843, 544, 708, 667, 278, 278, 500, 1066, 982, 844, 589, 715, 639, 724, 667, 651, 667, 544, 704, 667, 917, 614, 715, 715, 589, 686, 833, 722, 778, 725, 667, 722, 611, 639, 795, 667, 727, 673, 920, 923, 805, 886, 651, 694, 1022, 682, 556, 562, 522, 493, 553, 556, 688, 465, 556, 556, 472, 564, 686, 550, 556, 556, 556, 500, 833, 500, 835, 500, 572, 518, 830, 851, 621, 736, 526, 492, 752, 534, 556, 556, 556, 378, 496, 500, 222, 222, 222, 910, 828, 556, 472, 565, 500, 556, 778, 556, 492, 339, 944, 722, 944, 722, 944, 722, 667, 500, 333, 333, 556, 1e3, 1e3, 552, 222, 222, 222, 222, 333, 333, 333, 556, 556, 350, 1e3, 1e3, 188, 354, 333, 333, 500, 333, 167, 365, 556, 556, 1094, 556, 885, 323, 1083, 1e3, 768, 600, 834, 834, 834, 834, 1e3, 500, 998, 500, 1e3, 500, 500, 494, 612, 823, 713, 584, 549, 713, 979, 719, 274, 549, 549, 584, 549, 549, 604, 584, 604, 604, 708, 625, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 729, 604, 604, 354, 354, 1e3, 990, 990, 990, 990, 494, 604, 604, 604, 604, 354, 1021, 1052, 917, 750, 750, 531, 656, 594, 510, 500, 750, 750, 500, 500, 333, 333, 333, 333, 333, 333, 333, 333, 222, 222, 294, 294, 324, 324, 316, 328, 398, 285];
          c.LiberationSansItalicWidths = t;
          const i = [-1, -1, -1, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 402, 506, 507, 508, 509, 510, 511, 536, 537, 538, 539, 710, 711, 713, 728, 729, 730, 731, 732, 733, 900, 901, 902, 903, 904, 905, 906, 908, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 938, 939, 940, 941, 942, 943, 944, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 970, 971, 972, 973, 974, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1101, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1138, 1139, 1168, 1169, 7808, 7809, 7810, 7811, 7812, 7813, 7922, 7923, 8208, 8209, 8211, 8212, 8213, 8215, 8216, 8217, 8218, 8219, 8220, 8221, 8222, 8224, 8225, 8226, 8230, 8240, 8242, 8243, 8249, 8250, 8252, 8254, 8260, 8319, 8355, 8356, 8359, 8364, 8453, 8467, 8470, 8482, 8486, 8494, 8539, 8540, 8541, 8542, 8592, 8593, 8594, 8595, 8596, 8597, 8616, 8706, 8710, 8719, 8721, 8722, 8730, 8734, 8735, 8745, 8747, 8776, 8800, 8801, 8804, 8805, 8962, 8976, 8992, 8993, 9472, 9474, 9484, 9488, 9492, 9496, 9500, 9508, 9516, 9524, 9532, 9552, 9553, 9554, 9555, 9556, 9557, 9558, 9559, 9560, 9561, 9562, 9563, 9564, 9565, 9566, 9567, 9568, 9569, 9570, 9571, 9572, 9573, 9574, 9575, 9576, 9577, 9578, 9579, 9580, 9600, 9604, 9608, 9612, 9616, 9617, 9618, 9619, 9632, 9633, 9642, 9643, 9644, 9650, 9658, 9660, 9668, 9674, 9675, 9679, 9688, 9689, 9702, 9786, 9787, 9788, 9792, 9794, 9824, 9827, 9829, 9830, 9834, 9835, 9836, 61441, 61442, 61445, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1];
          c.LiberationSansItalicMapping = i;
          const m = [365, 0, 333, 278, 278, 355, 556, 556, 889, 667, 191, 333, 333, 389, 584, 278, 333, 278, 278, 556, 556, 556, 556, 556, 556, 556, 556, 556, 556, 278, 278, 584, 584, 584, 556, 1015, 667, 667, 722, 722, 667, 611, 778, 722, 278, 500, 667, 556, 833, 722, 778, 667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611, 278, 278, 278, 469, 556, 333, 556, 556, 500, 556, 556, 278, 556, 556, 222, 222, 500, 222, 833, 556, 556, 556, 556, 333, 500, 278, 556, 500, 722, 500, 500, 500, 334, 260, 334, 584, 333, 556, 556, 556, 556, 260, 556, 333, 737, 370, 556, 584, 737, 552, 400, 549, 333, 333, 333, 576, 537, 278, 333, 333, 365, 556, 834, 834, 834, 611, 667, 667, 667, 667, 667, 667, 1e3, 722, 667, 667, 667, 667, 278, 278, 278, 278, 722, 722, 778, 778, 778, 778, 778, 584, 778, 722, 722, 722, 722, 667, 667, 611, 556, 556, 556, 556, 556, 556, 889, 500, 556, 556, 556, 556, 278, 278, 278, 278, 556, 556, 556, 556, 556, 556, 556, 549, 611, 556, 556, 556, 556, 500, 556, 500, 667, 556, 667, 556, 667, 556, 722, 500, 722, 500, 722, 500, 722, 500, 722, 615, 722, 556, 667, 556, 667, 556, 667, 556, 667, 556, 667, 556, 778, 556, 778, 556, 778, 556, 778, 556, 722, 556, 722, 556, 278, 278, 278, 278, 278, 278, 278, 222, 278, 278, 735, 444, 500, 222, 667, 500, 500, 556, 222, 556, 222, 556, 292, 556, 334, 556, 222, 722, 556, 722, 556, 722, 556, 604, 723, 556, 778, 556, 778, 556, 778, 556, 1e3, 944, 722, 333, 722, 333, 722, 333, 667, 500, 667, 500, 667, 500, 667, 500, 611, 278, 611, 375, 611, 278, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 944, 722, 667, 500, 667, 611, 500, 611, 500, 611, 500, 222, 556, 667, 556, 1e3, 889, 778, 611, 667, 500, 611, 278, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 667, 278, 784, 838, 384, 774, 855, 752, 222, 667, 667, 551, 668, 667, 611, 722, 778, 278, 667, 668, 833, 722, 650, 778, 722, 667, 618, 611, 667, 798, 667, 835, 748, 278, 667, 578, 446, 556, 222, 547, 578, 575, 500, 557, 446, 441, 556, 556, 222, 500, 500, 576, 500, 448, 556, 690, 569, 482, 617, 395, 547, 648, 525, 713, 781, 222, 547, 556, 547, 781, 667, 667, 865, 542, 719, 667, 278, 278, 500, 1057, 1010, 854, 583, 722, 635, 719, 667, 656, 667, 542, 677, 667, 923, 604, 719, 719, 583, 656, 833, 722, 778, 719, 667, 722, 611, 635, 760, 667, 740, 667, 917, 938, 792, 885, 656, 719, 1010, 722, 556, 573, 531, 365, 583, 556, 669, 458, 559, 559, 438, 583, 688, 552, 556, 542, 556, 500, 458, 500, 823, 500, 573, 521, 802, 823, 625, 719, 521, 510, 750, 542, 556, 556, 556, 365, 510, 500, 222, 278, 222, 906, 812, 556, 438, 559, 500, 552, 778, 556, 489, 411, 944, 722, 944, 722, 944, 722, 667, 500, 333, 333, 556, 1e3, 1e3, 552, 222, 222, 222, 222, 333, 333, 333, 556, 556, 350, 1e3, 1e3, 188, 354, 333, 333, 500, 333, 167, 365, 556, 556, 1094, 556, 885, 323, 1073, 1e3, 768, 600, 834, 834, 834, 834, 1e3, 500, 1e3, 500, 1e3, 500, 500, 494, 612, 823, 713, 584, 549, 713, 979, 719, 274, 549, 549, 583, 549, 549, 604, 584, 604, 604, 708, 625, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 729, 604, 604, 354, 354, 1e3, 990, 990, 990, 990, 494, 604, 604, 604, 604, 354, 1021, 1052, 917, 750, 750, 531, 656, 594, 510, 500, 750, 750, 500, 500, 333, 333, 333, 333, 333, 333, 333, 333, 222, 222, 294, 294, 324, 324, 316, 328, 398, 285];
          c.LiberationSansRegularWidths = m;
          const v = [-1, -1, -1, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 402, 506, 507, 508, 509, 510, 511, 536, 537, 538, 539, 710, 711, 713, 728, 729, 730, 731, 732, 733, 900, 901, 902, 903, 904, 905, 906, 908, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 938, 939, 940, 941, 942, 943, 944, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 970, 971, 972, 973, 974, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1101, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1138, 1139, 1168, 1169, 7808, 7809, 7810, 7811, 7812, 7813, 7922, 7923, 8208, 8209, 8211, 8212, 8213, 8215, 8216, 8217, 8218, 8219, 8220, 8221, 8222, 8224, 8225, 8226, 8230, 8240, 8242, 8243, 8249, 8250, 8252, 8254, 8260, 8319, 8355, 8356, 8359, 8364, 8453, 8467, 8470, 8482, 8486, 8494, 8539, 8540, 8541, 8542, 8592, 8593, 8594, 8595, 8596, 8597, 8616, 8706, 8710, 8719, 8721, 8722, 8730, 8734, 8735, 8745, 8747, 8776, 8800, 8801, 8804, 8805, 8962, 8976, 8992, 8993, 9472, 9474, 9484, 9488, 9492, 9496, 9500, 9508, 9516, 9524, 9532, 9552, 9553, 9554, 9555, 9556, 9557, 9558, 9559, 9560, 9561, 9562, 9563, 9564, 9565, 9566, 9567, 9568, 9569, 9570, 9571, 9572, 9573, 9574, 9575, 9576, 9577, 9578, 9579, 9580, 9600, 9604, 9608, 9612, 9616, 9617, 9618, 9619, 9632, 9633, 9642, 9643, 9644, 9650, 9658, 9660, 9668, 9674, 9675, 9679, 9688, 9689, 9702, 9786, 9787, 9788, 9792, 9794, 9824, 9827, 9829, 9830, 9834, 9835, 9836, 61441, 61442, 61445, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1];
          c.LiberationSansRegularMapping = v;
        },
        /* 55 */
        /***/
        (d, c) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.MyriadProRegularMetrics = c.MyriadProRegularFactors = c.MyriadProItalicMetrics = c.MyriadProItalicFactors = c.MyriadProBoldMetrics = c.MyriadProBoldItalicMetrics = c.MyriadProBoldItalicFactors = c.MyriadProBoldFactors = void 0;
          const f = [1.36898, 1, 1, 0.72706, 0.80479, 0.83734, 0.98894, 0.99793, 0.9897, 0.93884, 0.86209, 0.94292, 0.94292, 1.16661, 1.02058, 0.93582, 0.96694, 0.93582, 1.19137, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.78076, 0.78076, 1.02058, 1.02058, 1.02058, 0.72851, 0.78966, 0.90838, 0.83637, 0.82391, 0.96376, 0.80061, 0.86275, 0.8768, 0.95407, 1.0258, 0.73901, 0.85022, 0.83655, 1.0156, 0.95546, 0.92179, 0.87107, 0.92179, 0.82114, 0.8096, 0.89713, 0.94438, 0.95353, 0.94083, 0.91905, 0.90406, 0.9446, 0.94292, 1.18777, 0.94292, 1.02058, 0.89903, 0.90088, 0.94938, 0.97898, 0.81093, 0.97571, 0.94938, 1.024, 0.9577, 0.95933, 0.98621, 1.0474, 0.97455, 0.98981, 0.9672, 0.95933, 0.9446, 0.97898, 0.97407, 0.97646, 0.78036, 1.10208, 0.95442, 0.95298, 0.97579, 0.9332, 0.94039, 0.938, 0.80687, 1.01149, 0.80687, 1.02058, 0.80479, 0.99793, 0.99793, 0.99793, 0.99793, 1.01149, 1.00872, 0.90088, 0.91882, 1.0213, 0.8361, 1.02058, 0.62295, 0.54324, 0.89022, 1.08595, 1, 1, 0.90088, 1, 0.97455, 0.93582, 0.90088, 1, 1.05686, 0.8361, 0.99642, 0.99642, 0.99642, 0.72851, 0.90838, 0.90838, 0.90838, 0.90838, 0.90838, 0.90838, 0.868, 0.82391, 0.80061, 0.80061, 0.80061, 0.80061, 1.0258, 1.0258, 1.0258, 1.0258, 0.97484, 0.95546, 0.92179, 0.92179, 0.92179, 0.92179, 0.92179, 1.02058, 0.92179, 0.94438, 0.94438, 0.94438, 0.94438, 0.90406, 0.86958, 0.98225, 0.94938, 0.94938, 0.94938, 0.94938, 0.94938, 0.94938, 0.9031, 0.81093, 0.94938, 0.94938, 0.94938, 0.94938, 0.98621, 0.98621, 0.98621, 0.98621, 0.93969, 0.95933, 0.9446, 0.9446, 0.9446, 0.9446, 0.9446, 1.08595, 0.9446, 0.95442, 0.95442, 0.95442, 0.95442, 0.94039, 0.97898, 0.94039, 0.90838, 0.94938, 0.90838, 0.94938, 0.90838, 0.94938, 0.82391, 0.81093, 0.82391, 0.81093, 0.82391, 0.81093, 0.82391, 0.81093, 0.96376, 0.84313, 0.97484, 0.97571, 0.80061, 0.94938, 0.80061, 0.94938, 0.80061, 0.94938, 0.80061, 0.94938, 0.80061, 0.94938, 0.8768, 0.9577, 0.8768, 0.9577, 0.8768, 0.9577, 1, 1, 0.95407, 0.95933, 0.97069, 0.95933, 1.0258, 0.98621, 1.0258, 0.98621, 1.0258, 0.98621, 1.0258, 0.98621, 1.0258, 0.98621, 0.887, 1.01591, 0.73901, 1.0474, 1, 1, 0.97455, 0.83655, 0.98981, 1, 1, 0.83655, 0.73977, 0.83655, 0.73903, 0.84638, 1.033, 0.95546, 0.95933, 1, 1, 0.95546, 0.95933, 0.8271, 0.95417, 0.95933, 0.92179, 0.9446, 0.92179, 0.9446, 0.92179, 0.9446, 0.936, 0.91964, 0.82114, 0.97646, 1, 1, 0.82114, 0.97646, 0.8096, 0.78036, 0.8096, 0.78036, 1, 1, 0.8096, 0.78036, 1, 1, 0.89713, 0.77452, 0.89713, 1.10208, 0.94438, 0.95442, 0.94438, 0.95442, 0.94438, 0.95442, 0.94438, 0.95442, 0.94438, 0.95442, 0.94438, 0.95442, 0.94083, 0.97579, 0.90406, 0.94039, 0.90406, 0.9446, 0.938, 0.9446, 0.938, 0.9446, 0.938, 1, 0.99793, 0.90838, 0.94938, 0.868, 0.9031, 0.92179, 0.9446, 1, 1, 0.89713, 1.10208, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90989, 0.9358, 0.91945, 0.83181, 0.75261, 0.87992, 0.82976, 0.96034, 0.83689, 0.97268, 1.0078, 0.90838, 0.83637, 0.8019, 0.90157, 0.80061, 0.9446, 0.95407, 0.92436, 1.0258, 0.85022, 0.97153, 1.0156, 0.95546, 0.89192, 0.92179, 0.92361, 0.87107, 0.96318, 0.89713, 0.93704, 0.95638, 0.91905, 0.91709, 0.92796, 1.0258, 0.93704, 0.94836, 1.0373, 0.95933, 1.0078, 0.95871, 0.94836, 0.96174, 0.92601, 0.9498, 0.98607, 0.95776, 0.95933, 1.05453, 1.0078, 0.98275, 0.9314, 0.95617, 0.91701, 1.05993, 0.9446, 0.78367, 0.9553, 1, 0.86832, 1.0128, 0.95871, 0.99394, 0.87548, 0.96361, 0.86774, 1.0078, 0.95871, 0.9446, 0.95871, 0.86774, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.94083, 0.97579, 0.94083, 0.97579, 0.94083, 0.97579, 0.90406, 0.94039, 0.96694, 1, 0.89903, 1, 1, 1, 0.93582, 0.93582, 0.93582, 1, 0.908, 0.908, 0.918, 0.94219, 0.94219, 0.96544, 1, 1.285, 1, 1, 0.81079, 0.81079, 1, 1, 0.74854, 1, 1, 1, 1, 0.99793, 1, 1, 1, 0.65, 1, 1.36145, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.17173, 1, 0.80535, 0.76169, 1.02058, 1.0732, 1.05486, 1, 1, 1.30692, 1.08595, 1.08595, 1, 1.08595, 1.08595, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.16161, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          c.MyriadProBoldFactors = f;
          const s = {
            lineHeight: 1.2,
            lineGap: 0.2
          };
          c.MyriadProBoldMetrics = s;
          const h = [1.36898, 1, 1, 0.66227, 0.80779, 0.81625, 0.97276, 0.97276, 0.97733, 0.92222, 0.83266, 0.94292, 0.94292, 1.16148, 1.02058, 0.93582, 0.96694, 0.93582, 1.17337, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.78076, 0.78076, 1.02058, 1.02058, 1.02058, 0.71541, 0.76813, 0.85576, 0.80591, 0.80729, 0.94299, 0.77512, 0.83655, 0.86523, 0.92222, 0.98621, 0.71743, 0.81698, 0.79726, 0.98558, 0.92222, 0.90637, 0.83809, 0.90637, 0.80729, 0.76463, 0.86275, 0.90699, 0.91605, 0.9154, 0.85308, 0.85458, 0.90531, 0.94292, 1.21296, 0.94292, 1.02058, 0.89903, 1.18616, 0.99613, 0.91677, 0.78216, 0.91677, 0.90083, 0.98796, 0.9135, 0.92168, 0.95381, 0.98981, 0.95298, 0.95381, 0.93459, 0.92168, 0.91513, 0.92004, 0.91677, 0.95077, 0.748, 1.04502, 0.91677, 0.92061, 0.94236, 0.89544, 0.89364, 0.9, 0.80687, 0.8578, 0.80687, 1.02058, 0.80779, 0.97276, 0.97276, 0.97276, 0.97276, 0.8578, 0.99973, 1.18616, 0.91339, 1.08074, 0.82891, 1.02058, 0.55509, 0.71526, 0.89022, 1.08595, 1, 1, 1.18616, 1, 0.96736, 0.93582, 1.18616, 1, 1.04864, 0.82711, 0.99043, 0.99043, 0.99043, 0.71541, 0.85576, 0.85576, 0.85576, 0.85576, 0.85576, 0.85576, 0.845, 0.80729, 0.77512, 0.77512, 0.77512, 0.77512, 0.98621, 0.98621, 0.98621, 0.98621, 0.95961, 0.92222, 0.90637, 0.90637, 0.90637, 0.90637, 0.90637, 1.02058, 0.90251, 0.90699, 0.90699, 0.90699, 0.90699, 0.85458, 0.83659, 0.94951, 0.99613, 0.99613, 0.99613, 0.99613, 0.99613, 0.99613, 0.85811, 0.78216, 0.90083, 0.90083, 0.90083, 0.90083, 0.95381, 0.95381, 0.95381, 0.95381, 0.9135, 0.92168, 0.91513, 0.91513, 0.91513, 0.91513, 0.91513, 1.08595, 0.91677, 0.91677, 0.91677, 0.91677, 0.91677, 0.89364, 0.92332, 0.89364, 0.85576, 0.99613, 0.85576, 0.99613, 0.85576, 0.99613, 0.80729, 0.78216, 0.80729, 0.78216, 0.80729, 0.78216, 0.80729, 0.78216, 0.94299, 0.76783, 0.95961, 0.91677, 0.77512, 0.90083, 0.77512, 0.90083, 0.77512, 0.90083, 0.77512, 0.90083, 0.77512, 0.90083, 0.86523, 0.9135, 0.86523, 0.9135, 0.86523, 0.9135, 1, 1, 0.92222, 0.92168, 0.92222, 0.92168, 0.98621, 0.95381, 0.98621, 0.95381, 0.98621, 0.95381, 0.98621, 0.95381, 0.98621, 0.95381, 0.86036, 0.97096, 0.71743, 0.98981, 1, 1, 0.95298, 0.79726, 0.95381, 1, 1, 0.79726, 0.6894, 0.79726, 0.74321, 0.81691, 1.0006, 0.92222, 0.92168, 1, 1, 0.92222, 0.92168, 0.79464, 0.92098, 0.92168, 0.90637, 0.91513, 0.90637, 0.91513, 0.90637, 0.91513, 0.909, 0.87514, 0.80729, 0.95077, 1, 1, 0.80729, 0.95077, 0.76463, 0.748, 0.76463, 0.748, 1, 1, 0.76463, 0.748, 1, 1, 0.86275, 0.72651, 0.86275, 1.04502, 0.90699, 0.91677, 0.90699, 0.91677, 0.90699, 0.91677, 0.90699, 0.91677, 0.90699, 0.91677, 0.90699, 0.91677, 0.9154, 0.94236, 0.85458, 0.89364, 0.85458, 0.90531, 0.9, 0.90531, 0.9, 0.90531, 0.9, 1, 0.97276, 0.85576, 0.99613, 0.845, 0.85811, 0.90251, 0.91677, 1, 1, 0.86275, 1.04502, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.00899, 1.30628, 0.85576, 0.80178, 0.66862, 0.7927, 0.69323, 0.88127, 0.72459, 0.89711, 0.95381, 0.85576, 0.80591, 0.7805, 0.94729, 0.77512, 0.90531, 0.92222, 0.90637, 0.98621, 0.81698, 0.92655, 0.98558, 0.92222, 0.85359, 0.90637, 0.90976, 0.83809, 0.94523, 0.86275, 0.83509, 0.93157, 0.85308, 0.83392, 0.92346, 0.98621, 0.83509, 0.92886, 0.91324, 0.92168, 0.95381, 0.90646, 0.92886, 0.90557, 0.86847, 0.90276, 0.91324, 0.86842, 0.92168, 0.99531, 0.95381, 0.9224, 0.85408, 0.92699, 0.86847, 1.0051, 0.91513, 0.80487, 0.93481, 1, 0.88159, 1.05214, 0.90646, 0.97355, 0.81539, 0.89398, 0.85923, 0.95381, 0.90646, 0.91513, 0.90646, 0.85923, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.9154, 0.94236, 0.9154, 0.94236, 0.9154, 0.94236, 0.85458, 0.89364, 0.96694, 1, 0.89903, 1, 1, 1, 0.91782, 0.91782, 0.91782, 1, 0.896, 0.896, 0.896, 0.9332, 0.9332, 0.95973, 1, 1.26, 1, 1, 0.80479, 0.80178, 1, 1, 0.85633, 1, 1, 1, 1, 0.97276, 1, 1, 1, 0.698, 1, 1.36145, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.14542, 1, 0.79199, 0.78694, 1.02058, 1.03493, 1.05486, 1, 1, 1.23026, 1.08595, 1.08595, 1, 1.08595, 1.08595, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.20006, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          c.MyriadProBoldItalicFactors = h;
          const g = {
            lineHeight: 1.2,
            lineGap: 0.2
          };
          c.MyriadProBoldItalicMetrics = g;
          const t = [1.36898, 1, 1, 0.65507, 0.84943, 0.85639, 0.88465, 0.88465, 0.86936, 0.88307, 0.86948, 0.85283, 0.85283, 1.06383, 1.02058, 0.75945, 0.9219, 0.75945, 1.17337, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.75945, 0.75945, 1.02058, 1.02058, 1.02058, 0.69046, 0.70926, 0.85158, 0.77812, 0.76852, 0.89591, 0.70466, 0.76125, 0.80094, 0.86822, 0.83864, 0.728, 0.77212, 0.79475, 0.93637, 0.87514, 0.8588, 0.76013, 0.8588, 0.72421, 0.69866, 0.77598, 0.85991, 0.80811, 0.87832, 0.78112, 0.77512, 0.8562, 1.0222, 1.18417, 1.0222, 1.27014, 0.89903, 1.15012, 0.93859, 0.94399, 0.846, 0.94399, 0.81453, 1.0186, 0.94219, 0.96017, 1.03075, 1.02175, 0.912, 1.03075, 0.96998, 0.96017, 0.93859, 0.94399, 0.94399, 0.95493, 0.746, 1.12658, 0.94578, 0.91, 0.979, 0.882, 0.882, 0.83, 0.85034, 0.83537, 0.85034, 1.02058, 0.70869, 0.88465, 0.88465, 0.88465, 0.88465, 0.83537, 0.90083, 1.15012, 0.9161, 0.94565, 0.73541, 1.02058, 0.53609, 0.69353, 0.79519, 1.08595, 1, 1, 1.15012, 1, 0.91974, 0.75945, 1.15012, 1, 0.9446, 0.73361, 0.9005, 0.9005, 0.9005, 0.62864, 0.85158, 0.85158, 0.85158, 0.85158, 0.85158, 0.85158, 0.773, 0.76852, 0.70466, 0.70466, 0.70466, 0.70466, 0.83864, 0.83864, 0.83864, 0.83864, 0.90561, 0.87514, 0.8588, 0.8588, 0.8588, 0.8588, 0.8588, 1.02058, 0.85751, 0.85991, 0.85991, 0.85991, 0.85991, 0.77512, 0.76013, 0.88075, 0.93859, 0.93859, 0.93859, 0.93859, 0.93859, 0.93859, 0.8075, 0.846, 0.81453, 0.81453, 0.81453, 0.81453, 0.82424, 0.82424, 0.82424, 0.82424, 0.9278, 0.96017, 0.93859, 0.93859, 0.93859, 0.93859, 0.93859, 1.08595, 0.8562, 0.94578, 0.94578, 0.94578, 0.94578, 0.882, 0.94578, 0.882, 0.85158, 0.93859, 0.85158, 0.93859, 0.85158, 0.93859, 0.76852, 0.846, 0.76852, 0.846, 0.76852, 0.846, 0.76852, 0.846, 0.89591, 0.8544, 0.90561, 0.94399, 0.70466, 0.81453, 0.70466, 0.81453, 0.70466, 0.81453, 0.70466, 0.81453, 0.70466, 0.81453, 0.80094, 0.94219, 0.80094, 0.94219, 0.80094, 0.94219, 1, 1, 0.86822, 0.96017, 0.86822, 0.96017, 0.83864, 0.82424, 0.83864, 0.82424, 0.83864, 0.82424, 0.83864, 1.03075, 0.83864, 0.82424, 0.81402, 1.02738, 0.728, 1.02175, 1, 1, 0.912, 0.79475, 1.03075, 1, 1, 0.79475, 0.83911, 0.79475, 0.66266, 0.80553, 1.06676, 0.87514, 0.96017, 1, 1, 0.87514, 0.96017, 0.86865, 0.87396, 0.96017, 0.8588, 0.93859, 0.8588, 0.93859, 0.8588, 0.93859, 0.867, 0.84759, 0.72421, 0.95493, 1, 1, 0.72421, 0.95493, 0.69866, 0.746, 0.69866, 0.746, 1, 1, 0.69866, 0.746, 1, 1, 0.77598, 0.88417, 0.77598, 1.12658, 0.85991, 0.94578, 0.85991, 0.94578, 0.85991, 0.94578, 0.85991, 0.94578, 0.85991, 0.94578, 0.85991, 0.94578, 0.87832, 0.979, 0.77512, 0.882, 0.77512, 0.8562, 0.83, 0.8562, 0.83, 0.8562, 0.83, 1, 0.88465, 0.85158, 0.93859, 0.773, 0.8075, 0.85751, 0.8562, 1, 1, 0.77598, 1.12658, 1.15012, 1.15012, 1.15012, 1.15012, 1.15012, 1.15313, 1.15012, 1.15012, 1.15012, 1.08106, 1.03901, 0.85158, 0.77025, 0.62264, 0.7646, 0.65351, 0.86026, 0.69461, 0.89947, 1.03075, 0.85158, 0.77812, 0.76449, 0.88836, 0.70466, 0.8562, 0.86822, 0.8588, 0.83864, 0.77212, 0.85308, 0.93637, 0.87514, 0.82352, 0.8588, 0.85701, 0.76013, 0.89058, 0.77598, 0.8156, 0.82565, 0.78112, 0.77899, 0.89386, 0.83864, 0.8156, 0.9486, 0.92388, 0.96186, 1.03075, 0.91123, 0.9486, 0.93298, 0.878, 0.93942, 0.92388, 0.84596, 0.96186, 0.95119, 1.03075, 0.922, 0.88787, 0.95829, 0.88, 0.93559, 0.93859, 0.78815, 0.93758, 1, 0.89217, 1.03737, 0.91123, 0.93969, 0.77487, 0.85769, 0.86799, 1.03075, 0.91123, 0.93859, 0.91123, 0.86799, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.87832, 0.979, 0.87832, 0.979, 0.87832, 0.979, 0.77512, 0.882, 0.9219, 1, 0.89903, 1, 1, 1, 0.87321, 0.87321, 0.87321, 1, 1.027, 1.027, 1.027, 0.86847, 0.86847, 0.79121, 1, 1.124, 1, 1, 0.73572, 0.73572, 1, 1, 0.85034, 1, 1, 1, 1, 0.88465, 1, 1, 1, 0.669, 1, 1.36145, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.04828, 1, 0.74948, 0.75187, 1.02058, 0.98391, 1.02119, 1, 1, 1.06233, 1.08595, 1.08595, 1, 1.08595, 1.08595, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.05233, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          c.MyriadProItalicFactors = t;
          const i = {
            lineHeight: 1.2,
            lineGap: 0.2
          };
          c.MyriadProItalicMetrics = i;
          const m = [1.36898, 1, 1, 0.76305, 0.82784, 0.94935, 0.89364, 0.92241, 0.89073, 0.90706, 0.98472, 0.85283, 0.85283, 1.0664, 1.02058, 0.74505, 0.9219, 0.74505, 1.23456, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.74505, 0.74505, 1.02058, 1.02058, 1.02058, 0.73002, 0.72601, 0.91755, 0.8126, 0.80314, 0.92222, 0.73764, 0.79726, 0.83051, 0.90284, 0.86023, 0.74, 0.8126, 0.84869, 0.96518, 0.91115, 0.8858, 0.79761, 0.8858, 0.74498, 0.73914, 0.81363, 0.89591, 0.83659, 0.89633, 0.85608, 0.8111, 0.90531, 1.0222, 1.22736, 1.0222, 1.27014, 0.89903, 0.90088, 0.86667, 1.0231, 0.896, 1.01411, 0.90083, 1.05099, 1.00512, 0.99793, 1.05326, 1.09377, 0.938, 1.06226, 1.00119, 0.99793, 0.98714, 1.0231, 1.01231, 0.98196, 0.792, 1.19137, 0.99074, 0.962, 1.01915, 0.926, 0.942, 0.856, 0.85034, 0.92006, 0.85034, 1.02058, 0.69067, 0.92241, 0.92241, 0.92241, 0.92241, 0.92006, 0.9332, 0.90088, 0.91882, 0.93484, 0.75339, 1.02058, 0.56866, 0.54324, 0.79519, 1.08595, 1, 1, 0.90088, 1, 0.95325, 0.74505, 0.90088, 1, 0.97198, 0.75339, 0.91009, 0.91009, 0.91009, 0.66466, 0.91755, 0.91755, 0.91755, 0.91755, 0.91755, 0.91755, 0.788, 0.80314, 0.73764, 0.73764, 0.73764, 0.73764, 0.86023, 0.86023, 0.86023, 0.86023, 0.92915, 0.91115, 0.8858, 0.8858, 0.8858, 0.8858, 0.8858, 1.02058, 0.8858, 0.89591, 0.89591, 0.89591, 0.89591, 0.8111, 0.79611, 0.89713, 0.86667, 0.86667, 0.86667, 0.86667, 0.86667, 0.86667, 0.86936, 0.896, 0.90083, 0.90083, 0.90083, 0.90083, 0.84224, 0.84224, 0.84224, 0.84224, 0.97276, 0.99793, 0.98714, 0.98714, 0.98714, 0.98714, 0.98714, 1.08595, 0.89876, 0.99074, 0.99074, 0.99074, 0.99074, 0.942, 1.0231, 0.942, 0.91755, 0.86667, 0.91755, 0.86667, 0.91755, 0.86667, 0.80314, 0.896, 0.80314, 0.896, 0.80314, 0.896, 0.80314, 0.896, 0.92222, 0.93372, 0.92915, 1.01411, 0.73764, 0.90083, 0.73764, 0.90083, 0.73764, 0.90083, 0.73764, 0.90083, 0.73764, 0.90083, 0.83051, 1.00512, 0.83051, 1.00512, 0.83051, 1.00512, 1, 1, 0.90284, 0.99793, 0.90976, 0.99793, 0.86023, 0.84224, 0.86023, 0.84224, 0.86023, 0.84224, 0.86023, 1.05326, 0.86023, 0.84224, 0.82873, 1.07469, 0.74, 1.09377, 1, 1, 0.938, 0.84869, 1.06226, 1, 1, 0.84869, 0.83704, 0.84869, 0.81441, 0.85588, 1.08927, 0.91115, 0.99793, 1, 1, 0.91115, 0.99793, 0.91887, 0.90991, 0.99793, 0.8858, 0.98714, 0.8858, 0.98714, 0.8858, 0.98714, 0.894, 0.91434, 0.74498, 0.98196, 1, 1, 0.74498, 0.98196, 0.73914, 0.792, 0.73914, 0.792, 1, 1, 0.73914, 0.792, 1, 1, 0.81363, 0.904, 0.81363, 1.19137, 0.89591, 0.99074, 0.89591, 0.99074, 0.89591, 0.99074, 0.89591, 0.99074, 0.89591, 0.99074, 0.89591, 0.99074, 0.89633, 1.01915, 0.8111, 0.942, 0.8111, 0.90531, 0.856, 0.90531, 0.856, 0.90531, 0.856, 1, 0.92241, 0.91755, 0.86667, 0.788, 0.86936, 0.8858, 0.89876, 1, 1, 0.81363, 1.19137, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90388, 1.03901, 0.92138, 0.78105, 0.7154, 0.86169, 0.80513, 0.94007, 0.82528, 0.98612, 1.06226, 0.91755, 0.8126, 0.81884, 0.92819, 0.73764, 0.90531, 0.90284, 0.8858, 0.86023, 0.8126, 0.91172, 0.96518, 0.91115, 0.83089, 0.8858, 0.87791, 0.79761, 0.89297, 0.81363, 0.88157, 0.89992, 0.85608, 0.81992, 0.94307, 0.86023, 0.88157, 0.95308, 0.98699, 0.99793, 1.06226, 0.95817, 0.95308, 0.97358, 0.928, 0.98088, 0.98699, 0.92761, 0.99793, 0.96017, 1.06226, 0.986, 0.944, 0.95978, 0.938, 0.96705, 0.98714, 0.80442, 0.98972, 1, 0.89762, 1.04552, 0.95817, 0.99007, 0.87064, 0.91879, 0.88888, 1.06226, 0.95817, 0.98714, 0.95817, 0.88888, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.89633, 1.01915, 0.89633, 1.01915, 0.89633, 1.01915, 0.8111, 0.942, 0.9219, 1, 0.89903, 1, 1, 1, 0.93173, 0.93173, 0.93173, 1, 1.06304, 1.06304, 1.06904, 0.89903, 0.89903, 0.80549, 1, 1.156, 1, 1, 0.76575, 0.76575, 1, 1, 0.72458, 1, 1, 1, 1, 0.92241, 1, 1, 1, 0.619, 1, 1.36145, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.07257, 1, 0.74705, 0.71119, 1.02058, 1.024, 1.02119, 1, 1, 1.1536, 1.08595, 1.08595, 1, 1.08595, 1.08595, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.05638, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          c.MyriadProRegularFactors = m;
          const v = {
            lineHeight: 1.2,
            lineGap: 0.2
          };
          c.MyriadProRegularMetrics = v;
        },
        /* 56 */
        /***/
        (d, c) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.SegoeuiRegularMetrics = c.SegoeuiRegularFactors = c.SegoeuiItalicMetrics = c.SegoeuiItalicFactors = c.SegoeuiBoldMetrics = c.SegoeuiBoldItalicMetrics = c.SegoeuiBoldItalicFactors = c.SegoeuiBoldFactors = void 0;
          const f = [1.76738, 1, 1, 0.99297, 0.9824, 1.04016, 1.06497, 1.03424, 0.97529, 1.17647, 1.23203, 1.1085, 1.1085, 1.16939, 1.2107, 0.9754, 1.21408, 0.9754, 1.59578, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 0.81378, 0.81378, 1.2107, 1.2107, 1.2107, 0.71703, 0.97847, 0.97363, 0.88776, 0.8641, 1.02096, 0.79795, 0.85132, 0.914, 1.06085, 1.1406, 0.8007, 0.89858, 0.83693, 1.14889, 1.09398, 0.97489, 0.92094, 0.97489, 0.90399, 0.84041, 0.95923, 1.00135, 1, 1.06467, 0.98243, 0.90996, 0.99361, 1.1085, 1.56942, 1.1085, 1.2107, 0.74627, 0.94282, 0.96752, 1.01519, 0.86304, 1.01359, 0.97278, 1.15103, 1.01359, 0.98561, 1.02285, 1.02285, 1.00527, 1.02285, 1.0302, 0.99041, 1.0008, 1.01519, 1.01359, 1.02258, 0.79104, 1.16862, 0.99041, 0.97454, 1.02511, 0.99298, 0.96752, 0.95801, 0.94856, 1.16579, 0.94856, 1.2107, 0.9824, 1.03424, 1.03424, 1, 1.03424, 1.16579, 0.8727, 1.3871, 1.18622, 1.10818, 1.04478, 1.2107, 1.18622, 0.75155, 0.94994, 1.28826, 1.21408, 1.21408, 0.91056, 1, 0.91572, 0.9754, 0.64663, 1.18328, 1.24866, 1.04478, 1.14169, 1.15749, 1.17389, 0.71703, 0.97363, 0.97363, 0.97363, 0.97363, 0.97363, 0.97363, 0.93506, 0.8641, 0.79795, 0.79795, 0.79795, 0.79795, 1.1406, 1.1406, 1.1406, 1.1406, 1.02096, 1.09398, 0.97426, 0.97426, 0.97426, 0.97426, 0.97426, 1.2107, 0.97489, 1.00135, 1.00135, 1.00135, 1.00135, 0.90996, 0.92094, 1.02798, 0.96752, 0.96752, 0.96752, 0.96752, 0.96752, 0.96752, 0.93136, 0.86304, 0.97278, 0.97278, 0.97278, 0.97278, 1.02285, 1.02285, 1.02285, 1.02285, 0.97122, 0.99041, 1, 1, 1, 1, 1, 1.28826, 1.0008, 0.99041, 0.99041, 0.99041, 0.99041, 0.96752, 1.01519, 0.96752, 0.97363, 0.96752, 0.97363, 0.96752, 0.97363, 0.96752, 0.8641, 0.86304, 0.8641, 0.86304, 0.8641, 0.86304, 0.8641, 0.86304, 1.02096, 1.03057, 1.02096, 1.03517, 0.79795, 0.97278, 0.79795, 0.97278, 0.79795, 0.97278, 0.79795, 0.97278, 0.79795, 0.97278, 0.914, 1.01359, 0.914, 1.01359, 0.914, 1.01359, 1, 1, 1.06085, 0.98561, 1.06085, 1.00879, 1.1406, 1.02285, 1.1406, 1.02285, 1.1406, 1.02285, 1.1406, 1.02285, 1.1406, 1.02285, 0.97138, 1.08692, 0.8007, 1.02285, 1, 1, 1.00527, 0.83693, 1.02285, 1, 1, 0.83693, 0.9455, 0.83693, 0.90418, 0.83693, 1.13005, 1.09398, 0.99041, 1, 1, 1.09398, 0.99041, 0.96692, 1.09251, 0.99041, 0.97489, 1.0008, 0.97489, 1.0008, 0.97489, 1.0008, 0.93994, 0.97931, 0.90399, 1.02258, 1, 1, 0.90399, 1.02258, 0.84041, 0.79104, 0.84041, 0.79104, 0.84041, 0.79104, 0.84041, 0.79104, 1, 1, 0.95923, 1.07034, 0.95923, 1.16862, 1.00135, 0.99041, 1.00135, 0.99041, 1.00135, 0.99041, 1.00135, 0.99041, 1.00135, 0.99041, 1.00135, 0.99041, 1.06467, 1.02511, 0.90996, 0.96752, 0.90996, 0.99361, 0.95801, 0.99361, 0.95801, 0.99361, 0.95801, 1.07733, 1.03424, 0.97363, 0.96752, 0.93506, 0.93136, 0.97489, 1.0008, 1, 1, 0.95923, 1.16862, 1.15103, 1.15103, 1.01173, 1.03959, 0.75953, 0.81378, 0.79912, 1.15103, 1.21994, 0.95161, 0.87815, 1.01149, 0.81525, 0.7676, 0.98167, 1.01134, 1.02546, 0.84097, 1.03089, 1.18102, 0.97363, 0.88776, 0.85134, 0.97826, 0.79795, 0.99361, 1.06085, 0.97489, 1.1406, 0.89858, 1.0388, 1.14889, 1.09398, 0.86039, 0.97489, 1.0595, 0.92094, 0.94793, 0.95923, 0.90996, 0.99346, 0.98243, 1.02112, 0.95493, 1.1406, 0.90996, 1.03574, 1.02597, 1.0008, 1.18102, 1.06628, 1.03574, 1.0192, 1.01932, 1.00886, 0.97531, 1.0106, 1.0008, 1.13189, 1.18102, 1.02277, 0.98683, 1.0016, 0.99561, 1.07237, 1.0008, 0.90434, 0.99921, 0.93803, 0.8965, 1.23085, 1.06628, 1.04983, 0.96268, 1.0499, 0.98439, 1.18102, 1.06628, 1.0008, 1.06628, 0.98439, 0.79795, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.09466, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.97278, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.02065, 1, 1, 1, 1, 1, 1, 1.06467, 1.02511, 1.06467, 1.02511, 1.06467, 1.02511, 0.90996, 0.96752, 1, 1.21408, 0.89903, 1, 1, 0.75155, 1.04394, 1.04394, 1.04394, 1.04394, 0.98633, 0.98633, 0.98633, 0.73047, 0.73047, 1.20642, 0.91211, 1.25635, 1.222, 1.02956, 1.03372, 1.03372, 0.96039, 1.24633, 1, 1.12454, 0.93503, 1.03424, 1.19687, 1.03424, 1, 1, 1, 0.771, 1, 1, 1.15749, 1.15749, 1.15749, 1.10948, 0.86279, 0.94434, 0.86279, 0.94434, 0.86182, 1, 1, 1.16897, 1, 0.96085, 0.90137, 1.2107, 1.18416, 1.13973, 0.69825, 0.9716, 2.10339, 1.29004, 1.29004, 1.21172, 1.29004, 1.29004, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.42603, 1, 0.99862, 0.99862, 1, 0.87025, 0.87025, 0.87025, 0.87025, 1.18874, 1.42603, 1, 1.42603, 1.42603, 0.99862, 1, 1, 1, 1, 1, 1.2886, 1.04315, 1.15296, 1.34163, 1, 1, 1, 1.09193, 1.09193, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          c.SegoeuiBoldFactors = f;
          const s = {
            lineHeight: 1.33008,
            lineGap: 0
          };
          c.SegoeuiBoldMetrics = s;
          const h = [1.76738, 1, 1, 0.98946, 1.03959, 1.04016, 1.02809, 1.036, 0.97639, 1.10953, 1.23203, 1.11144, 1.11144, 1.16939, 1.21237, 0.9754, 1.21261, 0.9754, 1.59754, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 0.81378, 0.81378, 1.21237, 1.21237, 1.21237, 0.73541, 0.97847, 0.97363, 0.89723, 0.87897, 1.0426, 0.79429, 0.85292, 0.91149, 1.05815, 1.1406, 0.79631, 0.90128, 0.83853, 1.04396, 1.10615, 0.97552, 0.94436, 0.97552, 0.88641, 0.80527, 0.96083, 1.00135, 1, 1.06777, 0.9817, 0.91142, 0.99361, 1.11144, 1.57293, 1.11144, 1.21237, 0.74627, 1.31818, 1.06585, 0.97042, 0.83055, 0.97042, 0.93503, 1.1261, 0.97042, 0.97922, 1.14236, 0.94552, 1.01054, 1.14236, 1.02471, 0.97922, 0.94165, 0.97042, 0.97042, 1.0276, 0.78929, 1.1261, 0.97922, 0.95874, 1.02197, 0.98507, 0.96752, 0.97168, 0.95107, 1.16579, 0.95107, 1.21237, 1.03959, 1.036, 1.036, 1, 1.036, 1.16579, 0.87357, 1.31818, 1.18754, 1.26781, 1.05356, 1.21237, 1.18622, 0.79487, 0.94994, 1.29004, 1.24047, 1.24047, 1.31818, 1, 0.91484, 0.9754, 1.31818, 1.1349, 1.24866, 1.05356, 1.13934, 1.15574, 1.17389, 0.73541, 0.97363, 0.97363, 0.97363, 0.97363, 0.97363, 0.97363, 0.94385, 0.87897, 0.79429, 0.79429, 0.79429, 0.79429, 1.1406, 1.1406, 1.1406, 1.1406, 1.0426, 1.10615, 0.97552, 0.97552, 0.97552, 0.97552, 0.97552, 1.21237, 0.97552, 1.00135, 1.00135, 1.00135, 1.00135, 0.91142, 0.94436, 0.98721, 1.06585, 1.06585, 1.06585, 1.06585, 1.06585, 1.06585, 0.96705, 0.83055, 0.93503, 0.93503, 0.93503, 0.93503, 1.14236, 1.14236, 1.14236, 1.14236, 0.93125, 0.97922, 0.94165, 0.94165, 0.94165, 0.94165, 0.94165, 1.29004, 0.94165, 0.97922, 0.97922, 0.97922, 0.97922, 0.96752, 0.97042, 0.96752, 0.97363, 1.06585, 0.97363, 1.06585, 0.97363, 1.06585, 0.87897, 0.83055, 0.87897, 0.83055, 0.87897, 0.83055, 0.87897, 0.83055, 1.0426, 1.0033, 1.0426, 0.97042, 0.79429, 0.93503, 0.79429, 0.93503, 0.79429, 0.93503, 0.79429, 0.93503, 0.79429, 0.93503, 0.91149, 0.97042, 0.91149, 0.97042, 0.91149, 0.97042, 1, 1, 1.05815, 0.97922, 1.05815, 0.97922, 1.1406, 1.14236, 1.1406, 1.14236, 1.1406, 1.14236, 1.1406, 1.14236, 1.1406, 1.14236, 0.97441, 1.04302, 0.79631, 1.01582, 1, 1, 1.01054, 0.83853, 1.14236, 1, 1, 0.83853, 1.09125, 0.83853, 0.90418, 0.83853, 1.19508, 1.10615, 0.97922, 1, 1, 1.10615, 0.97922, 1.01034, 1.10466, 0.97922, 0.97552, 0.94165, 0.97552, 0.94165, 0.97552, 0.94165, 0.91602, 0.91981, 0.88641, 1.0276, 1, 1, 0.88641, 1.0276, 0.80527, 0.78929, 0.80527, 0.78929, 0.80527, 0.78929, 0.80527, 0.78929, 1, 1, 0.96083, 1.05403, 0.95923, 1.16862, 1.00135, 0.97922, 1.00135, 0.97922, 1.00135, 0.97922, 1.00135, 0.97922, 1.00135, 0.97922, 1.00135, 0.97922, 1.06777, 1.02197, 0.91142, 0.96752, 0.91142, 0.99361, 0.97168, 0.99361, 0.97168, 0.99361, 0.97168, 1.23199, 1.036, 0.97363, 1.06585, 0.94385, 0.96705, 0.97552, 0.94165, 1, 1, 0.96083, 1.1261, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 0.95161, 1.27126, 1.00811, 0.83284, 0.77702, 0.99137, 0.95253, 1.0347, 0.86142, 1.07205, 1.14236, 0.97363, 0.89723, 0.86869, 1.09818, 0.79429, 0.99361, 1.05815, 0.97552, 1.1406, 0.90128, 1.06662, 1.04396, 1.10615, 0.84918, 0.97552, 1.04694, 0.94436, 0.98015, 0.96083, 0.91142, 1.00356, 0.9817, 1.01945, 0.98999, 1.1406, 0.91142, 1.04961, 0.9898, 1.00639, 1.14236, 1.07514, 1.04961, 0.99607, 1.02897, 1.008, 0.9898, 0.95134, 1.00639, 1.11121, 1.14236, 1.00518, 0.97981, 1.02186, 1, 1.08578, 0.94165, 0.99314, 0.98387, 0.93028, 0.93377, 1.35125, 1.07514, 1.10687, 0.93491, 1.04232, 1.00351, 1.14236, 1.07514, 0.94165, 1.07514, 1.00351, 0.79429, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.09097, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.93503, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.96609, 1, 1, 1, 1, 1, 1, 1.06777, 1.02197, 1.06777, 1.02197, 1.06777, 1.02197, 0.91142, 0.96752, 1, 1.21261, 0.89903, 1, 1, 0.75155, 1.04745, 1.04745, 1.04745, 1.04394, 0.98633, 0.98633, 0.98633, 0.72959, 0.72959, 1.20502, 0.91406, 1.26514, 1.222, 1.02956, 1.03372, 1.03372, 0.96039, 1.24633, 1, 1.09125, 0.93327, 1.03336, 1.16541, 1.036, 1, 1, 1, 0.771, 1, 1, 1.15574, 1.15574, 1.15574, 1.15574, 0.86364, 0.94434, 0.86279, 0.94434, 0.86224, 1, 1, 1.16798, 1, 0.96085, 0.90068, 1.21237, 1.18416, 1.13904, 0.69825, 0.9716, 2.10339, 1.29004, 1.29004, 1.21339, 1.29004, 1.29004, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.42603, 1, 0.99862, 0.99862, 1, 0.87025, 0.87025, 0.87025, 0.87025, 1.18775, 1.42603, 1, 1.42603, 1.42603, 0.99862, 1, 1, 1, 1, 1, 1.2886, 1.04315, 1.15296, 1.34163, 1, 1, 1, 1.13269, 1.13269, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          c.SegoeuiBoldItalicFactors = h;
          const g = {
            lineHeight: 1.33008,
            lineGap: 0
          };
          c.SegoeuiBoldItalicMetrics = g;
          const t = [1.76738, 1, 1, 0.98946, 1.14763, 1.05365, 1.06234, 0.96927, 0.92586, 1.15373, 1.18414, 0.91349, 0.91349, 1.07403, 1.17308, 0.78383, 1.20088, 0.78383, 1.42531, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.78383, 0.78383, 1.17308, 1.17308, 1.17308, 0.77349, 0.94565, 0.94729, 0.85944, 0.88506, 0.9858, 0.74817, 0.80016, 0.88449, 0.98039, 0.95782, 0.69238, 0.89898, 0.83231, 0.98183, 1.03989, 0.96924, 0.86237, 0.96924, 0.80595, 0.74524, 0.86091, 0.95402, 0.94143, 0.98448, 0.8858, 0.83089, 0.93285, 1.0949, 1.39016, 1.0949, 1.45994, 0.74627, 1.04839, 0.97454, 0.97454, 0.87207, 0.97454, 0.87533, 1.06151, 0.97454, 1.00176, 1.16484, 1.08132, 0.98047, 1.16484, 1.02989, 1.01054, 0.96225, 0.97454, 0.97454, 1.06598, 0.79004, 1.16344, 1.00351, 0.94629, 0.9973, 0.91016, 0.96777, 0.9043, 0.91082, 0.92481, 0.91082, 1.17308, 0.95748, 0.96927, 0.96927, 1, 0.96927, 0.92481, 0.80597, 1.04839, 1.23393, 1.1781, 0.9245, 1.17308, 1.20808, 0.63218, 0.94261, 1.24822, 1.09971, 1.09971, 1.04839, 1, 0.85273, 0.78032, 1.04839, 1.09971, 1.22326, 0.9245, 1.09836, 1.13525, 1.15222, 0.70424, 0.94729, 0.94729, 0.94729, 0.94729, 0.94729, 0.94729, 0.85498, 0.88506, 0.74817, 0.74817, 0.74817, 0.74817, 0.95782, 0.95782, 0.95782, 0.95782, 0.9858, 1.03989, 0.96924, 0.96924, 0.96924, 0.96924, 0.96924, 1.17308, 0.96924, 0.95402, 0.95402, 0.95402, 0.95402, 0.83089, 0.86237, 0.88409, 0.97454, 0.97454, 0.97454, 0.97454, 0.97454, 0.97454, 0.92916, 0.87207, 0.87533, 0.87533, 0.87533, 0.87533, 0.93146, 0.93146, 0.93146, 0.93146, 0.93854, 1.01054, 0.96225, 0.96225, 0.96225, 0.96225, 0.96225, 1.24822, 0.8761, 1.00351, 1.00351, 1.00351, 1.00351, 0.96777, 0.97454, 0.96777, 0.94729, 0.97454, 0.94729, 0.97454, 0.94729, 0.97454, 0.88506, 0.87207, 0.88506, 0.87207, 0.88506, 0.87207, 0.88506, 0.87207, 0.9858, 0.95391, 0.9858, 0.97454, 0.74817, 0.87533, 0.74817, 0.87533, 0.74817, 0.87533, 0.74817, 0.87533, 0.74817, 0.87533, 0.88449, 0.97454, 0.88449, 0.97454, 0.88449, 0.97454, 1, 1, 0.98039, 1.00176, 0.98039, 1.00176, 0.95782, 0.93146, 0.95782, 0.93146, 0.95782, 0.93146, 0.95782, 1.16484, 0.95782, 0.93146, 0.84421, 1.12761, 0.69238, 1.08132, 1, 1, 0.98047, 0.83231, 1.16484, 1, 1, 0.84723, 1.04861, 0.84723, 0.78755, 0.83231, 1.23736, 1.03989, 1.01054, 1, 1, 1.03989, 1.01054, 0.9857, 1.03849, 1.01054, 0.96924, 0.96225, 0.96924, 0.96225, 0.96924, 0.96225, 0.92383, 0.90171, 0.80595, 1.06598, 1, 1, 0.80595, 1.06598, 0.74524, 0.79004, 0.74524, 0.79004, 0.74524, 0.79004, 0.74524, 0.79004, 1, 1, 0.86091, 1.02759, 0.85771, 1.16344, 0.95402, 1.00351, 0.95402, 1.00351, 0.95402, 1.00351, 0.95402, 1.00351, 0.95402, 1.00351, 0.95402, 1.00351, 0.98448, 0.9973, 0.83089, 0.96777, 0.83089, 0.93285, 0.9043, 0.93285, 0.9043, 0.93285, 0.9043, 1.31868, 0.96927, 0.94729, 0.97454, 0.85498, 0.92916, 0.96924, 0.8761, 1, 1, 0.86091, 1.16344, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 0.81965, 0.81965, 0.94729, 0.78032, 0.71022, 0.90883, 0.84171, 0.99877, 0.77596, 1.05734, 1.2, 0.94729, 0.85944, 0.82791, 0.9607, 0.74817, 0.93285, 0.98039, 0.96924, 0.95782, 0.89898, 0.98316, 0.98183, 1.03989, 0.78614, 0.96924, 0.97642, 0.86237, 0.86075, 0.86091, 0.83089, 0.90082, 0.8858, 0.97296, 1.01284, 0.95782, 0.83089, 1.0976, 1.04, 1.03342, 1.2, 1.0675, 1.0976, 0.98205, 1.03809, 1.05097, 1.04, 0.95364, 1.03342, 1.05401, 1.2, 1.02148, 1.0119, 1.04724, 1.0127, 1.02732, 0.96225, 0.8965, 0.97783, 0.93574, 0.94818, 1.30679, 1.0675, 1.11826, 0.99821, 1.0557, 1.0326, 1.2, 1.0675, 0.96225, 1.0675, 1.0326, 0.74817, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.03754, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.87533, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.98705, 1, 1, 1, 1, 1, 1, 0.98448, 0.9973, 0.98448, 0.9973, 0.98448, 0.9973, 0.83089, 0.96777, 1, 1.20088, 0.89903, 1, 1, 0.75155, 0.94945, 0.94945, 0.94945, 0.94945, 1.12317, 1.12317, 1.12317, 0.67603, 0.67603, 1.15621, 0.73584, 1.21191, 1.22135, 1.06483, 0.94868, 0.94868, 0.95996, 1.24633, 1, 1.07497, 0.87709, 0.96927, 1.01473, 0.96927, 1, 1, 1, 0.77295, 1, 1, 1.09836, 1.09836, 1.09836, 1.01522, 0.86321, 0.94434, 0.8649, 0.94434, 0.86182, 1, 1, 1.083, 1, 0.91578, 0.86438, 1.17308, 1.18416, 1.14589, 0.69825, 0.97622, 1.96791, 1.24822, 1.24822, 1.17308, 1.24822, 1.24822, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.42603, 1, 0.99862, 0.99862, 1, 0.87025, 0.87025, 0.87025, 0.87025, 1.17984, 1.42603, 1, 1.42603, 1.42603, 0.99862, 1, 1, 1, 1, 1, 1.2886, 1.04315, 1.15296, 1.34163, 1, 1, 1, 1.10742, 1.10742, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          c.SegoeuiItalicFactors = t;
          const i = {
            lineHeight: 1.33008,
            lineGap: 0
          };
          c.SegoeuiItalicMetrics = i;
          const m = [1.76738, 1, 1, 0.98594, 1.02285, 1.10454, 1.06234, 0.96927, 0.92037, 1.19985, 1.2046, 0.90616, 0.90616, 1.07152, 1.1714, 0.78032, 1.20088, 0.78032, 1.40246, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.78032, 0.78032, 1.1714, 1.1714, 1.1714, 0.80597, 0.94084, 0.96706, 0.85944, 0.85734, 0.97093, 0.75842, 0.79936, 0.88198, 0.9831, 0.95782, 0.71387, 0.86969, 0.84636, 1.07796, 1.03584, 0.96924, 0.83968, 0.96924, 0.82826, 0.79649, 0.85771, 0.95132, 0.93119, 0.98965, 0.88433, 0.8287, 0.93365, 1.08612, 1.3638, 1.08612, 1.45786, 0.74627, 0.80499, 0.91484, 1.05707, 0.92383, 1.05882, 0.9403, 1.12654, 1.05882, 1.01756, 1.09011, 1.09011, 0.99414, 1.09011, 1.034, 1.01756, 1.05356, 1.05707, 1.05882, 1.04399, 0.84863, 1.21968, 1.01756, 0.95801, 1.00068, 0.91797, 0.96777, 0.9043, 0.90351, 0.92105, 0.90351, 1.1714, 0.85337, 0.96927, 0.96927, 0.99912, 0.96927, 0.92105, 0.80597, 1.2434, 1.20808, 1.05937, 0.90957, 1.1714, 1.20808, 0.75155, 0.94261, 1.24644, 1.09971, 1.09971, 0.84751, 1, 0.85273, 0.78032, 0.61584, 1.05425, 1.17914, 0.90957, 1.08665, 1.11593, 1.14169, 0.73381, 0.96706, 0.96706, 0.96706, 0.96706, 0.96706, 0.96706, 0.86035, 0.85734, 0.75842, 0.75842, 0.75842, 0.75842, 0.95782, 0.95782, 0.95782, 0.95782, 0.97093, 1.03584, 0.96924, 0.96924, 0.96924, 0.96924, 0.96924, 1.1714, 0.96924, 0.95132, 0.95132, 0.95132, 0.95132, 0.8287, 0.83968, 0.89049, 0.91484, 0.91484, 0.91484, 0.91484, 0.91484, 0.91484, 0.93575, 0.92383, 0.9403, 0.9403, 0.9403, 0.9403, 0.8717, 0.8717, 0.8717, 0.8717, 1.00527, 1.01756, 1.05356, 1.05356, 1.05356, 1.05356, 1.05356, 1.24644, 0.95923, 1.01756, 1.01756, 1.01756, 1.01756, 0.96777, 1.05707, 0.96777, 0.96706, 0.91484, 0.96706, 0.91484, 0.96706, 0.91484, 0.85734, 0.92383, 0.85734, 0.92383, 0.85734, 0.92383, 0.85734, 0.92383, 0.97093, 1.0969, 0.97093, 1.05882, 0.75842, 0.9403, 0.75842, 0.9403, 0.75842, 0.9403, 0.75842, 0.9403, 0.75842, 0.9403, 0.88198, 1.05882, 0.88198, 1.05882, 0.88198, 1.05882, 1, 1, 0.9831, 1.01756, 0.9831, 1.01756, 0.95782, 0.8717, 0.95782, 0.8717, 0.95782, 0.8717, 0.95782, 1.09011, 0.95782, 0.8717, 0.84784, 1.11551, 0.71387, 1.09011, 1, 1, 0.99414, 0.84636, 1.09011, 1, 1, 0.84636, 1.0536, 0.84636, 0.94298, 0.84636, 1.23297, 1.03584, 1.01756, 1, 1, 1.03584, 1.01756, 1.00323, 1.03444, 1.01756, 0.96924, 1.05356, 0.96924, 1.05356, 0.96924, 1.05356, 0.93066, 0.98293, 0.82826, 1.04399, 1, 1, 0.82826, 1.04399, 0.79649, 0.84863, 0.79649, 0.84863, 0.79649, 0.84863, 0.79649, 0.84863, 1, 1, 0.85771, 1.17318, 0.85771, 1.21968, 0.95132, 1.01756, 0.95132, 1.01756, 0.95132, 1.01756, 0.95132, 1.01756, 0.95132, 1.01756, 0.95132, 1.01756, 0.98965, 1.00068, 0.8287, 0.96777, 0.8287, 0.93365, 0.9043, 0.93365, 0.9043, 0.93365, 0.9043, 1.08571, 0.96927, 0.96706, 0.91484, 0.86035, 0.93575, 0.96924, 0.95923, 1, 1, 0.85771, 1.21968, 1.11437, 1.11437, 0.93109, 0.91202, 0.60411, 0.84164, 0.55572, 1.01173, 0.97361, 0.81818, 0.81818, 0.96635, 0.78032, 0.72727, 0.92366, 0.98601, 1.03405, 0.77968, 1.09799, 1.2, 0.96706, 0.85944, 0.85638, 0.96491, 0.75842, 0.93365, 0.9831, 0.96924, 0.95782, 0.86969, 0.94152, 1.07796, 1.03584, 0.78437, 0.96924, 0.98715, 0.83968, 0.83491, 0.85771, 0.8287, 0.94492, 0.88433, 0.9287, 1.0098, 0.95782, 0.8287, 1.0625, 0.98248, 1.03424, 1.2, 1.01071, 1.0625, 0.95246, 1.03809, 1.04912, 0.98248, 1.00221, 1.03424, 1.05443, 1.2, 1.04785, 0.99609, 1.00169, 1.05176, 0.99346, 1.05356, 0.9087, 1.03004, 0.95542, 0.93117, 1.23362, 1.01071, 1.07831, 1.02512, 1.05205, 1.03502, 1.2, 1.01071, 1.05356, 1.01071, 1.03502, 0.75842, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.03719, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.9403, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.04021, 1, 1, 1, 1, 1, 1, 0.98965, 1.00068, 0.98965, 1.00068, 0.98965, 1.00068, 0.8287, 0.96777, 1, 1.20088, 0.89903, 1, 1, 0.75155, 1.03077, 1.03077, 1.03077, 1.03077, 1.13196, 1.13196, 1.13196, 0.67428, 0.67428, 1.16039, 0.73291, 1.20996, 1.22135, 1.06483, 0.94868, 0.94868, 0.95996, 1.24633, 1, 1.07497, 0.87796, 0.96927, 1.01518, 0.96927, 1, 1, 1, 0.77295, 1, 1, 1.10539, 1.10539, 1.11358, 1.06967, 0.86279, 0.94434, 0.86279, 0.94434, 0.86182, 1, 1, 1.083, 1, 0.91578, 0.86507, 1.1714, 1.18416, 1.14589, 0.69825, 0.97622, 1.9697, 1.24822, 1.24822, 1.17238, 1.24822, 1.24822, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.42603, 1, 0.99862, 0.99862, 1, 0.87025, 0.87025, 0.87025, 0.87025, 1.18083, 1.42603, 1, 1.42603, 1.42603, 0.99862, 1, 1, 1, 1, 1, 1.2886, 1.04315, 1.15296, 1.34163, 1, 1, 1, 1.10938, 1.10938, 1, 1, 1, 1.05425, 1.09971, 1.09971, 1.09971, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          c.SegoeuiRegularFactors = m;
          const v = {
            lineHeight: 1.33008,
            lineGap: 0
          };
          c.SegoeuiRegularMetrics = v;
        },
        /* 57 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.PostScriptEvaluator = c.PostScriptCompiler = c.PDFFunctionFactory = void 0, c.isPDFFunction = S;
          var s = f(4), h = f(2), g = f(58), t = f(5), i = f(59);
          class m {
            constructor({
              xref: w,
              isEvalSupported: F = !0
            }) {
              this.xref = w, this.isEvalSupported = F !== !1;
            }
            create(w) {
              const F = this.getCached(w);
              if (F)
                return F;
              const j = E.parse({
                xref: this.xref,
                isEvalSupported: this.isEvalSupported,
                fn: w instanceof s.Ref ? this.xref.fetch(w) : w
              });
              return this._cache(w, j), j;
            }
            createFromArray(w) {
              const F = this.getCached(w);
              if (F)
                return F;
              const j = E.parseArray({
                xref: this.xref,
                isEvalSupported: this.isEvalSupported,
                fnObj: w instanceof s.Ref ? this.xref.fetch(w) : w
              });
              return this._cache(w, j), j;
            }
            getCached(w) {
              var j;
              let F;
              if (w instanceof s.Ref ? F = w : w instanceof s.Dict ? F = w.objId : w instanceof t.BaseStream && (F = (j = w.dict) == null ? void 0 : j.objId), F) {
                const P = this._localFunctionCache.getByRef(F);
                if (P)
                  return P;
              }
              return null;
            }
            _cache(w, F) {
              var P;
              if (!F)
                throw new Error('PDFFunctionFactory._cache - expected "parsedFunction" argument.');
              let j;
              w instanceof s.Ref ? j = w : w instanceof s.Dict ? j = w.objId : w instanceof t.BaseStream && (j = (P = w.dict) == null ? void 0 : P.objId), j && this._localFunctionCache.set(null, j, F);
            }
            get _localFunctionCache() {
              return (0, h.shadow)(this, "_localFunctionCache", new i.LocalFunctionCache());
            }
          }
          c.PDFFunctionFactory = m;
          function v(T) {
            if (!Array.isArray(T))
              return null;
            const w = T.length;
            for (let F = 0; F < w; F++)
              if (typeof T[F] != "number") {
                const j = new Array(w);
                for (let P = 0; P < w; P++)
                  j[P] = +T[P];
                return j;
              }
            return T;
          }
          class E {
            static getSampleArray(w, F, j, P) {
              let V, J, ne = 1;
              for (V = 0, J = w.length; V < J; V++)
                ne *= w[V];
              ne *= F;
              const Z = new Array(ne);
              let te = 0, G = 0;
              const N = 1 / (2 ** j - 1), q = P.getBytes((ne * j + 7) / 8);
              let ie = 0;
              for (V = 0; V < ne; V++) {
                for (; te < j; )
                  G <<= 8, G |= q[ie++], te += 8;
                te -= j, Z[V] = (G >> te) * N, G &= (1 << te) - 1;
              }
              return Z;
            }
            static parse({
              xref: w,
              isEvalSupported: F,
              fn: j
            }) {
              const P = j.dict || j;
              switch (P.get("FunctionType")) {
                case 0:
                  return this.constructSampled({
                    xref: w,
                    isEvalSupported: F,
                    fn: j,
                    dict: P
                  });
                case 1:
                  break;
                case 2:
                  return this.constructInterpolated({
                    xref: w,
                    isEvalSupported: F,
                    dict: P
                  });
                case 3:
                  return this.constructStiched({
                    xref: w,
                    isEvalSupported: F,
                    dict: P
                  });
                case 4:
                  return this.constructPostScript({
                    xref: w,
                    isEvalSupported: F,
                    fn: j,
                    dict: P
                  });
              }
              throw new h.FormatError("Unknown type of function");
            }
            static parseArray({
              xref: w,
              isEvalSupported: F,
              fnObj: j
            }) {
              if (!Array.isArray(j))
                return this.parse({
                  xref: w,
                  isEvalSupported: F,
                  fn: j
                });
              const P = [];
              for (const V of j)
                P.push(this.parse({
                  xref: w,
                  isEvalSupported: F,
                  fn: w.fetchIfRef(V)
                }));
              return function(V, J, ne, Z) {
                for (let te = 0, G = P.length; te < G; te++)
                  P[te](V, J, ne, Z + te);
              };
            }
            static constructSampled({
              xref: w,
              isEvalSupported: F,
              fn: j,
              dict: P
            }) {
              function V(ae) {
                const se = ae.length, L = [];
                let W = 0;
                for (let M = 0; M < se; M += 2)
                  L[W++] = [ae[M], ae[M + 1]];
                return L;
              }
              function J(ae, se, L, W, M) {
                return W + (ae - se) * ((M - W) / (L - se));
              }
              let ne = v(P.getArray("Domain")), Z = v(P.getArray("Range"));
              if (!ne || !Z)
                throw new h.FormatError("No domain or range");
              const te = ne.length / 2, G = Z.length / 2;
              ne = V(ne), Z = V(Z);
              const N = v(P.getArray("Size")), q = P.get("BitsPerSample"), ie = P.get("Order") || 1;
              ie !== 1 && (0, h.info)("No support for cubic spline interpolation: " + ie);
              let oe = v(P.getArray("Encode"));
              if (oe)
                oe = V(oe);
              else {
                oe = [];
                for (let ae = 0; ae < te; ++ae)
                  oe.push([0, N[ae] - 1]);
              }
              let fe = v(P.getArray("Decode"));
              fe = fe ? V(fe) : Z;
              const Y = this.getSampleArray(N, G, q, j);
              return function(se, L, W, M) {
                const X = 1 << te, U = new Float64Array(X), Q = new Uint32Array(X);
                let re, le;
                for (le = 0; le < X; le++)
                  U[le] = 1;
                let ce = G, ee = 1;
                for (re = 0; re < te; ++re) {
                  const he = ne[re][0], pe = ne[re][1], de = Math.min(Math.max(se[L + re], he), pe);
                  let ge = J(de, he, pe, oe[re][0], oe[re][1]);
                  const me = N[re];
                  ge = Math.min(Math.max(ge, 0), me - 1);
                  const xe = ge < me - 1 ? Math.floor(ge) : ge - 1, ye = xe + 1 - ge, ve = ge - xe, Ce = xe * ce, Ie = Ce + ce;
                  for (le = 0; le < X; le++)
                    le & ee ? (U[le] *= ve, Q[le] += Ie) : (U[le] *= ye, Q[le] += Ce);
                  ce *= me, ee <<= 1;
                }
                for (le = 0; le < G; ++le) {
                  let he = 0;
                  for (re = 0; re < X; re++)
                    he += Y[Q[re] + le] * U[re];
                  he = J(he, 0, 1, fe[le][0], fe[le][1]), W[M + le] = Math.min(Math.max(he, Z[le][0]), Z[le][1]);
                }
              };
            }
            static constructInterpolated({
              xref: w,
              isEvalSupported: F,
              dict: j
            }) {
              const P = v(j.getArray("C0")) || [0], V = v(j.getArray("C1")) || [1], J = j.get("N"), ne = [];
              for (let te = 0, G = P.length; te < G; ++te)
                ne.push(V[te] - P[te]);
              const Z = ne.length;
              return function(G, N, q, ie) {
                const oe = J === 1 ? G[N] : G[N] ** J;
                for (let fe = 0; fe < Z; ++fe)
                  q[ie + fe] = P[fe] + oe * ne[fe];
              };
            }
            static constructStiched({
              xref: w,
              isEvalSupported: F,
              dict: j
            }) {
              const P = v(j.getArray("Domain"));
              if (!P)
                throw new h.FormatError("No domain");
              if (P.length / 2 !== 1)
                throw new h.FormatError("Bad domain for stiched function");
              const J = [];
              for (const G of j.get("Functions"))
                J.push(this.parse({
                  xref: w,
                  isEvalSupported: F,
                  fn: w.fetchIfRef(G)
                }));
              const ne = v(j.getArray("Bounds")), Z = v(j.getArray("Encode")), te = new Float32Array(1);
              return function(N, q, ie, oe) {
                const Y = function(Q, re, le) {
                  return Q > le ? Q = le : Q < re && (Q = re), Q;
                }(N[q], P[0], P[1]), ae = ne.length;
                let se;
                for (se = 0; se < ae && !(Y < ne[se]); ++se)
                  ;
                let L = P[0];
                se > 0 && (L = ne[se - 1]);
                let W = P[1];
                se < ne.length && (W = ne[se]);
                const M = Z[2 * se], X = Z[2 * se + 1];
                te[0] = L === W ? M : M + (Y - L) * (X - M) / (W - L), J[se](te, 0, ie, oe);
              };
            }
            static constructPostScript({
              xref: w,
              isEvalSupported: F,
              fn: j,
              dict: P
            }) {
              const V = v(P.getArray("Domain")), J = v(P.getArray("Range"));
              if (!V)
                throw new h.FormatError("No domain.");
              if (!J)
                throw new h.FormatError("No range.");
              const ne = new g.PostScriptLexer(j), te = new g.PostScriptParser(ne).parse();
              if (F && h.FeatureTest.isEvalSupported) {
                const ae = new k().compile(te, V, J);
                if (ae)
                  return new Function("src", "srcOffset", "dest", "destOffset", ae);
              }
              (0, h.info)("Unable to compile PS function");
              const G = J.length >> 1, N = V.length >> 1, q = new x(te), ie = /* @__PURE__ */ Object.create(null);
              let fe = 2048 * 4;
              const Y = new Float32Array(N);
              return function(se, L, W, M) {
                let X, U, Q = "";
                const re = Y;
                for (X = 0; X < N; X++)
                  U = se[L + X], re[X] = U, Q += U + "_";
                const le = ie[Q];
                if (le !== void 0) {
                  W.set(le, M);
                  return;
                }
                const ce = new Float32Array(G), ee = q.execute(re), he = ee.length - G;
                for (X = 0; X < G; X++) {
                  U = ee[he + X];
                  let pe = J[X * 2];
                  U < pe ? U = pe : (pe = J[X * 2 + 1], U > pe && (U = pe)), ce[X] = U;
                }
                fe > 0 && (fe--, ie[Q] = ce), W.set(ce, M);
              };
            }
          }
          function S(T) {
            let w;
            if (T instanceof s.Dict)
              w = T;
            else if (T instanceof t.BaseStream)
              w = T.dict;
            else
              return !1;
            return w.has("FunctionType");
          }
          const z = class z {
            constructor(w) {
              this.stack = w ? Array.from(w) : [];
            }
            push(w) {
              if (this.stack.length >= z.MAX_STACK_SIZE)
                throw new Error("PostScript function stack overflow.");
              this.stack.push(w);
            }
            pop() {
              if (this.stack.length <= 0)
                throw new Error("PostScript function stack underflow.");
              return this.stack.pop();
            }
            copy(w) {
              if (this.stack.length + w >= z.MAX_STACK_SIZE)
                throw new Error("PostScript function stack overflow.");
              const F = this.stack;
              for (let j = F.length - w, P = w - 1; P >= 0; P--, j++)
                F.push(F[j]);
            }
            index(w) {
              this.push(this.stack[this.stack.length - w - 1]);
            }
            roll(w, F) {
              const j = this.stack, P = j.length - w, V = j.length - 1, J = P + (F - Math.floor(F / w) * w);
              for (let ne = P, Z = V; ne < Z; ne++, Z--) {
                const te = j[ne];
                j[ne] = j[Z], j[Z] = te;
              }
              for (let ne = P, Z = J - 1; ne < Z; ne++, Z--) {
                const te = j[ne];
                j[ne] = j[Z], j[Z] = te;
              }
              for (let ne = J, Z = V; ne < Z; ne++, Z--) {
                const te = j[ne];
                j[ne] = j[Z], j[Z] = te;
              }
            }
          };
          ni(z, "MAX_STACK_SIZE", 100);
          let y = z;
          class x {
            constructor(w) {
              this.operators = w;
            }
            execute(w) {
              const F = new y(w);
              let j = 0;
              const P = this.operators, V = P.length;
              let J, ne, Z;
              for (; j < V; ) {
                if (J = P[j++], typeof J == "number") {
                  F.push(J);
                  continue;
                }
                switch (J) {
                  case "jz":
                    Z = F.pop(), ne = F.pop(), ne || (j = Z);
                    break;
                  case "j":
                    ne = F.pop(), j = ne;
                    break;
                  case "abs":
                    ne = F.pop(), F.push(Math.abs(ne));
                    break;
                  case "add":
                    Z = F.pop(), ne = F.pop(), F.push(ne + Z);
                    break;
                  case "and":
                    Z = F.pop(), ne = F.pop(), typeof ne == "boolean" && typeof Z == "boolean" ? F.push(ne && Z) : F.push(ne & Z);
                    break;
                  case "atan":
                    Z = F.pop(), ne = F.pop(), ne = Math.atan2(ne, Z) / Math.PI * 180, ne < 0 && (ne += 360), F.push(ne);
                    break;
                  case "bitshift":
                    Z = F.pop(), ne = F.pop(), ne > 0 ? F.push(ne << Z) : F.push(ne >> Z);
                    break;
                  case "ceiling":
                    ne = F.pop(), F.push(Math.ceil(ne));
                    break;
                  case "copy":
                    ne = F.pop(), F.copy(ne);
                    break;
                  case "cos":
                    ne = F.pop(), F.push(Math.cos(ne % 360 / 180 * Math.PI));
                    break;
                  case "cvi":
                    ne = F.pop() | 0, F.push(ne);
                    break;
                  case "cvr":
                    break;
                  case "div":
                    Z = F.pop(), ne = F.pop(), F.push(ne / Z);
                    break;
                  case "dup":
                    F.copy(1);
                    break;
                  case "eq":
                    Z = F.pop(), ne = F.pop(), F.push(ne === Z);
                    break;
                  case "exch":
                    F.roll(2, 1);
                    break;
                  case "exp":
                    Z = F.pop(), ne = F.pop(), F.push(ne ** Z);
                    break;
                  case "false":
                    F.push(!1);
                    break;
                  case "floor":
                    ne = F.pop(), F.push(Math.floor(ne));
                    break;
                  case "ge":
                    Z = F.pop(), ne = F.pop(), F.push(ne >= Z);
                    break;
                  case "gt":
                    Z = F.pop(), ne = F.pop(), F.push(ne > Z);
                    break;
                  case "idiv":
                    Z = F.pop(), ne = F.pop(), F.push(ne / Z | 0);
                    break;
                  case "index":
                    ne = F.pop(), F.index(ne);
                    break;
                  case "le":
                    Z = F.pop(), ne = F.pop(), F.push(ne <= Z);
                    break;
                  case "ln":
                    ne = F.pop(), F.push(Math.log(ne));
                    break;
                  case "log":
                    ne = F.pop(), F.push(Math.log10(ne));
                    break;
                  case "lt":
                    Z = F.pop(), ne = F.pop(), F.push(ne < Z);
                    break;
                  case "mod":
                    Z = F.pop(), ne = F.pop(), F.push(ne % Z);
                    break;
                  case "mul":
                    Z = F.pop(), ne = F.pop(), F.push(ne * Z);
                    break;
                  case "ne":
                    Z = F.pop(), ne = F.pop(), F.push(ne !== Z);
                    break;
                  case "neg":
                    ne = F.pop(), F.push(-ne);
                    break;
                  case "not":
                    ne = F.pop(), typeof ne == "boolean" ? F.push(!ne) : F.push(~ne);
                    break;
                  case "or":
                    Z = F.pop(), ne = F.pop(), typeof ne == "boolean" && typeof Z == "boolean" ? F.push(ne || Z) : F.push(ne | Z);
                    break;
                  case "pop":
                    F.pop();
                    break;
                  case "roll":
                    Z = F.pop(), ne = F.pop(), F.roll(ne, Z);
                    break;
                  case "round":
                    ne = F.pop(), F.push(Math.round(ne));
                    break;
                  case "sin":
                    ne = F.pop(), F.push(Math.sin(ne % 360 / 180 * Math.PI));
                    break;
                  case "sqrt":
                    ne = F.pop(), F.push(Math.sqrt(ne));
                    break;
                  case "sub":
                    Z = F.pop(), ne = F.pop(), F.push(ne - Z);
                    break;
                  case "true":
                    F.push(!0);
                    break;
                  case "truncate":
                    ne = F.pop(), ne = ne < 0 ? Math.ceil(ne) : Math.floor(ne), F.push(ne);
                    break;
                  case "xor":
                    Z = F.pop(), ne = F.pop(), typeof ne == "boolean" && typeof Z == "boolean" ? F.push(ne !== Z) : F.push(ne ^ Z);
                    break;
                  default:
                    throw new h.FormatError(`Unknown operator ${J}`);
                }
              }
              return F.stack;
            }
          }
          c.PostScriptEvaluator = x;
          class b {
            constructor(w) {
              this.type = w;
            }
            visit(w) {
              (0, h.unreachable)("abstract method");
            }
          }
          class u extends b {
            constructor(w, F, j) {
              super("args"), this.index = w, this.min = F, this.max = j;
            }
            visit(w) {
              w.visitArgument(this);
            }
          }
          class I extends b {
            constructor(w) {
              super("literal"), this.number = w, this.min = w, this.max = w;
            }
            visit(w) {
              w.visitLiteral(this);
            }
          }
          class O extends b {
            constructor(w, F, j, P, V) {
              super("binary"), this.op = w, this.arg1 = F, this.arg2 = j, this.min = P, this.max = V;
            }
            visit(w) {
              w.visitBinaryOperation(this);
            }
          }
          class D extends b {
            constructor(w, F) {
              super("max"), this.arg = w, this.min = w.min, this.max = F;
            }
            visit(w) {
              w.visitMin(this);
            }
          }
          class $ extends b {
            constructor(w, F, j) {
              super("var"), this.index = w, this.min = F, this.max = j;
            }
            visit(w) {
              w.visitVariable(this);
            }
          }
          class K extends b {
            constructor(w, F) {
              super("definition"), this.variable = w, this.arg = F;
            }
            visit(w) {
              w.visitVariableDefinition(this);
            }
          }
          class H {
            constructor() {
              this.parts = [];
            }
            visitArgument(w) {
              this.parts.push("Math.max(", w.min, ", Math.min(", w.max, ", src[srcOffset + ", w.index, "]))");
            }
            visitVariable(w) {
              this.parts.push("v", w.index);
            }
            visitLiteral(w) {
              this.parts.push(w.number);
            }
            visitBinaryOperation(w) {
              this.parts.push("("), w.arg1.visit(this), this.parts.push(" ", w.op, " "), w.arg2.visit(this), this.parts.push(")");
            }
            visitVariableDefinition(w) {
              this.parts.push("var "), w.variable.visit(this), this.parts.push(" = "), w.arg.visit(this), this.parts.push(";");
            }
            visitMin(w) {
              this.parts.push("Math.min("), w.arg.visit(this), this.parts.push(", ", w.max, ")");
            }
            toString() {
              return this.parts.join("");
            }
          }
          function B(T, w) {
            return w.type === "literal" && w.number === 0 ? T : T.type === "literal" && T.number === 0 ? w : w.type === "literal" && T.type === "literal" ? new I(T.number + w.number) : new O("+", T, w, T.min + w.min, T.max + w.max);
          }
          function R(T, w) {
            if (w.type === "literal") {
              if (w.number === 0)
                return new I(0);
              if (w.number === 1)
                return T;
              if (T.type === "literal")
                return new I(T.number * w.number);
            }
            if (T.type === "literal") {
              if (T.number === 0)
                return new I(0);
              if (T.number === 1)
                return w;
            }
            const F = Math.min(T.min * w.min, T.min * w.max, T.max * w.min, T.max * w.max), j = Math.max(T.min * w.min, T.min * w.max, T.max * w.min, T.max * w.max);
            return new O("*", T, w, F, j);
          }
          function _(T, w) {
            if (w.type === "literal") {
              if (w.number === 0)
                return T;
              if (T.type === "literal")
                return new I(T.number - w.number);
            }
            return w.type === "binary" && w.op === "-" && T.type === "literal" && T.number === 1 && w.arg1.type === "literal" && w.arg1.number === 1 ? w.arg2 : new O("-", T, w, T.min - w.max, T.max - w.min);
          }
          function A(T, w) {
            return T.min >= w ? new I(w) : T.max <= w ? T : new D(T, w);
          }
          class k {
            compile(w, F, j) {
              const P = [], V = [], J = F.length >> 1, ne = j.length >> 1;
              let Z = 0, te, G, N, q, ie, oe, fe, Y;
              for (let se = 0; se < J; se++)
                P.push(new u(se, F[se * 2], F[se * 2 + 1]));
              for (let se = 0, L = w.length; se < L; se++) {
                if (Y = w[se], typeof Y == "number") {
                  P.push(new I(Y));
                  continue;
                }
                switch (Y) {
                  case "add":
                    if (P.length < 2)
                      return null;
                    q = P.pop(), N = P.pop(), P.push(B(N, q));
                    break;
                  case "cvr":
                    if (P.length < 1)
                      return null;
                    break;
                  case "mul":
                    if (P.length < 2)
                      return null;
                    q = P.pop(), N = P.pop(), P.push(R(N, q));
                    break;
                  case "sub":
                    if (P.length < 2)
                      return null;
                    q = P.pop(), N = P.pop(), P.push(_(N, q));
                    break;
                  case "exch":
                    if (P.length < 2)
                      return null;
                    ie = P.pop(), oe = P.pop(), P.push(ie, oe);
                    break;
                  case "pop":
                    if (P.length < 1)
                      return null;
                    P.pop();
                    break;
                  case "index":
                    if (P.length < 1 || (N = P.pop(), N.type !== "literal") || (te = N.number, te < 0 || !Number.isInteger(te) || P.length < te))
                      return null;
                    if (ie = P[P.length - te - 1], ie.type === "literal" || ie.type === "var") {
                      P.push(ie);
                      break;
                    }
                    fe = new $(Z++, ie.min, ie.max), P[P.length - te - 1] = fe, P.push(fe), V.push(new K(fe, ie));
                    break;
                  case "dup":
                    if (P.length < 1)
                      return null;
                    if (typeof w[se + 1] == "number" && w[se + 2] === "gt" && w[se + 3] === se + 7 && w[se + 4] === "jz" && w[se + 5] === "pop" && w[se + 6] === w[se + 1]) {
                      N = P.pop(), P.push(A(N, w[se + 1])), se += 6;
                      break;
                    }
                    if (ie = P.at(-1), ie.type === "literal" || ie.type === "var") {
                      P.push(ie);
                      break;
                    }
                    fe = new $(Z++, ie.min, ie.max), P[P.length - 1] = fe, P.push(fe), V.push(new K(fe, ie));
                    break;
                  case "roll":
                    if (P.length < 2 || (q = P.pop(), N = P.pop(), q.type !== "literal" || N.type !== "literal") || (G = q.number, te = N.number, te <= 0 || !Number.isInteger(te) || !Number.isInteger(G) || P.length < te))
                      return null;
                    if (G = (G % te + te) % te, G === 0)
                      break;
                    P.push(...P.splice(P.length - te, te - G));
                    break;
                  default:
                    return null;
                }
              }
              if (P.length !== ne)
                return null;
              const ae = [];
              for (const se of V) {
                const L = new H();
                se.visit(L), ae.push(L.toString());
              }
              for (let se = 0, L = P.length; se < L; se++) {
                const W = P[se], M = new H();
                W.visit(M);
                const X = j[se * 2], U = j[se * 2 + 1], Q = [M.toString()];
                X > W.min && (Q.unshift("Math.max(", X, ", "), Q.push(")")), U < W.max && (Q.unshift("Math.min(", U, ", "), Q.push(")")), Q.unshift("dest[destOffset + ", se, "] = "), Q.push(";"), ae.push(Q.join(""));
              }
              return ae.join(`
`);
            }
          }
          c.PostScriptCompiler = k;
        },
        /* 58 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.PostScriptParser = c.PostScriptLexer = void 0;
          var s = f(2), h = f(4), g = f(3);
          class t {
            constructor(S) {
              this.lexer = S, this.operators = [], this.token = null, this.prev = null;
            }
            nextToken() {
              this.prev = this.token, this.token = this.lexer.getToken();
            }
            accept(S) {
              return this.token.type === S ? (this.nextToken(), !0) : !1;
            }
            expect(S) {
              if (this.accept(S))
                return !0;
              throw new s.FormatError(`Unexpected symbol: found ${this.token.type} expected ${S}.`);
            }
            parse() {
              return this.nextToken(), this.expect(i.LBRACE), this.parseBlock(), this.expect(i.RBRACE), this.operators;
            }
            parseBlock() {
              for (; ; )
                if (this.accept(i.NUMBER))
                  this.operators.push(this.prev.value);
                else if (this.accept(i.OPERATOR))
                  this.operators.push(this.prev.value);
                else if (this.accept(i.LBRACE))
                  this.parseCondition();
                else
                  return;
            }
            parseCondition() {
              const S = this.operators.length;
              if (this.operators.push(null, null), this.parseBlock(), this.expect(i.RBRACE), this.accept(i.IF))
                this.operators[S] = this.operators.length, this.operators[S + 1] = "jz";
              else if (this.accept(i.LBRACE)) {
                const y = this.operators.length;
                this.operators.push(null, null);
                const x = this.operators.length;
                this.parseBlock(), this.expect(i.RBRACE), this.expect(i.IFELSE), this.operators[y] = this.operators.length, this.operators[y + 1] = "j", this.operators[S] = x, this.operators[S + 1] = "jz";
              } else
                throw new s.FormatError("PS Function: error parsing conditional.");
            }
          }
          c.PostScriptParser = t;
          const i = {
            LBRACE: 0,
            RBRACE: 1,
            NUMBER: 2,
            OPERATOR: 3,
            IF: 4,
            IFELSE: 5
          };
          class m {
            static get opCache() {
              return (0, s.shadow)(this, "opCache", /* @__PURE__ */ Object.create(null));
            }
            constructor(S, y) {
              this.type = S, this.value = y;
            }
            static getOperator(S) {
              var y;
              return (y = m.opCache)[S] || (y[S] = new m(i.OPERATOR, S));
            }
            static get LBRACE() {
              return (0, s.shadow)(this, "LBRACE", new m(i.LBRACE, "{"));
            }
            static get RBRACE() {
              return (0, s.shadow)(this, "RBRACE", new m(i.RBRACE, "}"));
            }
            static get IF() {
              return (0, s.shadow)(this, "IF", new m(i.IF, "IF"));
            }
            static get IFELSE() {
              return (0, s.shadow)(this, "IFELSE", new m(i.IFELSE, "IFELSE"));
            }
          }
          class v {
            constructor(S) {
              this.stream = S, this.nextChar(), this.strBuf = [];
            }
            nextChar() {
              return this.currentChar = this.stream.getByte();
            }
            getToken() {
              let S = !1, y = this.currentChar;
              for (; ; ) {
                if (y < 0)
                  return h.EOF;
                if (S)
                  (y === 10 || y === 13) && (S = !1);
                else if (y === 37)
                  S = !0;
                else if (!(0, g.isWhiteSpace)(y))
                  break;
                y = this.nextChar();
              }
              switch (y | 0) {
                case 48:
                case 49:
                case 50:
                case 51:
                case 52:
                case 53:
                case 54:
                case 55:
                case 56:
                case 57:
                case 43:
                case 45:
                case 46:
                  return new m(i.NUMBER, this.getNumber());
                case 123:
                  return this.nextChar(), m.LBRACE;
                case 125:
                  return this.nextChar(), m.RBRACE;
              }
              const x = this.strBuf;
              for (x.length = 0, x[0] = String.fromCharCode(y); (y = this.nextChar()) >= 0 && (y >= 65 && y <= 90 || y >= 97 && y <= 122); )
                x.push(String.fromCharCode(y));
              const b = x.join("");
              switch (b.toLowerCase()) {
                case "if":
                  return m.IF;
                case "ifelse":
                  return m.IFELSE;
                default:
                  return m.getOperator(b);
              }
            }
            getNumber() {
              let S = this.currentChar;
              const y = this.strBuf;
              for (y.length = 0, y[0] = String.fromCharCode(S); (S = this.nextChar()) >= 0 && (S >= 48 && S <= 57 || S === 45 || S === 46); )
                y.push(String.fromCharCode(S));
              const x = parseFloat(y.join(""));
              if (isNaN(x))
                throw new s.FormatError(`Invalid floating point number: ${x}`);
              return x;
            }
          }
          c.PostScriptLexer = v;
        },
        /* 59 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.RegionalImageCache = c.LocalTilingPatternCache = c.LocalImageCache = c.LocalGStateCache = c.LocalFunctionCache = c.LocalColorSpaceCache = c.GlobalImageCache = void 0;
          var s = f(2), h = f(4);
          class g {
            constructor(u) {
              this.constructor === g && (0, s.unreachable)("Cannot initialize BaseLocalCache."), this._onlyRefs = (u == null ? void 0 : u.onlyRefs) === !0, this._onlyRefs || (this._nameRefMap = /* @__PURE__ */ new Map(), this._imageMap = /* @__PURE__ */ new Map()), this._imageCache = new h.RefSetCache();
            }
            getByName(u) {
              this._onlyRefs && (0, s.unreachable)("Should not call `getByName` method.");
              const I = this._nameRefMap.get(u);
              return I ? this.getByRef(I) : this._imageMap.get(u) || null;
            }
            getByRef(u) {
              return this._imageCache.get(u) || null;
            }
            set(u, I, O) {
              (0, s.unreachable)("Abstract method `set` called.");
            }
          }
          class t extends g {
            set(u, I = null, O) {
              if (typeof u != "string")
                throw new Error('LocalImageCache.set - expected "name" argument.');
              if (I) {
                if (this._imageCache.has(I))
                  return;
                this._nameRefMap.set(u, I), this._imageCache.put(I, O);
                return;
              }
              this._imageMap.has(u) || this._imageMap.set(u, O);
            }
          }
          c.LocalImageCache = t;
          class i extends g {
            set(u = null, I = null, O) {
              if (typeof u != "string" && !I)
                throw new Error('LocalColorSpaceCache.set - expected "name" and/or "ref" argument.');
              if (I) {
                if (this._imageCache.has(I))
                  return;
                u !== null && this._nameRefMap.set(u, I), this._imageCache.put(I, O);
                return;
              }
              this._imageMap.has(u) || this._imageMap.set(u, O);
            }
          }
          c.LocalColorSpaceCache = i;
          class m extends g {
            constructor(u) {
              super({
                onlyRefs: !0
              });
            }
            set(u = null, I, O) {
              if (!I)
                throw new Error('LocalFunctionCache.set - expected "ref" argument.');
              this._imageCache.has(I) || this._imageCache.put(I, O);
            }
          }
          c.LocalFunctionCache = m;
          class v extends g {
            set(u, I = null, O) {
              if (typeof u != "string")
                throw new Error('LocalGStateCache.set - expected "name" argument.');
              if (I) {
                if (this._imageCache.has(I))
                  return;
                this._nameRefMap.set(u, I), this._imageCache.put(I, O);
                return;
              }
              this._imageMap.has(u) || this._imageMap.set(u, O);
            }
          }
          c.LocalGStateCache = v;
          class E extends g {
            constructor(u) {
              super({
                onlyRefs: !0
              });
            }
            set(u = null, I, O) {
              if (!I)
                throw new Error('LocalTilingPatternCache.set - expected "ref" argument.');
              this._imageCache.has(I) || this._imageCache.put(I, O);
            }
          }
          c.LocalTilingPatternCache = E;
          class S extends g {
            constructor(u) {
              super({
                onlyRefs: !0
              });
            }
            set(u = null, I, O) {
              if (!I)
                throw new Error('RegionalImageCache.set - expected "ref" argument.');
              this._imageCache.has(I) || this._imageCache.put(I, O);
            }
          }
          c.RegionalImageCache = S;
          const x = class x {
            constructor() {
              this._refCache = new h.RefSetCache(), this._imageCache = new h.RefSetCache();
            }
            get _byteSize() {
              let u = 0;
              for (const I of this._imageCache)
                u += I.byteSize;
              return u;
            }
            get _cacheLimitReached() {
              return !(this._imageCache.size < x.MIN_IMAGES_TO_CACHE || this._byteSize < x.MAX_BYTE_SIZE);
            }
            shouldCache(u, I) {
              let O = this._refCache.get(u);
              return O || (O = /* @__PURE__ */ new Set(), this._refCache.put(u, O)), O.add(I), !(O.size < x.NUM_PAGES_THRESHOLD || !this._imageCache.has(u) && this._cacheLimitReached);
            }
            addByteSize(u, I) {
              const O = this._imageCache.get(u);
              O && (O.byteSize || (O.byteSize = I));
            }
            getData(u, I) {
              const O = this._refCache.get(u);
              if (!O || O.size < x.NUM_PAGES_THRESHOLD)
                return null;
              const D = this._imageCache.get(u);
              return D ? (O.add(I), D) : null;
            }
            setData(u, I) {
              if (!this._refCache.has(u))
                throw new Error('GlobalImageCache.setData - expected "shouldCache" to have been called.');
              if (!this._imageCache.has(u)) {
                if (this._cacheLimitReached) {
                  (0, s.warn)("GlobalImageCache.setData - cache limit reached.");
                  return;
                }
                this._imageCache.put(u, I);
              }
            }
            clear(u = !1) {
              u || this._refCache.clear(), this._imageCache.clear();
            }
          };
          ni(x, "NUM_PAGES_THRESHOLD", 2), ni(x, "MIN_IMAGES_TO_CACHE", 10), ni(x, "MAX_BYTE_SIZE", 5 * s.MAX_IMAGE_SIZE_TO_CACHE);
          let y = x;
          c.GlobalImageCache = y;
        },
        /* 60 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.bidi = b;
          var s = f(2);
          const h = ["BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "S", "B", "S", "WS", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "B", "B", "B", "S", "WS", "ON", "ON", "ET", "ET", "ET", "ON", "ON", "ON", "ON", "ON", "ES", "CS", "ES", "CS", "CS", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "CS", "ON", "ON", "ON", "ON", "ON", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "ON", "ON", "ON", "ON", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "ON", "ON", "ON", "BN", "BN", "BN", "BN", "BN", "BN", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "CS", "ON", "ET", "ET", "ET", "ET", "ON", "ON", "ON", "ON", "L", "ON", "ON", "BN", "ON", "ON", "ET", "ET", "EN", "EN", "ON", "L", "ON", "ON", "ON", "EN", "L", "ON", "ON", "ON", "ON", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "L", "L", "L", "L", "L", "L", "L", "L"], g = ["AN", "AN", "AN", "AN", "AN", "AN", "ON", "ON", "AL", "ET", "ET", "AL", "CS", "AL", "ON", "ON", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "ET", "AN", "AN", "AL", "AL", "AL", "NSM", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "ON", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "NSM", "NSM", "ON", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "AL", "AL", "AL", "AL", "AL", "AL"];
          function t(u) {
            return (u & 1) !== 0;
          }
          function i(u) {
            return (u & 1) === 0;
          }
          function m(u, I, O) {
            let D, $;
            for (D = I, $ = u.length; D < $; ++D)
              if (u[D] !== O)
                return D;
            return D;
          }
          function v(u, I, O, D) {
            for (let $ = I; $ < O; ++$)
              u[$] = D;
          }
          function E(u, I, O) {
            for (let D = I, $ = O - 1; D < $; ++D, --$) {
              const K = u[D];
              u[D] = u[$], u[$] = K;
            }
          }
          function S(u, I, O = !1) {
            let D = "ltr";
            return O ? D = "ttb" : I || (D = "rtl"), {
              str: u,
              dir: D
            };
          }
          const y = [], x = [];
          function b(u, I = -1, O = !1) {
            let D = !0;
            const $ = u.length;
            if ($ === 0 || O)
              return S(u, D, O);
            y.length = $, x.length = $;
            let K = 0, H, B;
            for (H = 0; H < $; ++H) {
              y[H] = u.charAt(H);
              const P = u.charCodeAt(H);
              let V = "L";
              P <= 255 ? V = h[P] : 1424 <= P && P <= 1524 ? V = "R" : 1536 <= P && P <= 1791 ? (V = g[P & 255], V || (0, s.warn)("Bidi: invalid Unicode character " + P.toString(16))) : (1792 <= P && P <= 2220 || 64336 <= P && P <= 65023 || 65136 <= P && P <= 65279) && (V = "AL"), (V === "R" || V === "AL" || V === "AN") && K++, x[H] = V;
            }
            if (K === 0)
              return D = !0, S(u, D);
            I === -1 && (K / $ < 0.3 && $ > 4 ? (D = !0, I = 0) : (D = !1, I = 1));
            const R = [];
            for (H = 0; H < $; ++H)
              R[H] = I;
            const _ = t(I) ? "R" : "L", A = _, k = A;
            let z = A;
            for (H = 0; H < $; ++H)
              x[H] === "NSM" ? x[H] = z : z = x[H];
            z = A;
            let T;
            for (H = 0; H < $; ++H)
              T = x[H], T === "EN" ? x[H] = z === "AL" ? "AN" : "EN" : (T === "R" || T === "L" || T === "AL") && (z = T);
            for (H = 0; H < $; ++H)
              T = x[H], T === "AL" && (x[H] = "R");
            for (H = 1; H < $ - 1; ++H)
              x[H] === "ES" && x[H - 1] === "EN" && x[H + 1] === "EN" && (x[H] = "EN"), x[H] === "CS" && (x[H - 1] === "EN" || x[H - 1] === "AN") && x[H + 1] === x[H - 1] && (x[H] = x[H - 1]);
            for (H = 0; H < $; ++H)
              if (x[H] === "EN") {
                for (let P = H - 1; P >= 0 && x[P] === "ET"; --P)
                  x[P] = "EN";
                for (let P = H + 1; P < $ && x[P] === "ET"; ++P)
                  x[P] = "EN";
              }
            for (H = 0; H < $; ++H)
              T = x[H], (T === "WS" || T === "ES" || T === "ET" || T === "CS") && (x[H] = "ON");
            for (z = A, H = 0; H < $; ++H)
              T = x[H], T === "EN" ? x[H] = z === "L" ? "L" : "EN" : (T === "R" || T === "L") && (z = T);
            for (H = 0; H < $; ++H)
              if (x[H] === "ON") {
                const P = m(x, H + 1, "ON");
                let V = A;
                H > 0 && (V = x[H - 1]);
                let J = k;
                P + 1 < $ && (J = x[P + 1]), V !== "L" && (V = "R"), J !== "L" && (J = "R"), V === J && v(x, H, P, V), H = P - 1;
              }
            for (H = 0; H < $; ++H)
              x[H] === "ON" && (x[H] = _);
            for (H = 0; H < $; ++H)
              T = x[H], i(R[H]) ? T === "R" ? R[H] += 1 : (T === "AN" || T === "EN") && (R[H] += 2) : (T === "L" || T === "AN" || T === "EN") && (R[H] += 1);
            let w = -1, F = 99, j;
            for (H = 0, B = R.length; H < B; ++H)
              j = R[H], w < j && (w = j), F > j && t(j) && (F = j);
            for (j = w; j >= F; --j) {
              let P = -1;
              for (H = 0, B = R.length; H < B; ++H)
                R[H] < j ? P >= 0 && (E(y, P, H), P = -1) : P < 0 && (P = H);
              P >= 0 && E(y, P, R.length);
            }
            for (H = 0, B = y.length; H < B; ++H) {
              const P = y[H];
              (P === "<" || P === ">") && (y[H] = "");
            }
            return S(y.join(""), D);
          }
        },
        /* 61 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.getFontSubstitution = x;
          var s = f(38), h = f(3);
          const g = {
            style: "normal",
            weight: "normal"
          }, t = {
            style: "normal",
            weight: "bold"
          }, i = {
            style: "italic",
            weight: "normal"
          }, m = {
            style: "italic",
            weight: "bold"
          }, v = /* @__PURE__ */ new Map([["Times-Roman", {
            local: ["Times New Roman", "Times-Roman", "Times", "Liberation Serif", "Nimbus Roman", "Nimbus Roman L", "Tinos", "Thorndale", "TeX Gyre Termes", "FreeSerif", "DejaVu Serif", "Bitstream Vera Serif", "Ubuntu"],
            style: g,
            ultimate: "serif"
          }], ["Times-Bold", {
            alias: "Times-Roman",
            style: t,
            ultimate: "serif"
          }], ["Times-Italic", {
            alias: "Times-Roman",
            style: i,
            ultimate: "serif"
          }], ["Times-BoldItalic", {
            alias: "Times-Roman",
            style: m,
            ultimate: "serif"
          }], ["Helvetica", {
            local: ["Helvetica", "Helvetica Neue", "Arial", "Arial Nova", "Liberation Sans", "Arimo", "Nimbus Sans", "Nimbus Sans L", "A030", "TeX Gyre Heros", "FreeSans", "DejaVu Sans", "Albany", "Bitstream Vera Sans", "Arial Unicode MS", "Microsoft Sans Serif", "Apple Symbols", "Cantarell"],
            path: "LiberationSans-Regular.ttf",
            style: g,
            ultimate: "sans-serif"
          }], ["Helvetica-Bold", {
            alias: "Helvetica",
            path: "LiberationSans-Bold.ttf",
            style: t,
            ultimate: "sans-serif"
          }], ["Helvetica-Oblique", {
            alias: "Helvetica",
            path: "LiberationSans-Italic.ttf",
            style: i,
            ultimate: "sans-serif"
          }], ["Helvetica-BoldOblique", {
            alias: "Helvetica",
            path: "LiberationSans-BoldItalic.ttf",
            style: m,
            ultimate: "sans-serif"
          }], ["Courier", {
            local: ["Courier", "Courier New", "Liberation Mono", "Nimbus Mono", "Nimbus Mono L", "Cousine", "Cumberland", "TeX Gyre Cursor", "FreeMono"],
            style: g,
            ultimate: "monospace"
          }], ["Courier-Bold", {
            alias: "Courier",
            style: t,
            ultimate: "monospace"
          }], ["Courier-Oblique", {
            alias: "Courier",
            style: i,
            ultimate: "monospace"
          }], ["Courier-BoldOblique", {
            alias: "Courier",
            style: m,
            ultimate: "monospace"
          }], ["ArialBlack", {
            local: ["Arial Black"],
            style: {
              style: "normal",
              weight: "900"
            },
            fallback: "Helvetica-Bold"
          }], ["ArialBlack-Bold", {
            alias: "ArialBlack"
          }], ["ArialBlack-Italic", {
            alias: "ArialBlack",
            style: {
              style: "italic",
              weight: "900"
            },
            fallback: "Helvetica-BoldOblique"
          }], ["ArialBlack-BoldItalic", {
            alias: "ArialBlack-Italic"
          }], ["ArialNarrow", {
            local: ["Arial Narrow", "Liberation Sans Narrow", "Helvetica Condensed", "Nimbus Sans Narrow", "TeX Gyre Heros Cn"],
            style: g,
            fallback: "Helvetica"
          }], ["ArialNarrow-Bold", {
            alias: "ArialNarrow",
            style: t,
            fallback: "Helvetica-Bold"
          }], ["ArialNarrow-Italic", {
            alias: "ArialNarrow",
            style: i,
            fallback: "Helvetica-Oblique"
          }], ["ArialNarrow-BoldItalic", {
            alias: "ArialNarrow",
            style: m,
            fallback: "Helvetica-BoldOblique"
          }], ["Calibri", {
            local: ["Calibri", "Carlito"],
            style: g,
            fallback: "Helvetica"
          }], ["Calibri-Bold", {
            alias: "Calibri",
            style: t,
            fallback: "Helvetica-Bold"
          }], ["Calibri-Italic", {
            alias: "Calibri",
            style: i,
            fallback: "Helvetica-Oblique"
          }], ["Calibri-BoldItalic", {
            alias: "Calibri",
            style: m,
            fallback: "Helvetica-BoldOblique"
          }], ["Wingdings", {
            local: ["Wingdings", "URW Dingbats"],
            style: g
          }], ["Wingdings-Regular", {
            alias: "Wingdings"
          }], ["Wingdings-Bold", {
            alias: "Wingdings"
          }]]), E = /* @__PURE__ */ new Map([["Arial-Black", "ArialBlack"]]);
          function S(b) {
            switch (b) {
              case t:
                return "Bold";
              case i:
                return "Italic";
              case m:
                return "Bold Italic";
              default:
                if ((b == null ? void 0 : b.weight) === "bold")
                  return "Bold";
                if ((b == null ? void 0 : b.style) === "italic")
                  return "Italic";
            }
            return "";
          }
          function y({
            alias: b,
            local: u,
            path: I,
            fallback: O,
            style: D,
            ultimate: $
          }, K, H, B = !0, R = !0, _ = "") {
            const A = {
              style: null,
              ultimate: null
            };
            if (u) {
              const k = _ ? ` ${_}` : "";
              for (const z of u)
                K.push(`local(${z}${k})`);
            }
            if (b) {
              const k = v.get(b), z = _ || S(D);
              Object.assign(A, y(k, K, H, B && !O, R && !I, z));
            }
            if (D && (A.style = D), $ && (A.ultimate = $), B && O) {
              const k = v.get(O), {
                ultimate: z
              } = y(k, K, H, B, R && !I, _);
              A.ultimate || (A.ultimate = z);
            }
            return R && I && H && K.push(`url(${H}${I})`), A;
          }
          function x(b, u, I, O, D) {
            O = (0, s.normalizeFontName)(O);
            const $ = O;
            let K = b.get($);
            if (K)
              return K;
            let H = v.get(O);
            if (!H) {
              for (const [w, F] of E)
                if (O.startsWith(w)) {
                  O = `${F}${O.substring(w.length)}`, H = v.get(O);
                  break;
                }
            }
            let B = !1;
            H || (H = v.get(D), B = !0);
            const R = `${u.getDocId()}_s${u.createFontId()}`;
            if (!H) {
              if (!(0, h.validateFontName)(O))
                return b.set($, null), null;
              const w = /bold/gi.test(O), F = /oblique|italic/gi.test(O), j = w && F && m || w && t || F && i || g;
              return K = {
                css: R,
                guessFallback: !0,
                loadedName: R,
                baseFontName: O,
                src: `local(${O})`,
                style: j
              }, b.set($, K), K;
            }
            const _ = [];
            B && (0, h.validateFontName)(O) && _.push(`local(${O})`);
            const {
              style: A,
              ultimate: k
            } = y(H, _, I), z = k === null, T = z ? "" : `,${k}`;
            return K = {
              css: `${R}${T}`,
              guessFallback: z,
              loadedName: R,
              baseFontName: O,
              src: _.join(","),
              style: A
            }, b.set($, K), K;
          }
        },
        /* 62 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.ImageResizer = void 0;
          var s = f(2);
          const h = 2048, g = 65537, t = 128;
          class i {
            constructor(v, E) {
              this._imgData = v, this._isMask = E;
            }
            static needsToBeResized(v, E) {
              if (v <= this._goodSquareLength && E <= this._goodSquareLength)
                return !1;
              const {
                MAX_DIM: S
              } = this;
              if (v > S || E > S)
                return !0;
              const y = v * E;
              if (this._hasMaxArea)
                return y > this.MAX_AREA;
              if (y < this._goodSquareLength ** 2)
                return !1;
              if (this._areGoodDims(v, E))
                return this._goodSquareLength = Math.max(this._goodSquareLength, Math.floor(Math.sqrt(v * E))), !1;
              this._goodSquareLength = this._guessMax(this._goodSquareLength, S, t, 0);
              const x = this.MAX_AREA = this._goodSquareLength ** 2;
              return y > x;
            }
            static get MAX_DIM() {
              return (0, s.shadow)(this, "MAX_DIM", this._guessMax(h, g, 0, 1));
            }
            static get MAX_AREA() {
              return this._hasMaxArea = !0, (0, s.shadow)(this, "MAX_AREA", this._guessMax(i._goodSquareLength, this.MAX_DIM, t, 0) ** 2);
            }
            static set MAX_AREA(v) {
              v >= 0 && (this._hasMaxArea = !0, (0, s.shadow)(this, "MAX_AREA", v));
            }
            static setMaxArea(v) {
              this._hasMaxArea || (this.MAX_AREA = v >> 2);
            }
            static _areGoodDims(v, E) {
              try {
                const S = new OffscreenCanvas(v, E), y = S.getContext("2d");
                y.fillRect(0, 0, 1, 1);
                const x = y.getImageData(0, 0, 1, 1).data[3];
                return S.width = S.height = 1, x !== 0;
              } catch {
                return !1;
              }
            }
            static _guessMax(v, E, S, y) {
              for (; v + S + 1 < E; ) {
                const x = Math.floor((v + E) / 2), b = y || x;
                this._areGoodDims(x, b) ? v = x : E = x;
              }
              return v;
            }
            static async createImage(v, E = !1) {
              return new i(v, E)._createImage();
            }
            async _createImage() {
              const v = this._encodeBMP(), E = new Blob([v.buffer], {
                type: "image/bmp"
              }), S = createImageBitmap(E), {
                MAX_AREA: y,
                MAX_DIM: x
              } = i, {
                _imgData: b
              } = this, {
                width: u,
                height: I
              } = b, O = Math.max(u / x, I / x, Math.sqrt(u * I / y)), D = Math.max(O, 2), $ = Math.round(10 * (O + 1.25)) / 10 / D, K = Math.floor(Math.log2($)), H = new Array(K + 2).fill(2);
              H[0] = D, H.splice(-1, 1, $ / (1 << K));
              let B = u, R = I, _ = await S;
              for (const A of H) {
                const k = B, z = R;
                B = Math.floor(B / A) - 1, R = Math.floor(R / A) - 1;
                const T = new OffscreenCanvas(B, R);
                T.getContext("2d").drawImage(_, 0, 0, k, z, 0, 0, B, R), _ = T.transferToImageBitmap();
              }
              return b.data = null, b.bitmap = _, b.width = B, b.height = R, b;
            }
            _encodeBMP() {
              const {
                width: v,
                height: E,
                kind: S
              } = this._imgData;
              let y = this._imgData.data, x, b = new Uint8Array(0), u = b, I = 0;
              switch (S) {
                case s.ImageKind.GRAYSCALE_1BPP: {
                  x = 1, b = new Uint8Array(this._isMask ? [255, 255, 255, 255, 0, 0, 0, 0] : [0, 0, 0, 0, 255, 255, 255, 255]);
                  const R = v + 7 >> 3, _ = R + 3 & -4;
                  if (R !== _) {
                    const A = new Uint8Array(_ * E);
                    let k = 0;
                    for (let z = 0, T = E * R; z < T; z += R, k += _)
                      A.set(y.subarray(z, z + R), k);
                    y = A;
                  }
                  break;
                }
                case s.ImageKind.RGB_24BPP: {
                  if (x = 24, v & 3) {
                    const R = 3 * v, _ = R + 3 & -4, A = _ - R, k = new Uint8Array(_ * E);
                    let z = 0;
                    for (let T = 0, w = E * R; T < w; T += R) {
                      const F = y.subarray(T, T + R);
                      for (let j = 0; j < R; j += 3)
                        k[z++] = F[j + 2], k[z++] = F[j + 1], k[z++] = F[j];
                      z += A;
                    }
                    y = k;
                  } else
                    for (let R = 0, _ = y.length; R < _; R += 3) {
                      const A = y[R];
                      y[R] = y[R + 2], y[R + 2] = A;
                    }
                  break;
                }
                case s.ImageKind.RGBA_32BPP:
                  x = 32, I = 3, u = new Uint8Array(68);
                  const B = new DataView(u.buffer);
                  s.FeatureTest.isLittleEndian ? (B.setUint32(0, 255, !0), B.setUint32(4, 65280, !0), B.setUint32(8, 16711680, !0), B.setUint32(12, 4278190080, !0)) : (B.setUint32(0, 4278190080, !0), B.setUint32(4, 16711680, !0), B.setUint32(8, 65280, !0), B.setUint32(12, 255, !0));
                  break;
                default:
                  throw new Error("invalid format");
              }
              let O = 0;
              const D = 40 + u.length, $ = 14 + D + b.length + y.length, K = new Uint8Array($), H = new DataView(K.buffer);
              return H.setUint16(O, 19778, !0), O += 2, H.setUint32(O, $, !0), O += 4, H.setUint32(O, 0, !0), O += 4, H.setUint32(O, 14 + D + b.length, !0), O += 4, H.setUint32(O, D, !0), O += 4, H.setInt32(O, v, !0), O += 4, H.setInt32(O, -E, !0), O += 4, H.setUint16(O, 1, !0), O += 2, H.setUint16(O, x, !0), O += 2, H.setUint32(O, I, !0), O += 4, H.setUint32(O, 0, !0), O += 4, H.setInt32(O, 0, !0), O += 4, H.setInt32(O, 0, !0), O += 4, H.setUint32(O, b.length / 4, !0), O += 4, H.setUint32(O, 0, !0), O += 4, K.set(u, O), O += u.length, K.set(b, O), O += b.length, K.set(y, O), K;
            }
          }
          c.ImageResizer = i, i._goodSquareLength = h;
        },
        /* 63 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.MurmurHash3_64 = void 0;
          var s = f(2);
          const h = 3285377520, g = 4294901760, t = 65535;
          class i {
            constructor(v) {
              this.h1 = v ? v & 4294967295 : h, this.h2 = v ? v & 4294967295 : h;
            }
            update(v) {
              let E, S;
              if (typeof v == "string") {
                E = new Uint8Array(v.length * 2), S = 0;
                for (let R = 0, _ = v.length; R < _; R++) {
                  const A = v.charCodeAt(R);
                  A <= 255 ? E[S++] = A : (E[S++] = A >>> 8, E[S++] = A & 255);
                }
              } else if ((0, s.isArrayBuffer)(v))
                E = v.slice(), S = E.byteLength;
              else
                throw new Error("Wrong data format in MurmurHash3_64_update. Input must be a string or array.");
              const y = S >> 2, x = S - y * 4, b = new Uint32Array(E.buffer, 0, y);
              let u = 0, I = 0, O = this.h1, D = this.h2;
              const $ = 3432918353, K = 461845907, H = $ & t, B = K & t;
              for (let R = 0; R < y; R++)
                R & 1 ? (u = b[R], u = u * $ & g | u * H & t, u = u << 15 | u >>> 17, u = u * K & g | u * B & t, O ^= u, O = O << 13 | O >>> 19, O = O * 5 + 3864292196) : (I = b[R], I = I * $ & g | I * H & t, I = I << 15 | I >>> 17, I = I * K & g | I * B & t, D ^= I, D = D << 13 | D >>> 19, D = D * 5 + 3864292196);
              switch (u = 0, x) {
                case 3:
                  u ^= E[y * 4 + 2] << 16;
                case 2:
                  u ^= E[y * 4 + 1] << 8;
                case 1:
                  u ^= E[y * 4], u = u * $ & g | u * H & t, u = u << 15 | u >>> 17, u = u * K & g | u * B & t, y & 1 ? O ^= u : D ^= u;
              }
              this.h1 = O, this.h2 = D;
            }
            hexdigest() {
              let v = this.h1, E = this.h2;
              return v ^= E >>> 1, v = v * 3981806797 & g | v * 36045 & t, E = E * 4283543511 & g | ((E << 16 | v >>> 16) * 2950163797 & g) >>> 16, v ^= E >>> 1, v = v * 444984403 & g | v * 60499 & t, E = E * 3301882366 & g | ((E << 16 | v >>> 16) * 3120437893 & g) >>> 16, v ^= E >>> 1, (v >>> 0).toString(16).padStart(8, "0") + (E >>> 0).toString(16).padStart(8, "0");
            }
          }
          c.MurmurHash3_64 = i;
        },
        /* 64 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.OperatorList = void 0;
          var s = f(2);
          function h(E, S, y, x, b) {
            let u = E;
            for (let I = 0, O = S.length - 1; I < O; I++) {
              const D = S[I];
              u = u[D] || (u[D] = []);
            }
            u[S.at(-1)] = {
              checkFn: y,
              iterateFn: x,
              processFn: b
            };
          }
          const g = [];
          h(g, [s.OPS.save, s.OPS.transform, s.OPS.paintInlineImageXObject, s.OPS.restore], null, function(S, y) {
            const x = S.fnArray, b = S.iCurr - 3, u = (y - b) % 4;
            switch (u) {
              case 0:
                return x[y] === s.OPS.save;
              case 1:
                return x[y] === s.OPS.transform;
              case 2:
                return x[y] === s.OPS.paintInlineImageXObject;
              case 3:
                return x[y] === s.OPS.restore;
            }
            throw new Error(`iterateInlineImageGroup - invalid pos: ${u}`);
          }, function(S, y) {
            const O = S.fnArray, D = S.argsArray, $ = S.iCurr, K = $ - 3, H = $ - 2, B = $ - 1, R = Math.min(Math.floor((y - K) / 4), 200);
            if (R < 10)
              return y - (y - K) % 4;
            let _ = 0;
            const A = [];
            let k = 0, z = 1, T = 1;
            for (let J = 0; J < R; J++) {
              const ne = D[H + (J << 2)], Z = D[B + (J << 2)][0];
              z + Z.width > 1e3 && (_ = Math.max(_, z), T += k + 2, z = 0, k = 0), A.push({
                transform: ne,
                x: z,
                y: T,
                w: Z.width,
                h: Z.height
              }), z += Z.width + 2, k = Math.max(k, Z.height);
            }
            const w = Math.max(_, z) + 1, F = T + k + 1, j = new Uint8Array(w * F * 4), P = w << 2;
            for (let J = 0; J < R; J++) {
              const ne = D[B + (J << 2)][0].data, Z = A[J].w << 2;
              let te = 0, G = A[J].x + A[J].y * w << 2;
              j.set(ne.subarray(0, Z), G - P);
              for (let N = 0, q = A[J].h; N < q; N++)
                j.set(ne.subarray(te, te + Z), G), te += Z, G += P;
              for (j.set(ne.subarray(te - Z, te), G); G >= 0; )
                ne[G - 4] = ne[G], ne[G - 3] = ne[G + 1], ne[G - 2] = ne[G + 2], ne[G - 1] = ne[G + 3], ne[G + Z] = ne[G + Z - 4], ne[G + Z + 1] = ne[G + Z - 3], ne[G + Z + 2] = ne[G + Z - 2], ne[G + Z + 3] = ne[G + Z - 1], G -= P;
            }
            const V = {
              width: w,
              height: F
            };
            if (S.isOffscreenCanvasSupported) {
              const J = new OffscreenCanvas(w, F);
              J.getContext("2d").putImageData(new ImageData(new Uint8ClampedArray(j.buffer), w, F), 0, 0), V.bitmap = J.transferToImageBitmap(), V.data = null;
            } else
              V.kind = s.ImageKind.RGBA_32BPP, V.data = j;
            return O.splice(K, R * 4, s.OPS.paintInlineImageXObjectGroup), D.splice(K, R * 4, [V, A]), K + 1;
          }), h(g, [s.OPS.save, s.OPS.transform, s.OPS.paintImageMaskXObject, s.OPS.restore], null, function(S, y) {
            const x = S.fnArray, b = S.iCurr - 3, u = (y - b) % 4;
            switch (u) {
              case 0:
                return x[y] === s.OPS.save;
              case 1:
                return x[y] === s.OPS.transform;
              case 2:
                return x[y] === s.OPS.paintImageMaskXObject;
              case 3:
                return x[y] === s.OPS.restore;
            }
            throw new Error(`iterateImageMaskGroup - invalid pos: ${u}`);
          }, function(S, y) {
            const I = S.fnArray, O = S.argsArray, D = S.iCurr, $ = D - 3, K = D - 2, H = D - 1;
            let B = Math.floor((y - $) / 4);
            if (B < 10)
              return y - (y - $) % 4;
            let R = !1, _, A;
            const k = O[H][0], z = O[K][0], T = O[K][1], w = O[K][2], F = O[K][3];
            if (T === w) {
              R = !0, _ = K + 4;
              let j = H + 4;
              for (let P = 1; P < B; P++, _ += 4, j += 4)
                if (A = O[_], O[j][0] !== k || A[0] !== z || A[1] !== T || A[2] !== w || A[3] !== F) {
                  P < 10 ? R = !1 : B = P;
                  break;
                }
            }
            if (R) {
              B = Math.min(B, 1e3);
              const j = new Float32Array(B * 2);
              _ = K;
              for (let P = 0; P < B; P++, _ += 4)
                A = O[_], j[P << 1] = A[4], j[(P << 1) + 1] = A[5];
              I.splice($, B * 4, s.OPS.paintImageMaskXObjectRepeat), O.splice($, B * 4, [k, z, T, w, F, j]);
            } else {
              B = Math.min(B, 100);
              const j = [];
              for (let P = 0; P < B; P++) {
                A = O[K + (P << 2)];
                const V = O[H + (P << 2)][0];
                j.push({
                  data: V.data,
                  width: V.width,
                  height: V.height,
                  interpolate: V.interpolate,
                  count: V.count,
                  transform: A
                });
              }
              I.splice($, B * 4, s.OPS.paintImageMaskXObjectGroup), O.splice($, B * 4, [j]);
            }
            return $ + 1;
          }), h(g, [s.OPS.save, s.OPS.transform, s.OPS.paintImageXObject, s.OPS.restore], function(E) {
            const S = E.argsArray, y = E.iCurr - 2;
            return S[y][1] === 0 && S[y][2] === 0;
          }, function(S, y) {
            const x = S.fnArray, b = S.argsArray, u = S.iCurr - 3, I = (y - u) % 4;
            switch (I) {
              case 0:
                return x[y] === s.OPS.save;
              case 1:
                if (x[y] !== s.OPS.transform)
                  return !1;
                const O = S.iCurr - 2, D = b[O][0], $ = b[O][3];
                return !(b[y][0] !== D || b[y][1] !== 0 || b[y][2] !== 0 || b[y][3] !== $);
              case 2:
                if (x[y] !== s.OPS.paintImageXObject)
                  return !1;
                const K = S.iCurr - 1, H = b[K][0];
                return b[y][0] === H;
              case 3:
                return x[y] === s.OPS.restore;
            }
            throw new Error(`iterateImageGroup - invalid pos: ${I}`);
          }, function(E, S) {
            const b = E.fnArray, u = E.argsArray, I = E.iCurr, O = I - 3, D = I - 2, $ = I - 1, K = u[$][0], H = u[D][0], B = u[D][3], R = Math.min(Math.floor((S - O) / 4), 1e3);
            if (R < 3)
              return S - (S - O) % 4;
            const _ = new Float32Array(R * 2);
            let A = D;
            for (let z = 0; z < R; z++, A += 4) {
              const T = u[A];
              _[z << 1] = T[4], _[(z << 1) + 1] = T[5];
            }
            const k = [K, H, B, _];
            return b.splice(O, R * 4, s.OPS.paintImageXObjectRepeat), u.splice(O, R * 4, k), O + 1;
          }), h(g, [s.OPS.beginText, s.OPS.setFont, s.OPS.setTextMatrix, s.OPS.showText, s.OPS.endText], null, function(S, y) {
            const x = S.fnArray, b = S.argsArray, u = S.iCurr - 4, I = (y - u) % 5;
            switch (I) {
              case 0:
                return x[y] === s.OPS.beginText;
              case 1:
                return x[y] === s.OPS.setFont;
              case 2:
                return x[y] === s.OPS.setTextMatrix;
              case 3:
                if (x[y] !== s.OPS.showText)
                  return !1;
                const O = S.iCurr - 3, D = b[O][0], $ = b[O][1];
                return !(b[y][0] !== D || b[y][1] !== $);
              case 4:
                return x[y] === s.OPS.endText;
            }
            throw new Error(`iterateShowTextGroup - invalid pos: ${I}`);
          }, function(E, S) {
            const b = E.fnArray, u = E.argsArray, I = E.iCurr, O = I - 4, D = I - 3, $ = I - 2, K = I - 1, H = I, B = u[D][0], R = u[D][1];
            let _ = Math.min(Math.floor((S - O) / 5), 1e3);
            if (_ < 3)
              return S - (S - O) % 5;
            let A = O;
            O >= 4 && b[O - 4] === b[D] && b[O - 3] === b[$] && b[O - 2] === b[K] && b[O - 1] === b[H] && u[O - 4][0] === B && u[O - 4][1] === R && (_++, A -= 5);
            let k = A + 4;
            for (let z = 1; z < _; z++)
              b.splice(k, 3), u.splice(k, 3), k += 2;
            return k + 1;
          });
          class t {
            constructor(S) {
              this.queue = S;
            }
            _optimize() {
            }
            push(S, y) {
              this.queue.fnArray.push(S), this.queue.argsArray.push(y), this._optimize();
            }
            flush() {
            }
            reset() {
            }
          }
          class i extends t {
            constructor(S) {
              super(S), this.state = null, this.context = {
                iCurr: 0,
                fnArray: S.fnArray,
                argsArray: S.argsArray,
                isOffscreenCanvasSupported: !1
              }, this.match = null, this.lastProcessed = 0;
            }
            set isOffscreenCanvasSupported(S) {
              this.context.isOffscreenCanvasSupported = S;
            }
            _optimize() {
              const S = this.queue.fnArray;
              let y = this.lastProcessed, x = S.length, b = this.state, u = this.match;
              if (!b && !u && y + 1 === x && !g[S[y]]) {
                this.lastProcessed = x;
                return;
              }
              const I = this.context;
              for (; y < x; ) {
                if (u) {
                  if ((0, u.iterateFn)(I, y)) {
                    y++;
                    continue;
                  }
                  if (y = (0, u.processFn)(I, y + 1), x = S.length, u = null, b = null, y >= x)
                    break;
                }
                if (b = (b || g)[S[y]], !b || Array.isArray(b)) {
                  y++;
                  continue;
                }
                if (I.iCurr = y, y++, b.checkFn && !(0, b.checkFn)(I)) {
                  b = null;
                  continue;
                }
                u = b, b = null;
              }
              this.state = b, this.match = u, this.lastProcessed = y;
            }
            flush() {
              for (; this.match; ) {
                const S = this.queue.fnArray.length;
                this.lastProcessed = (0, this.match.processFn)(this.context, S), this.match = null, this.state = null, this._optimize();
              }
            }
            reset() {
              this.state = null, this.match = null, this.lastProcessed = 0;
            }
          }
          const v = class v {
            constructor(S = 0, y) {
              this._streamSink = y, this.fnArray = [], this.argsArray = [], this.optimizer = y && !(S & s.RenderingIntentFlag.OPLIST) ? new i(this) : new t(this), this.dependencies = /* @__PURE__ */ new Set(), this._totalLength = 0, this.weight = 0, this._resolved = y ? null : Promise.resolve();
            }
            set isOffscreenCanvasSupported(S) {
              this.optimizer.isOffscreenCanvasSupported = S;
            }
            get length() {
              return this.argsArray.length;
            }
            get ready() {
              return this._resolved || this._streamSink.ready;
            }
            get totalLength() {
              return this._totalLength + this.length;
            }
            addOp(S, y) {
              this.optimizer.push(S, y), this.weight++, this._streamSink && (this.weight >= v.CHUNK_SIZE ? this.flush() : this.weight >= v.CHUNK_SIZE_ABOUT && (S === s.OPS.restore || S === s.OPS.endText) && this.flush());
            }
            addImageOps(S, y, x) {
              x !== void 0 && this.addOp(s.OPS.beginMarkedContentProps, ["OC", x]), this.addOp(S, y), x !== void 0 && this.addOp(s.OPS.endMarkedContent, []);
            }
            addDependency(S) {
              this.dependencies.has(S) || (this.dependencies.add(S), this.addOp(s.OPS.dependency, [S]));
            }
            addDependencies(S) {
              for (const y of S)
                this.addDependency(y);
            }
            addOpList(S) {
              if (!(S instanceof v)) {
                (0, s.warn)('addOpList - ignoring invalid "opList" parameter.');
                return;
              }
              for (const y of S.dependencies)
                this.dependencies.add(y);
              for (let y = 0, x = S.length; y < x; y++)
                this.addOp(S.fnArray[y], S.argsArray[y]);
            }
            getIR() {
              return {
                fnArray: this.fnArray,
                argsArray: this.argsArray,
                length: this.length
              };
            }
            get _transfers() {
              var u;
              const S = [], {
                fnArray: y,
                argsArray: x,
                length: b
              } = this;
              for (let I = 0; I < b; I++)
                switch (y[I]) {
                  case s.OPS.paintInlineImageXObject:
                  case s.OPS.paintInlineImageXObjectGroup:
                  case s.OPS.paintImageMaskXObject:
                    const O = x[I][0];
                    !O.cached && ((u = O.data) == null ? void 0 : u.buffer) instanceof ArrayBuffer && S.push(O.data.buffer);
                    break;
                }
              return S;
            }
            flush(S = !1, y = null) {
              this.optimizer.flush();
              const x = this.length;
              this._totalLength += x, this._streamSink.enqueue({
                fnArray: this.fnArray,
                argsArray: this.argsArray,
                lastChunk: S,
                separateAnnots: y,
                length: x
              }, 1, this._transfers), this.dependencies.clear(), this.fnArray.length = 0, this.argsArray.length = 0, this.weight = 0, this.optimizer.reset();
            }
          };
          ni(v, "CHUNK_SIZE", 1e3), ni(v, "CHUNK_SIZE_ABOUT", v.CHUNK_SIZE - 5);
          let m = v;
          c.OperatorList = m;
        },
        /* 65 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.PDFImage = void 0;
          var s = f(2), h = f(28), g = f(5), t = f(12), i = f(18), m = f(62), v = f(26), E = f(30), S = f(4);
          function y(u, I, O, D) {
            return u = I + u * O, u < 0 ? u = 0 : u > D && (u = D), u;
          }
          function x(u, I, O, D, $, K) {
            const H = $ * K;
            let B;
            I <= 8 ? B = new Uint8Array(H) : I <= 16 ? B = new Uint16Array(H) : B = new Uint32Array(H);
            const R = O / $, _ = D / K;
            let A, k, z, T = 0, w;
            const F = new Uint16Array($), j = O;
            for (A = 0; A < $; A++)
              F[A] = Math.floor(A * R);
            for (A = 0; A < K; A++)
              for (z = Math.floor(A * _) * j, k = 0; k < $; k++)
                w = z + F[k], B[T++] = u[w];
            return B;
          }
          class b {
            constructor({
              xref: I,
              res: O,
              image: D,
              isInline: $ = !1,
              smask: K = null,
              mask: H = null,
              isMask: B = !1,
              pdfFunctionFactory: R,
              localColorSpaceCache: _
            }) {
              var j;
              this.image = D;
              const A = D.dict, k = A.get("F", "Filter");
              let z;
              if (k instanceof S.Name)
                z = k.name;
              else if (Array.isArray(k)) {
                const P = I.fetchIfRef(k[0]);
                P instanceof S.Name && (z = P.name);
              }
              switch (z) {
                case "JPXDecode":
                  const P = new E.JpxImage();
                  P.parseImageProperties(D.stream), D.stream.reset(), D.width = P.width, D.height = P.height, D.bitsPerComponent = P.bitsPerComponent, D.numComps = P.componentsCount;
                  break;
                case "JBIG2Decode":
                  D.bitsPerComponent = 1, D.numComps = 1;
                  break;
              }
              let T = A.get("W", "Width"), w = A.get("H", "Height");
              if (Number.isInteger(D.width) && D.width > 0 && Number.isInteger(D.height) && D.height > 0 && (D.width !== T || D.height !== w) && ((0, s.warn)("PDFImage - using the Width/Height of the image data, rather than the image dictionary."), T = D.width, w = D.height), T < 1 || w < 1)
                throw new s.FormatError(`Invalid image width: ${T} or height: ${w}`);
              this.width = T, this.height = w, this.interpolate = A.get("I", "Interpolate"), this.imageMask = A.get("IM", "ImageMask") || !1, this.matte = A.get("Matte") || !1;
              let F = D.bitsPerComponent;
              if (!F && (F = A.get("BPC", "BitsPerComponent"), !F))
                if (this.imageMask)
                  F = 1;
                else
                  throw new s.FormatError(`Bits per component missing in image: ${this.imageMask}`);
              if (this.bpc = F, !this.imageMask) {
                let P = A.getRaw("CS") || A.getRaw("ColorSpace");
                if (!P)
                  switch ((0, s.info)("JPX images (which do not require color spaces)"), D.numComps) {
                    case 1:
                      P = S.Name.get("DeviceGray");
                      break;
                    case 3:
                      P = S.Name.get("DeviceRGB");
                      break;
                    case 4:
                      P = S.Name.get("DeviceCMYK");
                      break;
                    default:
                      throw new Error(`JPX images with ${D.numComps} color components not supported.`);
                  }
                this.colorSpace = t.ColorSpace.parse({
                  cs: P,
                  xref: I,
                  resources: $ ? O : null,
                  pdfFunctionFactory: R,
                  localColorSpaceCache: _
                }), this.numComps = this.colorSpace.numComps;
              }
              if (this.decode = A.getArray("D", "Decode"), this.needsDecode = !1, this.decode && (this.colorSpace && !this.colorSpace.isDefaultDecode(this.decode, F) || B && !t.ColorSpace.isDefaultDecode(this.decode, 1))) {
                this.needsDecode = !0;
                const P = (1 << F) - 1;
                this.decodeCoefficients = [], this.decodeAddends = [];
                const V = ((j = this.colorSpace) == null ? void 0 : j.name) === "Indexed";
                for (let J = 0, ne = 0; J < this.decode.length; J += 2, ++ne) {
                  const Z = this.decode[J], te = this.decode[J + 1];
                  this.decodeCoefficients[ne] = V ? (te - Z) / P : te - Z, this.decodeAddends[ne] = V ? Z : P * Z;
                }
              }
              K ? this.smask = new b({
                xref: I,
                res: O,
                image: K,
                isInline: $,
                pdfFunctionFactory: R,
                localColorSpaceCache: _
              }) : H && (H instanceof g.BaseStream ? H.dict.get("IM", "ImageMask") ? this.mask = new b({
                xref: I,
                res: O,
                image: H,
                isInline: $,
                isMask: !0,
                pdfFunctionFactory: R,
                localColorSpaceCache: _
              }) : (0, s.warn)("Ignoring /Mask in image without /ImageMask.") : this.mask = H);
            }
            static async buildImage({
              xref: I,
              res: O,
              image: D,
              isInline: $ = !1,
              pdfFunctionFactory: K,
              localColorSpaceCache: H
            }) {
              const B = D;
              let R = null, _ = null;
              const A = D.dict.get("SMask"), k = D.dict.get("Mask");
              return A ? A instanceof g.BaseStream ? R = A : (0, s.warn)("Unsupported /SMask format.") : k && (k instanceof g.BaseStream || Array.isArray(k) ? _ = k : (0, s.warn)("Unsupported /Mask format.")), new b({
                xref: I,
                res: O,
                image: B,
                isInline: $,
                smask: R,
                mask: _,
                pdfFunctionFactory: K,
                localColorSpaceCache: H
              });
            }
            static createRawMask({
              imgArray: I,
              width: O,
              height: D,
              imageIsFromDecodeStream: $,
              inverseDecode: K,
              interpolate: H
            }) {
              const B = (O + 7 >> 3) * D, R = I.byteLength, _ = B === R;
              let A, k;
              if ($ && (!K || _) ? A = I : K ? (A = new Uint8Array(B), A.set(I), A.fill(255, R)) : A = new Uint8Array(I), K)
                for (k = 0; k < R; k++)
                  A[k] ^= 255;
              return {
                data: A,
                width: O,
                height: D,
                interpolate: H
              };
            }
            static async createMask({
              imgArray: I,
              width: O,
              height: D,
              imageIsFromDecodeStream: $,
              inverseDecode: K,
              interpolate: H,
              isOffscreenCanvasSupported: B = !1
            }) {
              const R = O === 1 && D === 1 && K === (I.length === 0 || !!(I[0] & 128));
              if (R)
                return {
                  isSingleOpaquePixel: R
                };
              if (B) {
                if (m.ImageResizer.needsToBeResized(O, D)) {
                  const T = new Uint8ClampedArray(O * D * 4);
                  return (0, h.convertBlackAndWhiteToRGBA)({
                    src: I,
                    dest: T,
                    width: O,
                    height: D,
                    nonBlackColor: 0,
                    inverseDecode: K
                  }), m.ImageResizer.createImage({
                    kind: s.ImageKind.RGBA_32BPP,
                    data: T,
                    width: O,
                    height: D,
                    interpolate: H
                  });
                }
                const _ = new OffscreenCanvas(O, D), A = _.getContext("2d"), k = A.createImageData(O, D);
                (0, h.convertBlackAndWhiteToRGBA)({
                  src: I,
                  dest: k.data,
                  width: O,
                  height: D,
                  nonBlackColor: 0,
                  inverseDecode: K
                }), A.putImageData(k, 0, 0);
                const z = _.transferToImageBitmap();
                return {
                  data: null,
                  width: O,
                  height: D,
                  interpolate: H,
                  bitmap: z
                };
              }
              return this.createRawMask({
                imgArray: I,
                width: O,
                height: D,
                inverseDecode: K,
                imageIsFromDecodeStream: $,
                interpolate: H
              });
            }
            get drawWidth() {
              var I, O;
              return Math.max(this.width, ((I = this.smask) == null ? void 0 : I.width) || 0, ((O = this.mask) == null ? void 0 : O.width) || 0);
            }
            get drawHeight() {
              var I, O;
              return Math.max(this.height, ((I = this.smask) == null ? void 0 : I.height) || 0, ((O = this.mask) == null ? void 0 : O.height) || 0);
            }
            decodeBuffer(I) {
              const O = this.bpc, D = this.numComps, $ = this.decodeAddends, K = this.decodeCoefficients, H = (1 << O) - 1;
              let B, R;
              if (O === 1) {
                for (B = 0, R = I.length; B < R; B++)
                  I[B] = +!I[B];
                return;
              }
              let _ = 0;
              for (B = 0, R = this.width * this.height; B < R; B++)
                for (let A = 0; A < D; A++)
                  I[_] = y(I[_], $[A], K[A], H), _++;
            }
            getComponents(I) {
              const O = this.bpc;
              if (O === 8)
                return I;
              const D = this.width, $ = this.height, K = this.numComps, H = D * $ * K;
              let B = 0, R;
              O <= 8 ? R = new Uint8Array(H) : O <= 16 ? R = new Uint16Array(H) : R = new Uint32Array(H);
              const _ = D * K, A = (1 << O) - 1;
              let k = 0, z, T;
              if (O === 1) {
                let w, F, j;
                for (let P = 0; P < $; P++) {
                  for (F = k + (_ & -8), j = k + _; k < F; )
                    T = I[B++], R[k] = T >> 7 & 1, R[k + 1] = T >> 6 & 1, R[k + 2] = T >> 5 & 1, R[k + 3] = T >> 4 & 1, R[k + 4] = T >> 3 & 1, R[k + 5] = T >> 2 & 1, R[k + 6] = T >> 1 & 1, R[k + 7] = T & 1, k += 8;
                  if (k < j)
                    for (T = I[B++], w = 128; k < j; )
                      R[k++] = +!!(T & w), w >>= 1;
                }
              } else {
                let w = 0;
                for (T = 0, k = 0, z = H; k < z; ++k) {
                  for (k % _ === 0 && (T = 0, w = 0); w < O; )
                    T = T << 8 | I[B++], w += 8;
                  const F = w - O;
                  let j = T >> F;
                  j < 0 ? j = 0 : j > A && (j = A), R[k] = j, T &= (1 << F) - 1, w = F;
                }
              }
              return R;
            }
            fillOpacity(I, O, D, $, K) {
              const H = this.smask, B = this.mask;
              let R, _, A, k, z, T;
              if (H)
                _ = H.width, A = H.height, R = new Uint8ClampedArray(_ * A), H.fillGrayBuffer(R), (_ !== O || A !== D) && (R = x(R, H.bpc, _, A, O, D));
              else if (B)
                if (B instanceof b) {
                  for (_ = B.width, A = B.height, R = new Uint8ClampedArray(_ * A), B.numComps = 1, B.fillGrayBuffer(R), k = 0, z = _ * A; k < z; ++k)
                    R[k] = 255 - R[k];
                  (_ !== O || A !== D) && (R = x(R, B.bpc, _, A, O, D));
                } else if (Array.isArray(B)) {
                  R = new Uint8ClampedArray(O * D);
                  const w = this.numComps;
                  for (k = 0, z = O * D; k < z; ++k) {
                    let F = 0;
                    const j = k * w;
                    for (T = 0; T < w; ++T) {
                      const P = K[j + T], V = T * 2;
                      if (P < B[V] || P > B[V + 1]) {
                        F = 255;
                        break;
                      }
                    }
                    R[k] = F;
                  }
                } else
                  throw new s.FormatError("Unknown mask format.");
              if (R)
                for (k = 0, T = 3, z = O * $; k < z; ++k, T += 4)
                  I[T] = R[k];
              else
                for (k = 0, T = 3, z = O * $; k < z; ++k, T += 4)
                  I[T] = 255;
            }
            undoPreblend(I, O, D) {
              var A;
              const $ = (A = this.smask) == null ? void 0 : A.matte;
              if (!$)
                return;
              const K = this.colorSpace.getRgb($, 0), H = K[0], B = K[1], R = K[2], _ = O * D * 4;
              for (let k = 0; k < _; k += 4) {
                const z = I[k + 3];
                if (z === 0) {
                  I[k] = 255, I[k + 1] = 255, I[k + 2] = 255;
                  continue;
                }
                const T = 255 / z;
                I[k] = (I[k] - H) * T + H, I[k + 1] = (I[k + 1] - B) * T + B, I[k + 2] = (I[k + 2] - R) * T + R;
              }
            }
            async createImageData(I = !1, O = !1) {
              const D = this.drawWidth, $ = this.drawHeight, K = {
                width: D,
                height: $,
                interpolate: this.interpolate,
                kind: 0,
                data: null
              }, H = this.numComps, B = this.width, R = this.height, _ = this.bpc, A = B * H * _ + 7 >> 3, k = O && m.ImageResizer.needsToBeResized(D, $);
              if (!I) {
                let Z;
                if (this.colorSpace.name === "DeviceGray" && _ === 1 ? Z = s.ImageKind.GRAYSCALE_1BPP : this.colorSpace.name === "DeviceRGB" && _ === 8 && !this.needsDecode && (Z = s.ImageKind.RGB_24BPP), Z && !this.smask && !this.mask && D === B && $ === R) {
                  const te = this.getImageBytes(R * A, {});
                  if (O)
                    return k ? m.ImageResizer.createImage({
                      data: te,
                      kind: Z,
                      width: D,
                      height: $,
                      interpolate: this.interpolate
                    }, this.needsDecode) : this.createBitmap(Z, B, R, te);
                  if (K.kind = Z, K.data = te, this.needsDecode) {
                    (0, s.assert)(Z === s.ImageKind.GRAYSCALE_1BPP, "PDFImage.createImageData: The image must be grayscale.");
                    const G = K.data;
                    for (let N = 0, q = G.length; N < q; N++)
                      G[N] ^= 255;
                  }
                  return K;
                }
                if (this.image instanceof v.JpegStream && !this.smask && !this.mask && !this.needsDecode) {
                  let te = R * A;
                  if (O && !k) {
                    let G = !1;
                    switch (this.colorSpace.name) {
                      case "DeviceGray":
                        te *= 4, G = !0;
                        break;
                      case "DeviceRGB":
                        te = te / 3 * 4, G = !0;
                        break;
                      case "DeviceCMYK":
                        G = !0;
                        break;
                    }
                    if (G) {
                      const N = this.getImageBytes(te, {
                        drawWidth: D,
                        drawHeight: $,
                        forceRGBA: !0
                      });
                      return this.createBitmap(s.ImageKind.RGBA_32BPP, D, $, N);
                    }
                  } else
                    switch (this.colorSpace.name) {
                      case "DeviceGray":
                        te *= 3;
                      case "DeviceRGB":
                      case "DeviceCMYK":
                        return K.kind = s.ImageKind.RGB_24BPP, K.data = this.getImageBytes(te, {
                          drawWidth: D,
                          drawHeight: $,
                          forceRGB: !0
                        }), k ? m.ImageResizer.createImage(K) : K;
                    }
                }
              }
              const z = this.getImageBytes(R * A, {
                internal: !0
              }), T = 0 | z.length / A * $ / R, w = this.getComponents(z);
              let F, j, P, V, J, ne;
              if (O && !k && (P = new OffscreenCanvas(D, $), V = P.getContext("2d"), J = V.createImageData(D, $), ne = J.data), K.kind = s.ImageKind.RGBA_32BPP, !I && !this.smask && !this.mask ? (!O || k ? (K.kind = s.ImageKind.RGB_24BPP, ne = new Uint8ClampedArray(D * $ * 3), F = 0) : (new Uint32Array(ne.buffer).fill(s.FeatureTest.isLittleEndian ? 4278190080 : 255), F = 1), j = !1) : ((!O || k) && (ne = new Uint8ClampedArray(D * $ * 4)), F = 1, j = !0, this.fillOpacity(ne, D, $, T, w)), this.needsDecode && this.decodeBuffer(w), this.colorSpace.fillRgb(ne, B, R, D, $, T, _, w, F), j && this.undoPreblend(ne, D, T), O && !k) {
                V.putImageData(J, 0, 0);
                const Z = P.transferToImageBitmap();
                return {
                  data: null,
                  width: D,
                  height: $,
                  bitmap: Z,
                  interpolate: this.interpolate
                };
              }
              return K.data = ne, k ? m.ImageResizer.createImage(K) : K;
            }
            fillGrayBuffer(I) {
              const O = this.numComps;
              if (O !== 1)
                throw new s.FormatError(`Reading gray scale from a color image: ${O}`);
              const D = this.width, $ = this.height, K = this.bpc, H = D * O * K + 7 >> 3, B = this.getImageBytes($ * H, {
                internal: !0
              }), R = this.getComponents(B);
              let _, A;
              if (K === 1) {
                if (A = D * $, this.needsDecode)
                  for (_ = 0; _ < A; ++_)
                    I[_] = R[_] - 1 & 255;
                else
                  for (_ = 0; _ < A; ++_)
                    I[_] = -R[_] & 255;
                return;
              }
              this.needsDecode && this.decodeBuffer(R), A = D * $;
              const k = 255 / ((1 << K) - 1);
              for (_ = 0; _ < A; ++_)
                I[_] = k * R[_];
            }
            createBitmap(I, O, D, $) {
              const K = new OffscreenCanvas(O, D), H = K.getContext("2d");
              let B;
              I === s.ImageKind.RGBA_32BPP ? B = new ImageData($, O, D) : (B = H.createImageData(O, D), (0, h.convertToRGBA)({
                kind: I,
                src: $,
                dest: new Uint32Array(B.data.buffer),
                width: O,
                height: D,
                inverseDecode: this.needsDecode
              })), H.putImageData(B, 0, 0);
              const R = K.transferToImageBitmap();
              return {
                data: null,
                width: O,
                height: D,
                bitmap: R,
                interpolate: this.interpolate
              };
            }
            getImageBytes(I, {
              drawWidth: O,
              drawHeight: D,
              forceRGBA: $ = !1,
              forceRGB: K = !1,
              internal: H = !1
            }) {
              this.image.reset(), this.image.drawWidth = O || this.width, this.image.drawHeight = D || this.height, this.image.forceRGBA = !!$, this.image.forceRGB = !!K;
              const B = this.image.getBytes(I);
              return H || this.image instanceof i.DecodeStream ? B : ((0, s.assert)(B instanceof Uint8Array, 'PDFImage.getImageBytes: Unsupported "imageBytes" type.'), new Uint8Array(B));
            }
          }
          c.PDFImage = b;
        },
        /* 66 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.Catalog = void 0;
          var s = f(3), h = f(2), g = f(4), t = f(67), i = f(5), m = f(68), v = f(12), E = f(69), S = f(59), y = f(70), x = f(72);
          function b(I) {
            return I instanceof g.Dict && (I = I.get("D")), Array.isArray(I) ? I : null;
          }
          class u {
            constructor(O, D) {
              if (this.pdfManager = O, this.xref = D, this._catDict = D.getCatalogObj(), !(this._catDict instanceof g.Dict))
                throw new h.FormatError("Catalog object is not a dictionary.");
              this.toplevelPagesDict, this._actualNumPages = null, this.fontCache = new g.RefSetCache(), this.builtInCMapCache = /* @__PURE__ */ new Map(), this.standardFontDataCache = /* @__PURE__ */ new Map(), this.globalImageCache = new S.GlobalImageCache(), this.pageKidsCountCache = new g.RefSetCache(), this.pageIndexCache = new g.RefSetCache(), this.nonBlendModesSet = new g.RefSet(), this.systemFontCache = /* @__PURE__ */ new Map();
            }
            cloneDict() {
              return this._catDict.clone();
            }
            get version() {
              const O = this._catDict.get("Version");
              if (O instanceof g.Name) {
                if (s.PDF_VERSION_REGEXP.test(O.name))
                  return (0, h.shadow)(this, "version", O.name);
                (0, h.warn)(`Invalid PDF catalog version: ${O.name}`);
              }
              return (0, h.shadow)(this, "version", null);
            }
            get lang() {
              const O = this._catDict.get("Lang");
              return (0, h.shadow)(this, "lang", typeof O == "string" ? (0, h.stringToPDFString)(O) : null);
            }
            get needsRendering() {
              const O = this._catDict.get("NeedsRendering");
              return (0, h.shadow)(this, "needsRendering", typeof O == "boolean" ? O : !1);
            }
            get collection() {
              let O = null;
              try {
                const D = this._catDict.get("Collection");
                D instanceof g.Dict && D.size > 0 && (O = D);
              } catch (D) {
                if (D instanceof s.MissingDataException)
                  throw D;
                (0, h.info)("Cannot fetch Collection entry; assuming no collection is present.");
              }
              return (0, h.shadow)(this, "collection", O);
            }
            get acroForm() {
              let O = null;
              try {
                const D = this._catDict.get("AcroForm");
                D instanceof g.Dict && D.size > 0 && (O = D);
              } catch (D) {
                if (D instanceof s.MissingDataException)
                  throw D;
                (0, h.info)("Cannot fetch AcroForm entry; assuming no forms are present.");
              }
              return (0, h.shadow)(this, "acroForm", O);
            }
            get acroFormRef() {
              const O = this._catDict.getRaw("AcroForm");
              return (0, h.shadow)(this, "acroFormRef", O instanceof g.Ref ? O : null);
            }
            get metadata() {
              var $;
              const O = this._catDict.getRaw("Metadata");
              if (!(O instanceof g.Ref))
                return (0, h.shadow)(this, "metadata", null);
              let D = null;
              try {
                const K = this.xref.fetch(O, !(($ = this.xref.encrypt) != null && $.encryptMetadata));
                if (K instanceof i.BaseStream && K.dict instanceof g.Dict) {
                  const H = K.dict.get("Type"), B = K.dict.get("Subtype");
                  if ((0, g.isName)(H, "Metadata") && (0, g.isName)(B, "XML")) {
                    const R = (0, h.stringToUTF8String)(K.getString());
                    R && (D = new y.MetadataParser(R).serializable);
                  }
                }
              } catch (K) {
                if (K instanceof s.MissingDataException)
                  throw K;
                (0, h.info)(`Skipping invalid Metadata: "${K}".`);
              }
              return (0, h.shadow)(this, "metadata", D);
            }
            get markInfo() {
              let O = null;
              try {
                O = this._readMarkInfo();
              } catch (D) {
                if (D instanceof s.MissingDataException)
                  throw D;
                (0, h.warn)("Unable to read mark info.");
              }
              return (0, h.shadow)(this, "markInfo", O);
            }
            _readMarkInfo() {
              const O = this._catDict.get("MarkInfo");
              if (!(O instanceof g.Dict))
                return null;
              const D = {
                Marked: !1,
                UserProperties: !1,
                Suspects: !1
              };
              for (const $ in D) {
                const K = O.get($);
                typeof K == "boolean" && (D[$] = K);
              }
              return D;
            }
            get structTreeRoot() {
              let O = null;
              try {
                O = this._readStructTreeRoot();
              } catch (D) {
                if (D instanceof s.MissingDataException)
                  throw D;
                (0, h.warn)("Unable read to structTreeRoot info.");
              }
              return (0, h.shadow)(this, "structTreeRoot", O);
            }
            _readStructTreeRoot() {
              const O = this._catDict.getRaw("StructTreeRoot"), D = this.xref.fetchIfRef(O);
              if (!(D instanceof g.Dict))
                return null;
              const $ = new x.StructTreeRoot(D, O);
              return $.init(), $;
            }
            get toplevelPagesDict() {
              const O = this._catDict.get("Pages");
              if (!(O instanceof g.Dict))
                throw new h.FormatError("Invalid top-level pages dictionary.");
              return (0, h.shadow)(this, "toplevelPagesDict", O);
            }
            get documentOutline() {
              let O = null;
              try {
                O = this._readDocumentOutline();
              } catch (D) {
                if (D instanceof s.MissingDataException)
                  throw D;
                (0, h.warn)("Unable to read document outline.");
              }
              return (0, h.shadow)(this, "documentOutline", O);
            }
            _readDocumentOutline() {
              let O = this._catDict.get("Outlines");
              if (!(O instanceof g.Dict) || (O = O.getRaw("First"), !(O instanceof g.Ref)))
                return null;
              const D = {
                items: []
              }, $ = [{
                obj: O,
                parent: D
              }], K = new g.RefSet();
              K.put(O);
              const H = this.xref, B = new Uint8ClampedArray(3);
              for (; $.length > 0; ) {
                const R = $.shift(), _ = H.fetchIfRef(R.obj);
                if (_ === null)
                  continue;
                if (!_.has("Title"))
                  throw new h.FormatError("Invalid outline item encountered.");
                const A = {
                  url: null,
                  dest: null,
                  action: null
                };
                u.parseDestDictionary({
                  destDict: _,
                  resultObj: A,
                  docBaseUrl: this.baseUrl,
                  docAttachments: this.attachments
                });
                const k = _.get("Title"), z = _.get("F") || 0, T = _.getArray("C"), w = _.get("Count");
                let F = B;
                Array.isArray(T) && T.length === 3 && (T[0] !== 0 || T[1] !== 0 || T[2] !== 0) && (F = v.ColorSpace.singletons.rgb.getRgb(T, 0));
                const j = {
                  action: A.action,
                  attachment: A.attachment,
                  dest: A.dest,
                  url: A.url,
                  unsafeUrl: A.unsafeUrl,
                  newWindow: A.newWindow,
                  setOCGState: A.setOCGState,
                  title: (0, h.stringToPDFString)(k),
                  color: F,
                  count: Number.isInteger(w) ? w : void 0,
                  bold: !!(z & 2),
                  italic: !!(z & 1),
                  items: []
                };
                R.parent.items.push(j), O = _.getRaw("First"), O instanceof g.Ref && !K.has(O) && ($.push({
                  obj: O,
                  parent: j
                }), K.put(O)), O = _.getRaw("Next"), O instanceof g.Ref && !K.has(O) && ($.push({
                  obj: O,
                  parent: R.parent
                }), K.put(O));
              }
              return D.items.length > 0 ? D.items : null;
            }
            get permissions() {
              let O = null;
              try {
                O = this._readPermissions();
              } catch (D) {
                if (D instanceof s.MissingDataException)
                  throw D;
                (0, h.warn)("Unable to read permissions.");
              }
              return (0, h.shadow)(this, "permissions", O);
            }
            _readPermissions() {
              const O = this.xref.trailer.get("Encrypt");
              if (!(O instanceof g.Dict))
                return null;
              let D = O.get("P");
              if (typeof D != "number")
                return null;
              D += 4294967296;
              const $ = [];
              for (const K in h.PermissionFlag) {
                const H = h.PermissionFlag[K];
                D & H && $.push(H);
              }
              return $;
            }
            get optionalContentConfig() {
              let O = null;
              try {
                const D = this._catDict.get("OCProperties");
                if (!D)
                  return (0, h.shadow)(this, "optionalContentConfig", null);
                const $ = D.get("D");
                if (!$)
                  return (0, h.shadow)(this, "optionalContentConfig", null);
                const K = D.get("OCGs");
                if (!Array.isArray(K))
                  return (0, h.shadow)(this, "optionalContentConfig", null);
                const H = [], B = [];
                for (const R of K) {
                  if (!(R instanceof g.Ref))
                    continue;
                  B.push(R);
                  const _ = this.xref.fetchIfRef(R);
                  H.push({
                    id: R.toString(),
                    name: typeof _.get("Name") == "string" ? (0, h.stringToPDFString)(_.get("Name")) : null,
                    intent: typeof _.get("Intent") == "string" ? (0, h.stringToPDFString)(_.get("Intent")) : null
                  });
                }
                O = this._readOptionalContentConfig($, B), O.groups = H;
              } catch (D) {
                if (D instanceof s.MissingDataException)
                  throw D;
                (0, h.warn)(`Unable to read optional content config: ${D}`);
              }
              return (0, h.shadow)(this, "optionalContentConfig", O);
            }
            _readOptionalContentConfig(O, D) {
              function $(A) {
                const k = [];
                if (Array.isArray(A))
                  for (const z of A)
                    z instanceof g.Ref && D.includes(z) && k.push(z.toString());
                return k;
              }
              function K(A, k = 0) {
                if (!Array.isArray(A))
                  return null;
                const z = [];
                for (const w of A) {
                  if (w instanceof g.Ref && D.includes(w)) {
                    R.put(w), z.push(w.toString());
                    continue;
                  }
                  const F = H(w, k);
                  F && z.push(F);
                }
                if (k > 0)
                  return z;
                const T = [];
                for (const w of D)
                  R.has(w) || T.push(w.toString());
                return T.length && z.push({
                  name: null,
                  order: T
                }), z;
              }
              function H(A, k) {
                if (++k > _)
                  return (0, h.warn)("parseNestedOrder - reached MAX_NESTED_LEVELS."), null;
                const z = B.fetchIfRef(A);
                if (!Array.isArray(z))
                  return null;
                const T = B.fetchIfRef(z[0]);
                if (typeof T != "string")
                  return null;
                const w = K(z.slice(1), k);
                return !w || !w.length ? null : {
                  name: (0, h.stringToPDFString)(T),
                  order: w
                };
              }
              const B = this.xref, R = new g.RefSet(), _ = 10;
              return {
                name: typeof O.get("Name") == "string" ? (0, h.stringToPDFString)(O.get("Name")) : null,
                creator: typeof O.get("Creator") == "string" ? (0, h.stringToPDFString)(O.get("Creator")) : null,
                baseState: O.get("BaseState") instanceof g.Name ? O.get("BaseState").name : null,
                on: $(O.get("ON")),
                off: $(O.get("OFF")),
                order: K(O.get("Order")),
                groups: null
              };
            }
            setActualNumPages(O = null) {
              this._actualNumPages = O;
            }
            get hasActualNumPages() {
              return this._actualNumPages !== null;
            }
            get _pagesCount() {
              const O = this.toplevelPagesDict.get("Count");
              if (!Number.isInteger(O))
                throw new h.FormatError("Page count in top-level pages dictionary is not an integer.");
              return (0, h.shadow)(this, "_pagesCount", O);
            }
            get numPages() {
              return this.hasActualNumPages ? this._actualNumPages : this._pagesCount;
            }
            get destinations() {
              const O = this._readDests(), D = /* @__PURE__ */ Object.create(null);
              if (O instanceof t.NameTree)
                for (const [$, K] of O.getAll()) {
                  const H = b(K);
                  H && (D[(0, h.stringToPDFString)($)] = H);
                }
              else O instanceof g.Dict && O.forEach(function($, K) {
                const H = b(K);
                H && (D[$] = H);
              });
              return (0, h.shadow)(this, "destinations", D);
            }
            getDestination(O) {
              const D = this._readDests();
              if (D instanceof t.NameTree) {
                const $ = b(D.get(O));
                if ($)
                  return $;
                const K = this.destinations[O];
                if (K)
                  return (0, h.warn)(`Found "${O}" at an incorrect position in the NameTree.`), K;
              } else if (D instanceof g.Dict) {
                const $ = b(D.get(O));
                if ($)
                  return $;
              }
              return null;
            }
            _readDests() {
              const O = this._catDict.get("Names");
              if (O != null && O.has("Dests"))
                return new t.NameTree(O.getRaw("Dests"), this.xref);
              if (this._catDict.has("Dests"))
                return this._catDict.get("Dests");
            }
            get pageLabels() {
              let O = null;
              try {
                O = this._readPageLabels();
              } catch (D) {
                if (D instanceof s.MissingDataException)
                  throw D;
                (0, h.warn)("Unable to read page labels.");
              }
              return (0, h.shadow)(this, "pageLabels", O);
            }
            _readPageLabels() {
              const O = this._catDict.getRaw("PageLabels");
              if (!O)
                return null;
              const D = new Array(this.numPages);
              let $ = null, K = "";
              const B = new t.NumberTree(O, this.xref).getAll();
              let R = "", _ = 1;
              for (let A = 0, k = this.numPages; A < k; A++) {
                const z = B.get(A);
                if (z !== void 0) {
                  if (!(z instanceof g.Dict))
                    throw new h.FormatError("PageLabel is not a dictionary.");
                  if (z.has("Type") && !(0, g.isName)(z.get("Type"), "PageLabel"))
                    throw new h.FormatError("Invalid type in PageLabel dictionary.");
                  if (z.has("S")) {
                    const T = z.get("S");
                    if (!(T instanceof g.Name))
                      throw new h.FormatError("Invalid style in PageLabel dictionary.");
                    $ = T.name;
                  } else
                    $ = null;
                  if (z.has("P")) {
                    const T = z.get("P");
                    if (typeof T != "string")
                      throw new h.FormatError("Invalid prefix in PageLabel dictionary.");
                    K = (0, h.stringToPDFString)(T);
                  } else
                    K = "";
                  if (z.has("St")) {
                    const T = z.get("St");
                    if (!(Number.isInteger(T) && T >= 1))
                      throw new h.FormatError("Invalid start in PageLabel dictionary.");
                    _ = T;
                  } else
                    _ = 1;
                }
                switch ($) {
                  case "D":
                    R = _;
                    break;
                  case "R":
                  case "r":
                    R = (0, s.toRomanNumerals)(_, $ === "r");
                    break;
                  case "A":
                  case "a":
                    const T = 26, j = $ === "a" ? 97 : 65, P = _ - 1;
                    R = String.fromCharCode(j + P % T).repeat(Math.floor(P / T) + 1);
                    break;
                  default:
                    if ($)
                      throw new h.FormatError(`Invalid style "${$}" in PageLabel dictionary.`);
                    R = "";
                }
                D[A] = K + R, _++;
              }
              return D;
            }
            get pageLayout() {
              const O = this._catDict.get("PageLayout");
              let D = "";
              if (O instanceof g.Name)
                switch (O.name) {
                  case "SinglePage":
                  case "OneColumn":
                  case "TwoColumnLeft":
                  case "TwoColumnRight":
                  case "TwoPageLeft":
                  case "TwoPageRight":
                    D = O.name;
                }
              return (0, h.shadow)(this, "pageLayout", D);
            }
            get pageMode() {
              const O = this._catDict.get("PageMode");
              let D = "UseNone";
              if (O instanceof g.Name)
                switch (O.name) {
                  case "UseNone":
                  case "UseOutlines":
                  case "UseThumbs":
                  case "FullScreen":
                  case "UseOC":
                  case "UseAttachments":
                    D = O.name;
                }
              return (0, h.shadow)(this, "pageMode", D);
            }
            get viewerPreferences() {
              const O = this._catDict.get("ViewerPreferences");
              if (!(O instanceof g.Dict))
                return (0, h.shadow)(this, "viewerPreferences", null);
              let D = null;
              for (const $ of O.getKeys()) {
                const K = O.get($);
                let H;
                switch ($) {
                  case "HideToolbar":
                  case "HideMenubar":
                  case "HideWindowUI":
                  case "FitWindow":
                  case "CenterWindow":
                  case "DisplayDocTitle":
                  case "PickTrayByPDFSize":
                    typeof K == "boolean" && (H = K);
                    break;
                  case "NonFullScreenPageMode":
                    if (K instanceof g.Name)
                      switch (K.name) {
                        case "UseNone":
                        case "UseOutlines":
                        case "UseThumbs":
                        case "UseOC":
                          H = K.name;
                          break;
                        default:
                          H = "UseNone";
                      }
                    break;
                  case "Direction":
                    if (K instanceof g.Name)
                      switch (K.name) {
                        case "L2R":
                        case "R2L":
                          H = K.name;
                          break;
                        default:
                          H = "L2R";
                      }
                    break;
                  case "ViewArea":
                  case "ViewClip":
                  case "PrintArea":
                  case "PrintClip":
                    if (K instanceof g.Name)
                      switch (K.name) {
                        case "MediaBox":
                        case "CropBox":
                        case "BleedBox":
                        case "TrimBox":
                        case "ArtBox":
                          H = K.name;
                          break;
                        default:
                          H = "CropBox";
                      }
                    break;
                  case "PrintScaling":
                    if (K instanceof g.Name)
                      switch (K.name) {
                        case "None":
                        case "AppDefault":
                          H = K.name;
                          break;
                        default:
                          H = "AppDefault";
                      }
                    break;
                  case "Duplex":
                    if (K instanceof g.Name)
                      switch (K.name) {
                        case "Simplex":
                        case "DuplexFlipShortEdge":
                        case "DuplexFlipLongEdge":
                          H = K.name;
                          break;
                        default:
                          H = "None";
                      }
                    break;
                  case "PrintPageRange":
                    Array.isArray(K) && K.length % 2 === 0 && K.every((R, _, A) => Number.isInteger(R) && R > 0 && (_ === 0 || R >= A[_ - 1]) && R <= this.numPages) && (H = K);
                    break;
                  case "NumCopies":
                    Number.isInteger(K) && K > 0 && (H = K);
                    break;
                  default:
                    (0, h.warn)(`Ignoring non-standard key in ViewerPreferences: ${$}.`);
                    continue;
                }
                if (H === void 0) {
                  (0, h.warn)(`Bad value, for key "${$}", in ViewerPreferences: ${K}.`);
                  continue;
                }
                D || (D = /* @__PURE__ */ Object.create(null)), D[$] = H;
              }
              return (0, h.shadow)(this, "viewerPreferences", D);
            }
            get openAction() {
              const O = this._catDict.get("OpenAction"), D = /* @__PURE__ */ Object.create(null);
              if (O instanceof g.Dict) {
                const $ = new g.Dict(this.xref);
                $.set("A", O);
                const K = {
                  url: null,
                  dest: null,
                  action: null
                };
                u.parseDestDictionary({
                  destDict: $,
                  resultObj: K
                }), Array.isArray(K.dest) ? D.dest = K.dest : K.action && (D.action = K.action);
              } else Array.isArray(O) && (D.dest = O);
              return (0, h.shadow)(this, "openAction", (0, h.objectSize)(D) > 0 ? D : null);
            }
            get attachments() {
              const O = this._catDict.get("Names");
              let D = null;
              if (O instanceof g.Dict && O.has("EmbeddedFiles")) {
                const $ = new t.NameTree(O.getRaw("EmbeddedFiles"), this.xref);
                for (const [K, H] of $.getAll()) {
                  const B = new E.FileSpec(H, this.xref);
                  D || (D = /* @__PURE__ */ Object.create(null)), D[(0, h.stringToPDFString)(K)] = B.serializable;
                }
              }
              return (0, h.shadow)(this, "attachments", D);
            }
            get xfaImages() {
              const O = this._catDict.get("Names");
              let D = null;
              if (O instanceof g.Dict && O.has("XFAImages")) {
                const $ = new t.NameTree(O.getRaw("XFAImages"), this.xref);
                for (const [K, H] of $.getAll())
                  D || (D = new g.Dict(this.xref)), D.set((0, h.stringToPDFString)(K), H);
              }
              return (0, h.shadow)(this, "xfaImages", D);
            }
            _collectJavaScript() {
              const O = this._catDict.get("Names");
              let D = null;
              function $(H, B) {
                if (!(B instanceof g.Dict) || !(0, g.isName)(B.get("S"), "JavaScript"))
                  return;
                let R = B.get("JS");
                if (R instanceof i.BaseStream)
                  R = R.getString();
                else if (typeof R != "string")
                  return;
                R = (0, h.stringToPDFString)(R).replaceAll("\0", ""), R && (D || (D = /* @__PURE__ */ new Map())).set(H, R);
              }
              if (O instanceof g.Dict && O.has("JavaScript")) {
                const H = new t.NameTree(O.getRaw("JavaScript"), this.xref);
                for (const [B, R] of H.getAll())
                  $((0, h.stringToPDFString)(B), R);
              }
              const K = this._catDict.get("OpenAction");
              return K && $("OpenAction", K), D;
            }
            get jsActions() {
              const O = this._collectJavaScript();
              let D = (0, s.collectActions)(this.xref, this._catDict, h.DocumentActionEventType);
              if (O) {
                D || (D = /* @__PURE__ */ Object.create(null));
                for (const [$, K] of O)
                  $ in D ? D[$].push(K) : D[$] = [K];
              }
              return (0, h.shadow)(this, "jsActions", D);
            }
            async fontFallback(O, D) {
              const $ = await Promise.all(this.fontCache);
              for (const K of $)
                if (K.loadedName === O) {
                  K.fallback(D);
                  return;
                }
            }
            async cleanup(O = !1) {
              (0, m.clearGlobalCaches)(), this.globalImageCache.clear(O), this.pageKidsCountCache.clear(), this.pageIndexCache.clear(), this.nonBlendModesSet.clear();
              const D = await Promise.all(this.fontCache);
              for (const {
                dict: $
              } of D)
                delete $.cacheKey;
              this.fontCache.clear(), this.builtInCMapCache.clear(), this.standardFontDataCache.clear(), this.systemFontCache.clear();
            }
            async getPageDict(O) {
              const D = [this.toplevelPagesDict], $ = new g.RefSet(), K = this._catDict.getRaw("Pages");
              K instanceof g.Ref && $.put(K);
              const H = this.xref, B = this.pageKidsCountCache, R = this.pageIndexCache;
              let _ = 0;
              for (; D.length; ) {
                const A = D.pop();
                if (A instanceof g.Ref) {
                  const w = B.get(A);
                  if (w >= 0 && _ + w <= O) {
                    _ += w;
                    continue;
                  }
                  if ($.has(A))
                    throw new h.FormatError("Pages tree contains circular reference.");
                  $.put(A);
                  const F = await H.fetchAsync(A);
                  if (F instanceof g.Dict) {
                    let j = F.getRaw("Type");
                    if (j instanceof g.Ref && (j = await H.fetchAsync(j)), (0, g.isName)(j, "Page") || !F.has("Kids")) {
                      if (B.has(A) || B.put(A, 1), R.has(A) || R.put(A, _), _ === O)
                        return [F, A];
                      _++;
                      continue;
                    }
                  }
                  D.push(F);
                  continue;
                }
                if (!(A instanceof g.Dict))
                  throw new h.FormatError("Page dictionary kid reference points to wrong type of object.");
                const {
                  objId: k
                } = A;
                let z = A.getRaw("Count");
                if (z instanceof g.Ref && (z = await H.fetchAsync(z)), Number.isInteger(z) && z >= 0 && (k && !B.has(k) && B.put(k, z), _ + z <= O)) {
                  _ += z;
                  continue;
                }
                let T = A.getRaw("Kids");
                if (T instanceof g.Ref && (T = await H.fetchAsync(T)), !Array.isArray(T)) {
                  let w = A.getRaw("Type");
                  if (w instanceof g.Ref && (w = await H.fetchAsync(w)), (0, g.isName)(w, "Page") || !A.has("Kids")) {
                    if (_ === O)
                      return [A, null];
                    _++;
                    continue;
                  }
                  throw new h.FormatError("Page dictionary kids object is not an array.");
                }
                for (let w = T.length - 1; w >= 0; w--)
                  D.push(T[w]);
              }
              throw new Error(`Page index ${O} not found.`);
            }
            async getAllPageDicts(O = !1) {
              const {
                ignoreErrors: D
              } = this.pdfManager.evaluatorOptions, $ = [{
                currentNode: this.toplevelPagesDict,
                posInKids: 0
              }], K = new g.RefSet(), H = this._catDict.getRaw("Pages");
              H instanceof g.Ref && K.put(H);
              const B = /* @__PURE__ */ new Map(), R = this.xref, _ = this.pageIndexCache;
              let A = 0;
              function k(T, w) {
                w && !_.has(w) && _.put(w, A), B.set(A++, [T, w]);
              }
              function z(T) {
                if (T instanceof s.XRefEntryException && !O)
                  throw T;
                O && D && A === 0 && ((0, h.warn)(`getAllPageDicts - Skipping invalid first page: "${T}".`), T = g.Dict.empty), B.set(A++, [T, null]);
              }
              for (; $.length > 0; ) {
                const T = $.at(-1), {
                  currentNode: w,
                  posInKids: F
                } = T;
                let j = w.getRaw("Kids");
                if (j instanceof g.Ref)
                  try {
                    j = await R.fetchAsync(j);
                  } catch (ne) {
                    z(ne);
                    break;
                  }
                if (!Array.isArray(j)) {
                  z(new h.FormatError("Page dictionary kids object is not an array."));
                  break;
                }
                if (F >= j.length) {
                  $.pop();
                  continue;
                }
                const P = j[F];
                let V;
                if (P instanceof g.Ref) {
                  if (K.has(P)) {
                    z(new h.FormatError("Pages tree contains circular reference."));
                    break;
                  }
                  K.put(P);
                  try {
                    V = await R.fetchAsync(P);
                  } catch (ne) {
                    z(ne);
                    break;
                  }
                } else
                  V = P;
                if (!(V instanceof g.Dict)) {
                  z(new h.FormatError("Page dictionary kid reference points to wrong type of object."));
                  break;
                }
                let J = V.getRaw("Type");
                if (J instanceof g.Ref)
                  try {
                    J = await R.fetchAsync(J);
                  } catch (ne) {
                    z(ne);
                    break;
                  }
                (0, g.isName)(J, "Page") || !V.has("Kids") ? k(V, P instanceof g.Ref ? P : null) : $.push({
                  currentNode: V,
                  posInKids: 0
                }), T.posInKids++;
              }
              return B;
            }
            getPageIndex(O) {
              const D = this.pageIndexCache.get(O);
              if (D !== void 0)
                return Promise.resolve(D);
              const $ = this.xref;
              function K(R) {
                let _ = 0, A;
                return $.fetchAsync(R).then(function(k) {
                  if ((0, g.isRefsEqual)(R, O) && !(0, g.isDict)(k, "Page") && !(k instanceof g.Dict && !k.has("Type") && k.has("Contents")))
                    throw new h.FormatError("The reference does not point to a /Page dictionary.");
                  if (!k)
                    return null;
                  if (!(k instanceof g.Dict))
                    throw new h.FormatError("Node must be a dictionary.");
                  return A = k.getRaw("Parent"), k.getAsync("Parent");
                }).then(function(k) {
                  if (!k)
                    return null;
                  if (!(k instanceof g.Dict))
                    throw new h.FormatError("Parent must be a dictionary.");
                  return k.getAsync("Kids");
                }).then(function(k) {
                  if (!k)
                    return null;
                  const z = [];
                  let T = !1;
                  for (const w of k) {
                    if (!(w instanceof g.Ref))
                      throw new h.FormatError("Kid must be a reference.");
                    if ((0, g.isRefsEqual)(w, R)) {
                      T = !0;
                      break;
                    }
                    z.push($.fetchAsync(w).then(function(F) {
                      if (!(F instanceof g.Dict))
                        throw new h.FormatError("Kid node must be a dictionary.");
                      F.has("Count") ? _ += F.get("Count") : _++;
                    }));
                  }
                  if (!T)
                    throw new h.FormatError("Kid reference not found in parent's kids.");
                  return Promise.all(z).then(function() {
                    return [_, A];
                  });
                });
              }
              let H = 0;
              const B = (R) => K(R).then((_) => {
                if (!_)
                  return this.pageIndexCache.put(O, H), H;
                const [A, k] = _;
                return H += A, B(k);
              });
              return B(O);
            }
            get baseUrl() {
              const O = this._catDict.get("URI");
              if (O instanceof g.Dict) {
                const D = O.get("Base");
                if (typeof D == "string") {
                  const $ = (0, h.createValidAbsoluteUrl)(D, null, {
                    tryConvertEncoding: !0
                  });
                  if ($)
                    return (0, h.shadow)(this, "baseUrl", $.href);
                }
              }
              return (0, h.shadow)(this, "baseUrl", this.pdfManager.docBaseUrl);
            }
            static parseDestDictionary({
              destDict: O,
              resultObj: D,
              docBaseUrl: $ = null,
              docAttachments: K = null
            }) {
              if (!(O instanceof g.Dict)) {
                (0, h.warn)("parseDestDictionary: `destDict` must be a dictionary.");
                return;
              }
              let H = O.get("A"), B, R;
              if (H instanceof g.Dict || (O.has("Dest") ? H = O.get("Dest") : (H = O.get("AA"), H instanceof g.Dict && (H.has("D") ? H = H.get("D") : H.has("U") && (H = H.get("U"))))), H instanceof g.Dict) {
                const _ = H.get("S");
                if (!(_ instanceof g.Name)) {
                  (0, h.warn)("parseDestDictionary: Invalid type in Action dictionary.");
                  return;
                }
                const A = _.name;
                switch (A) {
                  case "ResetForm":
                    const k = H.get("Flags"), z = ((typeof k == "number" ? k : 0) & 1) === 0, T = [], w = [];
                    for (const oe of H.get("Fields") || [])
                      oe instanceof g.Ref ? w.push(oe.toString()) : typeof oe == "string" && T.push((0, h.stringToPDFString)(oe));
                    D.resetForm = {
                      fields: T,
                      refs: w,
                      include: z
                    };
                    break;
                  case "URI":
                    B = H.get("URI"), B instanceof g.Name && (B = "/" + B.name);
                    break;
                  case "GoTo":
                    R = H.get("D");
                    break;
                  case "Launch":
                  case "GoToR":
                    const F = H.get("F");
                    F instanceof g.Dict ? B = F.get("F") || null : typeof F == "string" && (B = F);
                    let j = H.get("D");
                    if (j && (j instanceof g.Name && (j = j.name), typeof B == "string")) {
                      const oe = B.split("#")[0];
                      typeof j == "string" ? B = oe + "#" + j : Array.isArray(j) && (B = oe + "#" + JSON.stringify(j));
                    }
                    const P = H.get("NewWindow");
                    typeof P == "boolean" && (D.newWindow = P);
                    break;
                  case "GoToE":
                    const V = H.get("T");
                    let J;
                    if (K && V instanceof g.Dict) {
                      const oe = V.get("R"), fe = V.get("N");
                      (0, g.isName)(oe, "C") && typeof fe == "string" && (J = K[(0, h.stringToPDFString)(fe)]);
                    }
                    J ? D.attachment = J : (0, h.warn)('parseDestDictionary - unimplemented "GoToE" action.');
                    break;
                  case "Named":
                    const ne = H.get("N");
                    ne instanceof g.Name && (D.action = ne.name);
                    break;
                  case "SetOCGState":
                    const Z = H.get("State"), te = H.get("PreserveRB");
                    if (!Array.isArray(Z) || Z.length === 0)
                      break;
                    const G = [];
                    for (const oe of Z)
                      if (oe instanceof g.Name)
                        switch (oe.name) {
                          case "ON":
                          case "OFF":
                          case "Toggle":
                            G.push(oe.name);
                            break;
                        }
                      else oe instanceof g.Ref && G.push(oe.toString());
                    if (G.length !== Z.length)
                      break;
                    D.setOCGState = {
                      state: G,
                      preserveRB: typeof te == "boolean" ? te : !0
                    };
                    break;
                  case "JavaScript":
                    const N = H.get("JS");
                    let q;
                    N instanceof i.BaseStream ? q = N.getString() : typeof N == "string" && (q = N);
                    const ie = q && (0, s.recoverJsURL)((0, h.stringToPDFString)(q));
                    if (ie) {
                      B = ie.url, D.newWindow = ie.newWindow;
                      break;
                    }
                  default:
                    if (A === "JavaScript" || A === "SubmitForm")
                      break;
                    (0, h.warn)(`parseDestDictionary - unsupported action: "${A}".`);
                    break;
                }
              } else O.has("Dest") && (R = O.get("Dest"));
              if (typeof B == "string") {
                const _ = (0, h.createValidAbsoluteUrl)(B, $, {
                  addDefaultProtocol: !0,
                  tryConvertEncoding: !0
                });
                _ && (D.url = _.href), D.unsafeUrl = B;
              }
              R && (R instanceof g.Name && (R = R.name), typeof R == "string" ? D.dest = (0, h.stringToPDFString)(R) : Array.isArray(R) && (D.dest = R));
            }
          }
          c.Catalog = u;
        },
        /* 67 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.NumberTree = c.NameTree = void 0;
          var s = f(4), h = f(2);
          class g {
            constructor(v, E, S) {
              this.constructor === g && (0, h.unreachable)("Cannot initialize NameOrNumberTree."), this.root = v, this.xref = E, this._type = S;
            }
            getAll() {
              const v = /* @__PURE__ */ new Map();
              if (!this.root)
                return v;
              const E = this.xref, S = new s.RefSet();
              S.put(this.root);
              const y = [this.root];
              for (; y.length > 0; ) {
                const x = E.fetchIfRef(y.shift());
                if (!(x instanceof s.Dict))
                  continue;
                if (x.has("Kids")) {
                  const u = x.get("Kids");
                  if (!Array.isArray(u))
                    continue;
                  for (const I of u) {
                    if (S.has(I))
                      throw new h.FormatError(`Duplicate entry in "${this._type}" tree.`);
                    y.push(I), S.put(I);
                  }
                  continue;
                }
                const b = x.get(this._type);
                if (Array.isArray(b))
                  for (let u = 0, I = b.length; u < I; u += 2)
                    v.set(E.fetchIfRef(b[u]), E.fetchIfRef(b[u + 1]));
              }
              return v;
            }
            get(v) {
              if (!this.root)
                return null;
              const E = this.xref;
              let S = E.fetchIfRef(this.root), y = 0;
              const x = 10;
              for (; S.has("Kids"); ) {
                if (++y > x)
                  return (0, h.warn)(`Search depth limit reached for "${this._type}" tree.`), null;
                const u = S.get("Kids");
                if (!Array.isArray(u))
                  return null;
                let I = 0, O = u.length - 1;
                for (; I <= O; ) {
                  const D = I + O >> 1, $ = E.fetchIfRef(u[D]), K = $.get("Limits");
                  if (v < E.fetchIfRef(K[0]))
                    O = D - 1;
                  else if (v > E.fetchIfRef(K[1]))
                    I = D + 1;
                  else {
                    S = $;
                    break;
                  }
                }
                if (I > O)
                  return null;
              }
              const b = S.get(this._type);
              if (Array.isArray(b)) {
                let u = 0, I = b.length - 2;
                for (; u <= I; ) {
                  const O = u + I >> 1, D = O + (O & 1), $ = E.fetchIfRef(b[D]);
                  if (v < $)
                    I = D - 2;
                  else if (v > $)
                    u = D + 2;
                  else
                    return E.fetchIfRef(b[D + 1]);
                }
              }
              return null;
            }
          }
          class t extends g {
            constructor(v, E) {
              super(v, E, "Names");
            }
          }
          c.NameTree = t;
          class i extends g {
            constructor(v, E) {
              super(v, E, "Nums");
            }
          }
          c.NumberTree = i;
        },
        /* 68 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.clearGlobalCaches = t;
          var s = f(50), h = f(4), g = f(40);
          function t() {
            (0, s.clearPatternCaches)(), (0, h.clearPrimitiveCaches)(), (0, g.clearUnicodeCaches)();
          }
        },
        /* 69 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.FileSpec = void 0;
          var s = f(2), h = f(5), g = f(4);
          function t(m) {
            return m.has("UF") ? m.get("UF") : m.has("F") ? m.get("F") : m.has("Unix") ? m.get("Unix") : m.has("Mac") ? m.get("Mac") : m.has("DOS") ? m.get("DOS") : null;
          }
          class i {
            constructor(v, E) {
              v instanceof g.Dict && (this.xref = E, this.root = v, v.has("FS") && (this.fs = v.get("FS")), this.description = v.has("Desc") ? (0, s.stringToPDFString)(v.get("Desc")) : "", v.has("RF") && (0, s.warn)("Related file specifications are not supported"), this.contentAvailable = !0, v.has("EF") || (this.contentAvailable = !1, (0, s.warn)("Non-embedded file specifications are not supported")));
            }
            get filename() {
              if (!this._filename && this.root) {
                const v = t(this.root) || "unnamed";
                this._filename = (0, s.stringToPDFString)(v).replaceAll("\\\\", "\\").replaceAll("\\/", "/").replaceAll("\\", "/");
              }
              return this._filename;
            }
            get content() {
              if (!this.contentAvailable)
                return null;
              !this.contentRef && this.root && (this.contentRef = t(this.root.get("EF")));
              let v = null;
              if (this.contentRef) {
                const E = this.xref.fetchIfRef(this.contentRef);
                E instanceof h.BaseStream ? v = E.getBytes() : (0, s.warn)("Embedded file specification points to non-existing/invalid content");
              } else
                (0, s.warn)("Embedded file specification does not have a content");
              return v;
            }
            get serializable() {
              return {
                filename: this.filename,
                content: this.content
              };
            }
          }
          c.FileSpec = i;
        },
        /* 70 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.MetadataParser = void 0;
          var s = f(71);
          class h {
            constructor(t) {
              t = this._repair(t);
              const m = new s.SimpleXMLParser({
                lowerCaseName: !0
              }).parseFromString(t);
              this._metadataMap = /* @__PURE__ */ new Map(), this._data = t, m && this._parse(m);
            }
            _repair(t) {
              return t.replace(/^[^<]+/, "").replaceAll(/>\\376\\377([^<]+)/g, function(i, m) {
                const v = m.replaceAll(/\\([0-3])([0-7])([0-7])/g, function(S, y, x, b) {
                  return String.fromCharCode(y * 64 + x * 8 + b * 1);
                }).replaceAll(/&(amp|apos|gt|lt|quot);/g, function(S, y) {
                  switch (y) {
                    case "amp":
                      return "&";
                    case "apos":
                      return "'";
                    case "gt":
                      return ">";
                    case "lt":
                      return "<";
                    case "quot":
                      return '"';
                  }
                  throw new Error(`_repair: ${y} isn't defined.`);
                }), E = [">"];
                for (let S = 0, y = v.length; S < y; S += 2) {
                  const x = v.charCodeAt(S) * 256 + v.charCodeAt(S + 1);
                  x >= 32 && x < 127 && x !== 60 && x !== 62 && x !== 38 ? E.push(String.fromCharCode(x)) : E.push("&#x" + (65536 + x).toString(16).substring(1) + ";");
                }
                return E.join("");
              });
            }
            _getSequence(t) {
              const i = t.nodeName;
              return i !== "rdf:bag" && i !== "rdf:seq" && i !== "rdf:alt" ? null : t.childNodes.filter((m) => m.nodeName === "rdf:li");
            }
            _parseArray(t) {
              if (!t.hasChildNodes())
                return;
              const [i] = t.childNodes, m = this._getSequence(i) || [];
              this._metadataMap.set(t.nodeName, m.map((v) => v.textContent.trim()));
            }
            _parse(t) {
              let i = t.documentElement;
              if (i.nodeName !== "rdf:rdf")
                for (i = i.firstChild; i && i.nodeName !== "rdf:rdf"; )
                  i = i.nextSibling;
              if (!(!i || i.nodeName !== "rdf:rdf" || !i.hasChildNodes())) {
                for (const m of i.childNodes)
                  if (m.nodeName === "rdf:description")
                    for (const v of m.childNodes) {
                      const E = v.nodeName;
                      switch (E) {
                        case "#text":
                          continue;
                        case "dc:creator":
                        case "dc:subject":
                          this._parseArray(v);
                          continue;
                      }
                      this._metadataMap.set(E, v.textContent.trim());
                    }
              }
            }
            get serializable() {
              return {
                parsedData: this._metadataMap,
                rawData: this._data
              };
            }
          }
          c.MetadataParser = h;
        },
        /* 71 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.XMLParserErrorCode = c.XMLParserBase = c.SimpleXMLParser = c.SimpleDOMNode = void 0;
          var s = f(3);
          const h = {
            NoError: 0,
            EndOfDocument: -1,
            UnterminatedCdat: -2,
            UnterminatedXmlDeclaration: -3,
            UnterminatedDoctypeDeclaration: -4,
            UnterminatedComment: -5,
            MalformedElement: -6,
            OutOfMemory: -7,
            UnterminatedAttributeValue: -8,
            UnterminatedElement: -9,
            ElementNeverBegun: -10
          };
          c.XMLParserErrorCode = h;
          function g(E, S) {
            const y = E[S];
            return y === " " || y === `
` || y === "\r" || y === "	";
          }
          function t(E) {
            for (let S = 0, y = E.length; S < y; S++)
              if (!g(E, S))
                return !1;
            return !0;
          }
          class i {
            _resolveEntities(S) {
              return S.replaceAll(/&([^;]+);/g, (y, x) => {
                if (x.substring(0, 2) === "#x")
                  return String.fromCodePoint(parseInt(x.substring(2), 16));
                if (x.substring(0, 1) === "#")
                  return String.fromCodePoint(parseInt(x.substring(1), 10));
                switch (x) {
                  case "lt":
                    return "<";
                  case "gt":
                    return ">";
                  case "amp":
                    return "&";
                  case "quot":
                    return '"';
                  case "apos":
                    return "'";
                }
                return this.onResolveEntity(x);
              });
            }
            _parseContent(S, y) {
              const x = [];
              let b = y;
              function u() {
                for (; b < S.length && g(S, b); )
                  ++b;
              }
              for (; b < S.length && !g(S, b) && S[b] !== ">" && S[b] !== "/"; )
                ++b;
              const I = S.substring(y, b);
              for (u(); b < S.length && S[b] !== ">" && S[b] !== "/" && S[b] !== "?"; ) {
                u();
                let O = "", D = "";
                for (; b < S.length && !g(S, b) && S[b] !== "="; )
                  O += S[b], ++b;
                if (u(), S[b] !== "=")
                  return null;
                ++b, u();
                const $ = S[b];
                if ($ !== '"' && $ !== "'")
                  return null;
                const K = S.indexOf($, ++b);
                if (K < 0)
                  return null;
                D = S.substring(b, K), x.push({
                  name: O,
                  value: this._resolveEntities(D)
                }), b = K + 1, u();
              }
              return {
                name: I,
                attributes: x,
                parsed: b - y
              };
            }
            _parseProcessingInstruction(S, y) {
              let x = y;
              function b() {
                for (; x < S.length && g(S, x); )
                  ++x;
              }
              for (; x < S.length && !g(S, x) && S[x] !== ">" && S[x] !== "?" && S[x] !== "/"; )
                ++x;
              const u = S.substring(y, x);
              b();
              const I = x;
              for (; x < S.length && (S[x] !== "?" || S[x + 1] !== ">"); )
                ++x;
              const O = S.substring(I, x);
              return {
                name: u,
                value: O,
                parsed: x - y
              };
            }
            parseXml(S) {
              let y = 0;
              for (; y < S.length; ) {
                const x = S[y];
                let b = y;
                if (x === "<") {
                  ++b;
                  const u = S[b];
                  let I;
                  switch (u) {
                    case "/":
                      if (++b, I = S.indexOf(">", b), I < 0) {
                        this.onError(h.UnterminatedElement);
                        return;
                      }
                      this.onEndElement(S.substring(b, I)), b = I + 1;
                      break;
                    case "?":
                      ++b;
                      const O = this._parseProcessingInstruction(S, b);
                      if (S.substring(b + O.parsed, b + O.parsed + 2) !== "?>") {
                        this.onError(h.UnterminatedXmlDeclaration);
                        return;
                      }
                      this.onPi(O.name, O.value), b += O.parsed + 2;
                      break;
                    case "!":
                      if (S.substring(b + 1, b + 3) === "--") {
                        if (I = S.indexOf("-->", b + 3), I < 0) {
                          this.onError(h.UnterminatedComment);
                          return;
                        }
                        this.onComment(S.substring(b + 3, I)), b = I + 3;
                      } else if (S.substring(b + 1, b + 8) === "[CDATA[") {
                        if (I = S.indexOf("]]>", b + 8), I < 0) {
                          this.onError(h.UnterminatedCdat);
                          return;
                        }
                        this.onCdata(S.substring(b + 8, I)), b = I + 3;
                      } else if (S.substring(b + 1, b + 8) === "DOCTYPE") {
                        const K = S.indexOf("[", b + 8);
                        let H = !1;
                        if (I = S.indexOf(">", b + 8), I < 0) {
                          this.onError(h.UnterminatedDoctypeDeclaration);
                          return;
                        }
                        if (K > 0 && I > K) {
                          if (I = S.indexOf("]>", b + 8), I < 0) {
                            this.onError(h.UnterminatedDoctypeDeclaration);
                            return;
                          }
                          H = !0;
                        }
                        const B = S.substring(b + 8, I + (H ? 1 : 0));
                        this.onDoctype(B), b = I + (H ? 2 : 1);
                      } else {
                        this.onError(h.MalformedElement);
                        return;
                      }
                      break;
                    default:
                      const D = this._parseContent(S, b);
                      if (D === null) {
                        this.onError(h.MalformedElement);
                        return;
                      }
                      let $ = !1;
                      if (S.substring(b + D.parsed, b + D.parsed + 2) === "/>")
                        $ = !0;
                      else if (S.substring(b + D.parsed, b + D.parsed + 1) !== ">") {
                        this.onError(h.UnterminatedElement);
                        return;
                      }
                      this.onBeginElement(D.name, D.attributes, $), b += D.parsed + ($ ? 2 : 1);
                      break;
                  }
                } else {
                  for (; b < S.length && S[b] !== "<"; )
                    b++;
                  const u = S.substring(y, b);
                  this.onText(this._resolveEntities(u));
                }
                y = b;
              }
            }
            onResolveEntity(S) {
              return `&${S};`;
            }
            onPi(S, y) {
            }
            onComment(S) {
            }
            onCdata(S) {
            }
            onDoctype(S) {
            }
            onText(S) {
            }
            onBeginElement(S, y, x) {
            }
            onEndElement(S) {
            }
            onError(S) {
            }
          }
          c.XMLParserBase = i;
          class m {
            constructor(S, y) {
              this.nodeName = S, this.nodeValue = y, Object.defineProperty(this, "parentNode", {
                value: null,
                writable: !0
              });
            }
            get firstChild() {
              var S;
              return (S = this.childNodes) == null ? void 0 : S[0];
            }
            get nextSibling() {
              const S = this.parentNode.childNodes;
              if (!S)
                return;
              const y = S.indexOf(this);
              if (y !== -1)
                return S[y + 1];
            }
            get textContent() {
              return this.childNodes ? this.childNodes.map(function(S) {
                return S.textContent;
              }).join("") : this.nodeValue || "";
            }
            get children() {
              return this.childNodes || [];
            }
            hasChildNodes() {
              var S;
              return ((S = this.childNodes) == null ? void 0 : S.length) > 0;
            }
            searchNode(S, y) {
              var I;
              if (y >= S.length)
                return this;
              const x = S[y];
              if (x.name.startsWith("#") && y < S.length - 1)
                return this.searchNode(S, y + 1);
              const b = [];
              let u = this;
              for (; ; ) {
                if (x.name === u.nodeName)
                  if (x.pos === 0) {
                    const O = u.searchNode(S, y + 1);
                    if (O !== null)
                      return O;
                  } else {
                    if (b.length === 0)
                      return null;
                    {
                      const [O] = b.pop();
                      let D = 0;
                      for (const $ of O.childNodes)
                        if (x.name === $.nodeName) {
                          if (D === x.pos)
                            return $.searchNode(S, y + 1);
                          D++;
                        }
                      return u.searchNode(S, y + 1);
                    }
                  }
                if (((I = u.childNodes) == null ? void 0 : I.length) > 0)
                  b.push([u, 0]), u = u.childNodes[0];
                else {
                  if (b.length === 0)
                    return null;
                  for (; b.length !== 0; ) {
                    const [O, D] = b.pop(), $ = D + 1;
                    if ($ < O.childNodes.length) {
                      b.push([O, $]), u = O.childNodes[$];
                      break;
                    }
                  }
                  if (b.length === 0)
                    return null;
                }
              }
            }
            dump(S) {
              if (this.nodeName === "#text") {
                S.push((0, s.encodeToXmlString)(this.nodeValue));
                return;
              }
              if (S.push(`<${this.nodeName}`), this.attributes)
                for (const y of this.attributes)
                  S.push(` ${y.name}="${(0, s.encodeToXmlString)(y.value)}"`);
              if (this.hasChildNodes()) {
                S.push(">");
                for (const y of this.childNodes)
                  y.dump(S);
                S.push(`</${this.nodeName}>`);
              } else this.nodeValue ? S.push(`>${(0, s.encodeToXmlString)(this.nodeValue)}</${this.nodeName}>`) : S.push("/>");
            }
          }
          c.SimpleDOMNode = m;
          class v extends i {
            constructor({
              hasAttributes: S = !1,
              lowerCaseName: y = !1
            }) {
              super(), this._currentFragment = null, this._stack = null, this._errorCode = h.NoError, this._hasAttributes = S, this._lowerCaseName = y;
            }
            parseFromString(S) {
              if (this._currentFragment = [], this._stack = [], this._errorCode = h.NoError, this.parseXml(S), this._errorCode !== h.NoError)
                return;
              const [y] = this._currentFragment;
              if (y)
                return {
                  documentElement: y
                };
            }
            onText(S) {
              if (t(S))
                return;
              const y = new m("#text", S);
              this._currentFragment.push(y);
            }
            onCdata(S) {
              const y = new m("#text", S);
              this._currentFragment.push(y);
            }
            onBeginElement(S, y, x) {
              this._lowerCaseName && (S = S.toLowerCase());
              const b = new m(S);
              b.childNodes = [], this._hasAttributes && (b.attributes = y), this._currentFragment.push(b), !x && (this._stack.push(this._currentFragment), this._currentFragment = b.childNodes);
            }
            onEndElement(S) {
              this._currentFragment = this._stack.pop() || [];
              const y = this._currentFragment.at(-1);
              if (!y)
                return null;
              for (const x of y.childNodes)
                x.parentNode = y;
              return y;
            }
            onError(S) {
              this._errorCode = S;
            }
          }
          c.SimpleXMLParser = v;
        },
        /* 72 */
        /***/
        (d, c, f) => {
          var x, U2, u, Bd, z2, H2;
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.StructTreeRoot = c.StructTreePage = void 0;
          var s = f(2), h = f(4), g = f(67), t = f(73);
          const i = 40, m = {
            PAGE_CONTENT: 1,
            STREAM_CONTENT: 2,
            OBJECT: 3,
            ANNOTATION: 4,
            ELEMENT: 5
          }, $ = class $ {
            constructor(H, B) {
              zn(this, x);
              this.dict = H, this.ref = B instanceof h.Ref ? B : null, this.roleMap = /* @__PURE__ */ new Map(), this.structParentIds = null;
            }
            init() {
              this.readRoleMap();
            }
            addAnnotationIdToPage(H, B) {
              Nt(this, x, U2).call(this, H, B, m.ANNOTATION);
            }
            readRoleMap() {
              const H = this.dict.get("RoleMap");
              H instanceof h.Dict && H.forEach((B, R) => {
                R instanceof h.Name && this.roleMap.set(B, R.name);
              });
            }
            static async canCreateStructureTree({
              catalogRef: H,
              pdfManager: B,
              newAnnotationsByPage: R
            }) {
              var k;
              if (!(H instanceof h.Ref))
                return (0, s.warn)("Cannot save the struct tree: no catalog reference."), !1;
              let _ = 0, A = !0;
              for (const [z, T] of R) {
                const {
                  ref: w
                } = await B.getPage(z);
                if (!(w instanceof h.Ref)) {
                  (0, s.warn)(`Cannot save the struct tree: page ${z} has no ref.`), A = !0;
                  break;
                }
                for (const F of T)
                  (k = F.accessibilityData) != null && k.type && (F.parentTreeId = _++, A = !1);
              }
              if (A) {
                for (const z of R.values())
                  for (const T of z)
                    delete T.parentTreeId;
                return !1;
              }
              return !0;
            }
            static async createStructureTree({
              newAnnotationsByPage: H,
              xref: B,
              catalogRef: R,
              pdfManager: _,
              newRefs: A
            }) {
              const k = _.catalog.cloneDict(), z = B.getNewTemporaryRef();
              k.set("StructTreeRoot", z);
              const T = [];
              await (0, t.writeObject)(R, k, T, B), A.push({
                ref: R,
                data: T.join("")
              });
              const w = new h.Dict(B);
              w.set("Type", h.Name.get("StructTreeRoot"));
              const F = B.getNewTemporaryRef();
              w.set("ParentTree", F);
              const j = [];
              w.set("K", j);
              const P = new h.Dict(B), V = [];
              P.set("Nums", V);
              const J = await Nt(this, u, Bd).call(this, {
                newAnnotationsByPage: H,
                structTreeRootRef: z,
                kids: j,
                nums: V,
                xref: B,
                pdfManager: _,
                newRefs: A,
                buffer: T
              });
              w.set("ParentTreeNextKey", J), T.length = 0, await (0, t.writeObject)(F, P, T, B), A.push({
                ref: F,
                data: T.join("")
              }), T.length = 0, await (0, t.writeObject)(z, w, T, B), A.push({
                ref: z,
                data: T.join("")
              });
            }
            async canUpdateStructTree({
              pdfManager: H,
              newAnnotationsByPage: B
            }) {
              var T, w;
              if (!this.ref)
                return (0, s.warn)("Cannot update the struct tree: no root reference."), !1;
              let R = this.dict.get("ParentTreeNextKey");
              if (!Number.isInteger(R) || R < 0)
                return (0, s.warn)("Cannot update the struct tree: invalid next key."), !1;
              const _ = this.dict.get("ParentTree");
              if (!(_ instanceof h.Dict))
                return (0, s.warn)("Cannot update the struct tree: ParentTree isn't a dict."), !1;
              const A = _.get("Nums");
              if (!Array.isArray(A))
                return (0, s.warn)("Cannot update the struct tree: nums isn't an array."), !1;
              const {
                numPages: k
              } = H.catalog;
              for (const F of B.keys()) {
                const {
                  pageDict: j,
                  ref: P
                } = await H.getPage(F);
                if (!(P instanceof h.Ref))
                  return (0, s.warn)(`Cannot save the struct tree: page ${F} has no ref.`), !1;
                const V = j.get("StructParents");
                if (!Number.isInteger(V) || V < 0 || V >= k)
                  return (0, s.warn)(`Cannot save the struct tree: page ${F} has no id.`), !1;
              }
              let z = !0;
              for (const [F, j] of B) {
                const {
                  pageDict: P
                } = await H.getPage(F);
                Nt(T = $, u, z2).call(T, {
                  elements: j,
                  xref: this.dict.xref,
                  pageDict: P,
                  parentTree: _
                });
                for (const V of j)
                  (w = V.accessibilityData) != null && w.type && (V.parentTreeId = R++, z = !1);
              }
              if (z) {
                for (const F of B.values())
                  for (const j of F)
                    delete j.parentTreeId, delete j.structTreeParent;
                return !1;
              }
              return !0;
            }
            async updateStructureTree({
              newAnnotationsByPage: H,
              pdfManager: B,
              newRefs: R
            }) {
              var ne;
              const _ = this.dict.xref, A = this.dict.clone(), k = this.ref;
              let z = A.getRaw("ParentTree"), T;
              z instanceof h.Ref ? T = _.fetch(z) : (T = z, z = _.getNewTemporaryRef(), A.set("ParentTree", z)), T = T.clone();
              let w = T.getRaw("Nums"), F = null;
              w instanceof h.Ref && (F = w, w = _.fetch(F)), w = w.slice(), F || T.set("Nums", w);
              let j = A.getRaw("K"), P = null;
              j instanceof h.Ref ? (P = j, j = _.fetch(P)) : (P = _.getNewTemporaryRef(), A.set("K", P)), j = Array.isArray(j) ? j.slice() : [j];
              const V = [], J = await Nt(ne = $, u, Bd).call(ne, {
                newAnnotationsByPage: H,
                structTreeRootRef: k,
                kids: j,
                nums: w,
                xref: _,
                pdfManager: B,
                newRefs: R,
                buffer: V
              });
              A.set("ParentTreeNextKey", J), V.length = 0, await (0, t.writeObject)(P, j, V, _), R.push({
                ref: P,
                data: V.join("")
              }), F && (V.length = 0, await (0, t.writeObject)(F, w, V, _), R.push({
                ref: F,
                data: V.join("")
              })), V.length = 0, await (0, t.writeObject)(z, T, V, _), R.push({
                ref: z,
                data: V.join("")
              }), V.length = 0, await (0, t.writeObject)(k, A, V, _), R.push({
                ref: k,
                data: V.join("")
              });
            }
          };
          x = new WeakSet(), U2 = function(H, B, R) {
            if (!(H instanceof h.Ref) || B < 0)
              return;
            this.structParentIds || (this.structParentIds = new h.RefSetCache());
            let _ = this.structParentIds.get(H);
            _ || (_ = [], this.structParentIds.put(H, _)), _.push([B, R]);
          }, u = new WeakSet(), Bd = async function({
            newAnnotationsByPage: H,
            structTreeRootRef: B,
            kids: R,
            nums: _,
            xref: A,
            pdfManager: k,
            newRefs: z,
            buffer: T
          }) {
            const w = h.Name.get("OBJR");
            let F = -1 / 0;
            for (const [j, P] of H) {
              const {
                ref: V
              } = await k.getPage(j);
              for (const {
                accessibilityData: {
                  type: J,
                  title: ne,
                  lang: Z,
                  alt: te,
                  expanded: G,
                  actualText: N
                },
                ref: q,
                parentTreeId: ie,
                structTreeParent: oe
              } of P) {
                F = Math.max(F, ie);
                const fe = A.getNewTemporaryRef(), Y = new h.Dict(A);
                Y.set("S", h.Name.get(J)), ne && Y.set("T", ne), Z && Y.set("Lang", Z), te && Y.set("Alt", te), G && Y.set("E", G), N && Y.set("ActualText", N), oe ? await Nt(this, u, H2).call(this, {
                  structTreeParent: oe,
                  tagDict: Y,
                  newTagRef: fe,
                  fallbackRef: B,
                  xref: A,
                  newRefs: z,
                  buffer: T
                }) : Y.set("P", B);
                const ae = new h.Dict(A);
                Y.set("K", ae), ae.set("Type", w), ae.set("Pg", V), ae.set("Obj", q), T.length = 0, await (0, t.writeObject)(fe, Y, T, A), z.push({
                  ref: fe,
                  data: T.join("")
                }), _.push(ie, fe), R.push(fe);
              }
            }
            return F + 1;
          }, z2 = function({
            elements: H,
            xref: B,
            pageDict: R,
            parentTree: _
          }) {
            const A = /* @__PURE__ */ new Map();
            for (const F of H)
              if (F.structTreeParentId) {
                const j = parseInt(F.structTreeParentId.split("_mc")[1], 10);
                A.set(j, F);
              }
            const k = R.get("StructParents"), T = new g.NumberTree(_, B).get(k);
            if (!Array.isArray(T))
              return;
            const w = (F, j, P) => {
              const V = A.get(F);
              if (V) {
                const J = j.getRaw("P"), ne = B.fetchIfRef(J);
                return J instanceof h.Ref && ne instanceof h.Dict && (V.structTreeParent = {
                  ref: P,
                  dict: j
                }), !0;
              }
              return !1;
            };
            for (const F of T) {
              if (!(F instanceof h.Ref))
                continue;
              const j = B.fetch(F), P = j.get("K");
              if (Number.isInteger(P)) {
                w(P, j, F);
                continue;
              }
              if (Array.isArray(P)) {
                for (let V of P)
                  if (V = B.fetchIfRef(V), Number.isInteger(V) && w(V, j, F))
                    break;
              }
            }
          }, H2 = async function({
            structTreeParent: {
              ref: H,
              dict: B
            },
            tagDict: R,
            newTagRef: _,
            fallbackRef: A,
            xref: k,
            newRefs: z,
            buffer: T
          }) {
            const w = B.getRaw("P");
            let F = k.fetchIfRef(w);
            R.set("P", w);
            let j = !1, P, V = F.getRaw("K");
            if (V instanceof h.Ref ? P = k.fetch(V) : (P = V, V = k.getNewTemporaryRef(), F = F.clone(), F.set("K", V), j = !0), Array.isArray(P)) {
              const J = P.indexOf(H);
              if (J >= 0)
                P = P.slice(), P.splice(J + 1, 0, _);
              else {
                (0, s.warn)("Cannot update the struct tree: parent kid not found."), R.set("P", A);
                return;
              }
            } else P instanceof h.Dict && (P = [V, _], V = k.getNewTemporaryRef(), F.set("K", V), j = !0);
            T.length = 0, await (0, t.writeObject)(V, P, T, k), z.push({
              ref: V,
              data: T.join("")
            }), j && (T.length = 0, await (0, t.writeObject)(w, F, T, k), z.push({
              ref: w,
              data: T.join("")
            }));
          }, zn($, u);
          let v = $;
          c.StructTreeRoot = v;
          class E {
            constructor(H, B) {
              this.tree = H, this.dict = B, this.kids = [], this.parseKids();
            }
            get role() {
              const H = this.dict.get("S"), B = H instanceof h.Name ? H.name : "", {
                root: R
              } = this.tree;
              return R.roleMap.has(B) ? R.roleMap.get(B) : B;
            }
            parseKids() {
              let H = null;
              const B = this.dict.getRaw("Pg");
              B instanceof h.Ref && (H = B.toString());
              const R = this.dict.get("K");
              if (Array.isArray(R))
                for (const _ of R) {
                  const A = this.parseKid(H, _);
                  A && this.kids.push(A);
                }
              else {
                const _ = this.parseKid(H, R);
                _ && this.kids.push(_);
              }
            }
            parseKid(H, B) {
              if (Number.isInteger(B))
                return this.tree.pageDict.objId !== H ? null : new S({
                  type: m.PAGE_CONTENT,
                  mcid: B,
                  pageObjId: H
                });
              let R = null;
              if (B instanceof h.Ref ? R = this.dict.xref.fetch(B) : B instanceof h.Dict && (R = B), !R)
                return null;
              const _ = R.getRaw("Pg");
              _ instanceof h.Ref && (H = _.toString());
              const A = R.get("Type") instanceof h.Name ? R.get("Type").name : null;
              if (A === "MCR") {
                if (this.tree.pageDict.objId !== H)
                  return null;
                const k = R.getRaw("Stm");
                return new S({
                  type: m.STREAM_CONTENT,
                  refObjId: k instanceof h.Ref ? k.toString() : null,
                  pageObjId: H,
                  mcid: R.get("MCID")
                });
              }
              if (A === "OBJR") {
                if (this.tree.pageDict.objId !== H)
                  return null;
                const k = R.getRaw("Obj");
                return new S({
                  type: m.OBJECT,
                  refObjId: k instanceof h.Ref ? k.toString() : null,
                  pageObjId: H
                });
              }
              return new S({
                type: m.ELEMENT,
                dict: R
              });
            }
          }
          class S {
            constructor({
              type: H,
              dict: B = null,
              mcid: R = null,
              pageObjId: _ = null,
              refObjId: A = null
            }) {
              this.type = H, this.dict = B, this.mcid = R, this.pageObjId = _, this.refObjId = A, this.parentNode = null;
            }
          }
          class y {
            constructor(H, B) {
              this.root = H, this.rootDict = H ? H.dict : null, this.pageDict = B, this.nodes = [];
            }
            parse(H) {
              var z, T;
              if (!this.root || !this.rootDict)
                return;
              const B = this.rootDict.get("ParentTree");
              if (!B)
                return;
              const R = this.pageDict.get("StructParents"), _ = H instanceof h.Ref && ((z = this.root.structParentIds) == null ? void 0 : z.get(H));
              if (!Number.isInteger(R) && !_)
                return;
              const A = /* @__PURE__ */ new Map(), k = new g.NumberTree(B, this.rootDict.xref);
              if (Number.isInteger(R)) {
                const w = k.get(R);
                if (Array.isArray(w))
                  for (const F of w)
                    F instanceof h.Ref && this.addNode(this.rootDict.xref.fetch(F), A);
              }
              if (_)
                for (const [w, F] of _) {
                  const j = k.get(w);
                  if (j) {
                    const P = this.addNode(this.rootDict.xref.fetchIfRef(j), A);
                    ((T = P == null ? void 0 : P.kids) == null ? void 0 : T.length) === 1 && P.kids[0].type === m.OBJECT && (P.kids[0].type = F);
                  }
                }
            }
            addNode(H, B, R = 0) {
              if (R > i)
                return (0, s.warn)("StructTree MAX_DEPTH reached."), null;
              if (B.has(H))
                return B.get(H);
              const _ = new E(this, H);
              B.set(H, _);
              const A = H.get("P");
              if (!A || (0, h.isName)(A.get("Type"), "StructTreeRoot"))
                return this.addTopLevelNode(H, _) || B.delete(H), _;
              const k = this.addNode(A, B, R + 1);
              if (!k)
                return _;
              let z = !1;
              for (const T of k.kids)
                T.type === m.ELEMENT && T.dict === H && (T.parentNode = _, z = !0);
              return z || B.delete(H), _;
            }
            addTopLevelNode(H, B) {
              const R = this.rootDict.get("K");
              if (!R)
                return !1;
              if (R instanceof h.Dict)
                return R.objId !== H.objId ? !1 : (this.nodes[0] = B, !0);
              if (!Array.isArray(R))
                return !0;
              let _ = !1;
              for (let A = 0; A < R.length; A++) {
                const k = R[A];
                (k == null ? void 0 : k.toString()) === H.objId && (this.nodes[A] = B, _ = !0);
              }
              return _;
            }
            get serializable() {
              function H(R, _, A = 0) {
                if (A > i) {
                  (0, s.warn)("StructTree too deep to be fully serialized.");
                  return;
                }
                const k = /* @__PURE__ */ Object.create(null);
                k.role = R.role, k.children = [], _.children.push(k);
                const z = R.dict.get("Alt");
                typeof z == "string" && (k.alt = (0, s.stringToPDFString)(z));
                const T = R.dict.get("Lang");
                typeof T == "string" && (k.lang = (0, s.stringToPDFString)(T));
                for (const w of R.kids) {
                  const F = w.type === m.ELEMENT ? w.parentNode : null;
                  if (F) {
                    H(F, k, A + 1);
                    continue;
                  } else w.type === m.PAGE_CONTENT || w.type === m.STREAM_CONTENT ? k.children.push({
                    type: "content",
                    id: `p${w.pageObjId}_mc${w.mcid}`
                  }) : w.type === m.OBJECT ? k.children.push({
                    type: "object",
                    id: w.refObjId
                  }) : w.type === m.ANNOTATION && k.children.push({
                    type: "annotation",
                    id: `${s.AnnotationPrefix}${w.refObjId}`
                  });
                }
              }
              const B = /* @__PURE__ */ Object.create(null);
              B.children = [], B.role = "Root";
              for (const R of this.nodes)
                R && H(R, B);
              return B;
            }
          }
          c.StructTreePage = y;
        },
        /* 73 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.incrementalUpdate = K, c.writeDict = E, c.writeObject = v;
          var s = f(2), h = f(4), g = f(3), t = f(71), i = f(5), m = f(74);
          async function v(H, B, R, {
            encrypt: _ = null
          }) {
            const A = _ == null ? void 0 : _.createCipherTransform(H.num, H.gen);
            R.push(`${H.num} ${H.gen} obj
`), B instanceof h.Dict ? await E(B, R, A) : B instanceof i.BaseStream ? await S(B, R, A) : Array.isArray(B) && await y(B, R, A), R.push(`
endobj
`);
          }
          async function E(H, B, R) {
            B.push("<<");
            for (const _ of H.getKeys())
              B.push(` /${(0, g.escapePDFName)(_)} `), await x(H.getRaw(_), B, R);
            B.push(">>");
          }
          async function S(H, B, R) {
            let _ = H.getString();
            const {
              dict: A
            } = H, [k, z] = await Promise.all([A.getAsync("Filter"), A.getAsync("DecodeParms")]), T = Array.isArray(k) ? await A.xref.fetchIfRefAsync(k[0]) : k, w = (0, h.isName)(T, "FlateDecode");
            if (typeof CompressionStream < "u" && (_.length >= 256 || w))
              try {
                const j = (0, s.stringToBytes)(_), P = new CompressionStream("deflate"), V = P.writable.getWriter();
                V.write(j), V.close();
                const J = await new Response(P.readable).arrayBuffer();
                _ = (0, s.bytesToString)(new Uint8Array(J));
                let ne, Z;
                k ? w || (ne = Array.isArray(k) ? [h.Name.get("FlateDecode"), ...k] : [h.Name.get("FlateDecode"), k], z && (Z = Array.isArray(z) ? [null, ...z] : [null, z])) : ne = h.Name.get("FlateDecode"), ne && A.set("Filter", ne), Z && A.set("DecodeParms", Z);
              } catch (j) {
                (0, s.info)(`writeStream - cannot compress data: "${j}".`);
              }
            R && (_ = R.encryptString(_)), A.set("Length", _.length), await E(A, B, R), B.push(` stream
`, _, `
endstream`);
          }
          async function y(H, B, R) {
            B.push("[");
            let _ = !0;
            for (const A of H)
              _ ? _ = !1 : B.push(" "), await x(A, B, R);
            B.push("]");
          }
          async function x(H, B, R) {
            H instanceof h.Name ? B.push(`/${(0, g.escapePDFName)(H.name)}`) : H instanceof h.Ref ? B.push(`${H.num} ${H.gen} R`) : Array.isArray(H) ? await y(H, B, R) : typeof H == "string" ? (R && (H = R.encryptString(H)), B.push(`(${(0, g.escapeString)(H)})`)) : typeof H == "number" ? B.push((0, g.numberToString)(H)) : typeof H == "boolean" ? B.push(H.toString()) : H instanceof h.Dict ? await E(H, B, R) : H instanceof i.BaseStream ? await S(H, B, R) : H === null ? B.push("null") : (0, s.warn)(`Unhandled value in writer: ${typeof H}, please file a bug.`);
          }
          function b(H, B, R, _) {
            for (let A = B + R - 1; A > R - 1; A--)
              _[A] = H & 255, H >>= 8;
            return R + B;
          }
          function u(H, B, R) {
            for (let _ = 0, A = H.length; _ < A; _++)
              R[B + _] = H.charCodeAt(_) & 255;
          }
          function I(H, B) {
            const R = Math.floor(Date.now() / 1e3), _ = B.filename || "", A = [R.toString(), _, H.toString()];
            let k = A.reduce((w, F) => w + F.length, 0);
            for (const w of Object.values(B.info))
              A.push(w), k += w.length;
            const z = new Uint8Array(k);
            let T = 0;
            for (const w of A)
              u(w, T, z), T += w.length;
            return (0, s.bytesToString)((0, m.calculateMD5)(z));
          }
          function O(H, B) {
            const R = new t.SimpleXMLParser({
              hasAttributes: !0
            }).parseFromString(H);
            for (const {
              xfa: A
            } of B) {
              if (!A)
                continue;
              const {
                path: k,
                value: z
              } = A;
              if (!k)
                continue;
              const T = (0, g.parseXFAPath)(k);
              let w = R.documentElement.searchNode(T, 0);
              !w && T.length > 1 && (w = R.documentElement.searchNode([T.at(-1)], 0)), w ? w.childNodes = Array.isArray(z) ? z.map((F) => new t.SimpleDOMNode("value", F)) : [new t.SimpleDOMNode("#text", z)] : (0, s.warn)(`Node not found for path: ${k}`);
            }
            const _ = [];
            return R.documentElement.dump(_), _.join("");
          }
          async function D({
            xref: H,
            acroForm: B,
            acroFormRef: R,
            hasXfa: _,
            hasXfaDatasetsEntry: A,
            xfaDatasetsRef: k,
            needAppearances: z,
            newRefs: T
          }) {
            if (_ && !A && !k && (0, s.warn)("XFA - Cannot save it"), !z && (!_ || !k || A))
              return;
            const w = B.clone();
            if (_ && !A) {
              const j = B.get("XFA").slice();
              j.splice(2, 0, "datasets"), j.splice(3, 0, k), w.set("XFA", j);
            }
            z && w.set("NeedAppearances", !0);
            const F = [];
            await v(R, w, F, H), T.push({
              ref: R,
              data: F.join("")
            });
          }
          function $({
            xfaData: H,
            xfaDatasetsRef: B,
            newRefs: R,
            xref: _
          }) {
            if (H === null) {
              const z = _.fetchIfRef(B);
              H = O(z.getString(), R);
            }
            const A = _.encrypt;
            A && (H = A.createCipherTransform(B.num, B.gen).encryptString(H));
            const k = `${B.num} ${B.gen} obj
<< /Type /EmbeddedFile /Length ${H.length}>>
stream
` + H + `
endstream
endobj
`;
            R.push({
              ref: B,
              data: k
            });
          }
          async function K({
            originalData: H,
            xrefInfo: B,
            newRefs: R,
            xref: _ = null,
            hasXfa: A = !1,
            xfaDatasetsRef: k = null,
            hasXfaDatasetsEntry: z = !1,
            needAppearances: T,
            acroFormRef: w = null,
            acroForm: F = null,
            xfaData: j = null
          }) {
            await D({
              xref: _,
              acroForm: F,
              acroFormRef: w,
              hasXfa: A,
              hasXfaDatasetsEntry: z,
              xfaDatasetsRef: k,
              needAppearances: T,
              newRefs: R
            }), A && $({
              xfaData: j,
              xfaDatasetsRef: k,
              newRefs: R,
              xref: _
            });
            const P = new h.Dict(null), V = B.newRef;
            let J, ne;
            const Z = H.at(-1);
            Z === 10 || Z === 13 ? (J = [], ne = H.length) : (J = [`
`], ne = H.length + 1), P.set("Size", V.num + 1), P.set("Prev", B.startXRef), P.set("Type", h.Name.get("XRef")), B.rootRef !== null && P.set("Root", B.rootRef), B.infoRef !== null && P.set("Info", B.infoRef), B.encryptRef !== null && P.set("Encrypt", B.encryptRef), R.push({
              ref: V,
              data: ""
            }), R = R.sort((W, M) => W.ref.num - M.ref.num);
            const te = [[0, 1, 65535]], G = [0, 1];
            let N = 0;
            for (const {
              ref: W,
              data: M
            } of R)
              N = Math.max(N, ne), te.push([1, ne, Math.min(W.gen, 65535)]), ne += M.length, G.push(W.num, 1), J.push(M);
            if (P.set("Index", G), Array.isArray(B.fileIds) && B.fileIds.length > 0) {
              const W = I(ne, B);
              P.set("ID", [B.fileIds[0], W]);
            }
            const ie = [1, Math.ceil(Math.log2(N) / 8), 2], fe = (ie[0] + ie[1] + ie[2]) * te.length;
            P.set("W", ie), P.set("Length", fe), J.push(`${V.num} ${V.gen} obj
`), await E(P, J, null), J.push(` stream
`);
            const Y = J.reduce((W, M) => W + M.length, 0), ae = `
endstream
endobj
startxref
${ne}
%%EOF
`, se = new Uint8Array(H.length + Y + fe + ae.length);
            se.set(H);
            let L = H.length;
            for (const W of J)
              u(W, L, se), L += W.length;
            for (const [W, M, X] of te)
              L = b(W, ie[0], L, se), L = b(M, ie[1], L, se), L = b(X, ie[2], L, se);
            return u(ae, L, se), se;
          }
        },
        /* 74 */
        /***/
        (d, c, f) => {
          var K, H, W2, $d, q2, xl, Ud;
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.calculateSHA256 = c.calculateMD5 = c.PDF20 = c.PDF17 = c.CipherTransformFactory = c.ARCFourCipher = c.AES256Cipher = c.AES128Cipher = void 0, c.calculateSHA384 = S, c.calculateSHA512 = void 0;
          var s = f(2), h = f(4), g = f(75);
          class t {
            constructor(w) {
              this.a = 0, this.b = 0;
              const F = new Uint8Array(256), j = w.length;
              for (let P = 0; P < 256; ++P)
                F[P] = P;
              for (let P = 0, V = 0; P < 256; ++P) {
                const J = F[P];
                V = V + J + w[P % j] & 255, F[P] = F[V], F[V] = J;
              }
              this.s = F;
            }
            encryptBlock(w) {
              let F = this.a, j = this.b;
              const P = this.s, V = w.length, J = new Uint8Array(V);
              for (let ne = 0; ne < V; ++ne) {
                F = F + 1 & 255;
                const Z = P[F];
                j = j + Z & 255;
                const te = P[j];
                P[F] = te, P[j] = Z, J[ne] = w[ne] ^ P[Z + te & 255];
              }
              return this.a = F, this.b = j, J;
            }
            decryptBlock(w) {
              return this.encryptBlock(w);
            }
            encrypt(w) {
              return this.encryptBlock(w);
            }
          }
          c.ARCFourCipher = t;
          const i = function() {
            const w = new Uint8Array([7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21]), F = new Int32Array([-680876936, -389564586, 606105819, -1044525330, -176418897, 1200080426, -1473231341, -45705983, 1770035416, -1958414417, -42063, -1990404162, 1804603682, -40341101, -1502002290, 1236535329, -165796510, -1069501632, 643717713, -373897302, -701558691, 38016083, -660478335, -405537848, 568446438, -1019803690, -187363961, 1163531501, -1444681467, -51403784, 1735328473, -1926607734, -378558, -2022574463, 1839030562, -35309556, -1530992060, 1272893353, -155497632, -1094730640, 681279174, -358537222, -722521979, 76029189, -640364487, -421815835, 530742520, -995338651, -198630844, 1126891415, -1416354905, -57434055, 1700485571, -1894986606, -1051523, -2054922799, 1873313359, -30611744, -1560198380, 1309151649, -145523070, -1120210379, 718787259, -343485551]);
            function j(P, V, J) {
              let ne = 1732584193, Z = -271733879, te = -1732584194, G = 271733878;
              const N = J + 72 & -64, q = new Uint8Array(N);
              let ie, oe;
              for (ie = 0; ie < J; ++ie)
                q[ie] = P[V++];
              q[ie++] = 128;
              const fe = N - 8;
              for (; ie < fe; )
                q[ie++] = 0;
              q[ie++] = J << 3 & 255, q[ie++] = J >> 5 & 255, q[ie++] = J >> 13 & 255, q[ie++] = J >> 21 & 255, q[ie++] = J >>> 29 & 255, q[ie++] = 0, q[ie++] = 0, q[ie++] = 0;
              const Y = new Int32Array(16);
              for (ie = 0; ie < N; ) {
                for (oe = 0; oe < 16; ++oe, ie += 4)
                  Y[oe] = q[ie] | q[ie + 1] << 8 | q[ie + 2] << 16 | q[ie + 3] << 24;
                let ae = ne, se = Z, L = te, W = G, M, X;
                for (oe = 0; oe < 64; ++oe) {
                  oe < 16 ? (M = se & L | ~se & W, X = oe) : oe < 32 ? (M = W & se | ~W & L, X = 5 * oe + 1 & 15) : oe < 48 ? (M = se ^ L ^ W, X = 3 * oe + 5 & 15) : (M = L ^ (se | ~W), X = 7 * oe & 15);
                  const U = W, Q = ae + M + F[oe] + Y[X] | 0, re = w[oe];
                  W = L, L = se, se = se + (Q << re | Q >>> 32 - re) | 0, ae = U;
                }
                ne = ne + ae | 0, Z = Z + se | 0, te = te + L | 0, G = G + W | 0;
              }
              return new Uint8Array([ne & 255, ne >> 8 & 255, ne >> 16 & 255, ne >>> 24 & 255, Z & 255, Z >> 8 & 255, Z >> 16 & 255, Z >>> 24 & 255, te & 255, te >> 8 & 255, te >> 16 & 255, te >>> 24 & 255, G & 255, G >> 8 & 255, G >> 16 & 255, G >>> 24 & 255]);
            }
            return j;
          }();
          c.calculateMD5 = i;
          class m {
            constructor(w, F) {
              this.high = w | 0, this.low = F | 0;
            }
            and(w) {
              this.high &= w.high, this.low &= w.low;
            }
            xor(w) {
              this.high ^= w.high, this.low ^= w.low;
            }
            or(w) {
              this.high |= w.high, this.low |= w.low;
            }
            shiftRight(w) {
              w >= 32 ? (this.low = this.high >>> w - 32 | 0, this.high = 0) : (this.low = this.low >>> w | this.high << 32 - w, this.high = this.high >>> w | 0);
            }
            shiftLeft(w) {
              w >= 32 ? (this.high = this.low << w - 32, this.low = 0) : (this.high = this.high << w | this.low >>> 32 - w, this.low <<= w);
            }
            rotateRight(w) {
              let F, j;
              w & 32 ? (j = this.low, F = this.high) : (F = this.low, j = this.high), w &= 31, this.low = F >>> w | j << 32 - w, this.high = j >>> w | F << 32 - w;
            }
            not() {
              this.high = ~this.high, this.low = ~this.low;
            }
            add(w) {
              const F = (this.low >>> 0) + (w.low >>> 0);
              let j = (this.high >>> 0) + (w.high >>> 0);
              F > 4294967295 && (j += 1), this.low = F | 0, this.high = j | 0;
            }
            copyTo(w, F) {
              w[F] = this.high >>> 24 & 255, w[F + 1] = this.high >> 16 & 255, w[F + 2] = this.high >> 8 & 255, w[F + 3] = this.high & 255, w[F + 4] = this.low >>> 24 & 255, w[F + 5] = this.low >> 16 & 255, w[F + 6] = this.low >> 8 & 255, w[F + 7] = this.low & 255;
            }
            assign(w) {
              this.high = w.high, this.low = w.low;
            }
          }
          const v = /* @__PURE__ */ function() {
            function w(G, N) {
              return G >>> N | G << 32 - N;
            }
            function F(G, N, q) {
              return G & N ^ ~G & q;
            }
            function j(G, N, q) {
              return G & N ^ G & q ^ N & q;
            }
            function P(G) {
              return w(G, 2) ^ w(G, 13) ^ w(G, 22);
            }
            function V(G) {
              return w(G, 6) ^ w(G, 11) ^ w(G, 25);
            }
            function J(G) {
              return w(G, 7) ^ w(G, 18) ^ G >>> 3;
            }
            function ne(G) {
              return w(G, 17) ^ w(G, 19) ^ G >>> 10;
            }
            const Z = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298];
            function te(G, N, q) {
              let ie = 1779033703, oe = 3144134277, fe = 1013904242, Y = 2773480762, ae = 1359893119, se = 2600822924, L = 528734635, W = 1541459225;
              const M = Math.ceil((q + 9) / 64) * 64, X = new Uint8Array(M);
              let U, Q;
              for (U = 0; U < q; ++U)
                X[U] = G[N++];
              X[U++] = 128;
              const re = M - 8;
              for (; U < re; )
                X[U++] = 0;
              X[U++] = 0, X[U++] = 0, X[U++] = 0, X[U++] = q >>> 29 & 255, X[U++] = q >> 21 & 255, X[U++] = q >> 13 & 255, X[U++] = q >> 5 & 255, X[U++] = q << 3 & 255;
              const le = new Uint32Array(64);
              for (U = 0; U < M; ) {
                for (Q = 0; Q < 16; ++Q)
                  le[Q] = X[U] << 24 | X[U + 1] << 16 | X[U + 2] << 8 | X[U + 3], U += 4;
                for (Q = 16; Q < 64; ++Q)
                  le[Q] = ne(le[Q - 2]) + le[Q - 7] + J(le[Q - 15]) + le[Q - 16] | 0;
                let ce = ie, ee = oe, he = fe, pe = Y, de = ae, ge = se, me = L, xe = W, ye, ve;
                for (Q = 0; Q < 64; ++Q)
                  ye = xe + V(de) + F(de, ge, me) + Z[Q] + le[Q], ve = P(ce) + j(ce, ee, he), xe = me, me = ge, ge = de, de = pe + ye | 0, pe = he, he = ee, ee = ce, ce = ye + ve | 0;
                ie = ie + ce | 0, oe = oe + ee | 0, fe = fe + he | 0, Y = Y + pe | 0, ae = ae + de | 0, se = se + ge | 0, L = L + me | 0, W = W + xe | 0;
              }
              return new Uint8Array([ie >> 24 & 255, ie >> 16 & 255, ie >> 8 & 255, ie & 255, oe >> 24 & 255, oe >> 16 & 255, oe >> 8 & 255, oe & 255, fe >> 24 & 255, fe >> 16 & 255, fe >> 8 & 255, fe & 255, Y >> 24 & 255, Y >> 16 & 255, Y >> 8 & 255, Y & 255, ae >> 24 & 255, ae >> 16 & 255, ae >> 8 & 255, ae & 255, se >> 24 & 255, se >> 16 & 255, se >> 8 & 255, se & 255, L >> 24 & 255, L >> 16 & 255, L >> 8 & 255, L & 255, W >> 24 & 255, W >> 16 & 255, W >> 8 & 255, W & 255]);
            }
            return te;
          }();
          c.calculateSHA256 = v;
          const E = function() {
            function w(te, G, N, q, ie) {
              te.assign(G), te.and(N), ie.assign(G), ie.not(), ie.and(q), te.xor(ie);
            }
            function F(te, G, N, q, ie) {
              te.assign(G), te.and(N), ie.assign(G), ie.and(q), te.xor(ie), ie.assign(N), ie.and(q), te.xor(ie);
            }
            function j(te, G, N) {
              te.assign(G), te.rotateRight(28), N.assign(G), N.rotateRight(34), te.xor(N), N.assign(G), N.rotateRight(39), te.xor(N);
            }
            function P(te, G, N) {
              te.assign(G), te.rotateRight(14), N.assign(G), N.rotateRight(18), te.xor(N), N.assign(G), N.rotateRight(41), te.xor(N);
            }
            function V(te, G, N) {
              te.assign(G), te.rotateRight(1), N.assign(G), N.rotateRight(8), te.xor(N), N.assign(G), N.shiftRight(7), te.xor(N);
            }
            function J(te, G, N) {
              te.assign(G), te.rotateRight(19), N.assign(G), N.rotateRight(61), te.xor(N), N.assign(G), N.shiftRight(6), te.xor(N);
            }
            const ne = [new m(1116352408, 3609767458), new m(1899447441, 602891725), new m(3049323471, 3964484399), new m(3921009573, 2173295548), new m(961987163, 4081628472), new m(1508970993, 3053834265), new m(2453635748, 2937671579), new m(2870763221, 3664609560), new m(3624381080, 2734883394), new m(310598401, 1164996542), new m(607225278, 1323610764), new m(1426881987, 3590304994), new m(1925078388, 4068182383), new m(2162078206, 991336113), new m(2614888103, 633803317), new m(3248222580, 3479774868), new m(3835390401, 2666613458), new m(4022224774, 944711139), new m(264347078, 2341262773), new m(604807628, 2007800933), new m(770255983, 1495990901), new m(1249150122, 1856431235), new m(1555081692, 3175218132), new m(1996064986, 2198950837), new m(2554220882, 3999719339), new m(2821834349, 766784016), new m(2952996808, 2566594879), new m(3210313671, 3203337956), new m(3336571891, 1034457026), new m(3584528711, 2466948901), new m(113926993, 3758326383), new m(338241895, 168717936), new m(666307205, 1188179964), new m(773529912, 1546045734), new m(1294757372, 1522805485), new m(1396182291, 2643833823), new m(1695183700, 2343527390), new m(1986661051, 1014477480), new m(2177026350, 1206759142), new m(2456956037, 344077627), new m(2730485921, 1290863460), new m(2820302411, 3158454273), new m(3259730800, 3505952657), new m(3345764771, 106217008), new m(3516065817, 3606008344), new m(3600352804, 1432725776), new m(4094571909, 1467031594), new m(275423344, 851169720), new m(430227734, 3100823752), new m(506948616, 1363258195), new m(659060556, 3750685593), new m(883997877, 3785050280), new m(958139571, 3318307427), new m(1322822218, 3812723403), new m(1537002063, 2003034995), new m(1747873779, 3602036899), new m(1955562222, 1575990012), new m(2024104815, 1125592928), new m(2227730452, 2716904306), new m(2361852424, 442776044), new m(2428436474, 593698344), new m(2756734187, 3733110249), new m(3204031479, 2999351573), new m(3329325298, 3815920427), new m(3391569614, 3928383900), new m(3515267271, 566280711), new m(3940187606, 3454069534), new m(4118630271, 4000239992), new m(116418474, 1914138554), new m(174292421, 2731055270), new m(289380356, 3203993006), new m(460393269, 320620315), new m(685471733, 587496836), new m(852142971, 1086792851), new m(1017036298, 365543100), new m(1126000580, 2618297676), new m(1288033470, 3409855158), new m(1501505948, 4234509866), new m(1607167915, 987167468), new m(1816402316, 1246189591)];
            function Z(te, G, N, q = !1) {
              let ie, oe, fe, Y, ae, se, L, W;
              q ? (ie = new m(3418070365, 3238371032), oe = new m(1654270250, 914150663), fe = new m(2438529370, 812702999), Y = new m(355462360, 4144912697), ae = new m(1731405415, 4290775857), se = new m(2394180231, 1750603025), L = new m(3675008525, 1694076839), W = new m(1203062813, 3204075428)) : (ie = new m(1779033703, 4089235720), oe = new m(3144134277, 2227873595), fe = new m(1013904242, 4271175723), Y = new m(2773480762, 1595750129), ae = new m(1359893119, 2917565137), se = new m(2600822924, 725511199), L = new m(528734635, 4215389547), W = new m(1541459225, 327033209));
              const M = Math.ceil((N + 17) / 128) * 128, X = new Uint8Array(M);
              let U, Q;
              for (U = 0; U < N; ++U)
                X[U] = te[G++];
              X[U++] = 128;
              const re = M - 16;
              for (; U < re; )
                X[U++] = 0;
              X[U++] = 0, X[U++] = 0, X[U++] = 0, X[U++] = 0, X[U++] = 0, X[U++] = 0, X[U++] = 0, X[U++] = 0, X[U++] = 0, X[U++] = 0, X[U++] = 0, X[U++] = N >>> 29 & 255, X[U++] = N >> 21 & 255, X[U++] = N >> 13 & 255, X[U++] = N >> 5 & 255, X[U++] = N << 3 & 255;
              const le = new Array(80);
              for (U = 0; U < 80; U++)
                le[U] = new m(0, 0);
              let ce = new m(0, 0), ee = new m(0, 0), he = new m(0, 0), pe = new m(0, 0), de = new m(0, 0), ge = new m(0, 0), me = new m(0, 0), xe = new m(0, 0);
              const ye = new m(0, 0), ve = new m(0, 0), Ce = new m(0, 0), Ie = new m(0, 0);
              let Ae;
              for (U = 0; U < M; ) {
                for (Q = 0; Q < 16; ++Q)
                  le[Q].high = X[U] << 24 | X[U + 1] << 16 | X[U + 2] << 8 | X[U + 3], le[Q].low = X[U + 4] << 24 | X[U + 5] << 16 | X[U + 6] << 8 | X[U + 7], U += 8;
                for (Q = 16; Q < 80; ++Q)
                  Ae = le[Q], J(Ae, le[Q - 2], Ie), Ae.add(le[Q - 7]), V(Ce, le[Q - 15], Ie), Ae.add(Ce), Ae.add(le[Q - 16]);
                for (ce.assign(ie), ee.assign(oe), he.assign(fe), pe.assign(Y), de.assign(ae), ge.assign(se), me.assign(L), xe.assign(W), Q = 0; Q < 80; ++Q)
                  ye.assign(xe), P(Ce, de, Ie), ye.add(Ce), w(Ce, de, ge, me, Ie), ye.add(Ce), ye.add(ne[Q]), ye.add(le[Q]), j(ve, ce, Ie), F(Ce, ce, ee, he, Ie), ve.add(Ce), Ae = xe, xe = me, me = ge, ge = de, pe.add(ye), de = pe, pe = he, he = ee, ee = ce, Ae.assign(ye), Ae.add(ve), ce = Ae;
                ie.add(ce), oe.add(ee), fe.add(he), Y.add(pe), ae.add(de), se.add(ge), L.add(me), W.add(xe);
              }
              let Se;
              return q ? (Se = new Uint8Array(48), ie.copyTo(Se, 0), oe.copyTo(Se, 8), fe.copyTo(Se, 16), Y.copyTo(Se, 24), ae.copyTo(Se, 32), se.copyTo(Se, 40)) : (Se = new Uint8Array(64), ie.copyTo(Se, 0), oe.copyTo(Se, 8), fe.copyTo(Se, 16), Y.copyTo(Se, 24), ae.copyTo(Se, 32), se.copyTo(Se, 40), L.copyTo(Se, 48), W.copyTo(Se, 56)), Se;
            }
            return Z;
          }();
          c.calculateSHA512 = E;
          function S(T, w, F) {
            return E(T, w, F, !0);
          }
          class y {
            decryptBlock(w) {
              return w;
            }
            encrypt(w) {
              return w;
            }
          }
          class x {
            constructor() {
              this.constructor === x && (0, s.unreachable)("Cannot initialize AESBaseCipher."), this._s = new Uint8Array([99, 124, 119, 123, 242, 107, 111, 197, 48, 1, 103, 43, 254, 215, 171, 118, 202, 130, 201, 125, 250, 89, 71, 240, 173, 212, 162, 175, 156, 164, 114, 192, 183, 253, 147, 38, 54, 63, 247, 204, 52, 165, 229, 241, 113, 216, 49, 21, 4, 199, 35, 195, 24, 150, 5, 154, 7, 18, 128, 226, 235, 39, 178, 117, 9, 131, 44, 26, 27, 110, 90, 160, 82, 59, 214, 179, 41, 227, 47, 132, 83, 209, 0, 237, 32, 252, 177, 91, 106, 203, 190, 57, 74, 76, 88, 207, 208, 239, 170, 251, 67, 77, 51, 133, 69, 249, 2, 127, 80, 60, 159, 168, 81, 163, 64, 143, 146, 157, 56, 245, 188, 182, 218, 33, 16, 255, 243, 210, 205, 12, 19, 236, 95, 151, 68, 23, 196, 167, 126, 61, 100, 93, 25, 115, 96, 129, 79, 220, 34, 42, 144, 136, 70, 238, 184, 20, 222, 94, 11, 219, 224, 50, 58, 10, 73, 6, 36, 92, 194, 211, 172, 98, 145, 149, 228, 121, 231, 200, 55, 109, 141, 213, 78, 169, 108, 86, 244, 234, 101, 122, 174, 8, 186, 120, 37, 46, 28, 166, 180, 198, 232, 221, 116, 31, 75, 189, 139, 138, 112, 62, 181, 102, 72, 3, 246, 14, 97, 53, 87, 185, 134, 193, 29, 158, 225, 248, 152, 17, 105, 217, 142, 148, 155, 30, 135, 233, 206, 85, 40, 223, 140, 161, 137, 13, 191, 230, 66, 104, 65, 153, 45, 15, 176, 84, 187, 22]), this._inv_s = new Uint8Array([82, 9, 106, 213, 48, 54, 165, 56, 191, 64, 163, 158, 129, 243, 215, 251, 124, 227, 57, 130, 155, 47, 255, 135, 52, 142, 67, 68, 196, 222, 233, 203, 84, 123, 148, 50, 166, 194, 35, 61, 238, 76, 149, 11, 66, 250, 195, 78, 8, 46, 161, 102, 40, 217, 36, 178, 118, 91, 162, 73, 109, 139, 209, 37, 114, 248, 246, 100, 134, 104, 152, 22, 212, 164, 92, 204, 93, 101, 182, 146, 108, 112, 72, 80, 253, 237, 185, 218, 94, 21, 70, 87, 167, 141, 157, 132, 144, 216, 171, 0, 140, 188, 211, 10, 247, 228, 88, 5, 184, 179, 69, 6, 208, 44, 30, 143, 202, 63, 15, 2, 193, 175, 189, 3, 1, 19, 138, 107, 58, 145, 17, 65, 79, 103, 220, 234, 151, 242, 207, 206, 240, 180, 230, 115, 150, 172, 116, 34, 231, 173, 53, 133, 226, 249, 55, 232, 28, 117, 223, 110, 71, 241, 26, 113, 29, 41, 197, 137, 111, 183, 98, 14, 170, 24, 190, 27, 252, 86, 62, 75, 198, 210, 121, 32, 154, 219, 192, 254, 120, 205, 90, 244, 31, 221, 168, 51, 136, 7, 199, 49, 177, 18, 16, 89, 39, 128, 236, 95, 96, 81, 127, 169, 25, 181, 74, 13, 45, 229, 122, 159, 147, 201, 156, 239, 160, 224, 59, 77, 174, 42, 245, 176, 200, 235, 187, 60, 131, 83, 153, 97, 23, 43, 4, 126, 186, 119, 214, 38, 225, 105, 20, 99, 85, 33, 12, 125]), this._mix = new Uint32Array([0, 235474187, 470948374, 303765277, 941896748, 908933415, 607530554, 708780849, 1883793496, 2118214995, 1817866830, 1649639237, 1215061108, 1181045119, 1417561698, 1517767529, 3767586992, 4003061179, 4236429990, 4069246893, 3635733660, 3602770327, 3299278474, 3400528769, 2430122216, 2664543715, 2362090238, 2193862645, 2835123396, 2801107407, 3035535058, 3135740889, 3678124923, 3576870512, 3341394285, 3374361702, 3810496343, 3977675356, 4279080257, 4043610186, 2876494627, 2776292904, 3076639029, 3110650942, 2472011535, 2640243204, 2403728665, 2169303058, 1001089995, 899835584, 666464733, 699432150, 59727847, 226906860, 530400753, 294930682, 1273168787, 1172967064, 1475418501, 1509430414, 1942435775, 2110667444, 1876241833, 1641816226, 2910219766, 2743034109, 2976151520, 3211623147, 2505202138, 2606453969, 2302690252, 2269728455, 3711829422, 3543599269, 3240894392, 3475313331, 3843699074, 3943906441, 4178062228, 4144047775, 1306967366, 1139781709, 1374988112, 1610459739, 1975683434, 2076935265, 1775276924, 1742315127, 1034867998, 866637845, 566021896, 800440835, 92987698, 193195065, 429456164, 395441711, 1984812685, 2017778566, 1784663195, 1683407248, 1315562145, 1080094634, 1383856311, 1551037884, 101039829, 135050206, 437757123, 337553864, 1042385657, 807962610, 573804783, 742039012, 2531067453, 2564033334, 2328828971, 2227573024, 2935566865, 2700099354, 3001755655, 3168937228, 3868552805, 3902563182, 4203181171, 4102977912, 3736164937, 3501741890, 3265478751, 3433712980, 1106041591, 1340463100, 1576976609, 1408749034, 2043211483, 2009195472, 1708848333, 1809054150, 832877231, 1068351396, 766945465, 599762354, 159417987, 126454664, 361929877, 463180190, 2709260871, 2943682380, 3178106961, 3009879386, 2572697195, 2538681184, 2236228733, 2336434550, 3509871135, 3745345300, 3441850377, 3274667266, 3910161971, 3877198648, 4110568485, 4211818798, 2597806476, 2497604743, 2261089178, 2295101073, 2733856160, 2902087851, 3202437046, 2968011453, 3936291284, 3835036895, 4136440770, 4169408201, 3535486456, 3702665459, 3467192302, 3231722213, 2051518780, 1951317047, 1716890410, 1750902305, 1113818384, 1282050075, 1584504582, 1350078989, 168810852, 67556463, 371049330, 404016761, 841739592, 1008918595, 775550814, 540080725, 3969562369, 3801332234, 4035489047, 4269907996, 3569255213, 3669462566, 3366754619, 3332740144, 2631065433, 2463879762, 2160117071, 2395588676, 2767645557, 2868897406, 3102011747, 3069049960, 202008497, 33778362, 270040487, 504459436, 875451293, 975658646, 675039627, 641025152, 2084704233, 1917518562, 1615861247, 1851332852, 1147550661, 1248802510, 1484005843, 1451044056, 933301370, 967311729, 733156972, 632953703, 260388950, 25965917, 328671808, 496906059, 1206477858, 1239443753, 1543208500, 1441952575, 2144161806, 1908694277, 1675577880, 1842759443, 3610369226, 3644379585, 3408119516, 3307916247, 4011190502, 3776767469, 4077384432, 4245618683, 2809771154, 2842737049, 3144396420, 3043140495, 2673705150, 2438237621, 2203032232, 2370213795]), this._mixCol = new Uint8Array(256);
              for (let w = 0; w < 256; w++)
                this._mixCol[w] = w < 128 ? w << 1 : w << 1 ^ 27;
              this.buffer = new Uint8Array(16), this.bufferPosition = 0;
            }
            _expandKey(w) {
              (0, s.unreachable)("Cannot call `_expandKey` on the base class");
            }
            _decrypt(w, F) {
              let j, P, V;
              const J = new Uint8Array(16);
              J.set(w);
              for (let ne = 0, Z = this._keySize; ne < 16; ++ne, ++Z)
                J[ne] ^= F[Z];
              for (let ne = this._cyclesOfRepetition - 1; ne >= 1; --ne) {
                j = J[13], J[13] = J[9], J[9] = J[5], J[5] = J[1], J[1] = j, j = J[14], P = J[10], J[14] = J[6], J[10] = J[2], J[6] = j, J[2] = P, j = J[15], P = J[11], V = J[7], J[15] = J[3], J[11] = j, J[7] = P, J[3] = V;
                for (let Z = 0; Z < 16; ++Z)
                  J[Z] = this._inv_s[J[Z]];
                for (let Z = 0, te = ne * 16; Z < 16; ++Z, ++te)
                  J[Z] ^= F[te];
                for (let Z = 0; Z < 16; Z += 4) {
                  const te = this._mix[J[Z]], G = this._mix[J[Z + 1]], N = this._mix[J[Z + 2]], q = this._mix[J[Z + 3]];
                  j = te ^ G >>> 8 ^ G << 24 ^ N >>> 16 ^ N << 16 ^ q >>> 24 ^ q << 8, J[Z] = j >>> 24 & 255, J[Z + 1] = j >> 16 & 255, J[Z + 2] = j >> 8 & 255, J[Z + 3] = j & 255;
                }
              }
              j = J[13], J[13] = J[9], J[9] = J[5], J[5] = J[1], J[1] = j, j = J[14], P = J[10], J[14] = J[6], J[10] = J[2], J[6] = j, J[2] = P, j = J[15], P = J[11], V = J[7], J[15] = J[3], J[11] = j, J[7] = P, J[3] = V;
              for (let ne = 0; ne < 16; ++ne)
                J[ne] = this._inv_s[J[ne]], J[ne] ^= F[ne];
              return J;
            }
            _encrypt(w, F) {
              const j = this._s;
              let P, V, J;
              const ne = new Uint8Array(16);
              ne.set(w);
              for (let Z = 0; Z < 16; ++Z)
                ne[Z] ^= F[Z];
              for (let Z = 1; Z < this._cyclesOfRepetition; Z++) {
                for (let te = 0; te < 16; ++te)
                  ne[te] = j[ne[te]];
                J = ne[1], ne[1] = ne[5], ne[5] = ne[9], ne[9] = ne[13], ne[13] = J, J = ne[2], V = ne[6], ne[2] = ne[10], ne[6] = ne[14], ne[10] = J, ne[14] = V, J = ne[3], V = ne[7], P = ne[11], ne[3] = ne[15], ne[7] = J, ne[11] = V, ne[15] = P;
                for (let te = 0; te < 16; te += 4) {
                  const G = ne[te + 0], N = ne[te + 1], q = ne[te + 2], ie = ne[te + 3];
                  P = G ^ N ^ q ^ ie, ne[te + 0] ^= P ^ this._mixCol[G ^ N], ne[te + 1] ^= P ^ this._mixCol[N ^ q], ne[te + 2] ^= P ^ this._mixCol[q ^ ie], ne[te + 3] ^= P ^ this._mixCol[ie ^ G];
                }
                for (let te = 0, G = Z * 16; te < 16; ++te, ++G)
                  ne[te] ^= F[G];
              }
              for (let Z = 0; Z < 16; ++Z)
                ne[Z] = j[ne[Z]];
              J = ne[1], ne[1] = ne[5], ne[5] = ne[9], ne[9] = ne[13], ne[13] = J, J = ne[2], V = ne[6], ne[2] = ne[10], ne[6] = ne[14], ne[10] = J, ne[14] = V, J = ne[3], V = ne[7], P = ne[11], ne[3] = ne[15], ne[7] = J, ne[11] = V, ne[15] = P;
              for (let Z = 0, te = this._keySize; Z < 16; ++Z, ++te)
                ne[Z] ^= F[te];
              return ne;
            }
            _decryptBlock2(w, F) {
              const j = w.length;
              let P = this.buffer, V = this.bufferPosition;
              const J = [];
              let ne = this.iv;
              for (let G = 0; G < j; ++G) {
                if (P[V] = w[G], ++V, V < 16)
                  continue;
                const N = this._decrypt(P, this._key);
                for (let q = 0; q < 16; ++q)
                  N[q] ^= ne[q];
                ne = P, J.push(N), P = new Uint8Array(16), V = 0;
              }
              if (this.buffer = P, this.bufferLength = V, this.iv = ne, J.length === 0)
                return new Uint8Array(0);
              let Z = 16 * J.length;
              if (F) {
                const G = J.at(-1);
                let N = G[15];
                if (N <= 16) {
                  for (let q = 15, ie = 16 - N; q >= ie; --q)
                    if (G[q] !== N) {
                      N = 0;
                      break;
                    }
                  Z -= N, J[J.length - 1] = G.subarray(0, 16 - N);
                }
              }
              const te = new Uint8Array(Z);
              for (let G = 0, N = 0, q = J.length; G < q; ++G, N += 16)
                te.set(J[G], N);
              return te;
            }
            decryptBlock(w, F, j = null) {
              const P = w.length, V = this.buffer;
              let J = this.bufferPosition;
              if (j)
                this.iv = j;
              else {
                for (let ne = 0; J < 16 && ne < P; ++ne, ++J)
                  V[J] = w[ne];
                if (J < 16)
                  return this.bufferLength = J, new Uint8Array(0);
                this.iv = V, w = w.subarray(16);
              }
              return this.buffer = new Uint8Array(16), this.bufferLength = 0, this.decryptBlock = this._decryptBlock2, this.decryptBlock(w, F);
            }
            encrypt(w, F) {
              const j = w.length;
              let P = this.buffer, V = this.bufferPosition;
              const J = [];
              F || (F = new Uint8Array(16));
              for (let te = 0; te < j; ++te) {
                if (P[V] = w[te], ++V, V < 16)
                  continue;
                for (let N = 0; N < 16; ++N)
                  P[N] ^= F[N];
                const G = this._encrypt(P, this._key);
                F = G, J.push(G), P = new Uint8Array(16), V = 0;
              }
              if (this.buffer = P, this.bufferLength = V, this.iv = F, J.length === 0)
                return new Uint8Array(0);
              const ne = 16 * J.length, Z = new Uint8Array(ne);
              for (let te = 0, G = 0, N = J.length; te < N; ++te, G += 16)
                Z.set(J[te], G);
              return Z;
            }
          }
          class b extends x {
            constructor(w) {
              super(), this._cyclesOfRepetition = 10, this._keySize = 160, this._rcon = new Uint8Array([141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141]), this._key = this._expandKey(w);
            }
            _expandKey(w) {
              const j = this._s, P = this._rcon, V = new Uint8Array(176);
              V.set(w);
              for (let J = 16, ne = 1; J < 176; ++ne) {
                let Z = V[J - 3], te = V[J - 2], G = V[J - 1], N = V[J - 4];
                Z = j[Z], te = j[te], G = j[G], N = j[N], Z ^= P[ne];
                for (let q = 0; q < 4; ++q)
                  V[J] = Z ^= V[J - 16], J++, V[J] = te ^= V[J - 16], J++, V[J] = G ^= V[J - 16], J++, V[J] = N ^= V[J - 16], J++;
              }
              return V;
            }
          }
          c.AES128Cipher = b;
          class u extends x {
            constructor(w) {
              super(), this._cyclesOfRepetition = 14, this._keySize = 224, this._key = this._expandKey(w);
            }
            _expandKey(w) {
              const j = this._s, P = new Uint8Array(240);
              P.set(w);
              let V = 1, J, ne, Z, te;
              for (let G = 32, N = 1; G < 240; ++N) {
                G % 32 === 16 ? (J = j[J], ne = j[ne], Z = j[Z], te = j[te]) : G % 32 === 0 && (J = P[G - 3], ne = P[G - 2], Z = P[G - 1], te = P[G - 4], J = j[J], ne = j[ne], Z = j[Z], te = j[te], J ^= V, (V <<= 1) >= 256 && (V = (V ^ 27) & 255));
                for (let q = 0; q < 4; ++q)
                  P[G] = J ^= P[G - 32], G++, P[G] = ne ^= P[G - 32], G++, P[G] = Z ^= P[G - 32], G++, P[G] = te ^= P[G - 32], G++;
              }
              return P;
            }
          }
          c.AES256Cipher = u;
          class I {
            checkOwnerPassword(w, F, j, P) {
              const V = new Uint8Array(w.length + 56);
              V.set(w, 0), V.set(F, w.length), V.set(j, w.length + F.length);
              const J = v(V, 0, V.length);
              return (0, s.isArrayEqual)(J, P);
            }
            checkUserPassword(w, F, j) {
              const P = new Uint8Array(w.length + 8);
              P.set(w, 0), P.set(F, w.length);
              const V = v(P, 0, P.length);
              return (0, s.isArrayEqual)(V, j);
            }
            getOwnerKey(w, F, j, P) {
              const V = new Uint8Array(w.length + 56);
              V.set(w, 0), V.set(F, w.length), V.set(j, w.length + F.length);
              const J = v(V, 0, V.length);
              return new u(J).decryptBlock(P, !1, new Uint8Array(16));
            }
            getUserKey(w, F, j) {
              const P = new Uint8Array(w.length + 8);
              P.set(w, 0), P.set(F, w.length);
              const V = v(P, 0, P.length);
              return new u(V).decryptBlock(j, !1, new Uint8Array(16));
            }
          }
          c.PDF17 = I;
          class O {
            _hash(w, F, j) {
              let P = v(F, 0, F.length).subarray(0, 32), V = [0], J = 0;
              for (; J < 64 || V.at(-1) > J - 32; ) {
                const ne = w.length + P.length + j.length, Z = new Uint8Array(ne);
                let te = 0;
                Z.set(w, te), te += w.length, Z.set(P, te), te += P.length, Z.set(j, te);
                const G = new Uint8Array(ne * 64);
                for (let ie = 0, oe = 0; ie < 64; ie++, oe += ne)
                  G.set(Z, oe);
                V = new b(P.subarray(0, 16)).encrypt(G, P.subarray(16, 32));
                const q = V.slice(0, 16).reduce((ie, oe) => ie + oe, 0) % 3;
                q === 0 ? P = v(V, 0, V.length) : q === 1 ? P = S(V, 0, V.length) : q === 2 && (P = E(V, 0, V.length)), J++;
              }
              return P.subarray(0, 32);
            }
            checkOwnerPassword(w, F, j, P) {
              const V = new Uint8Array(w.length + 56);
              V.set(w, 0), V.set(F, w.length), V.set(j, w.length + F.length);
              const J = this._hash(w, V, j);
              return (0, s.isArrayEqual)(J, P);
            }
            checkUserPassword(w, F, j) {
              const P = new Uint8Array(w.length + 8);
              P.set(w, 0), P.set(F, w.length);
              const V = this._hash(w, P, []);
              return (0, s.isArrayEqual)(V, j);
            }
            getOwnerKey(w, F, j, P) {
              const V = new Uint8Array(w.length + 56);
              V.set(w, 0), V.set(F, w.length), V.set(j, w.length + F.length);
              const J = this._hash(w, V, j);
              return new u(J).decryptBlock(P, !1, new Uint8Array(16));
            }
            getUserKey(w, F, j) {
              const P = new Uint8Array(w.length + 8);
              P.set(w, 0), P.set(F, w.length);
              const V = this._hash(w, P, []);
              return new u(V).decryptBlock(j, !1, new Uint8Array(16));
            }
          }
          c.PDF20 = O;
          class D {
            constructor(w, F) {
              this.StringCipherConstructor = w, this.StreamCipherConstructor = F;
            }
            createStream(w, F) {
              const j = new this.StreamCipherConstructor();
              return new g.DecryptStream(w, F, function(V, J) {
                return j.decryptBlock(V, J);
              });
            }
            decryptString(w) {
              const F = new this.StringCipherConstructor();
              let j = (0, s.stringToBytes)(w);
              return j = F.decryptBlock(j, !0), (0, s.bytesToString)(j);
            }
            encryptString(w) {
              const F = new this.StringCipherConstructor();
              if (F instanceof x) {
                const V = 16 - w.length % 16;
                w += String.fromCharCode(V).repeat(V);
                const J = new Uint8Array(16);
                if (typeof crypto < "u")
                  crypto.getRandomValues(J);
                else
                  for (let te = 0; te < 16; te++)
                    J[te] = Math.floor(256 * Math.random());
                let ne = (0, s.stringToBytes)(w);
                ne = F.encrypt(ne, J);
                const Z = new Uint8Array(16 + ne.length);
                return Z.set(J), Z.set(ne, 16), (0, s.bytesToString)(Z);
              }
              let j = (0, s.stringToBytes)(w);
              return j = F.encrypt(j), (0, s.bytesToString)(j);
            }
          }
          const z = class z {
            constructor(w, F, j) {
              zn(this, H);
              const P = w.get("Filter");
              if (!(0, h.isName)(P, "Standard"))
                throw new s.FormatError("unknown encryption method");
              this.filterName = P.name, this.dict = w;
              const V = w.get("V");
              if (!Number.isInteger(V) || V !== 1 && V !== 2 && V !== 4 && V !== 5)
                throw new s.FormatError("unsupported encryption algorithm");
              this.algorithm = V;
              let J = w.get("Length");
              if (!J)
                if (V <= 3)
                  J = 40;
                else {
                  const ae = w.get("CF"), se = w.get("StmF");
                  if (ae instanceof h.Dict && se instanceof h.Name) {
                    ae.suppressEncryption = !0;
                    const L = ae.get(se.name);
                    J = (L == null ? void 0 : L.get("Length")) || 128, J < 40 && (J <<= 3);
                  }
                }
              if (!Number.isInteger(J) || J < 40 || J % 8 !== 0)
                throw new s.FormatError("invalid key length");
              const ne = (0, s.stringToBytes)(w.get("O")), Z = (0, s.stringToBytes)(w.get("U")), te = ne.subarray(0, 32), G = Z.subarray(0, 32), N = w.get("P"), q = w.get("R"), ie = (V === 4 || V === 5) && w.get("EncryptMetadata") !== !1;
              this.encryptMetadata = ie;
              const oe = (0, s.stringToBytes)(F);
              let fe;
              if (j) {
                if (q === 6)
                  try {
                    j = (0, s.utf8StringToString)(j);
                  } catch {
                    (0, s.warn)("CipherTransformFactory: Unable to convert UTF8 encoded password.");
                  }
                fe = (0, s.stringToBytes)(j);
              }
              let Y;
              if (V !== 5)
                Y = Nt(this, H, $d).call(this, oe, fe, te, G, N, q, J, ie);
              else {
                const ae = ne.subarray(32, 40), se = ne.subarray(40, 48), L = Z.subarray(0, 48), W = Z.subarray(32, 40), M = Z.subarray(40, 48), X = (0, s.stringToBytes)(w.get("OE")), U = (0, s.stringToBytes)(w.get("UE")), Q = (0, s.stringToBytes)(w.get("Perms"));
                Y = Nt(this, H, W2).call(this, q, fe, te, ae, se, L, G, W, M, X, U, Q);
              }
              if (!Y && !j)
                throw new s.PasswordException("No password given", s.PasswordResponses.NEED_PASSWORD);
              if (!Y && j) {
                const ae = Nt(this, H, q2).call(this, fe, te, q, J);
                Y = Nt(this, H, $d).call(this, oe, ae, te, G, N, q, J, ie);
              }
              if (!Y)
                throw new s.PasswordException("Incorrect Password", s.PasswordResponses.INCORRECT_PASSWORD);
              if (this.encryptionKey = Y, V >= 4) {
                const ae = w.get("CF");
                ae instanceof h.Dict && (ae.suppressEncryption = !0), this.cf = ae, this.stmf = w.get("StmF") || h.Name.get("Identity"), this.strf = w.get("StrF") || h.Name.get("Identity"), this.eff = w.get("EFF") || this.stmf;
              }
            }
            createCipherTransform(w, F) {
              if (this.algorithm === 4 || this.algorithm === 5)
                return new D(Nt(this, H, Ud).call(this, this.cf, this.strf, w, F, this.encryptionKey), Nt(this, H, Ud).call(this, this.cf, this.stmf, w, F, this.encryptionKey));
              const j = Nt(this, H, xl).call(this, w, F, this.encryptionKey, !1), P = function() {
                return new t(j);
              };
              return new D(P, P);
            }
          };
          K = new WeakMap(), H = new WeakSet(), W2 = function(w, F, j, P, V, J, ne, Z, te, G, N, q) {
            if (F) {
              const oe = Math.min(127, F.length);
              F = F.subarray(0, oe);
            } else
              F = [];
            const ie = w === 6 ? new O() : new I();
            return ie.checkUserPassword(F, Z, ne) ? ie.getUserKey(F, te, N) : F.length && ie.checkOwnerPassword(F, P, J, j) ? ie.getOwnerKey(F, V, J, G) : null;
          }, $d = function(w, F, j, P, V, J, ne, Z) {
            const te = 40 + j.length + w.length, G = new Uint8Array(te);
            let N = 0, q, ie;
            if (F)
              for (ie = Math.min(32, F.length); N < ie; ++N)
                G[N] = F[N];
            for (q = 0; N < 32; )
              G[N++] = Un(z, K)[q++];
            for (q = 0, ie = j.length; q < ie; ++q)
              G[N++] = j[q];
            for (G[N++] = V & 255, G[N++] = V >> 8 & 255, G[N++] = V >> 16 & 255, G[N++] = V >>> 24 & 255, q = 0, ie = w.length; q < ie; ++q)
              G[N++] = w[q];
            J >= 4 && !Z && (G[N++] = 255, G[N++] = 255, G[N++] = 255, G[N++] = 255);
            let oe = i(G, 0, N);
            const fe = ne >> 3;
            if (J >= 3)
              for (q = 0; q < 50; ++q)
                oe = i(oe, 0, fe);
            const Y = oe.subarray(0, fe);
            let ae, se;
            if (J >= 3) {
              for (N = 0; N < 32; ++N)
                G[N] = Un(z, K)[N];
              for (q = 0, ie = w.length; q < ie; ++q)
                G[N++] = w[q];
              ae = new t(Y), se = ae.encryptBlock(i(G, 0, N)), ie = Y.length;
              const L = new Uint8Array(ie);
              for (q = 1; q <= 19; ++q) {
                for (let W = 0; W < ie; ++W)
                  L[W] = Y[W] ^ q;
                ae = new t(L), se = ae.encryptBlock(se);
              }
              for (q = 0, ie = se.length; q < ie; ++q)
                if (P[q] !== se[q])
                  return null;
            } else
              for (ae = new t(Y), se = ae.encryptBlock(Un(z, K)), q = 0, ie = se.length; q < ie; ++q)
                if (P[q] !== se[q])
                  return null;
            return Y;
          }, q2 = function(w, F, j, P) {
            const V = new Uint8Array(32);
            let J = 0;
            const ne = Math.min(32, w.length);
            for (; J < ne; ++J)
              V[J] = w[J];
            let Z = 0;
            for (; J < 32; )
              V[J++] = Un(z, K)[Z++];
            let te = i(V, 0, J);
            const G = P >> 3;
            if (j >= 3)
              for (Z = 0; Z < 50; ++Z)
                te = i(te, 0, te.length);
            let N, q;
            if (j >= 3) {
              q = F;
              const ie = new Uint8Array(G);
              for (Z = 19; Z >= 0; Z--) {
                for (let oe = 0; oe < G; ++oe)
                  ie[oe] = te[oe] ^ Z;
                N = new t(ie), q = N.encryptBlock(q);
              }
            } else
              N = new t(te.subarray(0, G)), q = N.encryptBlock(F);
            return q;
          }, xl = function(w, F, j, P = !1) {
            const V = new Uint8Array(j.length + 9), J = j.length;
            let ne;
            for (ne = 0; ne < J; ++ne)
              V[ne] = j[ne];
            return V[ne++] = w & 255, V[ne++] = w >> 8 & 255, V[ne++] = w >> 16 & 255, V[ne++] = F & 255, V[ne++] = F >> 8 & 255, P && (V[ne++] = 115, V[ne++] = 65, V[ne++] = 108, V[ne++] = 84), i(V, 0, ne).subarray(0, Math.min(j.length + 5, 16));
          }, Ud = function(w, F, j, P, V) {
            if (!(F instanceof h.Name))
              throw new s.FormatError("Invalid crypt filter name.");
            const J = this, ne = w.get(F.name), Z = ne == null ? void 0 : ne.get("CFM");
            if (!Z || Z.name === "None")
              return function() {
                return new y();
              };
            if (Z.name === "V2")
              return function() {
                var te;
                return new t(Nt(te = J, H, xl).call(te, j, P, V, !1));
              };
            if (Z.name === "AESV2")
              return function() {
                var te;
                return new b(Nt(te = J, H, xl).call(te, j, P, V, !0));
              };
            if (Z.name === "AESV3")
              return function() {
                return new u(V);
              };
            throw new s.FormatError("Unknown crypto method");
          }, zn(z, K, new Uint8Array([40, 191, 78, 94, 78, 117, 138, 65, 100, 0, 78, 86, 255, 250, 1, 8, 46, 46, 0, 182, 208, 104, 62, 128, 47, 12, 169, 254, 100, 83, 105, 122]));
          let $ = z;
          c.CipherTransformFactory = $;
        },
        /* 75 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.DecryptStream = void 0;
          var s = f(18);
          const h = 512;
          class g extends s.DecodeStream {
            constructor(i, m, v) {
              super(m), this.str = i, this.dict = i.dict, this.decrypt = v, this.nextChunk = null, this.initialized = !1;
            }
            readBlock() {
              var x;
              let i;
              if (this.initialized ? i = this.nextChunk : (i = this.str.getBytes(h), this.initialized = !0), !i || i.length === 0) {
                this.eof = !0;
                return;
              }
              this.nextChunk = this.str.getBytes(h);
              const m = ((x = this.nextChunk) == null ? void 0 : x.length) > 0, v = this.decrypt;
              i = v(i, !m);
              const E = this.bufferLength, S = E + i.length;
              this.ensureBuffer(S).set(i, E), this.bufferLength = S;
            }
          }
          c.DecryptStream = g;
        },
        /* 76 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.ObjectLoader = void 0;
          var s = f(4), h = f(5), g = f(3), t = f(2);
          function i(E) {
            return E instanceof s.Ref || E instanceof s.Dict || E instanceof h.BaseStream || Array.isArray(E);
          }
          function m(E, S) {
            if (E instanceof s.Dict)
              E = E.getRawValues();
            else if (E instanceof h.BaseStream)
              E = E.dict.getRawValues();
            else if (!Array.isArray(E))
              return;
            for (const y of E)
              i(y) && S.push(y);
          }
          class v {
            constructor(S, y, x) {
              this.dict = S, this.keys = y, this.xref = x, this.refSet = null;
            }
            async load() {
              if (this.xref.stream.isDataLoaded)
                return;
              const {
                keys: S,
                dict: y
              } = this;
              this.refSet = new s.RefSet();
              const x = [];
              for (const b of S) {
                const u = y.getRaw(b);
                u !== void 0 && x.push(u);
              }
              return this._walk(x);
            }
            async _walk(S) {
              const y = [], x = [];
              for (; S.length; ) {
                let b = S.pop();
                if (b instanceof s.Ref) {
                  if (this.refSet.has(b))
                    continue;
                  try {
                    this.refSet.put(b), b = this.xref.fetch(b);
                  } catch (u) {
                    if (!(u instanceof g.MissingDataException)) {
                      (0, t.warn)(`ObjectLoader._walk - requesting all data: "${u}".`), this.refSet = null;
                      const {
                        manager: I
                      } = this.xref.stream;
                      return I.requestAllChunks();
                    }
                    y.push(b), x.push({
                      begin: u.begin,
                      end: u.end
                    });
                  }
                }
                if (b instanceof h.BaseStream) {
                  const u = b.getBaseStreams();
                  if (u) {
                    let I = !1;
                    for (const O of u)
                      O.isDataLoaded || (I = !0, x.push({
                        begin: O.start,
                        end: O.end
                      }));
                    I && y.push(b);
                  }
                }
                m(b, S);
              }
              if (x.length) {
                await this.xref.stream.manager.requestRanges(x);
                for (const b of y)
                  b instanceof s.Ref && this.refSet.remove(b);
                return this._walk(y);
              }
              this.refSet = null;
            }
          }
          c.ObjectLoader = v;
        },
        /* 77 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.XFAFactory = void 0;
          var s = f(78), h = f(79), g = f(89), t = f(85), i = f(84), m = f(2), v = f(90), E = f(100);
          class S {
            constructor(x) {
              try {
                this.root = new v.XFAParser().parse(S._createDocument(x));
                const b = new h.Binder(this.root);
                this.form = b.bind(), this.dataHandler = new g.DataHandler(this.root, b.getData()), this.form[s.$globalData].template = this.form;
              } catch (b) {
                (0, m.warn)(`XFA - an error occurred during parsing and binding: ${b}`);
              }
            }
            isValid() {
              return this.root && this.form;
            }
            _createPagesHelper() {
              const x = this.form[s.$toPages]();
              return new Promise((b, u) => {
                const I = () => {
                  try {
                    const O = x.next();
                    O.done ? b(O.value) : setTimeout(I, 0);
                  } catch (O) {
                    u(O);
                  }
                };
                setTimeout(I, 0);
              });
            }
            async _createPages() {
              try {
                this.pages = await this._createPagesHelper(), this.dims = this.pages.children.map((x) => {
                  const {
                    width: b,
                    height: u
                  } = x.attributes.style;
                  return [0, 0, parseInt(b), parseInt(u)];
                });
              } catch (x) {
                (0, m.warn)(`XFA - an error occurred during layout: ${x}`);
              }
            }
            getBoundingBox(x) {
              return this.dims[x];
            }
            async getNumPages() {
              return this.pages || await this._createPages(), this.dims.length;
            }
            setImages(x) {
              this.form[s.$globalData].images = x;
            }
            setFonts(x) {
              this.form[s.$globalData].fontFinder = new t.FontFinder(x);
              const b = [];
              for (let u of this.form[s.$globalData].usedTypefaces)
                u = (0, i.stripQuotes)(u), this.form[s.$globalData].fontFinder.find(u) || b.push(u);
              return b.length > 0 ? b : null;
            }
            appendFonts(x, b) {
              this.form[s.$globalData].fontFinder.add(x, b);
            }
            async getPages() {
              this.pages || await this._createPages();
              const x = this.pages;
              return this.pages = null, x;
            }
            serializeData(x) {
              return this.dataHandler.serialize(x);
            }
            static _createDocument(x) {
              return x["/xdp:xdp"] ? Object.values(x).join("") : x["xdp:xdp"];
            }
            static getRichTextAsHtml(x) {
              if (!x || typeof x != "string")
                return null;
              try {
                let b = new v.XFAParser(E.XhtmlNamespace, !0).parse(x);
                if (!["body", "xhtml"].includes(b[s.$nodeName])) {
                  const D = E.XhtmlNamespace.body({});
                  D[s.$appendChild](b), b = D;
                }
                const u = b[s.$toHTML]();
                if (!u.success)
                  return null;
                const {
                  html: I
                } = u, {
                  attributes: O
                } = I;
                return O && (O.class && (O.class = O.class.filter((D) => !D.startsWith("xfa"))), O.dir = "auto"), {
                  html: I,
                  str: b[s.$text]()
                };
              } catch (b) {
                (0, m.warn)(`XFA - an error occurred during parsing of rich text: ${b}`);
              }
              return null;
            }
          }
          c.XFAFactory = S;
        },
        /* 78 */
        /***/
        (d, c) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.$uid = c.$toStyle = c.$toString = c.$toPages = c.$toHTML = c.$text = c.$tabIndex = c.$setValue = c.$setSetAttributes = c.$setId = c.$searchNode = c.$root = c.$resolvePrototypes = c.$removeChild = c.$pushPara = c.$pushGlyphs = c.$popPara = c.$onText = c.$onChildCheck = c.$onChild = c.$nsAttributes = c.$nodeName = c.$namespaceId = c.$lastAttribute = c.$isUsable = c.$isTransparent = c.$isThereMoreWidth = c.$isSplittable = c.$isNsAgnostic = c.$isDescendent = c.$isDataValue = c.$isCDATAXml = c.$isBindable = c.$insertAt = c.$indexOf = c.$ids = c.$hasSettableValue = c.$globalData = c.$getTemplateRoot = c.$getSubformParent = c.$getRealChildrenByNameIt = c.$getParent = c.$getNextPage = c.$getExtra = c.$getDataValue = c.$getContainedChildren = c.$getChildrenByNameIt = c.$getChildrenByName = c.$getChildrenByClass = c.$getChildren = c.$getAvailableSpace = c.$getAttributes = c.$getAttributeIt = c.$flushHTML = c.$finalize = c.$extra = c.$dump = c.$data = c.$content = c.$consumed = c.$clone = c.$cleanup = c.$cleanPage = c.$clean = c.$childrenToHTML = c.$appendChild = c.$addHTML = c.$acceptWhitespace = void 0;
          const f = Symbol();
          c.$acceptWhitespace = f;
          const s = Symbol();
          c.$addHTML = s;
          const h = Symbol();
          c.$appendChild = h;
          const g = Symbol();
          c.$childrenToHTML = g;
          const t = Symbol();
          c.$clean = t;
          const i = Symbol();
          c.$cleanPage = i;
          const m = Symbol();
          c.$cleanup = m;
          const v = Symbol();
          c.$clone = v;
          const E = Symbol();
          c.$consumed = E;
          const S = Symbol("content");
          c.$content = S;
          const y = Symbol("data");
          c.$data = y;
          const x = Symbol();
          c.$dump = x;
          const b = Symbol("extra");
          c.$extra = b;
          const u = Symbol();
          c.$finalize = u;
          const I = Symbol();
          c.$flushHTML = I;
          const O = Symbol();
          c.$getAttributeIt = O;
          const D = Symbol();
          c.$getAttributes = D;
          const $ = Symbol();
          c.$getAvailableSpace = $;
          const K = Symbol();
          c.$getChildrenByClass = K;
          const H = Symbol();
          c.$getChildrenByName = H;
          const B = Symbol();
          c.$getChildrenByNameIt = B;
          const R = Symbol();
          c.$getDataValue = R;
          const _ = Symbol();
          c.$getExtra = _;
          const A = Symbol();
          c.$getRealChildrenByNameIt = A;
          const k = Symbol();
          c.$getChildren = k;
          const z = Symbol();
          c.$getContainedChildren = z;
          const T = Symbol();
          c.$getNextPage = T;
          const w = Symbol();
          c.$getSubformParent = w;
          const F = Symbol();
          c.$getParent = F;
          const j = Symbol();
          c.$getTemplateRoot = j;
          const P = Symbol();
          c.$globalData = P;
          const V = Symbol();
          c.$hasSettableValue = V;
          const J = Symbol();
          c.$ids = J;
          const ne = Symbol();
          c.$indexOf = ne;
          const Z = Symbol();
          c.$insertAt = Z;
          const te = Symbol();
          c.$isCDATAXml = te;
          const G = Symbol();
          c.$isBindable = G;
          const N = Symbol();
          c.$isDataValue = N;
          const q = Symbol();
          c.$isDescendent = q;
          const ie = Symbol();
          c.$isNsAgnostic = ie;
          const oe = Symbol();
          c.$isSplittable = oe;
          const fe = Symbol();
          c.$isThereMoreWidth = fe;
          const Y = Symbol();
          c.$isTransparent = Y;
          const ae = Symbol();
          c.$isUsable = ae;
          const se = Symbol();
          c.$lastAttribute = se;
          const L = Symbol("namespaceId");
          c.$namespaceId = L;
          const W = Symbol("nodeName");
          c.$nodeName = W;
          const M = Symbol();
          c.$nsAttributes = M;
          const X = Symbol();
          c.$onChild = X;
          const U = Symbol();
          c.$onChildCheck = U;
          const Q = Symbol();
          c.$onText = Q;
          const re = Symbol();
          c.$pushGlyphs = re;
          const le = Symbol();
          c.$popPara = le;
          const ce = Symbol();
          c.$pushPara = ce;
          const ee = Symbol();
          c.$removeChild = ee;
          const he = Symbol("root");
          c.$root = he;
          const pe = Symbol();
          c.$resolvePrototypes = pe;
          const de = Symbol();
          c.$searchNode = de;
          const ge = Symbol();
          c.$setId = ge;
          const me = Symbol();
          c.$setSetAttributes = me;
          const xe = Symbol();
          c.$setValue = xe;
          const ye = Symbol();
          c.$tabIndex = ye;
          const ve = Symbol();
          c.$text = ve;
          const Ce = Symbol();
          c.$toPages = Ce;
          const Ie = Symbol();
          c.$toHTML = Ie;
          const Ae = Symbol();
          c.$toString = Ae;
          const Se = Symbol();
          c.$toStyle = Se;
          const De = Symbol("uid");
          c.$uid = De;
        },
        /* 79 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.Binder = void 0;
          var s = f(78), h = f(80), g = f(88), t = f(87), i = f(81), m = f(2);
          const v = i.NamespaceIds.datasets.id;
          function E(y) {
            const x = new h.Text({});
            return x[s.$content] = y, x;
          }
          class S {
            constructor(x) {
              var b;
              this.root = x, this.datasets = x.datasets, this.data = ((b = x.datasets) == null ? void 0 : b.data) || new t.XmlObject(i.NamespaceIds.datasets.id, "data"), this.emptyMerge = this.data[s.$getChildren]().length === 0, this.root.form = this.form = x.template[s.$clone]();
            }
            _isConsumeData() {
              return !this.emptyMerge && this._mergeMode;
            }
            _isMatchTemplate() {
              return !this._isConsumeData();
            }
            bind() {
              return this._bindElement(this.form, this.data), this.form;
            }
            getData() {
              return this.data;
            }
            _bindValue(x, b, u) {
              var I, O;
              if (x[s.$data] = b, x[s.$hasSettableValue]())
                if (b[s.$isDataValue]()) {
                  const D = b[s.$getDataValue]();
                  x[s.$setValue](E(D));
                } else if (x instanceof h.Field && ((O = (I = x.ui) == null ? void 0 : I.choiceList) == null ? void 0 : O.open) === "multiSelect") {
                  const D = b[s.$getChildren]().map(($) => $[s.$content].trim()).join(`
`);
                  x[s.$setValue](E(D));
                } else this._isConsumeData() && (0, m.warn)("XFA - Nodes haven't the same type.");
              else !b[s.$isDataValue]() || this._isMatchTemplate() ? this._bindElement(x, b) : (0, m.warn)("XFA - Nodes haven't the same type.");
            }
            _findDataByNameToConsume(x, b, u, I) {
              if (!x)
                return null;
              let O, D;
              for (let $ = 0; $ < 3; $++) {
                for (O = u[s.$getRealChildrenByNameIt](x, !1, !0); D = O.next().value, !!D; )
                  if (b === D[s.$isDataValue]())
                    return D;
                if (u[s.$namespaceId] === i.NamespaceIds.datasets.id && u[s.$nodeName] === "data")
                  break;
                u = u[s.$getParent]();
              }
              return I ? (O = this.data[s.$getRealChildrenByNameIt](x, !0, !1), D = O.next().value, D || (O = this.data[s.$getAttributeIt](x, !0), D = O.next().value, D != null && D[s.$isDataValue]()) ? D : null) : null;
            }
            _setProperties(x, b) {
              if (x.hasOwnProperty("setProperty"))
                for (const {
                  ref: u,
                  target: I,
                  connection: O
                } of x.setProperty.children) {
                  if (O || !u)
                    continue;
                  const D = (0, g.searchNode)(this.root, b, u, !1, !1);
                  if (!D) {
                    (0, m.warn)(`XFA - Invalid reference: ${u}.`);
                    continue;
                  }
                  const [$] = D;
                  if (!$[s.$isDescendent](this.data)) {
                    (0, m.warn)("XFA - Invalid node: must be a data node.");
                    continue;
                  }
                  const K = (0, g.searchNode)(this.root, x, I, !1, !1);
                  if (!K) {
                    (0, m.warn)(`XFA - Invalid target: ${I}.`);
                    continue;
                  }
                  const [H] = K;
                  if (!H[s.$isDescendent](x)) {
                    (0, m.warn)("XFA - Invalid target: must be a property or subproperty.");
                    continue;
                  }
                  const B = H[s.$getParent]();
                  if (H instanceof h.SetProperty || B instanceof h.SetProperty) {
                    (0, m.warn)("XFA - Invalid target: cannot be a setProperty or one of its properties.");
                    continue;
                  }
                  if (H instanceof h.BindItems || B instanceof h.BindItems) {
                    (0, m.warn)("XFA - Invalid target: cannot be a bindItems or one of its properties.");
                    continue;
                  }
                  const R = $[s.$text](), _ = H[s.$nodeName];
                  if (H instanceof t.XFAAttribute) {
                    const A = /* @__PURE__ */ Object.create(null);
                    A[_] = R;
                    const k = Reflect.construct(Object.getPrototypeOf(B).constructor, [A]);
                    B[_] = k[_];
                    continue;
                  }
                  if (!H.hasOwnProperty(s.$content)) {
                    (0, m.warn)("XFA - Invalid node to use in setProperty");
                    continue;
                  }
                  H[s.$data] = $, H[s.$content] = R, H[s.$finalize]();
                }
            }
            _bindItems(x, b) {
              if (!x.hasOwnProperty("items") || !x.hasOwnProperty("bindItems") || x.bindItems.isEmpty())
                return;
              for (const O of x.items.children)
                x[s.$removeChild](O);
              x.items.clear();
              const u = new h.Items({}), I = new h.Items({});
              x[s.$appendChild](u), x.items.push(u), x[s.$appendChild](I), x.items.push(I);
              for (const {
                ref: O,
                labelRef: D,
                valueRef: $,
                connection: K
              } of x.bindItems.children) {
                if (K || !O)
                  continue;
                const H = (0, g.searchNode)(this.root, b, O, !1, !1);
                if (!H) {
                  (0, m.warn)(`XFA - Invalid reference: ${O}.`);
                  continue;
                }
                for (const B of H) {
                  if (!B[s.$isDescendent](this.datasets)) {
                    (0, m.warn)(`XFA - Invalid ref (${O}): must be a datasets child.`);
                    continue;
                  }
                  const R = (0, g.searchNode)(this.root, B, D, !0, !1);
                  if (!R) {
                    (0, m.warn)(`XFA - Invalid label: ${D}.`);
                    continue;
                  }
                  const [_] = R;
                  if (!_[s.$isDescendent](this.datasets)) {
                    (0, m.warn)("XFA - Invalid label: must be a datasets child.");
                    continue;
                  }
                  const A = (0, g.searchNode)(this.root, B, $, !0, !1);
                  if (!A) {
                    (0, m.warn)(`XFA - Invalid value: ${$}.`);
                    continue;
                  }
                  const [k] = A;
                  if (!k[s.$isDescendent](this.datasets)) {
                    (0, m.warn)("XFA - Invalid value: must be a datasets child.");
                    continue;
                  }
                  const z = E(_[s.$text]()), T = E(k[s.$text]());
                  u[s.$appendChild](z), u.text.push(z), I[s.$appendChild](T), I.text.push(T);
                }
              }
            }
            _bindOccurrences(x, b, u) {
              let I;
              if (b.length > 1 && (I = x[s.$clone](), I[s.$removeChild](I.occur), I.occur = null), this._bindValue(x, b[0], u), this._setProperties(x, b[0]), this._bindItems(x, b[0]), b.length === 1)
                return;
              const O = x[s.$getParent](), D = x[s.$nodeName], $ = O[s.$indexOf](x);
              for (let K = 1, H = b.length; K < H; K++) {
                const B = b[K], R = I[s.$clone]();
                O[D].push(R), O[s.$insertAt]($ + K, R), this._bindValue(R, B, u), this._setProperties(R, B), this._bindItems(R, B);
              }
            }
            _createOccurrences(x) {
              if (!this.emptyMerge)
                return;
              const {
                occur: b
              } = x;
              if (!b || b.initial <= 1)
                return;
              const u = x[s.$getParent](), I = x[s.$nodeName];
              if (!(u[I] instanceof t.XFAObjectArray))
                return;
              let O;
              x.name ? O = u[I].children.filter((K) => K.name === x.name).length : O = u[I].children.length;
              const D = u[s.$indexOf](x) + 1, $ = b.initial - O;
              if ($) {
                const K = x[s.$clone]();
                K[s.$removeChild](K.occur), K.occur = null, u[I].push(K), u[s.$insertAt](D, K);
                for (let H = 1; H < $; H++) {
                  const B = K[s.$clone]();
                  u[I].push(B), u[s.$insertAt](D + H, B);
                }
              }
            }
            _getOccurInfo(x) {
              const {
                name: b,
                occur: u
              } = x;
              if (!u || !b)
                return [1, 1];
              const I = u.max === -1 ? 1 / 0 : u.max;
              return [u.min, I];
            }
            _setAndBind(x, b) {
              this._setProperties(x, b), this._bindItems(x, b), this._bindElement(x, b);
            }
            _bindElement(x, b) {
              const u = [];
              this._createOccurrences(x);
              for (const I of x[s.$getChildren]()) {
                if (I[s.$data])
                  continue;
                if (this._mergeMode === void 0 && I[s.$nodeName] === "subform") {
                  this._mergeMode = I.mergeMode === "consumeData";
                  const R = b[s.$getChildren]();
                  if (R.length > 0)
                    this._bindOccurrences(I, [R[0]], null);
                  else if (this.emptyMerge) {
                    const _ = b[s.$namespaceId] === v ? -1 : b[s.$namespaceId], A = I[s.$data] = new t.XmlObject(_, I.name || "root");
                    b[s.$appendChild](A), this._bindElement(I, A);
                  }
                  continue;
                }
                if (!I[s.$isBindable]())
                  continue;
                let O = !1, D = null, $ = null, K = null;
                if (I.bind) {
                  switch (I.bind.match) {
                    case "none":
                      this._setAndBind(I, b);
                      continue;
                    case "global":
                      O = !0;
                      break;
                    case "dataRef":
                      if (!I.bind.ref) {
                        (0, m.warn)(`XFA - ref is empty in node ${I[s.$nodeName]}.`), this._setAndBind(I, b);
                        continue;
                      }
                      $ = I.bind.ref;
                      break;
                  }
                  I.bind.picture && (D = I.bind.picture[s.$content]);
                }
                const [H, B] = this._getOccurInfo(I);
                if ($)
                  if (K = (0, g.searchNode)(this.root, b, $, !0, !1), K === null) {
                    if (K = (0, g.createDataNode)(this.data, b, $), !K)
                      continue;
                    this._isConsumeData() && (K[s.$consumed] = !0), this._setAndBind(I, K);
                    continue;
                  } else
                    this._isConsumeData() && (K = K.filter((R) => !R[s.$consumed])), K.length > B ? K = K.slice(0, B) : K.length === 0 && (K = null), K && this._isConsumeData() && K.forEach((R) => {
                      R[s.$consumed] = !0;
                    });
                else {
                  if (!I.name) {
                    this._setAndBind(I, b);
                    continue;
                  }
                  if (this._isConsumeData()) {
                    const R = [];
                    for (; R.length < B; ) {
                      const _ = this._findDataByNameToConsume(I.name, I[s.$hasSettableValue](), b, O);
                      if (!_)
                        break;
                      _[s.$consumed] = !0, R.push(_);
                    }
                    K = R.length > 0 ? R : null;
                  } else {
                    if (K = b[s.$getRealChildrenByNameIt](I.name, !1, this.emptyMerge).next().value, !K) {
                      if (H === 0) {
                        u.push(I);
                        continue;
                      }
                      const R = b[s.$namespaceId] === v ? -1 : b[s.$namespaceId];
                      K = I[s.$data] = new t.XmlObject(R, I.name), this.emptyMerge && (K[s.$consumed] = !0), b[s.$appendChild](K), this._setAndBind(I, K);
                      continue;
                    }
                    this.emptyMerge && (K[s.$consumed] = !0), K = [K];
                  }
                }
                K ? this._bindOccurrences(I, K, D) : H > 0 ? this._setAndBind(I, b) : u.push(I);
              }
              u.forEach((I) => I[s.$getParent]()[s.$removeChild](I));
            }
          }
          c.Binder = S;
        },
        /* 80 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.Value = c.Text = c.TemplateNamespace = c.Template = c.SetProperty = c.Items = c.Field = c.BindItems = void 0;
          var s = f(78), h = f(81), g = f(82), t = f(83), i = f(87), m = f(84), v = f(2), E = f(85), S = f(3), y = f(88);
          const x = h.NamespaceIds.template.id, b = "http://www.w3.org/2000/svg", u = 2, I = 3, O = 5e3, D = /^H(\d+)$/, $ = /* @__PURE__ */ new Set(["image/gif", "image/jpeg", "image/jpg", "image/pjpeg", "image/png", "image/apng", "image/x-png", "image/bmp", "image/x-ms-bmp", "image/tiff", "image/tif", "application/octet-stream"]), K = [[[66, 77], "image/bmp"], [[255, 216, 255], "image/jpeg"], [[73, 73, 42, 0], "image/tiff"], [[77, 77, 0, 42], "image/tiff"], [[71, 73, 70, 56, 57, 97], "image/gif"], [[137, 80, 78, 71, 13, 10, 26, 10], "image/png"]];
          function H(Ne) {
            if (!Ne || !Ne.border)
              return {
                w: 0,
                h: 0
              };
            const C = Ne.border[s.$getExtra]();
            return C ? {
              w: C.widths[0] + C.widths[2] + C.insets[0] + C.insets[2],
              h: C.widths[1] + C.widths[3] + C.insets[1] + C.insets[3]
            } : {
              w: 0,
              h: 0
            };
          }
          function B(Ne) {
            return Ne.margin && (Ne.margin.topInset || Ne.margin.rightInset || Ne.margin.bottomInset || Ne.margin.leftInset);
          }
          function R(Ne, C) {
            if (!Ne.value) {
              const ue = new ea({});
              Ne[s.$appendChild](ue), Ne.value = ue;
            }
            Ne.value[s.$setValue](C);
          }
          function* _(Ne) {
            for (const C of Ne[s.$getChildren]()) {
              if (C instanceof so) {
                yield* C[s.$getContainedChildren]();
                continue;
              }
              yield C;
            }
          }
          function A(Ne) {
            var C;
            return ((C = Ne.validate) == null ? void 0 : C.nullTest) === "error";
          }
          function k(Ne) {
            for (; Ne; ) {
              if (!Ne.traversal) {
                Ne[s.$tabIndex] = Ne[s.$getParent]()[s.$tabIndex];
                return;
              }
              if (Ne[s.$tabIndex])
                return;
              let C = null;
              for (const He of Ne.traversal[s.$getChildren]())
                if (He.operation === "next") {
                  C = He;
                  break;
                }
              if (!C || !C.ref) {
                Ne[s.$tabIndex] = Ne[s.$getParent]()[s.$tabIndex];
                return;
              }
              const ue = Ne[s.$getTemplateRoot]();
              Ne[s.$tabIndex] = ++ue[s.$tabIndex];
              const je = ue[s.$searchNode](C.ref, Ne);
              if (!je)
                return;
              Ne = je[0];
            }
          }
          function z(Ne, C) {
            var je;
            const ue = Ne.assist;
            if (ue) {
              const He = ue[s.$toHTML]();
              He && (C.title = He);
              const dt = ue.role.match(D);
              if (dt) {
                const Ct = "heading", Et = dt[1];
                C.role = Ct, C["aria-level"] = Et;
              }
            }
            if (Ne.layout === "table")
              C.role = "table";
            else if (Ne.layout === "row")
              C.role = "row";
            else {
              const He = Ne[s.$getParent]();
              He.layout === "row" && (C.role = ((je = He.assist) == null ? void 0 : je.role) === "TH" ? "columnheader" : "cell");
            }
          }
          function T(Ne) {
            if (!Ne.assist)
              return null;
            const C = Ne.assist;
            return C.speak && C.speak[s.$content] !== "" ? C.speak[s.$content] : C.toolTip ? C.toolTip[s.$content] : null;
          }
          function w(Ne) {
            return m.HTMLResult.success({
              name: "div",
              attributes: {
                class: ["xfaRich"],
                style: /* @__PURE__ */ Object.create(null)
              },
              children: [{
                name: "span",
                attributes: {
                  style: /* @__PURE__ */ Object.create(null)
                },
                value: Ne
              }]
            });
          }
          function F(Ne) {
            const C = Ne[s.$getTemplateRoot]();
            C[s.$extra].firstUnsplittable === null && (C[s.$extra].firstUnsplittable = Ne, C[s.$extra].noLayoutFailure = !0);
          }
          function j(Ne) {
            const C = Ne[s.$getTemplateRoot]();
            C[s.$extra].firstUnsplittable === Ne && (C[s.$extra].noLayoutFailure = !1);
          }
          function P(Ne) {
            if (Ne[s.$extra] || (Ne[s.$extra] = /* @__PURE__ */ Object.create(null), Ne.targetType === "auto"))
              return !1;
            const C = Ne[s.$getTemplateRoot]();
            let ue = null;
            if (Ne.target) {
              if (ue = C[s.$searchNode](Ne.target, Ne[s.$getParent]()), !ue)
                return !1;
              ue = ue[0];
            }
            const {
              currentPageArea: je,
              currentContentArea: He
            } = C[s.$extra];
            if (Ne.targetType === "pageArea")
              return ue instanceof Ft || (ue = null), Ne.startNew ? (Ne[s.$extra].target = ue || je, !0) : ue && ue !== je ? (Ne[s.$extra].target = ue, !0) : !1;
            ue instanceof he || (ue = null);
            const Ge = ue && ue[s.$getParent]();
            let dt, Ct = Ge;
            if (Ne.startNew)
              if (ue) {
                const Et = Ge.contentArea.children, Vt = Et.indexOf(He), nn = Et.indexOf(ue);
                Vt !== -1 && Vt < nn && (Ct = null), dt = nn - 1;
              } else
                dt = je.contentArea.children.indexOf(He);
            else if (ue && ue !== He)
              dt = Ge.contentArea.children.indexOf(ue) - 1, Ct = Ge === je ? null : Ge;
            else
              return !1;
            return Ne[s.$extra].target = Ct, Ne[s.$extra].index = dt, !0;
          }
          function V(Ne, C, ue) {
            const je = Ne[s.$getTemplateRoot](), He = je[s.$extra].noLayoutFailure, Ge = C[s.$getSubformParent];
            C[s.$getSubformParent] = () => Ne, je[s.$extra].noLayoutFailure = !0;
            const dt = C[s.$toHTML](ue);
            Ne[s.$addHTML](dt.html, dt.bbox), je[s.$extra].noLayoutFailure = He, C[s.$getSubformParent] = Ge;
          }
          class J extends i.StringObject {
            constructor(C) {
              super(x, "appearanceFilter"), this.id = C.id || "", this.type = (0, m.getStringOption)(C.type, ["optional", "required"]), this.use = C.use || "", this.usehref = C.usehref || "";
            }
          }
          class ne extends i.XFAObject {
            constructor(C) {
              super(x, "arc", !0), this.circular = (0, m.getInteger)({
                data: C.circular,
                defaultValue: 0,
                validate: (ue) => ue === 1
              }), this.hand = (0, m.getStringOption)(C.hand, ["even", "left", "right"]), this.id = C.id || "", this.startAngle = (0, m.getFloat)({
                data: C.startAngle,
                defaultValue: 0,
                validate: (ue) => !0
              }), this.sweepAngle = (0, m.getFloat)({
                data: C.sweepAngle,
                defaultValue: 360,
                validate: (ue) => !0
              }), this.use = C.use || "", this.usehref = C.usehref || "", this.edge = null, this.fill = null;
            }
            [s.$toHTML]() {
              var Et;
              const C = this.edge || new Se({}), ue = C[s.$toStyle](), je = /* @__PURE__ */ Object.create(null);
              ((Et = this.fill) == null ? void 0 : Et.presence) === "visible" ? Object.assign(je, this.fill[s.$toStyle]()) : je.fill = "transparent", je.strokeWidth = (0, t.measureToString)(C.presence === "visible" ? C.thickness : 0), je.stroke = ue.color;
              let He;
              const Ge = {
                xmlns: b,
                style: {
                  width: "100%",
                  height: "100%",
                  overflow: "visible"
                }
              };
              if (this.sweepAngle === 360)
                He = {
                  name: "ellipse",
                  attributes: {
                    xmlns: b,
                    cx: "50%",
                    cy: "50%",
                    rx: "50%",
                    ry: "50%",
                    style: je
                  }
                };
              else {
                const Vt = this.startAngle * Math.PI / 180, nn = this.sweepAngle * Math.PI / 180, _n = this.sweepAngle > 180 ? 1 : 0, [hn, Cn, $n, Gt] = [50 * (1 + Math.cos(Vt)), 50 * (1 - Math.sin(Vt)), 50 * (1 + Math.cos(Vt + nn)), 50 * (1 - Math.sin(Vt + nn))];
                He = {
                  name: "path",
                  attributes: {
                    xmlns: b,
                    d: `M ${hn} ${Cn} A 50 50 0 ${_n} 0 ${$n} ${Gt}`,
                    vectorEffect: "non-scaling-stroke",
                    style: je
                  }
                }, Object.assign(Ge, {
                  viewBox: "0 0 100 100",
                  preserveAspectRatio: "none"
                });
              }
              const dt = {
                name: "svg",
                children: [He],
                attributes: Ge
              }, Ct = this[s.$getParent]()[s.$getParent]();
              return B(Ct) ? m.HTMLResult.success({
                name: "div",
                attributes: {
                  style: {
                    display: "inline",
                    width: "100%",
                    height: "100%"
                  }
                },
                children: [dt]
              }) : (dt.attributes.style.position = "absolute", m.HTMLResult.success(dt));
            }
          }
          class Z extends i.XFAObject {
            constructor(C) {
              super(x, "area", !0), this.colSpan = (0, m.getInteger)({
                data: C.colSpan,
                defaultValue: 1,
                validate: (ue) => ue >= 1 || ue === -1
              }), this.id = C.id || "", this.name = C.name || "", this.relevant = (0, m.getRelevant)(C.relevant), this.use = C.use || "", this.usehref = C.usehref || "", this.x = (0, m.getMeasurement)(C.x, "0pt"), this.y = (0, m.getMeasurement)(C.y, "0pt"), this.desc = null, this.extras = null, this.area = new i.XFAObjectArray(), this.draw = new i.XFAObjectArray(), this.exObject = new i.XFAObjectArray(), this.exclGroup = new i.XFAObjectArray(), this.field = new i.XFAObjectArray(), this.subform = new i.XFAObjectArray(), this.subformSet = new i.XFAObjectArray();
            }
            *[s.$getContainedChildren]() {
              yield* _(this);
            }
            [s.$isTransparent]() {
              return !0;
            }
            [s.$isBindable]() {
              return !0;
            }
            [s.$addHTML](C, ue) {
              const [je, He, Ge, dt] = ue;
              this[s.$extra].width = Math.max(this[s.$extra].width, je + Ge), this[s.$extra].height = Math.max(this[s.$extra].height, He + dt), this[s.$extra].children.push(C);
            }
            [s.$getAvailableSpace]() {
              return this[s.$extra].availableSpace;
            }
            [s.$toHTML](C) {
              const ue = (0, t.toStyle)(this, "position"), je = {
                style: ue,
                id: this[s.$uid],
                class: ["xfaArea"]
              };
              (0, t.isPrintOnly)(this) && je.class.push("xfaPrintOnly"), this.name && (je.xfaName = this.name);
              const He = [];
              this[s.$extra] = {
                children: He,
                width: 0,
                height: 0,
                availableSpace: C
              };
              const Ge = this[s.$childrenToHTML]({
                filter: /* @__PURE__ */ new Set(["area", "draw", "field", "exclGroup", "subform", "subformSet"]),
                include: !0
              });
              if (!Ge.success)
                return Ge.isBreak() ? Ge : (delete this[s.$extra], m.HTMLResult.FAILURE);
              ue.width = (0, t.measureToString)(this[s.$extra].width), ue.height = (0, t.measureToString)(this[s.$extra].height);
              const dt = {
                name: "div",
                attributes: je,
                children: He
              }, Ct = [this.x, this.y, this[s.$extra].width, this[s.$extra].height];
              return delete this[s.$extra], m.HTMLResult.success(dt, Ct);
            }
          }
          class te extends i.XFAObject {
            constructor(C) {
              super(x, "assist", !0), this.id = C.id || "", this.role = C.role || "", this.use = C.use || "", this.usehref = C.usehref || "", this.speak = null, this.toolTip = null;
            }
            [s.$toHTML]() {
              var C;
              return ((C = this.toolTip) == null ? void 0 : C[s.$content]) || null;
            }
          }
          class G extends i.XFAObject {
            constructor(C) {
              super(x, "barcode", !0), this.charEncoding = (0, m.getKeyword)({
                data: C.charEncoding ? C.charEncoding.toLowerCase() : "",
                defaultValue: "",
                validate: (ue) => ["utf-8", "big-five", "fontspecific", "gbk", "gb-18030", "gb-2312", "ksc-5601", "none", "shift-jis", "ucs-2", "utf-16"].includes(ue) || ue.match(/iso-8859-\d{2}/)
              }), this.checksum = (0, m.getStringOption)(C.checksum, ["none", "1mod10", "1mod10_1mod11", "2mod10", "auto"]), this.dataColumnCount = (0, m.getInteger)({
                data: C.dataColumnCount,
                defaultValue: -1,
                validate: (ue) => ue >= 0
              }), this.dataLength = (0, m.getInteger)({
                data: C.dataLength,
                defaultValue: -1,
                validate: (ue) => ue >= 0
              }), this.dataPrep = (0, m.getStringOption)(C.dataPrep, ["none", "flateCompress"]), this.dataRowCount = (0, m.getInteger)({
                data: C.dataRowCount,
                defaultValue: -1,
                validate: (ue) => ue >= 0
              }), this.endChar = C.endChar || "", this.errorCorrectionLevel = (0, m.getInteger)({
                data: C.errorCorrectionLevel,
                defaultValue: -1,
                validate: (ue) => ue >= 0 && ue <= 8
              }), this.id = C.id || "", this.moduleHeight = (0, m.getMeasurement)(C.moduleHeight, "5mm"), this.moduleWidth = (0, m.getMeasurement)(C.moduleWidth, "0.25mm"), this.printCheckDigit = (0, m.getInteger)({
                data: C.printCheckDigit,
                defaultValue: 0,
                validate: (ue) => ue === 1
              }), this.rowColumnRatio = (0, m.getRatio)(C.rowColumnRatio), this.startChar = C.startChar || "", this.textLocation = (0, m.getStringOption)(C.textLocation, ["below", "above", "aboveEmbedded", "belowEmbedded", "none"]), this.truncate = (0, m.getInteger)({
                data: C.truncate,
                defaultValue: 0,
                validate: (ue) => ue === 1
              }), this.type = (0, m.getStringOption)(C.type ? C.type.toLowerCase() : "", ["aztec", "codabar", "code2of5industrial", "code2of5interleaved", "code2of5matrix", "code2of5standard", "code3of9", "code3of9extended", "code11", "code49", "code93", "code128", "code128a", "code128b", "code128c", "code128sscc", "datamatrix", "ean8", "ean8add2", "ean8add5", "ean13", "ean13add2", "ean13add5", "ean13pwcd", "fim", "logmars", "maxicode", "msi", "pdf417", "pdf417macro", "plessey", "postauscust2", "postauscust3", "postausreplypaid", "postausstandard", "postukrm4scc", "postusdpbc", "postusimb", "postusstandard", "postus5zip", "qrcode", "rfid", "rss14", "rss14expanded", "rss14limited", "rss14stacked", "rss14stackedomni", "rss14truncated", "telepen", "ucc128", "ucc128random", "ucc128sscc", "upca", "upcaadd2", "upcaadd5", "upcapwcd", "upce", "upceadd2", "upceadd5", "upcean2", "upcean5", "upsmaxicode"]), this.upsMode = (0, m.getStringOption)(C.upsMode, ["usCarrier", "internationalCarrier", "secureSymbol", "standardSymbol"]), this.use = C.use || "", this.usehref = C.usehref || "", this.wideNarrowRatio = (0, m.getRatio)(C.wideNarrowRatio), this.encrypt = null, this.extras = null;
            }
          }
          class N extends i.XFAObject {
            constructor(C) {
              super(x, "bind", !0), this.match = (0, m.getStringOption)(C.match, ["once", "dataRef", "global", "none"]), this.ref = C.ref || "", this.picture = null;
            }
          }
          class q extends i.XFAObject {
            constructor(C) {
              super(x, "bindItems"), this.connection = C.connection || "", this.labelRef = C.labelRef || "", this.ref = C.ref || "", this.valueRef = C.valueRef || "";
            }
          }
          c.BindItems = q;
          class ie extends i.XFAObject {
            constructor(C) {
              super(x, "bookend"), this.id = C.id || "", this.leader = C.leader || "", this.trailer = C.trailer || "", this.use = C.use || "", this.usehref = C.usehref || "";
            }
          }
          class oe extends i.Option01 {
            constructor(C) {
              super(x, "boolean"), this.id = C.id || "", this.name = C.name || "", this.use = C.use || "", this.usehref = C.usehref || "";
            }
            [s.$toHTML](C) {
              return w(this[s.$content] === 1 ? "1" : "0");
            }
          }
          class fe extends i.XFAObject {
            constructor(C) {
              super(x, "border", !0), this.break = (0, m.getStringOption)(C.break, ["close", "open"]), this.hand = (0, m.getStringOption)(C.hand, ["even", "left", "right"]), this.id = C.id || "", this.presence = (0, m.getStringOption)(C.presence, ["visible", "hidden", "inactive", "invisible"]), this.relevant = (0, m.getRelevant)(C.relevant), this.use = C.use || "", this.usehref = C.usehref || "", this.corner = new i.XFAObjectArray(4), this.edge = new i.XFAObjectArray(4), this.extras = null, this.fill = null, this.margin = null;
            }
            [s.$getExtra]() {
              if (!this[s.$extra]) {
                const C = this.edge.children.slice();
                if (C.length < 4) {
                  const He = C.at(-1) || new Se({});
                  for (let Ge = C.length; Ge < 4; Ge++)
                    C.push(He);
                }
                const ue = C.map((He) => He.thickness), je = [0, 0, 0, 0];
                this.margin && (je[0] = this.margin.topInset, je[1] = this.margin.rightInset, je[2] = this.margin.bottomInset, je[3] = this.margin.leftInset), this[s.$extra] = {
                  widths: ue,
                  insets: je,
                  edges: C
                };
              }
              return this[s.$extra];
            }
            [s.$toStyle]() {
              var He;
              const {
                edges: C
              } = this[s.$getExtra](), ue = C.map((Ge) => {
                const dt = Ge[s.$toStyle]();
                return dt.color || (dt.color = "#000000"), dt;
              }), je = /* @__PURE__ */ Object.create(null);
              if (this.margin && Object.assign(je, this.margin[s.$toStyle]()), ((He = this.fill) == null ? void 0 : He.presence) === "visible" && Object.assign(je, this.fill[s.$toStyle]()), this.corner.children.some((Ge) => Ge.radius !== 0)) {
                const Ge = this.corner.children.map((dt) => dt[s.$toStyle]());
                if (Ge.length === 2 || Ge.length === 3) {
                  const dt = Ge.at(-1);
                  for (let Ct = Ge.length; Ct < 4; Ct++)
                    Ge.push(dt);
                }
                je.borderRadius = Ge.map((dt) => dt.radius).join(" ");
              }
              switch (this.presence) {
                case "invisible":
                case "hidden":
                  je.borderStyle = "";
                  break;
                case "inactive":
                  je.borderStyle = "none";
                  break;
                default:
                  je.borderStyle = ue.map((Ge) => Ge.style).join(" ");
                  break;
              }
              return je.borderWidth = ue.map((Ge) => Ge.width).join(" "), je.borderColor = ue.map((Ge) => Ge.color).join(" "), je;
            }
          }
          class Y extends i.XFAObject {
            constructor(C) {
              super(x, "break", !0), this.after = (0, m.getStringOption)(C.after, ["auto", "contentArea", "pageArea", "pageEven", "pageOdd"]), this.afterTarget = C.afterTarget || "", this.before = (0, m.getStringOption)(C.before, ["auto", "contentArea", "pageArea", "pageEven", "pageOdd"]), this.beforeTarget = C.beforeTarget || "", this.bookendLeader = C.bookendLeader || "", this.bookendTrailer = C.bookendTrailer || "", this.id = C.id || "", this.overflowLeader = C.overflowLeader || "", this.overflowTarget = C.overflowTarget || "", this.overflowTrailer = C.overflowTrailer || "", this.startNew = (0, m.getInteger)({
                data: C.startNew,
                defaultValue: 0,
                validate: (ue) => ue === 1
              }), this.use = C.use || "", this.usehref = C.usehref || "", this.extras = null;
            }
          }
          class ae extends i.XFAObject {
            constructor(C) {
              super(x, "breakAfter", !0), this.id = C.id || "", this.leader = C.leader || "", this.startNew = (0, m.getInteger)({
                data: C.startNew,
                defaultValue: 0,
                validate: (ue) => ue === 1
              }), this.target = C.target || "", this.targetType = (0, m.getStringOption)(C.targetType, ["auto", "contentArea", "pageArea"]), this.trailer = C.trailer || "", this.use = C.use || "", this.usehref = C.usehref || "", this.script = null;
            }
          }
          class se extends i.XFAObject {
            constructor(C) {
              super(x, "breakBefore", !0), this.id = C.id || "", this.leader = C.leader || "", this.startNew = (0, m.getInteger)({
                data: C.startNew,
                defaultValue: 0,
                validate: (ue) => ue === 1
              }), this.target = C.target || "", this.targetType = (0, m.getStringOption)(C.targetType, ["auto", "contentArea", "pageArea"]), this.trailer = C.trailer || "", this.use = C.use || "", this.usehref = C.usehref || "", this.script = null;
            }
            [s.$toHTML](C) {
              return this[s.$extra] = {}, m.HTMLResult.FAILURE;
            }
          }
          class L extends i.XFAObject {
            constructor(C) {
              super(x, "button", !0), this.highlight = (0, m.getStringOption)(C.highlight, ["inverted", "none", "outline", "push"]), this.id = C.id || "", this.use = C.use || "", this.usehref = C.usehref || "", this.extras = null;
            }
            [s.$toHTML](C) {
              const je = this[s.$getParent]()[s.$getParent](), He = {
                name: "button",
                attributes: {
                  id: this[s.$uid],
                  class: ["xfaButton"],
                  style: {}
                },
                children: []
              };
              for (const Ge of je.event.children) {
                if (Ge.activity !== "click" || !Ge.script)
                  continue;
                const dt = (0, S.recoverJsURL)(Ge.script[s.$content]);
                if (!dt)
                  continue;
                const Ct = (0, t.fixURL)(dt.url);
                Ct && He.children.push({
                  name: "a",
                  attributes: {
                    id: "link" + this[s.$uid],
                    href: Ct,
                    newWindow: dt.newWindow,
                    class: ["xfaLink"],
                    style: {}
                  },
                  children: []
                });
              }
              return m.HTMLResult.success(He);
            }
          }
          class W extends i.XFAObject {
            constructor(C) {
              super(x, "calculate", !0), this.id = C.id || "", this.override = (0, m.getStringOption)(C.override, ["disabled", "error", "ignore", "warning"]), this.use = C.use || "", this.usehref = C.usehref || "", this.extras = null, this.message = null, this.script = null;
            }
          }
          class M extends i.XFAObject {
            constructor(C) {
              super(x, "caption", !0), this.id = C.id || "", this.placement = (0, m.getStringOption)(C.placement, ["left", "bottom", "inline", "right", "top"]), this.presence = (0, m.getStringOption)(C.presence, ["visible", "hidden", "inactive", "invisible"]), this.reserve = Math.ceil((0, m.getMeasurement)(C.reserve)), this.use = C.use || "", this.usehref = C.usehref || "", this.extras = null, this.font = null, this.margin = null, this.para = null, this.value = null;
            }
            [s.$setValue](C) {
              R(this, C);
            }
            [s.$getExtra](C) {
              if (!this[s.$extra]) {
                let {
                  width: ue,
                  height: je
                } = C;
                switch (this.placement) {
                  case "left":
                  case "right":
                  case "inline":
                    ue = this.reserve <= 0 ? ue : this.reserve;
                    break;
                  case "top":
                  case "bottom":
                    je = this.reserve <= 0 ? je : this.reserve;
                    break;
                }
                this[s.$extra] = (0, t.layoutNode)(this, {
                  width: ue,
                  height: je
                });
              }
              return this[s.$extra];
            }
            [s.$toHTML](C) {
              if (!this.value)
                return m.HTMLResult.EMPTY;
              this[s.$pushPara]();
              const ue = this.value[s.$toHTML](C).html;
              if (!ue)
                return this[s.$popPara](), m.HTMLResult.EMPTY;
              const je = this.reserve;
              if (this.reserve <= 0) {
                const {
                  w: dt,
                  h: Ct
                } = this[s.$getExtra](C);
                switch (this.placement) {
                  case "left":
                  case "right":
                  case "inline":
                    this.reserve = dt;
                    break;
                  case "top":
                  case "bottom":
                    this.reserve = Ct;
                    break;
                }
              }
              const He = [];
              typeof ue == "string" ? He.push({
                name: "#text",
                value: ue
              }) : He.push(ue);
              const Ge = (0, t.toStyle)(this, "font", "margin", "visibility");
              switch (this.placement) {
                case "left":
                case "right":
                  this.reserve > 0 && (Ge.width = (0, t.measureToString)(this.reserve));
                  break;
                case "top":
                case "bottom":
                  this.reserve > 0 && (Ge.height = (0, t.measureToString)(this.reserve));
                  break;
              }
              return (0, t.setPara)(this, null, ue), this[s.$popPara](), this.reserve = je, m.HTMLResult.success({
                name: "div",
                attributes: {
                  style: Ge,
                  class: ["xfaCaption"]
                },
                children: He
              });
            }
          }
          class X extends i.StringObject {
            constructor(C) {
              super(x, "certificate"), this.id = C.id || "", this.name = C.name || "", this.use = C.use || "", this.usehref = C.usehref || "";
            }
          }
          class U extends i.XFAObject {
            constructor(C) {
              super(x, "certificates", !0), this.credentialServerPolicy = (0, m.getStringOption)(C.credentialServerPolicy, ["optional", "required"]), this.id = C.id || "", this.url = C.url || "", this.urlPolicy = C.urlPolicy || "", this.use = C.use || "", this.usehref = C.usehref || "", this.encryption = null, this.issuers = null, this.keyUsage = null, this.oids = null, this.signing = null, this.subjectDNs = null;
            }
          }
          class Q extends i.XFAObject {
            constructor(C) {
              super(x, "checkButton", !0), this.id = C.id || "", this.mark = (0, m.getStringOption)(C.mark, ["default", "check", "circle", "cross", "diamond", "square", "star"]), this.shape = (0, m.getStringOption)(C.shape, ["square", "round"]), this.size = (0, m.getMeasurement)(C.size, "10pt"), this.use = C.use || "", this.usehref = C.usehref || "", this.border = null, this.extras = null, this.margin = null;
            }
            [s.$toHTML](C) {
              var ci, En, Ui;
              const ue = (0, t.toStyle)("margin"), je = (0, t.measureToString)(this.size);
              ue.width = ue.height = je;
              let He, Ge, dt;
              const Ct = this[s.$getParent]()[s.$getParent](), Et = Ct.items.children.length && Ct.items.children[0][s.$toHTML]().html || [], Vt = {
                on: (Et[0] !== void 0 ? Et[0] : "on").toString(),
                off: (Et[1] !== void 0 ? Et[1] : "off").toString()
              }, _n = (((ci = Ct.value) == null ? void 0 : ci[s.$text]()) || "off") === Vt.on || void 0, hn = Ct[s.$getSubformParent](), Cn = Ct[s.$uid];
              let $n;
              hn instanceof We ? (dt = hn[s.$uid], He = "radio", Ge = "xfaRadio", $n = ((En = hn[s.$data]) == null ? void 0 : En[s.$uid]) || hn[s.$uid]) : (He = "checkbox", Ge = "xfaCheckbox", $n = ((Ui = Ct[s.$data]) == null ? void 0 : Ui[s.$uid]) || Ct[s.$uid]);
              const Gt = {
                name: "input",
                attributes: {
                  class: [Ge],
                  style: ue,
                  fieldId: Cn,
                  dataId: $n,
                  type: He,
                  checked: _n,
                  xfaOn: Vt.on,
                  xfaOff: Vt.off,
                  "aria-label": T(Ct),
                  "aria-required": !1
                }
              };
              return dt && (Gt.attributes.name = dt), A(Ct) && (Gt.attributes["aria-required"] = !0, Gt.attributes.required = !0), m.HTMLResult.success({
                name: "label",
                attributes: {
                  class: ["xfaLabel"]
                },
                children: [Gt]
              });
            }
          }
          class re extends i.XFAObject {
            constructor(C) {
              super(x, "choiceList", !0), this.commitOn = (0, m.getStringOption)(C.commitOn, ["select", "exit"]), this.id = C.id || "", this.open = (0, m.getStringOption)(C.open, ["userControl", "always", "multiSelect", "onEntry"]), this.textEntry = (0, m.getInteger)({
                data: C.textEntry,
                defaultValue: 0,
                validate: (ue) => ue === 1
              }), this.use = C.use || "", this.usehref = C.usehref || "", this.border = null, this.extras = null, this.margin = null;
            }
            [s.$toHTML](C) {
              var Vt, nn, _n;
              const ue = (0, t.toStyle)(this, "border", "margin"), He = this[s.$getParent]()[s.$getParent](), dt = {
                fontSize: `calc(${((Vt = He.font) == null ? void 0 : Vt.size) || 10}px * var(--scale-factor))`
              }, Ct = [];
              if (He.items.children.length > 0) {
                const hn = He.items;
                let Cn = 0, $n = 0;
                hn.children.length === 2 && (Cn = hn.children[0].save, $n = 1 - Cn);
                const Gt = hn.children[Cn][s.$toHTML]().html, ci = hn.children[$n][s.$toHTML]().html;
                let En = !1;
                const Ui = ((nn = He.value) == null ? void 0 : nn[s.$text]()) || "";
                for (let li = 0, sn = Gt.length; li < sn; li++) {
                  const Ot = {
                    name: "option",
                    attributes: {
                      value: ci[li] || Gt[li],
                      style: dt
                    },
                    value: Gt[li]
                  };
                  ci[li] === Ui && (Ot.attributes.selected = En = !0), Ct.push(Ot);
                }
                En || Ct.splice(0, 0, {
                  name: "option",
                  attributes: {
                    hidden: !0,
                    selected: !0
                  },
                  value: " "
                });
              }
              const Et = {
                class: ["xfaSelect"],
                fieldId: He[s.$uid],
                dataId: ((_n = He[s.$data]) == null ? void 0 : _n[s.$uid]) || He[s.$uid],
                style: ue,
                "aria-label": T(He),
                "aria-required": !1
              };
              return A(He) && (Et["aria-required"] = !0, Et.required = !0), this.open === "multiSelect" && (Et.multiple = !0), m.HTMLResult.success({
                name: "label",
                attributes: {
                  class: ["xfaLabel"]
                },
                children: [{
                  name: "select",
                  children: Ct,
                  attributes: Et
                }]
              });
            }
          }
          class le extends i.XFAObject {
            constructor(C) {
              super(x, "color", !0), this.cSpace = (0, m.getStringOption)(C.cSpace, ["SRGB"]), this.id = C.id || "", this.use = C.use || "", this.usehref = C.usehref || "", this.value = C.value ? (0, m.getColor)(C.value) : "", this.extras = null;
            }
            [s.$hasSettableValue]() {
              return !1;
            }
            [s.$toStyle]() {
              return this.value ? v.Util.makeHexColor(this.value.r, this.value.g, this.value.b) : null;
            }
          }
          class ce extends i.XFAObject {
            constructor(C) {
              super(x, "comb"), this.id = C.id || "", this.numberOfCells = (0, m.getInteger)({
                data: C.numberOfCells,
                defaultValue: 0,
                validate: (ue) => ue >= 0
              }), this.use = C.use || "", this.usehref = C.usehref || "";
            }
          }
          class ee extends i.XFAObject {
            constructor(C) {
              super(x, "connect", !0), this.connection = C.connection || "", this.id = C.id || "", this.ref = C.ref || "", this.usage = (0, m.getStringOption)(C.usage, ["exportAndImport", "exportOnly", "importOnly"]), this.use = C.use || "", this.usehref = C.usehref || "", this.picture = null;
            }
          }
          class he extends i.XFAObject {
            constructor(C) {
              super(x, "contentArea", !0), this.h = (0, m.getMeasurement)(C.h), this.id = C.id || "", this.name = C.name || "", this.relevant = (0, m.getRelevant)(C.relevant), this.use = C.use || "", this.usehref = C.usehref || "", this.w = (0, m.getMeasurement)(C.w), this.x = (0, m.getMeasurement)(C.x, "0pt"), this.y = (0, m.getMeasurement)(C.y, "0pt"), this.desc = null, this.extras = null;
            }
            [s.$toHTML](C) {
              const ue = (0, t.measureToString)(this.x), je = (0, t.measureToString)(this.y), He = {
                left: ue,
                top: je,
                width: (0, t.measureToString)(this.w),
                height: (0, t.measureToString)(this.h)
              }, Ge = ["xfaContentarea"];
              return (0, t.isPrintOnly)(this) && Ge.push("xfaPrintOnly"), m.HTMLResult.success({
                name: "div",
                children: [],
                attributes: {
                  style: He,
                  class: Ge,
                  id: this[s.$uid]
                }
              });
            }
          }
          class pe extends i.XFAObject {
            constructor(C) {
              super(x, "corner", !0), this.id = C.id || "", this.inverted = (0, m.getInteger)({
                data: C.inverted,
                defaultValue: 0,
                validate: (ue) => ue === 1
              }), this.join = (0, m.getStringOption)(C.join, ["square", "round"]), this.presence = (0, m.getStringOption)(C.presence, ["visible", "hidden", "inactive", "invisible"]), this.radius = (0, m.getMeasurement)(C.radius), this.stroke = (0, m.getStringOption)(C.stroke, ["solid", "dashDot", "dashDotDot", "dashed", "dotted", "embossed", "etched", "lowered", "raised"]), this.thickness = (0, m.getMeasurement)(C.thickness, "0.5pt"), this.use = C.use || "", this.usehref = C.usehref || "", this.color = null, this.extras = null;
            }
            [s.$toStyle]() {
              const C = (0, t.toStyle)(this, "visibility");
              return C.radius = (0, t.measureToString)(this.join === "square" ? 0 : this.radius), C;
            }
          }
          class de extends i.ContentObject {
            constructor(C) {
              super(x, "date"), this.id = C.id || "", this.name = C.name || "", this.use = C.use || "", this.usehref = C.usehref || "";
            }
            [s.$finalize]() {
              const C = this[s.$content].trim();
              this[s.$content] = C ? new Date(C) : null;
            }
            [s.$toHTML](C) {
              return w(this[s.$content] ? this[s.$content].toString() : "");
            }
          }
          class ge extends i.ContentObject {
            constructor(C) {
              super(x, "dateTime"), this.id = C.id || "", this.name = C.name || "", this.use = C.use || "", this.usehref = C.usehref || "";
            }
            [s.$finalize]() {
              const C = this[s.$content].trim();
              this[s.$content] = C ? new Date(C) : null;
            }
            [s.$toHTML](C) {
              return w(this[s.$content] ? this[s.$content].toString() : "");
            }
          }
          class me extends i.XFAObject {
            constructor(C) {
              super(x, "dateTimeEdit", !0), this.hScrollPolicy = (0, m.getStringOption)(C.hScrollPolicy, ["auto", "off", "on"]), this.id = C.id || "", this.picker = (0, m.getStringOption)(C.picker, ["host", "none"]), this.use = C.use || "", this.usehref = C.usehref || "", this.border = null, this.comb = null, this.extras = null, this.margin = null;
            }
            [s.$toHTML](C) {
              var Ge;
              const ue = (0, t.toStyle)(this, "border", "font", "margin"), je = this[s.$getParent]()[s.$getParent](), He = {
                name: "input",
                attributes: {
                  type: "text",
                  fieldId: je[s.$uid],
                  dataId: ((Ge = je[s.$data]) == null ? void 0 : Ge[s.$uid]) || je[s.$uid],
                  class: ["xfaTextfield"],
                  style: ue,
                  "aria-label": T(je),
                  "aria-required": !1
                }
              };
              return A(je) && (He.attributes["aria-required"] = !0, He.attributes.required = !0), m.HTMLResult.success({
                name: "label",
                attributes: {
                  class: ["xfaLabel"]
                },
                children: [He]
              });
            }
          }
          class xe extends i.ContentObject {
            constructor(C) {
              super(x, "decimal"), this.fracDigits = (0, m.getInteger)({
                data: C.fracDigits,
                defaultValue: 2,
                validate: (ue) => !0
              }), this.id = C.id || "", this.leadDigits = (0, m.getInteger)({
                data: C.leadDigits,
                defaultValue: -1,
                validate: (ue) => !0
              }), this.name = C.name || "", this.use = C.use || "", this.usehref = C.usehref || "";
            }
            [s.$finalize]() {
              const C = parseFloat(this[s.$content].trim());
              this[s.$content] = isNaN(C) ? null : C;
            }
            [s.$toHTML](C) {
              return w(this[s.$content] !== null ? this[s.$content].toString() : "");
            }
          }
          class ye extends i.XFAObject {
            constructor(C) {
              super(x, "defaultUi", !0), this.id = C.id || "", this.use = C.use || "", this.usehref = C.usehref || "", this.extras = null;
            }
          }
          class ve extends i.XFAObject {
            constructor(C) {
              super(x, "desc", !0), this.id = C.id || "", this.use = C.use || "", this.usehref = C.usehref || "", this.boolean = new i.XFAObjectArray(), this.date = new i.XFAObjectArray(), this.dateTime = new i.XFAObjectArray(), this.decimal = new i.XFAObjectArray(), this.exData = new i.XFAObjectArray(), this.float = new i.XFAObjectArray(), this.image = new i.XFAObjectArray(), this.integer = new i.XFAObjectArray(), this.text = new i.XFAObjectArray(), this.time = new i.XFAObjectArray();
            }
          }
          class Ce extends i.OptionObject {
            constructor(C) {
              super(x, "digestMethod", ["", "SHA1", "SHA256", "SHA512", "RIPEMD160"]), this.id = C.id || "", this.use = C.use || "", this.usehref = C.usehref || "";
            }
          }
          class Ie extends i.XFAObject {
            constructor(C) {
              super(x, "digestMethods", !0), this.id = C.id || "", this.type = (0, m.getStringOption)(C.type, ["optional", "required"]), this.use = C.use || "", this.usehref = C.usehref || "", this.digestMethod = new i.XFAObjectArray();
            }
          }
          class Ae extends i.XFAObject {
            constructor(C) {
              super(x, "draw", !0), this.anchorType = (0, m.getStringOption)(C.anchorType, ["topLeft", "bottomCenter", "bottomLeft", "bottomRight", "middleCenter", "middleLeft", "middleRight", "topCenter", "topRight"]), this.colSpan = (0, m.getInteger)({
                data: C.colSpan,
                defaultValue: 1,
                validate: (ue) => ue >= 1 || ue === -1
              }), this.h = C.h ? (0, m.getMeasurement)(C.h) : "", this.hAlign = (0, m.getStringOption)(C.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]), this.id = C.id || "", this.locale = C.locale || "", this.maxH = (0, m.getMeasurement)(C.maxH, "0pt"), this.maxW = (0, m.getMeasurement)(C.maxW, "0pt"), this.minH = (0, m.getMeasurement)(C.minH, "0pt"), this.minW = (0, m.getMeasurement)(C.minW, "0pt"), this.name = C.name || "", this.presence = (0, m.getStringOption)(C.presence, ["visible", "hidden", "inactive", "invisible"]), this.relevant = (0, m.getRelevant)(C.relevant), this.rotate = (0, m.getInteger)({
                data: C.rotate,
                defaultValue: 0,
                validate: (ue) => ue % 90 === 0
              }), this.use = C.use || "", this.usehref = C.usehref || "", this.w = C.w ? (0, m.getMeasurement)(C.w) : "", this.x = (0, m.getMeasurement)(C.x, "0pt"), this.y = (0, m.getMeasurement)(C.y, "0pt"), this.assist = null, this.border = null, this.caption = null, this.desc = null, this.extras = null, this.font = null, this.keep = null, this.margin = null, this.para = null, this.traversal = null, this.ui = null, this.value = null, this.setProperty = new i.XFAObjectArray();
            }
            [s.$setValue](C) {
              R(this, C);
            }
            [s.$toHTML](C) {
              if (k(this), this.presence === "hidden" || this.presence === "inactive")
                return m.HTMLResult.EMPTY;
              (0, t.fixDimensions)(this), this[s.$pushPara]();
              const ue = this.w, je = this.h, {
                w: He,
                h: Ge,
                isBroken: dt
              } = (0, t.layoutNode)(this, C);
              if (He && this.w === "") {
                if (dt && this[s.$getSubformParent]()[s.$isThereMoreWidth]())
                  return this[s.$popPara](), m.HTMLResult.FAILURE;
                this.w = He;
              }
              if (Ge && this.h === "" && (this.h = Ge), F(this), !(0, g.checkDimensions)(this, C))
                return this.w = ue, this.h = je, this[s.$popPara](), m.HTMLResult.FAILURE;
              j(this);
              const Ct = (0, t.toStyle)(this, "font", "hAlign", "dimensions", "position", "presence", "rotate", "anchorType", "border", "margin");
              (0, t.setMinMaxDimensions)(this, Ct), Ct.margin && (Ct.padding = Ct.margin, delete Ct.margin);
              const Et = ["xfaDraw"];
              this.font && Et.push("xfaFont"), (0, t.isPrintOnly)(this) && Et.push("xfaPrintOnly");
              const Vt = {
                style: Ct,
                id: this[s.$uid],
                class: Et
              };
              this.name && (Vt.xfaName = this.name);
              const nn = {
                name: "div",
                attributes: Vt,
                children: []
              };
              z(this, Vt);
              const _n = (0, t.computeBbox)(this, nn, C), hn = this.value ? this.value[s.$toHTML](C).html : null;
              return hn === null ? (this.w = ue, this.h = je, this[s.$popPara](), m.HTMLResult.success((0, t.createWrapper)(this, nn), _n)) : (nn.children.push(hn), (0, t.setPara)(this, Ct, hn), this.w = ue, this.h = je, this[s.$popPara](), m.HTMLResult.success((0, t.createWrapper)(this, nn), _n));
            }
          }
          class Se extends i.XFAObject {
            constructor(C) {
              super(x, "edge", !0), this.cap = (0, m.getStringOption)(C.cap, ["square", "butt", "round"]), this.id = C.id || "", this.presence = (0, m.getStringOption)(C.presence, ["visible", "hidden", "inactive", "invisible"]), this.stroke = (0, m.getStringOption)(C.stroke, ["solid", "dashDot", "dashDotDot", "dashed", "dotted", "embossed", "etched", "lowered", "raised"]), this.thickness = (0, m.getMeasurement)(C.thickness, "0.5pt"), this.use = C.use || "", this.usehref = C.usehref || "", this.color = null, this.extras = null;
            }
            [s.$toStyle]() {
              const C = (0, t.toStyle)(this, "visibility");
              if (Object.assign(C, {
                linecap: this.cap,
                width: (0, t.measureToString)(this.thickness),
                color: this.color ? this.color[s.$toStyle]() : "#000000",
                style: ""
              }), this.presence !== "visible")
                C.style = "none";
              else
                switch (this.stroke) {
                  case "solid":
                    C.style = "solid";
                    break;
                  case "dashDot":
                    C.style = "dashed";
                    break;
                  case "dashDotDot":
                    C.style = "dashed";
                    break;
                  case "dashed":
                    C.style = "dashed";
                    break;
                  case "dotted":
                    C.style = "dotted";
                    break;
                  case "embossed":
                    C.style = "ridge";
                    break;
                  case "etched":
                    C.style = "groove";
                    break;
                  case "lowered":
                    C.style = "inset";
                    break;
                  case "raised":
                    C.style = "outset";
                    break;
                }
              return C;
            }
          }
          class De extends i.OptionObject {
            constructor(C) {
              super(x, "encoding", ["adbe.x509.rsa_sha1", "adbe.pkcs7.detached", "adbe.pkcs7.sha1"]), this.id = C.id || "", this.use = C.use || "", this.usehref = C.usehref || "";
            }
          }
          class Be extends i.XFAObject {
            constructor(C) {
              super(x, "encodings", !0), this.id = C.id || "", this.type = (0, m.getStringOption)(C.type, ["optional", "required"]), this.use = C.use || "", this.usehref = C.usehref || "", this.encoding = new i.XFAObjectArray();
            }
          }
          class ke extends i.XFAObject {
            constructor(C) {
              super(x, "encrypt", !0), this.id = C.id || "", this.use = C.use || "", this.usehref = C.usehref || "", this.certificate = null;
            }
          }
          class be extends i.XFAObject {
            constructor(C) {
              super(x, "encryptData", !0), this.id = C.id || "", this.operation = (0, m.getStringOption)(C.operation, ["encrypt", "decrypt"]), this.target = C.target || "", this.use = C.use || "", this.usehref = C.usehref || "", this.filter = null, this.manifest = null;
            }
          }
          class we extends i.XFAObject {
            constructor(C) {
              super(x, "encryption", !0), this.id = C.id || "", this.type = (0, m.getStringOption)(C.type, ["optional", "required"]), this.use = C.use || "", this.usehref = C.usehref || "", this.certificate = new i.XFAObjectArray();
            }
          }
          class Le extends i.OptionObject {
            constructor(C) {
              super(x, "encryptionMethod", ["", "AES256-CBC", "TRIPLEDES-CBC", "AES128-CBC", "AES192-CBC"]), this.id = C.id || "", this.use = C.use || "", this.usehref = C.usehref || "";
            }
          }
          class Re extends i.XFAObject {
            constructor(C) {
              super(x, "encryptionMethods", !0), this.id = C.id || "", this.type = (0, m.getStringOption)(C.type, ["optional", "required"]), this.use = C.use || "", this.usehref = C.usehref || "", this.encryptionMethod = new i.XFAObjectArray();
            }
          }
          class ct extends i.XFAObject {
            constructor(C) {
              super(x, "event", !0), this.activity = (0, m.getStringOption)(C.activity, ["click", "change", "docClose", "docReady", "enter", "exit", "full", "indexChange", "initialize", "mouseDown", "mouseEnter", "mouseExit", "mouseUp", "postExecute", "postOpen", "postPrint", "postSave", "postSign", "postSubmit", "preExecute", "preOpen", "prePrint", "preSave", "preSign", "preSubmit", "ready", "validationState"]), this.id = C.id || "", this.listen = (0, m.getStringOption)(C.listen, ["refOnly", "refAndDescendents"]), this.name = C.name || "", this.ref = C.ref || "", this.use = C.use || "", this.usehref = C.usehref || "", this.extras = null, this.encryptData = null, this.execute = null, this.script = null, this.signData = null, this.submit = null;
            }
          }
          class ft extends i.ContentObject {
            constructor(C) {
              super(x, "exData"), this.contentType = C.contentType || "", this.href = C.href || "", this.id = C.id || "", this.maxLength = (0, m.getInteger)({
                data: C.maxLength,
                defaultValue: -1,
                validate: (ue) => ue >= -1
              }), this.name = C.name || "", this.rid = C.rid || "", this.transferEncoding = (0, m.getStringOption)(C.transferEncoding, ["none", "base64", "package"]), this.use = C.use || "", this.usehref = C.usehref || "";
            }
            [s.$isCDATAXml]() {
              return this.contentType === "text/html";
            }
            [s.$onChild](C) {
              return this.contentType === "text/html" && C[s.$namespaceId] === h.NamespaceIds.xhtml.id ? (this[s.$content] = C, !0) : this.contentType === "text/xml" ? (this[s.$content] = C, !0) : !1;
            }
            [s.$toHTML](C) {
              return this.contentType !== "text/html" || !this[s.$content] ? m.HTMLResult.EMPTY : this[s.$content][s.$toHTML](C);
            }
          }
          class kt extends i.XFAObject {
            constructor(C) {
              super(x, "exObject", !0), this.archive = C.archive || "", this.classId = C.classId || "", this.codeBase = C.codeBase || "", this.codeType = C.codeType || "", this.id = C.id || "", this.name = C.name || "", this.use = C.use || "", this.usehref = C.usehref || "", this.extras = null, this.boolean = new i.XFAObjectArray(), this.date = new i.XFAObjectArray(), this.dateTime = new i.XFAObjectArray(), this.decimal = new i.XFAObjectArray(), this.exData = new i.XFAObjectArray(), this.exObject = new i.XFAObjectArray(), this.float = new i.XFAObjectArray(), this.image = new i.XFAObjectArray(), this.integer = new i.XFAObjectArray(), this.text = new i.XFAObjectArray(), this.time = new i.XFAObjectArray();
            }
          }
          class We extends i.XFAObject {
            constructor(C) {
              super(x, "exclGroup", !0), this.access = (0, m.getStringOption)(C.access, ["open", "nonInteractive", "protected", "readOnly"]), this.accessKey = C.accessKey || "", this.anchorType = (0, m.getStringOption)(C.anchorType, ["topLeft", "bottomCenter", "bottomLeft", "bottomRight", "middleCenter", "middleLeft", "middleRight", "topCenter", "topRight"]), this.colSpan = (0, m.getInteger)({
                data: C.colSpan,
                defaultValue: 1,
                validate: (ue) => ue >= 1 || ue === -1
              }), this.h = C.h ? (0, m.getMeasurement)(C.h) : "", this.hAlign = (0, m.getStringOption)(C.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]), this.id = C.id || "", this.layout = (0, m.getStringOption)(C.layout, ["position", "lr-tb", "rl-row", "rl-tb", "row", "table", "tb"]), this.maxH = (0, m.getMeasurement)(C.maxH, "0pt"), this.maxW = (0, m.getMeasurement)(C.maxW, "0pt"), this.minH = (0, m.getMeasurement)(C.minH, "0pt"), this.minW = (0, m.getMeasurement)(C.minW, "0pt"), this.name = C.name || "", this.presence = (0, m.getStringOption)(C.presence, ["visible", "hidden", "inactive", "invisible"]), this.relevant = (0, m.getRelevant)(C.relevant), this.use = C.use || "", this.usehref = C.usehref || "", this.w = C.w ? (0, m.getMeasurement)(C.w) : "", this.x = (0, m.getMeasurement)(C.x, "0pt"), this.y = (0, m.getMeasurement)(C.y, "0pt"), this.assist = null, this.bind = null, this.border = null, this.calculate = null, this.caption = null, this.desc = null, this.extras = null, this.margin = null, this.para = null, this.traversal = null, this.validate = null, this.connect = new i.XFAObjectArray(), this.event = new i.XFAObjectArray(), this.field = new i.XFAObjectArray(), this.setProperty = new i.XFAObjectArray();
            }
            [s.$isBindable]() {
              return !0;
            }
            [s.$hasSettableValue]() {
              return !0;
            }
            [s.$setValue](C) {
              for (const ue of this.field.children) {
                if (!ue.value) {
                  const je = new ea({});
                  ue[s.$appendChild](je), ue.value = je;
                }
                ue.value[s.$setValue](C);
              }
            }
            [s.$isThereMoreWidth]() {
              return this.layout.endsWith("-tb") && this[s.$extra].attempt === 0 && this[s.$extra].numberInLine > 0 || this[s.$getParent]()[s.$isThereMoreWidth]();
            }
            [s.$isSplittable]() {
              var ue;
              const C = this[s.$getSubformParent]();
              return C[s.$isSplittable]() ? this[s.$extra]._isSplittable !== void 0 ? this[s.$extra]._isSplittable : this.layout === "position" || this.layout.includes("row") ? (this[s.$extra]._isSplittable = !1, !1) : (ue = C.layout) != null && ue.endsWith("-tb") && C[s.$extra].numberInLine !== 0 ? !1 : (this[s.$extra]._isSplittable = !0, !0) : !1;
            }
            [s.$flushHTML]() {
              return (0, g.flushHTML)(this);
            }
            [s.$addHTML](C, ue) {
              (0, g.addHTML)(this, C, ue);
            }
            [s.$getAvailableSpace]() {
              return (0, g.getAvailableSpace)(this);
            }
            [s.$toHTML](C) {
              if (k(this), this.presence === "hidden" || this.presence === "inactive" || this.h === 0 || this.w === 0)
                return m.HTMLResult.EMPTY;
              (0, t.fixDimensions)(this);
              const ue = [], je = {
                id: this[s.$uid],
                class: []
              };
              (0, t.setAccess)(this, je.class), this[s.$extra] || (this[s.$extra] = /* @__PURE__ */ Object.create(null)), Object.assign(this[s.$extra], {
                children: ue,
                attributes: je,
                attempt: 0,
                line: null,
                numberInLine: 0,
                availableSpace: {
                  width: Math.min(this.w || 1 / 0, C.width),
                  height: Math.min(this.h || 1 / 0, C.height)
                },
                width: 0,
                height: 0,
                prevHeight: 0,
                currentWidth: 0
              });
              const He = this[s.$isSplittable]();
              if (He || F(this), !(0, g.checkDimensions)(this, C))
                return m.HTMLResult.FAILURE;
              const Ge = /* @__PURE__ */ new Set(["field"]);
              if (this.layout.includes("row")) {
                const En = this[s.$getSubformParent]().columnWidths;
                Array.isArray(En) && En.length > 0 && (this[s.$extra].columnWidths = En, this[s.$extra].currentColumn = 0);
              }
              const dt = (0, t.toStyle)(this, "anchorType", "dimensions", "position", "presence", "border", "margin", "hAlign"), Ct = ["xfaExclgroup"], Et = (0, t.layoutClass)(this);
              Et && Ct.push(Et), (0, t.isPrintOnly)(this) && Ct.push("xfaPrintOnly"), je.style = dt, je.class = Ct, this.name && (je.xfaName = this.name), this[s.$pushPara]();
              const Vt = this.layout === "lr-tb" || this.layout === "rl-tb", nn = Vt ? u : 1;
              for (; this[s.$extra].attempt < nn; this[s.$extra].attempt++) {
                Vt && this[s.$extra].attempt === u - 1 && (this[s.$extra].numberInLine = 0);
                const En = this[s.$childrenToHTML]({
                  filter: Ge,
                  include: !0
                });
                if (En.success)
                  break;
                if (En.isBreak())
                  return this[s.$popPara](), En;
                if (Vt && this[s.$extra].attempt === 0 && this[s.$extra].numberInLine === 0 && !this[s.$getTemplateRoot]()[s.$extra].noLayoutFailure) {
                  this[s.$extra].attempt = nn;
                  break;
                }
              }
              if (this[s.$popPara](), He || j(this), this[s.$extra].attempt === nn)
                return He || delete this[s.$extra], m.HTMLResult.FAILURE;
              let _n = 0, hn = 0;
              this.margin && (_n = this.margin.leftInset + this.margin.rightInset, hn = this.margin.topInset + this.margin.bottomInset);
              const Cn = Math.max(this[s.$extra].width + _n, this.w || 0), $n = Math.max(this[s.$extra].height + hn, this.h || 0), Gt = [this.x, this.y, Cn, $n];
              this.w === "" && (dt.width = (0, t.measureToString)(Cn)), this.h === "" && (dt.height = (0, t.measureToString)($n));
              const ci = {
                name: "div",
                attributes: je,
                children: ue
              };
              return z(this, je), delete this[s.$extra], m.HTMLResult.success((0, t.createWrapper)(this, ci), Gt);
            }
          }
          class jt extends i.XFAObject {
            constructor(C) {
              super(x, "execute"), this.connection = C.connection || "", this.executeType = (0, m.getStringOption)(C.executeType, ["import", "remerge"]), this.id = C.id || "", this.runAt = (0, m.getStringOption)(C.runAt, ["client", "both", "server"]), this.use = C.use || "", this.usehref = C.usehref || "";
            }
          }
          class yt extends i.XFAObject {
            constructor(C) {
              super(x, "extras", !0), this.id = C.id || "", this.name = C.name || "", this.use = C.use || "", this.usehref = C.usehref || "", this.boolean = new i.XFAObjectArray(), this.date = new i.XFAObjectArray(), this.dateTime = new i.XFAObjectArray(), this.decimal = new i.XFAObjectArray(), this.exData = new i.XFAObjectArray(), this.extras = new i.XFAObjectArray(), this.float = new i.XFAObjectArray(), this.image = new i.XFAObjectArray(), this.integer = new i.XFAObjectArray(), this.text = new i.XFAObjectArray(), this.time = new i.XFAObjectArray();
            }
          }
          class Ye extends i.XFAObject {
            constructor(C) {
              super(x, "field", !0), this.access = (0, m.getStringOption)(C.access, ["open", "nonInteractive", "protected", "readOnly"]), this.accessKey = C.accessKey || "", this.anchorType = (0, m.getStringOption)(C.anchorType, ["topLeft", "bottomCenter", "bottomLeft", "bottomRight", "middleCenter", "middleLeft", "middleRight", "topCenter", "topRight"]), this.colSpan = (0, m.getInteger)({
                data: C.colSpan,
                defaultValue: 1,
                validate: (ue) => ue >= 1 || ue === -1
              }), this.h = C.h ? (0, m.getMeasurement)(C.h) : "", this.hAlign = (0, m.getStringOption)(C.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]), this.id = C.id || "", this.locale = C.locale || "", this.maxH = (0, m.getMeasurement)(C.maxH, "0pt"), this.maxW = (0, m.getMeasurement)(C.maxW, "0pt"), this.minH = (0, m.getMeasurement)(C.minH, "0pt"), this.minW = (0, m.getMeasurement)(C.minW, "0pt"), this.name = C.name || "", this.presence = (0, m.getStringOption)(C.presence, ["visible", "hidden", "inactive", "invisible"]), this.relevant = (0, m.getRelevant)(C.relevant), this.rotate = (0, m.getInteger)({
                data: C.rotate,
                defaultValue: 0,
                validate: (ue) => ue % 90 === 0
              }), this.use = C.use || "", this.usehref = C.usehref || "", this.w = C.w ? (0, m.getMeasurement)(C.w) : "", this.x = (0, m.getMeasurement)(C.x, "0pt"), this.y = (0, m.getMeasurement)(C.y, "0pt"), this.assist = null, this.bind = null, this.border = null, this.calculate = null, this.caption = null, this.desc = null, this.extras = null, this.font = null, this.format = null, this.items = new i.XFAObjectArray(2), this.keep = null, this.margin = null, this.para = null, this.traversal = null, this.ui = null, this.validate = null, this.value = null, this.bindItems = new i.XFAObjectArray(), this.connect = new i.XFAObjectArray(), this.event = new i.XFAObjectArray(), this.setProperty = new i.XFAObjectArray();
            }
            [s.$isBindable]() {
              return !0;
            }
            [s.$setValue](C) {
              R(this, C);
            }
            [s.$toHTML](C) {
              var En, Ui, li;
              if (k(this), !this.ui) {
                this.ui = new oo({}), this.ui[s.$globalData] = this[s.$globalData], this[s.$appendChild](this.ui);
                let sn;
                switch (this.items.children.length) {
                  case 0:
                    sn = new jc({}), this.ui.textEdit = sn;
                    break;
                  case 1:
                    sn = new Q({}), this.ui.checkButton = sn;
                    break;
                  case 2:
                    sn = new re({}), this.ui.choiceList = sn;
                    break;
                }
                this.ui[s.$appendChild](sn);
              }
              if (!this.ui || this.presence === "hidden" || this.presence === "inactive" || this.h === 0 || this.w === 0)
                return m.HTMLResult.EMPTY;
              this.caption && delete this.caption[s.$extra], this[s.$pushPara]();
              const ue = this.caption ? this.caption[s.$toHTML](C).html : null, je = this.w, He = this.h;
              let Ge = 0, dt = 0;
              this.margin && (Ge = this.margin.leftInset + this.margin.rightInset, dt = this.margin.topInset + this.margin.bottomInset);
              let Ct = null;
              if (this.w === "" || this.h === "") {
                let sn = null, Ot = null, dr = 0, Yi = 0;
                if (this.ui.checkButton)
                  dr = Yi = this.ui.checkButton.size;
                else {
                  const {
                    w: ts,
                    h: yr
                  } = (0, t.layoutNode)(this, C);
                  ts !== null ? (dr = ts, Yi = yr) : Yi = (0, E.getMetrics)(this.font, !0).lineNoGap;
                }
                if (Ct = H(this.ui[s.$getExtra]()), dr += Ct.w, Yi += Ct.h, this.caption) {
                  const {
                    w: ts,
                    h: yr,
                    isBroken: ui
                  } = this.caption[s.$getExtra](C);
                  if (ui && this[s.$getSubformParent]()[s.$isThereMoreWidth]())
                    return this[s.$popPara](), m.HTMLResult.FAILURE;
                  switch (sn = ts, Ot = yr, this.caption.placement) {
                    case "left":
                    case "right":
                    case "inline":
                      sn += dr;
                      break;
                    case "top":
                    case "bottom":
                      Ot += Yi;
                      break;
                  }
                } else
                  sn = dr, Ot = Yi;
                sn && this.w === "" && (sn += Ge, this.w = Math.min(this.maxW <= 0 ? 1 / 0 : this.maxW, this.minW + 1 < sn ? sn : this.minW)), Ot && this.h === "" && (Ot += dt, this.h = Math.min(this.maxH <= 0 ? 1 / 0 : this.maxH, this.minH + 1 < Ot ? Ot : this.minH));
              }
              if (this[s.$popPara](), (0, t.fixDimensions)(this), F(this), !(0, g.checkDimensions)(this, C))
                return this.w = je, this.h = He, this[s.$popPara](), m.HTMLResult.FAILURE;
              j(this);
              const Et = (0, t.toStyle)(this, "font", "dimensions", "position", "rotate", "anchorType", "presence", "margin", "hAlign");
              (0, t.setMinMaxDimensions)(this, Et);
              const Vt = ["xfaField"];
              this.font && Vt.push("xfaFont"), (0, t.isPrintOnly)(this) && Vt.push("xfaPrintOnly");
              const nn = {
                style: Et,
                id: this[s.$uid],
                class: Vt
              };
              Et.margin && (Et.padding = Et.margin, delete Et.margin), (0, t.setAccess)(this, Vt), this.name && (nn.xfaName = this.name);
              const _n = [], hn = {
                name: "div",
                attributes: nn,
                children: _n
              };
              z(this, nn);
              const Cn = this.border ? this.border[s.$toStyle]() : null, $n = (0, t.computeBbox)(this, hn, C), Gt = this.ui[s.$toHTML]().html;
              if (!Gt)
                return Object.assign(Et, Cn), m.HTMLResult.success((0, t.createWrapper)(this, hn), $n);
              this[s.$tabIndex] && ((En = Gt.children) != null && En[0] ? Gt.children[0].attributes.tabindex = this[s.$tabIndex] : Gt.attributes.tabindex = this[s.$tabIndex]), Gt.attributes.style || (Gt.attributes.style = /* @__PURE__ */ Object.create(null));
              let ci = null;
              if (this.ui.button ? (Gt.children.length === 1 && ([ci] = Gt.children.splice(0, 1)), Object.assign(Gt.attributes.style, Cn)) : Object.assign(Et, Cn), _n.push(Gt), this.value) {
                if (this.ui.imageEdit)
                  Gt.children.push(this.value[s.$toHTML]().html);
                else if (!this.ui.button) {
                  let sn = "";
                  if (this.value.exData)
                    sn = this.value.exData[s.$text]();
                  else if (this.value.text)
                    sn = this.value.text[s.$getExtra]();
                  else {
                    const Ot = this.value[s.$toHTML]().html;
                    Ot !== null && (sn = Ot.children[0].value);
                  }
                  this.ui.textEdit && ((Ui = this.value.text) != null && Ui.maxChars) && (Gt.children[0].attributes.maxLength = this.value.text.maxChars), sn && (this.ui.numericEdit && (sn = parseFloat(sn), sn = isNaN(sn) ? "" : sn.toString()), Gt.children[0].name === "textarea" ? Gt.children[0].attributes.textContent = sn : Gt.children[0].attributes.value = sn);
                }
              }
              if (!this.ui.imageEdit && ((li = Gt.children) != null && li[0]) && this.h) {
                Ct = Ct || H(this.ui[s.$getExtra]());
                let sn = 0;
                if (this.caption && ["top", "bottom"].includes(this.caption.placement)) {
                  sn = this.caption.reserve, sn <= 0 && (sn = this.caption[s.$getExtra](C).h);
                  const Ot = this.h - sn - dt - Ct.h;
                  Gt.children[0].attributes.style.height = (0, t.measureToString)(Ot);
                } else
                  Gt.children[0].attributes.style.height = "100%";
              }
              if (ci && Gt.children.push(ci), !ue)
                return Gt.attributes.class && Gt.attributes.class.push("xfaLeft"), this.w = je, this.h = He, m.HTMLResult.success((0, t.createWrapper)(this, hn), $n);
              if (this.ui.button)
                return Et.padding && delete Et.padding, ue.name === "div" && (ue.name = "span"), Gt.children.push(ue), m.HTMLResult.success(hn, $n);
              switch (this.ui.checkButton && (ue.attributes.class[0] = "xfaCaptionForCheckButton"), Gt.attributes.class || (Gt.attributes.class = []), Gt.children.splice(0, 0, ue), this.caption.placement) {
                case "left":
                  Gt.attributes.class.push("xfaLeft");
                  break;
                case "right":
                  Gt.attributes.class.push("xfaRight");
                  break;
                case "top":
                  Gt.attributes.class.push("xfaTop");
                  break;
                case "bottom":
                  Gt.attributes.class.push("xfaBottom");
                  break;
                case "inline":
                  Gt.attributes.class.push("xfaLeft");
                  break;
              }
              return this.w = je, this.h = He, m.HTMLResult.success((0, t.createWrapper)(this, hn), $n);
            }
          }
          c.Field = Ye;
          class mt extends i.XFAObject {
            constructor(C) {
              super(x, "fill", !0), this.id = C.id || "", this.presence = (0, m.getStringOption)(C.presence, ["visible", "hidden", "inactive", "invisible"]), this.use = C.use || "", this.usehref = C.usehref || "", this.color = null, this.extras = null, this.linear = null, this.pattern = null, this.radial = null, this.solid = null, this.stipple = null;
            }
            [s.$toStyle]() {
              var Ct;
              const C = this[s.$getParent](), je = C[s.$getParent]()[s.$getParent](), He = /* @__PURE__ */ Object.create(null);
              let Ge = "color", dt = Ge;
              C instanceof fe && (Ge = "background-color", dt = "background", je instanceof oo && (He.backgroundColor = "white")), (C instanceof Ut || C instanceof ne) && (Ge = dt = "fill", He.fill = "white");
              for (const Et of Object.getOwnPropertyNames(this)) {
                if (Et === "extras" || Et === "color")
                  continue;
                const Vt = this[Et];
                if (!(Vt instanceof i.XFAObject))
                  continue;
                const nn = Vt[s.$toStyle](this.color);
                return nn && (He[nn.startsWith("#") ? Ge : dt] = nn), He;
              }
              if ((Ct = this.color) != null && Ct.value) {
                const Et = this.color[s.$toStyle]();
                He[Et.startsWith("#") ? Ge : dt] = Et;
              }
              return He;
            }
          }
          class Pt extends i.XFAObject {
            constructor(C) {
              super(x, "filter", !0), this.addRevocationInfo = (0, m.getStringOption)(C.addRevocationInfo, ["", "required", "optional", "none"]), this.id = C.id || "", this.name = C.name || "", this.use = C.use || "", this.usehref = C.usehref || "", this.version = (0, m.getInteger)({
                data: this.version,
                defaultValue: 5,
                validate: (ue) => ue >= 1 && ue <= 5
              }), this.appearanceFilter = null, this.certificates = null, this.digestMethods = null, this.encodings = null, this.encryptionMethods = null, this.handler = null, this.lockDocument = null, this.mdp = null, this.reasons = null, this.timeStamp = null;
            }
          }
          class et extends i.ContentObject {
            constructor(C) {
              super(x, "float"), this.id = C.id || "", this.name = C.name || "", this.use = C.use || "", this.usehref = C.usehref || "";
            }
            [s.$finalize]() {
              const C = parseFloat(this[s.$content].trim());
              this[s.$content] = isNaN(C) ? null : C;
            }
            [s.$toHTML](C) {
              return w(this[s.$content] !== null ? this[s.$content].toString() : "");
            }
          }
          class tn extends i.XFAObject {
            constructor(C) {
              super(x, "font", !0), this.baselineShift = (0, m.getMeasurement)(C.baselineShift), this.fontHorizontalScale = (0, m.getFloat)({
                data: C.fontHorizontalScale,
                defaultValue: 100,
                validate: (ue) => ue >= 0
              }), this.fontVerticalScale = (0, m.getFloat)({
                data: C.fontVerticalScale,
                defaultValue: 100,
                validate: (ue) => ue >= 0
              }), this.id = C.id || "", this.kerningMode = (0, m.getStringOption)(C.kerningMode, ["none", "pair"]), this.letterSpacing = (0, m.getMeasurement)(C.letterSpacing, "0"), this.lineThrough = (0, m.getInteger)({
                data: C.lineThrough,
                defaultValue: 0,
                validate: (ue) => ue === 1 || ue === 2
              }), this.lineThroughPeriod = (0, m.getStringOption)(C.lineThroughPeriod, ["all", "word"]), this.overline = (0, m.getInteger)({
                data: C.overline,
                defaultValue: 0,
                validate: (ue) => ue === 1 || ue === 2
              }), this.overlinePeriod = (0, m.getStringOption)(C.overlinePeriod, ["all", "word"]), this.posture = (0, m.getStringOption)(C.posture, ["normal", "italic"]), this.size = (0, m.getMeasurement)(C.size, "10pt"), this.typeface = C.typeface || "Courier", this.underline = (0, m.getInteger)({
                data: C.underline,
                defaultValue: 0,
                validate: (ue) => ue === 1 || ue === 2
              }), this.underlinePeriod = (0, m.getStringOption)(C.underlinePeriod, ["all", "word"]), this.use = C.use || "", this.usehref = C.usehref || "", this.weight = (0, m.getStringOption)(C.weight, ["normal", "bold"]), this.extras = null, this.fill = null;
            }
            [s.$clean](C) {
              super[s.$clean](C), this[s.$globalData].usedTypefaces.add(this.typeface);
            }
            [s.$toStyle]() {
              const C = (0, t.toStyle)(this, "fill"), ue = C.color;
              return ue && (ue === "#000000" ? delete C.color : ue.startsWith("#") || (C.background = ue, C.backgroundClip = "text", C.color = "transparent")), this.baselineShift && (C.verticalAlign = (0, t.measureToString)(this.baselineShift)), C.fontKerning = this.kerningMode === "none" ? "none" : "normal", C.letterSpacing = (0, t.measureToString)(this.letterSpacing), this.lineThrough !== 0 && (C.textDecoration = "line-through", this.lineThrough === 2 && (C.textDecorationStyle = "double")), this.overline !== 0 && (C.textDecoration = "overline", this.overline === 2 && (C.textDecorationStyle = "double")), C.fontStyle = this.posture, C.fontSize = (0, t.measureToString)(0.99 * this.size), (0, t.setFontFamily)(this, this, this[s.$globalData].fontFinder, C), this.underline !== 0 && (C.textDecoration = "underline", this.underline === 2 && (C.textDecorationStyle = "double")), C.fontWeight = this.weight, C;
            }
          }
          class Xt extends i.XFAObject {
            constructor(C) {
              super(x, "format", !0), this.id = C.id || "", this.use = C.use || "", this.usehref = C.usehref || "", this.extras = null, this.picture = null;
            }
          }
          class _e extends i.StringObject {
            constructor(C) {
              super(x, "handler"), this.id = C.id || "", this.type = (0, m.getStringOption)(C.type, ["optional", "required"]), this.use = C.use || "", this.usehref = C.usehref || "";
            }
          }
          class Qe extends i.XFAObject {
            constructor(C) {
              super(x, "hyphenation"), this.excludeAllCaps = (0, m.getInteger)({
                data: C.excludeAllCaps,
                defaultValue: 0,
                validate: (ue) => ue === 1
              }), this.excludeInitialCap = (0, m.getInteger)({
                data: C.excludeInitialCap,
                defaultValue: 0,
                validate: (ue) => ue === 1
              }), this.hyphenate = (0, m.getInteger)({
                data: C.hyphenate,
                defaultValue: 0,
                validate: (ue) => ue === 1
              }), this.id = C.id || "", this.pushCharacterCount = (0, m.getInteger)({
                data: C.pushCharacterCount,
                defaultValue: 3,
                validate: (ue) => ue >= 0
              }), this.remainCharacterCount = (0, m.getInteger)({
                data: C.remainCharacterCount,
                defaultValue: 3,
                validate: (ue) => ue >= 0
              }), this.use = C.use || "", this.usehref = C.usehref || "", this.wordCharacterCount = (0, m.getInteger)({
                data: C.wordCharacterCount,
                defaultValue: 7,
                validate: (ue) => ue >= 0
              });
            }
          }
          class qe extends i.StringObject {
            constructor(C) {
              super(x, "image"), this.aspect = (0, m.getStringOption)(C.aspect, ["fit", "actual", "height", "none", "width"]), this.contentType = C.contentType || "", this.href = C.href || "", this.id = C.id || "", this.name = C.name || "", this.transferEncoding = (0, m.getStringOption)(C.transferEncoding, ["base64", "none", "package"]), this.use = C.use || "", this.usehref = C.usehref || "";
            }
            [s.$toHTML]() {
              if (this.contentType && !$.has(this.contentType.toLowerCase()))
                return m.HTMLResult.EMPTY;
              let C = this[s.$globalData].images && this[s.$globalData].images.get(this.href);
              if (!C && (this.href || !this[s.$content]) || (!C && this.transferEncoding === "base64" && (C = (0, v.stringToBytes)(atob(this[s.$content]))), !C))
                return m.HTMLResult.EMPTY;
              if (!this.contentType) {
                for (const [Ge, dt] of K)
                  if (C.length > Ge.length && Ge.every((Ct, Et) => Ct === C[Et])) {
                    this.contentType = dt;
                    break;
                  }
                if (!this.contentType)
                  return m.HTMLResult.EMPTY;
              }
              const ue = new Blob([C], {
                type: this.contentType
              });
              let je;
              switch (this.aspect) {
                case "fit":
                case "actual":
                  break;
                case "height":
                  je = {
                    height: "100%",
                    objectFit: "fill"
                  };
                  break;
                case "none":
                  je = {
                    width: "100%",
                    height: "100%",
                    objectFit: "fill"
                  };
                  break;
                case "width":
                  je = {
                    width: "100%",
                    objectFit: "fill"
                  };
                  break;
              }
              const He = this[s.$getParent]();
              return m.HTMLResult.success({
                name: "img",
                attributes: {
                  class: ["xfaImage"],
                  style: je,
                  src: URL.createObjectURL(ue),
                  alt: He ? T(He[s.$getParent]()) : null
                }
              });
            }
          }
          class Je extends i.XFAObject {
            constructor(C) {
              super(x, "imageEdit", !0), this.data = (0, m.getStringOption)(C.data, ["link", "embed"]), this.id = C.id || "", this.use = C.use || "", this.usehref = C.usehref || "", this.border = null, this.extras = null, this.margin = null;
            }
            [s.$toHTML](C) {
              return this.data === "embed" ? m.HTMLResult.success({
                name: "div",
                children: [],
                attributes: {}
              }) : m.HTMLResult.EMPTY;
            }
          }
          class nt extends i.ContentObject {
            constructor(C) {
              super(x, "integer"), this.id = C.id || "", this.name = C.name || "", this.use = C.use || "", this.usehref = C.usehref || "";
            }
            [s.$finalize]() {
              const C = parseInt(this[s.$content].trim(), 10);
              this[s.$content] = isNaN(C) ? null : C;
            }
            [s.$toHTML](C) {
              return w(this[s.$content] !== null ? this[s.$content].toString() : "");
            }
          }
          class At extends i.XFAObject {
            constructor(C) {
              super(x, "issuers", !0), this.id = C.id || "", this.type = (0, m.getStringOption)(C.type, ["optional", "required"]), this.use = C.use || "", this.usehref = C.usehref || "", this.certificate = new i.XFAObjectArray();
            }
          }
          class Rt extends i.XFAObject {
            constructor(C) {
              super(x, "items", !0), this.id = C.id || "", this.name = C.name || "", this.presence = (0, m.getStringOption)(C.presence, ["visible", "hidden", "inactive", "invisible"]), this.ref = C.ref || "", this.save = (0, m.getInteger)({
                data: C.save,
                defaultValue: 0,
                validate: (ue) => ue === 1
              }), this.use = C.use || "", this.usehref = C.usehref || "", this.boolean = new i.XFAObjectArray(), this.date = new i.XFAObjectArray(), this.dateTime = new i.XFAObjectArray(), this.decimal = new i.XFAObjectArray(), this.exData = new i.XFAObjectArray(), this.float = new i.XFAObjectArray(), this.image = new i.XFAObjectArray(), this.integer = new i.XFAObjectArray(), this.text = new i.XFAObjectArray(), this.time = new i.XFAObjectArray();
            }
            [s.$toHTML]() {
              const C = [];
              for (const ue of this[s.$getChildren]())
                C.push(ue[s.$text]());
              return m.HTMLResult.success(C);
            }
          }
          c.Items = Rt;
          class St extends i.XFAObject {
            constructor(C) {
              super(x, "keep", !0), this.id = C.id || "";
              const ue = ["none", "contentArea", "pageArea"];
              this.intact = (0, m.getStringOption)(C.intact, ue), this.next = (0, m.getStringOption)(C.next, ue), this.previous = (0, m.getStringOption)(C.previous, ue), this.use = C.use || "", this.usehref = C.usehref || "", this.extras = null;
            }
          }
          class _t extends i.XFAObject {
            constructor(C) {
              super(x, "keyUsage");
              const ue = ["", "yes", "no"];
              this.crlSign = (0, m.getStringOption)(C.crlSign, ue), this.dataEncipherment = (0, m.getStringOption)(C.dataEncipherment, ue), this.decipherOnly = (0, m.getStringOption)(C.decipherOnly, ue), this.digitalSignature = (0, m.getStringOption)(C.digitalSignature, ue), this.encipherOnly = (0, m.getStringOption)(C.encipherOnly, ue), this.id = C.id || "", this.keyAgreement = (0, m.getStringOption)(C.keyAgreement, ue), this.keyCertSign = (0, m.getStringOption)(C.keyCertSign, ue), this.keyEncipherment = (0, m.getStringOption)(C.keyEncipherment, ue), this.nonRepudiation = (0, m.getStringOption)(C.nonRepudiation, ue), this.type = (0, m.getStringOption)(C.type, ["optional", "required"]), this.use = C.use || "", this.usehref = C.usehref || "";
            }
          }
          class Zt extends i.XFAObject {
            constructor(C) {
              super(x, "line", !0), this.hand = (0, m.getStringOption)(C.hand, ["even", "left", "right"]), this.id = C.id || "", this.slope = (0, m.getStringOption)(C.slope, ["\\", "/"]), this.use = C.use || "", this.usehref = C.usehref || "", this.edge = null;
            }
            [s.$toHTML]() {
              const C = this[s.$getParent]()[s.$getParent](), ue = this.edge || new Se({}), je = ue[s.$toStyle](), He = /* @__PURE__ */ Object.create(null), Ge = ue.presence === "visible" ? ue.thickness : 0;
              He.strokeWidth = (0, t.measureToString)(Ge), He.stroke = je.color;
              let dt, Ct, Et, Vt, nn = "100%", _n = "100%";
              C.w <= Ge ? ([dt, Ct, Et, Vt] = ["50%", 0, "50%", "100%"], nn = He.strokeWidth) : C.h <= Ge ? ([dt, Ct, Et, Vt] = [0, "50%", "100%", "50%"], _n = He.strokeWidth) : this.slope === "\\" ? [dt, Ct, Et, Vt] = [0, 0, "100%", "100%"] : [dt, Ct, Et, Vt] = [0, "100%", "100%", 0];
              const Cn = {
                name: "svg",
                children: [{
                  name: "line",
                  attributes: {
                    xmlns: b,
                    x1: dt,
                    y1: Ct,
                    x2: Et,
                    y2: Vt,
                    style: He
                  }
                }],
                attributes: {
                  xmlns: b,
                  width: nn,
                  height: _n,
                  style: {
                    overflow: "visible"
                  }
                }
              };
              return B(C) ? m.HTMLResult.success({
                name: "div",
                attributes: {
                  style: {
                    display: "inline",
                    width: "100%",
                    height: "100%"
                  }
                },
                children: [Cn]
              }) : (Cn.attributes.style.position = "absolute", m.HTMLResult.success(Cn));
            }
          }
          class an extends i.XFAObject {
            constructor(C) {
              super(x, "linear", !0), this.id = C.id || "", this.type = (0, m.getStringOption)(C.type, ["toRight", "toBottom", "toLeft", "toTop"]), this.use = C.use || "", this.usehref = C.usehref || "", this.color = null, this.extras = null;
            }
            [s.$toStyle](C) {
              C = C ? C[s.$toStyle]() : "#FFFFFF";
              const ue = this.type.replace(/([RBLT])/, " $1").toLowerCase(), je = this.color ? this.color[s.$toStyle]() : "#000000";
              return `linear-gradient(${ue}, ${C}, ${je})`;
            }
          }
          class ze extends i.ContentObject {
            constructor(C) {
              super(x, "lockDocument"), this.id = C.id || "", this.type = (0, m.getStringOption)(C.type, ["optional", "required"]), this.use = C.use || "", this.usehref = C.usehref || "";
            }
            [s.$finalize]() {
              this[s.$content] = (0, m.getStringOption)(this[s.$content], ["auto", "0", "1"]);
            }
          }
          class $e extends i.XFAObject {
            constructor(C) {
              super(x, "manifest", !0), this.action = (0, m.getStringOption)(C.action, ["include", "all", "exclude"]), this.id = C.id || "", this.name = C.name || "", this.use = C.use || "", this.usehref = C.usehref || "", this.extras = null, this.ref = new i.XFAObjectArray();
            }
          }
          class Ve extends i.XFAObject {
            constructor(C) {
              super(x, "margin", !0), this.bottomInset = (0, m.getMeasurement)(C.bottomInset, "0"), this.id = C.id || "", this.leftInset = (0, m.getMeasurement)(C.leftInset, "0"), this.rightInset = (0, m.getMeasurement)(C.rightInset, "0"), this.topInset = (0, m.getMeasurement)(C.topInset, "0"), this.use = C.use || "", this.usehref = C.usehref || "", this.extras = null;
            }
            [s.$toStyle]() {
              return {
                margin: (0, t.measureToString)(this.topInset) + " " + (0, t.measureToString)(this.rightInset) + " " + (0, t.measureToString)(this.bottomInset) + " " + (0, t.measureToString)(this.leftInset)
              };
            }
          }
          class Ke extends i.XFAObject {
            constructor(C) {
              super(x, "mdp"), this.id = C.id || "", this.permissions = (0, m.getInteger)({
                data: C.permissions,
                defaultValue: 2,
                validate: (ue) => ue === 1 || ue === 3
              }), this.signatureType = (0, m.getStringOption)(C.signatureType, ["filler", "author"]), this.use = C.use || "", this.usehref = C.usehref || "";
            }
          }
          class at extends i.XFAObject {
            constructor(C) {
              super(x, "medium"), this.id = C.id || "", this.imagingBBox = (0, m.getBBox)(C.imagingBBox), this.long = (0, m.getMeasurement)(C.long), this.orientation = (0, m.getStringOption)(C.orientation, ["portrait", "landscape"]), this.short = (0, m.getMeasurement)(C.short), this.stock = C.stock || "", this.trayIn = (0, m.getStringOption)(C.trayIn, ["auto", "delegate", "pageFront"]), this.trayOut = (0, m.getStringOption)(C.trayOut, ["auto", "delegate"]), this.use = C.use || "", this.usehref = C.usehref || "";
            }
          }
          class It extends i.XFAObject {
            constructor(C) {
              super(x, "message", !0), this.id = C.id || "", this.use = C.use || "", this.usehref = C.usehref || "", this.text = new i.XFAObjectArray();
            }
          }
          class st extends i.XFAObject {
            constructor(C) {
              super(x, "numericEdit", !0), this.hScrollPolicy = (0, m.getStringOption)(C.hScrollPolicy, ["auto", "off", "on"]), this.id = C.id || "", this.use = C.use || "", this.usehref = C.usehref || "", this.border = null, this.comb = null, this.extras = null, this.margin = null;
            }
            [s.$toHTML](C) {
              var Ge;
              const ue = (0, t.toStyle)(this, "border", "font", "margin"), je = this[s.$getParent]()[s.$getParent](), He = {
                name: "input",
                attributes: {
                  type: "text",
                  fieldId: je[s.$uid],
                  dataId: ((Ge = je[s.$data]) == null ? void 0 : Ge[s.$uid]) || je[s.$uid],
                  class: ["xfaTextfield"],
                  style: ue,
                  "aria-label": T(je),
                  "aria-required": !1
                }
              };
              return A(je) && (He.attributes["aria-required"] = !0, He.attributes.required = !0), m.HTMLResult.success({
                name: "label",
                attributes: {
                  class: ["xfaLabel"]
                },
                children: [He]
              });
            }
          }
          class Ze extends i.XFAObject {
            constructor(C) {
              super(x, "occur", !0), this.id = C.id || "", this.initial = C.initial !== "" ? (0, m.getInteger)({
                data: C.initial,
                defaultValue: "",
                validate: (ue) => !0
              }) : "", this.max = C.max !== "" ? (0, m.getInteger)({
                data: C.max,
                defaultValue: 1,
                validate: (ue) => !0
              }) : "", this.min = C.min !== "" ? (0, m.getInteger)({
                data: C.min,
                defaultValue: 1,
                validate: (ue) => !0
              }) : "", this.use = C.use || "", this.usehref = C.usehref || "", this.extras = null;
            }
            [s.$clean]() {
              const C = this[s.$getParent](), ue = this.min;
              this.min === "" && (this.min = C instanceof Ft || C instanceof Dt ? 0 : 1), this.max === "" && (ue === "" ? this.max = C instanceof Ft || C instanceof Dt ? -1 : 1 : this.max = this.min), this.max !== -1 && this.max < this.min && (this.max = this.min), this.initial === "" && (this.initial = C instanceof ao ? 1 : this.min);
            }
          }
          class gt extends i.StringObject {
            constructor(C) {
              super(x, "oid"), this.id = C.id || "", this.name = C.name || "", this.use = C.use || "", this.usehref = C.usehref || "";
            }
          }
          class Lt extends i.XFAObject {
            constructor(C) {
              super(x, "oids", !0), this.id = C.id || "", this.type = (0, m.getStringOption)(C.type, ["optional", "required"]), this.use = C.use || "", this.usehref = C.usehref || "", this.oid = new i.XFAObjectArray();
            }
          }
          class Yt extends i.XFAObject {
            constructor(C) {
              super(x, "overflow"), this.id = C.id || "", this.leader = C.leader || "", this.target = C.target || "", this.trailer = C.trailer || "", this.use = C.use || "", this.usehref = C.usehref || "";
            }
            [s.$getExtra]() {
              if (!this[s.$extra]) {
                const C = this[s.$getParent](), ue = this[s.$getTemplateRoot](), je = ue[s.$searchNode](this.target, C), He = ue[s.$searchNode](this.leader, C), Ge = ue[s.$searchNode](this.trailer, C);
                this[s.$extra] = {
                  target: (je == null ? void 0 : je[0]) || null,
                  leader: (He == null ? void 0 : He[0]) || null,
                  trailer: (Ge == null ? void 0 : Ge[0]) || null,
                  addLeader: !1,
                  addTrailer: !1
                };
              }
              return this[s.$extra];
            }
          }
          class Ft extends i.XFAObject {
            constructor(C) {
              super(x, "pageArea", !0), this.blankOrNotBlank = (0, m.getStringOption)(C.blankOrNotBlank, ["any", "blank", "notBlank"]), this.id = C.id || "", this.initialNumber = (0, m.getInteger)({
                data: C.initialNumber,
                defaultValue: 1,
                validate: (ue) => !0
              }), this.name = C.name || "", this.numbered = (0, m.getInteger)({
                data: C.numbered,
                defaultValue: 1,
                validate: (ue) => !0
              }), this.oddOrEven = (0, m.getStringOption)(C.oddOrEven, ["any", "even", "odd"]), this.pagePosition = (0, m.getStringOption)(C.pagePosition, ["any", "first", "last", "only", "rest"]), this.relevant = (0, m.getRelevant)(C.relevant), this.use = C.use || "", this.usehref = C.usehref || "", this.desc = null, this.extras = null, this.medium = null, this.occur = null, this.area = new i.XFAObjectArray(), this.contentArea = new i.XFAObjectArray(), this.draw = new i.XFAObjectArray(), this.exclGroup = new i.XFAObjectArray(), this.field = new i.XFAObjectArray(), this.subform = new i.XFAObjectArray();
            }
            [s.$isUsable]() {
              return this[s.$extra] ? !this.occur || this.occur.max === -1 || this[s.$extra].numberOfUse < this.occur.max : (this[s.$extra] = {
                numberOfUse: 0
              }, !0);
            }
            [s.$cleanPage]() {
              delete this[s.$extra];
            }
            [s.$getNextPage]() {
              this[s.$extra] || (this[s.$extra] = {
                numberOfUse: 0
              });
              const C = this[s.$getParent]();
              return C.relation === "orderedOccurrence" && this[s.$isUsable]() ? (this[s.$extra].numberOfUse += 1, this) : C[s.$getNextPage]();
            }
            [s.$getAvailableSpace]() {
              return this[s.$extra].space || {
                width: 0,
                height: 0
              };
            }
            [s.$toHTML]() {
              this[s.$extra] || (this[s.$extra] = {
                numberOfUse: 1
              });
              const C = [];
              this[s.$extra].children = C;
              const ue = /* @__PURE__ */ Object.create(null);
              if (this.medium && this.medium.short && this.medium.long) {
                if (ue.width = (0, t.measureToString)(this.medium.short), ue.height = (0, t.measureToString)(this.medium.long), this[s.$extra].space = {
                  width: this.medium.short,
                  height: this.medium.long
                }, this.medium.orientation === "landscape") {
                  const je = ue.width;
                  ue.width = ue.height, ue.height = je, this[s.$extra].space = {
                    width: this.medium.long,
                    height: this.medium.short
                  };
                }
              } else
                (0, v.warn)("XFA - No medium specified in pageArea: please file a bug.");
              return this[s.$childrenToHTML]({
                filter: /* @__PURE__ */ new Set(["area", "draw", "field", "subform"]),
                include: !0
              }), this[s.$childrenToHTML]({
                filter: /* @__PURE__ */ new Set(["contentArea"]),
                include: !0
              }), m.HTMLResult.success({
                name: "div",
                children: C,
                attributes: {
                  class: ["xfaPage"],
                  id: this[s.$uid],
                  style: ue,
                  xfaName: this.name
                }
              });
            }
          }
          class Dt extends i.XFAObject {
            constructor(C) {
              super(x, "pageSet", !0), this.duplexImposition = (0, m.getStringOption)(C.duplexImposition, ["longEdge", "shortEdge"]), this.id = C.id || "", this.name = C.name || "", this.relation = (0, m.getStringOption)(C.relation, ["orderedOccurrence", "duplexPaginated", "simplexPaginated"]), this.relevant = (0, m.getRelevant)(C.relevant), this.use = C.use || "", this.usehref = C.usehref || "", this.extras = null, this.occur = null, this.pageArea = new i.XFAObjectArray(), this.pageSet = new i.XFAObjectArray();
            }
            [s.$cleanPage]() {
              for (const C of this.pageArea.children)
                C[s.$cleanPage]();
              for (const C of this.pageSet.children)
                C[s.$cleanPage]();
            }
            [s.$isUsable]() {
              return !this.occur || this.occur.max === -1 || this[s.$extra].numberOfUse < this.occur.max;
            }
            [s.$getNextPage]() {
              if (this[s.$extra] || (this[s.$extra] = {
                numberOfUse: 1,
                pageIndex: -1,
                pageSetIndex: -1
              }), this.relation === "orderedOccurrence") {
                if (this[s.$extra].pageIndex + 1 < this.pageArea.children.length)
                  return this[s.$extra].pageIndex += 1, this.pageArea.children[this[s.$extra].pageIndex][s.$getNextPage]();
                if (this[s.$extra].pageSetIndex + 1 < this.pageSet.children.length)
                  return this[s.$extra].pageSetIndex += 1, this.pageSet.children[this[s.$extra].pageSetIndex][s.$getNextPage]();
                if (this[s.$isUsable]())
                  return this[s.$extra].numberOfUse += 1, this[s.$extra].pageIndex = -1, this[s.$extra].pageSetIndex = -1, this[s.$getNextPage]();
                const Ge = this[s.$getParent]();
                return Ge instanceof Dt ? Ge[s.$getNextPage]() : (this[s.$cleanPage](), this[s.$getNextPage]());
              }
              const C = this[s.$getTemplateRoot]()[s.$extra].pageNumber, ue = C % 2 === 0 ? "even" : "odd", je = C === 0 ? "first" : "rest";
              let He = this.pageArea.children.find((Ge) => Ge.oddOrEven === ue && Ge.pagePosition === je);
              return He || (He = this.pageArea.children.find((Ge) => Ge.oddOrEven === "any" && Ge.pagePosition === je), He) || (He = this.pageArea.children.find((Ge) => Ge.oddOrEven === "any" && Ge.pagePosition === "any"), He) ? He : this.pageArea.children[0];
            }
          }
          class Wt extends i.XFAObject {
            constructor(C) {
              super(x, "para", !0), this.hAlign = (0, m.getStringOption)(C.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]), this.id = C.id || "", this.lineHeight = C.lineHeight ? (0, m.getMeasurement)(C.lineHeight, "0pt") : "", this.marginLeft = C.marginLeft ? (0, m.getMeasurement)(C.marginLeft, "0pt") : "", this.marginRight = C.marginRight ? (0, m.getMeasurement)(C.marginRight, "0pt") : "", this.orphans = (0, m.getInteger)({
                data: C.orphans,
                defaultValue: 0,
                validate: (ue) => ue >= 0
              }), this.preserve = C.preserve || "", this.radixOffset = C.radixOffset ? (0, m.getMeasurement)(C.radixOffset, "0pt") : "", this.spaceAbove = C.spaceAbove ? (0, m.getMeasurement)(C.spaceAbove, "0pt") : "", this.spaceBelow = C.spaceBelow ? (0, m.getMeasurement)(C.spaceBelow, "0pt") : "", this.tabDefault = C.tabDefault ? (0, m.getMeasurement)(this.tabDefault) : "", this.tabStops = (C.tabStops || "").trim().split(/\s+/).map((ue, je) => je % 2 === 1 ? (0, m.getMeasurement)(ue) : ue), this.textIndent = C.textIndent ? (0, m.getMeasurement)(C.textIndent, "0pt") : "", this.use = C.use || "", this.usehref = C.usehref || "", this.vAlign = (0, m.getStringOption)(C.vAlign, ["top", "bottom", "middle"]), this.widows = (0, m.getInteger)({
                data: C.widows,
                defaultValue: 0,
                validate: (ue) => ue >= 0
              }), this.hyphenation = null;
            }
            [s.$toStyle]() {
              const C = (0, t.toStyle)(this, "hAlign");
              return this.marginLeft !== "" && (C.paddingLeft = (0, t.measureToString)(this.marginLeft)), this.marginRight !== "" && (C.paddingight = (0, t.measureToString)(this.marginRight)), this.spaceAbove !== "" && (C.paddingTop = (0, t.measureToString)(this.spaceAbove)), this.spaceBelow !== "" && (C.paddingBottom = (0, t.measureToString)(this.spaceBelow)), this.textIndent !== "" && (C.textIndent = (0, t.measureToString)(this.textIndent), (0, t.fixTextIndent)(C)), this.lineHeight > 0 && (C.lineHeight = (0, t.measureToString)(this.lineHeight)), this.tabDefault !== "" && (C.tabSize = (0, t.measureToString)(this.tabDefault)), this.tabStops.length > 0, this.hyphenatation && Object.assign(C, this.hyphenatation[s.$toStyle]()), C;
            }
          }
          class xt extends i.XFAObject {
            constructor(C) {
              super(x, "passwordEdit", !0), this.hScrollPolicy = (0, m.getStringOption)(C.hScrollPolicy, ["auto", "off", "on"]), this.id = C.id || "", this.passwordChar = C.passwordChar || "*", this.use = C.use || "", this.usehref = C.usehref || "", this.border = null, this.extras = null, this.margin = null;
            }
          }
          class Bt extends i.XFAObject {
            constructor(C) {
              super(x, "pattern", !0), this.id = C.id || "", this.type = (0, m.getStringOption)(C.type, ["crossHatch", "crossDiagonal", "diagonalLeft", "diagonalRight", "horizontal", "vertical"]), this.use = C.use || "", this.usehref = C.usehref || "", this.color = null, this.extras = null;
            }
            [s.$toStyle](C) {
              C = C ? C[s.$toStyle]() : "#FFFFFF";
              const ue = this.color ? this.color[s.$toStyle]() : "#000000", je = 5, He = "repeating-linear-gradient", Ge = `${C},${C} ${je}px,${ue} ${je}px,${ue} ${2 * je}px`;
              switch (this.type) {
                case "crossHatch":
                  return `${He}(to top,${Ge}) ${He}(to right,${Ge})`;
                case "crossDiagonal":
                  return `${He}(45deg,${Ge}) ${He}(-45deg,${Ge})`;
                case "diagonalLeft":
                  return `${He}(45deg,${Ge})`;
                case "diagonalRight":
                  return `${He}(-45deg,${Ge})`;
                case "horizontal":
                  return `${He}(to top,${Ge})`;
                case "vertical":
                  return `${He}(to right,${Ge})`;
              }
              return "";
            }
          }
          class ht extends i.StringObject {
            constructor(C) {
              super(x, "picture"), this.id = C.id || "", this.use = C.use || "", this.usehref = C.usehref || "";
            }
          }
          class Ht extends i.XFAObject {
            constructor(C) {
              super(x, "proto", !0), this.appearanceFilter = new i.XFAObjectArray(), this.arc = new i.XFAObjectArray(), this.area = new i.XFAObjectArray(), this.assist = new i.XFAObjectArray(), this.barcode = new i.XFAObjectArray(), this.bindItems = new i.XFAObjectArray(), this.bookend = new i.XFAObjectArray(), this.boolean = new i.XFAObjectArray(), this.border = new i.XFAObjectArray(), this.break = new i.XFAObjectArray(), this.breakAfter = new i.XFAObjectArray(), this.breakBefore = new i.XFAObjectArray(), this.button = new i.XFAObjectArray(), this.calculate = new i.XFAObjectArray(), this.caption = new i.XFAObjectArray(), this.certificate = new i.XFAObjectArray(), this.certificates = new i.XFAObjectArray(), this.checkButton = new i.XFAObjectArray(), this.choiceList = new i.XFAObjectArray(), this.color = new i.XFAObjectArray(), this.comb = new i.XFAObjectArray(), this.connect = new i.XFAObjectArray(), this.contentArea = new i.XFAObjectArray(), this.corner = new i.XFAObjectArray(), this.date = new i.XFAObjectArray(), this.dateTime = new i.XFAObjectArray(), this.dateTimeEdit = new i.XFAObjectArray(), this.decimal = new i.XFAObjectArray(), this.defaultUi = new i.XFAObjectArray(), this.desc = new i.XFAObjectArray(), this.digestMethod = new i.XFAObjectArray(), this.digestMethods = new i.XFAObjectArray(), this.draw = new i.XFAObjectArray(), this.edge = new i.XFAObjectArray(), this.encoding = new i.XFAObjectArray(), this.encodings = new i.XFAObjectArray(), this.encrypt = new i.XFAObjectArray(), this.encryptData = new i.XFAObjectArray(), this.encryption = new i.XFAObjectArray(), this.encryptionMethod = new i.XFAObjectArray(), this.encryptionMethods = new i.XFAObjectArray(), this.event = new i.XFAObjectArray(), this.exData = new i.XFAObjectArray(), this.exObject = new i.XFAObjectArray(), this.exclGroup = new i.XFAObjectArray(), this.execute = new i.XFAObjectArray(), this.extras = new i.XFAObjectArray(), this.field = new i.XFAObjectArray(), this.fill = new i.XFAObjectArray(), this.filter = new i.XFAObjectArray(), this.float = new i.XFAObjectArray(), this.font = new i.XFAObjectArray(), this.format = new i.XFAObjectArray(), this.handler = new i.XFAObjectArray(), this.hyphenation = new i.XFAObjectArray(), this.image = new i.XFAObjectArray(), this.imageEdit = new i.XFAObjectArray(), this.integer = new i.XFAObjectArray(), this.issuers = new i.XFAObjectArray(), this.items = new i.XFAObjectArray(), this.keep = new i.XFAObjectArray(), this.keyUsage = new i.XFAObjectArray(), this.line = new i.XFAObjectArray(), this.linear = new i.XFAObjectArray(), this.lockDocument = new i.XFAObjectArray(), this.manifest = new i.XFAObjectArray(), this.margin = new i.XFAObjectArray(), this.mdp = new i.XFAObjectArray(), this.medium = new i.XFAObjectArray(), this.message = new i.XFAObjectArray(), this.numericEdit = new i.XFAObjectArray(), this.occur = new i.XFAObjectArray(), this.oid = new i.XFAObjectArray(), this.oids = new i.XFAObjectArray(), this.overflow = new i.XFAObjectArray(), this.pageArea = new i.XFAObjectArray(), this.pageSet = new i.XFAObjectArray(), this.para = new i.XFAObjectArray(), this.passwordEdit = new i.XFAObjectArray(), this.pattern = new i.XFAObjectArray(), this.picture = new i.XFAObjectArray(), this.radial = new i.XFAObjectArray(), this.reason = new i.XFAObjectArray(), this.reasons = new i.XFAObjectArray(), this.rectangle = new i.XFAObjectArray(), this.ref = new i.XFAObjectArray(), this.script = new i.XFAObjectArray(), this.setProperty = new i.XFAObjectArray(), this.signData = new i.XFAObjectArray(), this.signature = new i.XFAObjectArray(), this.signing = new i.XFAObjectArray(), this.solid = new i.XFAObjectArray(), this.speak = new i.XFAObjectArray(), this.stipple = new i.XFAObjectArray(), this.subform = new i.XFAObjectArray(), this.subformSet = new i.XFAObjectArray(), this.subjectDN = new i.XFAObjectArray(), this.subjectDNs = new i.XFAObjectArray(), this.submit = new i.XFAObjectArray(), this.text = new i.XFAObjectArray(), this.textEdit = new i.XFAObjectArray(), this.time = new i.XFAObjectArray(), this.timeStamp = new i.XFAObjectArray(), this.toolTip = new i.XFAObjectArray(), this.traversal = new i.XFAObjectArray(), this.traverse = new i.XFAObjectArray(), this.ui = new i.XFAObjectArray(), this.validate = new i.XFAObjectArray(), this.value = new i.XFAObjectArray(), this.variables = new i.XFAObjectArray();
            }
          }
          class Qt extends i.XFAObject {
            constructor(C) {
              super(x, "radial", !0), this.id = C.id || "", this.type = (0, m.getStringOption)(C.type, ["toEdge", "toCenter"]), this.use = C.use || "", this.usehref = C.usehref || "", this.color = null, this.extras = null;
            }
            [s.$toStyle](C) {
              C = C ? C[s.$toStyle]() : "#FFFFFF";
              const ue = this.color ? this.color[s.$toStyle]() : "#000000";
              return `radial-gradient(circle at center, ${this.type === "toEdge" ? `${C},${ue}` : `${ue},${C}`})`;
            }
          }
          class Vn extends i.StringObject {
            constructor(C) {
              super(x, "reason"), this.id = C.id || "", this.name = C.name || "", this.use = C.use || "", this.usehref = C.usehref || "";
            }
          }
          class $t extends i.XFAObject {
            constructor(C) {
              super(x, "reasons", !0), this.id = C.id || "", this.type = (0, m.getStringOption)(C.type, ["optional", "required"]), this.use = C.use || "", this.usehref = C.usehref || "", this.reason = new i.XFAObjectArray();
            }
          }
          class Ut extends i.XFAObject {
            constructor(C) {
              super(x, "rectangle", !0), this.hand = (0, m.getStringOption)(C.hand, ["even", "left", "right"]), this.id = C.id || "", this.use = C.use || "", this.usehref = C.usehref || "", this.corner = new i.XFAObjectArray(4), this.edge = new i.XFAObjectArray(4), this.fill = null;
            }
            [s.$toHTML]() {
              var Vt;
              const C = this.edge.children.length ? this.edge.children[0] : new Se({}), ue = C[s.$toStyle](), je = /* @__PURE__ */ Object.create(null);
              ((Vt = this.fill) == null ? void 0 : Vt.presence) === "visible" ? Object.assign(je, this.fill[s.$toStyle]()) : je.fill = "transparent", je.strokeWidth = (0, t.measureToString)(C.presence === "visible" ? C.thickness : 0), je.stroke = ue.color;
              const Ge = (this.corner.children.length ? this.corner.children[0] : new pe({}))[s.$toStyle](), Ct = {
                name: "svg",
                children: [{
                  name: "rect",
                  attributes: {
                    xmlns: b,
                    width: "100%",
                    height: "100%",
                    x: 0,
                    y: 0,
                    rx: Ge.radius,
                    ry: Ge.radius,
                    style: je
                  }
                }],
                attributes: {
                  xmlns: b,
                  style: {
                    overflow: "visible"
                  },
                  width: "100%",
                  height: "100%"
                }
              }, Et = this[s.$getParent]()[s.$getParent]();
              return B(Et) ? m.HTMLResult.success({
                name: "div",
                attributes: {
                  style: {
                    display: "inline",
                    width: "100%",
                    height: "100%"
                  }
                },
                children: [Ct]
              }) : (Ct.attributes.style.position = "absolute", m.HTMLResult.success(Ct));
            }
          }
          class dn extends i.StringObject {
            constructor(C) {
              super(x, "ref"), this.id = C.id || "", this.use = C.use || "", this.usehref = C.usehref || "";
            }
          }
          class kn extends i.StringObject {
            constructor(C) {
              super(x, "script"), this.binding = C.binding || "", this.contentType = C.contentType || "", this.id = C.id || "", this.name = C.name || "", this.runAt = (0, m.getStringOption)(C.runAt, ["client", "both", "server"]), this.use = C.use || "", this.usehref = C.usehref || "";
            }
          }
          class _i extends i.XFAObject {
            constructor(C) {
              super(x, "setProperty"), this.connection = C.connection || "", this.ref = C.ref || "", this.target = C.target || "";
            }
          }
          c.SetProperty = _i;
          class As extends i.XFAObject {
            constructor(C) {
              super(x, "signData", !0), this.id = C.id || "", this.operation = (0, m.getStringOption)(C.operation, ["sign", "clear", "verify"]), this.ref = C.ref || "", this.target = C.target || "", this.use = C.use || "", this.usehref = C.usehref || "", this.filter = null, this.manifest = null;
            }
          }
          class Q0 extends i.XFAObject {
            constructor(C) {
              super(x, "signature", !0), this.id = C.id || "", this.type = (0, m.getStringOption)(C.type, ["PDF1.3", "PDF1.6"]), this.use = C.use || "", this.usehref = C.usehref || "", this.border = null, this.extras = null, this.filter = null, this.manifest = null, this.margin = null;
            }
          }
          class J0 extends i.XFAObject {
            constructor(C) {
              super(x, "signing", !0), this.id = C.id || "", this.type = (0, m.getStringOption)(C.type, ["optional", "required"]), this.use = C.use || "", this.usehref = C.usehref || "", this.certificate = new i.XFAObjectArray();
            }
          }
          class eu extends i.XFAObject {
            constructor(C) {
              super(x, "solid", !0), this.id = C.id || "", this.use = C.use || "", this.usehref = C.usehref || "", this.extras = null;
            }
            [s.$toStyle](C) {
              return C ? C[s.$toStyle]() : "#FFFFFF";
            }
          }
          class tu extends i.StringObject {
            constructor(C) {
              super(x, "speak"), this.disable = (0, m.getInteger)({
                data: C.disable,
                defaultValue: 0,
                validate: (ue) => ue === 1
              }), this.id = C.id || "", this.priority = (0, m.getStringOption)(C.priority, ["custom", "caption", "name", "toolTip"]), this.rid = C.rid || "", this.use = C.use || "", this.usehref = C.usehref || "";
            }
          }
          class nu extends i.XFAObject {
            constructor(C) {
              super(x, "stipple", !0), this.id = C.id || "", this.rate = (0, m.getInteger)({
                data: C.rate,
                defaultValue: 50,
                validate: (ue) => ue >= 0 && ue <= 100
              }), this.use = C.use || "", this.usehref = C.usehref || "", this.color = null, this.extras = null;
            }
            [s.$toStyle](C) {
              const ue = this.rate / 100;
              return v.Util.makeHexColor(Math.round(C.value.r * (1 - ue) + this.value.r * ue), Math.round(C.value.g * (1 - ue) + this.value.g * ue), Math.round(C.value.b * (1 - ue) + this.value.b * ue));
            }
          }
          class Fc extends i.XFAObject {
            constructor(C) {
              super(x, "subform", !0), this.access = (0, m.getStringOption)(C.access, ["open", "nonInteractive", "protected", "readOnly"]), this.allowMacro = (0, m.getInteger)({
                data: C.allowMacro,
                defaultValue: 0,
                validate: (ue) => ue === 1
              }), this.anchorType = (0, m.getStringOption)(C.anchorType, ["topLeft", "bottomCenter", "bottomLeft", "bottomRight", "middleCenter", "middleLeft", "middleRight", "topCenter", "topRight"]), this.colSpan = (0, m.getInteger)({
                data: C.colSpan,
                defaultValue: 1,
                validate: (ue) => ue >= 1 || ue === -1
              }), this.columnWidths = (C.columnWidths || "").trim().split(/\s+/).map((ue) => ue === "-1" ? -1 : (0, m.getMeasurement)(ue)), this.h = C.h ? (0, m.getMeasurement)(C.h) : "", this.hAlign = (0, m.getStringOption)(C.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]), this.id = C.id || "", this.layout = (0, m.getStringOption)(C.layout, ["position", "lr-tb", "rl-row", "rl-tb", "row", "table", "tb"]), this.locale = C.locale || "", this.maxH = (0, m.getMeasurement)(C.maxH, "0pt"), this.maxW = (0, m.getMeasurement)(C.maxW, "0pt"), this.mergeMode = (0, m.getStringOption)(C.mergeMode, ["consumeData", "matchTemplate"]), this.minH = (0, m.getMeasurement)(C.minH, "0pt"), this.minW = (0, m.getMeasurement)(C.minW, "0pt"), this.name = C.name || "", this.presence = (0, m.getStringOption)(C.presence, ["visible", "hidden", "inactive", "invisible"]), this.relevant = (0, m.getRelevant)(C.relevant), this.restoreState = (0, m.getStringOption)(C.restoreState, ["manual", "auto"]), this.scope = (0, m.getStringOption)(C.scope, ["name", "none"]), this.use = C.use || "", this.usehref = C.usehref || "", this.w = C.w ? (0, m.getMeasurement)(C.w) : "", this.x = (0, m.getMeasurement)(C.x, "0pt"), this.y = (0, m.getMeasurement)(C.y, "0pt"), this.assist = null, this.bind = null, this.bookend = null, this.border = null, this.break = null, this.calculate = null, this.desc = null, this.extras = null, this.keep = null, this.margin = null, this.occur = null, this.overflow = null, this.pageSet = null, this.para = null, this.traversal = null, this.validate = null, this.variables = null, this.area = new i.XFAObjectArray(), this.breakAfter = new i.XFAObjectArray(), this.breakBefore = new i.XFAObjectArray(), this.connect = new i.XFAObjectArray(), this.draw = new i.XFAObjectArray(), this.event = new i.XFAObjectArray(), this.exObject = new i.XFAObjectArray(), this.exclGroup = new i.XFAObjectArray(), this.field = new i.XFAObjectArray(), this.proto = new i.XFAObjectArray(), this.setProperty = new i.XFAObjectArray(), this.subform = new i.XFAObjectArray(), this.subformSet = new i.XFAObjectArray();
            }
            [s.$getSubformParent]() {
              const C = this[s.$getParent]();
              return C instanceof so ? C[s.$getSubformParent]() : C;
            }
            [s.$isBindable]() {
              return !0;
            }
            [s.$isThereMoreWidth]() {
              return this.layout.endsWith("-tb") && this[s.$extra].attempt === 0 && this[s.$extra].numberInLine > 0 || this[s.$getParent]()[s.$isThereMoreWidth]();
            }
            *[s.$getContainedChildren]() {
              yield* _(this);
            }
            [s.$flushHTML]() {
              return (0, g.flushHTML)(this);
            }
            [s.$addHTML](C, ue) {
              (0, g.addHTML)(this, C, ue);
            }
            [s.$getAvailableSpace]() {
              return (0, g.getAvailableSpace)(this);
            }
            [s.$isSplittable]() {
              var ue;
              const C = this[s.$getSubformParent]();
              return C[s.$isSplittable]() ? this[s.$extra]._isSplittable !== void 0 ? this[s.$extra]._isSplittable : this.layout === "position" || this.layout.includes("row") ? (this[s.$extra]._isSplittable = !1, !1) : this.keep && this.keep.intact !== "none" ? (this[s.$extra]._isSplittable = !1, !1) : (ue = C.layout) != null && ue.endsWith("-tb") && C[s.$extra].numberInLine !== 0 ? !1 : (this[s.$extra]._isSplittable = !0, !0) : !1;
            }
            [s.$toHTML](C) {
              var sn;
              if (k(this), this.break) {
                if (this.break.after !== "auto" || this.break.afterTarget !== "") {
                  const Ot = new ae({
                    targetType: this.break.after,
                    target: this.break.afterTarget,
                    startNew: this.break.startNew.toString()
                  });
                  Ot[s.$globalData] = this[s.$globalData], this[s.$appendChild](Ot), this.breakAfter.push(Ot);
                }
                if (this.break.before !== "auto" || this.break.beforeTarget !== "") {
                  const Ot = new se({
                    targetType: this.break.before,
                    target: this.break.beforeTarget,
                    startNew: this.break.startNew.toString()
                  });
                  Ot[s.$globalData] = this[s.$globalData], this[s.$appendChild](Ot), this.breakBefore.push(Ot);
                }
                if (this.break.overflowTarget !== "") {
                  const Ot = new Yt({
                    target: this.break.overflowTarget,
                    leader: this.break.overflowLeader,
                    trailer: this.break.overflowTrailer
                  });
                  Ot[s.$globalData] = this[s.$globalData], this[s.$appendChild](Ot), this.overflow.push(Ot);
                }
                this[s.$removeChild](this.break), this.break = null;
              }
              if (this.presence === "hidden" || this.presence === "inactive")
                return m.HTMLResult.EMPTY;
              if ((this.breakBefore.children.length > 1 || this.breakAfter.children.length > 1) && (0, v.warn)("XFA - Several breakBefore or breakAfter in subforms: please file a bug."), this.breakBefore.children.length >= 1) {
                const Ot = this.breakBefore.children[0];
                if (P(Ot))
                  return m.HTMLResult.breakNode(Ot);
              }
              if ((sn = this[s.$extra]) != null && sn.afterBreakAfter)
                return m.HTMLResult.EMPTY;
              (0, t.fixDimensions)(this);
              const ue = [], je = {
                id: this[s.$uid],
                class: []
              };
              (0, t.setAccess)(this, je.class), this[s.$extra] || (this[s.$extra] = /* @__PURE__ */ Object.create(null)), Object.assign(this[s.$extra], {
                children: ue,
                line: null,
                attributes: je,
                attempt: 0,
                numberInLine: 0,
                availableSpace: {
                  width: Math.min(this.w || 1 / 0, C.width),
                  height: Math.min(this.h || 1 / 0, C.height)
                },
                width: 0,
                height: 0,
                prevHeight: 0,
                currentWidth: 0
              });
              const He = this[s.$getTemplateRoot](), Ge = He[s.$extra].noLayoutFailure, dt = this[s.$isSplittable]();
              if (dt || F(this), !(0, g.checkDimensions)(this, C))
                return m.HTMLResult.FAILURE;
              const Ct = /* @__PURE__ */ new Set(["area", "draw", "exclGroup", "field", "subform", "subformSet"]);
              if (this.layout.includes("row")) {
                const Ot = this[s.$getSubformParent]().columnWidths;
                Array.isArray(Ot) && Ot.length > 0 && (this[s.$extra].columnWidths = Ot, this[s.$extra].currentColumn = 0);
              }
              const Et = (0, t.toStyle)(this, "anchorType", "dimensions", "position", "presence", "border", "margin", "hAlign"), Vt = ["xfaSubform"], nn = (0, t.layoutClass)(this);
              if (nn && Vt.push(nn), je.style = Et, je.class = Vt, this.name && (je.xfaName = this.name), this.overflow) {
                const Ot = this.overflow[s.$getExtra]();
                Ot.addLeader && (Ot.addLeader = !1, V(this, Ot.leader, C));
              }
              this[s.$pushPara]();
              const _n = this.layout === "lr-tb" || this.layout === "rl-tb", hn = _n ? u : 1;
              for (; this[s.$extra].attempt < hn; this[s.$extra].attempt++) {
                _n && this[s.$extra].attempt === u - 1 && (this[s.$extra].numberInLine = 0);
                const Ot = this[s.$childrenToHTML]({
                  filter: Ct,
                  include: !0
                });
                if (Ot.success)
                  break;
                if (Ot.isBreak())
                  return this[s.$popPara](), Ot;
                if (_n && this[s.$extra].attempt === 0 && this[s.$extra].numberInLine === 0 && !He[s.$extra].noLayoutFailure) {
                  this[s.$extra].attempt = hn;
                  break;
                }
              }
              if (this[s.$popPara](), dt || j(this), He[s.$extra].noLayoutFailure = Ge, this[s.$extra].attempt === hn)
                return this.overflow && (this[s.$getTemplateRoot]()[s.$extra].overflowNode = this.overflow), dt || delete this[s.$extra], m.HTMLResult.FAILURE;
              if (this.overflow) {
                const Ot = this.overflow[s.$getExtra]();
                Ot.addTrailer && (Ot.addTrailer = !1, V(this, Ot.trailer, C));
              }
              let Cn = 0, $n = 0;
              this.margin && (Cn = this.margin.leftInset + this.margin.rightInset, $n = this.margin.topInset + this.margin.bottomInset);
              const Gt = Math.max(this[s.$extra].width + Cn, this.w || 0), ci = Math.max(this[s.$extra].height + $n, this.h || 0), En = [this.x, this.y, Gt, ci];
              if (this.w === "" && (Et.width = (0, t.measureToString)(Gt)), this.h === "" && (Et.height = (0, t.measureToString)(ci)), (Et.width === "0px" || Et.height === "0px") && ue.length === 0)
                return m.HTMLResult.EMPTY;
              const Ui = {
                name: "div",
                attributes: je,
                children: ue
              };
              z(this, je);
              const li = m.HTMLResult.success((0, t.createWrapper)(this, Ui), En);
              if (this.breakAfter.children.length >= 1) {
                const Ot = this.breakAfter.children[0];
                if (P(Ot))
                  return this[s.$extra].afterBreakAfter = li, m.HTMLResult.breakNode(Ot);
              }
              return delete this[s.$extra], li;
            }
          }
          class so extends i.XFAObject {
            constructor(C) {
              super(x, "subformSet", !0), this.id = C.id || "", this.name = C.name || "", this.relation = (0, m.getStringOption)(C.relation, ["ordered", "choice", "unordered"]), this.relevant = (0, m.getRelevant)(C.relevant), this.use = C.use || "", this.usehref = C.usehref || "", this.bookend = null, this.break = null, this.desc = null, this.extras = null, this.occur = null, this.overflow = null, this.breakAfter = new i.XFAObjectArray(), this.breakBefore = new i.XFAObjectArray(), this.subform = new i.XFAObjectArray(), this.subformSet = new i.XFAObjectArray();
            }
            *[s.$getContainedChildren]() {
              yield* _(this);
            }
            [s.$getSubformParent]() {
              let C = this[s.$getParent]();
              for (; !(C instanceof Fc); )
                C = C[s.$getParent]();
              return C;
            }
            [s.$isBindable]() {
              return !0;
            }
          }
          class iu extends i.ContentObject {
            constructor(C) {
              super(x, "subjectDN"), this.delimiter = C.delimiter || ",", this.id = C.id || "", this.name = C.name || "", this.use = C.use || "", this.usehref = C.usehref || "";
            }
            [s.$finalize]() {
              this[s.$content] = new Map(this[s.$content].split(this.delimiter).map((C) => (C = C.split("=", 2), C[0] = C[0].trim(), C)));
            }
          }
          class ru extends i.XFAObject {
            constructor(C) {
              super(x, "subjectDNs", !0), this.id = C.id || "", this.type = (0, m.getStringOption)(C.type, ["optional", "required"]), this.use = C.use || "", this.usehref = C.usehref || "", this.subjectDN = new i.XFAObjectArray();
            }
          }
          class su extends i.XFAObject {
            constructor(C) {
              super(x, "submit", !0), this.embedPDF = (0, m.getInteger)({
                data: C.embedPDF,
                defaultValue: 0,
                validate: (ue) => ue === 1
              }), this.format = (0, m.getStringOption)(C.format, ["xdp", "formdata", "pdf", "urlencoded", "xfd", "xml"]), this.id = C.id || "", this.target = C.target || "", this.textEncoding = (0, m.getKeyword)({
                data: C.textEncoding ? C.textEncoding.toLowerCase() : "",
                defaultValue: "",
                validate: (ue) => ["utf-8", "big-five", "fontspecific", "gbk", "gb-18030", "gb-2312", "ksc-5601", "none", "shift-jis", "ucs-2", "utf-16"].includes(ue) || ue.match(/iso-8859-\d{2}/)
              }), this.use = C.use || "", this.usehref = C.usehref || "", this.xdpContent = C.xdpContent || "", this.encrypt = null, this.encryptData = new i.XFAObjectArray(), this.signData = new i.XFAObjectArray();
            }
          }
          class ao extends i.XFAObject {
            constructor(C) {
              super(x, "template", !0), this.baseProfile = (0, m.getStringOption)(C.baseProfile, ["full", "interactiveForms"]), this.extras = null, this.subform = new i.XFAObjectArray();
            }
            [s.$finalize]() {
              this.subform.children.length === 0 && (0, v.warn)("XFA - No subforms in template node."), this.subform.children.length >= 2 && (0, v.warn)("XFA - Several subforms in template node: please file a bug."), this[s.$tabIndex] = O;
            }
            [s.$isSplittable]() {
              return !0;
            }
            [s.$searchNode](C, ue) {
              return C.startsWith("#") ? [this[s.$ids].get(C.slice(1))] : (0, y.searchNode)(this, ue, C, !0, !0);
            }
            *[s.$toPages]() {
              var $n, Gt, ci;
              if (!this.subform.children.length)
                return m.HTMLResult.success({
                  name: "div",
                  children: []
                });
              this[s.$extra] = {
                overflowNode: null,
                firstUnsplittable: null,
                currentContentArea: null,
                currentPageArea: null,
                noLayoutFailure: !1,
                pageNumber: 1,
                pagePosition: "first",
                oddOrEven: "odd",
                blankOrNotBlank: "nonBlank",
                paraStack: []
              };
              const C = this.subform.children[0];
              C.pageSet[s.$cleanPage]();
              const ue = C.pageSet.pageArea.children, je = {
                name: "div",
                children: []
              };
              let He = null, Ge = null, dt = null;
              if (C.breakBefore.children.length >= 1 ? (Ge = C.breakBefore.children[0], dt = Ge.target) : C.subform.children.length >= 1 && C.subform.children[0].breakBefore.children.length >= 1 ? (Ge = C.subform.children[0].breakBefore.children[0], dt = Ge.target) : ($n = C.break) != null && $n.beforeTarget ? (Ge = C.break, dt = Ge.beforeTarget) : C.subform.children.length >= 1 && ((Gt = C.subform.children[0].break) != null && Gt.beforeTarget) && (Ge = C.subform.children[0].break, dt = Ge.beforeTarget), Ge) {
                const En = this[s.$searchNode](dt, Ge[s.$getParent]());
                En instanceof Ft && (He = En, Ge[s.$extra] = {});
              }
              He || (He = ue[0]), He[s.$extra] = {
                numberOfUse: 1
              };
              const Ct = He[s.$getParent]();
              Ct[s.$extra] = {
                numberOfUse: 1,
                pageIndex: Ct.pageArea.children.indexOf(He),
                pageSetIndex: 0
              };
              let Et, Vt = null, nn = null, _n = !0, hn = 0, Cn = 0;
              for (; ; ) {
                if (_n)
                  hn = 0;
                else if (je.children.pop(), ++hn === I)
                  return (0, v.warn)("XFA - Something goes wrong: please file a bug."), je;
                Et = null, this[s.$extra].currentPageArea = He;
                const En = He[s.$toHTML]().html;
                je.children.push(En), Vt && (this[s.$extra].noLayoutFailure = !0, En.children.push(Vt[s.$toHTML](He[s.$extra].space).html), Vt = null), nn && (this[s.$extra].noLayoutFailure = !0, En.children.push(nn[s.$toHTML](He[s.$extra].space).html), nn = null);
                const Ui = He.contentArea.children, li = En.children.filter((Ot) => Ot.attributes.class.includes("xfaContentarea"));
                _n = !1, this[s.$extra].firstUnsplittable = null, this[s.$extra].noLayoutFailure = !1;
                const sn = (Ot) => {
                  var Yi;
                  const dr = C[s.$flushHTML]();
                  dr && (_n || (_n = ((Yi = dr.children) == null ? void 0 : Yi.length) > 0), li[Ot].children.push(dr));
                };
                for (let Ot = Cn, dr = Ui.length; Ot < dr; Ot++) {
                  const Yi = this[s.$extra].currentContentArea = Ui[Ot], ts = {
                    width: Yi.w,
                    height: Yi.h
                  };
                  Cn = 0, Vt && (li[Ot].children.push(Vt[s.$toHTML](ts).html), Vt = null), nn && (li[Ot].children.push(nn[s.$toHTML](ts).html), nn = null);
                  const yr = C[s.$toHTML](ts);
                  if (yr.success)
                    return yr.html ? (_n || (_n = ((ci = yr.html.children) == null ? void 0 : ci.length) > 0), li[Ot].children.push(yr.html)) : !_n && je.children.length > 1 && je.children.pop(), je;
                  if (yr.isBreak()) {
                    const ui = yr.breakNode;
                    if (sn(Ot), ui.targetType === "auto")
                      continue;
                    ui.leader && (Vt = this[s.$searchNode](ui.leader, ui[s.$getParent]()), Vt = Vt ? Vt[0] : null), ui.trailer && (nn = this[s.$searchNode](ui.trailer, ui[s.$getParent]()), nn = nn ? nn[0] : null), ui.targetType === "pageArea" ? (Et = ui[s.$extra].target, Ot = 1 / 0) : ui[s.$extra].target ? (Et = ui[s.$extra].target, Cn = ui[s.$extra].index + 1, Ot = 1 / 0) : Ot = ui[s.$extra].index;
                    continue;
                  }
                  if (this[s.$extra].overflowNode) {
                    const ui = this[s.$extra].overflowNode;
                    this[s.$extra].overflowNode = null;
                    const co = ui[s.$getExtra](), na = co.target;
                    co.addLeader = co.leader !== null, co.addTrailer = co.trailer !== null, sn(Ot);
                    const Dy = Ot;
                    if (Ot = 1 / 0, na instanceof Ft)
                      Et = na;
                    else if (na instanceof he) {
                      const Rc = Ui.indexOf(na);
                      Rc !== -1 ? Rc > Dy ? Ot = Rc - 1 : Cn = Rc : (Et = na[s.$getParent](), Cn = Et.contentArea.children.indexOf(na));
                    }
                    continue;
                  }
                  sn(Ot);
                }
                this[s.$extra].pageNumber += 1, Et && (Et[s.$isUsable]() ? Et[s.$extra].numberOfUse += 1 : Et = null), He = Et || He[s.$getNextPage](), yield null;
              }
            }
          }
          c.Template = ao;
          class Pc extends i.ContentObject {
            constructor(C) {
              super(x, "text"), this.id = C.id || "", this.maxChars = (0, m.getInteger)({
                data: C.maxChars,
                defaultValue: 0,
                validate: (ue) => ue >= 0
              }), this.name = C.name || "", this.rid = C.rid || "", this.use = C.use || "", this.usehref = C.usehref || "";
            }
            [s.$acceptWhitespace]() {
              return !0;
            }
            [s.$onChild](C) {
              return C[s.$namespaceId] === h.NamespaceIds.xhtml.id ? (this[s.$content] = C, !0) : ((0, v.warn)(`XFA - Invalid content in Text: ${C[s.$nodeName]}.`), !1);
            }
            [s.$onText](C) {
              this[s.$content] instanceof i.XFAObject || super[s.$onText](C);
            }
            [s.$finalize]() {
              typeof this[s.$content] == "string" && (this[s.$content] = this[s.$content].replaceAll(`\r
`, `
`));
            }
            [s.$getExtra]() {
              return typeof this[s.$content] == "string" ? this[s.$content].split(/[\u2029\u2028\n]/).reduce((C, ue) => (ue && C.push(ue), C), []).join(`
`) : this[s.$content][s.$text]();
            }
            [s.$toHTML](C) {
              if (typeof this[s.$content] == "string") {
                const ue = w(this[s.$content]).html;
                return this[s.$content].includes("\u2029") ? (ue.name = "div", ue.children = [], this[s.$content].split("\u2029").map((je) => je.split(/[\u2028\n]/).reduce((He, Ge) => (He.push({
                  name: "span",
                  value: Ge
                }, {
                  name: "br"
                }), He), [])).forEach((je) => {
                  ue.children.push({
                    name: "p",
                    children: je
                  });
                })) : /[\u2028\n]/.test(this[s.$content]) && (ue.name = "div", ue.children = [], this[s.$content].split(/[\u2028\n]/).forEach((je) => {
                  ue.children.push({
                    name: "span",
                    value: je
                  }, {
                    name: "br"
                  });
                })), m.HTMLResult.success(ue);
              }
              return this[s.$content][s.$toHTML](C);
            }
          }
          c.Text = Pc;
          class jc extends i.XFAObject {
            constructor(C) {
              super(x, "textEdit", !0), this.allowRichText = (0, m.getInteger)({
                data: C.allowRichText,
                defaultValue: 0,
                validate: (ue) => ue === 1
              }), this.hScrollPolicy = (0, m.getStringOption)(C.hScrollPolicy, ["auto", "off", "on"]), this.id = C.id || "", this.multiLine = (0, m.getInteger)({
                data: C.multiLine,
                defaultValue: "",
                validate: (ue) => ue === 0 || ue === 1
              }), this.use = C.use || "", this.usehref = C.usehref || "", this.vScrollPolicy = (0, m.getStringOption)(C.vScrollPolicy, ["auto", "off", "on"]), this.border = null, this.comb = null, this.extras = null, this.margin = null;
            }
            [s.$toHTML](C) {
              var Ge, dt;
              const ue = (0, t.toStyle)(this, "border", "font", "margin");
              let je;
              const He = this[s.$getParent]()[s.$getParent]();
              return this.multiLine === "" && (this.multiLine = He instanceof Ae ? 1 : 0), this.multiLine === 1 ? je = {
                name: "textarea",
                attributes: {
                  dataId: ((Ge = He[s.$data]) == null ? void 0 : Ge[s.$uid]) || He[s.$uid],
                  fieldId: He[s.$uid],
                  class: ["xfaTextfield"],
                  style: ue,
                  "aria-label": T(He),
                  "aria-required": !1
                }
              } : je = {
                name: "input",
                attributes: {
                  type: "text",
                  dataId: ((dt = He[s.$data]) == null ? void 0 : dt[s.$uid]) || He[s.$uid],
                  fieldId: He[s.$uid],
                  class: ["xfaTextfield"],
                  style: ue,
                  "aria-label": T(He),
                  "aria-required": !1
                }
              }, A(He) && (je.attributes["aria-required"] = !0, je.attributes.required = !0), m.HTMLResult.success({
                name: "label",
                attributes: {
                  class: ["xfaLabel"]
                },
                children: [je]
              });
            }
          }
          class au extends i.StringObject {
            constructor(C) {
              super(x, "time"), this.id = C.id || "", this.name = C.name || "", this.use = C.use || "", this.usehref = C.usehref || "";
            }
            [s.$finalize]() {
              const C = this[s.$content].trim();
              this[s.$content] = C ? new Date(C) : null;
            }
            [s.$toHTML](C) {
              return w(this[s.$content] ? this[s.$content].toString() : "");
            }
          }
          class ou extends i.XFAObject {
            constructor(C) {
              super(x, "timeStamp"), this.id = C.id || "", this.server = C.server || "", this.type = (0, m.getStringOption)(C.type, ["optional", "required"]), this.use = C.use || "", this.usehref = C.usehref || "";
            }
          }
          class cu extends i.StringObject {
            constructor(C) {
              super(x, "toolTip"), this.id = C.id || "", this.rid = C.rid || "", this.use = C.use || "", this.usehref = C.usehref || "";
            }
          }
          class lu extends i.XFAObject {
            constructor(C) {
              super(x, "traversal", !0), this.id = C.id || "", this.use = C.use || "", this.usehref = C.usehref || "", this.extras = null, this.traverse = new i.XFAObjectArray();
            }
          }
          class uu extends i.XFAObject {
            constructor(C) {
              super(x, "traverse", !0), this.id = C.id || "", this.operation = (0, m.getStringOption)(C.operation, ["next", "back", "down", "first", "left", "right", "up"]), this.ref = C.ref || "", this.use = C.use || "", this.usehref = C.usehref || "", this.extras = null, this.script = null;
            }
            get name() {
              return this.operation;
            }
            [s.$isTransparent]() {
              return !1;
            }
          }
          class oo extends i.XFAObject {
            constructor(C) {
              super(x, "ui", !0), this.id = C.id || "", this.use = C.use || "", this.usehref = C.usehref || "", this.extras = null, this.picture = null, this.barcode = null, this.button = null, this.checkButton = null, this.choiceList = null, this.dateTimeEdit = null, this.defaultUi = null, this.imageEdit = null, this.numericEdit = null, this.passwordEdit = null, this.signature = null, this.textEdit = null;
            }
            [s.$getExtra]() {
              if (this[s.$extra] === void 0) {
                for (const C of Object.getOwnPropertyNames(this)) {
                  if (C === "extras" || C === "picture")
                    continue;
                  const ue = this[C];
                  if (ue instanceof i.XFAObject)
                    return this[s.$extra] = ue, ue;
                }
                this[s.$extra] = null;
              }
              return this[s.$extra];
            }
            [s.$toHTML](C) {
              const ue = this[s.$getExtra]();
              return ue ? ue[s.$toHTML](C) : m.HTMLResult.EMPTY;
            }
          }
          class du extends i.XFAObject {
            constructor(C) {
              super(x, "validate", !0), this.formatTest = (0, m.getStringOption)(C.formatTest, ["warning", "disabled", "error"]), this.id = C.id || "", this.nullTest = (0, m.getStringOption)(C.nullTest, ["disabled", "error", "warning"]), this.scriptTest = (0, m.getStringOption)(C.scriptTest, ["error", "disabled", "warning"]), this.use = C.use || "", this.usehref = C.usehref || "", this.extras = null, this.message = null, this.picture = null, this.script = null;
            }
          }
          class ea extends i.XFAObject {
            constructor(C) {
              super(x, "value", !0), this.id = C.id || "", this.override = (0, m.getInteger)({
                data: C.override,
                defaultValue: 0,
                validate: (ue) => ue === 1
              }), this.relevant = (0, m.getRelevant)(C.relevant), this.use = C.use || "", this.usehref = C.usehref || "", this.arc = null, this.boolean = null, this.date = null, this.dateTime = null, this.decimal = null, this.exData = null, this.float = null, this.image = null, this.integer = null, this.line = null, this.rectangle = null, this.text = null, this.time = null;
            }
            [s.$setValue](C) {
              var He;
              const ue = this[s.$getParent]();
              if (ue instanceof Ye && (He = ue.ui) != null && He.imageEdit) {
                this.image || (this.image = new qe({}), this[s.$appendChild](this.image)), this.image[s.$content] = C[s.$content];
                return;
              }
              const je = C[s.$nodeName];
              if (this[je] !== null) {
                this[je][s.$content] = C[s.$content];
                return;
              }
              for (const Ge of Object.getOwnPropertyNames(this)) {
                const dt = this[Ge];
                dt instanceof i.XFAObject && (this[Ge] = null, this[s.$removeChild](dt));
              }
              this[C[s.$nodeName]] = C, this[s.$appendChild](C);
            }
            [s.$text]() {
              if (this.exData)
                return typeof this.exData[s.$content] == "string" ? this.exData[s.$content].trim() : this.exData[s.$content][s.$text]().trim();
              for (const C of Object.getOwnPropertyNames(this)) {
                if (C === "image")
                  continue;
                const ue = this[C];
                if (ue instanceof i.XFAObject)
                  return (ue[s.$content] || "").toString().trim();
              }
              return null;
            }
            [s.$toHTML](C) {
              for (const ue of Object.getOwnPropertyNames(this)) {
                const je = this[ue];
                if (je instanceof i.XFAObject)
                  return je[s.$toHTML](C);
              }
              return m.HTMLResult.EMPTY;
            }
          }
          c.Value = ea;
          class hu extends i.XFAObject {
            constructor(C) {
              super(x, "variables", !0), this.id = C.id || "", this.use = C.use || "", this.usehref = C.usehref || "", this.boolean = new i.XFAObjectArray(), this.date = new i.XFAObjectArray(), this.dateTime = new i.XFAObjectArray(), this.decimal = new i.XFAObjectArray(), this.exData = new i.XFAObjectArray(), this.float = new i.XFAObjectArray(), this.image = new i.XFAObjectArray(), this.integer = new i.XFAObjectArray(), this.manifest = new i.XFAObjectArray(), this.script = new i.XFAObjectArray(), this.text = new i.XFAObjectArray(), this.time = new i.XFAObjectArray();
            }
            [s.$isTransparent]() {
              return !0;
            }
          }
          class ta {
            static [h.$buildXFAObject](C, ue) {
              if (ta.hasOwnProperty(C)) {
                const je = ta[C](ue);
                return je[s.$setSetAttributes](ue), je;
              }
            }
            static appearanceFilter(C) {
              return new J(C);
            }
            static arc(C) {
              return new ne(C);
            }
            static area(C) {
              return new Z(C);
            }
            static assist(C) {
              return new te(C);
            }
            static barcode(C) {
              return new G(C);
            }
            static bind(C) {
              return new N(C);
            }
            static bindItems(C) {
              return new q(C);
            }
            static bookend(C) {
              return new ie(C);
            }
            static boolean(C) {
              return new oe(C);
            }
            static border(C) {
              return new fe(C);
            }
            static break(C) {
              return new Y(C);
            }
            static breakAfter(C) {
              return new ae(C);
            }
            static breakBefore(C) {
              return new se(C);
            }
            static button(C) {
              return new L(C);
            }
            static calculate(C) {
              return new W(C);
            }
            static caption(C) {
              return new M(C);
            }
            static certificate(C) {
              return new X(C);
            }
            static certificates(C) {
              return new U(C);
            }
            static checkButton(C) {
              return new Q(C);
            }
            static choiceList(C) {
              return new re(C);
            }
            static color(C) {
              return new le(C);
            }
            static comb(C) {
              return new ce(C);
            }
            static connect(C) {
              return new ee(C);
            }
            static contentArea(C) {
              return new he(C);
            }
            static corner(C) {
              return new pe(C);
            }
            static date(C) {
              return new de(C);
            }
            static dateTime(C) {
              return new ge(C);
            }
            static dateTimeEdit(C) {
              return new me(C);
            }
            static decimal(C) {
              return new xe(C);
            }
            static defaultUi(C) {
              return new ye(C);
            }
            static desc(C) {
              return new ve(C);
            }
            static digestMethod(C) {
              return new Ce(C);
            }
            static digestMethods(C) {
              return new Ie(C);
            }
            static draw(C) {
              return new Ae(C);
            }
            static edge(C) {
              return new Se(C);
            }
            static encoding(C) {
              return new De(C);
            }
            static encodings(C) {
              return new Be(C);
            }
            static encrypt(C) {
              return new ke(C);
            }
            static encryptData(C) {
              return new be(C);
            }
            static encryption(C) {
              return new we(C);
            }
            static encryptionMethod(C) {
              return new Le(C);
            }
            static encryptionMethods(C) {
              return new Re(C);
            }
            static event(C) {
              return new ct(C);
            }
            static exData(C) {
              return new ft(C);
            }
            static exObject(C) {
              return new kt(C);
            }
            static exclGroup(C) {
              return new We(C);
            }
            static execute(C) {
              return new jt(C);
            }
            static extras(C) {
              return new yt(C);
            }
            static field(C) {
              return new Ye(C);
            }
            static fill(C) {
              return new mt(C);
            }
            static filter(C) {
              return new Pt(C);
            }
            static float(C) {
              return new et(C);
            }
            static font(C) {
              return new tn(C);
            }
            static format(C) {
              return new Xt(C);
            }
            static handler(C) {
              return new _e(C);
            }
            static hyphenation(C) {
              return new Qe(C);
            }
            static image(C) {
              return new qe(C);
            }
            static imageEdit(C) {
              return new Je(C);
            }
            static integer(C) {
              return new nt(C);
            }
            static issuers(C) {
              return new At(C);
            }
            static items(C) {
              return new Rt(C);
            }
            static keep(C) {
              return new St(C);
            }
            static keyUsage(C) {
              return new _t(C);
            }
            static line(C) {
              return new Zt(C);
            }
            static linear(C) {
              return new an(C);
            }
            static lockDocument(C) {
              return new ze(C);
            }
            static manifest(C) {
              return new $e(C);
            }
            static margin(C) {
              return new Ve(C);
            }
            static mdp(C) {
              return new Ke(C);
            }
            static medium(C) {
              return new at(C);
            }
            static message(C) {
              return new It(C);
            }
            static numericEdit(C) {
              return new st(C);
            }
            static occur(C) {
              return new Ze(C);
            }
            static oid(C) {
              return new gt(C);
            }
            static oids(C) {
              return new Lt(C);
            }
            static overflow(C) {
              return new Yt(C);
            }
            static pageArea(C) {
              return new Ft(C);
            }
            static pageSet(C) {
              return new Dt(C);
            }
            static para(C) {
              return new Wt(C);
            }
            static passwordEdit(C) {
              return new xt(C);
            }
            static pattern(C) {
              return new Bt(C);
            }
            static picture(C) {
              return new ht(C);
            }
            static proto(C) {
              return new Ht(C);
            }
            static radial(C) {
              return new Qt(C);
            }
            static reason(C) {
              return new Vn(C);
            }
            static reasons(C) {
              return new $t(C);
            }
            static rectangle(C) {
              return new Ut(C);
            }
            static ref(C) {
              return new dn(C);
            }
            static script(C) {
              return new kn(C);
            }
            static setProperty(C) {
              return new _i(C);
            }
            static signData(C) {
              return new As(C);
            }
            static signature(C) {
              return new Q0(C);
            }
            static signing(C) {
              return new J0(C);
            }
            static solid(C) {
              return new eu(C);
            }
            static speak(C) {
              return new tu(C);
            }
            static stipple(C) {
              return new nu(C);
            }
            static subform(C) {
              return new Fc(C);
            }
            static subformSet(C) {
              return new so(C);
            }
            static subjectDN(C) {
              return new iu(C);
            }
            static subjectDNs(C) {
              return new ru(C);
            }
            static submit(C) {
              return new su(C);
            }
            static template(C) {
              return new ao(C);
            }
            static text(C) {
              return new Pc(C);
            }
            static textEdit(C) {
              return new jc(C);
            }
            static time(C) {
              return new au(C);
            }
            static timeStamp(C) {
              return new ou(C);
            }
            static toolTip(C) {
              return new cu(C);
            }
            static traversal(C) {
              return new lu(C);
            }
            static traverse(C) {
              return new uu(C);
            }
            static ui(C) {
              return new oo(C);
            }
            static validate(C) {
              return new du(C);
            }
            static value(C) {
              return new ea(C);
            }
            static variables(C) {
              return new hu(C);
            }
          }
          c.TemplateNamespace = ta;
        },
        /* 81 */
        /***/
        (d, c) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.NamespaceIds = c.$buildXFAObject = void 0;
          const f = Symbol();
          c.$buildXFAObject = f;
          const s = {
            config: {
              id: 0,
              check: (h) => h.startsWith("http://www.xfa.org/schema/xci/")
            },
            connectionSet: {
              id: 1,
              check: (h) => h.startsWith("http://www.xfa.org/schema/xfa-connection-set/")
            },
            datasets: {
              id: 2,
              check: (h) => h.startsWith("http://www.xfa.org/schema/xfa-data/")
            },
            form: {
              id: 3,
              check: (h) => h.startsWith("http://www.xfa.org/schema/xfa-form/")
            },
            localeSet: {
              id: 4,
              check: (h) => h.startsWith("http://www.xfa.org/schema/xfa-locale-set/")
            },
            pdf: {
              id: 5,
              check: (h) => h === "http://ns.adobe.com/xdp/pdf/"
            },
            signature: {
              id: 6,
              check: (h) => h === "http://www.w3.org/2000/09/xmldsig#"
            },
            sourceSet: {
              id: 7,
              check: (h) => h.startsWith("http://www.xfa.org/schema/xfa-source-set/")
            },
            stylesheet: {
              id: 8,
              check: (h) => h === "http://www.w3.org/1999/XSL/Transform"
            },
            template: {
              id: 9,
              check: (h) => h.startsWith("http://www.xfa.org/schema/xfa-template/")
            },
            xdc: {
              id: 10,
              check: (h) => h.startsWith("http://www.xfa.org/schema/xdc/")
            },
            xdp: {
              id: 11,
              check: (h) => h === "http://ns.adobe.com/xdp/"
            },
            xfdf: {
              id: 12,
              check: (h) => h === "http://ns.adobe.com/xfdf/"
            },
            xhtml: {
              id: 13,
              check: (h) => h === "http://www.w3.org/1999/xhtml"
            },
            xmpmeta: {
              id: 14,
              check: (h) => h === "http://ns.adobe.com/xmpmeta/"
            }
          };
          c.NamespaceIds = s;
        },
        /* 82 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.addHTML = i, c.checkDimensions = E, c.flushHTML = t, c.getAvailableSpace = m;
          var s = f(78), h = f(83);
          function g(S, y) {
            return {
              name: "div",
              attributes: {
                class: [S.layout === "lr-tb" ? "xfaLr" : "xfaRl"]
              },
              children: y
            };
          }
          function t(S) {
            if (!S[s.$extra])
              return null;
            const x = {
              name: "div",
              attributes: S[s.$extra].attributes,
              children: S[s.$extra].children
            };
            if (S[s.$extra].failingNode) {
              const b = S[s.$extra].failingNode[s.$flushHTML]();
              b && (S.layout.endsWith("-tb") ? x.children.push(g(S, [b])) : x.children.push(b));
            }
            return x.children.length === 0 ? null : x;
          }
          function i(S, y, x) {
            const b = S[s.$extra], u = b.availableSpace, [I, O, D, $] = x;
            switch (S.layout) {
              case "position": {
                b.width = Math.max(b.width, I + D), b.height = Math.max(b.height, O + $), b.children.push(y);
                break;
              }
              case "lr-tb":
              case "rl-tb":
                (!b.line || b.attempt === 1) && (b.line = g(S, []), b.children.push(b.line), b.numberInLine = 0), b.numberInLine += 1, b.line.children.push(y), b.attempt === 0 ? (b.currentWidth += D, b.height = Math.max(b.height, b.prevHeight + $)) : (b.currentWidth = D, b.prevHeight = b.height, b.height += $, b.attempt = 0), b.width = Math.max(b.width, b.currentWidth);
                break;
              case "rl-row":
              case "row": {
                b.children.push(y), b.width += D, b.height = Math.max(b.height, $);
                const K = (0, h.measureToString)(b.height);
                for (const H of b.children)
                  H.attributes.style.height = K;
                break;
              }
              case "table": {
                b.width = Math.min(u.width, Math.max(b.width, D)), b.height += $, b.children.push(y);
                break;
              }
              case "tb": {
                b.width = Math.min(u.width, Math.max(b.width, D)), b.height += $, b.children.push(y);
                break;
              }
            }
          }
          function m(S) {
            const y = S[s.$extra].availableSpace, x = S.margin ? S.margin.topInset + S.margin.bottomInset : 0, b = S.margin ? S.margin.leftInset + S.margin.rightInset : 0;
            switch (S.layout) {
              case "lr-tb":
              case "rl-tb":
                return S[s.$extra].attempt === 0 ? {
                  width: y.width - b - S[s.$extra].currentWidth,
                  height: y.height - x - S[s.$extra].prevHeight
                } : {
                  width: y.width - b,
                  height: y.height - x - S[s.$extra].height
                };
              case "rl-row":
              case "row":
                return {
                  width: S[s.$extra].columnWidths.slice(S[s.$extra].currentColumn).reduce((I, O) => I + O),
                  height: y.height - b
                };
              case "table":
              case "tb":
                return {
                  width: y.width - b,
                  height: y.height - x - S[s.$extra].height
                };
              case "position":
              default:
                return y;
            }
          }
          function v(S) {
            let y = S.w === "" ? NaN : S.w, x = S.h === "" ? NaN : S.h, [b, u] = [0, 0];
            switch (S.anchorType || "") {
              case "bottomCenter":
                [b, u] = [y / 2, x];
                break;
              case "bottomLeft":
                [b, u] = [0, x];
                break;
              case "bottomRight":
                [b, u] = [y, x];
                break;
              case "middleCenter":
                [b, u] = [y / 2, x / 2];
                break;
              case "middleLeft":
                [b, u] = [0, x / 2];
                break;
              case "middleRight":
                [b, u] = [y, x / 2];
                break;
              case "topCenter":
                [b, u] = [y / 2, 0];
                break;
              case "topRight":
                [b, u] = [y, 0];
                break;
            }
            let I, O;
            switch (S.rotate || 0) {
              case 0:
                [I, O] = [-b, -u];
                break;
              case 90:
                [I, O] = [-u, b], [y, x] = [x, -y];
                break;
              case 180:
                [I, O] = [b, u], [y, x] = [-y, -x];
                break;
              case 270:
                [I, O] = [u, -b], [y, x] = [-x, y];
                break;
            }
            return [S.x + I + Math.min(0, y), S.y + O + Math.min(0, x), Math.abs(y), Math.abs(x)];
          }
          function E(S, y) {
            var $;
            if (S[s.$getTemplateRoot]()[s.$extra].firstUnsplittable === null || S.w === 0 || S.h === 0)
              return !0;
            const x = 2, b = S[s.$getSubformParent](), u = (($ = b[s.$extra]) == null ? void 0 : $.attempt) || 0, [, I, O, D] = v(S);
            switch (b.layout) {
              case "lr-tb":
              case "rl-tb":
                return u === 0 ? S[s.$getTemplateRoot]()[s.$extra].noLayoutFailure ? S.w !== "" ? Math.round(O - y.width) <= x : y.width > x : S.h !== "" && Math.round(D - y.height) > x ? !1 : S.w !== "" ? Math.round(O - y.width) <= x ? !0 : b[s.$extra].numberInLine === 0 ? y.height > x : !1 : y.width > x : S[s.$getTemplateRoot]()[s.$extra].noLayoutFailure ? !0 : S.h !== "" && Math.round(D - y.height) > x ? !1 : S.w === "" || Math.round(O - y.width) <= x ? y.height > x : b[s.$isThereMoreWidth]() ? !1 : y.height > x;
              case "table":
              case "tb":
                return S[s.$getTemplateRoot]()[s.$extra].noLayoutFailure ? !0 : S.h !== "" && !S[s.$isSplittable]() ? Math.round(D - y.height) <= x : S.w === "" || Math.round(O - y.width) <= x ? y.height > x : b[s.$isThereMoreWidth]() ? !1 : y.height > x;
              case "position":
                if (S[s.$getTemplateRoot]()[s.$extra].noLayoutFailure || S.h === "" || Math.round(D + I - y.height) <= x)
                  return !0;
                const K = S[s.$getTemplateRoot]()[s.$extra].currentContentArea;
                return D + I > K.h;
              case "rl-row":
              case "row":
                return S[s.$getTemplateRoot]()[s.$extra].noLayoutFailure ? !0 : S.h !== "" ? Math.round(D - y.height) <= x : !0;
              default:
                return !0;
            }
          }
        },
        /* 83 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.computeBbox = b, c.createWrapper = D, c.fixDimensions = u, c.fixTextIndent = $, c.fixURL = A, c.isPrintOnly = H, c.layoutClass = I, c.layoutNode = x, c.measureToString = v, c.setAccess = K, c.setFontFamily = _, c.setMinMaxDimensions = S, c.setPara = R, c.toStyle = O;
          var s = f(78), h = f(2), g = f(84), t = f(85), i = f(86), m = f(87);
          function v(k) {
            return typeof k == "string" ? "0px" : Number.isInteger(k) ? `${k}px` : `${k.toFixed(2)}px`;
          }
          const E = {
            anchorType(k, z) {
              const T = k[s.$getSubformParent]();
              if (!(!T || T.layout && T.layout !== "position"))
                switch ("transform" in z || (z.transform = ""), k.anchorType) {
                  case "bottomCenter":
                    z.transform += "translate(-50%, -100%)";
                    break;
                  case "bottomLeft":
                    z.transform += "translate(0,-100%)";
                    break;
                  case "bottomRight":
                    z.transform += "translate(-100%,-100%)";
                    break;
                  case "middleCenter":
                    z.transform += "translate(-50%,-50%)";
                    break;
                  case "middleLeft":
                    z.transform += "translate(0,-50%)";
                    break;
                  case "middleRight":
                    z.transform += "translate(-100%,-50%)";
                    break;
                  case "topCenter":
                    z.transform += "translate(-50%,0)";
                    break;
                  case "topRight":
                    z.transform += "translate(-100%,0)";
                    break;
                }
            },
            dimensions(k, z) {
              var j;
              const T = k[s.$getSubformParent]();
              let w = k.w;
              const F = k.h;
              if ((j = T.layout) != null && j.includes("row")) {
                const P = T[s.$extra], V = k.colSpan;
                let J;
                V === -1 ? (J = P.columnWidths.slice(P.currentColumn).reduce((ne, Z) => ne + Z, 0), P.currentColumn = 0) : (J = P.columnWidths.slice(P.currentColumn, P.currentColumn + V).reduce((ne, Z) => ne + Z, 0), P.currentColumn = (P.currentColumn + k.colSpan) % P.columnWidths.length), isNaN(J) || (w = k.w = J);
              }
              z.width = w !== "" ? v(w) : "auto", z.height = F !== "" ? v(F) : "auto";
            },
            position(k, z) {
              const T = k[s.$getSubformParent]();
              T != null && T.layout && T.layout !== "position" || (z.position = "absolute", z.left = v(k.x), z.top = v(k.y));
            },
            rotate(k, z) {
              k.rotate && ("transform" in z || (z.transform = ""), z.transform += `rotate(-${k.rotate}deg)`, z.transformOrigin = "top left");
            },
            presence(k, z) {
              switch (k.presence) {
                case "invisible":
                  z.visibility = "hidden";
                  break;
                case "hidden":
                case "inactive":
                  z.display = "none";
                  break;
              }
            },
            hAlign(k, z) {
              if (k[s.$nodeName] === "para")
                switch (k.hAlign) {
                  case "justifyAll":
                    z.textAlign = "justify-all";
                    break;
                  case "radix":
                    z.textAlign = "left";
                    break;
                  default:
                    z.textAlign = k.hAlign;
                }
              else
                switch (k.hAlign) {
                  case "left":
                    z.alignSelf = "start";
                    break;
                  case "center":
                    z.alignSelf = "center";
                    break;
                  case "right":
                    z.alignSelf = "end";
                    break;
                }
            },
            margin(k, z) {
              k.margin && (z.margin = k.margin[s.$toStyle]().margin);
            }
          };
          function S(k, z) {
            k[s.$getSubformParent]().layout === "position" && (k.minW > 0 && (z.minWidth = v(k.minW)), k.maxW > 0 && (z.maxWidth = v(k.maxW)), k.minH > 0 && (z.minHeight = v(k.minH)), k.maxH > 0 && (z.maxHeight = v(k.maxH)));
          }
          function y(k, z, T, w, F, j) {
            const P = new i.TextMeasure(z, T, w, F);
            return typeof k == "string" ? P.addString(k) : k[s.$pushGlyphs](P), P.compute(j);
          }
          function x(k, z) {
            let T = null, w = null, F = !1;
            if ((!k.w || !k.h) && k.value) {
              let j = 0, P = 0;
              k.margin && (j = k.margin.leftInset + k.margin.rightInset, P = k.margin.topInset + k.margin.bottomInset);
              let V = null, J = null;
              k.para && (J = /* @__PURE__ */ Object.create(null), V = k.para.lineHeight === "" ? null : k.para.lineHeight, J.top = k.para.spaceAbove === "" ? 0 : k.para.spaceAbove, J.bottom = k.para.spaceBelow === "" ? 0 : k.para.spaceBelow, J.left = k.para.marginLeft === "" ? 0 : k.para.marginLeft, J.right = k.para.marginRight === "" ? 0 : k.para.marginRight);
              let ne = k.font;
              if (!ne) {
                const G = k[s.$getTemplateRoot]();
                let N = k[s.$getParent]();
                for (; N && N !== G; ) {
                  if (N.font) {
                    ne = N.font;
                    break;
                  }
                  N = N[s.$getParent]();
                }
              }
              const Z = (k.w || z.width) - j, te = k[s.$globalData].fontFinder;
              if (k.value.exData && k.value.exData[s.$content] && k.value.exData.contentType === "text/html") {
                const G = y(k.value.exData[s.$content], ne, J, V, te, Z);
                w = G.width, T = G.height, F = G.isBroken;
              } else {
                const G = k.value[s.$text]();
                if (G) {
                  const N = y(G, ne, J, V, te, Z);
                  w = N.width, T = N.height, F = N.isBroken;
                }
              }
              w !== null && !k.w && (w += j), T !== null && !k.h && (T += P);
            }
            return {
              w,
              h: T,
              isBroken: F
            };
          }
          function b(k, z, T) {
            let w;
            if (k.w !== "" && k.h !== "")
              w = [k.x, k.y, k.w, k.h];
            else {
              if (!T)
                return null;
              let F = k.w;
              if (F === "") {
                if (k.maxW === 0) {
                  const P = k[s.$getSubformParent]();
                  F = P.layout === "position" && P.w !== "" ? 0 : k.minW;
                } else
                  F = Math.min(k.maxW, T.width);
                z.attributes.style.width = v(F);
              }
              let j = k.h;
              if (j === "") {
                if (k.maxH === 0) {
                  const P = k[s.$getSubformParent]();
                  j = P.layout === "position" && P.h !== "" ? 0 : k.minH;
                } else
                  j = Math.min(k.maxH, T.height);
                z.attributes.style.height = v(j);
              }
              w = [k.x, k.y, F, j];
            }
            return w;
          }
          function u(k) {
            var T;
            const z = k[s.$getSubformParent]();
            if ((T = z.layout) != null && T.includes("row")) {
              const w = z[s.$extra], F = k.colSpan;
              let j;
              F === -1 ? j = w.columnWidths.slice(w.currentColumn).reduce((P, V) => P + V, 0) : j = w.columnWidths.slice(w.currentColumn, w.currentColumn + F).reduce((P, V) => P + V, 0), isNaN(j) || (k.w = j);
            }
            z.layout && z.layout !== "position" && (k.x = k.y = 0), k.layout === "table" && k.w === "" && Array.isArray(k.columnWidths) && (k.w = k.columnWidths.reduce((w, F) => w + F, 0));
          }
          function I(k) {
            switch (k.layout) {
              case "position":
                return "xfaPosition";
              case "lr-tb":
                return "xfaLrTb";
              case "rl-row":
                return "xfaRlRow";
              case "rl-tb":
                return "xfaRlTb";
              case "row":
                return "xfaRow";
              case "table":
                return "xfaTable";
              case "tb":
                return "xfaTb";
              default:
                return "xfaPosition";
            }
          }
          function O(k, ...z) {
            const T = /* @__PURE__ */ Object.create(null);
            for (const w of z) {
              const F = k[w];
              if (F !== null) {
                if (E.hasOwnProperty(w)) {
                  E[w](k, T);
                  continue;
                }
                if (F instanceof m.XFAObject) {
                  const j = F[s.$toStyle]();
                  j ? Object.assign(T, j) : (0, h.warn)(`(DEBUG) - XFA - style for ${w} not implemented yet`);
                }
              }
            }
            return T;
          }
          function D(k, z) {
            const {
              attributes: T
            } = z, {
              style: w
            } = T, F = {
              name: "div",
              attributes: {
                class: ["xfaWrapper"],
                style: /* @__PURE__ */ Object.create(null)
              },
              children: []
            };
            if (T.class.push("xfaWrapped"), k.border) {
              const {
                widths: j,
                insets: P
              } = k.border[s.$extra];
              let V, J, ne = P[0], Z = P[3];
              const te = P[0] + P[2], G = P[1] + P[3];
              switch (k.border.hand) {
                case "even":
                  ne -= j[0] / 2, Z -= j[3] / 2, V = `calc(100% + ${(j[1] + j[3]) / 2 - G}px)`, J = `calc(100% + ${(j[0] + j[2]) / 2 - te}px)`;
                  break;
                case "left":
                  ne -= j[0], Z -= j[3], V = `calc(100% + ${j[1] + j[3] - G}px)`, J = `calc(100% + ${j[0] + j[2] - te}px)`;
                  break;
                case "right":
                  V = G ? `calc(100% - ${G}px)` : "100%", J = te ? `calc(100% - ${te}px)` : "100%";
                  break;
              }
              const N = ["xfaBorder"];
              H(k.border) && N.push("xfaPrintOnly");
              const q = {
                name: "div",
                attributes: {
                  class: N,
                  style: {
                    top: `${ne}px`,
                    left: `${Z}px`,
                    width: V,
                    height: J
                  }
                },
                children: []
              };
              for (const ie of ["border", "borderWidth", "borderColor", "borderRadius", "borderStyle"])
                w[ie] !== void 0 && (q.attributes.style[ie] = w[ie], delete w[ie]);
              F.children.push(q, z);
            } else
              F.children.push(z);
            for (const j of ["background", "backgroundClip", "top", "left", "width", "height", "minWidth", "minHeight", "maxWidth", "maxHeight", "transform", "transformOrigin", "visibility"])
              w[j] !== void 0 && (F.attributes.style[j] = w[j], delete w[j]);
            return F.attributes.style.position = w.position === "absolute" ? "absolute" : "relative", delete w.position, w.alignSelf && (F.attributes.style.alignSelf = w.alignSelf, delete w.alignSelf), F;
          }
          function $(k) {
            const z = (0, g.getMeasurement)(k.textIndent, "0px");
            if (z >= 0)
              return;
            const w = "padding" + ((k.textAlign === "right" ? "right" : "left") === "left" ? "Left" : "Right"), F = (0, g.getMeasurement)(k[w], "0px");
            k[w] = `${F - z}px`;
          }
          function K(k, z) {
            switch (k.access) {
              case "nonInteractive":
                z.push("xfaNonInteractive");
                break;
              case "readOnly":
                z.push("xfaReadOnly");
                break;
              case "protected":
                z.push("xfaDisabled");
                break;
            }
          }
          function H(k) {
            return k.relevant.length > 0 && !k.relevant[0].excluded && k.relevant[0].viewname === "print";
          }
          function B(k) {
            const z = k[s.$getTemplateRoot]()[s.$extra].paraStack;
            return z.length ? z.at(-1) : null;
          }
          function R(k, z, T) {
            var w;
            if ((w = T.attributes.class) != null && w.includes("xfaRich")) {
              z && (k.h === "" && (z.height = "auto"), k.w === "" && (z.width = "auto"));
              const F = B(k);
              if (F) {
                const j = T.attributes.style;
                switch (j.display = "flex", j.flexDirection = "column", F.vAlign) {
                  case "top":
                    j.justifyContent = "start";
                    break;
                  case "bottom":
                    j.justifyContent = "end";
                    break;
                  case "middle":
                    j.justifyContent = "center";
                    break;
                }
                const P = F[s.$toStyle]();
                for (const [V, J] of Object.entries(P))
                  V in j || (j[V] = J);
              }
            }
          }
          function _(k, z, T, w) {
            if (!T) {
              delete w.fontFamily;
              return;
            }
            const F = (0, g.stripQuotes)(k.typeface);
            w.fontFamily = `"${F}"`;
            const j = T.find(F);
            if (j) {
              const {
                fontFamily: P
              } = j.regular.cssFontInfo;
              P !== F && (w.fontFamily = `"${P}"`);
              const V = B(z);
              if (V && V.lineHeight !== "" || w.lineHeight)
                return;
              const J = (0, t.selectFont)(k, j);
              J && (w.lineHeight = Math.max(1.2, J.lineHeight));
            }
          }
          function A(k) {
            const z = (0, h.createValidAbsoluteUrl)(k, null, {
              addDefaultProtocol: !0,
              tryConvertEncoding: !0
            });
            return z ? z.href : null;
          }
        },
        /* 84 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.HTMLResult = void 0, c.getBBox = u, c.getColor = b, c.getFloat = m, c.getInteger = i, c.getKeyword = v, c.getMeasurement = S, c.getRatio = y, c.getRelevant = x, c.getStringOption = E, c.stripQuotes = t;
          var s = f(2);
          const h = {
            pt: (O) => O,
            cm: (O) => O / 2.54 * 72,
            mm: (O) => O / (10 * 2.54) * 72,
            in: (O) => O * 72,
            px: (O) => O
          }, g = /([+-]?\d+\.?\d*)(.*)/;
          function t(O) {
            return O.startsWith("'") || O.startsWith('"') ? O.slice(1, -1) : O;
          }
          function i({
            data: O,
            defaultValue: D,
            validate: $
          }) {
            if (!O)
              return D;
            O = O.trim();
            const K = parseInt(O, 10);
            return !isNaN(K) && $(K) ? K : D;
          }
          function m({
            data: O,
            defaultValue: D,
            validate: $
          }) {
            if (!O)
              return D;
            O = O.trim();
            const K = parseFloat(O);
            return !isNaN(K) && $(K) ? K : D;
          }
          function v({
            data: O,
            defaultValue: D,
            validate: $
          }) {
            return O ? (O = O.trim(), $(O) ? O : D) : D;
          }
          function E(O, D) {
            return v({
              data: O,
              defaultValue: D[0],
              validate: ($) => D.includes($)
            });
          }
          function S(O, D = "0") {
            if (D || (D = "0"), !O)
              return S(D);
            const $ = O.trim().match(g);
            if (!$)
              return S(D);
            const [, K, H] = $, B = parseFloat(K);
            if (isNaN(B))
              return S(D);
            if (B === 0)
              return 0;
            const R = h[H];
            return R ? R(B) : B;
          }
          function y(O) {
            if (!O)
              return {
                num: 1,
                den: 1
              };
            const D = O.trim().split(/\s*:\s*/).map((H) => parseFloat(H)).filter((H) => !isNaN(H));
            if (D.length === 1 && D.push(1), D.length === 0)
              return {
                num: 1,
                den: 1
              };
            const [$, K] = D;
            return {
              num: $,
              den: K
            };
          }
          function x(O) {
            return O ? O.trim().split(/\s+/).map((D) => ({
              excluded: D[0] === "-",
              viewname: D.substring(1)
            })) : [];
          }
          function b(O, D = [0, 0, 0]) {
            let [$, K, H] = D;
            if (!O)
              return {
                r: $,
                g: K,
                b: H
              };
            const B = O.trim().split(/\s*,\s*/).map((R) => Math.min(Math.max(0, parseInt(R.trim(), 10)), 255)).map((R) => isNaN(R) ? 0 : R);
            return B.length < 3 ? {
              r: $,
              g: K,
              b: H
            } : ([$, K, H] = B, {
              r: $,
              g: K,
              b: H
            });
          }
          function u(O) {
            if (!O)
              return {
                x: -1,
                y: -1,
                width: -1,
                height: -1
              };
            const $ = O.trim().split(/\s*,\s*/).map((_) => S(_, "-1"));
            if ($.length < 4 || $[2] < 0 || $[3] < 0)
              return {
                x: -1,
                y: -1,
                width: -1,
                height: -1
              };
            const [K, H, B, R] = $;
            return {
              x: K,
              y: H,
              width: B,
              height: R
            };
          }
          class I {
            static get FAILURE() {
              return (0, s.shadow)(this, "FAILURE", new I(!1, null, null, null));
            }
            static get EMPTY() {
              return (0, s.shadow)(this, "EMPTY", new I(!0, null, null, null));
            }
            constructor(D, $, K, H) {
              this.success = D, this.html = $, this.bbox = K, this.breakNode = H;
            }
            isBreak() {
              return !!this.breakNode;
            }
            static breakNode(D) {
              return new I(!1, null, null, D);
            }
            static success(D, $ = null) {
              return new I(!0, D, $, null);
            }
          }
          c.HTMLResult = I;
        },
        /* 85 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.FontFinder = void 0, c.getMetrics = m, c.selectFont = i;
          var s = f(78), h = f(84), g = f(2);
          class t {
            constructor(E) {
              this.fonts = /* @__PURE__ */ new Map(), this.cache = /* @__PURE__ */ new Map(), this.warned = /* @__PURE__ */ new Set(), this.defaultFont = null, this.add(E);
            }
            add(E, S = null) {
              for (const x of E)
                this.addPdfFont(x);
              for (const x of this.fonts.values())
                x.regular || (x.regular = x.italic || x.bold || x.bolditalic);
              if (!S || S.size === 0)
                return;
              const y = this.fonts.get("PdfJS-Fallback-PdfJS-XFA");
              for (const x of S)
                this.fonts.set(x, y);
            }
            addPdfFont(E) {
              var I, O, D;
              const S = E.cssFontInfo, y = S.fontFamily;
              let x = this.fonts.get(y);
              x || (x = /* @__PURE__ */ Object.create(null), this.fonts.set(y, x), this.defaultFont || (this.defaultFont = x));
              let b = "";
              const u = parseFloat(S.fontWeight);
              parseFloat(S.italicAngle) !== 0 ? b = u >= 700 ? "bolditalic" : "italic" : u >= 700 && (b = "bold"), b || ((E.name.includes("Bold") || (I = E.psName) != null && I.includes("Bold")) && (b = "bold"), (E.name.includes("Italic") || E.name.endsWith("It") || (O = E.psName) != null && O.includes("Italic") || (D = E.psName) != null && D.endsWith("It")) && (b += "italic")), b || (b = "regular"), x[b] = E;
            }
            getDefault() {
              return this.defaultFont;
            }
            find(E, S = !0) {
              var I, O;
              let y = this.fonts.get(E) || this.cache.get(E);
              if (y)
                return y;
              const x = /,|-|_| |bolditalic|bold|italic|regular|it/gi;
              let b = E.replaceAll(x, "");
              if (y = this.fonts.get(b), y)
                return this.cache.set(E, y), y;
              b = b.toLowerCase();
              const u = [];
              for (const [D, $] of this.fonts.entries())
                D.replaceAll(x, "").toLowerCase().startsWith(b) && u.push($);
              if (u.length === 0)
                for (const [, D] of this.fonts.entries())
                  (I = D.regular.name) != null && I.replaceAll(x, "").toLowerCase().startsWith(b) && u.push(D);
              if (u.length === 0) {
                b = b.replaceAll(/psmt|mt/gi, "");
                for (const [D, $] of this.fonts.entries())
                  D.replaceAll(x, "").toLowerCase().startsWith(b) && u.push($);
              }
              if (u.length === 0)
                for (const D of this.fonts.values())
                  (O = D.regular.name) != null && O.replaceAll(x, "").toLowerCase().startsWith(b) && u.push(D);
              return u.length >= 1 ? (u.length !== 1 && S && (0, g.warn)(`XFA - Too many choices to guess the correct font: ${E}`), this.cache.set(E, u[0]), u[0]) : (S && !this.warned.has(E) && (this.warned.add(E), (0, g.warn)(`XFA - Cannot find the font: ${E}`)), null);
            }
          }
          c.FontFinder = t;
          function i(v, E) {
            return v.posture === "italic" ? v.weight === "bold" ? E.bolditalic : E.italic : v.weight === "bold" ? E.bold : E.regular;
          }
          function m(v, E = !1) {
            let S = null;
            if (v) {
              const u = (0, h.stripQuotes)(v.typeface), I = v[s.$globalData].fontFinder.find(u);
              S = i(v, I);
            }
            if (!S)
              return {
                lineHeight: 12,
                lineGap: 2,
                lineNoGap: 10
              };
            const y = v.size || 10, x = S.lineHeight ? Math.max(E ? 0 : 1.2, S.lineHeight) : 1.2, b = S.lineGap === void 0 ? 0.2 : S.lineGap;
            return {
              lineHeight: x * y,
              lineGap: b * y,
              lineNoGap: Math.max(1, x - b) * y
            };
          }
        },
        /* 86 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.TextMeasure = void 0;
          var s = f(85);
          const h = 1.02;
          class g {
            constructor(v, E, S, y) {
              if (this.lineHeight = S, this.paraMargin = E || {
                top: 0,
                bottom: 0,
                left: 0,
                right: 0
              }, !v) {
                [this.pdfFont, this.xfaFont] = this.defaultFont(y);
                return;
              }
              this.xfaFont = {
                typeface: v.typeface,
                posture: v.posture,
                weight: v.weight,
                size: v.size,
                letterSpacing: v.letterSpacing
              };
              const x = y.find(v.typeface);
              if (!x) {
                [this.pdfFont, this.xfaFont] = this.defaultFont(y);
                return;
              }
              this.pdfFont = (0, s.selectFont)(v, x), this.pdfFont || ([this.pdfFont, this.xfaFont] = this.defaultFont(y));
            }
            defaultFont(v) {
              const E = v.find("Helvetica", !1) || v.find("Myriad Pro", !1) || v.find("Arial", !1) || v.getDefault();
              if (E != null && E.regular) {
                const y = E.regular, b = {
                  typeface: y.cssFontInfo.fontFamily,
                  posture: "normal",
                  weight: "normal",
                  size: 10,
                  letterSpacing: 0
                };
                return [y, b];
              }
              return [null, {
                typeface: "Courier",
                posture: "normal",
                weight: "normal",
                size: 10,
                letterSpacing: 0
              }];
            }
          }
          class t {
            constructor(v, E, S, y) {
              this.fontFinder = y, this.stack = [new g(v, E, S, y)];
            }
            pushData(v, E, S) {
              const y = this.stack.at(-1);
              for (const b of ["typeface", "posture", "weight", "size", "letterSpacing"])
                v[b] || (v[b] = y.xfaFont[b]);
              for (const b of ["top", "bottom", "left", "right"])
                isNaN(E[b]) && (E[b] = y.paraMargin[b]);
              const x = new g(v, E, S || y.lineHeight, this.fontFinder);
              x.pdfFont || (x.pdfFont = y.pdfFont), this.stack.push(x);
            }
            popFont() {
              this.stack.pop();
            }
            topFont() {
              return this.stack.at(-1);
            }
          }
          class i {
            constructor(v, E, S, y) {
              this.glyphs = [], this.fontSelector = new t(v, E, S, y), this.extraHeight = 0;
            }
            pushData(v, E, S) {
              this.fontSelector.pushData(v, E, S);
            }
            popFont(v) {
              return this.fontSelector.popFont();
            }
            addPara() {
              const v = this.fontSelector.topFont();
              this.extraHeight += v.paraMargin.top + v.paraMargin.bottom;
            }
            addString(v) {
              if (!v)
                return;
              const E = this.fontSelector.topFont(), S = E.xfaFont.size;
              if (E.pdfFont) {
                const y = E.xfaFont.letterSpacing, x = E.pdfFont, b = x.lineHeight || 1.2, u = E.lineHeight || Math.max(1.2, b) * S, I = x.lineGap === void 0 ? 0.2 : x.lineGap, O = b - I, D = Math.max(1, O) * S, $ = S / 1e3, K = x.defaultWidth || x.charsToGlyphs(" ")[0].width;
                for (const H of v.split(/[\u2029\n]/)) {
                  const B = x.encodeString(H).join(""), R = x.charsToGlyphs(B);
                  for (const _ of R) {
                    const A = _.width || K;
                    this.glyphs.push([A * $ + y, u, D, _.unicode, !1]);
                  }
                  this.glyphs.push([0, 0, 0, `
`, !0]);
                }
                this.glyphs.pop();
                return;
              }
              for (const y of v.split(/[\u2029\n]/)) {
                for (const x of y.split(""))
                  this.glyphs.push([S, 1.2 * S, S, x, !1]);
                this.glyphs.push([0, 0, 0, `
`, !0]);
              }
              this.glyphs.pop();
            }
            compute(v) {
              let E = -1, S = 0, y = 0, x = 0, b = 0, u = 0, I = !1, O = !0;
              for (let D = 0, $ = this.glyphs.length; D < $; D++) {
                const [K, H, B, R, _] = this.glyphs[D], A = R === " ", k = O ? B : H;
                if (_) {
                  y = Math.max(y, b), b = 0, x += u, u = k, E = -1, S = 0, O = !1;
                  continue;
                }
                if (A) {
                  b + K > v ? (y = Math.max(y, b), b = 0, x += u, u = k, E = -1, S = 0, I = !0, O = !1) : (u = Math.max(k, u), S = b, b += K, E = D);
                  continue;
                }
                if (b + K > v) {
                  x += u, u = k, E !== -1 ? (D = E, y = Math.max(y, S), b = 0, E = -1, S = 0) : (y = Math.max(y, b), b = K), I = !0, O = !1;
                  continue;
                }
                b += K, u = Math.max(k, u);
              }
              return y = Math.max(y, b), x += u + this.extraHeight, {
                width: h * y,
                height: x,
                isBroken: I
              };
            }
          }
          c.TextMeasure = i;
        },
        /* 87 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.XmlObject = c.XFAObjectArray = c.XFAObject = c.XFAAttribute = c.StringObject = c.OptionObject = c.Option10 = c.Option01 = c.IntegerObject = c.ContentObject = void 0;
          var s = f(78), h = f(84), g = f(2), t = f(3), i = f(81), m = f(88);
          const v = Symbol(), E = Symbol(), S = Symbol(), y = Symbol("_children"), x = Symbol(), b = Symbol(), u = Symbol(), I = Symbol(), O = Symbol(), D = Symbol(), $ = Symbol(), K = Symbol(), H = Symbol(), B = Symbol("parent"), R = Symbol(), _ = Symbol(), A = Symbol();
          let k = 0;
          const z = i.NamespaceIds.datasets.id;
          class T {
            constructor(N, q, ie = !1) {
              this[s.$namespaceId] = N, this[s.$nodeName] = q, this[$] = ie, this[B] = null, this[y] = [], this[s.$uid] = `${q}${k++}`, this[s.$globalData] = null;
            }
            get isXFAObject() {
              return !0;
            }
            get isXFAObjectArray() {
              return !1;
            }
            createNodes(N) {
              let q = this, ie = null;
              for (const {
                name: oe,
                index: fe
              } of N) {
                for (let Y = 0, ae = isFinite(fe) ? fe : 0; Y <= ae; Y++) {
                  const se = q[s.$namespaceId] === z ? -1 : q[s.$namespaceId];
                  ie = new j(se, oe), q[s.$appendChild](ie);
                }
                q = ie;
              }
              return ie;
            }
            [s.$onChild](N) {
              if (!this[$] || !this[s.$onChildCheck](N))
                return !1;
              const q = N[s.$nodeName], ie = this[q];
              if (ie instanceof w) {
                if (ie.push(N))
                  return this[s.$appendChild](N), !0;
              } else
                return ie !== null && this[s.$removeChild](ie), this[q] = N, this[s.$appendChild](N), !0;
              let oe = "";
              return this.id ? oe = ` (id: ${this.id})` : this.name && (oe = ` (name: ${this.name} ${this.h.value})`), (0, g.warn)(`XFA - node "${this[s.$nodeName]}"${oe} has already enough "${q}"!`), !1;
            }
            [s.$onChildCheck](N) {
              return this.hasOwnProperty(N[s.$nodeName]) && N[s.$namespaceId] === this[s.$namespaceId];
            }
            [s.$isNsAgnostic]() {
              return !1;
            }
            [s.$acceptWhitespace]() {
              return !1;
            }
            [s.$isCDATAXml]() {
              return !1;
            }
            [s.$isBindable]() {
              return !1;
            }
            [s.$popPara]() {
              this.para && this[s.$getTemplateRoot]()[s.$extra].paraStack.pop();
            }
            [s.$pushPara]() {
              this[s.$getTemplateRoot]()[s.$extra].paraStack.push(this.para);
            }
            [s.$setId](N) {
              this.id && this[s.$namespaceId] === i.NamespaceIds.template.id && N.set(this.id, this);
            }
            [s.$getTemplateRoot]() {
              return this[s.$globalData].template;
            }
            [s.$isSplittable]() {
              return !1;
            }
            [s.$isThereMoreWidth]() {
              return !1;
            }
            [s.$appendChild](N) {
              N[B] = this, this[y].push(N), !N[s.$globalData] && this[s.$globalData] && (N[s.$globalData] = this[s.$globalData]);
            }
            [s.$removeChild](N) {
              const q = this[y].indexOf(N);
              this[y].splice(q, 1);
            }
            [s.$hasSettableValue]() {
              return this.hasOwnProperty("value");
            }
            [s.$setValue](N) {
            }
            [s.$onText](N) {
            }
            [s.$finalize]() {
            }
            [s.$clean](N) {
              delete this[$], this[s.$cleanup] && (N.clean(this[s.$cleanup]), delete this[s.$cleanup]);
            }
            [s.$indexOf](N) {
              return this[y].indexOf(N);
            }
            [s.$insertAt](N, q) {
              q[B] = this, this[y].splice(N, 0, q), !q[s.$globalData] && this[s.$globalData] && (q[s.$globalData] = this[s.$globalData]);
            }
            [s.$isTransparent]() {
              return !this.name;
            }
            [s.$lastAttribute]() {
              return "";
            }
            [s.$text]() {
              return this[y].length === 0 ? this[s.$content] : this[y].map((N) => N[s.$text]()).join("");
            }
            get [S]() {
              const N = Object.getPrototypeOf(this);
              if (!N._attributes) {
                const q = N._attributes = /* @__PURE__ */ new Set();
                for (const ie of Object.getOwnPropertyNames(this)) {
                  if (this[ie] === null || this[ie] instanceof T || this[ie] instanceof w)
                    break;
                  q.add(ie);
                }
              }
              return (0, g.shadow)(this, S, N._attributes);
            }
            [s.$isDescendent](N) {
              let q = this;
              for (; q; ) {
                if (q === N)
                  return !0;
                q = q[s.$getParent]();
              }
              return !1;
            }
            [s.$getParent]() {
              return this[B];
            }
            [s.$getSubformParent]() {
              return this[s.$getParent]();
            }
            [s.$getChildren](N = null) {
              return N ? this[N] : this[y];
            }
            [s.$dump]() {
              const N = /* @__PURE__ */ Object.create(null);
              this[s.$content] && (N.$content = this[s.$content]);
              for (const q of Object.getOwnPropertyNames(this)) {
                const ie = this[q];
                ie !== null && (ie instanceof T ? N[q] = ie[s.$dump]() : ie instanceof w ? ie.isEmpty() || (N[q] = ie.dump()) : N[q] = ie);
              }
              return N;
            }
            [s.$toStyle]() {
              return null;
            }
            [s.$toHTML]() {
              return h.HTMLResult.EMPTY;
            }
            *[s.$getContainedChildren]() {
              for (const N of this[s.$getChildren]())
                yield N;
            }
            *[I](N, q) {
              for (const ie of this[s.$getContainedChildren]())
                if (!N || q === N.has(ie[s.$nodeName])) {
                  const oe = this[s.$getAvailableSpace](), fe = ie[s.$toHTML](oe);
                  fe.success || (this[s.$extra].failingNode = ie), yield fe;
                }
            }
            [s.$flushHTML]() {
              return null;
            }
            [s.$addHTML](N, q) {
              this[s.$extra].children.push(N);
            }
            [s.$getAvailableSpace]() {
            }
            [s.$childrenToHTML]({
              filter: N = null,
              include: q = !0
            }) {
              if (!this[s.$extra].generator)
                this[s.$extra].generator = this[I](N, q);
              else {
                const ie = this[s.$getAvailableSpace](), oe = this[s.$extra].failingNode[s.$toHTML](ie);
                if (!oe.success)
                  return oe;
                oe.html && this[s.$addHTML](oe.html, oe.bbox), delete this[s.$extra].failingNode;
              }
              for (; ; ) {
                const ie = this[s.$extra].generator.next();
                if (ie.done)
                  break;
                const oe = ie.value;
                if (!oe.success)
                  return oe;
                oe.html && this[s.$addHTML](oe.html, oe.bbox);
              }
              return this[s.$extra].generator = null, h.HTMLResult.EMPTY;
            }
            [s.$setSetAttributes](N) {
              this[_] = new Set(Object.keys(N));
            }
            [D](N) {
              const q = this[S], ie = this[_];
              return [...N].filter((oe) => q.has(oe) && !ie.has(oe));
            }
            [s.$resolvePrototypes](N, q = /* @__PURE__ */ new Set()) {
              for (const ie of this[y])
                ie[R](N, q);
            }
            [R](N, q) {
              const ie = this[O](N, q);
              ie ? this[v](ie, N, q) : this[s.$resolvePrototypes](N, q);
            }
            [O](N, q) {
              const {
                use: ie,
                usehref: oe
              } = this;
              if (!ie && !oe)
                return null;
              let fe = null, Y = null, ae = null, se = ie;
              if (oe ? (se = oe, oe.startsWith("#som(") && oe.endsWith(")") ? Y = oe.slice(5, -1) : oe.startsWith(".#som(") && oe.endsWith(")") ? Y = oe.slice(6, -1) : oe.startsWith("#") ? ae = oe.slice(1) : oe.startsWith(".#") && (ae = oe.slice(2))) : ie.startsWith("#") ? ae = ie.slice(1) : Y = ie, this.use = this.usehref = "", ae ? fe = N.get(ae) : (fe = (0, m.searchNode)(N.get(s.$root), this, Y, !0, !1), fe && (fe = fe[0])), !fe)
                return (0, g.warn)(`XFA - Invalid prototype reference: ${se}.`), null;
              if (fe[s.$nodeName] !== this[s.$nodeName])
                return (0, g.warn)(`XFA - Incompatible prototype: ${fe[s.$nodeName]} !== ${this[s.$nodeName]}.`), null;
              if (q.has(fe))
                return (0, g.warn)("XFA - Cycle detected in prototypes use."), null;
              q.add(fe);
              const L = fe[O](N, q);
              return L && fe[v](L, N, q), fe[s.$resolvePrototypes](N, q), q.delete(fe), fe;
            }
            [v](N, q, ie) {
              if (ie.has(N)) {
                (0, g.warn)("XFA - Cycle detected in prototypes use.");
                return;
              }
              !this[s.$content] && N[s.$content] && (this[s.$content] = N[s.$content]), new Set(ie).add(N);
              for (const fe of this[D](N[_]))
                this[fe] = N[fe], this[_] && this[_].add(fe);
              for (const fe of Object.getOwnPropertyNames(this)) {
                if (this[S].has(fe))
                  continue;
                const Y = this[fe], ae = N[fe];
                if (Y instanceof w) {
                  for (const se of Y[y])
                    se[R](q, ie);
                  for (let se = Y[y].length, L = ae[y].length; se < L; se++) {
                    const W = N[y][se][s.$clone]();
                    if (Y.push(W))
                      W[B] = this, this[y].push(W), W[R](q, ie);
                    else
                      break;
                  }
                  continue;
                }
                if (Y !== null) {
                  Y[s.$resolvePrototypes](q, ie), ae && Y[v](ae, q, ie);
                  continue;
                }
                if (ae !== null) {
                  const se = ae[s.$clone]();
                  se[B] = this, this[fe] = se, this[y].push(se), se[R](q, ie);
                }
              }
            }
            static [x](N) {
              return Array.isArray(N) ? N.map((q) => T[x](q)) : typeof N == "object" && N !== null ? Object.assign({}, N) : N;
            }
            [s.$clone]() {
              const N = Object.create(Object.getPrototypeOf(this));
              for (const q of Object.getOwnPropertySymbols(this))
                try {
                  N[q] = this[q];
                } catch {
                  (0, g.shadow)(N, q, this[q]);
                }
              N[s.$uid] = `${N[s.$nodeName]}${k++}`, N[y] = [];
              for (const q of Object.getOwnPropertyNames(this)) {
                if (this[S].has(q)) {
                  N[q] = T[x](this[q]);
                  continue;
                }
                const ie = this[q];
                N[q] = ie instanceof w ? new w(ie[K]) : null;
              }
              for (const q of this[y]) {
                const ie = q[s.$nodeName], oe = q[s.$clone]();
                N[y].push(oe), oe[B] = N, N[ie] === null ? N[ie] = oe : N[ie][y].push(oe);
              }
              return N;
            }
            [s.$getChildren](N = null) {
              return N ? this[y].filter((q) => q[s.$nodeName] === N) : this[y];
            }
            [s.$getChildrenByClass](N) {
              return this[N];
            }
            [s.$getChildrenByName](N, q, ie = !0) {
              return Array.from(this[s.$getChildrenByNameIt](N, q, ie));
            }
            *[s.$getChildrenByNameIt](N, q, ie = !0) {
              if (N === "parent") {
                yield this[B];
                return;
              }
              for (const oe of this[y])
                oe[s.$nodeName] === N && (yield oe), oe.name === N && (yield oe), (q || oe[s.$isTransparent]()) && (yield* oe[s.$getChildrenByNameIt](N, q, !1));
              ie && this[S].has(N) && (yield new F(this, N, this[N]));
            }
          }
          c.XFAObject = T;
          class w {
            constructor(N = 1 / 0) {
              this[K] = N, this[y] = [];
            }
            get isXFAObject() {
              return !1;
            }
            get isXFAObjectArray() {
              return !0;
            }
            push(N) {
              return this[y].length <= this[K] ? (this[y].push(N), !0) : ((0, g.warn)(`XFA - node "${N[s.$nodeName]}" accepts no more than ${this[K]} children`), !1);
            }
            isEmpty() {
              return this[y].length === 0;
            }
            dump() {
              return this[y].length === 1 ? this[y][0][s.$dump]() : this[y].map((N) => N[s.$dump]());
            }
            [s.$clone]() {
              const N = new w(this[K]);
              return N[y] = this[y].map((q) => q[s.$clone]()), N;
            }
            get children() {
              return this[y];
            }
            clear() {
              this[y].length = 0;
            }
          }
          c.XFAObjectArray = w;
          class F {
            constructor(N, q, ie) {
              this[B] = N, this[s.$nodeName] = q, this[s.$content] = ie, this[s.$consumed] = !1, this[s.$uid] = `attribute${k++}`;
            }
            [s.$getParent]() {
              return this[B];
            }
            [s.$isDataValue]() {
              return !0;
            }
            [s.$getDataValue]() {
              return this[s.$content].trim();
            }
            [s.$setValue](N) {
              N = N.value || "", this[s.$content] = N.toString();
            }
            [s.$text]() {
              return this[s.$content];
            }
            [s.$isDescendent](N) {
              return this[B] === N || this[B][s.$isDescendent](N);
            }
          }
          c.XFAAttribute = F;
          class j extends T {
            constructor(N, q, ie = {}) {
              if (super(N, q), this[s.$content] = "", this[b] = null, q !== "#text") {
                const oe = /* @__PURE__ */ new Map();
                this[E] = oe;
                for (const [fe, Y] of Object.entries(ie))
                  oe.set(fe, new F(this, fe, Y));
                if (ie.hasOwnProperty(s.$nsAttributes)) {
                  const fe = ie[s.$nsAttributes].xfa.dataNode;
                  fe !== void 0 && (fe === "dataGroup" ? this[b] = !1 : fe === "dataValue" && (this[b] = !0));
                }
              }
              this[s.$consumed] = !1;
            }
            [s.$toString](N) {
              const q = this[s.$nodeName];
              if (q === "#text") {
                N.push((0, t.encodeToXmlString)(this[s.$content]));
                return;
              }
              const ie = (0, g.utf8StringToString)(q), oe = this[s.$namespaceId] === z ? "xfa:" : "";
              N.push(`<${oe}${ie}`);
              for (const [fe, Y] of this[E].entries()) {
                const ae = (0, g.utf8StringToString)(fe);
                N.push(` ${ae}="${(0, t.encodeToXmlString)(Y[s.$content])}"`);
              }
              if (this[b] !== null && (this[b] ? N.push(' xfa:dataNode="dataValue"') : N.push(' xfa:dataNode="dataGroup"')), !this[s.$content] && this[y].length === 0) {
                N.push("/>");
                return;
              }
              if (N.push(">"), this[s.$content])
                typeof this[s.$content] == "string" ? N.push((0, t.encodeToXmlString)(this[s.$content])) : this[s.$content][s.$toString](N);
              else
                for (const fe of this[y])
                  fe[s.$toString](N);
              N.push(`</${oe}${ie}>`);
            }
            [s.$onChild](N) {
              if (this[s.$content]) {
                const q = new j(this[s.$namespaceId], "#text");
                this[s.$appendChild](q), q[s.$content] = this[s.$content], this[s.$content] = "";
              }
              return this[s.$appendChild](N), !0;
            }
            [s.$onText](N) {
              this[s.$content] += N;
            }
            [s.$finalize]() {
              if (this[s.$content] && this[y].length > 0) {
                const N = new j(this[s.$namespaceId], "#text");
                this[s.$appendChild](N), N[s.$content] = this[s.$content], delete this[s.$content];
              }
            }
            [s.$toHTML]() {
              return this[s.$nodeName] === "#text" ? h.HTMLResult.success({
                name: "#text",
                value: this[s.$content]
              }) : h.HTMLResult.EMPTY;
            }
            [s.$getChildren](N = null) {
              return N ? this[y].filter((q) => q[s.$nodeName] === N) : this[y];
            }
            [s.$getAttributes]() {
              return this[E];
            }
            [s.$getChildrenByClass](N) {
              const q = this[E].get(N);
              return q !== void 0 ? q : this[s.$getChildren](N);
            }
            *[s.$getChildrenByNameIt](N, q) {
              const ie = this[E].get(N);
              ie && (yield ie);
              for (const oe of this[y])
                oe[s.$nodeName] === N && (yield oe), q && (yield* oe[s.$getChildrenByNameIt](N, q));
            }
            *[s.$getAttributeIt](N, q) {
              const ie = this[E].get(N);
              ie && (!q || !ie[s.$consumed]) && (yield ie);
              for (const oe of this[y])
                yield* oe[s.$getAttributeIt](N, q);
            }
            *[s.$getRealChildrenByNameIt](N, q, ie) {
              for (const oe of this[y])
                oe[s.$nodeName] === N && (!ie || !oe[s.$consumed]) && (yield oe), q && (yield* oe[s.$getRealChildrenByNameIt](N, q, ie));
            }
            [s.$isDataValue]() {
              return this[b] === null ? this[y].length === 0 || this[y][0][s.$namespaceId] === i.NamespaceIds.xhtml.id : this[b];
            }
            [s.$getDataValue]() {
              return this[b] === null ? this[y].length === 0 ? this[s.$content].trim() : this[y][0][s.$namespaceId] === i.NamespaceIds.xhtml.id ? this[y][0][s.$text]().trim() : null : this[s.$content].trim();
            }
            [s.$setValue](N) {
              N = N.value || "", this[s.$content] = N.toString();
            }
            [s.$dump](N = !1) {
              const q = /* @__PURE__ */ Object.create(null);
              N && (q.$ns = this[s.$namespaceId]), this[s.$content] && (q.$content = this[s.$content]), q.$name = this[s.$nodeName], q.children = [];
              for (const ie of this[y])
                q.children.push(ie[s.$dump](N));
              q.attributes = /* @__PURE__ */ Object.create(null);
              for (const [ie, oe] of this[E])
                q.attributes[ie] = oe[s.$content];
              return q;
            }
          }
          c.XmlObject = j;
          class P extends T {
            constructor(N, q) {
              super(N, q), this[s.$content] = "";
            }
            [s.$onText](N) {
              this[s.$content] += N;
            }
            [s.$finalize]() {
            }
          }
          c.ContentObject = P;
          class V extends P {
            constructor(N, q, ie) {
              super(N, q), this[H] = ie;
            }
            [s.$finalize]() {
              this[s.$content] = (0, h.getKeyword)({
                data: this[s.$content],
                defaultValue: this[H][0],
                validate: (N) => this[H].includes(N)
              });
            }
            [s.$clean](N) {
              super[s.$clean](N), delete this[H];
            }
          }
          c.OptionObject = V;
          class J extends P {
            [s.$finalize]() {
              this[s.$content] = this[s.$content].trim();
            }
          }
          c.StringObject = J;
          class ne extends P {
            constructor(N, q, ie, oe) {
              super(N, q), this[u] = ie, this[A] = oe;
            }
            [s.$finalize]() {
              this[s.$content] = (0, h.getInteger)({
                data: this[s.$content],
                defaultValue: this[u],
                validate: this[A]
              });
            }
            [s.$clean](N) {
              super[s.$clean](N), delete this[u], delete this[A];
            }
          }
          c.IntegerObject = ne;
          class Z extends ne {
            constructor(N, q) {
              super(N, q, 0, (ie) => ie === 1);
            }
          }
          c.Option01 = Z;
          class te extends ne {
            constructor(N, q) {
              super(N, q, 1, (ie) => ie === 0);
            }
          }
          c.Option10 = te;
        },
        /* 88 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.createDataNode = x, c.searchNode = y;
          var s = f(78), h = f(2);
          const g = /^[^.[]+/, t = /^[^\]]+/, i = {
            dot: 0,
            dotDot: 1,
            dotHash: 2,
            dotBracket: 3,
            dotParen: 4
          }, m = /* @__PURE__ */ new Map([["$data", (b, u) => b.datasets ? b.datasets.data : b], ["$record", (b, u) => (b.datasets ? b.datasets.data : b)[s.$getChildren]()[0]], ["$template", (b, u) => b.template], ["$connectionSet", (b, u) => b.connectionSet], ["$form", (b, u) => b.form], ["$layout", (b, u) => b.layout], ["$host", (b, u) => b.host], ["$dataWindow", (b, u) => b.dataWindow], ["$event", (b, u) => b.event], ["!", (b, u) => b.datasets], ["$xfa", (b, u) => b], ["xfa", (b, u) => b], ["$", (b, u) => u]]), v = /* @__PURE__ */ new WeakMap();
          function E(b) {
            return b = b.trim(), b === "*" ? 1 / 0 : parseInt(b, 10) || 0;
          }
          function S(b, u, I = !0) {
            let O = b.match(g);
            if (!O)
              return null;
            let [D] = O;
            const $ = [{
              name: D,
              cacheName: "." + D,
              index: 0,
              js: null,
              formCalc: null,
              operator: i.dot
            }];
            let K = D.length;
            for (; K < b.length; ) {
              const H = K;
              if (b.charAt(K++) === "[") {
                if (O = b.slice(K).match(t), !O)
                  return (0, h.warn)("XFA - Invalid index in SOM expression"), null;
                $.at(-1).index = E(O[0]), K += O[0].length + 1;
                continue;
              }
              let R;
              switch (b.charAt(K)) {
                case ".":
                  if (!u)
                    return null;
                  K++, R = i.dotDot;
                  break;
                case "#":
                  K++, R = i.dotHash;
                  break;
                case "[":
                  if (I)
                    return (0, h.warn)("XFA - SOM expression contains a FormCalc subexpression which is not supported for now."), null;
                  R = i.dotBracket;
                  break;
                case "(":
                  if (I)
                    return (0, h.warn)("XFA - SOM expression contains a JavaScript subexpression which is not supported for now."), null;
                  R = i.dotParen;
                  break;
                default:
                  R = i.dot;
                  break;
              }
              if (O = b.slice(K).match(g), !O)
                break;
              [D] = O, K += D.length, $.push({
                name: D,
                cacheName: b.slice(H, K),
                operator: R,
                index: 0,
                js: null,
                formCalc: null
              });
            }
            return $;
          }
          function y(b, u, I, O = !0, D = !0) {
            const $ = S(I, O);
            if (!$)
              return null;
            const K = m.get($[0].name);
            let H = 0, B;
            K ? (B = !0, b = [K(b, u)], H = 1) : (B = u === null, b = [u || b]);
            for (let R = $.length; H < R; H++) {
              const {
                name: _,
                cacheName: A,
                operator: k,
                index: z
              } = $[H], T = [];
              for (const w of b) {
                if (!w.isXFAObject)
                  continue;
                let F, j;
                if (D && (j = v.get(w), j || (j = /* @__PURE__ */ new Map(), v.set(w, j)), F = j.get(A)), !F) {
                  switch (k) {
                    case i.dot:
                      F = w[s.$getChildrenByName](_, !1);
                      break;
                    case i.dotDot:
                      F = w[s.$getChildrenByName](_, !0);
                      break;
                    case i.dotHash:
                      F = w[s.$getChildrenByClass](_), F = F.isXFAObjectArray ? F.children : [F];
                      break;
                  }
                  D && j.set(A, F);
                }
                F.length > 0 && T.push(F);
              }
              if (T.length === 0 && !B && H === 0) {
                if (u = u[s.$getParent](), !u)
                  return null;
                H = -1, b = [u];
                continue;
              }
              b = isFinite(z) ? T.filter((w) => z < w.length).map((w) => w[z]) : T.flat();
            }
            return b.length === 0 ? null : b;
          }
          function x(b, u, I) {
            const O = S(I);
            if (!O || O.some((K) => K.operator === i.dotDot))
              return null;
            const D = m.get(O[0].name);
            let $ = 0;
            D ? (b = D(b, u), $ = 1) : b = u || b;
            for (let K = O.length; $ < K; $++) {
              const {
                name: H,
                operator: B,
                index: R
              } = O[$];
              if (!isFinite(R))
                return O[$].index = 0, b.createNodes(O.slice($));
              let _;
              switch (B) {
                case i.dot:
                  _ = b[s.$getChildrenByName](H, !1);
                  break;
                case i.dotDot:
                  _ = b[s.$getChildrenByName](H, !0);
                  break;
                case i.dotHash:
                  _ = b[s.$getChildrenByClass](H), _ = _.isXFAObjectArray ? _.children : [_];
                  break;
              }
              if (_.length === 0)
                return b.createNodes(O.slice($));
              if (R < _.length) {
                const A = _[R];
                if (!A.isXFAObject)
                  return (0, h.warn)("XFA - Cannot create a node."), null;
                b = A;
              } else
                return O[$].index = R - _.length, b.createNodes(O.slice($));
            }
            return null;
          }
        },
        /* 89 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.DataHandler = void 0;
          var s = f(78);
          class h {
            constructor(t, i) {
              this.data = i, this.dataset = t.datasets || null;
            }
            serialize(t) {
              const i = [[-1, this.data[s.$getChildren]()]];
              for (; i.length > 0; ) {
                const v = i.at(-1), [E, S] = v;
                if (E + 1 === S.length) {
                  i.pop();
                  continue;
                }
                const y = S[++v[0]], x = t.get(y[s.$uid]);
                if (x)
                  y[s.$setValue](x);
                else {
                  const u = y[s.$getAttributes]();
                  for (const I of u.values()) {
                    const O = t.get(I[s.$uid]);
                    if (O) {
                      I[s.$setValue](O);
                      break;
                    }
                  }
                }
                const b = y[s.$getChildren]();
                b.length > 0 && i.push([-1, b]);
              }
              const m = ['<xfa:datasets xmlns:xfa="http://www.xfa.org/schema/xfa-data/1.0/">'];
              if (this.dataset)
                for (const v of this.dataset[s.$getChildren]())
                  v[s.$nodeName] !== "data" && v[s.$toString](m);
              return this.data[s.$toString](m), m.push("</xfa:datasets>"), m.join("");
            }
          }
          c.DataHandler = h;
        },
        /* 90 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.XFAParser = void 0;
          var s = f(78), h = f(71), g = f(91), t = f(2);
          class i extends h.XMLParserBase {
            constructor(v = null, E = !1) {
              super(), this._builder = new g.Builder(v), this._stack = [], this._globalData = {
                usedTypefaces: /* @__PURE__ */ new Set()
              }, this._ids = /* @__PURE__ */ new Map(), this._current = this._builder.buildRoot(this._ids), this._errorCode = h.XMLParserErrorCode.NoError, this._whiteRegex = /^\s+$/, this._nbsps = /\xa0+/g, this._richText = E;
            }
            parse(v) {
              if (this.parseXml(v), this._errorCode === h.XMLParserErrorCode.NoError)
                return this._current[s.$finalize](), this._current.element;
            }
            onText(v) {
              if (v = v.replace(this._nbsps, (E) => E.slice(1) + " "), this._richText || this._current[s.$acceptWhitespace]()) {
                this._current[s.$onText](v, this._richText);
                return;
              }
              this._whiteRegex.test(v) || this._current[s.$onText](v.trim());
            }
            onCdata(v) {
              this._current[s.$onText](v);
            }
            _mkAttributes(v, E) {
              let S = null, y = null;
              const x = /* @__PURE__ */ Object.create({});
              for (const {
                name: b,
                value: u
              } of v)
                if (b === "xmlns")
                  S ? (0, t.warn)(`XFA - multiple namespace definition in <${E}>`) : S = u;
                else if (b.startsWith("xmlns:")) {
                  const I = b.substring(6);
                  y || (y = []), y.push({
                    prefix: I,
                    value: u
                  });
                } else {
                  const I = b.indexOf(":");
                  if (I === -1)
                    x[b] = u;
                  else {
                    let O = x[s.$nsAttributes];
                    O || (O = x[s.$nsAttributes] = /* @__PURE__ */ Object.create(null));
                    const [D, $] = [b.slice(0, I), b.slice(I + 1)], K = O[D] || (O[D] = /* @__PURE__ */ Object.create(null));
                    K[$] = u;
                  }
                }
              return [S, y, x];
            }
            _getNameAndPrefix(v, E) {
              const S = v.indexOf(":");
              return S === -1 ? [v, null] : [v.substring(S + 1), E ? "" : v.substring(0, S)];
            }
            onBeginElement(v, E, S) {
              const [y, x, b] = this._mkAttributes(E, v), [u, I] = this._getNameAndPrefix(v, this._builder.isNsAgnostic()), O = this._builder.build({
                nsPrefix: I,
                name: u,
                attributes: b,
                namespace: y,
                prefixes: x
              });
              if (O[s.$globalData] = this._globalData, S) {
                O[s.$finalize](), this._current[s.$onChild](O) && O[s.$setId](this._ids), O[s.$clean](this._builder);
                return;
              }
              this._stack.push(this._current), this._current = O;
            }
            onEndElement(v) {
              const E = this._current;
              if (E[s.$isCDATAXml]() && typeof E[s.$content] == "string") {
                const S = new i();
                S._globalData = this._globalData;
                const y = S.parse(E[s.$content]);
                E[s.$content] = null, E[s.$onChild](y);
              }
              E[s.$finalize](), this._current = this._stack.pop(), this._current[s.$onChild](E) && E[s.$setId](this._ids), E[s.$clean](this._builder);
            }
            onError(v) {
              this._errorCode = v;
            }
          }
          c.XFAParser = i;
        },
        /* 91 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.Builder = void 0;
          var s = f(81), h = f(78), g = f(92), t = f(80), i = f(101), m = f(2), v = f(87);
          class E extends v.XFAObject {
            constructor(b) {
              super(-1, "root", /* @__PURE__ */ Object.create(null)), this.element = null, this[h.$ids] = b;
            }
            [h.$onChild](b) {
              return this.element = b, !0;
            }
            [h.$finalize]() {
              super[h.$finalize](), this.element.template instanceof t.Template && (this[h.$ids].set(h.$root, this.element), this.element.template[h.$resolvePrototypes](this[h.$ids]), this.element.template[h.$ids] = this[h.$ids]);
            }
          }
          class S extends v.XFAObject {
            constructor() {
              super(-1, "", /* @__PURE__ */ Object.create(null));
            }
            [h.$onChild](b) {
              return !1;
            }
          }
          class y {
            constructor(b = null) {
              this._namespaceStack = [], this._nsAgnosticLevel = 0, this._namespacePrefixes = /* @__PURE__ */ new Map(), this._namespaces = /* @__PURE__ */ new Map(), this._nextNsId = Math.max(...Object.values(s.NamespaceIds).map(({
                id: u
              }) => u)), this._currentNamespace = b || new i.UnknownNamespace(++this._nextNsId);
            }
            buildRoot(b) {
              return new E(b);
            }
            build({
              nsPrefix: b,
              name: u,
              attributes: I,
              namespace: O,
              prefixes: D
            }) {
              const $ = O !== null;
              if ($ && (this._namespaceStack.push(this._currentNamespace), this._currentNamespace = this._searchNamespace(O)), D && this._addNamespacePrefix(D), I.hasOwnProperty(h.$nsAttributes)) {
                const B = g.NamespaceSetUp.datasets, R = I[h.$nsAttributes];
                let _ = null;
                for (const [A, k] of Object.entries(R))
                  if (this._getNamespaceToUse(A) === B) {
                    _ = {
                      xfa: k
                    };
                    break;
                  }
                _ ? I[h.$nsAttributes] = _ : delete I[h.$nsAttributes];
              }
              const K = this._getNamespaceToUse(b), H = (K == null ? void 0 : K[s.$buildXFAObject](u, I)) || new S();
              return H[h.$isNsAgnostic]() && this._nsAgnosticLevel++, ($ || D || H[h.$isNsAgnostic]()) && (H[h.$cleanup] = {
                hasNamespace: $,
                prefixes: D,
                nsAgnostic: H[h.$isNsAgnostic]()
              }), H;
            }
            isNsAgnostic() {
              return this._nsAgnosticLevel > 0;
            }
            _searchNamespace(b) {
              let u = this._namespaces.get(b);
              if (u)
                return u;
              for (const [I, {
                check: O
              }] of Object.entries(s.NamespaceIds))
                if (O(b)) {
                  if (u = g.NamespaceSetUp[I], u)
                    return this._namespaces.set(b, u), u;
                  break;
                }
              return u = new i.UnknownNamespace(++this._nextNsId), this._namespaces.set(b, u), u;
            }
            _addNamespacePrefix(b) {
              for (const {
                prefix: u,
                value: I
              } of b) {
                const O = this._searchNamespace(I);
                let D = this._namespacePrefixes.get(u);
                D || (D = [], this._namespacePrefixes.set(u, D)), D.push(O);
              }
            }
            _getNamespaceToUse(b) {
              if (!b)
                return this._currentNamespace;
              const u = this._namespacePrefixes.get(b);
              return (u == null ? void 0 : u.length) > 0 ? u.at(-1) : ((0, m.warn)(`Unknown namespace prefix: ${b}.`), null);
            }
            clean(b) {
              const {
                hasNamespace: u,
                prefixes: I,
                nsAgnostic: O
              } = b;
              u && (this._currentNamespace = this._namespaceStack.pop()), I && I.forEach(({
                prefix: D
              }) => {
                this._namespacePrefixes.get(D).pop();
              }), O && this._nsAgnosticLevel--;
            }
          }
          c.Builder = y;
        },
        /* 92 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.NamespaceSetUp = void 0;
          var s = f(93), h = f(94), g = f(95), t = f(96), i = f(97), m = f(98), v = f(80), E = f(99), S = f(100);
          const y = {
            config: s.ConfigNamespace,
            connection: h.ConnectionSetNamespace,
            datasets: g.DatasetsNamespace,
            localeSet: t.LocaleSetNamespace,
            signature: i.SignatureNamespace,
            stylesheet: m.StylesheetNamespace,
            template: v.TemplateNamespace,
            xdp: E.XdpNamespace,
            xhtml: S.XhtmlNamespace
          };
          c.NamespaceSetUp = y;
        },
        /* 93 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.ConfigNamespace = void 0;
          var s = f(81), h = f(78), g = f(87), t = f(84), i = f(2);
          const m = s.NamespaceIds.config.id;
          class v extends g.XFAObject {
            constructor(ue) {
              super(m, "acrobat", !0), this.acrobat7 = null, this.autoSave = null, this.common = null, this.validate = null, this.validateApprovalSignatures = null, this.submitUrl = new g.XFAObjectArray();
            }
          }
          class E extends g.XFAObject {
            constructor(ue) {
              super(m, "acrobat7", !0), this.dynamicRender = null;
            }
          }
          class S extends g.OptionObject {
            constructor(ue) {
              super(m, "ADBE_JSConsole", ["delegate", "Enable", "Disable"]);
            }
          }
          class y extends g.OptionObject {
            constructor(ue) {
              super(m, "ADBE_JSDebugger", ["delegate", "Enable", "Disable"]);
            }
          }
          class x extends g.Option01 {
            constructor(ue) {
              super(m, "addSilentPrint");
            }
          }
          class b extends g.Option01 {
            constructor(ue) {
              super(m, "addViewerPreferences");
            }
          }
          class u extends g.Option10 {
            constructor(ue) {
              super(m, "adjustData");
            }
          }
          class I extends g.IntegerObject {
            constructor(ue) {
              super(m, "adobeExtensionLevel", 0, (je) => je >= 1 && je <= 8);
            }
          }
          class O extends g.XFAObject {
            constructor(ue) {
              super(m, "agent", !0), this.name = ue.name ? ue.name.trim() : "", this.common = new g.XFAObjectArray();
            }
          }
          class D extends g.ContentObject {
            constructor(ue) {
              super(m, "alwaysEmbed");
            }
          }
          class $ extends g.StringObject {
            constructor(ue) {
              super(m, "amd");
            }
          }
          class K extends g.XFAObject {
            constructor(ue) {
              super(m, "area"), this.level = (0, t.getInteger)({
                data: ue.level,
                defaultValue: 0,
                validate: (je) => je >= 1 && je <= 3
              }), this.name = (0, t.getStringOption)(ue.name, ["", "barcode", "coreinit", "deviceDriver", "font", "general", "layout", "merge", "script", "signature", "sourceSet", "templateCache"]);
            }
          }
          class H extends g.OptionObject {
            constructor(ue) {
              super(m, "attributes", ["preserve", "delegate", "ignore"]);
            }
          }
          class B extends g.OptionObject {
            constructor(ue) {
              super(m, "autoSave", ["disabled", "enabled"]);
            }
          }
          class R extends g.StringObject {
            constructor(ue) {
              super(m, "base");
            }
          }
          class _ extends g.XFAObject {
            constructor(ue) {
              super(m, "batchOutput"), this.format = (0, t.getStringOption)(ue.format, ["none", "concat", "zip", "zipCompress"]);
            }
          }
          class A extends g.ContentObject {
            constructor(ue) {
              super(m, "behaviorOverride");
            }
            [h.$finalize]() {
              this[h.$content] = new Map(this[h.$content].trim().split(/\s+/).filter((ue) => ue.includes(":")).map((ue) => ue.split(":", 2)));
            }
          }
          class k extends g.XFAObject {
            constructor(ue) {
              super(m, "cache", !0), this.templateCache = null;
            }
          }
          class z extends g.Option01 {
            constructor(ue) {
              super(m, "change");
            }
          }
          class T extends g.XFAObject {
            constructor(ue) {
              super(m, "common", !0), this.data = null, this.locale = null, this.localeSet = null, this.messaging = null, this.suppressBanner = null, this.template = null, this.validationMessaging = null, this.versionControl = null, this.log = new g.XFAObjectArray();
            }
          }
          class w extends g.XFAObject {
            constructor(ue) {
              super(m, "compress"), this.scope = (0, t.getStringOption)(ue.scope, ["imageOnly", "document"]);
            }
          }
          class F extends g.Option01 {
            constructor(ue) {
              super(m, "compressLogicalStructure");
            }
          }
          class j extends g.Option10 {
            constructor(ue) {
              super(m, "compressObjectStream");
            }
          }
          class P extends g.XFAObject {
            constructor(ue) {
              super(m, "compression", !0), this.compressLogicalStructure = null, this.compressObjectStream = null, this.level = null, this.type = null;
            }
          }
          class V extends g.XFAObject {
            constructor(ue) {
              super(m, "config", !0), this.acrobat = null, this.present = null, this.trace = null, this.agent = new g.XFAObjectArray();
            }
          }
          class J extends g.OptionObject {
            constructor(ue) {
              super(m, "conformance", ["A", "B"]);
            }
          }
          class ne extends g.Option01 {
            constructor(ue) {
              super(m, "contentCopy");
            }
          }
          class Z extends g.IntegerObject {
            constructor(ue) {
              super(m, "copies", 1, (je) => je >= 1);
            }
          }
          class te extends g.StringObject {
            constructor(ue) {
              super(m, "creator");
            }
          }
          class G extends g.IntegerObject {
            constructor(ue) {
              super(m, "currentPage", 0, (je) => je >= 0);
            }
          }
          class N extends g.XFAObject {
            constructor(ue) {
              super(m, "data", !0), this.adjustData = null, this.attributes = null, this.incrementalLoad = null, this.outputXSL = null, this.range = null, this.record = null, this.startNode = null, this.uri = null, this.window = null, this.xsl = null, this.excludeNS = new g.XFAObjectArray(), this.transform = new g.XFAObjectArray();
            }
          }
          class q extends g.XFAObject {
            constructor(ue) {
              super(m, "debug", !0), this.uri = null;
            }
          }
          class ie extends g.ContentObject {
            constructor(ue) {
              super(m, "defaultTypeface"), this.writingScript = (0, t.getStringOption)(ue.writingScript, ["*", "Arabic", "Cyrillic", "EastEuropeanRoman", "Greek", "Hebrew", "Japanese", "Korean", "Roman", "SimplifiedChinese", "Thai", "TraditionalChinese", "Vietnamese"]);
            }
          }
          class oe extends g.OptionObject {
            constructor(ue) {
              super(m, "destination", ["pdf", "pcl", "ps", "webClient", "zpl"]);
            }
          }
          class fe extends g.Option01 {
            constructor(ue) {
              super(m, "documentAssembly");
            }
          }
          class Y extends g.XFAObject {
            constructor(ue) {
              super(m, "driver", !0), this.name = ue.name ? ue.name.trim() : "", this.fontInfo = null, this.xdc = null;
            }
          }
          class ae extends g.OptionObject {
            constructor(ue) {
              super(m, "duplexOption", ["simplex", "duplexFlipLongEdge", "duplexFlipShortEdge"]);
            }
          }
          class se extends g.OptionObject {
            constructor(ue) {
              super(m, "dynamicRender", ["forbidden", "required"]);
            }
          }
          class L extends g.Option01 {
            constructor(ue) {
              super(m, "embed");
            }
          }
          class W extends g.Option01 {
            constructor(ue) {
              super(m, "encrypt");
            }
          }
          class M extends g.XFAObject {
            constructor(ue) {
              super(m, "encryption", !0), this.encrypt = null, this.encryptionLevel = null, this.permissions = null;
            }
          }
          class X extends g.OptionObject {
            constructor(ue) {
              super(m, "encryptionLevel", ["40bit", "128bit"]);
            }
          }
          class U extends g.StringObject {
            constructor(ue) {
              super(m, "enforce");
            }
          }
          class Q extends g.XFAObject {
            constructor(ue) {
              super(m, "equate"), this.force = (0, t.getInteger)({
                data: ue.force,
                defaultValue: 1,
                validate: (je) => je === 0
              }), this.from = ue.from || "", this.to = ue.to || "";
            }
          }
          class re extends g.XFAObject {
            constructor(ue) {
              super(m, "equateRange"), this.from = ue.from || "", this.to = ue.to || "", this._unicodeRange = ue.unicodeRange || "";
            }
            get unicodeRange() {
              const ue = [], je = /U\+([0-9a-fA-F]+)/, He = this._unicodeRange;
              for (let Ge of He.split(",").map((dt) => dt.trim()).filter((dt) => !!dt))
                Ge = Ge.split("-", 2).map((dt) => {
                  const Ct = dt.match(je);
                  return Ct ? parseInt(Ct[1], 16) : 0;
                }), Ge.length === 1 && Ge.push(Ge[0]), ue.push(Ge);
              return (0, i.shadow)(this, "unicodeRange", ue);
            }
          }
          class le extends g.ContentObject {
            constructor(ue) {
              super(m, "exclude");
            }
            [h.$finalize]() {
              this[h.$content] = this[h.$content].trim().split(/\s+/).filter((ue) => ue && ["calculate", "close", "enter", "exit", "initialize", "ready", "validate"].includes(ue));
            }
          }
          class ce extends g.StringObject {
            constructor(ue) {
              super(m, "excludeNS");
            }
          }
          class ee extends g.OptionObject {
            constructor(ue) {
              super(m, "flipLabel", ["usePrinterSetting", "on", "off"]);
            }
          }
          class he extends g.XFAObject {
            constructor(ue) {
              super(m, "fontInfo", !0), this.embed = null, this.map = null, this.subsetBelow = null, this.alwaysEmbed = new g.XFAObjectArray(), this.defaultTypeface = new g.XFAObjectArray(), this.neverEmbed = new g.XFAObjectArray();
            }
          }
          class pe extends g.Option01 {
            constructor(ue) {
              super(m, "formFieldFilling");
            }
          }
          class de extends g.StringObject {
            constructor(ue) {
              super(m, "groupParent");
            }
          }
          class ge extends g.OptionObject {
            constructor(ue) {
              super(m, "ifEmpty", ["dataValue", "dataGroup", "ignore", "remove"]);
            }
          }
          class me extends g.StringObject {
            constructor(ue) {
              super(m, "includeXDPContent");
            }
          }
          class xe extends g.OptionObject {
            constructor(ue) {
              super(m, "incrementalLoad", ["none", "forwardOnly"]);
            }
          }
          class ye extends g.Option01 {
            constructor(ue) {
              super(m, "incrementalMerge");
            }
          }
          class ve extends g.Option01 {
            constructor(ue) {
              super(m, "interactive");
            }
          }
          class Ce extends g.OptionObject {
            constructor(ue) {
              super(m, "jog", ["usePrinterSetting", "none", "pageSet"]);
            }
          }
          class Ie extends g.XFAObject {
            constructor(ue) {
              super(m, "labelPrinter", !0), this.name = (0, t.getStringOption)(ue.name, ["zpl", "dpl", "ipl", "tcpl"]), this.batchOutput = null, this.flipLabel = null, this.fontInfo = null, this.xdc = null;
            }
          }
          class Ae extends g.OptionObject {
            constructor(ue) {
              super(m, "layout", ["paginate", "panel"]);
            }
          }
          class Se extends g.IntegerObject {
            constructor(ue) {
              super(m, "level", 0, (je) => je > 0);
            }
          }
          class De extends g.Option01 {
            constructor(ue) {
              super(m, "linearized");
            }
          }
          class Be extends g.StringObject {
            constructor(ue) {
              super(m, "locale");
            }
          }
          class ke extends g.StringObject {
            constructor(ue) {
              super(m, "localeSet");
            }
          }
          class be extends g.XFAObject {
            constructor(ue) {
              super(m, "log", !0), this.mode = null, this.threshold = null, this.to = null, this.uri = null;
            }
          }
          class we extends g.XFAObject {
            constructor(ue) {
              super(m, "map", !0), this.equate = new g.XFAObjectArray(), this.equateRange = new g.XFAObjectArray();
            }
          }
          class Le extends g.XFAObject {
            constructor(ue) {
              super(m, "mediumInfo", !0), this.map = null;
            }
          }
          class Re extends g.XFAObject {
            constructor(ue) {
              super(m, "message", !0), this.msgId = null, this.severity = null;
            }
          }
          class ct extends g.XFAObject {
            constructor(ue) {
              super(m, "messaging", !0), this.message = new g.XFAObjectArray();
            }
          }
          class ft extends g.OptionObject {
            constructor(ue) {
              super(m, "mode", ["append", "overwrite"]);
            }
          }
          class kt extends g.Option01 {
            constructor(ue) {
              super(m, "modifyAnnots");
            }
          }
          class We extends g.IntegerObject {
            constructor(ue) {
              super(m, "msgId", 1, (je) => je >= 1);
            }
          }
          class jt extends g.StringObject {
            constructor(ue) {
              super(m, "nameAttr");
            }
          }
          class yt extends g.ContentObject {
            constructor(ue) {
              super(m, "neverEmbed");
            }
          }
          class Ye extends g.IntegerObject {
            constructor(ue) {
              super(m, "numberOfCopies", null, (je) => je >= 2 && je <= 5);
            }
          }
          class mt extends g.XFAObject {
            constructor(ue) {
              super(m, "openAction", !0), this.destination = null;
            }
          }
          class Pt extends g.XFAObject {
            constructor(ue) {
              super(m, "output", !0), this.to = null, this.type = null, this.uri = null;
            }
          }
          class et extends g.StringObject {
            constructor(ue) {
              super(m, "outputBin");
            }
          }
          class tn extends g.XFAObject {
            constructor(ue) {
              super(m, "outputXSL", !0), this.uri = null;
            }
          }
          class Xt extends g.OptionObject {
            constructor(ue) {
              super(m, "overprint", ["none", "both", "draw", "field"]);
            }
          }
          class _e extends g.StringObject {
            constructor(ue) {
              super(m, "packets");
            }
            [h.$finalize]() {
              this[h.$content] !== "*" && (this[h.$content] = this[h.$content].trim().split(/\s+/).filter((ue) => ["config", "datasets", "template", "xfdf", "xslt"].includes(ue)));
            }
          }
          class Qe extends g.XFAObject {
            constructor(ue) {
              super(m, "pageOffset"), this.x = (0, t.getInteger)({
                data: ue.x,
                defaultValue: "useXDCSetting",
                validate: (je) => !0
              }), this.y = (0, t.getInteger)({
                data: ue.y,
                defaultValue: "useXDCSetting",
                validate: (je) => !0
              });
            }
          }
          class qe extends g.StringObject {
            constructor(ue) {
              super(m, "pageRange");
            }
            [h.$finalize]() {
              const ue = this[h.$content].trim().split(/\s+/).map((He) => parseInt(He, 10)), je = [];
              for (let He = 0, Ge = ue.length; He < Ge; He += 2)
                je.push(ue.slice(He, He + 2));
              this[h.$content] = je;
            }
          }
          class Je extends g.OptionObject {
            constructor(ue) {
              super(m, "pagination", ["simplex", "duplexShortEdge", "duplexLongEdge"]);
            }
          }
          class nt extends g.OptionObject {
            constructor(ue) {
              super(m, "paginationOverride", ["none", "forceDuplex", "forceDuplexLongEdge", "forceDuplexShortEdge", "forceSimplex"]);
            }
          }
          class At extends g.IntegerObject {
            constructor(ue) {
              super(m, "part", 1, (je) => !1);
            }
          }
          class Rt extends g.XFAObject {
            constructor(ue) {
              super(m, "pcl", !0), this.name = ue.name || "", this.batchOutput = null, this.fontInfo = null, this.jog = null, this.mediumInfo = null, this.outputBin = null, this.pageOffset = null, this.staple = null, this.xdc = null;
            }
          }
          class St extends g.XFAObject {
            constructor(ue) {
              super(m, "pdf", !0), this.name = ue.name || "", this.adobeExtensionLevel = null, this.batchOutput = null, this.compression = null, this.creator = null, this.encryption = null, this.fontInfo = null, this.interactive = null, this.linearized = null, this.openAction = null, this.pdfa = null, this.producer = null, this.renderPolicy = null, this.scriptModel = null, this.silentPrint = null, this.submitFormat = null, this.tagged = null, this.version = null, this.viewerPreferences = null, this.xdc = null;
            }
          }
          class _t extends g.XFAObject {
            constructor(ue) {
              super(m, "pdfa", !0), this.amd = null, this.conformance = null, this.includeXDPContent = null, this.part = null;
            }
          }
          class Zt extends g.XFAObject {
            constructor(ue) {
              super(m, "permissions", !0), this.accessibleContent = null, this.change = null, this.contentCopy = null, this.documentAssembly = null, this.formFieldFilling = null, this.modifyAnnots = null, this.plaintextMetadata = null, this.print = null, this.printHighQuality = null;
            }
          }
          class an extends g.Option01 {
            constructor(ue) {
              super(m, "pickTrayByPDFSize");
            }
          }
          class ze extends g.StringObject {
            constructor(ue) {
              super(m, "picture");
            }
          }
          class $e extends g.Option01 {
            constructor(ue) {
              super(m, "plaintextMetadata");
            }
          }
          class Ve extends g.OptionObject {
            constructor(ue) {
              super(m, "presence", ["preserve", "dissolve", "dissolveStructure", "ignore", "remove"]);
            }
          }
          class Ke extends g.XFAObject {
            constructor(ue) {
              super(m, "present", !0), this.behaviorOverride = null, this.cache = null, this.common = null, this.copies = null, this.destination = null, this.incrementalMerge = null, this.layout = null, this.output = null, this.overprint = null, this.pagination = null, this.paginationOverride = null, this.script = null, this.validate = null, this.xdp = null, this.driver = new g.XFAObjectArray(), this.labelPrinter = new g.XFAObjectArray(), this.pcl = new g.XFAObjectArray(), this.pdf = new g.XFAObjectArray(), this.ps = new g.XFAObjectArray(), this.submitUrl = new g.XFAObjectArray(), this.webClient = new g.XFAObjectArray(), this.zpl = new g.XFAObjectArray();
            }
          }
          class at extends g.Option01 {
            constructor(ue) {
              super(m, "print");
            }
          }
          class It extends g.Option01 {
            constructor(ue) {
              super(m, "printHighQuality");
            }
          }
          class st extends g.OptionObject {
            constructor(ue) {
              super(m, "printScaling", ["appdefault", "noScaling"]);
            }
          }
          class Ze extends g.StringObject {
            constructor(ue) {
              super(m, "printerName");
            }
          }
          class gt extends g.StringObject {
            constructor(ue) {
              super(m, "producer");
            }
          }
          class Lt extends g.XFAObject {
            constructor(ue) {
              super(m, "ps", !0), this.name = ue.name || "", this.batchOutput = null, this.fontInfo = null, this.jog = null, this.mediumInfo = null, this.outputBin = null, this.staple = null, this.xdc = null;
            }
          }
          class Yt extends g.ContentObject {
            constructor(ue) {
              super(m, "range");
            }
            [h.$finalize]() {
              this[h.$content] = this[h.$content].trim().split(/\s*,\s*/, 2).map((ue) => ue.split("-").map((je) => parseInt(je.trim(), 10))).filter((ue) => ue.every((je) => !isNaN(je))).map((ue) => (ue.length === 1 && ue.push(ue[0]), ue));
            }
          }
          class Ft extends g.ContentObject {
            constructor(ue) {
              super(m, "record");
            }
            [h.$finalize]() {
              this[h.$content] = this[h.$content].trim();
              const ue = parseInt(this[h.$content], 10);
              !isNaN(ue) && ue >= 0 && (this[h.$content] = ue);
            }
          }
          class Dt extends g.ContentObject {
            constructor(ue) {
              super(m, "relevant");
            }
            [h.$finalize]() {
              this[h.$content] = this[h.$content].trim().split(/\s+/);
            }
          }
          class Wt extends g.ContentObject {
            constructor(ue) {
              super(m, "rename");
            }
            [h.$finalize]() {
              this[h.$content] = this[h.$content].trim(), (this[h.$content].toLowerCase().startsWith("xml") || new RegExp("[\\p{L}_][\\p{L}\\d._\\p{M}-]*", "u").test(this[h.$content])) && (0, i.warn)("XFA - Rename: invalid XFA name");
            }
          }
          class xt extends g.OptionObject {
            constructor(ue) {
              super(m, "renderPolicy", ["server", "client"]);
            }
          }
          class Bt extends g.OptionObject {
            constructor(ue) {
              super(m, "runScripts", ["both", "client", "none", "server"]);
            }
          }
          class ht extends g.XFAObject {
            constructor(ue) {
              super(m, "script", !0), this.currentPage = null, this.exclude = null, this.runScripts = null;
            }
          }
          class Ht extends g.OptionObject {
            constructor(ue) {
              super(m, "scriptModel", ["XFA", "none"]);
            }
          }
          class Qt extends g.OptionObject {
            constructor(ue) {
              super(m, "severity", ["ignore", "error", "information", "trace", "warning"]);
            }
          }
          class Vn extends g.XFAObject {
            constructor(ue) {
              super(m, "silentPrint", !0), this.addSilentPrint = null, this.printerName = null;
            }
          }
          class $t extends g.XFAObject {
            constructor(ue) {
              super(m, "staple"), this.mode = (0, t.getStringOption)(ue.mode, ["usePrinterSetting", "on", "off"]);
            }
          }
          class Ut extends g.StringObject {
            constructor(ue) {
              super(m, "startNode");
            }
          }
          class dn extends g.IntegerObject {
            constructor(ue) {
              super(m, "startPage", 0, (je) => !0);
            }
          }
          class kn extends g.OptionObject {
            constructor(ue) {
              super(m, "submitFormat", ["html", "delegate", "fdf", "xml", "pdf"]);
            }
          }
          class _i extends g.StringObject {
            constructor(ue) {
              super(m, "submitUrl");
            }
          }
          class As extends g.IntegerObject {
            constructor(ue) {
              super(m, "subsetBelow", 100, (je) => je >= 0 && je <= 100);
            }
          }
          class Q0 extends g.Option01 {
            constructor(ue) {
              super(m, "suppressBanner");
            }
          }
          class J0 extends g.Option01 {
            constructor(ue) {
              super(m, "tagged");
            }
          }
          class eu extends g.XFAObject {
            constructor(ue) {
              super(m, "template", !0), this.base = null, this.relevant = null, this.startPage = null, this.uri = null, this.xsl = null;
            }
          }
          class tu extends g.OptionObject {
            constructor(ue) {
              super(m, "threshold", ["trace", "error", "information", "warning"]);
            }
          }
          class nu extends g.OptionObject {
            constructor(ue) {
              super(m, "to", ["null", "memory", "stderr", "stdout", "system", "uri"]);
            }
          }
          class Fc extends g.XFAObject {
            constructor(ue) {
              super(m, "templateCache"), this.maxEntries = (0, t.getInteger)({
                data: ue.maxEntries,
                defaultValue: 5,
                validate: (je) => je >= 0
              });
            }
          }
          class so extends g.XFAObject {
            constructor(ue) {
              super(m, "trace", !0), this.area = new g.XFAObjectArray();
            }
          }
          class iu extends g.XFAObject {
            constructor(ue) {
              super(m, "transform", !0), this.groupParent = null, this.ifEmpty = null, this.nameAttr = null, this.picture = null, this.presence = null, this.rename = null, this.whitespace = null;
            }
          }
          class ru extends g.OptionObject {
            constructor(ue) {
              super(m, "type", ["none", "ascii85", "asciiHex", "ccittfax", "flate", "lzw", "runLength", "native", "xdp", "mergedXDP"]);
            }
          }
          class su extends g.StringObject {
            constructor(ue) {
              super(m, "uri");
            }
          }
          class ao extends g.OptionObject {
            constructor(ue) {
              super(m, "validate", ["preSubmit", "prePrint", "preExecute", "preSave"]);
            }
          }
          class Pc extends g.ContentObject {
            constructor(ue) {
              super(m, "validateApprovalSignatures");
            }
            [h.$finalize]() {
              this[h.$content] = this[h.$content].trim().split(/\s+/).filter((ue) => ["docReady", "postSign"].includes(ue));
            }
          }
          class jc extends g.OptionObject {
            constructor(ue) {
              super(m, "validationMessaging", ["allMessagesIndividually", "allMessagesTogether", "firstMessageOnly", "noMessages"]);
            }
          }
          class au extends g.OptionObject {
            constructor(ue) {
              super(m, "version", ["1.7", "1.6", "1.5", "1.4", "1.3", "1.2"]);
            }
          }
          class ou extends g.XFAObject {
            constructor(ue) {
              super(m, "VersionControl"), this.outputBelow = (0, t.getStringOption)(ue.outputBelow, ["warn", "error", "update"]), this.sourceAbove = (0, t.getStringOption)(ue.sourceAbove, ["warn", "error"]), this.sourceBelow = (0, t.getStringOption)(ue.sourceBelow, ["update", "maintain"]);
            }
          }
          class cu extends g.XFAObject {
            constructor(ue) {
              super(m, "viewerPreferences", !0), this.ADBE_JSConsole = null, this.ADBE_JSDebugger = null, this.addViewerPreferences = null, this.duplexOption = null, this.enforce = null, this.numberOfCopies = null, this.pageRange = null, this.pickTrayByPDFSize = null, this.printScaling = null;
            }
          }
          class lu extends g.XFAObject {
            constructor(ue) {
              super(m, "webClient", !0), this.name = ue.name ? ue.name.trim() : "", this.fontInfo = null, this.xdc = null;
            }
          }
          class uu extends g.OptionObject {
            constructor(ue) {
              super(m, "whitespace", ["preserve", "ltrim", "normalize", "rtrim", "trim"]);
            }
          }
          class oo extends g.ContentObject {
            constructor(ue) {
              super(m, "window");
            }
            [h.$finalize]() {
              const ue = this[h.$content].trim().split(/\s*,\s*/, 2).map((je) => parseInt(je, 10));
              if (ue.some((je) => isNaN(je))) {
                this[h.$content] = [0, 0];
                return;
              }
              ue.length === 1 && ue.push(ue[0]), this[h.$content] = ue;
            }
          }
          class du extends g.XFAObject {
            constructor(ue) {
              super(m, "xdc", !0), this.uri = new g.XFAObjectArray(), this.xsl = new g.XFAObjectArray();
            }
          }
          class ea extends g.XFAObject {
            constructor(ue) {
              super(m, "xdp", !0), this.packets = null;
            }
          }
          class hu extends g.XFAObject {
            constructor(ue) {
              super(m, "xsl", !0), this.debug = null, this.uri = null;
            }
          }
          class ta extends g.XFAObject {
            constructor(ue) {
              super(m, "zpl", !0), this.name = ue.name ? ue.name.trim() : "", this.batchOutput = null, this.flipLabel = null, this.fontInfo = null, this.xdc = null;
            }
          }
          class Ne {
            static [s.$buildXFAObject](ue, je) {
              if (Ne.hasOwnProperty(ue))
                return Ne[ue](je);
            }
            static acrobat(ue) {
              return new v(ue);
            }
            static acrobat7(ue) {
              return new E(ue);
            }
            static ADBE_JSConsole(ue) {
              return new S(ue);
            }
            static ADBE_JSDebugger(ue) {
              return new y(ue);
            }
            static addSilentPrint(ue) {
              return new x(ue);
            }
            static addViewerPreferences(ue) {
              return new b(ue);
            }
            static adjustData(ue) {
              return new u(ue);
            }
            static adobeExtensionLevel(ue) {
              return new I(ue);
            }
            static agent(ue) {
              return new O(ue);
            }
            static alwaysEmbed(ue) {
              return new D(ue);
            }
            static amd(ue) {
              return new $(ue);
            }
            static area(ue) {
              return new K(ue);
            }
            static attributes(ue) {
              return new H(ue);
            }
            static autoSave(ue) {
              return new B(ue);
            }
            static base(ue) {
              return new R(ue);
            }
            static batchOutput(ue) {
              return new _(ue);
            }
            static behaviorOverride(ue) {
              return new A(ue);
            }
            static cache(ue) {
              return new k(ue);
            }
            static change(ue) {
              return new z(ue);
            }
            static common(ue) {
              return new T(ue);
            }
            static compress(ue) {
              return new w(ue);
            }
            static compressLogicalStructure(ue) {
              return new F(ue);
            }
            static compressObjectStream(ue) {
              return new j(ue);
            }
            static compression(ue) {
              return new P(ue);
            }
            static config(ue) {
              return new V(ue);
            }
            static conformance(ue) {
              return new J(ue);
            }
            static contentCopy(ue) {
              return new ne(ue);
            }
            static copies(ue) {
              return new Z(ue);
            }
            static creator(ue) {
              return new te(ue);
            }
            static currentPage(ue) {
              return new G(ue);
            }
            static data(ue) {
              return new N(ue);
            }
            static debug(ue) {
              return new q(ue);
            }
            static defaultTypeface(ue) {
              return new ie(ue);
            }
            static destination(ue) {
              return new oe(ue);
            }
            static documentAssembly(ue) {
              return new fe(ue);
            }
            static driver(ue) {
              return new Y(ue);
            }
            static duplexOption(ue) {
              return new ae(ue);
            }
            static dynamicRender(ue) {
              return new se(ue);
            }
            static embed(ue) {
              return new L(ue);
            }
            static encrypt(ue) {
              return new W(ue);
            }
            static encryption(ue) {
              return new M(ue);
            }
            static encryptionLevel(ue) {
              return new X(ue);
            }
            static enforce(ue) {
              return new U(ue);
            }
            static equate(ue) {
              return new Q(ue);
            }
            static equateRange(ue) {
              return new re(ue);
            }
            static exclude(ue) {
              return new le(ue);
            }
            static excludeNS(ue) {
              return new ce(ue);
            }
            static flipLabel(ue) {
              return new ee(ue);
            }
            static fontInfo(ue) {
              return new he(ue);
            }
            static formFieldFilling(ue) {
              return new pe(ue);
            }
            static groupParent(ue) {
              return new de(ue);
            }
            static ifEmpty(ue) {
              return new ge(ue);
            }
            static includeXDPContent(ue) {
              return new me(ue);
            }
            static incrementalLoad(ue) {
              return new xe(ue);
            }
            static incrementalMerge(ue) {
              return new ye(ue);
            }
            static interactive(ue) {
              return new ve(ue);
            }
            static jog(ue) {
              return new Ce(ue);
            }
            static labelPrinter(ue) {
              return new Ie(ue);
            }
            static layout(ue) {
              return new Ae(ue);
            }
            static level(ue) {
              return new Se(ue);
            }
            static linearized(ue) {
              return new De(ue);
            }
            static locale(ue) {
              return new Be(ue);
            }
            static localeSet(ue) {
              return new ke(ue);
            }
            static log(ue) {
              return new be(ue);
            }
            static map(ue) {
              return new we(ue);
            }
            static mediumInfo(ue) {
              return new Le(ue);
            }
            static message(ue) {
              return new Re(ue);
            }
            static messaging(ue) {
              return new ct(ue);
            }
            static mode(ue) {
              return new ft(ue);
            }
            static modifyAnnots(ue) {
              return new kt(ue);
            }
            static msgId(ue) {
              return new We(ue);
            }
            static nameAttr(ue) {
              return new jt(ue);
            }
            static neverEmbed(ue) {
              return new yt(ue);
            }
            static numberOfCopies(ue) {
              return new Ye(ue);
            }
            static openAction(ue) {
              return new mt(ue);
            }
            static output(ue) {
              return new Pt(ue);
            }
            static outputBin(ue) {
              return new et(ue);
            }
            static outputXSL(ue) {
              return new tn(ue);
            }
            static overprint(ue) {
              return new Xt(ue);
            }
            static packets(ue) {
              return new _e(ue);
            }
            static pageOffset(ue) {
              return new Qe(ue);
            }
            static pageRange(ue) {
              return new qe(ue);
            }
            static pagination(ue) {
              return new Je(ue);
            }
            static paginationOverride(ue) {
              return new nt(ue);
            }
            static part(ue) {
              return new At(ue);
            }
            static pcl(ue) {
              return new Rt(ue);
            }
            static pdf(ue) {
              return new St(ue);
            }
            static pdfa(ue) {
              return new _t(ue);
            }
            static permissions(ue) {
              return new Zt(ue);
            }
            static pickTrayByPDFSize(ue) {
              return new an(ue);
            }
            static picture(ue) {
              return new ze(ue);
            }
            static plaintextMetadata(ue) {
              return new $e(ue);
            }
            static presence(ue) {
              return new Ve(ue);
            }
            static present(ue) {
              return new Ke(ue);
            }
            static print(ue) {
              return new at(ue);
            }
            static printHighQuality(ue) {
              return new It(ue);
            }
            static printScaling(ue) {
              return new st(ue);
            }
            static printerName(ue) {
              return new Ze(ue);
            }
            static producer(ue) {
              return new gt(ue);
            }
            static ps(ue) {
              return new Lt(ue);
            }
            static range(ue) {
              return new Yt(ue);
            }
            static record(ue) {
              return new Ft(ue);
            }
            static relevant(ue) {
              return new Dt(ue);
            }
            static rename(ue) {
              return new Wt(ue);
            }
            static renderPolicy(ue) {
              return new xt(ue);
            }
            static runScripts(ue) {
              return new Bt(ue);
            }
            static script(ue) {
              return new ht(ue);
            }
            static scriptModel(ue) {
              return new Ht(ue);
            }
            static severity(ue) {
              return new Qt(ue);
            }
            static silentPrint(ue) {
              return new Vn(ue);
            }
            static staple(ue) {
              return new $t(ue);
            }
            static startNode(ue) {
              return new Ut(ue);
            }
            static startPage(ue) {
              return new dn(ue);
            }
            static submitFormat(ue) {
              return new kn(ue);
            }
            static submitUrl(ue) {
              return new _i(ue);
            }
            static subsetBelow(ue) {
              return new As(ue);
            }
            static suppressBanner(ue) {
              return new Q0(ue);
            }
            static tagged(ue) {
              return new J0(ue);
            }
            static template(ue) {
              return new eu(ue);
            }
            static templateCache(ue) {
              return new Fc(ue);
            }
            static threshold(ue) {
              return new tu(ue);
            }
            static to(ue) {
              return new nu(ue);
            }
            static trace(ue) {
              return new so(ue);
            }
            static transform(ue) {
              return new iu(ue);
            }
            static type(ue) {
              return new ru(ue);
            }
            static uri(ue) {
              return new su(ue);
            }
            static validate(ue) {
              return new ao(ue);
            }
            static validateApprovalSignatures(ue) {
              return new Pc(ue);
            }
            static validationMessaging(ue) {
              return new jc(ue);
            }
            static version(ue) {
              return new au(ue);
            }
            static versionControl(ue) {
              return new ou(ue);
            }
            static viewerPreferences(ue) {
              return new cu(ue);
            }
            static webClient(ue) {
              return new lu(ue);
            }
            static whitespace(ue) {
              return new uu(ue);
            }
            static window(ue) {
              return new oo(ue);
            }
            static xdc(ue) {
              return new du(ue);
            }
            static xdp(ue) {
              return new ea(ue);
            }
            static xsl(ue) {
              return new hu(ue);
            }
            static zpl(ue) {
              return new ta(ue);
            }
          }
          c.ConfigNamespace = Ne;
        },
        /* 94 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.ConnectionSetNamespace = void 0;
          var s = f(81), h = f(87);
          const g = s.NamespaceIds.connectionSet.id;
          class t extends h.XFAObject {
            constructor(K) {
              super(g, "connectionSet", !0), this.wsdlConnection = new h.XFAObjectArray(), this.xmlConnection = new h.XFAObjectArray(), this.xsdConnection = new h.XFAObjectArray();
            }
          }
          class i extends h.XFAObject {
            constructor(K) {
              super(g, "effectiveInputPolicy"), this.id = K.id || "", this.name = K.name || "", this.use = K.use || "", this.usehref = K.usehref || "";
            }
          }
          class m extends h.XFAObject {
            constructor(K) {
              super(g, "effectiveOutputPolicy"), this.id = K.id || "", this.name = K.name || "", this.use = K.use || "", this.usehref = K.usehref || "";
            }
          }
          class v extends h.StringObject {
            constructor(K) {
              super(g, "operation"), this.id = K.id || "", this.input = K.input || "", this.name = K.name || "", this.output = K.output || "", this.use = K.use || "", this.usehref = K.usehref || "";
            }
          }
          class E extends h.StringObject {
            constructor(K) {
              super(g, "rootElement"), this.id = K.id || "", this.name = K.name || "", this.use = K.use || "", this.usehref = K.usehref || "";
            }
          }
          class S extends h.StringObject {
            constructor(K) {
              super(g, "soapAction"), this.id = K.id || "", this.name = K.name || "", this.use = K.use || "", this.usehref = K.usehref || "";
            }
          }
          class y extends h.StringObject {
            constructor(K) {
              super(g, "soapAddress"), this.id = K.id || "", this.name = K.name || "", this.use = K.use || "", this.usehref = K.usehref || "";
            }
          }
          class x extends h.StringObject {
            constructor(K) {
              super(g, "uri"), this.id = K.id || "", this.name = K.name || "", this.use = K.use || "", this.usehref = K.usehref || "";
            }
          }
          class b extends h.StringObject {
            constructor(K) {
              super(g, "wsdlAddress"), this.id = K.id || "", this.name = K.name || "", this.use = K.use || "", this.usehref = K.usehref || "";
            }
          }
          class u extends h.XFAObject {
            constructor(K) {
              super(g, "wsdlConnection", !0), this.dataDescription = K.dataDescription || "", this.name = K.name || "", this.effectiveInputPolicy = null, this.effectiveOutputPolicy = null, this.operation = null, this.soapAction = null, this.soapAddress = null, this.wsdlAddress = null;
            }
          }
          class I extends h.XFAObject {
            constructor(K) {
              super(g, "xmlConnection", !0), this.dataDescription = K.dataDescription || "", this.name = K.name || "", this.uri = null;
            }
          }
          class O extends h.XFAObject {
            constructor(K) {
              super(g, "xsdConnection", !0), this.dataDescription = K.dataDescription || "", this.name = K.name || "", this.rootElement = null, this.uri = null;
            }
          }
          class D {
            static [s.$buildXFAObject](K, H) {
              if (D.hasOwnProperty(K))
                return D[K](H);
            }
            static connectionSet(K) {
              return new t(K);
            }
            static effectiveInputPolicy(K) {
              return new i(K);
            }
            static effectiveOutputPolicy(K) {
              return new m(K);
            }
            static operation(K) {
              return new v(K);
            }
            static rootElement(K) {
              return new E(K);
            }
            static soapAction(K) {
              return new S(K);
            }
            static soapAddress(K) {
              return new y(K);
            }
            static uri(K) {
              return new x(K);
            }
            static wsdlAddress(K) {
              return new b(K);
            }
            static wsdlConnection(K) {
              return new u(K);
            }
            static xmlConnection(K) {
              return new I(K);
            }
            static xsdConnection(K) {
              return new O(K);
            }
          }
          c.ConnectionSetNamespace = D;
        },
        /* 95 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.DatasetsNamespace = void 0;
          var s = f(78), h = f(81), g = f(87);
          const t = h.NamespaceIds.datasets.id;
          class i extends g.XmlObject {
            constructor(S) {
              super(t, "data", S);
            }
            [s.$isNsAgnostic]() {
              return !0;
            }
          }
          class m extends g.XFAObject {
            constructor(S) {
              super(t, "datasets", !0), this.data = null, this.Signature = null;
            }
            [s.$onChild](S) {
              const y = S[s.$nodeName];
              (y === "data" && S[s.$namespaceId] === t || y === "Signature" && S[s.$namespaceId] === h.NamespaceIds.signature.id) && (this[y] = S), this[s.$appendChild](S);
            }
          }
          class v {
            static [h.$buildXFAObject](S, y) {
              if (v.hasOwnProperty(S))
                return v[S](y);
            }
            static datasets(S) {
              return new m(S);
            }
            static data(S) {
              return new i(S);
            }
          }
          c.DatasetsNamespace = v;
        },
        /* 96 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.LocaleSetNamespace = void 0;
          var s = f(81), h = f(87), g = f(84);
          const t = s.NamespaceIds.localeSet.id;
          class i extends h.XFAObject {
            constructor(V) {
              super(t, "calendarSymbols", !0), this.name = "gregorian", this.dayNames = new h.XFAObjectArray(2), this.eraNames = null, this.meridiemNames = null, this.monthNames = new h.XFAObjectArray(2);
            }
          }
          class m extends h.StringObject {
            constructor(V) {
              super(t, "currencySymbol"), this.name = (0, g.getStringOption)(V.name, ["symbol", "isoname", "decimal"]);
            }
          }
          class v extends h.XFAObject {
            constructor(V) {
              super(t, "currencySymbols", !0), this.currencySymbol = new h.XFAObjectArray(3);
            }
          }
          class E extends h.StringObject {
            constructor(V) {
              super(t, "datePattern"), this.name = (0, g.getStringOption)(V.name, ["full", "long", "med", "short"]);
            }
          }
          class S extends h.XFAObject {
            constructor(V) {
              super(t, "datePatterns", !0), this.datePattern = new h.XFAObjectArray(4);
            }
          }
          class y extends h.ContentObject {
            constructor(V) {
              super(t, "dateTimeSymbols");
            }
          }
          class x extends h.StringObject {
            constructor(V) {
              super(t, "day");
            }
          }
          class b extends h.XFAObject {
            constructor(V) {
              super(t, "dayNames", !0), this.abbr = (0, g.getInteger)({
                data: V.abbr,
                defaultValue: 0,
                validate: (J) => J === 1
              }), this.day = new h.XFAObjectArray(7);
            }
          }
          class u extends h.StringObject {
            constructor(V) {
              super(t, "era");
            }
          }
          class I extends h.XFAObject {
            constructor(V) {
              super(t, "eraNames", !0), this.era = new h.XFAObjectArray(2);
            }
          }
          class O extends h.XFAObject {
            constructor(V) {
              super(t, "locale", !0), this.desc = V.desc || "", this.name = "isoname", this.calendarSymbols = null, this.currencySymbols = null, this.datePatterns = null, this.dateTimeSymbols = null, this.numberPatterns = null, this.numberSymbols = null, this.timePatterns = null, this.typeFaces = null;
            }
          }
          class D extends h.XFAObject {
            constructor(V) {
              super(t, "localeSet", !0), this.locale = new h.XFAObjectArray();
            }
          }
          class $ extends h.StringObject {
            constructor(V) {
              super(t, "meridiem");
            }
          }
          class K extends h.XFAObject {
            constructor(V) {
              super(t, "meridiemNames", !0), this.meridiem = new h.XFAObjectArray(2);
            }
          }
          class H extends h.StringObject {
            constructor(V) {
              super(t, "month");
            }
          }
          class B extends h.XFAObject {
            constructor(V) {
              super(t, "monthNames", !0), this.abbr = (0, g.getInteger)({
                data: V.abbr,
                defaultValue: 0,
                validate: (J) => J === 1
              }), this.month = new h.XFAObjectArray(12);
            }
          }
          class R extends h.StringObject {
            constructor(V) {
              super(t, "numberPattern"), this.name = (0, g.getStringOption)(V.name, ["full", "long", "med", "short"]);
            }
          }
          class _ extends h.XFAObject {
            constructor(V) {
              super(t, "numberPatterns", !0), this.numberPattern = new h.XFAObjectArray(4);
            }
          }
          class A extends h.StringObject {
            constructor(V) {
              super(t, "numberSymbol"), this.name = (0, g.getStringOption)(V.name, ["decimal", "grouping", "percent", "minus", "zero"]);
            }
          }
          class k extends h.XFAObject {
            constructor(V) {
              super(t, "numberSymbols", !0), this.numberSymbol = new h.XFAObjectArray(5);
            }
          }
          class z extends h.StringObject {
            constructor(V) {
              super(t, "timePattern"), this.name = (0, g.getStringOption)(V.name, ["full", "long", "med", "short"]);
            }
          }
          class T extends h.XFAObject {
            constructor(V) {
              super(t, "timePatterns", !0), this.timePattern = new h.XFAObjectArray(4);
            }
          }
          class w extends h.XFAObject {
            constructor(V) {
              super(t, "typeFace", !0), this.name = V.name | "";
            }
          }
          class F extends h.XFAObject {
            constructor(V) {
              super(t, "typeFaces", !0), this.typeFace = new h.XFAObjectArray();
            }
          }
          class j {
            static [s.$buildXFAObject](V, J) {
              if (j.hasOwnProperty(V))
                return j[V](J);
            }
            static calendarSymbols(V) {
              return new i(V);
            }
            static currencySymbol(V) {
              return new m(V);
            }
            static currencySymbols(V) {
              return new v(V);
            }
            static datePattern(V) {
              return new E(V);
            }
            static datePatterns(V) {
              return new S(V);
            }
            static dateTimeSymbols(V) {
              return new y(V);
            }
            static day(V) {
              return new x(V);
            }
            static dayNames(V) {
              return new b(V);
            }
            static era(V) {
              return new u(V);
            }
            static eraNames(V) {
              return new I(V);
            }
            static locale(V) {
              return new O(V);
            }
            static localeSet(V) {
              return new D(V);
            }
            static meridiem(V) {
              return new $(V);
            }
            static meridiemNames(V) {
              return new K(V);
            }
            static month(V) {
              return new H(V);
            }
            static monthNames(V) {
              return new B(V);
            }
            static numberPattern(V) {
              return new R(V);
            }
            static numberPatterns(V) {
              return new _(V);
            }
            static numberSymbol(V) {
              return new A(V);
            }
            static numberSymbols(V) {
              return new k(V);
            }
            static timePattern(V) {
              return new z(V);
            }
            static timePatterns(V) {
              return new T(V);
            }
            static typeFace(V) {
              return new w(V);
            }
            static typeFaces(V) {
              return new F(V);
            }
          }
          c.LocaleSetNamespace = j;
        },
        /* 97 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.SignatureNamespace = void 0;
          var s = f(81), h = f(87);
          const g = s.NamespaceIds.signature.id;
          class t extends h.XFAObject {
            constructor(v) {
              super(g, "signature", !0);
            }
          }
          class i {
            static [s.$buildXFAObject](v, E) {
              if (i.hasOwnProperty(v))
                return i[v](E);
            }
            static signature(v) {
              return new t(v);
            }
          }
          c.SignatureNamespace = i;
        },
        /* 98 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.StylesheetNamespace = void 0;
          var s = f(81), h = f(87);
          const g = s.NamespaceIds.stylesheet.id;
          class t extends h.XFAObject {
            constructor(v) {
              super(g, "stylesheet", !0);
            }
          }
          class i {
            static [s.$buildXFAObject](v, E) {
              if (i.hasOwnProperty(v))
                return i[v](E);
            }
            static stylesheet(v) {
              return new t(v);
            }
          }
          c.StylesheetNamespace = i;
        },
        /* 99 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.XdpNamespace = void 0;
          var s = f(81), h = f(78), g = f(87);
          const t = s.NamespaceIds.xdp.id;
          class i extends g.XFAObject {
            constructor(E) {
              super(t, "xdp", !0), this.uuid = E.uuid || "", this.timeStamp = E.timeStamp || "", this.config = null, this.connectionSet = null, this.datasets = null, this.localeSet = null, this.stylesheet = new g.XFAObjectArray(), this.template = null;
            }
            [h.$onChildCheck](E) {
              const S = s.NamespaceIds[E[h.$nodeName]];
              return S && E[h.$namespaceId] === S.id;
            }
          }
          class m {
            static [s.$buildXFAObject](E, S) {
              if (m.hasOwnProperty(E))
                return m[E](S);
            }
            static xdp(E) {
              return new i(E);
            }
          }
          c.XdpNamespace = m;
        },
        /* 100 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.XhtmlNamespace = void 0;
          var s = f(78), h = f(81), g = f(83), t = f(84), i = f(87);
          const m = h.NamespaceIds.xhtml.id, v = Symbol(), E = /* @__PURE__ */ new Set(["color", "font", "font-family", "font-size", "font-stretch", "font-style", "font-weight", "margin", "margin-bottom", "margin-left", "margin-right", "margin-top", "letter-spacing", "line-height", "orphans", "page-break-after", "page-break-before", "page-break-inside", "tab-interval", "tab-stop", "text-align", "text-decoration", "text-indent", "vertical-align", "widows", "kerning-mode", "xfa-font-horizontal-scale", "xfa-font-vertical-scale", "xfa-spacerun", "xfa-tab-stops"]), S = /* @__PURE__ */ new Map([["page-break-after", "breakAfter"], ["page-break-before", "breakBefore"], ["page-break-inside", "breakInside"], ["kerning-mode", (V) => V === "none" ? "none" : "normal"], ["xfa-font-horizontal-scale", (V) => `scaleX(${Math.max(0, Math.min(parseInt(V) / 100)).toFixed(2)})`], ["xfa-font-vertical-scale", (V) => `scaleY(${Math.max(0, Math.min(parseInt(V) / 100)).toFixed(2)})`], ["xfa-spacerun", ""], ["xfa-tab-stops", ""], ["font-size", (V, J) => (V = J.fontSize = (0, t.getMeasurement)(V), (0, g.measureToString)(0.99 * V))], ["letter-spacing", (V) => (0, g.measureToString)((0, t.getMeasurement)(V))], ["line-height", (V) => (0, g.measureToString)((0, t.getMeasurement)(V))], ["margin", (V) => (0, g.measureToString)((0, t.getMeasurement)(V))], ["margin-bottom", (V) => (0, g.measureToString)((0, t.getMeasurement)(V))], ["margin-left", (V) => (0, g.measureToString)((0, t.getMeasurement)(V))], ["margin-right", (V) => (0, g.measureToString)((0, t.getMeasurement)(V))], ["margin-top", (V) => (0, g.measureToString)((0, t.getMeasurement)(V))], ["text-indent", (V) => (0, g.measureToString)((0, t.getMeasurement)(V))], ["font-family", (V) => V], ["vertical-align", (V) => (0, g.measureToString)((0, t.getMeasurement)(V))]]), y = /\s+/g, x = /[\r\n]+/g, b = /\r\n?/g;
          function u(V, J, ne) {
            const Z = /* @__PURE__ */ Object.create(null);
            if (!V)
              return Z;
            const te = /* @__PURE__ */ Object.create(null);
            for (const [G, N] of V.split(";").map((q) => q.split(":", 2))) {
              const q = S.get(G);
              if (q === "")
                continue;
              let ie = N;
              q && (ie = typeof q == "string" ? q : q(N, te)), G.endsWith("scale") ? Z.transform = Z.transform ? `${Z[G]} ${ie}` : ie : Z[G.replaceAll(/-([a-zA-Z])/g, (oe, fe) => fe.toUpperCase())] = ie;
            }
            if (Z.fontFamily && (0, g.setFontFamily)({
              typeface: Z.fontFamily,
              weight: Z.fontWeight || "normal",
              posture: Z.fontStyle || "normal",
              size: te.fontSize || 0
            }, J, J[s.$globalData].fontFinder, Z), ne && Z.verticalAlign && Z.verticalAlign !== "0px" && Z.fontSize) {
              const q = (0, t.getMeasurement)(Z.fontSize);
              Z.fontSize = (0, g.measureToString)(q * 0.583), Z.verticalAlign = (0, g.measureToString)(Math.sign((0, t.getMeasurement)(Z.verticalAlign)) * q * 0.333);
            }
            return ne && Z.fontSize && (Z.fontSize = `calc(${Z.fontSize} * var(--scale-factor))`), (0, g.fixTextIndent)(Z), Z;
          }
          function I(V) {
            return V.style ? V.style.trim().split(/\s*;\s*/).filter((J) => !!J).map((J) => J.split(/\s*:\s*/, 2)).filter(([J, ne]) => (J === "font-family" && V[s.$globalData].usedTypefaces.add(ne), E.has(J))).map((J) => J.join(":")).join(";") : "";
          }
          const O = /* @__PURE__ */ new Set(["body", "html"]);
          class D extends i.XmlObject {
            constructor(J, ne) {
              super(m, ne), this[v] = !1, this.style = J.style || "";
            }
            [s.$clean](J) {
              super[s.$clean](J), this.style = I(this);
            }
            [s.$acceptWhitespace]() {
              return !O.has(this[s.$nodeName]);
            }
            [s.$onText](J, ne = !1) {
              ne ? this[v] = !0 : (J = J.replaceAll(x, ""), this.style.includes("xfa-spacerun:yes") || (J = J.replaceAll(y, " "))), J && (this[s.$content] += J);
            }
            [s.$pushGlyphs](J, ne = !0) {
              const Z = /* @__PURE__ */ Object.create(null), te = {
                top: NaN,
                bottom: NaN,
                left: NaN,
                right: NaN
              };
              let G = null;
              for (const [N, q] of this.style.split(";").map((ie) => ie.split(":", 2)))
                switch (N) {
                  case "font-family":
                    Z.typeface = (0, t.stripQuotes)(q);
                    break;
                  case "font-size":
                    Z.size = (0, t.getMeasurement)(q);
                    break;
                  case "font-weight":
                    Z.weight = q;
                    break;
                  case "font-style":
                    Z.posture = q;
                    break;
                  case "letter-spacing":
                    Z.letterSpacing = (0, t.getMeasurement)(q);
                    break;
                  case "margin":
                    const ie = q.split(/ \t/).map((oe) => (0, t.getMeasurement)(oe));
                    switch (ie.length) {
                      case 1:
                        te.top = te.bottom = te.left = te.right = ie[0];
                        break;
                      case 2:
                        te.top = te.bottom = ie[0], te.left = te.right = ie[1];
                        break;
                      case 3:
                        te.top = ie[0], te.bottom = ie[2], te.left = te.right = ie[1];
                        break;
                      case 4:
                        te.top = ie[0], te.left = ie[1], te.bottom = ie[2], te.right = ie[3];
                        break;
                    }
                    break;
                  case "margin-top":
                    te.top = (0, t.getMeasurement)(q);
                    break;
                  case "margin-bottom":
                    te.bottom = (0, t.getMeasurement)(q);
                    break;
                  case "margin-left":
                    te.left = (0, t.getMeasurement)(q);
                    break;
                  case "margin-right":
                    te.right = (0, t.getMeasurement)(q);
                    break;
                  case "line-height":
                    G = (0, t.getMeasurement)(q);
                    break;
                }
              if (J.pushData(Z, te, G), this[s.$content])
                J.addString(this[s.$content]);
              else
                for (const N of this[s.$getChildren]()) {
                  if (N[s.$nodeName] === "#text") {
                    J.addString(N[s.$content]);
                    continue;
                  }
                  N[s.$pushGlyphs](J);
                }
              ne && J.popFont();
            }
            [s.$toHTML](J) {
              const ne = [];
              if (this[s.$extra] = {
                children: ne
              }, this[s.$childrenToHTML]({}), ne.length === 0 && !this[s.$content])
                return t.HTMLResult.EMPTY;
              let Z;
              return this[v] ? Z = this[s.$content] ? this[s.$content].replaceAll(b, `
`) : void 0 : Z = this[s.$content] || void 0, t.HTMLResult.success({
                name: this[s.$nodeName],
                attributes: {
                  href: this.href,
                  style: u(this.style, this, this[v])
                },
                children: ne,
                value: Z
              });
            }
          }
          class $ extends D {
            constructor(J) {
              super(J, "a"), this.href = (0, g.fixURL)(J.href) || "";
            }
          }
          class K extends D {
            constructor(J) {
              super(J, "b");
            }
            [s.$pushGlyphs](J) {
              J.pushFont({
                weight: "bold"
              }), super[s.$pushGlyphs](J), J.popFont();
            }
          }
          class H extends D {
            constructor(J) {
              super(J, "body");
            }
            [s.$toHTML](J) {
              const ne = super[s.$toHTML](J), {
                html: Z
              } = ne;
              return Z ? (Z.name = "div", Z.attributes.class = ["xfaRich"], ne) : t.HTMLResult.EMPTY;
            }
          }
          class B extends D {
            constructor(J) {
              super(J, "br");
            }
            [s.$text]() {
              return `
`;
            }
            [s.$pushGlyphs](J) {
              J.addString(`
`);
            }
            [s.$toHTML](J) {
              return t.HTMLResult.success({
                name: "br"
              });
            }
          }
          class R extends D {
            constructor(J) {
              super(J, "html");
            }
            [s.$toHTML](J) {
              var Z;
              const ne = [];
              if (this[s.$extra] = {
                children: ne
              }, this[s.$childrenToHTML]({}), ne.length === 0)
                return t.HTMLResult.success({
                  name: "div",
                  attributes: {
                    class: ["xfaRich"],
                    style: {}
                  },
                  value: this[s.$content] || ""
                });
              if (ne.length === 1) {
                const te = ne[0];
                if ((Z = te.attributes) != null && Z.class.includes("xfaRich"))
                  return t.HTMLResult.success(te);
              }
              return t.HTMLResult.success({
                name: "div",
                attributes: {
                  class: ["xfaRich"],
                  style: {}
                },
                children: ne
              });
            }
          }
          class _ extends D {
            constructor(J) {
              super(J, "i");
            }
            [s.$pushGlyphs](J) {
              J.pushFont({
                posture: "italic"
              }), super[s.$pushGlyphs](J), J.popFont();
            }
          }
          class A extends D {
            constructor(J) {
              super(J, "li");
            }
          }
          class k extends D {
            constructor(J) {
              super(J, "ol");
            }
          }
          class z extends D {
            constructor(J) {
              super(J, "p");
            }
            [s.$pushGlyphs](J) {
              super[s.$pushGlyphs](J, !1), J.addString(`
`), J.addPara(), J.popFont();
            }
            [s.$text]() {
              return this[s.$getParent]()[s.$getChildren]().at(-1) === this ? super[s.$text]() : super[s.$text]() + `
`;
            }
          }
          class T extends D {
            constructor(J) {
              super(J, "span");
            }
          }
          class w extends D {
            constructor(J) {
              super(J, "sub");
            }
          }
          class F extends D {
            constructor(J) {
              super(J, "sup");
            }
          }
          class j extends D {
            constructor(J) {
              super(J, "ul");
            }
          }
          class P {
            static [h.$buildXFAObject](J, ne) {
              if (P.hasOwnProperty(J))
                return P[J](ne);
            }
            static a(J) {
              return new $(J);
            }
            static b(J) {
              return new K(J);
            }
            static body(J) {
              return new H(J);
            }
            static br(J) {
              return new B(J);
            }
            static html(J) {
              return new R(J);
            }
            static i(J) {
              return new _(J);
            }
            static li(J) {
              return new A(J);
            }
            static ol(J) {
              return new k(J);
            }
            static p(J) {
              return new z(J);
            }
            static span(J) {
              return new T(J);
            }
            static sub(J) {
              return new w(J);
            }
            static sup(J) {
              return new F(J);
            }
            static ul(J) {
              return new j(J);
            }
          }
          c.XhtmlNamespace = P;
        },
        /* 101 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.UnknownNamespace = void 0;
          var s = f(81), h = f(87);
          class g {
            constructor(i) {
              this.namespaceId = i;
            }
            [s.$buildXFAObject](i, m) {
              return new h.XmlObject(this.namespaceId, i, m);
            }
          }
          c.UnknownNamespace = g;
        },
        /* 102 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.DatasetReader = void 0;
          var s = f(2), h = f(3), g = f(71);
          function t(v) {
            try {
              return (0, s.stringToUTF8String)(v);
            } catch (E) {
              return (0, s.warn)(`UTF-8 decoding failed: "${E}".`), v;
            }
          }
          class i extends g.SimpleXMLParser {
            constructor(E) {
              super(E), this.node = null;
            }
            onEndElement(E) {
              const S = super.onEndElement(E);
              if (S && E === "xfa:datasets")
                throw this.node = S, new Error("Aborting DatasetXMLParser.");
            }
          }
          class m {
            constructor(E) {
              if (E.datasets)
                this.node = new g.SimpleXMLParser({
                  hasAttributes: !0
                }).parseFromString(E.datasets).documentElement;
              else {
                const S = new i({
                  hasAttributes: !0
                });
                try {
                  S.parseFromString(E["xdp:xdp"]);
                } catch {
                }
                this.node = S.node;
              }
            }
            getValue(E) {
              if (!this.node || !E)
                return "";
              const S = this.node.searchNode((0, h.parseXFAPath)(E), 0);
              if (!S)
                return "";
              const y = S.firstChild;
              return (y == null ? void 0 : y.nodeName) === "value" ? S.children.map((x) => t(x.textContent)) : t(S.textContent);
            }
          }
          c.DatasetReader = m;
        },
        /* 103 */
        /***/
        (d, c, f) => {
          var E;
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.XRef = void 0;
          var s = f(2), h = f(4), g = f(16), t = f(3), i = f(5), m = f(74);
          class v {
            constructor(y, x) {
              zn(this, E, null);
              this.stream = y, this.pdfManager = x, this.entries = [], this._xrefStms = /* @__PURE__ */ new Set(), this._cacheMap = /* @__PURE__ */ new Map(), this._pendingRefs = new h.RefSet(), this._newPersistentRefNum = null, this._newTemporaryRefNum = null;
            }
            getNewPersistentRef(y) {
              this._newPersistentRefNum === null && (this._newPersistentRefNum = this.entries.length || 1);
              const x = this._newPersistentRefNum++;
              return this._cacheMap.set(x, y), h.Ref.get(x, 0);
            }
            getNewTemporaryRef() {
              return this._newTemporaryRefNum === null && (this._newTemporaryRefNum = this.entries.length || 1), h.Ref.get(this._newTemporaryRefNum++, 0);
            }
            resetNewTemporaryRef() {
              this._newTemporaryRefNum = null;
            }
            setStartXRef(y) {
              this.startXRefQueue = [y];
            }
            parse(y = !1) {
              let x;
              y ? ((0, s.warn)("Indexing all PDF objects"), x = this.indexObjects()) : x = this.readXRef(), x.assignXref(this), this.trailer = x;
              let b;
              try {
                b = x.get("Encrypt");
              } catch (I) {
                if (I instanceof t.MissingDataException)
                  throw I;
                (0, s.warn)(`XRef.parse - Invalid "Encrypt" reference: "${I}".`);
              }
              if (b instanceof h.Dict) {
                const I = x.get("ID"), O = I != null && I.length ? I[0] : "";
                b.suppressEncryption = !0, this.encrypt = new m.CipherTransformFactory(b, O, this.pdfManager.password);
              }
              let u;
              try {
                u = x.get("Root");
              } catch (I) {
                if (I instanceof t.MissingDataException)
                  throw I;
                (0, s.warn)(`XRef.parse - Invalid "Root" reference: "${I}".`);
              }
              if (u instanceof h.Dict)
                try {
                  if (u.get("Pages") instanceof h.Dict) {
                    this.root = u;
                    return;
                  }
                } catch (I) {
                  if (I instanceof t.MissingDataException)
                    throw I;
                  (0, s.warn)(`XRef.parse - Invalid "Pages" reference: "${I}".`);
                }
              throw y ? new s.InvalidPDFException("Invalid Root reference.") : new t.XRefParseException();
            }
            processXRefTable(y) {
              "tableState" in this || (this.tableState = {
                entryNum: 0,
                streamPos: y.lexer.stream.pos,
                parserBuf1: y.buf1,
                parserBuf2: y.buf2
              });
              const x = this.readXRefTable(y);
              if (!(0, h.isCmd)(x, "trailer"))
                throw new s.FormatError("Invalid XRef table: could not find trailer dictionary");
              let b = y.getObj();
              if (!(b instanceof h.Dict) && b.dict && (b = b.dict), !(b instanceof h.Dict))
                throw new s.FormatError("Invalid XRef table: could not parse trailer dictionary");
              return delete this.tableState, b;
            }
            readXRefTable(y) {
              const x = y.lexer.stream, b = this.tableState;
              x.pos = b.streamPos, y.buf1 = b.parserBuf1, y.buf2 = b.parserBuf2;
              let u;
              for (; ; ) {
                if (!("firstEntryNum" in b) || !("entryCount" in b)) {
                  if ((0, h.isCmd)(u = y.getObj(), "trailer"))
                    break;
                  b.firstEntryNum = u, b.entryCount = y.getObj();
                }
                let I = b.firstEntryNum;
                const O = b.entryCount;
                if (!Number.isInteger(I) || !Number.isInteger(O))
                  throw new s.FormatError("Invalid XRef table: wrong types in subsection header");
                for (let D = b.entryNum; D < O; D++) {
                  b.streamPos = x.pos, b.entryNum = D, b.parserBuf1 = y.buf1, b.parserBuf2 = y.buf2;
                  const $ = {};
                  $.offset = y.getObj(), $.gen = y.getObj();
                  const K = y.getObj();
                  if (K instanceof h.Cmd)
                    switch (K.cmd) {
                      case "f":
                        $.free = !0;
                        break;
                      case "n":
                        $.uncompressed = !0;
                        break;
                    }
                  if (!Number.isInteger($.offset) || !Number.isInteger($.gen) || !($.free || $.uncompressed))
                    throw new s.FormatError(`Invalid entry in XRef subsection: ${I}, ${O}`);
                  D === 0 && $.free && I === 1 && (I = 0), this.entries[D + I] || (this.entries[D + I] = $);
                }
                b.entryNum = 0, b.streamPos = x.pos, b.parserBuf1 = y.buf1, b.parserBuf2 = y.buf2, delete b.firstEntryNum, delete b.entryCount;
              }
              if (this.entries[0] && !this.entries[0].free)
                throw new s.FormatError("Invalid XRef table: unexpected first object");
              return u;
            }
            processXRefStream(y) {
              if (!("streamState" in this)) {
                const x = y.dict, b = x.get("W");
                let u = x.get("Index");
                u || (u = [0, x.get("Size")]), this.streamState = {
                  entryRanges: u,
                  byteWidths: b,
                  entryNum: 0,
                  streamPos: y.pos
                };
              }
              return this.readXRefStream(y), delete this.streamState, y.dict;
            }
            readXRefStream(y) {
              const x = this.streamState;
              y.pos = x.streamPos;
              const [b, u, I] = x.byteWidths, O = x.entryRanges;
              for (; O.length > 0; ) {
                const [D, $] = O;
                if (!Number.isInteger(D) || !Number.isInteger($))
                  throw new s.FormatError(`Invalid XRef range fields: ${D}, ${$}`);
                if (!Number.isInteger(b) || !Number.isInteger(u) || !Number.isInteger(I))
                  throw new s.FormatError(`Invalid XRef entry fields length: ${D}, ${$}`);
                for (let K = x.entryNum; K < $; ++K) {
                  x.entryNum = K, x.streamPos = y.pos;
                  let H = 0, B = 0, R = 0;
                  for (let A = 0; A < b; ++A) {
                    const k = y.getByte();
                    if (k === -1)
                      throw new s.FormatError("Invalid XRef byteWidths 'type'.");
                    H = H << 8 | k;
                  }
                  b === 0 && (H = 1);
                  for (let A = 0; A < u; ++A) {
                    const k = y.getByte();
                    if (k === -1)
                      throw new s.FormatError("Invalid XRef byteWidths 'offset'.");
                    B = B << 8 | k;
                  }
                  for (let A = 0; A < I; ++A) {
                    const k = y.getByte();
                    if (k === -1)
                      throw new s.FormatError("Invalid XRef byteWidths 'generation'.");
                    R = R << 8 | k;
                  }
                  const _ = {};
                  switch (_.offset = B, _.gen = R, H) {
                    case 0:
                      _.free = !0;
                      break;
                    case 1:
                      _.uncompressed = !0;
                      break;
                    case 2:
                      break;
                    default:
                      throw new s.FormatError(`Invalid XRef entry type: ${H}`);
                  }
                  this.entries[D + K] || (this.entries[D + K] = _);
                }
                x.entryNum = 0, x.streamPos = y.pos, O.splice(0, 2);
              }
            }
            indexObjects() {
              function D(te, G) {
                let N = "", q = te[G];
                for (; q !== 10 && q !== 13 && q !== 60 && !(++G >= te.length); )
                  N += String.fromCharCode(q), q = te[G];
                return N;
              }
              function $(te, G, N) {
                const q = N.length, ie = te.length;
                let oe = 0;
                for (; G < ie; ) {
                  let fe = 0;
                  for (; fe < q && te[G + fe] === N[fe]; )
                    ++fe;
                  if (fe >= q)
                    break;
                  G++, oe++;
                }
                return oe;
              }
              const K = /\b(endobj|\d+\s+\d+\s+obj|xref|trailer\s*<<)\b/g, H = /\b(startxref|\d+\s+\d+\s+obj)\b/g, B = /^(\d+)\s+(\d+)\s+obj\b/, R = new Uint8Array([116, 114, 97, 105, 108, 101, 114]), _ = new Uint8Array([115, 116, 97, 114, 116, 120, 114, 101, 102]), A = new Uint8Array([47, 88, 82, 101, 102]);
              this.entries.length = 0, this._cacheMap.clear();
              const k = this.stream;
              k.pos = 0;
              const z = k.getBytes(), T = (0, s.bytesToString)(z), w = z.length;
              let F = k.start;
              const j = [], P = [];
              for (; F < w; ) {
                let te = z[F];
                if (te === 9 || te === 10 || te === 13 || te === 32) {
                  ++F;
                  continue;
                }
                if (te === 37) {
                  do {
                    if (++F, F >= w)
                      break;
                    te = z[F];
                  } while (te !== 10 && te !== 13);
                  continue;
                }
                const G = D(z, F);
                let N;
                if (G.startsWith("xref") && (G.length === 4 || /\s/.test(G[4])))
                  F += $(z, F, R), j.push(F), F += $(z, F, _);
                else if (N = B.exec(G)) {
                  const q = N[1] | 0, ie = N[2] | 0, oe = F + G.length;
                  let fe, Y = !1;
                  if (!this.entries[q])
                    Y = !0;
                  else if (this.entries[q].gen === ie)
                    try {
                      new g.Parser({
                        lexer: new g.Lexer(k.makeSubStream(oe))
                      }).getObj(), Y = !0;
                    } catch (W) {
                      W instanceof t.ParserEOFException ? (0, s.warn)(`indexObjects -- checking object (${G}): "${W}".`) : Y = !0;
                    }
                  Y && (this.entries[q] = {
                    offset: F - k.start,
                    gen: ie,
                    uncompressed: !0
                  }), K.lastIndex = oe;
                  const ae = K.exec(T);
                  ae ? (fe = K.lastIndex + 1 - F, ae[1] !== "endobj" && ((0, s.warn)(`indexObjects: Found "${ae[1]}" inside of another "obj", caused by missing "endobj" -- trying to recover.`), fe -= ae[1].length + 1)) : fe = w - F;
                  const se = z.subarray(F, F + fe), L = $(se, 0, A);
                  L < fe && se[L + 5] < 64 && (P.push(F - k.start), this._xrefStms.add(F - k.start)), F += fe;
                } else if (G.startsWith("trailer") && (G.length === 7 || /\s/.test(G[7]))) {
                  j.push(F);
                  const q = F + G.length;
                  let ie;
                  H.lastIndex = q;
                  const oe = H.exec(T);
                  oe ? (ie = H.lastIndex + 1 - F, oe[1] !== "startxref" && ((0, s.warn)(`indexObjects: Found "${oe[1]}" after "trailer", caused by missing "startxref" -- trying to recover.`), ie -= oe[1].length + 1)) : ie = w - F, F += ie;
                } else
                  F += G.length + 1;
              }
              for (const te of P)
                this.startXRefQueue.push(te), this.readXRef(!0);
              const V = [];
              let J = !1;
              for (const te of j) {
                k.pos = te;
                const G = new g.Parser({
                  lexer: new g.Lexer(k),
                  xref: this,
                  allowStreams: !0,
                  recoveryMode: !0
                }), N = G.getObj();
                if (!(0, h.isCmd)(N, "trailer"))
                  continue;
                const q = G.getObj();
                q instanceof h.Dict && (V.push(q), q.has("Encrypt") && (J = !0));
              }
              let ne, Z;
              for (const te of [...V, "genFallback", ...V]) {
                if (te === "genFallback") {
                  if (!Z)
                    break;
                  this._generationFallback = !0;
                  continue;
                }
                let G = !1;
                try {
                  const N = te.get("Root");
                  if (!(N instanceof h.Dict))
                    continue;
                  const q = N.get("Pages");
                  if (!(q instanceof h.Dict))
                    continue;
                  const ie = q.get("Count");
                  Number.isInteger(ie) && (G = !0);
                } catch (N) {
                  Z = N;
                  continue;
                }
                if (G && (!J || te.has("Encrypt")) && te.has("ID"))
                  return te;
                ne = te;
              }
              if (ne)
                return ne;
              if (this.topDict)
                return this.topDict;
              throw new s.InvalidPDFException("Invalid PDF structure.");
            }
            readXRef(y = !1) {
              const x = this.stream, b = /* @__PURE__ */ new Set();
              for (; this.startXRefQueue.length; ) {
                try {
                  const u = this.startXRefQueue[0];
                  if (b.has(u)) {
                    (0, s.warn)("readXRef - skipping XRef table since it was already parsed."), this.startXRefQueue.shift();
                    continue;
                  }
                  b.add(u), x.pos = u + x.start;
                  const I = new g.Parser({
                    lexer: new g.Lexer(x),
                    xref: this,
                    allowStreams: !0
                  });
                  let O = I.getObj(), D;
                  if ((0, h.isCmd)(O, "xref"))
                    D = this.processXRefTable(I), this.topDict || (this.topDict = D), O = D.get("XRefStm"), Number.isInteger(O) && !this._xrefStms.has(O) && (this._xrefStms.add(O), this.startXRefQueue.push(O), Un(this, E) ?? Mc(this, E, O));
                  else if (Number.isInteger(O)) {
                    if (!Number.isInteger(I.getObj()) || !(0, h.isCmd)(I.getObj(), "obj") || !((O = I.getObj()) instanceof i.BaseStream))
                      throw new s.FormatError("Invalid XRef stream");
                    if (D = this.processXRefStream(O), this.topDict || (this.topDict = D), !D)
                      throw new s.FormatError("Failed to read XRef stream");
                  } else
                    throw new s.FormatError("Invalid XRef stream header");
                  O = D.get("Prev"), Number.isInteger(O) ? this.startXRefQueue.push(O) : O instanceof h.Ref && this.startXRefQueue.push(O.num);
                } catch (u) {
                  if (u instanceof t.MissingDataException)
                    throw u;
                  (0, s.info)("(while reading XRef): " + u);
                }
                this.startXRefQueue.shift();
              }
              if (this.topDict)
                return this.topDict;
              if (!y)
                throw new t.XRefParseException();
            }
            get lastXRefStreamPos() {
              return Un(this, E) ?? (this._xrefStms.size > 0 ? Math.max(...this._xrefStms) : null);
            }
            getEntry(y) {
              const x = this.entries[y];
              return x && !x.free && x.offset ? x : null;
            }
            fetchIfRef(y, x = !1) {
              return y instanceof h.Ref ? this.fetch(y, x) : y;
            }
            fetch(y, x = !1) {
              if (!(y instanceof h.Ref))
                throw new Error("ref object is not a reference");
              const b = y.num, u = this._cacheMap.get(b);
              if (u !== void 0)
                return u instanceof h.Dict && !u.objId && (u.objId = y.toString()), u;
              let I = this.getEntry(b);
              if (I === null)
                return this._cacheMap.set(b, I), I;
              if (this._pendingRefs.has(y))
                return this._pendingRefs.remove(y), (0, s.warn)(`Ignoring circular reference: ${y}.`), h.CIRCULAR_REF;
              this._pendingRefs.put(y);
              try {
                I = I.uncompressed ? this.fetchUncompressed(y, I, x) : this.fetchCompressed(y, I, x), this._pendingRefs.remove(y);
              } catch (O) {
                throw this._pendingRefs.remove(y), O;
              }
              return I instanceof h.Dict ? I.objId = y.toString() : I instanceof i.BaseStream && (I.dict.objId = y.toString()), I;
            }
            fetchUncompressed(y, x, b = !1) {
              const u = y.gen;
              let I = y.num;
              if (x.gen !== u) {
                const B = `Inconsistent generation in XRef: ${y}`;
                if (this._generationFallback && x.gen < u)
                  return (0, s.warn)(B), this.fetchUncompressed(h.Ref.get(I, x.gen), x, b);
                throw new t.XRefEntryException(B);
              }
              const O = this.stream.makeSubStream(x.offset + this.stream.start), D = new g.Parser({
                lexer: new g.Lexer(O),
                xref: this,
                allowStreams: !0
              }), $ = D.getObj(), K = D.getObj(), H = D.getObj();
              if ($ !== I || K !== u || !(H instanceof h.Cmd))
                throw new t.XRefEntryException(`Bad (uncompressed) XRef entry: ${y}`);
              if (H.cmd !== "obj") {
                if (H.cmd.startsWith("obj") && (I = parseInt(H.cmd.substring(3), 10), !Number.isNaN(I)))
                  return I;
                throw new t.XRefEntryException(`Bad (uncompressed) XRef entry: ${y}`);
              }
              return x = this.encrypt && !b ? D.getObj(this.encrypt.createCipherTransform(I, u)) : D.getObj(), x instanceof i.BaseStream || this._cacheMap.set(I, x), x;
            }
            fetchCompressed(y, x, b = !1) {
              const u = x.offset, I = this.fetch(h.Ref.get(u, 0));
              if (!(I instanceof i.BaseStream))
                throw new s.FormatError("bad ObjStm stream");
              const O = I.dict.get("First"), D = I.dict.get("N");
              if (!Number.isInteger(O) || !Number.isInteger(D))
                throw new s.FormatError("invalid first and n parameters for ObjStm stream");
              let $ = new g.Parser({
                lexer: new g.Lexer(I),
                xref: this,
                allowStreams: !0
              });
              const K = new Array(D), H = new Array(D);
              for (let _ = 0; _ < D; ++_) {
                const A = $.getObj();
                if (!Number.isInteger(A))
                  throw new s.FormatError(`invalid object number in the ObjStm stream: ${A}`);
                const k = $.getObj();
                if (!Number.isInteger(k))
                  throw new s.FormatError(`invalid object offset in the ObjStm stream: ${k}`);
                K[_] = A, H[_] = k;
              }
              const B = (I.start || 0) + O, R = new Array(D);
              for (let _ = 0; _ < D; ++_) {
                const A = _ < D - 1 ? H[_ + 1] - H[_] : void 0;
                if (A < 0)
                  throw new s.FormatError("Invalid offset in the ObjStm stream.");
                $ = new g.Parser({
                  lexer: new g.Lexer(I.makeSubStream(B + H[_], A, I.dict)),
                  xref: this,
                  allowStreams: !0
                });
                const k = $.getObj();
                if (R[_] = k, k instanceof i.BaseStream)
                  continue;
                const z = K[_], T = this.entries[z];
                T && T.offset === u && T.gen === _ && this._cacheMap.set(z, k);
              }
              if (x = R[x.gen], x === void 0)
                throw new t.XRefEntryException(`Bad (compressed) XRef entry: ${y}`);
              return x;
            }
            async fetchIfRefAsync(y, x) {
              return y instanceof h.Ref ? this.fetchAsync(y, x) : y;
            }
            async fetchAsync(y, x) {
              try {
                return this.fetch(y, x);
              } catch (b) {
                if (!(b instanceof t.MissingDataException))
                  throw b;
                return await this.pdfManager.requestRange(b.begin, b.end), this.fetchAsync(y, x);
              }
            }
            getCatalogObj() {
              return this.root;
            }
          }
          E = new WeakMap(), c.XRef = v;
        },
        /* 104 */
        /***/
        (d, c, f) => {
          var m, V2, X2, bl;
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.MessageHandler = void 0;
          var s = f(2);
          const h = {
            UNKNOWN: 0,
            DATA: 1,
            ERROR: 2
          }, g = {
            UNKNOWN: 0,
            CANCEL: 1,
            CANCEL_COMPLETE: 2,
            CLOSE: 3,
            ENQUEUE: 4,
            ERROR: 5,
            PULL: 6,
            PULL_COMPLETE: 7,
            START_COMPLETE: 8
          };
          function t(y) {
            switch (y instanceof Error || typeof y == "object" && y !== null || (0, s.unreachable)('wrapReason: Expected "reason" to be a (possibly cloned) Error.'), y.name) {
              case "AbortException":
                return new s.AbortException(y.message);
              case "MissingPDFException":
                return new s.MissingPDFException(y.message);
              case "PasswordException":
                return new s.PasswordException(y.message, y.code);
              case "UnexpectedResponseException":
                return new s.UnexpectedResponseException(y.message, y.status);
              case "UnknownErrorException":
                return new s.UnknownErrorException(y.message, y.details);
              default:
                return new s.UnknownErrorException(y.message, y.toString());
            }
          }
          class i {
            constructor(x, b, u) {
              zn(this, m);
              this.sourceName = x, this.targetName = b, this.comObj = u, this.callbackId = 1, this.streamId = 1, this.streamSinks = /* @__PURE__ */ Object.create(null), this.streamControllers = /* @__PURE__ */ Object.create(null), this.callbackCapabilities = /* @__PURE__ */ Object.create(null), this.actionHandler = /* @__PURE__ */ Object.create(null), this._onComObjOnMessage = (I) => {
                const O = I.data;
                if (O.targetName !== this.sourceName)
                  return;
                if (O.stream) {
                  Nt(this, m, X2).call(this, O);
                  return;
                }
                if (O.callback) {
                  const $ = O.callbackId, K = this.callbackCapabilities[$];
                  if (!K)
                    throw new Error(`Cannot resolve callback ${$}`);
                  if (delete this.callbackCapabilities[$], O.callback === h.DATA)
                    K.resolve(O.data);
                  else if (O.callback === h.ERROR)
                    K.reject(t(O.reason));
                  else
                    throw new Error("Unexpected callback case");
                  return;
                }
                const D = this.actionHandler[O.action];
                if (!D)
                  throw new Error(`Unknown action from worker: ${O.action}`);
                if (O.callbackId) {
                  const $ = this.sourceName, K = O.sourceName;
                  new Promise(function(H) {
                    H(D(O.data));
                  }).then(function(H) {
                    u.postMessage({
                      sourceName: $,
                      targetName: K,
                      callback: h.DATA,
                      callbackId: O.callbackId,
                      data: H
                    });
                  }, function(H) {
                    u.postMessage({
                      sourceName: $,
                      targetName: K,
                      callback: h.ERROR,
                      callbackId: O.callbackId,
                      reason: t(H)
                    });
                  });
                  return;
                }
                if (O.streamId) {
                  Nt(this, m, V2).call(this, O);
                  return;
                }
                D(O.data);
              }, u.addEventListener("message", this._onComObjOnMessage);
            }
            on(x, b) {
              const u = this.actionHandler;
              if (u[x])
                throw new Error(`There is already an actionName called "${x}"`);
              u[x] = b;
            }
            send(x, b, u) {
              this.comObj.postMessage({
                sourceName: this.sourceName,
                targetName: this.targetName,
                action: x,
                data: b
              }, u);
            }
            sendWithPromise(x, b, u) {
              const I = this.callbackId++, O = new s.PromiseCapability();
              this.callbackCapabilities[I] = O;
              try {
                this.comObj.postMessage({
                  sourceName: this.sourceName,
                  targetName: this.targetName,
                  action: x,
                  callbackId: I,
                  data: b
                }, u);
              } catch (D) {
                O.reject(D);
              }
              return O.promise;
            }
            sendWithStream(x, b, u, I) {
              const O = this.streamId++, D = this.sourceName, $ = this.targetName, K = this.comObj;
              return new ReadableStream({
                start: (H) => {
                  const B = new s.PromiseCapability();
                  return this.streamControllers[O] = {
                    controller: H,
                    startCall: B,
                    pullCall: null,
                    cancelCall: null,
                    isClosed: !1
                  }, K.postMessage({
                    sourceName: D,
                    targetName: $,
                    action: x,
                    streamId: O,
                    data: b,
                    desiredSize: H.desiredSize
                  }, I), B.promise;
                },
                pull: (H) => {
                  const B = new s.PromiseCapability();
                  return this.streamControllers[O].pullCall = B, K.postMessage({
                    sourceName: D,
                    targetName: $,
                    stream: g.PULL,
                    streamId: O,
                    desiredSize: H.desiredSize
                  }), B.promise;
                },
                cancel: (H) => {
                  (0, s.assert)(H instanceof Error, "cancel must have a valid reason");
                  const B = new s.PromiseCapability();
                  return this.streamControllers[O].cancelCall = B, this.streamControllers[O].isClosed = !0, K.postMessage({
                    sourceName: D,
                    targetName: $,
                    stream: g.CANCEL,
                    streamId: O,
                    reason: t(H)
                  }), B.promise;
                }
              }, u);
            }
            destroy() {
              this.comObj.removeEventListener("message", this._onComObjOnMessage);
            }
          }
          m = new WeakSet(), V2 = function(x) {
            const b = x.streamId, u = this.sourceName, I = x.sourceName, O = this.comObj, D = this, $ = this.actionHandler[x.action], K = {
              enqueue(H, B = 1, R) {
                if (this.isCancelled)
                  return;
                const _ = this.desiredSize;
                this.desiredSize -= B, _ > 0 && this.desiredSize <= 0 && (this.sinkCapability = new s.PromiseCapability(), this.ready = this.sinkCapability.promise), O.postMessage({
                  sourceName: u,
                  targetName: I,
                  stream: g.ENQUEUE,
                  streamId: b,
                  chunk: H
                }, R);
              },
              close() {
                this.isCancelled || (this.isCancelled = !0, O.postMessage({
                  sourceName: u,
                  targetName: I,
                  stream: g.CLOSE,
                  streamId: b
                }), delete D.streamSinks[b]);
              },
              error(H) {
                (0, s.assert)(H instanceof Error, "error must have a valid reason"), !this.isCancelled && (this.isCancelled = !0, O.postMessage({
                  sourceName: u,
                  targetName: I,
                  stream: g.ERROR,
                  streamId: b,
                  reason: t(H)
                }));
              },
              sinkCapability: new s.PromiseCapability(),
              onPull: null,
              onCancel: null,
              isCancelled: !1,
              desiredSize: x.desiredSize,
              ready: null
            };
            K.sinkCapability.resolve(), K.ready = K.sinkCapability.promise, this.streamSinks[b] = K, new Promise(function(H) {
              H($(x.data, K));
            }).then(function() {
              O.postMessage({
                sourceName: u,
                targetName: I,
                stream: g.START_COMPLETE,
                streamId: b,
                success: !0
              });
            }, function(H) {
              O.postMessage({
                sourceName: u,
                targetName: I,
                stream: g.START_COMPLETE,
                streamId: b,
                reason: t(H)
              });
            });
          }, X2 = function(x) {
            const b = x.streamId, u = this.sourceName, I = x.sourceName, O = this.comObj, D = this.streamControllers[b], $ = this.streamSinks[b];
            switch (x.stream) {
              case g.START_COMPLETE:
                x.success ? D.startCall.resolve() : D.startCall.reject(t(x.reason));
                break;
              case g.PULL_COMPLETE:
                x.success ? D.pullCall.resolve() : D.pullCall.reject(t(x.reason));
                break;
              case g.PULL:
                if (!$) {
                  O.postMessage({
                    sourceName: u,
                    targetName: I,
                    stream: g.PULL_COMPLETE,
                    streamId: b,
                    success: !0
                  });
                  break;
                }
                $.desiredSize <= 0 && x.desiredSize > 0 && $.sinkCapability.resolve(), $.desiredSize = x.desiredSize, new Promise(function(K) {
                  var H;
                  K((H = $.onPull) == null ? void 0 : H.call($));
                }).then(function() {
                  O.postMessage({
                    sourceName: u,
                    targetName: I,
                    stream: g.PULL_COMPLETE,
                    streamId: b,
                    success: !0
                  });
                }, function(K) {
                  O.postMessage({
                    sourceName: u,
                    targetName: I,
                    stream: g.PULL_COMPLETE,
                    streamId: b,
                    reason: t(K)
                  });
                });
                break;
              case g.ENQUEUE:
                if ((0, s.assert)(D, "enqueue should have stream controller"), D.isClosed)
                  break;
                D.controller.enqueue(x.chunk);
                break;
              case g.CLOSE:
                if ((0, s.assert)(D, "close should have stream controller"), D.isClosed)
                  break;
                D.isClosed = !0, D.controller.close(), Nt(this, m, bl).call(this, D, b);
                break;
              case g.ERROR:
                (0, s.assert)(D, "error should have stream controller"), D.controller.error(t(x.reason)), Nt(this, m, bl).call(this, D, b);
                break;
              case g.CANCEL_COMPLETE:
                x.success ? D.cancelCall.resolve() : D.cancelCall.reject(t(x.reason)), Nt(this, m, bl).call(this, D, b);
                break;
              case g.CANCEL:
                if (!$)
                  break;
                new Promise(function(K) {
                  var H;
                  K((H = $.onCancel) == null ? void 0 : H.call($, t(x.reason)));
                }).then(function() {
                  O.postMessage({
                    sourceName: u,
                    targetName: I,
                    stream: g.CANCEL_COMPLETE,
                    streamId: b,
                    success: !0
                  });
                }, function(K) {
                  O.postMessage({
                    sourceName: u,
                    targetName: I,
                    stream: g.CANCEL_COMPLETE,
                    streamId: b,
                    reason: t(K)
                  });
                }), $.sinkCapability.reject(t(x.reason)), $.isCancelled = !0, delete this.streamSinks[b];
                break;
              default:
                throw new Error("Unexpected stream case");
            }
          }, bl = async function(x, b) {
            var u, I, O;
            await Promise.allSettled([(u = x.startCall) == null ? void 0 : u.promise, (I = x.pullCall) == null ? void 0 : I.promise, (O = x.cancelCall) == null ? void 0 : O.promise]), delete this.streamControllers[b];
          }, c.MessageHandler = i;
        },
        /* 105 */
        /***/
        (d, c, f) => {
          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.PDFWorkerStream = void 0;
          var s = f(2);
          class h {
            constructor(m) {
              this._msgHandler = m, this._contentLength = null, this._fullRequestReader = null, this._rangeRequestReaders = [];
            }
            getFullReader() {
              return (0, s.assert)(!this._fullRequestReader, "PDFWorkerStream.getFullReader can only be called once."), this._fullRequestReader = new g(this._msgHandler), this._fullRequestReader;
            }
            getRangeReader(m, v) {
              const E = new t(m, v, this._msgHandler);
              return this._rangeRequestReaders.push(E), E;
            }
            cancelAllRequests(m) {
              var v;
              (v = this._fullRequestReader) == null || v.cancel(m);
              for (const E of this._rangeRequestReaders.slice(0))
                E.cancel(m);
            }
          }
          c.PDFWorkerStream = h;
          class g {
            constructor(m) {
              this._msgHandler = m, this.onProgress = null, this._contentLength = null, this._isRangeSupported = !1, this._isStreamingSupported = !1;
              const v = this._msgHandler.sendWithStream("GetReader");
              this._reader = v.getReader(), this._headersReady = this._msgHandler.sendWithPromise("ReaderHeadersReady").then((E) => {
                this._isStreamingSupported = E.isStreamingSupported, this._isRangeSupported = E.isRangeSupported, this._contentLength = E.contentLength;
              });
            }
            get headersReady() {
              return this._headersReady;
            }
            get contentLength() {
              return this._contentLength;
            }
            get isStreamingSupported() {
              return this._isStreamingSupported;
            }
            get isRangeSupported() {
              return this._isRangeSupported;
            }
            async read() {
              const {
                value: m,
                done: v
              } = await this._reader.read();
              return v ? {
                value: void 0,
                done: !0
              } : {
                value: m.buffer,
                done: !1
              };
            }
            cancel(m) {
              this._reader.cancel(m);
            }
          }
          class t {
            constructor(m, v, E) {
              this._msgHandler = E, this.onProgress = null;
              const S = this._msgHandler.sendWithStream("GetRangeReader", {
                begin: m,
                end: v
              });
              this._reader = S.getReader();
            }
            get isStreamingSupported() {
              return !1;
            }
            async read() {
              const {
                value: m,
                done: v
              } = await this._reader.read();
              return v ? {
                value: void 0,
                done: !0
              } : {
                value: m.buffer,
                done: !1
              };
            }
            cancel(m) {
              this._reader.cancel(m);
            }
          }
        }
        /******/
      ], a = {};
      function o(d) {
        var c = a[d];
        if (c !== void 0)
          return c.exports;
        var f = a[d] = {
          /******/
          // no module.id needed
          /******/
          // no module.loaded needed
          /******/
          exports: {}
          /******/
        };
        return r[d](f, f.exports, o), f.exports;
      }
      var l = {};
      return (() => {
        var d = l;
        Object.defineProperty(d, "__esModule", {
          value: !0
        }), Object.defineProperty(d, "WorkerMessageHandler", {
          enumerable: !0,
          get: function() {
            return c.WorkerMessageHandler;
          }
        });
        var c = o(1);
      })(), l;
    })()
  ));
})(M2);
var xS = M2.exports;
const bS = /* @__PURE__ */ ys(xS), yS = tt(Me)(({ theme: e }) => ({
  backgroundColor: e.palette.grey[100],
  height: "20px"
}));
function vS() {
  const [e, n] = Ee(0), [r, a] = Ee([!0]);
  ot(() => {
    typeof e == "number" && a(Array(e).fill(!0));
  }, [e]);
  function o({ numPages: c }) {
    n(c);
  }
  function l(c) {
    a([!1]), console.error("Could not load preview."), console.error(c), Tl("Could not load preview. Please download file to view details.", {
      icon: "💾"
    });
  }
  function d(c) {
    a((f) => (f[c] = !1, [...f]));
  }
  return {
    numPages: e,
    allPagesLoaded: r.every((c) => !c),
    handleLoadSuccess: o,
    handleError: l,
    handlePageRenderSuccess: d
  };
}
const Af = 0.5, kf = 2, G2 = 0.25, zd = 24, R0 = (e) => Math.round(e * 100) / 100, wS = (e) => Math.min(kf, R0(e + G2)), SS = (e) => Math.max(Af, R0(e - G2));
function _S(e, n) {
  return !n.width || !n.height || !e.width || !e.height ? 1 : R0(
    Math.min(
      1,
      (e.width - zd) / n.width,
      (e.height - zd) / n.height
    )
  );
}
function lp(e, n) {
  return !n || !e ? 1 : Math.min(
    kf,
    Math.max(Af, R0((e - zd) / n))
  );
}
const up = (e, n) => n !== null && Math.abs(e - n) < 0.01;
function CS(e, n) {
  const [r, a] = Ee(null), [o, l] = Ee(null), [d, c] = Ee(null), f = ut(0);
  function s(g) {
    const t = e.current;
    if (!n || !t) return;
    const i = _S(
      { width: t.clientWidth, height: t.clientHeight },
      { width: g.originalWidth, height: g.originalHeight }
    );
    f.current = g.originalWidth, l(i), c(lp(t.clientWidth, g.originalWidth)), a((m) => m ?? i);
  }
  function h() {
    const g = e.current;
    if (!g || !f.current) return;
    const t = lp(g.clientWidth, f.current);
    c(t), a(t);
  }
  return {
    zoom: r,
    fit: o,
    fitWidth: d,
    handleFirstPageLoad: s,
    handleFitWidth: h,
    handleZoomIn: () => a((g) => wS(g ?? 1)),
    handleZoomOut: () => a((g) => SS(g ?? 1)),
    handleFit: () => o !== null && a(o)
  };
}
const AS = ({
  zoom: e,
  fit: n,
  fitWidth: r,
  onZoomIn: a,
  onZoomOut: o,
  onFit: l,
  onFitWidth: d
}) => /* @__PURE__ */ p.jsxs(
  Pe,
  {
    direction: "row",
    "data-testid": "pdf-zoom-toolbar",
    sx: {
      alignItems: "center",
      justifyContent: "center",
      gap: 0.5,
      py: 0.5,
      flexShrink: 0,
      bgcolor: "common.neutrals.100",
      borderBottom: "1px solid",
      borderColor: "common.neutrals.200"
    },
    children: [
      /* @__PURE__ */ p.jsx(
        Gn,
        {
          size: "small",
          "aria-label": "Zoom out",
          disabled: e <= Af,
          onClick: o,
          children: /* @__PURE__ */ p.jsx(it, { icon: "minus", sx: { fontSize: 14 } })
        }
      ),
      /* @__PURE__ */ p.jsxs(
        Te,
        {
          variant: "body2",
          sx: {
            width: 48,
            textAlign: "center",
            fontVariantNumeric: "tabular-nums"
          },
          children: [
            Math.round(e * 100),
            "%"
          ]
        }
      ),
      /* @__PURE__ */ p.jsx(
        Gn,
        {
          size: "small",
          "aria-label": "Zoom in",
          disabled: e >= kf,
          onClick: a,
          children: /* @__PURE__ */ p.jsx(it, { icon: "plus", sx: { fontSize: 14 } })
        }
      ),
      /* @__PURE__ */ p.jsx(
        lt,
        {
          size: "small",
          variant: "text",
          sx: { ml: 1 },
          disabled: up(e, n),
          onClick: l,
          children: "Fit to page"
        }
      ),
      /* @__PURE__ */ p.jsx(
        lt,
        {
          size: "small",
          variant: "text",
          disabled: up(e, r),
          onClick: d,
          children: "Fit to width"
        }
      )
    ]
  }
), kS = tt(Pe)(({ theme: e }) => ({
  ".pdf-preview-container": {
    width: "100%",
    maxHeight: "calc(var(--liscio-app-viewport-height, 100vh) - 100px)",
    overflow: "scroll",
    backgroundColor: e.palette.common.white
  },
  "@media (max-width: 900px)": {
    ".pdf-preview-container": {
      width: "100%",
      overflow: "scroll",
      backgroundColor: "#f1f2f3"
    },
    ".pdf-preview-page": {
      width: "100%"
    }
  }
})), ES = {
  ".pdf-preview-container": {
    flex: 1,
    minHeight: 0,
    maxHeight: "none",
    overflow: "auto",
    backgroundColor: "common.neutrals.200",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    p: 1.5
  }
};
function IS() {
  const e = ut(null), [n, r] = Ee(0);
  return Pa(() => {
    e.current && r(e.current.offsetWidth);
  }, []), ot(() => {
    var a;
    (a = S1.GlobalWorkerOptions) != null && a.workerSrc || (S1.GlobalWorkerOptions.workerSrc = bS);
  }, []), { containerRef: e, containerWidth: n };
}
const TS = ({
  numPages: e,
  width: n,
  scale: r,
  centered: a,
  onFirstPageLoad: o,
  onPageRendered: l
}) => /* @__PURE__ */ p.jsx(p.Fragment, { children: e > 0 && [...Array(e)].map((d, c) => /* @__PURE__ */ p.jsxs("div", { style: a ? { margin: "0 auto" } : void 0, children: [
  /* @__PURE__ */ p.jsx(
    x7,
    {
      pageNumber: c + 1,
      ...r ? { scale: r } : { width: n },
      onLoadSuccess: c === 0 ? o : void 0,
      renderTextLayer: !1,
      renderAnnotationLayer: !1,
      onRenderSuccess: () => l(c),
      onRenderError: () => {
        console.error(`render page ${c + 1} error`);
      },
      className: "pdf-preview-page"
    }
  ),
  /* @__PURE__ */ p.jsx(yS, {})
] }, c)) }), no = ({
  url: e,
  width: n,
  height: r,
  maxHeight: a,
  showZoomControls: o = !1
}) => {
  const l = ut(null), { containerRef: d, containerWidth: c } = IS(), f = vS(), s = CS(l, o), h = o ? s.zoom : null;
  return /* @__PURE__ */ p.jsxs(
    kS,
    {
      width: "100%",
      height: r,
      ref: d,
      maxHeight: a,
      sx: o ? ES : void 0,
      children: [
        /* @__PURE__ */ p.jsx(h5, { open: !f.allPagesLoaded }),
        o && /* @__PURE__ */ p.jsx(
          AS,
          {
            zoom: s.zoom ?? 1,
            fit: s.fit,
            fitWidth: s.fitWidth,
            onZoomIn: s.handleZoomIn,
            onZoomOut: s.handleZoomOut,
            onFit: s.handleFit,
            onFitWidth: s.handleFitWidth
          }
        ),
        /* @__PURE__ */ p.jsx(
          m7,
          {
            file: e,
            inputRef: l,
            className: "pdf-preview-container",
            loading: /* @__PURE__ */ p.jsx(mi, { open: !0 }),
            onLoadError: f.handleError,
            onLoadSuccess: f.handleLoadSuccess,
            children: /* @__PURE__ */ p.jsx(
              TS,
              {
                numPages: f.numPages,
                width: n || c,
                scale: h,
                centered: o,
                onFirstPageLoad: s.handleFirstPageLoad,
                onPageRendered: f.handlePageRenderSuccess
              }
            )
          }
        )
      ]
    }
  );
}, OS = ({
  url: e,
  title: n
}) => /* @__PURE__ */ p.jsx("iframe", { width: "100%", height: "100%", src: e, title: n });
function FS({
  recipient: e
}) {
  if (!e) return null;
  const { initials: n, avatar: r, account_name: a, name: o } = e;
  return /* @__PURE__ */ p.jsx(
    f5,
    {
      initials: n,
      avatar: r,
      accountName: a,
      name: o
    }
  );
}
const PS = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.\d+)?Z$/, jS = (e) => {
  const n = PS.exec(e ?? ""), r = Date.parse(e ?? "");
  if (!n || !Number.isFinite(r)) return {};
  const a = new Date(r), o = n.slice(1, 7).map(Number), l = [
    a.getUTCFullYear(),
    a.getUTCMonth() + 1,
    a.getUTCDate(),
    a.getUTCHours(),
    a.getUTCMinutes(),
    a.getUTCSeconds()
  ];
  return o.every((d, c) => d === l[c]) ? { createdAt: r } : {};
}, RS = (e) => ({
  kind: "multi",
  app: {
    key: "@liscio/client"
  },
  platform: {
    // key: config.platform, // TODO
  },
  firm: {
    key: e.company_url,
    url: e.company_url,
    name: e.cpa_name,
    id: e.cpa_id,
    ...jS(e.cpa_created_at)
  },
  role: {
    key: e.role
  }
}), MS = () => {
  const e = of();
  return { identify: Oe(
    async (r) => {
      if (e) {
        const a = RS(r);
        await e.identify(a);
      }
    },
    [e]
  ) };
}, DS = {
  auth_token: "",
  email: ""
}, Ls = Qa()(
  (e, n) => ({
    auth_token: "",
    avatar: "",
    desktop_app_message: "",
    email: "",
    has_agreed_privacy_policy: !1,
    whataver: "",
    companyLogoUrl: null,
    isInitialized: !1,
    explicitLogout: !1,
    setIsInitialized: (r) => e({ isInitialized: r }),
    setAuth: (r) => {
      e({ ...r });
    },
    clearAuth: () => {
      e({ ...DS });
    },
    setExplicitLogout: () => e({ explicitLogout: !0 }),
    setAuthToken: (r) => {
      e({ auth_token: r });
      const a = n();
      return {
        auth_token: r,
        email: a.email
      };
    },
    forgotPasswordEmail: "",
    setForgotPasswordEmail: (r) => e({ forgotPasswordEmail: r }),
    loginRedirect: "",
    setLoginRedirect: (r) => e({ loginRedirect: r })
  })
), ir = xx("SecureStoragePlugin", {
  web: () => import("./web-TnUEoorG.js").then((e) => new e.SecureStoragePluginWeb())
}), Ef = "auth_session", Na = "auth_login_redirect", Hd = "oauth_nonce", NS = () => {
  var n;
  const e = (((n = window == null ? void 0 : window.location) == null ? void 0 : n.hostname) || "").split(".").slice(-2);
  if (e.length === 2)
    return e.join(".");
};
var Um, zm;
const wc = {
  domain: NS(),
  secure: (zm = (Um = window.location) == null ? void 0 : Um.protocol) == null ? void 0 : zm.includes("https"),
  sameSite: "lax"
}, LS = async (e) => {
  if (On.isNativePlatform())
    try {
      const { value: n } = await ir.get({ key: e });
      if (n)
        return JSON.parse(n);
    } catch {
    }
  else
    try {
      const n = Gr.get(e);
      if (n)
        return JSON.parse(n);
    } catch {
    }
}, BS = async (e, n) => {
  const r = JSON.stringify(n);
  try {
    On.isNativePlatform() ? await ir.set({ key: e, value: r }) : Gr.set(e, r, wc);
  } catch {
  }
}, $S = async (e) => {
  try {
    On.isNativePlatform() ? await ir.remove({ key: e }) : Gr.remove(e, wc);
  } catch {
  }
}, M0 = async () => LS(Ef), iB = async (e) => BS(Ef, e), K2 = async () => $S(Ef), rB = () => {
  try {
    return On.isNativePlatform() ? localStorage.getItem(Na) : Gr.get(Na);
  } catch {
  }
}, US = (e) => {
  On.isNativePlatform() ? localStorage.setItem(Na, e) : Gr.set(Na, e, wc);
}, sB = async () => {
  try {
    On.isNativePlatform() ? localStorage.removeItem(Na) : Gr.remove(Na, wc);
  } catch {
  }
}, zS = (e, n) => {
  Gr.set(e, n, {
    ...wc,
    expires: 1 / 48
    // Expire in 30 minutes or 1/48th of a day
  });
}, HS = async () => {
  const e = l7();
  return await ir.set({ key: Hd, value: e }), e;
}, WS = async (e) => {
  const { value: n } = await ir.get({
    key: Hd
  });
  if (!n || e !== n)
    throw new Error("Unable to verify OAuth nonce!");
  try {
    await ir.remove({ key: Hd });
  } catch {
  }
}, Y2 = (e) => {
  try {
    const n = e.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"), r = JSON.parse(atob(n));
    return typeof (r == null ? void 0 : r.exp) == "number" && r.exp < Date.now() / 1e3;
  } catch {
    return !1;
  }
}, aB = async () => {
  const e = await M0();
  if (e != null && e.auth_token && Y2(e.auth_token)) {
    await K2();
    return;
  }
  return e;
};
function xr() {
  const e = Jt(), { auth_token: n } = Ls(), { identify: r } = MS();
  return Sn({
    // Only fetch when authenticated
    enabled: !!n,
    queryKey: ["home-data"],
    queryFn: async () => {
      const a = await e.users.getHomeData();
      return a && await r(a.data), a;
    },
    cacheTime: 36e6,
    // 10 hours
    staleTime: 36e6
    // 10 hours
  });
}
function oB() {
  const e = Jt();
  return Sn({
    queryKey: ["menu-items"],
    queryFn: e.users.getMenuItems,
    cacheTime: 36e6,
    // 10 hours
    staleTime: 36e6
    // 10 hours
  });
}
function If() {
  return Sn({
    queryKey: ["profile"],
    queryFn: ({ signal: e }) => J5(e),
    cacheTime: 36e6,
    // 10 hours
    staleTime: 36e6
    // 10 hours
  });
}
const Z2 = () => {
  const { data: e, isLoading: n } = If();
  return {
    cpa_user_id: e == null ? void 0 : e.cpa_user_id,
    avatar: e == null ? void 0 : e.avatar,
    email: e == null ? void 0 : e.email,
    first_name: e == null ? void 0 : e.first_name,
    middle_name: e == null ? void 0 : e.middle_name,
    last_name: e == null ? void 0 : e.last_name,
    name: e != null && e.first_name || e != null && e.last_name ? `${e.first_name} ${e.last_name}` : void 0,
    phone: e == null ? void 0 : e.phone,
    role: e == null ? void 0 : e.role,
    title: e == null ? void 0 : e.title,
    isCustomer: (e == null ? void 0 : e.role) === Lc.Client,
    isFirmUser: (e == null ? void 0 : e.role) === Lc.Firm_Admin || (e == null ? void 0 : e.role) === Lc.Firm_Employee,
    isFirmAdmin: (e == null ? void 0 : e.role) === Lc.Firm_Admin,
    isLoading: n,
    two_factor_enabled: e == null ? void 0 : e.two_factor_enabled
  };
};
process.env.NODE_ENV !== "production" && (Fe.node, Fe.object.isRequired);
function D0(e) {
  return iw(e);
}
function Wd(e, n) {
  return Wd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, a) {
    return r.__proto__ = a, r;
  }, Wd(e, n);
}
function qS(e, n) {
  e.prototype = Object.create(n.prototype), e.prototype.constructor = e, Wd(e, n);
}
const dp = Nn.createContext(null);
function VS(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Tf(e, n) {
  var r = function(l) {
    return n && al(l) ? n(l) : l;
  }, a = /* @__PURE__ */ Object.create(null);
  return e && $y.map(e, function(o) {
    return o;
  }).forEach(function(o) {
    a[o.key] = r(o);
  }), a;
}
function XS(e, n) {
  e = e || {}, n = n || {};
  function r(h) {
    return h in n ? n[h] : e[h];
  }
  var a = /* @__PURE__ */ Object.create(null), o = [];
  for (var l in e)
    l in n ? o.length && (a[l] = o, o = []) : o.push(l);
  var d, c = {};
  for (var f in n) {
    if (a[f])
      for (d = 0; d < a[f].length; d++) {
        var s = a[f][d];
        c[a[f][d]] = r(s);
      }
    c[f] = r(f);
  }
  for (d = 0; d < o.length; d++)
    c[o[d]] = r(o[d]);
  return c;
}
function Ms(e, n, r) {
  return r[n] != null ? r[n] : e.props[n];
}
function GS(e, n) {
  return Tf(e.children, function(r) {
    return ol(r, {
      onExited: n.bind(null, r),
      in: !0,
      appear: Ms(r, "appear", e),
      enter: Ms(r, "enter", e),
      exit: Ms(r, "exit", e)
    });
  });
}
function KS(e, n, r) {
  var a = Tf(e.children), o = XS(n, a);
  return Object.keys(o).forEach(function(l) {
    var d = o[l];
    if (al(d)) {
      var c = l in n, f = l in a, s = n[l], h = al(s) && !s.props.in;
      f && (!c || h) ? o[l] = ol(d, {
        onExited: r.bind(null, d),
        in: !0,
        exit: Ms(d, "exit", e),
        enter: Ms(d, "enter", e)
      }) : !f && c && !h ? o[l] = ol(d, {
        in: !1
      }) : f && c && al(s) && (o[l] = ol(d, {
        onExited: r.bind(null, d),
        in: s.props.in,
        exit: Ms(d, "exit", e),
        enter: Ms(d, "enter", e)
      }));
    }
  }), o;
}
var YS = Object.values || function(e) {
  return Object.keys(e).map(function(n) {
    return e[n];
  });
}, ZS = {
  component: "div",
  childFactory: function(n) {
    return n;
  }
}, Of = /* @__PURE__ */ function(e) {
  qS(n, e);
  function n(a, o) {
    var l;
    l = e.call(this, a, o) || this;
    var d = l.handleExited.bind(VS(l));
    return l.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: d,
      firstRender: !0
    }, l;
  }
  var r = n.prototype;
  return r.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, r.componentWillUnmount = function() {
    this.mounted = !1;
  }, n.getDerivedStateFromProps = function(o, l) {
    var d = l.children, c = l.handleExited, f = l.firstRender;
    return {
      children: f ? GS(o, c) : KS(o, d, c),
      firstRender: !1
    };
  }, r.handleExited = function(o, l) {
    var d = Tf(this.props.children);
    o.key in d || (o.props.onExited && o.props.onExited(l), this.mounted && this.setState(function(c) {
      var f = zt({}, c.children);
      return delete f[o.key], {
        children: f
      };
    }));
  }, r.render = function() {
    var o = this.props, l = o.component, d = o.childFactory, c = Ti(o, ["component", "childFactory"]), f = this.state.contextValue, s = YS(this.state.children).map(d);
    return delete c.appear, delete c.enter, delete c.exit, l === null ? /* @__PURE__ */ Nn.createElement(dp.Provider, {
      value: f
    }, s) : /* @__PURE__ */ Nn.createElement(dp.Provider, {
      value: f
    }, /* @__PURE__ */ Nn.createElement(l, c, s));
  }, n;
}(Nn.Component);
Of.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: Fe.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: Fe.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: Fe.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: Fe.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: Fe.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: Fe.func
} : {};
Of.defaultProps = ZS;
function Q2(e) {
  const {
    className: n,
    classes: r,
    pulsate: a = !1,
    rippleX: o,
    rippleY: l,
    rippleSize: d,
    in: c,
    onExited: f,
    timeout: s
  } = e, [h, g] = Ue.useState(!1), t = ji(n, r.ripple, r.rippleVisible, a && r.ripplePulsate), i = {
    width: d,
    height: d,
    top: -(d / 2) + l,
    left: -(d / 2) + o
  }, m = ji(r.child, h && r.childLeaving, a && r.childPulsate);
  return !c && !h && g(!0), Ue.useEffect(() => {
    if (!c && f != null) {
      const v = setTimeout(f, s);
      return () => {
        clearTimeout(v);
      };
    }
  }, [f, c, s]), /* @__PURE__ */ p.jsx("span", {
    className: t,
    style: i,
    children: /* @__PURE__ */ p.jsx("span", {
      className: m
    })
  });
}
process.env.NODE_ENV !== "production" && (Q2.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: Fe.object.isRequired,
  className: Fe.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: Fe.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: Fe.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: Fe.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: Fe.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: Fe.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: Fe.number,
  /**
   * exit delay
   */
  timeout: Fe.number.isRequired
});
const er = F0("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), QS = ["center", "classes", "className"];
let N0 = (e) => e, hp, fp, pp, gp;
const qd = 550, JS = 80, e_ = y0(hp || (hp = N0`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`)), t_ = y0(fp || (fp = N0`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`)), n_ = y0(pp || (pp = N0`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`)), i_ = Zs("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), r_ = Zs(Q2, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})(gp || (gp = N0`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), er.rippleVisible, e_, qd, ({
  theme: e
}) => e.transitions.easing.easeInOut, er.ripplePulsate, ({
  theme: e
}) => e.transitions.duration.shorter, er.child, er.childLeaving, t_, qd, ({
  theme: e
}) => e.transitions.easing.easeInOut, er.childPulsate, n_, ({
  theme: e
}) => e.transitions.easing.easeInOut), J2 = /* @__PURE__ */ Ue.forwardRef(function(n, r) {
  const a = D0({
    props: n,
    name: "MuiTouchRipple"
  }), {
    center: o = !1,
    classes: l = {},
    className: d
  } = a, c = Ti(a, QS), [f, s] = Ue.useState([]), h = Ue.useRef(0), g = Ue.useRef(null);
  Ue.useEffect(() => {
    g.current && (g.current(), g.current = null);
  }, [f]);
  const t = Ue.useRef(!1), i = B4(), m = Ue.useRef(null), v = Ue.useRef(null), E = Ue.useCallback((b) => {
    const {
      pulsate: u,
      rippleX: I,
      rippleY: O,
      rippleSize: D,
      cb: $
    } = b;
    s((K) => [...K, /* @__PURE__ */ p.jsx(r_, {
      classes: {
        ripple: ji(l.ripple, er.ripple),
        rippleVisible: ji(l.rippleVisible, er.rippleVisible),
        ripplePulsate: ji(l.ripplePulsate, er.ripplePulsate),
        child: ji(l.child, er.child),
        childLeaving: ji(l.childLeaving, er.childLeaving),
        childPulsate: ji(l.childPulsate, er.childPulsate)
      },
      timeout: qd,
      pulsate: u,
      rippleX: I,
      rippleY: O,
      rippleSize: D
    }, h.current)]), h.current += 1, g.current = $;
  }, [l]), S = Ue.useCallback((b = {}, u = {}, I = () => {
  }) => {
    const {
      pulsate: O = !1,
      center: D = o || u.pulsate,
      fakeElement: $ = !1
      // For test purposes
    } = u;
    if ((b == null ? void 0 : b.type) === "mousedown" && t.current) {
      t.current = !1;
      return;
    }
    (b == null ? void 0 : b.type) === "touchstart" && (t.current = !0);
    const K = $ ? null : v.current, H = K ? K.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let B, R, _;
    if (D || b === void 0 || b.clientX === 0 && b.clientY === 0 || !b.clientX && !b.touches)
      B = Math.round(H.width / 2), R = Math.round(H.height / 2);
    else {
      const {
        clientX: A,
        clientY: k
      } = b.touches && b.touches.length > 0 ? b.touches[0] : b;
      B = Math.round(A - H.left), R = Math.round(k - H.top);
    }
    if (D)
      _ = Math.sqrt((2 * H.width ** 2 + H.height ** 2) / 3), _ % 2 === 0 && (_ += 1);
    else {
      const A = Math.max(Math.abs((K ? K.clientWidth : 0) - B), B) * 2 + 2, k = Math.max(Math.abs((K ? K.clientHeight : 0) - R), R) * 2 + 2;
      _ = Math.sqrt(A ** 2 + k ** 2);
    }
    b != null && b.touches ? m.current === null && (m.current = () => {
      E({
        pulsate: O,
        rippleX: B,
        rippleY: R,
        rippleSize: _,
        cb: I
      });
    }, i.start(JS, () => {
      m.current && (m.current(), m.current = null);
    })) : E({
      pulsate: O,
      rippleX: B,
      rippleY: R,
      rippleSize: _,
      cb: I
    });
  }, [o, E, i]), y = Ue.useCallback(() => {
    S({}, {
      pulsate: !0
    });
  }, [S]), x = Ue.useCallback((b, u) => {
    if (i.clear(), (b == null ? void 0 : b.type) === "touchend" && m.current) {
      m.current(), m.current = null, i.start(0, () => {
        x(b, u);
      });
      return;
    }
    m.current = null, s((I) => I.length > 0 ? I.slice(1) : I), g.current = u;
  }, [i]);
  return Ue.useImperativeHandle(r, () => ({
    pulsate: y,
    start: S,
    stop: x
  }), [y, S, x]), /* @__PURE__ */ p.jsx(i_, zt({
    className: ji(er.root, l.root, d),
    ref: v
  }, c, {
    children: /* @__PURE__ */ p.jsx(Of, {
      component: null,
      exit: !0,
      children: f
    })
  }));
});
process.env.NODE_ENV !== "production" && (J2.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: Fe.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: Fe.object,
  /**
   * @ignore
   */
  className: Fe.string
});
function s_(e) {
  return bc("MuiButtonBase", e);
}
const a_ = F0("MuiButtonBase", ["root", "disabled", "focusVisible"]), o_ = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "touchRippleRef", "type"], c_ = (e) => {
  const {
    disabled: n,
    focusVisible: r,
    focusVisibleClassName: a,
    classes: o
  } = e, d = wf({
    root: ["root", n && "disabled", r && "focusVisible"]
  }, s_, o);
  return r && a && (d.root += ` ${a}`), d;
}, l_ = Zs("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, n) => n.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${a_.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), Ff = /* @__PURE__ */ Ue.forwardRef(function(n, r) {
  const a = D0({
    props: n,
    name: "MuiButtonBase"
  }), {
    action: o,
    centerRipple: l = !1,
    children: d,
    className: c,
    component: f = "button",
    disabled: s = !1,
    disableRipple: h = !1,
    disableTouchRipple: g = !1,
    focusRipple: t = !1,
    LinkComponent: i = "a",
    onBlur: m,
    onClick: v,
    onContextMenu: E,
    onDragLeave: S,
    onFocus: y,
    onFocusVisible: x,
    onKeyDown: b,
    onKeyUp: u,
    onMouseDown: I,
    onMouseLeave: O,
    onMouseUp: D,
    onTouchEnd: $,
    onTouchMove: K,
    onTouchStart: H,
    tabIndex: B = 0,
    TouchRippleProps: R,
    touchRippleRef: _,
    type: A
  } = a, k = Ti(a, o_), z = Ue.useRef(null), T = Ue.useRef(null), w = Da(T, _), {
    isFocusVisibleRef: F,
    onFocus: j,
    onBlur: P,
    ref: V
  } = X4(), [J, ne] = Ue.useState(!1);
  s && J && ne(!1), Ue.useImperativeHandle(o, () => ({
    focusVisible: () => {
      ne(!0), z.current.focus();
    }
  }), []);
  const [Z, te] = Ue.useState(!1);
  Ue.useEffect(() => {
    te(!0);
  }, []);
  const G = Z && !h && !s;
  Ue.useEffect(() => {
    J && t && !h && Z && T.current.pulsate();
  }, [h, t, J, Z]);
  function N(de, ge, me = g) {
    return Uc((xe) => (ge && ge(xe), !me && T.current && T.current[de](xe), !0));
  }
  const q = N("start", I), ie = N("stop", E), oe = N("stop", S), fe = N("stop", D), Y = N("stop", (de) => {
    J && de.preventDefault(), O && O(de);
  }), ae = N("start", H), se = N("stop", $), L = N("stop", K), W = N("stop", (de) => {
    P(de), F.current === !1 && ne(!1), m && m(de);
  }, !1), M = Uc((de) => {
    z.current || (z.current = de.currentTarget), j(de), F.current === !0 && (ne(!0), x && x(de)), y && y(de);
  }), X = () => {
    const de = z.current;
    return f && f !== "button" && !(de.tagName === "A" && de.href);
  }, U = Ue.useRef(!1), Q = Uc((de) => {
    t && !U.current && J && T.current && de.key === " " && (U.current = !0, T.current.stop(de, () => {
      T.current.start(de);
    })), de.target === de.currentTarget && X() && de.key === " " && de.preventDefault(), b && b(de), de.target === de.currentTarget && X() && de.key === "Enter" && !s && (de.preventDefault(), v && v(de));
  }), re = Uc((de) => {
    t && de.key === " " && T.current && J && !de.defaultPrevented && (U.current = !1, T.current.stop(de, () => {
      T.current.pulsate(de);
    })), u && u(de), v && de.target === de.currentTarget && X() && de.key === " " && !de.defaultPrevented && v(de);
  });
  let le = f;
  le === "button" && (k.href || k.to) && (le = i);
  const ce = {};
  le === "button" ? (ce.type = A === void 0 ? "button" : A, ce.disabled = s) : (!k.href && !k.to && (ce.role = "button"), s && (ce["aria-disabled"] = s));
  const ee = Da(r, V, z);
  process.env.NODE_ENV !== "production" && Ue.useEffect(() => {
    G && !T.current && console.error(["MUI: The `component` prop provided to ButtonBase is invalid.", "Please make sure the children prop is rendered in this custom component."].join(`
`));
  }, [G]);
  const he = zt({}, a, {
    centerRipple: l,
    component: f,
    disabled: s,
    disableRipple: h,
    disableTouchRipple: g,
    focusRipple: t,
    tabIndex: B,
    focusVisible: J
  }), pe = c_(he);
  return /* @__PURE__ */ p.jsxs(l_, zt({
    as: le,
    className: ji(pe.root, c),
    ownerState: he,
    onBlur: W,
    onClick: v,
    onContextMenu: ie,
    onFocus: M,
    onKeyDown: Q,
    onKeyUp: re,
    onMouseDown: q,
    onMouseLeave: Y,
    onMouseUp: fe,
    onDragLeave: oe,
    onTouchEnd: se,
    onTouchMove: L,
    onTouchStart: ae,
    ref: ee,
    tabIndex: s ? -1 : B,
    type: A
  }, ce, k, {
    children: [d, G ? (
      /* TouchRipple is only needed client-side, x2 boost on the server. */
      /* @__PURE__ */ p.jsx(J2, zt({
        ref: w,
        center: l
      }, R))
    ) : null]
  }));
});
process.env.NODE_ENV !== "production" && (Ff.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: vf,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: Fe.bool,
  /**
   * The content of the component.
   */
  children: Fe.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: Fe.object,
  /**
   * @ignore
   */
  className: Fe.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: P4,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: Fe.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: Fe.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: Fe.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: Fe.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: Fe.string,
  /**
   * @ignore
   */
  href: Fe.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: Fe.elementType,
  /**
   * @ignore
   */
  onBlur: Fe.func,
  /**
   * @ignore
   */
  onClick: Fe.func,
  /**
   * @ignore
   */
  onContextMenu: Fe.func,
  /**
   * @ignore
   */
  onDragLeave: Fe.func,
  /**
   * @ignore
   */
  onFocus: Fe.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: Fe.func,
  /**
   * @ignore
   */
  onKeyDown: Fe.func,
  /**
   * @ignore
   */
  onKeyUp: Fe.func,
  /**
   * @ignore
   */
  onMouseDown: Fe.func,
  /**
   * @ignore
   */
  onMouseLeave: Fe.func,
  /**
   * @ignore
   */
  onMouseUp: Fe.func,
  /**
   * @ignore
   */
  onTouchEnd: Fe.func,
  /**
   * @ignore
   */
  onTouchMove: Fe.func,
  /**
   * @ignore
   */
  onTouchStart: Fe.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: Fe.oneOfType([Fe.arrayOf(Fe.oneOfType([Fe.func, Fe.object, Fe.bool])), Fe.func, Fe.object]),
  /**
   * @default 0
   */
  tabIndex: Fe.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: Fe.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: Fe.oneOfType([Fe.func, Fe.shape({
    current: Fe.shape({
      pulsate: Fe.func.isRequired,
      start: Fe.func.isRequired,
      stop: Fe.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: Fe.oneOfType([Fe.oneOf(["button", "reset", "submit"]), Fe.string])
});
function u_(e) {
  return bc("MuiButton", e);
}
const Wc = F0("MuiButton", ["root", "text", "textInherit", "textPrimary", "textSecondary", "textSuccess", "textError", "textInfo", "textWarning", "outlined", "outlinedInherit", "outlinedPrimary", "outlinedSecondary", "outlinedSuccess", "outlinedError", "outlinedInfo", "outlinedWarning", "contained", "containedInherit", "containedPrimary", "containedSecondary", "containedSuccess", "containedError", "containedInfo", "containedWarning", "disableElevation", "focusVisible", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorSuccess", "colorError", "colorInfo", "colorWarning", "textSizeSmall", "textSizeMedium", "textSizeLarge", "outlinedSizeSmall", "outlinedSizeMedium", "outlinedSizeLarge", "containedSizeSmall", "containedSizeMedium", "containedSizeLarge", "sizeMedium", "sizeSmall", "sizeLarge", "fullWidth", "startIcon", "endIcon", "icon", "iconSizeSmall", "iconSizeMedium", "iconSizeLarge"]), eb = /* @__PURE__ */ Ue.createContext({});
process.env.NODE_ENV !== "production" && (eb.displayName = "ButtonGroupContext");
const tb = /* @__PURE__ */ Ue.createContext(void 0);
process.env.NODE_ENV !== "production" && (tb.displayName = "ButtonGroupButtonContext");
const d_ = ["children", "color", "component", "className", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"], h_ = (e) => {
  const {
    color: n,
    disableElevation: r,
    fullWidth: a,
    size: o,
    variant: l,
    classes: d
  } = e, c = {
    root: ["root", l, `${l}${Ri(n)}`, `size${Ri(o)}`, `${l}Size${Ri(o)}`, `color${Ri(n)}`, r && "disableElevation", a && "fullWidth"],
    label: ["label"],
    startIcon: ["icon", "startIcon", `iconSize${Ri(o)}`],
    endIcon: ["icon", "endIcon", `iconSize${Ri(o)}`]
  }, f = wf(c, u_, d);
  return zt({}, d, f);
}, nb = (e) => zt({}, e.size === "small" && {
  "& > *:nth-of-type(1)": {
    fontSize: 18
  }
}, e.size === "medium" && {
  "& > *:nth-of-type(1)": {
    fontSize: 20
  }
}, e.size === "large" && {
  "& > *:nth-of-type(1)": {
    fontSize: 22
  }
}), f_ = Zs(Ff, {
  shouldForwardProp: (e) => O2(e) || e === "classes",
  name: "MuiButton",
  slot: "Root",
  overridesResolver: (e, n) => {
    const {
      ownerState: r
    } = e;
    return [n.root, n[r.variant], n[`${r.variant}${Ri(r.color)}`], n[`size${Ri(r.size)}`], n[`${r.variant}Size${Ri(r.size)}`], r.color === "inherit" && n.colorInherit, r.disableElevation && n.disableElevation, r.fullWidth && n.fullWidth];
  }
})(({
  theme: e,
  ownerState: n
}) => {
  var r, a;
  const o = e.palette.mode === "light" ? e.palette.grey[300] : e.palette.grey[800], l = e.palette.mode === "light" ? e.palette.grey.A100 : e.palette.grey[700];
  return zt({}, e.typography.button, {
    minWidth: 64,
    padding: "6px 16px",
    borderRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create(["background-color", "box-shadow", "border-color", "color"], {
      duration: e.transitions.duration.short
    }),
    "&:hover": zt({
      textDecoration: "none",
      backgroundColor: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : zc(e.palette.text.primary, e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, n.variant === "text" && n.color !== "inherit" && {
      backgroundColor: e.vars ? `rgba(${e.vars.palette[n.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : zc(e.palette[n.color].main, e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, n.variant === "outlined" && n.color !== "inherit" && {
      border: `1px solid ${(e.vars || e).palette[n.color].main}`,
      backgroundColor: e.vars ? `rgba(${e.vars.palette[n.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : zc(e.palette[n.color].main, e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, n.variant === "contained" && {
      backgroundColor: e.vars ? e.vars.palette.Button.inheritContainedHoverBg : l,
      boxShadow: (e.vars || e).shadows[4],
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        boxShadow: (e.vars || e).shadows[2],
        backgroundColor: (e.vars || e).palette.grey[300]
      }
    }, n.variant === "contained" && n.color !== "inherit" && {
      backgroundColor: (e.vars || e).palette[n.color].dark,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (e.vars || e).palette[n.color].main
      }
    }),
    "&:active": zt({}, n.variant === "contained" && {
      boxShadow: (e.vars || e).shadows[8]
    }),
    [`&.${Wc.focusVisible}`]: zt({}, n.variant === "contained" && {
      boxShadow: (e.vars || e).shadows[6]
    }),
    [`&.${Wc.disabled}`]: zt({
      color: (e.vars || e).palette.action.disabled
    }, n.variant === "outlined" && {
      border: `1px solid ${(e.vars || e).palette.action.disabledBackground}`
    }, n.variant === "contained" && {
      color: (e.vars || e).palette.action.disabled,
      boxShadow: (e.vars || e).shadows[0],
      backgroundColor: (e.vars || e).palette.action.disabledBackground
    })
  }, n.variant === "text" && {
    padding: "6px 8px"
  }, n.variant === "text" && n.color !== "inherit" && {
    color: (e.vars || e).palette[n.color].main
  }, n.variant === "outlined" && {
    padding: "5px 15px",
    border: "1px solid currentColor"
  }, n.variant === "outlined" && n.color !== "inherit" && {
    color: (e.vars || e).palette[n.color].main,
    border: e.vars ? `1px solid rgba(${e.vars.palette[n.color].mainChannel} / 0.5)` : `1px solid ${zc(e.palette[n.color].main, 0.5)}`
  }, n.variant === "contained" && {
    color: e.vars ? (
      // this is safe because grey does not change between default light/dark mode
      e.vars.palette.text.primary
    ) : (r = (a = e.palette).getContrastText) == null ? void 0 : r.call(a, e.palette.grey[300]),
    backgroundColor: e.vars ? e.vars.palette.Button.inheritContainedBg : o,
    boxShadow: (e.vars || e).shadows[2]
  }, n.variant === "contained" && n.color !== "inherit" && {
    color: (e.vars || e).palette[n.color].contrastText,
    backgroundColor: (e.vars || e).palette[n.color].main
  }, n.color === "inherit" && {
    color: "inherit",
    borderColor: "currentColor"
  }, n.size === "small" && n.variant === "text" && {
    padding: "4px 5px",
    fontSize: e.typography.pxToRem(13)
  }, n.size === "large" && n.variant === "text" && {
    padding: "8px 11px",
    fontSize: e.typography.pxToRem(15)
  }, n.size === "small" && n.variant === "outlined" && {
    padding: "3px 9px",
    fontSize: e.typography.pxToRem(13)
  }, n.size === "large" && n.variant === "outlined" && {
    padding: "7px 21px",
    fontSize: e.typography.pxToRem(15)
  }, n.size === "small" && n.variant === "contained" && {
    padding: "4px 10px",
    fontSize: e.typography.pxToRem(13)
  }, n.size === "large" && n.variant === "contained" && {
    padding: "8px 22px",
    fontSize: e.typography.pxToRem(15)
  }, n.fullWidth && {
    width: "100%"
  });
}, ({
  ownerState: e
}) => e.disableElevation && {
  boxShadow: "none",
  "&:hover": {
    boxShadow: "none"
  },
  [`&.${Wc.focusVisible}`]: {
    boxShadow: "none"
  },
  "&:active": {
    boxShadow: "none"
  },
  [`&.${Wc.disabled}`]: {
    boxShadow: "none"
  }
}), p_ = Zs("span", {
  name: "MuiButton",
  slot: "StartIcon",
  overridesResolver: (e, n) => {
    const {
      ownerState: r
    } = e;
    return [n.startIcon, n[`iconSize${Ri(r.size)}`]];
  }
})(({
  ownerState: e
}) => zt({
  display: "inherit",
  marginRight: 8,
  marginLeft: -4
}, e.size === "small" && {
  marginLeft: -2
}, nb(e))), g_ = Zs("span", {
  name: "MuiButton",
  slot: "EndIcon",
  overridesResolver: (e, n) => {
    const {
      ownerState: r
    } = e;
    return [n.endIcon, n[`iconSize${Ri(r.size)}`]];
  }
})(({
  ownerState: e
}) => zt({
  display: "inherit",
  marginRight: -4,
  marginLeft: 8
}, e.size === "small" && {
  marginRight: -2
}, nb(e))), Or = /* @__PURE__ */ Ue.forwardRef(function(n, r) {
  const a = Ue.useContext(eb), o = Ue.useContext(tb), l = Nl(a, n), d = D0({
    props: l,
    name: "MuiButton"
  }), {
    children: c,
    color: f = "primary",
    component: s = "button",
    className: h,
    disabled: g = !1,
    disableElevation: t = !1,
    disableFocusRipple: i = !1,
    endIcon: m,
    focusVisibleClassName: v,
    fullWidth: E = !1,
    size: S = "medium",
    startIcon: y,
    type: x,
    variant: b = "text"
  } = d, u = Ti(d, d_), I = zt({}, d, {
    color: f,
    component: s,
    disabled: g,
    disableElevation: t,
    disableFocusRipple: i,
    fullWidth: E,
    size: S,
    type: x,
    variant: b
  }), O = h_(I), D = y && /* @__PURE__ */ p.jsx(p_, {
    className: O.startIcon,
    ownerState: I,
    children: y
  }), $ = m && /* @__PURE__ */ p.jsx(g_, {
    className: O.endIcon,
    ownerState: I,
    children: m
  }), K = o || "";
  return /* @__PURE__ */ p.jsxs(f_, zt({
    ownerState: I,
    className: ji(a.className, O.root, h, K),
    component: s,
    disabled: g,
    focusRipple: !i,
    focusVisibleClassName: ji(O.focusVisible, v),
    ref: r,
    type: x
  }, u, {
    classes: O,
    children: [D, c, $]
  }));
});
process.env.NODE_ENV !== "production" && (Or.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: Fe.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: Fe.object,
  /**
   * @ignore
   */
  className: Fe.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: Fe.oneOfType([Fe.oneOf(["inherit", "primary", "secondary", "success", "error", "info", "warning"]), Fe.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: Fe.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: Fe.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: Fe.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: Fe.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: Fe.bool,
  /**
   * Element placed after the children.
   */
  endIcon: Fe.node,
  /**
   * @ignore
   */
  focusVisibleClassName: Fe.string,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: Fe.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: Fe.string,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: Fe.oneOfType([Fe.oneOf(["small", "medium", "large"]), Fe.string]),
  /**
   * Element placed before the children.
   */
  startIcon: Fe.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: Fe.oneOfType([Fe.arrayOf(Fe.oneOfType([Fe.func, Fe.object, Fe.bool])), Fe.func, Fe.object]),
  /**
   * @ignore
   */
  type: Fe.oneOfType([Fe.oneOf(["button", "reset", "submit"]), Fe.string]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: Fe.oneOfType([Fe.oneOf(["contained", "outlined", "text"]), Fe.string])
});
function m_() {
  const {
    accounts: { getContactAccounts: e }
  } = Jt();
  return Sn({
    queryKey: ["accountsPaged"],
    queryFn: e
  });
}
function x_(e = "") {
  const {
    accounts: { getAccountOverview: n }
  } = Jt();
  return Sn({
    queryKey: ["account-overview", e],
    queryFn: n,
    enabled: !!e
  });
}
function ib() {
  const {
    accounts: { getAccountsOfContactOnTheBasisOfUserId: e }
  } = Jt();
  return Sn({
    queryKey: ["accounts-of-contact-on-the-basis-of-user-id"],
    queryFn: e
  });
}
function Pf(e) {
  const {
    accounts: { getAccountsOfContact: n }
  } = Jt();
  return Sn({
    queryKey: ["accounts-of-contact"],
    queryFn: () => n(String(e || ""))
  });
}
function b_(e) {
  const {
    accounts: { getAccountsAsTaskData: n }
  } = Jt();
  return Sn({
    queryKey: ["accounts-as-task-data"],
    queryFn: n,
    enabled: !e
  });
}
function y_(e, n) {
  const {
    accounts: { searchAccounts: r }
  } = Jt();
  return Sn({
    queryKey: ["searched-accounts", e],
    queryFn: r,
    enabled: !!e && !n
  });
}
const v_ = ({
  fixedToAccountId: e,
  fixedToContactId: n
}) => {
  var f;
  const { data: r } = m_(), a = !(r != null && r.count_data.all), {
    formState: { errors: o }
  } = Rr(), { field: l } = Vr({ name: "participants" }), d = Oe(
    (s) => {
      const g = (l.value || []).concat(s);
      l.onChange(g);
    },
    [l]
  ), c = Oe(
    (s) => {
      l.onChange([
        ...(l.value || []).slice(0, s),
        ...(l.value || []).slice(s + 1)
      ]);
    },
    [l]
  );
  return /* @__PURE__ */ p.jsx(
    gM,
    {
      fixedToAccountId: e,
      fixedToContactId: n,
      value: l.value,
      placeholder: "Select recipients",
      onAddElement: d,
      onRemoveElement: (s, h) => {
        c(h);
      },
      error: !!(o != null && o.participants),
      helperText: String((f = o == null ? void 0 : o.participants) == null ? void 0 : f.message),
      accountIsRequired: !a,
      shouldAddCSTMembers: !0
    }
  );
}, w_ = 10;
function rb({
  type: e,
  disabled: n,
  fixedToAccountId: r,
  fixedToContactId: a
}) {
  var d;
  const {
    register: o,
    formState: { errors: l }
  } = Rr();
  return e !== on.NewFile ? null : /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsx(
      gr,
      {
        control: /* @__PURE__ */ p.jsx(
          v_,
          {
            fixedToAccountId: r,
            fixedToContactId: a
          }
        ),
        label: "Recipients:",
        labelPlacement: "top"
      }
    ),
    /* @__PURE__ */ p.jsx(
      gr,
      {
        control: /* @__PURE__ */ p.jsx(
          vi,
          {
            ...o("message"),
            disabled: n,
            fullWidth: !0,
            multiline: !0,
            minRows: 5,
            maxRows: w_,
            placeholder: "Write a message...",
            error: !!(l != null && l.message),
            helperText: (d = l == null ? void 0 : l.message) == null ? void 0 : d.message
          }
        ),
        label: "Description:",
        labelPlacement: "top"
      }
    )
  ] });
}
const S_ = tt(Pe)(() => ({
  width: "50%",
  margin: "0 auto",
  textAlign: "center"
})), sb = ({
  disabled: e,
  isScannerDisabled: n
}) => {
  const [r, a] = Ee(!1), { setValue: o } = Rr(), { append: l } = Hh({ name: "files" }), { open: d } = Wf({
    onScan: (t) => {
      Hf(t).then((i) => {
        l(i);
      });
    }
  }), c = Oe(
    async (t, i) => {
      if (i.forEach(
        (m) => j2(m.file)
      ), t.length) {
        a(!0);
        const m = t.map(async (E) => {
          if (typeof E.arrayBuffer == "function") {
            const S = await E.arrayBuffer();
            return new File([S], E.name, { type: E.type });
          }
          return E;
        }), v = await Promise.all(m);
        a(!1), l([...v]);
      }
    },
    [l]
  );
  function f() {
    o("files", []);
  }
  const s = e, { getRootProps: h, getInputProps: g } = fc({
    onDrop: c,
    accept: vc
  });
  return /* @__PURE__ */ p.jsxs(S_, { children: [
    /* @__PURE__ */ p.jsx(mi, { open: !!r }),
    /* @__PURE__ */ p.jsxs(Or, { ...h(), variant: "outlined", children: [
      "Browse Files for Upload",
      /* @__PURE__ */ p.jsx(
        "input",
        {
          "data-testid": "file-upload-input",
          ...g(),
          disabled: s
        }
      )
    ] }),
    !n && /* @__PURE__ */ p.jsx(
      Or,
      {
        sx: { margin: "16px 0px" },
        variant: "outlined",
        onClick: d,
        disabled: e,
        children: "Open Document Scanner"
      }
    ),
    /* @__PURE__ */ p.jsx(Or, { onClick: f, children: "Clear Files" })
  ] });
}, __ = ({ src: e }) => /* @__PURE__ */ p.jsx(
  Pe,
  {
    sx: { height: "100%", position: "relative" },
    justifyContent: "center",
    alignItems: "center",
    children: /* @__PURE__ */ p.jsx("img", { src: e, alt: "file to upload", width: "100%" })
  }
), C_ = ({ fileType: e }) => /* @__PURE__ */ p.jsx(
  Pe,
  {
    sx: { height: "100%", position: "relative" },
    justifyContent: "center",
    alignItems: "center",
    children: /* @__PURE__ */ p.jsxs(Te, { variant: "body2", sx: { width: "75%", textAlign: "center" }, children: [
      'Preview is not available for files of type "',
      e,
      '"'
    ] })
  }
), A_ = ({
  open: e,
  file: n,
  closeFunction: r
}) => {
  var c;
  const [a, o] = Ee("");
  ot(() => {
    if (!n) return;
    if ("file_url" in n && n.file_url)
      return o(n.file_url);
    const f = new FileReader();
    f.addEventListener(
      "load",
      () => {
        o(f.result);
      },
      !1
    ), n instanceof File && f.readAsDataURL(n);
  }, [n]);
  const l = a && (n == null ? void 0 : n.type) === "application/pdf", d = a && ((c = n == null ? void 0 : n.type) == null ? void 0 : c.includes("image/"));
  return /* @__PURE__ */ p.jsx(ms, { open: e, children: /* @__PURE__ */ p.jsxs(Xr, { children: [
    /* @__PURE__ */ p.jsx(
      Kr,
      {
        onNavigationClick: r,
        title: n == null ? void 0 : n.name,
        DefaultStateElement: Ys,
        hideSecondaryActionButton: !0,
        position: "relative"
      }
    ),
    l && /* @__PURE__ */ p.jsx(no, { url: a }),
    d && /* @__PURE__ */ p.jsx(__, { src: a }),
    !d && !l && /* @__PURE__ */ p.jsx(C_, { fileType: n.type || "" })
  ] }) });
}, k_ = tt(Pe)({
  padding: "0px 20px 0px 20px",
  width: "100%",
  minHeight: "32px"
  // Reduced height
});
function E_({
  file: e,
  hideActions: n,
  onDeleteClick: r
}) {
  var c, f;
  const [a, o] = Ee(!1);
  if (!e) return null;
  const l = (c = e == null ? void 0 : e.type) == null ? void 0 : c.includes("application/pdf"), d = (f = e == null ? void 0 : e.type) == null ? void 0 : f.includes("image/");
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsxs(
      k_,
      {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center",
        children: [
          /* @__PURE__ */ p.jsxs(Pe, { direction: "row", alignItems: "center", textAlign: "left", spacing: 1, children: [
            /* @__PURE__ */ p.jsxs("div", { style: { fontSize: "14px", marginRight: "6px" }, children: [
              l && /* @__PURE__ */ p.jsx(it, { icon: "filePdf", sx: { fontSize: "16px" } }),
              d && /* @__PURE__ */ p.jsx(it, { icon: "fileImage", sx: { fontSize: "16px" } }),
              !l && !d && /* @__PURE__ */ p.jsx(it, { icon: "file", sx: { fontSize: "16px" } })
            ] }),
            /* @__PURE__ */ p.jsx(
              Te,
              {
                variant: "body2",
                onClick: () => o(!0),
                sx: {
                  fontSize: "13px",
                  cursor: "pointer",
                  "&:hover": {
                    textDecoration: "underline"
                  }
                },
                children: e.name
              }
            )
          ] }),
          !n && /* @__PURE__ */ p.jsxs(Pe, { direction: "row", spacing: 0.5, children: [
            /* @__PURE__ */ p.jsx(
              Gn,
              {
                onClick: () => o(!0),
                size: "small",
                sx: { padding: "4px" },
                children: /* @__PURE__ */ p.jsx(it, { icon: "preview", sx: { fontSize: "16px" } })
              }
            ),
            /* @__PURE__ */ p.jsx(
              Gn,
              {
                "data-testid": "delete-file-from-form",
                onClick: r,
                size: "small",
                sx: { padding: "4px" },
                children: /* @__PURE__ */ p.jsx(it, { icon: "delete", sx: { fontSize: "16px" } })
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ p.jsx(
      A_,
      {
        file: e,
        open: a,
        closeFunction: () => o(!1)
      }
    )
  ] });
}
const I_ = tt(Gh)(({ theme: e }) => ({
  color: e.palette.error.main,
  textAlign: "center"
}));
function ab({
  uploadProgressPercentMap: e,
  cancelUpload: n
}) {
  var s, h;
  const [r, a] = Ee(), {
    formState: { errors: o },
    watch: l
  } = Rr(), d = l("files"), { remove: c } = Hh({ name: "files" });
  if (!d || (d == null ? void 0 : d.length) === 0) return null;
  function f(g) {
    c(g);
  }
  return /* @__PURE__ */ p.jsxs(
    Pe,
    {
      direction: "column",
      spacing: 5,
      justifyContent: "center",
      alignItems: "center",
      children: [
        d.map((g, t) => {
          const i = d.length - 1 === t, m = e[Rl(g)], v = m > 0 && m < 100, E = Object.values(e || {}), S = E.every((y) => y === 100);
          return /* @__PURE__ */ p.jsxs(
            Pe,
            {
              direction: "row",
              sx: { width: "100%" },
              ref: (y) => {
                i && y && vx(y, "body-wrapper-overlay");
              },
              children: [
                /* @__PURE__ */ p.jsx(
                  E_,
                  {
                    hideActions: (E == null ? void 0 : E.length) > 0 && (v || S),
                    file: g,
                    onDeleteClick: () => {
                      a(t);
                    }
                  }
                ),
                v && /* @__PURE__ */ p.jsx(
                  Wh,
                  {
                    variant: "determinate",
                    value: m
                  }
                ),
                (E == null ? void 0 : E.length) > 0 && (v || S) && /* @__PURE__ */ p.jsxs(
                  Gn,
                  {
                    onClick: v ? () => n(g) : () => {
                    },
                    children: [
                      v && /* @__PURE__ */ p.jsx(it, { icon: "close", color: "primary" }),
                      S && /* @__PURE__ */ p.jsx(it, { icon: "success", color: "success" })
                    ]
                  }
                )
              ]
            },
            Rl(g)
          );
        }),
        (o == null ? void 0 : o.files) && /* @__PURE__ */ p.jsx(I_, { variant: "filled", children: (s = o == null ? void 0 : o.files) == null ? void 0 : s.message }),
        typeof r == "number" && /* @__PURE__ */ p.jsx(
          Yh,
          {
            open: typeof r == "number",
            onConfirm: () => {
              f(r), a(void 0);
            },
            onCancel: () => a(void 0),
            title: "Do you want to clear this file from the form?",
            content: (h = d[r]) == null ? void 0 : h.name,
            confirmLabel: "Clear file"
          }
        )
      ]
    }
  );
}
const mp = (/* @__PURE__ */ new Date()).getFullYear(), T_ = (e, n, r) => Array.from(
  {
    length: (n - e) / r + 1
  },
  (a, o) => e + o * r
), O_ = T_(
  mp,
  mp - 15,
  -1
).map((e) => ({ label: String(e), value: String(e) })), F_ = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
].map((e) => ({ label: e, value: e })), Vd = (e) => (n) => e ? n.label.toLowerCase().includes(e.toLowerCase()) : !0, ob = (e) => String(e.key ?? e.value ?? e.label), P_ = (e) => gs(ob(e), e.label), j_ = (e) => (n) => Vd(e)(n) || df(ob(n), e);
function R_(e, n) {
  var r;
  return {
    doc_ids: [e],
    year: n.upload_file_year || "",
    month: n.upload_file_month || "",
    // the tags form expects values in this format
    tags: (r = n.tags) == null ? void 0 : r.map((a) => ({
      value: a,
      label: a,
      key: a
    })),
    file_name: n.doc_name || ""
  };
}
function M_() {
  var E, S;
  const { data: e } = xr(), [n, r] = Ee(""), [a, o] = Ee(""), [l, d] = Ee(""), c = ((S = (E = e == null ? void 0 : e.data) == null ? void 0 : E.pref_type_options) == null ? void 0 : S.upload_tags) || [], f = F_.filter(Vd(n)), s = O_.filter(Vd(a)), h = c.filter(j_(l)), { getValues: g, setValue: t } = Rr(), { append: i, remove: m } = Hh({
    name: "tags"
  });
  function v(y) {
    if (!y) return t("tags", []);
    const { tags: x } = g();
    x.find(
      (u) => y.label === (u == null ? void 0 : u.label)
    ) || i(y);
  }
  return {
    handleTagsChange: v,
    removeTagByIndex: m,
    setMonthsFilter: r,
    setYearsFilter: o,
    setTagsFilter: d,
    monthsFilter: n,
    yearsFilter: a,
    tagsFilter: l,
    monthsOptions: f,
    yearsOptions: s,
    tagsOptions: h
  };
}
const D_ = ({
  placeholder: e = "Select",
  value: n,
  handleClick: r,
  getLabel: a = (o) => o.label
}) => Array.isArray(n) ? n.length === 0 ? /* @__PURE__ */ p.jsx(p.Fragment, { children: e }) : /* @__PURE__ */ p.jsx(p.Fragment, { children: n.map((o, l) => /* @__PURE__ */ p.jsx(
  fr,
  {
    onClick: (d) => r(d, l),
    label: a(o),
    sx: { margin: "5px" }
  },
  o.label
)) }) : /* @__PURE__ */ p.jsx(p.Fragment, { children: n && a(n) || e }), N_ = tt(Ei)(() => ({
  justifyContent: "flex-start",
  flexWrap: "wrap",
  textTransform: "none"
})), Ia = ({
  title: e,
  placeholder: n,
  value: r,
  data: a,
  onChange: o,
  onSearchChange: l,
  isLoading: d,
  searchString: c,
  searchDebounce: f = 500,
  renderItem: s,
  getLabel: h,
  handleChipClick: g,
  error: t,
  inlineError: i = !1,
  disabled: m,
  clearable: v = !0,
  btnProps: E = {},
  ...S
}) => {
  function y(B) {
    B.preventDefault(), B.stopPropagation(), B.nativeEvent.stopImmediatePropagation();
  }
  const [x, b] = Ee(!1), u = (B) => {
    y(B), b(!0);
  }, I = () => b(!1), O = (B) => !Array.isArray(B) && (B == null ? void 0 : B.value) || 1, D = s || ((B) => /* @__PURE__ */ p.jsx(Mn, { children: B && h ? h(B) : B == null ? void 0 : B.label })), $ = (B) => {
    o(B), I();
  }, K = (B) => {
    y(B), o(null);
  };
  function H(B, R) {
    if (y(B), g) return g(R);
  }
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsxs(Pe, { children: [
      /* @__PURE__ */ p.jsxs(
        Pe,
        {
          direction: "row",
          justifyContent: "space-between",
          flexGrow: 1,
          ...S,
          children: [
            /* @__PURE__ */ p.jsx(
              N_,
              {
                endIcon: /* @__PURE__ */ p.jsx(it, { icon: "caretDown" }),
                size: "large",
                disabled: m,
                onClick: u,
                ...E,
                children: /* @__PURE__ */ p.jsx(
                  D_,
                  {
                    placeholder: n,
                    value: r,
                    handleClick: H,
                    getLabel: h
                  }
                )
              }
            ),
            t && !i && /* @__PURE__ */ p.jsx(Kh, { title: t.message, children: /* @__PURE__ */ p.jsx(Si, { color: "error", children: /* @__PURE__ */ p.jsx(it, { icon: "error" }) }) }),
            r && !m && v && /* @__PURE__ */ p.jsx(
              Si,
              {
                "aria-label": "clear-select",
                onClick: K,
                edge: "end",
                size: "small",
                children: /* @__PURE__ */ p.jsx(it, { icon: "clear" })
              }
            )
          ]
        }
      ),
      t && i && /* @__PURE__ */ p.jsx(Gh, { error: !0, children: t.message })
    ] }),
    /* @__PURE__ */ p.jsx(
      k6,
      {
        open: x,
        closeFunction: I,
        data: a,
        keyExtractor: O,
        onSearchChange: l,
        onSelect: $,
        title: e,
        renderItem: D,
        isLoading: d,
        searchString: c,
        searchDebounce: f
      }
    )
  ] });
}, cB = ({
  name: e,
  control: n,
  data: r,
  ...a
}) => {
  const { field: o } = Vr({ name: e, control: n }), l = Tt(
    () => r.find((d) => d.value === o.value),
    [o.value, r]
  );
  return /* @__PURE__ */ p.jsx(
    Ia,
    {
      ...a,
      data: r,
      value: l,
      onChange: (d) => o.onChange(d == null ? void 0 : d.value)
    }
  );
}, lB = ({
  avatar: e,
  initials: n,
  label: r
}) => /* @__PURE__ */ p.jsxs(Me, { display: "flex", flexDirection: "row", alignItems: "center", children: [
  /* @__PURE__ */ p.jsx(Me, { children: /* @__PURE__ */ p.jsx(Xs, { src: e, children: n }) }),
  /* @__PURE__ */ p.jsx(Me, { ml: 4, children: /* @__PURE__ */ p.jsx(Yy, { children: r }) })
] }), qc = tt(gr)({
  alignItems: "center"
});
function cb({
  type: e,
  disabled: n
}) {
  var x;
  const {
    register: r,
    setValue: a,
    watch: o,
    formState: { errors: l }
  } = Rr(), {
    handleTagsChange: d,
    removeTagByIndex: c,
    setMonthsFilter: f,
    setYearsFilter: s,
    setTagsFilter: h,
    monthsFilter: g,
    yearsFilter: t,
    tagsFilter: i,
    monthsOptions: m,
    yearsOptions: v,
    tagsOptions: E
  } = M_(), S = o("file_name"), y = e === on.Edit;
  return e === on.Workflow ? null : /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    y && /* @__PURE__ */ p.jsx(
      qc,
      {
        control: /* @__PURE__ */ p.jsx(
          qs,
          {
            ...r("file_name"),
            disabled: n,
            error: !!(l != null && l.file_name),
            helperText: (x = l == null ? void 0 : l.file_name) == null ? void 0 : x.message
          }
        ),
        label: "Filename",
        labelPlacement: "top",
        value: S
      }
    ),
    /* @__PURE__ */ p.jsx(
      qc,
      {
        sx: {
          width: "100%",
          display: "flex",
          alignItems: "center"
        },
        control: /* @__PURE__ */ p.jsx(
          Ia,
          {
            disabled: n,
            error: l == null ? void 0 : l.year,
            title: "Year",
            data: v,
            onSearchChange: s,
            onChange: (b) => a("year", (b == null ? void 0 : b.value) || ""),
            searchString: t
          }
        ),
        label: "Year",
        labelPlacement: "top",
        value: o("year") ? { label: o("year") } : ""
      }
    ),
    /* @__PURE__ */ p.jsx(
      qc,
      {
        control: /* @__PURE__ */ p.jsx(
          Ia,
          {
            disabled: n,
            error: l == null ? void 0 : l.month,
            title: "Month",
            data: m,
            onSearchChange: f,
            onChange: (b) => a("month", (b == null ? void 0 : b.value) || ""),
            searchString: g
          }
        ),
        label: "Month",
        labelPlacement: "top",
        value: o("month") ? { label: o("month") } : ""
      }
    ),
    !y && /* @__PURE__ */ p.jsx(
      qc,
      {
        control: /* @__PURE__ */ p.jsx(
          Ia,
          {
            disabled: n,
            title: "Tags",
            data: E,
            getLabel: P_,
            error: l == null ? void 0 : l.tags,
            onSearchChange: h,
            onChange: d,
            handleChipClick: c,
            searchString: i
          }
        ),
        label: "Tags",
        labelPlacement: "top",
        value: o("tags") || []
      }
    )
  ] });
}
const lb = Jr(void 0), uB = ({
  children: e,
  ...n
}) => /* @__PURE__ */ p.jsx(lb.Provider, { value: n, children: e }), _s = () => {
  const e = Nn.useContext(lb);
  if (!e)
    throw new Error("useAppRoutes must be used within a AppRoutesProvider");
  return e;
}, L_ = {
  [on.NewFile]: cs.NewFile,
  [on.MessageThread]: cs.Message,
  [on.NewMessage]: cs.Message,
  [on.Task]: cs.Task,
  [on.Invoice]: cs.Invoice,
  [on.Workflow]: cs.Workflow
};
function ub({
  onNavigationClick: e,
  type: n,
  onFileUpload: r,
  taskId: a,
  isDraft: o
}) {
  var A;
  const { data: l } = xr(), d = Ki(), { mutateAsync: c, isLoading: f } = Vx({ taskId: a, isDraft: o }), { mutateAsync: s, isLoading: h } = w6(), { mutateAsync: g, isLoading: t } = Xx(), { mutateAsync: i, isLoading: m } = v6(), { getValues: v, watch: E, setValue: S, formState: y } = Rr(), [x, b] = Ee({}), [u, I] = Ee({}), O = n === on.Edit, D = n === on.NewFile || n === on.Workflow, { filesDetail: $ } = _s();
  async function K() {
    var z;
    const k = v();
    await i(
      {
        ...v(),
        year: Number(k.year),
        multi_tags: k == null ? void 0 : k.tags.map((T) => T.label),
        document_ids: Number((z = k == null ? void 0 : k.doc_ids) == null ? void 0 : z[0]),
        file_name: [k.file_name, k.file_extension].filter(Boolean).join(".")
      },
      {
        onSuccess: () => {
          var T;
          if (e)
            e("go:back");
          else {
            const w = (T = k == null ? void 0 : k.doc_ids) == null ? void 0 : T[0];
            d(($ == null ? void 0 : $.link({ id: `${w}` })) ?? "");
          }
        }
      }
    );
  }
  function H(k) {
    if (!k) return;
    const z = Rl(k);
    x[z].abort(), delete x[z], delete u[z], I({ ...u }), b({ ...x });
    const { files: T } = v(), F = Array.from(T).filter(
      (j) => Rl(j) !== z
    );
    S("files", F);
  }
  async function B(k) {
    var Z, te;
    const z = L_[n], T = await g({
      documents: k.files,
      taskId: a,
      uploadType: z,
      setCancelController: b,
      onUploadProgress: I
    }), w = F2(
      T,
      k.files
    ), F = (T == null ? void 0 : T.filter(({ data: G }) => !!G.data).map(
      ({ data: G }) => G.data
    )) || [], j = F.map((G) => G.id), P = k.files.filter(
      (G, N) => !(w != null && w.includes(N))
    ), V = {
      ...k,
      files: P
    }, J = {
      doc_ids: j,
      formValues: {
        ...V,
        id: a
      },
      isMessageAltered: !!((Z = y == null ? void 0 : y.touchedFields) != null && Z.message)
    }, ne = D ? await s(J) : await c(J);
    ((te = ne == null ? void 0 : ne.doc_ids) == null ? void 0 : te.length) !== 0 && (r && r(
      // TODO: fix this typing, outside the scope of this ticket. No idea why this was working before.
      // https://liscio.atlassian.net/browse/DEV-3565
      // eslint-disable-next-line
      // @ts-ignore
      n === on.Workflow ? F || [] : j || [],
      V
    ), e("go:back"));
  }
  async function R(k) {
    try {
      O ? await K() : await B(k);
    } catch (z) {
      rn.error(
        z instanceof Error && z.message ? z.message : "Unable to upload document"
      );
    } finally {
      I({});
    }
  }
  const _ = O ? !1 : f || h || ((A = E("files")) == null ? void 0 : A.length) === 0;
  return ot(() => {
    var T;
    const { message: k, files: z } = v();
    if (z.length && (!y.touchedFields.message || !k)) {
      const w = z.map((F) => ({
        ...F,
        doc_name: F.name
      }));
      S(
        "message",
        CC(
          w,
          (T = l == null ? void 0 : l.data) == null ? void 0 : T.uname
        )
      );
    }
  }, [S, l, y, v]), {
    disableSubmit: _,
    filesAreUploading: f || h || t,
    isEditView: O,
    fileUpdating: m,
    onSubmit: R,
    uploadProgressPercentMap: u,
    cancelUpload: H
  };
}
const B_ = tt(Me)(() => ({
  margin: "25px 0px 0px 0px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center"
})), $_ = tt("form")({
  display: "flex",
  flexGrow: "1",
  flexDirection: "column",
  overflow: "scroll"
});
function db({
  fileId: e,
  onNavigationClick: n,
  type: r,
  onFileUpload: a,
  taskId: o,
  fixedToAccountId: l,
  fixedToContactId: d,
  isScannerDisabled: c
}) {
  const {
    disableSubmit: f,
    filesAreUploading: s,
    isEditView: h,
    fileUpdating: g,
    onSubmit: t,
    uploadProgressPercentMap: i,
    cancelUpload: m
  } = ub({
    onNavigationClick: n,
    type: r,
    onFileUpload: a,
    fileId: e,
    taskId: o
  }), {
    handleSubmit: v,
    formState: { errors: E }
  } = Rr(), S = Object.values(i || {}), x = S.length > 0 && S.every((b) => b === 100) || g;
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsx(mi, { open: x }),
    /* @__PURE__ */ p.jsxs($_, { onSubmit: v(t), children: [
      /* @__PURE__ */ p.jsx(
        Ya,
        {
          sx: { padding: "16px 8px 8px 8px" },
          display: "flex",
          flexDirection: "column",
          id: "body-wrapper-overlay",
          children: /* @__PURE__ */ p.jsxs(Pe, { gap: "8px", children: [
            /* @__PURE__ */ p.jsx(
              rb,
              {
                type: r,
                disabled: s,
                fixedToAccountId: l,
                fixedToContactId: d
              }
            ),
            /* @__PURE__ */ p.jsx(cb, { type: r, disabled: s }),
            !h && /* @__PURE__ */ p.jsx(
              sb,
              {
                isScannerDisabled: c,
                disabled: s
              }
            ),
            /* @__PURE__ */ p.jsx(B_, { children: /* @__PURE__ */ p.jsx(
              ab,
              {
                errors: E,
                uploadProgressPercentMap: i,
                cancelUpload: m
              }
            ) })
          ] })
        }
      ),
      /* @__PURE__ */ p.jsx(Zh, { children: /* @__PURE__ */ p.jsx(
        Or,
        {
          variant: "contained",
          type: "submit",
          fullWidth: !0,
          disabled: f,
          children: h ? "Edit file" : "Add attachment"
        }
      ) })
    ] })
  ] });
}
const U_ = tt(Me)(() => ({
  margin: "25px 0px 0px 0px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center"
})), z_ = tt("div")({
  display: "flex",
  flexGrow: "1",
  flexDirection: "column",
  overflow: "scroll"
});
function hb({
  fileId: e,
  onNavigationClick: n,
  type: r,
  onFileUpload: a,
  taskId: o,
  fixedToAccountId: l,
  isScannerDisabled: d
}) {
  const {
    disableSubmit: c,
    filesAreUploading: f,
    isEditView: s,
    fileUpdating: h,
    onSubmit: g,
    uploadProgressPercentMap: t,
    cancelUpload: i
  } = ub({
    onNavigationClick: n,
    type: r,
    onFileUpload: a,
    fileId: e,
    taskId: o,
    isDraft: !1
  }), {
    handleSubmit: m,
    formState: { errors: v }
  } = Rr(), E = Object.values(t || {}), y = E.length > 0 && E.every((x) => x === 100) || h;
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsx(mi, { open: y }),
    /* @__PURE__ */ p.jsxs(z_, { children: [
      /* @__PURE__ */ p.jsx(Ya, { sx: { padding: "16px 8px 8px 8px" }, children: /* @__PURE__ */ p.jsxs(Pe, { gap: "8px", children: [
        /* @__PURE__ */ p.jsx(
          rb,
          {
            type: r,
            disabled: f,
            fixedToAccountId: l
          }
        ),
        /* @__PURE__ */ p.jsx(cb, { type: r, disabled: f }),
        !s && /* @__PURE__ */ p.jsx(
          sb,
          {
            isScannerDisabled: d,
            disabled: f
          }
        ),
        /* @__PURE__ */ p.jsx(U_, { children: /* @__PURE__ */ p.jsx(
          ab,
          {
            errors: v,
            uploadProgressPercentMap: t,
            cancelUpload: i
          }
        ) })
      ] }) }),
      /* @__PURE__ */ p.jsx(Zh, { children: /* @__PURE__ */ p.jsx(
        Or,
        {
          variant: "contained",
          fullWidth: !0,
          disabled: c,
          onClick: () => m(g)(),
          children: "Add File"
        }
      ) })
    ] })
  ] });
}
function H_(e, n) {
  var r, a, o;
  return n ? (e == null ? void 0 : e.source) === "Message" ? (r = n.messagesDetail) == null ? void 0 : r.link({ id: (e == null ? void 0 : e.link) ?? "" }) : (e == null ? void 0 : e.source) === "Task" ? (a = n.tasksDetail) == null ? void 0 : a.link({ id: (e == null ? void 0 : e.link) ?? "" }) : (e == null ? void 0 : e.source) === "Bill" ? (o = n.invoicesDetail) == null ? void 0 : o.link({ id: (e == null ? void 0 : e.link) ?? "" }) : "" : "";
}
const W_ = tt(Zy)(({ theme: e }) => ({
  zIndex: e.zIndex.modal + 1,
  "& .MuiDrawer-paper": {
    padding: "16px 12px",
    backgroundColor: e.palette.common.white,
    color: e.palette.grey[800]
  }
})), q_ = ({
  file: e,
  open: n,
  onClose: r,
  closeFilePreviewFunction: a,
  canMutateFile: o = !0
}) => {
  var S, y;
  const l = Mr(), [d, c] = Ee(!1), [f, s] = Ee(!1), [h, g] = Ee(!1), { isLoading: t } = Z2(), i = _s();
  async function m() {
    const { onSuccess: x, onError: b } = P2(
      (e == null ? void 0 : e.doc_name) || "Your file"
    );
    g(!0), e && await Tb(e).then(x).catch(b), g(!1);
  }
  const v = e == null ? void 0 : e.is_file_archived_by_contact, E = H_(e, i);
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsxs(W_, { anchor: "bottom", open: n, onClose: r, children: [
      !e && /* @__PURE__ */ p.jsx(u0, {}),
      !!e && /* @__PURE__ */ p.jsxs(Pe, { gap: "8px", children: [
        /* @__PURE__ */ p.jsxs(Pe, { direction: "row", justifyContent: "space-between", children: [
          /* @__PURE__ */ p.jsxs(ks, { children: [
            /* @__PURE__ */ p.jsx(it, { icon: "copy", htmlColor: l.palette.grey[500] }),
            /* @__PURE__ */ p.jsxs(Me, { children: [
              /* @__PURE__ */ p.jsx(Te, { variant: "body2", sx: { wordBreak: "break-all" }, children: e == null ? void 0 : e.doc_name }),
              /* @__PURE__ */ p.jsxs(Te, { variant: "caption", children: [
                "by ",
                (S = e == null ? void 0 : e.uploader) == null ? void 0 : S.name,
                " • ",
                e == null ? void 0 : e.date_created
              ] })
            ] })
          ] }),
          /* @__PURE__ */ p.jsx(Gn, { onClick: m, children: /* @__PURE__ */ p.jsx(it, { icon: "download" }) })
        ] }),
        /* @__PURE__ */ p.jsx(wn, {}),
        /* @__PURE__ */ p.jsxs(ks, { children: [
          /* @__PURE__ */ p.jsx(ra, { children: "ASSOCIATED WITH" }),
          /* @__PURE__ */ p.jsx(Me, { children: (y = e == null ? void 0 : e.recipient) == null ? void 0 : y.map((x) => /* @__PURE__ */ p.jsx(
            FS,
            {
              recipient: x
            },
            x.name
          )) })
        ] }),
        /* @__PURE__ */ p.jsx(wn, {}),
        /* @__PURE__ */ p.jsxs(ks, { children: [
          /* @__PURE__ */ p.jsx(ra, { children: "SOURCE" }),
          /* @__PURE__ */ p.jsx(Te, { children: e != null && e.link ? /* @__PURE__ */ p.jsx(Ex, { to: E, children: e == null ? void 0 : e.source }) : /* @__PURE__ */ p.jsx(Te, { children: e == null ? void 0 : e.source }) })
        ] }),
        /* @__PURE__ */ p.jsxs(ks, { children: [
          /* @__PURE__ */ p.jsx(ra, { children: "DATE ADDED" }),
          /* @__PURE__ */ p.jsx(Te, { children: e == null ? void 0 : e.date_created })
        ] }),
        /* @__PURE__ */ p.jsxs(ks, { children: [
          /* @__PURE__ */ p.jsx(ra, { children: "YEAR" }),
          /* @__PURE__ */ p.jsx(Te, { children: e == null ? void 0 : e.upload_file_year })
        ] }),
        /* @__PURE__ */ p.jsxs(ks, { children: [
          /* @__PURE__ */ p.jsx(ra, { children: "MONTH" }),
          /* @__PURE__ */ p.jsx(Te, { children: e == null ? void 0 : e.upload_file_month })
        ] }),
        /* @__PURE__ */ p.jsxs(ks, { children: [
          /* @__PURE__ */ p.jsx(ra, { children: "TAGS" }),
          /* @__PURE__ */ p.jsx(Me, { children: /* @__PURE__ */ p.jsx(p5, { tags: (e == null ? void 0 : e.tags) || [], getLabel: gs }) })
        ] }),
        /* @__PURE__ */ p.jsx(wn, {}),
        /* @__PURE__ */ p.jsxs(Me, { children: [
          o && /* @__PURE__ */ p.jsx(
            lt,
            {
              startIcon: /* @__PURE__ */ p.jsx(it, { icon: "edit" }),
              onClick: () => {
                r(), s(!0);
              },
              children: "Edit File Details (Tags, File Name, etc.)"
            }
          ),
          o && /* @__PURE__ */ p.jsx(
            lt,
            {
              startIcon: /* @__PURE__ */ p.jsx(it, { icon: "archive" }),
              onClick: () => {
                r(), c(!0);
              },
              children: v ? "Unarchive File" : "Archive File"
            }
          ),
          /* @__PURE__ */ p.jsx(
            lt,
            {
              startIcon: /* @__PURE__ */ p.jsx(it, { icon: "download" }),
              onClick: m,
              children: "Download"
            }
          )
        ] })
      ] })
    ] }),
    o && (e == null ? void 0 : e.id) && /* @__PURE__ */ p.jsx(
      S6,
      {
        id: e == null ? void 0 : e.id,
        open: d,
        closeFunction: () => c(!1),
        onSuccess: a,
        isFileArchived: v
      }
    ),
    /* @__PURE__ */ p.jsx(ms, { open: o && f, children: (e == null ? void 0 : e.id) && /* @__PURE__ */ p.jsx(
      sL,
      {
        fileId: e != null && e.id ? String(e == null ? void 0 : e.id) : void 0,
        formData: R_(e == null ? void 0 : e.id, e),
        goBack: () => {
          s(!1);
        },
        type: on.Edit
      }
    ) }),
    /* @__PURE__ */ p.jsx(mi, { open: t || h })
  ] });
};
let ua;
const dB = ({
  captureCompany: e
} = {}) => {
  const n = Ki(), r = {
    adobeEsignSuccess: "esign-interstitials/delivery-signature-success?"
  }, a = Oe(
    async (o) => {
      const l = new URL(o.url), d = new URLSearchParams(l.search);
      e && d.set("company_name", l.hostname);
      const c = d.toString() ? `?${d.toString()}` : "", f = `${l.pathname}${c}`;
      if (f.includes(r.adobeEsignSuccess)) {
        await kx.close();
        return;
      } else
        n(f);
    },
    [e, r.adobeEsignSuccess, n]
  );
  ot(() => ((async () => {
    ua || (ua = await Go.addListener(
      "appUrlOpen",
      a
    ));
  })(), () => {
    ua == null || ua.remove(), ua = void 0;
  }));
};
let xp = !1;
const hB = (e = !1) => {
  const n = "shouldReloadLiveUpdate", r = "blockLiveUpdateReload", a = async () => {
    try {
      return (await Sa.get({ key: n })).value === "true";
    } catch {
    }
  }, o = async (f) => {
    await Sa.set({
      key: n,
      value: JSON.stringify(f)
    });
  }, l = async () => {
    try {
      return (await Sa.get({ key: r })).value === "true";
    } catch {
    }
  }, d = async (f) => {
    await Sa.set({
      key: r,
      value: JSON.stringify(f)
    });
  }, c = Oe(async () => {
    if (On.isNativePlatform())
      if (await a())
        await l() || (o(!1), await w1.reload());
      else {
        const s = await w1.sync();
        await o(s.activeApplicationPathChanged);
      }
  }, [a, o]);
  return ot(() => {
    const f = async () => {
      xp || (xp = !0, c(), await Go.addListener("resume", c));
    };
    On.isNativePlatform() && !e && f();
  }), {
    setBlockReload: d
  };
};
function fb({
  pageParam: e = 1,
  sortField: n,
  sortOrder: r,
  all: a,
  enabled: o = !0
}) {
  const {
    notifications: { getNotifications: l }
  } = Jt(), d = [
    "notifications",
    String(e),
    r || "",
    n || "",
    a ? "true" : "false"
  ];
  return Sn({
    queryKey: d,
    queryFn: () => l({ pageParam: e, queryKey: d }),
    enabled: o
  });
}
const V_ = (e) => {
  const n = qn(), {
    notifications: { markAllRead: r }
  } = Jt();
  return Ln({
    mutationFn: r,
    onSuccess: () => {
      e != null && e.onSuccess && e.onSuccess(), n.invalidateQueries(["notifications"]);
    }
  });
}, pb = (e) => {
  const n = qn(), {
    notifications: { viewNotification: r }
  } = Jt();
  return Ln({
    mutationFn: r,
    onSuccess: () => {
      n.invalidateQueries(["notifications"]);
    }
  });
}, X_ = () => {
  const {
    devices: { addDevice: e }
  } = Jt();
  return Ln({
    mutationFn: e
  });
}, jf = (e) => {
  const {
    auth: { cpaAuthorizationV5WithTemporaryAuthToken: n }
  } = Jt();
  return Ln({
    mutationFn: n,
    onSuccess: async (r) => {
      e != null && e.onSuccess && e.onSuccess(r);
    },
    onError: (r) => {
      e != null && e.onError && e.onError(r);
    }
  });
}, gb = (e) => {
  const {
    auth: { postApiV5AuthMfaSetupsWithTemporaryAuthToken: n }
  } = Jt();
  return Ln({
    mutationFn: n,
    onSuccess: async (r) => {
      e != null && e.onSuccess && e.onSuccess(r);
    },
    onError: (r) => {
      e != null && e.onError && e.onError(r);
    }
  });
}, mb = (e) => {
  const {
    auth: { patchApiV5AuthMfaSetupsWithTemporaryAuthToken: n }
  } = Jt();
  return Ln({
    mutationFn: n,
    onSuccess: async (r) => {
      e != null && e.onSuccess && e.onSuccess(r);
    },
    onError: (r) => {
      e != null && e.onError && e.onError(r);
    }
  });
}, G_ = (e) => {
  const {
    auth: { passwordResetsIdV5WithTemporaryAuthToken: n }
  } = Jt();
  return Ln({
    mutationFn: n,
    onSuccess: async (r) => {
      e != null && e.onSuccess && e.onSuccess(r);
    }
  });
}, xb = (e) => {
  const {
    auth: { postMfaV5WithTemporaryAuthToken: n }
  } = Jt();
  return Ln({
    mutationFn: n,
    onSuccess: async (r) => {
      e != null && e.onSuccess && e.onSuccess(r);
    },
    onError: (r) => {
      e != null && e.onError && e.onError(r);
    }
  });
}, K_ = ({
  token: e,
  cpaId: n,
  onSuccess: r
}) => Sn({
  queryKey: ["magicLinkValidation", e, n],
  queryFn: () => {
    const a = n != null && n !== "" ? { cpa_id: parseInt(n, 10) } : {};
    return e8(e, a).then((o) => (r && r(o), o));
  },
  // A rejected link stays rejected: retry only network and server errors.
  retry: (a, o) => a < 3 && (rf(o) ?? 500) >= 500
}), Y_ = async (e = () => {
}) => {
  On.isNativePlatform() && (Rs.addListener("registration", async (n) => {
    try {
      await e(n.value);
    } catch (r) {
      console.log("Unable to save device_id", r);
    }
  }), Rs.addListener("registrationError", (n) => {
    console.log("Token Registration error:", n.error);
  }), Rs.requestPermissions().then((n) => {
    n.receive === "granted" && Rs.register();
  }));
}, fB = ({
  isLoggedIn: e
}) => {
  const { mutateAsync: n } = X_();
  ot(() => (e && Y_(n), () => {
    On.isNativePlatform() && Rs.removeAllListeners();
  }), [n, e]);
}, pB = () => {
  Pa(() => (On.isNativePlatform() && Rs.removeAllDeliveredNotifications(), Go.addListener("appStateChange", ({ isActive: e }) => {
    e && On.isNativePlatform() && Rs.removeAllDeliveredNotifications();
  }), () => {
    Go.removeAllListeners();
  }), []);
}, Z_ = (e) => {
  const [n, r] = Ee(!0), [a, o] = Ee(), [l, d] = Ee();
  return ot(() => {
    const c = new FileReader();
    c.addEventListener("load", () => {
      r(!1), d(c.result);
    }), c.addEventListener("error", () => {
      r(!1), o(c.error);
    }), c.readAsDataURL(e);
  }, [r, d, o]), {
    isReading: n,
    dataURL: l,
    error: a
  };
};
function gB() {
  const { data: e } = fb({
    pageParam: 1,
    sortField: "id",
    sortOrder: "dsc"
  });
  return {
    notifications: e == null ? void 0 : e.pagination.count
  };
}
const bb = "liscio_v5_signin_tab_v1";
function Q_(e) {
  return e === "magicLink" || e === "password";
}
function yb() {
  if (typeof window > "u" || !window.localStorage)
    return null;
  try {
    const e = window.localStorage.getItem(bb);
    return Q_(e) ? e : null;
  } catch {
    return null;
  }
}
function J_(e) {
  const n = yb();
  return n ? { tab: n, source: "storage" } : { tab: e, source: "default" };
}
function mB(e) {
  const [n, r] = Ee(
    () => J_(e).tab
  ), a = Oe((o) => {
    var l;
    r(o);
    try {
      (l = window.localStorage) == null || l.setItem(bb, o);
    } catch {
    }
  }, []);
  return { activeTab: n, setActiveTab: a };
}
function xB(e) {
  return yb() ?? e;
}
const Iu = "remember_me_email", eC = () => {
  const [e, n] = Ee(!0), [r, a] = Ee(""), o = Oe(
    async (d) => {
      await ir.set({
        key: Iu,
        value: d
      }), a(d);
    },
    [a]
  ), l = Oe(async () => {
    try {
      await ir.remove({ key: Iu }), a("");
    } catch {
    }
  }, [a]);
  return ot(() => {
    (async () => {
      try {
        const { value: c } = await ir.get({
          key: Iu
        });
        c && a(c);
      } catch {
      }
      n(!1);
    })();
  }, [a, n]), {
    isLoading: e,
    email: r,
    rememberEmail: o,
    forgetEmail: l
  };
};
function _r(e) {
  const n = new Uint8Array(e);
  let r = "";
  for (const o of n)
    r += String.fromCharCode(o);
  return btoa(r).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
function Bl(e) {
  const n = e.replace(/-/g, "+").replace(/_/g, "/"), r = (4 - n.length % 4) % 4, a = n.padEnd(n.length + r, "="), o = atob(a), l = new ArrayBuffer(o.length), d = new Uint8Array(l);
  for (let c = 0; c < o.length; c++)
    d[c] = o.charCodeAt(c);
  return l;
}
function Sc() {
  return tC.stubThis((globalThis == null ? void 0 : globalThis.PublicKeyCredential) !== void 0 && typeof globalThis.PublicKeyCredential == "function");
}
const tC = {
  stubThis: (e) => e
};
function vb(e) {
  const { id: n } = e;
  return {
    ...e,
    id: Bl(n),
    /**
     * `descriptor.transports` is an array of our `AuthenticatorTransportFuture` that includes newer
     * transports that TypeScript's DOM lib is ignorant of. Convince TS that our list of transports
     * are fine to pass to WebAuthn since browsers will recognize the new value.
     */
    transports: e.transports
  };
}
function wb(e) {
  return (
    // Consider localhost valid as well since it's okay wrt Secure Contexts
    e === "localhost" || // Support punycode (ACE) or ascii labels and domains
    /^((xn--[a-z0-9-]+|[a-z0-9]+(-[a-z0-9]+)*)\.)+([a-z]{2,}|xn--[a-z0-9-]+)$/i.test(e)
  );
}
class di extends Error {
  constructor({ message: n, code: r, cause: a, name: o }) {
    super(n, { cause: a }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.name = o ?? a.name, this.code = r;
  }
}
function nC({ error: e, options: n }) {
  var a, o, l;
  const { publicKey: r } = n;
  if (!r)
    throw Error("options was missing required publicKey property");
  if (e.name === "AbortError") {
    if (n.signal instanceof AbortSignal)
      return new di({
        message: "Registration ceremony was sent an abort signal",
        code: "ERROR_CEREMONY_ABORTED",
        cause: e
      });
  } else if (e.name === "ConstraintError") {
    if (((a = r.authenticatorSelection) == null ? void 0 : a.requireResidentKey) === !0)
      return new di({
        message: "Discoverable credentials were required but no available authenticator supported it",
        code: "ERROR_AUTHENTICATOR_MISSING_DISCOVERABLE_CREDENTIAL_SUPPORT",
        cause: e
      });
    if (
      // @ts-ignore: `mediation` doesn't yet exist on CredentialCreationOptions but it's possible as of Sept 2024
      n.mediation === "conditional" && ((o = r.authenticatorSelection) == null ? void 0 : o.userVerification) === "required"
    )
      return new di({
        message: "User verification was required during automatic registration but it could not be performed",
        code: "ERROR_AUTO_REGISTER_USER_VERIFICATION_FAILURE",
        cause: e
      });
    if (((l = r.authenticatorSelection) == null ? void 0 : l.userVerification) === "required")
      return new di({
        message: "User verification was required but no available authenticator supported it",
        code: "ERROR_AUTHENTICATOR_MISSING_USER_VERIFICATION_SUPPORT",
        cause: e
      });
  } else {
    if (e.name === "InvalidStateError")
      return new di({
        message: "The authenticator was previously registered",
        code: "ERROR_AUTHENTICATOR_PREVIOUSLY_REGISTERED",
        cause: e
      });
    if (e.name === "NotAllowedError")
      return new di({
        message: e.message,
        code: "ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY",
        cause: e
      });
    if (e.name === "NotSupportedError")
      return r.pubKeyCredParams.filter((c) => c.type === "public-key").length === 0 ? new di({
        message: 'No entry in pubKeyCredParams was of type "public-key"',
        code: "ERROR_MALFORMED_PUBKEYCREDPARAMS",
        cause: e
      }) : new di({
        message: "No available authenticator supported any of the specified pubKeyCredParams algorithms",
        code: "ERROR_AUTHENTICATOR_NO_SUPPORTED_PUBKEYCREDPARAMS_ALG",
        cause: e
      });
    if (e.name === "SecurityError") {
      const d = globalThis.location.hostname;
      if (wb(d)) {
        if (r.rp.id !== d)
          return new di({
            message: `The RP ID "${r.rp.id}" is invalid for this domain`,
            code: "ERROR_INVALID_RP_ID",
            cause: e
          });
      } else return new di({
        message: `${globalThis.location.hostname} is an invalid domain`,
        code: "ERROR_INVALID_DOMAIN",
        cause: e
      });
    } else if (e.name === "TypeError") {
      if (r.user.id.byteLength < 1 || r.user.id.byteLength > 64)
        return new di({
          message: "User ID was not between 1 and 64 characters",
          code: "ERROR_INVALID_USER_ID_LENGTH",
          cause: e
        });
    } else if (e.name === "UnknownError")
      return new di({
        message: "The authenticator was unable to process the specified options, or could not create a new credential",
        code: "ERROR_AUTHENTICATOR_GENERAL_ERROR",
        cause: e
      });
  }
  return e;
}
class iC {
  constructor() {
    Object.defineProperty(this, "controller", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    });
  }
  createNewAbortSignal() {
    if (this.controller) {
      const r = new Error("Cancelling existing WebAuthn API call for new one");
      r.name = "AbortError", this.controller.abort(r);
    }
    const n = new AbortController();
    return this.controller = n, n.signal;
  }
  cancelCeremony() {
    if (this.controller) {
      const n = new Error("Manually cancelling existing WebAuthn API call");
      n.name = "AbortError", this.controller.abort(n), this.controller = void 0;
    }
  }
}
const Sb = new iC(), rC = ["cross-platform", "platform"];
function _b(e) {
  if (e && !(rC.indexOf(e) < 0))
    return e;
}
async function sC(e) {
  var m;
  !e.optionsJSON && e.challenge && (console.warn("startRegistration() was not called correctly. It will try to continue with the provided options, but this call should be refactored to use the expected call structure instead. See https://simplewebauthn.dev/docs/packages/browser#typeerror-cannot-read-properties-of-undefined-reading-challenge for more information."), e = { optionsJSON: e });
  const { optionsJSON: n, useAutoRegister: r = !1 } = e;
  if (!Sc())
    throw new Error("WebAuthn is not supported in this browser");
  const a = {
    ...n,
    challenge: Bl(n.challenge),
    user: {
      ...n.user,
      id: Bl(n.user.id)
    },
    excludeCredentials: (m = n.excludeCredentials) == null ? void 0 : m.map(vb)
  }, o = {};
  r && (o.mediation = "conditional"), o.publicKey = a, o.signal = Sb.createNewAbortSignal();
  let l;
  try {
    l = await navigator.credentials.create(o);
  } catch (v) {
    throw nC({ error: v, options: o });
  }
  if (!l)
    throw new Error("Registration was not completed");
  const { id: d, rawId: c, response: f, type: s } = l;
  let h;
  typeof f.getTransports == "function" && (h = f.getTransports());
  let g;
  if (typeof f.getPublicKeyAlgorithm == "function")
    try {
      g = f.getPublicKeyAlgorithm();
    } catch (v) {
      Tu("getPublicKeyAlgorithm()", v);
    }
  let t;
  if (typeof f.getPublicKey == "function")
    try {
      const v = f.getPublicKey();
      v !== null && (t = _r(v));
    } catch (v) {
      Tu("getPublicKey()", v);
    }
  let i;
  if (typeof f.getAuthenticatorData == "function")
    try {
      i = _r(f.getAuthenticatorData());
    } catch (v) {
      Tu("getAuthenticatorData()", v);
    }
  return {
    id: d,
    rawId: _r(c),
    response: {
      attestationObject: _r(f.attestationObject),
      clientDataJSON: _r(f.clientDataJSON),
      transports: h,
      publicKeyAlgorithm: g,
      publicKey: t,
      authenticatorData: i
    },
    type: s,
    clientExtensionResults: l.getClientExtensionResults(),
    authenticatorAttachment: _b(l.authenticatorAttachment)
  };
}
function Tu(e, n) {
  console.warn(`The browser extension that intercepted this WebAuthn API call incorrectly implemented ${e}. You should report this error to them.
`, n);
}
function aC() {
  if (!Sc())
    return Ou.stubThis(new Promise((n) => n(!1)));
  const e = globalThis.PublicKeyCredential;
  return (e == null ? void 0 : e.isConditionalMediationAvailable) === void 0 ? Ou.stubThis(new Promise((n) => n(!1))) : Ou.stubThis(e.isConditionalMediationAvailable());
}
const Ou = {
  stubThis: (e) => e
};
function oC({ error: e, options: n }) {
  const { publicKey: r } = n;
  if (!r)
    throw Error("options was missing required publicKey property");
  if (e.name === "AbortError") {
    if (n.signal instanceof AbortSignal)
      return new di({
        message: "Authentication ceremony was sent an abort signal",
        code: "ERROR_CEREMONY_ABORTED",
        cause: e
      });
  } else {
    if (e.name === "NotAllowedError")
      return new di({
        message: e.message,
        code: "ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY",
        cause: e
      });
    if (e.name === "SecurityError") {
      const a = globalThis.location.hostname;
      if (wb(a)) {
        if (r.rpId !== a)
          return new di({
            message: `The RP ID "${r.rpId}" is invalid for this domain`,
            code: "ERROR_INVALID_RP_ID",
            cause: e
          });
      } else return new di({
        message: `${globalThis.location.hostname} is an invalid domain`,
        code: "ERROR_INVALID_DOMAIN",
        cause: e
      });
    } else if (e.name === "UnknownError")
      return new di({
        message: "The authenticator was unable to process the specified options, or could not create a new assertion signature",
        code: "ERROR_AUTHENTICATOR_GENERAL_ERROR",
        cause: e
      });
  }
  return e;
}
async function cC(e) {
  var i, m;
  !e.optionsJSON && e.challenge && (console.warn("startAuthentication() was not called correctly. It will try to continue with the provided options, but this call should be refactored to use the expected call structure instead. See https://simplewebauthn.dev/docs/packages/browser#typeerror-cannot-read-properties-of-undefined-reading-challenge for more information."), e = { optionsJSON: e });
  const { optionsJSON: n, useBrowserAutofill: r = !1, verifyBrowserAutofillInput: a = !0 } = e;
  if (!Sc())
    throw new Error("WebAuthn is not supported in this browser");
  let o;
  ((i = n.allowCredentials) == null ? void 0 : i.length) !== 0 && (o = (m = n.allowCredentials) == null ? void 0 : m.map(vb));
  const l = {
    ...n,
    challenge: Bl(n.challenge),
    allowCredentials: o
  }, d = {};
  if (r) {
    if (!await aC())
      throw Error("Browser does not support WebAuthn autofill");
    if (document.querySelectorAll("input[autocomplete$='webauthn']").length < 1 && a)
      throw Error('No <input> with "webauthn" as the only or last value in its `autocomplete` attribute was detected');
    d.mediation = "conditional", l.allowCredentials = [];
  }
  d.publicKey = l, d.signal = Sb.createNewAbortSignal();
  let c;
  try {
    c = await navigator.credentials.get(d);
  } catch (v) {
    throw oC({ error: v, options: d });
  }
  if (!c)
    throw new Error("Authentication was not completed");
  const { id: f, rawId: s, response: h, type: g } = c;
  let t;
  return h.userHandle && (t = _r(h.userHandle)), {
    id: f,
    rawId: _r(s),
    response: {
      authenticatorData: _r(h.authenticatorData),
      clientDataJSON: _r(h.clientDataJSON),
      signature: _r(h.signature),
      userHandle: t
    },
    type: g,
    clientExtensionResults: c.getClientExtensionResults(),
    authenticatorAttachment: _b(c.authenticatorAttachment)
  };
}
const en = {
  SCREEN_VIEWED: "login_screen_viewed",
  MAGIC_LINK_TAB_CLICKED: "login_magic_link_tab_clicked",
  PASSWORD_TAB_CLICKED: "login_password_tab_clicked",
  MAGIC_LINK_REQUEST_SUBMITTED: "login_magic_link_request_submitted",
  MAGIC_LINK_REQUEST_COMPLETED: "login_magic_link_request_completed",
  MAGIC_LINK_REQUEST_FAILED: "login_magic_link_request_failed",
  PASSWORD_SIGN_IN_SUBMITTED: "login_password_sign_in_submitted",
  PASSWORD_SIGN_IN_COMPLETED: "login_password_sign_in_completed",
  PASSWORD_SIGN_IN_FAILED: "login_password_sign_in_failed",
  PASSKEY_SIGN_IN_SUBMITTED: "login_passkey_sign_in_submitted",
  PASSKEY_SIGN_IN_COMPLETED: "login_passkey_sign_in_completed",
  PASSKEY_SIGN_IN_FAILED: "login_passkey_sign_in_failed",
  PASSKEY_SETUP_SUBMITTED: "login_passkey_setup_submitted",
  PASSKEY_SETUP_COMPLETED: "login_passkey_setup_completed",
  PASSKEY_SETUP_FAILED: "login_passkey_setup_failed",
  PASSKEY_SETUP_PROMPT_SHOWN: "login_passkey_setup_prompt_shown",
  PASSKEY_SETUP_PROMPT_ACCEPTED: "login_passkey_setup_prompt_accepted",
  PASSKEY_SETUP_PROMPT_DISMISSED: "login_passkey_setup_prompt_dismissed",
  PASSKEY_RENAMED: "login_passkey_renamed",
  PASSKEY_DELETED: "login_passkey_deleted",
  MFA_PROMPT_SHOWN: "login_mfa_prompt_shown",
  MFA_CODE_SUBMITTED: "login_mfa_code_submitted",
  MFA_CODE_COMPLETED: "login_mfa_code_completed",
  MFA_CODE_FAILED: "login_mfa_code_failed",
  FORGOT_PASSWORD_CLICKED: "login_forgot_password_clicked",
  FORGOT_PASSWORD_SUBMITTED: "login_forgot_password_submitted",
  FORGOT_PASSWORD_COMPLETED: "login_forgot_password_completed",
  FORGOT_PASSWORD_FAILED: "login_forgot_password_failed",
  BACK_TO_SIGN_IN_CLICKED: "login_back_to_sign_in_clicked",
  OAUTH_BUTTON_CLICKED: "login_oauth_button_clicked",
  OAUTH_COMPLETED: "login_oauth_completed",
  OAUTH_FAILED: "login_oauth_failed",
  MAGIC_LINK_CLICKED: "login_magic_link_clicked",
  MAGIC_LINK_COMPLETED: "login_magic_link_completed",
  MAGIC_LINK_FAILED: "login_magic_link_failed",
  CPA_AUTHORIZATION_CLICKED: "login_cpa_authorization_clicked",
  CPA_AUTHORIZATION_COMPLETED: "login_cpa_authorization_completed",
  CPA_AUTHORIZATION_FAILED: "login_cpa_authorization_failed",
  FLOW_COMPLETED: "login_flow_completed"
}, Fu = {
  GOOGLE: "google",
  MICROSOFT: "microsoft"
}, Pu = {
  PASSWORD: "password",
  MAGIC_LINK: "magic_link",
  PASSKEY: "passkey"
}, ki = {
  PASSWORD: "password",
  MAGIC_LINK_REQUEST: "magic_link_request",
  MAGIC_LINK_CLICKED: "magic_link_clicked",
  OAUTH: "oauth",
  PASSKEY: "passkey"
}, ju = {
  MFA_CODE: "mfa_code",
  MAGIC_LINK_SENT: "magic_link_sent",
  CPA_SELECTOR: "cpa_selector"
}, bB = {
  MAGIC_LINK: "magic_link",
  PASSWORD: "password"
}, bp = {
  SIGN_IN_TAB: "sign_in_tab",
  MFA_RECOVERY: "mfa_recovery"
}, Cb = {
  LOGIN_V5_NATIVE: "login_v5_native",
  MAGIC_LINK_CLICKED: "magic_link_clicked"
}, Rf = (e, n) => {
  if (!e)
    return;
  const r = e.length === 1, a = e.find((o) => o.company_url === n);
  if (r)
    return e[0];
  if (a)
    return a;
}, lC = (e) => e === "outlook365" ? "outlook" : e, Mf = "liscio.passkeyPostLoginPrompt.pending", Xd = "liscio.passkeyPostLoginPrompt.dismissedUntil", uC = 30 * 24 * 60 * 60 * 1e3, dC = [
  ki.PASSWORD,
  ki.MAGIC_LINK_REQUEST,
  ki.MAGIC_LINK_CLICKED,
  ki.OAUTH
], Df = () => {
  if (!(typeof window > "u"))
    return window.localStorage;
}, Ab = (e) => {
  var n;
  try {
    return (n = Df()) == null ? void 0 : n.getItem(e);
  } catch {
    return;
  }
}, kb = (e, n) => {
  var r;
  try {
    (r = Df()) == null || r.setItem(e, n);
  } catch {
  }
}, Eb = (e) => {
  var n;
  try {
    (n = Df()) == null || n.removeItem(e);
  } catch {
  }
}, Ib = (e) => dC.includes(e), Nf = (e) => {
  Ib(e) && kb(
    Mf,
    JSON.stringify({ primaryMethod: e, createdAt: Date.now() })
  );
}, yp = () => {
  const e = Ab(Mf);
  if (e)
    try {
      const n = JSON.parse(e);
      if (typeof n.primaryMethod != "string" || typeof n.createdAt != "number" || !Ib(n.primaryMethod)) {
        $l();
        return;
      }
      return n;
    } catch {
      $l();
      return;
    }
}, $l = () => {
  Eb(Mf);
}, hC = () => {
  kb(
    Xd,
    String(Date.now() + uC)
  ), $l();
}, vp = () => {
  const e = Number(Ab(Xd));
  return !Number.isFinite(e) || e <= 0 ? !1 : e <= Date.now() ? (Eb(Xd), !1) : !0;
};
async function Tb(e) {
  e && await Ob({
    downloadUrl: e.file_download_url,
    fileName: e.doc_name
  });
}
async function Ob({
  downloadUrl: e,
  fileName: n,
  openInNewTab: r = !1
}) {
  if (On.isNativePlatform())
    try {
      const a = Math.floor(Math.random() * 1e4), o = {
        url: e,
        path: n || `document-${a}.pdf`,
        directory: h7.Documents,
        progress: !0,
        method: "GET"
      };
      await f7.downloadFile(o);
    } catch (a) {
      console.error(a);
    }
  else
    r ? window.open(e, "_blank") : window.location.href = e;
}
var Fb = { exports: {} };
(function(e, n) {
  (function(r, a) {
    a();
  })(Mi, function() {
    function r(s, h) {
      return typeof h > "u" ? h = { autoBom: !1 } : typeof h != "object" && (console.warn("Deprecated: Expected third argument to be a object"), h = { autoBom: !h }), h.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(s.type) ? new Blob(["\uFEFF", s], { type: s.type }) : s;
    }
    function a(s, h, g) {
      var t = new XMLHttpRequest();
      t.open("GET", s), t.responseType = "blob", t.onload = function() {
        f(t.response, h, g);
      }, t.onerror = function() {
        console.error("could not download file");
      }, t.send();
    }
    function o(s) {
      var h = new XMLHttpRequest();
      h.open("HEAD", s, !1);
      try {
        h.send();
      } catch {
      }
      return 200 <= h.status && 299 >= h.status;
    }
    function l(s) {
      try {
        s.dispatchEvent(new MouseEvent("click"));
      } catch {
        var h = document.createEvent("MouseEvents");
        h.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), s.dispatchEvent(h);
      }
    }
    var d = typeof window == "object" && window.window === window ? window : typeof self == "object" && self.self === self ? self : typeof Mi == "object" && Mi.global === Mi ? Mi : void 0, c = d.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), f = d.saveAs || (typeof window != "object" || window !== d ? function() {
    } : "download" in HTMLAnchorElement.prototype && !c ? function(s, h, g) {
      var t = d.URL || d.webkitURL, i = document.createElement("a");
      h = h || s.name || "download", i.download = h, i.rel = "noopener", typeof s == "string" ? (i.href = s, i.origin === location.origin ? l(i) : o(i.href) ? a(s, h, g) : l(i, i.target = "_blank")) : (i.href = t.createObjectURL(s), setTimeout(function() {
        t.revokeObjectURL(i.href);
      }, 4e4), setTimeout(function() {
        l(i);
      }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(s, h, g) {
      if (h = h || s.name || "download", typeof s != "string") navigator.msSaveOrOpenBlob(r(s, g), h);
      else if (o(s)) a(s, h, g);
      else {
        var t = document.createElement("a");
        t.href = s, t.target = "_blank", setTimeout(function() {
          l(t);
        });
      }
    } : function(s, h, g, t) {
      if (t = t || open("", "_blank"), t && (t.document.title = t.document.body.innerText = "downloading..."), typeof s == "string") return a(s, h, g);
      var i = s.type === "application/octet-stream", m = /constructor/i.test(d.HTMLElement) || d.safari, v = /CriOS\/[\d]+/.test(navigator.userAgent);
      if ((v || i && m || c) && typeof FileReader < "u") {
        var E = new FileReader();
        E.onloadend = function() {
          var x = E.result;
          x = v ? x : x.replace(/^data:[^;]*;/, "data:attachment/file;"), t ? t.location.href = x : location = x, t = null;
        }, E.readAsDataURL(s);
      } else {
        var S = d.URL || d.webkitURL, y = S.createObjectURL(s);
        t ? t.location = y : location.href = y, t = null, setTimeout(function() {
          S.revokeObjectURL(y);
        }, 4e4);
      }
    });
    d.saveAs = f.saveAs = f, e.exports = f;
  });
})(Fb);
var fC = Fb.exports;
const Gd = /* @__PURE__ */ ys(fC);
function Vc(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Pb = { exports: {} };
/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/
(function(e, n) {
  (function(r) {
    e.exports = r();
  })(function() {
    return function r(a, o, l) {
      function d(s, h) {
        if (!o[s]) {
          if (!a[s]) {
            var g = typeof Vc == "function" && Vc;
            if (!h && g) return g(s, !0);
            if (c) return c(s, !0);
            var t = new Error("Cannot find module '" + s + "'");
            throw t.code = "MODULE_NOT_FOUND", t;
          }
          var i = o[s] = { exports: {} };
          a[s][0].call(i.exports, function(m) {
            var v = a[s][1][m];
            return d(v || m);
          }, i, i.exports, r, a, o, l);
        }
        return o[s].exports;
      }
      for (var c = typeof Vc == "function" && Vc, f = 0; f < l.length; f++) d(l[f]);
      return d;
    }({ 1: [function(r, a, o) {
      var l = r("./utils"), d = r("./support"), c = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
      o.encode = function(f) {
        for (var s, h, g, t, i, m, v, E = [], S = 0, y = f.length, x = y, b = l.getTypeOf(f) !== "string"; S < f.length; ) x = y - S, g = b ? (s = f[S++], h = S < y ? f[S++] : 0, S < y ? f[S++] : 0) : (s = f.charCodeAt(S++), h = S < y ? f.charCodeAt(S++) : 0, S < y ? f.charCodeAt(S++) : 0), t = s >> 2, i = (3 & s) << 4 | h >> 4, m = 1 < x ? (15 & h) << 2 | g >> 6 : 64, v = 2 < x ? 63 & g : 64, E.push(c.charAt(t) + c.charAt(i) + c.charAt(m) + c.charAt(v));
        return E.join("");
      }, o.decode = function(f) {
        var s, h, g, t, i, m, v = 0, E = 0, S = "data:";
        if (f.substr(0, S.length) === S) throw new Error("Invalid base64 input, it looks like a data url.");
        var y, x = 3 * (f = f.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
        if (f.charAt(f.length - 1) === c.charAt(64) && x--, f.charAt(f.length - 2) === c.charAt(64) && x--, x % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
        for (y = d.uint8array ? new Uint8Array(0 | x) : new Array(0 | x); v < f.length; ) s = c.indexOf(f.charAt(v++)) << 2 | (t = c.indexOf(f.charAt(v++))) >> 4, h = (15 & t) << 4 | (i = c.indexOf(f.charAt(v++))) >> 2, g = (3 & i) << 6 | (m = c.indexOf(f.charAt(v++))), y[E++] = s, i !== 64 && (y[E++] = h), m !== 64 && (y[E++] = g);
        return y;
      };
    }, { "./support": 30, "./utils": 32 }], 2: [function(r, a, o) {
      var l = r("./external"), d = r("./stream/DataWorker"), c = r("./stream/Crc32Probe"), f = r("./stream/DataLengthProbe");
      function s(h, g, t, i, m) {
        this.compressedSize = h, this.uncompressedSize = g, this.crc32 = t, this.compression = i, this.compressedContent = m;
      }
      s.prototype = { getContentWorker: function() {
        var h = new d(l.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new f("data_length")), g = this;
        return h.on("end", function() {
          if (this.streamInfo.data_length !== g.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
        }), h;
      }, getCompressedWorker: function() {
        return new d(l.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
      } }, s.createWorkerFrom = function(h, g, t) {
        return h.pipe(new c()).pipe(new f("uncompressedSize")).pipe(g.compressWorker(t)).pipe(new f("compressedSize")).withStreamInfo("compression", g);
      }, a.exports = s;
    }, { "./external": 6, "./stream/Crc32Probe": 25, "./stream/DataLengthProbe": 26, "./stream/DataWorker": 27 }], 3: [function(r, a, o) {
      var l = r("./stream/GenericWorker");
      o.STORE = { magic: "\0\0", compressWorker: function() {
        return new l("STORE compression");
      }, uncompressWorker: function() {
        return new l("STORE decompression");
      } }, o.DEFLATE = r("./flate");
    }, { "./flate": 7, "./stream/GenericWorker": 28 }], 4: [function(r, a, o) {
      var l = r("./utils"), d = function() {
        for (var c, f = [], s = 0; s < 256; s++) {
          c = s;
          for (var h = 0; h < 8; h++) c = 1 & c ? 3988292384 ^ c >>> 1 : c >>> 1;
          f[s] = c;
        }
        return f;
      }();
      a.exports = function(c, f) {
        return c !== void 0 && c.length ? l.getTypeOf(c) !== "string" ? function(s, h, g, t) {
          var i = d, m = t + g;
          s ^= -1;
          for (var v = t; v < m; v++) s = s >>> 8 ^ i[255 & (s ^ h[v])];
          return -1 ^ s;
        }(0 | f, c, c.length, 0) : function(s, h, g, t) {
          var i = d, m = t + g;
          s ^= -1;
          for (var v = t; v < m; v++) s = s >>> 8 ^ i[255 & (s ^ h.charCodeAt(v))];
          return -1 ^ s;
        }(0 | f, c, c.length, 0) : 0;
      };
    }, { "./utils": 32 }], 5: [function(r, a, o) {
      o.base64 = !1, o.binary = !1, o.dir = !1, o.createFolders = !0, o.date = null, o.compression = null, o.compressionOptions = null, o.comment = null, o.unixPermissions = null, o.dosPermissions = null;
    }, {}], 6: [function(r, a, o) {
      var l = null;
      l = typeof Promise < "u" ? Promise : r("lie"), a.exports = { Promise: l };
    }, { lie: 37 }], 7: [function(r, a, o) {
      var l = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Uint32Array < "u", d = r("pako"), c = r("./utils"), f = r("./stream/GenericWorker"), s = l ? "uint8array" : "array";
      function h(g, t) {
        f.call(this, "FlateWorker/" + g), this._pako = null, this._pakoAction = g, this._pakoOptions = t, this.meta = {};
      }
      o.magic = "\b\0", c.inherits(h, f), h.prototype.processChunk = function(g) {
        this.meta = g.meta, this._pako === null && this._createPako(), this._pako.push(c.transformTo(s, g.data), !1);
      }, h.prototype.flush = function() {
        f.prototype.flush.call(this), this._pako === null && this._createPako(), this._pako.push([], !0);
      }, h.prototype.cleanUp = function() {
        f.prototype.cleanUp.call(this), this._pako = null;
      }, h.prototype._createPako = function() {
        this._pako = new d[this._pakoAction]({ raw: !0, level: this._pakoOptions.level || -1 });
        var g = this;
        this._pako.onData = function(t) {
          g.push({ data: t, meta: g.meta });
        };
      }, o.compressWorker = function(g) {
        return new h("Deflate", g);
      }, o.uncompressWorker = function() {
        return new h("Inflate", {});
      };
    }, { "./stream/GenericWorker": 28, "./utils": 32, pako: 38 }], 8: [function(r, a, o) {
      function l(i, m) {
        var v, E = "";
        for (v = 0; v < m; v++) E += String.fromCharCode(255 & i), i >>>= 8;
        return E;
      }
      function d(i, m, v, E, S, y) {
        var x, b, u = i.file, I = i.compression, O = y !== s.utf8encode, D = c.transformTo("string", y(u.name)), $ = c.transformTo("string", s.utf8encode(u.name)), K = u.comment, H = c.transformTo("string", y(K)), B = c.transformTo("string", s.utf8encode(K)), R = $.length !== u.name.length, _ = B.length !== K.length, A = "", k = "", z = "", T = u.dir, w = u.date, F = { crc32: 0, compressedSize: 0, uncompressedSize: 0 };
        m && !v || (F.crc32 = i.crc32, F.compressedSize = i.compressedSize, F.uncompressedSize = i.uncompressedSize);
        var j = 0;
        m && (j |= 8), O || !R && !_ || (j |= 2048);
        var P = 0, V = 0;
        T && (P |= 16), S === "UNIX" ? (V = 798, P |= function(ne, Z) {
          var te = ne;
          return ne || (te = Z ? 16893 : 33204), (65535 & te) << 16;
        }(u.unixPermissions, T)) : (V = 20, P |= function(ne) {
          return 63 & (ne || 0);
        }(u.dosPermissions)), x = w.getUTCHours(), x <<= 6, x |= w.getUTCMinutes(), x <<= 5, x |= w.getUTCSeconds() / 2, b = w.getUTCFullYear() - 1980, b <<= 4, b |= w.getUTCMonth() + 1, b <<= 5, b |= w.getUTCDate(), R && (k = l(1, 1) + l(h(D), 4) + $, A += "up" + l(k.length, 2) + k), _ && (z = l(1, 1) + l(h(H), 4) + B, A += "uc" + l(z.length, 2) + z);
        var J = "";
        return J += `
\0`, J += l(j, 2), J += I.magic, J += l(x, 2), J += l(b, 2), J += l(F.crc32, 4), J += l(F.compressedSize, 4), J += l(F.uncompressedSize, 4), J += l(D.length, 2), J += l(A.length, 2), { fileRecord: g.LOCAL_FILE_HEADER + J + D + A, dirRecord: g.CENTRAL_FILE_HEADER + l(V, 2) + J + l(H.length, 2) + "\0\0\0\0" + l(P, 4) + l(E, 4) + D + A + H };
      }
      var c = r("../utils"), f = r("../stream/GenericWorker"), s = r("../utf8"), h = r("../crc32"), g = r("../signature");
      function t(i, m, v, E) {
        f.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = m, this.zipPlatform = v, this.encodeFileName = E, this.streamFiles = i, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
      }
      c.inherits(t, f), t.prototype.push = function(i) {
        var m = i.meta.percent || 0, v = this.entriesCount, E = this._sources.length;
        this.accumulate ? this.contentBuffer.push(i) : (this.bytesWritten += i.data.length, f.prototype.push.call(this, { data: i.data, meta: { currentFile: this.currentFile, percent: v ? (m + 100 * (v - E - 1)) / v : 100 } }));
      }, t.prototype.openedSource = function(i) {
        this.currentSourceOffset = this.bytesWritten, this.currentFile = i.file.name;
        var m = this.streamFiles && !i.file.dir;
        if (m) {
          var v = d(i, m, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
          this.push({ data: v.fileRecord, meta: { percent: 0 } });
        } else this.accumulate = !0;
      }, t.prototype.closedSource = function(i) {
        this.accumulate = !1;
        var m = this.streamFiles && !i.file.dir, v = d(i, m, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
        if (this.dirRecords.push(v.dirRecord), m) this.push({ data: function(E) {
          return g.DATA_DESCRIPTOR + l(E.crc32, 4) + l(E.compressedSize, 4) + l(E.uncompressedSize, 4);
        }(i), meta: { percent: 100 } });
        else for (this.push({ data: v.fileRecord, meta: { percent: 0 } }); this.contentBuffer.length; ) this.push(this.contentBuffer.shift());
        this.currentFile = null;
      }, t.prototype.flush = function() {
        for (var i = this.bytesWritten, m = 0; m < this.dirRecords.length; m++) this.push({ data: this.dirRecords[m], meta: { percent: 100 } });
        var v = this.bytesWritten - i, E = function(S, y, x, b, u) {
          var I = c.transformTo("string", u(b));
          return g.CENTRAL_DIRECTORY_END + "\0\0\0\0" + l(S, 2) + l(S, 2) + l(y, 4) + l(x, 4) + l(I.length, 2) + I;
        }(this.dirRecords.length, v, i, this.zipComment, this.encodeFileName);
        this.push({ data: E, meta: { percent: 100 } });
      }, t.prototype.prepareNextSource = function() {
        this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
      }, t.prototype.registerPrevious = function(i) {
        this._sources.push(i);
        var m = this;
        return i.on("data", function(v) {
          m.processChunk(v);
        }), i.on("end", function() {
          m.closedSource(m.previous.streamInfo), m._sources.length ? m.prepareNextSource() : m.end();
        }), i.on("error", function(v) {
          m.error(v);
        }), this;
      }, t.prototype.resume = function() {
        return !!f.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
      }, t.prototype.error = function(i) {
        var m = this._sources;
        if (!f.prototype.error.call(this, i)) return !1;
        for (var v = 0; v < m.length; v++) try {
          m[v].error(i);
        } catch {
        }
        return !0;
      }, t.prototype.lock = function() {
        f.prototype.lock.call(this);
        for (var i = this._sources, m = 0; m < i.length; m++) i[m].lock();
      }, a.exports = t;
    }, { "../crc32": 4, "../signature": 23, "../stream/GenericWorker": 28, "../utf8": 31, "../utils": 32 }], 9: [function(r, a, o) {
      var l = r("../compressions"), d = r("./ZipFileWorker");
      o.generateWorker = function(c, f, s) {
        var h = new d(f.streamFiles, s, f.platform, f.encodeFileName), g = 0;
        try {
          c.forEach(function(t, i) {
            g++;
            var m = function(y, x) {
              var b = y || x, u = l[b];
              if (!u) throw new Error(b + " is not a valid compression method !");
              return u;
            }(i.options.compression, f.compression), v = i.options.compressionOptions || f.compressionOptions || {}, E = i.dir, S = i.date;
            i._compressWorker(m, v).withStreamInfo("file", { name: t, dir: E, date: S, comment: i.comment || "", unixPermissions: i.unixPermissions, dosPermissions: i.dosPermissions }).pipe(h);
          }), h.entriesCount = g;
        } catch (t) {
          h.error(t);
        }
        return h;
      };
    }, { "../compressions": 3, "./ZipFileWorker": 8 }], 10: [function(r, a, o) {
      function l() {
        if (!(this instanceof l)) return new l();
        if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
        this.files = /* @__PURE__ */ Object.create(null), this.comment = null, this.root = "", this.clone = function() {
          var d = new l();
          for (var c in this) typeof this[c] != "function" && (d[c] = this[c]);
          return d;
        };
      }
      (l.prototype = r("./object")).loadAsync = r("./load"), l.support = r("./support"), l.defaults = r("./defaults"), l.version = "3.10.1", l.loadAsync = function(d, c) {
        return new l().loadAsync(d, c);
      }, l.external = r("./external"), a.exports = l;
    }, { "./defaults": 5, "./external": 6, "./load": 11, "./object": 15, "./support": 30 }], 11: [function(r, a, o) {
      var l = r("./utils"), d = r("./external"), c = r("./utf8"), f = r("./zipEntries"), s = r("./stream/Crc32Probe"), h = r("./nodejsUtils");
      function g(t) {
        return new d.Promise(function(i, m) {
          var v = t.decompressed.getContentWorker().pipe(new s());
          v.on("error", function(E) {
            m(E);
          }).on("end", function() {
            v.streamInfo.crc32 !== t.decompressed.crc32 ? m(new Error("Corrupted zip : CRC32 mismatch")) : i();
          }).resume();
        });
      }
      a.exports = function(t, i) {
        var m = this;
        return i = l.extend(i || {}, { base64: !1, checkCRC32: !1, optimizedBinaryString: !1, createFolders: !1, decodeFileName: c.utf8decode }), h.isNode && h.isStream(t) ? d.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : l.prepareContent("the loaded zip file", t, !0, i.optimizedBinaryString, i.base64).then(function(v) {
          var E = new f(i);
          return E.load(v), E;
        }).then(function(v) {
          var E = [d.Promise.resolve(v)], S = v.files;
          if (i.checkCRC32) for (var y = 0; y < S.length; y++) E.push(g(S[y]));
          return d.Promise.all(E);
        }).then(function(v) {
          for (var E = v.shift(), S = E.files, y = 0; y < S.length; y++) {
            var x = S[y], b = x.fileNameStr, u = l.resolve(x.fileNameStr);
            m.file(u, x.decompressed, { binary: !0, optimizedBinaryString: !0, date: x.date, dir: x.dir, comment: x.fileCommentStr.length ? x.fileCommentStr : null, unixPermissions: x.unixPermissions, dosPermissions: x.dosPermissions, createFolders: i.createFolders }), x.dir || (m.file(u).unsafeOriginalName = b);
          }
          return E.zipComment.length && (m.comment = E.zipComment), m;
        });
      };
    }, { "./external": 6, "./nodejsUtils": 14, "./stream/Crc32Probe": 25, "./utf8": 31, "./utils": 32, "./zipEntries": 33 }], 12: [function(r, a, o) {
      var l = r("../utils"), d = r("../stream/GenericWorker");
      function c(f, s) {
        d.call(this, "Nodejs stream input adapter for " + f), this._upstreamEnded = !1, this._bindStream(s);
      }
      l.inherits(c, d), c.prototype._bindStream = function(f) {
        var s = this;
        (this._stream = f).pause(), f.on("data", function(h) {
          s.push({ data: h, meta: { percent: 0 } });
        }).on("error", function(h) {
          s.isPaused ? this.generatedError = h : s.error(h);
        }).on("end", function() {
          s.isPaused ? s._upstreamEnded = !0 : s.end();
        });
      }, c.prototype.pause = function() {
        return !!d.prototype.pause.call(this) && (this._stream.pause(), !0);
      }, c.prototype.resume = function() {
        return !!d.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
      }, a.exports = c;
    }, { "../stream/GenericWorker": 28, "../utils": 32 }], 13: [function(r, a, o) {
      var l = r("readable-stream").Readable;
      function d(c, f, s) {
        l.call(this, f), this._helper = c;
        var h = this;
        c.on("data", function(g, t) {
          h.push(g) || h._helper.pause(), s && s(t);
        }).on("error", function(g) {
          h.emit("error", g);
        }).on("end", function() {
          h.push(null);
        });
      }
      r("../utils").inherits(d, l), d.prototype._read = function() {
        this._helper.resume();
      }, a.exports = d;
    }, { "../utils": 32, "readable-stream": 16 }], 14: [function(r, a, o) {
      a.exports = { isNode: typeof Buffer < "u", newBufferFrom: function(l, d) {
        if (Buffer.from && Buffer.from !== Uint8Array.from) return Buffer.from(l, d);
        if (typeof l == "number") throw new Error('The "data" argument must not be a number');
        return new Buffer(l, d);
      }, allocBuffer: function(l) {
        if (Buffer.alloc) return Buffer.alloc(l);
        var d = new Buffer(l);
        return d.fill(0), d;
      }, isBuffer: function(l) {
        return Buffer.isBuffer(l);
      }, isStream: function(l) {
        return l && typeof l.on == "function" && typeof l.pause == "function" && typeof l.resume == "function";
      } };
    }, {}], 15: [function(r, a, o) {
      function l(u, I, O) {
        var D, $ = c.getTypeOf(I), K = c.extend(O || {}, h);
        K.date = K.date || /* @__PURE__ */ new Date(), K.compression !== null && (K.compression = K.compression.toUpperCase()), typeof K.unixPermissions == "string" && (K.unixPermissions = parseInt(K.unixPermissions, 8)), K.unixPermissions && 16384 & K.unixPermissions && (K.dir = !0), K.dosPermissions && 16 & K.dosPermissions && (K.dir = !0), K.dir && (u = S(u)), K.createFolders && (D = E(u)) && y.call(this, D, !0);
        var H = $ === "string" && K.binary === !1 && K.base64 === !1;
        O && O.binary !== void 0 || (K.binary = !H), (I instanceof g && I.uncompressedSize === 0 || K.dir || !I || I.length === 0) && (K.base64 = !1, K.binary = !0, I = "", K.compression = "STORE", $ = "string");
        var B = null;
        B = I instanceof g || I instanceof f ? I : m.isNode && m.isStream(I) ? new v(u, I) : c.prepareContent(u, I, K.binary, K.optimizedBinaryString, K.base64);
        var R = new t(u, B, K);
        this.files[u] = R;
      }
      var d = r("./utf8"), c = r("./utils"), f = r("./stream/GenericWorker"), s = r("./stream/StreamHelper"), h = r("./defaults"), g = r("./compressedObject"), t = r("./zipObject"), i = r("./generate"), m = r("./nodejsUtils"), v = r("./nodejs/NodejsStreamInputAdapter"), E = function(u) {
        u.slice(-1) === "/" && (u = u.substring(0, u.length - 1));
        var I = u.lastIndexOf("/");
        return 0 < I ? u.substring(0, I) : "";
      }, S = function(u) {
        return u.slice(-1) !== "/" && (u += "/"), u;
      }, y = function(u, I) {
        return I = I !== void 0 ? I : h.createFolders, u = S(u), this.files[u] || l.call(this, u, null, { dir: !0, createFolders: I }), this.files[u];
      };
      function x(u) {
        return Object.prototype.toString.call(u) === "[object RegExp]";
      }
      var b = { load: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, forEach: function(u) {
        var I, O, D;
        for (I in this.files) D = this.files[I], (O = I.slice(this.root.length, I.length)) && I.slice(0, this.root.length) === this.root && u(O, D);
      }, filter: function(u) {
        var I = [];
        return this.forEach(function(O, D) {
          u(O, D) && I.push(D);
        }), I;
      }, file: function(u, I, O) {
        if (arguments.length !== 1) return u = this.root + u, l.call(this, u, I, O), this;
        if (x(u)) {
          var D = u;
          return this.filter(function(K, H) {
            return !H.dir && D.test(K);
          });
        }
        var $ = this.files[this.root + u];
        return $ && !$.dir ? $ : null;
      }, folder: function(u) {
        if (!u) return this;
        if (x(u)) return this.filter(function($, K) {
          return K.dir && u.test($);
        });
        var I = this.root + u, O = y.call(this, I), D = this.clone();
        return D.root = O.name, D;
      }, remove: function(u) {
        u = this.root + u;
        var I = this.files[u];
        if (I || (u.slice(-1) !== "/" && (u += "/"), I = this.files[u]), I && !I.dir) delete this.files[u];
        else for (var O = this.filter(function($, K) {
          return K.name.slice(0, u.length) === u;
        }), D = 0; D < O.length; D++) delete this.files[O[D].name];
        return this;
      }, generate: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, generateInternalStream: function(u) {
        var I, O = {};
        try {
          if ((O = c.extend(u || {}, { streamFiles: !1, compression: "STORE", compressionOptions: null, type: "", platform: "DOS", comment: null, mimeType: "application/zip", encodeFileName: d.utf8encode })).type = O.type.toLowerCase(), O.compression = O.compression.toUpperCase(), O.type === "binarystring" && (O.type = "string"), !O.type) throw new Error("No output type specified.");
          c.checkSupport(O.type), O.platform !== "darwin" && O.platform !== "freebsd" && O.platform !== "linux" && O.platform !== "sunos" || (O.platform = "UNIX"), O.platform === "win32" && (O.platform = "DOS");
          var D = O.comment || this.comment || "";
          I = i.generateWorker(this, O, D);
        } catch ($) {
          (I = new f("error")).error($);
        }
        return new s(I, O.type || "string", O.mimeType);
      }, generateAsync: function(u, I) {
        return this.generateInternalStream(u).accumulate(I);
      }, generateNodeStream: function(u, I) {
        return (u = u || {}).type || (u.type = "nodebuffer"), this.generateInternalStream(u).toNodejsStream(I);
      } };
      a.exports = b;
    }, { "./compressedObject": 2, "./defaults": 5, "./generate": 9, "./nodejs/NodejsStreamInputAdapter": 12, "./nodejsUtils": 14, "./stream/GenericWorker": 28, "./stream/StreamHelper": 29, "./utf8": 31, "./utils": 32, "./zipObject": 35 }], 16: [function(r, a, o) {
      a.exports = r("stream");
    }, { stream: void 0 }], 17: [function(r, a, o) {
      var l = r("./DataReader");
      function d(c) {
        l.call(this, c);
        for (var f = 0; f < this.data.length; f++) c[f] = 255 & c[f];
      }
      r("../utils").inherits(d, l), d.prototype.byteAt = function(c) {
        return this.data[this.zero + c];
      }, d.prototype.lastIndexOfSignature = function(c) {
        for (var f = c.charCodeAt(0), s = c.charCodeAt(1), h = c.charCodeAt(2), g = c.charCodeAt(3), t = this.length - 4; 0 <= t; --t) if (this.data[t] === f && this.data[t + 1] === s && this.data[t + 2] === h && this.data[t + 3] === g) return t - this.zero;
        return -1;
      }, d.prototype.readAndCheckSignature = function(c) {
        var f = c.charCodeAt(0), s = c.charCodeAt(1), h = c.charCodeAt(2), g = c.charCodeAt(3), t = this.readData(4);
        return f === t[0] && s === t[1] && h === t[2] && g === t[3];
      }, d.prototype.readData = function(c) {
        if (this.checkOffset(c), c === 0) return [];
        var f = this.data.slice(this.zero + this.index, this.zero + this.index + c);
        return this.index += c, f;
      }, a.exports = d;
    }, { "../utils": 32, "./DataReader": 18 }], 18: [function(r, a, o) {
      var l = r("../utils");
      function d(c) {
        this.data = c, this.length = c.length, this.index = 0, this.zero = 0;
      }
      d.prototype = { checkOffset: function(c) {
        this.checkIndex(this.index + c);
      }, checkIndex: function(c) {
        if (this.length < this.zero + c || c < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + c + "). Corrupted zip ?");
      }, setIndex: function(c) {
        this.checkIndex(c), this.index = c;
      }, skip: function(c) {
        this.setIndex(this.index + c);
      }, byteAt: function() {
      }, readInt: function(c) {
        var f, s = 0;
        for (this.checkOffset(c), f = this.index + c - 1; f >= this.index; f--) s = (s << 8) + this.byteAt(f);
        return this.index += c, s;
      }, readString: function(c) {
        return l.transformTo("string", this.readData(c));
      }, readData: function() {
      }, lastIndexOfSignature: function() {
      }, readAndCheckSignature: function() {
      }, readDate: function() {
        var c = this.readInt(4);
        return new Date(Date.UTC(1980 + (c >> 25 & 127), (c >> 21 & 15) - 1, c >> 16 & 31, c >> 11 & 31, c >> 5 & 63, (31 & c) << 1));
      } }, a.exports = d;
    }, { "../utils": 32 }], 19: [function(r, a, o) {
      var l = r("./Uint8ArrayReader");
      function d(c) {
        l.call(this, c);
      }
      r("../utils").inherits(d, l), d.prototype.readData = function(c) {
        this.checkOffset(c);
        var f = this.data.slice(this.zero + this.index, this.zero + this.index + c);
        return this.index += c, f;
      }, a.exports = d;
    }, { "../utils": 32, "./Uint8ArrayReader": 21 }], 20: [function(r, a, o) {
      var l = r("./DataReader");
      function d(c) {
        l.call(this, c);
      }
      r("../utils").inherits(d, l), d.prototype.byteAt = function(c) {
        return this.data.charCodeAt(this.zero + c);
      }, d.prototype.lastIndexOfSignature = function(c) {
        return this.data.lastIndexOf(c) - this.zero;
      }, d.prototype.readAndCheckSignature = function(c) {
        return c === this.readData(4);
      }, d.prototype.readData = function(c) {
        this.checkOffset(c);
        var f = this.data.slice(this.zero + this.index, this.zero + this.index + c);
        return this.index += c, f;
      }, a.exports = d;
    }, { "../utils": 32, "./DataReader": 18 }], 21: [function(r, a, o) {
      var l = r("./ArrayReader");
      function d(c) {
        l.call(this, c);
      }
      r("../utils").inherits(d, l), d.prototype.readData = function(c) {
        if (this.checkOffset(c), c === 0) return new Uint8Array(0);
        var f = this.data.subarray(this.zero + this.index, this.zero + this.index + c);
        return this.index += c, f;
      }, a.exports = d;
    }, { "../utils": 32, "./ArrayReader": 17 }], 22: [function(r, a, o) {
      var l = r("../utils"), d = r("../support"), c = r("./ArrayReader"), f = r("./StringReader"), s = r("./NodeBufferReader"), h = r("./Uint8ArrayReader");
      a.exports = function(g) {
        var t = l.getTypeOf(g);
        return l.checkSupport(t), t !== "string" || d.uint8array ? t === "nodebuffer" ? new s(g) : d.uint8array ? new h(l.transformTo("uint8array", g)) : new c(l.transformTo("array", g)) : new f(g);
      };
    }, { "../support": 30, "../utils": 32, "./ArrayReader": 17, "./NodeBufferReader": 19, "./StringReader": 20, "./Uint8ArrayReader": 21 }], 23: [function(r, a, o) {
      o.LOCAL_FILE_HEADER = "PK", o.CENTRAL_FILE_HEADER = "PK", o.CENTRAL_DIRECTORY_END = "PK", o.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x07", o.ZIP64_CENTRAL_DIRECTORY_END = "PK", o.DATA_DESCRIPTOR = "PK\x07\b";
    }, {}], 24: [function(r, a, o) {
      var l = r("./GenericWorker"), d = r("../utils");
      function c(f) {
        l.call(this, "ConvertWorker to " + f), this.destType = f;
      }
      d.inherits(c, l), c.prototype.processChunk = function(f) {
        this.push({ data: d.transformTo(this.destType, f.data), meta: f.meta });
      }, a.exports = c;
    }, { "../utils": 32, "./GenericWorker": 28 }], 25: [function(r, a, o) {
      var l = r("./GenericWorker"), d = r("../crc32");
      function c() {
        l.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
      }
      r("../utils").inherits(c, l), c.prototype.processChunk = function(f) {
        this.streamInfo.crc32 = d(f.data, this.streamInfo.crc32 || 0), this.push(f);
      }, a.exports = c;
    }, { "../crc32": 4, "../utils": 32, "./GenericWorker": 28 }], 26: [function(r, a, o) {
      var l = r("../utils"), d = r("./GenericWorker");
      function c(f) {
        d.call(this, "DataLengthProbe for " + f), this.propName = f, this.withStreamInfo(f, 0);
      }
      l.inherits(c, d), c.prototype.processChunk = function(f) {
        if (f) {
          var s = this.streamInfo[this.propName] || 0;
          this.streamInfo[this.propName] = s + f.data.length;
        }
        d.prototype.processChunk.call(this, f);
      }, a.exports = c;
    }, { "../utils": 32, "./GenericWorker": 28 }], 27: [function(r, a, o) {
      var l = r("../utils"), d = r("./GenericWorker");
      function c(f) {
        d.call(this, "DataWorker");
        var s = this;
        this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, f.then(function(h) {
          s.dataIsReady = !0, s.data = h, s.max = h && h.length || 0, s.type = l.getTypeOf(h), s.isPaused || s._tickAndRepeat();
        }, function(h) {
          s.error(h);
        });
      }
      l.inherits(c, d), c.prototype.cleanUp = function() {
        d.prototype.cleanUp.call(this), this.data = null;
      }, c.prototype.resume = function() {
        return !!d.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, l.delay(this._tickAndRepeat, [], this)), !0);
      }, c.prototype._tickAndRepeat = function() {
        this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (l.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
      }, c.prototype._tick = function() {
        if (this.isPaused || this.isFinished) return !1;
        var f = null, s = Math.min(this.max, this.index + 16384);
        if (this.index >= this.max) return this.end();
        switch (this.type) {
          case "string":
            f = this.data.substring(this.index, s);
            break;
          case "uint8array":
            f = this.data.subarray(this.index, s);
            break;
          case "array":
          case "nodebuffer":
            f = this.data.slice(this.index, s);
        }
        return this.index = s, this.push({ data: f, meta: { percent: this.max ? this.index / this.max * 100 : 0 } });
      }, a.exports = c;
    }, { "../utils": 32, "./GenericWorker": 28 }], 28: [function(r, a, o) {
      function l(d) {
        this.name = d || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = { data: [], end: [], error: [] }, this.previous = null;
      }
      l.prototype = { push: function(d) {
        this.emit("data", d);
      }, end: function() {
        if (this.isFinished) return !1;
        this.flush();
        try {
          this.emit("end"), this.cleanUp(), this.isFinished = !0;
        } catch (d) {
          this.emit("error", d);
        }
        return !0;
      }, error: function(d) {
        return !this.isFinished && (this.isPaused ? this.generatedError = d : (this.isFinished = !0, this.emit("error", d), this.previous && this.previous.error(d), this.cleanUp()), !0);
      }, on: function(d, c) {
        return this._listeners[d].push(c), this;
      }, cleanUp: function() {
        this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
      }, emit: function(d, c) {
        if (this._listeners[d]) for (var f = 0; f < this._listeners[d].length; f++) this._listeners[d][f].call(this, c);
      }, pipe: function(d) {
        return d.registerPrevious(this);
      }, registerPrevious: function(d) {
        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
        this.streamInfo = d.streamInfo, this.mergeStreamInfo(), this.previous = d;
        var c = this;
        return d.on("data", function(f) {
          c.processChunk(f);
        }), d.on("end", function() {
          c.end();
        }), d.on("error", function(f) {
          c.error(f);
        }), this;
      }, pause: function() {
        return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
      }, resume: function() {
        if (!this.isPaused || this.isFinished) return !1;
        var d = this.isPaused = !1;
        return this.generatedError && (this.error(this.generatedError), d = !0), this.previous && this.previous.resume(), !d;
      }, flush: function() {
      }, processChunk: function(d) {
        this.push(d);
      }, withStreamInfo: function(d, c) {
        return this.extraStreamInfo[d] = c, this.mergeStreamInfo(), this;
      }, mergeStreamInfo: function() {
        for (var d in this.extraStreamInfo) Object.prototype.hasOwnProperty.call(this.extraStreamInfo, d) && (this.streamInfo[d] = this.extraStreamInfo[d]);
      }, lock: function() {
        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
        this.isLocked = !0, this.previous && this.previous.lock();
      }, toString: function() {
        var d = "Worker " + this.name;
        return this.previous ? this.previous + " -> " + d : d;
      } }, a.exports = l;
    }, {}], 29: [function(r, a, o) {
      var l = r("../utils"), d = r("./ConvertWorker"), c = r("./GenericWorker"), f = r("../base64"), s = r("../support"), h = r("../external"), g = null;
      if (s.nodestream) try {
        g = r("../nodejs/NodejsStreamOutputAdapter");
      } catch {
      }
      function t(m, v) {
        return new h.Promise(function(E, S) {
          var y = [], x = m._internalType, b = m._outputType, u = m._mimeType;
          m.on("data", function(I, O) {
            y.push(I), v && v(O);
          }).on("error", function(I) {
            y = [], S(I);
          }).on("end", function() {
            try {
              var I = function(O, D, $) {
                switch (O) {
                  case "blob":
                    return l.newBlob(l.transformTo("arraybuffer", D), $);
                  case "base64":
                    return f.encode(D);
                  default:
                    return l.transformTo(O, D);
                }
              }(b, function(O, D) {
                var $, K = 0, H = null, B = 0;
                for ($ = 0; $ < D.length; $++) B += D[$].length;
                switch (O) {
                  case "string":
                    return D.join("");
                  case "array":
                    return Array.prototype.concat.apply([], D);
                  case "uint8array":
                    for (H = new Uint8Array(B), $ = 0; $ < D.length; $++) H.set(D[$], K), K += D[$].length;
                    return H;
                  case "nodebuffer":
                    return Buffer.concat(D);
                  default:
                    throw new Error("concat : unsupported type '" + O + "'");
                }
              }(x, y), u);
              E(I);
            } catch (O) {
              S(O);
            }
            y = [];
          }).resume();
        });
      }
      function i(m, v, E) {
        var S = v;
        switch (v) {
          case "blob":
          case "arraybuffer":
            S = "uint8array";
            break;
          case "base64":
            S = "string";
        }
        try {
          this._internalType = S, this._outputType = v, this._mimeType = E, l.checkSupport(S), this._worker = m.pipe(new d(S)), m.lock();
        } catch (y) {
          this._worker = new c("error"), this._worker.error(y);
        }
      }
      i.prototype = { accumulate: function(m) {
        return t(this, m);
      }, on: function(m, v) {
        var E = this;
        return m === "data" ? this._worker.on(m, function(S) {
          v.call(E, S.data, S.meta);
        }) : this._worker.on(m, function() {
          l.delay(v, arguments, E);
        }), this;
      }, resume: function() {
        return l.delay(this._worker.resume, [], this._worker), this;
      }, pause: function() {
        return this._worker.pause(), this;
      }, toNodejsStream: function(m) {
        if (l.checkSupport("nodestream"), this._outputType !== "nodebuffer") throw new Error(this._outputType + " is not supported by this method");
        return new g(this, { objectMode: this._outputType !== "nodebuffer" }, m);
      } }, a.exports = i;
    }, { "../base64": 1, "../external": 6, "../nodejs/NodejsStreamOutputAdapter": 13, "../support": 30, "../utils": 32, "./ConvertWorker": 24, "./GenericWorker": 28 }], 30: [function(r, a, o) {
      if (o.base64 = !0, o.array = !0, o.string = !0, o.arraybuffer = typeof ArrayBuffer < "u" && typeof Uint8Array < "u", o.nodebuffer = typeof Buffer < "u", o.uint8array = typeof Uint8Array < "u", typeof ArrayBuffer > "u") o.blob = !1;
      else {
        var l = new ArrayBuffer(0);
        try {
          o.blob = new Blob([l], { type: "application/zip" }).size === 0;
        } catch {
          try {
            var d = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
            d.append(l), o.blob = d.getBlob("application/zip").size === 0;
          } catch {
            o.blob = !1;
          }
        }
      }
      try {
        o.nodestream = !!r("readable-stream").Readable;
      } catch {
        o.nodestream = !1;
      }
    }, { "readable-stream": 16 }], 31: [function(r, a, o) {
      for (var l = r("./utils"), d = r("./support"), c = r("./nodejsUtils"), f = r("./stream/GenericWorker"), s = new Array(256), h = 0; h < 256; h++) s[h] = 252 <= h ? 6 : 248 <= h ? 5 : 240 <= h ? 4 : 224 <= h ? 3 : 192 <= h ? 2 : 1;
      s[254] = s[254] = 1;
      function g() {
        f.call(this, "utf-8 decode"), this.leftOver = null;
      }
      function t() {
        f.call(this, "utf-8 encode");
      }
      o.utf8encode = function(i) {
        return d.nodebuffer ? c.newBufferFrom(i, "utf-8") : function(m) {
          var v, E, S, y, x, b = m.length, u = 0;
          for (y = 0; y < b; y++) (64512 & (E = m.charCodeAt(y))) == 55296 && y + 1 < b && (64512 & (S = m.charCodeAt(y + 1))) == 56320 && (E = 65536 + (E - 55296 << 10) + (S - 56320), y++), u += E < 128 ? 1 : E < 2048 ? 2 : E < 65536 ? 3 : 4;
          for (v = d.uint8array ? new Uint8Array(u) : new Array(u), y = x = 0; x < u; y++) (64512 & (E = m.charCodeAt(y))) == 55296 && y + 1 < b && (64512 & (S = m.charCodeAt(y + 1))) == 56320 && (E = 65536 + (E - 55296 << 10) + (S - 56320), y++), E < 128 ? v[x++] = E : (E < 2048 ? v[x++] = 192 | E >>> 6 : (E < 65536 ? v[x++] = 224 | E >>> 12 : (v[x++] = 240 | E >>> 18, v[x++] = 128 | E >>> 12 & 63), v[x++] = 128 | E >>> 6 & 63), v[x++] = 128 | 63 & E);
          return v;
        }(i);
      }, o.utf8decode = function(i) {
        return d.nodebuffer ? l.transformTo("nodebuffer", i).toString("utf-8") : function(m) {
          var v, E, S, y, x = m.length, b = new Array(2 * x);
          for (v = E = 0; v < x; ) if ((S = m[v++]) < 128) b[E++] = S;
          else if (4 < (y = s[S])) b[E++] = 65533, v += y - 1;
          else {
            for (S &= y === 2 ? 31 : y === 3 ? 15 : 7; 1 < y && v < x; ) S = S << 6 | 63 & m[v++], y--;
            1 < y ? b[E++] = 65533 : S < 65536 ? b[E++] = S : (S -= 65536, b[E++] = 55296 | S >> 10 & 1023, b[E++] = 56320 | 1023 & S);
          }
          return b.length !== E && (b.subarray ? b = b.subarray(0, E) : b.length = E), l.applyFromCharCode(b);
        }(i = l.transformTo(d.uint8array ? "uint8array" : "array", i));
      }, l.inherits(g, f), g.prototype.processChunk = function(i) {
        var m = l.transformTo(d.uint8array ? "uint8array" : "array", i.data);
        if (this.leftOver && this.leftOver.length) {
          if (d.uint8array) {
            var v = m;
            (m = new Uint8Array(v.length + this.leftOver.length)).set(this.leftOver, 0), m.set(v, this.leftOver.length);
          } else m = this.leftOver.concat(m);
          this.leftOver = null;
        }
        var E = function(y, x) {
          var b;
          for ((x = x || y.length) > y.length && (x = y.length), b = x - 1; 0 <= b && (192 & y[b]) == 128; ) b--;
          return b < 0 || b === 0 ? x : b + s[y[b]] > x ? b : x;
        }(m), S = m;
        E !== m.length && (d.uint8array ? (S = m.subarray(0, E), this.leftOver = m.subarray(E, m.length)) : (S = m.slice(0, E), this.leftOver = m.slice(E, m.length))), this.push({ data: o.utf8decode(S), meta: i.meta });
      }, g.prototype.flush = function() {
        this.leftOver && this.leftOver.length && (this.push({ data: o.utf8decode(this.leftOver), meta: {} }), this.leftOver = null);
      }, o.Utf8DecodeWorker = g, l.inherits(t, f), t.prototype.processChunk = function(i) {
        this.push({ data: o.utf8encode(i.data), meta: i.meta });
      }, o.Utf8EncodeWorker = t;
    }, { "./nodejsUtils": 14, "./stream/GenericWorker": 28, "./support": 30, "./utils": 32 }], 32: [function(r, a, o) {
      var l = r("./support"), d = r("./base64"), c = r("./nodejsUtils"), f = r("./external");
      function s(v) {
        return v;
      }
      function h(v, E) {
        for (var S = 0; S < v.length; ++S) E[S] = 255 & v.charCodeAt(S);
        return E;
      }
      r("setimmediate"), o.newBlob = function(v, E) {
        o.checkSupport("blob");
        try {
          return new Blob([v], { type: E });
        } catch {
          try {
            var S = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
            return S.append(v), S.getBlob(E);
          } catch {
            throw new Error("Bug : can't construct the Blob.");
          }
        }
      };
      var g = { stringifyByChunk: function(v, E, S) {
        var y = [], x = 0, b = v.length;
        if (b <= S) return String.fromCharCode.apply(null, v);
        for (; x < b; ) E === "array" || E === "nodebuffer" ? y.push(String.fromCharCode.apply(null, v.slice(x, Math.min(x + S, b)))) : y.push(String.fromCharCode.apply(null, v.subarray(x, Math.min(x + S, b)))), x += S;
        return y.join("");
      }, stringifyByChar: function(v) {
        for (var E = "", S = 0; S < v.length; S++) E += String.fromCharCode(v[S]);
        return E;
      }, applyCanBeUsed: { uint8array: function() {
        try {
          return l.uint8array && String.fromCharCode.apply(null, new Uint8Array(1)).length === 1;
        } catch {
          return !1;
        }
      }(), nodebuffer: function() {
        try {
          return l.nodebuffer && String.fromCharCode.apply(null, c.allocBuffer(1)).length === 1;
        } catch {
          return !1;
        }
      }() } };
      function t(v) {
        var E = 65536, S = o.getTypeOf(v), y = !0;
        if (S === "uint8array" ? y = g.applyCanBeUsed.uint8array : S === "nodebuffer" && (y = g.applyCanBeUsed.nodebuffer), y) for (; 1 < E; ) try {
          return g.stringifyByChunk(v, S, E);
        } catch {
          E = Math.floor(E / 2);
        }
        return g.stringifyByChar(v);
      }
      function i(v, E) {
        for (var S = 0; S < v.length; S++) E[S] = v[S];
        return E;
      }
      o.applyFromCharCode = t;
      var m = {};
      m.string = { string: s, array: function(v) {
        return h(v, new Array(v.length));
      }, arraybuffer: function(v) {
        return m.string.uint8array(v).buffer;
      }, uint8array: function(v) {
        return h(v, new Uint8Array(v.length));
      }, nodebuffer: function(v) {
        return h(v, c.allocBuffer(v.length));
      } }, m.array = { string: t, array: s, arraybuffer: function(v) {
        return new Uint8Array(v).buffer;
      }, uint8array: function(v) {
        return new Uint8Array(v);
      }, nodebuffer: function(v) {
        return c.newBufferFrom(v);
      } }, m.arraybuffer = { string: function(v) {
        return t(new Uint8Array(v));
      }, array: function(v) {
        return i(new Uint8Array(v), new Array(v.byteLength));
      }, arraybuffer: s, uint8array: function(v) {
        return new Uint8Array(v);
      }, nodebuffer: function(v) {
        return c.newBufferFrom(new Uint8Array(v));
      } }, m.uint8array = { string: t, array: function(v) {
        return i(v, new Array(v.length));
      }, arraybuffer: function(v) {
        return v.buffer;
      }, uint8array: s, nodebuffer: function(v) {
        return c.newBufferFrom(v);
      } }, m.nodebuffer = { string: t, array: function(v) {
        return i(v, new Array(v.length));
      }, arraybuffer: function(v) {
        return m.nodebuffer.uint8array(v).buffer;
      }, uint8array: function(v) {
        return i(v, new Uint8Array(v.length));
      }, nodebuffer: s }, o.transformTo = function(v, E) {
        if (E = E || "", !v) return E;
        o.checkSupport(v);
        var S = o.getTypeOf(E);
        return m[S][v](E);
      }, o.resolve = function(v) {
        for (var E = v.split("/"), S = [], y = 0; y < E.length; y++) {
          var x = E[y];
          x === "." || x === "" && y !== 0 && y !== E.length - 1 || (x === ".." ? S.pop() : S.push(x));
        }
        return S.join("/");
      }, o.getTypeOf = function(v) {
        return typeof v == "string" ? "string" : Object.prototype.toString.call(v) === "[object Array]" ? "array" : l.nodebuffer && c.isBuffer(v) ? "nodebuffer" : l.uint8array && v instanceof Uint8Array ? "uint8array" : l.arraybuffer && v instanceof ArrayBuffer ? "arraybuffer" : void 0;
      }, o.checkSupport = function(v) {
        if (!l[v.toLowerCase()]) throw new Error(v + " is not supported by this platform");
      }, o.MAX_VALUE_16BITS = 65535, o.MAX_VALUE_32BITS = -1, o.pretty = function(v) {
        var E, S, y = "";
        for (S = 0; S < (v || "").length; S++) y += "\\x" + ((E = v.charCodeAt(S)) < 16 ? "0" : "") + E.toString(16).toUpperCase();
        return y;
      }, o.delay = function(v, E, S) {
        setImmediate(function() {
          v.apply(S || null, E || []);
        });
      }, o.inherits = function(v, E) {
        function S() {
        }
        S.prototype = E.prototype, v.prototype = new S();
      }, o.extend = function() {
        var v, E, S = {};
        for (v = 0; v < arguments.length; v++) for (E in arguments[v]) Object.prototype.hasOwnProperty.call(arguments[v], E) && S[E] === void 0 && (S[E] = arguments[v][E]);
        return S;
      }, o.prepareContent = function(v, E, S, y, x) {
        return f.Promise.resolve(E).then(function(b) {
          return l.blob && (b instanceof Blob || ["[object File]", "[object Blob]"].indexOf(Object.prototype.toString.call(b)) !== -1) && typeof FileReader < "u" ? new f.Promise(function(u, I) {
            var O = new FileReader();
            O.onload = function(D) {
              u(D.target.result);
            }, O.onerror = function(D) {
              I(D.target.error);
            }, O.readAsArrayBuffer(b);
          }) : b;
        }).then(function(b) {
          var u = o.getTypeOf(b);
          return u ? (u === "arraybuffer" ? b = o.transformTo("uint8array", b) : u === "string" && (x ? b = d.decode(b) : S && y !== !0 && (b = function(I) {
            return h(I, l.uint8array ? new Uint8Array(I.length) : new Array(I.length));
          }(b))), b) : f.Promise.reject(new Error("Can't read the data of '" + v + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
        });
      };
    }, { "./base64": 1, "./external": 6, "./nodejsUtils": 14, "./support": 30, setimmediate: 54 }], 33: [function(r, a, o) {
      var l = r("./reader/readerFor"), d = r("./utils"), c = r("./signature"), f = r("./zipEntry"), s = r("./support");
      function h(g) {
        this.files = [], this.loadOptions = g;
      }
      h.prototype = { checkSignature: function(g) {
        if (!this.reader.readAndCheckSignature(g)) {
          this.reader.index -= 4;
          var t = this.reader.readString(4);
          throw new Error("Corrupted zip or bug: unexpected signature (" + d.pretty(t) + ", expected " + d.pretty(g) + ")");
        }
      }, isSignature: function(g, t) {
        var i = this.reader.index;
        this.reader.setIndex(g);
        var m = this.reader.readString(4) === t;
        return this.reader.setIndex(i), m;
      }, readBlockEndOfCentral: function() {
        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
        var g = this.reader.readData(this.zipCommentLength), t = s.uint8array ? "uint8array" : "array", i = d.transformTo(t, g);
        this.zipComment = this.loadOptions.decodeFileName(i);
      }, readBlockZip64EndOfCentral: function() {
        this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
        for (var g, t, i, m = this.zip64EndOfCentralSize - 44; 0 < m; ) g = this.reader.readInt(2), t = this.reader.readInt(4), i = this.reader.readData(t), this.zip64ExtensibleData[g] = { id: g, length: t, value: i };
      }, readBlockZip64EndOfCentralLocator: function() {
        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
      }, readLocalFiles: function() {
        var g, t;
        for (g = 0; g < this.files.length; g++) t = this.files[g], this.reader.setIndex(t.localHeaderOffset), this.checkSignature(c.LOCAL_FILE_HEADER), t.readLocalPart(this.reader), t.handleUTF8(), t.processAttributes();
      }, readCentralDir: function() {
        var g;
        for (this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(c.CENTRAL_FILE_HEADER); ) (g = new f({ zip64: this.zip64 }, this.loadOptions)).readCentralPart(this.reader), this.files.push(g);
        if (this.centralDirRecords !== this.files.length && this.centralDirRecords !== 0 && this.files.length === 0) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
      }, readEndOfCentral: function() {
        var g = this.reader.lastIndexOfSignature(c.CENTRAL_DIRECTORY_END);
        if (g < 0) throw this.isSignature(0, c.LOCAL_FILE_HEADER) ? new Error("Corrupted zip: can't find end of central directory") : new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
        this.reader.setIndex(g);
        var t = g;
        if (this.checkSignature(c.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === d.MAX_VALUE_16BITS || this.diskWithCentralDirStart === d.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === d.MAX_VALUE_16BITS || this.centralDirRecords === d.MAX_VALUE_16BITS || this.centralDirSize === d.MAX_VALUE_32BITS || this.centralDirOffset === d.MAX_VALUE_32BITS) {
          if (this.zip64 = !0, (g = this.reader.lastIndexOfSignature(c.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
          if (this.reader.setIndex(g), this.checkSignature(c.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, c.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(c.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
          this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(c.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
        }
        var i = this.centralDirOffset + this.centralDirSize;
        this.zip64 && (i += 20, i += 12 + this.zip64EndOfCentralSize);
        var m = t - i;
        if (0 < m) this.isSignature(t, c.CENTRAL_FILE_HEADER) || (this.reader.zero = m);
        else if (m < 0) throw new Error("Corrupted zip: missing " + Math.abs(m) + " bytes.");
      }, prepareReader: function(g) {
        this.reader = l(g);
      }, load: function(g) {
        this.prepareReader(g), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
      } }, a.exports = h;
    }, { "./reader/readerFor": 22, "./signature": 23, "./support": 30, "./utils": 32, "./zipEntry": 34 }], 34: [function(r, a, o) {
      var l = r("./reader/readerFor"), d = r("./utils"), c = r("./compressedObject"), f = r("./crc32"), s = r("./utf8"), h = r("./compressions"), g = r("./support");
      function t(i, m) {
        this.options = i, this.loadOptions = m;
      }
      t.prototype = { isEncrypted: function() {
        return (1 & this.bitFlag) == 1;
      }, useUTF8: function() {
        return (2048 & this.bitFlag) == 2048;
      }, readLocalPart: function(i) {
        var m, v;
        if (i.skip(22), this.fileNameLength = i.readInt(2), v = i.readInt(2), this.fileName = i.readData(this.fileNameLength), i.skip(v), this.compressedSize === -1 || this.uncompressedSize === -1) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
        if ((m = function(E) {
          for (var S in h) if (Object.prototype.hasOwnProperty.call(h, S) && h[S].magic === E) return h[S];
          return null;
        }(this.compressionMethod)) === null) throw new Error("Corrupted zip : compression " + d.pretty(this.compressionMethod) + " unknown (inner file : " + d.transformTo("string", this.fileName) + ")");
        this.decompressed = new c(this.compressedSize, this.uncompressedSize, this.crc32, m, i.readData(this.compressedSize));
      }, readCentralPart: function(i) {
        this.versionMadeBy = i.readInt(2), i.skip(2), this.bitFlag = i.readInt(2), this.compressionMethod = i.readString(2), this.date = i.readDate(), this.crc32 = i.readInt(4), this.compressedSize = i.readInt(4), this.uncompressedSize = i.readInt(4);
        var m = i.readInt(2);
        if (this.extraFieldsLength = i.readInt(2), this.fileCommentLength = i.readInt(2), this.diskNumberStart = i.readInt(2), this.internalFileAttributes = i.readInt(2), this.externalFileAttributes = i.readInt(4), this.localHeaderOffset = i.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
        i.skip(m), this.readExtraFields(i), this.parseZIP64ExtraField(i), this.fileComment = i.readData(this.fileCommentLength);
      }, processAttributes: function() {
        this.unixPermissions = null, this.dosPermissions = null;
        var i = this.versionMadeBy >> 8;
        this.dir = !!(16 & this.externalFileAttributes), i == 0 && (this.dosPermissions = 63 & this.externalFileAttributes), i == 3 && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || this.fileNameStr.slice(-1) !== "/" || (this.dir = !0);
      }, parseZIP64ExtraField: function() {
        if (this.extraFields[1]) {
          var i = l(this.extraFields[1].value);
          this.uncompressedSize === d.MAX_VALUE_32BITS && (this.uncompressedSize = i.readInt(8)), this.compressedSize === d.MAX_VALUE_32BITS && (this.compressedSize = i.readInt(8)), this.localHeaderOffset === d.MAX_VALUE_32BITS && (this.localHeaderOffset = i.readInt(8)), this.diskNumberStart === d.MAX_VALUE_32BITS && (this.diskNumberStart = i.readInt(4));
        }
      }, readExtraFields: function(i) {
        var m, v, E, S = i.index + this.extraFieldsLength;
        for (this.extraFields || (this.extraFields = {}); i.index + 4 < S; ) m = i.readInt(2), v = i.readInt(2), E = i.readData(v), this.extraFields[m] = { id: m, length: v, value: E };
        i.setIndex(S);
      }, handleUTF8: function() {
        var i = g.uint8array ? "uint8array" : "array";
        if (this.useUTF8()) this.fileNameStr = s.utf8decode(this.fileName), this.fileCommentStr = s.utf8decode(this.fileComment);
        else {
          var m = this.findExtraFieldUnicodePath();
          if (m !== null) this.fileNameStr = m;
          else {
            var v = d.transformTo(i, this.fileName);
            this.fileNameStr = this.loadOptions.decodeFileName(v);
          }
          var E = this.findExtraFieldUnicodeComment();
          if (E !== null) this.fileCommentStr = E;
          else {
            var S = d.transformTo(i, this.fileComment);
            this.fileCommentStr = this.loadOptions.decodeFileName(S);
          }
        }
      }, findExtraFieldUnicodePath: function() {
        var i = this.extraFields[28789];
        if (i) {
          var m = l(i.value);
          return m.readInt(1) !== 1 || f(this.fileName) !== m.readInt(4) ? null : s.utf8decode(m.readData(i.length - 5));
        }
        return null;
      }, findExtraFieldUnicodeComment: function() {
        var i = this.extraFields[25461];
        if (i) {
          var m = l(i.value);
          return m.readInt(1) !== 1 || f(this.fileComment) !== m.readInt(4) ? null : s.utf8decode(m.readData(i.length - 5));
        }
        return null;
      } }, a.exports = t;
    }, { "./compressedObject": 2, "./compressions": 3, "./crc32": 4, "./reader/readerFor": 22, "./support": 30, "./utf8": 31, "./utils": 32 }], 35: [function(r, a, o) {
      function l(m, v, E) {
        this.name = m, this.dir = E.dir, this.date = E.date, this.comment = E.comment, this.unixPermissions = E.unixPermissions, this.dosPermissions = E.dosPermissions, this._data = v, this._dataBinary = E.binary, this.options = { compression: E.compression, compressionOptions: E.compressionOptions };
      }
      var d = r("./stream/StreamHelper"), c = r("./stream/DataWorker"), f = r("./utf8"), s = r("./compressedObject"), h = r("./stream/GenericWorker");
      l.prototype = { internalStream: function(m) {
        var v = null, E = "string";
        try {
          if (!m) throw new Error("No output type specified.");
          var S = (E = m.toLowerCase()) === "string" || E === "text";
          E !== "binarystring" && E !== "text" || (E = "string"), v = this._decompressWorker();
          var y = !this._dataBinary;
          y && !S && (v = v.pipe(new f.Utf8EncodeWorker())), !y && S && (v = v.pipe(new f.Utf8DecodeWorker()));
        } catch (x) {
          (v = new h("error")).error(x);
        }
        return new d(v, E, "");
      }, async: function(m, v) {
        return this.internalStream(m).accumulate(v);
      }, nodeStream: function(m, v) {
        return this.internalStream(m || "nodebuffer").toNodejsStream(v);
      }, _compressWorker: function(m, v) {
        if (this._data instanceof s && this._data.compression.magic === m.magic) return this._data.getCompressedWorker();
        var E = this._decompressWorker();
        return this._dataBinary || (E = E.pipe(new f.Utf8EncodeWorker())), s.createWorkerFrom(E, m, v);
      }, _decompressWorker: function() {
        return this._data instanceof s ? this._data.getContentWorker() : this._data instanceof h ? this._data : new c(this._data);
      } };
      for (var g = ["asText", "asBinary", "asNodeBuffer", "asUint8Array", "asArrayBuffer"], t = function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, i = 0; i < g.length; i++) l.prototype[g[i]] = t;
      a.exports = l;
    }, { "./compressedObject": 2, "./stream/DataWorker": 27, "./stream/GenericWorker": 28, "./stream/StreamHelper": 29, "./utf8": 31 }], 36: [function(r, a, o) {
      (function(l) {
        var d, c, f = l.MutationObserver || l.WebKitMutationObserver;
        if (f) {
          var s = 0, h = new f(m), g = l.document.createTextNode("");
          h.observe(g, { characterData: !0 }), d = function() {
            g.data = s = ++s % 2;
          };
        } else if (l.setImmediate || l.MessageChannel === void 0) d = "document" in l && "onreadystatechange" in l.document.createElement("script") ? function() {
          var v = l.document.createElement("script");
          v.onreadystatechange = function() {
            m(), v.onreadystatechange = null, v.parentNode.removeChild(v), v = null;
          }, l.document.documentElement.appendChild(v);
        } : function() {
          setTimeout(m, 0);
        };
        else {
          var t = new l.MessageChannel();
          t.port1.onmessage = m, d = function() {
            t.port2.postMessage(0);
          };
        }
        var i = [];
        function m() {
          var v, E;
          c = !0;
          for (var S = i.length; S; ) {
            for (E = i, i = [], v = -1; ++v < S; ) E[v]();
            S = i.length;
          }
          c = !1;
        }
        a.exports = function(v) {
          i.push(v) !== 1 || c || d();
        };
      }).call(this, typeof Mi < "u" ? Mi : typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, {}], 37: [function(r, a, o) {
      var l = r("immediate");
      function d() {
      }
      var c = {}, f = ["REJECTED"], s = ["FULFILLED"], h = ["PENDING"];
      function g(S) {
        if (typeof S != "function") throw new TypeError("resolver must be a function");
        this.state = h, this.queue = [], this.outcome = void 0, S !== d && v(this, S);
      }
      function t(S, y, x) {
        this.promise = S, typeof y == "function" && (this.onFulfilled = y, this.callFulfilled = this.otherCallFulfilled), typeof x == "function" && (this.onRejected = x, this.callRejected = this.otherCallRejected);
      }
      function i(S, y, x) {
        l(function() {
          var b;
          try {
            b = y(x);
          } catch (u) {
            return c.reject(S, u);
          }
          b === S ? c.reject(S, new TypeError("Cannot resolve promise with itself")) : c.resolve(S, b);
        });
      }
      function m(S) {
        var y = S && S.then;
        if (S && (typeof S == "object" || typeof S == "function") && typeof y == "function") return function() {
          y.apply(S, arguments);
        };
      }
      function v(S, y) {
        var x = !1;
        function b(O) {
          x || (x = !0, c.reject(S, O));
        }
        function u(O) {
          x || (x = !0, c.resolve(S, O));
        }
        var I = E(function() {
          y(u, b);
        });
        I.status === "error" && b(I.value);
      }
      function E(S, y) {
        var x = {};
        try {
          x.value = S(y), x.status = "success";
        } catch (b) {
          x.status = "error", x.value = b;
        }
        return x;
      }
      (a.exports = g).prototype.finally = function(S) {
        if (typeof S != "function") return this;
        var y = this.constructor;
        return this.then(function(x) {
          return y.resolve(S()).then(function() {
            return x;
          });
        }, function(x) {
          return y.resolve(S()).then(function() {
            throw x;
          });
        });
      }, g.prototype.catch = function(S) {
        return this.then(null, S);
      }, g.prototype.then = function(S, y) {
        if (typeof S != "function" && this.state === s || typeof y != "function" && this.state === f) return this;
        var x = new this.constructor(d);
        return this.state !== h ? i(x, this.state === s ? S : y, this.outcome) : this.queue.push(new t(x, S, y)), x;
      }, t.prototype.callFulfilled = function(S) {
        c.resolve(this.promise, S);
      }, t.prototype.otherCallFulfilled = function(S) {
        i(this.promise, this.onFulfilled, S);
      }, t.prototype.callRejected = function(S) {
        c.reject(this.promise, S);
      }, t.prototype.otherCallRejected = function(S) {
        i(this.promise, this.onRejected, S);
      }, c.resolve = function(S, y) {
        var x = E(m, y);
        if (x.status === "error") return c.reject(S, x.value);
        var b = x.value;
        if (b) v(S, b);
        else {
          S.state = s, S.outcome = y;
          for (var u = -1, I = S.queue.length; ++u < I; ) S.queue[u].callFulfilled(y);
        }
        return S;
      }, c.reject = function(S, y) {
        S.state = f, S.outcome = y;
        for (var x = -1, b = S.queue.length; ++x < b; ) S.queue[x].callRejected(y);
        return S;
      }, g.resolve = function(S) {
        return S instanceof this ? S : c.resolve(new this(d), S);
      }, g.reject = function(S) {
        var y = new this(d);
        return c.reject(y, S);
      }, g.all = function(S) {
        var y = this;
        if (Object.prototype.toString.call(S) !== "[object Array]") return this.reject(new TypeError("must be an array"));
        var x = S.length, b = !1;
        if (!x) return this.resolve([]);
        for (var u = new Array(x), I = 0, O = -1, D = new this(d); ++O < x; ) $(S[O], O);
        return D;
        function $(K, H) {
          y.resolve(K).then(function(B) {
            u[H] = B, ++I !== x || b || (b = !0, c.resolve(D, u));
          }, function(B) {
            b || (b = !0, c.reject(D, B));
          });
        }
      }, g.race = function(S) {
        var y = this;
        if (Object.prototype.toString.call(S) !== "[object Array]") return this.reject(new TypeError("must be an array"));
        var x = S.length, b = !1;
        if (!x) return this.resolve([]);
        for (var u = -1, I = new this(d); ++u < x; ) O = S[u], y.resolve(O).then(function(D) {
          b || (b = !0, c.resolve(I, D));
        }, function(D) {
          b || (b = !0, c.reject(I, D));
        });
        var O;
        return I;
      };
    }, { immediate: 36 }], 38: [function(r, a, o) {
      var l = {};
      (0, r("./lib/utils/common").assign)(l, r("./lib/deflate"), r("./lib/inflate"), r("./lib/zlib/constants")), a.exports = l;
    }, { "./lib/deflate": 39, "./lib/inflate": 40, "./lib/utils/common": 41, "./lib/zlib/constants": 44 }], 39: [function(r, a, o) {
      var l = r("./zlib/deflate"), d = r("./utils/common"), c = r("./utils/strings"), f = r("./zlib/messages"), s = r("./zlib/zstream"), h = Object.prototype.toString, g = 0, t = -1, i = 0, m = 8;
      function v(S) {
        if (!(this instanceof v)) return new v(S);
        this.options = d.assign({ level: t, method: m, chunkSize: 16384, windowBits: 15, memLevel: 8, strategy: i, to: "" }, S || {});
        var y = this.options;
        y.raw && 0 < y.windowBits ? y.windowBits = -y.windowBits : y.gzip && 0 < y.windowBits && y.windowBits < 16 && (y.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new s(), this.strm.avail_out = 0;
        var x = l.deflateInit2(this.strm, y.level, y.method, y.windowBits, y.memLevel, y.strategy);
        if (x !== g) throw new Error(f[x]);
        if (y.header && l.deflateSetHeader(this.strm, y.header), y.dictionary) {
          var b;
          if (b = typeof y.dictionary == "string" ? c.string2buf(y.dictionary) : h.call(y.dictionary) === "[object ArrayBuffer]" ? new Uint8Array(y.dictionary) : y.dictionary, (x = l.deflateSetDictionary(this.strm, b)) !== g) throw new Error(f[x]);
          this._dict_set = !0;
        }
      }
      function E(S, y) {
        var x = new v(y);
        if (x.push(S, !0), x.err) throw x.msg || f[x.err];
        return x.result;
      }
      v.prototype.push = function(S, y) {
        var x, b, u = this.strm, I = this.options.chunkSize;
        if (this.ended) return !1;
        b = y === ~~y ? y : y === !0 ? 4 : 0, typeof S == "string" ? u.input = c.string2buf(S) : h.call(S) === "[object ArrayBuffer]" ? u.input = new Uint8Array(S) : u.input = S, u.next_in = 0, u.avail_in = u.input.length;
        do {
          if (u.avail_out === 0 && (u.output = new d.Buf8(I), u.next_out = 0, u.avail_out = I), (x = l.deflate(u, b)) !== 1 && x !== g) return this.onEnd(x), !(this.ended = !0);
          u.avail_out !== 0 && (u.avail_in !== 0 || b !== 4 && b !== 2) || (this.options.to === "string" ? this.onData(c.buf2binstring(d.shrinkBuf(u.output, u.next_out))) : this.onData(d.shrinkBuf(u.output, u.next_out)));
        } while ((0 < u.avail_in || u.avail_out === 0) && x !== 1);
        return b === 4 ? (x = l.deflateEnd(this.strm), this.onEnd(x), this.ended = !0, x === g) : b !== 2 || (this.onEnd(g), !(u.avail_out = 0));
      }, v.prototype.onData = function(S) {
        this.chunks.push(S);
      }, v.prototype.onEnd = function(S) {
        S === g && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = d.flattenChunks(this.chunks)), this.chunks = [], this.err = S, this.msg = this.strm.msg;
      }, o.Deflate = v, o.deflate = E, o.deflateRaw = function(S, y) {
        return (y = y || {}).raw = !0, E(S, y);
      }, o.gzip = function(S, y) {
        return (y = y || {}).gzip = !0, E(S, y);
      };
    }, { "./utils/common": 41, "./utils/strings": 42, "./zlib/deflate": 46, "./zlib/messages": 51, "./zlib/zstream": 53 }], 40: [function(r, a, o) {
      var l = r("./zlib/inflate"), d = r("./utils/common"), c = r("./utils/strings"), f = r("./zlib/constants"), s = r("./zlib/messages"), h = r("./zlib/zstream"), g = r("./zlib/gzheader"), t = Object.prototype.toString;
      function i(v) {
        if (!(this instanceof i)) return new i(v);
        this.options = d.assign({ chunkSize: 16384, windowBits: 0, to: "" }, v || {});
        var E = this.options;
        E.raw && 0 <= E.windowBits && E.windowBits < 16 && (E.windowBits = -E.windowBits, E.windowBits === 0 && (E.windowBits = -15)), !(0 <= E.windowBits && E.windowBits < 16) || v && v.windowBits || (E.windowBits += 32), 15 < E.windowBits && E.windowBits < 48 && !(15 & E.windowBits) && (E.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new h(), this.strm.avail_out = 0;
        var S = l.inflateInit2(this.strm, E.windowBits);
        if (S !== f.Z_OK) throw new Error(s[S]);
        this.header = new g(), l.inflateGetHeader(this.strm, this.header);
      }
      function m(v, E) {
        var S = new i(E);
        if (S.push(v, !0), S.err) throw S.msg || s[S.err];
        return S.result;
      }
      i.prototype.push = function(v, E) {
        var S, y, x, b, u, I, O = this.strm, D = this.options.chunkSize, $ = this.options.dictionary, K = !1;
        if (this.ended) return !1;
        y = E === ~~E ? E : E === !0 ? f.Z_FINISH : f.Z_NO_FLUSH, typeof v == "string" ? O.input = c.binstring2buf(v) : t.call(v) === "[object ArrayBuffer]" ? O.input = new Uint8Array(v) : O.input = v, O.next_in = 0, O.avail_in = O.input.length;
        do {
          if (O.avail_out === 0 && (O.output = new d.Buf8(D), O.next_out = 0, O.avail_out = D), (S = l.inflate(O, f.Z_NO_FLUSH)) === f.Z_NEED_DICT && $ && (I = typeof $ == "string" ? c.string2buf($) : t.call($) === "[object ArrayBuffer]" ? new Uint8Array($) : $, S = l.inflateSetDictionary(this.strm, I)), S === f.Z_BUF_ERROR && K === !0 && (S = f.Z_OK, K = !1), S !== f.Z_STREAM_END && S !== f.Z_OK) return this.onEnd(S), !(this.ended = !0);
          O.next_out && (O.avail_out !== 0 && S !== f.Z_STREAM_END && (O.avail_in !== 0 || y !== f.Z_FINISH && y !== f.Z_SYNC_FLUSH) || (this.options.to === "string" ? (x = c.utf8border(O.output, O.next_out), b = O.next_out - x, u = c.buf2string(O.output, x), O.next_out = b, O.avail_out = D - b, b && d.arraySet(O.output, O.output, x, b, 0), this.onData(u)) : this.onData(d.shrinkBuf(O.output, O.next_out)))), O.avail_in === 0 && O.avail_out === 0 && (K = !0);
        } while ((0 < O.avail_in || O.avail_out === 0) && S !== f.Z_STREAM_END);
        return S === f.Z_STREAM_END && (y = f.Z_FINISH), y === f.Z_FINISH ? (S = l.inflateEnd(this.strm), this.onEnd(S), this.ended = !0, S === f.Z_OK) : y !== f.Z_SYNC_FLUSH || (this.onEnd(f.Z_OK), !(O.avail_out = 0));
      }, i.prototype.onData = function(v) {
        this.chunks.push(v);
      }, i.prototype.onEnd = function(v) {
        v === f.Z_OK && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = d.flattenChunks(this.chunks)), this.chunks = [], this.err = v, this.msg = this.strm.msg;
      }, o.Inflate = i, o.inflate = m, o.inflateRaw = function(v, E) {
        return (E = E || {}).raw = !0, m(v, E);
      }, o.ungzip = m;
    }, { "./utils/common": 41, "./utils/strings": 42, "./zlib/constants": 44, "./zlib/gzheader": 47, "./zlib/inflate": 49, "./zlib/messages": 51, "./zlib/zstream": 53 }], 41: [function(r, a, o) {
      var l = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
      o.assign = function(f) {
        for (var s = Array.prototype.slice.call(arguments, 1); s.length; ) {
          var h = s.shift();
          if (h) {
            if (typeof h != "object") throw new TypeError(h + "must be non-object");
            for (var g in h) h.hasOwnProperty(g) && (f[g] = h[g]);
          }
        }
        return f;
      }, o.shrinkBuf = function(f, s) {
        return f.length === s ? f : f.subarray ? f.subarray(0, s) : (f.length = s, f);
      };
      var d = { arraySet: function(f, s, h, g, t) {
        if (s.subarray && f.subarray) f.set(s.subarray(h, h + g), t);
        else for (var i = 0; i < g; i++) f[t + i] = s[h + i];
      }, flattenChunks: function(f) {
        var s, h, g, t, i, m;
        for (s = g = 0, h = f.length; s < h; s++) g += f[s].length;
        for (m = new Uint8Array(g), s = t = 0, h = f.length; s < h; s++) i = f[s], m.set(i, t), t += i.length;
        return m;
      } }, c = { arraySet: function(f, s, h, g, t) {
        for (var i = 0; i < g; i++) f[t + i] = s[h + i];
      }, flattenChunks: function(f) {
        return [].concat.apply([], f);
      } };
      o.setTyped = function(f) {
        f ? (o.Buf8 = Uint8Array, o.Buf16 = Uint16Array, o.Buf32 = Int32Array, o.assign(o, d)) : (o.Buf8 = Array, o.Buf16 = Array, o.Buf32 = Array, o.assign(o, c));
      }, o.setTyped(l);
    }, {}], 42: [function(r, a, o) {
      var l = r("./common"), d = !0, c = !0;
      try {
        String.fromCharCode.apply(null, [0]);
      } catch {
        d = !1;
      }
      try {
        String.fromCharCode.apply(null, new Uint8Array(1));
      } catch {
        c = !1;
      }
      for (var f = new l.Buf8(256), s = 0; s < 256; s++) f[s] = 252 <= s ? 6 : 248 <= s ? 5 : 240 <= s ? 4 : 224 <= s ? 3 : 192 <= s ? 2 : 1;
      function h(g, t) {
        if (t < 65537 && (g.subarray && c || !g.subarray && d)) return String.fromCharCode.apply(null, l.shrinkBuf(g, t));
        for (var i = "", m = 0; m < t; m++) i += String.fromCharCode(g[m]);
        return i;
      }
      f[254] = f[254] = 1, o.string2buf = function(g) {
        var t, i, m, v, E, S = g.length, y = 0;
        for (v = 0; v < S; v++) (64512 & (i = g.charCodeAt(v))) == 55296 && v + 1 < S && (64512 & (m = g.charCodeAt(v + 1))) == 56320 && (i = 65536 + (i - 55296 << 10) + (m - 56320), v++), y += i < 128 ? 1 : i < 2048 ? 2 : i < 65536 ? 3 : 4;
        for (t = new l.Buf8(y), v = E = 0; E < y; v++) (64512 & (i = g.charCodeAt(v))) == 55296 && v + 1 < S && (64512 & (m = g.charCodeAt(v + 1))) == 56320 && (i = 65536 + (i - 55296 << 10) + (m - 56320), v++), i < 128 ? t[E++] = i : (i < 2048 ? t[E++] = 192 | i >>> 6 : (i < 65536 ? t[E++] = 224 | i >>> 12 : (t[E++] = 240 | i >>> 18, t[E++] = 128 | i >>> 12 & 63), t[E++] = 128 | i >>> 6 & 63), t[E++] = 128 | 63 & i);
        return t;
      }, o.buf2binstring = function(g) {
        return h(g, g.length);
      }, o.binstring2buf = function(g) {
        for (var t = new l.Buf8(g.length), i = 0, m = t.length; i < m; i++) t[i] = g.charCodeAt(i);
        return t;
      }, o.buf2string = function(g, t) {
        var i, m, v, E, S = t || g.length, y = new Array(2 * S);
        for (i = m = 0; i < S; ) if ((v = g[i++]) < 128) y[m++] = v;
        else if (4 < (E = f[v])) y[m++] = 65533, i += E - 1;
        else {
          for (v &= E === 2 ? 31 : E === 3 ? 15 : 7; 1 < E && i < S; ) v = v << 6 | 63 & g[i++], E--;
          1 < E ? y[m++] = 65533 : v < 65536 ? y[m++] = v : (v -= 65536, y[m++] = 55296 | v >> 10 & 1023, y[m++] = 56320 | 1023 & v);
        }
        return h(y, m);
      }, o.utf8border = function(g, t) {
        var i;
        for ((t = t || g.length) > g.length && (t = g.length), i = t - 1; 0 <= i && (192 & g[i]) == 128; ) i--;
        return i < 0 || i === 0 ? t : i + f[g[i]] > t ? i : t;
      };
    }, { "./common": 41 }], 43: [function(r, a, o) {
      a.exports = function(l, d, c, f) {
        for (var s = 65535 & l | 0, h = l >>> 16 & 65535 | 0, g = 0; c !== 0; ) {
          for (c -= g = 2e3 < c ? 2e3 : c; h = h + (s = s + d[f++] | 0) | 0, --g; ) ;
          s %= 65521, h %= 65521;
        }
        return s | h << 16 | 0;
      };
    }, {}], 44: [function(r, a, o) {
      a.exports = { Z_NO_FLUSH: 0, Z_PARTIAL_FLUSH: 1, Z_SYNC_FLUSH: 2, Z_FULL_FLUSH: 3, Z_FINISH: 4, Z_BLOCK: 5, Z_TREES: 6, Z_OK: 0, Z_STREAM_END: 1, Z_NEED_DICT: 2, Z_ERRNO: -1, Z_STREAM_ERROR: -2, Z_DATA_ERROR: -3, Z_BUF_ERROR: -5, Z_NO_COMPRESSION: 0, Z_BEST_SPEED: 1, Z_BEST_COMPRESSION: 9, Z_DEFAULT_COMPRESSION: -1, Z_FILTERED: 1, Z_HUFFMAN_ONLY: 2, Z_RLE: 3, Z_FIXED: 4, Z_DEFAULT_STRATEGY: 0, Z_BINARY: 0, Z_TEXT: 1, Z_UNKNOWN: 2, Z_DEFLATED: 8 };
    }, {}], 45: [function(r, a, o) {
      var l = function() {
        for (var d, c = [], f = 0; f < 256; f++) {
          d = f;
          for (var s = 0; s < 8; s++) d = 1 & d ? 3988292384 ^ d >>> 1 : d >>> 1;
          c[f] = d;
        }
        return c;
      }();
      a.exports = function(d, c, f, s) {
        var h = l, g = s + f;
        d ^= -1;
        for (var t = s; t < g; t++) d = d >>> 8 ^ h[255 & (d ^ c[t])];
        return -1 ^ d;
      };
    }, {}], 46: [function(r, a, o) {
      var l, d = r("../utils/common"), c = r("./trees"), f = r("./adler32"), s = r("./crc32"), h = r("./messages"), g = 0, t = 4, i = 0, m = -2, v = -1, E = 4, S = 2, y = 8, x = 9, b = 286, u = 30, I = 19, O = 2 * b + 1, D = 15, $ = 3, K = 258, H = K + $ + 1, B = 42, R = 113, _ = 1, A = 2, k = 3, z = 4;
      function T(Y, ae) {
        return Y.msg = h[ae], ae;
      }
      function w(Y) {
        return (Y << 1) - (4 < Y ? 9 : 0);
      }
      function F(Y) {
        for (var ae = Y.length; 0 <= --ae; ) Y[ae] = 0;
      }
      function j(Y) {
        var ae = Y.state, se = ae.pending;
        se > Y.avail_out && (se = Y.avail_out), se !== 0 && (d.arraySet(Y.output, ae.pending_buf, ae.pending_out, se, Y.next_out), Y.next_out += se, ae.pending_out += se, Y.total_out += se, Y.avail_out -= se, ae.pending -= se, ae.pending === 0 && (ae.pending_out = 0));
      }
      function P(Y, ae) {
        c._tr_flush_block(Y, 0 <= Y.block_start ? Y.block_start : -1, Y.strstart - Y.block_start, ae), Y.block_start = Y.strstart, j(Y.strm);
      }
      function V(Y, ae) {
        Y.pending_buf[Y.pending++] = ae;
      }
      function J(Y, ae) {
        Y.pending_buf[Y.pending++] = ae >>> 8 & 255, Y.pending_buf[Y.pending++] = 255 & ae;
      }
      function ne(Y, ae) {
        var se, L, W = Y.max_chain_length, M = Y.strstart, X = Y.prev_length, U = Y.nice_match, Q = Y.strstart > Y.w_size - H ? Y.strstart - (Y.w_size - H) : 0, re = Y.window, le = Y.w_mask, ce = Y.prev, ee = Y.strstart + K, he = re[M + X - 1], pe = re[M + X];
        Y.prev_length >= Y.good_match && (W >>= 2), U > Y.lookahead && (U = Y.lookahead);
        do
          if (re[(se = ae) + X] === pe && re[se + X - 1] === he && re[se] === re[M] && re[++se] === re[M + 1]) {
            M += 2, se++;
            do
              ;
            while (re[++M] === re[++se] && re[++M] === re[++se] && re[++M] === re[++se] && re[++M] === re[++se] && re[++M] === re[++se] && re[++M] === re[++se] && re[++M] === re[++se] && re[++M] === re[++se] && M < ee);
            if (L = K - (ee - M), M = ee - K, X < L) {
              if (Y.match_start = ae, U <= (X = L)) break;
              he = re[M + X - 1], pe = re[M + X];
            }
          }
        while ((ae = ce[ae & le]) > Q && --W != 0);
        return X <= Y.lookahead ? X : Y.lookahead;
      }
      function Z(Y) {
        var ae, se, L, W, M, X, U, Q, re, le, ce = Y.w_size;
        do {
          if (W = Y.window_size - Y.lookahead - Y.strstart, Y.strstart >= ce + (ce - H)) {
            for (d.arraySet(Y.window, Y.window, ce, ce, 0), Y.match_start -= ce, Y.strstart -= ce, Y.block_start -= ce, ae = se = Y.hash_size; L = Y.head[--ae], Y.head[ae] = ce <= L ? L - ce : 0, --se; ) ;
            for (ae = se = ce; L = Y.prev[--ae], Y.prev[ae] = ce <= L ? L - ce : 0, --se; ) ;
            W += ce;
          }
          if (Y.strm.avail_in === 0) break;
          if (X = Y.strm, U = Y.window, Q = Y.strstart + Y.lookahead, re = W, le = void 0, le = X.avail_in, re < le && (le = re), se = le === 0 ? 0 : (X.avail_in -= le, d.arraySet(U, X.input, X.next_in, le, Q), X.state.wrap === 1 ? X.adler = f(X.adler, U, le, Q) : X.state.wrap === 2 && (X.adler = s(X.adler, U, le, Q)), X.next_in += le, X.total_in += le, le), Y.lookahead += se, Y.lookahead + Y.insert >= $) for (M = Y.strstart - Y.insert, Y.ins_h = Y.window[M], Y.ins_h = (Y.ins_h << Y.hash_shift ^ Y.window[M + 1]) & Y.hash_mask; Y.insert && (Y.ins_h = (Y.ins_h << Y.hash_shift ^ Y.window[M + $ - 1]) & Y.hash_mask, Y.prev[M & Y.w_mask] = Y.head[Y.ins_h], Y.head[Y.ins_h] = M, M++, Y.insert--, !(Y.lookahead + Y.insert < $)); ) ;
        } while (Y.lookahead < H && Y.strm.avail_in !== 0);
      }
      function te(Y, ae) {
        for (var se, L; ; ) {
          if (Y.lookahead < H) {
            if (Z(Y), Y.lookahead < H && ae === g) return _;
            if (Y.lookahead === 0) break;
          }
          if (se = 0, Y.lookahead >= $ && (Y.ins_h = (Y.ins_h << Y.hash_shift ^ Y.window[Y.strstart + $ - 1]) & Y.hash_mask, se = Y.prev[Y.strstart & Y.w_mask] = Y.head[Y.ins_h], Y.head[Y.ins_h] = Y.strstart), se !== 0 && Y.strstart - se <= Y.w_size - H && (Y.match_length = ne(Y, se)), Y.match_length >= $) if (L = c._tr_tally(Y, Y.strstart - Y.match_start, Y.match_length - $), Y.lookahead -= Y.match_length, Y.match_length <= Y.max_lazy_match && Y.lookahead >= $) {
            for (Y.match_length--; Y.strstart++, Y.ins_h = (Y.ins_h << Y.hash_shift ^ Y.window[Y.strstart + $ - 1]) & Y.hash_mask, se = Y.prev[Y.strstart & Y.w_mask] = Y.head[Y.ins_h], Y.head[Y.ins_h] = Y.strstart, --Y.match_length != 0; ) ;
            Y.strstart++;
          } else Y.strstart += Y.match_length, Y.match_length = 0, Y.ins_h = Y.window[Y.strstart], Y.ins_h = (Y.ins_h << Y.hash_shift ^ Y.window[Y.strstart + 1]) & Y.hash_mask;
          else L = c._tr_tally(Y, 0, Y.window[Y.strstart]), Y.lookahead--, Y.strstart++;
          if (L && (P(Y, !1), Y.strm.avail_out === 0)) return _;
        }
        return Y.insert = Y.strstart < $ - 1 ? Y.strstart : $ - 1, ae === t ? (P(Y, !0), Y.strm.avail_out === 0 ? k : z) : Y.last_lit && (P(Y, !1), Y.strm.avail_out === 0) ? _ : A;
      }
      function G(Y, ae) {
        for (var se, L, W; ; ) {
          if (Y.lookahead < H) {
            if (Z(Y), Y.lookahead < H && ae === g) return _;
            if (Y.lookahead === 0) break;
          }
          if (se = 0, Y.lookahead >= $ && (Y.ins_h = (Y.ins_h << Y.hash_shift ^ Y.window[Y.strstart + $ - 1]) & Y.hash_mask, se = Y.prev[Y.strstart & Y.w_mask] = Y.head[Y.ins_h], Y.head[Y.ins_h] = Y.strstart), Y.prev_length = Y.match_length, Y.prev_match = Y.match_start, Y.match_length = $ - 1, se !== 0 && Y.prev_length < Y.max_lazy_match && Y.strstart - se <= Y.w_size - H && (Y.match_length = ne(Y, se), Y.match_length <= 5 && (Y.strategy === 1 || Y.match_length === $ && 4096 < Y.strstart - Y.match_start) && (Y.match_length = $ - 1)), Y.prev_length >= $ && Y.match_length <= Y.prev_length) {
            for (W = Y.strstart + Y.lookahead - $, L = c._tr_tally(Y, Y.strstart - 1 - Y.prev_match, Y.prev_length - $), Y.lookahead -= Y.prev_length - 1, Y.prev_length -= 2; ++Y.strstart <= W && (Y.ins_h = (Y.ins_h << Y.hash_shift ^ Y.window[Y.strstart + $ - 1]) & Y.hash_mask, se = Y.prev[Y.strstart & Y.w_mask] = Y.head[Y.ins_h], Y.head[Y.ins_h] = Y.strstart), --Y.prev_length != 0; ) ;
            if (Y.match_available = 0, Y.match_length = $ - 1, Y.strstart++, L && (P(Y, !1), Y.strm.avail_out === 0)) return _;
          } else if (Y.match_available) {
            if ((L = c._tr_tally(Y, 0, Y.window[Y.strstart - 1])) && P(Y, !1), Y.strstart++, Y.lookahead--, Y.strm.avail_out === 0) return _;
          } else Y.match_available = 1, Y.strstart++, Y.lookahead--;
        }
        return Y.match_available && (L = c._tr_tally(Y, 0, Y.window[Y.strstart - 1]), Y.match_available = 0), Y.insert = Y.strstart < $ - 1 ? Y.strstart : $ - 1, ae === t ? (P(Y, !0), Y.strm.avail_out === 0 ? k : z) : Y.last_lit && (P(Y, !1), Y.strm.avail_out === 0) ? _ : A;
      }
      function N(Y, ae, se, L, W) {
        this.good_length = Y, this.max_lazy = ae, this.nice_length = se, this.max_chain = L, this.func = W;
      }
      function q() {
        this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = y, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new d.Buf16(2 * O), this.dyn_dtree = new d.Buf16(2 * (2 * u + 1)), this.bl_tree = new d.Buf16(2 * (2 * I + 1)), F(this.dyn_ltree), F(this.dyn_dtree), F(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new d.Buf16(D + 1), this.heap = new d.Buf16(2 * b + 1), F(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new d.Buf16(2 * b + 1), F(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
      }
      function ie(Y) {
        var ae;
        return Y && Y.state ? (Y.total_in = Y.total_out = 0, Y.data_type = S, (ae = Y.state).pending = 0, ae.pending_out = 0, ae.wrap < 0 && (ae.wrap = -ae.wrap), ae.status = ae.wrap ? B : R, Y.adler = ae.wrap === 2 ? 0 : 1, ae.last_flush = g, c._tr_init(ae), i) : T(Y, m);
      }
      function oe(Y) {
        var ae = ie(Y);
        return ae === i && function(se) {
          se.window_size = 2 * se.w_size, F(se.head), se.max_lazy_match = l[se.level].max_lazy, se.good_match = l[se.level].good_length, se.nice_match = l[se.level].nice_length, se.max_chain_length = l[se.level].max_chain, se.strstart = 0, se.block_start = 0, se.lookahead = 0, se.insert = 0, se.match_length = se.prev_length = $ - 1, se.match_available = 0, se.ins_h = 0;
        }(Y.state), ae;
      }
      function fe(Y, ae, se, L, W, M) {
        if (!Y) return m;
        var X = 1;
        if (ae === v && (ae = 6), L < 0 ? (X = 0, L = -L) : 15 < L && (X = 2, L -= 16), W < 1 || x < W || se !== y || L < 8 || 15 < L || ae < 0 || 9 < ae || M < 0 || E < M) return T(Y, m);
        L === 8 && (L = 9);
        var U = new q();
        return (Y.state = U).strm = Y, U.wrap = X, U.gzhead = null, U.w_bits = L, U.w_size = 1 << U.w_bits, U.w_mask = U.w_size - 1, U.hash_bits = W + 7, U.hash_size = 1 << U.hash_bits, U.hash_mask = U.hash_size - 1, U.hash_shift = ~~((U.hash_bits + $ - 1) / $), U.window = new d.Buf8(2 * U.w_size), U.head = new d.Buf16(U.hash_size), U.prev = new d.Buf16(U.w_size), U.lit_bufsize = 1 << W + 6, U.pending_buf_size = 4 * U.lit_bufsize, U.pending_buf = new d.Buf8(U.pending_buf_size), U.d_buf = 1 * U.lit_bufsize, U.l_buf = 3 * U.lit_bufsize, U.level = ae, U.strategy = M, U.method = se, oe(Y);
      }
      l = [new N(0, 0, 0, 0, function(Y, ae) {
        var se = 65535;
        for (se > Y.pending_buf_size - 5 && (se = Y.pending_buf_size - 5); ; ) {
          if (Y.lookahead <= 1) {
            if (Z(Y), Y.lookahead === 0 && ae === g) return _;
            if (Y.lookahead === 0) break;
          }
          Y.strstart += Y.lookahead, Y.lookahead = 0;
          var L = Y.block_start + se;
          if ((Y.strstart === 0 || Y.strstart >= L) && (Y.lookahead = Y.strstart - L, Y.strstart = L, P(Y, !1), Y.strm.avail_out === 0) || Y.strstart - Y.block_start >= Y.w_size - H && (P(Y, !1), Y.strm.avail_out === 0)) return _;
        }
        return Y.insert = 0, ae === t ? (P(Y, !0), Y.strm.avail_out === 0 ? k : z) : (Y.strstart > Y.block_start && (P(Y, !1), Y.strm.avail_out), _);
      }), new N(4, 4, 8, 4, te), new N(4, 5, 16, 8, te), new N(4, 6, 32, 32, te), new N(4, 4, 16, 16, G), new N(8, 16, 32, 32, G), new N(8, 16, 128, 128, G), new N(8, 32, 128, 256, G), new N(32, 128, 258, 1024, G), new N(32, 258, 258, 4096, G)], o.deflateInit = function(Y, ae) {
        return fe(Y, ae, y, 15, 8, 0);
      }, o.deflateInit2 = fe, o.deflateReset = oe, o.deflateResetKeep = ie, o.deflateSetHeader = function(Y, ae) {
        return Y && Y.state ? Y.state.wrap !== 2 ? m : (Y.state.gzhead = ae, i) : m;
      }, o.deflate = function(Y, ae) {
        var se, L, W, M;
        if (!Y || !Y.state || 5 < ae || ae < 0) return Y ? T(Y, m) : m;
        if (L = Y.state, !Y.output || !Y.input && Y.avail_in !== 0 || L.status === 666 && ae !== t) return T(Y, Y.avail_out === 0 ? -5 : m);
        if (L.strm = Y, se = L.last_flush, L.last_flush = ae, L.status === B) if (L.wrap === 2) Y.adler = 0, V(L, 31), V(L, 139), V(L, 8), L.gzhead ? (V(L, (L.gzhead.text ? 1 : 0) + (L.gzhead.hcrc ? 2 : 0) + (L.gzhead.extra ? 4 : 0) + (L.gzhead.name ? 8 : 0) + (L.gzhead.comment ? 16 : 0)), V(L, 255 & L.gzhead.time), V(L, L.gzhead.time >> 8 & 255), V(L, L.gzhead.time >> 16 & 255), V(L, L.gzhead.time >> 24 & 255), V(L, L.level === 9 ? 2 : 2 <= L.strategy || L.level < 2 ? 4 : 0), V(L, 255 & L.gzhead.os), L.gzhead.extra && L.gzhead.extra.length && (V(L, 255 & L.gzhead.extra.length), V(L, L.gzhead.extra.length >> 8 & 255)), L.gzhead.hcrc && (Y.adler = s(Y.adler, L.pending_buf, L.pending, 0)), L.gzindex = 0, L.status = 69) : (V(L, 0), V(L, 0), V(L, 0), V(L, 0), V(L, 0), V(L, L.level === 9 ? 2 : 2 <= L.strategy || L.level < 2 ? 4 : 0), V(L, 3), L.status = R);
        else {
          var X = y + (L.w_bits - 8 << 4) << 8;
          X |= (2 <= L.strategy || L.level < 2 ? 0 : L.level < 6 ? 1 : L.level === 6 ? 2 : 3) << 6, L.strstart !== 0 && (X |= 32), X += 31 - X % 31, L.status = R, J(L, X), L.strstart !== 0 && (J(L, Y.adler >>> 16), J(L, 65535 & Y.adler)), Y.adler = 1;
        }
        if (L.status === 69) if (L.gzhead.extra) {
          for (W = L.pending; L.gzindex < (65535 & L.gzhead.extra.length) && (L.pending !== L.pending_buf_size || (L.gzhead.hcrc && L.pending > W && (Y.adler = s(Y.adler, L.pending_buf, L.pending - W, W)), j(Y), W = L.pending, L.pending !== L.pending_buf_size)); ) V(L, 255 & L.gzhead.extra[L.gzindex]), L.gzindex++;
          L.gzhead.hcrc && L.pending > W && (Y.adler = s(Y.adler, L.pending_buf, L.pending - W, W)), L.gzindex === L.gzhead.extra.length && (L.gzindex = 0, L.status = 73);
        } else L.status = 73;
        if (L.status === 73) if (L.gzhead.name) {
          W = L.pending;
          do {
            if (L.pending === L.pending_buf_size && (L.gzhead.hcrc && L.pending > W && (Y.adler = s(Y.adler, L.pending_buf, L.pending - W, W)), j(Y), W = L.pending, L.pending === L.pending_buf_size)) {
              M = 1;
              break;
            }
            M = L.gzindex < L.gzhead.name.length ? 255 & L.gzhead.name.charCodeAt(L.gzindex++) : 0, V(L, M);
          } while (M !== 0);
          L.gzhead.hcrc && L.pending > W && (Y.adler = s(Y.adler, L.pending_buf, L.pending - W, W)), M === 0 && (L.gzindex = 0, L.status = 91);
        } else L.status = 91;
        if (L.status === 91) if (L.gzhead.comment) {
          W = L.pending;
          do {
            if (L.pending === L.pending_buf_size && (L.gzhead.hcrc && L.pending > W && (Y.adler = s(Y.adler, L.pending_buf, L.pending - W, W)), j(Y), W = L.pending, L.pending === L.pending_buf_size)) {
              M = 1;
              break;
            }
            M = L.gzindex < L.gzhead.comment.length ? 255 & L.gzhead.comment.charCodeAt(L.gzindex++) : 0, V(L, M);
          } while (M !== 0);
          L.gzhead.hcrc && L.pending > W && (Y.adler = s(Y.adler, L.pending_buf, L.pending - W, W)), M === 0 && (L.status = 103);
        } else L.status = 103;
        if (L.status === 103 && (L.gzhead.hcrc ? (L.pending + 2 > L.pending_buf_size && j(Y), L.pending + 2 <= L.pending_buf_size && (V(L, 255 & Y.adler), V(L, Y.adler >> 8 & 255), Y.adler = 0, L.status = R)) : L.status = R), L.pending !== 0) {
          if (j(Y), Y.avail_out === 0) return L.last_flush = -1, i;
        } else if (Y.avail_in === 0 && w(ae) <= w(se) && ae !== t) return T(Y, -5);
        if (L.status === 666 && Y.avail_in !== 0) return T(Y, -5);
        if (Y.avail_in !== 0 || L.lookahead !== 0 || ae !== g && L.status !== 666) {
          var U = L.strategy === 2 ? function(Q, re) {
            for (var le; ; ) {
              if (Q.lookahead === 0 && (Z(Q), Q.lookahead === 0)) {
                if (re === g) return _;
                break;
              }
              if (Q.match_length = 0, le = c._tr_tally(Q, 0, Q.window[Q.strstart]), Q.lookahead--, Q.strstart++, le && (P(Q, !1), Q.strm.avail_out === 0)) return _;
            }
            return Q.insert = 0, re === t ? (P(Q, !0), Q.strm.avail_out === 0 ? k : z) : Q.last_lit && (P(Q, !1), Q.strm.avail_out === 0) ? _ : A;
          }(L, ae) : L.strategy === 3 ? function(Q, re) {
            for (var le, ce, ee, he, pe = Q.window; ; ) {
              if (Q.lookahead <= K) {
                if (Z(Q), Q.lookahead <= K && re === g) return _;
                if (Q.lookahead === 0) break;
              }
              if (Q.match_length = 0, Q.lookahead >= $ && 0 < Q.strstart && (ce = pe[ee = Q.strstart - 1]) === pe[++ee] && ce === pe[++ee] && ce === pe[++ee]) {
                he = Q.strstart + K;
                do
                  ;
                while (ce === pe[++ee] && ce === pe[++ee] && ce === pe[++ee] && ce === pe[++ee] && ce === pe[++ee] && ce === pe[++ee] && ce === pe[++ee] && ce === pe[++ee] && ee < he);
                Q.match_length = K - (he - ee), Q.match_length > Q.lookahead && (Q.match_length = Q.lookahead);
              }
              if (Q.match_length >= $ ? (le = c._tr_tally(Q, 1, Q.match_length - $), Q.lookahead -= Q.match_length, Q.strstart += Q.match_length, Q.match_length = 0) : (le = c._tr_tally(Q, 0, Q.window[Q.strstart]), Q.lookahead--, Q.strstart++), le && (P(Q, !1), Q.strm.avail_out === 0)) return _;
            }
            return Q.insert = 0, re === t ? (P(Q, !0), Q.strm.avail_out === 0 ? k : z) : Q.last_lit && (P(Q, !1), Q.strm.avail_out === 0) ? _ : A;
          }(L, ae) : l[L.level].func(L, ae);
          if (U !== k && U !== z || (L.status = 666), U === _ || U === k) return Y.avail_out === 0 && (L.last_flush = -1), i;
          if (U === A && (ae === 1 ? c._tr_align(L) : ae !== 5 && (c._tr_stored_block(L, 0, 0, !1), ae === 3 && (F(L.head), L.lookahead === 0 && (L.strstart = 0, L.block_start = 0, L.insert = 0))), j(Y), Y.avail_out === 0)) return L.last_flush = -1, i;
        }
        return ae !== t ? i : L.wrap <= 0 ? 1 : (L.wrap === 2 ? (V(L, 255 & Y.adler), V(L, Y.adler >> 8 & 255), V(L, Y.adler >> 16 & 255), V(L, Y.adler >> 24 & 255), V(L, 255 & Y.total_in), V(L, Y.total_in >> 8 & 255), V(L, Y.total_in >> 16 & 255), V(L, Y.total_in >> 24 & 255)) : (J(L, Y.adler >>> 16), J(L, 65535 & Y.adler)), j(Y), 0 < L.wrap && (L.wrap = -L.wrap), L.pending !== 0 ? i : 1);
      }, o.deflateEnd = function(Y) {
        var ae;
        return Y && Y.state ? (ae = Y.state.status) !== B && ae !== 69 && ae !== 73 && ae !== 91 && ae !== 103 && ae !== R && ae !== 666 ? T(Y, m) : (Y.state = null, ae === R ? T(Y, -3) : i) : m;
      }, o.deflateSetDictionary = function(Y, ae) {
        var se, L, W, M, X, U, Q, re, le = ae.length;
        if (!Y || !Y.state || (M = (se = Y.state).wrap) === 2 || M === 1 && se.status !== B || se.lookahead) return m;
        for (M === 1 && (Y.adler = f(Y.adler, ae, le, 0)), se.wrap = 0, le >= se.w_size && (M === 0 && (F(se.head), se.strstart = 0, se.block_start = 0, se.insert = 0), re = new d.Buf8(se.w_size), d.arraySet(re, ae, le - se.w_size, se.w_size, 0), ae = re, le = se.w_size), X = Y.avail_in, U = Y.next_in, Q = Y.input, Y.avail_in = le, Y.next_in = 0, Y.input = ae, Z(se); se.lookahead >= $; ) {
          for (L = se.strstart, W = se.lookahead - ($ - 1); se.ins_h = (se.ins_h << se.hash_shift ^ se.window[L + $ - 1]) & se.hash_mask, se.prev[L & se.w_mask] = se.head[se.ins_h], se.head[se.ins_h] = L, L++, --W; ) ;
          se.strstart = L, se.lookahead = $ - 1, Z(se);
        }
        return se.strstart += se.lookahead, se.block_start = se.strstart, se.insert = se.lookahead, se.lookahead = 0, se.match_length = se.prev_length = $ - 1, se.match_available = 0, Y.next_in = U, Y.input = Q, Y.avail_in = X, se.wrap = M, i;
      }, o.deflateInfo = "pako deflate (from Nodeca project)";
    }, { "../utils/common": 41, "./adler32": 43, "./crc32": 45, "./messages": 51, "./trees": 52 }], 47: [function(r, a, o) {
      a.exports = function() {
        this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
      };
    }, {}], 48: [function(r, a, o) {
      a.exports = function(l, d) {
        var c, f, s, h, g, t, i, m, v, E, S, y, x, b, u, I, O, D, $, K, H, B, R, _, A;
        c = l.state, f = l.next_in, _ = l.input, s = f + (l.avail_in - 5), h = l.next_out, A = l.output, g = h - (d - l.avail_out), t = h + (l.avail_out - 257), i = c.dmax, m = c.wsize, v = c.whave, E = c.wnext, S = c.window, y = c.hold, x = c.bits, b = c.lencode, u = c.distcode, I = (1 << c.lenbits) - 1, O = (1 << c.distbits) - 1;
        e: do {
          x < 15 && (y += _[f++] << x, x += 8, y += _[f++] << x, x += 8), D = b[y & I];
          t: for (; ; ) {
            if (y >>>= $ = D >>> 24, x -= $, ($ = D >>> 16 & 255) === 0) A[h++] = 65535 & D;
            else {
              if (!(16 & $)) {
                if (!(64 & $)) {
                  D = b[(65535 & D) + (y & (1 << $) - 1)];
                  continue t;
                }
                if (32 & $) {
                  c.mode = 12;
                  break e;
                }
                l.msg = "invalid literal/length code", c.mode = 30;
                break e;
              }
              K = 65535 & D, ($ &= 15) && (x < $ && (y += _[f++] << x, x += 8), K += y & (1 << $) - 1, y >>>= $, x -= $), x < 15 && (y += _[f++] << x, x += 8, y += _[f++] << x, x += 8), D = u[y & O];
              n: for (; ; ) {
                if (y >>>= $ = D >>> 24, x -= $, !(16 & ($ = D >>> 16 & 255))) {
                  if (!(64 & $)) {
                    D = u[(65535 & D) + (y & (1 << $) - 1)];
                    continue n;
                  }
                  l.msg = "invalid distance code", c.mode = 30;
                  break e;
                }
                if (H = 65535 & D, x < ($ &= 15) && (y += _[f++] << x, (x += 8) < $ && (y += _[f++] << x, x += 8)), i < (H += y & (1 << $) - 1)) {
                  l.msg = "invalid distance too far back", c.mode = 30;
                  break e;
                }
                if (y >>>= $, x -= $, ($ = h - g) < H) {
                  if (v < ($ = H - $) && c.sane) {
                    l.msg = "invalid distance too far back", c.mode = 30;
                    break e;
                  }
                  if (R = S, (B = 0) === E) {
                    if (B += m - $, $ < K) {
                      for (K -= $; A[h++] = S[B++], --$; ) ;
                      B = h - H, R = A;
                    }
                  } else if (E < $) {
                    if (B += m + E - $, ($ -= E) < K) {
                      for (K -= $; A[h++] = S[B++], --$; ) ;
                      if (B = 0, E < K) {
                        for (K -= $ = E; A[h++] = S[B++], --$; ) ;
                        B = h - H, R = A;
                      }
                    }
                  } else if (B += E - $, $ < K) {
                    for (K -= $; A[h++] = S[B++], --$; ) ;
                    B = h - H, R = A;
                  }
                  for (; 2 < K; ) A[h++] = R[B++], A[h++] = R[B++], A[h++] = R[B++], K -= 3;
                  K && (A[h++] = R[B++], 1 < K && (A[h++] = R[B++]));
                } else {
                  for (B = h - H; A[h++] = A[B++], A[h++] = A[B++], A[h++] = A[B++], 2 < (K -= 3); ) ;
                  K && (A[h++] = A[B++], 1 < K && (A[h++] = A[B++]));
                }
                break;
              }
            }
            break;
          }
        } while (f < s && h < t);
        f -= K = x >> 3, y &= (1 << (x -= K << 3)) - 1, l.next_in = f, l.next_out = h, l.avail_in = f < s ? s - f + 5 : 5 - (f - s), l.avail_out = h < t ? t - h + 257 : 257 - (h - t), c.hold = y, c.bits = x;
      };
    }, {}], 49: [function(r, a, o) {
      var l = r("../utils/common"), d = r("./adler32"), c = r("./crc32"), f = r("./inffast"), s = r("./inftrees"), h = 1, g = 2, t = 0, i = -2, m = 1, v = 852, E = 592;
      function S(B) {
        return (B >>> 24 & 255) + (B >>> 8 & 65280) + ((65280 & B) << 8) + ((255 & B) << 24);
      }
      function y() {
        this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new l.Buf16(320), this.work = new l.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
      }
      function x(B) {
        var R;
        return B && B.state ? (R = B.state, B.total_in = B.total_out = R.total = 0, B.msg = "", R.wrap && (B.adler = 1 & R.wrap), R.mode = m, R.last = 0, R.havedict = 0, R.dmax = 32768, R.head = null, R.hold = 0, R.bits = 0, R.lencode = R.lendyn = new l.Buf32(v), R.distcode = R.distdyn = new l.Buf32(E), R.sane = 1, R.back = -1, t) : i;
      }
      function b(B) {
        var R;
        return B && B.state ? ((R = B.state).wsize = 0, R.whave = 0, R.wnext = 0, x(B)) : i;
      }
      function u(B, R) {
        var _, A;
        return B && B.state ? (A = B.state, R < 0 ? (_ = 0, R = -R) : (_ = 1 + (R >> 4), R < 48 && (R &= 15)), R && (R < 8 || 15 < R) ? i : (A.window !== null && A.wbits !== R && (A.window = null), A.wrap = _, A.wbits = R, b(B))) : i;
      }
      function I(B, R) {
        var _, A;
        return B ? (A = new y(), (B.state = A).window = null, (_ = u(B, R)) !== t && (B.state = null), _) : i;
      }
      var O, D, $ = !0;
      function K(B) {
        if ($) {
          var R;
          for (O = new l.Buf32(512), D = new l.Buf32(32), R = 0; R < 144; ) B.lens[R++] = 8;
          for (; R < 256; ) B.lens[R++] = 9;
          for (; R < 280; ) B.lens[R++] = 7;
          for (; R < 288; ) B.lens[R++] = 8;
          for (s(h, B.lens, 0, 288, O, 0, B.work, { bits: 9 }), R = 0; R < 32; ) B.lens[R++] = 5;
          s(g, B.lens, 0, 32, D, 0, B.work, { bits: 5 }), $ = !1;
        }
        B.lencode = O, B.lenbits = 9, B.distcode = D, B.distbits = 5;
      }
      function H(B, R, _, A) {
        var k, z = B.state;
        return z.window === null && (z.wsize = 1 << z.wbits, z.wnext = 0, z.whave = 0, z.window = new l.Buf8(z.wsize)), A >= z.wsize ? (l.arraySet(z.window, R, _ - z.wsize, z.wsize, 0), z.wnext = 0, z.whave = z.wsize) : (A < (k = z.wsize - z.wnext) && (k = A), l.arraySet(z.window, R, _ - A, k, z.wnext), (A -= k) ? (l.arraySet(z.window, R, _ - A, A, 0), z.wnext = A, z.whave = z.wsize) : (z.wnext += k, z.wnext === z.wsize && (z.wnext = 0), z.whave < z.wsize && (z.whave += k))), 0;
      }
      o.inflateReset = b, o.inflateReset2 = u, o.inflateResetKeep = x, o.inflateInit = function(B) {
        return I(B, 15);
      }, o.inflateInit2 = I, o.inflate = function(B, R) {
        var _, A, k, z, T, w, F, j, P, V, J, ne, Z, te, G, N, q, ie, oe, fe, Y, ae, se, L, W = 0, M = new l.Buf8(4), X = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
        if (!B || !B.state || !B.output || !B.input && B.avail_in !== 0) return i;
        (_ = B.state).mode === 12 && (_.mode = 13), T = B.next_out, k = B.output, F = B.avail_out, z = B.next_in, A = B.input, w = B.avail_in, j = _.hold, P = _.bits, V = w, J = F, ae = t;
        e: for (; ; ) switch (_.mode) {
          case m:
            if (_.wrap === 0) {
              _.mode = 13;
              break;
            }
            for (; P < 16; ) {
              if (w === 0) break e;
              w--, j += A[z++] << P, P += 8;
            }
            if (2 & _.wrap && j === 35615) {
              M[_.check = 0] = 255 & j, M[1] = j >>> 8 & 255, _.check = c(_.check, M, 2, 0), P = j = 0, _.mode = 2;
              break;
            }
            if (_.flags = 0, _.head && (_.head.done = !1), !(1 & _.wrap) || (((255 & j) << 8) + (j >> 8)) % 31) {
              B.msg = "incorrect header check", _.mode = 30;
              break;
            }
            if ((15 & j) != 8) {
              B.msg = "unknown compression method", _.mode = 30;
              break;
            }
            if (P -= 4, Y = 8 + (15 & (j >>>= 4)), _.wbits === 0) _.wbits = Y;
            else if (Y > _.wbits) {
              B.msg = "invalid window size", _.mode = 30;
              break;
            }
            _.dmax = 1 << Y, B.adler = _.check = 1, _.mode = 512 & j ? 10 : 12, P = j = 0;
            break;
          case 2:
            for (; P < 16; ) {
              if (w === 0) break e;
              w--, j += A[z++] << P, P += 8;
            }
            if (_.flags = j, (255 & _.flags) != 8) {
              B.msg = "unknown compression method", _.mode = 30;
              break;
            }
            if (57344 & _.flags) {
              B.msg = "unknown header flags set", _.mode = 30;
              break;
            }
            _.head && (_.head.text = j >> 8 & 1), 512 & _.flags && (M[0] = 255 & j, M[1] = j >>> 8 & 255, _.check = c(_.check, M, 2, 0)), P = j = 0, _.mode = 3;
          case 3:
            for (; P < 32; ) {
              if (w === 0) break e;
              w--, j += A[z++] << P, P += 8;
            }
            _.head && (_.head.time = j), 512 & _.flags && (M[0] = 255 & j, M[1] = j >>> 8 & 255, M[2] = j >>> 16 & 255, M[3] = j >>> 24 & 255, _.check = c(_.check, M, 4, 0)), P = j = 0, _.mode = 4;
          case 4:
            for (; P < 16; ) {
              if (w === 0) break e;
              w--, j += A[z++] << P, P += 8;
            }
            _.head && (_.head.xflags = 255 & j, _.head.os = j >> 8), 512 & _.flags && (M[0] = 255 & j, M[1] = j >>> 8 & 255, _.check = c(_.check, M, 2, 0)), P = j = 0, _.mode = 5;
          case 5:
            if (1024 & _.flags) {
              for (; P < 16; ) {
                if (w === 0) break e;
                w--, j += A[z++] << P, P += 8;
              }
              _.length = j, _.head && (_.head.extra_len = j), 512 & _.flags && (M[0] = 255 & j, M[1] = j >>> 8 & 255, _.check = c(_.check, M, 2, 0)), P = j = 0;
            } else _.head && (_.head.extra = null);
            _.mode = 6;
          case 6:
            if (1024 & _.flags && (w < (ne = _.length) && (ne = w), ne && (_.head && (Y = _.head.extra_len - _.length, _.head.extra || (_.head.extra = new Array(_.head.extra_len)), l.arraySet(_.head.extra, A, z, ne, Y)), 512 & _.flags && (_.check = c(_.check, A, ne, z)), w -= ne, z += ne, _.length -= ne), _.length)) break e;
            _.length = 0, _.mode = 7;
          case 7:
            if (2048 & _.flags) {
              if (w === 0) break e;
              for (ne = 0; Y = A[z + ne++], _.head && Y && _.length < 65536 && (_.head.name += String.fromCharCode(Y)), Y && ne < w; ) ;
              if (512 & _.flags && (_.check = c(_.check, A, ne, z)), w -= ne, z += ne, Y) break e;
            } else _.head && (_.head.name = null);
            _.length = 0, _.mode = 8;
          case 8:
            if (4096 & _.flags) {
              if (w === 0) break e;
              for (ne = 0; Y = A[z + ne++], _.head && Y && _.length < 65536 && (_.head.comment += String.fromCharCode(Y)), Y && ne < w; ) ;
              if (512 & _.flags && (_.check = c(_.check, A, ne, z)), w -= ne, z += ne, Y) break e;
            } else _.head && (_.head.comment = null);
            _.mode = 9;
          case 9:
            if (512 & _.flags) {
              for (; P < 16; ) {
                if (w === 0) break e;
                w--, j += A[z++] << P, P += 8;
              }
              if (j !== (65535 & _.check)) {
                B.msg = "header crc mismatch", _.mode = 30;
                break;
              }
              P = j = 0;
            }
            _.head && (_.head.hcrc = _.flags >> 9 & 1, _.head.done = !0), B.adler = _.check = 0, _.mode = 12;
            break;
          case 10:
            for (; P < 32; ) {
              if (w === 0) break e;
              w--, j += A[z++] << P, P += 8;
            }
            B.adler = _.check = S(j), P = j = 0, _.mode = 11;
          case 11:
            if (_.havedict === 0) return B.next_out = T, B.avail_out = F, B.next_in = z, B.avail_in = w, _.hold = j, _.bits = P, 2;
            B.adler = _.check = 1, _.mode = 12;
          case 12:
            if (R === 5 || R === 6) break e;
          case 13:
            if (_.last) {
              j >>>= 7 & P, P -= 7 & P, _.mode = 27;
              break;
            }
            for (; P < 3; ) {
              if (w === 0) break e;
              w--, j += A[z++] << P, P += 8;
            }
            switch (_.last = 1 & j, P -= 1, 3 & (j >>>= 1)) {
              case 0:
                _.mode = 14;
                break;
              case 1:
                if (K(_), _.mode = 20, R !== 6) break;
                j >>>= 2, P -= 2;
                break e;
              case 2:
                _.mode = 17;
                break;
              case 3:
                B.msg = "invalid block type", _.mode = 30;
            }
            j >>>= 2, P -= 2;
            break;
          case 14:
            for (j >>>= 7 & P, P -= 7 & P; P < 32; ) {
              if (w === 0) break e;
              w--, j += A[z++] << P, P += 8;
            }
            if ((65535 & j) != (j >>> 16 ^ 65535)) {
              B.msg = "invalid stored block lengths", _.mode = 30;
              break;
            }
            if (_.length = 65535 & j, P = j = 0, _.mode = 15, R === 6) break e;
          case 15:
            _.mode = 16;
          case 16:
            if (ne = _.length) {
              if (w < ne && (ne = w), F < ne && (ne = F), ne === 0) break e;
              l.arraySet(k, A, z, ne, T), w -= ne, z += ne, F -= ne, T += ne, _.length -= ne;
              break;
            }
            _.mode = 12;
            break;
          case 17:
            for (; P < 14; ) {
              if (w === 0) break e;
              w--, j += A[z++] << P, P += 8;
            }
            if (_.nlen = 257 + (31 & j), j >>>= 5, P -= 5, _.ndist = 1 + (31 & j), j >>>= 5, P -= 5, _.ncode = 4 + (15 & j), j >>>= 4, P -= 4, 286 < _.nlen || 30 < _.ndist) {
              B.msg = "too many length or distance symbols", _.mode = 30;
              break;
            }
            _.have = 0, _.mode = 18;
          case 18:
            for (; _.have < _.ncode; ) {
              for (; P < 3; ) {
                if (w === 0) break e;
                w--, j += A[z++] << P, P += 8;
              }
              _.lens[X[_.have++]] = 7 & j, j >>>= 3, P -= 3;
            }
            for (; _.have < 19; ) _.lens[X[_.have++]] = 0;
            if (_.lencode = _.lendyn, _.lenbits = 7, se = { bits: _.lenbits }, ae = s(0, _.lens, 0, 19, _.lencode, 0, _.work, se), _.lenbits = se.bits, ae) {
              B.msg = "invalid code lengths set", _.mode = 30;
              break;
            }
            _.have = 0, _.mode = 19;
          case 19:
            for (; _.have < _.nlen + _.ndist; ) {
              for (; N = (W = _.lencode[j & (1 << _.lenbits) - 1]) >>> 16 & 255, q = 65535 & W, !((G = W >>> 24) <= P); ) {
                if (w === 0) break e;
                w--, j += A[z++] << P, P += 8;
              }
              if (q < 16) j >>>= G, P -= G, _.lens[_.have++] = q;
              else {
                if (q === 16) {
                  for (L = G + 2; P < L; ) {
                    if (w === 0) break e;
                    w--, j += A[z++] << P, P += 8;
                  }
                  if (j >>>= G, P -= G, _.have === 0) {
                    B.msg = "invalid bit length repeat", _.mode = 30;
                    break;
                  }
                  Y = _.lens[_.have - 1], ne = 3 + (3 & j), j >>>= 2, P -= 2;
                } else if (q === 17) {
                  for (L = G + 3; P < L; ) {
                    if (w === 0) break e;
                    w--, j += A[z++] << P, P += 8;
                  }
                  P -= G, Y = 0, ne = 3 + (7 & (j >>>= G)), j >>>= 3, P -= 3;
                } else {
                  for (L = G + 7; P < L; ) {
                    if (w === 0) break e;
                    w--, j += A[z++] << P, P += 8;
                  }
                  P -= G, Y = 0, ne = 11 + (127 & (j >>>= G)), j >>>= 7, P -= 7;
                }
                if (_.have + ne > _.nlen + _.ndist) {
                  B.msg = "invalid bit length repeat", _.mode = 30;
                  break;
                }
                for (; ne--; ) _.lens[_.have++] = Y;
              }
            }
            if (_.mode === 30) break;
            if (_.lens[256] === 0) {
              B.msg = "invalid code -- missing end-of-block", _.mode = 30;
              break;
            }
            if (_.lenbits = 9, se = { bits: _.lenbits }, ae = s(h, _.lens, 0, _.nlen, _.lencode, 0, _.work, se), _.lenbits = se.bits, ae) {
              B.msg = "invalid literal/lengths set", _.mode = 30;
              break;
            }
            if (_.distbits = 6, _.distcode = _.distdyn, se = { bits: _.distbits }, ae = s(g, _.lens, _.nlen, _.ndist, _.distcode, 0, _.work, se), _.distbits = se.bits, ae) {
              B.msg = "invalid distances set", _.mode = 30;
              break;
            }
            if (_.mode = 20, R === 6) break e;
          case 20:
            _.mode = 21;
          case 21:
            if (6 <= w && 258 <= F) {
              B.next_out = T, B.avail_out = F, B.next_in = z, B.avail_in = w, _.hold = j, _.bits = P, f(B, J), T = B.next_out, k = B.output, F = B.avail_out, z = B.next_in, A = B.input, w = B.avail_in, j = _.hold, P = _.bits, _.mode === 12 && (_.back = -1);
              break;
            }
            for (_.back = 0; N = (W = _.lencode[j & (1 << _.lenbits) - 1]) >>> 16 & 255, q = 65535 & W, !((G = W >>> 24) <= P); ) {
              if (w === 0) break e;
              w--, j += A[z++] << P, P += 8;
            }
            if (N && !(240 & N)) {
              for (ie = G, oe = N, fe = q; N = (W = _.lencode[fe + ((j & (1 << ie + oe) - 1) >> ie)]) >>> 16 & 255, q = 65535 & W, !(ie + (G = W >>> 24) <= P); ) {
                if (w === 0) break e;
                w--, j += A[z++] << P, P += 8;
              }
              j >>>= ie, P -= ie, _.back += ie;
            }
            if (j >>>= G, P -= G, _.back += G, _.length = q, N === 0) {
              _.mode = 26;
              break;
            }
            if (32 & N) {
              _.back = -1, _.mode = 12;
              break;
            }
            if (64 & N) {
              B.msg = "invalid literal/length code", _.mode = 30;
              break;
            }
            _.extra = 15 & N, _.mode = 22;
          case 22:
            if (_.extra) {
              for (L = _.extra; P < L; ) {
                if (w === 0) break e;
                w--, j += A[z++] << P, P += 8;
              }
              _.length += j & (1 << _.extra) - 1, j >>>= _.extra, P -= _.extra, _.back += _.extra;
            }
            _.was = _.length, _.mode = 23;
          case 23:
            for (; N = (W = _.distcode[j & (1 << _.distbits) - 1]) >>> 16 & 255, q = 65535 & W, !((G = W >>> 24) <= P); ) {
              if (w === 0) break e;
              w--, j += A[z++] << P, P += 8;
            }
            if (!(240 & N)) {
              for (ie = G, oe = N, fe = q; N = (W = _.distcode[fe + ((j & (1 << ie + oe) - 1) >> ie)]) >>> 16 & 255, q = 65535 & W, !(ie + (G = W >>> 24) <= P); ) {
                if (w === 0) break e;
                w--, j += A[z++] << P, P += 8;
              }
              j >>>= ie, P -= ie, _.back += ie;
            }
            if (j >>>= G, P -= G, _.back += G, 64 & N) {
              B.msg = "invalid distance code", _.mode = 30;
              break;
            }
            _.offset = q, _.extra = 15 & N, _.mode = 24;
          case 24:
            if (_.extra) {
              for (L = _.extra; P < L; ) {
                if (w === 0) break e;
                w--, j += A[z++] << P, P += 8;
              }
              _.offset += j & (1 << _.extra) - 1, j >>>= _.extra, P -= _.extra, _.back += _.extra;
            }
            if (_.offset > _.dmax) {
              B.msg = "invalid distance too far back", _.mode = 30;
              break;
            }
            _.mode = 25;
          case 25:
            if (F === 0) break e;
            if (ne = J - F, _.offset > ne) {
              if ((ne = _.offset - ne) > _.whave && _.sane) {
                B.msg = "invalid distance too far back", _.mode = 30;
                break;
              }
              Z = ne > _.wnext ? (ne -= _.wnext, _.wsize - ne) : _.wnext - ne, ne > _.length && (ne = _.length), te = _.window;
            } else te = k, Z = T - _.offset, ne = _.length;
            for (F < ne && (ne = F), F -= ne, _.length -= ne; k[T++] = te[Z++], --ne; ) ;
            _.length === 0 && (_.mode = 21);
            break;
          case 26:
            if (F === 0) break e;
            k[T++] = _.length, F--, _.mode = 21;
            break;
          case 27:
            if (_.wrap) {
              for (; P < 32; ) {
                if (w === 0) break e;
                w--, j |= A[z++] << P, P += 8;
              }
              if (J -= F, B.total_out += J, _.total += J, J && (B.adler = _.check = _.flags ? c(_.check, k, J, T - J) : d(_.check, k, J, T - J)), J = F, (_.flags ? j : S(j)) !== _.check) {
                B.msg = "incorrect data check", _.mode = 30;
                break;
              }
              P = j = 0;
            }
            _.mode = 28;
          case 28:
            if (_.wrap && _.flags) {
              for (; P < 32; ) {
                if (w === 0) break e;
                w--, j += A[z++] << P, P += 8;
              }
              if (j !== (4294967295 & _.total)) {
                B.msg = "incorrect length check", _.mode = 30;
                break;
              }
              P = j = 0;
            }
            _.mode = 29;
          case 29:
            ae = 1;
            break e;
          case 30:
            ae = -3;
            break e;
          case 31:
            return -4;
          case 32:
          default:
            return i;
        }
        return B.next_out = T, B.avail_out = F, B.next_in = z, B.avail_in = w, _.hold = j, _.bits = P, (_.wsize || J !== B.avail_out && _.mode < 30 && (_.mode < 27 || R !== 4)) && H(B, B.output, B.next_out, J - B.avail_out) ? (_.mode = 31, -4) : (V -= B.avail_in, J -= B.avail_out, B.total_in += V, B.total_out += J, _.total += J, _.wrap && J && (B.adler = _.check = _.flags ? c(_.check, k, J, B.next_out - J) : d(_.check, k, J, B.next_out - J)), B.data_type = _.bits + (_.last ? 64 : 0) + (_.mode === 12 ? 128 : 0) + (_.mode === 20 || _.mode === 15 ? 256 : 0), (V == 0 && J === 0 || R === 4) && ae === t && (ae = -5), ae);
      }, o.inflateEnd = function(B) {
        if (!B || !B.state) return i;
        var R = B.state;
        return R.window && (R.window = null), B.state = null, t;
      }, o.inflateGetHeader = function(B, R) {
        var _;
        return B && B.state && 2 & (_ = B.state).wrap ? ((_.head = R).done = !1, t) : i;
      }, o.inflateSetDictionary = function(B, R) {
        var _, A = R.length;
        return B && B.state ? (_ = B.state).wrap !== 0 && _.mode !== 11 ? i : _.mode === 11 && d(1, R, A, 0) !== _.check ? -3 : H(B, R, A, A) ? (_.mode = 31, -4) : (_.havedict = 1, t) : i;
      }, o.inflateInfo = "pako inflate (from Nodeca project)";
    }, { "../utils/common": 41, "./adler32": 43, "./crc32": 45, "./inffast": 48, "./inftrees": 50 }], 50: [function(r, a, o) {
      var l = r("../utils/common"), d = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0], c = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78], f = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0], s = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];
      a.exports = function(h, g, t, i, m, v, E, S) {
        var y, x, b, u, I, O, D, $, K, H = S.bits, B = 0, R = 0, _ = 0, A = 0, k = 0, z = 0, T = 0, w = 0, F = 0, j = 0, P = null, V = 0, J = new l.Buf16(16), ne = new l.Buf16(16), Z = null, te = 0;
        for (B = 0; B <= 15; B++) J[B] = 0;
        for (R = 0; R < i; R++) J[g[t + R]]++;
        for (k = H, A = 15; 1 <= A && J[A] === 0; A--) ;
        if (A < k && (k = A), A === 0) return m[v++] = 20971520, m[v++] = 20971520, S.bits = 1, 0;
        for (_ = 1; _ < A && J[_] === 0; _++) ;
        for (k < _ && (k = _), B = w = 1; B <= 15; B++) if (w <<= 1, (w -= J[B]) < 0) return -1;
        if (0 < w && (h === 0 || A !== 1)) return -1;
        for (ne[1] = 0, B = 1; B < 15; B++) ne[B + 1] = ne[B] + J[B];
        for (R = 0; R < i; R++) g[t + R] !== 0 && (E[ne[g[t + R]]++] = R);
        if (O = h === 0 ? (P = Z = E, 19) : h === 1 ? (P = d, V -= 257, Z = c, te -= 257, 256) : (P = f, Z = s, -1), B = _, I = v, T = R = j = 0, b = -1, u = (F = 1 << (z = k)) - 1, h === 1 && 852 < F || h === 2 && 592 < F) return 1;
        for (; ; ) {
          for (D = B - T, K = E[R] < O ? ($ = 0, E[R]) : E[R] > O ? ($ = Z[te + E[R]], P[V + E[R]]) : ($ = 96, 0), y = 1 << B - T, _ = x = 1 << z; m[I + (j >> T) + (x -= y)] = D << 24 | $ << 16 | K | 0, x !== 0; ) ;
          for (y = 1 << B - 1; j & y; ) y >>= 1;
          if (y !== 0 ? (j &= y - 1, j += y) : j = 0, R++, --J[B] == 0) {
            if (B === A) break;
            B = g[t + E[R]];
          }
          if (k < B && (j & u) !== b) {
            for (T === 0 && (T = k), I += _, w = 1 << (z = B - T); z + T < A && !((w -= J[z + T]) <= 0); ) z++, w <<= 1;
            if (F += 1 << z, h === 1 && 852 < F || h === 2 && 592 < F) return 1;
            m[b = j & u] = k << 24 | z << 16 | I - v | 0;
          }
        }
        return j !== 0 && (m[I + j] = B - T << 24 | 64 << 16 | 0), S.bits = k, 0;
      };
    }, { "../utils/common": 41 }], 51: [function(r, a, o) {
      a.exports = { 2: "need dictionary", 1: "stream end", 0: "", "-1": "file error", "-2": "stream error", "-3": "data error", "-4": "insufficient memory", "-5": "buffer error", "-6": "incompatible version" };
    }, {}], 52: [function(r, a, o) {
      var l = r("../utils/common"), d = 0, c = 1;
      function f(W) {
        for (var M = W.length; 0 <= --M; ) W[M] = 0;
      }
      var s = 0, h = 29, g = 256, t = g + 1 + h, i = 30, m = 19, v = 2 * t + 1, E = 15, S = 16, y = 7, x = 256, b = 16, u = 17, I = 18, O = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0], D = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13], $ = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7], K = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], H = new Array(2 * (t + 2));
      f(H);
      var B = new Array(2 * i);
      f(B);
      var R = new Array(512);
      f(R);
      var _ = new Array(256);
      f(_);
      var A = new Array(h);
      f(A);
      var k, z, T, w = new Array(i);
      function F(W, M, X, U, Q) {
        this.static_tree = W, this.extra_bits = M, this.extra_base = X, this.elems = U, this.max_length = Q, this.has_stree = W && W.length;
      }
      function j(W, M) {
        this.dyn_tree = W, this.max_code = 0, this.stat_desc = M;
      }
      function P(W) {
        return W < 256 ? R[W] : R[256 + (W >>> 7)];
      }
      function V(W, M) {
        W.pending_buf[W.pending++] = 255 & M, W.pending_buf[W.pending++] = M >>> 8 & 255;
      }
      function J(W, M, X) {
        W.bi_valid > S - X ? (W.bi_buf |= M << W.bi_valid & 65535, V(W, W.bi_buf), W.bi_buf = M >> S - W.bi_valid, W.bi_valid += X - S) : (W.bi_buf |= M << W.bi_valid & 65535, W.bi_valid += X);
      }
      function ne(W, M, X) {
        J(W, X[2 * M], X[2 * M + 1]);
      }
      function Z(W, M) {
        for (var X = 0; X |= 1 & W, W >>>= 1, X <<= 1, 0 < --M; ) ;
        return X >>> 1;
      }
      function te(W, M, X) {
        var U, Q, re = new Array(E + 1), le = 0;
        for (U = 1; U <= E; U++) re[U] = le = le + X[U - 1] << 1;
        for (Q = 0; Q <= M; Q++) {
          var ce = W[2 * Q + 1];
          ce !== 0 && (W[2 * Q] = Z(re[ce]++, ce));
        }
      }
      function G(W) {
        var M;
        for (M = 0; M < t; M++) W.dyn_ltree[2 * M] = 0;
        for (M = 0; M < i; M++) W.dyn_dtree[2 * M] = 0;
        for (M = 0; M < m; M++) W.bl_tree[2 * M] = 0;
        W.dyn_ltree[2 * x] = 1, W.opt_len = W.static_len = 0, W.last_lit = W.matches = 0;
      }
      function N(W) {
        8 < W.bi_valid ? V(W, W.bi_buf) : 0 < W.bi_valid && (W.pending_buf[W.pending++] = W.bi_buf), W.bi_buf = 0, W.bi_valid = 0;
      }
      function q(W, M, X, U) {
        var Q = 2 * M, re = 2 * X;
        return W[Q] < W[re] || W[Q] === W[re] && U[M] <= U[X];
      }
      function ie(W, M, X) {
        for (var U = W.heap[X], Q = X << 1; Q <= W.heap_len && (Q < W.heap_len && q(M, W.heap[Q + 1], W.heap[Q], W.depth) && Q++, !q(M, U, W.heap[Q], W.depth)); ) W.heap[X] = W.heap[Q], X = Q, Q <<= 1;
        W.heap[X] = U;
      }
      function oe(W, M, X) {
        var U, Q, re, le, ce = 0;
        if (W.last_lit !== 0) for (; U = W.pending_buf[W.d_buf + 2 * ce] << 8 | W.pending_buf[W.d_buf + 2 * ce + 1], Q = W.pending_buf[W.l_buf + ce], ce++, U === 0 ? ne(W, Q, M) : (ne(W, (re = _[Q]) + g + 1, M), (le = O[re]) !== 0 && J(W, Q -= A[re], le), ne(W, re = P(--U), X), (le = D[re]) !== 0 && J(W, U -= w[re], le)), ce < W.last_lit; ) ;
        ne(W, x, M);
      }
      function fe(W, M) {
        var X, U, Q, re = M.dyn_tree, le = M.stat_desc.static_tree, ce = M.stat_desc.has_stree, ee = M.stat_desc.elems, he = -1;
        for (W.heap_len = 0, W.heap_max = v, X = 0; X < ee; X++) re[2 * X] !== 0 ? (W.heap[++W.heap_len] = he = X, W.depth[X] = 0) : re[2 * X + 1] = 0;
        for (; W.heap_len < 2; ) re[2 * (Q = W.heap[++W.heap_len] = he < 2 ? ++he : 0)] = 1, W.depth[Q] = 0, W.opt_len--, ce && (W.static_len -= le[2 * Q + 1]);
        for (M.max_code = he, X = W.heap_len >> 1; 1 <= X; X--) ie(W, re, X);
        for (Q = ee; X = W.heap[1], W.heap[1] = W.heap[W.heap_len--], ie(W, re, 1), U = W.heap[1], W.heap[--W.heap_max] = X, W.heap[--W.heap_max] = U, re[2 * Q] = re[2 * X] + re[2 * U], W.depth[Q] = (W.depth[X] >= W.depth[U] ? W.depth[X] : W.depth[U]) + 1, re[2 * X + 1] = re[2 * U + 1] = Q, W.heap[1] = Q++, ie(W, re, 1), 2 <= W.heap_len; ) ;
        W.heap[--W.heap_max] = W.heap[1], function(pe, de) {
          var ge, me, xe, ye, ve, Ce, Ie = de.dyn_tree, Ae = de.max_code, Se = de.stat_desc.static_tree, De = de.stat_desc.has_stree, Be = de.stat_desc.extra_bits, ke = de.stat_desc.extra_base, be = de.stat_desc.max_length, we = 0;
          for (ye = 0; ye <= E; ye++) pe.bl_count[ye] = 0;
          for (Ie[2 * pe.heap[pe.heap_max] + 1] = 0, ge = pe.heap_max + 1; ge < v; ge++) be < (ye = Ie[2 * Ie[2 * (me = pe.heap[ge]) + 1] + 1] + 1) && (ye = be, we++), Ie[2 * me + 1] = ye, Ae < me || (pe.bl_count[ye]++, ve = 0, ke <= me && (ve = Be[me - ke]), Ce = Ie[2 * me], pe.opt_len += Ce * (ye + ve), De && (pe.static_len += Ce * (Se[2 * me + 1] + ve)));
          if (we !== 0) {
            do {
              for (ye = be - 1; pe.bl_count[ye] === 0; ) ye--;
              pe.bl_count[ye]--, pe.bl_count[ye + 1] += 2, pe.bl_count[be]--, we -= 2;
            } while (0 < we);
            for (ye = be; ye !== 0; ye--) for (me = pe.bl_count[ye]; me !== 0; ) Ae < (xe = pe.heap[--ge]) || (Ie[2 * xe + 1] !== ye && (pe.opt_len += (ye - Ie[2 * xe + 1]) * Ie[2 * xe], Ie[2 * xe + 1] = ye), me--);
          }
        }(W, M), te(re, he, W.bl_count);
      }
      function Y(W, M, X) {
        var U, Q, re = -1, le = M[1], ce = 0, ee = 7, he = 4;
        for (le === 0 && (ee = 138, he = 3), M[2 * (X + 1) + 1] = 65535, U = 0; U <= X; U++) Q = le, le = M[2 * (U + 1) + 1], ++ce < ee && Q === le || (ce < he ? W.bl_tree[2 * Q] += ce : Q !== 0 ? (Q !== re && W.bl_tree[2 * Q]++, W.bl_tree[2 * b]++) : ce <= 10 ? W.bl_tree[2 * u]++ : W.bl_tree[2 * I]++, re = Q, he = (ce = 0) === le ? (ee = 138, 3) : Q === le ? (ee = 6, 3) : (ee = 7, 4));
      }
      function ae(W, M, X) {
        var U, Q, re = -1, le = M[1], ce = 0, ee = 7, he = 4;
        for (le === 0 && (ee = 138, he = 3), U = 0; U <= X; U++) if (Q = le, le = M[2 * (U + 1) + 1], !(++ce < ee && Q === le)) {
          if (ce < he) for (; ne(W, Q, W.bl_tree), --ce != 0; ) ;
          else Q !== 0 ? (Q !== re && (ne(W, Q, W.bl_tree), ce--), ne(W, b, W.bl_tree), J(W, ce - 3, 2)) : ce <= 10 ? (ne(W, u, W.bl_tree), J(W, ce - 3, 3)) : (ne(W, I, W.bl_tree), J(W, ce - 11, 7));
          re = Q, he = (ce = 0) === le ? (ee = 138, 3) : Q === le ? (ee = 6, 3) : (ee = 7, 4);
        }
      }
      f(w);
      var se = !1;
      function L(W, M, X, U) {
        J(W, (s << 1) + (U ? 1 : 0), 3), function(Q, re, le, ce) {
          N(Q), V(Q, le), V(Q, ~le), l.arraySet(Q.pending_buf, Q.window, re, le, Q.pending), Q.pending += le;
        }(W, M, X);
      }
      o._tr_init = function(W) {
        se || (function() {
          var M, X, U, Q, re, le = new Array(E + 1);
          for (Q = U = 0; Q < h - 1; Q++) for (A[Q] = U, M = 0; M < 1 << O[Q]; M++) _[U++] = Q;
          for (_[U - 1] = Q, Q = re = 0; Q < 16; Q++) for (w[Q] = re, M = 0; M < 1 << D[Q]; M++) R[re++] = Q;
          for (re >>= 7; Q < i; Q++) for (w[Q] = re << 7, M = 0; M < 1 << D[Q] - 7; M++) R[256 + re++] = Q;
          for (X = 0; X <= E; X++) le[X] = 0;
          for (M = 0; M <= 143; ) H[2 * M + 1] = 8, M++, le[8]++;
          for (; M <= 255; ) H[2 * M + 1] = 9, M++, le[9]++;
          for (; M <= 279; ) H[2 * M + 1] = 7, M++, le[7]++;
          for (; M <= 287; ) H[2 * M + 1] = 8, M++, le[8]++;
          for (te(H, t + 1, le), M = 0; M < i; M++) B[2 * M + 1] = 5, B[2 * M] = Z(M, 5);
          k = new F(H, O, g + 1, t, E), z = new F(B, D, 0, i, E), T = new F(new Array(0), $, 0, m, y);
        }(), se = !0), W.l_desc = new j(W.dyn_ltree, k), W.d_desc = new j(W.dyn_dtree, z), W.bl_desc = new j(W.bl_tree, T), W.bi_buf = 0, W.bi_valid = 0, G(W);
      }, o._tr_stored_block = L, o._tr_flush_block = function(W, M, X, U) {
        var Q, re, le = 0;
        0 < W.level ? (W.strm.data_type === 2 && (W.strm.data_type = function(ce) {
          var ee, he = 4093624447;
          for (ee = 0; ee <= 31; ee++, he >>>= 1) if (1 & he && ce.dyn_ltree[2 * ee] !== 0) return d;
          if (ce.dyn_ltree[18] !== 0 || ce.dyn_ltree[20] !== 0 || ce.dyn_ltree[26] !== 0) return c;
          for (ee = 32; ee < g; ee++) if (ce.dyn_ltree[2 * ee] !== 0) return c;
          return d;
        }(W)), fe(W, W.l_desc), fe(W, W.d_desc), le = function(ce) {
          var ee;
          for (Y(ce, ce.dyn_ltree, ce.l_desc.max_code), Y(ce, ce.dyn_dtree, ce.d_desc.max_code), fe(ce, ce.bl_desc), ee = m - 1; 3 <= ee && ce.bl_tree[2 * K[ee] + 1] === 0; ee--) ;
          return ce.opt_len += 3 * (ee + 1) + 5 + 5 + 4, ee;
        }(W), Q = W.opt_len + 3 + 7 >>> 3, (re = W.static_len + 3 + 7 >>> 3) <= Q && (Q = re)) : Q = re = X + 5, X + 4 <= Q && M !== -1 ? L(W, M, X, U) : W.strategy === 4 || re === Q ? (J(W, 2 + (U ? 1 : 0), 3), oe(W, H, B)) : (J(W, 4 + (U ? 1 : 0), 3), function(ce, ee, he, pe) {
          var de;
          for (J(ce, ee - 257, 5), J(ce, he - 1, 5), J(ce, pe - 4, 4), de = 0; de < pe; de++) J(ce, ce.bl_tree[2 * K[de] + 1], 3);
          ae(ce, ce.dyn_ltree, ee - 1), ae(ce, ce.dyn_dtree, he - 1);
        }(W, W.l_desc.max_code + 1, W.d_desc.max_code + 1, le + 1), oe(W, W.dyn_ltree, W.dyn_dtree)), G(W), U && N(W);
      }, o._tr_tally = function(W, M, X) {
        return W.pending_buf[W.d_buf + 2 * W.last_lit] = M >>> 8 & 255, W.pending_buf[W.d_buf + 2 * W.last_lit + 1] = 255 & M, W.pending_buf[W.l_buf + W.last_lit] = 255 & X, W.last_lit++, M === 0 ? W.dyn_ltree[2 * X]++ : (W.matches++, M--, W.dyn_ltree[2 * (_[X] + g + 1)]++, W.dyn_dtree[2 * P(M)]++), W.last_lit === W.lit_bufsize - 1;
      }, o._tr_align = function(W) {
        J(W, 2, 3), ne(W, x, H), function(M) {
          M.bi_valid === 16 ? (V(M, M.bi_buf), M.bi_buf = 0, M.bi_valid = 0) : 8 <= M.bi_valid && (M.pending_buf[M.pending++] = 255 & M.bi_buf, M.bi_buf >>= 8, M.bi_valid -= 8);
        }(W);
      };
    }, { "../utils/common": 41 }], 53: [function(r, a, o) {
      a.exports = function() {
        this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
      };
    }, {}], 54: [function(r, a, o) {
      (function(l) {
        (function(d, c) {
          if (!d.setImmediate) {
            var f, s, h, g, t = 1, i = {}, m = !1, v = d.document, E = Object.getPrototypeOf && Object.getPrototypeOf(d);
            E = E && E.setTimeout ? E : d, f = {}.toString.call(d.process) === "[object process]" ? function(b) {
              process.nextTick(function() {
                y(b);
              });
            } : function() {
              if (d.postMessage && !d.importScripts) {
                var b = !0, u = d.onmessage;
                return d.onmessage = function() {
                  b = !1;
                }, d.postMessage("", "*"), d.onmessage = u, b;
              }
            }() ? (g = "setImmediate$" + Math.random() + "$", d.addEventListener ? d.addEventListener("message", x, !1) : d.attachEvent("onmessage", x), function(b) {
              d.postMessage(g + b, "*");
            }) : d.MessageChannel ? ((h = new MessageChannel()).port1.onmessage = function(b) {
              y(b.data);
            }, function(b) {
              h.port2.postMessage(b);
            }) : v && "onreadystatechange" in v.createElement("script") ? (s = v.documentElement, function(b) {
              var u = v.createElement("script");
              u.onreadystatechange = function() {
                y(b), u.onreadystatechange = null, s.removeChild(u), u = null;
              }, s.appendChild(u);
            }) : function(b) {
              setTimeout(y, 0, b);
            }, E.setImmediate = function(b) {
              typeof b != "function" && (b = new Function("" + b));
              for (var u = new Array(arguments.length - 1), I = 0; I < u.length; I++) u[I] = arguments[I + 1];
              var O = { callback: b, args: u };
              return i[t] = O, f(t), t++;
            }, E.clearImmediate = S;
          }
          function S(b) {
            delete i[b];
          }
          function y(b) {
            if (m) setTimeout(y, 0, b);
            else {
              var u = i[b];
              if (u) {
                m = !0;
                try {
                  (function(I) {
                    var O = I.callback, D = I.args;
                    switch (D.length) {
                      case 0:
                        O();
                        break;
                      case 1:
                        O(D[0]);
                        break;
                      case 2:
                        O(D[0], D[1]);
                        break;
                      case 3:
                        O(D[0], D[1], D[2]);
                        break;
                      default:
                        O.apply(c, D);
                    }
                  })(u);
                } finally {
                  S(b), m = !1;
                }
              }
            }
          }
          function x(b) {
            b.source === d && typeof b.data == "string" && b.data.indexOf(g) === 0 && y(+b.data.slice(g.length));
          }
        })(typeof self > "u" ? l === void 0 ? this : l : self);
      }).call(this, typeof Mi < "u" ? Mi : typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, {}] }, {}, [10])(10);
  });
})(Pb);
var pC = Pb.exports;
const gC = /* @__PURE__ */ ys(pC);
var Ul = {};
Ul._getBinaryFromXHR = function(e) {
  return e.response || e.responseText;
};
function wp() {
  try {
    return new window.XMLHttpRequest();
  } catch {
  }
}
function mC() {
  try {
    return new window.ActiveXObject("Microsoft.XMLHTTP");
  } catch {
  }
}
var xC = typeof window < "u" && window.ActiveXObject ? (
  /* Microsoft failed to properly
   * implement the XMLHttpRequest in IE7 (can't request local files),
   * so we use the ActiveXObject when it is available
   * Additionally XMLHttpRequest can be disabled in IE7/IE8 so
   * we need a fallback.
   */
  function() {
    return wp() || mC();
  }
) : (
  // For all other browsers, use the standard XMLHttpRequest object
  wp
);
Ul.getBinaryContent = function(e, n) {
  var r, a, o, l;
  n || (n = {}), typeof n == "function" ? (l = n, n = {}) : typeof n.callback == "function" && (l = n.callback), !l && typeof Promise < "u" ? r = new Promise(function(c, f) {
    a = c, o = f;
  }) : (a = function(c) {
    l(null, c);
  }, o = function(c) {
    l(c, null);
  });
  try {
    var d = xC();
    d.open("GET", e, !0), "responseType" in d && (d.responseType = "arraybuffer"), d.overrideMimeType && d.overrideMimeType("text/plain; charset=x-user-defined"), d.onreadystatechange = function(c) {
      if (d.readyState === 4)
        if (d.status === 200 || d.status === 0)
          try {
            a(Ul._getBinaryFromXHR(d));
          } catch (f) {
            o(new Error(f));
          }
        else
          o(new Error("Ajax error for " + e + " : " + this.status + " " + this.statusText));
    }, n.progress && (d.onprogress = function(c) {
      n.progress({
        path: e,
        originalEvent: c,
        percent: c.loaded / c.total * 100,
        loaded: c.loaded,
        total: c.total
      });
    }), d.send();
  } catch (c) {
    o(new Error(c), null);
  }
  return r;
};
var bC = Ul;
const yC = /* @__PURE__ */ ys(bC), vC = 1, wC = "BulkDocumentBundle.zip";
function jb(e) {
  return new Promise((n, r) => {
    yC.getBinaryContent(e, (a, o) => {
      if (a) {
        r(a);
        return;
      }
      n(o);
    });
  });
}
async function SC({
  url: e,
  fileName: n,
  zip: r
}) {
  const a = await jb(e), o = uf(/* @__PURE__ */ new Date(), "yyyy-MM-dd HH:mm:ss");
  r.file(n, a, {
    binary: !0,
    createFolders: !1,
    date: new Date(o)
  });
}
async function yB(e) {
  const n = await jb(e.aws_url_original);
  if (typeof n == "string" ? n.length === 0 : n.byteLength === 0)
    throw new Error("Downloaded file is empty");
  const a = typeof n == "string" ? Uint8Array.from(n, (o) => o.charCodeAt(0) & 255) : n;
  Gd.saveAs(
    new Blob([a], { type: e.content_type }),
    e.doc_name
  );
}
function _C(e, n) {
  var o;
  const r = n[e.doc_name] > 1 ? ` (${n[e.doc_name] - 1})` : "";
  let a = e.doc_name || "";
  if (a.split(".").length === 1)
    a = `${e.doc_name}${r}.${(o = e == null ? void 0 : e.content_type) == null ? void 0 : o.split("/")[1]}`;
  else if (r && a.split(".").length === 2) {
    const [l, ...d] = a.split(".");
    a = `${l}${r}.${d}`;
  } else if (r) {
    const l = a.split("."), d = l.pop();
    a = `${l.join(".")}${r}.${d}`;
  }
  return a;
}
async function vB(e) {
  if (e.length <= vC)
    await Promise.all(
      e.map(
        (n) => Gd.saveAs(n.aws_url_original, n.doc_name)
      )
    );
  else {
    const n = new gC(), { addFilesToZipPromises: r } = e.reduce(
      (o, l) => {
        const d = {
          ...o.count,
          [l.doc_name]: o.count[l.doc_name] ? o.count[l.doc_name] + 1 : 1
        }, c = _C(l, d);
        return {
          count: d,
          // Create array of Promises to add files to zip.
          addFilesToZipPromises: [
            ...o.addFilesToZipPromises,
            SC({
              url: l.aws_url_original,
              fileName: c,
              zip: n
            })
          ]
        };
      },
      {
        addFilesToZipPromises: [],
        count: {}
      }
    );
    await Promise.all(r);
    const a = await n.generateAsync({ type: "blob" });
    Gd.saveAs(a, wC);
  }
}
const wB = (e, n) => n.map((r) => r.key).includes(e), SB = (e) => ({
  "First name": e.taxpayer_first_name,
  "Middle name": e.taxpayer_middle_name,
  "Last name": e.taxpayer_last_name,
  "Current filing status?": e.in_curr_filling_status,
  Birthdate: nr({
    dateString: e.in_self_birthdate
  }),
  "Drivers License #": e.in_self_driver_license,
  "Date Issued": nr({
    dateString: e.in_self_license_issue_date
  }),
  "Expiration Date": nr({
    dateString: e.in_self_license_expiry_date
  }),
  "State of issue": e.in_self_license_state
}), _B = (e) => ({
  "First name": e.in_sps_first_name,
  "Middle name": e.in_sps_middle_name,
  "Last name": e.in_sps_last_name,
  Birthdate: nr({
    dateString: e.in_sps_birthdate
  }),
  "Drivers License #": e.in_sps_driver_license,
  "Date Issued": nr({
    dateString: e.in_sps_license_issue_date
  }),
  "Expiration Date": nr({
    dateString: e.in_sps_license_expiry_date
  }),
  "State of issue": e.in_sps_license_state
}), CC = (e, n) => {
  const r = `User ${n || ""} has sent the following ${wx(e.length, "file", "files")}:`, a = (e == null ? void 0 : e.reduce(
    (o, l, d) => l ? `${o} ${l == null ? void 0 : l.doc_name}${d === e.length - 1 ? "." : ","}` : o,
    r
  )) || "";
  return a === r ? "" : a;
};
var Lf = { exports: {} };
Lf.exports;
(function(e) {
  var n = function() {
    var r = String.fromCharCode, a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$", l = {};
    function d(f, s) {
      if (!l[f]) {
        l[f] = {};
        for (var h = 0; h < f.length; h++)
          l[f][f.charAt(h)] = h;
      }
      return l[f][s];
    }
    var c = {
      compressToBase64: function(f) {
        if (f == null) return "";
        var s = c._compress(f, 6, function(h) {
          return a.charAt(h);
        });
        switch (s.length % 4) {
          default:
          case 0:
            return s;
          case 1:
            return s + "===";
          case 2:
            return s + "==";
          case 3:
            return s + "=";
        }
      },
      decompressFromBase64: function(f) {
        return f == null ? "" : f == "" ? null : c._decompress(f.length, 32, function(s) {
          return d(a, f.charAt(s));
        });
      },
      compressToUTF16: function(f) {
        return f == null ? "" : c._compress(f, 15, function(s) {
          return r(s + 32);
        }) + " ";
      },
      decompressFromUTF16: function(f) {
        return f == null ? "" : f == "" ? null : c._decompress(f.length, 16384, function(s) {
          return f.charCodeAt(s) - 32;
        });
      },
      //compress into uint8array (UCS-2 big endian format)
      compressToUint8Array: function(f) {
        for (var s = c.compress(f), h = new Uint8Array(s.length * 2), g = 0, t = s.length; g < t; g++) {
          var i = s.charCodeAt(g);
          h[g * 2] = i >>> 8, h[g * 2 + 1] = i % 256;
        }
        return h;
      },
      //decompress from uint8array (UCS-2 big endian format)
      decompressFromUint8Array: function(f) {
        if (f == null)
          return c.decompress(f);
        for (var s = new Array(f.length / 2), h = 0, g = s.length; h < g; h++)
          s[h] = f[h * 2] * 256 + f[h * 2 + 1];
        var t = [];
        return s.forEach(function(i) {
          t.push(r(i));
        }), c.decompress(t.join(""));
      },
      //compress into a string that is already URI encoded
      compressToEncodedURIComponent: function(f) {
        return f == null ? "" : c._compress(f, 6, function(s) {
          return o.charAt(s);
        });
      },
      //decompress from an output of compressToEncodedURIComponent
      decompressFromEncodedURIComponent: function(f) {
        return f == null ? "" : f == "" ? null : (f = f.replace(/ /g, "+"), c._decompress(f.length, 32, function(s) {
          return d(o, f.charAt(s));
        }));
      },
      compress: function(f) {
        return c._compress(f, 16, function(s) {
          return r(s);
        });
      },
      _compress: function(f, s, h) {
        if (f == null) return "";
        var g, t, i = {}, m = {}, v = "", E = "", S = "", y = 2, x = 3, b = 2, u = [], I = 0, O = 0, D;
        for (D = 0; D < f.length; D += 1)
          if (v = f.charAt(D), Object.prototype.hasOwnProperty.call(i, v) || (i[v] = x++, m[v] = !0), E = S + v, Object.prototype.hasOwnProperty.call(i, E))
            S = E;
          else {
            if (Object.prototype.hasOwnProperty.call(m, S)) {
              if (S.charCodeAt(0) < 256) {
                for (g = 0; g < b; g++)
                  I = I << 1, O == s - 1 ? (O = 0, u.push(h(I)), I = 0) : O++;
                for (t = S.charCodeAt(0), g = 0; g < 8; g++)
                  I = I << 1 | t & 1, O == s - 1 ? (O = 0, u.push(h(I)), I = 0) : O++, t = t >> 1;
              } else {
                for (t = 1, g = 0; g < b; g++)
                  I = I << 1 | t, O == s - 1 ? (O = 0, u.push(h(I)), I = 0) : O++, t = 0;
                for (t = S.charCodeAt(0), g = 0; g < 16; g++)
                  I = I << 1 | t & 1, O == s - 1 ? (O = 0, u.push(h(I)), I = 0) : O++, t = t >> 1;
              }
              y--, y == 0 && (y = Math.pow(2, b), b++), delete m[S];
            } else
              for (t = i[S], g = 0; g < b; g++)
                I = I << 1 | t & 1, O == s - 1 ? (O = 0, u.push(h(I)), I = 0) : O++, t = t >> 1;
            y--, y == 0 && (y = Math.pow(2, b), b++), i[E] = x++, S = String(v);
          }
        if (S !== "") {
          if (Object.prototype.hasOwnProperty.call(m, S)) {
            if (S.charCodeAt(0) < 256) {
              for (g = 0; g < b; g++)
                I = I << 1, O == s - 1 ? (O = 0, u.push(h(I)), I = 0) : O++;
              for (t = S.charCodeAt(0), g = 0; g < 8; g++)
                I = I << 1 | t & 1, O == s - 1 ? (O = 0, u.push(h(I)), I = 0) : O++, t = t >> 1;
            } else {
              for (t = 1, g = 0; g < b; g++)
                I = I << 1 | t, O == s - 1 ? (O = 0, u.push(h(I)), I = 0) : O++, t = 0;
              for (t = S.charCodeAt(0), g = 0; g < 16; g++)
                I = I << 1 | t & 1, O == s - 1 ? (O = 0, u.push(h(I)), I = 0) : O++, t = t >> 1;
            }
            y--, y == 0 && (y = Math.pow(2, b), b++), delete m[S];
          } else
            for (t = i[S], g = 0; g < b; g++)
              I = I << 1 | t & 1, O == s - 1 ? (O = 0, u.push(h(I)), I = 0) : O++, t = t >> 1;
          y--, y == 0 && (y = Math.pow(2, b), b++);
        }
        for (t = 2, g = 0; g < b; g++)
          I = I << 1 | t & 1, O == s - 1 ? (O = 0, u.push(h(I)), I = 0) : O++, t = t >> 1;
        for (; ; )
          if (I = I << 1, O == s - 1) {
            u.push(h(I));
            break;
          } else O++;
        return u.join("");
      },
      decompress: function(f) {
        return f == null ? "" : f == "" ? null : c._decompress(f.length, 32768, function(s) {
          return f.charCodeAt(s);
        });
      },
      _decompress: function(f, s, h) {
        var g = [], t = 4, i = 4, m = 3, v = "", E = [], S, y, x, b, u, I, O, D = { val: h(0), position: s, index: 1 };
        for (S = 0; S < 3; S += 1)
          g[S] = S;
        for (x = 0, u = Math.pow(2, 2), I = 1; I != u; )
          b = D.val & D.position, D.position >>= 1, D.position == 0 && (D.position = s, D.val = h(D.index++)), x |= (b > 0 ? 1 : 0) * I, I <<= 1;
        switch (x) {
          case 0:
            for (x = 0, u = Math.pow(2, 8), I = 1; I != u; )
              b = D.val & D.position, D.position >>= 1, D.position == 0 && (D.position = s, D.val = h(D.index++)), x |= (b > 0 ? 1 : 0) * I, I <<= 1;
            O = r(x);
            break;
          case 1:
            for (x = 0, u = Math.pow(2, 16), I = 1; I != u; )
              b = D.val & D.position, D.position >>= 1, D.position == 0 && (D.position = s, D.val = h(D.index++)), x |= (b > 0 ? 1 : 0) * I, I <<= 1;
            O = r(x);
            break;
          case 2:
            return "";
        }
        for (g[3] = O, y = O, E.push(O); ; ) {
          if (D.index > f)
            return "";
          for (x = 0, u = Math.pow(2, m), I = 1; I != u; )
            b = D.val & D.position, D.position >>= 1, D.position == 0 && (D.position = s, D.val = h(D.index++)), x |= (b > 0 ? 1 : 0) * I, I <<= 1;
          switch (O = x) {
            case 0:
              for (x = 0, u = Math.pow(2, 8), I = 1; I != u; )
                b = D.val & D.position, D.position >>= 1, D.position == 0 && (D.position = s, D.val = h(D.index++)), x |= (b > 0 ? 1 : 0) * I, I <<= 1;
              g[i++] = r(x), O = i - 1, t--;
              break;
            case 1:
              for (x = 0, u = Math.pow(2, 16), I = 1; I != u; )
                b = D.val & D.position, D.position >>= 1, D.position == 0 && (D.position = s, D.val = h(D.index++)), x |= (b > 0 ? 1 : 0) * I, I <<= 1;
              g[i++] = r(x), O = i - 1, t--;
              break;
            case 2:
              return E.join("");
          }
          if (t == 0 && (t = Math.pow(2, m), m++), g[O])
            v = g[O];
          else if (O === i)
            v = y + y.charAt(0);
          else
            return null;
          E.push(v), g[i++] = y + v.charAt(0), t--, y = v, t == 0 && (t = Math.pow(2, m), m++);
        }
      }
    };
    return c;
  }();
  e != null ? e.exports = n : typeof angular < "u" && angular != null && angular.module("LZString", []).factory("LZString", function() {
    return n;
  });
})(Lf);
var Rb = Lf.exports;
function CB(e) {
  const n = JSON.stringify(e);
  return Rb.compressToEncodedURIComponent(n);
}
function AB(e) {
  const n = Rb.decompressFromEncodedURIComponent(e);
  return JSON.parse(n);
}
const zl = (e) => Sx(
  e,
  Ra.firm_requires_mfa
), Mb = (e) => Sx(
  e,
  Ra.invalid_sign_in_method
), AC = [
  { abbreviation: "AL", full: "Alabama" },
  { abbreviation: "AK", full: "Alaska" },
  { abbreviation: "AZ", full: "Arizona" },
  { abbreviation: "AR", full: "Arkansas" },
  { abbreviation: "CA", full: "California" },
  { abbreviation: "CO", full: "Colorado" },
  { abbreviation: "CT", full: "Connecticut" },
  { abbreviation: "DE", full: "Delaware" },
  { abbreviation: "DC", full: "District of Columbia" },
  { abbreviation: "FL", full: "Florida" },
  { abbreviation: "GA", full: "Georgia" },
  { abbreviation: "HI", full: "Hawaii" },
  { abbreviation: "ID", full: "Idaho" },
  { abbreviation: "IL", full: "Illinois" },
  { abbreviation: "IN", full: "Indiana" },
  { abbreviation: "IA", full: "Iowa" },
  { abbreviation: "KS", full: "Kansas" },
  { abbreviation: "KY", full: "Kentucky" },
  { abbreviation: "LA", full: "Louisiana" },
  { abbreviation: "ME", full: "Maine" },
  { abbreviation: "MD", full: "Maryland" },
  { abbreviation: "MA", full: "Massachusetts" },
  { abbreviation: "MI", full: "Michigan" },
  { abbreviation: "MN", full: "Minnesota" },
  { abbreviation: "MS", full: "Mississippi" },
  { abbreviation: "MO", full: "Missouri" },
  { abbreviation: "MT", full: "Montana" },
  { abbreviation: "NE", full: "Nebraska" },
  { abbreviation: "NV", full: "Nevada" },
  { abbreviation: "NH", full: "New Hampshire" },
  { abbreviation: "NJ", full: "New Jersey" },
  { abbreviation: "NM", full: "New Mexico" },
  { abbreviation: "NY", full: "New York" },
  { abbreviation: "NC", full: "North Carolina" },
  { abbreviation: "ND", full: "North Dakota" },
  { abbreviation: "OH", full: "Ohio" },
  { abbreviation: "OK", full: "Oklahoma" },
  { abbreviation: "OR", full: "Oregon" },
  { abbreviation: "PA", full: "Pennsylvania" },
  { abbreviation: "RI", full: "Rhode Island" },
  { abbreviation: "SC", full: "South Carolina" },
  { abbreviation: "SD", full: "South Dakota" },
  { abbreviation: "TN", full: "Tennessee" },
  { abbreviation: "TX", full: "Texas" },
  { abbreviation: "UT", full: "Utah" },
  { abbreviation: "VT", full: "Vermont" },
  { abbreviation: "VA", full: "Virginia" },
  { abbreviation: "WA", full: "Washington" },
  { abbreviation: "WV", full: "West Virginia" },
  { abbreviation: "WI", full: "Wisconsin" },
  { abbreviation: "WY", full: "Wyoming" },
  // Additional
  { abbreviation: "ON", full: "Ontario" },
  { abbreviation: "QC", full: "Quebec" },
  { abbreviation: "NS", full: "Nova Scotia" },
  { abbreviation: "NB", full: "New Brunswick" },
  { abbreviation: "MB", full: "Manitoba" },
  { abbreviation: "BC", full: "British Columbia" },
  { abbreviation: "PE", full: "Prince Edward Island" },
  { abbreviation: "SK", full: "Saskatchewan" },
  { abbreviation: "AB", full: "Alberta" },
  { abbreviation: "NL", full: "Newfoundland and Labrador" },
  { abbreviation: "AS", full: "American Samoa" },
  { abbreviation: "FM", full: "Federated States of Micronesia" },
  { abbreviation: "GU", full: "Guam" },
  { abbreviation: "MH", full: "Marshall Islands" },
  { abbreviation: "MP", full: "Northern Mariana Islands" },
  { abbreviation: "PR", full: "Puerto Rico" },
  { abbreviation: "PW", full: "Palau" },
  { abbreviation: "VI", full: "U.S. Virgin Islands" },
  { abbreviation: "UM", full: "U.S. Minor Outlying Islands" }
], kC = Object.fromEntries(
  AC.map(({ full: e, abbreviation: n }) => [e.toLowerCase(), n])
), kB = (e) => e && kC[e.toLowerCase().trim()] || "", EC = [
  /failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /importing a module script failed/i,
  /not a valid javascript mime type/i,
  /chunkloaderror/i,
  /loading chunk \d+ failed/i
], IC = "liscio:chunk-load-recovery", TC = () => {
  if (!(typeof window > "u"))
    return window.location;
}, OC = () => {
  if (!(typeof window > "u"))
    try {
      return window.sessionStorage;
    } catch {
      return;
    }
}, FC = (e) => `${IC}:${e || "unknown"}`, Db = (e, n = 0) => {
  if (n > 5)
    return "";
  if (typeof e == "string")
    return e;
  if (e instanceof Error)
    return `${e.name} ${e.message}`;
  if (e && typeof e == "object") {
    const r = e, a = r.error || r.reason || r.payload;
    if (a && a !== e)
      return Db(a, n + 1);
    if (typeof r.message == "string")
      return r.message;
  }
  return "";
}, Nb = (e) => {
  if (typeof Event < "u" && e instanceof Event && e.type === "vite:preloadError")
    return !0;
  const n = Db(e);
  return EC.some((r) => r.test(n));
}, Sp = (e, n = {}) => {
  if (!Nb(e))
    return !1;
  const r = n.storage || OC(), a = n.location || TC();
  if (!r || !a)
    return !1;
  const o = FC(n.appVersion);
  try {
    if (r.getItem(o))
      return !1;
    r.setItem(o, "true");
  } catch {
    return !1;
  }
  return a.reload(), !0;
}, EB = (e = {}) => {
  if (typeof window > "u")
    return () => {
    };
  const n = (a) => {
    const o = a, l = o.detail || o.payload, d = Nb(l) ? l : a;
    Sp(d, e) && a.preventDefault();
  }, r = (a) => {
    Sp(a.reason, e) && a.preventDefault();
  };
  return window.addEventListener("vite:preloadError", n), window.addEventListener("unhandledrejection", r), () => {
    window.removeEventListener("vite:preloadError", n), window.removeEventListener("unhandledrejection", r);
  };
}, _p = (e, n) => n === "archived" ? `${e} (Archived)` : e, PC = (e) => {
  const n = _p(
    e.display_name,
    e.lifecycle_status
  );
  return e.account ? [
    n,
    _p(
      e.account.display_name ?? "Recipient unavailable",
      e.account.lifecycle_status
    )
  ].join(" . ") : n;
}, jC = (e) => {
  var n;
  return e.historical_recipients !== void 0 ? e.historical_recipients.map(PC).join(", ") : (n = e.is_recipient) == null ? void 0 : n.join(", ");
}, RC = /* @__PURE__ */ new Set(["bill", "invoice"]), MC = (e) => !!(e && RC.has(e.trim().toLowerCase())), DC = (e) => {
  var n;
  return !!e && // v3 reports the source as 'Bill'; the v5 FileSource enum uses 'bill'.
  ((n = e == null ? void 0 : e.source) == null ? void 0 : n.trim().toLowerCase()) !== "bill" && !MC(e == null ? void 0 : e.task_type_key);
}, NC = /^\/invoices\/list(?:[/?#]|$)/, IB = (e) => typeof e == "string" && (e.startsWith("/\\") || NC.test(e));
function po(e) {
  var n;
  return (n = e == null ? void 0 : e.response) == null ? void 0 : n.status;
}
function LC(e) {
  return (e == null ? void 0 : e.name) === "NotAllowedError";
}
const BC = ({
  onProcessFinished: e,
  desiredCpaUrl: n,
  isMfaSetupEnabled: r,
  trackLoginEvent: a,
  loginPrimaryMethodRef: o
}) => {
  var U;
  const [l, d] = Ee("loginForm"), [c, f] = Ee(""), { rememberEmail: s } = eC(), { enablePasskeyLogin: h = !1 } = Dr(), g = !!h && Sc(), t = ut(""), i = ut(""), m = ut("password"), v = ut(a), E = ut(o);
  ot(() => {
    v.current = a, E.current = o;
  }, [a, o]);
  const S = () => {
    var Q;
    return m.current === "passkey" ? ki.PASSKEY : ((Q = E.current) == null ? void 0 : Q.current) ?? ki.PASSWORD;
  }, y = () => {
    d("loginForm"), i.current = "", f("");
  }, {
    mutateAsync: x,
    data: b,
    isLoading: u,
    error: I
  } = t8({
    mutation: {
      onSuccess: (Q) => {
        var ee, he, pe, de;
        const { auth_token: re, mfa_required: le, magic_link_sent: ce } = Q;
        t.current = re || "", ce ? ((ee = v.current) == null || ee.call(v, en.PASSWORD_SIGN_IN_COMPLETED, {
          next_step: ju.MAGIC_LINK_SENT
        }), d("magicLinkSent")) : le ? ((he = v.current) == null || he.call(v, en.PASSWORD_SIGN_IN_COMPLETED, {
          next_step: ju.MFA_CODE
        }), (pe = v.current) == null || pe.call(v, en.MFA_PROMPT_SHOWN), d("mfaCode")) : ((de = v.current) == null || de.call(v, en.PASSWORD_SIGN_IN_COMPLETED, {
          next_step: ju.CPA_SELECTOR
        }), d("cpaAutoSelect"));
      },
      onError: (Q) => {
        var re;
        (re = v.current) == null || re.call(v, en.PASSWORD_SIGN_IN_FAILED, {
          error_status: po(Q)
        });
      }
    }
  }), O = Oe(
    ({
      email: Q,
      password: re,
      rememberMe: le,
      appType: ce
    }) => {
      var ee;
      return (ee = v.current) == null || ee.call(v, en.PASSWORD_SIGN_IN_SUBMITTED), m.current = "password", le && s(Q), f(Q), x({
        data: {
          email: Q,
          password: re,
          app_type: ce
        }
      });
    },
    [s, x]
  ), {
    mutateAsync: D,
    isLoading: $,
    error: K
  } = n8({
    mutation: {}
  }), {
    mutateAsync: H,
    data: B,
    isLoading: R,
    error: _
  } = i8({
    mutation: {
      onSuccess: (Q) => {
        var le;
        const { auth_token: re } = Q;
        t.current = re || "", (le = v.current) == null || le.call(v, en.PASSKEY_SIGN_IN_COMPLETED), d("cpaAutoSelect");
      }
    }
  }), A = Oe(async () => {
    var Q, re, le;
    if ((Q = v.current) == null || Q.call(v, en.PASSKEY_SIGN_IN_SUBMITTED), !g)
      throw (re = v.current) == null || re.call(v, en.PASSKEY_SIGN_IN_FAILED), new Error("Passkeys are not supported in this browser");
    m.current = "passkey", E.current && (E.current.current = ki.PASSKEY);
    try {
      const { challenge_id: ce, options: ee } = await D(), he = await cC({
        optionsJSON: ee
      });
      return H({
        data: {
          challenge_id: ce,
          credential: he
        }
      });
    } catch (ce) {
      if (LC(ce))
        return;
      throw (le = v.current) == null || le.call(v, en.PASSKEY_SIGN_IN_FAILED, {
        error_status: po(ce)
      }), ce;
    }
  }, [
    D,
    g,
    H
  ]), {
    mutateAsync: k,
    isLoading: z,
    error: T
  } = ax({
    mutation: {
      onSuccess: () => {
        var Q;
        (Q = v.current) == null || Q.call(v, en.MAGIC_LINK_REQUEST_COMPLETED), d("magicLinkSent");
      },
      onError: (Q) => {
        var re;
        (re = v.current) == null || re.call(v, en.MAGIC_LINK_REQUEST_FAILED, {
          error_status: po(Q)
        });
      }
    }
  }), w = Oe(
    ({
      email: Q,
      appType: re,
      cpaSiteUrl: le,
      trackProperties: ce
    }) => {
      var ee;
      return (ee = v.current) == null || ee.call(v, en.MAGIC_LINK_REQUEST_SUBMITTED, {
        ...ce ?? {}
      }), f(Q), k({
        data: {
          email: Q,
          app_type: re,
          cpa_site_url: le
        }
      });
    },
    [k]
  ), {
    mutateAsync: F,
    data: j,
    isLoading: P,
    error: V
  } = gb(), {
    mutateAsync: J,
    isLoading: ne,
    error: Z
  } = mb({
    onSuccess: async (Q) => {
      Q.auth_token && (t.current = Q.auth_token || "", d("mfaSetupComplete"));
    }
  }), te = Oe(
    (Q) => J({
      two_factor_code: Q,
      temporary_auth_token: t.current
    }),
    [J]
  ), {
    mutateAsync: G,
    isLoading: N,
    data: q,
    error: ie
  } = xb({
    onSuccess: (Q) => {
      var le;
      (le = v.current) == null || le.call(v, en.MFA_CODE_COMPLETED);
      const { auth_token: re } = Q;
      t.current = re || "", d("cpaAutoSelect");
    },
    onError: (Q) => {
      var re;
      (re = v.current) == null || re.call(v, en.MFA_CODE_FAILED, {
        error_status: po(Q)
      });
    }
  }), oe = Oe(
    (Q) => {
      var re;
      return (re = v.current) == null || re.call(v, en.MFA_CODE_SUBMITTED), G({
        two_factor_code: Q,
        temporary_auth_token: t.current
      });
    },
    [G]
  ), {
    mutateAsync: fe,
    isLoading: Y,
    error: ae
  } = jf({
    onSuccess: async (Q) => {
      var re, le;
      if (Q.auth_token) {
        const ce = S();
        (re = v.current) == null || re.call(v, en.CPA_AUTHORIZATION_COMPLETED, {
          login_method: m.current
        }), (le = v.current) == null || le.call(v, en.FLOW_COMPLETED, {
          primary_method: ce
        }), Nf(ce), e(Q);
      }
    }
  }), se = Oe(
    (Q) => {
      var re;
      d("cpaSelected"), i.current = Q, Y || ((re = v.current) == null || re.call(v, en.CPA_AUTHORIZATION_CLICKED, {
        login_method: m.current
      }), fe({
        cpa_uuid: Q,
        temporary_auth_token: t.current,
        login_type: m.current
      }).catch((le) => {
        var ce;
        if (Mb(le)) {
          y();
          return;
        }
        if (zl(le)) {
          d("mfaSetup"), r && F({
            temporary_auth_token: t.current
          });
          return;
        }
        (ce = v.current) == null || ce.call(v, en.CPA_AUTHORIZATION_FAILED, {
          login_method: m.current,
          error_status: po(le)
        });
      }));
    },
    [
      F,
      Y,
      r,
      fe
    ]
  );
  if (l === "cpaAutoSelect") {
    const Q = (b == null ? void 0 : b.cpa_data) || (q == null ? void 0 : q.cpa_data) || (B == null ? void 0 : B.cpa_data), re = Rf(Q, n);
    re != null && re.cpa_uuid ? se(re == null ? void 0 : re.cpa_uuid) : d("cpaSelector");
  }
  const L = (U = ie == null ? void 0 : ie.response) == null ? void 0 : U.data, W = zl(ae) ? null : ae, M = (b == null ? void 0 : b.cpa_data) || (q == null ? void 0 : q.cpa_data) || (B == null ? void 0 : B.cpa_data), X = Oe(() => M == null ? void 0 : M.find(
    (Q) => Q.cpa_uuid === i.current
  ), [M]);
  return {
    signIn: O,
    signInWithPasskey: A,
    isPasskeySupported: g,
    generateMagicLink: w,
    selectCpa: se,
    validateMfaCode: oe,
    setupMfaCode: te,
    resetProcess: y,
    getSelectedCpa: X,
    processState: l,
    mfaSetupConfiguration: j,
    signInCpas: M,
    signInEmail: c,
    isLoading: u || $ || R || z || N || Y || P || ne,
    error: L || W || I || K || _ || T || V || Z
  };
}, $C = Qa()((e) => ({
  isBiometryAvailable: !1,
  isBiometricLoginEnabled: !1,
  biometryType: g7.NONE,
  setIsBiometryAvailable: (n) => e({ isBiometryAvailable: n }),
  setIsBiometricLoginEnabled: (n) => e({ isBiometricLoginEnabled: n }),
  setBiometryType: (n) => e({ biometryType: n })
})), Ru = "biometry_enabled", UC = ({ webAppUrl: e }) => {
  const {
    isBiometryAvailable: n,
    setIsBiometryAvailable: r,
    isBiometricLoginEnabled: a,
    setIsBiometricLoginEnabled: o,
    biometryType: l,
    setBiometryType: d
  } = $C(), c = Oe(async () => {
    if (On.isNativePlatform())
      try {
        const g = await ia.isAvailable();
        r(g.isAvailable), d(g.biometryType);
        try {
          const { value: t } = await ir.get({
            key: Ru
          });
          o(
            t === g.biometryType.toString()
          );
        } catch {
        }
      } catch {
      }
  }, [r, d, o]);
  ot(() => {
    c();
  }, [c]);
  const f = Oe(
    async ({ email: g, password: t }) => {
      n && l !== void 0 && (a || await ia.verifyIdentity({
        reason: "For biometric log in to Liscio Mobile App",
        title: "Log in to Liscio"
      }), await ia.setCredentials({
        server: e,
        username: g,
        password: t
      }), await ir.set({
        key: Ru,
        value: l.toString()
      }));
    },
    [n, l, a, e]
  ), s = Oe(async () => {
    n && l !== void 0 && (await ia.deleteCredentials({ server: e }), await ir.remove({ key: Ru }), o(!1));
  }, [
    n,
    l,
    e,
    o
  ]), h = Oe(async () => {
    if (n && l !== void 0)
      try {
        await ia.verifyIdentity({
          reason: "For biometric log in to Liscio Mobile App",
          title: "Log in to Liscio"
        });
        const g = await ia.getCredentials({
          server: e
        });
        return { email: g.username, password: g.password };
      } catch {
      }
  }, [n, l, e]);
  return {
    isBiometryAvailable: n,
    biometryType: l,
    isBiometricLoginEnabled: a,
    initBiometry: c,
    saveBiometricCredentials: f,
    clearBiometricsCredentials: s,
    performBiometricVerification: h
  };
}, TB = ({
  onProcessFinished: e,
  desiredCpaUrl: n,
  webAppUrl: r,
  appType: a,
  trackLoginEvent: o,
  loginPrimaryMethodRef: l
}) => {
  const {
    signIn: d,
    signInWithPasskey: c,
    isPasskeySupported: f,
    generateMagicLink: s,
    selectCpa: h,
    validateMfaCode: g,
    resetProcess: t,
    processState: i,
    signInCpas: m,
    signInEmail: v,
    isLoading: E,
    error: S,
    getSelectedCpa: y
  } = BC({
    onProcessFinished: e,
    desiredCpaUrl: n,
    trackLoginEvent: o,
    loginPrimaryMethodRef: l
  }), {
    isBiometricLoginEnabled: x,
    saveBiometricCredentials: b,
    performBiometricVerification: u,
    biometryType: I
  } = UC({ webAppUrl: r }), O = Ls(({ explicitLogout: K }) => K), D = Oe(
    async ({
      email: K,
      password: H,
      rememberMe: B,
      enableBiometrics: R,
      appType: _
    }) => {
      const A = await d({
        email: K,
        password: H,
        rememberMe: B,
        appType: _
      });
      return R && await b({
        email: K,
        password: H
      }), A;
    },
    [d, b]
  ), $ = Oe(async () => {
    const K = await u();
    if (K) {
      const { email: H, password: B } = K;
      l && (l.current = ki.PASSWORD), await d({
        email: H,
        password: B,
        rememberMe: !1,
        appType: a
      }).catch(_x);
    }
  }, [
    d,
    u,
    a,
    l
  ]);
  return ot(() => {
    x && !O && $();
  }, [$, O, x]), {
    biometricSignIn: $,
    signIn: D,
    signInWithPasskey: c,
    isPasskeySupported: f,
    generateMagicLink: s,
    selectCpa: h,
    validateMfaCode: g,
    resetProcess: t,
    getSelectedCpa: y,
    processState: i,
    signInCpas: m,
    signInEmail: v,
    isLoading: E,
    error: S,
    isBiometricLoginEnabled: x,
    biometryType: I
  };
};
function zC(e) {
  var n;
  return (n = e == null ? void 0 : e.response) == null ? void 0 : n.status;
}
function Cp(e) {
  switch (e) {
    case "google":
      return Fu.GOOGLE;
    case "outlook365":
      return Fu.MICROSOFT;
    default:
      return console.warn("Unknown OAuth provider for analytics:", e), Fu.MICROSOFT;
  }
}
const OB = ({
  provider: e,
  oAuthConfig: n,
  signUp: r = !1,
  shouldAddLegacyAppStateCookie: a,
  onProcessFinished: o,
  desiredCpaUrl: l,
  loginType: d,
  cpaId: c,
  trackLoginEvent: f
}) => {
  const [s, h] = Ee(), g = r ? r8 : s8, t = ut(f);
  ot(() => {
    t.current = f;
  }, [f]);
  const i = Cp(e), { mutateAsync: m, isLoading: v } = jf({
    onSuccess: async (I) => {
      var O, D;
      I.auth_token && o && ((O = t.current) == null || O.call(t, en.CPA_AUTHORIZATION_COMPLETED, {}), (D = t.current) == null || D.call(t, en.FLOW_COMPLETED, {
        primary_method: ki.OAUTH
      }), r || Nf(ki.OAUTH), o(I));
    }
  }), {
    mutateAsync: E,
    data: S,
    error: y,
    isLoading: x
  } = g({
    mutation: {
      onSuccess: (I) => {
        var D, $;
        (D = t.current) == null || D.call(t, en.OAUTH_COMPLETED, {
          provider: i
        });
        const O = Rf(
          I.cpa_data,
          l
        );
        O && (($ = t.current) == null || $.call(t, en.CPA_AUTHORIZATION_CLICKED, {}), m({
          cpa_uuid: O.cpa_uuid,
          temporary_auth_token: I.auth_token,
          login_type: d
        }));
      },
      onError: (I) => {
        var O;
        (O = t.current) == null || O.call(t, en.OAUTH_FAILED, {
          provider: i,
          error_status: zC(I)
        });
      }
    }
  }), b = Oe(
    async (I) => {
      const O = await HS(), D = n.url, $ = new URLSearchParams({
        client_id: n.clientId,
        response_type: "code",
        redirect_uri: n.redirectUri,
        scope: n.scope,
        state: O,
        ...I
      }), K = `${D}?${$.toString()}`;
      if (On.isNativePlatform())
        window.open(K);
      else {
        if (a) {
          const H = r ? "authenticate/oauth/sign_up" : "authenticate/oauth", B = `${window.location.origin}/${H}/${e}/${O}`;
          zS(O, B);
        }
        window.location.replace(K);
      }
    },
    [n, e, a, r]
  ), u = Oe(
    async ({
      code: I,
      nonce: O,
      provider: D
    }) => {
      var $;
      try {
        await WS(O);
      } catch {
        h({ message: "Invalid state nonce in OAuth response." }), ($ = t.current) == null || $.call(t, en.OAUTH_FAILED, {
          provider: Cp(D),
          error_status: void 0
        });
        return;
      }
      E({
        data: {
          code: I,
          login_type: lC(D),
          redirect_uri: n.redirectUri,
          cpa_id: c
        }
      }).catch(_x);
    },
    [n.redirectUri, E, c]
  );
  return {
    error: s || y,
    initiateOAuth: b,
    handleOAuthResponse: u,
    signInCpas: S == null ? void 0 : S.cpa_data,
    signInTemporaryAuthToken: S == null ? void 0 : S.auth_token,
    selectCpa: (I) => {
      var O;
      (O = t.current) == null || O.call(t, en.CPA_AUTHORIZATION_CLICKED, {}), m({
        cpa_uuid: I.cpa_uuid,
        temporary_auth_token: (S == null ? void 0 : S.auth_token) || "",
        login_type: d
      });
    },
    isCpaSelecting: v,
    isSigningIn: x,
    isLoading: v || x
  };
};
function Ap(e) {
  var n;
  return (n = e == null ? void 0 : e.response) == null ? void 0 : n.status;
}
const HC = ({
  token: e,
  onProcessFinished: n,
  desiredCpaUrl: r,
  isMfaSetupEnabled: a,
  cpaId: o,
  trackLoginEvent: l
}) => {
  const [d, c] = Ee(
    "initialVerification"
  ), f = ut(""), s = ut(""), h = ut(l), g = ut(!1);
  ot(() => {
    h.current = l;
  }, [l]);
  const {
    mutateAsync: t,
    data: i,
    isLoading: m,
    error: v
  } = gb(), {
    mutateAsync: E,
    isLoading: S,
    error: y
  } = mb({
    onSuccess: async (k) => {
      k.auth_token && (f.current = k.auth_token || "", c("mfaSetupComplete"));
    }
  }), x = Oe(
    (k) => E({
      two_factor_code: k,
      temporary_auth_token: f.current
    }),
    [E]
  ), {
    mutateAsync: b,
    isLoading: u,
    error: I
  } = jf({
    onSuccess: async (k) => {
      var z, T;
      k.auth_token && ((z = h.current) == null || z.call(h, en.CPA_AUTHORIZATION_COMPLETED, {
        login_method: Pu.MAGIC_LINK
      }), (T = h.current) == null || T.call(h, en.FLOW_COMPLETED, {
        primary_method: ki.MAGIC_LINK_CLICKED
      }), Nf(
        ki.MAGIC_LINK_CLICKED
      ), n(k));
    }
  }), O = Oe(
    (k) => {
      var z;
      c("cpaSelected"), s.current = k, u || ((z = h.current) == null || z.call(h, en.CPA_AUTHORIZATION_CLICKED, {
        login_method: Pu.MAGIC_LINK
      }), b({
        cpa_uuid: k,
        temporary_auth_token: f.current,
        login_type: "password"
      }).catch((T) => {
        var w;
        if (Mb(T)) {
          c("initialVerification");
          return;
        }
        if (zl(T)) {
          c("mfaSetup"), a && t({
            temporary_auth_token: f.current
          });
          return;
        }
        (w = h.current) == null || w.call(h, en.CPA_AUTHORIZATION_FAILED, {
          login_method: Pu.MAGIC_LINK,
          error_status: Ap(T)
        });
      }));
    },
    [
      t,
      u,
      a,
      b
    ]
  ), {
    data: D,
    error: $,
    isLoading: K
  } = K_({
    token: e,
    cpaId: o,
    onSuccess: (k) => {
      var T;
      (T = h.current) == null || T.call(h, en.MAGIC_LINK_COMPLETED);
      const { auth_token: z } = k;
      f.current = z || "", c("cpaAutoSelect");
    }
  });
  if (ot(() => {
    var k;
    !$ || g.current || (g.current = !0, (k = h.current) == null || k.call(h, en.MAGIC_LINK_FAILED, {
      error_status: Ap($)
    }));
  }, [$]), d === "cpaAutoSelect") {
    const k = D == null ? void 0 : D.cpa_data, z = Rf(k, r);
    z != null && z.cpa_uuid ? O(z == null ? void 0 : z.cpa_uuid) : c("cpaSelector");
  }
  const H = K || u || m || S, B = zl(I) ? null : I, R = $ || B || v || y, _ = D == null ? void 0 : D.cpa_data, A = Oe(() => _ == null ? void 0 : _.find(
    (k) => k.cpa_uuid === s.current
  ), [_]);
  return {
    isLoading: H,
    processState: d,
    signInCpas: _,
    mfaSetupConfiguration: i,
    getSelectedCpa: A,
    setupMfaCode: x,
    selectCpa: O,
    error: R
  };
}, FB = ({
  appType: e,
  cpaSiteUrl: n,
  processState: r,
  signIn: a,
  generateMagicLink: o,
  resetProcess: l,
  trackLoginEvent: d,
  loginPrimaryMethodRef: c,
  includeBiometrics: f = !1
}) => {
  const s = Oe(() => {
    d(en.BACK_TO_SIGN_IN_CLICKED, {
      from_process_state: r
    }), l();
  }, [r, l, d]), h = Oe(
    (i) => {
      c.current = ki.PASSWORD;
      const m = {
        email: i.email,
        password: i.password,
        rememberMe: !!i.enableRememberMe,
        appType: e
      };
      return a(f ? {
        ...m,
        enableBiometrics: !!i.enableBiometrics
      } : m);
    },
    [e, f, c, a]
  ), g = Oe(
    (i) => (c.current = ki.MAGIC_LINK_REQUEST, o({
      email: i,
      appType: e,
      cpaSiteUrl: n,
      trackProperties: {
        request_source: bp.SIGN_IN_TAB
      }
    })),
    [e, n, o, c]
  ), t = Oe(
    (i) => i ? () => {
      c.current = ki.MAGIC_LINK_REQUEST, o({
        email: i,
        appType: e,
        cpaSiteUrl: n,
        trackProperties: {
          request_source: bp.MFA_RECOVERY
        }
      });
    } : void 0,
    [e, n, o, c]
  );
  return {
    resetProcessWithAnalytics: s,
    handleSignInForm: h,
    handleSendMagicLink: g,
    handleMfaRecoveryMagicLink: t
  };
}, PB = ({
  token: e,
  onProcessFinished: n
}) => {
  var y, x;
  const [r, a] = Ee(
    "initialVerification"
  ), o = ut(""), { mutateAsync: l } = a8({
    mutation: {
      onSuccess: (b) => {
        const { auth_token: u, mfa_required: I } = b;
        o.current = u || "", a(I ? "mfaCode" : "newPasswordForm");
      }
    }
  }), { error: d, isLoading: c } = Sn({
    queryKey: ["authTokenValidation", e],
    queryFn: () => l({ data: { reset_token: e } }),
    retry: !1,
    cacheTime: 1 / 0
  }), {
    mutateAsync: f,
    isLoading: s,
    error: h
  } = xb({
    onSuccess: (b) => {
      const { auth_token: u } = b;
      o.current = u || "", a("newPasswordForm");
    }
  }), {
    mutateAsync: g,
    isLoading: t,
    error: i
  } = G_({
    onSuccess: async () => {
      n && n();
    }
  }), m = Oe(
    (b) => {
      g({
        password: b,
        password_confirmation: b,
        url_token: e,
        temporary_auth_token: o.current
      });
    },
    [g, e]
  ), v = Oe(
    (b) => {
      f({
        two_factor_code: b,
        temporary_auth_token: o.current
      });
    },
    [f]
  ), E = (y = i == null ? void 0 : i.response) == null ? void 0 : y.data, S = (x = h == null ? void 0 : h.response) == null ? void 0 : x.data;
  return {
    isLoading: t || s || c,
    processState: r,
    resetPassword: m,
    validateMfaCode: v,
    errors: d || E || S
  };
}, WC = Qa()((e) => ({
  cpas: [],
  sessionCpa: void 0,
  setSessionCpa: (n) => e({ sessionCpa: n }),
  appCpa: void 0,
  setAppCpa: (n) => e({ appCpa: n }),
  queryCompany: void 0,
  setQueryCompany: (n) => e({ queryCompany: n }),
  queryCpaUuid: void 0,
  setQueryCpaUuid: (n) => e({ queryCpaUuid: n }),
  isLoading: !1,
  setIsLoading: (n) => e({ isLoading: n }),
  isInitialized: !1,
  setIsInitialized: (n) => e({ isInitialized: n }),
  clearCpa: () => e({
    cpas: [],
    sessionCpa: void 0,
    appCpa: void 0,
    isInitialized: !1,
    queryCompany: void 0,
    queryCpaUuid: void 0
  })
})), jB = ({
  onProcessFinished: e
}) => {
  const n = Ls(({ clearAuth: s }) => s), r = Ls(
    ({ setExplicitLogout: s }) => s
  ), a = WC(({ clearCpa: s }) => s), o = qn(), l = Oe(async () => {
    o.clear(), await K2(), n(), a(), r(), e && e();
  }, [o, n, a, r, e]), { mutateAsync: d, isLoading: c } = o8();
  return {
    logout: async () => {
      try {
        await d(), l();
      } catch (s) {
        sf(s) === af && l();
      }
    },
    isLoading: c
  };
}, Mu = ({
  draftId: e,
  messageThreadId: n,
  content: r,
  participants: a = [],
  status: o = cl.Sent,
  title: l,
  doc_ids: d,
  attachment_origins: c,
  is_notify_via_text: f = !1,
  account_ids: s = [],
  ai_message_draft_uuid: h,
  private_documents_acknowledged: g
}) => {
  const t = {
    message_thread_id: n,
    status: o,
    content: r
  };
  return h != null && h !== "" && (t.ai_message_draft_uuid = h), {
    id: e || "",
    participants: a,
    messages: t,
    thread: {
      title: l,
      is_notify_via_text: f,
      status: o
    },
    doc_ids: d,
    attachment_origins: c,
    account_ids: s,
    private_documents_acknowledged: g
  };
}, qC = /<(?:img|table|iframe|embed|video|audio|object|svg|canvas|hr)\b/i;
function VC(e) {
  if (e == null || !String(e).trim())
    return !1;
  const n = String(e);
  return qC.test(n) || !!b0(n).result.trim();
}
function XC(e) {
  const n = Jt(), r = qn(), { sendMessage: a } = (e == null ? void 0 : e.messagesApi) || n.messages;
  return Ln({
    mutationKey: ["sending-message"],
    mutationFn: (o) => a(o),
    onMutate: async (o) => {
      var c;
      const l = (c = o.messages) == null ? void 0 : c.message_thread_id;
      await r.cancelQueries({ queryKey: ["messageThread", l] });
      const d = r.getQueryData([
        "messageThread",
        l
      ]);
      r.setQueryData(["messageThread", l], () => ({
        ...d,
        warning_msg: "",
        isOptimistic: !0
      }));
    },
    onSuccess: (o, l) => {
      var c;
      r.invalidateQueries(["messages"]);
      const d = (c = l == null ? void 0 : l.messages) == null ? void 0 : c.message_thread_id;
      d && r.invalidateQueries(["messageThread", d]), e != null && e.onSuccess && e.onSuccess();
    }
  });
}
const GC = (e) => {
  const n = Jt(), { createDraft: r } = (e == null ? void 0 : e.messagesApi) || n.messages;
  return Ln({
    mutationFn: (a) => r(a)
  });
}, KC = (e) => {
  const n = Jt(), { updateDraft: r } = (e == null ? void 0 : e.messagesApi) || n.messages;
  return Ln({
    mutationFn: (a) => r(a)
    // No need to invalidate the messageThread query here - the form already has the latest state
    // and refetching the entire thread causes unnecessary flickering during draft updates
  });
}, YC = (e) => {
  const n = Jt(), { updateParticipantsInDraft: r } = (e == null ? void 0 : e.messagesApi) || n.messages;
  return Ln({
    mutationFn: (a) => r(a)
    // No need to invalidate the messageThread query here - the form already has the latest state
    // and refetching the entire thread causes unnecessary flickering during participant updates
  });
}, ZC = (e) => {
  const n = Jt(), r = qn(), { discardMessageDraft: a } = (e == null ? void 0 : e.messagesApi) || n.messages;
  return Ln({
    mutationFn: (o) => a(o),
    onSuccess: () => {
      r.invalidateQueries(["messages"]);
    }
  });
};
class kp extends Error {
}
const RB = ({
  draftId: e,
  messageThreadId: n,
  debounceTimeout: r = 2e3,
  messagesApi: a,
  preventEmptyReplyDraftCreation: o = !1
} = {}) => {
  const [l, d] = Ee(e), c = ut(e), f = ut(0), s = ut(null), h = ut(Promise.resolve()), g = ut([]), t = ut(), i = ut(/* @__PURE__ */ new Set()), m = ut(null), [v, E] = Ee(!1), S = qn();
  ot(() => {
    c.current !== e && (f.current += 1, c.current = e, d(e), g.current = [], t.current = void 0, i.current.clear());
  }, [e]);
  const y = ut(null), x = ut(
    null
  ), b = ut(null), {
    mutateAsync: u,
    isLoading: I,
    error: O
  } = GC({ messagesApi: a }), {
    mutateAsync: D,
    isLoading: $,
    error: K
  } = KC({ messagesApi: a }), {
    mutateAsync: H,
    isLoading: B,
    error: R
  } = YC({ messagesApi: a }), {
    mutateAsync: _,
    isLoading: A,
    error: k
  } = XC({ messagesApi: a }), {
    mutateAsync: z,
    isLoading: T,
    error: w
  } = ZC({ messagesApi: a }), F = Oe(async () => {
    if (s.current)
      return s.current;
    const U = Mu({
      messageThreadId: n,
      status: cl.Draft,
      participants: [],
      content: "",
      title: "",
      doc_ids: []
    }), Q = f.current, re = u(U).then((le) => {
      const ce = le == null ? void 0 : le.message_id;
      if (Q !== f.current)
        throw new kp(
          "The active draft changed while an earlier draft was being created."
        );
      return c.current = ce, d(ce), ce;
    }).catch((le) => {
      throw console.error("Failed to create draft:", le), le;
    }).finally(() => {
      s.current === re && (s.current = null);
    });
    return s.current = re, re;
  }, [n, u]), j = Oe(async () => {
    if (c.current) return c.current;
    const U = await F();
    if (!U)
      throw new Error("Failed to create draft – aborting follow-up request");
    return U;
  }, [F]), P = Oe(() => {
    y.current && (clearTimeout(y.current), y.current = null);
  }, []), V = Oe(() => {
    P(), x.current = null;
  }, [P]), J = Oe(
    () => x.current !== null || b.current !== null,
    []
  ), ne = Oe((U) => {
    const Q = h.current.then(U, U);
    return h.current = Q.then(
      () => {
      },
      () => {
      }
    ), Q;
  }, []), Z = Oe((U) => {
    if (U !== f.current)
      throw new kp(
        "The active draft changed before the operation completed."
      );
  }, []), te = Oe(
    () => g.current.filter(
      (U) => !i.current.has(U)
    ),
    []
  ), G = Oe(
    () => {
      var U;
      return (U = t.current) == null ? void 0 : U.filter(
        ({ document_id: Q }) => !i.current.has(Q)
      );
    },
    []
  ), N = Oe(
    async (U) => {
      const Q = f.current;
      g.current = U.attachments || [], t.current = U.attachmentOrigins, await ne(async () => {
        if (Z(Q), o && n && !c.current && !s.current && !VC(U.content) && te().length === 0)
          return;
        const re = await j();
        Z(Q);
        const le = Mu({
          draftId: re,
          messageThreadId: n,
          status: cl.Draft,
          content: U.content || "",
          title: U.subject || "",
          doc_ids: te(),
          attachment_origins: G()
        });
        await D(le);
      });
    },
    [
      ne,
      Z,
      j,
      te,
      G,
      n,
      o,
      D
    ]
  ), q = Oe(
    async (U, { createDraftIfMissing: Q }) => {
      const re = f.current;
      try {
        return await ne(async () => {
          if (Z(re), !Q && !c.current) return !1;
          const le = await j();
          return Z(re), await H({
            participants: U.participants,
            account_ids: U.account_ids,
            id: le
          }), !0;
        });
      } catch (le) {
        throw console.error("Failed to update participants:", le), n && S.invalidateQueries({ queryKey: ["messageThread", n] }).catch((ce) => {
          console.error(
            "Failed to refresh thread participants:",
            ce
          );
        }), le;
      }
    },
    [
      Z,
      ne,
      j,
      n,
      S,
      H
    ]
  ), ie = Oe(
    async (U) => {
      await q(U, { createDraftIfMissing: !0 });
    },
    [q]
  ), oe = Oe(
    (U) => q(U, { createDraftIfMissing: !1 }),
    [q]
  ), fe = Oe(
    async (U) => {
      const Q = f.current;
      V();
      const re = ne(async () => {
        Z(Q);
        const le = await j();
        Z(Q), await c8(
          le,
          U
        ), i.current.add(U), g.current = te(), t.current = G(), await Promise.all([
          S.invalidateQueries({ queryKey: ["messageThread"] }),
          S.invalidateQueries({ queryKey: ["messages"] })
        ]);
      });
      m.current = re, E(!0);
      try {
        await re;
      } finally {
        m.current === re && (m.current = null, E(!1));
      }
    },
    [
      V,
      Z,
      ne,
      j,
      te,
      G,
      S
    ]
  ), Y = Oe((U) => {
    i.current.delete(U);
  }, []), ae = Oe(
    async (U) => {
      const Q = b.current;
      if (Q)
        try {
          await Q;
        } catch {
          if (x.current !== U) return;
        }
      if (x.current !== U) return;
      const re = N(U);
      b.current = re;
      try {
        await re, x.current === U && (x.current = null);
      } finally {
        b.current === re && (b.current = null);
      }
    },
    [N]
  ), se = Oe(
    async function U() {
      P();
      const Q = b.current;
      if (Q)
        return await Q, U();
      const re = x.current;
      re && (await ae(re), x.current && await U());
    },
    [P, ae]
  ), L = ut(ae);
  L.current = ae;
  const W = Oe(
    (U) => {
      P(), x.current = U, y.current = setTimeout(() => {
        y.current = null, L.current(U).catch((Q) => {
          console.error("Failed to autosave message:", Q);
        });
      }, r);
    },
    [P, r]
  ), M = Oe(
    async (U) => {
      const Q = f.current;
      try {
        V();
        const re = m.current;
        return g.current = U.attachments || [], t.current = U.attachmentOrigins, await ne(async () => {
          await re, Z(Q);
          const le = await j();
          Z(Q);
          const ce = Mu({
            draftId: le,
            messageThreadId: n,
            status: cl.Sent,
            participants: U.participants,
            content: U.content || "",
            title: U.subject || "",
            doc_ids: te(),
            attachment_origins: G(),
            is_notify_via_text: U.is_notify_via_text || !1,
            account_ids: U.account_ids || [],
            ai_message_draft_uuid: U.ai_message_draft_uuid,
            private_documents_acknowledged: U.private_documents_acknowledged
          }), ee = await _(ce);
          return c.current = void 0, d(void 0), g.current = [], t.current = void 0, i.current.clear(), ee;
        });
      } catch (re) {
        throw console.error("Failed to send message:", re), re;
      }
    },
    [
      V,
      Z,
      ne,
      j,
      te,
      G,
      n,
      _
    ]
  ), X = Oe(async () => {
    const U = f.current;
    V(), !(!c.current && !s.current) && await ne(async () => {
      Z(U);
      const Q = await j();
      Z(U), await z(Q), c.current = void 0, d(void 0), g.current = [], t.current = void 0, i.current.clear();
    });
  }, [
    V,
    Z,
    ne,
    j,
    z
  ]);
  return ot(() => () => {
    P();
  }, [P]), {
    updateMessageBody: N,
    debouncedUpdateBodyAndSubject: W,
    cancelDebouncedUpdateBodyAndSubject: V,
    flushPendingDebouncedUpdate: se,
    hasPendingDebouncedUpdate: J,
    updateParticipants: ie,
    updateParticipantsIfDraft: oe,
    removePersistedAttachment: fe,
    markAttachmentReattached: Y,
    ensureDraftId: j,
    sendMessage: M,
    discardMessageDraft: X,
    hasDraft: !!l,
    draftId: l,
    isLoading: I || A || T || $ || B || v,
    isSavingDraft: I,
    isSendingMessage: A,
    isDiscardingDraft: T,
    isUpdatingDraft: $,
    isRemovingAttachment: v,
    error: O || k || w || K || R
  };
}, MB = (e = []) => e.map((n) => n == null ? void 0 : n.id), DB = (e, n = !0) => e.map((r) => {
  var f, s, h, g, t, i, m, v, E, S, y, x, b;
  if (!((f = r.recipient) != null && f.assigne_type) && !((s = r.recipient) != null && s.assignee_type) && !((h = r.recipient) != null && h.type))
    throw new Error("Recipient type is not defined");
  const a = ((g = r.recipient) == null ? void 0 : g.type) || ((t = r.recipient) == null ? void 0 : t.assignee_type) || ((i = r.recipient) == null ? void 0 : i.assigne_type), o = ((m = r.recipient) == null ? void 0 : m.id) ?? ((v = r.recipient) == null ? void 0 : v.value), l = a === Il.Contact && ((E = r.recipient) == null ? void 0 : E.cpa_user_id) == null, d = ((S = r.recipient) == null ? void 0 : S.cpa_user_id) ?? (a === Il.User ? o : void 0), c = ((y = r.recipient) == null ? void 0 : y.contact_id) ?? (l ? o : void 0);
  return {
    id: l ? c : d ?? o,
    account_id: ((x = r.account) == null ? void 0 : x.value) ?? ((b = r.recipient) == null ? void 0 : b.account_id) ?? null,
    cpa_user_id: d,
    contact_id: c,
    type: a,
    is_recipient: n,
    message_participant_id: r.message_participant_id
    // Send for backend lookup if updating
  };
}), NB = (e) => e ? e.map((n) => {
  const r = n.contact_name || "", a = r.trim().split(/\s+/), o = a[0] || "", l = a.slice(1).join(" ") || "", d = n.type || n.assignee_type, c = d === Il.Contact && n.cpa_user_id == null, f = n.contact_id ?? (c ? n.id : void 0), s = n.cpa_user_id ?? (d === Il.User ? n.id : void 0), h = c ? f : s ?? n.id;
  return {
    recipient: {
      value: Number(h),
      label: r,
      assignee_type: d,
      assigne_type: d,
      // Add required fields for AccountContactSelector
      first_name: o,
      last_name: l,
      email: "",
      id: Number(h),
      cpa_user_id: s == null ? void 0 : Number(s),
      contact_id: f == null ? void 0 : Number(f),
      type: d,
      account_id: n.account_id ? Number(n.account_id) : void 0,
      account_name: n.account_name || void 0
    },
    account: n.account_id ? {
      value: Number(n.account_id),
      label: n.account_name || "",
      account_id: Number(n.account_id),
      account_name: n.account_name || ""
    } : null,
    message_participant_id: n.message_participant_id,
    // Preserve for updates
    // Delivery membership is independent from the UI's canRemove state.
    is_recipient: n.is_recipient !== !1
  };
}) : [];
function LB({
  value: e,
  onChange: n,
  persist: r,
  getParticipantKey: a,
  getRecipientKey: o,
  onFailure: l,
  onSuccess: d
}) {
  const c = ut(e), f = ut(e), s = ut([]), h = ut(!1), [g, t] = Ee(!1);
  ot(() => {
    !h.current && s.current.length === 0 && (c.current = e, f.current = e);
  }, [e]);
  const i = Oe(
    (y) => new Set(y.map(a)),
    [a]
  ), m = Oe(
    (y, x) => {
      const b = i(y), u = i(x);
      return new Set(
        [...y, ...x].filter((I) => {
          const O = a(I);
          return b.has(O) !== u.has(O);
        }).map(o)
      );
    },
    [a, o, i]
  ), v = Oe(
    (y, x) => {
      const b = i(x.before), u = i(x.after), I = new Set(
        [...b].filter(($) => !u.has($))
      ), O = x.after.filter(
        ($) => !b.has(a($))
      );
      return [...y.filter(
        ($) => !I.has(a($))
      ), ...O];
    },
    [a, i]
  ), E = Oe(async () => {
    if (!h.current) {
      for (h.current = !0, t(!0); s.current.length > 0; ) {
        const y = s.current[0];
        if (!y) break;
        try {
          await r(y.after), c.current = y.after, s.current.shift();
        } catch {
          const x = [...y.recipientKeys];
          s.current.shift(), s.current = s.current.filter(
            (u) => ![...u.recipientKeys].some(
              (I) => y.recipientKeys.has(I)
            )
          );
          let b = c.current;
          s.current = s.current.map((u) => {
            const I = v(b, u), O = { ...u, before: b, after: I };
            return b = I, O;
          }), f.current = b, n(b), l == null || l(x);
          continue;
        }
        try {
          d == null || d(y.before, y.after);
        } catch (x) {
          console.error(
            "Participant persistence success callback failed:",
            x
          );
        }
      }
      h.current = !1, t(!1);
    }
  }, [v, n, l, d, r]);
  return { replaceParticipants: Oe(
    (y) => {
      const x = f.current, b = {
        before: x,
        after: y,
        recipientKeys: m(x, y)
      };
      f.current = y, n(y), s.current.push(b), E();
    },
    [m, n, E]
  ), isPending: g };
}
const BB = () => {
  const [e, n] = Ee(!1), [r, a] = Ee(null), o = of(), l = Dr();
  return ot(() => {
    o && o.waitForInitialization().then(() => n(!0)).catch((d) => {
      a(d), n(!0);
    });
  }, [o]), {
    isInitialized: e,
    error: r,
    flags: l
  };
}, QC = (e) => {
  const n = u7(`/${e}/*`);
  if (e && n)
    return !!n;
}, JC = {
  isLoading: !0
}, Lb = Jr(JC), $B = ({
  children: e,
  authWithBiometryV5ProcessState: n
}) => /* @__PURE__ */ p.jsx(
  Lb.Provider,
  {
    value: n,
    children: e
  }
), UB = () => xs(Lb);
var eA = /* @__PURE__ */ ((e) => (e.Completed = "COMPLETED", e.Failed = "FAILED", e.Pending = "PENDING", e.Processing = "PROCESSING", e))(eA || {}), tA = /* @__PURE__ */ ((e) => (e.DueDate = "DUE_DATE", e.LastActivity = "LAST_ACTIVITY", e))(tA || {}), Bb = /* @__PURE__ */ ((e) => (e.Archived = "ARCHIVED", e.Closed = "CLOSED", e.Draft = "DRAFT", e.NewRequest = "NEW_REQUEST", e.Open = "OPEN", e.Recalled = "RECALLED", e.Requested = "REQUESTED", e.Returned = "RETURNED", e.Submitted = "SUBMITTED", e))(Bb || {});
const Ep = (e, n, r) => {
  var a;
  switch (e) {
    case ns.boolean:
      return {
        type: e,
        value: n == null ? void 0 : n.value,
        notApplicable: (n == null ? void 0 : n.not_applicable) || !1,
        prepopulatedEdited: (n && "prepopulated_edited" in n ? n.prepopulated_edited : !1) || !1,
        isComplete: (n == null ? void 0 : n.not_applicable) || typeof (n == null ? void 0 : n.value) == "boolean"
      };
    case ns.text:
    case ns.firm_authored_text:
      return {
        type: e,
        value: n == null ? void 0 : n.value,
        notApplicable: (n == null ? void 0 : n.not_applicable) || !1,
        prepopulatedEdited: (n && "prepopulated_edited" in n ? n.prepopulated_edited : !1) || !1,
        isComplete: (n == null ? void 0 : n.not_applicable) || ((n == null ? void 0 : n.value) || "").trim().length > 0
      };
    case ns.upload_document:
      return {
        type: e,
        value: n == null ? void 0 : n.value,
        notApplicable: (n == null ? void 0 : n.not_applicable) || !1,
        prepopulatedEdited: (n && "prepopulated_edited" in n ? n.prepopulated_edited : !1) || !1,
        isComplete: (n == null ? void 0 : n.not_applicable) || ((a = (n == null ? void 0 : n.value) || []) == null ? void 0 : a.length) > 0
      };
    case ns.reviewable_document:
      return {
        type: e,
        dependency: r == null ? void 0 : r.object,
        value: null,
        notApplicable: (n == null ? void 0 : n.not_applicable) || !1,
        prepopulatedEdited: (n && "prepopulated_edited" in n ? n.prepopulated_edited : !1) || !1,
        isComplete: (n == null ? void 0 : n.not_applicable) || !!(n != null && n.value)
      };
    case ns.signable_document:
      return {
        type: e,
        dependency: r == null ? void 0 : r.object,
        value: null,
        notApplicable: (n == null ? void 0 : n.not_applicable) || !1,
        prepopulatedEdited: (n && "prepopulated_edited" in n ? n.prepopulated_edited : !1) || !1,
        isComplete: (n == null ? void 0 : n.not_applicable) || !!(n != null && n.value)
      };
    case ns.payable:
      return {
        type: e,
        dependency: r == null ? void 0 : r.object,
        value: null,
        notApplicable: (n == null ? void 0 : n.not_applicable) || !1,
        prepopulatedEdited: (n && "prepopulated_edited" in n ? n.prepopulated_edited : !1) || !1,
        isComplete: (n == null ? void 0 : n.not_applicable) || !!(n != null && n.value)
      };
    case ns.dynamic:
      return {
        type: e,
        dependency: r == null ? void 0 : r.object,
        value: null,
        notApplicable: (n == null ? void 0 : n.not_applicable) || !1,
        prepopulatedEdited: (n && "prepopulated_edited" in n ? n.prepopulated_edited : !1) || !1,
        isComplete: (n == null ? void 0 : n.not_applicable) || !!(n != null && n.value)
      };
    default:
      throw new Error(`Invalid response type: ${e}`);
  }
}, Ip = (e) => {
  if (e.notApplicable) return !0;
  switch (e.type) {
    case "boolean":
      return typeof e.value == "boolean";
    case "text":
    case "firm_authored_text":
      return typeof e.value == "string" && e.value.trim().length > 0;
    case "upload_document":
      return Array.isArray(e.value) && e.value.length > 0;
    case "reviewable_document":
      return !!e.value;
    case "signable_document":
    case "payable":
    case "dynamic":
      return !0;
  }
}, Kd = ({
  showOnlyUnansweredQuestions: e,
  isConditionalQuestion: n,
  isQuestionAvailable: r,
  isQuestionComplete: a
}) => e ? n ? r && !a : !a : n ? r : !0, Tp = (e) => {
  if (!e) return [];
  const { questionsIds: n, questionsMap: r } = e;
  return n.filter((a) => {
    var c;
    if (!a) return !1;
    const o = r[a], l = !!((c = o == null ? void 0 : o.dependentQuestionsIds) != null && c.find((f) => {
      const s = r[f];
      return !s.isComplete && s.isAvailable;
    }));
    return !(o != null && o.isComplete) || l;
  });
}, Op = (e) => (e == null ? void 0 : e.sectionsIds.filter((n) => {
  const r = e.sectionsMap[n] || {};
  return (r == null ? void 0 : r.questionsAvailableCount) !== (r == null ? void 0 : r.questionsCompletedCount);
})) || [], La = (e, n) => {
  if (!e) return [];
  const r = e.questionsMap, a = n || (e == null ? void 0 : e.questionsIds) || [];
  return a == null ? void 0 : a.filter(
    (o) => {
      var l;
      return o ? (l = r[o]) == null ? void 0 : l.isAvailable : !1;
    }
  );
}, nA = (e) => {
  const n = e.questionsMap, r = [], a = Object.keys(e.sectionsMap).reduce(
    (o, l) => (o[l] = {
      question: e.sectionsMap[l].questionsLabelIndex + 1,
      condition: 1
    }, o),
    {}
  );
  e.questionsIds.forEach((o, l) => {
    var s;
    if (!o || (s = n[o]) != null && s.isConditional) return;
    const d = a[n[o].sectionId];
    let c = l;
    const f = n[o];
    f.numberLabel = `${d.question}`, r[c++] = f.id, f.dependentQuestionsIds.forEach((h) => {
      const g = n[h];
      g.numberLabel = `${d.question}.${d.condition}`, d.condition++;
    }), d.question++;
  }), e.questionsIds = r;
}, iA = (e, n) => {
  if (!e || !n) return null;
  const r = n.questionsMap, o = n.sectionsMap[e];
  let l = 0, d = 0, c = 0;
  o.questionsIds.forEach((f) => {
    const s = r[f];
    l++, d += s.isAvailable ? 1 : 0, c += s.isAvailable && s.isComplete ? 1 : 0;
  }), o.questionsTotalCount = l, o.questionsAvailableCount = d, o.questionsCompletedCount = c, n.questionsAnsweredCount = 0, n.questionsAvailableCount = 0, Object.values(n.sectionsMap).forEach((f) => {
    n.questionsAnsweredCount += f.questionsCompletedCount, n.questionsAvailableCount += f.questionsAvailableCount;
  });
}, Fp = (e, n, r) => {
  e.dependentQuestionsIds.forEach((a) => {
    const o = n == null ? void 0 : n[a];
    o.isAvailable = !0, o.isVisible = Kd({
      showOnlyUnansweredQuestions: r,
      isConditionalQuestion: !0,
      isQuestionAvailable: o.isAvailable,
      isQuestionComplete: o.isComplete
    });
  });
}, $b = (e) => {
  var r;
  const n = {
    title: (e == null ? void 0 : e.title) || "",
    description: (e == null ? void 0 : e.description) || "",
    type: (e == null ? void 0 : e.type) || "",
    status: (e == null ? void 0 : e.status) || "",
    dueDate: (e == null ? void 0 : e.due_date) || "",
    sourceFile: (r = e == null ? void 0 : e.source_documents) == null ? void 0 : r[0],
    sectionsIds: [],
    sectionsMap: {},
    questionsIds: [],
    availableQuestionsIds: [],
    questionsMap: {},
    questionsTotalCount: 0,
    questionsAvailableCount: 0,
    questionsAnsweredCount: 0,
    questionsNonConditionalCount: 0,
    isEditable: !1
  };
  return n.isEditable = e.status === ox.open, n;
}, zB = (e, n, r) => Sd(n, (o) => {
  o.questionsTotalCount = 0, o.questionsAvailableCount = 0, o.questionsAnsweredCount = 0, o.questionsNonConditionalCount = 0;
  const l = [];
  e == null || e.forEach((c, f) => {
    var t, i;
    const s = c.uuid, h = c.title || "", g = {
      id: s,
      title: h,
      loadedAt: r,
      questionsLoadedAt: -1 / 0,
      questionsIds: [],
      questionsTotalCount: c.items_total_count || 0,
      questionsAvailableCount: c.items_total_count || 0,
      questionsCompletedCount: c.items_completed_count || 0,
      questionsTotalNonConditionalCount: c.items_total_non_conditional_count || 0,
      questionsStartIndex: f === 0 ? 0 : o.sectionsMap[l[f - 1]].questionsStartIndex + (((t = o.sectionsMap[l[f - 1]]) == null ? void 0 : t.questionsTotalNonConditionalCount) ?? 0),
      questionsLabelIndex: f === 0 ? 0 : o.sectionsMap[l[f - 1]].questionsLabelIndex + ((i = o.sectionsMap[l[f - 1]]) == null ? void 0 : i.questionsTotalNonConditionalCount)
    };
    l.push(g.id), o.sectionsMap[g.id] = g, o.questionsTotalCount += c.items_total_count || 0, o.questionsAvailableCount += c.items_total_count || 0, o.questionsAnsweredCount += c.items_completed_count || 0, o.questionsNonConditionalCount += c.items_total_non_conditional_count || 0;
  });
  const d = La(o);
  o.availableQuestionsIds = d, o.sectionsIds = l;
}), HB = (e, n, r, a, o) => {
  const l = structuredClone(e), d = n.id, c = n.title || "";
  let f = n.questionsStartIndex;
  r == null || r.forEach((h) => {
    const g = h.uuid, t = g, i = Ep(
      h.item_type,
      h.response_item,
      h.dependency
    ), m = {
      id: t,
      requestItemId: g,
      // responseItemId,
      ...i,
      sectionId: d,
      sectionTitle: c,
      prompt: h.prompt || "",
      hint: h.hint,
      numberLabel: "",
      // Top level section questions are never conditionals
      isConditional: !1,
      isAvailable: !0,
      conditions: [],
      dependentQuestionsIds: [],
      isVisible: Kd({
        showOnlyUnansweredQuestions: a,
        isConditionalQuestion: !1,
        isQuestionAvailable: !0,
        isQuestionComplete: i.isComplete
      })
    };
    l.questionsIds[f++] = m.id, l.questionsMap[m.id] = m, m.dependentQuestionsIds = (h.conditional_items ?? []).map(
      (v) => {
        const E = Ep(
          v.item_type,
          v.response_item,
          v.dependency
        ), S = {
          id: v.uuid,
          hint: v.hint,
          requestItemId: v.uuid,
          sectionId: d,
          sectionTitle: n.title || "",
          prompt: v.prompt || "",
          ...E,
          numberLabel: "",
          isConditional: !0,
          isVisible: Kd({
            showOnlyUnansweredQuestions: a,
            isConditionalQuestion: !0,
            isQuestionAvailable: !0,
            isQuestionComplete: E.isComplete
          }),
          // conditionals are now only returned by the server if their conditions are met
          isAvailable: !0,
          dependentQuestionsIds: [],
          conditions: [
            {
              conditionalParentId: m.id
            }
          ]
        };
        return l.questionsMap[S.id] = S, S.id;
      }
    );
  }), nA(l), l.sectionsMap[d].questionsLoadedAt = o;
  const s = La(l);
  return l.availableQuestionsIds = s, l;
}, Yd = {
  requestId: "",
  currentQuestionIndex: 0,
  showOnlyUnansweredQuestions: !1,
  isSaving: !1,
  isSubmitted: !1,
  error: void 0,
  validationErrors: [],
  unansweredQuestionIdsSnapshot: [],
  incompleteSectionIdsSnapshot: [],
  disableEdit: !1
}, Pp = {
  setRequestData: () => {
  },
  setRequest: () => {
  },
  setQuestionIsNotApplicable: () => {
  },
  setQuestionValue: () => {
  },
  setShowOnlyUnansweredQuestions: () => {
  },
  setCurrentQuestionIndex: () => {
  },
  setIsSaving: () => {
  },
  setIsSubmitted: () => {
  },
  setError: () => {
  },
  setCurrentSectionId: () => {
  },
  setDisableEdit() {
  },
  setRefetchSections: () => {
  },
  setRefetchItems: () => {
  },
  refetchSections: () => {
  },
  refetchItems: () => {
  },
  addValidationError: () => {
  },
  removeValidationError: () => {
  },
  clearValidationErrors: () => {
  }
}, rA = (e, n) => c7()((r, a) => ({
  // State
  ...Yd,
  requestId: e,
  goBackUrl: n,
  // Actions
  setRequestData: (o) => {
    try {
      const l = $b(o);
      r((d) => ({
        ...d,
        // Store raw data
        workflowRequestQueryData: o,
        rawRequestData: o,
        request: l
      }));
    } catch (l) {
      rn.error(l.message, { id: "request-adapter-error" });
    }
  },
  setRequest: (o) => {
    const { showOnlyUnansweredQuestions: l } = a(), d = l ? Tp(o) : [], c = l ? Op(o) : [];
    r({
      unansweredQuestionIdsSnapshot: d,
      incompleteSectionIdsSnapshot: c
    }), r({
      request: o
    });
  },
  setQuestionValue: (o, l) => {
    const { request: d, showOnlyUnansweredQuestions: c } = a(), f = Sd(d, (s) => {
      var g;
      const h = (g = s == null ? void 0 : s.questionsMap) == null ? void 0 : g[o];
      if (!h)
        throw new Error("Unknown question");
      if (h.value = (l == null ? void 0 : l.value) ?? l, h.isComplete = Ip(h) ?? !1, Fp(
        h,
        s == null ? void 0 : s.questionsMap,
        c
      ), s) {
        const t = La(s);
        t && (s.availableQuestionsIds = t);
      }
    });
    r({
      request: f
    });
  },
  setQuestionIsNotApplicable: (o, l) => {
    const { request: d, showOnlyUnansweredQuestions: c } = a(), f = Sd(d, (s) => {
      var g;
      const h = (g = s == null ? void 0 : s.questionsMap) == null ? void 0 : g[o];
      if (!h)
        throw new Error("Unknown question");
      if (h.notApplicable = l, h.isComplete = Ip(h) ?? !1, Fp(
        h,
        s == null ? void 0 : s.questionsMap,
        c
      ), s) {
        const t = La(s);
        t && (s.availableQuestionsIds = t);
      }
      s && iA(h.sectionId, s);
    });
    r({
      request: f
    });
  },
  setShowOnlyUnansweredQuestions: (o) => {
    const {
      request: l,
      showOnlyUnansweredQuestions: d
    } = a(), c = o ?? !d, f = c ? Tp(l) : [], s = c ? Op(l) : [];
    r({
      showOnlyUnansweredQuestions: c,
      unansweredQuestionIdsSnapshot: f,
      incompleteSectionIdsSnapshot: s
    });
  },
  setCurrentQuestionIndex: (o) => {
    r((l) => {
      var s, h, g;
      const d = (s = l.request) == null ? void 0 : s.availableQuestionsIds[o];
      if (!d)
        throw new Error("Current question index is out of scope");
      const c = (h = l.request) == null ? void 0 : h.questionsMap[d];
      if (!c)
        throw new Error("Undefined question");
      const f = (g = l.request) == null ? void 0 : g.sectionsMap[c.sectionId];
      return {
        ...l,
        currentQuestionIndex: o,
        currentQuestionId: d,
        currentSectionId: f == null ? void 0 : f.id
      };
    });
  },
  setIsSaving: (o) => r({ isSaving: o }),
  setIsSubmitted: (o) => r({ isSubmitted: o }),
  setError: (o) => r({ error: o }),
  setCurrentSectionId: (o) => r({ currentSectionId: o }),
  setDisableEdit: (o) => r({ disableEdit: o }),
  setRefetchSections: (o) => r({ refetchSections: o }),
  setRefetchItems: (o) => r({ refetchItems: o }),
  refetchSections: () => a().refetchSections(),
  refetchItems: () => {
    a().refetchItems();
  },
  addValidationError: (o, l) => r((d) => d.validationErrors.some(
    (f) => f.key === o
  ) ? d : {
    validationErrors: [...d.validationErrors, { key: o, message: l }]
  }),
  removeValidationError: (o) => r((l) => ({
    validationErrors: l.validationErrors.filter(
      (d) => d.key !== o
    )
  })),
  clearValidationErrors: () => r(() => ({
    validationErrors: []
  }))
})), sA = (e, n) => {
  const {
    requestId: r,
    request: a,
    setError: o,
    setIsSaving: l,
    setQuestionIsNotApplicable: d,
    setQuestionValue: c,
    refetchSections: f,
    refetchItems: s
  } = lf(e), h = l8(), { trackRequestEvent: g } = n1(), t = Oe(
    (y, x = {}) => {
      const b = V3({
        request: a,
        requestId: r
      });
      g(y, {
        ...b,
        ...x
      });
    },
    [g, a, r]
  ), i = async ({ id: y, value: x }) => {
    const b = a == null ? void 0 : a.questionsMap[y];
    if (!b)
      throw new Error(`Invalid question "${y}"`);
    c(y, x), o(void 0);
    try {
      switch (b.type) {
        case "boolean":
          await h.mutateAsync({
            data: {
              value: x
            },
            sectionId: b.sectionId,
            itemId: b.requestItemId,
            requestId: r
          });
          break;
        case "text":
        case "firm_authored_text":
          await h.mutateAsync({
            data: {
              value: x
            },
            sectionId: b.sectionId,
            itemId: b.requestItemId,
            requestId: r
          });
          break;
      }
      f(), s(), t("request_edited");
    } catch {
      await n();
    }
  }, m = async ({
    id: y,
    value: x
  }) => {
    const b = a == null ? void 0 : a.questionsMap[y];
    if (!b)
      throw new Error(`Invalid question "${y}"`);
    if (c(y, x), b.type === "upload_document")
      try {
        const u = x, I = (u == null ? void 0 : u.map((O) => ({
          type: "document",
          id: O != null && O.uuid ? O.uuid : O
        }))) ?? [];
        await h.mutateAsync({
          data: {
            value: I
          },
          sectionId: b.sectionId,
          itemId: b.requestItemId,
          requestId: r
        }), f(), s(), t("request_edited");
      } catch {
        await n();
      }
  }, v = async (y, x) => {
    const b = a == null ? void 0 : a.questionsMap[y];
    if (!b)
      throw new Error(`Invalid question "${y}"`);
    d(y, x);
    try {
      switch (b.type) {
        case "boolean":
          await h.mutateAsync({
            data: {
              not_applicable: x
            },
            sectionId: b.sectionId,
            itemId: b.requestItemId,
            requestId: r
          });
          break;
        case "text":
        case "firm_authored_text":
          await h.mutateAsync({
            data: {
              not_applicable: x
            },
            sectionId: b.sectionId,
            itemId: b.requestItemId,
            requestId: r
          });
          break;
        case "upload_document":
          await h.mutateAsync({
            data: {
              not_applicable: x
            },
            sectionId: b.sectionId,
            itemId: b.requestItemId,
            requestId: r
          }), c(b.id, []);
          break;
      }
      f(), s(), t("request_edited");
    } catch {
      await n();
    }
  }, E = h.isLoading, S = h.error;
  return ot(() => {
    l(E);
  }, [l, E]), ot(() => {
    o(S);
  }, [o, S]), {
    answerQuestion: i,
    answerQuestionFileUpload: m,
    answerQuestionNotApplicable: v
  };
}, Ub = Jr({
  store: {
    getState: () => ({
      ...Yd,
      ...Pp
    }),
    getInitialState: () => ({
      ...Yd,
      ...Pp
    }),
    setState: () => {
    },
    subscribe: () => () => {
    },
    destroy: () => {
    }
  },
  mutations: {
    answerQuestion: () => {
    },
    answerQuestionFileUpload: () => {
    },
    answerQuestionNotApplicable: () => {
    }
  }
}), WB = ({
  id: e,
  children: n,
  goBackUrl: r
}) => {
  const [a] = Ee(() => rA(e, r)), { setRequestData: o } = lf(a), {
    data: l,
    isFetching: d,
    refetch: c
  } = f0(e, {
    query: { cacheTime: 1 / 0, staleTime: 1 / 0 }
  }), f = sA(a, c);
  ot(() => {
    l && !d && o(l);
  }, [o, l, d]);
  const s = { store: a, mutations: f };
  return /* @__PURE__ */ p.jsx(Ub.Provider, { value: s, children: n });
}, aA = ({
  isRequestEditable: e,
  hasSelectedSection: n,
  selectedSectionQuestionsCount: r,
  answeredQuestionsCount: a,
  availableQuestionsCount: o,
  visibleQuestionsCount: l,
  hasIncompleteSection: d,
  showOnlyUnansweredQuestions: c
}) => n ? l === 0 && d && c ? "empty-section-navigate" : r === 0 ? "not-available" : a === o ? "all-done" : "section-complete" : e ? a === 0 ? "new" : a === o ? "all-done" : "initial" : "submitted", Bf = JSON, oA = (e) => e.toUpperCase(), cA = (e) => {
  const n = {};
  return e.forEach((r, a) => {
    n[a] = r;
  }), n;
}, lA = (e, n, r) => e.document ? e : {
  document: e,
  variables: n,
  requestHeaders: r,
  signal: void 0
}, uA = (e, n, r) => e.query ? e : {
  query: e,
  variables: n,
  requestHeaders: r,
  signal: void 0
}, dA = (e, n) => e.documents ? e : {
  documents: e,
  requestHeaders: n,
  signal: void 0
}, hA = (e, n, ...r) => {
  const [a, o] = r;
  return e.document ? e : {
    url: e,
    document: n,
    variables: a,
    requestHeaders: o,
    signal: void 0
  };
};
function yl(e, n) {
  if (!!!e)
    throw new Error(n);
}
function fA(e) {
  return typeof e == "object" && e !== null;
}
function pA(e, n) {
  if (!!!e)
    throw new Error(
      "Unexpected invariant triggered."
    );
}
const gA = /\r\n|[\n\r]/g;
function Zd(e, n) {
  let r = 0, a = 1;
  for (const o of e.body.matchAll(gA)) {
    if (typeof o.index == "number" || pA(!1), o.index >= n)
      break;
    r = o.index + o[0].length, a += 1;
  }
  return {
    line: a,
    column: n + 1 - r
  };
}
function mA(e) {
  return zb(
    e.source,
    Zd(e.source, e.start)
  );
}
function zb(e, n) {
  const r = e.locationOffset.column - 1, a = "".padStart(r) + e.body, o = n.line - 1, l = e.locationOffset.line - 1, d = n.line + l, c = n.line === 1 ? r : 0, f = n.column + c, s = `${e.name}:${d}:${f}
`, h = a.split(/\r\n|[\n\r]/g), g = h[o];
  if (g.length > 120) {
    const t = Math.floor(f / 80), i = f % 80, m = [];
    for (let v = 0; v < g.length; v += 80)
      m.push(g.slice(v, v + 80));
    return s + jp([
      [`${d} |`, m[0]],
      ...m.slice(1, t + 1).map((v) => ["|", v]),
      ["|", "^".padStart(i)],
      ["|", m[t + 1]]
    ]);
  }
  return s + jp([
    // Lines specified like this: ["prefix", "string"],
    [`${d - 1} |`, h[o - 1]],
    [`${d} |`, g],
    ["|", "^".padStart(f)],
    [`${d + 1} |`, h[o + 1]]
  ]);
}
function jp(e) {
  const n = e.filter(([a, o]) => o !== void 0), r = Math.max(...n.map(([a]) => a.length));
  return n.map(([a, o]) => a.padStart(r) + (o ? " " + o : "")).join(`
`);
}
function xA(e) {
  const n = e[0];
  return n == null || "kind" in n || "length" in n ? {
    nodes: n,
    source: e[1],
    positions: e[2],
    path: e[3],
    originalError: e[4],
    extensions: e[5]
  } : n;
}
class $f extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */
  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */
  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */
  /**
   * The original error thrown from a field resolver during execution.
   */
  /**
   * Extension fields to add to the formatted error.
   */
  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(n, ...r) {
    var a, o, l;
    const { nodes: d, source: c, positions: f, path: s, originalError: h, extensions: g } = xA(r);
    super(n), this.name = "GraphQLError", this.path = s ?? void 0, this.originalError = h ?? void 0, this.nodes = Rp(
      Array.isArray(d) ? d : d ? [d] : void 0
    );
    const t = Rp(
      (a = this.nodes) === null || a === void 0 ? void 0 : a.map((m) => m.loc).filter((m) => m != null)
    );
    this.source = c ?? (t == null || (o = t[0]) === null || o === void 0 ? void 0 : o.source), this.positions = f ?? (t == null ? void 0 : t.map((m) => m.start)), this.locations = f && c ? f.map((m) => Zd(c, m)) : t == null ? void 0 : t.map((m) => Zd(m.source, m.start));
    const i = fA(
      h == null ? void 0 : h.extensions
    ) ? h == null ? void 0 : h.extensions : void 0;
    this.extensions = (l = g ?? i) !== null && l !== void 0 ? l : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), h != null && h.stack ? Object.defineProperty(this, "stack", {
      value: h.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(this, $f) : Object.defineProperty(this, "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  toString() {
    let n = this.message;
    if (this.nodes)
      for (const r of this.nodes)
        r.loc && (n += `

` + mA(r.loc));
    else if (this.source && this.locations)
      for (const r of this.locations)
        n += `

` + zb(this.source, r);
    return n;
  }
  toJSON() {
    const n = {
      message: this.message
    };
    return this.locations != null && (n.locations = this.locations), this.path != null && (n.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (n.extensions = this.extensions), n;
  }
}
function Rp(e) {
  return e === void 0 || e.length === 0 ? void 0 : e;
}
function ai(e, n, r) {
  return new $f(`Syntax Error: ${r}`, {
    source: e,
    positions: [n]
  });
}
class bA {
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The Token at which this Node begins.
   */
  /**
   * The Token at which this Node ends.
   */
  /**
   * The Source document the AST represents.
   */
  constructor(n, r, a) {
    this.start = n.start, this.end = r.end, this.startToken = n, this.endToken = r, this.source = a;
  }
  get [Symbol.toStringTag]() {
    return "Location";
  }
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
class Hb {
  /**
   * The kind of Token.
   */
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The 1-indexed line number on which this Token appears.
   */
  /**
   * The 1-indexed column number at which this Token begins.
   */
  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */
  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(n, r, a, o, l, d) {
    this.kind = n, this.start = r, this.end = a, this.line = o, this.column = l, this.value = d, this.prev = null, this.next = null;
  }
  get [Symbol.toStringTag]() {
    return "Token";
  }
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
}
const Wb = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, yA = new Set(Object.keys(Wb));
function Mp(e) {
  const n = e == null ? void 0 : e.kind;
  return typeof n == "string" && yA.has(n);
}
var _a;
(function(e) {
  e.QUERY = "query", e.MUTATION = "mutation", e.SUBSCRIPTION = "subscription";
})(_a || (_a = {}));
var Qd;
(function(e) {
  e.QUERY = "QUERY", e.MUTATION = "MUTATION", e.SUBSCRIPTION = "SUBSCRIPTION", e.FIELD = "FIELD", e.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", e.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", e.INLINE_FRAGMENT = "INLINE_FRAGMENT", e.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", e.SCHEMA = "SCHEMA", e.SCALAR = "SCALAR", e.OBJECT = "OBJECT", e.FIELD_DEFINITION = "FIELD_DEFINITION", e.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", e.INTERFACE = "INTERFACE", e.UNION = "UNION", e.ENUM = "ENUM", e.ENUM_VALUE = "ENUM_VALUE", e.INPUT_OBJECT = "INPUT_OBJECT", e.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION";
})(Qd || (Qd = {}));
var Kt;
(function(e) {
  e.NAME = "Name", e.DOCUMENT = "Document", e.OPERATION_DEFINITION = "OperationDefinition", e.VARIABLE_DEFINITION = "VariableDefinition", e.SELECTION_SET = "SelectionSet", e.FIELD = "Field", e.ARGUMENT = "Argument", e.FRAGMENT_SPREAD = "FragmentSpread", e.INLINE_FRAGMENT = "InlineFragment", e.FRAGMENT_DEFINITION = "FragmentDefinition", e.VARIABLE = "Variable", e.INT = "IntValue", e.FLOAT = "FloatValue", e.STRING = "StringValue", e.BOOLEAN = "BooleanValue", e.NULL = "NullValue", e.ENUM = "EnumValue", e.LIST = "ListValue", e.OBJECT = "ObjectValue", e.OBJECT_FIELD = "ObjectField", e.DIRECTIVE = "Directive", e.NAMED_TYPE = "NamedType", e.LIST_TYPE = "ListType", e.NON_NULL_TYPE = "NonNullType", e.SCHEMA_DEFINITION = "SchemaDefinition", e.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", e.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", e.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", e.FIELD_DEFINITION = "FieldDefinition", e.INPUT_VALUE_DEFINITION = "InputValueDefinition", e.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", e.UNION_TYPE_DEFINITION = "UnionTypeDefinition", e.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", e.ENUM_VALUE_DEFINITION = "EnumValueDefinition", e.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", e.DIRECTIVE_DEFINITION = "DirectiveDefinition", e.SCHEMA_EXTENSION = "SchemaExtension", e.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", e.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", e.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", e.UNION_TYPE_EXTENSION = "UnionTypeExtension", e.ENUM_TYPE_EXTENSION = "EnumTypeExtension", e.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension";
})(Kt || (Kt = {}));
function Jd(e) {
  return e === 9 || e === 32;
}
function ec(e) {
  return e >= 48 && e <= 57;
}
function qb(e) {
  return e >= 97 && e <= 122 || // A-Z
  e >= 65 && e <= 90;
}
function Vb(e) {
  return qb(e) || e === 95;
}
function vA(e) {
  return qb(e) || ec(e) || e === 95;
}
function wA(e) {
  var n;
  let r = Number.MAX_SAFE_INTEGER, a = null, o = -1;
  for (let d = 0; d < e.length; ++d) {
    var l;
    const c = e[d], f = SA(c);
    f !== c.length && (a = (l = a) !== null && l !== void 0 ? l : d, o = d, d !== 0 && f < r && (r = f));
  }
  return e.map((d, c) => c === 0 ? d : d.slice(r)).slice(
    (n = a) !== null && n !== void 0 ? n : 0,
    o + 1
  );
}
function SA(e) {
  let n = 0;
  for (; n < e.length && Jd(e.charCodeAt(n)); )
    ++n;
  return n;
}
function _A(e, n) {
  const r = e.replace(/"""/g, '\\"""'), a = r.split(/\r\n|[\n\r]/g), o = a.length === 1, l = a.length > 1 && a.slice(1).every((i) => i.length === 0 || Jd(i.charCodeAt(0))), d = r.endsWith('\\"""'), c = e.endsWith('"') && !d, f = e.endsWith("\\"), s = c || f, h = (
    // add leading and trailing new lines only if it improves readability
    !o || e.length > 70 || s || l || d
  );
  let g = "";
  const t = o && Jd(e.charCodeAt(0));
  return (h && !t || l) && (g += `
`), g += r, (h || s) && (g += `
`), '"""' + g + '"""';
}
var rt;
(function(e) {
  e.SOF = "<SOF>", e.EOF = "<EOF>", e.BANG = "!", e.DOLLAR = "$", e.AMP = "&", e.PAREN_L = "(", e.PAREN_R = ")", e.SPREAD = "...", e.COLON = ":", e.EQUALS = "=", e.AT = "@", e.BRACKET_L = "[", e.BRACKET_R = "]", e.BRACE_L = "{", e.PIPE = "|", e.BRACE_R = "}", e.NAME = "Name", e.INT = "Int", e.FLOAT = "Float", e.STRING = "String", e.BLOCK_STRING = "BlockString", e.COMMENT = "Comment";
})(rt || (rt = {}));
class CA {
  /**
   * The previously focused non-ignored token.
   */
  /**
   * The currently focused non-ignored token.
   */
  /**
   * The (1-indexed) line containing the current token.
   */
  /**
   * The character offset at which the current line begins.
   */
  constructor(n) {
    const r = new Hb(rt.SOF, 0, 0, 0, 0);
    this.source = n, this.lastToken = r, this.token = r, this.line = 1, this.lineStart = 0;
  }
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */
  advance() {
    return this.lastToken = this.token, this.token = this.lookahead();
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  lookahead() {
    let n = this.token;
    if (n.kind !== rt.EOF)
      do
        if (n.next)
          n = n.next;
        else {
          const r = kA(this, n.end);
          n.next = r, r.prev = n, n = r;
        }
      while (n.kind === rt.COMMENT);
    return n;
  }
}
function AA(e) {
  return e === rt.BANG || e === rt.DOLLAR || e === rt.AMP || e === rt.PAREN_L || e === rt.PAREN_R || e === rt.SPREAD || e === rt.COLON || e === rt.EQUALS || e === rt.AT || e === rt.BRACKET_L || e === rt.BRACKET_R || e === rt.BRACE_L || e === rt.PIPE || e === rt.BRACE_R;
}
function io(e) {
  return e >= 0 && e <= 55295 || e >= 57344 && e <= 1114111;
}
function L0(e, n) {
  return Xb(e.charCodeAt(n)) && Gb(e.charCodeAt(n + 1));
}
function Xb(e) {
  return e >= 55296 && e <= 56319;
}
function Gb(e) {
  return e >= 56320 && e <= 57343;
}
function Bs(e, n) {
  const r = e.source.body.codePointAt(n);
  if (r === void 0)
    return rt.EOF;
  if (r >= 32 && r <= 126) {
    const a = String.fromCodePoint(r);
    return a === '"' ? `'"'` : `"${a}"`;
  }
  return "U+" + r.toString(16).toUpperCase().padStart(4, "0");
}
function Zn(e, n, r, a, o) {
  const l = e.line, d = 1 + r - e.lineStart;
  return new Hb(n, r, a, l, d, o);
}
function kA(e, n) {
  const r = e.source.body, a = r.length;
  let o = n;
  for (; o < a; ) {
    const l = r.charCodeAt(o);
    switch (l) {
      case 65279:
      case 9:
      case 32:
      case 44:
        ++o;
        continue;
      case 10:
        ++o, ++e.line, e.lineStart = o;
        continue;
      case 13:
        r.charCodeAt(o + 1) === 10 ? o += 2 : ++o, ++e.line, e.lineStart = o;
        continue;
      case 35:
        return EA(e, o);
      case 33:
        return Zn(e, rt.BANG, o, o + 1);
      case 36:
        return Zn(e, rt.DOLLAR, o, o + 1);
      case 38:
        return Zn(e, rt.AMP, o, o + 1);
      case 40:
        return Zn(e, rt.PAREN_L, o, o + 1);
      case 41:
        return Zn(e, rt.PAREN_R, o, o + 1);
      case 46:
        if (r.charCodeAt(o + 1) === 46 && r.charCodeAt(o + 2) === 46)
          return Zn(e, rt.SPREAD, o, o + 3);
        break;
      case 58:
        return Zn(e, rt.COLON, o, o + 1);
      case 61:
        return Zn(e, rt.EQUALS, o, o + 1);
      case 64:
        return Zn(e, rt.AT, o, o + 1);
      case 91:
        return Zn(e, rt.BRACKET_L, o, o + 1);
      case 93:
        return Zn(e, rt.BRACKET_R, o, o + 1);
      case 123:
        return Zn(e, rt.BRACE_L, o, o + 1);
      case 124:
        return Zn(e, rt.PIPE, o, o + 1);
      case 125:
        return Zn(e, rt.BRACE_R, o, o + 1);
      case 34:
        return r.charCodeAt(o + 1) === 34 && r.charCodeAt(o + 2) === 34 ? jA(e, o) : TA(e, o);
    }
    if (ec(l) || l === 45)
      return IA(e, o, l);
    if (Vb(l))
      return RA(e, o);
    throw ai(
      e.source,
      o,
      l === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : io(l) || L0(r, o) ? `Unexpected character: ${Bs(e, o)}.` : `Invalid character: ${Bs(e, o)}.`
    );
  }
  return Zn(e, rt.EOF, a, a);
}
function EA(e, n) {
  const r = e.source.body, a = r.length;
  let o = n + 1;
  for (; o < a; ) {
    const l = r.charCodeAt(o);
    if (l === 10 || l === 13)
      break;
    if (io(l))
      ++o;
    else if (L0(r, o))
      o += 2;
    else
      break;
  }
  return Zn(
    e,
    rt.COMMENT,
    n,
    o,
    r.slice(n + 1, o)
  );
}
function IA(e, n, r) {
  const a = e.source.body;
  let o = n, l = r, d = !1;
  if (l === 45 && (l = a.charCodeAt(++o)), l === 48) {
    if (l = a.charCodeAt(++o), ec(l))
      throw ai(
        e.source,
        o,
        `Invalid number, unexpected digit after 0: ${Bs(
          e,
          o
        )}.`
      );
  } else
    o = Du(e, o, l), l = a.charCodeAt(o);
  if (l === 46 && (d = !0, l = a.charCodeAt(++o), o = Du(e, o, l), l = a.charCodeAt(o)), (l === 69 || l === 101) && (d = !0, l = a.charCodeAt(++o), (l === 43 || l === 45) && (l = a.charCodeAt(++o)), o = Du(e, o, l), l = a.charCodeAt(o)), l === 46 || Vb(l))
    throw ai(
      e.source,
      o,
      `Invalid number, expected digit but got: ${Bs(
        e,
        o
      )}.`
    );
  return Zn(
    e,
    d ? rt.FLOAT : rt.INT,
    n,
    o,
    a.slice(n, o)
  );
}
function Du(e, n, r) {
  if (!ec(r))
    throw ai(
      e.source,
      n,
      `Invalid number, expected digit but got: ${Bs(
        e,
        n
      )}.`
    );
  const a = e.source.body;
  let o = n + 1;
  for (; ec(a.charCodeAt(o)); )
    ++o;
  return o;
}
function TA(e, n) {
  const r = e.source.body, a = r.length;
  let o = n + 1, l = o, d = "";
  for (; o < a; ) {
    const c = r.charCodeAt(o);
    if (c === 34)
      return d += r.slice(l, o), Zn(e, rt.STRING, n, o + 1, d);
    if (c === 92) {
      d += r.slice(l, o);
      const f = r.charCodeAt(o + 1) === 117 ? r.charCodeAt(o + 2) === 123 ? OA(e, o) : FA(e, o) : PA(e, o);
      d += f.value, o += f.size, l = o;
      continue;
    }
    if (c === 10 || c === 13)
      break;
    if (io(c))
      ++o;
    else if (L0(r, o))
      o += 2;
    else
      throw ai(
        e.source,
        o,
        `Invalid character within String: ${Bs(
          e,
          o
        )}.`
      );
  }
  throw ai(e.source, o, "Unterminated string.");
}
function OA(e, n) {
  const r = e.source.body;
  let a = 0, o = 3;
  for (; o < 12; ) {
    const l = r.charCodeAt(n + o++);
    if (l === 125) {
      if (o < 5 || !io(a))
        break;
      return {
        value: String.fromCodePoint(a),
        size: o
      };
    }
    if (a = a << 4 | Eo(l), a < 0)
      break;
  }
  throw ai(
    e.source,
    n,
    `Invalid Unicode escape sequence: "${r.slice(
      n,
      n + o
    )}".`
  );
}
function FA(e, n) {
  const r = e.source.body, a = Dp(r, n + 2);
  if (io(a))
    return {
      value: String.fromCodePoint(a),
      size: 6
    };
  if (Xb(a) && r.charCodeAt(n + 6) === 92 && r.charCodeAt(n + 7) === 117) {
    const o = Dp(r, n + 8);
    if (Gb(o))
      return {
        value: String.fromCodePoint(a, o),
        size: 12
      };
  }
  throw ai(
    e.source,
    n,
    `Invalid Unicode escape sequence: "${r.slice(n, n + 6)}".`
  );
}
function Dp(e, n) {
  return Eo(e.charCodeAt(n)) << 12 | Eo(e.charCodeAt(n + 1)) << 8 | Eo(e.charCodeAt(n + 2)) << 4 | Eo(e.charCodeAt(n + 3));
}
function Eo(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 65 && e <= 70 ? e - 55 : e >= 97 && e <= 102 ? e - 87 : -1;
}
function PA(e, n) {
  const r = e.source.body;
  switch (r.charCodeAt(n + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: `
`,
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw ai(
    e.source,
    n,
    `Invalid character escape sequence: "${r.slice(
      n,
      n + 2
    )}".`
  );
}
function jA(e, n) {
  const r = e.source.body, a = r.length;
  let o = e.lineStart, l = n + 3, d = l, c = "";
  const f = [];
  for (; l < a; ) {
    const s = r.charCodeAt(l);
    if (s === 34 && r.charCodeAt(l + 1) === 34 && r.charCodeAt(l + 2) === 34) {
      c += r.slice(d, l), f.push(c);
      const h = Zn(
        e,
        rt.BLOCK_STRING,
        n,
        l + 3,
        // Return a string of the lines joined with U+000A.
        wA(f).join(`
`)
      );
      return e.line += f.length - 1, e.lineStart = o, h;
    }
    if (s === 92 && r.charCodeAt(l + 1) === 34 && r.charCodeAt(l + 2) === 34 && r.charCodeAt(l + 3) === 34) {
      c += r.slice(d, l), d = l + 1, l += 4;
      continue;
    }
    if (s === 10 || s === 13) {
      c += r.slice(d, l), f.push(c), s === 13 && r.charCodeAt(l + 1) === 10 ? l += 2 : ++l, c = "", d = l, o = l;
      continue;
    }
    if (io(s))
      ++l;
    else if (L0(r, l))
      l += 2;
    else
      throw ai(
        e.source,
        l,
        `Invalid character within String: ${Bs(
          e,
          l
        )}.`
      );
  }
  throw ai(e.source, l, "Unterminated string.");
}
function RA(e, n) {
  const r = e.source.body, a = r.length;
  let o = n + 1;
  for (; o < a; ) {
    const l = r.charCodeAt(o);
    if (vA(l))
      ++o;
    else
      break;
  }
  return Zn(
    e,
    rt.NAME,
    n,
    o,
    r.slice(n, o)
  );
}
const MA = 10, Kb = 2;
function Uf(e) {
  return B0(e, []);
}
function B0(e, n) {
  switch (typeof e) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? `[function ${e.name}]` : "[function]";
    case "object":
      return DA(e, n);
    default:
      return String(e);
  }
}
function DA(e, n) {
  if (e === null)
    return "null";
  if (n.includes(e))
    return "[Circular]";
  const r = [...n, e];
  if (NA(e)) {
    const a = e.toJSON();
    if (a !== e)
      return typeof a == "string" ? a : B0(a, r);
  } else if (Array.isArray(e))
    return BA(e, r);
  return LA(e, r);
}
function NA(e) {
  return typeof e.toJSON == "function";
}
function LA(e, n) {
  const r = Object.entries(e);
  return r.length === 0 ? "{}" : n.length > Kb ? "[" + $A(e) + "]" : "{ " + r.map(
    ([o, l]) => o + ": " + B0(l, n)
  ).join(", ") + " }";
}
function BA(e, n) {
  if (e.length === 0)
    return "[]";
  if (n.length > Kb)
    return "[Array]";
  const r = Math.min(MA, e.length), a = e.length - r, o = [];
  for (let l = 0; l < r; ++l)
    o.push(B0(e[l], n));
  return a === 1 ? o.push("... 1 more item") : a > 1 && o.push(`... ${a} more items`), "[" + o.join(", ") + "]";
}
function $A(e) {
  const n = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (n === "Object" && typeof e.constructor == "function") {
    const r = e.constructor.name;
    if (typeof r == "string" && r !== "")
      return r;
  }
  return n;
}
const UA = globalThis.process && // eslint-disable-next-line no-undef
process.env.NODE_ENV === "production", zA = (
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  UA ? function(n, r) {
    return n instanceof r;
  } : function(n, r) {
    if (n instanceof r)
      return !0;
    if (typeof n == "object" && n !== null) {
      var a;
      const o = r.prototype[Symbol.toStringTag], l = (
        // We still need to support constructor's name to detect conflicts with older versions of this library.
        Symbol.toStringTag in n ? n[Symbol.toStringTag] : (a = n.constructor) === null || a === void 0 ? void 0 : a.name
      );
      if (o === l) {
        const d = Uf(n);
        throw new Error(`Cannot use ${o} "${d}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
      }
    }
    return !1;
  }
);
class Yb {
  constructor(n, r = "GraphQL request", a = {
    line: 1,
    column: 1
  }) {
    typeof n == "string" || yl(!1, `Body must be a string. Received: ${Uf(n)}.`), this.body = n, this.name = r, this.locationOffset = a, this.locationOffset.line > 0 || yl(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || yl(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function HA(e) {
  return zA(e, Yb);
}
function WA(e, n) {
  return new qA(e, n).parseDocument();
}
class qA {
  constructor(n, r = {}) {
    const a = HA(n) ? n : new Yb(n);
    this._lexer = new CA(a), this._options = r, this._tokenCounter = 0;
  }
  /**
   * Converts a name lex token into a name parse node.
   */
  parseName() {
    const n = this.expectToken(rt.NAME);
    return this.node(n, {
      kind: Kt.NAME,
      value: n.value
    });
  }
  // Implements the parsing rules in the Document section.
  /**
   * Document : Definition+
   */
  parseDocument() {
    return this.node(this._lexer.token, {
      kind: Kt.DOCUMENT,
      definitions: this.many(
        rt.SOF,
        this.parseDefinition,
        rt.EOF
      )
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  parseDefinition() {
    if (this.peek(rt.BRACE_L))
      return this.parseOperationDefinition();
    const n = this.peekDescription(), r = n ? this._lexer.lookahead() : this._lexer.token;
    if (r.kind === rt.NAME) {
      switch (r.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
      if (n)
        throw ai(
          this._lexer.source,
          this._lexer.token.start,
          "Unexpected description, descriptions are supported only on type definitions."
        );
      switch (r.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
        case "extend":
          return this.parseTypeSystemExtension();
      }
    }
    throw this.unexpected(r);
  }
  // Implements the parsing rules in the Operations section.
  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  parseOperationDefinition() {
    const n = this._lexer.token;
    if (this.peek(rt.BRACE_L))
      return this.node(n, {
        kind: Kt.OPERATION_DEFINITION,
        operation: _a.QUERY,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
    const r = this.parseOperationType();
    let a;
    return this.peek(rt.NAME) && (a = this.parseName()), this.node(n, {
      kind: Kt.OPERATION_DEFINITION,
      operation: r,
      name: a,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */
  parseOperationType() {
    const n = this.expectToken(rt.NAME);
    switch (n.value) {
      case "query":
        return _a.QUERY;
      case "mutation":
        return _a.MUTATION;
      case "subscription":
        return _a.SUBSCRIPTION;
    }
    throw this.unexpected(n);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  parseVariableDefinitions() {
    return this.optionalMany(
      rt.PAREN_L,
      this.parseVariableDefinition,
      rt.PAREN_R
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: Kt.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(rt.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(rt.EQUALS) ? this.parseConstValueLiteral() : void 0,
      directives: this.parseConstDirectives()
    });
  }
  /**
   * Variable : $ Name
   */
  parseVariable() {
    const n = this._lexer.token;
    return this.expectToken(rt.DOLLAR), this.node(n, {
      kind: Kt.VARIABLE,
      name: this.parseName()
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */
  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: Kt.SELECTION_SET,
      selections: this.many(
        rt.BRACE_L,
        this.parseSelection,
        rt.BRACE_R
      )
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  parseSelection() {
    return this.peek(rt.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  parseField() {
    const n = this._lexer.token, r = this.parseName();
    let a, o;
    return this.expectOptionalToken(rt.COLON) ? (a = r, o = this.parseName()) : o = r, this.node(n, {
      kind: Kt.FIELD,
      alias: a,
      name: o,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(rt.BRACE_L) ? this.parseSelectionSet() : void 0
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  parseArguments(n) {
    const r = n ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(rt.PAREN_L, r, rt.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  parseArgument(n = !1) {
    const r = this._lexer.token, a = this.parseName();
    return this.expectToken(rt.COLON), this.node(r, {
      kind: Kt.ARGUMENT,
      name: a,
      value: this.parseValueLiteral(n)
    });
  }
  parseConstArgument() {
    return this.parseArgument(!0);
  }
  // Implements the parsing rules in the Fragments section.
  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  parseFragment() {
    const n = this._lexer.token;
    this.expectToken(rt.SPREAD);
    const r = this.expectOptionalKeyword("on");
    return !r && this.peek(rt.NAME) ? this.node(n, {
      kind: Kt.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1)
    }) : this.node(n, {
      kind: Kt.INLINE_FRAGMENT,
      typeCondition: r ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  parseFragmentDefinition() {
    const n = this._lexer.token;
    return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(n, {
      kind: Kt.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    }) : this.node(n, {
      kind: Kt.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentName : Name but not `on`
   */
  parseFragmentName() {
    if (this._lexer.token.value === "on")
      throw this.unexpected();
    return this.parseName();
  }
  // Implements the parsing rules in the Values section.
  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseValueLiteral(n) {
    const r = this._lexer.token;
    switch (r.kind) {
      case rt.BRACKET_L:
        return this.parseList(n);
      case rt.BRACE_L:
        return this.parseObject(n);
      case rt.INT:
        return this.advanceLexer(), this.node(r, {
          kind: Kt.INT,
          value: r.value
        });
      case rt.FLOAT:
        return this.advanceLexer(), this.node(r, {
          kind: Kt.FLOAT,
          value: r.value
        });
      case rt.STRING:
      case rt.BLOCK_STRING:
        return this.parseStringLiteral();
      case rt.NAME:
        switch (this.advanceLexer(), r.value) {
          case "true":
            return this.node(r, {
              kind: Kt.BOOLEAN,
              value: !0
            });
          case "false":
            return this.node(r, {
              kind: Kt.BOOLEAN,
              value: !1
            });
          case "null":
            return this.node(r, {
              kind: Kt.NULL
            });
          default:
            return this.node(r, {
              kind: Kt.ENUM,
              value: r.value
            });
        }
      case rt.DOLLAR:
        if (n)
          if (this.expectToken(rt.DOLLAR), this._lexer.token.kind === rt.NAME) {
            const a = this._lexer.token.value;
            throw ai(
              this._lexer.source,
              r.start,
              `Unexpected variable "$${a}" in constant value.`
            );
          } else
            throw this.unexpected(r);
        return this.parseVariable();
      default:
        throw this.unexpected();
    }
  }
  parseConstValueLiteral() {
    return this.parseValueLiteral(!0);
  }
  parseStringLiteral() {
    const n = this._lexer.token;
    return this.advanceLexer(), this.node(n, {
      kind: Kt.STRING,
      value: n.value,
      block: n.kind === rt.BLOCK_STRING
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  parseList(n) {
    const r = () => this.parseValueLiteral(n);
    return this.node(this._lexer.token, {
      kind: Kt.LIST,
      values: this.any(rt.BRACKET_L, r, rt.BRACKET_R)
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */
  parseObject(n) {
    const r = () => this.parseObjectField(n);
    return this.node(this._lexer.token, {
      kind: Kt.OBJECT,
      fields: this.any(rt.BRACE_L, r, rt.BRACE_R)
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  parseObjectField(n) {
    const r = this._lexer.token, a = this.parseName();
    return this.expectToken(rt.COLON), this.node(r, {
      kind: Kt.OBJECT_FIELD,
      name: a,
      value: this.parseValueLiteral(n)
    });
  }
  // Implements the parsing rules in the Directives section.
  /**
   * Directives[Const] : Directive[?Const]+
   */
  parseDirectives(n) {
    const r = [];
    for (; this.peek(rt.AT); )
      r.push(this.parseDirective(n));
    return r;
  }
  parseConstDirectives() {
    return this.parseDirectives(!0);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */
  parseDirective(n) {
    const r = this._lexer.token;
    return this.expectToken(rt.AT), this.node(r, {
      kind: Kt.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(n)
    });
  }
  // Implements the parsing rules in the Types section.
  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  parseTypeReference() {
    const n = this._lexer.token;
    let r;
    if (this.expectOptionalToken(rt.BRACKET_L)) {
      const a = this.parseTypeReference();
      this.expectToken(rt.BRACKET_R), r = this.node(n, {
        kind: Kt.LIST_TYPE,
        type: a
      });
    } else
      r = this.parseNamedType();
    return this.expectOptionalToken(rt.BANG) ? this.node(n, {
      kind: Kt.NON_NULL_TYPE,
      type: r
    }) : r;
  }
  /**
   * NamedType : Name
   */
  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: Kt.NAMED_TYPE,
      name: this.parseName()
    });
  }
  // Implements the parsing rules in the Type Definition section.
  peekDescription() {
    return this.peek(rt.STRING) || this.peek(rt.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  parseDescription() {
    if (this.peekDescription())
      return this.parseStringLiteral();
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */
  parseSchemaDefinition() {
    const n = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("schema");
    const a = this.parseConstDirectives(), o = this.many(
      rt.BRACE_L,
      this.parseOperationTypeDefinition,
      rt.BRACE_R
    );
    return this.node(n, {
      kind: Kt.SCHEMA_DEFINITION,
      description: r,
      directives: a,
      operationTypes: o
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  parseOperationTypeDefinition() {
    const n = this._lexer.token, r = this.parseOperationType();
    this.expectToken(rt.COLON);
    const a = this.parseNamedType();
    return this.node(n, {
      kind: Kt.OPERATION_TYPE_DEFINITION,
      operation: r,
      type: a
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  parseScalarTypeDefinition() {
    const n = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("scalar");
    const a = this.parseName(), o = this.parseConstDirectives();
    return this.node(n, {
      kind: Kt.SCALAR_TYPE_DEFINITION,
      description: r,
      name: a,
      directives: o
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  parseObjectTypeDefinition() {
    const n = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("type");
    const a = this.parseName(), o = this.parseImplementsInterfaces(), l = this.parseConstDirectives(), d = this.parseFieldsDefinition();
    return this.node(n, {
      kind: Kt.OBJECT_TYPE_DEFINITION,
      description: r,
      name: a,
      interfaces: o,
      directives: l,
      fields: d
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  parseImplementsInterfaces() {
    return this.expectOptionalKeyword("implements") ? this.delimitedMany(rt.AMP, this.parseNamedType) : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */
  parseFieldsDefinition() {
    return this.optionalMany(
      rt.BRACE_L,
      this.parseFieldDefinition,
      rt.BRACE_R
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  parseFieldDefinition() {
    const n = this._lexer.token, r = this.parseDescription(), a = this.parseName(), o = this.parseArgumentDefs();
    this.expectToken(rt.COLON);
    const l = this.parseTypeReference(), d = this.parseConstDirectives();
    return this.node(n, {
      kind: Kt.FIELD_DEFINITION,
      description: r,
      name: a,
      arguments: o,
      type: l,
      directives: d
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  parseArgumentDefs() {
    return this.optionalMany(
      rt.PAREN_L,
      this.parseInputValueDef,
      rt.PAREN_R
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  parseInputValueDef() {
    const n = this._lexer.token, r = this.parseDescription(), a = this.parseName();
    this.expectToken(rt.COLON);
    const o = this.parseTypeReference();
    let l;
    this.expectOptionalToken(rt.EQUALS) && (l = this.parseConstValueLiteral());
    const d = this.parseConstDirectives();
    return this.node(n, {
      kind: Kt.INPUT_VALUE_DEFINITION,
      description: r,
      name: a,
      type: o,
      defaultValue: l,
      directives: d
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  parseInterfaceTypeDefinition() {
    const n = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("interface");
    const a = this.parseName(), o = this.parseImplementsInterfaces(), l = this.parseConstDirectives(), d = this.parseFieldsDefinition();
    return this.node(n, {
      kind: Kt.INTERFACE_TYPE_DEFINITION,
      description: r,
      name: a,
      interfaces: o,
      directives: l,
      fields: d
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  parseUnionTypeDefinition() {
    const n = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("union");
    const a = this.parseName(), o = this.parseConstDirectives(), l = this.parseUnionMemberTypes();
    return this.node(n, {
      kind: Kt.UNION_TYPE_DEFINITION,
      description: r,
      name: a,
      directives: o,
      types: l
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  parseUnionMemberTypes() {
    return this.expectOptionalToken(rt.EQUALS) ? this.delimitedMany(rt.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  parseEnumTypeDefinition() {
    const n = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("enum");
    const a = this.parseName(), o = this.parseConstDirectives(), l = this.parseEnumValuesDefinition();
    return this.node(n, {
      kind: Kt.ENUM_TYPE_DEFINITION,
      description: r,
      name: a,
      directives: o,
      values: l
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */
  parseEnumValuesDefinition() {
    return this.optionalMany(
      rt.BRACE_L,
      this.parseEnumValueDefinition,
      rt.BRACE_R
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */
  parseEnumValueDefinition() {
    const n = this._lexer.token, r = this.parseDescription(), a = this.parseEnumValueName(), o = this.parseConstDirectives();
    return this.node(n, {
      kind: Kt.ENUM_VALUE_DEFINITION,
      description: r,
      name: a,
      directives: o
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseEnumValueName() {
    if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
      throw ai(
        this._lexer.source,
        this._lexer.token.start,
        `${Xc(
          this._lexer.token
        )} is reserved and cannot be used for an enum value.`
      );
    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  parseInputObjectTypeDefinition() {
    const n = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("input");
    const a = this.parseName(), o = this.parseConstDirectives(), l = this.parseInputFieldsDefinition();
    return this.node(n, {
      kind: Kt.INPUT_OBJECT_TYPE_DEFINITION,
      description: r,
      name: a,
      directives: o,
      fields: l
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */
  parseInputFieldsDefinition() {
    return this.optionalMany(
      rt.BRACE_L,
      this.parseInputValueDef,
      rt.BRACE_R
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  parseTypeSystemExtension() {
    const n = this._lexer.lookahead();
    if (n.kind === rt.NAME)
      switch (n.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    throw this.unexpected(n);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */
  parseSchemaExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    const r = this.parseConstDirectives(), a = this.optionalMany(
      rt.BRACE_L,
      this.parseOperationTypeDefinition,
      rt.BRACE_R
    );
    if (r.length === 0 && a.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: Kt.SCHEMA_EXTENSION,
      directives: r,
      operationTypes: a
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  parseScalarTypeExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    const r = this.parseName(), a = this.parseConstDirectives();
    if (a.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: Kt.SCALAR_TYPE_EXTENSION,
      name: r,
      directives: a
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  parseObjectTypeExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    const r = this.parseName(), a = this.parseImplementsInterfaces(), o = this.parseConstDirectives(), l = this.parseFieldsDefinition();
    if (a.length === 0 && o.length === 0 && l.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: Kt.OBJECT_TYPE_EXTENSION,
      name: r,
      interfaces: a,
      directives: o,
      fields: l
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  parseInterfaceTypeExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    const r = this.parseName(), a = this.parseImplementsInterfaces(), o = this.parseConstDirectives(), l = this.parseFieldsDefinition();
    if (a.length === 0 && o.length === 0 && l.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: Kt.INTERFACE_TYPE_EXTENSION,
      name: r,
      interfaces: a,
      directives: o,
      fields: l
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  parseUnionTypeExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    const r = this.parseName(), a = this.parseConstDirectives(), o = this.parseUnionMemberTypes();
    if (a.length === 0 && o.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: Kt.UNION_TYPE_EXTENSION,
      name: r,
      directives: a,
      types: o
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  parseEnumTypeExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    const r = this.parseName(), a = this.parseConstDirectives(), o = this.parseEnumValuesDefinition();
    if (a.length === 0 && o.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: Kt.ENUM_TYPE_EXTENSION,
      name: r,
      directives: a,
      values: o
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  parseInputObjectTypeExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    const r = this.parseName(), a = this.parseConstDirectives(), o = this.parseInputFieldsDefinition();
    if (a.length === 0 && o.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: Kt.INPUT_OBJECT_TYPE_EXTENSION,
      name: r,
      directives: a,
      fields: o
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */
  parseDirectiveDefinition() {
    const n = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(rt.AT);
    const a = this.parseName(), o = this.parseArgumentDefs(), l = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    const d = this.parseDirectiveLocations();
    return this.node(n, {
      kind: Kt.DIRECTIVE_DEFINITION,
      description: r,
      name: a,
      arguments: o,
      repeatable: l,
      locations: d
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  parseDirectiveLocations() {
    return this.delimitedMany(rt.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  parseDirectiveLocation() {
    const n = this._lexer.token, r = this.parseName();
    if (Object.prototype.hasOwnProperty.call(Qd, r.value))
      return r;
    throw this.unexpected(n);
  }
  // Core parsing utility functions
  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */
  node(n, r) {
    return this._options.noLocation !== !0 && (r.loc = new bA(
      n,
      this._lexer.lastToken,
      this._lexer.source
    )), r;
  }
  /**
   * Determines if the next token is of a given kind
   */
  peek(n) {
    return this._lexer.token.kind === n;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectToken(n) {
    const r = this._lexer.token;
    if (r.kind === n)
      return this.advanceLexer(), r;
    throw ai(
      this._lexer.source,
      r.start,
      `Expected ${Zb(n)}, found ${Xc(r)}.`
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalToken(n) {
    return this._lexer.token.kind === n ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectKeyword(n) {
    const r = this._lexer.token;
    if (r.kind === rt.NAME && r.value === n)
      this.advanceLexer();
    else
      throw ai(
        this._lexer.source,
        r.start,
        `Expected "${n}", found ${Xc(r)}.`
      );
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalKeyword(n) {
    const r = this._lexer.token;
    return r.kind === rt.NAME && r.value === n ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  unexpected(n) {
    const r = n ?? this._lexer.token;
    return ai(
      this._lexer.source,
      r.start,
      `Unexpected ${Xc(r)}.`
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  any(n, r, a) {
    this.expectToken(n);
    const o = [];
    for (; !this.expectOptionalToken(a); )
      o.push(r.call(this));
    return o;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  optionalMany(n, r, a) {
    if (this.expectOptionalToken(n)) {
      const o = [];
      do
        o.push(r.call(this));
      while (!this.expectOptionalToken(a));
      return o;
    }
    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  many(n, r, a) {
    this.expectToken(n);
    const o = [];
    do
      o.push(r.call(this));
    while (!this.expectOptionalToken(a));
    return o;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  delimitedMany(n, r) {
    this.expectOptionalToken(n);
    const a = [];
    do
      a.push(r.call(this));
    while (this.expectOptionalToken(n));
    return a;
  }
  advanceLexer() {
    const { maxTokens: n } = this._options, r = this._lexer.advance();
    if (n !== void 0 && r.kind !== rt.EOF && (++this._tokenCounter, this._tokenCounter > n))
      throw ai(
        this._lexer.source,
        r.start,
        `Document contains more that ${n} tokens. Parsing aborted.`
      );
  }
}
function Xc(e) {
  const n = e.value;
  return Zb(e.kind) + (n != null ? ` "${n}"` : "");
}
function Zb(e) {
  return AA(e) ? `"${e}"` : e;
}
function VA(e) {
  return `"${e.replace(XA, GA)}"`;
}
const XA = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function GA(e) {
  return KA[e.charCodeAt(0)];
}
const KA = [
  "\\u0000",
  "\\u0001",
  "\\u0002",
  "\\u0003",
  "\\u0004",
  "\\u0005",
  "\\u0006",
  "\\u0007",
  "\\b",
  "\\t",
  "\\n",
  "\\u000B",
  "\\f",
  "\\r",
  "\\u000E",
  "\\u000F",
  "\\u0010",
  "\\u0011",
  "\\u0012",
  "\\u0013",
  "\\u0014",
  "\\u0015",
  "\\u0016",
  "\\u0017",
  "\\u0018",
  "\\u0019",
  "\\u001A",
  "\\u001B",
  "\\u001C",
  "\\u001D",
  "\\u001E",
  "\\u001F",
  "",
  "",
  '\\"',
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 2F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 3F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 4F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\\\",
  "",
  "",
  "",
  // 5F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 6F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\u007F",
  "\\u0080",
  "\\u0081",
  "\\u0082",
  "\\u0083",
  "\\u0084",
  "\\u0085",
  "\\u0086",
  "\\u0087",
  "\\u0088",
  "\\u0089",
  "\\u008A",
  "\\u008B",
  "\\u008C",
  "\\u008D",
  "\\u008E",
  "\\u008F",
  "\\u0090",
  "\\u0091",
  "\\u0092",
  "\\u0093",
  "\\u0094",
  "\\u0095",
  "\\u0096",
  "\\u0097",
  "\\u0098",
  "\\u0099",
  "\\u009A",
  "\\u009B",
  "\\u009C",
  "\\u009D",
  "\\u009E",
  "\\u009F"
], YA = Object.freeze({});
function ZA(e, n, r = Wb) {
  const a = /* @__PURE__ */ new Map();
  for (const S of Object.values(Kt))
    a.set(S, QA(n, S));
  let o, l = Array.isArray(e), d = [e], c = -1, f = [], s = e, h, g;
  const t = [], i = [];
  do {
    c++;
    const S = c === d.length, y = S && f.length !== 0;
    if (S) {
      if (h = i.length === 0 ? void 0 : t[t.length - 1], s = g, g = i.pop(), y)
        if (l) {
          s = s.slice();
          let b = 0;
          for (const [u, I] of f) {
            const O = u - b;
            I === null ? (s.splice(O, 1), b++) : s[O] = I;
          }
        } else {
          s = Object.defineProperties(
            {},
            Object.getOwnPropertyDescriptors(s)
          );
          for (const [b, u] of f)
            s[b] = u;
        }
      c = o.index, d = o.keys, f = o.edits, l = o.inArray, o = o.prev;
    } else if (g) {
      if (h = l ? c : d[c], s = g[h], s == null)
        continue;
      t.push(h);
    }
    let x;
    if (!Array.isArray(s)) {
      var m, v;
      Mp(s) || yl(!1, `Invalid AST Node: ${Uf(s)}.`);
      const b = S ? (m = a.get(s.kind)) === null || m === void 0 ? void 0 : m.leave : (v = a.get(s.kind)) === null || v === void 0 ? void 0 : v.enter;
      if (x = b == null ? void 0 : b.call(n, s, h, g, t, i), x === YA)
        break;
      if (x === !1) {
        if (!S) {
          t.pop();
          continue;
        }
      } else if (x !== void 0 && (f.push([h, x]), !S))
        if (Mp(x))
          s = x;
        else {
          t.pop();
          continue;
        }
    }
    if (x === void 0 && y && f.push([h, s]), S)
      t.pop();
    else {
      var E;
      o = {
        inArray: l,
        index: c,
        keys: d,
        edits: f,
        prev: o
      }, l = Array.isArray(s), d = l ? s : (E = r[s.kind]) !== null && E !== void 0 ? E : [], c = -1, f = [], g && i.push(g), g = s;
    }
  } while (o !== void 0);
  return f.length !== 0 ? f[f.length - 1][1] : e;
}
function QA(e, n) {
  const r = e[n];
  return typeof r == "object" ? r : typeof r == "function" ? {
    enter: r,
    leave: void 0
  } : {
    enter: e.enter,
    leave: e.leave
  };
}
function JA(e) {
  return ZA(e, tk);
}
const ek = 80, tk = {
  Name: {
    leave: (e) => e.value
  },
  Variable: {
    leave: (e) => "$" + e.name
  },
  // Document
  Document: {
    leave: (e) => Mt(e.definitions, `

`)
  },
  OperationDefinition: {
    leave(e) {
      const n = ln("(", Mt(e.variableDefinitions, ", "), ")"), r = Mt(
        [
          e.operation,
          Mt([e.name, n]),
          Mt(e.directives, " ")
        ],
        " "
      );
      return (r === "query" ? "" : r + " ") + e.selectionSet;
    }
  },
  VariableDefinition: {
    leave: ({ variable: e, type: n, defaultValue: r, directives: a }) => e + ": " + n + ln(" = ", r) + ln(" ", Mt(a, " "))
  },
  SelectionSet: {
    leave: ({ selections: e }) => hr(e)
  },
  Field: {
    leave({ alias: e, name: n, arguments: r, directives: a, selectionSet: o }) {
      const l = ln("", e, ": ") + n;
      let d = l + ln("(", Mt(r, ", "), ")");
      return d.length > ek && (d = l + ln(`(
`, vl(Mt(r, `
`)), `
)`)), Mt([d, Mt(a, " "), o], " ");
    }
  },
  Argument: {
    leave: ({ name: e, value: n }) => e + ": " + n
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name: e, directives: n }) => "..." + e + ln(" ", Mt(n, " "))
  },
  InlineFragment: {
    leave: ({ typeCondition: e, directives: n, selectionSet: r }) => Mt(
      [
        "...",
        ln("on ", e),
        Mt(n, " "),
        r
      ],
      " "
    )
  },
  FragmentDefinition: {
    leave: ({ name: e, typeCondition: n, variableDefinitions: r, directives: a, selectionSet: o }) => (
      // or removed in the future.
      `fragment ${e}${ln("(", Mt(r, ", "), ")")} on ${n} ${ln("", Mt(a, " "), " ")}` + o
    )
  },
  // Value
  IntValue: {
    leave: ({ value: e }) => e
  },
  FloatValue: {
    leave: ({ value: e }) => e
  },
  StringValue: {
    leave: ({ value: e, block: n }) => n ? _A(e) : VA(e)
  },
  BooleanValue: {
    leave: ({ value: e }) => e ? "true" : "false"
  },
  NullValue: {
    leave: () => "null"
  },
  EnumValue: {
    leave: ({ value: e }) => e
  },
  ListValue: {
    leave: ({ values: e }) => "[" + Mt(e, ", ") + "]"
  },
  ObjectValue: {
    leave: ({ fields: e }) => "{" + Mt(e, ", ") + "}"
  },
  ObjectField: {
    leave: ({ name: e, value: n }) => e + ": " + n
  },
  // Directive
  Directive: {
    leave: ({ name: e, arguments: n }) => "@" + e + ln("(", Mt(n, ", "), ")")
  },
  // Type
  NamedType: {
    leave: ({ name: e }) => e
  },
  ListType: {
    leave: ({ type: e }) => "[" + e + "]"
  },
  NonNullType: {
    leave: ({ type: e }) => e + "!"
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description: e, directives: n, operationTypes: r }) => ln("", e, `
`) + Mt(["schema", Mt(n, " "), hr(r)], " ")
  },
  OperationTypeDefinition: {
    leave: ({ operation: e, type: n }) => e + ": " + n
  },
  ScalarTypeDefinition: {
    leave: ({ description: e, name: n, directives: r }) => ln("", e, `
`) + Mt(["scalar", n, Mt(r, " ")], " ")
  },
  ObjectTypeDefinition: {
    leave: ({ description: e, name: n, interfaces: r, directives: a, fields: o }) => ln("", e, `
`) + Mt(
      [
        "type",
        n,
        ln("implements ", Mt(r, " & ")),
        Mt(a, " "),
        hr(o)
      ],
      " "
    )
  },
  FieldDefinition: {
    leave: ({ description: e, name: n, arguments: r, type: a, directives: o }) => ln("", e, `
`) + n + (Np(r) ? ln(`(
`, vl(Mt(r, `
`)), `
)`) : ln("(", Mt(r, ", "), ")")) + ": " + a + ln(" ", Mt(o, " "))
  },
  InputValueDefinition: {
    leave: ({ description: e, name: n, type: r, defaultValue: a, directives: o }) => ln("", e, `
`) + Mt(
      [n + ": " + r, ln("= ", a), Mt(o, " ")],
      " "
    )
  },
  InterfaceTypeDefinition: {
    leave: ({ description: e, name: n, interfaces: r, directives: a, fields: o }) => ln("", e, `
`) + Mt(
      [
        "interface",
        n,
        ln("implements ", Mt(r, " & ")),
        Mt(a, " "),
        hr(o)
      ],
      " "
    )
  },
  UnionTypeDefinition: {
    leave: ({ description: e, name: n, directives: r, types: a }) => ln("", e, `
`) + Mt(
      ["union", n, Mt(r, " "), ln("= ", Mt(a, " | "))],
      " "
    )
  },
  EnumTypeDefinition: {
    leave: ({ description: e, name: n, directives: r, values: a }) => ln("", e, `
`) + Mt(["enum", n, Mt(r, " "), hr(a)], " ")
  },
  EnumValueDefinition: {
    leave: ({ description: e, name: n, directives: r }) => ln("", e, `
`) + Mt([n, Mt(r, " ")], " ")
  },
  InputObjectTypeDefinition: {
    leave: ({ description: e, name: n, directives: r, fields: a }) => ln("", e, `
`) + Mt(["input", n, Mt(r, " "), hr(a)], " ")
  },
  DirectiveDefinition: {
    leave: ({ description: e, name: n, arguments: r, repeatable: a, locations: o }) => ln("", e, `
`) + "directive @" + n + (Np(r) ? ln(`(
`, vl(Mt(r, `
`)), `
)`) : ln("(", Mt(r, ", "), ")")) + (a ? " repeatable" : "") + " on " + Mt(o, " | ")
  },
  SchemaExtension: {
    leave: ({ directives: e, operationTypes: n }) => Mt(
      ["extend schema", Mt(e, " "), hr(n)],
      " "
    )
  },
  ScalarTypeExtension: {
    leave: ({ name: e, directives: n }) => Mt(["extend scalar", e, Mt(n, " ")], " ")
  },
  ObjectTypeExtension: {
    leave: ({ name: e, interfaces: n, directives: r, fields: a }) => Mt(
      [
        "extend type",
        e,
        ln("implements ", Mt(n, " & ")),
        Mt(r, " "),
        hr(a)
      ],
      " "
    )
  },
  InterfaceTypeExtension: {
    leave: ({ name: e, interfaces: n, directives: r, fields: a }) => Mt(
      [
        "extend interface",
        e,
        ln("implements ", Mt(n, " & ")),
        Mt(r, " "),
        hr(a)
      ],
      " "
    )
  },
  UnionTypeExtension: {
    leave: ({ name: e, directives: n, types: r }) => Mt(
      [
        "extend union",
        e,
        Mt(n, " "),
        ln("= ", Mt(r, " | "))
      ],
      " "
    )
  },
  EnumTypeExtension: {
    leave: ({ name: e, directives: n, values: r }) => Mt(["extend enum", e, Mt(n, " "), hr(r)], " ")
  },
  InputObjectTypeExtension: {
    leave: ({ name: e, directives: n, fields: r }) => Mt(["extend input", e, Mt(n, " "), hr(r)], " ")
  }
};
function Mt(e, n = "") {
  var r;
  return (r = e == null ? void 0 : e.filter((a) => a).join(n)) !== null && r !== void 0 ? r : "";
}
function hr(e) {
  return ln(`{
`, vl(Mt(e, `
`)), `
}`);
}
function ln(e, n, r = "") {
  return n != null && n !== "" ? e + n + r : "";
}
function vl(e) {
  return ln("  ", e.replace(/\n/g, `
  `));
}
function Np(e) {
  var n;
  return (n = e == null ? void 0 : e.some((r) => r.includes(`
`))) !== null && n !== void 0 ? n : !1;
}
const Lp = (e) => {
  var a, o;
  let n;
  const r = e.definitions.filter((l) => l.kind === "OperationDefinition");
  return r.length === 1 && (n = (o = (a = r[0]) == null ? void 0 : a.name) == null ? void 0 : o.value), n;
}, Nu = (e) => {
  if (typeof e == "string") {
    let r;
    try {
      const a = WA(e);
      r = Lp(a);
    } catch {
    }
    return { query: e, operationName: r };
  }
  const n = Lp(e);
  return { query: JA(e), operationName: n };
};
class $o extends Error {
  constructor(n, r) {
    const a = `${$o.extractMessage(n)}: ${JSON.stringify({
      response: n,
      request: r
    })}`;
    super(a), Object.setPrototypeOf(this, $o.prototype), this.response = n, this.request = r, typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, $o);
  }
  static extractMessage(n) {
    var r, a;
    return ((a = (r = n.errors) == null ? void 0 : r[0]) == null ? void 0 : a.message) ?? `GraphQL Error (Code: ${n.status})`;
  }
}
var eh = { exports: {} };
(function(e, n) {
  var r = typeof self < "u" ? self : Mi, a = function() {
    function l() {
      this.fetch = !1, this.DOMException = r.DOMException;
    }
    return l.prototype = r, new l();
  }();
  (function(l) {
    (function(d) {
      var c = {
        searchParams: "URLSearchParams" in l,
        iterable: "Symbol" in l && "iterator" in Symbol,
        blob: "FileReader" in l && "Blob" in l && function() {
          try {
            return new Blob(), !0;
          } catch {
            return !1;
          }
        }(),
        formData: "FormData" in l,
        arrayBuffer: "ArrayBuffer" in l
      };
      function f(_) {
        return _ && DataView.prototype.isPrototypeOf(_);
      }
      if (c.arrayBuffer)
        var s = [
          "[object Int8Array]",
          "[object Uint8Array]",
          "[object Uint8ClampedArray]",
          "[object Int16Array]",
          "[object Uint16Array]",
          "[object Int32Array]",
          "[object Uint32Array]",
          "[object Float32Array]",
          "[object Float64Array]"
        ], h = ArrayBuffer.isView || function(_) {
          return _ && s.indexOf(Object.prototype.toString.call(_)) > -1;
        };
      function g(_) {
        if (typeof _ != "string" && (_ = String(_)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(_))
          throw new TypeError("Invalid character in header field name");
        return _.toLowerCase();
      }
      function t(_) {
        return typeof _ != "string" && (_ = String(_)), _;
      }
      function i(_) {
        var A = {
          next: function() {
            var k = _.shift();
            return { done: k === void 0, value: k };
          }
        };
        return c.iterable && (A[Symbol.iterator] = function() {
          return A;
        }), A;
      }
      function m(_) {
        this.map = {}, _ instanceof m ? _.forEach(function(A, k) {
          this.append(k, A);
        }, this) : Array.isArray(_) ? _.forEach(function(A) {
          this.append(A[0], A[1]);
        }, this) : _ && Object.getOwnPropertyNames(_).forEach(function(A) {
          this.append(A, _[A]);
        }, this);
      }
      m.prototype.append = function(_, A) {
        _ = g(_), A = t(A);
        var k = this.map[_];
        this.map[_] = k ? k + ", " + A : A;
      }, m.prototype.delete = function(_) {
        delete this.map[g(_)];
      }, m.prototype.get = function(_) {
        return _ = g(_), this.has(_) ? this.map[_] : null;
      }, m.prototype.has = function(_) {
        return this.map.hasOwnProperty(g(_));
      }, m.prototype.set = function(_, A) {
        this.map[g(_)] = t(A);
      }, m.prototype.forEach = function(_, A) {
        for (var k in this.map)
          this.map.hasOwnProperty(k) && _.call(A, this.map[k], k, this);
      }, m.prototype.keys = function() {
        var _ = [];
        return this.forEach(function(A, k) {
          _.push(k);
        }), i(_);
      }, m.prototype.values = function() {
        var _ = [];
        return this.forEach(function(A) {
          _.push(A);
        }), i(_);
      }, m.prototype.entries = function() {
        var _ = [];
        return this.forEach(function(A, k) {
          _.push([k, A]);
        }), i(_);
      }, c.iterable && (m.prototype[Symbol.iterator] = m.prototype.entries);
      function v(_) {
        if (_.bodyUsed)
          return Promise.reject(new TypeError("Already read"));
        _.bodyUsed = !0;
      }
      function E(_) {
        return new Promise(function(A, k) {
          _.onload = function() {
            A(_.result);
          }, _.onerror = function() {
            k(_.error);
          };
        });
      }
      function S(_) {
        var A = new FileReader(), k = E(A);
        return A.readAsArrayBuffer(_), k;
      }
      function y(_) {
        var A = new FileReader(), k = E(A);
        return A.readAsText(_), k;
      }
      function x(_) {
        for (var A = new Uint8Array(_), k = new Array(A.length), z = 0; z < A.length; z++)
          k[z] = String.fromCharCode(A[z]);
        return k.join("");
      }
      function b(_) {
        if (_.slice)
          return _.slice(0);
        var A = new Uint8Array(_.byteLength);
        return A.set(new Uint8Array(_)), A.buffer;
      }
      function u() {
        return this.bodyUsed = !1, this._initBody = function(_) {
          this._bodyInit = _, _ ? typeof _ == "string" ? this._bodyText = _ : c.blob && Blob.prototype.isPrototypeOf(_) ? this._bodyBlob = _ : c.formData && FormData.prototype.isPrototypeOf(_) ? this._bodyFormData = _ : c.searchParams && URLSearchParams.prototype.isPrototypeOf(_) ? this._bodyText = _.toString() : c.arrayBuffer && c.blob && f(_) ? (this._bodyArrayBuffer = b(_.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : c.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(_) || h(_)) ? this._bodyArrayBuffer = b(_) : this._bodyText = _ = Object.prototype.toString.call(_) : this._bodyText = "", this.headers.get("content-type") || (typeof _ == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : c.searchParams && URLSearchParams.prototype.isPrototypeOf(_) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
        }, c.blob && (this.blob = function() {
          var _ = v(this);
          if (_)
            return _;
          if (this._bodyBlob)
            return Promise.resolve(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(new Blob([this._bodyArrayBuffer]));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as blob");
          return Promise.resolve(new Blob([this._bodyText]));
        }, this.arrayBuffer = function() {
          return this._bodyArrayBuffer ? v(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(S);
        }), this.text = function() {
          var _ = v(this);
          if (_)
            return _;
          if (this._bodyBlob)
            return y(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(x(this._bodyArrayBuffer));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as text");
          return Promise.resolve(this._bodyText);
        }, c.formData && (this.formData = function() {
          return this.text().then($);
        }), this.json = function() {
          return this.text().then(JSON.parse);
        }, this;
      }
      var I = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
      function O(_) {
        var A = _.toUpperCase();
        return I.indexOf(A) > -1 ? A : _;
      }
      function D(_, A) {
        A = A || {};
        var k = A.body;
        if (_ instanceof D) {
          if (_.bodyUsed)
            throw new TypeError("Already read");
          this.url = _.url, this.credentials = _.credentials, A.headers || (this.headers = new m(_.headers)), this.method = _.method, this.mode = _.mode, this.signal = _.signal, !k && _._bodyInit != null && (k = _._bodyInit, _.bodyUsed = !0);
        } else
          this.url = String(_);
        if (this.credentials = A.credentials || this.credentials || "same-origin", (A.headers || !this.headers) && (this.headers = new m(A.headers)), this.method = O(A.method || this.method || "GET"), this.mode = A.mode || this.mode || null, this.signal = A.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && k)
          throw new TypeError("Body not allowed for GET or HEAD requests");
        this._initBody(k);
      }
      D.prototype.clone = function() {
        return new D(this, { body: this._bodyInit });
      };
      function $(_) {
        var A = new FormData();
        return _.trim().split("&").forEach(function(k) {
          if (k) {
            var z = k.split("="), T = z.shift().replace(/\+/g, " "), w = z.join("=").replace(/\+/g, " ");
            A.append(decodeURIComponent(T), decodeURIComponent(w));
          }
        }), A;
      }
      function K(_) {
        var A = new m(), k = _.replace(/\r?\n[\t ]+/g, " ");
        return k.split(/\r?\n/).forEach(function(z) {
          var T = z.split(":"), w = T.shift().trim();
          if (w) {
            var F = T.join(":").trim();
            A.append(w, F);
          }
        }), A;
      }
      u.call(D.prototype);
      function H(_, A) {
        A || (A = {}), this.type = "default", this.status = A.status === void 0 ? 200 : A.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in A ? A.statusText : "OK", this.headers = new m(A.headers), this.url = A.url || "", this._initBody(_);
      }
      u.call(H.prototype), H.prototype.clone = function() {
        return new H(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new m(this.headers),
          url: this.url
        });
      }, H.error = function() {
        var _ = new H(null, { status: 0, statusText: "" });
        return _.type = "error", _;
      };
      var B = [301, 302, 303, 307, 308];
      H.redirect = function(_, A) {
        if (B.indexOf(A) === -1)
          throw new RangeError("Invalid status code");
        return new H(null, { status: A, headers: { location: _ } });
      }, d.DOMException = l.DOMException;
      try {
        new d.DOMException();
      } catch {
        d.DOMException = function(A, k) {
          this.message = A, this.name = k;
          var z = Error(A);
          this.stack = z.stack;
        }, d.DOMException.prototype = Object.create(Error.prototype), d.DOMException.prototype.constructor = d.DOMException;
      }
      function R(_, A) {
        return new Promise(function(k, z) {
          var T = new D(_, A);
          if (T.signal && T.signal.aborted)
            return z(new d.DOMException("Aborted", "AbortError"));
          var w = new XMLHttpRequest();
          function F() {
            w.abort();
          }
          w.onload = function() {
            var j = {
              status: w.status,
              statusText: w.statusText,
              headers: K(w.getAllResponseHeaders() || "")
            };
            j.url = "responseURL" in w ? w.responseURL : j.headers.get("X-Request-URL");
            var P = "response" in w ? w.response : w.responseText;
            k(new H(P, j));
          }, w.onerror = function() {
            z(new TypeError("Network request failed"));
          }, w.ontimeout = function() {
            z(new TypeError("Network request failed"));
          }, w.onabort = function() {
            z(new d.DOMException("Aborted", "AbortError"));
          }, w.open(T.method, T.url, !0), T.credentials === "include" ? w.withCredentials = !0 : T.credentials === "omit" && (w.withCredentials = !1), "responseType" in w && c.blob && (w.responseType = "blob"), T.headers.forEach(function(j, P) {
            w.setRequestHeader(P, j);
          }), T.signal && (T.signal.addEventListener("abort", F), w.onreadystatechange = function() {
            w.readyState === 4 && T.signal.removeEventListener("abort", F);
          }), w.send(typeof T._bodyInit > "u" ? null : T._bodyInit);
        });
      }
      return R.polyfill = !0, l.fetch || (l.fetch = R, l.Headers = m, l.Request = D, l.Response = H), d.Headers = m, d.Request = D, d.Response = H, d.fetch = R, Object.defineProperty(d, "__esModule", { value: !0 }), d;
    })({});
  })(a), a.fetch.ponyfill = !0, delete a.fetch.polyfill;
  var o = a;
  n = o.fetch, n.default = o.fetch, n.fetch = o.fetch, n.Headers = o.Headers, n.Request = o.Request, n.Response = o.Response, e.exports = n;
})(eh, eh.exports);
var Hl = eh.exports;
const wl = /* @__PURE__ */ ys(Hl), nk = /* @__PURE__ */ I7({
  __proto__: null,
  default: wl
}, [Hl]), da = (e) => {
  let n = {};
  return e && (typeof Headers < "u" && e instanceof Headers || nk && Hl.Headers && e instanceof Hl.Headers ? n = cA(e) : Array.isArray(e) ? e.forEach(([r, a]) => {
    r && a !== void 0 && (n[r] = a);
  }) : n = e), n;
}, Bp = (e) => e.replace(/([\s,]|#[^\n\r]+)+/g, " ").trim(), ik = (e) => {
  if (!Array.isArray(e.query)) {
    const a = e, o = [`query=${encodeURIComponent(Bp(a.query))}`];
    return e.variables && o.push(`variables=${encodeURIComponent(a.jsonSerializer.stringify(a.variables))}`), a.operationName && o.push(`operationName=${encodeURIComponent(a.operationName)}`), o.join("&");
  }
  if (typeof e.variables < "u" && !Array.isArray(e.variables))
    throw new Error("Cannot create query with given variable type, array expected");
  const n = e, r = e.query.reduce((a, o, l) => (a.push({
    query: Bp(o),
    variables: n.variables ? n.jsonSerializer.stringify(n.variables[l]) : void 0
  }), a), []);
  return `query=${encodeURIComponent(n.jsonSerializer.stringify(r))}`;
}, rk = (e) => async (n) => {
  const { url: r, query: a, variables: o, operationName: l, fetch: d, fetchOptions: c, middleware: f } = n, s = { ...n.headers };
  let h = "", g;
  e === "POST" ? (g = ak(a, o, l, c.jsonSerializer), typeof g == "string" && (s["Content-Type"] = "application/json")) : h = ik({
    query: a,
    variables: o,
    operationName: l,
    jsonSerializer: c.jsonSerializer ?? Bf
  });
  const t = {
    method: e,
    headers: s,
    body: g,
    ...c
  };
  let i = r, m = t;
  if (f) {
    const v = await Promise.resolve(f({ ...t, url: r, operationName: l, variables: o })), { url: E, ...S } = v;
    i = E, m = S;
  }
  return h && (i = `${i}?${h}`), await d(i, m);
};
class Qb {
  constructor(n, r = {}) {
    this.url = n, this.requestConfig = r, this.rawRequest = async (...a) => {
      const [o, l, d] = a, c = uA(o, l, d), { headers: f, fetch: s = wl, method: h = "POST", requestMiddleware: g, responseMiddleware: t, ...i } = this.requestConfig, { url: m } = this;
      c.signal !== void 0 && (i.signal = c.signal);
      const { operationName: v } = Nu(c.query);
      return Lu({
        url: m,
        query: c.query,
        variables: c.variables,
        headers: {
          ...da(Bu(f)),
          ...da(c.requestHeaders)
        },
        operationName: v,
        fetch: s,
        method: h,
        fetchOptions: i,
        middleware: g
      }).then((E) => (t && t(E), E)).catch((E) => {
        throw t && t(E), E;
      });
    };
  }
  async request(n, ...r) {
    const [a, o] = r, l = lA(n, a, o), { headers: d, fetch: c = wl, method: f = "POST", requestMiddleware: s, responseMiddleware: h, ...g } = this.requestConfig, { url: t } = this;
    l.signal !== void 0 && (g.signal = l.signal);
    const { query: i, operationName: m } = Nu(l.document);
    return Lu({
      url: t,
      query: i,
      variables: l.variables,
      headers: {
        ...da(Bu(d)),
        ...da(l.requestHeaders)
      },
      operationName: m,
      fetch: c,
      method: f,
      fetchOptions: g,
      middleware: s
    }).then((v) => (h && h(v), v.data)).catch((v) => {
      throw h && h(v), v;
    });
  }
  // prettier-ignore
  batchRequests(n, r) {
    const a = dA(n, r), { headers: o, ...l } = this.requestConfig;
    a.signal !== void 0 && (l.signal = a.signal);
    const d = a.documents.map(({ document: f }) => Nu(f).query), c = a.documents.map(({ variables: f }) => f);
    return Lu({
      url: this.url,
      query: d,
      // @ts-expect-error TODO reconcile batch variables into system.
      variables: c,
      headers: {
        ...da(Bu(o)),
        ...da(a.requestHeaders)
      },
      operationName: void 0,
      fetch: this.requestConfig.fetch ?? wl,
      method: this.requestConfig.method || "POST",
      fetchOptions: l,
      middleware: this.requestConfig.requestMiddleware
    }).then((f) => (this.requestConfig.responseMiddleware && this.requestConfig.responseMiddleware(f), f.data)).catch((f) => {
      throw this.requestConfig.responseMiddleware && this.requestConfig.responseMiddleware(f), f;
    });
  }
  setHeaders(n) {
    return this.requestConfig.headers = n, this;
  }
  /**
   * Attach a header to the client. All subsequent requests will have this header.
   */
  setHeader(n, r) {
    const { headers: a } = this.requestConfig;
    return a ? a[n] = r : this.requestConfig.headers = { [n]: r }, this;
  }
  /**
   * Change the client endpoint. All subsequent requests will send to this endpoint.
   */
  setEndpoint(n) {
    return this.url = n, this;
  }
}
const Lu = async (e) => {
  const { query: n, variables: r, fetchOptions: a } = e, o = rk(oA(e.method ?? "post")), l = Array.isArray(e.query), d = await o(e), c = await ok(d, a.jsonSerializer ?? Bf), f = Array.isArray(c) ? !c.some(({ data: h }) => !h) : !!c.data, s = Array.isArray(c) || !c.errors || Array.isArray(c.errors) && !c.errors.length || a.errorPolicy === "all" || a.errorPolicy === "ignore";
  if (d.ok && s && f) {
    const { errors: h, ...g } = (Array.isArray(c), c), t = a.errorPolicy === "ignore" ? g : c;
    return {
      ...l ? { data: t } : t,
      headers: d.headers,
      status: d.status
    };
  } else {
    const h = typeof c == "string" ? {
      error: c
    } : c;
    throw new $o(
      // @ts-expect-error TODO
      { ...h, status: d.status, headers: d.headers },
      { query: n, variables: r }
    );
  }
};
async function sk(e, n, ...r) {
  const a = hA(e, n, ...r);
  return new Qb(a.url).request({
    ...a
  });
}
const ak = (e, n, r, a) => {
  const o = a ?? Bf;
  if (!Array.isArray(e))
    return o.stringify({ query: e, variables: n, operationName: r });
  if (typeof n < "u" && !Array.isArray(n))
    throw new Error("Cannot create request body with given variable type, array expected");
  const l = e.reduce((d, c, f) => (d.push({ query: c, variables: n ? n[f] : void 0 }), d), []);
  return o.stringify(l);
}, ok = async (e, n) => {
  let r;
  return e.headers.forEach((a, o) => {
    o.toLowerCase() === "content-type" && (r = a);
  }), r && (r.toLowerCase().startsWith("application/json") || r.toLowerCase().startsWith("application/graphql+json") || r.toLowerCase().startsWith("application/graphql-response+json")) ? n.parse(await e.text()) : e.text();
}, Bu = (e) => typeof e == "function" ? e() : e, ck = async (e) => {
  const n = await M0(), r = n != null && n.auth_token ? {
    Authorization: n.auth_token
  } : void 0;
  return sk({
    // url: `${config.api.url}/graphql`, // TODO
    url: "/graphql",
    document: cx,
    variables: {
      statuses: e.statuses,
      page: Number(e.page),
      perPage: Number(e.perPage)
    },
    requestHeaders: r
  });
};
function qB() {
  return Js().useMutationGraphQL(
    u8
  );
}
function VB() {
  return Js().useMutationGraphQL(d8);
}
function XB() {
  return Js().useMutationGraphQL(h8);
}
function GB(e, n) {
  return Js().useGraphQLWithOptions(
    f8,
    n || {},
    e || {}
  );
}
function KB(e, n) {
  return Js().useGraphQLWithOptions(
    cx,
    { retry: !1, ...n },
    e
  );
}
const Jb = "requestWorkflows";
function YB({
  statuses: e,
  perPage: n = 50,
  totalPages: r
}) {
  return g0({
    queryKey: [Jb, e, n],
    queryFn: ({ pageParam: a = 1 }) => ck({
      statuses: e,
      page: a,
      perPage: n
    }),
    getNextPageParam: (a, o) => {
      if (o.length < r) return o.length + 1;
    },
    getPreviousPageParam: (a, o) => o.length - 1
  });
}
function ZB(e, n = !1) {
  const r = Jt();
  return Sn({
    queryKey: ["request-completion-values", e],
    queryFn: () => r.workflows.getCompletionValues(e),
    enabled: n
  });
}
function QB(e, n = !1) {
  const r = Jt();
  return Sn({
    queryKey: ["create-esign-url", e],
    queryFn: () => r.workflows.createESignAgreement(e),
    enabled: n
  });
}
function JB(e, n = !1) {
  const r = Jt();
  return Sn({
    queryKey: ["request-esign-document-url", e],
    queryFn: () => r.workflows.getESignDocumentURL(e),
    enabled: n,
    refetchInterval: 5e3,
    refetchIntervalInBackground: !0,
    refetchOnWindowFocus: !1
  });
}
const e$ = (e, n) => Js().useGraphQLWithOptions(
  lx,
  {
    enabled: !!e,
    ...n
  },
  {
    id: e
  }
);
function lk() {
  return Js().useMutationGraphQL(
    p8
  );
}
const uk = (e, n) => {
  n.removeQueries({
    queryKey: [
      lx.definitions[0].name.value,
      { id: e }
    ]
  });
}, th = -1, xi = () => {
  const {
    store: e,
    mutations: {
      answerQuestion: n,
      answerQuestionFileUpload: r,
      answerQuestionNotApplicable: a
    }
  } = xs(Ub), {
    // State
    requestId: o,
    goBackUrl: l,
    request: d,
    rawRequestData: c,
    currentQuestionIndex: f,
    currentQuestionId: s,
    currentSectionId: h,
    showOnlyUnansweredQuestions: g,
    unansweredQuestionIdsSnapshot: t,
    incompleteSectionIdsSnapshot: i,
    isSaving: m,
    isSubmitted: v,
    disableEdit: E,
    error: S,
    validationErrors: y,
    // Actions
    setShowOnlyUnansweredQuestions: x,
    setCurrentQuestionIndex: b,
    setIsSubmitted: u,
    setCurrentSectionId: I,
    setDisableEdit: O,
    setRequest: D,
    setRefetchSections: $,
    setRefetchItems: K,
    refetchSections: H,
    refetchItems: B,
    addValidationError: R,
    removeValidationError: _,
    clearValidationErrors: A
  } = lf(e), k = Ki(), z = qn(), { requestDetailQuestion: T } = _s(), { isLoading: w, refetch: F } = f0(o, {
    query: { cacheTime: 1 / 0, staleTime: 1 / 0, enabled: !1 }
  }), j = Oe(async () => {
    try {
      const oe = await F();
      if (oe != null && oe.data) {
        const fe = $b(oe.data);
        D(fe);
      }
      return oe;
    } catch (oe) {
      throw rn.error("Error refreshing request data"), oe;
    }
  }, [F, D]), P = Oe(() => {
    const oe = (d == null ? void 0 : d.questionsMap) || {};
    return d ? d == null ? void 0 : d.availableQuestionsIds.findIndex((fe) => !oe[fe].isComplete) : th;
  }, [d]), V = Oe(
    (oe) => {
      const fe = oe ? d == null ? void 0 : d.sectionsMap[oe] : void 0;
      return ((fe == null ? void 0 : fe.questionsIds) || (d == null ? void 0 : d.questionsIds) || []).find((se) => {
        if (!se) return !1;
        const L = d == null ? void 0 : d.questionsMap[se];
        return (L == null ? void 0 : L.isAvailable) && !L.isComplete;
      });
    },
    [d]
  ), J = Oe(
    (oe) => {
      const fe = V(oe);
      return fe ? d == null ? void 0 : d.questionsMap[fe] : null;
    },
    [V, d == null ? void 0 : d.questionsMap]
  ), { mutate: ne, isLoading: Z } = lk(), te = Oe(
    (oe) => {
      oe && ne(
        {
          workflowRequestId: oe,
          status: Bb.Submitted
        },
        {
          onSuccess: (fe) => {
            var Y, ae;
            if ((ae = (Y = fe == null ? void 0 : fe.updateWorkflowRequest) == null ? void 0 : Y.errors) != null && ae.length) {
              rn.error("Error submitting request");
              return;
            } else
              u(!0), x(!1), rn.success("Request submitted");
            uk(oe, z), z.removeQueries([Jb]);
          },
          onError: () => {
            rn.error("Error submitting request");
          }
        }
      );
    },
    [
      z,
      u,
      ne,
      x
    ]
  ), G = Oe(() => {
    const oe = V();
    if (!oe)
      return;
    const fe = d == null ? void 0 : d.questionsMap[oe];
    if (!fe)
      return;
    const Y = fe.sectionId;
    k(
      (T == null ? void 0 : T.link({
        requestId: o,
        sectionId: Y,
        questionId: oe
      })) ?? "/"
    );
  }, [
    V,
    k,
    d == null ? void 0 : d.questionsMap,
    T,
    o
  ]), N = Oe(
    (oe) => {
      if (!oe) return [];
      const fe = La(
        d,
        g ? t : void 0
      ), Y = [], ae = (d == null ? void 0 : d.questionsMap) || {};
      return fe == null || fe.forEach((se) => {
        const L = ae[se];
        L.sectionId === oe && Y.push(L);
      }), Y;
    },
    [d, g, t]
  ), q = Tt(() => {
    if (d) {
      const oe = g ? i : d.sectionsIds;
      return (oe == null ? void 0 : oe.map((fe) => d.sectionsMap[fe])) || [];
    }
    return [];
  }, [d, g, i]), ie = Oe(
    (oe) => {
      var Y, ae, se;
      const fe = oe ? (Y = d == null ? void 0 : d.sectionsMap) == null ? void 0 : Y[oe] : null;
      return (fe == null ? void 0 : fe.questionsLoadedAt) !== -1 / 0 && (fe == null ? void 0 : fe.questionsLoadedAt) !== void 0 ? aA({
        isRequestEditable: !!(d != null && d.isEditable),
        hasSelectedSection: !!oe,
        answeredQuestionsCount: (d == null ? void 0 : d.questionsAnsweredCount) ?? 0,
        availableQuestionsCount: ((ae = La(d)) == null ? void 0 : ae.length) ?? 0,
        hasIncompleteSection: !!(i != null && i[0]),
        selectedSectionQuestionsCount: (fe == null ? void 0 : fe.questionsTotalCount) ?? 0,
        showOnlyUnansweredQuestions: g,
        visibleQuestionsCount: ((se = N(oe)) == null ? void 0 : se.length) ?? 0
      }) : "loading";
    },
    [
      d,
      N,
      i,
      g
    ]
  );
  return {
    // State
    requestId: o,
    goBackUrl: l,
    request: d,
    rawRequestData: c,
    currentQuestionIndex: f,
    currentQuestionId: s,
    currentSectionId: h,
    visibleSections: q,
    showOnlyUnansweredQuestions: g,
    incompleteSectionIdsSnapshot: i,
    isLoading: w,
    isSaving: m,
    isSubmitted: v,
    error: S,
    validationErrors: y,
    isSubmittingRequest: Z,
    disableEdit: E,
    getVisibleQuestions: N,
    getProcessState: ie,
    // Actions
    setShowOnlyUnansweredQuestions: x,
    refetchRequest: j,
    setCurrentQuestionIndex: b,
    setCurrentSectionId: I,
    setDisableEdit: O,
    getFirstUnansweredQuestionIndex: P,
    getFirstUnansweredQuestionId: V,
    getFirstUnansweredQuestion: J,
    handleRequestSubmit: te,
    navigateToFirstUnansweredQuestion: G,
    // Mutations
    answerQuestion: n,
    answerQuestionFileUpload: r,
    answerQuestionNotApplicable: a,
    setRequest: D,
    setRefetchSections: $,
    setRefetchItems: K,
    refetchSections: H,
    refetchItems: B,
    addValidationError: R,
    removeValidationError: _,
    clearValidationErrors: A
  };
}, e9 = (e) => e.reduce((n, r) => n + r.file.size, 0), $p = (e, { sendPercent: n = 0.15 } = {}) => {
  const r = e.reduce(
    (d, c) => d + c.file.size * c.progress,
    0
  ), a = e9(e);
  return r / a / (1 / (1 - n));
};
function Fs(e, n, r) {
  return n.map((a) => a.id === e ? {
    ...r(a),
    id: a.id
  } : a);
}
function $u(e, n, r, a) {
  return Fs(e, r, (o) => ({
    ...o,
    files: o.files.map((l, d) => n === d ? a(l) : l)
  }));
}
const tc = Qa()((e, n) => ({
  // state
  files: [],
  uploads: [],
  uploadBatchIdx: 0,
  // Actions
  addFiles: (r, a) => {
    e((o) => ({
      files: [...o.files, ...r.map((l) => ({ file: l, progress: 0 }))],
      uploadType: a
    }));
  },
  setReferer: (r) => e({ referer: r }),
  deleteFile: (r) => {
    e((a) => ({
      files: [...a.files.slice(0, r), ...a.files.slice(r + 1)]
    }));
  },
  clearFiles: () => {
    e(() => ({ files: [] }));
  },
  createBatchFromFiles: (r, {
    uploadBatchKey: a,
    uploadType: o
  } = {}) => {
    const l = n();
    if (l.files.length === 0)
      throw new Error("No upload files for batch");
    const d = {
      id: l.uploadBatchIdx,
      uploadBatchKey: a,
      uploadType: o,
      files: l.files,
      batchSize: e9(l.files),
      data: r,
      isUploadingBatch: !1,
      isUploadingFiles: !1,
      isSendingFiles: !1,
      isSuccess: !1,
      progress: 0
    };
    return e(() => ({
      files: [],
      uploadBatchIdx: l.uploadBatchIdx + 1,
      uploads: [...l.uploads, d]
    })), d;
  },
  startUploadBatch: (r) => {
    e(({ uploads: a }) => ({
      uploads: Fs(r, a, (o) => ({
        ...o,
        isUploadingBatch: !0,
        isUploadingFiles: !0
      }))
    }));
  },
  retryUploadBatch: (r) => {
    e(({ uploads: a }) => ({
      uploads: Fs(r, a, (o) => {
        const l = o.files.map((c) => c.error ? {
          ...c,
          error: void 0,
          progress: 0
        } : c), d = $p(l);
        return {
          ...o,
          isUploadingBatch: !0,
          isUploadingFiles: !0,
          // Clear files, errors and progress and increment retries
          error: void 0,
          files: l,
          progress: d,
          retryAttempts: (o.retryAttempts || 0) + 1
        };
      })
    }));
  },
  fileUploadStart: ({ batchId: r, idx: a, controller: o, uploadPromise: l }) => {
    e(({ uploads: d }) => ({
      uploads: $u(
        r,
        a,
        d,
        (c) => ({
          ...c,
          progress: 0,
          isUploading: !0,
          controller: o,
          uploadPromise: l,
          error: !1
        })
      )
    }));
  },
  fileUploadProgress: ({ batchId: r, idx: a, progress: o }) => {
    e(({ uploads: l }) => ({
      uploads: Fs(r, l, (d) => {
        const c = d.files.map((s, h) => ({
          ...s,
          progress: a === h ? o : s.progress
        })), f = $p(c);
        return {
          ...d,
          files: c,
          progress: f
        };
      })
    }));
  },
  fileUploadComplete: ({ batchId: r, idx: a, document: o }) => {
    e(({ uploads: l }) => ({
      uploads: $u(
        r,
        a,
        l,
        (d) => ({
          ...d,
          isUploading: !1,
          progress: 1,
          isSuccess: !0,
          document: o
        })
      )
    }));
  },
  // NOTE: It would be nice to move these async status states to react-query where they belongs...
  fileUploadError: ({ batchId: r, idx: a, error: o }) => {
    e(({ uploads: l }) => ({
      uploads: $u(
        r,
        a,
        l,
        (d) => ({
          ...d,
          isUploading: !1,
          error: o
        })
      )
    }));
  },
  allFileUploadsComplete: (r, a) => {
    e(({ uploads: o }) => ({
      uploads: Fs(r, o, (l) => ({
        ...l,
        isUploadingFiles: !1,
        isSendingFiles: !0,
        controller: a
      }))
    }));
  },
  sendFilesComplete: (r) => {
    e(({ uploads: a }) => ({
      uploads: Fs(r, a, (o) => ({
        ...o,
        progress: 1,
        isSuccess: !0,
        isUploadingBatch: !1,
        isUploadingFiles: !1,
        isSendingFiles: !1
      }))
    }));
  },
  batchUploadError: ({ batchId: r, error: a, retryable: o = !0 }) => {
    e(({ uploads: l }) => ({
      uploads: Fs(r, l, (d) => ({
        ...d,
        isSuccess: !1,
        isUploadingFiles: !1,
        isUploadingBatch: !1,
        isSendingFiles: !1,
        error: a,
        retryable: o
      }))
    }));
  },
  deleteUploadBatch: (r) => {
    e(({ uploads: a }) => ({
      uploads: a.filter((o) => o.id !== r)
    }));
  }
})), $0 = (e) => {
  const n = qn(), {
    files: r,
    uploads: a,
    referer: o,
    clearFiles: l,
    deleteFile: d,
    createBatchFromFiles: c,
    startUploadBatch: f,
    retryUploadBatch: s,
    fileUploadStart: h,
    fileUploadProgress: g,
    fileUploadComplete: t,
    fileUploadError: i,
    allFileUploadsComplete: m,
    sendFilesComplete: v,
    batchUploadError: E,
    deleteUploadBatch: S
  } = tc(
    ({
      files: $,
      uploads: K,
      referer: H,
      clearFiles: B,
      deleteFile: R,
      createBatchFromFiles: _,
      startUploadBatch: A,
      retryUploadBatch: k,
      fileUploadStart: z,
      fileUploadProgress: T,
      fileUploadComplete: w,
      fileUploadError: F,
      allFileUploadsComplete: j,
      sendFilesComplete: P,
      batchUploadError: V,
      deleteUploadBatch: J
    }) => ({
      files: $,
      uploads: K,
      referer: H,
      clearFiles: B,
      deleteFile: R,
      createBatchFromFiles: _,
      startUploadBatch: A,
      retryUploadBatch: k,
      fileUploadStart: z,
      fileUploadProgress: T,
      fileUploadComplete: w,
      fileUploadError: F,
      allFileUploadsComplete: j,
      sendFilesComplete: P,
      batchUploadError: V,
      deleteUploadBatch: J
    })
  ), y = Jt(), x = Tt(() => e != null && e.uploadBatchKey ? a.filter(
    ($) => $.uploadBatchKey === e.uploadBatchKey
  ) : a, [a, e == null ? void 0 : e.uploadBatchKey]), b = Tt(
    () => x.find(($) => $.isUploadingBatch) !== void 0,
    [x]
  ), u = async ($) => {
    var H, B;
    if (!$ || $.isSuccess || $.isUploadingBatch)
      throw new Error("Invalid upload batch");
    const K = $.id;
    f(K);
    try {
      const R = await Promise.all(
        $.files.map(async (A, k) => {
          if (A.document)
            return A.document;
          if (A.isUploading && A.uploadPromise)
            return await A.uploadPromise;
          try {
            const z = new AbortController(), T = new Promise(
              (F, j) => {
                y.documents.uploadFile({
                  file: A.file,
                  type: ($ == null ? void 0 : $.uploadType) || cs.NewFile,
                  // Track upload progress
                  onUploadProgress: ({ progress: P }) => {
                    g({
                      batchId: K,
                      idx: k,
                      progress: P || 0
                    });
                  },
                  // Abort controller
                  signal: z.signal
                }).then((P) => {
                  F(P.data.data);
                }).catch(j);
              }
            );
            h({
              batchId: K,
              idx: k,
              controller: z,
              uploadPromise: T
            });
            const w = await T;
            return t({
              batchId: K,
              idx: k,
              document: w
            }), w;
          } catch (z) {
            throw i({
              batchId: K,
              idx: k,
              error: "Error uploading document"
            }), z;
          }
        })
      ), _ = new AbortController();
      m(K, _);
      try {
        typeof (e == null ? void 0 : e.onDocumentsUploaded) == "function" && await (e == null ? void 0 : e.onDocumentsUploaded({
          documents: R,
          batch: $,
          abortController: _
        })), v(K);
      } catch {
        E({
          batchId: K,
          error: ((H = e == null ? void 0 : e.completionError) == null ? void 0 : H.message) ?? "Error Completing Upload",
          retryable: (B = e == null ? void 0 : e.completionError) == null ? void 0 : B.retryable
        });
      }
      n.invalidateQueries(["files"]);
    } catch {
      E({
        batchId: K,
        error: "Error uploading files"
      });
    }
  }, I = async ($) => {
    const K = c($, {
      uploadType: e == null ? void 0 : e.uploadType,
      uploadBatchKey: e == null ? void 0 : e.uploadBatchKey
    });
    await u(K);
  }, O = async ($) => {
    const K = tc.getState().uploads.find(
      (H) => H.id === $ && (!(e != null && e.uploadBatchKey) || H.uploadBatchKey === e.uploadBatchKey)
    );
    !K || K.retryable === !1 || K.isSuccess || K.isUploadingBatch || (s($), await u(K));
  }, D = async ($) => {
    var H;
    const K = x.find(({ id: B }) => B === $);
    K && ((H = K.controller) == null || H.abort(), K.files.forEach((B) => {
      var R;
      (R = B.controller) == null || R.abort("Cancelled by user");
    }), S($));
  };
  return {
    // State
    files: r,
    uploads: x,
    referer: o,
    uploadInProgress: b,
    uploadBatchKey: e == null ? void 0 : e.uploadBatchKey,
    // File Actions
    clearFiles: l,
    deleteFile: d,
    // Upload Batch Actions
    uploadFiles: I,
    retryUpload: O,
    deleteUploadBatch: S,
    cancelAndDeleteUpload: D
  };
}, t9 = (e) => !e || e.length < 1 ? [] : e.filter((n) => n.uuid).map((n) => ({
  uuid: `${n.uuid}`,
  filename: n.doc_name ?? null,
  retrieval_token: null
})), t$ = (e) => {
  var s;
  const { requestId: n, request: r, answerQuestionFileUpload: a } = xi(), { mutateAsync: o } = qx(), l = (s = r == null ? void 0 : r.questionsMap) == null ? void 0 : s[e], { data: d } = Wx(
    (l == null ? void 0 : l.value) || []
  ), c = d.documents, f = async (h) => {
    if (!l)
      throw new Error(
        `Invalid question id "${e}" for request "${n}"`
      );
    if (!c.find((t) => t.id === t.id))
      throw new Error(`Invalid document id "${h.id}"`);
    await o({
      documentId: h.id,
      messageId: "",
      docType: "Request"
    });
    const g = (c == null ? void 0 : c.filter((t) => t.uuid !== h.uuid)) || [];
    await a({
      id: l.id,
      value: t9(g)
    });
  };
  return Ln({
    mutationFn: (h) => f(h)
  });
};
var dk = /* @__PURE__ */ ((e) => (e[e.draft = 0] = "draft", e[e.saved = 1] = "saved", e[e.complete = 2] = "complete", e[e.final = 3] = "final", e))(dk || {}), hk = /* @__PURE__ */ ((e) => (e.Boolean = "answer_boolean", e.Text = "answer_text", e.Upload = "uploaded_document", e))(hk || {}), fk = /* @__PURE__ */ ((e) => (e.Boolean = "WfiAnswerBooleanQuestion", e.Text = "WfiAnswerTextQuestion", e.FirmAuthoredText = "WfiFirmAuthoredTextAcknowledgement", e.Upload = "WfiUploadDocument", e))(fk || {});
const n$ = {
  WORKFLOW_REQUESTS: {
    REQUEST_RECALLED: "workflowrequests:request_recalled",
    UNAUTHORIZED: "workflowrequests:unauthorized",
    REQUEST_NOT_FOUND: "workflowrequests:not_found"
  }
}, pk = ({
  open: e,
  onClose: n,
  onCancel: r,
  onSubmit: a,
  ...o
}) => /* @__PURE__ */ p.jsxs(
  oi,
  {
    open: e,
    onClose: n,
    title: "Delete Attachments",
    cancelLabel: "No",
    onCancel: r,
    submitLabel: "Yes",
    onSubmit: a,
    ...o,
    children: [
      /* @__PURE__ */ p.jsxs(Te, { component: "span", children: [
        "You are about to mark this answer as",
        " "
      ] }),
      /* @__PURE__ */ p.jsx(Te, { component: "span", variant: "body2", children: "N/A" }),
      /* @__PURE__ */ p.jsxs(Te, { component: "span", children: [
        " ",
        "which will remove all attached files. This action cannot be undone. Proceed?"
      ] })
    ]
  }
), gk = ({
  isNotApplicableQuestion: e,
  onSubmit: n,
  shouldShowConfirmationDialog: r,
  ...a
}) => {
  const [o, l] = Ee(!1), d = Oe(() => l(!1), []), c = Oe(
    async (s) => {
      n(s), d();
    },
    [d, n]
  ), f = Oe(() => {
    e ? c(!1) : r ? l(!0) : c(!0);
  }, [c, e, r]);
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsx(
      lt,
      {
        onClick: f,
        variant: e ? "contained" : "outlined",
        ...a,
        children: "N/A"
      }
    ),
    /* @__PURE__ */ p.jsx(
      pk,
      {
        open: o,
        onClose: d,
        onCancel: d,
        onSubmit: () => c(!0)
      }
    )
  ] });
}, mk = tt(Te)(({ theme: e }) => ({
  color: e.palette.common.neutrals[700],
  marginTop: e.spacing(1)
})), xk = ({
  children: e,
  ...n
}) => /* @__PURE__ */ p.jsxs(mk, { variant: "body1", ...n, children: [
  "Prior year value: ",
  e
] }), n9 = "#00AECC", bk = tt(Te)(({ theme: e }) => ({
  padding: `0px ${e.spacing(0.5)}`,
  marginRight: e.spacing(1),
  textWrap: "nowrap"
})), yk = ({
  isComplete: e,
  statusText: n
}) => {
  const r = Mr(), a = n || (e ? "DONE" : "TO-DO"), o = e ? r.palette.common.neutrals[500] : n9;
  return /* @__PURE__ */ p.jsx(
    bk,
    {
      borderRadius: 1,
      border: `solid 1px ${o}`,
      sx: { color: o },
      children: a
    }
  );
}, vk = tt(Me)({
  width: "20px",
  height: "20px"
}), wk = tt(Qm)(({ theme: e }) => ({
  gap: e.spacing(1),
  padding: `${e.spacing(3)} ${e.spacing(2)}`,
  borderRadius: 0,
  justifyContent: "space-between",
  alignItems: "center",
  maxWidth: "100vw"
})), Sk = ({
  title: e,
  onClick: n,
  infoContent: r,
  disabled: a,
  selected: o
}) => {
  const { isMobile: l } = ri();
  return /* @__PURE__ */ p.jsx(bs, { disablePadding: !0, children: /* @__PURE__ */ p.jsxs(
    wk,
    {
      disabled: a,
      onClick: n,
      selected: o,
      divider: l,
      children: [
        /* @__PURE__ */ p.jsx(g5, { variant: o ? "body2" : "body1", children: e }),
        /* @__PURE__ */ p.jsxs(Pe, { direction: "row", alignItems: "center", justifyContent: "flex-end", children: [
          r,
          /* @__PURE__ */ p.jsx(vk, { children: !a && /* @__PURE__ */ p.jsx(it, { icon: "chevronRight", fontSize: "small" }) })
        ] })
      ]
    }
  ) });
}, i$ = ({
  children: e = "Save and Exit",
  dialogProps: {
    children: n = "We save your progress automatically as you answer questions. Would you like to exit?",
    ...r
  } = {},
  onClose: a = () => {
  },
  ...o
}) => {
  const [l, d] = Ee(!1), c = Oe(() => {
    d(!1), a();
  }, [a]), { goBackUrl: f } = xi(), s = Ki(), { requestsListProtected: h } = _s(), g = Oe(
    (i) => {
      d(!0), o.onClick && o.onClick(i);
    },
    [o]
  ), t = Oe(() => {
    c(), s(f || (h == null ? void 0 : h.link()) || "/", {
      state: m5("slide-out")
    });
  }, [c, s, f, h]);
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsx(vd, { ...o, onClick: g, children: e }),
    /* @__PURE__ */ p.jsx(
      oi,
      {
        open: l,
        onClose: c,
        title: "Save & Exit",
        cancelLabel: "Stay Here",
        onCancel: c,
        cancelBtnProps: {
          color: "primary"
        },
        submitLabel: "Save & Exit",
        onSubmit: t,
        ...r,
        children: n
      }
    )
  ] });
}, r$ = ({
  sections: e,
  onSectionClick: n
}) => {
  const { sectionId: r } = m0();
  return /* @__PURE__ */ p.jsx(Gs, { children: e.map((a) => /* @__PURE__ */ p.jsx(
    Sk,
    {
      onClick: () => n(a.id),
      title: a.title,
      selected: a.id === r,
      infoContent: /* @__PURE__ */ p.jsx(
        yk,
        {
          isComplete: a.questionsCompletedCount === a.questionsAvailableCount,
          statusText: `${a.questionsCompletedCount}/${a.questionsAvailableCount}`
        }
      ),
      disabled: !a.questionsAvailableCount
    },
    a.id
  )) });
}, _k = ({
  disabled: e = !1,
  onCancel: n = () => {
  },
  component: r = lt,
  children: a = "Submit",
  ...o
}) => {
  const { id: l } = m0(), {
    handleRequestSubmit: d,
    getFirstUnansweredQuestionIndex: c,
    isSubmittingRequest: f,
    setShowOnlyUnansweredQuestions: s
  } = xi(), { trackRequestStoreEvent: h } = HP(), [g, t] = Ee(!1), [i, m] = Ee(th), v = i === th, E = v ? "Cancel" : "View Unanswered ", S = v ? "Submit" : "Submit Anyway", y = Oe(() => {
    t(!1), d(l), h("request_submitted");
  }, [l, d, h]), x = Oe(() => {
    v || (s(!0), h("request_view_unanswered"), n()), t(!1);
  }, [
    n,
    v,
    s,
    h
  ]), b = Oe(() => {
    m(c()), t(!0);
  }, [
    m,
    c,
    t
  ]), u = r;
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsx(mi, { open: f }),
    /* @__PURE__ */ p.jsxs(
      oi,
      {
        open: g,
        title: "Confirm Submission",
        onClose: () => {
          t(!1);
        },
        cancelBtnProps: {
          color: "primary"
        },
        cancelLabel: E,
        onCancel: x,
        submitLabel: S,
        onSubmit: y,
        children: [
          v && /* @__PURE__ */ p.jsxs(Te, { component: "div", children: [
            "Are you sure you want to submit your response? You will",
            " ",
            /* @__PURE__ */ p.jsx("strong", { children: /* @__PURE__ */ p.jsx("u", { children: "not" }) }),
            " ",
            "be able to make further edits after submission."
          ] }),
          !v && /* @__PURE__ */ p.jsxs(Pe, { gap: 2, children: [
            /* @__PURE__ */ p.jsxs(Te, { component: "div", children: [
              "You have",
              " ",
              /* @__PURE__ */ p.jsx("strong", { children: /* @__PURE__ */ p.jsx("u", { children: "not" }) }),
              " ",
              "answered one or more questions in this request, are you sure you want to submit it? You will not be able to make further edits after submission."
            ] }),
            /* @__PURE__ */ p.jsxs(Te, { children: [
              "Alternately, click ",
              /* @__PURE__ */ p.jsx("i", { children: "View Unanswered" }),
              " to review all questions you have not yet completed."
            ] })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ p.jsx(
      u,
      {
        disabled: e,
        variant: "contained",
        onClick: b,
        ...o,
        children: a
      }
    )
  ] });
}, Ck = tt(Pe)(({ theme: e }) => ({
  justifyContent: "space-between",
  height: "100%",
  padding: e.spacing(2)
}));
function s$({
  open: e
}) {
  const n = Ki(), { requestsListProtected: r } = _s(), a = () => {
    n((r == null ? void 0 : r.link()) ?? "/");
  };
  return /* @__PURE__ */ p.jsxs(ms, { open: e, children: [
    /* @__PURE__ */ p.jsx(
      Kr,
      {
        onNavigationClick: a,
        DefaultStateElement: Ys,
        title: "Requests",
        position: "relative"
      }
    ),
    /* @__PURE__ */ p.jsxs(Ck, { children: [
      /* @__PURE__ */ p.jsxs(Pe, { flexGrow: 1, alignItems: "center", justifyContent: "center", children: [
        /* @__PURE__ */ p.jsx(Te, { variant: "h5", children: "Thank you!" }),
        /* @__PURE__ */ p.jsx(Te, { children: "Your responses were submitted successfully." })
      ] }),
      /* @__PURE__ */ p.jsx(lt, { onClick: a, variant: "contained", children: "Back to Requests" })
    ] })
  ] });
}
const Ak = tt(x5)(({ theme: e }) => ({
  "& .MuiSwitch-thumb": {
    backgroundColor: e.palette.common.white
  },
  "& .MuiSwitch-track": {
    backgroundColor: e.palette.common.neutrals[500]
  },
  "& .MuiSwitch-switchBase": {
    "&.Mui-checked": {
      "& + .MuiSwitch-track": {
        backgroundColor: n9,
        opacity: 1
      }
    }
  }
})), kk = ({
  data: e,
  isLoading: n,
  onView: r
}) => n ? /* @__PURE__ */ p.jsx(u0, { numberOfElements: 5, mt: 1 }) : /* @__PURE__ */ p.jsx(Pe, { width: "100%", gap: 2, children: /* @__PURE__ */ p.jsx(Gs, { children: e == null ? void 0 : e.map((a, o) => /* @__PURE__ */ p.jsxs(
  bs,
  {
    divider: o < e.length - 1,
    secondaryAction: /* @__PURE__ */ p.jsx(
      lt,
      {
        startIcon: /* @__PURE__ */ p.jsx(it, { icon: "preview" }),
        variant: "text",
        size: "small",
        onClick: () => r(a.package),
        children: "View"
      }
    ),
    sx: (l) => ({
      padding: l.spacing(1, 0)
    }),
    "aria-label": a.member,
    children: [
      /* @__PURE__ */ p.jsx(Jm, { children: /* @__PURE__ */ p.jsx(it, { icon: "filePdf", color: "action" }) }),
      /* @__PURE__ */ p.jsx(Mn, { primary: a.member })
    ]
  },
  a.uuid
)) }) }), Up = tt(In)(() => ({
  position: "sticky",
  right: 0
})), Ek = ({
  data: e = [],
  maxWidth: n = "80vw",
  backgroundColor: r
}) => {
  const a = Mr(), o = r || a.palette.common.white, l = `linear-gradient(to right, ${o}00 0%, ${o} 20%);`, d = (c) => {
    c && window.open(c, "_blank");
  };
  return /* @__PURE__ */ p.jsx(ex, { sx: { maxWidth: n }, children: /* @__PURE__ */ p.jsxs(b5, { "aria-label": "estimate payments table", children: [
    /* @__PURE__ */ p.jsxs(y5, { children: [
      /* @__PURE__ */ p.jsxs(Nc, { children: [
        /* @__PURE__ */ p.jsx(In, { rowSpan: 2, align: "center", children: "JDX" }),
        /* @__PURE__ */ p.jsx(In, { rowSpan: 2, align: "center", children: "Year" }),
        /* @__PURE__ */ p.jsx(In, { colSpan: 2, align: "center", children: "Q1" }),
        /* @__PURE__ */ p.jsx(In, { colSpan: 2, align: "center", children: "Q2" }),
        /* @__PURE__ */ p.jsx(In, { colSpan: 2, align: "center", children: "Q3" }),
        /* @__PURE__ */ p.jsx(In, { colSpan: 2, align: "center", children: "Q4" }),
        /* @__PURE__ */ p.jsx(Up, { rowSpan: 2, align: "center" })
      ] }),
      /* @__PURE__ */ p.jsxs(Nc, { children: [
        /* @__PURE__ */ p.jsx(In, { align: "left", children: "Date" }),
        /* @__PURE__ */ p.jsx(In, { align: "right", children: "Amount" }),
        /* @__PURE__ */ p.jsx(In, { align: "left", children: "Date" }),
        /* @__PURE__ */ p.jsx(In, { align: "right", children: "Amount" }),
        /* @__PURE__ */ p.jsx(In, { align: "left", children: "Date" }),
        /* @__PURE__ */ p.jsx(In, { align: "right", children: "Amount" }),
        /* @__PURE__ */ p.jsx(In, { align: "left", children: "Date" }),
        /* @__PURE__ */ p.jsx(In, { align: "right", children: "Amount" })
      ] })
    ] }),
    /* @__PURE__ */ p.jsxs(v5, { children: [
      e.map((c) => /* @__PURE__ */ p.jsxs(Nc, { children: [
        /* @__PURE__ */ p.jsx(In, { align: "center", children: c.jurisdiction }),
        /* @__PURE__ */ p.jsx(In, { align: "center", children: c.tax_year }),
        /* @__PURE__ */ p.jsx(In, { align: "left", children: nr({
          dateString: c == null ? void 0 : c.q1_due_date,
          defaultPlaceholder: "-",
          outputFormat: "MM/dd"
        }) }),
        /* @__PURE__ */ p.jsx(In, { align: "right", children: js(
          c.q1_payment_estimate,
          "-"
        ) }),
        /* @__PURE__ */ p.jsx(In, { align: "left", children: nr({
          dateString: c == null ? void 0 : c.q2_due_date,
          defaultPlaceholder: "-",
          outputFormat: "MM/dd"
        }) }),
        /* @__PURE__ */ p.jsx(In, { align: "right", children: js(
          c.q2_payment_estimate,
          "-"
        ) }),
        /* @__PURE__ */ p.jsx(In, { align: "left", children: nr({
          dateString: c == null ? void 0 : c.q3_due_date,
          defaultPlaceholder: "-",
          outputFormat: "MM/dd"
        }) }),
        /* @__PURE__ */ p.jsx(In, { align: "right", children: js(
          c.q3_payment_estimate,
          "-"
        ) }),
        /* @__PURE__ */ p.jsx(In, { align: "left", children: nr({
          dateString: c == null ? void 0 : c.q4_due_date,
          defaultPlaceholder: "-",
          outputFormat: "MM/dd"
        }) }),
        /* @__PURE__ */ p.jsx(In, { align: "right", children: js(
          c.q4_payment_estimate,
          "-"
        ) }),
        /* @__PURE__ */ p.jsx(Up, { sx: { background: l }, children: c.payment_url && /* @__PURE__ */ p.jsx(
          lt,
          {
            size: "small",
            variant: "contained",
            onClick: () => {
              d(c == null ? void 0 : c.payment_url);
            },
            children: "Pay"
          }
        ) })
      ] }, c.uuid)),
      e.length === 0 && /* @__PURE__ */ p.jsx(Nc, { children: /* @__PURE__ */ p.jsx(In, { colSpan: 11, align: "center", children: "The list is empty" }) })
    ] })
  ] }) });
}, a$ = ({ data: e = [] }) => {
  const n = ({
    quarter: a,
    dueDate: o,
    paymentEstimate: l
  }) => /* @__PURE__ */ p.jsxs(
    Pe,
    {
      direction: "row",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      children: [
        /* @__PURE__ */ p.jsxs(Te, { variant: "h6", color: "GrayText", p: 2, children: [
          a,
          " - Due Date",
          " ",
          nr({
            dateString: o,
            defaultPlaceholder: "-"
          })
        ] }),
        /* @__PURE__ */ p.jsxs(Te, { variant: "h6", color: "GrayText", p: 2, children: [
          "Amount ",
          js(l, "-")
        ] })
      ]
    }
  ), r = (a) => {
    a && window.open(a, "_blank");
  };
  return /* @__PURE__ */ p.jsx(Me, { height: "100%", overflow: "auto", children: /* @__PURE__ */ p.jsx(
    Gs,
    {
      sx: { width: "100%", maxWidth: "100vw", bgcolor: "background.paper" },
      children: e.map((a) => /* @__PURE__ */ p.jsx(p.Fragment, { children: /* @__PURE__ */ p.jsx(bs, { disableGutters: !0, children: /* @__PURE__ */ p.jsx(
        Mn,
        {
          disableTypography: !0,
          primary: /* @__PURE__ */ p.jsxs(
            Pe,
            {
              direction: "row",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ p.jsxs(Te, { variant: "h6", p: 1, component: "div", children: [
                  "Jurisdiction ",
                  a.jurisdiction,
                  " "
                ] }),
                /* @__PURE__ */ p.jsxs(Te, { variant: "h6", p: 1, component: "div", children: [
                  "Tax Year ",
                  a.tax_year
                ] })
              ]
            }
          ),
          secondary: /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
            /* @__PURE__ */ p.jsx(
              n,
              {
                quarter: "Q1",
                dueDate: a == null ? void 0 : a.q1_due_date,
                paymentEstimate: a == null ? void 0 : a.q1_payment_estimate
              }
            ),
            /* @__PURE__ */ p.jsx(
              n,
              {
                quarter: "Q2",
                dueDate: a == null ? void 0 : a.q2_due_date,
                paymentEstimate: a == null ? void 0 : a.q2_payment_estimate
              }
            ),
            /* @__PURE__ */ p.jsx(
              n,
              {
                quarter: "Q3",
                dueDate: a == null ? void 0 : a.q3_due_date,
                paymentEstimate: a == null ? void 0 : a.q3_payment_estimate
              }
            ),
            /* @__PURE__ */ p.jsx(
              n,
              {
                quarter: "Q4",
                dueDate: a == null ? void 0 : a.q4_due_date,
                paymentEstimate: a == null ? void 0 : a.q4_payment_estimate
              }
            ),
            a.payment_url && /* @__PURE__ */ p.jsx(Me, { p: 1, children: /* @__PURE__ */ p.jsxs(
              lt,
              {
                variant: "outlined",
                color: "info",
                size: "small",
                fullWidth: !0,
                onClick: () => {
                  r(
                    a == null ? void 0 : a.payment_url
                  );
                },
                children: [
                  "Go to ",
                  a.jurisdiction,
                  " Payment Portal"
                ]
              }
            ) })
          ] })
        }
      ) }, a.uuid) }))
    }
  ) });
}, Ik = tt(Pe)(({ theme: e }) => ({
  backgroundColor: e.palette.background.paper,
  position: "sticky",
  top: 0,
  zIndex: e.zIndex.slidingViews
})), o$ = ({
  slots: e,
  titleEditable: n
}) => {
  const { RequestContextMenu: r } = e || {}, { request: a, requestId: o, refetchRequest: l } = xi(), [d, c] = Ee(!1), [f, s] = Ee(a == null ? void 0 : a.title), { mutateAsync: h } = g8(), g = () => {
    c(!0);
  }, t = async () => {
    c(!1), await h({ id: o, data: { title: f } }), l();
  };
  return /* @__PURE__ */ p.jsxs(Ik, { px: 2, py: 3, gap: 1, children: [
    /* @__PURE__ */ p.jsx(w5, { label: a == null ? void 0 : a.status, sx: { width: "fit-content" } }),
    /* @__PURE__ */ p.jsxs(Pe, { direction: "row", justifyContent: "space-between", alignItems: "center", children: [
      !d && /* @__PURE__ */ p.jsxs(Te, { variant: "h5", children: [
        a == null ? void 0 : a.title,
        n && /* @__PURE__ */ p.jsx(Si, { onClick: g, children: /* @__PURE__ */ p.jsx(it, { icon: "penOutline", fontSize: "small", color: "secondary" }) })
      ] }),
      d && /* @__PURE__ */ p.jsxs(Pe, { width: "100%", children: [
        /* @__PURE__ */ p.jsx(Qy, { id: "request-details-panel-title-label", children: "TITLE" }),
        /* @__PURE__ */ p.jsxs(Pe, { direction: "row", alignItems: "center", children: [
          /* @__PURE__ */ p.jsx(
            Jy,
            {
              "aria-labelledby": "request-details-panel-title-label",
              defaultValue: a == null ? void 0 : a.title,
              onChange: (i) => s(i.target.value),
              fullWidth: !0
            }
          ),
          /* @__PURE__ */ p.jsx(Si, { onClick: () => c(!1), children: /* @__PURE__ */ p.jsx(it, { icon: "close", fontSize: "small" }) }),
          /* @__PURE__ */ p.jsx(Si, { onClick: t, children: /* @__PURE__ */ p.jsx(it, { icon: "check", fontSize: "small", color: "secondary" }) })
        ] })
      ] }),
      r
    ] }),
    /* @__PURE__ */ p.jsx(Te, { variant: "body1", children: a == null ? void 0 : a.description })
  ] });
}, Tk = tt(Qh)(
  ({ theme: e }) => ({
    height: "6px",
    borderRadius: "100px",
    "&.MuiLinearProgress-root": {
      backgroundColor: e.palette.common.neutrals.A100
    },
    "& .MuiLinearProgress-barColorSecondary": {
      backgroundColor: e.palette.common.neutrals[500]
    }
  })
), Ok = () => {
  const { request: e } = xi(), n = (e == null ? void 0 : e.questionsAnsweredCount) ?? 0, r = (e == null ? void 0 : e.questionsAvailableCount) ?? 0, a = (n / r || 0) * 100, o = `${n}/${r}`;
  return /* @__PURE__ */ p.jsx(Tk, { value: a, label: o });
}, Fk = tt(Pe)(({ theme: e }) => ({
  justifyContent: "space-between",
  alignItems: "center",
  paddingLeft: e.spacing(1),
  marginTop: e.spacing(2)
})), Pk = tt(e5)(({ theme: e }) => ({
  width: "100%",
  display: "flex",
  marginRight: e.spacing(2),
  justifyContent: "space-between",
  alignItems: "center",
  color: e.palette.common.neutrals[900]
})), jk = tt(Pe)(({ theme: e }) => ({
  backgroundColor: e.palette.background.paper,
  borderBottom: `solid 1px ${e.palette.divider}`,
  position: "sticky",
  top: 0,
  zIndex: e.zIndex.slidingViews
})), c$ = () => {
  const { showOnlyUnansweredQuestions: e, setShowOnlyUnansweredQuestions: n } = xi();
  return /* @__PURE__ */ p.jsxs(jk, { px: 2, py: 3, children: [
    /* @__PURE__ */ p.jsx(Ok, {}),
    /* @__PURE__ */ p.jsx(Pe, { children: /* @__PURE__ */ p.jsx(Pe, { direction: "row", borderRadius: 1, children: /* @__PURE__ */ p.jsx(Fk, { children: /* @__PURE__ */ p.jsxs(Pk, { children: [
      /* @__PURE__ */ p.jsx(Te, { children: "Unanswered questions only" }),
      /* @__PURE__ */ p.jsx(
        Ak,
        {
          "data-testid": "show-unanswered-only-toggle",
          label: "",
          checked: e,
          onChange: (r) => n(r.target.checked)
        }
      )
    ] }) }) }) })
  ] });
}, Rk = Jn.object().shape({
  amount: Jn.number().required("Amount is required").min(0.01, "Must be greater than 0").typeError("Not valid amount")
}), Mk = ({
  normalizedAmountInCents: e,
  isRefund: n,
  wfRequestUuid: r,
  taxReturnFormId: a,
  requestStatus: o
}) => {
  var D;
  const l = l0(), d = e < 0 && o === ox.draft, c = Math.abs(e) / 100, [f, s] = Ee(!1), [h, g] = Ee(c), {
    register: t,
    handleSubmit: i,
    formState: { errors: m },
    reset: v
  } = mr({
    resolver: ws(Rk),
    defaultValues: {
      amount: c
    }
  }), E = ($) => {
    g($.amount), Tl.success("Tax balance updated successfully"), s(!1);
  }, S = ($) => {
    const K = p0($);
    Tl.error(K || "Failed to update tax balance");
  }, { mutate: y, isLoading: x } = m8({
    mutation: {
      onSuccess: ($, K) => {
        const H = K.data, B = parseFloat(n ? H.refund || "0" : H.amount_due);
        E({ amount: B });
      },
      onError: S
    }
  }), b = ($) => {
    if (!r || !a) return;
    const K = Math.abs($.amount).toString();
    y({
      requestId: r,
      id: a,
      // Backend accepts both amount_due and refund; generated type is stale
      data: n ? { refund: K, amount_due: "0" } : { amount_due: K, refund: "0" }
    });
  }, u = () => {
    i(b)();
  }, I = () => {
    s(!0), v({ amount: h });
  }, O = () => {
    s(!1), v({ amount: h });
  };
  return /* @__PURE__ */ p.jsxs(
    Pe,
    {
      sx: {
        position: "relative",
        paddingTop: 0,
        height: 82,
        display: "flex",
        justifyContent: "center",
        pr: 1
      },
      alignItems: "center",
      children: [
        f ? /* @__PURE__ */ p.jsx("form", { onSubmit: i(b), children: /* @__PURE__ */ p.jsx(
          qs,
          {
            ...t("amount"),
            error: !!(m != null && m.amount),
            helperText: (D = m == null ? void 0 : m.amount) == null ? void 0 : D.message,
            size: "small",
            sx: {
              minWidth: "7rem",
              "& .MuiFormHelperText-root": {
                marginTop: 0,
                marginLeft: 0,
                marginRight: 0
              }
            },
            inputProps: {
              step: "0.01",
              min: "0",
              type: "number"
            }
          }
        ) }) : /* @__PURE__ */ p.jsx(
          Te,
          {
            variant: "h6",
            fontWeight: 600,
            minWidth: "7rem",
            textAlign: "right",
            children: J8(h)
          }
        ),
        !f && d ? /* @__PURE__ */ p.jsx(
          Gn,
          {
            onClick: I,
            "aria-label": "Edit",
            sx: {
              position: "absolute",
              top: 0,
              right: 0,
              padding: 0,
              backgroundColor: "white",
              "&:hover": { backgroundColor: l.palette.grey[100] }
            },
            children: /* @__PURE__ */ p.jsx(
              it,
              {
                icon: "penOutline",
                fontSize: "small",
                color: "secondary",
                sx: { fontSize: "0.8rem" }
              }
            )
          }
        ) : f ? /* @__PURE__ */ p.jsxs(Pe, { direction: "row", sx: { position: "absolute", top: 0, right: 0 }, children: [
          /* @__PURE__ */ p.jsx(
            Gn,
            {
              onClick: u,
              disabled: x,
              "aria-label": "Save",
              sx: {
                padding: 0,
                backgroundColor: "white",
                "&:hover": { backgroundColor: "grey.100" },
                fontSize: "0.8rem"
              },
              color: "primary",
              children: x ? /* @__PURE__ */ p.jsx(Jh, { size: 16, sx: { fontSize: "0.8rem" } }) : /* @__PURE__ */ p.jsx(it, { icon: "check", fontSize: "small", sx: { fontSize: "0.8rem" } })
            }
          ),
          /* @__PURE__ */ p.jsx(
            Gn,
            {
              onClick: O,
              disabled: x,
              "aria-label": "Cancel",
              sx: {
                padding: 0,
                backgroundColor: "white",
                "&:hover": { backgroundColor: "grey.100" },
                fontSize: "0.8rem"
              },
              color: "error",
              children: /* @__PURE__ */ p.jsx(it, { icon: "close", fontSize: "small", sx: { fontSize: "0.8rem" } })
            }
          )
        ] }) : null
      ]
    }
  );
}, nh = "REFUND", Dk = "AMOUNT DUE", Nk = tt(fr)(({ theme: e, label: n }) => ({
  background: n === nh ? e.palette.common.success[100] : e.palette.common.error[100],
  // theme.palette.error.light?,
  color: n === nh ? e.palette.common.success[700] : e.palette.common.error[600],
  //theme.palette.error.main?,
  fontWeight: 600,
  fontSize: "0.75rem",
  padding: "3px 6px 3px 6px",
  lineHeight: "1rem"
})), ih = ({
  amountInCents: e,
  isRefund: n
}) => {
  const r = e >= 0 && n ? nh : Dk;
  return /* @__PURE__ */ p.jsx(Nk, { label: r, size: "small" });
}, Lk = ({
  amountInCents: e,
  alignItems: n
}) => {
  const r = n === "flex-start" ? 0 : void 0, a = n === "flex-end" ? 0 : void 0;
  return /* @__PURE__ */ p.jsx(
    Te,
    {
      variant: "h1",
      sx: {
        paddingLeft: r,
        paddingRight: a
      },
      children: js(Math.abs(e))
    }
  );
}, Bk = /\.(png|jpe?g|gif|webp|bmp|svg)$/i, $k = (e, n) => (n == null ? void 0 : n.toLowerCase()) === "application/pdf" || !!(e != null && e.toLowerCase().endsWith(".pdf")), Uk = (e, n) => !!(n != null && n.toLowerCase().startsWith("image/")) || Bk.test(e ?? ""), zk = ({ url: e, fileName: n, contentType: r }) => Uk(n, r) ? /* @__PURE__ */ p.jsx(Me, { sx: { p: 2, textAlign: "center" }, children: /* @__PURE__ */ p.jsx(
  Me,
  {
    component: "img",
    src: e,
    alt: n ?? "File",
    sx: { maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }
  }
) }) : /* @__PURE__ */ p.jsxs(
  Me,
  {
    sx: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 2,
      p: 4,
      height: "100%"
    },
    children: [
      /* @__PURE__ */ p.jsx(Te, { variant: "label", sx: { textAlign: "center" }, children: "Preview not available" }),
      /* @__PURE__ */ p.jsx(lt, { variant: "outlined", href: e, children: "Download" })
    ]
  }
), Hk = 420;
function Wk({
  retrievalToken: e,
  signedUrl: n,
  fileName: r,
  contentType: a,
  showZoomControls: o,
  extended: l
}) {
  return $k(r, a) ? /* @__PURE__ */ p.jsx(
    no,
    {
      url: n ?? "",
      showZoomControls: o,
      ...l ? { height: "100%" } : {}
    }
  ) : !e && n ? /* @__PURE__ */ p.jsx(
    zk,
    {
      url: n,
      fileName: r,
      contentType: a
    }
  ) : /* @__PURE__ */ p.jsx(
    i1,
    {
      retrievalToken: e || void 0,
      fileName: r || void 0
    }
  );
}
const Qs = ({
  retrievalToken: e,
  signedUrl: n,
  fileName: r,
  contentType: a,
  onClose: o,
  sidePanel: l,
  actions: d,
  showZoomControls: c = !1,
  escClose: f = !1
}) => {
  const s = () => {
    o == null || o();
  }, h = !!l || !!d || c, g = /* @__PURE__ */ p.jsx(
    Wk,
    {
      signedUrl: n,
      fileName: r,
      contentType: a,
      retrievalToken: e,
      showZoomControls: c,
      extended: h
    }
  );
  return /* @__PURE__ */ p.jsx(
    oi,
    {
      open: !!n,
      title: r,
      onClose: s,
      fullWidth: !0,
      maxWidth: "xl",
      scroll: h ? "paper" : "body",
      contentProps: h ? void 0 : { sx: { p: 0 } },
      options: e ? /* @__PURE__ */ p.jsx(pj, { retrievalToken: e }) : void 0,
      escClose: f || h,
      ...h ? { layout: "documentPreview", actions: d } : {},
      children: h ? /* @__PURE__ */ p.jsxs(Pe, { direction: "row", sx: { flex: 1, minHeight: 0 }, children: [
        /* @__PURE__ */ p.jsx(Pe, { sx: { flex: 1, minWidth: 0, minHeight: 0 }, children: g }),
        l && /* @__PURE__ */ p.jsx(
          Me,
          {
            "data-testid": "preview-side-panel",
            sx: {
              width: Hk,
              flexShrink: 0,
              overflow: "auto",
              p: 3,
              borderLeft: "1px solid",
              borderColor: "common.neutrals.200"
            },
            children: l
          }
        )
      ] }) : g
    }
  );
}, qk = tt(Ii)(({ theme: e }) => ({
  color: e.palette.primary.main,
  display: "flex",
  gap: e.spacing(1),
  alignItems: "center",
  justifyContent: "center",
  textDecoration: "none",
  fontSize: "0.875rem",
  lineHeight: "1rem",
  "&:hover": {
    textDecoration: "none"
  }
})), Vk = ({ onClick: e }) => /* @__PURE__ */ p.jsxs(qk, { onClick: e, children: [
  /* @__PURE__ */ p.jsx(it, { icon: "filePdf", sx: { width: "16px" } }),
  "Voucher"
] }), es = (e, n) => {
  const { mutateAsync: r } = x8(), a = ut(e || ""), [o, l] = Ee(null), [d, c] = Ee(!1), [f, s] = Ee(null), h = Oe(async () => {
    var m;
    if (a.current) {
      c(!0), s(null);
      try {
        const v = await r({
          data: {
            disposition: (n == null ? void 0 : n.disposition) ?? "inline",
            retrieval_token: a.current
          }
        });
        l(v), (m = n == null ? void 0 : n.onSignedUrlFetched) == null || m.call(n, v);
      } catch (v) {
        const E = v instanceof Error ? v : new Error("Failed to fetch signed URL");
        s(E), n != null && n.onError ? n == null || n.onError() : rn.error("Failed to load document preview");
      } finally {
        c(!1);
      }
    }
  }, [r, n]), g = Oe(() => {
    l(null), s(null);
  }, []), t = Oe(() => {
    s(null);
  }, []), i = Oe(async () => {
    g(), await h();
  }, [g, h]);
  return {
    signedUrlData: o,
    isLoading: d,
    error: f,
    refreshSignedUrl: i,
    clearSignedUrl: g,
    clearError: t,
    setRetrievalToken: (m) => {
      a.current = m;
    }
  };
}, i9 = ({
  paymentPortalUrl: e,
  paymentVoucherToken: n
}) => {
  const [r, a] = Ee(!1), {
    signedUrlData: o,
    setRetrievalToken: l,
    refreshSignedUrl: d,
    clearSignedUrl: c
  } = es(), f = async () => {
    n && (l(n), await d(), a(!0));
  }, s = () => {
    e ? window.open(e, "_blank") : console.warn("No payment portal URL provided.");
  };
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsxs(
      Pe,
      {
        direction: "row",
        alignItems: "center",
        justifyContent: "flex-end",
        width: "100%",
        gap: 1,
        children: [
          n && /* @__PURE__ */ p.jsx(Me, { pr: 2, pl: 2, children: /* @__PURE__ */ p.jsx(Vk, { onClick: f }) }),
          e && /* @__PURE__ */ p.jsx(lt, { variant: "outlined", onClick: s, children: "Pay" })
        ]
      }
    ),
    r && o && /* @__PURE__ */ p.jsx(
      Qs,
      {
        retrievalToken: n,
        signedUrl: o.signed_url,
        fileName: o.filename,
        onClose: () => {
          a(!1), c();
        }
      }
    )
  ] });
}, l$ = ({
  title: e,
  amountDueInCents: n,
  refundInCents: r,
  paymentVoucherToken: a,
  paymentPortalUrl: o,
  wfRequestUuid: l,
  taxReturnFormId: d,
  requestStatus: c
}) => {
  const f = !!(o || a), s = r != null && r !== void 0, h = s ? r : (n || 0) * -1;
  return /* @__PURE__ */ p.jsxs(
    Pe,
    {
      alignItems: "center",
      justifyContent: "space-between",
      direction: "row",
      py: 2,
      height: 90,
      sx: { position: "relative" },
      children: [
        /* @__PURE__ */ p.jsx(Te, { children: e }),
        /* @__PURE__ */ p.jsxs(Pe, { direction: "row", alignItems: "center", gap: 1, children: [
          f && /* @__PURE__ */ p.jsx(
            i9,
            {
              paymentPortalUrl: o,
              paymentVoucherToken: a
            }
          ),
          /* @__PURE__ */ p.jsx(ih, { isRefund: s, amountInCents: h }),
          /* @__PURE__ */ p.jsx(
            Mk,
            {
              normalizedAmountInCents: h,
              isRefund: s,
              wfRequestUuid: l,
              taxReturnFormId: d,
              requestStatus: c
            }
          )
        ] })
      ]
    }
  );
}, Xk = tt(Pe)(({ theme: e }) => ({
  paddingRight: e.spacing(2),
  paddingLeft: e.spacing(2),
  paddingTop: e.spacing(1),
  paddingBottom: e.spacing(1)
})), Gc = ({
  amountInCents: e,
  dueDate: n,
  title: r
}) => /* @__PURE__ */ p.jsxs(Xk, { children: [
  /* @__PURE__ */ p.jsx(Te, { variant: "body1", children: r }),
  /* @__PURE__ */ p.jsx(Te, { variant: "body2", color: "#6a7881", children: nr({
    dateString: n,
    defaultPlaceholder: "-",
    outputFormat: "LLL dd, y"
  }) }),
  /* @__PURE__ */ p.jsx(Te, { variant: "h6", mt: 1, fontWeight: 600, children: js(e, "-") })
] }), Gk = ({
  estimatedPayment: e
}) => {
  const n = () => {
    e.payment_url ? window.open(e.payment_url, "_blank") : console.warn("No payment portal URL provided.");
  };
  return /* @__PURE__ */ p.jsxs(Pe, { children: [
    /* @__PURE__ */ p.jsxs(Pe, { direction: "row", alignItems: "center", justifyContent: "space-between", children: [
      /* @__PURE__ */ p.jsx(Te, { variant: "subtitle1", mt: 0.5, mb: 0.5, children: e.jurisdiction }),
      e.payment_url && /* @__PURE__ */ p.jsx(
        lt,
        {
          variant: "text",
          endIcon: /* @__PURE__ */ p.jsx(it, { icon: "chevronRight" }),
          onClick: n,
          size: "small",
          children: "Pay"
        }
      )
    ] }),
    /* @__PURE__ */ p.jsxs(Pe, { direction: "row", justifyContent: "space-between", children: [
      /* @__PURE__ */ p.jsx(
        Gc,
        {
          title: "Q1",
          amountInCents: e.q1_payment_estimate,
          dueDate: e.q1_due_date
        }
      ),
      /* @__PURE__ */ p.jsx(
        Gc,
        {
          title: "Q2",
          amountInCents: e.q2_payment_estimate,
          dueDate: e.q2_due_date
        }
      ),
      /* @__PURE__ */ p.jsx(
        Gc,
        {
          title: "Q3",
          amountInCents: e.q3_payment_estimate,
          dueDate: e.q3_due_date
        }
      ),
      /* @__PURE__ */ p.jsx(
        Gc,
        {
          title: "Q4",
          amountInCents: e.q4_payment_estimate,
          dueDate: e.q4_due_date
        }
      )
    ] })
  ] });
}, u$ = ({
  paymentEstimates: e
}) => /* @__PURE__ */ p.jsx(Pe, { gap: 1, children: e.map((n, r) => /* @__PURE__ */ p.jsxs(Nn.Fragment, { children: [
  r > 0 && /* @__PURE__ */ p.jsx(wn, { role: "separator" }),
  /* @__PURE__ */ p.jsx(Gk, { estimatedPayment: n })
] }, r)) }), d$ = (e) => (e.q1_payment_estimate ?? 0) !== 0 || (e.q2_payment_estimate ?? 0) !== 0 || (e.q3_payment_estimate ?? 0) !== 0 || (e.q4_payment_estimate ?? 0) !== 0, Kk = tt(bs)(({ theme: e, indent: n }) => ({
  padding: `${e.spacing(2)} 0`,
  ...n && { paddingLeft: e.spacing(3) }
})), Yk = ({
  title: e,
  description: n,
  retrievalToken: r,
  indent: a = !1
}) => {
  const [o, l] = Ee(!1), {
    signedUrlData: d,
    setRetrievalToken: c,
    refreshSignedUrl: f,
    clearSignedUrl: s
  } = es();
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsxs(Kk, { indent: a, children: [
      /* @__PURE__ */ p.jsx(Mn, { primary: e, secondary: n }),
      /* @__PURE__ */ p.jsx(
        lt,
        {
          variant: "text",
          startIcon: /* @__PURE__ */ p.jsx(it, { icon: "show" }),
          onClick: async () => {
            c(r), await f(), l(!0);
          },
          size: "small",
          children: "Preview"
        }
      )
    ] }),
    o && d && /* @__PURE__ */ p.jsx(
      Qs,
      {
        retrievalToken: r,
        signedUrl: d.signed_url,
        fileName: d.filename,
        onClose: () => {
          l(!1), s();
        }
      }
    )
  ] });
}, h$ = ({
  items: e
}) => /* @__PURE__ */ p.jsx(Gs, { disablePadding: !0, children: e.map((n, r) => /* @__PURE__ */ p.jsxs(Nn.Fragment, { children: [
  r !== 0 && /* @__PURE__ */ p.jsx(wn, {}),
  /* @__PURE__ */ p.jsx(
    Yk,
    {
      title: n.title,
      description: n.description,
      retrievalToken: n.retrievalToken,
      indent: n.indent
    },
    r
  )
] }, r)) }), zp = "workflowSignableDocumentDesktopErrorMessage", Zk = "In order to send, make sure you've added signers in the Client Signatures section.", Qk = (e, n, r, a) => {
  const o = a.some(
    (d) => d.uuid === e
  ), l = n === "sign-on-same-device" || !r || a.some((d) => d.uuid === n);
  return o && l;
}, Jk = (e, n, r, a = []) => {
  const { addValidationError: o, removeValidationError: l } = xi();
  ot(() => {
    !Qk(
      e,
      n,
      r,
      a
    ) ? o(zp, Zk) : l(zp);
  }, [
    o,
    e,
    r,
    l,
    a,
    n
  ]);
}, _c = () => {
  const { requestDetailSection: e, requestDetailQuestion: n } = _s(), { requestId: r, request: a, getFirstUnansweredQuestion: o, visibleSections: l } = xi(), d = Ki(), { sectionId: c, view: f } = m0(), s = (l == null ? void 0 : l.length) ?? 0, h = s ? s - 1 : 0, g = (l == null ? void 0 : l.findIndex((u) => u.id === c)) ?? -1, t = Tt(() => !(!c || g === -1 || g === h), [g, c, h]), i = Tt(() => !(!c || g === -1 || g === 0), [g, c]), m = Oe(() => {
    if (t && l) {
      const u = g + 1, I = l[u].id;
      d(`sections/${I}/`, { replace: !0 });
    }
  }, [t, d, g, l]), v = Oe(() => {
    if (i && l) {
      const u = g - 1, I = l[u].id;
      d(`sections/${I}/`, { replace: !0 });
    }
  }, [i, d, g, l]), E = Oe(
    (u) => {
      const I = o(u);
      I && d(
        (n == null ? void 0 : n.link({
          id: r,
          sectionId: I.sectionId,
          questionId: I.id
        })) ?? "/",
        { replace: !0 }
      );
    },
    [o, d, n, r]
  ), S = Oe(() => {
    const u = o();
    u && d(
      (e == null ? void 0 : e.link({
        id: r,
        sectionId: u.sectionId
      })) ?? "/"
    );
  }, [o, d, e, r]), y = f === "dispatch", x = Tt(
    () => (a == null ? void 0 : a.type) === b8.tax_delivery,
    [a]
  );
  return {
    hasNextSection: t,
    hasPreviousSection: i,
    navigateToTheNextSection: m,
    navigateToThePreviousSection: v,
    navigateToTheFirstUnansweredQuestion: E,
    navigateToTheFirstUnansweredSection: S,
    isDispatchView: y,
    isTaxDeliveryRequest: x,
    isTaxDeliveryDispatch: y && x
  };
}, is = (e, n, r) => {
  var a;
  if (e && e.length > 0) {
    const o = e == null ? void 0 : e.find((l) => l.label === n);
    switch (r) {
      case "contactId":
        return (o == null ? void 0 : o.label) === "spouse" && o.sign_on_same_device ? "sign-on-same-device" : ((a = o == null ? void 0 : o.contact) == null ? void 0 : a.uuid) || "";
      case "kbaRequired":
        return (o == null ? void 0 : o.kba_required) || !1;
      default:
        return (o == null ? void 0 : o.id) || "";
    }
  }
  return "";
}, eE = ({
  signers: e,
  disabled: n
}) => {
  const r = qn(), { mutate: a } = y8(), o = ut([]), [l, d] = Ee(!1), [c, f] = Ee(
    is(e, "tax_payer", "contactId")
  ), [s, h] = Ee(
    is(e, "spouse", "contactId")
  ), [g, t] = Ee(
    is(e, "tax_payer", "kbaRequired")
  ), [i, m] = Ee(
    is(e, "spouse", "kbaRequired")
  ), { requestId: v } = xi(), { isDispatchView: E } = _c(), { data: S } = f0(v), y = S == null ? void 0 : S.assigned_contacts, x = !!(e != null && e[1]);
  Jk(
    c,
    s,
    x,
    y
  );
  const b = Tt(
    () => y == null ? void 0 : y.reduce((_, A) => (_[A.uuid ?? ""] = `${A.first_name} ${A.last_name}`, _), {}),
    [y]
  ) || {};
  ot(() => {
    var _, A;
    if ((y == null ? void 0 : y.length) === 1 && !s && D(y[0].uuid ?? ""), o.current && ((_ = o.current) == null ? void 0 : _.length) > 0 && y && (y == null ? void 0 : y.length) > o.current.length && s === "") {
      const k = y.find(
        (z) => {
          var T;
          return !((T = o.current) != null && T.some((w) => w === z));
        }
      );
      K((k == null ? void 0 : k.uuid) || "", !1, !0);
    }
    if (o.current && ((A = o.current) == null ? void 0 : A.length) > 0 && y && (y == null ? void 0 : y.length) < o.current.length) {
      const k = o.current.find(
        (z) => !(y != null && y.some((T) => T === z))
      );
      c === (k == null ? void 0 : k.uuid) && D(""), s === (k == null ? void 0 : k.uuid) && K("", !1);
    }
    y != null && y.length && (o.current = y);
  }, [y]);
  const u = (_) => {
    const A = _.target.checked, k = is(e, "tax_payer", "id");
    k && (t(A), B({
      signerId: k,
      kba_required: A,
      contact_id: c || ""
    }));
  }, I = (_) => {
    const A = _.target.checked, k = is(e, "spouse", "id");
    k && (m(A), B({
      signerId: k,
      kba_required: A,
      contact_id: s || ""
    }));
  }, O = (_) => {
    const A = _.target.value || "";
    D(A);
  }, D = (_) => {
    f(_);
    const A = is(e, "tax_payer", "id");
    A && B({
      signerId: A,
      contact_id: _,
      sign_on_same_device: !1,
      kba_required: g
    });
  }, $ = (_) => {
    const A = _.target.value || "";
    let k = !1;
    A === "sign-on-same-device" && (k = !0), K(A, k);
  }, K = (_, A, k = !1) => {
    h(_);
    const z = is(e, "spouse", "id");
    z && B(
      {
        signerId: z,
        contact_id: _ === "sign-on-same-device" ? "" : _,
        sign_on_same_device: A,
        kba_required: i
      },
      {
        onSettled: () => {
          k && d(!0);
        }
      }
    );
  }, H = (_) => {
    if (c !== null && _) {
      if (_ === "sign-on-same-device") return "Sign on same device";
      const A = b[_];
      return A || "Select";
    }
    return c !== null && l ? (d(!1), b[s]) : b[s] || "Select";
  }, B = (_, A) => {
    a(
      { id: _.signerId, data: { ..._ } },
      {
        ...A,
        onSuccess: () => {
          r.invalidateQueries({
            queryKey: [v8(v)]
          });
        },
        onSettled: () => {
          var k;
          (k = A == null ? void 0 : A.onSettled) == null || k.call(A);
        }
      }
    );
  }, R = n && !E;
  return /* @__PURE__ */ p.jsxs(No, { gap: 2, width: "18rem", children: [
    /* @__PURE__ */ p.jsxs(Me, { "data-tour-id": "tax-delivery-first-signer", children: [
      /* @__PURE__ */ p.jsx(Te, { variant: "caption", mb: 1, children: "First Signer" }),
      /* @__PURE__ */ p.jsxs(No, { gap: 2, direction: "row", alignItems: "center", children: [
        /* @__PURE__ */ p.jsxs(
          g1,
          {
            displayEmpty: !0,
            renderValue: (_) => b[_] || "Select",
            onChange: O,
            disabled: R || !(y != null && y.length),
            defaultValue: c || void 0,
            fullWidth: !0,
            children: [
              /* @__PURE__ */ p.jsx(Rn, { children: "--" }),
              y == null ? void 0 : y.map((_) => {
                const A = `${_.first_name} ${_.last_name}`;
                return /* @__PURE__ */ p.jsx(
                  Rn,
                  {
                    disabled: _.uuid === s,
                    value: _.uuid,
                    children: A
                  },
                  _.uuid
                );
              })
            ]
          },
          c
        ),
        /* @__PURE__ */ p.jsx(
          gr,
          {
            control: /* @__PURE__ */ p.jsx(
              Hi,
              {
                checked: g,
                disabled: R || !c,
                onChange: u
              }
            ),
            sx: { alignItems: "center" },
            label: "KBA"
          }
        )
      ] })
    ] }),
    x && /* @__PURE__ */ p.jsxs(Me, { "data-tour-id": "tax-delivery-second-signer", children: [
      /* @__PURE__ */ p.jsx(Te, { variant: "caption", mb: 1, children: "Second Signer" }),
      /* @__PURE__ */ p.jsxs(No, { gap: 2, direction: "row", children: [
        /* @__PURE__ */ p.jsxs(
          g1,
          {
            displayEmpty: !0,
            renderValue: H,
            onChange: $,
            disabled: R || !(y != null && y.length) || c === null,
            defaultValue: s || void 0,
            fullWidth: !0,
            children: [
              /* @__PURE__ */ p.jsx(Rn, { children: "--" }),
              /* @__PURE__ */ p.jsx(Rn, { value: "sign-on-same-device", children: "Sign on same device" }),
              y == null ? void 0 : y.map((_) => {
                const A = `${_.first_name} ${_.last_name}`;
                return /* @__PURE__ */ p.jsx(
                  Rn,
                  {
                    disabled: _.uuid === c,
                    value: _.uuid,
                    children: A
                  },
                  _.uuid
                );
              })
            ]
          },
          s
        ),
        /* @__PURE__ */ p.jsx(
          gr,
          {
            control: /* @__PURE__ */ p.jsx(
              Hi,
              {
                disabled: R,
                checked: i,
                onChange: I
              }
            ),
            sx: { alignItems: "center" },
            label: "KBA"
          }
        )
      ] })
    ] })
  ] });
}, f$ = ({ retrievalToken: e }) => {
  const [n, r] = Ee(!1), {
    signedUrlData: a,
    setRetrievalToken: o,
    refreshSignedUrl: l,
    clearSignedUrl: d
  } = es();
  return e ? /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsx(
      lt,
      {
        variant: "text",
        startIcon: /* @__PURE__ */ p.jsx(it, { icon: "show" }),
        onClick: async () => {
          o(e), await l(), r(!0);
        },
        size: "small",
        children: "Preview"
      }
    ),
    n && a && /* @__PURE__ */ p.jsx(
      Qs,
      {
        retrievalToken: e,
        signedUrl: a.signed_url,
        fileName: a.filename,
        onClose: () => {
          r(!1), d();
        }
      }
    )
  ] }) : null;
}, tE = ["personal_information", "contact_information"], zf = (e) => tE.includes(e), rh = 3e3, nE = 100, iE = "8.5px", rE = "16.5px", r9 = {
  multiline: !0,
  minRows: 1,
  maxRows: 8,
  inputProps: { maxLength: rh }
}, s9 = (e) => ({
  "& .MuiInputBase-root.MuiInputBase-multiline": {
    padding: 0
  },
  "& .MuiInputBase-inputMultiline": {
    padding: `${e} 14px`
  }
}), a9 = ({ value: e, mt: n = -0.25 }) => e.length <= nE ? null : /* @__PURE__ */ p.jsxs(
  Te,
  {
    variant: "caption",
    color: e.length >= rh ? "error" : "text.secondary",
    sx: { textAlign: "right", mt: n },
    children: [
      e.length,
      " / ",
      rh
    ]
  }
);
var sE = /* @__PURE__ */ ((e) => (e.IOS = "ios", e.ANDROID = "android", e.WEB = "web", e))(sE || {}), us = /* @__PURE__ */ ((e) => (e.CLIENT = "client", e.FIRM = "firm", e))(us || {});
const aE = "Open your authenticator app (Google Authenticator, Authy, 1Password, etc.) and enter the 6-digit code shown.", p$ = "No active recipients are available. Add an active recipient to send this reply.";
var o9 = { exports: {} };
(function(e, n) {
  (function(r) {
    e.exports = r();
  })(function(r) {
    var a = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
    function o(S, y) {
      var x = S[0], b = S[1], u = S[2], I = S[3];
      x += (b & u | ~b & I) + y[0] - 680876936 | 0, x = (x << 7 | x >>> 25) + b | 0, I += (x & b | ~x & u) + y[1] - 389564586 | 0, I = (I << 12 | I >>> 20) + x | 0, u += (I & x | ~I & b) + y[2] + 606105819 | 0, u = (u << 17 | u >>> 15) + I | 0, b += (u & I | ~u & x) + y[3] - 1044525330 | 0, b = (b << 22 | b >>> 10) + u | 0, x += (b & u | ~b & I) + y[4] - 176418897 | 0, x = (x << 7 | x >>> 25) + b | 0, I += (x & b | ~x & u) + y[5] + 1200080426 | 0, I = (I << 12 | I >>> 20) + x | 0, u += (I & x | ~I & b) + y[6] - 1473231341 | 0, u = (u << 17 | u >>> 15) + I | 0, b += (u & I | ~u & x) + y[7] - 45705983 | 0, b = (b << 22 | b >>> 10) + u | 0, x += (b & u | ~b & I) + y[8] + 1770035416 | 0, x = (x << 7 | x >>> 25) + b | 0, I += (x & b | ~x & u) + y[9] - 1958414417 | 0, I = (I << 12 | I >>> 20) + x | 0, u += (I & x | ~I & b) + y[10] - 42063 | 0, u = (u << 17 | u >>> 15) + I | 0, b += (u & I | ~u & x) + y[11] - 1990404162 | 0, b = (b << 22 | b >>> 10) + u | 0, x += (b & u | ~b & I) + y[12] + 1804603682 | 0, x = (x << 7 | x >>> 25) + b | 0, I += (x & b | ~x & u) + y[13] - 40341101 | 0, I = (I << 12 | I >>> 20) + x | 0, u += (I & x | ~I & b) + y[14] - 1502002290 | 0, u = (u << 17 | u >>> 15) + I | 0, b += (u & I | ~u & x) + y[15] + 1236535329 | 0, b = (b << 22 | b >>> 10) + u | 0, x += (b & I | u & ~I) + y[1] - 165796510 | 0, x = (x << 5 | x >>> 27) + b | 0, I += (x & u | b & ~u) + y[6] - 1069501632 | 0, I = (I << 9 | I >>> 23) + x | 0, u += (I & b | x & ~b) + y[11] + 643717713 | 0, u = (u << 14 | u >>> 18) + I | 0, b += (u & x | I & ~x) + y[0] - 373897302 | 0, b = (b << 20 | b >>> 12) + u | 0, x += (b & I | u & ~I) + y[5] - 701558691 | 0, x = (x << 5 | x >>> 27) + b | 0, I += (x & u | b & ~u) + y[10] + 38016083 | 0, I = (I << 9 | I >>> 23) + x | 0, u += (I & b | x & ~b) + y[15] - 660478335 | 0, u = (u << 14 | u >>> 18) + I | 0, b += (u & x | I & ~x) + y[4] - 405537848 | 0, b = (b << 20 | b >>> 12) + u | 0, x += (b & I | u & ~I) + y[9] + 568446438 | 0, x = (x << 5 | x >>> 27) + b | 0, I += (x & u | b & ~u) + y[14] - 1019803690 | 0, I = (I << 9 | I >>> 23) + x | 0, u += (I & b | x & ~b) + y[3] - 187363961 | 0, u = (u << 14 | u >>> 18) + I | 0, b += (u & x | I & ~x) + y[8] + 1163531501 | 0, b = (b << 20 | b >>> 12) + u | 0, x += (b & I | u & ~I) + y[13] - 1444681467 | 0, x = (x << 5 | x >>> 27) + b | 0, I += (x & u | b & ~u) + y[2] - 51403784 | 0, I = (I << 9 | I >>> 23) + x | 0, u += (I & b | x & ~b) + y[7] + 1735328473 | 0, u = (u << 14 | u >>> 18) + I | 0, b += (u & x | I & ~x) + y[12] - 1926607734 | 0, b = (b << 20 | b >>> 12) + u | 0, x += (b ^ u ^ I) + y[5] - 378558 | 0, x = (x << 4 | x >>> 28) + b | 0, I += (x ^ b ^ u) + y[8] - 2022574463 | 0, I = (I << 11 | I >>> 21) + x | 0, u += (I ^ x ^ b) + y[11] + 1839030562 | 0, u = (u << 16 | u >>> 16) + I | 0, b += (u ^ I ^ x) + y[14] - 35309556 | 0, b = (b << 23 | b >>> 9) + u | 0, x += (b ^ u ^ I) + y[1] - 1530992060 | 0, x = (x << 4 | x >>> 28) + b | 0, I += (x ^ b ^ u) + y[4] + 1272893353 | 0, I = (I << 11 | I >>> 21) + x | 0, u += (I ^ x ^ b) + y[7] - 155497632 | 0, u = (u << 16 | u >>> 16) + I | 0, b += (u ^ I ^ x) + y[10] - 1094730640 | 0, b = (b << 23 | b >>> 9) + u | 0, x += (b ^ u ^ I) + y[13] + 681279174 | 0, x = (x << 4 | x >>> 28) + b | 0, I += (x ^ b ^ u) + y[0] - 358537222 | 0, I = (I << 11 | I >>> 21) + x | 0, u += (I ^ x ^ b) + y[3] - 722521979 | 0, u = (u << 16 | u >>> 16) + I | 0, b += (u ^ I ^ x) + y[6] + 76029189 | 0, b = (b << 23 | b >>> 9) + u | 0, x += (b ^ u ^ I) + y[9] - 640364487 | 0, x = (x << 4 | x >>> 28) + b | 0, I += (x ^ b ^ u) + y[12] - 421815835 | 0, I = (I << 11 | I >>> 21) + x | 0, u += (I ^ x ^ b) + y[15] + 530742520 | 0, u = (u << 16 | u >>> 16) + I | 0, b += (u ^ I ^ x) + y[2] - 995338651 | 0, b = (b << 23 | b >>> 9) + u | 0, x += (u ^ (b | ~I)) + y[0] - 198630844 | 0, x = (x << 6 | x >>> 26) + b | 0, I += (b ^ (x | ~u)) + y[7] + 1126891415 | 0, I = (I << 10 | I >>> 22) + x | 0, u += (x ^ (I | ~b)) + y[14] - 1416354905 | 0, u = (u << 15 | u >>> 17) + I | 0, b += (I ^ (u | ~x)) + y[5] - 57434055 | 0, b = (b << 21 | b >>> 11) + u | 0, x += (u ^ (b | ~I)) + y[12] + 1700485571 | 0, x = (x << 6 | x >>> 26) + b | 0, I += (b ^ (x | ~u)) + y[3] - 1894986606 | 0, I = (I << 10 | I >>> 22) + x | 0, u += (x ^ (I | ~b)) + y[10] - 1051523 | 0, u = (u << 15 | u >>> 17) + I | 0, b += (I ^ (u | ~x)) + y[1] - 2054922799 | 0, b = (b << 21 | b >>> 11) + u | 0, x += (u ^ (b | ~I)) + y[8] + 1873313359 | 0, x = (x << 6 | x >>> 26) + b | 0, I += (b ^ (x | ~u)) + y[15] - 30611744 | 0, I = (I << 10 | I >>> 22) + x | 0, u += (x ^ (I | ~b)) + y[6] - 1560198380 | 0, u = (u << 15 | u >>> 17) + I | 0, b += (I ^ (u | ~x)) + y[13] + 1309151649 | 0, b = (b << 21 | b >>> 11) + u | 0, x += (u ^ (b | ~I)) + y[4] - 145523070 | 0, x = (x << 6 | x >>> 26) + b | 0, I += (b ^ (x | ~u)) + y[11] - 1120210379 | 0, I = (I << 10 | I >>> 22) + x | 0, u += (x ^ (I | ~b)) + y[2] + 718787259 | 0, u = (u << 15 | u >>> 17) + I | 0, b += (I ^ (u | ~x)) + y[9] - 343485551 | 0, b = (b << 21 | b >>> 11) + u | 0, S[0] = x + S[0] | 0, S[1] = b + S[1] | 0, S[2] = u + S[2] | 0, S[3] = I + S[3] | 0;
    }
    function l(S) {
      var y = [], x;
      for (x = 0; x < 64; x += 4)
        y[x >> 2] = S.charCodeAt(x) + (S.charCodeAt(x + 1) << 8) + (S.charCodeAt(x + 2) << 16) + (S.charCodeAt(x + 3) << 24);
      return y;
    }
    function d(S) {
      var y = [], x;
      for (x = 0; x < 64; x += 4)
        y[x >> 2] = S[x] + (S[x + 1] << 8) + (S[x + 2] << 16) + (S[x + 3] << 24);
      return y;
    }
    function c(S) {
      var y = S.length, x = [1732584193, -271733879, -1732584194, 271733878], b, u, I, O, D, $;
      for (b = 64; b <= y; b += 64)
        o(x, l(S.substring(b - 64, b)));
      for (S = S.substring(b - 64), u = S.length, I = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], b = 0; b < u; b += 1)
        I[b >> 2] |= S.charCodeAt(b) << (b % 4 << 3);
      if (I[b >> 2] |= 128 << (b % 4 << 3), b > 55)
        for (o(x, I), b = 0; b < 16; b += 1)
          I[b] = 0;
      return O = y * 8, O = O.toString(16).match(/(.*?)(.{0,8})$/), D = parseInt(O[2], 16), $ = parseInt(O[1], 16) || 0, I[14] = D, I[15] = $, o(x, I), x;
    }
    function f(S) {
      var y = S.length, x = [1732584193, -271733879, -1732584194, 271733878], b, u, I, O, D, $;
      for (b = 64; b <= y; b += 64)
        o(x, d(S.subarray(b - 64, b)));
      for (S = b - 64 < y ? S.subarray(b - 64) : new Uint8Array(0), u = S.length, I = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], b = 0; b < u; b += 1)
        I[b >> 2] |= S[b] << (b % 4 << 3);
      if (I[b >> 2] |= 128 << (b % 4 << 3), b > 55)
        for (o(x, I), b = 0; b < 16; b += 1)
          I[b] = 0;
      return O = y * 8, O = O.toString(16).match(/(.*?)(.{0,8})$/), D = parseInt(O[2], 16), $ = parseInt(O[1], 16) || 0, I[14] = D, I[15] = $, o(x, I), x;
    }
    function s(S) {
      var y = "", x;
      for (x = 0; x < 4; x += 1)
        y += a[S >> x * 8 + 4 & 15] + a[S >> x * 8 & 15];
      return y;
    }
    function h(S) {
      var y;
      for (y = 0; y < S.length; y += 1)
        S[y] = s(S[y]);
      return S.join("");
    }
    h(c("hello")), typeof ArrayBuffer < "u" && !ArrayBuffer.prototype.slice && function() {
      function S(y, x) {
        return y = y | 0 || 0, y < 0 ? Math.max(y + x, 0) : Math.min(y, x);
      }
      ArrayBuffer.prototype.slice = function(y, x) {
        var b = this.byteLength, u = S(y, b), I = b, O, D, $, K;
        return x !== r && (I = S(x, b)), u > I ? new ArrayBuffer(0) : (O = I - u, D = new ArrayBuffer(O), $ = new Uint8Array(D), K = new Uint8Array(this, u, O), $.set(K), D);
      };
    }();
    function g(S) {
      return /[\u0080-\uFFFF]/.test(S) && (S = unescape(encodeURIComponent(S))), S;
    }
    function t(S, y) {
      var x = S.length, b = new ArrayBuffer(x), u = new Uint8Array(b), I;
      for (I = 0; I < x; I += 1)
        u[I] = S.charCodeAt(I);
      return y ? u : b;
    }
    function i(S) {
      return String.fromCharCode.apply(null, new Uint8Array(S));
    }
    function m(S, y, x) {
      var b = new Uint8Array(S.byteLength + y.byteLength);
      return b.set(new Uint8Array(S)), b.set(new Uint8Array(y), S.byteLength), b;
    }
    function v(S) {
      var y = [], x = S.length, b;
      for (b = 0; b < x - 1; b += 2)
        y.push(parseInt(S.substr(b, 2), 16));
      return String.fromCharCode.apply(String, y);
    }
    function E() {
      this.reset();
    }
    return E.prototype.append = function(S) {
      return this.appendBinary(g(S)), this;
    }, E.prototype.appendBinary = function(S) {
      this._buff += S, this._length += S.length;
      var y = this._buff.length, x;
      for (x = 64; x <= y; x += 64)
        o(this._hash, l(this._buff.substring(x - 64, x)));
      return this._buff = this._buff.substring(x - 64), this;
    }, E.prototype.end = function(S) {
      var y = this._buff, x = y.length, b, u = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], I;
      for (b = 0; b < x; b += 1)
        u[b >> 2] |= y.charCodeAt(b) << (b % 4 << 3);
      return this._finish(u, x), I = h(this._hash), S && (I = v(I)), this.reset(), I;
    }, E.prototype.reset = function() {
      return this._buff = "", this._length = 0, this._hash = [1732584193, -271733879, -1732584194, 271733878], this;
    }, E.prototype.getState = function() {
      return {
        buff: this._buff,
        length: this._length,
        hash: this._hash.slice()
      };
    }, E.prototype.setState = function(S) {
      return this._buff = S.buff, this._length = S.length, this._hash = S.hash, this;
    }, E.prototype.destroy = function() {
      delete this._hash, delete this._buff, delete this._length;
    }, E.prototype._finish = function(S, y) {
      var x = y, b, u, I;
      if (S[x >> 2] |= 128 << (x % 4 << 3), x > 55)
        for (o(this._hash, S), x = 0; x < 16; x += 1)
          S[x] = 0;
      b = this._length * 8, b = b.toString(16).match(/(.*?)(.{0,8})$/), u = parseInt(b[2], 16), I = parseInt(b[1], 16) || 0, S[14] = u, S[15] = I, o(this._hash, S);
    }, E.hash = function(S, y) {
      return E.hashBinary(g(S), y);
    }, E.hashBinary = function(S, y) {
      var x = c(S), b = h(x);
      return y ? v(b) : b;
    }, E.ArrayBuffer = function() {
      this.reset();
    }, E.ArrayBuffer.prototype.append = function(S) {
      var y = m(this._buff.buffer, S), x = y.length, b;
      for (this._length += S.byteLength, b = 64; b <= x; b += 64)
        o(this._hash, d(y.subarray(b - 64, b)));
      return this._buff = b - 64 < x ? new Uint8Array(y.buffer.slice(b - 64)) : new Uint8Array(0), this;
    }, E.ArrayBuffer.prototype.end = function(S) {
      var y = this._buff, x = y.length, b = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], u, I;
      for (u = 0; u < x; u += 1)
        b[u >> 2] |= y[u] << (u % 4 << 3);
      return this._finish(b, x), I = h(this._hash), S && (I = v(I)), this.reset(), I;
    }, E.ArrayBuffer.prototype.reset = function() {
      return this._buff = new Uint8Array(0), this._length = 0, this._hash = [1732584193, -271733879, -1732584194, 271733878], this;
    }, E.ArrayBuffer.prototype.getState = function() {
      var S = E.prototype.getState.call(this);
      return S.buff = i(S.buff), S;
    }, E.ArrayBuffer.prototype.setState = function(S) {
      return S.buff = t(S.buff, !0), E.prototype.setState.call(this, S);
    }, E.ArrayBuffer.prototype.destroy = E.prototype.destroy, E.ArrayBuffer.prototype._finish = E.prototype._finish, E.ArrayBuffer.hash = function(S, y) {
      var x = f(new Uint8Array(S)), b = h(x);
      return y ? v(b) : b;
    }, E;
  });
})(o9);
var oE = o9.exports;
const c9 = /* @__PURE__ */ ys(oE);
async function cE(e) {
  const n = await e.arrayBuffer(), r = new c9.ArrayBuffer();
  return r.append(n), btoa(r.end(!0));
}
function lE(e, n, r, a) {
  return new Promise((o, l) => {
    const d = new XMLHttpRequest();
    d.upload.onprogress = (c) => {
      c.lengthComputable && a(c.loaded / c.total * 100);
    }, d.onload = () => {
      d.status >= 200 && d.status < 300 ? o() : l(new Error(`Upload failed with status: ${d.status}`));
    }, d.onerror = () => {
      l(new Error("Upload failed due to network error"));
    }, d.open("PUT", e), Object.entries(r).forEach(([c, f]) => {
      d.setRequestHeader(c, f);
    }), d.send(n);
  });
}
const uE = () => {
  const [e, n] = Ee(0), [r, a] = Ee(!1), [o, l] = Ee(null), d = w8(), c = ux();
  return {
    uploadFile: Oe(
      async (s) => {
        var v;
        const { file: h, requestUuid: g, attachedTo: t, sectionId: i, itemId: m } = s;
        a(!0), n(0), l(null);
        try {
          const E = await cE(h), S = await d.mutateAsync({
            data: {
              blob: {
                filename: h.name,
                byte_size: h.size,
                checksum: E,
                content_type: h.type || "application/octet-stream"
              }
            }
          });
          if (!((v = S.direct_upload) != null && v.url) || !S.signed_id)
            throw new Error("Invalid direct upload response");
          n(20), await lE(
            S.direct_upload.url,
            h,
            S.direct_upload.headers || {},
            (x) => n(20 + x * 0.6)
          ), n(80);
          const y = await c.mutateAsync({
            requestUuid: g,
            data: {
              signed_blob_id: S.signed_id,
              attached_to: t,
              section_id: i,
              item_id: m
            }
          });
          return n(100), y.data;
        } catch (E) {
          const S = E instanceof Error ? E : new Error("Upload failed");
          throw l(S), S;
        } finally {
          a(!1);
        }
      },
      [d, c]
    ),
    isUploading: r,
    progress: e,
    error: o
  };
};
async function dE(e) {
  const n = await e.arrayBuffer(), r = new c9.ArrayBuffer();
  return r.append(n), btoa(r.end(!0));
}
function hE(e, n, r, a) {
  return new Promise((o, l) => {
    const d = new XMLHttpRequest();
    d.upload.onprogress = (c) => {
      c.lengthComputable && a(c.loaded / c.total * 100);
    }, d.onload = () => {
      d.status >= 200 && d.status < 300 ? o() : l(new Error(`Upload failed with status: ${d.status}`));
    }, d.onerror = () => {
      l(new Error("Upload failed due to network error"));
    }, d.open("PUT", e), Object.entries(r).forEach(([c, f]) => {
      d.setRequestHeader(c, f);
    }), d.send(n);
  });
}
const fE = () => {
  const [e, n] = Ee(0), [r, a] = Ee(!1), [o, l] = Ee(null), d = S8(), c = dx();
  return {
    uploadFile: Oe(
      async (s) => {
        var E;
        const { file: h, requestUuid: g, attachedTo: t, sectionId: i, itemId: m, receivedVia: v } = s;
        a(!0), n(0), l(null);
        try {
          const S = await dE(h), y = await d.mutateAsync({
            data: {
              blob: {
                filename: h.name,
                byte_size: h.size,
                checksum: S,
                content_type: h.type || "application/octet-stream"
              }
            }
          });
          if (!((E = y.direct_upload) != null && E.url) || !y.signed_id)
            throw new Error("Invalid direct upload response");
          n(20), await hE(
            y.direct_upload.url,
            h,
            y.direct_upload.headers || {},
            (b) => n(20 + b * 0.6)
          ), n(80);
          const x = await c.mutateAsync({
            requestUuid: g,
            data: {
              signed_blob_id: y.signed_id,
              attached_to: t,
              section_id: i,
              item_id: m,
              received_via: v
            }
          });
          return n(100), x.data;
        } catch (S) {
          const y = S instanceof Error ? S : new Error("Upload failed");
          throw l(y), y;
        } finally {
          a(!1);
        }
      },
      [d, c]
    ),
    isUploading: r,
    progress: e,
    error: o
  };
}, pE = () => {
  const { mutateAsync: e, isLoading: n } = ux();
  return {
    attachVaultDocument: Oe(
      async (a) => {
        const { documentId: o, requestUuid: l, attachedTo: d, sectionId: c, itemId: f } = a;
        try {
          return (await e({
            requestUuid: l,
            data: {
              document_id: o,
              attached_to: d,
              section_id: c,
              item_id: f
            }
          })).data;
        } catch (s) {
          throw console.error("Failed to attach document from vault:", s), s;
        }
      },
      [e]
    ),
    isAttaching: n
  };
}, gE = () => {
  const { mutateAsync: e, isLoading: n } = dx();
  return {
    attachVaultDocument: Oe(
      async (a) => {
        const { documentId: o, requestUuid: l, attachedTo: d, sectionId: c, itemId: f } = a;
        try {
          return (await e({
            requestUuid: l,
            data: {
              document_id: o,
              attached_to: d,
              section_id: c,
              item_id: f
            }
          })).data;
        } catch (s) {
          throw console.error("Failed to attach document from vault (firm):", s), s;
        }
      },
      [e]
    ),
    isAttaching: n
  };
}, mE = tt(tx)(({ theme: e }) => ({
  zIndex: e.zIndex.modal + 1,
  "& .MuiDrawer-paper": {
    backgroundColor: e.palette.common.white,
    color: e.palette.common.neutrals[500],
    height: "33%"
  }
}));
function l9({
  open: e,
  onClose: n,
  onScanDocument: r,
  onBrowseFiles: a,
  fileInputProps: o,
  fileInputTestId: l = "upload-file-input"
}) {
  return /* @__PURE__ */ p.jsxs(
    mE,
    {
      anchor: "bottom",
      open: e,
      onClose: n,
      onOpen: () => {
      },
      disableSwipeToOpen: !0,
      children: [
        /* @__PURE__ */ p.jsx(Pe, { p: 2, children: /* @__PURE__ */ p.jsx(Te, { color: "#8a939a", children: "Upload Files" }) }),
        /* @__PURE__ */ p.jsxs(
          Pe,
          {
            p: 2,
            gap: 3,
            sx: {
              backgroundColor: "#434566",
              color: "#f2f2f2",
              height: "100%"
            },
            children: [
              /* @__PURE__ */ p.jsxs(
                Pe,
                {
                  direction: "row",
                  onClick: r,
                  sx: { cursor: "pointer" },
                  children: [
                    /* @__PURE__ */ p.jsx(it, { icon: "camera" }),
                    /* @__PURE__ */ p.jsx(Te, { ml: 4, children: "Scan Document" })
                  ]
                }
              ),
              /* @__PURE__ */ p.jsxs(
                Pe,
                {
                  direction: "row",
                  onClick: a,
                  sx: { cursor: "pointer" },
                  children: [
                    /* @__PURE__ */ p.jsx(it, { icon: "uploadFile" }),
                    /* @__PURE__ */ p.jsx(Te, { ml: 4, children: "Browse Files" }),
                    o && /* @__PURE__ */ p.jsx("input", { "data-testid": l, ...o })
                  ]
                }
              )
            ]
          }
        )
      ]
    }
  );
}
function xE(e, n, r, a) {
  const o = Math.min(r / e, a / n);
  return { width: e * o, height: n * o };
}
const Hf = async (e) => {
  const n = new b7();
  (await Promise.all(
    e.map(async (d) => new Promise((c) => {
      const f = new Image();
      f.onload = function() {
        var m, v, E, S;
        const s = f == null ? void 0 : f.naturalWidth, h = f == null ? void 0 : f.naturalHeight, g = (v = (m = n == null ? void 0 : n.internal) == null ? void 0 : m.pageSize) == null ? void 0 : v.getHeight(), t = (S = (E = n == null ? void 0 : n.internal) == null ? void 0 : E.pageSize) == null ? void 0 : S.getWidth(), i = xE(
          s,
          h,
          t,
          g
        );
        c({
          base64: d,
          type: "JPEG",
          left: 0,
          top: 0,
          width: i.width,
          height: i.height
        });
      }, f.src = d;
    }))
  )).forEach((d, c) => {
    c !== 0 && n.addPage(), n.addImage(
      d.base64,
      d.type,
      d.left,
      d.top,
      d.width,
      d.height
    );
  });
  const a = `${Date.now()}-${Math.floor(Math.random() * 1e4)}.pdf`, o = n.output("blob");
  return new File([o], a, {
    lastModified: Date.now(),
    type: o.type
  });
}, bE = tt(Me)(({ theme: e }) => ({
  width: "100%",
  height: "95px",
  position: "fixed",
  bottom: 0,
  left: 0,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-end",
  background: "black",
  zIndex: e.zIndex.modal + 2
})), yE = tt(Me)(() => ({
  position: "fixed",
  left: 0,
  bottom: 0,
  height: ["-webkit-fill-available", "100vh"],
  width: "100vw",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 5e3,
  background: "rgba(255, 255, 255, .65)"
})), Hp = tt(Me)(() => ({
  height: "65%",
  alignSelf: "center",
  width: "35vw",
  margin: "10px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
})), vE = tt(Te)(() => ({
  borderRadius: "5px",
  background: "rgba(0, 0, 0, .3)",
  padding: "10px",
  marginBottom: "10px",
  color: "white"
}));
function wE({
  howManyPages: e,
  handleCancelClick: n = () => {
  },
  handleConfirmClick: r = () => {
  },
  showOverlay: a,
  newPagePreview: o
}) {
  return a ? o ? /* @__PURE__ */ p.jsxs(yE, { children: [
    /* @__PURE__ */ p.jsx(vE, { children: "Page Scanned" }),
    /* @__PURE__ */ p.jsx("img", { width: "80%", src: o, alt: "new page preview" })
  ] }) : /* @__PURE__ */ p.jsxs(bE, { children: [
    /* @__PURE__ */ p.jsx(Hp, { children: /* @__PURE__ */ p.jsx(
      Ei,
      {
        variant: "contained",
        size: "large",
        color: "error",
        onClick: n,
        children: "Cancel"
      }
    ) }),
    /* @__PURE__ */ p.jsx(Hp, { children: e > 0 && /* @__PURE__ */ p.jsxs(
      Ei,
      {
        onClick: r,
        variant: "contained",
        color: "primary",
        size: "large",
        children: [
          /* @__PURE__ */ p.jsxs(Me, { children: [
            e,
            " ",
            wx(e, "Page", "Pages")
          ] }),
          /* @__PURE__ */ p.jsx(it, { icon: "chevronRight" })
        ]
      }
    ) })
  ] }) : null;
}
const SE = ({ hasVideoAccessError: e, revokeVideoAccessError: n, onRetry: r }) => /* @__PURE__ */ p.jsx(ms, { open: e, children: /* @__PURE__ */ p.jsxs(Xr, { children: [
  /* @__PURE__ */ p.jsxs(
    Ya,
    {
      sx: {
        display: "flex",
        flexDirection: "column",
        gap: "30px",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "16px"
      },
      children: [
        /* @__PURE__ */ p.jsx(it, { icon: "videoSlash", sx: { width: "100px", height: "100px" } }),
        /* @__PURE__ */ p.jsx(Te, { variant: "h2", children: "Allow Liscio App access to your camera." }),
        /* @__PURE__ */ p.jsx(Te, { children: "To scan documents, please allow camera access when prompted" }),
        /* @__PURE__ */ p.jsxs(
          Me,
          {
            sx: {
              backgroundColor: "grey.100",
              borderRadius: 2,
              padding: 2,
              width: "100%"
            },
            children: [
              /* @__PURE__ */ p.jsx(Te, { color: "text.secondary", children: "If you previously denied access, you may need to:" }),
              /* @__PURE__ */ p.jsx(Te, { color: "text.secondary", sx: { mt: 1 }, children: "1. Tap the lock/settings icon in your browser's address bar" }),
              /* @__PURE__ */ p.jsx(Te, { color: "text.secondary", children: '2. Find "Camera" and change it to "Allow"' }),
              /* @__PURE__ */ p.jsx(Te, { color: "text.secondary", children: "3. Refresh the page and try again" })
            ]
          }
        )
      ]
    }
  ),
  /* @__PURE__ */ p.jsx(Zh, { children: /* @__PURE__ */ p.jsxs(No, { spacing: 1.5, width: "100%", children: [
    r && /* @__PURE__ */ p.jsx(
      Ei,
      {
        variant: "contained",
        onClick: r,
        fullWidth: !0,
        children: "Try Again"
      }
    ),
    /* @__PURE__ */ p.jsx(
      Ei,
      {
        variant: r ? "outlined" : "contained",
        onClick: n,
        fullWidth: !0,
        children: "Cancel"
      }
    )
  ] }) })
] }) }), _E = tt(Me, {
  shouldForwardProp: (e) => e !== "showScanner"
})(({ showScanner: e, theme: n }) => ({
  height: "100vh",
  width: "100vw",
  position: "fixed",
  left: 0,
  bottom: 0,
  zIndex: e ? n.zIndex.modal + 2 : -10,
  opacity: e ? "1" : "0"
})), CE = `osbx6//YvK6NgD9GpwEHg7muyeSm31NJeFoatp8MKiO6obZ1zXw9tAelzM7xHlflzNatGkFz+mOIaSZiqbZ1sgTH4SUWB4gTVpcUimOVXyXxs4xvpCxYmiUnNRaGf/+IZ4cvQTwr5S1aM36GhnnrydN64LFYbn7pQgcKCaZsu18q9B+8JiJSHCQyLerrojZ5OGyy9Pb5i4gCzzVP4dTKXKnGenZmodR7GnN+I1Fq0gwYTCJCQICGjuEtbEZuA7o5heAiSHTSjpjHi+9vu40vPoMX/lukSRCbIFvhV+tOin9bfcM4puaXKCUsCzqdn67TUoiDMVuHfS0Qtdsuug0jPA==
U2NhbmJvdFNESwoqLmxpc2Npb3N0YWdpbmcuY29tfCoubGlzY2lvLm1lfG0ubGlzY2lvc3RhZ2luZy5jb218bG9jYWxob3N0fG0ubGlzY2lvLm1lCjE4MzE1OTM1OTkKNTkwCjg=
`, Uu = "document-scanner-view", AE = {
  facingMode: { ideal: "environment" },
  width: { ideal: 1920 },
  height: { ideal: 1080 }
};
async function kE() {
  try {
    return !navigator.mediaDevices || !navigator.mediaDevices.getUserMedia ? (console.error("Camera API not available - requires HTTPS or localhost"), null) : await navigator.mediaDevices.getUserMedia({
      video: {
        facingMode: { ideal: "environment" }
      }
    });
  } catch (e) {
    return console.error("Camera permission request failed:", e), null;
  }
}
function EE(e) {
  e && e.getTracks().forEach((n) => n.stop());
}
const IE = ({
  children: e
}) => {
  const n = ut(), r = ut(), a = ut(), [o, l] = Ee(!1), [d, c] = Ee(
    []
  ), [f, s] = Ee(""), [h, g] = Ee(!1), [t, i] = Ee(!1), m = ut(), v = Oe(() => n.current ? Promise.resolve(n.current) : (r.current || (r.current = import("scanbot-web-sdk").then(
    ({ default: O }) => O.initialize({
      licenseKey: CE,
      engine: "/"
    })
  ).then((O) => (n.current = O, O)).catch((O) => {
    throw r.current = void 0, O;
  })), r.current), []), E = Oe(
    async (O, D) => {
      var K, H;
      (K = a == null ? void 0 : a.current) == null || K.disableAutoCapture(), (H = O.utils) == null || H.flash();
      const $ = await O.toDataUrl(D.cropped);
      s($ || ""), setTimeout(() => {
        var B;
        s(""), (B = a == null ? void 0 : a.current) == null || B.enableAutoCapture();
      }, 1800), c((B) => [
        ...B,
        {
          imgURL: $ || "",
          bytes: D.cropped
        }
      ]);
    },
    []
  ), S = Oe(async (O) => {
    a.current = await O.createDocumentScanner({
      containerId: Uu,
      videoConstraints: AE,
      onError: console.error,
      onDocumentDetected: (D) => E(O, D),
      autoCaptureEnabled: !0,
      acceptedAngleScore: 50,
      // default is 75
      acceptedSizeScore: 75
      // default is 80
    });
  }, [E]), y = Oe(() => {
    var O, D;
    (O = a == null ? void 0 : a.current) == null || O.disableAutoCapture(), (D = a == null ? void 0 : a.current) == null || D.dispose(), a.current = void 0, m.current = void 0, l(!1), c([]);
  }, []), x = Oe(() => {
    m.current && m.current(d.map((O) => O.imgURL)), y();
  }, [y, d]), b = Oe(
    async (O) => {
      var $, K, H;
      i(!0), m.current = O;
      try {
        const B = await kE();
        if (!B) {
          g(!0), i(!1);
          return;
        }
        EE(B);
        const R = await v();
        await S(R), l(!0);
      } catch (B) {
        console.error("Scanner initialization failed:", B), g(!0), i(!1), ($ = a == null ? void 0 : a.current) == null || $.disableAutoCapture(), (K = a == null ? void 0 : a.current) == null || K.dispose(), a.current = void 0, l(!1), c([]);
        return;
      }
      const D = document.querySelector(`#${Uu} svg`) || {};
      (H = D == null ? void 0 : D.style) != null && H.cssText && (D.style.cssText += "left: 0"), i(!1);
    },
    [v, S]
  ), u = Oe(() => {
    g(!1), m.current && b(m.current);
  }, [b]), I = Tt(() => ({
    open: b
  }), [b]);
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsx(Cc.Provider, { value: I, children: e }),
    /* @__PURE__ */ p.jsx(
      wE,
      {
        showOverlay: !t && !!o,
        handleCancelClick: y,
        handleConfirmClick: x,
        howManyPages: d.length,
        newPagePreview: f
      }
    ),
    /* @__PURE__ */ p.jsx(_E, { showScanner: o, id: Uu }),
    /* @__PURE__ */ p.jsx(mi, { open: t }),
    /* @__PURE__ */ p.jsx(
      SE,
      {
        hasVideoAccessError: h,
        revokeVideoAccessError: () => {
          g(!1);
        },
        onRetry: u
      }
    )
  ] });
}, TE = `AlavppXPRozeJS84uZuEyXPYQAX7TrQqiqoBKfEGSXL5qgLVCQdruAO+b7j2rgmYMppWb5kyXijwPj3mvRZ3+iY/JQG3hTztH7QCAR8oiNH/gCmUmlehKysjG8dUviRsaYVNyGKvrBSYczpsPNzUprR4WOzIgqxeXMxbs6CZY7WRM7S4xEOrLjqcrCw8G4fe48scs1rkVHD61r80Q4LDzT34o6AhgZ/hFgR1+7U8IloIHmt8GHPLyX/C9tVAE6AcBC9XWuLvxVq00YJGD1d8v3J0Z4etgSDgti8GYWUDtCfFcDKsCnKpcfgiQ73gsQZIP8jugLuTsAZW3YDvSlVZ/A==
U2NhbmJvdFNESwpjb20ubGlzY2lvLmRldnxjb20ubGlzY2lvLnVhdHxtZS5saXNjaW8ubGlzY2lvcHJvfGNvbS5saXNjaW9tb2JpbGUuYXBwCjE4MzE1MDc3OTAKNTkwCjI=
`, zu = "Document scanning is unavailable right now. Please upload a photo or file instead.";
function Hu(e, n, r) {
  const a = n, o = typeof (a == null ? void 0 : a.message) == "string" ? a.message : "Unknown error", l = typeof (a == null ? void 0 : a.status) == "string" ? a.status : void 0;
  return r(new Error(`Scanbot SDK ${e} failed: ${o}`), {
    status: l,
    message: o
  }), o;
}
const OE = ({
  children: e,
  onError: n,
  onLicenseInfo: r,
  showLicenseStatus: a
}) => {
  const o = ut(!1), l = ut(!1), d = ut();
  Pa(() => {
    if (!o.current) {
      o.current = !0;
      const s = _1.promisify();
      s.initializeSdk({
        loggingEnabled: !0,
        licenseKey: TE,
        storageImageFormat: "JPG",
        storageImageQuality: 80
      }).catch((h) => {
        const g = Hu("initialization", h, n);
        /license key is invalid/i.test(g) && (l.current = !0, d.current = g);
      }).then(async () => {
        try {
          const {
            isLicenseValid: h,
            licenseStatus: g,
            licenseExpirationDate: t
          } = await s.getLicenseInfo(), i = {
            isLicenseValid: h,
            licenseStatus: g,
            licenseExpirationDate: t
          };
          r(i), h || (l.current || n(new Error(`Scanbot SDK license invalid: ${g}`), i), l.current = !0, d.current || (d.current = g));
        } catch (h) {
          if (!l.current) {
            const g = Hu("license lookup", h, n);
            /license key is invalid/i.test(g) && (l.current = !0, d.current = g);
          }
        }
      });
    }
  }, [n, r]);
  const c = Oe(
    async (s) => {
      if (l.current) {
        rn.error(
          a && d.current ? `${zu} (${d.current})` : zu,
          { id: "scanbot-unavailable" }
        );
        return;
      }
      const h = _1.promisify();
      let g;
      try {
        g = await h.UI.startDocumentScanner({
          uiConfigs: {
            cameraPreviewMode: "FIT_IN",
            pageCounterButtonTitle: "%d Page(s)",
            multiPageEnabled: !0,
            acceptedAngleScore: 50,
            // default is 75
            acceptedSizeScore: 75
            // default is 80
          }
        });
      } catch (t) {
        Hu("document scan", t, n), rn.error(zu, { id: "scanbot-unavailable" });
        return;
      }
      g && g.pages && g.pages.length > 0 && s(
        g.pages.map(
          (t) => On.convertFileSrc(t.documentImageFileUri || "")
        )
      );
    },
    [n, a]
  ), f = Tt(() => ({
    open: c
  }), [c]);
  return /* @__PURE__ */ p.jsx(Cc.Provider, { value: f, children: e });
};
var sh;
(function(e) {
  e.Base64 = "base64", e.ImageFilePath = "imageFilePath";
})(sh || (sh = {}));
var ah;
(function(e) {
  e.Success = "success", e.Cancel = "cancel";
})(ah || (ah = {}));
const FE = xx("DocumentScanner", {
  web: () => import("./web-DMYDZTFo.js").then((e) => new e.DocumentScannerWeb())
}), PE = ({
  children: e
}) => {
  const n = Oe(
    async (a) => {
      const { scannedImages: o, status: l } = await FE.scanDocument({
        responseType: sh.ImageFilePath
      });
      l === ah.Success && o && a(o.map(On.convertFileSrc));
    },
    []
  ), r = Tt(() => ({
    open: n
  }), [n]);
  return /* @__PURE__ */ p.jsx(Cc.Provider, { value: r, children: e });
}, u9 = {
  open: () => {
    console.error("unsupported platform");
  }
}, Cc = Jr(u9), g$ = ({
  children: e,
  onError: n,
  onLicenseInfo: r,
  showLicenseStatus: a
}) => {
  const o = On.getPlatform();
  return o === "web" ? /* @__PURE__ */ p.jsx(IE, { children: e }) : o === "android" ? /* @__PURE__ */ p.jsx(
    OE,
    {
      onError: n,
      onLicenseInfo: r,
      showLicenseStatus: a,
      children: e
    }
  ) : o === "ios" ? /* @__PURE__ */ p.jsx(PE, { children: e }) : /* @__PURE__ */ p.jsx(Cc.Provider, { value: u9 });
};
function jE() {
  return xs(Cc);
}
const Wf = ({ onScan: e }) => {
  const n = jE();
  return {
    open: () => {
      n.open(e);
    }
  };
}, Zr = {
  bgcolor: "background.paper",
  border: 1,
  borderColor: "divider",
  borderRadius: 3
}, rr = 44, RE = { large: 54, regular: 44 }, ME = { large: 19, regular: 17 }, DE = 84, NE = () => {
  var e;
  return (e = window.matchMedia) != null && e.call(window, "(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
}, d9 = {
  minHeight: rr,
  minWidth: rr,
  px: 0.25,
  fontSize: (e) => e.typography.pxToRem(16),
  fontWeight: 600,
  color: "common.secondary.700",
  textDecoration: "underline",
  verticalAlign: "baseline"
};
function LE({
  rootProps: e,
  onBrowse: n,
  onVaultClick: r,
  vaultDisabled: a = !1,
  disabled: o = !1,
  children: l
}) {
  const { isMobile: d } = ri(), c = ({
    label: f,
    onClick: s,
    unavailable: h
  }) => h ? /* @__PURE__ */ p.jsx(Me, { component: "span", sx: { color: "text.disabled" }, children: f }) : /* @__PURE__ */ p.jsx(
    Ii,
    {
      component: "button",
      type: "button",
      onClick: s,
      sx: d9,
      children: f
    }
  );
  return /* @__PURE__ */ p.jsxs(
    S5,
    {
      ...e,
      role: "group",
      "aria-label": "Add organizer files",
      sx: {
        minHeight: rr,
        p: 0,
        px: 1,
        flexWrap: "wrap",
        columnGap: 0.5,
        borderColor: "common.neutrals.300",
        borderRadius: 1,
        color: "common.neutrals.800",
        fontSize: (f) => f.typography.pxToRem(16)
      },
      children: [
        l,
        /* @__PURE__ */ p.jsx(it, { icon: "upload", sx: { color: "inherit" } }),
        /* @__PURE__ */ p.jsx("span", { children: d ? "Add from" : "Drop files to attach," }),
        c({
          label: "Liscio Vault",
          onClick: r,
          unavailable: o || a
        }),
        /* @__PURE__ */ p.jsx("span", { children: "or" }),
        c({
          label: "Browse",
          onClick: n,
          unavailable: o
        })
      ]
    }
  );
}
function BE({
  filename: e,
  caption: n,
  onOpen: r,
  onRemove: a,
  disabled: o = !1
}) {
  return /* @__PURE__ */ p.jsxs(
    Pe,
    {
      direction: "row",
      "data-testid": "organizer-file-row",
      sx: {
        alignItems: "center",
        gap: 1,
        minHeight: rr,
        minWidth: 0,
        maxWidth: "100%",
        boxSizing: "border-box",
        px: 1.5,
        py: 0.5,
        borderRadius: 1,
        bgcolor: "common.success.50"
      },
      children: [
        /* @__PURE__ */ p.jsx(it, { icon: "check", sx: { color: "success.dark", flexShrink: 0 } }),
        /* @__PURE__ */ p.jsxs(
          Me,
          {
            component: r ? "button" : "span",
            type: r ? "button" : void 0,
            onClick: r,
            sx: {
              // Zero basis width keeps a long filename from widening the page on phones.
              flex: 1,
              width: 0,
              minWidth: 0,
              minHeight: rr,
              py: 0.5,
              px: 0,
              border: 0,
              background: "none",
              font: "inherit",
              color: "text.primary",
              textAlign: "left",
              cursor: r ? "pointer" : "default"
            },
            children: [
              /* @__PURE__ */ p.jsx(
                Te,
                {
                  component: "span",
                  sx: {
                    display: "block",
                    fontSize: "inherit",
                    overflowWrap: "anywhere"
                  },
                  children: e
                }
              ),
              n && /* @__PURE__ */ p.jsx(
                Te,
                {
                  component: "span",
                  variant: "caption",
                  sx: {
                    display: "block",
                    color: "common.neutrals.700",
                    overflowWrap: "anywhere"
                  },
                  children: n
                }
              )
            ]
          }
        ),
        a && /* @__PURE__ */ p.jsx(
          Ii,
          {
            component: "button",
            type: "button",
            disabled: o,
            onClick: a,
            sx: { ...d9, flexShrink: 0 },
            children: "Remove"
          }
        )
      ]
    }
  );
}
const $E = Qa(
  (e, n) => ({
    // Initial state
    requestId: "",
    sections: [],
    currentSectionId: null,
    currentFieldIndex: 0,
    isEditing: !1,
    editingSectionId: null,
    dirtyFields: /* @__PURE__ */ new Set(),
    validationErrors: {},
    isSaving: !1,
    appType: us.CLIENT,
    // Default to 'client', should be set by parent component
    // Actions
    setSections: (r) => {
      e({ sections: r });
    },
    setCurrentSectionId: (r) => {
      e({ currentSectionId: r });
      const o = n().sections.find((l) => l.id === r);
      o && "currentFieldIndex" in o ? e({ currentFieldIndex: o.currentFieldIndex }) : e({ currentFieldIndex: 0 });
    },
    setCurrentFieldIndex: (r) => e({ currentFieldIndex: r }),
    setIsEditing: (r) => e({ isEditing: r }),
    setEditingSectionId: (r) => e({ editingSectionId: r }),
    markFieldDirty: (r) => {
      const a = new Set(n().dirtyFields);
      a.add(r), e({ dirtyFields: a });
    },
    clearDirtyFields: () => e({ dirtyFields: /* @__PURE__ */ new Set() }),
    setValidationError: (r, a) => {
      const o = { ...n().validationErrors };
      a ? o[r] = a : delete o[r], e({ validationErrors: o });
    },
    clearValidationErrors: () => e({ validationErrors: {} }),
    setIsSaving: (r) => e({ isSaving: r }),
    setAppType: (r) => e({ appType: r }),
    updateGroupedSectionField: (r, a, o) => {
      const l = n().sections.map((d) => {
        if (d.id === r && "fields" in d) {
          const c = d;
          return {
            ...c,
            fields: c.fields.map(
              (f) => f.id === a ? { ...f, value: o } : f
            )
          };
        }
        return d;
      });
      e({ sections: l }), n().markFieldDirty(a);
    },
    updateSingleEntryField: (r, a, o) => {
      const l = n().sections.map((d) => {
        if (d.id === r && "fields" in d) {
          const c = d, f = o != null && (typeof o == "boolean" || typeof o == "string" && o.trim() !== "" || !!o);
          return {
            ...c,
            fields: c.fields.map(
              (s) => s.id === a ? { ...s, value: o, isComplete: f } : s
            )
          };
        }
        return d;
      });
      e({ sections: l }), n().markFieldDirty(a);
    },
    confirmGroupedSectionFields: (r, a) => {
      const o = n().sections.map((l) => {
        if (l.id === r && "fields" in l) {
          const d = l;
          return {
            ...d,
            fields: d.fields.map(
              (c) => a.includes(c.id) ? { ...c, is_confirmed: !0 } : c
            )
          };
        }
        return l;
      });
      e({ sections: o });
    },
    confirmSingleEntryField: (r, a) => {
      const o = n().sections.map((l) => {
        if (l.id === r && "fields" in l) {
          const d = l;
          return {
            ...d,
            fields: d.fields.map(
              (c) => c.id === a ? { ...c, is_confirmed: !0 } : c
            )
          };
        }
        return l;
      });
      e({ sections: o });
    }
  })
), UE = Uy(
  () => Promise.resolve().then(() => kN)
), zE = 2048 * 1024 * 1024, Wp = (e, n) => e === us.FIRM || n.uploaded_by_role !== "firm", h9 = ({
  appType: e,
  onBusyChange: n,
  requestUuid: r,
  sectionId: a,
  itemId: o,
  disabled: l = !1,
  locked: d = !1,
  allAttachments: c,
  onAttachmentsChange: f,
  onNotApplicable: s,
  onUndoNotApplicable: h,
  isNotApplicable: g = !1,
  variant: t = "default"
}) => {
  const i = t === "organizer", m = $E((Ae) => Ae.appType), v = e ?? m, E = uE(), S = fE(), y = pE(), x = gE(), { uploadFile: b, isUploading: u, progress: I } = v === us.FIRM ? S : E, { attachVaultDocument: O, isAttaching: D } = v === us.FIRM ? x : y, $ = _8(), K = C8(), { mutateAsync: H, isLoading: B } = v === us.FIRM ? K : $, { isMobile: R } = ri(), [_, A] = Ee(!1), [k, z] = Ee(!1), T = Tt(
    () => c.filter(
      (Ae) => Ae.section_id === a && Ae.item_id === o && Ae.file_name && Ae.content_type
    ),
    [c, a, o]
  ), [w, F] = Ee([]), [j, P] = Ee(null), [V, J] = Ee(!1), [ne, Z] = Ee(!1), [te, G] = Ee(!1), N = u || D || B || w.length > 0 || !!j || V || ne || te;
  ot(() => (n == null || n(N), () => n == null ? void 0 : n(!1)), [N, n]);
  const q = Oe(async () => {
    Z(!0);
    try {
      await f();
    } catch {
      rn.error("Unable to refresh attachments. Please reload before submitting.");
    } finally {
      Z(!1);
    }
  }, [f]), [ie, oe] = Ee(null), [fe, Y] = Ee(null), [ae, se] = Ee(null), {
    signedUrlData: L,
    setRetrievalToken: W,
    refreshSignedUrl: M,
    clearSignedUrl: X
  } = es();
  ot(() => {
    if (w.length === 0 || j)
      return;
    const Ae = w[0];
    P(Ae), F((Se) => Se.slice(1)), b({
      file: Ae,
      requestUuid: r,
      attachedTo: "section_item",
      sectionId: a,
      itemId: o
    }).then((Se) => {
      Se && !i && rn.success(`${Ae.name} uploaded successfully`);
    }).catch(() => {
      rn.error(`Failed to upload ${Ae.name}`);
    }).finally(async () => {
      try {
        await q();
      } finally {
        P(null);
      }
    });
  }, [w.length, j]);
  const U = Oe(
    (Ae) => {
      F((Se) => [...Se, Ae]);
    },
    []
  ), Q = Oe(
    (Ae, Se) => {
      Se.forEach((De) => {
        const Be = De.errors.map((ke) => ke.message).join(", ");
        rn.error(`${De.file.name}: ${Be}`);
      }), Ae.forEach((De) => {
        U(De);
      });
    },
    [U]
  ), { getRootProps: re, getInputProps: le, open: ce } = fc({
    onDrop: Q,
    noClick: !0,
    noDragEventsBubbling: !0,
    accept: vc,
    maxSize: zE,
    disabled: l || u,
    multiple: !0
    // Allow multiple file uploads
  }), { open: ee } = Wf({
    onScan: (Ae) => {
      G(!0), Hf(Ae).then(U).catch(() => rn.error("Failed to prepare scanned document")).finally(() => G(!1));
    }
  }), he = Oe(() => {
    ee(), A(!1);
  }, [ee]), pe = Oe(() => {
    ce(), A(!1);
  }, [ce]), de = Oe(() => {
    R ? A(!0) : ce();
  }, [R, ce]), ge = Oe(async () => {
    if (ie)
      try {
        await H({ id: ie.id }), i || rn.success(`${ie.file_name} deleted`), await q();
      } catch {
        rn.error("Failed to delete attachment");
      } finally {
        oe(null);
      }
  }, [ie, H, q, i]), me = Oe(
    async (Ae) => {
      if (Ae.length === 0) return;
      J(!0);
      let Se = 0, De = 0;
      for (const Be of Ae)
        try {
          await O({
            documentId: Be.id,
            requestUuid: r,
            attachedTo: "section_item",
            sectionId: a,
            itemId: o
          }), Se += 1;
        } catch (ke) {
          De += 1;
          const be = Be.doc_name ?? `document ${Be.id}`;
          console.error("Failed to attach document from vault:", be, Be.id, ke);
        }
      try {
        await q();
      } finally {
        J(!1);
      }
      Se > 0 ? De === 0 ? (i || rn.success(`${Se} file(s) attached from Liscio Vault`), z(!1)) : rn.error(
        `${Se} file(s) attached; ${De} could not be attached.`
      ) : De > 0 && rn.error("Failed to attach documents from Liscio Vault");
    },
    [O, r, a, o, q, i]
  ), xe = Oe(
    async (Ae) => {
      var Se, De;
      try {
        let Be = Ae.retrieval_token;
        !Be && Ae.id && (v === us.FIRM ? Be = ((Se = (await A8(Ae.id)).data) == null ? void 0 : Se.retrieval_token) ?? null : Be = ((De = (await k8(Ae.id)).data) == null ? void 0 : De.retrieval_token) ?? null), Be ? (Y(Ae), se(Be), W(Be), await M()) : Ae.download_url && window.open(Ae.download_url, "_blank");
      } catch (Be) {
        console.error("Failed to fetch attachment details:", Be), Ae.download_url ? window.open(Ae.download_url, "_blank") : rn.error("Failed to open attachment");
      }
    },
    [v, W, M]
  ), ye = l || u || D || j !== null, ve = l || u || D, Ce = (Ae) => !l && !d && Wp(v, Ae), Ie = Tt(() => {
    const Ae = [];
    return T.forEach((Se) => {
      const De = Se.uploaded_by_role === "firm", Be = !l && Wp(v, Se);
      Ae.push({
        key: Se.id,
        filename: De ? /* @__PURE__ */ p.jsxs(Pe, { direction: "column", gap: 0, children: [
          /* @__PURE__ */ p.jsx("span", { children: Se.file_name }),
          /* @__PURE__ */ p.jsx(Te, { variant: "caption", color: "common.neutrals.700", children: "Uploaded by firm" })
        ] }) : Se.file_name,
        mimeType: Se.content_type ?? void 0,
        size: Se.file_size ?? void 0,
        onCancel: Be ? () => oe(Se) : void 0,
        onClick: () => xe(Se)
      });
    }), j && Ae.push({
      key: `uploading-${j.name}-${j.size}`,
      filename: j.name,
      mimeType: j.type,
      size: j.size,
      progress: I
    }), w.forEach((Se) => {
      Ae.push({
        key: `queued-${Se.name}-${Se.size}`,
        filename: Se.name,
        mimeType: Se.type,
        size: Se.size,
        progress: 0
        // Not started yet
      });
    }), Ae;
  }, [
    T,
    v,
    j,
    w,
    I,
    l,
    xe
  ]);
  return g ? /* @__PURE__ */ p.jsxs(
    Me,
    {
      "data-testid": "marked-not-applicable",
      sx: {
        p: 1.5,
        borderRadius: 1,
        backgroundColor: "grey.100",
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        opacity: 0.6
        // Faded appearance to look disabled
      },
      children: [
        /* @__PURE__ */ p.jsx(
          Me,
          {
            sx: {
              width: 24,
              height: 24,
              borderRadius: "50%",
              backgroundColor: "success.light",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0
            },
            children: /* @__PURE__ */ p.jsx(
              Te,
              {
                variant: "body2",
                sx: {
                  color: "success.contrastText",
                  fontSize: "0.875rem",
                  fontWeight: "bold"
                },
                children: "✓"
              }
            )
          }
        ),
        /* @__PURE__ */ p.jsx(Te, { variant: "body2", sx: { flex: 1, color: "text.secondary" }, children: "Marked as Not Applicable" }),
        h && /* @__PURE__ */ p.jsx(
          Ii,
          {
            component: "button",
            type: "button",
            onClick: h,
            disabled: l,
            sx: {
              cursor: l ? "not-allowed" : "pointer",
              textDecoration: "none",
              fontSize: "0.875rem",
              color: "primary.main",
              "&:hover": {
                textDecoration: "underline"
              },
              "&:disabled": {
                opacity: 0.5
              }
            },
            children: "Undo"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsxs(Me, { children: [
      i ? /* @__PURE__ */ p.jsxs(Pe, { sx: { gap: 1, minWidth: 0 }, children: [
        !d && /* @__PURE__ */ p.jsx(
          LE,
          {
            rootProps: re(),
            onBrowse: de,
            onVaultClick: () => z(!0),
            vaultDisabled: ye,
            disabled: ve,
            children: /* @__PURE__ */ p.jsx("input", { "data-testid": "rfi-file-attachments-input", ...le() })
          }
        ),
        T.map((Ae) => /* @__PURE__ */ p.jsx(
          BE,
          {
            filename: Ae.file_name ?? "",
            caption: Ae.uploaded_by_role === "firm" ? "Uploaded by firm" : void 0,
            onOpen: () => xe(Ae),
            onRemove: Ce(Ae) ? () => oe(Ae) : void 0
          },
          Ae.id
        )),
        Ie.filter((Ae) => Ae.progress !== void 0).map(({ key: Ae, ...Se }) => /* @__PURE__ */ p.jsx(d0, { ...Se }, Ae))
      ] }) : /* @__PURE__ */ p.jsx(
        Xo,
        {
          ...re(),
          onBrowse: de,
          onVaultClick: () => z(!0),
          vaultDisabled: ye,
          attachments: Ie,
          disabled: ve,
          children: /* @__PURE__ */ p.jsx("input", { "data-testid": "rfi-file-attachments-input", ...le() })
        }
      ),
      s && T.length === 0 && !j && w.length === 0 && /* @__PURE__ */ p.jsx(Me, { sx: { mt: 1, display: "flex", justifyContent: "flex-start" }, children: /* @__PURE__ */ p.jsx(
        Ii,
        {
          component: "button",
          type: "button",
          onClick: s,
          disabled: l || u || D || j !== null,
          sx: {
            cursor: l || u || D ? "not-allowed" : "pointer",
            textDecoration: "none",
            fontSize: "0.875rem",
            "&:hover": {
              textDecoration: "underline"
            },
            "&:disabled": {
              opacity: 0.5
            }
          },
          children: "Mark as 'Not Applicable'"
        }
      ) })
    ] }),
    /* @__PURE__ */ p.jsx(
      l9,
      {
        open: _,
        onClose: () => A(!1),
        onScanDocument: he,
        onBrowseFiles: pe,
        fileInputTestId: "rfi-mobile-file-input"
      }
    ),
    k && /* @__PURE__ */ p.jsx(zy, { fallback: null, children: /* @__PURE__ */ p.jsx(
      UE,
      {
        open: k,
        onClose: () => z(!1),
        onAttach: me,
        variant: v === us.FIRM ? "firm" : "client"
      }
    ) }),
    /* @__PURE__ */ p.jsx(
      oi,
      {
        open: !!ie,
        onClose: () => oe(null),
        title: "Delete Attachment",
        submitLabel: "Yes",
        onSubmit: ge,
        cancelLabel: "No",
        onCancel: () => oe(null),
        submitBtnProps: { disabled: B },
        children: /* @__PURE__ */ p.jsxs(Te, { children: [
          "You are about to delete the attached file",
          " ",
          /* @__PURE__ */ p.jsx("b", { children: ie == null ? void 0 : ie.file_name }),
          ". This action cannot be undone. Proceed?"
        ] })
      }
    ),
    fe && L && /* @__PURE__ */ p.jsx(
      Qs,
      {
        retrievalToken: ae || void 0,
        signedUrl: L.signed_url || null,
        fileName: L.filename || fe.file_name || null,
        onClose: () => {
          Y(null), se(null), X();
        }
      }
    )
  ] });
};
function Ac(e, n) {
  if (!e || !e.field)
    return !0;
  const r = e.operator || "equals", a = e.value;
  return typeof n == "boolean" && typeof a == "boolean" || typeof n == "string" && typeof a == "string" || typeof n == "number" && typeof a == "number" ? r === "equals" ? n === a : n !== a : n == null ? a == null : n === a;
}
const f9 = ({
  sectionId: e,
  field: n,
  fieldValues: r,
  localFieldValues: a,
  isEditing: o,
  disabled: l = !1,
  hasSingleItem: d,
  hasPrefilledFields: c,
  readOnly: f,
  requestUuid: s,
  allAttachments: h,
  onAttachmentsChange: g,
  handleFieldChange: t,
  handleFieldBlur: i,
  onNotApplicable: m,
  onUndoNotApplicable: v,
  alternateValue: E,
  alternateValueLabel: S,
  firmEditable: y = !1,
  getAlternateValue: x
}) => {
  var R;
  const b = n.conditional_items && n.conditional_items.length > 0, u = r[n.id], O = !zf(e) || (d || !c) && !f || y, D = l0(), $ = o ? {
    variant: "body2",
    fontWeight: 500,
    color: l && n.type === "text" ? "text.secondary" : void 0
  } : {
    variant: "caption",
    fontWeight: 400,
    color: "text.secondary"
  }, K = n.type === "boolean" ? r[n.id] : a[n.id] ?? r[n.id], B = Tt(() => {
    if (E == null || K == null) return !1;
    if (n.type === "boolean") {
      const _ = String(E) === "true", A = String(K) === "true";
      return _ !== A;
    }
    return String(K) !== String(E);
  }, [E, K, n.type]) ? n.type === "boolean" ? E === !0 || E === "true" ? "Yes" : E === !1 || E === "false" ? "No" : String(E) : String(E) : null;
  return /* @__PURE__ */ p.jsxs(Pe, { id: `field-${n.id}`, spacing: o ? 0.5 : 0.25, children: [
    /* @__PURE__ */ p.jsxs(Te, { ...$, children: [
      n.label,
      n.required && /* @__PURE__ */ p.jsx("span", { style: { color: "#d32f2f", fontSize: "1.75em", verticalAlign: "middle" }, children: " *" })
    ] }),
    n.help_text && /* @__PURE__ */ p.jsx(Te, { variant: "caption", color: "text.secondary", children: n.help_text }),
    o ? n.type === "boolean" ? /* @__PURE__ */ p.jsxs(Pe, { direction: "row", spacing: 3, alignItems: "center", children: [
      /* @__PURE__ */ p.jsx(
        gr,
        {
          control: /* @__PURE__ */ p.jsx(
            Vo,
            {
              checked: r[n.id] === !0,
              onChange: () => t(n.id, !0),
              disabled: l,
              size: "small"
            }
          ),
          label: "Yes",
          labelPlacement: "end",
          sx: {
            alignItems: "center",
            margin: 0,
            "& .MuiFormControlLabel-label": {
              marginLeft: "8px"
            }
          }
        }
      ),
      /* @__PURE__ */ p.jsx(
        gr,
        {
          control: /* @__PURE__ */ p.jsx(
            Vo,
            {
              checked: r[n.id] === !1,
              onChange: () => t(n.id, !1),
              disabled: l,
              size: "small"
            }
          ),
          label: "No",
          labelPlacement: "end",
          sx: {
            alignItems: "center",
            margin: 0,
            "& .MuiFormControlLabel-label": {
              marginLeft: "8px"
            }
          }
        }
      )
    ] }) : n.type === "file" ? /* @__PURE__ */ p.jsx(
      h9,
      {
        requestUuid: s,
        sectionId: n.sectionId,
        itemId: n.id,
        disabled: l,
        allAttachments: h,
        onAttachmentsChange: g,
        onNotApplicable: m ? () => m(n.sectionId, n.id) : void 0,
        onUndoNotApplicable: v ? () => v(n.sectionId, n.id) : void 0,
        isNotApplicable: n.status === "not_applicable"
      }
    ) : /* @__PURE__ */ p.jsx(
      vi,
      {
        value: O ? a[n.id] || "" : r[n.id] || "",
        onChange: (_) => t(n.id, _.target.value),
        onBlur: () => i(n.id),
        disabled: l,
        type: n.type === "date" ? "date" : "text",
        fullWidth: !0,
        size: "small",
        ...n.type === "text" ? r9 : {},
        sx: {
          ...s9(iE),
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: D.palette.text.primary
          }
        }
      }
    ) : /* @__PURE__ */ p.jsx(Te, { variant: "body1", color: "text.primary", fontWeight: 400, children: n.type === "boolean" ? n.value === !0 || n.value === "true" ? "Yes" : n.value === !1 || n.value === "false" ? "No" : "—" : n.type === "file" ? n.value ? "File uploaded" : "—" : n.value || "—" }),
    o && n.type === "text" && !l && !f && /* @__PURE__ */ p.jsx(
      a9,
      {
        value: O ? a[n.id] || "" : String(r[n.id] || "")
      }
    ),
    B && /* @__PURE__ */ p.jsxs(
      Te,
      {
        component: "span",
        variant: "body2",
        color: "text.secondary",
        sx: {
          mt: 0.5,
          pl: 1,
          py: 0.5,
          borderLeft: `3px solid ${D.palette.warning.main}`,
          backgroundColor: D.palette.warning.light + "20",
          lineHeight: 1.4
        },
        children: [
          S,
          /* @__PURE__ */ p.jsx(
            Te,
            {
              component: "span",
              variant: "body2",
              color: "text.primary",
              sx: { fontWeight: 400 },
              children: B
            }
          )
        ]
      }
    ),
    b && ((R = n.conditional_items) == null ? void 0 : R.map((_) => Ac(
      _.show_if,
      u
    ) ? /* @__PURE__ */ p.jsx(Pe, { spacing: 0.5, sx: { pl: 3, mt: 1 }, children: /* @__PURE__ */ p.jsx(
      f9,
      {
        sectionId: e,
        field: _,
        fieldValues: r,
        localFieldValues: a,
        isEditing: o,
        disabled: l,
        hasSingleItem: d,
        hasPrefilledFields: c,
        readOnly: f,
        requestUuid: s,
        allAttachments: h,
        onAttachmentsChange: g,
        handleFieldChange: t,
        handleFieldBlur: i,
        onNotApplicable: m,
        onUndoNotApplicable: v,
        alternateValue: x == null ? void 0 : x(_.id),
        alternateValueLabel: S,
        firmEditable: y,
        getAlternateValue: x
      }
    ) }, _.id) : null))
  ] }, n.id);
}, HE = ({
  isEditing: e,
  isSaving: n,
  hasChanges: r,
  isSectionConfirmed: a,
  areAllFieldsCompleted: o,
  section: l,
  disabled: d = !1,
  shouldShowButtons: c,
  onEdit: f,
  onSave: s,
  onClose: h,
  onConfirm: g
}) => c ? /* @__PURE__ */ p.jsx(
  Pe,
  {
    direction: { xs: "column", sm: "row" },
    spacing: { xs: 1.5, sm: 2 },
    sx: { mt: 2 },
    children: e ? (
      // Multi-item sections: Show Save and Close
      /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
        /* @__PURE__ */ p.jsx(
          lt,
          {
            variant: "contained",
            onClick: s,
            disabled: d || n || !r,
            startIcon: /* @__PURE__ */ p.jsx(it, { icon: "check" }),
            sx: { width: { xs: "100%", sm: "auto" } },
            children: "Save"
          }
        ),
        /* @__PURE__ */ p.jsx(
          lt,
          {
            variant: "outlined",
            onClick: h,
            disabled: d || n,
            startIcon: /* @__PURE__ */ p.jsx(it, { icon: "close" }),
            sx: { width: { xs: "100%", sm: "auto" } },
            children: "Close"
          }
        )
      ] })
    ) : (
      // View mode: Show Confirm and Edit
      /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
        /* @__PURE__ */ p.jsx(
          lt,
          {
            variant: a ? "contained" : "outlined",
            onClick: g,
            disabled: d || !l.isEditable || a || o,
            startIcon: /* @__PURE__ */ p.jsx(it, { icon: "check" }),
            color: a ? "success" : "primary",
            sx: { width: { xs: "100%", sm: "auto" } },
            children: a ? "Confirmed" : "Confirm"
          }
        ),
        /* @__PURE__ */ p.jsx(
          lt,
          {
            variant: "outlined",
            onClick: f,
            disabled: d || !l.isEditable,
            startIcon: /* @__PURE__ */ p.jsx(it, { icon: "pencil" }),
            sx: { width: { xs: "100%", sm: "auto" } },
            children: "Edit"
          }
        )
      ] })
    )
  }
) : null, oh = (e, n) => {
  for (const r of e) {
    if (r.id === n)
      return r;
    if (r.conditional_items && r.conditional_items.length > 0) {
      const a = oh(r.conditional_items, n);
      if (a)
        return a;
    }
  }
}, WE = ({
  sectionId: e,
  fields: n,
  onSave: r,
  hasSingleItem: a,
  hasPrefilledFields: o,
  readOnly: l,
  initialFieldValuesRef: d,
  setFieldValue: c,
  setLocalFieldValue: f,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  fieldValues: s,
  // Not used in handleFieldBlur (we compare against initialFieldValuesRef instead)
  localFieldValues: h,
  firmEditable: g = !1
}) => {
  const t = ut({}), i = zf(e), m = !l && (!i || a || !o || g), v = Oe(
    (x) => {
      Object.keys(x).length !== 0 && (Object.entries(x).forEach(([b, u]) => {
        d.current[b] = u, c(b, u), typeof u == "string" && f(b, u);
      }), r(e, x).catch((b) => {
        console.error("Error auto-saving field:", b);
        const u = p0(b) || "Failed to save changes";
        rn.error(u), Object.entries(x).forEach(([I]) => {
          const O = d.current[I];
          c(I, O), typeof O == "string" && f(I, O);
        });
      }));
    },
    [
      e,
      r,
      d,
      c,
      f
    ]
  ), E = Oe(
    (x, b) => {
      const u = oh(n, x);
      m ? (u == null ? void 0 : u.type) === "boolean" ? v({ [x]: b }) : (u == null ? void 0 : u.type) !== "file" && (f(x, b), t.current[x] = !0) : c(x, b);
    },
    [n, m, v, f, c]
  ), S = Oe(
    (x) => {
      if (m) {
        const b = oh(n, x);
        if (b && b.type !== "boolean" && b.type !== "file") {
          const u = h[x] || null, I = d.current[x] ?? null;
          u !== I && (v({ [x]: u }), t.current[x] = !1);
        }
      }
    },
    [n, m, h, d, v]
  ), y = Oe(() => {
    t.current = {};
  }, []);
  return {
    handleAutoSave: v,
    handleFieldChange: E,
    handleFieldBlur: S,
    clearPendingChanges: y
  };
}, qp = (e) => e.some((n) => {
  const r = n.value;
  return r == null || r === "" ? !1 : typeof r == "boolean" ? !0 : typeof r == "string" ? r.trim() !== "" : !0;
}), qE = ({
  sectionId: e,
  fields: n,
  hasSingleItem: r,
  readOnly: a,
  firmEditable: o = !1
}) => {
  const l = zf(e), d = Tt(
    () => qp(n),
    [n]
  ), [c, f] = Ee(
    o || !l || !d || r || a
  ), s = ut(d), h = ut(r), g = ut(a), t = ut(l), i = ut(o), m = ut(!0);
  ot(() => {
    if (m.current) {
      m.current = !1, s.current = d, h.current = r, g.current = a, t.current = l, i.current = o;
      return;
    }
    const y = qp(n), x = s.current !== y, b = h.current !== r, u = g.current !== a, I = t.current !== l, O = i.current !== o;
    if (s.current = y, h.current = r, g.current = a, t.current = l, i.current = o, O && o) {
      f(!0);
      return;
    }
    if (!l) {
      f(!0);
      return;
    }
    (x || b || u || I) && !a && !r && f(!y);
  }, [n, r, a, l, d, o]);
  const v = Oe(() => {
    f(!0);
  }, []), E = Oe(() => {
    f(!1);
  }, []);
  return {
    isEditing: c,
    setIsEditing: f,
    enterEditMode: v,
    exitEditMode: E,
    shouldShowButtons: l && !a && !r && d && !o,
    hasPrefilledFields: d
  };
}, p9 = (e, n) => {
  for (const r of e)
    n[r.id] = r.value, r.conditional_items && r.conditional_items.length > 0 && p9(r.conditional_items, n);
  return n;
}, VE = (e) => e == null ? !1 : typeof e == "string" ? e.trim() !== "" : !0, XE = ({ fields: e }) => {
  const n = Oe(() => p9(e, {}), [e]), r = ut(
    n()
  ), [a, o] = Ee(
    n()
  ), [l, d] = Ee(
    Object.fromEntries(
      Object.entries(n()).map(([t, i]) => [
        t,
        typeof i == "string" ? i : ""
      ])
    )
  ), c = ut(l);
  c.current = l;
  const f = Oe(() => {
    const t = n(), i = r.current, m = { ...t };
    Object.keys(i).forEach((E) => {
      const S = i[E], y = t[E];
      if (S !== y && S !== void 0) {
        const x = c.current[E];
        typeof S == "string" && x !== void 0 && S === x ? m[E] = S : VE(y) || (m[E] = S);
      }
    }), r.current = m, o(m);
    const v = Object.fromEntries(
      Object.entries(m).map(([E, S]) => [
        E,
        typeof S == "string" ? S : ""
      ])
    );
    d(v), c.current = v;
  }, [n]), s = Oe(() => {
    const t = n();
    r.current = t, o(t);
    const i = Object.fromEntries(
      Object.entries(t).map(([m, v]) => [
        m,
        typeof v == "string" ? v : ""
      ])
    );
    d(i);
  }, [n]), h = Oe((t, i) => {
    o((m) => ({
      ...m,
      [t]: i
    }));
  }, []), g = Oe((t, i) => {
    d((m) => ({
      ...m,
      [t]: i
    }));
  }, []);
  return {
    fieldValues: a,
    localFieldValues: l,
    initialFieldValuesRef: r,
    getInitialValues: n,
    setFieldValue: h,
    setLocalFieldValue: g,
    resetValues: s,
    syncWithSection: f
  };
}, GE = [
  "personal_information",
  "contact_information",
  "document_request_list"
], m$ = ({
  section: e,
  onSave: n,
  onConfirm: r,
  disabled: a = !1,
  readOnly: o = !1,
  requestUuid: l,
  allAttachments: d,
  onAttachmentsChange: c,
  pendingReview: f = !1,
  onNotApplicable: s,
  onUndoNotApplicable: h,
  firmEditable: g = !1,
  onFirmSave: t,
  getAlternateValue: i,
  alternateValueLabel: m
}) => {
  const v = o && !g, E = f && GE.includes(e.id), S = Tt(() => E ? e.fields.length > 0 && e.fields.every((ie) => ie.type === "file") ? { ...e, fields: [] } : {
    ...e,
    fields: e.fields.map((ie) => {
      var oe;
      return {
        ...ie,
        value: null,
        conditional_items: (oe = ie.conditional_items) == null ? void 0 : oe.map((fe) => ({
          ...fe,
          value: null
        }))
      };
    })
  } : e, [e, E]), {
    fieldValues: y,
    localFieldValues: x,
    initialFieldValuesRef: b,
    setFieldValue: u,
    setLocalFieldValue: I,
    resetValues: O,
    syncWithSection: D
  } = XE({ fields: S.fields }), [$, K] = Ee(!1), H = e.fields.length === 1, {
    isEditing: B,
    setIsEditing: R,
    enterEditMode: _,
    exitEditMode: A,
    shouldShowButtons: k,
    hasPrefilledFields: z
  } = qE({
    sectionId: e.id,
    fields: e.fields,
    hasSingleItem: H,
    readOnly: v,
    firmEditable: g
  }), T = g && t ? t : n, { handleFieldChange: w, handleFieldBlur: F, clearPendingChanges: j } = WE({
    sectionId: e.id,
    fields: e.fields,
    onSave: T,
    hasSingleItem: H,
    hasPrefilledFields: z,
    readOnly: v,
    initialFieldValuesRef: b,
    setFieldValue: u,
    setLocalFieldValue: I,
    fieldValues: y,
    localFieldValues: x,
    firmEditable: g
  }), P = Object.keys(y).some((q) => {
    const ie = y[q], oe = b.current[q];
    return ie !== oe;
  });
  process.env.NODE_ENV === "development" && console.log("GroupedSectionForm render:", {
    sectionId: e.id,
    sectionTitle: e.title,
    isEditable: e.isEditable,
    isEditing: B,
    hasSingleItem: H,
    disabled: a,
    fieldsCount: e.fields.length
  }), ot(() => {
    D(), j();
  }, [D, j]), ot(() => {
    !B && !H && z && O();
  }, [B, H, z, O]);
  const V = async () => {
    const q = e.fields.map((ie) => ie.id);
    r && await r(e.id, q, y);
  }, J = () => {
    O(), H || A();
  }, ne = () => {
    _();
  }, Z = async () => {
    K(!0);
    try {
      b.current = { ...y }, await new Promise((q) => setTimeout(q, 500)), await T(e.id, y), rn.success(`${e.title} saved successfully`), H || R(!1);
    } catch (q) {
      console.error("Error saving grouped section:", q);
      const ie = p0(q) || "Failed to save changes. Please try again.";
      rn.error(ie);
    } finally {
      K(!1);
    }
  }, te = Oe(
    (q) => {
      if (q.status === "completed" || q.status === "not_applicable")
        return !0;
      const ie = y[q.id] ?? q.value;
      return q.type === "boolean" ? ie != null : q.type === "text" || q.type === "date" ? ie != null && String(ie).trim() !== "" : q.type === "file" ? !!ie : !1;
    },
    [y]
  ), G = Tt(() => {
    const q = (ie, oe) => {
      if (!te(ie))
        return !1;
      if (ie.conditional_items && ie.conditional_items.length > 0) {
        const fe = oe ?? y[ie.id] ?? ie.value;
        if (!ie.conditional_items.filter(
          (se) => se.show_if ? Ac(
            se.show_if,
            fe
          ) : !0
        ).every(
          (se) => q(se, fe)
        ))
          return !1;
      }
      return !0;
    };
    return e.fields.every((ie) => q(ie));
  }, [e.fields, y, te]), N = e.fields.every(
    (q) => q.is_confirmed === !0
  );
  return /* @__PURE__ */ p.jsx(
    hc,
    {
      variant: "outlined",
      sx: {
        p: { xs: 2, sm: 3 },
        // Smaller padding on mobile
        mb: 2,
        width: "100%"
      },
      children: /* @__PURE__ */ p.jsxs(Pe, { spacing: 2, children: [
        /* @__PURE__ */ p.jsxs(Me, { display: "flex", alignItems: "center", gap: 2, children: [
          /* @__PURE__ */ p.jsx(
            Te,
            {
              variant: "h6",
              sx: { fontSize: { xs: "1.1rem", sm: "1.25rem" } },
              children: e.title
            }
          ),
          E && /* @__PURE__ */ p.jsx(
            fr,
            {
              label: "Pending Liscio Review",
              color: "warning",
              size: "medium",
              variant: "outlined"
            }
          )
        ] }),
        S.fields.map((q) => /* @__PURE__ */ p.jsx(
          f9,
          {
            sectionId: e.id,
            field: q,
            fieldValues: y,
            localFieldValues: x,
            isEditing: B,
            disabled: a,
            hasSingleItem: H,
            hasPrefilledFields: z,
            readOnly: v,
            requestUuid: l,
            allAttachments: d,
            onAttachmentsChange: c,
            handleFieldChange: w,
            handleFieldBlur: F,
            onNotApplicable: s,
            onUndoNotApplicable: h,
            alternateValue: i == null ? void 0 : i(q.id),
            alternateValueLabel: m,
            firmEditable: g,
            getAlternateValue: i
          },
          q.id
        )),
        /* @__PURE__ */ p.jsx(
          HE,
          {
            isEditing: B,
            isSaving: $,
            hasChanges: P,
            isSectionConfirmed: N,
            areAllFieldsCompleted: G,
            section: e,
            disabled: a,
            shouldShowButtons: k,
            onEdit: ne,
            onSave: Z,
            onClose: J,
            onConfirm: V
          }
        )
      ] })
    }
  );
}, KE = ({
  field: e,
  // currentIndex is kept for API compatibility but not directly used in this component's rendering
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  currentIndex: n,
  totalFields: r,
  onValueChange: a,
  disabled: o = !1,
  readOnly: l = !1,
  parentFieldValue: d,
  requestUuid: c,
  allAttachments: f,
  onAttachmentsChange: s,
  onNotApplicable: h,
  onUndoNotApplicable: g
}) => {
  var O;
  const [t, i] = Ee(
    typeof e.value == "string" ? e.value : ""
  ), [m, v] = Ee(
    typeof e.value == "boolean" ? e.value : null
  ), E = ut(!1), S = ut(null), y = l0();
  if (ot(() => {
    i(typeof e.value == "string" ? e.value : ""), v(typeof e.value == "boolean" ? e.value : null), E.current = !1;
  }, [e.value]), ot(() => {
    E.current && e.type !== "boolean" && e.type !== "file" && (S.current && clearTimeout(S.current), S.current = setTimeout(() => {
      const D = t || null;
      D !== (e.value || null) && (a(e.id, D), E.current = !1), S.current = null;
    }, 100));
  }, [d]), ot(() => () => {
    S.current && clearTimeout(S.current);
  }, []), e.show_if && d !== void 0 && !Ac(e.show_if, d))
    return null;
  const x = (D) => {
    l || (e.type === "boolean" ? (v(D), a(e.id, D)) : (i(D), E.current = !0));
  }, b = () => {
    if (!l && e.type !== "boolean" && e.type !== "file") {
      const D = t || null;
      D !== (e.value || null) && (a(e.id, D), E.current = !1);
    }
  }, u = () => e.type === "boolean" ? e.value === !0 ? "Yes" : e.value === !1 ? "No" : "—" : e.type === "file" ? e.value ? "File uploaded" : "—" : e.value || "—", I = e.conditional_items && e.conditional_items.length > 0;
  return /* @__PURE__ */ p.jsx(Me, { id: `field-${e.id}`, children: /* @__PURE__ */ p.jsxs(Pe, { spacing: 1, children: [
    /* @__PURE__ */ p.jsxs(
      Te,
      {
        variant: "body1",
        fontWeight: 500,
        color: o && e.type === "text" ? "text.secondary" : void 0,
        children: [
          e.numberLabel,
          ". ",
          e.prompt,
          e.required && /* @__PURE__ */ p.jsx("span", { style: { color: "#d32f2f", fontSize: "1.75em", verticalAlign: "middle" }, children: " *" })
        ]
      }
    ),
    e.hint && /* @__PURE__ */ p.jsx(Te, { variant: "body2", color: "text.secondary", children: e.hint }),
    e.type === "boolean" ? /* @__PURE__ */ p.jsxs(Pe, { direction: "row", spacing: 3, alignItems: "center", children: [
      /* @__PURE__ */ p.jsx(
        gr,
        {
          control: /* @__PURE__ */ p.jsx(
            Vo,
            {
              checked: m === !0,
              onChange: () => x(!0),
              disabled: o || l,
              size: "small"
            }
          ),
          label: "Yes",
          labelPlacement: "end",
          sx: {
            alignItems: "center",
            margin: 0,
            "& .MuiFormControlLabel-label": {
              marginLeft: "8px"
            }
          }
        }
      ),
      /* @__PURE__ */ p.jsx(
        gr,
        {
          control: /* @__PURE__ */ p.jsx(
            Vo,
            {
              checked: m === !1,
              onChange: () => x(!1),
              disabled: o || l,
              size: "small"
            }
          ),
          label: "No",
          labelPlacement: "end",
          sx: {
            alignItems: "center",
            margin: 0,
            "& .MuiFormControlLabel-label": {
              marginLeft: "8px"
            }
          }
        }
      )
    ] }) : l ? /* @__PURE__ */ p.jsx(Te, { variant: "body1", color: "text.secondary", children: u() }) : e.type === "file" ? /* @__PURE__ */ p.jsx(
      h9,
      {
        requestUuid: c,
        sectionId: e.sectionId,
        itemId: e.id,
        disabled: o,
        allAttachments: f,
        onAttachmentsChange: s,
        onNotApplicable: h ? () => h(e.sectionId, e.id) : void 0,
        onUndoNotApplicable: g ? () => g(e.sectionId, e.id) : void 0,
        isNotApplicable: e.status === "not_applicable"
      }
    ) : /* @__PURE__ */ p.jsx(
      vi,
      {
        value: t,
        onChange: (D) => x(D.target.value),
        onBlur: b,
        disabled: o,
        fullWidth: !0,
        ...r9,
        placeholder: "Enter your answer...",
        sx: {
          ...s9(rE),
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: y.palette.text.primary
          }
        }
      }
    ),
    e.type === "text" && !o && !l && /* @__PURE__ */ p.jsx(a9, { value: t, mt: -0.5 }),
    I && ((O = e.conditional_items) == null ? void 0 : O.map((D) => /* @__PURE__ */ p.jsx(Me, { sx: { pl: 3, mt: 1 }, children: /* @__PURE__ */ p.jsx(
      KE,
      {
        field: D,
        currentIndex: parseInt(D.numberLabel, 10),
        totalFields: r,
        onValueChange: a,
        disabled: o,
        readOnly: l,
        parentFieldValue: e.type === "boolean" ? m : e.value,
        requestUuid: c,
        allAttachments: f,
        onAttachmentsChange: s
      }
    ) }, D.id)))
  ] }) });
};
function x$(e) {
  return "fields" in e && e.fields.length > 0 && "isEditable" in e;
}
function b$(e) {
  return "fields" in e && e.fields.length > 0 && "numberLabel" in e.fields[0];
}
const YE = [
  "personal_information",
  "contact_information",
  "document_request_list",
  "form_1040_2025"
];
function ZE(e, n) {
  return YE.includes(e.id) ? !0 : n <= 15;
}
function g9(e, n) {
  return n === "firm" ? e.firm_value ?? e.client_value ?? e.ai_value ?? null : e.client_value ?? e.firm_value ?? e.ai_value ?? null;
}
function m9(e, n, r = "client") {
  const a = g9(e, r);
  let o = null;
  a != null && (typeof a == "boolean" || typeof a == "string" ? o = a : o = String(a));
  let l = "text";
  e.type === "boolean" ? l = "boolean" : e.type === "date" ? l = "date" : e.type === "file" && (l = "file");
  const d = [];
  e.conditional_items && e.conditional_items.length > 0 && d.push(
    ...e.conditional_items.map(
      (f) => m9(f, n, r)
    )
  );
  const c = e.status === "completed" || e.status === "not_applicable" || e.status === "pending" ? e.status : void 0;
  return {
    id: e.id,
    label: e.label,
    value: o,
    type: l,
    sectionId: n,
    requestItemId: e.id,
    is_confirmed: !1,
    // TODO: Add confirmation status from API if available
    required: e.required ?? !1,
    help_text: e.help_text ?? null,
    status: c,
    conditional_items: d.length > 0 ? d : void 0,
    show_if: e.show_if ? {
      field: e.show_if.field,
      value: e.show_if.value,
      operator: e.show_if.operator
    } : null
  };
}
function x9(e, n, r, a = "client") {
  const o = g9(e, a);
  let l = null;
  o != null && (typeof o == "boolean" || typeof o == "string" ? l = o : l = String(o));
  let d = "text";
  e.type === "boolean" ? d = "boolean" : e.type === "file" && (d = "file");
  const c = [];
  e.conditional_items && e.conditional_items.length > 0 && c.push(
    ...e.conditional_items.map(
      (h, g) => x9(h, n, r + g + 1, a)
    )
  );
  const f = e.status === "completed" || e.status === "not_applicable" || e.status === "pending" ? e.status : void 0, s = f === "completed" || f === "not_applicable" ? !0 : o != null;
  return {
    id: e.id,
    numberLabel: String(r + 1),
    prompt: e.label,
    hint: e.help_text ?? null,
    value: l,
    type: d,
    sectionId: n,
    requestItemId: e.id,
    isComplete: s,
    is_confirmed: !1,
    // TODO: Add confirmation status from API if available
    required: e.required ?? !1,
    status: f,
    conditional_items: c.length > 0 ? c : void 0,
    show_if: e.show_if ? {
      field: e.show_if.field,
      value: e.show_if.value,
      operator: e.show_if.operator
    } : null
  };
}
function Vp(e, n, r, a = 0, o = "client") {
  const l = [];
  let d = a;
  for (const c of e)
    r ? l.push(m9(c, n, o)) : (l.push(x9(c, n, d, o)), d++);
  return { fields: l, index: d };
}
function y$(e, n = {}) {
  const { appType: r = "client" } = n, a = [];
  for (const o of e) {
    const l = o.items || [], d = l.length;
    if (ZE(o, d)) {
      const { fields: f } = Vp(l, o.id, !0, 0, r), s = {
        id: o.id,
        title: o.title,
        fields: f,
        isEditable: !0
      };
      a.push(s);
    } else {
      const { fields: f, index: s } = Vp(l, o.id, !1, 0, r), h = {
        id: o.id,
        title: o.title,
        fields: f,
        currentFieldIndex: 0,
        totalFields: s
      };
      a.push(h);
    }
  }
  return a;
}
function b9(e, n, r) {
  if (!e) return null;
  const a = e.find((l) => l.id === n);
  if (!(a != null && a.items)) return null;
  let o = a.items.find((l) => l.id === r);
  if (o) return o;
  for (const l of a.items)
    if (l.conditional_items && (o = l.conditional_items.find((d) => d.id === r), o))
      return o;
  return null;
}
function v$(e, n, r) {
  const a = b9(e, n, r);
  return a && a.client_value !== void 0 && a.client_value !== null ? a.client_value : null;
}
function w$(e, n, r) {
  const a = b9(e, n, r);
  return a && a.firm_value !== void 0 && a.firm_value !== null ? a.firm_value : null;
}
const Pi = (e, n) => JSON.stringify([e, n]);
function ro(e) {
  return e.status === "completed" && e.client_value == null ? null : e.client_value ?? e.firm_value ?? e.ai_value ?? null;
}
function y9(e, n, r) {
  return e.map((a) => {
    const o = n.filter(
      (d) => d.sectionId === a.id
    );
    if (!o.length) return a;
    const l = (d) => {
      let c = d;
      for (const { patch: f } of o.filter(
        (s) => s.itemId === d.id
      ))
        c = r(c, f);
      return c.conditional_items && (c = {
        ...c,
        conditional_items: c.conditional_items.map(l)
      }), c;
    };
    return { ...a, items: a.items.map(l) };
  });
}
function QE(e, n) {
  return y9(e, n, (r, a) => {
    const o = Object.prototype.hasOwnProperty.call(
      a,
      "client_value"
    );
    return {
      ...r,
      ...a,
      status: a.status ?? (o ? "completed" : r.status)
    };
  });
}
function S$(e, n) {
  return y9(e, n, (r, a) => {
    const { client_value: o, status: l, ...d } = a;
    return {
      ...r,
      ...d,
      ..."client_value" in a ? { firm_value: o, client_value: o } : {},
      status: l ?? r.status
    };
  });
}
function v9(e) {
  return e.status === "not_applicable" ? [] : (e.conditional_items ?? []).filter(
    (n) => Ac(n.show_if, ro(e))
  );
}
function pr(e) {
  return e.flatMap((n) => [
    n,
    ...pr(v9(n))
  ]);
}
const Xp = (e) => e != null && (typeof e != "string" || e.trim() !== "");
function w9(e) {
  return e.status === "not_applicable" ? !0 : e.type === "file" ? e.status === "completed" : Xp(e.firm_value) || !e.required && e.status === "completed" ? !0 : e.status === "completed" && Xp(e.client_value);
}
function U0(e) {
  return pr(e).every(w9);
}
function JE(e) {
  const n = new Map(e.items.map((r) => [r.id, r]));
  return e.items.filter((r) => {
    var o;
    const a = ((o = r.show_if) == null ? void 0 : o.field) && n.get(r.show_if.field);
    return !a || Ac(r.show_if, ro(a));
  });
}
function eI(e) {
  const n = e.id.toLowerCase().replace(/[^a-z0-9]/g, "_");
  if (/address|street|city|state|zip|postal|country/.test(n))
    return "Your address";
  if (/phone|telephone|mobile/.test(n)) return "Phone numbers";
  if (/spouse/.test(n)) return "Your spouse";
  if (/taxpayer/.test(n)) return "About you";
}
function tI(e) {
  return $s(e).flatMap(
    (n) => n.confirmation ? [U0(n.items)] : pr(n.items).map(w9)
  );
}
function ch(e) {
  const n = e.flatMap(tI), r = n.filter(Boolean).length;
  return {
    answered: r,
    total: n.length,
    unanswered: n.length - r,
    progress: e7(r, n.length)
  };
}
function $s(e) {
  const n = ["personal_information", "contact_information"].includes(
    e.id
  ), r = [];
  for (const a of JE(e)) {
    const o = n && a.type !== "file" && a.type !== "boolean", l = o ? eI(a) : void 0, d = l && r.find((c) => c.title === l);
    d ? d.items.push(a) : r.push({
      id: a.id,
      title: l || a.label,
      items: [a],
      confirmation: o
    });
  }
  return r;
}
const nI = (e, n) => !!n && e.client_value === n.client_value && e.status === n.status, iI = (e, n, r) => e.some(
  (a) => a.section_id === n && a.item_id === r.id
);
function rI(e, n) {
  return $s(e).find(
    (r) => pr(r.items).some((a) => a.id === n)
  );
}
function sI(e) {
  const n = e == null ? void 0 : e.errors;
  return Array.isArray(n) && n.length > 0 && n.every(
    (r) => (r == null ? void 0 : r.type) === "validation_error"
  );
}
function aI(e, n, r) {
  const a = e.find((o) => o.id === n);
  return a && $s(a).find((o) => o.id === r);
}
function oI(e, n, r, a = []) {
  const o = aI(e, n, r.id);
  if (!o || !U0(o.items)) return !1;
  const l = new Map(
    pr(o.items).map((d) => [d.id, d])
  );
  return pr(r.items).every(
    (d) => nI(d, l.get(d.id)) && !iI(a, n, d)
  );
}
function Io(e) {
  return e.flatMap(
    (n) => $s(n).filter((r) => !U0(r.items)).map((r) => Pi(n.id, r.id))
  );
}
function cI(e) {
  const n = ch([e]), r = n.total ? `${n.answered} of ${n.total} completed` : "Nothing to answer";
  return { ...n, count: r };
}
function lI(e, n) {
  for (const [r, a] of e.entries()) {
    const o = $s(a).map((l) => Pi(a.id, l.id)).find((l) => n.has(l));
    if (o) return { index: r, key: o };
  }
}
function uI({
  scrollTop: e,
  viewHeight: n,
  rowTop: r,
  rowHeight: a
}) {
  const o = r + a - n;
  return Math.min(Math.max(e, o), r);
}
function dI({
  entries: e,
  saveRejected: n,
  onSelect: r
}) {
  return e.length ? /* @__PURE__ */ p.jsxs(
    Za,
    {
      severity: "error",
      role: "region",
      "aria-labelledby": "organizer-error-summary-title",
      "data-organizer-error-summary": !0,
      tabIndex: -1,
      sx: { mb: 3 },
      children: [
        /* @__PURE__ */ p.jsx(
          ef,
          {
            id: "organizer-error-summary-title",
            component: "h2",
            sx: { typography: "subtitle1", fontWeight: 700 },
            children: hI(e.length, n)
          }
        ),
        /* @__PURE__ */ p.jsx(Gs, { disablePadding: !0, children: e.map((a) => /* @__PURE__ */ p.jsx(bs, { disableGutters: !0, sx: { py: 0 }, children: a.cardKey === void 0 ? a.message : /* @__PURE__ */ p.jsx(
          Ii,
          {
            component: "button",
            type: "button",
            onClick: () => r(a),
            sx: {
              minHeight: rr,
              textAlign: "left",
              color: "error.dark",
              textDecoration: "underline",
              fontWeight: 600
            },
            children: a.message
          }
        ) }, a.key)) })
      ]
    }
  ) : null;
}
function hI(e, n) {
  return `Fix ${e} ${e === 1 ? "answer" : "answers"} ${n ? "to save your changes" : "before you submit"}`;
}
function fI({
  welcomeMessage: e,
  onSave: n,
  onClose: r,
  onSavingChange: a
}) {
  const { isMobile: o } = ri(), [l, d] = Ee(e ?? ""), [c, f] = Ee(!1);
  ot(() => (a(c), () => a(!1)), [c, a]);
  const s = async () => {
    if (!c) {
      f(!0);
      try {
        await n(l.trim() || null), r();
      } catch {
        rn.error("Could not save the welcome message.");
      } finally {
        f(!1);
      }
    }
  }, h = (g) => {
    c || (g.key === "Escape" ? r() : g.key === "Enter" && (g.ctrlKey || g.metaKey) && (g.preventDefault(), s()));
  };
  return /* @__PURE__ */ p.jsxs(Pe, { "data-welcome-editor": !0, sx: { gap: 1.5 }, children: [
    /* @__PURE__ */ p.jsx(
      vi,
      {
        label: "Welcome message",
        value: l,
        onChange: (g) => d(g.target.value),
        onKeyDown: h,
        disabled: c,
        multiline: !0,
        minRows: 3,
        autoFocus: !0,
        fullWidth: !0,
        inputProps: { maxLength: 5e3 }
      }
    ),
    /* @__PURE__ */ p.jsxs(Pe, { sx: { flexDirection: "row", alignItems: "center", gap: 1 }, children: [
      /* @__PURE__ */ p.jsx(
        lt,
        {
          variant: "contained",
          disabled: c,
          onClick: () => void s(),
          children: "Save"
        }
      ),
      /* @__PURE__ */ p.jsx(lt, { disabled: c, onClick: r, children: "Cancel" }),
      !o && /* @__PURE__ */ p.jsx(Te, { variant: "caption", sx: { ml: 1 }, children: "Ctrl+Enter saves · Escape cancels" })
    ] })
  ] });
}
const pI = "Review your information and share the details your firm needs.";
function gI({
  clientName: e,
  welcomeMessage: n,
  onSaveWelcomeMessage: r,
  onEditingChange: a,
  onSavingChange: o,
  stepCount: l
}) {
  const { isMobile: d } = ri(), [c, f] = Ee(!1), s = ut(null);
  ot(() => {
    r || f(!1);
  }, [r]), ot(() => (a(c), () => a(!1)), [c, a]);
  const h = () => f(!0), g = () => {
    f(!1), requestAnimationFrame(() => {
      var t;
      return (t = s.current) == null ? void 0 : t.focus();
    });
  };
  return /* @__PURE__ */ p.jsx(
    Me,
    {
      sx: {
        ...Zr,
        borderRadius: 8,
        px: { xs: 2.25, md: 3.5 },
        py: { xs: 2.5, md: 3 },
        mb: 3
      },
      children: /* @__PURE__ */ p.jsxs(Pe, { sx: { gap: d ? 2 : 0 }, children: [
        /* @__PURE__ */ p.jsxs(
          Pe,
          {
            sx: {
              flexDirection: "row",
              alignItems: "center",
              gap: 1,
              mb: d ? 0 : 2
            },
            children: [
              /* @__PURE__ */ p.jsx(Te, { variant: "h5", children: e ? `Hi ${e},` : "Welcome to your organizer" }),
              r && !c && /* @__PURE__ */ p.jsx(ja, { title: "Edit welcome message", children: /* @__PURE__ */ p.jsx(
                Gn,
                {
                  ref: s,
                  "aria-label": "Edit welcome message",
                  onClick: h,
                  children: /* @__PURE__ */ p.jsx(it, { icon: "penOutline", fontSize: "small" })
                }
              ) })
            ]
          }
        ),
        c && r ? /* @__PURE__ */ p.jsx(
          fI,
          {
            welcomeMessage: n,
            onSave: r,
            onClose: g,
            onSavingChange: o
          }
        ) : /* @__PURE__ */ p.jsx(
          Te,
          {
            variant: "subtitle1",
            sx: { whiteSpace: "pre-wrap", overflowWrap: "anywhere" },
            children: n || pI
          }
        ),
        /* @__PURE__ */ p.jsxs(Te, { variant: "subtitle1", sx: { mt: 2 }, children: [
          "Complete ",
          l,
          " steps. Your answers save as you go, so you can stop and come back anytime."
        ] })
      ] })
    }
  );
}
function z0({
  onMessage: e,
  preview: n,
  busy: r
}) {
  return e ? /* @__PURE__ */ p.jsxs(
    Pe,
    {
      sx: {
        ...Zr,
        p: 2,
        flexDirection: "row",
        alignItems: "center",
        gap: 1.5
      },
      children: [
        /* @__PURE__ */ p.jsx(
          Xs,
          {
            sx: {
              width: 44,
              height: 44,
              flexShrink: 0,
              bgcolor: "primary.main",
              color: "primary.contrastText"
            },
            children: /* @__PURE__ */ p.jsx(it, { icon: "message", fontSize: "small" })
          }
        ),
        /* @__PURE__ */ p.jsxs(Me, { children: [
          /* @__PURE__ */ p.jsx(Te, { sx: { fontWeight: 700 }, children: "Questions?" }),
          /* @__PURE__ */ p.jsx(
            ja,
            {
              describeChild: !0,
              title: n ? "This is just a client preview." : "",
              children: /* @__PURE__ */ p.jsx(
                lt,
                {
                  disabled: r,
                  onClick: e,
                  sx: { px: 0, color: "secondary.dark" },
                  children: "Message your firm"
                }
              )
            }
          )
        ] })
      ]
    }
  ) : null;
}
function H0({
  onPrint: e,
  busy: n,
  fullWidth: r
}) {
  return /* @__PURE__ */ p.jsx(
    lt,
    {
      variant: "outlined",
      fullWidth: r,
      startIcon: /* @__PURE__ */ p.jsx(it, { icon: "print", fontSize: "small" }),
      disabled: n,
      onClick: e,
      children: "Print PDF"
    }
  );
}
function mI({
  onView: e,
  onPrint: n,
  onMessage: r,
  preview: a,
  busy: o
}) {
  const { isMobile: l } = ri();
  return /* @__PURE__ */ p.jsx(Me, { sx: { px: l ? 2 : 0, pt: l ? 2.5 : 0 }, children: /* @__PURE__ */ p.jsxs(
    Me,
    {
      sx: {
        ...Zr,
        maxWidth: 700,
        mx: "auto",
        mt: l ? 0 : 8,
        p: l ? 3 : 6,
        textAlign: "center"
      },
      children: [
        /* @__PURE__ */ p.jsx(
          Xs,
          {
            sx: {
              width: 80,
              height: 80,
              mx: "auto",
              mb: 3,
              bgcolor: "common.success.50",
              color: "success.dark"
            },
            children: /* @__PURE__ */ p.jsx(it, { icon: "check", fontSize: "large" })
          }
        ),
        /* @__PURE__ */ p.jsx(Te, { variant: "h2", children: "Thank you! Your organizer was sent." }),
        /* @__PURE__ */ p.jsx(Te, { variant: "subtitle1", sx: { mt: 2, mb: 4 }, children: "Your firm now has everything you shared." }),
        /* @__PURE__ */ p.jsxs(Pe, { sx: { alignItems: "center", gap: 1.5 }, children: [
          /* @__PURE__ */ p.jsx(lt, { variant: "outlined", onClick: e, children: "View my answers" }),
          l && /* @__PURE__ */ p.jsx(H0, { onPrint: n, busy: o }),
          l && /* @__PURE__ */ p.jsx(
            z0,
            {
              onMessage: r,
              preview: a,
              busy: o
            }
          )
        ] })
      ]
    }
  ) });
}
const Wu = {
  border: 1,
  borderColor: "divider",
  borderRadius: 1,
  bgcolor: "background.paper",
  px: 0.75,
  py: 0.25,
  font: "inherit"
};
function xI({ model: e, props: n }) {
  const r = !n.readOnly && !e.isSubmitted;
  return /* @__PURE__ */ p.jsx(
    gI,
    {
      clientName: n.clientName,
      welcomeMessage: n.welcomeMessage,
      onSaveWelcomeMessage: r ? n.onSaveWelcomeMessage : void 0,
      onEditingChange: e.setWelcomeEditing,
      onSavingChange: e.setWelcomeSaving,
      stepCount: e.sections.length + 1
    }
  );
}
function bI({
  model: e,
  props: n,
  onPrint: r
}) {
  var g;
  const { currentStep: a, sections: o, reviewing: l } = e, { isMobile: d } = ri(), { readOnly: c, showsSubmitted: f } = e, s = l && f, h = l ? f ? "Your answers" : "Review & submit" : o[a].title;
  return /* @__PURE__ */ p.jsxs(
    Me,
    {
      component: n.embedded ? "section" : "main",
      sx: { flex: 1, minWidth: 0, maxWidth: 760 },
      children: [
        !c && /* @__PURE__ */ p.jsx(
          dI,
          {
            entries: e.errorEntries,
            saveRejected: e.saveRejected,
            onSelect: e.selectError
          }
        ),
        n.lockedReason && /* @__PURE__ */ p.jsx(
          Za,
          {
            id: e.lockNoticeId,
            severity: "info",
            role: "note",
            sx: { mb: 3 },
            children: n.lockedReason
          }
        ),
        a === 0 && !l && /* @__PURE__ */ p.jsx(xI, { model: e, props: n }),
        /* @__PURE__ */ p.jsx(
          Te,
          {
            variant: "h2",
            component: n.embedded ? "h2" : "h1",
            "data-organizer-step-heading": !0,
            tabIndex: -1,
            sx: { fontWeight: 700, mb: 3 },
            children: h
          }
        ),
        s && /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
          /* @__PURE__ */ p.jsx(Te, { variant: "subtitle1", sx: { mb: d ? 2 : 3 }, children: "Submitted. Answers can no longer be changed." }),
          d && /* @__PURE__ */ p.jsxs(Pe, { sx: { mb: 3, gap: 2, alignItems: "flex-start" }, children: [
            /* @__PURE__ */ p.jsx(H0, { onPrint: r, busy: e.busy }),
            /* @__PURE__ */ p.jsx(
              z0,
              {
                onMessage: e.openMessage,
                preview: n.preview,
                busy: e.busy
              }
            )
          ] })
        ] }),
        l && !c && /* @__PURE__ */ p.jsx(yI, { model: e }),
        !l && !c && /* @__PURE__ */ p.jsx(vI, { model: e }),
        /* @__PURE__ */ p.jsxs(Pe, { sx: { gap: 2 }, children: [
          /* @__PURE__ */ p.jsx(wI, { model: e, props: n }),
          !l && e.showUnanswered && !e.listedCards(o[a]).length && /* @__PURE__ */ p.jsx(Me, { role: "status", sx: { ...Zr, p: 3 }, children: /* @__PURE__ */ p.jsx(Te, { variant: "subtitle1", children: "Nothing left to answer in this section." }) }),
          l && !c && !e.showAll && !e.reviewKeys.length && !((g = n.validationErrors) != null && g.length) && /* @__PURE__ */ p.jsx(Me, { sx: { ...Zr, p: 3 }, children: /* @__PURE__ */ p.jsx(Te, { variant: "subtitle1", children: "Everything is answered." }) }),
          l && /* @__PURE__ */ p.jsx(SI, { model: e, props: n })
        ] }),
        !s && /* @__PURE__ */ p.jsx(_I, { model: e }),
        !d && /* @__PURE__ */ p.jsxs(
          Pe,
          {
            sx: {
              flexDirection: "row",
              flexWrap: "wrap",
              alignItems: "center",
              gap: 2,
              pb: 2,
              typography: "caption"
            },
            children: [
              /* @__PURE__ */ p.jsxs(
                Me,
                {
                  component: "span",
                  sx: { display: "inline-flex", alignItems: "center", gap: 0.75 },
                  children: [
                    /* @__PURE__ */ p.jsx(Me, { component: "kbd", sx: Wu, children: "Tab" }),
                    "move"
                  ]
                }
              ),
              /* @__PURE__ */ p.jsxs(
                Me,
                {
                  component: "span",
                  sx: { display: "inline-flex", alignItems: "center", gap: 0.75 },
                  children: [
                    /* @__PURE__ */ p.jsx(Me, { component: "kbd", sx: Wu, children: "Enter" }),
                    "/",
                    /* @__PURE__ */ p.jsx(Me, { component: "kbd", sx: Wu, children: "Space" }),
                    "activate"
                  ]
                }
              )
            ]
          }
        )
      ]
    }
  );
}
function yI({ model: e }) {
  const { showAll: n, setShowAll: r, setReviewKeys: a, sections: o, progress: l, busy: d } = e;
  return /* @__PURE__ */ p.jsxs(
    Pe,
    {
      role: "group",
      "aria-label": "Review filter",
      sx: { flexDirection: "row", gap: 1, mb: 3 },
      children: [
        /* @__PURE__ */ p.jsxs(
          lt,
          {
            disabled: d,
            "aria-pressed": !n,
            variant: n ? "outlined" : "contained",
            onClick: () => {
              r(!1), a(Io(o));
            },
            children: [
              "Unanswered (",
              l.unanswered,
              ")"
            ]
          }
        ),
        /* @__PURE__ */ p.jsx(
          lt,
          {
            disabled: d,
            "aria-pressed": n,
            variant: n ? "contained" : "outlined",
            onClick: () => r(!0),
            children: "All questions"
          }
        )
      ]
    }
  );
}
function vI({ model: e }) {
  const { showUnanswered: n, filterUnanswered: r, busy: a } = e;
  return /* @__PURE__ */ p.jsxs(
    Pe,
    {
      role: "group",
      "aria-label": "Section filter",
      sx: { flexDirection: "row", gap: 1, mb: 3 },
      children: [
        /* @__PURE__ */ p.jsx(
          lt,
          {
            disabled: a,
            "aria-pressed": !n,
            variant: n ? "outlined" : "contained",
            onClick: () => r(!1),
            children: "Show all"
          }
        ),
        /* @__PURE__ */ p.jsx(
          lt,
          {
            disabled: a,
            "aria-pressed": n,
            variant: n ? "contained" : "outlined",
            onClick: () => r(!0),
            children: "Show unanswered"
          }
        )
      ]
    }
  );
}
function wI({ model: e, props: n }) {
  const { reviewing: r, sections: a, currentStep: o, renderCard: l, listedCards: d } = e;
  return /* @__PURE__ */ p.jsx(p.Fragment, { children: (r ? a : [a[o]]).map((c) => {
    const f = d(c);
    return f.length ? /* @__PURE__ */ p.jsxs(Pe, { sx: { gap: 1.5 }, children: [
      r && /* @__PURE__ */ p.jsx(
        Te,
        {
          variant: "h5",
          component: n.embedded ? "h3" : "h2",
          sx: { mt: 1 },
          children: c.title
        }
      ),
      f.map((s) => l(c, s))
    ] }, c.id) : null;
  }) });
}
function SI({ model: e, props: n }) {
  const {
    readOnly: r,
    showsSubmitted: a,
    isSubmitted: o,
    isEditing: l,
    progress: d,
    busy: c,
    action: f,
    setSubmitted: s,
    setConfirmation: h
  } = e, g = dc(), t = n.submitDisabledReason;
  return /* @__PURE__ */ p.jsxs(
    Me,
    {
      sx: {
        ...Zr,
        borderRadius: 4,
        p: { xs: 2.5, md: 3.5 },
        mt: 1
      },
      children: [
        !a && /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
          /* @__PURE__ */ p.jsx(Te, { variant: "h4", children: "Ready to submit?" }),
          /* @__PURE__ */ p.jsxs(Te, { variant: "subtitle1", sx: { my: 2 }, children: [
            d.unanswered > 0 && `You still have ${d.unanswered} unanswered ${d.unanswered === 1 ? "question" : "questions"}. `,
            "After you submit, you can't make changes or add files."
          ] })
        ] }),
        /* @__PURE__ */ p.jsx(
          lt,
          {
            variant: "contained",
            disabled: r || o || c || l,
            className: t ? "Mui-disabled" : void 0,
            "aria-disabled": t ? !0 : void 0,
            "aria-describedby": t ? g : void 0,
            sx: { width: { xs: "100%", md: "auto" } },
            onClick: () => {
              t || f(n.onSubmit, () => {
                s(!0), h(!0);
              });
            },
            children: a || o ? "Submitted" : "Submit"
          }
        ),
        t && /* @__PURE__ */ p.jsx(
          Te,
          {
            id: g,
            variant: "body2",
            sx: { mt: 1.5, color: "text.primary" },
            children: t
          }
        )
      ]
    }
  );
}
function _I({ model: e }) {
  const { currentStep: n, sections: r, busy: a, reviewing: o, go: l, isEditing: d } = e, { isMobile: c } = ri(), f = a || d;
  return /* @__PURE__ */ p.jsxs(
    Pe,
    {
      sx: {
        position: "sticky",
        bottom: 0,
        bgcolor: "common.neutrals.100",
        borderTop: 1,
        borderColor: "divider",
        mt: 3,
        py: 2,
        gap: 1,
        zIndex: 1
      },
      children: [
        d && /* @__PURE__ */ p.jsx(Te, { role: "status", sx: { fontWeight: 700 }, children: "Save or cancel your changes to continue." }),
        /* @__PURE__ */ p.jsxs(
          Pe,
          {
            sx: { flexDirection: "row", gap: 2, justifyContent: "space-between" },
            children: [
              /* @__PURE__ */ p.jsx(
                lt,
                {
                  variant: "outlined",
                  disabled: n === 0 || f,
                  startIcon: /* @__PURE__ */ p.jsx(it, { icon: "chevronLeft", fontSize: "small" }),
                  onClick: () => l(n - 1),
                  children: "Back"
                }
              ),
              !o && /* @__PURE__ */ p.jsx(
                lt,
                {
                  variant: "contained",
                  disabled: f,
                  endIcon: /* @__PURE__ */ p.jsx(it, { icon: "chevronRight", fontSize: "small" }),
                  sx: {
                    flex: { xs: 1, md: "0 0 auto" },
                    whiteSpace: "nowrap"
                  },
                  onClick: () => l(n + 1),
                  children: n === r.length - 1 ? "Review & submit" : c ? "Continue" : `Continue to ${r[n + 1].title}`
                }
              )
            ]
          }
        )
      ]
    }
  );
}
function CI({
  onClosePreview: e
}) {
  return /* @__PURE__ */ p.jsxs(
    Me,
    {
      sx: {
        position: "sticky",
        top: 0,
        zIndex: 1200,
        bgcolor: "secondary.dark",
        color: "secondary.contrastText",
        px: { xs: 2, md: 3 },
        py: 1.5,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexWrap: "wrap",
        gap: 2
      },
      children: [
        /* @__PURE__ */ p.jsxs(
          Pe,
          {
            sx: {
              flexDirection: "row",
              alignItems: "center",
              gap: 1.5,
              maxWidth: 850
            },
            children: [
              /* @__PURE__ */ p.jsx(it, { icon: "preview", fontSize: "small", sx: { flexShrink: 0 } }),
              /* @__PURE__ */ p.jsx(Te, { children: "You're viewing what your client sees. Changes in this preview are not saved to the request." })
            ]
          }
        ),
        e && /* @__PURE__ */ p.jsx(
          lt,
          {
            variant: "contained",
            onClick: e,
            sx: {
              bgcolor: "background.paper",
              color: "secondary.dark",
              "&:hover": { bgcolor: "common.neutrals.100" }
            },
            children: "Close Client Preview"
          }
        )
      ]
    }
  );
}
function AI({
  isMobile: e,
  busy: n,
  onClick: r
}) {
  return e ? /* @__PURE__ */ p.jsx(
    Gn,
    {
      "aria-label": "Back",
      disabled: n,
      onClick: r,
      sx: {
        width: rr,
        height: rr,
        flexShrink: 0
      },
      children: /* @__PURE__ */ p.jsx(it, { icon: "arrowLeft", fontSize: "small" })
    }
  ) : /* @__PURE__ */ p.jsx(
    lt,
    {
      variant: "text",
      startIcon: /* @__PURE__ */ p.jsx(it, { icon: "arrowLeft", fontSize: "small" }),
      disabled: n,
      onClick: r,
      children: "Back"
    }
  );
}
function kI({
  title: e,
  clientName: n,
  isMobile: r
}) {
  return (
    // Zero basis width keeps a long title from widening the page on phones.
    /* @__PURE__ */ p.jsxs(Me, { sx: { flex: 1, width: 0, minWidth: 0 }, children: [
      /* @__PURE__ */ p.jsx(
        Te,
        {
          variant: "h5",
          noWrap: !r,
          sx: {
            overflowWrap: "anywhere",
            ...r && {
              fontSize: (a) => a.typography.pxToRem(17),
              fontWeight: 700
            }
          },
          children: e
        }
      ),
      n && /* @__PURE__ */ p.jsx(
        Te,
        {
          variant: "subtitle2",
          noWrap: !0,
          sx: r ? { fontSize: (a) => a.typography.pxToRem(14) } : void 0,
          children: n
        }
      )
    ] })
  );
}
function EI({
  error: e,
  busy: n,
  saving: r,
  dirty: a
}) {
  return e ? "Save failed" : n || r ? "Saving…" : a ? "Unsaved changes" : "Saved automatically";
}
function II({
  error: e,
  busy: n,
  saving: r,
  dirty: a
}) {
  const o = !e && !n && !r && !a, l = e ? "error.main" : o ? "success.dark" : "text.primary";
  return /* @__PURE__ */ p.jsxs(
    Te,
    {
      role: "status",
      sx: { color: l, display: "flex", alignItems: "center", gap: 0.5 },
      children: [
        o && /* @__PURE__ */ p.jsx(it, { icon: "check", fontSize: "small" }),
        EI({ error: e, busy: n, saving: r, dirty: a })
      ]
    }
  );
}
function TI({
  isMobile: e,
  busy: n,
  readOnly: r,
  onPrint: a,
  onExit: o
}) {
  return /* @__PURE__ */ p.jsxs(
    Pe,
    {
      sx: {
        flexDirection: "row",
        alignItems: "center",
        gap: 1,
        flexShrink: 0
      },
      children: [
        !e && /* @__PURE__ */ p.jsx(H0, { onPrint: a, busy: n }),
        /* @__PURE__ */ p.jsx(
          lt,
          {
            variant: "outlined",
            disabled: n,
            onClick: o,
            sx: { whiteSpace: "nowrap" },
            children: r ? "Exit" : "Save & Exit"
          }
        )
      ]
    }
  );
}
function S9({
  error: e,
  busy: n,
  onRetry: r
}) {
  return e ? /* @__PURE__ */ p.jsx(
    Za,
    {
      severity: "error",
      sx: { maxWidth: 1120, mx: "auto", mt: 2 },
      action: /* @__PURE__ */ p.jsx(lt, { color: "error", disabled: n, onClick: r, children: "Try saving again" }),
      children: e
    }
  ) : null;
}
function OI({
  title: e,
  clientName: n,
  preview: r,
  onClosePreview: a,
  onPrint: o,
  busy: l,
  saving: d,
  dirty: c,
  error: f,
  readOnly: s,
  onExit: h,
  onRetry: g
}) {
  const { isMobile: t } = ri();
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    r && /* @__PURE__ */ p.jsx(CI, { onClosePreview: a }),
    /* @__PURE__ */ p.jsx(
      Me,
      {
        component: "header",
        sx: {
          bgcolor: "background.paper",
          borderBottom: 1,
          borderColor: "divider"
        },
        children: /* @__PURE__ */ p.jsxs(
          Me,
          {
            sx: {
              maxWidth: 1200,
              mx: "auto",
              px: { xs: 1, md: 3 },
              py: { xs: 1, md: 2 },
              display: "flex",
              alignItems: "center",
              flexWrap: "nowrap",
              gap: { xs: 1, md: 2 }
            },
            children: [
              /* @__PURE__ */ p.jsx(
                AI,
                {
                  isMobile: t,
                  busy: l,
                  onClick: r ? a : h
                }
              ),
              !t && /* @__PURE__ */ p.jsx(
                tf,
                {
                  "aria-label": "Liscio",
                  sx: {
                    width: 32,
                    height: 32,
                    objectFit: "contain",
                    flexShrink: 0
                  }
                }
              ),
              /* @__PURE__ */ p.jsx(
                kI,
                {
                  title: e,
                  clientName: n,
                  isMobile: t
                }
              ),
              !s && !t && /* @__PURE__ */ p.jsx(
                II,
                {
                  error: f,
                  busy: l,
                  saving: d,
                  dirty: c
                }
              ),
              /* @__PURE__ */ p.jsx(
                TI,
                {
                  isMobile: t,
                  busy: l,
                  readOnly: s,
                  onPrint: o,
                  onExit: h
                }
              )
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ p.jsx(S9, { error: f, busy: l, onRetry: g })
  ] });
}
function _9({ sectionProgress: e }, n) {
  var r;
  return (r = e[n]) == null ? void 0 : r.count;
}
function C9({ sectionProgress: e }, n) {
  var r;
  return ((r = e[n]) == null ? void 0 : r.unanswered) === 0;
}
function A9({
  detail: e,
  complete: n,
  inRow: r
}) {
  return e ? (
    // A span, so it is valid inside the step button.
    /* @__PURE__ */ p.jsx(
      Te,
      {
        component: "span",
        variant: "body2",
        sx: {
          display: "block",
          color: n ? "success.dark" : "text.primary",
          ...r ? { fontWeight: "fontWeightRegular" } : { mt: 1 }
        },
        children: e
      }
    )
  ) : null;
}
function FI({
  index: e,
  complete: n,
  current: r
}) {
  const a = n || r, o = n ? "success.dark" : r ? "primary.main" : "background.paper";
  return /* @__PURE__ */ p.jsx(
    Xs,
    {
      sx: {
        width: 32,
        height: 32,
        typography: "subtitle2",
        flexShrink: 0,
        bgcolor: o,
        color: a ? "primary.contrastText" : "text.primary",
        border: a ? 0 : 1,
        borderColor: "divider"
      },
      children: n ? /* @__PURE__ */ p.jsx(it, { icon: "check", fontSize: "small" }) : e + 1
    }
  );
}
function k9({
  onResume: e,
  busy: n
}) {
  return /* @__PURE__ */ p.jsx(lt, { variant: "outlined", fullWidth: !0, disabled: n, onClick: e, children: "Pick up where you left off" });
}
const E9 = { sidebar: 56, sheet: 64 }, Gp = 48;
function I9(e) {
  const { sections: n, step: r, submitted: a, onGo: o, busy: l, rowHeight: d } = e;
  return /* @__PURE__ */ p.jsx(Pe, { component: "nav", "aria-label": "Organizer steps", sx: { p: 1, gap: 0.5 }, children: [...n.map((c) => c.title), "Review & submit"].map(
    (c, f) => {
      const s = r === f, h = f < n.length ? C9(e, f) : a, g = _9(e, f);
      return /* @__PURE__ */ p.jsxs(
        lt,
        {
          disabled: l,
          "aria-current": s ? "step" : void 0,
          "aria-label": `Step ${f + 1}: ${c}${g ? `, ${g}` : ""}`,
          onClick: () => o(f),
          sx: {
            justifyContent: "flex-start",
            textAlign: "left",
            gap: 1.5,
            // Tripled class beats the organizer root's `.MuiButton-root`
            // minimum whatever the stylesheet order.
            "&&&": { minHeight: d },
            px: 1.5,
            bgcolor: s ? "common.primary.50" : void 0,
            color: "text.primary",
            fontWeight: s ? 700 : 500
          },
          children: [
            /* @__PURE__ */ p.jsx(FI, { index: f, complete: h, current: s }),
            " ",
            /* @__PURE__ */ p.jsxs(Pe, { component: "span", sx: { minWidth: 0 }, children: [
              c,
              " ",
              /* @__PURE__ */ p.jsx(A9, { detail: g, complete: h, inRow: !0 })
            ] })
          ]
        },
        f < n.length ? n[f].id : "review"
      );
    }
  ) });
}
function qu(e, n) {
  var o;
  const r = e == null ? void 0 : e.querySelector('[aria-current="step"]');
  if (!e || !r) return;
  const a = uI({
    scrollTop: e.scrollTop,
    viewHeight: e.clientHeight,
    rowTop: r.offsetTop,
    rowHeight: r.offsetHeight
  });
  (o = e.scrollTo) == null || o.call(e, { top: a, behavior: n });
}
function PI(e, n) {
  ot(() => {
    const r = e.current;
    if (!r) return;
    qu(r, "auto");
    const a = new ResizeObserver(
      () => qu(r, "auto")
    );
    return a.observe(r), () => a.disconnect();
  }, [e]), ot(() => {
    qu(e.current, NE());
  }, [e, n]);
}
function jI(e) {
  const n = ut(null);
  return PI(n, e.step), /* @__PURE__ */ p.jsx(
    Me,
    {
      ref: n,
      sx: {
        ...Zr,
        // Row offsetTop is measured from this element.
        position: "relative",
        minHeight: 0,
        overflowY: "auto"
      },
      children: /* @__PURE__ */ p.jsx(I9, { ...e, rowHeight: E9.sidebar })
    }
  );
}
const RI = { page: 24, preview: 110, embedded: 24 }, T9 = 24, MI = { page: 95, preview: 95, embedded: 90 }, DI = 590, NI = (e) => `@media (max-height: ${e + DI - 0.02}px)`, Kp = (e, n, r) => `calc(var(--liscio-app-viewport-height, 100${r}) - ${e + n + T9}px)`;
function LI(e) {
  const { isMobile: n } = ri(), r = dc(), a = e.embedded ? "embedded" : e.preview ? "preview" : "page", o = RI[a], l = MI[a];
  return n ? null : /* @__PURE__ */ p.jsxs(
    Pe,
    {
      component: "aside",
      sx: {
        display: "flex",
        width: 290,
        flexShrink: 0,
        gap: 2,
        position: "sticky",
        top: o,
        // Keeps space under the Questions card when the page cannot scroll it up.
        mb: `${T9}px`,
        // Keep the whole sidebar on screen; only the step list scrolls.
        maxHeight: Kp(o, l, "vh"),
        // Mobile browsers resize the dynamic viewport with their toolbars; vh above is the fallback.
        "@supports (height: 100dvh)": {
          maxHeight: Kp(o, l, "dvh")
        },
        // Too short to stick usefully: the sidebar scrolls with the page.
        [NI(o)]: { position: "static", maxHeight: "none" }
      },
      children: [
        /* @__PURE__ */ p.jsxs(Me, { sx: { ...Zr, p: 2.5 }, children: [
          /* @__PURE__ */ p.jsxs(
            Pe,
            {
              sx: {
                flexDirection: "row",
                justifyContent: "space-between",
                mb: 1.5
              },
              children: [
                /* @__PURE__ */ p.jsx(Te, { id: r, sx: { fontWeight: 700 }, children: "Your progress" }),
                /* @__PURE__ */ p.jsx(Te, { sx: { fontWeight: 700, color: "success.dark" }, children: Cx(e.progress) })
              ]
            }
          ),
          /* @__PURE__ */ p.jsx(
            nf,
            {
              "aria-labelledby": r,
              value: e.progress,
              color: "success",
              sx: { height: 8, borderRadius: 2 }
            }
          ),
          e.onResume && /* @__PURE__ */ p.jsx(Me, { sx: { mt: 2 }, children: /* @__PURE__ */ p.jsx(k9, { onResume: e.onResume, busy: e.busy }) })
        ] }),
        /* @__PURE__ */ p.jsx(jI, { ...e }),
        /* @__PURE__ */ p.jsx(
          z0,
          {
            onMessage: e.onMessage,
            preview: e.preview,
            busy: e.busy
          }
        )
      ]
    }
  );
}
function BI({
  step: e,
  stepCount: n,
  progress: r,
  detail: a,
  complete: o,
  onOpenSheet: l
}) {
  return /* @__PURE__ */ p.jsxs(
    Me,
    {
      sx: {
        bgcolor: "background.paper",
        p: 2,
        borderBottom: 1,
        borderColor: "divider"
      },
      children: [
        /* @__PURE__ */ p.jsxs(
          Pe,
          {
            sx: {
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 1.5
            },
            children: [
              /* @__PURE__ */ p.jsxs(Te, { children: [
                "Step ",
                e + 1,
                " of ",
                n,
                " · ",
                Cx(r),
                " done"
              ] }),
              /* @__PURE__ */ p.jsx(
                lt,
                {
                  variant: "outlined",
                  startIcon: /* @__PURE__ */ p.jsx(it, { icon: "menu", fontSize: "small" }),
                  onClick: l,
                  children: "All steps"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ p.jsx(
          nf,
          {
            "aria-label": "Your progress",
            value: r,
            color: "success",
            sx: { height: 8, borderRadius: 2 }
          }
        ),
        /* @__PURE__ */ p.jsx(A9, { detail: a, complete: o })
      ]
    }
  );
}
function $I(e) {
  const n = () => e.onSheet(!1), { onPrint: r, onMessage: a } = e, o = r && (() => (n(), r())), l = a && (() => (n(), a()));
  return /* @__PURE__ */ p.jsxs(
    _5,
    {
      anchor: "bottom",
      open: e.sheet,
      onClose: n,
      slotProps: {
        backdrop: {
          sx: (d) => ({
            bgcolor: b2(d.palette.common.neutrals[900], 0.45)
          })
        }
      },
      PaperProps: {
        sx: {
          bgcolor: "background.paper",
          color: "text.primary",
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          maxHeight: "85vh"
        }
      },
      children: [
        /* @__PURE__ */ p.jsxs(
          Pe,
          {
            sx: {
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              p: 2
            },
            children: [
              /* @__PURE__ */ p.jsx(
                Te,
                {
                  variant: "h4",
                  sx: {
                    fontSize: (d) => d.typography.pxToRem(21),
                    fontWeight: 700
                  },
                  children: "All steps"
                }
              ),
              /* @__PURE__ */ p.jsx(
                Gn,
                {
                  "aria-label": "Close all steps",
                  sx: { width: Gp, height: Gp },
                  onClick: n,
                  children: /* @__PURE__ */ p.jsx(it, { icon: "close" })
                }
              )
            ]
          }
        ),
        e.onResume && /* @__PURE__ */ p.jsx(Me, { sx: { px: 2, pb: 1 }, children: /* @__PURE__ */ p.jsx(k9, { onResume: e.onResume, busy: e.busy }) }),
        /* @__PURE__ */ p.jsx(I9, { ...e, rowHeight: E9.sheet }),
        o && /* @__PURE__ */ p.jsx(Me, { sx: { px: 2, pb: 2 }, children: /* @__PURE__ */ p.jsx(
          H0,
          {
            fullWidth: !0,
            busy: e.busy,
            onPrint: o
          }
        ) }),
        /* @__PURE__ */ p.jsx(
          z0,
          {
            onMessage: l,
            preview: e.preview,
            busy: e.busy
          }
        )
      ]
    }
  );
}
function UI(e) {
  const { isMobile: n } = ri();
  return !n || e.hidden ? null : /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsx(
      BI,
      {
        step: e.step,
        stepCount: e.sections.length + 1,
        progress: e.progress,
        detail: _9(e, e.step),
        complete: C9(e, e.step),
        onOpenSheet: () => e.onSheet(!0)
      }
    ),
    /* @__PURE__ */ p.jsx($I, { ...e })
  ] });
}
const zI = 'input:not([type="hidden"]):not(:disabled), textarea:not(:disabled), [role="combobox"]:not([aria-disabled="true"]), button:not(:disabled)';
function HI(e, n) {
  return (n ?? []).map((r) => {
    const a = e.findIndex(
      (l) => l.id === r.section_id
    ), o = a >= 0 ? rI(e[a], r.item_id) : void 0;
    return {
      key: Pi(r.section_id, r.item_id),
      message: r.message,
      itemId: r.item_id,
      ...o && {
        step: a,
        cardKey: Pi(e[a].id, o.id)
      }
    };
  });
}
function WI(e, n) {
  var o;
  const r = Array.from(
    e.querySelectorAll("[data-organizer-field]")
  ).find((l) => l.dataset.organizerField === n), a = (r == null ? void 0 : r.querySelector(zI)) ?? e.querySelector("[data-organizer-edit]") ?? e;
  (o = a.scrollIntoView) == null || o.call(a, { block: "center" }), a.focus({ preventScroll: !0 });
}
const qI = ({
  size: e,
  narrow: n,
  followUp: r,
  readableLock: a
}) => {
  const o = RE[e];
  return {
    ...n && { maxWidth: 420 },
    "& .MuiInputBase-root": { minHeight: o },
    // Multiline roots add their own padding; the input carries all of it.
    "& .MuiInputBase-multiline": { p: 0 },
    // Pad the line so a single line fills the box exactly (54px or 44px).
    "& .MuiInputBase-input": {
      lineHeight: 1.25,
      padding: (l) => `calc((${o}px - 1.25em) / 2) ${l.spacing(1.5)}`
    },
    "& input.MuiInputBase-input": { height: "1.25em" },
    "& .MuiSelect-select.MuiInputBase-input": { minHeight: "1.25em" },
    ...r && {
      "& .MuiOutlinedInput-root": { bgcolor: "background.paper" },
      "& .MuiOutlinedInput-notchedOutline": {
        borderWidth: 1.5,
        borderColor: "common.neutrals.300"
      }
    },
    "& .MuiInputBase-input, & .MuiSelect-select": {
      fontSize: (l) => l.typography.pxToRem(ME[e])
    },
    ...a && {
      "& .MuiInputBase-input.Mui-disabled, & .MuiSelect-select.Mui-disabled": {
        color: "text.primary",
        WebkitTextFillColor: (l) => l.palette.text.primary
      }
    }
  };
};
function VI({
  item: e,
  disabled: n,
  onChange: r
}) {
  const a = ro(e);
  return /* @__PURE__ */ p.jsx(
    Pe,
    {
      role: "group",
      "aria-label": e.label,
      sx: { flexDirection: "row", gap: 1 },
      children: [!0, !1].map((o) => {
        const l = a === o;
        return /* @__PURE__ */ p.jsx(
          lt,
          {
            variant: l ? "contained" : "outlined",
            "aria-pressed": l,
            startIcon: l ? /* @__PURE__ */ p.jsx(it, { icon: "check" }) : void 0,
            disabled: n,
            onClick: () => r(e, { client_value: l ? "" : o }, !0),
            sx: {
              minWidth: DE,
              minHeight: rr,
              transition: "none",
              fontSize: (d) => d.typography.pxToRem(17),
              "&.Mui-disabled": {
                color: "text.primary",
                bgcolor: l ? "common.secondary.100" : "background.paper",
                border: 1,
                borderColor: l ? "secondary.main" : "divider"
              }
            },
            children: o ? "Yes" : "No"
          },
          String(o)
        );
      })
    }
  );
}
function XI({ message: e, hint: n }) {
  return !e && !n ? null : /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    e && /* @__PURE__ */ p.jsx(
      Me,
      {
        component: "span",
        role: "alert",
        sx: { display: "block", fontWeight: 600, color: "common.error.600" },
        children: e
      }
    ),
    n && /* @__PURE__ */ p.jsx(
      Me,
      {
        component: "span",
        sx: {
          display: "block",
          fontWeight: 400,
          // text.secondary is 3.1:1 on white, too light for body text.
          color: "common.neutrals.700"
        },
        children: n
      }
    )
  ] });
}
function GI({
  large: e = !1,
  followUp: n = !1,
  item: r,
  disabled: a,
  readableLock: o = !1,
  onChange: l,
  onBlur: d,
  message: c,
  hint: f
}) {
  var m;
  const s = ro(r), h = typeof s == "string" || typeof s == "number" ? String(s) : "", g = r.type === "select", t = r.type === "string", i = t || r.type === "text";
  return /* @__PURE__ */ p.jsxs(
    vi,
    {
      label: r.label,
      value: h,
      select: g,
      disabled: a,
      error: !!c,
      helperText: /* @__PURE__ */ p.jsx(XI, { message: c, hint: f }),
      FormHelperTextProps: {
        sx: {
          mx: 0,
          mt: 0.75,
          typography: "body2",
          // The shared theme sets a smaller size on errors.
          "&.Mui-error": { typography: "body2" }
        }
      },
      type: r.type === "date" || r.type === "number" ? r.type : "text",
      multiline: i,
      minRows: i ? 1 : void 0,
      maxRows: i ? 4 : void 0,
      inputProps: {
        "aria-label": r.label,
        maxLength: 3e3,
        ...t && {
          onKeyDown: (v) => {
            v.key === "Enter" && v.preventDefault();
          }
        }
      },
      sx: qI({
        size: e ? "large" : "regular",
        narrow: n && (t || r.type === "number"),
        followUp: n,
        readableLock: o
      }),
      SelectProps: {
        displayEmpty: !0,
        inputProps: { "aria-label": r.label }
      },
      onChange: (v) => {
        const E = t ? v.target.value.replace(/\r\n|\r|\n/g, " ") : v.target.value;
        l(
          r,
          {
            client_value: r.type === "number" && E !== "" ? Number(E) : E
          },
          g
        );
      },
      onBlur: d,
      children: [
        g && /* @__PURE__ */ p.jsx(vd, { value: "", children: "Select an answer" }),
        g && ((m = r.options) == null ? void 0 : m.map((v, E) => /* @__PURE__ */ p.jsx(vd, { value: v.value ?? "", children: v.label ?? v.value }, `${v.value}-${E}`)))
      ]
    }
  );
}
function O9(e) {
  const { item: n, sectionId: r, disabled: a, locked: o, renderAttachment: l } = e;
  return n.type === "file" ? /* @__PURE__ */ p.jsx(p.Fragment, { children: l({ sectionId: r, item: n, disabled: a, locked: o }) }) : n.type === "boolean" ? /* @__PURE__ */ p.jsx(VI, { ...e }) : /* @__PURE__ */ p.jsx(GI, { ...e });
}
function KI(e) {
  return /* @__PURE__ */ p.jsxs(
    Pe,
    {
      sx: {
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "center",
        rowGap: 1.25,
        columnGap: 2.5
      },
      children: [
        /* @__PURE__ */ p.jsx(
          Te,
          {
            variant: "subtitle1",
            sx: { fontWeight: 600, flex: "1 1 320px", minWidth: 0 },
            children: e.item.label
          }
        ),
        /* @__PURE__ */ p.jsx(O9, { ...e })
      ]
    }
  );
}
function YI({
  item: e,
  showNotApplicable: n,
  onChange: r
}) {
  return /* @__PURE__ */ p.jsxs(
    Pe,
    {
      sx: {
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "space-between",
        rowGap: 1.25,
        columnGap: 2.5
      },
      children: [
        /* @__PURE__ */ p.jsx(
          Te,
          {
            variant: "subtitle1",
            sx: { fontWeight: 600, flex: "1 1 auto", minWidth: 0 },
            children: e.label
          }
        ),
        n && /* @__PURE__ */ p.jsx(
          lt,
          {
            variant: "outlined",
            sx: { flexShrink: 0 },
            onClick: () => r(e, { status: "not_applicable" }, !0),
            children: "Not applicable this year"
          }
        )
      ]
    }
  );
}
function ZI({
  item: e,
  disabled: n,
  onChange: r
}) {
  return /* @__PURE__ */ p.jsxs(
    Pe,
    {
      "data-testid": "organizer-not-applicable",
      sx: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1,
        minHeight: rr,
        pl: 1.5,
        pr: 0.5,
        borderRadius: 1,
        bgcolor: "common.neutrals.100"
      },
      children: [
        /* @__PURE__ */ p.jsx(Te, { children: "You marked this not applicable this year." }),
        !n && /* @__PURE__ */ p.jsx(
          Ii,
          {
            component: "button",
            type: "button",
            onClick: () => r(e, { status: "pending" }, !0),
            sx: {
              minHeight: rr,
              minWidth: rr,
              px: 1,
              flexShrink: 0,
              fontWeight: 600,
              color: "common.secondary.700",
              textDecoration: "underline"
            },
            children: "Undo"
          }
        )
      ]
    }
  );
}
function QI({ sectionId: e, item: n, validationErrors: r }, a) {
  var d;
  const o = (d = r == null ? void 0 : r.find(
    (c) => c.section_id === e && c.item_id === n.id
  )) == null ? void 0 : d.message, l = n.type !== "file" && n.type !== "boolean" && !a;
  return l ? { inside: o, inField: l } : { below: o, inField: l };
}
function F9(e) {
  const { item: n, disabled: r, isMobile: a, onChange: o } = e, l = n.status === "not_applicable", d = n.type === "file" && n.status !== "completed" && !r && !l, c = n.type === "boolean" && !a && !l, f = n.type === "file" || n.type === "boolean" && !c, { inside: s, below: h, inField: g } = QI(e, l);
  return /* @__PURE__ */ p.jsxs(Pe, { sx: { gap: 1.5 }, children: [
    c && /* @__PURE__ */ p.jsx(KI, { ...e }),
    f && /* @__PURE__ */ p.jsx(
      YI,
      {
        item: n,
        showNotApplicable: d,
        onChange: o
      }
    ),
    n.help_text && !g && /* @__PURE__ */ p.jsx(Te, { variant: "body2", children: n.help_text }),
    l && /* @__PURE__ */ p.jsx(
      ZI,
      {
        item: n,
        disabled: r,
        onChange: o
      }
    ),
    !l && !c && /* @__PURE__ */ p.jsx(
      O9,
      {
        ...e,
        message: s,
        hint: n.help_text ?? void 0
      }
    ),
    h && /* @__PURE__ */ p.jsx(Te, { role: "alert", sx: { color: "common.error.600" }, children: h }),
    v9(n).map((t) => /* @__PURE__ */ p.jsx(
      Me,
      {
        "data-testid": "organizer-follow-up",
        "data-organizer-field": t.id,
        sx: { bgcolor: "common.neutrals.100", borderRadius: 2, p: 2 },
        children: /* @__PURE__ */ p.jsx(F9, { ...e, followUp: !0, item: t })
      },
      t.id
    ))
  ] });
}
const JI = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
  rowGap: 2.25,
  columnGap: 2.5
};
function eT(e) {
  return /street|occupation/i.test(e.id);
}
function tT(e) {
  if (e.status === "not_applicable") return "Not applicable";
  const n = ro(e);
  return typeof n == "boolean" ? n ? "Yes" : "No" : (typeof n == "string" || typeof n == "number") && String(n) || "Not provided";
}
function nT({ title: e, complete: n }) {
  return /* @__PURE__ */ p.jsxs(
    Pe,
    {
      sx: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1
      },
      children: [
        /* @__PURE__ */ p.jsx(Te, { variant: "h4", children: e }),
        n && /* @__PURE__ */ p.jsx(
          fr,
          {
            label: "Confirmed",
            size: "small",
            sx: {
              bgcolor: "common.success.50",
              color: "success.dark",
              borderRadius: 100,
              px: 0.5,
              "& .MuiChip-label": {
                px: 1,
                py: 0.25,
                fontSize: (r) => r.typography.pxToRem(14),
                fontWeight: 700
              }
            }
          }
        )
      ]
    }
  );
}
function iT({
  card: e,
  fieldProps: n
}) {
  const r = e.confirmation;
  return /* @__PURE__ */ p.jsx(Me, { sx: r ? JI : { display: "contents" }, children: e.items.map((a) => /* @__PURE__ */ p.jsx(
    Me,
    {
      "data-organizer-field": a.id,
      sx: r && eT(a) ? { gridColumn: "1 / -1" } : void 0,
      children: /* @__PURE__ */ p.jsx(
        F9,
        {
          ...n,
          large: r,
          item: a,
          onBlur: r ? () => {
          } : n.onBlur
        }
      )
    },
    a.id
  )) });
}
function rT({
  card: e,
  sectionId: n,
  validationErrors: r
}) {
  return /* @__PURE__ */ p.jsx(
    Me,
    {
      sx: {
        display: "grid",
        gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
        columnGap: 3
      },
      children: pr(e.items).map((a) => /* @__PURE__ */ p.jsxs(
        Me,
        {
          sx: { py: 1.5, borderBottom: 1, borderColor: "divider" },
          children: [
            /* @__PURE__ */ p.jsx(Te, { variant: "subtitle2", children: a.label }),
            /* @__PURE__ */ p.jsx(
              Te,
              {
                variant: "h5",
                sx: { whiteSpace: "pre-line", overflowWrap: "anywhere" },
                children: tT(a)
              }
            ),
            r == null ? void 0 : r.filter(
              (o) => o.section_id === n && o.item_id === a.id
            ).map((o, l) => /* @__PURE__ */ p.jsx(Te, { role: "alert", sx: { color: "common.error.600" }, children: o.message }, l))
          ]
        },
        a.id
      ))
    }
  );
}
function sT({
  card: e,
  editing: n,
  complete: r,
  canConfirm: a = !0,
  onEdit: o,
  onCancel: l,
  onConfirm: d
}) {
  return /* @__PURE__ */ p.jsxs(
    Pe,
    {
      "data-organizer-actions": !0,
      sx: {
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "stretch", md: "flex-start" },
        gap: 1.5
      },
      children: [
        (n || !r && a) && /* @__PURE__ */ p.jsx(
          lt,
          {
            variant: "contained",
            startIcon: /* @__PURE__ */ p.jsx(it, { icon: "check" }),
            onClick: () => d(pr(e.items)),
            sx: { flex: { xs: 1, md: "0 0 auto" } },
            children: n ? "Save changes" : "Yes, this is correct"
          }
        ),
        /* @__PURE__ */ p.jsx(
          lt,
          {
            variant: "outlined",
            "data-organizer-edit": n ? void 0 : "",
            startIcon: n ? void 0 : /* @__PURE__ */ p.jsx(it, { icon: "pencil" }),
            onClick: n ? l : o,
            children: n ? "Cancel" : "Edit"
          }
        )
      ]
    }
  );
}
const aT = {
  bgcolor: "common.black",
  color: "common.white",
  fontSize: "0.9375rem",
  fontWeight: 400,
  lineHeight: 1.4,
  maxWidth: 260,
  px: 1.5,
  py: 1.25,
  borderRadius: 1
};
function oT({
  reason: e,
  children: n
}) {
  return e ? /* @__PURE__ */ p.jsx(
    ja,
    {
      title: e,
      describeChild: !0,
      disableInteractive: !0,
      followCursor: !0,
      placement: "top",
      componentsProps: { tooltip: { sx: aT } },
      children: n
    }
  ) : n;
}
function cT({
  card: e,
  confirmed: n,
  editing: r,
  canConfirm: a,
  lockedReason: o,
  lockNoticeId: l,
  onEdit: d,
  onCancel: c,
  onConfirm: f,
  ...s
}) {
  const h = U0(e.items), g = !e.confirmation || r, t = e.confirmation && !s.disabled, i = /* @__PURE__ */ p.jsx(
    Me,
    {
      component: "section",
      "aria-label": e.title,
      "aria-describedby": o ? l : void 0,
      tabIndex: -1,
      "data-organizer-card": Pi(s.sectionId, e.id),
      sx: {
        ...Zr,
        borderRadius: e.confirmation ? 4 : 3,
        borderColor: r ? "secondary.main" : "divider",
        p: { xs: 2.5, md: 3.5 },
        scrollMarginTop: 120,
        ...o && {
          "&& .MuiFormControlLabel-label.Mui-disabled": {
            color: "text.primary"
          }
        }
      },
      children: /* @__PURE__ */ p.jsxs(Pe, { sx: { gap: 2.5 }, children: [
        e.confirmation && /* @__PURE__ */ p.jsx(nT, { title: e.title, complete: n }),
        g ? /* @__PURE__ */ p.jsx(
          iT,
          {
            card: e,
            fieldProps: { ...s, readableLock: !!o }
          }
        ) : /* @__PURE__ */ p.jsx(
          rT,
          {
            card: e,
            sectionId: s.sectionId,
            validationErrors: s.validationErrors
          }
        ),
        t && /* @__PURE__ */ p.jsx(
          sT,
          {
            card: e,
            editing: r,
            complete: h,
            canConfirm: a,
            onEdit: d,
            onCancel: c,
            onConfirm: f
          }
        )
      ] })
    }
  );
  return /* @__PURE__ */ p.jsx(oT, { reason: o, children: i });
}
function lT(e, n, r = QE) {
  const a = ut(/* @__PURE__ */ new Map()), o = ut(Promise.resolve()), l = ut(/* @__PURE__ */ new Set()), [d, c] = Ee(0), [f, s] = Ee(!1), [h, g] = Ee(!1), t = () => c((E) => E + 1), i = (E, S = !1) => {
    var y;
    for (const x of E) {
      const b = Pi(x.sectionId, x.itemId);
      S ? l.current.add(b) : l.current.delete(b);
      const u = { ...(y = a.current.get(b)) == null ? void 0 : y.patch, ...x.patch };
      "client_value" in x.patch && !("status" in x.patch) && delete u.status, a.current.set(b, { ...x, patch: u });
    }
    t();
  }, m = (E) => {
    E.forEach((S) => {
      a.current.delete(S), l.current.delete(S);
    }), a.current.size || g(!1), t();
  }, v = (E = !1) => {
    const S = o.current.catch(() => {
    }).then(async () => {
      const y = Array.from(a.current.entries()).filter(
        ([x]) => E || !l.current.has(x)
      );
      if (y.forEach(([x]) => l.current.delete(x)), !y.length) return !1;
      s(!0), g(!1);
      try {
        await n(y.map(([, x]) => x));
        for (const [x, b] of y)
          a.current.get(x) === b && a.current.delete(x);
        return t(), !0;
      } catch (x) {
        throw g(!0), x;
      } finally {
        s(!1);
      }
    });
    return o.current = S, S;
  };
  return {
    sections: r(
      e,
      Array.from(a.current.entries()).map(
        ([E, S]) => l.current.has(E) ? {
          ...S,
          patch: { ...S.patch, status: "pending" }
        } : S
      )
    ),
    stage: i,
    discard: m,
    flush: v,
    saving: f,
    error: h,
    dirty: a.current.size > 0,
    /** Item keys with an unsaved or failed edit. */
    pendingKeys: new Set(a.current.keys())
  };
}
function uT(e) {
  const [n, r] = Ee(!1), [a, o] = Ee(/* @__PURE__ */ new Set()), l = () => o(new Set(e));
  return {
    showUnanswered: n,
    filterUnanswered: (d) => {
      r(d), l();
    },
    refresh: l,
    lists: (d) => !n || e.has(d) || a.has(d)
  };
}
const dT = "Your changes couldn't be saved. Check your connection and try saving again.";
function hT(e) {
  requestAnimationFrame(
    () => {
      var n, r;
      return (r = (n = e.current) == null ? void 0 : n.querySelector("[data-organizer-error-summary], [data-organizer-step-heading]")) == null ? void 0 : r.focus({ preventScroll: !0 });
    }
  );
}
function fT(e, n) {
  if (e !== "rejected")
    return n || e === "error" ? dT : void 0;
}
function pT(e) {
  var r, a;
  const n = e == null ? void 0 : e.querySelector("[data-welcome-editor]");
  (r = n == null ? void 0 : n.scrollIntoView) == null || r.call(n, { block: "center" }), (a = n == null ? void 0 : n.querySelector("textarea")) == null || a.focus();
}
function gT(e) {
  var ge;
  const { isMobile: n } = ri(), r = lT(
    e.sections,
    e.onSaveItems,
    e.applyUpdates
  ), a = ut(null), [o, l] = Ee(e.initialStep ?? 0), [d, c] = Ee(!1), [f, s] = Ee(!1), [h, g] = Ee(
    () => e.initialStep === e.sections.length ? Io(e.sections) : []
  ), [t, i] = Ee({}), [m, v] = Ee(!1), [E, S] = Ee(!1), [y, x] = Ee({}), [b, u] = Ee(!!e.submitted), [I, O] = Ee(!!e.submitted), [D, $] = Ee(!1), [K, H] = Ee(), B = b || !!e.submitted, R = !!e.readOnly || !e.preview && B, _ = R && !e.preview, A = dc(), k = !!e.busy || D, z = r.sections, T = Math.min(o, z.length), w = T === z.length, F = ch(z), j = e.savedSections ?? e.sections, P = ch(j), V = j.map(cI), J = /* @__PURE__ */ new Set([...Io(z), ...Io(j)]), ne = uT(J), Z = ut(/* @__PURE__ */ new Map()), te = new Set(
    z.flatMap(
      (me) => $s(me).map(
        (xe) => Pi(me.id, xe.id)
      )
    )
  ), G = Object.fromEntries(
    Object.entries(t).filter(
      ([me, xe]) => xe && te.has(me)
    )
  ), N = m || Object.keys(G).length > 0, { onEditingChange: q } = e;
  ot(() => (q == null || q(N), () => q == null ? void 0 : q(!1)), [N, q]);
  const ie = e.saveError || K || fT(e.saveStatus, r.error), oe = (me) => {
    Z.current.delete(me), i((xe) => ({ ...xe, [me]: !1 }));
  }, fe = Object.keys(t).filter(
    (me) => t[me] && !te.has(me)
  ), Y = fe.join("|");
  ot(() => {
    fe.length && (r.discard(
      fe.flatMap((me) => Z.current.get(me) ?? [])
    ), i((me) => ({
      ...me,
      ...Object.fromEntries(fe.map((xe) => [xe, !1]))
    })), fe.forEach((me) => Z.current.delete(me)));
  }, [Y]);
  const ae = (me) => {
    var xe;
    return Array.from(
      ((xe = a.current) == null ? void 0 : xe.querySelectorAll("[data-organizer-card]")) ?? []
    ).find((ye) => ye.dataset.organizerCard === me);
  }, se = (me, { all: xe = !1, focusHeading: ye = !0 } = {}) => {
    var Ce, Ie;
    if (k) return !1;
    const ve = Object.keys(G)[0];
    return N ? (c(!1), requestAnimationFrame(() => {
      var Ae, Se;
      if (ve) {
        (Se = (Ae = ae(ve)) == null ? void 0 : Ae.scrollIntoView) == null || Se.call(Ae, { block: "center" });
        return;
      }
      pT(a.current);
    }), !1) : (l(me), c(!1), s(xe), ne.refresh(), me === z.length && g(Io(z)), (Ie = (Ce = a.current) == null ? void 0 : Ce.scrollIntoView) == null || Ie.call(Ce, { block: "start" }), ye && !n && hT(a), !0);
  }, L = lI(z, J), W = () => {
    const me = L;
    R || !me || !se(me.index, { focusHeading: !1 }) || requestAnimationFrame(() => {
      var ye;
      const xe = ae(me.key);
      (ye = xe == null ? void 0 : xe.scrollIntoView) == null || ye.call(xe, { block: "center" }), xe == null || xe.focus({ preventScroll: !0 });
    });
  }, M = new Set(
    (ge = e.validationErrors) == null ? void 0 : ge.map(
      (me) => Pi(me.section_id, me.item_id)
    )
  ), X = HI(z, e.validationErrors), U = (me) => {
    const { step: xe, cardKey: ye, itemId: ve } = me;
    xe === void 0 || ye === void 0 || !(ae(ye) !== void 0) && xe !== T && !se(xe, { focusHeading: !1 }) || requestAnimationFrame(() => {
      const Ie = ae(ye);
      Ie && WI(Ie, ve);
    });
  }, Q = (me) => $s(me).filter((xe) => {
    const ye = Pi(me.id, xe.id), ve = pr(xe.items).some((Ce) => {
      const Ie = Pi(me.id, Ce.id);
      return M.has(Ie) || r.pendingKeys.has(Ie);
    });
    return R || G[ye] || ve ? !0 : w ? f || h.includes(ye) : ne.lists(ye);
  }), re = async (me = [], xe) => {
    r.stage(me);
    try {
      await r.flush() && H(void 0), xe == null || xe();
    } catch {
    }
  }, le = async (me, xe, ye = !0) => {
    if (!k) {
      $(!0), H(void 0);
      try {
        !R && ye && await r.flush(!0), await me(), xe == null || xe();
      } catch (ve) {
        sI(ve) || H(
          "This action could not be completed. Your answers are still here. Please try again."
        );
      } finally {
        $(!1);
      }
    }
  }, ce = (me, xe, ye, ve = !1, Ce = !1) => {
    if (R || k) return;
    const Ie = [{ sectionId: me, itemId: xe.id, patch: ye }];
    ve ? re(Ie) : r.stage(Ie, Ce);
  }, ee = (me, xe) => {
    const ye = Pi(me.id, xe.id);
    return /* @__PURE__ */ p.jsx(
      cT,
      {
        card: xe,
        confirmed: oI(
          j,
          me.id,
          xe,
          e.validationErrors
        ),
        sectionId: me.id,
        disabled: R || k || !!y[ye],
        locked: R,
        lockedReason: e.lockedReason,
        lockNoticeId: A,
        isMobile: n,
        canConfirm: e.canConfirm,
        editing: !!G[ye],
        renderAttachment: e.renderAttachment,
        validationErrors: e.validationErrors,
        onChange: (ve, Ce, Ie) => ce(
          me.id,
          ve,
          Ce,
          Ie && !xe.confirmation,
          xe.confirmation
        ),
        onBlur: () => {
          !R && !k && re();
        },
        onEdit: () => {
          Z.current.set(
            ye,
            pr(xe.items).map(
              (ve) => Pi(me.id, ve.id)
            )
          ), i((ve) => ({ ...ve, [ye]: !0 })), requestAnimationFrame(() => {
            var ve, Ce, Ie;
            (Ie = (Ce = (ve = ae(ye)) == null ? void 0 : ve.querySelector("[data-organizer-actions]")) == null ? void 0 : Ce.scrollIntoView) == null || Ie.call(Ce, { block: "center" });
          });
        },
        onCancel: () => {
          r.discard(
            pr(xe.items).map(
              (ve) => Pi(me.id, ve.id)
            )
          ), oe(ye);
        },
        onConfirm: async (ve) => {
          x((Ie) => ({ ...Ie, [ye]: !0 }));
          const Ce = ve.filter((Ie) => Ie.type !== "file").filter(
            (Ie) => e.canConfirm !== !1 || r.pendingKeys.has(Pi(me.id, Ie.id))
          ).map((Ie) => ({
            sectionId: me.id,
            itemId: Ie.id,
            patch: Ie.status === "not_applicable" ? { status: "not_applicable" } : { client_value: ro(Ie) }
          }));
          await re(Ce, () => oe(ye)), x((Ie) => ({ ...Ie, [ye]: !1 }));
        }
      },
      ye
    );
  }, { onMessage: he } = e, pe = he ? () => void le(he) : void 0, de = {
    sections: j,
    sectionProgress: V,
    step: T,
    progress: P.progress,
    onResume: !R && L ? W : void 0,
    submitted: B,
    preview: e.preview,
    embedded: e.embedded,
    sheet: d,
    onSheet: c,
    onGo: se,
    onMessage: pe,
    busy: k
  };
  return {
    root: a,
    drafts: r,
    currentStep: T,
    sections: z,
    reviewing: w,
    progress: F,
    busy: k,
    error: ie,
    readOnly: R,
    showsSubmitted: _,
    lockNoticeId: A,
    openMessage: pe,
    isSubmitted: B,
    confirmation: I,
    navigation: de,
    showAll: f,
    showUnanswered: ne.showUnanswered,
    filterUnanswered: ne.filterUnanswered,
    listedCards: Q,
    errorEntries: X,
    saveRejected: e.saveStatus === "rejected",
    selectError: U,
    reviewKeys: h,
    editing: G,
    isEditing: N,
    welcomeEditing: m,
    welcomeSaving: E,
    setShowAll: s,
    setReviewKeys: g,
    setConfirmation: O,
    setActionError: H,
    setSubmitted: u,
    setWelcomeEditing: v,
    setWelcomeSaving: S,
    go: se,
    action: le,
    renderCard: ee
  };
}
function _$(e) {
  const n = gT(e), {
    root: r,
    drafts: a,
    sections: o,
    busy: l,
    error: d,
    readOnly: c,
    confirmation: f,
    navigation: s,
    setConfirmation: h,
    setActionError: g,
    go: t,
    action: i
  } = n, m = n.reviewing && n.showsSubmitted, v = e.embedded, { handleRef: E } = e, { currentStep: S } = n;
  ot(() => {
    if (E)
      return E.current = { flush: () => a.flush(!0), step: S }, () => {
        E.current = null;
      };
  });
  const y = () => void i(e.onPrint), x = () => {
    g(void 0), i(
      async () => {
        var b;
        await ((b = e.onRetry) == null ? void 0 : b.call(e)), await a.flush();
      },
      void 0,
      !1
    );
  };
  return /* @__PURE__ */ p.jsxs(
    Me,
    {
      ref: r,
      sx: {
        minHeight: v ? "auto" : "100vh",
        flexShrink: 0,
        bgcolor: "common.neutrals.100",
        color: "text.primary",
        "& .MuiButton-root": {
          minHeight: 44
        },
        "& .MuiOutlinedInput-root": { borderRadius: 2 }
      },
      children: [
        v ? /* @__PURE__ */ p.jsx(S9, { error: d, busy: l, onRetry: x }) : /* @__PURE__ */ p.jsx(
          OI,
          {
            ...e,
            busy: l,
            dirty: a.dirty || e.saveStatus === "rejected" || n.welcomeEditing,
            saving: a.saving || e.saveStatus === "saving" || n.welcomeSaving,
            error: d,
            readOnly: c,
            onPrint: y,
            onExit: () => {
              n.welcomeSaving || i(e.onSaveExit);
            },
            onRetry: x
          }
        ),
        f ? /* @__PURE__ */ p.jsx(
          mI,
          {
            onPrint: y,
            onMessage: n.openMessage,
            preview: e.preview,
            busy: l,
            onView: () => {
              h(!1), t(o.length, { all: !0 });
            }
          }
        ) : /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
          /* @__PURE__ */ p.jsx(
            UI,
            {
              ...s,
              hidden: m,
              onPrint: v ? void 0 : y
            }
          ),
          /* @__PURE__ */ p.jsxs(
            Me,
            {
              sx: {
                maxWidth: 1200,
                mx: "auto",
                px: { xs: 2, md: 3 },
                pt: { xs: 2.5, md: 4 },
                display: "flex",
                alignItems: "flex-start",
                gap: 5
              },
              children: [
                /* @__PURE__ */ p.jsx(LI, { ...s }),
                /* @__PURE__ */ p.jsx(
                  bI,
                  {
                    model: n,
                    props: e,
                    onPrint: y
                  }
                )
              ]
            }
          )
        ] })
      ]
    }
  );
}
const mT = Nn.lazy(
  () => import("./RequestsListViewMobile-DdYJPMyf.js")
), xT = Nn.lazy(
  () => import("./RequestsListViewDesktop-DykoDBLs.js")
);
function C$() {
  return /* @__PURE__ */ p.jsx(
    C5,
    {
      SmallView: /* @__PURE__ */ p.jsx(mT, {}),
      LargeView: /* @__PURE__ */ p.jsx(xT, {})
    }
  );
}
const A$ = (e) => {
  const n = Ls(({ auth_token: a }) => a);
  return `${Jt().client.getUri()}/api/v5/workflow/${e}/to_pdf?token=${n}`;
};
Qa((e) => ({
  showUnansweredOnly: !1,
  setShowUnansweredOnly: (n) => e(() => ({ showUnansweredOnly: n }))
}));
const bT = "data:image/svg+xml,%3csvg%20width='289'%20height='249'%20viewBox='0%200%20289%20249'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='124.001'%20cy='124.325'%20r='123.825'%20fill='%23EEF0F1'/%3e%3crect%20x='25.0039'%20y='32.1117'%20width='196.997'%20height='39.5878'%20rx='6.89217'%20fill='%23CBEDF3'/%3e%3crect%20x='31.8945'%20y='40.1235'%20width='23.5642'%20height='23.5642'%20rx='4.71284'%20fill='%2380D7E6'/%3e%3crect%20x='25.0039'%20y='80.3147'%20width='196.997'%20height='39.5878'%20rx='6.89217'%20fill='%23CBEDF3'/%3e%3crect%20x='31.8945'%20y='88.3265'%20width='23.5642'%20height='23.5642'%20rx='4.71284'%20fill='%2380D7E6'/%3e%3crect%20x='25.0039'%20y='128.518'%20width='196.997'%20height='39.5878'%20rx='6.89217'%20fill='%23CBEDF3'/%3e%3crect%20x='31.8945'%20y='136.53'%20width='23.5642'%20height='23.5642'%20rx='4.71284'%20fill='%2380D7E6'/%3e%3crect%20x='25.0039'%20y='176.721'%20width='196.997'%20height='39.5878'%20rx='6.89217'%20fill='%23CBEDF3'/%3e%3crect%20x='31.8945'%20y='184.733'%20width='23.5642'%20height='23.5642'%20rx='4.71284'%20fill='%2380D7E6'/%3e%3crect%20x='201'%20y='81.5'%20width='88'%20height='88'%20rx='44'%20fill='%23DFE3E8'/%3e%3c/svg%3e", yT = tt(Me)({
  position: "relative",
  // request-submit-success.svg is 289x249
  paddingTop: `${249 / 289 * 100}%`,
  width: "100%",
  overflow: "hidden"
}), vT = tt(Me)({
  position: "absolute",
  // Position animation to display over the bg image circle area
  right: "14.6%",
  top: "49.25%",
  // This scales the animation to the relative sizef of it's container
  // It just happens to be the case that 100% fits the animation correctly
  width: "100%"
}), wT = ({
  animationProps: e = {},
  ...n
}) => /* @__PURE__ */ p.jsxs(yT, { ...n, children: [
  /* @__PURE__ */ p.jsx(
    Me,
    {
      component: "img",
      src: bT,
      position: "absolute",
      width: "100%",
      top: 0,
      left: 0
    }
  ),
  /* @__PURE__ */ p.jsx(vT, { children: /* @__PURE__ */ p.jsx(
    A5,
    {
      autoplay: !0,
      style: { transform: "translate(50%,-49%)" },
      ...e
    }
  ) })
] }), ST = tt(Pe)(({ theme: e }) => ({
  flex: "1",
  backgroundColor: e.palette.common.neutrals[100],
  padding: `0px ${e.spacing(3)}`,
  overflowY: "auto",
  alignItems: "center",
  justifyContent: "center"
})), _T = () => /* @__PURE__ */ p.jsxs(ST, { gap: 1, position: "relative", children: [
  /* @__PURE__ */ p.jsx(Me, { minWidth: 248, children: /* @__PURE__ */ p.jsx(wT, {}) }),
  /* @__PURE__ */ p.jsx(Te, { variant: "h5", children: "Thank you!" }),
  /* @__PURE__ */ p.jsx(Te, { variant: "body1", children: "Your responses were submitted successfully." })
] }), CT = tt(Pe)(({ theme: e }) => ({
  zIndex: e.zIndex.appBar,
  alignItems: "end",
  [e.breakpoints.down("md")]: {
    alignItems: "normal"
  },
  minHeight: "72.5px"
})), Yp = tt(lt)(({ theme: e }) => ({
  color: e.palette.common.neutrals[800]
})), AT = () => {
  const {
    hasNextSection: e,
    hasPreviousSection: n,
    navigateToTheNextSection: r,
    navigateToThePreviousSection: a
  } = _c();
  return !e && !n ? null : /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsx(wn, {}),
    /* @__PURE__ */ p.jsxs(CT, { p: 2, direction: "row", justifyContent: "space-between", children: [
      /* @__PURE__ */ p.jsx(Me, { children: n && /* @__PURE__ */ p.jsx(
        Yp,
        {
          onClick: a,
          startIcon: /* @__PURE__ */ p.jsx(it, { icon: "chevronLeft", fontSize: "small" }),
          children: "Previous section"
        }
      ) }),
      /* @__PURE__ */ p.jsx(Me, { children: e && /* @__PURE__ */ p.jsx(
        Yp,
        {
          onClick: r,
          endIcon: /* @__PURE__ */ p.jsx(it, { icon: "chevronRight", fontSize: "small" }),
          children: "Next section"
        }
      ) })
    ] })
  ] });
};
function kT({
  question: e,
  disabled: n = !1
}) {
  const { hideRequestNotApplicableOnBoolean: r } = Dr(), { answerQuestion: a, answerQuestionNotApplicable: o } = xi(), l = e.notApplicable ? void 0 : e.value, d = Oe(
    (c) => {
      e.notApplicable && o(e.id, !1), a({ id: e.id, value: c });
    },
    [
      a,
      o,
      e.id,
      e.notApplicable
    ]
  );
  return /* @__PURE__ */ p.jsxs(Pe, { direction: "row", justifyContent: "space-between", gap: 1, children: [
    /* @__PURE__ */ p.jsx(
      lt,
      {
        disabled: n,
        variant: l === !0 ? "contained" : "outlined",
        onClick: () => {
          d(!0);
        },
        children: "Yes"
      }
    ),
    /* @__PURE__ */ p.jsx(
      lt,
      {
        disabled: n,
        variant: l === !1 ? "contained" : "outlined",
        onClick: () => {
          d(!1);
        },
        children: "No"
      }
    ),
    !r && /* @__PURE__ */ p.jsx(
      lt,
      {
        disabled: n,
        variant: e.notApplicable ? "contained" : "outlined",
        onClick: () => {
          o(e.id, !e.notApplicable);
        },
        children: "N/A"
      }
    )
  ] });
}
const ET = ({
  documents: e = [],
  onCancel: n,
  disabled: r,
  ...a
}) => {
  const [o, l] = Ee(), { signedUrlData: d, setRetrievalToken: c, refreshSignedUrl: f, clearSignedUrl: s } = es();
  return e.length > 0 ? /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsx(Pe, { gap: 1, ...a, children: e.map((h) => /* @__PURE__ */ p.jsx(
      d0,
      {
        disabled: r,
        filename: h.filename || "",
        onClick: async () => {
          l(h), h.retrieval_token && (c(h.retrieval_token), await f());
        },
        onCancel: n ? () => n(h) : void 0
      },
      h.uuid
    )) }),
    (o == null ? void 0 : o.retrieval_token) && d && /* @__PURE__ */ p.jsx(
      Qs,
      {
        retrievalToken: o.retrieval_token,
        signedUrl: d.signed_url,
        fileName: d.filename,
        onClose: () => {
          l(void 0), s();
        }
      }
    )
  ] }) : null;
}, IT = ({
  question: e,
  disabled: n
}) => {
  const { answerQuestionFileUpload: r, answerQuestionNotApplicable: a } = xi(), o = e.value, l = Oe(
    async (g) => {
      await r({
        value: [...o, ...t9(g)],
        id: (e == null ? void 0 : e.id) || ""
      });
    },
    [e, o, r]
  ), [d, c] = Ee(), f = () => c(void 0), s = Tt(
    () => o.find((g) => g.uuid === d),
    [o, d]
  ), h = async () => {
    s && (await r({
      value: o.filter((g) => g.uuid !== s.uuid),
      id: (e == null ? void 0 : e.id) || ""
    }), f());
  };
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsxs(Pe, { flex: 1, children: [
      /* @__PURE__ */ p.jsxs(Pe, { direction: "row", gap: 2, alignItems: "center", children: [
        /* @__PURE__ */ p.jsx(Pe, { flex: 1, children: /* @__PURE__ */ p.jsx(
          R2,
          {
            name: "files",
            uploadType: cs.Workflow,
            disabled: n || e.notApplicable,
            hideFileDetails: !0,
            hideFilesList: !0,
            onChange: l,
            isDraft: !1
          },
          o.length
        ) }),
        /* @__PURE__ */ p.jsx(Pe, { children: /* @__PURE__ */ p.jsx(
          gk,
          {
            disabled: n,
            isNotApplicableQuestion: e.notApplicable,
            shouldShowConfirmationDialog: !!o.length,
            onSubmit: (g) => {
              a(e.id, g);
            }
          }
        ) })
      ] }),
      /* @__PURE__ */ p.jsx(Pe, { mt: 2, children: /* @__PURE__ */ p.jsx(
        ET,
        {
          documents: o,
          onCancel: (g) => c(g.uuid),
          disabled: n || e.notApplicable
        }
      ) })
    ] }),
    /* @__PURE__ */ p.jsxs(
      oi,
      {
        open: !!s,
        onClose: f,
        title: "Delete Attachment",
        cancelLabel: "No",
        onCancel: f,
        submitLabel: "Yes",
        onSubmit: h,
        children: [
          "You are about to delete the attached file ",
          /* @__PURE__ */ p.jsx("b", { children: s == null ? void 0 : s.filename }),
          ". This action cannot be undone. Proceed?"
        ]
      }
    )
  ] });
}, TT = tt(Te)(({ theme: e }) => ({
  color: e.palette.info.main
})), OT = () => /* @__PURE__ */ p.jsx(TT, { variant: "caption", children: "This field was pre-populated but edited by the client." }), FT = tt(vi)(({ theme: e }) => ({
  "& .MuiInputBase-root": {
    backgroundColor: e.palette.common.white
  },
  "& .MuiInputBase-root.Mui-disabled": {
    backgroundColor: "transparent"
  }
}));
function PT({
  disabled: e = !1,
  question: n
}) {
  const { hideRequestNotApplicableOnText: r } = Dr(), { answerQuestion: a, answerQuestionNotApplicable: o } = xi(), l = (n == null ? void 0 : n.value) || "", d = (n == null ? void 0 : n.prepopulatedEdited) || !1, { register: c, getValues: f } = mr({
    defaultValues: {
      shortAnswerValue: l
    }
  }), s = c("shortAnswerValue");
  if (typeof l != "string")
    throw new Error("Wrong value for short answer type question");
  const h = Oe(() => {
    const g = f("shortAnswerValue");
    a({ id: n.id, value: g });
  }, [a, f, n.id]);
  return /* @__PURE__ */ p.jsxs(Pe, { flex: 1, direction: "row", gap: 1, alignItems: "center", children: [
    /* @__PURE__ */ p.jsxs(Me, { flex: 1, children: [
      /* @__PURE__ */ p.jsx(
        FT,
        {
          fullWidth: !0,
          "data-testid": "request-short-answer-text",
          ...s,
          onBlur: (g) => {
            h(), s.onBlur(g);
          },
          disabled: !r && n.notApplicable || e
        }
      ),
      d && /* @__PURE__ */ p.jsx(OT, {}),
      n.hint && /* @__PURE__ */ p.jsx(xk, { children: n.hint })
    ] }),
    !r && /* @__PURE__ */ p.jsx(
      lt,
      {
        disabled: e,
        variant: n.notApplicable ? "contained" : "outlined",
        onClick: () => {
          o(n.id, !n.notApplicable);
        },
        children: "N/A"
      }
    )
  ] });
}
function Zp({
  value: e
}) {
  const [n, r] = Ee(!1), {
    signedUrlData: a,
    setRetrievalToken: o,
    refreshSignedUrl: l,
    clearSignedUrl: d
  } = es();
  return e ? /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsx(
      lt,
      {
        variant: "text",
        onClick: async () => {
          e.retrieval_token && (o(e.retrieval_token), await l(), r(!0));
        },
        startIcon: /* @__PURE__ */ p.jsx(it, { icon: "preview" }),
        sx: {
          minWidth: "150px",
          paddingTop: "0px",
          paddingLeft: "2px",
          justifyContent: "flex-start"
        },
        children: /* @__PURE__ */ p.jsx(Te, { variant: "h4", children: e.filename })
      },
      e.uuid
    ),
    n && a && /* @__PURE__ */ p.jsx(
      Qs,
      {
        retrievalToken: e.retrieval_token,
        signedUrl: a.signed_url,
        fileName: a.filename,
        onClose: () => {
          r(!1), d();
        }
      }
    )
  ] }) : null;
}
const jT = tt(Me)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "column",
  gap: e.spacing(1),
  justifyContent: "center",
  padding: e.spacing(3)
})), Qp = ({
  title: e,
  amountDueInCents: n,
  refundInCents: r,
  alignItems: a = "center",
  paymentVoucherToken: o,
  paymentPortalUrl: l
}) => {
  const d = !!(l || o), { isMobile: c } = ri(), f = r != null && r !== void 0, s = f ? r : (n || 0) * -1;
  return /* @__PURE__ */ p.jsxs(hc, { variant: "outlined", children: [
    /* @__PURE__ */ p.jsxs(
      Pe,
      {
        p: 2,
        alignItems: "center",
        justifyContent: "space-between",
        direction: "row",
        children: [
          /* @__PURE__ */ p.jsx(Te, { children: e }),
          c && /* @__PURE__ */ p.jsx(ih, { isRefund: f, amountInCents: s })
        ]
      }
    ),
    /* @__PURE__ */ p.jsx(wn, {}),
    /* @__PURE__ */ p.jsxs(jT, { alignItems: a, children: [
      !c && /* @__PURE__ */ p.jsx(ih, { isRefund: f, amountInCents: s }),
      /* @__PURE__ */ p.jsx(
        Lk,
        {
          alignItems: a,
          amountInCents: s
        }
      ),
      d && /* @__PURE__ */ p.jsx(
        i9,
        {
          paymentPortalUrl: l,
          paymentVoucherToken: o
        }
      )
    ] })
  ] });
}, RT = ({
  fetchUrl: e
}) => {
  var c;
  const { client: n } = Jt(), { data: r, isLoading: a, isError: o } = Sn({
    queryKey: ["balance-item", e],
    queryFn: () => n.get(e)
  }), { isMobile: l } = ri(), d = Tt(() => {
    var g;
    if (!((g = r == null ? void 0 : r.data) != null && g.key_amounts)) return [];
    const f = r.data.key_amounts, s = f.filter((t) => !t.locality).sort((t, i) => t.jurisdiction === "US" ? -1 : i.jurisdiction === "US" ? 1 : t.jurisdiction.localeCompare(i.jurisdiction)), h = f.filter((t) => !!t.locality);
    return s.map((t) => {
      const i = h.filter(
        (m) => m.jurisdiction === t.jurisdiction
      );
      return { state: t, localities: i };
    });
  }, [(c = r == null ? void 0 : r.data) == null ? void 0 : c.key_amounts]);
  return a ? /* @__PURE__ */ p.jsx(nx, {}) : o ? /* @__PURE__ */ p.jsx("div", { children: "Error loading balance items" }) : /* @__PURE__ */ p.jsx(Me, { width: "100%", children: d.map(({ state: f, localities: s }) => {
    var h, g;
    return /* @__PURE__ */ p.jsxs(Me, { width: "100%", children: [
      /* @__PURE__ */ p.jsx(Me, { marginBottom: 2, width: "100%", children: /* @__PURE__ */ p.jsx(
        Qp,
        {
          title: f.label,
          amountDueInCents: f.amount_due_in_cents,
          refundInCents: f.refund_in_cents,
          paymentPortalUrl: ((h = f.rpv_payment_link) == null ? void 0 : h.payment_url) ?? void 0,
          paymentVoucherToken: ((g = f.rpv_document) == null ? void 0 : g.retrieval_token) ?? void 0,
          alignItems: l ? "flex-end" : "flex-start"
        }
      ) }),
      s.map((t) => {
        var i, m;
        return /* @__PURE__ */ p.jsx(
          Me,
          {
            marginBottom: 2,
            width: "100%",
            sx: (v) => ({
              paddingLeft: v.spacing(3)
            }),
            children: /* @__PURE__ */ p.jsx(
              Qp,
              {
                title: t.label,
                amountDueInCents: t.amount_due_in_cents,
                refundInCents: t.refund_in_cents,
                paymentPortalUrl: ((i = t.rpv_payment_link) == null ? void 0 : i.payment_url) ?? void 0,
                paymentVoucherToken: ((m = t.rpv_document) == null ? void 0 : m.retrieval_token) ?? void 0,
                alignItems: l ? "flex-end" : "flex-start"
              }
            )
          },
          t.uuid || `${t.jurisdiction}-${t.locality}-${t.label}`
        );
      })
    ] }, f.uuid || `${f.jurisdiction}-${f.label}`);
  }) });
};
function MT({ question: e }) {
  var g;
  const n = Jt(), [r, a] = Ee(null), { signedUrlData: o, setRetrievalToken: l, refreshSignedUrl: d, clearSignedUrl: c } = es(), { data: f, isLoading: s } = Sn({
    queryKey: ["schedule_k1", (g = e.dependency) == null ? void 0 : g.read_url],
    queryFn: () => {
      var t;
      return n.client.get(
        ((t = e.dependency) == null ? void 0 : t.read_url) ?? ""
      );
    }
  }), h = f == null ? void 0 : f.data;
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsx(
      kk,
      {
        data: h || [],
        isLoading: s,
        onView: async (t) => {
          a(t), t != null && t.retrieval_token && (l(t.retrieval_token), await d());
        }
      }
    ),
    (r == null ? void 0 : r.retrieval_token) && o && /* @__PURE__ */ p.jsx(
      Qs,
      {
        retrievalToken: r.retrieval_token,
        signedUrl: o.signed_url,
        fileName: o.filename ?? "File",
        onClose: () => {
          a(null), c();
        }
      }
    )
  ] });
}
function DT({
  fetchUrl: e
}) {
  const n = Mr(), { client: r } = Jt(), { data: a } = Sn({
    queryKey: ["payment-estimate", e],
    queryFn: () => r.get(e)
  });
  return /* @__PURE__ */ p.jsx(
    Ek,
    {
      data: a == null ? void 0 : a.data,
      maxWidth: "45vw",
      backgroundColor: n.palette.common.neutrals[100]
    }
  );
}
const NT = tt(Te)(({ theme: e }) => ({
  color: e.palette.common.neutrals[500]
})), P9 = ({
  title: e,
  subtitle: n
}) => /* @__PURE__ */ p.jsxs(Pe, { direction: "row", gap: 2, alignItems: "center", children: [
  /* @__PURE__ */ p.jsx(Xs, {}),
  /* @__PURE__ */ p.jsxs(Pe, { children: [
    /* @__PURE__ */ p.jsx(Te, { variant: "h5", children: e }),
    n && /* @__PURE__ */ p.jsx(NT, { children: n })
  ] })
] }), LT = tt(Te)(({ theme: e }) => ({
  color: e.palette.common.neutrals[500]
})), Ur = ({ label: e, value: n }) => /* @__PURE__ */ p.jsxs(Pe, { direction: "row", justifyContent: "space-between", px: 2, py: 3, children: [
  /* @__PURE__ */ p.jsx(LT, { children: e }),
  !Array.isArray(n) && /* @__PURE__ */ p.jsx(Te, { children: n || "-" }),
  Array.isArray(n) && /* @__PURE__ */ p.jsx(Pe, { alignItems: "end", children: n.map((r, a) => /* @__PURE__ */ p.jsx(Te, { children: r }, a)) })
] }), j9 = ({
  addressStreet1: e,
  addressStreet2: n,
  addressCity: r,
  addressState: a,
  addressZipCode: o,
  addressCountry: l
}) => {
  const d = [];
  e && d.push(e), n && d.push(n);
  const c = [a, o, l].filter(Boolean).join(" "), f = r ? `${r}, ${c}` : c;
  return f && d.push(f), d;
}, BT = ({
  taxReturnSummary: e
}) => {
  var a, o, l, d, c, f, s, h, g, t, i, m, v, E, S, y, x;
  const n = e == null ? void 0 : e.profile, r = j9({
    addressCity: (o = (a = e == null ? void 0 : e.profile) == null ? void 0 : a.address) == null ? void 0 : o.city,
    addressCountry: (d = (l = e == null ? void 0 : e.profile) == null ? void 0 : l.address) == null ? void 0 : d.country,
    addressState: (f = (c = e == null ? void 0 : e.profile) == null ? void 0 : c.address) == null ? void 0 : f.state,
    addressStreet1: (h = (s = e == null ? void 0 : e.profile) == null ? void 0 : s.address) == null ? void 0 : h.street_1,
    addressStreet2: (t = (g = e == null ? void 0 : e.profile) == null ? void 0 : g.address) == null ? void 0 : t.street_2,
    addressZipCode: (m = (i = e == null ? void 0 : e.profile) == null ? void 0 : i.address) == null ? void 0 : m.zip
  });
  return /* @__PURE__ */ p.jsxs(Pe, { gap: 3, children: [
    /* @__PURE__ */ p.jsx(
      P9,
      {
        title: ((v = n == null ? void 0 : n.entity) == null ? void 0 : v.name) || "",
        subtitle: (E = n == null ? void 0 : n.entity) == null ? void 0 : E.partnership_name
      }
    ),
    /* @__PURE__ */ p.jsxs(Pe, { children: [
      /* @__PURE__ */ p.jsx(Ur, { label: "Address", value: r }),
      /* @__PURE__ */ p.jsx(wn, {}),
      /* @__PURE__ */ p.jsx(Ur, { label: "Phone", value: (S = n == null ? void 0 : n.entity) == null ? void 0 : S.phone }),
      /* @__PURE__ */ p.jsx(wn, {}),
      /* @__PURE__ */ p.jsx(Ur, { label: "Email", value: (y = n == null ? void 0 : n.entity) == null ? void 0 : y.email }),
      /* @__PURE__ */ p.jsx(wn, {}),
      /* @__PURE__ */ p.jsx(
        Ur,
        {
          label: "Signing Officer",
          value: (x = n == null ? void 0 : n.entity) == null ? void 0 : x.signer_name
        }
      )
    ] })
  ] });
}, $T = ({
  taxReturnSummary: e
}) => {
  var c, f, s, h, g, t, i, m, v, E, S, y, x, b, u, I, O;
  const n = e == null ? void 0 : e.profile, r = j9({
    addressCity: (f = (c = e == null ? void 0 : e.profile) == null ? void 0 : c.address) == null ? void 0 : f.city,
    addressCountry: (h = (s = e == null ? void 0 : e.profile) == null ? void 0 : s.address) == null ? void 0 : h.country,
    addressState: (t = (g = e == null ? void 0 : e.profile) == null ? void 0 : g.address) == null ? void 0 : t.state,
    addressStreet1: (m = (i = e == null ? void 0 : e.profile) == null ? void 0 : i.address) == null ? void 0 : m.street_1,
    addressStreet2: (E = (v = e == null ? void 0 : e.profile) == null ? void 0 : v.address) == null ? void 0 : E.street_2,
    addressZipCode: (y = (S = e == null ? void 0 : e.profile) == null ? void 0 : S.address) == null ? void 0 : y.zip
  }), { first_name: a, last_name: o, name: l } = (n == null ? void 0 : n.taxpayer) || {}, d = a && o ? `${a} ${o}`.trim() : l || "";
  return /* @__PURE__ */ p.jsxs(Pe, { gap: 3, children: [
    /* @__PURE__ */ p.jsx(
      P9,
      {
        title: d
      }
    ),
    /* @__PURE__ */ p.jsxs(Pe, { children: [
      /* @__PURE__ */ p.jsx(Ur, { label: "Address", value: r }),
      /* @__PURE__ */ p.jsx(wn, {}),
      /* @__PURE__ */ p.jsx(Ur, { label: "Phone", value: (x = n == null ? void 0 : n.taxpayer) == null ? void 0 : x.phone }),
      /* @__PURE__ */ p.jsx(wn, {}),
      /* @__PURE__ */ p.jsx(Ur, { label: "Email", value: (b = n == null ? void 0 : n.taxpayer) == null ? void 0 : b.email }),
      /* @__PURE__ */ p.jsx(wn, {}),
      /* @__PURE__ */ p.jsx(
        Ur,
        {
          label: "Bank Routing #",
          value: (u = n == null ? void 0 : n.bank_information) == null ? void 0 : u.rtn
        }
      ),
      /* @__PURE__ */ p.jsx(wn, {}),
      /* @__PURE__ */ p.jsx(
        Ur,
        {
          label: "Bank Account #",
          value: (I = n == null ? void 0 : n.bank_information) != null && I.account_number_last_4_digits ? `********${(O = n == null ? void 0 : n.bank_information) == null ? void 0 : O.account_number_last_4_digits}` : null
        }
      )
    ] })
  ] });
}, UT = ({
  fetchUrl: e
}) => {
  const n = Jt(), { data: r, isLoading: a, isError: o } = Sn({
    queryKey: [e],
    queryFn: () => n.client.get(e).then((l) => l.data)
  });
  return a ? /* @__PURE__ */ p.jsx(nx, { role: "progressbar" }) : o ? /* @__PURE__ */ p.jsx("div", { children: "Error loading tax filing items" }) : /* @__PURE__ */ p.jsxs(hc, { variant: "outlined", sx: { width: "100%", p: 2 }, children: [
    (r == null ? void 0 : r.tax_return_type) === "personal" && /* @__PURE__ */ p.jsx($T, { taxReturnSummary: r }),
    (r == null ? void 0 : r.tax_return_type) === "business" && /* @__PURE__ */ p.jsx(BT, { taxReturnSummary: r })
  ] });
}, zT = ({
  question: e
}) => {
  var n, r, a, o;
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    ((n = e == null ? void 0 : e.dependency) == null ? void 0 : n.type) === "schedule_k1s" && /* @__PURE__ */ p.jsx(MT, { question: e }),
    ((r = e == null ? void 0 : e.dependency) == null ? void 0 : r.type) === "payment_estimates" && e.dependency.read_url && /* @__PURE__ */ p.jsx(DT, { fetchUrl: e.dependency.read_url }),
    ((a = e == null ? void 0 : e.dependency) == null ? void 0 : a.type) === "balances" && e.dependency.read_url && /* @__PURE__ */ p.jsx(RT, { fetchUrl: e.dependency.read_url }),
    ((o = e == null ? void 0 : e.dependency) == null ? void 0 : o.type) === "tax_information" && e.dependency.read_url && /* @__PURE__ */ p.jsx(UT, { fetchUrl: e.dependency.read_url })
  ] });
}, HT = tt(Pe, {
  shouldForwardProp: (e) => e !== "isSelected" && e !== "isConditional"
})(({ theme: e, isConditional: n, isSelected: r }) => ({
  flexDirection: "row",
  borderRadius: e.shape.borderRadius,
  padding: e.spacing(2),
  transition: e.transitions.create("background-color", {
    duration: 1500
  }),
  ...n ? {
    marginLeft: e.spacing(8),
    backgroundColor: r ? e.palette.common.primary[50] : e.palette.primary.contrastText
  } : {
    backgroundColor: r ? e.palette.common.primary[50] : void 0
  }
})), WT = ({
  children: e,
  isConditional: n,
  isSelected: r,
  isSelectedTimeout: a = 5e3,
  ...o
}) => {
  const [l, d] = Ee(!1), c = r && !l;
  return Ax(
    () => d(!0),
    a,
    c
  ), ot(() => {
    r || d(!1);
  }, [r]), /* @__PURE__ */ p.jsx(
    HT,
    {
      ...o,
      isConditional: n,
      isSelected: c,
      children: e
    }
  );
}, R9 = (e) => /* @__PURE__ */ p.jsx(
  y7.div,
  {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    ...e
  }
), qT = tt(Me)(({ theme: e }) => ({
  width: e.spacing(6)
})), Jp = ({
  question: e,
  disabled: n,
  ...r
}) => {
  var o, l;
  const a = Number((o = e.conditions) == null ? void 0 : o.length) > 0;
  return /* @__PURE__ */ p.jsx(R9, { layout: !0, children: /* @__PURE__ */ p.jsxs(WT, { ...r, isConditional: a, children: [
    /* @__PURE__ */ p.jsx(qT, { children: /* @__PURE__ */ p.jsx(Te, { children: e.numberLabel }) }),
    /* @__PURE__ */ p.jsxs(Pe, { gap: 2, flex: 1, children: [
      /* @__PURE__ */ p.jsx(Te, { children: e.prompt }),
      /* @__PURE__ */ p.jsxs(Me, { flex: 1, display: "flex", children: [
        e.type === "boolean" && /* @__PURE__ */ p.jsx(kT, { question: e, disabled: n }),
        (e.type === "text" || e.type === "firm_authored_text") && /* @__PURE__ */ p.jsx(PT, { question: e, disabled: n }),
        e.type === "upload_document" && /* @__PURE__ */ p.jsx(
          IT,
          {
            question: e,
            disabled: n
          }
        ),
        e.type === "reviewable_document" && "dependency" in e && /* @__PURE__ */ p.jsx(
          Zp,
          {
            value: e.dependency
          }
        ),
        e.type === "signable_document" && "dependency" in e && /* @__PURE__ */ p.jsx(
          eE,
          {
            signers: (l = e.dependency) == null ? void 0 : l.signatories,
            disabled: n
          }
        ),
        e.type === "payable" && "dependency" in e && /* @__PURE__ */ p.jsx(
          Zp,
          {
            value: e.dependency.document
          }
        ),
        e.type === "dynamic" && "dependency" in e && /* @__PURE__ */ p.jsx(
          zT,
          {
            question: e
          }
        )
      ] })
    ] })
  ] }) }, `${e.id}-question`);
}, VT = (e) => /* @__PURE__ */ Ue.createElement("svg", { width: 288, height: 249, viewBox: "0 0 288 249", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ Ue.createElement("circle", { cx: 124.001, cy: 124.325, r: 123.825, fill: "#EEF0F1" }), /* @__PURE__ */ Ue.createElement("rect", { x: 25.5039, y: 32.6118, width: 195.997, height: 38.5878, rx: 6.39217, fill: "#F9FAFB" }), /* @__PURE__ */ Ue.createElement("rect", { x: 25.5039, y: 32.6118, width: 195.997, height: 38.5878, rx: 6.39217, stroke: "#ACB2B7", strokeLinecap: "round", strokeDasharray: "4 8" }), /* @__PURE__ */ Ue.createElement("rect", { x: 32.3945, y: 40.6235, width: 22.5642, height: 22.5642, rx: 4.21284, fill: "#DFE3E8", stroke: "#ACB2B7", strokeLinecap: "round", strokeDasharray: "4 6" }), /* @__PURE__ */ Ue.createElement("rect", { x: 25.5039, y: 80.8149, width: 195.997, height: 38.5878, rx: 6.39217, fill: "#F9FAFB" }), /* @__PURE__ */ Ue.createElement("rect", { x: 25.5039, y: 80.8149, width: 195.997, height: 38.5878, rx: 6.39217, stroke: "#ACB2B7", strokeLinecap: "round", strokeDasharray: "4 8" }), /* @__PURE__ */ Ue.createElement("rect", { x: 32.3945, y: 88.8267, width: 22.5642, height: 22.5642, rx: 4.21284, fill: "#DFE3E8", stroke: "#ACB2B7", strokeLinecap: "round", strokeDasharray: "4 6" }), /* @__PURE__ */ Ue.createElement("rect", { x: 25.5039, y: 129.018, width: 195.997, height: 38.5878, rx: 6.39217, fill: "#F9FAFB" }), /* @__PURE__ */ Ue.createElement("rect", { x: 25.5039, y: 129.018, width: 195.997, height: 38.5878, rx: 6.39217, stroke: "#ACB2B7", strokeLinecap: "round", strokeDasharray: "4 8" }), /* @__PURE__ */ Ue.createElement("rect", { x: 32.3945, y: 137.03, width: 22.5642, height: 22.5642, rx: 4.21284, fill: "#DFE3E8", stroke: "#ACB2B7", strokeLinecap: "round", strokeDasharray: "4 6" }), /* @__PURE__ */ Ue.createElement("rect", { x: 25.5039, y: 177.221, width: 195.997, height: 38.5878, rx: 6.39217, fill: "#F9FAFB" }), /* @__PURE__ */ Ue.createElement("rect", { x: 25.5039, y: 177.221, width: 195.997, height: 38.5878, rx: 6.39217, stroke: "#ACB2B7", strokeLinecap: "round", strokeDasharray: "4 8" }), /* @__PURE__ */ Ue.createElement("rect", { x: 32.3945, y: 185.233, width: 22.5642, height: 22.5642, rx: 4.21284, fill: "#DFE3E8", stroke: "#ACB2B7", strokeLinecap: "round", strokeDasharray: "4 6" }), /* @__PURE__ */ Ue.createElement("rect", { x: 201, y: 81.5, width: 86.5909, height: 86.5909, rx: 43.2955, fill: "#DFE3E8" }), /* @__PURE__ */ Ue.createElement("path", { d: "M244.297 152.795C234.234 152.795 225.047 147.545 220.016 138.795C214.984 130.155 214.984 119.545 220.016 110.795C225.047 102.155 234.234 96.7954 244.297 96.7954C254.25 96.7954 263.438 102.155 268.469 110.795C273.5 119.545 273.5 130.155 268.469 138.795C263.438 147.545 254.25 152.795 244.297 152.795ZM226.797 119.545C225.812 119.545 225.047 120.42 225.047 121.295V128.295C225.047 129.28 225.812 130.045 226.797 130.045H261.797C262.672 130.045 263.547 129.28 263.547 128.295V121.295C263.547 120.42 262.672 119.545 261.797 119.545H226.797Z", fill: "#E57373" })), Us = tt(Te)(({ theme: e }) => ({
  color: e.palette.common.neutrals[700],
  textAlign: "center"
})), kc = tt(Me)(({ theme: e }) => ({
  transform: `translateX(${e.spacing(3)})`
})), XT = (e) => /* @__PURE__ */ Ue.createElement("svg", { width: 288, height: 249, viewBox: "0 0 288 249", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ Ue.createElement("circle", { cx: 124.001, cy: 124.325, r: 123.825, fill: "#EEF0F1" }), /* @__PURE__ */ Ue.createElement("rect", { x: 25.0039, y: 32.1117, width: 196.997, height: 39.5878, rx: 6.89217, fill: "#CBEDF3" }), /* @__PURE__ */ Ue.createElement("rect", { x: 31.8945, y: 40.1235, width: 23.5642, height: 23.5642, rx: 4.71284, fill: "#80D7E6" }), /* @__PURE__ */ Ue.createElement("rect", { x: 25.0039, y: 80.3147, width: 196.997, height: 39.5878, rx: 6.89217, fill: "#CBEDF3" }), /* @__PURE__ */ Ue.createElement("rect", { x: 31.8945, y: 88.3265, width: 23.5642, height: 23.5642, rx: 4.71284, fill: "#80D7E6" }), /* @__PURE__ */ Ue.createElement("rect", { x: 25.0039, y: 128.518, width: 196.997, height: 39.5878, rx: 6.89217, fill: "#CBEDF3" }), /* @__PURE__ */ Ue.createElement("rect", { x: 31.8945, y: 136.53, width: 23.5642, height: 23.5642, rx: 4.71284, fill: "#80D7E6" }), /* @__PURE__ */ Ue.createElement("rect", { x: 25.0039, y: 176.721, width: 196.997, height: 39.5878, rx: 6.89217, fill: "#CBEDF3" }), /* @__PURE__ */ Ue.createElement("rect", { x: 31.8945, y: 184.733, width: 23.5642, height: 23.5642, rx: 4.71284, fill: "#80D7E6" }), /* @__PURE__ */ Ue.createElement("rect", { x: 201, y: 81.5, width: 86.5909, height: 86.5909, rx: 43.2955, fill: "#DFE3E8" }), /* @__PURE__ */ Ue.createElement("path", { d: "M218.922 102.045H224.172C225.594 102.045 226.797 103.249 226.797 104.67V109.92C226.797 111.452 225.594 112.545 224.172 112.545V122.17H230.297C230.297 120.749 231.391 119.545 232.922 119.545H238.172C239.594 119.545 240.797 120.749 240.797 122.17V127.42C240.797 128.952 239.594 130.045 238.172 130.045H232.922C231.391 130.045 230.297 128.952 230.297 127.42H224.172V138.795C224.172 139.342 224.5 139.67 225.047 139.67H230.297C230.297 138.249 231.391 137.045 232.922 137.045H238.172C239.594 137.045 240.797 138.249 240.797 139.67V144.92C240.797 146.452 239.594 147.545 238.172 147.545H232.922C231.391 147.545 230.297 146.452 230.297 144.92H225.047C221.656 144.92 218.922 142.186 218.922 138.795V124.795V112.545C217.391 112.545 216.297 111.452 216.297 109.92V104.67C216.297 103.249 217.391 102.045 218.922 102.045ZM233.797 107.295C233.797 105.436 235.328 103.795 237.297 103.795H268.797C270.656 103.795 272.297 105.436 272.297 107.295C272.297 109.264 270.656 110.795 268.797 110.795H237.297C235.328 110.795 233.797 109.264 233.797 107.295ZM247.797 124.795C247.797 122.936 249.328 121.295 251.297 121.295H268.797C270.656 121.295 272.297 122.936 272.297 124.795C272.297 126.764 270.656 128.295 268.797 128.295H251.297C249.328 128.295 247.797 126.764 247.797 124.795ZM247.797 142.295C247.797 140.436 249.328 138.795 251.297 138.795H268.797C270.656 138.795 272.297 140.436 272.297 142.295C272.297 144.264 270.656 145.795 268.797 145.795H251.297C249.328 145.795 247.797 144.264 247.797 142.295Z", fill: "#00687A" })), GT = () => {
  const { data: e } = If(), { navigateToTheFirstUnansweredQuestion: n } = _c();
  return /* @__PURE__ */ p.jsxs(Pe, { justifyContent: "center", alignItems: "center", flex: 1, children: [
    /* @__PURE__ */ p.jsx(kc, { children: /* @__PURE__ */ p.jsx(XT, {}) }),
    /* @__PURE__ */ p.jsxs(Te, { variant: "body2", children: [
      "Welcome, ",
      e == null ? void 0 : e.first_name
    ] }),
    /* @__PURE__ */ p.jsx(Us, { textAlign: "center", maxWidth: "60%", children: "To get started, simply answer the questions in each section — your progress saves automatically. You can step away and return anytime, even in the Liscio app on your phone." }),
    /* @__PURE__ */ p.jsxs(Us, { textAlign: "center", maxWidth: "60%", children: [
      "Once you're done, just hit ",
      /* @__PURE__ */ p.jsx("b", { children: "Submit" }),
      " to let your team know you’re all set."
    ] }),
    /* @__PURE__ */ p.jsx(Me, { mt: 3, children: /* @__PURE__ */ p.jsx(
      lt,
      {
        variant: "contained",
        onClick: () => n(),
        children: "Get Started"
      }
    ) })
  ] });
}, KT = (e) => /* @__PURE__ */ Ue.createElement("svg", { width: 288, height: 248, viewBox: "0 0 288 248", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ Ue.createElement("circle", { cx: 124.001, cy: 123.825, r: 123.825, fill: "#EEF0F1" }), /* @__PURE__ */ Ue.createElement("rect", { x: 25.0039, y: 31.6113, width: 196.997, height: 39.5878, rx: 6.89217, fill: "#CBEDF3" }), /* @__PURE__ */ Ue.createElement("rect", { x: 31.8945, y: 39.623, width: 23.5642, height: 23.5642, rx: 4.71284, fill: "#80D7E6" }), /* @__PURE__ */ Ue.createElement("rect", { x: 25.0039, y: 79.8145, width: 196.997, height: 39.5878, rx: 6.89217, fill: "#CBEDF3" }), /* @__PURE__ */ Ue.createElement("rect", { x: 31.8945, y: 87.8262, width: 23.5642, height: 23.5642, rx: 4.71284, fill: "#80D7E6" }), /* @__PURE__ */ Ue.createElement("rect", { x: 25.0039, y: 128.018, width: 196.997, height: 39.5878, rx: 6.89217, fill: "#CBEDF3" }), /* @__PURE__ */ Ue.createElement("rect", { x: 31.8945, y: 136.029, width: 23.5642, height: 23.5642, rx: 4.71284, fill: "#80D7E6" }), /* @__PURE__ */ Ue.createElement("rect", { x: 25.0039, y: 176.221, width: 196.997, height: 39.5878, rx: 6.89217, fill: "#CBEDF3" }), /* @__PURE__ */ Ue.createElement("rect", { x: 31.8945, y: 184.232, width: 23.5642, height: 23.5642, rx: 4.71284, fill: "#80D7E6" }), /* @__PURE__ */ Ue.createElement("rect", { x: 201, y: 81, width: 86.5909, height: 86.5909, rx: 43.2955, fill: "#DFE3E8" }), /* @__PURE__ */ Ue.createElement("path", { d: "M266.938 120.795H253.922C252.828 120.795 251.844 120.249 251.406 119.264C251.078 118.28 251.297 117.077 252.062 116.311L256.547 111.827C249.656 105.155 238.719 105.155 231.828 111.936C225.047 118.827 225.047 129.874 231.828 136.764C238.719 143.545 249.766 143.545 256.656 136.764C257.969 135.342 260.156 135.342 261.578 136.764C262.891 138.077 262.891 140.264 261.578 141.686C251.953 151.202 236.531 151.202 226.906 141.686C217.391 132.061 217.391 116.639 226.906 107.014C236.422 97.4985 251.844 97.4985 261.469 106.905L266.062 102.311C266.719 101.655 267.922 101.436 268.906 101.764C269.891 102.202 270.547 103.186 270.547 104.17V118.17C270.547 119.702 269.344 120.795 267.922 120.795H266.938Z", fill: "#00687A" })), YT = () => {
  const { data: e } = If(), { navigateToTheFirstUnansweredQuestion: n } = _c();
  return /* @__PURE__ */ p.jsxs(Pe, { justifyContent: "center", alignItems: "center", flex: 1, children: [
    /* @__PURE__ */ p.jsx(kc, { children: /* @__PURE__ */ p.jsx(KT, {}) }),
    /* @__PURE__ */ p.jsxs(Te, { variant: "body2", children: [
      "Welcome back, ",
      e == null ? void 0 : e.first_name
    ] }),
    /* @__PURE__ */ p.jsx(Us, { textAlign: "center", maxWidth: "60%", children: "There are still some unanswered questions remaining." }),
    /* @__PURE__ */ p.jsx(Us, { textAlign: "center", maxWidth: "60%", children: "Let's pick up where you left off." }),
    /* @__PURE__ */ p.jsx(Me, { mt: 3, children: /* @__PURE__ */ p.jsx(
      lt,
      {
        variant: "outlined",
        onClick: () => n(),
        children: "Continue"
      }
    ) })
  ] });
}, M9 = (e) => /* @__PURE__ */ Ue.createElement("svg", { width: 288, height: 249, viewBox: "0 0 288 249", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ Ue.createElement("circle", { cx: 124.001, cy: 124.325, r: 123.825, fill: "#EEF0F1" }), /* @__PURE__ */ Ue.createElement("rect", { x: 25.0039, y: 32.1118, width: 196.997, height: 39.5878, rx: 6.89217, fill: "#CBEDF3" }), /* @__PURE__ */ Ue.createElement("rect", { x: 31.8945, y: 40.1235, width: 23.5642, height: 23.5642, rx: 4.71284, fill: "#80D7E6" }), /* @__PURE__ */ Ue.createElement("rect", { x: 25.0039, y: 80.3149, width: 196.997, height: 39.5878, rx: 6.89217, fill: "#CBEDF3" }), /* @__PURE__ */ Ue.createElement("rect", { x: 31.8945, y: 88.3267, width: 23.5642, height: 23.5642, rx: 4.71284, fill: "#80D7E6" }), /* @__PURE__ */ Ue.createElement("rect", { x: 25.0039, y: 128.518, width: 196.997, height: 39.5878, rx: 6.89217, fill: "#CBEDF3" }), /* @__PURE__ */ Ue.createElement("rect", { x: 31.8945, y: 136.53, width: 23.5642, height: 23.5642, rx: 4.71284, fill: "#80D7E6" }), /* @__PURE__ */ Ue.createElement("rect", { x: 25.0039, y: 176.721, width: 196.997, height: 39.5878, rx: 6.89217, fill: "#CBEDF3" }), /* @__PURE__ */ Ue.createElement("rect", { x: 31.8945, y: 184.733, width: 23.5642, height: 23.5642, rx: 4.71284, fill: "#80D7E6" }), /* @__PURE__ */ Ue.createElement("rect", { x: 201, y: 81.5, width: 86.5909, height: 86.5909, rx: 43.2955, fill: "#DFE3E8" }), /* @__PURE__ */ Ue.createElement("path", { d: "M267.703 108.389C269.125 109.702 269.125 111.999 267.703 113.311L239.703 141.311C238.391 142.733 236.094 142.733 234.781 141.311L220.781 127.311C219.359 125.999 219.359 123.702 220.781 122.389C222.094 120.967 224.391 120.967 225.703 122.389L237.297 133.874L262.781 108.389C264.094 106.967 266.391 106.967 267.703 108.389Z", fill: "#00687A" })), ZT = () => /* @__PURE__ */ p.jsxs(Pe, { justifyContent: "center", alignItems: "center", flex: 1, children: [
  /* @__PURE__ */ p.jsx(kc, { children: /* @__PURE__ */ p.jsx(M9, {}) }),
  /* @__PURE__ */ p.jsx(Te, { variant: "body2", children: "This section is completed" }),
  /* @__PURE__ */ p.jsx(Us, { children: "Select a different section to continue." })
] }), QT = () => /* @__PURE__ */ p.jsxs(Pe, { justifyContent: "center", alignItems: "center", flex: 1, children: [
  /* @__PURE__ */ p.jsx(kc, { children: /* @__PURE__ */ p.jsx(M9, {}) }),
  /* @__PURE__ */ p.jsx(Te, { variant: "body2", children: "No unanswered questions left" }),
  /* @__PURE__ */ p.jsx(Us, { children: "Review and submit your information." })
] }), JT = (e) => /* @__PURE__ */ Ue.createElement("svg", { width: 289, height: 254, viewBox: "0 0 289 254", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ Ue.createElement("circle", { cx: 124.001, cy: 126.825, r: 123.825, fill: "#EEF0F1" }), /* @__PURE__ */ Ue.createElement("rect", { x: 25.0039, y: 34.6118, width: 196.997, height: 39.5878, rx: 6.89217, fill: "#CBEDF3" }), /* @__PURE__ */ Ue.createElement("rect", { x: 31.8945, y: 42.6235, width: 23.5642, height: 23.5642, rx: 4.71284, fill: "#80D7E6" }), /* @__PURE__ */ Ue.createElement("rect", { x: 25.0039, y: 82.8149, width: 196.997, height: 39.5878, rx: 6.89217, fill: "#CBEDF3" }), /* @__PURE__ */ Ue.createElement("rect", { x: 31.8945, y: 90.8267, width: 23.5642, height: 23.5642, rx: 4.71284, fill: "#80D7E6" }), /* @__PURE__ */ Ue.createElement("rect", { x: 25.0039, y: 131.018, width: 196.997, height: 39.5878, rx: 6.89217, fill: "#CBEDF3" }), /* @__PURE__ */ Ue.createElement("rect", { x: 31.8945, y: 139.03, width: 23.5642, height: 23.5642, rx: 4.71284, fill: "#80D7E6" }), /* @__PURE__ */ Ue.createElement("rect", { x: 25.0039, y: 179.221, width: 196.997, height: 39.5878, rx: 6.89217, fill: "#CBEDF3" }), /* @__PURE__ */ Ue.createElement("rect", { x: 31.8945, y: 187.233, width: 23.5642, height: 23.5642, rx: 4.71284, fill: "#80D7E6" }), /* @__PURE__ */ Ue.createElement("rect", { x: 201, y: 84, width: 88, height: 88, rx: 44, fill: "#DFE3E8" }), /* @__PURE__ */ Ue.createElement("path", { d: "M245 156C234.938 156 225.75 150.75 220.719 142C215.688 133.359 215.688 122.75 220.719 114C225.75 105.359 234.938 100 245 100C254.953 100 264.141 105.359 269.172 114C274.203 122.75 274.203 133.359 269.172 142C264.141 150.75 254.953 156 245 156ZM257.359 122.859H257.25C258.344 121.875 258.344 120.234 257.25 119.141C256.266 118.156 254.625 118.156 253.641 119.141L241.5 131.391L236.359 126.25C235.266 125.156 233.625 125.156 232.641 126.25C231.547 127.234 231.547 128.875 232.641 129.859L239.641 136.859C240.625 137.953 242.266 137.953 243.359 136.859L257.359 122.859Z", fill: "#1AA777" })), eO = () => /* @__PURE__ */ p.jsxs(Pe, { justifyContent: "center", alignItems: "center", flex: 1, children: [
  /* @__PURE__ */ p.jsx(kc, { children: /* @__PURE__ */ p.jsx(JT, {}) }),
  /* @__PURE__ */ p.jsx(Te, { variant: "body2", children: "Request Submitted" }),
  /* @__PURE__ */ p.jsx(Us, { children: "This request has been submitted. It's available for reference, but cannot be changed." })
] }), tO = ({
  processState: e
}) => {
  if (!e) return null;
  if (e === "submitted")
    return /* @__PURE__ */ p.jsx(eO, {});
  if (e === "new")
    return /* @__PURE__ */ p.jsx(GT, {});
  if (e === "initial")
    return /* @__PURE__ */ p.jsx(YT, {});
  if (e === "section-complete")
    return /* @__PURE__ */ p.jsx(ZT, {});
  if (e === "all-done")
    return /* @__PURE__ */ p.jsx(QT, {});
  if (e === "not-available")
    return /* @__PURE__ */ p.jsx(VT, {});
}, eg = "request-sections-questions-list", nO = ({
  questionId: e,
  enabled: n,
  scrollContainerId: r = eg
}) => (ot(() => {
  if (e && n) {
    const a = document.getElementById(e);
    a && vx(a, eg, {
      includeElementHeight: !1,
      scrollOffset: -70
    });
  }
}, [e, n]), {
  scrollContainerId: r
}), iO = tt(Pe)(({ theme: e }) => ({
  flex: "1",
  backgroundColor: e.palette.common.neutrals[100],
  padding: `0px ${e.spacing(3)}`,
  overflowY: "auto",
  scrollbarGutter: "stable both-edges",
  position: "relative"
})), rO = tt(R9)(() => ({
  flex: 1,
  display: "flex"
})), sO = tt(Pe)(({ theme: e }) => ({
  backgroundColor: e.palette.common.neutrals[100],
  position: "sticky",
  top: 0,
  zIndex: e.zIndex.slidingViews
})), aO = () => {
  var v, E, S;
  const { sectionId: e, questionId: n } = m0(), r = Ki(), {
    request: a,
    getVisibleQuestions: o,
    getProcessState: l,
    incompleteSectionIdsSnapshot: d,
    requestId: c,
    disableEdit: f
  } = xi(), s = ut(null);
  ot(() => {
    var y;
    (y = s == null ? void 0 : s.current) == null || y.scrollTo(0, 0);
  }, [e]);
  const h = e ? (v = a == null ? void 0 : a.sectionsMap) == null ? void 0 : v[e] : null, g = o(e), { scrollContainerId: t } = nO({
    questionId: n,
    enabled: g.length > 0
  }), i = Tt(
    () => l(e),
    [l, e]
  );
  if (Pa(() => {
    i === "empty-section-navigate" && r(
      `/requests/${c}/sections/${d == null ? void 0 : d[0]}`
    );
  }, [i, r, d, c]), !e || !a)
    return null;
  const m = (((S = (E = a == null ? void 0 : a.sectionsMap) == null ? void 0 : E[e]) == null ? void 0 : S.questionsLoadedAt) ?? -1 / 0) > -1 / 0;
  return /* @__PURE__ */ p.jsxs(iO, { ref: s, id: t, children: [
    /* @__PURE__ */ p.jsx(sO, { children: /* @__PURE__ */ p.jsx(Te, { variant: "body2", m: 2, children: h == null ? void 0 : h.title }) }),
    /* @__PURE__ */ p.jsxs(Pe, { flex: "1", justifyContent: "flex-start", gap: 2, children: [
      a && !m && (g == null ? void 0 : g.length) === 0 && /* @__PURE__ */ p.jsx(u0, {}),
      /* @__PURE__ */ p.jsxs(
        v7,
        {
          mode: g.length === 0 ? "wait" : "sync",
          children: [
            g == null ? void 0 : g.map((y) => {
              var x;
              return /* @__PURE__ */ p.jsxs(Nn.Fragment, { children: [
                /* @__PURE__ */ p.jsx(
                  Jp,
                  {
                    id: y.id,
                    disabled: !(a != null && a.isEditable) || f,
                    question: y,
                    isSelected: y.id === n
                  },
                  y.id
                ),
                (x = y == null ? void 0 : y.dependentQuestionsIds) == null ? void 0 : x.map((b) => /* @__PURE__ */ p.jsx(
                  Jp,
                  {
                    id: b,
                    disabled: !(a != null && a.isEditable) || f,
                    question: a == null ? void 0 : a.questionsMap[b],
                    isSelected: b === n,
                    isConditional: !0
                  },
                  b
                ))
              ] }, y.id);
            }),
            /* @__PURE__ */ p.jsx(rO, { children: a && m && (g == null ? void 0 : g.length) === 0 && /* @__PURE__ */ p.jsx(tO, { processState: i }) })
          ]
        },
        e
      )
    ] })
  ] });
}, oO = ({ slots: e, slotProps: n }) => {
  const {
    RequestBody: { RequestLeftPanel: r, RequestRightPanel: a }
  } = n ?? { RequestBody: {} }, {
    RequestRightPanel: o,
    RequestLeftPanel: l,
    RequestMainPanel: d
  } = e ?? {}, { isSubmitted: c } = xi(), f = d ?? /* @__PURE__ */ p.jsx(aO, {}), s = d === void 0;
  return /* @__PURE__ */ p.jsxs(Pe, { flex: 1, direction: "row", overflow: "hidden", children: [
    (r == null ? void 0 : r.toggle) && /* @__PURE__ */ p.jsx(Pe, { direction: "row", flex: 0, alignItems: "start", px: 1, py: 2, children: /* @__PURE__ */ p.jsx(
      ja,
      {
        title: r != null && r.open ? "Hide all sections" : "Show all sections",
        placement: "right",
        children: /* @__PURE__ */ p.jsx(
          Si,
          {
            onClick: r != null && r.open ? r == null ? void 0 : r.onClose : r == null ? void 0 : r.onOpen,
            style: { backgroundColor: "transparent" },
            children: /* @__PURE__ */ p.jsx(
              it,
              {
                color: "secondary",
                icon: r.open ? "arrowLeftToLine" : "toc",
                fontSize: "small"
              }
            )
          }
        )
      }
    ) }),
    l && /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
      /* @__PURE__ */ p.jsx(
        m1,
        {
          in: r == null ? void 0 : r.open,
          orientation: "horizontal",
          collapsedSize: 0,
          children: /* @__PURE__ */ p.jsx(
            Pe,
            {
              overflow: "auto",
              height: "100%",
              width: "25vw",
              maxWidth: "400px",
              children: l
            }
          )
        }
      ),
      /* @__PURE__ */ p.jsx(wn, { orientation: "vertical" })
    ] }),
    /* @__PURE__ */ p.jsxs(Pe, { flex: "1", overflow: "hidden", children: [
      !c && f,
      c && /* @__PURE__ */ p.jsx(_T, {}),
      s && /* @__PURE__ */ p.jsx(AT, {})
    ] }),
    /* @__PURE__ */ p.jsx(wn, { orientation: "vertical" }),
    o && /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
      /* @__PURE__ */ p.jsx(
        m1,
        {
          in: a == null ? void 0 : a.open,
          orientation: "horizontal",
          collapsedSize: 0,
          children: /* @__PURE__ */ p.jsx(
            Pe,
            {
              direction: "row",
              overflow: "auto",
              height: "100%",
              width: "40vw",
              maxWidth: "40rem",
              children: o
            }
          )
        }
      ),
      (a == null ? void 0 : a.toggle) && /* @__PURE__ */ p.jsx(Pe, { direction: "row", alignItems: "start", padding: 1, children: /* @__PURE__ */ p.jsx(
        ja,
        {
          title: a != null && a.open ? "Hide request info" : "Show request info",
          placement: "left",
          children: /* @__PURE__ */ p.jsx(
            Si,
            {
              onClick: a != null && a.open ? a == null ? void 0 : a.onClose : a == null ? void 0 : a.onOpen,
              style: { backgroundColor: "transparent" },
              children: /* @__PURE__ */ p.jsx(
                it,
                {
                  color: "secondary",
                  icon: a != null && a.open ? "arrowRightToLine" : "infoCircle",
                  fontSize: "small"
                }
              )
            }
          )
        }
      ) })
    ] })
  ] });
}, cO = tt(Pe)(({ theme: e, color: n }) => ({
  color: n || e.palette.common.neutrals[300],
  flexDirection: "row",
  alignItems: "center"
})), Vu = ({
  icon: e,
  label: n,
  showLabel: r = !0,
  color: a
}) => /* @__PURE__ */ p.jsxs(cO, { gap: 1, color: a, children: [
  e,
  /* @__PURE__ */ p.jsx(t5, { in: r, children: /* @__PURE__ */ p.jsx(Te, { fontSize: 14, children: n }) })
] }), lO = () => {
  const e = Mr(), [n, r] = Ee(!1), a = () => r(!1), { isSaving: o, error: l } = xi(), d = t7(o, {
    duration: (c) => c ? 750 : -1
  });
  return ot(() => {
    o && r(!0);
  }, [o]), Ax(a, 2e3, n && !d), d ? /* @__PURE__ */ p.jsx(
    Vu,
    {
      icon: /* @__PURE__ */ p.jsx(k5, { fontSize: "inherit" }),
      label: "Saving",
      color: e.palette.common.black
    }
  ) : l ? /* @__PURE__ */ p.jsx(
    Vu,
    {
      icon: /* @__PURE__ */ p.jsx(it, { icon: "cloudX", fontSize: "inherit" }),
      label: "Failed",
      color: e.palette.error.main
    }
  ) : /* @__PURE__ */ p.jsx(
    Vu,
    {
      icon: /* @__PURE__ */ p.jsx(it, { icon: "cloudCheck", fontSize: "inherit" }),
      label: "Saved",
      color: e.palette.success.main,
      showLabel: n
    }
  );
}, uO = ({ slots: e }) => {
  const n = Ki(), { request: r, isSubmitted: a } = xi(), { navigateToTheFirstUnansweredQuestion: o, isDispatchView: l } = _c(), { requestsListProtected: d } = _s(), c = r == null ? void 0 : r.isEditable, f = (r == null ? void 0 : r.status) === "draft", s = (r == null ? void 0 : r.status) === "pending", h = (r == null ? void 0 : r.status) === "open", g = !a && c && (r == null ? void 0 : r.questionsAnsweredCount) !== 0;
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsxs(Pe, { direction: "row", alignItems: "center", children: [
      /* @__PURE__ */ p.jsxs(Pe, { direction: "row", alignItems: "center", p: 2, gap: 1, flex: 2, children: [
        /* @__PURE__ */ p.jsxs(E5, { ariaLabel: "Request Header", children: [
          /* @__PURE__ */ p.jsx(
            Ii,
            {
              to: "#",
              onClick: (t) => {
                t.preventDefault(), n(-1);
              },
              children: /* @__PURE__ */ p.jsx(Te, { fontSize: "1.2rem !important", children: "Requests" })
            }
          ),
          /* @__PURE__ */ p.jsx(Te, { fontSize: "1.2rem !important", color: "primary", children: r == null ? void 0 : r.title })
        ] }),
        /* @__PURE__ */ p.jsx(lO, {})
      ] }),
      /* @__PURE__ */ p.jsxs(Pe, { p: 2, direction: "row", gap: 2, children: [
        !c && !l && !f && !s && !h && /* @__PURE__ */ p.jsx(Za, { severity: "info", children: /* @__PURE__ */ p.jsx(ef, { children: "This request has been submitted. It's available for reference, but cannot be changed." }) }),
        !(e != null && e.RequestHeaderActions) && /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
          g && /* @__PURE__ */ p.jsx(
            _k,
            {
              onCancel: o
            }
          ),
          a && /* @__PURE__ */ p.jsx(
            lt,
            {
              variant: "contained",
              to: (d == null ? void 0 : d.link()) || "",
              children: "Back to Requests"
            }
          )
        ] }),
        (e == null ? void 0 : e.RequestHeaderActions) && e.RequestHeaderActions
      ] })
    ] }),
    /* @__PURE__ */ p.jsx(wn, {})
  ] });
}, k$ = ({
  slots: e,
  slotProps: n
}) => /* @__PURE__ */ p.jsx(I5, { header: /* @__PURE__ */ p.jsx(uO, { slots: e }), children: /* @__PURE__ */ p.jsx(oO, { slots: e, slotProps: n }) });
var Xe = typeof window < "u" ? window : void 0, gi = typeof globalThis < "u" ? globalThis : Xe;
typeof self > "u" && (gi.self = gi), typeof File > "u" && (gi.File = function() {
});
var D9 = Array.prototype, tg = D9.forEach, ng = D9.indexOf, qi = gi == null ? void 0 : gi.navigator, bt = gi == null ? void 0 : gi.document, pi = gi == null ? void 0 : gi.location, lh = gi == null ? void 0 : gi.fetch, uh = gi != null && gi.XMLHttpRequest && "withCredentials" in new gi.XMLHttpRequest() ? gi.XMLHttpRequest : void 0, ig = gi == null ? void 0 : gi.AbortController, Fi = qi == null ? void 0 : qi.userAgent, qt = Xe ?? {}, Lr = { DEBUG: !1, LIB_VERSION: "1.359.1" };
function rg(e, n, r, a, o, l, d) {
  try {
    var c = e[l](d), f = c.value;
  } catch (s) {
    return void r(s);
  }
  c.done ? n(f) : Promise.resolve(f).then(a, o);
}
function Br(e) {
  return function() {
    var n = this, r = arguments;
    return new Promise(function(a, o) {
      var l = e.apply(n, r);
      function d(f) {
        rg(l, a, o, d, c, "next", f);
      }
      function c(f) {
        rg(l, a, o, d, c, "throw", f);
      }
      d(void 0);
    });
  };
}
function pt() {
  return pt = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var r = arguments[n];
      for (var a in r) ({}).hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, pt.apply(null, arguments);
}
function N9(e, n) {
  if (e == null) return {};
  var r = {};
  for (var a in e) if ({}.hasOwnProperty.call(e, a)) {
    if (n.indexOf(a) !== -1) continue;
    r[a] = e[a];
  }
  return r;
}
var dO = ["$snapshot", "$pageview", "$pageleave", "$set", "survey dismissed", "survey sent", "survey shown", "$identify", "$groupidentify", "$create_alias", "$$client_ingestion_warning", "$web_experiment_applied", "$feature_enrollment_update", "$feature_flag_called"], hO = ["amazonbot", "amazonproductbot", "app.hypefactors.com", "applebot", "archive.org_bot", "awariobot", "backlinksextendedbot", "baiduspider", "bingbot", "bingpreview", "chrome-lighthouse", "dataforseobot", "deepscan", "duckduckbot", "facebookexternal", "facebookcatalog", "http://yandex.com/bots", "hubspot", "ia_archiver", "leikibot", "linkedinbot", "meta-externalagent", "mj12bot", "msnbot", "nessus", "petalbot", "pinterest", "prerender", "rogerbot", "screaming frog", "sebot-wa", "sitebulb", "slackbot", "slurp", "trendictionbot", "turnitin", "twitterbot", "vercel-screenshot", "vercelbot", "yahoo! slurp", "yandexbot", "zoombot", "bot.htm", "bot.php", "(bot;", "bot/", "crawler", "ahrefsbot", "ahrefssiteaudit", "semrushbot", "siteauditbot", "splitsignalbot", "gptbot", "oai-searchbot", "chatgpt-user", "perplexitybot", "better uptime bot", "sentryuptimebot", "uptimerobot", "headlesschrome", "cypress", "google-hoteladsverifier", "adsbot-google", "apis-google", "duplexweb-google", "feedfetcher-google", "google favicon", "google web preview", "google-read-aloud", "googlebot", "googleother", "google-cloudvertexbot", "googleweblight", "mediapartners-google", "storebot-google", "google-inspectiontool", "bytespider"], sg = function(e, n) {
  if (n === void 0 && (n = []), !e) return !1;
  var r = e.toLowerCase();
  return hO.concat(n).some((a) => {
    var o = a.toLowerCase();
    return r.indexOf(o) !== -1;
  });
};
function cn(e, n) {
  return e.indexOf(n) !== -1;
}
var W0 = function(e) {
  return e.trim();
}, dh = function(e) {
  return e.replace(/^\$/, "");
}, fO = Array.isArray, L9 = Object.prototype, B9 = L9.hasOwnProperty, q0 = L9.toString, gn = fO || function(e) {
  return q0.call(e) === "[object Array]";
}, Hr = (e) => typeof e == "function", ii = (e) => e === Object(e) && !gn(e), Ca = (e) => {
  if (ii(e)) {
    for (var n in e) if (B9.call(e, n)) return !1;
    return !0;
  }
  return !1;
}, wt = (e) => e === void 0, ti = (e) => q0.call(e) == "[object String]", hh = (e) => ti(e) && e.trim().length === 0, br = (e) => e === null, un = (e) => wt(e) || br(e), Pr = (e) => q0.call(e) == "[object Number]" && e == e, va = (e) => Pr(e) && e > 0, qr = (e) => q0.call(e) === "[object Boolean]", pO = (e) => e instanceof FormData, gO = (e) => cn(dO, e);
function fh(e) {
  return e === null || typeof e != "object";
}
function Wl(e, n) {
  return Object.prototype.toString.call(e) === "[object " + n + "]";
}
function $9(e) {
  return !wt(Event) && function(n, r) {
    try {
      return n instanceof r;
    } catch {
      return !1;
    }
  }(e, Event);
}
var mO = [!0, "true", 1, "1", "yes"], Xu = (e) => cn(mO, e), xO = [!1, "false", 0, "0", "no"];
function kr(e, n, r, a, o) {
  return n > r && (a.warn("min cannot be greater than max."), n = r), Pr(e) ? e > r ? (a.warn(" cannot be  greater than max: " + r + ". Using max value instead."), r) : e < n ? (a.warn(" cannot be less than min: " + n + ". Using min value instead."), n) : e : (a.warn(" must be a number. using max or fallback. max: " + r + ", fallback: " + o), kr(o || r, n, r, a));
}
class bO {
  constructor(n) {
    this.t = {}, this.i = n.i, this.o = kr(n.bucketSize, 0, 100, n.h), this.m = kr(n.refillRate, 0, this.o, n.h), this.S = kr(n.refillInterval, 0, 864e5, n.h);
  }
  $(n, r) {
    var a = r - n.lastAccess, o = Math.floor(a / this.S);
    if (o > 0) {
      var l = o * this.m;
      n.tokens = Math.min(n.tokens + l, this.o), n.lastAccess = n.lastAccess + o * this.S;
    }
  }
  consumeRateLimit(n) {
    var r, a = Date.now(), o = String(n), l = this.t[o];
    return l ? this.$(l, a) : (l = { tokens: this.o, lastAccess: a }, this.t[o] = l), l.tokens === 0 || (l.tokens--, l.tokens === 0 && ((r = this.i) == null || r.call(this, n)), l.tokens === 0);
  }
  stop() {
    this.t = {};
  }
}
var Xi = "Mobile", ql = "iOS", Wr = "Android", Ba = "Tablet", U9 = Wr + " " + Ba, z9 = "iPad", H9 = "Apple", W9 = H9 + " Watch", nc = "Safari", $a = "BlackBerry", q9 = "Samsung", V9 = q9 + "Browser", X9 = q9 + " Internet", zs = "Chrome", yO = zs + " OS", G9 = zs + " " + ql, qf = "Internet Explorer", K9 = qf + " " + Xi, Vf = "Opera", vO = Vf + " Mini", Xf = "Edge", Y9 = "Microsoft " + Xf, Ta = "Firefox", Z9 = Ta + " " + ql, ic = "Nintendo", rc = "PlayStation", Oa = "Xbox", Q9 = Wr + " " + Xi, J9 = Xi + " " + nc, To = "Windows", ph = To + " Phone", ag = "Nokia", gh = "Ouya", e3 = "Generic", wO = e3 + " " + Xi.toLowerCase(), t3 = e3 + " " + Ba.toLowerCase(), mh = "Konqueror", Ci = "(\\d+(\\.\\d+)?)", Gu = new RegExp("Version/" + Ci), SO = new RegExp(Oa, "i"), _O = new RegExp(rc + " \\w+", "i"), CO = new RegExp(ic + " \\w+", "i"), Gf = new RegExp($a + "|PlayBook|BB10", "i"), AO = { "NT3.51": "NT 3.11", "NT4.0": "NT 4.0", "5.0": "2000", 5.1: "XP", 5.2: "XP", "6.0": "Vista", 6.1: "7", 6.2: "8", 6.3: "8.1", 6.4: "10", "10.0": "10" }, Kc, og, Ku, kO = (e, n) => n && cn(n, H9) || function(r) {
  return cn(r, nc) && !cn(r, zs) && !cn(r, Wr);
}(e), n3 = function(e, n) {
  return n = n || "", cn(e, " OPR/") && cn(e, "Mini") ? vO : cn(e, " OPR/") ? Vf : Gf.test(e) ? $a : cn(e, "IE" + Xi) || cn(e, "WPDesktop") ? K9 : cn(e, V9) ? X9 : cn(e, Xf) || cn(e, "Edg/") ? Y9 : cn(e, "FBIOS") ? "Facebook " + Xi : cn(e, "UCWEB") || cn(e, "UCBrowser") ? "UC Browser" : cn(e, "CriOS") ? G9 : cn(e, "CrMo") || cn(e, zs) ? zs : cn(e, Wr) && cn(e, nc) ? Q9 : cn(e, "FxiOS") ? Z9 : cn(e.toLowerCase(), mh.toLowerCase()) ? mh : kO(e, n) ? cn(e, Xi) ? J9 : nc : cn(e, Ta) ? Ta : cn(e, "MSIE") || cn(e, "Trident/") ? qf : cn(e, "Gecko") ? Ta : "";
}, EO = { [K9]: [new RegExp("rv:" + Ci)], [Y9]: [new RegExp(Xf + "?\\/" + Ci)], [zs]: [new RegExp("(" + zs + "|CrMo)\\/" + Ci)], [G9]: [new RegExp("CriOS\\/" + Ci)], "UC Browser": [new RegExp("(UCBrowser|UCWEB)\\/" + Ci)], [nc]: [Gu], [J9]: [Gu], [Vf]: [new RegExp("(Opera|OPR)\\/" + Ci)], [Ta]: [new RegExp(Ta + "\\/" + Ci)], [Z9]: [new RegExp("FxiOS\\/" + Ci)], [mh]: [new RegExp("Konqueror[:/]?" + Ci, "i")], [$a]: [new RegExp($a + " " + Ci), Gu], [Q9]: [new RegExp("android\\s" + Ci, "i")], [X9]: [new RegExp(V9 + "\\/" + Ci)], [qf]: [new RegExp("(rv:|MSIE )" + Ci)], Mozilla: [new RegExp("rv:" + Ci)] }, IO = function(e, n) {
  var r = n3(e, n), a = EO[r];
  if (wt(a)) return null;
  for (var o = 0; o < a.length; o++) {
    var l = a[o], d = e.match(l);
    if (d) return parseFloat(d[d.length - 2]);
  }
  return null;
}, cg = [[new RegExp(Oa + "; " + Oa + " (.*?)[);]", "i"), (e) => [Oa, e && e[1] || ""]], [new RegExp(ic, "i"), [ic, ""]], [new RegExp(rc, "i"), [rc, ""]], [Gf, [$a, ""]], [new RegExp(To, "i"), (e, n) => {
  if (/Phone/.test(n) || /WPDesktop/.test(n)) return [ph, ""];
  if (new RegExp(Xi).test(n) && !/IEMobile\b/.test(n)) return [To + " " + Xi, ""];
  var r = /Windows NT ([0-9.]+)/i.exec(n);
  if (r && r[1]) {
    var a = r[1], o = AO[a] || "";
    return /arm/i.test(n) && (o = "RT"), [To, o];
  }
  return [To, ""];
}], [/((iPhone|iPad|iPod).*?OS (\d+)_(\d+)_?(\d+)?|iPhone)/, (e) => {
  if (e && e[3]) {
    var n = [e[3], e[4], e[5] || "0"];
    return [ql, n.join(".")];
  }
  return [ql, ""];
}], [/(watch.*\/(\d+\.\d+\.\d+)|watch os,(\d+\.\d+),)/i, (e) => {
  var n = "";
  return e && e.length >= 3 && (n = wt(e[2]) ? e[3] : e[2]), ["watchOS", n];
}], [new RegExp("(" + Wr + " (\\d+)\\.(\\d+)\\.?(\\d+)?|" + Wr + ")", "i"), (e) => {
  if (e && e[2]) {
    var n = [e[2], e[3], e[4] || "0"];
    return [Wr, n.join(".")];
  }
  return [Wr, ""];
}], [/Mac OS X (\d+)[_.](\d+)[_.]?(\d+)?/i, (e) => {
  var n = ["Mac OS X", ""];
  if (e && e[1]) {
    var r = [e[1], e[2], e[3] || "0"];
    n[1] = r.join(".");
  }
  return n;
}], [/Mac/i, ["Mac OS X", ""]], [/CrOS/, [yO, ""]], [/Linux|debian/i, ["Linux", ""]]], lg = function(e) {
  return CO.test(e) ? ic : _O.test(e) ? rc : SO.test(e) ? Oa : new RegExp(gh, "i").test(e) ? gh : new RegExp("(" + ph + "|WPDesktop)", "i").test(e) ? ph : /iPad/.test(e) ? z9 : /iPod/.test(e) ? "iPod Touch" : /iPhone/.test(e) ? "iPhone" : /(watch)(?: ?os[,/]|\d,\d\/)[\d.]+/i.test(e) ? W9 : Gf.test(e) ? $a : /(kobo)\s(ereader|touch)/i.test(e) ? "Kobo" : new RegExp(ag, "i").test(e) ? ag : /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i.test(e) || /(kf[a-z]+)( bui|\)).+silk\//i.test(e) ? "Kindle Fire" : /(Android|ZTE)/i.test(e) ? new RegExp(Xi).test(e) && !/(9138B|TB782B|Nexus [97]|pixel c|HUAWEISHT|BTV|noble nook|smart ultra 6)/i.test(e) || /pixel[\daxl ]{1,6}/i.test(e) && !/pixel c/i.test(e) || /(huaweimed-al00|tah-|APA|SM-G92|i980|zte|U304AA)/i.test(e) || /lmy47v/i.test(e) && !/QTAQZ3/i.test(e) ? Wr : U9 : new RegExp("(pda|" + Xi + ")", "i").test(e) ? wO : new RegExp(Ba, "i").test(e) && !new RegExp(Ba + " pc", "i").test(e) ? t3 : "";
}, TO = (e) => e instanceof Error;
function OO(e) {
  var n = globalThis._posthogChunkIds;
  if (n) {
    var r = Object.keys(n);
    return Ku && r.length === og || (og = r.length, Ku = r.reduce((a, o) => {
      Kc || (Kc = {});
      var l = Kc[o];
      if (l) a[l[0]] = l[1];
      else for (var d = e(o), c = d.length - 1; c >= 0; c--) {
        var f = d[c], s = f == null ? void 0 : f.filename, h = n[o];
        if (s && h) {
          a[s] = h, Kc[o] = [s, h];
          break;
        }
      }
      return a;
    }, {})), Ku;
  }
}
class FO {
  constructor(n, r, a) {
    a === void 0 && (a = []), this.coercers = n, this.stackParser = r, this.modifiers = a;
  }
  buildFromUnknown(n, r) {
    r === void 0 && (r = {});
    var a = r && r.mechanism || { handled: !0, type: "generic" }, o = this.buildCoercingContext(a, r, 0).apply(n), l = this.buildParsingContext(r), d = this.parseStacktrace(o, l);
    return { $exception_list: this.convertToExceptionList(d, a), $exception_level: "error" };
  }
  modifyFrames(n) {
    var r = this;
    return Br(function* () {
      for (var a of n) a.stacktrace && a.stacktrace.frames && gn(a.stacktrace.frames) && (a.stacktrace.frames = yield r.applyModifiers(a.stacktrace.frames));
      return n;
    })();
  }
  coerceFallback(n) {
    var r;
    return { type: "Error", value: "Unknown error", stack: (r = n.syntheticException) == null ? void 0 : r.stack, synthetic: !0 };
  }
  parseStacktrace(n, r) {
    var a, o;
    return n.cause != null && (a = this.parseStacktrace(n.cause, r)), n.stack != "" && n.stack != null && (o = this.applyChunkIds(this.stackParser(n.stack, n.synthetic ? r.skipFirstLines : 0), r.chunkIdMap)), pt({}, n, { cause: a, stack: o });
  }
  applyChunkIds(n, r) {
    return n.map((a) => (a.filename && r && (a.chunk_id = r[a.filename]), a));
  }
  applyCoercers(n, r) {
    for (var a of this.coercers) if (a.match(n)) return a.coerce(n, r);
    return this.coerceFallback(r);
  }
  applyModifiers(n) {
    var r = this;
    return Br(function* () {
      var a = n;
      for (var o of r.modifiers) a = yield o(a);
      return a;
    })();
  }
  convertToExceptionList(n, r) {
    var a, o, l, d = { type: n.type, value: n.value, mechanism: { type: (a = r.type) !== null && a !== void 0 ? a : "generic", handled: (o = r.handled) === null || o === void 0 || o, synthetic: (l = n.synthetic) !== null && l !== void 0 && l } };
    n.stack && (d.stacktrace = { type: "raw", frames: n.stack });
    var c = [d];
    return n.cause != null && c.push(...this.convertToExceptionList(n.cause, pt({}, r, { handled: !0 }))), c;
  }
  buildParsingContext(n) {
    var r;
    return { chunkIdMap: OO(this.stackParser), skipFirstLines: (r = n.skipFirstLines) !== null && r !== void 0 ? r : 1 };
  }
  buildCoercingContext(n, r, a) {
    a === void 0 && (a = 0);
    var o = (l, d) => {
      if (d <= 4) {
        var c = this.buildCoercingContext(n, r, d);
        return this.applyCoercers(l, c);
      }
    };
    return pt({}, r, { syntheticException: a == 0 ? r.syntheticException : void 0, mechanism: n, apply: (l) => o(l, a), next: (l) => o(l, a + 1) });
  }
}
var Ua = "?";
function xh(e, n, r, a, o) {
  var l = { platform: e, filename: n, function: r === "<anonymous>" ? Ua : r, in_app: !0 };
  return wt(a) || (l.lineno = a), wt(o) || (l.colno = o), l;
}
var i3 = (e, n) => {
  var r = e.indexOf("safari-extension") !== -1, a = e.indexOf("safari-web-extension") !== -1;
  return r || a ? [e.indexOf("@") !== -1 ? e.split("@")[0] : Ua, r ? "safari-extension:" + n : "safari-web-extension:" + n] : [e, n];
}, PO = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i, jO = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, RO = /\((\S*)(?::(\d+))(?::(\d+))\)/, MO = (e, n) => {
  var r = PO.exec(e);
  if (r) {
    var [, a, o, l] = r;
    return xh(n, a, Ua, +o, +l);
  }
  var d = jO.exec(e);
  if (d) {
    if (d[2] && d[2].indexOf("eval") === 0) {
      var c = RO.exec(d[2]);
      c && (d[2] = c[1], d[3] = c[2], d[4] = c[3]);
    }
    var [f, s] = i3(d[1] || Ua, d[2]);
    return xh(n, s, f, d[3] ? +d[3] : void 0, d[4] ? +d[4] : void 0);
  }
}, DO = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, NO = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, LO = (e, n) => {
  var r = DO.exec(e);
  if (r) {
    if (r[3] && r[3].indexOf(" > eval") > -1) {
      var a = NO.exec(r[3]);
      a && (r[1] = r[1] || "eval", r[3] = a[1], r[4] = a[2], r[5] = "");
    }
    var o = r[3], l = r[1] || Ua;
    return [l, o] = i3(l, o), xh(n, o, l, r[4] ? +r[4] : void 0, r[5] ? +r[5] : void 0);
  }
}, ug = /\(error: (.*)\)/, dg = 50;
function BO() {
  return function(e) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++) r[a - 1] = arguments[a];
    return function(o, l) {
      l === void 0 && (l = 0);
      for (var d = [], c = o.split(`
`), f = l; f < c.length; f++) {
        var s = c[f];
        if (!(s.length > 1024)) {
          var h = ug.test(s) ? s.replace(ug, "$1") : s;
          if (!h.match(/\S*Error: /)) {
            for (var g of r) {
              var t = g(h, e);
              if (t) {
                d.push(t);
                break;
              }
            }
            if (d.length >= dg) break;
          }
        }
      }
      return function(i) {
        if (!i.length) return [];
        var m = Array.from(i);
        return m.reverse(), m.slice(0, dg).map((v) => {
          return pt({}, v, { filename: v.filename || (E = m, E[E.length - 1] || {}).filename, function: v.function || Ua });
          var E;
        });
      }(d);
    };
  }("web:javascript", MO, LO);
}
class $O {
  match(n) {
    return this.isDOMException(n) || this.isDOMError(n);
  }
  coerce(n, r) {
    var a = ti(n.stack);
    return { type: this.getType(n), value: this.getValue(n), stack: a ? n.stack : void 0, cause: n.cause ? r.next(n.cause) : void 0, synthetic: !1 };
  }
  getType(n) {
    return this.isDOMError(n) ? "DOMError" : "DOMException";
  }
  getValue(n) {
    var r = n.name || (this.isDOMError(n) ? "DOMError" : "DOMException");
    return n.message ? r + ": " + n.message : r;
  }
  isDOMException(n) {
    return Wl(n, "DOMException");
  }
  isDOMError(n) {
    return Wl(n, "DOMError");
  }
}
class UO {
  match(n) {
    return ((r) => r instanceof Error)(n);
  }
  coerce(n, r) {
    return { type: this.getType(n), value: this.getMessage(n, r), stack: this.getStack(n), cause: n.cause ? r.next(n.cause) : void 0, synthetic: !1 };
  }
  getType(n) {
    return n.name || n.constructor.name;
  }
  getMessage(n, r) {
    var a = n.message;
    return a.error && typeof a.error.message == "string" ? String(a.error.message) : String(a);
  }
  getStack(n) {
    return n.stacktrace || n.stack || void 0;
  }
}
class zO {
  constructor() {
  }
  match(n) {
    return Wl(n, "ErrorEvent") && n.error != null;
  }
  coerce(n, r) {
    var a, o = r.apply(n.error);
    return o || { type: "ErrorEvent", value: n.message, stack: (a = r.syntheticException) == null ? void 0 : a.stack, synthetic: !0 };
  }
}
var HO = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
class WO {
  match(n) {
    return typeof n == "string";
  }
  coerce(n, r) {
    var a, [o, l] = this.getInfos(n);
    return { type: o ?? "Error", value: l ?? n, stack: (a = r.syntheticException) == null ? void 0 : a.stack, synthetic: !0 };
  }
  getInfos(n) {
    var r = "Error", a = n, o = n.match(HO);
    return o && (r = o[1], a = o[2]), [r, a];
  }
}
var qO = ["fatal", "error", "warning", "log", "info", "debug"];
function r3(e, n) {
  n === void 0 && (n = 40);
  var r = Object.keys(e);
  if (r.sort(), !r.length) return "[object has no keys]";
  for (var a = r.length; a > 0; a--) {
    var o = r.slice(0, a).join(", ");
    if (!(o.length > n)) return a === r.length || o.length <= n ? o : o.slice(0, n) + "...";
  }
  return "";
}
class VO {
  match(n) {
    return typeof n == "object" && n !== null;
  }
  coerce(n, r) {
    var a, o = this.getErrorPropertyFromObject(n);
    return o ? r.apply(o) : { type: this.getType(n), value: this.getValue(n), stack: (a = r.syntheticException) == null ? void 0 : a.stack, level: this.isSeverityLevel(n.level) ? n.level : "error", synthetic: !0 };
  }
  getType(n) {
    return $9(n) ? n.constructor.name : "Error";
  }
  getValue(n) {
    if ("name" in n && typeof n.name == "string") {
      var r = "'" + n.name + "' captured as exception";
      return "message" in n && typeof n.message == "string" && (r += " with message: '" + n.message + "'"), r;
    }
    if ("message" in n && typeof n.message == "string") return n.message;
    var a = this.getObjectClassName(n);
    return (a && a !== "Object" ? "'" + a + "'" : "Object") + " captured as exception with keys: " + r3(n);
  }
  isSeverityLevel(n) {
    return ti(n) && !hh(n) && qO.indexOf(n) >= 0;
  }
  getErrorPropertyFromObject(n) {
    for (var r in n) if (Object.prototype.hasOwnProperty.call(n, r)) {
      var a = n[r];
      if (TO(a)) return a;
    }
  }
  getObjectClassName(n) {
    try {
      var r = Object.getPrototypeOf(n);
      return r ? r.constructor.name : void 0;
    } catch {
      return;
    }
  }
}
class XO {
  match(n) {
    return $9(n);
  }
  coerce(n, r) {
    var a, o = n.constructor.name;
    return { type: o, value: o + " captured as exception with keys: " + r3(n), stack: (a = r.syntheticException) == null ? void 0 : a.stack, synthetic: !0 };
  }
}
class GO {
  match(n) {
    return fh(n);
  }
  coerce(n, r) {
    var a;
    return { type: "Error", value: "Primitive value captured as exception: " + String(n), stack: (a = r.syntheticException) == null ? void 0 : a.stack, synthetic: !0 };
  }
}
class KO {
  match(n) {
    return Wl(n, "PromiseRejectionEvent");
  }
  coerce(n, r) {
    var a, o = this.getUnhandledRejectionReason(n);
    return fh(o) ? { type: "UnhandledRejection", value: "Non-Error promise rejection captured with value: " + String(o), stack: (a = r.syntheticException) == null ? void 0 : a.stack, synthetic: !0 } : r.apply(o);
  }
  getUnhandledRejectionReason(n) {
    if (fh(n)) return n;
    try {
      if ("reason" in n) return n.reason;
      if ("detail" in n && "reason" in n.detail) return n.detail.reason;
    } catch {
    }
    return n;
  }
}
var s3 = function(e, n) {
  var { debugEnabled: r } = n === void 0 ? {} : n, a = { k: function(o) {
    if (Xe && (Lr.DEBUG || qt.POSTHOG_DEBUG || r) && !wt(Xe.console) && Xe.console) {
      for (var l = ("__rrweb_original__" in Xe.console[o]) ? Xe.console[o].__rrweb_original__ : Xe.console[o], d = arguments.length, c = new Array(d > 1 ? d - 1 : 0), f = 1; f < d; f++) c[f - 1] = arguments[f];
      l(e, ...c);
    }
  }, info: function() {
    for (var o = arguments.length, l = new Array(o), d = 0; d < o; d++) l[d] = arguments[d];
    a.k("log", ...l);
  }, warn: function() {
    for (var o = arguments.length, l = new Array(o), d = 0; d < o; d++) l[d] = arguments[d];
    a.k("warn", ...l);
  }, error: function() {
    for (var o = arguments.length, l = new Array(o), d = 0; d < o; d++) l[d] = arguments[d];
    a.k("error", ...l);
  }, critical: function() {
    for (var o = arguments.length, l = new Array(o), d = 0; d < o; d++) l[d] = arguments[d];
    console.error(e, ...l);
  }, uninitializedWarning: (o) => {
    a.error("You must initialize PostHog before calling " + o);
  }, createLogger: (o, l) => s3(e + " " + o, l) };
  return a;
}, vt = s3("[PostHog.js]"), Bn = vt.createLogger, YO = Bn("[ExternalScriptsLoader]"), hg = (e, n, r) => {
  if (e.config.disable_external_dependency_loading) return YO.warn(n + " was requested but loading of external scripts is disabled."), r("Loading of external scripts is disabled");
  var a = bt == null ? void 0 : bt.querySelectorAll("script");
  if (a) {
    for (var o, l = function() {
      if (a[d].src === n) {
        var f = a[d];
        return f.__posthog_loading_callback_fired ? { v: r() } : (f.addEventListener("load", (s) => {
          f.__posthog_loading_callback_fired = !0, r(void 0, s);
        }), f.onerror = (s) => r(s), { v: void 0 });
      }
    }, d = 0; d < a.length; d++) if (o = l()) return o.v;
  }
  var c = () => {
    if (!bt) return r("document not found");
    var f = bt.createElement("script");
    if (f.type = "text/javascript", f.crossOrigin = "anonymous", f.src = n, f.onload = (g) => {
      f.__posthog_loading_callback_fired = !0, r(void 0, g);
    }, f.onerror = (g) => r(g), e.config.prepare_external_dependency_script && (f = e.config.prepare_external_dependency_script(f)), !f) return r("prepare_external_dependency_script returned null");
    if (e.config.external_scripts_inject_target === "head") bt.head.appendChild(f);
    else {
      var s, h = bt.querySelectorAll("body > script");
      h.length > 0 ? (s = h[0].parentNode) == null || s.insertBefore(f, h[0]) : bt.body.appendChild(f);
    }
  };
  bt != null && bt.body ? c() : bt == null || bt.addEventListener("DOMContentLoaded", c);
};
qt.__PosthogExtensions__ = qt.__PosthogExtensions__ || {}, qt.__PosthogExtensions__.loadExternalDependency = (e, n, r) => {
  var a = "/static/" + n + ".js?v=" + e.version;
  if (n === "remote-config" && (a = "/array/" + e.config.token + "/config.js"), n === "toolbar") {
    var o = 3e5;
    a = a + "&t=" + Math.floor(Date.now() / o) * o;
  }
  var l = e.requestRouter.endpointFor("assets", a);
  hg(e, l, r);
}, qt.__PosthogExtensions__.loadSiteApp = (e, n, r) => {
  var a = e.requestRouter.endpointFor("api", n);
  hg(e, a, r);
};
var Vl = {};
function fs(e, n, r) {
  if (gn(e)) {
    if (tg && e.forEach === tg) e.forEach(n, r);
    else if ("length" in e && e.length === +e.length) {
      for (var a = 0, o = e.length; a < o; a++) if (a in e && n.call(r, e[a], a) === Vl) return;
    }
  }
}
function Tn(e, n, r) {
  if (!un(e)) {
    if (gn(e)) return fs(e, n, r);
    if (pO(e)) {
      for (var a of e.entries()) if (n.call(r, a[1], a[0]) === Vl) return;
    } else for (var o in e) if (B9.call(e, o) && n.call(r, e[o], o) === Vl) return;
  }
}
var Xn = function(e) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++) r[a - 1] = arguments[a];
  return fs(r, function(o) {
    for (var l in o) o[l] !== void 0 && (e[l] = o[l]);
  }), e;
}, za = function(e) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++) r[a - 1] = arguments[a];
  return fs(r, function(o) {
    fs(o, function(l) {
      e.push(l);
    });
  }), e;
};
function Sl(e) {
  for (var n = Object.keys(e), r = n.length, a = new Array(r); r--; ) a[r] = [n[r], e[n[r]]];
  return a;
}
var fg = function(e) {
  try {
    return e();
  } catch {
    return;
  }
}, ZO = function(e) {
  return function() {
    try {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++) r[a] = arguments[a];
      return e.apply(this, r);
    } catch (o) {
      vt.critical("Implementation error. Please turn on debug mode and open a ticket on https://app.posthog.com/home#panel=support%3Asupport%3A."), vt.critical(o);
    }
  };
}, Kf = function(e) {
  var n = {};
  return Tn(e, function(r, a) {
    (ti(r) && r.length > 0 || Pr(r)) && (n[a] = r);
  }), n;
};
function QO(e, n) {
  return r = e, a = (l) => ti(l) && !br(n) ? l.slice(0, n) : l, o = /* @__PURE__ */ new Set(), function l(d, c) {
    return d !== Object(d) ? a ? a(d, c) : d : o.has(d) ? void 0 : (o.add(d), gn(d) ? (f = [], fs(d, (s) => {
      f.push(l(s));
    })) : (f = {}, Tn(d, (s, h) => {
      o.has(s) || (f[h] = l(s, h));
    })), f);
    var f;
  }(r);
  var r, a, o;
}
var JO = ["herokuapp.com", "vercel.app", "netlify.app"];
function eF(e) {
  var n = e == null ? void 0 : e.hostname;
  if (!ti(n)) return !1;
  var r = n.split(".").slice(-2).join(".");
  for (var a of JO) if (r === a) return !1;
  return !0;
}
function a3(e, n) {
  for (var r = 0; r < e.length; r++) if (n(e[r])) return e[r];
}
function Qn(e, n, r, a) {
  var { capture: o = !1, passive: l = !0 } = a ?? {};
  e == null || e.addEventListener(n, r, { capture: o, passive: l });
}
function o3(e) {
  return e.name === "ph_toolbar_internal";
}
var c3 = "$people_distinct_id", Oo = "__alias", Fo = "__timers", pg = "$autocapture_disabled_server_side", bh = "$heatmaps_enabled_server_side", gg = "$exception_capture_enabled_server_side", yh = "$error_tracking_suppression_rules", mg = "$error_tracking_capture_extension_exceptions", xg = "$web_vitals_enabled_server_side", l3 = "$dead_clicks_enabled_server_side", bg = "$product_tours_enabled_server_side", yg = "$web_vitals_allowed_metrics", Yc = "$session_recording_remote_config", Xl = "$sesid", u3 = "$session_is_sampled", Aa = "$enabled_feature_flags", Po = "$early_access_features", vh = "$feature_flag_details", jo = "$stored_person_properties", Ps = "$stored_group_properties", wh = "$surveys", Gl = "$flag_call_reported", Sh = "$feature_flag_errors", Kl = "$feature_flag_evaluated_at", wr = "$user_state", _h = "$client_session_props", Ch = "$capture_rate_limit", Ah = "$initial_campaign_params", kh = "$initial_referrer_info", Yl = "$initial_person_info", Zl = "$epp", d3 = "__POSTHOG_TOOLBAR__", go = "$posthog_cookieless", tF = [c3, Oo, "__cmpns", Fo, "$session_recording_enabled_server_side", bh, Xl, Aa, yh, wr, Po, vh, Ps, jo, wh, Gl, Sh, Kl, _h, Ch, Ah, kh, Zl, Yl];
Math.trunc || (Math.trunc = function(e) {
  return e < 0 ? Math.ceil(e) : Math.floor(e);
}), Number.isInteger || (Number.isInteger = function(e) {
  return Pr(e) && isFinite(e) && Math.floor(e) === e;
});
var vg = "0123456789abcdef";
class Ql {
  constructor(n) {
    if (this.bytes = n, n.length !== 16) throw new TypeError("not 128-bit length");
  }
  static fromFieldsV7(n, r, a, o) {
    if (!Number.isInteger(n) || !Number.isInteger(r) || !Number.isInteger(a) || !Number.isInteger(o) || n < 0 || r < 0 || a < 0 || o < 0 || n > 281474976710655 || r > 4095 || a > 1073741823 || o > 4294967295) throw new RangeError("invalid field value");
    var l = new Uint8Array(16);
    return l[0] = n / Math.pow(2, 40), l[1] = n / Math.pow(2, 32), l[2] = n / Math.pow(2, 24), l[3] = n / Math.pow(2, 16), l[4] = n / Math.pow(2, 8), l[5] = n, l[6] = 112 | r >>> 8, l[7] = r, l[8] = 128 | a >>> 24, l[9] = a >>> 16, l[10] = a >>> 8, l[11] = a, l[12] = o >>> 24, l[13] = o >>> 16, l[14] = o >>> 8, l[15] = o, new Ql(l);
  }
  toString() {
    for (var n = "", r = 0; r < this.bytes.length; r++) n = n + vg.charAt(this.bytes[r] >>> 4) + vg.charAt(15 & this.bytes[r]), r !== 3 && r !== 5 && r !== 7 && r !== 9 || (n += "-");
    if (n.length !== 36) throw new Error("Invalid UUIDv7 was generated");
    return n;
  }
  clone() {
    return new Ql(this.bytes.slice(0));
  }
  equals(n) {
    return this.compareTo(n) === 0;
  }
  compareTo(n) {
    for (var r = 0; r < 16; r++) {
      var a = this.bytes[r] - n.bytes[r];
      if (a !== 0) return Math.sign(a);
    }
    return 0;
  }
}
class nF {
  constructor() {
    this.P = 0, this.T = 0, this.R = new iF();
  }
  generate() {
    var n = this.generateOrAbort();
    if (wt(n)) {
      this.P = 0;
      var r = this.generateOrAbort();
      if (wt(r)) throw new Error("Could not generate UUID after timestamp reset");
      return r;
    }
    return n;
  }
  generateOrAbort() {
    var n = Date.now();
    if (n > this.P) this.P = n, this.I();
    else {
      if (!(n + 1e4 > this.P)) return;
      this.T++, this.T > 4398046511103 && (this.P++, this.I());
    }
    return Ql.fromFieldsV7(this.P, Math.trunc(this.T / Math.pow(2, 30)), this.T & Math.pow(2, 30) - 1, this.R.nextUint32());
  }
  I() {
    this.T = 1024 * this.R.nextUint32() + (1023 & this.R.nextUint32());
  }
}
var wg, h3 = (e) => {
  if (typeof UUIDV7_DENY_WEAK_RNG < "u" && UUIDV7_DENY_WEAK_RNG) throw new Error("no cryptographically strong RNG available");
  for (var n = 0; n < e.length; n++) e[n] = 65536 * Math.trunc(65536 * Math.random()) + Math.trunc(65536 * Math.random());
  return e;
};
Xe && !wt(Xe.crypto) && crypto.getRandomValues && (h3 = (e) => crypto.getRandomValues(e));
class iF {
  constructor() {
    this.C = new Uint32Array(8), this.F = 1 / 0;
  }
  nextUint32() {
    return this.F >= this.C.length && (h3(this.C), this.F = 0), this.C[this.F++];
  }
}
var hs = () => rF().toString(), rF = () => (wg || (wg = new nF())).generate(), mo = "", sF = /[a-z0-9][a-z0-9-]+\.[a-z]{2,}$/i;
function aF(e, n) {
  if (n) {
    var r = function(o, l) {
      if (l === void 0 && (l = bt), mo) return mo;
      if (!l || ["localhost", "127.0.0.1"].includes(o)) return "";
      for (var d = o.split("."), c = Math.min(d.length, 8), f = "dmn_chk_" + hs(); !mo && c--; ) {
        var s = d.slice(c).join("."), h = f + "=1;domain=." + s + ";path=/";
        l.cookie = h + ";max-age=3", l.cookie.includes(f) && (l.cookie = h + ";max-age=0", mo = s);
      }
      return mo;
    }(e);
    if (!r) {
      var a = ((o) => {
        var l = o.match(sF);
        return l ? l[0] : "";
      })(e);
      a !== r && vt.info("Warning: cookie subdomain discovery mismatch", a, r), r = a;
    }
    return r ? "; domain=." + r : "";
  }
  return "";
}
var Cr = { O: () => !!bt, M: function(e) {
  vt.error("cookieStore error: " + e);
}, A: function(e) {
  if (bt) {
    try {
      for (var n = e + "=", r = bt.cookie.split(";").filter((l) => l.length), a = 0; a < r.length; a++) {
        for (var o = r[a]; o.charAt(0) == " "; ) o = o.substring(1, o.length);
        if (o.indexOf(n) === 0) return decodeURIComponent(o.substring(n.length, o.length));
      }
    } catch {
    }
    return null;
  }
}, D: function(e) {
  var n;
  try {
    n = JSON.parse(Cr.A(e)) || {};
  } catch {
  }
  return n;
}, L: function(e, n, r, a, o) {
  if (bt) try {
    var l = "", d = "", c = aF(bt.location.hostname, a);
    if (r) {
      var f = /* @__PURE__ */ new Date();
      f.setTime(f.getTime() + 24 * r * 60 * 60 * 1e3), l = "; expires=" + f.toUTCString();
    }
    o && (d = "; secure");
    var s = e + "=" + encodeURIComponent(JSON.stringify(n)) + l + "; SameSite=Lax; path=/" + c + d;
    return s.length > 3686.4 && vt.warn("cookieStore warning: large cookie, len=" + s.length), bt.cookie = s, s;
  } catch {
    return;
  }
}, j: function(e, n) {
  if (bt != null && bt.cookie) try {
    Cr.L(e, "", -1, n);
  } catch {
    return;
  }
} }, Yu = null, Dn = { O: function() {
  if (!br(Yu)) return Yu;
  var e = !0;
  if (wt(Xe)) e = !1;
  else try {
    var n = "__mplssupport__";
    Dn.L(n, "xyz"), Dn.A(n) !== '"xyz"' && (e = !1), Dn.j(n);
  } catch {
    e = !1;
  }
  return e || vt.error("localStorage unsupported; falling back to cookie store"), Yu = e, e;
}, M: function(e) {
  vt.error("localStorage error: " + e);
}, A: function(e) {
  try {
    return Xe == null ? void 0 : Xe.localStorage.getItem(e);
  } catch (n) {
    Dn.M(n);
  }
  return null;
}, D: function(e) {
  try {
    return JSON.parse(Dn.A(e)) || {};
  } catch {
  }
  return null;
}, L: function(e, n) {
  try {
    Xe == null || Xe.localStorage.setItem(e, JSON.stringify(n));
  } catch (r) {
    Dn.M(r);
  }
}, j: function(e) {
  try {
    Xe == null || Xe.localStorage.removeItem(e);
  } catch (n) {
    Dn.M(n);
  }
} }, oF = ["$device_id", "distinct_id", Xl, u3, Zl, Yl, wr], Zc = {}, cF = { O: function() {
  return !0;
}, M: function(e) {
  vt.error("memoryStorage error: " + e);
}, A: function(e) {
  return Zc[e] || null;
}, D: function(e) {
  return Zc[e] || null;
}, L: function(e, n) {
  Zc[e] = n;
}, j: function(e) {
  delete Zc[e];
} }, Es = null, hi = { O: function() {
  if (!br(Es)) return Es;
  if (Es = !0, wt(Xe)) Es = !1;
  else try {
    var e = "__support__";
    hi.L(e, "xyz"), hi.A(e) !== '"xyz"' && (Es = !1), hi.j(e);
  } catch {
    Es = !1;
  }
  return Es;
}, M: function(e) {
  vt.error("sessionStorage error: ", e);
}, A: function(e) {
  try {
    return Xe == null ? void 0 : Xe.sessionStorage.getItem(e);
  } catch (n) {
    hi.M(n);
  }
  return null;
}, D: function(e) {
  try {
    return JSON.parse(hi.A(e)) || null;
  } catch {
  }
  return null;
}, L: function(e, n) {
  try {
    Xe == null || Xe.sessionStorage.setItem(e, JSON.stringify(n));
  } catch (r) {
    hi.M(r);
  }
}, j: function(e) {
  try {
    Xe == null || Xe.sessionStorage.removeItem(e);
  } catch (n) {
    hi.M(n);
  }
} }, $r = function(e) {
  return e[e.PENDING = -1] = "PENDING", e[e.DENIED = 0] = "DENIED", e[e.GRANTED = 1] = "GRANTED", e;
}({});
class lF {
  constructor(n) {
    this._instance = n;
  }
  get N() {
    return this._instance.config;
  }
  get consent() {
    return this.U() ? $r.DENIED : this.H;
  }
  isOptedOut() {
    return this.N.cookieless_mode === "always" || this.consent === $r.DENIED || this.consent === $r.PENDING && (this.N.opt_out_capturing_by_default || this.N.cookieless_mode === "on_reject");
  }
  isOptedIn() {
    return !this.isOptedOut();
  }
  isExplicitlyOptedOut() {
    return this.consent === $r.DENIED;
  }
  optInOut(n) {
    this.B.L(this.q, n ? 1 : 0, this.N.cookie_expiration, this.N.cross_subdomain_cookie, this.N.secure_cookie);
  }
  reset() {
    this.B.j(this.q, this.N.cross_subdomain_cookie);
  }
  get q() {
    var { token: n, opt_out_capturing_cookie_prefix: r, consent_persistence_name: a } = this._instance.config;
    return a || (r ? r + n : "__ph_opt_in_out_" + n);
  }
  get H() {
    var n = this.B.A(this.q);
    return Xu(n) ? $r.GRANTED : cn(xO, n) ? $r.DENIED : $r.PENDING;
  }
  get B() {
    if (!this.V) {
      var n = this.N.opt_out_capturing_persistence_type;
      this.V = n === "localStorage" ? Dn : Cr;
      var r = n === "localStorage" ? Cr : Dn;
      r.A(this.q) && (this.V.A(this.q) || this.optInOut(Xu(r.A(this.q))), r.j(this.q, this.N.cross_subdomain_cookie));
    }
    return this.V;
  }
  U() {
    return !!this.N.respect_dnt && !!a3([qi == null ? void 0 : qi.doNotTrack, qi == null ? void 0 : qi.msDoNotTrack, qt.doNotTrack], (n) => Xu(n));
  }
}
var Qc = Bn("[Dead Clicks]"), uF = () => !0, dF = (e) => {
  var n, r = !((n = e.instance.persistence) == null || !n.get_property(l3)), a = e.instance.config.capture_dead_clicks;
  return qr(a) ? a : !!ii(a) || r;
};
class Sg {
  get lazyLoadedDeadClicksAutocapture() {
    return this.W;
  }
  constructor(n, r, a) {
    this.instance = n, this.isEnabled = r, this.onCapture = a, this.startIfEnabledOrStop();
  }
  onRemoteConfig(n) {
    "captureDeadClicks" in n && (this.instance.persistence && this.instance.persistence.register({ [l3]: n.captureDeadClicks }), this.startIfEnabledOrStop());
  }
  startIfEnabledOrStop() {
    this.isEnabled(this) ? this.G(() => {
      this.Y();
    }) : this.stop();
  }
  G(n) {
    var r, a;
    (r = qt.__PosthogExtensions__) != null && r.initDeadClicksAutocapture && n(), (a = qt.__PosthogExtensions__) == null || a.loadExternalDependency == null || a.loadExternalDependency(this.instance, "dead-clicks-autocapture", (o) => {
      o ? Qc.error("failed to load script", o) : n();
    });
  }
  Y() {
    var n;
    if (bt) {
      if (!this.W && (n = qt.__PosthogExtensions__) != null && n.initDeadClicksAutocapture) {
        var r = ii(this.instance.config.capture_dead_clicks) ? this.instance.config.capture_dead_clicks : {};
        r.__onCapture = this.onCapture, this.W = qt.__PosthogExtensions__.initDeadClicksAutocapture(this.instance, r), this.W.start(bt), Qc.info("starting...");
      }
    } else Qc.error("`document` not found. Cannot start.");
  }
  stop() {
    this.W && (this.W.stop(), this.W = void 0, Qc.info("stopping..."));
  }
}
var Zu = Bn("[SegmentIntegration]");
function hF(e, n) {
  var r = e.config.segment;
  if (!r) return n();
  (function(a, o) {
    var l = a.config.segment;
    if (!l) return o();
    var d = (f) => {
      var s = () => f.anonymousId() || hs();
      a.config.get_device_id = s, f.id() && (a.register({ distinct_id: f.id(), $device_id: s() }), a.persistence.set_property(wr, "identified")), o();
    }, c = l.user();
    "then" in c && Hr(c.then) ? c.then(d) : d(c);
  })(e, () => {
    r.register(((a) => {
      Promise && Promise.resolve || Zu.warn("This browser does not have Promise support, and can not use the segment integration");
      var o = (l, d) => {
        if (!d) return l;
        l.event.userId || l.event.anonymousId === a.get_distinct_id() || (Zu.info("No userId set, resetting PostHog"), a.reset()), l.event.userId && l.event.userId !== a.get_distinct_id() && (Zu.info("UserId set, identifying with PostHog"), a.identify(l.event.userId));
        var c = a.calculateEventProperties(d, l.event.properties);
        return l.event.properties = Object.assign({}, c, l.event.properties), l;
      };
      return { name: "PostHog JS", type: "enrichment", version: "1.0.0", isLoaded: () => !0, load: () => Promise.resolve(), track: (l) => o(l, l.event.event), page: (l) => o(l, "$pageview"), identify: (l) => o(l, "$identify"), screen: (l) => o(l, "$screen") };
    })(e)).then(() => {
      n();
    });
  });
}
var f3 = "posthog-js";
function p3(e, n) {
  var { organization: r, projectId: a, prefix: o, severityAllowList: l = ["error"], sendExceptionsToPostHog: d = !0 } = n === void 0 ? {} : n;
  return (c) => {
    var f, s, h, g, t;
    if (!(l === "*" || l.includes(c.level)) || !e.__loaded) return c;
    c.tags || (c.tags = {});
    var i = e.requestRouter.endpointFor("ui", "/project/" + e.config.token + "/person/" + e.get_distinct_id());
    c.tags["PostHog Person URL"] = i, e.sessionRecordingStarted() && (c.tags["PostHog Recording URL"] = e.get_session_replay_url({ withTimestamp: !0 }));
    var m, v = ((f = c.exception) == null ? void 0 : f.values) || [], E = v.map((y) => pt({}, y, { stacktrace: y.stacktrace ? pt({}, y.stacktrace, { type: "raw", frames: (y.stacktrace.frames || []).map((x) => pt({}, x, { platform: "web:javascript" })) }) : void 0 })), S = { $exception_message: ((s = v[0]) == null ? void 0 : s.value) || c.message, $exception_type: (h = v[0]) == null ? void 0 : h.type, $exception_level: c.level, $exception_list: E, $sentry_event_id: c.event_id, $sentry_exception: c.exception, $sentry_exception_message: ((g = v[0]) == null ? void 0 : g.value) || c.message, $sentry_exception_type: (t = v[0]) == null ? void 0 : t.type, $sentry_tags: c.tags };
    return r && a && (S.$sentry_url = (o || "https://sentry.io/organizations/") + r + "/issues/?project=" + a + "&query=" + c.event_id), d && ((m = e.exceptions) == null || m.sendExceptionEvent(S)), c;
  };
}
class fF {
  constructor(n, r, a, o, l, d) {
    this.name = f3, this.setupOnce = function(c) {
      c(p3(n, { organization: r, projectId: a, prefix: o, severityAllowList: l, sendExceptionsToPostHog: d == null || d }));
    };
  }
}
class _g {
  constructor(n) {
    this.J = (r, a, o) => {
      o && (o.noSessionId || o.activityTimeout || o.sessionPastMaximumLength) && (vt.info("[PageViewManager] Session rotated, clearing pageview state", { sessionId: r, changeReason: o }), this.K = void 0, this._instance.scrollManager.resetContext());
    }, this._instance = n, this.X();
  }
  X() {
    var n;
    this.Z = (n = this._instance.sessionManager) == null ? void 0 : n.onSessionId(this.J);
  }
  destroy() {
    var n;
    (n = this.Z) == null || n.call(this), this.Z = void 0;
  }
  doPageView(n, r) {
    var a, o = this.tt(n, r);
    return this.K = { pathname: (a = Xe == null ? void 0 : Xe.location.pathname) !== null && a !== void 0 ? a : "", pageViewId: r, timestamp: n }, this._instance.scrollManager.resetContext(), o;
  }
  doPageLeave(n) {
    var r;
    return this.tt(n, (r = this.K) == null ? void 0 : r.pageViewId);
  }
  doEvent() {
    var n;
    return { $pageview_id: (n = this.K) == null ? void 0 : n.pageViewId };
  }
  tt(n, r) {
    var a = this.K;
    if (!a) return { $pageview_id: r };
    var o = { $pageview_id: r, $prev_pageview_id: a.pageViewId }, l = this._instance.scrollManager.getContext();
    if (l && !this._instance.config.disable_scroll_properties) {
      var { maxScrollHeight: d, lastScrollY: c, maxScrollY: f, maxContentHeight: s, lastContentY: h, maxContentY: g } = l;
      if (!(wt(d) || wt(c) || wt(f) || wt(s) || wt(h) || wt(g))) {
        d = Math.ceil(d), c = Math.ceil(c), f = Math.ceil(f), s = Math.ceil(s), h = Math.ceil(h), g = Math.ceil(g);
        var t = d <= 1 ? 1 : kr(c / d, 0, 1, vt), i = d <= 1 ? 1 : kr(f / d, 0, 1, vt), m = s <= 1 ? 1 : kr(h / s, 0, 1, vt), v = s <= 1 ? 1 : kr(g / s, 0, 1, vt);
        o = Xn(o, { $prev_pageview_last_scroll: c, $prev_pageview_last_scroll_percentage: t, $prev_pageview_max_scroll: f, $prev_pageview_max_scroll_percentage: i, $prev_pageview_last_content: h, $prev_pageview_last_content_percentage: m, $prev_pageview_max_content: g, $prev_pageview_max_content_percentage: v });
      }
    }
    return a.pathname && (o.$prev_pageview_pathname = a.pathname), a.timestamp && (o.$prev_pageview_duration = (n.getTime() - a.timestamp.getTime()) / 1e3), o;
  }
}
var Jl = (e) => {
  var n = bt == null ? void 0 : bt.createElement("a");
  return wt(n) ? null : (n.href = e, n);
}, pF = function(e, n) {
  var r, a;
  n === void 0 && (n = "&");
  var o = [];
  return Tn(e, function(l, d) {
    wt(l) || wt(d) || d === "undefined" || (r = encodeURIComponent(((c) => c instanceof File)(l) ? l.name : l.toString()), a = encodeURIComponent(d), o[o.length] = a + "=" + r);
  }), o.join(n);
}, e0 = function(e, n) {
  for (var r, a = ((e.split("#")[0] || "").split(/\?(.*)/)[1] || "").replace(/^\?+/g, "").split("&"), o = 0; o < a.length; o++) {
    var l = a[o].split("=");
    if (l[0] === n) {
      r = l;
      break;
    }
  }
  if (!gn(r) || r.length < 2) return "";
  var d = r[1];
  try {
    d = decodeURIComponent(d);
  } catch {
    vt.error("Skipping decoding for malformed query param: " + d);
  }
  return d.replace(/\+/g, " ");
}, sc = function(e, n, r) {
  if (!e || !n || !n.length) return e;
  for (var a = e.split("#"), o = a[0] || "", l = a[1], d = o.split("?"), c = d[1], f = d[0], s = (c || "").split("&"), h = [], g = 0; g < s.length; g++) {
    var t = s[g].split("=");
    gn(t) && (n.includes(t[0]) ? h.push(t[0] + "=" + r) : h.push(s[g]));
  }
  var i = f;
  return c != null && (i += "?" + h.join("&")), l != null && (i += "#" + l), i;
}, t0 = function(e, n) {
  var r = e.match(new RegExp(n + "=([^&]*)"));
  return r ? r[1] : null;
}, Jc = "https?://(.*)", Ha = ["gclid", "gclsrc", "dclid", "gbraid", "wbraid", "fbclid", "msclkid", "twclid", "li_fat_id", "igshid", "ttclid", "rdt_cid", "epik", "qclid", "sccid", "irclid", "_kx"], gF = za(["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "gad_source", "mc_cid"], Ha), ac = "<masked>", mF = ["li_fat_id"];
function g3(e, n, r) {
  if (!bt) return {};
  var a, o = n ? za([], Ha, r || []) : [], l = m3(sc(bt.URL, o, ac), e), d = (a = {}, Tn(mF, function(c) {
    var f = Cr.A(c);
    a[c] = f || null;
  }), a);
  return Xn(d, l);
}
function m3(e, n) {
  var r = gF.concat(n || []), a = {};
  return Tn(r, function(o) {
    var l = e0(e, o);
    a[o] = l || null;
  }), a;
}
function x3(e) {
  var n = function(l) {
    return l ? l.search(Jc + "google.([^/?]*)") === 0 ? "google" : l.search(Jc + "bing.com") === 0 ? "bing" : l.search(Jc + "yahoo.com") === 0 ? "yahoo" : l.search(Jc + "duckduckgo.com") === 0 ? "duckduckgo" : null : null;
  }(e), r = n != "yahoo" ? "q" : "p", a = {};
  if (!br(n)) {
    a.$search_engine = n;
    var o = bt ? e0(bt.referrer, r) : "";
    o.length && (a.ph_keyword = o);
  }
  return a;
}
function Cg() {
  return navigator.language || navigator.userLanguage;
}
function b3() {
  return (bt == null ? void 0 : bt.referrer) || "$direct";
}
function y3(e, n) {
  var r = e ? za([], Ha, n || []) : [], a = pi == null ? void 0 : pi.href.substring(0, 1e3);
  return { r: b3().substring(0, 1e3), u: a ? sc(a, r, ac) : void 0 };
}
function v3(e) {
  var n, { r, u: a } = e, o = { $referrer: r, $referring_domain: r == null ? void 0 : r == "$direct" ? "$direct" : (n = Jl(r)) == null ? void 0 : n.host };
  if (a) {
    o.$current_url = a;
    var l = Jl(a);
    o.$host = l == null ? void 0 : l.host, o.$pathname = l == null ? void 0 : l.pathname;
    var d = m3(a);
    Xn(o, d);
  }
  if (r) {
    var c = x3(r);
    Xn(o, c);
  }
  return o;
}
function w3() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return;
  }
}
function xF() {
  try {
    return (/* @__PURE__ */ new Date()).getTimezoneOffset();
  } catch {
    return;
  }
}
function bF(e, n) {
  var r, a, o, l;
  if (!Fi) return {};
  var d, c, f, s, h, g, t, i, m = e ? za([], Ha, n || []) : [], [v, E] = function(S) {
    for (var y = 0; y < cg.length; y++) {
      var [x, b] = cg[y], u = x.exec(S), I = u && (Hr(b) ? b(u, S) : b);
      if (I) return I;
    }
    return ["", ""];
  }(Fi);
  return Xn(Kf({ $os: v, $os_version: E, $browser: n3(Fi, navigator.vendor), $device: lg(Fi), $device_type: (c = Fi, f = { userAgentDataPlatform: (r = navigator) == null || (r = r.userAgentData) == null ? void 0 : r.platform, maxTouchPoints: (a = navigator) == null ? void 0 : a.maxTouchPoints, screenWidth: Xe == null || (o = Xe.screen) == null ? void 0 : o.width, screenHeight: Xe == null || (l = Xe.screen) == null ? void 0 : l.height, devicePixelRatio: Xe == null ? void 0 : Xe.devicePixelRatio }, i = lg(c), i === z9 || i === U9 || i === "Kobo" || i === "Kindle Fire" || i === t3 ? Ba : i === ic || i === Oa || i === rc || i === gh ? "Console" : i === W9 ? "Wearable" : i ? Xi : (f == null ? void 0 : f.userAgentDataPlatform) === "Android" && ((s = f == null ? void 0 : f.maxTouchPoints) !== null && s !== void 0 ? s : 0) > 0 ? Math.min((h = f == null ? void 0 : f.screenWidth) !== null && h !== void 0 ? h : 0, (g = f == null ? void 0 : f.screenHeight) !== null && g !== void 0 ? g : 0) / ((t = f == null ? void 0 : f.devicePixelRatio) !== null && t !== void 0 ? t : 1) >= 600 ? Ba : Xi : "Desktop"), $timezone: w3(), $timezone_offset: xF() }), { $current_url: sc(pi == null ? void 0 : pi.href, m, ac), $host: pi == null ? void 0 : pi.host, $pathname: pi == null ? void 0 : pi.pathname, $raw_user_agent: Fi.length > 1e3 ? Fi.substring(0, 997) + "..." : Fi, $browser_version: IO(Fi, navigator.vendor), $browser_language: Cg(), $browser_language_prefix: (d = Cg(), typeof d == "string" ? d.split("-")[0] : void 0), $screen_height: Xe == null ? void 0 : Xe.screen.height, $screen_width: Xe == null ? void 0 : Xe.screen.width, $viewport_height: Xe == null ? void 0 : Xe.innerHeight, $viewport_width: Xe == null ? void 0 : Xe.innerWidth, $lib: "web", $lib_version: Lr.LIB_VERSION, $insert_id: Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10), $time: Date.now() / 1e3 });
}
var yF = ["cookie", "localstorage", "localstorage+cookie", "sessionstorage", "memory"];
class Qu {
  constructor(n, r) {
    this.N = n, this.props = {}, this.it = !1, this.et = ((a) => {
      var o = "";
      return a.token && (o = a.token.replace(/\+/g, "PL").replace(/\//g, "SL").replace(/=/g, "EQ")), a.persistence_name ? "ph_" + a.persistence_name : "ph_" + o + "_posthog";
    })(n), this.B = this.rt(n), this.load(), n.debug && vt.info("Persistence loaded", n.persistence, pt({}, this.props)), this.update_config(n, n, r), this.save();
  }
  isDisabled() {
    return !!this.st;
  }
  rt(n) {
    yF.indexOf(n.persistence.toLowerCase()) === -1 && (vt.critical("Unknown persistence type " + n.persistence + "; falling back to localStorage+cookie"), n.persistence = "localStorage+cookie");
    var r = function(o) {
      o === void 0 && (o = []);
      var l = [...oF, ...o];
      return pt({}, Dn, { D: function(d) {
        try {
          var c = {};
          try {
            c = Cr.D(d) || {};
          } catch {
          }
          var f = Xn(c, JSON.parse(Dn.A(d) || "{}"));
          return Dn.L(d, f), f;
        } catch {
        }
        return null;
      }, L: function(d, c, f, s, h, g) {
        try {
          Dn.L(d, c, void 0, void 0, g);
          var t = {};
          l.forEach((i) => {
            c[i] && (t[i] = c[i]);
          }), Object.keys(t).length && Cr.L(d, t, f, s, h, g);
        } catch (i) {
          Dn.M(i);
        }
      }, j: function(d, c) {
        try {
          Xe == null || Xe.localStorage.removeItem(d), Cr.j(d, c);
        } catch (f) {
          Dn.M(f);
        }
      } });
    }(n.cookie_persisted_properties || []), a = n.persistence.toLowerCase();
    return a === "localstorage" && Dn.O() ? Dn : a === "localstorage+cookie" && r.O() ? r : a === "sessionstorage" && hi.O() ? hi : a === "memory" ? cF : a === "cookie" ? Cr : r.O() ? r : Cr;
  }
  nt(n) {
    var r = n ?? this.N.feature_flag_cache_ttl_ms;
    if (!r || r <= 0) return !1;
    var a = this.props[Kl];
    return !a || typeof a != "number" || Date.now() - a > r;
  }
  properties() {
    var n = {};
    return Tn(this.props, (r, a) => {
      if (a === Aa && ii(r)) {
        if (!this.nt()) for (var o = Object.keys(r), l = 0; l < o.length; l++) n["$feature/" + o[l]] = r[o[l]];
      } else c = a, f = !1, (br(d = tF) ? f : ng && d.indexOf === ng ? d.indexOf(c) != -1 : (Tn(d, function(s) {
        if (f || (f = s === c)) return Vl;
      }), f)) || (n[a] = r);
      var d, c, f;
    }), n;
  }
  load() {
    if (!this.st) {
      var n = this.B.D(this.et);
      n && (this.props = Xn({}, n));
    }
  }
  save() {
    this.st || this.B.L(this.et, this.props, this.ot, this.ut, this.ht, this.N.debug);
  }
  remove() {
    this.B.j(this.et, !1), this.B.j(this.et, !0);
  }
  clear() {
    this.remove(), this.props = {};
  }
  register_once(n, r, a) {
    if (ii(n)) {
      wt(r) && (r = "None"), this.ot = wt(a) ? this.dt : a;
      var o = !1;
      if (Tn(n, (l, d) => {
        this.props.hasOwnProperty(d) && this.props[d] !== r || (this.props[d] = l, o = !0);
      }), o) return this.save(), !0;
    }
    return !1;
  }
  register(n, r) {
    if (ii(n)) {
      this.ot = wt(r) ? this.dt : r;
      var a = !1;
      if (Tn(n, (o, l) => {
        n.hasOwnProperty(l) && this.props[l] !== o && (this.props[l] = o, a = !0);
      }), a) return this.save(), !0;
    }
    return !1;
  }
  unregister(n) {
    n in this.props && (delete this.props[n], this.save());
  }
  update_campaign_params() {
    if (!this.it) {
      var n = g3(this.N.custom_campaign_params, this.N.mask_personal_data_properties, this.N.custom_personal_data_properties);
      Ca(Kf(n)) || this.register(n), this.it = !0;
    }
  }
  update_search_keyword() {
    var n;
    this.register((n = bt == null ? void 0 : bt.referrer) ? x3(n) : {});
  }
  update_referrer_info() {
    var n;
    this.register_once({ $referrer: b3(), $referring_domain: bt != null && bt.referrer && ((n = Jl(bt.referrer)) == null ? void 0 : n.host) || "$direct" }, void 0);
  }
  set_initial_person_info() {
    this.props[Ah] || this.props[kh] || this.register_once({ [Yl]: y3(this.N.mask_personal_data_properties, this.N.custom_personal_data_properties) }, void 0);
  }
  get_initial_props() {
    var n = {};
    Tn([kh, Ah], (d) => {
      var c = this.props[d];
      c && Tn(c, function(f, s) {
        n["$initial_" + dh(s)] = f;
      });
    });
    var r, a, o = this.props[Yl];
    if (o) {
      var l = (r = v3(o), a = {}, Tn(r, function(d, c) {
        a["$initial_" + dh(c)] = d;
      }), a);
      Xn(n, l);
    }
    return n;
  }
  safe_merge(n) {
    return Tn(this.props, function(r, a) {
      a in n || (n[a] = r);
    }), n;
  }
  update_config(n, r, a) {
    if (this.dt = this.ot = n.cookie_expiration, this.set_disabled(n.disable_persistence || !!a), this.set_cross_subdomain(n.cross_subdomain_cookie), this.set_secure(n.secure_cookie), n.persistence !== r.persistence || !((d, c) => {
      if (d.length !== c.length) return !1;
      var f = [...d].sort(), s = [...c].sort();
      return f.every((h, g) => h === s[g]);
    })(n.cookie_persisted_properties || [], r.cookie_persisted_properties || [])) {
      var o = this.rt(n), l = this.props;
      this.clear(), this.B = o, this.props = l, this.save();
    }
  }
  set_disabled(n) {
    this.st = n, this.st ? this.remove() : this.save();
  }
  set_cross_subdomain(n) {
    n !== this.ut && (this.ut = n, this.remove(), this.save());
  }
  set_secure(n) {
    n !== this.ht && (this.ht = n, this.remove(), this.save());
  }
  set_event_timer(n, r) {
    var a = this.props[Fo] || {};
    a[n] = r, this.props[Fo] = a, this.save();
  }
  remove_event_timer(n) {
    var r = (this.props[Fo] || {})[n];
    return wt(r) || (delete this.props[Fo][n], this.save()), r;
  }
  get_property(n) {
    return this.props[n];
  }
  set_property(n, r) {
    this.props[n] = r, this.save();
  }
}
var xo = { Activation: "events", Cancellation: "cancelEvents" }, Ju = { Popover: "popover", API: "api", Widget: "widget", ExternalSurvey: "external_survey" }, Ro = { SHOWN: "survey shown", DISMISSED: "survey dismissed", SENT: "survey sent", ABANDONED: "survey abandoned" }, ed = { SURVEY_ID: "$survey_id", SURVEY_NAME: "$survey_name", SURVEY_RESPONSE: "$survey_response", SURVEY_ITERATION: "$survey_iteration", SURVEY_ITERATION_START_DATE: "$survey_iteration_start_date", SURVEY_PARTIALLY_COMPLETED: "$survey_partially_completed", SURVEY_SUBMISSION_ID: "$survey_submission_id", SURVEY_QUESTIONS: "$survey_questions", SURVEY_COMPLETED: "$survey_completed", PRODUCT_TOUR_ID: "$product_tour_id", SURVEY_LAST_SEEN_DATE: "$survey_last_seen_date" }, Eh = { Popover: "popover", Inline: "inline" }, vF = function(e) {
  return e.SHOWN = "product tour shown", e.DISMISSED = "product tour dismissed", e.COMPLETED = "product tour completed", e.STEP_SHOWN = "product tour step shown", e.STEP_COMPLETED = "product tour step completed", e.BUTTON_CLICKED = "product tour button clicked", e.STEP_SELECTOR_FAILED = "product tour step selector failed", e.BANNER_CONTAINER_SELECTOR_FAILED = "product tour banner container selector failed", e.BANNER_ACTION_CLICKED = "product tour banner action clicked", e;
}({}), Ag = function(e) {
  return e.TOUR_ID = "$product_tour_id", e.TOUR_NAME = "$product_tour_name", e.TOUR_ITERATION = "$product_tour_iteration", e.TOUR_RENDER_REASON = "$product_tour_render_reason", e.TOUR_STEP_ID = "$product_tour_step_id", e.TOUR_STEP_ORDER = "$product_tour_step_order", e.TOUR_STEP_TYPE = "$product_tour_step_type", e.TOUR_DISMISS_REASON = "$product_tour_dismiss_reason", e.TOUR_BUTTON_TEXT = "$product_tour_button_text", e.TOUR_BUTTON_ACTION = "$product_tour_button_action", e.TOUR_BUTTON_LINK = "$product_tour_button_link", e.TOUR_BUTTON_TOUR_ID = "$product_tour_button_tour_id", e.TOUR_STEPS_COUNT = "$product_tour_steps_count", e.TOUR_STEP_SELECTOR = "$product_tour_step_selector", e.TOUR_STEP_SELECTOR_FOUND = "$product_tour_step_selector_found", e.TOUR_STEP_ELEMENT_TAG = "$product_tour_step_element_tag", e.TOUR_STEP_ELEMENT_ID = "$product_tour_step_element_id", e.TOUR_STEP_ELEMENT_CLASSES = "$product_tour_step_element_classes", e.TOUR_STEP_ELEMENT_TEXT = "$product_tour_step_element_text", e.TOUR_ERROR = "$product_tour_error", e.TOUR_MATCHES_COUNT = "$product_tour_matches_count", e.TOUR_FAILURE_PHASE = "$product_tour_failure_phase", e.TOUR_WAITED_FOR_ELEMENT = "$product_tour_waited_for_element", e.TOUR_WAIT_DURATION_MS = "$product_tour_wait_duration_ms", e.TOUR_BANNER_SELECTOR = "$product_tour_banner_selector", e.TOUR_LINKED_SURVEY_ID = "$product_tour_linked_survey_id", e.USE_MANUAL_SELECTOR = "$use_manual_selector", e.INFERENCE_DATA_PRESENT = "$inference_data_present", e.TOUR_LAST_SEEN_DATE = "$product_tour_last_seen_date", e.TOUR_TYPE = "$product_tour_type", e;
}({}), kg = Bn("[RateLimiter]");
class wF {
  constructor(n) {
    this.serverLimits = {}, this.lastEventRateLimited = !1, this.checkForLimiting = (r) => {
      var a = r.text;
      if (a && a.length) try {
        (JSON.parse(a).quota_limited || []).forEach((o) => {
          kg.info((o || "events") + " is quota limited."), this.serverLimits[o] = (/* @__PURE__ */ new Date()).getTime() + 6e4;
        });
      } catch (o) {
        return void kg.warn('could not rate limit - continuing. Error: "' + (o == null ? void 0 : o.message) + '"', { text: a });
      }
    }, this.instance = n, this.lastEventRateLimited = this.clientRateLimitContext(!0).isRateLimited;
  }
  get captureEventsPerSecond() {
    var n;
    return ((n = this.instance.config.rate_limiting) == null ? void 0 : n.events_per_second) || 10;
  }
  get captureEventsBurstLimit() {
    var n;
    return Math.max(((n = this.instance.config.rate_limiting) == null ? void 0 : n.events_burst_limit) || 10 * this.captureEventsPerSecond, this.captureEventsPerSecond);
  }
  clientRateLimitContext(n) {
    var r, a, o;
    n === void 0 && (n = !1);
    var { captureEventsBurstLimit: l, captureEventsPerSecond: d } = this, c = (/* @__PURE__ */ new Date()).getTime(), f = (r = (a = this.instance.persistence) == null ? void 0 : a.get_property(Ch)) !== null && r !== void 0 ? r : { tokens: l, last: c };
    f.tokens += (c - f.last) / 1e3 * d, f.last = c, f.tokens > l && (f.tokens = l);
    var s = f.tokens < 1;
    return s || n || (f.tokens = Math.max(0, f.tokens - 1)), !s || this.lastEventRateLimited || n || this.instance.capture("$$client_ingestion_warning", { $$client_ingestion_warning_message: "posthog-js client rate limited. Config is set to " + d + " events per second and " + l + " events burst limit." }, { skip_client_rate_limiting: !0 }), this.lastEventRateLimited = s, (o = this.instance.persistence) == null || o.set_property(Ch, f), { isRateLimited: s, remainingTokens: f.tokens };
  }
  isServerRateLimited(n) {
    var r = this.serverLimits[n || "events"] || !1;
    return r !== !1 && (/* @__PURE__ */ new Date()).getTime() < r;
  }
}
var bo = Bn("[RemoteConfig]");
class S3 {
  constructor(n) {
    this._instance = n;
  }
  get remoteConfig() {
    var n;
    return (n = qt._POSTHOG_REMOTE_CONFIG) == null || (n = n[this._instance.config.token]) == null ? void 0 : n.config;
  }
  vt(n) {
    var r, a;
    (r = qt.__PosthogExtensions__) != null && r.loadExternalDependency ? (a = qt.__PosthogExtensions__) == null || a.loadExternalDependency == null || a.loadExternalDependency(this._instance, "remote-config", () => n(this.remoteConfig)) : n();
  }
  ct(n) {
    this._instance._send_request({ method: "GET", url: this._instance.requestRouter.endpointFor("assets", "/array/" + this._instance.config.token + "/config"), callback: (r) => {
      n(r.json);
    } });
  }
  load() {
    try {
      if (this.remoteConfig) return bo.info("Using preloaded remote config", this.remoteConfig), this.ft(this.remoteConfig), void this._t();
      if (this._instance.bt()) return void bo.warn("Remote config is disabled. Falling back to local config.");
      this.vt((n) => {
        if (!n) return bo.info("No config found after loading remote JS config. Falling back to JSON."), void this.ct((r) => {
          this.ft(r), this._t();
        });
        this.ft(n), this._t();
      });
    } catch (n) {
      bo.error("Error loading remote config", n);
    }
  }
  stop() {
    this.yt && (clearInterval(this.yt), this.yt = void 0);
  }
  refresh() {
    this._instance.bt() || (bt == null ? void 0 : bt.visibilityState) === "hidden" || this._instance.reloadFeatureFlags();
  }
  _t() {
    var n;
    if (!this.yt) {
      var r = (n = this._instance.config.remote_config_refresh_interval_ms) !== null && n !== void 0 ? n : 3e5;
      r !== 0 && (this.yt = setInterval(() => {
        this.refresh();
      }, r));
    }
  }
  ft(n) {
    n || bo.error("Failed to fetch remote config from PostHog."), this._instance.ft(n ?? {}), (n == null ? void 0 : n.hasFeatureFlags) !== !1 && (this._instance.config.advanced_disable_feature_flags_on_first_load || this._instance.featureFlags.ensureFlagsLoaded());
  }
}
var zr = function(e) {
  return e.GZipJS = "gzip-js", e.Base64 = "base64", e;
}({}), sr = Uint8Array, Di = Uint16Array, Wa = Uint32Array, Yf = new sr([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0]), Zf = new sr([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0]), Eg = new sr([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), _3 = function(e, n) {
  for (var r = new Di(31), a = 0; a < 31; ++a) r[a] = n += 1 << e[a - 1];
  var o = new Wa(r[30]);
  for (a = 1; a < 30; ++a) for (var l = r[a]; l < r[a + 1]; ++l) o[l] = l - r[a] << 5 | a;
  return [r, o];
}, C3 = _3(Yf, 2), SF = C3[0], Ih = C3[1];
SF[28] = 258, Ih[258] = 28;
for (var Ig = _3(Zf, 0)[1], A3 = new Di(32768), Pn = 0; Pn < 32768; ++Pn) {
  var Is = (43690 & Pn) >>> 1 | (21845 & Pn) << 1;
  Is = (61680 & (Is = (52428 & Is) >>> 2 | (13107 & Is) << 2)) >>> 4 | (3855 & Is) << 4, A3[Pn] = ((65280 & Is) >>> 8 | (255 & Is) << 8) >>> 1;
}
var Uo = function(e, n, r) {
  for (var a = e.length, o = 0, l = new Di(n); o < a; ++o) ++l[e[o] - 1];
  var d, c = new Di(n);
  for (o = 0; o < n; ++o) c[o] = c[o - 1] + l[o - 1] << 1;
  for (d = new Di(a), o = 0; o < a; ++o) d[o] = A3[c[e[o] - 1]++] >>> 15 - e[o];
  return d;
}, Hs = new sr(288);
for (Pn = 0; Pn < 144; ++Pn) Hs[Pn] = 8;
for (Pn = 144; Pn < 256; ++Pn) Hs[Pn] = 9;
for (Pn = 256; Pn < 280; ++Pn) Hs[Pn] = 7;
for (Pn = 280; Pn < 288; ++Pn) Hs[Pn] = 8;
var n0 = new sr(32);
for (Pn = 0; Pn < 32; ++Pn) n0[Pn] = 5;
var _F = Uo(Hs, 9), CF = Uo(n0, 5), k3 = function(e) {
  return (e / 8 >> 0) + (7 & e && 1);
}, E3 = function(e, n, r) {
  (r == null || r > e.length) && (r = e.length);
  var a = new (e instanceof Di ? Di : e instanceof Wa ? Wa : sr)(r - n);
  return a.set(e.subarray(n, r)), a;
}, Nr = function(e, n, r) {
  r <<= 7 & n;
  var a = n / 8 >> 0;
  e[a] |= r, e[a + 1] |= r >>> 8;
}, yo = function(e, n, r) {
  r <<= 7 & n;
  var a = n / 8 >> 0;
  e[a] |= r, e[a + 1] |= r >>> 8, e[a + 2] |= r >>> 16;
}, td = function(e, n) {
  for (var r = [], a = 0; a < e.length; ++a) e[a] && r.push({ s: a, f: e[a] });
  var o = r.length, l = r.slice();
  if (!o) return [new sr(0), 0];
  if (o == 1) {
    var d = new sr(r[0].s + 1);
    return d[r[0].s] = 1, [d, 1];
  }
  r.sort(function(u, I) {
    return u.f - I.f;
  }), r.push({ s: -1, f: 25001 });
  var c = r[0], f = r[1], s = 0, h = 1, g = 2;
  for (r[0] = { s: -1, f: c.f + f.f, l: c, r: f }; h != o - 1; ) c = r[r[s].f < r[g].f ? s++ : g++], f = r[s != h && r[s].f < r[g].f ? s++ : g++], r[h++] = { s: -1, f: c.f + f.f, l: c, r: f };
  var t = l[0].s;
  for (a = 1; a < o; ++a) l[a].s > t && (t = l[a].s);
  var i = new Di(t + 1), m = Th(r[h - 1], i, 0);
  if (m > n) {
    a = 0;
    var v = 0, E = m - n, S = 1 << E;
    for (l.sort(function(u, I) {
      return i[I.s] - i[u.s] || u.f - I.f;
    }); a < o; ++a) {
      var y = l[a].s;
      if (!(i[y] > n)) break;
      v += S - (1 << m - i[y]), i[y] = n;
    }
    for (v >>>= E; v > 0; ) {
      var x = l[a].s;
      i[x] < n ? v -= 1 << n - i[x]++ - 1 : ++a;
    }
    for (; a >= 0 && v; --a) {
      var b = l[a].s;
      i[b] == n && (--i[b], ++v);
    }
    m = n;
  }
  return [new sr(i), m];
}, Th = function(e, n, r) {
  return e.s == -1 ? Math.max(Th(e.l, n, r + 1), Th(e.r, n, r + 1)) : n[e.s] = r;
}, Tg = function(e) {
  for (var n = e.length; n && !e[--n]; ) ;
  for (var r = new Di(++n), a = 0, o = e[0], l = 1, d = function(f) {
    r[a++] = f;
  }, c = 1; c <= n; ++c) if (e[c] == o && c != n) ++l;
  else {
    if (!o && l > 2) {
      for (; l > 138; l -= 138) d(32754);
      l > 2 && (d(l > 10 ? l - 11 << 5 | 28690 : l - 3 << 5 | 12305), l = 0);
    } else if (l > 3) {
      for (d(o), --l; l > 6; l -= 6) d(8304);
      l > 2 && (d(l - 3 << 5 | 8208), l = 0);
    }
    for (; l--; ) d(o);
    l = 1, o = e[c];
  }
  return [r.subarray(0, a), n];
}, vo = function(e, n) {
  for (var r = 0, a = 0; a < n.length; ++a) r += e[a] * n[a];
  return r;
}, Oh = function(e, n, r) {
  var a = r.length, o = k3(n + 2);
  e[o] = 255 & a, e[o + 1] = a >>> 8, e[o + 2] = 255 ^ e[o], e[o + 3] = 255 ^ e[o + 1];
  for (var l = 0; l < a; ++l) e[o + l + 4] = r[l];
  return 8 * (o + 4 + a);
}, Og = function(e, n, r, a, o, l, d, c, f, s, h) {
  Nr(n, h++, r), ++o[256];
  for (var g = td(o, 15), t = g[0], i = g[1], m = td(l, 15), v = m[0], E = m[1], S = Tg(t), y = S[0], x = S[1], b = Tg(v), u = b[0], I = b[1], O = new Di(19), D = 0; D < y.length; ++D) O[31 & y[D]]++;
  for (D = 0; D < u.length; ++D) O[31 & u[D]]++;
  for (var $ = td(O, 7), K = $[0], H = $[1], B = 19; B > 4 && !K[Eg[B - 1]]; --B) ;
  var R, _, A, k, z = s + 5 << 3, T = vo(o, Hs) + vo(l, n0) + d, w = vo(o, t) + vo(l, v) + d + 14 + 3 * B + vo(O, K) + (2 * O[16] + 3 * O[17] + 7 * O[18]);
  if (z <= T && z <= w) return Oh(n, h, e.subarray(f, f + s));
  if (Nr(n, h, 1 + (w < T)), h += 2, w < T) {
    R = Uo(t, i), _ = t, A = Uo(v, E), k = v;
    var F = Uo(K, H);
    for (Nr(n, h, x - 257), Nr(n, h + 5, I - 1), Nr(n, h + 10, B - 4), h += 14, D = 0; D < B; ++D) Nr(n, h + 3 * D, K[Eg[D]]);
    h += 3 * B;
    for (var j = [y, u], P = 0; P < 2; ++P) {
      var V = j[P];
      for (D = 0; D < V.length; ++D) {
        var J = 31 & V[D];
        Nr(n, h, F[J]), h += K[J], J > 15 && (Nr(n, h, V[D] >>> 5 & 127), h += V[D] >>> 12);
      }
    }
  } else R = _F, _ = Hs, A = CF, k = n0;
  for (D = 0; D < c; ++D) if (a[D] > 255) {
    J = a[D] >>> 18 & 31, yo(n, h, R[J + 257]), h += _[J + 257], J > 7 && (Nr(n, h, a[D] >>> 23 & 31), h += Yf[J]);
    var ne = 31 & a[D];
    yo(n, h, A[ne]), h += k[ne], ne > 3 && (yo(n, h, a[D] >>> 5 & 8191), h += Zf[ne]);
  } else yo(n, h, R[a[D]]), h += _[a[D]];
  return yo(n, h, R[256]), h + _[256];
}, AF = new Wa([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]), kF = function() {
  for (var e = new Wa(256), n = 0; n < 256; ++n) {
    for (var r = n, a = 9; --a; ) r = (1 & r && 3988292384) ^ r >>> 1;
    e[n] = r;
  }
  return e;
}(), EF = function(e, n, r, a, o) {
  return function(l, d, c, f, s, h) {
    var g = l.length, t = new sr(f + g + 5 * (1 + Math.floor(g / 7e3)) + s), i = t.subarray(f, t.length - s), m = 0;
    if (!d || g < 8) for (var v = 0; v <= g; v += 65535) {
      var E = v + 65535;
      E < g ? m = Oh(i, m, l.subarray(v, E)) : (i[v] = h, m = Oh(i, m, l.subarray(v, g)));
    }
    else {
      for (var S = AF[d - 1], y = S >>> 13, x = 8191 & S, b = (1 << c) - 1, u = new Di(32768), I = new Di(b + 1), O = Math.ceil(c / 3), D = 2 * O, $ = function(L) {
        return (l[L] ^ l[L + 1] << O ^ l[L + 2] << D) & b;
      }, K = new Wa(25e3), H = new Di(288), B = new Di(32), R = 0, _ = 0, A = (v = 0, 0), k = 0, z = 0; v < g; ++v) {
        var T = $(v), w = 32767 & v, F = I[T];
        if (u[w] = F, I[T] = w, k <= v) {
          var j = g - v;
          if ((R > 7e3 || A > 24576) && j > 423) {
            m = Og(l, i, 0, K, H, B, _, A, z, v - z, m), A = R = _ = 0, z = v;
            for (var P = 0; P < 286; ++P) H[P] = 0;
            for (P = 0; P < 30; ++P) B[P] = 0;
          }
          var V = 2, J = 0, ne = x, Z = w - F & 32767;
          if (j > 2 && T == $(v - Z)) for (var te = Math.min(y, j) - 1, G = Math.min(32767, v), N = Math.min(258, j); Z <= G && --ne && w != F; ) {
            if (l[v + V] == l[v + V - Z]) {
              for (var q = 0; q < N && l[v + q] == l[v + q - Z]; ++q) ;
              if (q > V) {
                if (V = q, J = Z, q > te) break;
                var ie = Math.min(Z, q - 2), oe = 0;
                for (P = 0; P < ie; ++P) {
                  var fe = v - Z + P + 32768 & 32767, Y = fe - u[fe] + 32768 & 32767;
                  Y > oe && (oe = Y, F = fe);
                }
              }
            }
            Z += (w = F) - (F = u[w]) + 32768 & 32767;
          }
          if (J) {
            K[A++] = 268435456 | Ih[V] << 18 | Ig[J];
            var ae = 31 & Ih[V], se = 31 & Ig[J];
            _ += Yf[ae] + Zf[se], ++H[257 + ae], ++B[se], k = v + V, ++R;
          } else K[A++] = l[v], ++H[l[v]];
        }
      }
      m = Og(l, i, h, K, H, B, _, A, z, v - z, m);
    }
    return E3(t, 0, f + k3(m) + s);
  }(e, n.level == null ? 6 : n.level, n.mem == null ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(e.length)))) : 12 + n.mem, r, a, !0);
}, nd = function(e, n, r) {
  for (; r; ++n) e[n] = r, r >>>= 8;
};
function IF(e, n) {
  n === void 0 && (n = {});
  var r = /* @__PURE__ */ function() {
    var c = 4294967295;
    return { p: function(f) {
      for (var s = c, h = 0; h < f.length; ++h) s = kF[255 & s ^ f[h]] ^ s >>> 8;
      c = s;
    }, d: function() {
      return 4294967295 ^ c;
    } };
  }(), a = e.length;
  r.p(e);
  var o, l = EF(e, n, 10 + ((o = n).filename && o.filename.length + 1 || 0), 8), d = l.length;
  return function(c, f) {
    var s = f.filename;
    if (c[0] = 31, c[1] = 139, c[2] = 8, c[8] = f.level < 2 ? 4 : f.level == 9 ? 2 : 0, c[9] = 3, f.mtime != 0 && nd(c, 4, Math.floor(new Date(f.mtime || Date.now()) / 1e3)), s) {
      c[3] = 8;
      for (var h = 0; h <= s.length; ++h) c[h + 10] = s.charCodeAt(h);
    }
  }(l, n), nd(l, d - 8, r.d()), nd(l, d - 4, a), l;
}
var TF = function(e) {
  var n, r, a, o, l = "";
  for (n = r = 0, a = (e = (e + "").replace(/\r\n/g, `
`).replace(/\r/g, `
`)).length, o = 0; o < a; o++) {
    var d = e.charCodeAt(o), c = null;
    d < 128 ? r++ : c = d > 127 && d < 2048 ? String.fromCharCode(d >> 6 | 192, 63 & d | 128) : String.fromCharCode(d >> 12 | 224, d >> 6 & 63 | 128, 63 & d | 128), br(c) || (r > n && (l += e.substring(n, r)), l += c, n = r = o + 1);
  }
  return r > n && (l += e.substring(n, e.length)), l;
}, OF = !!uh || !!lh, i0 = function(e, n, r) {
  var a;
  r === void 0 && (r = !0);
  var [o, l] = e.split("?"), d = pt({}, n), c = (a = l == null ? void 0 : l.split("&").map((s) => {
    var h, [g, t] = s.split("="), i = r && (h = d[g]) !== null && h !== void 0 ? h : t;
    return delete d[g], g + "=" + i;
  })) !== null && a !== void 0 ? a : [], f = pF(d);
  return f && c.push(f), o + "?" + c.join("&");
}, Mo = (e, n) => JSON.stringify(e, (r, a) => typeof a == "bigint" ? a.toString() : a, n), id = (e) => {
  var { data: n, compression: r } = e;
  if (n) {
    if (r === zr.GZipJS) {
      var a = IF(function(c, f) {
        var s = c.length;
        if (typeof TextEncoder < "u") return new TextEncoder().encode(c);
        for (var h = new sr(c.length + (c.length >>> 1)), g = 0, t = function(E) {
          h[g++] = E;
        }, i = 0; i < s; ++i) {
          if (g + 5 > h.length) {
            var m = new sr(g + 8 + (s - i << 1));
            m.set(h), h = m;
          }
          var v = c.charCodeAt(i);
          v < 128 || f ? t(v) : v < 2048 ? (t(192 | v >>> 6), t(128 | 63 & v)) : v > 55295 && v < 57344 ? (t(240 | (v = 65536 + (1047552 & v) | 1023 & c.charCodeAt(++i)) >>> 18), t(128 | v >>> 12 & 63), t(128 | v >>> 6 & 63), t(128 | 63 & v)) : (t(224 | v >>> 12), t(128 | v >>> 6 & 63), t(128 | 63 & v));
        }
        return E3(h, 0, g);
      }(Mo(n)), { mtime: 0 });
      return { contentType: "text/plain", body: a.buffer.slice(a.byteOffset, a.byteOffset + a.byteLength), estimatedSize: a.byteLength };
    }
    if (r === zr.Base64) {
      var o = function(c) {
        var f, s, h, g, t, i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", m = 0, v = 0, E = "", S = [];
        if (!c) return c;
        c = TF(c);
        do
          f = (t = c.charCodeAt(m++) << 16 | c.charCodeAt(m++) << 8 | c.charCodeAt(m++)) >> 18 & 63, s = t >> 12 & 63, h = t >> 6 & 63, g = 63 & t, S[v++] = i.charAt(f) + i.charAt(s) + i.charAt(h) + i.charAt(g);
        while (m < c.length);
        switch (E = S.join(""), c.length % 3) {
          case 1:
            E = E.slice(0, -2) + "==";
            break;
          case 2:
            E = E.slice(0, -1) + "=";
        }
        return E;
      }(Mo(n)), l = ((c) => "data=" + encodeURIComponent(typeof c == "string" ? c : Mo(c)))(o);
      return { contentType: "application/x-www-form-urlencoded", body: l, estimatedSize: new Blob([l]).size };
    }
    var d = Mo(n);
    return { contentType: "application/json", body: d, estimatedSize: new Blob([d]).size };
  }
}, _l = [];
lh && _l.push({ transport: "fetch", method: (e) => {
  var n, r, { contentType: a, body: o, estimatedSize: l } = (n = id(e)) !== null && n !== void 0 ? n : {}, d = new Headers();
  Tn(e.headers, function(h, g) {
    d.append(g, h);
  }), a && d.append("Content-Type", a);
  var c = e.url, f = null;
  if (ig) {
    var s = new ig();
    f = { signal: s.signal, timeout: setTimeout(() => s.abort(), e.timeout) };
  }
  lh(c, pt({ method: (e == null ? void 0 : e.method) || "GET", headers: d, keepalive: e.method === "POST" && (l || 0) < 52428.8, body: o, signal: (r = f) == null ? void 0 : r.signal }, e.fetchOptions)).then((h) => h.text().then((g) => {
    var t = { statusCode: h.status, text: g };
    if (h.status === 200) try {
      t.json = JSON.parse(g);
    } catch (i) {
      vt.error(i);
    }
    e.callback == null || e.callback(t);
  })).catch((h) => {
    vt.error(h), e.callback == null || e.callback({ statusCode: 0, error: h });
  }).finally(() => f ? clearTimeout(f.timeout) : null);
} }), uh && _l.push({ transport: "XHR", method: (e) => {
  var n, r = new uh();
  r.open(e.method || "GET", e.url, !0);
  var { contentType: a, body: o } = (n = id(e)) !== null && n !== void 0 ? n : {};
  Tn(e.headers, function(l, d) {
    r.setRequestHeader(d, l);
  }), a && r.setRequestHeader("Content-Type", a), e.timeout && (r.timeout = e.timeout), e.disableXHRCredentials || (r.withCredentials = !0), r.onreadystatechange = () => {
    if (r.readyState === 4) {
      var l = { statusCode: r.status, text: r.responseText };
      if (r.status === 200) try {
        l.json = JSON.parse(r.responseText);
      } catch {
      }
      e.callback == null || e.callback(l);
    }
  }, r.send(o);
} }), qi != null && qi.sendBeacon && _l.push({ transport: "sendBeacon", method: (e) => {
  var n = i0(e.url, { beacon: "1" });
  try {
    var r, { contentType: a, body: o } = (r = id(e)) !== null && r !== void 0 ? r : {}, l = typeof o == "string" ? new Blob([o], { type: a }) : o;
    qi.sendBeacon(n, l);
  } catch {
  }
} });
var Fh = 3e3;
class FF {
  constructor(n, r) {
    this.wt = !0, this.Et = [], this.xt = kr((r == null ? void 0 : r.flush_interval_ms) || Fh, 250, 5e3, vt.createLogger("flush interval"), Fh), this.St = n;
  }
  enqueue(n) {
    this.Et.push(n), this.$t || this.kt();
  }
  unload() {
    this.Pt();
    var n = this.Et.length > 0 ? this.Tt() : {}, r = Object.values(n);
    [...r.filter((a) => a.url.indexOf("/e") === 0), ...r.filter((a) => a.url.indexOf("/e") !== 0)].map((a) => {
      this.St(pt({}, a, { transport: "sendBeacon" }));
    });
  }
  enable() {
    this.wt = !1, this.kt();
  }
  kt() {
    var n = this;
    this.wt || (this.$t = setTimeout(() => {
      if (this.Pt(), this.Et.length > 0) {
        var r = this.Tt(), a = function() {
          var l = r[o], d = (/* @__PURE__ */ new Date()).getTime();
          l.data && gn(l.data) && Tn(l.data, (c) => {
            c.offset = Math.abs(c.timestamp - d), delete c.timestamp;
          }), n.St(l);
        };
        for (var o in r) a();
      }
    }, this.xt));
  }
  Pt() {
    clearTimeout(this.$t), this.$t = void 0;
  }
  Tt() {
    var n = {};
    return Tn(this.Et, (r) => {
      var a, o = r, l = (o ? o.batchKey : null) || o.url;
      wt(n[l]) && (n[l] = pt({}, o, { data: [] })), (a = n[l].data) == null || a.push(o.data);
    }), this.Et = [], n;
  }
}
var PF = ["retriesPerformedSoFar"];
class jF {
  constructor(n) {
    this.Rt = !1, this.It = 3e3, this.Et = [], this._instance = n, this.Et = [], this.Ct = !0, !wt(Xe) && "onLine" in Xe.navigator && (this.Ct = Xe.navigator.onLine, this.Ft = () => {
      this.Ct = !0, this.Ot();
    }, this.Mt = () => {
      this.Ct = !1;
    }, Qn(Xe, "online", this.Ft), Qn(Xe, "offline", this.Mt));
  }
  get length() {
    return this.Et.length;
  }
  retriableRequest(n) {
    var { retriesPerformedSoFar: r } = n, a = N9(n, PF);
    va(r) && (a.url = i0(a.url, { retry_count: r })), this._instance._send_request(pt({}, a, { callback: (o) => {
      o.statusCode !== 200 && (o.statusCode < 400 || o.statusCode >= 500) && (r ?? 0) < 10 ? this.At(pt({ retriesPerformedSoFar: r }, a)) : a.callback == null || a.callback(o);
    } }));
  }
  At(n) {
    var r = n.retriesPerformedSoFar || 0;
    n.retriesPerformedSoFar = r + 1;
    var a = function(d) {
      var c = 3e3 * Math.pow(2, d), f = c / 2, s = Math.min(18e5, c), h = (Math.random() - 0.5) * (s - f);
      return Math.ceil(s + h);
    }(r), o = Date.now() + a;
    this.Et.push({ retryAt: o, requestOptions: n });
    var l = "Enqueued failed request for retry in " + a;
    navigator.onLine || (l += " (Browser is offline)"), vt.warn(l), this.Rt || (this.Rt = !0, this.Dt());
  }
  Dt() {
    if (this.Lt && clearTimeout(this.Lt), this.Et.length === 0) return this.Rt = !1, void (this.Lt = void 0);
    this.Lt = setTimeout(() => {
      this.Ct && this.Et.length > 0 && this.Ot(), this.Dt();
    }, this.It);
  }
  Ot() {
    var n = Date.now(), r = [], a = this.Et.filter((l) => l.retryAt < n || (r.push(l), !1));
    if (this.Et = r, a.length > 0) for (var { requestOptions: o } of a) this.retriableRequest(o);
  }
  unload() {
    for (var { requestOptions: n } of (this.Lt && (clearTimeout(this.Lt), this.Lt = void 0), this.Rt = !1, wt(Xe) || (this.Ft && (Xe.removeEventListener("online", this.Ft), this.Ft = void 0), this.Mt && (Xe.removeEventListener("offline", this.Mt), this.Mt = void 0)), this.Et)) try {
      this._instance._send_request(pt({}, n, { transport: "sendBeacon" }));
    } catch (r) {
      vt.error(r);
    }
    this.Et = [];
  }
}
class RF {
  constructor(n) {
    this.jt = () => {
      var r, a, o, l;
      this.Nt || (this.Nt = {});
      var d = this.scrollElement(), c = this.scrollY(), f = d ? Math.max(0, d.scrollHeight - d.clientHeight) : 0, s = c + ((d == null ? void 0 : d.clientHeight) || 0), h = (d == null ? void 0 : d.scrollHeight) || 0;
      this.Nt.lastScrollY = Math.ceil(c), this.Nt.maxScrollY = Math.max(c, (r = this.Nt.maxScrollY) !== null && r !== void 0 ? r : 0), this.Nt.maxScrollHeight = Math.max(f, (a = this.Nt.maxScrollHeight) !== null && a !== void 0 ? a : 0), this.Nt.lastContentY = s, this.Nt.maxContentY = Math.max(s, (o = this.Nt.maxContentY) !== null && o !== void 0 ? o : 0), this.Nt.maxContentHeight = Math.max(h, (l = this.Nt.maxContentHeight) !== null && l !== void 0 ? l : 0);
    }, this._instance = n;
  }
  getContext() {
    return this.Nt;
  }
  resetContext() {
    var n = this.Nt;
    return setTimeout(this.jt, 0), n;
  }
  startMeasuringScrollPosition() {
    Qn(Xe, "scroll", this.jt, { capture: !0 }), Qn(Xe, "scrollend", this.jt, { capture: !0 }), Qn(Xe, "resize", this.jt);
  }
  scrollElement() {
    if (!this._instance.config.scroll_root_selector) return Xe == null ? void 0 : Xe.document.documentElement;
    var n = gn(this._instance.config.scroll_root_selector) ? this._instance.config.scroll_root_selector : [this._instance.config.scroll_root_selector];
    for (var r of n) {
      var a = Xe == null ? void 0 : Xe.document.querySelector(r);
      if (a) return a;
    }
  }
  scrollY() {
    if (this._instance.config.scroll_root_selector) {
      var n = this.scrollElement();
      return n && n.scrollTop || 0;
    }
    return Xe && (Xe.scrollY || Xe.pageYOffset || Xe.document.documentElement.scrollTop) || 0;
  }
  scrollX() {
    if (this._instance.config.scroll_root_selector) {
      var n = this.scrollElement();
      return n && n.scrollLeft || 0;
    }
    return Xe && (Xe.scrollX || Xe.pageXOffset || Xe.document.documentElement.scrollLeft) || 0;
  }
}
var MF = (e) => y3(e == null ? void 0 : e.config.mask_personal_data_properties, e == null ? void 0 : e.config.custom_personal_data_properties);
class Fg {
  constructor(n, r, a, o) {
    this.Ut = (l) => {
      var d = this.zt();
      if (!d || d.sessionId !== l) {
        var c = { sessionId: l, props: this.Ht(this._instance) };
        this.Bt.register({ [_h]: c });
      }
    }, this._instance = n, this.qt = r, this.Bt = a, this.Ht = o || MF, this.qt.onSessionId(this.Ut);
  }
  zt() {
    return this.Bt.props[_h];
  }
  getSetOnceProps() {
    var n, r = (n = this.zt()) == null ? void 0 : n.props;
    return r ? "r" in r ? v3(r) : { $referring_domain: r.referringDomain, $pathname: r.initialPathName, utm_source: r.utm_source, utm_campaign: r.utm_campaign, utm_medium: r.utm_medium, utm_content: r.utm_content, utm_term: r.utm_term } : {};
  }
  getSessionProps() {
    var n = {};
    return Tn(Kf(this.getSetOnceProps()), (r, a) => {
      a === "$current_url" && (a = "url"), n["$session_entry_" + dh(a)] = r;
    }), n;
  }
}
class Qf {
  constructor() {
    this.Vt = {}, this.Vt = {};
  }
  on(n, r) {
    return this.Vt[n] || (this.Vt[n] = []), this.Vt[n].push(r), () => {
      this.Vt[n] = this.Vt[n].filter((a) => a !== r);
    };
  }
  emit(n, r) {
    for (var a of this.Vt[n] || []) a(r);
    for (var o of this.Vt["*"] || []) o(n, r);
  }
}
var rd = Bn("[SessionId]");
class Pg {
  on(n, r) {
    return this.Wt.on(n, r);
  }
  constructor(n, r, a) {
    var o;
    if (this.Gt = [], this.Yt = void 0, this.Wt = new Qf(), this.Jt = (h, g) => !(!va(h) || !va(g)) && Math.abs(h - g) > this.sessionTimeoutMs, !n.persistence) throw new Error("SessionIdManager requires a PostHogPersistence instance");
    if (n.config.cookieless_mode === "always") throw new Error('SessionIdManager cannot be used with cookieless_mode="always"');
    this.N = n.config, this.Bt = n.persistence, this.Kt = void 0, this.Xt = void 0, this._sessionStartTimestamp = null, this._sessionActivityTimestamp = null, this.Qt = r || hs, this.Zt = a || hs;
    var l = this.N.persistence_name || this.N.token, d = this.N.session_idle_timeout_seconds || 1800;
    if (this._sessionTimeoutMs = 1e3 * kr(d, 60, 36e3, rd.createLogger("session_idle_timeout_seconds"), 1800), n.register({ $configured_session_timeout_ms: this._sessionTimeoutMs }), this.ti(), this.ii = "ph_" + l + "_window_id", this.ei = "ph_" + l + "_primary_window_exists", this.ri()) {
      var c = hi.D(this.ii), f = hi.D(this.ei);
      c && !f ? this.Kt = c : hi.j(this.ii), hi.L(this.ei, !0);
    }
    if ((o = this.N.bootstrap) != null && o.sessionID) try {
      var s = ((h) => {
        var g = h.replace(/-/g, "");
        if (g.length !== 32) throw new Error("Not a valid UUID");
        if (g[12] !== "7") throw new Error("Not a UUIDv7");
        return parseInt(g.substring(0, 12), 16);
      })(this.N.bootstrap.sessionID);
      this.si(this.N.bootstrap.sessionID, (/* @__PURE__ */ new Date()).getTime(), s);
    } catch (h) {
      rd.error("Invalid sessionID in bootstrap", h);
    }
    this.ni();
  }
  get sessionTimeoutMs() {
    return this._sessionTimeoutMs;
  }
  onSessionId(n) {
    return wt(this.Gt) && (this.Gt = []), this.Gt.push(n), this.Xt && n(this.Xt, this.Kt), () => {
      this.Gt = this.Gt.filter((r) => r !== n);
    };
  }
  ri() {
    return this.N.persistence !== "memory" && !this.Bt.st && hi.O();
  }
  oi(n) {
    n !== this.Kt && (this.Kt = n, this.ri() && hi.L(this.ii, n));
  }
  ai() {
    return this.Kt ? this.Kt : this.ri() ? hi.D(this.ii) : null;
  }
  si(n, r, a) {
    n === this.Xt && r === this._sessionActivityTimestamp && a === this._sessionStartTimestamp || (this._sessionStartTimestamp = a, this._sessionActivityTimestamp = r, this.Xt = n, this.Bt.register({ [Xl]: [r, n, a] }));
  }
  li() {
    var n = this.Bt.props[Xl];
    return gn(n) && n.length === 2 && n.push(n[0]), n || [0, null, 0];
  }
  resetSessionId() {
    this.si(null, null, null);
  }
  destroy() {
    clearTimeout(this.ui), this.ui = void 0, this.Yt && Xe && (Xe.removeEventListener("beforeunload", this.Yt, { capture: !1 }), this.Yt = void 0), this.Gt = [];
  }
  ni() {
    this.Yt = () => {
      this.ri() && hi.j(this.ei);
    }, Qn(Xe, "beforeunload", this.Yt, { capture: !1 });
  }
  checkAndGetSessionAndWindowId(n, r) {
    if (n === void 0 && (n = !1), r === void 0 && (r = null), this.N.cookieless_mode === "always") throw new Error('checkAndGetSessionAndWindowId should not be called with cookieless_mode="always"');
    var a = r || (/* @__PURE__ */ new Date()).getTime(), [o, l, d] = this.li(), c = this.ai(), f = va(d) && Math.abs(a - d) > 864e5, s = !1, h = !l, g = !h && !n && this.Jt(a, o);
    h || g || f ? (l = this.Qt(), c = this.Zt(), rd.info("new session ID generated", { sessionId: l, windowId: c, changeReason: { noSessionId: h, activityTimeout: g, sessionPastMaximumLength: f } }), d = a, s = !0) : c || (c = this.Zt(), s = !0);
    var t = va(o) && n && !f ? o : a, i = va(d) ? d : (/* @__PURE__ */ new Date()).getTime();
    return this.oi(c), this.si(l, t, i), n || this.ti(), s && this.Gt.forEach((m) => m(l, c, s ? { noSessionId: h, activityTimeout: g, sessionPastMaximumLength: f } : void 0)), { sessionId: l, windowId: c, sessionStartTimestamp: i, changeReason: s ? { noSessionId: h, activityTimeout: g, sessionPastMaximumLength: f } : void 0, lastActivityTimestamp: o };
  }
  ti() {
    clearTimeout(this.ui), this.ui = setTimeout(() => {
      var [n] = this.li();
      if (this.Jt((/* @__PURE__ */ new Date()).getTime(), n)) {
        var r = this.Xt;
        this.resetSessionId(), this.Wt.emit("forcedIdleReset", { idleSessionId: r });
      }
    }, 1.1 * this.sessionTimeoutMs);
  }
}
var I3 = function(e, n) {
  if (!e) return !1;
  var r = e.userAgent;
  if (r && sg(r, n)) return !0;
  try {
    var a = e == null ? void 0 : e.userAgentData;
    if (a != null && a.brands && a.brands.some((o) => sg(o == null ? void 0 : o.brand, n))) return !0;
  } catch {
  }
  return !!e.webdriver;
}, r0 = function(e, n) {
  if (!function(r) {
    try {
      new RegExp(r);
    } catch {
      return !1;
    }
    return !0;
  }(n)) return !1;
  try {
    return new RegExp(n).test(e);
  } catch {
    return !1;
  }
};
function jg(e, n, r) {
  return Mo({ distinct_id: e, userPropertiesToSet: n, userPropertiesToSetOnce: r });
}
var T3 = { exact: (e, n) => n.some((r) => e.some((a) => r === a)), is_not: (e, n) => n.every((r) => e.every((a) => r !== a)), regex: (e, n) => n.some((r) => e.some((a) => r0(r, a))), not_regex: (e, n) => n.every((r) => e.every((a) => !r0(r, a))), icontains: (e, n) => n.map(el).some((r) => e.map(el).some((a) => r.includes(a))), not_icontains: (e, n) => n.map(el).every((r) => e.map(el).every((a) => !r.includes(a))), gt: (e, n) => n.some((r) => {
  var a = parseFloat(r);
  return !isNaN(a) && e.some((o) => a > parseFloat(o));
}), lt: (e, n) => n.some((r) => {
  var a = parseFloat(r);
  return !isNaN(a) && e.some((o) => a < parseFloat(o));
}) }, el = (e) => e.toLowerCase();
function O3(e, n) {
  return !e || Object.entries(e).every((r) => {
    var [a, o] = r, l = n == null ? void 0 : n[a];
    if (wt(l) || br(l)) return !1;
    var d = [String(l)], c = T3[o.operator];
    return !!c && c(o.values, d);
  });
}
var Do = function(e) {
  return e.US = "us", e.EU = "eu", e.CUSTOM = "custom", e;
}({}), Rg = "i.posthog.com";
class DF {
  constructor(n) {
    this.hi = {}, this.instance = n;
  }
  get apiHost() {
    var n = this.instance.config.api_host.trim().replace(/\/$/, "");
    return n === "https://app.posthog.com" ? "https://us.i.posthog.com" : n;
  }
  get flagsApiHost() {
    var n = this.instance.config.flags_api_host;
    return n ? n.trim().replace(/\/$/, "") : this.apiHost;
  }
  get uiHost() {
    var n, r = (n = this.instance.config.ui_host) == null ? void 0 : n.replace(/\/$/, "");
    return r || (r = this.apiHost.replace("." + Rg, ".posthog.com")), r === "https://app.posthog.com" ? "https://us.posthog.com" : r;
  }
  get region() {
    return this.hi[this.apiHost] || (/https:\/\/(app|us|us-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this.hi[this.apiHost] = Do.US : /https:\/\/(eu|eu-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this.hi[this.apiHost] = Do.EU : this.hi[this.apiHost] = Do.CUSTOM), this.hi[this.apiHost];
  }
  endpointFor(n, r) {
    if (r === void 0 && (r = ""), r && (r = r[0] === "/" ? r : "/" + r), n === "ui") return this.uiHost + r;
    if (n === "flags") return this.flagsApiHost + r;
    if (this.region === Do.CUSTOM) return this.apiHost + r;
    var a = Rg + r;
    switch (n) {
      case "assets":
        return "https://" + this.region + "-assets." + a;
      case "api":
        return "https://" + this.region + "." + a;
    }
  }
}
var An = Bn("[Surveys]"), F3 = "seenSurvey_", NF = (e, n) => {
  var r = "$survey_" + n + "/" + e.id;
  return e.current_iteration && e.current_iteration > 0 && (r = "$survey_" + n + "/" + e.id + "/" + e.current_iteration), r;
}, Mg = (e) => ((n, r) => {
  var a = "" + n + r.id;
  return r.current_iteration && r.current_iteration > 0 && (a = "" + n + r.id + "_" + r.current_iteration), a;
})(F3, e), LF = [Ju.Popover, Ju.Widget, Ju.API], BF = { ignoreConditions: !1, ignoreDelay: !1, displayType: Eh.Popover }, $F = Bn("[PostHog ExternalIntegrations]"), UF = { intercom: "intercom-integration", crispChat: "crisp-chat-integration" };
class zF {
  constructor(n) {
    this._instance = n;
  }
  G(n, r) {
    var a;
    (a = qt.__PosthogExtensions__) == null || a.loadExternalDependency == null || a.loadExternalDependency(this._instance, n, (o) => {
      if (o) return $F.error("failed to load script", o);
      r();
    });
  }
  startIfEnabledOrStop() {
    var n = this, r = function(d) {
      var c, f, s;
      !o || (c = qt.__PosthogExtensions__) != null && (c = c.integrations) != null && c[d] || n.G(UF[d], () => {
        var h;
        (h = qt.__PosthogExtensions__) == null || (h = h.integrations) == null || (h = h[d]) == null || h.start(n._instance);
      }), !o && (f = qt.__PosthogExtensions__) != null && (f = f.integrations) != null && f[d] && ((s = qt.__PosthogExtensions__) == null || (s = s.integrations) == null || (s = s[d]) == null || s.stop());
    };
    for (var [a, o] of Object.entries((l = this._instance.config.integrations) !== null && l !== void 0 ? l : {})) {
      var l;
      r(a);
    }
  }
}
var HF = () => {
}, sd = () => ({}), Dg = { $anon_distinct_id: void 0, di: !1, featureFlagEventHandlers: [], hasLoadedFlags: !1, getFlags: () => [], getFlagsWithDetails: sd, getFlagVariants: sd, getFlagPayloads: sd, onFeatureFlags: () => () => {
}, vi: () => ({ flags: [], flagVariants: {} }) }, WF = typeof Proxy < "u" ? new Proxy(Dg, { get: (e, n) => (vt.error("[PostHog] Feature flags is not yet loaded or not included in this bundle"), n in e ? e[n] : HF) }) : Dg, zo = {}, ad = 0, Ph = () => {
}, wa = "posthog", P3 = !OF && (Fi == null ? void 0 : Fi.indexOf("MSIE")) === -1 && (Fi == null ? void 0 : Fi.indexOf("Mozilla")) === -1, Ng = (e) => {
  var n;
  return pt({ api_host: "https://us.i.posthog.com", flags_api_host: null, ui_host: null, token: "", autocapture: !0, cross_subdomain_cookie: eF(bt == null ? void 0 : bt.location), persistence: "localStorage+cookie", persistence_name: "", cookie_persisted_properties: [], loaded: Ph, save_campaign_params: !0, custom_campaign_params: [], custom_blocked_useragents: [], save_referrer: !0, capture_pageleave: "if_capture_pageview", defaults: e ?? "unset", __preview_deferred_init_extensions: !1, debug: pi && ti(pi == null ? void 0 : pi.search) && pi.search.indexOf("__posthog_debug=true") !== -1 || !1, cookie_expiration: 365, upgrade: !1, disable_session_recording: !1, disable_persistence: !1, disable_web_experiments: !0, disable_surveys: !1, disable_surveys_automatic_display: !1, disable_conversations: !1, disable_product_tours: !1, disable_external_dependency_loading: !1, enable_recording_console_log: void 0, secure_cookie: (Xe == null || (n = Xe.location) == null ? void 0 : n.protocol) === "https:", ip: !1, opt_out_capturing_by_default: !1, opt_out_persistence_by_default: !1, opt_out_useragent_filter: !1, opt_out_capturing_persistence_type: "localStorage", consent_persistence_name: null, opt_out_capturing_cookie_prefix: null, opt_in_site_apps: !1, property_denylist: [], respect_dnt: !1, sanitize_properties: null, request_headers: {}, request_batching: !0, properties_string_max_length: 65535, mask_all_element_attributes: !1, mask_all_text: !1, mask_personal_data_properties: !1, custom_personal_data_properties: [], advanced_disable_flags: !1, advanced_disable_decide: !1, advanced_disable_feature_flags: !1, advanced_disable_feature_flags_on_first_load: !1, advanced_only_evaluate_survey_feature_flags: !1, advanced_enable_surveys: !1, advanced_disable_toolbar_metrics: !1, feature_flag_request_timeout_ms: 3e3, surveys_request_timeout_ms: 1e4, on_request_error: (r) => {
    var a = "Bad HTTP status: " + r.statusCode + " " + r.text;
    vt.error(a);
  }, get_device_id: (r) => r, capture_performance: void 0, name: "posthog", bootstrap: {}, disable_compression: !1, session_idle_timeout_seconds: 1800, person_profiles: "identified_only", before_send: void 0, request_queue_config: { flush_interval_ms: Fh }, error_tracking: {}, _onCapture: Ph, __preview_eager_load_replay: !1 }, ((r) => ({ rageclick: !(r && r >= "2025-11-30") || { content_ignorelist: !0 }, capture_pageview: !(r && r >= "2025-05-24") || "history_change", session_recording: r && r >= "2025-11-30" ? { strictMinimumDuration: !0 } : {}, external_scripts_inject_target: r && r >= "2026-01-30" ? "head" : "body", internal_or_test_user_hostname: r && r >= "2026-01-30" ? /^(localhost|127\.0\.0\.1)$/ : void 0 }))(e));
}, Lg = (e) => {
  var n = {};
  wt(e.process_person) || (n.person_profiles = e.process_person), wt(e.xhr_headers) || (n.request_headers = e.xhr_headers), wt(e.cookie_name) || (n.persistence_name = e.cookie_name), wt(e.disable_cookie) || (n.disable_persistence = e.disable_cookie), wt(e.store_google) || (n.save_campaign_params = e.store_google), wt(e.verbose) || (n.debug = e.verbose);
  var r = Xn({}, n, e);
  return gn(e.property_blacklist) && (wt(e.property_denylist) ? r.property_denylist = e.property_blacklist : gn(e.property_denylist) ? r.property_denylist = [...e.property_blacklist, ...e.property_denylist] : vt.error("Invalid value for property_denylist config: " + e.property_denylist)), r;
};
class qF {
  constructor() {
    this.__forceAllowLocalhost = !1;
  }
  get ci() {
    return this.__forceAllowLocalhost;
  }
  set ci(n) {
    vt.error("WebPerformanceObserver is deprecated and has no impact on network capture. Use `_forceAllowLocalhostNetworkCapture` on `posthog.sessionRecording`"), this.__forceAllowLocalhost = n;
  }
}
class Ar {
  fi(n, r) {
    if (n) {
      var a = this.pi.indexOf(n);
      a !== -1 && this.pi.splice(a, 1);
    }
    return this.pi.push(r), r.initialize == null || r.initialize(), r;
  }
  get featureFlags() {
    var n;
    return (n = this.gi) !== null && n !== void 0 ? n : WF;
  }
  get decideEndpointWasHit() {
    var n, r;
    return (n = (r = this.gi) == null ? void 0 : r.hasLoadedFlags) !== null && n !== void 0 && n;
  }
  get flagsEndpointWasHit() {
    var n, r;
    return (n = (r = this.gi) == null ? void 0 : r.hasLoadedFlags) !== null && n !== void 0 && n;
  }
  constructor() {
    var n;
    this.webPerformance = new qF(), this.mi = !1, this.version = Lr.LIB_VERSION, this.bi = new Qf(), this.pi = [], this._calculate_event_properties = this.calculateEventProperties.bind(this), this.config = Ng(), this.SentryIntegration = fF, this.sentryIntegration = (a) => function(o, l) {
      var d = p3(o, l);
      return { name: f3, processEvent: (c) => d(c) };
    }(this, a), this.__request_queue = [], this.__loaded = !1, this.analyticsDefaultEndpoint = "/e/", this.yi = !1, this.wi = null, this.Ei = null, this.xi = null, this.scrollManager = new RF(this), this.pageViewManager = new _g(this), this.rateLimiter = new wF(this), this.requestRouter = new DF(this), this.consent = new lF(this), this.externalIntegrations = new zF(this);
    var r = (n = Ar.__defaultExtensionClasses) !== null && n !== void 0 ? n : {};
    this.gi = r.featureFlags && new r.featureFlags(this), this.toolbar = r.toolbar && new r.toolbar(this), this.surveys = r.surveys && new r.surveys(this), this.conversations = r.conversations && new r.conversations(this), this.logs = r.logs && new r.logs(this), this.experiments = r.experiments && new r.experiments(this), this.exceptions = r.exceptions && new r.exceptions(this), this.people = { set: (a, o, l) => {
      var d = ti(a) ? { [a]: o } : a;
      this.setPersonProperties(d), l == null || l({});
    }, set_once: (a, o, l) => {
      var d = ti(a) ? { [a]: o } : a;
      this.setPersonProperties(void 0, d), l == null || l({});
    } }, this.on("eventCaptured", (a) => vt.info('send "' + (a == null ? void 0 : a.event) + '"', a));
  }
  init(n, r, a) {
    if (a && a !== wa) {
      var o, l = (o = zo[a]) !== null && o !== void 0 ? o : new Ar();
      return l._init(n, r, a), zo[a] = l, zo[wa][a] = l, l;
    }
    return this._init(n, r, a);
  }
  _init(n, r, a) {
    var o;
    if (r === void 0 && (r = {}), wt(n) || hh(n)) return vt.critical("PostHog was initialized without a token. This likely indicates a misconfiguration. Please check the first argument passed to posthog.init()"), this;
    if (this.__loaded) return console.warn("[PostHog.js]", "You have already initialized PostHog! Re-initializing is a no-op"), this;
    this.__loaded = !0, this.config = {}, r.debug = this.Si(r.debug), this.$i = r, this.ki = [], r.person_profiles ? this.Ei = r.person_profiles : r.process_person && (this.Ei = r.process_person), this.set_config(Xn({}, Ng(r.defaults), Lg(r), { name: a, token: n })), this.config.on_xhr_error && vt.error("on_xhr_error is deprecated. Use on_request_error instead"), this.compression = r.disable_compression ? void 0 : zr.GZipJS;
    var l = this.Pi();
    this.persistence = new Qu(this.config, l), this.sessionPersistence = this.config.persistence === "sessionStorage" || this.config.persistence === "memory" ? this.persistence : new Qu(pt({}, this.config, { persistence: "sessionStorage" }), l);
    var d = pt({}, this.persistence.props), c = pt({}, this.sessionPersistence.props);
    this.register({ $initialization_time: (/* @__PURE__ */ new Date()).toISOString() }), this.Ti = new FF((m) => this.Ri(m), this.config.request_queue_config), this.Ii = new jF(this), this.__request_queue = [];
    var f = this.config.cookieless_mode === "always" || this.config.cookieless_mode === "on_reject" && this.consent.isExplicitlyOptedOut();
    if (f || (this.sessionManager = new Pg(this), this.sessionPropsManager = new Fg(this, this.sessionManager, this.persistence)), this.config.__preview_deferred_init_extensions ? (vt.info("Deferring extension initialization to improve startup performance"), setTimeout(() => {
      this.Ci(f);
    }, 0)) : (vt.info("Initializing extensions synchronously"), this.Ci(f)), Lr.DEBUG = Lr.DEBUG || this.config.debug, Lr.DEBUG && vt.info("Starting in debug mode", { this: this, config: r, thisC: pt({}, this.config), p: d, s: c }), ((o = r.bootstrap) == null ? void 0 : o.distinctID) !== void 0) {
      var s, h, g = this.config.get_device_id(hs()), t = (s = r.bootstrap) != null && s.isIdentifiedID ? g : r.bootstrap.distinctID;
      this.persistence.set_property(wr, (h = r.bootstrap) != null && h.isIdentifiedID ? "identified" : "anonymous"), this.register({ distinct_id: r.bootstrap.distinctID, $device_id: t });
    }
    if (f) this.register_once({ distinct_id: go, $device_id: null }, "");
    else if (!this.get_distinct_id()) {
      var i = this.config.get_device_id(hs());
      this.register_once({ distinct_id: i, $device_id: i }, ""), this.persistence.set_property(wr, "anonymous");
    }
    return Qn(Xe, "onpagehide" in self ? "pagehide" : "unload", this._handle_unload.bind(this), { passive: !1 }), r.segment ? hF(this, () => this.Fi()) : this.Fi(), Hr(this.config._onCapture) && this.config._onCapture !== Ph && (vt.warn("onCapture is deprecated. Please use `before_send` instead"), this.on("eventCaptured", (m) => this.config._onCapture(m.event, m))), this.config.ip && vt.warn('The `ip` config option has NO EFFECT AT ALL and has been deprecated. Use a custom transformation or "Discard IP data" project setting instead. See https://posthog.com/tutorials/web-redact-properties#hiding-customer-ip-address for more information.'), this;
  }
  Ci(n) {
    var r, a, o, l, d, c, f, s = performance.now(), h = pt({}, Ar.__defaultExtensionClasses, this.config.__extensionClasses), g = [];
    h.featureFlags && this.pi.push(this.gi = (r = this.gi) !== null && r !== void 0 ? r : new h.featureFlags(this)), h.exceptions && this.pi.push(this.exceptions = (a = this.exceptions) !== null && a !== void 0 ? a : new h.exceptions(this)), h.historyAutocapture && this.pi.push(this.historyAutocapture = new h.historyAutocapture(this)), h.tracingHeaders && this.pi.push(new h.tracingHeaders(this)), h.siteApps && this.pi.push(this.siteApps = new h.siteApps(this)), h.sessionRecording && !n && this.pi.push(this.sessionRecording = new h.sessionRecording(this)), this.config.disable_scroll_properties || g.push(() => {
      this.scrollManager.startMeasuringScrollPosition();
    }), h.autocapture && this.pi.push(this.autocapture = new h.autocapture(this)), h.surveys && this.pi.push(this.surveys = (o = this.surveys) !== null && o !== void 0 ? o : new h.surveys(this)), h.logs && this.pi.push(this.logs = (l = this.logs) !== null && l !== void 0 ? l : new h.logs(this)), h.conversations && this.pi.push(this.conversations = (d = this.conversations) !== null && d !== void 0 ? d : new h.conversations(this)), h.productTours && this.pi.push(this.productTours = new h.productTours(this)), h.heatmaps && this.pi.push(this.heatmaps = new h.heatmaps(this)), h.webVitalsAutocapture && this.pi.push(this.webVitalsAutocapture = new h.webVitalsAutocapture(this)), h.exceptionObserver && this.pi.push(this.exceptionObserver = new h.exceptionObserver(this)), h.deadClicksAutocapture && this.pi.push(this.deadClicksAutocapture = new h.deadClicksAutocapture(this, dF)), h.toolbar && this.pi.push(this.toolbar = (c = this.toolbar) !== null && c !== void 0 ? c : new h.toolbar(this)), h.experiments && this.pi.push(this.experiments = (f = this.experiments) !== null && f !== void 0 ? f : new h.experiments(this)), this.pi.forEach((t) => {
      t.initialize && g.push(() => {
        t.initialize == null || t.initialize();
      });
    }), g.push(() => {
      if (this.Oi) {
        var t = this.Oi;
        this.Oi = void 0, this.ft(t);
      }
    }), this.Mi(g, s);
  }
  Mi(n, r) {
    for (; n.length > 0; ) {
      if (this.config.__preview_deferred_init_extensions && performance.now() - r >= 30 && n.length > 0) return void setTimeout(() => {
        this.Mi(n, r);
      }, 0);
      var a = n.shift();
      if (a) try {
        a();
      } catch (l) {
        vt.error("Error initializing extension:", l);
      }
    }
    var o = Math.round(performance.now() - r);
    this.register_for_session({ $sdk_debug_extensions_init_method: this.config.__preview_deferred_init_extensions ? "deferred" : "synchronous", $sdk_debug_extensions_init_time_ms: o }), this.config.__preview_deferred_init_extensions && vt.info("PostHog extensions initialized (" + o + "ms)");
  }
  ft(n) {
    var r;
    if (!bt || !bt.body) return vt.info("document not ready yet, trying again in 500 milliseconds..."), void setTimeout(() => {
      this.ft(n);
    }, 500);
    this.config.__preview_deferred_init_extensions && (this.Oi = n), this.compression = void 0, n.supportedCompression && !this.config.disable_compression && (this.compression = cn(n.supportedCompression, zr.GZipJS) ? zr.GZipJS : cn(n.supportedCompression, zr.Base64) ? zr.Base64 : void 0), (r = n.analytics) != null && r.endpoint && (this.analyticsDefaultEndpoint = n.analytics.endpoint), this.set_config({ person_profiles: this.Ei ? this.Ei : "identified_only" }), this.pi.forEach((a) => a.onRemoteConfig == null ? void 0 : a.onRemoteConfig(n));
  }
  Fi() {
    try {
      this.config.loaded(this);
    } catch (a) {
      vt.critical("`loaded` function failed", a);
    }
    if (this.Ai(), this.config.internal_or_test_user_hostname && pi != null && pi.hostname) {
      var n = pi.hostname, r = this.config.internal_or_test_user_hostname;
      (typeof r == "string" ? n === r : r.test(n)) && this.setInternalOrTestUser();
    }
    this.config.capture_pageview && setTimeout(() => {
      (this.consent.isOptedIn() || this.config.cookieless_mode === "always") && this.Di();
    }, 1), this.Li = new S3(this), this.Li.load();
  }
  Ai() {
    var n;
    this.is_capturing() && this.config.request_batching && ((n = this.Ti) == null || n.enable());
  }
  _dom_loaded() {
    this.is_capturing() && fs(this.__request_queue, (n) => this.Ri(n)), this.__request_queue = [], this.Ai();
  }
  _handle_unload() {
    var n, r, a;
    (n = this.surveys) == null || n.handlePageUnload(), this.config.request_batching ? (this.ji() && this.capture("$pageleave"), (r = this.Ti) == null || r.unload(), (a = this.Ii) == null || a.unload()) : this.ji() && this.capture("$pageleave", null, { transport: "sendBeacon" });
  }
  _send_request(n) {
    this.__loaded && (P3 ? this.__request_queue.push(n) : this.rateLimiter.isServerRateLimited(n.batchKey) || (n.transport = n.transport || this.config.api_transport, n.url = i0(n.url, { ip: this.config.ip ? 1 : 0 }), n.headers = pt({}, this.config.request_headers, n.headers), n.compression = n.compression === "best-available" ? this.compression : n.compression, n.disableXHRCredentials = this.config.__preview_disable_xhr_credentials, this.config.__preview_disable_beacon && (n.disableTransport = ["sendBeacon"]), n.fetchOptions = n.fetchOptions || this.config.fetch_options, ((r) => {
      var a, o, l, d = pt({}, r);
      d.timeout = d.timeout || 6e4, d.url = i0(d.url, { _: (/* @__PURE__ */ new Date()).getTime().toString(), ver: Lr.LIB_VERSION, compression: d.compression });
      var c = (a = d.transport) !== null && a !== void 0 ? a : "fetch", f = _l.filter((h) => !d.disableTransport || !h.transport || !d.disableTransport.includes(h.transport)), s = (o = (l = a3(f, (h) => h.transport === c)) == null ? void 0 : l.method) !== null && o !== void 0 ? o : f[0].method;
      if (!s) throw new Error("No available transport method");
      s(d);
    })(pt({}, n, { callback: (r) => {
      var a, o;
      this.rateLimiter.checkForLimiting(r), r.statusCode >= 400 && ((a = (o = this.config).on_request_error) == null || a.call(o, r)), n.callback == null || n.callback(r);
    } }))));
  }
  Ri(n) {
    this.Ii ? this.Ii.retriableRequest(n) : this._send_request(n);
  }
  _execute_array(n) {
    ad++;
    try {
      var r, a = [], o = [], l = [];
      fs(n, (c) => {
        c && (r = c[0], gn(r) ? l.push(c) : Hr(c) ? c.call(this) : gn(c) && r === "alias" ? a.push(c) : gn(c) && r.indexOf("capture") !== -1 && Hr(this[r]) ? l.push(c) : o.push(c));
      });
      var d = function(c, f) {
        fs(c, function(s) {
          if (gn(s[0])) {
            var h = f;
            Tn(s, function(g) {
              h = h[g[0]].apply(h, g.slice(1));
            });
          } else this[s[0]].apply(this, s.slice(1));
        }, f);
      };
      d(a, this), d(o, this), d(l, this);
    } finally {
      ad--;
    }
  }
  push(n) {
    if (ad > 0 && gn(n) && ti(n[0])) {
      var r = Ar.prototype[n[0]];
      Hr(r) && r.apply(this, n.slice(1));
    } else this._execute_array([n]);
  }
  capture(n, r, a) {
    var o;
    if (this.__loaded && this.persistence && this.sessionPersistence && this.Ti) {
      if (this.is_capturing()) if (!wt(n) && ti(n)) {
        var l = !this.config.opt_out_useragent_filter && this._is_bot();
        if (!(l && !this.config.__preview_capture_bot_pageviews)) {
          var d = a != null && a.skip_client_rate_limiting ? void 0 : this.rateLimiter.clientRateLimitContext();
          if (d == null || !d.isRateLimited) {
            r != null && r.$current_url && !ti(r == null ? void 0 : r.$current_url) && (vt.error("Invalid `$current_url` property provided to `posthog.capture`. Input must be a string. Ignoring provided value."), r == null || delete r.$current_url), n !== "$exception" || a != null && a.Ni || vt.warn("Using `posthog.capture('$exception')` is unreliable because it does not attach required metadata. Use `posthog.captureException(error)` instead, which attaches required metadata automatically."), this.sessionPersistence.update_search_keyword(), this.config.save_campaign_params && this.sessionPersistence.update_campaign_params(), this.config.save_referrer && this.sessionPersistence.update_referrer_info(), (this.config.save_campaign_params || this.config.save_referrer) && this.persistence.set_initial_person_info();
            var c = /* @__PURE__ */ new Date(), f = (a == null ? void 0 : a.timestamp) || c, s = hs(), h = { uuid: s, event: n, properties: this.calculateEventProperties(n, r || {}, f, s) };
            n === "$pageview" && this.config.__preview_capture_bot_pageviews && l && (h.event = "$bot_pageview", h.properties.$browser_type = "bot"), d && (h.properties.$lib_rate_limit_remaining_tokens = d.remainingTokens), a != null && a.$set && (h.$set = a == null ? void 0 : a.$set);
            var g, t = n !== "$groupidentify", i = this.Ui(a == null ? void 0 : a.$set_once, t);
            if (i && (h.$set_once = i), (h = QO(h, a != null && a._noTruncate ? null : this.config.properties_string_max_length)).timestamp = f, wt(a == null ? void 0 : a.timestamp) || (h.properties.$event_time_override_provided = !0, h.properties.$event_time_override_system_time = c), n === Ro.DISMISSED || n === Ro.SENT) {
              var m = r == null ? void 0 : r[ed.SURVEY_ID], v = r == null ? void 0 : r[ed.SURVEY_ITERATION];
              g = { id: m, current_iteration: v }, localStorage.getItem(Mg(g)) || localStorage.setItem(Mg(g), "true"), h.$set = pt({}, h.$set, { [NF({ id: m, current_iteration: v }, n === Ro.SENT ? "responded" : "dismissed")]: !0 });
            } else n === Ro.SHOWN && (h.$set = pt({}, h.$set, { [ed.SURVEY_LAST_SEEN_DATE]: (/* @__PURE__ */ new Date()).toISOString() }));
            if (n === vF.SHOWN) {
              var E = r == null ? void 0 : r[Ag.TOUR_TYPE];
              E && (h.$set = pt({}, h.$set, { [Ag.TOUR_LAST_SEEN_DATE + "/" + E]: (/* @__PURE__ */ new Date()).toISOString() }));
            }
            var S = pt({}, h.properties.$set, h.$set);
            if (Ca(S) || this.setPersonPropertiesForFlags(S), !un(this.config.before_send)) {
              var y = this.zi(h);
              if (!y) return;
              h = y;
            }
            this.bi.emit("eventCaptured", h);
            var x = { method: "POST", url: (o = a == null ? void 0 : a._url) !== null && o !== void 0 ? o : this.requestRouter.endpointFor("api", this.analyticsDefaultEndpoint), data: h, compression: "best-available", batchKey: a == null ? void 0 : a._batchKey };
            return !this.config.request_batching || a && (a == null || !a._batchKey) || a != null && a.send_instantly ? this.Ri(x) : this.Ti.enqueue(x), h;
          }
          vt.critical("This capture call is ignored due to client rate limiting.");
        }
      } else vt.error("No event name provided to posthog.capture");
    } else vt.uninitializedWarning("posthog.capture");
  }
  _addCaptureHook(n) {
    return this.on("eventCaptured", (r) => n(r.event, r));
  }
  calculateEventProperties(n, r, a, o, l) {
    if (a = a || /* @__PURE__ */ new Date(), !this.persistence || !this.sessionPersistence) return r;
    var d = l ? void 0 : this.persistence.remove_event_timer(n), c = pt({}, r);
    if (c.token = this.config.token, c.$config_defaults = this.config.defaults, (this.config.cookieless_mode == "always" || this.config.cookieless_mode == "on_reject" && this.consent.isExplicitlyOptedOut()) && (c.$cookieless_mode = !0), n === "$snapshot") {
      var f = pt({}, this.persistence.properties(), this.sessionPersistence.properties());
      return c.distinct_id = f.distinct_id, (!ti(c.distinct_id) && !Pr(c.distinct_id) || hh(c.distinct_id)) && vt.error("Invalid distinct_id for replay event. This indicates a bug in your implementation"), c;
    }
    var s, h = bF(this.config.mask_personal_data_properties, this.config.custom_personal_data_properties);
    if (this.sessionManager) {
      var { sessionId: g, windowId: t } = this.sessionManager.checkAndGetSessionAndWindowId(l, a.getTime());
      c.$session_id = g, c.$window_id = t;
    }
    this.sessionPropsManager && Xn(c, this.sessionPropsManager.getSessionProps());
    try {
      var i;
      this.sessionRecording && Xn(c, this.sessionRecording.sdkDebugProperties), c.$sdk_debug_retry_queue_size = (i = this.Ii) == null ? void 0 : i.length;
    } catch (S) {
      c.$sdk_debug_error_capturing_properties = String(S);
    }
    if (this.requestRouter.region === Do.CUSTOM && (c.$lib_custom_api_host = this.config.api_host), s = n !== "$pageview" || l ? n !== "$pageleave" || l ? this.pageViewManager.doEvent() : this.pageViewManager.doPageLeave(a) : this.pageViewManager.doPageView(a, o), c = Xn(c, s), n === "$pageview" && bt && (c.title = bt.title), !wt(d)) {
      var m = a.getTime() - d;
      c.$duration = parseFloat((m / 1e3).toFixed(3));
    }
    Fi && this.config.opt_out_useragent_filter && (c.$browser_type = this._is_bot() ? "bot" : "browser"), (c = Xn({}, h, this.persistence.properties(), this.sessionPersistence.properties(), c)).$is_identified = this._isIdentified(), gn(this.config.property_denylist) ? Tn(this.config.property_denylist, function(S) {
      delete c[S];
    }) : vt.error("Invalid value for property_denylist config: " + this.config.property_denylist + " or property_blacklist config: " + this.config.property_blacklist);
    var v = this.config.sanitize_properties;
    v && (vt.error("sanitize_properties is deprecated. Use before_send instead"), c = v(c, n));
    var E = this.Hi();
    return c.$process_person_profile = E, E && !l && this.Bi("_calculate_event_properties"), c;
  }
  Ui(n, r) {
    var a;
    if (r === void 0 && (r = !0), !this.persistence || !this.Hi() || this.mi) return n;
    var o = this.persistence.get_initial_props(), l = (a = this.sessionPropsManager) == null ? void 0 : a.getSetOnceProps(), d = Xn({}, o, l || {}, n || {}), c = this.config.sanitize_properties;
    return c && (vt.error("sanitize_properties is deprecated. Use before_send instead"), d = c(d, "$set_once")), r && (this.mi = !0), Ca(d) ? void 0 : d;
  }
  register(n, r) {
    var a;
    (a = this.persistence) == null || a.register(n, r);
  }
  register_once(n, r, a) {
    var o;
    (o = this.persistence) == null || o.register_once(n, r, a);
  }
  register_for_session(n) {
    var r;
    (r = this.sessionPersistence) == null || r.register(n);
  }
  unregister(n) {
    var r;
    (r = this.persistence) == null || r.unregister(n);
  }
  unregister_for_session(n) {
    var r;
    (r = this.sessionPersistence) == null || r.unregister(n);
  }
  qi(n, r) {
    this.register({ [n]: r });
  }
  getFeatureFlag(n, r) {
    var a;
    return (a = this.gi) == null ? void 0 : a.getFeatureFlag(n, r);
  }
  getFeatureFlagPayload(n) {
    var r;
    return (r = this.gi) == null ? void 0 : r.getFeatureFlagPayload(n);
  }
  getFeatureFlagResult(n, r) {
    var a;
    return (a = this.gi) == null ? void 0 : a.getFeatureFlagResult(n, r);
  }
  isFeatureEnabled(n, r) {
    var a;
    return (a = this.gi) == null ? void 0 : a.isFeatureEnabled(n, r);
  }
  reloadFeatureFlags() {
    var n;
    (n = this.gi) == null || n.reloadFeatureFlags();
  }
  updateFlags(n, r, a) {
    var o;
    (o = this.gi) == null || o.updateFlags(n, r, a);
  }
  updateEarlyAccessFeatureEnrollment(n, r, a) {
    var o;
    (o = this.gi) == null || o.updateEarlyAccessFeatureEnrollment(n, r, a);
  }
  getEarlyAccessFeatures(n, r, a) {
    var o;
    return r === void 0 && (r = !1), (o = this.gi) == null ? void 0 : o.getEarlyAccessFeatures(n, r, a);
  }
  on(n, r) {
    return this.bi.on(n, r);
  }
  onFeatureFlags(n) {
    return this.gi ? this.gi.onFeatureFlags(n) : (n([], {}, { errorsLoading: !0 }), () => {
    });
  }
  onSurveysLoaded(n) {
    return this.surveys ? this.surveys.onSurveysLoaded(n) : (n([], { isLoaded: !1, error: "Surveys module not available" }), () => {
    });
  }
  onSessionId(n) {
    var r, a;
    return (r = (a = this.sessionManager) == null ? void 0 : a.onSessionId(n)) !== null && r !== void 0 ? r : () => {
    };
  }
  getSurveys(n, r) {
    r === void 0 && (r = !1), this.surveys ? this.surveys.getSurveys(n, r) : n([], { isLoaded: !1, error: "Surveys module not available" });
  }
  getActiveMatchingSurveys(n, r) {
    r === void 0 && (r = !1), this.surveys ? this.surveys.getActiveMatchingSurveys(n, r) : n([], { isLoaded: !1, error: "Surveys module not available" });
  }
  renderSurvey(n, r) {
    var a;
    (a = this.surveys) == null || a.renderSurvey(n, r);
  }
  displaySurvey(n, r) {
    var a;
    r === void 0 && (r = BF), (a = this.surveys) == null || a.displaySurvey(n, r);
  }
  cancelPendingSurvey(n) {
    var r;
    (r = this.surveys) == null || r.cancelPendingSurvey(n);
  }
  canRenderSurvey(n) {
    var r, a;
    return (r = (a = this.surveys) == null ? void 0 : a.canRenderSurvey(n)) !== null && r !== void 0 ? r : { visible: !1, disabledReason: "Surveys module not available" };
  }
  canRenderSurveyAsync(n, r) {
    var a, o;
    return r === void 0 && (r = !1), (a = (o = this.surveys) == null ? void 0 : o.canRenderSurveyAsync(n, r)) !== null && a !== void 0 ? a : Promise.resolve({ visible: !1, disabledReason: "Surveys module not available" });
  }
  identify(n, r, a) {
    if (!this.__loaded || !this.persistence) return vt.uninitializedWarning("posthog.identify");
    if (Pr(n) && (n = n.toString(), vt.warn("The first argument to posthog.identify was a number, but it should be a string. It has been converted to a string.")), n) if (["distinct_id", "distinctid"].includes(n.toLowerCase())) vt.critical('The string "' + n + '" was set in posthog.identify which indicates an error. This ID should be unique to the user and not a hardcoded string.');
    else if (n !== go) {
      if (this.Bi("posthog.identify")) {
        var o = this.get_distinct_id();
        if (this.register({ $user_id: n }), !this.get_property("$device_id")) {
          var l = o;
          this.register_once({ $had_persisted_distinct_id: !0, $device_id: l }, "");
        }
        n !== o && n !== this.get_property(Oo) && (this.unregister(Oo), this.register({ distinct_id: n }));
        var d, c = (this.persistence.get_property(wr) || "anonymous") === "anonymous";
        n !== o && c ? (this.persistence.set_property(wr, "identified"), this.setPersonPropertiesForFlags(pt({}, a || {}, r || {}), !1), this.capture("$identify", { distinct_id: n, $anon_distinct_id: o }, { $set: r || {}, $set_once: a || {} }), this.xi = jg(n, r, a), (d = this.gi) == null || d.setAnonymousDistinctId(o)) : (r || a) && this.setPersonProperties(r, a), n !== o && (this.reloadFeatureFlags(), this.unregister(Gl));
      }
    } else vt.critical('The string "' + go + '" was set in posthog.identify which indicates an error. This ID is only used as a sentinel value.');
    else vt.error("Unique user id has not been set in posthog.identify");
  }
  setPersonProperties(n, r) {
    if ((n || r) && this.Bi("posthog.setPersonProperties")) {
      var a = jg(this.get_distinct_id(), n, r);
      this.xi !== a ? (this.setPersonPropertiesForFlags(pt({}, r || {}, n || {})), this.capture("$set", { $set: n || {}, $set_once: r || {} }), this.xi = a) : vt.info("A duplicate setPersonProperties call was made with the same properties. It has been ignored.");
    }
  }
  group(n, r, a) {
    if (n && r) {
      var o = this.getGroups();
      o[n] !== r && this.resetGroupPropertiesForFlags(n), this.register({ $groups: pt({}, o, { [n]: r }) }), a && (this.capture("$groupidentify", { $group_type: n, $group_key: r, $group_set: a }), this.setGroupPropertiesForFlags({ [n]: a })), o[n] === r || a || this.reloadFeatureFlags();
    } else vt.error("posthog.group requires a group type and group key");
  }
  resetGroups() {
    this.register({ $groups: {} }), this.resetGroupPropertiesForFlags(), this.reloadFeatureFlags();
  }
  setPersonPropertiesForFlags(n, r) {
    var a;
    r === void 0 && (r = !0), (a = this.gi) == null || a.setPersonPropertiesForFlags(n, r);
  }
  resetPersonPropertiesForFlags() {
    var n;
    (n = this.gi) == null || n.resetPersonPropertiesForFlags();
  }
  setGroupPropertiesForFlags(n, r) {
    var a;
    r === void 0 && (r = !0), this.Bi("posthog.setGroupPropertiesForFlags") && ((a = this.gi) == null || a.setGroupPropertiesForFlags(n, r));
  }
  resetGroupPropertiesForFlags(n) {
    var r;
    (r = this.gi) == null || r.resetGroupPropertiesForFlags(n);
  }
  reset(n) {
    var r, a, o, l, d, c, f;
    if (vt.info("reset"), !this.__loaded) return vt.uninitializedWarning("posthog.reset");
    var s = this.get_property("$device_id");
    if (this.consent.reset(), (r = this.persistence) == null || r.clear(), (a = this.sessionPersistence) == null || a.clear(), (o = this.surveys) == null || o.reset(), (l = this.Li) == null || l.stop(), (d = this.gi) == null || d.reset(), (c = this.persistence) == null || c.set_property(wr, "anonymous"), (f = this.sessionManager) == null || f.resetSessionId(), this.xi = null, this.config.cookieless_mode === "always") this.register_once({ distinct_id: go, $device_id: null }, "");
    else {
      var h = this.config.get_device_id(hs());
      this.register_once({ distinct_id: h, $device_id: n ? h : s }, "");
    }
    this.register({ $last_posthog_reset: (/* @__PURE__ */ new Date()).toISOString() }, 1);
  }
  get_distinct_id() {
    return this.get_property("distinct_id");
  }
  getGroups() {
    return this.get_property("$groups") || {};
  }
  get_session_id() {
    var n, r;
    return (n = (r = this.sessionManager) == null ? void 0 : r.checkAndGetSessionAndWindowId(!0).sessionId) !== null && n !== void 0 ? n : "";
  }
  get_session_replay_url(n) {
    if (!this.sessionManager) return "";
    var { sessionId: r, sessionStartTimestamp: a } = this.sessionManager.checkAndGetSessionAndWindowId(!0), o = this.requestRouter.endpointFor("ui", "/project/" + this.config.token + "/replay/" + r);
    if (n != null && n.withTimestamp && a) {
      var l, d = (l = n.timestampLookBack) !== null && l !== void 0 ? l : 10;
      if (!a) return o;
      o += "?t=" + Math.max(Math.floor(((/* @__PURE__ */ new Date()).getTime() - a) / 1e3) - d, 0);
    }
    return o;
  }
  alias(n, r) {
    return n === this.get_property(c3) ? (vt.critical("Attempting to create alias for existing People user - aborting."), -2) : this.Bi("posthog.alias") ? (wt(r) && (r = this.get_distinct_id()), n !== r ? (this.qi(Oo, n), this.capture("$create_alias", { alias: n, distinct_id: r })) : (vt.warn("alias matches current distinct_id - skipping api call."), this.identify(n), -1)) : void 0;
  }
  set_config(n) {
    var r = pt({}, this.config);
    if (ii(n)) {
      var a, o, l, d, c, f, s, h, g;
      Xn(this.config, Lg(n));
      var t = this.Pi();
      (a = this.persistence) == null || a.update_config(this.config, r, t), this.sessionPersistence = this.config.persistence === "sessionStorage" || this.config.persistence === "memory" ? this.persistence : new Qu(pt({}, this.config, { persistence: "sessionStorage" }), t);
      var i = this.Si(this.config.debug);
      qr(i) && (this.config.debug = i), qr(this.config.debug) && (this.config.debug ? (Lr.DEBUG = !0, Dn.O() && Dn.L("ph_debug", "true"), vt.info("set_config", { config: n, oldConfig: r, newConfig: pt({}, this.config) })) : (Lr.DEBUG = !1, Dn.O() && Dn.j("ph_debug"))), (o = this.exceptionObserver) == null || o.onConfigChange(), (l = this.sessionRecording) == null || l.startIfEnabledOrStop(), (d = this.autocapture) == null || d.startIfEnabled(), (c = this.heatmaps) == null || c.startIfEnabled(), (f = this.exceptionObserver) == null || f.startIfEnabledOrStop(), (s = this.deadClicksAutocapture) == null || s.startIfEnabledOrStop(), (h = this.surveys) == null || h.loadIfEnabled(), this.Vi(), (g = this.externalIntegrations) == null || g.startIfEnabledOrStop();
    }
  }
  startSessionRecording(n) {
    var r = n === !0, a = { sampling: r || !(n == null || !n.sampling), linked_flag: r || !(n == null || !n.linked_flag), url_trigger: r || !(n == null || !n.url_trigger), event_trigger: r || !(n == null || !n.event_trigger) };
    if (Object.values(a).some(Boolean)) {
      var o, l, d, c, f;
      (o = this.sessionManager) == null || o.checkAndGetSessionAndWindowId(), a.sampling && ((l = this.sessionRecording) == null || l.overrideSampling()), a.linked_flag && ((d = this.sessionRecording) == null || d.overrideLinkedFlag()), a.url_trigger && ((c = this.sessionRecording) == null || c.overrideTrigger("url")), a.event_trigger && ((f = this.sessionRecording) == null || f.overrideTrigger("event"));
    }
    this.set_config({ disable_session_recording: !1 });
  }
  stopSessionRecording() {
    this.set_config({ disable_session_recording: !0 });
  }
  sessionRecordingStarted() {
    var n;
    return !((n = this.sessionRecording) == null || !n.started);
  }
  captureException(n, r) {
    if (this.exceptions) {
      var a = new Error("PostHog syntheticException"), o = this.exceptions.buildProperties(n, { handled: !0, syntheticException: a });
      return this.exceptions.sendExceptionEvent(pt({}, o, r));
    }
  }
  startExceptionAutocapture(n) {
    this.set_config({ capture_exceptions: n == null || n });
  }
  stopExceptionAutocapture() {
    this.set_config({ capture_exceptions: !1 });
  }
  loadToolbar(n) {
    var r, a;
    return (r = (a = this.toolbar) == null ? void 0 : a.loadToolbar(n)) !== null && r !== void 0 && r;
  }
  get_property(n) {
    var r;
    return (r = this.persistence) == null ? void 0 : r.props[n];
  }
  getSessionProperty(n) {
    var r;
    return (r = this.sessionPersistence) == null ? void 0 : r.props[n];
  }
  toString() {
    var n, r = (n = this.config.name) !== null && n !== void 0 ? n : wa;
    return r !== wa && (r = wa + "." + r), r;
  }
  _isIdentified() {
    var n, r;
    return ((n = this.persistence) == null ? void 0 : n.get_property(wr)) === "identified" || ((r = this.sessionPersistence) == null ? void 0 : r.get_property(wr)) === "identified";
  }
  Hi() {
    var n, r;
    return !(this.config.person_profiles === "never" || this.config.person_profiles === "identified_only" && !this._isIdentified() && Ca(this.getGroups()) && ((n = this.persistence) == null || (n = n.props) == null || !n[Oo]) && ((r = this.persistence) == null || (r = r.props) == null || !r[Zl]));
  }
  ji() {
    return this.config.capture_pageleave === !0 || this.config.capture_pageleave === "if_capture_pageview" && (this.config.capture_pageview === !0 || this.config.capture_pageview === "history_change");
  }
  createPersonProfile() {
    this.Hi() || this.Bi("posthog.createPersonProfile") && this.setPersonProperties({}, {});
  }
  setInternalOrTestUser() {
    this.Bi("posthog.setInternalOrTestUser") && this.setPersonProperties({ $internal_or_test_user: !0 });
  }
  Bi(n) {
    return this.config.person_profiles === "never" ? (vt.error(n + ' was called, but process_person is set to "never". This call will be ignored.'), !1) : (this.qi(Zl, !0), !0);
  }
  Pi() {
    if (this.config.cookieless_mode === "always") return !0;
    var n = this.consent.isOptedOut(), r = this.config.opt_out_persistence_by_default || this.config.cookieless_mode === "on_reject";
    return this.config.disable_persistence || n && !!r;
  }
  Vi() {
    var n, r, a, o, l = this.Pi();
    return ((n = this.persistence) == null ? void 0 : n.st) !== l && ((a = this.persistence) == null || a.set_disabled(l)), ((r = this.sessionPersistence) == null ? void 0 : r.st) !== l && ((o = this.sessionPersistence) == null || o.set_disabled(l)), l;
  }
  opt_in_capturing(n) {
    var r;
    if (this.config.cookieless_mode !== "always") {
      if (this.config.cookieless_mode === "on_reject" && this.consent.isExplicitlyOptedOut()) {
        var a, o, l, d, c;
        this.reset(!0), (a = this.sessionManager) == null || a.destroy(), (o = this.pageViewManager) == null || o.destroy(), this.sessionManager = new Pg(this), this.pageViewManager = new _g(this), this.persistence && (this.sessionPropsManager = new Fg(this, this.sessionManager, this.persistence));
        var f = (l = (d = this.config.__extensionClasses) == null ? void 0 : d.sessionRecording) !== null && l !== void 0 ? l : (c = Ar.__defaultExtensionClasses) == null ? void 0 : c.sessionRecording;
        f && (this.sessionRecording = this.fi(this.sessionRecording, new f(this)));
      }
      var s, h;
      this.consent.optInOut(!0), this.Vi(), this.Ai(), (r = this.sessionRecording) == null || r.startIfEnabledOrStop(), this.config.cookieless_mode == "on_reject" && ((s = this.surveys) == null || s.loadIfEnabled()), (wt(n == null ? void 0 : n.captureEventName) || n != null && n.captureEventName) && this.capture((h = n == null ? void 0 : n.captureEventName) !== null && h !== void 0 ? h : "$opt_in", n == null ? void 0 : n.captureProperties, { send_instantly: !0 }), this.config.capture_pageview && this.Di();
    } else vt.warn('Consent opt in/out is not valid with cookieless_mode="always" and will be ignored');
  }
  opt_out_capturing() {
    var n, r, a;
    this.config.cookieless_mode !== "always" ? (this.config.cookieless_mode === "on_reject" && this.consent.isOptedIn() && this.reset(!0), this.consent.optInOut(!1), this.Vi(), this.config.cookieless_mode === "on_reject" && (this.register({ distinct_id: go, $device_id: null }), (n = this.sessionManager) == null || n.destroy(), (r = this.pageViewManager) == null || r.destroy(), this.sessionManager = void 0, this.sessionPropsManager = void 0, (a = this.sessionRecording) == null || a.stopRecording(), this.sessionRecording = void 0, this.Di())) : vt.warn('Consent opt in/out is not valid with cookieless_mode="always" and will be ignored');
  }
  has_opted_in_capturing() {
    return this.consent.isOptedIn();
  }
  has_opted_out_capturing() {
    return this.consent.isOptedOut();
  }
  get_explicit_consent_status() {
    var n = this.consent.consent;
    return n === $r.GRANTED ? "granted" : n === $r.DENIED ? "denied" : "pending";
  }
  is_capturing() {
    return this.config.cookieless_mode === "always" || (this.config.cookieless_mode === "on_reject" ? this.consent.isExplicitlyOptedOut() || this.consent.isOptedIn() : !this.has_opted_out_capturing());
  }
  clear_opt_in_out_capturing() {
    this.consent.reset(), this.Vi();
  }
  _is_bot() {
    return qi ? I3(qi, this.config.custom_blocked_useragents) : void 0;
  }
  Di() {
    bt && (bt.visibilityState === "visible" ? this.yi || (this.yi = !0, this.capture("$pageview", { title: bt.title }, { send_instantly: !0 }), this.wi && (bt.removeEventListener("visibilitychange", this.wi), this.wi = null)) : this.wi || (this.wi = this.Di.bind(this), Qn(bt, "visibilitychange", this.wi)));
  }
  debug(n) {
    n === !1 ? (Xe == null || Xe.console.log("You've disabled debug mode."), this.set_config({ debug: !1 })) : (Xe == null || Xe.console.log("You're now in debug mode. All calls to PostHog will be logged in your console.\nYou can disable this with `posthog.debug(false)`."), this.set_config({ debug: !0 }));
  }
  bt() {
    var n, r, a, o, l, d, c, f = this.$i || {};
    return "advanced_disable_flags" in f ? !!f.advanced_disable_flags : this.config.advanced_disable_flags !== !1 ? !!this.config.advanced_disable_flags : this.config.advanced_disable_decide === !0 ? (vt.warn("Config field 'advanced_disable_decide' is deprecated. Please use 'advanced_disable_flags' instead. The old field will be removed in a future major version."), !0) : (a = "advanced_disable_decide", o = !1, l = vt, d = (r = "advanced_disable_flags") in (n = f) && !un(n[r]), c = a in n && !un(n[a]), d ? n[r] : c ? (l && l.warn("Config field '" + a + "' is deprecated. Please use '" + r + "' instead. The old field will be removed in a future major version."), n[a]) : o);
  }
  zi(n) {
    if (un(this.config.before_send)) return n;
    var r = gn(this.config.before_send) ? this.config.before_send : [this.config.before_send], a = n;
    for (var o of r) {
      if (a = o(a), un(a)) {
        var l = "Event '" + n.event + "' was rejected in beforeSend function";
        return gO(n.event) ? vt.warn(l + ". This can cause unexpected behavior.") : vt.info(l), null;
      }
      a.properties && !Ca(a.properties) || vt.warn("Event '" + n.event + "' has no properties after beforeSend function, this is likely an error.");
    }
    return a;
  }
  getPageViewId() {
    var n;
    return (n = this.pageViewManager.K) == null ? void 0 : n.pageViewId;
  }
  captureTraceFeedback(n, r) {
    this.capture("$ai_feedback", { $ai_trace_id: String(n), $ai_feedback_text: r });
  }
  captureTraceMetric(n, r, a) {
    this.capture("$ai_metric", { $ai_trace_id: String(n), $ai_metric_name: r, $ai_metric_value: String(a) });
  }
  Si(n) {
    var r = qr(n) && !n, a = Dn.O() && Dn.A("ph_debug") === "true";
    return !r && (!!a || n);
  }
}
Ar.__defaultExtensionClasses = {}, function(e, n) {
  for (var r = 0; r < n.length; r++) e.prototype[n[r]] = ZO(e.prototype[n[r]]);
}(Ar, ["identify"]);
function Bg(e) {
  return e instanceof Element && (e.id === d3 || !(e.closest == null || !e.closest(".toolbar-global-fade-container")));
}
function V0(e) {
  return !!e && e.nodeType === 1;
}
function ps(e, n) {
  return !!e && !!e.tagName && e.tagName.toLowerCase() === n.toLowerCase();
}
function j3(e) {
  return !!e && e.nodeType === 3;
}
function R3(e) {
  return !!e && e.nodeType === 11;
}
function Jf(e) {
  return e ? W0(e).split(/\s+/) : [];
}
function $g(e) {
  var n = Xe == null ? void 0 : Xe.location.href;
  return !!(n && e && e.some((r) => n.match(r)));
}
function s0(e) {
  var n = "";
  switch (typeof e.className) {
    case "string":
      n = e.className;
      break;
    case "object":
      n = (e.className && "baseVal" in e.className ? e.className.baseVal : null) || e.getAttribute("class") || "";
      break;
    default:
      n = "";
  }
  return Jf(n);
}
function M3(e) {
  return un(e) ? null : W0(e).split(/(\s+)/).filter((n) => oc(n)).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255);
}
function Ec(e) {
  var n = "";
  return jh(e) && !B3(e) && e.childNodes && e.childNodes.length && Tn(e.childNodes, function(r) {
    var a;
    j3(r) && r.textContent && (n += (a = M3(r.textContent)) !== null && a !== void 0 ? a : "");
  }), W0(n);
}
function Ug(e) {
  return wt(e.target) ? e.srcElement || null : (n = e.target) != null && n.shadowRoot ? e.composedPath()[0] || null : e.target || null;
  var n;
}
var e1 = ["a", "button", "form", "input", "select", "textarea", "label"];
function D3(e, n) {
  if (wt(n)) return !0;
  var r, a = function(l) {
    if (n.some((d) => l.matches(d))) return { v: !0 };
  };
  for (var o of e) if (r = a(o)) return r.v;
  return !1;
}
function N3(e) {
  var n = e.parentNode;
  return !(!n || !V0(n)) && n;
}
var VF = ["next", "previous", "prev", ">", "<"], zg = 10, Hg = [".ph-no-rageclick", ".ph-no-capture"];
function XF(e, n) {
  if (!Xe || t1(e)) return !1;
  var r, a, o;
  if (qr(n) ? (r = !!n && Hg, a = void 0) : (r = (o = n == null ? void 0 : n.css_selector_ignorelist) !== null && o !== void 0 ? o : Hg, a = n == null ? void 0 : n.content_ignorelist), r === !1) return !1;
  var { targetElementList: l } = L3(e, !1);
  return !function(d, c) {
    if (d === !1 || wt(d)) return !1;
    var f;
    if (d === !0) f = VF;
    else {
      if (!gn(d)) return !1;
      if (d.length > zg) return vt.error("[PostHog] content_ignorelist array cannot exceed " + zg + " items. Use css_selector_ignorelist for more complex matching."), !1;
      f = d.map((s) => s.toLowerCase());
    }
    return c.some((s) => {
      var { safeText: h, ariaLabel: g } = s;
      return f.some((t) => h.includes(t) || g.includes(t));
    });
  }(a, l.map((d) => {
    var c;
    return { safeText: Ec(d).toLowerCase(), ariaLabel: ((c = d.getAttribute("aria-label")) == null ? void 0 : c.toLowerCase().trim()) || "" };
  })) && !D3(l, r);
}
var t1 = (e) => !e || ps(e, "html") || !V0(e), L3 = (e, n) => {
  if (!Xe || t1(e)) return { parentIsUsefulElement: !1, targetElementList: [] };
  for (var r = !1, a = [e], o = e; o.parentNode && !ps(o, "body"); ) if (R3(o.parentNode)) a.push(o.parentNode.host), o = o.parentNode.host;
  else {
    var l = N3(o);
    if (!l) break;
    if (n || e1.indexOf(l.tagName.toLowerCase()) > -1) r = !0;
    else {
      var d = Xe.getComputedStyle(l);
      d && d.getPropertyValue("cursor") === "pointer" && (r = !0);
    }
    a.push(l), o = l;
  }
  return { parentIsUsefulElement: r, targetElementList: a };
};
function GF(e, n, r, a, o) {
  var l, d, c, f;
  if (r === void 0 && (r = void 0), !Xe || t1(e) || (l = r) != null && l.url_allowlist && !$g(r.url_allowlist) || (d = r) != null && d.url_ignorelist && $g(r.url_ignorelist)) return !1;
  if ((c = r) != null && c.dom_event_allowlist) {
    var s = r.dom_event_allowlist;
    if (s && !s.some((m) => n.type === m)) return !1;
  }
  var { parentIsUsefulElement: h, targetElementList: g } = L3(e, a);
  if (!function(m, v) {
    var E = v == null ? void 0 : v.element_allowlist;
    if (wt(E)) return !0;
    var S, y = function(b) {
      if (E.some((u) => b.tagName.toLowerCase() === u)) return { v: !0 };
    };
    for (var x of m) if (S = y(x)) return S.v;
    return !1;
  }(g, r) || !D3(g, (f = r) == null ? void 0 : f.css_selector_allowlist)) return !1;
  var t = Xe.getComputedStyle(e);
  if (t && t.getPropertyValue("cursor") === "pointer" && n.type === "click") return !0;
  var i = e.tagName.toLowerCase();
  switch (i) {
    case "html":
      return !1;
    case "form":
      return (o || ["submit"]).indexOf(n.type) >= 0;
    case "input":
    case "select":
    case "textarea":
      return (o || ["change", "click"]).indexOf(n.type) >= 0;
    default:
      return h ? (o || ["click"]).indexOf(n.type) >= 0 : (o || ["click"]).indexOf(n.type) >= 0 && (e1.indexOf(i) > -1 || e.getAttribute("contenteditable") === "true");
  }
}
function jh(e) {
  for (var n = e; n.parentNode && !ps(n, "body"); n = n.parentNode) {
    var r = s0(n);
    if (cn(r, "ph-sensitive") || cn(r, "ph-no-capture")) return !1;
  }
  if (cn(s0(e), "ph-include")) return !0;
  var a = e.type || "";
  if (ti(a)) switch (a.toLowerCase()) {
    case "hidden":
    case "password":
      return !1;
  }
  var o = e.name || e.id || "";
  return !(ti(o) && /^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i.test(o.replace(/[^a-zA-Z0-9]/g, "")));
}
function B3(e) {
  return !!(ps(e, "input") && !["button", "checkbox", "submit", "reset"].includes(e.type) || ps(e, "select") || ps(e, "textarea") || e.getAttribute("contenteditable") === "true");
}
var $3 = "(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11})", KF = new RegExp("^(?:" + $3 + ")$"), YF = new RegExp($3), U3 = "\\d{3}-?\\d{2}-?\\d{4}", ZF = new RegExp("^(" + U3 + ")$"), QF = new RegExp("(" + U3 + ")");
function oc(e, n) {
  return n === void 0 && (n = !0), !(un(e) || ti(e) && (e = W0(e), (n ? KF : YF).test((e || "").replace(/[- ]/g, "")) || (n ? ZF : QF).test(e)));
}
function z3(e) {
  var n = Ec(e);
  return oc(n = (n + " " + H3(e)).trim()) ? n : "";
}
function H3(e) {
  var n = "";
  return e && e.childNodes && e.childNodes.length && Tn(e.childNodes, function(r) {
    var a;
    if (r && ((a = r.tagName) == null ? void 0 : a.toLowerCase()) === "span") try {
      var o = Ec(r);
      n = (n + " " + o).trim(), r.childNodes && r.childNodes.length && (n = (n + " " + H3(r)).trim());
    } catch (l) {
      vt.error("[AutoCapture]", l);
    }
  }), n;
}
function JF(e) {
  return function(n) {
    var r = n.map((a) => {
      var o, l, d = "";
      if (a.tag_name && (d += a.tag_name), a.attr_class) for (var c of (a.attr_class.sort(), a.attr_class)) d += "." + c.replace(/"/g, "");
      var f = pt({}, a.text ? { text: a.text } : {}, { "nth-child": (o = a.nth_child) !== null && o !== void 0 ? o : 0, "nth-of-type": (l = a.nth_of_type) !== null && l !== void 0 ? l : 0 }, a.href ? { href: a.href } : {}, a.attr_id ? { attr_id: a.attr_id } : {}, a.attributes), s = {};
      return Sl(f).sort((h, g) => {
        var [t] = h, [i] = g;
        return t.localeCompare(i);
      }).forEach((h) => {
        var [g, t] = h;
        return s[Wg(g.toString())] = Wg(t.toString());
      }), d += ":", d += Sl(s).map((h) => {
        var [g, t] = h;
        return g + '="' + t + '"';
      }).join("");
    });
    return r.join(";");
  }(function(n) {
    return n.map((r) => {
      var a, o, l = { text: (a = r.$el_text) == null ? void 0 : a.slice(0, 400), tag_name: r.tag_name, href: (o = r.attr__href) == null ? void 0 : o.slice(0, 2048), attr_class: eP(r), attr_id: r.attr__id, nth_child: r.nth_child, nth_of_type: r.nth_of_type, attributes: {} };
      return Sl(r).filter((d) => {
        var [c] = d;
        return c.indexOf("attr__") === 0;
      }).forEach((d) => {
        var [c, f] = d;
        return l.attributes[c] = f;
      }), l;
    });
  }(e));
}
function Wg(e) {
  return e.replace(/"|\\"/g, '\\"');
}
function eP(e) {
  var n = e.attr__class;
  return n ? gn(n) ? n : Jf(n) : void 0;
}
class qg {
  constructor(n) {
    this.disabled = n === !1;
    var r = ii(n) ? n : {};
    this.thresholdPx = r.threshold_px || 30, this.timeoutMs = r.timeout_ms || 1e3, this.clickCount = r.click_count || 3, this.clicks = [];
  }
  isRageClick(n, r, a) {
    if (this.disabled) return !1;
    var o = this.clicks[this.clicks.length - 1];
    if (o && Math.abs(n - o.x) + Math.abs(r - o.y) < this.thresholdPx && a - o.timestamp < this.timeoutMs) {
      if (this.clicks.push({ x: n, y: r, timestamp: a }), this.clicks.length === this.clickCount) return !0;
    } else this.clicks = [{ x: n, y: r, timestamp: a }];
    return !1;
  }
}
var od = "$copy_autocapture", Vg = Bn("[AutoCapture]");
function cd(e, n) {
  return n.length > e ? n.slice(0, e) + "..." : n;
}
function tP(e) {
  if (e.previousElementSibling) return e.previousElementSibling;
  var n = e;
  do
    n = n.previousSibling;
  while (n && !V0(n));
  return n;
}
function nP(e, n, r, a) {
  var o = e.tagName.toLowerCase(), l = { tag_name: o };
  e1.indexOf(o) > -1 && !r && (o.toLowerCase() === "a" || o.toLowerCase() === "button" ? l.$el_text = cd(1024, z3(e)) : l.$el_text = cd(1024, Ec(e)));
  var d = s0(e);
  d.length > 0 && (l.classes = d.filter(function(h) {
    return h !== "";
  })), Tn(e.attributes, function(h) {
    var g;
    if ((!B3(e) || ["name", "id", "class", "aria-label"].indexOf(h.name) !== -1) && (a == null || !a.includes(h.name)) && !n && oc(h.value) && (g = h.name, !ti(g) || g.substring(0, 10) !== "_ngcontent" && g.substring(0, 7) !== "_nghost")) {
      var t = h.value;
      h.name === "class" && (t = Jf(t).join(" ")), l["attr__" + h.name] = cd(1024, t);
    }
  });
  for (var c = 1, f = 1, s = e; s = tP(s); ) c++, s.tagName === e.tagName && f++;
  return l.nth_child = c, l.nth_of_type = f, l;
}
function iP(e, n) {
  for (var r, a, { e: o, maskAllElementAttributes: l, maskAllText: d, elementAttributeIgnoreList: c, elementsChainAsString: f } = n, s = [e], h = e; h.parentNode && !ps(h, "body"); ) R3(h.parentNode) ? (s.push(h.parentNode.host), h = h.parentNode.host) : (s.push(h.parentNode), h = h.parentNode);
  var g, t = [], i = {}, m = !1, v = !1;
  if (Tn(s, (b) => {
    var u = jh(b);
    b.tagName.toLowerCase() === "a" && (m = b.getAttribute("href"), m = u && m && oc(m) && m), cn(s0(b), "ph-no-capture") && (v = !0), t.push(nP(b, l, d, c));
    var I = function(O) {
      if (!jh(O)) return {};
      var D = {};
      return Tn(O.attributes, function($) {
        if ($.name && $.name.indexOf("data-ph-capture-attribute") === 0) {
          var K = $.name.replace("data-ph-capture-attribute-", ""), H = $.value;
          K && H && oc(H) && (D[K] = H);
        }
      }), D;
    }(b);
    Xn(i, I);
  }), v) return { props: {}, explicitNoCapture: v };
  if (d || (e.tagName.toLowerCase() === "a" || e.tagName.toLowerCase() === "button" ? t[0].$el_text = z3(e) : t[0].$el_text = Ec(e)), m) {
    var E, S;
    t[0].attr__href = m;
    var y = (E = Jl(m)) == null ? void 0 : E.host, x = Xe == null || (S = Xe.location) == null ? void 0 : S.host;
    y && x && y !== x && (g = m);
  }
  return { props: Xn({ $event_type: o.type, $ce_version: 1 }, f ? {} : { $elements: t }, { $elements_chain: JF(t) }, (r = t[0]) != null && r.$el_text ? { $el_text: (a = t[0]) == null ? void 0 : a.$el_text } : {}, g && o.type === "click" ? { $external_click_url: g } : {}, i) };
}
var wo = Bn("[ExceptionAutocapture]");
function Xg(e, n, r) {
  try {
    if (!(n in e)) return () => {
    };
    var a = e[n], o = r(a);
    return Hr(o) && (o.prototype = o.prototype || {}, Object.defineProperties(o, { __posthog_wrapped__: { enumerable: !1, value: !0 } })), e[n] = o, () => {
      e[n] = a;
    };
  } catch {
    return () => {
    };
  }
}
var rP = Bn("[TracingHeaders]"), rs = Bn("[Web Vitals]"), Gg = 9e5, Kg = "disabled", Yg = "lazy_loading", So = "awaiting_config", tl = "missing_config";
Bn("[SessionRecording]");
var Rh = "[SessionRecording]", Ts = Bn(Rh), sP = Bn("[Heatmaps]");
function Zg(e) {
  return ii(e) && "clientX" in e && "clientY" in e && Pr(e.clientX) && Pr(e.clientY);
}
var Qg = Bn("[Product Tours]"), ld = "ph_product_tours", aP = ["$set_once", "$set"], ss = Bn("[SiteApps]");
function ha(e, n, r) {
  if (un(e)) return !1;
  switch (r) {
    case "exact":
      return e === n;
    case "contains":
      var a = n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&").replace(/_/g, ".").replace(/%/g, ".*");
      return new RegExp(a, "i").test(e);
    case "regex":
      try {
        return new RegExp(n).test(e);
      } catch {
        return !1;
      }
    default:
      return !1;
  }
}
class oP {
  constructor(n) {
    this.Wi = new Qf(), this.Gi = (r, a) => this.Yi(r, a) && this.Ji(r, a) && this.Ki(r, a) && this.Xi(r, a), this.Yi = (r, a) => a == null || !a.event || (r == null ? void 0 : r.event) === (a == null ? void 0 : a.event), this._instance = n, this.Qi = /* @__PURE__ */ new Set(), this.Zi = /* @__PURE__ */ new Set();
  }
  init() {
    var n;
    if (!wt((n = this._instance) == null ? void 0 : n._addCaptureHook)) {
      var r;
      (r = this._instance) == null || r._addCaptureHook((a, o) => {
        this.on(a, o);
      });
    }
  }
  register(n) {
    var r, a;
    if (!wt((r = this._instance) == null ? void 0 : r._addCaptureHook) && (n.forEach((d) => {
      var c, f;
      (c = this.Zi) == null || c.add(d), (f = d.steps) == null || f.forEach((s) => {
        var h;
        (h = this.Qi) == null || h.add((s == null ? void 0 : s.event) || "");
      });
    }), (a = this._instance) != null && a.autocapture)) {
      var o, l = /* @__PURE__ */ new Set();
      n.forEach((d) => {
        var c;
        (c = d.steps) == null || c.forEach((f) => {
          f != null && f.selector && l.add(f == null ? void 0 : f.selector);
        });
      }), (o = this._instance) == null || o.autocapture.setElementSelectors(l);
    }
  }
  on(n, r) {
    var a;
    r != null && n.length != 0 && (this.Qi.has(n) || this.Qi.has(r == null ? void 0 : r.event)) && this.Zi && ((a = this.Zi) == null ? void 0 : a.size) > 0 && this.Zi.forEach((o) => {
      this.te(r, o) && this.Wi.emit("actionCaptured", o.name);
    });
  }
  ie(n) {
    this.onAction("actionCaptured", (r) => n(r));
  }
  te(n, r) {
    if ((r == null ? void 0 : r.steps) == null) return !1;
    for (var a of r.steps) if (this.Gi(n, a)) return !0;
    return !1;
  }
  onAction(n, r) {
    return this.Wi.on(n, r);
  }
  Ji(n, r) {
    if (r != null && r.url) {
      var a, o = n == null || (a = n.properties) == null ? void 0 : a.$current_url;
      if (!o || typeof o != "string" || !ha(o, r.url, r.url_matching || "contains")) return !1;
    }
    return !0;
  }
  Ki(n, r) {
    return !!this.ee(n, r) && !!this.re(n, r) && !!this.se(n, r);
  }
  ee(n, r) {
    var a;
    if (r == null || !r.href) return !0;
    var o = this.ne(n);
    if (o.length > 0) return o.some((c) => ha(c.href, r.href, r.href_matching || "exact"));
    var l, d = (n == null || (a = n.properties) == null ? void 0 : a.$elements_chain) || "";
    return !!d && ha((l = d.match(/(?::|")href="(.*?)"/)) ? l[1] : "", r.href, r.href_matching || "exact");
  }
  re(n, r) {
    var a;
    if (r == null || !r.text) return !0;
    var o = this.ne(n);
    if (o.length > 0) return o.some((s) => ha(s.text, r.text, r.text_matching || "exact") || ha(s.$el_text, r.text, r.text_matching || "exact"));
    var l, d, c, f = (n == null || (a = n.properties) == null ? void 0 : a.$elements_chain) || "";
    return !!f && (l = function(s) {
      for (var h, g = [], t = /(?::|")text="(.*?)"/g; !un(h = t.exec(s)); ) g.includes(h[1]) || g.push(h[1]);
      return g;
    }(f), d = r.text, c = r.text_matching || "exact", l.some((s) => ha(s, d, c)));
  }
  se(n, r) {
    var a, o;
    if (r == null || !r.selector) return !0;
    var l = n == null || (a = n.properties) == null ? void 0 : a.$element_selectors;
    if (l != null && l.includes(r.selector)) return !0;
    var d = (n == null || (o = n.properties) == null ? void 0 : o.$elements_chain) || "";
    if (r.selector_regex && d) try {
      return new RegExp(r.selector_regex).test(d);
    } catch {
      return !1;
    }
    return !1;
  }
  ne(n) {
    var r;
    return (n == null || (r = n.properties) == null ? void 0 : r.$elements) == null ? [] : n == null ? void 0 : n.properties.$elements;
  }
  Xi(n, r) {
    return r == null || !r.properties || r.properties.length === 0 || O3(r.properties.reduce((a, o) => {
      var l = gn(o.value) ? o.value.map(String) : o.value != null ? [String(o.value)] : [];
      return a[o.key] = { values: l, operator: o.operator || "exact" }, a;
    }, {}), n == null ? void 0 : n.properties);
  }
}
class cP {
  constructor(n) {
    this._instance = n, this.oe = /* @__PURE__ */ new Map(), this.ae = /* @__PURE__ */ new Map(), this.le = /* @__PURE__ */ new Map();
  }
  ue(n, r) {
    return !!n && O3(n.propertyFilters, r == null ? void 0 : r.properties);
  }
  he(n, r) {
    var a = /* @__PURE__ */ new Map();
    return n.forEach((o) => {
      var l;
      (l = o.conditions) == null || (l = l[r]) == null || (l = l.values) == null || l.forEach((d) => {
        if (d != null && d.name) {
          var c = a.get(d.name) || [];
          c.push(o.id), a.set(d.name, c);
        }
      });
    }), a;
  }
  de(n, r, a) {
    var o = (a === xo.Activation ? this.oe : this.ae).get(n), l = [];
    return this.ve((d) => {
      l = d.filter((c) => o == null ? void 0 : o.includes(c.id));
    }), l.filter((d) => {
      var c, f = (c = d.conditions) == null || (c = c[a]) == null || (c = c.values) == null ? void 0 : c.find((s) => s.name === n);
      return this.ue(f, r);
    });
  }
  register(n) {
    var r;
    wt((r = this._instance) == null ? void 0 : r._addCaptureHook) || (this.ce(n), this.fe(n));
  }
  fe(n) {
    var r = n.filter((a) => {
      var o, l;
      return ((o = a.conditions) == null ? void 0 : o.actions) && ((l = a.conditions) == null || (l = l.actions) == null || (l = l.values) == null ? void 0 : l.length) > 0;
    });
    r.length !== 0 && (this.pe == null && (this.pe = new oP(this._instance), this.pe.init(), this.pe.ie((a) => {
      this.onAction(a);
    })), r.forEach((a) => {
      var o, l, d, c, f;
      a.conditions && (o = a.conditions) != null && o.actions && (l = a.conditions) != null && (l = l.actions) != null && l.values && ((d = a.conditions) == null || (d = d.actions) == null || (d = d.values) == null ? void 0 : d.length) > 0 && ((c = this.pe) == null || c.register(a.conditions.actions.values), (f = a.conditions) == null || (f = f.actions) == null || (f = f.values) == null || f.forEach((s) => {
        if (s && s.name) {
          var h = this.le.get(s.name);
          h && h.push(a.id), this.le.set(s.name, h || [a.id]);
        }
      }));
    }));
  }
  ce(n) {
    var r, a = n.filter((l) => {
      var d, c;
      return ((d = l.conditions) == null ? void 0 : d.events) && ((c = l.conditions) == null || (c = c.events) == null || (c = c.values) == null ? void 0 : c.length) > 0;
    }), o = n.filter((l) => {
      var d, c;
      return ((d = l.conditions) == null ? void 0 : d.cancelEvents) && ((c = l.conditions) == null || (c = c.cancelEvents) == null || (c = c.values) == null ? void 0 : c.length) > 0;
    });
    (a.length !== 0 || o.length !== 0) && ((r = this._instance) == null || r._addCaptureHook((l, d) => {
      this.onEvent(l, d);
    }), this.oe = this.he(n, xo.Activation), this.ae = this.he(n, xo.Cancellation));
  }
  onEvent(n, r) {
    var a, o = this._e(), l = this.ge(), d = this.me(), c = ((a = this._instance) == null || (a = a.persistence) == null ? void 0 : a.props[l]) || [];
    if (d === n && r && c.length > 0) {
      var f, s;
      o.info("event matched, removing item from activated items", { event: n, eventPayload: r, existingActivatedItems: c });
      var h = (r == null || (f = r.properties) == null ? void 0 : f.$survey_id) || (r == null || (s = r.properties) == null ? void 0 : s.$product_tour_id);
      if (h) {
        var g = c.indexOf(h);
        g >= 0 && (c.splice(g, 1), this.be(c));
      }
    } else {
      if (this.ae.has(n)) {
        var t = this.de(n, r, xo.Cancellation);
        t.length > 0 && (o.info("cancel event matched, cancelling items", { event: n, itemsToCancel: t.map((m) => m.id) }), t.forEach((m) => {
          var v = c.indexOf(m.id);
          v >= 0 && c.splice(v, 1), this.ye(m.id);
        }), this.be(c));
      }
      if (this.oe.has(n)) {
        o.info("event name matched", { event: n, eventPayload: r, items: this.oe.get(n) });
        var i = this.de(n, r, xo.Activation);
        this.be(c.concat(i.map((m) => m.id) || []));
      }
    }
  }
  onAction(n) {
    var r, a = this.ge(), o = ((r = this._instance) == null || (r = r.persistence) == null ? void 0 : r.props[a]) || [];
    this.le.has(n) && this.be(o.concat(this.le.get(n) || []));
  }
  be(n) {
    var r, a = this._e(), o = this.ge(), l = [...new Set(n)].filter((d) => !this.we(d));
    a.info("updating activated items", { activatedItems: l }), (r = this._instance) == null || (r = r.persistence) == null || r.register({ [o]: l });
  }
  getActivatedIds() {
    var n, r = this.ge(), a = (n = this._instance) == null || (n = n.persistence) == null ? void 0 : n.props[r];
    return a || [];
  }
  getEventToItemsMap() {
    return this.oe;
  }
  Ee() {
    return this.pe;
  }
}
class lP extends cP {
  constructor(n) {
    super(n);
  }
  ge() {
    return "$surveys_activated";
  }
  me() {
    return Ro.SHOWN;
  }
  ve(n) {
    var r;
    (r = this._instance) == null || r.getSurveys(n);
  }
  ye(n) {
    var r;
    (r = this._instance) == null || r.cancelPendingSurvey(n);
  }
  _e() {
    return An;
  }
  we() {
    return !1;
  }
  getSurveys() {
    return this.getActivatedIds();
  }
  getEventToSurveys() {
    return this.getEventToItemsMap();
  }
}
var uP = Xe != null && Xe.location ? t0(Xe.location.hash, "__posthog") || t0(location.hash, "state") : null, Jg = "_postHogToolbarParams", em = Bn("[Toolbar]"), os = function(e) {
  return e[e.UNINITIALIZED = 0] = "UNINITIALIZED", e[e.LOADING = 1] = "LOADING", e[e.LOADED = 2] = "LOADED", e;
}(os || {}), Oi = Bn("[FeatureFlags]"), _o = Bn("[FeatureFlags]", { debugEnabled: !0 }), dP = "errors_while_computing_flags", hP = "flag_missing", fP = "quota_limited", pP = "timeout", gP = "connection_error", mP = "unknown_error", xP = (e) => "api_error_" + e, ud = "$active_feature_flags", fa = "$override_feature_flags", tm = "$feature_flag_payloads", Co = "$override_feature_flag_payloads", nm = "$feature_flag_request_id", im = (e) => {
  var n = {};
  for (var [r, a] of Sl(e || {})) a && (n[r] = a);
  return n;
}, bP = (e) => {
  var n = e.flags;
  return n ? (e.featureFlags = Object.fromEntries(Object.keys(n).map((r) => {
    var a;
    return [r, (a = n[r].variant) !== null && a !== void 0 ? a : n[r].enabled];
  })), e.featureFlagPayloads = Object.fromEntries(Object.keys(n).filter((r) => n[r].enabled).filter((r) => {
    var a;
    return (a = n[r].metadata) == null ? void 0 : a.payload;
  }).map((r) => {
    var a;
    return [r, (a = n[r].metadata) == null ? void 0 : a.payload];
  }))) : Oi.warn("Using an older version of the feature flags endpoint. Please upgrade your PostHog server to the latest version"), e;
}, yP = function(e) {
  return e.FeatureFlags = "feature_flags", e.Recordings = "recordings", e;
}({}), dd = Bn("[Error tracking]"), vP = { icontains: (e, n) => !!Xe && n.href.toLowerCase().indexOf(e.toLowerCase()) > -1, not_icontains: (e, n) => !!Xe && n.href.toLowerCase().indexOf(e.toLowerCase()) === -1, regex: (e, n) => !!Xe && r0(n.href, e), not_regex: (e, n) => !!Xe && !r0(n.href, e), exact: (e, n) => n.href === e, is_not: (e, n) => n.href !== e };
class yi {
  constructor(n) {
    var r = this;
    this.getWebExperimentsAndEvaluateDisplayLogic = function(a) {
      a === void 0 && (a = !1), r.getWebExperiments((o) => {
        yi.xe("retrieved web experiments from the server"), r.Se = /* @__PURE__ */ new Map(), o.forEach((l) => {
          if (l.feature_flag_key) {
            var d;
            r.Se && (yi.xe("setting flag key ", l.feature_flag_key, " to web experiment ", l), (d = r.Se) == null || d.set(l.feature_flag_key, l));
            var c = r._instance.getFeatureFlag(l.feature_flag_key);
            ti(c) && l.variants[c] && r.$e(l.name, c, l.variants[c].transforms);
          } else if (l.variants) for (var f in l.variants) {
            var s = l.variants[f];
            yi.ke(s) && r.$e(l.name, f, s.transforms);
          }
        });
      }, a);
    }, this._instance = n, this._instance.onFeatureFlags((a) => {
      this.onFeatureFlags(a);
    });
  }
  initialize() {
  }
  onFeatureFlags(n) {
    if (this._is_bot()) yi.xe("Refusing to render web experiment since the viewer is a likely bot");
    else if (!this._instance.config.disable_web_experiments) {
      if (un(this.Se)) return this.Se = /* @__PURE__ */ new Map(), this.loadIfEnabled(), void this.previewWebExperiment();
      yi.xe("applying feature flags", n), n.forEach((r) => {
        var a;
        if (this.Se && (a = this.Se) != null && a.has(r)) {
          var o, l = this._instance.getFeatureFlag(r), d = (o = this.Se) == null ? void 0 : o.get(r);
          l && d != null && d.variants[l] && this.$e(d.name, l, d.variants[l].transforms);
        }
      });
    }
  }
  previewWebExperiment() {
    var n = yi.getWindowLocation();
    if (n != null && n.search) {
      var r = e0(n == null ? void 0 : n.search, "__experiment_id"), a = e0(n == null ? void 0 : n.search, "__experiment_variant");
      r && a && (yi.xe("previewing web experiments " + r + " && " + a), this.getWebExperiments((o) => {
        this.Pe(parseInt(r), a, o);
      }, !1, !0));
    }
  }
  loadIfEnabled() {
    this._instance.config.disable_web_experiments || this.getWebExperimentsAndEvaluateDisplayLogic();
  }
  getWebExperiments(n, r, a) {
    if (this._instance.config.disable_web_experiments && !a) return n([]);
    var o = this._instance.get_property("$web_experiments");
    if (o && !r) return n(o);
    this._instance._send_request({ url: this._instance.requestRouter.endpointFor("api", "/api/web_experiments/?token=" + this._instance.config.token), method: "GET", callback: (l) => {
      if (l.statusCode !== 200 || !l.json) return n([]);
      var d = l.json.experiments || [];
      return n(d);
    } });
  }
  Pe(n, r, a) {
    var o = a.filter((l) => l.id === n);
    o && o.length > 0 && (yi.xe("Previewing web experiment [" + o[0].name + "] with variant [" + r + "]"), this.$e(o[0].name, r, o[0].variants[r].transforms));
  }
  static ke(n) {
    return !un(n.conditions) && yi.Te(n) && yi.Re(n);
  }
  static Te(n) {
    var r;
    if (un(n.conditions) || un((r = n.conditions) == null ? void 0 : r.url)) return !0;
    var a, o, l, d = yi.getWindowLocation();
    return !!d && ((a = n.conditions) == null || !a.url || vP[(o = (l = n.conditions) == null ? void 0 : l.urlMatchType) !== null && o !== void 0 ? o : "icontains"](n.conditions.url, d));
  }
  static getWindowLocation() {
    return Xe == null ? void 0 : Xe.location;
  }
  static Re(n) {
    var r;
    if (un(n.conditions) || un((r = n.conditions) == null ? void 0 : r.utm)) return !0;
    var a = g3();
    if (a.utm_source) {
      var o, l, d, c, f, s, h, g, t = (o = n.conditions) == null || (o = o.utm) == null || !o.utm_campaign || ((l = n.conditions) == null || (l = l.utm) == null ? void 0 : l.utm_campaign) == a.utm_campaign, i = (d = n.conditions) == null || (d = d.utm) == null || !d.utm_source || ((c = n.conditions) == null || (c = c.utm) == null ? void 0 : c.utm_source) == a.utm_source, m = (f = n.conditions) == null || (f = f.utm) == null || !f.utm_medium || ((s = n.conditions) == null || (s = s.utm) == null ? void 0 : s.utm_medium) == a.utm_medium, v = (h = n.conditions) == null || (h = h.utm) == null || !h.utm_term || ((g = n.conditions) == null || (g = g.utm) == null ? void 0 : g.utm_term) == a.utm_term;
      return t && m && v && i;
    }
    return !1;
  }
  static xe(n) {
    for (var r = arguments.length, a = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++) a[o - 1] = arguments[o];
    vt.info("[WebExperiments] " + n, a);
  }
  $e(n, r, a) {
    this._is_bot() ? yi.xe("Refusing to render web experiment since the viewer is a likely bot") : r !== "control" ? a.forEach((o) => {
      if (o.selector) {
        var l;
        yi.xe("applying transform of variant " + r + " for experiment " + n + " ", o);
        var d = (l = document) == null ? void 0 : l.querySelectorAll(o.selector);
        d == null || d.forEach((c) => {
          var f = c;
          o.html && (f.innerHTML = o.html), o.css && f.setAttribute("style", o.css);
        });
      }
    }) : yi.xe("Control variants leave the page unmodified.");
  }
  _is_bot() {
    return qi && this._instance ? I3(qi, this._instance.config.custom_blocked_useragents) : void 0;
  }
}
var Zi = Bn("[Conversations]"), X0 = { featureFlags: class {
  constructor(e) {
    this.di = !1, this.Ie = !1, this.Ce = !1, this.Fe = !1, this.Oe = !1, this.Me = !1, this.Ae = !1, this.De = !1, this._instance = e, this.featureFlagEventHandlers = [];
  }
  Le() {
    var e, n;
    return (e = (n = this._instance.persistence) == null ? void 0 : n.nt(this._instance.config.feature_flag_cache_ttl_ms)) !== null && e !== void 0 && e;
  }
  je() {
    return !!this.Le() && (this.De || this.Ce || (this.De = !0, Oi.warn("Feature flag cache is stale, triggering refresh..."), this.reloadFeatureFlags()), !0);
  }
  Ne() {
    var e, n = (e = this._instance.config.evaluation_contexts) !== null && e !== void 0 ? e : this._instance.config.evaluation_environments;
    return !this._instance.config.evaluation_environments || this._instance.config.evaluation_contexts || this.Ae || (Oi.warn("evaluation_environments is deprecated. Use evaluation_contexts instead. evaluation_environments will be removed in a future version."), this.Ae = !0), n != null && n.length ? n.filter((r) => {
      var a = r && typeof r == "string" && r.trim().length > 0;
      return a || Oi.error("Invalid evaluation context found:", r, "Expected non-empty string"), a;
    }) : [];
  }
  Ue() {
    return this.Ne().length > 0;
  }
  initialize() {
    var e, n, { config: r } = this._instance, a = (e = (n = r.bootstrap) == null ? void 0 : n.featureFlags) !== null && e !== void 0 ? e : {};
    if (Object.keys(a).length) {
      var o, l, d = (o = (l = r.bootstrap) == null ? void 0 : l.featureFlagPayloads) !== null && o !== void 0 ? o : {}, c = Object.keys(a).filter((s) => !!a[s]).reduce((s, h) => (s[h] = a[h] || !1, s), {}), f = Object.keys(d).filter((s) => c[s]).reduce((s, h) => (d[h] && (s[h] = d[h]), s), {});
      this.receivedFeatureFlags({ featureFlags: c, featureFlagPayloads: f });
    }
  }
  updateFlags(e, n, r) {
    var a = r != null && r.merge ? this.getFlagVariants() : {}, o = r != null && r.merge ? this.getFlagPayloads() : {}, l = pt({}, a, e), d = pt({}, o, n), c = {};
    for (var [f, s] of Object.entries(l)) {
      var h = typeof s == "string";
      c[f] = { key: f, enabled: !!h || !!s, variant: h ? s : void 0, reason: void 0, metadata: wt(d == null ? void 0 : d[f]) ? void 0 : { id: 0, version: void 0, description: void 0, payload: d[f] } };
    }
    this.receivedFeatureFlags({ flags: c });
  }
  get hasLoadedFlags() {
    return this.Ie;
  }
  getFlags() {
    return Object.keys(this.getFlagVariants());
  }
  getFlagsWithDetails() {
    var e = this._instance.get_property(vh), n = this._instance.get_property(fa), r = this._instance.get_property(Co);
    if (!r && !n) return e || {};
    var a = Xn({}, e || {}), o = [.../* @__PURE__ */ new Set([...Object.keys(r || {}), ...Object.keys(n || {})])];
    for (var l of o) {
      var d, c, f = a[l], s = n == null ? void 0 : n[l], h = wt(s) ? (d = f == null ? void 0 : f.enabled) !== null && d !== void 0 && d : !!s, g = wt(s) ? f.variant : typeof s == "string" ? s : void 0, t = r == null ? void 0 : r[l], i = pt({}, f, { enabled: h, variant: h ? g ?? (f == null ? void 0 : f.variant) : void 0 });
      h !== (f == null ? void 0 : f.enabled) && (i.original_enabled = f == null ? void 0 : f.enabled), g !== (f == null ? void 0 : f.variant) && (i.original_variant = f == null ? void 0 : f.variant), t && (i.metadata = pt({}, f == null ? void 0 : f.metadata, { payload: t, original_payload: f == null || (c = f.metadata) == null ? void 0 : c.payload })), a[l] = i;
    }
    return this.di || (Oi.warn(" Overriding feature flag details!", { flagDetails: e, overriddenPayloads: r, finalDetails: a }), this.di = !0), a;
  }
  getFlagVariants() {
    var e = this._instance.get_property(Aa), n = this._instance.get_property(fa);
    if (!n) return e || {};
    for (var r = Xn({}, e), a = Object.keys(n), o = 0; o < a.length; o++) r[a[o]] = n[a[o]];
    return this.di || (Oi.warn(" Overriding feature flags!", { enabledFlags: e, overriddenFlags: n, finalFlags: r }), this.di = !0), r;
  }
  getFlagPayloads() {
    var e = this._instance.get_property(tm), n = this._instance.get_property(Co);
    if (!n) return e || {};
    for (var r = Xn({}, e || {}), a = Object.keys(n), o = 0; o < a.length; o++) r[a[o]] = n[a[o]];
    return this.di || (Oi.warn(" Overriding feature flag payloads!", { flagPayloads: e, overriddenPayloads: n, finalPayloads: r }), this.di = !0), r;
  }
  reloadFeatureFlags() {
    this.Fe || this._instance.config.advanced_disable_feature_flags || this.ze || (this._instance.bi.emit("featureFlagsReloading", !0), this.ze = setTimeout(() => {
      this.He();
    }, 5));
  }
  Be() {
    clearTimeout(this.ze), this.ze = void 0;
  }
  ensureFlagsLoaded() {
    this.Ie || this.Ce || this.ze || this.reloadFeatureFlags();
  }
  setAnonymousDistinctId(e) {
    this.$anon_distinct_id = e;
  }
  setReloadingPaused(e) {
    this.Fe = e;
  }
  He(e) {
    var n;
    if (this.Be(), !this._instance.bt()) if (this.Ce) this.Oe = !0;
    else {
      var r = this._instance.config.token, a = this._instance.get_property("$device_id"), o = { token: r, distinct_id: this._instance.get_distinct_id(), groups: this._instance.getGroups(), $anon_distinct_id: this.$anon_distinct_id, person_properties: pt({}, ((n = this._instance.persistence) == null ? void 0 : n.get_initial_props()) || {}, this._instance.get_property(jo) || {}), group_properties: this._instance.get_property(Ps), timezone: w3() };
      br(a) || wt(a) || (o.$device_id = a), (e != null && e.disableFlags || this._instance.config.advanced_disable_feature_flags) && (o.disable_flags = !0), this.Ue() && (o.evaluation_contexts = this.Ne());
      var l = this._instance.config.advanced_only_evaluate_survey_feature_flags ? "&only_evaluate_survey_feature_flags=true" : "", d = this._instance.requestRouter.endpointFor("flags", "/flags/?v=2" + l);
      this.Ce = !0, this._instance._send_request({ method: "POST", url: d, data: o, compression: this._instance.config.disable_compression ? void 0 : zr.Base64, timeout: this._instance.config.feature_flag_request_timeout_ms, callback: (c) => {
        var f, s, h, g = !0;
        if (c.statusCode === 200 && (this.Oe || (this.$anon_distinct_id = void 0), g = !1), this.Ce = !1, !o.disable_flags || this.Oe) {
          this.Me = !g;
          var t = [];
          c.error ? c.error instanceof Error ? t.push(c.error.name === "AbortError" ? pP : gP) : t.push(mP) : c.statusCode !== 200 && t.push(xP(c.statusCode)), (f = c.json) != null && f.errorsWhileComputingFlags && t.push(dP);
          var i = !((s = c.json) == null || (s = s.quotaLimited) == null || !s.includes(yP.FeatureFlags));
          if (i && t.push(fP), (h = this._instance.persistence) == null || h.register({ [Sh]: t }), i) Oi.warn("You have hit your feature flags quota limit, and will not be able to load feature flags until the quota is reset.  Please visit https://posthog.com/docs/billing/limits-alerts to learn more.");
          else {
            var m;
            o.disable_flags || this.receivedFeatureFlags((m = c.json) !== null && m !== void 0 ? m : {}, g), this.Oe && (this.Oe = !1, this.He());
          }
        }
      } });
    }
  }
  getFeatureFlag(e, n) {
    var r;
    if (n === void 0 && (n = {}), !n.fresh || this.Me) if (this.Ie || this.getFlags() && this.getFlags().length > 0) {
      if (!this.je()) {
        var a = this.getFeatureFlagResult(e, n);
        return (r = a == null ? void 0 : a.variant) !== null && r !== void 0 ? r : a == null ? void 0 : a.enabled;
      }
    } else Oi.warn('getFeatureFlag for key "' + e + `" failed. Feature flags didn't load in time.`);
  }
  getFeatureFlagDetails(e) {
    return this.getFlagsWithDetails()[e];
  }
  getFeatureFlagPayload(e) {
    var n = this.getFeatureFlagResult(e, { send_event: !1 });
    return n == null ? void 0 : n.payload;
  }
  getFeatureFlagResult(e, n) {
    if (n === void 0 && (n = {}), !n.fresh || this.Me) if (this.Ie || this.getFlags() && this.getFlags().length > 0) {
      if (!this.je()) {
        var r = this.getFlagVariants(), a = e in r, o = r[e], l = this.getFlagPayloads()[e], d = String(o), c = this._instance.get_property(nm) || void 0, f = this._instance.get_property(Kl) || void 0, s = this._instance.get_property(Gl) || {};
        if ((n.send_event || !("send_event" in n)) && (!(e in s) || !s[e].includes(d))) {
          var h, g, t, i, m, v, E, S, y, x;
          gn(s[e]) ? s[e].push(d) : s[e] = [d], (h = this._instance.persistence) == null || h.register({ [Gl]: s });
          var b = this.getFeatureFlagDetails(e), u = [...(g = this._instance.get_property(Sh)) !== null && g !== void 0 ? g : []];
          wt(o) && u.push(hP);
          var I = { $feature_flag: e, $feature_flag_response: o, $feature_flag_payload: l || null, $feature_flag_request_id: c, $feature_flag_evaluated_at: f, $feature_flag_bootstrapped_response: ((t = this._instance.config.bootstrap) == null || (t = t.featureFlags) == null ? void 0 : t[e]) || null, $feature_flag_bootstrapped_payload: ((i = this._instance.config.bootstrap) == null || (i = i.featureFlagPayloads) == null ? void 0 : i[e]) || null, $used_bootstrap_value: !this.Me };
          wt(b == null || (m = b.metadata) == null ? void 0 : m.version) || (I.$feature_flag_version = b.metadata.version);
          var O, D = (v = b == null || (E = b.reason) == null ? void 0 : E.description) !== null && v !== void 0 ? v : b == null || (S = b.reason) == null ? void 0 : S.code;
          D && (I.$feature_flag_reason = D), b != null && (y = b.metadata) != null && y.id && (I.$feature_flag_id = b.metadata.id), wt(b == null ? void 0 : b.original_variant) && wt(b == null ? void 0 : b.original_enabled) || (I.$feature_flag_original_response = wt(b.original_variant) ? b.original_enabled : b.original_variant), b != null && (x = b.metadata) != null && x.original_payload && (I.$feature_flag_original_payload = b == null || (O = b.metadata) == null ? void 0 : O.original_payload), u.length && (I.$feature_flag_error = u.join(",")), this._instance.capture("$feature_flag_called", I);
        }
        if (a) {
          var $ = l;
          if (!wt(l)) try {
            $ = JSON.parse(l);
          } catch {
          }
          return { key: e, enabled: !!o, variant: typeof o == "string" ? o : void 0, payload: $ };
        }
      }
    } else Oi.warn('getFeatureFlagResult for key "' + e + `" failed. Feature flags didn't load in time.`);
  }
  getRemoteConfigPayload(e, n) {
    var r = this._instance.config.token, a = { distinct_id: this._instance.get_distinct_id(), token: r };
    this.Ue() && (a.evaluation_contexts = this.Ne()), this._instance._send_request({ method: "POST", url: this._instance.requestRouter.endpointFor("flags", "/flags/?v=2"), data: a, compression: this._instance.config.disable_compression ? void 0 : zr.Base64, timeout: this._instance.config.feature_flag_request_timeout_ms, callback: (o) => {
      var l, d = (l = o.json) == null ? void 0 : l.featureFlagPayloads;
      n((d == null ? void 0 : d[e]) || void 0);
    } });
  }
  isFeatureEnabled(e, n) {
    if (n === void 0 && (n = {}), !n.fresh || this.Me) {
      if (this.Ie || this.getFlags() && this.getFlags().length > 0) {
        var r = this.getFeatureFlag(e, n);
        return wt(r) ? void 0 : !!r;
      }
      Oi.warn('isFeatureEnabled for key "' + e + `" failed. Feature flags didn't load in time.`);
    }
  }
  addFeatureFlagsHandler(e) {
    this.featureFlagEventHandlers.push(e);
  }
  removeFeatureFlagsHandler(e) {
    this.featureFlagEventHandlers = this.featureFlagEventHandlers.filter((n) => n !== e);
  }
  receivedFeatureFlags(e, n) {
    if (this._instance.persistence) {
      this.Ie = !0;
      var r = this.getFlagVariants(), a = this.getFlagPayloads(), o = this.getFlagsWithDetails();
      (function(l, d, c, f, s) {
        c === void 0 && (c = {}), f === void 0 && (f = {}), s === void 0 && (s = {});
        var h = bP(l), g = h.flags, t = h.featureFlags, i = h.featureFlagPayloads;
        if (t) {
          var m = l.requestId, v = l.evaluatedAt;
          if (gn(t)) {
            Oi.warn("v1 of the feature flags endpoint is deprecated. Please use the latest version.");
            var E = {};
            if (t) for (var S = 0; S < t.length; S++) E[t[S]] = !0;
            d && d.register({ [ud]: t, [Aa]: E });
          } else {
            var y = t, x = i, b = g;
            if (l.errorsWhileComputingFlags) if (g) {
              var u = new Set(Object.keys(g).filter((I) => {
                var O;
                return !((O = g[I]) != null && O.failed);
              }));
              y = pt({}, c, Object.fromEntries(Object.entries(y).filter((I) => {
                var [O] = I;
                return u.has(O);
              }))), x = pt({}, f, Object.fromEntries(Object.entries(x || {}).filter((I) => {
                var [O] = I;
                return u.has(O);
              }))), b = pt({}, s, Object.fromEntries(Object.entries(b || {}).filter((I) => {
                var [O] = I;
                return u.has(O);
              })));
            } else y = pt({}, c, y), x = pt({}, f, x), b = pt({}, s, b);
            d && d.register(pt({ [ud]: Object.keys(im(y)), [Aa]: y || {}, [tm]: x || {}, [vh]: b || {} }, m ? { [nm]: m } : {}, v ? { [Kl]: v } : {}));
          }
        }
      })(e, this._instance.persistence, r, a, o), n || (this.De = !1), this.qe(n);
    }
  }
  override(e, n) {
    n === void 0 && (n = !1), Oi.warn("override is deprecated. Please use overrideFeatureFlags instead."), this.overrideFeatureFlags({ flags: e, suppressWarning: n });
  }
  overrideFeatureFlags(e) {
    if (!this._instance.__loaded || !this._instance.persistence) return Oi.uninitializedWarning("posthog.featureFlags.overrideFeatureFlags");
    if (e === !1) return this._instance.persistence.unregister(fa), this._instance.persistence.unregister(Co), this.qe(), _o.info("All overrides cleared");
    if (e && typeof e == "object" && ("flags" in e || "payloads" in e)) {
      var n, r = e;
      if (this.di = !!((n = r.suppressWarning) !== null && n !== void 0 && n), "flags" in r) {
        if (r.flags === !1) this._instance.persistence.unregister(fa), _o.info("Flag overrides cleared");
        else if (r.flags) {
          if (gn(r.flags)) {
            for (var a = {}, o = 0; o < r.flags.length; o++) a[r.flags[o]] = !0;
            this._instance.persistence.register({ [fa]: a });
          } else this._instance.persistence.register({ [fa]: r.flags });
          _o.info("Flag overrides set", { flags: r.flags });
        }
      }
      return "payloads" in r && (r.payloads === !1 ? (this._instance.persistence.unregister(Co), _o.info("Payload overrides cleared")) : r.payloads && (this._instance.persistence.register({ [Co]: r.payloads }), _o.info("Payload overrides set", { payloads: r.payloads }))), void this.qe();
    }
    this.qe();
  }
  onFeatureFlags(e) {
    if (this.addFeatureFlagsHandler(e), this.Ie) {
      var { flags: n, flagVariants: r } = this.vi();
      e(n, r);
    }
    return () => this.removeFeatureFlagsHandler(e);
  }
  updateEarlyAccessFeatureEnrollment(e, n, r) {
    var a, o = (this._instance.get_property(Po) || []).find((f) => f.flagKey === e), l = { ["$feature_enrollment/" + e]: n }, d = { $feature_flag: e, $feature_enrollment: n, $set: l };
    o && (d.$early_access_feature_name = o.name), r && (d.$feature_enrollment_stage = r), this._instance.capture("$feature_enrollment_update", d), this.setPersonPropertiesForFlags(l, !1);
    var c = pt({}, this.getFlagVariants(), { [e]: n });
    (a = this._instance.persistence) == null || a.register({ [ud]: Object.keys(im(c)), [Aa]: c }), this.qe();
  }
  getEarlyAccessFeatures(e, n, r) {
    n === void 0 && (n = !1);
    var a = this._instance.get_property(Po), o = r ? "&" + r.map((l) => "stage=" + l).join("&") : "";
    if (a && !n) return e(a);
    this._instance._send_request({ url: this._instance.requestRouter.endpointFor("api", "/api/early_access_features/?token=" + this._instance.config.token + o), method: "GET", callback: (l) => {
      var d, c;
      if (l.json) {
        var f = l.json.earlyAccessFeatures;
        return (d = this._instance.persistence) == null || d.unregister(Po), (c = this._instance.persistence) == null || c.register({ [Po]: f }), e(f);
      }
    } });
  }
  vi() {
    var e = this.getFlags(), n = this.getFlagVariants();
    return { flags: e.filter((r) => n[r]), flagVariants: Object.keys(n).filter((r) => n[r]).reduce((r, a) => (r[a] = n[a], r), {}) };
  }
  qe(e) {
    var { flags: n, flagVariants: r } = this.vi();
    this.featureFlagEventHandlers.forEach((a) => a(n, r, { errorsLoading: e }));
  }
  setPersonPropertiesForFlags(e, n) {
    n === void 0 && (n = !0);
    var r = this._instance.get_property(jo) || {};
    this._instance.register({ [jo]: pt({}, r, e) }), n && this._instance.reloadFeatureFlags();
  }
  resetPersonPropertiesForFlags() {
    this._instance.unregister(jo);
  }
  setGroupPropertiesForFlags(e, n) {
    n === void 0 && (n = !0);
    var r = this._instance.get_property(Ps) || {};
    Object.keys(r).length !== 0 && Object.keys(r).forEach((a) => {
      r[a] = pt({}, r[a], e[a]), delete e[a];
    }), this._instance.register({ [Ps]: pt({}, r, e) }), n && this._instance.reloadFeatureFlags();
  }
  resetGroupPropertiesForFlags(e) {
    if (e) {
      var n = this._instance.get_property(Ps) || {};
      this._instance.register({ [Ps]: pt({}, n, { [e]: {} }) });
    } else this._instance.unregister(Ps);
  }
  reset() {
    this.Ie = !1, this.Ce = !1, this.Fe = !1, this.Oe = !1, this.Me = !1, this.$anon_distinct_id = void 0, this.Be(), this.di = !1;
  }
} }, wP = { sessionRecording: class {
  get started() {
    var e;
    return !((e = this.Ve) == null || !e.isStarted);
  }
  get status() {
    var e, n;
    return this.We === So || this.We === tl ? this.We : (e = (n = this.Ve) == null ? void 0 : n.status) !== null && e !== void 0 ? e : this.We;
  }
  constructor(e) {
    if (this._forceAllowLocalhostNetworkCapture = !1, this.We = Kg, this.Ge = void 0, this._instance = e, !this._instance.sessionManager) throw Ts.error("started without valid sessionManager"), new Error(Rh + " started without valid sessionManager. This is a bug.");
    if (this._instance.config.cookieless_mode === "always") throw new Error(Rh + ' cannot be used with cookieless_mode="always"');
  }
  initialize() {
    this.startIfEnabledOrStop();
  }
  get Ye() {
    var e, n = !((e = this._instance.get_property(Yc)) == null || !e.enabled), r = !this._instance.config.disable_session_recording, a = this._instance.config.disable_session_recording || this._instance.consent.isOptedOut();
    return Xe && n && r && !a;
  }
  startIfEnabledOrStop(e) {
    var n;
    if (!this.Ye || (n = this.Ve) == null || !n.isStarted) {
      var r = !wt(Object.assign) && !wt(Array.from);
      this.Ye && r ? (this.Je(e), Ts.info("starting")) : (this.We = Kg, this.stopRecording());
    }
  }
  Je(e) {
    var n, r, a;
    this.Ye && (this.We !== So && this.We !== tl && (this.We = Yg), qt != null && (n = qt.__PosthogExtensions__) != null && (n = n.rrweb) != null && n.record && (r = qt.__PosthogExtensions__) != null && r.initSessionRecording ? this.Ke(e) : (a = qt.__PosthogExtensions__) == null || a.loadExternalDependency == null || a.loadExternalDependency(this._instance, this.Xe, (o) => {
      if (o) return Ts.error("could not load recorder", o);
      this.Ke(e);
    }));
  }
  stopRecording() {
    var e, n;
    (e = this.Ge) == null || e.call(this), this.Ge = void 0, (n = this.Ve) == null || n.stop();
  }
  Qe() {
    var e, n;
    (e = this.Ge) == null || e.call(this), this.Ge = void 0, (n = this.Ve) == null || n.discard();
  }
  Ze() {
    var e;
    (e = this._instance.persistence) == null || e.unregister(u3);
  }
  tr(e, n) {
    if (un(e)) return null;
    var r, a = Pr(e) ? e : parseFloat(e);
    return typeof (r = a) == "number" && Number.isFinite(r) && r >= 0 && r <= 1 ? a : (Ts.warn(n + " must be between 0 and 1. Ignoring invalid value:", e), null);
  }
  ir(e) {
    if (this._instance.persistence) {
      var n, r, a = this._instance.persistence, o = () => {
        var l, d = e.sessionRecording === !1 ? void 0 : e.sessionRecording, c = this.tr((l = this._instance.config.session_recording) == null ? void 0 : l.sampleRate, "session_recording.sampleRate"), f = this.tr(d == null ? void 0 : d.sampleRate, "remote config sampleRate"), s = c ?? f;
        un(s) && this.Ze();
        var h = d == null ? void 0 : d.minimumDurationMilliseconds;
        a.register({ [Yc]: pt({ cache_timestamp: Date.now(), enabled: !!d }, d, { networkPayloadCapture: pt({ capturePerformance: e.capturePerformance }, d == null ? void 0 : d.networkPayloadCapture), canvasRecording: { enabled: d == null ? void 0 : d.recordCanvas, fps: d == null ? void 0 : d.canvasFps, quality: d == null ? void 0 : d.canvasQuality }, sampleRate: s, minimumDurationMilliseconds: wt(h) ? null : h, endpoint: d == null ? void 0 : d.endpoint, triggerMatchType: d == null ? void 0 : d.triggerMatchType, masking: d == null ? void 0 : d.masking, urlTriggers: d == null ? void 0 : d.urlTriggers }) });
      };
      o(), (n = this.Ge) == null || n.call(this), this.Ge = (r = this._instance.sessionManager) == null ? void 0 : r.onSessionId(o);
    }
  }
  onRemoteConfig(e) {
    return "sessionRecording" in e ? e.sessionRecording === !1 ? (this.ir(e), void this.Qe()) : (this.ir(e), void this.startIfEnabledOrStop()) : (this.We === So && (this.We = tl, Ts.warn("config refresh failed, recording will not start until page reload")), void this.startIfEnabledOrStop());
  }
  log(e, n) {
    var r;
    n === void 0 && (n = "log"), (r = this.Ve) != null && r.log ? this.Ve.log(e, n) : Ts.warn("log called before recorder was ready");
  }
  get Xe() {
    var e, n, r = (e = this._instance) == null || (e = e.persistence) == null ? void 0 : e.get_property(Yc);
    return (r == null || (n = r.scriptConfig) == null ? void 0 : n.script) || "lazy-recorder";
  }
  er() {
    var e, n = this._instance.get_property(Yc);
    if (!n) return !1;
    var r = (e = (typeof n == "object" ? n : JSON.parse(n)).cache_timestamp) !== null && e !== void 0 ? e : 0;
    return Date.now() - r <= 36e5;
  }
  Ke(e) {
    var n, r;
    if ((n = qt.__PosthogExtensions__) == null || !n.initSessionRecording) throw Error("Called on script loaded before session recording is available");
    if (this.Ve || (this.Ve = (r = qt.__PosthogExtensions__) == null ? void 0 : r.initSessionRecording(this._instance), this.Ve._forceAllowLocalhostNetworkCapture = this._forceAllowLocalhostNetworkCapture), !this.er())
      return this.We === tl || this.We === So ? void 0 : (this.We = So, Ts.info("persisted remote config is stale, requesting fresh config before starting"), void new S3(this._instance).load());
    this.We = Yg, this.Ve.start(e);
  }
  onRRwebEmit(e) {
    var n;
    (n = this.Ve) == null || n.onRRwebEmit == null || n.onRRwebEmit(e);
  }
  overrideLinkedFlag() {
    var e, n;
    this.Ve || (n = this._instance.persistence) == null || n.register({ $replay_override_linked_flag: !0 }), (e = this.Ve) == null || e.overrideLinkedFlag();
  }
  overrideSampling() {
    var e, n;
    this.Ve || (n = this._instance.persistence) == null || n.register({ $replay_override_sampling: !0 }), (e = this.Ve) == null || e.overrideSampling();
  }
  overrideTrigger(e) {
    var n, r;
    this.Ve || (r = this._instance.persistence) == null || r.register({ [e === "url" ? "$replay_override_url_trigger" : "$replay_override_event_trigger"]: !0 }), (n = this.Ve) == null || n.overrideTrigger(e);
  }
  get sdkDebugProperties() {
    var e;
    return ((e = this.Ve) == null ? void 0 : e.sdkDebugProperties) || { $recording_status: this.status };
  }
  tryAddCustomEvent(e, n) {
    var r;
    return !((r = this.Ve) == null || !r.tryAddCustomEvent(e, n));
  }
} }, SP = { autocapture: class {
  constructor(e) {
    this.rr = !1, this.sr = null, this.nr = !1, this.instance = e, this.rageclicks = new qg(e.config.rageclick), this.ar = null;
  }
  initialize() {
    this.startIfEnabled();
  }
  get N() {
    var e, n, r = ii(this.instance.config.autocapture) ? this.instance.config.autocapture : {};
    return r.url_allowlist = (e = r.url_allowlist) == null ? void 0 : e.map((a) => new RegExp(a)), r.url_ignorelist = (n = r.url_ignorelist) == null ? void 0 : n.map((a) => new RegExp(a)), r;
  }
  lr() {
    if (this.isBrowserSupported()) {
      if (Xe && bt) {
        var e = (r) => {
          r = r || (Xe == null ? void 0 : Xe.event);
          try {
            this.ur(r);
          } catch (a) {
            Vg.error("Failed to capture event", a);
          }
        };
        if (Qn(bt, "submit", e, { capture: !0 }), Qn(bt, "change", e, { capture: !0 }), Qn(bt, "click", e, { capture: !0 }), this.N.capture_copied_text) {
          var n = (r) => {
            r = r || (Xe == null ? void 0 : Xe.event), this.ur(r, od);
          };
          Qn(bt, "copy", n, { capture: !0 }), Qn(bt, "cut", n, { capture: !0 });
        }
      }
    } else Vg.info("Disabling Automatic Event Collection because this browser is not supported");
  }
  startIfEnabled() {
    this.isEnabled && !this.rr && (this.lr(), this.rr = !0);
  }
  onRemoteConfig(e) {
    e.elementsChainAsString && (this.nr = e.elementsChainAsString), this.instance.persistence && this.instance.persistence.register({ [pg]: !!e.autocapture_opt_out }), this.sr = !!e.autocapture_opt_out, this.startIfEnabled();
  }
  setElementSelectors(e) {
    this.ar = e;
  }
  getElementSelectors(e) {
    var n, r = [];
    return (n = this.ar) == null || n.forEach((a) => {
      var o = bt == null ? void 0 : bt.querySelectorAll(a);
      o == null || o.forEach((l) => {
        e === l && r.push(a);
      });
    }), r;
  }
  get isEnabled() {
    var e, n, r = (e = this.instance.persistence) == null ? void 0 : e.props[pg], a = this.sr;
    if (br(a) && !qr(r) && !this.instance.bt()) return !1;
    var o = (n = this.sr) !== null && n !== void 0 ? n : !!r;
    return !!this.instance.config.autocapture && !o;
  }
  ur(e, n) {
    if (n === void 0 && (n = "$autocapture"), this.isEnabled) {
      var r, a = Ug(e);
      j3(a) && (a = a.parentNode || null), n === "$autocapture" && e.type === "click" && e instanceof MouseEvent && this.instance.config.rageclick && (r = this.rageclicks) != null && r.isRageClick(e.clientX, e.clientY, e.timeStamp || (/* @__PURE__ */ new Date()).getTime()) && XF(a, this.instance.config.rageclick) && this.ur(e, "$rageclick");
      var o = n === od;
      if (a && GF(a, e, this.N, o, o ? ["copy", "cut"] : void 0)) {
        var { props: l, explicitNoCapture: d } = iP(a, { e, maskAllElementAttributes: this.instance.config.mask_all_element_attributes, maskAllText: this.instance.config.mask_all_text, elementAttributeIgnoreList: this.N.element_attribute_ignorelist, elementsChainAsString: this.nr });
        if (d) return !1;
        var c = this.getElementSelectors(a);
        if (c && c.length > 0 && (l.$element_selectors = c), n === od) {
          var f, s = M3(Xe == null || (f = Xe.getSelection()) == null ? void 0 : f.toString()), h = e.type || "clipboard";
          if (!s) return !1;
          l.$selected_content = s, l.$copy_type = h;
        }
        return this.instance.capture(n, l), !0;
      }
    }
  }
  isBrowserSupported() {
    return Hr(bt == null ? void 0 : bt.querySelectorAll);
  }
}, historyAutocapture: class {
  constructor(e) {
    var n;
    this._instance = e, this.hr = (Xe == null || (n = Xe.location) == null ? void 0 : n.pathname) || "";
  }
  initialize() {
    this.startIfEnabled();
  }
  get isEnabled() {
    return this._instance.config.capture_pageview === "history_change";
  }
  startIfEnabled() {
    this.isEnabled && (vt.info("History API monitoring enabled, starting..."), this.monitorHistoryChanges());
  }
  stop() {
    this.dr && this.dr(), this.dr = void 0, vt.info("History API monitoring stopped");
  }
  monitorHistoryChanges() {
    var e, n;
    if (Xe && Xe.history) {
      var r = this;
      (e = Xe.history.pushState) != null && e.__posthog_wrapped__ || Xg(Xe.history, "pushState", (a) => function(o, l, d) {
        a.call(this, o, l, d), r.vr("pushState");
      }), (n = Xe.history.replaceState) != null && n.__posthog_wrapped__ || Xg(Xe.history, "replaceState", (a) => function(o, l, d) {
        a.call(this, o, l, d), r.vr("replaceState");
      }), this.cr();
    }
  }
  vr(e) {
    try {
      var n, r = Xe == null || (n = Xe.location) == null ? void 0 : n.pathname;
      if (!r) return;
      r !== this.hr && this.isEnabled && this._instance.capture("$pageview", { navigation_type: e }), this.hr = r;
    } catch (a) {
      vt.error("Error capturing " + e + " pageview", a);
    }
  }
  cr() {
    if (!this.dr) {
      var e = () => {
        this.vr("popstate");
      };
      Qn(Xe, "popstate", e), this.dr = () => {
        Xe && Xe.removeEventListener("popstate", e);
      };
    }
  }
}, heatmaps: class {
  constructor(e) {
    var n;
    this.pr = !1, this.rr = !1, this._r = null, this.instance = e, this.pr = !((n = this.instance.persistence) == null || !n.props[bh]), this.rageclicks = new qg(e.config.rageclick);
  }
  initialize() {
    this.startIfEnabled();
  }
  get flushIntervalMilliseconds() {
    var e = 5e3;
    return ii(this.instance.config.capture_heatmaps) && this.instance.config.capture_heatmaps.flush_interval_milliseconds && (e = this.instance.config.capture_heatmaps.flush_interval_milliseconds), e;
  }
  get isEnabled() {
    return un(this.instance.config.capture_heatmaps) ? un(this.instance.config.enable_heatmaps) ? this.pr : this.instance.config.enable_heatmaps : this.instance.config.capture_heatmaps !== !1;
  }
  startIfEnabled() {
    if (this.isEnabled) {
      if (this.rr) return;
      sP.info("starting..."), this.gr(), this.mr();
    } else {
      var e;
      clearInterval((e = this._r) !== null && e !== void 0 ? e : void 0), this.br(), this.getAndClearBuffer();
    }
  }
  onRemoteConfig(e) {
    if ("heatmaps" in e) {
      var n = !!e.heatmaps;
      this.instance.persistence && this.instance.persistence.register({ [bh]: n }), this.pr = n, this.startIfEnabled();
    }
  }
  getAndClearBuffer() {
    var e = this.C;
    return this.C = void 0, e;
  }
  yr(e) {
    this.wr(e.originalEvent, "deadclick");
  }
  mr() {
    this._r && clearInterval(this._r), this._r = function(e) {
      return (e == null ? void 0 : e.visibilityState) === "visible";
    }(bt) ? setInterval(this.Ot.bind(this), this.flushIntervalMilliseconds) : null;
  }
  gr() {
    Xe && bt && (this.Er = this.Ot.bind(this), Qn(Xe, "beforeunload", this.Er), this.Sr = (e) => this.wr(e || (Xe == null ? void 0 : Xe.event)), Qn(bt, "click", this.Sr, { capture: !0 }), this.$r = (e) => this.kr(e || (Xe == null ? void 0 : Xe.event)), Qn(bt, "mousemove", this.$r, { capture: !0 }), this.Pr = new Sg(this.instance, uF, this.yr.bind(this)), this.Pr.startIfEnabledOrStop(), this.Tr = this.mr.bind(this), Qn(bt, "visibilitychange", this.Tr), this.rr = !0);
  }
  br() {
    var e;
    Xe && bt && (this.Er && Xe.removeEventListener("beforeunload", this.Er), this.Sr && bt.removeEventListener("click", this.Sr, { capture: !0 }), this.$r && bt.removeEventListener("mousemove", this.$r, { capture: !0 }), this.Tr && bt.removeEventListener("visibilitychange", this.Tr), clearTimeout(this.Rr), (e = this.Pr) == null || e.stop(), this.rr = !1);
  }
  Ir(e, n) {
    var r = this.instance.scrollManager.scrollY(), a = this.instance.scrollManager.scrollX(), o = this.instance.scrollManager.scrollElement(), l = function(d, c, f) {
      for (var s = d; s && V0(s) && !ps(s, "body"); ) {
        if (s === f) return !1;
        if (cn(c, Xe == null ? void 0 : Xe.getComputedStyle(s).position)) return !0;
        s = N3(s);
      }
      return !1;
    }(Ug(e), ["fixed", "sticky"], o);
    return { x: e.clientX + (l ? 0 : a), y: e.clientY + (l ? 0 : r), target_fixed: l, type: n };
  }
  wr(e, n) {
    var r;
    if (n === void 0 && (n = "click"), !Bg(e.target) && Zg(e)) {
      var a = this.Ir(e, n);
      (r = this.rageclicks) != null && r.isRageClick(e.clientX, e.clientY, (/* @__PURE__ */ new Date()).getTime()) && this.Cr(pt({}, a, { type: "rageclick" })), this.Cr(a);
    }
  }
  kr(e) {
    !Bg(e.target) && Zg(e) && (clearTimeout(this.Rr), this.Rr = setTimeout(() => {
      this.Cr(this.Ir(e, "mousemove"));
    }, 500));
  }
  Cr(e) {
    if (Xe) {
      var n = Xe.location.href, r = this.instance.config.mask_personal_data_properties, a = this.instance.config.custom_personal_data_properties, o = r ? za([], Ha, a || []) : [], l = sc(n, o, ac);
      this.C = this.C || {}, this.C[l] || (this.C[l] = []), this.C[l].push(e);
    }
  }
  Ot() {
    this.C && !Ca(this.C) && this.instance.capture("$$heatmap", { $heatmap_data: this.getAndClearBuffer() });
  }
}, deadClicksAutocapture: Sg, webVitalsAutocapture: class {
  constructor(e) {
    var n;
    this.pr = !1, this.rr = !1, this.C = { url: void 0, metrics: [], firstMetricTimestamp: void 0 }, this.Fr = () => {
      clearTimeout(this.Or), this.C.metrics.length !== 0 && (this._instance.capture("$web_vitals", this.C.metrics.reduce((r, a) => pt({}, r, { ["$web_vitals_" + a.name + "_event"]: pt({}, a), ["$web_vitals_" + a.name + "_value"]: a.value }), {})), this.C = { url: void 0, metrics: [], firstMetricTimestamp: void 0 });
    }, this.Mr = (r) => {
      var a, o = (a = this._instance.sessionManager) == null ? void 0 : a.checkAndGetSessionAndWindowId(!0);
      if (wt(o)) rs.error("Could not read session ID. Dropping metrics!");
      else {
        this.C = this.C || { url: void 0, metrics: [], firstMetricTimestamp: void 0 };
        var l = this.Ar();
        wt(l) || (un(r == null ? void 0 : r.name) || un(r == null ? void 0 : r.value) ? rs.error("Invalid metric received", r) : this.Dr && r.value >= this.Dr ? rs.error("Ignoring metric with value >= " + this.Dr, r) : (this.C.url !== l && (this.Fr(), this.Or = setTimeout(this.Fr, this.flushToCaptureTimeoutMs)), wt(this.C.url) && (this.C.url = l), this.C.firstMetricTimestamp = wt(this.C.firstMetricTimestamp) ? Date.now() : this.C.firstMetricTimestamp, r.attribution && r.attribution.interactionTargetElement && (r.attribution.interactionTargetElement = void 0), this.C.metrics.push(pt({}, r, { $current_url: l, $session_id: o.sessionId, $window_id: o.windowId, timestamp: Date.now() })), this.C.metrics.length === this.allowedMetrics.length && this.Fr()));
      }
    }, this.Lr = () => {
      if (!this.rr) {
        var r, a, o, l, d = qt.__PosthogExtensions__;
        wt(d) || wt(d.postHogWebVitalsCallbacks) || ({ onLCP: r, onCLS: a, onFCP: o, onINP: l } = d.postHogWebVitalsCallbacks), r && a && o && l ? (this.allowedMetrics.indexOf("LCP") > -1 && r(this.Mr.bind(this)), this.allowedMetrics.indexOf("CLS") > -1 && a(this.Mr.bind(this)), this.allowedMetrics.indexOf("FCP") > -1 && o(this.Mr.bind(this)), this.allowedMetrics.indexOf("INP") > -1 && l(this.Mr.bind(this)), this.rr = !0) : rs.error("web vitals callbacks not loaded - not starting");
      }
    }, this._instance = e, this.pr = !((n = this._instance.persistence) == null || !n.props[xg]), this.startIfEnabled();
  }
  get allowedMetrics() {
    var e, n, r = ii(this._instance.config.capture_performance) ? (e = this._instance.config.capture_performance) == null ? void 0 : e.web_vitals_allowed_metrics : void 0;
    return un(r) ? ((n = this._instance.persistence) == null ? void 0 : n.props[yg]) || ["CLS", "FCP", "INP", "LCP"] : r;
  }
  get flushToCaptureTimeoutMs() {
    return (ii(this._instance.config.capture_performance) ? this._instance.config.capture_performance.web_vitals_delayed_flush_ms : void 0) || 5e3;
  }
  get useAttribution() {
    var e = ii(this._instance.config.capture_performance) ? this._instance.config.capture_performance.web_vitals_attribution : void 0;
    return e != null && e;
  }
  get Dr() {
    var e = ii(this._instance.config.capture_performance) && Pr(this._instance.config.capture_performance.__web_vitals_max_value) ? this._instance.config.capture_performance.__web_vitals_max_value : Gg;
    return 0 < e && e <= 6e4 ? Gg : e;
  }
  get isEnabled() {
    var e = pi == null ? void 0 : pi.protocol;
    if (e !== "http:" && e !== "https:") return rs.info("Web Vitals are disabled on non-http/https protocols"), !1;
    var n = ii(this._instance.config.capture_performance) ? this._instance.config.capture_performance.web_vitals : qr(this._instance.config.capture_performance) ? this._instance.config.capture_performance : void 0;
    return qr(n) ? n : this.pr;
  }
  startIfEnabled() {
    this.isEnabled && !this.rr && (rs.info("enabled, starting..."), this.G(this.Lr));
  }
  onRemoteConfig(e) {
    if ("capturePerformance" in e) {
      var n = ii(e.capturePerformance) && !!e.capturePerformance.web_vitals, r = ii(e.capturePerformance) ? e.capturePerformance.web_vitals_allowed_metrics : void 0;
      this._instance.persistence && (this._instance.persistence.register({ [xg]: n }), this._instance.persistence.register({ [yg]: r })), this.pr = n, this.startIfEnabled();
    }
  }
  G(e) {
    var n, r;
    if ((n = qt.__PosthogExtensions__) != null && n.postHogWebVitalsCallbacks) e();
    else {
      var a = this.useAttribution ? "web-vitals-with-attribution" : "web-vitals";
      (r = qt.__PosthogExtensions__) == null || r.loadExternalDependency == null || r.loadExternalDependency(this._instance, a, (o) => {
        o ? rs.error("failed to load script", o) : e();
      });
    }
  }
  Ar() {
    var e = Xe ? Xe.location.href : void 0;
    if (e) {
      var n = this._instance.config.mask_personal_data_properties, r = this._instance.config.custom_personal_data_properties, a = n ? za([], Ha, r || []) : [];
      return sc(e, a, ac);
    }
    rs.error("Could not determine current URL");
  }
} }, _P = { exceptionObserver: class {
  constructor(e) {
    var n, r, a;
    this.Lr = () => {
      var o;
      if (Xe && this.isEnabled && (o = qt.__PosthogExtensions__) != null && o.errorWrappingFunctions) {
        var l = qt.__PosthogExtensions__.errorWrappingFunctions.wrapOnError, d = qt.__PosthogExtensions__.errorWrappingFunctions.wrapUnhandledRejection, c = qt.__PosthogExtensions__.errorWrappingFunctions.wrapConsoleError;
        try {
          !this.jr && this.N.capture_unhandled_errors && (this.jr = l(this.captureException.bind(this))), !this.Nr && this.N.capture_unhandled_rejections && (this.Nr = d(this.captureException.bind(this))), !this.Ur && this.N.capture_console_errors && (this.Ur = c(this.captureException.bind(this)));
        } catch (f) {
          wo.error("failed to start", f), this.zr();
        }
      }
    }, this._instance = e, this.Hr = !((n = this._instance.persistence) == null || !n.props[gg]), this.Br = new bO({ refillRate: (r = this._instance.config.error_tracking.__exceptionRateLimiterRefillRate) !== null && r !== void 0 ? r : 1, bucketSize: (a = this._instance.config.error_tracking.__exceptionRateLimiterBucketSize) !== null && a !== void 0 ? a : 10, refillInterval: 1e4, h: wo }), this.N = this.qr(), this.startIfEnabledOrStop();
  }
  qr() {
    var e = this._instance.config.capture_exceptions, n = { capture_unhandled_errors: !1, capture_unhandled_rejections: !1, capture_console_errors: !1 };
    return ii(e) ? n = pt({}, n, e) : (wt(e) ? this.Hr : e) && (n = pt({}, n, { capture_unhandled_errors: !0, capture_unhandled_rejections: !0 })), n;
  }
  get isEnabled() {
    return this.N.capture_console_errors || this.N.capture_unhandled_errors || this.N.capture_unhandled_rejections;
  }
  startIfEnabledOrStop() {
    this.isEnabled ? (wo.info("enabled"), this.zr(), this.G(this.Lr)) : this.zr();
  }
  G(e) {
    var n, r;
    (n = qt.__PosthogExtensions__) != null && n.errorWrappingFunctions && e(), (r = qt.__PosthogExtensions__) == null || r.loadExternalDependency == null || r.loadExternalDependency(this._instance, "exception-autocapture", (a) => {
      if (a) return wo.error("failed to load script", a);
      e();
    });
  }
  zr() {
    var e, n, r;
    (e = this.jr) == null || e.call(this), this.jr = void 0, (n = this.Nr) == null || n.call(this), this.Nr = void 0, (r = this.Ur) == null || r.call(this), this.Ur = void 0;
  }
  onRemoteConfig(e) {
    if ("autocaptureExceptions" in e) {
      var n = e.autocaptureExceptions;
      this.Hr = !!n || !1, this._instance.persistence && this._instance.persistence.register({ [gg]: this.Hr }), this.N = this.qr(), this.startIfEnabledOrStop();
    }
  }
  onConfigChange() {
    this.N = this.qr();
  }
  captureException(e) {
    var n, r, a, o = (n = e == null || (r = e.$exception_list) == null || (r = r[0]) == null ? void 0 : r.type) !== null && n !== void 0 ? n : "Exception";
    this.Br.consumeRateLimit(o) ? wo.info("Skipping exception capture because of client rate limiting.", { exception: o }) : (a = this._instance.exceptions) == null || a.sendExceptionEvent(e);
  }
}, exceptions: class {
  constructor(e) {
    var n, r;
    this.Vr = [], this.Wr = new FO([new $O(), new KO(), new zO(), new UO(), new XO(), new VO(), new WO(), new GO()], BO()), this._instance = e, this.Vr = (n = (r = this._instance.persistence) == null ? void 0 : r.get_property(yh)) !== null && n !== void 0 ? n : [];
  }
  onRemoteConfig(e) {
    var n, r, a;
    if ("errorTracking" in e) {
      var o = (n = (r = e.errorTracking) == null ? void 0 : r.suppressionRules) !== null && n !== void 0 ? n : [], l = (a = e.errorTracking) == null ? void 0 : a.captureExtensionExceptions;
      this.Vr = o, this._instance.persistence && this._instance.persistence.register({ [yh]: this.Vr, [mg]: l });
    }
  }
  get Gr() {
    var e, n = !!this._instance.get_property(mg), r = this._instance.config.error_tracking.captureExtensionExceptions;
    return (e = r ?? n) !== null && e !== void 0 && e;
  }
  buildProperties(e, n) {
    return this.Wr.buildFromUnknown(e, { syntheticException: n == null ? void 0 : n.syntheticException, mechanism: { handled: n == null ? void 0 : n.handled } });
  }
  sendExceptionEvent(e) {
    var n = e.$exception_list;
    if (this.Yr(n)) {
      if (this.Jr(n)) return void dd.info("Skipping exception capture because a suppression rule matched");
      if (!this.Gr && this.Kr(n)) return void dd.info("Skipping exception capture because it was thrown by an extension");
      if (!this._instance.config.error_tracking.__capturePostHogExceptions && this.Xr(n)) return void dd.info("Skipping exception capture because it was thrown by the PostHog SDK");
    }
    return this._instance.capture("$exception", e, { _noTruncate: !0, _batchKey: "exceptionEvent", Ni: !0 });
  }
  Jr(e) {
    if (e.length === 0) return !1;
    var n = e.reduce((r, a) => {
      var { type: o, value: l } = a;
      return ti(o) && o.length > 0 && r.$exception_types.push(o), ti(l) && l.length > 0 && r.$exception_values.push(l), r;
    }, { $exception_types: [], $exception_values: [] });
    return this.Vr.some((r) => {
      var a = r.values.map((o) => {
        var l, d = T3[o.operator], c = gn(o.value) ? o.value : [o.value], f = (l = n[o.key]) !== null && l !== void 0 ? l : [];
        return c.length > 0 && d(c, f);
      });
      return r.type === "OR" ? a.some(Boolean) : a.every(Boolean);
    });
  }
  Kr(e) {
    return e.flatMap((n) => {
      var r, a;
      return (r = (a = n.stacktrace) == null ? void 0 : a.frames) !== null && r !== void 0 ? r : [];
    }).some((n) => n.filename && n.filename.startsWith("chrome-extension://"));
  }
  Xr(e) {
    if (e.length > 0) {
      var n, r, a, o, l = (n = (r = e[0].stacktrace) == null ? void 0 : r.frames) !== null && n !== void 0 ? n : [], d = l[l.length - 1];
      return (a = d == null || (o = d.filename) == null ? void 0 : o.includes("posthog.com/static")) !== null && a !== void 0 && a;
    }
    return !1;
  }
  Yr(e) {
    return !un(e) && gn(e);
  }
} }, CP = pt({ productTours: class {
  constructor(e) {
    this.Qr = null, this.Zr = null, this._instance = e;
  }
  initialize() {
    this.loadIfEnabled();
  }
  onRemoteConfig(e) {
    "productTours" in e && (this._instance.persistence && this._instance.persistence.register({ [bg]: !!e.productTours }), this.loadIfEnabled());
  }
  loadIfEnabled() {
    var e, n;
    this.Qr || (e = this._instance).config.disable_product_tours || (n = e.persistence) == null || !n.get_property(bg) || this.G(() => this.ts());
  }
  G(e) {
    var n, r;
    (n = qt.__PosthogExtensions__) != null && n.generateProductTours ? e() : (r = qt.__PosthogExtensions__) == null || r.loadExternalDependency == null || r.loadExternalDependency(this._instance, "product-tours", (a) => {
      a ? Qg.error("Could not load product tours script", a) : e();
    });
  }
  ts() {
    var e;
    !this.Qr && (e = qt.__PosthogExtensions__) != null && e.generateProductTours && (this.Qr = qt.__PosthogExtensions__.generateProductTours(this._instance, !0));
  }
  getProductTours(e, n) {
    if (n === void 0 && (n = !1), !gn(this.Zr) || n) {
      var r = this._instance.persistence;
      if (r) {
        var a = r.props[ld];
        if (gn(a) && !n) return this.Zr = a, void e(a, { isLoaded: !0 });
      }
      this._instance._send_request({ url: this._instance.requestRouter.endpointFor("api", "/api/product_tours/?token=" + this._instance.config.token), method: "GET", callback: (o) => {
        var l = o.statusCode;
        if (l !== 200 || !o.json) {
          var d = "Product Tours API could not be loaded, status: " + l;
          return Qg.error(d), void e([], { isLoaded: !1, error: d });
        }
        var c = gn(o.json.product_tours) ? o.json.product_tours : [];
        this.Zr = c, r && r.register({ [ld]: c }), e(c, { isLoaded: !0 });
      } });
    } else e(this.Zr, { isLoaded: !0 });
  }
  getActiveProductTours(e) {
    un(this.Qr) ? e([], { isLoaded: !1, error: "Product tours not loaded" }) : this.Qr.getActiveProductTours(e);
  }
  showProductTour(e) {
    var n;
    (n = this.Qr) == null || n.showTourById(e);
  }
  previewTour(e) {
    this.Qr ? this.Qr.previewTour(e) : this.G(() => {
      var n;
      this.ts(), (n = this.Qr) == null || n.previewTour(e);
    });
  }
  dismissProductTour() {
    var e;
    (e = this.Qr) == null || e.dismissTour("user_clicked_skip");
  }
  nextStep() {
    var e;
    (e = this.Qr) == null || e.nextStep();
  }
  previousStep() {
    var e;
    (e = this.Qr) == null || e.previousStep();
  }
  clearCache() {
    var e;
    this.Zr = null, (e = this._instance.persistence) == null || e.unregister(ld);
  }
  resetTour(e) {
    var n;
    (n = this.Qr) == null || n.resetTour(e);
  }
  resetAllTours() {
    var e;
    (e = this.Qr) == null || e.resetAllTours();
  }
  cancelPendingTour(e) {
    var n;
    (n = this.Qr) == null || n.cancelPendingTour(e);
  }
} }, X0), AP = { siteApps: class {
  constructor(e) {
    this._instance = e, this.es = [], this.apps = {};
  }
  get isEnabled() {
    return !!this._instance.config.opt_in_site_apps;
  }
  rs(e, n) {
    if (n) {
      var r = this.globalsForEvent(n);
      this.es.push(r), this.es.length > 1e3 && (this.es = this.es.slice(10));
    }
  }
  get siteAppLoaders() {
    var e;
    return (e = qt._POSTHOG_REMOTE_CONFIG) == null || (e = e[this._instance.config.token]) == null ? void 0 : e.siteApps;
  }
  initialize() {
    if (this.isEnabled) {
      var e = this._instance._addCaptureHook(this.rs.bind(this));
      this.ss = () => {
        e(), this.es = [], this.ss = void 0;
      };
    }
  }
  globalsForEvent(e) {
    var n, r, a, o, l, d, c;
    if (!e) throw new Error("Event payload is required");
    var f = {}, s = this._instance.get_property("$groups") || [], h = this._instance.get_property("$stored_group_properties") || {};
    for (var [g, t] of Object.entries(h)) f[g] = { id: s[g], type: g, properties: t };
    var { $set_once: i, $set: m } = e;
    return { event: pt({}, N9(e, aP), { properties: pt({}, e.properties, m ? { $set: pt({}, (n = (r = e.properties) == null ? void 0 : r.$set) !== null && n !== void 0 ? n : {}, m) } : {}, i ? { $set_once: pt({}, (a = (o = e.properties) == null ? void 0 : o.$set_once) !== null && a !== void 0 ? a : {}, i) } : {}), elements_chain: (l = (d = e.properties) == null ? void 0 : d.$elements_chain) !== null && l !== void 0 ? l : "", distinct_id: (c = e.properties) == null ? void 0 : c.distinct_id }), person: { properties: this._instance.get_property("$stored_person_properties") }, groups: f };
  }
  setupSiteApp(e) {
    var n = this.apps[e.id], r = () => {
      var d;
      !n.errored && this.es.length && (ss.info("Processing " + this.es.length + " events for site app with id " + e.id), this.es.forEach((c) => n.processEvent == null ? void 0 : n.processEvent(c)), n.processedBuffer = !0), Object.values(this.apps).every((c) => c.processedBuffer || c.errored) && ((d = this.ss) == null || d.call(this));
    }, a = !1, o = (d) => {
      n.errored = !d, n.loaded = !0, ss.info("Site app with id " + e.id + " " + (d ? "loaded" : "errored")), a && r();
    };
    try {
      var { processEvent: l } = e.init({ posthog: this._instance, callback: (d) => {
        o(d);
      } });
      l && (n.processEvent = l), a = !0;
    } catch (d) {
      ss.error("Error while initializing PostHog app with config id " + e.id, d), o(!1);
    }
    if (a && n.loaded) try {
      r();
    } catch (d) {
      ss.error("Error while processing buffered events PostHog app with config id " + e.id, d), n.errored = !0;
    }
  }
  ns() {
    var e = this.siteAppLoaders || [];
    for (var n of e) this.apps[n.id] = { id: n.id, loaded: !1, errored: !1, processedBuffer: !1 };
    for (var r of e) this.setupSiteApp(r);
  }
  os(e) {
    if (Object.keys(this.apps).length !== 0) {
      var n = this.globalsForEvent(e);
      for (var r of Object.values(this.apps)) try {
        r.processEvent == null || r.processEvent(n);
      } catch (a) {
        ss.error("Error while processing event " + e.event + " for site app " + r.id, a);
      }
    }
  }
  onRemoteConfig(e) {
    var n, r, a, o = this;
    if ((n = this.siteAppLoaders) != null && n.length) return this.isEnabled ? (this.ns(), void this._instance.on("eventCaptured", (f) => this.os(f))) : void ss.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
    if ((r = this.ss) == null || r.call(this), (a = e.siteApps) != null && a.length) if (this.isEnabled) {
      var l = function(f) {
        var s;
        qt["__$$ph_site_app_" + f] = o._instance, (s = qt.__PosthogExtensions__) == null || s.loadSiteApp == null || s.loadSiteApp(o._instance, c, (h) => {
          if (h) return ss.error("Error while initializing PostHog app with config id " + f, h);
        });
      };
      for (var { id: d, url: c } of e.siteApps) l(d);
    } else ss.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
  }
} }, kP = { tracingHeaders: class {
  constructor(e) {
    this.ls = void 0, this.us = void 0, this.Lr = () => {
      var n, r;
      wt(this.ls) && ((n = qt.__PosthogExtensions__) == null || (n = n.tracingHeadersPatchFns) == null || n._patchXHR(this._instance.config.__add_tracing_headers || [], this._instance.get_distinct_id(), this._instance.sessionManager)), wt(this.us) && ((r = qt.__PosthogExtensions__) == null || (r = r.tracingHeadersPatchFns) == null || r._patchFetch(this._instance.config.__add_tracing_headers || [], this._instance.get_distinct_id(), this._instance.sessionManager));
    }, this._instance = e;
  }
  initialize() {
    this.startIfEnabledOrStop();
  }
  G(e) {
    var n, r;
    (n = qt.__PosthogExtensions__) != null && n.tracingHeadersPatchFns && e(), (r = qt.__PosthogExtensions__) == null || r.loadExternalDependency == null || r.loadExternalDependency(this._instance, "tracing-headers", (a) => {
      if (a) return rP.error("failed to load script", a);
      e();
    });
  }
  startIfEnabledOrStop() {
    var e, n;
    this._instance.config.__add_tracing_headers ? this.G(this.Lr) : ((e = this.ls) == null || e.call(this), (n = this.us) == null || n.call(this), this.ls = void 0, this.us = void 0);
  }
} }, EP = pt({ surveys: class {
  constructor(e) {
    this.hs = void 0, this._surveyManager = null, this.ds = !1, this.vs = [], this.cs = null, this._instance = e, this._surveyEventReceiver = null;
  }
  initialize() {
    this.loadIfEnabled();
  }
  onRemoteConfig(e) {
    if (!this._instance.config.disable_surveys) {
      var n = e.surveys;
      if (un(n)) return An.warn("Flags not loaded yet. Not loading surveys.");
      var r = gn(n);
      this.hs = r ? n.length > 0 : n, An.info("flags response received, isSurveysEnabled: " + this.hs), this.loadIfEnabled();
    }
  }
  reset() {
    localStorage.removeItem("lastSeenSurveyDate");
    for (var e = [], n = 0; n < localStorage.length; n++) {
      var r = localStorage.key(n);
      (r != null && r.startsWith(F3) || r != null && r.startsWith("inProgressSurvey_")) && e.push(r);
    }
    e.forEach((a) => localStorage.removeItem(a));
  }
  loadIfEnabled() {
    if (!this._surveyManager) if (this.ds) An.info("Already initializing surveys, skipping...");
    else if (this._instance.config.disable_surveys) An.info("Disabled. Not loading surveys.");
    else if (this._instance.config.cookieless_mode && this._instance.consent.isOptedOut()) An.info("Not loading surveys in cookieless mode without consent.");
    else {
      var e = qt == null ? void 0 : qt.__PosthogExtensions__;
      if (e) {
        if (!wt(this.hs) || this._instance.config.advanced_enable_surveys) {
          var n = this.hs || this._instance.config.advanced_enable_surveys;
          this.ds = !0;
          try {
            var r = e.generateSurveys;
            if (r) return void this.fs(r, n);
            var a = e.loadExternalDependency;
            if (!a) return void this.ps("PostHog loadExternalDependency extension not found.");
            a(this._instance, "surveys", (o) => {
              o || !e.generateSurveys ? this.ps("Could not load surveys script", o) : this.fs(e.generateSurveys, n);
            });
          } catch (o) {
            throw this.ps("Error initializing surveys", o), o;
          } finally {
            this.ds = !1;
          }
        }
      } else An.error("PostHog Extensions not found.");
    }
  }
  fs(e, n) {
    this._surveyManager = e(this._instance, n), this._surveyEventReceiver = new lP(this._instance), An.info("Surveys loaded successfully"), this._s({ isLoaded: !0 });
  }
  ps(e, n) {
    An.error(e, n), this._s({ isLoaded: !1, error: e });
  }
  onSurveysLoaded(e) {
    return this.vs.push(e), this._surveyManager && this._s({ isLoaded: !0 }), () => {
      this.vs = this.vs.filter((n) => n !== e);
    };
  }
  getSurveys(e, n) {
    if (n === void 0 && (n = !1), this._instance.config.disable_surveys) return An.info("Disabled. Not loading surveys."), e([]);
    var r, a = this._instance.get_property(wh);
    if (a && !n) return e(a, { isLoaded: !0 });
    typeof Promise < "u" && this.cs ? this.cs.then((o) => {
      var { surveys: l, context: d } = o;
      return e(l, d);
    }) : (typeof Promise < "u" && (this.cs = new Promise((o) => {
      r = o;
    })), this._instance._send_request({ url: this._instance.requestRouter.endpointFor("api", "/api/surveys/?token=" + this._instance.config.token), method: "GET", timeout: this._instance.config.surveys_request_timeout_ms, callback: (o) => {
      var l;
      this.cs = null;
      var d = o.statusCode;
      if (d !== 200 || !o.json) {
        var c = "Surveys API could not be loaded, status: " + d;
        An.error(c);
        var f = { isLoaded: !1, error: c };
        return e([], f), void (r == null || r({ surveys: [], context: f }));
      }
      var s, h = o.json.surveys || [], g = h.filter((i) => function(m) {
        return !(!m.start_date || m.end_date);
      }(i) && (function(m) {
        var v;
        return !((v = m.conditions) == null || (v = v.events) == null || (v = v.values) == null || !v.length);
      }(i) || function(m) {
        var v;
        return !((v = m.conditions) == null || (v = v.actions) == null || (v = v.values) == null || !v.length);
      }(i)));
      g.length > 0 && ((s = this._surveyEventReceiver) == null || s.register(g)), (l = this._instance.persistence) == null || l.register({ [wh]: h });
      var t = { isLoaded: !0 };
      e(h, t), r == null || r({ surveys: h, context: t });
    } }));
  }
  _s(e) {
    for (var n of this.vs) try {
      if (!e.isLoaded) return n([], e);
      this.getSurveys(n);
    } catch (r) {
      An.error("Error in survey callback", r);
    }
  }
  getActiveMatchingSurveys(e, n) {
    if (n === void 0 && (n = !1), !un(this._surveyManager)) return this._surveyManager.getActiveMatchingSurveys(e, n);
    An.warn("init was not called");
  }
  gs(e) {
    var n = null;
    return this.getSurveys((r) => {
      var a;
      n = (a = r.find((o) => o.id === e)) !== null && a !== void 0 ? a : null;
    }), n;
  }
  bs(e) {
    if (un(this._surveyManager)) return { eligible: !1, reason: "SDK is not enabled or survey functionality is not yet loaded" };
    var n = typeof e == "string" ? this.gs(e) : e;
    return n ? this._surveyManager.checkSurveyEligibility(n) : { eligible: !1, reason: "Survey not found" };
  }
  canRenderSurvey(e) {
    if (un(this._surveyManager)) return An.warn("init was not called"), { visible: !1, disabledReason: "SDK is not enabled or survey functionality is not yet loaded" };
    var n = this.bs(e);
    return { visible: n.eligible, disabledReason: n.reason };
  }
  canRenderSurveyAsync(e, n) {
    return un(this._surveyManager) ? (An.warn("init was not called"), Promise.resolve({ visible: !1, disabledReason: "SDK is not enabled or survey functionality is not yet loaded" })) : new Promise((r) => {
      this.getSurveys((a) => {
        var o, l = (o = a.find((c) => c.id === e)) !== null && o !== void 0 ? o : null;
        if (l) {
          var d = this.bs(l);
          r({ visible: d.eligible, disabledReason: d.reason });
        } else r({ visible: !1, disabledReason: "Survey not found" });
      }, n);
    });
  }
  renderSurvey(e, n, r) {
    var a;
    if (un(this._surveyManager)) An.warn("init was not called");
    else {
      var o = typeof e == "string" ? this.gs(e) : e;
      if (o != null && o.id) if (LF.includes(o.type)) {
        var l = bt == null ? void 0 : bt.querySelector(n);
        if (l) return (a = o.appearance) != null && a.surveyPopupDelaySeconds ? (An.info("Rendering survey " + o.id + " with delay of " + o.appearance.surveyPopupDelaySeconds + " seconds"), void setTimeout(() => {
          var d, c;
          An.info("Rendering survey " + o.id + " with delay of " + ((d = o.appearance) == null ? void 0 : d.surveyPopupDelaySeconds) + " seconds"), (c = this._surveyManager) == null || c.renderSurvey(o, l, r), An.info("Survey " + o.id + " rendered");
        }, 1e3 * o.appearance.surveyPopupDelaySeconds)) : void this._surveyManager.renderSurvey(o, l, r);
        An.warn("Survey element not found");
      } else An.warn("Surveys of type " + o.type + " cannot be rendered in the app");
      else An.warn("Survey not found");
    }
  }
  displaySurvey(e, n) {
    var r;
    if (un(this._surveyManager)) An.warn("init was not called");
    else {
      var a = this.gs(e);
      if (a) {
        var o = a;
        if ((r = a.appearance) != null && r.surveyPopupDelaySeconds && n.ignoreDelay && (o = pt({}, a, { appearance: pt({}, a.appearance, { surveyPopupDelaySeconds: 0 }) })), n.displayType !== Eh.Popover && n.initialResponses && An.warn("initialResponses is only supported for popover surveys. prefill will not be applied."), n.ignoreConditions === !1) {
          var l = this.canRenderSurvey(a);
          if (!l.visible) return void An.warn("Survey is not eligible to be displayed: ", l.disabledReason);
        }
        n.displayType !== Eh.Inline ? this._surveyManager.handlePopoverSurvey(o, n) : this.renderSurvey(o, n.selector, n.properties);
      } else An.warn("Survey not found");
    }
  }
  cancelPendingSurvey(e) {
    un(this._surveyManager) ? An.warn("init was not called") : this._surveyManager.cancelSurvey(e);
  }
  handlePageUnload() {
    var e;
    (e = this._surveyManager) == null || e.handlePageUnload();
  }
} }, X0), IP = { toolbar: class {
  constructor(e) {
    this.instance = e;
  }
  ys(e) {
    qt.ph_toolbar_state = e;
  }
  ws() {
    var e;
    return (e = qt.ph_toolbar_state) !== null && e !== void 0 ? e : os.UNINITIALIZED;
  }
  initialize() {
    return this.maybeLoadToolbar();
  }
  maybeLoadToolbar(e, n, r) {
    if (e === void 0 && (e = void 0), n === void 0 && (n = void 0), r === void 0 && (r = void 0), o3(this.instance.config) || !Xe || !bt) return !1;
    e = e ?? Xe.location, r = r ?? Xe.history;
    try {
      if (!n) {
        try {
          Xe.localStorage.setItem("test", "test"), Xe.localStorage.removeItem("test");
        } catch {
          return !1;
        }
        n = Xe == null ? void 0 : Xe.localStorage;
      }
      var a, o = uP || t0(e.hash, "__posthog") || t0(e.hash, "state"), l = o ? fg(() => JSON.parse(atob(decodeURIComponent(o)))) || fg(() => JSON.parse(decodeURIComponent(o))) : null;
      return l && l.action === "ph_authorize" ? ((a = l).source = "url", a && Object.keys(a).length > 0 && (l.desiredHash ? e.hash = l.desiredHash : r ? r.replaceState(r.state, "", e.pathname + e.search) : e.hash = "")) : ((a = JSON.parse(n.getItem(Jg) || "{}")).source = "localstorage", delete a.userIntent), !(!a.token || this.instance.config.token !== a.token) && (this.loadToolbar(a), !0);
    } catch {
      return !1;
    }
  }
  Es(e) {
    var n = qt.ph_load_toolbar || qt.ph_load_editor;
    !un(n) && Hr(n) ? n(e, this.instance) : em.warn("No toolbar load function found");
  }
  loadToolbar(e) {
    var n = !(bt == null || !bt.getElementById(d3));
    if (!Xe || n) return !1;
    var r = this.instance.requestRouter.region === "custom" && this.instance.config.advanced_disable_toolbar_metrics, a = pt({ token: this.instance.config.token }, e, { apiURL: this.instance.requestRouter.endpointFor("ui") }, r ? { instrument: !1 } : {});
    if (Xe.localStorage.setItem(Jg, JSON.stringify(pt({}, a, { source: void 0 }))), this.ws() === os.LOADED) this.Es(a);
    else if (this.ws() === os.UNINITIALIZED) {
      var o;
      this.ys(os.LOADING), (o = qt.__PosthogExtensions__) == null || o.loadExternalDependency == null || o.loadExternalDependency(this.instance, "toolbar", (l) => {
        if (l) return em.error("[Toolbar] Failed to load", l), void this.ys(os.UNINITIALIZED);
        this.ys(os.LOADED), this.Es(a);
      }), Qn(Xe, "turbolinks:load", () => {
        this.ys(os.UNINITIALIZED), this.loadToolbar(a);
      });
    }
    return !0;
  }
  xs(e) {
    return this.loadToolbar(e);
  }
  maybeLoadEditor(e, n, r) {
    return e === void 0 && (e = void 0), n === void 0 && (n = void 0), r === void 0 && (r = void 0), this.maybeLoadToolbar(e, n, r);
  }
} }, TP = pt({ experiments: yi }, X0), OP = { conversations: class {
  constructor(e) {
    this.Ss = void 0, this._conversationsManager = null, this.$s = !1, this.ks = null, this._instance = e;
  }
  initialize() {
    this.loadIfEnabled();
  }
  onRemoteConfig(e) {
    if (!this._instance.config.disable_conversations) {
      var n = e.conversations;
      un(n) || (qr(n) ? this.Ss = n : (this.Ss = n.enabled, this.ks = n), this.loadIfEnabled());
    }
  }
  reset() {
    var e;
    (e = this._conversationsManager) == null || e.reset(), this._conversationsManager = null, this.Ss = void 0, this.ks = null;
  }
  loadIfEnabled() {
    if (!(this._conversationsManager || this.$s || this._instance.config.disable_conversations || o3(this._instance.config) || this._instance.config.cookieless_mode && this._instance.consent.isOptedOut())) {
      var e = qt == null ? void 0 : qt.__PosthogExtensions__;
      if (e && !wt(this.Ss) && this.Ss) if (this.ks && this.ks.token) {
        this.$s = !0;
        try {
          var n = e.initConversations;
          if (n) return this.Ps(n), void (this.$s = !1);
          var r = e.loadExternalDependency;
          if (!r) return void this.Ts("PostHog loadExternalDependency extension not found.");
          r(this._instance, "conversations", (a) => {
            a || !e.initConversations ? this.Ts("Could not load conversations script", a) : this.Ps(e.initConversations), this.$s = !1;
          });
        } catch (a) {
          this.Ts("Error initializing conversations", a), this.$s = !1;
        }
      } else Zi.error("Conversations enabled but missing token in remote config.");
    }
  }
  Ps(e) {
    if (this.ks) try {
      this._conversationsManager = e(this.ks, this._instance), Zi.info("Conversations loaded successfully");
    } catch (n) {
      this.Ts("Error completing conversations initialization", n);
    }
    else Zi.error("Cannot complete initialization: remote config is null");
  }
  Ts(e, n) {
    Zi.error(e, n), this._conversationsManager = null, this.$s = !1;
  }
  show() {
    this._conversationsManager ? this._conversationsManager.show() : Zi.warn("Conversations not loaded yet.");
  }
  hide() {
    this._conversationsManager && this._conversationsManager.hide();
  }
  isAvailable() {
    return this.Ss === !0 && !br(this._conversationsManager);
  }
  isVisible() {
    var e, n;
    return (e = (n = this._conversationsManager) == null ? void 0 : n.isVisible()) !== null && e !== void 0 && e;
  }
  sendMessage(e, n, r) {
    var a = this;
    return Br(function* () {
      return a._conversationsManager ? a._conversationsManager.sendMessage(e, n, r) : (Zi.warn("Conversations not available yet."), null);
    })();
  }
  getMessages(e, n) {
    var r = this;
    return Br(function* () {
      return r._conversationsManager ? r._conversationsManager.getMessages(e, n) : (Zi.warn("Conversations not available yet."), null);
    })();
  }
  markAsRead(e) {
    var n = this;
    return Br(function* () {
      return n._conversationsManager ? n._conversationsManager.markAsRead(e) : (Zi.warn("Conversations not available yet."), null);
    })();
  }
  getTickets(e) {
    var n = this;
    return Br(function* () {
      return n._conversationsManager ? n._conversationsManager.getTickets(e) : (Zi.warn("Conversations not available yet."), null);
    })();
  }
  requestRestoreLink(e) {
    var n = this;
    return Br(function* () {
      return n._conversationsManager ? n._conversationsManager.requestRestoreLink(e) : (Zi.warn("Conversations not available yet."), null);
    })();
  }
  restoreFromToken(e) {
    var n = this;
    return Br(function* () {
      return n._conversationsManager ? n._conversationsManager.restoreFromToken(e) : (Zi.warn("Conversations not available yet."), null);
    })();
  }
  restoreFromUrlToken() {
    var e = this;
    return Br(function* () {
      return e._conversationsManager ? e._conversationsManager.restoreFromUrlToken() : (Zi.warn("Conversations not available yet."), null);
    })();
  }
  getCurrentTicketId() {
    var e, n;
    return (e = (n = this._conversationsManager) == null ? void 0 : n.getCurrentTicketId()) !== null && e !== void 0 ? e : null;
  }
  getWidgetSessionId() {
    var e, n;
    return (e = (n = this._conversationsManager) == null ? void 0 : n.getWidgetSessionId()) !== null && e !== void 0 ? e : null;
  }
} }, FP = { logs: class {
  constructor(e) {
    var n;
    this.Rs = !1, this.Is = !1, this._instance = e, this._instance && (n = this._instance.config.logs) != null && n.captureConsoleLogs && (this.Rs = !0);
  }
  initialize() {
    this.loadIfEnabled();
  }
  onRemoteConfig(e) {
    var n, r = (n = e.logs) == null ? void 0 : n.captureConsoleLogs;
    !un(r) && r && (this.Rs = !0, this.loadIfEnabled());
  }
  reset() {
  }
  loadIfEnabled() {
    if (this.Rs && !this.Is) {
      var e = Bn("[logs]"), n = qt == null ? void 0 : qt.__PosthogExtensions__;
      if (n) {
        var r = n.loadExternalDependency;
        r ? r(this._instance, "logs", (a) => {
          var o;
          a || (o = n.logs) == null || !o.initializeLogs ? e.error("Could not load logs script", a) : (n.logs.initializeLogs(this._instance), this.Is = !0);
        }) : e.error("PostHog loadExternalDependency extension not found.");
      } else e.error("PostHog Extensions not found.");
    }
  }
} }, PP = pt({}, X0, wP, SP, _P, CP, AP, EP, kP, IP, TP, OP, FP);
Ar.__defaultExtensionClasses = pt({}, PP);
var rm, si = (rm = zo[wa] = new Ar(), function() {
  function e() {
    e.done || (e.done = !0, P3 = !1, Tn(zo, function(n) {
      n._dom_loaded();
    }));
  }
  bt != null && bt.addEventListener ? bt.readyState === "complete" ? e() : Qn(bt, "DOMContentLoaded", e, { capture: !1 }) : Xe && vt.error("Browser doesn't support `document.addEventListener` so PostHog couldn't be initialized");
}(), rm), W3 = Jr({
  client: si,
  bootstrap: void 0
});
function q3(e, n, r) {
  if (r === void 0 && (r = /* @__PURE__ */ new WeakMap()), e === n)
    return !0;
  if (typeof e != "object" || e === null || typeof n != "object" || n === null)
    return !1;
  if (r.has(e) && r.get(e) === n)
    return !0;
  r.set(e, n);
  var a = Object.keys(e), o = Object.keys(n);
  if (a.length !== o.length)
    return !1;
  for (var l = 0, d = a; l < d.length; l++) {
    var c = d[l];
    if (!o.includes(c) || !q3(e[c], n[c], r))
      return !1;
  }
  return !0;
}
function jP(e) {
  var n, r, a = e.children, o = e.client, l = e.apiKey, d = e.options, c = ut(null), f = Tt(function() {
    return o ? (l && console.warn("[PostHog.js] You have provided both `client` and `apiKey` to `PostHogProvider`. `apiKey` will be ignored in favour of `client`."), d && console.warn("[PostHog.js] You have provided both `client` and `options` to `PostHogProvider`. `options` will be ignored in favour of `client`."), o) : (l || console.warn("[PostHog.js] No `apiKey` or `client` were provided to `PostHogProvider`. Using default global `window.posthog` instance. You must initialize it manually. This is not recommended behavior."), si);
  }, [o, l, JSON.stringify(d)]);
  return ot(function() {
    if (!o) {
      var s = c.current;
      s ? (l !== s.apiKey && console.warn("[PostHog.js] You have provided a different `apiKey` to `PostHogProvider` than the one that was already initialized. This is not supported by our provider and we'll keep using the previous key. If you need to toggle between API Keys you need to control the `client` yourself and pass it in as a prop rather than an `apiKey` prop."), d && !q3(d, s.options) && si.set_config(d), c.current = {
        apiKey: l,
        options: d ?? {}
      }) : (si.__loaded && console.warn("[PostHog.js] `posthog` was already loaded elsewhere. This may cause issues."), si.init(l, d), c.current = {
        apiKey: l,
        options: d ?? {}
      });
    }
  }, [o, l, JSON.stringify(d)]), Nn.createElement(W3.Provider, { value: { client: f, bootstrap: (n = d == null ? void 0 : d.bootstrap) !== null && n !== void 0 ? n : (r = o == null ? void 0 : o.config) === null || r === void 0 ? void 0 : r.bootstrap } }, a);
}
var hd = function(e) {
  return typeof e == "function";
}, Mh = function(e, n) {
  return Mh = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, a) {
    r.__proto__ = a;
  } || function(r, a) {
    for (var o in a) Object.prototype.hasOwnProperty.call(a, o) && (r[o] = a[o]);
  }, Mh(e, n);
};
function RP(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
  Mh(e, n);
  function r() {
    this.constructor = e;
  }
  e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
}
var MP = {
  componentStack: null,
  exceptionEvent: null,
  error: null
}, DP = {
  INVALID_FALLBACK: "[PostHog.js][PostHogErrorBoundary] Invalid fallback prop, provide a valid React element or a function that returns a valid React element."
};
(function(e) {
  RP(n, e);
  function n(r) {
    var a = e.call(this, r) || this;
    return a.state = MP, a;
  }
  return n.prototype.componentDidCatch = function(r, a) {
    var o = this.props.additionalProperties, l;
    hd(o) ? l = o(r) : typeof o == "object" && (l = o);
    var d = this.context.client, c = d.captureException(r, l), f = a.componentStack;
    this.setState({
      error: r,
      componentStack: f ?? null,
      exceptionEvent: c
    });
  }, n.prototype.render = function() {
    var r = this.props, a = r.children, o = r.fallback, l = this.state;
    if (l.componentStack == null)
      return hd(a) ? a() : a;
    var d = hd(o) ? Nn.createElement(o, {
      error: l.error,
      componentStack: l.componentStack,
      exceptionEvent: l.exceptionEvent
    }) : o;
    return Nn.isValidElement(d) ? d : (console.warn(DP.INVALID_FALLBACK), Nn.createElement(Nn.Fragment, null));
  }, n.contextType = W3, n;
})(Nn.Component);
const NP = "https://us.i.posthog.com";
function LP(e) {
  let n = 2166136261;
  for (let r = 0; r < e.length; r++)
    n ^= e.charCodeAt(r), n = Math.imul(n, 16777619);
  return (n >>> 0) % 1e6 / 1e6;
}
function BP(e) {
  return typeof e == "string" && /\/signup\/[^/?#]+/.test(e);
}
function $P(e) {
  if (!e) return null;
  const n = e.properties || {};
  return [
    n.$current_url,
    n.$pathname,
    n.$referrer,
    n.current_url,
    n.pathname,
    n.referrer
  ].some(BP) ? null : e;
}
function UP(e) {
  return (n) => {
    var l, d;
    if (!n) return null;
    const r = n.event;
    if (r === "$identify" || r === "$set" || r && !r.startsWith("$")) return n;
    const a = n.distinct_id ?? ((l = n.properties) == null ? void 0 : l.$distinct_id) ?? ((d = n.properties) == null ? void 0 : d.distinct_id) ?? "";
    return a ? LP(a) < e ? n : null : n;
  };
}
function zP(e) {
  const n = typeof e == "number" && e >= 0 && e <= 1 ? UP(e) : void 0;
  return (r) => {
    const a = $P(r);
    return n ? n(a) : a;
  };
}
const E$ = ({
  projectToken: e,
  host: n = NP,
  isLoggedIn: r,
  homeData: a,
  userType: o,
  appVersion: l,
  platform: d,
  eventSampleRate: c,
  children: f
}) => {
  const s = ut(!1), h = ut(r), g = ut(void 0);
  return ot(() => {
    if (!e || s.current) return;
    const t = {
      api_host: n,
      defaults: "2026-01-30",
      // Versioned defaults: SPA pageviews, script inject in head, session/rageclick tweaks
      person_profiles: "identified_only"
      // Only create person profiles after identify(); anonymous events stay cheaper
    };
    t.before_send = zP(c), si.init(e, t), s.current = !0;
  }, [e, n, c]), ot(() => {
    var t;
    e && (r && a ? g.current !== a.current_cpa_user_uuid && (si == null || si.identify(a.current_cpa_user_uuid, {
      codebase: "liscio-frontend",
      user_type: o,
      cpa_id: a.cpa_uuid,
      firm_name: (t = a.userpilot_data) == null ? void 0 : t.firm_name,
      app_version: l,
      platform: d
    }), g.current = a.current_cpa_user_uuid) : h.current && !r && (si == null || si.reset(), g.current = void 0), h.current = r);
  }, [e, r, a, o, l, d]), e ? /* @__PURE__ */ p.jsx(jP, { client: si, children: f }) : /* @__PURE__ */ p.jsx(p.Fragment, { children: f });
}, Ic = () => ({ trackEvent: Oe(
  (n, r) => {
    if (!(!n || typeof (si == null ? void 0 : si.capture) != "function"))
      try {
        si.capture(n, r);
      } catch {
      }
  },
  []
) }), V3 = (e, n) => {
  var r, a, o, l, d, c, f;
  return {
    request_id: e.requestId,
    state: (r = e.request) == null ? void 0 : r.status,
    type: (a = e.request) == null ? void 0 : a.type,
    num_questions: (o = e.request) == null ? void 0 : o.questionsTotalCount,
    num_sections: (l = e.request) == null ? void 0 : l.sectionsIds.length,
    due_date: (d = e.request) == null ? void 0 : d.dueDate,
    percent_complete: typeof ((c = e.request) == null ? void 0 : c.questionsAnsweredCount) == "number" && typeof ((f = e.request) == null ? void 0 : f.questionsAvailableCount) == "number" ? Math.round(
      e.request.questionsAnsweredCount / e.request.questionsAvailableCount
    ) * 100 : void 0,
    ...n
  };
}, n1 = () => {
  const { trackEvent: e } = Ic(), { data: n } = xr(), r = Tt(
    () => {
      var o, l;
      return {
        role: (o = n == null ? void 0 : n.data) == null ? void 0 : o.role,
        firm_id: (l = n == null ? void 0 : n.data) == null ? void 0 : l.cpa_uuid
      };
    },
    [n]
  );
  return { trackRequestEvent: Oe(
    (o, l) => {
      e(o, {
        ...r,
        ...l
      });
    },
    [e, r]
  ) };
}, HP = () => {
  const { trackRequestEvent: e } = n1(), { requestId: n, request: r } = xi(), a = Tt(() => ({ requestId: n, request: r }), [n, r]);
  return { trackRequestStoreEvent: Oe(
    (l, d) => {
      const c = V3(a, d);
      e(l, c);
    },
    [e, a]
  ) };
}, I$ = (e) => {
  const { trackRequestEvent: n } = n1(), { data: r } = f0(e, {
    query: {
      cacheTime: 1 / 0,
      staleTime: 1 / 0,
      enabled: !!e
    }
  });
  return { trackRequestQueryEvent: Oe(
    (o, l = {}) => {
      const d = r == null ? void 0 : r.uuid;
      d && n(o, {
        request_id: d,
        type: r.type || void 0,
        due_date: (r == null ? void 0 : r.due_date) ?? void 0,
        percent_complete: (r == null ? void 0 : r.percent_complete) ?? void 0,
        state: r == null ? void 0 : r.status,
        ...l
      });
    },
    [n, r]
  ) };
};
var Ho = {}, G0 = {};
Object.defineProperty(G0, "__esModule", { value: !0 });
G0.regionAPIs = void 0;
G0.regionAPIs = /* @__PURE__ */ new Map([
  ["us", "https://api-iam.intercom.io"],
  ["eu", "https://api-iam.eu.intercom.io"],
  ["ap", "https://api-iam.au.intercom.io"]
]);
var qa = {}, WP = Mi && Mi.__awaiter || function(e, n, r, a) {
  function o(l) {
    return l instanceof r ? l : new r(function(d) {
      d(l);
    });
  }
  return new (r || (r = Promise))(function(l, d) {
    function c(h) {
      try {
        s(a.next(h));
      } catch (g) {
        d(g);
      }
    }
    function f(h) {
      try {
        s(a.throw(h));
      } catch (g) {
        d(g);
      }
    }
    function s(h) {
      h.done ? l(h.value) : o(h.value).then(c, f);
    }
    s((a = a.apply(e, n || [])).next());
  });
};
Object.defineProperty(qa, "__esModule", { value: !0 });
qa.ref = qa.init = void 0;
const sm = "_intercom_npm_loader", cc = function() {
  cc.loaderQueue(arguments);
};
cc.q = [];
cc.loaderQueue = function(e) {
  cc.q.push(e);
};
const nl = function() {
  var e, n, r = document;
  if (!r.getElementById(sm)) {
    var a = r.createElement("script");
    a.type = "text/javascript", a.async = !0, a.id = sm, a.src = "https://widget.intercom.io/widget/" + ((e = window.intercomSettings) === null || e === void 0 ? void 0 : e.app_id);
    var o = r.getElementsByTagName("script")[0];
    (n = o.parentNode) === null || n === void 0 || n.insertBefore(a, o);
  }
}, am = () => document.readyState === "complete" || document.readyState === "interactive", qP = () => WP(void 0, void 0, void 0, function* () {
  var e = window, n = e.Intercom;
  e.intercomSettings && (e.intercomSettings.installation_type = "npm-package"), typeof n == "function" ? (n("reattach_activator"), n("update", e.intercomSettings)) : (e.Intercom = cc, am() ? nl() : (document.addEventListener("readystatechange", function() {
    am() && nl();
  }), e.attachEvent ? e.attachEvent("onload", nl) : e.addEventListener("load", nl, !1)));
});
qa.init = qP;
qa.ref = void 0;
(function(e) {
  var n = Mi && Mi.__rest || function(H, B) {
    var R = {};
    for (var _ in H) Object.prototype.hasOwnProperty.call(H, _) && B.indexOf(_) < 0 && (R[_] = H[_]);
    if (H != null && typeof Object.getOwnPropertySymbols == "function")
      for (var A = 0, _ = Object.getOwnPropertySymbols(H); A < _.length; A++)
        B.indexOf(_[A]) < 0 && Object.prototype.propertyIsEnumerable.call(H, _[A]) && (R[_[A]] = H[_[A]]);
    return R;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.onUserEmailSupplied = e.showConversation = e.showTicket = e.startChecklist = e.startSurvey = e.showNews = e.showArticle = e.startTour = e.getVisitorId = e.trackEvent = e.onUnreadCountChange = e.onShow = e.onHide = e.showNewMessage = e.showMessages = e.showSpace = e.show = e.hide = e.update = e.shutdown = e.boot = e.Intercom = void 0;
  const r = G0, a = qa, o = (H, ...B) => {
    typeof window !== void 0 && window.Intercom ? window.Intercom(H, ...B) : console.warn("Please ensure Intercom is setup and running on client-side!");
  }, l = (H) => {
    if (typeof H != "object") {
      console.warn("Intercom initialiser called with invalid parameters.");
      return;
    }
    const { region: B = "us" } = H, R = n(H, ["region"]);
    typeof window < "u" && !a.ref && (window.intercomSettings = Object.assign(Object.assign({}, R), { api_base: r.regionAPIs.get(B) }), (0, a.init)());
  };
  e.Intercom = l, e.default = e.Intercom;
  const d = (H) => o("boot", H);
  e.boot = d;
  const c = () => o("shutdown");
  e.shutdown = c;
  const f = (H) => o("update", H);
  e.update = f;
  const s = () => o("hide");
  e.hide = s;
  const h = () => o("show");
  e.show = h;
  const g = (H) => o("showSpace", H);
  e.showSpace = g;
  const t = () => o("showMessages");
  e.showMessages = t;
  const i = (H) => o("showNewMessage", H);
  e.showNewMessage = i;
  const m = (H) => o("onHide", H);
  e.onHide = m;
  const v = (H) => o("onShow", H);
  e.onShow = v;
  const E = (H) => o("onUnreadCountChange", H);
  e.onUnreadCountChange = E;
  const S = (...H) => o("trackEvent", ...H);
  e.trackEvent = S;
  const y = () => o("getVisitorId");
  e.getVisitorId = y;
  const x = (H) => o("startTour", H);
  e.startTour = x;
  const b = (H) => o("showArticle", H);
  e.showArticle = b;
  const u = (H) => o("showNews", H);
  e.showNews = u;
  const I = (H) => o("startSurvey", H);
  e.startSurvey = I;
  const O = (H) => o("startChecklist", H);
  e.startChecklist = O;
  const D = (H) => o("showTicket", H);
  e.showTicket = D;
  const $ = (H) => o("showConversation", H);
  e.showConversation = $;
  const K = (H) => o("onUserEmailSupplied", H);
  e.onUserEmailSupplied = K;
})(Ho);
const VP = /* @__PURE__ */ ys(Ho), XP = () => {
  const { hostname: e } = window.location;
  if (e === "localhost" || e === "127.0.0.1")
    return e;
  const n = e.split(".");
  return n.length > 2 ? `.${n.slice(-2).join(".")}` : e;
}, GP = () => {
  const e = ["intercom-"], n = Gr.get(), r = XP();
  Object.keys(n).forEach((a) => {
    e.some((o) => a.startsWith(o)) && Gr.remove(a, { path: "/", domain: r });
  });
}, KP = 15e3, YP = "intercom_boot_failed";
let Dh = !1, ds;
const X3 = () => window.Intercom, ZP = () => {
  const e = X3();
  return !e || Array.isArray(e.q) ? "not_loaded" : "script_loaded";
}, Nh = (e, n) => {
  Dh || (Dh = !0, n && e(n));
}, Lh = () => {
  ds == null || ds();
}, QP = ({
  app: e,
  workspace: n,
  report: r
}) => {
  var l;
  if (Dh || ds)
    return;
  const a = window.setTimeout(() => {
    o(), Nh(r, {
      outcomeClass: ZP() === "script_loaded" ? "timeout" : "provider_network",
      app: e,
      workspace: n
    });
  }, KP);
  function o() {
    window.clearTimeout(a), ds === o && (ds = void 0);
  }
  ds = o, (l = X3()) == null || l("ready", () => {
    ds === o && (o(), Nh(r));
  });
}, JP = (e) => {
  const n = rf(e);
  return typeof n == "number" ? n >= 500 ? "5xx" : n >= 400 ? "4xx" : "unknown" : K8(e) && !e.response ? "network" : "unknown";
}, ej = ({
  app: e,
  workspace: n,
  error: r,
  report: a
}) => {
  Lh(), Nh(a, {
    outcomeClass: "settings_fetch_failed",
    app: e,
    workspace: n,
    httpStatusClass: JP(r)
  });
}, T$ = (e) => {
  const n = {
    provider: "intercom",
    operation: "widget_boot",
    outcome_class: e.outcomeClass,
    app: e.app,
    workspace: e.workspace
  };
  return e.httpStatusClass && (n.http_status_class = e.httpStatusClass), {
    message: YP,
    context: {
      level: "warning",
      fingerprint: ["intercom-boot", e.outcomeClass],
      tags: n
    }
  };
}, tj = {
  hideIntercom: () => {
  },
  showIntercom: () => {
  },
  checkIfIntercomIsAvailable: () => !1
}, G3 = Jr(tj), om = () => {
}, O$ = ({
  children: e,
  workspace: n,
  onBootFailure: r
}) => {
  const { isIntercomEnabled: a } = Dr(), l = !!Ls(({ auth_token: t }) => t), {
    data: d,
    isError: c,
    error: f
  } = hx(
    {
      workspace: n
    },
    { query: { enabled: l } }
  ), s = ut(r);
  s.current = r;
  const h = !On.isNativePlatform();
  ot(() => {
    l && d && a && h && d && (VP({
      app_id: d.app_id,
      intercom_user_jwt: d.intercom_user_jwt,
      hide_default_launcher: !0,
      created_at: d.created_at,
      version: d.version,
      //@ts-expect-error Intercom types are not correct
      companies: d.companies.map((t) => ({
        company_id: t.company_id,
        created_at: t.created_at,
        name: t.name,
        size: t.size,
        is_user_default_message_recipient: t.is_user_default_message_recipient,
        edoc_requests_in_last_60_days: t.edoc_requests_in_last_60_days,
        sms_enabled_user_count: t.sms_enabled_user_count,
        email_active: t.email_active,
        email_active_user_count: t.email_active_user_count,
        standard_requests_count: t.standard_requests_count,
        standard_request_last_created_at: t.standard_request_last_created_at,
        organizer_sent_count: t.organizer_sent_count,
        organizer_last_sent_at: t.organizer_last_sent_at,
        smart_delivery_sent_count: t.smart_delivery_sent_count,
        smart_delivery_last_sent_at: t.smart_delivery_last_sent_at
      }))
    }), QP({
      app: n,
      workspace: n,
      report: (t) => (s.current ?? om)(t)
    }));
  }, [
    d,
    l,
    a,
    h,
    n
  ]), ot(() => {
    l && c && a && h && ej({
      app: n,
      workspace: n,
      error: f,
      report: (t) => (s.current ?? om)(t)
    });
  }, [
    f,
    l,
    a,
    c,
    h,
    n
  ]), ot(() => Lh, []), ot(() => {
    a && !l && (Lh(), window.Intercom && Ho.shutdown(), GP());
  }, [l, a]);
  const g = Tt(
    () => ({
      hideIntercom: Ho.hide,
      showIntercom: Ho.show,
      checkIfIntercomIsAvailable: () => !!window.Intercom
    }),
    []
  );
  return /* @__PURE__ */ p.jsx(G3.Provider, { value: g, children: e });
}, nj = () => xs(G3), F$ = (e) => {
  const { checkIfIntercomIsAvailable: n, showIntercom: r } = nj(), a = On.isNativePlatform();
  return {
    openHelpCenter: Oe(() => {
      const l = n();
      if (a || !l) {
        kx.open({ url: e });
        return;
      }
      r();
    }, [
      n,
      e,
      a,
      r
    ])
  };
}, P$ = (e) => {
  const [n, r] = Ee(e), a = Tt(() => !!(Object.keys(e).length !== Object.keys(n).length || Object.keys(e).find(
    (l) => JSON.stringify(e[l]) !== JSON.stringify(n[l])
  )), [e, n]), o = Oe(
    () => r(e),
    [r, e]
  );
  return {
    filters: n,
    setFilters: r,
    hasFiltersSelected: a,
    resetFilters: o
  };
}, ij = () => {
  const e = Ki(), n = x0(), r = Oe(
    (h, g = {}) => {
      const {
        replace: t = !1,
        goBackUrl: i,
        redirectedFrom: m,
        preserveScroll: v,
        tab: E,
        state: S = {}
      } = g;
      e(h, {
        replace: t,
        state: {
          ...S,
          ...i ? { goBackUrl: i } : {},
          ...m ? { redirectedFrom: m } : {},
          ...v ? { scroll: n7() } : {},
          ...E ? { tab: E } : {}
        }
      });
    },
    [e]
  ), a = Oe(
    (h = "/") => {
      var t, i, m;
      const g = (t = n == null ? void 0 : n.state) == null ? void 0 : t.goBackUrl;
      e(g || h, {
        state: {
          scroll: (i = n == null ? void 0 : n.state) == null ? void 0 : i.scroll,
          tab: (m = n == null ? void 0 : n.state) == null ? void 0 : m.tab
        }
      });
    },
    [e, n]
  ), o = Oe(
    (h = "/") => {
      var t;
      const g = (t = n == null ? void 0 : n.state) == null ? void 0 : t.redirectedFrom;
      e(g || h, {
        replace: !0,
        state: (n == null ? void 0 : n.state) || {}
      });
    },
    [e, n]
  ), l = Oe(
    (h = "/authenticate/login") => {
      e(h, {
        replace: !0,
        state: {
          ...n.state,
          redirectedFrom: n.pathname + n.search + n.hash
        }
      });
    },
    [e, n]
  ), d = Oe((h) => {
    window.location.replace(h);
  }, []), c = Oe((h) => {
    window.location.href = h;
  }, []), f = Oe(
    (h, g = {}) => {
      On.isNativePlatform() ? window.open(h, g.target || "_self") : g.replace ? window.location.replace(h) : g.target === "_blank" ? window.open(h, "_blank") : window.location.href = h;
    },
    []
  ), s = Oe(() => {
    var h;
    return (h = n.state) == null ? void 0 : h.redirectedFrom;
  }, [n]);
  return {
    navigateTo: r,
    goBack: a,
    redirectExternal: d,
    navigateHard: c,
    openUrl: f,
    redirectToLogin: l,
    continueToOriginalDestination: o,
    getRedirectedFrom: s
  };
}, j$ = (e, n) => {
  const [r, a] = Ix(), o = Oe(() => i7(r, n), [n, r]), l = Oe(
    (g) => {
      const t = new URLSearchParams();
      Object.entries(g).forEach(([i, m]) => {
        m && t.set(i, String(m));
      }), a(t);
    },
    [a]
  ), d = Oe(() => {
    const g = sessionStorage.getItem(e);
    if (g)
      try {
        return JSON.parse(g);
      } catch (t) {
        return console.error(
          "Failed to parse stored filters from sessionStorage:",
          t
        ), {};
      }
    return {};
  }, [e]), c = Oe(
    (g) => {
      sessionStorage.setItem(e, JSON.stringify(g));
    },
    [e]
  ), f = Oe(() => {
    sessionStorage.removeItem(e);
  }, [e]), s = Oe(() => {
    const g = o();
    return { ...d(), ...g };
  }, [d, o]), h = Oe(
    (g) => {
      c(g), l(g);
    },
    [c, l]
  );
  return {
    getParametersFromUrl: o,
    setParametersInUrl: l,
    getParametersFromSessionStorage: d,
    setParametersInSessionStorage: c,
    removeParametersFromSessionStorage: f,
    getParametersFromSessionStorageAndUrl: s,
    setParametersInSessionStorageAndUrl: h
  };
};
function R$({
  dirtyFields: e,
  getValues: n,
  identity: r,
  mergeDirtyField: a,
  reset: o,
  values: l
}) {
  const d = ut(r), c = ut(e);
  c.current = e, ot(() => {
    if (!l) return;
    const f = d.current !== r, s = Object.keys(c.current);
    if (f || s.length === 0)
      o(l);
    else {
      const h = n(), g = { ...l };
      s.forEach((t) => {
        g[t] = a ? a(t, g[t], h[t]) : h[t];
      }), o(g, { keepDirty: !0, keepTouched: !0 });
    }
    d.current = r;
  }, [n, r, a, o, l]);
}
const Er = /* @__PURE__ */ new WeakMap(), rj = 5 * 60 * 1e3, sj = (e, n) => {
  const r = Er.get(e);
  if ((r == null ? void 0 : r.scope) !== n) {
    if ((r == null ? void 0 : r.scope) === void 0) {
      Er.set(e, { ...r, scope: n });
      return;
    }
    Er.set(e, { scope: n });
  }
}, aj = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{6}Z$/, K3 = (e) => {
  if (e === void 0) return !0;
  if (e === null || !aj.test(e))
    return !1;
  const n = e.replace(
    /\.(\d{3})\d{3}Z$/,
    ".$1Z"
  ), r = Date.parse(n);
  return !Number.isNaN(r) && new Date(r).toISOString() === n;
}, oj = (e) => K3(e.count_snapshot_at) && (e.count_snapshot_at === void 0 || typeof e.inbox_count == "number" && typeof e.sent_count == "number" && typeof e.draft_count == "number" && typeof e.archive_count == "number" && typeof e.alert_count == "number" && typeof e.pinned_count == "number"), cj = (e, n) => {
  const r = Er.get(e);
  if (n === void 0)
    return (r == null ? void 0 : r.authoritativeReceivedAt) !== void 0 && Date.now() - r.authoritativeReceivedAt < rj ? !1 : ((r == null ? void 0 : r.countSnapshotAt) !== void 0 && Er.set(e, { scope: r.scope }), !0);
  if (n === null || !K3(n))
    return !1;
  const a = Date.now();
  return (r == null ? void 0 : r.countSnapshotAt) !== void 0 && n <= r.countSnapshotAt ? (Er.set(e, {
    ...r,
    authoritativeReceivedAt: a
  }), !1) : (Er.set(e, {
    ...r,
    countSnapshotAt: n,
    authoritativeReceivedAt: a
  }), !0);
}, lj = (e) => {
  if (!(!e.count_snapshot_at || typeof e.inbox_count != "number" || typeof e.sent_count != "number" || typeof e.draft_count != "number" || typeof e.archive_count != "number" || typeof e.alert_count != "number" || typeof e.pinned_count != "number"))
    return {
      inbox_count: e.inbox_count,
      sent_count: e.sent_count,
      draft_count: e.draft_count,
      archive_count: e.archive_count,
      alert_count: e.alert_count,
      pinned_count: e.pinned_count,
      count_snapshot_at: e.count_snapshot_at
    };
}, uj = (e, n) => {
  const r = lj(n), o = oj(n) && cj(e, n.count_snapshot_at), l = Er.get(e);
  return o ? (r && Er.set(e, {
    ...l,
    counts: r
  }), {
    data: n,
    tabCountsAccepted: !0,
    hasRetainedTabCounts: !!(n.count_snapshot_at || l != null && l.counts)
  }) : {
    data: l != null && l.counts ? { ...n, ...l.counts } : n,
    tabCountsAccepted: !1,
    hasRetainedTabCounts: !!(l != null && l.counts)
  };
}, dj = (e, n) => {
  var l;
  if (!e) return e;
  const r = ((l = n.inbox) == null ? void 0 : l.map((d) => d.thread_id)) || [], a = n.read_status === !0, o = (d) => d == null ? void 0 : d.map(
    (c) => r.includes(c == null ? void 0 : c.thread_id) ? { ...c, read: a } : c
  );
  return e.pages ? {
    ...e,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    pages: e.pages.map((d) => ({
      ...d,
      inbox: o(d.inbox),
      sent: o(d.sent),
      archive: o(d.archive),
      alert: o(d.alert),
      pinned: o(d.pinned),
      all_messages: o(d.all_messages)
    }))
  } : {
    ...e,
    inbox: o(e.inbox),
    sent: o(e.sent),
    archive: o(e.archive),
    alert: o(e.alert),
    pinned: o(e.pinned),
    all_messages: o(e.all_messages)
  };
}, hj = (e, n) => e && typeof e == "object" ? { ...e, ...n } : n;
function M$({
  consumer: e,
  cpaUserId: n,
  enabled: r = !0
}) {
  const a = ut(!1), o = ut(!1), l = qn();
  ot(() => {
    if (!r || !n || (sj(l, String(n)), a.current && o.current))
      return;
    const d = e.subscriptions.create(
      {
        channel: "MessageChannel",
        cpa_user_id: n
      },
      {
        connected: () => {
          a.current = !0;
        },
        received: (f) => {
          f && (f.read_status === !0 ? l.setQueriesData(
            { queryKey: ["messages"] },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (s) => dj(s, f)
          ) : l.invalidateQueries({ queryKey: ["messages"] }), f.unread_thread_count !== void 0 && l.invalidateQueries({ queryKey: ["unreadCount"] }));
        },
        disconnected: () => {
          a.current = !1;
        }
      }
    ), c = e.subscriptions.create(
      {
        channel: "MessageCountChannel",
        cpa_user_id: n
      },
      {
        connected: () => {
          o.current = !0;
        },
        received: (f) => {
          if (typeof f == "object" && f !== null && "broadcast_version" in f) {
            const h = uj(
              l,
              f
            ), g = h.data, t = typeof g.unread_thread_count == "number" || g.unread_thread_count === !1 ? g.unread_thread_count : void 0;
            l.setQueryData(
              ["messageCounts", void 0],
              (i) => h.tabCountsAccepted ? hj(i, g) : i && typeof i == "object" ? {
                ...i,
                ...t !== void 0 && {
                  unread_thread_count: t
                }
              } : h.hasRetainedTabCounts ? {
                ...g,
                ...t !== void 0 && {
                  unread_thread_count: t
                }
              } : t !== void 0 ? { unread_thread_count: t } : i
            ), l.setQueriesData(
              {
                queryKey: ["messages"],
                predicate: (i) => {
                  var m;
                  return ((m = i.meta) == null ? void 0 : m.messageCountsScope) === "unfiltered";
                }
              },
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              (i) => i && (i.pages ? {
                ...i,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                pages: i.pages.map((m, v) => v === 0 ? {
                  ...m,
                  ...h.tabCountsAccepted && {
                    inbox_count: g.inbox_count,
                    sent_count: g.sent_count,
                    draft_count: g.draft_count,
                    archive_count: g.archive_count,
                    alert_count: g.alert_count,
                    pinned_count: g.pinned_count,
                    count_snapshot_at: g.count_snapshot_at
                  },
                  ...t !== void 0 && {
                    unread_thread_count: t
                  }
                } : m)
              } : {
                ...i,
                ...h.tabCountsAccepted && {
                  inbox_count: g.inbox_count,
                  sent_count: g.sent_count,
                  draft_count: g.draft_count,
                  archive_count: g.archive_count,
                  alert_count: g.alert_count,
                  pinned_count: g.pinned_count,
                  count_snapshot_at: g.count_snapshot_at
                },
                ...t !== void 0 && {
                  unread_thread_count: t
                }
              })
            );
          } else
            l.invalidateQueries({ queryKey: ["messages"] }), l.invalidateQueries({ queryKey: ["messageCounts"] });
        },
        disconnected: () => {
          o.current = !1;
        }
      }
    );
    return () => {
      d && (d.unsubscribe(), a.current = !1), c && (c.unsubscribe(), o.current = !1), Er.delete(l);
    };
  }, [e, n, r, l]);
}
const i1 = ({ file: e, retrievalToken: n, fileName: r }) => {
  const a = Oe(
    (t) => {
      if (t != null && t.signed_url) {
        const i = document.createElement("a");
        i.href = t.signed_url, i.download = (t == null ? void 0 : t.filename) || r || "download", document.body.appendChild(i), i.click(), document.body.removeChild(i);
      }
    },
    [r]
  ), { isLoading: o, refreshSignedUrl: l, setRetrievalToken: d } = es(
    n || void 0,
    {
      disposition: fx.attachment,
      onSignedUrlFetched: a
    }
  ), c = Oe(async () => {
    if (e) {
      const { onSuccess: t, onError: i } = P2(
        (e == null ? void 0 : e.doc_name) || "Your file"
      );
      await Tb(e).then(t).catch(i);
    }
  }, [e]), f = Oe(async () => {
    if (n)
      try {
        d(n), await l();
      } catch (t) {
        console.error("Error getting signed URL for download:", t);
      }
  }, [n, l, d]), s = !!n;
  if (!s && !e)
    return null;
  const h = s ? f : c, g = s ? o || !n : !e;
  return /* @__PURE__ */ p.jsxs(
    Ya,
    {
      justifyContent: "center",
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      children: [
        /* @__PURE__ */ p.jsx(Te, { variant: "label", textAlign: "center", children: "Please download the file to view the details." }),
        /* @__PURE__ */ p.jsx(
          Gn,
          {
            onClick: h,
            color: "primary",
            disabled: g,
            children: /* @__PURE__ */ p.jsx(it, { icon: "download", fontSize: "large" })
          }
        )
      ]
    }
  );
}, fj = ({ onNavigationClick: e, onSecondaryActionClick: n, children: r, title: a }) => {
  const o = /* @__PURE__ */ p.jsx(
    Gn,
    {
      "aria-label": "Navigation",
      size: "large",
      onClick: n,
      children: /* @__PURE__ */ p.jsx(it, { icon: "download" })
    }
  );
  return /* @__PURE__ */ p.jsx(
    Ys,
    {
      onNavigationClick: e,
      title: a,
      children: r,
      secondaryActionChildren: o
    }
  );
}, pj = ({
  retrievalToken: e,
  onDownloadStart: n,
  onDownloadComplete: r,
  onError: a,
  disabled: o,
  ...l
}) => {
  const d = Oe(
    (g) => {
      if (g != null && g.signed_url) {
        const t = document.createElement("a");
        t.href = g.signed_url, t.download = (g == null ? void 0 : g.filename) || "download", document.body.appendChild(t), t.click(), document.body.removeChild(t), r == null || r();
      }
    },
    [r]
  ), { isLoading: c, refreshSignedUrl: f, setRetrievalToken: s } = es(
    e,
    {
      disposition: fx.attachment,
      onError: a,
      onSignedUrlFetched: d
    }
  ), h = Oe(async () => {
    if (e)
      try {
        n == null || n(), s(e), await f();
      } catch (g) {
        console.error("Error getting signed URL for download:", g), a == null || a();
      }
  }, [
    e,
    f,
    s,
    n,
    a
  ]);
  return /* @__PURE__ */ p.jsx(ja, { title: "Download", children: /* @__PURE__ */ p.jsx("span", { children: /* @__PURE__ */ p.jsx(
    Gn,
    {
      onClick: h,
      disabled: o || c,
      size: "small",
      ...l,
      children: /* @__PURE__ */ p.jsx(it, { icon: "download" })
    }
  ) }) });
}, gj = tt(no)({
  // Needed for better rendering within scrollable containers
  ".pdf-preview-container": {
    overflow: "none"
  }
}), Y3 = ({
  documentId: e,
  ...n
}) => {
  const { data: r, isFetching: a } = Hx(String(e));
  return /* @__PURE__ */ p.jsxs(Me, { ...n, children: [
    (r == null ? void 0 : r.file_type) === "PDF" && !a && /* @__PURE__ */ p.jsx(Me, { width: "100%", minWidth: "70vw", children: /* @__PURE__ */ p.jsx(
      gj,
      {
        url: r.file_download_url,
        maxHeight: "calc(var(--liscio-app-viewport-height, 100vh) - 150px)"
      }
    ) }),
    (r == null ? void 0 : r.file_type) !== "PDF" && !a && /* @__PURE__ */ p.jsx(i1, { file: r }),
    /* @__PURE__ */ p.jsx(mi, { open: a })
  ] });
}, mj = ({
  fileSrc: e,
  mimeType: n
}) => /^image\//.test(n) ? /* @__PURE__ */ p.jsx(Me, { component: "img", src: e, width: "100%" }) : n === "application/pdf" ? /* @__PURE__ */ p.jsx(Me, { width: "100%", minWidth: "70vw", children: /* @__PURE__ */ p.jsx(no, { url: e, height: "60vh" }) }) : /* @__PURE__ */ p.jsx(Me, { display: "flex", width: "100%", p: 4, children: /* @__PURE__ */ p.jsxs(Te, { children: [
  "Preview is not available for files of type ",
  n
] }) }), xj = 1500, fd = 10, bj = new Error(
  "The file is still being prepared. Please close and try again."
), D$ = ({
  documentId: e,
  open: n,
  closeFunction: r,
  canMutateFile: a = !0,
  labelledActions: o = !1
}) => {
  const [l, d] = Ee(!1), [c, f] = Ee(0), {
    data: s,
    isFetching: h,
    isError: g,
    error: t,
    refetch: i
  } = Hx(String(e));
  ot(() => {
    f(0);
  }, [e, n]), ot(() => {
    if (!n || !e || s || h || g || c >= fd)
      return;
    const E = window.setTimeout(() => {
      f((S) => S + 1), i();
    }, xj);
    return () => window.clearTimeout(E);
  }, [
    e,
    s,
    c,
    g,
    h,
    n,
    i
  ]);
  const m = !s && !g && c < fd, v = !s && !g && c >= fd;
  return g && t || v ? /* @__PURE__ */ p.jsx(ms, { open: n, children: /* @__PURE__ */ p.jsxs(Xr, { children: [
    /* @__PURE__ */ p.jsx(
      Kr,
      {
        onNavigationClick: r,
        DefaultStateElement: cp,
        title: "File",
        hideSecondaryActionButton: !0
      }
    ),
    /* @__PURE__ */ p.jsx(
      El,
      {
        title: "Unable to load file",
        error: t ?? bj,
        onClose: r
      }
    )
  ] }) }) : /* @__PURE__ */ p.jsxs(ms, { open: n, children: [
    /* @__PURE__ */ p.jsxs(Xr, { children: [
      /* @__PURE__ */ p.jsx(
        Kr,
        {
          onNavigationClick: r,
          DefaultStateElement: o ? mS : cp,
          title: s == null ? void 0 : s.doc_name,
          hideSecondaryActionButton: !s,
          onSecondaryActionClick: () => d(!0)
        }
      ),
      (s == null ? void 0 : s.file_type) === "PDF" && !h && /* @__PURE__ */ p.jsx(no, { url: s.file_download_url }),
      (s == null ? void 0 : s.file_type) !== "PDF" && !h && /* @__PURE__ */ p.jsx(i1, { file: s })
    ] }),
    !!s && /* @__PURE__ */ p.jsx(
      q_,
      {
        file: s,
        open: l,
        onClose: () => d(!1),
        closeFilePreviewFunction: r,
        canMutateFile: a && DC(s)
      }
    ),
    /* @__PURE__ */ p.jsx(mi, { open: h || m })
  ] });
}, Z3 = ({
  file: e,
  ...n
}) => {
  const { isReading: r, dataURL: a } = Z_(e);
  return /* @__PURE__ */ p.jsxs(Me, { ...n, children: [
    r && /* @__PURE__ */ p.jsx(nf, { variant: "indeterminate" }),
    a && /* @__PURE__ */ p.jsx(mj, { fileSrc: a, mimeType: e.type })
  ] });
}, N$ = ({
  title: e,
  onClose: n,
  url: r,
  isOpen: a
}) => /* @__PURE__ */ p.jsx(
  oi,
  {
    open: a,
    onClose: n,
    title: e,
    contentProps: { sx: { p: 0 } },
    fullScreen: !0,
    children: /* @__PURE__ */ p.jsx(OS, { title: e || "File", url: r })
  }
), L$ = ({
  isOpen: e,
  url: n,
  onClose: r,
  title: a
}) => {
  const o = Math.floor(Math.random() * 1e4), l = a || `document-${o}.pdf`;
  return /* @__PURE__ */ p.jsx(ms, { open: e, children: /* @__PURE__ */ p.jsxs(Xr, { children: [
    /* @__PURE__ */ p.jsx(
      Kr,
      {
        onNavigationClick: r,
        title: a,
        DefaultStateElement: fj,
        onSecondaryActionClick: () => Ob({
          downloadUrl: n,
          fileName: l,
          openInNewTab: !0
        })
      }
    ),
    /* @__PURE__ */ p.jsx(no, { url: n })
  ] }) });
}, B$ = (e, n) => {
  const r = n ?? {}, a = typeof r.name == "string" && /^\w+$/.test(r.name) ? r.name : "Error", o = typeof r.status == "number" ? ` ${r.status}` : "", l = new Error(`PDF viewer ${e} failed: ${a}${o}`);
  if (l.name = "PdfViewerError", typeof r.stack == "string") {
    const d = r.stack.split(`
`).filter((c) => /^\s+at /.test(c));
    d.length > 0 && (l.stack = [
      `${l.name}: ${l.message}`,
      ...d
    ].join(`
`));
  }
  return {
    error: l,
    context: {
      fingerprint: ["pdf-document-viewer", e, a],
      tags: { component: "PdfDocumentViewer", operation: e }
    }
  };
}, $$ = ({
  documentIds: e = [],
  onCancel: n,
  disabled: r,
  ...a
}) => {
  const { isLoading: o, data: l } = Wx(e), d = Tt(
    () => (l == null ? void 0 : l.documents) || [],
    [l == null ? void 0 : l.documents]
  ), [c, f] = Ee(), s = Tt(() => {
    if (c)
      return d.find((h) => h.id === c);
  }, [c, d]);
  return e.length > 0 ? /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsxs(Pe, { gap: 1, ...a, children: [
      o && e.map((h) => /* @__PURE__ */ p.jsx(Vs, { variant: "rectangular" }, h)),
      !o && d.length > 0 && d.map((h) => /* @__PURE__ */ p.jsx(
        d0,
        {
          disabled: r,
          filename: h.doc_name || "",
          mimeType: h.content_type,
          size: h.file_size || 0,
          onClick: () => f(h.id),
          onCancel: n ? () => n(h) : void 0
        },
        h.uuid
      ))
    ] }),
    /* @__PURE__ */ p.jsx(
      oi,
      {
        open: !!s,
        title: s == null ? void 0 : s.doc_name,
        onClose: () => f(void 0),
        contentProps: { sx: { p: 0 } },
        maxWidth: !1,
        children: c && /* @__PURE__ */ p.jsx(Y3, { documentId: c })
      }
    )
  ] }) : null;
}, yj = (e) => `Unsupported Files: ${e.map((n) => {
  var r;
  return ((r = n == null ? void 0 : n.file) == null ? void 0 : r.name) || "";
}).join(", ")}`, r1 = ({
  url: e,
  options: n
} = {}) => {
  const r = x0(), a = Ki(), o = tc((g) => g.addFiles), l = r.pathname !== e ? r.pathname : void 0, d = n == null ? void 0 : n.onDropAccepted, c = Oe(
    (g, t) => {
      o(g, l), d && d(g, t), e && r.pathname !== e && a(e);
    },
    [o, d, a, r.pathname, e, l]
  ), f = n == null ? void 0 : n.onDropRejected, s = Oe(
    (g, t) => {
      if (f) {
        f(g, t);
        return;
      }
      Tl.error(yj(g));
    },
    [f]
  );
  return fc({
    accept: vc,
    ...n,
    onDropAccepted: c,
    onDropRejected: s
  });
}, vj = tt(Me)(({ theme: e }) => ({
  backgroundColor: e.palette.success.main,
  opacity: 0.5,
  position: "absolute",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  zIndex: e.zIndex.tooltip
})), U$ = ({
  url: e,
  options: n,
  children: r,
  activeDragComponent: a = /* @__PURE__ */ p.jsx(vj, {}),
  ...o
}) => {
  const { clientFileUploadRedesign: l } = Dr(), { getRootProps: d, getInputProps: c, isDragActive: f } = r1(
    {
      url: e,
      options: {
        noClick: !0,
        ...n
      }
    }
  );
  return l ? /* @__PURE__ */ p.jsxs(
    Me,
    {
      "data-testid": "global-file-drop",
      position: "relative",
      display: "flex",
      flex: 1,
      ...o,
      ...d(),
      children: [
        /* @__PURE__ */ p.jsx("input", { ...c() }),
        r,
        f && a
      ]
    }
  ) : r;
}, z$ = (e = []) => {
  const n = x0(), r = tc((o) => o.clearFiles), a = ut();
  ot(() => {
    const o = e.some(
      (d) => v1(d, n.pathname)
    ), l = a.current ? e.some((d) => v1(d, a.current || "")) : !1;
    n.pathname !== a.current && l && !o && r(), a.current = n.pathname;
  }, [n.pathname, r, e]);
}, wj = ({
  url: e
}) => {
  const n = x0(), r = Ki(), a = tc((c) => c.addFiles), o = n.pathname !== e ? n.pathname : void 0, { open: l } = Wf({
    onScan: (c) => {
      Hf(c).then((f) => {
        d([f]);
      });
    }
  }), d = Oe(
    (c) => {
      a(c, o), e && n.pathname !== e && r(e);
    },
    [a, o, n.pathname, r, e]
  );
  return {
    openScanner: l
  };
}, Sj = tt(oi)({
  "& .MuiTypography-h5": {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  }
}), _j = tt(lt)(({ theme: e }) => ({
  margin: "0 auto",
  width: "100%",
  backgroundColor: e.palette.common.tertiary[400]
})), H$ = ({
  onBrowse: e = () => {
  }
}) => {
  var u, I, O;
  const n = _s(), { files: r, deleteFile: a } = $0(), { getInputProps: o } = r1({
    url: (u = n.filesNew) == null ? void 0 : u.link()
  }), [l, d] = Ee(), [c, f] = Ee(!1), s = Tt(() => {
    if (l !== void 0)
      return r[l];
  }, [l, r]), h = () => f(!1), g = (D) => {
    d(D), f(!0);
  }, t = Oe(() => {
    l !== void 0 && (f(!1), d(void 0), a(l));
  }, [l, a]), [i, m] = Ee(), [v, E] = Ee(!1), S = (D) => {
    m(D), E(!0);
  }, y = () => E(!1), x = Tt(() => {
    if (i !== void 0)
      return r[i];
  }, [i, r]), {
    formState: { errors: b }
  } = Rr();
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsx(
      Zm,
      {
        error: (I = b == null ? void 0 : b.files) == null ? void 0 : I.message,
        fullWidth: !0,
        "data-testid": "upload-files-list",
        onClick: (D) => r7(D),
        children: /* @__PURE__ */ p.jsx(
          Xo,
          {
            onBrowse: e,
            attachments: r.map((D, $) => ({
              filename: D.file.name,
              mimeType: D.file.type,
              size: D.file.size,
              onCancel: () => g($),
              onClick: () => S($)
            })),
            children: /* @__PURE__ */ p.jsx("input", { "data-testid": "upload-files-input", ...o() })
          }
        )
      }
    ),
    /* @__PURE__ */ p.jsx(
      oi,
      {
        title: "Delete Attachment",
        open: !!(s && c),
        onClose: h,
        onCancel: h,
        cancelLabel: "No",
        onSubmit: t,
        submitLabel: "Yes",
        children: /* @__PURE__ */ p.jsxs(Te, { children: [
          "You are about to delete the attached file",
          " ",
          /* @__PURE__ */ p.jsx("b", { children: s == null ? void 0 : s.file.name }),
          ". This action cannot be undone. Proceed?"
        ] })
      }
    ),
    /* @__PURE__ */ p.jsxs(
      Sj,
      {
        maxWidth: !1,
        title: ((O = x == null ? void 0 : x.file) == null ? void 0 : O.name) || "File Preview",
        open: !!(x && v),
        onClose: y,
        children: [
          x && /* @__PURE__ */ p.jsx(Z3, { file: x.file }),
          /* @__PURE__ */ p.jsx(_j, { onClick: y, variant: "contained", children: "Close" })
        ]
      }
    )
  ] });
}, Q3 = ({
  uploadBatch: e
}) => {
  const n = Tt(
    () => e.files.reduce((a, o) => o.progress === 1 ? a + 1 : a, 0),
    [e.files]
  ), r = e.files.length;
  return /* @__PURE__ */ p.jsx(Me, { children: /* @__PURE__ */ p.jsxs(Te, { variant: "body1", children: [
    n,
    "/",
    r,
    " : ",
    cf(e.batchSize)
  ] }) });
}, Cj = tt(bs)({
  padding: 0
}), Aj = ({
  fileItem: e
}) => {
  const n = e.error;
  return /* @__PURE__ */ p.jsx(Cj, { children: /* @__PURE__ */ p.jsxs(
    Pe,
    {
      flex: 1,
      width: "100%",
      padding: (r) => r.spacing(1),
      color: (r) => n ? r.palette.error.main : void 0,
      bgcolor: (r) => n ? r.palette.common.error[50] : void 0,
      borderRadius: 1,
      children: [
        /* @__PURE__ */ p.jsxs(Me, { display: "flex", gap: 2, alignItems: "center", width: "100%", children: [
          /* @__PURE__ */ p.jsx(T5, { mimeType: e.file.type }),
          /* @__PURE__ */ p.jsx(Te, { noWrap: !0, overflow: "hidden", children: e.file.name })
        ] }),
        /* @__PURE__ */ p.jsx(Me, { children: /* @__PURE__ */ p.jsx(Te, { variant: "body1", children: cf(e.file.size) }) }),
        /* @__PURE__ */ p.jsx(Me, { flex: 1, children: /* @__PURE__ */ p.jsx(
          Qh,
          {
            value: Math.round(e.progress * 100),
            color: n ? "error" : "secondary"
          }
        ) })
      ]
    }
  ) });
}, kj = tt(Gs)({ maxHeight: "100%", overflow: "auto" }), J3 = ({
  files: e
}) => /* @__PURE__ */ p.jsx(kj, { children: e.map((n, r) => /* @__PURE__ */ p.jsx(
  Aj,
  {
    fileItem: n
  },
  `${r}-${n.file.name}`
)) }), Ej = ({
  uploadBatch: e
}) => e.error ? /* @__PURE__ */ p.jsxs(
  Te,
  {
    color: (n) => n.palette.error.main,
    variant: "body1",
    display: "flex",
    alignItems: "center",
    gap: 1,
    children: [
      /* @__PURE__ */ p.jsx(it, { icon: "error" }),
      " Uploads Not Completed"
    ]
  }
) : e.isSuccess ? /* @__PURE__ */ p.jsxs(
  Te,
  {
    color: (n) => n.palette.success.main,
    variant: "body1",
    display: "flex",
    alignItems: "center",
    gap: 1,
    children: [
      /* @__PURE__ */ p.jsx(it, { icon: "success" }),
      " Upload complete!"
    ]
  }
) : /* @__PURE__ */ p.jsx(Te, { variant: "body1", children: "Files uploading..." }), Ij = tt(Pe)({
  position: "fixed",
  right: 32,
  bottom: 32,
  width: 320
}), Tj = ({
  uploadBatchKey: e,
  onRetry: n
}) => {
  const [r, a] = Ee(void 0), { uploads: o, deleteUploadBatch: l, retryUpload: d, cancelAndDeleteUpload: c } = $0({ uploadBatchKey: e }), f = n ?? d, s = (h) => {
    a(r === h ? void 0 : h);
  };
  return /* @__PURE__ */ p.jsx(Ij, { gap: 2, children: o.map((h) => /* @__PURE__ */ p.jsx(hc, { elevation: 3, children: /* @__PURE__ */ p.jsxs(Me, { children: [
    /* @__PURE__ */ p.jsx(
      yd,
      {
        expanded: r === h.id,
        onClick: () => s(h.id),
        summary: /* @__PURE__ */ p.jsxs(Me, { px: 2, pt: 1, pb: 0, children: [
          /* @__PURE__ */ p.jsx(Ej, { uploadBatch: h }),
          /* @__PURE__ */ p.jsx(Q3, { uploadBatch: h })
        ] }),
        square: !1,
        summaryProps: {
          sx: {
            border: "none",
            pr: 2,
            "& .MuiAccordionSummary-content": { margin: 0 }
          }
        },
        detailsProps: {
          sx: (g) => ({
            maxHeight: `calc(100vh - ${g.spacing(24)})`,
            overflow: "auto",
            border: "none"
          })
        },
        children: /* @__PURE__ */ p.jsx(J3, { files: h.files })
      }
    ),
    r !== h.id && /* @__PURE__ */ p.jsx(Me, { p: 2, pt: 0, pb: 1, children: /* @__PURE__ */ p.jsx(
      Qh,
      {
        value: Math.round(h.progress * 100)
      }
    ) }),
    h.isSuccess && /* @__PURE__ */ p.jsx(Me, { px: 2, pb: 1, children: /* @__PURE__ */ p.jsx(
      lt,
      {
        onClick: () => l(h.id),
        variant: "outlined",
        fullWidth: !0,
        children: "Close"
      }
    ) }),
    h.error && h.retryable === !1 && /* @__PURE__ */ p.jsxs(Me, { sx: { px: 2, pb: 1 }, children: [
      /* @__PURE__ */ p.jsx(Te, { role: "alert", children: h.error }),
      /* @__PURE__ */ p.jsx(
        lt,
        {
          variant: "outlined",
          fullWidth: !0,
          onClick: () => l(h.id),
          children: "Close"
        }
      )
    ] }),
    h.error && h.retryable !== !1 && /* @__PURE__ */ p.jsxs(Pe, { px: 2, pb: 1, direction: "row", gap: 2, children: [
      /* @__PURE__ */ p.jsx(Me, { flex: 1, children: /* @__PURE__ */ p.jsx(
        lt,
        {
          variant: "outlined",
          fullWidth: !0,
          size: "small",
          onClick: () => c(h.id),
          children: "Cancel"
        }
      ) }),
      /* @__PURE__ */ p.jsx(Me, { flex: 1, children: /* @__PURE__ */ p.jsx(
        lt,
        {
          variant: "contained",
          fullWidth: !0,
          startIcon: /* @__PURE__ */ p.jsx(it, { icon: "retry" }),
          size: "small",
          color: "error",
          onClick: () => f(h.id),
          children: "Retry"
        }
      ) })
    ] })
  ] }) }, h.id)) });
}, Oj = ({
  uploadBatchKey: e,
  onRetry: n
}) => {
  const r = Mr(), { uploads: a, deleteUploadBatch: o, retryUpload: l, cancelAndDeleteUpload: d } = $0({ uploadBatchKey: e }), c = n ?? l, f = a[0], [s, h] = Ee(!1), g = () => h(!0), t = (E) => {
    h(!1), d(E);
  }, i = (E) => {
    o(E), h(!1);
  }, m = (E) => {
    d(E), h(!1);
  }, v = (E) => {
    c(E), h(!1);
  };
  return f ? /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsxs(Xr, { sx: { zIndex: r.zIndex.appBar + 1 }, children: [
      /* @__PURE__ */ p.jsx(
        Kr,
        {
          title: "Files Uploading...",
          DefaultStateElement: Ys,
          onNavigationClick: g
        }
      ),
      /* @__PURE__ */ p.jsx(Ya, { children: /* @__PURE__ */ p.jsxs(Pe, { p: 2, gap: 2, children: [
        /* @__PURE__ */ p.jsx(Q3, { uploadBatch: f }),
        /* @__PURE__ */ p.jsx(J3, { files: f.files })
      ] }) })
    ] }),
    /* @__PURE__ */ p.jsx(
      pu,
      {
        type: "success",
        title: "Upload Completed Successfully!",
        open: f.isSuccess,
        onConfirm: () => i(f.id),
        confirmLabel: "Done"
      }
    ),
    /* @__PURE__ */ p.jsx(
      pu,
      {
        type: "error",
        title: "Upload Not Completed",
        open: !!f.error && !f.isUploadingBatch,
        onCancel: f.retryable === !1 ? void 0 : () => m(f.id),
        onConfirm: () => f.retryable === !1 ? i(f.id) : v(f.id),
        confirmLabel: f.retryable === !1 ? "Close" : "Retry",
        children: f.retryable === !1 ? f.error : "An error occurred and your action couldn't be completed. Please try again, and if this keeps happening, contact our support team for help."
      }
    ),
    /* @__PURE__ */ p.jsx(
      pu,
      {
        type: "warning",
        title: "Active Uploads in Progress",
        open: s && f.isUploadingBatch,
        cancelLabel: "Stay",
        onCancel: () => h(!1),
        confirmLabel: "Yes, Cancel",
        onConfirm: () => t(f.id),
        children: "There are active uploads in progress. Navigating away from this screen will cancel them."
      }
    )
  ] }) : null;
}, W$ = ({
  uploadBatchKey: e,
  onRetry: n
}) => {
  const { isMobile: r } = ri(), { uploadInProgress: a } = $0({ uploadBatchKey: e });
  return s7(a), r ? /* @__PURE__ */ p.jsx(
    Oj,
    {
      uploadBatchKey: e,
      onRetry: n
    }
  ) : /* @__PURE__ */ p.jsx(
    Tj,
    {
      uploadBatchKey: e,
      onRetry: n
    }
  );
};
function q$({
  open: e,
  handleClose: n,
  url: r
}) {
  const { getInputProps: a, open: o } = r1({
    url: r
  }), { openScanner: l } = wj({
    url: r
  }), d = () => {
    l(), n();
  }, c = () => {
    o(), n();
  };
  return /* @__PURE__ */ p.jsx(
    l9,
    {
      open: e,
      onClose: n,
      onScanDocument: d,
      onBrowseFiles: c,
      fileInputProps: a()
    }
  );
}
const Fj = Fn(No)(({ theme: e }) => ({
  height: "50px",
  backgroundColor: e.palette.common.neutrals[100],
  borderTop: `solid 1px ${e.palette.common.neutrals[200]}`
})), Pj = () => /* @__PURE__ */ p.jsx(Fj, { alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ p.jsxs(wi, { variant: "caption", children: [
  "Liscio © ",
  uf(/* @__PURE__ */ new Date(), "yyyy"),
  ". All rights reserved"
] }) }), ey = Jr({
  isDrawerOpen: !1,
  setIsDrawerOpen: () => {
  },
  mobileLayout: !1
}), jj = ({
  children: e,
  mobileLayout: n = !1
}) => {
  const [r, a] = Ee(!1);
  return /* @__PURE__ */ p.jsx(
    ey.Provider,
    {
      value: { isDrawerOpen: r, setIsDrawerOpen: a, mobileLayout: n },
      children: e
    }
  );
}, K0 = () => xs(ey), Rj = tt(Me)(({ theme: e }) => ({
  alignSelf: "center",
  paddingTop: "20px",
  paddingBottom: "20px",
  maxWidth: "160px",
  img: {
    objectFit: "contain"
  },
  [e.breakpoints.only("md")]: {
    width: "60px",
    paddingTop: "20px",
    paddingBottom: "20px",
    paddingLeft: "0px",
    paddingRight: "0px",
    textAlign: "center"
  },
  [e.breakpoints.down("md")]: {
    paddingY: "20px",
    textAlign: "center",
    img: {
      maxWidth: "80px"
    }
  }
})), Mj = tt(Me)(({ theme: e }) => ({
  maxWidth: "100%",
  height: "auto",
  [e.breakpoints.only("md")]: {
    // tablet style
  }
})), Dj = () => {
  const e = Mr(), { isTablet: n } = ri(), { mobileLayout: r } = K0(), a = n && !r ? e.assets.logo : e.assets.logoExpanded, o = On.getPlatform() === "ios" ? "62px" : "20px";
  return /* @__PURE__ */ p.jsx(Rj, { sx: { pt: o, ...n && r && { width: "auto", px: 2 } }, children: /* @__PURE__ */ p.jsx(Mj, { component: "img", src: a, alt: "logo" }) });
}, Nj = tt(Pe, {
  shouldForwardProp: (e) => e !== "forceMobileMetrics"
})(({ theme: e, forceMobileMetrics: n }) => ({
  flexGrow: 1,
  backgroundColor: e.palette.common.tertiary[500],
  color: e.palette.common.tertiaryContrast,
  width: "100%",
  [e.breakpoints.up("sm")]: {
    height: "var(--liscio-app-viewport-height, 100vh)",
    overflowY: "scroll",
    overflowX: "hidden",
    boxShadow: "2px 0px 8px 0px rgba(153, 50, 50, 0.12)",
    "&::-webkit-scrollbar": {
      width: "3px !important"
    },
    "&::-webkit-scrollbar-track": {
      boxShadow: "inset 0 0 1px hsl(206 98.8% 5.9% / 0.2)",
      WebkitBoxShadow: "inset 0 0 1px hsl(206 98.8% 5.9% / 0.2)"
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "hsl(206 98.8% 5.9% / 0.2)",
      outline: "1px solid hsl(206 98.8% 5.9% / 0.2)"
    }
  },
  [e.breakpoints.only("md")]: {
    width: "80px"
  },
  [e.breakpoints.up("lg")]: {
    width: "200px"
  },
  ...n && { width: 280, maxWidth: "100%" }
})), Lj = tt(Me)({
  marginTop: "auto"
}), cm = ({
  primaryNav: e,
  secondaryNav: n
}) => {
  const { mobileLayout: r } = K0(), { isDesktop: a } = ri();
  return /* @__PURE__ */ p.jsxs(Nj, { forceMobileMetrics: r && a, children: [
    /* @__PURE__ */ p.jsx(Dj, {}),
    /* @__PURE__ */ p.jsx(Me, { children: e }),
    /* @__PURE__ */ p.jsx(Lj, { children: n })
  ] });
}, Bj = (e) => {
  const { isDrawerOpen: n, setIsDrawerOpen: r, mobileLayout: a } = K0();
  return a ? /* @__PURE__ */ p.jsx(
    tx,
    {
      open: n,
      onClose: () => r(!1),
      onOpen: () => r(!0),
      sx: e.safeAreaInsets ? {
        "html.native-android & .MuiDrawer-paper": {
          left: "var(--safe-area-inset-left, env(safe-area-inset-left, 0px))",
          maxWidth: "calc(100vw - var(--safe-area-inset-left, env(safe-area-inset-left, 0px)) - var(--safe-area-inset-right, env(safe-area-inset-right, 0px)))"
        }
      } : void 0,
      children: /* @__PURE__ */ p.jsx(cm, { ...e })
    }
  ) : /* @__PURE__ */ p.jsx(Me, { children: /* @__PURE__ */ p.jsx(cm, { ...e }) });
}, $j = tt(ix)({
  minHeight: "var(--liscio-app-viewport-height, 100vh)",
  "@supports (height: 100dvh)": {
    minHeight: "var(--liscio-app-viewport-height, 100dvh)"
  },
  padding: 0,
  display: "flex"
}), Uj = tt(Pe)({
  height: "var(--liscio-app-viewport-height, 100vh)",
  "@supports (height: 100dvh)": {
    height: "var(--liscio-app-viewport-height, 100dvh)"
  },
  flex: 1
}), zj = tt(Me)(({ theme: e }) => ({
  height: "calc(var(--liscio-app-viewport-height, 100vh) - 50px)",
  "@supports (height: 100dvh)": {
    height: "calc(var(--liscio-app-viewport-height, 100dvh) - 50px)"
  },
  [e.breakpoints.down("md")]: {
    height: "var(--liscio-app-viewport-height, 100vh)",
    "@supports (height: 100dvh)": {
      height: "var(--liscio-app-viewport-height, 100dvh)"
    }
  },
  flex: 1,
  display: "flex",
  flexDirection: "column",
  overflow: "auto"
})), V$ = ({
  primaryNav: e,
  secondaryNav: n,
  banner: r,
  children: a = /* @__PURE__ */ p.jsx(d7, {}),
  footer: o = /* @__PURE__ */ p.jsx(Pj, {}),
  fallback: l = /* @__PURE__ */ p.jsx(mi, { open: !0 }),
  mobileLayout: d,
  constrainContentWidth: c = !1,
  safeAreaInsets: f = !1
}) => {
  const { isDesktop: s } = ri(), h = d ?? !s;
  return /* @__PURE__ */ p.jsx(jj, { mobileLayout: h, children: /* @__PURE__ */ p.jsx(
    $j,
    {
      disableGutters: !h,
      maxWidth: !1,
      className: "LayoutContainer",
      children: /* @__PURE__ */ p.jsxs(
        Pe,
        {
          direction: "row",
          className: "Stack",
          sx: {
            flex: 1,
            ...c && { minWidth: 0, maxWidth: "100%" }
          },
          children: [
            /* @__PURE__ */ p.jsx(Bj, { primaryNav: e, secondaryNav: n, safeAreaInsets: f }),
            /* @__PURE__ */ p.jsxs(
              Uj,
              {
                className: "Content",
                sx: c ? { minWidth: 0, maxWidth: "100%" } : void 0,
                children: [
                  r,
                  /* @__PURE__ */ p.jsx(
                    zj,
                    {
                      component: "main",
                      id: "body-wrapper",
                      className: "Main",
                      sx: {
                        ...d && s && {
                          height: "var(--liscio-app-viewport-height, 100vh)",
                          "@supports (height: 100dvh)": {
                            height: "var(--liscio-app-viewport-height, 100dvh)"
                          }
                        },
                        ...c && { minWidth: 0, maxWidth: "100%" }
                      },
                      children: /* @__PURE__ */ p.jsx(Nn.Suspense, { fallback: l, children: a })
                    }
                  ),
                  !h && o
                ]
              }
            )
          ]
        }
      )
    }
  ) });
}, Hj = tt(Qm, {
  shouldForwardProp: (e) => e !== "forceMobileMetrics"
})(({ theme: e, forceMobileMetrics: n }) => ({
  height: "40px",
  padding: "7px 25px 7px 34px",
  "&:hover": {
    backgroundColor: e.palette.common.tertiary[400]
  },
  "&:active": {
    backgroundColor: e.palette.common.tertiary[900]
  },
  "&.Mui-selected": {
    backgroundColor: e.palette.common.tertiary[700]
  },
  "&.Mui-selected:hover": {
    backgroundColor: e.palette.common.tertiary[700]
  },
  [e.breakpoints.only("md")]: {
    justifyContent: "center",
    padding: "0px"
  },
  [e.breakpoints.down("md")]: {
    paddingTop: "12px",
    paddingBottom: "12px"
  },
  ...n && {
    "&&": {
      width: "100%",
      minWidth: 0,
      paddingTop: e.spacing(1.5),
      paddingBottom: e.spacing(1.5),
      paddingLeft: e.spacing(4.25),
      paddingRight: e.spacing(3.125),
      justifyContent: "flex-start"
    }
  }
})), Wj = tt(Jm, {
  shouldForwardProp: (e) => e !== "forceMobileMetrics"
})(({ theme: e, forceMobileMetrics: n }) => ({
  [`& .${n5.root}`]: {
    fontSize: "1rem"
  },
  [e.breakpoints.up("md")]: {
    minWidth: "40px"
  },
  [e.breakpoints.only("md")]: {
    minWidth: "0px"
  },
  ...n && { "&&": { minWidth: e.spacing(7), flexShrink: 0 } }
})), qj = tt(Km)(({ theme: e }) => ({
  color: e.palette.common.tertiaryContrast
})), Vj = tt(Mn, {
  shouldForwardProp: (e) => e !== "forceMobileMetrics"
})(({ forceMobileMetrics: e }) => ({
  [`& .${i5.body1}`]: {
    fontSize: "12px",
    fontWeight: 600,
    fontFamily: "inherit",
    letterSpacing: "1px",
    textTransform: "uppercase",
    ...e && {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    }
  },
  ...e && {
    flex: "1 1 auto",
    minWidth: 0,
    margin: 0
  }
})), X$ = ({
  to: e,
  label: n,
  icon: r,
  closeMobileDrawerOnClick: a = !0,
  onClick: o = () => {
  },
  badgeNumber: l,
  badgeColor: d,
  start: c,
  // NOTE: This was added to appease our playwright tests
  role: f = "button",
  ...s
}) => {
  const { isTablet: h, isDesktop: g } = ri(), { setIsDrawerOpen: t, mobileLayout: i } = K0(), m = i && g, v = Oe(
    (y) => {
      o(y), a && t(!1);
    },
    [o, a, t]
  ), E = QC(
    a7((e == null ? void 0 : e.toString()) || "")
  ), S = c ? E : void 0;
  return /* @__PURE__ */ p.jsx(bs, { disablePadding: !0, children: /* @__PURE__ */ p.jsxs(
    Hj,
    {
      selected: S,
      ...s,
      to: e,
      role: f,
      onClick: v,
      forceMobileMetrics: m,
      children: [
        r !== !1 && /* @__PURE__ */ p.jsx(Wj, { forceMobileMetrics: m, children: /* @__PURE__ */ p.jsx(
          qj,
          {
            badgeContent: l ?? null,
            color: "primary",
            "data-testid": `nav-menu-badge-${n}`,
            className: "test-badge",
            sx: {
              "& .MuiBadge-badge": {
                backgroundColor: d
              }
            },
            children: r
          }
        ) }),
        (!h || i) && /* @__PURE__ */ p.jsx(Vj, { forceMobileMetrics: m, primary: n })
      ]
    }
  ) });
}, Xj = Fn(Me)(({ theme: e }) => ({
  color: e.palette.common.neutrals[500],
  ...e.typography.body1
})), Gj = Fn(Ai)(({ theme: e }) => ({
  padding: 0,
  marginRight: "4px",
  height: "24px",
  background: e.palette.common.neutrals[100],
  color: e.palette.common.neutrals[600]
})), Kj = (e, n = 150) => {
  if (!e || e.length <= n)
    return e;
  const r = e.substring(0, n * 1.5).search(/[.!?]\s/);
  if (r !== -1 && r <= n * 1.2)
    return e.substring(0, r + 1).trim();
  const a = e.substring(0, n), o = a.lastIndexOf(" ");
  return o > n * 0.8 ? a.substring(0, o).trim() + "..." : a.trim() + "...";
}, Yj = (e, n = 60) => {
  if (!e || e.length <= n)
    return e;
  const r = e.substring(0, n), a = r.lastIndexOf(" ");
  return a > n * 0.8 ? r.substring(0, a).trim() + "..." : r.trim() + "...";
}, G$ = ({
  title: e,
  snippet: n,
  isUnread: r,
  unreadRepliesCount: a
}) => {
  const o = b0(n || "").result, l = Kj(o), d = e ? Yj(e) : void 0;
  return /* @__PURE__ */ p.jsxs(Pe, { width: "100%", children: [
    /* @__PURE__ */ p.jsxs(Pe, { direction: "row", alignItems: "center", children: [
      a ? /* @__PURE__ */ p.jsx(
        Gj,
        {
          "data-testid": "unread-messages-chip",
          label: `${a} NEW`
        }
      ) : null,
      d && /* @__PURE__ */ p.jsx(Te, { variant: r ? "body2" : "body1", children: d })
    ] }),
    /* @__PURE__ */ p.jsx(Xj, { children: l })
  ] });
};
function Zj(e) {
  return e === 1 ? "1 file needs assignment." : `${e} files need assignment.`;
}
const K$ = ({
  enabled: e,
  queueLink: n
}) => {
  const { data: r } = E8({
    query: { enabled: e }
  }), a = e ? r == null ? void 0 : r.data.count : void 0, [o, l] = Ee(a), [d, c] = Ee(!1);
  ot(() => {
    a !== void 0 && l(a);
  }, [a]);
  const f = a ?? o;
  return !e || d || f === void 0 || f <= 0 ? null : /* @__PURE__ */ p.jsxs(
    Pe,
    {
      "data-testid": "fileconnect-queue-banner",
      direction: "row",
      sx: {
        alignItems: "center",
        gap: 1,
        px: 3,
        py: 1,
        bgcolor: "primary.dark",
        color: "primary.contrastText"
      },
      children: [
        /* @__PURE__ */ p.jsx(
          Me,
          {
            "aria-hidden": !0,
            sx: {
              width: 6,
              height: 6,
              flex: "none",
              borderRadius: "50%",
              bgcolor: "common.accent.500"
            }
          }
        ),
        /* @__PURE__ */ p.jsxs(Te, { variant: "body2", color: "inherit", children: [
          /* @__PURE__ */ p.jsx(Me, { component: "strong", sx: { fontWeight: "fontWeightBold" }, children: Zj(f) }),
          " ",
          "Ingested through FileConnect, not yet assigned or delivered."
        ] }),
        /* @__PURE__ */ p.jsx(
          Ii,
          {
            ...n,
            variant: "body2",
            color: "inherit",
            underline: "always",
            sx: {
              fontWeight: "fontWeightBold",
              // Legacy's global `a:hover, a:focus` rule recolors links to near the banner's background
              // and drops the underline; pin both so the link stays visible on hover and focus.
              "&:hover, &:focus": { color: "inherit", textDecoration: "underline" }
            },
            children: "Open FileConnect queue"
          }
        ),
        /* @__PURE__ */ p.jsx(
          Gn,
          {
            "aria-label": "Dismiss FileConnect banner",
            color: "inherit",
            size: "small",
            onClick: () => c(!0),
            sx: { ml: "auto" },
            children: /* @__PURE__ */ p.jsx(it, { icon: "close", fontSize: "small" })
          }
        )
      ]
    }
  );
};
function Y$({ updates: e, onLookupError: n }) {
  const [r, a] = Ee(), o = On.getPlatform(), l = o === "android" || o === "ios" ? e[o] : void 0, d = l == null ? void 0 : l.build, c = l == null ? void 0 : l.url;
  if (ot(() => {
    if (a(void 0), !On.isNativePlatform() || !Number.isSafeInteger(d) || !d || d <= 0 || !c)
      return;
    try {
      if (new URL(c).protocol !== "https:") return;
    } catch {
      return;
    }
    let s = !0;
    return (async () => {
      try {
        const { build: g } = await Go.getInfo();
        if (!s || !/^\d+$/.test(g) || Number(g) >= d)
          return;
        const t = `nativeStoreUpdateDismissed:${o}:${g}:${d}`, i = await Sa.get({ key: t });
        s && i.value !== "true" && a({ url: c, key: t });
      } catch (g) {
        s && n(g);
      }
    })(), () => {
      s = !1;
    };
  }, [o, d, c, n]), !r) return null;
  const f = () => {
    a(void 0), Sa.set({ key: r.key, value: "true" }).catch(
      n
    );
  };
  return /* @__PURE__ */ p.jsxs(
    Za,
    {
      severity: "info",
      onClose: f,
      sx: {
        position: "fixed",
        top: "var(--safe-area-inset-top, env(safe-area-inset-top, 0px))",
        left: 0,
        right: 0,
        zIndex: "appBar"
      },
      children: [
        "A newer version of this app is available.",
        " ",
        /* @__PURE__ */ p.jsx(
          Ii,
          {
            href: r.url,
            target: "_blank",
            rel: "noopener noreferrer",
            color: "inherit",
            children: "Update app"
          }
        )
      ]
    }
  );
}
const lm = ({
  name: e,
  options: n,
  control: r,
  sx: a
}) => {
  const { field: o } = Vr({ name: e, control: r });
  return /* @__PURE__ */ p.jsx(
    qs,
    {
      select: !0,
      onChange: o.onChange,
      onBlur: o.onBlur,
      value: o.value,
      ref: o.ref,
      sx: a,
      children: n.map((l) => /* @__PURE__ */ p.jsx(Rn, { value: l.value, children: l.label }, l.value))
    }
  );
}, Qj = [
  { value: "unread", label: "Unread" },
  { value: "all", label: "All" }
], Jj = [
  { value: "asc", label: "Ascending" },
  { value: "dsc", label: "Descending" }
], Z$ = ({
  onUpdate: e,
  sortOrder: n,
  filterBy: r
}) => {
  const { control: a } = mr({
    defaultValues: {
      filterBy: r,
      sortOrder: n
    }
  }), { filterBy: o, sortOrder: l } = Vy({ control: a });
  return ot(() => {
    (o !== r || l !== n) && e({ filterBy: o, sortOrder: l });
  }, [o, r, l, n, e]), /* @__PURE__ */ p.jsx(p.Fragment, { children: /* @__PURE__ */ p.jsx("form", { children: /* @__PURE__ */ p.jsxs(Pe, { direction: "row", gap: "16px", justifyContent: "flex-end", children: [
    /* @__PURE__ */ p.jsx(
      gr,
      {
        sx: { alignItems: "center", gap: "8px" },
        control: /* @__PURE__ */ p.jsx(
          lm,
          {
            sx: { width: "140px" },
            name: "filterBy",
            control: a,
            options: Qj
          }
        ),
        label: "Filter By:",
        labelPlacement: "start"
      }
    ),
    /* @__PURE__ */ p.jsx(
      gr,
      {
        sx: { alignItems: "center", gap: "8px" },
        control: /* @__PURE__ */ p.jsx(
          lm,
          {
            sx: { width: "140px" },
            name: "sortOrder",
            control: a,
            options: Jj
          }
        ),
        label: "Sort Order:",
        labelPlacement: "start"
      }
    )
  ] }) }) });
}, eR = (e) => {
  const n = e.toLowerCase();
  return n === "task" ? /* @__PURE__ */ p.jsx(it, { icon: "tasks" }) : n === "bill" ? /* @__PURE__ */ p.jsx(it, { icon: "billing" }) : /* @__PURE__ */ p.jsx(it, { icon: "inbox" });
}, tR = tt(Pe)(({ theme: e }) => ({
  "& svg": {
    width: "12px",
    "& path": {
      fill: e.palette.grey[500]
    }
  }
})), nR = tt(Te)(({ theme: e }) => ({
  color: e.palette.grey[500]
})), ty = ({ type: e }) => {
  const n = eR(e);
  return /* @__PURE__ */ p.jsxs(tR, { direction: "row", gap: "4px", alignItems: "center", children: [
    n,
    /* @__PURE__ */ p.jsx(nR, { variant: "caption", children: e })
  ] });
}, ny = (e) => {
  const n = e.type.toLowerCase();
  return n === "message" ? e.url : n === "request" ? e.url.replace("requests/", "") : n === "task" ? e.record_id : e.id;
}, iR = tt(Te)(({ theme: e }) => ({
  color: e.palette.grey[500]
})), rR = tt(Ym)({
  width: "24px",
  height: "24px"
}), Q$ = ({
  notifications: e,
  goBackUrl: n,
  getNotificationRedirectUrl: r
}) => {
  const [a] = Ix(), o = Ki(), { mutate: l } = pb(), d = (c, f) => {
    let s = c.type.toLowerCase();
    s === "wfrequest" && (s = "request"), ["request", "task reminder summary", "rfirequest"].includes(s) && !c.is_read_in_app && l(c.id), o(f, {
      state: {
        goBackUrl: `${n}?${a.toString()}`
      }
    });
  };
  return /* @__PURE__ */ p.jsxs(qh, { children: [
    /* @__PURE__ */ p.jsx(wn, {}),
    e.length === 0 && /* @__PURE__ */ p.jsx(Te, { variant: "h3", sx: { textAlign: "center", mt: 8 }, children: "The list is empty" }),
    e.map((c) => {
      const f = ny(c);
      return /* @__PURE__ */ p.jsx(Vh, { disablePadding: !0, divider: !0, children: /* @__PURE__ */ p.jsx(
        Xh,
        {
          onClick: () => d(
            c,
            r(
              c.type,
              f,
              c.url
            )
          ),
          "aria-label": "notification-button",
          children: /* @__PURE__ */ p.jsxs(Pe, { direction: "row", width: "100%", gap: "8px", children: [
            /* @__PURE__ */ p.jsxs(Pe, { alignItems: "center", mt: "8px", children: [
              /* @__PURE__ */ p.jsx(O5, { isUnread: !c.is_read_in_app }),
              /* @__PURE__ */ p.jsx(rR, { src: c.avatar })
            ] }),
            /* @__PURE__ */ p.jsxs(Pe, { width: "100%", children: [
              /* @__PURE__ */ p.jsxs(
                Pe,
                {
                  direction: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  children: [
                    /* @__PURE__ */ p.jsx(ty, { type: c.type }),
                    /* @__PURE__ */ p.jsx(iR, { variant: "caption", children: c.tym })
                  ]
                }
              ),
              /* @__PURE__ */ p.jsx(Te, { variant: "h6", children: c.sender }),
              c.title && /* @__PURE__ */ p.jsx(Te, { variant: "h6", color: "text.secondary", children: c.title }),
              /* @__PURE__ */ p.jsx(
                Te,
                {
                  variant: "h6",
                  fontWeight: 500,
                  color: "text.secondary",
                  children: b0(c.content_limit || "").result
                }
              )
            ] })
          ] })
        }
      ) }, c.id);
    })
  ] });
}, sR = () => /* @__PURE__ */ p.jsx(Me, { sx: { width: "80%", padding: "32px", margin: "auto" }, children: /* @__PURE__ */ p.jsx(Vs, {}) }), aR = () => /* @__PURE__ */ p.jsx(
  Me,
  {
    sx: {
      width: "80%",
      padding: "32px",
      margin: "auto",
      textAlign: "center"
    },
    children: /* @__PURE__ */ p.jsx(Te, { variant: "label", children: "NO NOTIFICATIONS FOUND" })
  }
), oR = tt(Te)(({ theme: e }) => ({
  color: e.palette.grey[500]
})), cR = ({
  notifications: e,
  closePreview: n,
  getNotificationRedirectUrl: r
}) => {
  const a = e.length - 1, { navigateTo: o } = ij(), { mutate: l } = pb(), d = (c, f) => {
    let s = c.type.toLowerCase();
    s === "wfrequest" && (s = "request"), ["request", "task reminder summary", "rfirequest"].includes(s) && !c.is_read_in_app && l(c.id), n(), o(f);
  };
  return /* @__PURE__ */ p.jsx(qh, { children: e.map((c, f) => {
    const s = ny(c);
    return /* @__PURE__ */ p.jsx(
      Vh,
      {
        disablePadding: !0,
        divider: f !== a,
        children: /* @__PURE__ */ p.jsx(
          Xh,
          {
            onClick: () => d(
              c,
              r(
                c.type,
                s,
                c.url
              )
            ),
            "aria-label": "notification-button",
            children: /* @__PURE__ */ p.jsxs(Pe, { width: "100%", gap: "4px", children: [
              /* @__PURE__ */ p.jsxs(
                Pe,
                {
                  direction: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  children: [
                    /* @__PURE__ */ p.jsx(ty, { type: c.type }),
                    c.tym && /* @__PURE__ */ p.jsx(oR, { variant: "caption", children: c.tym })
                  ]
                }
              ),
              /* @__PURE__ */ p.jsx(Te, { variant: "body2", children: c.sender }),
              c.title && /* @__PURE__ */ p.jsx(Te, { variant: "body1", children: c.title }),
              /* @__PURE__ */ p.jsx(Te, { variant: "body1", children: b0(c.content_limit || "").result })
            ] })
          }
        )
      },
      c.id
    );
  }) });
}, lR = tt(Pe)({
  maxHeight: "40vh",
  overflow: "auto"
}), J$ = ({
  close: e,
  goBackUrl: n,
  getNotificationRedirectUrl: r
}) => {
  const { data: a, isLoading: o } = fb({
    sortField: "id",
    sortOrder: "dsc"
  }), { mutateAsync: l, isLoading: d } = V_({
    onSuccess: e
  }), c = !(a != null && a.collection.length);
  return /* @__PURE__ */ p.jsxs(Pe, { sx: { width: "450px" }, children: [
    /* @__PURE__ */ p.jsxs(
      Pe,
      {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "8px",
        children: [
          /* @__PURE__ */ p.jsx(Te, { variant: "caption", children: `NOTIFICATIONS (${(a == null ? void 0 : a.pagination.count) || "-"})` }),
          /* @__PURE__ */ p.jsx(
            Ei,
            {
              size: "small",
              startIcon: /* @__PURE__ */ p.jsx(it, { icon: "check" }),
              onClick: () => l(),
              disabled: d,
              children: "MARK ALL AS READ"
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ p.jsx(wn, {}),
    /* @__PURE__ */ p.jsxs(lR, { children: [
      o && /* @__PURE__ */ p.jsx(sR, {}),
      !o && c && /* @__PURE__ */ p.jsx(aR, {}),
      !o && !c && /* @__PURE__ */ p.jsx(
        cR,
        {
          notifications: a == null ? void 0 : a.collection,
          closePreview: e,
          getNotificationRedirectUrl: r
        }
      )
    ] }),
    /* @__PURE__ */ p.jsx(wn, {}),
    /* @__PURE__ */ p.jsx(Ex, { to: n, onClick: e, children: /* @__PURE__ */ p.jsx(Ei, { component: "span", fullWidth: !0, children: "View all notifications" }) })
  ] });
}, uR = tt(hc)(() => ({
  padding: "16px",
  display: "flex",
  gap: "16px",
  flexDirection: "column"
})), Os = tt(Te)(({ theme: e }) => ({
  color: e.palette.common.neutrals[500]
})), Ao = tt(Pe)({
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  paddingTop: "30px",
  paddingBottom: "30px"
}), dR = tt(Pe)({
  flexDirection: "row",
  alignItems: "center",
  paddingTop: "30px",
  paddingBottom: "30px",
  gap: "16px"
}), eU = ({
  profileName: e,
  profileAvatar: n,
  addressStreet1: r,
  addressStreet2: a,
  addressCity: o,
  addressState: l,
  addressCountry: d,
  addressZipCode: c,
  phone: f,
  email: s,
  bankRtn: h,
  bankAccountNumber: g
}) => {
  const i = [[r, a, o].filter(Boolean).join(" "), l].filter(Boolean).join(", "), m = [c, d].filter(Boolean).join(", ");
  return /* @__PURE__ */ p.jsxs(uR, { variant: "outlined", children: [
    /* @__PURE__ */ p.jsxs(dR, { children: [
      /* @__PURE__ */ p.jsx(Xs, { src: n }),
      /* @__PURE__ */ p.jsx(Te, { children: e })
    ] }),
    /* @__PURE__ */ p.jsx(wn, {}),
    /* @__PURE__ */ p.jsxs(Ao, { children: [
      /* @__PURE__ */ p.jsx(Te, { component: "div", children: "Address" }),
      /* @__PURE__ */ p.jsxs(Pe, { textAlign: "right", children: [
        i && /* @__PURE__ */ p.jsx(Os, { children: i }),
        m && /* @__PURE__ */ p.jsx(Os, { children: m }),
        !i && !m && /* @__PURE__ */ p.jsx(Os, { children: "-" })
      ] })
    ] }),
    /* @__PURE__ */ p.jsx(wn, {}),
    /* @__PURE__ */ p.jsxs(Ao, { children: [
      /* @__PURE__ */ p.jsx(Te, { children: "Phone" }),
      /* @__PURE__ */ p.jsx(Os, { children: f || "-" })
    ] }),
    /* @__PURE__ */ p.jsx(wn, {}),
    /* @__PURE__ */ p.jsxs(Ao, { children: [
      /* @__PURE__ */ p.jsx(Te, { children: "Email" }),
      /* @__PURE__ */ p.jsx(Os, { children: s || "-" })
    ] }),
    /* @__PURE__ */ p.jsx(wn, {}),
    /* @__PURE__ */ p.jsxs(Ao, { children: [
      /* @__PURE__ */ p.jsx(Te, { children: "Bank Routing #" }),
      /* @__PURE__ */ p.jsx(Os, { children: h || "-" })
    ] }),
    /* @__PURE__ */ p.jsx(wn, {}),
    /* @__PURE__ */ p.jsxs(Ao, { children: [
      /* @__PURE__ */ p.jsx(Te, { children: "Bank Account #" }),
      /* @__PURE__ */ p.jsx(Os, { children: g || "-" })
    ] })
  ] });
}, iy = ({
  label: e = "Year",
  placeholder: n,
  ...r
}) => {
  var d, c;
  const { isLoading: a, data: o } = xr(), l = Tt(() => {
    var f, s;
    return (s = (f = o == null ? void 0 : o.data) == null ? void 0 : f.pref_type_options) != null && s.upload_file_year ? o.data.pref_type_options.upload_file_year.map(
      (h) => String(h.value)
    ) : [];
  }, [(c = (d = o == null ? void 0 : o.data) == null ? void 0 : d.pref_type_options) == null ? void 0 : c.upload_file_year]);
  return /* @__PURE__ */ p.jsx(
    h0,
    {
      placeholder: n,
      label: e,
      loading: a,
      options: l,
      ...r
    }
  );
}, tU = (e) => {
  var a;
  const { field: n, fieldState: r } = Vr({ name: e.name });
  return /* @__PURE__ */ p.jsx(
    iy,
    {
      ...e,
      value: n.value || null,
      onChange: (o, l) => n.onChange(l),
      error: (a = r.error) == null ? void 0 : a.message
    }
  );
}, ry = ({
  label: e = "Month",
  placeholder: n,
  ...r
}) => {
  var d, c;
  const { isLoading: a, data: o } = xr(), l = Tt(() => {
    var f, s;
    return (s = (f = o == null ? void 0 : o.data) == null ? void 0 : f.pref_type_options) != null && s.upload_file_month ? o.data.pref_type_options.upload_file_month.map(
      (h) => String(h.value)
    ) : [];
  }, [(c = (d = o == null ? void 0 : o.data) == null ? void 0 : d.pref_type_options) == null ? void 0 : c.upload_file_month]);
  return /* @__PURE__ */ p.jsx(
    h0,
    {
      placeholder: n,
      label: e,
      loading: a,
      options: l,
      ...r
    }
  );
}, nU = (e) => {
  var a;
  const { field: n, fieldState: r } = Vr({ name: e.name });
  return /* @__PURE__ */ p.jsx(
    ry,
    {
      ...e,
      value: n.value || null,
      onChange: (o, l) => n.onChange(l),
      error: (a = r.error) == null ? void 0 : a.message
    }
  );
}, sy = ({
  label: e = "Tags",
  ...n
}) => {
  var l, d;
  const { isLoading: r, data: a } = xr(), o = Tt(() => {
    var c, f;
    return (f = (c = a == null ? void 0 : a.data) == null ? void 0 : c.pref_type_options) != null && f.upload_tags ? a.data.pref_type_options.upload_tags.map(
      (s) => String(s.value)
    ) : [];
  }, [(d = (l = a == null ? void 0 : a.data) == null ? void 0 : l.pref_type_options) == null ? void 0 : d.upload_tags]);
  return /* @__PURE__ */ p.jsx(
    h0,
    {
      multiple: !0,
      label: e,
      loading: r,
      options: o,
      getOptionLabel: (c) => gs(c),
      filterOptions: (c, f) => {
        const s = new Set(r5()(c, f));
        return c.filter(
          (h) => s.has(h) || df(h, f.inputValue)
        );
      },
      ...n
    }
  );
}, iU = (e) => {
  var a;
  const { field: n, fieldState: r } = Vr({ name: e.name });
  return /* @__PURE__ */ p.jsx(
    sy,
    {
      ...e,
      value: n.value || [],
      onChange: (o, l) => n.onChange(l),
      error: (a = r.error) == null ? void 0 : a.message
    }
  );
}, hR = tt(Me)(({ theme: e }) => ({
  backgroundColor: e.palette.common.neutrals[100],
  display: "flex",
  minHeight: "var(--liscio-app-viewport-height, 100vh)",
  alignItems: "center"
})), fR = tt(ix)(({ theme: e }) => ({
  backgroundColor: e.palette.common.white,
  padding: e.spacing(4)
})), ay = ({
  children: e
}) => /* @__PURE__ */ p.jsx(hR, { children: /* @__PURE__ */ p.jsx(fR, { maxWidth: "sm", children: e }) }), pR = (e) => /* @__PURE__ */ Ue.createElement("svg", { width: 201, height: 201, viewBox: "0 0 201 201", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ Ue.createElement("path", { d: "M0.5 100.5C0.5 45.2715 45.2715 0.5 100.5 0.5C155.728 0.5 200.5 45.2715 200.5 100.5C200.5 155.728 155.728 200.5 100.5 200.5H0.5V100.5Z", fill: "#E7E9EB" }), /* @__PURE__ */ Ue.createElement("path", { d: "M103.156 29.3438L156.031 51.8438C162.219 54.6562 167 60.5625 167 67.875C166.719 96 155.188 146.906 106.812 170.25C102.031 172.5 96.6875 172.5 91.9062 170.25C43.5312 146.906 32 96 32 67.875C31.7188 60.5625 36.5 54.6562 42.6875 51.8438L95.5625 29.3438C96.6875 28.7812 98.0938 28.5 99.5 28.5C100.625 28.5 102.031 28.7812 103.156 29.3438ZM115.25 87C115.25 78.5625 107.938 71.25 99.5 71.25C90.7812 71.25 83.75 78.5625 83.75 87C83.75 93.4688 87.4062 98.8125 92.75 101.344V120.75C92.75 124.688 95.5625 127.5 99.5 127.5C103.156 127.5 106.25 124.688 106.25 120.75V101.344C111.312 98.8125 115.25 93.4688 115.25 87Z", fill: "#74C5FB" }), /* @__PURE__ */ Ue.createElement("path", { d: "M106.25 101.344V120.75C106.25 124.688 103.156 127.5 99.5 127.5C95.5625 127.5 92.75 124.688 92.75 120.75V101.344C87.4062 98.8125 83.75 93.4688 83.75 87C83.75 78.5625 90.7812 71.25 99.5 71.25C107.938 71.25 115.25 78.5625 115.25 87C115.25 93.4688 111.312 98.8125 106.25 101.344Z", fill: "#0061A0" })), gR = (e) => /* @__PURE__ */ Ue.createElement("svg", { width: 41, height: 40, viewBox: "0 0 41 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ Ue.createElement("path", { d: "M40.5925 19.9996C40.5925 31.0463 31.6385 40 20.592 40C9.54633 40 0.592529 31.0463 0.592529 19.9996C0.592529 8.95386 9.54633 0 20.592 0C31.6385 0 40.5925 8.95386 40.5925 19.9996Z", fill: "#EC1C24" }), /* @__PURE__ */ Ue.createElement("path", { d: "M18.8775 15.764L23.673 20.558C24.3652 21.251 25.489 21.251 26.1829 20.558C26.8753 19.8648 26.8769 18.7419 26.1829 18.0488L21.3872 13.253C17.9557 9.82092 12.4098 9.76569 8.90563 13.0787C8.87325 13.106 8.84086 13.1346 8.81105 13.1644C8.79583 13.1798 8.78331 13.196 8.76809 13.2097C8.75234 13.2247 8.7366 13.2382 8.72163 13.2532C8.69144 13.2834 8.6637 13.315 8.63725 13.3465C5.32254 16.8523 5.37957 22.3983 8.81118 25.8303L13.6069 30.6248C14.3006 31.3176 15.4229 31.3176 16.1165 30.6248C16.8107 29.9316 16.8107 28.8072 16.1183 28.1156L11.3225 23.32C9.22899 21.2274 9.21493 17.8311 11.2791 15.7205C13.3894 13.6564 16.7838 13.6714 18.8775 15.764ZM25.0669 9.37769C24.3739 10.071 24.3739 11.1937 25.0687 11.8869L29.8627 16.6826C31.9549 18.7752 31.9685 22.171 29.9045 24.2821C27.7935 26.3444 24.4002 26.3309 22.3072 24.238L17.5116 19.4429C16.818 18.7496 15.6939 18.7496 15.0012 19.4429C14.3071 20.1355 14.3071 21.2618 15.0012 21.953L19.7953 26.7489C23.2278 30.1809 28.7731 30.2368 32.2779 26.9232C32.3104 26.8946 32.3411 26.8679 32.3734 26.8376C32.388 26.8227 32.4016 26.8075 32.416 26.7923C32.4314 26.7774 32.4467 26.7636 32.4612 26.7471C32.492 26.7185 32.5183 26.687 32.5456 26.6542C35.8605 23.1498 35.8051 17.6056 32.3734 14.1716L27.5778 9.37756C26.8847 8.68337 25.7593 8.68337 25.0669 9.37769Z", fill: "white" })), mR = (e) => /* @__PURE__ */ Ue.createElement("svg", { width: 45, height: 40, viewBox: "0 0 45 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ Ue.createElement("g", { clipPath: "url(#clip0_6086_218)" }, /* @__PURE__ */ Ue.createElement("path", { d: "M44.7999 20.175C44.7999 22.2875 43.1103 24 41.026 24H27.9999L22.3999 12.5238L28.4443 1.91309C29.4864 0.0837228 31.7944 -0.543109 33.5994 0.512993L33.6001 0.513412C35.4052 1.56958 36.0238 3.90893 34.9817 5.73846L28.9373 16.35H41.026C43.1103 16.35 44.7999 18.0625 44.7999 20.175Z", fill: "#1A73E8" }), /* @__PURE__ */ Ue.createElement("path", { d: "M33.3539 39.4803L33.3532 39.4807C31.5879 40.5498 29.3307 39.9153 28.3115 38.0635L22.4001 27.3229L16.4887 38.0635C15.4695 39.9153 13.2123 40.5498 11.447 39.4807L11.4463 39.4803C9.68092 38.4112 9.07597 36.0432 10.0951 34.1913L16.0065 23.4498L22.4001 23.2L28.7937 23.4498L34.705 34.1913C35.7242 36.0432 35.1193 38.4112 33.3539 39.4803Z", fill: "#EA4335" }), /* @__PURE__ */ Ue.createElement("path", { d: "M22.4001 12.2228L20.7332 16.8L16.0065 15.9571L10.0951 5.60054C9.07597 3.81499 9.68091 1.53186 11.4463 0.501073L11.447 0.500662C13.2123 -0.530056 15.4695 0.0817121 16.4887 1.86712L22.4001 12.2228Z", fill: "#FBBC04" }), /* @__PURE__ */ Ue.createElement("path", { d: "M21.6 16L17.1818 24H3.80454C1.70335 24 0 22.2091 0 20C0 17.7909 1.70335 16 3.80454 16H21.6Z", fill: "#34A853" }), /* @__PURE__ */ Ue.createElement("path", { d: "M28.8 24H16L22.4 12.8L28.8 24Z", fill: "#185DB7" })), /* @__PURE__ */ Ue.createElement("defs", null, /* @__PURE__ */ Ue.createElement("clipPath", { id: "clip0_6086_218" }, /* @__PURE__ */ Ue.createElement("rect", { width: 44.8, height: 40, fill: "white" })))), xR = (e) => /* @__PURE__ */ Ue.createElement("svg", { width: 33, height: 40, viewBox: "0 0 33 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ Ue.createElement("g", { clipPath: "url(#clip0_6087_232)" }, /* @__PURE__ */ Ue.createElement("path", { d: "M16.3611 0.488281C22.2256 0.488281 27.0086 5.11567 27.2604 10.9188C26.7142 10.7269 26.1386 10.5934 25.5432 10.5258C24.5674 10.4149 23.5965 10.322 22.6302 10.2465C22.0874 7.27673 19.4872 5.02571 16.3611 5.02571C13.2349 5.02571 10.6347 7.27673 10.0919 10.2465C9.12565 10.322 8.15473 10.4149 7.17887 10.5258C6.58349 10.5934 6.00793 10.7269 5.46167 10.9188C5.71354 5.11567 10.4965 0.488281 16.3611 0.488281Z", fill: "#205694" }), /* @__PURE__ */ Ue.createElement("path", { d: "M16.3612 9.99557C19.3756 10.0013 22.4348 10.1726 25.5434 10.5258C29.1449 10.9349 32.0248 13.7421 32.0248 17.4092C32.0248 31.8784 20.8298 39.202 16.3612 39.3772C11.8926 39.202 0.69751 31.8784 0.69751 17.4092C0.69751 13.7421 3.57749 10.9349 7.17899 10.5258C10.2875 10.1726 13.3468 10.0013 16.3612 9.99557Z", fill: "url(#paint0_linear_6087_232)" }), /* @__PURE__ */ Ue.createElement("path", { d: "M16.3611 25.5527C21.3069 25.5527 25.4433 28.7628 26.4805 33.0582C22.9988 37.1776 18.7327 39.2842 16.3611 39.3772C13.9895 39.2842 9.72342 37.1776 6.2417 33.0582C7.27887 28.7628 11.4155 25.5527 16.3611 25.5527Z", fill: "url(#paint1_linear_6087_232)" }), /* @__PURE__ */ Ue.createElement("path", { d: "M16.361 23.9322C19.2844 23.9322 21.6542 21.5621 21.6542 18.6384C21.6542 15.7147 19.2844 13.3445 16.361 13.3445C13.4377 13.3445 11.0679 15.7147 11.0679 18.6384C11.0679 21.5621 13.4377 23.9322 16.361 23.9322Z", fill: "url(#paint2_linear_6087_232)" })), /* @__PURE__ */ Ue.createElement("defs", null, /* @__PURE__ */ Ue.createElement("linearGradient", { id: "paint0_linear_6087_232", x1: 16.3612, y1: 39.3772, x2: 16.3612, y2: 9.99557, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ Ue.createElement("stop", { stopColor: "#205694" }), /* @__PURE__ */ Ue.createElement("stop", { offset: 1, stopColor: "#0275D0" })), /* @__PURE__ */ Ue.createElement("linearGradient", { id: "paint1_linear_6087_232", x1: 16.3611, y1: 39.3772, x2: 16.3611, y2: 25.5527, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ Ue.createElement("stop", { stopColor: "#0A99E8" }), /* @__PURE__ */ Ue.createElement("stop", { offset: 1, stopColor: "#46C5FA" })), /* @__PURE__ */ Ue.createElement("linearGradient", { id: "paint2_linear_6087_232", x1: 16.361, y1: 23.9322, x2: 16.361, y2: 13.3445, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ Ue.createElement("stop", { stopColor: "#0A99E8" }), /* @__PURE__ */ Ue.createElement("stop", { offset: 1, stopColor: "#46C5FA" })), /* @__PURE__ */ Ue.createElement("clipPath", { id: "clip0_6087_232" }, /* @__PURE__ */ Ue.createElement("rect", { width: 32.5926, height: 40, fill: "white" })))), bR = tt(Pe)(({ theme: e }) => ({
  justifyContent: "center",
  alignItems: "center",
  boxShadow: e.shadows[6],
  borderRadius: e.shape.borderRadius,
  height: e.spacing(8),
  width: e.spacing(8)
})), yR = {
  google: mR,
  microsoft: xR,
  authy: gR
}, pd = ({ provider: e }) => {
  const n = yR[e];
  return /* @__PURE__ */ p.jsx(bR, { children: /* @__PURE__ */ p.jsx(n, {}) });
}, vR = tt(Pe)(({ theme: e }) => ({
  gap: e.spacing(4)
})), wR = tt(Pe)(({ theme: e }) => ({
  gap: e.spacing(2)
})), SR = ({
  openForm: e,
  getSelectedCpa: n
}) => {
  var a;
  const r = ((a = n()) == null ? void 0 : a.cpa_name) || "";
  return /* @__PURE__ */ p.jsxs(vR, { children: [
    /* @__PURE__ */ p.jsx(Te, { variant: "h2", children: "Protect your account" }),
    /* @__PURE__ */ p.jsx(Pe, { alignItems: "center", children: /* @__PURE__ */ p.jsx(pR, {}) }),
    /* @__PURE__ */ p.jsxs(Te, { children: [
      "Your firm administrator has enabled",
      " ",
      /* @__PURE__ */ p.jsx("strong", { children: "multi-factor authentication" }),
      " to enhance security",
      " ",
      r ? `for ${r}` : ""
    ] }),
    /* @__PURE__ */ p.jsx(Te, { children: "Supported authentication apps include: Google Authenticator, Microsoft Authenticator, Authy, and others." }),
    /* @__PURE__ */ p.jsxs(wR, { direction: "row", justifyContent: "center", children: [
      /* @__PURE__ */ p.jsx(pd, { provider: "google" }),
      /* @__PURE__ */ p.jsx(pd, { provider: "microsoft" }),
      /* @__PURE__ */ p.jsx(pd, { provider: "authy" })
    ] }),
    /* @__PURE__ */ p.jsx(Me, { pt: 4, textAlign: "right", children: /* @__PURE__ */ p.jsx(
      lt,
      {
        variant: "contained",
        type: "submit",
        size: "large",
        onClick: e,
        children: "Start Setup"
      }
    ) })
  ] });
}, _R = ({ theme: e }) => ({
  [`& ${s5.root}`]: {
    color: e.palette.common.white,
    [e.breakpoints.up("md")]: {
      color: e.palette.text.secondary
    }
  }
}), CR = tt(vi)(_R), AR = Jn.object().shape({
  mfaCode: Jn.string().required("Code is required")
}), kR = ({ qrCodeSrc: e }) => /* @__PURE__ */ p.jsx(Me, { display: "flex", justifyContent: "center", children: /* @__PURE__ */ p.jsx(Me, { component: "img", src: e }) }), ER = tt(Te)(({ theme: e }) => ({
  background: e.palette.common.neutrals[100],
  padding: e.spacing(2),
  width: "fit-content",
  alignSelf: "center",
  borderRadius: e.shape.borderRadius,
  letterSpacing: "3px"
})), IR = ({
  otpSecret: e
}) => /* @__PURE__ */ p.jsx(ER, { variant: "body2", children: e || "-" }), TR = tt(Pe)(({ theme: e }) => ({
  gap: e.spacing(4)
})), OR = ({
  onSubmit: e,
  isLoading: n,
  qrCodeSrc: r,
  otpSecret: a
}) => {
  var c;
  const {
    handleSubmit: o,
    register: l,
    formState: { errors: d }
  } = mr({
    resolver: ws(AR)
  });
  return /* @__PURE__ */ p.jsx("form", { onSubmit: o(e), children: /* @__PURE__ */ p.jsxs(TR, { children: [
    /* @__PURE__ */ p.jsx(Te, { variant: "h2", children: "Set up multi-factor authentication" }),
    /* @__PURE__ */ p.jsx(Te, { children: "Open your preferred authenticator app and use your phone camera to scan the barcode below." }),
    /* @__PURE__ */ p.jsx(kR, { qrCodeSrc: r }),
    /* @__PURE__ */ p.jsx(F5, { text: "Or enter the code manually" }),
    /* @__PURE__ */ p.jsx(IR, { otpSecret: a }),
    /* @__PURE__ */ p.jsxs(Te, { children: [
      "The authenthicator app will generate a verification code. Enter the",
      " ",
      /* @__PURE__ */ p.jsx("strong", { children: "verification code below" }),
      "."
    ] }),
    /* @__PURE__ */ p.jsxs(Me, { children: [
      /* @__PURE__ */ p.jsx(Te, { mb: 1, children: "Verification code" }),
      /* @__PURE__ */ p.jsx(
        CR,
        {
          ...l("mfaCode"),
          fullWidth: !0,
          placeholder: "Enter verification code",
          error: !!(d != null && d.mfaCode),
          helperText: (c = d == null ? void 0 : d.mfaCode) == null ? void 0 : c.message
        }
      )
    ] }),
    /* @__PURE__ */ p.jsx(Me, { textAlign: "right", children: /* @__PURE__ */ p.jsx(
      lt,
      {
        variant: "contained",
        type: "submit",
        disabled: n,
        size: "large",
        children: "Verify"
      }
    ) })
  ] }) });
}, FR = ({
  isLoading: e,
  onSubmit: n,
  qrCodeSrc: r,
  otpSecret: a,
  getSelectedCpa: o
}) => {
  const [l, d] = Ee("info");
  return /* @__PURE__ */ p.jsxs(ay, { children: [
    l === "info" && /* @__PURE__ */ p.jsx(
      SR,
      {
        openForm: () => d("form"),
        getSelectedCpa: o
      }
    ),
    l === "form" && /* @__PURE__ */ p.jsx(
      OR,
      {
        isLoading: e,
        onSubmit: n,
        qrCodeSrc: r,
        otpSecret: a
      }
    )
  ] });
}, PR = 2800, jR = tt(Pe)(({ theme: e }) => ({
  gap: e.spacing(4)
})), RR = ({
  onDelayedSuccess: e
}) => {
  const n = ut();
  return ot(() => (n.current || (n.current = setTimeout(e, PR)), () => {
    n.current && (clearTimeout(n.current), n.current = void 0);
  }), [e]), /* @__PURE__ */ p.jsx(ay, { children: /* @__PURE__ */ p.jsxs(jR, { children: [
    /* @__PURE__ */ p.jsx(Te, { variant: "h2", children: "Multi-factor Authentication Enabled" }),
    /* @__PURE__ */ p.jsx(Pe, { alignItems: "center", children: /* @__PURE__ */ p.jsx(P5, { autoplay: !0 }) }),
    /* @__PURE__ */ p.jsx(Te, { children: "You have successfully enabled Multi-factor Authentication for your account." }),
    /* @__PURE__ */ p.jsx(Te, { children: "You'll be redirected to your homepage in a few seconds." })
  ] }) });
};
function oy({ text: e, query: n }) {
  const r = n.trim().toLowerCase();
  if (!r)
    return /* @__PURE__ */ p.jsx(p.Fragment, { children: e });
  const o = e.toLowerCase().indexOf(r);
  if (o === -1)
    return /* @__PURE__ */ p.jsx(p.Fragment, { children: e });
  const l = e.slice(0, o), d = e.slice(o, o + r.length), c = e.slice(o + r.length);
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    l,
    /* @__PURE__ */ p.jsx(
      vn,
      {
        component: "span",
        sx: { bgcolor: "#fff59d", borderRadius: 0.25, px: 0.25 },
        children: d
      }
    ),
    c
  ] });
}
function MR({
  contact: e,
  searchQuery: n,
  selected: r,
  disabled: a = !1,
  multiSelect: o = !0,
  onSelect: l
}) {
  const d = e.initials ?? e.name.split(" ").map((f) => f.charAt(0)).join("").slice(0, 2).toUpperCase(), c = [e.role, e.email].filter(Boolean);
  return /* @__PURE__ */ p.jsxs(
    vn,
    {
      role: "button",
      tabIndex: a ? -1 : 0,
      "aria-disabled": a,
      onClick: () => {
        a || l();
      },
      onKeyDown: (f) => {
        a || (f.key === "Enter" || f.key === " ") && (f.preventDefault(), l());
      },
      sx: {
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        px: 2,
        py: 1.25,
        cursor: a ? "not-allowed" : "pointer",
        opacity: a ? 0.5 : 1,
        bgcolor: r ? "grey.100" : "background.paper",
        "&:hover": a ? void 0 : { bgcolor: "grey.100" }
      },
      children: [
        /* @__PURE__ */ p.jsx(
          Ym,
          {
            variant: "rounded",
            src: e.avatar ?? void 0,
            sx: {
              width: 32,
              height: 32,
              fontSize: 12,
              fontWeight: 600,
              bgcolor: "grey.200",
              color: "text.secondary",
              borderRadius: 1
            },
            children: d
          }
        ),
        /* @__PURE__ */ p.jsxs(vn, { sx: { flex: 1, minWidth: 0 }, children: [
          /* @__PURE__ */ p.jsx(wi, { variant: "body2", sx: { fontWeight: 600 }, children: /* @__PURE__ */ p.jsx(oy, { text: e.name, query: n }) }),
          c.length > 0 && /* @__PURE__ */ p.jsx(wi, { variant: "caption", color: "text.secondary", noWrap: !0, children: c.join(", ") })
        ] }),
        o ? /* @__PURE__ */ p.jsx(
          Hi,
          {
            checked: r,
            disabled: a,
            size: "small",
            sx: { p: 0.5 },
            tabIndex: -1,
            onClick: (f) => f.stopPropagation(),
            onChange: () => {
              a || l();
            }
          }
        ) : /* @__PURE__ */ p.jsx(
          Vo,
          {
            checked: r,
            disabled: a,
            size: "small",
            sx: {
              p: 0.5,
              color: "grey.400",
              "&.Mui-checked": { color: "secondary.main" }
            },
            tabIndex: -1,
            onClick: (f) => f.stopPropagation(),
            onChange: () => {
              a || l();
            }
          }
        )
      ]
    }
  );
}
function DR(e, n) {
  return `${e}:${n}`;
}
function NR({
  account: e,
  contacts: n,
  contactCount: r,
  searchQuery: a,
  multiSelect: o,
  selectedKeys: l,
  allowCreateContact: d,
  getOptionDisabled: c,
  onAddContact: f,
  onSelectContact: s
}) {
  const h = d && !e.isEmployeesGroup && !e.isAccountlessGroup && f, g = e.isEmployeesGroup ? `${r} employee${r === 1 ? "" : "s"}` : [
    e.entityType,
    `${r} contact${r === 1 ? "" : "s"}`
  ].filter(Boolean).join(" · ");
  return /* @__PURE__ */ p.jsxs(vn, { children: [
    /* @__PURE__ */ p.jsxs(vn, { sx: { px: 2, py: 1, bgcolor: "grey.50" }, children: [
      /* @__PURE__ */ p.jsx(wi, { variant: "body2", sx: { fontWeight: 700 }, children: /* @__PURE__ */ p.jsx(oy, { text: e.name, query: a }) }),
      /* @__PURE__ */ p.jsx(wi, { variant: "caption", color: "text.secondary", children: g })
    ] }),
    n.map((t, i) => {
      const m = DR(e.id, t.id), v = l.has(m), E = (c == null ? void 0 : c(e, t)) ?? !1;
      return /* @__PURE__ */ p.jsxs(vn, { children: [
        i > 0 && /* @__PURE__ */ p.jsx(x1, {}),
        /* @__PURE__ */ p.jsx(
          MR,
          {
            contact: t,
            searchQuery: a,
            selected: v,
            disabled: E,
            multiSelect: o,
            onSelect: () => s(e, t)
          }
        )
      ] }, m);
    }),
    h && /* @__PURE__ */ p.jsxs(vn, { children: [
      n.length > 0 && /* @__PURE__ */ p.jsx(x1, {}),
      /* @__PURE__ */ p.jsx(vn, { sx: { px: 2, py: 0.75 }, children: /* @__PURE__ */ p.jsx(
        Ei,
        {
          size: "small",
          onClick: () => f(e),
          startIcon: /* @__PURE__ */ p.jsx(it, { icon: "plus", fontSize: "small" }),
          sx: {
            textTransform: "none",
            fontWeight: 600,
            color: "secondary.main",
            p: 0.75,
            px: 1,
            minWidth: 0,
            borderRadius: 1,
            "&:hover": {
              bgcolor: "grey.100",
              textDecoration: "underline"
            }
          },
          children: "Add Contact"
        }
      ) })
    ] })
  ] });
}
function LR({
  searchQuery: e,
  onCreateAccount: n
}) {
  return /* @__PURE__ */ p.jsxs(vn, { sx: { px: 2, py: 3, textAlign: "center" }, children: [
    /* @__PURE__ */ p.jsxs(wi, { variant: "body2", sx: { mb: 0.5 }, children: [
      "No contacts or accounts match",
      " ",
      /* @__PURE__ */ p.jsxs(vn, { component: "span", sx: { fontWeight: 700 }, children: [
        "'",
        e,
        "'"
      ] })
    ] }),
    /* @__PURE__ */ p.jsx(
      wi,
      {
        variant: "caption",
        color: "text.secondary",
        sx: { display: "block", mb: 2 },
        children: "Create a new record and send this message to it."
      }
    ),
    n && /* @__PURE__ */ p.jsx(vn, { sx: { display: "flex", justifyContent: "flex-start" }, children: /* @__PURE__ */ p.jsx(
      Ei,
      {
        startIcon: /* @__PURE__ */ p.jsx(it, { icon: "plus" }),
        onClick: n,
        sx: {
          textTransform: "none",
          fontWeight: 600,
          color: "secondary.main"
        },
        children: "Create new account"
      }
    ) })
  ] });
}
function BR(e) {
  return e.chips.length === 0 ? null : /* @__PURE__ */ p.jsx(
    j5,
    {
      ...e,
      onAssignAccount: e.onAssignAccount ? (n, r) => {
        var l, d;
        const a = e.chips.find(
          (c) => c.key.accountId === n.accountId && c.key.contactId === n.contactId
        ), o = (l = a == null ? void 0 : a.accountOptions) == null ? void 0 : l.find(
          (c) => c.id === r.id
        );
        o && ((d = e.onAssignAccount) == null || d.call(e, n, o));
      } : void 0
    }
  );
}
function gd(e, n) {
  return `${e}:${n}`;
}
function $R(e) {
  return e.some((n) => n.contacts.length > 0);
}
const UR = 2;
function rU({
  groups: e,
  loading: n = !1,
  multiSelect: r = !0,
  selectedKeys: a,
  selectedChips: o,
  onSelect: l,
  onRemoveChip: d,
  onRemoveAccount: c,
  onAssignAccount: f,
  onRefreshAccountOptions: s,
  getOptionDisabled: h,
  allowCreateContact: g,
  allowCreateAccount: t,
  onAddContact: i,
  onCreateAccount: m,
  placeholder: v = "Search contacts & accounts",
  ariaLabel: E,
  emptyState: S,
  maxHeight: y = "320px",
  compact: x = !1,
  dropdownPlacement: b = "bottom",
  disabled: u = !1,
  error: I = !1,
  helperText: O,
  renderChip: D,
  accountAssignmentDisplay: $,
  renderCreateContactPanel: K,
  renderCreateAccountPanel: H,
  openCreateContactForAccount: B,
  onOpenCreateContactForAccountHandled: R,
  searchQuery: _,
  onSearchChange: A,
  onInteract: k,
  minSearchLength: z = UR
}) {
  const [T, w] = Ee(!1), F = ut(null), [j, P] = Ee("list"), [V, J] = Ee(""), [ne, Z] = Ee(null), te = ut(null), N = `liscio-recipient-search-${dc().replace(/:/g, "")}`, q = `${N}-helper-text`, ie = _ ?? V, oe = A ?? J, fe = ie.trim(), Y = fe.length >= z;
  ot(() => {
    B && (Z(B), P("create-contact"), w(!0), R == null || R());
  }, [B, R]);
  const ae = Tt(
    () => new Set(a.map((de) => gd(de.accountId, de.contactId))),
    [a]
  ), se = Tt(() => j === "create-account" || j === "create-contact" ? j : Y && fe.length > 0 && !n && !$R(e) ? "no-results" : "list", [j, Y, fe, n, e]);
  ot(() => {
    var de, ge;
    T && !n && ((ge = (de = F.current) == null ? void 0 : de.scrollIntoView) == null || ge.call(de, { block: "nearest" }));
  }, [T, n, se, e]);
  const L = Oe(() => {
    u || (w(!0), P("list"));
  }, [u]), W = Oe(() => {
    w(!1), Z(null), (j === "create-account" || j === "create-contact") && P("list");
  }, [j]), M = Oe(
    (de) => {
      var me;
      const ge = de.target;
      ge && !ge.isConnected || (me = ge == null ? void 0 : ge.closest) != null && me.call(
        ge,
        ".MuiPopover-root, .MuiModal-root, .MuiAutocomplete-popper, .contact-card-popper, .recipient-account-options"
      ) || W();
    },
    [W]
  ), X = Oe(() => {
    P("list"), Z(null);
  }, []), U = Oe(
    (de) => {
      oe(de), P("list");
    },
    [oe]
  ), Q = Oe(
    (de) => {
      Z(de), P("create-contact"), i == null || i(de);
    },
    [i]
  ), re = Oe(() => {
    P("create-account"), m == null || m(fe);
  }, [m, fe]), le = Oe(
    (de, ge) => {
      const me = gd(de.id, ge.id), xe = ae.has(me);
      if (r && xe) {
        const ye = o.find(
          (ve) => gd(ve.key.accountId, ve.key.contactId) === me
        );
        if ((ye == null ? void 0 : ye.canRemove) === !1) return;
        d({ accountId: de.id, contactId: ge.id });
      } else
        l(de, ge), oe(""), P("list");
      r || W();
    },
    [
      r,
      ae,
      o,
      l,
      d,
      W,
      oe
    ]
  ), ce = () => {
    L();
  }, ee = /* @__PURE__ */ p.jsx(
    Te,
    {
      variant: "body2",
      color: "text.secondary",
      sx: { px: 2, py: 3, textAlign: "center" },
      children: "Type to search contacts & accounts"
    }
  ), he = () => Y ? n ? /* @__PURE__ */ p.jsx(vn, { sx: { display: "flex", justifyContent: "center", py: 3 }, children: /* @__PURE__ */ p.jsx(Wh, { size: 24 }) }) : e.length === 0 ? fe.length === 0 ? S ?? ee : S ?? /* @__PURE__ */ p.jsx(
    Te,
    {
      variant: "body2",
      color: "text.secondary",
      sx: { px: 2, py: 3, textAlign: "center" },
      children: "No accounts found"
    }
  ) : e.map((de) => /* @__PURE__ */ p.jsx(
    NR,
    {
      account: de.account,
      contacts: de.contacts,
      contactCount: de.contactCount,
      searchQuery: ie,
      multiSelect: r,
      selectedKeys: ae,
      allowCreateContact: g,
      getOptionDisabled: h,
      onAddContact: Q,
      onSelectContact: le
    },
    de.account.id
  )) : S ?? ee, pe = () => {
    const de = t && Y && se === "list", ge = r;
    return !de && !ge ? null : /* @__PURE__ */ p.jsxs(
      vn,
      {
        sx: {
          flexShrink: 0,
          borderTop: 1,
          borderColor: "divider",
          bgcolor: "background.paper",
          px: 2,
          py: 1.25,
          display: "flex",
          alignItems: "center",
          gap: 1,
          justifyContent: de && ge ? "space-between" : "flex-end"
        },
        children: [
          de && /* @__PURE__ */ p.jsxs(
            vn,
            {
              component: "button",
              type: "button",
              onClick: re,
              sx: {
                display: "inline-flex",
                alignItems: "center",
                gap: 0.5,
                border: "none",
                bgcolor: "transparent",
                cursor: "pointer",
                color: "secondary.main",
                fontWeight: 600,
                fontSize: "0.875rem",
                fontFamily: "inherit",
                p: 0,
                "&:hover": { textDecoration: "underline" }
              },
              children: [
                /* @__PURE__ */ p.jsx(it, { icon: "plus", fontSize: "small" }),
                "Create new account"
              ]
            }
          ),
          ge && /* @__PURE__ */ p.jsx(
            Ei,
            {
              type: "button",
              size: "small",
              variant: "contained",
              onClick: W,
              sx: { textTransform: "none", fontWeight: 600 },
              children: "Done"
            }
          )
        ]
      }
    );
  };
  return /* @__PURE__ */ p.jsxs(vn, { sx: { width: "100%" }, children: [
    /* @__PURE__ */ p.jsxs(vn, { sx: { position: "relative" }, children: [
      /* @__PURE__ */ p.jsxs(
        vn,
        {
          onClick: (de) => {
            var me;
            de.target.closest('button, [role="combobox"]') || u || (k == null || k(), L(), (me = te.current) == null || me.focus());
          },
          sx: {
            minHeight: 40,
            border: 1,
            borderColor: I ? "error.main" : "grey.300",
            borderRadius: 1,
            px: 1,
            py: 0.75,
            ...x && {
              minHeight: 45,
              py: 0.25,
              // A slimmer account group keeps a row of chips within it.
              '& [role="group"]': { py: 0.25 }
            },
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 0.5,
            cursor: u ? "not-allowed" : "text",
            bgcolor: u ? "action.disabledBackground" : "background.paper",
            opacity: u ? 0.6 : 1
          },
          children: [
            /* @__PURE__ */ p.jsx(
              BR,
              {
                chips: o,
                disabled: u,
                onRemoveChip: d,
                onRemoveAccount: c,
                onAssignAccount: f,
                onRefreshAccountOptions: s,
                renderChip: D,
                accountAssignmentDisplay: $
              }
            ),
            /* @__PURE__ */ p.jsx(
              qs,
              {
                inputRef: te,
                value: ie,
                autoComplete: "off",
                onChange: (de) => {
                  U(de.target.value), L();
                },
                onFocus: () => {
                  k == null || k(), ce();
                },
                onKeyDown: (de) => {
                  var ge;
                  de.key === "Escape" && T && (de.stopPropagation(), W(), (ge = te.current) == null || ge.blur());
                },
                disabled: u,
                placeholder: o.length === 0 ? v : "",
                variant: "standard",
                inputProps: {
                  name: N,
                  id: N,
                  "aria-label": E,
                  "aria-describedby": O ? q : void 0,
                  "aria-invalid": I || void 0,
                  autoComplete: "off",
                  "data-1p-ignore": !0,
                  "data-lpignore": "true"
                },
                InputProps: {
                  disableUnderline: !0,
                  startAdornment: o.length === 0 ? /* @__PURE__ */ p.jsx(kl, { position: "start", children: /* @__PURE__ */ p.jsx(
                    it,
                    {
                      icon: "search",
                      fontSize: "small",
                      sx: { color: "text.secondary" }
                    }
                  ) }) : void 0,
                  sx: {
                    fontSize: "0.875rem",
                    // A compact field keeps the search input on the chips' row
                    // until under 30px are left, as MUI's own chip inputs do.
                    minWidth: x ? 30 : 120,
                    flex: 1,
                    // The field already shades a disabled selector; the theme's
                    // disabled input fill would draw a second box inside it.
                    "&.Mui-disabled": { bgcolor: "transparent" }
                  }
                },
                sx: { flex: 1, minWidth: x ? 30 : 80 }
              }
            )
          ]
        }
      ),
      T && !u && /* @__PURE__ */ p.jsx(
        a5,
        {
          mouseEvent: "onMouseDown",
          touchEvent: "onTouchStart",
          onClickAway: M,
          children: /* @__PURE__ */ p.jsxs(
            R5,
            {
              ref: F,
              elevation: 4,
              sx: {
                position: "absolute",
                top: b === "bottom" ? "100%" : void 0,
                bottom: b === "top" ? "100%" : void 0,
                left: 0,
                right: 0,
                mt: b === "bottom" ? 0.5 : 0,
                mb: b === "top" ? 0.5 : 0,
                zIndex: 1300,
                borderRadius: 1,
                overflow: "hidden"
              },
              children: [
                se === "create-account" && (H == null ? void 0 : H({
                  prefillName: fe,
                  onBack: X,
                  onCancel: X
                })),
                se === "create-contact" && ne && (K == null ? void 0 : K({
                  account: ne,
                  onBack: X,
                  onCancel: X
                })),
                (se === "list" || se === "no-results") && /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
                  /* @__PURE__ */ p.jsx(vn, { sx: { maxHeight: y, overflow: "auto" }, children: se === "no-results" ? /* @__PURE__ */ p.jsx(
                    LR,
                    {
                      searchQuery: ie,
                      onCreateAccount: t ? re : void 0
                    }
                  ) : he() }),
                  pe()
                ] })
              ]
            }
          )
        }
      )
    ] }),
    O && /* @__PURE__ */ p.jsx(
      Te,
      {
        id: q,
        role: I ? "alert" : void 0,
        variant: "caption",
        color: I ? "error" : "text.secondary",
        sx: { mt: 0.5, ml: 1.75, display: "block" },
        children: O
      }
    )
  ] });
}
const sU = -1, aU = 0, zR = ({
  option: e,
  selected: n,
  disabled: r
}) => /* @__PURE__ */ p.jsxs(
  gu,
  {
    container: !0,
    direction: "row",
    sx: {
      justifyContent: "space-between",
      alignItems: "center"
    },
    children: [
      /* @__PURE__ */ p.jsxs(gu, { item: !0, children: [
        /* @__PURE__ */ p.jsxs(Te, { variant: "body1", children: [
          e.firstName,
          " ",
          e.middleName,
          " ",
          e.lastName
        ] }),
        /* @__PURE__ */ p.jsx(
          Te,
          {
            variant: "body1",
            fontWeight: 400,
            sx: (a) => ({
              color: a.palette.common.neutrals[600]
            }),
            children: `${e.role}, ${e.primaryEmail}`
          }
        )
      ] }),
      /* @__PURE__ */ p.jsx(gu, { item: !0, children: /* @__PURE__ */ p.jsx(
        M5,
        {
          style: { marginRight: 8 },
          checked: n,
          disabled: r
        }
      ) })
    ]
  }
), HR = ({
  children: e,
  tooltip: n,
  disabled: r = !1,
  listItemProps: a = {}
}) => {
  const o = /* @__PURE__ */ p.jsx(
    vn,
    {
      sx: {
        opacity: r ? 0.5 : 1,
        pointerEvents: r ? "none" : "auto",
        width: "100%"
      },
      "aria-disabled": r,
      children: e
    }
  ), l = /* @__PURE__ */ p.jsx("li", { ...a, "aria-disabled": r, children: o });
  return n ? /* @__PURE__ */ p.jsx(Kh, { title: n, arrow: !0, children: r ? (
    // span needed to allow Tooltip on disabled elements
    /* @__PURE__ */ p.jsx("span", { style: { width: "100%", display: "block" }, children: l })
  ) : l }) : l;
}, WR = ({
  firstName: e,
  middleName: n,
  lastName: r,
  role: a,
  account: o,
  email: l,
  onRemove: d,
  disabled: c,
  disableRemoval: f
}) => {
  const s = [e, n, r].join(" ").trim(), h = [xu(e) ?? "", xu(n) ?? "", xu(r) ?? ""].join("").toUpperCase();
  return /* @__PURE__ */ p.jsxs(
    bs,
    {
      secondaryAction: c || f ? null : /* @__PURE__ */ p.jsx(Gn, { onClick: d, edge: "end", "aria-label": "delete", children: /* @__PURE__ */ p.jsx(it, { icon: "close", sx: { fontSize: "0.625em" } }) }),
      sx: (g) => ({
        height: "74px",
        paddingLeft: g.spacing(1),
        margin: `${g.spacing(1)} 0`,
        borderRadius: "4px",
        backgroundColor: g.palette.common.neutrals[100]
      }),
      children: [
        /* @__PURE__ */ p.jsx(D5, { sx: { width: "60px" }, children: /* @__PURE__ */ p.jsx(
          Xs,
          {
            alt: s,
            sx: (g) => ({
              borderStyle: "none",
              width: "46px",
              height: "46px",
              fontSize: "1rem",
              color: g.palette.common.neutrals[700],
              backgroundColor: g.palette.common.neutrals[200]
            }),
            children: h
          }
        ) }),
        /* @__PURE__ */ p.jsx(
          Mn,
          {
            primary: /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
              /* @__PURE__ */ p.jsx(Te, { variant: "body1", fontWeight: 600, lineHeight: 1.25, children: s }),
              /* @__PURE__ */ p.jsx(
                Te,
                {
                  variant: "body1",
                  lineHeight: 1.25,
                  sx: (g) => ({ color: g.typography.body1.color }),
                  children: o
                }
              )
            ] }),
            secondary: /* @__PURE__ */ p.jsx(
              Te,
              {
                variant: "body1",
                fontWeight: 400,
                lineHeight: 1.25,
                sx: (g) => ({ color: g.palette.common.neutrals[600] }),
                children: `${a}, ${l}`
              }
            )
          }
        )
      ]
    }
  );
};
function qR({
  account: e,
  recipients: n,
  onRemove: r,
  disabled: a,
  disableRemoval: o,
  maxHeight: l = "20rem"
}) {
  return !n || n.length === 0 ? null : /* @__PURE__ */ p.jsxs(Pe, { children: [
    /* @__PURE__ */ p.jsx(Te, { mt: 2, variant: "h5", children: e }),
    /* @__PURE__ */ p.jsx(
      Gs,
      {
        sx: {
          width: "100%",
          maxHeight: l,
          overflowY: "auto",
          overflowX: "hidden"
        },
        children: n.map((d) => /* @__PURE__ */ p.jsx(
          WR,
          {
            firstName: d.firstName,
            middleName: d.middleName,
            lastName: d.lastName,
            email: d.primaryEmail || "",
            role: d.role || "",
            account: e,
            onRemove: () => r(d.uuid),
            disabled: a,
            disableRemoval: o
          },
          d.uuid
        ))
      }
    )
  ] });
}
const VR = tt(Pe)(({ theme: e }) => ({
  border: "1px solid",
  borderColor: e.palette.grey[300],
  borderRadius: e.shape.borderRadius,
  position: "relative",
  width: "100%",
  backgroundColor: e.palette.background.paper,
  zIndex: e.zIndex.modal
})), XR = tt(Pe)(({ theme: e }) => ({
  borderTop: `1px solid ${e.palette.divider}`,
  padding: "0.5rem",
  zIndex: e.zIndex.modal
}));
function GR({
  children: e,
  onDoneClick: n,
  onClearClick: r,
  helperMessage: a,
  showClearOption: o
}) {
  return /* @__PURE__ */ p.jsxs(VR, { children: [
    e,
    /* @__PURE__ */ p.jsxs(XR, { direction: "row", alignItems: "center", gap: 1, children: [
      o && r && /* @__PURE__ */ p.jsx(
        Ii,
        {
          component: "button",
          variant: "caption",
          underline: "hover",
          onMouseDown: (l) => {
            l.preventDefault(), l.stopPropagation(), r(l);
          },
          sx: { cursor: "pointer" },
          children: "Clear selection"
        }
      ),
      a && /* @__PURE__ */ p.jsx(Te, { variant: "caption", color: "text.secondary", sx: { flex: 1 }, children: a }),
      /* @__PURE__ */ p.jsx(
        lt,
        {
          variant: "contained",
          color: "primary",
          sx: { width: "5rem", ml: "auto" },
          onMouseDown: (l) => {
            l.stopPropagation(), n == null || n(l);
          },
          children: "Done"
        }
      )
    ] })
  ] });
}
function KR(e) {
  return !e || Array.isArray(e) && e.length === 0 ? [] : e.reduce((n, r) => [
    ...n,
    ...r.contacts.map((a) => ({
      id: a.id,
      uuid: a.uuid || "",
      firstName: a.first_name || "",
      middleName: a.middle_name || "",
      lastName: a.last_name || "",
      primaryEmail: a.primary_email || "",
      role: a.role || "",
      account: {
        name: r.name,
        uuid: r.uuid
      }
    }))
  ], []);
}
function YR(e, n) {
  const r = ((n == null ? void 0 : n.enabled) ?? !0) && e.length > 0, a = mx({
    queries: e.map((c) => ({
      queryKey: ["accounts-for-contact", c],
      queryFn: async (f) => (await I8(
        c,
        f.signal
      )).data.map((h) => ({
        ...h,
        contacts: h.contacts.map((g) => ({
          ...g,
          last_name: g.last_name ?? ""
        }))
      })),
      enabled: r,
      staleTime: 0
    }))
  }), o = a.some((c) => c.isLoading), l = a.length > 0 && a.every((c) => c.isFetched);
  return {
    data: Tt(() => {
      if (!l || a.length === 0)
        return { data: [] };
      const c = a.map((g) => g.data ?? []);
      return c.some((g) => g.length === 0) ? { data: [] } : { data: c[0].filter(
        (g) => c.every(
          (t) => t.some((i) => i.uuid === g.uuid)
        )
      ).map((g) => {
        const t = /* @__PURE__ */ new Map();
        return c.forEach((i) => {
          const m = i.find(
            (v) => v.uuid === g.uuid
          );
          m == null || m.contacts.forEach((v) => {
            t.set(v.uuid, v);
          });
        }), {
          ...g,
          contacts: Array.from(t.values())
        };
      }) };
    }, [l, a]),
    isLoading: o,
    isFetched: l
  };
}
const ZR = tt(o5)(({ theme: e }) => ({
  "& .MuiAutocomplete-groupLabel": {
    color: e.palette.text.primary,
    fontSize: e.typography.h6.fontSize,
    fontWeight: e.typography.fontWeightBold,
    borderBottom: `1px solid ${e.palette.common.neutrals[200]}`
  },
  "& .MuiAutocomplete-groupUl": {
    "& .MuiAutocomplete-option": {
      paddingLeft: "16px"
    }
  }
}));
function oU({
  name: e = "recipients",
  control: n,
  label: r = "ASSIGNEES",
  assignedAccountFieldName: a = "assignedAccountId",
  assignedContactIdsFieldName: o = "assignedContactIds",
  account: l,
  assignedContacts: d = [],
  required: c,
  disabled: f,
  disableRemoval: s,
  helperMessage: h,
  maxHeight: g
}) {
  var oe;
  const [t, i] = Ee(
    l == null ? void 0 : l.uuid
  );
  ot(() => {
    l != null && l.uuid ? i(l.uuid) : i(void 0);
  }, [l]);
  const { field: m } = Vr({
    name: a,
    control: n,
    defaultValue: "",
    rules: {
      required: c ? "Required" : void 0
    }
  }), { field: v } = Vr({
    name: o,
    control: n,
    defaultValue: [],
    rules: {
      required: c ? "Required" : void 0
    }
  }), [E, S] = Ee(""), [y, x] = Ee(""), [b, u] = Ee([]), [I, O] = Ee(!1), [D, $] = Ee(!1), K = d.length > 0 && !l && !t, H = K && !E && !D, B = Tt(
    () => d.map((fe) => fe.uuid),
    [d]
  ), {
    data: R,
    isLoading: _,
    isFetched: A
  } = YR(B, {
    enabled: K && !D
  }), k = K && !D && A && (!(R != null && R.data) || R.data.length === 0), { data: z, isLoading: T } = T8(
    { term: E, account_id: t },
    {
      query: {
        enabled: !H && (t ? !0 : !!E || I),
        staleTime: 0
      }
    }
  ), w = Tt(() => H && (R != null && R.data) ? R : z, [H, R, z]), F = (T || _) && !k;
  ot(() => {
    var fe;
    if (H && A && ((fe = R == null ? void 0 : R.data) == null ? void 0 : fe.length) === 1 && !t && !D) {
      const Y = R.data[0];
      i(Y.uuid), m.onChange(Y.uuid);
    }
  }, [
    H,
    A,
    R == null ? void 0 : R.data,
    t,
    m,
    D
  ]);
  const [j, P] = Ee(!1);
  ot(() => {
    P(!1);
  }, [d]), ot(() => {
    if (!(d.length === 0 || j) && t && Array.isArray(w == null ? void 0 : w.data) && w.data.length > 0) {
      const fe = w.data.find(
        (Y) => Y.uuid === t
      );
      if (fe) {
        const Y = fe.contacts.filter(
          (ae) => d.some(
            (se) => se.uuid === ae.uuid
          )
        ).map((ae) => ({
          ...ae,
          firstName: ae.first_name || "",
          middleName: ae.middle_name || "",
          lastName: ae.last_name,
          role: ae.role || "",
          primaryEmail: ae.primary_email || "",
          account: {
            name: fe.name,
            uuid: fe.uuid
          }
        }));
        Y.length > 0 && (u(Y), P(!0));
      }
    }
  }, [
    t,
    d,
    w == null ? void 0 : w.data,
    j
  ]);
  const V = Oe(
    (fe) => {
      S(fe);
    },
    [S]
  ), J = Tt(
    () => M4(V, 500),
    [V]
  ), ne = Tt(() => {
    const fe = w != null && w.data ? KR(w.data) : [];
    if (E && t && fe.length > 0) {
      const Y = E.toLowerCase();
      return fe.filter(
        (ae) => {
          var se;
          return ae.firstName.toLowerCase().includes(Y) || ae.lastName.toLowerCase().includes(Y) || (((se = ae.primaryEmail) == null ? void 0 : se.toLowerCase().includes(Y)) ?? !1) || ae.account.name.toLowerCase().includes(Y);
        }
      );
    }
    return fe;
  }, [w, E, t]), Z = Oe(
    (fe, Y) => {
      var W;
      const ae = Y.filter(
        (M) => typeof M != "string"
      );
      if (s) {
        const M = b.map((Q) => Q.uuid), X = ae.map((Q) => Q.uuid);
        if (M.some((Q) => !X.includes(Q)))
          return;
      }
      const se = ((W = ae[0]) == null ? void 0 : W.account.uuid) || "", L = ae.map((M) => M.uuid);
      m.onChange(se), v.onChange(L), i(se), u(ae);
    },
    [
      s,
      b,
      m,
      v
    ]
  ), te = Oe(
    (fe, Y, ae) => {
      ae === "input" && (x(Y), J(Y));
    },
    [J]
  ), G = (fe) => {
    const Y = b.filter(
      (ae) => ae.uuid !== fe
    );
    u(Y), Y.length === 0 && (i(void 0), m.onChange(""), P(!0), $(!0)), v.onChange(
      Y.map((ae) => ae.uuid)
    );
  }, N = Oe(
    (fe) => b.some(
      (Y) => Y.account.uuid !== fe.account.uuid
    ),
    [b]
  ), q = Oe(() => {
    u([]), i(void 0), m.onChange(""), v.onChange([]), S(""), x(""), P(!0), $(!0);
  }, [m, v]), ie = Tt(() => {
    const fe = (b.length > 0 || !!t) && !s;
    return function(ae) {
      return /* @__PURE__ */ p.jsx(
        GR,
        {
          ...ae,
          helperMessage: h,
          showClearOption: fe,
          onClearClick: q
        }
      );
    };
  }, [
    h,
    b.length,
    t,
    s,
    q
  ]);
  return /* @__PURE__ */ p.jsxs(Pe, { children: [
    /* @__PURE__ */ p.jsx(N5, { children: r }),
    /* @__PURE__ */ p.jsx(
      h0,
      {
        disabled: f,
        PopperComponent: ZR,
        PaperComponent: ie,
        placeholder: "Search by account or contact name",
        name: e,
        multiple: !0,
        disableClearable: !0,
        disableCloseOnSelect: !0,
        disablePortal: !0,
        forcePopupIcon: !1,
        clearOnBlur: !1,
        open: I,
        loading: F && (!!E || H),
        options: ne,
        groupBy: (fe) => fe.account.name,
        filterOptions: (fe) => fe,
        filterSelectedOptions: !1,
        isOptionEqualToValue: (fe, Y) => fe.uuid === Y.uuid && // prevent same contact in multiple accounts from being selected
        fe.account.uuid === Y.account.uuid,
        noOptionsText: k ? "There are no Accounts associated with this Contact." : "No matches...",
        value: b,
        inputValue: y,
        onInputChange: te,
        onChange: Z,
        onOpen: () => O(!0),
        onClose: (fe, Y) => {
          (Y === "blur" || Y === "escape") && (O(!1), Y === "blur" && (x(""), S("")));
        },
        getOptionLabel: (fe) => typeof fe == "string" ? fe : fe.uuid,
        getOptionDisabled: N,
        renderInputProps: {
          startAdornment: /* @__PURE__ */ p.jsx(it, { icon: "search", color: "disabled", fontSize: "small" })
        },
        renderOption: (fe, Y, { selected: ae }) => {
          const { key: se, ...L } = fe, W = f || !Y.primaryEmail, M = Y.primaryEmail ? void 0 : "No email address available. Cannot select this recipient.";
          return /* @__PURE__ */ p.jsx(
            HR,
            {
              listItemProps: L,
              disabled: W,
              tooltip: M,
              children: /* @__PURE__ */ p.jsx(
                zR,
                {
                  option: Y,
                  selected: ae,
                  disabled: W
                }
              )
            },
            se
          );
        }
      }
    ),
    l && l.uuid && (ne == null ? void 0 : ne.length) === 0 && /* @__PURE__ */ p.jsx(Pe, { width: "100%", justifyContent: "center", alignItems: "center", mt: 2, children: /* @__PURE__ */ p.jsx(wi, { variant: "label", color: "textSecondary", children: "There are no contacts associated with this account" }) }),
    k && d[0] && /* @__PURE__ */ p.jsxs(
      Pe,
      {
        width: "100%",
        justifyContent: "center",
        alignItems: "flex-start",
        mt: 2,
        p: 2,
        sx: (fe) => ({
          backgroundColor: fe.palette.common.warning[50],
          borderRadius: 1
        }),
        children: [
          /* @__PURE__ */ p.jsxs(Pe, { direction: "row", alignItems: "center", gap: 1, children: [
            /* @__PURE__ */ p.jsx(it, { icon: "warning", color: "warning", fontSize: "small" }),
            /* @__PURE__ */ p.jsxs(wi, { variant: "body2", fontWeight: "medium", children: [
              d[0].first_name,
              " ",
              d[0].last_name,
              " ",
              "does not have an Account."
            ] })
          ] }),
          /* @__PURE__ */ p.jsxs(wi, { variant: "body2", color: "textSecondary", mt: 1, children: [
            "Add an Account to this Contact to proceed.",
            d[0].id && /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
              " ",
              /* @__PURE__ */ p.jsx(
                Ii,
                {
                  href: `/contactdetails/${d[0].id}?tab=relationships`,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  sx: { fontWeight: "medium" },
                  children: "Create an Account"
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ p.jsxs(wi, { variant: "body2", color: "textSecondary", mt: 1, children: [
            "or",
            " ",
            /* @__PURE__ */ p.jsx(
              Ii,
              {
                component: "button",
                type: "button",
                onClick: q,
                sx: { fontWeight: "medium", verticalAlign: "baseline" },
                children: "Unassign Contact"
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ p.jsx(
      qR,
      {
        account: (oe = b[0]) == null ? void 0 : oe.account.name,
        recipients: b,
        onRemove: G,
        disabled: f,
        disableRemoval: s,
        maxHeight: g
      }
    )
  ] });
}
const QR = tt(Me, {
  shouldForwardProp: (e) => e !== "presentation"
})(({ theme: e, presentation: n }) => ({
  color: e.palette.text.primary,
  fontSize: e.typography.body1.fontSize,
  lineHeight: e.typography.body1.lineHeight,
  "& img": {
    maxWidth: "100%",
    height: "auto"
  },
  /* Match Client Preview “info” light blue (e.g. badge); not primary (navy actions). */
  "& a": {
    color: e.palette.info.light,
    textDecoration: "underline"
  },
  "& p": { margin: 0 },
  "& p + p": {
    marginTop: n === "message" ? 0 : e.spacing(1)
  },
  /* TinyMCE uses forced_root_block: 'div' — mirror paragraph spacing for stacked blocks */
  "& div": { margin: 0 },
  "& div + div": {
    marginTop: n === "message" ? 0 : e.spacing(1)
  }
}));
function JR(e) {
  if (typeof document > "u")
    return e;
  const n = document.createElement("textarea");
  return n.innerHTML = e, n.value;
}
function eM({
  html: e,
  presentation: n = "default"
}) {
  const r = n === "message" ? e : JR(e);
  return /* @__PURE__ */ p.jsx(QR, { presentation: n, children: /* @__PURE__ */ p.jsx(w7, { content: r }) });
}
const tM = {
  contact: "contact",
  emp: "employee"
}, nM = (e) => tM[e] || e, md = (e) => (n) => {
  const r = n.label.toLowerCase(), a = e.toLowerCase();
  return r.includes(a);
}, iM = ({
  selectedAccount: e,
  employeesAndContacts: n,
  relContactsAndCstOfAccount: r,
  employeesAndContactsOfAccount: a,
  searchedContacts: o,
  recipientSearchString: l = "",
  isCustomer: d
}) => e && !d ? l ? (a == null ? void 0 : a.filter(
  md(l)
)) || [] : a || [] : e && d ? l ? (r == null ? void 0 : r.filter(
  md(l)
)) || [] : r || [] : d ? l ? (n == null ? void 0 : n.filter(
  md(l)
)) || [] : n || [] : l ? o || [] : n || [], um = (e) => (n) => {
  const r = n.label.toLowerCase(), a = e.toLowerCase();
  return r.includes(a);
}, rM = ({
  fixedToContactId: e,
  selectedRecipient: n,
  accountSearchString: r,
  searchedAccounts: a,
  accountsAsTaskData: o,
  loggedUserAccounts: l,
  isCustomer: d
}) => {
  var c;
  if (e) return n == null ? void 0 : n.accounts;
  if (n && n.type === "contact")
    return r ? ((c = n.accounts) == null ? void 0 : c.filter(
      um(r)
    )) || [] : n.accounts || [];
  if (d) {
    const f = (l == null ? void 0 : l.data) || [];
    return r ? f.filter(um(r)) : f;
  }
  return r ? a || [] : o || [];
};
function sM(e) {
  const { getContactDetails: n } = Jt().contacts;
  return Sn({
    queryKey: ["contact", String(e)],
    queryFn: n,
    enabled: !!e
  });
}
function aM(e) {
  const {
    contacts: { getEmployeesAndContactsOfAccount: n }
  } = Jt();
  return Sn({
    queryKey: ["employees-and-contacts-of-account", String(e)],
    queryFn: n,
    enabled: !!e
  });
}
function oM(e, n) {
  const {
    contacts: { getRelContactsAndCstOfAccounts: r }
  } = Jt();
  return Sn({
    queryKey: ["contacts_and_cst_of_accounts", String(e)],
    queryFn: r,
    enabled: n && !!e
  });
}
function cM() {
  const {
    contacts: { getEmployeesAndContacts: e }
  } = Jt();
  return Sn({
    queryKey: ["employees-and-contacts"],
    queryFn: e
  });
}
function lM(e) {
  const {
    contacts: { searchContacts: n }
  } = Jt();
  return Sn({
    queryKey: ["searched-contacts", e],
    queryFn: n,
    enabled: !!e
  });
}
const uM = ({
  fixedToContactId: e,
  selectedRecipient: n,
  selectedAccount: r,
  recipientSearchString: a,
  accountSearchString: o
}) => {
  var z;
  const { isCustomer: l, isLoading: d } = Z2(), { data: c } = xr(), { data: f, isLoading: s } = cM(), { data: h, isLoading: g } = b_(l), {
    data: t,
    isLoading: i
  } = aM((r == null ? void 0 : r.value) || ""), {
    data: m,
    isLoading: v
  } = oM((r == null ? void 0 : r.value) || "", l), { data: E, isLoading: S } = lM(a), { data: y, isLoading: x } = y_(o, l), { data: b, isLoading: u } = ib(), {
    data: I,
    isLoading: O
  } = Pf(String(((z = c == null ? void 0 : c.data) == null ? void 0 : z.contact_id) || "")), D = l ? !1 : g, $ = r ? i : !1, K = r && l ? v : !1, H = a ? S : !1, B = o && !l ? x : !1, R = iM({
    relContactsAndCstOfAccount: m,
    selectedAccount: r,
    recipientSearchString: a,
    employeesAndContacts: f,
    searchedContacts: E,
    employeesAndContactsOfAccount: t,
    isCustomer: l
  }), _ = rM({
    fixedToContactId: e,
    selectedRecipient: n,
    accountSearchString: o,
    accountsAsTaskData: h,
    searchedAccounts: y,
    loggedUserAccounts: b,
    isCustomer: l
  }), { recipientContacts: A, recipientEmployees: k } = R.reduce(
    (T, w) => (w.type === "contact" && T.recipientContacts.push(w), w.type === "emp" && T.recipientEmployees.push(w), T),
    { recipientContacts: [], recipientEmployees: [] }
  );
  return {
    recipientContacts: A,
    recipientEmployees: k,
    loggedUserAccounts: b,
    contactAccountsWithCST: I,
    accounts: _,
    isLoading: s || D || H || $ || B || u || K || d || O
  };
}, dm = tt(Me)(({ theme: e }) => ({
  width: "80px",
  [e.breakpoints.down("md")]: {
    width: "64px"
  }
})), dM = ({
  open: e = !1,
  selectedRecipient: n,
  selectedAccount: r,
  onChange: a,
  onCancel: o,
  fixedToAccountId: l,
  fixedToContactId: d,
  useOnlyEmployees: c,
  accountIsRequired: f,
  shouldAddCSTMembers: s = !1
}) => {
  const [h, g] = Ee(
    n
  ), [t, i] = Ee(r), [m, v] = Ee(""), [E, S] = Ee(""), {
    recipientContacts: y,
    recipientEmployees: x,
    accounts: b,
    isLoading: u,
    contactAccountsWithCST: I
  } = uM({
    selectedRecipient: h,
    selectedAccount: t,
    recipientSearchString: m,
    accountSearchString: E
  }), O = Tt(
    () => c ? x : [...y, ...x],
    [x, y, c]
  ), D = () => {
    var B;
    let H = [];
    if (s) {
      const R = (B = I == null ? void 0 : I.data) == null ? void 0 : B.find(
        (_) => _.value === (t == null ? void 0 : t.value)
      );
      H = (R == null ? void 0 : R.cst_member) || [];
    }
    if ((H == null ? void 0 : H.length) > 0) {
      const _ = [
        h,
        ...H || []
      ].map(
        (A) => ({
          recipient: A,
          account: t
        })
      );
      a(_);
    } else
      a({
        recipient: h,
        account: t
      });
    o(), g(null), i(null), v(""), S("");
  };
  Pa(() => {
    (b == null ? void 0 : b.length) === 1 && i(b[0]);
  }, [b]), Pa(() => {
    var H;
    h && ((H = h.accounts) == null ? void 0 : H.length) === 1 && i(h.accounts[0]);
  }, [h]), ot(() => {
    d && g(n);
  }, [
    d,
    g,
    n,
    h
  ]), ot(() => {
    l && i(r);
  }, [
    l,
    i,
    r,
    t
  ]);
  const K = !h || !t && f;
  return /* @__PURE__ */ p.jsxs(
    qm,
    {
      open: e,
      onClose: o,
      "aria-labelledby": "alert-dialog-title",
      "aria-describedby": "alert-dialog-description",
      fullWidth: !0,
      "data-testid": "contact-selector-container",
      children: [
        /* @__PURE__ */ p.jsx(Vm, { id: "alert-dialog-title", children: "Select Contact" }),
        /* @__PURE__ */ p.jsxs(Xm, { children: [
          /* @__PURE__ */ p.jsxs(Pe, { direction: "row", alignItems: "center", children: [
            /* @__PURE__ */ p.jsx(dm, { children: /* @__PURE__ */ p.jsx(Te, { children: "Recipient:" }) }),
            /* @__PURE__ */ p.jsx(
              Ia,
              {
                data: O,
                onChange: g,
                onSearchChange: v,
                value: h,
                title: "Select Recipient",
                isLoading: u,
                searchString: m,
                renderItem: (H) => /* @__PURE__ */ p.jsxs(
                  Me,
                  {
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    pt: 1,
                    pb: 1,
                    children: [
                      /* @__PURE__ */ p.jsx(Te, { children: H == null ? void 0 : H.label }),
                      /* @__PURE__ */ p.jsx(
                        fr,
                        {
                          label: nM(
                            H == null ? void 0 : H.type
                          ),
                          size: "small"
                        }
                      )
                    ]
                  }
                ),
                disabled: !!d
              }
            )
          ] }),
          /* @__PURE__ */ p.jsxs(Pe, { direction: "row", alignItems: "center", children: [
            /* @__PURE__ */ p.jsx(dm, { children: /* @__PURE__ */ p.jsx(Te, { children: "Account:" }) }),
            /* @__PURE__ */ p.jsx(
              Ia,
              {
                data: d && h ? h.accounts : b,
                onChange: i,
                onSearchChange: S,
                value: t,
                title: "Select Account",
                isLoading: u,
                searchString: E,
                disabled: !!l
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ p.jsxs(Gm, { children: [
          /* @__PURE__ */ p.jsx(lt, { onClick: o, children: "Close" }),
          /* @__PURE__ */ p.jsx(
            lt,
            {
              onClick: D,
              autoFocus: !0,
              variant: "contained",
              disabled: K,
              children: "OK"
            }
          )
        ] })
      ]
    }
  );
}, hM = tt(Me)(({ theme: e }) => ({
  borderStyle: "solid",
  borderWidth: "1.5px",
  borderRadius: "8px",
  width: "100%",
  display: "flex",
  rowGap: "4px",
  columnGap: "4px",
  padding: "14.5px 14px",
  minHeight: "54.56px",
  // strange...
  maxHeight: "100px",
  overflow: "auto",
  color: e.palette.common.neutrals[300],
  flexWrap: "wrap",
  "&:hover": {
    borderColor: e.palette.common.neutrals[800]
  },
  "&:focus": {
    borderColor: e.palette.common.primary[500]
  }
})), fM = tt(c5)(() => ({
  width: "100%"
})), pM = tt(Gh)(({ theme: e }) => ({
  color: e.palette.error.main
})), gM = ({
  placeholder: e,
  value: n = [],
  onAddElement: r,
  onRemoveElement: a,
  error: o,
  helperText: l,
  fixedToAccountId: d,
  fixedToContactId: c,
  accountIsRequired: f,
  shouldAddCSTMembers: s
}) => {
  const [h, g] = Ee(!1), t = () => g(!1), [i, m] = Ee(), [v, E] = Ee(), { data: S } = sM(c), { data: y } = x_(d), [x, b] = Ee(n);
  return ot(() => {
    if (n.length !== x.length) {
      const u = Y8(
        n,
        (I) => {
          var O, D;
          return `${(O = I == null ? void 0 : I.account) == null ? void 0 : O.value}${(D = I == null ? void 0 : I.recipient) == null ? void 0 : D.value}`;
        }
      );
      b(u);
    }
  }, [n, x.length]), ot(() => {
    if (c && !i && S) {
      const { contact: u, accounts: I } = (S == null ? void 0 : S.data[0]) || {};
      m({
        value: u.id,
        label: `${u.first_name} ${u.first_name}`,
        accounts: I
      });
    }
  }, [c, i, S]), ot(() => {
    d && !v && y && E({
      value: y == null ? void 0 : y.account.id,
      label: y == null ? void 0 : y.account.name
    });
  }, [d, v, y]), /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsxs(fM, { children: [
      /* @__PURE__ */ p.jsxs(
        hM,
        {
          role: "button",
          sx: {
            borderColor: (u) => o ? u.palette.error.main : u.palette.common.neutrals[400]
          },
          tabIndex: 0,
          onClick: () => g(!0),
          children: [
            x.length === 0 && e,
            x.map((u, I) => {
              var O, D, $, K;
              return /* @__PURE__ */ p.jsx(
                L5,
                {
                  onRemoveClick: () => a(u, I),
                  userName: (O = u == null ? void 0 : u.recipient) == null ? void 0 : O.label,
                  accountName: (D = u == null ? void 0 : u.account) == null ? void 0 : D.label
                },
                `${($ = u == null ? void 0 : u.recipient) == null ? void 0 : $.value}_${(K = u == null ? void 0 : u.account) == null ? void 0 : K.value}`
              );
            })
          ]
        }
      ),
      o && /* @__PURE__ */ p.jsx(pM, { variant: "filled", "data-testid": "field-error", children: l })
    ] }),
    /* @__PURE__ */ p.jsx(
      dM,
      {
        fixedToAccountId: d,
        fixedToContactId: c,
        selectedAccount: v || null,
        open: h,
        selectedRecipient: i,
        onCancel: t,
        onChange: r,
        accountIsRequired: f,
        shouldAddCSTMembers: s
      }
    )
  ] });
}, cU = ({
  icon: e,
  severity: n,
  actionButtonText: r = "Got it",
  onActionButtonClick: a,
  title: o,
  message: l
}) => /* @__PURE__ */ p.jsx(Me, { m: 0, p: 0, maxWidth: 400, children: /* @__PURE__ */ p.jsxs(
  Za,
  {
    icon: e ? /* @__PURE__ */ p.jsx(it, { icon: e }) : void 0,
    severity: n,
    action: a ? /* @__PURE__ */ p.jsx(
      lt,
      {
        variant: "outlined",
        color: "inherit",
        style: { fontSize: 12 },
        onClick: a,
        children: r
      }
    ) : null,
    children: [
      o && /* @__PURE__ */ p.jsx(ef, { variant: "label", children: o }),
      l && /* @__PURE__ */ p.jsx(Te, { variant: "body1", children: l })
    ]
  }
) }), lU = ({ test: e }) => {
  const { data: n } = hx({
    workspace: "client"
  });
  return /* @__PURE__ */ p.jsxs(Me, { children: [
    e,
    ":",
    n == null ? void 0 : n.intercom_user_jwt
  ] });
}, cy = Jr(null), uU = ({
  children: e
}) => {
  const [n, r] = Ee(
    {}
  ), a = Oe((c, f) => {
    r((s) => ({
      ...s,
      [c]: f
    }));
  }, []), o = Oe((c) => {
    r((f) => {
      const s = { ...f };
      return delete s[c], s;
    });
  }, []), l = Object.values(n).some(Boolean), d = {
    registerLoader: a,
    unregisterLoader: o,
    isAnyLoading: l
  };
  return /* @__PURE__ */ p.jsxs(cy.Provider, { value: d, children: [
    /* @__PURE__ */ p.jsx(mi, { open: l }),
    e
  ] });
}, mM = () => {
  const e = xs(cy);
  if (!e)
    throw new Error(
      "useUnifiedLoader must be used within a UnifiedLoaderProvider"
    );
  return e;
}, dU = (e, n) => {
  const { registerLoader: r, unregisterLoader: a } = mM();
  Nn.useEffect(() => (r(e, n), () => a(e)), [e, n, r, a]);
}, xM = tt(Me)(({ theme: e }) => ({
  width: "100%",
  flexGrow: 1,
  color: e.palette.common.black,
  paddingTop: "48px",
  paddingBottom: "16px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "center",
  maxWidth: e.breakpoints.values.sm,
  [e.breakpoints.up("md")]: {
    color: e.palette.text.primary
  }
})), hU = ({
  title: e = "Forgot Password?",
  form: n,
  backLink: r,
  footer: a,
  formMaxWidth: o = 420
}) => /* @__PURE__ */ p.jsx(Me, { sx: { width: "100%", minHeight: "var(--liscio-app-viewport-height, 100vh)", backgroundColor: "background.default" }, children: /* @__PURE__ */ p.jsx(rx, { maxWidth: !1, disableGutters: !0, innerProps: { minHeight: "var(--liscio-app-viewport-height, 100vh)" }, children: /* @__PURE__ */ p.jsxs(xM, { children: [
  /* @__PURE__ */ p.jsx(Pe, { alignItems: "center", mb: 5, children: /* @__PURE__ */ p.jsx(tf, { width: 200, variant: "logoSplash" }) }),
  /* @__PURE__ */ p.jsxs(Me, { width: "100%", maxWidth: o, children: [
    /* @__PURE__ */ p.jsx(Te, { mb: 4, variant: "h3", textAlign: "center", children: e }),
    n
  ] }),
  /* @__PURE__ */ p.jsx(Me, { display: "flex", flexDirection: "column", alignItems: "center", mt: 3, children: r }),
  a
] }) }) });
var s1 = {};
Object.defineProperty(s1, "__esModule", {
  value: !0
});
var ly = s1.default = void 0, bM = vM(Nn), yM = I2;
function uy(e) {
  if (typeof WeakMap != "function") return null;
  var n = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (uy = function(a) {
    return a ? r : n;
  })(e);
}
function vM(e, n) {
  if (e && e.__esModule) return e;
  if (e === null || typeof e != "object" && typeof e != "function") return { default: e };
  var r = uy(n);
  if (r && r.has(e)) return r.get(e);
  var a = { __proto__: null }, o = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var l in e) if (l !== "default" && Object.prototype.hasOwnProperty.call(e, l)) {
    var d = o ? Object.getOwnPropertyDescriptor(e, l) : null;
    d && (d.get || d.set) ? Object.defineProperty(a, l, d) : a[l] = e[l];
  }
  return a.default = e, r && r.set(e, a), a;
}
function wM(e) {
  return Object.keys(e).length === 0;
}
function SM(e = null) {
  const n = bM.useContext(yM.ThemeContext);
  return !n || wM(n) ? e : n;
}
ly = s1.default = SM;
var Ni = "top", cr = "bottom", lr = "right", Li = "left", a1 = "auto", Tc = [Ni, cr, lr, Li], Va = "start", lc = "end", _M = "clippingParents", dy = "viewport", ko = "popper", CM = "reference", hm = /* @__PURE__ */ Tc.reduce(function(e, n) {
  return e.concat([n + "-" + Va, n + "-" + lc]);
}, []), hy = /* @__PURE__ */ [].concat(Tc, [a1]).reduce(function(e, n) {
  return e.concat([n, n + "-" + Va, n + "-" + lc]);
}, []), AM = "beforeRead", kM = "read", EM = "afterRead", IM = "beforeMain", TM = "main", OM = "afterMain", FM = "beforeWrite", PM = "write", jM = "afterWrite", RM = [AM, kM, EM, IM, TM, OM, FM, PM, jM];
function jr(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Gi(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var n = e.ownerDocument;
    return n && n.defaultView || window;
  }
  return e;
}
function Ws(e) {
  var n = Gi(e).Element;
  return e instanceof n || e instanceof Element;
}
function ar(e) {
  var n = Gi(e).HTMLElement;
  return e instanceof n || e instanceof HTMLElement;
}
function o1(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var n = Gi(e).ShadowRoot;
  return e instanceof n || e instanceof ShadowRoot;
}
function MM(e) {
  var n = e.state;
  Object.keys(n.elements).forEach(function(r) {
    var a = n.styles[r] || {}, o = n.attributes[r] || {}, l = n.elements[r];
    !ar(l) || !jr(l) || (Object.assign(l.style, a), Object.keys(o).forEach(function(d) {
      var c = o[d];
      c === !1 ? l.removeAttribute(d) : l.setAttribute(d, c === !0 ? "" : c);
    }));
  });
}
function DM(e) {
  var n = e.state, r = {
    popper: {
      position: n.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(n.elements.popper.style, r.popper), n.styles = r, n.elements.arrow && Object.assign(n.elements.arrow.style, r.arrow), function() {
    Object.keys(n.elements).forEach(function(a) {
      var o = n.elements[a], l = n.attributes[a] || {}, d = Object.keys(n.styles.hasOwnProperty(a) ? n.styles[a] : r[a]), c = d.reduce(function(f, s) {
        return f[s] = "", f;
      }, {});
      !ar(o) || !jr(o) || (Object.assign(o.style, c), Object.keys(l).forEach(function(f) {
        o.removeAttribute(f);
      }));
    });
  };
}
const NM = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: MM,
  effect: DM,
  requires: ["computeStyles"]
};
function Fr(e) {
  return e.split("-")[0];
}
var Ds = Math.max, a0 = Math.min, Xa = Math.round;
function Bh() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(n) {
    return n.brand + "/" + n.version;
  }).join(" ") : navigator.userAgent;
}
function fy() {
  return !/^((?!chrome|android).)*safari/i.test(Bh());
}
function Ga(e, n, r) {
  n === void 0 && (n = !1), r === void 0 && (r = !1);
  var a = e.getBoundingClientRect(), o = 1, l = 1;
  n && ar(e) && (o = e.offsetWidth > 0 && Xa(a.width) / e.offsetWidth || 1, l = e.offsetHeight > 0 && Xa(a.height) / e.offsetHeight || 1);
  var d = Ws(e) ? Gi(e) : window, c = d.visualViewport, f = !fy() && r, s = (a.left + (f && c ? c.offsetLeft : 0)) / o, h = (a.top + (f && c ? c.offsetTop : 0)) / l, g = a.width / o, t = a.height / l;
  return {
    width: g,
    height: t,
    top: h,
    right: s + g,
    bottom: h + t,
    left: s,
    x: s,
    y: h
  };
}
function c1(e) {
  var n = Ga(e), r = e.offsetWidth, a = e.offsetHeight;
  return Math.abs(n.width - r) <= 1 && (r = n.width), Math.abs(n.height - a) <= 1 && (a = n.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: a
  };
}
function py(e, n) {
  var r = n.getRootNode && n.getRootNode();
  if (e.contains(n))
    return !0;
  if (r && o1(r)) {
    var a = n;
    do {
      if (a && e.isSameNode(a))
        return !0;
      a = a.parentNode || a.host;
    } while (a);
  }
  return !1;
}
function Qr(e) {
  return Gi(e).getComputedStyle(e);
}
function LM(e) {
  return ["table", "td", "th"].indexOf(jr(e)) >= 0;
}
function Cs(e) {
  return ((Ws(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Y0(e) {
  return jr(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (o1(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Cs(e)
  );
}
function fm(e) {
  return !ar(e) || // https://github.com/popperjs/popper-core/issues/837
  Qr(e).position === "fixed" ? null : e.offsetParent;
}
function BM(e) {
  var n = /firefox/i.test(Bh()), r = /Trident/i.test(Bh());
  if (r && ar(e)) {
    var a = Qr(e);
    if (a.position === "fixed")
      return null;
  }
  var o = Y0(e);
  for (o1(o) && (o = o.host); ar(o) && ["html", "body"].indexOf(jr(o)) < 0; ) {
    var l = Qr(o);
    if (l.transform !== "none" || l.perspective !== "none" || l.contain === "paint" || ["transform", "perspective"].indexOf(l.willChange) !== -1 || n && l.willChange === "filter" || n && l.filter && l.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function Oc(e) {
  for (var n = Gi(e), r = fm(e); r && LM(r) && Qr(r).position === "static"; )
    r = fm(r);
  return r && (jr(r) === "html" || jr(r) === "body" && Qr(r).position === "static") ? n : r || BM(e) || n;
}
function l1(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Wo(e, n, r) {
  return Ds(e, a0(n, r));
}
function $M(e, n, r) {
  var a = Wo(e, n, r);
  return a > r ? r : a;
}
function gy() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function my(e) {
  return Object.assign({}, gy(), e);
}
function xy(e, n) {
  return n.reduce(function(r, a) {
    return r[a] = e, r;
  }, {});
}
var UM = function(n, r) {
  return n = typeof n == "function" ? n(Object.assign({}, r.rects, {
    placement: r.placement
  })) : n, my(typeof n != "number" ? n : xy(n, Tc));
};
function zM(e) {
  var n, r = e.state, a = e.name, o = e.options, l = r.elements.arrow, d = r.modifiersData.popperOffsets, c = Fr(r.placement), f = l1(c), s = [Li, lr].indexOf(c) >= 0, h = s ? "height" : "width";
  if (!(!l || !d)) {
    var g = UM(o.padding, r), t = c1(l), i = f === "y" ? Ni : Li, m = f === "y" ? cr : lr, v = r.rects.reference[h] + r.rects.reference[f] - d[f] - r.rects.popper[h], E = d[f] - r.rects.reference[f], S = Oc(l), y = S ? f === "y" ? S.clientHeight || 0 : S.clientWidth || 0 : 0, x = v / 2 - E / 2, b = g[i], u = y - t[h] - g[m], I = y / 2 - t[h] / 2 + x, O = Wo(b, I, u), D = f;
    r.modifiersData[a] = (n = {}, n[D] = O, n.centerOffset = O - I, n);
  }
}
function HM(e) {
  var n = e.state, r = e.options, a = r.element, o = a === void 0 ? "[data-popper-arrow]" : a;
  o != null && (typeof o == "string" && (o = n.elements.popper.querySelector(o), !o) || py(n.elements.popper, o) && (n.elements.arrow = o));
}
const WM = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: zM,
  effect: HM,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Ka(e) {
  return e.split("-")[1];
}
var qM = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function VM(e, n) {
  var r = e.x, a = e.y, o = n.devicePixelRatio || 1;
  return {
    x: Xa(r * o) / o || 0,
    y: Xa(a * o) / o || 0
  };
}
function pm(e) {
  var n, r = e.popper, a = e.popperRect, o = e.placement, l = e.variation, d = e.offsets, c = e.position, f = e.gpuAcceleration, s = e.adaptive, h = e.roundOffsets, g = e.isFixed, t = d.x, i = t === void 0 ? 0 : t, m = d.y, v = m === void 0 ? 0 : m, E = typeof h == "function" ? h({
    x: i,
    y: v
  }) : {
    x: i,
    y: v
  };
  i = E.x, v = E.y;
  var S = d.hasOwnProperty("x"), y = d.hasOwnProperty("y"), x = Li, b = Ni, u = window;
  if (s) {
    var I = Oc(r), O = "clientHeight", D = "clientWidth";
    if (I === Gi(r) && (I = Cs(r), Qr(I).position !== "static" && c === "absolute" && (O = "scrollHeight", D = "scrollWidth")), I = I, o === Ni || (o === Li || o === lr) && l === lc) {
      b = cr;
      var $ = g && I === u && u.visualViewport ? u.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        I[O]
      );
      v -= $ - a.height, v *= f ? 1 : -1;
    }
    if (o === Li || (o === Ni || o === cr) && l === lc) {
      x = lr;
      var K = g && I === u && u.visualViewport ? u.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        I[D]
      );
      i -= K - a.width, i *= f ? 1 : -1;
    }
  }
  var H = Object.assign({
    position: c
  }, s && qM), B = h === !0 ? VM({
    x: i,
    y: v
  }, Gi(r)) : {
    x: i,
    y: v
  };
  if (i = B.x, v = B.y, f) {
    var R;
    return Object.assign({}, H, (R = {}, R[b] = y ? "0" : "", R[x] = S ? "0" : "", R.transform = (u.devicePixelRatio || 1) <= 1 ? "translate(" + i + "px, " + v + "px)" : "translate3d(" + i + "px, " + v + "px, 0)", R));
  }
  return Object.assign({}, H, (n = {}, n[b] = y ? v + "px" : "", n[x] = S ? i + "px" : "", n.transform = "", n));
}
function XM(e) {
  var n = e.state, r = e.options, a = r.gpuAcceleration, o = a === void 0 ? !0 : a, l = r.adaptive, d = l === void 0 ? !0 : l, c = r.roundOffsets, f = c === void 0 ? !0 : c, s = {
    placement: Fr(n.placement),
    variation: Ka(n.placement),
    popper: n.elements.popper,
    popperRect: n.rects.popper,
    gpuAcceleration: o,
    isFixed: n.options.strategy === "fixed"
  };
  n.modifiersData.popperOffsets != null && (n.styles.popper = Object.assign({}, n.styles.popper, pm(Object.assign({}, s, {
    offsets: n.modifiersData.popperOffsets,
    position: n.options.strategy,
    adaptive: d,
    roundOffsets: f
  })))), n.modifiersData.arrow != null && (n.styles.arrow = Object.assign({}, n.styles.arrow, pm(Object.assign({}, s, {
    offsets: n.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: f
  })))), n.attributes.popper = Object.assign({}, n.attributes.popper, {
    "data-popper-placement": n.placement
  });
}
const GM = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: XM,
  data: {}
};
var il = {
  passive: !0
};
function KM(e) {
  var n = e.state, r = e.instance, a = e.options, o = a.scroll, l = o === void 0 ? !0 : o, d = a.resize, c = d === void 0 ? !0 : d, f = Gi(n.elements.popper), s = [].concat(n.scrollParents.reference, n.scrollParents.popper);
  return l && s.forEach(function(h) {
    h.addEventListener("scroll", r.update, il);
  }), c && f.addEventListener("resize", r.update, il), function() {
    l && s.forEach(function(h) {
      h.removeEventListener("scroll", r.update, il);
    }), c && f.removeEventListener("resize", r.update, il);
  };
}
const YM = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: KM,
  data: {}
};
var ZM = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Cl(e) {
  return e.replace(/left|right|bottom|top/g, function(n) {
    return ZM[n];
  });
}
var QM = {
  start: "end",
  end: "start"
};
function gm(e) {
  return e.replace(/start|end/g, function(n) {
    return QM[n];
  });
}
function u1(e) {
  var n = Gi(e), r = n.pageXOffset, a = n.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: a
  };
}
function d1(e) {
  return Ga(Cs(e)).left + u1(e).scrollLeft;
}
function JM(e, n) {
  var r = Gi(e), a = Cs(e), o = r.visualViewport, l = a.clientWidth, d = a.clientHeight, c = 0, f = 0;
  if (o) {
    l = o.width, d = o.height;
    var s = fy();
    (s || !s && n === "fixed") && (c = o.offsetLeft, f = o.offsetTop);
  }
  return {
    width: l,
    height: d,
    x: c + d1(e),
    y: f
  };
}
function eD(e) {
  var n, r = Cs(e), a = u1(e), o = (n = e.ownerDocument) == null ? void 0 : n.body, l = Ds(r.scrollWidth, r.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), d = Ds(r.scrollHeight, r.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), c = -a.scrollLeft + d1(e), f = -a.scrollTop;
  return Qr(o || r).direction === "rtl" && (c += Ds(r.clientWidth, o ? o.clientWidth : 0) - l), {
    width: l,
    height: d,
    x: c,
    y: f
  };
}
function h1(e) {
  var n = Qr(e), r = n.overflow, a = n.overflowX, o = n.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + o + a);
}
function by(e) {
  return ["html", "body", "#document"].indexOf(jr(e)) >= 0 ? e.ownerDocument.body : ar(e) && h1(e) ? e : by(Y0(e));
}
function qo(e, n) {
  var r;
  n === void 0 && (n = []);
  var a = by(e), o = a === ((r = e.ownerDocument) == null ? void 0 : r.body), l = Gi(a), d = o ? [l].concat(l.visualViewport || [], h1(a) ? a : []) : a, c = n.concat(d);
  return o ? c : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    c.concat(qo(Y0(d)))
  );
}
function $h(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function tD(e, n) {
  var r = Ga(e, !1, n === "fixed");
  return r.top = r.top + e.clientTop, r.left = r.left + e.clientLeft, r.bottom = r.top + e.clientHeight, r.right = r.left + e.clientWidth, r.width = e.clientWidth, r.height = e.clientHeight, r.x = r.left, r.y = r.top, r;
}
function mm(e, n, r) {
  return n === dy ? $h(JM(e, r)) : Ws(n) ? tD(n, r) : $h(eD(Cs(e)));
}
function nD(e) {
  var n = qo(Y0(e)), r = ["absolute", "fixed"].indexOf(Qr(e).position) >= 0, a = r && ar(e) ? Oc(e) : e;
  return Ws(a) ? n.filter(function(o) {
    return Ws(o) && py(o, a) && jr(o) !== "body";
  }) : [];
}
function iD(e, n, r, a) {
  var o = n === "clippingParents" ? nD(e) : [].concat(n), l = [].concat(o, [r]), d = l[0], c = l.reduce(function(f, s) {
    var h = mm(e, s, a);
    return f.top = Ds(h.top, f.top), f.right = a0(h.right, f.right), f.bottom = a0(h.bottom, f.bottom), f.left = Ds(h.left, f.left), f;
  }, mm(e, d, a));
  return c.width = c.right - c.left, c.height = c.bottom - c.top, c.x = c.left, c.y = c.top, c;
}
function yy(e) {
  var n = e.reference, r = e.element, a = e.placement, o = a ? Fr(a) : null, l = a ? Ka(a) : null, d = n.x + n.width / 2 - r.width / 2, c = n.y + n.height / 2 - r.height / 2, f;
  switch (o) {
    case Ni:
      f = {
        x: d,
        y: n.y - r.height
      };
      break;
    case cr:
      f = {
        x: d,
        y: n.y + n.height
      };
      break;
    case lr:
      f = {
        x: n.x + n.width,
        y: c
      };
      break;
    case Li:
      f = {
        x: n.x - r.width,
        y: c
      };
      break;
    default:
      f = {
        x: n.x,
        y: n.y
      };
  }
  var s = o ? l1(o) : null;
  if (s != null) {
    var h = s === "y" ? "height" : "width";
    switch (l) {
      case Va:
        f[s] = f[s] - (n[h] / 2 - r[h] / 2);
        break;
      case lc:
        f[s] = f[s] + (n[h] / 2 - r[h] / 2);
        break;
    }
  }
  return f;
}
function uc(e, n) {
  n === void 0 && (n = {});
  var r = n, a = r.placement, o = a === void 0 ? e.placement : a, l = r.strategy, d = l === void 0 ? e.strategy : l, c = r.boundary, f = c === void 0 ? _M : c, s = r.rootBoundary, h = s === void 0 ? dy : s, g = r.elementContext, t = g === void 0 ? ko : g, i = r.altBoundary, m = i === void 0 ? !1 : i, v = r.padding, E = v === void 0 ? 0 : v, S = my(typeof E != "number" ? E : xy(E, Tc)), y = t === ko ? CM : ko, x = e.rects.popper, b = e.elements[m ? y : t], u = iD(Ws(b) ? b : b.contextElement || Cs(e.elements.popper), f, h, d), I = Ga(e.elements.reference), O = yy({
    reference: I,
    element: x,
    strategy: "absolute",
    placement: o
  }), D = $h(Object.assign({}, x, O)), $ = t === ko ? D : I, K = {
    top: u.top - $.top + S.top,
    bottom: $.bottom - u.bottom + S.bottom,
    left: u.left - $.left + S.left,
    right: $.right - u.right + S.right
  }, H = e.modifiersData.offset;
  if (t === ko && H) {
    var B = H[o];
    Object.keys(K).forEach(function(R) {
      var _ = [lr, cr].indexOf(R) >= 0 ? 1 : -1, A = [Ni, cr].indexOf(R) >= 0 ? "y" : "x";
      K[R] += B[A] * _;
    });
  }
  return K;
}
function rD(e, n) {
  n === void 0 && (n = {});
  var r = n, a = r.placement, o = r.boundary, l = r.rootBoundary, d = r.padding, c = r.flipVariations, f = r.allowedAutoPlacements, s = f === void 0 ? hy : f, h = Ka(a), g = h ? c ? hm : hm.filter(function(m) {
    return Ka(m) === h;
  }) : Tc, t = g.filter(function(m) {
    return s.indexOf(m) >= 0;
  });
  t.length === 0 && (t = g);
  var i = t.reduce(function(m, v) {
    return m[v] = uc(e, {
      placement: v,
      boundary: o,
      rootBoundary: l,
      padding: d
    })[Fr(v)], m;
  }, {});
  return Object.keys(i).sort(function(m, v) {
    return i[m] - i[v];
  });
}
function sD(e) {
  if (Fr(e) === a1)
    return [];
  var n = Cl(e);
  return [gm(e), n, gm(n)];
}
function aD(e) {
  var n = e.state, r = e.options, a = e.name;
  if (!n.modifiersData[a]._skip) {
    for (var o = r.mainAxis, l = o === void 0 ? !0 : o, d = r.altAxis, c = d === void 0 ? !0 : d, f = r.fallbackPlacements, s = r.padding, h = r.boundary, g = r.rootBoundary, t = r.altBoundary, i = r.flipVariations, m = i === void 0 ? !0 : i, v = r.allowedAutoPlacements, E = n.options.placement, S = Fr(E), y = S === E, x = f || (y || !m ? [Cl(E)] : sD(E)), b = [E].concat(x).reduce(function(J, ne) {
      return J.concat(Fr(ne) === a1 ? rD(n, {
        placement: ne,
        boundary: h,
        rootBoundary: g,
        padding: s,
        flipVariations: m,
        allowedAutoPlacements: v
      }) : ne);
    }, []), u = n.rects.reference, I = n.rects.popper, O = /* @__PURE__ */ new Map(), D = !0, $ = b[0], K = 0; K < b.length; K++) {
      var H = b[K], B = Fr(H), R = Ka(H) === Va, _ = [Ni, cr].indexOf(B) >= 0, A = _ ? "width" : "height", k = uc(n, {
        placement: H,
        boundary: h,
        rootBoundary: g,
        altBoundary: t,
        padding: s
      }), z = _ ? R ? lr : Li : R ? cr : Ni;
      u[A] > I[A] && (z = Cl(z));
      var T = Cl(z), w = [];
      if (l && w.push(k[B] <= 0), c && w.push(k[z] <= 0, k[T] <= 0), w.every(function(J) {
        return J;
      })) {
        $ = H, D = !1;
        break;
      }
      O.set(H, w);
    }
    if (D)
      for (var F = m ? 3 : 1, j = function(ne) {
        var Z = b.find(function(te) {
          var G = O.get(te);
          if (G)
            return G.slice(0, ne).every(function(N) {
              return N;
            });
        });
        if (Z)
          return $ = Z, "break";
      }, P = F; P > 0; P--) {
        var V = j(P);
        if (V === "break") break;
      }
    n.placement !== $ && (n.modifiersData[a]._skip = !0, n.placement = $, n.reset = !0);
  }
}
const oD = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: aD,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function xm(e, n, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: e.top - n.height - r.y,
    right: e.right - n.width + r.x,
    bottom: e.bottom - n.height + r.y,
    left: e.left - n.width - r.x
  };
}
function bm(e) {
  return [Ni, lr, cr, Li].some(function(n) {
    return e[n] >= 0;
  });
}
function cD(e) {
  var n = e.state, r = e.name, a = n.rects.reference, o = n.rects.popper, l = n.modifiersData.preventOverflow, d = uc(n, {
    elementContext: "reference"
  }), c = uc(n, {
    altBoundary: !0
  }), f = xm(d, a), s = xm(c, o, l), h = bm(f), g = bm(s);
  n.modifiersData[r] = {
    referenceClippingOffsets: f,
    popperEscapeOffsets: s,
    isReferenceHidden: h,
    hasPopperEscaped: g
  }, n.attributes.popper = Object.assign({}, n.attributes.popper, {
    "data-popper-reference-hidden": h,
    "data-popper-escaped": g
  });
}
const lD = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: cD
};
function uD(e, n, r) {
  var a = Fr(e), o = [Li, Ni].indexOf(a) >= 0 ? -1 : 1, l = typeof r == "function" ? r(Object.assign({}, n, {
    placement: e
  })) : r, d = l[0], c = l[1];
  return d = d || 0, c = (c || 0) * o, [Li, lr].indexOf(a) >= 0 ? {
    x: c,
    y: d
  } : {
    x: d,
    y: c
  };
}
function dD(e) {
  var n = e.state, r = e.options, a = e.name, o = r.offset, l = o === void 0 ? [0, 0] : o, d = hy.reduce(function(h, g) {
    return h[g] = uD(g, n.rects, l), h;
  }, {}), c = d[n.placement], f = c.x, s = c.y;
  n.modifiersData.popperOffsets != null && (n.modifiersData.popperOffsets.x += f, n.modifiersData.popperOffsets.y += s), n.modifiersData[a] = d;
}
const hD = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: dD
};
function fD(e) {
  var n = e.state, r = e.name;
  n.modifiersData[r] = yy({
    reference: n.rects.reference,
    element: n.rects.popper,
    strategy: "absolute",
    placement: n.placement
  });
}
const pD = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: fD,
  data: {}
};
function gD(e) {
  return e === "x" ? "y" : "x";
}
function mD(e) {
  var n = e.state, r = e.options, a = e.name, o = r.mainAxis, l = o === void 0 ? !0 : o, d = r.altAxis, c = d === void 0 ? !1 : d, f = r.boundary, s = r.rootBoundary, h = r.altBoundary, g = r.padding, t = r.tether, i = t === void 0 ? !0 : t, m = r.tetherOffset, v = m === void 0 ? 0 : m, E = uc(n, {
    boundary: f,
    rootBoundary: s,
    padding: g,
    altBoundary: h
  }), S = Fr(n.placement), y = Ka(n.placement), x = !y, b = l1(S), u = gD(b), I = n.modifiersData.popperOffsets, O = n.rects.reference, D = n.rects.popper, $ = typeof v == "function" ? v(Object.assign({}, n.rects, {
    placement: n.placement
  })) : v, K = typeof $ == "number" ? {
    mainAxis: $,
    altAxis: $
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, $), H = n.modifiersData.offset ? n.modifiersData.offset[n.placement] : null, B = {
    x: 0,
    y: 0
  };
  if (I) {
    if (l) {
      var R, _ = b === "y" ? Ni : Li, A = b === "y" ? cr : lr, k = b === "y" ? "height" : "width", z = I[b], T = z + E[_], w = z - E[A], F = i ? -D[k] / 2 : 0, j = y === Va ? O[k] : D[k], P = y === Va ? -D[k] : -O[k], V = n.elements.arrow, J = i && V ? c1(V) : {
        width: 0,
        height: 0
      }, ne = n.modifiersData["arrow#persistent"] ? n.modifiersData["arrow#persistent"].padding : gy(), Z = ne[_], te = ne[A], G = Wo(0, O[k], J[k]), N = x ? O[k] / 2 - F - G - Z - K.mainAxis : j - G - Z - K.mainAxis, q = x ? -O[k] / 2 + F + G + te + K.mainAxis : P + G + te + K.mainAxis, ie = n.elements.arrow && Oc(n.elements.arrow), oe = ie ? b === "y" ? ie.clientTop || 0 : ie.clientLeft || 0 : 0, fe = (R = H == null ? void 0 : H[b]) != null ? R : 0, Y = z + N - fe - oe, ae = z + q - fe, se = Wo(i ? a0(T, Y) : T, z, i ? Ds(w, ae) : w);
      I[b] = se, B[b] = se - z;
    }
    if (c) {
      var L, W = b === "x" ? Ni : Li, M = b === "x" ? cr : lr, X = I[u], U = u === "y" ? "height" : "width", Q = X + E[W], re = X - E[M], le = [Ni, Li].indexOf(S) !== -1, ce = (L = H == null ? void 0 : H[u]) != null ? L : 0, ee = le ? Q : X - O[U] - D[U] - ce + K.altAxis, he = le ? X + O[U] + D[U] - ce - K.altAxis : re, pe = i && le ? $M(ee, X, he) : Wo(i ? ee : Q, X, i ? he : re);
      I[u] = pe, B[u] = pe - X;
    }
    n.modifiersData[a] = B;
  }
}
const xD = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: mD,
  requiresIfExists: ["offset"]
};
function bD(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function yD(e) {
  return e === Gi(e) || !ar(e) ? u1(e) : bD(e);
}
function vD(e) {
  var n = e.getBoundingClientRect(), r = Xa(n.width) / e.offsetWidth || 1, a = Xa(n.height) / e.offsetHeight || 1;
  return r !== 1 || a !== 1;
}
function wD(e, n, r) {
  r === void 0 && (r = !1);
  var a = ar(n), o = ar(n) && vD(n), l = Cs(n), d = Ga(e, o, r), c = {
    scrollLeft: 0,
    scrollTop: 0
  }, f = {
    x: 0,
    y: 0
  };
  return (a || !a && !r) && ((jr(n) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  h1(l)) && (c = yD(n)), ar(n) ? (f = Ga(n, !0), f.x += n.clientLeft, f.y += n.clientTop) : l && (f.x = d1(l))), {
    x: d.left + c.scrollLeft - f.x,
    y: d.top + c.scrollTop - f.y,
    width: d.width,
    height: d.height
  };
}
function SD(e) {
  var n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), a = [];
  e.forEach(function(l) {
    n.set(l.name, l);
  });
  function o(l) {
    r.add(l.name);
    var d = [].concat(l.requires || [], l.requiresIfExists || []);
    d.forEach(function(c) {
      if (!r.has(c)) {
        var f = n.get(c);
        f && o(f);
      }
    }), a.push(l);
  }
  return e.forEach(function(l) {
    r.has(l.name) || o(l);
  }), a;
}
function _D(e) {
  var n = SD(e);
  return RM.reduce(function(r, a) {
    return r.concat(n.filter(function(o) {
      return o.phase === a;
    }));
  }, []);
}
function CD(e) {
  var n;
  return function() {
    return n || (n = new Promise(function(r) {
      Promise.resolve().then(function() {
        n = void 0, r(e());
      });
    })), n;
  };
}
function AD(e) {
  var n = e.reduce(function(r, a) {
    var o = r[a.name];
    return r[a.name] = o ? Object.assign({}, o, a, {
      options: Object.assign({}, o.options, a.options),
      data: Object.assign({}, o.data, a.data)
    }) : a, r;
  }, {});
  return Object.keys(n).map(function(r) {
    return n[r];
  });
}
var ym = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function vm() {
  for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
    n[r] = arguments[r];
  return !n.some(function(a) {
    return !(a && typeof a.getBoundingClientRect == "function");
  });
}
function kD(e) {
  e === void 0 && (e = {});
  var n = e, r = n.defaultModifiers, a = r === void 0 ? [] : r, o = n.defaultOptions, l = o === void 0 ? ym : o;
  return function(c, f, s) {
    s === void 0 && (s = l);
    var h = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, ym, l),
      modifiersData: {},
      elements: {
        reference: c,
        popper: f
      },
      attributes: {},
      styles: {}
    }, g = [], t = !1, i = {
      state: h,
      setOptions: function(S) {
        var y = typeof S == "function" ? S(h.options) : S;
        v(), h.options = Object.assign({}, l, h.options, y), h.scrollParents = {
          reference: Ws(c) ? qo(c) : c.contextElement ? qo(c.contextElement) : [],
          popper: qo(f)
        };
        var x = _D(AD([].concat(a, h.options.modifiers)));
        return h.orderedModifiers = x.filter(function(b) {
          return b.enabled;
        }), m(), i.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!t) {
          var S = h.elements, y = S.reference, x = S.popper;
          if (vm(y, x)) {
            h.rects = {
              reference: wD(y, Oc(x), h.options.strategy === "fixed"),
              popper: c1(x)
            }, h.reset = !1, h.placement = h.options.placement, h.orderedModifiers.forEach(function(K) {
              return h.modifiersData[K.name] = Object.assign({}, K.data);
            });
            for (var b = 0; b < h.orderedModifiers.length; b++) {
              if (h.reset === !0) {
                h.reset = !1, b = -1;
                continue;
              }
              var u = h.orderedModifiers[b], I = u.fn, O = u.options, D = O === void 0 ? {} : O, $ = u.name;
              typeof I == "function" && (h = I({
                state: h,
                options: D,
                name: $,
                instance: i
              }) || h);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: CD(function() {
        return new Promise(function(E) {
          i.forceUpdate(), E(h);
        });
      }),
      destroy: function() {
        v(), t = !0;
      }
    };
    if (!vm(c, f))
      return i;
    i.setOptions(s).then(function(E) {
      !t && s.onFirstUpdate && s.onFirstUpdate(E);
    });
    function m() {
      h.orderedModifiers.forEach(function(E) {
        var S = E.name, y = E.options, x = y === void 0 ? {} : y, b = E.effect;
        if (typeof b == "function") {
          var u = b({
            state: h,
            name: S,
            instance: i,
            options: x
          }), I = function() {
          };
          g.push(u || I);
        }
      });
    }
    function v() {
      g.forEach(function(E) {
        return E();
      }), g = [];
    }
    return i;
  };
}
var ED = [YM, pD, GM, NM, hD, oD, xD, WM, lD], ID = /* @__PURE__ */ kD({
  defaultModifiers: ED
});
function TD(e) {
  return typeof e == "function" ? e() : e;
}
const o0 = /* @__PURE__ */ Ue.forwardRef(function(n, r) {
  const {
    children: a,
    container: o,
    disablePortal: l = !1
  } = n, [d, c] = Ue.useState(null), f = Da(/* @__PURE__ */ Ue.isValidElement(a) ? a.ref : null, r);
  if (Zo(() => {
    l || c(TD(o) || document.body);
  }, [o, l]), Zo(() => {
    if (d && !l)
      return Od(r, d), () => {
        Od(r, null);
      };
  }, [r, d, l]), l) {
    if (/* @__PURE__ */ Ue.isValidElement(a)) {
      const s = {
        ref: f
      };
      return /* @__PURE__ */ Ue.cloneElement(a, s);
    }
    return /* @__PURE__ */ p.jsx(Ue.Fragment, {
      children: a
    });
  }
  return /* @__PURE__ */ p.jsx(Ue.Fragment, {
    children: d && /* @__PURE__ */ Z8.createPortal(a, d)
  });
});
process.env.NODE_ENV !== "production" && (o0.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: Fe.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: Fe.oneOfType([Qo, Fe.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: Fe.bool
});
process.env.NODE_ENV !== "production" && (o0.propTypes = R4(o0.propTypes));
function OD(e) {
  return bc("MuiPopper", e);
}
F0("MuiPopper", ["root"]);
const FD = ["anchorEl", "children", "direction", "disablePortal", "modifiers", "open", "placement", "popperOptions", "popperRef", "slotProps", "slots", "TransitionProps", "ownerState"], PD = ["anchorEl", "children", "container", "direction", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition", "slotProps", "slots"];
function jD(e, n) {
  if (n === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function c0(e) {
  return typeof e == "function" ? e() : e;
}
function Z0(e) {
  return e.nodeType !== void 0;
}
function RD(e) {
  return !Z0(e);
}
const MD = (e) => {
  const {
    classes: n
  } = e;
  return wf({
    root: ["root"]
  }, OD, n);
}, DD = {}, ND = /* @__PURE__ */ Ue.forwardRef(function(n, r) {
  var a;
  const {
    anchorEl: o,
    children: l,
    direction: d,
    disablePortal: c,
    modifiers: f,
    open: s,
    placement: h,
    popperOptions: g,
    popperRef: t,
    slotProps: i = {},
    slots: m = {},
    TransitionProps: v
    // @ts-ignore internal logic
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
  } = n, E = Ti(n, FD), S = Ue.useRef(null), y = Da(S, r), x = Ue.useRef(null), b = Da(x, t), u = Ue.useRef(b);
  Zo(() => {
    u.current = b;
  }, [b]), Ue.useImperativeHandle(t, () => x.current, []);
  const I = jD(h, d), [O, D] = Ue.useState(I), [$, K] = Ue.useState(c0(o));
  Ue.useEffect(() => {
    x.current && x.current.forceUpdate();
  }), Ue.useEffect(() => {
    o && K(c0(o));
  }, [o]), Zo(() => {
    if (!$ || !s)
      return;
    const A = (T) => {
      D(T.placement);
    };
    if (process.env.NODE_ENV !== "production" && $ && Z0($) && $.nodeType === 1) {
      const T = $.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && T.top === 0 && T.left === 0 && T.right === 0 && T.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let k = [{
      name: "preventOverflow",
      options: {
        altBoundary: c
      }
    }, {
      name: "flip",
      options: {
        altBoundary: c
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: T
      }) => {
        A(T);
      }
    }];
    f != null && (k = k.concat(f)), g && g.modifiers != null && (k = k.concat(g.modifiers));
    const z = ID($, S.current, zt({
      placement: I
    }, g, {
      modifiers: k
    }));
    return u.current(z), () => {
      z.destroy(), u.current(null);
    };
  }, [$, c, f, s, g, I]);
  const H = {
    placement: O
  };
  v !== null && (H.TransitionProps = v);
  const B = MD(n), R = (a = m.root) != null ? a : "div", _ = ew({
    elementType: R,
    externalSlotProps: i.root,
    externalForwardedProps: E,
    additionalProps: {
      role: "tooltip",
      ref: y
    },
    ownerState: n,
    className: B.root
  });
  return /* @__PURE__ */ p.jsx(R, zt({}, _, {
    children: typeof l == "function" ? l(H) : l
  }));
}), vy = /* @__PURE__ */ Ue.forwardRef(function(n, r) {
  const {
    anchorEl: a,
    children: o,
    container: l,
    direction: d = "ltr",
    disablePortal: c = !1,
    keepMounted: f = !1,
    modifiers: s,
    open: h,
    placement: g = "bottom",
    popperOptions: t = DD,
    popperRef: i,
    style: m,
    transition: v = !1,
    slotProps: E = {},
    slots: S = {}
  } = n, y = Ti(n, PD), [x, b] = Ue.useState(!0), u = () => {
    b(!1);
  }, I = () => {
    b(!0);
  };
  if (!f && !h && (!v || x))
    return null;
  let O;
  if (l)
    O = l;
  else if (a) {
    const K = c0(a);
    O = K && Z0(K) ? X1(K).body : X1(null).body;
  }
  const D = !h && f && (!v || x) ? "none" : void 0, $ = v ? {
    in: h,
    onEnter: u,
    onExited: I
  } : void 0;
  return /* @__PURE__ */ p.jsx(o0, {
    disablePortal: c,
    container: O,
    children: /* @__PURE__ */ p.jsx(ND, zt({
      anchorEl: a,
      direction: d,
      disablePortal: c,
      modifiers: s,
      ref: r,
      open: v ? !x : h,
      placement: g,
      popperOptions: t,
      popperRef: i,
      slotProps: E,
      slots: S
    }, y, {
      style: zt({
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: D
      }, m),
      TransitionProps: $,
      children: o
    }))
  });
});
process.env.NODE_ENV !== "production" && (vy.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: y2(Fe.oneOfType([Qo, Fe.object, Fe.func]), (e) => {
    if (e.open) {
      const n = c0(e.anchorEl);
      if (n && Z0(n) && n.nodeType === 1) {
        const r = n.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && r.top === 0 && r.left === 0 && r.right === 0 && r.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!n || typeof n.getBoundingClientRect != "function" || RD(n) && n.contextElement != null && n.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: Fe.oneOfType([Fe.node, Fe.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: Fe.oneOfType([Qo, Fe.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: Fe.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: Fe.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: Fe.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: Fe.arrayOf(Fe.shape({
    data: Fe.object,
    effect: Fe.func,
    enabled: Fe.bool,
    fn: Fe.func,
    name: Fe.any,
    options: Fe.object,
    phase: Fe.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: Fe.arrayOf(Fe.string),
    requiresIfExists: Fe.arrayOf(Fe.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: Fe.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: Fe.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: Fe.shape({
    modifiers: Fe.array,
    onFirstUpdate: Fe.func,
    placement: Fe.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: Fe.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: vf,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: Fe.shape({
    root: Fe.oneOfType([Fe.func, Fe.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: Fe.shape({
    root: Fe.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: Fe.bool
});
const LD = ["anchorEl", "component", "components", "componentsProps", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "transition", "slots", "slotProps"], BD = Zs(vy, {
  name: "MuiPopper",
  slot: "Root",
  overridesResolver: (e, n) => n.root
})({}), wy = /* @__PURE__ */ Ue.forwardRef(function(n, r) {
  var a;
  const o = ly(), l = D0({
    props: n,
    name: "MuiPopper"
  }), {
    anchorEl: d,
    component: c,
    components: f,
    componentsProps: s,
    container: h,
    disablePortal: g,
    keepMounted: t,
    modifiers: i,
    open: m,
    placement: v,
    popperOptions: E,
    popperRef: S,
    transition: y,
    slots: x,
    slotProps: b
  } = l, u = Ti(l, LD), I = (a = x == null ? void 0 : x.root) != null ? a : f == null ? void 0 : f.Root, O = zt({
    anchorEl: d,
    container: h,
    disablePortal: g,
    keepMounted: t,
    modifiers: i,
    open: m,
    placement: v,
    popperOptions: E,
    popperRef: S,
    transition: y
  }, u);
  return /* @__PURE__ */ p.jsx(BD, zt({
    as: c,
    direction: o == null ? void 0 : o.direction,
    slots: {
      root: I
    },
    slotProps: b ?? s
  }, O, {
    ref: r
  }));
});
process.env.NODE_ENV !== "production" && (wy.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: Fe.oneOfType([Qo, Fe.object, Fe.func]),
  /**
   * Popper render function or node.
   */
  children: Fe.oneOfType([Fe.node, Fe.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: Fe.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: Fe.shape({
    Root: Fe.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  componentsProps: Fe.shape({
    root: Fe.oneOfType([Fe.func, Fe.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: Fe.oneOfType([Qo, Fe.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: Fe.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: Fe.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: Fe.arrayOf(Fe.shape({
    data: Fe.object,
    effect: Fe.func,
    enabled: Fe.bool,
    fn: Fe.func,
    name: Fe.any,
    options: Fe.object,
    phase: Fe.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: Fe.arrayOf(Fe.string),
    requiresIfExists: Fe.arrayOf(Fe.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: Fe.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: Fe.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: Fe.shape({
    modifiers: Fe.array,
    onFirstUpdate: Fe.func,
    placement: Fe.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: Fe.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: vf,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: Fe.shape({
    root: Fe.oneOfType([Fe.func, Fe.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: Fe.shape({
    root: Fe.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: Fe.oneOfType([Fe.arrayOf(Fe.oneOfType([Fe.func, Fe.object, Fe.bool])), Fe.func, Fe.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: Fe.bool
});
const rl = 8, Uh = 1600, wm = 8, $D = 2, UD = 40, zD = 3, HD = 500, WD = 50, Sm = (e) => document.querySelector(`[data-tour-id="${e}"]`), qD = (e) => {
  const n = Number(e.dataset.tourMinHeight);
  return Number.isFinite(n) && n > 0 ? n : void 0;
}, VD = (e) => {
  const n = e.getBoundingClientRect(), r = qD(e);
  return n.width < wm || n.height < wm || r !== void 0 && n.height < r ? null : {
    top: n.top - rl,
    left: n.left - rl,
    width: n.width + rl * 2,
    height: n.height + rl * 2
  };
}, XD = (e) => {
  const n = e.getBoundingClientRect();
  return `${Math.round(n.width)}:${Math.round(n.height)}`;
}, GD = (e) => e.split("-")[0], KD = (e) => e.split("-")[1], sl = 28, YD = "#ea15a4", ZD = "#c7118b", zh = (e) => {
  var n, r;
  return ((r = (n = e.palette.common) == null ? void 0 : n.accent) == null ? void 0 : r[500]) ?? YD;
}, Sy = (e) => {
  var n, r;
  return ((r = (n = e.palette.common) == null ? void 0 : n.accent) == null ? void 0 : r[600]) ?? ZD;
}, xd = ({
  returnAction: e
}) => e != null && e.visible ? /* @__PURE__ */ p.jsx(
  Or,
  {
    variant: "contained",
    onClick: e.onClick,
    disabled: e.disabled,
    sx: (n) => ({
      position: "fixed",
      right: 24,
      bottom: 24,
      "html.native-android &": {
        bottom: "calc(24px + var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px)))"
      },
      zIndex: Uh + 2,
      bgcolor: zh(n),
      color: n.palette.common.white,
      borderRadius: 999,
      px: 3,
      py: 1.25,
      overflow: "hidden",
      boxShadow: "0 14px 34px rgba(234, 21, 164, 0.28)",
      whiteSpace: "nowrap",
      "&:hover": {
        bgcolor: Sy(n)
      },
      "&::after": {
        content: '""',
        position: "absolute",
        top: 0,
        bottom: 0,
        left: "-45%",
        width: "35%",
        background: "linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), transparent)",
        animation: "guided-tour-return-wave 1.8s ease-in-out infinite"
      },
      "@keyframes guided-tour-return-wave": {
        "0%": { left: "-45%" },
        "60%": { left: "110%" },
        "100%": { left: "110%" }
      }
    }),
    children: e.label
  }
) : null, QD = ({
  basePlacement: e,
  isHorizontalPlacement: n,
  shouldAlignArrowToEnd: r,
  backgroundColor: a
}) => ({
  left: e === "right" ? -10 : !n && !r ? sl : "auto",
  right: e === "left" ? -10 : !n && r ? sl : "auto",
  top: n && !r ? sl : e === "bottom" ? -10 : "auto",
  bottom: e === "top" ? -10 : n && r ? sl : "auto",
  borderStyle: "solid",
  borderWidth: e === "left" ? "10px 0 10px 10px" : e === "right" ? "10px 10px 10px 0" : e === "top" ? "10px 10px 0 10px" : "0 10px 10px 10px",
  borderColor: e === "left" ? `transparent transparent transparent ${a}` : e === "right" ? `transparent ${a} transparent transparent` : e === "top" ? `${a} transparent transparent transparent` : `transparent transparent ${a} transparent`
}), fU = ({
  open: e,
  steps: n,
  activeStepIndex: r,
  onStepChange: a,
  onSkip: o,
  onDone: l,
  returnAction: d
}) => {
  const c = n[r], f = c == null ? void 0 : c.id, s = c == null ? void 0 : c.targetId, h = (c == null ? void 0 : c.optional) ?? !1, [g, t] = Ee(null), [i, m] = Ee(null), [v, E] = Ee(!1), S = r === 0, y = r === n.length - 1;
  ot(() => {
    var H;
    !e || !c || (H = c.beforeShow) == null || H.call(c);
  }, [f, e]), ot(() => {
    if (!e || !s) {
      t(null), m(null);
      return;
    }
    t(null), m(null);
    let H, B, R = 0, _ = !1, A = null, k, z = null, T = 0;
    const w = h ? zD : UD, F = () => {
      H && (window.cancelAnimationFrame(H), H = void 0), B && (window.clearTimeout(B), B = void 0);
    }, j = () => {
      z = null, T = 0, t(null), m(null);
    }, P = () => {
      if (!(!h || _)) {
        if (y) {
          l();
          return;
        }
        a(r + 1);
      }
    }, V = () => {
      if (R < w) {
        R += 1, J(WD);
        return;
      }
      if (h) {
        P();
        return;
      }
      J(HD);
    }, J = (N = 0) => {
      if (_ || H || B)
        return;
      const q = () => {
        B = void 0, H = window.requestAnimationFrame(() => {
          H = void 0, Z();
        });
      };
      if (N > 0) {
        B = window.setTimeout(q, N);
        return;
      }
      q();
    }, ne = (N) => {
      A !== N && (k == null || k.disconnect(), A = N, !(!N || typeof ResizeObserver > "u") && (k = new ResizeObserver(() => {
        R = 0, J();
      }), k.observe(N)));
    };
    function Z() {
      if (_)
        return;
      const N = Sm(s);
      if (ne(N), !N) {
        j(), V();
        return;
      }
      const q = VD(N);
      if (!q) {
        j(), V();
        return;
      }
      const ie = XD(N);
      if (ie === z ? T += 1 : (z = ie, T = 1), T < $D) {
        t(null), m(null), J();
        return;
      }
      t(N), m(q);
    }
    const te = Sm(s);
    typeof (te == null ? void 0 : te.scrollIntoView) == "function" && te.scrollIntoView({ block: "center", inline: "nearest" }), J();
    const G = () => {
      R = 0, J();
    };
    return window.addEventListener("resize", G), window.addEventListener("scroll", G, !0), () => {
      _ = !0, F(), k == null || k.disconnect(), window.removeEventListener("resize", G), window.removeEventListener("scroll", G, !0), t(null), m(null);
    };
  }, [
    r,
    h,
    s,
    y,
    l,
    a,
    e
  ]);
  const x = (c == null ? void 0 : c.placement) ?? "right", b = GD(x), u = KD(x), I = b === "left" || b === "right", O = u === "end";
  if (!e || !c)
    return /* @__PURE__ */ p.jsx(xd, { returnAction: d });
  if (!g || !i)
    return /* @__PURE__ */ p.jsx(xd, { returnAction: d });
  const D = async () => {
    var B;
    if (v)
      return;
    E(!0);
    let H;
    try {
      H = await ((B = c.onNext) == null ? void 0 : B.call(c));
    } catch (R) {
      console.error("Guided tour step failed", R);
      return;
    } finally {
      E(!1);
    }
    if (H !== !1) {
      if (y) {
        l();
        return;
      }
      a(r + 1);
    }
  }, $ = () => {
    !S && !v && a(r - 1);
  }, K = v ? c.nextPendingLabel ?? c.nextLabel ?? "Loading..." : c.nextLabel ?? (y ? "Done" : "Next");
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsx(xd, { returnAction: d }),
    i && /* @__PURE__ */ p.jsx(
      Me,
      {
        "data-testid": "guided-tour-highlight",
        sx: {
          position: "fixed",
          top: i.top,
          left: i.left,
          width: i.width,
          height: i.height,
          border: "2px solid #0061a0",
          borderRadius: "12px",
          boxShadow: "0 0 0 4px rgba(234, 21, 164, 0.12)",
          pointerEvents: "none",
          transition: "all 160ms ease",
          zIndex: Uh,
          borderColor: (H) => zh(H)
        }
      }
    ),
    /* @__PURE__ */ p.jsx(
      wy,
      {
        open: !0,
        anchorEl: g,
        placement: x,
        modifiers: [
          { name: "offset", options: { offset: [0, 18] } },
          { name: "preventOverflow", options: { padding: 16 } },
          { name: "flip", enabled: !0 }
        ],
        sx: { zIndex: Uh + 1 },
        children: /* @__PURE__ */ p.jsx(
          Me,
          {
            sx: (H) => ({
              position: "relative",
              width: 360,
              maxWidth: "calc(100vw - 32px)",
              backgroundColor: H.palette.background.paper,
              borderRadius: "12px",
              boxShadow: "0 18px 48px rgba(15, 23, 42, 0.22)",
              border: `1px solid ${H.palette.divider}`,
              p: 2,
              "&::before": {
                content: '""',
                position: "absolute",
                width: 0,
                height: 0,
                ...QD({
                  basePlacement: b,
                  isHorizontalPlacement: I,
                  shouldAlignArrowToEnd: O,
                  backgroundColor: H.palette.background.paper
                })
              }
            }),
            children: /* @__PURE__ */ p.jsxs(Pe, { gap: 1.5, children: [
              /* @__PURE__ */ p.jsxs(
                Te,
                {
                  variant: "caption",
                  color: "text.secondary",
                  fontWeight: 700,
                  sx: { letterSpacing: "0.08em" },
                  children: [
                    "STEP ",
                    r + 1,
                    " OF ",
                    n.length
                  ]
                }
              ),
              /* @__PURE__ */ p.jsxs(Pe, { gap: 0.75, children: [
                /* @__PURE__ */ p.jsx(Te, { variant: "h6", fontWeight: 700, children: c.title }),
                /* @__PURE__ */ p.jsx(Te, { variant: "body2", color: "text.secondary", children: c.body })
              ] }),
              /* @__PURE__ */ p.jsxs(
                Pe,
                {
                  direction: "row",
                  alignItems: "center",
                  gap: 1,
                  mt: 0.5,
                  sx: { minWidth: 0 },
                  children: [
                    /* @__PURE__ */ p.jsx(
                      Or,
                      {
                        variant: "text",
                        color: "inherit",
                        onClick: o,
                        disabled: v,
                        sx: { flexShrink: 0, whiteSpace: "nowrap" },
                        children: "Skip tour"
                      }
                    ),
                    /* @__PURE__ */ p.jsx(Me, { flex: 1 }),
                    !S && /* @__PURE__ */ p.jsx(
                      Or,
                      {
                        variant: "outlined",
                        onClick: $,
                        disabled: v,
                        sx: { flexShrink: 0, whiteSpace: "nowrap" },
                        children: "Back"
                      }
                    ),
                    /* @__PURE__ */ p.jsx(
                      Or,
                      {
                        variant: "contained",
                        onClick: D,
                        disabled: v,
                        sx: (H) => ({
                          flexShrink: 0,
                          whiteSpace: "nowrap",
                          minWidth: 96,
                          bgcolor: zh(H),
                          color: H.palette.common.white,
                          "&:hover": {
                            bgcolor: Sy(H)
                          }
                        }),
                        children: K
                      }
                    )
                  ]
                }
              )
            ] })
          }
        )
      }
    )
  ] });
}, JD = Jn.object().shape({
  mfaCode: Jn.string().required("Code is required")
}), pU = ({
  isLoading: e,
  onSubmit: n,
  backToLogin: r,
  onRequestMagicLink: a,
  topContent: o,
  renderCodeInput: l
}) => {
  var s;
  const {
    handleSubmit: d,
    register: c,
    formState: { errors: f }
  } = mr({
    resolver: ws(JD)
  });
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    o,
    /* @__PURE__ */ p.jsxs("form", { onSubmit: d(n), children: [
      /* @__PURE__ */ p.jsx(Te, { variant: "h3", textAlign: "center", mb: 4, children: "Enter Passcode" }),
      /* @__PURE__ */ p.jsx(Te, { variant: "body1", textAlign: "center", mb: 4, children: aE }),
      /* @__PURE__ */ p.jsxs(Pe, { gap: 2, children: [
        l({
          registerMfaCode: c,
          errorMessage: (s = f == null ? void 0 : f.mfaCode) == null ? void 0 : s.message
        }),
        /* @__PURE__ */ p.jsx(lt, { variant: "contained", type: "submit", disabled: e, size: "large", children: "Verify Code" })
      ] }),
      a && /* @__PURE__ */ p.jsx(Me, { mt: 2, textAlign: "center", children: /* @__PURE__ */ p.jsx(
        Ii,
        {
          component: "button",
          type: "button",
          variant: "body2",
          onClick: a,
          sx: { cursor: "pointer" },
          children: "Email me a magic link instead"
        }
      ) }),
      /* @__PURE__ */ p.jsx(Me, { mt: 4, children: /* @__PURE__ */ p.jsxs(Te, { variant: "body1", textAlign: "center", mb: 4, children: [
        "Back to",
        " ",
        /* @__PURE__ */ p.jsx(Ii, { sx: { cursor: "pointer" }, onClick: r, children: "Login" })
      ] }) })
    ] })
  ] });
}, gU = ({
  email: e,
  onBackToLogin: n
}) => /* @__PURE__ */ p.jsxs(
  Me,
  {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    p: 4,
    children: [
      /* @__PURE__ */ p.jsx(Te, { variant: "h2", mb: 4, children: "Check Your Email" }),
      /* @__PURE__ */ p.jsxs(Pe, { gap: 3, maxWidth: "400px", children: [
        /* @__PURE__ */ p.jsxs(Te, { variant: "body1", children: [
          "A verification email has been sent to ",
          /* @__PURE__ */ p.jsx("strong", { children: e }),
          ". Please check your inbox and click the verification link to access the platform."
        ] }),
        /* @__PURE__ */ p.jsx(
          Te,
          {
            variant: "body2",
            color: (r) => r.palette.text.secondary,
            children: "Didn't receive the email? Check your spam folder or try signing in again."
          }
        ),
        /* @__PURE__ */ p.jsx(lt, { variant: "outlined", onClick: n, sx: { mt: 2 }, children: "Back to Sign In" })
      ] })
    ]
  }
), mU = ({
  appType: e,
  validationSchema: n,
  trackLoginEvent: r,
  forgotPasswordEmail: a = "",
  requestForgotPassword: o,
  requestMagicLink: l,
  backToLoginPath: d = "/authenticate/login"
}) => {
  var H;
  const { v5Login: c } = Dr(), {
    mutateAsync: f,
    error: s,
    data: h
  } = O8(), {
    mutateAsync: g,
    data: t,
    isLoading: i,
    error: m
  } = ax(), {
    register: v,
    formState: { errors: E },
    handleSubmit: S,
    getValues: y
  } = mr({
    resolver: ws(n),
    defaultValues: {
      email: a
    }
  }), x = Oe(
    async (B) => {
      var R;
      if (c) {
        r(en.FORGOT_PASSWORD_SUBMITTED);
        try {
          const _ = await f({
            data: { email: B.email, app_type: e }
          });
          return r(en.FORGOT_PASSWORD_COMPLETED), _;
        } catch (_) {
          throw r(en.FORGOT_PASSWORD_FAILED, {
            error_status: (R = _ == null ? void 0 : _.response) == null ? void 0 : R.status
          }), _;
        }
      }
      return o.mutateAsync(B);
    },
    [e, o, f, r, c]
  ), b = Oe(
    async (B) => c ? g({
      data: { email: B.email, app_type: e }
    }) : l.mutateAsync(B),
    [e, l, g, c]
  ), u = o.isLoading || l.isLoading || i, I = o.error || l.error || s || m, O = o.data || l.data || h || t, D = Ki(), $ = Oe(
    () => D(d),
    [d, D]
  ), K = Tt(() => {
    var R;
    const { email: B } = y();
    return ((R = O == null ? void 0 : O.message) == null ? void 0 : R.replace("#{email}", B)) || "";
  }, [O == null ? void 0 : O.message, y]);
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsx("form", { style: { width: "100%" }, children: /* @__PURE__ */ p.jsxs(Pe, { gap: 2, width: "100%", children: [
      /* @__PURE__ */ p.jsx(
        vi,
        {
          ...v("email"),
          fullWidth: !0,
          type: "email",
          placeholder: "Email",
          error: !!(E != null && E.email),
          helperText: (H = E == null ? void 0 : E.email) == null ? void 0 : H.message,
          disabled: u
        }
      ),
      /* @__PURE__ */ p.jsxs(Pe, { mt: 2, gap: 2, children: [
        /* @__PURE__ */ p.jsx(
          lt,
          {
            onClick: S(x),
            variant: "contained",
            type: "submit",
            disabled: u,
            size: "large",
            fullWidth: !0,
            children: "Submit"
          }
        ),
        /* @__PURE__ */ p.jsx(
          lt,
          {
            onClick: S(b),
            variant: "outlined",
            type: "submit",
            disabled: u,
            size: "large",
            fullWidth: !0,
            children: "Send Magic Link"
          }
        )
      ] })
    ] }) }),
    /* @__PURE__ */ p.jsx(mi, { open: u }),
    /* @__PURE__ */ p.jsx(
      Yh,
      {
        open: !!O,
        title: "Password Reset Requested",
        content: K,
        onConfirm: $,
        confirmLabel: "Okay"
      }
    ),
    /* @__PURE__ */ p.jsx(El, { title: "Forgot Password Error", error: I })
  ] });
}, xU = ({
  token: e,
  cpaId: n,
  isMobile: r,
  backToLogin: a,
  trackLoginEvent: o,
  onProcessFinished: l,
  desiredCpaUrl: d,
  enableMfaSetupProcess: c = !1,
  renderCpaSelector: f,
  renderMfaSetupDesktopOnlyInfo: s,
  renderFallback: h
}) => {
  const g = ut(!1);
  ot(() => {
    g.current || (g.current = !0, o(en.MAGIC_LINK_CLICKED, {
      login_surface: Cb.MAGIC_LINK_CLICKED
    }));
  }, [o]);
  const {
    isLoading: t,
    processState: i,
    selectCpa: m,
    signInCpas: v,
    error: E,
    mfaSetupConfiguration: S,
    getSelectedCpa: y,
    setupMfaCode: x
  } = HC({
    token: e,
    cpaId: n,
    onProcessFinished: l,
    desiredCpaUrl: d,
    isMfaSetupEnabled: c && !r,
    trackLoginEvent: o
  }), b = Oe(
    (O) => {
      O.cpa_uuid && m(O.cpa_uuid);
    },
    [m]
  ), u = sf(E), I = i === "initialVerification" && (u === Ra.invalid_link || u === Ra.expired_link) ? p0(E) : void 0;
  return ot(() => {
    I && (rn.error(I, { id: "magic-link-error", duration: 8e3 }), a());
  }, [I, a]), i === "cpaSelector" ? /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    f({
      cpas: v,
      onCancel: a,
      onCpaSelected: b
    }),
    /* @__PURE__ */ p.jsx(El, { title: "Sign In Error", error: E })
  ] }) : i === "mfaSetup" && (!c || r) ? s({
    getSelectedCpa: () => y(),
    resetProcess: a
  }) : i === "mfaSetup" && c ? /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsx(
      FR,
      {
        isLoading: t,
        qrCodeSrc: S == null ? void 0 : S.qr_code,
        otpSecret: S == null ? void 0 : S.unconfirmed_otp_secret,
        onSubmit: ({ mfaCode: O }) => x(O),
        getSelectedCpa: y
      }
    ),
    /* @__PURE__ */ p.jsx(El, { title: "MFA Setup Error", error: E })
  ] }) : i === "mfaSetupComplete" && c ? /* @__PURE__ */ p.jsx(
    RR,
    {
      onDelayedSuccess: () => {
        var D;
        const O = (D = y()) == null ? void 0 : D.cpa_uuid;
        O && m(O);
      }
    }
  ) : (i === "cpaSelected" || i === "initialVerification") && !E ? /* @__PURE__ */ p.jsx(mi, { open: !0 }) : I ? /* @__PURE__ */ p.jsx(mi, { open: !0 }) : h({ error: E, backToLogin: a });
}, eN = Jn.object({
  password: Jn.string().required("Required"),
  password_confirmation: Jn.string().required("Required").oneOf([Jn.ref("password")], "Passwords must match")
}), tN = ({
  onSubmit: e,
  isLoading: n,
  onCancel: r,
  PasswordInputComponent: a,
  validationSchema: o = eN
}) => {
  var s, h;
  const {
    register: l,
    handleSubmit: d,
    formState: { errors: c }
  } = mr({
    resolver: ws(o)
  }), f = Oe(
    async (g) => {
      e(g.password);
    },
    [e]
  );
  return /* @__PURE__ */ p.jsxs("form", { onSubmit: d(f), children: [
    /* @__PURE__ */ p.jsx(Te, { variant: "h3", textAlign: "center", mb: 4, mt: 4, children: "Password Reset" }),
    /* @__PURE__ */ p.jsxs(Pe, { mt: 2, gap: 2, children: [
      /* @__PURE__ */ p.jsx(
        a,
        {
          ...l("password"),
          placeholder: "New Password",
          error: !!c.password,
          helperText: (s = c == null ? void 0 : c.password) == null ? void 0 : s.message,
          disabled: n
        }
      ),
      /* @__PURE__ */ p.jsx(
        a,
        {
          ...l("password_confirmation"),
          placeholder: "Confirm Password",
          error: !!c.password_confirmation,
          helperText: (h = c == null ? void 0 : c.password_confirmation) == null ? void 0 : h.message,
          disabled: n
        }
      ),
      /* @__PURE__ */ p.jsxs(Pe, { mt: 2, gap: 2, children: [
        /* @__PURE__ */ p.jsx(lt, { disabled: n, variant: "contained", type: "submit", size: "large", children: "Submit" }),
        /* @__PURE__ */ p.jsx(lt, { variant: "outlined", type: "button", size: "large", onClick: r, children: "Cancel" })
      ] })
    ] })
  ] });
}, bU = ({
  logo: e,
  footer: n,
  processState: r,
  errors: a,
  isLoading: o,
  parseError: l,
  onCancel: d,
  onResetPassword: c,
  onValidateMfaCode: f,
  PasswordInputComponent: s,
  MfaCodeFormComponent: h,
  validationSchema: g,
  contentTopMargin: t = 2,
  footerTopMargin: i = 0
}) => /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
  e,
  /* @__PURE__ */ p.jsxs(Me, { mt: t, children: [
    /* @__PURE__ */ p.jsx(B5, { error: a, parseError: l }),
    r === "newPasswordForm" && /* @__PURE__ */ p.jsx(
      tN,
      {
        onSubmit: c,
        isLoading: o,
        onCancel: d,
        PasswordInputComponent: s,
        validationSchema: g
      }
    ),
    r === "mfaCode" && /* @__PURE__ */ p.jsx(
      h,
      {
        backToLogin: d,
        isLoading: o,
        onSubmit: ({ mfaCode: m }) => {
          f(m);
        }
      }
    )
  ] }),
  /* @__PURE__ */ p.jsx(Me, { mt: i, children: n })
] });
function _y(e) {
  if (e == null)
    return;
  const n = String(e).trim();
  if (!(!n || n === "null" || n === "undefined"))
    return n;
}
const Fa = [
  "#455A64",
  "#6A1B9A",
  "#00695C",
  "#5E35B1",
  "#1565C0",
  "#2E7D32",
  "#4527A0",
  "#C62828"
];
function Cy(e) {
  if (!(e != null && e.trim()))
    return "?";
  const n = e.trim().split(/\s+/).filter(Boolean);
  return n.length >= 2 ? `${n[0][0] ?? ""}${n[1][0] ?? ""}`.toUpperCase() : (n[0] ?? "").slice(0, 2).toUpperCase() || "?";
}
function nN(e) {
  let n = 0;
  for (let r = 0; r < e.length; r += 1)
    n = Math.imul(31, n) + e.charCodeAt(r);
  return n;
}
function Ay(e, n = 0) {
  const r = (e == null ? void 0 : e.trim()) || `workspace:${n}`, a = nN(r), o = (Math.abs(a) + n * 17) % Fa.length;
  return Fa[o];
}
function iN(e) {
  const n = Fa.indexOf(e);
  return n < 0 ? 0 : n;
}
function rN(e, n) {
  if (e !== n)
    return e;
  let r = iN(e), a = e;
  for (let o = 1; o < Fa.length && (r = (r + 1) % Fa.length, a = Fa[r], a === n); o += 1)
    ;
  return a;
}
function ky(e) {
  if (e.length <= 1)
    return e;
  const n = [{ ...e[0] }];
  for (let r = 1; r < e.length; r += 1) {
    const a = n[r - 1].avatarColor, o = rN(
      e[r].avatarColor,
      a
    );
    n.push({ ...e[r], avatarColor: o });
  }
  return n;
}
function sN(e) {
  if (e != null && e.trim())
    return e.trim().toLowerCase();
}
function Ey(e) {
  const n = sN(e);
  if (n)
    return n.includes("staff") || n.includes("employee") || n.includes("admin") || n.includes("firm") || n === "emp" || n.includes("accountant") ? "staff" : "client";
}
function Iy(e) {
  const n = e == null ? void 0 : e.trim();
  if (n)
    return n.split("_").filter(Boolean).map(
      (r) => r.charAt(0).toUpperCase() + r.slice(1).toLowerCase()
    ).join(" ");
}
function aN(e, n) {
  const r = e.cpa_name ?? "Workspace", a = e.cpa_uuid ?? `row-${n}`, o = Iy(e.cpa_user_role), l = Ey(e.cpa_user_role);
  return {
    rowKey: a,
    title: r,
    logoUrl: _y(e.cpa_logo_url),
    initials: Cy(r),
    avatarColor: Ay(`${a}:${r}`, n),
    roleLabel: o,
    roleKind: l,
    showActiveBadge: !1
  };
}
function oN(e, n) {
  const r = e.name ?? "Workspace", a = String(e.cpa_uuid ?? e.id ?? `row-${n}`), o = Iy(e.cpa_user_role), l = Ey(e.cpa_user_role);
  return {
    rowKey: a,
    title: r,
    logoUrl: _y(e.logo),
    initials: Cy(r),
    avatarColor: Ay(`${a}:${r}`, n),
    roleLabel: o,
    roleKind: l,
    lastAccessedText: e.last_accessed_label,
    showActiveBadge: !!(e.is_active || e.is_current_cpa)
  };
}
const cN = 480;
function lN({ row: e }) {
  var l;
  const [n, r] = Ee(!1), a = (l = e.logoUrl) == null ? void 0 : l.trim(), o = !!a && !n;
  return /* @__PURE__ */ p.jsx(
    Me,
    {
      flexShrink: 0,
      width: 48,
      height: 48,
      borderRadius: 1.5,
      bgcolor: o ? "grey.100" : e.avatarColor,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      overflow: "hidden",
      sx: o ? {} : {
        color: "common.white",
        fontWeight: 700,
        fontSize: 15,
        letterSpacing: 0.5
      },
      children: o ? /* @__PURE__ */ p.jsx(
        Me,
        {
          component: "img",
          src: a,
          alt: "",
          onError: () => r(!0),
          sx: { width: "100%", height: "100%", objectFit: "cover" }
        }
      ) : e.initials
    }
  );
}
function uN({
  row: e,
  onSelect: n
}) {
  const r = e.roleKind === "staff" ? "secondary.main" : "primary.main", a = !!(e.roleLabel || e.lastAccessedText);
  return /* @__PURE__ */ p.jsxs(
    Me,
    {
      role: "button",
      tabIndex: 0,
      onClick: n,
      onKeyDown: (o) => {
        (o.key === "Enter" || o.key === " ") && (o.preventDefault(), n());
      },
      sx: {
        display: "flex",
        alignItems: "center",
        gap: 2,
        p: 2,
        borderRadius: 2,
        border: "1px solid",
        borderColor: "divider",
        bgcolor: "grey.50",
        boxShadow: "0 1px 2px rgba(0, 0, 0, 0.035)",
        cursor: "pointer",
        transition: (o) => o.transitions.create(
          ["background-color", "box-shadow", "border-color"],
          {
            duration: o.transitions.duration.shortest
          }
        ),
        "&:hover": {
          bgcolor: "grey.100",
          boxShadow: "0 2px 6px rgba(0, 0, 0, 0.055)",
          borderColor: "grey.300"
        },
        "&:active": {
          bgcolor: "grey.200",
          boxShadow: "0 1px 2px rgba(0, 0, 0, 0.04)"
        },
        "&:focus-visible": {
          outline: "2px solid",
          outlineColor: "primary.main",
          outlineOffset: 2
        }
      },
      children: [
        /* @__PURE__ */ p.jsx(lN, { row: e }),
        /* @__PURE__ */ p.jsxs(Me, { flex: 1, minWidth: 0, textAlign: "left", children: [
          /* @__PURE__ */ p.jsxs(Pe, { direction: "row", alignItems: "center", gap: 1, flexWrap: "wrap", children: [
            /* @__PURE__ */ p.jsx(Te, { variant: "subtitle1", fontWeight: 700, noWrap: !0, children: e.title }),
            e.showActiveBadge ? /* @__PURE__ */ p.jsx(
              fr,
              {
                label: "ACTIVE",
                size: "small",
                sx: (o) => ({
                  height: 22,
                  fontSize: 11,
                  fontWeight: 700,
                  letterSpacing: 0.4,
                  bgcolor: o.palette.success.light,
                  color: o.palette.success.dark,
                  border: "none"
                })
              }
            ) : null
          ] }),
          a ? /* @__PURE__ */ p.jsxs(Te, { variant: "body2", color: "text.secondary", mt: 0.5, children: [
            e.roleLabel ? /* @__PURE__ */ p.jsx(
              Me,
              {
                component: "span",
                sx: { color: r, fontWeight: 600 },
                children: e.roleLabel
              }
            ) : null,
            e.roleLabel && e.lastAccessedText ? /* @__PURE__ */ p.jsx(
              Me,
              {
                component: "span",
                sx: { color: "text.disabled", px: 0.75 },
                children: "·"
              }
            ) : null,
            e.lastAccessedText ? /* @__PURE__ */ p.jsx(Me, { component: "span", children: e.lastAccessedText }) : null
          ] }) : null
        ] }),
        /* @__PURE__ */ p.jsx(
          Te,
          {
            component: "span",
            sx: {
              color: "text.disabled",
              fontSize: 20,
              lineHeight: 1,
              flexShrink: 0,
              pr: 0.5
            },
            "aria-hidden": !0,
            children: "›"
          }
        )
      ]
    }
  );
}
const Ty = ({
  signedInEmail: e,
  workspaces: n,
  onSelectRowKey: r,
  onCancel: a,
  cancelLabel: o = "Cancel and sign out"
}) => {
  const l = !!(e != null && e.trim());
  return /* @__PURE__ */ p.jsx(
    rx,
    {
      maxWidth: "sm",
      innerProps: { minHeight: "var(--liscio-app-viewport-height, 100vh)" },
      children: /* @__PURE__ */ p.jsxs(
        Me,
        {
          sx: {
            width: "100%",
            maxWidth: cN,
            mx: "auto",
            px: { xs: 2, sm: 0 },
            py: { xs: 4, md: 6 },
            color: "text.primary"
          },
          children: [
            /* @__PURE__ */ p.jsx(
              Me,
              {
                sx: {
                  mb: 3,
                  width: "100%",
                  display: "flex",
                  justifyContent: "center"
                },
                children: /* @__PURE__ */ p.jsx(Me, { sx: { width: "100%", maxWidth: 240 }, children: /* @__PURE__ */ p.jsx(
                  tf,
                  {
                    variant: "logoSplash",
                    sx: {
                      width: "100%",
                      maxHeight: 72,
                      objectFit: "contain",
                      display: "block"
                    }
                  }
                ) })
              }
            ),
            /* @__PURE__ */ p.jsx(
              Te,
              {
                variant: "h5",
                fontWeight: 700,
                gutterBottom: !0,
                sx: { textAlign: "center" },
                children: "Choose a workspace"
              }
            ),
            l ? /* @__PURE__ */ p.jsxs(
              Te,
              {
                variant: "body2",
                color: "text.secondary",
                mb: 3,
                sx: { textAlign: "center" },
                children: [
                  "You're signed in as",
                  " ",
                  /* @__PURE__ */ p.jsx(Me, { component: "span", fontWeight: 700, color: "text.primary", children: e }),
                  ". Pick the firm you want to work with."
                ]
              }
            ) : /* @__PURE__ */ p.jsx(
              Te,
              {
                variant: "body2",
                color: "text.secondary",
                mb: 3,
                sx: { textAlign: "center" },
                children: "Pick the firm you want to work with."
              }
            ),
            /* @__PURE__ */ p.jsx(Pe, { spacing: 1.5, children: n.map((d) => /* @__PURE__ */ p.jsx(
              uN,
              {
                row: d,
                onSelect: () => r(d.rowKey)
              },
              d.rowKey
            )) }),
            /* @__PURE__ */ p.jsx(
              lt,
              {
                fullWidth: !0,
                variant: "outlined",
                color: "inherit",
                onClick: a,
                sx: {
                  mt: 3,
                  py: 1.25,
                  borderColor: "divider",
                  color: "text.secondary",
                  fontWeight: 600,
                  borderRadius: 2,
                  textTransform: "none"
                },
                children: o
              }
            )
          ]
        }
      )
    }
  );
}, yU = ({
  cpas: e = [],
  onCancel: n,
  onCpaSelected: r,
  isLoading: a,
  userEmail: o,
  cancelLabel: l = "Cancel"
}) => {
  if (a)
    return /* @__PURE__ */ p.jsx(mi, { open: !0 });
  const d = ky(
    e.map(
      (f, s) => aN(f, s)
    )
  ), c = (f) => {
    const s = d.findIndex((h) => h.rowKey === f);
    s >= 0 && r(e[s]);
  };
  return /* @__PURE__ */ p.jsx(
    Ty,
    {
      signedInEmail: o,
      workspaces: d,
      onSelectRowKey: c,
      onCancel: n,
      cancelLabel: l
    }
  );
};
function vU({
  cpas: e,
  selectCpa: n,
  onCancel: r,
  userEmail: a,
  cancelLabel: o
}) {
  const l = ky(
    e.map((c, f) => oN(c, f))
  ), d = (c) => {
    const f = l.findIndex((s) => s.rowKey === c);
    f >= 0 && n(e[f]);
  };
  return /* @__PURE__ */ p.jsx(
    Ty,
    {
      signedInEmail: a,
      workspaces: l,
      onSelectRowKey: d,
      onCancel: r,
      cancelLabel: o ?? "Cancel and sign out"
    }
  );
}
const Al = 10, dN = (e) => (e == null ? void 0 : e.name) === "NotAllowedError", Oy = ({
  onSuccess: e,
  onCancel: n
} = {}) => {
  const r = qn(), { trackEvent: a } = Ic(), [o, l] = Ee(!1), d = F8(), c = P8(), f = Sc(), s = o || d.isLoading || c.isLoading, h = () => r.invalidateQueries({
    queryKey: px()
  });
  return {
    isRegistering: s,
    isWebAuthnSupported: f,
    registerPasskey: async ({
      currentPasskeyCount: t
    }) => {
      if (!f)
        return rn.error("This browser does not support passkeys"), !1;
      if (t >= Al)
        return rn.error("Delete an existing passkey before adding another"), !1;
      a(en.PASSKEY_SETUP_SUBMITTED), l(!0);
      try {
        const i = await d.mutateAsync(), m = await sC({
          optionsJSON: i.options
        });
        return await c.mutateAsync({
          data: {
            challenge_id: i.challenge_id,
            credential: m
          }
        }), await h(), a(en.PASSKEY_SETUP_COMPLETED), rn.success("Passkey added"), await (e == null ? void 0 : e()), !0;
      } catch (i) {
        return dN(i) ? (n == null || n(), !1) : (a(en.PASSKEY_SETUP_FAILED), rn.error("Unable to add passkey. Please try again."), !1);
      } finally {
        l(!1);
      }
    }
  };
}, _m = (e) => e ? new Date(e).toLocaleString() : "Never", wU = () => {
  const { enablePasskeyLogin: e = !1 } = Dr(), n = qn(), { trackEvent: r } = Ic(), a = gx({
    query: { enabled: !!e }
  }), o = j8(), l = R8(), d = a.data ?? [], { isRegistering: c, isWebAuthnSupported: f, registerPasskey: s } = Oy(), h = c || o.isLoading || l.isLoading;
  if (!e)
    return null;
  const g = () => n.invalidateQueries({
    queryKey: px()
  }), t = () => s({ currentPasskeyCount: d.length }), i = async (v, E) => {
    const S = window.prompt("Name this passkey", E);
    if (S)
      try {
        await o.mutateAsync({ id: v, data: { nickname: S } }), await g(), r(en.PASSKEY_RENAMED), rn.success("Passkey renamed");
      } catch {
        rn.error("Unable to rename passkey. Please try again.");
      }
  }, m = async (v) => {
    if (window.confirm(
      "Delete this passkey? You can keep using your other sign-in methods."
    ))
      try {
        await l.mutateAsync({ id: v }), await g(), r(en.PASSKEY_DELETED), rn.success("Passkey deleted");
      } catch {
        rn.error("Unable to delete passkey. Please try again.");
      }
  };
  return /* @__PURE__ */ p.jsxs(Pe, { gap: 2, children: [
    /* @__PURE__ */ p.jsxs(Pe, { direction: "row", alignItems: "center", justifyContent: "space-between", children: [
      /* @__PURE__ */ p.jsxs(Pe, { children: [
        /* @__PURE__ */ p.jsx(Te, { variant: "h3", children: "Passkeys" }),
        /* @__PURE__ */ p.jsx(Te, { color: "text.secondary", children: "Sign in with your device biometric, PIN, or security key." })
      ] }),
      /* @__PURE__ */ p.jsx(
        lt,
        {
          type: "button",
          variant: "contained",
          disabled: h || !f || d.length >= Al,
          onClick: t,
          children: "Add passkey"
        }
      )
    ] }),
    !f && /* @__PURE__ */ p.jsx(Te, { color: "error", children: "This browser does not support passkeys." }),
    d.length >= Al && /* @__PURE__ */ p.jsxs(Te, { color: "text.secondary", children: [
      "You have reached the maximum of ",
      Al,
      " passkeys."
    ] }),
    a.isLoading && /* @__PURE__ */ p.jsx(Te, { children: "Loading passkeys..." }),
    !a.isLoading && d.length === 0 && /* @__PURE__ */ p.jsx(Te, { color: "text.secondary", children: "No passkeys added yet." }),
    d.map((v) => /* @__PURE__ */ p.jsxs(
      Pe,
      {
        direction: { xs: "column", sm: "row" },
        justifyContent: "space-between",
        gap: 2,
        sx: (E) => ({
          border: `1px solid ${E.palette.divider}`,
          borderRadius: 2,
          padding: 2
        }),
        children: [
          /* @__PURE__ */ p.jsxs(Pe, { children: [
            /* @__PURE__ */ p.jsx(Te, { fontWeight: 700, children: v.display_name }),
            /* @__PURE__ */ p.jsxs(Te, { variant: "body2", color: "text.secondary", children: [
              v.provider_label,
              " · Created",
              " ",
              _m(v.created_at),
              " · Last used",
              " ",
              _m(v.last_used_at)
            ] })
          ] }),
          /* @__PURE__ */ p.jsxs(Pe, { direction: "row", gap: 1, children: [
            /* @__PURE__ */ p.jsx(
              lt,
              {
                type: "button",
                variant: "outlined",
                disabled: h,
                onClick: () => i(v.id, v.display_name),
                children: "Rename"
              }
            ),
            /* @__PURE__ */ p.jsx(
              lt,
              {
                type: "button",
                variant: "outlined",
                color: "error",
                disabled: h,
                onClick: () => m(v.id),
                children: "Delete"
              }
            )
          ] })
        ]
      },
      v.id
    ))
  ] });
}, SU = () => {
  const { enablePasskeyLogin: e = !1 } = Dr(), n = Ls(({ auth_token: E }) => E), [r, a] = Ee(
    () => vp()
  ), [o, l] = Ee(() => yp()), { trackEvent: d } = Ic(), { isRegistering: c, isWebAuthnSupported: f, registerPasskey: s } = Oy({
    onSuccess: () => {
      $l(), l(void 0);
    },
    onCancel: () => {
      l(void 0);
    }
  });
  ot(() => {
    l(yp()), a(vp());
  }, [n]);
  const h = !!(e && n && o && f && !r), g = gx({
    query: { enabled: h }
  }), t = g.data ?? [], i = Tt(
    () => h && !g.isLoading && !g.isError && t.length === 0,
    [
      h,
      t.length,
      g.isError,
      g.isLoading
    ]
  );
  ot(() => {
    !i || !o || d(en.PASSKEY_SETUP_PROMPT_SHOWN, {
      primary_method: o.primaryMethod
    });
  }, [i, o, d]);
  const m = () => {
    hC(), a(!0), l(void 0), d(en.PASSKEY_SETUP_PROMPT_DISMISSED, {
      primary_method: o == null ? void 0 : o.primaryMethod
    });
  }, v = async () => {
    d(en.PASSKEY_SETUP_PROMPT_ACCEPTED, {
      primary_method: o == null ? void 0 : o.primaryMethod
    }), await s({ currentPasskeyCount: t.length });
  };
  return i ? /* @__PURE__ */ p.jsx(
    oi,
    {
      open: !0,
      title: "Set up a passkey?",
      type: "info",
      onClose: m,
      onCancel: m,
      cancelLabel: "Maybe later",
      cancelBtnProps: { disabled: c },
      onSubmit: v,
      submitLabel: "Set up passkey",
      submitBtnProps: { disabled: c },
      children: /* @__PURE__ */ p.jsx(Te, { color: "text.secondary", children: "Sign in faster next time with your device biometric, PIN, or security key." })
    }
  ) : null;
}, hN = tt(Me)(({ theme: e }) => {
  var n, r;
  return {
    display: "flex",
    alignItems: "stretch",
    borderBottom: `1px solid ${((r = (n = e.palette.common) == null ? void 0 : n.neutrals) == null ? void 0 : r[300]) ?? "#d1d5db"}`
  };
}), Cm = tt(Ff, {
  shouldForwardProp: (e) => e !== "isActive"
})(({ theme: e, isActive: n }) => {
  var r, a, o, l, d, c, f, s;
  return {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: e.spacing(1.25),
    padding: e.spacing(1.75, 1),
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "20px",
    color: n ? ((a = (r = e.palette.common) == null ? void 0 : r.accent) == null ? void 0 : a[600]) ?? "#ed1cb0" : ((l = (o = e.palette.common) == null ? void 0 : o.neutrals) == null ? void 0 : l[500]) ?? "#8f98a3",
    borderBottom: n ? `3px solid ${((c = (d = e.palette.common) == null ? void 0 : d.accent) == null ? void 0 : c[600]) ?? "#ed1cb0"}` : "2px solid transparent",
    marginBottom: "-1px",
    "& .MuiTouchRipple-root": {
      color: ((s = (f = e.palette.common) == null ? void 0 : f.neutrals) == null ? void 0 : s[400]) ?? "#b5bdc8"
    }
  };
}), fN = tt("span")(({ theme: e }) => ({
  display: "inline-flex",
  alignItems: "center",
  padding: e.spacing(0.375, 1),
  borderRadius: "999px",
  fontSize: "11px",
  fontWeight: 800,
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  color: "currentColor",
  border: "1px solid currentColor"
})), pa = ["magicLink", "password"], pN = ({ value: e, onChange: n }) => {
  var c, f, s, h;
  const r = Mr(), a = ((f = (c = r.palette.common) == null ? void 0 : c.neutrals) == null ? void 0 : f[500]) ?? "#6b7280", o = ((h = (s = r.palette.common) == null ? void 0 : s.accent) == null ? void 0 : h[600]) ?? "#ed1cb0", l = e === "magicLink" ? o : a, d = (g) => {
    const t = pa.indexOf(e);
    if (t < 0) return;
    const i = pa.length - 1;
    let m = t;
    switch (g.key) {
      case "ArrowRight":
        m = (t + 1) % pa.length;
        break;
      case "ArrowLeft":
        m = (t - 1 + pa.length) % pa.length;
        break;
      case "Home":
        m = 0;
        break;
      case "End":
        m = i;
        break;
      default:
        return;
    }
    g.preventDefault(), n(pa[m]);
  };
  return /* @__PURE__ */ p.jsxs(hN, { role: "tablist", "aria-label": "Sign-in method", children: [
    /* @__PURE__ */ p.jsxs(
      Cm,
      {
        role: "tab",
        "aria-selected": e === "magicLink",
        tabIndex: e === "magicLink" ? 0 : -1,
        isActive: e === "magicLink",
        onClick: () => n("magicLink"),
        onKeyDown: d,
        type: "button",
        children: [
          /* @__PURE__ */ p.jsx(
            it,
            {
              icon: "sparklesSolid",
              "aria-hidden": !0,
              sx: { color: l, fontSize: "16px" }
            }
          ),
          "Magic Link",
          /* @__PURE__ */ p.jsx(fN, { children: "Fast" })
        ]
      }
    ),
    /* @__PURE__ */ p.jsxs(
      Cm,
      {
        role: "tab",
        "aria-selected": e === "password",
        tabIndex: e === "password" ? 0 : -1,
        isActive: e === "password",
        onClick: () => n("password"),
        onKeyDown: d,
        type: "button",
        children: [
          /* @__PURE__ */ p.jsx(
            it,
            {
              icon: "lock",
              "aria-hidden": !0,
              sx: {
                color: e === "password" ? o : a,
                fontSize: "16px"
              }
            }
          ),
          "Password"
        ]
      }
    )
  ] });
}, gN = tt(Pe)(({ theme: e }) => ({
  height: e.spacing(30),
  width: "100%"
})), _U = ({
  topContent: e
}) => /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
  e,
  /* @__PURE__ */ p.jsx(gN, { alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ p.jsx(Jh, { color: "inherit" }) })
] }), CU = tt(lt)(({ theme: e }) => ({
  backgroundColor: e.palette.common.white,
  borderRadius: "5px",
  color: e.palette.common.neutrals[800],
  border: `1px solid ${e.palette.common.neutrals[400]}`,
  width: "100%",
  paddingLeft: "8px",
  paddingRight: "8px",
  "&:hover": {
    backgroundColor: e.palette.common.neutrals[200]
  }
})), mN = ({
  control: e,
  updateRememberMeEmailValue: n,
  captureForgotPasswordEmail: r,
  forgotPasswordTo: a,
  forgotPasswordColor: o,
  RememberMeToggleComponent: l,
  BiometricsToggleComponent: d,
  LinkComponent: c
}) => /* @__PURE__ */ p.jsxs(
  Pe,
  {
    direction: { xs: "column", sm: "row" },
    alignItems: { xs: "flex-start", sm: "center" },
    justifyContent: "space-between",
    gap: { xs: 2, sm: 0 },
    useFlexGap: !0,
    children: [
      /* @__PURE__ */ p.jsx(
        l,
        {
          name: "enableRememberMe",
          resetEmailField: n,
          control: e
        }
      ),
      /* @__PURE__ */ p.jsx(
        c,
        {
          onClick: r,
          to: a,
          underline: "none",
          color: o,
          children: /* @__PURE__ */ p.jsx(Te, { children: "Forgot your password?" })
        }
      ),
      /* @__PURE__ */ p.jsx(d, { control: e, name: "enableBiometrics" })
    ]
  }
), Am = ({
  isLoading: e,
  submitLabel: n
}) => /* @__PURE__ */ p.jsx(lt, { variant: "contained", type: "submit", disabled: e, size: "large", children: n }), AU = ({
  isLoading: e,
  control: n,
  updateRememberMeEmailValue: r,
  captureForgotPasswordEmail: a,
  credentialsFields: o,
  submitLabel: l,
  forgotPasswordTo: d,
  forgotPasswordColor: c,
  RememberMeToggleComponent: f,
  BiometricsToggleComponent: s,
  LinkComponent: h,
  submitButtonBeforeOptions: g = !1,
  gap: t = 2
}) => {
  const i = /* @__PURE__ */ p.jsx(
    mN,
    {
      control: n,
      updateRememberMeEmailValue: r,
      captureForgotPasswordEmail: a,
      forgotPasswordTo: d,
      forgotPasswordColor: c,
      RememberMeToggleComponent: f,
      BiometricsToggleComponent: s,
      LinkComponent: h
    }
  );
  return /* @__PURE__ */ p.jsxs(Pe, { gap: t, useFlexGap: !0, children: [
    o,
    g ? /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
      /* @__PURE__ */ p.jsx(Am, { isLoading: e, submitLabel: l }),
      i
    ] }) : /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
      i,
      /* @__PURE__ */ p.jsx(Am, { isLoading: e, submitLabel: l })
    ] })
  ] });
}, kU = ({
  isLoading: e = !1,
  onSubmit: n,
  validationSchema: r
}) => {
  var c;
  const {
    register: a,
    handleSubmit: o,
    formState: { errors: l }
  } = mr({
    resolver: ws(r)
  }), d = (f) => {
    n(f.email);
  };
  return /* @__PURE__ */ p.jsx("form", { onSubmit: o(d), children: /* @__PURE__ */ p.jsxs(Pe, { gap: 2, useFlexGap: !0, children: [
    /* @__PURE__ */ p.jsx(
      qs,
      {
        ...a("email"),
        fullWidth: !0,
        type: "email",
        placeholder: "Email",
        inputProps: { "aria-label": "Email" },
        error: !!(l != null && l.email),
        helperText: (c = l == null ? void 0 : l.email) == null ? void 0 : c.message,
        disabled: e
      }
    ),
    /* @__PURE__ */ p.jsxs(lt, { variant: "contained", type: "submit", disabled: e, size: "large", children: [
      /* @__PURE__ */ p.jsx(it, { icon: "sparkles", sx: { color: "common.white", fontSize: "14px", mr: 1 } }),
      "Email me a sign-in link"
    ] }),
    /* @__PURE__ */ p.jsx(
      Te,
      {
        textAlign: "center",
        color: (f) => {
          var s, h;
          return ((h = (s = f.palette.common) == null ? void 0 : s.neutrals) == null ? void 0 : h[500]) ?? "#6b7280";
        },
        children: "No password needed - Link expires in 15 min"
      }
    )
  ] }) });
}, EU = ({
  activeTab: e,
  onTabChange: n,
  headerContent: r,
  stackLeadingContent: a,
  magicLinkPanel: o,
  passwordPanel: l,
  stackTrailingContent: d,
  footerContent: c
}) => /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
  r,
  /* @__PURE__ */ p.jsxs(Pe, { gap: 3, useFlexGap: !0, children: [
    a,
    /* @__PURE__ */ p.jsx(pN, { value: e, onChange: n }),
    e === "magicLink" ? o : l,
    d
  ] }),
  c
] }), xN = ({
  thread: e
}) => /* @__PURE__ */ p.jsxs(Me, { children: [
  /* @__PURE__ */ p.jsx(Me, { children: /* @__PURE__ */ p.jsx(Me, { component: "img", src: $5, width: 120 }) }),
  /* @__PURE__ */ p.jsx(Te, { variant: "h6", mt: 5, mb: 2, children: e.message[0].title }),
  /* @__PURE__ */ p.jsx(wn, {}),
  /* @__PURE__ */ p.jsx(Pe, { divider: /* @__PURE__ */ p.jsx(wn, {}), gap: 4, mt: 2, mb: 4, children: e.message.map((n) => /* @__PURE__ */ p.jsxs(Me, { children: [
    /* @__PURE__ */ p.jsxs(
      Me,
      {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ p.jsx(Te, { variant: "h6", children: n.sender }),
          /* @__PURE__ */ p.jsx(Me, { children: n.sent_at_iso8601 ? uf(p7(n.sent_at_iso8601), "PPpp") : n.tym })
        ]
      }
    ),
    /* @__PURE__ */ p.jsx(Me, { mt: 1, children: /* @__PURE__ */ p.jsx(Me, { children: /* @__PURE__ */ p.jsxs(Te, { children: [
      "To: ",
      jC(n)
    ] }) }) }),
    /* @__PURE__ */ p.jsx(Me, { mt: 4, children: /* @__PURE__ */ p.jsx(
      eM,
      {
        html: n.content,
        presentation: "message"
      }
    ) }),
    n.documents && n.documents.length > 0 && /* @__PURE__ */ p.jsx(Me, { mt: 4, children: /* @__PURE__ */ p.jsxs(Te, { children: [
      "Attachments:",
      " ",
      n.documents.map(({ doc_name: r }) => r).join(", ")
    ] }) })
  ] }, n.id)) }),
  /* @__PURE__ */ p.jsx(wn, {})
] }), IU = ({
  thread: e
}) => {
  const n = ut(null), r = E7({
    content: () => n.current
  });
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsx(Kh, { title: "Print Message Thread", children: /* @__PURE__ */ p.jsx(
      Gn,
      {
        onClick: r,
        disabled: !e,
        sx: { width: 60, height: 60 },
        children: /* @__PURE__ */ p.jsx(it, { icon: "print", fontSize: "large" })
      }
    ) }),
    e && /* @__PURE__ */ p.jsx(U5, { ref: n, children: /* @__PURE__ */ p.jsx(xN, { thread: e }) })
  ] });
}, TU = ({ documents: e, chipSize: n = "small", maxNameWidth: r = 100, sx: a }) => {
  var c, f;
  if (!e || e.length === 0) return null;
  const o = e[0], l = (c = o == null ? void 0 : o.aws_url_content_type) == null ? void 0 : c.includes("application/pdf"), d = (f = o == null ? void 0 : o.aws_url_content_type) == null ? void 0 : f.includes("image/");
  return /* @__PURE__ */ p.jsxs(
    Pe,
    {
      direction: "row",
      sx: {
        mr: 2,
        justifyContent: "flex-start",
        alignItems: "center",
        gap: 1,
        minWidth: 0,
        flexShrink: 1,
        ...a
      },
      children: [
        /* @__PURE__ */ p.jsx(
          fr,
          {
            size: n,
            sx: { minWidth: 0, flex: "0 1 auto" },
            label: /* @__PURE__ */ p.jsxs(
              Pe,
              {
                direction: "row",
                sx: { alignItems: "center", overflow: "hidden", minWidth: 0 },
                children: [
                  /* @__PURE__ */ p.jsx(z5, { isPdf: !!l, isImage: !!d }),
                  /* @__PURE__ */ p.jsx(
                    Te,
                    {
                      ml: 0.5,
                      variant: n === "small" ? "caption" : "body2",
                      noWrap: !0,
                      sx: {
                        maxWidth: r,
                        minWidth: 0,
                        display: "inline-block"
                      },
                      children: o == null ? void 0 : o.display_name
                    }
                  )
                ]
              }
            )
          }
        ),
        e.length > 1 && /* @__PURE__ */ p.jsx(
          fr,
          {
            size: n,
            sx: { flexShrink: 0 },
            label: `+ ${e.length - 1}`
          }
        )
      ]
    }
  );
}, bN = tt(Me)(({ theme: e }) => ({
  display: "flex",
  gap: e.spacing(1),
  padding: e.spacing(2),
  borderBottom: `1px solid ${e.palette.divider}`,
  flexWrap: "wrap",
  alignItems: "center"
})), yN = tt(Me)(({ theme: e }) => ({
  display: "flex",
  gap: e.spacing(0.5),
  padding: e.spacing(1, 2),
  flexWrap: "wrap",
  alignItems: "center",
  minHeight: e.spacing(4)
})), ga = tt(lt)(
  ({ theme: e, active: n }) => ({
    textTransform: "uppercase",
    fontWeight: 500,
    fontSize: "0.75rem",
    padding: e.spacing(0.75, 2),
    minWidth: "auto",
    backgroundColor: n ? e.palette.primary.main : void 0,
    color: n ? e.palette.primary.contrastText : void 0,
    "&:hover": {
      backgroundColor: n ? e.palette.primary.dark : void 0
    }
  })
), km = [
  { label: "All", value: "" },
  { label: "Me", value: Lo.Client },
  { label: "Uploaded by Firm", value: Lo.Firm }
], vN = ({
  searchQuery: e,
  onSearchQueryChange: n,
  selectedTags: r,
  onSelectedTagsChange: a,
  selectedMonths: o,
  onSelectedMonthsChange: l,
  selectedYears: d,
  onSelectedYearsChange: c,
  selectedAccount: f,
  onSelectedAccountChange: s,
  fileUploadedBy: h,
  onFileUploadedByChange: g,
  filterStatus: t,
  onFilterStatusChange: i,
  onClearFilters: m,
  availableTags: v,
  availableYears: E,
  availableMonths: S,
  accounts: y,
  isLoadingFilters: x
}) => {
  var A;
  const [b, u] = Ee(null), [I, O] = Ee(null), [D, $] = Ee(null), [K, H] = Ee(null), [B, R] = Ee(null), _ = e || r.length > 0 || d.length > 0 || o.length > 0 || h || f;
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsxs(bN, { children: [
      /* @__PURE__ */ p.jsx(Te, { variant: "body2", sx: { fontWeight: 500, mr: 1 }, children: "Filter by" }),
      /* @__PURE__ */ p.jsx(
        vi,
        {
          placeholder: "Search files...",
          value: e,
          onChange: (k) => n(k.target.value),
          size: "small",
          sx: { flex: 1, minWidth: 200, maxWidth: 300 },
          InputProps: {
            startAdornment: /* @__PURE__ */ p.jsx(vr, { position: "start", children: /* @__PURE__ */ p.jsx(it, { icon: "search" }) })
          }
        }
      ),
      /* @__PURE__ */ p.jsx(
        ga,
        {
          variant: "outlined",
          size: "small",
          active: !!h,
          onClick: (k) => u(k.currentTarget),
          children: "Uploaded By"
        }
      ),
      /* @__PURE__ */ p.jsx(
        ga,
        {
          variant: "outlined",
          size: "small",
          active: r.length > 0,
          onClick: (k) => O(k.currentTarget),
          children: "Tags"
        }
      ),
      /* @__PURE__ */ p.jsx(
        ga,
        {
          variant: "outlined",
          size: "small",
          active: !!f,
          onClick: (k) => R(k.currentTarget),
          children: "Account"
        }
      ),
      /* @__PURE__ */ p.jsx(
        ga,
        {
          variant: "outlined",
          size: "small",
          active: o.length > 0,
          onClick: (k) => $(k.currentTarget),
          children: "Month"
        }
      ),
      /* @__PURE__ */ p.jsx(
        ga,
        {
          variant: "outlined",
          size: "small",
          active: d.length > 0,
          onClick: (k) => H(k.currentTarget),
          children: "Year"
        }
      ),
      /* @__PURE__ */ p.jsx(
        ga,
        {
          variant: t === "active" ? "contained" : "outlined",
          size: "small",
          onClick: () => i(t === "active" ? "archived" : "active"),
          children: t === "active" ? "Active" : "Archived"
        }
      ),
      _ && /* @__PURE__ */ p.jsx(
        lt,
        {
          variant: "text",
          size: "small",
          startIcon: /* @__PURE__ */ p.jsx(it, { icon: "close" }),
          onClick: m,
          children: "Clear All"
        }
      )
    ] }),
    _ && /* @__PURE__ */ p.jsxs(yN, { children: [
      d.map((k) => /* @__PURE__ */ p.jsx(
        Ai,
        {
          label: k,
          size: "small",
          onDelete: () => c(d.filter((z) => z !== k))
        },
        k
      )),
      o.map((k) => /* @__PURE__ */ p.jsx(
        Ai,
        {
          label: k,
          size: "small",
          onDelete: () => l(o.filter((z) => z !== k))
        },
        k
      )),
      r.map((k) => /* @__PURE__ */ p.jsx(
        Ai,
        {
          label: gs(k),
          size: "small",
          onDelete: () => a(r.filter((z) => z !== k))
        },
        k
      )),
      f && /* @__PURE__ */ p.jsx(
        Ai,
        {
          label: `Account: ${f.name}`,
          size: "small",
          onDelete: () => s(null)
        }
      ),
      h && /* @__PURE__ */ p.jsx(
        Ai,
        {
          label: ((A = km.find((k) => k.value === h)) == null ? void 0 : A.label) || h,
          size: "small",
          onDelete: () => g("")
        }
      )
    ] }),
    /* @__PURE__ */ p.jsx(
      Ji,
      {
        anchorEl: b,
        open: !!b,
        onClose: () => u(null),
        children: km.map((k) => /* @__PURE__ */ p.jsx(
          Rn,
          {
            selected: h === k.value,
            onClick: () => {
              g(k.value || ""), u(null);
            },
            children: /* @__PURE__ */ p.jsx(Mn, { primary: k.label })
          },
          k.value || "all"
        ))
      }
    ),
    /* @__PURE__ */ p.jsx(
      Ji,
      {
        anchorEl: I,
        open: !!I,
        onClose: () => O(null),
        PaperProps: { sx: { maxHeight: 300 } },
        children: v.map((k) => /* @__PURE__ */ p.jsxs(
          Rn,
          {
            onClick: () => {
              a(
                r.includes(k) ? r.filter((z) => z !== k) : [...r, k]
              );
            },
            children: [
              /* @__PURE__ */ p.jsx(Hi, { checked: r.includes(k), size: "small" }),
              /* @__PURE__ */ p.jsx(Mn, { primary: gs(k) })
            ]
          },
          k
        ))
      }
    ),
    /* @__PURE__ */ p.jsx(
      Ji,
      {
        anchorEl: D,
        open: !!D,
        onClose: () => $(null),
        children: S.map((k) => /* @__PURE__ */ p.jsxs(
          Rn,
          {
            onClick: () => {
              l(
                o.includes(k) ? o.filter((z) => z !== k) : [...o, k]
              );
            },
            children: [
              /* @__PURE__ */ p.jsx(Hi, { checked: o.includes(k), size: "small" }),
              /* @__PURE__ */ p.jsx(Mn, { primary: k })
            ]
          },
          k
        ))
      }
    ),
    /* @__PURE__ */ p.jsx(
      Ji,
      {
        anchorEl: K,
        open: !!K,
        onClose: () => H(null),
        children: E.map((k) => /* @__PURE__ */ p.jsxs(
          Rn,
          {
            onClick: () => {
              c(
                d.includes(k) ? d.filter((z) => z !== k) : [...d, k]
              );
            },
            children: [
              /* @__PURE__ */ p.jsx(Hi, { checked: d.includes(k), size: "small" }),
              /* @__PURE__ */ p.jsx(Mn, { primary: k })
            ]
          },
          k
        ))
      }
    ),
    /* @__PURE__ */ p.jsx(
      Ji,
      {
        anchorEl: B,
        onClose: () => R(null),
        open: !!B,
        PaperProps: { sx: { maxHeight: 300, minWidth: 250 } },
        children: x ? /* @__PURE__ */ p.jsx(Rn, { disabled: !0, children: /* @__PURE__ */ p.jsx(Mn, { primary: "Loading..." }) }) : y.length === 0 ? /* @__PURE__ */ p.jsx(Rn, { disabled: !0, children: /* @__PURE__ */ p.jsx(Mn, { primary: "No accounts found" }) }) : y.map((k) => /* @__PURE__ */ p.jsx(
          Rn,
          {
            selected: (f == null ? void 0 : f.id) === k.id,
            onClick: () => {
              s(k), R(null);
            },
            children: /* @__PURE__ */ p.jsx(Mn, { primary: k.name })
          },
          k.id
        ))
      }
    )
  ] });
}, wN = tt(Me)(({ theme: e }) => ({
  display: "flex",
  gap: e.spacing(1),
  padding: e.spacing(2),
  borderBottom: `1px solid ${e.palette.divider}`,
  flexWrap: "wrap",
  alignItems: "center"
})), SN = tt(Me)(({ theme: e }) => ({
  display: "flex",
  gap: e.spacing(0.5),
  padding: e.spacing(1, 2),
  flexWrap: "wrap",
  alignItems: "center",
  minHeight: e.spacing(4)
})), as = tt(lt)(
  ({ theme: e, active: n }) => ({
    textTransform: "uppercase",
    fontWeight: 500,
    fontSize: "0.75rem",
    padding: e.spacing(0.75, 2),
    minWidth: "auto",
    backgroundColor: n ? e.palette.primary.main : void 0,
    color: n ? e.palette.primary.contrastText : void 0,
    "&:hover": {
      backgroundColor: n ? e.palette.primary.dark : void 0
    }
  })
), Em = [
  { label: "All", value: "" },
  { label: "Uploaded by Client", value: Lo.Client },
  { label: "Uploaded by Firm", value: Lo.Firm },
  { label: "Firm Only Files", value: Lo.Private }
], Im = [
  { key: "message", value: "message", label: "Message" },
  { key: "note", value: "note", label: "Note" },
  { key: "task", value: "task", label: "Task" },
  { key: "manual", value: "manual", label: "Manual" },
  { key: "bill", value: "bill", label: "Bill" },
  { key: "request", value: "request", label: "Request" }
], _N = ({
  searchQuery: e,
  onSearchQueryChange: n,
  searchMinLength: r,
  isSearching: a = !1,
  selectedSources: o,
  onSelectedSourcesChange: l,
  selectedTags: d,
  onSelectedTagsChange: c,
  selectedMonths: f,
  onSelectedMonthsChange: s,
  selectedYears: h,
  onSelectedYearsChange: g,
  selectedAccount: t,
  onSelectedAccountChange: i,
  selectedContacts: m,
  onSelectedContactsChange: v,
  fileUploadedBy: E,
  onFileUploadedByChange: S,
  filterStatus: y,
  onFilterStatusChange: x,
  onClearFilters: b,
  availableTags: u,
  availableYears: I,
  availableMonths: O,
  accounts: D,
  contacts: $,
  initialAccounts: K = [],
  initialContacts: H = [],
  onAccountSearchRequested: B,
  onContactSearchRequested: R,
  isLoadingAccountSearch: _ = !1,
  isLoadingContactSearch: A = !1,
  isLoadingInitialFilters: k = !1,
  isLoadingAccountContacts: z = !1,
  isLoadingFilters: T = !1,
  hideStatusFilter: w = !1
}) => {
  var ke;
  const [F, j] = Ee(null), [P, V] = Ee(null), [J, ne] = Ee(null), [Z, te] = Ee(null), [G, N] = Ee(null), [q, ie] = Ee(null), [oe, fe] = Ee(null), [Y, ae] = Ee(""), [se, L] = Ee(""), [W, M] = Ee(""), [X, U] = Ee(""), [Q, re] = Ee(""), [le, ce] = Ee(""), ee = e || d.length > 0 || h.length > 0 || f.length > 0 || o.length > 0 || E || t || m.length > 0, he = dc(), pe = e.trim().length, de = !!r && pe > 0 && pe < r, ge = (be, we) => be.trim() ? we.filter(
    (Le) => Le.toLowerCase().includes(be.trim().toLowerCase())
  ) : we, me = Y.trim() ? Im.filter(
    (be) => be.label.toLowerCase().includes(Y.trim().toLowerCase())
  ) : Im, xe = u.filter(
    (be) => df(be, se)
  ), ye = ge(W, O), ve = ge(X, I), Ce = () => {
    j(null), ae("");
  }, Ie = () => {
    ne(null), L("");
  }, Ae = () => {
    te(null), M("");
  }, Se = () => {
    N(null), U("");
  }, De = () => {
    ie(null), re("");
  }, Be = () => {
    fe(null), ce("");
  };
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsxs(wN, { children: [
      /* @__PURE__ */ p.jsx(Te, { variant: "body2", sx: { fontWeight: 500, mr: 1 }, children: "Filter by" }),
      /* @__PURE__ */ p.jsx(
        vi,
        {
          placeholder: r ? `Search files (${r}+ characters)` : "Search files...",
          value: e,
          onChange: (be) => n(be.target.value),
          size: "small",
          sx: { flex: 1, minWidth: 200, maxWidth: 300 },
          inputProps: {
            "aria-label": "Search files",
            "aria-describedby": de ? he : void 0
          },
          InputProps: {
            startAdornment: /* @__PURE__ */ p.jsx(vr, { position: "start", children: /* @__PURE__ */ p.jsx(it, { icon: "search" }) }),
            endAdornment: a ? /* @__PURE__ */ p.jsx(vr, { position: "end", children: /* @__PURE__ */ p.jsx(Jh, { size: 16, "aria-label": "Searching files" }) }) : de ? /* @__PURE__ */ p.jsx(vr, { position: "end", children: /* @__PURE__ */ p.jsxs(
              Te,
              {
                id: he,
                variant: "caption",
                color: "text.secondary",
                role: "status",
                children: [
                  "Type ",
                  r,
                  "+ characters"
                ]
              }
            ) }) : void 0
          }
        }
      ),
      /* @__PURE__ */ p.jsx(
        as,
        {
          variant: "outlined",
          size: "small",
          active: o.length > 0,
          onClick: (be) => j(be.currentTarget),
          children: "Sources"
        }
      ),
      /* @__PURE__ */ p.jsx(
        as,
        {
          variant: "outlined",
          size: "small",
          active: !!E,
          onClick: (be) => V(be.currentTarget),
          children: "Uploaded By"
        }
      ),
      /* @__PURE__ */ p.jsx(
        as,
        {
          variant: "outlined",
          size: "small",
          active: d.length > 0,
          onClick: (be) => ne(be.currentTarget),
          children: "Tags"
        }
      ),
      /* @__PURE__ */ p.jsx(
        as,
        {
          variant: "outlined",
          size: "small",
          active: f.length > 0,
          onClick: (be) => te(be.currentTarget),
          children: "Month"
        }
      ),
      /* @__PURE__ */ p.jsx(
        as,
        {
          variant: "outlined",
          size: "small",
          active: h.length > 0,
          onClick: (be) => N(be.currentTarget),
          children: "Year"
        }
      ),
      /* @__PURE__ */ p.jsx(
        as,
        {
          variant: "outlined",
          size: "small",
          active: !!t,
          onClick: (be) => ie(be.currentTarget),
          children: "Account"
        }
      ),
      /* @__PURE__ */ p.jsx(
        as,
        {
          variant: "outlined",
          size: "small",
          active: m.length > 0,
          onClick: (be) => fe(be.currentTarget),
          children: "Contact"
        }
      ),
      !w && /* @__PURE__ */ p.jsx(
        as,
        {
          variant: y === "active" ? "contained" : "outlined",
          size: "small",
          onClick: () => x(
            y === "active" ? "archived" : "active"
          ),
          children: y === "active" ? "Active" : "Archived"
        }
      ),
      ee && /* @__PURE__ */ p.jsx(
        lt,
        {
          variant: "text",
          size: "small",
          startIcon: /* @__PURE__ */ p.jsx(it, { icon: "close" }),
          onClick: b,
          children: "Clear All"
        }
      )
    ] }),
    ee && /* @__PURE__ */ p.jsxs(SN, { children: [
      h.map((be) => /* @__PURE__ */ p.jsx(
        Ai,
        {
          label: be,
          size: "small",
          onDelete: () => g(h.filter((we) => we !== be))
        },
        be
      )),
      f.map((be) => /* @__PURE__ */ p.jsx(
        Ai,
        {
          label: be,
          size: "small",
          onDelete: () => s(f.filter((we) => we !== be))
        },
        be
      )),
      d.map((be) => /* @__PURE__ */ p.jsx(
        Ai,
        {
          label: gs(be),
          size: "small",
          onDelete: () => c(d.filter((we) => we !== be))
        },
        be
      )),
      o.map((be) => /* @__PURE__ */ p.jsx(
        Ai,
        {
          label: be.label,
          size: "small",
          onDelete: () => l(
            o.filter((we) => we.key !== be.key)
          )
        },
        be.key
      )),
      t && /* @__PURE__ */ p.jsx(
        Ai,
        {
          label: `Account: ${t.name}`,
          size: "small",
          onDelete: () => i(null)
        }
      ),
      m.map((be) => /* @__PURE__ */ p.jsx(
        Ai,
        {
          label: `Contact: ${be.name}`,
          size: "small",
          onDelete: () => v(
            m.filter((we) => we.id !== be.id)
          )
        },
        be.id
      )),
      E && /* @__PURE__ */ p.jsx(
        Ai,
        {
          label: ((ke = Em.find((be) => be.value === E)) == null ? void 0 : ke.label) || E,
          size: "small",
          onDelete: () => S("")
        }
      )
    ] }),
    /* @__PURE__ */ p.jsx(
      Ji,
      {
        anchorEl: P,
        open: !!P,
        onClose: () => V(null),
        children: Em.map((be) => /* @__PURE__ */ p.jsx(
          Rn,
          {
            selected: E === be.value,
            onClick: () => {
              S(be.value || ""), V(null);
            },
            children: /* @__PURE__ */ p.jsx(Mn, { primary: be.label })
          },
          be.value || "all"
        ))
      }
    ),
    /* @__PURE__ */ p.jsxs(
      Ji,
      {
        anchorEl: F,
        open: !!F,
        onClose: Ce,
        PaperProps: { sx: { maxHeight: 360, minWidth: 220 } },
        children: [
          /* @__PURE__ */ p.jsx(
            Me,
            {
              sx: { px: 1.5, py: 1 },
              onClick: (be) => be.stopPropagation(),
              onKeyDown: (be) => be.stopPropagation(),
              onKeyUp: (be) => be.stopPropagation(),
              children: /* @__PURE__ */ p.jsx(
                vi,
                {
                  size: "small",
                  placeholder: "Search sources...",
                  value: Y,
                  onChange: (be) => ae(be.target.value),
                  fullWidth: !0,
                  autoFocus: !0,
                  InputProps: {
                    startAdornment: /* @__PURE__ */ p.jsx(vr, { position: "start", children: /* @__PURE__ */ p.jsx(it, { icon: "search" }) })
                  }
                }
              )
            }
          ),
          me.map((be) => /* @__PURE__ */ p.jsxs(
            Rn,
            {
              onClick: () => {
                const we = o.find((Le) => Le.key === be.key);
                l(
                  we ? o.filter((Le) => Le.key !== be.key) : [...o, be]
                );
              },
              children: [
                /* @__PURE__ */ p.jsx(
                  Hi,
                  {
                    checked: o.some((we) => we.key === be.key),
                    size: "small"
                  }
                ),
                /* @__PURE__ */ p.jsx(Mn, { primary: be.label })
              ]
            },
            be.key
          ))
        ]
      }
    ),
    /* @__PURE__ */ p.jsxs(
      Ji,
      {
        anchorEl: J,
        open: !!J,
        onClose: Ie,
        PaperProps: { sx: { maxHeight: 360, minWidth: 220 } },
        children: [
          /* @__PURE__ */ p.jsx(
            Me,
            {
              sx: { px: 1.5, py: 1 },
              onClick: (be) => be.stopPropagation(),
              onKeyDown: (be) => be.stopPropagation(),
              onKeyUp: (be) => be.stopPropagation(),
              children: /* @__PURE__ */ p.jsx(
                vi,
                {
                  size: "small",
                  placeholder: "Search tags...",
                  value: se,
                  onChange: (be) => L(be.target.value),
                  fullWidth: !0,
                  autoFocus: !0,
                  InputProps: {
                    startAdornment: /* @__PURE__ */ p.jsx(vr, { position: "start", children: /* @__PURE__ */ p.jsx(it, { icon: "search" }) })
                  }
                }
              )
            }
          ),
          xe.map((be) => /* @__PURE__ */ p.jsxs(
            Rn,
            {
              onClick: () => {
                c(
                  d.includes(be) ? d.filter((we) => we !== be) : [...d, be]
                );
              },
              children: [
                /* @__PURE__ */ p.jsx(Hi, { checked: d.includes(be), size: "small" }),
                /* @__PURE__ */ p.jsx(Mn, { primary: gs(be) })
              ]
            },
            be
          ))
        ]
      }
    ),
    /* @__PURE__ */ p.jsxs(
      Ji,
      {
        anchorEl: Z,
        open: !!Z,
        onClose: Ae,
        PaperProps: { sx: { maxHeight: 360, minWidth: 220 } },
        children: [
          /* @__PURE__ */ p.jsx(
            Me,
            {
              sx: { px: 1.5, py: 1 },
              onClick: (be) => be.stopPropagation(),
              onKeyDown: (be) => be.stopPropagation(),
              onKeyUp: (be) => be.stopPropagation(),
              children: /* @__PURE__ */ p.jsx(
                vi,
                {
                  size: "small",
                  placeholder: "Search month...",
                  value: W,
                  onChange: (be) => M(be.target.value),
                  fullWidth: !0,
                  autoFocus: !0,
                  InputProps: {
                    startAdornment: /* @__PURE__ */ p.jsx(vr, { position: "start", children: /* @__PURE__ */ p.jsx(it, { icon: "search" }) })
                  }
                }
              )
            }
          ),
          ye.map((be) => /* @__PURE__ */ p.jsxs(
            Rn,
            {
              onClick: () => {
                s(
                  f.includes(be) ? f.filter((we) => we !== be) : [...f, be]
                );
              },
              children: [
                /* @__PURE__ */ p.jsx(Hi, { checked: f.includes(be), size: "small" }),
                /* @__PURE__ */ p.jsx(Mn, { primary: be })
              ]
            },
            be
          ))
        ]
      }
    ),
    /* @__PURE__ */ p.jsxs(
      Ji,
      {
        anchorEl: G,
        open: !!G,
        onClose: Se,
        PaperProps: { sx: { maxHeight: 360, minWidth: 220 } },
        children: [
          /* @__PURE__ */ p.jsx(
            Me,
            {
              sx: { px: 1.5, py: 1 },
              onClick: (be) => be.stopPropagation(),
              onKeyDown: (be) => be.stopPropagation(),
              onKeyUp: (be) => be.stopPropagation(),
              children: /* @__PURE__ */ p.jsx(
                vi,
                {
                  size: "small",
                  placeholder: "Search year...",
                  value: X,
                  onChange: (be) => U(be.target.value),
                  fullWidth: !0,
                  autoFocus: !0,
                  InputProps: {
                    startAdornment: /* @__PURE__ */ p.jsx(vr, { position: "start", children: /* @__PURE__ */ p.jsx(it, { icon: "search" }) })
                  }
                }
              )
            }
          ),
          ve.map((be) => /* @__PURE__ */ p.jsxs(
            Rn,
            {
              onClick: () => {
                g(
                  h.includes(be) ? h.filter((we) => we !== be) : [...h, be]
                );
              },
              children: [
                /* @__PURE__ */ p.jsx(Hi, { checked: h.includes(be), size: "small" }),
                /* @__PURE__ */ p.jsx(Mn, { primary: be })
              ]
            },
            be
          ))
        ]
      }
    ),
    /* @__PURE__ */ p.jsxs(
      Ji,
      {
        anchorEl: q,
        onClose: De,
        open: !!q,
        PaperProps: { sx: { maxHeight: 360, minWidth: 280 } },
        children: [
          /* @__PURE__ */ p.jsx(
            Me,
            {
              sx: { px: 1.5, py: 1 },
              onClick: (be) => be.stopPropagation(),
              onKeyDown: (be) => be.stopPropagation(),
              onKeyUp: (be) => be.stopPropagation(),
              children: /* @__PURE__ */ p.jsx(
                vi,
                {
                  size: "small",
                  placeholder: "Type to search accounts...",
                  value: Q,
                  onChange: (be) => {
                    const we = be.target.value;
                    re(we), B == null || B(we);
                  },
                  fullWidth: !0,
                  autoFocus: !0,
                  InputProps: {
                    startAdornment: /* @__PURE__ */ p.jsx(vr, { position: "start", children: /* @__PURE__ */ p.jsx(it, { icon: "search" }) })
                  }
                }
              )
            }
          ),
          (B ? Q.trim() ? _ : k : T) ? /* @__PURE__ */ p.jsx(Rn, { disabled: !0, children: /* @__PURE__ */ p.jsx(Mn, { primary: "Loading..." }) }) : (Q.trim() ? D : K).length === 0 ? /* @__PURE__ */ p.jsx(Rn, { disabled: !0, children: /* @__PURE__ */ p.jsx(Mn, { primary: (B && Q.trim(), "No accounts found") }) }) : (Q.trim() ? D : K).map((be) => /* @__PURE__ */ p.jsx(
            Rn,
            {
              selected: (t == null ? void 0 : t.id) === be.id,
              onClick: () => {
                i(be), De();
              },
              children: /* @__PURE__ */ p.jsx(Mn, { primary: be.name })
            },
            be.id
          ))
        ]
      }
    ),
    /* @__PURE__ */ p.jsxs(
      Ji,
      {
        anchorEl: oe,
        onClose: Be,
        open: !!oe,
        PaperProps: { sx: { maxHeight: 360, minWidth: 280 } },
        children: [
          /* @__PURE__ */ p.jsx(
            Me,
            {
              sx: { px: 1.5, py: 1 },
              onClick: (be) => be.stopPropagation(),
              onKeyDown: (be) => be.stopPropagation(),
              onKeyUp: (be) => be.stopPropagation(),
              children: /* @__PURE__ */ p.jsx(
                vi,
                {
                  size: "small",
                  placeholder: "Type to search contacts...",
                  value: le,
                  onChange: (be) => {
                    const we = be.target.value;
                    ce(we), R == null || R(we);
                  },
                  fullWidth: !0,
                  autoFocus: !0,
                  InputProps: {
                    startAdornment: /* @__PURE__ */ p.jsx(vr, { position: "start", children: /* @__PURE__ */ p.jsx(it, { icon: "search" }) })
                  }
                }
              )
            }
          ),
          (R ? le.trim() ? A : k || z : T) ? /* @__PURE__ */ p.jsx(Rn, { disabled: !0, children: /* @__PURE__ */ p.jsx(Mn, { primary: "Loading..." }) }) : (le.trim() ? $ : H).length === 0 ? /* @__PURE__ */ p.jsx(Rn, { disabled: !0, children: /* @__PURE__ */ p.jsx(Mn, { primary: (R && le.trim(), "No contacts found") }) }) : (le.trim() ? $ : H).map((be) => {
            const we = m.some((Le) => Le.id === be.id);
            return /* @__PURE__ */ p.jsxs(
              Rn,
              {
                onClick: () => {
                  v(
                    we ? m.filter((Le) => Le.id !== be.id) : [...m, be]
                  );
                },
                children: [
                  /* @__PURE__ */ p.jsx(Hi, { checked: we, size: "small" }),
                  /* @__PURE__ */ p.jsx(Mn, { primary: be.name })
                ]
              },
              be.id
            );
          })
        ]
      }
    )
  ] });
}, Tm = (e) => e ? { id: String(e.id), name: e.name } : void 0, Om = 3, CN = 300;
function AN({
  enabled: e,
  messageAttachments: n = !1
}) {
  var pe, de;
  const r = Jt(), { data: a } = xr(), [o, l] = Ee(""), [d, c] = Ee("active"), [f, s] = Ee(""), [h, g] = Ee([]), [t, i] = Ee([]), [m, v] = Ee([]), [E, S] = Ee([]), [y, x] = Ee(null), [b, u] = Ee([]), [I, O] = Ee("created_at"), [D, $] = Ee("desc"), [K, H] = Ee([]), [B, R] = Ee([]), [_, A] = Ee([]), [k, z] = Ee([]), [T, w] = Ee([]), [F, j] = Ee(!1), [P, V] = Ee(!1), [J, ne] = Ee(!1), [Z, te] = Ee(!1), G = ut();
  ot(() => {
    if (e) {
      if (ne(!0), n) {
        const ge = new AbortController();
        return Promise.all([
          y1({ keyword: "" }, ge.signal),
          M8(ge.signal)
        ]).then(([me, xe]) => {
          ge.signal.aborted || (R(
            me.data.map((ye) => ({
              id: String(ye.id),
              name: `${ye.first_name} ${ye.last_name}`.trim()
            }))
          ), H(
            (xe.data || []).map((ye) => ({
              id: String(ye.id),
              name: ye.name || ""
            }))
          ));
        }).catch(() => {
          ge.signal.aborted || (R([]), H([]));
        }).finally(() => {
          ge.signal.aborted || ne(!1);
        }), () => ge.abort();
      }
      Promise.allSettled([
        r.contacts.getEmployeesAndContacts(),
        r.accounts.getAccountsAsTaskData()
      ]).then(([ge, me]) => {
        if (ge.status === "fulfilled") {
          const xe = ge.value;
          Array.isArray(xe) && R(
            xe.map((ye) => ({
              id: String(ye.value ?? ye.id),
              name: ye.label || ""
            })).filter((ye) => ye.id && ye.name)
          );
        }
        if (me.status === "fulfilled") {
          const xe = me.value;
          Array.isArray(xe) && H(
            xe.map((ye) => ({
              id: String(ye.value),
              name: ye.label || ""
            })).filter((ye) => ye.id && ye.name)
          );
        }
      }).finally(() => ne(!1));
    }
  }, [e, r, n]), ot(() => {
    var me;
    if (!e || !(y != null && y.id)) {
      A([]), w([]);
      return;
    }
    (me = G.current) == null || me.abort(), G.current = void 0, w([]), V(!1), u([]), te(!0);
    let ge = !0;
    if (n) {
      const xe = new AbortController();
      return D8({
        account_ids: [Number(y.id)]
      }, xe.signal).then((ye) => {
        ge && (A(
          ye.data.filter((ve) => ve.type === "contact").map((ve) => ({
            id: String(ve.id),
            name: `${ve.first_name} ${ve.last_name}`.trim()
          }))
        ), w([]));
      }).catch(() => {
        ge && (A([]), w([]));
      }).finally(() => {
        ge && te(!1);
      }), () => {
        ge = !1, xe.abort();
      };
    }
    return r.contacts.getAccountContacts(y.id).then((xe) => {
      if (!ge) return;
      const ye = (Array.isArray(xe) ? xe : []).map((ve) => ({
        id: String(ve.id),
        name: ve.label || ""
      })).filter((ve) => ve.id && ve.name);
      A(ye), w([]);
    }).catch(() => {
      ge && (A([]), w([]));
    }).finally(() => {
      ge && te(!1);
    }), () => {
      ge = !1;
    };
  }, [e, y == null ? void 0 : y.id, r, n]);
  const N = ut(
    wd((ge, me) => {
      if (!ge.trim()) {
        z([]), j(!1);
        return;
      }
      j(!0), me.accounts.searchTaskAccounts({ keyword: ge.trim(), message: !0 }).then((xe) => {
        const ye = (Array.isArray(xe) ? xe : []).map((ve) => ({
          id: String(ve.value),
          name: ve.label || ""
        })).filter((ve) => ve.id && ve.name);
        z(ye);
      }).catch(() => z([])).finally(() => j(!1));
    }, 300)
  ).current, q = ut(
    wd((ge, me) => {
      if (!ge.trim()) {
        w([]), V(!1);
        return;
      }
      V(!0), me.contacts.searchTaskContacts(N8.RequestInformation, ge.trim(), !0).then((xe) => {
        const ye = (Array.isArray(xe) ? xe : []).map((ve) => ({
          id: String(ve.id),
          name: ve.label || ""
        })).filter((ve) => ve.id && ve.name);
        w(ye);
      }).catch(() => w([])).finally(() => V(!1));
    }, 300)
  ).current;
  ot(
    () => () => {
      var ge;
      N.cancel(), q.cancel(), (ge = G.current) == null || ge.abort();
    },
    [N, q]
  );
  const ie = Oe(
    (ge) => {
      if (n) {
        const me = ge.trim().toLowerCase();
        z(
          K.filter(
            (xe) => xe.name.toLowerCase().includes(me)
          )
        );
        return;
      }
      N(ge, r);
    },
    // debouncedAccountSearch is a ref (.current), stable across renders
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, K, n]
  ), oe = Oe(
    (ge) => {
      var me;
      if ((me = G.current) == null || me.abort(), G.current = void 0, y) {
        if (!ge.trim()) {
          w([]), V(!1);
          return;
        }
        V(!0);
        const xe = ge.trim().toLowerCase(), ye = _.filter(
          (ve) => ve.name.toLowerCase().includes(xe)
        );
        w(ye), V(!1);
      } else {
        if (n) {
          const xe = new AbortController();
          G.current = xe, V(!0), y1(
            { keyword: ge.trim() },
            xe.signal
          ).then((ye) => {
            xe.signal.aborted || w(
              ye.data.map((ve) => ({
                id: String(ve.id),
                name: `${ve.first_name} ${ve.last_name}`.trim()
              }))
            );
          }).catch(() => {
            xe.signal.aborted || w([]);
          }).finally(() => {
            G.current === xe && (G.current = void 0, V(!1));
          });
          return;
        }
        q(ge, r);
      }
    },
    // debouncedContactSearch is a ref (.current), stable across renders
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, y, _, n]
  ), fe = Tt(
    () => ({
      sortBy: I,
      sortOrder: D,
      tags: h,
      showArchived: d === "archived",
      searchString: o,
      year: t.length > 0 ? t : void 0,
      month: m.length > 0 ? m : void 0,
      fileUploadedBy: f || void 0,
      accountId: (y == null ? void 0 : y.id) ?? void 0,
      contactIds: b.length > 0 ? b.map((ge) => ge.id) : void 0,
      source: E.length > 0 ? E.map((ge) => ge.value).join(",") : void 0
    }),
    [
      I,
      D,
      h,
      d,
      o,
      t,
      m,
      f,
      y == null ? void 0 : y.id,
      b,
      E
    ]
  ), Y = zx(fe, {
    enabled: e && !n
  }), [ae, se] = Ee(""), L = o.trim().length >= Om ? o : "";
  ot(() => {
    const ge = setTimeout(
      () => se(L),
      CN
    );
    return () => clearTimeout(ge);
  }, [L]);
  const W = g0({
    queryKey: [
      "message-attachment-candidates",
      ae,
      d,
      f,
      h,
      t,
      m,
      E,
      I,
      D,
      y == null ? void 0 : y.id,
      b
    ],
    queryFn: ({ pageParam: ge = 1, signal: me }) => L8({
      page: ge,
      per_page: 15,
      query: ae || void 0,
      account_id: y ? Number(y.id) : void 0,
      contact_ids: b.length > 0 ? b.map((xe) => Number(xe.id)) : void 0,
      uploader_type: f || void 0,
      source: E.length > 0 ? E.map((xe) => xe.value).join(",") : void 0,
      tags: h.length > 0 ? h.join("|") : void 0,
      year: t.length > 0 ? t : void 0,
      month: m.length > 0 ? m : void 0,
      archived: d === "archived",
      sort_field: I === "doc_name" ? "display_name" : I,
      sort_order: D
    }, me),
    enabled: e && n,
    keepPreviousData: !0,
    getNextPageParam: (ge) => ge.meta.page < ge.meta.total_pages ? ge.meta.page + 1 : void 0
  }), M = n && (L !== ae || W.isFetching && !W.isFetchingNextPage), X = Tt(() => {
    var me, xe;
    return n ? (((me = W.data) == null ? void 0 : me.pages) || []).flatMap(
      (ye) => ye.data.map((ve) => {
        var Ie;
        const Ce = ve;
        return {
          id: Ce.document_id,
          uuid: Ce.uuid,
          doc_name: Ce.name,
          content_type: Ce.content_type || void 0,
          file_size: Ce.file_size ?? void 0,
          firm_only: Ce.firm_only,
          is_private_to_firm: Ce.firm_only,
          date_created: Ce.created_at,
          tags: Ce.tags,
          upload_file_year: Ce.upload_file_year,
          upload_file_month: Ce.upload_file_month,
          uploaded_by: ((Ie = Ce.uploaded_by) == null ? void 0 : Ie.name) || void 0,
          account: Tm(Ce.account),
          contact: Tm(Ce.contact)
        };
      })
    ) : (((xe = Y.data) == null ? void 0 : xe.pages) || []).flatMap((ye) => {
      if (!ye || typeof ye > "u") return [];
      const ve = ye == null ? void 0 : ye.documents;
      return Array.isArray(ve) ? ve : [];
    }).filter(Boolean);
  }, [n, (pe = W.data) == null ? void 0 : pe.pages, (de = Y.data) == null ? void 0 : de.pages]), U = Oe((ge) => {
    $(I === ge && D === "asc" ? "desc" : "asc"), O(ge);
  }, [I, D]), Q = Oe(() => {
    l(""), g([]), i([]), v([]), S([]), s(""), x(null), u([]);
  }, []), re = Tt(() => {
    var me, xe;
    return (((xe = (me = a == null ? void 0 : a.data) == null ? void 0 : me.pref_type_options) == null ? void 0 : xe.upload_tags) || []).map((ye) => String(ye.label));
  }, [a]), le = Tt(() => {
    var me, xe;
    return (((xe = (me = a == null ? void 0 : a.data) == null ? void 0 : me.pref_type_options) == null ? void 0 : xe.upload_file_year) || []).map((ye) => String(ye.label)).sort((ye, ve) => Number(ve) - Number(ye));
  }, [a]), ce = Tt(() => {
    var me, xe;
    return (((xe = (me = a == null ? void 0 : a.data) == null ? void 0 : me.pref_type_options) == null ? void 0 : xe.upload_file_month) || []).map((ye) => String(ye.label));
  }, [a]), ee = y ? _ : B;
  return {
    filterProps: Tt(
      () => ({
        searchQuery: o,
        onSearchQueryChange: l,
        searchMinLength: n ? Om : void 0,
        isSearching: M,
        selectedSources: E,
        onSelectedSourcesChange: S,
        selectedTags: h,
        onSelectedTagsChange: g,
        selectedMonths: m,
        onSelectedMonthsChange: v,
        selectedYears: t,
        onSelectedYearsChange: i,
        selectedAccount: y,
        onSelectedAccountChange: x,
        selectedContacts: b,
        onSelectedContactsChange: u,
        fileUploadedBy: f,
        onFileUploadedByChange: s,
        filterStatus: d,
        onFilterStatusChange: c,
        onClearFilters: Q,
        availableTags: re,
        availableYears: le,
        availableMonths: ce,
        accounts: k,
        contacts: T,
        initialAccounts: K,
        initialContacts: ee,
        onAccountSearchRequested: ie,
        onContactSearchRequested: oe,
        isLoadingAccountSearch: F,
        isLoadingContactSearch: P,
        isLoadingInitialFilters: J,
        isLoadingAccountContacts: Z
      }),
      [
        o,
        n,
        M,
        E,
        h,
        m,
        t,
        y,
        b,
        f,
        d,
        Q,
        re,
        le,
        ce,
        k,
        T,
        K,
        ee,
        ie,
        oe,
        F,
        P,
        J,
        Z
      ]
    ),
    documents: X,
    hasNextPage: n ? W.hasNextPage ?? !1 : Y.hasNextPage ?? !1,
    fetchNextPage: n ? W.fetchNextPage : Y.fetchNextPage ?? (() => {
    }),
    isLoading: n ? W.isLoading : Y.isLoading ?? !1,
    isError: n ? W.isError : Y.isError ?? !1,
    refetch: () => {
      var ge, me;
      (me = (ge = n ? W : Y).refetch) == null || me.call(ge);
    },
    isFetchingNextPage: n ? W.isFetchingNextPage : Y.isFetchingNextPage ?? !1,
    sortField: I,
    sortOrder: D,
    handleSort: U
  };
}
const Fm = (e) => ({
  id: e.id,
  uuid: e.uuid,
  doc_name: e.doc_name,
  content_type: e.content_type,
  file_size: e.file_size,
  is_private_to_firm: e.is_private_to_firm ?? e.firm_only
}), Pm = ({
  open: e,
  onClose: n,
  onAttach: r,
  title: a = "LISCIO VAULT",
  variant: o = "firm",
  messageAttachments: l = !1,
  renderPreview: d
}) => {
  var re;
  const [c, f] = Ee([]), [s, h] = Ee(
    null
  ), [g, t] = Ee(""), [i, m] = Ee(
    "active"
  ), [v, E] = Ee(""), [S, y] = Ee([]), [x, b] = Ee([]), [u, I] = Ee([]), [, O] = Ee([]), [D, $] = Ee(null), [K, H] = Ee(null), [B, R] = Ee("created_at"), [_, A] = Ee("desc"), { data: k } = xr(), z = AN({
    enabled: e && o === "firm",
    messageAttachments: l
  }), { data: T, isLoading: w } = ib(), F = (re = k == null ? void 0 : k.data) != null && re.contact_id ? String(k.data.contact_id) : void 0, j = o === "client" ? F : (K == null ? void 0 : K.id) || F, P = Tt(() => {
    if (o !== "client") return [];
    const le = T, ce = le == null ? void 0 : le.data;
    return Array.isArray(ce) ? ce.map((ee) => ({
      id: String(ee.value),
      name: ee.label || ""
    })).filter((ee) => ee.id && ee.name) : [];
  }, [o, T]), V = w, J = b6(
    j || "",
    {
      sortBy: B,
      sortOrder: _,
      tags: S,
      showArchived: i === "archived",
      searchString: g,
      year: x.length > 0 ? x : void 0,
      month: u.length > 0 ? u : void 0,
      fileUploadedBy: v || void 0,
      accountId: D == null ? void 0 : D.id
    },
    {
      enabled: e && o === "client" && !!j
    }
  ), ne = J.data, Z = Tt(() => ((ne == null ? void 0 : ne.pages) || []).flatMap((ce) => !ce || typeof ce > "u" ? [] : (ce == null ? void 0 : ce.documents) || []).filter(Boolean), [ne]), te = o === "firm" ? z.documents : Z, G = o === "firm" ? z.fetchNextPage : J.fetchNextPage, N = o === "firm" ? z.isFetchingNextPage : J.isFetchingNextPage, q = o === "firm" ? z.hasNextPage : J.hasNextPage, ie = o === "firm" ? z.sortField : B, oe = o === "firm" ? z.sortOrder : _, Y = o === "firm" ? z.handleSort : (le) => {
    A(B === le && _ === "asc" ? "desc" : "asc"), R(le);
  }, ae = Oe((le) => {
    f(
      (ce) => ce.includes(le) ? ce.filter((ee) => ee !== le) : [...ce, le]
    );
  }, []), se = Oe(() => {
    c.length === te.length ? f([]) : f(te.map((le) => le.id));
  }, [c.length, te]), L = Oe(() => {
    const le = te.filter((ce) => c.includes(ce.id)).map(Fm);
    r(le), f([]), h(null), n();
  }, [te, c, r, n]), W = Oe(() => {
    f([]), t(""), y([]), b([]), I([]), O([]), E(""), $(null), H(null), h(null), n();
  }, [n]), M = Oe(() => {
    t(""), y([]), b([]), I([]), O([]), E(""), $(null), H(null);
  }, []), X = Tt(() => {
    var ce, ee;
    return (((ee = (ce = k == null ? void 0 : k.data) == null ? void 0 : ce.pref_type_options) == null ? void 0 : ee.upload_tags) || []).map((he) => String(he.label));
  }, [k]), U = Tt(() => {
    var ce, ee;
    return (((ee = (ce = k == null ? void 0 : k.data) == null ? void 0 : ce.pref_type_options) == null ? void 0 : ee.upload_file_year) || []).map((he) => String(he.label)).sort((he, pe) => Number(pe) - Number(he));
  }, [k]), Q = Tt(() => {
    var ce, ee;
    return (((ee = (ce = k == null ? void 0 : k.data) == null ? void 0 : ce.pref_type_options) == null ? void 0 : ee.upload_file_month) || []).map((he) => String(he.label));
  }, [k]);
  return s && d ? /* @__PURE__ */ p.jsx(
    oi,
    {
      open: e,
      onClose: W,
      title: s.doc_name,
      layout: "documentPreview",
      options: /* @__PURE__ */ p.jsx(lt, { variant: "text", onClick: () => h(null), children: "Back to Liscio Vault" }),
      children: d(Fm(s))
    }
  ) : /* @__PURE__ */ p.jsxs(
    oi,
    {
      open: e,
      onClose: W,
      title: a,
      maxWidth: "lg",
      fullWidth: !0,
      contentProps: {
        sx: {
          display: "flex",
          flexDirection: "column",
          height: "85vh",
          minHeight: 500,
          maxHeight: "90vh",
          overflow: "hidden",
          p: 0
        }
      },
      children: [
        /* @__PURE__ */ p.jsxs(
          Me,
          {
            sx: {
              overflow: "auto",
              flex: "1 1 0",
              minHeight: 0,
              display: "flex",
              flexDirection: "column"
            },
            children: [
              o === "client" ? /* @__PURE__ */ p.jsx(
                vN,
                {
                  searchQuery: g,
                  onSearchQueryChange: t,
                  selectedTags: S,
                  onSelectedTagsChange: y,
                  selectedMonths: u,
                  onSelectedMonthsChange: I,
                  selectedYears: x,
                  onSelectedYearsChange: b,
                  selectedAccount: D,
                  onSelectedAccountChange: $,
                  fileUploadedBy: v,
                  onFileUploadedByChange: E,
                  filterStatus: i,
                  onFilterStatusChange: m,
                  onClearFilters: M,
                  availableTags: X,
                  availableYears: U,
                  availableMonths: Q,
                  accounts: P,
                  isLoadingFilters: V
                }
              ) : /* @__PURE__ */ p.jsx(_N, { ...z.filterProps }),
              /* @__PURE__ */ p.jsx(ex, { sx: { flex: "1 1 0", minHeight: 240, overflow: "auto" }, children: /* @__PURE__ */ p.jsxs(l5, { stickyHeader: !0, size: "small", children: [
                /* @__PURE__ */ p.jsx(u5, { children: /* @__PURE__ */ p.jsxs(b1, { children: [
                  /* @__PURE__ */ p.jsx(zi, { padding: "checkbox", children: /* @__PURE__ */ p.jsx(
                    Hi,
                    {
                      indeterminate: c.length > 0 && c.length < te.length,
                      checked: te.length > 0 && c.length === te.length,
                      onChange: se
                    }
                  ) }),
                  /* @__PURE__ */ p.jsx(zi, { children: /* @__PURE__ */ p.jsx(
                    Dc,
                    {
                      active: ie === "doc_name",
                      direction: ie === "doc_name" ? oe : "asc",
                      onClick: () => Y("doc_name"),
                      children: "File Name"
                    }
                  ) }),
                  /* @__PURE__ */ p.jsx(zi, { children: "Tags" }),
                  /* @__PURE__ */ p.jsx(zi, { children: /* @__PURE__ */ p.jsx(
                    Dc,
                    {
                      active: ie === "upload_file_month",
                      direction: ie === "upload_file_month" ? oe : "asc",
                      onClick: () => Y("upload_file_month"),
                      children: "Month"
                    }
                  ) }),
                  /* @__PURE__ */ p.jsx(zi, { children: /* @__PURE__ */ p.jsx(
                    Dc,
                    {
                      active: ie === "upload_file_year",
                      direction: ie === "upload_file_year" ? oe : "asc",
                      onClick: () => Y("upload_file_year"),
                      children: "Year"
                    }
                  ) }),
                  /* @__PURE__ */ p.jsx(zi, { children: /* @__PURE__ */ p.jsx(
                    Dc,
                    {
                      active: ie === "created_at",
                      direction: ie === "created_at" ? oe : "asc",
                      onClick: () => Y("created_at"),
                      children: "Date Added"
                    }
                  ) })
                ] }) }),
                /* @__PURE__ */ p.jsx(d5, { children: te.length === 0 ? /* @__PURE__ */ p.jsx(b1, { children: /* @__PURE__ */ p.jsx(zi, { colSpan: 6, align: "center", children: /* @__PURE__ */ p.jsx(Te, { sx: { p: 2 }, children: "No documents found in Liscio Vault" }) }) }) : te.map((le) => {
                  var ce;
                  return /* @__PURE__ */ p.jsxs(
                    H5,
                    {
                      selected: c.includes(le.id),
                      onClick: () => ae(le.id),
                      sx: { cursor: "pointer" },
                      children: [
                        /* @__PURE__ */ p.jsx(zi, { padding: "checkbox", children: /* @__PURE__ */ p.jsx(Hi, { checked: c.includes(le.id) }) }),
                        /* @__PURE__ */ p.jsx(zi, { children: /* @__PURE__ */ p.jsxs(Pe, { spacing: 0.25, children: [
                          /* @__PURE__ */ p.jsxs(W5, { spacing: 1, align: "center", children: [
                            /* @__PURE__ */ p.jsx(Te, { variant: "body2", component: "span", children: le.doc_name }),
                            le.firm_only && /* @__PURE__ */ p.jsx(
                              fr,
                              {
                                size: "small",
                                label: "Firm Only",
                                "aria-label": `${le.doc_name} is firm only`
                              }
                            ),
                            d && le.uuid && z.filterProps.filterStatus === "active" && /* @__PURE__ */ p.jsx(
                              lt,
                              {
                                size: "small",
                                variant: "text",
                                onClick: (ee) => {
                                  ee.stopPropagation(), h(le);
                                },
                                children: "Preview"
                              }
                            )
                          ] }),
                          le.uploaded_by && /* @__PURE__ */ p.jsxs(
                            Te,
                            {
                              variant: "caption",
                              color: "text.secondary",
                              component: "span",
                              children: [
                                "by ",
                                le.uploaded_by
                              ]
                            }
                          )
                        ] }) }),
                        /* @__PURE__ */ p.jsx(zi, { children: /* @__PURE__ */ p.jsxs(
                          Pe,
                          {
                            direction: "row",
                            spacing: 0.5,
                            flexWrap: "wrap",
                            useFlexGap: !0,
                            children: [
                              (ce = le.tags) == null ? void 0 : ce.slice(0, 2).map((ee) => /* @__PURE__ */ p.jsx(fr, { label: gs(ee), size: "small" }, ee)),
                              le.tags && le.tags.length > 2 && /* @__PURE__ */ p.jsx(
                                fr,
                                {
                                  label: `+${le.tags.length - 2}`,
                                  size: "small",
                                  variant: "outlined"
                                }
                              )
                            ]
                          }
                        ) }),
                        /* @__PURE__ */ p.jsx(zi, { children: le.upload_file_month || "-" }),
                        /* @__PURE__ */ p.jsx(zi, { children: le.upload_file_year || "-" }),
                        /* @__PURE__ */ p.jsx(zi, { children: le.date_created ? new Date(le.date_created).toLocaleDateString() : le.created ? new Date(le.created * 1e3).toLocaleDateString() : "-" })
                      ]
                    },
                    le.id
                  );
                }) })
              ] }) }),
              te.length > 0 && q && /* @__PURE__ */ p.jsx(
                Me,
                {
                  sx: {
                    p: 2,
                    textAlign: "center",
                    borderTop: 1,
                    borderColor: "divider"
                  },
                  children: /* @__PURE__ */ p.jsx(
                    lt,
                    {
                      variant: "text",
                      disabled: N,
                      onClick: () => G(),
                      children: N ? "Loading..." : "Load more"
                    }
                  )
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ p.jsxs(
          Me,
          {
            sx: {
              flexShrink: 0,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 2,
              p: 2,
              borderTop: 1,
              borderColor: "divider"
            },
            children: [
              /* @__PURE__ */ p.jsxs(Te, { variant: "body2", color: "text.secondary", children: [
                c.length,
                " file(s) selected"
              ] }),
              /* @__PURE__ */ p.jsxs(Me, { sx: { display: "flex", gap: 2 }, children: [
                /* @__PURE__ */ p.jsx(lt, { variant: "outlined", onClick: W, children: "Cancel" }),
                /* @__PURE__ */ p.jsxs(
                  lt,
                  {
                    variant: "contained",
                    onClick: L,
                    disabled: c.length === 0,
                    children: [
                      "Attach Files (",
                      c.length,
                      ")"
                    ]
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
}, kN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LiscioVaultModal: Pm,
  default: Pm
}, Symbol.toStringTag, { value: "Module" })), EN = "TO-DO", IN = "DONE", OU = ({
  isComplete: e,
  isActive: n
}) => {
  const r = Mr(), a = e ? IN : EN, o = e ? r.palette.success.main : n ? r.palette.primary.main : r.palette.divider;
  return /* @__PURE__ */ p.jsx(
    Me,
    {
      sx: {
        borderRadius: "5px",
        border: `1px solid ${o}`,
        padding: "2px 8px",
        color: o,
        textTransform: "uppercase"
      },
      role: "status",
      children: /* @__PURE__ */ p.jsx(Te, { variant: "subtitle2", fontWeight: "bold", children: a })
    }
  );
}, TN = (e) => {
  if (!e) return [];
  const n = /* @__PURE__ */ new Set(), r = [];
  return Object.entries(e).forEach(([a, o]) => {
    var d, c;
    if (a.includes(":")) return;
    let l = o == null ? void 0 : o.trim();
    a === "month" && l && /^\d+$/.test(l) && (l = ((d = e["month:Month"]) == null ? void 0 : d.trim()) || ((c = e["month:Mon"]) == null ? void 0 : c.trim())), !(!l || n.has(l)) && (n.add(l), r.push(l));
  }), r;
}, ma = 500, ON = 12, FN = () => typeof window < "u" && typeof window.matchMedia == "function" && window.matchMedia("(prefers-reduced-motion: reduce)").matches, PN = (e) => typeof e == "function" ? e() : document.querySelector(e), jN = () => {
  const [e, n] = Ee(null), r = ut(!0), a = ut(/* @__PURE__ */ new Set()), o = ut(/* @__PURE__ */ new Set()), l = ut(/* @__PURE__ */ new Set()), d = Oe((g) => {
    const t = requestAnimationFrame(() => {
      a.current.delete(t), r.current && g();
    });
    a.current.add(t);
  }, []), c = Oe((g, t) => {
    const i = window.setTimeout(() => {
      o.current.delete(i), r.current && g();
    }, t);
    o.current.add(i);
  }, []), f = Oe(
    (g, t = ON) => new Promise((i) => {
      const m = (v) => {
        if (!r.current) {
          i(null);
          return;
        }
        const E = PN(g);
        if (E || v <= 0) {
          i(E);
          return;
        }
        d(() => m(v - 1));
      };
      m(t);
    }),
    [d]
  ), s = Oe(
    (g) => {
      if (!g.isConnected) return;
      const t = !g.hasAttribute("tabindex");
      t && (g.tabIndex = -1), g.dataset.guidedHighlight = "true", g.focus({ preventScroll: !1 });
      const i = () => {
        delete g.dataset.guidedHighlight, t && g.removeAttribute("tabindex"), l.current.delete(i);
      };
      l.current.add(i), c(i, 1600);
    },
    [c]
  );
  ot(() => {
    r.current = !0;
    const g = a.current, t = o.current, i = l.current;
    return () => {
      r.current = !1, g.forEach(cancelAnimationFrame), t.forEach(window.clearTimeout), Array.from(i).forEach((m) => m()), g.clear(), t.clear();
    };
  }, []);
  const h = Oe(
    async (g, t, i, m) => {
      const v = await f(t);
      if (!r.current) return;
      if (!v) {
        m();
        return;
      }
      if (FN()) {
        s(v), m();
        return;
      }
      const E = v.getBoundingClientRect(), S = `top ${ma}ms ease-in-out, left ${ma}ms ease-in-out, width ${ma}ms ease-in-out, height ${ma}ms ease-in-out, opacity ${ma}ms ease-in-out`;
      n({
        label: i,
        top: g.top,
        left: g.left,
        width: g.width,
        height: g.height,
        opacity: 1,
        transition: "none"
      }), d(
        () => d(
          () => n({
            label: i,
            top: E.top,
            left: E.left,
            width: E.width,
            height: E.height,
            opacity: 0,
            transition: S
          })
        )
      ), c(() => {
        n(null), s(v), m();
      }, ma + 60);
    },
    [s, d, c, f]
  );
  return { ghost: e, flyToTarget: h };
}, FU = ({
  fileUuid: e,
  originalName: n,
  suggestedName: r,
  target: a,
  onDismiss: o,
  onComplete: l,
  onShown: d,
  collapseOnDismiss: c = !0,
  completeLabel: f
}) => {
  const s = ut(null), h = ut(!1), [g, t] = Ee(!0), [i, m] = Ee(!0), { ghost: v, flyToTarget: E } = jN(), { data: S } = B8(e, {
    query: { enabled: !!e }
  });
  ot(() => {
    h.current || (h.current = !0, d == null || d());
  }, [d]);
  const y = Oe(
    (u) => {
      const I = s.current;
      if (m(!1), t(!1), !I) {
        u();
        return;
      }
      E(
        I.getBoundingClientRect(),
        a,
        r,
        u
      );
    },
    [E, r, a]
  ), x = Oe(() => {
    c ? y(o) : (t(!1), o());
  }, [y, c, o]), b = Oe(
    () => y(l),
    [y, l]
  );
  return bx(
    /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
      /* @__PURE__ */ p.jsx(
        q5,
        {
          ref: s,
          open: g,
          originalName: n,
          suggestedName: r,
          foundInDocumentLabels: TN(
            (S == null ? void 0 : S.preview_values) ?? null
          ),
          onDismiss: x,
          onComplete: b,
          showBackdrop: i,
          completeLabel: f
        }
      ),
      v && /* @__PURE__ */ p.jsx(V5, { ...v })
    ] }),
    document.body
  );
}, PU = async ({
  saveTemplate: e,
  getCurrentSuggestion: n,
  renameCurrentFile: r
}) => {
  await e();
  const a = await n();
  try {
    return await r(a), { status: "updated", name: a.name };
  } catch (o) {
    return { status: "rename_failed", name: a.name, error: o };
  }
};
let jm = 0;
const RN = (e, n) => (jm += 1, { id: `tok-${jm}-${e}`, variable: e, hint: n }), bd = (e) => {
  var d;
  const n = Array.from(e.matchAll(/\{([^}]+)\}/g)), r = [], a = [];
  let o = 0;
  const l = (d = n[0]) != null && d.index ? e.slice(0, n[0].index) : "";
  return n.forEach((c, f) => {
    r.length > 0 && a.push(e.slice(o, c.index));
    const s = c[1].indexOf(":"), h = s === -1 ? c[1] : c[1].slice(0, s), g = s === -1 ? void 0 : c[1].slice(s + 1);
    r.push({ id: `parsed-${f}-${h}`, variable: h, hint: g }), o = (c.index ?? 0) + c[0].length;
  }), { tokens: r, separators: a, prefix: l, suffix: e.slice(o) };
}, Fy = (e) => `${e.variable}${e.hint ? `:${e.hint}` : ""}`, f1 = (e, n, r, a, o) => a + e.map(
  (l, d) => d < e.length - 1 ? `${r(l)}${n[d] ?? " "}` : r(l)
).join("") + o, Rm = (e, n, r = "", a = "") => f1(
  e,
  n,
  (o) => `{${Fy(o)}}`,
  r,
  a
), jU = (e, n, r, a = "", o = "") => f1(
  e,
  n,
  (l) => {
    const d = Fy(l), c = (r == null ? void 0 : r[d]) ?? (r == null ? void 0 : r[l.variable]);
    return c == null ? `{${d}}` : c.replace(/[",:;<>|?*]/g, "");
  },
  a,
  o
), MN = 90, DN = /[",:;<>|?*]/g, NN = /([ \t\n\v\f\r._-])[ \t\n\v\f\r._-]+/g, LN = /^[\0 \t\n\v\f\r]+|[\0 \t\n\v\f\r]+$/g, Mm = /^[ \t\n\v\f\r._-]+|[ \t\n\v\f\r._-]+$/g, BN = /\{(\w+)(?::([^}]+))?\}/g, $N = (e) => `{${e.variable}${e.hint === void 0 ? "" : `:${e.hint}`}}`, UN = (e, n, r) => (r ? e == null ? void 0 : e[`${n}:${r}`] : "") || (e == null ? void 0 : e[n]) || "", Dm = (e) => e.replace(NN, "$1"), zN = (e) => {
  let n = Dm(e);
  return n = Dm(
    n.replace(DN, "").replace(LN, "")
  ), n = n.replace(Mm, ""), n = Array.from(n).slice(0, MN).join(""), n.replace(Mm, "");
}, Nm = (e, n, r, a = "", o = "") => zN(
  f1(e, n, $N, a, o).replace(
    BN,
    (l, d, c) => UN(r, d, c)
  )
), Lm = "__all__", HN = "Generated image 1.pdf", Bm = (e) => {
  const n = e.lastIndexOf(".");
  return n > 0 ? e.slice(n) : "";
}, RU = ({
  open: e,
  onClose: n,
  originalName: r,
  suggestedName: a,
  documentUuid: o,
  previewValues: l,
  source: d = "file_intelligence",
  onTemplateSaved: c,
  trackEvent: f
}) => {
  var ce;
  const s = r ?? HN, h = qn(), { data: g, isLoading: t } = $8({
    query: { enabled: e }
  }), { data: i, isLoading: m } = U8({ query: { enabled: e } }), v = z8(), E = (ce = i == null ? void 0 : i.templates.find(
    (ee) => ee.document_type === Lm
  )) == null ? void 0 : ce.template_string, [S, y] = Ee(""), [x, b] = Ee([]), [u, I] = Ee([]), [O, D] = Ee({ prefix: "", suffix: "" }), [$, K] = Ee(null), [H, B] = Ee(!1), [R, _] = Ee(null), [A, k] = Ee(!1), [z, T] = Ee(0), [w, F] = Ee(!1), j = ut(!1), P = Oe((ee) => {
    const he = bd(ee);
    y(ee), b(he.tokens), I(he.separators), D({ prefix: he.prefix, suffix: he.suffix }), K(null);
  }, []), V = Oe(
    () => P(S),
    [S, P]
  ), J = Rm(
    x,
    u,
    O.prefix,
    O.suffix
  ).trim(), ne = Tt(() => {
    const ee = bd(S);
    return Rm(
      ee.tokens,
      ee.separators,
      ee.prefix,
      ee.suffix
    ).trim();
  }, [S]), Z = J !== ne;
  ot(() => {
    if (!e) {
      j.current = !1;
      return;
    }
    t || m || j.current || (j.current = !0, B(!1), P(E ?? ""));
  }, [t, E, P, e, m]), ot(() => {
    _(null);
  }, [o]), ot(() => {
    if (!e || !o) {
      _(null), k(!1);
      return;
    }
    let ee = !0;
    return k(!0), H8(o).then((he) => {
      ee && _((pe) => ({
        suggestion: he.suggestion,
        previewValues: he.preview_values ?? (pe == null ? void 0 : pe.previewValues)
      }));
    }).catch(() => {
      ee && _(
        (he) => he ? { previewValues: he.previewValues } : null
      );
    }).finally(() => {
      ee && k(!1);
    }), () => {
      ee = !1;
    };
  }, [o, e, z]);
  const te = Tt(() => {
    var he, pe;
    const ee = {
      ...((he = g == null ? void 0 : g.variables) == null ? void 0 : he.insight) ?? {},
      ...((pe = g == null ? void 0 : g.variables) == null ? void 0 : pe.db) ?? {}
    };
    return ee.extended_type && (ee.extended_type = {
      ...ee.extended_type,
      label: "Document Type"
    }), ee;
  }, [g == null ? void 0 : g.variables]), G = Tt(
    () => (g == null ? void 0 : g.format_hints) ?? {},
    [g == null ? void 0 : g.format_hints]
  ), N = Tt(
    () => x.map((ee) => {
      var he, pe, de, ge;
      return {
        id: ee.id,
        label: ee.hint ? `${((he = te[ee.variable]) == null ? void 0 : he.label) || ee.variable} (${((de = (pe = G[ee.variable]) == null ? void 0 : pe[ee.hint]) == null ? void 0 : de.description) || ee.hint})` : ((ge = te[ee.variable]) == null ? void 0 : ge.label) || ee.variable,
        formatOptions: Object.entries(G[ee.variable] ?? {}).map(
          ([me, xe]) => ({
            value: me,
            label: xe.description || me,
            example: xe.example
          })
        )
      };
    }),
    [G, x, te]
  ), q = Tt(() => {
    const ee = new Set(x.map((de) => de.variable)), he = [
      "extended_type",
      "year",
      "month",
      "issuer",
      "account_name",
      "contact_name"
    ], pe = /* @__PURE__ */ new Set([
      "doc_type",
      "subtype",
      "upload_year",
      "upload_month"
    ]);
    return Object.entries(te).filter(([de]) => !ee.has(de) && !pe.has(de)).map(([de, ge]) => ({
      value: de,
      label: ge.label || de,
      formatOptions: Object.entries(G[de] ?? {}).map(
        ([me, xe]) => ({
          value: me,
          label: xe.description || me,
          example: xe.example
        })
      )
    })).sort((de, ge) => {
      const me = he.indexOf(de.value), xe = he.indexOf(ge.value);
      return me === -1 && xe === -1 ? de.label.localeCompare(ge.label) : me === -1 ? 1 : xe === -1 ? -1 : me - xe;
    });
  }, [G, x, te]), ie = (R == null ? void 0 : R.previewValues) ?? l, oe = Tt(() => {
    const ee = /* @__PURE__ */ new Set();
    return x.flatMap((he) => {
      var ge;
      if (ee.has(he.variable)) return [];
      const pe = `${he.variable}${he.hint ? `:${he.hint}` : ""}`, de = (ie == null ? void 0 : ie[pe]) ?? (ie == null ? void 0 : ie[he.variable]);
      return de ? (ee.add(he.variable), [
        {
          label: ((ge = te[he.variable]) == null ? void 0 : ge.label) || he.variable,
          value: de
        }
      ]) : [];
    });
  }, [ie, x, te]), fe = ie != null, Y = fe ? Nm(
    x,
    u,
    ie,
    O.prefix,
    O.suffix
  ) : "", ae = (R == null ? void 0 : R.suggestion) ?? "", se = Tt(() => {
    if (!fe || !S) return "";
    const ee = bd(S);
    return Nm(
      ee.tokens,
      ee.separators,
      ie,
      ee.prefix,
      ee.suffix
    );
  }, [S, fe, ie]), L = se && ae.startsWith(se) ? ae.slice(se.length) : null, W = L !== null && /^(\.[^.]+)?$/.test(L) ? L : r !== void 0 ? Bm(r) : [ae, a, s].map((ee) => Bm(ee ?? "")).find(Boolean) ?? "", M = !fe && S && !Z && ((R == null ? void 0 : R.suggestion) || a) || "", X = Y ? `${Y}${W}` : M, U = (ee, he) => {
    x.some((pe) => pe.variable === ee && pe.hint === he) || (x.length && I((pe) => [...pe, " "]), b((pe) => [
      ...pe,
      RN(ee, he)
    ]));
  }, Q = (ee) => {
    b(
      (he) => he.filter((pe, de) => de !== ee)
    ), I((he) => ee === 0 ? he.slice(1) : he.filter(
      (pe, de) => de !== ee - 1
    ));
  }, re = (ee, he) => {
    ee === he || ee < 0 || he < 0 || ee >= x.length || b((pe) => {
      const de = [...pe], [ge] = de.splice(ee, 1);
      return de.splice(he, 0, ge), de;
    });
  }, le = async () => {
    const ee = J;
    if (!ee || w) return;
    K(null), F(!0);
    let he;
    try {
      const pe = await v.mutateAsync({
        id: Lm,
        data: o ? { template_string: ee, document_uuid: o } : { template_string: ee }
      });
      he = (pe == null ? void 0 : pe.template_string) || ee, await h.invalidateQueries({
        queryKey: W8()
      }), _(
        (ge) => ge && { previewValues: ge.previewValues }
      ), T((ge) => ge + 1), f == null || f("naming_template_saved", {
        source: d,
        token_count: x.length,
        is_first_template: !E
      });
      const de = await (c == null ? void 0 : c());
      P(he), B(!!de), de && K(de);
    } catch {
      he && (P(he), c && B(!0)), K(
        "The naming template update could not be completed. Please try again."
      );
    } finally {
      F(!1);
    }
  };
  return /* @__PURE__ */ p.jsx(
    X5,
    {
      open: e,
      loading: t || m || A && !R,
      saving: w,
      dirty: Z,
      canRetrySave: H,
      tokens: N,
      options: q,
      separators: u,
      detectedFields: oe,
      originalName: s,
      previewName: X,
      error: $,
      onClose: n,
      onReset: V,
      onAdd: U,
      onRemove: Q,
      onReorder: re,
      onFormatChange: (ee, he) => {
        b(
          (pe) => pe.map(
            (de, ge) => ge === ee ? { ...de, hint: he } : de
          )
        );
      },
      onSeparatorChange: (ee, he) => {
        I(
          (pe) => pe.map(
            (de, ge) => ge === ee ? he : de
          )
        );
      },
      onSave: () => void le()
    }
  );
};
function MU(e) {
  return e.canRemove ?? e.is_recipient !== !1;
}
const DU = ({
  userType: e,
  appVersion: n,
  platform: r,
  defaultLoginSurface: a = Cb.LOGIN_V5_NATIVE
}) => {
  const { trackEvent: o } = Ic(), { v5Login: l = !1 } = Dr();
  return Oe(
    (d, c = {}) => {
      o(d, {
        codebase: "liscio-frontend",
        login_surface: a,
        user_type: e,
        app_version: n,
        platform: r,
        v5_login: l,
        ...c
      });
    },
    [a, n, r, o, e, l]
  );
}, WN = (e) => {
  var n;
  return ((n = e == null ? void 0 : e.response) == null ? void 0 : n.data) ?? (e == null ? void 0 : e.data);
}, qN = (e) => {
  if (!e || typeof e != "object" || Array.isArray(e))
    return !1;
  const n = e;
  if (Array.isArray(n.errors) || n.errors && typeof n.errors == "object")
    return !1;
  const r = n.type;
  if (typeof r != "string")
    return !1;
  const a = r.toLowerCase();
  return a === Ra.unauthorized || a === af.toLowerCase();
}, VN = (e) => {
  var o, l, d, c, f, s, h, g, t, i;
  const n = ((o = e.data) == null ? void 0 : o.status) || ((l = e.response) == null ? void 0 : l.status), r = WN(e);
  if ((d = e == null ? void 0 : e.errors) != null && d.unauthorized)
    return !0;
  const a = sf(r || e) || "";
  return a ? [
    Ra.unauthorized,
    af
  ].includes(a) : n === 401 && qN(r) ? !0 : n === 601 || n === 401 ? Array.isArray((f = (c = e == null ? void 0 : e.data) == null ? void 0 : c.errors) == null ? void 0 : f.unauthorized) || Array.isArray((g = (h = (s = e == null ? void 0 : e.response) == null ? void 0 : s.data) == null ? void 0 : h.errors) == null ? void 0 : g.unauthorized) || Array.isArray((i = (t = e == null ? void 0 : e.response) == null ? void 0 : t.errors) == null ? void 0 : i.unauthorized) : !1;
}, XN = (e) => {
  const n = G5(e), r = n.client;
  return r.interceptors.request.use(e.requestInterceptor), r.interceptors.response.use(
    e.responseInterceptorOnFulfilled,
    e.responseInterceptorOnError
  ), n;
}, Py = (e, n) => {
  VN(e) && (window == null ? void 0 : window.location.pathname) !== n && (US(
    `${window.location.pathname}${window.location.search}`
  ), window.location.replace(n));
}, GN = (e) => (n) => (Py(n, e), Promise.resolve(n)), jy = (e) => async (n) => (n.response && n.response.status, Py(n, e), !window.navigator.onLine && !n.response && n.code === "ERR_NETWORK" && window.location.replace("/errors/internet-connection"), Promise.reject(n)), KN = (e) => {
  async function n(r) {
    const a = await M0();
    return a != null && a.auth_token && !Y2(a.auth_token) && r.headers && !r.headers.Authorization && (r.headers.Authorization = a.auth_token), r;
  }
  return {
    requestInterceptor: n,
    responseInterceptorOnFulfilled: GN(e),
    responseInterceptorOnError: jy(e)
  };
}, YN = (e, n) => {
  const r = new Qb(`${e}/graphql`, {
    requestMiddleware: n
  });
  function a(c, ...[f]) {
    return Sn(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      [c.definitions[0].name.value, f],
      async ({ queryKey: s }) => {
        const h = r.request(
          c,
          s[1] ? s[1] : void 0
        );
        return d(h, c);
      }
    );
  }
  function o(c, f, ...[s]) {
    return Sn(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      [c.definitions[0].name.value, s],
      async ({ queryKey: h }) => {
        const g = r.request(
          c,
          h[1] ? h[1] : void 0
        );
        return d(g, c);
      },
      f
    );
  }
  function l(c, f) {
    return Ln({
      ...f,
      mutationFn: (s) => {
        const h = r.request(
          c,
          s || void 0
        );
        return d(h, c);
      }
    });
  }
  function d(c, f) {
    return new Promise((s, h) => {
      c == null || c.then((g) => {
        var i, m, v;
        const t = f.definitions[0].selectionSet.selections[0].name.value;
        (m = (i = g[t]) == null ? void 0 : i.errors) != null && m.length && h((v = g[t]) == null ? void 0 : v.errors), s(g);
      }).catch((g) => {
        var m, v, E, S, y, x, b, u, I, O, D, $;
        const t = [];
        if (g != null && g.response) {
          const K = ((E = (v = (m = g == null ? void 0 : g.response) == null ? void 0 : m.errors) == null ? void 0 : v[0]) == null ? void 0 : E.message) || ((x = (y = (S = g == null ? void 0 : g.response) == null ? void 0 : S.errors) == null ? void 0 : y.unauthorized) == null ? void 0 : x[0]) || "Something went wrong", H = ((O = (I = (u = (b = g == null ? void 0 : g.response) == null ? void 0 : b.errors) == null ? void 0 : u[0]) == null ? void 0 : I.extensions) == null ? void 0 : O.code) || (($ = (D = g == null ? void 0 : g.response) == null ? void 0 : D.response) == null ? void 0 : $.code) || "default:no_code";
          t.push({
            message: K,
            code: H
          });
        } else
          t.push({
            message: (g == null ? void 0 : g.message) || "Something went wrong",
            code: (g == null ? void 0 : g.code) || "default:no_code"
          });
        jy(
          "/authenticate/logout"
        )(g), h(t);
      });
    });
  }
  return {
    graphQLClient: r,
    useGraphQL: a,
    useGraphQLWithOptions: o,
    useMutationGraphQL: l
  };
}, ZN = async (e) => {
  let n = {
    ...e.headers
  };
  const r = await M0();
  return r != null && r.auth_token && (n = {
    ...n,
    Authorization: r.auth_token
  }), {
    ...e,
    headers: n
  };
}, Js = () => {
  var n;
  const e = (n = xs(hf)) == null ? void 0 : n.graphQLClient;
  if (!e)
    throw new Error(
      "useGraphQLClient must be used within an ApiClientProvider"
    );
  return e;
};
let $m;
function NU({
  children: e,
  queryClient: n
}) {
  $m = n || new V8({
    defaultOptions: {
      queries: {
        refetchOnReconnect: !1,
        refetchOnWindowFocus: !1
      }
    }
  });
  const r = XN({
    baseURL: "",
    ...KN("/authenticate/logout")
  }), a = YN("", ZN);
  return /* @__PURE__ */ p.jsx(X8, { client: $m, children: /* @__PURE__ */ p.jsx(x6, { apiClient: r, graphQLClient: a, children: e }) });
}
const QN = (e, n) => Jn.object({
  tags: Jn.array().test(
    "required-tag-in-edit",
    "at least 1 tag is mandatory",
    (r) => e === on.Edit ? r && r.length > 0 : !0
  ),
  file_name: Jn.string().test(
    "required-name-in-edit",
    "Required",
    (r) => e === on.Edit ? !!r : !0
  ),
  participants: Jn.array().test({
    name: "has-at-least-one-participant",
    message: "At least one participant required",
    test: (r) => e === on.NewFile ? r && (r == null ? void 0 : r.length) > 0 : !0
  }).test({
    name: "all-participants-have-accounts",
    message: "All participants must be associated with an account, unless the user has no accounts",
    test: (r) => e === on.NewFile ? n || (r == null ? void 0 : r.every(
      (a) => {
        var o;
        return !!((o = a == null ? void 0 : a.account) != null && o.value);
      }
    )) : !0
  }),
  files: Jn.mixed().test({
    name: "has-at-least-one-file",
    message: "No file selected",
    test: (r) => {
      const a = r;
      return (Jn.ref("doc_ids") && Array).length > 0 || !!((a == null ? void 0 : a.length) > 0 && a.every((l) => l instanceof File));
    }
  }).test({
    name: "is-valid-size",
    message: `This file is too large. Files must be smaller than ${q8}MB`,
    test: (r) => p6(r[0])
  })
}), JN = ({
  accounts: e,
  defaultRecipient: n
}) => {
  if (!e) return [];
  if ((e == null ? void 0 : e.length) === 1) {
    const r = e[0], a = r.cst_member;
    if (a.length > 0)
      return a.map((l) => ({
        recipient: l,
        account: r
      }));
    if (n)
      return [
        {
          recipient: n,
          account: r
        }
      ];
  }
  return [];
}, eL = (e) => async (n) => {
  var r;
  try {
    return {
      values: await e.validate(n, {
        abortEarly: !1
      }),
      errors: {}
    };
  } catch (a) {
    return {
      values: {},
      errors: (r = a == null ? void 0 : a.inner) == null ? void 0 : r.reduce(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (o, l) => ({
          ...o,
          [l.path]: {
            type: l.type ?? "validation",
            message: l.message
          }
        }),
        {}
      )
    };
  }
}, tL = (e) => Oe(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async (n) => eL(e)(n),
  [e]
);
function Ry(e, n) {
  var g;
  const { data: r } = xr(), { data: a } = Pf(
    String(((g = r == null ? void 0 : r.data) == null ? void 0 : g.contact_id) || "")
  ), o = e || {}, l = !(a != null && a.data) || (a == null ? void 0 : a.data.length) === 0, { baseName: d, extension: c } = Tt(() => o7((o == null ? void 0 : o.file_name) || ""), [o == null ? void 0 : o.file_name]), f = Tt(
    () => QN(n, l),
    [n, l]
  ), s = Tt(() => {
    var t;
    return n !== on.NewFile || !on.Workflow ? [] : JN({
      accounts: a == null ? void 0 : a.data,
      defaultRecipient: (t = r == null ? void 0 : r.data) == null ? void 0 : t.default_recipient
    });
  }, [a == null ? void 0 : a.data, r == null ? void 0 : r.data, n]), h = tL(f);
  return mr({
    defaultValues: {
      year: "",
      month: "",
      files: [],
      tags: [],
      participants: s,
      ...o,
      file_name: d,
      file_extension: c
    },
    resolver: h
  });
}
function nL({
  formData: e,
  type: n,
  fixedToAccountId: r,
  fixedToContactId: a,
  taskId: o,
  fileId: l,
  onFileUpload: d,
  onNavigationClick: c,
  isScannerDisabled: f
}) {
  const s = Ry(e, n);
  return /* @__PURE__ */ p.jsx(Hm, { ...s, children: n === on.Workflow ? /* @__PURE__ */ p.jsx(
    hb,
    {
      fixedToAccountId: r,
      taskId: o,
      fileId: l,
      onFileUpload: d,
      onNavigationClick: c,
      type: n,
      isScannerDisabled: f
    }
  ) : /* @__PURE__ */ p.jsx(
    db,
    {
      fixedToAccountId: r,
      fixedToContactId: a,
      taskId: o,
      fileId: l,
      onFileUpload: d,
      onNavigationClick: c,
      type: n,
      isScannerDisabled: f
    }
  ) });
}
const My = ({
  title: e,
  onNavigationClick: n,
  hideSecondaryActionButton: r
}) => /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
  /* @__PURE__ */ p.jsx(Bi, { children: /* @__PURE__ */ p.jsx(
    Gn,
    {
      "aria-label": "Back",
      size: "large",
      onClick: () => n && n("go:back"),
      children: /* @__PURE__ */ p.jsx(it, { icon: "chevronLeft" })
    }
  ) }),
  /* @__PURE__ */ p.jsxs(Ks, { children: [
    e && /* @__PURE__ */ p.jsx(Te, { variant: "h2", children: e }),
    !e && /* @__PURE__ */ p.jsx(Vs, { width: 180 })
  ] }),
  /* @__PURE__ */ p.jsx(Bi, { children: !r && /* @__PURE__ */ p.jsx(
    Gn,
    {
      "aria-label": "Archive",
      size: "large",
      onClick: () => n && n("go:archive"),
      children: /* @__PURE__ */ p.jsx(it, { icon: "archive", fontSize: "small" })
    }
  ) })
] }), iL = {
  [on.NewMessage]: "Attach File to New Message",
  [on.MessageThread]: "Attach File to Message Thread",
  [on.Task]: "Attach File to Task",
  [on.Invoice]: "Attach File to Invoice",
  [on.Edit]: "Edit File",
  [on.NewFile]: "Upload New File",
  [on.Workflow]: "Upload File"
};
function LU({
  fileId: e,
  taskId: n,
  goBack: r,
  type: a,
  formData: o,
  onFileUpload: l,
  fixedToAccountId: d,
  fixedToContactId: c,
  isScannerDisabled: f
}) {
  var S;
  const { data: s, isLoading: h } = xr(), { isLoading: g } = Pf(
    String(((S = s == null ? void 0 : s.data) == null ? void 0 : S.contact_id) || "")
  ), t = Oe(
    (y) => {
      y === "go:back" && r && r();
    },
    [r]
  ), i = iL[a], m = a === on.NewFile || a === on.Workflow, v = g || h, E = !v || !m;
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsx(Tx, { title: i }),
    /* @__PURE__ */ p.jsxs(Xr, { dataTestId: "UploadForm", children: [
      /* @__PURE__ */ p.jsx(
        Kr,
        {
          onNavigationClick: t,
          title: i,
          hideSecondaryActionButton: !0,
          DefaultStateElement: My
        }
      ),
      /* @__PURE__ */ p.jsx(mi, { open: v }),
      E && /* @__PURE__ */ p.jsx(
        nL,
        {
          onNavigationClick: t,
          type: a,
          formData: o,
          onFileUpload: l,
          fixedToAccountId: d,
          fixedToContactId: c,
          fileId: e,
          taskId: n,
          isScannerDisabled: f
        }
      )
    ] })
  ] });
}
const rL = {
  [on.NewMessage]: "Attach File to New Message",
  [on.MessageThread]: "Attach File to Message Thread",
  [on.Task]: "Attach File to Task",
  [on.Invoice]: "Attach File to Invoice",
  [on.Edit]: "Edit File",
  [on.NewFile]: "Upload New File",
  [on.Workflow]: "Upload File"
};
function sL({
  fileId: e,
  taskId: n,
  goBack: r,
  type: a,
  formData: o,
  onFileUpload: l,
  fixedToAccountId: d,
  fixedToContactId: c,
  isScannerDisabled: f
}) {
  const s = Ry(o, a), h = Oe(
    (t) => {
      t === "go:back" && r && r();
    },
    [r]
  ), g = rL[a];
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsx(Tx, { title: g }),
    /* @__PURE__ */ p.jsxs(Xr, { dataTestId: "UploadDocumentFormView", children: [
      /* @__PURE__ */ p.jsx(
        Kr,
        {
          onNavigationClick: h,
          title: g,
          hideSecondaryActionButton: !0,
          DefaultStateElement: My
        }
      ),
      /* @__PURE__ */ p.jsx(Hm, { ...s, children: a === on.Workflow ? /* @__PURE__ */ p.jsx(
        hb,
        {
          fixedToAccountId: d,
          taskId: n,
          fileId: e,
          onFileUpload: l,
          onNavigationClick: h,
          type: a,
          isScannerDisabled: f
        }
      ) : /* @__PURE__ */ p.jsx(
        db,
        {
          fixedToAccountId: d,
          fixedToContactId: c,
          taskId: n,
          fileId: e,
          onFileUpload: l,
          onNavigationClick: h,
          type: a,
          isScannerDisabled: f
        }
      ) })
    ] })
  ] });
}
export {
  gM as $,
  Kr as A,
  Y2 as B,
  Ls as C,
  WC as D,
  UC as E,
  fb as F,
  V_ as G,
  ty as H,
  ny as I,
  Q$ as J,
  Z$ as K,
  J$ as L,
  cR as M,
  Bb as N,
  o6 as O,
  Ys as P,
  QL as Q,
  Jb as R,
  l6 as S,
  tB as T,
  eB as U,
  JL as V,
  $x as W,
  Ks as X,
  Bi as Y,
  NU as Z,
  kB as _,
  K0 as a,
  IE as a$,
  dM as a0,
  YL as a1,
  ZL as a2,
  Ox as a3,
  u6 as a4,
  S6 as a5,
  k6 as a6,
  ra as a7,
  ks as a8,
  R2 as a9,
  J3 as aA,
  Aj as aB,
  Ej as aC,
  Oj as aD,
  q$ as aE,
  V$ as aF,
  ey as aG,
  jj as aH,
  Hj as aI,
  X$ as aJ,
  Xj as aK,
  G$ as aL,
  K$ as aM,
  Y$ as aN,
  eR as aO,
  aR as aP,
  sR as aQ,
  ms as aR,
  Cc as aS,
  g$ as aT,
  jE as aU,
  Wf as aV,
  xE as aW,
  Hf as aX,
  PE as aY,
  OE as aZ,
  TE as a_,
  nB as aa,
  gS as ab,
  op as ac,
  F2 as ad,
  Y3 as ae,
  D$ as af,
  mj as ag,
  Z3 as ah,
  N$ as ai,
  L$ as aj,
  cp as ak,
  mS as al,
  no as am,
  OS as an,
  i1 as ao,
  q_ as ap,
  fj as aq,
  pj as ar,
  Qs as as,
  B$ as at,
  $$ as au,
  H$ as av,
  Tj as aw,
  W$ as ax,
  Q3 as ay,
  kj as az,
  YB as b,
  Ek as b$,
  wE as b0,
  _E as b1,
  SE as b2,
  CE as b3,
  Ia as b4,
  cB as b5,
  lB as b6,
  Qp as b7,
  eU as b8,
  iy as b9,
  $b as bA,
  zB as bB,
  HB as bC,
  ck as bD,
  qB as bE,
  VB as bF,
  XB as bG,
  ZB as bH,
  QB as bI,
  JB as bJ,
  e$ as bK,
  lk as bL,
  dk as bM,
  hk as bN,
  fk as bO,
  n$ as bP,
  gk as bQ,
  mk as bR,
  xk as bS,
  yk as bT,
  Sk as bU,
  i$ as bV,
  r$ as bW,
  _k as bX,
  s$ as bY,
  Ak as bZ,
  kk as b_,
  tU as ba,
  ry as bb,
  nU as bc,
  sy as bd,
  iU as be,
  ay as bf,
  FR as bg,
  RR as bh,
  kR as bi,
  IR as bj,
  pd as bk,
  rU as bl,
  aU as bm,
  sU as bn,
  oU as bo,
  WR as bp,
  eM as bq,
  VC as br,
  C$ as bs,
  A$ as bt,
  _c as bu,
  th as bv,
  xi as bw,
  t$ as bx,
  Ub as by,
  WB as bz,
  KB as c,
  SU as c$,
  a$ as c0,
  o$ as c1,
  c$ as c2,
  l$ as c3,
  u$ as c4,
  d$ as c5,
  h$ as c6,
  eE as c7,
  f$ as c8,
  KE as c9,
  lU as cA,
  cy as cB,
  uU as cC,
  mM as cD,
  dU as cE,
  hU as cF,
  xd as cG,
  fU as cH,
  pU as cI,
  gU as cJ,
  mU as cK,
  xU as cL,
  tN as cM,
  eN as cN,
  bU as cO,
  yU as cP,
  vU as cQ,
  Ty as cR,
  _y as cS,
  Cy as cT,
  Ay as cU,
  ky as cV,
  Ey as cW,
  Iy as cX,
  aN as cY,
  oN as cZ,
  wU as c_,
  tE as ca,
  zf as cb,
  S$ as cc,
  QE as cd,
  Pi as ce,
  v9 as cf,
  JE as cg,
  _$ as ch,
  h9 as ci,
  LE as cj,
  BE as ck,
  m$ as cl,
  $E as cm,
  x$ as cn,
  b$ as co,
  ZE as cp,
  y$ as cq,
  b9 as cr,
  v$ as cs,
  w$ as ct,
  Ac as cu,
  k$ as cv,
  Vk as cw,
  BT as cx,
  $T as cy,
  cU as cz,
  GB as d,
  PB as d$,
  pN as d0,
  _U as d1,
  CU as d2,
  AU as d3,
  kU as d4,
  EU as d5,
  IU as d6,
  xN as d7,
  TU as d8,
  Pm as d9,
  xb as dA,
  K_ as dB,
  xr as dC,
  oB as dD,
  If as dE,
  Z2 as dF,
  gB as dG,
  M$ as dH,
  K3 as dI,
  oj as dJ,
  uj as dK,
  dB as dL,
  hB as dM,
  Y_ as dN,
  fB as dO,
  pB as dP,
  Z_ as dQ,
  bb as dR,
  J_ as dS,
  mB as dT,
  xB as dU,
  eC as dV,
  BC as dW,
  TB as dX,
  OB as dY,
  HC as dZ,
  FB as d_,
  _N as da,
  AN as db,
  OU as dc,
  FU as dd,
  TN as de,
  PU as df,
  RN as dg,
  bd as dh,
  Rm as di,
  jU as dj,
  Nm as dk,
  jN as dl,
  RU as dm,
  sE as dn,
  us as dp,
  vc as dq,
  w_ as dr,
  aE as ds,
  p$ as dt,
  zx as du,
  X_ as dv,
  jf as dw,
  gb as dx,
  mb as dy,
  G_ as dz,
  P$ as e,
  I$ as e$,
  lC as e0,
  jB as e1,
  RB as e2,
  Mu as e3,
  MB as e4,
  DB as e5,
  NB as e6,
  LB as e7,
  BB as e8,
  Z7 as e9,
  SB as eA,
  _B as eB,
  CC as eC,
  CB as eD,
  AB as eE,
  zl as eF,
  Mb as eG,
  Db as eH,
  Nb as eI,
  Sp as eJ,
  EB as eK,
  jS as eL,
  jC as eM,
  DC as eN,
  MC as eO,
  IB as eP,
  YP as eQ,
  ej as eR,
  Lh as eS,
  T$ as eT,
  QP as eU,
  Lb as eV,
  $B as eW,
  UB as eX,
  V3 as eY,
  n1 as eZ,
  HP as e_,
  QC as ea,
  F$ as eb,
  ij as ec,
  j$ as ed,
  es as ee,
  VL as ef,
  GL as eg,
  Q7 as eh,
  XL as ei,
  J7 as ej,
  Cd as ek,
  KL as el,
  n6 as em,
  i6 as en,
  uE as eo,
  fE as ep,
  pE as eq,
  gE as er,
  R$ as es,
  MU as et,
  Tb as eu,
  Ob as ev,
  yB as ew,
  _C as ex,
  vB as ey,
  wB as ez,
  x6 as f,
  E$ as f0,
  Ic as f1,
  G3 as f2,
  O$ as f3,
  nj as f4,
  DU as f5,
  en as f6,
  Fu as f7,
  Pu as f8,
  ki as f9,
  vj as fA,
  U$ as fB,
  e9 as fC,
  $p as fD,
  Fs as fE,
  $u as fF,
  z$ as fG,
  yj as fH,
  r1 as fI,
  wj as fJ,
  $0 as fK,
  tc as fL,
  lb as fM,
  uB as fN,
  ju as fa,
  bB as fb,
  bp as fc,
  Cb as fd,
  sL as fe,
  LU as ff,
  JN as fg,
  Ry as fh,
  db as fi,
  hb as fj,
  ub as fk,
  B_ as fl,
  rb as fm,
  sb as fn,
  v_ as fo,
  cb as fp,
  ab as fq,
  E_ as fr,
  A_ as fs,
  O_ as ft,
  F_ as fu,
  Vd as fv,
  P_ as fw,
  j_ as fx,
  R_ as fy,
  QN as fz,
  KN as g,
  YN as h,
  XN as i,
  p as j,
  Jt as k,
  Js as l,
  eA as m,
  US as n,
  M0 as o,
  aB as p,
  K2 as q,
  ZN as r,
  tA as s,
  iB as t,
  _s as u,
  sB as v,
  rB as w,
  zS as x,
  HS as y,
  WS as z
};
//# sourceMappingURL=index-BohHFVu7.js.map
